(function() {
    'use strict';

    angular
        .module('editorApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'oitozero.ngSweetAlert',
            'common.service',
            'image.service',
            'modules.service',
            'ui.router',
            'ui.sortable',
            'infinite-scroll',
            'ngDraggable',
            'ngWebSocket',
            'angularLazyImg'
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            // 'angular-loading-bar'
            // 'monospaced.qrcode'
        ])
        .run(run);

    run.$inject = ['stateHandler', 'translationHandler'];

    function run(stateHandler, translationHandler) {
        stateHandler.initialize();
        translationHandler.initialize();
    }
})();

(function () {
    'use strict';

    angular
        .module('editorApp')
        .factory('User', User)
        .factory('ToneSettings', ToneSettings);

    User.$inject = ['$resource'];
    ToneSettings.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
    function ToneSettings ($resource) {
        var resourceUrl =  'manager/' + 'api/tone-settings/:path/:id';
        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'byStoreId': {
                method: 'GET',
                params:{
                    path:"byStoreId"
                }
            },
            "save":{
                method:"POST"
            },
            "delete":{
                method:"DELETE"
            },
            'update': { method:'PUT' },
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('editorApp')
        .factory('Theme', Theme);


    function Theme () {
        return{
            judge:function() {
                console.log(localStorage.getItem('themeFlag'));
                var newCss = document.getElementById("linkid");
                if (localStorage.getItem('themeFlag') == 'three') {
                    newCss.href = "content/css/themeThree.css";
                } else if (localStorage.getItem('themeFlag') == 'two') {
                    newCss.href = "content/css/themeTwo.css";
                } else {
                    newCss.href = "content/css/themeOne.css";
                }
            },
            sweetHintImg:function(){
                if (localStorage.getItem('themeFlag') == 'three') {
                    return "content/images/icons/popThree_ic_msg_hint.svg";
                }else if(localStorage.getItem('themeFlag') == 'two'){
                    return "content/images/icons/pop_ic_msg_hint.svg";
                }else{
                    return "content/images/icons/pop_ic_msg_hint.svg";
                }
            },
            sweetSuccedImg: function(){
                if (localStorage.getItem('themeFlag') == 'three') {
                    return "content/images/icons/popThree_ic_msg_succeed.svg";
                }else if(localStorage.getItem('themeFlag') == 'two'){
                    return "content/images/icons/pop_ic_msg_succeed.svg";
                }else{
                    return "content/images/icons/pop_ic_msg_succeed.svg";
                }
            },
            sweetBrokenImg:function(){
                return "content/images/icons/broken.svg";
            },
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" data-translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('editorApp')
        .factory('Register', Register)
        .factory('AccountP', AccountP);

    Register.$inject = ['$resource'];
    AccountP.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }

    function AccountP($resource) {
        var resourceUrl =  'security/' + 'api/platform-users/:path/:id';
        var service = $resource(resourceUrl, {}, {
            'checkPassword': {
                method: "GET",
                params: {
                    path: "checkPassword"
                },
                transformResponse: function(data) {
                    return data;
                }
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account', '$localStorage'];

    function Principal ($q, Account, $localStorage) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                $localStorage.user = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false; 
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset-password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset-password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var resourceUrl = 'security/' + 'api/platform-users/changePassword/:id';
        return $resource(resourceUrl, {}, {
            'save': { method:'POST' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish'];

    function Auth ($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            loginWithToken: loginWithToken,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                // if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'social-auth')) {
                //     $state.go('home');
                // }
                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
                // if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                //     if (isAuthenticated) {
                //         // user is signed in but not authorized for desired state
                //         $state.go('accessdenied');
                //     } else {
                //         // user is not authenticated. stow the state they wanted before you
                //         // send them to the login service, so you can return them when you're done
                //         storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                //         // now, send them to the signin state so they can log in
                //         $state.go('accessdenied').then(function() {
                //             // LoginService.open();
                //         });
                //     }
                // }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials).then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$q', 'MessageService', 'Store', 'LANGUAGES'];

    function AuthServerProvider ($http, $localStorage, $sessionStorage, $q, MessageService, Store, LANGUAGES) {
        var service = {
            getToken: getToken,
            login: login,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout
        };

        return service;

        function getToken () {

            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function login (credentials) {

            var data = {
                phone: credentials.phone,
                password: credentials.password,
                storeId:credentials.storeId,
                rememberMe: credentials.rememberMe
            };
            return $http.post('manager/api/customers/authenticate', data).success(authenticateSuccess);

            function authenticateSuccess (data, status, headers) {
                var bearerToken = headers('Authorization');
                if (bearerToken== null || bearerToken.length<=7) {
                    MessageService.error("登录失败，请重新验证");
                    return ;
                }
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, credentials.rememberMe);
                    return jwt;
                }
            }
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if(rememberMe){
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
            Store.current({},function(res){
                if (res.status == 200) {
                    $localStorage.store = res.data;
                    if ($localStorage.store.availableLangKey) {
                        $localStorage.lagnuages = $localStorage.store.availableLangKey;
                    }
                }else{
                    MessageService.error("商户信息获取失败");
                }
            });
            
            // if ($localStorage.lagnuages == null) {
            //     if ($localStorage.store == null) {
            //         Store.current({},function(res){
            //             if (res.status == 200) {
            //                 $localStorage.store = res.data;
            //                 if ($localStorage.store.availableLangKey) {
            //                     $localStorage.lagnuages = $localStorage.store.availableLangKey;
            //                 }
            //             }else{
            //                 MessageService.error("商户信息获取失败");
            //             }
            //         });
            //     }else{
            //         if ($localStorage.store.availableLangKey) {
            //             $localStorage.lagnuages = $localStorage.store.availableLangKey;
            //         }
            //     }
            // }
            
            
        }

        function logout () {
            delete $localStorage.user;
            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('manager/api/customers/current', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .controller('UserAgentController', UserAgentController);

    UserAgentController.$inject = ['$localStorage', '$scope', '$stateParams', '$uibModalInstance'];

    function UserAgentController ($localStorage, $scope, $stateParams, $uibModalInstance) {
        var vm = this;
        localStorage.setItem("userAgentTime",time());
        function time() {
            var d = new Date();
            var getFullYear = d.getFullYear();
            var getMonth = d.getMonth() + 1;
            var getDate = d.getDate();
            return getFullYear + '-' + getMonth + '-' + getDate
        }
        //返回
        $scope.cancel = function() {
            $uibModalInstance.close();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', '$q', 'ProfileService', 'LoginService', '$scope', '$localStorage', '$uibModal',
    "$stateParams", "Product", "Store", "Qinius", "$cookieStore", "MessageNotification", 'MessageService', 'DateUtils', 'ToneSettings','$translate','StoreWorkEditConfig'];

    function NavbarController ($state, Auth, Principal, $q, ProfileService, LoginService, $scope, $localStorage, $uibModal,
        $stateParams, Product, Store, Qinius, $cookieStore, MessageNotification, MessageService, DateUtils, ToneSettings,$translate, StoreWorkEditConfig) {
        var vm = this;
        var _urlParam = getUrlParam();
        handleFontSizeInit();
        if(_urlParam && _urlParam['authorization']){
            $localStorage.authenticationToken = _urlParam['authorization'];
        };
        document.title = $translate.instant("hint.loadingText")
        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;
        vm.login = login;
        vm.register = register;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;
        vm.isLogin = false;
        vm.shrink = shrink;
        vm.storeId = $stateParams.storeId || $state.params.storeId || $cookieStore.get("store-id");
        if (!vm.storeId) {
            return;
        }
        vm.sidebar2Shrik = sidebar2Shrik;
        vm.titleNavbar = titleNavbar;
        vm.lmenuClick = lmenuClick;
        vm.account = $localStorage.user;
        vm.navSelection = "";
        vm.store = Store.get({id:vm.storeId});
        $scope.domains = Qinius.getDomain({storeId: vm.storeId});

        //获取自定义颜色
        getToneSettings();
        function getToneSettings() {
            ToneSettings.byStoreId({id:vm.storeId}, function (res) {
                if(res.status == 200){
                    if(res.data){
                        vm.data = res.data;
                        for(var key in  res.data){
                            if(res.data[key]){
                                document.body.style.setProperty('--' + key, res.data[key]);
                            }
                        }
                    }
                }else{
                    MessageService.error(res.message)
                }
            }, function (error) {});
        }
        //获取商品
        var items = [{key: "saleable", op: "=", value: "true"}, {
            key: "productRangeType",
            op: "like",
            value: "ALL"
        }, {key: "storeId", op: "=", value: vm.storeId}];

        var items2 = [{key: "saleable", op: "=", value: "true"}, {
            key: "productRangeType",
            op: "like",
            value: "WEB"
        }, {key: "storeId", op: "=", value: vm.storeId}];


        localStorage.removeItem('editor-thumbnail');
        StoreWorkEditConfig.storeId({storeId: vm.storeId}, function (res) {
            if(res.status == 200 && res.data.thumbnail){
                localStorage.setItem('editor-thumbnail', res.data.thumbnail);
            }
        });
        $q.all([$scope.domains.$promise, vm.store.$promise]).then(function () {
            vm.store = vm.store.data;
            vm.domain = 'https://' + $scope.domains.domains[0] + '/';
            localStorage.setItem('editor-domain', vm.domain);
            vm.logoUrl = vm.store.menuLogo ? vm.domain + vm.store.menuLogo : 'content/images/logo.png';
            var faviconLogoUrl =  vm.store.faviconLogo ? vm.domain + vm.store.faviconLogo : 'favicon.ico';
            setWebIcon(faviconLogoUrl)
        });

        //作品库
        if($localStorage == null || $localStorage.user == null || $localStorage.authenticationToken == null){
            vm.isLogin = false;
        }else{
            vm.isLogin = true;
        }

        $scope.getName = function(){
            if (vm.account.name == "未知"  && !!vm.account.phone) {
                return vm.account.phone.substring(0,3)+"****"+vm.account.phone.substring(7);
            }else{
                return vm.account.name;
            }
        }

        ProfileService.getProfileInfo().then(function (response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
            $(".titleNavbar").eq(vm.menu).find($(".arrowsB")).removeClass('arrows').addClass('arrowsTop');
            // 菜单刷新后定位
            vm.lmenu = sessionStorage.getItem("lmenu") == null ? 'a_storeManagement' : sessionStorage.getItem("lmenu");
        });

        var $bar1 = $(".sidebar1-btn");
        var $side1 = $(".sidebar1");
        var $bar2 = $(".sidebar2-btn");
        var $side2 = $(".sidebar2");
        var isHide = false;
        var $navbar = $(".navbar-wrap");
        window.showSidebar2Shrink = function (event) {
            if ($navbar.hasClass("sidebar-collapse3")){
                $(".sidebar2-shrink").removeClass('shidebar2-shrink-left').addClass('shidebar2-shrink-left2');
                return
            }
            $(".sidebar2-shrink").removeClass('shidebar2-shrink-left').addClass('shidebar2-shrink-left');
        };

        window.hideSidebar2Shrink = function (event) {
            if ($navbar.hasClass("sidebar-collapse3")){
                $(".sidebar2-shrink").removeClass('shidebar2-shrink-left2');
                return
            }
            $(".sidebar2-shrink").removeClass('shidebar2-shrink-left');
        };

        function lmenuClick(a_id) {
            vm.lmenu = a_id;
            sessionStorage.setItem("lmenu", a_id);
        }

        var createModal = function (url, controller, type) {
            if (type == null) {
                type = "Login";
            }

            return $uibModal.open({
                templateUrl: url,
                controller: controller,
                backdrop: 'static',
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: 'vm',
                resolve: {
                    entity:{
                        type:type
                    },
                }
            });
        };

        function login() {
            createModal('app/account/register/register.html', 'RegisterController', "Login").result.then(
                function () {
                });
        };

        function register(){
            createModal('app/account/register/register.html', 'RegisterController', "Register").result.then(
                function () {
                });
        }



        function logout() {
            collapseNavbar();
            Auth.logout();
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }


        function shrink() {
            $navbar.toggleClass("sidebar-collapse");
            $side2.addClass('transition');
            if (isHide) {
                if ($navbar.hasClass("sidebar-collapse")) {
                    $bar1.removeClass('btn1-shrik1').addClass("btn1-shrik2");
                    $navbar.toggleClass("sidebar-collapse3").toggleClass("sidebar-collapse4");
                    $(".wrap").removeClass("wrap-mar130").removeClass("wrap-mar50").toggleClass("wrap-mar60");
                } else {
                    $bar1.removeClass('btn1-shrik2').addClass("btn1-shrik1");
                    $(".wrap").removeClass("wrap-mar50").removeClass("wrap-mar60").toggleClass("wrap-mar130");
                    $navbar.toggleClass("sidebar-collapse4").toggleClass("sidebar-collapse3");
                }
            } else {$bar1.toggleClass('btn1-shrik1').toggleClass("btn1-shrik2");
                $(".wrap").toggleClass("wrap-mar50");
            }
            return false;
        }

        $scope.resetPassword = function(){
            createModal('app/account/password/password.html', 'PasswordController').result.then(
                function(data) {
                });
        };

        function titleNavbar(i) {
            var $titleNavbar = $(".titleNavbar");
            var $menu1 = $(".menu1");
            // click时清空一级菜单样式
            $titleNavbar.find($(".navbar-title")).css({
                background: '#3c434d'
            });
            $titleNavbar.find($(".arrowsB")).removeClass('arrowsTop').addClass('arrows');
            //若二级菜单为隐藏状态：
            if ($titleNavbar.eq(i).find($menu1).is(':hidden')) {
                //箭头运动状态向下
                $titleNavbar.eq(i).find($(".arrowsB")).removeClass('arrows').addClass('arrowsTop');
                // click时改变一级菜单背景色和字体色
                $titleNavbar.eq(i).find($(".navbar-title")).css({
                    background: '#313840'
                });
                //显示当前二级菜单
                $titleNavbar.eq(i).find($menu1).slideDown(400);
                localStorage.setItem("menu1",i);
                //隐藏其他二级菜单
                $titleNavbar.eq(i).siblings().find($(".menu1")).hide();

            } else {
                $titleNavbar.eq(i).find($(".arrowsB")).removeClass('arrowsTop').addClass('arrows');
                $titleNavbar.eq(i).find($(".navbar-title")).css({
                    background: '#313840'
                });
                $titleNavbar.eq(i).find($menu1).slideUp(400);
                $titleNavbar.eq(i).siblings().find($menu1).hide();
            }
        }

        function sidebar2Shrik() {
            if(!($(".sidebar2-shrink").hasClass('shidebar2-shrink-left')||$(".sidebar2-shrink").hasClass('shidebar2-shrink-left2'))){
                return
            }

            $side2.removeClass('transition');
            $(".sidebar2-shrink").removeClass('shidebar2-shrink-left2');
            isHide = !isHide;

            if(isHide){
                $(".sidebar2").addClass("sidebar2-zIndex");
                $bar2.removeClass('btn2-shrik1').addClass("btn2-shrik2");
            }else {
                $(".sidebar2").removeClass("sidebar2-zIndex");
                $bar2.removeClass('btn2-shrik2').addClass("btn2-shrik1");
            }
            if ($navbar.hasClass("sidebar-collapse")) {
                $(".wrap").toggleClass("wrap-mar50").toggleClass("wrap-mar60");
                $navbar.removeClass("sidebar-collapse3").toggleClass("sidebar-collapse4");
            } else {
                $navbar.removeClass("sidebar-collapse2").removeClass("sidebar-collapse4").toggleClass("sidebar-collapse3");
                $(".wrap").removeClass("wrap-mar50").toggleClass("wrap-mar130");
            }
        }


        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }



        if($localStorage == null || $localStorage.user == null || $localStorage.authenticationToken == null){
            vm.isLogin = false;
        }else{
            vm.isLogin = true;
        }

        $scope.login = function () {
            createModal('app/account/register/register.html', 'RegisterController').result.then(
                function () {
                });
        };
        function route() {
            var _class = angular.element('#myWork').attr('class');
            if(_class == 'pageOn'){
                angular.element('#myWork').removeClass('pageOn');
            }
        }


        //消息列表
        vm.messageList = [];
        // MessageNotification.getAllByCondition2(
        //     {items:[
        //         {key:"pageType", op : "!=", value:"Edit"},
        //         {key:"storeId", op : "=", value:vm.storeId},
        //         {key:"available", op : "=", value:"true"},
        //         {key:"validate", op : ">=", value: DateUtils.convertLocalDateToServer(new Date())}]
        // }, function (res) {
        //         if(res.status == 200){
        //             vm.messageList =res.data;
        //         }else {
        //             MessageService.error(res.message);
        //         }
        // })
        function compareDate(s1,s2){
            return ((new Date(s1.replace(/-/g,"\/")))>(new Date(s2.replace(/-/g,"\/"))));
        }
        function getNowFormatDate() {
            var date = new Date();
            var seperator1 = "-";
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var strDate = date.getDate();
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate;
            }
            var currentdate = year + seperator1 + month + seperator1 + strDate;
            return currentdate;
        }

        userAgent()
        function userAgent() {
            var _userAgentTime = localStorage.getItem("userAgentTime");
            if(getExploreName().indexOf('Chrome') == -1 && time()!=_userAgentTime && !isMobile()){
                $uibModal.open({
                    templateUrl: 'app/layouts/navbar/userAgent.html',
                    controller: 'UserAgentController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    resolve: {}
                });
            }
        }
        function isMobile(){
            var ua = window.navigator.userAgent;
            var isWeChat = ua.match(/MicroMessenger/i);
            if(isWeChat){
                // 检测是否为 PC 微信小程序环境（PC 小程序特有标识）
                if (/MiniProgramEnv\/Windows|MiniProgramEnv\/Mac/i.test(ua)) {
                     return true; // 这就是PC 小程序 WebView
                 }
                 // PC微信内置浏览器（打开普通链接）
                 if (/WindowsWechat|MacWechat/i.test(ua)) {
                     return false;
                 }
                 // 手机端微信
                 return true;
             }
            if(ua.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone|HarmonyOS|Harmony)/i)) {
                return true;
            }else{
                return false;
            }
        }
        function time() {
            var d = new Date();
            var getFullYear = d.getFullYear();
            var getMonth = d.getMonth() + 1;
            var getDate = d.getDate();
            return getFullYear + '-' + getMonth + '-' + getDate
        }

        // 设置标签页icon
        function setWebIcon(path){
            var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
            link.type = 'image/x-icon';
            link.rel = 'icon';
            link.href = path;
            document.getElementsByTagName('head')[0].appendChild(link);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .directive('activeLink', activeLink);

    function activeLink() {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var clazz = attrs.activeLink;
            var path = attrs.href;
            path = path.substring(1); //hack because path does bot return including hashbang
            scope.location = location;
            scope.$watch('location.path()', function(newPath) {
                if (path === newPath) {
                    element.addClass(clazz);
                } else {
                    element.removeClass(clazz);
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'home',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content2@': {
                        templateUrl: 'app/home/home.html',
                        controller: 'HomeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
                parent: 'app2',
                url: '/{storeId}/login',
                data: {
                    authorities: [],
                    pageTitle: 'home.title'
                },
                views: {
                    'content2@': {
                        templateUrl: 'app/home/home.html',
                        controller: 'HomeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }]
                }
            })
            .state('home2', {
                parent: 'app',
                url: '/',
                data: {
                    authorities: [],
                    pageTitle: 'global.menu.entities.commodity-center'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/gallery/gallery.html',
                        controller: 'GalleryController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('gallery');
                        $translatePartialLoader.addPart('common');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$state', 'MessageService', 'Customer', '$rootScope', 'Auth', '$stateParams', '$cookieStore', '$translate'];

    function HomeController ($scope, Principal, LoginService, $state, MessageService, Customer, $rootScope, Auth, $stateParams, $cookieStore, $translate) {
        var vm = this;
        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.storeId = $stateParams.storeId || $cookieStore.get("store-id");
        if (!vm.storeId) {
            return;
        }

        $scope.with = window.screen.width;
        vm.password = null;
        vm.rememberMe = true;
        vm.phone = null;

        Auth.logout();

         
        function cancel() {
            vm.credentials = {
                phone: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
        }

        function login(event) {
            if (vm.phone == null || vm.phone == '' || vm.password == null || vm.password == '') {
                MessageService.error($translate.instant("loginMessages.enterPhoneAndPassword"));
                return;
            }
            event.preventDefault();
            Auth.login({
                phone: vm.phone,
                password: vm.password,
                storeId:vm.storeId,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;

                $state.go('webArticle', {storeId:vm.storeId});
                $(".wrap").css({margin: '48px 10px 10px 130px'});

                localStorage.removeItem('menu1');
                localStorage.removeItem('menu2');
                localStorage.removeItem('pageName');

                $rootScope.$broadcast('authenticationSuccess');
                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is succesful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function (err) {
                MessageService.error($translate.instant("loginMessages.incorrectUsernameOrPassword"));
                vm.authenticationError = true;
            });


        }

    }
})();

(function(){
	"use strict";
	angular
	.module("editorApp")
	.controller("FolderDialogController", FolderDialogController);
	FolderDialogController.$inject = ['$scope', '$uibModalInstance', 'MessageService', '$stateParams',  'Folder', 'entity', '$translate'];

    function FolderDialogController( $scope,  $uibModalInstance, MessageService, $stateParams,  Folder, entity, $translate) {

       var vm = this;
        vm.clear = clear;
        vm.save = save;
        vm.id = null;
        vm.newFolder = true;
        if(entity.id){
            vm.newFolder = false;
            Folder.get({id:entity.id},function(data){
                vm.folder = data;
            })
        }else{
            vm.folder = {type:entity.type};
        }


        function clear() {
            $uibModalInstance.dismiss('cancel');
        }



        $scope.validate = function () {
            if (vm.folder.name == null || vm.folder.name == "") {
                MessageService.error($translate.instant("folder.enterName"));
                return false;
            }
            return true;
        };

        function save() {
            if (!$scope.validate()) {
                return;
            }
            vm.isSaving = true;
            if (entity.id) {
                Folder.update(vm.folder , onSaveSuccess, onSaveError)
            }else{
                Folder.save(vm.folder ,onSaveSuccess, onSaveError)
            }

        }
        function onSaveSuccess(result) {
            MessageService.success($translate.instant("folder.createSuccess"));
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            MessageService.error($translate.instant("folder.createFailed"));
            vm.isSaving = false;
        }

    }

})();

(function(){
	"use strict";
	angular
	.module("editorApp")
	.controller("EntityMoveFolderController", EntityMoveFolderController);
	EntityMoveFolderController.$inject = ['$scope', '$uibModalInstance', 'MessageService', '$stateParams',  'Folder', 'entity', 'Article', 'Gallery', '$translate'];

    function EntityMoveFolderController( $scope,  $uibModalInstance, MessageService, $stateParams,  Folder, entity, Article, Gallery, $translate) {

       var vm = this;
        vm.clear = clear;
        vm.save = save;
        vm.entity = entity;
        if(entity.ids && entity.type){
            Folder.storeGetAllByCondition({items: [{key: "type", op: "=", value: entity.type},{key: "articleId", op: "=", value: entity.articleId}]},function(res){
                $scope.folders = res.data;
            });
        }
        vm.folderId = entity.folderId || null;
        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        $scope.folderSelected = function(folder){
            if (folder == null) {
                //空目录
                $scope.folderId = "";

            }else  if (folder != null) {
                //文件夹
                if (folder.id == $scope.folderId) {
                    $scope.folderId = null;
                    folder.selected = false;
                }else{
                    for (var i = $scope.folders.length - 1; i >= 0; i--) {
                        var f = $scope.folders[i];
                        if (f.selected) {
                            f.selected = false;
                        }
                    }
                    folder.selected = true;
                    $scope.folderId = folder.id;
                }
            }

        }



        $scope.validate = function () {
            if ($scope.folderId == null) {
                MessageService.error($translate.instant("move.failedSelectFolder"));
                return false;
            }
            return true;
        };

        function save() {
            if (!$scope.validate()) {
                return;
            }
            vm.isSaving = true;
            if (entity.ids && entity.type == 'Article') {
                Article.moveFolder({articles: entity.ids , folderId: $scope.folderId}, onSaveSuccess, onSaveError)
            }else if (entity.ids && entity.type == 'Gallery') {
                //图片库操作  Gallery
                Gallery.moveFolder({galleries: entity.ids , folderId: $scope.folderId}, onSaveSuccess, onSaveError)

            }
        }
        function onSaveSuccess(result) {
            MessageService.success($translate.instant("move.success"));
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            MessageService.error($translate.instant("move.failed"));
            vm.isSaving = false;
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('editorApp')
        .controller('Template2Controller', Template2Controller);

    Template2Controller.$inject = ['$state', 'AuthServerProvider', '$stateParams', 'Article', 'StoreWorkEditConfig', 'Product', 'Editors','$localStorage', 'OrderArticle'];

    function Template2Controller($state, AuthServerProvider, $stateParams, Article, StoreWorkEditConfig, Product, Editors,$localStorage, OrderArticle) {

        // {storeId}/{pid}/{vid}/{aid}
        $(".navbar").hide();
        $(".wrap").hide();
        var storeId = $stateParams.storeId;
        var pid = $stateParams.pid;
        var vid = $stateParams.vid;
        var aid = $stateParams.aid;
        var orderArticleId = $stateParams.orderArticleId;
        localStorage.removeItem('variableData');
        var variableData = $stateParams.variableData;
        if(variableData){
            localStorage.setItem('variableData', variableData);
        }
        localStorage.setItem('themeFlag', 'two');
        //清除即时保存数据
        localStorage.removeItem('save-article');
        console.log($stateParams)

        //对escape()编码的字符串进行解码
        function getQueryString(name) {
            var reg = new RegExp("(^|)" + name + "=([^&]*)(&|$)", "i");
            var r = window.location.href.match(reg);
            if(r != null){
                return window.decodeURIComponent(r[2]);
            }
            return null;//如果此处只写return;则返回的是undefined
        };
        var str = getQueryString("returnurl");
        var str1 = getQueryString("returnurl1");
        var str2 = getQueryString("returnurl2");
        var saveUserName = getQueryString("saveUserName");
        var returnurl2Text = getQueryString("returnurl2Text");
        var source = getQueryString("source");
        console.log(returnurl2Text)
        if(str){
            localStorage.setItem('returnurl', str);
        }else{
            localStorage.removeItem('returnurl')
        }
        if(str1){
            localStorage.setItem('returnurl1',str1);
        }else {
            localStorage.removeItem('returnurl1')
        }

        if(str2){
            localStorage.setItem('returnurl2', str2);
        }else {
            localStorage.removeItem('returnurl2')
        }
        if(saveUserName){
            localStorage.setItem('saveUserName', saveUserName);
        }else {
            localStorage.removeItem('saveUserName')
        }
        if(returnurl2Text){
            localStorage.setItem('returnurl2Text', returnurl2Text);
        }else {
            localStorage.removeItem('returnurl2Text')
        }
        if(source){
            localStorage.setItem('source', source);
        }else {
            localStorage.removeItem('source')
        }
        function isMobile(){
            var ua = window.navigator.userAgent;
            var isWeChat = ua.match(/MicroMessenger/i);
            if(isWeChat){
                // 检测是否为 PC 微信小程序环境（PC 小程序特有标识）
                if (/MiniProgramEnv\/Windows|MiniProgramEnv\/Mac/i.test(ua)) {
                     return true; // 这就是PC 小程序 WebView
                 }
                 // PC微信内置浏览器（打开普通链接）
                 if (/WindowsWechat|MacWechat/i.test(ua)) {
                     return false;
                 }
                 // 手机端微信
                 return true;
             }
            if(ua.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone|HarmonyOS|Harmony)/i)) {
                return true;
            }else{
                return false;
            }
        }
        var isMobile = isMobile();
        // return

        if ($stateParams.auth) {
            AuthServerProvider.storeAuthenticationToken($stateParams.auth, true);
            init();
        }
        else if ($stateParams.ticket) {
            var token = getToken($stateParams.ticket, function(token) {
                if (token) {
                    AuthServerProvider.storeAuthenticationToken(token, true);
                    init();
                } else {
                    // illegal
                    console.error("Cannot open article with failure of getToken");
                }
            });
        } else {
            // illegal
            console.error("Cannot open article with nothing ticket or auth");
        }

        function getToken(ticket, callback) {
            Article.getToken({ticket: ticket}, function (res) {
                if (res.status == 200) {
                    var token = res.data;
                    if (token && callback) {
                        callback(token);
                    } else {
                        console.log("Invalid token or callback, token=" + token);
                    }
                } else {
                    console.log("Error to getToken with ticket: " + ticket + ", article=" + aid);
                }
            });
        }

        function init() {
            debugger
            if (orderArticleId) {
                OrderArticle.get({id: orderArticleId},function(res){
                    var data = res.data;
                    document.title = data.productName;
                    if (!isMobile) {
                        // pc browser
                        if (data.editorType == "PICTURE" || data.editorType == "PICTURE_PRO" || data.editorType == "PICTURE_PRO_P") {
                            $state.go('editorPhotoWebEdit1', {storeId: storeId, orderArticleId: orderArticleId},{location: 'replace'})
                        }
                        else {
                            $state.go('editorPhotoAlbumEdit1', {storeId: storeId, orderArticleId: orderArticleId},{location: 'replace'})
                        }
                    }
                    else {
                        // mobile device
                        $state.go('404',{storeId:vm.storeId,tips:"不支持的接口调用"},{location: 'replace'});
                    }
                })
            }
            else if (aid) {
                Article.get({id: aid},function (res) {
                    if(res.status==200){
                        $localStorage.article = res.data;
                        document.title = res.data.productName;
                        if(res.data.invalid){//作品失效
                            $state.go('articlesFailure',{storeId:storeId},{location: 'replace'});
                            return
                        }
                        Product.get({id: pid}, function (res1) {
                            var product = res1.data;
                            var data = res.data;
                            //进入新建页面
                            if (data.articleStatus=='NEW'){
                                StoreWorkEditConfig.storeId(function (msg) {
                                    if (msg.status == 200) {
                                        // sku
                                        if(msg.data.level == 'ItemValue'){
                                            selectXml(data);
                                        }else{
                                            // 模板行
                                            if(!isMobile){
                                                if (data.editorType == "PICTURE" || data.editorType == "PICTURE_PRO" || data.editorType == "PICTURE_PRO_P") {
                                                    $state.go("editorPhotoBothWeb", {storeId: storeId, pid: pid, vid: data.itemValueId, xmlId: vid, aid: aid},{location: 'replace'});
                                                }else{
                                                    $state.go("editorPhotoAlbum", {storeId: storeId, pid: pid, vid: data.itemValueId, xmlId: vid, aid: aid},{location: 'replace'});
                                                }
                                            }else{
                                                localStorage.setItem("Production", "start");
                                                localStorage.removeItem("pages");
                                                localStorage.removeItem("article-count");
                                                localStorage.removeItem("work-save");
                                                if (data.editorType == "PICTURE" || data.editorType == "PICTURE_PRO" || data.editorType == "PICTURE_PRO_P") {
                                                    $state.go("editorPhotoBoth", {storeId: storeId, pid: pid, vid: data.itemValueId, xmlId: vid, aid: aid},{reload: true,location: 'replace'});
                                                    return
                                                }
                                                if (data.editorType == 'BOOK_JUNIOR') {
                                                    $state.go('product-choose-ec', {storeId: storeId, pid: pid, vid: data.itemValueId, xmlId: vid, aid: aid},{location: 'replace'})
                                                } else if (data.editorType == null || data.editorType == "" || data.editorType == 'BOOK_SENIOR') {
                                                    $state.go('product-chooseNew-ec', {storeId: storeId, pid: pid, vid: data.itemValueId, xmlId: vid, aid: aid},{location: 'replace'})
                                                } else if (data.editorType == 'NEW_EDITOR'||data.editorType == 'CALENDAR_EDITOR') {
                                                    $state.go('editorPhotoAlbumM', {storeId: storeId, pid: pid, vid: data.itemValueId, xmlId: vid, aid: aid},{location: 'replace'})
                                                } else if (data.editorType == "FORM_EDITOR") {
                                                    $state.go('editorForm', {storeId: storeId, pid: pid, vid: data.itemValueId, xmlId: vid, aid: aid},{location: 'replace'})
                                                } else if (data.editorType == "PHOTO_EDITOR") {
                                                    $state.go('idPhoto', {storeId: storeId, pid: pid, vid: data.itemValueId, xmlId: vid, aid: aid},{location: 'replace'})
                                                }else{
                                                    $state.go('product-chooseThree-ec', {storeId: storeId, pid: pid, vid: data.itemValueId, xmlId: vid, aid: aid},{location: 'replace'})
                                                }
                                            }
                                        }
                                    }
                                })
                            }else{
                                // 进入编辑页面
                                if(!isMobile){
                                    if(data.editorType=='PICTURE' || data.editorType=='PICTURE_PRO' || data.editorType=='PICTURE_PRO_P'){
                                        $state.go("editorPhotoBothWebEdit",{storeId:storeId,aid:aid},{location: 'replace'})
                                    }else{
                                        $state.go('editorPhotoAlbumEdit', {storeId:storeId,aid:aid},{location: 'replace'})
                                    }
                                }else{
                                    localStorage.setItem("Production", "view");
                                    if (data.editorType == 'BOOK_JUNIOR') {
                                        $state.go('editorPhotoAlbumEditM', {storeId: storeId, aid: aid}, {reload: true,location: 'replace'});
                                    } else if (data.editorType == "PHOTO_EDITOR") {
                                        $state.go("idPhotoEdit", {storeId: storeId, aid: aid}, {reload: true,location: 'replace'});
                                    }  else if (data.editorType == "PICTURE" || data.editorType == "PICTURE_PRO" || data.editorType == "PICTURE_PRO_P") {
                                        $state.go("editorPhotoBothEdit", {storeId: storeId, aid: aid},{reload: true,location: 'replace'});
                                    } else if (data.editorType == null || data.editorType == "" || data.editorType == 'BOOK_SENIOR') {
                                        $state.go('editorPhotoAlbumEditM', {storeId: storeId, aid: aid}, {reload: true,location: 'replace'});
                                    } else if (data.editorType == 'NEW_EDITOR'||data.editorType == 'CALENDAR_EDITOR') {
                                        $state.go('editorPhotoAlbumEditM', {storeId: storeId, aid: aid}, {reload: true,location: 'replace'});
                                    }else{
                                        $state.go('product-choosesThree-ec', {storeId: storeId, aid: aid}, {reload: true,location: 'replace'});
                                    }
                                }
                            }
                        })
                    }
                })
            }
        }



        function selectXml(data) {
            //web 端
            Product.get({id: pid}, function (res) {
                if(!isMobile){
                    Editors.navigateSelect(storeId, {pid:pid, vid:vid, aid:aid, mobile: isMobile, selectState: 'commoditySelect'})
                }else{
                    Editors.navigateSelect(storeId, {pid:pid, vid:vid, aid:aid, mobile: isMobile, selectState: 'thumbnail'})
                }
            })
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('editorApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('thumbnail', {
                parent: 'app',
                url: '/{storeId}/{pid}/{vid}/{aid}/productThumbnail',
                data: {
                    authorities: [],
                    pageTitle: 'product.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/template/template.html',
                        controller: 'TemplateController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('product');
                        $translatePartialLoader.addPart('common');
                        return $translate.refresh();
                    }],
                    // entity: ['$stateParams', 'Product', function ($stateParams, Product) {
                    //     return Product.get({id: $stateParams.pid}).$promise;
                    // }]
                }
            })
            .state('thumbnail2', {
                parent: 'app',
                url: '/{storeId}/{pid}/{vid}/{aid}/articleDesign?auth&ticket&variableData&returnurl&returnurl2&returnurl2Text&saveUserName',
                data: {
                    authorities: [],
                    pageTitle: 'editorApp.product.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: '',
                        controller: 'Template2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('product');
                        $translatePartialLoader.addPart('common');
                        return $translate.refresh();
                    }]
                }
            })
            .state('order-article-design2', {
                parent: 'app',
                url: '/{storeId}/{orderArticleId}/articleDesign2?auth&ticket&variableData&returnurl&returnurl2&returnurl2Text&saveUserName',
                data: {
                    authorities: [],
                    pageTitle: 'editorApp.product.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: '',
                        controller: 'Template2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('product');
                        $translatePartialLoader.addPart('common');
                        return $translate.refresh();
                    }]
                }
            })
            .state('preview', {
                parent: 'app',
                url: '/{storeId}/{pid}/{vid}/{aid}/articlePreview?auth&ticket',
                data: {
                    authorities: [],
                    pageTitle: 'editorApp.product.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: '',
                        controller: 'PreviewController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('product');
                        $translatePartialLoader.addPart('common');
                        return $translate.refresh();
                    }]
                }
            })
            .state('preview2', {
                parent: 'app',
                url: '/{storeId}/{orderArticleId}/articlePreview2?auth&ticket',
                data: {
                    authorities: [],
                    pageTitle: 'editorApp.product.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: '',
                        controller: 'PreviewController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('product');
                        $translatePartialLoader.addPart('common');
                        return $translate.refresh();
                    }]
                }
            })
            .state('share', {
                parent: 'app',
                url: '/{storeId}/{pid}/{vid}/{aid}/articleShare?auth&ticket',
                data: {
                    authorities: [],
                    pageTitle: 'editorApp.product.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: '',
                        controller: 'PreviewController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('product');
                        $translatePartialLoader.addPart('common');
                        return $translate.refresh();
                    }]
                }
            })
            //手机传图回调功能
            .state('galleryUploadPage0', {
                parent: 'app',
                url: '/{storeId}/{fid}/gallery/{aid}?auth&ticket',
                data: {
                    authorities: [],
                    pageTitle: 'home.title'
                },
                views: {
                    'content@': {
                        templateUrl: '',
                        controller: 'GalleryUpload0PageController',
                        controllerAs: 'vm'
                    }
                }
            })
            //web端调用传照片 传图中
            .state('galleryUploadPage', {
                parent: 'app',
                url: '/{storeId}/{fid}/gallery/uploading/{aid}',
                data: {
                    authorities: [],
                    pageTitle: 'home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/gallery/gallery-upload.html',
                        controller: 'GalleryUploadPageController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('editor');
                        $translatePartialLoader.addPart('gallery');
                        $translatePartialLoader.addPart('common');
                        return $translate.refresh();
                    }],
                }
            })
            ;
    }

})();

(function() {
    'use strict';
    angular
        .module('editorApp')
        .factory('Qinius', Qinius)
        .factory('WxJS', WxJS)
        .factory('ServiceWxJS', ServiceWxJS)
        .factory('ItemValue', ItemValue)
        .factory('Convert', Convert)
        .factory('StoreWechatSetting', StoreWechatSetting)
        .factory('Evaluate', Evaluate)
        .factory('Store', Store)
        .factory('StoreConfig', StoreConfig)
        .factory("SubstitutionSetting", SubstitutionSetting)
        .factory('ProductXml', ProductXml)
        .factory('ThemeClassify', ThemeClassify)
        .factory('ProductTitle', ProductTitle)
        .factory('ProductTitleConfig', ProductTitleConfig)
        .factory('ProductTitleStyle', ProductTitleStyle)
        .factory('ProductPurchase', ProductPurchase)
        .factory('Document', Document);

    Qinius.$inject = ['$resource'];
    WxJS.$inject = ['$resource'];
    ServiceWxJS.$inject = ['$resource'];
    ItemValue.$inject = ['$resource'];
    Convert.$inject = ['$resource'];
    StoreWechatSetting.$inject = ['$resource'];
    Evaluate.$inject = ['$resource', 'DateUtils'];
    Store.$inject = ['$resource'];
    StoreConfig.$inject = ['$resource'];
    SubstitutionSetting.$inject = ['$resource'];
    ProductXml.$inject = ['$resource'];
    ThemeClassify.$inject = ['$resource'];
    ProductTitle.$inject = ['$resource'];
    ProductTitleConfig.$inject = ['$resource'];
    ProductTitleStyle.$inject = ['$resource'];
    ProductPurchase.$inject = ['$resource'];
    Document.$inject = ['$resource'];

    function SubstitutionSetting ($resource) {
        var resourceUrl =  'manager/' + 'api/substitution-settings/:path';
        return $resource(resourceUrl, {}, {
            "getByStore":{
                method:"GET",
                params:{
                    path:"getByStore"
                }
            }
        });
    }

    function ProductXml ($resource) {
        var resourceUrl =  'manager/' + 'api/product-xmls/:path/:id';
        return $resource(resourceUrl, {}, {
            "byCondition":{
                method:"POST",
                params:{
                    path:"byCondition"
                }
            },
            "get":{
                method:"GET"
            }
        });
    }

    function ItemValue($resource) {
        var resourceUrl = 'manager/' + 'api/item-values/:path/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                params:{
                    path:"client"
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }

    function Convert ($resource) {
        var resourceUrl =  'fileserves/' + 'api/convert/:path/:storeId/:id';

        return $resource(resourceUrl, {}, {
            "thumbnailator": {
                method:"GET",
                params:{
                    path:"thumbnailator"
                }
            },
            "imageOptimize":{
                method:"GET",
                params:{
                    path:"imageOptimize"
                }
            },
            'xmlToPicLayoutDocument': {
                method: 'GET',
                params: {
                    path: 'xmlToPicLayoutDocument'
                }
            },
            "uploadDocument":{
                method:"POST",
                params:{
                    path:"uploadDocument"
                }
            },
            "articleUploadDocument":{
                method:"POST",
                params:{
                    path:"articleUploadDocument"
                }
            },
            "xmlToDocument2":{
                method:"GET",
                params:{
                    path:"xmlToDocument2"
                }
            },
            "xmlToDocument":{
                method:"GET",
                params:{
                    path:"xmlToDocument"
                }
            },
            "imgFilter":{
                method: 'GET',
                params: {
                    path: "filter"
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            "articles":{
                method:"GET",
                params:{
                    path:"articles"
                }
            },
            "saveArticle":{
                method:"POST",
                params:{
                    path:"saveArticle"
                }
            }
        });
    }

    function Evaluate($resource, DateUtils) {
        var resourceUrl = 'service/' + 'api/evaluates/:path/:id';

        return $resource(resourceUrl, {}, {
            'byCondition': {
                method: 'POST',
                params: {
                    path: 'byCondition'
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function(data) {
                    var copy = angular.copy(data);
                    copy.startTime = DateUtils.convertLocalDateToServer(copy.startTime);
                    copy.endTime = DateUtils.convertLocalDateToServer(copy.endTime);
                    return angular.toJson(copy);
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                        // data.startTime = DateUtils.convertLocalDateFromServer(data.startTime);
                        // data.endTime = DateUtils.convertLocalDateFromServer(data.endTime);
                    }
                    return data;
                }
            },
            "addEvaluates":{
                method:"GET",
                params:{
                    path:"add"
                }
            }
        });
    }

    function Store($resource) {
        var resourceUrl = 'manager/' + 'api/stores/:path/:id';

        return $resource(resourceUrl, {}, {
            "get": {
                method: "GET"
            },
            "getAllByCondition": {
                method: "POST",
                params: {
                    path: "getAllByCondition"
                }
            },
            "current": {
                method: "GET",
                params: {
                    path: "current"
                }
            }
        });
    }

    function StoreConfig($resource) {
        var resourceUrl = 'manager/' + 'api/store-configs/:path/:id';

        return $resource(resourceUrl, {}, {
            'getCurrent': {
                method: 'GET',
                params: {
                    path: "current"
                },
            },
            'getAllByTypes': {
                method: 'POST',
                params: {
                    path: "getAllByTypes"
                }
            },
            "byStoreIdAndType": {
                method: 'GET',
                params: {
                    path: "byStoreIdAndType"
                },
            },
            "getAllByCondition": {
                method: "POST",
                params: {
                    path: "getAllByCondition"
                }
            },
            'update': {
                method: 'PUT',
            }
        });
    }

    function Qinius($resource) {
        var service = $resource('manager/api/qiniu/:path/:id', {}, {
            'get': {
                method: 'GET',
                params: {
                    path: 'upload-token'
                },
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'tokenWithPolicy': {
                method: 'GET',
                params: {
                    path: 'tokenWithPolicy'
                },
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'getDomain':{
                method: 'GET',
                params: {
                    path: 'bucket-domains'
                }
            }
        });
        return service;
    }

    function ServiceWxJS ($resource) {
        var resourceUrl =  'service/' + 'api/wechat/:path';
        return $resource(resourceUrl, {}, {
            'payConfig': {
                method: 'GET',
                params:{
                    path:"payConfig"
                }
            }
        });
    }

    function WxJS ($resource) {
        var resourceUrl =  'manager/' + 'api/wechat/:path';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                params:{
                    path:"webConfig"
                }
            },
            'get1': {
                method: 'GET',
                params: {
                    path: "small_webconfig"
                }
            },
            'get2': {
                method: 'GET',
                params:{
                    path:"webconfig2"
                }
            },
            'getTicket': {
                method: 'GET',
                params: {
                    path: "js-ticket"
                }
            },
            'payConfig': {
                method: 'GET',
                params:{
                    path:"payConfig"
                }
            },
            'wechartQRPay': {
                method: 'GET',
                params: {
                    path: 'wechartQRPay'
                }
            }
        });
    }

    function StoreWechatSetting($resource){
        var resourceUrl = "manager/api/store-wechat-settings/:path/:id";
        return $resource(resourceUrl,{},{
            "get":{
                method:"GET",
            },
            "getByStoreId":{
                method:"GET",
                params:{
                    path:"getByStoreId"
                }
            },
            "getPublicWechatSetting":{
                method:"GET",
                params:{
                    path:"getPublicWechatSetting"
                }
            },
            "getAuthorizerInfo": {
                method: "GET",
                params: {
                    path: "getAuthorizerInfo"
                }
            }

        });
    }

    function ThemeClassify($resource){
        var resourceUrl = "manager/api/theme-classify/:path/:id";

        return $resource(resourceUrl, {}, {
            "getAll": {
                method: "POST",
                params: {
                    path: "getAllByCondition"
                }
            },
            "byCondition":{
                method:"POST",
                params:{
                    path:"byCondition"
                }
            },
            "byCondition3":{
                method:"POST",
                params:{
                    path:"byCondition3"
                }
            },
            "getAllByCondition3":{
                method:"POST",
                params:{
                    path:"getAllByCondition3"
                }
            },
            "getAllByCondition":{
                method:"POST",
                params:{
                    path:"getAllByCondition"
                }
            },
            "byCondition4":{
                method:"GET",
                params:{
                    path:"byCondition4"
                }
            },
            "getAllByCondition4":{
                method:"GET",
                params:{
                    path:"getAllByCondition4"
                }
            },
            "del":{
                method:"DELETE"
            },
            "changeStatue":{
                method:"GET",
                params:{
                    path:"changeStatue"
                }
            },
            "get":{
                method:"GET"
            },
            "save":{
                method:"PUT"
            }
        });
    }

    function ProductTitle ($resource) {
        var resourceUrl =  'manager/' + 'api/product-titles/:path/:id';
        return $resource(resourceUrl, {}, {
            "byCondition":{
                method:"POST",
                params:{
                    path:"byCondition"
                }
            },
            "getAllByCondition":{
                method:"POST",
                params:{
                    path:"getAllByCondition"
                }
            }
        });
    }

    function ProductTitleConfig ($resource) {
        var resourceUrl =  'manager/' + 'api/product-title-configs/:path/:id';

        return $resource(resourceUrl, {}, {
            'storeId': {
                method: 'GET',
                params: {
                    path: 'storeId'
                },
            },
            'update': { method:'PUT' }
        });
    }

    function ProductTitleStyle ($resource) {
        var resourceUrl =  'manager/' + 'api/product-title-styles/:path/:id';
        return $resource(resourceUrl, {}, {
            "countHits":{
                method:"GET",
                params:{
                    path:"countHits"
                }
            },
            "getProducts":{
                method: 'POST',
                params: {
                    path: 'getProducts'
                }
            },
            "byCondition":{
                method:"POST",
                params:{
                    path:"byCondition"
                }
            },
            "getAllByCondition":{
                method:"POST",
                params:{
                    path:"getAllByCondition"
                }
            }
        });
    }

    function ProductPurchase ($resource){
        var resourceUrl ="manager/api/product-purchases/:path/:id";
        return $resource(resourceUrl,{},{
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
        })
    }

    function Document ($resource){
        var resourceUrl =  'fileserves/' + 'api/convert/document/:path/:storeId/:id';
        return $resource(resourceUrl,{},{
            "importData":{
                method:"POST",
                params:{
                    path:"importData"
                }
            }
        })
    }
})();

(function () {
    'use strict';

    angular
        .module('editorApp')
        .controller('TemplateController', TemplateController);

    TemplateController.$inject = ['$state', '$scope', '$stateParams', '$q', '$localStorage', 'Qinius', 'Theme',
    'ProductXml', 'ToneSettings', '$cookies', '$rootScope', 'Product'];

    function TemplateController($state, $scope, $stateParams, $q, $localStorage, Qinius, Theme,
     ProductXml, ToneSettings, $cookies, $rootScope, Product) {

        var vm = this;

        $(".navbar-gallery").hide();
        $(".wrap").show().addClass('no-margins');
        $(".well").css({'margin-bottom': 0});
        $scope.dWidth = document.documentElement.clientWidth;
        $("body").css({width: $scope.dWidth, 'min-width': $scope.dWidth});
        vm.showDetail = false;
        // vm.product = entity;
        vm.chooseTheme = chooseTheme;
        vm.changeImgStyle = changeImgStyle;
        var num = 0;
        vm.storeId = $stateParams.storeId || $localStorage.storeId;
        vm.pid = $stateParams.pid;
        vm.vid = $stateParams.vid;
        vm.aid = $stateParams.aid;
        $localStorage.article = {id:vm.aid};
        $scope.selectMenuShow = false;
        console.log(vm.vid)
        //风格切换  引入不同的css文件
        Theme.judge();

        $scope.imgClick = function (event) {
            if (event == null || event.originalEvent == null || event.currentTarget == null) {
                return;
            }
            if (event.originalEvent.layerX > event.currentTarget.clientWidth / 2) {
                $scope.nextImg();
            } else {
                $scope.prevImg();
            }

        }

        $scope.screenWidth = window.screen.width;
        vm.domains = Qinius.getDomain();
        vm.product = Product.get({id: $stateParams.pid});
        vm.width = $(window).width();
        var init = 0;

        var unsubscribe = $rootScope.$on('changeLanguage', function(event, result) {
            vm.product = Product.get({id: $stateParams.pid});
            $q.all([vm.product.$promise, vm.domains.$promise]).then(function () {
                $scope.init();
                vm.chooseTheme(null, -1);
            });
        });
        $scope.$on('$destroy', unsubscribe);

        $scope.init = function(){
            vm.product = vm.product.data;
            vm.lagnuages =[];
            if ($localStorage.lagnuages) {
                for(var i = 0 ; i<$localStorage.lagnuages.length; i++ ){
                    var lang = $localStorage.lagnuages[i];
                    var langObj = {key:lang};
                    if (lang == 'zh-cn') {
                        langObj.value = "中文";
                    }
                    if (lang == 'en') {
                        langObj.value = "English";
                    }
                    if (vm.lang == lang) {
                        vm.langValue = langObj.value;
                        langObj.selected = true;
                    }
                    vm.lagnuages.push(langObj);
                }
            }
            // 屏幕尺寸
            vm.windowWidth = $(window).width();
            vm.windowHeight = $(window).height() + 'px';
            vm.len = 0;
            for (var i = 0; i < vm.product.itemValues.length; i++) {
                var itemValue = vm.product.itemValues[i];
                if (itemValue.cancelled) {
                    continue;
                }
                vm.len++;
                if (itemValue.id == vm.vid) {
                    vm.itemValueOne = angular.copy(itemValue);
                    vm.itemValueOneCopy = angular.copy(itemValue);
                }
            }
            vm.themeList = [];
            if (vm.itemValueOne != null && vm.itemValueOne.productXmlLines != null && vm.itemValueOne.productXmlLines.length > 0) {
                vm.itemValueOne.productXmlLines.sort(function (a, b) {
                    return a.seq - b.seq;
                });
                for (var i = 0; i < vm.itemValueOne.productXmlLines.length; i++) {
                    var line = vm.itemValueOne.productXmlLines[i];
                    if (!line.themeClassifies || line.cancelled||!line.paid) {
                        continue;
                    }
                    line.themeClassifies.forEach(function (themeClassifie) {
                        if(!checkRepetition(themeClassifie.id)){
                            vm.themeList.push({
                                id: themeClassifie.id,
                                name: themeClassifie.name,
                                seq: Number(line.productXmlThemeSeq) + Number(themeClassifie.seq)
                            });
                        }
                    })
                }
            }
            vm.themeList.sort(function (a, b) {
                return a.seq - b.seq;
            })

            $scope.domain = 'https://' + vm.domains.domains[0] + '/';
            getToneSettings();
        }

        $q.all([vm.product.$promise, vm.domains.$promise]).then(function () {
            $scope.init();
        });

        function getToneSettings() {
            ToneSettings.byStoreId({id:vm.storeId}, function (res) {
                if(res.status == 200){
                    if(res.data){
                        vm.toneSettings = res.data;
                        console.log(vm.toneSettings.logo)
                        for(var key in  res.data){
                            if(res.data[key]){
                                document.body.style.setProperty('--' + key, res.data[key]);
                            }
                        }
                    }
                }else{
                    swal({
                        title: res.message,
                        text: "",
                        showConfirmButton: false,
                        type: "info"
                    });
                }
            }, function (error) {});
        }

        // 检查是否存在重复--vm.themeList
        function checkRepetition(id) {
            if (vm.themeList.length == 0) {
                return false;
            } else {
                for (var i = 0; i < vm.themeList.length; i++) {
                    if (vm.themeList[i].id == id) {
                        return true;
                    }
                }
            }
            return false;
        }

        $scope.closeModal = function () {
            $scope.selectMenuShow = !$scope.selectMenuShow;
        }

        $scope.prevImg = function () {
            if (init > 0) {
                init--;
            } else {
                return;
            }
            document.getElementById("top-img").src = vm.imgs[init].identifier + '?imageView2' || '//:0';
        };
        $scope.nextImg = function () {
            if (init < (num - 1)) {
                init++;
            } else {
                return;
            }
            document.getElementById("top-img").src = vm.imgs[init].identifier + '?imageView2' || '//:0';
        };

        $scope.valueSeleted = function (value) {
            vm.productXmlLine = value;
            if (value.xmlShowPic) {
                //图片预览出来
                vm.xmlShowPic = true;
                ProductXml.get({id: vm.productXmlLine.productXmlId}, function (res) {
                    if(res.status == 200){
                        if (res.data.documentPics && res.data.documentPics.length > 0) {
                            res.data.documentPics.sort(function (a, b) {
                                return a.seq - b.seq;
                            });
                        }
                        vm.imgs = res.data.documentPics;
                        num = vm.imgs.length || 0;
                    }else {
                        MessageService.error(res.message);
                    }
                }, function () {

                })
            } else {
                $scope.productChoose();
            }
        };

        $scope.previewClose = function () {
            init = 0;
            vm.xmlShowPic = false;
        };

        var startMade = function (xmlId) {
            localStorage.removeItem("delPic");
            localStorage.removeItem("picArrChoose");
            localStorage.removeItem("picArrChoose2");
            localStorage.removeItem("gallery2");
            localStorage.removeItem("picArrCopy");
            localStorage.removeItem("picArr");
            localStorage.removeItem("isSort");
            var workSave = JSON.parse(localStorage.getItem('work-save'));
            if (workSave) {
                var nearHour = (new Date().getTime() - workSave.date) / 1000 / 3600;
                console.log(nearHour);
                if (workSave.pid == vm.pid && workSave.vid == vm.vid && (workSave.xmlId == xmlId || workSave.xmlId == "null" && xmlId == null) && nearHour <= 3) {
                    return
                }
            }

            localStorage.setItem("Production", "start");
            localStorage.removeItem("choose");
            localStorage.removeItem("multipartUpload");
            localStorage.removeItem("index");
            localStorage.removeItem("i");
            localStorage.removeItem("go");
            localStorage.removeItem("single");
            localStorage.removeItem("pages");
            localStorage.removeItem("marginLeft");
            localStorage.removeItem("$index");
            localStorage.removeItem("next");
            localStorage.removeItem("gallery");
            localStorage.removeItem("galleryCopy");
            localStorage.removeItem("saveOldPage");
            localStorage.removeItem("saveOldPageIndex");
            localStorage.removeItem("reviewPages");
            localStorage.removeItem("pageAllPx");
            localStorage.removeItem("pageAllMm");
            localStorage.removeItem("work-save");
            localStorage.setItem('countN', 1);

            var gallerys = JSON.parse(localStorage.getItem('gallery'));
            angular.forEach(gallerys, function (gallery) {
                gallery.useNum = 0;       //次数清零
            });
            localStorage.setItem('gallery', JSON.stringify(gallerys));
        };

        $scope.productChoose = function () {
            var xmlId = vm.productXmlLine.id;

            startMade(xmlId);
            debugger
            if (vm.product.editorType == null || vm.product.editorType == "" || vm.product.editorType == "BOOK_SENIOR") {
                $state.go('editorPhotoAlbumM', {storeId: vm.storeId, pid: vm.pid, vid: vm.vid, xmlId: xmlId, aid: vm.aid},{location: 'replace'})
            } else if (vm.product.editorType == "PICTURE" || vm.product.editorType == "PICTURE_PRO" || vm.product.editorType == "PICTURE_PRO_P") {
                $state.go('editorPhotoBoth', {storeId: vm.storeId, pid: vm.pid, vid: vm.vid, xmlId: xmlId, aid: vm.aid},{location: 'replace'})
            }   else if (vm.product.editorType == "BOOK_JUNIOR") {
                $state.go('editorPhotoAlbumM', {storeId: vm.storeId, pid: vm.pid, vid: vm.vid, xmlId: xmlId, aid: vm.aid},{location: 'replace'})
            }  else if (vm.product.editorType == "PHOTO_EDITOR") {
                $state.go('idPhoto', {storeId: vm.storeId, pid: vm.pid, vid: vm.vid, xmlId: xmlId, aid: vm.aid},{location: 'replace'})
            } else if (vm.product.editorType == "POSTER" || vm.product.editorType == "DIY_EDITOR") {
                $state.go('product-chooseThree-ec', {storeId: vm.storeId, pid: vm.pid, vid: vm.vid, xmlId: xmlId, aid: vm.aid},{location: 'replace'})
            } else if (vm.product.editorType == "FORM_EDITOR") {
                $state.go('editorForm', {storeId: vm.storeId, pid: vm.pid, vid: vm.vid, xmlId: xmlId, aid: vm.aid},{location: 'replace'})
            } else if (vm.product.editorType == "NEW_EDITOR"||vm.product.editorType == "CALENDAR_EDITOR") {
                $state.go('editorPhotoAlbumM', {storeId: vm.storeId, pid: vm.pid, vid: vm.vid, xmlId: xmlId, aid: vm.aid},{location: 'replace'})
            } else {
                $state.go('editorPhotoAlbumM', {storeId: vm.storeId, pid: vm.pid, vid: vm.vid, xmlId: xmlId, aid: vm.aid},{location: 'replace'})
            }
        };
        function isIphoneX() {
            return /iphone/gi.test(navigator.userAgent) && (screen.height == 812 && screen.width == 375)
        }

        $scope.isIphoneX = isIphoneX();

        var windowH = $(window).height();
        if (localStorage.getItem('windowH')) {
            windowH = localStorage.getItem('windowH')
        }

        $(window).scroll(function () {
            if ($scope.isIphoneX) {
                var wh = $(window).height(); //页面可视化区域高度
                if (wh > windowH) {
                    $(".iphoneX-content").height(36);
                } else {
                    $(".iphoneX-content").height(0);
                }
            }
        });

        var theme_index = -1;

        function chooseTheme(name, index) {
            if (index == -1) {
                // vm.itemValueOne = angular.copy(vm.itemValueOneCopy);
                if (vm.searchText) {
                    vm.itemValueOne.productXmlLines = [];
                    vm.oldThemeList = angular.copy(vm.itemValueOneCopy.productXmlLines);
                    vm.itemValueOne.productXmlLines = vm.fuzzyQuery(vm.oldThemeList , vm.searchText)
                }else{
                    vm.itemValueOne = angular.copy(vm.itemValueOneCopy);
                }
                if (vm.itemValueOne.productXmlLines.length) {
                    vm.itemValueOne.productXmlLines.sort(function(a, b){
                        return a.seq-b.seq;
                    })
                }

                $("#themeDiv_00").addClass("bc-ff9803");
                $("#themeDiv_" + theme_index).removeClass("bc-ff9803");
                $("#themeDiv0_" + theme_index).removeClass("bc-ffffff");

                $("#themeDiv0_00").removeClass("bc-fafafa");
                $("#themeDiv0_00").addClass("bc-ffffff");
                theme_index = -1;
            } else {
                if (theme_index == -1) {
                    $("#themeDiv_00").removeClass("bc-ff9803");
                    $("#themeDiv_00").removeClass("bc-fafafa");

                    $("#themeDiv0_00").removeClass("bc-ffffff");
                    $("#themeDiv0_00").addClass("bc-fafafa");
                } else {
                    $("#themeDiv_" + theme_index).removeClass("bc-ff9803");
                    $("#themeDiv0_" + theme_index).removeClass("bc-ffffff");
                    $("#themeDiv0_" + theme_index).addClass("bc-fafafa");
                }
                theme_index = index;
                $("#themeDiv_" + theme_index).addClass("bc-ff9803");
                $("#themeDiv0_" + theme_index).addClass("bc-ffffff");

                if (vm.searchText) {
                    vm.itemValueOne.productXmlLines = [];
                    vm.oldThemeList = [];
                    if (vm.itemValueOneCopy != null && vm.itemValueOneCopy.productXmlLines != null) {
                        var line = vm.itemValueOneCopy.productXmlLines;
                        for (var i = 0; i < line.length; i++) {
                            if(!line[i].notAvailable&&!line[i].cancelled&&line[i].paid){
                                var _ise = false;
                                line[i].themeClassifies.forEach(function (themeClassifie) {
                                    if (name == themeClassifie.name) {
                                        _ise = true;
                                    }
                                })
                                if (_ise) {
                                    vm.oldThemeList.push(line[i])
                                }
                            }
                        }
                    }
                    vm.itemValueOne.productXmlLines = vm.fuzzyQuery(vm.oldThemeList , vm.searchText)
                }else{
                    vm.itemValueOne.productXmlLines = [];
                    if (vm.itemValueOneCopy != null && vm.itemValueOneCopy.productXmlLines != null) {
                        var line = vm.itemValueOneCopy.productXmlLines;
                        for (var i = 0; i < line.length; i++) {
                            if(!line[i].notAvailable&&!line[i].cancelled&&line[i].paid){
                                var _ise = false;
                                line[i].themeClassifies.forEach(function (themeClassifie) {
                                    if (name == themeClassifie.name) {
                                        _ise = true;
                                    }
                                })
                                if (_ise) {
                                    vm.itemValueOne.productXmlLines.push(line[i]);
                                }
                            }
                        }
                        vm.itemValueOne.productXmlLines.sort(function(a, b){
                            return a.seq-b.seq;
                        })
                    }
                }
            }
        }

        function changeImgStyle(imgId) {
            var div0 = document.getElementById('div_' + imgId);
            console.log(div0.offsetHeight);
            if (div0.offsetHeight >= 150) {
                document.getElementById('div0_' + imgId).style.height = 201 + "px";
            } else if (div0.offsetHeight <= 105) {
                document.getElementById('div0_' + imgId).style.height = 150 + "px";
            } else {
                document.getElementById('div0_' + imgId).style.height = 191 + "px";
            }

            // 作无效返回
            return 0 + "px";
        }

        $scope.clearSearchText = function () {
            vm.searchText = '';
            vm.haveFocus = false;
            vm.search = false;
            vm.itemValueOne.productXmlLines = vm.oldThemeList
        }
        vm.oldThemeList = []
        $scope.searchMethodClick = function(){
            if (!vm.searchText) {
                return
            }
            vm.oldThemeList = vm.itemValueOne.productXmlLines
            vm.itemValueOne.productXmlLines = vm.fuzzyQuery(vm.itemValueOne.productXmlLines , vm.searchText)
        }
        vm.fuzzyQuery = function(list, keyWord) {
            if (keyWord != "") {
                var reg = new RegExp(keyWord);
                var arr = [];
                for (var i = 0; i < list.length; i++) {
                    if (reg.test(list[i].name)) {
                        arr.push(list[i])
                    }
                }
                return arr;
            } else {
                return;
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('editorApp')
        .controller('PreviewController', PreviewController);

    PreviewController.$inject = ['$state', 'AuthServerProvider', '$stateParams', '$localStorage','Article','OrderArticle'];

    function PreviewController($state, AuthServerProvider, $stateParams, $localStorage, Article,OrderArticle) {
        var vm = this;
        $(".navbar").hide();
        $(".wrap").show().addClass('no-margins').css({height: '100vh', background: '#fff'});
        // {storeId}/{pid}/{vid}/{aid}
        var storeId = $stateParams.storeId;
        var pid = $stateParams.pid;
        var vid = $stateParams.vid;
        var aid = $stateParams.aid;
        var orderArticleId = $stateParams.orderArticleId;
        $localStorage.article = {id:aid};
        if($stateParams.authorization){
            $localStorage.authenticationToken = $stateParams.authorization;
        }

        //对escape()编码的字符串进行解码
        function getQueryString(name) {
            var reg = new RegExp("(^|)" + name + "=([^&]*)(&|$)", "i");
            var r = window.location.href.match(reg);
            if (r != null) {
                return window.decodeURIComponent(r[2]);
            }
            return null;//如果此处只写return;则返回的是undefined
        };
        var str = getQueryString("returnurl");
        var str1 = getQueryString("returnurl1");
        var str2 = getQueryString("returnurl2");
        var saveUserName = getQueryString("saveUserName");
        var returnurl2Text = getQueryString("returnurl2Text");
        var source = getQueryString("source");
        if(str){
            localStorage.setItem('returnurl', str);
        }else {
            localStorage.removeItem('returnurl')
        }
        if(str1){
            localStorage.setItem('returnurl1', str1);
        }else {
            localStorage.removeItem('returnurl1')
        }
        if(str2){
            localStorage.setItem('returnurl2', str2);
        }else {
            localStorage.removeItem('returnurl2')
        }
        if(saveUserName){
            localStorage.setItem('saveUserName', saveUserName);
        }else {
            localStorage.removeItem('saveUserName')
        }
        if(returnurl2Text){
            localStorage.setItem('returnurl2Text', returnurl2Text);
        }else {
            localStorage.removeItem('returnurl2Text')
        }
        if(source){
            localStorage.setItem('source', source);
        }else {
            localStorage.removeItem('source')
        }

        var pathNames = window.location.pathname.split("/");
        var lastName = pathNames[pathNames.length - 1];
        console.log(lastName)
        // var screenW = document.body.clientWidth;
        function isMobile(){
            var ua = window.navigator.userAgent;
            var isWeChat = ua.match(/MicroMessenger/i);
            if(isWeChat){
                // 检测是否为 PC 微信小程序环境（PC 小程序特有标识）
                if (/MiniProgramEnv\/Windows|MiniProgramEnv\/Mac/i.test(ua)) {
                     return true; // 这就是PC 小程序 WebView
                 }
                 // PC微信内置浏览器（打开普通链接）
                 if (/WindowsWechat|MacWechat/i.test(ua)) {
                     return false;
                 }
                 // 手机端微信
                 return true;
             }
            if(ua.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone|HarmonyOS|Harmony)/i)) {
                return true;
            }else{
                return false;
            }
        }
        var isMobile = isMobile();
        if ($stateParams.auth) {
            AuthServerProvider.storeAuthenticationToken($stateParams.auth, true);
            init();
        }
        else if ($stateParams.ticket) {
            getToken($stateParams.ticket, function(token) {
                if (token) {
                    AuthServerProvider.storeAuthenticationToken(token, true);
                    init();
                } else {
                    // illegal
                    console.error("Cannot open article with failure of getToken");
                }
            });
        } else {
            init();
            // illegal
            console.error("Cannot open article with nothing ticket or auth");
        }

        function getToken(ticket, callback) {
            Article.getToken({ticket: ticket}, function (res) {
                if (res.status == 200) {
                    var token = res.data;
                    if (token && callback) {
                        callback(token);
                    } else {
                        console.log("Invalid token or callback, token=" + token);
                    }
                } else {
                    console.log("Error to getToken with ticket: " + ticket + ", article=" + aid);
                }
            });
        }

        function init() {
            if(orderArticleId){
                if (!isMobile) {
                    $state.go("page-view2", {storeId: storeId, orderArticleId: orderArticleId},{location: 'replace'});
                } else {
                    console.log(orderArticleId)
                    OrderArticle.get({id: orderArticleId},function(res){
                        var data = res.data;
                        document.title = data.productName;
                        if (data.editorType == "PICTURE" || data.editorType == "PICTURE_PRO" || data.editorType == "PICTURE_PRO_P") {
                            $state.go('editorPhotoPreview1', {storeId: storeId, orderArticleId: orderArticleId},{location: 'replace'})
                        }
                        else if(data.editorType=='BOOK_JUNIOR'||data.editorType=='BOOK_SENIOR' || data.editorType=='NEW_EDITOR' || data.editorType=='CALENDAR_EDITOR') {
                            $state.go('product-view-ec-1', {storeId: storeId, orderArticleId: orderArticleId},{location: 'replace'})
                        }else{
                            $state.go("product-view5-ec-1", {storeId: storeId, orderArticleId: orderArticleId},{location: 'replace'});
                        }
                    })
                }
            }
            if(aid){
                Article.get({id: aid},function (res) {
                    var data = res.data;
                    document.title = data.productName;
                    if(res.data.invalid){//作品失效
                        $state.go('articlesFailure',{storeId:storeId},{location: 'replace'});
                        return
                    }
                    if (!isMobile) {
                        //预览
                        if (lastName == 'articlePreview' || !lastName) {
                            $state.go("page-view", {storeId: storeId, aid: aid},{location: 'replace'});
                        } else {
                            $state.go("page-view", {storeId: storeId, aid: aid},{location: 'replace'});
                            // $state.go("page-view2", {storeId: storeId, orderArticleId: aid});
                        }
                    } else {
                        if (lastName == 'articlePreview') {
                            if (data.editorType == "PICTURE" || data.editorType == "PICTURE_PRO" || data.editorType == "PICTURE_PRO_P") {
                                $state.go('editorPhotoPreviewShare', {storeId: storeId, aid: aid},{location: 'replace'})
                                return
                            }
                            if(data.editorType=='BOOK_JUNIOR'||data.editorType=='BOOK_SENIOR' || data.editorType=='NEW_EDITOR' || data.editorType=='CALENDAR_EDITOR') {
                                $state.go('product-view-ec', {storeId: storeId, aid: aid},{location: 'replace'});   // 小程序/H5 作品预览
                            }else{
                                $state.go("product-view5-ec", {storeId: storeId, aid: aid},{location: 'replace'});
                            }
                        } else {
                            // lastName == 'articleShare'
                            if (data.editorType == "PICTURE" || data.editorType == "PICTURE_PRO" || data.editorType == "PICTURE_PRO_P") {
                                $state.go('editorPhotoPreviewShare', {storeId: storeId, aid: aid},{location: 'replace'})
                                return
                            }
                            if(data.editorType=='BOOK_JUNIOR'||data.editorType=='BOOK_SENIOR' || data.editorType=='NEW_EDITOR' || data.editorType=='CALENDAR_EDITOR') {
                                $state.go("product-view2-ec", {storeId: storeId, aid: aid, viewIndex: 0},{location: 'replace'});  // 小程序/H5 作品分享的预览
                            }else{
                                $state.go("product-view5-ec", {storeId: storeId, aid: aid},{location: 'replace'});
                            }
                        }
                    }
                })
            }
        }

        // var screenH = document.body.clientHeight;

    }
})();

(function () {
    'use strict';

    angular
        .module('editorApp')
        .controller('CodeModalController', CodeModalController);

    CodeModalController.$inject = ['$scope', '$state', 'MessageService', '$location', '$uibModalInstance', 'entity', 'Md5'];

    function CodeModalController($scope, $state, MessageService, $location, $uibModalInstance, entity, Md5) {
        var vm = this;
        var code = entity;

        $scope.modalSave = function () {
            if(!vm.code){
                MessageService.error("请输入秘钥");
                return
            }
            var _code = Md5.hex_md5(angular.copy(vm.code));
            console.log(_code)
            if(_code != code){
                MessageService.error("请输入正确的秘钥");
                return
            }
            MessageService.success("秘钥解密成功");
            $uibModalInstance.close(true);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('editorApp')
        .controller('ProductThreeEcController', ProductThreeEcController);

    ProductThreeEcController.$inject = ['$state', '$scope', '$q', '$stateParams', 'Convert', 'Qinius', 'QiniuToken', 'WxJS', 'Gallery', 'ItemValue', 'SweetAlert', 'Theme', '$localStorage', '$timeout', 'FontManagement', '$rootScope'
        , 'ImageService', 'ClipArt', 'PlatformWechatSetting', 'UidService', 'Store', 'Article', 'CommonService', '$http', 'Folder',
        'MessageNotification', 'ThemeClassify', 'entity', 'Product', 'ProductXml', 'DateUtils', 'Iphone','DiyEditorSetting',
        'ListService', 'StoreWorkEditConfig','$translate','IMAGE_SUPPORTED_MIME','MessageService','StoreStorages', '$websocket'];

    function ProductThreeEcController($state, $scope, $q, $stateParams, Convert, Qinius, QiniuToken, WxJS, Gallery, ItemValue, SweetAlert, Theme, $localStorage, $timeout, FontManagement, $rootScope
        , ImageService, ClipArt, PlatformWechatSetting, UidService, Store, Article, CommonService, $http, Folder,
          MessageNotification, ThemeClassify, entity, Product, ProductXml, DateUtils, Iphone, DiyEditorSetting,
          ListService, StoreWorkEditConfig,$translate,IMAGE_SUPPORTED_MIME,MessageService,StoreStorages, $websocket) {
        //初始化
        // $localStorage.authenticationToken = "eyJhbGciOiJIUzUxMiJ9.eyJzdG9yZSI6MTAsInNlcnZpY2UiOiJlY29tbWVyY2UiLCJzdG9yZV9hY3RpdmF0ZWQiOnRydWUsInN0b3JlX3BlcmlvZCI6eyJuYW5vIjo5MTYwMDAwMDAsImVwb2NoU2Vjb25kIjoxNzIwNzQ5Nzc5fSwic3ViIjoiMTIzMDcxMTA2MzA0ODk3MSJ9.rvo6GhnY5CV4nbZgByggqqiGI52jqeIgI14vJTr2Noz2tztYdVc2AttbfeqsypIRZe-b69ibJoCjEqA6RHpI0Q";
        // $localStorage.lagnuages = ['zh-cn', 'en'];
        $(".navbar-gallery").hide();
        $(".wrap").show().addClass('no-margins');
        $(".well").css({'margin-bottom': 0});
        $scope.dWidth = document.documentElement.clientWidth;
        $("body").css({width: $scope.dWidth, 'min-width': $scope.dWidth});
        var vm = this;
        vm.isEdit = entity.type == 'edit' ? true : false;
        var variableDatas = JSON.parse(localStorage.getItem('variableData'));
        vm.storeId = $stateParams.storeId;
        vm.pid = $stateParams.pid;
        vm.aid = $stateParams.aid;
        vm.vid = $stateParams.vid;
        vm.xmlId = $stateParams.xmlId;
        vm.salesOrderId = $stateParams.soid ? $stateParams.soid : null;
        vm.productLineId = $stateParams.plid ? $stateParams.plid : null;
        vm.counts = 0;
        vm.selectImg = [];
        vm.indexNum = 0;
        vm.itemsPerPage = 20;
        vm.photoAll = [];
        vm.duplicateList = []; //重复图片
        vm.isDuplicateList = false; //重复图片弹框
        vm.deletePhotoSure = false; //删除处理失败照片确认框
        vm.pendingDeletePhoto = null; //待删除的处理失败照片
        vm.supportedMimeTypes = IMAGE_SUPPORTED_MIME;
        $scope.domains = Qinius.getDomain();

        $scope.agentIos = false;
        var unsubQiniuToken = QiniuToken.subscribe('get', {}, function (token) {
            vm.token = token;
        });
        $scope.$on('$destroy', unsubQiniuToken);
        vm.platformSetting = PlatformWechatSetting.get();
        vm.isIPhone6 = isIPhone6();
        vm.photoArray = [];
        vm.photoSelectAll = JSON.parse(localStorage.getItem("photoSelectAll")) || [];
        vm.isPhone = false;
        vm.threeIsModal = false;
        vm.threeModalText = "";
        vm.threeLoading = false;
        vm.threeLoadingText=$translate.instant("hint.loadingText");
        vm.threeError = false;
        vm.threeErrorText=$translate.instant("hint.loadingText");

        diyEditorSettingConstInit();
        function diyEditorSettingConstInit(){
            vm.diyEditorSetting = {
                templateShow: true,//模板
                templateIcon: 'https://resources.momentsgocdn.com/gallery-5ae458bb-3254-4b9b-93dc-9caa0838a3ab',
                templateText:$translate.instant("editorBtn.templateText"),
                templateColor:'#333',
                clipartShow: true,//素材
                clipartIcon: 'https://resources.momentsgocdn.com/gallery-9fe28d31-ce19-4a77-bda9-c0e48b55059d',
                clipartText:$translate.instant("editorBtn.clipartText"),
                clipartColor:'#333',
                wordShow: true,//文字
                wordIcon: 'https://resources.momentsgocdn.com/gallery-9cf32f4b-46f2-4679-d454-55b11d66f8ba',
                wordText:$translate.instant("editorBtn.wordText"),
                wordColor:'#333',
                imgShow: true,//图片
                imgIcon: 'https://resources.momentsgocdn.com/gallery-09babd73-2e43-4c06-c4d6-f181f313d7c2',
                imgText:$translate.instant("editorBtn.imgText"),
                imgColor:'#333',
                photoShow: true,//图片框
                photoIcon: 'https://resources.momentsgocdn.com/v2/qn-photoshape.png',
                photoText:$translate.instant("editorBtn.photoText"),
                photoColor:'#333',
                graffitiShow: true,//涂鸦
                graffitiIcon: 'https://resources.momentsgocdn.com/v2/qn-photoshape.png',
                graffitiText:$translate.instant("editorBtn.graffiti"),
                graffitiColor:'#333',
                changeImgSelf: true,//换图
                changeImgIcon: 'https://resources.momentsgocdn.com/gallery-4d1f90d1-6c58-430d-abbb-2582c5eb24af',
                changeImgText:$translate.instant("editorBtn.changeImgText"),
                changeImgColor:'#000',
                filterShow: true,//滤镜显示
                filterIcon: 'https://resources.momentsgocdn.com/gallery-1b8c1b12-bbe1-47da-f73c-b42b5b1c8aaa',
                filterText:$translate.instant("editorBtn.filterText"),
                filterColor:'#000',
                rotationSelf: true,//旋转
                rotationIcon: 'https://resources.momentsgocdn.com/gallery-22f21c70-d5dc-4530-d00c-47fc34e4fb4d',
                rotationText:$translate.instant("editorBtn.rotationText"),
                rotationColor:'#000',
                upSelf: true,//放大
                upIcon: 'https://resources.momentsgocdn.com/gallery-584d87d7-c25a-46c3-cdc9-120d3e2f65d2',
                upText:$translate.instant("editorBtn.upText"),
                upColor:'#000',
                downSelf: true,//缩小
                downIcon: 'https://resources.momentsgocdn.com/gallery-8834bf87-10ca-4922-a5ea-3e9bde06f555',
                downText:$translate.instant("editorBtn.downText"),
                downColor:'#000',
                flipSelf: true,//翻转
                flipIcon: 'https://resources.momentsgocdn.com/gallery-7c05fe8d-31c8-4fae-8b31-9250e777d75e',
                flipText:$translate.instant("editorBtn.flipText"),
                flipColor:'#000',
                restoreSelf: true,//还原
                restoreIcon: 'https://resources.momentsgocdn.com/gallery-a1fd5b5d-ccd9-488f-8951-2753c6a1aa4c',
                restoreText:$translate.instant("editorBtn.restoreText"),
                restoreColor:'#000',
                spreadSelf: true,//展开
                spreadIcon: 'https://resources.momentsgocdn.com/gallery-584d87d7-c25a-46c3-cdc9-120d3e2f65d2',
                spreadText:$translate.instant("editorBtn.spreadText"),
                spreadColor:'#000',
                retractSelf: true,//缩回
                retractIcon: 'https://resources.momentsgocdn.com/gallery-8834bf87-10ca-4922-a5ea-3e9bde06f555',
                retractText:$translate.instant("editorBtn.retractText"),
                retractColor:'#000',
                editWordIconSelf: true,//编辑文字
                editWordIcon: 'https://resources.momentsgocdn.com/gallery-5e70fa05-5a5d-4e9d-ab4f-1699c6877940',
                editWordText:$translate.instant("editorBtn.editWordText"),
                editWordColor:'#0a0a0a',
                wordStyleIconSelf: true,//文字样式
                wordStyleIcon: 'https://resources.momentsgocdn.com/gallery-581f0375-e252-4c0f-ee79-ef69e4dfb1f9',
                wordStyleText:$translate.instant("editorBtn.wordStyleText"),
                wordStyleColor:'#0a0a0a',
                delWordIconSelf: true,//删除文字
                delWordIcon: 'https://resources.momentsgocdn.com/gallery-5072c751-ca0a-4b20-be05-bd61e8910176',
                delWordText:$translate.instant("editorBtn.delWordText"),
                delWordColor:'#0a0a0a',
                upButtonSelf: true, //放大按钮
                upButtonIcon: 'https://resources.momentsgocdn.com/gallery-7c6b81c0-5515-4b6e-994c-0d2da6e4606a',
                downButtonSelf: true, //缩小按钮
                downButtonIcon: 'https://resources.momentsgocdn.com/gallery-fde0cdea-8c55-41e7-fcc1-819c97b9739e',
                mainColor: 'var(--genericColor)', //主色调
                templateSeq: 1,
                clipartSeq: 2,
                wordSeq: 3,
                imgSeq: 4,
                photoSeq: 5,
                graffitiSeq: 6,
            };
        }

        //阻止微信端长按赋值保存图片
        document.oncontextmenu = function (e) {
            //或者return false;
            e.preventDefault();
        };

        init();

        var productId = null;
        function init() {
            if (!vm.isEdit) {
                getProduct(vm.pid,function () {
                    Article.getByUser({id: $stateParams.aid}, function (article) {
                        if (article.status == 200) {
                            vm.article = article.data;
                            document.title = vm.article.productName;
                            if(vm.article.invalid){//作品失效
                                $state.go('articlesFailure',{storeId:vm.storeId},{location: 'replace'});
                                return
                            }
                            ItemValue.get({id: $stateParams.vid}, function (res) {
                                $("body").toggleClass('bg');
                                $scope.status = localStorage.getItem('Production');
                                vm.productXmlLine = res.data.productXmlLines[0];
                                angular.forEach(res.data.productXmlLines, function (line) {
                                    if (line.id == vm.xmlId) {
                                        vm.productXmlLine = angular.copy(line);
                                    }
                                });
                                vm.article.modelBlendentUuid = vm.productXmlLine.modelBlendentUuid;
                                vm.article.cover = vm.productXmlLine.coverImg;
                                vm.article.themeClassifyId = vm.productXmlLine.productXmlThemeId;
                                vm.article.themeClassifyName = vm.productXmlLine.productXmlThemeName;
                                vm.article.productXmlId = vm.productXmlLine.productXmlId;
                                vm.article.productXmlName = vm.productXmlLine.productXmlName;
                                vm.article.musicIdentify = vm.productXmlLine.musicIdentify;
                                vm.article.itemValueId = res.data.id || vm.vid;
                                if (!res.data.productBokehType) {
                                    vm.article.bokehtype = 'None';
                                } else {
                                    vm.article.bokehtype = res.data.productBokehType;
                                }

                                var result = ListService.inList(vm.article, variableDatas, ["productXmlId"]);
                                if(result&&result.data&&result.data.length){
                                    angular.forEach(result.data,function (va,i) {
                                        if(va.type=='text'){
                                            vm.variableTextDatas.push(va)
                                        }
                                        if(va.type=='box'){
                                            vm.variableBoxDatas.push(va)
                                        }
                                    })
                                }
                                Convert.xmlToDocument2({
                                    identifier: vm.productXmlLine ? vm.productXmlLine.productXmlIdentifier : res.data.productXmlIdentifier,
                                    provider: "qiniu",
                                    editorType:vm.article.editorType,
                                    patternType:vm.product.patternType,
                                }, function (res) {
                                    vm.counts = 0;
                                    $scope.pages = res;
                                    productId = vm.pid;
                                    angular.forEach(res.pages.page, function (page, i) {
                                        angular.forEach(page.levels.level, function (level) {
                                            if (level.imagebox && level.imagebox.geometry) {
                                                vm.counts++;
                                            }
                                        })
                                    });
                                    abook();
                                });
                            });
                        }
                    })
                },function (error) {
                    if(error.status === 403){//token失效
                        return $state.go('404',{storeId:vm.storeId},{location: 'replace'});
                    }
                    if(error.data.status === 404){//未找到作品
                        $state.go('404',{storeId:vm.storeId,tips:error.data.message},{location: 'replace'});
                    }
                    if(error.data.status === 410){//作品编辑器失效
                        $state.go('404',{storeId:vm.storeId,tips:'编辑器失效'},{location: 'replace'});
                    }
                })
            } else {
                Article.getByUser({id: $stateParams.aid}, function (res) {
                    vm.article = res.data;
                    document.title = vm.article.productName;
                    if(vm.article.invalid){//作品失效
                        $state.go('articlesFailure',{storeId:vm.storeId},{location: 'replace'});
                        return
                    }
                    productId = res.data.productId;
                    getProduct(productId,function () {
                        ItemValue.get({id: res.data.itemValueId}, function (resp) {
                            if(resp.status == 200){
                                vm.article.skuNumber = resp.data.skuNumber;
                                vm.article.productBokeh = resp.data.productBokeh;
                                vm.article.productBokehType = resp.data.productBokehType;
                                if (!resp.data.productBokehType) {
                                    vm.article.bokehtype = 'None';
                                } else {
                                    vm.article.bokehtype = resp.data.productBokehType;
                                }
                                angular.forEach(resp.data.productXmlLines, function (line) {
                                    if (line.productXmlId == vm.article.productXmlId) {
                                        vm.productXmlLine = angular.copy(line);
                                    }
                                });
                                Convert.xmlToDocument2({
                                    identifier: vm.article.fileName,
                                    provider: 'qiniu',
                                    editorType:vm.article.editorType,
                                    patternType:vm.product.patternType,
                                }, function (res) {
                                    vm.article.document = res;
                                    angular.forEach(vm.article.document.pages.page, function (page, i) {
                                        angular.forEach(page.levels.level, function (level) {
                                            if (level.imagebox && level.imagebox.geometry) {
                                                vm.counts++;
                                            }
                                        })
                                    });
                                    abook();
                                });
                            }else {
                                MessageService.error(res.message);
                            }
                        });
                    })
                },function(error){
                    if(error.status === 403){//token失效
                        return $state.go('404',{storeId:vm.storeId},{location: 'replace'});
                    }
                    if(error.data.status === 404){//未找到作品
                        $state.go('404',{storeId:vm.storeId,tips:error.data.message},{location: 'replace'});
                    }
                    if(error.data.status === 410){//作品编辑器失效
                        $state.go('404',{storeId:vm.storeId,tips:'编辑器失效'},{location: 'replace'});
                    }
                })
            }
            vm.page4 = true;
            vm.page5 = false;

            $scope.qiniuId = localStorage.getItem("gallery") ? JSON.parse(localStorage.getItem("gallery")) : [];
        }


        vm.fontList = [];
        function getProduct(productId,callback) {
            Product.get({id: productId, cancelled: false}, function (res) {
                vm.product = res.data;
                if(vm.product.editorType == 'DIY_EDITOR'){
                    if(vm.product.diyEditorSettingId){
                        getDiyEditorSetting();
                    }else{
                        //获取所有字体
                        getAllFont();
                        diyEditorSettingInit()
                    }
                }else{
                    //获取所有字体
                    getAllFont();
                    diyEditorSettingInit()
                }
                if(callback){callback()}
            })
        }

        function getDiyEditorSetting(){
            DiyEditorSetting.get({id: vm.product.diyEditorSettingId}, function (res) {
                vm.diyEditorSetting = res.data ? res.data : vm.diyEditorSetting;
                if(vm.diyEditorSetting.templateSelf){
                    vm.diyEditorSetting.templateIcon = vm.diyEditorSetting.templateIcon || 'https://resources.momentsgocdn.com/gallery-5ae458bb-3254-4b9b-93dc-9caa0838a3ab';
                }else{
                    vm.diyEditorSetting.templateIcon = 'https://resources.momentsgocdn.com/gallery-5ae458bb-3254-4b9b-93dc-9caa0838a3ab';
                }
                vm.diyEditorSetting.templateText = vm.diyEditorSetting.templateText || $translate.instant("editorBtn.templateText");
                vm.diyEditorSetting.templateColor = vm.diyEditorSetting.templateColor || '#333';

                if(vm.diyEditorSetting.clipartSelf){
                    vm.diyEditorSetting.clipartIcon = vm.diyEditorSetting.clipartIcon || 'https://resources.momentsgocdn.com/gallery-9fe28d31-ce19-4a77-bda9-c0e48b55059d';
                }else{
                    vm.diyEditorSetting.clipartIcon = 'https://resources.momentsgocdn.com/gallery-9fe28d31-ce19-4a77-bda9-c0e48b55059d';
                }
                vm.diyEditorSetting.clipartText = vm.diyEditorSetting.clipartText || $translate.instant("editorBtn.clipartText");
                vm.diyEditorSetting.clipartColor = vm.diyEditorSetting.clipartColor || '#333';
                if(vm.diyEditorSetting.wordIconSelf){
                    vm.diyEditorSetting.wordIcon = vm.diyEditorSetting.wordIcon || 'https://resources.momentsgocdn.com/gallery-9cf32f4b-46f2-4679-d454-55b11d66f8ba';
                }else{
                    vm.diyEditorSetting.wordIcon = 'https://resources.momentsgocdn.com/gallery-9cf32f4b-46f2-4679-d454-55b11d66f8ba';
                }
                vm.diyEditorSetting.wordText = vm.diyEditorSetting.wordText || $translate.instant("editorBtn.wordText");
                vm.diyEditorSetting.wordColor = vm.diyEditorSetting.wordColor || '#333';

                if(vm.diyEditorSetting.imgSelf){
                    vm.diyEditorSetting.imgIcon = vm.diyEditorSetting.imgIcon || 'https://resources.momentsgocdn.com/gallery-09babd73-2e43-4c06-c4d6-f181f313d7c2';
                }else{
                    vm.diyEditorSetting.imgIcon = 'https://resources.momentsgocdn.com/gallery-09babd73-2e43-4c06-c4d6-f181f313d7c2';
                }
                vm.diyEditorSetting.imgText = vm.diyEditorSetting.imgText || $translate.instant("editorBtn.imgText");
                vm.diyEditorSetting.imgColor = vm.diyEditorSetting.imgColor || '#333';

                if(vm.diyEditorSetting.changeImgSelf){
                    vm.diyEditorSetting.changeImgIcon = vm.diyEditorSetting.changeImgIcon || 'https://resources.momentsgocdn.com/gallery-4d1f90d1-6c58-430d-abbb-2582c5eb24af';
                }else{
                    vm.diyEditorSetting.changeImgIcon = 'https://resources.momentsgocdn.com/gallery-4d1f90d1-6c58-430d-abbb-2582c5eb24af';
                }
                vm.diyEditorSetting.changeImgText = vm.diyEditorSetting.changeImgText || $translate.instant("editorBtn.changeImgText");
                vm.diyEditorSetting.changeImgColor = vm.diyEditorSetting.changeImgColor || '#000';

                if(vm.diyEditorSetting.filterSelf){
                    vm.diyEditorSetting.filterIcon = vm.diyEditorSetting.filterIcon || 'https://resources.momentsgocdn.com/gallery-1b8c1b12-bbe1-47da-f73c-b42b5b1c8aaa';
                }else{
                    vm.diyEditorSetting.filterIcon = 'https://resources.momentsgocdn.com/gallery-1b8c1b12-bbe1-47da-f73c-b42b5b1c8aaa';
                }
                vm.diyEditorSetting.filterText = vm.diyEditorSetting.filterText || $translate.instant("editorBtn.filterText");
                vm.diyEditorSetting.filterColor = vm.diyEditorSetting.filterColor || '#000';

                if(vm.diyEditorSetting.rotationSelf){
                    vm.diyEditorSetting.rotationIcon = vm.diyEditorSetting.rotationIcon || 'https://resources.momentsgocdn.com/gallery-22f21c70-d5dc-4530-d00c-47fc34e4fb4d';
                }else{
                    vm.diyEditorSetting.rotationIcon = 'https://resources.momentsgocdn.com/gallery-22f21c70-d5dc-4530-d00c-47fc34e4fb4d';
                }
                vm.diyEditorSetting.rotationText = vm.diyEditorSetting.rotationText || $translate.instant("editorBtn.rotationText");
                vm.diyEditorSetting.rotationColor = vm.diyEditorSetting.rotationColor || '#000';

                if(vm.diyEditorSetting.upSelf){
                    vm.diyEditorSetting.upIcon = vm.diyEditorSetting.upIcon || 'https://resources.momentsgocdn.com/gallery-584d87d7-c25a-46c3-cdc9-120d3e2f65d2';
                }else{
                    vm.diyEditorSetting.upIcon = 'https://resources.momentsgocdn.com/gallery-584d87d7-c25a-46c3-cdc9-120d3e2f65d2';
                }
                vm.diyEditorSetting.upText = vm.diyEditorSetting.upText || $translate.instant("editorBtn.upText");
                vm.diyEditorSetting.upColor = vm.diyEditorSetting.upColor || '#000';

                if(vm.diyEditorSetting.downSelf){
                    vm.diyEditorSetting.downIcon = vm.diyEditorSetting.downIcon || 'https://resources.momentsgocdn.com/gallery-8834bf87-10ca-4922-a5ea-3e9bde06f555';
                }else{
                    vm.diyEditorSetting.downIcon = 'https://resources.momentsgocdn.com/gallery-8834bf87-10ca-4922-a5ea-3e9bde06f555';
                }
                vm.diyEditorSetting.downText = vm.diyEditorSetting.downText || $translate.instant("editorBtn.downText");
                vm.diyEditorSetting.downColor = vm.diyEditorSetting.downColor || '#000';

                if(vm.diyEditorSetting.flipSelf){
                    vm.diyEditorSetting.flipIcon = vm.diyEditorSetting.flipIcon || 'https://resources.momentsgocdn.com/gallery-7c05fe8d-31c8-4fae-8b31-9250e777d75e';
                }else{
                    vm.diyEditorSetting.flipIcon = 'https://resources.momentsgocdn.com/gallery-7c05fe8d-31c8-4fae-8b31-9250e777d75e';
                }
                vm.diyEditorSetting.flipText = vm.diyEditorSetting.flipText || $translate.instant("editorBtn.flipText");
                vm.diyEditorSetting.flipColor = vm.diyEditorSetting.flipColor || '#000';

                if(vm.diyEditorSetting.restoreSelf){
                    vm.diyEditorSetting.restoreIcon = vm.diyEditorSetting.restoreIcon || 'https://resources.momentsgocdn.com/gallery-a1fd5b5d-ccd9-488f-8951-2753c6a1aa4c';
                }else{
                    vm.diyEditorSetting.restoreIcon = 'https://resources.momentsgocdn.com/gallery-a1fd5b5d-ccd9-488f-8951-2753c6a1aa4c';
                }
                vm.diyEditorSetting.restoreText = vm.diyEditorSetting.restoreText || $translate.instant("editorBtn.restoreText");
                vm.diyEditorSetting.restoreColor = vm.diyEditorSetting.restoreColor || '#000';

                if(vm.diyEditorSetting.spreadSelf){
                    vm.diyEditorSetting.spreadIcon = vm.diyEditorSetting.spreadIcon || 'https://resources.momentsgocdn.com/gallery-584d87d7-c25a-46c3-cdc9-120d3e2f65d2';
                }else{
                    vm.diyEditorSetting.spreadIcon = 'https://resources.momentsgocdn.com/gallery-584d87d7-c25a-46c3-cdc9-120d3e2f65d2';
                }
                vm.diyEditorSetting.spreadText = vm.diyEditorSetting.spreadText || $translate.instant("editorBtn.spreadText");
                vm.diyEditorSetting.spreadColor = vm.diyEditorSetting.spreadColor || '#000';

                if(vm.diyEditorSetting.retractSelf){
                    vm.diyEditorSetting.retractIcon = vm.diyEditorSetting.retractIcon || 'https://resources.momentsgocdn.com/gallery-8834bf87-10ca-4922-a5ea-3e9bde06f555';
                }else{
                    vm.diyEditorSetting.retractIcon = 'https://resources.momentsgocdn.com/gallery-8834bf87-10ca-4922-a5ea-3e9bde06f555';
                }
                vm.diyEditorSetting.retractText = vm.diyEditorSetting.retractText || $translate.instant("editorBtn.retractText");
                vm.diyEditorSetting.retractColor = vm.diyEditorSetting.retractColor || '#000';

                if(vm.diyEditorSetting.editWordIconSelf){
                    vm.diyEditorSetting.editWordIcon = vm.diyEditorSetting.editWordIcon || 'https://resources.momentsgocdn.com/gallery-5e70fa05-5a5d-4e9d-ab4f-1699c6877940';
                }else{
                    vm.diyEditorSetting.editWordIcon = 'https://resources.momentsgocdn.com/gallery-5e70fa05-5a5d-4e9d-ab4f-1699c6877940';
                }
                vm.diyEditorSetting.editWordText = vm.diyEditorSetting.editWordText || $translate.instant("editorBtn.editWordText");
                vm.diyEditorSetting.editWordColor = vm.diyEditorSetting.editWordColor || '#0a0a0a';

                if(vm.diyEditorSetting.wordStyleIconSelf){
                    vm.diyEditorSetting.wordStyleIcon = vm.diyEditorSetting.wordStyleIcon || 'https://resources.momentsgocdn.com/gallery-581f0375-e252-4c0f-ee79-ef69e4dfb1f9';
                }else{
                    vm.diyEditorSetting.wordStyleIcon = 'https://resources.momentsgocdn.com/gallery-581f0375-e252-4c0f-ee79-ef69e4dfb1f9';
                }
                vm.diyEditorSetting.wordStyleText = vm.diyEditorSetting.wordStyleText || $translate.instant("editorBtn.wordStyleText");
                vm.diyEditorSetting.wordStyleColor = vm.diyEditorSetting.wordStyleColor || '#0a0a0a';

                if(vm.diyEditorSetting.delWordIconSelf){
                    vm.diyEditorSetting.delWordIcon = vm.diyEditorSetting.delWordIcon || 'https://resources.momentsgocdn.com/gallery-5072c751-ca0a-4b20-be05-bd61e8910176';
                }else{
                    vm.diyEditorSetting.delWordIcon = 'https://resources.momentsgocdn.com/gallery-5072c751-ca0a-4b20-be05-bd61e8910176';
                }
                vm.diyEditorSetting.delWordText = vm.diyEditorSetting.delWordText || $translate.instant("editorBtn.delWordText");
                vm.diyEditorSetting.delWordColor = vm.diyEditorSetting.delWordColor || '#0a0a0a';

                vm.diyEditorSetting.upButtonIcon = vm.diyEditorSetting.upButtonIcon || 'https://resources.momentsgocdn.com/gallery-7c6b81c0-5515-4b6e-994c-0d2da6e4606a';

                vm.diyEditorSetting.downButtonIcon = vm.diyEditorSetting.downButtonIcon || 'https://resources.momentsgocdn.com/gallery-fde0cdea-8c55-41e7-fcc1-819c97b9739e';
                vm.diyEditorSetting.mainColor = vm.diyEditorSetting.mainColor || 'var(--genericColor)';
                if(vm.diyEditorSetting.wordIconSelf){
                    if(vm.diyEditorSetting.fontSupportSelf){
                        vm.diyEditorSetting.supportFonts.forEach(function (supportFont) {
                            vm.fontList.push(supportFont.fontManagement)
                        })
                    }else{
                        //获取所有字体
                        getAllFont();
                    }
                    if(vm.diyEditorSetting.fontColorSupportSelf){
                        $scope.colorList = [];
                        vm.diyEditorSetting.supportFontColors.forEach(function (supportFontColor) {
                            $scope.colorList.push(supportFontColor.color)
                        })
                    }
                }else{
                    //获取所有字体
                    getAllFont();
                }
                diyEditorSettingInit()
            })
        }

        function diyEditorSettingInit(){
            if(vm.diyEditorSetting){
                vm.diyEditorSetting.seqItem=[];
                if(vm.diyEditorSetting.wordShow){
                    vm.diyEditorSetting.seqItem.push({
                        type:'word',
                        seq: vm.diyEditorSetting.wordSeq
                    })
                }
                if(vm.diyEditorSetting.templateShow){
                    vm.diyEditorSetting.seqItem.push({
                        type:'template',
                        seq: vm.diyEditorSetting.templateSeq
                    })
                }
                if(vm.diyEditorSetting.clipartShow){
                    vm.diyEditorSetting.seqItem.push({
                        type:'clipart',
                        seq: vm.diyEditorSetting.clipartSeq
                    })
                }
                if(vm.diyEditorSetting.imgShow){
                    vm.diyEditorSetting.seqItem.push({
                        type:'img',
                        seq: vm.diyEditorSetting.imgSeq
                    })
                }
                if(vm.diyEditorSetting.graffitiShow){
                    vm.diyEditorSetting.seqItem.push({
                        type:'graffiti',
                        seq: vm.diyEditorSetting.graffitiSeq
                    })
                }
                if(vm.diyEditorSetting.photoShow){
                    vm.diyEditorSetting.seqItem.push({
                        type:'photo',
                        seq: vm.diyEditorSetting.photoSeq
                    })
                }
                vm.diyEditorSetting.seqItem = vm.diyEditorSetting.seqItem.sort(sortItem("seq"));
            }
        }

        $q.all([$scope.domains.$promise,vm.platformSetting.$promise]).then(function () {
            $scope.domain = 'https://' + $scope.domains.domains[0] + '/';
            vm.platformSetting = vm.platformSetting.data;
            /**
             * wechat api
             */
            if (wx) {
                var url = window.location.hash && window.location.href.slice(0, -window.location.hash.length) || window.location.href;
                WxJS.get({url: url}, function (res) {
                    if(res.status==200) {
                        $scope.agentIos = browserVersions();
                        var config = res.data;
                        wx.config({
                            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                            appId: config.appId, // 必填，公众号的唯一标识
                            timestamp: config.timestamp, // 必填，生成签名的时间戳
                            nonceStr: config.nonceStr, // 必填，生成签名的随机串
                            signature: config.signature,// 必填，签名，见附录1
                            jsApiList: ['chooseImage', 'uploadImage', 'hideMenuItems'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                        });
                        wx.ready(function () {
                            console.log('wechat api ready!');

                            wx.hideMenuItems({
                                menuList: ["menuItem:copyUrl", "menuItem:share:timeline", "menuItem:share:appMessage", "menuItem:share:qq", "menuItem:share:appMessage", "menuItem:share:QZone"]
                            });
                        });
                        wx.error(function (res) {
                            console.log(res)
                        });
                    }
                }, function () {
                    console.log("wx config error");
                });
            }

            vm.lagnuages =[];
            if ($localStorage.lagnuages) {
                for(var i = 0 ; i<$localStorage.lagnuages.length; i++ ){
                    var lang = $localStorage.lagnuages[i];
                    var langObj = {key:lang};
                    if (lang == 'zh-cn') {
                        langObj.value = "中文";
                    }
                    if (lang == 'en') {
                        langObj.value = "English";
                    }
                    if (vm.lang == lang) {
                        vm.langValue = langObj.value;
                        langObj.selected = true;
                    }
                    vm.lagnuages.push(langObj);
                }
            }

            // token过期 — QiniuToken 单例自动刷新
            //获取图片库
            loadAll('isNull');
            //消息列表
            getMessage();
            vm.isIPhoneX = Iphone;
            websocket()
        });

        $scope.uploadPhoto = function () {
            uploadAble(StoreStorages,vm.storeId, function (res) {
                if(res.status == 200){
                    if($scope.agentIos){
                        $rootScope.$broadcast('clickAndroidUpload',true);
                    }else{
                        $timeout(function () {
                            $("#uploadImageMutipleThree").trigger("click");
                        })
                    }
                }else{
                    if(res.status == 400){
                        threeInfo('系统出错');
                    } else {
                        threeInfo(res.data||'系统出错');
                    }
                }
            })
        }

        // websocket接收上传的图片（多端互通实时更新）
        function websocket(){
            var urlws = vm.platformSetting.editorNotifyUrl.split("://")[1];
            urlws = urlws.split("/")[0];
            var ws = $websocket("wss://"+ urlws +"/widget/ws/websocket?uid=Gallery"+vm.aid);
            ws.onOpen(function() {
                console.log('WebSocket连接已打开, url:'+ws.url);
            });
            ws.onMessage(function(message) {
                var photo = JSON.parse(message.data);
                if (photo.folderId == vm.folderId || (photo.folderId == null && vm.folderId == '')) {
                    // 同步某张照片的大图/色彩转换处理状态
                    var syncPhoto = function (target) {
                        if (!target) return;
                        target.largeStatus = photo.largeStatus;
                        target.stripKey = photo.stripKey;
                        target.thumbnailKey = photo.thumbnailKey;
                        target.identifier1 = $scope.domain + photo.thumbnailKey;
                        if (target.convertFlag) {
                            target.convertStatus = photo.convertStatus;
                            // 色彩转换完成后资源identifier会变化，需同步更新（photo.identifier未带域名）
                            target.identifier = $scope.domain + photo.identifier;
                        }
                    };
                    // 同步图库列表
                    var _photo = null;
                    for (var i = 0; i < vm.photoAll.length; i++) {
                        if (vm.photoAll[i].id == photo.id) {
                            _photo = vm.photoAll[i];
                            syncPhoto(_photo);
                            break;
                        }
                    }
                    // 同步已选集合
                    if (vm.photoSelectAll && vm.photoSelectAll.length) {
                        for (var j = 0; j < vm.photoSelectAll.length; j++) {
                            if (vm.photoSelectAll[j].id == photo.id) {
                                syncPhoto(vm.photoSelectAll[j]);
                            }
                        }
                    }
                    // 同步更新画布图片框中的大图处理状态，确保编辑组件实时显示
                    if (vm.pageData && vm.pageData.length) {
                        angular.forEach(vm.pageData, function (page) {
                            if (page.levels && page.levels.level) {
                                angular.forEach(page.levels.level, function (level) {
                                    if (level.imagebox && level.imagebox.image &&
                                        level.imagebox.image.resourceid == photo.id) {
                                        level.imagebox.image.largeStatus = photo.largeStatus;
                                        level.imagebox.image.stripKey = photo.stripKey;
                                    }
                                });
                            }
                        });
                    }
                    $scope.$applyAsync();
                }
            });
            ws.onError(function(error) {
                console.log('WebSocket错误：', error);
            });
            ws.onClose(function() {
                console.log('WebSocket连接已关闭');
            });
        }
        //消息列表
        function getMessage() {
            vm.messageList = "";
            MessageNotification.getAllByCondition2({
                items: [
                    {key: "available", op: "=", value: "true"},
                    {key: "validate", op: ">=", value: DateUtils.convertLocalDateToServer(new Date())},
                    {key:"storeId", op : "=", value:vm.storeId},
                    {key: "pageType", op: "=", value: "Edit"}]
            }, function (res) {
                if(res.status == 200){
                    res.data.sort(compare('seq'))
                    vm.message = angular.copy(res.data);
                    vm.messageEdit = angular.copy(res.data);
                    vm.messageEditText = "\xa0\xa0\xa0\xa0\xa0\xa0";
                    angular.forEach(res.data, function (resp, i) {
                        vm.messageList += resp.content
                        if (i != res.data.length - 1) {
                            vm.messageList += "\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0"
                        }
                    })
                }else {
                    MessageService.error(res.message);
                }
            });
        }
        function compare(property) {
            return function (a, b) {
                var value1 = a[property];
                var value2 = b[property];
                return value1 - value2;
            }
        }


        $scope.getBack = function (item) {
            if (item == 'page5') {
                vm.page4 = true;
                vm.page5 = false;
            }
        }


        $('.sticker-scroll').scroll(function () {
            if (!vm.photoCompleted) {
                var allHeight = $(this).find("ul").height() - $(this).height();
                if ($(this).scrollTop() >= allHeight) {
                    vm.indexNum++;
                    loadAll()
                }
            }
        });
        vm.uploadPhotoItem=[];
        $scope.$on('uoloadFinished', function(event, args) {
            if(args){
                angular.forEach(vm.photoAll,function (qin) {
                    if(qin.blobCover){
                        qin.blobCover = null;
                    }
                })
                console.log('···················上传完成···················');
                // updatePic();
            }
        });
        $scope.uploadSuccess = function(res){
            if(res.largeFlag || $scope.isLarge(res.imageInfo)){
                res.identifier1 = res.identifier + '.thumbnail.jpg';
            }
            vm.photoAll.unshift(res)
        }

        // 监听重复图片事件
        $scope.$on('duplicateImages', function(event, duplicateList,flag,currentFileList) {
            if (duplicateList && duplicateList.length > 0) {
                vm.duplicateList = duplicateList;
                MessageService.confirm({
                    title: '提示',
                    cancel: '取消',
                    confirm: '确认',
                    msg: '检测到图库中有' + vm.duplicateList.length + '张重复图片，是否需要自动去重？',
                    html: '<span class="themecolor themecolor-btn">查看重复图片</span>'
                }, function(res) {
                    if (res == 'htmlClick') {
                        vm.isDuplicateList = true;
                    } else {
                        var ids = [];
                        vm.duplicateList.forEach(function(item) {
                            ids.push(item.id);
                        });
                        Gallery.batchDelete(ids, function() {
                            // 上传的全是重复图
                           if(ids.length == vm.photoAll.length){
                                MessageService.success('去重成功！');
                                vm.duplicateList = [];
                                vm.photoAll = [];
                                vm.indexNum = 0;
                                vm.maxId = null;
                                vm.photoCompleted = false;
                                loadAll();
                           }else{
                            // 去重
                            var deletedIds = {};
                            currentFileList.forEach(function(_v){
                                if(_v.duplicate){
                                    deletedIds[_v.id] = true;
                                }
                            });
                            vm.photoAll = vm.photoAll.filter(function(img){
                                return !deletedIds[img.id];
                            });
                            $rootScope.$broadcast('uoloadFinished',flag);
                           }
                        }, function(error) {
                            MessageService.error('删除失败！');
                            vm.duplicateList = [];
                        });
                    }
                }, function() {
                    vm.duplicateList = [];
                    $rootScope.$broadcast('uoloadFinished',flag);
                });
            }
        });
        $scope.duplicateChange = function(val) {
            var _val = JSON.parse(val)
            // val 可能是: 0(关闭), 1(全部删除), 数组(部分删除)
            // 当删除部分图片时，从已选列表中移除对应图片，避免重新加载后这些图片被重新选中
            if(Array.isArray(_val) && _val.length){
                var deletedIds = {};
                _val.forEach(function(_v){
                    deletedIds[_v.id] = true;
                });
                vm.photoAll = vm.photoSelectAll.filter(function(img){
                    return !deletedIds[img.id];
                });
            }
            vm.isDuplicateList = false;
            vm.duplicateList = [];
            vm.indexNum = 0;
            vm.maxId = null;
            vm.photoCompleted = false;
            loadAll();
        };

        // 上传图片后更新图片库/文件夹
        function updatePic() {
            vm.photoAll=[];
            vm.indexNum = 0;
            vm.photoCompleted = false;
            loadAll();
        }
        function loadAll() {
            var items = [];
            items.push({key: "folderId", op: "isNull", value: ''})
            items.push({key: "articleId", op: "=", value: vm.aid})
            if (vm.maxId) {
                items.push({key: "id", op: "<=",value: vm.maxId});
            }
            Gallery.storeByCondition({
                items: items,
                page: vm.indexNum,
                size: vm.itemsPerPage,
                sort: sorts()
            }, onSuccess, onError);
        }

        function sorts() {
            return ["id,desc"];
        }

        function onSuccess(res) {
            if (vm.maxId == null && res.data.length > 0) {
                vm.maxId = res.data[0].id;
            }
            for (var i = 0; i < res.data.length; i++) {
                if (!res.data[i].cancelled) {
                    res.data[i].identifier = $scope.domain + res.data[i].identifier;
                    if(res.data[i].largeFlag || $scope.isLarge(res.data[i].imageInfo)){
                        res.data[i].identifier1 = res.data[i].identifier + '.thumbnail.jpg';
                    }
                    vm.photoAll.push(res.data[i])
                }
            }
            if (res.data.length < 20) {
                vm.photoCompleted = true;
            }
        }

        function onError(data) {
            if(data.status !== 403){
                MessageService.hint($translate.instant("galleryMessage.failedToObtainThePhotoGallery"));
            }

        }


        //获取dpi
        js_getDPI(function (dpi) {
            vm.windowDpi = dpi;
        });
        vm.pageData = null;
        vm.pageIndex = 0;
        $scope.template = null;
        function abook() {
            productXmlGet()
            vm.page4 = true;
            vm.page8 = true;
            if (vm.isEdit) {
                $scope.template = angular.copy(vm.article.document);
            } else {
                $scope.template = angular.copy($scope.pages);
            }
            documentAnalysis($scope, $http, vm, $scope.template,FontManagement,'other', function(page){
                ratioInfo(page)
            }, function () {
                $timeout(function () {
                    vm.page8 = false;
                    vm.pageData = $scope.template.pages.page;
                    vm.pageSum = $scope.template.pages.page.length - 1;
                    vm.pageIndex = 0;
                    warnIcon()
                    $timeout(function () {
                        thumbnailInit();
                    },1000)
                }, 1000)
            })
        }

        function productXmlGet(){
            ProductXml.get({id:vm.article.productXmlId}, function (productXml) {
                vm.productXmlData = productXml.data;
            })
        }
        vm.isEditboxMagnify = false;
        vm.ratioInfo = ratioInfo;
        function ratioInfo(item) {
            vm.windowWidth = document.body.clientWidth;
            vm.windowHeight = document.body.clientHeight * 0.91 - 175;
            if(vm.isAddImagebox || vm.mapDepot || vm.isMaterial || (vm.istemplate && vm.page4)){
                vm.windowHeight = document.body.clientHeight - 280 - (document.body.clientHeight*0.02);
            }
            if(vm.isEditboxMagnify){
                var ratio = item.mediabox.width / item.mediabox.height;
                var ratio1 = vm.windowWidth / vm.windowHeight;
                if (ratio >= ratio1) {
                    item.custom.ratio1 = vm.windowWidth / item.mediabox.width;
                } else {
                    item.custom.ratio1 = vm.windowHeight / item.mediabox.height;
                }
            }else{
                var ratio = item.custom.width / item.custom.height;
                var ratio1 = vm.windowWidth / vm.windowHeight;
                if (ratio >= ratio1) {
                    item.custom.ratio1 = vm.windowWidth / item.custom.width;
                } else {
                    item.custom.ratio1 = vm.windowHeight / item.custom.height;
                }
            }
            item.custom.thumbnailScale = 300 / item.custom.width;
        }
        $scope.editboxMagnify = function () {
            vm.isEditboxMagnify = !vm.isEditboxMagnify;
            ratioInfo(vm.pageData[vm.pageIndex]);
        }
        function warnIcon() {
            vm.warnIcon = false;
            vm.pageData[vm.pageIndex].levels.level.forEach(function (level) {
                if(level.imagebox && level.imagebox.image && pxInsufficient(level.imagebox,vm.imgSize, vm.imgDpi)){
                    vm.warnIcon = true;
                }
            })
        }

        $scope.previousPage = function () {
            thumbnailInit2(vm.pageData[vm.pageIndex],function(){
                vm.pageIndex--;
                warnIcon();
                ratioInfo(vm.pageData[vm.pageIndex]);
            })
        }
        $scope.nextPage = function () {
            thumbnailInit2(vm.pageData[vm.pageIndex],function(){
                vm.pageIndex++;
                warnIcon();
                ratioInfo(vm.pageData[vm.pageIndex]);
            })
        }
        $scope.goPageContent = function (index) {
            vm.isDocumentTextDetection=false;
            vm.pageIndex = index;
            warnIcon();
            ratioInfo(vm.pageData[vm.pageIndex]);
        }

        /*******************************************点击模板*************************************************************************/
        $scope.templateShow = function () {
            vm.istemplate = true;
            productInit()
            ratioInfo(vm.pageData[vm.pageIndex])
        }
        $scope.templateHide = function () {
            vm.istemplate = false;
            ratioInfo(vm.pageData[vm.pageIndex])
        }

        function productInit() {
            Product.get({id: vm.article.productId, cancelled: false}, function (res) {
                for (var i = 0; i < res.data.itemValues.length; i++) {
                    var itemValue = res.data.itemValues[i];
                    if (itemValue.cancelled) {
                        continue;
                    }
                    if (itemValue.id == vm.article.itemValueId) {
                        vm.tempList = angular.copy(itemValue);
                        productXmlInit()
                    }
                }
            })
        }
        function productXmlInit(){
            vm.productXmlThemeId = '';
            vm.productXmls = [{id:'',name:$translate.instant("editorCommon.all"), seq:''}];
            vm.tempList.productXmlLines.forEach(function (temp) {
                if (temp.themeClassifies && !temp.cancelled && temp.paid) {
                    temp.themeClassifies.forEach(function (themeClassifie) {
                        var isExist = false;
                        for(var i=0; i<vm.productXmls.length; i++){
                            if(vm.productXmls[i].id == themeClassifie.id){
                                isExist = true;
                                break;
                            }
                        }
                        if(!isExist){
                            vm.productXmls.push(themeClassifie)
                        }
                    })
                }
            })
            vm.productXmls.sort(function (a, b) {
                return a.seq - b.seq;
            });
        }
        $scope.productXmlCb = function(item){
            vm.productXmlThemeId = item.id;
        };
        $scope.productXmlShow = function(themeClassifies){
            var _exist = false;
            themeClassifies.forEach(function (themeClassifie) {
                if (vm.productXmlThemeId ==  themeClassifie.id) {
                    _exist = true;
                }
            })
            return _exist
        }
        vm.imgs = [];
        var templateSwiper = null;
        $scope.templateCb = function (temp) {
            if (temp.id == vm.xmlId || temp.productXmlId == vm.article.productXmlId) {
                vm.threeIsModal1 = true;
                vm.threeModalText1 = $translate.instant("editorCommon.alreadyExistTemplate");
                return
            }
            vm.xmlShowPic = true;
            $scope.chooseTemp = temp;
            ProductXml.get({id: temp.productXmlId}, function (res) {
                if (res.data.documentPics && res.data.documentPics.length > 0) {
                    res.data.documentPics.sort(function (a, b) {
                        return a.seq - b.seq;
                    });
                }
                vm.imgs = res.data.documentPics;
                if(vm.imgs.length > 0){
                    $timeout(function () {
                        templateSwiperInit();
                        templateSwiper.init();//现在才初始化
                    },200)
                }
            }, function () {

            })
        }
        function templateSwiperInit() {
            templateSwiper = new Swiper ('.swiper-template-view-content', {
                // 如果需要前进后退按钮
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                }
            })
        }

        var inits = 0, num = 0;
        $scope.previewClose = function () {
            vm.xmlShowPic = false;
        };
        $scope.changeAllTemp = function () {
            vm.threeIsModal = true;
            vm.threeModalText = $translate.instant("editorCommon.whetherReplaceTemplate");
        }

        function templateReplace() {
            if(vm.isEdit){
                vm.pageData.forEach(function (page) {
                    if(page.levels.level){
                        page.levels.level.forEach(function (level) {
                            if (level.imagebox && level.imagebox.image && level.imagebox.image.resource && level.imagebox.image.resource.identifier) {
                                vm.photoSelectAll.push({
                                    height: level.imagebox.image.height,
                                    id: level.imagebox.image.resourceid,
                                    imageInfo: level.imagebox.image.imageInfo,
                                    identifier: level.imagebox.image.resource.identifier.indexOf('http') > -1 ? level.imagebox.image.resource.identifier : domain + level.imagebox.image.resource.identifier,
                                    imgsize: level.imagebox.image.imgsize,
                                    name: null,
                                    provider: "qiniu",
                                    usenum: 1,
                                    width: level.imagebox.image.width
                                });
                            }
                        })
                    }
                })
                Convert.xmlToDocument2({
                    identifier: $scope.chooseTemp.productXmlIdentifier,
                    provider: "qiniu",
                    editorType:vm.article.editorType,
                    patternType:vm.product.patternType,
                }, function (res) {
                    vm.counts = 0;
                    angular.forEach(res.pages.page, function (page, i) {
                        if(!page.backup) {
                            angular.forEach(page.levels.level, function (level) {
                                if (level.imagebox && level.imagebox.geometry) {
                                    vm.counts++;
                                }
                            })
                        }
                    });
                    $scope.previewClose();
                    $scope.templateHide();
                    vm.article.document = res;

                    vm.productXmlLine = angular.copy($scope.chooseTemp);
                    vm.modelBlendentUuid=vm.productXmlLine.modelBlendentUuid;
                    vm.article.modelBlendentUuid= vm.productXmlLine.modelBlendentUuid;
                    vm.article.cover= vm.productXmlLine.coverImg;
                    vm.article.themeClassifyId= vm.productXmlLine.productXmlThemeId;
                    vm.article.themeClassifyName= vm.productXmlLine.productXmlThemeName;
                    vm.article.productXmlId= vm.productXmlLine.productXmlId;
                    vm.article.productXmlName= vm.productXmlLine.productXmlName;
                    vm.article.productXmlLineId= vm.productXmlLine.id;
                    if(vm.productXmlLine && vm.productXmlLine.musicIdentify){
                        vm.article.musicIdentify= vm.productXmlLine.musicIdentify;
                    }
                    vm.isHtml2canvas = false;
                    vm.editProductXml = true;
                    abook();
                });
            }else{
                // window.location.href = vm.platformSetting.editorNotifyUrl+'/#/'+vm.storeId+'/'+vm.pid+'/'+vm.vid+'/'+$scope.chooseTemp.id+'/'+vm.aid+'/chooseThree';
                $state.go('product-chooseThree-ec', {storeId: vm.storeId, pid: vm.pid, vid: vm.vid, xmlId: $scope.chooseTemp.id, aid: vm.aid},{location: 'replace'})
                // window.location.reload();
                localStorage.setItem("photoSelectAll", JSON.stringify(vm.photoSelectAll));
            }
        }

        /*******************************************点击图片库*************************************************************************/
        vm.isImageboxSelectItem = false;
        vm.mapDepot = false;
        $scope.photoGalleryShow = function () {
            vm.mapDepot = true;
            ratioInfo(vm.pageData[vm.pageIndex])
        }
        $scope.photoGalleryHide = function () {
            vm.mapDepot = false;
            vm.isAddImagebox = false;
            ratioInfo(vm.pageData[vm.pageIndex])
        }
        $('#photoGallery').on('scroll', function(event){
            var realScrollHeight=event.currentTarget.clientHeight+event.currentTarget.scrollTop;
            if(!vm.photoCompleted){
                if((event.currentTarget.scrollHeight-1)<realScrollHeight && realScrollHeight < (event.currentTarget.scrollHeight+1)){
                    vm.indexNum++
                    loadAll("isNull")
                }
            }
        })
        $scope.addImageboxCb = function(){
            vm.isAddImagebox = true;
            ratioInfo(vm.pageData[vm.pageIndex])
        };
        function imageboxAddFn(item, callback){

            imageboxAdd($http, item, vm.pageData[vm.pageIndex].trimbox, vm.article, function(imagebox){

                addImagebox($http, imagebox, function () {
                    var _level = {
                        seq: vm.pageData[vm.pageIndex].levels.level.length + 1,
                        imagebox: imagebox
                    }
                    vm.pageData[vm.pageIndex].levels.level.push(_level);
                    $timeout(function () {
                        if(!vm.isImageboxSelectItem){
                            $scope.makeBody();
                        }
                        vm.levelIndex = parseInt(vm.pageData[vm.pageIndex].levels.level.length-1);
                        vm.levelType = 'imagebox';
                        thumbnailInit();
                            if(callback){callback()}
                    });
                });
            })
        }


        /*******************************************素材处理*************************************************************************/
        $scope.makeBody = vm.makeBody = function (callback) {
            vm.levelIndex = null;
            vm.levelType = null;
            vm.isImageboxSelectItem = false;
            vm.textStyleShow = false;
            vm.textboxSelect = false;
            vm.filterShow = false;
            vm.mattingShow = false;
            if(vm.isAddImagebox || vm.mapDepot || vm.isMaterial || vm.istemplate){
                vm.istemplate = false;
                vm.isMaterial = false;
                vm.mapDepot = false;
                vm.isAddImagebox = false;
                ratioInfo(vm.pageData[vm.pageIndex]);
            }else {
                vm.istemplate = false;
                vm.isMaterial = false;
                // vm.mapDepot = false;
                vm.isAddImagebox = false;
            }
            if(callback)(callback())
        };
        vm.levelDome = function(item){
            vm.mattingShow = false;
            vm.filterShow = false;
            vm.isImageboxSelectItem = false;
            vm.istemplate = false;
            vm.isMaterial = false;
            vm.textboxSelect = false;
            vm.mapDepot = false;
            vm.isAddImagebox = false;
            vm.textStyleShow = false;
            if(item){
                vm[item] = true;
            }
        }

        vm.isMaterial = false;
        $scope.materialShow = function () {
            vm.isMaterial = true;
            vm.materialPage = 0;
            vm.materialSum = 20;
            vm.materialData = [];
            getThemeClassify();
            ratioInfo(vm.pageData[vm.pageIndex])
        }

        function getThemeClassify(){
            //分类
            ThemeClassify.getAllByCondition4({type: 'ClipArt', storeId: vm.storeId}, function (res) {
                if(!res.data){res.data=[]}
                vm.classify = [];
                if($scope.template.cliparts && $scope.template.cliparts.clipart && $scope.template.cliparts.clipart.length>0){
                    vm.classify = [{
                        id: "",
                        name: $translate.instant("editorCommon.recommend"),
                        seq: 0,
                        type: "CLIPART",
                        used: true
                    }]
                }
                res.data.forEach(function (item) {
                    if(item.storeId) {
                        vm.classify.push(item)
                    }
                })
                res.data.forEach(function (item) {
                    if(!item.storeId) {
                        vm.classify.push(item)
                    }
                })
                vm.classifyW = res.data.length * 86;
                if(vm.classify && vm.classify.length>0){
                    initMaterial(vm.classify[0].id)
                }
            });
        }
        $scope.classifyCb = function (item) {
            vm.materialPage = 0;
            vm.materialData = [];
            initMaterial(item.id)
        }
        //获取素材
        vm.isMaterial1 = false;

        function initMaterial(id) {
            vm.classifyId = id;
            if(id){
                ClipArt.byCondition3({
                    items: [
                        {key: "themeClassify.id", op: "=", value: id}],
                    page: vm.materialPage,
                    size: vm.materialSum,
                    sort: ["seq,asc"]
                }, function (res) {
                    angular.forEach(res.data, function (resp) {
                        var arr = {
                            name: resp.name,
                            identifier: $scope.domain + resp.identifier,
                            provider: resp.provider,
                            themeClassifyName: resp.themeClassifyName,
                            themeClassifyId: resp.themeClassifyId,
                            resource: {
                                identifier: $scope.domain + resp.identifier,
                                provider: resp.provider
                            }
                        }
                        vm.materialData.push(arr);
                    })
                    vm.materialW = vm.materialData.length * 90 + 20;
                    if (res.data.length < vm.materialSum) {
                        vm.isMaterial1 = true;
                    }else {
                        vm.isMaterial1 = false;
                    }
                });
            }else{
                $scope.template.cliparts.clipart.forEach(function (clipart) {
                    var arr = {
                        name: "",
                        identifier: clipart.resource.identifier,
                        provider: "",
                        themeClassifyName: $translate.instant("editorCommon.recommend"),
                        themeClassifyId: "",
                        resource: clipart.resource
                    }
                    vm.materialData.push(arr);
                })
                vm.materialW = vm.materialData.length * 90 + 20;
                vm.isMaterial1 = true;
            }
        }
        $('#materialView').on('scroll', function(event){
            var realScrollHeight=event.currentTarget.clientHeight+event.currentTarget.scrollTop;
            if(!vm.isMaterial1){
                if((event.currentTarget.scrollHeight-1)<realScrollHeight && realScrollHeight < (event.currentTarget.scrollHeight+1)){
                    vm.materialPage++;
                    initMaterial(vm.classifyId)
                }
            }
        })
        $scope.materialHide = function () {
            vm.isMaterial = false;
            ratioInfo(vm.pageData[vm.pageIndex])
        }

        //添加素材
        vm.repeatAddNumber = 0;
        $scope.addImageart = function (item) {
            vm.threeLoading = true;
            vm.threeLoadingText=$translate.instant("hint.loadingText");
            imageartAdd($http, item.resource.identifier, vm.pageData[vm.pageIndex].trimbox, function(imageart){
                if(vm.repeatAddNumber>4){
                    vm.repeatAddNumber = 0;
                }
                var _num = 10*vm.repeatAddNumber;
                imageart.geometry.x += _num/vm.pageData[vm.pageIndex].custom.ratio1;
                imageart.geometry.y += _num/vm.pageData[vm.pageIndex].custom.ratio1;
                var _level = {
                    seq: vm.pageData[vm.pageIndex].levels.level.length + 1,
                    imageart: imageart
                }
                vm.pageData[vm.pageIndex].levels.level.push(_level);
                thumbnailInit();
                vm.threeLoading = false;
                vm.repeatAddNumber++;
            },vm.pageData[vm.pageIndex].custom.ratio1)
        }
        $scope.savePage4 = function () {
            $scope.template.pages.page = vm.pageData;
            $scope.save()
        }
        /*******************************************文字处理*************************************************************************/
        $scope.colorList = ['#ff001e', '#ff5c00', '#ff9700', '#61734d', '#838c97', '#8d4ac8', '#b8e986', '#7e6565', '#ffffff', '#f1e7d9', '#b5ce99', '#82c281', '#dac2ef', '#000', '#797979', '#7c330a', '#eec78d', '#444444', '#589ceb', '#4a7bc8', '#ddabab'];
        $scope.selectedColor = $scope.colorList[0];

        vm.textboxSelect = false;
        textStyleTabInit();
        function textStyleTabInit(){
            vm.textStyleTab = [
                {name: $translate.instant("font.textStyleTabFont"), id: 'textStyleTabFont'},
                {name: $translate.instant("font.textStyleTabSize"), id: 'textStyleTabSize'},
                {name: $translate.instant("font.textStyleTabType"), id: 'textStyleTabType'},
                {name: $translate.instant("font.textStyleTabColor"), id: 'textStyleTabColor'},
            ];
        }
        vm.textStyleItem = 'textStyleTabFont';
        //添加文字
        $scope.fontShow = function () {
            vm.page5 = true;
            vm.fontTab = 'fontColor';
            $scope.selectedColor = $scope.colorList[0];

            // var _level ={
            //     seq: vm.pageData[vm.pageIndex].levels.level.length+1,
            //     textbox: textbox
            // }
            var _size = Math.floor(vm.pageData[vm.pageIndex].trimbox.height/8);

            vm.fontData = {
                seq: vm.pageData[vm.pageIndex].levels.level.length + 1,
                textbox: {
                    type: 'add',
                    geometry: {
                        x: '0',
                        y: '0',
                        width: 100,
                        height: 20
                    },
                    rotation: {
                        angle: '0'
                    },
                    text: '',
                    style: {
                        font: "",
                        size: _size,
                        color: $scope.selectedColor,
                        bold: false,
                        italic: false,
                        lineheight: _size,
                        letterspacing: 0,
                        align: 'left',
                        writingmode:'horizontal-tb'
                    },
                    fontuuid: vm.fontItem.uuid,
                    identifier: "",
                    editable: true,
                    movable: true,
                    lock: false,
                    version: '2.0',
                    transparency: 1,
                    useradded: true
                }
            }
            var _fontStyle = [];
            for (var j = 0; j < vm.fontItem.fontStyles.length; j++) {
                _fontStyle.push(vm.fontItem.fontStyles[j].style)
            }
            if (_fontStyle.indexOf('NORMAL') != '-1') {
                vm.fontData.textbox.style.bold = false;
                vm.fontData.textbox.style.italic = false;
            } else {
                if (_fontStyle.indexOf('BOLD_ITALIC') != '-1') {
                    vm.fontData.textbox.style.bold = true;
                    vm.fontData.textbox.style.italic = true;
                } else {
                    if (_fontStyle.indexOf('ITALIC') != '-1') {
                        vm.fontData.textbox.style.italic = true;
                        vm.fontData.textbox.style.bold = false;
                    }
                    if (_fontStyle.indexOf('BOLD') != '-1') {
                        vm.fontData.textbox.style.bold = true;
                        vm.fontData.textbox.style.italic = false;
                    }
                }
            }
            getFontCSS(FontManagement, vm.fontData.textbox, $scope);
            vm.text = '';
            $timeout(function () {
                $('textarea.three-font-body-input').focus()
            },100);
        };
        //切换字体
        $scope.updateTextFont = function (data) {
            if (data == undefined) {
                threeInfo($translate.instant("font.failedAddText"));
                return
            }
            if (!data.enable) {
                threeInfo($translate.instant("font.fontChange"));
                return
            }
            var text = angular.copy(vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox);
            vm.fontStyle = [];
            for (var i = 0; i < vm.fontList.length; i++) {
                if (vm.fontList[i].uuid == data.uuid) {
                    for (var j = 0; j < vm.fontList[i].fontStyles.length; j++) {
                        vm.fontStyle.push(vm.fontList[i].fontStyles[j].style)
                    }
                }
            }
            text.style.bold = false;
            text.style.italic = false;
            if (vm.fontStyle.indexOf('NORMAL') != '-1') {
                text.style.bold = false;
                text.style.italic = false;
            } else {
                if (vm.fontStyle.indexOf('BOLD_ITALIC') != '-1') {
                    text.style.bold = true;
                    text.style.italic = true;
                } else {
                    if (vm.fontStyle.indexOf('ITALIC') != '-1') {
                        text.style.italic = true;
                    }
                    if (vm.fontStyle.indexOf('BOLD') != '-1') {
                        text.style.bold = true;
                    }
                }
            }
            text.style.font = data.family;
            text.fontuuid = data.uuid;
            text.identifier = $scope.domain + data.fontStyles[0].identifier;
            vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.loading = true;
            FontSupport2(FontManagement, text, function (res) {
                var msg = res.data;
                if (res.status == 200) {
                    if (!msg.success || msg.failed) {
                        MessageService.minConfirm({
                            confirm:$translate.instant("button.returnCorrection"),
                            msg:$translate.instant("font.pleaseChangeFonts1") +
                                    '<span class="theme-color">'+msg.failed+'</span>' + $translate.instant("font.pleaseChangeFonts2")
                        })
                    } else {
                        vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox = text;
                        getFontCSS(FontManagement, vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox, $scope);
                        $timeout(function () {
                            sizeHeight();
                            fontStyle(data.uuid);
                            thumbnailInit();
                        })
                    }
                }
                vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.loading = false;
            })
        };

        function fontStyle(fontuuid) {
            var text = vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox;
            vm.fontStyle = [];
            for (var i = 0; i < vm.fontList.length; i++) {
                if (vm.fontList[i].uuid == fontuuid) {
                    for (var j = 0; j < vm.fontList[i].fontStyles.length; j++) {
                        vm.fontStyle.push(vm.fontList[i].fontStyles[j].style)
                    }
                }
            }
            text.style.bold1 = false;
            text.style.italic1 = false;
            if (vm.fontStyle.indexOf('NORMAL') == '-1') {
                text.style.normal = false;
            } else {
                text.style.normal = true;
            }
            if (vm.fontStyle.indexOf('BOLD_ITALIC') != '-1') {
                text.style.bold1 = true;
                text.style.italic1 = true;
            } else {
                if (vm.fontStyle.indexOf('ITALIC') != '-1') {
                    text.style.italic1 = true;
                }
                if (vm.fontStyle.indexOf('BOLD') != '-1') {
                    text.style.bold1 = true;
                }
            }
        }

        window.densityInput = function (e) {
            var val = $('#rangeChange').val();
            if (vm.pageData[vm.pageIndex].levels.level[vm.levelIndex] && vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox) {
                vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.size = parseInt(val);
                vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.lineheight = parseInt(val);
            }

            var currentPage = vm.pageData[vm.pageIndex].levels.level;
            var item = currentPage[vm.levelIndex].textbox;

            if (item.geometry.width < parseInt(item.style.size)) {
                item.geometry.width = (Number(parseInt(item.style.size)) + Number(5));
            }
            if (item.geometry.width > vm.pageData[vm.pageIndex].trimbox.width) {
                item.geometry.width = vm.pageData[vm.pageIndex].trimbox.width;
                // item.geometry.x = 0;
            }
            sizeHeight();
            thumbnailInit();
            $scope.$digest();
        }
        window.textStyleTransparency = function (e) {
            var val = $('#textStyleTransparency').val();
            if (vm.pageData[vm.pageIndex].levels.level[vm.levelIndex] && vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox) {
                vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.transparency = parseInt(val) / 100;
                vm.transparency = parseInt(val);
            }
        }
        //斜体
        $scope.operationItalic = function () {
            var text = vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox;
            if (vm.fontStyle.indexOf('NORMAL') != '-1') {
                text.style.italic = !text.style.italic;
                $timeout(function () {
                    sizeHeight();
                }, 200)
            } else {
                if (vm.fontStyle.indexOf('BOLD_ITALIC') != '-1' || vm.fontStyle.indexOf('BOLD') != '-1') {
                    if (text.style.bold) {
                        text.style.italic = !text.style.italic;
                        $timeout(function () {
                            sizeHeight();
                        }, 200)
                    }
                }
            }
        }
        //粗体
        $scope.operationBold = function () {
            var text = vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox;
            if (vm.fontStyle.indexOf('NORMAL') != '-1') {
                text.style.bold = !text.style.bold;
                $timeout(function () {
                    sizeHeight();
                }, 200)
            } else {
                if (vm.fontStyle.indexOf('BOLD_ITALIC') != '-1' || vm.fontStyle.indexOf('ITALIC') != '-1') {
                    if (text.style.italic) {
                        text.style.bold = !text.style.bold;
                        $timeout(function () {
                            sizeHeight();
                        }, 200)
                    }
                }
            }
        }
        $scope.operationBarDir = function (item) {
            var text = vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox;
            text.style.align = item;
            thumbnailInit();
        };
        $scope.fontColorCb = function (item) {
            var text = vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox;
            text.style.color = item;
            thumbnailInit();
        }
        $scope.textLayout = function(item){
            var text = vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox;
            var text1 = angular.copy(vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox);
            var _writingmode = angular.copy(text.style.writingmode);
            text.style.writingmode = item;
            if(writingmodeInit(_writingmode) && writingmodeInit(text.style.writingmode)){
            }else{
                text.geometry.width = text1.geometry.height;
                text.geometry.height = text1.geometry.width;
            }
            thumbnailInit();
        };
        vm.fontItem = null;
        function getAllFont() {
            vm.fontItem = null;
            FontManagement.getAll({}, function (res) {
                vm.fontList = res;
                if(vm.fontList && vm.fontList.length>0){
                    vm.fontItem = vm.fontList[0];
                    vm.fontList.forEach(function (item){
                        if(item.defaultShow){
                            vm.fontItem = item;
                        }
                    })
                }
            });
        }

        //判断是ios or Android
        var u = navigator.userAgent;
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

        var textFlag = true;
        var inputEle = document.getElementById('three-font-body-input');

        // 兼容安卓文字输入（首行空格不显示bug）
        $scope.changeText = function (e) {
            if (isAndroid == true && isiOS == false) {
                fn(e);
                var targ = e.currentTarget ? e.currentTarget : e.srcElement;
                vm.text = vm.fontData.textbox.text = targ.value;
            }
        }

        /**
         * 兼容iOS文字输入
         */
        inputEle.addEventListener('compositionstart', function () {
            textFlag = false;
        });
        inputEle.addEventListener('compositionend', function (event) {
            textFlag = true;
            // compositionend 事件发生在 input 之后，故此需要此处调用 input 中逻辑
            if (isAndroid == false && isiOS == true) {
                vm.text = event.target.value;
            }
        });
        inputEle.addEventListener('input', function (event) {
            // 忽略一切非直接输入，不做逻辑处理
            if (textFlag) {
                if (isAndroid == false && isiOS == true) {
                    vm.text = event.target.value;
                }
            };
        });

        $scope.savePage5 = function () {
            if (!vm.fontData.textbox.text) {
                vm.page4 = true;
                vm.page5 = false;
                return
            }
            if(vm.text){
                vm.fontData.textbox.text =  vm.text;
            }
            FontSupport2(FontManagement, vm.fontData.textbox, function (res) {
                var msg = res.data;
                if (res.status == 200) {
                    if (!msg.success || msg.failed) {
                        MessageService.minConfirm({
                            confirm:$translate.instant("button.returnCorrection"),
                            msg:$translate.instant("font.pleaseChangeFonts1") +
                                    '<span class="theme-color">'+msg.failed+'</span>' + $translate.instant("font.pleaseChangeFonts2")
                        })
                    } else {
                        vm.page4 = true;
                        vm.page5 = false;
                        vm.fontData.textbox.style.color = $scope.selectedColor;
                        if (vm.fontData.textbox.type == 'add') {
                            vm.fontData.textbox.geometry.width = Number($("#c-xml-page-material-fontId").width()) + Number(10);
                            vm.fontData.textbox.geometry.x = (vm.pageData[vm.pageIndex].trimbox.width - vm.fontData.textbox.geometry.width) / 2 + vm.pageData[vm.pageIndex].trimbox.x;
                            vm.fontData.textbox.geometry.y = (vm.pageData[vm.pageIndex].trimbox.height - vm.fontData.textbox.geometry.height) / 2 + vm.pageData[vm.pageIndex].trimbox.y;
                            vm.pageData[vm.pageIndex].levels.level.push(vm.fontData)
                            vm.levelIndex = vm.pageData[vm.pageIndex].levels.level.length-1;
                        }
                        if (vm.fontData.textbox.type == 'edit') {
                            vm.pageData[vm.pageIndex].levels.level[vm.levelIndex] = vm.fontData;
                        }
                        sizeHeight1(function () {
                            thumbnailInit();
                        })
                    }
                }
            })
        };
        //选中文字
        // $scope.textboxSelectCb = function (e, index) {
        //     console.log('dfafaskldfsjkdaf;ljka')
        //     fn(e);
        //     vm.levelIndex = index;
        //     vm.levelType = 'textbox';
        // }
        var isTextbox = false;
        //删除文字
        $scope.deleteTextbox = function (e) {
            fn(e)
            if (vm.pageData[vm.pageIndex].levels.level[vm.levelIndex] && vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox) {
                vm.pageData[vm.pageIndex].levels.level.splice(vm.levelIndex, 1);
                vm.levelIndex = null;
                vm.levelType = null;
                $scope.makeBody();
                thumbnailInit();
            }
        }
        $scope.editTextbox = function (e, index, item) {
            fn(e)
            vm.page5 = true;
            vm.fontData = vm.pageData[vm.pageIndex].levels.level[vm.levelIndex];
            vm.fontData.textbox.type = 'edit';
            $scope.selectedColor = vm.fontData.textbox.style.color;
            vm.fontTab = 'fontColor';
            vm.text = vm.fontData.textbox.text;
            $timeout(function () {
                $('textarea.three-font-body-input').focus()
            },100);
        }
        //文字样式
        $scope.textStyleTextbox = function () {
            vm.textStyleShow = true;
        }


        function sizeHeight() {
            sizeHeight1();
            // $timeout(function () {
            //     var _h = Number($('.pitch1').find('.c-xml-page-textboxe-text span').height()) + 5;
            //     vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.geometry.height = _h;
            //     $scope.$digest();
            // })
        }
        vm.sizeHeight1 = sizeHeight1;
        function sizeHeight1(callback) {
            if(vm.pageData[vm.pageIndex] && vm.pageData[vm.pageIndex].levels && vm.pageData[vm.pageIndex].levels.level && vm.pageData[vm.pageIndex].levels.level[vm.levelIndex] && vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox){
                getTextHeight(vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox, $scope)
            }
            if(callback){callback()}
        }
        //字体样式
        $scope.textStyleTabCb = function (item) {
            vm.textStyleItem = item.id;
        }
        $scope.textStyleHide = function () {
            vm.textStyleShow = false;
        }

        $scope.writingmodeInit = function (item) {
            if(item == 'vertical-lr' || item == 'vertical-rl'){
                return true
            }else{
                return false
            }
        }
        /*******************************************照片框处理*************************************************************************/

        //展开
        vm.isModeOut = false;
        $scope.modeIn = function () {
            var _imagebox = vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox;
            if (_imagebox.bokehtype != 'None') {
                if (_imagebox.image && _imagebox.image.resource.identifier) {
                    imageboxModeIn(_imagebox, function (imagebox) {
                        vm.isModeOut = true;
                        thumbnailInit();
                    })
                }
            }
        };
        //缩放
        $scope.modeOut = function () {
            var _imagebox = vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox;
            if (_imagebox.bokehtype == 'None') {
                if (_imagebox.image && _imagebox.image.resource.identifier) {
                    imageboxModeOut(_imagebox, function (imagebox) {
                        vm.isModeOut = false;
                        getBackgroundSource3(_imagebox, _imagebox.geometry.width, _imagebox.geometry.height, _imagebox.image, _imagebox.bokehtypes, $scope, function () {
                            thumbnailInit();
                        });
                    })
                }
            }
        };


        $scope.cropImageboxMassive = function () {
            imageboxMassive(vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox, vm.pageData[vm.pageIndex]);
            thumbnailInit();
            warnIcon()
        }
        $scope.cropImageboxMin = function () {
            imageboxMin(vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox, vm.pageData[vm.pageIndex]);
            thumbnailInit();
            warnIcon()
        }
        $scope.cropImageboxRotate = function (flag) {
            imageboxRotate($scope, vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox, flag);
            $timeout(function () {
                thumbnailInit();
            },1000)
        }
        $scope.cropImagRestore = function () {
            imagRestore($scope, vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox, $http);
            $timeout(function () {
                thumbnailInit();
            },1000)
            warnIcon()
        }
        $scope.overturnImagebox = function () {
            imageboxOverturn(vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox);
            $timeout(function () {
                thumbnailInit();
            },1000)
        }

        vm.mattingShow = false;
        vm.filterShow = false;
        vm.filterType='';
        vm.filterList=[
            {img:'content/images/filter1.png',type:''},
            {img:'content/images/filter2.png',type:'selfie_anime'},
            {img:'content/images/filter3.png',type:'wave'},
            {img:'content/images/filter4.png',type:'warm'},
            {img:'content/images/filter5.png',type:'scream'},
            {img:'content/images/filter6.png',type:'gothic'},
            {img:'content/images/filter7.png',type:'lavender'},
        ];
        vm.mattingList=[
            {img:'content/images/filter8.png',type:''},
            {img:'content/images/filter9.png',type:'body_seg'},
        ];
        $scope.filterCb = function(item){
            if(!vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox || !vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image || !vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.resource.identifier){
                return;
            }
            if(item.type == vm.filterType){
                return;
            }
            vm.threeLoading = true;
            vm.threeLoadingText = $translate.instant("hint.loadingText");
            var _imagebox = vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox;
            if(_imagebox.image.resourceid){
                Gallery.getOne({id:_imagebox.image.resourceid},function (res) {
                    // if(res.imgSize.size / 1024 < 1024*4){
                    //     threeInfo("图片不能大于4M")
                    //     return
                    // }
                    var _identifier = $scope.domain + res.data.identifier;
                    if(!item.type){
                        vm.filterType=item.type;
                        vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.resource.identifier = _identifier;
                        vm.threeLoading = false;
                        vm.threeLoadingText = '';
                        thumbnailInit();
                    }else {
                        Convert.imageEnhance({
                            imageUrl: _identifier,
                            type: item.type
                        }, function (resp) {
                            if(resp.status == 200){
                                vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.resource.identifier = $scope.domain + resp.message;
                                vm.filterType=item.type;
                                thumbnailInit();
                            }else{
                                threeInfo(resp.message)
                            }
                            vm.threeLoading = false;
                            vm.threeLoadingText = '';
                        }, function () {
                            vm.threeLoading = false;
                            vm.threeLoadingText = '';
                            threeInfo($translate.instant("editorCommon.loadError"))
                        });
                    }
                }, function () {
                    vm.threeLoading = false;
                    vm.threeLoadingText = '';
                    threeInfo($translate.instant("editorCommon.loadError"))
                })
            }else {
                if(!_imagebox.image.resource.identifier1){
                    _imagebox.image.resource.identifier1 = angular.copy(_imagebox.image.resource.identifier);
                }
                if(!item.type){
                    vm.filterType=item.type;
                    vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.resource.identifier = _imagebox.image.resource.identifier1;
                    vm.threeLoading = false;
                    vm.threeLoadingText = '';
                    thumbnailInit();
                }else {
                    Convert.imageEnhance({
                        imageUrl: _imagebox.image.resource.identifier1,
                        type: item.type
                    }, function (resp) {
                        if(resp.status == 200){
                            vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.resource.identifier = $scope.domain + resp.message;
                            vm.filterType=item.type;
                            thumbnailInit();
                        }else{
                            threeInfo(resp.message)
                        }
                        vm.threeLoading = false;
                        vm.threeLoadingText = '';
                    }, function () {
                        vm.threeLoading = false;
                        vm.threeLoadingText = '';
                        threeInfo($translate.instant("editorCommon.loadError"))
                    });
                }
            }
        };
        function threeInfo(item){
            vm.threeError = true;
            vm.threeErrorText=item;
            $timeout(function () {
                vm.threeError = false;
                vm.threeErrorText="";
            },1500)
        }
        $scope.mattingImage = function () {
            vm.mattingShow = true;
        };
        $scope.cutImage = function () {
            $timeout(function () {
                vm.filterShow = true;
            })
        };
        $scope.filterChoose = function (item) {
            switch (item) {
                case 'selfie_anime':
                    return $translate.instant("editorBtn.selfieAnime");
                    break;
                case 'warm':
                    return $translate.instant("editorBtn.warm");
                    break;
                case 'wave':
                    return $translate.instant("editorBtn.wave");
                    break;
                case 'lavender':
                    return $translate.instant("editorBtn.lavender");
                    break;
                case 'scream':
                    return $translate.instant("editorBtn.scream");
                    break;
                case 'gothic':
                    return $translate.instant("editorBtn.gothic");
                    break;
                case 'body_seg':
                    return $translate.instant("editorBtn.bodySeg");
                    break;
                default:
                    return $translate.instant("editorBtn.originalPainting");
            }
        }

        var dragGal = {};
        var drag = false;
        var startChangeTimeout;
        vm.isSmallPic = false;
        window.startChange = function (e) {
            startChangeTimeout = setTimeout(function() {
                vm.isSmallPic = true;
                $scope.$digest();
            }, 200);
            drag = true;
            var i = e.target.dataset.imgindex;
            $scope.galleryArr = vm.photoAll[i];
            $scope.galleryChoose = vm.photoAll[i].identifier;
            if(vm.photoAll[i].largeFlag){
                $scope.galleryChoose = vm.photoAll[i].identifier + '.thumbnail.jpg';
            }

            $scope.galleryId = i;
            $scope.galleryX = e.changedTouches[0].clientX ? e.changedTouches[0].clientX - 53 : 0;
            $scope.galleryY = e.changedTouches[0].clientY ? e.changedTouches[0].clientY - 40 : 0;
            dragGal.clientX = e.changedTouches[0].clientX ? e.changedTouches[0].clientX : 0;
            dragGal.clientY = e.changedTouches[0].clientY ? e.changedTouches[0].clientY : 0;
            dragGal.pageX = e.changedTouches[0].pageX ? e.changedTouches[0].pageX : 0;
            dragGal.pageY = e.changedTouches[0].pageY ? e.changedTouches[0].pageY : 0;
            dragGal.coordX = $scope.galleryX;
            dragGal.coordY = $scope.galleryY;
            $scope.$digest();
            return false;
        };

        window.dragChange = function (e) {
            clearTimeout(startChangeTimeout);
            if (drag) {
                //手指离开屏幕
                $scope.galleryX = (dragGal.coordX + (e.changedTouches[0].clientX - dragGal.clientX));
                $scope.galleryY = (dragGal.coordY + (e.changedTouches[0].clientY - dragGal.clientY));

                // if (Math.abs($scope.galleryY - dragGal.coordY) > 10) {
                //     vm.isSmallPic = true;
                // }

                //向上滑动;
                if ($scope.galleryY <= 0) {
                    $scope.galleryY = 0;
                }
                //向左滑动;        <-----
                if ($scope.galleryX <= 0) {
                    $scope.galleryX = 0;
                }
                //向下滑动;
                if ($scope.galleryY >= $scope.dHeight - 62) {
                    $scope.galleryY = $scope.dHeight - 62;
                }
                // 向右滑动;    ---->
                if ($scope.galleryX >= $scope.dWidth - 62) {
                    $scope.galleryX = $scope.dWidth - 62;
                }

                var _picTop = $("#small-pic").offset().top;
                var _picLeft = $("#small-pic").offset().left;
                for (var i1 = 0; i1 < vm.pageData[vm.pageIndex].levels.level.length; i1++) {
                    var _level = vm.pageData[vm.pageIndex].levels.level[i1];
                    if (_level.imagebox) {
                        var _imageboxLeft = $(".imagebox" + i1).offset().left;
                        var _imageboxTop = $(".imagebox" + i1).offset().top;
                        var _imageboxRight = _imageboxLeft + $(".imagebox" + i1).width();
                        var _imageboxBottom = _imageboxTop + $(".imagebox" + i1).height();
                        if ((_imageboxTop < _picTop) && (_picTop < _imageboxBottom) && (_imageboxLeft < _picLeft) && (_picLeft < _imageboxRight)) {
                            $(".imagebox" + i1).find(".imageboxHint").css("background", "rgba(103, 106, 108, 0.8)")
                            break;
                        }else{
                            $(".imagebox" + i1).find(".imageboxHint").css("background", "rgba(0,0,0,0.2)")
                        }
                    }
                }
                $scope.$digest();
                return false;
            }
        };

        window.stopChange = function (e) {
            clearTimeout(startChangeTimeout);
            if (!drag) {
                return
            }
            drag = false;
            var _picTop = $("#small-pic").offset().top;
            var _picLeft = $("#small-pic").offset().left;
            for (var i1 = 0; i1 < vm.pageData[vm.pageIndex].levels.level.length; i1++) {
                var _level = vm.pageData[vm.pageIndex].levels.level[i1];
                if (_level.imagebox) {
                    var _imageboxLeft = $(".imagebox" + i1).offset().left;
                    var _imageboxTop = $(".imagebox" + i1).offset().top;
                    var _imageboxRight = _imageboxLeft + $(".imagebox" + i1).width();
                    var _imageboxBottom = _imageboxTop + $(".imagebox" + i1).height();
                    if ((_imageboxTop < _picTop) && (_picTop < _imageboxBottom) && (_imageboxLeft < _picLeft) && (_picLeft < _imageboxRight)) {
                        $scope.replaceImagebox1($scope.galleryArr, i1)
                        break;
                    }
                }
            }
            vm.isSmallPic = false;
            $scope.$digest();
        };


        $scope.addImageboxImg = function (item) {
            if(vm.isAddImagebox){
                imageboxAddFn(item)
            }else{
                if(vm.pageData[vm.pageIndex] && vm.pageData[vm.pageIndex].levels.level && vm.pageData[vm.pageIndex].levels.level[vm.levelIndex] && vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox){
                    replaceImagebox(item)
                }else{
                    for (var i = 0; i < vm.pageData[vm.pageIndex].levels.level.length; i++) {
                        var _level = vm.pageData[vm.pageIndex].levels.level[i];
                        if (_level.imagebox && _level.imagebox.image && !_level.imagebox.image.resource.identifier) {
                            vm.levelIndex = i;
                            replaceImagebox(item, function () {
                                vm.levelIndex = null;
                                vm.levelType = null;
                            })
                            break;
                        }
                    }
                }
            }
        };
        $scope.replaceImagebox1 = function (data, index) {
            vm.levelIndex = index;
            replaceImagebox(data)
        }

        function replaceImagebox(data, callback) {
            var item = angular.copy(data);
            var _imagebox = vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox;
            var identifier = _imagebox.mask.resource.identifier;
            // $.ajax({
            //     type: "GET",
            //     url: item.identifier + "?imageInfo",
            //     success: function (va) {
            //         var format = va.format.toLowerCase();
            //         if (format == 'heic') {
            //             swal({
            //                 title: "照片格式错误",
            //                 text: "请更换使用JPG格式图片添加至相框！",
            //                 timer: 2000,
            //                 showConfirmButton: false
            //             });
            //             return
            //         }

                    _imagebox.image = {
                        resource: {
                            identifier: item.identifier,
                            provider: 'qiniu'
                        },
                        resourceid:item.sourceId,
                        filterResource: {
                            identifier: '',
                            provider: 'qiniu'
                        },
                        imageInfo:item.imageInfo,
                        width: item.width,
                        height: item.height,
                        imgSize: item.imgSize,
                        index: item.seq,
                        parameter: angular.fromJson(item.parameter),
                        scale: 1,
                        angle: 0,
                        largeFlag: item.largeFlag,
                        largeStatus: item.largeStatus,
                        convertFlag: item.convertFlag,
                        convertStatus: item.convertStatus,
                        stripKey: item.stripKey,
                        thumbnailKey: item.thumbnailKey
                    }
                    addImagebox($http, _imagebox, function () {
                        imageSelectInit();
                        warnIcon();
                        thumbnailInit();
                            if(callback){callback()}
                    });
            //     }
            // });
        }

        function imageSelectInit() {
            vm.photoSelectAll = [];
            for (var i = 0; i < vm.pageData.length; i++) {
                for (var j = 0; j < vm.pageData[i].levels.level.length; j++) {
                    var _level = vm.pageData[i].levels.level[j];
                    if (_level.imagebox) {
                        for (var k = 0; k < vm.photoAll.length; k++) {
                            if (_level.imagebox.image && _level.imagebox.image.resource && _level.imagebox.image.resource.identifier == vm.photoAll[k].identifier) {
                                vm.photoSelectAll.push(vm.photoAll[k]);
                                break
                            }
                        }
                    }
                }
            }
        }

        // 图库照片处理状态：大图处理中/失败、色彩转换中/失败，无特殊状态返回''（正常展示照片）
        $scope.photoStatus = function (photo) {
            if (!photo) return '';
            if (photo.convertFlag == true && photo.convertStatus == 'running') return 'convertRunning';
            if (photo.convertStatus == 'error') return 'convertError';
            if (photo.largeFlag && photo.largeStatus == 'running') return 'largeRunning';
            if (photo.largeFlag && photo.largeStatus == 'error') return 'largeError';
            return '';
        };
        // 是否处理失败状态（大图处理失败、色彩转换失败）
        $scope.isPhotoFailed = function (photo) {
            var status = $scope.photoStatus(photo);
            return status === 'largeError' || status === 'convertError';
        };
        // 处理中的照片不可选中/添加到图片框，处理失败的照片点击弹出删除确认框
        $scope.onPhotoStatusClick = function (photo, event) {
            if (event) {
                event.stopPropagation();
            }
            if ($scope.isPhotoFailed(photo)) {
                vm.pendingDeletePhoto = photo;
                vm.deletePhotoSure = true;
            }
        };
        // 确认删除处理失败的照片，取消则仅关闭弹框
        $scope.deletePhotoConfirm = function () {
            var photo = vm.pendingDeletePhoto;
            if (!photo || !photo.id) {
                vm.deletePhotoSure = false;
                vm.pendingDeletePhoto = null;
                return;
            }
            var id = photo.id;
            Gallery.batchDelete([id], function () {
                MessageService.success($translate.instant('nav.photograph.content.deletePhoto.success'));
                // 清除图片框中引用该照片的图片
                if (vm.pageData && vm.pageData.length) {
                    angular.forEach(vm.pageData, function (page) {
                        if (page && page.levels && page.levels.level) {
                            angular.forEach(page.levels.level, function (level) {
                                if (level.imagebox && level.imagebox.image &&
                                    (level.imagebox.image.resourceid == id ||
                                    (photo.sourceId != null && level.imagebox.image.resourceid == photo.sourceId))) {
                                    level.imagebox.image = {
                                        resource: {
                                            identifier: '',
                                            provider: ''
                                        },
                                        filterResource: {
                                            identifier: '',
                                            provider: ''
                                        },
                                        offsetx: 0,
                                        offsety: 0,
                                        width: '',
                                        height: '',
                                        imgsize: '',
                                        index: '',
                                        parameter: [],
                                        scale: 1,
                                        angle: 0
                                    };
                                }
                            });
                        }
                    });
                }
                // 从本地图库列表及已选集合中移除
                var removeFromList = function (list) {
                    if (!list || !list.length) return;
                    for (var i = list.length - 1; i >= 0; i--) {
                        if (list[i].id === id) {
                            list.splice(i, 1);
                        }
                    }
                };
                removeFromList(vm.photoAll);
                removeFromList(vm.photoSelectAll);
                imageSelectInit();
                vm.deletePhotoSure = false;
                vm.pendingDeletePhoto = null;
            }, function () {
                vm.deletePhotoSure = false;
                vm.pendingDeletePhoto = null;
                MessageService.error($translate.instant('nav.photograph.content.deletePhoto.failed'));
            });
        };

        // 子组件点击处理失败的照片时emit此事件，由父级弹出删除确认框
        $scope.$on('requestDeletePhoto', function (event, photo) {
            if (photo && $scope.isPhotoFailed(photo)) {
                vm.pendingDeletePhoto = photo;
                vm.deletePhotoSure = true;
            }
        });


        //保存
        function articleOverdue(callback){
            Article.get({id: vm.article.id}, function (article) {
                if(article.data.fileName != vm.article.fileName){
                    MessageService.minConfirm({
                        cancel:$translate.instant("button.cancel"),
                        confirm:$translate.instant("button.refresh"),
                        msg:$translate.instant("hint.articleOverdue")
                    },function(){
                        $state.go("product-choosesThree-ec", {storeId: vm.storeId, aid:  vm.article.id},{reload:true,location: 'replace'});
                    })
                }else{
                    callback();
                }
            })
        }
        $scope.isSave = false;
        vm.isDocumentTextDetection = false;
        $scope.save = function () {
            articleOverdue(function () {
                if ($scope.isSave) {
                    return;
                }
                var _documentTextDetection = documentTextDetection1($scope.template.pages.page);
                if(!_documentTextDetection.pass){
                    vm.isDocumentTextDetection = true;
                    vm.documentTextDetection = _documentTextDetection.pages;
                    return;
                }
                if ($scope.template.pages.page.length < $scope.PAGELEN) {
                    SweetAlert.swal({
                        title: $translate.instant("editorCommon.loadTemplate"),
                        imageUrl: Theme.sweetHintImg(),
                        text: "",
                        timer: 2000,
                        showConfirmButton: false
                    });
                    return
                }

                if (vm.article.ordered) {
                    SweetAlert.swal({
                        title: $translate.instant("font.warmPrompt"),
                        imageUrl: Theme.sweetHintImg(),
                        text: $translate.instant("editorCommon.newWork"),
                        timer: 2000,
                        showConfirmButton: false
                    });
                }
                //判断是否有图片未上传  且是否继续保存
                if (!$scope.isContinue()) {
                    // vm.completed = false;
                    SweetAlert.swal({
                        title: $translate.instant("editorCommon.saveSure"),
                        imageUrl: Theme.sweetHintImg(),
                        showCancelButton: true,
                        confirmButtonText: $translate.instant("button.confirm"),
                        cancelButtonText: $translate.instant("button.cancel"),
                        closeOnConfirm: true,
                        closeOnCancel: true
                    }, function (isConfirm) {
                        if (isConfirm) {
                            $timeout(function () {
                                generateJsonFile();
                            }, 500);
                            return;
                        }
                    })
                } else {
                    // vm.completed = true;
                    generateJsonFile();
                }
            })
        }

        function generateJsonFile() {
            $scope.isSave = true;
            vm.threeLoading = true;
            vm.threeLoadingText=$translate.instant("hint.loadingText");
            thumbnailInit(function () {
                thumbnailInit1(function () {
                    thumbnailInit2($scope.template.pages.page[vm.pageIndex],function(){
                        var template = saveData();
                        template.hostinfo = hostInfo();
                        Convert.articleUploadDocument(template, function (res) {
                            vm.article.articleStatus = vm.completed;
                            vm.article.fileName = res.data.identifier;
                            vm.article.id = vm.aid;
                            vm.article.pageCount = $scope.template.pages.page.length;
                            vm.article.saveUserName = localStorage.getItem('saveUserName') || ''
                            Article.update(vm.article, function (resp) {
                                $scope.isSave = false;
                                vm.threeLoading = false;
                                swal({
                                    title: $translate.instant("editorCommon.modifySuccess"),
                                    text: $translate.instant("editorCommon.synchronizationOfWorks"),
                                    imageUrl: Theme.sweetSuccedImg(),
                                    timer: 2000,
                                    showConfirmButton: false
                                });
                                $state.go("product-view5-ec", {storeId: vm.storeId, aid: resp.data.id}, {reload: true,location: 'replace'});
                            }, function () {
                                $scope.isSave = false;
                                vm.threeLoading = false;
                                swal({
                                    title: $translate.instant("editorCommon.saveError"),
                                    text: $translate.instant("editorCommon.saveError1"),
                                    imageUrl: Theme.sweetHintImg(),
                                    timer: 2000,
                                    showConfirmButton: false
                                });
                            })
                        }, function () {
                            $scope.isSave = false;
                            vm.threeLoading = false;
                            swal({
                                title: $translate.instant("editorCommon.saveError"),
                                text: $translate.instant("editorCommon.saveError1"),
                                imageUrl: Theme.sweetHintImg(),
                                timer: 2000,
                                showConfirmButton: false
                            });
                        })
                    })
                })
            })
            localStorage.removeItem("photoSelectAll");
        }

        $scope.isContinue = function () {
            var hasEmpty = true;
            for (var i = 0; i < $scope.template.pages.page.length; i++) {
                var _page = $scope.template.pages.page[i];
                if (_page.levels.level) {
                    for (var j = 0; j < _page.levels.level.length; j++) {
                        var _level = _page.levels.level[j];
                        if (_level.imagebox) {
                            if (!_level.imagebox.image || !_level.imagebox.image.resource || !_level.imagebox.image.resource.identifier) {
                                hasEmpty = false;
                            }
                        }
                    }
                }
            }
            vm.completed = hasEmpty ? 'COMPLETED' : 'EDITING';
            return hasEmpty;
        };

        function saveData() {
            var _template = angular.copy($scope.template);
            angular.forEach(_template.pages.page, function (page, index) {
                page.editbox = {
                    width: transitionMm(page.editbox.width),
                    height: transitionMm(page.editbox.height),
                    x: transitionMm(page.editbox.x),
                    y: transitionMm(page.editbox.y)
                };
                if(page.editboxes && page.editboxes.editbox){
                    page.editboxes.editbox.forEach(function (editbox, editboxIndex) {
                        page.editboxes.editbox[editboxIndex] = {
                            width: transitionMm(editbox.width),
                            height: transitionMm(editbox.height),
                            x: transitionMm(editbox.x),
                            y: transitionMm(editbox.y)
                        }
                    })
                }
                page.mediabox = {
                    width: transitionMm(page.mediabox.width),
                    height: transitionMm(page.mediabox.height),
                    x: transitionMm(page.mediabox.x),
                    y: transitionMm(page.mediabox.y)
                };
                page.trimbox = {
                    width: transitionMm(page.trimbox.width),
                    height: transitionMm(page.trimbox.height),
                    x: transitionMm(page.trimbox.x),
                    y: transitionMm(page.trimbox.y)
                };
                page.custom = {};
                if (page.scene) {
                    page.scene.geometry = {
                        width: transitionMm(page.scene.geometry.width),
                        height: transitionMm(page.scene.geometry.height),
                        x: transitionMm(page.scene.geometry.x),
                        y: transitionMm(page.scene.geometry.y)
                    };
                    page.scene.imagebox.geometry = {
                        width: transitionMm(page.scene.imagebox.geometry.width),
                        height: transitionMm(page.scene.imagebox.geometry.height),
                        x: transitionMm(page.scene.imagebox.geometry.x),
                        y: transitionMm(page.scene.imagebox.geometry.y)
                    };
                }
                //条形码
                if (page.barcode) {
                    page.barcode.geometry = {
                        width: transitionMm(page.barcode.geometry.width),
                        height: transitionMm(page.barcode.geometry.height),
                        x: transitionMm(page.barcode.geometry.x),
                        y: transitionMm(page.barcode.geometry.y)
                    };
                }
                if (page.qrcode) {
                    page.qrcode.geometry = {
                        width: transitionMm(page.qrcode.geometry.width),
                        height: transitionMm(page.qrcode.geometry.height),
                        x: transitionMm(page.qrcode.geometry.x),
                        y: transitionMm(page.qrcode.geometry.y)
                    };
                }

                //背景
                if (page.background.resource.identifier) {
                    page.background.offsetx = transitionMm(page.background.offsetx);
                    page.background.offsety = transitionMm(page.background.offsety);
                }
                angular.forEach(page.levels.level, function (level, i) {
                    if (level.imageart) {
                        level.imageart.rotation.angle = -level.imageart.rotation.angle;
                        level.imageart.offsetx = transitionMm(level.imageart.offsetx);
                        level.imageart.offsety = transitionMm(level.imageart.offsety);
                        level.imageart.width = transitionMm(level.imageart.width);
                        level.imageart.height = transitionMm(level.imageart.height);
                        level.imageart.geometry = {
                            width: transitionMm(level.imageart.geometry.width),
                            height: transitionMm(level.imageart.geometry.height),
                            x: transitionMm(level.imageart.geometry.x),
                            y: transitionMm(level.imageart.geometry.y)
                        };
                    }
                    if (level.imagebox) {
                        level.imagebox.rotation.angle = -level.imagebox.rotation.angle;
                        level.imagebox.geometry = {
                            width: transitionMm(level.imagebox.geometry.width),
                            height: transitionMm(level.imagebox.geometry.height),
                            x: transitionMm(level.imagebox.geometry.x),
                            y: transitionMm(level.imagebox.geometry.y)
                        };
                        if (level.imagebox.blurredrectangle) {
                            level.imagebox.blurredrectangle = {
                                width: transitionMm(level.imagebox.blurredrectangle.width),
                                height: transitionMm(level.imagebox.blurredrectangle.height),
                                x: transitionMm(level.imagebox.blurredrectangle.x),
                                y: transitionMm(level.imagebox.blurredrectangle.y)
                            };
                        }
                        if (level.imagebox.image) {
                            level.imagebox.image.width = transitionMm(level.imagebox.image.width);
                            level.imagebox.image.height = transitionMm(level.imagebox.image.height);
                            level.imagebox.image.offsetx = transitionMm(level.imagebox.image.offsetx);
                            level.imagebox.image.offsety = transitionMm(level.imagebox.image.offsety);
                        }
                    }
                    if (level.textbox) {
                        if (!(level.textbox.text == '' || level.textbox.text == null || level.textbox.text == $translate.instant("editorCommon.describe29") || level.textbox.text == '双击输入文字' || level.textbox.text == '请输入文字') && (level.textbox.geometry.width != 0 && level.textbox.geometry.height != 0)) {
                            level.textbox.rotation.angle = -level.textbox.rotation.angle;
                            level.textbox.geometry = {
                                width: transitionMm(level.textbox.geometry.width),
                                height: transitionMm(level.textbox.geometry.height),
                                x: transitionMm(level.textbox.geometry.x),
                                y: transitionMm(level.textbox.geometry.y)
                            };
                        }else{
                            level.textbox = null;
                        }
                    }
                    if (level.textdocument && level.textdocument.geometry) {
                        level.textdocument.rotation.angle = -level.textdocument.rotation.angle;
                        level.textdocument.geometry = {
                            width: transitionMm(level.textdocument.geometry.width),
                            height: transitionMm(level.textdocument.geometry.height),
                            x: transitionMm(level.textdocument.geometry.x),
                            y: transitionMm(level.textdocument.geometry.y)
                        };

                        var backg = level.textdocument.background;
                        if (backg.resource.identifier) {
                            backg.offsetx = transitionMm(backg.offsetx);
                            backg.offsety = transitionMm(backg.offsety);
                        }

                        angular.forEach(level.textdocument.levels.level, function (lev, l) {
                            if (lev.imageart && lev.imageart.geometry) {
                                var art = lev.imageart;
                                art.geometry = {
                                    width: transitionMm(art.geometry.width),
                                    height: transitionMm(art.geometry.height),
                                    x: transitionMm(art.geometry.x),
                                    y: transitionMm(art.geometry.y)
                                };
                                art.offsetx = transitionMm(art.offsetx);
                                art.offsety = transitionMm(art.offsety);
                            }
                            if (lev.textbox && lev.textbox.geometry) {
                                var text = lev.textbox;
                                text.geometry = {
                                    width: transitionMm(text.geometry.width),
                                    height: transitionMm(text.geometry.height),
                                    x: transitionMm(text.geometry.x),
                                    y: transitionMm(text.geometry.y)
                                };
                            }
                        })
                    }
                })
            })
            _template.version= '3.0';
            return _template;
        }

        function fn($event) {
            var $event = $event || window.event;
            if ($event && $event.preventDefault) {
                $event.preventDefault();
            } else {
                window.event.returnValue = false;
                return false;
            }
            $event.stopPropagation();
        }

        $scope.threeModalHide = function () {
            vm.threeIsModal = false;
            vm.threeModalText = "";
            vm.threeIsModal1 = false;
            vm.threeModalText1 = "";
        }
        $scope.threeModalSave = function () {
            vm.threeIsModal = false;
            vm.threeModalText = "";
            vm.threeIsModal1 = false;
            vm.threeModalText1 = "";
            templateReplace();
        }

        //生成缩略图
        vm.isHtml2canvas = false;
        vm.isThreeView3d1 = false;
        vm.isThreeView3d = true;
        vm.threeView3dW=110;
        vm.threeView3dH=110;
        vm.pageData1 = [];
        vm.threeView3d={
            top: 50,
            right: 5
        }
        $scope.threeView3d1Cb = function () {
            vm.isThreeView3d1=true;
            // vm.threeView3dW=$(window).width();
            // vm.threeView3dH=400;
        }
        $scope.threeView3d1CbHide = function () {
            vm.isThreeView3d1=false;
            // vm.threeView3dW=110;
            // vm.threeView3dH=110;
        }


        var a = null;
        vm.thumbnailInit = thumbnailInit;
        function thumbnailInit(callback) {
            if (vm.productXmlData && vm.productXmlData.modelType === 'THREE') {
                vm.thumbnailPageData = angular.copy(vm.pageData[vm.pageIndex]);
                pageTrimbox(vm.thumbnailPageData, $translate.instant("editorCommon.describe29"))
                if (a !== null) {
                    clearTimeout(a)
                }
                a = setTimeout(function() {
                    $timeout(function () {
                        html2canvas_adapt(document.getElementById('thumbnail-view'), {
                            onrendered: function (canvas) {
                                if(canvas){
                                    QiniuToken.uploadThumbnail(canvas, function (data) {
                                        vm.pageData[vm.pageIndex].pagecover = {
                                            identifier: $scope.domain + data.key,
                                            provider: 'qiniu'
                                        }
                                        vm.isHtml2canvas = true;
                                        vm.pageData1 = angular.copy(vm.pageData);
                                        if(callback){callback()}
                                    }, function () {
                                        if (callback) {callback()};
                                    });
                                }else{
                                    if (callback) {callback()};
                                }
                            },
                            error:function(){
                                if (callback) {callback()};
                            },
                            letterRendering: true,
                            useCORS: true,
                            width: vm.thumbnailPageData.mediabox.width*vm.thumbnailPageData.custom.thumbnailScale,
                            height: vm.thumbnailPageData.mediabox.height*vm.thumbnailPageData.custom.thumbnailScale,
                            windowWidth: document.body.scrollWidth,
                            windowHeight: document.body.scrollHeight,
                            x: 0,
                            y: 0,
                            backgroundColor: "rgba(0, 0, 0, 0)"
                        });
                    },1000)
                }, 3000)
            }else{
                if(callback){callback()}
            }
        }
        //生成封面图
        function thumbnailInit1(callback) {
            vm.thumbnailPageData1 = angular.copy(vm.pageData[0]);
            pageTrimbox(vm.thumbnailPageData1, $translate.instant("editorCommon.describe29"))
            $timeout(function (){
                html2canvas_adapt(document.getElementById('thumbnail-view1'), {
                    onrendered: function (canvas) {
                        if(canvas){
                            QiniuToken.uploadThumbnail(canvas, function (data) {
                                vm.article.covered=true;
                                vm.article.cover=data.key;
                                if(callback){callback()};
                            }, function () {
                                vm.article.covered=false;
                                vm.article.cover=null;
                                if (callback) {callback()};
                            });
                        }else{
                            vm.article.covered=false;
                            vm.article.cover=null;
                            if (callback) {callback()};
                        }
                    },
                    error:function(){
                        vm.article.covered=false;
                        vm.article.cover=null;
                        if (callback) {callback()};
                    },
                    letterRendering: true,
                    useCORS: true,
                    width: vm.thumbnailPageData1.mediabox.width*vm.thumbnailPageData1.custom.thumbnailScale,
                    height: vm.thumbnailPageData1.mediabox.height*vm.thumbnailPageData1.custom.thumbnailScale,
                    windowWidth: document.body.scrollWidth,
                    windowHeight: document.body.scrollHeight,
                    x: 0,
                    y: 0,
                    backgroundColor: "rgba(0, 0, 0, 0)"
                });
            },1000);
        }
        //生成封面图
        function thumbnailInit2(page,callback) {
            if(!page.scene || !page.scene.geometry){
                callback()
                return
            }
            vm.threeLoading = true;
            vm.threeLoadingText = "";
            vm.thumbnailPageData = angular.copy(page);
            $timeout(function (){
                html2canvas_adapt(document.getElementById('thumbnail-view'), {
                    onrendered: function (canvas) {
                        QiniuToken.uploadThumbnail(canvas, function (data) {
                            vm.threeLoading = false;
                            page.pagecover = {
                                identifier: $scope.domain + data.key,
                                provider: 'qiniu'
                            }
                            vm.thumbnailPageData = null;
                            callback()
                        });
                    },
                    letterRendering: true,
                    useCORS: true,
                    width: vm.thumbnailPageData.custom.width*vm.thumbnailPageData.custom.thumbnailScale,
                    height: vm.thumbnailPageData.custom.height*vm.thumbnailPageData.custom.thumbnailScale,
                    windowWidth: document.body.scrollWidth,
                    windowHeight: document.body.scrollHeight,
                    x: 0,
                    y: 0,
                    backgroundColor: "rgba(0, 0, 0, 0)"
                });
            },1000)
        }

        window.threeView3dStart = function (e) {
            fn(e);
            vm.threeView3d1 = angular.copy(vm.threeView3d);
            vm.threeView3d1.x = e.changedTouches[0].clientX != null ? e.changedTouches[0].clientX: 0;          //鼠标到页面左边的距离
            vm.threeView3d1.y = e.changedTouches[0].clientY != null ? e.changedTouches[0].clientY: 0;           //鼠标到页面顶部的距离
            $scope.$digest();
        };
        window.threeView3dOn = function (e) {
            fn(e);
            $timeout(function () {
                var nx = e.changedTouches[0].clientX != null ? e.changedTouches[0].clientX: 0;
                var ny = e.changedTouches[0].clientY != null ? e.changedTouches[0].clientY: 0;
                //计算移动后的左偏移量和顶部的偏移量
                var nl = nx - vm.threeView3d1.x;
                var nt = ny - vm.threeView3d1.y;
                vm.threeView3d.right = vm.threeView3d1.right - nl;
                vm.threeView3d.top = vm.threeView3d1.top + nt;
            })
        }
        //像素不足提醒
        vm.imgSize = 150;
        vm.imgDpi = 150;
        StoreWorkEditConfig.storeId({storeId: vm.storeId}, function (res) {
            if(res.status == 200){
                vm.imgSize = res.data.imgSize;
                vm.imgDpi = res.data.imgDpi;
            }
        });

        /* -------------------------------------  涂鸦  ----------------------------------------*/
        vm.isGraffiti = false;
        vm.oldGraffitiMagnify = false;
        $scope.graffitiCb = function () {
            // vm.oldGraffitiMagnify = vm.isEditboxMagnify;
            // if(!vm.isEditboxMagnify){
            //     $scope.editboxMagnify();
            // }
            vm.isGraffiti = true;
            canvasInit()
        };

        //涂鸦
        vm.graffitiColors = ["#000000", "#E0E0E0", "#FFFFFF", "#FFF0F6", "#FFD6E7", "#EFDBFF", "#FF85C0", "#FF7875", "#D46B08", "#FFC069", "#FADB14", "#FFF566", "#D9F7BE", "#95DE64", "#87E8DE", "#096DD9", "#BAE7FF", "#B37FEB", "#722ED1"];
        vm.graffitiColor = '#000000';
        vm.graffitiPage = 1;

        window.graffitiPenChen = function (e) {
            var val = $('#graffitiPen').val();
            vm.graffitiPen = parseInt(val);
            console.log(vm.graffitiPen)
        }

        $scope.graffitiColorSet = function(item){
            vm.graffitiColor = item;
        }
        $scope.graffitiHide = function () {
            vm.isGraffiti = false;
        }
        $scope.graffitiSave = function () {
            vm.isGraffiti = false;
            if(vm.step>-1){
                var canvas = document.getElementById('graffitiCanvas');
                var url = canvas.toDataURL('image/png');
                clearImageEdgeBlank(url, 0, function (img, x, y) {
                    QiniuToken.uploadThumbnail(img, function (data) {
                        var imageart = {
                            resource:{
                                identifier: $scope.domain + data.key
                            }
                        }
                        imageartAdd($http, imageart.resource.identifier, vm.pageData[vm.pageIndex].trimbox, function(imageart){
                            if(vm.pageData[vm.pageIndex].scene){
                                x -= vm.pageData[vm.pageIndex].scene.imagebox.geometry.x * vm.pageData[vm.pageIndex].custom.ratio1;
                                y -= vm.pageData[vm.pageIndex].scene.imagebox.geometry.y * vm.pageData[vm.pageIndex].custom.ratio1;
                            }
                            imageart.geometry.x = x / vm.pageData[vm.pageIndex].custom.ratio1;
                            imageart.geometry.y = y / vm.pageData[vm.pageIndex].custom.ratio1;
                            var _level = {
                                seq: vm.pageData[vm.pageIndex].levels.level.length + 1,
                                imageart: imageart
                            }
                            vm.pageData[vm.pageIndex].levels.level.push(_level);
                            // if(!vm.oldGraffitiMagnify){
                            //     $scope.editboxMagnify();
                            // }
                            thumbnailInit();
                        }, vm.pageData[vm.pageIndex].custom.ratio1, true)
                    });
                })
            }
        }
        function clearImageEdgeBlank(url, padding, callback) {
            // create canvas
            var canvas = document.createElement("canvas");
            var ctx = canvas.getContext("2d");

            // create image
            var image = new Image();
            image.onload = draw;
            image.src = url;
            image.crossOrigin = "Anonymous";

            function draw() {
                canvas.width = image.width;
                canvas.height = image.height;
                ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
                var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                var data = imageData.data;
                var width = imageData.width;
                var height = imageData.height;
                // var width = imageData;
                // var height = imageData;
                // 裁剪需要的起点和终点,初始值为画布左上和右下点互换设置成极限值。
                var startX = width,
                    startY = height,
                    endX = 0,
                    endY = 0;
                /*
                col为列，row为行，两层循环构造每一个网格，
                便利所有网格的像素，如果有色彩则设置裁剪的起点和终点
                */
                for (var col = 0; col < width; col++) {
                    for (var row = 0; row < height; row++) {
                        // 网格索引
                        var pxStartIndex = (row * width + col) * 4;

                        // 网格的实际像素RGBA
                        var pxData = {
                            r: data[pxStartIndex],
                            g: data[pxStartIndex + 1],
                            b: data[pxStartIndex + 2],
                            a: data[pxStartIndex + 3]
                        };

                        // 存在色彩：不透明
                        var colorExist = pxData.a !== 0;

                        /*
                        如果当前像素点有色彩
                        startX坐标取当前col和startX的最小值
                        endX坐标取当前col和endX的最大值
                        startY坐标取当前row和startY的最小值
                        endY坐标取当前row和endY的最大值
                        */
                        if (colorExist) {
                            startX = Math.min(col, startX);
                            endX = Math.max(col, startX);
                            startY = Math.min(row, startY);
                            endY = Math.max(row, endY);
                        }
                    }
                }

                // 右下坐标需要扩展1px,才能完整的截取到图像
                endX += 1;
                endY += 1;

                // 加上padding
                startX -= padding;
                startY -= padding;
                endX += padding;
                endY += padding;

                // 根据计算的起点终点进行裁剪
                var cropCanvas = document.createElement("canvas");
                var cropCtx = cropCanvas.getContext("2d");
                cropCanvas.width = endX - startX;
                cropCanvas.height = endY - startY;
                cropCtx.drawImage(
                    image,
                    startX,
                    startY,
                    cropCanvas.width,
                    cropCanvas.height,
                    0,
                    0,
                    cropCanvas.width,
                    cropCanvas.height
                );

                // rosolve裁剪后的图像字符串
                callback(cropCanvas.toDataURL(), startX, startY);
            }
        }
        $scope.graffitiRetreat = function () {
            if (vm.step >= 0) {
                $timeout(function () {
                    var canvas = document.getElementById('graffitiCanvas');
                    vm.step--;
                    vm.canvasHistory = vm.canvasHistory.slice(0,-1);
                    vm.context.clearRect(0, 0, canvas.width, canvas.height);
                    if(vm.canvasHistory[vm.step]){
                        vm.context.putImageData(vm.canvasHistory[vm.step], 0, 0)
                    }
                })
            }
        }

        vm.canvasHistory = [];
        function canvasInit() {
            $timeout(function () {
                var canvas = document.getElementById('graffitiCanvas');
                vm.context = canvas.getContext('2d');
                canvas.width = vm.pageData[vm.pageIndex].custom.width * vm.pageData[vm.pageIndex].custom.ratio1;
                canvas.height = vm.pageData[vm.pageIndex].custom.height * vm.pageData[vm.pageIndex].custom.ratio1;
                vm.graffitiPen = 3;
                vm.canvasHistory = [];
                vm.step = -1;
                vm.eraserEnabled = false;
                listenToMouse(canvas);
            })
        }
        function drawLine(x1, y1, x2, y2) {
            vm.context.beginPath();
            vm.context.strokeStyle = vm.graffitiColor;
            vm.context.lineCap="round";
            vm.context.moveTo(x1, y1) // 起点
            vm.context.lineWidth = vm.graffitiPen;
            vm.context.lineTo(x2, y2) // 终点
            vm.context.stroke();
            vm.context.closePath()
        }
        function listenToMouse(canvas) {
            var using1 = false;
            var lastPoint = {
                x: undefined,
                y: undefined
            };
            // 特性检测
            canvas.addEventListener("touchstart",function(aaa) {
                fn(aaa);
                $timeout(function () {
                    vm.graffitiPage = 1;
                    var x = aaa.targetTouches[0].pageX - (vm.windowWidth - vm.pageData[vm.pageIndex].custom.width * vm.pageData[vm.pageIndex].custom.ratio1) / 2;
                    var y = aaa.targetTouches[0].pageY - ((vm.windowHeight - vm.pageData[vm.pageIndex].custom.height * vm.pageData[vm.pageIndex].custom.ratio1) / 2 + 50);
                    using1 = true
                    if (vm.eraserEnabled) {
                        vm.context.clearRect(x - 5, y - 5, 10, 10)
                    } else {
                        lastPoint = {
                            "x": x,
                            "y": y
                        }
                    }
                })
            })
            canvas.addEventListener("touchmove",function(aaa){
                fn(aaa);
                var x = aaa.changedTouches[0].pageX - (vm.windowWidth - vm.pageData[vm.pageIndex].custom.width * vm.pageData[vm.pageIndex].custom.ratio1) / 2;
                var y = aaa.changedTouches[0].pageY - ((vm.windowHeight - vm.pageData[vm.pageIndex].custom.height * vm.pageData[vm.pageIndex].custom.ratio1) / 2 + 50);
                if (!using1) {
                    return
                }
                if (vm.eraserEnabled) {
                    vm.context.clearRect(x - 5, y - 5, 10, 10)
                } else {
                    var newPoint = {
                        "x": x,
                        "y": y
                    }
                    drawLine(lastPoint.x, lastPoint.y, newPoint.x, newPoint.y)
                    lastPoint = newPoint
                }
            })
            canvas.addEventListener("touchend",function(event){
                fn(event);
                using1 = false
                vm.step++;
                vm.canvasHistory.push(vm.context.getImageData(0, 0, canvas.width, canvas.height))
            })
        }
        //取色器
        $scope.graffitiPageCb = function (item) {
            vm.graffitiPage = 2;
            $timeout(function () {
                var width = document.body.clientWidth;
                var height = 200;
                var can = document.getElementById('ColorTip');
                var ctx = can.getContext('2d');
                var cur = document.getElementById('cur');
                var curColor = 'rgba(255,0,0,1)';
                can.width = width;
                can.height = 200;
                colorBar();
                colorBox(curColor);
                bind();
                /**
                 *  绘制左边颜色条
                 *  用createLinearGradient命令创建一个gradientBar对象 然后给gradientBar对象填充颜色就行了
                 *  这里从默色(红)开始渐变到红结束
                 */
                function colorBar() {
                    var gradientBar = ctx.createLinearGradient(0, 0, 0, height);
                    gradientBar.addColorStop(0, '#f00');
                    gradientBar.addColorStop(1 / 6, '#f0f');
                    gradientBar.addColorStop(2 / 6, '#00f');
                    gradientBar.addColorStop(3 / 6, '#0ff');
                    gradientBar.addColorStop(4 / 6, '#0f0');
                    gradientBar.addColorStop(5 / 6, '#ff0');
                    gradientBar.addColorStop(1, '#f00');

                    ctx.fillStyle = gradientBar;
                    //绘制出去 x y height width
                    ctx.fillRect(0, 0, 20, height);
                }

                function rgb2hex(rgb) {
                    var aRgb = rgb instanceof Array ? rgb : (rgb.split(',') || [0, 0, 0]);
                    var temp;
                    return [
                        (temp = Number(aRgb[0]).toString(16)).length == 1 ? ('0' + temp) : temp,
                        (temp = Number(aRgb[1]).toString(16)).length == 1 ? ('0' + temp) : temp,
                        (temp = Number(aRgb[2]).toString(16)).length == 1 ? ('0' + temp) : temp,
                    ].join('');
                }

                function hex2rgb(hex) {
                    if (hex.length == 3) {
                        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
                    }
                    return [
                        parseInt(hex[0] + hex[1], 16),
                        parseInt(hex[2] + hex[3], 16),
                        parseInt(hex[4] + hex[5], 16),
                    ].join();
                }

                function putCurDom(color) {
                    if (/([0-9a-f]{3}|[0-9a-f]{6})/i.test(color)) {
                        // hex
                        color = hex2rgb(color);
                    } else if (color instanceof Array) {
                        color = color.join(',');
                    } else if (/\d{1,3}(\,\d{1,3}){2}/i.test(color)) {

                    } else {
                        return;
                    }
                }

                /**
                 *  绘制颜色板块
                 *  addColorStop(stop, color) stop介于0于1之间 表示开始和结束的位置 color在stop的位置需要显示的颜色
                 *  这里画2个渐变对象
                 *      gradientBase从左到右开始渐变
                 *      my_gradient1从上到下开始渐变
                 *  然后让2个重叠在一起 只需要他们的绘画位置不同即可
                 *
                 * @param color 默认颜色(红)
                 */

                function colorBox(color) {
                    //这里x偏30 才能让左上角是白色
                    var gradientBase = ctx.createLinearGradient(30, 0, width + 30, 0);
                    gradientBase.addColorStop(0, 'rgba(255,255,255,1)');
                    gradientBase.addColorStop(1, color);
                    ctx.fillStyle = gradientBase;
                    //画偏30 别挡住颜色条
                    ctx.fillRect(30, 0, width, height);

                    var my_gradient1 = ctx.createLinearGradient(0, 0, 0, width);
                    my_gradient1.addColorStop(0, 'rgba(0,0,0,0)');
                    my_gradient1.addColorStop(1, 'rgba(0,0,0,1)');
                    ctx.fillStyle = my_gradient1;
                    ctx.fillRect(30, 0, width, height);
                }
                //绑定点击事件
                function bind() {
                    var rgbaStr = '#000';
                    can.addEventListener('click', function(e) {
                        var ePos = {
                            x: e.offsetX || e.layerX,
                            y: e.offsetY || e.layerY
                        }
                        if (ePos.x >= 0 && ePos.x < 20 && ePos.y >= 0 && ePos.y < width) {
                            // in
                            rgbaStr = getRgbaAtPoint(ePos, 'bar');
                            colorBox('rgba(' + rgbaStr + ')');
                        } else if (ePos.x >= 30 && ePos.x < 30 + width && ePos.y >= 0 && ePos.y < width) {
                            rgbaStr = getRgbaAtPoint(ePos, 'box');
                        } else {
                            return;
                        }
                        cur.style.left = ePos.x + 'px';
                        cur.style.top = ePos.y + 'px';
                        // cur.style.outlineColor = (rgbaStr[0] > 256 / 2 || rgbaStr[1] > 256 / 2 || rgbaStr[2] > 256 / 2) ? '#000' : '#fff';
                        outColor(rgbaStr);
                    });

                    can.addEventListener("touchmove",function(e){
                        var ePos = {
                            x: parseInt(e.touches[0].pageX),
                            y: parseInt(e.touches[0].pageY-$("#ColorTip").offset().top)
                        };
                        if (ePos.x >= 0 && ePos.x < 20 && ePos.y >= 0 && ePos.y < width) {
                            // in
                            rgbaStr = getRgbaAtPoint(ePos, 'bar');
                            colorBox('rgba(' + rgbaStr + ')');
                        } else if (ePos.x >= 30 && ePos.x < 30 + width && ePos.y >= 0 && ePos.y < width) {
                            rgbaStr = getRgbaAtPoint(ePos, 'box');
                        } else {
                            return;
                        }
                        cur.style.left = ePos.x + 'px';
                        cur.style.top = ePos.y + 'px';
                        // cur.style.outlineColor = (rgbaStr[0] > 256 / 2 || rgbaStr[1] > 256 / 2 || rgbaStr[2] > 256 / 2) ? '#000' : '#fff';
                        outColor(rgbaStr);
                    })
                    can.addEventListener("touchend",function(event){

                    })
                }

                function outColor(rgb) {
                    $timeout(function () {
                        vm.graffitiColor = RGB2Color(rgb[0], rgb[1], rgb[2]);
                    })
                }
                function getRgbaAtPoint(pos, area) {
                    if (area == 'bar') {
                        var imgData = ctx.getImageData(0, 0, 20, width);
                    } else {
                        var imgData = ctx.getImageData(0, 0, can.width, can.height);
                    }

                    var data = imgData.data;
                    var dataIndex = parseInt((pos.y * imgData.width + pos.x) * 4);
                    return [
                        data[dataIndex],
                        data[dataIndex + 1],
                        data[dataIndex + 2],
                        (data[dataIndex + 3] / 255).toFixed(2),
                    ];
                }
            })
        }

        //rgb转16进制
        function RGB2Color(r,g,b) {
            return '#' + byte2Hex(r) + byte2Hex(g) + byte2Hex(b);
        }
        function byte2Hex (n) {
            var nybHexString = "0123456789ABCDEF";
            return String(nybHexString.substr((n >> 4) & 0x0F,1)) + nybHexString.substr(n & 0x0F,1);
        }
        /* -------------------------------------  涂鸦end  ----------------------------------------*/
        $scope.$on('changeLanguage', function ($event,lang) {
            textStyleTabInit();
            getMessage();
            diyEditorSettingConstInit();
            vm.materialData=[];
            getThemeClassify();
            vm.fontList = [];
            productInit();
            if(vm.product.editorType == 'DIY_EDITOR'){
                if(vm.product.diyEditorSettingId){
                    getDiyEditorSetting();
                }else{
                    //获取所有字体
                    getAllFont();
                    diyEditorSettingInit()
                }
            }else{
                //获取所有字体
                getAllFont();
                diyEditorSettingInit()
            }

        });
        //部件名
        $scope.partName = function (partid) {
            if (!$scope.template||!$scope.template.config||!$scope.template.config.parts||!$scope.template.config.parts.list) {
                return
            }
            var partName = "";
            for(var i=0; i<$scope.template.config.parts.list.length; i++){
                if($scope.template.config.parts.list[i].id == partid){
                    partName = $scope.template.config.parts.list[i].name;
                }
            }
            return partName
        }
        // 抠图
        $scope.mattingOpen = function () {
            vm.imageboxCutout = {
                image: vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.resource.identifier,
                mattingMask: vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.mattingMask,
                resourceid: vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.resourceid,
                angle: vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.angle,
                flip: vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.flip,
            }
            vm.isShowImageCutout = true;
        };
        $scope.imageCutoutChange = function(text){
            if(text){
                vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.resource.identifier = text.result;
                vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.mattingMask = text.mattingMask;
                vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.angle = text.angle;
                vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.flip = text.flip;
            }
        }
        $scope.imageCutoutSave = function(text){
            vm.isShowImageCutout = false;
            if(text){
                vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.resource.identifier = text.result;
                vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.mattingMask = text.mattingMask;
                vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.angle = text.angle;
                vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.flip = text.flip;
            }
        }
        // 是否大图
        $scope.isLarge = function(imageInfo){
            if(!imageInfo)return
            return imageInfo.size >= 20971520 || imageInfo.width > 30000 || imageInfo.height > 30000 || (imageInfo.width*imageInfo.height)>150000000
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('editorApp')
        .controller('ProductNewEcController', ProductNewEcController);

    ProductNewEcController.$inject = ['$state', '$scope', '$q', '$stateParams', 'Convert', 'Qinius', 'QiniuToken', 'Gallery', 'ItemValue', 'SweetAlert', 'Theme', '$timeout', 'FontManagement', '$rootScope'
        , 'ImageService', 'ClipArt', 'PlatformWechatSetting', 'UidService', 'CommonService', '$http', 'Folder', 'MessageNotification', 'ThemeClassify', 'Article','ListService',
    'WxJS', 'StoreWorkEditConfig', '$translate', '$localStorage', 'IMAGE_SUPPORTED_MIME'];

    function ProductNewEcController($state, $scope, $q, $stateParams, Convert, Qinius, QiniuToken, Gallery, ItemValue, SweetAlert, Theme, $timeout, FontManagement, $rootScope
        , ImageService, ClipArt, PlatformWechatSetting, UidService, CommonService, $http, Folder, MessageNotification, ThemeClassify, Article, ListService,
                                    WxJS, StoreWorkEditConfig, $translate, $localStorage, IMAGE_SUPPORTED_MIME) {

        var vm = this;
        //阻止微信端长按赋值保存图片
        document.oncontextmenu = function (e) {
            e.preventDefault();
        };
        var variableDatas = JSON.parse(localStorage.getItem('variableData'));
        vm.variableTextDatas = [];
        vm.variableBoxDatas=[];
        console.log(variableDatas)
        $scope.agentIos = false;

        vm.windowDpiW = js_getDPI();

        //风格切换  引入不同的css文件
        Theme.judge();

        $(".navbar-gallery").hide();
        $(".wrap").show().addClass('no-margins');
        $(".well").css({'margin-bottom': 0});
        vm.storeId = $stateParams.storeId;
        vm.pid = $stateParams.pid;
        vm.aid = $stateParams.aid;
        vm.vid = $stateParams.vid;
        vm.xmlId = $stateParams.xmlId;
        vm.isEdit = vm.pid ? false : true;
        vm.pattern = 'BOOK';
        vm.replace = "true";
        $scope.dWidth = document.documentElement.clientWidth;
        $("body").css({width: $scope.dWidth, 'min-width': $scope.dWidth});
        $scope.status = localStorage.getItem('Production');

        vm.supportedMimeTypes = IMAGE_SUPPORTED_MIME;

        $scope.countN = parseInt(localStorage.getItem('countN'));
        var tt = localStorage.getItem('guide-step');
        if ($scope.status == 'make' && tt) {
            localStorage.setItem('countN', 8);
            $scope.countN = 8;
        } else {
            $scope.countN = parseInt(localStorage.getItem('countN'));
        }

        if (tt == 'true') {
            vm.guideStep = true;
        } else if (tt == 'false' || tt == '' || tt == null || tt == undefined) {
            vm.guideStep = false;
        }
        $scope.domains = Qinius.getDomain();
        var unsubQiniuToken = QiniuToken.subscribe('get', {}, function (token) {
            vm.token = token;
        });
        $scope.$on('$destroy', unsubQiniuToken);
        vm.platformSetting = PlatformWechatSetting.get();

        var monthStr = new Date().getMonth() + 1;
        var dayStr = new Date().getDate();
        var timestr = new Date().getFullYear() + "-" + (monthStr > 9 ? monthStr : "0" + monthStr) + "-" + (dayStr > 9 ? dayStr : "0" + dayStr);
        getMessageNotification();
        function getMessageNotification(){
           //工作区
            MessageNotification.getAllByCondition2({
                items: [
                    {key: "available", op: "=", value: "true"},
                    {key: "validate", op: ">=", value: timestr},
                    {key: "pageType", op: "=", value: "Gallery"}]
            }, function (res) {
                if(res.status == 200){
                    res.data.sort(compare('seq'))
                    vm.messageGallery = angular.copy(res.data);
                    vm.messageGalleryText = "\xa0\xa0\xa0\xa0\xa0\xa0";
                    angular.forEach(res.data, function (resp, i) {
                        vm.messageGalleryText += resp.content
                        if (i != res.data.length - 1) {
                            vm.messageGalleryText += "\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0"
                        }
                    })
                }else {
                    MessageService.error(res.message);
                }
            });
            // 平铺
            MessageNotification.getAllByCondition2({
                items: [
                    {key: "available", op: "=", value: "true"},
                    {key: "validate", op: ">=", value: timestr},
                    {key: "pageType", op: "=", value: "Tile"}]
            }, function (res) {
                if(res.status == 200){
                    res.data.sort(compare('seq'))
                    vm.messageTile = angular.copy(res.data);
                    vm.messageTileText = "\xa0\xa0\xa0\xa0\xa0\xa0";
                    angular.forEach(res.data, function (resp, i) {
                        vm.messageTileText += resp.content
                        if (i != res.data.length - 1) {
                            vm.messageTileText += "\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0"
                        }
                    })
                }else {
                    MessageService.error(res.message);
                }
            });
            //编辑
            MessageNotification.getAllByCondition2({
                items: [
                    {key: "available", op: "=", value: "true"},
                    {key: "validate", op: ">=", value: timestr},
                    {key: "pageType", op: "=", value: "Edit"}]
            }, function (res) {
                if(res.status == 200){
                    res.data.sort(compare('seq'))
                    vm.message = angular.copy(res.data);
                    vm.messageEdit = angular.copy(res.data);
                    vm.messageEditText = "\xa0\xa0\xa0\xa0\xa0\xa0";
                    angular.forEach(res.data, function (resp, i) {
                        vm.messageEditText += resp.content
                        if (i != res.data.length - 1) {
                            vm.messageEditText += "\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0"
                        }
                    })
                }else {
                    MessageService.error(res.message);
                }
            });
        }


        var url = window.location.hash && window.location.href.slice(0, -window.location.hash.length) || window.location.href;
        localStorage.setItem('url', url);

        vm.editHeight = document.documentElement.clientHeight;

        if (!window.__wxjs_is_wkwebview) {
            $scope.dHeight = vm.editHeight;
            // 禁止安卓默认事件
            var androidDefault = document.querySelector('.page-make');
            androidDefault.addEventListener('contextmenu', function (e) {
                e.preventDefault();
            });
        } else {
            $scope.dHeight = localStorage.getItem('windowMinH') || vm.editHeight;
        }

        var unitTransform = function (mm) {
            // mm换算成px  Math.ceil(mm / 25.4 * 300);
            // return (mm * 3) - 0;
            return mm / 25.4 * vm.windowDpiW;
        };
        var unitTransformPx = function (px) {
            // px换算成mm  Math.floor(px / 300 * 25.4)
            // return (px * 1 / 3).toFixed(2) - 0;
            return px / vm.windowDpiW * 25.4;
        };

        var $he = $(window).height() / 2;
        $('.arrowCircle-up').on('click', function (e) {
            e.preventDefault();
            var scrollTop = $(".edit-page-content").scrollTop();
            var cha = (scrollTop - $he) > 0 ? scrollTop - $he : 0;
            $(".edit-page-content").scrollTop(cha);
        });
        $('.arrowCircle-down').on('click', function (e) {
            e.preventDefault();
            var scrollTop = $(".edit-page-content").scrollTop();
            $(".edit-page-content").scrollTop(scrollTop + $he);
        });

        $scope.isSave = false;
        $rootScope.currentCarouselIndex = 0;
        $scope.selectSketchMenu = 'sketch-color';
        $scope.colorList = ['#ff001e', '#ff5c00', '#ff9700', '#61734d', '#838c97', '#8d4ac8', '#b8e986', '#7e6565', '#ffffff', '#f1e7d9', '#b5ce99', '#82c281', '#dac2ef', '#000', '#797979', '#7c330a', '#eec78d', '#444444', '#589ceb', '#4a7bc8', '#ddabab'];
        $scope.selectedColor = $scope.colorList[0];
        $scope.stickerList = [];
        $scope.selectedFont = '';
        $scope.domain = null;
        $scope.PAGELEN = 0;
        //底部模板栏，像素栏，图片栏高度:84+pading:8   =100
        $scope.mHeight = 84;
        //52+62+100 +20
        $scope.tHeight = 240;
        // 左移按钮
        $scope.visibleLeft = false;
        // 右移按钮
        $scope.visibleRight = false;
        // 编辑按钮
        $scope.showBarMenu = true;
        // 底部按钮栏
        $scope.showBottomMenu = true;
        $scope.showTempMenu = false;
        $scope.showCut = false;
        $scope.showText = false;
        $scope.loading = true;
        $scope.template = {pages: {page: []}};
        $scope.pageAllPx = {page: []};
        $scope.weixinFlag = localStorage.getItem('distinguish');
        $scope.template.maxPageHeight = 0;
        $scope.template.ulWidth = 0;
        vm.FirstSeven = 0;
        vm.flags = false;
        vm.isOrientation = false;
        vm.counts = localStorage.getItem('article-count') || 0;


        // 成功多少张
        var indd = 0;
        var errorImageArr = [];
        var initValue = 0;

        vm.galleryPage = [];
        vm.loadMore = loadMore;
        vm.indexNum = 0;
        vm.itemsPerPage = 20;
        vm.more = true;


        var mL = 0, liW = 0, ulW = 0, selectTextIndex = 0;
        var runR = true, runL = true, flag = true, isDragging = false, moveSticker = false, moveText = false;
        var drag;
        var dragBox = {}, stickerDragBox = {};
        var goes = [], local_pages = [];
        var $ul = $(".carousel5");
        var $li = $(".template-carousel");
        $li.hide();
        vm.fontuuids = [];

        function getLocalStorage() {
            // 工作区中编辑作品所用到的图片
            $scope.qiniuId = JSON.parse(localStorage.getItem("gallery")) || [];
            // $scope.template.pages数据
            local_pages = JSON.parse(localStorage.getItem("pages")) || [];
        }

        if ($scope.status == 'make' || $scope.status == 'view') {
            goToMake()
        }

        //这一步是分页下拉  刷新滚动条置顶
        window.scrollTo(0, 0);

        function loadAll(folderId) {
            if (folderId == 'isNull') {
                Gallery.storeByCondition({
                    items: [{key: "folderId", op: "isNull", value: ''},{key: "articleId", op: "=", value: vm.aid}],
                    page: vm.indexNum,
                    size: vm.itemsPerPage,
                    sort: sorts()
                }, onSuccess, onError);
            } else {
                Gallery.storeByCondition({
                    items: [{key: "folderId", op: "=", value: folderId},{key: "articleId", op: "=", value: vm.aid}],
                    page: vm.indexNum,
                    size: vm.itemsPerPage,
                    sort: sorts()
                }, onSuccess, onError);
            }
        }

        function sorts() {
            return ["id,desc"];
        }

        function onSuccess(res) {
            if(res.status == 200){
                if (res.data.length < vm.itemsPerPage) {
                    vm.more = false;
                    flag = false;
                } else {
                    vm.more = true;
                    flag = true;
                }
                angular.forEach(res.data, function (item) {
                    item.usenum = 0;
                    item.identifier = $scope.domain + item.identifier;
                    vm.galleryPage.push(item);
                });
                getPagePhoto();
            }else {
                MessageService.error(res.message);
            }
        }

        function onError(error) {
            if(error.status !== 403){
                swal({
                    title: $translate.instant("galleryMessage.failedToObtainThePhotoGallery"),
                    text: "",
                    imageUrl: Theme.sweetHintImg(),
                    timer: 2000,
                    showConfirmButton: false
                });
            }

        }

        function loadMore() {
            vm.indexNum++;
            if ($scope.folderInside) {
                loadAll($scope.folderOne.id);
            } else {
                loadAll('isNull');
            }
        }

        $scope.getCount = function () {
            if ($scope.qiniuId == null) {
                return vm.count;
            }
            if (vm.counts - $scope.qiniuId.length > 0) {
                return vm.counts - $scope.qiniuId.length;
            } else {
                return 0;
            }
        };

        //获取分页图片 (删除、上传都会重新刷新获取一定数量的照片)
        function getPagePhoto() {
            // console.log(vm.galleryPage);//这个是分页限制的数据格式 每次只显示10条
            var timeList = [];
            vm.photoArray = [];
            //判断日期是否重复
            for (var i = 0; i < vm.galleryPage.length; i++) {
                var photoCreatedDate = new Date(vm.galleryPage[i].createdDate);
                if (checkExist(timeList, photoCreatedDate)) {
                    timeList.push(photoCreatedDate);
                }
            }
            //将相同日期下的照片整合
            for (var m = 0; m < timeList.length; m++) {
                var tempObj = {};
                var tempItems = [];
                for (var j = 0; j < vm.galleryPage.length; j++) {
                    var createdDate = new Date(vm.galleryPage[j].createdDate);
                    if (timeList[m].getFullYear() == createdDate.getFullYear() &&
                        timeList[m].getMonth() == createdDate.getMonth() &&
                        timeList[m].getDate() == createdDate.getDate()) {
                        tempItems.push(vm.galleryPage[j])
                    }
                }
                var time = timeList[m].getFullYear() + '年' + (timeList[m].getMonth() + 1) + '月' + timeList[m].getDate() + '日';
                tempObj = {"createDate": time, "galleries": tempItems};
                vm.photoArray.push(tempObj);
            }
            $scope.photos = vm.photoArray;
            $(".photo-show").show();
        }

        /**
         * 加载七牛域名和localStorage
         */
        $q.all([$scope.domains.$promise, vm.platformSetting.$promise]).then(function () {
            vm.platformSetting = vm.platformSetting.data;
            /**
             * wechat api
             */

            vm.lagnuages =[];
            if ($localStorage.lagnuages) {
                for(var i = 0 ; i<$localStorage.lagnuages.length; i++ ){
                    var lang = $localStorage.lagnuages[i];
                    var langObj = {key:lang};
                    if (lang == 'zh-cn') {
                        langObj.value = "中文";
                    }
                    if (lang == 'en') {
                        langObj.value = "English";
                    }
                    if (vm.lang == lang) {
                        vm.langValue = langObj.value;
                        langObj.selected = true;
                    }
                    vm.lagnuages.push(langObj);
                }
            }

            if (wx) {
                var url = window.location.hash && window.location.href.slice(0, -window.location.hash.length) || window.location.href;
                WxJS.get({url: url}, function (res) {
                    if(res.status==200){
                        $scope.agentIos = browserVersions();
                        console.log("agentIos: "+$scope.agentIos)
                        var config = res.data;
                        wx.config({
                            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                            appId: config.appId, // 必填，公众号的唯一标识
                            timestamp: config.timestamp, // 必填，生成签名的时间戳
                            nonceStr: config.nonceStr, // 必填，生成签名的随机串
                            signature: config.signature,// 必填，签名，见附录1
                            jsApiList: ['chooseImage', 'uploadImage', 'hideMenuItems'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                        });
                        wx.ready(function () {
                            console.log('wechat api ready!');
                            wx.hideMenuItems({
                                menuList: ["menuItem:copyUrl", "menuItem:share:timeline", "menuItem:share:appMessage", "menuItem:share:qq", "menuItem:share:appMessage", "menuItem:share:QZone"]
                            });
                        });
                        wx.error(function (res) {
                            console.log(res)
                        });
                    }

                }, function () {
                    console.log("wx config error");
                });
            }
            //设置回退事件
            $scope.bool = false;
            //监听浏览器返回的事件
            setTimeout(function () {
                $scope.bool = true;
            }, 2000);
            window.addEventListener("popstate", function (e) {
                if (window.location.href.indexOf("chooseNew") > 0 || window.location.href.indexOf("choosesNew") > 0) {
                    if ($scope.bool) {
                        swal({
                            title: $translate.instant("choose.editorMessage.worksNoSave"),
                            text: $translate.instant("choose.editorMessage.sendBackCatalog"),
                            imageUrl: Theme.sweetHintImg(),
                            timer: 2000,
                            showConfirmButton: false
                        });
                    }
                    $(".folder-footer").show();
                    removeAlertClass();
                    $scope.bool = false;
                } else if (window.location.href == (vm.platformSetting.editorNotifyUrl + '/#/') || window.location.href == vm.platformSetting.editorNotifyUrl + '/#/login') {
                    if (vm.pid && vm.vid) {
                        $state.go('product-chooseNew-ec', {
                            storeId: vm.storeId,
                            pid: vm.pid,
                            vid: vm.vid,
                            xmlId: vm.xmlId,
                            aid: vm.aid,
                        }, {reload: false});
                    }else if (vm.aid) {
                        $state.go('product-choosesNew-ec', {
                            storeId: vm.storeId,
                            aid: vm.aid
                        }, {reload: false});
                    }
                } else if (window.location.href == (vm.platformSetting.editorNotifyUrl + '/#/login')) {
                    var url = "";
                    if (vm.pid && vm.vid) {
                        url = vm.platformSetting.editorNotifyUrl + '/#/' + vm.storeId + '/' + vm.pid + '/' + vm.vid + '/' + vm.aid + '/productThumbnail';
                        // $state.go('thumbnail',{storeId:vm.storeId,pid:vm.pid,vid:vm.vid,aid:vm.aid})
                    } else {
                        //编辑
                        url = vm.platformSetting.editorNotifyUrl + '/#/' + vm.storeId + '/' + vm.aid + '/view';
                    }
                    window.location.href = url;
                }
            }, false);
            function pushHistory() {
                var url = null;
                //新建
                if (vm.pid && vm.vid) {
                    url = vm.platformSetting.editorNotifyUrl + '/#/' + vm.storeId + '/' + vm.pid + '/' + vm.vid + '/' + vm.aid + '/productThumbnail';
                } else {
                    //编辑
                    url = vm.platformSetting.editorNotifyUrl + '/#/' + vm.storeId + '/' + vm.aid + '/view';
                }
                var state = {
                    title: "",
                    url: url
                };
                window.history.pushState(state, "");
            }

            pushHistory();

            //设置title
            CommonService.setDocumentTitle($translate.instant("choose.title"));
            $scope.domain = 'https://' + $scope.domains.domains[0] + '/';
            // token过期 — QiniuToken 单例自动刷新
            loadAll('isNull');
            loadFolders();
            getItem();

            // alert($scope.agentIos)
            /**
             * 上传本地图片
             * 保存到七牛
             */
            $scope.chooseWx = function () {
                initValue = $scope.qiniuId.length;
                var upindex = 0;
                wx.chooseImage({
                    count: 9, // 默认9
                    sizeType: ['original'], // 可以指定是原图还是压缩图，默认二者都有
                    sourceType: ['album'], // 可以指定来源是相册还是相机，默认二者都有
                    success: function (res) {
                        var localIds = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
                        $(".save-pages").removeClass('hide1');
                        asyncGetImg(localIds);

                        function asyncGetImg(datas) {
                            $(".save-pages").addClass('hide1');
                            setTimeout(function () {
                                swal({
                                    title: $translate.instant("choose.editorMessage.startUploading",{datasLength:datas.length}),
                                    text: $translate.instant("choose.editorMessage.imagUploaSlow")+"\n"+$translate.instant("choose.editorMessage.pleaseWaitPatiently"),
                                    showConfirmButton: false,
                                    type: "info"
                                });
                            }, 500);

                            indd = 0; //成功张数
                            errorImageArr = []; //失败张数
                            var index_ = 0;
                            if (datas.length > index_) {
                                getImg2(datas, index_);
                            }
                        }

                        function getImg2(datas, index_) {
                            //上传到微信服务器
                            wx.uploadImage({
                                localId: datas[index_],
                                isShowProgressTips: 1,
                                success: function (res) {
                                    index_++;
                                    if (datas.length > index_) {
                                        getImg2(datas, index_);
                                    }
                                    swal({
                                        title: $translate.instant("choose.editorMessage.thePictureIsUploaded")+"(" + (indd + 1 + errorImageArr.length) + "/" + datas.length + ")....",
                                        text: $translate.instant("choose.editorMessage.imagUploaSlow")+"\n"+$translate.instant("choose.editorMessage.pleaseWaitPatiently"),
                                        showConfirmButton: false,
                                        type: "info"
                                    });
                                    Gallery.upload({
                                        identifiers: res.serverId,
                                        provider: "QINIU",
                                        fileName: '',
                                        imgSize: 0,
                                        folderId: $scope.folderOne ? $scope.folderOne.id : '',
                                        articleId:vm.aid
                                    }, function (resp) {
                                        if(resp.status==200){
                                            console.log('Gallery.upload服务器输出' + resp.data);
                                            qiniuToImg(resp.data);
                                            indd++;
                                            if (indd == datas.length) {
                                                setTimeout(function () {
                                                    var text = '';
                                                    if ($scope.status == 'start') {
                                                        text = (datas.length + initValue - $scope.qiniuId.length) > 0 ?  $translate.instant("choose.editorMessage.pictureRepetition",{pictureLength:(datas.length + initValue - $scope.qiniuId.length)}): ''
                                                    }
                                                    swal({
                                                        title: $translate.instant("choose.editorMessage.uploadCompleted"),
                                                        text: text,
                                                        imageUrl: Theme.sweetSuccedImg(),
                                                        confirmButtonText: $translate.instant("choose.editor.confirm")
                                                    });
                                                }, 1000);

                                                updatePic();

                                            } else if (datas.length == (indd + errorImageArr.length) && errorImageArr.length != 0) {
                                                SweetAlert.swal({
                                                    title: $translate.instant("choose.editorMessage.uploadCompleted"),
                                                    text: $translate.instant("choose.editorMessage.pictureRepetition",{pictureLength:errorImageArr.length}),
                                                    imageUrl: Theme.sweetHintImg(),
                                                    showCancelButton: true,
                                                    confirmButtonText: $translate.instant("choose.editor.confirm"),
                                                    cancelButtonText: $translate.instant("choose.editor.cancel")
                                                }, function (isConfirm) {
                                                    if (isConfirm) {
                                                        asyncGetImg(errorImageArr);
                                                    } else {
                                                        SweetAlert.swal({
                                                            title: $translate.instant("choose.editorMessage.pictureUploadingCancel"),
                                                            imageUrl: Theme.sweetHintImg(),
                                                            text: "",
                                                            timer: 2000,
                                                            showConfirmButton: false
                                                        });

                                                        updatePic();
                                                    }
                                                })

                                            }
                                        }
                                    }, function (error) {
                                        errorImageArr.push(datas[index_]);
                                        //最后一个失败了的话
                                        if (datas.length == (indd + errorImageArr.length)) {
                                            SweetAlert.swal({
                                                title: $translate.instant("choose.editorMessage.uploadCompleted"),
                                                text: $translate.instant("choose.editorMessage.pictureRepetition",{pictureLength:errorImageArr.length}),
                                                imageUrl: Theme.sweetHintImg(),
                                                showCancelButton: true,
                                                confirmButtonText:  $translate.instant("choose.editor.confirm"),
                                                cancelButtonText: $translate.instant("choose.editor.cancel")
                                            }, function (isConfirm) {
                                                if (isConfirm) {
                                                    asyncGetImg(errorImageArr);
                                                } else {
                                                    SweetAlert.swal({
                                                        title: $translate.instant("choose.editorMessage.pictureUploadingCancel"),
                                                        imageUrl: Theme.sweetHintImg(),
                                                        text: "",
                                                        timer: 2000,
                                                        showConfirmButton: false
                                                    });
                                                }
                                            })
                                        }
                                    });
                                },
                                error: function (error) {
                                    swal({
                                        title: $translate.instant("uploadContent.pictureUpload",{currentLenght:(indd + 1 + errorImageArr.length),datasLength:datas.length}),
                                        text: $translate.instant("uploadContent.greatBeach"),
                                        showConfirmButton: false,
                                        type: "info"
                                    });
                                    index_++;
                                    if (datas.length > index_) {
                                        getImg2(datas, index_);
                                    }
                                    errorImageArr.push(datas[index_]);
                                    //最后一个失败了的话
                                    if (datas.length == (indd + errorImageArr.length)) {
                                        SweetAlert.swal({
                                            title: $translate.instant("choose.editorMessage.uploadCompleted"),
                                            text: $translate.instant("choose.editorMessage.pictureRepetition",{pictureLength:errorImageArr.length}),
                                            imageUrl: Theme.sweetHintImg(),
                                            showCancelButton: true,
                                            confirmButtonText: $translate.instant("choose.editor.confirm"),
                                            cancelButtonText: $translate.instant("choose.editor.cancel")
                                        }, function (isConfirm) {
                                            if (isConfirm) {
                                                asyncGetImg(errorImageArr);
                                            } else {
                                                SweetAlert.swal({
                                                    title: $translate.instant("choose.editorMessage.pictureUploadingCancel"),
                                                    imageUrl: Theme.sweetHintImg(),
                                                    text: "",
                                                    timer: 2000,
                                                    showConfirmButton: false
                                                });
                                            }
                                        })
                                    }
                                }
                            });
                        }
                    }
                });
            };

            //非调用微信公众号上传图片 无9张限制 可多张上传 上传到七牛  并且可以返回路径在页面显示
            window.uploadPicMutiple = function ($event) {
                initValue = $scope.qiniuId.length;
                var files = [];
                vm.higherSize = [];
                for (var i = 0; i < $event.target.files.length; i++) {
                    var f = $event.target.files[i];
                    if(f.type =='image/png'||f.type =='image/jpeg'||f.type =='image/jpg' || !f.type){
                        f.imgSize = f.size;
                        if ( f.size / 1024 > 20480) {
                            vm.higherSize.push(i + 1);
                        }
                        files.push(f)
                    }
                }

                //系统检测到{{}}张大于20M的图片，已自动过滤\n请压缩后再尝试上传！
                if (vm.higherSize.length > 0) {
                    $scope.bigSizeTip = true;
                    $scope.higherSizeLen = vm.higherSize.length;
                    $scope.$digest();
                } else {
                    if(files.length > 0){
                        $(".save-pages").removeClass('hide1');
                        filterUpload(files);
                    }
                }
                $scope.filterBigSize = function () {
                    $scope.bigSizeTip = false;
                    console.log(files)
                    files = files.filter(function (item, index) {
                        return item.size / 1024 < 20480;
                    });
                    if (files.length == 0) {
                        updatePic();
                    } else {
                        filterUpload(files);
                    }
                }
            };
        });

        function getItem() {
            $scope.qiniuId = JSON.parse(localStorage.getItem("gallery")) || [];        //拿到 localStorage 中的图片数据
            localStorage.setItem("gallery", JSON.stringify($scope.qiniuId));           //工作区中所有的图片信息

            localStorage.removeItem('go');
            $scope.multipartUpload = localStorage.getItem("multipartUpload");
            //新建页面
            if (vm.pid && $scope.status == 'start') {
                init();
            } else if (vm.aid && $scope.status == 'start') {      //编辑页面
                vm.counts = localStorage.getItem('article-count');
            }
        }

        /**************************************---图片上传操作---************start*******************************/
        function filterUpload(files) {
            $(".save-pages").addClass('hide1');
            asyncUpload(files)
        }

        function asyncUpload(files) {
            indd = 0;
            errorImageArr = [];
            setTimeout(function () {
                swal({
                    title: $translate.instant("uploadContent.startUploading",{datasLength:files.length}),
                    text: $translate.instant("uploadContent.greatBeach"),
                    showConfirmButton: false,
                    type: "info"
                });
            }, 500);
            for (var i = 0; i < 5 && i < files.length; i++) {
                var file = files[i];
                qiniuUpload(file, files, i);
            }
        }

        function qiniuUpload(file, files, index_) {
            var formData = new FormData();
            formData.append('file', file);
            formData.append('unique_names', false);
            formData.append('key', "file-" + UidService.get());
            formData.append('token', vm.token);
            var reader = new FileReader();
            reader.readAsArrayBuffer(file)
            reader.onloadend = function (e){
                formData.append('crc32', CRC32.buf(new Uint8Array(this.result)));
                $.ajax({
                    cache: true,
                    type: "POST",
                    url: 'https://upload.qiniup.com/',
                    data: formData,
                    async: true,
                    contentType: false,
                    processData: false,
                    success: function (data) {
                        swal({
                            title: $translate.instant("uploadContent.pictureUpload",{currentLenght:(indd + 1 + errorImageArr.length),datasLength:files.length}),
                            text: $translate.instant("uploadContent.greatBeach"),
                            showConfirmButton: false,
                            type: "info"
                        });
                        $.ajax({
                            type: "GET",
                            url: $scope.domain + data.key + "?imageInfo",
                            success: function (va) {
                                console.log(va)
                                if (va.orientation == "Left-bottom" || va.orientation == "Right-top" || va.orientation == "Left-top" || va.orientation == "Right-bottom") {
                                    file.width = va.height;
                                    file.height = va.width;
                                } else {
                                    file.width = va.width;
                                    file.height = va.height;
                                }
                                serviceUpload(data, file, files.length);
                            },
                            error: function (request) {
                                serviceUpload(data, file, files.length);
                            }
                        });
                        if (files.length > index_ + 1 && index_ >= 4) {
                            var f = files[index_ + 1];
                            qiniuUpload(f, files, index_ + 1);
                        }
                    },
                    error: function (request) {
                        errorImageArr.push(file);
                        swal({
                            title: $translate.instant("uploadContent.pictureUpload",{currentLenght:(indd + 1),datasLength:files.length}),
                            text: $translate.instant("uploadContent.greatBeach"),
                            showConfirmButton: false,
                            type: "info"
                        });
                        //最后一个失败了的话
                        if (files.length == (indd + errorImageArr.length)) {
                            SweetAlert.swal({
                                title: $translate.instant("choose.editorMessage.uploadCompleted"),
                                text: $translate.instant("choose.editorMessage.pictureRepetition",{pictureLength:errorImageArr.length}),
                                imageUrl: Theme.sweetHintImg(),
                                showCancelButton: true,
                                confirmButtonText: $translate.instant("choose.editor.confirm"),
                                cancelButtonText: $translate.instant("choose.editor.cancel")
                            }, function (isConfirm) {
                                if (isConfirm) {
                                    asyncUpload(errorImageArr);
                                } else {
                                    SweetAlert.swal({
                                        title: $translate.instant("choose.editorMessage.pictureUploadingCancel"),
                                        imageUrl: Theme.sweetHintImg(),
                                        text: "",
                                        timer: 2000,
                                        showConfirmButton: false
                                    });
                                    updatePic();
                                }
                            })
                        }
                    }
                });
            }
        }

        function serviceUpload(data, file, len) {
            Gallery.upload({
                identifiers: data.key,
                provider: "QINIU",
                fileName: file.name,
                imgSize: file.size,
                width: file.width,
                height: file.height,
                folderId: $scope.folderOne ? $scope.folderOne.id : '',
                articleId:vm.aid
            }, function (resp) {
                if(resp.status == 200){
                    indd++;
                    if (len == indd) {
                        setTimeout(function () {
                            var text = '';
                            if ($scope.status == 'start') {
                                text = (len + initValue - $scope.qiniuId.length) > 0 ? "存在" + (len + initValue - $scope.qiniuId.length) + "张照片重复\n请重新选择上传" : ''
                            }
                            swal({
                                title: $translate.instant("choose.editorMessage.uploadCompleted"),
                                text: text,
                                imageUrl: Theme.sweetSuccedImg(),
                                confirmButtonText: $translate.instant("choose.editor.confirm")
                            });
                            updatePic();
                        }, 1000);
                    } else if (len == (indd + errorImageArr.length) && errorImageArr.length != 0) {
                        SweetAlert.swal({
                            title: $translate.instant("choose.editorMessage.uploadCompleted"),
                            text: $translate.instant("choose.editorMessage.breakUpload",{errorImageArrLength:errorImageArr.length}),
                            imageUrl: Theme.sweetHintImg(),
                            showCancelButton: true,
                            confirmButtonText: $translate.instant("choose.editor.confirm"),
                            cancelButtonText: $translate.instant("choose.editor.cancel")
                        }, function (isConfirm) {
                            if (isConfirm) {
                                asyncUpload(errorImageArr);
                            } else {
                                SweetAlert.swal({
                                    title: $translate.instant("choose.editorMessage.pictureUploadingCancel"),
                                    imageUrl: Theme.sweetHintImg(),
                                    text: "",
                                    timer: 2000,
                                    showConfirmButton: false
                                });
                                updatePic();
                            }
                        })
                    }
                    qiniuToImg(resp.data);
                }else {
                    errorImageArr.push(file);
                    //最后一个失败了的话
                    if (len == (indd + errorImageArr.length)) {
                        SweetAlert.swal({
                            title: $translate.instant("choose.editorMessage.uploadCompleted"),
                            text: $translate.instant("choose.editorMessage.pictureRepetition",{pictureLength:errorImageArr.length}),
                            imageUrl: Theme.sweetHintImg(),
                            showCancelButton: true,
                            confirmButtonText: $translate.instant("choose.editor.confirm"),
                            cancelButtonText: $translate.instant("choose.editor.cancel")
                        }, function (isConfirm) {
                            if (isConfirm) {
                                asyncUpload(errorImageArr);
                            } else {
                                SweetAlert.swal({
                                    title: $translate.instant("choose.editorMessage.pictureUploadingCancel"),
                                    imageUrl: Theme.sweetHintImg(),
                                    text: "",
                                    timer: 2000,
                                    showConfirmButton: false
                                });
                                updatePic();
                            }
                        })
                    }
                }
            }, function (error) {
                errorImageArr.push(file);
                //最后一个失败了的话
                if (len == (indd + errorImageArr.length)) {
                    SweetAlert.swal({
                        title: $translate.instant("choose.editorMessage.uploadCompleted"),
                        text: $translate.instant("choose.editorMessage.pictureRepetition",{pictureLength:errorImageArr.length}),
                        imageUrl: Theme.sweetHintImg(),
                        showCancelButton: true,
                        confirmButtonText: $translate.instant("choose.editor.confirm"),
                        cancelButtonText: $translate.instant("choose.editor.cancel")
                    }, function (isConfirm) {
                        if (isConfirm) {
                            asyncUpload(errorImageArr);
                        } else {
                            SweetAlert.swal({
                                title: $translate.instant("choose.editorMessage.pictureUploadingCancel"),
                                imageUrl: Theme.sweetHintImg(),
                                text: "",
                                timer: 2000,
                                showConfirmButton: false
                            });
                            updatePic();
                        }
                    })
                }
            });
        }

        /**
         * 上传本地图片
         * 更新$scope.qiniuId
         * 更新localStorage       新建页面：pid?-gallery    编辑页面：aid?-gallery
         * @param photos
         */
        function qiniuToImg(photos) {
            if ($scope.status == 'gallery') {
                return
            }
            $scope.multipartUpload = localStorage.getItem("multipartUpload");

            $scope.qiniuId = JSON.parse(localStorage.getItem("gallery")) || [];
            photos.identifier = $scope.domain + photos.identifier;
            photos.usenum = 0;
            $scope.qiniuId.push(photos);

            //筛选出重复的  比较identifier
            $scope.qiniuId = uniqeByKeys($scope.qiniuId, ['id', 'identifier']);

            //更新缓存
            localStorage.setItem("gallery", JSON.stringify($scope.qiniuId));
        }

        function obj2key(obj, keys) {
            var n = keys.length,
                key = [];
            while (n--) {
                key.push(obj[keys[n]]);
            }
            return key.join('|');
        }

        //去重操作
        function uniqeByKeys(array, keys) {
            var arr = [];
            var hash = {};
            for (var i = 0, j = array.length; i < j; i++) {
                var k = obj2key(array[i], keys);
                if (!(k in hash)) {
                    hash[k] = true;
                    arr.push(array[i]);
                }
            }
            return arr;
        }

        /**************************************---图片上传操作---*************end********************************/


        /**************************************---图片库操作---************start*******************************/
        // 返回工作区
        $scope.backToView = function () {
            if ($scope.folderInside) {
                $scope.hideFolderContent();
            }
            setProductionStorage('start');
            $scope.gallaryPic = [];
            angular.forEach($scope.photos, function (p, i) {
                p.select_photoAll = false;
                angular.forEach(p.galleries, function (g, j) {
                    g.select_photo = false
                });
            });
            window.scrollTo(0, 0);
        };

        // 上传图片后更新图片库/文件夹
        function updatePic() {
            if ($scope.folderOne && $scope.folderOne.id) {
                $scope.showFolderContent($scope.folderOne);
            } else {
                $scope.folderInside = false;
                $scope.currentNav = 'gallery';
                $scope.moveGallery = false;
                $scope.delBar = false;
                vm.galleryPage = [];
                vm.indexNum = 0;
                loadAll('isNull');
            }
        }

        //初始化的时候判断照片是否可选
        var arrTemp = JSON.parse(localStorage.getItem("gallery")) || [];
        var temp = arrTemp.map(function (item) {
            return item.identifier;
        });
        $scope.justifySelect = function (gallery) {
            if (temp.length > 0) {
                for (var i = 0; i < temp.length; i++) {
                    if (temp.indexOf(gallery.identifier) > -1) {
                        gallery.select_photo = false;
                        gallery.flag = false;
                        return true;
                    } else {
                        gallery.flag = true;
                        return false;
                    }
                }
            } else {
                gallery.flag = true;
                return false;
            }
        };
        //下一步  点击图片框 选择图片库  这里图片无限制  单选
        $scope.selectThis2 = function (gallery, photo, index) {
            if (!gallery.flag) {
                return
            }
            $scope.gallaryPic = [];
            $scope.moveGalleryIds = [];
            gallery.select_photo = !gallery.select_photo;
            for (var i = 0; i < photo.galleries.length; i++) {
                if (!photo.galleries[i].select_photo) {
                    photo.select_photoAll = false;
                    break;
                } else if (i == photo.galleries.length - 1) {
                    photo.select_photoAll = true;
                }
            }
            var t = 0;
            angular.forEach($scope.photos, function (p) {
                angular.forEach(p.galleries, function (g) {
                    if (g.select_photo) {
                        t++;
                        $scope.gallaryPic.push(g);       //选择导入图片的数组
                        $scope.moveGalleryIds.push(g.id);
                    }
                })
            });
            $scope.select_photo = t ? true : false;         //确认按钮的显示
            $scope.delBar = t ? true : false; //删除栏的显示
        };

        //下一步  点击图片框 选择图片库  这里图片无限制  全选
        $scope.selectedPhoto = function (index, photo) {
            $scope.gallaryPic = [];
            $scope.moveGalleryIds = [];
            if ($scope.photos == '' || $scope.photos == null) {
                return;
            } else {
                if (photo.select_photoAll == null) {
                    photo.select_photoAll = true;
                } else {
                    photo.select_photoAll = !photo.select_photoAll;
                }
                $scope.delBar = true;
                angular.forEach(photo.galleries, function (g, i) {
                    g.select_photo = photo.select_photoAll;
                });

                if (photo.select_photoAll) {
                    $scope.select_photoAll = true;
                } else {
                    $scope.select_photoAll = false;
                }

                var t = 0;
                angular.forEach($scope.photos, function (p, i) {
                    angular.forEach(p.galleries, function (g, j) {
                        if (g.select_photo == true && g.flag == true) {
                            $scope.gallaryPic.push(g);      //选择导入图片的数组
                            $scope.moveGalleryIds.push(g.id);
                        }
                    });
                    if (!p.select_photoAll) {
                        t++;
                    }
                    if (i == $scope.photos.length - 1) {
                        if (t == $scope.photos.length && $scope.gallaryPic.length == 0) {
                            $scope.delBar = false;
                        }
                    }
                });
            }
        };

        //导入功能   判断所选图片是否符合要求
        $scope.confirmImport = function ($event) {
            $event.stopPropagation();
            //导入之后 项目库不再出现引导页
            $scope.qiniuId = JSON.parse(localStorage.getItem("gallery")) || [];
            cancelSelect($scope.qiniuId)
            $scope.multipartUpload = localStorage.getItem("multipartUpload");
            $scope.selectAllFolder = false;
            // 文件夹选择导入
            if ($scope.currentNav == 'folder') {
                var str = '';
                angular.forEach($scope.folderIds, function (f) {
                    str += f + ';'
                });
                var temp = $scope.qiniuId.map(function (item) {
                    return item.identifier;
                });

                Gallery.all({
                    items: [{key: "folderId", op: "in", value: str},{key: "articleId", op: "=", value: vm.aid}],
                    sort: sorts()
                }, function (resp) {
                    if(resp.status == 200){
                        angular.forEach(resp.data, function (p) {
                            angular.forEach(p.galleries, function (g, i) {
                                g.usenum = 0;
                                g.identifier = $scope.domain + g.identifier;
                                if (temp.length > 0) {
                                    for (var i = 0; i < temp.length; i++) {
                                        if (temp.indexOf(g.identifier) > -1) {
                                            // console.log(g.identifier)
                                            return;
                                        }
                                    }
                                }

                                if ((typeof g.parameter) == 'string') {
                                    g.parameter = JSON.parse(g.parameter);
                                }
                                // 从尾部添加
                                $scope.qiniuId.push(g);
                            })
                        });
                        setLocalstorage();
                        return;
                    }else {
                        MessageService.error(resp.message);
                    }
                });
            }
            angular.forEach($scope.gallaryPic, function (p, i) {
                if ((typeof p.parameter) == 'string') {
                    p.parameter = JSON.parse(p.parameter);
                }

                $scope.qiniuId.push(p);

            });
            setLocalstorage();
            if ($scope.folderInside) {
                $scope.hideFolderContent();
            }
        };

        function setLocalstorage() {
            localStorage.setItem("gallery", JSON.stringify($scope.qiniuId));
            setProductionStorage('start');
            $scope.gallaryPic = [];
            angular.forEach($scope.photos, function (p, i) {
                p.select_photoAll = false;
                angular.forEach(p.galleries, function (g, j) {
                    g.select_photo = false
                });
            });

            cancelSelectFolders();
            $scope.selectAllGallery = $scope.delBar = false;
            window.scrollTo(0, 0);
        }

        /**************************************---图片库操作---*************end********************************/
        $scope.gallaryPic = [];         //个人图片库选择

        $scope.selectAllGallery = false;
        $scope.moveGalleryIds = [];
        /**
         * 初始化
         */
        function init() {
            ItemValue.get({id: $stateParams.vid}, function (res) {
                if(res.status == 200){
                    vm.itemValue = res.data;
                    $("body").toggleClass('bg');
                    $scope.status = localStorage.getItem('Production');
                    vm.productXmlLine = angular.copy(res.data.productXmlLines[0]);
                    angular.forEach(res.data.productXmlLines, function (line) {
                        if (line.id == vm.xmlId) {
                            vm.productXmlLine = angular.copy(line);
                        }
                    })
                    vm.article = {
                        cover: vm.productXmlLine.coverImg,
                        themeClassifyId: vm.productXmlLine.productXmlThemeId,
                        themeClassifyName: vm.productXmlLine.productXmlThemeName,
                        productXmlId: vm.productXmlLine.productXmlId,
                        productXmlName: vm.productXmlLine.productXmlName,
                        musicIdentify: vm.productXmlLine ? vm.productXmlLine.musicIdentify : res.data.musicIdentify,
                        sku: res.data.sku,
                        skuNumber: res.data.skuNumber,
                        name: res.data.productName,
                        productId: res.data.productId,
                        productName: res.data.productName,
                        categoryId: res.data.categoryId,
                        categoryName: res.data.categoryName,
                        categoryStoreId: res.data.categoryStoreId,
                        categoryStoreName: res.data.categoryStoreName,
                        editorType: res.data.productEditorType,
                        productBokehType: res.data.productBokehType,
                        itemValueId: res.data.itemValueId || vm.vid
                    };

                    vm.article.bokehtype = res.data.productBokehType;


                    var result = ListService.inList(vm.article, variableDatas, ["productXmlId"]);
                    if(result&&result.data&&result.data.length){
                        angular.forEach(result.data,function (va,i) {
                            if(va.type=='text'){
                                vm.variableTextDatas.push(va)
                            }
                            if(va.type=='box'){
                                vm.variableBoxDatas.push(va)
                            }
                        })
                    }
                    console.log(vm.variableTextDatas)
                    console.log(vm.variableBoxDatas)

                    $scope.isCanClick = false;
                    Convert.xmlToDocument({
                        identifier: vm.productXmlLine ? vm.productXmlLine.productXmlIdentifier : res.data.productXmlIdentifier,
                        provider: 'qiniu'
                    }, function (res) {
                        $scope.picArr = [];
                        vm.counts = 0;
                        var isChoose = JSON.parse(localStorage.getItem('picArrCopy'));
                        angular.forEach(res.pages.page, function (page, i) {
                            if (page.backup) {
                                if (i == res.pages.page.length - 1) {
                                    $scope.isCanClick = true;
                                }
                                return
                            }
                            var len = 0;
                            angular.forEach(page.levels.level, function (level) {
                                if (level.imagebox && level.imagebox.geometry) {
                                    len++;
                                    vm.counts++;
                                    if(vm.variableBoxDatas.length&&level.name){
                                        for (var _i = 0; _i < vm.variableBoxDatas.length; _i++) {
                                            if(vm.variableBoxDatas[_i].name==level.name){
                                                vm.counts--
                                            }
                                        }
                                    }
                                }
                            })

                            if (len && !isChoose) {
                                var arr = {
                                    pageI: i,
                                    maskI: len,
                                    index: -1
                                };
                                $scope.picArr.push(arr);
                            }

                            if (i == res.pages.page.length - 1) {
                                $scope.isCanClick = true;
                            }
                        });
                        if (!isChoose) {
                            localStorage.setItem('picArr', JSON.stringify($scope.picArr));
                            localStorage.setItem('picArrCopy', JSON.stringify($scope.picArr));
                            localStorage.setItem('picArrChoose', 0);
                        }
                    });
                }else {
                    MessageService.error(res.message);
                }
            });
        }

        $scope.delPhoto = function (photo, index) {
            var newArr = angular.copy($scope.qiniuId);
            newArr.splice(index, 1);
            $scope.qiniuId = newArr;
            localStorage.setItem("gallery", JSON.stringify($scope.qiniuId));

            $scope.delPic = JSON.parse(localStorage.getItem('delPic')) || [];
            $scope.picI = parseInt(localStorage.getItem('picArrChoose'));
            var arr = $scope.picArr[$scope.picI];
            if (photo.seq && photo.seq.select) {
                $scope.delPic.push(photo.seq);
                $scope.delPic.sort(compare2('pageI', compare2('maskI')));
                arr = $scope.picArr[photo.seq.picI];
                arr.index -= 1;
                photo.seq = {
                    pageI: '',
                    maskI: '',
                    select: false
                };
                photo.pageI = '';
                photo.maskI = '';
            }
            localStorage.setItem('picArr', JSON.stringify($scope.picArr));
            localStorage.setItem('picArrChoose', $scope.picI);
            localStorage.setItem('delPic', JSON.stringify($scope.delPic));
        };

        /**
         * 显示图库div
         */
        $scope.showGallery = function () {
            setProductionStorage('gallery');
            window.scrollTo(0, 0);
            //初始化的时候判断照片是否可选
            var arrTemp = JSON.parse(localStorage.getItem("gallery")) || [];
            var temp = arrTemp.map(function (item) {
                return item.identifier;
            });
            $scope.justifySelect = function (gallery) {
                if (temp.length > 0) {
                    for (var i = 0; i < temp.length; i++) {
                        if (temp.indexOf(gallery.identifier) > -1) {
                            gallery.select_photo = false;
                            gallery.flag = false;
                            return true;
                        } else {
                            gallery.flag = true;
                            return false;
                        }
                    }
                } else {
                    gallery.flag = true;
                    return false;
                }
            };
        };

        //显示图片选择图标以及删除栏
        $scope.showDeleteBtn = function () {
            if (!$scope.photos.length) {
                $scope.selectAllGallery = $scope.delBar = false;
                swal({
                    title: "操作失败",
                    text: "没有图片选择",
                    imageUrl: Theme.sweetHintImg(),
                    timer: 1500,
                    showConfirmButton: false
                });
                return
            }
            $scope.selectAllGallery = !$scope.selectAllGallery;
            $scope.delBar = $scope.selectAllGallery;

            $scope.gallaryPic = [];
            $scope.moveGalleryIds = [];
            isShowSelectDot($scope.selectAllGallery);
        };

        function isShowSelectDot(flag) {
            angular.forEach($scope.photos, function (p) {
                p.select_photoAll = flag;
                angular.forEach(p.galleries, function (g) {
                    g.select_photo = flag;
                    if (flag) {
                        $scope.gallaryPic.push(g);       //选择导入图片的数组
                        $scope.moveGalleryIds.push(g.id);
                    }
                });
            });
        }

        /**************************************---文件夹操作---************start*******************************/
        $scope.currentNav = 'gallery';
        // 是否进入文件夹内
        $scope.folderInside = false;
        // 选中的某一文件夹信息
        $scope.folderOne = {};
        // 是否点击移动按钮
        $scope.moveGallery = false;
        // 文件夹点击
        $scope.selectAllFolder = false;
        $scope.selectOne = {
            folderId: '',
            selected: false
        };
        $scope.folderIds = [];
        $scope.editFolderNameArr = [];

        function loadFolders() {
            Folder.storeGetAllByCondition({
                items: [{key: "type", op: "=", value: "Gallery"},{key: "articleId", op: "=", value: vm.aid}],
                sort: ["id,asc"]
            }, function (resp) {
                if(resp.status == 200){
                    $scope.Folders = resp.data;
                }else {
                    MessageService.error(resp.message);
                }
            })
        }

        // 增加文件夹
        $scope.addFolder = function () {
            addAlertClass();
            $(".folder-footer").hide();
            swal({
                title: $translate.instant("uploadContent.createAlbum"),
                text: "",
                type: "input",
                showCancelButton: true,
                closeOnConfirm: false,
                confirmButtonText: $translate.instant("choose.editor.confirm"),
                cancelButtonText: $translate.instant("choose.editor.cancel"),
                animation: "slide-from-top",
                inputPlaceholder: $translate.instant("choose.editorMessage.pleaseEnterAFolderName")
            }, function (inputValue) {
                if (inputValue === false) {
                    $(".folder-footer").show();
                    return false;
                }
                if (inputValue === "") {
                    swal.showInputError("请输入名称!");
                    return false
                }
                if (inputValue.indexOf(" ") != -1) {
                    swal.showInputError("请不要输入空格!");
                    return false
                }
                Folder.save({
                    name: inputValue,
                    type: 'Gallery',
                    articleId:vm.aid
                }, function (resp) {
                    if(resp.status == 200){
                        $scope.Folders.push(resp.data);
                        $(".folder-footer").show();
                        swal.close();
                        removeAlertClass();
                    }else {
                        MessageService.error(resp.message);
                    }
                }, function () {
                    swal.showInputError("请输入正确的文件名!");
                })
            });
        };
        function addAlertClass() {
            setTimeout(function () {
                $(".sweet-alert").addClass('folder-alert');
                $(".sa-button-container").addClass('folder-alert-top');
                $(".sa-button-container .cancel").addClass('folder-alert-right')
            }, 200)
        }

        function removeAlertClass() {
            setTimeout(function () {
                $(".sweet-alert").removeClass('folder-alert');
                $(".sa-button-container").removeClass('folder-alert-top');
                $(".sa-button-container .cancel").removeClass('folder-alert-right')
            }, 200)
        }

        // 修改文件夹名
        $scope.editFolder = function () {
            addAlertClass();
            var len = $scope.folderIds.length;
            if (len > 1 || !len) {
                return
            }
            var folder = $scope.editFolderNameArr;
            $(".folder-footer").hide();
            swal({
                title: $translate.instant("choose.editorMessage.rename"),
                text: "",
                type: "input",
                showCancelButton: true,
                closeOnConfirm: false,
                confirmButtonText: $translate.instant("choose.editor.confirm"),
                cancelButtonText: $translate.instant("choose.editor.cancel"),
                animation: "slide-from-top",
                inputPlaceholder: $translate.instant("choose.editorMessage.pleaseEnterAFolderName"),
                inputValue: folder.name
            }, function (inputValue) {
                if (inputValue === false) {
                    $(".folder-footer").show();
                    removeAlertClass();
                    return false;
                }
                if (inputValue === "") {
                    swal.showInputError($translate.instant("choose.editorMessage.pleaseEnterCompanyName"));
                    return false
                }
                if (inputValue.indexOf(" ") != -1) {
                    swal.showInputError($translate.instant("choose.editorMessage.pleaseDoNotEnterASpace"));
                    return false
                }
                if (inputValue === folder.name) {
                    swal.showInputError($translate.instant("choose.editorMessage.pleaseEnterADifferentFolderName"));
                    return false
                }
                Folder.update({
                    name: inputValue,
                    type: 'Gallery',
                    id: folder.id,
                    articleId:vm.aid
                }, function (resp) {
                    if(resp.status == 200){
                        cancelSelectFolders();
                        folder.name = resp.data.name;
                        $(".folder-footer").show();
                        swal.close();
                        removeAlertClass();
                    }else {
                        MessageService.error(resp.message);
                    }
                }, function () {
                    swal.showInputError($translate.instant("choose.editorMessage.pleaseEnterTheCorrectFileName"));
                })
            });
        };

        function cancelSelectFolders() {
            $scope.folderIds = [];
            angular.forEach($scope.Folders, function (item) {
                item.selected = false;
            });
        }

        /**
         * 单选
         * @param item
         * @param flag-----   true：文件夹     false:作品
         */
        $scope.selectSingle = function (item, flag) {
            if (!item) {
                $scope.selectOne = {
                    folderId: '',
                    selected: true
                };
                angular.forEach($scope.Folders, function (folder, index) {
                    folder.selected = false;
                });
                return
            }
            item.selected = !item.selected;
            // 移动状态中
            if ($scope.moveGallery) {

                $scope.selectOne = {
                    folderId: item.id,
                    selected: item.selected
                };

                angular.forEach($scope.Folders, function (folder, index) {
                    folder.selected = false;
                });
                item.selected = $scope.selectOne.selected;
                if (item.selected) {
                    $scope.folderOne = angular.copy(item);
                }
                return
            }

            $scope.selectOne = {
                folderId: '',
                selected: false
            };
            //未选中时
            if (!item.selected) {
                // 文件夹
                if (flag) {
                    $scope.selectAllFolder = false;
                    var ind = $scope.folderIds.indexOf(item.id);
                    if (ind >= 0) {
                        $scope.folderIds.splice(ind, 1);
                    }
                } else {
                    $scope.selectAllAritle = false;
                    var ind = $scope.moveGalleryIds.indexOf(item.id);
                    if (ind >= 0) {
                        $scope.moveGalleryIds.splice(ind, 1);
                    }
                }
            } else {
                if (flag) {
                    $scope.folderIds.push(item.id);
                }
            }
        };

        $scope.selectFolders = function (item) {
            item.selected = !item.selected;

            $scope.selectOne = {
                folderId: '',
                selected: false
            };
            //未选中时
            if (!item.selected) {
                $scope.selectAllFolder = false;
                var ind = $scope.folderIds.indexOf(item.id);
                if (ind >= 0) {
                    $scope.folderIds.splice(ind, 1);
                }

                $scope.editFolderNameArr = [];

            } else {
                $scope.folderIds.push(item.id);
                $scope.editFolderNameArr = item;
            }
            showConfirmBtn();
        };

        /**
         * 全选
         * @param flag-----  true：文件夹     false:作品
         */
        $scope.chooseAll = function (flag) {
            if (flag) {
                $scope.folderIds = [];
                $scope.editFolderNameArr = [];
                $scope.selectAllFolder = !$scope.selectAllFolder;
                angular.forEach($scope.Folders, function (item, index) {
                    if ($scope.selectAllFolder) {
                        item.selected = true;
                        $scope.folderIds.push(item.id);
                    } else {
                        item.selected = false;
                    }
                });

                showConfirmBtn();
            } else {
                $scope.selectAllGallery = !$scope.selectAllGallery;
                angular.forEach($scope.photos, function (photo) {
                    angular.forEach(photo.galleries, function (item) {
                        if ($scope.selectAllGallery) {
                            item.select_photo = true;
                            photo.select_photoAll = true
                        } else {
                            item.select_photo = false;
                            photo.select_photoAll = false
                        }
                    })
                })
            }
        };

        $scope.saveMoveToFolder = function () {
            if (!$scope.selectOne.selected) {
                swal({
                    title: $translate.instant("choose.editorMessage.operationFailure"),
                    text: $translate.instant("choose.editorMessage.pleaseSelectAFolder"),
                    imageUrl: Theme.sweetHintImg(),
                    timer: 1500,
                    showConfirmButton: false
                });
                return
            }
            angular.forEach($scope.Folders, function (folder, index) {
                folder.selected = false;
            });

            $(".prev-btn-gallery").show();

            Gallery.moveFolder({
                galleries: $scope.moveGalleryIds,
                folderId: $scope.selectOne.folderId,
                articleId: vm.aid
            }, function (res) {
                if(res.status == 200){
                    $scope.currentNav = 'gallery';
                    $scope.delBar = false;
                    $scope.gallaryPic = [];
                    $scope.moveGalleryIds = [];
                    $scope.moveGallery = false;
                    $(".photo-show").hide();
                    if ($scope.selectOne.folderId) {
                        $scope.folderInside = true;
                        vm.indexNum = 0;
                        vm.galleryPage = [];
                        loadAll($scope.folderOne.id);
                    } else {
                        $scope.folderInside = false;
                        $scope.delBar = false;
                        vm.galleryPage = [];
                        vm.indexNum = 0;
                        loadAll('isNull');
                    }
                    $scope.selectOne = {
                        folderId: '',
                        selected: false
                    };
                }else {
                    MessageService.error(res.message);
                }
            })
        };

        $scope.backToGallery = function () {
            $scope.currentNav = 'gallery';
            $scope.moveGallery = false;
            $scope.delBar = false;
            $scope.selectOne = {
                folderId: '',
                selected: false
            };
            angular.forEach($scope.Folders, function (folder) {
                folder.selected = false;
            });
            clearGalleryAdd();
            $(".prev-btn-gallery").show();
        };

        $scope.moveToFolder = function () {
            if (!$scope.gallaryPic.length) {
                swal({
                    title: $translate.instant("choose.editorMessage.failedToMove"),
                    text: $translate.instant("choose.editorMessage.pleaseSelectAtLeastOnePicture"),
                    imageUrl: Theme.sweetHintImg(),
                    timer: 2000,
                    showConfirmButton: false
                });
                return
            }
            $scope.moveGallery = true;
            $scope.delBar = true;
            $scope.folderInside = false;
            $(".prev-btn-gallery").hide();
            $scope.currentNav = 'folder';
        };
        // 进入某一文件夹中
        $scope.showFolderContent = function (folder) {
            if (folder.selected) {
                folder.selected = false;
                $scope.selectAllGallery = !$scope.selectAllGallery;
                $scope.selectOne = {
                    folderId: '',
                    selected: false
                };

                $scope.selectAllFolder = false;
                var ind = $scope.folderIds.indexOf(folder.id);
                if (ind >= 0) {
                    $scope.folderIds.splice(ind, 1);
                }
                $scope.editFolderNameArr = [];
                showConfirmBtn();
                return
            }
            $scope.folderInside = true;
            $scope.currentNav = 'gallery';
            $scope.folderOne = angular.copy(folder);
            vm.indexNum = 0;
            vm.galleryPage = [];
            $(".photo-show").hide();
            loadAll(folder.id);
        };
        // 从某一文件夹出去
        $scope.hideFolderContent = function () {
            $scope.folderInside = false;
            $scope.moveGallery = false;
            $scope.currentNav = 'folder';
            $scope.folderOne = {};
            $scope.selectAllGallery = $scope.delBar = false;
        };
        // 图片库nav 点击
        $scope.galleryNavSel = function () {
            $(".photo-show").hide();
            vm.galleryPage = [];
            $scope.currentNav = 'gallery';
            $(".folder-editbar").addClass('hide1');
            $(".arrow-btn").removeClass('folder-arrow-up');
            angular.forEach($scope.Folders, function (folder, index) {
                folder.selected = false;
            });
            $scope.folderIds = [];
            $scope.selectAllGallery = $scope.delBar = false;
            vm.indexNum = 0;
            $scope.folderOne = null;
            loadAll('isNull');
        };
        // 图片库nav 点击
        $scope.folderNavSel = function () {
            vm.galleryPage = [];
            $scope.currentNav = 'folder';
            $scope.selectAllGallery = $scope.delBar = false;
        };

        function showConfirmBtn() {
            if ($scope.folderIds.length > 0) {
                $scope.delBar = true;
            } else {
                $scope.delBar = false;
            }
        }

        function clearGalleryAdd() {
            $scope.moveGalleryIds = [];
            $scope.selectAllGallery = false;
            angular.forEach($scope.photos, function (photo) {
                photo.select_photoAll = false;
                angular.forEach(photo.galleries, function (item) {
                    item.select_photo = false;
                })
            })
        }

        /**************************************---文件夹操作---*************end********************************/


        /**************************************---照片排序操作---************start*******************************/
        /**
         * 照片排序
         * 实现照片拖动排序 不是替换 而是占位
         */
        $scope.photoSort = function () {
            if ($scope.qiniuId.length == 0) {
                swal({
                    title: $translate.instant("choose.editorMessage.notPicture"),
                    imageUrl: Theme.sweetHintImg(),
                    timer: 2000,
                    showConfirmButton: false
                });
                return;
            } else {
                setProductionStorage('sort');
                var picI = parseInt(localStorage.getItem('picArrChoose'));
                localStorage.setItem('picArrChoose2', picI);
                $scope.delPic = JSON.parse(localStorage.getItem('delPic')) || [];
                localStorage.setItem('gallery2', JSON.stringify($scope.qiniuId));
            }
        };

        $scope.delPic = [];
        $scope.selectPage = function (photo) {
            $scope.picArr = JSON.parse(localStorage.getItem('picArr'));
            $scope.picI = parseInt(localStorage.getItem('picArrChoose'));
            var arr = $scope.picArr[$scope.picI];

            if (photo.seq && photo.seq.select) {
                $scope.delPic.push(photo.seq);
                $scope.delPic.sort(compare2('pageI', compare2('maskI')));
                arr = $scope.picArr[photo.seq.picI];
                arr.index -= 1;
                photo.seq = {
                    pageI: '',
                    maskI: '',
                    select: false
                }
            } else if ($scope.delPic.length) {
                var delArr = $scope.delPic.shift();
                arr = $scope.picArr[delArr.picI];
                arr.index += 1;
                photo.seq = {
                    pageI: delArr.pageI,
                    maskI: delArr.maskI,
                    select: true,
                    picI: delArr.picI
                }
            } else {
                if (arr.index + 1 >= arr.maskI) {
                    if ($scope.picI + 1 < $scope.picArr.length) {
                        arr = $scope.picArr[++$scope.picI];
                    } else {
                        SweetAlert.swal({
                            title: $translate.instant("choose.editorMessage.photoFillingIsComplete"),
                            imageUrl: Theme.sweetHintImg(),
                            text: $translate.instant("choose.editorMessage.pleaseMakeItImmediately"),
                            timer: 1500,
                            showConfirmButton: false
                        });
                        return
                    }
                }
                arr.index += 1;
                photo.seq = {
                    pageI: arr.pageI,
                    maskI: arr.index,
                    select: true,
                    picI: $scope.picI
                }
            }

            photo.pageI = photo.seq.pageI;
            photo.maskI = photo.seq.maskI;
            localStorage.setItem('picArr', JSON.stringify($scope.picArr));
            localStorage.setItem('picArrChoose', $scope.picI);
            localStorage.setItem("gallery", JSON.stringify($scope.qiniuId));
        };

        $scope.sureSort = function () {
            localStorage.setItem("gallery", JSON.stringify($scope.qiniuId));
            localStorage.setItem("isSort", "true");
            setProductionStorage('start');
            var picArr = JSON.parse(localStorage.getItem("picArr")) || [];
            localStorage.setItem("picArrCopy", JSON.stringify(picArr));
            $scope.qiniuId = JSON.parse(localStorage.getItem("gallery")) || [];
            localStorage.setItem("gallery2", JSON.stringify($scope.qiniuId));
            var picI = parseInt(localStorage.getItem('picArrChoose'));
            localStorage.setItem('picArrChoose2', picI);
            localStorage.setItem('delPic', JSON.stringify($scope.delPic));
        };

        //返回上一页 （从排序页面返回到工作区）
        $scope.showStartBtn = function () {
            getItem();
            setProductionStorage('start');
            $scope.selectAllGallery = $scope.delBar = false;
            angular.forEach($scope.photos, function (p, i) {
                p.select_photoAll = false;
                angular.forEach(p.galleries, function (g, j) {
                    g.select_photo = false
                });
            });
            //这一步是分页下拉  刷新滚动条置顶
            window.scrollTo(0, 0);
            var picArrCopy = JSON.parse(localStorage.getItem("picArrCopy")) || [];
            localStorage.setItem("picArr", JSON.stringify(picArrCopy));
            $scope.qiniuId = JSON.parse(localStorage.getItem("gallery2")) || [];
            localStorage.setItem("gallery", JSON.stringify($scope.qiniuId));
            var picI = parseInt(localStorage.getItem('picArrChoose2'));
            localStorage.setItem('picArrChoose', picI);
        };
        /**************************************---照片排序操作---*************end********************************/

        function cancelSelect(data) {
            $scope.photoPic = [];
            angular.forEach(data, function (item) {
                item.flg = false;
                item.photo_select = false;
            });
            t = 0;
        }

        /**
         * 下一步跳转页面
         * 移除localStorage    pid?-go
         */
        $scope.nextTo = function () {         //下一步跳转页面时移除“一键Go”的localStorage
            $scope.countN++;
            localStorage.setItem('countN', $scope.countN);
            localStorage.removeItem("go");
            removeOldPageStorage();
            localStorage.setItem("gallery", JSON.stringify($scope.qiniuId));
            var t = 0;
            angular.forEach($scope.qiniuId, function (photo, i) {
                photo.usenum = 0;
                if (photo.width) {
                    photo.ratio = photo.width / photo.height;
                    if ((typeof photo.parameter) == 'string') {
                        photo.parameter = JSON.parse(photo.parameter);
                    }
                    localStorage.setItem("gallery", JSON.stringify($scope.qiniuId));

                } else {
                    var newImg = document.createElement('img');
                    newImg.identifier = photo.identifier;
                    newImg.src = $scope.domain + photo.identifier + '?imageMogr2/strip';
                    newImg.onload = function () {
                        t++;
                        photo.width = newImg.width;
                        photo.height = newImg.height;
                        photo.ratio = newImg.width / newImg.height;
                        if ((typeof photo.parameter) == 'string') {
                            photo.parameter = JSON.parse(photo.parameter);
                        }
                        localStorage.setItem("gallery", JSON.stringify($scope.qiniuId));
                    };
                }

            });
            setProductionStorage('view');
            goToMake();
        };

        /**
         * 一键Go 跳转页面
         * 设置localStorage    pid?-go
         */
        $scope.goTo = function () {
            var isHasLowPic = false;
            // if (!$scope.isCanClick) {
            //     return
            // }
            var isSort = localStorage.getItem('isSort');
            if (isSort) {
                $scope.qiniuId.sort(compare2('pageI', compare2('maskI')));
            }

            angular.forEach($scope.qiniuId, function (photo, i) {
                if (i < vm.counts) {
                    photo.usenum = 1;
                } else {
                    photo.usenum = 0;
                }
                if (photo.imgSize / 1024 < 150) {
                    isHasLowPic = true;
                }
                if ((typeof photo.parameter) == 'string') {
                    photo.parameter = JSON.parse(photo.parameter);
                }

                if (!photo.width) {
                    var newImg = document.createElement('img');
                    newImg.identifier = photo.identifier;
                    newImg.src = $scope.domain + photo.identifier + '?imageMogr2/strip';
                    newImg.onload = function () {
                        photo.width = newImg.width;
                        photo.height = newImg.height;
                        photo.ratio = newImg.width / newImg.height;
                        localStorage.setItem("gallery", JSON.stringify($scope.qiniuId));
                    };
                } else {
                    photo.ratio = photo.width / photo.height;
                    localStorage.setItem("gallery", JSON.stringify($scope.qiniuId));
                }
            });

            if (isHasLowPic) {
                SweetAlert.swal({
                        title: $translate.instant("choose.editorMessage.thereAreLowResolutionPhotos"),
                        imageUrl: Theme.sweetHintImg(),
                        showCancelButton: true,
                        closeOnConfirm: false,
                        confirmButtonText: $translate.instant("choose.editor.confirm"),
                        cancelButtonText: $translate.instant("choose.editor.cancel")
                    }, function (isConfirm) {
                        if (isConfirm) {
                            virtual();
                        } else {
                            return;
                        }
                    }
                )
            } else {
                virtual();
            }
        };

        function compare2(name, minor) {
            return function (o, p) {
                var a, b;
                if (o && p && typeof o === 'object' && typeof p === 'object') {
                    a = o[name];
                    b = p[name];
                    if (a === b) {
                        return typeof minor === 'function' ? minor(o, p) : 0;
                    }
                    if (typeof a === typeof b) {
                        return a < b ? -1 : 1;
                    }
                    return typeof a < typeof b ? -1 : 1;
                } else {
                    console.log("error");
                }
            }
        }

        //虚化展示
        function virtual() {
            if (vm.article.productBokehType!='None') {
                SweetAlert.swal({
                        title: $translate.instant("choose.editor.go"),
                        text: $translate.instant("choose.editorMessage.fillHint"),
                        imageUrl: Theme.sweetHintImg(),
                        showCancelButton: true,
                        confirmButtonText: $translate.instant("choose.editor.goOn"),
                        cancelButtonText: $translate.instant("choose.editor.sortBack"),
                    }, function (isConfirm) {
                        if (isConfirm) {
                            going();
                        } else {
                            return;
                        }
                    }
                )
            } else {
                swal.close();
                going();
            }
        };

        function going() {
            localStorage.setItem("go", JSON.stringify($scope.qiniuId));
            removeOldPageStorage();

            $scope.countN++;
            localStorage.setItem('countN', $scope.countN);
            setProductionStorage('view');
            goToMake();
        }

        function goToMake() {
            if (vm.pid) {
                if (localStorage.getItem('multipartUpload')) {
                    local_pages = JSON.parse(localStorage.getItem("pages")) || [];
                } else {
                    getLocalStorage();
                }
                // 一键Go
                goes = JSON.parse(localStorage.getItem("go"));

                // 新建作品
                //  显示/隐藏引导页
                $scope.isHide = localStorage.getItem('isHide') || false;
                if (!$scope.isHide) {
                    $(".come-in").show();
                }
                Article.get({id: $stateParams.aid}, function (resp) {
                    if (resp.status == 200) {
                        vm.article = resp.data;
                        ItemValue.get({id: $stateParams.vid}, function (res) {
                            if(res.status == 200){
                                vm.itemValue = res.data;
                                vm.pattern = vm.itemValue.patternType;
                                vm.productXmlLine = angular.copy(vm.itemValue.productXmlLines[0]);
                                angular.forEach(vm.itemValue.productXmlLines, function (line) {
                                    if (line.id == vm.xmlId) {
                                        vm.productXmlLine = angular.copy(line);
                                    }
                                })
                                vm.article.cover = vm.productXmlLine.coverImg;
                                vm.article.themeClassifyId = vm.productXmlLine.productXmlThemeId;
                                vm.article.productXmlThemeName = vm.productXmlLine.productXmlThemeName;
                                vm.article.productXmlId = vm.productXmlLine.productXmlId;
                                vm.article.productXmlName = vm.productXmlLine.productXmlName;
                                vm.article.musicIdentify = vm.productXmlLine ? vm.productXmlLine.musicIdentify : vm.itemValue.musicIdentify;
                                vm.article.itemValueId = vm.itemValue.itemValueId || vm.vid;

                                if (!vm.itemValue.productBokehType) {
                                    vm.article.bokehtype = 'None';
                                } else {
                                    vm.article.bokehtype = vm.itemValue.productBokehType;
                                }
                                Convert.xmlToDocument({
                                    identifier: vm.productXmlLine ? vm.productXmlLine.productXmlIdentifier : vm.itemValue.productXmlIdentifier,
                                    provider: 'qiniu'
                                }, function (res) {
                                    vm.replace = res.replace;
                                    setPageContent(res);
                                });
                            }else {
                                MessageService.error(res.message);
                            }
                        });
                    }
                })

                var workSave = {
                    pid: vm.pid,
                    vid: vm.vid,
                    xmlId: vm.xmlId,
                    date: new Date().getTime()
                };
                localStorage.setItem('work-save', JSON.stringify(workSave));
            } else if (vm.aid) {
                // 编辑作品
                Article.get({id: $stateParams.aid}, function (resp) {
                    if(resp.status == 200){
                        vm.article = angular.copy(resp.data);
                        ItemValue.get({id: resp.data.itemValueId}, function (res) {
                            if(res.status == 200){
                                vm.pattern = res.data.patternType;
                                vm.article.skuNumber = res.data.skuNumber;
                                vm.article.productBokehType = res.data.productBokehType;
                                vm.article.bokehtype = res.data.productBokehType;
                            }else {
                                MessageService.error(res.message);
                            }
                        });
                        Convert.xmlToDocument({
                            identifier: vm.article.fileName,
                            provider: 'qiniu'
                        }, function (res) {
                            vm.replace = res.replace;

                            if (!!res.galleries && !!res.galleries.gallery) {
                                localStorage.setItem("gallery", JSON.stringify(res.galleries.gallery));
                                // getLocalStorage();
                            }

                            getLocalStorage();
                            $scope.isHide = true;
                            setPageContent(res);
                        });
                    }else {
                        MessageService.error(resp.message);
                    }
                });
            }
        }

        function removeOldPageStorage() {
            localStorage.removeItem("saveOldPage");
            localStorage.removeItem("saveOldPageIndex");
            localStorage.removeItem("galleryCopy");
            localStorage.removeItem("delPic");
            localStorage.removeItem("picArrChoose");
            localStorage.removeItem("picArrChoose2");
            localStorage.removeItem("gallery2");
            localStorage.removeItem("picArrCopy");
            localStorage.removeItem("picArr");
            localStorage.removeItem("isSort");
        }isIphoneX

        $scope.goBackToProduct = function () {
            setProductionStorage('make');
        };
        function isIphoneX() {
            return /iphone/gi.test(window.navigator.userAgent) && window.screen.width === 375 && (window.screen.height === 812 || window.screen.height == 724);
        }

        $scope.isIphoneX = isIphoneX();

        var windowH = $(window).height();
        vm.wid = $(window).width();
        localStorage.setItem('windowH', windowH);

        $(window).scroll(function () {
            if ($scope.isIphoneX) {
                var wh = $(window).height(); //页面可视化区域高度
                if (wh > windowH) {
                    $(".iphoneX-content").height(36);
                    $(".footer_bar,.footer_pic").height(84);
                    $(".footer-title").height(76);
                } else {
                    $(".iphoneX-content").height(0);
                    $(".footer_bar,.footer_pic").height(48);
                    $(".footer-title").height(40);
                }
            }
            //    向下滑动加载照片
            var scrollTop = $(window).scrollTop();
            var widH = $(window).height();
            var docH = $(document).height();
            if (scrollTop + widH + 100 >= docH) {
                if (flag == true && localStorage.getItem('Production') == 'gallery') {
                    loadMore();
                } else {
                    return;
                }
            } else {
                return;
            }
        });

        $('.sticker-scroll').scroll(function () {
            var allWidth = 92 * $scope.stickerList.length - $(this).width() - 1;
            if ($(this).scrollLeft() >= allWidth && $scope.artlabelChooseId != null) {
                if ($scope.stickerList.length == vm.totalClipartItems) {
                    SweetAlert.swal({
                        title: $translate.instant("choose.editorMessage.allFilesHaveBeenLoaded"),
                        imageUrl: Theme.sweetHintImg(),
                        timer: 1000,
                        showConfirmButton: false
                    });
                    return
                }
                vm.indexArtNum++;
                getBackgrounds($scope.labels[$scope.artlabelChooseIndex], ClipArt, vm.indexArtNum, function (res) {
                    vm.totalClipartItems = res.items;
                    angular.forEach(res.arr, function (arr) {
                        $scope.stickerList.push(arr);
                    })

                });
            }
        });

        // 判断是否重复
        function checkExist(list, obj) {
            if (list == null || list.length == 0) {
                return true;
            }
            for (var i = 0; i < list.length; i++) {
                if (list[i].getFullYear() == obj.getFullYear() &&
                    list[i].getMonth() == obj.getMonth() &&
                    list[i].getDate() == obj.getDate()) {
                    return false;
                }
            }
            return true;
        }

        /**
         * Get document
         * @param obj
         */
        function setPageContent(obj) {
            var k = 0;
            // 正常页
            var arrUse = {
                pages: {
                    page: []
                }
            };
            // 备用页
            var arrUnUse = {
                pages: {
                    page: []
                }
            };
            vm.counts = 0;
            //新建
            if (vm.pid) {
                angular.forEach(obj.pages.page, function (page, index) {
                    angular.forEach(page.levels.level, function (level, n) {
                        if (level.imagebox && level.imagebox.image && level.imagebox.image.resource) {
                            level.imagebox.image = null;
                        }
                    })
                })
                var usebox = []; //模板中标记使用的页
                var unusebox = []; //模板中标记不使用的页
                for (var i = 0; i < obj.pages.page.length; i++) {
                    var page = obj.pages.page[i];
                    if (page.uuid == null) {
                        page.uuid = UidService.get();
                    }
                    if (!page.backup) {
                        page.count = 1;
                        arrUse.pages.page.push(page);
                        $scope.PAGELEN++;
                        k++;
                        angular.forEach(page.levels.level, function (level) {
                            if (level.imagebox && level.imagebox.geometry) {
                                vm.counts++;
                                if (k < 8 || $scope.PAGELEN <= 7) {
                                    vm.FirstSeven++;
                                }
                            }
                        })
                    }
                    var p = angular.copy(page);
                    //将模板所有页设为备用页
                    if (p.backup) {
                        p.count = 0;
                        unusebox.push(p);
                    } else {
                        p.backup = true;
                        usebox.push(p);
                    }
                }
                // 将备用页放在正常页面的后面
                // arrUnUse.pages.page = usebox.concat(unusebox);
                arrUnUse.pages.page = unusebox.concat(usebox);
            } else {
                for (var i = 0; i < obj.pages.page.length; i++) {
                    var page = obj.pages.page[i];
                    if (page.uuid == null) {
                        page.uuid = UidService.get();
                    }
                    if (!page.backup) {
                        arrUse.pages.page.push(page);
                        $scope.PAGELEN++;
                        k++;
                        angular.forEach(page.levels.level, function (level) {
                            if (level.imagebox && level.imagebox.geometry) {
                                vm.counts++;
                                if (k < 8 || $scope.PAGELEN <= 7) {
                                    vm.FirstSeven++;
                                }
                            }
                        })
                    } else {
                        arrUnUse.pages.page.push(page);
                    }
                }
                //计算页面使用次数
                for (var i = 0; i < arrUnUse.pages.page.length; i++) {
                    var p1 = arrUnUse.pages.page[i];
                    var count = 0;
                    for (var j = arrUse.pages.page.length - 1; j >= 0; j--) {
                        var p2 = arrUse.pages.page[j];
                        if (p1.uuid == p2.uuid) {
                            count++;
                        }
                    }
                    p1.count = count;
                }
            }

            obj.pages = angular.copy(arrUse.pages);

            vm.article.bgimgs2 = angular.copy(obj.bgimgs2);
            vm.article.documentpics = angular.copy(obj.documentpics);
            vm.article.masks = angular.copy(obj.masks);
            vm.article.cliparts = angular.copy(obj.cliparts);
            vm.cover = angular.copy(obj.cover);
            vm.article.document = choose(local_pages, obj);
            localStorage.setItem('article-count', vm.counts);


            //单页编辑 底下可选择的模板
            if (local_pages.page && local_pages.page.length > 0) {
                for (var i = 0; i < arrUnUse.pages.page.length; i++) {
                    var p = arrUnUse.pages.page[i];
                    var count = 0;
                    for (var j = 0; j < local_pages.page.length; j++) {
                        var p2 = local_pages.page[j];
                        if (p.uuid == p2.uuid) {
                            count++;
                        }
                    }
                    p.count = count;
                }
            }
            getAll2(arrUnUse);
            //平铺页   单页编辑
            getAll(vm.article.document);
            $scope.qiniuId = JSON.parse(localStorage.getItem("gallery")).sort(compare('usenum'));
            localStorage.setItem('gallery', JSON.stringify($scope.qiniuId));
            $scope.artlabelChooseId = $scope.labels[0].id || null;
            $scope.artlabelChooseIndex = 0;
            getRecommendSource(obj.cliparts.clipart, $scope.labels, ClipArt, vm.indexArtNum, 'CLIPART');
        }

        $scope.labels = [$translate.instant("choose.editorMessage.recommend")];
        vm.indexArtNum = 0;
        vm.totalClipartItems = 0;

        function getRecommendSource(objs, labels, url, num, attr) {
            var list = []
            angular.forEach(objs, function (obj, i) {
                var arr = {
                    name: obj.name,
                    identifier: obj.resource.identifier,
                    provider: obj.resource.provider,
                    themeClassifyName: $translate.instant("choose.editorMessage.recommend"),
                    themeClassifyId: null,
                    resource: obj.resource
                }
                list.push(arr);
            })

            var len = 0;
            if (objs && objs.length) {
                len = objs.length;
            }
            //分类
            ThemeClassify.getAllByCondition4({type: attr,storeId:vm.storeId}, function (res) {
                if(res.status == 200){
                    labels = angular.copy(res.data);

                    if (len) {
                        labels.unshift({
                            name: $translate.instant("choose.editorMessage.recommend"),
                            id: null
                        })
                        setSource(attr, list, labels)
                        vm.totalClipartItems = len;
                    } else if (labels.length) {
                        getBackgrounds(labels[0], url, num, function (res) {
                            vm.totalClipartItems = res.items;
                            setSource(attr, res.arr, labels);
                        });
                    }
                }else {
                    MessageService.error(res.message);
                }
            });
        }

        function setSource(attr, list, labels) {
            $scope.stickerList = angular.copy(list);
            vm.cliparts = angular.copy($scope.stickerList);
            $scope.labels = labels;
            $scope.artlabelChooseId = labels[0].id;
            $scope.artlabelChooseIndex = 0;
        }

        function getBackgrounds(label, url, num, callback) {
            var list = {
                items: 0,
                arr: []
            };
            url.byCondition3({
                items: [
                    {key: "themeClassify.id", op: "=", value: label.id}],
                page: num,
                size: vm.itemsPerPage,
                sort: ["seq,asc"]
            }, function (res, headers) {
                list.items = headers('X-Total-Count');
                if(res.status==200){
                    angular.forEach(res.data, function (resp) {
                        var arr = {
                            name: resp.name,
                            identifier: $scope.domain + resp.identifier,
                            provider: resp.provider,
                            themeClassifyName: resp.themeClassifyName,
                            themeClassifyId: resp.themeClassifyId,
                            resource: {
                                identifier: $scope.domain + resp.identifier,
                                provider: resp.provider,
                            }
                        }
                        list.arr.push(arr);
                    })
                    callback.call(this, list);
                }else{
                    swal({
                        title: res.message,
                        text: "",
                        imageUrl: Theme.sweetSuccedImg(),
                        timer: 2000,
                        showConfirmButton: false
                    });
                }
            });
        }

        function showPages() {
            $timeout(function () {
                $scope.loading = false;
                $(".page-loading").hide().css({'opacity': 0});
                $li.show();
                $(".guide-view").removeClass('opacity-zero');
                // 等到刷新后直接赋值
                localStorage.setItem('pages', JSON.stringify($scope.template.pages));
            });

        }

        function choose(local_pages, res) {
            console.log($scope.picArr);
            // 一键Go
            if ((goes != null || goes != undefined) && goes.length && vm.vid) {
                var i = 0;
                angular.forEach(res.pages.page, function (page) {
                    if (page.backup) {
                        return
                    }
                    var arr = [];
                    angular.forEach(page.levels.level, function (level, j) {
                        // level.sort(compare('imagebox'));
                        var len = 0, img = level.imagebox;
                        if (img && img.geometry) {
                            len++;
                            if (!img.image) {
                                img.image = {}
                            }
                            if (len > 1) {
                                // 得到占位框的宽高比
                                img.ratio = img.geometry.width / img.geometry.height;
                                if (goes[i]) {
                                    goes[i].index = i;
                                    arr.push(goes[i]);
                                    i++;
                                }
                                console.log(j)
                                if (j == page.levels.level.length - 1) {
                                    // 按照占位框的宽高比排序
                                    page.levels.level.sort(compare('ratio'));
                                    // 按照工作区中图片的宽高比排序
                                    arr.sort(compare('ratio'));
                                }
                            } else {
                                if (!goes[i]) {
                                    return
                                }
                                if(level.variable){
                                    if(vm.variableBoxDatas.length&&level.name){
                                        var flag = true;
                                        for (var _i = 0; _i < vm.variableBoxDatas.length; _i++) {
                                            if(vm.variableBoxDatas[_i].name==level.name){
                                                flag = false;
                                                if(!vm.variableBoxDatas[_i].value){
                                                    vm.variableBoxDatas[_i].value = 'https://photoavatar-pic-dev.deltazo.com/file-463ea37f-1577-4451-a903-dc534e83f5f1'
                                                }
                                                vm.variableBoxDatas[_i].identifier = vm.variableBoxDatas[_i].value;
                                                $.ajax({
                                                    type: "GET",
                                                    url: vm.variableBoxDatas[_i].value + "?imageInfo",
                                                    async: false,
                                                    success: function (va) {
                                                        vm.variableBoxDatas[_i].imgSize = va.size;
                                                        if (va.orientation == "Left-bottom" || va.orientation == "Right-top" || va.orientation == "Left-top" || va.orientation == "Right-bottom") {
                                                            vm.variableBoxDatas[_i].width = va.height;
                                                            vm.variableBoxDatas[_i].height = va.width;
                                                        }else{
                                                            vm.variableBoxDatas[_i].width = va.width;
                                                            vm.variableBoxDatas[_i].height = va.height;
                                                        }
                                                        goes.splice(i,0,vm.variableBoxDatas[_i]);
                                                        img.image = imgParamter(img, goes[i], i);
                                                        if (vm.article.productBokehType!='None') {
                                                            img.blurredrectangle = {}
                                                        }
                                                        i++
                                                    },
                                                    error: function (request) {

                                                    }
                                                });
                                                break
                                            }
                                        }
                                        if(flag){
                                            img.image = imgParamter(img, goes[i], i);
                                            if (vm.article.productBokehType!='None') {
                                                img.blurredrectangle = {}
                                            }
                                            i++
                                        }
                                    }
                                }else{
                                    img.image = imgParamter(img, goes[i], i);
                                    if (vm.article.productBokehType!='None') {
                                        img.blurredrectangle = {}
                                    }
                                    i++
                                }
                            }
                        }
                    })
                });
            } else {
                // $scope.template.pages.page中的内容
                if (local_pages.page && local_pages.page.length > 0) {
                    // vm.counts = 0;
                    res.pages = angular.copy(local_pages);
                    angular.forEach(res.pages.page, function (p, index) {
                        // if (!p.backup) {
                        //     vm.counts += p.imageboxes.imagebox.length;
                        // }
                        angular.forEach(p.levels.level, function (level, i) {
                            var img = level.imagebox;
                            if (img && img.geometry && p && img.blobImage) {
                                img.blurredrectangle = img.blurredrectangle || {};
                                var imgIdentifier = "";
                                if (img.image && img.image.resource && img.image.resource.identifier) {
                                    imgIdentifier = img.image.resource.identifier;
                                }
                                if (!img.image) {
                                    img.image = {};
                                }
                                img.image = {
                                    resource: {
                                        identifier: imgIdentifier,
                                        provider: 'qiniu'
                                    },
                                    parameter: img.image.parameter || [],
                                    offsetx: img.image.offsetx || 0,
                                    offsety: img.image.offsety || 0,
                                    angle: img.image.angle || 0,
                                    scale: img.image.scale || 1,
                                    index: img.image.index ? img.image.index : vm.pid ? i :'',
                                    width: img.image.width || '',
                                    height: img.image.height || '',
                                    scaleW: img.image.scaleW || 1,
                                    scaleH: img.image.scaleH || 1,
                                    imgSize: img.image.imgSize || '',
                                    lowSize: img.image.lowSize == false ? false : true,
                                    resourceid: img.image ? img.image.sourceId ? img.image.sourceId : img.image.resourceid ? img.image.resourceid : '' : ''
                                };
                            }
                        })
                    });
                }
            }

            vm.article.document = {
                pages: res.pages
            };

            localStorage.removeItem("go");
            return res;
        }

        function compare(property) {
            return function (a, b) {
                var value1 = a[property];
                var value2 = b[property];
                return value1 - value2;
            }
        }

        function imgParamter(img, arr, i) {
            return {
                resource: {
                    identifier: img.image.resource && img.image.resource.identifier != '' ? img.image.resource.identifier : arr.identifier,
                    provider: 'qiniu',
                    width: arr.width,
                    height: arr.height
                },
                parameter: arr.parameter,
                offsetx: img.image.offsetx || 0,
                offsety: img.image.offsety || 0,
                angle: img.image.angle || 0,
                scale: img.image.scale || 1,
                index: i,
                width: arr.width,
                height: arr.height,
                imageInfo: img.image.imageInfo ?img.image.imageInfo: null,
                imgSize: arr.imgSize,
                resourceid: arr.sourceId,
                scaleH: img.image.scaleH || 1,
                scaleW: img.image.scaleW || 1,
            };
        }

        function getAll(document) {
            var marLeft = getSingleLocalStorage('marginLeft');
            $ul.css({'margin-left': -marLeft + 'px'});
            $rootScope.currentCarouselIndex = Math.abs(parseInt(marLeft / ($scope.dWidth * 0.94)));
            $scope.visibleLeft = $rootScope.currentCarouselIndex ? true : false;
            $scope.visibleRight = $rootScope.currentCarouselIndex + 1 == document.pages.page.length ? true : false;
            getFontList();
            //取得xml文档内容
            if (!(local_pages.length || local_pages.page && local_pages.page.length)) {
                getPageToPx1(document)
            } else {
                //刷新操作
                $scope.template.pages = angular.copy(local_pages);
                imageboxLow();
                vm.pageItem = angular.copy($scope.template.pages[$rootScope.currentCarouselIndex])
                f = vm.counts;
                showPages();
            }
        }

        function getAll2(document) {
            $scope.pageAllMm = angular.copy(document.pages);
            getPageToPx1(document, 'backup');
        }

        function getSingleLocalStorage(value) {
            return localStorage.getItem(value) || 0
        }

        function getPageToPx1(document, attr) {
            vm.template = angular.copy(document);
            documentAnalysis($scope, $http, vm, vm.template,FontManagement, 'gaoji', function(page,index){
                //平铺页面
                if ((index == 0 || index == $scope.PAGELEN - 1) && vm.pattern == 'BOOK') {
                    page.styleScale = $scope.dWidth * 0.6 / page.mediabox.width;
                } else {
                    page.styleScale = $scope.dWidth * 0.45 / page.mediabox.width;
                }
                // 编辑页面
                if (page.isMaxWidth) {
                    page.styleScale2 = $scope.dWidth * 0.94 / page.mediabox.width;
                } else {
                    page.styleScale2 = ($scope.dHeight - $scope.tHeight) / page.mediabox.height;
                }
                page.ratio = page.mediabox.width*page.styleScale / page.mediabox.width;
                page.ratio2 = page.mediabox.width*page.styleScale2 / page.mediabox.width

            }, function (res) {
                vm.thumbnailScale = 300 / res.pages.page[0].mediabox.width;
                if (attr == 'backup') {
                    $scope.pageAllPx = res.pages;
                } else {
                    $scope.template.pages = res.pages;
                    // if (vm.counts == 0 || vm.FirstSeven == 0) {
                    //     showPages();
                    // }
                    showPages();
                    $scope.isLeftRotation = false;
                    setTimeout(function(){
                        vm.thumbnailScale = 300 / $scope.template.pages.page[0].mediabox.width;
                        getSameUseNum();
                        imageboxLow();
                    },200)
                }

            })
        }

        function imageboxLow() {
            $scope.template.pages.page.forEach(function (page) {
                if(page && page.levels && page.levels.level){
                    page.levels.level.forEach(function (level) {
                        if(level.imagebox&&level.imagebox.image && level.imagebox.image.resource && level.imagebox.image.resource.identifier){
                            pxInsufficient(level.imagebox, vm.imgSize, vm.imgDpi)
                        }
                    })
                }
            })
        }
        function getSameUseNum() {
            angular.forEach($scope.template.pages.page, function (page, index) {
                angular.forEach(page.levels.level, function (level, i) {
                    var imagebox = level.imagebox;
                    if (imagebox && imagebox.image) {
                        for (var j = 0; j < $scope.qiniuId.length; j++) {
                            if ($scope.qiniuId[j].sourceId == imagebox.image.resourceid) {
                                imagebox.image.index = j;
                            }
                        }
                    }
                })
            })
        }

        function getScale(screenW, screenH, pageW, pageH) {
            if (screenW * 0.94 / (screenH - $scope.tHeight) < pageW / pageH) {
                //宽定，高不定
                return true;
            } else {
                //高定，宽不定
                return false;
            }
        }

        function getGeometryPx(page) {
            return {
                height: unitTransform(page.height),
                width: unitTransform(page.width),
                x: unitTransform(page.x),
                y: unitTransform(page.y)
            }
        }

        /*******************************************图片功能****************************start*********************************************/
        function getImageScale(imagebox, images) {
            var w0 = angular.copy(imagebox.width);
            var h0 = angular.copy(imagebox.height);
            if (imagebox.resource) {
                w0 = angular.copy(imagebox.resource.width);
                h0 = angular.copy(imagebox.resource.height);
                if (imagebox.angle == 90 || imagebox.angle == 270) {
                    w0 = angular.copy(imagebox.resource.height);
                    h0 = angular.copy(imagebox.resource.width);
                }
            } else {
                if (imagebox.angle == 90 || imagebox.angle == 270) {
                    w0 = angular.copy(imagebox.height);
                    h0 = angular.copy(imagebox.width);
                }
            }
            var x = 0, y = 0;

            var w = angular.copy(w0);
            var h = angular.copy(h0);
            var maskWidth = images.width;
            var maskHight = images.height;
            var isWidth = true;
            if ((w0 <= h0 || maskWidth <= maskHight) && (w0 / h0 < maskWidth / maskHight) || w0 >= h0 && maskWidth >= maskHight && (w0 / h0 < maskWidth / maskHight)) {
                w0 = maskWidth;
                h0 = maskWidth * h / w;
                isWidth = true;
            } else {
                h0 = maskHight;
                w0 = maskHight * w / h;
                isWidth = false;
            }

            var scaleW = w0 / w;
            var scaleH = h0 / h;
            x = x / scaleW;
            y = y / scaleH;
            return {
                isWidth: isWidth,
                nWidth: w0,
                nHeight: h0,
                scaleW: scaleW,
                scaleH: scaleH,
                x: x,
                y: y
            }
        }

        var f = 0;

        $scope.modeIn = function () {
            changeBlurred(true);
        };
        $scope.modeOut = function () {
            changeBlurred(false);
        };

        function changeBlurred(modeIn) {
            getCurrentImage();
            var imagebox = $scope.currentPage.levels.level[$scope.i].imagebox;

            if (modeIn) {
                imagebox.bokehtype = 'None'
                $(".cut-image").show();
            } else {
                imagebox.bokehtype = vm.article.bokehtype;
                imagebox.image.angle = 0;
                $(".cut-image").hide();
            }

            imgScale(imagebox, $scope.index, $scope.i, 0, 0, null, $scope, vm);
        }

        /**
         * 3种返回状态
         * 1： 平铺页面---->产品选择
         * 2： 图片编辑---->作品制作当前页
         * 3： 作品制作页面---->平铺页面
         */
        $scope.backTo = function () {
            var index = $rootScope.currentCarouselIndex;
            // 平铺页面---->产品选择
            if ($scope.status == 'view') {
                swal({
                    title: $translate.instant("choose.editorMessage.worksNotSave"),
                    text: "",
                    imageUrl: Theme.sweetHintImg(),
                    showCancelButton: true,
                    confirmButtonText: $translate.instant("choose.editor.cancel"),
                    cancelButtonText: $translate.instant("choose.editor.confirm"),
                    closeOnConfirm: true
                }, function (isConfirm) {
                    if (isConfirm) {
                    } else {
                        $scope.bool = false;
                        if (vm.pid) {
                            $state.go('thumbnail',{storeId:vm.storeId,pid:vm.pid,vid:vm.vid,aid:vm.aid});
                        } else {
                            $state.go("product-view-ec", {storeId: vm.storeId, aid: vm.aid});
                        }
                        removeAll();
                    }
                }, function () {
                });
            }

            // 图片编辑---->作品制作当前页
            if ($scope.showCut) {
                $scope.showCut = false;
                $scope.showBottomMenu = true;
                $scope.template.pages.page[index].levels.level[$scope.template.levelI].imagebox = $scope.cutImagebox;
                $scope.cutImagebox = [];
                tipStatus(false);
                $(".edit-head").css({position: 'fixed'});
                return
            }
            // 文字---->作品制作当前页
            if ($scope.showTextModal) {
                $scope.showTextMenu = false;
                $scope.showTextModal = false;
                $scope.showBottomMenu = true;
                tipStatus(false);
                var levels = $scope.template.pages.page[index].levels.level
                if (vm.addText) {
                    levels.splice($scope.template.levelI, 1);
                    $scope.template.levelI = levels.length - 1;
                } else {
                    levels[$scope.template.levelI].textbox = angular.copy($scope.textCopy);
                }
                vm.addText = false;
                $scope.textCopy = [];
                tipStatus(false);
                return
            }

            // 作品制作页面---->平铺页面
            if ($scope.status == 'make') {
                swal({
                    title: $translate.instant("choose.editorMessage.pageNotSave"),
                    text: "",
                    imageUrl: Theme.sweetHintImg(),
                    showCancelButton: true,
                    confirmButtonText: $translate.instant("choose.editor.cancel"),
                    cancelButtonText: $translate.instant("choose.editor.confirm"),
                    closeOnConfirm: true
                }, function (isConfirm) {
                    if (!isConfirm) {
                        $scope.template.pageI = null;
                        tipStatus(false);
                        $scope.showTempMenu = false;
                        $scope.isReplaceShow = false;
                        $scope.showStickerMenu = false;
                        setProductionStorage('view');
                        localStorage.removeItem('marginLeft');

                        $scope.galleryCopy = JSON.parse(localStorage.getItem("galleryCopy"));
                        localStorage.setItem('gallery', JSON.stringify($scope.galleryCopy));
                        $scope.qiniuId = $scope.galleryCopy;

                        var pageI = localStorage.getItem("saveOldPageIndex");
                        var oldPage = JSON.parse(localStorage.getItem("saveOldPage"));
                        if (vm.pageItem == null) {
                            $scope.template.pages.page[pageI] = angular.copy(oldPage);
                        } else {
                            $scope.template.pages.page[pageI] = angular.copy(vm.pageItem);
                            vm.pageItem = null;
                        }
                        vm.counts = 0;
                        angular.forEach($scope.template.pages.page, function (item, index) {
                            angular.forEach(item.levels.level, function (level) {
                                if (level.imagebox && level.imagebox.geometry) {
                                    vm.counts++;
                                }
                            })
                        });
                        angular.forEach($scope.pageAllPx.page, function (item, index) {
                            var count = 0;
                            angular.forEach($scope.template.pages.page, function (page, index) {
                                if (item.uuid == page.uuid) {
                                    count++;
                                }
                            });
                            item.count = count
                        });
                        $ul.css({marginLeft: '0px'});
                        $("#small-pic").addClass('hide1');

                        backToScrollTop();
                        $scope.$digest();
                        return;
                    }
                }, function () {
                });

            }
        };

        function backToScrollTop() {
            // 设置滚动距离
            var viewScrollTop = localStorage.getItem('view-scrollTop') || 0;
            if (!window.__wxjs_is_wkwebview) {
                $('.template-view').css("transform", "translateY(-" + viewScrollTop + "px)");
                setTimeout(function () {
                    $('.template-view').css("transform", "translateY(0px)");
                    $(".edit-page-content")[0].scrollTop = viewScrollTop;
                }, 10);
            } else {
                setTimeout(function () {
                    $(".edit-page-content")[0].scrollTop = viewScrollTop;
                }, 100);
            }

        }

        $scope.isFirstEdit = true;
        if ($scope.status == 'make') {
            $scope.isFirstEdit = false;
        }
        /**
         * 平铺页面点击进入作品制作页
         * @param page  点击页
         * @param index 点击页的下标
         */
        $scope.clickToEdit = function (page, index) {
            vm.isDocumentTextDetection=false;
            if (vm.sortStatus) {
                return
            }
            $rootScope.currentCarouselIndex = index;
            // 当引导页点击“不在提示”以后就不再count++;
            if (!vm.guideStep) {
                $scope.countN++;
                localStorage.setItem('countN', $scope.countN);
            }

            if (!vm.guideStep && ($scope.countN == 9 || $scope.countN == 10 || $scope.countN == 11 || $scope.countN == 12 || $scope.countN == 13)) {
                $('.tip-image').addClass('hide1');
            } else {
                $('.tip-image').removeClass('hide1');
            }

            var str = parseInt($('.template-view')[0].style.webkitTransform.replace(/[^0-9]+/g, '') || 0);
            var scrollT = parseInt($(".edit-page-content")[0].scrollTop);

            localStorage.setItem('view-scrollTop', scrollT + str);

            vm.pageIndex = index;
            vm.pageItem = angular.copy(page);
            setReviewStorage(index);
            setProductionStorage('make');

            $scope.showBottomMenu = true;

            $ul.css({marginLeft: -($scope.dWidth * 0.94 * index) + 'px'});

            $scope.visibleLeft = $rootScope.currentCarouselIndex ? true : false;
            $scope.visibleRight = $rootScope.currentCarouselIndex + 1 == $scope.template.pages.page.length ? true : false;

            $('.edit-menu-make').addClass('opacity-zero1');

            $scope.isFirstEdit = false;
            imageboxLow()
        };

        /**
         * 切换当前页所使用的模板
         * @param index     点击模板页下标
         * @param page      被点击模板页
         */
        $scope.changeTemp = function (index, page) {
            // 所要展示的page
            var currentInd = $rootScope.currentCarouselIndex;

            var currentPage = angular.copy($scope.template.pages.page[currentInd]);
            // 两个page 相同时不交换
            if (currentPage.uuid == page.uuid) {
                $(".text-tip").removeClass('hide1');
                setTimeout(function () {
                    $(".text-tip").addClass('hide1');
                }, 2000);
                return;
            }

            // 模板选中状态判断条件
            $scope.selectedLi = page.uuid;

            //使用次数+1
            page.count++;

            // 拷贝被点击模板     page不能受影响
            var clickPage = angular.copy(page);

            // 使用次数-1
            for (var i = $scope.pageAllPx.page.length - 1; i >= 0; i--) {
                var element = $scope.pageAllPx.page[i];
                if ($scope.template.pages.page[currentInd].uuid == element.uuid) {
                    element.count--;
                }
            }

            angular.forEach($scope.template.pages.page[currentInd].levels.level, function (level, l) {
                // 用户添加的"素材"需要留在当前页面
                if (level.imageart && level.imageart.geometry) {
                    if (level.imageart.useradded) {
                        var currentLevel = addLevel(clickPage);
                        currentLevel.imageart = level.imageart;
                    }
                }

                // 用户添加的"文字"需要留在当前页面
                if (level.textbox && level.textbox.geometry) {
                    if (level.textbox.useradded) {
                        var currentLevel = addLevel(clickPage);
                        currentLevel.textbox = level.textbox;
                    }
                }
            })

            // 开始交换
            $scope.template.pages.page[currentInd] = angular.copy(clickPage);
            $scope.template.pages.page[currentInd].backup = false;
            $scope.template.pages.page[currentInd].seq = currentInd;

            // 占位框从图片 有---->无 排序
            var arrs = [];
            angular.forEach(currentPage.levels.level, function (level) {
                if (level.imagebox && level.imagebox.geometry) {
                    var imagebox = level.imagebox;
                    if (imagebox.image && imagebox.image.resource && imagebox.image.resource.identifier) {
                        if ($scope.qiniuId.length && $scope.qiniuId[imagebox.image.index]) {
                            $scope.qiniuId[imagebox.image.index].usenum == 0 ? 0 : $scope.qiniuId[imagebox.image.index].usenum--;
                        }
                        arrs.push(imagebox)
                    }
                }
            })

            var i = 0;
            angular.forEach($scope.template.pages.page[currentInd].levels.level, function (level, l) {
                if (level.imagebox && level.imagebox.geometry) {
                    var imagebox = level.imagebox;
                    imagebox.bokehtype = vm.article.bokehtype;
                    if (vm.article.productBokehType!='None') {
                        imagebox.blurredrectangle = {}
                    }

                    verifyPic(arrs,i,imagebox,currentInd,l)
                    i++;
                }
            })
            vm.counts = 0;
            angular.forEach($scope.template.pages.page, function (item, index) {
                angular.forEach(item.levels.level, function (level) {
                    if (level.imagebox && level.imagebox.geometry) {
                        vm.counts++;
                    }
                })
            });
            setGalleryStorage();
        };


        function verifyPic(arrs,i,imagebox,currentInd,l){
            if (arrs[i]) {
                // $.ajax({
                //     type: "GET",
                //     url: arrs[i].image.resource.identifier + "?imageInfo",
                //     async: false,
                //     success: function (va) {
                //         console.log("i: "+i)
                //         if(va.format=='heic'){
                //             swal({
                //                 title: "照片格式错误",
                //                 text: "请更换使用JPG格式图片添加至相框！",
                //                 timer: 2000,
                //                 showConfirmButton: false
                //             });
                //             // i++;
                //             // return
                //         }else{
                            imagebox.imgUrl = arrs[i].imgUrl;
                            imagebox.image = angular.copy(arrs[i].image);
                            imgScale(imagebox, currentInd, l, 0, 0, 'center', $scope, vm);
                            if (imagebox.image && $scope.qiniuId.length && $scope.qiniuId[imagebox.image.index]) {
                                $scope.qiniuId[imagebox.image.index].usenum++;
                            }
                        // }
                //     }
                // });

            } else {
                imagebox.imgUrl = null;
                imagebox.image = {
                    resource: null,
                    filterResource: {
                        identifier: '',
                        provider: ''
                    },
                    offsetx: 0,
                    offsety: 0,
                    width: '',
                    height: '',
                    imgsize: '',
                    index: '',
                    parameter: [],
                    scale: 1,
                    angle: 0,
                }
                imagebox.blobImage = null;
            }

        }

        var moveLaR = function () {
            var page = $scope.template.pages.page[$rootScope.currentCarouselIndex];
            if ((window.orientation == 90 || window.orientation == -90) && vm.flags) {
                $li.removeClass('template-heng').addClass('template-heng2');
                var heights = $scope.dWidth * 0.94 * page.height / page.width - 1;
                $("#slide" + $rootScope.currentCarouselIndex).find(".slide-content").css({'height': heights});
            }
            $li.removeClass('template-heng3');
            tipStatus(false);
            $(".change-btn").hide();
            mL = Math.abs(parseFloat($ul.css('marginLeft')));
            liW = parseFloat($li[0].getBoundingClientRect().width);
            ulW = liW * $scope.PAGELEN;

            $scope.showBottomMenu = true;
        };

        /**
         * 左移按钮
         */
        $scope.pageLeft = function () {
            moveLaR();
            $scope.visibleRight = false;
            if (runL) {
                if (mL <= liW + 10) {
                    $scope.visibleLeft = false;
                }
                var index = $rootScope.currentCarouselIndex;
                $rootScope.currentCarouselIndex--;

                $ul.css({opacity: 0}).removeClass('fade-out').removeClass('is-paused');
                $ul.css({marginLeft: -(mL - liW) + 'px'});
                setTimeout(function () {
                    runL = true;
                    $ul.addClass('is-paused').addClass('fade-out').css({opacity: 1});
                }, 700);

                setReviewStorage($rootScope.currentCarouselIndex);
                setGalleryStorage();
                localStorage.setItem("marginLeft", $scope.dWidth * 0.94 * $rootScope.currentCarouselIndex);

                vm.pageIndex = $rootScope.currentCarouselIndex;
                vm.pageItem = angular.copy($scope.template.pages.page[vm.pageIndex]);
            }
            runL = false;
        };

        /**
         * 右移按钮
         */
        $scope.pageRight = function () {
            moveLaR();
            $scope.visibleLeft = true;
            if (runR) {
                if (mL + liW >= ulW - liW - 10) {
                    $scope.visibleRight = true;
                }
                $rootScope.currentCarouselIndex++;

                $ul.css({opacity: 0}).removeClass('fade-out').removeClass('is-paused');
                $ul.css({marginLeft: -(mL + liW) + 'px'});
                setTimeout(function () {
                    runR = true;
                    $ul.addClass('is-paused').addClass('fade-out').css({opacity: 1});
                }, 700);

                setReviewStorage($rootScope.currentCarouselIndex);
                setGalleryStorage();

                vm.pageIndex = $rootScope.currentCarouselIndex;
                vm.pageItem = angular.copy($scope.template.pages.page[vm.pageIndex]);
                localStorage.setItem("marginLeft", $scope.dWidth * 0.94 * $rootScope.currentCarouselIndex);
            }
            runR = false;
        };

        // 旋转屏幕
        window.addEventListener('orientationchange', function () {
            setTimeout(function () {
                $(".save-page").addClass('hide1');
                if (window.orientation == 180 || window.orientation == 0) {
                    //竖屏
                    $(".page-orientation").addClass('hide1');
                    if ($scope.isSave) {
                        return
                    }
                    orientationChange(false);
                    if (vm.isOrientation) {
                        vm.isOrientation = false;
                        return
                    }

                    var mar = ($scope.dWidth * 0.94 - $li.width()) / 2;
                    $li.css({'margin-left': mar}).removeClass('mar-top-0');
                } else if (window.orientation == 90 || window.orientation == -90) {
                    //横屏
                    $(".page-orientation").removeClass('hide1');
                    if ($scope.isSave) {
                        return
                    }
                    orientationChange(true);
                    var mar = ($scope.dWidth * 0.94 - $li.width()) / 2;
                    $li.css({'margin-left': mar}).addClass('mar-top-0');
                }
            }, 500);
        });

        if (window.orientation == 90 || window.orientation == -90) {
            $(".page-orientation").removeClass('hide1');
            vm.flags = false;
            vm.isOrientation = true;
            $(document.body).addClass('bgColor');
        }

        function orientationChange(flag) {
            vm.flags = flag;
            $scope.dHeight = document.documentElement.clientHeight;
            $scope.dWidth = document.documentElement.clientWidth;
            $(document.body).toggleClass('bgColor');

            $("body").css({width: $scope.dWidth, 'min-width': $scope.dWidth});      //设置页面的最小宽度
            localStorage.setItem("marginLeft", $scope.dWidth * 0.94 * $rootScope.currentCarouselIndex);
        }

        /**
         * 放大缩小及删除
         */
        function changeImgOffset(zoomIn) {
            getCurrentImage();
            var imagebox = $scope.currentImage.image;

            var number = 1.2;
            if (zoomIn) {
                imagebox.scale = imagebox.scale ? imagebox.scale * number : number;
            } else {
                if (imagebox.scale.toFixed(2) <= 1) {
                    imagebox.scale = 1;
                    return;
                }
                imagebox.scale = imagebox.scale / number;
            }
            imagebox.offsetx = 0;
            imagebox.offsety = 0;
            $("#cut-img").css({left: imgX, top: imgY});

            $scope.moveImg = {
                width: $("#cut-opacity").width(),
                height: $("#cut-opacity").height(),
                angle: imagebox.angle
            };
            pxInsufficient($scope.currentImage, vm.imgSize, vm.imgDpi);
        }

        function getCurrentImage() {
            $scope.index = $rootScope.currentCarouselIndex || 0;
            $scope.i = $scope.template.pages.page[$scope.index].selectImgIndex;
            $scope.imgs = document.getElementById("imgInput" + $scope.index + '' + $scope.i);
            $scope.imgReals = $(".imgBox" + $scope.index + '' + $scope.i);
            $scope.currentPage = $scope.template.pages.page[$scope.index];
        }

        var boxW = 0, boxH = 0, picW = 0, picH = 0, scale = 0;

        function getDpi(box) {
            boxW = unitTransformPx(box.geometry.width);
            boxH = unitTransformPx(box.geometry.height);
            picW = box.image.resource.width;
            picH = box.image.resource.height;
            scale = box.image.scale;
            var x = 0, y = 0;
            // 宽度适配
            if (box.adaptation == 'Width') {
                x = picW / (boxW / 25.4) / scale;
                y = boxH * picW / boxW / (boxH / 25.4) / scale;
            } else {
                x = boxW * picH / boxH / (boxW / 25.4) / scale;
                y = picH / (boxH / 25.4) / scale;
            }
            if (x < 150 || y < 150) {
                box.image.lowSize = true;
            } else {
                box.image.lowSize = false;
            }
        }

        $scope.zoomIn = function () {
            changeImgOffset(true);
        };

        $scope.zoomOut = function () {
            changeImgOffset(false);
        };

        var imgX = parseFloat($(".cut-position").css('left'));
        var imgY = parseFloat($(".cut-position").css('top'));
        /**
         * 进入图片编辑模式
         */
        $scope.cutImage = function () {
            getCurrentImage();
            $scope.showCut = true;
            $scope.template.levelI = $scope.i;
            var box = $scope.currentImage = $scope.currentPage.levels.level[$scope.i].imagebox;
            $("#cut-mask").attr('src', '');

            var ww = angular.copy(box.geometry.width);
            var hh = angular.copy(box.geometry.height);
            $scope.cutImagebox = angular.copy($scope.currentPage.levels.level[$scope.i].imagebox);
            var s = box.maskUrl + '?imageMogr2/strip/rotate/' + box.image.angle;
            if (ww > hh) {
                ww = $scope.dWidth * 0.8;
                hh = ww / box.geometry.width * box.geometry.height;
            } else {
                hh = ($scope.dHeight - 50) * 0.8;
                ww = hh / box.geometry.height * box.geometry.width;
            }
            if (ww > $scope.dWidth * 0.8) {
                ww = $scope.dWidth * 0.8;
                hh = ww / box.geometry.width * box.geometry.height;
            }
            if (hh > ($scope.dHeight - 50) * 0.8) {
                hh = ($scope.dHeight - 50) * 0.8;
                ww = hh / box.geometry.height * box.geometry.width;
            }

            if (box.adaptation == 'Width') {
                $scope.wOpacity = ww;
                $scope.hOpacity = '';
                $scope.w = ww;
                $scope.h = '';
            } else {
                $scope.hOpacity = hh;
                $scope.wOpacity = '';
                $scope.h = hh;
                $scope.w = '';
            }

            $scope.moveGeo = {
                width: ww,
                height: hh,
                scale: ww / box.geometry.width
            };
            imgX = ($scope.dWidth - ww) / 2;

            $scope.t = imgY;
            $scope.l = imgX;
            ImageService.convertImgToBase64(s, function (s) {
                var imagecanvas = document.createElement('canvas');
                var imagecontext = imagecanvas.getContext('2d');
                var newImg = document.createElement('img');
                newImg.src = 'content/images/zhezhao1.png';
                newImg.onload = function () {
                    newImg.onload = null;
                    var masks = document.createElement('img');
                    masks.src = s;
                    masks.onload = function () {
                        masks.onload = null;
                        imagecanvas.width = $scope.dWidth;
                        imagecanvas.height = $scope.dHeight - 50;
                        imagecontext.drawImage(masks, $scope.l, $scope.t, ww, hh);
                        imagecontext.globalCompositeOperation = 'source-out';
                        imagecontext.drawImage(newImg, 0, 0, $scope.dWidth, $scope.dHeight - 50);
                        $("#cut-mask").attr('src', imagecanvas.toDataURL());
                        $scope.imgW = ww;
                        $scope.imgH = hh;
                        $scope.moveImg = {
                            width: $("#cut-opacity").width(),
                            height: $("#cut-opacity").height(),
                            angle: box.image.angle
                        };
                        var coordX = box.image.offsetx * box.image.scale * $scope.moveGeo.scale;
                        var coordY = box.image.offsety * box.image.scale * $scope.moveGeo.scale;
                        $("#cut-img").css({
                            left: coordX + imgX,
                            top: coordY + imgY
                        });

                        $scope.$digest();
                    };
                };
                newImg.src = 'content/images/zhezhao1.png';
            });
        };

        /**
         * 拖拽编辑的图片
         */
        window.startEdit = function (e) {
            fn(e);
            var box = $scope.currentImage;
            if ($scope.moveImg.width <= 0 || $scope.moveImg.height <= 0) {
                $scope.moveImg = {
                    width: $("#cut-opacity").width(),
                    height: $("#cut-opacity").height(),
                    angle: box.image.angle
                };
            }
            selectImgBoxes($scope.i);
            $scope.imageArr = getImageScale($scope.moveImg, $scope.moveGeo);
            dragBox.clientX = e.changedTouches[0].clientX ? e.changedTouches[0].clientX : 0;
            dragBox.clientY = e.changedTouches[0].clientY ? e.changedTouches[0].clientY : 0;
            dragBox.coordX = box.image.offsetx * box.image.scale * $scope.moveGeo.scale * $scope.imageArr.scaleW;
            dragBox.coordY = box.image.offsety * box.image.scale * $scope.moveGeo.scale * $scope.imageArr.scaleH;
            drag = true;
        };

        window.dragEdit = function (e) {
            getCurrentImage();
            var box = $scope.currentImage;

            //乘以放大缩小倍数后的宽高
            var orignW = $scope.imageArr.nWidth * box.image.scale;
            var orignH = $scope.imageArr.nHeight * box.image.scale;
            var isWidth = $scope.imageArr.isWidth;
            if (drag) {
                var x = 0, y = 0;
                //手指离开屏幕
                if (!isWidth && box.image.scale == 1) {    //宽图
                    x = (dragBox.coordX + (e.changedTouches[0].clientX - dragBox.clientX)) / $scope.imageArr.scaleW;
                } else if (isWidth && box.image.scale == 1) {     //高图
                    y = (dragBox.coordY + (e.changedTouches[0].clientY - dragBox.clientY)) / $scope.imageArr.scaleH;
                } else if (box.image.scale > 1) {
                    x = (dragBox.coordX + (e.changedTouches[0].clientX - dragBox.clientX)) / $scope.imageArr.scaleW;
                    y = (dragBox.coordY + (e.changedTouches[0].clientY - dragBox.clientY)) / $scope.imageArr.scaleH;
                }

                //向上滑动;
                if (-y >= (orignH - $scope.moveGeo.height - 1)) {
                    y = -(orignH - $scope.moveGeo.height - 1);
                }
                //向左滑动;        <-----
                if (-x >= (orignW - ($scope.moveGeo.width + 1))) {
                    x = -(orignW - ($scope.moveGeo.width + 1));
                }
                //向下滑动;
                if (y >= 0) {
                    y = 0;
                }
                // 向右滑动;    ---->
                if (x >= 0) {
                    x = 0;
                }

                $("#cut-img").css({left: x + imgX, top: y + imgY});

                box.image.offsetx = x / box.image.scale / $scope.moveGeo.scale;
                box.image.offsety = y / box.image.scale / $scope.moveGeo.scale;

                $scope.$digest();
                e.stopPropagation();
                e.preventDefault();
                return false;

            }

        };

        window.stopEdit = function () {
            drag = false;
            dragBox = {};
        };

        /**
         * 保存所编辑过的图片
         */
        $scope.saveMove = function () {
            getCurrentImage();
            var box = $scope.currentImage;
            $scope.showBottomMenu = true;

            var imageArr = getImageScale(box.image, box.geometry);
            box.image.scaleW = imageArr.scaleW;
            box.image.scaleH = imageArr.scaleH;
            tipStatus(false);

            box.blobImage = true;
            $scope.showCut = false;
            var newImg = document.createElement('img');
            var img = box.imgUrl + '?imageMogr2/strip/thumbnail/!20p';
            if (box.image.angle != 0) {
                img += '/rotate/' + box.image.angle
            }
            newImg.src = img;
            newImg.onload = function () {
                box.image.resource.width = angular.copy(newImg.width * 5);
                box.image.resource.height = angular.copy(newImg.height * 5);
                console.log(newImg.width)
                console.log(newImg.height)
                imgScale(box, $scope.index, $scope.i, box.image.offsetx, box.image.offsety, null, $scope, vm);
                $scope.$digest();
            }
            newImg.src = img;
        };

        /**
         * 选择图片
         * @param flag   true: 逆时针旋转    false： 顺时针旋转
         */
        $scope.rotateImage = function (flag) {
            var box = $scope.currentImage;
            if (flag) {
                box.image.angle -= 90;
                if (box.image.angle == -90) {
                    box.image.angle = 270
                }
            } else {
                box.image.angle += 90;
                if (Math.abs(box.image.angle) == 360) {
                    box.image.angle = 0
                }
            }
            $scope.moveImg.angle = box.image.angle;
            $scope.imageArr = getImageScale($scope.moveImg, $scope.moveGeo);

            var imageEdit = getImageScale(box.image, box.geometry);

            box.image.scaleW = imageEdit.scaleW;
            box.image.scaleH = imageEdit.scaleH;

            if (imageEdit.isWidth) {
                $scope.w = $scope.imageArr.nWidth;
                $scope.h = '';
            } else {
                $scope.h = $scope.imageArr.nHeight;
                $scope.w = '';
            }

            box.image.offsetx = 0;
            box.image.offsety = 0;

            $("#cut-img").css({left: imgX, top: imgY});

            $scope.moveImg = {
                width: $("#cut-opacity").width(),
                height: $("#cut-opacity").height(),
                angle: box.image.angle
            }
        };

        $scope.addGallery = function () {
            getCurrentImage();

            $(".change,.cut-image").hide();
            $(".mode1,.mode2").addClass('hide1');
            $('.edit-menu').removeClass('opacity-zero1');

            tipStatus(false);
            $scope.showBottomMenu = true;

            if (!$scope.qiniuId) {
                return
            }

            $scope.multipartUpload = 'multipartUpload';
            localStorage.setItem("multipartUpload", "multipartUpload");
            setProductionStorage('start');
            localStorage.setItem('article-count', vm.counts);
            cancelSelect($scope.qiniuId)
        };

        // 点击显示 占位框中的 切换按钮
        $scope.isReplaceShow = true;
        $scope.replaceImage = function () {
            var index = $rootScope.currentCarouselIndex || 0;
            var i = $scope.template.pages.page[index].selectImgIndex || 0;
            if ($scope.isReplaceShow) {
                $(".change-btn").show();
            } else {
                $(".change-btn").hide();
            }
            $("#change-btn" + index + '' + i).hide();
            $scope.isReplaceShow = !$scope.isReplaceShow;
        };

        // 切换占位框图片
        $scope.changeMaskImage = function (index, i, e) {
            fn(e);
            var index0 = $rootScope.currentCarouselIndex != null ?$rootScope.currentCarouselIndex: 0;
            var i0 = $scope.template.pages.page[index].selectImgIndex != null ?$scope.template.pages.page[index].selectImgIndex: 0;

            // 需要切换的占位框
            var box0 = $scope.template.pages.page[index0].levels.level[i0].imagebox;

            // 被切换的占位框
            var box = $scope.template.pages.page[index].levels.level[i].imagebox;

            if(box0.mask.resource.identifier&&box0.mask.resource.identifier.length){
                // $.ajax({
                //     type: "GET",
                //     url: box.image.resource.identifier + "?imageInfo",
                //     async: false,
                //     success: function (va) {
                //         if(va.format.toLowerCase()=='heic'){
                //             SweetAlert.swal({
                //                 title: '照片格式错误',
                //                 imageUrl: Theme.sweetHintImg(),
                //                 text: "请更换使用JPG格式图片添加至相框！",
                //                 timer: 2000,
                //                 showConfirmButton: false
                //             });
                //             $(".change-btn").hide();
                //             $('.tip-image').removeClass('hide1');
                //         }else{
                //             swapBox();
                //         }
                //     },
                //     error: function (request) {
                //
                //     }
                // });
                swapBox();
            }else if(box.mask.resource.identifier&&box.mask.resource.identifier.length){
                // $.ajax({
                //     type: "GET",
                //     url: box0.image.resource.identifier + "?imageInfo",
                //     async: false,
                //     success: function (va) {
                //         if(va.format.toLowerCase()=='heic'){
                //             SweetAlert.swal({
                //                 title: '照片格式错误',
                //                 imageUrl: Theme.sweetHintImg(),
                //                 text: "请更换使用JPG格式图片添加至相框！",
                //                 timer: 2000,
                //                 showConfirmButton: false
                //             });
                //             $(".change-btn").hide();
                //             $('.tip-image').removeClass('hide1');
                //         }else{
                //             swapBox();
                //         }
                //     },
                //     error: function (request) {
                //
                //     }
                // });
                swapBox();
            }else{
                swapBox();
            }


            function swapBox() {
                var img0 = box0.image;
                var imgUrl0 = box0.imgUrl;

                box0.image = box.image;
                box.image = img0;

                box0.imgUrl = box.imgUrl;
                box.imgUrl = imgUrl0;

                imgScale(box0, index0, i0, 0, 0, 'center', $scope, vm);
                imgScale(box, index0, i, 0, 0, 'center', $scope, vm);
                $(".change-btn").hide();
                $('.tip-image').removeClass('hide1');
                $scope.template.currentMenu = '';
            }
        };

        //这块是图片中需要上传的区域
        $scope.chooseImage = function ($index, i) {
            $scope.template.pages.page[$index].selectImgIndex = i;
            var box = $scope.template.pages.page[$index].levels.level[i].imagebox;
            $scope.i = i;
            $(".change,.cut-image").hide();
            $(".mode1,.mode2").addClass('hide1');
            $('.edit-menu').removeClass('opacity-zero1');
            $scope.showBottomMenu = true;
            $scope.showTextModal = false;
            $scope.showCut = false;

            tipStatus(true);
            if (box.image && box.image.resource && box.image.resource.identifier) {
                if (box.bokehtype != 'None') {
                    $(".mode1,.mode2").removeClass('hide1');
                }
                return
            }

            if (!$scope.qiniuId) {
                return
            }
            getCurrentImage();
            $scope.multipartUpload = 'multipartUpload';
            localStorage.setItem("multipartUpload", "multipartUpload");
            setProductionStorage('start');
            localStorage.setItem('article-count', vm.counts);
            cancelSelect($scope.qiniuId)
        };

        var selectImgBoxes = function ($index) {
            var index = $rootScope.currentCarouselIndex || 0;
            $scope.template.pages.page[index].selectImgIndex = $index;
        };
        var getCurrentPage = function (index) {
            if (typeof index == 'undefined') {
                index = getPageIndex();
            }
            return $scope.template.pages.page[index];
        };

        var getPageIndex = function () {
            return $rootScope.currentCarouselIndex || 0
        };

        var isImagebox = false;
        vm.isImageboxSelectItem = false;
        window.moveImageboxStart = function (e) {
            var index = getPageIndex();
            var targ = e.currentTarget ? e.currentTarget : e.srcElement;
            var textIndex = targ.dataset.index || vm.levelIndex;
            selectImgBoxes(textIndex);
            vm.levelIndex = $scope.i = $scope.template.levelI = parseInt(textIndex);
            vm.levelType = 'imagebox';
            vm.isImageboxSelectItem = true;
            $scope.index = $scope.template.pageI = index;

            var currentPage = $scope.template.pages.page[$scope.index];
            var sticker = currentPage.levels.level[textIndex].imagebox;
            vm.cropImagebox = angular.copy(sticker);
            stickerDragBox.x = e.changedTouches[0].clientX || 0;          //鼠标到页面左边的距离
            stickerDragBox.y = e.changedTouches[0].clientY || 0;          //鼠标到页面顶部的距离
            stickerDragBox.l = sticker.image.offsetx * sticker.image.scale * currentPage.styleScale2;
            stickerDragBox.t = sticker.image.offsety * sticker.image.scale * currentPage.styleScale2;
            stickerDragBox.r = -(sticker.image.width * sticker.image.scale - sticker.geometry.width) * currentPage.styleScale2;
            stickerDragBox.b = -(sticker.image.height * sticker.image.scale - sticker.geometry.height) * currentPage.styleScale2;
            isImagebox = true;
            $scope.$apply();
            fn(e);
        }
        window.moveImageboxOn = function (e) {
            var currentPage = $scope.template.pages.page[$scope.index];
            var sticker = currentPage.levels.level[vm.levelIndex].imagebox;
            if (!isImagebox) {
                return
            }
            fn(e);
            var angle = Number(sticker.rotation.angle);
            var cx = (stickerDragBox.l + stickerDragBox.r) / 2;
            var cy = (stickerDragBox.t + stickerDragBox.b) / 2;
            var pt0 = rotatePoint({x: stickerDragBox.x, y: stickerDragBox.y}, {x: cx, y: cy}, -angle);
            var pt1 = rotatePoint({x: e.touches[0].pageX, y: e.touches[0].pageY}, {x: cx, y: cy}, -angle);
            var deltaX = pt1.x - pt0.x;
            var deltaY = pt1.y - pt0.y;
            var nl = stickerDragBox.l + deltaX;
            var nt = stickerDragBox.t + deltaY;
            if (nl < stickerDragBox.r) {
                nl = stickerDragBox.r
            };
            if (nl > 0) {
                nl = 0
            };
            if (nt < stickerDragBox.b) {
                nt = stickerDragBox.b
            };
            if (nt > 0) {
                nt = 0
            };

            sticker.image.offsetx = nl / sticker.image.scale / currentPage.styleScale2;
            sticker.image.offsety = nt / sticker.image.scale / currentPage.styleScale2;
            $scope.$apply();
        }
        window.moveImageboxEnd = function (e) {
            fn(e);
            isImagebox = false;
            var currentPage = $scope.template.pages.page[$scope.index];
            var box = $scope.template.pages.page[$scope.index].levels.level[$scope.template.levelI].imagebox;
            getCurrentImage();
            var imageLen = 0;
            angular.forEach($scope.template.pages.page[$scope.index].levels.level, function (level) {
                if (level.imagebox && level.imagebox.image && level.imagebox.image.resource) {
                    imageLen++;
                }
            })
            $.ajax({
                type: "GET",
                url: box.image.resource.identifier + "?imageInfo",
                success: function (va) {
                    if (box.image.resource.width == va.height && va.orientation == "Bottom-right") {
                        box.image.resource.width = va.width;
                        box.image.resource.height = va.height;
                        imgScale(box, $scope.index, $scope.i, 0, 0, null, $scope, vm);
                        return
                    }
                    if (va.orientation == "Left-bottom" || va.orientation == "Right-top" || va.orientation == "Left-top" || va.orientation == "Right-bottom") {
                        if (box.image.resource.width == va.height || box.image.angle == 90 || box.image.angle == 270) {
                            return
                        }
                        box.image.resource.width = va.height;
                        box.image.resource.height = va.width;
                        imgScale(box, $scope.index, $scope.i, 0, 0, null, $scope, vm);
                    }
                },
                error: function (request) {

                }
            });
            /**
             * 选中图片框   点击照片出现操作按钮
             */
            if (Math.abs(stickerDragBox.l / currentPage.styleScale2 - box.image.offsetx * box.image.scale) <= 6 && Math.abs(stickerDragBox.t / currentPage.styleScale2 - box.image.offsety * box.image.scale) <= 6) {
                stickerDragBox = {};
                selectImgBoxes($scope.i);

                tipStatus(true);

                if (vm.article.productBokehType!='None') {
                    $(".mode1,.mode2").removeClass('hide1');
                } else {
                    $(".mode1,.mode2").addClass('hide1');
                }

                if (box.bokehtype != 'None') {
                    $(".cut-image").hide();
                } else {
                    if (box.image && box.image.resource.identifier) {
                        $(".cut-image").show();
                    }
                }

                $(".change-btn").hide();
                $scope.isReplaceShow = true;
                if (imageLen < 2) {
                    $(".change").hide();
                } else {
                    $(".change").show();
                }

                $scope.showImageMenu = !$scope.showImageMenu;
                $scope.showStickerMenu = false;
                if ($scope.showImageMenu) {
                    $scope.showBottomMenu = false;
                } else {
                    $scope.showBottomMenu = true;
                }
                $scope.showTempMenu = false;

                $scope.$digest();

            } else {
                flag = true;
            }

            dragBox = {};
            $scope.$apply();
        }

        /*******************************************图片功能****************************end*********************************************/


        /*******************************************贴纸功能****************************start*********************************************/
        /**
         * 切换贴纸菜单
         */
        $scope.toggleStickerMenu = function ($event) {
            if ($event) {
                $event.stopPropagation();
            }
            $scope.showStickerMenu = !$scope.showStickerMenu;
            $scope.showBottomMenu = !$scope.showBottomMenu;
            if ($scope.showStickerMenu) {
                $scope.showTextMenu = false;
            }
        };

        $scope.selectLabel = function (label, index) {
            $scope.artlabelChooseId = label.id;
            $scope.artlabelChooseIndex = index;
            $scope.stickerList = [];
            vm.indexArtNum = 0;
            if (label.id == null) {
                vm.totalClipartItems = vm.cliparts.length;
                $scope.stickerList = angular.copy(vm.cliparts)
            } else {
                getBackgrounds(label, ClipArt, vm.indexArtNum, function (res) {
                    vm.totalClipartItems = res.items;
                    $scope.stickerList = res.arr;
                });
            }
        };

        /**
         * 显示模板
         */
        $scope.toggleTempMenu = function ($event) {
            if ($event) {
                $event.stopPropagation();
            }
            $scope.showTempMenu = !$scope.showTempMenu;
            $scope.showBottomMenu = !$scope.showBottomMenu;
            setUlWidth();
            getCurrentImage();
            $scope.selectedLi = $scope.currentPage.uuid;
        };

        function addLevel(currentPage) {
            $(".transparency").addClass("hide1");
            vm.isTransp = false;
            $(".coverage").addClass("hide1");
            vm.isCoverage = false;

            var arr = {
                seq: 1,
                imagebox: null,
                textbox: null,
                imageart: null,
                textdocument: null
            };

            if (!currentPage.levels.level) {
                currentPage.levels.level = [arr];
            } else {
                currentPage.levels.level.push(arr);
            }

            $scope.template.levelI = currentPage.levels.level.length - 1;
            var currentLevel = currentPage.levels.level[$scope.template.levelI];

            currentLevel.seq = $scope.template.levelI + 1;

            return currentLevel;
        }

        /**
         * 添加贴纸
         */
        $scope.addSticker = function (e, sticker) {
            $scope.template.pageI = $rootScope.currentCarouselIndex;
            var currentPage = $scope.template.pages.page[$scope.template.pageI];
            $scope.template.currentMenu = 'imageart';
            imageartAdd($http, sticker, currentPage.trimbox, function(imageart){
                var _num = 0;
                currentPage.levels.level.forEach(function (level) {
                    if(level.imageart){
                        _num+=10;
                    }
                });
                imageart.geometry.x += _num/currentPage.styleScale2;
                imageart.geometry.y += _num/currentPage.styleScale2;
                imageart.levelI = currentPage.levels.level.length;
                imageart.pageI = $scope.template.pageI;
                var _level = {
                    seq: currentPage.levels.level.length + 1,
                    imageart: imageart,
                }
                currentPage.levels.level.push(_level);
                console.log(currentPage)
            })
        };

        /**
         * 选中编辑贴纸
         * @param $event
         * @param $index
         */
        $scope.editSticker = function ($event, $index) {
            if ($event) {
                $event.stopPropagation();
            }
            $scope.template.levelI = $index;

        };

        /**
         * 缩放旋转贴纸
         * @type {boolean}
         */
        window.resizeStickerStart = function (e) {
            var currentPage = getCurrentPage();
            $scope.template.currentMenu = 'imageart';
            imageartZoomStart(e, currentPage.levels.level, 'outline1-solid', currentPage.styleScale2)
            fn(e);
        };

        window.resizeStickerOn = function (e) {
            var currentPage = getCurrentPage();
            var imageart = currentPage.levels.level[$scope.template.levelI].imageart;
            imageartZoomMove(e, imageart, currentPage.styleScale2,currentPage.trimbox);
            fn(e);
            $scope.$digest();
            e.stopPropagation();
            e.preventDefault();
            return false;
        };

        window.resizeStickerEnd = function () {
            imageartZoomEnd()
        };

        /**
         * 移动贴纸
         * @param e
         */
        $(".template-carousel").on("touchstart",".sticker-edit-box img", function (e) {
            var currentPage = getCurrentPage();
            vm.isImageboxSelectItem = false;
            imageartTouchstartStart(e, $scope.template.levelI, currentPage.levels.level, currentPage.styleScale2,currentPage.trimbox, function (imgIndex) {
                $scope.template.levelI = imgIndex;
                $scope.template.currentMenu = 'imageart';
            })
            fn(e);
            $scope.$digest();
        })
        $(".template-carousel").on("touchmove",".sticker-edit-box", function (e) {
            var currentPage = getCurrentPage();
            if (!e.originalEvent || e.originalEvent.touches.length == 1) {
                imagearOne(e, currentPage.levels.level[$scope.template.levelI].imageart, currentPage.styleScale2,currentPage.trimbox, function () {
                    vm.hint = !editboxIn(currentPage.editboxes.editbox , currentPage.levels.level[$scope.template.levelI].imageart.geometry, currentPage.levels.level[$scope.template.levelI].imageart.rotation.angle);
                });
                $scope.$digest();
            };
            if (e.originalEvent && e.originalEvent.touches.length >= 2) {
                var now = e.originalEvent.touches;
                Math.abs(e.originalEvent.touches[0].pageX - e.originalEvent.touches[1].pageX);
                imagearTouchstartTwo(function (imageartZoomItem) {
                    imagearTwo(e,getDistance(now[0], now[1]) - getDistance(imageartZoomItem.start[0], imageartZoomItem.start[1]),currentPage.levels.level[$scope.template.levelI].imageart, currentPage.trimbox, currentPage.styleScale2)
                })
                $scope.$digest();
            }
        })
        $(".template-carousel").on("touchend",".sticker-edit-box", function (e) {
            vm.hint = false;
            imageartZoomEnd();
            $scope.$apply();
        })

        /**
         * 删除贴纸
         * @param event
         * @param i
         */
        $scope.deleteSticker = function (event, i, index) {
            $scope.deleteAction(event, i);
        };

        $scope.deleteAction = function (e, i) {
            if (e) {
                fn(e);
            }
            var index = $rootScope.currentCarouselIndex || 0;
            var list = $scope.template.pages.page[index].levels.level
            list.splice(i, 1);
        }

        /*******************************************贴纸功能****************************end*********************************************/


        /*******************************************文字模板****************************start*********************************************/

        //文本框点击时

        $scope.selectDoc = function (e, $index, textdocument) {
            $scope.template.levelI = $index;
            $scope.template.angle = textdocument.rotation.angle;
            textdocument.current = 'textdocument';
            $scope.selectBox = textdocument;
        };

        var dragTextDoc = {};
        window.moveTextDocStart = function (e) {
            var $event = e || window.event;
            if ($event && $event.preventDefault) {
                $event.preventDefault();
            }
            else {
                window.event.returnValue = false;
                return false;
            }
            $event.stopPropagation();
            $scope.buttonShows = true;
            var targ = e.target ? e.target : e.srcElement;
            $scope.template.levelI = targ.dataset.index;
            var currentPage = $scope.template.pages.page[$rootScope.currentCarouselIndex];
            var currentLevel = currentPage.levels.level[$scope.template.levelI];
            var currentImg = currentLevel.textdocument;
            $scope.template.angle = currentImg.rotation.angle;
            if (!currentImg.movable || !currentImg.useradded) {
                return
            }

            dragTextDoc.clientX = e.changedTouches[0].clientX ? e.changedTouches[0].clientX : 0;
            dragTextDoc.clientY = e.changedTouches[0].clientY ? e.changedTouches[0].clientY : 0;
            dragTextDoc.coordX = targ.offsetLeft;
            dragTextDoc.coordY = targ.offsetTop;
            dragTextDoc.x = currentPage.trimbox.x;
            dragTextDoc.y = currentPage.trimbox.y;
            dragTextDoc.w = currentPage.trimbox.width;
            dragTextDoc.h = currentPage.trimbox.height;
            drag = true;
        };
        //move 事件
        window.moveTextDocOn = function (e) {
            fn(e);
            $scope.$digest();
            if (e.target.nodeName == 'SPAN') {
                return;
            }
            if (drag) {
                var currentPage = $scope.template.pages.page[$rootScope.currentCarouselIndex];
                var pressImg = currentPage.levels.level[$scope.template.levelI].textdocument;

                var offsetx = dragTextDoc.coordX + (e.changedTouches[0].clientX - dragTextDoc.clientX);
                var offsety = dragTextDoc.coordY + (e.changedTouches[0].clientY - dragTextDoc.clientY);

                if (offsetx <= dragTextDoc.x) {
                    offsetx = dragTextDoc.x;
                }

                if (offsetx >= (dragTextDoc.w - pressImg.geometry.width + dragTextDoc.x)) {
                    offsetx = dragTextDoc.w - pressImg.geometry.width + dragTextDoc.x;
                }
                if (offsety <= dragTextDoc.y) {
                    offsety = dragTextDoc.y;
                }

                if (offsety >= (dragTextDoc.h - pressImg.geometry.height + dragTextDoc.y)) {
                    offsety = dragTextDoc.h - pressImg.geometry.height + dragTextDoc.y;
                }
                pressImg.geometry.x = offsetx;
                pressImg.geometry.y = offsety;

            }
            return false;
        }

        //鼠标松开事件
        window.moveTextDocEnd = function () {
            if (!drag) {
                return
            }
            drag = false;
            dragTextDoc = {};
            $scope.$digest();
        }

        window.rotateTextDocStart = function (e) {
            fn(e);
            var targ = e.target ? e.target : e.srcElement;
            $scope.template.levelI = targ.dataset.index || $scope.template.levelI;
            var currentPage = $scope.template.pages.page[$rootScope.currentCarouselIndex];
            var currentLevel = currentPage.levels.level[$scope.template.levelI];
            var currentTextdocument = currentLevel.textdocument;
            if (currentTextdocument.lock) {
                return
            }
            drag = true;

            dragBox.clientX = e.clientX || 0;
            dragBox.clientY = e.clientY || 0;

            $scope.RightPanel = 'textDoc';


            dragBox.imgRotate = currentTextdocument.rotation.angle ? 360 - Number(currentTextdocument.rotation.angle) : 0;
            var radius = Math.sqrt(currentTextdocument.geometry.width * currentTextdocument.geometry.width + currentTextdocument.geometry.height * currentTextdocument.geometry.height)
            dragBox.originalRotate = parseInt(180 * Math.asin(currentTextdocument.geometry.width / radius) / (2 * Math.asin(1))) + dragBox.imgRotate;
            $(".rotate-icon" + $scope.template.levelI).addClass('rotate-icon-active');

            document.addEventListener("mousemove", rotateDocOn, true);
            document.addEventListener("mouseup", rotateDocEnd, true);
        }

        function rotateDocOn(e) {
            fn(e);
            var currentPage = $scope.template.pages.page[$rootScope.currentCarouselIndex];
            var currentImg = currentPage.levels.level[$scope.template.levelI].textdocument;
            if (drag) {
                var offsetX = (e.clientX - dragBox.clientX);
                var offsetY = (e.clientY - dragBox.clientY);
                var newX = (currentImg.geometry.width / 2 * $scope.currentPage.scale / $scope.currentPage.proportion + offsetX);
                var newY = (currentImg.geometry.height / 2 * $scope.currentPage.scale / $scope.currentPage.proportion + offsetY);
                dragBox.newRadius = Math.sqrt(newX * newX + newY * newY);
                var rotate = parseInt(180 * Math.asin(newX / dragBox.newRadius) / (2 * Math.asin(1)));
                if (newX > 0 && newY > 0) {
                    currentImg.rotation.angle = (dragBox.originalRotate - rotate);
                } else if (newX < 0 && newY > 0) {
                    currentImg.rotation.angle = (dragBox.originalRotate - rotate);
                } else if (newX < 0 && newY < 0) {
                    currentImg.rotation.angle = (dragBox.originalRotate + 180 + rotate);
                } else {
                    currentImg.rotation.angle = (dragBox.originalRotate + 180 + rotate);
                }


                if (currentImg.rotation.angle >= 360) {
                    currentImg.rotation.angle %= 360;
                }
                currentImg.rotation.angle = 360 - currentImg.rotation.angle
                $scope.template.angle = currentImg.rotation.angle;

            }
            $scope.$digest();
            return false;
        }

        function rotateDocEnd() {
            drag = false;
            dragBox = {};

            document.removeEventListener("mousemove", rotateDocOn, true);
            document.removeEventListener("mouseup", rotateDocEnd, true);
            $scope.$digest();
        }

        /*******************************************文字模板*****************************end*********************************************/


        /*******************************************文字处理****************************start*********************************************/
        /**
         * 更改文字字体
         */
        function getFontList() {
            FontManagement.getDefaultShow({}, function (res) {
                if(res.status == 200){
                    vm.defaultFont = res.data;
                }else {
                    swal({
                        title: $translate.instant("choose.editorMessage.failToGet"),
                        text: res.message,
                        imageUrl: Theme.sweetSuccedImg(),
                        timer: 2000,
                        showConfirmButton: false
                    });
                }
            });
            FontManagement.getAll({}, function (res) {
                    $scope.fontList = [];
                    angular.forEach(res, function (msg, i) {
                        $scope.fontList.push({
                            id: 0,
                            // 字体名称
                            value: msg.family,
                            child: [],
                            uuid: msg.uuid
                        });
                        var zh = null;
                        angular.forEach(msg.fontStyles, function (font, j) {
                            switch (font.style) {
                                case 'NORMAL':
                                    zh = "常规";
                                    break;
                                case 'BOLD':
                                    zh = "粗体";
                                    break;
                                case 'ITALIC':
                                    zh = "斜体";
                                    break;
                                case 'BOLD_ITALIC':
                                    zh = "粗斜体";
                                    break;
                                default:
                                    zh = null
                            }
                            $scope.fontList[i].child.push({
                                // 字体样式中文
                                value: zh,
                                // 字体样式英文
                                en: font.style,
                                path: font.path,
                                identifier: font.identifier,
                                domain: $scope.domain
                            });
                        });
                        if (i == res.length - 1) {
                            getFont();
                        }
                    });
            });
        }

        function getFont() {
            $scope.defaultText = {
                family: $scope.fontList[0].value,
                style: $scope.fontList[0].child[0].en,
                path: $scope.fontList[0].child[0].path,
                identifier: $scope.fontList[0].child[0].identifier,
                domain: $scope.domain
            };

            new MultiPicker({
                input: 'multiPickerInput',//点击触发插件的input框的id
                container: 'targetContainer',//插件插入的容器id
                jsonData: $scope.fontList,
                success: function (arr) {
                    $("#multiPickerInput").val(arr[0].value + "（" + arr[1].value + "）");
                    $scope.defaultText = {
                        family: arr[0].value,
                        uuid: arr[0].uuid,
                        style: arr[1].en,
                        path: arr[1].path,
                        identifier: arr[1].identifier,
                        domain: $scope.domain
                    };
                    var text = getCurrentText();
                    text.fontuuid = arr[0].uuid
                    if (vm.fontuuids.indexOf(text.fontuuid) == -1) {
                        vm.fontuuids.push(text.fontuuid);
                        getFontCSS(FontManagement, text, $scope);
                    }
                    text.styles = arr[1].en;
                    text.style.font = arr[0].value;
                    text.identifier = arr[1].path;
                    if (text.styles.indexOf('BOLD') != -1) {
                        text.style.bold = true;
                    } else {
                        text.style.bold = false;
                    }
                    if (text.styles.indexOf('ITALIC') != -1) {
                        text.style.italic = true;
                    } else {
                        text.style.italic = false;
                    }
                }//回调
            });
        }

        /**
         * 文字
         */
        var getCurrentText = function () {
            var index = $rootScope.currentCarouselIndex || 0;
            return $scope.template.pages.page[index].levels.level[$scope.template.levelI].textbox;
        };

        var elem = document.querySelector('input[type="range"]');

        var rangeValue = function () {
            var newValue = elem.value;
            var target = document.querySelector('.text-value');
            target.innerHTML = $translate.instant("choose.editor.fontSize",{size:newValue});
            var text = getCurrentText();
            text.style.size = newValue;
        };

        elem.addEventListener("input", rangeValue);

        /**
         * 更新文字
         */
        $scope.updateTextContents = function () {
            var w = $("#text-area").width();
            $("#text-div").width(w);
            var page = $scope.template.pages.page[$scope.template.pageI];
            setTimeout(function () {
                var text = page.levels.level[$scope.template.levelI].textbox;
                var $con = $("#text-div");

                var str = $scope.textContent.split('\n').join('<br/>');
                text.text = $scope.textContent;
                $con.html(str);
            }, 200);
        };

        /**
         * 文字输入确认按钮
         */
        $scope.saveText = function () {
            getCurrentImage();
            $scope.currentText = $scope.currentPage.levels.level[$scope.template.levelI].textbox;

            $scope.textContent = $scope.textContent.split(' ').join(' ');

            FontManagement.fontSupport({
                uuid: $scope.currentText.fontuuid,
                bold: $scope.currentText.style.bold,
                italic: $scope.currentText.style.italic,
                content: $scope.textContent
            }, function (res) {
                var msg = res.data;
                $scope.currentText.success = res.data.success;
                if (res.status == 200) {
                    if(!msg.success){
                        SweetAlert.swal({
                            title: $translate.instant("choose.editorMessage.fontIsNotAvailable"),
                            imageUrl: Theme.sweetHintImg(),
                            text: "",
                            timer: 2000,
                            showConfirmButton: false
                        });
                        return
                    }
                    if (msg.success && !msg.supported) {
                        swal({
                            title: "<img src='content/images/icons/ic_tishi.svg'><div style='color:#666;font-size: 16px;margin-top: 16px;'>"+$translate.instant("choose.editorMessage.warmPrompt")+"</div>",
                            text: "<div style='font-size: 12px;line-height: 24px;color: #333;'>"+$translate.instant("choose.editorMessage.specialCharacter")+"<br>"+$translate.instant("choose.editorMessage.pleaseModify")+"<span style='color:#FFA91B;font-size: 14px'>" + msg.failed + "</span></div>",
                            html: true,
                            confirmButtonText: $translate.instant("choose.editorMessage.correction")
                        });
                    } else {
                        $(window).unbind('scroll');

                        $scope.showBottomMenu = true;
                        $scope.showBarMenu = false;

                        tipStatus(false);
                        var i = $scope.template.levelI;
                        var index = $scope.template.pageI;
                        $(".slide-li").eq(index).find(".text-box").eq(i).removeClass('opacity-zero');
                        $scope.showTextModal = false;

                        $scope.template.currentMenu = 'textbox';
                        $scope.showTextMenu = false;
                        $scope.currentText.text = $scope.textContent;
                        $scope.currentText.style.lineheight = $scope.currentText.style.size;
                        //下载字体
                        if (vm.fontuuids.indexOf($scope.currentText.fontuuid) == -1) {
                            vm.fontuuids.push($scope.currentText.fontuuid);
                        }
                        getFontCSS(FontManagement, $scope.currentText, $scope);
                        vm.addText = false;
                        toImg($scope.currentText, $scope.currentPage.styleScale2, index, i);
                    }
                }
            })
        };

        /**
         * 文字菜单切换（点击）及初始化
         */
        $scope.toggleTextMenu = function ($event) {
            $(".text-img").css({'height': 0});
            // $("#text-area").attr('autofocus', "autofocus");

            $scope.showTextModal = !$scope.showTextModal;
            $scope.showTextMenu = !$scope.showTextMenu;
            $scope.showBottomMenu = !$scope.showBottomMenu;

            // 清空样式
            $scope.textContent = "";
            vm.addText = true;

            /**
             * 格式化颜色和文字的选择
             */
            $scope.selectedColor = $scope.colorList[0];
            $scope.selectedFont = $scope.fontList[0];
            angular.forEach($scope.fontList, function (item, index) {
                item.selected = !index;
            });

            $(".tip-image").addClass('hide1');

            //初始化并添加一个文字框
            if ($scope.showTextMenu) {
                var currentPage = $scope.template.pages.page[$rootScope.currentCarouselIndex];
                var _size = Math.floor(currentPage.trimbox.height/8);
                var currentLevel = addLevel(currentPage);

                $scope.template.pageI = $rootScope.currentCarouselIndex;
                currentLevel.textbox = ({
                    geometry: {
                        height: 24 * currentPage.styleScale,
                        width: 200 * currentPage.styleScale,
                        x: null,
                        y: null
                    },
                    rotation: {
                        angle: 0
                    },
                    style: {
                        color: $scope.selectedColor,
                        font: vm.defaultFont.family,
                        size: _size || $(".text-range").val(),
                        bold: false,
                        italic: false,
                        lineheight: _size || $(".text-range").val(),
                        letterspacing: 0,
                        align: 'left',
                        writingmode:'horizontal-tb'
                    },
                    text: '请输入文字',
                    type: 'dynamic',
                    status: '',
                    xM: null,
                    yM: null,
                    levelI: $scope.template.levelI,
                    pageI: $scope.template.pageI,
                    transparency: 1,
                    onlyshow: false,
                    movable: true,
                    editable: true,
                    useradded: true,
                    fontuuid: vm.defaultFont.uuid,
                    identifier: null,
                    version: '2.0'
                });

                $scope.template.currentMenu = 'text';
                $scope.selectCurrentTextBox($event, $scope.template.levelI);

            }
            var textbox = currentPage.levels.level[$scope.template.levelI];
            ;
            $scope.textCopy = angular.copy(textbox);
        };

        /**
         * 底部 编辑按钮<---->菜单栏 的切换
         * @param event
         */
        $scope.toggleBarMenu = function (event) {
            if (event) {
                event.stopPropagation();
            }
            $scope.showBarMenu = !$scope.showBarMenu;
            // 当引导页点击“不在提示”以后就不再count++;

            if (!vm.guideStep) {
                $scope.countN++;
                localStorage.setItem('countN', $scope.countN);
            }
        };

        /**
         * 关闭按钮--->菜单栏
         */
        $scope.closeToBarMenu = function (event) {
            if (event) {
                event.stopPropagation();
            }
            $scope.showBottomMenu = true;
            $scope.showBarMenu = false;
            $scope.showStickerMenu = false;
            $scope.showTempMenu = false;
        };

        var setUlWidth = function () {
            var len = vm.article.document.pages.page.length;
            if (len < 3) {
                return
            }
            //需要加上选中的边框值：2
            var w = 2;
            if ($scope.pageAllPx && $scope.pageAllPx.page.length) {
                var arr = $scope.pageAllPx.page;
                for (var j = 0; j < arr.length; j++) {
                    if (!arr[j].unreplace) {
                        arr[j].width = arr[j].mediabox.width * arr[j].styleScale2;
                        arr[j].height = arr[j].mediabox.height * arr[j].styleScale2;
                        w += arr[j].width * $scope.mHeight / arr[j].height + 12;
                    }

                }
            }

            $(".temp-ul").width(w + 'px');
        };

        /**
         * 选中当前文字框
         */
        $scope.selectCurrentTextBox = function ($event, $index) {
            // selectTextIndex = $index;
            if ($event) {
                $event.stopPropagation();
            }
            var currentPage = getCurrentPage();
            var currentText = currentPage.levels.level[$scope.template.levelI].textbox;

            /**
             * 显示文字颜色及字体选择菜单
             */
            $scope.showTextMenu = true;
            $scope.showStickerMenu = false;

            /**
             * 更新对应的颜色选择和字体
             */
            $scope.selectedColor = currentText.style.color;
            angular.forEach($scope.fontList, function (item) {
                if (item.value == currentText.style.font) {
                    item.selected = true;
                    $scope.selectedFont = item;
                } else {
                    item.selected = false;
                }
            });
        };
        /**
         * 更改文字颜色
         */
        $scope.selectTextColor = function (color) {
            $scope.selectedColor = color;
            var text = getCurrentText();
            text.style.color = color;
        };


        $scope.hideMenu = function () {
            $scope.showTextMenu = false;
            $scope.showStickerMenu = false;

            $scope.showBarMenu = true;
            $scope.showTempMenu = false;
            if (!$scope.showTextModal) {
                $scope.showBottomMenu = true;
            } else {
                $scope.showBottomMenu = false;
            }
            // $scope.template.currentMenu = '';
            // $scope.template.levelI = null;

            var currentPage = getCurrentPage();
        };


        function toImg(text, styleScale, index, textI) {
            if (text.text == '') {
                return
            }

            var page = $scope.template.pages.page[$scope.template.pageI];
            var pagemaxW = page.trimbox.width * styleScale;

            var fontStyle = text.styles ? text.styles : $scope.defaultText.style;

            // 常用emoji
            var regStr = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig;
            var org_val = text.text;
            if (regStr.test(org_val)) {
                text.text = org_val.replace(regStr, "");
            }

            var tmpNode = document.createElement("DIV");
            $(tmpNode).html(text.text).css({'font-size': text.style.size});

            //根据换行符分数组
            var arrs = $(tmpNode).html().split('\n');
            // 空格替换
            var str = $(".text-width").html(arrs[0]).html().replace(/\s/g, 'a');
            var ratio = $scope.currentPage.ratio2;
            $(".text-width").html(str)
            //先拿到数组中下标为0的宽度
            var $width = $(".text-width").html(str).css({
                'font-size': (text.style.size * ratio > 12 ? text.style.size * ratio : 12) + 'pt',
                'line-height': (text.style.size * ratio > 12 ? text.style.lineheight * ratio : text.style.lineheight * 12 / text.style.size) + 'pt',
                'letter-spacing': (text.style.size * ratio > 12 ? text.style.letterspacing * ratio : text.style.letterspacing * 12 / text.style.size) + 'pt',
                'font-weight': fontStyle,
                'font-family': '\'' + text.fontuuid + '\'',
                'transform': 'scale(' + (1 / 12 * text.style.size * ratio > 1 ? 1 : 1 / 12 * text.style.size * ratio) + ')',
            });

            var w0 = angular.copy(text.geometry.width * styleScale);
            var h0 = angular.copy(text.geometry.height * styleScale);
            var scale = 1 / 12 * text.style.size * ratio > 1 ? 1 : 1 / 12 * text.style.size * ratio;
            var htmlWidth = $width.width() * scale;
            var htmlHeight = $width.height() * scale;
            var t = 0,
                k = 0;
            if (htmlWidth > pagemaxW) {
                k = k + Math.ceil(htmlWidth / pagemaxW);
            }
            if (text.type != 'static' && pagemaxW) {
                var pattern_char = /[a-zA-Z0-9]/g;
                // var pattern_chin = /[\u4e00-\u9fa5]/g;
                var pattern = $width.html().match(pattern_char);
                var count_char = pattern ? pattern.length : 4;
                var maxW = (htmlWidth) > pagemaxW ? pagemaxW : (htmlWidth + count_char * 2);
                var maxH = htmlHeight;
                if (arrs.length == 1) {
                    w0 = maxW;
                    h0 = maxH * (arrs.length + k) + 2;
                } else {
                    for (var i = 1, len = arrs.length; i < len; i++) {
                        var count = arrs[i].match(pattern_char);
                        var over_char = count ? count.length : 4;
                        // 空格替换
                        var newWord = $width.html(arrs[i]).html().replace(/\s/g, '&nbsp;');
                        var overWidth = $width.html(newWord).width() * scale + over_char * 2;

                        //得到数组中宽度最大的一个
                        if (maxW < overWidth && overWidth < pagemaxW) {
                            maxW = overWidth;
                            maxH = $width.html(arrs[i]).height() * scale;
                            t = i;
                        } else if (maxW < overWidth && overWidth > pagemaxW) {
                            maxW = pagemaxW;
                            maxH = $width.html(arrs[i]).height() * scale;
                            k = k + parseInt(overWidth / pagemaxW);
                        }
                    }
                    $width.html(arrs[t]);
                    w0 = maxW;
                    h0 = maxH * (arrs.length + k);
                }
            }

            if(text.style.writingmode && text.style.writingmode != 'horizontal-tb'){
                text.geometry.width = h0 / styleScale;
                text.geometry.height = w0 / styleScale;
            }else{
                text.geometry.width = w0 / styleScale;
                text.geometry.height = h0 / styleScale;
            }

            var slideW = $("#slide-li" + $scope.template.pageI).find('.slide-content').width();
            var slideH = $("#slide-li" + $scope.template.pageI).find('.slide-content').height();
            var x = ((slideW - w0) / 2 + $scope.template.levelI) / styleScale;
            var y = ((slideH - h0) / 2 + $scope.template.levelI) / styleScale;


            if (text.geometry.x == null || text.geometry.y == null) {
                text.geometry.x = x;
                text.geometry.y = y;
            }

            if (text.geometry.width >= $scope.currentPage.trimbox.width) {
                text.geometry.x = $scope.currentPage.trimbox.x;
            }
        }

        /**
         * 删除文字框
         * @param $event
         * @param i
         * @param index
         */
        $scope.deleteSelectedText = function ($event, i, index) {
            $scope.template.levelI = i;
            $scope.deleteAction(event, i);
            $scope.showTextMenu = false;
        };

        /**
         * 编辑文字内容
         * @param $event
         * @param i
         * @param text
         * @param index
         */
        $scope.editTextContent = function ($event, i, text, index) {
            $scope.showTextModal = true;
            $scope.showImageMenu = false;
            $scope.showTempMenu = false;
            $scope.showStickerMenu = false;
            // selectTextIndex = i;
            $(".text-img-pic").css({width: text.geometry.width, height: text.geometry.height});
            $scope.textContent = text.text;
            $scope.template.levelI = i;
            $scope.template.pageI = index;
            $(".text-value").html(text.style.size + ' px');
            $(".rangeSize").val(text.style.size);

            // angular.element('#text-area')[0].focus();

            getCurrentImage();
            var textbox = $scope.template.pages.page[index].levels.level[i].textbox;
            $scope.textCopy = angular.copy(textbox);
            $(".tip-image").addClass('hide1');

        };

        /**
         * 移动文字框
         */
        var getCurrentTextFromEvent = function (e) {
            var targ = e.currentTarget ? e.currentTarget : e.srcElement;
            $scope.template.levelI = targ.dataset.index;
            $scope.template.currentMenu = 'text';
            return getCurrentText();
        };

        window.moveTextBoxStart = function (e) {
            fn(e);
            var index = $rootScope.currentCarouselIndex || 0;
            $scope.template.pageI = index;
            $scope.template.currentMenu = 'textbox';
            $('.tip-image').addClass('hide1');
            var currentPage = $scope.template.pages.page[$rootScope.currentCarouselIndex];

            textBoxMoveStart(e, $scope.template.levelI, currentPage.levels.level, currentPage.styleScale2, currentPage.trimbox, function (textIndex) {
                $scope.template.levelI = parseInt(textIndex);
                var text = $scope.template.pages.page[index].levels.level[textIndex].textbox;
                $(".text-img-pic").css({width: text.geometry.width, height: text.geometry.height});
                $scope.$digest();
            })
        };
        window.moveTextBoxOn = function (e) {
            textBoxMoveOn(e, $scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].textbox, $scope.template.pages.page[$scope.template.pageI].styleScale2, $scope.template.pages.page[$scope.template.pageI].trimbox,function () {
                vm.hint = !editboxIn($scope.template.pages.page[$scope.template.pageI].editboxes.editbox , $scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].textbox.geometry, $scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].textbox.rotation.angle);
            })
            $scope.$digest();
            fn(e);
        };
        window.moveTextBoxEnd = function (e) {
            vm.hint = false;
            textBoxMoveEnd();
            $scope.$apply();
            fn(e);
        };

        /**
         *旋转缩放文字
         * @param e
         */
        window.resizeTextBoxStart = function (e) {
            fn(e);
            // IE uses srcElement, others use target
            var text = getCurrentTextFromEvent(e);
            var currentPage = getCurrentPage();
            dragBox.clientX = e.changedTouches[0].clientX ? e.changedTouches[0].clientX : 0;
            dragBox.clientY = e.changedTouches[0].clientY ? e.changedTouches[0].clientY : 0;
            dragBox.coordX = angular.copy(text.geometry.x * currentPage.styleScale2);
            dragBox.coordY = angular.copy(text.geometry.y * currentPage.styleScale2);
            dragBox.width = angular.copy(text.geometry.width * currentPage.styleScale2);
            dragBox.height = angular.copy(text.geometry.width * currentPage.styleScale2);
            dragBox.originalFontSize = text.style.size;
            dragBox.radius = parseInt(Math.sqrt(dragBox.width * dragBox.width + dragBox.height * dragBox.height));
            dragBox.textRotate = text.rotation.angle ? Number(text.rotation.angle) : 0;
            dragBox.originalRotate = parseInt(180 * Math.asin(dragBox.width / dragBox.radius) / (2 * Math.asin(1))) + dragBox.textRotate;
            window.isDragging = true;
        };
        window.resizeTextBoxOn = function (e) {
            if (window.isDragging) {
                var text = getCurrentTextFromEvent(e);
                var offsetx = (e.changedTouches[0].clientX - dragBox.clientX);
                var offsety = (e.changedTouches[0].clientY - dragBox.clientY);
                var newX = (dragBox.width / 2 + offsetx);
                var newY = (dragBox.height / 2 + offsety);
                dragBox.newRadius = Math.sqrt(newX * newX + newY * newY);
                var rotate = parseInt(180 * Math.asin(newX / dragBox.newRadius) / (2 * Math.asin(1)));
                if (newX > 0 && newY > 0) {
                    text.rotation.angle = (dragBox.originalRotate - rotate);
                } else if (newX < 0 && newY > 0) {
                    text.rotation.angle = dragBox.originalRotate - rotate;
                } else if (newX < 0 && newY < 0) {
                    text.rotation.angle = dragBox.originalRotate + 180 + rotate;
                } else {
                    text.rotation.angle = (dragBox.originalRotate + 180 + rotate);
                }
            }

            $scope.$digest();
            e.stopPropagation();
            e.preventDefault();
            return false;
        };
        window.resizeTextBoxEnd = function (e) {
            window.isDragging = false;
            dragBox = {};
        };

        /*******************************************文字处理****************************end*********************************************/


        //更新所有占位框的使用照片图片
        function getUsedImageboxsNum() {
            vm.usedImageboxsNum = 0;
            vm.counts = 0;
            angular.forEach($scope.template.pages.page, function (item, index) {
                angular.forEach(item.levels.level, function (level) {
                    if (level.imagebox) {
                        vm.counts++;
                    }
                    if (level.imagebox && level.imagebox.image && level.imagebox.image.resource && level.imagebox.image.resource.identifier) {
                        vm.usedImageboxsNum++;
                    }
                })
            });
        }

        var completed = null;
        $scope.saveWork = function () {
            completed = vm.article.articleStatus;
            var index = $rootScope.currentCarouselIndex;
            // 作品保存后，将页面改为0；
            $rootScope.currentCarouselIndex = 0;
            vm.article.pageCount = $scope.template.pages.page.length;
            if ($scope.status == 'make') {
                $scope.template.pageI = null;
                setProductionStorage('view');
                $scope.showTempMenu = false;
                $scope.isReplaceShow = false;
                $scope.showStickerMenu = false;

                setGalleryStorage();
                localStorage.removeItem('marginLeft');

                $ul.css({marginLeft: '0px'});
                backToScrollTop();
                localStorage.setItem('pages', JSON.stringify($scope.template.pages));
                return;
            }
            var _documentTextDetection = documentTextDetection1($scope.template.pages.page);
            if(!_documentTextDetection.pass){
                vm.isDocumentTextDetection = true;
                vm.documentTextDetection = _documentTextDetection.pages;
                return;
            }
            if ($scope.template.pages.page.length < $scope.PAGELEN) {
                SweetAlert.swal({
                    title: $translate.instant("choose.editorMessage.templateIsLoading"),
                    imageUrl: Theme.sweetHintImg(),
                    text: "",
                    timer: 2000,
                    showConfirmButton: false
                });
                return
            }

            if (vm.article.ordered) {
                SweetAlert.swal({
                    title: $translate.instant("choose.editorMessage.warmPrompt"),
                    imageUrl: Theme.sweetHintImg(),
                    text: $translate.instant("choose.editorMessage."),
                    timer: 2000,
                    showConfirmButton: false
                });
            }

            getUsedImageboxsNum();
            if (vm.usedImageboxsNum < vm.counts) {
                completed = "EDITING";
                SweetAlert.swal({
                    title: $translate.instant("choose.editorMessage.baaroque"),
                    imageUrl: Theme.sweetHintImg(),
                    showCancelButton: true,
                    confirmButtonText: $translate.instant("choose.editor.confirm"),
                    cancelButtonText: $translate.instant("choose.editor.cancel"),
                    closeOnConfirm: true,
                    closeOnCancel: true
                }, function (isConfirm) {
                    if (isConfirm) {
                        $timeout(function () {
                            $(".save-page").removeClass('hide1');
                            thumbnailInit(function (res){
                                generateJsonFile();
                            })
                        }, 500);
                        return;
                    }
                })
            } else {
                completed = 'COMPLETED';
                $(".save-page").removeClass('hide1');
                thumbnailInit(function (res){
                    generateJsonFile();
                })
            }
        };

        //json下载文件中需要的内容
        var generateJsonFile = function () {
            $scope.isSave = true;
            var template = {
                pages: {
                    page: []
                },
                bgimgs2: vm.article.bgimgs2,
                documentpics: vm.article.documentpics,
                masks: vm.article.masks,
                cliparts: vm.article.cliparts,
                replace: vm.replace,
                cover: vm.cover,
                version: '2.0'
            };

            var doc = saveData();
            template.pages = doc.pages;
            //作品保存的时候 将用户选择照片填入 文档
            $scope.qiniuId = JSON.parse(localStorage.getItem("gallery"));
            template.galleries = {gallery: $scope.qiniuId};
            vm.article.id = vm.aid;
            removeAll();

            template.hostinfo = hostInfo();
            Convert.articleUploadDocument(template, function (res) {
                if(res.status == 200){
                    vm.article.id = vm.aid;
                    vm.article.articleStatus = completed;
                    vm.article.productType = 'CustomPrint';
                    vm.article.fileName = res.data.identifier;
                    vm.article.saveUserName = localStorage.getItem('saveUserName') || ''
                    Article.update(vm.article,function (resp) {
                        if(resp.status == 200){
                            $(".save-page").addClass('hide1');
                            $('.sweet-alert').removeClass('hide-button');
                            $scope.bool = false;
                            swal({
                                title: $translate.instant("choose.editorMessage.saveSuccessfully"),
                                text: $translate.instant("choose.editorMessage.workHasBeenSyncedToMyWork"),
                                imageUrl: Theme.sweetSuccedImg(),
                                timer: 2000,
                                showConfirmButton: false
                            });
                            localStorage.setItem('guide-step', true);
                            $scope.isSavingJson = false;
                            removeLocalStorage();
                            $state.go("product-view-ec", {storeId: vm.storeId, aid: resp.data.id});
                        }else {
                            $(".save-page").addClass('hide1');
                            swal({
                                title: $translate.instant("choose.editorMessage.failSave"),
                                text: $translate.instant("choose.editorMessage.saveError"),
                                imageUrl: Theme.sweetHintImg(),
                                timer: 2000,
                                showConfirmButton: false
                            });
                        }
                    })
                }

            }, function () {
                $(".save-page").addClass('hide1');
                swal({
                    title: $translate.instant("choose.editorMessage.failSave"),
                    text: $translate.instant("choose.editorMessage.saveError"),
                    imageUrl: Theme.sweetHintImg(),
                    timer: 2000,
                    showConfirmButton: false
                });
            })

        };
        function saveData() {
            return documentMM($scope.template,$scope.pageAllPx.page,'gaoji',$scope)
        }

        var removeLocalStorage = function () {
            localStorage.removeItem("choose");
            localStorage.removeItem("multipartUpload");
            localStorage.removeItem("go");
            localStorage.removeItem("pages");
            localStorage.removeItem("marginLeft");
            localStorage.removeItem("$index");
            localStorage.removeItem("gallery");
            localStorage.removeItem("work-save");
        };
        removeAll();
        function removeAll() {
            //清除关于作品的localStorage
            localStorage.removeItem("choose");
            localStorage.removeItem("multipartUpload");
            localStorage.removeItem("index");
            localStorage.removeItem("i");
            localStorage.removeItem("marginLeft");
            localStorage.removeItem("single");
            localStorage.removeItem("pages");
            localStorage.removeItem("gallery");
            localStorage.removeItem("galleryCopy");
            localStorage.removeItem("reviewPages");
            localStorage.removeItem("saveOldPage");
            localStorage.removeItem("saveOldPageIndex");
            localStorage.removeItem("pageAllPx");
            localStorage.removeItem("pageAllMm");
            localStorage.removeItem("view-scrollTop");
            localStorage.removeItem("work-save");
            localStorage.removeItem("delPic");
            localStorage.removeItem("picArrChoose");
            localStorage.removeItem("picArrChoose2");
            localStorage.removeItem("gallery2");
            localStorage.removeItem("picArrCopy");
            localStorage.removeItem("picArr");
            localStorage.removeItem("isSort");
        };

        function setProductionStorage(attr) {
            localStorage.setItem('Production', attr);
            $scope.status = attr;
        }

        function setReviewStorage(index) {
            localStorage.setItem('saveOldPage', JSON.stringify($scope.template.pages.page[index]));
            localStorage.setItem('saveOldPageIndex', index);
            localStorage.setItem('galleryCopy', JSON.stringify($scope.qiniuId));
            localStorage.setItem('pages', JSON.stringify($scope.template.pages));
        }

        function setGalleryStorage() {
            localStorage.setItem('gallery', JSON.stringify($scope.qiniuId));
        }

        function tipStatus(flag) {
            if (flag) {
                $('.edit-menu').removeClass('opacity-zero1');
                $('.tip-image').addClass('hide1');
                return
            } else {
                $('.edit-menu').addClass('opacity-zero1');
                $('.tip-image').removeClass('hide1');
            }
        }

        $scope.hideComeIn = function () {
            $scope.isHide = true;
            localStorage.setItem('isHide', true);
        };

        //防止事件冒泡，默认事件
        function fn(e) {
            e = e || window.event;
            e.cancelBubble = true;
            e.stopPropagation();
            e.returnValue = false;
            e.preventDefault();
        }

        /**
         * 点击其他地方时取消选中贴纸，文字框
         */
        $scope.$on('documentClicked', function () {
            setEveryThingUnselected();
            $scope.$digest();
        });
        var setEveryThingUnselected = function () {
            $scope.showTextMenu = false;
            $scope.showStickerMenu = false;
            $(".change-btn").hide();
        };

        /**
         * carousel滑动后初始化编辑菜单
         */
        $scope.$on('carouselSlideAway', function () {
            //关闭贴纸菜单
            $scope.showStickerMenu = false;
            //关闭文字菜单
            if ($scope.showTextMenu) {
                $scope.toggleTextMenu();
            }

            //取消当前页面的选择框
            if ($scope.template) {
                setEveryThingUnselected()
            }
        });


        //    引导页部分
        $scope.nextStep = function () {
            $scope.countN++;
            localStorage.setItem('countN', $scope.countN);
        };
        $scope.nextStep2 = function () {
            $scope.countN++;
            localStorage.setItem('countN', $scope.countN);
        };
        $scope.neverHint = function () {
            localStorage.setItem('guide-step', true);
            vm.guideStep = true;
            if ($scope.status == 'make') {
                $('.tip-image').removeClass('hide1');
            }
        };
        $scope.nextStep3 = function () {
            $scope.countN++;
            localStorage.setItem('countN', $scope.countN);
            if ($scope.countN == 13) {
                $('.tip-image').removeClass('hide1');
            }
        };

        //多选选择照片限制
        $scope.photoPic = [];
        var t = 0;
        $scope.selectRestrict = function (identifier, photo, $index) {
            var len = 0;
            photo.index = $index;
            //当前页
            $scope.currentPage = $scope.template.pages.page[$scope.index];
            //当前框
            $scope.currentImage = $scope.currentPage.levels.level[$scope.i].imagebox;
            // $scope.totalImgaes = $scope.currentPage.imageboxes.imagebox.filter(function (item) {
            //     return item.image == null || angular.equals({}, item.image)
            // })
            angular.forEach($scope.currentPage.levels.level, function (level) {
                if (level.imagebox && (!level.imagebox.image || level.imagebox.image && level.imagebox.image.resource == null)) {
                    len++;
                }
            })

            if ($scope.currentImage.image != null && $scope.currentImage.image.resource != null && $scope.currentImage.image.resource.identifier != null && $scope.currentImage.image.resource.identifier != "") {
                var total = len + 1;
            } else {
                var total = len;
            }
            if (photo.photo_select == false || photo.photo_select == undefined) {
                photo.photo_select = true;
                t++;
                if (t > total) {
                    SweetAlert.swal({
                        title: $translate.instant("choose.editorMessage.reselect"),
                        imageUrl: Theme.sweetHintImg(),
                        text: "",
                        timer: 2000,
                        showConfirmButton: false
                    });
                    photo.photo_select = false;
                    t--;
                    angular.forEach($scope.qiniuId, function (item) {
                        if (item.photo_select == undefined || item.photo_select == false) {
                            item.flg = true;
                        } else {
                            item.flg = false;
                        }
                    });
                }
            } else {
                photo.photo_select = false;
                t--;
                angular.forEach($scope.qiniuId, function (item) {
                    item.flg = false;
                });
            }

            $scope.photoPic = $scope.qiniuId.filter(function (item) {
                return item.photo_select == true;
            });
            localStorage.setItem('gallery', JSON.stringify($scope.qiniuId));
        };


        //    多张确认导入
        $scope.confirmChoose = function () {
            localStorage.setItem("photoPic", JSON.stringify($scope.photoPic));
            multipartTo($scope.photoPic);
        };


        //   多选照片导入
        function multipartTo(photos) {
            localStorage.setItem("gallery", JSON.stringify($scope.qiniuId));
            setProductionStorage('make');

            //当前页
            $scope.currentPage = $scope.template.pages.page[$scope.index];
            //当前框
            $scope.currentImage = $scope.currentPage.levels.level[$scope.i].imagebox;
            var imagebox = $scope.currentImage;
            //先赋值 下标i的占位框   选择的照片移除已赋值的

            //循环imageboxes 如果占位框有值则continue    赋值空box  赋值的usenum++   并移除已赋值的照片
            //如果都已经移除完毕   则循环结束 或者 imageboxes循环到尾
            if(photos[0].imageInfo){
                multipartTo1(photos[0].imageInfo)
            }else{
                $.ajax({
                    type: "GET",
                    url: photos[0].identifier + "?imageInfo",
                    async: false,
                    success: function (va) {
                        photos[0].imageInfo = va;
                        multipartTo1(va)
                    }
                })
            }

            function multipartTo1(va) {
                photos[0].usenum++;
                if (imagebox.image) {
                    $scope.imgIndex = imagebox.image.index;
                    $scope.imgId = imagebox.image.resourceid;
                    if ($scope.qiniuId.length) {
                        angular.forEach($scope.qiniuId, function (arr, i) {
                            if (arr.id == $scope.imgId) {
                                arr.usenum == 0 ? 0 : arr.usenum--;
                                setGalleryStorage();
                            }
                        })
                    }
                } else {
                    imagebox.image = {}
                }
                imagebox.image.imageInfo = va;
                imagebox.image.angle = orientationInit1(va.orientation).angle;
                imagebox.flip = orientationInit1(va.orientation).flip;
                setImgs(imagebox,photos[0],$scope.i);
                photos.splice(0, 1);
                for (var j = 0; j < $scope.currentPage.levels.level.length; j++) {
                    var level = $scope.currentPage.levels.level[j];
                    if (level.imagebox && level.imagebox.geometry&&j!=$scope.i) {
                        var img = level.imagebox;
                        if (img.image != null && img.image.resource != null && img.image.resource.identifier != null && img.image.resource.identifier != "") {
                            continue;
                        }
                        if (photos == null || photos.length == 0) {
                            break;
                        }

                        var photo = photos.splice(0, 1);
                        if(photo[0].imageInfo){
                            img.image.imageInfo = photo[0].imageInfo;
                            multipartTo2(JSON.parse(img.image.imageInfo))
                        }else{
                            $.ajax({
                                type: "GET",
                                url: photo[0].identifier + "?imageInfo",
                                async: false,
                                success: function (va) {
                                    photo[0].imageInfo = va;
                                    img.image.imageInfo = va;
                                    multipartTo2(JSON.parse(img.image.imageInfo))
                                }
                            })
                        }
                        function multipartTo2(imageInfo){
                            photo[0].usenum++;
                            img.image.angle = orientationInit1(imageInfo.orientation).angle;
                            img.flip = orientationInit1(imageInfo.orientation).flip;
                            photo[0] = orientationInit(photo[0]);
                            setImgs(img,photo[0],j)
                        }
                    }
                }
            }


            function setImgs(img,photo,x) {
                if (img.mask.resource.identifier) {
                    img.maskUrl = (img.mask.resource.identifier.indexOf('http') == -1 ? $scope.domain : '') + img.mask.resource.identifier;
                } else {
                    img.maskUrl = 'content/images/timg.jpg';
                }

                img.image = imgParamter(img, photo, photo.index);

                img.imgUrl = photo.identifier;
                img.image.resource.identifier = photo.identifier;
                img.image.offsety = 0;
                img.image.offsetx = 0;
                img.image.scale = 1;
                // img.image.angle = 0;
                if (vm.article.productBokeh) {
                    img.blurred = true;
                    img.blurredrectangle = {}
                }
                imgScale(img, $scope.index, x, 0, 0, 'center',$scope,vm);
            }

            $scope.showBottomMenu = true;
            $('.tip-image').removeClass('hide1');
            $scope.template.currentMenu = '';
        };

        vm.sortStatus = false;
        vm.orignTemp = null;
        var sort = null;
        var sortArray = [];
        $scope.sortPage = function () {
            vm.sortStatus = true;
            vm.orignTemp = angular.copy($scope.template);
            sort = new Sortable(document.getElementById('my-ui-list1'), {
                swap: true,
                filter: '.filtered',
                animation: 150,
                onEnd: function (/**Event*/evt) {
                    console.log('onEnd.foo:', [evt.item, evt.from]);
                    sortArray = [];
                    angular.forEach($('#my-ui-list1').find('.slide-content'), function (item, index) {
                        var seq = item.getAttribute("data-sort-tag");
                        var value = angular.copy($scope.template.pages.page[seq]);
                        value.seq = index;
                        sortArray.push(value)
                    });
                }
            });
        }

        $scope.sortBack = function () {
            vm.sortStatus = false;
            $scope.template = angular.copy(vm.orignTemp);
            vm.orignTemp = null;
            sort.destroy();
        }

        $scope.sortCancel = function () {
            $scope.template = angular.copy(vm.orignTemp);
        }

        $scope.saveSort = function () {
            if (!sortArray.length) {
                // $scope.template = angular.copy(vm.orignTemp);
            } else {
                $scope.template.pages.page = angular.copy(sortArray);

            }
            vm.sortStatus = false;
            sort.destroy();
        }
        $scope.textLayout = function(item){
            var text = $scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].textbox;
            var text1 = angular.copy($scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].textbox);
            text.style.writingmode = item;
            $timeout(function () {
                // text.geometry.width = Number($("#c-xml-page-material-fontId1").height()) + Number(5);
                // text.geometry.height = (Number($("#c-xml-page-material-fontId1").width()) + Number(5));
                text.geometry.width = text1.geometry.height;
                text.geometry.height = text1.geometry.width;
            },200)
        }
        //像素不足提醒
        vm.imgSize = 150;
        vm.imgDpi = 150;
        StoreWorkEditConfig.storeId({storeId: vm.storeId}, function (res) {
            if(res.status == 200){
                vm.imgSize = res.data.imgSize;
                vm.imgDpi = res.data.imgDpi;
            }
        });
        //边框
        $scope.imageboxW = function (imagebox) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.geometry.width) + Number(imagebox.border.lineWidth) * 2
                }
                if (imagebox.border.type == 'Pic') {
                    return imagebox.geometry.width
                    // return Number(imagebox.geometry.width) + (Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100) + (Number(imagebox.geometry.width) * Number(imagebox.border.edge.right) / 100)
                }
            } else {
                return imagebox.geometry.width
            }
        }
        $scope.imageboxH = function (imagebox) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.geometry.height) + Number(imagebox.border.lineWidth) * 2
                }
                if (imagebox.border.type == 'Pic') {
                    return imagebox.geometry.height
                    // return Number(imagebox.geometry.height) + (Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100) + (Number(imagebox.geometry.height) * Number(imagebox.border.edge.bottom) / 100)
                }
            } else {
                return imagebox.geometry.height
            }
        }
        $scope.imageboxL = function (imagebox) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.geometry.x) - Number(imagebox.border.lineWidth)
                }
                if (imagebox.border.type == 'Pic') {
                    return imagebox.geometry.x
                    // return Number(imagebox.geometry.x) - (Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100)
                }
            } else {
                return imagebox.geometry.x
            }
        }
        $scope.imageboxT = function (imagebox) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.geometry.y) - Number(imagebox.border.lineWidth)
                }
                if (imagebox.border.type == 'Pic') {
                    return imagebox.geometry.y
                    // return Number(imagebox.geometry.y) - (Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100)
                }
            } else {
                return imagebox.geometry.y
            }
        }
        $scope.imageboxWEdge = function (imagebox, edge) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.border.lineWidth)
                }
                if (imagebox.border.type == 'Pic') {
                    if (edge == 'left') {
                        return Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100
                    }
                    if (edge == 'top') {
                        return Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100
                    }
                    if (edge == 'right') {
                        return Number(imagebox.geometry.width) * Number(imagebox.border.edge.right) / 100
                    }
                    if (edge == 'bottom') {
                        return Number(imagebox.geometry.height) * Number(imagebox.border.edge.bottom) / 100
                    }
                }
            } else {
                return 0
            }
        }
        $scope.imageboxWRadius = function (imagebox, radius, ratio, ratio1) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                var _ratio = 1;
                if(ratio && ratio1){
                    if(imagebox.geometry.width > imagebox.geometry.height){
                        _ratio = ratio1
                    }else{
                        _ratio = ratio
                    }
                }
                if(ratio && !ratio1){
                    _ratio = ratio
                }
                if (imagebox.border.shape == 'Ellipse') {
                    return '50%'
                }
                if (imagebox.border.radius.filletType == 'Fixed') {//圆角固定值
                    var _radius = imagebox.border.radius[radius];
                    return _radius > 0 ?  (_radius + Number(imagebox.border.lineWidth)/2) * _ratio : 0;
                }else{
                    var radiusW = imagebox.geometry.width > imagebox.geometry.height ? imagebox.geometry.height : imagebox.geometry.width;
                    radiusW = radiusW + imagebox.border.lineWidth;
                    var _r = radiusW * imagebox.border.radius[radius] / 100;
                    return _r > 0 ? (_r + Number(imagebox.border.lineWidth)/2) * _ratio : 0
                }
            } else {
                return 0
            }
        }
        $scope.imageboxWRadius1 = function (imagebox, radius, ratio, ratio1) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                var _ratio = 1;
                if(ratio && ratio1){
                    if(imagebox.geometry.width > imagebox.geometry.height){
                        _ratio = ratio1
                    }else{
                        _ratio = ratio
                    }
                }
                if(ratio && !ratio1){
                    _ratio = ratio
                }
                if (imagebox.border.shape == 'Ellipse') {
                    return '50%'
                }
                if (imagebox.border.radius.filletType == 'Fixed') {//圆角固定值
                    var _radius = imagebox.border.radius[radius];
                    return  (_radius - Number(imagebox.border.lineWidth)/2) > 0 ? (_radius - Number(imagebox.border.lineWidth)/2) * _ratio : 0;
                }else{
                    var radiusW = imagebox.geometry.width > imagebox.geometry.height ? imagebox.geometry.height : imagebox.geometry.width;
                    radiusW = radiusW + imagebox.border.lineWidth;
                    var _r = radiusW * imagebox.border.radius[radius] / 100;
                    return (_r - Number(imagebox.border.lineWidth)/2) > 0 ? (_r - Number(imagebox.border.lineWidth)/2) * _ratio : 0
                }
            } else {
                return 0
            }
        }
        $scope.dropShadow = function(imagebox,ratio,ratio1){
            if (imagebox.shadow == null) {
                return
            }
            var width = $scope.imageboxW(imagebox) * ratio;
            var height =$scope.imageboxH(imagebox) * ratio1;
            return dropShadow(imagebox,width,height)
        }
        //生成缩略图
        function thumbnailInit(callback){
            thumbnailInit1(function (res){
                vm.article.covered=true;
                vm.article.cover=res;
                callback(res);
            })
        }
        function thumbnailInit1(callback) {
            $timeout(function (){
                html2canvas_adapt(document.getElementById('thumbnail-view'), {
                    onrendered: function (canvas) {
                        QiniuToken.uploadThumbnail(canvas, function (data) {
                            var identifier = data.key;
                            callback(identifier)
                        });
                    },
                    letterRendering: true,
                    useCORS: true,
                    width: $scope.template.pages.page[0].mediabox.width*vm.thumbnailScale,
                    height: $scope.template.pages.page[0].mediabox.height*vm.thumbnailScale,
                    windowWidth: document.body.scrollWidth,
                    windowHeight: document.body.scrollHeight,
                    x: -($scope.template.pages.page[0].mediabox.width - $scope.template.pages.page[0].mediabox.width*vm.thumbnailScale)/2,
                    y: -($scope.template.pages.page[0].mediabox.height - $scope.template.pages.page[0].mediabox.height*vm.thumbnailScale)/2,
                    ratio: vm.thumbnailScale,
                    backgroundColor: "rgba(0, 0, 0, 0)"
                });
            })
        }
        $scope.$on('changeLanguage', function () {
            getMessageNotification();
            getFontList();
            ThemeClassify.getAllByCondition4({type: 'CLIPART',storeId:vm.storeId}, function (res) {
                if(res.status == 200){
                    $scope.labels = angular.copy(res.data);
                }else {
                    MessageService.error(res.message);
                }
            });
        });

    }
})();

(function () {
    'use strict';

    angular
        .module('editorApp')
        .controller('ProductViewEcThreeShareController', ProductViewEcThreeShareController);

    ProductViewEcThreeShareController.$inject = ['$scope', '$stateParams', 'entity', '$q', '$localStorage', 'Qinius', 'Store',
        'ImageService', '$http', '$rootScope', 'Theme', 'ItemValue', 'PlatformWechatSetting', 'FontManagement','Product','Convert','ProductXml'];
    function ProductViewEcThreeShareController($scope, $stateParams, entity, $q, $localStorage, Qinius, Store,
                                    ImageService, $http, $rootScope, Theme, ItemValue, PlatformWechatSetting, FontManagement,Product,Convert,ProductXml) {
        var vm = this;

        //风格切换  引入不同的css文件
        Theme.judge();
        vm.platformSetting = PlatformWechatSetting.get();
        var audio = document.getElementById("audio");
        // audio.src = "content/ihope.mp3";
        audio.crossOrigin = 'anonymous';

        var timer = null;
        $(".navbar-gallery").hide();
        $(".wrap").show().addClass('no-margins');
        vm.storeId = $stateParams.storeId || $localStorage.storeId;
        vm.aid = $stateParams.aid;
        vm.article = entity.data;
        vm.reprint = 'LAR';
        $scope.dHeight = vm.dHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        $scope.dWidth = vm.dWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        $("body").css({width: $scope.dWidth, 'min-width': $scope.dWidth});
        $scope.document = {
            pages: [{}]
        };
        var artDoc = angular.copy(vm.article.document);

        $('.view2-article').on('click', 'touchstart', 'touchmove', function (event) {
            event.preventDefault();
        });
        /**
         * mm换算成px
         * @param mm
         * @returns {number}
         */
        var unitTransform = function (mm) {
            // return mm * 3;
            return mm / 25.4 * vm.windowDpi;
        };
        //dpi
        js_getDPI()
        function js_getDPI() {
            var arrDPI = new Array();
            if (window.screen.deviceXDPI != undefined) {
                arrDPI[0] = window.screen.deviceXDPI;
                arrDPI[1] = window.screen.deviceYDPI;
            }
            else {
                var tmpNode = document.createElement("DIV");
                tmpNode.style.cssText = "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
                document.body.appendChild(tmpNode);
                arrDPI[0] = parseInt(tmpNode.offsetWidth);
                arrDPI[1] = parseInt(tmpNode.offsetHeight);
                tmpNode.parentNode.removeChild(tmpNode);
            }
            vm.windowDpi = arrDPI[0];
            // vm.windowDpi = 300;
        }
        var $li = $(".templateView2-carousel");
        $li.hide();
        $scope.domains = Qinius.getDomain({storeId: vm.storeId});
        vm.store = Store.get({id: vm.storeId});
        var $load = $(".loading-page");
        var $flagBox = $(".flag-box");
        $flagBox.hide();

        function Play() {
            audio.play().then(function () {
                $(".PanelRight").removeClass('hide1');
                timer = window.setInterval(begin, 10);
            }).catch(function (error) {
                console.log(error);
            });
        }

        var rot = 10 - 0;
        function begin() {
            var micon = document.getElementById("music-icon");
            if (micon == null) {
                window.clearInterval(timer);
                return;
            }
            micon.style.transform = "rotate(" + rot + "deg)";
            rot += 1;
        }

        $("#Play").on('click', function () {
            window.clearInterval(timer);
            if (audio.paused) {
                audio.play();
                Play();
                $("#Play").children("img").removeClass("play").addClass("pause");
            }
            else {
                $("#Play").children("img").removeClass("pause").addClass("play");
                audio.pause();
            }
        });

        function makeCode() {
            var qrcode = new QRCode(document.getElementById("qrcode"), {
                width: 100,
                height: 100
            });
            qrcode.makeCode(vm.platformSetting.storeNotifyUrl + '/#/' + vm.storeId + '/index');
        }

        getAll(artDoc);
        function getAll(doc) {
            $q.all([$scope.domains.$promise, vm.article.$promise, vm.platformSetting.$promise, vm.store.$promise]).then(function () {
                if(vm.article.invalid){//作品失效
                    $state.go('articlesFailure',{storeId:vm.storeId},{location: 'replace'});
                    return
                }
                vm.platformSetting = vm.platformSetting.data;
                // vm.store = vm.store.data;
                // if (vm.store.storeType2.indexOf("MINI")<0) {
                //     $scope.miniType = false;
                //     makeCode();
                // }else{
                //     $scope.miniType = true;
                //     $http({
                //         url: "/fileserves/api/download/getMiniQrCode?storeId=" + vm.storeId,
                //         method: 'get',
                //         responseType: 'blob'
                //     }).success(function(res) {
                //         if(res.status == 200){
                //             var blob = new Blob([res.data], {
                //                 type: "image/jpeg"
                //             });
                //             $scope.image = URL.createObjectURL(blob);
                //         }else {
                //             MessageService.error(res.message);
                //         }
                //     })
                // }
                $scope.domain = 'https://' + $scope.domains.domains[0] + '/';
                // $scope.len = doc.pages.page.length;
                ItemValue.get({id: vm.article.itemValueId}, function (res) {
                    if(res.status == 200){
                        if (vm.article.musicIdentify) {
                            audio.src = $scope.domain + vm.article.musicIdentify;
                        }else{
                            if (res.data.musicIdentify) {
                                audio.src = $scope.domain + res.data.musicIdentify;
                            } else {
                                audio.src = '';
                            }
                        }
                    }else {
                        MessageService.error(res.message);
                    }
                });
                //取得xml文档内容
                // vm.reprint = doc.reprint;
                localStorage.setItem('reprint', vm.reprint);
                // var arrUse = {
                //     pages: {
                //         page: []
                //     },
                //     scene: doc.scene
                // };
                // arrUse.scene.imgUrl = arrUse.scene.resource.identifier;
                // angular.forEach(doc.pages.page, function (page) {
                //     if (!page.backup) {
                //         arrUse.pages.page.push(page);
                //     }
                // });
                // $scope.getDetail(arrUse, 0);
                // $scope.getDetail1(doc);

                // 自动播放音乐
                Play();
                Product.get({id: vm.article.productId}, function (resP) {
                    vm.product = resP.data;
                    Convert.xmlToDocument2({
                        identifier: vm.article.fileName,
                        provider: 'qiniu',
                        editorType:vm.article.editorType,
                        patternType:resP.data.patternType,
                    }, function (res) {
                        vm.article.document = res;
                        // $scope.getDetail(arrUse, 0);
                        $scope.getDetail1(res);
                        ProductXml.get({id:vm.article.productXmlId}, function (productXml) {
                            if(productXml.data.modelType && productXml.data.modelType === 'THREE'){
                                vm.modelType = 'THREE';
                                if(!productXml.data.modelPath){
                                    MessageService.error($translate.instant("editorCommon.not3D"));
                                    vm.threeView = false;
                                    return
                                }
                                vm.threeView = true;
                                vm.threeTemplate = vm.article.document;
                                vm.threeProductXmlData = productXml.data;
                            }else {
                                vm.modelType = 'TWO';
                            }
                        })
                    });
                })
            });
        }

        /**
         * 赋值 --> 先制作文字 --> 文字 --> [有占位框(生成新数组-->占位框图片转canvas) || 无占位框(占位框图片转canvas)]
         * @param document
         * @param index
         */
        $scope.getDetail1 = function(document){
            var windowRatio = 0.85;
            $scope.template = angular.copy(document);
            angular.forEach($scope.template.pages.page, function (page, index) {
                page.editbox = {
                    width: transitionPx(page.editbox.width),
                    height: transitionPx(page.editbox.height),
                    x: transitionPx(page.editbox.x),
                    y: transitionPx(page.editbox.y)
                };
                page.mediabox = {
                    width: transitionPx(page.mediabox.width),
                    height: transitionPx(page.mediabox.height),
                    x: transitionPx(page.mediabox.x),
                    y: transitionPx(page.mediabox.y)
                };
                page.trimbox = {
                    width: transitionPx(page.trimbox.width),
                    height: transitionPx(page.trimbox.height),
                    x: transitionPx(page.trimbox.x),
                    y: transitionPx(page.trimbox.y)
                };
                page.custom = {};
                if(page.scene){
                    page.scene.geometry = {
                        width: transitionPx(page.scene.geometry.width),
                        height: transitionPx(page.scene.geometry.height),
                        x: transitionPx(page.scene.geometry.x),
                        y: transitionPx(page.scene.geometry.y)
                    };
                    page.scene.imagebox.geometry = {
                        width: transitionPx(page.scene.imagebox.geometry.width),
                        height: transitionPx(page.scene.imagebox.geometry.height),
                        x: transitionPx(page.scene.imagebox.geometry.x),
                        y: transitionPx(page.scene.imagebox.geometry.y)
                    };
                    if(page.scene.resource){
                        getBackgroundSource(page.scene.resource,page.scene.geometry.width,page.scene.geometry.height,page.scene.resource);
                    }
                    page.custom.ratio = $scope.dWidth * windowRatio / page.scene.geometry.width;
                    page.custom.width = page.scene.geometry.width;
                    page.custom.height = page.scene.geometry.height;
                }else {
                    page.custom.ratio = $scope.dWidth * windowRatio / page.mediabox.width;
                    page.custom.width = page.mediabox.width;
                    page.custom.height = page.mediabox.height;
                }
                //条形码
                if(page.barcode){
                    page.barcode.geometry = {
                        width: transitionPx(page.barcode.geometry.width),
                        height: transitionPx(page.barcode.geometry.height),
                        x: transitionPx(page.barcode.geometry.x),
                        y: transitionPx(page.barcode.geometry.y)
                    };
                }
                if(page.qrcode){
                    page.qrcode.geometry = {
                        width: transitionPx(page.qrcode.geometry.width),
                        height: transitionPx(page.qrcode.geometry.height),
                        x: transitionPx(page.qrcode.geometry.x),
                        y: transitionPx(page.qrcode.geometry.y)
                    };
                }

                //背景
                if(page.background.resource.identifier){
                    getBackgroundSource(page.background.resource,page.mediabox.width,page.mediabox.height,page.background.resource);
                    page.background.offsetx = transitionPx(page.background.offsetx);
                    page.background.offsety = transitionPx(page.background.offsety);
                }
                angular.forEach(page.levels.level, function (level, i) {
                    if(level.imageart){
                        level.imageart.offsetx = transitionPx(level.imageart.offsetx);
                        level.imageart.offsety = transitionPx(level.imageart.offsety);
                        level.imageart.rotation.angle = -level.imageart.rotation.angle;
                        level.imageart.geometry = {
                            width: transitionPx(level.imageart.geometry.width),
                            height: transitionPx(level.imageart.geometry.height),
                            x: transitionPx(level.imageart.geometry.x),
                            y: transitionPx(level.imageart.geometry.y)
                        };
                        if(level.imageart.resource.identifier){
                            getBackgroundSource(level.imageart.resource,level.imageart.geometry.width,level.imageart.geometry.height,level.imageart.resource);
                        }
                    }
                    if(level.imagebox){
                        level.imagebox.geometry = {
                            width: transitionPx(level.imagebox.geometry.width),
                            height: transitionPx(level.imagebox.geometry.height),
                            x: transitionPx(level.imagebox.geometry.x),
                            y: transitionPx(level.imagebox.geometry.y)
                        };
                        level.imagebox.rotation.angle = -level.imagebox.rotation.angle;
                        level.imagebox.bokehtypes = level.imagebox.bokehtype;
                        if(level.imagebox.image){
                            level.imagebox.image.offsetx = transitionPx(level.imagebox.image.offsetx);
                            level.imagebox.image.offsety = transitionPx(level.imagebox.image.offsety);
                            if(level.imagebox.image.resource.identifier){
                                getBackgroundSource1(level.imagebox.image.resource,level.imagebox.geometry.width,level.imagebox.geometry.height,level.imagebox.image, level.imagebox.bokehtypes)
                            }
                        }
                        if(level.imagebox.blurredrectangle){
                            level.imagebox.blurredrectangle = {
                                width: transitionPx(level.imagebox.blurredrectangle.width),
                                height: transitionPx(level.imagebox.blurredrectangle.height),
                                x: transitionPx(level.imagebox.blurredrectangle.x),
                                y: transitionPx(level.imagebox.blurredrectangle.y)
                            };
                        }
                    }
                    if(level.textbox){
                        level.textbox.rotation.angle = -level.textbox.rotation.angle;
                        level.textbox.geometry = {
                            width: transitionPx(level.textbox.geometry.width),
                            height: transitionPx(level.textbox.geometry.height),
                            x: transitionPx(level.textbox.geometry.x),
                            y: transitionPx(level.textbox.geometry.y)
                        };
                        if(level.textbox.fontuuid){
                            //下载字体
                            getFont(level.textbox.fontuuid)
                        }
                        if (level.textbox.style.bold && level.textbox.style.italic) {
                            level.textbox.styles = 'BOLD_ITALIC';
                        } else if (level.textbox.style.bold) {
                            level.textbox.styles = 'BOLD';
                        } else if (level.textbox.style.italic) {
                            level.textbox.styles = 'ITALIC';
                        } else {
                            level.textbox.styles = 'NORMAL';
                        }
                        if (level.textbox.style.bold && level.textbox.style.italic) {
                            level.textbox.styles = 'BOLD_ITALIC';
                        } else if (level.textbox.style.bold) {
                            level.textbox.styles = 'BOLD';
                        } else if (level.textbox.style.italic) {
                            level.textbox.styles = 'ITALIC';
                        } else {
                            level.textbox.styles = 'NORMAL';
                        }
                    }
                    if (level.textdocument && level.textdocument.geometry) {
                        var textdocument = angular.copy(level.textdocument);
                        level.textdocument = {
                            background: textdocument.background,
                            geometry: {
                                width: transitionPx(textdocument.geometry.width),
                                height: transitionPx(textdocument.geometry.height),
                                x: transitionPx(textdocument.geometry.x),
                                y: transitionPx(textdocument.geometry.y)
                            },
                            rotation: {
                                angle:-textdocument.rotation.angle||0
                            },
                            current: 'textdocument',
                            levels: angular.copy(textdocument.levels),
                            lock: true,
                            transparency: textdocument.transparency,
                            movable: textdocument.movable,
                            useradded: textdocument.useradded,
                            editable: textdocument.editable,
                            scale:textdocument.geometry.width/page.mediabox.width
                        }

                        var backg = textdocument.background;
                        var pageW = textdocument.geometry.width,
                            pageH = textdocument.geometry.height;
                        if(backg.resource.identifier){
                            getBackgroundSource(backg.resource,pageW,pageH,backg);
                            backg.offsetx = transitionPx(backg.offsetx);
                            backg.offsety = transitionPx(backg.offsety);
                        }

                        angular.forEach(textdocument.levels.level, function (lev, l) {
                            if (lev.imageart && lev.imageart.geometry) {
                                var art = lev.imageart;
                                $http({url: art.resource.identifier + '?imageInfo'}).success(function (data) {
                                    level.textdocument.levels.level[l].imageart = {
                                        geometry:{
                                            width: transitionPx(art.geometry.width),
                                            height: transitionPx(art.geometry.height),
                                            x: transitionPx(art.geometry.x),
                                            y: transitionPx(art.geometry.y)
                                        },
                                        rotation: angular.copy(art.rotation),
                                        type: art.type,
                                        resource: {
                                            identifier:art.resource.identifier,
                                            provider:art.resource.provider,
                                            width:data.width,
                                            height:data.height
                                        },
                                        scale:art.scale,
                                        offsetx: transitionPx(art.offsetx),
                                        offsety: transitionPx(art.offsety),
                                        current: 'imageart',
                                        lock: false,
                                        transparency: art.transparency,
                                        onlyshow: art.onlyshow,
                                        movable: art.movable,
                                        useradded: art.useradded,
                                        editable: art.editable,
                                    }
                                }).error(function (error) {});
                            }
                            if (lev.textbox && lev.textbox.geometry) {
                                var text = lev.textbox;
                                level.textdocument.levels.level[l].textbox = {
                                    geometry: {
                                        width: transitionPx(text.geometry.width),
                                        height: transitionPx(text.geometry.height),
                                        x: transitionPx(text.geometry.x),
                                        y: transitionPx(text.geometry.y)
                                    },
                                    identifier: text.identifier,
                                    rotation: angular.copy(text.rotation),
                                    angle: angular.copy(text.angle),
                                    status: angular.copy(text.status),
                                    style: angular.copy(text.style),
                                    type: angular.copy(text.type),
                                    text: angular.copy(text.text),
                                    fontStyle: [{
                                        style: '',
                                        path: text.identifier
                                    }],
                                    current: 'textbox',
                                    lock: true,
                                    transparency: text.transparency,
                                    fontuuid:text.fontuuid,
                                    version:text.version
                                }
                                getFont(text.fontuuid)
                            }
                        })
                    }
                })
            })
            console.log($scope.template)
            showPage()
        }
        $scope.getDetail = function (document, index) {
            var obj = document.pages.page[index];
            $scope.scene = angular.copy(document.scene);

            $scope.template = document;
            var bgIdentifier = 'content/images/white.png';
            if (obj.background && obj.background.resource && obj.background.resource.identifier) {
                bgIdentifier = (obj.background.resource.identifier.indexOf('http') == -1 ? $scope.domain : '') + obj.background.resource.identifier + '?imageMogr2/thumbnail/!40p';
            }

            $scope.template.pages.page[index] = {
                bgImg:bgIdentifier,
                background: angular.copy(obj.background),
                barcode: angular.copy(obj.barcode),
                barcodeM: angular.copy(obj.barcode),
                qrcode: angular.copy(obj.qrcode),
                qrcodeM: angular.copy(obj.qrcode),
                barcodeRotation : {
                    angle: obj.barcodeRotation?obj.barcodeRotation.angle:0
                },
                mediabox: angular.copy(obj.mediabox),
                trimbox: angular.copy(obj.trimbox),
                textboxes: angular.copy(obj.textboxes),
                imageboxes: angular.copy(obj.imageboxes),
                levels: angular.copy(obj.levels),
                spread: obj.spread,
                centerrotation: obj.centerrotation ? true : false
            };

            $scope.scene = $scope.template.scene;
            $scope.scene.geometry = setGeometry($scope.scene.geometry);
            $scope.scene.imagebox.geometry = setGeometry1($scope.scene.imagebox.geometry);

            unitTransform($scope.template.pages.page[0].mediabox.width) * ($scope.dWidth - 45) /unitTransform($scope.template.pages.page[0].mediabox.width)
            //摆台
            var w0 = $scope.dWidth - 45,
                h0 = ($scope.dWidth - 45)*unitTransform($scope.template.pages.page[0].mediabox.height)/unitTransform($scope.template.pages.page[0].mediabox.width),
                w1 = $scope.scene.imagebox.geometry.width,
                h1 = $scope.scene.imagebox.geometry.height;
            if ((w0 <= h0 || w1 <= h1) && (w0 / h0 < w1 / h1) || w0 >= h0 && w1 >= h1 && (w0 / h0 < w1 / h1)) {
                $scope.imageboxConH = h1;
                $scope.imageboxConW = h1* w0 / h0;
                $scope.proportion = h0 / h1;
            } else {
                $scope.imageboxConW = w1;
                $scope.imageboxConH = w1 * h0 / w0;
                $scope.proportion = w0 / w1;
            }
            $scope.marginLeft = (w1 - $scope.imageboxConW) / 2;
            $scope.marginTop = (h1 - $scope.imageboxConH) / 2;


            var temp = $scope.template.pages.page[index];
            temp.styleScale = ((vm.dWidth - 45) / (unitTransform(obj.mediabox.width))) / $scope.proportion;
            //背景图片
            var w = temp.width* temp.styleScale,
                h = temp.height* temp.styleScale;
            if (temp.background.resource) {
                getBackgroundSource(temp.background.resource,w,h,temp.background);
                temp.background.offsetx = temp.background.offsetx* temp.styleScale;
                temp.background.offsety = temp.background.offsety* temp.styleScale;
                temp.background.offsetXM = angular.copy(temp.background.offsetx);
                temp.background.offsetYM = angular.copy(temp.background.offsety);
            }
            if (obj.barcode) {
                var barcode = obj.barcode.geometry;
                var angle = 0;
                if (obj.barcode.rotation && obj.barcode.rotation.angle) {
                    angle = obj.barcode.rotation.angle
                }
                temp.barcode = {
                    geometry: {
                        width: unitTransform(barcode.width) * temp.styleScale,
                        height: unitTransform(barcode.height) * temp.styleScale,
                        x: unitTransform(barcode.x) * temp.styleScale,
                        y: unitTransform(barcode.y) * temp.styleScale,
                        widthM: barcode.width,
                        heightM: barcode.height,
                        offsetXM: barcode.x,
                        offsetYM: barcode.y
                    },
                    rotation: {
                        angle: angle
                    }
                }
            }
            if (obj.qrcode) {
                var qrcode = obj.qrcode.geometry;
                var angle = 0;
                if (obj.qrcode.rotation && obj.qrcode.rotation.angle) {
                    angle = obj.qrcode.rotation.angle
                }
                temp.qrcode = {
                    geometry: {
                        width: unitTransform(qrcode.width) * temp.styleScale,
                        height: unitTransform(qrcode.height) * temp.styleScale,
                        x: unitTransform(qrcode.x) * temp.styleScale,
                        y: unitTransform(qrcode.y) * temp.styleScale,
                        widthM: qrcode.width,
                        heightM: qrcode.height,
                        offsetXM: qrcode.x,
                        offsetYM: qrcode.y
                    },
                    rotation: {
                        angle: angle
                    }
                }
            }

            angular.forEach(obj.levels.level, function (level, n) {

                if (level.imageart && level.imageart.geometry) {
                    var art = level.imageart;
                    $http({url: art.resource.identifier + '?imageInfo'}).success(function (data) {
                        temp.levels.level[n].imageart = {
                            geometry: getGeometry(art.geometry, temp),
                            rotation: {
                                angle: -art.rotation.angle
                            },
                            type: art.type,
                            resource: {
                                identifier:art.resource.identifier,
                                provider:art.resource.provider,
                                width:data.width,
                                height:data.height
                            },
                            scale:art.scale,
                            widthM: art.geometry.width,
                            heightM: art.geometry.height,
                            XM: art.geometry.x,
                            YM:art.geometry.y,
                            offsetXM: angular.copy(art.offsetx),
                            offsetYM: angular.copy(art.offsety),
                            offsetx: unitTransform(art.offsetx)* temp.styleScale,
                            offsety: unitTransform(art.offsety)* temp.styleScale,
                            current: 'imageart',
                            levelI: n,
                            pageI: index,
                            lock: false,
                            transparency: art.transparency,
                            onlyshow: art.onlyshow,
                            movable: art.movable,
                            editable: art.editable,
                        }
                    }).error(function (error) {});
                }
                if(level.textbox){
                    $scope.template.pages.page[index].levels.level[n].textbox = {
                        geometry: getGeometry(level.textbox.geometry, temp),
                        style: angular.copy(level.textbox.style),
                        identifier: level.textbox.identifier,
                        rotation: {
                            angle: -level.textbox.rotation.angle
                        },
                        text: level.textbox.text,
                        styles: 'NORMAL',
                        status: level.textbox.status,
                        type: level.textbox.type,
                        transparency: level.textbox.transparency,
                        movable: level.textbox.movable,
                        editable: level.textbox.editable,
                        fontuuid: level.textbox.fontuuid
                    };
                    var tempText = level.textbox;
                    if (tempText.style.bold && tempText.style.italic) {
                        tempText.styles = 'BOLD_ITALIC';
                    } else if (tempText.style.bold) {
                        tempText.styles = 'BOLD';
                    } else if (tempText.style.italic) {
                        tempText.styles = 'ITALIC';
                    } else {
                        tempText.styles = 'NORMAL';
                    }
                    if (level.textbox.text && level.textbox.identifier) {
                        toImg(tempText, $scope.template.pages.page[index].styleScale);
                    }
                    getFont(level.textbox.fontuuid)
                }
                if(level.imagebox){
                    var art = level.imagebox;
                    $scope.template.pages.page[index].levels.level[n].imagebox = {
                        geometry: getGeometry(level.imagebox.geometry, temp),
                        blurredrectangle: level.imagebox.blurredrectangle ? getGeometry(level.imagebox.blurredrectangle, temp) : null,

                        mask: angular.copy(level.imagebox.mask),
                        image: {
                            resource: {
                                identifier: level.imagebox.image ? level.imagebox.image.resource.identifier : '',
                                provider: level.imagebox.image ? level.imagebox.image.resource.provider : 'qiniu'
                            },
                            filterResource: {
                                identifier: level.imagebox.image && level.imagebox.image.filterResource ? level.imagebox.image.filterResource.identifier : '',
                                provider: level.imagebox.image && level.imagebox.image.filterResource ? level.imagebox.image.filterResource.provider : 'qiniu'
                            },
                            rotation: angular.copy(level.imagebox.rotation),
                            parameter: (!level.imagebox.image) || level.imagebox.image.parameter == null ? [] : angular.fromJson(level.imagebox.image.parameter),
                            filter: (!level.imagebox.image) || level.imagebox.image.filter == null ? '' : level.imagebox.image.filter,
                            offsetx: level.imagebox.image.offsetx == 0 ? 0 : (unitTransform(level.imagebox.image.offsetx) * $scope.template.pages.page[index].styleScale),
                            offsety: level.imagebox.image.offsety == 0 ? 0 : (unitTransform(level.imagebox.image.offsety) * $scope.template.pages.page[index].styleScale),
                            angle: level.imagebox.image && level.imagebox.image.angle ? level.imagebox.image.angle : 0,
                            scale: (!level.imagebox.image) || level.imagebox.image.scale == 1 ? 1 : level.imagebox.image.scale,
                            index: (!level.imagebox.image) ? '' : level.imagebox.image.index
                        },
                        imgUrl: 'content/images/timg.jpg',
                        maskUrl: 'content/images/timg.jpg',
                        rotation: angular.copy(level.imagebox.rotation),
                        scaleW: 1,
                        scaleH: 1,
                        bokehtype: level.imagebox.bokehtype
                    };

                    if (level.imagebox.bokehtype!='None') {
                        level.imagebox.blurredrectangle = getGeometry(level.imagebox.blurredrectangle, temp)
                    }

                    var imageboxes = $scope.template.pages.page[index].levels.level[n].imagebox;
                    if (level.imagebox.mask.resource.identifier) {
                        imageboxes.maskUrl = (level.imagebox.mask.resource.identifier.indexOf('http') == -1 ? $scope.domain : '') + level.imagebox.mask.resource.identifier + '?imageMogr2';
                    }

                    if (level.imagebox.image && level.imagebox.image.resource.identifier) {       //qiniu
                        imageboxes.imgUrl = (level.imagebox.image.resource.identifier.indexOf('http') == -1 ? $scope.domain : '') + level.imagebox.image.resource.identifier + '?imageMogr2/exifModify/eyJPcmllbnRhdGlvbiI6IjEifQ==/thumbnail/!40p';
                        if (imageboxes.image.angle != 0) {
                            imageboxes.imgUrl += '/rotate/' + imageboxes.image.angle
                        }
                    }
                }

                if (level.textdocument && level.textdocument.geometry) {
                    var textdocument = level.textdocument;
                    $scope.template.pages.page[index].levels.level[n].textdocument = {
                        background: textdocument.background,
                        geometry: getGeometry(textdocument.geometry,temp),
                        widthM: textdocument.geometry.width,
                        heightM: textdocument.geometry.height,
                        offsetXM: textdocument.geometry.x,
                        offsetYM: textdocument.geometry.y,
                        rotation: {
                            angle:textdocument.rotation.angle||0
                        },
                        current: 'textdocument',
                        levels: angular.copy(textdocument.levels),
                        levelI: n,
                        pageI: index,
                        lock: true,
                        transparency: textdocument.transparency,
                        movable: textdocument.movable,
                        editable: textdocument.editable,
                        scale:textdocument.geometry.width/obj.mediabox.width
                    }

                    var backg = temp.levels.level[n].textdocument.background;
                    var pageW = temp.levels.level[n].textdocument.geometry.width,
                        pageH = temp.levels.level[n].textdocument.geometry.height;
                    if(backg.resource.identifier){
                        getBackgroundSource(backg.resource,pageW,pageH,backg)
                        backg.offsetx = unitTransform(backg.offsetx)* temp.styleScale
                        backg.offsety = unitTransform(backg.offsety)* temp.styleScale
                        backg.offsetXM = angular.copy(backg.offsetx);
                        backg.offsetYM = angular.copy(backg.offsety);
                    }

                    angular.forEach(textdocument.levels.level, function (lev, l) {
                        if (lev.imageart && lev.imageart.geometry) {
                            var art = lev.imageart;
                            $http({url: art.resource.identifier + '?imageInfo'}).success(function (data) {
                                temp.levels.level[n].textdocument.levels.level[l].imageart = {
                                    geometry: getGeometry(art.geometry,temp),
                                    rotation: angular.copy(art.rotation),
                                    type: art.type,
                                    resource: {
                                        identifier:art.resource.identifier,
                                        provider:art.resource.provider,
                                        width:data.width,
                                        height:data.height
                                    },
                                    scale:art.scale,
                                    widthM: art.geometry.width,
                                    heightM: art.geometry.height,
                                    XM: art.geometry.x,
                                    YM:art.geometry.y,
                                    offsetXM: angular.copy(art.offsetx),
                                    offsetYM: angular.copy(art.offsety),
                                    offsetx: unitTransform(art.offsetx)* temp.styleScale,
                                    offsety: unitTransform(art.offsety)* temp.styleScale,
                                    current: 'imageart',
                                    levelI: n,
                                    pageI: index,
                                    lock: false,
                                    transparency: art.transparency,
                                    onlyshow: art.onlyshow,
                                    movable: art.movable,
                                    editable: art.editable,
                                }
                            }).error(function (error) {});
                        }
                        if (lev.textbox && lev.textbox.geometry) {
                            var text = lev.textbox;
                            temp.levels.level[n].textdocument.levels.level[l].textbox = {
                                geometry: getGeometry(text.geometry, temp),
                                identifier: text.identifier,
                                rotation: angular.copy(text.rotation),
                                angle: angular.copy(text.angle),
                                status: angular.copy(text.status),
                                style: angular.copy(text.style),
                                type: angular.copy(text.type),
                                text: angular.copy(text.text),
                                fontStyle: [{
                                    style: '',
                                    path: text.identifier
                                }],
                                widthM: text.geometry.width,
                                heightM: text.geometry.height,
                                offsetXM: text.geometry.x,
                                offsetYM: text.geometry.y,
                                current: 'textbox',
                                levelI: n,
                                pageI: index,
                                lock: true,
                                transparency: text.transparency,
                                lineheight: text.style.lineheight,
                                letterspacing: text.style.letterspacing,
                                fontuuid:text.fontuuid,
                                version:text.version
                            }
                            // toImg($scope.template.pages.page[i].levels.level[n].textbox)
                        }
                    })
                }
            });
            //背景图片
            if($scope.template.pages.page[index].background.resource.identifier){

                $http({url: $scope.template.pages.page[index].background.resource.identifier+'?imageInfo'}).success(function (data) {
                    var bgImgW = data.width;
                    var bgImgH = data.height;

                    var bgImgR = bgImgW/bgImgH;
                    var bgImgR1 = $scope.template.pages.page[index].width/$scope.template.pages.page[index].height;
                    if(bgImgR >= bgImgR1){
                        $scope.template.pages.page[index].background.adaptation = 'Height';
                    }else {
                        $scope.template.pages.page[index].background.adaptation = 'Width';
                    }
                }).error(function (error) {
                    MessageService.error("获取图片信息失败");
                });
            }
            var w =(unitTransform(document.scene.geometry.width) * $scope.template.pages.page[index].styleScale);
            $scope.template.pages.page[index].ratio = w  / (document.scene.geometry.width / 25.4 * vm.windowDpi)
            $scope.isLeftRotation = false;
            angular.forEach($scope.template.pages.page[0].levels.level, function (image) {
                if(image.imagebox){
                    imgScale(image.imagebox, 0, 0, image.imagebox.maskUrl, image.imagebox.image.offsetx, image.imagebox.image.offsety);
                }
            })
        };

        function getBackgroundSource1(res,pageW,pageH,item, bokehtypes) {
            var newImg = new Image();
            newImg.crossOrigin = "Anonymous";
            newImg.src = (res.identifier.indexOf('http') == -1 ? $scope.domain : '') + res.identifier + '?imageMogr2/exifModify/eyJPcmllbnRhdGlvbiI6IjEifQ==/rotate/' + item.angle+'/thumbnail/!40p';
            newImg.onload = function () {
                var imgR = pageW/pageH;
                var imgR1 = newImg.width/newImg.height;
                if(bokehtypes == 'None'){
                    if(imgR >= imgR1){
                        item.resource.adaptation = 'Height';
                        item.width= pageW;
                        item.height= pageW/newImg.width*newImg.height;
                    }else {
                        item.resource.adaptation = 'Width';
                        item.width= pageH/newImg.height * newImg.width;
                        item.height= pageH;
                    }
                }else {
                    if(imgR >= imgR1){
                        item.resource.adaptation = 'Height';
                        item.width= pageW;
                        item.height= pageW/newImg.width*newImg.height;
                        item.offsetx= 0;
                        item.offsety= (pageH - pageW/newImg.width*newImg.height) / 2;
                    }else {
                        item.resource.adaptation = 'Width';
                        item.width= pageH/newImg.height*newImg.width;
                        item.height= pageH;
                        item.offsetx= (pageW - pageH/newImg.height*newImg.width) / 2;
                        item.offsety= 0;
                    }
                }
                $scope.$digest();
            };
        }
        function getBackgroundSource(res,pageW,pageH,arr) {
            $http({url: res.identifier + '?imageInfo'}).success(function (data) {
                var bgImgR = data.width/data.height;
                var bgImgR1 = pageW/pageH;
                if(bgImgR >= bgImgR1){
                    arr.adaptation = 'Height';
                }else {
                    arr.adaptation = 'Width';
                }
            }).error(function (error) {});
        }

        function getFont(item){
            if(item){
                FontManagement.getCss({uuid: item}, function (res) {
                    if(res.status == 200){
                        var style=document.createElement("style");
                        style.type='text/css';
                        try{
                            style.appendChild(document.createTextNode(res.data));
                        }catch(ex){
                            style.stylesheet.cssText=res.data;
                        }
                        var Head=document.getElementsByTagName("head")[0];
                        Head.appendChild(style);
                    }else {
                        MessageService.error(res.message);
                    }
                });
            }
        }
        //mm转px
        function transitionPx(item) {
            return item * vm.windowDpi / 25.4;
        }
        /**
         * 摆台宽高坐标从 mm 换算成 px
         * @param obj
         * @param index
         * @returns {{height: number, width: number, x: number, y: number}}
         */
        function setGeometry(obj) {
            $scope.template.scene.styleScale = (unitTransform(obj.width) / ($scope.dWidth - 45));
            return {
                height: unitTransform(obj.height) / $scope.template.scene.styleScale,
                width: $scope.dWidth - 45,
                x: 0,
                y: 0
            };
        }
        function setGeometry1(obj) {
            return {
                height: unitTransform(obj.height) / $scope.template.scene.styleScale,
                width: unitTransform(obj.width) / $scope.template.scene.styleScale,
                x: unitTransform(obj.x) / $scope.template.scene.styleScale,
                y: unitTransform(obj.y) / $scope.template.scene.styleScale
            };
        }
        /**
         * 宽高坐标从 mm 换算成 px
         * @param obj
         * @param index
         * @returns {{height: number, width: number, x: number, y: number}}
         */
        function getGeometry(obj, temp) {
            return {
                height: unitTransform(obj.height) * temp.styleScale,
                width: unitTransform(obj.width) * temp.styleScale,
                x: unitTransform(obj.x) * temp.styleScale,
                y: unitTransform(obj.y) * temp.styleScale
            }
        }

        /**
         * 占位框宽高适配，进行canvas操作
         * @param images    占位框
         * @param index     第N页page
         * @param mask      蒙版图形
         * @param x         图片坐标x
         * @param y         图片坐标y
         */
        function imgScale(images, pageI, index, mask, x, y, flag) {
            var scaleW = 1, scaleH = 1;
            var newImg = new Image();
            newImg.crossOrigin = "Anonymous";
            newImg.src = images.imgUrl;

            newImg.onload = function () {
                newImg.onload = null;
                var w = newImg.width;
                var h = newImg.height;
                var maskWidth = images.geometry.width;
                var maskHight = images.geometry.height;
                if ((newImg.width <= newImg.height || maskWidth <= maskHight) && (newImg.width / newImg.height < maskWidth / maskHight) || newImg.width >= newImg.height && maskWidth >= maskHight && (newImg.width / newImg.height < maskWidth / maskHight)) {
                    newImg.width = maskWidth;
                    newImg.height = maskWidth * h / w;
                } else {
                    newImg.height = maskHight;
                    newImg.width = maskHight * w / h;
                }

                scaleW = newImg.width / w;
                scaleH = newImg.height / h;
                x = x / scaleW;
                y = y / scaleH;

                var img = images.imgUrl;
                if (images.bokehtype == 'Transparent') {
                    maskd3(img, images.imgUrl, images, function (src) {
                        images.blobSmall = src;
                        dropPicFinished(pageI,index);
                    });

                } else if (images.bokehtype == 'Blurred') {
                    maskd3(img, images.imgUrl, images, function (src) {
                        images.blobSmall = src;
                        $scope.$digest();
                    });

                    img = img + '/blur/40x1000';
                    maskd(img, images.maskUrl, 'source-in', x, y, maskWidth, maskHight, scaleW, scaleH, images.image.scale, function (src) {
                        images.blobUrl = src;
                        dropPicFinished(pageI,index);
                    });

                } else {
                    maskd(img, images.maskUrl, 'source-in', x, y, maskWidth, maskHight, scaleW, scaleH, images.image.scale, function (src) {
                        images.blobUrl = src;
                        dropPicFinished(pageI,index);
                    });
                }

            };
            newImg.onerror = function () {
                images.imgUrl = $scope.domain + images.image.resource.identifier + '?imageMogr2/exifModify/eyJPcmllbnRhdGlvbiI6IjEifQ==';
                if (images.image.angle != 0) {
                    images.imgUrl += '/rotate/' + images.image.angle
                }

                if (!flag) {
                    imgScale(images, pageI, index, mask, x, y, true);
                } else {
                    showPage();
                    $(".templateView-loading").addClass('hide1');
                    $(".background").show();
                }

            }
        }


        function dropPicFinished(pageI,index) {
            $scope.$apply(function () {
                if (index == pageI) {
                    showPage();
                }
                if (vm.reprint == 'OTHER' || $scope.template.pages.page.length < 2) {
                    showPage();
                }
                $(".templateView-loading").addClass('hide1');
                $(".background").show();
            });
        }

        function maskd3(img, src, imagebox, callback) {
            var imagecanvas = document.createElement('canvas');
            var imagecontext = imagecanvas.getContext('2d');
            var geo = imagebox.geometry;
            var blurredRec = imagebox.blurredrectangle;

            var newImg = new Image();
            newImg.crossOrigin = "Anonymous";
            newImg.src = src;
            newImg.onload = function () {
                newImg.onload = null;
                newImg.width = blurredRec.width;
                newImg.height = blurredRec.height;
                var masks = new Image();
                masks.crossOrigin = "Anonymous";
                masks.src = imagebox.maskUrl;

                masks.onload = function () {
                    masks.width = geo.width;
                    masks.height = geo.height;
                    imagecanvas.width = geo.width;
                    imagecanvas.height = geo.height;
                    imagecontext.mozImageSmoothingEnabled = true;
                    imagecontext.webkitImageSmoothingEnabled = true;
                    imagecontext.msImageSmoothingEnabled = true;
                    imagecontext.imageSmoothingEnabled = true;

                    imagecontext.drawImage(masks, 0, 0, geo.width, geo.height);
                    imagecontext.globalCompositeOperation = 'source-in';

                    imagecontext.drawImage(newImg, blurredRec.x, blurredRec.y, blurredRec.width, blurredRec.height);

                    if (!callback) {
                        return;
                    }
                    callback.call(this, ImageService.dataURLtoBlob(imagecanvas.toDataURL()));

                    imagecanvas = null;
                };
            };
        }

        function showPage() {
            $scope.loading = false;
            $(".page-loading").hide();
            $li.show();
            $load.hide();
            $flagBox.show();
        }

        var getPixelRatio = function (context) {
            var backingStoreRatio = context.webkitBackingStorePixelRatio ||
                context.mozBackingStorePixelRatio ||
                context.msBackingStorePixelRatio ||
                context.oBackingStorePixelRatio ||
                context.backingStorePixelRatio || 1;

            return (window.devicePixelRatio || 1) / backingStoreRatio;
        };

        function maskd(src, maskUrl, attr, x0, y0, width, height, scaleW, scaleH, scale, callback) {
            var imagecanvas = document.createElement('canvas');
            var imagecontext = imagecanvas.getContext('2d');

            var ratio = getPixelRatio(imagecontext);
            imagecanvas.style.width = width + "px";
            imagecanvas.style.height = height + "px";
            imagecanvas.width = width * ratio;
            imagecanvas.height = height * ratio;
            imagecontext.scale(ratio, ratio);

            var newImg = new Image();
            newImg.crossOrigin = "Anonymous";
            newImg.width = width;
            newImg.height = height;
            newImg.src = src;
            newImg.onload = function () {
                newImg.onload = null;
                var masks = new Image();
                masks.crossOrigin = "Anonymous";
                masks.onload = function () {
                    masks.onload = null;
                    masks.width = width;
                    masks.height = height;
                    imagecanvas.width = width;
                    imagecanvas.height = height;

                    imagecontext.drawImage(masks, 0, 0, width, height);
                    imagecontext.globalCompositeOperation = attr;

                    imagecontext.scale(scaleW, scaleH);
                    imagecontext.scale(scale, scale);

                    imagecontext.drawImage(newImg, x0, y0);


                    if (!callback) {
                        return;
                    }
                    callback.call(this, ImageService.dataURLtoBlob(imagecanvas.toDataURL()));

                    imagecanvas = null;
                };
                masks.src = maskUrl;
            };
        }

        function toImg(text, scale) {
            text.geometry.width /= scale;
            text.geometry.height /= scale;

            $http({
                url: '/editor/fileserves/api/convert/textToImg',
                method: 'POST',
                data: {
                    identifier: text.identifier,
                    text: text.text,
                    fontSize: text.style.size,
                    style: text.styles,
                    height: text.geometry.height,
                    width: text.geometry.width,
                    color: text.style.color,
                    family: text.style.font,
                    storeId: vm.storeId
                },
                responseType: 'blob'
            }).success(function (res, status, headers, config) {
                if(res.status == 200){
                    text.geometry.width = text.geometry.width * scale;
                    text.geometry.height = text.geometry.height * scale;

                    var createObjectURL = function (blob) {
                        return window[window.webkitURL ? 'webkitURL' : 'URL']['createObjectURL'](blob);
                    };
                    var fileURL = URL.createObjectURL(res.data);

                    text.picCode = text.pic = fileURL;
                    text.identifier = text.identifier || $scope.defaultText.path;
                }else {
                    MessageService.error(res.message);
                }
            }).error(function () {
                console.log("textToImg error");
            });
        }

        //旋转屏幕
        // window.addEventListener('orientationchange', function (event) {
        //     setReviewDoc();
        // });
        window.addEventListener('resize', function (event) {
            if (vm.reprint == 'OTHER' || $scope.template.pages.page.length < 2) {
                return
            }

            if (window.orientation == 0) {
                $rootScope.orientations = false;
            }
            setReviewDoc();
        });

        if (window.orientation == 90 || window.orientation == -90) {
            $li.width($scope.dWidth);
            $rootScope.orientation = false;
            console.log("always 横屏");
        } else {
            $rootScope.orientations = true;
        }

        function setReviewDoc() {
            $(".save-page").removeClass('hide1');
            $(".view2-article").addClass('hide1');
            $(".share-wrap").addClass('hide1');
            setTimeout(function () {
                if (window.orientation == 180 || window.orientation == 0) {
                    console.log("竖屏。。。。。");
                    $rootScope.orientations = true;
                    orientationChange();

                } else if (window.orientation == 90 || window.orientation == -90) {
                    console.log("横屏。。。。。");
                    $rootScope.orientations = false;
                    orientationChange();
                }
            }, 500);
        }

        function orientationChange() {
            $scope.dHeight = document.documentElement.clientHeight;
            $scope.dWidth = document.documentElement.clientWidth;
            $(".back-to-customer").width($scope.dWidth);
            $li.width($scope.dWidth);
            var newDoc = angular.copy(entity.data.document);
            getAll(newDoc);
            setTimeout(function () {
                $(".save-page").addClass('hide1');
                $(".view2-article").removeClass('hide1');
                $(".share-wrap").removeClass('hide1');
            }, 1500);
        }


        $scope.toggle = {
            now: false
        };
//边框
        $scope.imageboxW = function (imagebox) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.geometry.width) + Number(imagebox.border.lineWidth) * 2
                }
                if (imagebox.border.type == 'Pic') {
                    return imagebox.geometry.width
                    // return Number(imagebox.geometry.width) + (Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100) + (Number(imagebox.geometry.width) * Number(imagebox.border.edge.right) / 100)
                }
            } else {
                return imagebox.geometry.width
            }
        }
        $scope.imageboxH = function (imagebox) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.geometry.height) + Number(imagebox.border.lineWidth) * 2
                }
                if (imagebox.border.type == 'Pic') {
                    return imagebox.geometry.height
                    // return Number(imagebox.geometry.height) + (Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100) + (Number(imagebox.geometry.height) * Number(imagebox.border.edge.bottom) / 100)
                }
            } else {
                return imagebox.geometry.height
            }
        }
        $scope.imageboxL = function (imagebox) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.geometry.x) - Number(imagebox.border.lineWidth)
                }
                if (imagebox.border.type == 'Pic') {
                    return imagebox.geometry.x
                    // return Number(imagebox.geometry.x) - (Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100)
                }
            } else {
                return imagebox.geometry.x
            }
        }
        $scope.imageboxT = function (imagebox) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.geometry.y) - Number(imagebox.border.lineWidth)
                }
                if (imagebox.border.type == 'Pic') {
                    return imagebox.geometry.y
                    // return Number(imagebox.geometry.y) - (Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100)
                }
            } else {
                return imagebox.geometry.y
            }
        }
        $scope.imageboxWEdge = function (imagebox, edge) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.border.lineWidth)
                }
                if (imagebox.border.type == 'Pic') {
                    if (edge == 'left') {
                        return Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100
                    }
                    if (edge == 'top') {
                        return Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100
                    }
                    if (edge == 'right') {
                        return Number(imagebox.geometry.width) * Number(imagebox.border.edge.right) / 100
                    }
                    if (edge == 'bottom') {
                        return Number(imagebox.geometry.height) * Number(imagebox.border.edge.bottom) / 100
                    }
                }
            } else {
                return 0
            }
        }
        $scope.imageboxWRadius = function (imagebox, radius, ratio, ratio1) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                var _ratio = 1;
                if(ratio && ratio1){
                    if(imagebox.geometry.width > imagebox.geometry.height){
                        _ratio = ratio1
                    }else{
                        _ratio = ratio
                    }
                }
                if(ratio && !ratio1){
                    _ratio = ratio
                }
                if (imagebox.border.shape == 'Ellipse') {
                    return '50%'
                }
                if (imagebox.border.radius.filletType == 'Fixed') {//圆角固定值
                    var _radius = imagebox.border.radius[radius];
                    return _radius > 0 ?  (_radius + Number(imagebox.border.lineWidth)/2) * _ratio : 0;
                }else{
                    var radiusW = imagebox.geometry.width > imagebox.geometry.height ? imagebox.geometry.height : imagebox.geometry.width;
                    radiusW = radiusW + imagebox.border.lineWidth;
                    var _r = radiusW * imagebox.border.radius[radius] / 100;
                    return _r > 0 ? (_r + Number(imagebox.border.lineWidth)/2) * _ratio : 0
                }
            } else {
                return 0
            }
        }
        $scope.imageboxWRadius1 = function (imagebox, radius, ratio, ratio1) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                var _ratio = 1;
                if(ratio && ratio1){
                    if(imagebox.geometry.width > imagebox.geometry.height){
                        _ratio = ratio1
                    }else{
                        _ratio = ratio
                    }
                }
                if(ratio && !ratio1){
                    _ratio = ratio
                }
                if (imagebox.border.shape == 'Ellipse') {
                    return '50%'
                }
                if (imagebox.border.radius.filletType == 'Fixed') {//圆角固定值
                    var _radius = imagebox.border.radius[radius];
                    return  (_radius - Number(imagebox.border.lineWidth)/2) > 0 ? (_radius - Number(imagebox.border.lineWidth)/2) * _ratio : 0;
                }else{
                    var radiusW = imagebox.geometry.width > imagebox.geometry.height ? imagebox.geometry.height : imagebox.geometry.width;
                    radiusW = radiusW + imagebox.border.lineWidth;
                    var _r = radiusW * imagebox.border.radius[radius] / 100;
                    return (_r - Number(imagebox.border.lineWidth)/2) > 0 ? (_r - Number(imagebox.border.lineWidth)/2) * _ratio : 0
                }
            } else {
                return 0
            }
        }
        $scope.dropShadow = function(imagebox,ratio,ratio1){
            if (imagebox.shadow == null) {
                return
            }
            var width = $scope.imageboxW(imagebox) * ratio;
            var height =$scope.imageboxH(imagebox) * ratio1;
            return dropShadow(imagebox,width,height)
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('editorApp')
        .controller('ProductViewEcThreePreviewController', ProductViewEcThreePreviewController);

    ProductViewEcThreePreviewController.$inject = ['$scope', '$stateParams', 'entity', '$q', '$localStorage', 'Qinius',
        'ImageService', '$http', '$rootScope', 'Theme', 'ItemValue', 'PlatformWechatSetting', 'Store', 'FontManagement', '$translate'];
    function ProductViewEcThreePreviewController($scope, $stateParams, entity, $q, $localStorage, Qinius,
                                               ImageService, $http, $rootScope, Theme, ItemValue, PlatformWechatSetting, Store, FontManagement, $translate) {
        var vm = this;

        //风格切换  引入不同的css文件
        Theme.judge();
        vm.platformSetting = PlatformWechatSetting.get();
        var audio = document.getElementById("audio");
        // audio.src = "content/ihope.mp3";
        audio.crossOrigin = 'anonymous';

        var timer = null;
        $(".navbar-gallery").hide();
        $(".wrap").show().addClass('no-margins');
        vm.storeId = $stateParams.storeId || $localStorage.storeId;
        vm.aid = $stateParams.aid;
        vm.article = entity.data;
        vm.reprint = 'LAR';
        $scope.dHeight = vm.dHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        $scope.dWidth = vm.dWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        $("body").css({width: $scope.dWidth, 'min-width': $scope.dWidth});
        $scope.document = {
            pages: [{}]
        };
        var artDoc = angular.copy(vm.article.document);

        $('.view2-article').on('click', 'touchstart', 'touchmove', function (event) {
            event.preventDefault();
        });
        /**
         * mm换算成px
         * @param mm
         * @returns {number}
         */
        var unitTransform = function (mm) {
            // return mm * 3;
            return mm / 25.4 * vm.windowDpi;
        };
        //dpi
        js_getDPI()
        function js_getDPI() {
            var arrDPI = new Array();
            if (window.screen.deviceXDPI != undefined) {
                arrDPI[0] = window.screen.deviceXDPI;
                arrDPI[1] = window.screen.deviceYDPI;
            }
            else {
                var tmpNode = document.createElement("DIV");
                tmpNode.style.cssText = "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
                document.body.appendChild(tmpNode);
                arrDPI[0] = parseInt(tmpNode.offsetWidth);
                arrDPI[1] = parseInt(tmpNode.offsetHeight);
                tmpNode.parentNode.removeChild(tmpNode);
            }
            vm.windowDpi = arrDPI[0];
            // vm.windowDpi = 300;
        }

        var $li = $(".templateView2-carousel");
        $li.hide();
        $scope.domains = Qinius.getDomain({storeId: vm.storeId});
        vm.store = Store.get({id: vm.storeId});
        var $load = $(".loading-page");
        var $flagBox = $(".flag-box");
        $flagBox.hide();

        function Play() {
            audio.play().then(function () {
                $(".PanelRight").removeClass('hide1');
                timer = window.setInterval(begin, 10);
            }).catch(function (error) {
                console.log(error);
            });
        }

        var rot = 10 - 0;

        function begin() {
            var micon = document.getElementById("music-icon");
            if (micon == null) {
                window.clearInterval(timer);
                return;
            }
            micon.style.transform = "rotate(" + rot + "deg)";
            rot += 1;
        }

        $("#Play").on('click', function () {
            window.clearInterval(timer);
            if (audio.paused) {
                audio.play();
                Play();
                $("#Play").children("img").removeClass("play").addClass("pause");
            }
            else {
                $("#Play").children("img").removeClass("pause").addClass("play");
                audio.pause();
            }
        });

        function makeCode() {
            var qrcode = new QRCode(document.getElementById("qrcode"), {
                width: 100,
                height: 100
            });
            qrcode.makeCode(vm.platformSetting.storeNotifyUrl + '/#/' + vm.storeId + '/index');
        }

        getAll(artDoc);
        function getAll(doc) {
            $q.all([$scope.domains.$promise, vm.article.$promise, vm.platformSetting.$promise, vm.store.$promise]).then(function () {
                if(vm.article.invalid){//作品失效
                    $state.go('articlesFailure',{storeId:vm.storeId},{location: 'replace'});
                    return
                }
                vm.platformSetting = vm.platformSetting.data;
                vm.store = vm.store.data;
                if (vm.store.storeType2.indexOf("MINI") < 0) {
                    $scope.miniType = false;
                    // makeCode();
                } else {
                    $scope.miniType = true;
                    $http({
                        url: "/fileserves/api/download/getMiniQrCode?storeId=" + vm.storeId,
                        method: 'get',
                        responseType: 'blob'
                    }).success(function (res) {
                        if(res.status == 200){
                            var blob = new Blob([res.data], {
                                type: "image/jpeg"
                            });
                            $scope.image = URL.createObjectURL(blob);
                        }else {
                            MessageService.error(res.message);
                        }
                    })
                }
                $scope.domain = 'https://' + $scope.domains.domains[0] + '/';
                $scope.len = doc.pages.page.length;
                ItemValue.get({id: vm.article.itemValueId}, function (res) {
                    if(res.status == 200){
                        if (vm.article.musicIdentify) {
                            audio.src = $scope.domain + vm.article.musicIdentify;
                        } else {
                            if (res.data.musicIdentify) {
                                audio.src = $scope.domain + res.data.musicIdentify;
                            } else {
                                audio.src = '';
                            }
                        }
                    }else {
                        MessageService.error(res.message);
                    }
                });
                //取得xml文档内容
                vm.reprint = doc.reprint;
                localStorage.setItem('reprint', vm.reprint);
                // var arrUse = {
                //     pages: {
                //         page: []
                //     },
                //     scene: doc.scene
                // };
                // arrUse.scene.imgUrl = arrUse.scene.resource.identifier;
                // angular.forEach(doc.pages.page, function (page) {
                //     if (!page.backup) {
                //         arrUse.pages.page.push(page);
                //     }
                // });
                // $scope.getDetail(arrUse, 0);
                $scope.getDetail1(doc);

                // 自动播放音乐
                Play();
            });
        }

        /**
         * 赋值 --> 先制作文字 --> 文字 --> [有占位框(生成新数组-->占位框图片转canvas) || 无占位框(占位框图片转canvas)]
         * @param document
         * @param index
         */
        $scope.getDetail1 = function (document) {
            var windowRatio = 0.85;
            $scope.template = angular.copy(document);
            angular.forEach($scope.template.pages.page, function (page, index) {
                page.editbox = {
                    width: transitionPx(page.editbox.width),
                    height: transitionPx(page.editbox.height),
                    x: transitionPx(page.editbox.x),
                    y: transitionPx(page.editbox.y)
                };
                page.mediabox = {
                    width: transitionPx(page.mediabox.width),
                    height: transitionPx(page.mediabox.height),
                    x: transitionPx(page.mediabox.x),
                    y: transitionPx(page.mediabox.y)
                };
                page.trimbox = {
                    width: transitionPx(page.trimbox.width),
                    height: transitionPx(page.trimbox.height),
                    x: transitionPx(page.trimbox.x),
                    y: transitionPx(page.trimbox.y)
                };
                page.custom = {};
                if (page.scene) {
                    page.scene.geometry = {
                        width: transitionPx(page.scene.geometry.width),
                        height: transitionPx(page.scene.geometry.height),
                        x: transitionPx(page.scene.geometry.x),
                        y: transitionPx(page.scene.geometry.y)
                    };
                    page.scene.imagebox.geometry = {
                        width: transitionPx(page.scene.imagebox.geometry.width),
                        height: transitionPx(page.scene.imagebox.geometry.height),
                        x: transitionPx(page.scene.imagebox.geometry.x),
                        y: transitionPx(page.scene.imagebox.geometry.y)
                    };
                    if (page.scene.resource) {
                        getBackgroundSource(page.scene.resource, page.scene.geometry.width, page.scene.geometry.height, page.scene.resource);
                    }
                    page.custom.ratio = $scope.dWidth * windowRatio / page.scene.geometry.width;
                    page.custom.width = page.scene.geometry.width;
                    page.custom.height = page.scene.geometry.height;
                } else {
                    page.custom.ratio = $scope.dWidth * windowRatio / page.mediabox.width;
                    page.custom.width = page.mediabox.width;
                    page.custom.height = page.mediabox.height;
                }
                //条形码
                if (page.barcode) {
                    page.barcode.geometry = {
                        width: transitionPx(page.barcode.geometry.width),
                        height: transitionPx(page.barcode.geometry.height),
                        x: transitionPx(page.barcode.geometry.x),
                        y: transitionPx(page.barcode.geometry.y)
                    };
                }
                if (page.qrcode) {
                    page.qrcode.geometry = {
                        width: transitionPx(page.qrcode.geometry.width),
                        height: transitionPx(page.qrcode.geometry.height),
                        x: transitionPx(page.qrcode.geometry.x),
                        y: transitionPx(page.qrcode.geometry.y)
                    };
                }

                //背景
                if (page.background.resource.identifier) {
                    getBackgroundSource(page.background.resource, page.mediabox.width, page.mediabox.height, page.background.resource);
                    page.background.offsetx = transitionPx(page.background.offsetx);
                    page.background.offsety = transitionPx(page.background.offsety);
                }
                angular.forEach(page.levels.level, function (level, i) {
                    if (level.imageart) {
                        level.imageart.offsetx = transitionPx(level.imageart.offsetx);
                        level.imageart.offsety = transitionPx(level.imageart.offsety);
                        level.imageart.rotation.angle = -level.imageart.rotation.angle;
                        level.imageart.geometry = {
                            width: transitionPx(level.imageart.geometry.width),
                            height: transitionPx(level.imageart.geometry.height),
                            x: transitionPx(level.imageart.geometry.x),
                            y: transitionPx(level.imageart.geometry.y)
                        };
                        if (level.imageart.resource.identifier) {
                            getBackgroundSource(level.imageart.resource, level.imageart.geometry.width, level.imageart.geometry.height, level.imageart.resource);
                        }
                    }
                    if (level.imagebox) {
                        level.imagebox.geometry = {
                            width: transitionPx(level.imagebox.geometry.width),
                            height: transitionPx(level.imagebox.geometry.height),
                            x: transitionPx(level.imagebox.geometry.x),
                            y: transitionPx(level.imagebox.geometry.y)
                        };
                        level.imagebox.rotation.angle = -level.imagebox.rotation.angle;
                        level.imagebox.bokehtypes = level.imagebox.bokehtype;
                        if (level.imagebox.image) {
                            level.imagebox.image.offsetx = transitionPx(level.imagebox.image.offsetx);
                            level.imagebox.image.offsety = transitionPx(level.imagebox.image.offsety);
                            if (level.imagebox.image.resource.identifier) {
                                getBackgroundSource1(level.imagebox.image.resource, level.imagebox.geometry.width, level.imagebox.geometry.height, level.imagebox.image, level.imagebox.bokehtypes)
                            }
                        }
                        if (level.imagebox.blurredrectangle) {
                            level.imagebox.blurredrectangle = {
                                width: transitionPx(level.imagebox.blurredrectangle.width),
                                height: transitionPx(level.imagebox.blurredrectangle.height),
                                x: transitionPx(level.imagebox.blurredrectangle.x),
                                y: transitionPx(level.imagebox.blurredrectangle.y)
                            };
                        }
                    }
                    if (level.textbox) {
                        level.textbox.rotation.angle = -level.textbox.rotation.angle;
                        level.textbox.geometry = {
                            width: transitionPx(level.textbox.geometry.width),
                            height: transitionPx(level.textbox.geometry.height),
                            x: transitionPx(level.textbox.geometry.x),
                            y: transitionPx(level.textbox.geometry.y)
                        };
                        if (level.textbox.fontuuid) {
                            //下载字体
                            getFont(level.textbox.fontuuid)
                        }
                        if (level.textbox.style.bold && level.textbox.style.italic) {
                            level.textbox.styles = 'BOLD_ITALIC';
                        } else if (level.textbox.style.bold) {
                            level.textbox.styles = 'BOLD';
                        } else if (level.textbox.style.italic) {
                            level.textbox.styles = 'ITALIC';
                        } else {
                            level.textbox.styles = 'NORMAL';
                        }
                        if (level.textbox.style.bold && level.textbox.style.italic) {
                            level.textbox.styles = 'BOLD_ITALIC';
                        } else if (level.textbox.style.bold) {
                            level.textbox.styles = 'BOLD';
                        } else if (level.textbox.style.italic) {
                            level.textbox.styles = 'ITALIC';
                        } else {
                            level.textbox.styles = 'NORMAL';
                        }
                    }
                    if (level.textdocument && level.textdocument.geometry) {
                        var textdocument = angular.copy(level.textdocument);
                        level.textdocument = {
                            background: textdocument.background,
                            geometry: {
                                width: transitionPx(textdocument.geometry.width),
                                height: transitionPx(textdocument.geometry.height),
                                x: transitionPx(textdocument.geometry.x),
                                y: transitionPx(textdocument.geometry.y)
                            },
                            rotation: {
                                angle: -textdocument.rotation.angle || 0
                            },
                            current: 'textdocument',
                            levels: angular.copy(textdocument.levels),
                            lock: true,
                            transparency: textdocument.transparency,
                            movable: textdocument.movable,
                            useradded: textdocument.useradded,
                            editable: textdocument.editable,
                            scale: textdocument.geometry.width / page.mediabox.width
                        }

                        var backg = textdocument.background;
                        var pageW = textdocument.geometry.width,
                            pageH = textdocument.geometry.height;
                        if (backg.resource.identifier) {
                            getBackgroundSource(backg.resource, pageW, pageH, backg);
                            backg.offsetx = transitionPx(backg.offsetx);
                            backg.offsety = transitionPx(backg.offsety);
                        }

                        angular.forEach(textdocument.levels.level, function (lev, l) {
                            if (lev.imageart && lev.imageart.geometry) {
                                var art = lev.imageart;
                                $http({url: art.resource.identifier + '?imageInfo'}).success(function (data) {
                                    level.textdocument.levels.level[l].imageart = {
                                        geometry: {
                                            width: transitionPx(art.geometry.width),
                                            height: transitionPx(art.geometry.height),
                                            x: transitionPx(art.geometry.x),
                                            y: transitionPx(art.geometry.y)
                                        },
                                        rotation: angular.copy(art.rotation),
                                        type: art.type,
                                        resource: {
                                            identifier: art.resource.identifier,
                                            provider: art.resource.provider,
                                            width: data.width,
                                            height: data.height
                                        },
                                        scale: art.scale,
                                        offsetx: transitionPx(art.offsetx),
                                        offsety: transitionPx(art.offsety),
                                        current: 'imageart',
                                        lock: false,
                                        transparency: art.transparency,
                                        onlyshow: art.onlyshow,
                                        movable: art.movable,
                                        useradded: art.useradded,
                                        editable: art.editable,
                                    }
                                }).error(function (error) {
                                });
                            }
                            if (lev.textbox && lev.textbox.geometry) {
                                var text = lev.textbox;
                                level.textdocument.levels.level[l].textbox = {
                                    geometry: {
                                        width: transitionPx(text.geometry.width),
                                        height: transitionPx(text.geometry.height),
                                        x: transitionPx(text.geometry.x),
                                        y: transitionPx(text.geometry.y)
                                    },
                                    identifier: text.identifier,
                                    rotation: angular.copy(text.rotation),
                                    angle: angular.copy(text.angle),
                                    status: angular.copy(text.status),
                                    style: angular.copy(text.style),
                                    type: angular.copy(text.type),
                                    text: angular.copy(text.text),
                                    fontStyle: [{
                                        style: '',
                                        path: text.identifier
                                    }],
                                    current: 'textbox',
                                    lock: true,
                                    transparency: text.transparency,
                                    fontuuid: text.fontuuid,
                                    version: text.version
                                }
                                getFont(text.fontuuid)
                            }
                        })
                    }
                })
            })
            console.log($scope.template)
            showPage()
        }
        $scope.getDetail = function (document, index) {
            var obj = document.pages.page[index];
            $scope.scene = angular.copy(document.scene);

            $scope.template = document;
            var bgIdentifier = 'content/images/white.png';
            if (obj.background && obj.background.resource && obj.background.resource.identifier) {
                bgIdentifier = (obj.background.resource.identifier.indexOf('http') == -1 ? $scope.domain : '') + obj.background.resource.identifier + '?imageMogr2/thumbnail/!40p';
            }

            $scope.template.pages.page[index] = {
                bgImg: bgIdentifier,
                background: angular.copy(obj.background),
                barcode: angular.copy(obj.barcode),
                barcodeM: angular.copy(obj.barcode),
                qrcode: angular.copy(obj.qrcode),
                qrcodeM: angular.copy(obj.qrcode),
                barcodeRotation: {
                    angle: obj.barcodeRotation ? obj.barcodeRotation.angle : 0
                },
                mediabox: angular.copy(obj.mediabox),
                trimbox: angular.copy(obj.trimbox),
                textboxes: angular.copy(obj.textboxes),
                imageboxes: angular.copy(obj.imageboxes),
                levels: angular.copy(obj.levels),
                spread: obj.spread,
                centerrotation: obj.centerrotation ? true : false
            };

            $scope.scene = $scope.template.scene;
            $scope.scene.geometry = setGeometry($scope.scene.geometry);
            $scope.scene.imagebox.geometry = setGeometry1($scope.scene.imagebox.geometry);

            unitTransform($scope.template.pages.page[0].mediabox.width) * ($scope.dWidth - 45) / unitTransform($scope.template.pages.page[0].mediabox.width)
            //摆台
            var w0 = $scope.dWidth - 45,
                h0 = ($scope.dWidth - 45) * unitTransform($scope.template.pages.page[0].mediabox.height) / unitTransform($scope.template.pages.page[0].mediabox.width),
                w1 = $scope.scene.imagebox.geometry.width,
                h1 = $scope.scene.imagebox.geometry.height;
            if ((w0 <= h0 || w1 <= h1) && (w0 / h0 < w1 / h1) || w0 >= h0 && w1 >= h1 && (w0 / h0 < w1 / h1)) {
                $scope.imageboxConH = h1;
                $scope.imageboxConW = h1 * w0 / h0;
                $scope.proportion = h0 / h1;
            } else {
                $scope.imageboxConW = w1;
                $scope.imageboxConH = w1 * h0 / w0;
                $scope.proportion = w0 / w1;
            }
            $scope.marginLeft = (w1 - $scope.imageboxConW) / 2;
            $scope.marginTop = (h1 - $scope.imageboxConH) / 2;


            var temp = $scope.template.pages.page[index];
            temp.styleScale = ((vm.dWidth - 45) / (unitTransform(obj.mediabox.width))) / $scope.proportion;
            //背景图片
            var w = temp.width * temp.styleScale,
                h = temp.height * temp.styleScale;
            if (temp.background.resource) {
                getBackgroundSource(temp.background.resource, w, h, temp.background);
                temp.background.offsetx = temp.background.offsetx * temp.styleScale;
                temp.background.offsety = temp.background.offsety * temp.styleScale;
                temp.background.offsetXM = angular.copy(temp.background.offsetx);
                temp.background.offsetYM = angular.copy(temp.background.offsety);
            }
            if (obj.barcode) {
                var barcode = obj.barcode.geometry;
                var angle = 0;
                if (obj.barcode.rotation && obj.barcode.rotation.angle) {
                    angle = obj.barcode.rotation.angle
                }
                temp.barcode = {
                    geometry: {
                        width: unitTransform(barcode.width) * temp.styleScale,
                        height: unitTransform(barcode.height) * temp.styleScale,
                        x: unitTransform(barcode.x) * temp.styleScale,
                        y: unitTransform(barcode.y) * temp.styleScale,
                        widthM: barcode.width,
                        heightM: barcode.height,
                        offsetXM: barcode.x,
                        offsetYM: barcode.y
                    },
                    rotation: {
                        angle: angle
                    }
                }
            }
            if (obj.qrcode) {
                var qrcode = obj.qrcode.geometry;
                var angle = 0;
                if (obj.qrcode.rotation && obj.qrcode.rotation.angle) {
                    angle = obj.qrcode.rotation.angle
                }
                temp.qrcode = {
                    geometry: {
                        width: unitTransform(qrcode.width) * temp.styleScale,
                        height: unitTransform(qrcode.height) * temp.styleScale,
                        x: unitTransform(qrcode.x) * temp.styleScale,
                        y: unitTransform(qrcode.y) * temp.styleScale,
                        widthM: qrcode.width,
                        heightM: qrcode.height,
                        offsetXM: qrcode.x,
                        offsetYM: qrcode.y
                    },
                    rotation: {
                        angle: angle
                    }
                }
            }

            angular.forEach(obj.levels.level, function (level, n) {

                if (level.imageart && level.imageart.geometry) {
                    var art = level.imageart;
                    $http({url: art.resource.identifier + '?imageInfo'}).success(function (data) {
                        temp.levels.level[n].imageart = {
                            geometry: getGeometry(art.geometry, temp),
                            rotation: {
                                angle: -art.rotation.angle
                            },
                            type: art.type,
                            resource: {
                                identifier: art.resource.identifier,
                                provider: art.resource.provider,
                                width: data.width,
                                height: data.height
                            },
                            scale: art.scale,
                            widthM: art.geometry.width,
                            heightM: art.geometry.height,
                            XM: art.geometry.x,
                            YM: art.geometry.y,
                            offsetXM: angular.copy(art.offsetx),
                            offsetYM: angular.copy(art.offsety),
                            offsetx: unitTransform(art.offsetx) * temp.styleScale,
                            offsety: unitTransform(art.offsety) * temp.styleScale,
                            current: 'imageart',
                            levelI: n,
                            pageI: index,
                            lock: false,
                            transparency: art.transparency,
                            onlyshow: art.onlyshow,
                            movable: art.movable,
                            editable: art.editable,
                        }
                    }).error(function (error) {
                    });
                }
                if (level.textbox) {
                    $scope.template.pages.page[index].levels.level[n].textbox = {
                        geometry: getGeometry(level.textbox.geometry, temp),
                        style: angular.copy(level.textbox.style),
                        identifier: level.textbox.identifier,
                        rotation: {
                            angle: -level.textbox.rotation.angle
                        },
                        text: level.textbox.text,
                        styles: 'NORMAL',
                        status: level.textbox.status,
                        type: level.textbox.type,
                        transparency: level.textbox.transparency,
                        movable: level.textbox.movable,
                        editable: level.textbox.editable,
                        fontuuid: level.textbox.fontuuid
                    };
                    var tempText = level.textbox;
                    if (tempText.style.bold && tempText.style.italic) {
                        tempText.styles = 'BOLD_ITALIC';
                    } else if (tempText.style.bold) {
                        tempText.styles = 'BOLD';
                    } else if (tempText.style.italic) {
                        tempText.styles = 'ITALIC';
                    } else {
                        tempText.styles = 'NORMAL';
                    }
                    if (level.textbox.text && level.textbox.identifier) {
                        toImg(tempText, $scope.template.pages.page[index].styleScale);
                    }
                    getFont(level.textbox.fontuuid)
                }
                if (level.imagebox) {
                    var art = level.imagebox;
                    $scope.template.pages.page[index].levels.level[n].imagebox = {
                        geometry: getGeometry(level.imagebox.geometry, temp),
                        blurredrectangle: level.imagebox.blurredrectangle ? getGeometry(level.imagebox.blurredrectangle, temp) : null,

                        mask: angular.copy(level.imagebox.mask),
                        image: {
                            resource: {
                                identifier: level.imagebox.image ? level.imagebox.image.resource.identifier : '',
                                provider: level.imagebox.image ? level.imagebox.image.resource.provider : 'qiniu'
                            },
                            filterResource: {
                                identifier: level.imagebox.image && level.imagebox.image.filterResource ? level.imagebox.image.filterResource.identifier : '',
                                provider: level.imagebox.image && level.imagebox.image.filterResource ? level.imagebox.image.filterResource.provider : 'qiniu'
                            },
                            rotation: angular.copy(level.imagebox.rotation),
                            parameter: (!level.imagebox.image) || level.imagebox.image.parameter == null ? [] : angular.fromJson(level.imagebox.image.parameter),
                            filter: (!level.imagebox.image) || level.imagebox.image.filter == null ? '' : level.imagebox.image.filter,
                            offsetx: level.imagebox.image.offsetx == 0 ? 0 : (unitTransform(level.imagebox.image.offsetx) * $scope.template.pages.page[index].styleScale),
                            offsety: level.imagebox.image.offsety == 0 ? 0 : (unitTransform(level.imagebox.image.offsety) * $scope.template.pages.page[index].styleScale),
                            angle: level.imagebox.image && level.imagebox.image.angle ? level.imagebox.image.angle : 0,
                            scale: (!level.imagebox.image) || level.imagebox.image.scale == 1 ? 1 : level.imagebox.image.scale,
                            index: (!level.imagebox.image) ? '' : level.imagebox.image.index
                        },
                        imgUrl: 'content/images/timg.jpg',
                        maskUrl: 'content/images/timg.jpg',
                        rotation: angular.copy(level.imagebox.rotation),
                        scaleW: 1,
                        scaleH: 1,
                        bokehtype: level.imagebox.bokehtype
                    };

                    if (level.imagebox.bokehtype != 'None') {
                        level.imagebox.blurredrectangle = getGeometry(level.imagebox.blurredrectangle, temp)
                    }

                    var imageboxes = $scope.template.pages.page[index].levels.level[n].imagebox;
                    if (level.imagebox.mask.resource.identifier) {
                        imageboxes.maskUrl = (level.imagebox.mask.resource.identifier.indexOf('http') == -1 ? $scope.domain : '') + level.imagebox.mask.resource.identifier + '?imageMogr2';
                    }

                    if (level.imagebox.image && level.imagebox.image.resource.identifier) {       //qiniu
                        imageboxes.imgUrl = (level.imagebox.image.resource.identifier.indexOf('http') == -1 ? $scope.domain : '') + level.imagebox.image.resource.identifier + '?imageMogr2/auto-orient/thumbnail/!40p';
                        if (imageboxes.image.angle != 0) {
                            imageboxes.imgUrl += '/rotate/' + imageboxes.image.angle
                        }
                    }
                }

                if (level.textdocument && level.textdocument.geometry) {
                    var textdocument = level.textdocument;
                    $scope.template.pages.page[index].levels.level[n].textdocument = {
                        background: textdocument.background,
                        geometry: getGeometry(textdocument.geometry, temp),
                        widthM: textdocument.geometry.width,
                        heightM: textdocument.geometry.height,
                        offsetXM: textdocument.geometry.x,
                        offsetYM: textdocument.geometry.y,
                        rotation: {
                            angle: textdocument.rotation.angle || 0
                        },
                        current: 'textdocument',
                        levels: angular.copy(textdocument.levels),
                        levelI: n,
                        pageI: index,
                        lock: true,
                        transparency: textdocument.transparency,
                        movable: textdocument.movable,
                        editable: textdocument.editable,
                        scale: textdocument.geometry.width / obj.mediabox.width
                    }

                    var backg = temp.levels.level[n].textdocument.background;
                    var pageW = temp.levels.level[n].textdocument.geometry.width,
                        pageH = temp.levels.level[n].textdocument.geometry.height;
                    if (backg.resource.identifier) {
                        getBackgroundSource(backg.resource, pageW, pageH, backg)
                        backg.offsetx = unitTransform(backg.offsetx) * temp.styleScale
                        backg.offsety = unitTransform(backg.offsety) * temp.styleScale
                        backg.offsetXM = angular.copy(backg.offsetx);
                        backg.offsetYM = angular.copy(backg.offsety);
                    }

                    angular.forEach(textdocument.levels.level, function (lev, l) {
                        if (lev.imageart && lev.imageart.geometry) {
                            var art = lev.imageart;
                            $http({url: art.resource.identifier + '?imageInfo'}).success(function (data) {
                                temp.levels.level[n].textdocument.levels.level[l].imageart = {
                                    geometry: getGeometry(art.geometry, temp),
                                    rotation: angular.copy(art.rotation),
                                    type: art.type,
                                    resource: {
                                        identifier: art.resource.identifier,
                                        provider: art.resource.provider,
                                        width: data.width,
                                        height: data.height
                                    },
                                    scale: art.scale,
                                    widthM: art.geometry.width,
                                    heightM: art.geometry.height,
                                    XM: art.geometry.x,
                                    YM: art.geometry.y,
                                    offsetXM: angular.copy(art.offsetx),
                                    offsetYM: angular.copy(art.offsety),
                                    offsetx: unitTransform(art.offsetx) * temp.styleScale,
                                    offsety: unitTransform(art.offsety) * temp.styleScale,
                                    current: 'imageart',
                                    levelI: n,
                                    pageI: index,
                                    lock: false,
                                    transparency: art.transparency,
                                    onlyshow: art.onlyshow,
                                    movable: art.movable,
                                    editable: art.editable,
                                }
                            }).error(function (error) {
                            });
                        }
                        if (lev.textbox && lev.textbox.geometry) {
                            var text = lev.textbox;
                            temp.levels.level[n].textdocument.levels.level[l].textbox = {
                                geometry: getGeometry(text.geometry, temp),
                                identifier: text.identifier,
                                rotation: angular.copy(text.rotation),
                                angle: angular.copy(text.angle),
                                status: angular.copy(text.status),
                                style: angular.copy(text.style),
                                type: angular.copy(text.type),
                                text: angular.copy(text.text),
                                fontStyle: [{
                                    style: '',
                                    path: text.identifier
                                }],
                                widthM: text.geometry.width,
                                heightM: text.geometry.height,
                                offsetXM: text.geometry.x,
                                offsetYM: text.geometry.y,
                                current: 'textbox',
                                levelI: n,
                                pageI: index,
                                lock: true,
                                transparency: text.transparency,
                                lineheight: text.style.lineheight,
                                letterspacing: text.style.letterspacing,
                                fontuuid: text.fontuuid,
                                version: text.version
                            }
                            // toImg($scope.template.pages.page[i].levels.level[n].textbox)
                        }
                    })
                }
            });
            //背景图片
            if ($scope.template.pages.page[index].background.resource.identifier) {

                $http({url: $scope.template.pages.page[index].background.resource.identifier + '?imageInfo'}).success(function (data) {
                    var bgImgW = data.width;
                    var bgImgH = data.height;

                    var bgImgR = bgImgW / bgImgH;
                    var bgImgR1 = $scope.template.pages.page[index].width / $scope.template.pages.page[index].height;
                    if (bgImgR >= bgImgR1) {
                        $scope.template.pages.page[index].background.adaptation = 'Height';
                    } else {
                        $scope.template.pages.page[index].background.adaptation = 'Width';
                    }
                }).error(function (error) {
                    MessageService.error("获取图片信息失败");
                });
            }
            var w = (unitTransform(document.scene.geometry.width) * $scope.template.pages.page[index].styleScale);
            $scope.template.pages.page[index].ratio = w / (document.scene.geometry.width / 25.4 * vm.windowDpi)
            $scope.isLeftRotation = false;
            angular.forEach($scope.template.pages.page[0].levels.level, function (image) {
                if (image.imagebox) {
                    imgScale(image.imagebox, 0, 0, image.imagebox.maskUrl, image.imagebox.image.offsetx, image.imagebox.image.offsety);
                }
            })
        };

        function getBackgroundSource1(res, pageW, pageH, item, bokehtypes) {
            var newImg = new Image();
            newImg.crossOrigin = "Anonymous";
            newImg.src = (res.identifier.indexOf('http') == -1 ? $scope.domain : '') + res.identifier + '?imageMogr2/auto-orient/rotate/' + item.angle + '/thumbnail/!40p';
            newImg.onload = function () {
                var imgR = pageW / pageH;
                var imgR1 = newImg.width / newImg.height;
                if (bokehtypes == 'None') {
                    if (imgR >= imgR1) {
                        item.resource.adaptation = 'Height';
                        item.width = pageW;
                        item.height = pageW / newImg.width * newImg.height;
                    } else {
                        item.resource.adaptation = 'Width';
                        item.width = pageH / newImg.height * newImg.width;
                        item.height = pageH;
                    }
                } else {
                    if (imgR >= imgR1) {
                        item.resource.adaptation = 'Height';
                        item.width = pageW;
                        item.height = pageW / newImg.width * newImg.height;
                        item.offsetx = 0;
                        item.offsety = (pageH - pageW / newImg.width * newImg.height) / 2;
                    } else {
                        item.resource.adaptation = 'Width';
                        item.width = pageH / newImg.height * newImg.width;
                        item.height = pageH;
                        item.offsetx = (pageW - pageH / newImg.height * newImg.width) / 2;
                        item.offsety = 0;
                    }
                }
                $scope.$digest();
            };
        }

        function getBackgroundSource(res, pageW, pageH, arr) {
            $http({url: res.identifier + '?imageInfo'}).success(function (data) {
                var bgImgR = data.width / data.height;
                var bgImgR1 = pageW / pageH;
                if (bgImgR >= bgImgR1) {
                    arr.adaptation = 'Height';
                } else {
                    arr.adaptation = 'Width';
                }
            }).error(function (error) {
            });
        }

        function getFont(item) {
            if (item) {
                FontManagement.getCss({uuid: item}, function (res) {
                    if(res.status == 200){
                        var style = document.createElement("style");
                        style.type = 'text/css';
                        try {
                            style.appendChild(document.createTextNode(res.data));
                        } catch (ex) {
                            style.stylesheet.cssText = res.data;
                        }
                        var Head = document.getElementsByTagName("head")[0];
                        Head.appendChild(style);
                    }else {
                        MessageService.error(res.message);
                    }
                });
            }
        }

        //mm转px
        function transitionPx(item) {
            return item * vm.windowDpi / 25.4;
        }

        /**
         * 摆台宽高坐标从 mm 换算成 px
         * @param obj
         * @param index
         * @returns {{height: number, width: number, x: number, y: number}}
         */
        function setGeometry(obj) {
            $scope.template.scene.styleScale = (unitTransform(obj.width) / ($scope.dWidth - 45));
            return {
                height: unitTransform(obj.height) / $scope.template.scene.styleScale,
                width: $scope.dWidth - 45,
                x: 0,
                y: 0
            };
        }

        function setGeometry1(obj) {
            return {
                height: unitTransform(obj.height) / $scope.template.scene.styleScale,
                width: unitTransform(obj.width) / $scope.template.scene.styleScale,
                x: unitTransform(obj.x) / $scope.template.scene.styleScale,
                y: unitTransform(obj.y) / $scope.template.scene.styleScale
            };
        }

        /**
         * 宽高坐标从 mm 换算成 px
         * @param obj
         * @param index
         * @returns {{height: number, width: number, x: number, y: number}}
         */
        function getGeometry(obj, temp) {
            return {
                height: unitTransform(obj.height) * temp.styleScale,
                width: unitTransform(obj.width) * temp.styleScale,
                x: unitTransform(obj.x) * temp.styleScale,
                y: unitTransform(obj.y) * temp.styleScale
            }
        }

        /**
         * 占位框宽高适配，进行canvas操作
         * @param images    占位框
         * @param index     第N页page
         * @param mask      蒙版图形
         * @param x         图片坐标x
         * @param y         图片坐标y
         */
        function imgScale(images, pageI, index, mask, x, y, flag) {
            var scaleW = 1, scaleH = 1;
            var newImg = new Image();
            newImg.crossOrigin = "Anonymous";
            newImg.src = images.imgUrl;

            newImg.onload = function () {
                newImg.onload = null;
                var w = newImg.width;
                var h = newImg.height;
                var maskWidth = images.geometry.width;
                var maskHight = images.geometry.height;
                if ((newImg.width <= newImg.height || maskWidth <= maskHight) && (newImg.width / newImg.height < maskWidth / maskHight) || newImg.width >= newImg.height && maskWidth >= maskHight && (newImg.width / newImg.height < maskWidth / maskHight)) {
                    newImg.width = maskWidth;
                    newImg.height = maskWidth * h / w;
                } else {
                    newImg.height = maskHight;
                    newImg.width = maskHight * w / h;
                }

                scaleW = newImg.width / w;
                scaleH = newImg.height / h;
                x = x / scaleW;
                y = y / scaleH;

                var img = images.imgUrl;
                if (images.bokehtype == 'Transparent') {
                    maskd3(img, images.imgUrl, images, function (src) {
                        images.blobSmall = src;
                        dropPicFinished(pageI, index);
                    });

                } else if (images.bokehtype == 'Blurred') {
                    maskd3(img, images.imgUrl, images, function (src) {
                        images.blobSmall = src;
                        $scope.$digest();
                    });

                    img = img + '/blur/40x1000';
                    maskd(img, images.maskUrl, 'source-in', x, y, maskWidth, maskHight, scaleW, scaleH, images.image.scale, function (src) {
                        images.blobUrl = src;
                        dropPicFinished(pageI, index);
                    });

                } else {
                    maskd(img, images.maskUrl, 'source-in', x, y, maskWidth, maskHight, scaleW, scaleH, images.image.scale, function (src) {
                        images.blobUrl = src;
                        dropPicFinished(pageI, index);
                    });
                }

            };
            newImg.onerror = function () {
                images.imgUrl = $scope.domain + images.image.resource.identifier + '?imageMogr2/auto-orient';
                if (images.image.angle != 0) {
                    images.imgUrl += '/rotate/' + images.image.angle
                }

                if (!flag) {
                    imgScale(images, pageI, index, mask, x, y, true);
                } else {
                    showPage();
                    $(".templateView-loading").addClass('hide1');
                    $(".background").show();
                }

            }
        }


        function dropPicFinished(pageI, index) {
            $scope.$apply(function () {
                if (index == pageI) {
                    showPage();
                }
                if (vm.reprint == 'OTHER' || $scope.template.pages.page.length < 2) {
                    showPage();
                }
                $(".templateView-loading").addClass('hide1');
                $(".background").show();
            });
        }

        function maskd3(img, src, imagebox, callback) {
            var imagecanvas = document.createElement('canvas');
            var imagecontext = imagecanvas.getContext('2d');
            var geo = imagebox.geometry;
            var blurredRec = imagebox.blurredrectangle;

            var newImg = new Image();
            newImg.crossOrigin = "Anonymous";
            newImg.src = src;
            newImg.onload = function () {
                newImg.onload = null;
                newImg.width = blurredRec.width;
                newImg.height = blurredRec.height;
                var masks = new Image();
                masks.crossOrigin = "Anonymous";
                masks.src = imagebox.maskUrl;

                masks.onload = function () {
                    masks.width = geo.width;
                    masks.height = geo.height;
                    imagecanvas.width = geo.width;
                    imagecanvas.height = geo.height;
                    imagecontext.mozImageSmoothingEnabled = true;
                    imagecontext.webkitImageSmoothingEnabled = true;
                    imagecontext.msImageSmoothingEnabled = true;
                    imagecontext.imageSmoothingEnabled = true;

                    imagecontext.drawImage(masks, 0, 0, geo.width, geo.height);
                    imagecontext.globalCompositeOperation = 'source-in';

                    imagecontext.drawImage(newImg, blurredRec.x, blurredRec.y, blurredRec.width, blurredRec.height);

                    if (!callback) {
                        return;
                    }
                    callback.call(this, ImageService.dataURLtoBlob(imagecanvas.toDataURL()));

                    imagecanvas = null;
                };
            };
        }

        function showPage() {
            $scope.loading = false;
            $(".page-loading").hide();
            $li.show();
            $load.hide();
            $flagBox.show();
        }

        var getPixelRatio = function (context) {
            var backingStoreRatio = context.webkitBackingStorePixelRatio ||
                context.mozBackingStorePixelRatio ||
                context.msBackingStorePixelRatio ||
                context.oBackingStorePixelRatio ||
                context.backingStorePixelRatio || 1;

            return (window.devicePixelRatio || 1) / backingStoreRatio;
        };

        function maskd(src, maskUrl, attr, x0, y0, width, height, scaleW, scaleH, scale, callback) {
            var imagecanvas = document.createElement('canvas');
            var imagecontext = imagecanvas.getContext('2d');

            var ratio = getPixelRatio(imagecontext);
            imagecanvas.style.width = width + "px";
            imagecanvas.style.height = height + "px";
            imagecanvas.width = width * ratio;
            imagecanvas.height = height * ratio;
            imagecontext.scale(ratio, ratio);

            var newImg = new Image();
            newImg.crossOrigin = "Anonymous";
            newImg.width = width;
            newImg.height = height;
            newImg.src = src;
            newImg.onload = function () {
                newImg.onload = null;
                var masks = new Image();
                masks.crossOrigin = "Anonymous";
                masks.onload = function () {
                    masks.onload = null;
                    masks.width = width;
                    masks.height = height;
                    imagecanvas.width = width;
                    imagecanvas.height = height;

                    imagecontext.drawImage(masks, 0, 0, width, height);
                    imagecontext.globalCompositeOperation = attr;

                    imagecontext.scale(scaleW, scaleH);
                    imagecontext.scale(scale, scale);

                    imagecontext.drawImage(newImg, x0, y0);


                    if (!callback) {
                        return;
                    }
                    callback.call(this, ImageService.dataURLtoBlob(imagecanvas.toDataURL()));

                    imagecanvas = null;
                };
                masks.src = maskUrl;
            };
        }

        function toImg(text, scale) {
            text.geometry.width /= scale;
            text.geometry.height /= scale;

            $http({
                url: '/editor/fileserves/api/convert/textToImg',
                method: 'POST',
                data: {
                    identifier: text.identifier,
                    text: text.text,
                    fontSize: text.style.size,
                    style: text.styles,
                    height: text.geometry.height,
                    width: text.geometry.width,
                    color: text.style.color,
                    family: text.style.font,
                    storeId: vm.storeId
                },
                responseType: 'blob'
            }).success(function (res, status, headers, config) {
                if(res.status == 200){
                    text.geometry.width = text.geometry.width * scale;
                    text.geometry.height = text.geometry.height * scale;

                    var createObjectURL = function (blob) {
                        return window[window.webkitURL ? 'webkitURL' : 'URL']['createObjectURL'](blob);
                    };
                    var fileURL = URL.createObjectURL(res.data);

                    text.picCode = text.pic = fileURL;
                    text.identifier = text.identifier || $scope.defaultText.path;
                }else {
                    MessageService.error(res.message);
                }

            }).error(function () {
                console.log("textToImg error");
            });
        }

        //旋转屏幕
        // window.addEventListener('orientationchange', function (event) {
        //     setReviewDoc();
        // });
        window.addEventListener('resize', function (event) {
            if (vm.reprint == 'OTHER' || $scope.template.pages.page.length < 2) {
                return
            }

            if (window.orientation == 0) {
                $rootScope.orientations = false;
            }
            setReviewDoc();
        });

        if (window.orientation == 90 || window.orientation == -90) {
            $li.width($scope.dWidth);
            $rootScope.orientation = false;
            console.log("always 横屏");
        } else {
            $rootScope.orientations = true;
        }

        function setReviewDoc() {
            $(".save-page").removeClass('hide1');
            $(".view2-article").addClass('hide1');
            $(".share-wrap").addClass('hide1');
            setTimeout(function () {
                if (window.orientation == 180 || window.orientation == 0) {
                    console.log("竖屏。。。。。");
                    $rootScope.orientations = true;
                    orientationChange();

                } else if (window.orientation == 90 || window.orientation == -90) {
                    console.log("横屏。。。。。");
                    $rootScope.orientations = false;
                    orientationChange();
                }
            }, 500);
        }

        function orientationChange() {
            $scope.dHeight = document.documentElement.clientHeight;
            $scope.dWidth = document.documentElement.clientWidth;
            $(".back-to-customer").width($scope.dWidth);
            $li.width($scope.dWidth);
            var newDoc = angular.copy(entity.data.document);
            getAll(newDoc);
            setTimeout(function () {
                $(".save-page").addClass('hide1');
                $(".view2-article").removeClass('hide1');
                $(".share-wrap").removeClass('hide1');
            }, 1500);
        }


        $scope.toggle = {
            now: false
        };
//边框
        $scope.imageboxW = function (imagebox) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.geometry.width) + Number(imagebox.border.lineWidth) * 2
                }
                if (imagebox.border.type == 'Pic') {
                    return imagebox.geometry.width
                    // return Number(imagebox.geometry.width) + (Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100) + (Number(imagebox.geometry.width) * Number(imagebox.border.edge.right) / 100)
                }
            } else {
                return imagebox.geometry.width
            }
        }
        $scope.imageboxH = function (imagebox) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.geometry.height) + Number(imagebox.border.lineWidth) * 2
                }
                if (imagebox.border.type == 'Pic') {
                    return imagebox.geometry.height
                    // return Number(imagebox.geometry.height) + (Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100) + (Number(imagebox.geometry.height) * Number(imagebox.border.edge.bottom) / 100)
                }
            } else {
                return imagebox.geometry.height
            }
        }
        $scope.imageboxL = function (imagebox) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.geometry.x) - Number(imagebox.border.lineWidth)
                }
                if (imagebox.border.type == 'Pic') {
                    return imagebox.geometry.x
                    // return Number(imagebox.geometry.x) - (Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100)
                }
            } else {
                return imagebox.geometry.x
            }
        }
        $scope.imageboxT = function (imagebox) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.geometry.y) - Number(imagebox.border.lineWidth)
                }
                if (imagebox.border.type == 'Pic') {
                    return imagebox.geometry.y
                    // return Number(imagebox.geometry.y) - (Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100)
                }
            } else {
                return imagebox.geometry.y
            }
        }
        $scope.imageboxWEdge = function (imagebox, edge) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.border.lineWidth)
                }
                if (imagebox.border.type == 'Pic') {
                    if (edge == 'left') {
                        return Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100
                    }
                    if (edge == 'top') {
                        return Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100
                    }
                    if (edge == 'right') {
                        return Number(imagebox.geometry.width) * Number(imagebox.border.edge.right) / 100
                    }
                    if (edge == 'bottom') {
                        return Number(imagebox.geometry.height) * Number(imagebox.border.edge.bottom) / 100
                    }
                }
            } else {
                return 0
            }
        }
        $scope.imageboxWRadius = function (imagebox, radius, ratio, ratio1) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                var _ratio = 1;
                if(ratio && ratio1){
                    if(imagebox.geometry.width > imagebox.geometry.height){
                        _ratio = ratio1
                    }else{
                        _ratio = ratio
                    }
                }
                if(ratio && !ratio1){
                    _ratio = ratio
                }
                if (imagebox.border.shape == 'Ellipse') {
                    return '50%'
                }
                if (imagebox.border.radius.filletType == 'Fixed') {//圆角固定值
                    var _radius = imagebox.border.radius[radius];
                    return _radius > 0 ?  (_radius + Number(imagebox.border.lineWidth)/2) * _ratio : 0;
                }else{
                    var radiusW = imagebox.geometry.width > imagebox.geometry.height ? imagebox.geometry.height : imagebox.geometry.width;
                    radiusW = radiusW + imagebox.border.lineWidth;
                    var _r = radiusW * imagebox.border.radius[radius] / 100;
                    return _r > 0 ? (_r + Number(imagebox.border.lineWidth)/2) * _ratio : 0
                }
            } else {
                return 0
            }
        }
        $scope.imageboxWRadius1 = function (imagebox, radius, ratio, ratio1) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                var _ratio = 1;
                if(ratio && ratio1){
                    if(imagebox.geometry.width > imagebox.geometry.height){
                        _ratio = ratio1
                    }else{
                        _ratio = ratio
                    }
                }
                if(ratio && !ratio1){
                    _ratio = ratio
                }
                if (imagebox.border.shape == 'Ellipse') {
                    return '50%'
                }
                if (imagebox.border.radius.filletType == 'Fixed') {//圆角固定值
                    var _radius = imagebox.border.radius[radius];
                    return  (_radius - Number(imagebox.border.lineWidth)/2) > 0 ? (_radius - Number(imagebox.border.lineWidth)/2) * _ratio : 0;
                }else{
                    var radiusW = imagebox.geometry.width > imagebox.geometry.height ? imagebox.geometry.height : imagebox.geometry.width;
                    radiusW = radiusW + imagebox.border.lineWidth;
                    var _r = radiusW * imagebox.border.radius[radius] / 100;
                    return (_r - Number(imagebox.border.lineWidth)/2) > 0 ? (_r - Number(imagebox.border.lineWidth)/2) * _ratio : 0
                }
            } else {
                return 0
            }
        }
        $scope.dropShadow = function(imagebox,ratio,ratio1){
            if (imagebox.shadow == null) {
                return
            }
            var width = $scope.imageboxW(imagebox) * ratio;
            var height =$scope.imageboxH(imagebox) * ratio1;
            return dropShadow(imagebox,width,height)
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('editorApp')
        .controller('ProductViewEcThreeController', ProductViewEcThreeController);

    ProductViewEcThreeController.$inject = ['$scope', '$stateParams', 'entity', '$q', '$localStorage', 'Qinius', '$state', 'Cart', 'CommonService', 'Store',
        'ImageService', '$http', '$rootScope', 'Theme', 'ItemValue', 'PlatformWechatSetting', 'Article','Music','MessageNotification', 'FontManagement','ProductXml',
        'Convert', 'StoreWorkEditConfig','ModulesService', '$timeout', '$translate','Product'];
    function ProductViewEcThreeController($scope, $stateParams, entity, $q, $localStorage, Qinius, $state, Cart, CommonService, Store,
                                   ImageService, $http, $rootScope, Theme, ItemValue, PlatformWechatSetting, Article, Music,MessageNotification, FontManagement,ProductXml,
                                          Convert, StoreWorkEditConfig, ModulesService, $timeout, $translate,Product) {
        var vm = this;

        CommonService.setDocumentTitle('预览');
        $scope.orderFlag = localStorage.getItem('returnurl2Text') || $translate.instant("button.buttonText");

        //风格切换  引入不同的css文件
        Theme.judge();
        vm.platformSetting = PlatformWechatSetting.get();
        var audio = document.getElementById("audio");
        // audio.src = "content/ihope.mp3";
        audio.crossOrigin = 'anonymous';

        vm.orderOrigin =  localStorage.getItem('orderOrigin');


        var timer = null;
        $(".navbar-gallery").hide();
        $(".wrap").show().addClass('no-margins');
        vm.storeId = $stateParams.storeId || $localStorage.storeId;
        vm.aid = $stateParams.aid;
        vm.orderArticleId = $stateParams.orderArticleId;
        vm.store = Store.get({id: vm.storeId});
        vm.article = entity.data;
        vm.bindingtype = 'LAR';

        StoreWorkEditConfig.storeId({storeId: vm.storeId}, function (res) {
            if(res.status == 200){
                $scope.orderFlag = localStorage.getItem('returnurl2Text') || res.data.buttonText;
            }else{
                swal.showInputError(res.message);
            }
        });
        //预览引导页
        var tt = localStorage.getItem('guide-share');
        if (tt == 'true') {
            vm.share = true;
        } else if (tt == 'false' || tt == '' || tt == null) {
            vm.share = false;
        }
        $scope.nextStep = function () {
            vm.share = true;
            localStorage.setItem('guide-share', vm.share);
        };

        var monthStr = new Date().getMonth() + 1;
        var dayStr = new Date().getDate();
        var timestr = new Date().getFullYear() + "-" + (monthStr > 9 ? monthStr : "0" + monthStr) + "-" + (dayStr > 9 ? dayStr : "0" + dayStr);
        // MessageNotification.getAllByCondition2({
        //     items: [{key: "available", op: "=", value: "true"}, {
        //         key: "validate",
        //         op: ">=",
        //         value: timestr
        //     }, {key: "pageType", op: "=", value: "View"}]
        // },function (res) {
        //     if(res.status == 200){
        //         res.data.sort(compare('seq'))
        //         vm.message = angular.copy(res.data);
        //         vm.messageText = "\xa0\xa0\xa0\xa0\xa0\xa0";
        //         angular.forEach(res.data,function (resp) {
        //             console.log(resp);
        //             vm.messageText += resp.content+"\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0"
        //         })
        //     }else {
        //         MessageService.error(res.message);
        //     }
        // });

        function compare(property) {
            return function (a, b) {
                var value1 = a[property];
                var value2 = b[property];
                return value1-value2;
            }
        }

        //dpi
        js_getDPI()
        function js_getDPI() {
            var arrDPI = new Array();
            if (window.screen.deviceXDPI != undefined) {
                arrDPI[0] = window.screen.deviceXDPI;
                arrDPI[1] = window.screen.deviceYDPI;
            }
            else {
                var tmpNode = document.createElement("DIV");
                tmpNode.style.cssText = "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
                document.body.appendChild(tmpNode);
                arrDPI[0] = parseInt(tmpNode.offsetWidth);
                arrDPI[1] = parseInt(tmpNode.offsetHeight);
                tmpNode.parentNode.removeChild(tmpNode);
            }
            vm.windowDpi = arrDPI[0];
            // vm.windowDpi = 300;
        }
        $scope.action_addCart = 'addCart';
        $scope.action_orderNow = 'orderNow';
        $scope.quantity = 1;
        $scope.copy = 1;
        $scope.hideEdit = vm.article.id;
        $scope.price = 0;
        $scope.musicPage = false;
        $scope.dHeight = vm.dHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        $scope.dWidth = vm.dWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        $("body").css({width: $scope.dWidth, 'min-width': $scope.dWidth});
        $scope.document = {
            pages: [{}]
        };

        var artDoc = angular.copy(vm.article.document);

        $('.view2-article').on('click', 'touchstart', 'touchmove', function (event) {
            event.preventDefault();
        });
        /**
         * mm换算成px
         * @param mm
         * @returns {number}
         */
        var unitTransform = function (mm) {
            // return mm * 3;
            return mm / 25.4 * vm.windowDpi;
        };
        var $li = $(".templateView2-carousel");
        $li.hide();
        $scope.domains = Qinius.getDomain({storeId: vm.storeId});
        var $load = $(".loading-page");
        var $flagBox = $(".flag-box");
        $flagBox.hide();

        function Play() {
            audio.play().then(function () {
                $(".PanelRight").removeClass('hide1');
                timer = window.setInterval(begin, 10);
            }).catch(function (error) {
                console.log(error);
            });
        }

        var rot = 10 - 0;
        function begin() {
            var micon = document.getElementById("music-icon");
            if (micon == null) {
                window.clearInterval(timer);
                return;
            }
            micon.style.transform = "rotate(" + rot + "deg)";
            rot += 1;
        }

        $("#Play").on('click', function () {
            window.clearInterval(timer);
            if (audio.paused) {
                audio.play();
                Play();
                $("#Play").children("img").removeClass("play").addClass("pause");
            }
            else {
                $("#Play").children("img").removeClass("pause").addClass("play");
                audio.pause();
            }
        });

        vm.isHideMusicBtn = false;
        getAll(artDoc);
        function getAll(doc) {
            $q.all([$scope.domains.$promise, vm.article.$promise, vm.platformSetting.$promise]).then(function () {
                if(vm.article.invalid){//作品失效
                    $state.go('articlesFailure',{storeId:vm.storeId},{location: 'replace'});
                    return
                }
                vm.platformSetting = vm.platformSetting.data;
                $scope.domain = 'https://' + $scope.domains.domains[0] + '/';
                ItemValue.get({id: vm.article.itemValueId}, function (res) {
                    if(res.status == 200){
                        vm.itemValue = res.data;

                        //取得xml文档内容
                        vm.bindingtype = vm.itemValue.bindingType;
                        localStorage.setItem('bindingtype', vm.bindingtype);

                        $scope.price = res.data.price;
                        if (vm.article.musicIdentify) {
                            audio.src = $scope.domain + vm.article.musicIdentify;
                            vm.musicIdentify = vm.article.musicIdentify;
                        }else{
                            if ( res.data.productXmlLines) {
                                for (var i = res.data.productXmlLines.length - 1; i >= 0; i--) {
                                    var xml = res.data.productXmlLines[i];
                                    if (xml.productXmlId == vm.article.productXmlId && xml.musicIdentify) {
                                        audio.src = $scope.domain + xml.musicIdentify;
                                    }
                                }
                            } else {
                                audio.src = '';
                                vm.isHideMusicBtn = true;
                            }
                        }

                    }else {
                        MessageService.error(res.message);
                    }
                });
                Play();
                Product.get({id: vm.article.productId}, function (resP) {
                    vm.product = resP.data;
                    Convert.xmlToDocument2({
                        identifier: vm.article.fileName,
                        provider: 'qiniu',
                        editorType:vm.article.editorType,
                        patternType:resP.data.patternType,
                    }, function (res) {
                        vm.article.document = res;
                        // $scope.getDetail(arrUse, 0);
                        $scope.getDetail1(res);
                        Music.allByCondition({
                            items:[{key: "storeId", op: "=", value: vm.storeId}],
                            sort: ["id,asc"]
                        }, function (resp) {
                            if(resp.status == 200){
                                $scope.Musics = resp.data;
                            }else {
                                MessageService.error(resp.message);
                            }
                        });

                        ProductXml.get({id:vm.article.productXmlId}, function (productXml) {
                            if(productXml.data.modelType && productXml.data.modelType === 'THREE'){
                                vm.modelType = 'THREE';
                                if(!productXml.data.modelPath){
                                    MessageService.error($translate.instant("editorCommon.not3D"));
                                    vm.threeView = false;
                                    return
                                }
                                vm.threeView = true;
                                vm.threeTemplate = vm.article.document;
                                vm.threeProductXmlData = productXml.data;
                            }else {
                                vm.modelType = 'TWO';
                            }
                        })
                    });
                })
                //获取自定义颜色
                ModulesService.getToneSettings(vm.storeId,function (res) {
                    vm.toneSettings = res;
                });
            });
        }

        /**
         * 赋值 --> 先制作文字 --> 文字 --> [有占位框(生成新数组-->占位框图片转canvas) || 无占位框(占位框图片转canvas)]
         * @param document
         * @param index
         */
        $scope.getDetail1 = function(document){
            $scope.template = angular.copy(document);
            vm.isEdit = true;
            documentAnalysis($scope, $http, vm, $scope.template,FontManagement,'other', function(page){
                ratioInfo(page)
            }, function () {
                $scope.template.pages.page.forEach(function (page) {
                    if (!page.scene) {
                        pageTrimbox(page)
                    }
                })
            })
            showPage()
        }
        function ratioInfo(item) {
            var windowRatio = 0.85;
            item.custom.ratio = $scope.dWidth * windowRatio / item.custom.width;
        }
        $scope.getDetail = function (document, index) {
            var obj = document.pages.page[index];
            $scope.scene = angular.copy(document.scene);

            $scope.template = document;
            var bgIdentifier = 'content/images/white.png';
            if (obj.background && obj.background.resource && obj.background.resource.identifier) {
                bgIdentifier = (obj.background.resource.identifier.indexOf('http') == -1 ? $scope.domain : '') + obj.background.resource.identifier + '?imageMogr2/thumbnail/!40p';
            }

            $scope.template.pages.page[index] = {
                bgImg:bgIdentifier,
                background: angular.copy(obj.background),
                barcode: angular.copy(obj.barcode),
                barcodeM: angular.copy(obj.barcode),
                qrcode: angular.copy(obj.qrcode),
                qrcodeM: angular.copy(obj.qrcode),
                barcodeRotation : {
                    angle: obj.barcodeRotation?obj.barcodeRotation.angle:0
                },
                mediabox: angular.copy(obj.mediabox),
                trimbox: angular.copy(obj.trimbox),
                textboxes: angular.copy(obj.textboxes),
                imageboxes: angular.copy(obj.imageboxes),
                levels: angular.copy(obj.levels),
                spread: obj.spread,
                centerrotation: obj.centerrotation ? true : false
            };

            $scope.scene = $scope.template.scene;
            $scope.scene.geometry = setGeometry($scope.scene.geometry);
            $scope.scene.imagebox.geometry = setGeometry1($scope.scene.imagebox.geometry);

            unitTransform($scope.template.pages.page[0].mediabox.width) * ($scope.dWidth - 45) /unitTransform($scope.template.pages.page[0].mediabox.width)
            //摆台
            var w0 = $scope.dWidth - 45,
                h0 = ($scope.dWidth - 45)*unitTransform($scope.template.pages.page[0].mediabox.height)/unitTransform($scope.template.pages.page[0].mediabox.width),
                w1 = $scope.scene.imagebox.geometry.width,
                h1 = $scope.scene.imagebox.geometry.height;
            if ((w0 <= h0 || w1 <= h1) && (w0 / h0 < w1 / h1) || w0 >= h0 && w1 >= h1 && (w0 / h0 < w1 / h1)) {
                $scope.imageboxConH = h1;
                $scope.imageboxConW = h1* w0 / h0;
                $scope.proportion = h0 / h1;
            } else {
                $scope.imageboxConW = w1;
                $scope.imageboxConH = w1 * h0 / w0;
                $scope.proportion = w0 / w1;
            }
            $scope.marginLeft = (w1 - $scope.imageboxConW) / 2;
            $scope.marginTop = (h1 - $scope.imageboxConH) / 2;


            var temp = $scope.template.pages.page[index];
            temp.styleScale = ((vm.dWidth - 45) / (unitTransform(obj.mediabox.width))) / $scope.proportion;
            //背景图片
            var w = $scope.imageboxConW* temp.styleScale,
                h = $scope.imageboxConH* temp.styleScale;
            if (temp.background.resource) {
                getBackgroundSource($http, temp.background.resource,w,h,temp.background);
                temp.background.offsetXM = angular.copy(temp.background.offsetx);
                temp.background.offsetYM = angular.copy(temp.background.offsety);
                temp.background.offsetx = unitTransform(temp.background.offsetx)* temp.styleScale;
                temp.background.offsety = unitTransform(temp.background.offsety)* temp.styleScale;
            }
            if (obj.barcode) {
                var barcode = obj.barcode.geometry;
                var angle = 0;
                if (obj.barcode.rotation && obj.barcode.rotation.angle) {
                    angle = obj.barcode.rotation.angle
                }
                temp.barcode = {
                    geometry: {
                        width: unitTransform(barcode.width) * temp.styleScale,
                        height: unitTransform(barcode.height) * temp.styleScale,
                        x: unitTransform(barcode.x) * temp.styleScale,
                        y: unitTransform(barcode.y) * temp.styleScale,
                        widthM: barcode.width,
                        heightM: barcode.height,
                        offsetXM: barcode.x,
                        offsetYM: barcode.y
                    },
                    rotation: {
                        angle: angle
                    }
                }
            }
            if (obj.qrcode) {
                var qrcode = obj.qrcode.geometry;
                var angle = 0;
                if (obj.qrcode.rotation && obj.qrcode.rotation.angle) {
                    angle = obj.qrcode.rotation.angle
                }
                temp.qrcode = {
                    geometry: {
                        width: unitTransform(qrcode.width) * temp.styleScale,
                        height: unitTransform(qrcode.height) * temp.styleScale,
                        x: unitTransform(qrcode.x) * temp.styleScale,
                        y: unitTransform(qrcode.y) * temp.styleScale,
                        widthM: qrcode.width,
                        heightM: qrcode.height,
                        offsetXM: qrcode.x,
                        offsetYM: qrcode.y
                    },
                    rotation: {
                        angle: angle
                    }
                }
            }

            angular.forEach(obj.levels.level, function (level, n) {

                if (level.imageart && level.imageart.geometry) {
                    var art = level.imageart;
                    $http({url: art.resource.identifier + '?imageInfo'}).success(function (data) {
                        temp.levels.level[n].imageart = {
                            geometry: getGeometry(art.geometry, temp),
                            // rotation: angular.copy(art.rotation),
                            rotation: {
                                angle: -art.rotation.angle
                            },
                            type: art.type,
                            resource: {
                                identifier:art.resource.identifier,
                                provider:art.resource.provider,
                                width:data.width,
                                height:data.height
                            },
                            scale:art.scale,
                            widthM: art.geometry.width,
                            heightM: art.geometry.height,
                            XM: art.geometry.x,
                            YM:art.geometry.y,
                            offsetXM: angular.copy(art.offsetx),
                            offsetYM: angular.copy(art.offsety),
                            offsetx: unitTransform(art.offsetx)* temp.styleScale,
                            offsety: unitTransform(art.offsety)* temp.styleScale,
                            current: 'imageart',
                            levelI: n,
                            pageI: index,
                            lock: false,
                            transparency: art.transparency,
                            onlyshow: art.onlyshow,
                            movable: art.movable,
                            editable: art.editable,
                        }
                    }).error(function (error) {});
                }
                if(level.textbox){
                    $scope.template.pages.page[index].levels.level[n].textbox = {
                        geometry: getGeometry(level.textbox.geometry, temp),
                        style: angular.copy(level.textbox.style),
                        identifier: level.textbox.identifier,
                        rotation: {
                            angle: -level.textbox.rotation.angle
                        },
                        text: level.textbox.text,
                        styles: 'NORMAL',
                        status: level.textbox.status,
                        type: level.textbox.type,
                        transparency: level.textbox.transparency,
                        movable: level.textbox.movable,
                        editable: level.textbox.editable,
                        fontuuid: level.textbox.fontuuid
                    };
                    var tempText = level.textbox;
                    if (tempText.style.bold && tempText.style.italic) {
                        tempText.styles = 'BOLD_ITALIC';
                    } else if (tempText.style.bold) {
                        tempText.styles = 'BOLD';
                    } else if (tempText.style.italic) {
                        tempText.styles = 'ITALIC';
                    } else {
                        tempText.styles = 'NORMAL';
                    }
                    if (level.textbox.text && level.textbox.identifier) {
                        toImg(tempText, $scope.template.pages.page[index].styleScale);
                    }
                    getFontCSS(FontManagement,level.textbox.fontuuid, $scope);
                }
                if(level.imagebox){
                    var art = level.imagebox;
                    $scope.template.pages.page[index].levels.level[n].imagebox = {
                        geometry: getGeometry(level.imagebox.geometry, temp),
                        blurredrectangle: level.imagebox.blurredrectangle ? getGeometry(level.imagebox.blurredrectangle, temp) : null,

                        mask: angular.copy(level.imagebox.mask),
                        image: {
                            resource: {
                                identifier: level.imagebox.image ? level.imagebox.image.resource.identifier : '',
                                provider: level.imagebox.image ? level.imagebox.image.resource.provider : 'qiniu'
                            },
                            filterResource: {
                                identifier: level.imagebox.image && level.imagebox.image.filterResource ? level.imagebox.image.filterResource.identifier : '',
                                provider: level.imagebox.image && level.imagebox.image.filterResource ? level.imagebox.image.filterResource.provider : 'qiniu'
                            },
                            rotation: angular.copy(level.imagebox.rotation),
                            parameter: (!level.imagebox.image) || level.imagebox.image.parameter == null ? [] : angular.fromJson(level.imagebox.image.parameter),
                            filter: (!level.imagebox.image) || level.imagebox.image.filter == null ? '' : level.imagebox.image.filter,
                            offsetx: level.imagebox.image.offsetx == 0 ? 0 : (unitTransform(level.imagebox.image.offsetx) * $scope.template.pages.page[index].styleScale),
                            offsety: level.imagebox.image.offsety == 0 ? 0 : (unitTransform(level.imagebox.image.offsety) * $scope.template.pages.page[index].styleScale),
                            angle: level.imagebox.image && level.imagebox.image.angle ? level.imagebox.image.angle : 0,
                            scale: (!level.imagebox.image) || level.imagebox.image.scale == 1 ? 1 : level.imagebox.image.scale,
                            index: (!level.imagebox.image) ? '' : level.imagebox.image.index
                        },
                        imgUrl: 'content/images/timg.jpg',
                        maskUrl: 'content/images/timg.jpg',
                        rotation: angular.copy(level.imagebox.rotation),
                        scaleW: 1,
                        scaleH: 1,
                        flip: level.imagebox.flip,
                        bokehtype: level.imagebox.bokehtype
                    };

                    if (level.imagebox.bokehtype!='None') {
                        level.imagebox.blurredrectangle = getGeometry(level.imagebox.blurredrectangle, temp)
                    }

                    var imageboxes = $scope.template.pages.page[index].levels.level[n].imagebox;
                    if (level.imagebox.mask.resource.identifier) {
                        imageboxes.maskUrl = (level.imagebox.mask.resource.identifier.indexOf('http') == -1 ? $scope.domain : '') + level.imagebox.mask.resource.identifier + '?imageMogr2';
                    }

                    if (level.imagebox.image && level.imagebox.image.resource.identifier) {       //qiniu
                        imageboxes.imgUrl = (level.imagebox.image.resource.identifier.indexOf('http') == -1 ? $scope.domain : '') + level.imagebox.image.resource.identifier + '?imageMogr2/exifModify/eyJPcmllbnRhdGlvbiI6IjEifQ==/thumbnail/!40p';
                        if (imageboxes.image.angle != 0) {
                            imageboxes.imgUrl += '/rotate/' + imageboxes.image.angle
                        }
                    }
                }

                if (level.textdocument && level.textdocument.geometry) {
                    var textdocument = level.textdocument;
                    $scope.template.pages.page[index].levels.level[n].textdocument = {
                        background: textdocument.background,
                        geometry: getGeometry(textdocument.geometry,temp),
                        widthM: textdocument.geometry.width,
                        heightM: textdocument.geometry.height,
                        offsetXM: textdocument.geometry.x,
                        offsetYM: textdocument.geometry.y,
                        rotation: {
                            angle:textdocument.rotation.angle||0
                        },
                        current: 'textdocument',
                        levels: angular.copy(textdocument.levels),
                        levelI: n,
                        pageI: index,
                        lock: true,
                        transparency: textdocument.transparency,
                        movable: textdocument.movable,
                        editable: textdocument.editable,
                        scale:textdocument.geometry.width/obj.mediabox.width
                    }

                    var backg = temp.levels.level[n].textdocument.background;
                    var pageW = temp.levels.level[n].textdocument.geometry.width,
                        pageH = temp.levels.level[n].textdocument.geometry.height;
                    if(backg.resource.identifier){
                        getBackgroundSource($http, backg.resource,pageW,pageH,backg)
                        backg.offsetx = unitTransform(backg.offsetx)* temp.styleScale
                        backg.offsety = unitTransform(backg.offsety)* temp.styleScale
                        backg.offsetXM = angular.copy(backg.offsetx);
                        backg.offsetYM = angular.copy(backg.offsety);
                    }

                    angular.forEach(textdocument.levels.level, function (lev, l) {
                        if (lev.imageart && lev.imageart.geometry) {
                            var art = lev.imageart;
                            $http({url: art.resource.identifier + '?imageInfo'}).success(function (data) {
                                temp.levels.level[n].textdocument.levels.level[l].imageart = {
                                    geometry: getGeometry(art.geometry,temp),
                                    rotation: angular.copy(art.rotation),
                                    type: art.type,
                                    resource: {
                                        identifier:art.resource.identifier,
                                        provider:art.resource.provider,
                                        width:data.width,
                                        height:data.height
                                    },
                                    scale:art.scale,
                                    widthM: art.geometry.width,
                                    heightM: art.geometry.height,
                                    XM: art.geometry.x,
                                    YM:art.geometry.y,
                                    offsetXM: angular.copy(art.offsetx),
                                    offsetYM: angular.copy(art.offsety),
                                    offsetx: unitTransform(art.offsetx)* temp.styleScale,
                                    offsety: unitTransform(art.offsety)* temp.styleScale,
                                    current: 'imageart',
                                    levelI: n,
                                    pageI: index,
                                    lock: false,
                                    transparency: art.transparency,
                                    onlyshow: art.onlyshow,
                                    movable: art.movable,
                                    editable: art.editable,
                                }
                            }).error(function (error) {});
                        }
                        if (lev.textbox && lev.textbox.geometry) {
                            var text = lev.textbox;
                            temp.levels.level[n].textdocument.levels.level[l].textbox = {
                                geometry: getGeometry(text.geometry, temp),
                                identifier: text.identifier,
                                rotation: angular.copy(text.rotation),
                                angle: angular.copy(text.angle),
                                status: angular.copy(text.status),
                                style: angular.copy(text.style),
                                type: angular.copy(text.type),
                                text: angular.copy(text.text),
                                fontStyle: [{
                                    style: '',
                                    path: text.identifier
                                }],
                                widthM: text.geometry.width,
                                heightM: text.geometry.height,
                                offsetXM: text.geometry.x,
                                offsetYM: text.geometry.y,
                                current: 'textbox',
                                levelI: n,
                                pageI: index,
                                lock: true,
                                transparency: text.transparency,
                                lineheight: text.style.lineheight,
                                letterspacing: text.style.letterspacing,
                                fontuuid:text.fontuuid,
                                version:text.version
                            }
                            getFontCSS(FontManagement,text.fontuuid, $scope);
                            // toImg($scope.template.pages.page[i].levels.level[n].textbox)
                        }
                    })
                }
            });
            //背景图片
            if($scope.template.pages.page[index].background.resource.identifier){

                $http({url: $scope.template.pages.page[index].background.resource.identifier+'?imageInfo'}).success(function (data) {
                    var bgImgW = data.width;
                    var bgImgH = data.height;

                    var bgImgR = bgImgW/bgImgH;
                    var bgImgR1 = $scope.template.pages.page[index].width/$scope.template.pages.page[index].height;
                    if(bgImgR >= bgImgR1){
                        $scope.template.pages.page[index].background.adaptation = 'Height';
                    }else {
                        $scope.template.pages.page[index].background.adaptation = 'Width';
                    }
                }).error(function (error) {
                    MessageService.error("获取图片信息失败");
                });
            }
            var w =(unitTransform(document.scene.geometry.width) * $scope.template.pages.page[index].styleScale);
            $scope.template.pages.page[index].ratio = w  / (document.scene.geometry.width / 25.4 * vm.windowDpi)
            $scope.isLeftRotation = false;
            angular.forEach($scope.template.pages.page[0].levels.level, function (image) {
                if(image.imagebox){
                    imgScale(image.imagebox, 0, 0, image.imagebox.maskUrl, image.imagebox.image.offsetx, image.imagebox.image.offsety);
                }
            })
        };


        //mm转px
        function transitionPx(item) {
            return item * vm.windowDpi / 25.4;
        }
        //px转mm
        function transitionMm(item) {
            return item * 25.4 / vm.windowDpi;
        }
        /**
         * 摆台宽高坐标从 mm 换算成 px
         * @param obj
         * @param index
         * @returns {{height: number, width: number, x: number, y: number}}
         */
        function setGeometry(obj) {
            $scope.template.scene.styleScale = (unitTransform(obj.width) / ($scope.dWidth - 45));
            return {
                height: unitTransform(obj.height) / $scope.template.scene.styleScale,
                width: $scope.dWidth - 45,
                x: 0,
                y: 0
            };
        }
        function setGeometry1(obj) {
            return {
                height: unitTransform(obj.height) / $scope.template.scene.styleScale,
                width: unitTransform(obj.width) / $scope.template.scene.styleScale,
                x: unitTransform(obj.x) / $scope.template.scene.styleScale,
                y: unitTransform(obj.y) / $scope.template.scene.styleScale
            };
        }

        /**
         * 宽高坐标从 mm 换算成 px
         * @param obj
         * @param index
         * @returns {{height: number, width: number, x: number, y: number}}
         */
        function getGeometry(obj, temp) {
            return {
                height: unitTransform(obj.height) * temp.styleScale,
                width: unitTransform(obj.width) * temp.styleScale,
                x: unitTransform(obj.x) * temp.styleScale,
                y: unitTransform(obj.y) * temp.styleScale
            }
        }

        /**
         * 占位框宽高适配，进行canvas操作
         * @param images    占位框
         * @param index     第N页page
         * @param mask      蒙版图形
         * @param x         图片坐标x
         * @param y         图片坐标y
         */
        function imgScale(images, pageI, index, mask, x, y, flag) {
            var scaleW = 1, scaleH = 1;
            var newImg = new Image();
            newImg.crossOrigin = "Anonymous";
            newImg.src = images.imgUrl;

            newImg.onload = function () {
                newImg.onload = null;
                var w = newImg.width;
                var h = newImg.height;
                var maskWidth = images.geometry.width;
                var maskHight = images.geometry.height;
                if ((newImg.width <= newImg.height || maskWidth <= maskHight) && (newImg.width / newImg.height < maskWidth / maskHight) || newImg.width >= newImg.height && maskWidth >= maskHight && (newImg.width / newImg.height < maskWidth / maskHight)) {
                    newImg.width = maskWidth;
                    newImg.height = maskWidth * h / w;
                } else {
                    newImg.height = maskHight;
                    newImg.width = maskHight * w / h;
                }

                scaleW = newImg.width / w;
                scaleH = newImg.height / h;
                x = x / scaleW;
                y = y / scaleH;

                var img = images.imgUrl;
                if (images.bokehtype == 'Transparent') {
                    maskd3(img, images.imgUrl, images, function (src) {
                        images.blobSmall = src;
                        dropPicFinished(pageI,index);
                    });

                } else if (images.bokehtype == 'Blurred') {
                    maskd3(img, images.imgUrl, images, function (src) {
                        images.blobSmall = src;
                        $scope.$digest();
                    });

                    img = img + '/blur/40x1000';
                    maskd(img, images.maskUrl, 'source-in', x, y, maskWidth, maskHight, scaleW, scaleH, images.image.scale, function (src) {
                        images.blobUrl = src;
                        dropPicFinished(pageI,index);
                    });

                } else {
                    maskd(img, images.maskUrl, 'source-in', x, y, maskWidth, maskHight, scaleW, scaleH, images.image.scale, function (src) {
                        images.blobUrl = src;
                        dropPicFinished(pageI,index);
                    });
                }

            };
            newImg.onerror = function () {
                images.imgUrl = (images.image.resource.identifier.indexOf('http') == -1 ? $scope.domain : '') + images.image.resource.identifier + '?imageMogr2/exifModify/eyJPcmllbnRhdGlvbiI6IjEifQ==';
                if (images.image.angle != 0) {
                    images.imgUrl += '/rotate/' + images.image.angle
                }

                if (!flag) {
                    imgScale(images, pageI, index, mask, x, y, true);
                } else {
                    showPage();
                    $(".templateView-loading").addClass('hide1');
                    $(".background").show();
                }

            }
        }


        function dropPicFinished(pageI,index) {
            $scope.$apply(function () {
                if (index == pageI) {
                    showPage();
                }
                if (vm.bindingtype == 'OTHER' || $scope.template.pages.page.length < 2) {
                    showPage();
                }
                $(".templateView-loading").addClass('hide1');
                $(".background").show();
            });
        }

        function maskd3(img, src, imagebox, callback) {
            var imagecanvas = document.createElement('canvas');
            var imagecontext = imagecanvas.getContext('2d');
            var geo = imagebox.geometry;
            var blurredRec = imagebox.blurredrectangle;

            var newImg = new Image();
            newImg.crossOrigin = "Anonymous";
            newImg.src = src;
            newImg.onload = function () {
                newImg.onload = null;
                newImg.width = blurredRec.width;
                newImg.height = blurredRec.height;
                var masks = new Image();
                masks.crossOrigin = "Anonymous";
                masks.src = imagebox.maskUrl;

                masks.onload = function () {
                    masks.width = geo.width;
                    masks.height = geo.height;
                    imagecanvas.width = geo.width;
                    imagecanvas.height = geo.height;
                    imagecontext.mozImageSmoothingEnabled = true;
                    imagecontext.webkitImageSmoothingEnabled = true;
                    imagecontext.msImageSmoothingEnabled = true;
                    imagecontext.imageSmoothingEnabled = true;

                    imagecontext.drawImage(masks, 0, 0, geo.width, geo.height);
                    imagecontext.globalCompositeOperation = 'source-in';

                    imagecontext.drawImage(newImg, blurredRec.x, blurredRec.y, blurredRec.width, blurredRec.height);

                    if (!callback) {
                        return;
                    }
                    callback.call(this, ImageService.dataURLtoBlob(imagecanvas.toDataURL()));

                    imagecanvas = null;
                };
            };
        }

        function showPage() {
            $scope.loading = false;
            $(".page-loading").hide();
            $li.show();
            $load.hide();
            $flagBox.show();
        }

        var getPixelRatio = function (context) {
            var backingStoreRatio = context.webkitBackingStorePixelRatio ||
                context.mozBackingStorePixelRatio ||
                context.msBackingStorePixelRatio ||
                context.oBackingStorePixelRatio ||
                context.backingStorePixelRatio || 1;

            return (window.devicePixelRatio || 1) / backingStoreRatio;
        };

        function maskd(src, maskUrl, attr, x0, y0, width, height, scaleW, scaleH, scale, callback) {
            var imagecanvas = document.createElement('canvas');
            var imagecontext = imagecanvas.getContext('2d');

            var ratio = getPixelRatio(imagecontext);
            imagecanvas.style.width = width + "px";
            imagecanvas.style.height = height + "px";
            imagecanvas.width = width * ratio;
            imagecanvas.height = height * ratio;
            imagecontext.scale(ratio, ratio);

            var newImg = new Image();
            newImg.crossOrigin = "Anonymous";
            newImg.width = width;
            newImg.height = height;
            newImg.src = src;
            newImg.onload = function () {
                newImg.onload = null;
                var masks = new Image();
                masks.crossOrigin = "Anonymous";
                masks.onload = function () {
                    masks.onload = null;
                    masks.width = width;
                    masks.height = height;
                    imagecanvas.width = width;
                    imagecanvas.height = height;

                    imagecontext.drawImage(masks, 0, 0, width, height);
                    imagecontext.globalCompositeOperation = attr;

                    imagecontext.scale(scaleW, scaleH);
                    imagecontext.scale(scale, scale);

                    imagecontext.drawImage(newImg, x0, y0);


                    if (!callback) {
                        return;
                    }
                    callback.call(this, ImageService.dataURLtoBlob(imagecanvas.toDataURL()));

                    imagecanvas = null;
                };
                masks.src = maskUrl;
            };
        }

        function toImg(text, scale) {
            text.geometry.width /= scale;
            text.geometry.height /= scale;

            $http({
                url: '/editor/fileserves/api/convert/textToImg',
                method: 'POST',
                data: {
                    identifier: text.identifier,
                    text: text.text,
                    fontSize: text.style.size,
                    style: text.styles,
                    height: text.geometry.height,
                    width: text.geometry.width,
                    color: text.style.color,
                    family: text.style.font,
                    storeId: vm.storeId
                },
                responseType: 'blob'
            }).success(function (res, status, headers, config) {
                if(res.status == 200){
                    text.geometry.width = text.geometry.width * scale;
                    text.geometry.height = text.geometry.height * scale;

                    var createObjectURL = function (blob) {
                        return window[window.webkitURL ? 'webkitURL' : 'URL']['createObjectURL'](blob);
                    };
                    var fileURL = URL.createObjectURL(res.data);

                    text.picCode = text.pic = fileURL;
                    text.identifier = text.identifier || $scope.defaultText.path;
                }else {
                    MessageService.error(res.message);
                }
            }).error(function () {
                console.log("textToImg error");
            });
        }

        //旋转屏幕
        // window.addEventListener('orientationchange', function (event) {
        //     setReviewDoc();
        // });
        window.addEventListener('resize', function (event) {
            var status = localStorage.getItem('Production');
            if(status=='make'){
                return
            }
            if (vm.bindingtype == 'OTHER' || $scope.template.pages.page.length < 2) {
                return
            }
            // alert(window.location.href);
            if(window.location.href.indexOf('choose')!=-1){
                return
            }

            if (window.orientation == 0) {
                $rootScope.orientations = false;
            }
            setReviewDoc();
        });

        if (window.orientation == 90 || window.orientation == -90) {
            $li.width($scope.dWidth);
            $rootScope.orientation = false;
        } else {
            $rootScope.orientations = true;
        }

        function setReviewDoc() {
            $(".save-page").removeClass('hide1');
            $(".view2-article").addClass('hide1');
            $(".share-wrap").addClass('hide1');
            setTimeout(function () {
                if (window.orientation == 180 || window.orientation == 0) {
                    $rootScope.orientations = true;
                    orientationChange();

                } else if (window.orientation == 90 || window.orientation == -90) {
                    $rootScope.orientations = false;
                    orientationChange();
                }
            }, 500);
        }

        function orientationChange() {
            $scope.dHeight = document.documentElement.clientHeight;
            $scope.dWidth = document.documentElement.clientWidth;
            $(".back-to-customer").width($scope.dWidth);
            $li.width($scope.dWidth);
            var newDoc = angular.copy(entity.data.document);
            getAll(newDoc);
            setTimeout(function () {
                $(".save-page").addClass('hide1');
                $(".view2-article").removeClass('hide1');
                $(".share-wrap").removeClass('hide1');
            }, 1500);
        }

        $scope.toggle = {
            now: false
        };

        vm.returnurl = localStorage.getItem('returnurl');
        vm.returnurl1 = localStorage.getItem('returnurl1');
        vm.returnurl2 = localStorage.getItem('returnurl2');
        vm.source = localStorage.getItem('source');
        $scope.goToCustomer = function () {
            if(vm.source){
                uni.redirectTo({
                    url: vm.returnurl1
                })
                return
            }
            window.location.href = vm.returnurl1;
        };

        $scope.gotoOrder = function(){
            if(vm.source){
                uni.redirectTo({
                    url: vm.returnurl2
                })
                return
            }
            window.location.href = vm.returnurl2;
        }

        $scope.editWork = function () {
            window.removeEventListener("resize", setReviewDoc, false);
            if(vm.article.editorType == "PHOTO_EDITOR"){
                $state.go('idPhotoEdit', {storeId: vm.storeId, aid: vm.article.id}, {reload: true,location: 'replace'});
            }else{
                $state.go('product-choosesThree-ec', {storeId: vm.storeId, aid: vm.article.id}, {reload: true,location: 'replace'});
            }
            localStorage.setItem("Production", "view");
            //清除关于作品的localStorage
            localStorage.removeItem("choose");
            localStorage.removeItem("multipartUpload");
            localStorage.removeItem("index");
            localStorage.removeItem("i");
            localStorage.removeItem("marginLeft");
            localStorage.removeItem("single");
            localStorage.removeItem("pages");
            localStorage.removeItem("gallery");
            localStorage.removeItem("galleryCopy");
            localStorage.removeItem("reviewPages");
            localStorage.removeItem("saveOldPage");
            localStorage.removeItem("saveOldPageIndex");
            localStorage.removeItem("pageAllPx");
            localStorage.removeItem("pageAllMm");
            localStorage.removeItem("view-scrollTop");
            localStorage.removeItem("work-save");
            localStorage.removeItem("delPic");
            localStorage.removeItem("picArrChoose");
            localStorage.removeItem("picArrChoose2");
            localStorage.removeItem("gallery2");
            localStorage.removeItem("picArrCopy");
            localStorage.removeItem("picArr");
        };

        $scope.deleteWork = function () {
            swal({
                title: $translate.instant("editorCommon.describe11"),
                text: $translate.instant("editorCommon.describe12"),
                imageUrl: Theme.sweetHintImg(),
                showCancelButton: true,
                confirmButtonText: $translate.instant("button.confirm"),
                cancelButtonText: $translate.instant("button.cancel"),
                closeOnConfirm: false
            }, function () {
                Article.delete({
                    id: vm.article.id
                }, function (res) {
                    if(res.status == 200){
                        swal({
                            title: $translate.instant("editorCommon.deleteSuccess"),
                            text: "",
                            imageUrl: Theme.sweetSuccedImg(),
                            timer: 2000,
                            showConfirmButton: false
                        }, function () {
                            if (vm.platformSetting == null || vm.platformSetting.storeNotifyUrl == null) {
                                swal({
                                    title: $translate.instant("editorCommon.describe13"),
                                    text: $translate.instant("editorCommon.describe14"),
                                    imageUrl: Theme.sweetHintImg(),
                                    timer: 2000,
                                    showConfirmButton: false
                                });
                            }
                            window.location.href = vm.platformSetting.storeNotifyUrl + '/#/' + vm.storeId + '/article';
                        });
                    }else {
                        MessageService.error(res.message);
                    }
                }, function () {
                    console.log("error")
                });

            });
        };

        $scope.closeEditMenu = function () {
            if ($scope.showEditMenu) {
                // $scope.showEditMenu = false;
            }
        };

        $scope.toggleEditMenu = function (event) {
            $scope.selectMenuShow = false;
            event.stopPropagation();
            $('.edit-menu1').removeClass('hide1');
            $scope.showEditMenu = !$scope.showEditMenu;
        };

        $scope.addToCart = function () {
            $scope.selectMenuShow = true;
            $scope.showEditMenu = false;
            $scope.action = $scope.action_addCart;
        };

        $scope.addCart = function () {
            if (!vm.itemValue.productSaleable || vm.itemValue.cancelled || vm.itemValue.productCancelled) {
                swal({
                    title: $translate.instant("editorCommon.describe15"),
                    text: $translate.instant("editorCommon.describe16"),
                    imageUrl: Theme.sweetHintImg(),
                    timer: 2000,
                    showConfirmButton: false
                });
            } else if (vm.article.articleStatus == 'EDITING') {
                swal({
                    title: $translate.instant("editorCommon.describe15"),
                    text: $translate.instant("editorCommon.describe16"),
                    imageUrl: Theme.sweetHintImg(),
                    timer: 2000,
                    showConfirmButton: false
                });
            } else {
                Cart.addGoods({
                    articleId: vm.article.id,
                    price: $scope.price,
                    quantity: $scope.quantity,
                    copy: $scope.copy
                }, function (res) {
                    if(res.status == 200){
                        if (vm.platformSetting == null || vm.platformSetting.storeNotifyUrl == null) {
                            swal({
                                title: $translate.instant("editorCommon.describe13"),
                                text: $translate.instant("editorCommon.describe14"),
                                imageUrl: Theme.sweetHintImg(),
                                timer: 2000,
                                showConfirmButton: false
                            });
                        }
                        swal({
                            title: $translate.instant("editorCommon.shoppingSuccess"),
                            text: "",
                            imageUrl: Theme.sweetSuccedImg(),
                            timer: 1500,
                            showConfirmButton: false
                        }, function () {
                            window.location.href = vm.platformSetting.storeNotifyUrl + '/#/' + vm.storeId + '/cart';
                        });
                    }else {
                        MessageService.error(res.message);
                    }
                }, function () {
                })
            }

        };

         $scope.purchase = function () {
            if (vm.platformSetting == null || vm.platformSetting.storeNotifyUrl == null) {
                swal({
                    title: $translate.instant("editorCommon.describe13"),
                    text: $translate.instant("editorCommon.describe14"),
                    imageUrl: Theme.sweetHintImg(),
                    timer: 2000,
                    showConfirmButton: false
                });
            }
            window.location.href = vm.platformSetting.storeNotifyUrl + '/#/' + vm.storeId + '/sales-order/' + vm.article.id + '/' + $scope.copy + '/new2';
        };

        $scope.orderNow = function () {
            window.location.href = "https://avatar-demo.fotavatar.com";
            return
            $scope.selectMenuShow = false;
            $scope.showEditMenu = false;
            $scope.action = $scope.action_orderNow;

            if (!vm.itemValue.productSaleable || vm.itemValue.cancelled || vm.itemValue.productCancelled) {
                swal({
                    title: $translate.instant("editorCommon.describe15"),
                    text: $translate.instant("editorCommon.describe16"),
                    imageUrl: Theme.sweetHintImg(),
                    timer: 2000,
                    showConfirmButton: false
                });
                return;
            } else if (vm.article.articleStatus == 'EDITING') {
                swal({
                    title: $translate.instant("editorCommon.describe15"),
                    text: $translate.instant("editorCommon.describe16"),
                    imageUrl: Theme.sweetHintImg(),
                    timer: 2000,
                    showConfirmButton: false
                });
                return;
            }

            $scope.purchase();
        };

        $scope.closeModal = function () {
            $scope.selectMenuShow = false;
            $scope.showEditMenu = false;
        };


        var audioTest = null;
        $scope.openMusicList = function () {
            $scope.musicPage = true;
            audio.pause();
            vm.musicIdentify = vm.article.musicIdentify;
            if(vm.article.musicIdentify){
                angular.forEach($scope.Musics,function (music,i) {
                    if(music.identify== vm.article.musicIdentify){
                        $(".music-current").hide();
                        $(".music-current"+i).show();
                        setMusicStyle(i)
                    }
                })
            }

            audioTest = document.getElementById("audition");
            audioTest.crossOrigin = 'anonymous';
        };

        $scope.playList = function (identify,index) {
            // audioTest.pause();
            audioTest.src = $scope.domain + identify;
            vm.musicIdentify = identify;
            audioTest.play();
            setMusicStyle(index);
            Play()
        };

        function setMusicStyle(index) {
            $(".music-name").removeClass('music-active');
            $(".music-name"+index).addClass('music-active');
            $(".music-icon").hide();
            $(".music-icon"+index).show();

        }

        $scope.backTo = function () {
            $scope.musicPage = false;
            audioTest.pause();
            audio.play();
        };

        $scope.saveMusic = function () {
            if (vm.musicIdentify == null || vm.musicIdentify == "") {
                $scope.musicPage = false;
             }else{
                Article.updateMusic({id:vm.article.id, musicIdentify:vm.musicIdentify},function(res){
                    if(res.status == 200){
                        vm.article = res.data;
                        $scope.musicPage = false;
                        audio.src = $scope.domain + vm.article.musicIdentify;
                        audioTest.pause();
                        audio.play();
                    }else {
                        MessageService.error(res.message);
                    }
                },function(){

                })
             }

        }
    }
})();

(function () {
    'use strict';

    angular
        .module('editorApp')
        .controller('ProductViewEc3Controller', ProductViewEc3Controller);

    ProductViewEc3Controller.$inject = ['$scope', '$stateParams', 'entity', '$q', '$localStorage', 'Qinius',
        '$rootScope', 'Theme', 'ItemValue', 'PlatformWechatSetting', 'Store','MessageNotification'];
    function ProductViewEc3Controller($scope, $stateParams, entity, $q, $localStorage, Qinius,
                                    $rootScope, Theme, ItemValue, PlatformWechatSetting , Store, MessageNotification) {
        var vm = this;

        //风格切换  引入不同的css文件
        Theme.judge();
        vm.platformSetting = PlatformWechatSetting.get();
        var audio = document.getElementById("audio");
        // audio.src = "content/ihope.mp3";
        audio.crossOrigin = 'anonymous';

        var timer = null;
        $(".navbar-gallery").hide();
        $(".wrap").show().addClass('no-margins');
        vm.storeId = $stateParams.storeId || $localStorage.storeId;
        vm.aid = $stateParams.aid;
        vm.article = entity.data;
        vm.store = Store.get({id: vm.storeId});
        vm.bindingtype = 'Left';
        vm.counts = 0;
        $scope.k = 0;
        $scope.t = 0;
        $scope.dHeight = vm.dHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        $scope.dWidth = vm.dWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        $("body").css({width: $scope.dWidth, 'min-width': $scope.dWidth,'background':'#fff'});

        var $li = $(".templateView2-carousel");
        $li.hide();
        $scope.domains = Qinius.getDomain({storeId: vm.storeId});

        function Play() {
            audio.play().then(function () {
                $(".PanelRight").removeClass('hide1');
                timer = window.setInterval(begin, 10);
            }).catch(function (error) {
                console.log(error);
            });
        }

        var rot = 10 - 0;
        function begin() {
            var micon = document.getElementById("music-icon");
            if (micon == null) {
                window.clearInterval(timer);
                return;
            }
            micon.style.transform = "rotate(" + rot + "deg)";
            rot += 1;
        }

        $("#Play").on('click', function () {
            window.clearInterval(timer);
            if (audio.paused) {
                if ($(this).children().hasClass('play')) {
                    $("#Play").children("img").removeClass("play").addClass("pause");
                    Play();
                }
            }
            else {
                $("#Play").children("img").removeClass("pause").addClass("play");
                audio.pause();
            }
        });

        var monthStr = new Date().getMonth() + 1;
        var dayStr = new Date().getDate();
        var timestr = new Date().getFullYear() + "-" + (monthStr > 9 ? monthStr : "0" + monthStr) + "-" + (dayStr > 9 ? dayStr : "0" + dayStr);
        MessageNotification.getAllByCondition2({
            items: [{key: "available", op: "=", value: "true"}, {
                key: "validate",
                op: ">=",
                value: timestr
            }, {key: "pageType", op: "=", value: "View"}]
        },function (res) {
            if(res.status == 200){
                res.data.sort(compare('seq'))
                vm.message = angular.copy(res.data);
                vm.messageText = "\xa0\xa0\xa0\xa0\xa0\xa0";
                angular.forEach(res.data,function (resp) {
                    console.log(resp);
                    vm.messageText += resp.content+"\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0"
                })
            }else {
                MessageService.error(res.message);
            }
        });

        function compare(property) {
            return function (a, b) {
                var value1 = a[property];
                var value2 = b[property];
                return value1-value2;
            }
        }

        getAll();
        function getAll() {
            $q.all([$scope.domains.$promise, vm.article.$promise, vm.platformSetting.$promise, vm.store.$promise]).then(function () {
                vm.article = vm.article.data;
                if(vm.article.invalid){//作品失效
                    $state.go('articlesFailure',{storeId:vm.storeId},{location: 'replace'});
                    return
                }
                vm.platformSetting = vm.platformSetting.data;
                vm.store = vm.store.data;
                $scope.domain = 'https://' + $scope.domains.domains[0] + '/';
                ItemValue.get({id: vm.article.itemValueId}, function (res) {
                    if(res.status == 200){
                        vm.bindingtype = res.data.bindingType;
                        if (vm.article.musicIdentify) {
                            audio.src = $scope.domain + vm.article.musicIdentify;
                        }else{
                            if (res.data.musicIdentify) {
                                audio.src = $scope.domain + res.data.musicIdentify;
                            } else {
                                audio.src = '';
                            }
                        }
                    }else {
                        MessageService.error(res.message);
                    }
                });
                // 自动播放音乐
                Play();
            });
        }

        //旋转屏幕
        // window.addEventListener('orientationchange', function (event) {
        //     setReviewDoc();
        // });
        window.addEventListener('resize', function (event) {
            if (vm.bindingtype == 'None' || $scope.template.pages.page.length < 2) {
                return
            }

            if (window.orientation == 0) {
                $rootScope.orientations = false;
            }
            setReviewDoc();
        });

        if (window.orientation == 90 || window.orientation == -90) {
            $li.width($scope.dWidth);
            $rootScope.orientation = false;
            console.log("always 横屏");
        } else {
            $rootScope.orientations = true;
        }

        function setReviewDoc() {
            $(".save-page").removeClass('hide1');
            $(".view2-article").addClass('hide1');
            $(".share-wrap").addClass('hide1');
            setTimeout(function () {
                if (window.orientation == 180 || window.orientation == 0) {
                    console.log("竖屏。。。。。");
                    $rootScope.orientations = true;
                    orientationChange();

                } else if (window.orientation == 90 || window.orientation == -90) {
                    console.log("横屏。。。。。");
                    $rootScope.orientations = false;
                    orientationChange();
                }
            }, 500);
        }

        function orientationChange() {
            $scope.k = 0;
            $scope.dHeight = document.documentElement.clientHeight;
            $scope.dWidth = document.documentElement.clientWidth;
            $(".back-to-customer").width($scope.dWidth);
            $li.width($scope.dWidth);
            vm.article = angular.copy(entity.data);
            getAll();
            setTimeout(function () {
                $(".save-page").addClass('hide1');
                $(".view2-article").removeClass('hide1');
                $(".share-wrap").removeClass('hide1');
            }, 1500);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('editorApp')
        .controller('ProductViewEc2Controller', ProductViewEc2Controller);

    ProductViewEc2Controller.$inject = ['$scope', '$stateParams', 'entity', '$q', '$localStorage', 'Qinius', 'Store',
        '$http', '$rootScope', 'Theme', 'ItemValue', 'PlatformWechatSetting','Convert','Product','ModulesService'];
    function ProductViewEc2Controller($scope, $stateParams, entity, $q, $localStorage, Qinius, Store,
                                    $http, $rootScope, Theme, ItemValue, PlatformWechatSetting,Convert,Product,ModulesService) {
        var vm = this;

        //风格切换  引入不同的css文件
        Theme.judge();
        vm.platformSetting = PlatformWechatSetting.get();
        var audio = document.getElementById("audio");
        // audio.src = "content/ihope.mp3";
        audio.crossOrigin = 'anonymous';

        var timer = null;
        $(".navbar-gallery").hide();
        $(".wrap").show().addClass('no-margins');
        vm.storeId = $stateParams.storeId || $localStorage.storeId;
        vm.aid = $stateParams.aid;
        vm.article = angular.copy(entity.data);
        vm.bindingtype = 'Left';

        vm.store = Store.get({id: vm.storeId});
        $scope.dHeight = vm.dHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        $scope.dWidth = vm.dWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        $("body").css({width: $scope.dWidth, 'min-width': $scope.dWidth, 'background': '#fff'});
        var $li = $(".templateView2-carousel");
        $li.hide();
        $scope.domains = Qinius.getDomain({storeId: vm.storeId});

        function Play() {
            audio.play().then(function () {
                $(".PanelRight").removeClass('hide1');
                timer = window.setInterval(begin, 10);
            }).catch(function (error) {
                console.log(error);
            });
        }

        var rot = 10 - 0;

        function begin() {
            var micon = document.getElementById("music-icon");
            if (micon == null) {
                window.clearInterval(timer);
                return;
            }
            micon.style.transform = "rotate(" + rot + "deg)";
            rot += 1;
        }

        $("#Play").on('click', function () {
            window.clearInterval(timer);
            if (audio.paused) {
                audio.play();
                Play();
                $("#Play").children("img").removeClass("play").addClass("pause");
            }
            else {
                $("#Play").children("img").removeClass("pause").addClass("play");
                audio.pause();
            }
        });

        function makeCode() {
            var qrcode = new QRCode(document.getElementById("qrcode"), {
                width: 100,
                height: 100
            });
            qrcode.makeCode(vm.platformSetting.storeNotifyUrl + '/#/' + vm.storeId + '/index');
        }

        getAll();
        function getAll() {
            $q.all([$scope.domains.$promise, vm.article.$promise, vm.platformSetting.$promise, vm.store.$promise]).then(function () {
                if(vm.article.invalid){//作品失效
                    $state.go('articlesFailure',{storeId:vm.storeId},{location: 'replace'});
                    return
                }
                vm.platformSetting = vm.platformSetting.data;
                vm.store = vm.store.data;
                // if (vm.store.storeType2.indexOf("MINI") < 0) {
                if (1) {
                    $scope.miniType = false;
                    makeCode();
                } else {
                    $scope.miniType = true;
                    $http({
                        url: "/fileserves/api/download/getMiniQrCode?storeId=" + vm.storeId,
                        method: 'get',
                        responseType: 'blob'
                    }).success(function (res) {
                        if(res.status == 200){
                            var blob = new Blob([res.data], {
                                type: "image/jpeg"
                            });
                            $scope.image = URL.createObjectURL(blob);
                        }else {
                            MessageService.error(res.message);
                        }
                    })
                }
                Product.get({id: vm.article.productId}, function (resP) {
                    Convert.xmlToDocument2({
                        identifier: vm.article.fileName,
                        provider: 'qiniu',
                        editorType:vm.article.editorType,
                        patternType:resP.data.patternType,
                    }, function (resp) {
                        vm.documentPage = resp;
                    })
                })
                $scope.domain = 'https://' + $scope.domains.domains[0] + '/';
                ItemValue.get({id: vm.article.itemValueId}, function (res) {
                    if(res.status == 200){
                        vm.itemValue = res.data;
                        vm.bindingtype =  res.data.bindingType;
                        if (vm.article.musicIdentify) {
                            audio.src = $scope.domain + vm.article.musicIdentify;
                        } else {
                            if (res.data.musicIdentify) {
                                audio.src = $scope.domain + res.data.musicIdentify;
                            } else {
                                audio.src = '';
                            }
                        }
                    }else {
                        MessageService.error(res.message);
                    }
                });
                // 自动播放音乐
                // Play();

                //获取自定义颜色
                ModulesService.getToneSettings(vm.storeId,function (res) {
                    vm.toneSettings = res;
                });
            });
        }

        //旋转屏幕
        // window.addEventListener('orientationchange', function (event) {
        //     setReviewDoc();
        // });
        window.addEventListener('resize', function (event) {
            if (vm.bindingtype == 'None' || $scope.template.pages.page.length < 2) {
                return
            }

            if (window.orientation == 0) {
                $rootScope.orientations = false;
            }
            setReviewDoc();
        });

        if (window.orientation == 90 || window.orientation == -90) {
            $li.width($scope.dWidth);
            $rootScope.orientation = false;
        } else {
            $rootScope.orientations = true;
        }

        function setReviewDoc() {
            $(".save-page").removeClass('hide1');
            $(".view2-article").addClass('hide1');
            $(".share-wrap").addClass('hide1');
            setTimeout(function () {
                if (window.orientation == 180 || window.orientation == 0) {
                    $rootScope.orientations = true;
                    orientationChange();

                } else if (window.orientation == 90 || window.orientation == -90) {
                    $rootScope.orientations = false;
                    orientationChange();
                }
            }, 500);
        }

        function orientationChange() {
            $scope.k = 0;
            $scope.dHeight = document.documentElement.clientHeight;
            $scope.dWidth = document.documentElement.clientWidth;
            $(".back-to-customer").width($scope.dWidth);
            $li.width($scope.dWidth);
            vm.article = angular.copy(entity.data);
            getAll();
            setTimeout(function () {
                $(".save-page").addClass('hide1');
                $(".view2-article").removeClass('hide1');
                $(".share-wrap").removeClass('hide1');
            }, 1500);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('editorApp')
        .controller('ProductViewEcController', ProductViewEcController);

    ProductViewEcController.$inject = ['$scope', '$stateParams', 'entity', '$q', '$localStorage', 'Qinius', '$state', 'Cart', 'CommonService', 'Store',
        'MessageService', '$rootScope', 'Theme', 'ItemValue', 'PlatformWechatSetting', 'Article', 'Music', 'MessageNotification', 'StoreWorkEditConfig',
        'ModulesService', 'Convert', '$translate','Product'];
    function ProductViewEcController($scope, $stateParams, entity, $q, $localStorage, Qinius, $state, Cart, CommonService, Store,
                                   MessageService, $rootScope, Theme, ItemValue, PlatformWechatSetting, Article, Music, MessageNotification, StoreWorkEditConfig,
                                     ModulesService, Convert, $translate,Product) {
        var vm = this;

        CommonService.setDocumentTitle('预览');
        $scope.orderFlag = localStorage.getItem('returnurl2Text') || $translate.instant("button.buttonText");

        //风格切换  引入不同的css文件
        Theme.judge();
        vm.platformSetting = PlatformWechatSetting.get();
        var audio = document.getElementById("audio");
        audio.crossOrigin = 'anonymous';

        vm.orderOrigin = localStorage.getItem('orderOrigin');

        var returnurl = localStorage.getItem('returnurl');
        vm.returnurl = localStorage.getItem('returnurl');
        vm.returnurl1 = localStorage.getItem('returnurl1');
        vm.returnurl2 = localStorage.getItem('returnurl2');
        vm.source = localStorage.getItem('source');

        var timer = null;
        $(".navbar-gallery").hide();
        $(".wrap").show().addClass('no-margins');
        vm.storeId = $stateParams.storeId || $localStorage.storeId;
        vm.aid = $stateParams.aid;
        vm.orderArticleId = $stateParams.orderArticleId;
        Store.get({id: vm.storeId}, function (res) {
            if(res.status == 200){
                vm.store = res.data;
            }else {
                MessageService.error(res.message);
            }
        });
        vm.article = entity.data;
        vm.bindingtype = 'Left';
        vm.counts = 0;
        vm.isHideMusicBtn = false;

        StoreWorkEditConfig.storeId({storeId: vm.storeId}, function (res) {
            if(res.status == 200){
                $scope.orderFlag = localStorage.getItem('returnurl2Text') || res.data.buttonText;
            }else{
                swal.showInputError(res.message);
            }
        });
        //预览引导页
        var tt = localStorage.getItem('guide-share');
        if (tt == 'true') {
            vm.share = true;
        } else if (tt == 'false' || tt == '' || tt == null) {
            vm.share = false;
        }
        $scope.nextStep = function () {
            vm.share = true;
            localStorage.setItem('guide-share', vm.share);
        };
        js_getDPI()
        function js_getDPI() {
            var arrDPI = new Array();
            if (window.screen.deviceXDPI != undefined) {
                arrDPI[0] = window.screen.deviceXDPI;
                arrDPI[1] = window.screen.deviceYDPI;
            }
            else {
                var tmpNode = document.createElement("DIV");
                tmpNode.style.cssText = "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
                document.body.appendChild(tmpNode);
                arrDPI[0] = parseInt(tmpNode.offsetWidth);
                arrDPI[1] = parseInt(tmpNode.offsetHeight);
                tmpNode.parentNode.removeChild(tmpNode);
            }
            vm.windowDpiW = arrDPI[0];
            vm.windowDpiH = arrDPI[1];
            // vm.windowDpiW = 300;
            // vm.windowDpiH = 300;
            return arrDPI;
        }

        $scope.action_orderNow = 'orderNow';
        $scope.quantity = 1;
        $scope.copy = 1;
        $scope.hideEdit = vm.article.id;
        $scope.price = 0;
        $scope.k = 0;
        $scope.musicPage = false;
        $scope.viewPage = false;
        $scope.isRandomView = false;
        $scope.dHeight = vm.dHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        $scope.dWidth = vm.dWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        $("body").css({width: $scope.dWidth, 'min-width': $scope.dWidth});

        var $li = $(".templateView2-carousel");
        $scope.domains = Qinius.getDomain({storeId: vm.storeId});

        function Play() {
            audio.play().then(function () {
                $(".PanelRight").removeClass('hide1');
                timer = window.setInterval(begin, 10);
            }).catch(function (error) {
                console.log(error);
            });
        }

        var rot = 10 - 0;

        function begin(time) {
            var micon = document.getElementById("music-icon");
            if (micon == null) {
                window.clearInterval(timer);
                return;
            }
            micon.style.transform = "rotate(" + rot + "deg)";
            rot += 1;
        }

        $("#Play").on('click', function () {
            window.clearInterval(timer);
            if (audio.paused) {
                audio.play();
                Play();
                $("#Play").children("img").removeClass("play").addClass("pause");
            }
            else {
                $("#Play").children("img").removeClass("pause").addClass("play");
                audio.pause();
            }
        });

        var monthStr = new Date().getMonth() + 1;
        var dayStr = new Date().getDate();
        var timestr = new Date().getFullYear() + "-" + (monthStr > 9 ? monthStr : "0" + monthStr) + "-" + (dayStr > 9 ? dayStr : "0" + dayStr);
        MessageNotification.getAllByCondition2({
            items: [{key: "available", op: "=", value: "true"}, {
                key: "validate",
                op: ">=",
                value: timestr
            }, {key: "pageType", op: "=", value: "View"}]
        }, function (res) {
            if(res.status == 200){
                res.data.sort(compare('seq'))
                vm.message = angular.copy(res.data);
                vm.messageText = "\xa0\xa0\xa0\xa0\xa0\xa0";
                angular.forEach(res.data, function (resp) {
                    vm.messageText += resp.content + "\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0"
                })
            }else {
                MessageService.error(res.message);
            }
        });

        function compare(property) {
            return function (a, b) {
                var value1 = a[property];
                var value2 = b[property];
                return value1 - value2;
            }
        }

        getAll();
        function getAll() {
            $q.all([$scope.domains.$promise, vm.article.$promise, vm.platformSetting.$promise]).then(function () {
                if(vm.article.invalid){//作品失效
                    $state.go('articlesFailure',{storeId:vm.storeId},{location: 'replace'});
                    return
                }
                // 作品不存在
                if(!vm.article.productXmlId){
                    MessageService.error($translate.instant("editorCommon.describe32"));
                    return
                }
                vm.platformSetting = vm.platformSetting.data;
                $scope.domain = 'https://' + $scope.domains.domains[0] + '/';
                Product.get({id: vm.article.productId}, function (resP) {
                    Convert.xmlToDocument2({
                        identifier: vm.article.fileName,
                        provider: 'qiniu',
                        editorType:vm.article.editorType,
                        patternType:resP.data.patternType,
                    }, function (resp) {
                        vm.documentPage = resp;
                    })
                })
                ItemValue.get({id: vm.article.itemValueId}, function (res) {
                    if(res.status == 200){
                        vm.itemValue = res.data;
                        console.log(vm.itemValue)
                        $scope.price = res.data.price;
                        if (vm.article.musicIdentify) {
                            audio.src = $scope.domain + vm.article.musicIdentify;
                        } else {
                            if (res.data.musicIdentify) {
                                audio.src = $scope.domain + res.data.musicIdentify;
                            } else {
                                audio.src = '';
                                vm.isHideMusicBtn = true;
                            }
                        }

                        // autoPlayAudio2();
                    }else {
                        MessageService.error(res.message);
                    }
                });
                Play();
                Music.allByCondition({
                    items: [],
                    sort: ["id,asc"]
                }, function (resp) {
                    if(resp.status == 200){
                        $scope.Musics = resp.data;
                    }else {
                        MessageService.error(resp.message);
                    }
                });
                //获取自定义颜色
                ModulesService.getToneSettings(vm.storeId,function (res) {
                    vm.toneSettings = res;
                });
            });
        }

        //旋转屏幕
        window.addEventListener('resize', function (event) {
            var status = localStorage.getItem('Production');
            if (status == 'make') {
                return
            }
            // alert(window.location.href);
            if (window.location.href.indexOf('choose') != -1) {
                return
            }

            if (vm.bindingtype == 'None' || $scope.template.pages.page.length < 2) {
                return
            }

            if (window.orientation == 0) {
                $rootScope.orientations = false;
            }
            setReviewDoc();
        });

        if (window.orientation == 90 || window.orientation == -90) {
            $li.width($scope.dWidth);
            $rootScope.orientation = false;
        } else {
            $rootScope.orientations = true;
        }

        function setReviewDoc() {
            $(".save-page").removeClass('hide1');
            $(".view2-article").addClass('hide1');
            $(".share-wrap").addClass('hide1');
            setTimeout(function () {
                if (window.orientation == 180 || window.orientation == 0) {
                    $rootScope.orientations = true;
                    orientationChange();

                } else if (window.orientation == 90 || window.orientation == -90) {
                    $rootScope.orientations = false;
                    orientationChange();
                }
            }, 500);
        }

        function orientationChange() {
            $scope.k = 0;
            $scope.dHeight = document.documentElement.clientHeight;
            $scope.dWidth = document.documentElement.clientWidth;
            $(".back-to-customer").width($scope.dWidth);
            $li.width($scope.dWidth);
            // var newDoc = angular.copy(entity.document);
            getAll();
            setTimeout(function () {
                $(".save-page").addClass('hide1');
                $(".view2-article").removeClass('hide1');
                $(".share-wrap").removeClass('hide1');
            }, 1500);
        }

        $scope.toggle = {
            now: false
        };

        $scope.goToCustomer = function () {
            if(vm.source){
                uni.redirectTo({
                    url: vm.returnurl1
                })
                return
            }
            window.location.href = vm.returnurl1;
        };

        $scope.gotoOrder = function(){
            if(vm.source){
                uni.redirectTo({
                    url: vm.returnurl2
                })
                return
            }
            window.location.href = vm.returnurl2;
        }

        $scope.editWork = function () {
            window.removeEventListener("resize", setReviewDoc, false);
            $state.go('editorPhotoAlbumEditM', {storeId: vm.storeId, aid: vm.article.id}, {reload: true,location: 'replace'});

            localStorage.setItem("Production", "view");
            //清除关于作品的localStorage
            localStorage.removeItem("choose");
            localStorage.removeItem("multipartUpload");
            localStorage.removeItem("index");
            localStorage.removeItem("i");
            localStorage.removeItem("marginLeft");
            localStorage.removeItem("single");
            localStorage.removeItem("pages");
            localStorage.removeItem("gallery");
            localStorage.removeItem("galleryCopy");
            localStorage.removeItem("reviewPages");
            localStorage.removeItem("saveOldPage");
            localStorage.removeItem("saveOldPageIndex");
            localStorage.removeItem("pageAllPx");
            localStorage.removeItem("pageAllMm");
            localStorage.removeItem("view-scrollTop");
            localStorage.removeItem("work-save");
            localStorage.removeItem("delPic");
            localStorage.removeItem("picArrChoose");
            localStorage.removeItem("picArrChoose2");
            localStorage.removeItem("gallery2");
            localStorage.removeItem("picArrCopy");
            localStorage.removeItem("picArr");
        };

        $scope.deleteWork = function () {
            swal({
                title: $translate.instant("editorCommon.describe11"),
                text: $translate.instant("editorCommon.describe12"),
                imageUrl: Theme.sweetHintImg(),
                showCancelButton: true,
                confirmButtonText: $translate.instant("button.confirm"),
                cancelButtonText: $translate.instant("button.cancel"),
                closeOnConfirm: false
            }, function () {
                Article.delete({
                    id: vm.article.id
                }, function (res) {
                    if(res.status == 200){
                        swal({
                            title: $translate.instant("editorCommon.deleteSuccess"),
                            text: "",
                            imageUrl: Theme.sweetSuccedImg(),
                            timer: 2000,
                            showConfirmButton: false
                        }, function () {
                            if (vm.platformSetting == null || vm.platformSetting.storeNotifyUrl == null) {
                                swal({
                                    title: $translate.instant("editorCommon.describe13"),
                                    text: $translate.instant("editorCommon.describe14"),
                                    imageUrl: Theme.sweetHintImg(),
                                    timer: 2000,
                                    showConfirmButton: false
                                });
                            }
                            window.location.href = vm.platformSetting.storeNotifyUrl + '/#/' + vm.storeId + '/article';
                        });
                    }else {
                        MessageService.error(res.message);
                    }
                }, function () {
                    console.log("error")
                });

            });
        };

        $scope.toggleEditMenu = function (event) {
            $scope.selectMenuShow = false;
            event.stopPropagation();
            $('.edit-menu1').removeClass('hide1');
            $scope.showEditMenu = !$scope.showEditMenu;
        };

        $scope.purchase = function () {
            if (vm.platformSetting == null || vm.platformSetting.storeNotifyUrl == null) {
                swal({
                    title: $translate.instant("editorCommon.describe13"),
                    text: $translate.instant("editorCommon.describe14"),
                    imageUrl: Theme.sweetHintImg(),
                    timer: 2000,
                    showConfirmButton: false
                });
            }
            window.location.href = vm.platformSetting.storeNotifyUrl + '/#/' + vm.storeId + '/sales-order/' + vm.article.id + '/' + $scope.copy + '/new2';
        };

        $scope.orderNow = function () {
            if(vm.source){
                uni.redirectTo({
                    url: vm.returnurl2
                })
                return
            }
            window.location.href = vm.returnurl2;
            return
            $scope.selectMenuShow = false;
            $scope.showEditMenu = false;
            $scope.action = $scope.action_orderNow;
            $scope.copy = 1;
            if (!vm.itemValue.productSaleable || vm.itemValue.cancelled || vm.itemValue.productCancelled) {
                swal({
                    title: $translate.instant("editorCommon.describe15"),
                    text: $translate.instant("editorCommon.describe16"),
                    imageUrl: Theme.sweetHintImg(),
                    timer: 2000,
                    showConfirmButton: false
                });
                return;
            } else if (vm.article.articleStatus=='NEW'||vm.article.articleStatus=='EDITING') {
                swal({
                    title: $translate.instant("editorCommon.describe15"),
                    text: $translate.instant("editorCommon.describe16"),
                    imageUrl: Theme.sweetHintImg(),
                    timer: 2000,
                    showConfirmButton: false
                });
                return;
            }
            $scope.purchase();
        };

        var audioTest = null;
        $scope.openMusicList = function () {
            $scope.musicPage = true;
            audio.pause();
            vm.musicIdentify = vm.article.musicIdentify;
            if (vm.article.musicIdentify) {
                angular.forEach($scope.Musics, function (music, i) {
                    if (music.identify == vm.article.musicIdentify) {
                        $(".music-current").hide();
                        $(".music-current" + i).show();
                        setMusicStyle(i)
                    }
                })
            }

            audioTest = document.getElementById("audition");
            audioTest.crossOrigin = 'anonymous';
        };

        $scope.playList = function (identify, index) {
            // audioTest.pause();
            audioTest.src = $scope.domain + identify;
            vm.musicIdentify = identify;
            audioTest.play();
            setMusicStyle(index);
        };

        function setMusicStyle(index) {
            $(".music-name").removeClass('music-active');
            $(".music-name" + index).addClass('music-active');
            $(".music-icon").hide();
            $(".music-icon" + index).show();
        }

        $scope.backTo = function () {
            $scope.musicPage = false;
            audioTest.pause();
            audio.play();
        };

        $scope.saveMusic = function () {
            if (vm.musicIdentify == null || vm.musicIdentify == "") {
                $scope.musicPage = false;
            } else {
                Article.updateMusic({id: vm.article.id, musicIdentify: vm.musicIdentify}, function (res) {
                    if(res.status == 200){
                        vm.article = res.data;
                        $scope.musicPage = false;
                        audio.src = $scope.domain + vm.article.musicIdentify;
                        audioTest.pause();
                        audio.play();
                    }else {
                        MessageService.error(res.message);
                    }
                }, function () {

                })
            }

        }
    }
})();

(function () {
    'use strict';

    angular
        .module('editorApp')
        .controller('ProductDialogController', ProductDialogController);

    ProductDialogController.$inject = ['$timeout', '$state', '$scope', '$q', '$http', '$stateParams', 'ItemValue', 'CommonService', 'FontManagement', 'Convert', 'Qinius', 'QiniuToken', '$rootScope', 'Article', 'ImageService', '$localStorage', 'ClipArt', 'SweetAlert', 'Theme', 'UidService', 'ListService', 'Store', 'Gallery','IMAGE_SUPPORTED_MIME'];

    function ProductDialogController($timeout, $state, $scope, $q, $http, $stateParams, ItemValue, CommonService, FontManagement, Convert, Qinius, QiniuToken, $rootScope, Article, ImageService, $localStorage, ClipArt, SweetAlert, Theme, UidService, ListService, Store, Gallery, IMAGE_SUPPORTED_MIME) {

        var vm = this;
        //避免重复调用，当状态是make的时候进入新建/编辑作品页面
        var production = localStorage.getItem('Production');

        if (production == 'start' || production == 'gallery') {
            return
        }

        var tt = localStorage.getItem('guide-step');
        $scope.status = localStorage.getItem('Production');
        if ($scope.status == 'make' && tt) {
            localStorage.setItem('countN', 8);
            $scope.countN = 8;
        } else {
            $scope.countN = parseInt(localStorage.getItem('countN'));
        }


        if (tt == 'true') {
            vm.guideStep = true;
        } else if (tt == 'false' || tt == '' || tt == null || tt == undefined) {
            vm.guideStep = false;
        }
        if ($scope.loading == false) {
            $scope.loadingAfter = false;
        }

        //风格切换  引入不同的css文件
        Theme.judge();

        var url = window.location.hash && window.location.href.slice(0, -window.location.hash.length) || window.location.href;
        localStorage.setItem('url', url);


        // $scope.dHeight = $rootScope.dHeight || document.documentElement.clientHeight;
        vm.editHeight = document.documentElement.clientHeight;
        $scope.dWidth = document.documentElement.clientWidth;
        $("body").css({width: $scope.dWidth, 'min-width': $scope.dWidth});      //设置页面的最小宽度
        $(".well").css({'margin-bottom': 0});
        $(".navbar-gallery").hide();
        $(".wrap").show().addClass('no-margins');

        if (!window.__wxjs_is_wkwebview) {
            $scope.dHeight = $rootScope.dHeight || document.documentElement.clientHeight;
            // 禁止安卓默认事件
            var androidDefault = document.querySelector('.page-make');
            androidDefault.addEventListener('contextmenu', function (e) {
                e.preventDefault();
            });
        } else {
            $scope.dHeight = localStorage.getItem('windowMinH') || document.documentElement.clientHeight;
        }

        $rootScope.dHeight = $scope.dHeight;
        vm.supportedMimeTypes = IMAGE_SUPPORTED_MIME;

        vm.storeId = $stateParams.storeId || $localStorage.storeId;
        vm.pid = $stateParams.pid;      //新建作品id
        vm.vid = $stateParams.vid;      //新建作品参数id
        vm.aid = $stateParams.aid;      //编辑作品id
        vm.edit = false;
        vm.counts = 0;
        vm.FirstSeven = 0;
        vm.flags = false;
        vm.isOrientation = false;
        vm.supportedMimeTypes = IMAGE_SUPPORTED_MIME;


        Store.get({id: vm.storeId}, function (res) {
            if(res.status == 200){
                vm.store = res.data;
            }else {
                MessageService.error(res.message);
            }
        });

        /**
         * mm换算成px
         * @param mm
         * @returns {number}
         */
        var unitTransform = function (mm) {
            return mm * 3;
        };
        /**
         * px换算成mm
         * @param px
         * @returns {number}
         */
        var unitTransformPx = function (px) {
            return px * 1 / 3;
        };

        $scope.isSave = false;
        $rootScope.currentCarouselIndex = 0;
        $scope.selectSketchMenu = 'sketch-color';
        $scope.colorList = ['#ff001e', '#ff5c00', '#ff9700', '#61734d', '#838c97', '#8d4ac8', '#b8e986', '#7e6565', '#ffffff', '#f1e7d9', '#b5ce99', '#82c281', '#dac2ef', '#000', '#797979', '#7c330a', '#eec78d', '#444444', '#589ceb', '#4a7bc8', '#ddabab'];
        $scope.selectedColor = $scope.colorList[0];
        $scope.stickerList = [];
        $scope.selectedFont = '';
        $scope.domain = null;
        $scope.update = false;
        $scope.PAGELEN = 0;
        $scope.AllPAGELEN = 0;
        //底部模板栏，像素栏，图片栏高度:84+pading:8   =100
        $scope.mHeight = 84;
        //52+62+100 +20
        $scope.tHeight = 240;
        // 左移按钮
        $scope.visibleLeft = false;
        // 右移按钮
        $scope.visibleRight = false;
        // 编辑按钮
        $scope.showBarMenu = true;
        // 底部按钮栏
        $scope.showBottomMenu = true;
        $scope.showTempMenu = false;
        $scope.showImageMenu = false;
        $scope.showCut = false;
        $scope.showText = false;
        $scope.loading = true;
        $scope.template = {pages: {page: []}};
        $scope.pageAllPx = {page: []};
        $scope.status = localStorage.getItem('Production');
        $scope.weixinFlag = localStorage.getItem('distinguish');
        $scope.template.maxPageHeight = 0;
        $scope.template.ulWidth = 0;

        var mL = 0, liW = 0, ulW = 0, selectTextIndex = 0;
        var runR = true, runL = true, flag = true, isDragging = false, moveSticker = false, moveText = false, completed = false;
        var drag;
        var dragBox = {}, stickerDragBox = {};
        var gallery = [], goes = [], local_pages = [], single = [], pageIndex = [], pageI = [], proIndex = [], sort = [];
        var $ul = $(".carousel5");
        var $li = $(".template-carousel");
        $li.hide();


        var reviewDoc = null;

        if (vm.pid) {
            getLocalStorage();
            // 一键Go
            goes = JSON.parse(localStorage.getItem("go"));
        } else {
            getLocalStorage()
        }

        function getLocalStorage() {
            // 工作区中编辑作品所用到的图片
            gallery = JSON.parse(localStorage.getItem("gallery")) || [];
            // $scope.template.pages数据
            local_pages = JSON.parse(localStorage.getItem("pages")) || [];
            // 单张导入
            single = JSON.parse(localStorage.getItem("single"));
            // 单张导入到第N页
            pageIndex = localStorage.getItem("index");
            // 单张导入到第N个占位框
            pageI = localStorage.getItem("i");
            // 记录图片Id
            proIndex = localStorage.getItem("$index");

            sort = localStorage.getItem("sort");
        }

        $scope.domains = Qinius.getDomain();
        QiniuToken.get('get', {}, function (token) {
            vm.token = token;
        });

        if (vm.pid) {
            // 新建作品
            //  显示/隐藏引导页
            $scope.isHide = localStorage.getItem('isHide') || false;
            if (!$scope.isHide) {
                $(".come-in").show();
            }
            ItemValue.get({id: $stateParams.vid}, function (res) {
                if(res.status == 200){
                    vm.article = {
                        sku: res.data.sku,
                        name: res.data.productName,
                        productId: res.data.productId,
                        productName: res.data.productName,
                        categoryId: res.data.categoryId,
                        categoryName: res.data.categoryName,
                        themeClassifyId: res.data.productXmlThemeId,
                        themeClassifyName: res.data.productXmlThemeName,
                        productXmlId: res.data.productXmlId,
                        productXmlName: res.data.productXmlName
                    };
                    Convert.xmlToDocument({
                        identifier: res.data.productXmlIdentifier,
                        provider: res.data.productXmlProvider
                    }, function (resp) {
                        if(resp.status == 200){
                            setPageContent(resp.data);
                        }else {
                            MessageService.error(resp.message);
                        }
                    });
                }else {
                    MessageService.error(res.message);
                }
            });
        } else if (vm.aid) {
            // 编辑作品
            Article.get({id: $stateParams.aid}, function (resp) {
                if(resp.status == 200){
                    vm.article = angular.copy(resp.data);
                    $scope.update = true;
                    $scope.isHide = true;
                    setPageContent(resp.data.document);
                }else {
                    MessageService.error(resp.message);
                }
            });
        }

        /**
         * Get document
         * @param obj
         */
        function setPageContent(obj) {
            var k = 0;
            // 正常页
            var arrUse = {
                pages: {
                    page: []
                }
            };
            // 备用页
            var arrUnUse = {
                pages: {
                    page: []
                }
            };

            //新建
            if (vm.pid) {

                for (var i = 0; i < obj.pages.page.length; i++) {
                    var page = obj.pages.page[i];
                    if (page.uuid == null) {
                        page.uuid = UidService.get();
                    }
                    if (!page.backup) {
                        // if()
                        page.count = 1;
                        arrUse.pages.page.push(page);
                        $scope.PAGELEN++;
                        k++;
                        vm.counts += page.imageboxes.imagebox.length;
                        if (k < 4 || $scope.PAGELEN <= 3) {
                            vm.FirstSeven += page.imageboxes.imagebox.length;
                        }
                    }
                    //将模板所有页设为备用页
                    if (page.backup) {
                        page.count = 0;
                    }
                    var p = angular.copy(page);

                    if (p.backup) {
                        arrUnUse.pages.page.unshift(p);
                    } else {
                        arrUnUse.pages.page.push(p);
                    }
                    // arrUnUse.pages.page.push(p);
                    p.backup = true;
                }
            } else {
                for (var i = 0; i < obj.pages.page.length; i++) {
                    var page = obj.pages.page[i];
                    if (page.uuid == null) {
                        page.uuid = UidService.get();
                    }
                    if (!page.backup) {
                        arrUse.pages.page.push(page);
                        $scope.PAGELEN++;
                        k++;
                        vm.counts += page.imageboxes.imagebox.length;
                        if (k < 4 || $scope.PAGELEN <= 3) {
                            vm.FirstSeven += page.imageboxes.imagebox.length;
                        }
                    } else {
                        arrUnUse.pages.page.push(page);
                        // arrUnUse2.pages.page.push(page);
                    }
                }
                //计算页面使用次数
                for (var i = 0; i < arrUnUse.pages.page.length; i++) {
                    var p1 = arrUnUse.pages.page[i];
                    var count = 0;
                    for (var j = arrUse.pages.page.length - 1; j >= 0; j--) {
                        var p2 = arrUse.pages.page[j];
                        if (p1.uuid == p2.uuid) {
                            count++;
                        }
                    }
                    p1.count = count;
                }
            }

            // 将备用页放在正常页面的后面
            obj.pages = angular.copy(arrUse.pages);

            if (vm.counts == 0 || vm.FirstSeven == 0) {
                showPages();
            }

            vm.article.reprint = obj.reprint;
            if ($rootScope.template) {
                vm.article.document = choose(local_pages, $rootScope.template);
            } else {
                vm.article.document = choose(local_pages, obj);
            }
            localStorage.setItem('pages', JSON.stringify(vm.article.document.pages));
            if (!$rootScope.template) {
                //单页编辑 底下可选择的模板
                if (local_pages.page && local_pages.page.length > 0) {
                    for (var i = 0; i < arrUnUse.pages.page.length; i++) {
                        var p = arrUnUse.pages.page[i];
                        var count = 0;
                        for (var j = 0; j < local_pages.page.length; j++) {
                            var p2 = local_pages.page[j];
                            if (p.uuid == p2.uuid) {
                                count++;
                            }
                        }
                        p.count = count;
                    }
                }
                getAll2(arrUnUse.pages);
            }else{
                $scope.pageAllPx = JSON.parse(localStorage.getItem("pageAllPx"));
                angular.forEach($scope.pageAllPx.page,function (page,index) {
                    if (page.imageboxes.imagebox.length > 0) {
                        angular.forEach(page.imageboxes.imagebox, function (img, i) {
                            // setTimeout(function () {
                                maskScale2(img, index, i, img.maskUrl);
                            // },1000);
                        });
                    }
                })
            }
            //平铺页   单页编辑
            getAll(vm.article.document.pages);
        }

        function showPages() {
            $scope.loading = false;
            $(".page-loading").hide().css({'opacity': 0});
            $li.show();
            $(".guide-view").removeClass('opacity-zero');
        }

        function choose(local_pages, res) {
            console.log(vm.store.bokeh);
            // 一键Go
            if ((goes != null || goes != undefined) && goes.length && vm.vid) {
                var i = 0;
                angular.forEach(res.pages.page, function (page) {
                    if (page.backup) {
                        return
                    }
                    var arr = [];
                    angular.forEach(page.imageboxes.imagebox, function (img, j) {
                        var len = page.imageboxes.imagebox.length;
                        if (!img.image) {
                            img.image = {}
                        }
                        if (len > 1) {
                            // 得到占位框的宽高比
                            img.ratio = img.geometry.width / img.geometry.height;
                            if (goes[i]) {
                                goes[i].index = i;
                                arr.push(goes[i]);
                                i++;
                            }
                            if (j == len - 1) {
                                // 按照占位框的宽高比排序
                                page.imageboxes.imagebox.sort(compare('ratio'));
                                // 按照工作区中图片的宽高比排序
                                arr.sort(compare('ratio'));
                                angular.forEach(page.imageboxes.imagebox, function (img, m) {
                                    if (!arr[m]) {
                                        return
                                    }
                                    img.image = imgParamter(img, arr[m], arr[m].index);
                                    if (vm.store.bokeh) {
                                        img.blurred = true;
                                        img.blurredRectangle = {
                                            x: 0,
                                            y: 0,
                                            width: 0,
                                            height: 0
                                        }
                                    } else {
                                        img.blurred = false;
                                    }

                                });
                            }
                        } else {
                            if (!goes[i]) {
                                return
                            }
                            img.image = imgParamter(img, goes[i], i);
                            if (vm.store.bokeh) {
                                img.blurred = true;
                                img.blurredRectangle = {
                                    x: 0,
                                    y: 0,
                                    width: 0,
                                    height: 0
                                }
                            } else {
                                img.blurred = false;
                            }

                            i++
                        }
                    });
                });
                // }

            } else {
                // $scope.template.pages.page中的内容
                if (local_pages.page && local_pages.page.length > 0) {
                    vm.counts = 0;
                    res.pages = angular.copy(local_pages);
                    angular.forEach(local_pages.page, function (page, index) {
                        if (!page.backup) {
                            vm.counts += page.imageboxes.imagebox.length;
                        }
                        angular.forEach(page.imageboxes.imagebox, function (img, i) {
                            if (res.pages.page[index] && img.blobImage) {
                                if (!res.pages.page[index].imageboxes.imagebox[i].image) {
                                    res.pages.page[index].imageboxes.imagebox[i].image = {}
                                }

                                res.pages.page[index].imageboxes.imagebox[i].blobImage = img.blobImage;
                                res.pages.page[index].imageboxes.imagebox[i].blurred = img.blurred;
                                res.pages.page[index].imageboxes.imagebox[i].blurredRectangle = img.blurredRectangle || {};

                                res.pages.page[index].imageboxes.imagebox[i].image = {
                                    resource: {
                                        identifier: img.image.resource.identifier || '',
                                        provider: 'qiniu'
                                    },
                                    parameter: img.image.parameter || [],
                                    offsetX: img.image.offsetX || 0,
                                    offsetY: img.image.offsetY || 0,
                                    angle: img.image.angle || 0,
                                    scale: img.image.scale || 1,
                                    index: img.image.index ? img.image.index : vm.aid ? '' : i,
                                    width: img.image.width || '',
                                    height: img.image.height || '',
                                    scaleW: img.image.scaleW || 1,
                                    scaleH: img.image.scaleH || 1,
                                    imgSize: img.image.imgSize || '',
                                    lowSize: img.image.lowSize == false ? false : true,
                                    resourceId: img.image ? img.image.id ? img.image.id : img.image.resourceId ? img.image.resourceId : '' : ''
                                };
                            }

                        });
                        if (!$rootScope.template && res.pages.page[index]) {
                            res.pages.page[index].textboxes = angular.copy(page.textboxes);
                            res.pages.page[index].imagearts = angular.copy(page.imagearts);
                        }
                    });
                }

                // 单张导入
                if (single) {
                    var img = res.pages.page[pageIndex].imageboxes.imagebox[pageI];
                    if (!img.image) {
                        img.image = {}
                    } else {
                        $scope.imgIndex = img.image.index;
                        $scope.imgId = img.image.resourceId;
                    }
                    img.image = imgParamter(img, single, proIndex);
                    img.image.resource.identifier = single.identifier;
                }
            }

            vm.article.document = {
                pages: res.pages
            };
            reviewDoc = vm.article.document.pages;

            vm.edit = true;     //判断是否是模板上的文字
            localStorage.removeItem("go");
            return res;
        }

        $scope.hideComeIn = function () {
            $scope.isHide = true;
            localStorage.setItem('isHide', true);
        };

        function compare(property) {
            return function (a, b) {
                var value1 = a[property];
                var value2 = b[property];
                return value1 - value2;
            }
        }

        function imgParamter(img, arr, i) {
            return {
                resource: {
                    identifier: img.image.resource && img.image.resource.identifier != '' ? img.image.resource.identifier : arr.identifier,
                    provider: 'qiniu'
                },
                parameter: arr.parameter,
                offsetX: img.image.offsetX || 0,
                offsetY: img.image.offsetY || 0,
                angle: img.image.angle || 0,
                scale: img.image.scale || 1,
                index: i,
                width: arr.width,
                height: arr.height,
                imgSize: arr.imgSize,
                resourceId: arr.id,
                scaleH: img.image.scaleH || 1,
                scaleW: img.image.scaleW || 1,
            };
        }

        function getAll(pages) {
            $q.all([$scope.domains.$promise]).then(function () {
                //设置title
                CommonService.setDocumentTitle('制作作品');
                $scope.domain = 'https://' + $scope.domains.domains[0] + '/';
                var marLeft = getSingleLocalStorage('marginLeft');

                $(".carousel5").css({'margin-left': -marLeft + 'px'});
                $rootScope.currentCarouselIndex = Math.abs(parseInt(marLeft / ($scope.dWidth * 0.94)));
                $scope.visibleLeft = $rootScope.currentCarouselIndex ? true : false;
                $scope.visibleRight = $rootScope.currentCarouselIndex + 1 == pages.page.length ? true : false;
                getStickerList();
                getFontList();
                // 当有缓存的时候  （添加照片库进入编辑页面）
                if ($rootScope.template) {
                    if (vm.pid) {
                        $scope.galleryList = JSON.parse(localStorage.getItem('gallery'));
                        gallery = angular.copy($scope.galleryList);
                        reviewDoc = JSON.parse(localStorage.getItem('reviewPages'));
                        // $scope.pageAllPx = JSON.parse(localStorage.getItem('pageAllPx'));

                    } else {
                        $scope.galleryList = JSON.parse(localStorage.getItem('gallery'));
                        reviewDoc = JSON.parse(localStorage.getItem('reviewPages'));
                        // $scope.pageAllPx = JSON.parse(localStorage.getItem('pageAllPx'));
                    }

                    var imagebox = reviewDoc.page[$rootScope.currentCarouselIndex].imageboxes.imagebox;
                    var imageLen = imagebox.length;

                    if (vm.store.bokeh && (single || imagebox[pageI]&&imagebox[pageI].blobImage)) {
                        $(".mode1,.mode2").removeClass('hide1');
                        $(".cut-image").hide();
                    } else {
                        $(".mode1,.mode2").addClass('hide1');
                    }


                    if (single) {

                        var reviewImage = reviewDoc.page[pageIndex].imageboxes.imagebox[pageI];
                        if (!reviewImage.image) {
                            reviewImage.image = pages.page[pageIndex].imageboxes.imagebox[pageI].image
                        }
                        reviewImage.imgUrl = $scope.domain + single.identifier;
                        reviewImage.image.resourceId = single.id;
                        reviewImage.image.resource.identifier = single.identifier;
                        reviewImage.image.parameter = angular.fromJson(reviewImage.image.parameter);
                        reviewImage.image.offsetY = 0;
                        reviewImage.image.offsetX = 0;
                        if (vm.store.bokeh) {
                            reviewImage.blurred = true;
                            reviewImage.blurredRectangle = {
                                x: 0,
                                y: 0,
                                width: reviewImage.geometry.width,
                                height: reviewImage.geometry.height
                            }
                        }

                        if ($scope.galleryList.length) {
                            angular.forEach($scope.galleryList, function (arr, i) {
                                if (arr.id == $scope.imgId) {
                                    arr.useNum == 0 ? 0 : arr.useNum--;
                                    gallery = angular.copy($scope.galleryList);
                                    setGalleryStorage();
                                }
                            })
                        }

                        localStorage.removeItem("single");
                    }
                    setImageWidth();
                    showPages();
                    $scope.showImageMenu = true;
                    $scope.showBottomMenu = false;
                    if (imageLen < 2) {
                        $(".change").hide();
                    } else {
                        $(".change").show();
                    }

                    if (imageLen && !imagebox[0].image) {
                        $(".change,.cut-image").hide();
                    }

                    tipStatus(true);

                    for (var i = 0; i < reviewDoc.page.length; i++) {
                        getPageToPx(reviewDoc.page[i], i, true, true);
                    }
                    return;
                }
                reviewDoc = angular.copy(pages);
                // console.log(reviewDoc);
                // localStorage.setItem('pageAllMm', JSON.stringify(pages));
                //取得xml文档内容

                //安卓事件
                if (!window.__wxjs_is_wkwebview) {
                    var x = 0;
                    for (var t = 0; t < reviewDoc.page.length; t += 2) {
                        x++;
                        if (reviewDoc.page.length - t > 2) {
                            distributeFor(t, t + 2, reviewDoc, x);
                        } else {
                            distributeFor(t, reviewDoc.page.length, reviewDoc, x);
                        }
                    }

                } else {
                    for (var i = 0; i < reviewDoc.page.length; i++) {
                        getPageToPx(reviewDoc.page[i], i, true, true);
                    }
                }

            });
        }

        function getAll2(pages) {
            localStorage.setItem('pageAllMm', JSON.stringify(pages));
            var x = 0;
            for (var t = 0; t < pages.page.length; t += 2) {
                x++;
                if (pages.page.length - t > 2) {
                    distributeFor2(t, t + 2, pages, x);
                } else {
                    distributeFor2(t, pages.page.length, pages, x);
                }
            }
        }

        function distributeFor2(l, len, pages, x) {
            setTimeout(function () {
                for (var j = l; j < len; j++) {
                    getPageToPx2(pages.page[j], j, true, pages.page.length);
                }
            }, 1000 * x);
        }

        function distributeFor(l, len, pages, x) {
            setTimeout(function () {
                for (var j = l; j < len; j++) {
                    getPageToPx(pages.page[j], j, true, true);
                }
            }, 1000 * x);
        }


        function getSingleLocalStorage(value) {
            return localStorage.getItem(value) || 0
        }

        function getPageToPx2(page, index, isFirstIn, pageSize) {
            var isMaxWidth = getScale($scope.dWidth, $scope.dHeight, page.mediabox.width, page.mediabox.height, index);

            var styleScale = 1;
            var temp = {
                bgImg: page.background && page.background.resource.identifier ? $scope.domain + page.background.resource.identifier + '?imageMogr2/thumbnail/!40p' : '',
                background: angular.copy(page.background),
                mediabox: angular.copy(page.mediabox),
                trimbox: angular.copy(page.trimbox),     //裁切线
                textboxes: {textbox: []},
                imageboxes: angular.copy(page.imageboxes),
                imagearts: {imageart: []},
                isMaxWidth: isMaxWidth,
                spread: page.spread,
                backup: page.backup,
                uuid: page.uuid,
                count: page.count,
                widthM: page.mediabox.width,
                heightM: page.mediabox.height,
                width: unitTransform(page.mediabox.width),
                height: unitTransform(page.mediabox.height),
                selectImgIndex: 0,
                currentZindex: -1,
                centerRotation: page.centerRotation ? true : false
            };
            if (isMaxWidth) {
                temp.styleScale = styleScale = ($scope.dWidth * 0.94 / (unitTransform(page.mediabox.width)));
                temp.styleScale2 = styleScale;
            } else {
                temp.styleScale = styleScale = (($scope.dHeight - $scope.tHeight) / (unitTransform(page.mediabox.height)));
                temp.styleScale2 = styleScale;
            }

            //得到压缩比例后的最高page的高度

            if (page.barcode) {
                temp.barcode = getGeometry(page.barcode, temp);
                temp.barcodeM = angular.copy(page.barcode);
            }
            if (page.qrcode) {
                temp.qrcode = getGeometry(page.qrcode, temp);
                temp.qrcodeM = angular.copy(page.qrcode);
            }
            if (page.imagearts) {
                angular.forEach(page.imagearts.imageart, function (art, i) {
                    temp.imagearts.imageart[i] = {
                        geometry: getGeometry(art.geometry, temp),
                        resource: angular.copy(art.resource),
                        type: art.type,
                        rotation: {
                            angle: -art.rotation.angle
                        },
                        heightM: art.geometry.height,
                        widthM: art.geometry.width,
                        XM: art.geometry.x,
                        YM: art.geometry.y,
                        zindex: i,
                        imgUrl: art.resource.provider == 'qiniu' ? $scope.domain + art.resource.identifier : art.resource.identifier
                    };
                });
            }
            if (page.imageboxes.imagebox.length > 0) {
                angular.forEach(page.imageboxes.imagebox, function (img, i) {
                    var maskUrl = 'content/images/timg.jpg';
                    temp.imageboxes.imagebox[i] = {
                        geometry: getGeometry(img.geometry, temp),
                        mask: angular.copy(img.mask),
                        imgUrl: 'content/images/timg.jpg',
                        rotation: angular.copy(img.rotation),
                        heightM: img.geometry.height,
                        widthM: img.geometry.width,
                        offsetXM: img.geometry.x,
                        offsetYM: img.geometry.y,
                        blobImage: img.blobImage || ''
                    };

                    var imagebox = temp.imageboxes.imagebox[i];
                    if (img.mask.resource.identifier) {
                        maskUrl = $scope.domain + img.mask.resource.identifier;
                    }
                    var reviewImage = page.imageboxes.imagebox[i];

                    reviewImage.maskUrl = imagebox.maskUrl = maskUrl;

                    setTimeout(function () {
                        maskScale2(imagebox, index, i, maskUrl);
                    },1000);

                });
            }
            if (page.textboxes.textbox.length > 0) {
                angular.forEach(page.textboxes.textbox, function (text, i) {
                    temp.textboxes.textbox[i] = {
                        geometry: getGeometry(text.geometry, temp),
                        identifier: text.identifier,
                        style: angular.copy(text.style),
                        rotation: {
                            angle: -text.rotation.angle
                        },
                        text: text.text,
                        heightM: text.geometry.height,
                        widthM: text.geometry.width,
                        xM: text.geometry.x,
                        yM: text.geometry.y,
                        styles: 'NORMAL',
                        type: text.type,
                        status: text.status,
                        templateType: vm.edit ? text.type : '',
                        zindex: i
                    };
                    var tempText = temp.textboxes.textbox[i];
                    if (tempText.style.bold && tempText.style.italic) {
                        tempText.styles = 'BOLD_ITALIC';
                    } else if (tempText.style.bold) {
                        tempText.styles = 'BOLD';
                    } else if (tempText.style.italic) {
                        tempText.styles = 'ITALIC';
                    } else {
                        tempText.styles = 'NORMAL';
                    }
                    toImg(tempText, temp.styleScale, index, i);
                });
            }

            if (isFirstIn) {
                $scope.pageAllPx.page[index] = temp;
            }
            if (index == pageSize - 1) {
                if ($scope.status == 'make') {
                    // console.log(reviewDoc);
                    // console.log($scope.pageAllPx);
                    localStorage.setItem('pageAllPx', JSON.stringify($scope.pageAllPx));
                    setUlWidth();
                }
                // if(isFirstIn&&$scope.status == 'view'&&!window.__wxjs_is_wkwebview){
                //     $scope.$digest();
                // }
            }
        }

        function getPageToPx(page, index, flag, isFirstIn) {
            $scope.template.zindex = 0;
            var isMaxWidth = getScale($scope.dWidth, $scope.dHeight, page.mediabox.width, page.mediabox.height, index);
            var temp = [];

            $scope.template.pageI = 0;

            var thumbnailH = 0, styleScale = 1;
            temp = {
                bgImg: page.background && page.background.resource.identifier ? $scope.domain + page.background.resource.identifier + '?imageMogr2/thumbnail/!40p' : '',
                background: angular.copy(page.background),
                mediabox: angular.copy(page.mediabox),
                trimbox: angular.copy(page.trimbox),     //裁切线
                textboxes: {textbox: []},
                imageboxes: angular.copy(page.imageboxes),
                imagearts: {imageart: []},
                isMaxWidth: isMaxWidth,
                spread: page.spread,
                backup: page.backup,
                uuid: page.uuid,
                count: page.count,
                widthM: page.mediabox.width,
                heightM: page.mediabox.height,
                width: unitTransform(page.mediabox.width),
                height: unitTransform(page.mediabox.height),
                selectImgIndex: 0,
                currentZindex: -1,
                centerRotation: page.centerRotation ? true : false
            };
            if (isMaxWidth) {
                $scope.template.ulWidth += $scope.dWidth * 0.94;
                temp.styleScale = styleScale = ($scope.dWidth * 0.94 / (unitTransform(page.mediabox.width)));
                temp.styleScale2 = styleScale;
                thumbnailH = $scope.dWidth * 0.94 * unitTransform(page.mediabox.height) / unitTransform(page.mediabox.width);
            } else {
                $scope.template.ulWidth += ($scope.dHeight - $scope.tHeight) * unitTransform(page.mediabox.width) / unitTransform(page.mediabox.height);
                temp.styleScale = styleScale = (($scope.dHeight - $scope.tHeight) / (unitTransform(page.mediabox.height)));
                temp.styleScale2 = styleScale;
                thumbnailH = ($scope.dHeight - $scope.tHeight) * unitTransform(page.mediabox.width) / unitTransform(page.mediabox.height);
            }
            if ($scope.status == 'view') {
                if (index == 0 || index == $scope.PAGELEN - 1) {
                    temp.styleScale = ($scope.dWidth * 0.6 / (unitTransform(page.mediabox.width)));
                } else {
                    temp.styleScale = ($scope.dWidth * 0.45 / (unitTransform(page.mediabox.width)));
                }
            }
            //得到压缩比例后的最高page的高度
            if ($scope.template.maxPageHeight < thumbnailH) {
                $scope.template.maxPageHeight = thumbnailH;
            }
            if (page.barcode) {
                temp.barcode = getGeometry(page.barcode, temp);
                temp.barcodeM = angular.copy(page.barcode);
            }
            if (page.qrcode) {
                temp.qrcode = getGeometry(page.qrcode, temp);
                temp.qrcodeM = angular.copy(page.qrcode);
            }
            if (page.imagearts) {
                angular.forEach(page.imagearts.imageart, function (art, i) {
                    temp.imagearts.imageart[i] = {
                        geometry: getGeometry(art.geometry, temp),
                        resource: angular.copy(art.resource),
                        type: art.type,
                        rotation: {
                            angle: -art.rotation.angle
                        },
                        heightM: art.geometry.height,
                        widthM: art.geometry.width,
                        XM: art.geometry.x,
                        YM: art.geometry.y,
                        zindex: i,
                        imgUrl: art.resource.provider == 'qiniu' ? $scope.domain + art.resource.identifier : art.resource.identifier
                    };
                });
            }
            if (page.imageboxes.imagebox.length > 0) {
                angular.forEach(page.imageboxes.imagebox, function (img, i) {
                    var maskUrl = 'content/images/timg.jpg';
                    if (flag) {
                        temp.imageboxes.imagebox[i] = {
                            geometry: getGeometry(img.geometry, temp),
                            mask: angular.copy(img.mask),
                            imgUrl: 'content/images/timg.jpg',
                            rotation: angular.copy(img.rotation),
                            heightM: img.geometry.height,
                            widthM: img.geometry.width,
                            offsetXM: img.geometry.x,
                            offsetYM: img.geometry.y,
                            blobImage: img.blobImage || '',
                            blurred: img.blurred == true ? true : false
                        };
                        var imagebox = temp.imageboxes.imagebox[i];
                        if (img.mask.resource.identifier) {
                            maskUrl = $scope.domain + img.mask.resource.identifier;
                        }
                        // page   reviewDoc.page[index]
                        var reviewImage = page.imageboxes.imagebox[i];

                        reviewImage.maskUrl = imagebox.maskUrl = maskUrl;

                        if (img.image && img.image.resource && img.image.resource.identifier) {       //qiniu
                            imagebox.image = {
                                resource: {
                                    identifier: img.image.resource.identifier || '',
                                    provider: img.image.resource.provider || 'qiniu'
                                },
                                filterResource: {
                                    identifier: img.image.filterResource ? img.image.filterResource.identifier : '',
                                    provider: img.image.filterResource ? img.image.filterResource.provider : 'qiniu'
                                },
                                width: img.image.width,
                                height: img.image.height,
                                imgSize: img.image.imgSize,
                                index: img.image.index,
                                rotation: angular.copy(img.rotation),
                                parameter: angular.fromJson(img.image.parameter) || [],
                                filter: img.image.filter || '',
                                offsetX: img.blobImage ? img.image.offsetX : (unitTransform(img.image.offsetX) * temp.styleScale2),
                                offsetY: img.blobImage ? img.image.offsetY : (unitTransform(img.image.offsetY) * temp.styleScale2),
                                angle: img.image.angle || 0,
                                scale: img.image.scale || 1,
                                resourceId: img.image.resourceId || '',
                                scaleW: 1,
                                scaleH: 1
                            };

                            imagebox.blurredRectangle = {
                                x: 0,
                                y: 0,
                                width: 0,
                                height: 0
                            };


                            imagebox.adaptationW = img.blobImage ? img.adaptationW : '';
                            imagebox.imgUrl = $scope.domain + img.image.resource.identifier;
                            imgScale(imagebox, index, i, styleScale, temp.styleScale, imagebox.image.offsetX, imagebox.image.offsetY);
                        } else {
                            maskScale(imagebox, index, i, maskUrl);
                        }
                    } else {
                        var imagebox = temp.imageboxes.imagebox[i];
                        imagebox.geometry = getGeometry(img.geometry, temp);
                        imagebox.widthM = img.geometry.width;
                        imagebox.heightM = img.geometry.height;
                        imagebox.offsetXM = img.geometry.x;
                        imagebox.offsetYM = img.geometry.y;
                        if (img.blurred) {
                            var w = imagebox.image.width;
                            var h = imagebox.image.height;

                            if (img.adaptationW) {
                                imagebox.blurredRectangle = {
                                    height: imagebox.geometry.height,
                                    width: imagebox.geometry.height * w / h,
                                    x: (imagebox.geometry.width - imagebox.geometry.height * w / h) / 2,
                                    y: 0
                                }
                            } else {
                                imagebox.blurredRectangle = {
                                    width: imagebox.geometry.width,
                                    height: imagebox.geometry.width * h / w,
                                    x: 0,
                                    y: (imagebox.geometry.height - imagebox.geometry.width * h / w) / 2
                                }
                            }
                        }
                    }

                });
            }
            if (page.textboxes.textbox.length > 0) {
                angular.forEach(page.textboxes.textbox, function (text, i) {
                    // console.log(text.geometry)
                    temp.textboxes.textbox[i] = {
                        geometry: getGeometry(text.geometry, temp),
                        identifier: text.identifier,
                        style: angular.copy(text.style),
                        rotation: {
                            angle: -text.rotation.angle
                        },
                        text: text.text,
                        heightM: text.geometry.height,
                        widthM: text.geometry.width,
                        xM: text.geometry.x,
                        yM: text.geometry.y,
                        styles: 'NORMAL',
                        type: text.type,
                        status: text.status,
                        templateType: vm.edit ? text.type : '',
                        zindex: i
                    };
                    $scope.template.textI = i;
                    var tempText = temp.textboxes.textbox[i];
                    if (tempText.style.bold && tempText.style.italic) {
                        tempText.styles = 'BOLD_ITALIC';
                    } else if (tempText.style.bold) {
                        tempText.styles = 'BOLD';
                    } else if (tempText.style.italic) {
                        tempText.styles = 'ITALIC';
                    } else {
                        tempText.styles = 'NORMAL';
                    }
                    toImg(tempText, temp.styleScale, index, i);
                });
            }

            // if (isFirstIn) {
            //     $scope.pageAllPx.page[index] = temp;
            // }

            if (!page.backup) {
                $scope.template.pages.page[index] = temp;
            }

            if (index == reviewDoc.page.length - 1) {
                $rootScope.template = $scope.template;
                $scope.isLeftRotation = false;
                // if ($scope.status == 'make') {
                //     localStorage.setItem('pageAllPx', JSON.stringify($scope.pageAllPx));
                //     setUlWidth();
                // }
                if (isFirstIn && $scope.status == 'view' && !window.__wxjs_is_wkwebview) {
                    $scope.$digest();
                }
            }
        }

        function getScale(screenW, screenH, pageW, pageH) {
            if (screenW * 0.94 / (screenH - $scope.tHeight) < pageW / pageH) {
                //宽定，高不定
                return true;
            } else {
                //高定，宽不定
                return false;
            }
        }

        function getGeometry(page, temp) {
            return {
                height: unitTransform(page.height) * temp.styleScale,
                width: unitTransform(page.width) * temp.styleScale,
                x: unitTransform(page.x) * temp.styleScale,
                y: unitTransform(page.y) * temp.styleScale
            }
        }

        function getImageScale(imagebox, images) {
            var w0 = angular.copy(imagebox.width);
            var h0 = angular.copy(imagebox.height);

            if (imagebox.angle == 90 || imagebox.angle == 270) {
                w0 = angular.copy(imagebox.height);
                h0 = angular.copy(imagebox.width);
            }
            var x = 0, y = 0;

            var w = angular.copy(w0);
            var h = angular.copy(h0);
            var maskWidth = images.width;
            var maskHight = images.height;
            var isWidth = true;
            if ((w0 <= h0 || maskWidth <= maskHight) && (w0 / h0 < maskWidth / maskHight) || w0 >= h0 && maskWidth >= maskHight && (w0 / h0 < maskWidth / maskHight)) {
                w0 = maskWidth;
                h0 = maskWidth * h / w;
                isWidth = true;
            } else {
                h0 = maskHight;
                w0 = maskHight * w / h;
                isWidth = false;
            }

            var scaleW = w0 / w;
            var scaleH = h0 / h;
            x = x / scaleW;
            y = y / scaleH;
            return {
                isWidth: isWidth,
                nWidth: w0,
                nHeight: h0,
                scaleW: scaleW,
                scaleH: scaleH,
                x: x,
                y: y
            }
        }

        function maskScale2(imagebox, index, id, maskUrl) {
            // console.log(maskUrl)
            var w = imagebox.geometry.width;
            var h = imagebox.geometry.height;
            var newImg = document.createElement('img');
            newImg.crossOrigin = "Anonymous";
            newImg.src = 'content/images/timg.jpg';
            newImg.onload = function () {
                $scope.$digest();
                // console.log($(".imgBoxTemp" + index + '' + id))
                maskd($(".imgBoxTemp" + index + '' + id), 'content/images/timg.jpg', maskUrl, 0, 0, w, h, 1, 1, 1, true);
            };

        }

        function maskScale(imagebox, index, id, maskUrl) {
            var w = imagebox.geometry.width;
            var h = imagebox.geometry.height;
            var newImg = document.createElement('img');
            newImg.crossOrigin = "Anonymous";
            newImg.src = 'content/images/timg.jpg';
            newImg.onload = function () {
                $scope.$digest();
                maskd($(".imgBox" + index + '' + id), 'content/images/timg.jpg', maskUrl, 0, 0, w, h, 1, 1, 1, true, function (srcs) {
                    f++;
                    $scope.$digest();
                    if (f >= vm.counts) {
                        showPages();
                    }
                });
            };

        }

        var f = 0;

        function imgScale(imagebox, index, id, styleScaleBig, styleScaleSmall, x, y) {
            var scaleW = 1, scaleH = 1;

            var reviewPage = reviewDoc.page[index].imageboxes.imagebox[id];

            var newImg = document.createElement('img');
            newImg.crossOrigin = "Anonymous";
            newImg.src = imagebox.imgUrl + '?imageMogr2/exifModify/eyJPcmllbnRhdGlvbiI6IjEifQ==/rotate/0/thumbnail/!40p';
            newImg.onload = function () {

                var w = imagebox.image.width = newImg.width;
                var h = imagebox.image.height = newImg.height;

                if (imagebox.image.angle == 90 || imagebox.image.angle == 270) {
                    w = angular.copy(newImg.height);
                    h = angular.copy(newImg.width);
                }

                var wOrigin = angular.copy(w);
                var hOrigin = angular.copy(h);

                var maskWidth = imagebox.geometry.width / styleScaleSmall * styleScaleBig;
                var maskHight = imagebox.geometry.height / styleScaleSmall * styleScaleBig;
                var k = 0;
                if ((wOrigin <= hOrigin || maskWidth <= maskHight) && (wOrigin / hOrigin < maskWidth / maskHight) || wOrigin >= hOrigin && maskWidth >= maskHight && (wOrigin / hOrigin < maskWidth / maskHight)) {
                    wOrigin = imagebox.image.imageW = maskWidth;
                    hOrigin = imagebox.image.imageH = maskWidth * h / w;
                    imagebox.adaptationW = true;
                    if (imagebox.blurred) {
                        imagebox.blurredRectangle.height = imagebox.geometry.height;
                        imagebox.blurredRectangle.width = imagebox.geometry.height * w / h;
                        imagebox.blurredRectangle.x = (imagebox.geometry.width - imagebox.blurredRectangle.width) / 2;
                    }

                    k = 1;
                } else {
                    hOrigin = imagebox.image.imageH = maskHight;
                    wOrigin = imagebox.image.imageW = maskHight * w / h;
                    imagebox.adaptationW = false;
                    if (imagebox.blurred) {
                        imagebox.blurredRectangle.width = imagebox.geometry.width;
                        imagebox.blurredRectangle.height = imagebox.geometry.width * h / w;
                        imagebox.blurredRectangle.y = (imagebox.geometry.height - imagebox.blurredRectangle.height) / 2;
                    }

                    k = 2;
                }

                scaleW = wOrigin / w;
                scaleH = hOrigin / h;
                if (!imagebox.blobImage) {
                    x = x / scaleW;
                    y = y / scaleH;
                }

                imagebox.image.scaleW = scaleW;
                imagebox.image.scaleH = scaleH;

                var parameters = imagebox.image.parameter;

                if (vm.pid && !imagebox.blobImage && parameters != []) {
                    if (parameters.length == 1) {
                        if (k == 1) {
                            if (parameters[0].y / 2.5 * scaleH + parameters[0].height / 2.5 * scaleH > maskHight) {
                                y = -(parameters[0].y / 2.5 * scaleH + parameters[0].height / 2.5 * scaleH - maskHight) / scaleH;
                            }
                        } else {
                            if (parameters[0].x / 2.5 * scaleW + parameters[0].width / 2.5 * scaleW > maskWidth) {
                                x = -(parameters[0].x / 2.5 * scaleW + parameters[0].width / 2.5 * scaleW - maskWidth) / scaleW;
                            }
                        }
                    } else {
                        if (k == 1) {
                            //高图
                            //按照Y轴排序
                            // parameters.sort(sortY);
                            parameters.sort(compare('y'));
                            for (var t = parameters.length - 1; t >= 0; t--) {
                                if (parameters[t].y / 2.5 * scaleH + parameters[t].height / 2.5 * scaleH > maskHight) {
                                    var h = parameters[t].y / 2.5 * scaleH + parameters[t].height / 2.5 * scaleH - maskHight;
                                    //判断第一张头像是否超出显示范围
                                    if (parameters[0].y / 2.5 * scaleH - h >= 0) {
                                        y = -h / scaleH;
                                    }
                                }
                            }
                        } else {
                            //宽图
                            //按照X轴排序
                            // parameters.sort(sortX);
                            parameters.sort(compare('x'));
                            for (var t = parameters.length - 1; t >= 0; t--) {
                                if (parameters[t].x / 2.5 * scaleW + parameters[t].width / 2.5 * scaleW > maskWidth) {
                                    var w = parameters[t].x / 2.5 * scaleW + parameters[t].width / 2.5 * scaleW - maskWidth;
                                    if (parameters[0].x / 2.5 * scaleW - w >= 0) {
                                        x = -w / scaleW;
                                    }
                                }
                            }
                        }
                    }
                }

                getDpi(imagebox, index, id);

                imagebox.image.offsetX = x;
                imagebox.image.offsetY = y;

                reviewPage.adaptationW = imagebox.adaptationW;
                reviewPage.image = angular.copy(imagebox.image);
                $scope.$digest();
                reviewPage.imgUrl = imagebox.imgUrl;
                reviewPage.blurred = imagebox.blurred;
                reviewPage.blurredRectangle = imagebox.blurredRectangle;

                var img = imagebox.imgUrl + '?imageMogr2/exifModify/eyJPcmllbnRhdGlvbiI6IjEifQ==/rotate/' + imagebox.image.angle + '/thumbnail/!40p';

                if (imagebox.blurred) {
                    maskd3($(".imgBoxSmall" + index + '' + id), img, imagebox, function () {
                        $scope.$digest();
                    });
                    img = img + '/blur/40x1000';
                }

                maskd($(".imgBox" + index + '' + id), img, imagebox.maskUrl, x, y, maskWidth, maskHight, scaleW, scaleH, imagebox.image.scale, false, function (src) {
                    f++;
                    imagebox.blobImage = true;
                    reviewDoc.page[index].imageboxes.imagebox[id].blobImage = true;
                    $scope.$digest();
                    singleToRemember();
                    if (f >= vm.counts) {
                        showPages();
                    }
                });
            };
        }

        function maskd3(canvas, src, imagebox, callback) {
            var imagecanvas = canvas[0];
            var imagecontext = imagecanvas.getContext('2d');
            var c1 = canvas[1];
            var ctx1 = c1.getContext('2d');

            var geo = imagebox.geometry;
            var blurredRec = imagebox.blurredRectangle;

            imagecanvas.width = c1.width = geo.width * 2;
            imagecanvas.height = c1.height = geo.height * 2;
            imagecontext.scale(2, 2);

            var newImg = document.createElement('img');
            newImg.crossOrigin = "Anonymous";
            newImg.src = src;
            newImg.onload = function () {
                newImg.onload = null;
                newImg.width = blurredRec.width;
                newImg.height = blurredRec.height;
                var masks = document.createElement('img');
                masks.crossOrigin = "Anonymous";
                masks.src = imagebox.maskUrl;

                masks.onload = function () {
                    // masks.width = geo.width;
                    // masks.height = geo.height;
                    // imagecanvas.width = c1.width = geo.width;
                    // imagecanvas.height = c1.height = geo.height;

                    imagecontext.mozImageSmoothingEnabled = true;
                    imagecontext.webkitImageSmoothingEnabled = true;
                    imagecontext.msImageSmoothingEnabled = true;
                    imagecontext.imageSmoothingEnabled = true;

                    imagecontext.drawImage(masks, 0, 0, geo.width, geo.height);
                    imagecontext.globalCompositeOperation = 'source-in';

                    imagecontext.drawImage(newImg, blurredRec.x, blurredRec.y, blurredRec.width, blurredRec.height);
                    ctx1.drawImage(imagecanvas, 0, 0);
                    if (canvas.length > 2) {
                        var c2 = canvas[2];
                        var ctx2 = c2.getContext('2d');
                        c2.width = geo.width * 2;
                        c2.height = geo.height * 2;
                        ctx2.drawImage(imagecanvas, 0, 0);
                        if (canvas[3]) {
                            var c3 = canvas[3];
                            var ctx3 = c3.getContext('2d');
                            c3.width = geo.width * 2;
                            c3.height = geo.height * 2;
                            ctx3.drawImage(imagecanvas, 0, 0);
                        }
                    }

                    if (!callback) {
                        return;
                    }
                    callback.call(this, '');
                };
            };
        }

        $scope.modeIn = function () {
            changeBlurred(true);
        };
        $scope.modeOut = function () {
            changeBlurred(false);
        };

        function changeBlurred(modeIn) {
            getCurrentImage();
            var imagebox = $scope.currentImage;

            if (modeIn) {
                if (!imagebox.blurred) {
                    return
                }
                // 大图片模式
                imagebox.blurred = false;
                $(".cut-image").show();
            } else {
                if (imagebox.blurred) {
                    return
                }
                // 虚化模式
                imagebox.blurred = true;
                $(".cut-image").hide();
            }

            var styleScale = $scope.currentPage.styleScale;
            imgScale(imagebox, $scope.index, $scope.i, styleScale, styleScale, 0, 0);
        }

        function maskd(canvas, src, maskUrl, x0, y0, width, height, scaleW, scaleH, scale, hasPic, callback) {

            // var imagecanvas = document.createElement('canvas');
            if (canvas.length == 0) {
                return;
            }
            var imagecanvas = canvas[0];
            var imagecontext = imagecanvas.getContext('2d');
            imagecanvas.width = width * 2;
            imagecanvas.height = height * 2;
            imagecontext.scale(2, 2);

            var newImg = document.createElement('img');
            newImg.crossOrigin = "Anonymous";
            newImg.src = src;
            newImg.onload = function () {
                newImg.onload = null;
                newImg.width = width;
                newImg.height = height;
                var masks = document.createElement('img');
                masks.crossOrigin = "Anonymous";
                masks.src = maskUrl;

                masks.onload = function () {
                    masks.width = width;
                    masks.height = height;
                    imagecontext.mozImageSmoothingEnabled = true;
                    imagecontext.webkitImageSmoothingEnabled = true;
                    imagecontext.msImageSmoothingEnabled = true;
                    imagecontext.imageSmoothingEnabled = true;

                    imagecontext.drawImage(masks, 0, 0, width, height);
                    imagecontext.globalCompositeOperation = 'source-in';
                    if (!hasPic) {
                        imagecontext.scale(scaleW, scaleH);
                    }
                    imagecontext.scale(scale, scale);

                    if (!hasPic) {
                        imagecontext.drawImage(newImg, x0, y0);
                    } else {
                        imagecontext.drawImage(newImg, x0, y0, width, height);
                    }

                    if (canvas.length != 1) {
                        var c1 = canvas[1];
                        var ctx1 = c1.getContext('2d');
                        var c2 = canvas[2];
                        var ctx2 = c2.getContext('2d');
                        c1.width = c2.width = width * 2;
                        c1.height = c2.height = height * 2;

                        ctx1.drawImage(imagecanvas, 0, 0);
                        ctx2.drawImage(imagecanvas, 0, 0);
                        if (canvas[3]) {
                            var c3 = canvas[3];
                            var ctx3 = c3.getContext('2d');
                            c3.width = width * 2;
                            c3.height = height * 2;
                            ctx3.drawImage(imagecanvas, 0, 0);
                        }

                    }

                    if (!callback) {
                        return;
                    }
                    callback.call(this, '');


                };
            };
        }

        function isView() {
            if ($scope.status == 'view') {
                return;
            }
        }

        /**
         * 3种返回状态
         * 1： 平铺页面---->产品选择
         * 2： 图片编辑---->作品制作当前页
         * 3： 作品制作页面---->平铺页面
         */
        $scope.backTo = function () {
            // 平铺页面---->产品选择
            if ($scope.status == 'view') {
                swal({
                    title: "当前作品还没有保存，确认要回退么",
                    text: "",
                    imageUrl: Theme.sweetHintImg(),
                    showCancelButton: true,
                    confirmButtonText: "取消",
                    cancelButtonText: "确认",
                    closeOnConfirm: true
                }, function (isConfirm) {
                    if (isConfirm) {
                    } else {
                        if (vm.pid) {
                            $state.go('thumbnail',{storeId:vm.storeId,pid:vm.pid,vid:vm.vid,aid:vm.aid},{location: 'replace'})
                        } else {
                            $state.go('product-view-ec',{storeId:vm.storeId,aid:vm.aid},{location: 'replace'})
                        }
                        window.location.href = url;
                    }
                }, function () {
                });
            }

            getCurrentImage();

            // 图片编辑---->作品制作当前页
            if ($scope.showCut) {
                $scope.showCut = false;
                $scope.showImageMenu = false;
                $scope.showBottomMenu = true;
                $scope.template.pages.page[$scope.index].imageboxes.imagebox = angular.copy($scope.cutPage);
                reviewDoc = $scope.cutPageReview;
                $scope.cutPage = [];
                tipStatus(false);
                $(".edit-head").css({position: 'fixed'});
                return
            }
            // 文字---->作品制作当前页
            if ($scope.showTextModal) {
                $scope.showTextModal = false;
                $scope.showBottomMenu = true;
                tipStatus(false);
                $scope.template.pages.page[$scope.index].textboxes.textbox = angular.copy($scope.textCopy);
                reviewDoc = $scope.textCopyReview;
                $scope.textCopy = [];
                tipStatus(false);
                return
            }

            // 作品制作页面---->平铺页面
            if ($scope.status == 'make') {
                tipStatus(false);
                $scope.showImageMenu = false;
                $scope.showTempMenu = false;
                $scope.isReplaceShow = false;
                $scope.showStickerMenu = false;
                setProductionStorage('view');
                removeSingleStorage();

                if (vm.pid) {
                    reviewDoc = JSON.parse(localStorage.getItem("saveOldPage"));
                    $scope.pageAllPx = JSON.parse(localStorage.getItem("pageAllPx"));
                    $scope.galleryCopy = JSON.parse(localStorage.getItem("galleryCopy"));
                    localStorage.setItem('gallery', JSON.stringify($scope.galleryCopy));
                } else {
                    var isFirstCome = JSON.parse(localStorage.getItem("saveOldPage"));
                    if (!isFirstCome) {
                        setReviewStorage();
                    }
                    reviewDoc = JSON.parse(localStorage.getItem("saveOldPage"));
                    $scope.pageAllPx = JSON.parse(localStorage.getItem("pageAllPx"));
                    $scope.galleryCopy = JSON.parse(localStorage.getItem("galleryCopy"));
                    localStorage.setItem('gallery', JSON.stringify($scope.galleryCopy));
                }


                $ul.css({marginLeft: '0px'});
                $("#small-pic").addClass('hide1');

                backToScrollTop();
                for (var i = 0; i < reviewDoc.page.length; i++) {
                    if (i == $rootScope.currentCarouselIndex) {
                        getPageToPx(reviewDoc.page[i], i, true, false);
                    } else {
                        getPageToPx(reviewDoc.page[i], i, false, false);
                    }
                }

                return;
            }
        };

        function backToScrollTop() {
            // 设置滚动距离
            var viewScrollTop = localStorage.getItem('view-scrollTop') || 0;
            if (!window.__wxjs_is_wkwebview) {
                $('.template-view').css("transform", "translateY(-" + viewScrollTop + "px)");
                setTimeout(function () {
                    $('.template-view').css("transform", "translateY(0px)");
                    $(".edit-page-content")[0].scrollTop = viewScrollTop;
                }, 10);
            } else {
                setTimeout(function () {
                    $(".edit-page-content")[0].scrollTop = viewScrollTop;
                }, 100);
            }

        }

        $scope.isFirstEdit = true;
        if ($scope.status == 'make') {
            $scope.isFirstEdit = false;
        }
        /**
         * 平铺页面点击进入作品制作页
         * @param page  点击页
         * @param index 点击页的下标
         */
        $scope.clickToEdit = function (page, index) {
            $rootScope.currentCarouselIndex = index;

            // if($scope.countN==7&&!vm.guideStep){
            //     return
            // }
            // 当引导页点击“不在提示”以后就不再count++;
            if (!vm.guideStep) {
                $scope.countN++;
                localStorage.setItem('countN', $scope.countN);
            }

            var str = parseInt($('.template-view')[0].style.webkitTransform.replace(/[^0-9]+/g, '') || 0);
            var scrollT = parseInt($(".edit-page-content")[0].scrollTop);

            localStorage.setItem('view-scrollTop', scrollT + str);
            angular.forEach($scope.template.pages.page, function (page, index) {
                angular.forEach(page.imageboxes.imagebox, function (img, i) {
                    var reviewImage = reviewDoc.page[index].imageboxes.imagebox[i];
                    reviewImage.image = angular.copy(img.image);
                    reviewImage.maskUrl = img.maskUrl;
                    if (img.image && img.image.resource && img.image.resource.identifier) {
                        reviewImage.imgUrl = img.imgUrl;
                        reviewImage.blobImage = img.blobImage;
                    }
                })
            });

            setReviewStorage();
            setProductionStorage('make');

            for (var i = 0; i < reviewDoc.page.length; i++) {
                getPageToPx(reviewDoc.page[i], i, false, $scope.isFirstEdit);
            }

            $scope.showBottomMenu = true;
            $scope.showImageMenu = false;

            $ul.css({marginLeft: -($scope.dWidth * 0.94 * index) + 'px'});

            $scope.visibleLeft = $rootScope.currentCarouselIndex ? true : false;
            $scope.visibleRight = $rootScope.currentCarouselIndex + 1 == $scope.template.pages.page.length ? true : false;

            $('.edit-menu-make').addClass('opacity-zero');
            $('.tip-image').removeClass('hide1');

            $scope.isFirstEdit = false;
        };

        /**
         * 切换当前页所使用的模板
         * @param index     点击模板页下标
         * @param page      被点击模板页
         */
        $scope.changeTemp = function (index, page) {
            // 所要展示的page
            var currentInd = $rootScope.currentCarouselIndex;
            // 首页，尾页不交换提示
            if (currentInd == 0 || currentInd == $scope.PAGELEN - 1) {
                $(".text-tip").removeClass('hide1');
                setTimeout(function () {
                    $(".text-tip").addClass('hide1');
                }, 2000);
                return
            }

            var currentPage = angular.copy($scope.template.pages.page[currentInd]);
            // 两个page 相同时不交换
            if (currentPage.uuid == page.uuid) {
                return;
            }

            // 模板选中状态判断条件
            $scope.selectedLi = page.uuid;

            //使用次数+1
            page.count++;

            var pageAllMm = JSON.parse(localStorage.getItem('pageAllMm'));
            var reviewPage = pageAllMm.page[index];
            if (!reviewPage.imagearts) {
                reviewPage.imagearts = {
                    imageart: []
                }
            }
            if (!reviewPage.textboxes) {
                reviewPage.textboxes = {
                    textbox: []
                }
            }

            // 拷贝被点击模板     page不能受影响
            var clickPage = angular.copy(page);

            // 使用次数-1
            for (var i = $scope.pageAllPx.page.length - 1; i >= 0; i--) {
                var element = $scope.pageAllPx.page[i];
                if (reviewDoc.page[currentInd].uuid == element.uuid) {
                    element.count--;
                }
            }

            // 用户添加的"素材"需要留在当前页面
            if (reviewDoc.page[currentInd].imagearts) {
                var imageartR = reviewDoc.page[currentInd].imagearts.imageart;
                var imageartP = $scope.template.pages.page[currentInd].imagearts.imageart;
                for (var i = 0; i < imageartR.length; i++) {
                    if (imageartR[i].type == 'dynamic') {
                        clickPage.imagearts.imageart.push(imageartP[i]);

                        reviewPage.imagearts.imageart.push(imageartR[i]);
                    }
                }
            }

            // 用户添加的"文字"需要留在当前页面
            if (reviewDoc.page[currentInd].textboxes) {
                var textboxR = reviewDoc.page[currentInd].textboxes.textbox;
                var textboxP = $scope.template.pages.page[currentInd].textboxes.textbox;
                for (var j = 0; j < textboxR.length; j++) {
                    if (textboxR[j].type == 'dynamic') {
                        clickPage.textboxes.textbox.push(textboxP[j]);

                        reviewPage.textboxes.textbox.push(textboxR[j]);
                    }
                }
            }

            // 开始交换
            $scope.template.pages.page[currentInd] = angular.copy(clickPage);
            reviewDoc.page[currentInd] = angular.copy(reviewPage);

            $scope.template.pages.page[currentInd].backup = false;
            reviewDoc.page[currentInd].backup = false;

            // 占位框从图片 有---->无 排序
            var arrs = [];
            var currentImages = currentPage.imageboxes.imagebox;
            if (currentImages.length) {
                for (var i = 0; i < currentImages.length; i++) {
                    if (currentImages[i] && currentImages[i].imgUrl && currentImages[i].image) {
                        if (gallery.length && gallery[currentImages[i].image.index]) {
                            gallery[currentImages[i].image.index].useNum == 0 ? 0 : gallery[currentImages[i].image.index].useNum--;
                            // setGalleryStorage();
                        }
                        arrs.push(currentImages[i])
                    }
                }
            }

            var boxes = $scope.template.pages.page[currentInd].imageboxes.imagebox;
            angular.forEach(boxes, function (imagebox, i) {
                if (arrs[i]) {
                    imagebox.imgUrl = arrs[i].imgUrl;
                    imagebox.image = angular.copy(arrs[i].image);

                    reviewDoc.page[currentInd].imageboxes.imagebox[i].imgUrl = angular.copy(arrs[i].imgUrl);
                    reviewDoc.page[currentInd].imageboxes.imagebox[i].image = angular.copy(arrs[i].image);

                    var styleScale = $scope.template.pages.page[currentInd].styleScale;

                    if (vm.store.bokeh) {
                        imagebox.blurred = true;
                        imagebox.blurredRectangle = {
                            x: 0,
                            y: 0,
                            width: imagebox.geometry.width,
                            height: imagebox.geometry.height
                        }
                    }

                    imgScale(imagebox, currentInd, i, styleScale, styleScale, 0, 0);
                    if (imagebox.image && gallery.length && gallery[imagebox.image.index]) {
                        gallery[imagebox.image.index].useNum++;
                    }

                } else {
                    imagebox.imgUrl = null;
                    imagebox.image = null;
                    imagebox.blobImage = null;
                    reviewDoc.page[currentInd].imageboxes.imagebox[i].imgUrl = null;
                    reviewDoc.page[currentInd].imageboxes.imagebox[i].image = null;
                    reviewDoc.page[currentInd].imageboxes.imagebox[i].blobImage = null;

                    // maskScale(imagebox, currentInd, i, imagebox.maskUrl, false);
                    maskScale(imagebox, currentInd, i, imagebox.maskUrl);
                }
            });

            setGalleryStorage();
            singleToRemember();
            localStorage.setItem('reviewPages', JSON.stringify(reviewDoc));
        };

        var moveLaR = function () {
            var page = $scope.template.pages.page[$rootScope.currentCarouselIndex];
            if ((window.orientation == 90 || window.orientation == -90) && vm.flags) {
                $li.removeClass('template-heng').addClass('template-heng2');
                var heights = $scope.dWidth * 0.94 * page.height / page.width - 1;
                $("#slide" + $rootScope.currentCarouselIndex).find(".slide-content").css({'height': heights});
            }
            $li.removeClass('template-heng3');
            tipStatus(false);
            $(".change-btn").hide();
            mL = Math.abs(parseFloat($ul.css('marginLeft')));
            liW = parseFloat($li.css('width'));
            ulW = liW * $scope.PAGELEN;

            $scope.showBottomMenu = true;
            $scope.showImageMenu = false;
        };

        /**
         * 左移按钮
         */
        $scope.pageLeft = function () {
            moveLaR();
            $scope.visibleRight = false;
            if (mL <= liW + 10) {
                $scope.visibleLeft = false;
            }
            var index = $rootScope.currentCarouselIndex;
            $rootScope.currentCarouselIndex--;

            $ul.css({opacity: 0}).removeClass('fade-out').removeClass('is-paused');
            $ul.css({marginLeft: -(mL - liW) + 'px'});
            setTimeout(function () {
                $ul.addClass('is-paused').addClass('fade-out').css({opacity: 1});
            }, 700);

            setReviewStorage();
            setGalleryStorage();
            localStorage.setItem("marginLeft", $scope.dWidth * 0.94 * $rootScope.currentCarouselIndex);

            getPageToPx(reviewDoc.page[index], index, true, false);

        };

        /**
         * 右移按钮
         */
        $scope.pageRight = function () {
            moveLaR();
            $scope.visibleLeft = true;
            if (runR) {
                if (mL + liW >= ulW - liW - 10) {
                    $scope.visibleRight = true;
                }
                var index = $rootScope.currentCarouselIndex;
                $rootScope.currentCarouselIndex++;

                $ul.css({opacity: 0}).removeClass('fade-out').removeClass('is-paused');
                $ul.css({marginLeft: -(mL + liW) + 'px'});
                setTimeout(function () {
                    runR = true;
                    $ul.addClass('is-paused').addClass('fade-out').css({opacity: 1});
                }, 700);
                setReviewStorage();
                setGalleryStorage();

                localStorage.setItem("marginLeft", $scope.dWidth * 0.94 * $rootScope.currentCarouselIndex);

                getPageToPx(reviewDoc.page[index], index, true, false);

            }
            runR = false;
        };

        // 旋转屏幕
        window.addEventListener('orientationchange', function () {
            setTimeout(function () {
                $(".save-page").addClass('hide1');
                if (window.orientation == 180 || window.orientation == 0) {
                    //竖屏
                    $(".page-orientation").addClass('hide1');
                    if ($scope.isSave) {
                        return
                    }
                    orientationChange(false);
                    if (vm.isOrientation) {

                        for (var i = 0; i < reviewDoc.page.length; i++) {
                            getPageToPx(reviewDoc.page[i], i, true, true);
                        }


                        vm.isOrientation = false;
                        return
                    }

                    var mar = ($scope.dWidth * 0.94 - $li.width()) / 2;
                    $li.css({'margin-left': mar}).removeClass('mar-top-0');
                } else if (window.orientation == 90 || window.orientation == -90) {
                    //横屏
                    $(".page-orientation").removeClass('hide1');
                    if ($scope.isSave) {
                        return
                    }
                    orientationChange(true);
                    var mar = ($scope.dWidth * 0.94 - $li.width()) / 2;
                    $li.css({'margin-left': mar}).addClass('mar-top-0');
                }
            }, 500);
        });

        if (window.orientation == 90 || window.orientation == -90) {
            $(".page-orientation").removeClass('hide1');
            vm.flags = false;
            vm.isOrientation = true;
            $(document.body).addClass('bgColor');
        }

        function orientationChange(flag) {
            vm.flags = flag;
            $scope.dHeight = document.documentElement.clientHeight;
            $scope.dWidth = document.documentElement.clientWidth;
            $(document.body).toggleClass('bgColor');

            $("body").css({width: $scope.dWidth, 'min-width': $scope.dWidth});      //设置页面的最小宽度
            localStorage.setItem("marginLeft", $scope.dWidth * 0.94 * $rootScope.currentCarouselIndex);
        }

        /**
         * 放大缩小及删除
         */
        function changeImgOffset(zoomIn) {
            getCurrentImage();
            var imagebox = $scope.currentImage.image;

            var number = 1.2;
            if (zoomIn) {
                imagebox.scale = imagebox.scale ? imagebox.scale * number : number;
            } else {
                if (imagebox.scale == 1) {
                    return;
                }
                imagebox.scale = imagebox.scale / number;
            }

            imagebox.offsetX = 0;
            imagebox.offsetY = 0;
            $("#cut-img").css({left: imgX, top: imgY});

            $scope.moveImg = {
                width: $("#cut-opacity").width(),
                height: $("#cut-opacity").height(),
                angle: imagebox.angle
            };

            getDpi($scope.currentImage, $scope.index, $scope.i);

        }

        function getCurrentImage() {
            $scope.index = $rootScope.currentCarouselIndex || 0;
            $scope.i = $scope.template.pages.page[$scope.index].selectImgIndex;
            $scope.imgs = document.getElementById("imgInput" + $scope.index + '' + $scope.i);
            $scope.imgReals = $(".imgBox" + $scope.index + '' + $scope.i); //document.getElementById("imgInputReal" + $scope.index + '' + $scope.i);
            $scope.currentPage = $scope.template.pages.page[$scope.index];
            $scope.currentImage = $scope.currentPage.imageboxes.imagebox[$scope.i];
            $scope.currentText = $scope.currentPage.textboxes.textbox;
            // $scope.reviewPage = reviewDoc.page[$scope.index];
            // $scope.reviewImage = $scope.reviewPage.imageboxes.imagebox[$scope.i];
        }

        var boxW = 0, boxH = 0, picW = 0, picH = 0, scale = 0;

        function getDpi(box, index, i) {
            boxW = box.widthM;
            boxH = box.heightM;
            picW = box.image.width * 2.5;
            picH = box.image.height * 2.5;
            scale = box.image.scale;
            var x = 0, y = 0;
            // 宽度适配
            if (box.adaptationW) {
                x = picW / (boxW / 25.4) / scale;
                y = boxH * picW / boxW / (boxH / 25.4) / scale;
            } else {
                x = boxW * picH / boxH / (boxW / 25.4) / scale;
                y = picH / (boxH / 25.4) / scale;
            }
            if (x < 150 || y < 150) {
                box.image.lowSize = true;
            } else {
                box.image.lowSize = false;
            }
            reviewDoc.page[index].imageboxes.imagebox[i].image = angular.copy(box.image);
        }

        $scope.zoomIn = function () {
            changeImgOffset(true);
        };

        $scope.zoomOut = function () {
            changeImgOffset(false);
        };

        var imgX = parseFloat($(".cut-position").css('left'));
        var imgY = parseFloat($(".cut-position").css('top'));
        /**
         * 进入图片编辑模式
         */
        $scope.cutImage = function () {
            getCurrentImage();
            $scope.showCut = true;
            $scope.showImageMenu = false;
            var box = $scope.currentImage;

            var ww = angular.copy(box.geometry.width);
            var hh = angular.copy(box.geometry.height);
            $scope.cutPage = angular.copy($scope.currentPage.imageboxes.imagebox);
            $scope.cutPageReview = angular.copy(reviewDoc);
            var s = box.maskUrl;

            if (ww > hh) {
                ww = $scope.dWidth * 0.8;
                hh = ww / box.geometry.width * box.geometry.height;
            } else {
                hh = ($scope.dHeight - 50) * 0.8;
                ww = hh / box.geometry.height * box.geometry.width;
            }
            if (ww > $scope.dWidth * 0.8) {
                ww = $scope.dWidth * 0.8;
                hh = ww / box.geometry.width * box.geometry.height;
            }
            if (hh > ($scope.dHeight - 50) * 0.8) {
                hh = ($scope.dHeight - 50) * 0.8;
                ww = hh / box.geometry.height * box.geometry.width;
            }

            var imageArr = getImageScale(box.image, box.geometry);

            if (box.adaptationW) {
                $scope.wOpacity = ww;
                $scope.hOpacity = '';
            } else {
                $scope.hOpacity = hh;
                $scope.wOpacity = '';
            }

            if (box.image.angle == 90 || box.image.angle == 270) {
                if (imageArr.isWidth) {
                    $scope.w = ww;
                    $scope.h = '';
                } else {
                    $scope.h = hh;
                    $scope.w = '';
                }
            } else {
                if (box.adaptationW) {
                    $scope.w = ww;
                    $scope.h = '';
                } else {
                    $scope.h = hh;
                    $scope.w = '';
                }
            }

            $scope.moveGeo = {
                width: ww,
                height: hh,
                scale: ww / box.geometry.width
            };
            imgX = ($scope.dWidth - ww) / 2;

            $scope.t = imgY;
            $scope.l = imgX;

            ImageService.convertImgToBase64(s, function (s) {
                var imagecanvas = document.createElement('canvas');
                var imagecontext = imagecanvas.getContext('2d');
                // var img = document.createElement('img');
                // img.crossOrigin = "Anonymous";
                // img.src = 'content/images/zhezhao1.png';
                var newImg = document.createElement('img');
                newImg.crossOrigin = "Anonymous";
                newImg.src = 'content/images/zhezhao1.png';
                newImg.onload = function () {
                    newImg.onload = null;
                    var masks = document.createElement('img');
                    masks.src = s;
                    masks.crossOrigin = "anonymous";
                    masks.onload = function () {
                        masks.onload = null;
                        imagecanvas.width = $scope.dWidth;
                        imagecanvas.height = $scope.dHeight - 50;
                        imagecontext.drawImage(masks, $scope.l, $scope.t, ww, hh);
                        imagecontext.globalCompositeOperation = 'source-out';
                        imagecontext.drawImage(newImg, 0, 0, $scope.dWidth, $scope.dHeight - 50);
                        $("#cut-mask").attr('src', imagecanvas.toDataURL());
                        $scope.imgW = ww;
                        $scope.imgH = hh;
                        $scope.moveImg = {
                            width: $("#cut-opacity").width(),
                            height: $("#cut-opacity").height(),
                            angle: box.image.angle
                        };

                        var coordX = box.image.offsetX * box.image.scale * box.image.scaleW * $scope.moveGeo.scale;
                        var coordY = box.image.offsetY * box.image.scale * box.image.scaleH * $scope.moveGeo.scale;
                        $("#cut-img").css({left: coordX + imgX, top: coordY + imgY});

                        $scope.$digest();
                    };
                    masks.src = s;
                };
                newImg.src = 'content/images/zhezhao1.png';
            })
        };

        /**
         * 拖拽编辑的图片
         */
        window.startEdit = function (e) {
            fn(e);
            var box = $scope.currentImage;
            selectImgBoxes($scope.i);
            $scope.imageArr = getImageScale($scope.moveImg, $scope.moveGeo);
            dragBox.clientX = e.changedTouches[0].clientX ? e.changedTouches[0].clientX : 0;
            dragBox.clientY = e.changedTouches[0].clientY ? e.changedTouches[0].clientY : 0;
            dragBox.coordX = box.image.offsetX * box.image.scaleW * box.image.scale * $scope.moveGeo.scale * $scope.imageArr.scaleW;
            dragBox.coordY = box.image.offsetY * box.image.scaleH * box.image.scale * $scope.moveGeo.scale * $scope.imageArr.scaleH;
            drag = true;
        };

        window.dragEdit = function (e) {
            getCurrentImage();
            var box = $scope.currentImage;

            //乘以放大缩小倍数后的宽高
            var orignW = $scope.imageArr.nWidth * box.image.scale;
            var orignH = $scope.imageArr.nHeight * box.image.scale;
            var isWidth = $scope.imageArr.isWidth;
            if (drag) {
                var x = 0, y = 0;
                //手指离开屏幕
                if (!isWidth && box.image.scale == 1) {    //宽图
                    x = (dragBox.coordX + (e.changedTouches[0].clientX - dragBox.clientX)) / $scope.imageArr.scaleW;
                } else if (isWidth && box.image.scale == 1) {     //高图
                    y = (dragBox.coordY + (e.changedTouches[0].clientY - dragBox.clientY)) / $scope.imageArr.scaleH;
                } else if (box.image.scale > 1) {
                    x = (dragBox.coordX + (e.changedTouches[0].clientX - dragBox.clientX)) / $scope.imageArr.scaleW;
                    y = (dragBox.coordY + (e.changedTouches[0].clientY - dragBox.clientY)) / $scope.imageArr.scaleH;
                }

                //向上滑动;
                if (-y >= (orignH - $scope.moveGeo.height)) {
                    y = -(orignH - $scope.moveGeo.height);
                }
                //向左滑动;        <-----
                if (-x >= (orignW - ($scope.moveGeo.width))) {
                    x = -(orignW - ($scope.moveGeo.width));
                }
                //向下滑动;
                if (y >= 0) {
                    y = 0;
                }
                // 向右滑动;    ---->
                if (x >= 0) {
                    x = 0;
                }

                var img = box.imgUrl + '?imageMogr2/exifModify/eyJPcmllbnRhdGlvbiI6IjEifQ==/rotate/' + box.image.angle + '/thumbnail/!40p';

                $("#cut-img").css({left: x + imgX, top: y + imgY});


                box.image.offsetX = x / box.image.scale / $scope.moveGeo.scale / box.image.scaleW;
                box.image.offsetY = y / box.image.scale / $scope.moveGeo.scale / box.image.scaleH;

                $scope.$digest();
                e.stopPropagation();
                e.preventDefault();
                return false;

            }

        };

        window.stopEdit = function () {
            drag = false;
            dragBox = {};
            $rootScope.template = $scope.template;
        };

        /**
         * 保存所编辑过的图片
         */
        $scope.saveMove = function () {
            getCurrentImage();
            var box = $scope.currentImage;
            $scope.showImageMenu = false;
            $scope.showBottomMenu = true;

            var imageArr = getImageScale(box.image, box.geometry);
            box.image.scaleW = imageArr.scaleW;
            box.image.scaleH = imageArr.scaleH;
            tipStatus(false);

            var reviewPage = reviewDoc.page[$scope.index].imageboxes.imagebox[$scope.i];
            reviewPage.image = angular.copy(box.image);

            var img = box.imgUrl + '?imageMogr2/exifModify/eyJPcmllbnRhdGlvbiI6IjEifQ==/rotate/' + box.image.angle + '/thumbnail/!40p';

            maskd($scope.imgReals, img, box.maskUrl, box.image.offsetX, box.image.offsetY, box.geometry.width, box.geometry.height, box.image.scaleW, box.image.scaleH, box.image.scale, false, function (src) {
                box.blobImage = true;
                reviewPage.blobImage = true;
                $scope.showCut = false;
                singleToRemember();
                $scope.$digest();
            });
        };

        /**
         * 选择图片
         * @param flag   true: 逆时针旋转    false： 顺时针旋转
         */
        $scope.rotateImage = function (flag) {
            var box = $scope.currentImage;
            if (flag) {
                box.image.angle -= 90;
                if (box.image.angle == -90) {
                    box.image.angle = 270
                }
            } else {
                box.image.angle += 90;
                if (Math.abs(box.image.angle) == 360) {
                    box.image.angle = 0
                }
            }
            $scope.moveImg.angle = box.image.angle;
            $scope.imageArr = getImageScale($scope.moveImg, $scope.moveGeo);

            var imageEdit = getImageScale(box.image, box.geometry);

            box.image.scaleW = imageEdit.scaleW;
            box.image.scaleH = imageEdit.scaleH;

            if (imageEdit.isWidth) {
                $scope.w = $scope.imageArr.nWidth;
                $scope.h = '';
            } else {
                $scope.h = $scope.imageArr.nHeight;
                $scope.w = '';
            }

            box.image.offsetX = 0;
            box.image.offsetY = 0;

            $("#cut-img").css({left: imgX, top: imgY});

            $scope.moveImg = {
                width: $("#cut-opacity").width(),
                height: $("#cut-opacity").height(),
                angle: box.image.angle
            }
        };

        /**
         * 显示图片选择栏
         * @param $event
         */
        $scope.changeImage = function ($event) {
            if ($event) {
                $event.stopPropagation();
            }
            $scope.showImageMenu = !$scope.showImageMenu;
            $scope.showBottomMenu = false;
            $scope.showTempMenu = false;

            $scope.galleryList = JSON.parse(localStorage.getItem('gallery'));

            if (!$scope.galleryList) {
                return
            }
            setImageWidth();
        };

        function setImageWidth() {
            if (!$scope.galleryList) {
                return
            }
            var w = 0;
            var len = $scope.galleryList.length;
            for (var i = 0; i < len; i++) {
                //84+10
                w += 94;
            }
            setTimeout(function () {
                $(".image-ul").width(w + 'px');
            })
        }

        $scope.addGallery = function () {
            getCurrentImage();
            $rootScope.template = $scope.template;

            localStorage.setItem('reviewPages', JSON.stringify(reviewDoc));
            localStorage.setItem('pageAllPx', JSON.stringify($scope.pageAllPx));
            goToChoose($scope.index, $scope.i);
            localStorage.setItem('article-count', vm.counts)
        };

        var dragGal = {};
        window.startChange = function (e) {
            getCurrentImage();

            drag = true;
            $(".image-ul-mask").addClass('hide1');

            var i = e.target.dataset.imgindex;
            $scope.galleryArr = $scope.galleryList[i];
            $scope.galleryChoose = $scope.galleryList[i].identifier;

            $scope.galleryId = i;
            $scope.galleryX = e.changedTouches[0].clientX ? e.changedTouches[0].clientX - 30 : 0;
            $scope.galleryY = e.changedTouches[0].clientY ? e.changedTouches[0].clientY - 30 : 0;
            dragGal.clientX = e.changedTouches[0].clientX ? e.changedTouches[0].clientX : 0;
            dragGal.clientY = e.changedTouches[0].clientY ? e.changedTouches[0].clientY : 0;
            dragGal.pageX = e.changedTouches[0].pageX ? e.changedTouches[0].pageX : 0;
            dragGal.pageY = e.changedTouches[0].pageY ? e.changedTouches[0].pageY : 0;
            dragGal.coordX = $scope.galleryX;
            dragGal.coordY = $scope.galleryY;
            $scope.$digest();
            return false;
        };

        window.dragChange = function (e) {
            if (drag) {
                getCurrentImage();

                //手指离开屏幕
                $scope.galleryX = (dragGal.coordX + (e.changedTouches[0].clientX - dragGal.clientX));
                $scope.galleryY = (dragGal.coordY + (e.changedTouches[0].clientY - dragGal.clientY));

                if (Math.abs($scope.galleryY - dragGal.coordY) > 10) {
                    $("#small-pic").removeClass('hide1');
                }

                //向上滑动;
                if ($scope.galleryY <= 0) {
                    $scope.galleryY = 0;
                }
                //向左滑动;        <-----
                if ($scope.galleryX <= 0) {
                    $scope.galleryX = 0;
                }
                //向下滑动;
                if ($scope.galleryY >= $scope.dHeight - 62) {
                    $scope.galleryY = $scope.dHeight - 62;
                }
                // 向右滑动;    ---->
                if ($scope.galleryX >= $scope.dWidth - 62) {
                    $scope.galleryX = $scope.dWidth - 62;
                }
                $scope.$digest();
                return false;
            }
        };

        window.stopChange = function (e) {
            $("#small-pic").addClass('hide1');
            if (!drag) {
                return
            }
            drag = false;
            var image = $scope.currentPage.imageboxes.imagebox;
            var pageL = parseFloat($(".template-carousel").css('left')) + parseFloat($("#slide-li" + $scope.index).css('margin-left'));
            var pageT = parseFloat($(".template-carousel").css('margin-top')) + 112;

            for (var i = 0; i < image.length; i++) {
                var geo = image[i].geometry;
                if ($scope.galleryX > (pageL + geo.x) && $scope.galleryX < (pageL + geo.x + geo.width)) {
                    if ($scope.galleryY > (pageT + geo.y) && $scope.galleryY < (pageT + geo.y + geo.height)) {
                        if (image[i].mask.resource.identifier) {
                            image[i].maskUrl = $scope.domain + image[i].mask.resource.identifier;
                        } else {
                            image[i].maskUrl = 'content/images/timg.jpg';
                        }
                        if ($scope.galleryChoose) {       //qiniu
                            if (!image[i].image) {
                                image[i].image = {
                                    resource: {
                                        identifier: $scope.galleryChoose,
                                        provider: 'qiniu'
                                    },
                                    filterResource: {
                                        identifier: '',
                                        provider: 'qiniu'
                                    },
                                    rotation: {
                                        angle: 0
                                    },
                                    parameter: angular.fromJson($scope.galleryArr.parameter) || [],
                                    filter: '',
                                    offsetX: 0,
                                    offsetY: 0,
                                    angle: 0,
                                    scale: 1,
                                    scaleW: 1,
                                    scaleH: 1,
                                    width: $scope.galleryArr.width,
                                    height: $scope.galleryArr.height,
                                    imgSize: $scope.galleryArr.imgSize
                                }
                            }
                            if (vm.store.bokeh) {
                                image[i].blurred = true;
                                image[i].blurredRectangle = {
                                    x: 0,
                                    y: 0,
                                    width: image[i].geometry.width,
                                    height: image[i].geometry.height
                                }
                            }

                            image[i].imgUrl = $scope.domain + $scope.galleryChoose;
                            image[i].image.resource.identifier = $scope.galleryChoose;
                            image[i].image.imgSize = $scope.galleryArr.imgSize;
                            image[i].image.parameter = angular.fromJson($scope.galleryArr.parameter);

                            var styleScale = $scope.currentPage.styleScale;
                            imgScale(image[i], $scope.index, i, styleScale, styleScale, 0, 0);

                            if (image[i].blurred) {
                                $(".cut-image").hide();
                                $(".mode1,.mode2").removeClass('hide1');
                            } else {
                                $(".cut-image").show();
                            }
                            if (image.length < 2) {
                                $(".change").hide();
                            } else {
                                $(".change").show();
                            }
                        }
                        if ($scope.galleryList.length) {
                            var resourceId = image[i].image.resourceId;
                            if (image[i].image) {
                                for (var j = 0; j < $scope.galleryList.length; j++) {
                                    var arr = $scope.galleryList[j];
                                    if (arr.id == resourceId) {
                                        arr.useNum == 0 ? 0 : arr.useNum--;
                                    }
                                }
                            }

                            $scope.galleryArr.useNum += 1;
                            gallery = $scope.galleryList;
                            image[i].image.index = $scope.galleryId;
                            image[i].image.resourceId = $scope.galleryArr.id;
                            reviewDoc.page[$scope.index].imageboxes.imagebox[i].image = angular.copy(image[i].image);
                            setGalleryStorage();
                        }
                    }
                }


            }
        };

        // 点击显示 占位框中的 切换按钮
        $scope.isReplaceShow = true;
        $scope.replaceImage = function () {
            var index = $rootScope.currentCarouselIndex || 0;
            var i = $scope.template.pages.page[index].selectImgIndex || 0;
            if ($scope.isReplaceShow) {
                $(".change-btn").show();
            } else {
                $(".change-btn").hide();
            }
            $("#change-btn" + index + '' + i).hide();
            $scope.isReplaceShow = !$scope.isReplaceShow;
        };

        // 切换占位框图片
        $scope.changeMaskImage = function (index, i) {
            var index0 = $rootScope.currentCarouselIndex || 0;
            var i0 = $scope.template.pages.page[index].selectImgIndex || 0;

            // 需要切换的占位框
            var box0 = $scope.template.pages.page[index0].imageboxes.imagebox[i0];

            // 被切换的占位框
            var box = $scope.template.pages.page[index].imageboxes.imagebox[i];

            var maskWidth0 = box0.geometry.width;
            var maskHight0 = box0.geometry.height;

            var maskWidth = box.geometry.width;
            var maskHight = box.geometry.height;

            var w0 = box0.image.width;
            var h0 = box0.image.height;

            var w = box.image.width;
            var h = box.image.height;

            getValue(box, w, h, maskWidth0, maskHight0, index0, i0, box0, false, index, i);
            getValue(box0, w0, h0, maskWidth, maskHight, index, i, box, true, index0, i0);

        };

        function getValue(box, w, h, maskWidth, maskHight, index, id, box0, flag, originIndex, originI) {
            var imageW = box.image.width;
            var imageH = box.image.height;
            var scaleW = 1, scaleH = 1;

            if ((box.image.width <= box.image.height || maskWidth <= maskHight) && (box.image.width / box.image.height < maskWidth / maskHight) || box.image.width >= box.image.height && maskWidth >= maskHight && (box.image.width / box.image.height < maskWidth / maskHight)) {
                imageW = maskWidth;
                imageH = maskWidth * h / w;
                if (box0.blurred) {
                    box0.blurredRectangle.height = box0.geometry.height;
                    box0.blurredRectangle.width = box0.geometry.height * w / h;
                    box0.blurredRectangle.x = (box0.geometry.width - box0.blurredRectangle.width) / 2;
                    box0.blurredRectangle.y = 0;
                }

            } else {
                imageH = maskHight;
                imageW = maskHight * w / h;
                if (box0.blurred) {
                    box0.blurredRectangle.width = box0.geometry.width;
                    box0.blurredRectangle.height = box0.geometry.width * h / w;
                    box0.blurredRectangle.y = (box0.geometry.height - box0.blurredRectangle.height) / 2;
                    box0.blurredRectangle.x = 0;
                }
            }

            scaleW = imageW / w;
            scaleH = imageH / h;

            box0.image.offsetX = 0;
            box0.image.offsetY = 0;

            var img = box.imgUrl + '?imageMogr2/exifModify/eyJPcmllbnRhdGlvbiI6IjEifQ==/rotate/' + box.image.angle + '/thumbnail/!40p';

            if (box0.blurred) {
                maskd3($(".imgBoxSmall" + index + '' + id), img, box0);
                img = img + '/blur/40x1000';
            }

            maskd($(".imgBox" + index + '' + id), img, box0.maskUrl, 0, 0, maskWidth, maskHight, scaleW, scaleH, box.image.scale, false, function (src) {
                box0.blobImage = true;
                reviewDoc.page[index].imageboxes.imagebox[id].blobImage = true;

                if (flag) {
                    var arr = angular.copy(box0.image);
                    box0.image = angular.copy(box.image);
                    box.image = angular.copy(arr);
                    var image = box0.imgUrl;
                    box0.imgUrl = box.imgUrl;
                    box.imgUrl = image;

                    $(".change-btn").hide();
                    tipStatus(false);
                    var reviewArr = angular.copy(reviewDoc.page[index].imageboxes.imagebox[id].image);
                    reviewDoc.page[index].imageboxes.imagebox[id].image = angular.copy(reviewDoc.page[originIndex].imageboxes.imagebox[originI].image);
                    reviewDoc.page[originIndex].imageboxes.imagebox[originI].image = angular.copy(reviewArr);
                    singleToRemember();
                }

                $scope.$digest();

            });
        }

        //这块是图片中需要上传的区域
        $scope.chooseImage = function ($index, i) {
            $scope.template.pages.page[$index].selectImgIndex = i;

            $(".change,.cut-image").hide();
            $(".mode1,.mode2").addClass('hide1');

            tipStatus(true);
            $scope.showBottomMenu = false;
            $scope.showImageMenu = !$scope.showImageMenu;

            $scope.galleryList = JSON.parse(localStorage.getItem('gallery'));

            if (!$scope.galleryList) {
                return
            }
            setImageWidth();

        };

        function goToChoose($index, i) {
            localStorage.setItem("index", $index);
            localStorage.setItem("marginLeft", $scope.dWidth * 0.94 * $index);
            localStorage.setItem("i", i);
            localStorage.setItem("choose", 'choose');
            localStorage.setItem("Production", "start");
            localStorage.setItem('pages', JSON.stringify(reviewDoc));
            if (vm.pid) {
                $state.go('product.choose', {storeId: vm.storeId, pid: vm.pid, vid: vm.vid}, {reload: true,location: 'replace'});
            } else {
                $state.go('product.chooses', {storeId: vm.storeId, aid: vm.aid}, {reload: true,location: 'replace'});
            }
        }

        var selectImgBoxes = function ($index) {
            var index = $rootScope.currentCarouselIndex || 0;
            $scope.template.pages.page[index].selectImgIndex = $index;
        };
        var getCurrentPage = function (index) {
            if (typeof index == 'undefined') {
                index = getPageIndex();
            }
            return $scope.template.pages.page[index];
        };

        var getPageIndex = function () {
            return $rootScope.currentCarouselIndex || 0
        };

        /**
         * 拖拽图片
         */
        window.startDrag = function (e) {
            isView();
            fn(e);
            var index = getPageIndex();
            var i = e.target.dataset.imgindex;
            var box = $scope.template.pages.page[index].imageboxes.imagebox[i];
            selectImgBoxes(i);
            var targ = e.target ? e.target : e.srcElement;
            dragBox.clientX = e.changedTouches[0].clientX ? e.changedTouches[0].clientX : 0;
            dragBox.clientY = e.changedTouches[0].clientY ? e.changedTouches[0].clientY : 0;
            dragBox.coordX = parseInt(targ.style.left) - parseFloat(box.image.offsetX) * box.image.scaleW;
            dragBox.coordY = parseInt(targ.style.top) - parseFloat(box.image.offsetY) * box.image.scaleH;
            dragBox.offsetX = box.image.offsetX;
            dragBox.offsetY = box.image.offsetY;
            dragBox.imageArr = getImageScale(box.image, box.geometry);
            drag = true;
            dragBox.imagecanvas = document.createElement('canvas');
            dragBox.imagecontext = dragBox.imagecanvas.getContext('2d');
        };

        window.dragImage = function (e) {
            getCurrentImage();
            var box = $scope.currentImage;

            if ($scope.template.pages.page[$scope.index].selectImgIndex != e.target.dataset.imgindex) {
                return;
            }
            if (box.blurred) {
                return
            }

            flag = false;

            var orignW = dragBox.imageArr.nWidth;
            var orignH = dragBox.imageArr.nHeight;
            box.image.scaleW = dragBox.imageArr.scaleW;
            box.image.scaleH = dragBox.imageArr.scaleH;
            var isWidth = dragBox.imageArr.isWidth;
            if (drag) {
                //手指离开屏幕
                if (!isWidth && box.image.scale == 1) {    //宽图
                    box.image.offsetX = (box.geometry.x - dragBox.coordX + (e.changedTouches[0].clientX - dragBox.clientX)) / box.image.scaleW;
                } else if (isWidth && box.image.scale == 1) {     //高图
                    box.image.offsetY = (box.geometry.y - dragBox.coordY + (e.changedTouches[0].clientY - dragBox.clientY)) / box.image.scaleH;
                } else if (box.image.scale > 1) {
                    box.image.offsetX = (box.geometry.x - dragBox.coordX + (e.changedTouches[0].clientX - dragBox.clientX)) / box.image.scaleW;
                    box.image.offsetY = (box.geometry.y - dragBox.coordY + (e.changedTouches[0].clientY - dragBox.clientY)) / box.image.scaleH;
                }
                //向上滑动;
                if (-box.image.offsetY >= (orignH * box.image.scale - box.geometry.height) / box.image.scale / box.image.scaleH) {
                    box.image.offsetY = -(orignH * box.image.scale - box.geometry.height) / box.image.scale / box.image.scaleH;
                }
                //向左滑动;        <-----
                if (-box.image.offsetX >= (orignW * box.image.scale - box.geometry.width) / box.image.scale / box.image.scaleW) {
                    box.image.offsetX = -((orignW * box.image.scale - box.geometry.width) / box.image.scale / box.image.scaleW);
                }
                //向下滑动;
                if (box.image.offsetY >= 0) {
                    box.image.offsetY = 0;
                }
                // 向右滑动;    ---->
                if (box.image.offsetX >= 0) {
                    box.image.offsetX = 0;
                }

                var img = box.imgUrl + '?imageMogr2/exifModify/eyJPcmllbnRhdGlvbiI6IjEifQ==/rotate/' + box.image.angle + '/thumbnail/!40p';
                // $(".imgBox" + index + '' + id)[0]

                maskd2($("#imgInputReal" + e.target.id.replace("imgInput", "") + 'Make')[0], img, box.maskUrl, box.image.offsetX, box.image.offsetY, box.geometry.width, box.geometry.height, box.image.scaleW, box.image.scaleH, box.image.scale, function (src) {
                    box.blobImage = true;
                    reviewDoc.page[$scope.index].imageboxes.imagebox[$scope.i].blobImage = true;
                });

                $scope.$digest();
                e.stopPropagation();
                e.preventDefault();
                return false;
            }
        };

        window.stopDrag = function () {
            getCurrentImage();
            var box = $scope.currentImage;
            dragBox.imagecanvas = null;
            drag = false;
            var imageLen = $scope.template.pages.page[$scope.index].imageboxes.imagebox.length;
            /**
             * 选中图片框   点击照片出现操作按钮
             */
            if (Math.abs(dragBox.offsetX - box.image.offsetX) <= 6 && Math.abs(dragBox.offsetY - box.image.offsetY) <= 6) {
                selectImgBoxes($scope.i);

                tipStatus(true);

                if (vm.store.bokeh) {
                    $(".mode1,.mode2").removeClass('hide1');
                } else {
                    $(".mode1,.mode2").addClass('hide1');
                }

                if (box.blurred) {
                    $(".cut-image").hide();
                } else {
                    if (box.image && box.image.resource.identifier) {
                        $(".cut-image").show();
                    }
                }


                $(".change-btn").hide();
                $scope.isReplaceShow = true;
                if (imageLen < 2) {
                    $(".change").hide();
                } else {
                    $(".change").show();
                }

                $scope.showImageMenu = !$scope.showImageMenu;
                $scope.showStickerMenu = false;
                if ($scope.showImageMenu) {
                    $scope.showBottomMenu = false;
                } else {
                    $scope.showBottomMenu = true;
                }
                $scope.showTempMenu = false;
                $scope.galleryList = JSON.parse(localStorage.getItem('gallery'));


                setImageWidth();
                $scope.$digest();

            } else {
                flag = true;
            }
            $rootScope.template = $scope.template;
            var reviewPage = reviewDoc.page[$scope.index].imageboxes.imagebox[$scope.i];
            reviewPage.image = angular.copy(box.image);

            singleToRemember();
            dragBox = {};
        };
        function maskd2(imagecanvas, src, maskUrl, x0, y0, width, height, scaleW, scaleH, scale, callback) {
            var imagecontext = imagecanvas.getContext('2d');
            var newImg = document.createElement('img');
            newImg.crossOrigin = "Anonymous";
            newImg.src = src;
            newImg.onload = function () {
                newImg.onload = null;
                newImg.width = width;
                newImg.height = height;
                var masks = document.createElement('img');
                masks.crossOrigin = "Anonymous";
                masks.src = maskUrl;

                masks.onload = function () {
                    masks.width = width;
                    masks.height = height;
                    imagecanvas.width = width;
                    imagecanvas.height = height;
                    imagecontext.mozImageSmoothingEnabled = true;
                    imagecontext.webkitImageSmoothingEnabled = true;
                    imagecontext.msImageSmoothingEnabled = true;
                    imagecontext.imageSmoothingEnabled = true;

                    imagecontext.drawImage(masks, 0, 0, width, height);
                    imagecontext.globalCompositeOperation = 'source-in';

                    imagecontext.scale(scaleW, scaleH);

                    imagecontext.scale(scale, scale);
                    imagecontext.drawImage(newImg, x0, y0);


                    var pic = '';
                    // var pic = ImageService.dataURLtoBlob(imagecanvas.toDataURL());
                    // if (imgs) {
                    //     imgs.src = pic;
                    // }
                    // imgs.src = ImageService.dataURLtoBlob(imagecanvas.toDataURL());
                    if (!callback) {
                        return;
                    }
                    callback.call(this, pic);


                };
            };
        }

        /*******************************************贴纸功能****************************start*********************************************/
        /**
         * 获取贴纸列表
         */
        function getStickerList() {
            ClipArt.getAllByCondition({
                items: [{key: "type", op: "=", value: "wechat"}, {
                    key: "themeClassify.id",
                    op: "=",
                    value: vm.article.themeClassifyId
                }],
                sort: ["id,asc"]
            }, function (resp) {
                if(resp.status == 200){
                    angular.forEach(resp.data, function (obj, i) {
                        if (!obj.cancelled) {
                            if (obj.provider == 'qiniu') {
                                $scope.stickerList.push({
                                    name: obj.name,
                                    identifier: obj.identifier,
                                    provider: obj.provider,
                                    imgUrl: $scope.domain + obj.identifier
                                })
                            }
                        }
                    });
                }else {
                    MessageService.error(resp.message);
                }
            });
        }

        /**
         * 切换贴纸菜单
         */
        $scope.toggleStickerMenu = function ($event) {
            if ($event) {
                $event.stopPropagation();
            }
            $scope.showStickerMenu = !$scope.showStickerMenu;
            $scope.showBottomMenu = !$scope.showBottomMenu;
            if ($scope.showStickerMenu) {
                $scope.showTextMenu = false;
            }
        };

        /**
         * 显示模板
         */
        $scope.toggleTempMenu = function ($event) {
            if ($event) {
                $event.stopPropagation();
            }
            $scope.showTempMenu = !$scope.showTempMenu;
            $scope.showBottomMenu = !$scope.showBottomMenu;
            setUlWidth();
            getCurrentImage();
            $scope.selectedLi = $scope.currentPage.uuid;
        };

        /**
         * 获取当前选中的贴纸
         * @returns {Array}
         */
        var getCurrentStickerList = function () {
            var index = $rootScope.currentCarouselIndex || 0;
            var page = $scope.template.pages.page[index];
            return page.imagearts.imageart
        };
        /**
         * 添加贴纸
         */
        $scope.addSticker = function (e, sticker) {
            if (e) {
                e.stopPropagation();
            }

            var currentPage = $scope.template.pages.page[$rootScope.currentCarouselIndex];
            var pageW = (currentPage.isMaxWidth ? $scope.dWidth * 0.94 : ($scope.dHeight - $scope.tHeight) * currentPage.width / currentPage.height).toFixed(2);

            if (!currentPage.imagearts) {
                currentPage.imagearts = {
                    imageart: []
                }
            }

            $scope.template.pageI = $rootScope.currentCarouselIndex;
            $scope.template.artXM = Math.ceil(20 + currentPage.imagearts.imageart.length * 2);
            $scope.template.artYM = Math.ceil(20 + currentPage.imagearts.imageart.length * 2);

            var img = new Image();
            img.src = sticker.imgUrl;

            currentPage.imagearts.imageart.push({
                geometry: {
                    x: unitTransform($scope.template.artXM) * currentPage.styleScale,
                    y: unitTransform($scope.template.artYM) * currentPage.styleScale,
                    width: pageW / 4,
                    height: pageW / 4 * img.height / img.width
                },
                rotation: {
                    angle: 0
                },
                type: 'dynamic',
                resource: {
                    identifier: sticker.identifier,
                    provider: sticker.provider
                },
                imgUrl: sticker.imgUrl,
                naturalWidth: img.width * currentPage.styleScale,
                naturalHeight: img.height * currentPage.styleScale,
                widthM:unitTransformPx(pageW / 4 / currentPage.styleScale),
                height: unitTransformPx(pageW / 4 * img.height / img.width / currentPage.styleScale),
                XM: $scope.template.artXM,
                YM: $scope.template.artYM
            });

            var currentCreate = reviewDoc.page[$rootScope.currentCarouselIndex];
            if (!currentCreate.imagearts) {
                currentCreate.imagearts = {
                    imageart: []
                };
            }

            currentCreate.imagearts.imageart.push({
                geometry: {
                    x: $scope.template.artXM,
                    y: $scope.template.artYM,
                    width: unitTransformPx(pageW / 4 / currentPage.styleScale),
                    height: unitTransformPx(pageW / 4 * img.height / img.width / currentPage.styleScale)
                },
                rotation: {
                    angle: 0
                },
                type: 'dynamic',
                resource: {
                    identifier: sticker.identifier,
                    provider: sticker.provider
                },
                imgUrl: sticker.imgUrl,
                naturalWidth: img.width * currentPage.styleScale,
                naturalHeight: img.height * currentPage.styleScale,
                widthM:unitTransformPx(pageW / 4 / currentPage.styleScale),
                height: unitTransformPx(pageW / 4 * img.height / img.width / currentPage.styleScale),
                XM: $scope.template.artXM,
                YM: $scope.template.artYM
            });

            $scope.template.artI = $scope.template.pages.page[$rootScope.currentCarouselIndex].imagearts.imageart.length - 1;
            currentPage.imagearts.imageart[$scope.template.artI].zindex = $scope.template.artI;
            currentPage.currentZindex = $scope.template.artI;
            $scope.template.currentMenu = 'art';
            singleToRemember();
            $rootScope.template = $scope.template;
        };

        /**
         * 选中编辑贴纸
         * @param $event
         * @param $index
         */
        $scope.editSticker = function ($event, $index) {
            if ($event) {
                $event.stopPropagation();
            }
            var selectStickerList = getCurrentStickerList();

            $scope.template.artI = $index;
            var currentPage = getCurrentPage();
            if (selectStickerList[$index]) {
                currentPage.currentZindex = selectStickerList[$index].zindex;
            } else {
                currentPage.currentZindex = currentPage.imagearts.imageart.length;
            }
        };

        var getSticker = function (e) {
            var targ = e.target ? e.target : e.srcElement;
            var $index = targ.parentElement.dataset['index'];
            $scope.template.artI = $index;
            var selectStickerList = getCurrentStickerList();
            var sticker = selectStickerList[$index];
            if (sticker != null) {
                var img = new Image();
                img.src = sticker.imgUrl;
                sticker.naturalHeight = img.height * $scope.template.pages.page[$rootScope.currentCarouselIndex].styleScale;
                sticker.naturalWidth = img.width * $scope.template.pages.page[$rootScope.currentCarouselIndex].styleScale
            }
            $scope.template.currentMenu = 'art';
            return selectStickerList[$index];
        };

        //防止事件冒泡，默认事件
        function fn(e) {
            e = e || event;
            e.cancelBubble = true;
            e.stopPropagation();
            e.returnValue = false;
            e.preventDefault();
        }

        /**
         * 缩放旋转贴纸
         * @type {boolean}
         */
        window.resizeStickerStart = function (e) {
            fn(e);

            var targ = e.target ? e.target : e.srcElement;
            var sticker = getSticker(e);
            stickerDragBox.clientX = e.changedTouches[0].clientX || 0;          //鼠标到页面左边的距离
            stickerDragBox.clientY = e.changedTouches[0].clientY || 0;          //鼠标到页面顶部的距离
            stickerDragBox.coordX = targ.offsetLeft;        //鼠标到模板左边的距离
            stickerDragBox.coordY = targ.offsetTop;         //鼠标到模板顶部的距离

            sticker.scale = sticker.geometry.width / sticker.naturalWidth;
            stickerDragBox.width = angular.copy(sticker.geometry.width);
            stickerDragBox.height = angular.copy(sticker.geometry.height);
            //计算图形的半径
            sticker.radius = parseInt(Math.sqrt(sticker.naturalWidth * sticker.naturalWidth + sticker.naturalHeight * sticker.naturalHeight) / 2 * sticker.scale);

            stickerDragBox.radius = angular.copy(sticker.radius);
            stickerDragBox.stickerRotate = sticker.rotation.angle ? Number(sticker.rotation.angle) : 0;
            //Math.asin(x) 范围（-1，1）
            if (sticker.naturalWidth / 2 / sticker.radius > 1) {
                stickerDragBox.asin = Math.asin(1);
            } else if (sticker.naturalWidth / 2 / sticker.radius < -1) {
                stickerDragBox.asin = Math.asin(-1);
            } else {
                stickerDragBox.asin = Math.asin(sticker.naturalWidth / 2 / sticker.radius);
            }
            stickerDragBox.originalRotate = parseInt(180 * stickerDragBox.asin / (2 * Math.asin(1))) + stickerDragBox.stickerRotate;
            isDragging = true;
        };

        window.resizeStickerOn = function (e) {
            fn(e);
            var sticker = getSticker(e);
            if (isDragging) {
                var offsetX = (e.changedTouches[0].clientX - stickerDragBox.clientX);
                var offsetY = (e.changedTouches[0].clientY - stickerDragBox.clientY);

                var newX = (stickerDragBox.width / 2 + offsetX);
                var newY = (stickerDragBox.width / 2 + offsetY);
                sticker.newRadius = Math.sqrt(newX * newX + newY * newY);
                sticker.geometry.width = stickerDragBox.width * sticker.newRadius / stickerDragBox.radius;
                sticker.geometry.height = stickerDragBox.height * sticker.geometry.width / stickerDragBox.width;
                var rotate = parseInt(180 * Math.asin(newX / sticker.newRadius) / (2 * Math.asin(1)));

                if (newX > 0 && newY > 0) {
                    sticker.rotation.angle = stickerDragBox.originalRotate - rotate;
                } else if (newX < 0 && newY > 0) {
                    if (newX / newY + sticker.naturalWidth / sticker.naturalHeight) {
                        sticker.rotation.angle = stickerDragBox.originalRotate - rotate;
                    } else {
                        sticker.rotation.angle = stickerDragBox.originalRotate + 90 - rotate;
                    }
                } else if (newX < 0 && newY < 0) {
                    sticker.rotation.angle = stickerDragBox.originalRotate + 180 + rotate;

                } else {
                    if (newX / newY + sticker.naturalWidth / sticker.naturalHeight) {
                        sticker.rotation.angle = stickerDragBox.originalRotate + 180 + rotate;
                    } else {
                        sticker.rotation.angle = stickerDragBox.originalRotate + 270 - rotate;
                    }
                }
                $scope.$digest();
            }
            return false;
        };
        window.resizeStickerEnd = function (e) {
            var sticker = getSticker(e);
            var imageart = reviewDoc.page[$rootScope.currentCarouselIndex].imagearts.imageart[$scope.template.artI];
            var styleScale = $scope.template.pages.page[$rootScope.currentCarouselIndex].styleScale;

            imageart.rotation.angle = -sticker.rotation.angle;
            imageart.geometry.width = imageart.widthM = sticker.widthM = unitTransformPx(sticker.geometry.width / styleScale);
            imageart.geometry.height = imageart.heightM = sticker.heightM = unitTransformPx(sticker.geometry.height / styleScale);

            singleToRemember();
            isDragging = false;
            stickerDragBox = {};
            $rootScope.template = $scope.template;
        };

        /**
         * 移动贴纸
         * @param e
         */
        window.moveStickerStart = function (e) {
            var sticker = getSticker(e);
            var index = $rootScope.currentCarouselIndex || 0;
            $scope.template.pages.page[index].currentZindex = sticker.zindex;

            if (sticker.type == 'static') {
                return
            }

            dragBox.clientX = e.changedTouches[0].clientX ? e.changedTouches[0].clientX : 0;
            dragBox.clientY = e.changedTouches[0].clientY ? e.changedTouches[0].clientY : 0;
            dragBox.coordX = sticker.geometry.x;
            dragBox.coordY = sticker.geometry.y;
            moveSticker = true;
            window.event ? window.event.cancelBubble = true : e.stopPropagation();
            window.event ? window.event.returnValue = false : e.preventDefault();
            $scope.$digest();
        };
        window.moveStickerOn = function (e) {
            window.event ? window.event.cancelBubble = true : e.stopPropagation();
            window.event ? window.event.returnValue = false : e.preventDefault();
            if (moveSticker) {
                var sticker = getSticker(e);
                var offsetX = dragBox.coordX + (e.changedTouches[0].clientX - dragBox.clientX);
                var offsetY = dragBox.coordY + (e.changedTouches[0].clientY - dragBox.clientY);

                sticker.geometry.x = offsetX;
                sticker.geometry.y = offsetY;
            }
            $scope.$digest();
            return false;
        };
        window.moveStickerEnd = function (e) {
            var sticker = getSticker(e);
            var imageart = reviewDoc.page[$rootScope.currentCarouselIndex].imagearts.imageart[$scope.template.artI];
            var styleScale = $scope.template.pages.page[$rootScope.currentCarouselIndex].styleScale;
            imageart.geometry.x = imageart.XM = sticker.XM = unitTransformPx(sticker.geometry.x / styleScale);
            imageart.geometry.y = imageart.YM = sticker.YM = unitTransformPx(sticker.geometry.y / styleScale);
            singleToRemember();
            moveSticker = false;
            dragBox = {};
            $rootScope.template = $scope.template;
        };

        /**
         * 删除贴纸
         * @param event
         * @param i
         */
        $scope.deleteSticker = function (event, i, index) {
            var selectStickerList = getCurrentStickerList();
            var selectStickerDoc = reviewDoc.page[index].imagearts.imageart;
            deleteAction(event, selectStickerList, selectStickerDoc, i);
            $scope.editSticker(event, selectStickerList.length - 1);
        };

        function deleteAction(e, list, doc, i) {
            if (e) {
                fn(e);
            }
            list.splice(i, 1);
            doc.splice(i, 1);


            var index = $rootScope.currentCarouselIndex || 0;
            var currentPage = $scope.template.pages.page[index];
            currentPage.currentZindex -= 1;

            singleToRemember();
            $rootScope.template = $scope.template;
        }

        /*******************************************贴纸功能****************************end*********************************************/


        /*******************************************文字处理****************************start*********************************************/

        /**
         * 更改文字字体
         */
        function getFontList() {
            FontManagement.getAll({}, function (res) {
                $scope.fontList = [];
                angular.forEach(res, function (msg, i) {
                    $scope.fontList.push({
                        id: 0,
                        // 字体名称
                        value: msg.family,
                        child: []
                    });
                    var zh = null;
                    angular.forEach(msg.fontStyles, function (font, j) {
                        switch (font.style) {
                            case 'NORMAL':
                                zh = "常规";
                                break;
                            case 'BOLD':
                                zh = "粗体";
                                break;
                            case 'ITALIC':
                                zh = "斜体";
                                break;
                            case 'BOLD_ITALIC':
                                zh = "粗斜体";
                                break;
                            default:
                                zh = null
                        }
                        $scope.fontList[i].child.push({
                            // 字体样式中文
                            value: zh,
                            // 字体样式英文
                            en: font.style,
                            path: font.path,
                            identifier: font.identifier,
                            domain: $scope.domain
                        });
                    });
                    if (i == res.length - 1) {
                        getFont();
                    }
                });
            });
        }

        function getFont() {
            $scope.defaultText = {
                family: $scope.fontList[0].value,
                style: $scope.fontList[0].child[0].en,
                path: $scope.fontList[0].child[0].path,
                identifier: $scope.fontList[0].child[0].identifier,
                domain: $scope.domain
            };

            new MultiPicker({
                input: 'multiPickerInput',//点击触发插件的input框的id
                container: 'targetContainer',//插件插入的容器id
                jsonData: $scope.fontList,
                success: function (arr) {
                    $("#multiPickerInput").val(arr[0].value + "（" + arr[1].value + "）");
                    $scope.defaultText = {
                        family: arr[0].value,
                        style: arr[1].en,
                        path: arr[1].path,
                        identifier: arr[1].identifier,
                        domain: $scope.domain
                    };
                    var text = getCurrentText();
                    text.styles = arr[1].en;
                    text.style.font = arr[0].value;
                    text.identifier = arr[1].path;
                    if (text.styles.indexOf('BOLD') != -1) {
                        text.style.bold = true;
                    } else {
                        text.style.bold = false;
                    }
                    if (text.styles.indexOf('ITALIC') != -1) {
                        text.style.italic = true;
                    } else {
                        text.style.italic = false;
                    }
                }//回调
            });
        }

        /**
         * 文字
         */
        var getCurrentText = function () {
            var index = $rootScope.currentCarouselIndex || 0;
            if (!$scope.template.pages.page[index].textboxes.textbox[selectTextIndex]) {
                $scope.template.pages.page[index].textboxes.textbox[selectTextIndex] = {};
                reviewDoc.page[index].textboxes.textbox[selectTextIndex] = {};
            }
            return $scope.template.pages.page[index].textboxes.textbox[selectTextIndex];
        };

        var elem = document.querySelector('input[type="range"]');

        var rangeValue = function () {
            var newValue = elem.value;
            var target = document.querySelector('.text-value');
            target.innerHTML = "当前字号：" + newValue + " px";
            var text = getCurrentText();
            text.style.size = newValue;
        };

        elem.addEventListener("input", rangeValue);

        /**
         * 更新文字
         */
        $scope.updateTextContents = function () {
            var w = $("#text-area").width();
            $("#text-div").width(w);
            var page = $scope.template.pages.page[$scope.template.pageI];
            var maxW = (page.isMaxWidth ? $scope.dWidth * 0.94 : ($scope.dHeight - $scope.tHeight) * page.width / page.height) / page.styleScale;
            var maxH = page.isMaxWidth ? $scope.dWidth * 0.94 * page.height / page.width : ($scope.dHeight - $scope.tHeight) / page.styleScale;
            setTimeout(function () {
                var text = page.textboxes.textbox[$scope.template.textI];
                var $con = $("#text-div");

                var str = $scope.textContent.split('\n').join('<br/>');

                text.text = $scope.textContent;
                $con.html(str);
                text.maxW = maxW;
                text.maxH = maxH;
            }, 200);
        };

        /**
         * 文字输入确认按钮
         */
        $scope.saveText = function () {
            getCurrentImage();
            // $(".fix-bottom-section").removeAttr('style');
            $(window).unbind('scroll');

            $scope.showBottomMenu = true;
            $scope.showBarMenu = false;

            tipStatus(false);
            var i = $scope.template.textI;
            var index = $scope.template.pageI;
            $(".slide-li").eq(index).find(".text-box").eq(i).removeClass('opacity-zero');
            $scope.showTextModal = false;

            $scope.showTextMenu = false;
            var text = getCurrentText();
            text.text = $scope.textContent;


            toImg(text, $scope.currentPage.styleScale, index, i);
            var currentText = reviewDoc.page[index].textboxes.textbox[i];

            currentText.style = angular.copy(text.style);
            currentText.rotation = angular.copy(text.rotation);
            currentText.text = text.text;
            currentText.identifier = text.identifier;
            currentText.xM = text.xM;
            currentText.yM = text.yM;
            currentText.pic = text.pic;
            singleToRemember();


            $rootScope.template = $scope.template;
        };

        /**
         * 文字菜单切换（点击）及初始化
         */
        $scope.toggleTextMenu = function ($event) {
            $(".text-img").css({'height': 0});
            $("#text-area").attr('autofocus', "autofocus");

            getCurrentImage();
            var textbox = angular.copy($scope.currentText);
            $scope.textCopy = angular.copy(textbox);
            $scope.textCopyReview = angular.copy(reviewDoc);

            $scope.showTextModal = !$scope.showTextModal;
            $scope.showTextMenu = !$scope.showTextMenu;

            $scope.showBottomMenu = !$scope.showBottomMenu;

            // 清空样式
            $scope.textContent = "";

            /**
             * 格式化颜色和文字的选择
             */
            $scope.selectedColor = $scope.colorList[0];
            $scope.selectedFont = $scope.fontList[0];
            angular.forEach($scope.fontList, function (item, index) {
                item.selected = !index;
            });


            $(".tip-image").addClass('hide1');

            //初始化并添加一个文字框
            if ($scope.showTextMenu) {
                var currentPage = $scope.template.pages.page[$rootScope.currentCarouselIndex];

                if (!currentPage.textboxes.textbox) {
                    currentPage.textboxes.textbox = [];
                }

                $scope.template.pageI = $rootScope.currentCarouselIndex;
                var textXM = Math.ceil(20 + currentPage.textboxes.textbox.length * 2);
                var textYM = Math.ceil(20 + currentPage.textboxes.textbox.length * 2);
                currentPage.textboxes.textbox.push({
                    geometry: {
                        height: 24 * currentPage.styleScale,
                        width: 200 * currentPage.styleScale,
                        x: unitTransform(textXM) * currentPage.styleScale,
                        y: unitTransform(textYM) * currentPage.styleScale
                    },
                    rotation: {
                        angle: 0
                    },
                    style: {
                        color: $scope.selectedColor,
                        font: $scope.defaultText.family,
                        size: $(".text-range").val(),
                        bold: $scope.defaultText.style.indexOf('BOLD') >= 0 ? true : false,
                        italic: $scope.defaultText.style.indexOf('ITALIC') >= 0 ? true : false
                    },
                    identifier: $scope.defaultText.path,
                    styles: $scope.defaultText.style,
                    pic: '',
                    text: '',
                    type: 'dynamic',
                    status: '',
                    xM: textXM,
                    yM: textYM
                });

                $scope.template.textI = $scope.template.pages.page[$rootScope.currentCarouselIndex].textboxes.textbox.length - 1;
                currentPage.textboxes.textbox[$scope.template.textI].zindex = $scope.template.textI;
                currentPage.currentZindex = $scope.template.textI;

                var currentCreate = reviewDoc.page[$rootScope.currentCarouselIndex];
                if (!currentCreate.textboxes) {
                    currentCreate.textboxes = {
                        textbox: []
                    };
                }
                currentCreate.textboxes.textbox.push({
                    geometry: {
                        height: unitTransformPx(24),
                        width: unitTransformPx(200),
                        x: textXM,
                        y: textYM
                    },
                    rotation: {
                        angle: 0
                    },
                    style: {
                        color: $scope.selectedColor,
                        font: $scope.defaultText.family,
                        size: $(".text-range").val(),
                        bold: $scope.defaultText.style.indexOf('BOLD') >= 0 ? true : false,
                        italic: $scope.defaultText.style.indexOf('ITALIC') >= 0 ? true : false
                    },
                    identifier: $scope.defaultText.path,
                    styles: $scope.defaultText.style,
                    pic: '',
                    text: '',
                    type: 'dynamic',
                    status: '',
                    xM: textXM,
                    yM: textYM
                });

                $scope.template.currentMenu = 'text';
                $scope.selectCurrentTextBox($event, $scope.template.textI);

                $rootScope.template = $scope.template;
            }
        };

        /**
         * 底部 编辑按钮<---->菜单栏 的切换
         * @param event
         */
        $scope.toggleBarMenu = function (event) {
            if (event) {
                event.stopPropagation();
            }
            $scope.showBarMenu = !$scope.showBarMenu;
            // 当引导页点击“不在提示”以后就不再count++;
            if (!vm.guideStep) {
                $scope.countN++;
                localStorage.setItem('countN', $scope.countN);
            }
        };

        /**
         * 关闭按钮--->菜单栏
         */
        $scope.closeToBarMenu = function (event) {
            if (event) {
                event.stopPropagation();
            }
            $scope.showBottomMenu = true;
            $scope.showBarMenu = false;
            $scope.showStickerMenu = false;
            $scope.showTempMenu = false;
            $scope.showImageMenu = false;
        };

        var setUlWidth = function () {
            var len = vm.article.document.pages.page.length;
            if (len < 3) {
                return
            }
            //需要加上选中的边框值：2
            var w = 2;
            if ($scope.pageAllPx && $scope.pageAllPx.page.length) {
                var arr = $scope.pageAllPx.page;
                for (var j = 0; j < arr.length; j++) {
                    arr[j].width = unitTransform(arr[j].mediabox.width);
                    arr[j].height = unitTransform(arr[j].mediabox.height);
                    w += arr[j].width * $scope.mHeight / arr[j].height + 12;
                }
            }

            $(".temp-ul").width(w + 'px');
        };

        /**
         * 选中当前文字框
         */
        $scope.selectCurrentTextBox = function ($event, $index) {
            selectTextIndex = $index;
            if ($event) {
                $event.stopPropagation();
            }
            var currentText = getCurrentText();
            var currentPage = getCurrentPage();
            currentPage.currentZindex = currentText.zindex;

            /**
             * 显示文字颜色及字体选择菜单
             */
            $scope.showTextMenu = true;
            $scope.showStickerMenu = false;

            /**
             * 更新对应的颜色选择和字体
             */
            $scope.selectedColor = currentText.style.color;
            angular.forEach($scope.fontList, function (item) {
                if (item.value == currentText.style.font) {
                    item.selected = true;
                    $scope.selectedFont = item;
                } else {
                    item.selected = false;
                }
            });
        };
        /**
         * 更改文字颜色
         */
        $scope.selectTextColor = function (color) {
            $scope.selectedColor = color;
            var text = getCurrentText();
            text.style.color = color;
        };

        /**
         * 关闭编辑文字modal窗口
         */
        $scope.closeTextModal = function () {
            $scope.showTextModal = false;
            var text = getCurrentText();
            text.text = $scope.textContent;
            var $box = $("#slide" + $scope.template.pageI).find(".text-hidden" + $scope.template.textI);
            var boxWidth = text.geometry.width / $scope.template.pages.page[$rootScope.currentCarouselIndex].styleScale;
            $box.html(text.text);

            text.geometry.height = Math.ceil($box.width() / boxWidth) * 12;
            toImg(text);
        };

        $scope.hideMenu = function () {
            $scope.showTextMenu = false;
            $scope.showStickerMenu = false;

            $scope.showBarMenu = true;
            $scope.showTempMenu = false;
            if (!$scope.showImageMenu && !$scope.showTextModal) {
                $scope.showBottomMenu = true;
            }
            if ($scope.showTextModal) {
                $scope.showBottomMenu = false;
            }

            var currentPage = getCurrentPage();
            currentPage.currentZindex = -1;
        };


        function toImg(text, scale, index, textI) {
            if (text.text == '') {
                text.pic = '';
                return
            }
            var styleScale = scale ;
            var fontStyle = text.styles ? text.styles : $scope.defaultText.style;

            var tmpNode = document.createElement("DIV");
            $(tmpNode).html(text.text)
                .css({
                    'font-size': text.style.size
                });

            //根据换行符分数组
            var arrs = $(tmpNode).html().split('\n');
            //先拿到数组中下标为0的宽度
            var $width = $(".text-width").html(arrs[0]).css({
                'font-size': text.style.size + 'px',
                'font-weight': fontStyle,
                'font-family': text.style.font ? text.style.font : $scope.defaultText.family
            });

            var w0 = angular.copy(text.geometry.width);
            var h0 = angular.copy(text.geometry.height);

            var t = 0,
                k = 0;
            if ($width.width() > text.maxW) {
                k = k + parseInt($width.width() / text.maxW);
            }
            if (text.type != 'static' && text.maxW) {
                // console.log(text.text);
                var pattern_char = /[a-zA-Z0-9]/g;
                // var pattern_chin = /[\u4e00-\u9fa5]/g;
                var pattern = $width.html().match(pattern_char);
                var count_char = pattern ? pattern.length : 4;
                var maxW = ($width.width()) > text.maxW ? text.maxW : ($width.width() + count_char * 8);
                var maxH = $width.height();
                if (arrs.length == 1) {
                    w0 = maxW;
                    h0 = maxH * (arrs.length + k);
                } else {
                    for (var i = 1, len = arrs.length; i < len; i++) {
                        var count = arrs[i].match(pattern_char);
                        var over_char = count ? count.length : 4;
                        var overWidth = $width.html(arrs[i]).width() + over_char * 8;
                        //得到数组中宽度最大的一个
                        if (maxW < overWidth && overWidth < text.maxW) {
                            maxW = overWidth;
                            maxH = $width.html(arrs[i]).height();
                            t = i;
                        } else if (maxW < overWidth && overWidth > text.maxW) {
                            maxW = text.maxW;
                            maxH = $width.html(arrs[i]).height();
                            k = k + parseInt($width.width() / text.maxW);
                        }
                    }
                    $width.html(arrs[t]);
                    w0 = maxW;
                    h0 = maxH * (arrs.length + k);
                }
            } else {
                w0 /= styleScale;
                h0 /= styleScale;
            }

            if (text.geometry.height > $(".text-img" + textI).height()) {
                $(".text-img").height(text.geometry.height);
            }


            $http({
                url: '/editor/fileserves/api/convert/textToImg',
                method: 'POST',
                data: {
                    identifier: text.identifier ? text.identifier : $scope.defaultText.path,
                    text: text.text,
                    fontSize: text.style.size,
                    style: fontStyle,
                    height: h0,
                    width: w0,
                    color: text.style.color,
                    family: text.style.font ? text.style.font : $scope.defaultText.family,
                    storeId: vm.storeId
                },
                responseType: 'blob'
            }).success(function (res, status, headers, config) {
                if(res.status == 200){
                    text.geometry.width = w0 * styleScale;
                    text.geometry.height = h0 * styleScale;
                    var reviewText = reviewDoc.page[index].textboxes.textbox[textI];
                    if (reviewDoc.page[index] && reviewText) {
                        reviewText.geometry.width = reviewText.widthM = unitTransformPx(text.geometry.width) / styleScale;
                        reviewText.geometry.height = reviewText.heightM = unitTransformPx(text.geometry.height) / styleScale;
                    }
                    $(".text-img-pic").css({
                        width: w0 * styleScale,
                        height: h0 * styleScale
                    });
                    if (text.geometry.width < 90) {
                        text.divX = (100 - text.geometry.width) / 2
                    } else {
                        text.divX = 10
                    }
                    if (text.geometry.height < 35) {
                        text.divY = (35 - text.geometry.height) / 2
                    } else {
                        text.divY = 10
                    }

                    var createObjectURL = function (blob) {
                        return window[window.webkitURL ? 'webkitURL' : 'URL']['createObjectURL'](blob);
                    };
                    var fileURL = URL.createObjectURL(res.data);
                    text.pic = fileURL;
                    text.identifier = text.identifier || $scope.defaultText.path;
                }else {
                    MessageService.error(res.message);
                }
            }).error(function () {
                console.log("textToImg error");
            });
        }

        /**
         * 删除文字框
         * @param $event
         * @param i
         * @param index
         */
        $scope.deleteSelectedText = function ($event, i, index) {
            $scope.template.textI = i;
            var textList = $scope.template.pages.page[index].textboxes.textbox;
            var textDoc = reviewDoc.page[index].textboxes.textbox;
            deleteAction(event, textList, textDoc, i);
            $scope.showTextMenu = false;
        };

        /**
         * 编辑文字内容
         * @param $event
         * @param i
         * @param text
         * @param index
         */
        $scope.editTextContent = function ($event, i, text, index) {
            $scope.showTextModal = true;
            $scope.showImageMenu = false;
            selectTextIndex = i;
            $(".text-img-pic").css({width: text.geometry.width, height: text.geometry.height});
            $scope.textContent = text.text;
            $scope.template.textI = i;
            $scope.template.pageI = index;
            $(".text-value").html(text.style.size + ' px');
            $(".rangeSize").val(text.style.size);
            // elem.addEventListener("input", rangeValue);

            angular.element('#text-area')[0].focus();

            getCurrentImage();
            var textbox = angular.copy($scope.currentText);
            $scope.textCopy = angular.copy(textbox);
            $scope.textCopyReview = angular.copy(reviewDoc);

            $(".tip-image").addClass('hide1');

        };
        function editorDynamic($index, e) {
            var tag = (arguments[0].target || e.srcElement).tagName;
            if (tag == 'SPAN') {
                $scope.showTextModal = true;
                $scope.showImageMenu = false;
                selectTextIndex = $index;
                var text = getCurrentText();
                $scope.textContent = text.text;
                $(".text-value").html(text.style.size + ' px');
                $(".rangeSize").val(text.style.size);
                // elem.addEventListener("input", rangeValue);

                angular.element('#text-area')[0].focus();

                getCurrentImage();
                var textbox = angular.copy($scope.currentText);
                $scope.textCopy = angular.copy(textbox);
                $scope.textCopyReview = angular.copy(reviewDoc);
                $scope.showBarMenu = false;
                $scope.showBottomMenu = false;
                $(".tip-image").addClass('hide1');
            }
        }

        /**
         * 移动文字框
         */
        var getCurrentTextFromEvent = function (e) {
            var targ = e.currentTarget ? e.currentTarget : e.srcElement;
            $scope.template.textI = targ.dataset.index;
            selectTextIndex = +targ.dataset.index;
            $scope.template.currentMenu = 'text';
            return getCurrentText();
        };

        window.moveTextBoxStart = function (e) {
            var tag = (arguments[0].target || e.srcElement).tagName;
            var text = getCurrentTextFromEvent(e);
            var index = $rootScope.currentCarouselIndex || 0;
            $scope.template.pageI = index;
            $scope.template.pages.page[index].currentZindex = text.zindex;
            $(".text-img-pic").css({width: text.geometry.width, height: text.geometry.height});
            if (text.status == 'dynamic') {
                editorDynamic(text.zindex, e);
                window.event ? window.event.cancelBubble = true : e.stopPropagation();
                window.event ? window.event.returnValue = false : e.preventDefault();
                $scope.$digest();
                return;
            }
            if (tag == 'SPAN' || text.status == 'static') {
                return;
            }

            dragBox.clientX = e.changedTouches[0].clientX ? e.changedTouches[0].clientX : 0;
            dragBox.clientY = e.changedTouches[0].clientY ? e.changedTouches[0].clientY : 0;
            dragBox.coordX = text.geometry.x;
            dragBox.coordY = text.geometry.y;
            moveText = true;
            window.event ? window.event.cancelBubble = true : e.stopPropagation();
            window.event ? window.event.returnValue = false : e.preventDefault();
            $scope.$digest();
        };
        window.moveTextBoxOn = function (e) {
            if (moveText) {
                var text = getCurrentTextFromEvent(e);
                var offsetX = dragBox.coordX + (e.changedTouches[0].clientX - dragBox.clientX);
                var offsetY = dragBox.coordY + (e.changedTouches[0].clientY - dragBox.clientY);
                text.geometry.x = offsetX;
                text.geometry.y = offsetY;
            }
            $scope.$digest();
            window.event ? window.event.cancelBubble = true : e.stopPropagation();
            window.event ? window.event.returnValue = false : e.preventDefault();

            return false;
        };
        window.moveTextBoxEnd = function (e) {
            if (!moveText) {
                return
            }
            var text = getCurrentTextFromEvent(e);
            var currentText = reviewDoc.page[$rootScope.currentCarouselIndex].textboxes.textbox[$scope.template.textI];
            currentText.geometry.x = currentText.xM = unitTransformPx(text.geometry.x / $scope.template.pages.page[$rootScope.currentCarouselIndex].styleScale);
            currentText.geometry.y = currentText.yM = unitTransformPx(text.geometry.y / $scope.template.pages.page[$rootScope.currentCarouselIndex].styleScale);
            singleToRemember();
            moveText = false;
            dragBox = {};
            $rootScope.template = $scope.template;
        };

        /**
         *旋转缩放文字
         * @param e
         */
        window.resizeTextBoxStart = function (e) {
            fn(e);
            // IE uses srcElement, others use target
            var text = getCurrentTextFromEvent(e);
            dragBox.clientX = e.changedTouches[0].clientX ? e.changedTouches[0].clientX : 0;
            dragBox.clientY = e.changedTouches[0].clientY ? e.changedTouches[0].clientY : 0;
            dragBox.coordX = angular.copy(text.geometry.x);
            dragBox.coordY = angular.copy(text.geometry.y);
            dragBox.originalWidth = angular.copy(text.geometry.width);
            dragBox.originalFontSize = text.style.size;


            dragBox.textRotate = text.rotation.angle ? Number(text.rotation.angle) : 0;
            dragBox.radius = parseInt(Math.sqrt((text.geometry.width * text.geometry.width + text.geometry.height * text.geometry.height) / $scope.template.pages.page[$rootScope.currentCarouselIndex].styleScale / $scope.template.pages.page[$rootScope.currentCarouselIndex].styleScale) / 2);
            dragBox.originalRotate = parseInt(180 * Math.asin(text.geometry.width / $scope.template.pages.page[$rootScope.currentCarouselIndex].styleScale / 2 / dragBox.radius) / (2 * Math.asin(1))) + dragBox.textRotate;
            window.isDragging = true;
        };
        window.resizeTextBoxOn = function (e) {

            if (window.isDragging) {

                var text = getCurrentTextFromEvent(e);
                var offsetX = (e.changedTouches[0].clientX - dragBox.clientX);
                var offsetY = (e.changedTouches[0].clientY - dragBox.clientY);
                var newX = (text.geometry.width / 2 + offsetX);
                var newY = (text.geometry.height / 2 + offsetY);
                dragBox.newRadius = Math.sqrt(newX * newX + newY * newY);
                var rotate = parseInt(180 * Math.asin(newX / dragBox.newRadius) / (2 * Math.asin(1)));
                if (newX > 0 && newY > 0) {
                    text.rotation.angle = (dragBox.originalRotate - rotate);
                } else if (newX < 0 && newY > 0) {
                    text.rotation.angle = dragBox.originalRotate - rotate;
                } else if (newX < 0 && newY < 0) {
                    text.rotation.angle = dragBox.originalRotate + 180 + rotate;
                } else {
                    text.rotation.angle = (dragBox.originalRotate + 180 + rotate);
                }
            }

            $scope.$digest();
            e.stopPropagation();
            e.preventDefault();
            return false;
        };
        window.resizeTextBoxEnd = function (e) {
            var text = getCurrentTextFromEvent(e);
            var currentCreate = reviewDoc.page[$rootScope.currentCarouselIndex];
            currentCreate.textboxes.textbox[$scope.template.textI].rotation.angle = -text.rotation.angle;
            singleToRemember();
            window.isDragging = false;
            dragBox = {};
            $rootScope.template = $scope.template;
        };

        /*******************************************文字处理****************************end*********************************************

         /**
         * 保存作品，绘图开始
         */

        $scope.isContinue = function () {
            var hasEmpty = false;
            angular.forEach($scope.template.pages.page, function (item, index) {
                if (item.imageboxes.imagebox && item.imageboxes.imagebox.length) {
                    var isAllAdded = item.imageboxes.imagebox.every(function (box) {
                        return box.image && box.image.resource.identifier;
                    });
                    if (!isAllAdded) {
                        hasEmpty = true;
                        return;
                    }
                }
            });
            if (hasEmpty) {
                completed = false;
                return false;
            } else {
                completed = true;
                return true;
            }
        };

        $scope.pageSize = function () {
            var isLowSize = false;
            angular.forEach($scope.template.pages.page, function (page, index) {
                angular.forEach(page.imageboxes.imagebox, function (img, i) {

                    if (img.image && img.image.imgSize / 1024 < 300) {
                        isLowSize = true;
                        SweetAlert.swal({
                                title: '有像素低的照片，确定要保存吗？',
                                imageUrl: Theme.sweetHintImg(),
                                showCancelButton: true,
                                confirmButtonText: "确认",
                                cancelButtonText: "取消"
                            },
                            function (isConfirm) {
                                if (isConfirm) {
                                    $(".save-page").removeClass('hide1');
                                    generateJsonFile();
                                    return;
                                } else {
                                    return;
                                }
                            })
                    }
                })
            });
            if (!isLowSize) {
                $timeout(function () {
                    $(".save-page").removeClass('hide1');
                    generateJsonFile();
                })
            }
        };

        $scope.saveWork = function () {
            var index = $rootScope.currentCarouselIndex;
            // 作品保存后，将页面改为0；
            $rootScope.currentCarouselIndex = 0;
            if ($scope.status == 'make') {
                setProductionStorage('view');
                $scope.showImageMenu = false;
                $scope.showTempMenu = false;
                $scope.isReplaceShow = false;
                $scope.showStickerMenu = false;

                setGalleryStorage();
                removeSingleStorage();

                $ul.css({marginLeft: '0px'});
                backToScrollTop();
                for (var i = 0; i < reviewDoc.page.length; i++) {
                    if (i == index) {
                        getPageToPx(reviewDoc.page[i], i, true, false);
                    } else {
                        getPageToPx(reviewDoc.page[i], i, false, false);
                    }

                }
                return;
            }
            //判断是否有图片未上传  且是否继续保存
            if (!$scope.isContinue()) {
                SweetAlert.swal({
                    title: '当前作品没有制作完成，保存后，项目库照片将会丢失，确认保存？',
                    imageUrl: Theme.sweetHintImg(),
                    showCancelButton: true,
                    confirmButtonText: "确认",
                    cancelButtonText: "取消",
                    closeOnConfirm: true,
                    closeOnCancel: true
                }, function (isConfirm) {
                    if (isConfirm) {
                        $timeout(function () {
                            $scope.pageSize();
                        }, 500);
                        return;
                    }
                })
            } else {
                $scope.pageSize();
            }
        };

        //json下载文件中需要的内容
        var generateJsonFile = function () {
            $scope.isSave = true;
            var template = {
                pages: {
                    page: []
                },
                reprint: vm.article.reprint
            };

            angular.forEach($scope.template.pages.page, function (item, index) {
                setTemplete(item, template, index, true)
            });


            var tempLen = $scope.template.pages.page.length;
            for (var i = 0; i < $scope.pageAllPx.page.length; i++) {
                setTemplete($scope.pageAllPx.page[i], template, tempLen + i, false)
            }


            vm.article.saveUserName = localStorage.getItem('saveUserName') || ''
            if ($scope.update) {
                Article.update({
                    id: vm.article.id,
                    name: vm.article.name,
                    completed: completed,
                    sku: vm.article.sku,
                    cover: vm.article.cover,
                    document: template,
                    fileName: vm.article.fileName,
                    productId: vm.article.productId,
                    productName: vm.article.productName,
                    categoryId: vm.article.categoryId,
                    categoryName: vm.article.categoryName,
                    itemValueId: vm.article.itemValueId,
                    themeClassifyId: vm.article.themeClassifyId,
                    themeClassifyName: vm.article.themeClassifyName,
                    productXmlId: vm.article.productXmlId,
                    productXmlName: vm.article.productXmlName

                }, function (resp) {
                    if(resp.status == 200){
                        $(".save-page").addClass('hide1');
                        $('.sweet-alert').removeClass('hide-button');
                        swal({
                            title: "修改成功",
                            text: "作品已同步到我的作品",
                            imageUrl: Theme.sweetSuccedImg(),
                            timer: 2000,
                            showConfirmButton: false
                        });
                        localStorage.setItem('guide-step', true);
                        $state.go('product.view', {
                            aid: resp.data.id,
                            storeId: vm.storeId
                        }, {reload: true,location: 'replace'});
                        $scope.isSavingJson = false;
                        removeLocalStorage();
                    }else {
                        $(".save-page").addClass('hide1');
                        swal({
                            title: "保存失败",
                            text: "保存出错了，请稍后再试，或者联系工作人员",
                            imageUrl: Theme.sweetHintImg(),
                            timer: 2000,
                            showConfirmButton: false
                        });
                    }
                }, function () {
                    $(".save-page").addClass('hide1');
                    swal({
                        title: "保存失败",
                        text: "保存出错了，请稍后再试，或者联系工作人员",
                        imageUrl: Theme.sweetHintImg(),
                        timer: 2000,
                        showConfirmButton: false
                    });
                })
            } else {
                Article.save({
                    name: vm.article.name,
                    sku: vm.article.sku,
                    productId: vm.article.productId,
                    productName: vm.article.productName,
                    cover: vm.article.cover,
                    completed: completed,
                    document: template,
                    itemValueId: vm.vid,
                    categoryId: vm.article.categoryId,
                    categoryName: vm.article.categoryName,
                    themeClassifyId: vm.article.themeClassifyId,
                    themeClassifyName: vm.article.themeClassifyName,
                    productXmlId: vm.article.productXmlId,
                    productXmlName: vm.article.productXmlName
                }, function (resp) {
                    if(resp.status == 200){
                        $(".save-page").addClass('hide1');
                        $('.sweet-alert').removeClass('hide-button');
                        swal({
                            title: "保存成功",
                            text: "作品已同步到我的作品",
                            imageUrl: Theme.sweetSuccedImg(),
                            timer: 2000,
                            showConfirmButton: false
                        });
                        localStorage.setItem('guide-step', true);
                        $state.go('product.view', {
                            aid: resp.data.id,
                            storeId: vm.storeId
                        }, {reload: true,location: 'replace'});
                        $scope.isSavingJson = false;
                        removeLocalStorage();
                    }else {
                        $(".save-page").addClass('hide1');
                        swal({
                            title: "保存失败",
                            text: "保存出错了，请稍后再试，或者联系工作人员",
                            imageUrl: Theme.sweetHintImg(),
                            timer: 3000,
                            showConfirmButton: false
                        });
                    }
                }, function (resp) {
                    $(".save-page").addClass('hide1');
                    swal({
                        title: "保存失败",
                        text: "保存出错了，请稍后再试，或者联系工作人员",
                        imageUrl: Theme.sweetHintImg(),
                        timer: 3000,
                        showConfirmButton: false
                    });

                });
            }
        };

        function setTemplete(item, template, index, flag) {
            template.pages.page[index] = {
                centerRotation: item.centerRotation,
                mediabox: angular.copy(item.mediabox),
                trimbox: angular.copy(item.trimbox),
                background: angular.copy(item.background),
                barcode: angular.copy(item.barcodeM),
                qrcode: angular.copy(item.qrcodeM),
                imagearts: {imageart: []},
                imageboxes: {imagebox: []},
                textboxes: {textbox: []},
                spread: item.spread,
                backup: item.backup,
                uuid: item.uuid
            };
            var reviewP = reviewDoc.page[index];
            if (!flag) {
                reviewP = item;
            }

            angular.forEach(item.imagearts.imageart, function (art, i) {
                var imageartR = reviewP.imagearts.imageart[i];
                if(!item.backup){
                    imageartR = item.imagearts.imageart[i];
                }

                var imageart = {
                    geometry: {
                        height: imageartR.heightM,
                        width: imageartR.widthM,
                        x: imageartR.XM,
                        y: imageartR.YM
                    },
                    rotation: {
                        angle: -art.rotation.angle
                    },
                    type: art.type,
                    resource: angular.copy(art.resource)
                };
                template.pages.page[index].imagearts.imageart.push(imageart);
            });

            angular.forEach(item.imageboxes.imagebox, function (img, i) {

                var imagebox = {
                    geometry: {
                        height: img.heightM,
                        width: img.widthM,
                        x: img.offsetXM,
                        y: img.offsetYM
                    },
                    rotation: angular.copy(img.rotation),
                    mask: angular.copy(img.mask),
                    image: {
                        resource: {
                            identifier: '',
                            provider: 'qiniu'
                        },
                        scale: 1
                    },
                    blurred: img.blurred
                };
                if (img.blurred) {
                    imagebox.blurredRectangle = {
                        x: unitTransformPx(img.blurredRectangle.x) / item.styleScale,
                        y: unitTransformPx(img.blurredRectangle.y) / item.styleScale,
                        width: unitTransformPx(img.blurredRectangle.width) / item.styleScale,
                        height: unitTransformPx(img.blurredRectangle.height) / item.styleScale,
                    }
                }
                if (img.image) {
                    imagebox.image = {
                        offsetX: unitTransformPx(img.image.offsetX * img.image.scaleW) / item.styleScale2,
                        offsetY: unitTransformPx(img.image.offsetY * img.image.scaleH) / item.styleScale2,
                        scale: img.image.scale,
                        angle: img.image.angle,
                        resource: {
                            identifier: img.image ? img.image.resource.identifier : '',
                            provider: img.image ? img.image.resource.provider : 'wechat'
                        },
                        resourceId: img.image.resourceId
                    }
                }
                template.pages.page[index].imageboxes.imagebox.push(imagebox);
            });

            angular.forEach(item.textboxes.textbox, function (text, i) {

                if (!(text.text == '' || text.text == null)) {
                    // var textR = reviewP.textboxes.textbox[i];
                    var textbox = {
                        geometry: {
                            height: text.heightM,
                            width: text.widthM,
                            x: text.xM,
                            y: text.yM
                        },
                        rotation: {
                            angle: -text.rotation.angle
                        },
                        style: text.style,
                        text: text.text,
                        status: text.status,
                        type: text.type,
                        identifier: text.identifier
                    };
                    template.pages.page[index].textboxes.textbox.push(textbox);
                }
            });
        }

        var removeLocalStorage = function () {
            localStorage.removeItem("choose");
            localStorage.removeItem("multipartUpload");
            localStorage.removeItem("index");
            localStorage.removeItem("i");
            localStorage.removeItem("go");
            localStorage.removeItem("single");
            localStorage.removeItem("pages");
            localStorage.removeItem("marginLeft");
            localStorage.removeItem("$index");
            localStorage.removeItem("gallery");
            localStorage.removeItem("work-save");
        };

        function setProductionStorage(attr) {
            localStorage.setItem('Production', attr);
            $scope.status = attr;
        }

        function singleToRemember() {
            localStorage.setItem('pages', JSON.stringify(reviewDoc));
        }

        function setReviewStorage() {
            localStorage.setItem('saveOldPage', JSON.stringify(reviewDoc));
            localStorage.setItem('reviewPages', JSON.stringify(reviewDoc));
            localStorage.setItem('pageAllPx', JSON.stringify($scope.pageAllPx));
            localStorage.setItem('galleryCopy', JSON.stringify(gallery));
        }

        function setGalleryStorage() {
            localStorage.setItem('gallery', JSON.stringify(gallery));
        }

        function removeSingleStorage() {
            localStorage.removeItem('single');
            localStorage.removeItem('marginLeft');
        }

        function tipStatus(flag) {
            if (flag) {
                $('.edit-menu').removeClass('opacity-zero');
                $('.tip-image').addClass('hide1');
                return
            }
            $('.edit-menu').addClass('opacity-zero');
            $('.tip-image').removeClass('hide1');
        }

        //防止事件冒泡，默认事件
        function fn(e) {
            e = e || window.event;
            e.cancelBubble = true;
            e.stopPropagation();
            e.returnValue = false;
            e.preventDefault();
        }

        /**
         * 点击其他地方时取消选中贴纸，文字框
         */
        $scope.$on('documentClicked', function () {
            setEveryThingUnselected();
            $scope.$digest();
        });
        var setEveryThingUnselected = function () {
            $scope.showTextMenu = false;
            $scope.showStickerMenu = false;
            $(".change-btn").hide();
            var currentPage = getCurrentPage();
            currentPage.currentZindex = -1;
        };

        /**
         * carousel滑动后初始化编辑菜单
         */
        $scope.$on('carouselSlideAway', function () {
            //关闭贴纸菜单
            $scope.showStickerMenu = false;
            //关闭文字菜单
            if ($scope.showTextMenu) {
                $scope.toggleTextMenu();
            }

            //取消当前页面的选择框
            if ($scope.template) {
                setEveryThingUnselected()
            }
        });

        //    引导页部分
        $scope.nextStep2 = function () {
            $scope.countN++;
            localStorage.setItem('countN', $scope.countN);
        };
        $scope.nextStep3 = function () {
            $scope.countN++;
            localStorage.setItem('countN', $scope.countN);
        };

        $scope.neverHint = function () {
            localStorage.setItem('guide-step', true);
            vm.guideStep = true;
            $(".guide-view").addClass('hide1');
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('editorApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('product-choose-ec', {
                parent: 'app',
                url: '/{storeId}/{pid}/{vid}/{xmlId}/{aid}/choose',
                data: {
                    authorities: [],
                    pageTitle: 'editorApp.product.home.title2'
                },

                views: {
                    'content@': {
                        templateUrl: 'app/entities/product-ec/editor-photoAlbum.html',
                        controller: 'EditorPhotoAlbumEcController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('editor');
                        $translatePartialLoader.addPart('gallery');
                        $translatePartialLoader.addPart('common');
                        $translatePartialLoader.addPart('choose');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            id: null
                        };
                    }
                }
            })

            //新版编辑器
            .state('product-chooseNew-ec', {
                parent: 'app',
                url: '/{storeId}/{pid}/{vid}/{xmlId}/{aid}/chooseNew',
                data: {
                    authorities: [],
                    pageTitle: 'choose.title'
                },

                views: {
                    'content@': {
                        templateUrl: 'app/entities/product-ec/editor-photoAlbum.html',
                        controller: 'EditorPhotoAlbumEcController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('editor');
                        $translatePartialLoader.addPart('gallery');
                        $translatePartialLoader.addPart('common');
                        $translatePartialLoader.addPart('choose');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            id: null
                        };
                    }
                }
            })

            //edit---->chooses
            .state('product-chooses-ec', {
                parent: 'app',
                url: '/{storeId}/{aid}/chooses',
                data: {
                    authorities: [],
                    pageTitle: 'editorApp.product.home.title2'
                },

                views: {
                    'content@': {
                        templateUrl: 'app/entities/product-ec/editor-photoAlbum.html',
                        controller: 'EditorPhotoAlbumEcController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('editor');
                        $translatePartialLoader.addPart('gallery');
                        $translatePartialLoader.addPart('common');
                        $translatePartialLoader.addPart('choose');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            id: null,
                            type: 'edit'
                        };
                    }
                }
            })

            //新版编辑器edit---->chooses
            .state('product-choosesNew-ec', {
                parent: 'app',
                url: '/{storeId}/{aid}/choosesNew',
                data: {
                    authorities: [],
                    pageTitle: 'editorApp.product.home.title2'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/product-ec/editor-photoAlbum.html',
                        controller: 'EditorPhotoAlbumEcController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('editor');
                        $translatePartialLoader.addPart('gallery');
                        $translatePartialLoader.addPart('common');
                        $translatePartialLoader.addPart('choose');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            id: null,
                            type: 'edit'
                        };
                    }
                }
            })

            //新增编辑器Three
            .state('product-chooseThree-ec', {
                parent: 'app',
                url: '/{storeId}/{pid}/{vid}/{xmlId}/{aid}/gift',
                data: {
                    authorities: [],
                    pageTitle: 'editorApp.product.home.title2'
                },

                views: {
                    'content@': {
                        templateUrl: 'app/entities/product-ec/productsThree.html',
                        controller: 'ProductThreeEcController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('editor');
                        $translatePartialLoader.addPart('gallery');
                        $translatePartialLoader.addPart('common');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            id: null
                        };
                    }
                }
            })
            //新增编辑器Three
            .state('product-chooseThree1', {
                parent: 'app',
                url: '/{storeId}/{pid}/{vid}/{xmlId}/chooseThree1',
                data: {
                    authorities: [],
                    pageTitle: 'editorApp.product.home.title2'
                },

                views: {
                    'content@': {
                        templateUrl: 'app/entities/product/productsThree1.html',
                        controller: 'ProductThree1Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('editor');
                        $translatePartialLoader.addPart('gallery');
                        $translatePartialLoader.addPart('common');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {id: null};
                    }
                }
            })
            .state('product-choosesThree-ec', {
                parent: 'app',
                url: '/{storeId}/{aid}/gift',
                data: {
                    authorities: [],
                    pageTitle: 'editorApp.product.home.title2'
                },

                views: {
                    'content@': {
                        templateUrl: 'app/entities/product-ec/productsThree.html',
                        controller: 'ProductThreeEcController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('editor');
                        $translatePartialLoader.addPart('gallery');
                        $translatePartialLoader.addPart('common');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            id: null,
                            type: 'edit'
                        };
                    }
                }
            })

            // h5 小程序  作品预览
            .state('product-view-ec', {
                parent: 'app',
                url: '/{storeId}/{aid}/view',
                data: {
                    authorities: [],
                    pageTitle: 'editorApp.product.detail.viewTitle'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/product-ec/product-view.html',
                        controller: 'ProductViewEcController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('editor');
                        $translatePartialLoader.addPart('common');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Article', function ($stateParams, Article) {
                        return Article.get({id: $stateParams.aid}).$promise;
                    }]
                }
            })
            .state('product-view-ec-1', {
                parent: 'app',
                url: '/{storeId}/{orderArticleId}/view-or',
                data: {
                    authorities: [],
                    pageTitle: 'editorApp.product.detail.viewTitle'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/product-ec/product-view.html',
                        controller: 'ProductViewEcController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('editor');
                        $translatePartialLoader.addPart('common');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'OrderArticle', function ($stateParams, OrderArticle) {
                        return OrderArticle.get({id: $stateParams.orderArticleId}).$promise;
                    }]
                }
            })
            // h5 小程序 作品分享的预览
            .state('product-view2-ec', {
                parent: 'app',
                url: '/{storeId}/{aid}/view2/{viewIndex}',
                data: {
                    authorities: [],
                    pageTitle: 'editorApp.product.detail.shareTitle'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/product-ec/product-view2.html',
                        controller: 'ProductViewEc2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('editor');
                        $translatePartialLoader.addPart('common');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Article', function ($stateParams, Article) {
                        return Article.get({id: $stateParams.aid}).$promise;
                    }]
                }
            })

            //h5  订单作品分享的预览
            .state('product-viewOrder', {
                parent: 'app',
                url: '/{storeId}/{aid}/view/{oid}',
                data: {
                    authorities: [],
                    pageTitle: 'editorApp.product.detail.shareTitle'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/product-ec/product-view2.html',
                        controller: 'ProductViewEc2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('editor');
                        $translatePartialLoader.addPart('common');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'OrderArticle', function ($stateParams, OrderArticle) {
                        return OrderArticle.get({id: $stateParams.oid}).$promise;
                    }]
                }
            })

            //小程序  订单中作品的预览  以及订单中的分享页面  --订单预览没有二维码
            .state('product-view3', {
                parent: 'app',
                url: '/{storeId}/{id}/productView3',
                data: {
                    authorities: [],
                    pageTitle: 'editorApp.product.detail.show'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/product-ec/product-view2.html',
                        controller: 'ProductViewEc3Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('editor');
                        $translatePartialLoader.addPart('common');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'OrderArticle', function ($stateParams, OrderArticle) {
                        return OrderArticle.get({id: $stateParams.id}).$promise;
                    }]
                }
            })

            //h5 小程序 (海报编辑器) 作品Three-- 预览
            .state('product-view5-ec', {
                parent: 'app',
                url: '/{storeId}/{aid}/view5',
                data: {
                    authorities: [],
                    pageTitle: 'editorApp.product.detail.viewTitle'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/product-ec/product-viewThree.html',
                        controller: 'ProductViewEcThreeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('editor');
                        $translatePartialLoader.addPart('common');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Article', function ($stateParams, Article) {
                        return Article.get({id: $stateParams.aid}).$promise;
                    }]
                }
            })
            .state('product-view5-ec-1', {
                parent: 'app',
                url: '/{storeId}/{orderArticleId}/view5-or',
                data: {
                    authorities: [],
                    pageTitle: 'editorApp.product.detail.viewTitle'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/product-ec/product-viewThree.html',
                        controller: 'ProductViewEcThreeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('editor');
                        $translatePartialLoader.addPart('common');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'OrderArticle', function ($stateParams, OrderArticle) {
                        return OrderArticle.get({id: $stateParams.orderArticleId}).$promise;
                    }]
                }
            })
            //h5 小程序 (海报编辑器) 作品Three--分享
            .state('product-viewShare', {
                parent: 'app',
                url: '/{storeId}/{aid}/viewShare',
                data: {
                    authorities: [],
                    pageTitle: 'editorApp.product.detail.shareTitle'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/product-ec/product-viewThree-share.html',
                        controller: 'ProductViewEcThreeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('editor');
                        $translatePartialLoader.addPart('common');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Article', function ($stateParams, Article) {
                        return Article.get({id: $stateParams.aid}).$promise;
                    }]
                }
            })

            //h5 小程序 (海报编辑器) 订单作品Three--预览  --订单预览没有二维码
            .state('product-viewPreview', {
                parent: 'app',
                url: '/{storeId}/{id}/viewPreview',
                data: {
                    authorities: [],
                    pageTitle: 'editorApp.product.detail.show'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/product-ec/product-viewThree-preview.html',
                        controller: 'ProductViewEcThreePreviewController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('editor');
                        $translatePartialLoader.addPart('common');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'OrderArticle', function ($stateParams, OrderArticle) {
                        return OrderArticle.get({id: $stateParams.id}).$promise;
                    }]
                }
            })

            //新增编辑器Three
            .state('editorPhotoAlbumM', {
                parent: 'app',
                url: '/{storeId}/{pid}/{vid}/{xmlId}/{aid}/photobook',
                data: {
                    authorities: [],
                    pageTitle: 'editorApp.product.home.title2'
                },

                views: {
                    'content@': {
                        templateUrl: 'app/entities/product-ec/editor-photoAlbum.html',
                        controller: 'EditorPhotoAlbumEcController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('editor');
                        $translatePartialLoader.addPart('gallery');
                        $translatePartialLoader.addPart('common');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            id: null
                        };
                    }
                }
            })
            .state('editorPhotoAlbumEditM', {
                parent: 'app',
                url: '/{storeId}/{aid}/photobookEdit',
                data: {
                    authorities: [],
                    pageTitle: 'editorApp.product.home.title2'
                },

                views: {
                    'content@': {
                        templateUrl: 'app/entities/product-ec/editor-photoAlbum.html',
                        controller: 'EditorPhotoAlbumEcController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('editor');
                        $translatePartialLoader.addPart('gallery');
                        $translatePartialLoader.addPart('common');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            id: null,
                            type: 'edit'
                        };
                    }
                }
            })

            .state('editorPhoto', {
                parent: 'app',
                url: '/{storeId}/{pid}/{vid}/{xmlId}/{aid}/editorPhoto',
                cache:false,
                data: {
                    authorities: [],
                    pageTitle: 'editorApp.product.home.title2'
                },

                views: {
                    'content@': {
                        templateUrl: 'app/entities/product-ec/editor-photo-both.html',
                        controller: 'EditorPhotoBothController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('editor');
                        $translatePartialLoader.addPart('gallery');
                        $translatePartialLoader.addPart('common');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            type: 'add'
                        };
                    }
                }
            })
            .state('editorPhotoEdit', {
                parent: 'app',
                url: '/{storeId}/{aid}/editorPhotoEdit',
                data: {
                    authorities: [],
                    pageTitle: 'editorApp.page.home.title'
                },
                views: {
                    'content2@': {
                        templateUrl: 'app/entities/product-ec/editor-photo-both.html',
                        controller: 'EditorPhotoBothController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('editor');
                        $translatePartialLoader.addPart('gallery');
                        $translatePartialLoader.addPart('common');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            type: 'edit'
                        };
                    }
                }
            })
            .state('editorPhotoPreview', {
                parent: 'app',
                url: '/{storeId}/{aid}/editorPhotoPreview',
                data: {
                    authorities: [],
                    pageTitle: 'editorApp.product.home.title2'
                },

                views: {
                    'content@': {
                        templateUrl: 'app/entities/product-ec/editor-photo-preview.html',
                        controller: 'EditorPhotoPreviewController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('editor');
                        $translatePartialLoader.addPart('gallery');
                        $translatePartialLoader.addPart('common');
                        return $translate.refresh();
                    }]
                }
            })
            .state('editorPhotoPreview1', {
                parent: 'app',
                url: '/{storeId}/{orderArticleId}/editorPhotoPreview-or',
                data: {
                    authorities: [],
                    pageTitle: 'editorApp.product.home.title2'
                },

                views: {
                    'content@': {
                        templateUrl: 'app/entities/product-ec/editor-photo-preview.html',
                        controller: 'EditorPhotoPreviewController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('editor');
                        $translatePartialLoader.addPart('gallery');
                        $translatePartialLoader.addPart('common');
                        return $translate.refresh();
                    }]
                }
            })
            .state('editorPhotoPreviewShare', {
                parent: 'app',
                url: '/{storeId}/{aid}/editorPhotoShare',
                data: {
                    authorities: [],
                    pageTitle: 'editorApp.product.home.title2'
                },

                views: {
                    'content@': {
                        templateUrl: 'app/entities/product-ec/editor-photo-share.html',
                        controller: 'EditorPhotoPreviewController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('editor');
                        $translatePartialLoader.addPart('gallery');
                        $translatePartialLoader.addPart('common');
                        return $translate.refresh();
                    }]
                }
            })


            .state('editorPhotoBoth', {
                parent: 'app',
                url: '/{storeId}/{pid}/{vid}/{xmlId}/{aid}/editorPhotoBoth',
                cache:false,
                data: {
                    authorities: [],
                    pageTitle: 'editorApp.product.home.title2'
                },

                views: {
                    'content@': {
                        templateUrl: 'app/entities/product-ec/editor-photo-both.html',
                        controller: 'EditorPhotoBothController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('editor');
                        $translatePartialLoader.addPart('gallery');
                        $translatePartialLoader.addPart('common');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            type: 'add'
                        };
                    }
                }
            })
            .state('editorPhotoBothEdit', {
                parent: 'app',
                url: '/{storeId}/{aid}/editorPhotoBothEdit',
                data: {
                    authorities: [],
                    pageTitle: 'editorApp.page.home.title'
                },
                views: {
                    'content2@': {
                        templateUrl: 'app/entities/product-ec/editor-photo-both.html',
                        controller: 'EditorPhotoBothController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('editor');
                        $translatePartialLoader.addPart('gallery');
                        $translatePartialLoader.addPart('common');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            type: 'edit'
                        };
                    }
                }
            })
            //表单编辑器
            .state('editorForm', {
                parent: 'app',
                url: '/{storeId}/{pid}/{vid}/{xmlId}/{aid}/editorForm',
                data: {
                    authorities: [],
                    pageTitle: 'editorApp.product.home.title2'
                },

                views: {
                    'content@': {
                        templateUrl: 'app/entities/product-ec/editor-form.html',
                        controller: 'EditorFormController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('editor');
                        $translatePartialLoader.addPart('gallery');
                        $translatePartialLoader.addPart('common');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            id: null
                        };
                    }
                }
            })

            .state('idPhoto', {
                parent: 'app',
                url: '/{storeId}/{pid}/{vid}/{xmlId}/{aid}/idPhoto',
                cache:false,
                data: {
                    authorities: [],
                    pageTitle: 'editorApp.product.home.title2'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/product-ec/id-photo.html',
                        controller: 'IdPhotoController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('editor');
                        $translatePartialLoader.addPart('gallery');
                        $translatePartialLoader.addPart('common');
                        return $translate.refresh();
                    }]
                }
            })
            .state('idPhotoEdit', {
                parent: 'app',
                url: '/{storeId}/{aid}/idPhotoEdit',
                data: {
                    authorities: [],
                    pageTitle: 'editorApp.page.home.title'
                },
                views: {
                    'content2@': {
                        templateUrl: 'app/entities/product-ec/id-photo.html',
                        controller: 'IdPhotoController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('editor');
                        $translatePartialLoader.addPart('gallery');
                        $translatePartialLoader.addPart('common');
                        return $translate.refresh();
                    }]
                }
            })
        ;
    }

})();

(function () {
    'use strict';
    angular
        .module('editorApp')
        .factory('Product', Product)
        .factory('MessageNotification', MessageNotification)
        .factory('WechatAuth', WechatAuth)
        .factory('PlatformWechatSetting', PlatformWechatSetting)
        .factory('PageForView', PageForView)
        .factory('PlatformAbutment', PlatformAbutment)
        .factory('Cart', Cart)
        .factory('Iphone', Iphone)
        .factory("OrderArticle", OrderArticle)
        .factory("DiyEditorSetting", DiyEditorSetting)
        .factory("RecommendPics", RecommendPics)
        .factory("ImgprocContours", ImgprocContours);

    WechatAuth.$inject = ['$resource'];
    Product.$inject = ['$resource'];
    MessageNotification.$inject = ['$resource'];
    PlatformWechatSetting.$inject = ['$resource'];
    PageForView.$inject = ['$resource'];
    PlatformAbutment.$inject = ['$resource'];
    Cart.$inject = ['$resource'];
    OrderArticle.$inject = ['$resource'];
    DiyEditorSetting.$inject = ['$resource'];
    RecommendPics.$inject = ['$resource'];
    ImgprocContours.$inject = ['$resource'];

    function ImgprocContours ($resource, DateUtils) {
        var resourceUrl =  'imgproc/' + 'api/contours/:path/:id';

        return $resource(resourceUrl, {}, {
            'buildServiceImage': {
                method: 'POST',
                params: {
                    path: 'buildServiceImage'
                }
            },
            'generateContour': {
                method: 'POST',
                params: {
                    path: 'generateContour'
                }
            },
            'parseContour': {
                method: 'POST',
                params: {
                    path: 'parseContour'
                }
            },
        });
    }
    function RecommendPics ($resource, DateUtils) {
        var resourceUrl =  'manager/' + 'api/recommend-pics/:path/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'byCondition': {
                method: 'POST',
                params: {
                    path: 'byCondition'
                }
            },
            'byCondition2': {
                method: 'POST',
                params: {
                    path: 'byCondition2'
                }
            },
            'getAllByCondition': {
                method: 'POST',
                params: {
                    path: 'getAllByCondition'
                }
            },
            'getAllByCondition2': {
                method: 'POST',
                params: {
                    path: 'getAllByCondition2'
                }
            },
        });
    }
    function WechatAuth($resource) {
        var resourceUrl = 'manager/' + 'wx/:path/:id';
        return $resource(resourceUrl, {}, {
            "auth_notify3": {
                method: "GET",
                params: {
                    path: "customer/auth_notify3"
                }
            },
            "auth_notify4": {
                method: "GET",
                params: {
                    path: "customer/auth_notify4"
                }
            },

        });
    }

    function Product($resource) {
        var resourceUrl = 'manager/' + 'api/products/:path/:id';

        return $resource(resourceUrl, {}, {
            "getAllByCondition": {
                method: "POST",
                params: {
                    path: "getAllByCondition"
                }
            },
            "getAllByCondition2": {
                method: "POST",
                params: {
                    path: "getAllByCondition2"
                }
            },
            "byCondition2":{
                method:"POST",
                params:{
                    path:"byCondition2"
                }
            },
            "byCondition": {
                method: "POST",
                params: {
                    path: "byCondition"
                }
            },
            'get': {
                method: 'GET',
                params: {
                    path: "client"
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }

    function MessageNotification ($resource) {
        var resourceUrl =  'manager/' + 'api/message-notifications/:path/:id';

        return $resource(resourceUrl, {}, {
            "getAllByCondition2":{
                method:"POST",
                params:{
                    path:"getAllByCondition2"
                }
            },
            "getAllByCondition":{
                method:"POST",
                params:{
                    path:"getAllByCondition"
                }
            }
        });
    }

    function PlatformWechatSetting($resource) {
        var resourceUrl = "manager/api/platform-settings/:path/:id";

        return $resource(resourceUrl, {}, {
            "get": {
                method: "GET"
            }
        });
    }

    function PageForView($resource) {
        var resourceUrl = "service/api/page-for-views/:path/:id";
        return $resource(resourceUrl, {}, {
            "get": {
                method: "GET"
            }
        });
    }

    function PlatformAbutment ($resource) {
        var resourceUrl =  'manager/' + 'api/platform-abutment/:path/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET'
            },
            'getAllByCondition':{
                method: 'POST',
                params: {
                    path: 'getAllByCondition'
                }
            }
        });
    }

    function Cart ($resource) {
        var resourceUrl =  'service/' + 'api/carts/:path/';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET'
            },
            'addGoods':{
                method: 'GET',
                params: {
                    path: 'addGoods'
                }
            },
            "quantityChange":{
                method: 'GET',
                params: {
                    path: 'quantityChange'
                }
            },
            'removeGoods':{
                method: 'GET',
                params: {
                    path: 'removeGoods'
                }
            }
        });
    }

    function OrderArticle($resource) {
        var resourceUrl = 'service/' + 'api/order-articles/:path/:id';
        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getByUser': {
                method: 'GET',
                params: {
                    path: 'getByUser'
                }
            }
        })
    }

    function DiyEditorSetting ($resource) {
        var resourceUrl =  'manager/' + 'api/diy-editor-settings/:path/:id';
        return $resource(resourceUrl, {}, {
            'getOne4Platform': {
                method: 'GET',
                params: {
                    path: 'getOne4Platform'
                }
            },
            'byCondition1': {
                method: 'POST',
                params: {
                    path: 'byCondition1'
                }
            },
            "getAllByCondition1":{
                method:"POST",
                params:{
                    path:"getAllByCondition1"
                }
            },
            'byCondition': {
                method: 'POST',
                params: {
                    path: 'byCondition'
                }
            },
            "getAllByCondition":{
                method:"POST",
                params:{
                    path:"getAllByCondition"
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'save': { method:'POST' },
            'deleteBatch': {
                method: 'GET',
                params: {
                    path: 'deleteBatch'
                }
            },
            'enable':{
                method: 'GET',
                params: {
                    path: 'enable'
                }
            }
        });
    }
    function Iphone () {
        var isIphone = /iphone/gi.test(window.navigator.userAgent);
        var isIphone678 = window.screen.width === 375 && window.screen.height === 667;
        var isIphone678p = window.screen.width === 414 && window.screen.height === 736;
        var isIphoneSE = window.screen.width === 320 && window.screen.height === 568;
        var isIphone5 = window.screen.width === 320 && window.screen.height === 568;
        if (!isIphone || isIphone && (isIphone678 || isIphone678p || isIphoneSE || isIphone5)) {
            return false
        } else {
            return true
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('editorApp')
        .controller('ProductEcController', ProductEcController);

    ProductEcController.$inject = ['$state', '$scope', '$q', 'UidService', '$stateParams', 'Convert', 'Qinius', 'QiniuToken', 'Gallery', 'ItemValue', 'SweetAlert', 'Theme', '$timeout', 'FontManagement', '$rootScope'
        , 'ImageService', 'ClipArt', 'PlatformWechatSetting', 'Store', 'CommonService', '$http', 'Folder',
        'Product', 'ProductXml', 'MessageNotification', 'ThemeClassify', 'Article','ListService','WxJS',
        'StoreWorkEditConfig', '$translate', '$localStorage','IMAGE_SUPPORTED_MIME'];

    function ProductEcController($state, $scope, $q, UidService, $stateParams, Convert, Qinius, QiniuToken, Gallery, ItemValue, SweetAlert, Theme, $timeout, FontManagement, $rootScope
        , ImageService, ClipArt, PlatformWechatSetting, Store, CommonService, $http, Folder,
        Product, ProductXml, MessageNotification, ThemeClassify, Article,ListService,WxJS,
        StoreWorkEditConfig, $translate, $localStorage, IMAGE_SUPPORTED_MIME) {

        var vm = this;
        //阻止微信端长按赋值保存图片
        document.oncontextmenu = function (e) {
            //或者return false;
            e.preventDefault();
        };

        var variableDatas = JSON.parse(localStorage.getItem('variableData'));
        vm.variableTextDatas = [];
        vm.variableBoxDatas=[];
        $scope.agentIos = false;

        //风格切换  引入不同的css文件
        Theme.judge();

        $(".navbar-gallery").hide();
        $(".wrap").show().addClass('no-margins');
        $(".well").css({'margin-bottom': 0});
        vm.storeId = $stateParams.storeId;
        vm.pid = $stateParams.pid;
        vm.aid = $stateParams.aid;
        vm.vid = $stateParams.vid;
        vm.xmlId = $stateParams.xmlId;
        vm.isEdit = vm.pid ? false : true;
        vm.pattern = 'BOOK';
        vm.replace = "true";

        vm.supportedMimeTypes = IMAGE_SUPPORTED_MIME;
        $scope.dWidth = document.documentElement.clientWidth;
        $("body").css({width: $scope.dWidth, 'min-width': $scope.dWidth});
        $scope.status = localStorage.getItem('Production');

        $scope.countN = parseInt(localStorage.getItem('countN'));
        var isChoose = localStorage.getItem("choose");
        var tt = localStorage.getItem('guide-step');
        if ($scope.status == 'make' && tt) {
            localStorage.setItem('countN', 8);
            $scope.countN = 8;
        } else {
            $scope.countN = parseInt(localStorage.getItem('countN'));
        }

        if (tt == 'true') {
            vm.guideStep = true;
        } else if (tt == 'false' || tt == '' || tt == null || tt == undefined) {
            vm.guideStep = false;
        }
        $scope.domains = Qinius.getDomain();
        var unsubQiniuToken = QiniuToken.subscribe('get', {}, function (token) {
            vm.token = token;
        });
        $scope.$on('$destroy', unsubQiniuToken);
        vm.platformSetting = PlatformWechatSetting.get();
        Store.get({id: vm.storeId}, function (res) {
            if(res.status == 200){
                vm.store = res.data;
            }else {
                MessageService.error(res.message);
            }
        });
        vm.fontuuids = [];

        vm.windowDpiW = js_getDPI();

        var url = window.location.hash && window.location.href.slice(0, -window.location.hash.length) || window.location.href;
        localStorage.setItem('url', url);

        vm.editHeight = document.documentElement.clientHeight;

        if (!window.__wxjs_is_wkwebview) {
            $scope.dHeight = vm.editHeight;
            // 禁止安卓默认事件
            var androidDefault = document.querySelector('.page-make');
            androidDefault.addEventListener('contextmenu', function (e) {
                e.preventDefault();
            });
        } else {
            $scope.dHeight = localStorage.getItem('windowMinH') || vm.editHeight;
        }

        var unitTransform = function (mm) {
            // mm换算成px  Math.ceil(mm / 25.4 * 300);
            // return (mm * 3) - 0;
            return mm / 25.4 * vm.windowDpiW;
        };
        var unitTransformPx = function (px) {
            // px换算成mm  Math.floor(px / 300 * 25.4)
            // return (px * 1 / 3).toFixed(2) - 0;
            return px / vm.windowDpiW * 25.4;
        };

        var $he = $(window).height()/2;
        $('.arrowCircle-up').on('click',function(e){
            e.preventDefault();
            var scrollTop = $(".edit-page-content").scrollTop();
            var cha = (scrollTop - $he)>0? scrollTop - $he : 0;
            $(".edit-page-content").scrollTop(cha);
        });
        $('.arrowCircle-down').on('click',function(e){
            e.preventDefault();
            var scrollTop = $(".edit-page-content").scrollTop();
            $(".edit-page-content").scrollTop(scrollTop+$he);
        });

        $scope.isSave = false;
        $rootScope.currentCarouselIndex = 0;
        $scope.selectSketchMenu = 'sketch-color';
        $scope.colorList = ['#ff001e', '#ff5c00', '#ff9700', '#61734d', '#838c97', '#8d4ac8', '#b8e986', '#7e6565', '#ffffff', '#f1e7d9', '#b5ce99', '#82c281', '#dac2ef', '#000', '#797979', '#7c330a', '#eec78d', '#444444', '#589ceb', '#4a7bc8', '#ddabab'];
        $scope.selectedColor = $scope.colorList[0];
        $scope.stickerList = [];
        $scope.selectedFont = '';
        $scope.domain = null;
        $scope.update = false;
        $scope.PAGELEN = 0;
        //底部模板栏，像素栏，图片栏高度:84+pading:8   =100
        $scope.mHeight = 84;
        //52+62+100 +20
        $scope.tHeight = 240;
        // 左移按钮
        $scope.visibleLeft = false;
        // 右移按钮
        $scope.visibleRight = false;
        // 编辑按钮
        $scope.showBarMenu = true;
        // 底部按钮栏
        $scope.showBottomMenu = true;
        $scope.showTempMenu = false;
        $scope.showImageMenu = false;
        $scope.showCut = false;
        $scope.showText = false;
        $scope.loading = true;
        $scope.template = {pages: {page: []}};
        $scope.weixinFlag = localStorage.getItem('distinguish');
        $scope.template.maxPageHeight = 0;
        vm.edit = false;
        vm.FirstSeven = 0;
        vm.flags = false;
        vm.isOrientation = false;

        vm.counts = 0;

        // 成功多少张
        var indd = 0;
        var errorImageArr = [];
        var initValue = 0;

        vm.galleryPage = [];
        vm.loadMore = loadMore;
        vm.indexNum = 0;
        vm.itemsPerPage = 20;
        vm.more = true;
        $scope.gallaryPic = [];         //个人图片库选择

        $scope.currentNav = 'gallery';
        // 是否进入文件夹内
        $scope.folderInside = false;
        // 选中的某一文件夹信息
        $scope.folderOne = {};
        // 是否点击移动按钮
        $scope.moveGallery = false;
        // 文件夹点击
        $scope.selectAllFolder = false;
        $scope.selectOne = {
            folderId: '',
            selected: false
        };
        $scope.selectAllGallery = false;
        $scope.moveGalleryIds = [];
        $scope.folderIds = [];
        $scope.editFolderNameArr = [];
        var monthStr = new Date().getMonth() + 1;
        var dayStr = new Date().getDate();
        var timestr = new Date().getFullYear() + "-" + (monthStr > 9 ? monthStr : "0" + monthStr) + "-" + (dayStr > 9 ? dayStr : "0" + dayStr);
        getMessageNotification();
        function getMessageNotification(){
            //工作区
            MessageNotification.getAllByCondition2({
                items: [
                    {key: "available", op: "=", value: "true"},
                    {key: "validate", op: ">=", value: timestr},
                    {key: "pageType", op: "=", value: "Gallery"}]
            }, function (res) {
                if(res.status == 200){
                    res.data.sort(compare('seq'))
                    vm.messageGallery = angular.copy(res.data);
                    vm.messageGalleryText = "\xa0\xa0\xa0\xa0\xa0\xa0";
                    angular.forEach(res.data, function (resp, i) {
                        vm.messageGalleryText += resp.content
                        if (i != res.data.length - 1) {
                            vm.messageGalleryText += "\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0"
                        }
                    })
                }else {
                    MessageService.error(res.message);
                }
            });
            // 平铺
            MessageNotification.getAllByCondition2({
                items: [
                    {key: "available", op: "=", value: "true"},
                    {key: "validate", op: ">=", value: timestr},
                    {key: "pageType", op: "=", value: "Tile"}]
            }, function (res) {
                if(res.status == 200){
                    res.data.sort(compare('seq'))
                    vm.messageTile = angular.copy(res.data);
                    vm.messageTileText = "\xa0\xa0\xa0\xa0\xa0\xa0";
                    angular.forEach(res.data, function (resp, i) {
                        vm.messageTileText += resp.content
                        if (i != res.data.length - 1) {
                            vm.messageTileText += "\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0"
                        }
                    })
                }else {
                    MessageService.error(res.message);
                }
            });
            //编辑
            MessageNotification.getAllByCondition2({
                items: [
                    {key: "available", op: "=", value: "true"},
                    {key: "validate", op: ">=", value: timestr},
                    {key: "pageType", op: "=", value: "Edit"}]
            }, function (res) {
                if(res.status == 200){
                    res.data.sort(compare('seq'))
                    vm.message = angular.copy(res.data);
                    vm.messageEdit = angular.copy(res.data);
                    vm.messageEditText = "\xa0\xa0\xa0\xa0\xa0\xa0";
                    angular.forEach(res.data, function (resp, i) {
                        vm.messageEditText += resp.content
                        if (i != res.data.length - 1) {
                            vm.messageEditText += "\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0"
                        }
                    })
                }else {
                    MessageService.error(res.message);
                }
            });
        }

        var mL = 0, liW = 0, ulW = 0, selectTextIndex = 0;
        var runR = true, runL = true, flag = true, isDragging = false, moveSticker = false, moveText = false;
        var drag;
        var dragBox = {}, stickerDragBox = {};
        var goes = [], local_pages = [];
        var $ul = $(".carousel5");
        var $li = $(".template-carousel");
        $li.hide();

        function getLocalStorage() {
            // 工作区中编辑作品所用到的图片
            $scope.qiniuId = JSON.parse(localStorage.getItem("gallery")) || [];
            // $scope.template.pages数据
            local_pages = JSON.parse(localStorage.getItem("pages")) || [];
        }

        if ($scope.status == 'make' || $scope.status == 'view') {
            goToMake()
        }

        //这一步是分页下拉  刷新滚动条置顶
        window.scrollTo(0, 0);

        function loadAll(folderId) {
            if (folderId == 'isNull') {
                Gallery.storeByCondition({
                    items: [{key: "folderId", op: "isNull", value: ''},{key: "articleId", op: "=", value: vm.aid}],
                    page: vm.indexNum,
                    size: vm.itemsPerPage,
                    sort: sorts()
                }, onSuccess, onError);
            } else {
                Gallery.storeByCondition({
                    items: [{key: "folderId", op: "=", value: folderId},{key: "articleId", op: "=", value: vm.aid}],
                    page: vm.indexNum,
                    size: vm.itemsPerPage,
                    sort: sorts()
                }, onSuccess, onError);
            }
        }

        function sorts() {
            return ["id,desc"];
        }

        function onSuccess(res) {
            if(res.status == 200){
                if (res.data.length < vm.itemsPerPage) {
                    vm.more = false;
                    flag = false;
                } else {
                    vm.more = true;
                    flag = true;
                }
                angular.forEach(res.data, function (item) {
                    item.usenum = 0;
                    item.identifier = $scope.domain + item.identifier;
                    vm.galleryPage.push(item);
                });
                getPagePhoto();
            }else {
                MessageService.error(res.message);
            }
        }

        function onError(error) {
            if(error.status !== 403){
                swal({
                    title: $translate.instant("galleryMessage.failedToObtainThePhotoGallery"),
                    text: "",
                    imageUrl: Theme.sweetHintImg(),
                    timer: 2000,
                    showConfirmButton: false
                });
            }

        }


        function loadMore() {
            vm.indexNum++;
            if ($scope.folderInside) {
                loadAll($scope.folderOne.id);
            } else {
                loadAll('isNull');
            }
        }

        $scope.getCount = function () {
            if ($scope.qiniuId == null) {
                return vm.count;
            }
            if (vm.counts - $scope.qiniuId.length > 0) {
                return vm.counts - $scope.qiniuId.length;
            } else {
                return 0;
            }
        };

        //获取分页图片 (删除、上传都会重新刷新获取一定数量的照片)
        function getPagePhoto() {
            // console.log(vm.galleryPage);//这个是分页限制的数据格式 每次只显示10条
            var timeList = [];
            vm.photoArray = [];
            //判断日期是否重复
            for (var i = 0; i < vm.galleryPage.length; i++) {
                var photoCreatedDate = new Date(vm.galleryPage[i].createdDate);
                if (checkExist(timeList, photoCreatedDate)) {
                    timeList.push(photoCreatedDate);
                }
            }
            //将相同日期下的照片整合
            for (var m = 0; m < timeList.length; m++) {
                var tempObj = {};
                var tempItems = [];
                for (var j = 0; j < vm.galleryPage.length; j++) {
                    var createdDate = new Date(vm.galleryPage[j].createdDate);
                    if (timeList[m].getFullYear() == createdDate.getFullYear() &&
                        timeList[m].getMonth() == createdDate.getMonth() &&
                        timeList[m].getDate() == createdDate.getDate()) {
                        tempItems.push(vm.galleryPage[j])
                    }
                }
                var time = timeList[m].getFullYear() + '年' + (timeList[m].getMonth() + 1) + '月' + timeList[m].getDate() + '日';
                tempObj = {"createDate": time, "galleries": tempItems};
                vm.photoArray.push(tempObj);
            }
            $scope.photos = vm.photoArray;
            $(".photo-show").show();
        }

        /**
         * 加载七牛域名和localStorage
         */
        $q.all([$scope.domains.$promise, vm.platformSetting.$promise]).then(function () {
            vm.platformSetting = vm.platformSetting.data;


            vm.lagnuages =[];
            if ($localStorage.lagnuages) {
                for(var i = 0 ; i<$localStorage.lagnuages.length; i++ ){
                    var lang = $localStorage.lagnuages[i];
                    var langObj = {key:lang};
                    if (lang == 'zh-cn') {
                        langObj.value = "中文";
                    }
                    if (lang == 'en') {
                        langObj.value = "English";
                    }
                    if (vm.lang == lang) {
                        vm.langValue = langObj.value;
                        langObj.selected = true;
                    }
                    vm.lagnuages.push(langObj);
                }
            }

            if (wx) {
                var url = window.location.hash && window.location.href.slice(0, -window.location.hash.length) || window.location.href;
                WxJS.get({url: url}, function (res) {
                    if(res.status==200) {
                        $scope.agentIos = browserVersions();
                        var config = res.data;
                        wx.config({
                            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                            appId: config.appId, // 必填，公众号的唯一标识
                            timestamp: config.timestamp, // 必填，生成签名的时间戳
                            nonceStr: config.nonceStr, // 必填，生成签名的随机串
                            signature: config.signature,// 必填，签名，见附录1
                            jsApiList: ['chooseImage', 'uploadImage', 'hideMenuItems'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                        });
                        wx.ready(function () {
                            console.log('wechat api ready!');

                            wx.hideMenuItems({
                                menuList: ["menuItem:copyUrl", "menuItem:share:timeline", "menuItem:share:appMessage", "menuItem:share:qq", "menuItem:share:appMessage", "menuItem:share:QZone"]
                            });
                        });
                        wx.error(function (res) {
                            console.log(res)
                        });
                    }
                }, function () {
                    console.log("wx config error");
                });
            }

            //设置回退事件
            $scope.bool = false;
            //监听浏览器返回的事件
            setTimeout(function () {
                $scope.bool = true;
            }, 2000);
            window.addEventListener("popstate", function (e) {
                if (window.location.href.indexOf("choose") > 0 || window.location.href.indexOf("chooses") > 0) {
                    if ($scope.bool) {
                        swal({
                            title: $translate.instant("choose.editorMessage.worksNoSave"),
                            text: $translate.instant("choose.editorMessage.sendBackCatalog"),
                            imageUrl: Theme.sweetHintImg(),
                            timer: 2000,
                            showConfirmButton: false
                        });
                    }
                    $(".folder-footer").show();
                    removeAlertClass();
                    $scope.bool = false;
                } else if (window.location.href == (vm.platformSetting.editorNotifyUrl + '/#/') || window.location.href == vm.platformSetting.editorNotifyUrl + '/#/login') {
                    if (vm.pid && vm.vid) {
                        $state.go('product-choose-ec', {
                            storeId: vm.storeId,
                            pid: vm.pid,
                            vid: vm.vid,
                            xmlId: vm.xmlId,
                            aid: vm.aid
                        }, {reload: false});
                    }else if (vm.aid) {
                        $state.go('product-chooses-ec', {
                            storeId: vm.storeId,
                            aid: vm.aid
                        }, {reload: false});
                    }
                } else if (window.location.href == (vm.platformSetting.editorNotifyUrl + '/#/login')) {
                    var url = "";
                    if (vm.pid && vm.vid) {
                        url = vm.platformSetting.editorNotifyUrl + '/#/' + vm.storeId + '/' + vm.pid + '/' + vm.vid + '/' + vm.aid + '/productThumbnail';
                    } else {
                        //编辑
                        url = vm.platformSetting.editorNotifyUrl + '/#/' + vm.storeId + '/' + vm.aid + '/view';
                    }
                    window.location.href = url;
                }
            }, false);
            function pushHistory() {
                var url = null;
                //新建
                if (vm.pid && vm.vid) {
                    url = vm.platformSetting.editorNotifyUrl + '/#/' + vm.storeId + '/' + vm.pid + '/' + vm.vid + '/' + vm.aid + '/productThumbnail';
                } else {
                    //编辑
                    url = vm.platformSetting.editorNotifyUrl + '/#/' + vm.storeId + '/' + vm.aid + '/view';
                }
                var state = {
                    title: "",
                    url: url
                };
                window.history.pushState(state, "");
            }

            pushHistory();

            //设置title
            CommonService.setDocumentTitle($translate.instant("choose.title"));
            $scope.status = localStorage.getItem('Production');
            $scope.domain = 'https://' + $scope.domains.domains[0] + '/';
            // token过期 — QiniuToken 单例自动刷新
            loadAll('isNull');
            loadFolders();
            getItem();
            vm.counts = localStorage.getItem('article-count');
            /**
             * 上传本地图片
             * 保存到七牛
             */
            $scope.chooseWx = function () {
                initValue = $scope.qiniuId.length;
                var upindex = 0;
                wx.chooseImage({
                    count: 9, // 默认9
                    sizeType: ['original'], // 可以指定是原图还是压缩图，默认二者都有
                    sourceType: ['album'], // 可以指定来源是相册还是相机，默认二者都有
                    success: function (res) {
                        var localIds = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
                        $(".save-pages").removeClass('hide1');
                        asyncGetImg(localIds);

                        function asyncGetImg(datas) {
                            $(".save-pages").addClass('hide1');
                            setTimeout(function () {
                                swal({
                                    title: $translate.instant("choose.editorMessage.startUploading",{datasLength:datas.length}),
                                    text: $translate.instant("choose.editorMessage.imagUploaSlow")+"\n"+$translate.instant("choose.editorMessage.pleaseWaitPatiently"),
                                    showConfirmButton: false,
                                    type: "info"
                                });
                            }, 500);

                            indd = 0; //成功张数
                            errorImageArr = []; //失败张数
                            var index_ = 0;
                            if (datas.length > index_) {
                                getImg2(datas, index_);
                            }
                        }

                        function getImg2(datas, index_) {
                            //上传到微信服务器
                            wx.uploadImage({
                                localId: datas[index_],
                                isShowProgressTips: 1,
                                success: function (res) {
                                    index_++;
                                    if (datas.length > index_) {
                                        getImg2(datas, index_);
                                    }
                                    swal({
                                        title: $translate.instant("choose.editorMessage.thePictureIsUploaded")+"(" + (indd + 1 + errorImageArr.length) + "/" + datas.length + ")....",
                                        text: $translate.instant("choose.editorMessage.imagUploaSlow")+"\n"+$translate.instant("choose.editorMessage.pleaseWaitPatiently"),
                                        showConfirmButton: false,
                                        type: "info"
                                    });
                                    Gallery.upload({
                                        identifiers: res.serverId,
                                        provider: "QINIU",
                                        fileName: '',
                                        imgSize: 0,
                                        folderId: $scope.folderOne ? $scope.folderOne.id : '',
                                        articleId:vm.aid
                                    }, function (resp) {
                                        if(resp.status==200){
                                            console.log('Gallery.upload服务器输出' + resp.data);
                                            qiniuToImg(resp.data);
                                            indd++;
                                            if (indd == datas.length) {
                                                setTimeout(function () {
                                                    var text = '';
                                                    if ($scope.status == 'start') {
                                                        text = (datas.length + initValue - $scope.qiniuId.length) > 0 ?  $translate.instant("choose.editorMessage.pictureRepetition",{pictureLength:(datas.length + initValue - $scope.qiniuId.length)}): ''
                                                    }
                                                    swal({
                                                        title: $translate.instant("choose.editorMessage.uploadCompleted"),
                                                        text: text,
                                                        imageUrl: Theme.sweetSuccedImg(),
                                                        confirmButtonText: $translate.instant("choose.editor.confirm")
                                                    });
                                                }, 1000);

                                                updatePic();

                                            } else if (datas.length == (indd + errorImageArr.length) && errorImageArr.length != 0) {
                                                SweetAlert.swal({
                                                    title: $translate.instant("choose.editorMessage.uploadCompleted"),
                                                    text: $translate.instant("choose.editorMessage.pictureRepetition",{pictureLength:errorImageArr.length}),
                                                    imageUrl: Theme.sweetHintImg(),
                                                    showCancelButton: true,
                                                    confirmButtonText: $translate.instant("choose.editor.confirm"),
                                                    cancelButtonText: $translate.instant("choose.editor.cancel")
                                                }, function (isConfirm) {
                                                    if (isConfirm) {
                                                        asyncGetImg(errorImageArr);
                                                    } else {
                                                        SweetAlert.swal({
                                                            title: $translate.instant("choose.editorMessage.pictureUploadingCancel"),
                                                            imageUrl: Theme.sweetHintImg(),
                                                            text: "",
                                                            timer: 2000,
                                                            showConfirmButton: false
                                                        });

                                                        updatePic();
                                                    }
                                                })

                                            }
                                        }
                                    }, function (error) {
                                        errorImageArr.push(datas[index_]);
                                        //最后一个失败了的话
                                        if (datas.length == (indd + errorImageArr.length)) {
                                            SweetAlert.swal({
                                                title: $translate.instant("choose.editorMessage.uploadCompleted"),
                                                text: $translate.instant("choose.editorMessage.pictureRepetition",{pictureLength:errorImageArr.length}),
                                                imageUrl: Theme.sweetHintImg(),
                                                showCancelButton: true,
                                                confirmButtonText:  $translate.instant("choose.editor.confirm"),
                                                cancelButtonText: $translate.instant("choose.editor.cancel")
                                            }, function (isConfirm) {
                                                if (isConfirm) {
                                                    asyncGetImg(errorImageArr);
                                                } else {
                                                    SweetAlert.swal({
                                                        title: $translate.instant("choose.editorMessage.pictureUploadingCancel"),
                                                        imageUrl: Theme.sweetHintImg(),
                                                        text: "",
                                                        timer: 2000,
                                                        showConfirmButton: false
                                                    });
                                                }
                                            })
                                        }
                                    });
                                },
                                error: function (error) {
                                    swal({
                                        title: $translate.instant("choose.editorMessage.thePictureIsUploaded")+"(" + (indd + 1 + errorImageArr.length) + "/" + datas.length + ")....",
                                        text: $translate.instant("choose.editorMessage.imagUploaSlow")+"\n"+$translate.instant("choose.editorMessage.pleaseWaitPatiently"),
                                        showConfirmButton: false,
                                        type: "info"
                                    });
                                    index_++;
                                    if (datas.length > index_) {
                                        getImg2(datas, index_);
                                    }
                                    errorImageArr.push(datas[index_]);
                                    //最后一个失败了的话
                                    if (datas.length == (indd + errorImageArr.length)) {
                                        SweetAlert.swal({
                                            title: $translate.instant("choose.editorMessage.uploadCompleted"),
                                            text: $translate.instant("choose.editorMessage.pictureRepetition",{pictureLength:errorImageArr.length}),
                                            imageUrl: Theme.sweetHintImg(),
                                            showCancelButton: true,
                                            confirmButtonText: $translate.instant("choose.editor.confirm"),
                                            cancelButtonText: $translate.instant("choose.editor.cancel")
                                        }, function (isConfirm) {
                                            if (isConfirm) {
                                                asyncGetImg(errorImageArr);
                                            } else {
                                                SweetAlert.swal({
                                                    title: $translate.instant("choose.editorMessage.pictureUploadingCancel"),
                                                    imageUrl: Theme.sweetHintImg(),
                                                    text: "",
                                                    timer: 2000,
                                                    showConfirmButton: false
                                                });
                                            }
                                        })
                                    }
                                }
                            });
                        }
                    }
                });
            };

            //非调用微信公众号上传图片 无9张限制 可多张上传 上传到七牛  并且可以返回路径在页面显示
            window.uploadPicMutiple = function ($event) {
                initValue = $scope.qiniuId.length;
                var files = [];
                vm.higherSize = [];
                for (var i = 0; i < $event.target.files.length; i++) {
                    var f = $event.target.files[i];
                    if(f.type =='image/png'||f.type =='image/jpeg'||f.type =='image/jpg'||!f.type){
                        f.imgSize = f.size;
                        if ( f.size / 1024 > 20480) {
                            vm.higherSize.push(i + 1);
                        }
                        files.push(f)
                    }
                }

                if (vm.higherSize.length > 0) {
                    $scope.bigSizeTip = true;
                    $scope.higherSizeLen = vm.higherSize.length;
                    $scope.$digest();

                } else {
                    if(files.length > 0) {
                        $(".save-pages").removeClass('hide1');
                        filterUpload(files);
                    }
                }

                $scope.filterBigSize = function () {
                    $scope.bigSizeTip = false;
                    console.log(files)
                    files = files.filter(function (item, index) {
                        return item.size / 1024 < 20480;
                    });
                    if (files.length == 0) {
                        updatePic();
                    } else {
                        filterUpload(files);
                    }
                }
            };
        });

        function filterUpload(files) {
            $(".save-pages").addClass('hide1');
            asyncUpload(files)
        }

        function asyncUpload(files) {
            indd = 0;
            errorImageArr = [];
            setTimeout(function () {
                swal({
                    title: $translate.instant("uploadContent.startUploading",{datasLength:files.length}),
                    text: $translate.instant("uploadContent.greatBeach"),
                    showConfirmButton: false,
                    type: "info"
                });
            }, 500);
            for (var i = 0; i < 5 && i < files.length; i++) {
                var file = files[i];
                qiniuUpload(file, files, i);
            }
        }

        function qiniuUpload(file, files, index_) {
            var formData = new FormData();
            formData.append('file', file);
            formData.append('unique_names', false);
            formData.append('key', "file-" + UidService.get());
            formData.append('token', vm.token);
            var reader = new FileReader();
            reader.readAsArrayBuffer(file)
            reader.onloadend = function (e) {
                formData.append('crc32', CRC32.buf(new Uint8Array(this.result)));
                $.ajax({
                    cache: true,
                    type: "POST",
                    url: 'https://upload.qiniup.com/',
                    data: formData,
                    async: true,
                    contentType: false,
                    processData: false,
                    success: function (data) {
                        swal({
                            title: $translate.instant("uploadContent.startUploading2",{currentLenght:indd + 1 + errorImageArr.length,datasLength:files.length}),
                            text: $translate.instant("uploadContent.greatBeach"),
                            showConfirmButton: false,
                            type: "info"
                        });
                        $.ajax({
                            type: "GET",
                            url: $scope.domain + data.key + "?imageInfo",
                            success: function (va) {
                                if (va.orientation == "Left-bottom" || va.orientation == "Right-top" || va.orientation == "Left-top" || va.orientation == "Right-bottom") {
                                    file.width = va.height;
                                    file.height = va.width;
                                } else {
                                    file.width = va.width;
                                    file.height = va.height;
                                }
                                serviceUpload(data, file, files.length);
                            },
                            error: function (request) {
                                serviceUpload(data, file, files.length);
                            }
                        });
                        if (files.length > index_ + 1 && index_ >= 4) {
                            var f = files[index_ + 1];
                            qiniuUpload(f, files, index_ + 1);
                        }
                    },
                    error: function (request) {
                        errorImageArr.push(file);
                        //最后一个失败了的话
                        if (files.length == (indd + errorImageArr.length)) {
                            SweetAlert.swal({
                                title: $translate.instant("choose.editorMessage.uploadCompleted"),
                                text: $translate.instant("choose.editorMessage.pictureRepetition",{pictureLength:errorImageArr.length}),
                                imageUrl: Theme.sweetHintImg(),
                                showCancelButton: true,
                                confirmButtonText: $translate.instant("choose.editor.confirm"),
                                cancelButtonText: $translate.instant("choose.editor.cancel")
                            }, function (isConfirm) {
                                if (isConfirm) {
                                    asyncUpload(errorImageArr);
                                } else {
                                    SweetAlert.swal({
                                        title: $translate.instant("choose.editorMessage.pictureUploadingCancel"),
                                        imageUrl: Theme.sweetHintImg(),
                                        text: "",
                                        timer: 2000,
                                        showConfirmButton: false
                                    });
                                    updatePic();
                                }
                            })
                        }else{
                            swal({
                                title: $translate.instant("choose.editorMessage.uploadCompleted"),
                                text: $translate.instant("choose.editorMessage.pictureRepetition",{pictureLength:errorImageArr.length}),
                                showConfirmButton: false,
                                type: "info"
                            });
                        }
                    }
                });
            }
        }

        function serviceUpload(data, file, len) {
            Gallery.upload({
                identifiers: data.key,
                provider: "QINIU",
                fileName: file.name,
                imgSize: file.size,
                width: file.width,
                height: file.height,
                folderId: $scope.folderOne ? $scope.folderOne.id : '',
                articleId:vm.aid
            }, function (resp) {
                if(resp.status == 200){
                    indd++;
                    if (len == indd) {
                        setTimeout(function () {
                            var text = '';
                            if ($scope.status == 'start') {
                                // text = (len + initValue - $scope.qiniuId.length) > 0 ? "存在" + (len + initValue - $scope.qiniuId.length) + "张照片重复\n请重新选择上传" : ''
                                text = (len + initValue - $scope.qiniuId.length) > 0 ? $translate.instant("uploadContent.photoRepetition",{repeatCount:len + initValue - $scope.qiniuId.length}) : ''
                            }
                            swal({
                                title: $translate.instant("uploadContent.uploadCompleted"),
                                text: text,
                                imageUrl: Theme.sweetSuccedImg(),
                                confirmButtonText: $translate.instant("choose.editor.confirm")
                            });
                            updatePic();
                        }, 1000);
                    } else if (len == (indd + errorImageArr.length) && errorImageArr.length != 0) {
                        SweetAlert.swal({
                            title: $translate.instant("choose.editorMessage.uploadCompleted"),
                            text: $translate.instant("choose.editorMessage.breakUpload",{errorImageArrLength:errorImageArr.length}),
                            imageUrl: Theme.sweetHintImg(),
                            showCancelButton: true,
                            confirmButtonText: $translate.instant("choose.editor.confirm"),
                            cancelButtonText: $translate.instant("choose.editor.cancel")
                        }, function (isConfirm) {
                            if (isConfirm) {
                                asyncUpload(errorImageArr);
                            } else {
                                SweetAlert.swal({
                                    title: $translate.instant("choose.editorMessage.pictureUploadingCancel"),
                                    imageUrl: Theme.sweetHintImg(),
                                    text: "",
                                    timer: 2000,
                                    showConfirmButton: false
                                });
                                updatePic();
                            }
                        })
                    }
                    qiniuToImg(resp.data);
                }else {
                    errorImageArr.push(file);
                    //最后一个失败了的话
                    if (len == (indd + errorImageArr.length)) {
                        SweetAlert.swal({
                            title: $translate.instant("choose.editorMessage.uploadCompleted"),
                            text: $translate.instant("choose.editorMessage.pictureRepetition",{pictureLength:errorImageArr.length}),
                            imageUrl: Theme.sweetHintImg(),
                            showCancelButton: true,
                            confirmButtonText: $translate.instant("choose.editor.confirm"),
                            cancelButtonText: $translate.instant("choose.editor.cancel")
                        }, function (isConfirm) {
                            if (isConfirm) {
                                asyncUpload(errorImageArr);
                            } else {
                                SweetAlert.swal({
                                    title: $translate.instant("choose.editorMessage.pictureUploadingCancel"),
                                    imageUrl: Theme.sweetHintImg(),
                                    text: "",
                                    timer: 2000,
                                    showConfirmButton: false
                                });
                                updatePic();
                            }
                        })
                    }
                }
            }, function (error) {
                errorImageArr.push(file);
                //最后一个失败了的话
                if (len == (indd + errorImageArr.length)) {
                    SweetAlert.swal({
                        title: $translate.instant("choose.editorMessage.uploadCompleted"),
                        text: $translate.instant("choose.editorMessage.pictureRepetition",{pictureLength:errorImageArr.length}),
                        imageUrl: Theme.sweetHintImg(),
                        showCancelButton: true,
                        confirmButtonText: $translate.instant("choose.editor.confirm"),
                        cancelButtonText: $translate.instant("choose.editor.cancel")
                    }, function (isConfirm) {
                        if (isConfirm) {
                            asyncUpload(errorImageArr);
                        } else {
                            SweetAlert.swal({
                                title: $translate.instant("choose.editorMessage.pictureUploadingCancel"),
                                imageUrl: Theme.sweetHintImg(),
                                text: "",
                                timer: 2000,
                                showConfirmButton: false
                            });
                            updatePic();
                        }
                    })
                }
            });
        }

        //下一步  点击图片框 选择图片库  这里图片无限制
        $scope.selectThis2 = function (gallery, photo, index) {
            if (!gallery.flag) {
                return
            }
            $scope.gallaryPic = [];
            $scope.moveGalleryIds = [];
            gallery.select_photo = !gallery.select_photo;
            for (var i = 0; i < photo.galleries.length; i++) {
                if (!photo.galleries[i].select_photo) {
                    photo.select_photoAll = false;
                    break;
                } else if (i == photo.galleries.length - 1) {
                    photo.select_photoAll = true;
                }
            }
            var t = 0;
            angular.forEach($scope.photos, function (p) {
                angular.forEach(p.galleries, function (g) {
                    if (g.select_photo) {
                        t++;
                        $scope.gallaryPic.push(g);       //选择导入图片的数组
                        $scope.moveGalleryIds.push(g.id);
                    }
                })
            });
            $scope.select_photo = t ? true : false;         //确认按钮的显示
            $scope.delBar = t ? true : false; //删除栏的显示
        };

        // 全选
        $scope.selectedPhoto = function (index, photo) {
            $scope.gallaryPic = [];
            $scope.moveGalleryIds = [];
            if ($scope.photos == '' || $scope.photos == null) {
                return;
            } else {
                if (photo.select_photoAll == null) {
                    photo.select_photoAll = true;
                } else {
                    photo.select_photoAll = !photo.select_photoAll;
                }
                $scope.delBar = true;
                angular.forEach(photo.galleries, function (g, i) {
                    g.select_photo = photo.select_photoAll;
                });

                if (photo.select_photoAll) {
                    $scope.select_photoAll = true;
                } else {
                    $scope.select_photoAll = false;
                }

                var t = 0;
                angular.forEach($scope.photos, function (p, i) {
                    angular.forEach(p.galleries, function (g, j) {
                        if (g.select_photo == true && g.flag == true) {
                            $scope.gallaryPic.push(g);      //选择导入图片的数组
                            $scope.moveGalleryIds.push(g.id);
                        }
                    });
                    if (!p.select_photoAll) {
                        t++;
                    }
                    if (i == $scope.photos.length - 1) {
                        if (t == $scope.photos.length && $scope.gallaryPic.length == 0) {
                            $scope.delBar = false;
                        }
                    }
                });
            }
        };

        //导入功能   判断所选图片是否符合要求
        $scope.confirmImport = function ($event) {
            $event.stopPropagation();
            //导入之后 项目库不再出现引导页
            $scope.qiniuId = JSON.parse(localStorage.getItem("gallery")) || [];
            $scope.choose = localStorage.getItem("choose");
            $scope.selectAllFolder = false;
            // 文件夹选择导入
            if ($scope.currentNav == 'folder') {
                var str = '';
                angular.forEach($scope.folderIds, function (f) {
                    str += f + ';'
                });
                var temp = $scope.qiniuId.map(function (item) {
                    return item.identifier;
                });

                Gallery.all({
                    items: [{key: "folderId", op: "in", value: str},{key: "articleId", op: "=", value: vm.aid}],
                    sort: sorts()
                }, function (resp) {
                    if(resp.status == 200){
                        angular.forEach(resp.data, function (p) {
                            angular.forEach(p.galleries, function (g, i) {
                                g.usenum = 0;
                                g.identifier = $scope.domain + g.identifier;
                                if (temp.length > 0) {
                                    for (var i = 0; i < temp.length; i++) {
                                        if (temp.indexOf(g.identifier) > -1) {
                                            return;
                                        }
                                    }
                                }

                                if ((typeof g.parameter) == 'string') {
                                    g.parameter = JSON.parse(g.parameter);
                                }
                                if ($scope.choose) {
                                    // 从头部添加
                                    $scope.qiniuId.unshift(g);
                                } else {
                                    // 从尾部添加
                                    $scope.qiniuId.push(g);
                                }
                            })
                        });
                        setLocalstorage();
                        return;
                    }else {
                        MessageService.error(resp.message);
                    }
                });
            }
            angular.forEach($scope.gallaryPic, function (p, i) {
                if ((typeof p.parameter) == 'string') {
                    p.parameter = JSON.parse(p.parameter);
                }
                if ($scope.choose) {
                    $scope.qiniuId.unshift(p);
                } else {
                    $scope.qiniuId.push(p);
                }
            });
            setLocalstorage();

        };

        function setLocalstorage() {
            localStorage.setItem("gallery", JSON.stringify($scope.qiniuId));
            setProductionStorage('start');
            $scope.gallaryPic = [];
            angular.forEach($scope.photos, function (p, i) {
                p.select_photoAll = false;
                angular.forEach(p.galleries, function (g, j) {
                    g.select_photo = false
                });
            });

            cancelSelectFolders();
            $scope.selectAllGallery = $scope.delBar = false;
            window.scrollTo(0, 0);
        }

        //返回上一页
        $scope.showStartBtn = function () {
            if ($scope.status == 'sort') {
                getItem();
            }
            setProductionStorage('start');
            $scope.selectAllGallery = $scope.delBar = false;
            angular.forEach($scope.photos, function (p, i) {
                p.select_photoAll = false;
                angular.forEach(p.galleries, function (g, j) {
                    g.select_photo = false
                });
            });
            //这一步是分页下拉  刷新滚动条置顶
            window.scrollTo(0, 0);
            var picArrCopy = JSON.parse(localStorage.getItem("picArrCopy")) || [];
            localStorage.setItem("picArr", JSON.stringify(picArrCopy));
            $scope.qiniuId = JSON.parse(localStorage.getItem("gallery2")) || [];
            localStorage.setItem("gallery", JSON.stringify($scope.qiniuId));
            var picI = parseInt(localStorage.getItem('picArrChoose2'));
            localStorage.setItem('picArrChoose', picI);
        };
        $scope.showStartBtns = function () {
            localStorage.removeItem("go");
            var galleryCopy = JSON.parse(localStorage.getItem("galleryCopy")) || [];
            localStorage.setItem("gallery", JSON.stringify(galleryCopy));
            setProductionStorage('make');
        };

        function getItem() {
            $scope.qiniuId = JSON.parse(localStorage.getItem("gallery")) || [];        //拿到 localStorage 中的图片数据
            localStorage.setItem("gallery", JSON.stringify($scope.qiniuId));           //工作区中所有的图片信息

            localStorage.removeItem('go');
            $scope.choose = localStorage.getItem("choose");
            //新建页面
            if (vm.pid && $scope.status == 'start') {
                init();
            } else if (vm.aid && $scope.status == 'start') {      //编辑页面
                vm.counts = localStorage.getItem('article-count');
            }
        }

        //初始化的时候判断照片是否可选
        var arrTemp = JSON.parse(localStorage.getItem("gallery")) || [];
        var temp = arrTemp.map(function (item) {
            return item.identifier;
        });
        $scope.justifySelect = function (gallery) {
            if (temp.length > 0) {
                for (var i = 0; i < temp.length; i++) {
                    if (temp.indexOf(gallery.identifier) > -1) {
                        gallery.select_photo = false;
                        gallery.flag = false;
                        return true;
                    } else {
                        gallery.flag = true;
                        return false;
                    }
                }
            } else {
                gallery.flag = true;
                return false;
            }

        };

        /**
         * 初始化
         */
        function init() {
            ItemValue.get({id: $stateParams.vid}, function (res) {
                if(res.status == 200){
                    vm.itemValue = res.data;
                    $("body").toggleClass('bg');
                    $scope.status = localStorage.getItem('Production');
                    vm.productXmlLine = angular.copy(res.data.productXmlLines[0]);
                    angular.forEach(res.data.productXmlLines, function (line) {
                        if (line.id == vm.xmlId) {
                            vm.productXmlLine = angular.copy(line);
                        }
                    })
                    vm.article = {
                        cover: vm.productXmlLine.coverImg,
                        themeClassifyId: vm.productXmlLine.productXmlThemeId,
                        themeClassifyName: vm.productXmlLine.productXmlThemeName,
                        productXmlId: vm.productXmlLine.productXmlId,
                        productXmlName: vm.productXmlLine.productXmlName,
                        musicIdentify: vm.productXmlLine ? vm.productXmlLine.musicIdentify : res.data.musicIdentify,
                        sku: res.data.sku,
                        skuNumber: res.data.skuNumber,
                        name: res.data.productName,
                        productId: res.data.productId,
                        productName: res.data.productName,
                        categoryId: res.data.categoryId,
                        categoryName: res.data.categoryName,
                        categoryStoreId: res.data.categoryStoreId,
                        categoryStoreName: res.data.categoryStoreName,
                        editorType: res.data.productEditorType,
                        productBokehType: res.data.productBokehType,
                        itemValueId: res.data.itemValueId || vm.vid
                    };
                    vm.article.bokehtype = res.data.productBokehType;
                    console.log(vm.article.bokehtype)
                    var result = ListService.inList(vm.article, variableDatas, ["productXmlId"]);
                    if(result&&result.data&&result.data.length){
                        angular.forEach(result.data,function (va,i) {
                            if(va.type=='text'){
                                vm.variableTextDatas.push(va)
                            }
                            if(va.type=='box'){
                                vm.variableBoxDatas.push(va)
                            }
                        })
                    }
                    console.log(vm.variableTextDatas)
                    console.log(vm.variableBoxDatas)

                    $scope.isCanClick = false;
                    Convert.xmlToDocument({
                        identifier: vm.productXmlLine ? vm.productXmlLine.productXmlIdentifier : res.data.productXmlIdentifier,
                        provider: "qiniu"
                    }, function (res) {
                        $scope.picArr = [];
                        vm.counts = 0;
                        var isChoose = JSON.parse(localStorage.getItem('picArrCopy'));
                        angular.forEach(res.pages.page, function (page, i) {
                            if (page.backup) {
                                if (i == res.pages.page.length - 1) {
                                    $scope.isCanClick = true;
                                }
                                return
                            }
                            var len = 0;
                            angular.forEach(page.levels.level, function (level) {
                                if (level.imagebox && level.imagebox.geometry) {
                                    len++;
                                    vm.counts++;
                                    if(vm.variableBoxDatas.length&&level.name){
                                        for (var _i = 0; _i < vm.variableBoxDatas.length; _i++) {
                                            if(vm.variableBoxDatas[_i].name==level.name){
                                                vm.counts--
                                            }
                                        }
                                    }
                                }
                            })
                            if (len && !isChoose) {
                                var arr = {
                                    pageI: i,
                                    maskI: len,
                                    index: -1
                                };
                                $scope.picArr.push(arr);
                            }

                            if (i == res.pages.page.length - 1) {
                                $scope.isCanClick = true;
                            }
                        });

                        if (!isChoose) {
                            localStorage.setItem('picArr', JSON.stringify($scope.picArr));
                            localStorage.setItem('picArrCopy', JSON.stringify($scope.picArr));
                            localStorage.setItem('picArrChoose', 0);
                        }
                        console.log($scope.picArr)
                    });
                }else {
                    MessageService.error(res.message);
                }

            });

        }

        $scope.delPhoto = function (photo, index) {
            var newArr = angular.copy($scope.qiniuId);
            newArr.splice(index, 1);
            $scope.qiniuId = newArr;
            localStorage.setItem("gallery", JSON.stringify($scope.qiniuId));

            $scope.delPic = JSON.parse(localStorage.getItem('delPic')) || [];
            if(!$scope.picArr||!$scope.picArr.length){
                return
            }
            $scope.picI = parseInt(localStorage.getItem('picArrChoose'));
            var arr = $scope.picArr[$scope.picI];
            if (photo.seq && photo.seq.select) {
                $scope.delPic.push(photo.seq);
                $scope.delPic.sort(compare2('pageI', compare2('maskI')));
                arr = $scope.picArr[photo.seq.picI];
                arr.index -= 1;
                photo.seq = {
                    pageI: '',
                    maskI: '',
                    select: false
                };
                photo.pageI = '';
                photo.maskI = '';
            }

            localStorage.setItem('picArr', JSON.stringify($scope.picArr));
            localStorage.setItem('picArrChoose', $scope.picI);
            localStorage.setItem('delPic', JSON.stringify($scope.delPic));
        };

        /**
         * 显示图库div
         */
        $scope.showGallery = function () {
            setProductionStorage('gallery');
            window.scrollTo(0, 0);
            //初始化的时候判断照片是否可选
            var arrTemp = JSON.parse(localStorage.getItem("gallery")) || [];
            var temp = arrTemp.map(function (item) {
                return item.identifier;
            });
            $scope.justifySelect = function (gallery) {
                if (temp.length > 0) {
                    for (var i = 0; i < temp.length; i++) {
                        if (temp.indexOf(gallery.identifier) > -1) {
                            gallery.select_photo = false;
                            gallery.flag = false;
                            return true;
                        } else {
                            gallery.flag = true;
                            return false;
                        }
                    }
                } else {
                    gallery.flag = true;
                    return false;
                }

            };
        };

        /**
         * 上传本地图片
         * 更新$scope.qiniuId
         * 更新localStorage       新建页面：pid?-gallery    编辑页面：aid?-gallery
         * @param photos
         */
        function qiniuToImg(photos) {
            if ($scope.status == 'gallery') {
                return
            }
            $scope.choose = localStorage.getItem("choose");

            $scope.qiniuId = JSON.parse(localStorage.getItem("gallery")) || [];

            photos.identifier = $scope.domain + photos.identifier;
            photos.usenum = 0;

            if ($scope.choose) {
                $scope.qiniuId.unshift(photos);
            } else {
                $scope.qiniuId.push(photos);
            }


            //筛选出重复的  比较identifier
            $scope.qiniuId = uniqeByKeys($scope.qiniuId, ['id', 'identifier']);

            //更新缓存
            localStorage.setItem("gallery", JSON.stringify($scope.qiniuId));
        }

        function obj2key(obj, keys) {
            var n = keys.length,
                key = [];
            while (n--) {
                key.push(obj[keys[n]]);
            }
            return key.join('|');
        }

        //去重操作
        function uniqeByKeys(array, keys) {
            var arr = [];
            var hash = {};
            for (var i = 0, j = array.length; i < j; i++) {
                var k = obj2key(array[i], keys);
                if (!(k in hash)) {
                    hash[k] = true;
                    arr.push(array[i]);
                }
            }
            return arr;
        }

        //显示图片选择图标以及删除栏
        $scope.showDeleteBtn = function () {
            if (!$scope.photos.length) {
                $scope.selectAllGallery = $scope.delBar = false;
                swal({
                    title: "操作失败",
                    text: "没有图片选择",
                    imageUrl: Theme.sweetHintImg(),
                    timer: 1500,
                    showConfirmButton: false
                });
                return
            }
            $scope.selectAllGallery = !$scope.selectAllGallery;
            $scope.delBar = $scope.selectAllGallery;

            $scope.gallaryPic = [];
            $scope.moveGalleryIds = [];
            isShowSelectDot($scope.selectAllGallery);
        };

        function isShowSelectDot(flag) {
            angular.forEach($scope.photos, function (p) {
                p.select_photoAll = flag;
                angular.forEach(p.galleries, function (g) {
                    g.select_photo = flag;
                    if (flag) {
                        $scope.gallaryPic.push(g);       //选择导入图片的数组
                        $scope.moveGalleryIds.push(g.id);
                    }
                });
            });
        }

        function loadFolders() {
            Folder.storeGetAllByCondition({
                items: [{key: "type", op: "=", value: "Gallery"},{key: "articleId", op: "=", value: vm.aid}],
                sort: ["id,asc"]
            }, function (res) {
                if(res.status == 200){
                    $scope.Folders = res.data;
                }else {
                    MessageService.error(res.message);
                }
            })
        }


        $scope.backToView = function () {
            setProductionStorage('start');
            $scope.gallaryPic = [];
            angular.forEach($scope.photos, function (p, i) {
                p.select_photoAll = false;
                angular.forEach(p.galleries, function (g, j) {
                    g.select_photo = false
                });
            });
            window.scrollTo(0, 0);
        };

        // 增加文件夹
        $scope.addFolder = function () {
            addAlertClass();
            $(".folder-footer").hide();
            swal({
                title: $translate.instant("uploadContent.createAlbum"),
                text: "",
                type: "input",
                showCancelButton: true,
                closeOnConfirm: false,
                confirmButtonText: $translate.instant("choose.editor.confirm"),
                cancelButtonText: $translate.instant("choose.editor.cancel"),
                animation: "slide-from-top",
                inputPlaceholder: $translate.instant("choose.editorMessage.pleaseEnterAFolderName")
            }, function (inputValue) {
                if (inputValue === false) {
                    $(".folder-footer").show();
                    return false;
                }
                if (inputValue === "") {
                    swal.showInputError($translate.instant("choose.editorMessage.pleaseEnterCompanyName"));
                    return false
                }
                if (inputValue.indexOf(" ") != -1) {
                    swal.showInputError($translate.instant("choose.editorMessage.pleaseDoNotEnterASpace"));
                    return false
                }
                Folder.save({
                    name: inputValue,
                    type: 'Gallery',
                    articleId:vm.aid
                }, function (resp) {
                    if(resp.status == 200){
                        $scope.Folders.push(resp.data);
                        $(".folder-footer").show();
                        swal.close();
                        removeAlertClass();
                    }else {
                        swal.showInputError($translate.instant("choose.editorMessage.pleaseEnterTheCorrectFileName"));
                    }
                }, function () {
                    swal.showInputError($translate.instant("choose.editorMessage.pleaseEnterTheCorrectFileName"));
                })
            });
        };

        function addAlertClass() {
            setTimeout(function () {
                $(".sweet-alert").addClass('folder-alert');
                $(".sa-button-container").addClass('folder-alert-top');
                $(".sa-button-container .cancel").addClass('folder-alert-right')
            }, 200)
        }

        function removeAlertClass() {
            setTimeout(function () {
                $(".sweet-alert").removeClass('folder-alert');
                $(".sa-button-container").removeClass('folder-alert-top');
                $(".sa-button-container .cancel").removeClass('folder-alert-right')
            }, 200)
        }

        // 修改文件夹名
        $scope.editFolder = function () {
            addAlertClass();
            var len = $scope.folderIds.length;
            if (len > 1 || !len) {
                return
            }
            var folder = $scope.editFolderNameArr;
            $(".folder-footer").hide();
            swal({
                title: $translate.instant("choose.editorMessage.rename"),
                text: "",
                type: "input",
                showCancelButton: true,
                closeOnConfirm: false,
                confirmButtonText: $translate.instant("choose.editor.confirm"),
                cancelButtonText: $translate.instant("choose.editor.cancel"),
                animation: "slide-from-top",
                inputPlaceholder: $translate.instant("choose.editorMessage.pleaseEnterAFolderName"),
                inputValue: folder.name
            }, function (inputValue) {
                if (inputValue === false) {
                    $(".folder-footer").show();
                    removeAlertClass();
                    return false;
                }
                if (inputValue === "") {
                    swal.showInputError($translate.instant("choose.editorMessage.pleaseEnterCompanyName"));
                    return false
                }
                if (inputValue.indexOf(" ") != -1) {
                    swal.showInputError($translate.instant("choose.editorMessage.pleaseDoNotEnterASpace"));
                    return false
                }
                if (inputValue === folder.name) {
                    swal.showInputError($translate.instant("choose.editorMessage.pleaseEnterADifferentFolderName"));
                    return false
                }
                Folder.update({
                    name: inputValue,
                    type: 'Gallery',
                    id: folder.id,
                    articleId:vm.aid
                }, function (resp) {
                    if(resp.status == 200){
                        cancelSelectFolders();
                        folder.name = resp.data.name;
                        $(".folder-footer").show();
                        swal.close();
                        removeAlertClass();
                    }else {
                        swal.showInputError($translate.instant("choose.editorMessage.pleaseEnterTheCorrectFileName"));
                    }
                }, function () {
                    swal.showInputError($translate.instant("choose.editorMessage.pleaseEnterTheCorrectFileName"));
                })
            });
        };

        function cancelSelectFolders() {
            $scope.folderIds = [];
            angular.forEach($scope.Folders, function (item) {
                item.selected = false;
            });
        }

        /**
         * 单选
         * @param item
         * @param flag-----   true：文件夹     false:作品
         */
        $scope.selectSingle = function (item, flag) {
            if (!item) {
                $scope.selectOne = {
                    folderId: '',
                    selected: true
                };
                angular.forEach($scope.Folders, function (folder) {
                    folder.selected = false;
                });
                return
            }
            item.selected = !item.selected;
            // 移动状态中
            if ($scope.moveGallery) {

                $scope.selectOne = {
                    folderId: item.id,
                    selected: item.selected
                };

                angular.forEach($scope.Folders, function (folder) {
                    folder.selected = false;
                });
                item.selected = $scope.selectOne.selected;
                if (item.selected) {
                    $scope.folderOne = angular.copy(item);
                }
                return
            }

            $scope.selectOne = {
                folderId: '',
                selected: false
            };
            //未选中时
            if (!item.selected) {
                // 文件夹
                if (flag) {
                    $scope.selectAllFolder = false;
                    var ind = $scope.folderIds.indexOf(item.id);
                    if (ind >= 0) {
                        $scope.folderIds.splice(ind, 1);
                    }
                } else {
                    $scope.selectAllAritle = false;
                    var ind = $scope.moveGalleryIds.indexOf(item.id);
                    if (ind >= 0) {
                        $scope.moveGalleryIds.splice(ind, 1);
                    }
                }
            } else {
                if (flag) {
                    $scope.folderIds.push(item.id);
                }
            }
        };

        $scope.selectFolders = function (item) {
            item.selected = !item.selected;

            $scope.selectOne = {
                folderId: '',
                selected: false
            };
            //未选中时
            if (!item.selected) {
                $scope.selectAllFolder = false;
                var ind = $scope.folderIds.indexOf(item.id);
                if (ind >= 0) {
                    $scope.folderIds.splice(ind, 1);
                }

                $scope.editFolderNameArr = [];

            } else {
                $scope.folderIds.push(item.id);
                $scope.editFolderNameArr = item;
            }
            showConfirmBtn();
        };

        function showConfirmBtn() {
            if ($scope.folderIds.length > 0) {
                $scope.delBar = true;
            } else {
                $scope.delBar = false;
            }
        }

        /**
         * 全选
         * @param flag-----  true：文件夹     false:作品
         */
        $scope.chooseAll = function (flag) {
            if (flag) {
                $scope.folderIds = [];
                $scope.editFolderNameArr = [];
                $scope.selectAllFolder = !$scope.selectAllFolder;
                angular.forEach($scope.Folders, function (item, index) {
                    if ($scope.selectAllFolder) {
                        item.selected = true;
                        $scope.folderIds.push(item.id);
                    } else {
                        item.selected = false;
                    }
                });

                showConfirmBtn();
            } else {
                $scope.selectAllGallery = !$scope.selectAllGallery;
                angular.forEach($scope.photos, function (photo) {
                    angular.forEach(photo.galleries, function (item) {
                        if ($scope.selectAllGallery) {
                            item.select_photo = true;
                            photo.select_photoAll = true
                        } else {
                            item.select_photo = false;
                            photo.select_photoAll = false
                        }
                    })
                })
            }

        };

        $scope.saveMoveToFolder = function () {
            if (!$scope.selectOne.selected) {
                swal({
                    title: $translate.instant("choose.editorMessage.operationFailure"),
                    text: $translate.instant("choose.editorMessage.pleaseSelectAFolder"),
                    imageUrl: Theme.sweetHintImg(),
                    timer: 1500,
                    showConfirmButton: false
                });
                return
            }
            angular.forEach($scope.Folders, function (folder, index) {
                folder.selected = false;
            });

            $(".prev-btn-gallery").show();

            Gallery.moveFolder({
                galleries: $scope.moveGalleryIds,
                folderId: $scope.selectOne.folderId,
                articleId: vm.aid
            }, function (res) {
                if(res.status == 200){
                    $scope.currentNav = 'gallery';
                    $scope.delBar = false;
                    $scope.gallaryPic = [];
                    $scope.moveGalleryIds = [];
                    $scope.moveGallery = false;
                    $(".photo-show").hide();
                    if ($scope.selectOne.folderId) {
                        $scope.folderInside = true;
                        vm.indexNum = 0;
                        vm.galleryPage = [];
                        loadAll($scope.folderOne.id);
                    } else {
                        $scope.folderInside = false;
                        $scope.delBar = false;
                        vm.galleryPage = [];
                        vm.indexNum = 0;
                        loadAll('isNull');
                    }
                    $scope.selectOne = {
                        folderId: '',
                        selected: false
                    };
                }else {
                    MessageService.error(res.message);
                }
            })
        };

        $scope.backToGallery = function () {
            $scope.currentNav = 'gallery';
            $scope.moveGallery = false;
            $scope.delBar = false;
            $scope.selectOne = {
                folderId: '',
                selected: false
            };
            angular.forEach($scope.Folders, function (folder) {
                folder.selected = false;
            });
            clearGalleryAdd();
            $(".prev-btn-gallery").show();
        };

        $scope.moveToFolder = function () {
            if (!$scope.gallaryPic.length) {
                swal({
                    title: $translate.instant("choose.editorMessage.failedToMove"),
                    text: $translate.instant("choose.editorMessage.pleaseSelectAtLeastOnePicture"),
                    imageUrl: Theme.sweetHintImg(),
                    timer: 2000,
                    showConfirmButton: false
                });
                return
            }
            $scope.moveGallery = true;
            $scope.delBar = true;
            $scope.folderInside = false;
            $(".prev-btn-gallery").hide();
            $scope.currentNav = 'folder';
        };

        function clearGalleryAdd() {
            $scope.moveGalleryIds = [];
            $scope.selectAllGallery = false;
            angular.forEach($scope.photos, function (photo) {
                photo.select_photoAll = false;
                angular.forEach(photo.galleries, function (item) {
                    item.select_photo = false;
                })
            })
        }

        // 进入某一文件夹中
        $scope.showFolderContent = function (folder) {
            if (folder.selected) {
                folder.selected = false;
                $scope.selectAllGallery = !$scope.selectAllGallery;
                $scope.selectOne = {
                    folderId: '',
                    selected: false
                };

                $scope.selectAllFolder = false;
                var ind = $scope.folderIds.indexOf(folder.id);
                if (ind >= 0) {
                    $scope.folderIds.splice(ind, 1);
                }
                $scope.editFolderNameArr = [];
                showConfirmBtn();
                return
            }
            $scope.folderInside = true;
            $scope.currentNav = 'gallery';
            $scope.folderOne = angular.copy(folder);
            vm.indexNum = 0;
            vm.galleryPage = [];
            $(".photo-show").hide();
            loadAll(folder.id);
        };
        // 从某一文件夹出去
        $scope.hideFolderContent = function () {
            $scope.folderInside = false;
            $scope.moveGallery = false;
            $scope.currentNav = 'folder';
            $scope.folderOne = {};
            $scope.selectAllGallery = $scope.delBar = false;
        };
        // 图片库nav 点击
        $scope.galleryNavSel = function () {
            $(".photo-show").hide();
            vm.galleryPage = [];
            $scope.currentNav = 'gallery';
            $(".folder-editbar").addClass('hide1');
            $(".arrow-btn").removeClass('folder-arrow-up');
            angular.forEach($scope.Folders, function (folder, index) {
                folder.selected = false;
            });
            $scope.folderIds = [];
            $scope.selectAllGallery = $scope.delBar = false;
            vm.indexNum = 0;
            $scope.folderOne = null;
            loadAll('isNull');
        };
        // 图片库nav 点击
        $scope.folderNavSel = function () {
            vm.galleryPage = [];
            $scope.currentNav = 'folder';
            $scope.selectAllGallery = $scope.delBar = false;
        };

        // 上传图片后更新图片库/文件夹
        function updatePic() {
            if ($scope.folderOne && $scope.folderOne.id) {
                $scope.showFolderContent($scope.folderOne);
            } else {
                $scope.folderInside = false;
                $scope.currentNav = 'gallery';
                $scope.moveGallery = false;
                $scope.delBar = false;
                vm.galleryPage = [];
                vm.indexNum = 0;
                loadAll('isNull');
            }
        }


        /**
         * 照片排序
         * 实现照片拖动排序 不是替换 而是占位
         */
        $scope.photoSort = function () {
            if ($scope.qiniuId.length == 0) {
                swal({
                    title: $translate.instant("choose.editorMessage.notPicture"),
                    imageUrl: Theme.sweetHintImg(),
                    timer: 2000,
                    showConfirmButton: false
                });
                return;
            } else {
                setProductionStorage('sort');
                var picI = parseInt(localStorage.getItem('picArrChoose'));
                localStorage.setItem('picArrChoose2', picI);
                $scope.delPic = JSON.parse(localStorage.getItem('delPic')) || [];
                localStorage.setItem('gallery2', JSON.stringify($scope.qiniuId));
            }
        };

        $scope.delPic = [];
        $scope.selectPage = function (photo) {
            $scope.picArr = JSON.parse(localStorage.getItem('picArr'));
            $scope.picI = parseInt(localStorage.getItem('picArrChoose'));
            var arr = $scope.picArr[$scope.picI];

            if (photo.seq && photo.seq.select) {
                $scope.delPic.push(photo.seq);
                $scope.delPic.sort(compare2('pageI', compare2('maskI')));
                arr = $scope.picArr[photo.seq.picI];
                arr.index -= 1;
                photo.seq = {
                    pageI: '',
                    maskI: '',
                    select: false
                }
            } else if ($scope.delPic.length) {
                var delArr = $scope.delPic.shift();
                arr = $scope.picArr[delArr.picI];
                arr.index += 1;
                photo.seq = {
                    pageI: delArr.pageI,
                    maskI: delArr.maskI,
                    select: true,
                    picI: delArr.picI
                }
            } else {
                if (arr.index + 1 >= arr.maskI) {
                    if ($scope.picI + 1 < $scope.picArr.length) {
                        arr = $scope.picArr[++$scope.picI];
                    } else {
                        SweetAlert.swal({
                            title: $translate.instant("choose.editorMessage.photoFillingIsComplete"),
                            imageUrl: Theme.sweetHintImg(),
                            text:  $translate.instant("choose.editorMessage.pleaseMakeItImmediately"),
                            timer: 1500,
                            showConfirmButton: false
                        });
                        return
                    }
                }
                arr.index += 1;
                photo.seq = {
                    pageI: arr.pageI,
                    maskI: arr.index,
                    select: true,
                    picI: $scope.picI
                }
            }

            photo.pageI = photo.seq.pageI;
            photo.maskI = photo.seq.maskI;
            localStorage.setItem('picArr', JSON.stringify($scope.picArr));
            localStorage.setItem('picArrChoose', $scope.picI);
            localStorage.setItem("gallery", JSON.stringify($scope.qiniuId));
        };

        $scope.sureSort = function () {
            localStorage.setItem("gallery", JSON.stringify($scope.qiniuId));

            localStorage.setItem("isSort", "true");
            setProductionStorage('start');

            var picArr = JSON.parse(localStorage.getItem("picArr")) || [];
            localStorage.setItem("picArrCopy", JSON.stringify(picArr));
            $scope.qiniuId = JSON.parse(localStorage.getItem("gallery")) || [];
            localStorage.setItem("gallery2", JSON.stringify($scope.qiniuId));
            var picI = parseInt(localStorage.getItem('picArrChoose'));
            localStorage.setItem('picArrChoose2', picI);
            localStorage.setItem('delPic', JSON.stringify($scope.delPic));
        };

        /**
         * 单张图片选择跳转
         * 设置localStorage       新建页面：pid?-single    编辑页面：aid?-single
         * 更新localStorage       新建页面：pid?-gallery    编辑页面：aid?-gallery
         * @param identifier
         * @param photo
         */
        $scope.singleTo = function (identifier, photo, $index) {
            if(photo.imageInfo){
                singleToCb(photo.imageInfo)
            }else{
                $.ajax({
                    type: "GET",
                    url: photo.identifier + "?imageInfo",
                    success: function (va) {
                        photo.imageInfo = va;
                        singleToCb(photo.imageInfo)
                    }
                })
            }
            function singleToCb(imageInfo) {
                var i = $index;
                photo.usenum++;
                localStorage.setItem("gallery", JSON.stringify($scope.qiniuId));      //工作区中所有的图片信息
                setProductionStorage('make');

                getCurrentImage();
                var imagebox = $scope.template.pages.page[$scope.index].levels.level[$scope.i].imagebox;
                if (imagebox.mask.resource.identifier) {
                    imagebox.maskUrl = (imagebox.mask.resource.identifier.indexOf('http') == -1 ? $scope.domain : '') + imagebox.mask.resource.identifier;
                } else {
                    imagebox.maskUrl = 'content/images/timg.jpg';
                }

                if (imagebox.image) {
                    $scope.imgIndex = imagebox.image.index;
                    $scope.imgId = imagebox.image.resourceid;
                    if ($scope.qiniuId.length) {
                        angular.forEach($scope.qiniuId, function (arr, i) {
                            if (arr.id == $scope.imgId) {
                                arr.usenum == 0 ? 0 : arr.usenum--;
                                setGalleryStorage();
                            }
                        })
                    }
                } else {
                    imagebox.image = {}
                }

                imagebox.image = imgParamter(imagebox, photo, $index);

                imagebox.imgUrl = photo.identifier;
                imagebox.image.resource.identifier = photo.identifier;
                imagebox.image.offsety = 0;
                imagebox.image.offsetx = 0;

                var styleScale2 = $scope.currentPage.styleScale2;
                var styleScale = $scope.currentPage.styleScale;

                if (vm.article.productBokehType!='None') {
                    imagebox.blurred = true;
                    imagebox.blurredrectangle = {}
                }

                imgScale(imagebox, $scope.index, $scope.i,0, 0);
                setImageWidth();
                $scope.showImageMenu = true;
                $scope.showBottomMenu = false;
                tipStatus(true);
            }
        };

        // 导入添加的项目库图片
        $scope.importAddGallery = function () {
            var gallery = $scope.qiniuId.sort(compare('usenum'));
            localStorage.setItem("gallery", JSON.stringify(gallery));
            localStorage.setItem("galleryCopy", JSON.stringify(gallery));
            setProductionStorage('make');
            setImageWidth();
        };

        /**
         * 下一步跳转页面
         * 移除localStorage    pid?-go
         */
        $scope.nextTo = function () {         //下一步跳转页面时移除“一键Go”的localStorage
            $scope.countN++;
            localStorage.setItem('countN', $scope.countN);
            localStorage.removeItem("go");
            removeOldPageStorage();
            localStorage.setItem("gallery", JSON.stringify($scope.qiniuId));
            var t = 0;
            angular.forEach($scope.qiniuId, function (photo, i) {
                photo.usenum = 0;
                if (photo.width) {
                    photo.ratio = photo.width / photo.height;
                    if ((typeof photo.parameter) == 'string') {
                        photo.parameter = JSON.parse(photo.parameter);
                    }
                    localStorage.setItem("gallery", JSON.stringify($scope.qiniuId));

                } else {
                    var newImg = document.createElement('img');
                    newImg.identifier = photo.identifier;
                    newImg.src = $scope.domain + photo.identifier + '?imageMogr2/strip';
                    newImg.onload = function () {
                        t++;
                        photo.width = newImg.width;
                        photo.height = newImg.height;
                        photo.ratio = newImg.width / newImg.height;
                        if ((typeof photo.parameter) == 'string') {
                            photo.parameter = JSON.parse(photo.parameter);
                        }
                        localStorage.setItem("gallery", JSON.stringify($scope.qiniuId));
                    };
                }

            });
            setProductionStorage('view');
            goToMake();
        };

        /**
         * 一键Go 跳转页面
         * 设置localStorage    pid?-go
         */
        $scope.goTo = function () {
            var isHasLowPic = false;
            if (!$scope.isCanClick) {
                return
            }
            var isSort = localStorage.getItem('isSort');
            if (isSort) {
                $scope.qiniuId.sort(compare2('pageI', compare2('maskI')));
            }

            angular.forEach($scope.qiniuId, function (photo, i) {
                if (i < vm.counts) {
                    photo.usenum = 1;
                } else {
                    photo.usenum = 0;
                }
                if (photo.imgSize / 1024 < 150) {
                    isHasLowPic = true;
                }
                if ((typeof photo.parameter) == 'string') {
                    photo.parameter = JSON.parse(photo.parameter);
                }

                if (!photo.width) {
                    var newImg = document.createElement('img');
                    newImg.identifier = photo.identifier;
                    newImg.src = $scope.domain + photo.identifier + '?imageMogr2/strip';
                    newImg.onload = function () {
                        photo.width = newImg.width;
                        photo.height = newImg.height;
                        photo.ratio = newImg.width / newImg.height;
                        localStorage.setItem("gallery", JSON.stringify($scope.qiniuId));
                    };
                } else {
                    photo.ratio = photo.width / photo.height;
                    localStorage.setItem("gallery", JSON.stringify($scope.qiniuId));
                }
            });

            if (isHasLowPic) {
                SweetAlert.swal({
                        title: $translate.instant("choose.editorMessage.thereAreLowResolutionPhotos"),
                        imageUrl: Theme.sweetHintImg(),
                        showCancelButton: true,
                        confirmButtonText: $translate.instant("choose.editor.confirm"),
                        cancelButtonText: $translate.instant("choose.editor.cancel")
                    }, function (isConfirm) {
                        if (isConfirm) {
                            going();
                        } else {
                            return;
                        }
                    }
                )
            } else {
                going();
            }
        };

        function compare2(name, minor) {
            return function (o, p) {
                var a, b;
                if (o && p && typeof o === 'object' && typeof p === 'object') {
                    a = o[name];
                    b = p[name];
                    if (a === b) {
                        return typeof minor === 'function' ? minor(o, p) : 0;
                    }
                    if (typeof a === typeof b) {
                        return a < b ? -1 : 1;
                    }
                    return typeof a < typeof b ? -1 : 1;
                } else {
                    console.log("error");
                }
            }
        }

        function going() {
            localStorage.setItem("go", JSON.stringify($scope.qiniuId));
            removeOldPageStorage();

            $scope.countN++;
            localStorage.setItem('countN', $scope.countN);
            setProductionStorage('view');
            goToMake();

        }

        var productId = null;
        $scope.tempList = [];
        function goToMake() {
            if (vm.pid) {
                getLocalStorage();
                // 一键Go
                goes = JSON.parse(localStorage.getItem("go"));

                // 新建作品
                //  显示/隐藏引导页
                $scope.isHide = localStorage.getItem('isHide') || false;
                if (!$scope.isHide) {
                    $(".come-in").show();
                }

                Article.get({id: $stateParams.aid}, function (resp) {
                    if (resp.status == 200) {
                        vm.article = resp.data;

                        ItemValue.get({id: $stateParams.vid}, function (res) {
                            if (res.status == 200) {
                                vm.itemValue = res.data;
                                vm.productXmlLine = angular.copy(vm.itemValue.productXmlLines[0]);
                                angular.forEach(vm.itemValue.productXmlLines, function (line) {
                                    if (line.id == vm.xmlId) {
                                        vm.productXmlLine = angular.copy(line);
                                    }
                                })
                                vm.pattern = vm.itemValue.patternType;
                                vm.productXmlNumber = vm.itemValue.productXmlNumber;
                                vm.article.cover = vm.productXmlLine.coverImg;
                                vm.article.themeClassifyId = vm.productXmlLine.productXmlThemeId;
                                vm.article.productXmlThemeName = vm.productXmlLine.productXmlThemeName;
                                vm.article.productXmlId = vm.productXmlLine.productXmlId;
                                vm.article.productXmlName = vm.productXmlLine.productXmlName;
                                vm.article.musicIdentify = vm.productXmlLine ? vm.productXmlLine.musicIdentify : vm.itemValue.musicIdentify;
                                vm.article.itemValueId = vm.itemValue.itemValueId || vm.vid;
                                if (!vm.itemValue.productBokehType) {
                                    vm.article.bokehtype = 'None';
                                } else {
                                    vm.article.bokehtype = vm.itemValue.productBokehType;
                                }
                                console.log(vm.article.bokehtype)

                                Convert.xmlToDocument({
                                    identifier: vm.productXmlLine ? vm.productXmlLine.productXmlIdentifier : vm.itemValue.productXmlIdentifier,
                                    provider: 'qiniu'
                                }, function (res) {
                                    vm.replace = res.replace;
                                    productId = vm.pid;
                                    setPageContent(res);
                                });
                            }
                        })
                    }
                })

                var workSave = {
                    pid: vm.pid,
                    vid: vm.vid,
                    xmlId: vm.xmlId,
                    date: new Date().getTime()
                };
                localStorage.setItem('work-save', JSON.stringify(workSave));
            } else if (vm.aid) {
                // 编辑作品
                Article.get({id: $stateParams.aid}, function (resp) {
                    if(resp.status == 200){
                        vm.article = angular.copy(resp.data);
                        ItemValue.get({id: resp.data.itemValueId}, function (res) {
                            if(res.status == 200){
                                vm.pattern = res.data.patternType;
                                vm.article.productBokehType = res.data.productBokehType;
                                vm.article.bokehtype=res.data.productBokehType || 'None';

                                vm.article.skuNumber = res.data.skuNumber;
                                productId = res.data.productId;
                            }else {
                                MessageService.error(res.message);
                            }
                        });

                        Convert.xmlToDocument({
                            identifier: vm.article.fileName,
                            provider: 'qiniu'
                        }, function (res) {
                            vm.replace = res.replace;
                            if (!!res.galleries && !!res.galleries.gallery) {
                                localStorage.setItem("gallery", JSON.stringify(res.galleries.gallery));
                            }

                            getLocalStorage();
                            $scope.update = true;
                            $scope.isHide = true;
                            setPageContent(res);
                        });
                    }else {
                        MessageService.error(resp.message);
                    }
                });
            }
        }

        function removeOldPageStorage() {
            localStorage.removeItem("saveOldPage");
            localStorage.removeItem("saveOldPageIndex");
            localStorage.removeItem("galleryCopy");
            localStorage.removeItem("delPic");
            localStorage.removeItem("picArrChoose");
            localStorage.removeItem("picArrChoose2");
            localStorage.removeItem("gallery2");
            localStorage.removeItem("picArrCopy");
            localStorage.removeItem("picArr");
            localStorage.removeItem("isSort");
        }

        $scope.goBackToProduct = function () {
            setProductionStorage('make');
        };
        function isIphoneX() {
            return /iphone/gi.test(window.navigator.userAgent) && window.screen.width === 375 && (window.screen.height === 812 || window.screen.height == 724);
        }

        $scope.isIphoneX = isIphoneX();

        var windowH = $(window).height();
        vm.height = $(window).height();
        vm.wid = $(window).width();
        localStorage.setItem('windowH', windowH);

        $(window).scroll(function () {
            if ($scope.isIphoneX) {
                var wh = $(window).height(); //页面可视化区域高度
                if (wh > windowH) {
                    $(".iphoneX-content").height(36);
                    $(".footer_bar,.footer_pic").height(84);
                    $(".footer-title").height(76);
                } else {
                    $(".iphoneX-content").height(0);
                    $(".footer_bar,.footer_pic").height(48);
                    $(".footer-title").height(40);
                }
            }
            //    向下滑动加载照片
            var scrollTop = $(window).scrollTop();
            var widH = $(window).height();
            var docH = $(document).height();
            if (scrollTop + widH +100 >= docH) {
                if (flag == true && localStorage.getItem('Production') == 'gallery') {
                    loadMore();
                } else {
                    return;
                }
            } else {
                return;
            }

        });
        $('.sticker-scroll').scroll(function () {
            var allWidth = 92 * $scope.stickerList.length - $(this).width() - 1;
            if ($(this).scrollLeft() >= allWidth && $scope.artlabelChooseId != null) {
                if ($scope.stickerList.length == vm.totalClipartItems) {
                    SweetAlert.swal({
                        title: $translate.instant("choose.editorMessage.allFilesHaveBeenLoaded"),
                        imageUrl: Theme.sweetHintImg(),
                        timer: 1000,
                        showConfirmButton: false
                    });
                    return
                }
                vm.indexArtNum++;
                getBackgrounds($scope.labels[$scope.artlabelChooseIndex], ClipArt, vm.indexArtNum, function (res) {
                    vm.totalClipartItems = res.items;
                    angular.forEach(res.arr, function (arr) {
                        $scope.stickerList.push(arr);
                    })

                });
            }
        });

        // 判断是否重复
        function checkExist(list, obj) {
            if (list == null || list.length == 0) {
                return true;
            }
            for (var i = 0; i < list.length; i++) {
                if (list[i].getFullYear() == obj.getFullYear() &&
                    list[i].getMonth() == obj.getMonth() &&
                    list[i].getDate() == obj.getDate()) {
                    return false;
                }
            }
            return true;
        }


        /**
         * Get document
         * @param obj
         */
        function setPageContent(obj) {
            // 获取模板列表
            Product.get({id: productId, cancelled: false}, function (res) {
                if(res.status == 200){
                    vm.pattern = res.data.patternType;
                    for (var i = 0; i < res.data.itemValues.length; i++) {
                        var itemValue = res.data.itemValues[i];
                        if (itemValue.cancelled) {
                            continue;
                        }
                        if (itemValue.id == vm.vid) {
                            $scope.tempList = angular.copy(itemValue);
                        }
                    }
                }else {
                    MessageService.error(res.message);
                }

            })
            var k = 0;
            // 正常页
            var arrUse = {
                pages: {
                    page: []
                }
            };
            // 备用页
            var arrUnUse = {
                pages: {
                    page: []
                }
            };
            vm.counts = 0;
            //新建
            if (vm.pid) {
                angular.forEach(obj.pages.page, function (page, index) {
                    angular.forEach(page.levels.level, function (level, n) {
                        if (level.imagebox && level.imagebox.image && level.imagebox.image.resource) {
                            level.imagebox.image = null;
                        }
                    })
                })
                var usebox = []; //模板中标记使用的页
                var unusebox = []; //模板中标记不使用的页
                for (var i = 0; i < obj.pages.page.length; i++) {
                    var page = obj.pages.page[i];
                    if (!page.backup) {
                        arrUse.pages.page.push(page);
                        $scope.PAGELEN++;
                        k++;
                        angular.forEach(page.levels.level, function (level) {
                            if (level.imagebox && level.imagebox.geometry) {
                                vm.counts++;
                                if (k < 8 || $scope.PAGELEN <= 7) {
                                    vm.FirstSeven++;
                                }
                            }
                        })
                    }
                    var p = angular.copy(page);
                    //将模板所有页设为备用页
                    if (p.backup) {
                        unusebox.push(p);
                    } else {
                        p.backup = true;
                        usebox.push(p);
                    }
                }
                //使用的页 去掉封面 封底
                usebox.shift();
                usebox.pop();
                // 将备用页放在正常页面的后面
                arrUnUse.pages.page = unusebox.concat(usebox);
            } else {
                for (var i = 0; i < obj.pages.page.length; i++) {
                    var page = obj.pages.page[i];
                    if (!page.backup) {
                        arrUse.pages.page.push(page);
                        $scope.PAGELEN++;
                        k++;
                        angular.forEach(page.levels.level, function (level) {
                            if (level.imagebox && level.imagebox.geometry) {
                                vm.counts++;
                                if (k < 8 || $scope.PAGELEN <= 7) {
                                    vm.FirstSeven++;
                                }
                            }
                        })
                    } else {
                        arrUnUse.pages.page.push(page);
                    }
                }
            }

            obj.pages = angular.copy(arrUse.pages);
            vm.article.bgimgs2 = angular.copy(obj.bgimgs2);
            vm.article.documentpics = angular.copy(obj.documentpics);
            vm.article.masks = angular.copy(obj.masks);
            vm.article.cliparts = angular.copy(obj.cliparts);

            vm.cover = angular.copy(obj.cover);
            vm.article.document = choose(local_pages, obj);
            localStorage.setItem('article-count', vm.counts);

            $scope.pageAllMm = angular.copy(arrUnUse.pages);
            //平铺页   单页编辑
            getAll(vm.article.document);
            $scope.qiniuId = JSON.parse(localStorage.getItem("gallery")).sort(compare('usenum'));
            localStorage.setItem('gallery', JSON.stringify($scope.qiniuId));

            $scope.artlabelChooseId = $scope.labels[0].id || null;
            $scope.artlabelChooseIndex = 0;
            getRecommendSource(obj, $scope.labels, ClipArt, vm.indexArtNum, 'ClipArt');
        }

        $scope.labels = [$translate.instant("choose.editorMessage.recommend")];
        vm.indexArtNum = 0;
        vm.totalClipartItems = 0;

        function getRecommendSource(obj, labels, url, num, attr) {
            var list = [];
            var len = 0;
            if (obj.cliparts && obj.cliparts.clipart) {
                angular.forEach(obj.cliparts.clipart, function (obj, i) {
                    var arr = {
                        name: obj.name,
                        identifier: obj.resource.identifier,
                        provider: obj.resource.provider,
                        themeClassifyName: $translate.instant("choose.editorMessage.recommend"),
                        themeClassifyId: null,
                        resource: obj.resource
                    }
                    list.push(arr);
                })
                len = obj.cliparts.clipart.length;
            }

            //分类
            ThemeClassify.getAllByCondition4({type: attr,storeId:vm.storeId}, function (res) {
                if(res.status == 200){
                    if(!res.data){res.data=[]}
                    labels = angular.copy(res.data);

                    if (len) {
                        labels.unshift({
                            name: $translate.instant("choose.editorMessage.recommend"),
                            id: null
                        })
                        setSource(attr, list, labels)
                        vm.totalClipartItems = len;
                    } else if (labels.length) {
                        getBackgrounds(labels[0], url, num, function (res) {
                            vm.totalClipartItems = res.items;
                            setSource(attr, res.arr, labels);
                        });
                    }
                }else {
                    MessageService.error(res.message);
                }
            });
        }

        function setSource(attr, list, labels) {
            $scope.stickerList = angular.copy(list);
            vm.cliparts = angular.copy($scope.stickerList);
            $scope.labels = labels;
            $scope.artlabelChooseId = labels[0].id;
            $scope.artlabelChooseIndex = 0;
        }

        function getBackgrounds(label, url, num, callback) {
            var list = {
                items: 0,
                arr: []
            };
            url.byCondition3({
                items: [
                    {key: "themeClassify.id", op: "=", value: label.id}],
                page: num,
                size: vm.itemsPerPage,
                sort: ["seq,asc"]
            }, function (res, headers) {
                list.items = headers('X-Total-Count');
                if(res.status==200){
                    angular.forEach(res.data, function (resp) {
                        var arr = {
                            name: resp.name,
                            identifier: $scope.domain + resp.identifier,
                            provider: resp.provider,
                            themeClassifyName: resp.themeClassifyName,
                            themeClassifyId: resp.themeClassifyId,
                            resource: {
                                identifier: $scope.domain + resp.identifier,
                                provider: resp.provider,
                            }
                        }
                        list.arr.push(arr);
                    })
                    callback.call(this, list);
                }else{
                    swal({
                        title: res.message,
                        text: "",
                        imageUrl: Theme.sweetSuccedImg(),
                        timer: 2000,
                        showConfirmButton: false
                    });
                }
            });
        }

        function showPages() {
            $timeout(function() {
                $scope.loading = false;
                $(".page-loading").hide().css({'opacity': 0});
                $li.show();
                $(".guide-view").removeClass('opacity-zero');
                // 等到刷新后直接赋值
                localStorage.setItem('pages', JSON.stringify($scope.template.pages));
            });

        }

        function choose(local_pages, res) {
            // 一键Go
            if ((goes != null || goes != undefined) && goes.length && vm.vid) {
                var i = 0;
                angular.forEach(res.pages.page, function (page) {
                    if (page.backup) {
                        return
                    }
                    var arr = [];
                    angular.forEach(page.levels.level, function (level, j) {
                        // level.sort(compare('imagebox'));
                        var len = 0, img = level.imagebox;
                        if (img && img.geometry) {
                            len++;
                            if (!img.image) {
                                img.image = {}
                            }
                            console.log(len)
                            if (len > 1) {
                                // 得到占位框的宽高比
                                img.ratio = img.geometry.width / img.geometry.height;
                                if (goes[i]) {
                                    goes[i].index = i;
                                    arr.push(goes[i]);
                                    i++;
                                }
                                console.log(j)
                                if (j == page.levels.level.length - 1) {
                                    // 按照占位框的宽高比排序
                                    page.levels.level.sort(compare('ratio'));
                                    // 按照工作区中图片的宽高比排序
                                    arr.sort(compare('ratio'));
                                }
                            } else {
                                if (!goes[i]) {
                                    return
                                }
                                if(level.variable){
                                    if(vm.variableBoxDatas.length&&level.name){
                                        var flag = true;
                                        for (var _i = 0; _i < vm.variableBoxDatas.length; _i++) {
                                            if(vm.variableBoxDatas[_i].name==level.name){
                                                flag = false;
                                                if(!vm.variableBoxDatas[_i].value){
                                                    vm.variableBoxDatas[_i].value = 'https://photoavatar-pic-dev.deltazo.com/file-463ea37f-1577-4451-a903-dc534e83f5f1'
                                                }
                                                vm.variableBoxDatas[_i].identifier = vm.variableBoxDatas[_i].value;
                                                $.ajax({
                                                    type: "GET",
                                                    url: vm.variableBoxDatas[_i].value + "?imageInfo",
                                                    async: false,
                                                    success: function (va) {
                                                        vm.variableBoxDatas[_i].imgSize = va.size;
                                                        if (va.orientation == "Left-bottom" || va.orientation == "Right-top" || va.orientation == "Left-top" || va.orientation == "Right-bottom") {
                                                            vm.variableBoxDatas[_i].width = va.height;
                                                            vm.variableBoxDatas[_i].height = va.width;
                                                        }else{
                                                            vm.variableBoxDatas[_i].width = va.width;
                                                            vm.variableBoxDatas[_i].height = va.height;
                                                        }
                                                        goes.splice(i,0,vm.variableBoxDatas[_i]);
                                                        img.image = imgParamter(img, goes[i], i);
                                                        if (vm.article.productBokehType!='None') {
                                                            img.blurredrectangle = {}
                                                        }
                                                        i++
                                                    },
                                                    error: function (request) {

                                                    }
                                                });
                                                break
                                            }
                                        }
                                        if(flag){
                                            img.image = imgParamter(img, goes[i], i);
                                            if (vm.article.productBokehType!='None') {
                                                img.blurredrectangle = {}
                                            }
                                            i++
                                        }
                                    }
                                }else{
                                    img.image = imgParamter(img, goes[i], i);
                                    if (vm.article.productBokehType!='None') {
                                        img.blurredrectangle = {}
                                    }
                                    i++
                                }
                            }
                        }
                    })
                });
            } else {
                // $scope.template.pages.page中的内容
                if (local_pages.page && local_pages.page.length > 0) {
                    // vm.counts = 0;
                    res.pages = angular.copy(local_pages);
                    angular.forEach(res.pages.page, function (p, index) {
                        // if (!p.backup) {
                        //     vm.counts += p.imageboxes.imagebox.length;
                        // }
                        angular.forEach(p.levels.level, function (level, i) {
                            var img = level.imagebox;
                            if (img && img.geometry && p && img.blobImage) {
                                img.blurredrectangle = img.blurredrectangle || {};
                                var imgIdentifier = "";
                                if (img.image && img.image.resource && img.image.resource.identifier) {
                                    imgIdentifier = img.image.resource.identifier;
                                }
                                if (!img.image) {
                                    img.image = {};
                                }
                                img.image = {
                                    resource: {
                                        identifier: imgIdentifier,
                                        provider: 'qiniu'
                                    },
                                    parameter: img.image.parameter || [],
                                    offsetx: img.image.offsetx || 0,
                                    offsety: img.image.offsety || 0,
                                    angle: img.image.angle || 0,
                                    scale: img.image.scale || 1,
                                    index: img.image.index ? img.image.index : vm.pid ? i :'',
                                    width: img.image.width || '',
                                    height: img.image.height || '',
                                    scaleW: img.image.scaleW || 1,
                                    scaleH: img.image.scaleH || 1,
                                    imgSize: img.image.imgSize || '',
                                    lowSize: img.image.lowSize == false ? false : true,
                                    resourceid: img.image ? img.image.sourceId ? img.image.sourceId : img.image.resourceid ? img.image.resourceid : '' : ''
                                };
                            }
                        })
                    });
                }
            }

            vm.article.document = {
                pages: res.pages
            };

            vm.edit = true;     //判断是否是模板上的文字
            localStorage.removeItem("go");
            return res;
        }

        function compare(property) {
            return function (a, b) {
                var value1 = a[property];
                var value2 = b[property];
                return value1 - value2;
            }
        }

        function imgParamter(img, arr, i) {
            return {
                resource: {
                    identifier: img.image.resource && img.image.resource.identifier != '' ? img.image.resource.identifier : arr.identifier,
                    provider: 'qiniu',
                    width: arr.width,
                    height: arr.height
                },
                parameter: arr.parameter,
                offsetx: img.image.offsetx || 0,
                offsety: img.image.offsety || 0,
                angle: img.image.angle || 0,
                scale: img.image.scale || 1,
                index: i,
                width: arr.width,
                height: arr.height,
                imageInfo: arr.imageInfo,
                imgSize: arr.imgSize,
                resourceid: arr.sourceId,
                scaleH: img.image.scaleH || 1,
                scaleW: img.image.scaleW || 1,
            };
        }

        function getAll(document) {
            var marLeft = localStorage.getItem("marginLeft") || 0;
            $ul.css({'margin-left': -marLeft + 'px'});
            $rootScope.currentCarouselIndex = Math.abs(parseInt(marLeft / ($scope.dWidth * 0.94)));
            $scope.visibleLeft = $rootScope.currentCarouselIndex ? true : false;
            $scope.visibleRight = $rootScope.currentCarouselIndex + 1 == document.pages.page.length ? true : false;
            getFontList();
            //取得xml文档内容
            if(!(local_pages.length||local_pages.page&&local_pages.page.length)){
                getPageToPx1(document)
            }else{
                //刷新操作
                $scope.template.pages = angular.copy(local_pages);
                imageboxLow();
                vm.pageItem = angular.copy($scope.template.pages[$rootScope.currentCarouselIndex])
                showPages();
            }

        }

        function getPageToPx1(document) {
            vm.template = angular.copy(document);
            documentAnalysis($scope, $http, vm, vm.template,FontManagement, 'jianyi', function(page,index){
                //平铺页面
                if ((index == 0 || index == $scope.PAGELEN - 1) && vm.pattern == 'BOOK') {
                    page.styleScale = $scope.dWidth * 0.6 / page.mediabox.width;
                } else {
                    page.styleScale = $scope.dWidth * 0.45 / page.mediabox.width;
                }
                // 编辑页面
                if (page.isMaxWidth) {
                    page.styleScale2 = $scope.dWidth * 0.94 / page.mediabox.width;
                } else {
                    page.styleScale2 = ($scope.dHeight - $scope.tHeight) / page.mediabox.height;
                }
                page.ratio = page.mediabox.width*page.styleScale / page.mediabox.width;
                page.ratio2 = page.mediabox.width*page.styleScale2 / page.mediabox.width

            }, function (res) {
                vm.thumbnailScale = 300 / res.pages.page[0].mediabox.width;
                $scope.template.pages = res.pages;
                // if (vm.counts == 0 || vm.FirstSeven == 0) {
                //     showPages();
                // }
                showPages();
                $scope.isLeftRotation = false;
                setTimeout(function(){
                    getSameUseNum();
                    imageboxLow()
                },200)

            })
        }

        function imageboxLow() {
            $scope.template.pages.page.forEach(function (page) {
                if(page && page.levels && page.levels.level){
                    page.levels.level.forEach(function (level) {
                        if(level.imagebox&&level.imagebox.image && level.imagebox.image.resource && level.imagebox.image.resource.identifier){
                            pxInsufficient(level.imagebox, vm.imgSize, vm.imgDpi)
                        }
                    })
                }
            })
        }
        function getSameUseNum() {
            angular.forEach($scope.template.pages.page, function (page, index) {
                angular.forEach(page.levels.level, function (level, i) {
                    var imagebox = level.imagebox;
                    if (imagebox && imagebox.image) {
                        for (var j = 0; j < $scope.qiniuId.length; j++) {
                            if ($scope.qiniuId[j].sourceId == imagebox.image.resourceid) {
                                imagebox.image.index = j;
                            }
                        }
                    }
                })
            })
        }

        /*******************************************图片功能****************************start*********************************************/
        function getImageScale(imagebox, images) {
            var w0 = angular.copy(imagebox.width);
            var h0 = angular.copy(imagebox.height);
            if(imagebox.resource){
                w0 = angular.copy(imagebox.width);
                h0 = angular.copy(imagebox.height);
                if (imagebox.angle == 90 || imagebox.angle == 270) {
                    w0 = angular.copy(imagebox.height);
                    h0 = angular.copy(imagebox.width);
                }
            }else{
                if (imagebox.angle == 90 || imagebox.angle == 270) {
                    w0 = angular.copy(imagebox.height);
                    h0 = angular.copy(imagebox.width);
                }
            }

            var x = 0, y = 0;

            var w = angular.copy(w0);
            var h = angular.copy(h0);
            var maskWidth = images.width;
            var maskHight = images.height;
            var isWidth = true;
            if ((w0 <= h0 || maskWidth <= maskHight) && (w0 / h0 < maskWidth / maskHight) || w0 >= h0 && maskWidth >= maskHight && (w0 / h0 < maskWidth / maskHight)) {
                w0 = maskWidth;
                h0 = maskWidth * h / w;
                isWidth = true;
            } else {
                h0 = maskHight;
                w0 = maskHight * w / h;
                isWidth = false;
            }

            var scaleW = w0 / w;
            var scaleH = h0 / h;
            x = x / scaleW;
            y = y / scaleH;
            return {
                isWidth: isWidth,
                nWidth: w0,
                nHeight: h0,
                scaleW: scaleW,
                scaleH: scaleH,
                x: x,
                y: y
            }
        }

        var f = 0;

        function imgScale(imagebox, index, id,x,y) {
            var img = imagebox.image.resource.identifier + '?imageMogr2/strip/thumbnail/!20p';
            if (imagebox.image.angle != 0) {
                img += '/rotate/' + imagebox.image.angle
            }
            // var newImg = new Image();
            // newImg.crossOrigin = "Anonymous";
            // newImg.src = img;
            // newImg.onload = function () {
            //     newImg.onload = null;
                var width = imagebox.image.width;
                var height = imagebox.image.height;
                var wOrigin = angular.copy(width);
                var hOrigin = angular.copy(height);
                // 单页编辑占位框宽高
                var maskWidth = imagebox.geometry.width;
                var maskHight = imagebox.geometry.height;

                if(imagebox.bokehtype == 'None'){
                    if ((wOrigin <= hOrigin || maskWidth <= maskHight) && (wOrigin / hOrigin < maskWidth / maskHight) || wOrigin >= hOrigin && maskWidth >= maskHight && (wOrigin / hOrigin < maskWidth / maskHight)) {
                        imagebox.adaptation = 'Width';
                        imagebox.image.width= imagebox.geometry.width;
                        imagebox.image.height= imagebox.geometry.width/width*height;
                        imagebox.image.offsetx= x;
                        imagebox.image.offsety= y;
                    } else {
                        imagebox.adaptation = 'Height';
                        imagebox.image.width= imagebox.geometry.height/height*width;
                        imagebox.image.height= imagebox.geometry.height;
                        imagebox.image.offsetx= x;
                        imagebox.image.offsety= y;
                    }
                }else {
                    if ((wOrigin <= hOrigin || maskWidth <= maskHight) && (wOrigin / hOrigin < maskWidth / maskHight) || wOrigin >= hOrigin && maskWidth >= maskHight && (wOrigin / hOrigin < maskWidth / maskHight)) {
                        imagebox.adaptation = 'Width';
                        imagebox.image.width = imagebox.geometry.width;
                        imagebox.image.height = imagebox.geometry.width * height / width;
                        imagebox.image.offsetx = 0;
                        imagebox.image.offsety = 0;
                        imagebox.blurredrectangle = {
                            width: imagebox.geometry.height * width / height,
                            height: imagebox.geometry.height,
                            x: (imagebox.geometry.width - imagebox.geometry.height * width / height) / 2,
                            y: 0,
                        }
                    } else {
                        imagebox.adaptation = 'Height';
                        imagebox.image.width = imagebox.geometry.height * width / height;
                        imagebox.image.height = imagebox.geometry.height;
                        imagebox.image.offsetx = 0;
                        imagebox.image.offsety = 0;
                        imagebox.blurredrectangle = {
                            width: imagebox.geometry.width,
                            height: imagebox.geometry.width * height / width,
                            x: 0,
                            y: (imagebox.geometry.height - imagebox.geometry.width * height / width) / 2,
                        }
                    }
                }

                imagebox.blobImage = true;
                pxInsufficient(imagebox, vm.imgSize, vm.imgDpi)
                $timeout(function() {
                    $scope.$digest();
                    console.log("???!##")
                }, 0, false);
                f++;
                if (f >= vm.counts) {
                    showPages();
                }
                // $scope.$digest();
            // };
            // newImg.src = img;
        }

        //放大
        $scope.modeIn = function () {
            changeBlurred(true);
        };
        //缩小
        $scope.modeOut = function () {
            changeBlurred(false);
        };

        function changeBlurred(modeIn) {
            getCurrentImage();
            var imagebox = $scope.currentPage.levels.level[$scope.i].imagebox;

            if (modeIn) {
                // 大图片模式
                imagebox.bokehtype ='None'
                // imagebox.blurred = false;
                $(".cut-image").show();
            } else {
                // 虚化模式
                imagebox.bokehtype =vm.article.bokehtype;
                imagebox.image.angle = 0;
                $(".cut-image").hide();
            }
            imgScale(imagebox, $scope.index, $scope.i,  0, 0);
        }

        /**
         * 3种返回状态
         * 1： 平铺页面---->产品选择
         * 2： 图片编辑---->作品制作当前页
         * 3： 作品制作页面---->平铺页面
         */
        $scope.backTo = function () {
            var index = $rootScope.currentCarouselIndex;
            // 平铺页面---->产品选择
            if ($scope.status == 'view') {
                swal({
                    title: $translate.instant("choose.editorMessage.pageNotSave"),
                    text: "",
                    imageUrl: Theme.sweetHintImg(),
                    showCancelButton: true,
                    confirmButtonText: $translate.instant("choose.editor.cancel"),
                    cancelButtonText: $translate.instant("choose.editor.confirm"),
                    closeOnConfirm: true
                }, function (isConfirm) {
                    if (isConfirm) {
                    } else {
                        $scope.bool = false;
                        if (vm.pid) {
                            $state.go('thumbnail',{storeId:vm.storeId,pid:vm.pid,vid:vm.vid,aid:vm.aid});
                        } else {
                            $state.go("product-view-ec", {storeId: vm.storeId, aid: vm.aid});
                        }

                        removeAll();
                    }
                }, function () {
                });
            }

            // getCurrentImage();

            // 图片编辑---->作品制作当前页
            if ($scope.showCut) {
                $scope.showCut = false;
                $scope.showImageMenu = false;
                $scope.showBottomMenu = true;
                $scope.template.pages.page[index].levels.level[$scope.template.levelI].imagebox = $scope.cutImagebox;
                $scope.cutImagebox = [];
                tipStatus(false);
                $(".edit-head").css({position: 'fixed'});
                return
            }
            // 文字---->作品制作当前页
            if ($scope.showTextModal) {
                $scope.showTextMenu = false;
                $scope.showTextModal = false;
                $scope.showBottomMenu = true;
                var levels = $scope.template.pages.page[index].levels.level
                if(vm.addText){
                    levels.splice($scope.template.levelI, 1);
                    $scope.template.levelI = levels.length-1;
                }else{
                    levels[$scope.template.levelI].textbox = angular.copy($scope.textCopy);
                }
                vm.addText = false;
                $scope.textCopy = [];
                tipStatus(false);
                return
            }

            // 作品制作页面---->平铺页面
            if ($scope.status == 'make') {
                swal({
                    title: $translate.instant("choose.editorMessage.pageNotSave"),
                    text: "",
                    imageUrl: Theme.sweetHintImg(),
                    showCancelButton: true,
                    confirmButtonText: $translate.instant("choose.editor.cancel"),
                    cancelButtonText: $translate.instant("choose.editor.confirm"),
                    closeOnConfirm: true
                }, function (isConfirm) {
                    if (!isConfirm) {
                        tipStatus(false);
                        $scope.showImageMenu = false;
                        $scope.showTempMenu = false;
                        $scope.isReplaceShow = false;
                        $scope.showStickerMenu = false;
                        setProductionStorage('view');
                        localStorage.removeItem('marginLeft');

                        $scope.galleryCopy = JSON.parse(localStorage.getItem("galleryCopy"));
                        localStorage.setItem('gallery', JSON.stringify($scope.galleryCopy));
                        $scope.qiniuId = $scope.galleryCopy;

                        var pageI = localStorage.getItem("saveOldPageIndex");
                        var oldPage = JSON.parse(localStorage.getItem("saveOldPage"));
                        if(vm.pageItem==null){
                            $scope.template.pages.page[pageI] = angular.copy(oldPage);
                        }else{
                            $scope.template.pages.page[pageI] = angular.copy(vm.pageItem);
                            vm.pageItem = null;
                        }

                        $ul.css({marginLeft: '0px'});
                        $("#small-pic").addClass('hide1');

                        backToScrollTop();
                        $scope.$digest();
                        return;

                    }
                }, function () {
                });

            }
        };

        function backToScrollTop() {
            // 设置滚动距离
            var viewScrollTop = localStorage.getItem('view-scrollTop') || 0;
            if (!window.__wxjs_is_wkwebview) {
                $('.template-view').css("transform", "translateY(-" + viewScrollTop + "px)");
                setTimeout(function () {
                    $('.template-view').css("transform", "translateY(0px)");
                    $(".edit-page-content")[0].scrollTop = viewScrollTop;
                }, 10);
            } else {
                setTimeout(function () {
                    $(".edit-page-content")[0].scrollTop = viewScrollTop;
                }, 100);
            }

        }

        $scope.isFirstEdit = true;
        if ($scope.status == 'make') {
            $scope.isFirstEdit = false;
        }
        /**
         * 平铺页面点击进入作品制作页
         * @param page  点击页
         * @param index 点击页的下标
         */
        $scope.clickToEdit = function (page, index) {
            vm.isDocumentTextDetection=false;
            if(vm.sortStatus){
                return
            }
            $rootScope.currentCarouselIndex = index;

            // 当引导页点击“不在提示”以后就不再count++;
            isChoose = localStorage.getItem("choose");
            if (!vm.guideStep && !(isChoose == 'choose')) {
                $scope.countN++;
                localStorage.setItem('countN', $scope.countN);
            }

            if (!vm.guideStep && ($scope.countN == 9 || $scope.countN == 10 || $scope.countN == 11 || $scope.countN == 12 || $scope.countN == 13)) {
                $('.tip-image').addClass('hide1');
            } else {
                $('.tip-image').removeClass('hide1');
            }

            var str = parseInt($('.template-view')[0].style.webkitTransform.replace(/[^0-9]+/g, '') || 0);
            var scrollT = parseInt($(".edit-page-content")[0].scrollTop);

            localStorage.setItem('view-scrollTop', scrollT + str);

            vm.pageIndex = index;
            vm.pageItem = angular.copy(page);
            setReviewStorage(index);
            setProductionStorage('make');

            $scope.showBottomMenu = true;
            $scope.showImageMenu = false;

            $ul.css({marginLeft: -($scope.dWidth * 0.94 * index) + 'px'});

            $scope.visibleLeft = $rootScope.currentCarouselIndex ? true : false;
            $scope.visibleRight = $rootScope.currentCarouselIndex + 1 == $scope.template.pages.page.length ? true : false;

            $('.edit-menu-make').addClass('opacity-zero');

            $scope.isFirstEdit = false;
            imageboxLow()
        };

        $scope.showTempImg = function (temp) {
            if (temp.id == vm.xmlId) {
                SweetAlert.swal({
                    title: $translate.instant("choose.editorMessage.replaceFailed"),
                    imageUrl: Theme.sweetHintImg(),
                    text: $translate.instant("choose.editorMessage.alreadyInTheCurrentTemplate"),
                    timer: 1000,
                    showConfirmButton: false
                });
                return
            }
            vm.xmlShowPic = true;
            $scope.chooseTemp = temp;
            ProductXml.get({id: temp.productXmlId}, function (res) {
                if(res.status == 200){
                    if (res.data.documentPics && res.data.documentPics.length > 0) {
                        res.data.documentPics.sort(function (a, b) {
                            return a.seq - b.seq;
                        });
                    }
                    vm.imgs = res.data.documentPics;
                    num = vm.imgs.length || 0;
                }else {
                    MessageService.error(res.message);
                }
            }, function () {

            })
        }

        $scope.changeAllTemp = function () {
            SweetAlert.swal({
                title: $translate.instant("choose.editorMessage.replacingTemplateMessage"),
                imageUrl: Theme.sweetHintImg(),
                showCancelButton: true,
                confirmButtonText: $translate.instant("choose.editor.confirm"),
                cancelButtonText: $translate.instant("choose.editor.cancel"),
                closeOnConfirm: true,
                closeOnCancel: true
            }, function (isConfirm) {
                if (isConfirm) {
                    swal.close();
                    localStorage.removeItem('pages');
                    localStorage.removeItem("marginLeft");
                    angular.forEach($scope.qiniuId, function (photo, i) {
                        photo.usenum = 0;
                        localStorage.setItem("gallery", JSON.stringify($scope.qiniuId));
                    });
                    $state.go("product-choose-ec", {
                        storeId: vm.storeId,
                        pid: productId,
                        vid: vm.vid,
                        xmlId: $scope.chooseTemp.id,
                        aid: vm.aid
                    });
                } else {
                    console.log('取消');
                }
            })
        }

        var inits = 0, num = 0;
        vm.xmlShowPic = false;
        $scope.previewClose = function () {
            inits = 0;
            vm.xmlShowPic = false;
        };

        $scope.imgClick = function (event) {
            if (event == null || event.originalEvent == null || event.currentTarget == null) {
                return;
            }
            if (event.originalEvent.layerX > event.currentTarget.clientWidth / 2) {
                $scope.nextImg();
            } else {
                $scope.prevImg();
            }

        }
        $scope.prevImg = function () {
            if (inits > 0) {
                inits--;
            } else {
                return;
            }
            document.getElementById("top-img").src = vm.imgs[inits].identifier + '?imageView2' || '//:0';
        };
        $scope.nextImg = function () {
            if (inits < (num - 1)) {
                inits++;
            } else {
                return;
            }
            document.getElementById("top-img").src = vm.imgs[inits].identifier + '?imageView2' || '//:0';
        };

        var moveLaR = function () {
            var page = $scope.template.pages.page[$rootScope.currentCarouselIndex];
            if ((window.orientation == 90 || window.orientation == -90) && vm.flags) {
                $li.removeClass('template-heng').addClass('template-heng2');
                var heights = $scope.dWidth * 0.94 * page.height / page.width - 1;
                $("#slide" + $rootScope.currentCarouselIndex).find(".slide-content").css({'height': heights});
            }
            $li.removeClass('template-heng3');
            tipStatus(false);
            $(".change-btn").hide();
            mL = Math.abs(parseFloat($ul.css('marginLeft')));
            liW = parseFloat($li[0].getBoundingClientRect().width);
            ulW = liW * $scope.PAGELEN;

            $scope.showBottomMenu = true;
            $scope.showImageMenu = false;
        };

        /**
         * 左移按钮
         */
        $scope.pageLeft = function () {
            moveLaR();
            $scope.visibleRight = false;
            if (runL) {
                if (mL <= liW + 10) {
                    $scope.visibleLeft = false;
                }
                var index = $rootScope.currentCarouselIndex;
                $rootScope.currentCarouselIndex--;

                $ul.css({opacity: 0}).removeClass('fade-out').removeClass('is-paused');
                $ul.css({marginLeft: -(mL - liW) + 'px'});
                setTimeout(function () {
                    runL = true;
                    $ul.addClass('is-paused').addClass('fade-out').css({opacity: 1});
                }, 700);

                setReviewStorage($rootScope.currentCarouselIndex);
                setGalleryStorage();
                localStorage.setItem("marginLeft", $scope.dWidth * 0.94 * $rootScope.currentCarouselIndex);

                vm.pageIndex = $rootScope.currentCarouselIndex;
                vm.pageItem = angular.copy($scope.template.pages.page[vm.pageIndex]);
            }
            runL = false;
        };

        /**
         * 右移按钮
         */
        $scope.pageRight = function () {
            moveLaR();
            $scope.visibleLeft = true;
            if (runR) {
                if (mL + liW >= ulW - liW - 10) {
                    $scope.visibleRight = true;
                }
                $rootScope.currentCarouselIndex++;

                $ul.css({opacity: 0}).removeClass('fade-out').removeClass('is-paused');
                $ul.css({marginLeft: -(mL + liW) + 'px'});
                setTimeout(function () {
                    runR = true;
                    $ul.addClass('is-paused').addClass('fade-out').css({opacity: 1});
                }, 700);

                setReviewStorage($rootScope.currentCarouselIndex);
                setGalleryStorage();

                vm.pageIndex = $rootScope.currentCarouselIndex;
                vm.pageItem = angular.copy($scope.template.pages.page[vm.pageIndex]);
                localStorage.setItem("marginLeft", $scope.dWidth * 0.94 * $rootScope.currentCarouselIndex);
            }
            runR = false;
        };

        // 旋转屏幕
        window.addEventListener('orientationchange', function () {
            setTimeout(function () {
                $(".save-page").addClass('hide1');
                if (window.orientation == 180 || window.orientation == 0) {
                    //竖屏
                    $(".page-orientation").addClass('hide1');
                    if ($scope.isSave) {
                        return
                    }
                    orientationChange(false);
                    if (vm.isOrientation) {
                        // for (var i = 0; i < reviewDoc.page.length; i++) {
                        //     getPageToPx(reviewDoc.page[i], i, true, true, reviewDoc.page.length);
                        // }
                        vm.isOrientation = false;
                        return
                    }

                    var mar = ($scope.dWidth * 0.94 - $li.width()) / 2;
                    $li.css({'margin-left': mar}).removeClass('mar-top-0');
                } else if (window.orientation == 90 || window.orientation == -90) {
                    //横屏
                    $(".page-orientation").removeClass('hide1');
                    if ($scope.isSave) {
                        return
                    }
                    orientationChange(true);
                    var mar = ($scope.dWidth * 0.94 - $li.width()) / 2;
                    $li.css({'margin-left': mar}).addClass('mar-top-0');
                }
            }, 500);
        });

        if (window.orientation == 90 || window.orientation == -90) {
            $(".page-orientation").removeClass('hide1');
            vm.flags = false;
            vm.isOrientation = true;
            $(document.body).addClass('bgColor');
        }

        function orientationChange(flag) {
            vm.flags = flag;
            $scope.dHeight = document.documentElement.clientHeight;
            $scope.dWidth = document.documentElement.clientWidth;
            $(document.body).toggleClass('bgColor');

            $("body").css({width: $scope.dWidth, 'min-width': $scope.dWidth});      //设置页面的最小宽度
            localStorage.setItem("marginLeft", $scope.dWidth * 0.94 * $rootScope.currentCarouselIndex);
        }

        /**
         * 放大缩小及删除
         */
        function changeImgOffset(zoomIn) {
            getCurrentImage();
            var imagebox = $scope.currentImage.image;

            var number = 1.2;
            if (zoomIn) {
                imagebox.scale = imagebox.scale ? imagebox.scale * number : number;
            } else {
                if (imagebox.scale.toFixed(2) <= 1) {
                    imagebox.scale = 1;
                    return;
                }
                imagebox.scale = imagebox.scale / number;
            }

            console.log(imagebox.scale)
            imagebox.offsetx = 0;
            imagebox.offsety = 0;
            $("#cut-img").css({left: imgX, top: imgY});

            $scope.moveImg = {
                width: $("#cut-opacity").width(),
                height: $("#cut-opacity").height(),
                angle: imagebox.angle
            };
            pxInsufficient($scope.currentImage, vm.imgSize, vm.imgDpi)
        }

        function getCurrentImage() {
            $scope.index = $rootScope.currentCarouselIndex || 0;
            $scope.i = $scope.template.pages.page[$scope.index].selectImgIndex;
            $scope.imgs = document.getElementById("imgInput" + $scope.index + '' + $scope.i);
            $scope.imgReals = $(".imgBox" + $scope.index + '' + $scope.i);
            $scope.currentPage = $scope.template.pages.page[$scope.index];
        }

        var boxW = 0, boxH = 0, picW = 0, picH = 0, scale = 0;

        function getDpi(box) {
            boxW = unitTransformPx(box.geometry.width);
            boxH = unitTransformPx(box.geometry.height);
            picW = box.image.width;
            picH = box.image.height;
            scale = box.image.scale;
            var x = 0, y = 0;
            // 宽度适配
            if (box.adaptation=='Width') {
                x = picW / (boxW / 25.4) / scale;
                y = boxH * picW / boxW / (boxH / 25.4) / scale;
            } else {
                x = boxW * picH / boxH / (boxW / 25.4) / scale;
                y = picH / (boxH / 25.4) / scale;
            }
            if (x < 150 || y < 150) {
                box.image.lowSize = true;
            } else {
                box.image.lowSize = false;
            }
        }

        $scope.zoomIn = function () {
            changeImgOffset(true);
        };

        $scope.zoomOut = function () {
            changeImgOffset(false);
        };

        var imgX = parseFloat($(".cut-position").css('left'));
        var imgY = parseFloat($(".cut-position").css('top'));
        /**
         * 进入图片编辑模式
         */
        $scope.cutImage = function () {
            getCurrentImage();
            $scope.showCut = true;
            $scope.showImageMenu = false;
            var box = $scope.currentImage = $scope.currentPage.levels.level[$scope.i].imagebox;
            $("#cut-mask").attr('src', '');

            var ww = angular.copy(box.geometry.width);
            var hh = angular.copy(box.geometry.height);
            $scope.cutImagebox = angular.copy($scope.currentPage.levels.level[$scope.i].imagebox);
            var s = box.maskUrl;
            if (ww > hh) {
                ww = $scope.dWidth * 0.8;
                hh = ww / box.geometry.width * box.geometry.height;
            } else {
                hh = ($scope.dHeight - 50) * 0.8;
                ww = hh / box.geometry.height * box.geometry.width;
            }
            if (ww > $scope.dWidth * 0.8) {
                ww = $scope.dWidth * 0.8;
                hh = ww / box.geometry.width * box.geometry.height;
            }
            if (hh > ($scope.dHeight - 50) * 0.8) {
                hh = ($scope.dHeight - 50) * 0.8;
                ww = hh / box.geometry.height * box.geometry.width;
            }

            if (box.adaptation=='Width') {
                $scope.wOpacity = ww;
                $scope.hOpacity = '';
                $scope.w = ww;
                $scope.h = '';
            } else {
                $scope.hOpacity = hh;
                $scope.wOpacity = '';
                $scope.h = hh;
                $scope.w = '';
            }

            $scope.moveGeo = {
                width: ww,
                height: hh,
                scale: ww / box.geometry.width
            };
            imgX = ($scope.dWidth - ww) / 2;

            $scope.t = imgY;
            $scope.l = imgX;
            ImageService.convertImgToBase64(s, function (s) {
                var imagecanvas = document.createElement('canvas');
                var imagecontext = imagecanvas.getContext('2d');
                var newImg = document.createElement('img');
                newImg.src = 'content/images/zhezhao1.png';
                newImg.onload = function () {
                    newImg.onload = null;
                    var masks = document.createElement('img');
                    masks.src = s;
                    masks.onload = function () {
                        masks.onload = null;
                        imagecanvas.width = $scope.dWidth;
                        imagecanvas.height = $scope.dHeight - 50;
                        imagecontext.drawImage(masks, $scope.l, $scope.t, ww, hh);
                        imagecontext.globalCompositeOperation = 'source-out';
                        imagecontext.drawImage(newImg, 0, 0, $scope.dWidth, $scope.dHeight - 50);
                        $("#cut-mask").attr('src', imagecanvas.toDataURL());
                        $scope.imgW = ww;
                        $scope.imgH = hh;
                        $scope.moveImg = {
                            width: $("#cut-opacity").width(),
                            height: $("#cut-opacity").height(),
                            angle: box.image.angle
                        };
                        var coordX = box.image.offsetx * box.image.scale * $scope.moveGeo.scale;
                        var coordY = box.image.offsety * box.image.scale * $scope.moveGeo.scale;
                        $("#cut-img").css({
                            left: coordX + imgX,
                            top: coordY + imgY
                        });

                        $scope.$digest();
                    };
                };
                newImg.src = 'content/images/zhezhao1.png';
            });
        };

        /**
         * 拖拽编辑的图片
         */
        window.startEdit = function (e) {
            fn(e);
            var box = $scope.currentImage;
            if($scope.moveImg.width<=0||$scope.moveImg.height<=0){
                $scope.moveImg = {
                    width: $("#cut-opacity").width(),
                    height: $("#cut-opacity").height(),
                    angle: box.image.angle
                };
            }
            selectImgBoxes($scope.i);
            $scope.imageArr = getImageScale($scope.moveImg, $scope.moveGeo);
            dragBox.clientX = e.changedTouches[0].clientX ? e.changedTouches[0].clientX : 0;
            dragBox.clientY = e.changedTouches[0].clientY ? e.changedTouches[0].clientY : 0;
            dragBox.coordX = box.image.offsetx * box.image.scale * $scope.moveGeo.scale * $scope.imageArr.scaleW;
            dragBox.coordY = box.image.offsety * box.image.scale * $scope.moveGeo.scale * $scope.imageArr.scaleH;
            drag = true;
        };

        window.dragEdit = function (e) {
            getCurrentImage();
            var box = $scope.currentImage;

            //乘以放大缩小倍数后的宽高
            var orignW = $scope.imageArr.nWidth * box.image.scale;
            var orignH = $scope.imageArr.nHeight * box.image.scale;
            var isWidth = $scope.imageArr.isWidth;
            if (drag) {
                var x = 0, y = 0;
                //手指离开屏幕
                if (!isWidth && box.image.scale == 1) {    //宽图
                    x = (dragBox.coordX + (e.changedTouches[0].clientX - dragBox.clientX)) / $scope.imageArr.scaleW;
                } else if (isWidth && box.image.scale == 1) {     //高图
                    y = (dragBox.coordY + (e.changedTouches[0].clientY - dragBox.clientY)) / $scope.imageArr.scaleH;
                } else if (box.image.scale > 1) {
                    x = (dragBox.coordX + (e.changedTouches[0].clientX - dragBox.clientX)) / $scope.imageArr.scaleW;
                    y = (dragBox.coordY + (e.changedTouches[0].clientY - dragBox.clientY)) / $scope.imageArr.scaleH;
                }

                //向上滑动;
                if (-y >= (orignH - $scope.moveGeo.height-1)) {
                    y = -(orignH - $scope.moveGeo.height-1);
                }
                //向左滑动;        <-----
                if (-x >= (orignW - ($scope.moveGeo.width+1))) {
                    x = -(orignW - ($scope.moveGeo.width+1));
                }
                //向下滑动;
                if (y >= 0) {
                    y = 0;
                }
                // 向右滑动;    ---->
                if (x >= 0) {
                    x = 0;
                }

                $("#cut-img").css({left: x + imgX, top: y + imgY});

                box.image.offsetx = x / box.image.scale / $scope.moveGeo.scale;
                box.image.offsety = y / box.image.scale / $scope.moveGeo.scale;

                $scope.$digest();
                e.stopPropagation();
                e.preventDefault();
                return false;

            }

        };

        window.stopEdit = function () {
            drag = false;
            dragBox = {};
        };

        /**
         * 保存所编辑过的图片
         */
        $scope.saveMove = function () {
            getCurrentImage();
            var box = $scope.currentImage;
            $scope.showImageMenu = false;
            $scope.showBottomMenu = true;

            var imageArr = getImageScale(box.image, box.geometry);
            box.image.scaleW = imageArr.scaleW;
            box.image.scaleH = imageArr.scaleH;
            tipStatus(false);

            box.blobImage = true;
            $scope.showCut = false;
            var newImg = document.createElement('img');
            var img = box.imgUrl + '?imageMogr2/strip/thumbnail/!20p';
            if (box.image.angle != 0) {
                img += '/rotate/' + box.image.angle
            }
            newImg.src = img;
            newImg.onload = function () {
                box.image.width = angular.copy(newImg.width*5);
                box.image.height = angular.copy(newImg.height*5);
                console.log(newImg.width)
                console.log(newImg.height)
                imgScale(box, $scope.index, $scope.i, box.image.offsetx, box.image.offsety);
                $scope.$digest();
            }
            newImg.src = img;
        };

        /**
         * 选择图片
         * @param flag   true: 逆时针旋转    false： 顺时针旋转
         */
        $scope.rotateImage = function (flag) {
            var box = $scope.currentImage;
            if (flag) {
                box.image.angle -= 90;
                if (box.image.angle == -90) {
                    box.image.angle = 270
                }
            } else {
                box.image.angle += 90;
                if (Math.abs(box.image.angle) == 360) {
                    box.image.angle = 0
                }
            }
            $scope.moveImg.angle = box.image.angle;
            $scope.imageArr = getImageScale($scope.moveImg, $scope.moveGeo);

            var imageEdit = getImageScale(box.image, box.geometry);

            box.image.scaleW = imageEdit.scaleW;
            box.image.scaleH = imageEdit.scaleH;

            if (imageEdit.isWidth) {
                $scope.w = $scope.imageArr.nWidth;
                $scope.h = '';
            } else {
                $scope.h = $scope.imageArr.nHeight;
                $scope.w = '';
            }

            box.image.offsetx = 0;
            box.image.offsety = 0;

            $("#cut-img").css({left: imgX, top: imgY});

            $scope.moveImg = {
                width: $("#cut-opacity").width(),
                height: $("#cut-opacity").height(),
                angle: box.image.angle
            }
        };

        /**
         * 显示图片选择栏
         * @param $event
         */
        $scope.changeImage = function ($event) {
            if ($event) {
                $event.stopPropagation();
            }
            $scope.showImageMenu = !$scope.showImageMenu;
            $scope.showBottomMenu = false;
            $scope.showTempMenu = false;

            if (!$scope.qiniuId) {
                return
            }
            setImageWidth();
        };

        function setImageWidth() {
            if (!$scope.qiniuId) {
                return
            }
            var w = 0;
            var len = $scope.qiniuId.length;
            for (var i = 0; i < len; i++) {
                //84+10
                w += 94;
            }
            setTimeout(function () {
                $(".image-ul").width(w + 'px');
            })
        }

        $scope.addGallery = function () {
            getCurrentImage();
            $scope.choose = "choose";

            goToChoose($scope.index, $scope.i);
            localStorage.setItem('article-count', vm.counts);
        };

        var dragGal = {};
        window.startChange = function (e) {
            getCurrentImage();

            drag = true;
            $(".image-ul-mask").addClass('hide1');

            var i = e.target.dataset.imgindex;
            $scope.galleryArr = $scope.qiniuId[i];
            $scope.galleryChoose = $scope.qiniuId[i].identifier;

            $scope.galleryId = i;
            $scope.galleryX = e.changedTouches[0].clientX ? e.changedTouches[0].clientX - 30 : 0;
            $scope.galleryY = e.changedTouches[0].clientY ? e.changedTouches[0].clientY - 30 : 0;
            dragGal.clientX = e.changedTouches[0].clientX ? e.changedTouches[0].clientX : 0;
            dragGal.clientY = e.changedTouches[0].clientY ? e.changedTouches[0].clientY : 0;
            dragGal.pageX = e.changedTouches[0].pageX ? e.changedTouches[0].pageX : 0;
            dragGal.pageY = e.changedTouches[0].pageY ? e.changedTouches[0].pageY : 0;
            dragGal.coordX = $scope.galleryX;
            dragGal.coordY = $scope.galleryY;
            $scope.$digest();
            return false;
        };

        window.dragChange = function (e) {
            if (drag) {
                getCurrentImage();

                //手指离开屏幕
                $scope.galleryX = (dragGal.coordX + (e.changedTouches[0].clientX - dragGal.clientX));
                $scope.galleryY = (dragGal.coordY + (e.changedTouches[0].clientY - dragGal.clientY));

                if (Math.abs($scope.galleryY - dragGal.coordY) > 10) {
                    $("#small-pic").removeClass('hide1');
                }

                //向上滑动;
                if ($scope.galleryY <= 0) {
                    $scope.galleryY = 0;
                }
                //向左滑动;        <-----
                if ($scope.galleryX <= 0) {
                    $scope.galleryX = 0;
                }
                //向下滑动;
                if ($scope.galleryY >= $scope.dHeight - 62) {
                    $scope.galleryY = $scope.dHeight - 62;
                }
                // 向右滑动;    ---->
                if ($scope.galleryX >= $scope.dWidth - 62) {
                    $scope.galleryX = $scope.dWidth - 62;
                }
                $scope.$digest();
                return false;
            }
        };

        window.stopChange = function (e) {
            $("#small-pic").addClass('hide1');
            if (!drag) {
                return
            }
            drag = false;
            var levels = $scope.currentPage.levels.level;
            var imageLen = 0;
            angular.forEach(levels, function (level) {
                if (level.imagebox && level.imagebox.image&& level.imagebox.image.resource) {
                    imageLen++;
                }
            })
            var pageL = parseFloat($li.css('left')) + parseFloat($("#slide-li" + $scope.index).css('margin-left'));
            var pageT = parseFloat($("#slide-li" + $scope.index).css('margin-top')) + 112;
            var styleScale = $scope.currentPage.styleScale2;
            for (var i = levels.length - 1; i >= 0; i--) {
                var level = levels[i];
                if (level.imagebox && level.imagebox.geometry) {
                    var geo = level.imagebox.geometry;
                    if ($scope.galleryX > (pageL + geo.x*styleScale) && $scope.galleryX < (pageL + geo.x*styleScale + geo.width*styleScale)) {
                        if ($scope.galleryY > (pageT + geo.y*styleScale) && $scope.galleryY < (pageT + geo.y*styleScale + geo.height*styleScale)) {
                            if($scope.galleryArr.imageInfo){
                                addImageCb($scope.galleryArr.imageInfo)
                            }else{
                                $.ajax({
                                    type: "GET",
                                    url: $scope.galleryChoose + "?imageInfo",
                                    success: function (va) {
                                        $scope.galleryArr.imageInfo = va
                                        addImageCb($scope.galleryArr.imageInfo)
                                    }
                                })
                            }
                            function addImageCb(imageInfo){
                                if (level.imagebox.mask.resource.identifier) {
                                    level.imagebox.maskUrl = (level.imagebox.mask.resource.identifier.indexOf('http') == -1 ? $scope.domain : '') + level.imagebox.mask.resource.identifier;
                                } else {
                                    level.imagebox.maskUrl = 'content/images/timg.jpg';
                                }
                                if ($scope.galleryChoose) {       //qiniu
                                    $scope.galleryArr.width = orientationInit(imageInfo).width;
                                    $scope.galleryArr.height = orientationInit(imageInfo).height;
                                    var angle = orientationInit1(imageInfo.orientation).angle;
                                    level.imagebox.flip = orientationInit1(imageInfo.orientation).flip;
                                    level.imagebox.image = {
                                        resource: {
                                            identifier: $scope.galleryChoose,
                                            provider: 'qiniu',
                                        },
                                        width:$scope.galleryArr.width,
                                        height:$scope.galleryArr.height,
                                        imageInfo:$scope.galleryArr.imageInfo,
                                        resourceid: level.imagebox.image ? level.imagebox.image.resourceid : '',
                                        filterResource: {
                                            identifier: '',
                                            provider: 'qiniu'
                                        },
                                        rotation: {
                                            angle: 0
                                        },
                                        parameter: angular.fromJson($scope.galleryArr.parameter) || [],
                                        filter: '',
                                        offsetx: 0,
                                        offsety: 0,
                                        angle: angle || 0,
                                        scale: 1,
                                        scaleW: 1,
                                        scaleH: 1,
                                        imgSize: $scope.galleryArr.imgSize
                                    };
                                    if (vm.article.productBokehType!='None') {
                                        level.imagebox.blurred = true;
                                        level.imagebox.blurredrectangle = {}
                                    }

                                    level.imagebox.imgUrl = $scope.galleryChoose;
                                    imgScale(level.imagebox, $scope.index, i, 0, 0);

                                    if (level.imagebox.bokehtype!='None') {
                                        $(".cut-image").hide();
                                        $(".mode1,.mode2").removeClass('hide1');
                                    } else {
                                        $(".cut-image").show();
                                    }
                                    if (imageLen < 2) {
                                        $(".change").hide();
                                        console.log(imageLen)
                                    } else {
                                        $(".change").show();
                                    }
                                }
                                if ($scope.qiniuId.length) {
                                    var resourceid = level.imagebox.image.resourceid;
                                    if (level.imagebox.image) {
                                        for (var j = 0; j < $scope.qiniuId.length; j++) {
                                            var arr = $scope.qiniuId[j];
                                            if (arr.sourceId == resourceid) {
                                                arr.usenum == 0 ? 0 : arr.usenum--;
                                            }
                                        }
                                    }

                                    $scope.galleryArr.usenum += 1;
                                    level.imagebox.image.index = $scope.galleryId;
                                    level.imagebox.image.resourceid = $scope.galleryArr.sourceId;
                                    $scope.qiniuId.sort(compare('usenum'));
                                    setGalleryStorage();
                                }
                            }
                            break;
                        }
                    }
                }
            }
        };

        // 点击显示 占位框中的 切换按钮
        $scope.isReplaceShow = true;
        $scope.replaceImage = function () {
            var index = $rootScope.currentCarouselIndex || 0;
            var i = $scope.template.pages.page[index].selectImgIndex || 0;
            if ($scope.isReplaceShow) {
                $(".change-btn").show();
            } else {
                $(".change-btn").hide();
            }
            $("#change-btn" + index + '' + i).hide();
            $scope.isReplaceShow = !$scope.isReplaceShow;
        };

        // 切换占位框图片
        $scope.changeMaskImage = function (index, i,e) {
            fn(e);
            var index0 = $rootScope.currentCarouselIndex || 0;
            var i0 = $scope.template.pages.page[index].selectImgIndex || 0;

            // 需要切换的占位框
            var box0 = $scope.template.pages.page[index0].levels.level[i0].imagebox;

            // 被切换的占位框
            var box = $scope.template.pages.page[index].levels.level[i].imagebox;

            var img0 = box0.image;
            var imgUrl0 = box0.imgUrl;

            box0.image = box.image;
            box.image = img0;

            box0.imgUrl = box.imgUrl;
            box.imgUrl = imgUrl0;
            // box.image.angle = 0;
            // box0.image.angle = 0;

            imgScale(box0, index0, i0, 0, 0);
            imgScale(box, index0, i, 0, 0);
            $(".change-btn").hide();
            tipStatus(false);
        };

        //这块是图片中需要上传的区域
        $scope.chooseImage = function ($index, i) {
            $scope.template.pages.page[$index].selectImgIndex = i;
            $scope.i = i;

            $(".change,.cut-image").hide();
            $(".mode1,.mode2").addClass('hide1');

            tipStatus(true);
            $scope.showBottomMenu = false;
            $scope.showImageMenu = !$scope.showImageMenu;

            if (!$scope.qiniuId) {
                return
            }
            setImageWidth();
        };

        function goToChoose($index) {
            localStorage.setItem("marginLeft", $scope.dWidth * 0.94 * $index);
            localStorage.setItem("choose", 'choose');
            localStorage.setItem('pages', JSON.stringify($scope.template.pages));
            setProductionStorage('start');
        }

        var selectImgBoxes = function ($index) {
            var index = $rootScope.currentCarouselIndex || 0;
            $scope.template.pages.page[index].selectImgIndex = $index;
        };
        var getCurrentPage = function (index) {
            if (typeof index == 'undefined') {
                index = getPageIndex();
            }
            return $scope.template.pages.page[index];
        };

        var getPageIndex = function () {
            return $rootScope.currentCarouselIndex || 0
        };

        var isImagebox = false;
        vm.isImageboxSelectItem = false;
        window.moveImageboxStart = function (e) {
            fn(e);
            var index = getPageIndex();
            var targ = e.currentTarget ? e.currentTarget : e.srcElement;
            var textIndex = targ.dataset.index || vm.levelIndex;
            selectImgBoxes(textIndex);
            vm.levelIndex = $scope.i = $scope.template.levelI = parseInt(textIndex);
            vm.levelType = 'imagebox';
            vm.isImageboxSelectItem = true;
            $scope.index = index;

            var currentPage = $scope.template.pages.page[$scope.index];
            var sticker = currentPage.levels.level[textIndex].imagebox;
            vm.cropImagebox = angular.copy(sticker);
            stickerDragBox.x = e.changedTouches[0].clientX || 0;          //鼠标到页面左边的距离
            stickerDragBox.y = e.changedTouches[0].clientY || 0;          //鼠标到页面顶部的距离
            stickerDragBox.l = sticker.image.offsetx * sticker.image.scale*currentPage.styleScale2;
            stickerDragBox.t = sticker.image.offsety * sticker.image.scale*currentPage.styleScale2;
            stickerDragBox.r = -(sticker.image.width * sticker.image.scale - sticker.geometry.width)*currentPage.styleScale2;
            stickerDragBox.b = -(sticker.image.height * sticker.image.scale - sticker.geometry.height)*currentPage.styleScale2;
            isImagebox = true;
            $scope.$digest();
        }
        window.moveImageboxOn = function (e) {
            var currentPage = $scope.template.pages.page[$scope.index];
            var sticker = currentPage.levels.level[vm.levelIndex].imagebox;
            if(!isImagebox){
                return
            }
            fn(e);
            var angle = Number(sticker.rotation.angle);
            var cx = (stickerDragBox.l + stickerDragBox.r) / 2;
            var cy = (stickerDragBox.t + stickerDragBox.b) / 2;
            var pt0 = rotatePoint({x: stickerDragBox.x, y: stickerDragBox.y}, {x: cx, y: cy}, -angle);
            var pt1 = rotatePoint({x: e.touches[0].pageX, y: e.touches[0].pageY}, {x: cx, y: cy}, -angle);
            var deltaX = pt1.x - pt0.x;
            var deltaY = pt1.y - pt0.y;
            var nl = stickerDragBox.l + deltaX;
            var nt = stickerDragBox.t + deltaY;
            if (nl < stickerDragBox.r) {
                nl = stickerDragBox.r
            };
            if (nl > 0) {
                nl = 0
            };
            if (nt < stickerDragBox.b) {
                nt = stickerDragBox.b
            };
            if (nt > 0) {
                nt = 0
            };

            sticker.image.offsetx = nl/ sticker.image.scale/currentPage.styleScale2;
            sticker.image.offsety = nt/ sticker.image.scale/currentPage.styleScale2;
            $scope.$digest();
        }
        window.moveImageboxEnd = function (e) {
            fn(e);
            isImagebox = false;

            var currentPage = $scope.template.pages.page[$scope.index];
            var box = $scope.template.pages.page[$scope.index].levels.level[$scope.template.levelI].imagebox;
            getCurrentImage();
            var imageLen = 0;
            angular.forEach($scope.template.pages.page[$scope.index].levels.level, function (level) {
                if (level.imagebox && level.imagebox.image&& level.imagebox.image.resource) {
                    imageLen++;
                }
            })
            if(box.image.imageInfo){
                editImageboxCb(box.image.imageInfo)
            }else{
                $.ajax({
                    type: "GET",
                    url: box.image.resource.identifier + "?imageInfo",
                    success: function (va) {
                        box.image.imageInfo = va;
                        editImageboxCb(box.image.imageInfo)
                    }
                })
            }
            function editImageboxCb(imageInfo){
                if(box.image.width==imageInfo.height&&imageInfo.orientation == "Bottom-right"){
                    box.image.width = imageInfo.width;
                    box.image.height = imageInfo.height;
                    imgScale(box, $scope.index, $scope.i, 0, 0);
                    return
                }
                if (imageInfo.orientation == "Left-bottom" || imageInfo.orientation == "Right-top" || imageInfo.orientation == "Left-top" || imageInfo.orientation == "Right-bottom") {
                    if(box.image.width==imageInfo.height||box.image.angle==90||box.image.angle==270){
                        return
                    }
                    box.image.width = imageInfo.height;
                    box.image.height = imageInfo.width;
                    imgScale(box, $scope.index, $scope.i, 0, 0);
                }
            }
            /**
             * 选中图片框   点击照片出现操作按钮
             */
            if (Math.abs(stickerDragBox.l/currentPage.styleScale2 - box.image.offsetx*box.image.scale) <= 6 && Math.abs(stickerDragBox.t/currentPage.styleScale2 - box.image.offsety*box.image.scale) <= 6) {
                stickerDragBox = {};
                selectImgBoxes($scope.i);

                tipStatus(true);

                if (vm.article.productBokehType!='None') {
                    $(".mode1,.mode2").removeClass('hide1');
                } else {
                    $(".mode1,.mode2").addClass('hide1');
                }

                if (box.bokehtype!='None') {
                    $(".cut-image").hide();
                } else {
                    if (box.image && box.image.resource.identifier) {
                        $(".cut-image").show();
                    }
                }

                $(".change-btn").hide();
                $scope.isReplaceShow = true;
                if (imageLen < 2) {
                    $(".change").hide();
                } else {
                    $(".change").show();
                }

                $scope.showImageMenu = !$scope.showImageMenu;
                $scope.showStickerMenu = false;
                if ($scope.showImageMenu) {
                    $scope.showBottomMenu = false;
                } else {
                    $scope.showBottomMenu = true;
                }
                $scope.showTempMenu = false;

                setImageWidth();
                console.log($scope.i)
                $scope.$digest();

            } else {
                flag = true;
            }

            dragBox = {};
        }
        $scope.imageboxSelect = function (e) {
            fn(e);
            var targ = e.currentTarget ? e.currentTarget : e.srcElement;
            var textIndex = targ.dataset.index || vm.levelIndex;
            var _imageboxLength = 0;
            vm.levelIndex = parseInt(textIndex);
            vm.levelType = 'imagebox';
            vm.isImageboxSelectItem = true;
            var index = getPageIndex();
            vm.cropImagebox = angular.copy($scope.template.pages.page[index].levels.level[vm.levelIndex].imagebox);
            angular.forEach($scope.template.pages.page[index].levels.level, function (level) {
                if (level.imagebox && level.imagebox.image&& level.imagebox.image.resource) {
                    _imageboxLength++;
                }
            })
            selectImgBoxes(vm.levelIndex);

            tipStatus(true);

            if (vm.article.productBokehType!='None') {
                $(".mode1,.mode2").removeClass('hide1');
            } else {
                $(".mode1,.mode2").addClass('hide1');
            }

            if (vm.cropImagebox.bokehtype!='None') {
                $(".cut-image").hide();
            } else {
                if (vm.cropImagebox.image && vm.cropImagebox.image.resource && vm.cropImagebox.image.resource.identifier) {
                    $(".cut-image").show();
                }
            }

            $(".change-btn").hide();
            $scope.isReplaceShow = true;
            if (_imageboxLength < 2) {
                $(".change").hide();
            } else {
                $(".change").show();
            }

            $scope.showImageMenu = !$scope.showImageMenu;
            $scope.showStickerMenu = false;
            if ($scope.showImageMenu) {
                $scope.showBottomMenu = false;
            } else {
                $scope.showBottomMenu = true;
            }
            $scope.showTempMenu = false;


            if(vm.cropImagebox.image==null||vm.cropImagebox.image.resource==null){
                $(".change,.cut-image").hide();
                $(".mode1,.mode2").addClass('hide1');
            }

            setImageWidth();
            return false
        }

        /*******************************************图片功能****************************end*********************************************/


        /*******************************************贴纸功能****************************start*********************************************/

        /**
         * 获取贴纸列表
         */

        /**
         * 切换贴纸菜单
         */
        $scope.toggleStickerMenu = function ($event) {
            if ($event) {
                $event.stopPropagation();
            }
            $scope.showStickerMenu = !$scope.showStickerMenu;
            $scope.showBottomMenu = !$scope.showBottomMenu;
            if ($scope.showStickerMenu) {
                $scope.showTextMenu = false;
            }
        };

        $scope.selectLabel = function (label, index) {
            // ClipArt, vm.indexArtNum, 'ClipArt', vm.indexArtNum
            $scope.artlabelChooseId = label.id;
            $scope.artlabelChooseIndex = index;
            $scope.stickerList = [];
            vm.indexArtNum = 0;
            if (label.id == null) {
                vm.totalClipartItems = vm.cliparts.length;
                $scope.stickerList = angular.copy(vm.cliparts)
            } else {
                getBackgrounds(label, ClipArt, vm.indexArtNum, function (res) {
                    vm.totalClipartItems = res.items;
                    $scope.stickerList = res.arr;
                    console.log($scope.stickerList)
                });
            }
        };

        /**
         * 显示模板
         */
        $scope.toggleTempMenu = function ($event) {
            if ($event) {
                $event.stopPropagation();
            }
            $scope.showTempMenu = !$scope.showTempMenu;
            $scope.showBottomMenu = !$scope.showBottomMenu;
            getCurrentImage();
        };

        /**
         * 获取当前选中的贴纸
         * @returns {Array}
         */
        var getCurrentStickerList = function () {
            var index = $rootScope.currentCarouselIndex || 0;
            var page = $scope.template.pages.page[index];
            return page.imagearts.imageart
        };


        function addLevel(currentPage) {
            $(".transparency").addClass("hide1");
            vm.isTransp = false;
            $(".coverage").addClass("hide1");
            vm.isCoverage = false;

            var arr = {
                seq: 1,
                imagebox: null,
                textbox: null,
                imageart: null,
                textdocument: null
            };

            if (!currentPage.levels.level) {
                currentPage.levels.level = [arr];
            } else {
                currentPage.levels.level.push(arr);
            }

            $scope.template.levelI = currentPage.levels.level.length - 1;
            var currentLevel = currentPage.levels.level[$scope.template.levelI];

            currentLevel.seq = $scope.template.levelI + 1;

            return currentLevel;
        }

        /**
         * 添加贴纸
         */
        $scope.addSticker = function (e, sticker) {
            $scope.template.pageI = $rootScope.currentCarouselIndex;
            var currentPage = $scope.template.pages.page[$scope.template.pageI];
            $scope.template.currentMenu = 'imageart';
            imageartAdd($http, sticker, currentPage.trimbox, function(imageart){
                var _num = 0;
                currentPage.levels.level.forEach(function (level) {
                    if(level.imageart){
                        _num+=10;
                    }
                });
                imageart.geometry.x += _num/currentPage.styleScale2;
                imageart.geometry.y += _num/currentPage.styleScale2;
                imageart.levelI = currentPage.levels.level.length;
                imageart.pageI = $scope.template.pageI;
                // imageart.imgUrl = $scope.template.pageI;
                var _level = {
                    seq: currentPage.levels.level.length + 1,
                    imageart: imageart,
                }
                currentPage.levels.level.push(_level);
                console.log(currentPage)
            })
        };

        /**
         * 选中编辑贴纸
         * @param $event
         * @param $index
         */
        $scope.editSticker = function ($event, $index) {
            if ($event) {
                $event.stopPropagation();
            }
            $scope.template.levelI = $index;

        };

        //防止事件冒泡，默认事件
        function fn(e) {
            e = e || event;
            e.cancelBubble = true;
            e.stopPropagation();
            e.returnValue = false;
            e.preventDefault();
        }

        /**
         * 缩放旋转贴纸
         * @type {boolean}
         */
        window.resizeStickerStart = function (e) {
            var currentPage = getCurrentPage();
            $scope.template.currentMenu = 'imageart';
            imageartZoomStart(e, currentPage.levels.level, 'outline1-solid', currentPage.styleScale2,function (textIndex) {
                $scope.template.levelI = parseInt(textIndex);
            })
            fn(e);
        };

        window.resizeStickerOn = function (e) {
            var currentPage = getCurrentPage();
            var imageart = currentPage.levels.level[$scope.template.levelI].imageart;
            imageartZoomMove(e, imageart, currentPage.styleScale2,currentPage.trimbox);
            fn(e);
            $scope.$digest();
            e.stopPropagation();
            e.preventDefault();
            return false;
        };


        window.resizeStickerEnd = function () {
            imageartZoomEnd()
        };

        /**
         * 移动贴纸
         * @param e
         */
        $(".template-carousel").on("touchstart",".sticker-edit-box img", function (e) {
            var currentPage = getCurrentPage();
            vm.isImageboxSelectItem = false;
            imageartTouchstartStart(e, $scope.template.levelI, currentPage.levels.level, currentPage.styleScale2,currentPage.trimbox, function (imgIndex) {
                $scope.template.levelI = imgIndex;
                $scope.template.currentMenu = 'imageart';
            })
            fn(e);
            $scope.$digest();
        })
        $(".template-carousel").on("touchmove",".sticker-edit-box", function (e) {
            var currentPage = getCurrentPage();
            if (!e.originalEvent || e.originalEvent.touches.length == 1) {
                imagearOne(e, currentPage.levels.level[$scope.template.levelI].imageart, currentPage.styleScale2,currentPage.trimbox, function () {
                    vm.hint = !editboxIn(currentPage.editboxes.editbox , currentPage.levels.level[$scope.template.levelI].imageart.geometry, currentPage.levels.level[$scope.template.levelI].imageart.rotation.angle);
                });
                $scope.$digest();
            };
            if (e.originalEvent && e.originalEvent.touches.length >= 2) {
                var now = e.originalEvent.touches;
                Math.abs(e.originalEvent.touches[0].pageX - e.originalEvent.touches[1].pageX);
                imagearTouchstartTwo(function (imageartZoomItem) {
                    imagearTwo(e,getDistance(now[0], now[1]) - getDistance(imageartZoomItem.start[0], imageartZoomItem.start[1]),currentPage.levels.level[$scope.template.levelI].imageart, currentPage.trimbox, currentPage.styleScale2)
                })
                $scope.$digest();
            }
        })
        $(".template-carousel").on("touchend",".sticker-edit-box", function (e) {
            vm.hint = false;
            imageartZoomEnd();
            $scope.$apply();
        })

        /**
         * 删除贴纸
         * @param event
         * @param i
         */
        $scope.deleteSticker = function (event, i, index) {
            $scope.deleteAction(event, i);
        };

        $scope.deleteAction = function (e, i) {
            if (e) {
                fn(e);
            }
            var index = $rootScope.currentCarouselIndex || 0;
            // var i = $scope.template.levelI
            var list = $scope.template.pages.page[index].levels.level
            list.splice(i, 1);
        }

        /*******************************************贴纸功能****************************end*********************************************/


        /*******************************************文字模板****************************start*********************************************/

        //文本框点击时

        $scope.selectDoc = function (e, $index, textdocument) {
            $scope.template.levelI = $index;
            $scope.template.angle = textdocument.rotation.angle;
            textdocument.current = 'textdocument';
            $scope.selectBox = textdocument;
        };

        var dragTextDoc = {};
        window.moveTextDocStart = function (e) {
            var $event = e || window.event;
            if ($event && $event.preventDefault) {
                $event.preventDefault();
            }
            else {
                window.event.returnValue = false;
                return false;
            }
            $event.stopPropagation();
            $scope.buttonShows = true;
            var targ = e.target ? e.target : e.srcElement;
            $scope.template.levelI = targ.dataset.index;
            var currentPage = $scope.template.pages.page[$rootScope.currentCarouselIndex];
            var currentLevel = currentPage.levels.level[$scope.template.levelI];
            var currentImg = currentLevel.textdocument;
            $scope.template.angle = currentImg.rotation.angle;
            if (!currentImg.movable||!currentImg.useradded) {
                return
            }

            dragTextDoc.clientX = e.changedTouches[0].clientX ? e.changedTouches[0].clientX : 0;
            dragTextDoc.clientY = e.changedTouches[0].clientY ? e.changedTouches[0].clientY : 0;
            dragTextDoc.coordX = targ.offsetLeft;
            dragTextDoc.coordY = targ.offsetTop;
            dragTextDoc.x = currentPage.trimbox.x;
            dragTextDoc.y = currentPage.trimbox.y;
            dragTextDoc.w = currentPage.trimbox.width;
            dragTextDoc.h = currentPage.trimbox.height;
            drag = true;
        };
        //move 事件
        window.moveTextDocOn = function (e) {
            fn(e);
            $scope.$digest();
            if (e.target.nodeName == 'SPAN') {
                return;
            }
            if (drag) {
                var currentPage = $scope.template.pages.page[$rootScope.currentCarouselIndex];
                var pressImg = currentPage.levels.level[$scope.template.levelI].textdocument;

                var offsetx = dragTextDoc.coordX + (e.changedTouches[0].clientX - dragTextDoc.clientX);
                var offsety = dragTextDoc.coordY + (e.changedTouches[0].clientY - dragTextDoc.clientY);

                if (offsetx <= dragTextDoc.x) {
                    offsetx = dragTextDoc.x;
                }

                if (offsetx >= (dragTextDoc.w - pressImg.geometry.width+dragTextDoc.x)) {
                    offsetx = dragTextDoc.w- pressImg.geometry.width+dragTextDoc.x;
                }
                if (offsety <= dragTextDoc.y) {
                    offsety = dragTextDoc.y;
                }

                if (offsety >= (dragTextDoc.h - pressImg.geometry.height+dragTextDoc.y)) {
                    offsety = dragTextDoc.h - pressImg.geometry.height+dragTextDoc.y;
                }
                pressImg.geometry.x = offsetx;
                pressImg.geometry.y = offsety;

            }
            return false;
        }

        //鼠标松开事件
        window.moveTextDocEnd = function () {
            if (!drag) {
                return
            }
            drag = false;
            dragTextDoc = {};
            $scope.$digest();
        }

        window.rotateTextDocStart = function (e) {
            fn(e);
            var targ = e.target ? e.target : e.srcElement;
            $scope.template.levelI = targ.dataset.index || $scope.template.levelI;
            var currentPage = $scope.template.pages.page[$rootScope.currentCarouselIndex];
            var currentLevel = currentPage.levels.level[$scope.template.levelI];
            var currentTextdocument = currentLevel.textdocument;
            if (currentTextdocument.lock) {
                return
            }
            drag = true;

            dragBox.clientX = e.clientX || 0;
            dragBox.clientY = e.clientY || 0;

            $scope.RightPanel = 'textDoc';


            dragBox.imgRotate = currentTextdocument.rotation.angle ? 360 - Number(currentTextdocument.rotation.angle) : 0;
            var radius = Math.sqrt(currentTextdocument.geometry.width * currentTextdocument.geometry.width + currentTextdocument.geometry.height * currentTextdocument.geometry.height)
            dragBox.originalRotate = parseInt(180 * Math.asin(currentTextdocument.geometry.width / radius) / (2 * Math.asin(1))) + dragBox.imgRotate;
            $(".rotate-icon" + $scope.template.levelI).addClass('rotate-icon-active');

            document.addEventListener("mousemove", rotateDocOn, true);
            document.addEventListener("mouseup", rotateDocEnd, true);
        }

        function rotateDocOn(e) {
            fn(e);
            var currentPage = $scope.template.pages.page[$rootScope.currentCarouselIndex];
            var currentImg = currentPage.levels.level[$scope.template.levelI].textdocument;
            if (drag) {
                var offsetX = (e.clientX - dragBox.clientX);
                var offsetY = (e.clientY - dragBox.clientY);
                var newX = (currentImg.geometry.width / 2 * $scope.currentPage.scale / $scope.currentPage.proportion + offsetX);
                var newY = (currentImg.geometry.height / 2 * $scope.currentPage.scale / $scope.currentPage.proportion + offsetY);
                dragBox.newRadius = Math.sqrt(newX * newX + newY * newY);
                var rotate = parseInt(180 * Math.asin(newX / dragBox.newRadius) / (2 * Math.asin(1)));
                if (newX > 0 && newY > 0) {
                    currentImg.rotation.angle = (dragBox.originalRotate - rotate);
                } else if (newX < 0 && newY > 0) {
                    currentImg.rotation.angle = (dragBox.originalRotate - rotate);
                } else if (newX < 0 && newY < 0) {
                    currentImg.rotation.angle = (dragBox.originalRotate + 180 + rotate);
                } else {
                    currentImg.rotation.angle = (dragBox.originalRotate + 180 + rotate);
                }


                if (currentImg.rotation.angle >= 360) {
                    currentImg.rotation.angle %= 360;
                }
                currentImg.rotation.angle = 360 - currentImg.rotation.angle
                $scope.template.angle = currentImg.rotation.angle;

            }
            $scope.$digest();
            return false;
        }

        function rotateDocEnd() {
            drag = false;
            dragBox = {};

            document.removeEventListener("mousemove", rotateDocOn, true);
            document.removeEventListener("mouseup", rotateDocEnd, true);
            $scope.$digest();
        }

        /*******************************************文字模板*****************************end*********************************************/


        /*******************************************文字处理****************************start*********************************************/
        /**
         * 更改文字字体
         */
        function getFontList() {
            FontManagement.getDefaultShow({}, function (res) {
                if(res.status == 200){
                    vm.defaultFont = res.data;
                }else {
                    MessageService.error(res.message);
                }
            });
            FontManagement.getAll({}, function (res) {
                    $scope.fontList = [];
                    angular.forEach(res, function (msg, i) {
                        $scope.fontList.push({
                            id: 0,
                            // 字体名称
                            value: msg.family,
                            child: [],
                            uuid: msg.uuid
                        });
                        var zh = null;
                        angular.forEach(msg.fontStyles, function (font, j) {
                            switch (font.style) {
                                case 'NORMAL':
                                    zh = "常规";
                                    break;
                                case 'BOLD':
                                    zh = "粗体";
                                    break;
                                case 'ITALIC':
                                    zh = "斜体";
                                    break;
                                case 'BOLD_ITALIC':
                                    zh = "粗斜体";
                                    break;
                                default:
                                    zh = null
                            }
                            $scope.fontList[i].child.push({
                                // 字体样式中文
                                value: zh,
                                // 字体样式英文
                                en: font.style,
                                path: font.path,
                                identifier: font.identifier,
                                domain: $scope.domain
                            });
                        });
                        if (i == res.length - 1) {
                            getFont();
                        }
                    });
            });
        }

        function getFont() {
            $scope.defaultText = {
                family: $scope.fontList[0].value,
                style: $scope.fontList[0].child[0].en,
                path: $scope.fontList[0].child[0].path,
                identifier: $scope.fontList[0].child[0].identifier,
                domain: $scope.domain
            };

            new MultiPicker({
                input: 'multiPickerInput',//点击触发插件的input框的id
                container: 'targetContainer',//插件插入的容器id
                jsonData: $scope.fontList,
                success: function (arr) {
                    $("#multiPickerInput").val(arr[0].value + "（" + arr[1].value + "）");
                    $scope.defaultText = {
                        family: arr[0].value,
                        uuid: arr[0].uuid,
                        style: arr[1].en,
                        path: arr[1].path,
                        identifier: arr[1].identifier,
                        domain: $scope.domain
                    };
                    var text = getCurrentText();
                    text.fontuuid = arr[0].uuid;
                    //下载字体
                    if (vm.fontuuids.indexOf(text.fontuuid) == -1) {
                        vm.fontuuids.push(text.fontuuid);
                        getFontCSS(FontManagement, text, $scope);
                    }
                    text.styles = arr[1].en;
                    text.style.font = arr[0].value;
                    text.identifier = arr[1].path;
                    if (text.styles.indexOf('BOLD') != -1) {
                        text.style.bold = true;
                    } else {
                        text.style.bold = false;
                    }
                    if (text.styles.indexOf('ITALIC') != -1) {
                        text.style.italic = true;
                    } else {
                        text.style.italic = false;
                    }
                }//回调
            });
        }

        /**
         * 文字
         */
        var getCurrentText = function () {
            var index = $rootScope.currentCarouselIndex || 0;
            return $scope.template.pages.page[index].levels.level[$scope.template.levelI].textbox;
        };

        var elem = document.querySelector('input[type="range"]');

        var rangeValue = function () {
            var newValue = elem.value;
            var target = document.querySelector('.text-value');
            target.innerHTML = $translate.instant("choose.editor.fontSize",{size:newValue});

            var text = getCurrentText();
            text.style.size = newValue;
        };

        elem.addEventListener("input", rangeValue);

        /**
         * 更新文字
         */
        $scope.updateTextContents = function () {
            var w = $("#text-area").width();
            $("#text-div").width(w);
            var page = $scope.template.pages.page[$scope.template.pageI];
            setTimeout(function () {
                var text = page.levels.level[$scope.template.levelI].textbox;
                var $con = $("#text-div");

                var str = $scope.textContent.split('\n').join('<br/>');
                text.text = $scope.textContent;
                $con.html(str);
            }, 200);
        };

        /**
         * 文字输入确认按钮
         */
        $scope.saveText = function () {
            getCurrentImage();
            $scope.currentText = $scope.currentPage.levels.level[$scope.template.levelI].textbox;
            $scope.textContent = $scope.textContent.split(' ').join(' ');
            FontManagement.fontSupport({
                uuid:$scope.currentText.fontuuid,
                bold:$scope.currentText.style.bold,
                italic:$scope.currentText.style.italic,
                content:$scope.textContent},function (res) {
                var msg = res.data;
                $scope.currentText.success = res.data.success;
                if(res.status==200){
                    if(!msg.success){
                        SweetAlert.swal({
                            title: $translate.instant("choose.editorMessage.fontIsNotAvailable"),
                            imageUrl: Theme.sweetHintImg(),
                            text: "",
                            timer: 2000,
                            showConfirmButton: false
                        });
                        return
                    }
                    if(msg.success&&!msg.supported){
                        swal({
                            title:"<img src='content/images/icons/ic_tishi.svg'><div style='color:#666;font-size: 16px;margin-top: 16px;'>"+$translate.instant("choose.editorMessage.warmPrompt")+"</div>",
                            text:"<div style='font-size: 12px;line-height: 24px;color: #333;'>"+$translate.instant("choose.editorMessage.specialCharacter")+"<br>"+$translate.instant("choose.editorMessage.warmPrompt")+"<br><span style='color:#FFA91B;font-size: 14px'>"+msg.failed+"</span></div>",
                            html:true,
                            confirmButtonText: $translate.instant("choose.editorMessage.correction")
                        });
                    }else{
                        $(window).unbind('scroll');

                        $scope.showBottomMenu = true;
                        $scope.showBarMenu = false;

                        tipStatus(false);
                        var i = $scope.template.levelI;
                        var index = $scope.template.pageI;
                        $(".slide-li").eq(index).find(".text-box").eq(i).removeClass('opacity-zero');
                        $scope.showTextModal = false;

                        $scope.showTextMenu = false;
                        $scope.currentText.text = $scope.textContent;
                        $scope.currentText.style.lineheight =$scope.currentText.style.size;
                        console.log($scope.currentText)
                        //下载字体
                        if (vm.fontuuids.indexOf($scope.currentText.fontuuid) == -1) {
                            vm.fontuuids.push($scope.currentText.fontuuid);
                        }
                        getFontCSS(FontManagement, $scope.currentText, $scope);
                        vm.addText = false;
                        toImg($scope.currentText, $scope.currentPage.styleScale2, index, i);
                    }
                }
            })
        };

        /**
         * 文字菜单切换（点击）及初始化
         */
        $scope.toggleTextMenu = function ($event) {
            $(".text-img").css({'height': 0});
            $("#text-area").attr('autofocus', "autofocus");

            $scope.showTextModal = !$scope.showTextModal;
            $scope.showTextMenu = !$scope.showTextMenu;
            $scope.showBottomMenu = !$scope.showBottomMenu;

            // 清空样式
            $scope.textContent = "";
            vm.addText =true;

            /**
             * 格式化颜色和文字的选择
             */
            $scope.selectedColor = $scope.colorList[0];
            $scope.selectedFont = $scope.fontList[0];
            angular.forEach($scope.fontList, function (item, index) {
                item.selected = !index;
            });

            $(".tip-image").addClass('hide1');

            //初始化并添加一个文字框
            if ($scope.showTextMenu) {
                var currentPage = $scope.template.pages.page[$rootScope.currentCarouselIndex];
                var _size = Math.floor(currentPage.trimbox.height/8);
                var currentLevel = addLevel(currentPage);

                $scope.template.pageI = $rootScope.currentCarouselIndex;
                currentLevel.textbox = ({
                    geometry: {
                        height: 24 * currentPage.styleScale,
                        width: 200 * currentPage.styleScale,
                        x: null,
                        y: null
                    },
                    rotation: {
                        angle: 0
                    },
                    style: {
                        color: $scope.selectedColor,
                        font: vm.defaultFont.family,
                        size: _size || $(".text-range").val(),
                        bold: false,
                        italic: false,
                        lineheight: _size || $(".text-range").val(),
                        letterspacing: 0,
                        align: 'left',
                        writingmode:'horizontal-tb'
                    },
                    text: '请输入文字',
                    type: 'dynamic',
                    status: '',
                    xM: null,
                    yM: null,
                    levelI: $scope.template.levelI,
                    pageI: $scope.template.pageI,
                    transparency: 1,
                    onlyshow: false,
                    movable: true,
                    editable: true,
                    useradded: true,
                    fontuuid: vm.defaultFont.uuid,
                    identifier: null,
                    version:'2.0'
                });

                $scope.template.currentMenu = 'text';
                $scope.selectCurrentTextBox($event, $scope.template.levelI);

            }
            var textbox = currentPage.levels.level[$scope.template.levelI];;
            $scope.textCopy = angular.copy(textbox);
        };

        /**
         * 底部 编辑按钮<---->菜单栏 的切换
         * @param event
         */
        $scope.toggleBarMenu = function (event) {
            if (event) {
                event.stopPropagation();
            }
            $scope.showBarMenu = !$scope.showBarMenu;
            // 当引导页点击“不在提示”以后就不再count++;

            isChoose = localStorage.getItem("choose");
            if (!vm.guideStep && !(isChoose == 'choose')) {
                $scope.countN++;
                localStorage.setItem('countN', $scope.countN);
            }
        };

        /**
         * 关闭按钮--->菜单栏
         */
        $scope.closeToBarMenu = function (event) {
            if (event) {
                event.stopPropagation();
            }
            $scope.showBottomMenu = true;
            $scope.showBarMenu = false;
            $scope.showStickerMenu = false;
            $scope.showTempMenu = false;
            $scope.showImageMenu = false;
        };

        /**
         * 选中当前文字框
         */
        $scope.selectCurrentTextBox = function ($event, $index) {
            selectTextIndex = $index;
            if ($event) {
                $event.stopPropagation();
            }
            var currentPage = getCurrentPage();
            var currentText = currentPage.levels.level[$scope.template.levelI].textbox;

            /**
             * 显示文字颜色及字体选择菜单
             */
            $scope.showTextMenu = true;
            $scope.showStickerMenu = false;

            /**
             * 更新对应的颜色选择和字体
             */
            $scope.selectedColor = currentText.style.color;
            angular.forEach($scope.fontList, function (item) {
                if (item.value == currentText.style.font) {
                    item.selected = true;
                    $scope.selectedFont = item;
                } else {
                    item.selected = false;
                }
            });
        };
        /**
         * 更改文字颜色
         */
        $scope.selectTextColor = function (color) {
            $scope.selectedColor = color;
            var text = getCurrentText();
            text.style.color = color;
        };


        $scope.hideMenu = function () {
            $scope.showTextMenu = false;
            $scope.showStickerMenu = false;

            $scope.showBarMenu = true;
            $scope.showTempMenu = false;
            if (!$scope.showImageMenu && !$scope.showTextModal) {
                $scope.showBottomMenu = true;
            }
            if ($scope.showTextModal) {
                $scope.showBottomMenu = false;
            }

            var currentPage = getCurrentPage();
            currentPage.currentZindex = -1;
        };


        function toImg(text, styleScale, index, textI) {
            if (text.text == '') {
                return
            }

            var page = $scope.template.pages.page[$scope.template.pageI];
            var pagemaxW = page.trimbox.width*styleScale;

            var fontStyle = text.styles ? text.styles : $scope.defaultText.style;

            // 常用emoji
            var regStr = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig;
            var org_val = text.text;
            if (regStr.test(org_val)) {
                text.text = org_val.replace(regStr, "");
            }

            var tmpNode = document.createElement("DIV");
            $(tmpNode).html(text.text).css({'font-size': text.style.size});

            //根据换行符分数组
            var arrs = $(tmpNode).html().split('\n');
            // 空格替换
            var str = $(".text-width").html(arrs[0]).html().replace(/\s/g, 'a');
            var ratio = $scope.currentPage.ratio2;
            $(".text-width").html(str)
            //先拿到数组中下标为0的宽度
            var $width = $(".text-width").html(str).css({
                'font-size': (text.style.size* ratio > 12 ? text.style.size* ratio : 12) + 'pt',
                'line-height': (text.style.size* ratio > 12 ? text.style.lineheight* ratio : text.style.lineheight*12/text.style.size) + 'pt',
                'letter-spacing': (text.style.size* ratio > 12 ? text.style.letterspacing* ratio : text.style.letterspacing*12/text.style.size) + 'pt',
                'font-weight': fontStyle,
                'font-family': '\'' + text.fontuuid + '\'',
                'transform':'scale('+(1 / 12 * text.style.size* ratio > 1 ? 1 : 1 / 12 * text.style.size* ratio)+')',
            });

            var w0 = angular.copy(text.geometry.width*styleScale);
            var h0 = angular.copy(text.geometry.height*styleScale);
            var scale = 1 / 12 * text.style.size* ratio > 1 ? 1 : 1 / 12 * text.style.size* ratio;
            var htmlWidth = $width.width()*scale;
            var htmlHeight = $width.height()*scale;
            var t = 0,
                k = 0;
            if (htmlWidth > pagemaxW) {
                k = k + Math.ceil(htmlWidth / pagemaxW);
            }
            if (text.type != 'static' && pagemaxW) {
                var pattern_char = /[a-zA-Z0-9]/g;
                // var pattern_chin = /[\u4e00-\u9fa5]/g;
                var pattern = $width.html().match(pattern_char);
                var count_char = pattern ? pattern.length : 4;
                var maxW = (htmlWidth) > pagemaxW ? pagemaxW : (htmlWidth + count_char*2);
                var maxH = htmlHeight;
                if (arrs.length == 1) {
                    w0 = maxW;
                    h0 = maxH * (arrs.length + k)+2;
                } else {
                    for (var i = 1, len = arrs.length; i < len; i++) {
                        var count = arrs[i].match(pattern_char);
                        var over_char = count ? count.length : 4;
                        // 空格替换
                        var newWord = $width.html(arrs[i]).html().replace(/\s/g, '&nbsp;');
                        var overWidth = $width.html(newWord).width() * scale + over_char*2;

                        //得到数组中宽度最大的一个
                        if (maxW < overWidth && overWidth < pagemaxW) {
                            maxW = overWidth;
                            maxH = $width.html(arrs[i]).height() * scale;
                            t = i;
                        } else if (maxW < overWidth && overWidth > pagemaxW) {
                            maxW = pagemaxW;
                            maxH = $width.html(arrs[i]).height() * scale;
                            k = k + parseInt(overWidth / pagemaxW);
                        }
                    }
                    $width.html(arrs[t]);
                    w0 = maxW;
                    h0 = maxH * (arrs.length + k);
                }
            } else {
                // w0 /= styleScale;
                // h0 /= styleScale;
            }

            if(text.style.writingmode && text.style.writingmode != 'horizontal-tb'){
                text.geometry.width = h0 / styleScale;
                text.geometry.height = w0 / styleScale;
            }else{
                text.geometry.width = w0 / styleScale;
                text.geometry.height = h0 / styleScale;
            }

            var slideW = $("#slide-li"+$scope.template.pageI).find('.slide-content').width();
            var slideH = $("#slide-li"+$scope.template.pageI).find('.slide-content').height();
            var x = ((slideW - w0)/2+$scope.template.levelI)/styleScale;
            var y = ((slideH - h0)/2+$scope.template.levelI)/styleScale;


            if(text.geometry.x==null||text.geometry.y==null){
                text.geometry.x = x;
                text.geometry.y = y;
            }


            if(text.geometry.width>=$scope.currentPage.trimbox.width){
                text.geometry.x = $scope.currentPage.trimbox.x;
            }

        }

        /**
         * 删除文字框
         * @param $event
         * @param i
         * @param index
         */
        $scope.deleteSelectedText = function ($event, i, index) {
            console.log(i);
            $scope.template.levelI = i;
            $scope.deleteAction(event, i);
            $scope.showTextMenu = false;
        };

        /**
         * 编辑文字内容
         * @param $event
         * @param i
         * @param text
         * @param index
         */
        $scope.editTextContent = function ($event, i, text, index) {
            $scope.showTextModal = true;
            $scope.showImageMenu = false;
            $scope.showTempMenu = false;
            $scope.showStickerMenu = false;
            selectTextIndex = i;
            $(".text-img-pic").css({width: text.geometry.width, height: text.geometry.height});
            $scope.textContent = text.text;
            $scope.template.levelI = i;
            $scope.template.pageI = index;
            $(".text-value").html(text.style.size + ' px');
            $(".rangeSize").val(text.style.size);

            angular.element('#text-area')[0].focus();

            getCurrentImage();
            var textbox = $scope.template.pages.page[index].levels.level[i].textbox;
            $scope.textCopy = angular.copy(textbox);
            $(".tip-image").addClass('hide1');

        };

        /**
         * 移动文字框
         */
        var getCurrentTextFromEvent = function (e) {
            var targ = e.currentTarget ? e.currentTarget : e.srcElement;
            $scope.template.levelI = targ.dataset.index;
            selectTextIndex = +targ.dataset.index;
            $scope.template.currentMenu = 'text';
            return getCurrentText();
        };

        window.moveTextBoxStart = function (e) {
            fn(e);
            var index = $rootScope.currentCarouselIndex || 0;
            $scope.template.pageI = index;
            tipStatus(true);
            $scope.template.currentMenu = 'textbox';
            var currentPage = $scope.template.pages.page[$rootScope.currentCarouselIndex];

            textBoxMoveStart(e, $scope.template.levelI, currentPage.levels.level, currentPage.styleScale2, currentPage.trimbox, function (textIndex) {
                $scope.template.levelI = parseInt(textIndex);
                var text = $scope.template.pages.page[index].levels.level[textIndex].textbox;
                $(".text-img-pic").css({width: text.geometry.width, height: text.geometry.height});
                // moveText = true;
                $scope.$digest();
            })
        };
        window.moveTextBoxOn = function (e) {
            textBoxMoveOn(e, $scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].textbox, $scope.template.pages.page[$scope.template.pageI].styleScale2, $scope.template.pages.page[$scope.template.pageI].trimbox,function () {
                vm.hint = !editboxIn($scope.template.pages.page[$scope.template.pageI].editboxes.editbox , $scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].textbox.geometry, $scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].textbox.rotation.angle);
            })
            $scope.$digest();
            fn(e);
        };
        window.moveTextBoxEnd = function (e) {
            vm.hint = false;
            textBoxMoveEnd();
            $scope.$apply();
            fn(e);
        };

        /**
         *旋转缩放文字
         * @param e
         */
        window.resizeTextBoxStart = function (e) {
            fn(e);
            var text = getCurrentTextFromEvent(e);
            var currentPage = getCurrentPage();
            dragBox.clientX = e.changedTouches[0].clientX ? e.changedTouches[0].clientX : 0;
            dragBox.clientY = e.changedTouches[0].clientY ? e.changedTouches[0].clientY : 0;
            dragBox.coordX = angular.copy(text.geometry.x * currentPage.styleScale2);
            dragBox.coordY = angular.copy(text.geometry.y* currentPage.styleScale2);
            dragBox.width = angular.copy(text.geometry.width* currentPage.styleScale2);
            dragBox.height = angular.copy(text.geometry.width* currentPage.styleScale2);
            dragBox.originalFontSize = text.style.size;
            dragBox.radius = parseInt(Math.sqrt(dragBox.width * dragBox.width + dragBox.height * dragBox.height));
            dragBox.textRotate = text.rotation.angle ? Number(text.rotation.angle) : 0;
            dragBox.originalRotate = parseInt(180 * Math.asin(dragBox.width/dragBox.radius) / (2 * Math.asin(1))) + dragBox.textRotate;
            window.isDragging = true;
        };
        window.resizeTextBoxOn = function (e) {
            if (window.isDragging) {
                var text = getCurrentTextFromEvent(e);
                var offsetx = (e.changedTouches[0].clientX - dragBox.clientX);
                var offsety = (e.changedTouches[0].clientY - dragBox.clientY);
                var newX = (dragBox.width / 2 + offsetx);
                var newY = (dragBox.height / 2 + offsety);
                dragBox.newRadius = Math.sqrt(newX * newX + newY * newY);
                var rotate = parseInt(180 * Math.asin(newX / dragBox.newRadius) / (2 * Math.asin(1)));
                if (newX > 0 && newY > 0) {
                    text.rotation.angle = (dragBox.originalRotate - rotate);
                } else if (newX < 0 && newY > 0) {
                    text.rotation.angle = dragBox.originalRotate - rotate;
                } else if (newX < 0 && newY < 0) {
                    text.rotation.angle = dragBox.originalRotate + 180 + rotate;
                } else {
                    text.rotation.angle = (dragBox.originalRotate + 180 + rotate);
                }
            }

                $scope.$digest();
            e.stopPropagation();
            e.preventDefault();
            return false;
        };
        window.resizeTextBoxEnd = function (e) {
            window.isDragging = false;
            dragBox = {};
        };

        /*******************************************文字处理****************************end*********************************************/

        //更新所有占位框的使用照片图片
        function getUsedImageboxsNum() {
            vm.usedImageboxsNum= 0;
            vm.counts= 0;
            angular.forEach($scope.template.pages.page, function (item, index) {
                angular.forEach(item.levels.level, function (level) {
                    if (level.imagebox) {
                        vm.counts++;
                    }
                    if (level.imagebox && level.imagebox.image && level.imagebox.image.resource && level.imagebox.image.resource.identifier) {
                        vm.usedImageboxsNum++;
                    }
                })
            });
        }

        var completed = null;
        $scope.saveWork = function () {
            completed = vm.article.articleStatus;
            // 作品保存后，将页面改为0；
            $rootScope.currentCarouselIndex = 0;
            vm.article.pageCount = $scope.template.pages.page.length;
            if ($scope.status == 'make') {
                setProductionStorage('view');
                $scope.showImageMenu = false;
                $scope.showTempMenu = false;
                $scope.isReplaceShow = false;
                $scope.showStickerMenu = false;

                setGalleryStorage();
                localStorage.removeItem('marginLeft');

                $ul.css({marginLeft: '0px'});
                backToScrollTop();
                localStorage.setItem('pages', JSON.stringify($scope.template.pages));
                return;
            }
            var _documentTextDetection = documentTextDetection1($scope.template.pages.page);
            if(!_documentTextDetection.pass){
                vm.isDocumentTextDetection = true;
                vm.documentTextDetection = _documentTextDetection.pages;
                return;
            }
            if ($scope.template.pages.page.length < $scope.PAGELEN) {
                SweetAlert.swal({
                    title: $translate.instant("choose.editorMessage.templateIsLoading"),
                    imageUrl: Theme.sweetHintImg(),
                    text: "",
                    timer: 2000,
                    showConfirmButton: false
                });
                return
            }

            if (vm.article.ordered) {
                SweetAlert.swal({
                    title: $translate.instant("choose.editorMessage.warmPrompt"),
                    imageUrl: Theme.sweetHintImg(),
                    text: $translate.instant("choose.editorMessage."),
                    timer: 2000,
                    showConfirmButton: false
                });
            }

            getUsedImageboxsNum();
            if(vm.usedImageboxsNum < vm.counts){
                completed = "EDITING";
                SweetAlert.swal({
                    title: $translate.instant("choose.editorMessage.baaroque"),
                    imageUrl: Theme.sweetHintImg(),
                    showCancelButton: true,
                    confirmButtonText: $translate.instant("choose.editor.confirm"),
                    cancelButtonText: $translate.instant("choose.editor.cancel"),
                    closeOnConfirm: true,
                    closeOnCancel: true
                }, function (isConfirm) {
                    if (isConfirm) {
                        $timeout(function () {
                            $(".save-page").removeClass('hide1');
                            thumbnailInit(function (res){
                                generateJsonFile();
                            })
                        }, 500);
                        return;
                    }
                })
            } else {
                completed = 'COMPLETED';
                $(".save-page").removeClass('hide1');
                thumbnailInit(function (res){
                    generateJsonFile();
                })
            }

        };

        //json下载文件中需要的内容
        var generateJsonFile = function () {
            $scope.isSave = true;
            var template = {
                pages: {
                    page: []
                },
                bgimgs2: vm.article.bgimgs2,
                documentpics: vm.article.documentpics,
                masks: vm.article.masks,
                cliparts: vm.article.cliparts,
                replace: vm.replace,
                cover: vm.cover,
                version: '2.0'
            };

            var doc = saveData();
            template.pages = doc.pages;
            for (var i = 0; i < $scope.pageAllMm.page.length; i++) {
                template.pages.page.push($scope.pageAllMm.page[i])
            }
            //作品保存的时候 将用户选择照片填入 文档
            $scope.qiniuId = JSON.parse(localStorage.getItem("gallery"));
            template.galleries = {gallery: $scope.qiniuId};
            removeAll();
            template.hostinfo = hostInfo();
            Convert.articleUploadDocument(template, function (res) {
                if(res.status == 200){
                    vm.article.id = vm.aid;
                    vm.article.articleStatus = completed;
                    vm.article.productType = 'CustomPrint';
                    vm.article.fileName = res.data.identifier;
                    vm.article.saveUserName = localStorage.getItem('saveUserName') || ''
                    Article.update(vm.article,function (resp) {
                        if(resp.status == 200){
                            $(".save-page").addClass('hide1');
                            $('.sweet-alert').removeClass('hide-button');
                            $scope.bool = false;
                            swal({
                                title: $translate.instant("choose.editorMessage.saveSuccessfully"),
                                text: $translate.instant("choose.editorMessage.workHasBeenSyncedToMyWork"),
                                imageUrl: Theme.sweetSuccedImg(),
                                timer: 2000,
                                showConfirmButton: false
                            });
                            localStorage.setItem('guide-step', true);
                            $scope.isSavingJson = false;
                            removeLocalStorage();
                            $state.go("product-view-ec", {storeId: vm.storeId, aid: resp.data.id});
                        }else {
                            $(".save-page").addClass('hide1');
                            swal({
                                title: $translate.instant("choose.editorMessage.failSave"),
                                text: $translate.instant("choose.editorMessage.saveError"),
                                imageUrl: Theme.sweetHintImg(),
                                timer: 2000,
                                showConfirmButton: false
                            });
                        }
                    })
                }
            }, function () {
                $(".save-page").addClass('hide1');
                swal({
                    title: $translate.instant("choose.editorMessage.failSave"),
                    text: $translate.instant("choose.editorMessage.saveError"),
                    imageUrl: Theme.sweetHintImg(),
                    timer: 2000,
                    showConfirmButton: false
                });
            })

        };

        function saveData() {
            return documentMM($scope.template,null,'gaoji',$scope)
        }

        var removeLocalStorage = function () {
            localStorage.removeItem("choose");
            localStorage.removeItem("multipartUpload");
            localStorage.removeItem("go");
            localStorage.removeItem("pages");
            localStorage.removeItem("marginLeft");
            localStorage.removeItem("$index");
            localStorage.removeItem("gallery");
            localStorage.removeItem("work-save");
        };

        function removeAll() {
            //清除关于作品的localStorage
            localStorage.removeItem("choose");
            localStorage.removeItem("multipartUpload");
            localStorage.removeItem("index");
            localStorage.removeItem("i");
            localStorage.removeItem("marginLeft");
            localStorage.removeItem("single");
            localStorage.removeItem("pages");
            localStorage.removeItem("gallery");
            localStorage.removeItem("galleryCopy");
            localStorage.removeItem("reviewPages");
            localStorage.removeItem("saveOldPage");
            localStorage.removeItem("saveOldPageIndex");
            localStorage.removeItem("pageAllPx");
            localStorage.removeItem("pageAllMm");
            localStorage.removeItem("view-scrollTop");
            localStorage.removeItem("work-save");
            localStorage.removeItem("delPic");
            localStorage.removeItem("picArrChoose");
            localStorage.removeItem("picArrChoose2");
            localStorage.removeItem("gallery2");
            localStorage.removeItem("picArrCopy");
            localStorage.removeItem("picArr");
            localStorage.removeItem("isSort");
        };

        function setProductionStorage(attr) {
            localStorage.setItem('Production', attr);
            $scope.status = attr;
        }

        function setReviewStorage(index) {
            localStorage.setItem('saveOldPage', JSON.stringify($scope.template.pages.page[index]));
            localStorage.setItem('saveOldPageIndex', index);
            localStorage.setItem('galleryCopy', JSON.stringify($scope.qiniuId));
            localStorage.setItem('pages', JSON.stringify($scope.template.pages));
        }

        function setGalleryStorage() {
            localStorage.setItem('gallery', JSON.stringify($scope.qiniuId));
        }

        function tipStatus(flag) {
            if (flag) {
                $('.edit-menu').removeClass('opacity-zero');
                $('.tip-image').addClass('hide1');
                return
            }
            $('.edit-menu').addClass('opacity-zero');
            $('.tip-image').removeClass('hide1');
        }

        $scope.hideComeIn = function () {
            $scope.isHide = true;
            localStorage.setItem('isHide', true);
        };

        //防止事件冒泡，默认事件
        function fn(e) {
            e = e || window.event;
            e.cancelBubble = true;
            e.stopPropagation();
            e.returnValue = false;
            e.preventDefault();
        }


        /**
         * 点击其他地方时取消选中贴纸，文字框
         */
        $scope.$on('documentClicked', function () {
            setEveryThingUnselected();
            $scope.$digest();
        });
        var setEveryThingUnselected = function () {
            $scope.showTextMenu = false;
            $scope.showStickerMenu = false;
            $(".change-btn").hide();
            var currentPage = getCurrentPage();
            currentPage.currentZindex = -1;
        };

        /**
         * carousel滑动后初始化编辑菜单
         */
        $scope.$on('carouselSlideAway', function () {
            //关闭贴纸菜单
            $scope.showStickerMenu = false;
            //关闭文字菜单
            if ($scope.showTextMenu) {
                $scope.toggleTextMenu();
            }

            //取消当前页面的选择框
            if ($scope.template) {
                setEveryThingUnselected()
            }
        });


        //    引导页部分
        $scope.nextStep = function () {
            $scope.countN++;
            localStorage.setItem('countN', $scope.countN);
        };
        $scope.nextStep2 = function () {
            $scope.countN++;
            localStorage.setItem('countN', $scope.countN);
        };
        $scope.neverHint = function () {
            localStorage.setItem('guide-step', true);
            vm.guideStep = true;
            if ($scope.status == 'make') {
                $('.tip-image').removeClass('hide1');
            }
        };

        $scope.nextStep3 = function () {
            $scope.countN++;
            localStorage.setItem('countN', $scope.countN);
            if ($scope.countN == 14) {
                $('.tip-image').removeClass('hide1');
            }
        };


        vm.sortStatus = false;
        vm.orignTemp = null;
        var sort = null;
        var sortArray=[];
        $scope.sortPage = function () {
            vm.sortStatus = true;
            vm.orignTemp = angular.copy($scope.template);
            sort = new Sortable(document.getElementById('my-ui-list1'), {
                swap: true,
                filter: '.filtered',
                animation: 150,
                onEnd: function (/**Event*/evt) {
                    console.log('onEnd.foo:', [evt.item, evt.from]);
                    sortArray=[];
                    angular.forEach($('#my-ui-list1').find('.slide-content'),function(item,index){
                        var seq = item.getAttribute("data-sort-tag");
                        var value = angular.copy($scope.template.pages.page[seq]);
                        value.seq = index;
                        sortArray.push(value)
                    });
                },
            });
        }

        $scope.sortBack = function () {
            vm.sortStatus = false;
            $scope.template = angular.copy(vm.orignTemp);
            vm.orignTemp = null;
            sort.destroy();
        }

        $scope.sortCancel = function () {
            $scope.template = angular.copy(vm.orignTemp);
        }

        $scope.saveSort = function () {
            if(!sortArray.length){
                // $scope.template = angular.copy(vm.orignTemp);
            }else{
                $scope.template.pages.page = angular.copy(sortArray);

            }
            vm.sortStatus = false;
            sort.destroy();
        }
        $scope.textLayout = function(item){
            var text = $scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].textbox;
            var text1 = angular.copy($scope.template.pages.page[$scope.template.pageI].levels.level[$scope.template.levelI].textbox);
            text.style.writingmode = item;
            $timeout(function () {
                text.geometry.width = text1.geometry.height;
                text.geometry.height = text1.geometry.width;
            },200)
        }
        //像素不足提醒
        vm.imgSize = 150;
        vm.imgDpi = 150;
        StoreWorkEditConfig.storeId({storeId: vm.storeId}, function (res) {
            if(res.status == 200){
                vm.imgSize = res.data.imgSize;
                vm.imgDpi = res.data.imgDpi;
            }
        });
        //边框
        $scope.imageboxW = function (imagebox) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.geometry.width) + Number(imagebox.border.lineWidth) * 2
                }
                if (imagebox.border.type == 'Pic') {
                    return imagebox.geometry.width
                    // return Number(imagebox.geometry.width) + (Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100) + (Number(imagebox.geometry.width) * Number(imagebox.border.edge.right) / 100)
                }
            } else {
                return imagebox.geometry.width
            }
        }
        $scope.imageboxH = function (imagebox) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.geometry.height) + Number(imagebox.border.lineWidth) * 2
                }
                if (imagebox.border.type == 'Pic') {
                    return imagebox.geometry.height
                    // return Number(imagebox.geometry.height) + (Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100) + (Number(imagebox.geometry.height) * Number(imagebox.border.edge.bottom) / 100)
                }
            } else {
                return imagebox.geometry.height
            }
        }
        $scope.imageboxL = function (imagebox) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.geometry.x) - Number(imagebox.border.lineWidth)
                }
                if (imagebox.border.type == 'Pic') {
                    return imagebox.geometry.x
                    // return Number(imagebox.geometry.x) - (Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100)
                }
            } else {
                return imagebox.geometry.x
            }
        }
        $scope.imageboxT = function (imagebox) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.geometry.y) - Number(imagebox.border.lineWidth)
                }
                if (imagebox.border.type == 'Pic') {
                    return imagebox.geometry.y
                    // return Number(imagebox.geometry.y) - (Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100)
                }
            } else {
                return imagebox.geometry.y
            }
        }
        $scope.imageboxWEdge = function (imagebox, edge) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.border.lineWidth)
                }
                if (imagebox.border.type == 'Pic') {
                    if (edge == 'left') {
                        return Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100
                    }
                    if (edge == 'top') {
                        return Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100
                    }
                    if (edge == 'right') {
                        return Number(imagebox.geometry.width) * Number(imagebox.border.edge.right) / 100
                    }
                    if (edge == 'bottom') {
                        return Number(imagebox.geometry.height) * Number(imagebox.border.edge.bottom) / 100
                    }
                }
            } else {
                return 0
            }
        }
        $scope.imageboxWRadius = function (imagebox, radius, ratio, ratio1) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                var _ratio = 1;
                if(ratio && ratio1){
                    if(imagebox.geometry.width > imagebox.geometry.height){
                        _ratio = ratio1
                    }else{
                        _ratio = ratio
                    }
                }
                if(ratio && !ratio1){
                    _ratio = ratio
                }
                if (imagebox.border.shape == 'Ellipse') {
                    return '50%'
                }
                if (imagebox.border.radius.filletType == 'Fixed') {//圆角固定值
                    var _radius = imagebox.border.radius[radius];
                    return _radius > 0 ?  (_radius + Number(imagebox.border.lineWidth)/2) * _ratio : 0;
                }else{
                    var radiusW = imagebox.geometry.width > imagebox.geometry.height ? imagebox.geometry.height : imagebox.geometry.width;
                    radiusW = radiusW + imagebox.border.lineWidth;
                    var _r = radiusW * imagebox.border.radius[radius] / 100;
                    return _r > 0 ? (_r + Number(imagebox.border.lineWidth)/2) * _ratio : 0
                }
            } else {
                return 0
            }
        }
        $scope.imageboxWRadius1 = function (imagebox, radius, ratio, ratio1) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                var _ratio = 1;
                if(ratio && ratio1){
                    if(imagebox.geometry.width > imagebox.geometry.height){
                        _ratio = ratio1
                    }else{
                        _ratio = ratio
                    }
                }
                if(ratio && !ratio1){
                    _ratio = ratio
                }
                if (imagebox.border.shape == 'Ellipse') {
                    return '50%'
                }
                if (imagebox.border.radius.filletType == 'Fixed') {//圆角固定值
                    var _radius = imagebox.border.radius[radius];
                    return  (_radius - Number(imagebox.border.lineWidth)/2) > 0 ? (_radius - Number(imagebox.border.lineWidth)/2) * _ratio : 0;
                }else{
                    var radiusW = imagebox.geometry.width > imagebox.geometry.height ? imagebox.geometry.height : imagebox.geometry.width;
                    radiusW = radiusW + imagebox.border.lineWidth;
                    var _r = radiusW * imagebox.border.radius[radius] / 100;
                    return (_r - Number(imagebox.border.lineWidth)/2) > 0 ? (_r - Number(imagebox.border.lineWidth)/2) * _ratio : 0
                }
            } else {
                return 0
            }
        }
        $scope.dropShadow = function(imagebox,ratio,ratio1){
            if (!imagebox || imagebox.shadow == null) {
                return
            }
            var width = $scope.imageboxW(imagebox) * ratio;
            var height =$scope.imageboxH(imagebox) * ratio1;
            return dropShadow(imagebox,width,height)
        }
        //生成缩略图
        function thumbnailInit(callback){
            thumbnailInit1(function (res){
                vm.article.covered=true;
                vm.article.cover=res;
                callback(res);
            })
        }
        function thumbnailInit1(callback) {
            $timeout(function (){
                html2canvas_adapt(document.getElementById('thumbnail-view'), {
                    onrendered: function (canvas) {
                        QiniuToken.uploadThumbnail(canvas, function (data) {
                            var identifier = data.key;
                            callback(identifier)
                        });
                    },
                    letterRendering: true,
                    useCORS: true,
                    width: $scope.template.pages.page[0].mediabox.width*vm.thumbnailScale,
                    height: $scope.template.pages.page[0].mediabox.height*vm.thumbnailScale,
                    windowWidth: document.body.scrollWidth,
                    windowHeight: document.body.scrollHeight,
                    x: -($scope.template.pages.page[0].mediabox.width - $scope.template.pages.page[0].mediabox.width*vm.thumbnailScale)/2,
                    y: -($scope.template.pages.page[0].mediabox.height - $scope.template.pages.page[0].mediabox.height*vm.thumbnailScale)/2,
                    ratio: vm.thumbnailScale,
                    backgroundColor: "rgba(0, 0, 0, 0)"
                });
            })
        }

        $scope.$on('changeLanguage', function () {
            getMessageNotification();
            getFontList();
            ThemeClassify.getAllByCondition4({type: 'ClipArt',storeId:vm.storeId}, function (res) {
                if(res.status == 200){
                    if(!res.data){res.data=[]}
                    $scope.labels = angular.copy(res.data);
                }else {
                    MessageService.error(res.message);
                }
            });
        });

    }
})();

(function () {
    'use strict';

    angular
        .module('editorApp')
        .controller('IdPhotoController', IdPhotoController);

    IdPhotoController.$inject = ['$state', '$scope', '$q', '$stateParams', 'Convert', 'Qinius', 'QiniuToken', 'WxJS', 'Gallery', 'ItemValue', 'SweetAlert', 'Theme', '$localStorage', '$timeout', 'FontManagement', '$rootScope'
        , 'ImageService', 'ClipArt', 'PlatformWechatSetting', 'UidService', 'Store', 'Article', 'CommonService', '$http', 'Folder', 'MessageNotification', 'Product',
        'StoreWorkEditConfig', '$translate','IMAGE_SUPPORTED_MIME','MessageService','DateUtils','$websocket','StoreStorages'];

    function IdPhotoController($state, $scope, $q, $stateParams, Convert, Qinius, QiniuToken, WxJS, Gallery, ItemValue, SweetAlert, Theme, $localStorage, $timeout, FontManagement, $rootScope
        , ImageService, ClipArt, PlatformWechatSetting, UidService, Store, Article, CommonService, $http, Folder, MessageNotification, Product,
        StoreWorkEditConfig, $translate,IMAGE_SUPPORTED_MIME,MessageService,DateUtils,$websocket,StoreStorages) {
        //初始化
        $(".navbar-gallery").hide();
        $(".wrap").show().addClass('no-margins');
        $(".well").css({'margin-bottom': 0});
        $scope.dWidth = document.documentElement.clientWidth;
        $("body").css({width: $scope.dWidth, 'min-width': $scope.dWidth});
        var vm = this;
        vm.storeId = $stateParams.storeId;
        vm.pid = $stateParams.pid;
        vm.aid = $stateParams.aid;
        vm.vid = $stateParams.vid;
        vm.xmlId = $stateParams.xmlId;
        $scope.agentIos = false;
        vm.loading = true;
        vm.levelIndex = null;
        $scope.domains = Qinius.getDomain();
        QiniuToken.get('get', {}, function (token) {
            vm.token = token;
        });
        //像素不足提醒
        vm.imgSize = 150;
        vm.imgDpi = 150;
        StoreWorkEditConfig.storeId({storeId: vm.storeId}, function (res) {
            if (res.status == 200) {
                vm.imgSize = res.data.imgSize;
                vm.imgDpi = res.data.imgDpi;
            }
        });
        $q.all([$scope.domains.$promise]).then(function () {
            $scope.domain = 'https://' + $scope.domains.domains[0] + '/';
            wxInfo();
            PlatformWechatSetting.get({},function (res) {
                vm.platformSetting = res.data;
                websocket();
            });
            getMessage();
            init();
        })

        function wxInfo() {
            /**
             * wechat api
             */
            if (wx) {
                var url = window.location.hash && window.location.href.slice(0, -window.location.hash.length) || window.location.href;
                WxJS.get({url: url}, function (res) {
                    if(res.status==200) {
                        $scope.agentIos = browserVersions();
                        var config = res.data;
                        wx.config({
                            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                            appId: config.appId, // 必填，公众号的唯一标识
                            timestamp: config.timestamp, // 必填，生成签名的时间戳
                            nonceStr: config.nonceStr, // 必填，生成签名的随机串
                            signature: config.signature,// 必填，签名，见附录1
                            jsApiList: ['chooseImage', 'uploadImage', 'hideMenuItems'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                        });
                        wx.ready(function () {
                            console.log('wechat api ready!');

                            wx.hideMenuItems({
                                menuList: ["menuItem:copyUrl", "menuItem:share:timeline", "menuItem:share:appMessage", "menuItem:share:qq", "menuItem:share:appMessage", "menuItem:share:QZone"]
                            });
                        });
                        wx.error(function (res) {
                            console.log(res)
                        });
                    }
                }, function () {
                    console.log("wx config error");
                });
            }
        }
        //消息列表
        function getMessage() {
            vm.messageList = "";
            MessageNotification.getAllByCondition2({
                items: [
                    {key: "available", op: "=", value: "true"},
                    {key: "validate", op: ">=", value: DateUtils.convertLocalDateToServer(new Date())},
                    {key:"storeId", op : "=", value:vm.storeId},
                    {key: "pageType", op: "=", value: "Edit"}]
            }, function (res) {
                if(res.status == 200){
                    res.data.sort(compare('seq'))
                    vm.message = angular.copy(res.data);
                    vm.messageEdit = angular.copy(res.data);
                    vm.messageEditText = "\xa0\xa0\xa0\xa0\xa0\xa0";
                    angular.forEach(res.data, function (resp, i) {
                        vm.messageList += resp.content
                        if (i != res.data.length - 1) {
                            vm.messageList += "\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0"
                        }
                    })
                }else {
                    MessageService.error(res.message);
                }
            });
        }
        function compare(property) {
            return function (a, b) {
                var value1 = a[property];
                var value2 = b[property];
                return value1 - value2;
            }
        }

        function getProduct(productId,callback) {
            Product.get({id: productId, cancelled: false}, function (res) {
                vm.product = res.data;
                if(callback){callback()}
            })
        }
        vm.isImage = true;
        function init() {
            Article.getByUser({id: $stateParams.aid}, function (res) {
                vm.article = res.data;
                if(vm.article.invalid){//作品失效
                    $state.go('articlesFailure',{storeId:vm.storeId},{location: 'replace'});
                    return
                }
                getProduct(res.data.productId,function () {
                    ItemValue.get({id: res.data.itemValueId}, function (resp) {
                        if(resp.status == 200){
                            vm.productXmlLine = resp.data.productXmlLines[0];
                            angular.forEach(resp.data.productXmlLines, function (line) {
                                if (line.id == vm.xmlId) {
                                    vm.productXmlLine = angular.copy(line);
                                }
                            });
                            vm.article.modelBlendentUuid = vm.productXmlLine.modelBlendentUuid;
                            vm.article.cover = vm.productXmlLine.coverImg;
                            vm.article.productXmlId = vm.productXmlLine.productXmlId;
                            vm.article.productXmlName = vm.productXmlLine.productXmlName;
                            vm.article.musicIdentify = vm.productXmlLine.musicIdentify;
                            vm.article.skuNumber = resp.data.skuNumber;
                            vm.article.productBokeh = resp.data.productBokeh;
                            vm.article.productBokehType = resp.data.productBokehType;
                            if(!vm.article.fileName){
                                vm.article.fileName = vm.productXmlLine ? vm.productXmlLine.productXmlIdentifier : resp.data.productXmlIdentifier;
                            }
                            if (!resp.data.productBokehType) {
                                vm.article.bokehtype = 'None';
                            } else {
                                vm.article.bokehtype = resp.data.productBokehType;
                            }
                            Convert.xmlToDocument2({
                                identifier: vm.article.fileName,
                                provider: 'qiniu',
                                editorType:vm.article.editorType,
                                patternType:vm.product.patternType,
                            }, function (res) {
                                vm.article.document = res;
                                abook();
                            });
                        }else {
                            MessageService.error(res.message);
                        }
                    });
                })
            },function(error){
                if(error.status === 403){//token失效
                    return $state.go('404',{storeId:vm.storeId},{location: 'replace'});
                }
                if(error.data.status === 404){//未找到作品
                    $state.go('404',{storeId:vm.storeId,tips:error.data.message},{location: 'replace'});
                }
                if(error.data.status === 410){//作品编辑器失效
                    $state.go('404',{storeId:vm.storeId,tips:'编辑器失效'},{location: 'replace'});
                }
            })
        }
        $scope.template = null;
        function abook() {
            $scope.template = angular.copy(vm.article.document);
            $scope.template.pages.page = $scope.template.pages.page.slice(0, 1);
            angular.forEach($scope.template.pages.page, function (page, i) {
                angular.forEach(page.levels.level, function (level) {
                    if (level.imageart && level.imageart.geometry) {
                        level.imageart.onlyshow = true;
                    }
                    if (level.imagebox && level.imagebox.geometry) {
                        if(!level.imagebox.image || !level.imagebox.image.resource || !level.imagebox.image.resource.identifier){
                            vm.isImage = false;
                        }
                    }
                })
            });
            documentAnalysis($scope, $http, vm, $scope.template,FontManagement,'other', function(page){
                ratioInfo(page)
            }, function () {
                warnIcon();
                vm.loading = false;
            })
        }
        vm.ratioInfo = ratioInfo;
        function ratioInfo(item) {
            vm.windowWidth = $(window).width() * 0.9;
            vm.windowHeight = $(window).height() - 300;
            var ratio = item.custom.width / item.custom.height;
            var ratio1 = vm.windowWidth / vm.windowHeight;
            if (ratio >= ratio1) {
                item.custom.ratio1 = vm.windowWidth / item.custom.width;
            } else {
                item.custom.ratio1 = vm.windowHeight / item.custom.height;
            }
            item.custom.thumbnailScale = 300 / item.custom.width;
        }
        function warnIcon() {
            vm.warnIcon = false;
            $scope.template.pages.page[0].levels.level.forEach(function (level) {
                if(level.imagebox && level.imagebox.image && pxInsufficient(level.imagebox,vm.imgSize, vm.imgDpi)){
                    vm.warnIcon = true;
                }
            })
        }
        $scope.uploadPhoto = function () {
            uploadAble(StoreStorages,vm.storeId, function (res) {
                if(res.status == 200){
                    if($scope.agentIos){
                        $rootScope.$broadcast('clickAndroidUpload',true);
                    }else{
                        $timeout(function () {
                            $("#uploadImageMutipleThree").trigger("click");
                        })
                    }
                }else{
                    if(res.status == 400){
                        threeInfo('系统出错');
                    } else {
                        threeInfo(res.data||'系统出错');
                    }
                }
            })
        }
        // websocket接收上传的图片（多端互通实时更新）
        function websocket(){
            var urlws = vm.platformSetting.editorNotifyUrl.split("://")[1];
            urlws = urlws.split("/")[0];
            var ws = $websocket("wss://"+ urlws +"/widget/ws/websocket?uid=Gallery"+vm.aid);
            ws.onOpen(function() {
                console.log('WebSocket连接已打开, url:'+ws.url);
            });
            ws.onMessage(function(message) {
                var photo = JSON.parse(message.data);
                photo.identifier = $scope.domain + photo.identifier;
                addImage(photo)
            });
            ws.onError(function(error) {
                console.log('WebSocket错误：', error);
            });
            ws.onClose(function() {
                console.log('WebSocket连接已关闭');
            });
        }
        function addImage(photo) {
            vm.isImage = true;
            $scope.template.pages.page[0].levels.level.forEach(function (level,index) {
                if(level.imagebox){
                    (function (levelIndex) {
                        replaceImagebox(levelIndex, photo)
                    })(index)
                }
            })
        }
        function replaceImagebox(levelIndex, data) {
            var item = angular.copy(data);
            var imagebox = $scope.template.pages.page[0].levels.level[levelIndex].imagebox;
            imagebox.image = {
                resource: {
                    identifier: item.identifier,
                    provider: 'qiniu'
                },
                resourceid:item.id,
                filterResource: {
                    identifier: '',
                    provider: 'qiniu'
                },
                width: item.width,
                height: item.height,
                imgSize: item.imgSize,
                index: item.seq,
                parameter: angular.fromJson(item.parameter),
                scale: 1,
                angle: 0
            }
            addImagebox($http, imagebox, function () {});
        }

        function isContinue() {
            var hasEmpty = true;
            for (var i = 0; i < $scope.template.pages.page.length; i++) {
                var _page = $scope.template.pages.page[i];
                if (_page.levels.level) {
                    for (var j = 0; j < _page.levels.level.length; j++) {
                        var _level = _page.levels.level[j];
                        if (_level.imagebox && _level.imagebox.image) {
                            if (_level.imagebox.image.resource && _level.imagebox.image.resource.identifier) {
                            } else {
                                hasEmpty = false;
                                break;
                            }
                        }
                    }
                }
            }
            vm.completed = hasEmpty ? 'COMPLETED' : 'EDITING';
            return hasEmpty;
        };
        $scope.isSave = false;
        $scope.saveTab = function () {
            if ($scope.isSave) {
                return;
            }
            //判断是否有图片未上传  且是否继续保存
            if (!isContinue()) {
                SweetAlert.swal({
                    title: $translate.instant("editorCommon.saveSure"),
                    imageUrl: Theme.sweetHintImg(),
                    showCancelButton: true,
                    confirmButtonText: $translate.instant("button.confirm"),
                    cancelButtonText: $translate.instant("button.cancel"),
                    closeOnConfirm: true,
                    closeOnCancel: true
                }, function (isConfirm) {
                    if (isConfirm) {
                        $timeout(function () {
                            generateJsonFile();
                        }, 500);
                        return;
                    }
                })
            } else {
                generateJsonFile();
            }
        }
        function generateJsonFile() {
            $scope.isSave = true;
            vm.threeLoading = true;
            vm.threeLoadingText=$translate.instant("hint.loadingText");
            // 生成缩略图保存作品
            thumbnailInit(function () {
                $scope.template = documentMM($scope.template, null, null);
                $scope.isSave = true;
                $scope.template.hostinfo = hostInfo();
                Convert.articleUploadDocument($scope.template, function (res) {
                    vm.article.articleStatus = vm.completed;
                    vm.article.productType = 'CustomPrint';
                    vm.article.pageCount = $scope.template.pages.page.length;
                    vm.article.fileName = res.data.identifier;
                    vm.article.unFilledCount = 0;
                    vm.article.saveUserName = localStorage.getItem('saveUserName') || ''
                    Article.update(vm.article, function (resp) {
                        vm.threeLoading = false;
                        $scope.isSave = false;
                        swal({
                            title: $translate.instant("editorCommon.modifySuccess"),
                            text: $translate.instant("editorCommon.synchronizationOfWorks"),
                            imageUrl: Theme.sweetSuccedImg(),
                            timer: 2000,
                            showConfirmButton: false
                        });
                        $state.go("product-view5-ec", {storeId: vm.storeId, aid: resp.data.id}, {reload: true,location: 'replace'});
                    }, function () {
                        vm.threeLoading = false;
                        $scope.isSave = false;
                        swal({
                            title: $translate.instant("editorCommon.saveError"),
                            text: $translate.instant("editorCommon.saveError1"),
                            imageUrl: Theme.sweetHintImg(),
                            timer: 2000,
                            showConfirmButton: false
                        });
                    })
                }, function () {
                    $scope.isSave = false;
                    vm.threeLoading = false;
                    swal({
                        title: $translate.instant("editorCommon.saveError"),
                        text: $translate.instant("editorCommon.saveError1"),
                        imageUrl: Theme.sweetHintImg(),
                        timer: 2000,
                        showConfirmButton: false
                    });
                })
            })
        }
        //生成封面图
        function thumbnailInit(callback) {
            $timeout(function () {
                html2canvas_adapt(document.getElementById('thumbnail-view'), {
                    onrendered: function (canvas) {
                        if(canvas){
                            QiniuToken.uploadThumbnail(canvas, function (data) {
                                var identifier = data.key;
                                vm.article.covered = true;
                                vm.article.cover = identifier;
                                if (callback) {callback()};
                            }, function () {
                                vm.article.covered=false;
                                vm.article.cover=null;
                                if (callback) {callback()};
                            });
                        }else{
                            vm.article.covered=false;
                            vm.article.cover=null;
                            if (callback) {callback()};
                        }
                    },
                    error:function(){
                        vm.article.covered=false;
                        vm.article.cover=null;
                        if (callback) {callback()};
                    },
                    letterRendering: true,
                    useCORS: true,
                    width: $scope.template.pages.page[0].custom.width * $scope.template.pages.page[0].custom.thumbnailScale,
                    height: $scope.template.pages.page[0].custom.height * $scope.template.pages.page[0].custom.thumbnailScale,
                    windowWidth: document.body.scrollWidth,
                    windowHeight: document.body.scrollHeight,
                    x: 0,
                    y: 0,
                    backgroundColor: "rgba(0, 0, 0, 0)"
                });
            })
        }
        function threeInfo(item) {
            vm.threeError = true;
            vm.threeErrorText = item;
            $timeout(function () {
                vm.threeError = false;
                vm.threeErrorText = "";
            }, 1500)
        }
        $scope.canvasOuter = function (e) {
            fn(e)
            vm.levelIndex = null;
        }

        $scope.rotateImagebox = function () {
            if ($scope.template.pages.page[0].levels.level[vm.levelIndex] && $scope.template.pages.page[0].levels.level[vm.levelIndex].imagebox) {
                var imagebox = $scope.template.pages.page[0].levels.level[vm.levelIndex].imagebox;
                imageboxRotate($scope, imagebox);
            }
        }

        //图片框的操作
        $scope.imageboxSite = function (item) {
            if (!$scope.template.pages.page[0].levels.level[vm.levelIndex] || $scope.template.pages.page[0].levels.level[vm.levelIndex].imagebox.bokehtype != 'None') {
                return
            }
            var _imagebox = $scope.template.pages.page[0].levels.level[vm.levelIndex].imagebox;
            if (item == 'center') {
                _imagebox.image.offsetx = -(_imagebox.image.width * _imagebox.image.scale - _imagebox.geometry.width) / 2 / _imagebox.image.scale;
                _imagebox.image.offsety = -(_imagebox.image.height * _imagebox.image.scale - _imagebox.geometry.height) / 2 / _imagebox.image.scale;
            }
            if (_imagebox.image.offsetx > 0) {
                _imagebox.image.offsetx = 0;
            }
            if (_imagebox.image.offsety > 0) {
                _imagebox.image.offsety = 0;
            }
        }

        $scope.fillImagebox = function () {
            $scope.template.pages.page[0].levels.level.forEach(function (level, i) {
                if (level.imagebox && i == vm.levelIndex) {
                    var item = level.imagebox;
                    item.bokehtype = 'Transparent';
                    vm.imageboxLoad = true;
                    getBackgroundSource3(item, item.geometry.width, item.geometry.height, item.image, item.bokehtype, $scope, function () {
                        vm.imageboxLoad = false;
                    });
                }
            })
        }
        $scope.cutImagebox = function () {
            $scope.template.pages.page[0].levels.level.forEach(function (level, i) {
                if (level.imagebox && i == vm.levelIndex) {
                    var item = level.imagebox;
                    item.bokehtype = 'None';
                    vm.imageboxLoad = true;
                    getBackgroundSource3(item, item.geometry.width, item.geometry.height, item.image, item.bokehtype, $scope, function () {
                        vm.imageboxLoad = false;
                    });
                }
            })
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('editorApp')
        .controller('EditorPhotoAlbumEcController', EditorPhotoAlbumEcController);
    EditorPhotoAlbumEcController.$inject = ['$state', '$scope', '$q', '$stateParams', 'Convert', 'Qinius', 'QiniuToken', 'WxJS', 'Gallery', 'ItemValue', 'SweetAlert', 'Theme', '$localStorage', '$timeout', 'FontManagement', '$rootScope'
        , 'ImageService', 'ClipArt', 'PlatformWechatSetting', 'UidService', 'Store', 'Article', 'CommonService', '$http',
        'Folder', 'MessageNotification', 'ThemeClassify', 'entity', 'Product', 'ProductXml', 'DateUtils', 'Iphone', 'Algorithm',
        'StoreWorkEditConfig', '$translate', 'MessageService','IMAGE_SUPPORTED_MIME','StoreStorages','$websocket'];

    function EditorPhotoAlbumEcController($state, $scope, $q, $stateParams, Convert, Qinius, QiniuToken, WxJS, Gallery, ItemValue, SweetAlert, Theme, $localStorage, $timeout, FontManagement, $rootScope
        , ImageService, ClipArt, PlatformWechatSetting, UidService, Store, Article, CommonService, $http,
          Folder, MessageNotification, ThemeClassify, entity, Product, ProductXml, DateUtils, Iphone, Algorithm,
          StoreWorkEditConfig, $translate, MessageService,IMAGE_SUPPORTED_MIME,StoreStorages,$websocket) {
        //初始化
        $(".navbar-gallery").hide();
        $(".wrap").addClass('no-margins');
        $(".wrap").removeAttr("style");
        $(".well").css({'margin-bottom': 0});
        $scope.dWidth = document.documentElement.clientWidth;
        $("body").css({width: $scope.dWidth, 'min-width': $scope.dWidth});
        //#ifdef MP-WEIXIN || MP-TOUTIAO
        console.log('MP-WEIXIN')
        // #endif

        var vm = this;
        vm.isEdit = entity.type == 'edit' ? true : false;
        vm.storeId = $stateParams.storeId;
        vm.pid = $stateParams.pid;
        vm.aid = $stateParams.aid;
        vm.vid = $stateParams.vid;
        vm.xmlId = $stateParams.xmlId;
        vm.counts = 0;
        vm.selectImg = [];
        vm.indexNum = 0;
        vm.maxId = null;
        vm.itemsPerPage = 40;
        vm.photoAll = [];
        $scope.domains = Qinius.getDomain();
        vm.platformSetting = PlatformWechatSetting.get();
        vm.photoArray = [];
        vm.photoSelectAll = localStorage.getItem("photoSelectAll") ? JSON.parse(localStorage.getItem("photoSelectAll")) : [];
        vm.isPhone = false;
        vm.threeIsModal = false;
        vm.threeModalText = "";
        vm.threeLoading = true;
        vm.threeLoadingText=$translate.instant("hint.loadingText");
        vm.threeError = false;
        vm.threeErrorText=$translate.instant("hint.loadingText");
        vm.threeError1 = false;
        vm.threeErrorText1='';
        vm.page8 = false;
        vm.store = Store.get({id: vm.storeId});
        $scope.agentIos = false;
        QiniuToken.get('get', {}, function (token) {
            vm.token = token;
        });
        vm.isIPhone6 = isIPhone6();
        vm.supportedMimeTypes = IMAGE_SUPPORTED_MIME;
        vm.duplicateList = []; //重复图片
        vm.isDuplicateList = false; //重复图片弹框
        vm.deletePhotoSure = false; //删除处理失败照片确认框
        vm.pendingDeletePhoto = null; //待删除的处理失败照片

        //阻止微信端长按赋值保存图片
        document.oncontextmenu = function (e) {
            //或者return false;
            e.preventDefault();
        };

        init()

        var templateEdit = localStorage.getItem("templateEdit") != null ?  localStorage.getItem("templateEdit") : "";
        function init() {
            if (!vm.isEdit) {
                Article.getByUser({id: $stateParams.aid}, function (resp) {
                    if (resp.status == 200) {
                        vm.article = resp.data;
                        document.title = vm.article.productName;
                        if(vm.article.invalid){//作品失效
                            $state.go('articlesFailure',{storeId:vm.storeId},{location: 'replace'});
                            return
                        }
                        getProduct(vm.article.productId,function () {
                            ItemValue.get({id: $stateParams.vid}, function (res) {
                                $("body").toggleClass('bg');
                                $scope.status = localStorage.getItem('Production');
                                vm.productXmlLine = angular.copy(res.data.productXmlLines[0]);
                                angular.forEach(res.data.productXmlLines, function (line) {
                                    if (line.id == vm.xmlId) {
                                        vm.productXmlLine = angular.copy(line);
                                    }
                                })
                                vm.article.cover = vm.productXmlLine.coverImg;
                                vm.article.themeClassifyId = vm.productXmlLine.productXmlThemeId;
                                vm.article.themeClassifyName = vm.productXmlLine.productXmlThemeName;
                                vm.article.productXmlId = vm.productXmlLine.productXmlId;
                                vm.article.productXmlName = vm.productXmlLine.productXmlName;
                                vm.article.musicIdentify = vm.productXmlLine ? vm.productXmlLine.musicIdentify : res.data.musicIdentify;
                                vm.article.editorType= res.data.productEditorType;
                                vm.article.itemValueId= res.data.itemValueId || vm.vid;
                                if (!res.data.productBokehType) {
                                    vm.article.bokehtype = 'None';
                                } else {
                                    vm.article.bokehtype = res.data.productBokehType;
                                }
                                console.log(vm.article.bokehtype)
                                Convert.xmlToDocument2({
                                    identifier: vm.productXmlLine.productXmlIdentifier,
                                    provider: "qiniu",
                                    editorType:vm.article.editorType,
                                    patternType:vm.product.patternType,
                                }, function (res) {
                                    vm.replace = res.replace;
                                    vm.counts = 0;
                                    $scope.pages = res;
                                    if($scope.pages.config.productType == 'CALENDAR'&&$scope.pages.config.dynamic){
                                        vm.isCalendar = true;
                                        yearInfo()
                                    }
                                    angular.forEach(res.pages.page, function (page, i) {
                                        if(!page.backup){
                                            angular.forEach(page.levels.level, function (level) {
                                                if (level.imagebox && level.imagebox.geometry) {
                                                    vm.counts++;
                                                }
                                            })
                                        }
                                    });
                                    if(templateEdit){
                                        threeInfo1($translate.instant("editorCommon.replaceTemplateSuccess"));
                                    }
                                    vm.page0=true;
                                    if(vm.counts == 0 || templateEdit){
                                        vm.page0=false;
                                        vm.page1 = false;
                                        vm.page2 = false;
                                        $scope.book();
                                        loadAll('isNull')
                                    }
                                    vm.threeLoading = false;
                                });
                            });
                        });
                    }
                },function (error) {
                    if(error.status === 403){//token失效
                        return $state.go('404',{storeId:vm.storeId},{location: 'replace'});
                    }
                    if(error.data.status === 404){//未找到作品
                        $state.go('404',{storeId:vm.storeId,tips:error.data.message},{location: 'replace'});
                    }
                    if(error.data.status === 410){//作品编辑器失效
                        $state.go('404',{storeId:vm.storeId,tips:'编辑器失效'},{location: 'replace'});
                    }
                })
            } else {
                vm.page0=false;
                Article.getByUser({id: $stateParams.aid}, function (res) {
                    vm.article = res.data;
                    document.title = vm.article.productName;
                    if(vm.article.invalid){//作品失效
                        $state.go('articlesFailure',{storeId:vm.storeId},{location: 'replace'});
                        return
                    }
                    getProduct(vm.article.productId,function () {
                        ItemValue.get({id: res.data.itemValueId}, function (resp) {
                            if(resp.status == 200){
                                vm.article.skuNumber = resp.data.skuNumber;
                                vm.article.productBokeh = resp.data.productBokeh;
                                vm.article.productBokehType = resp.data.productBokehType;
                                if (!resp.data.productBokehType) {
                                    vm.article.bokehtype = 'None';
                                } else {
                                    vm.article.bokehtype = resp.data.productBokehType;
                                }
                                angular.forEach(resp.data.productXmlLines, function (line) {
                                    if (line.productXmlId == vm.article.productXmlId) {
                                        vm.productXmlLine = angular.copy(line);
                                    }
                                });
                                Convert.xmlToDocument2({
                                    identifier: vm.article.fileName,
                                    provider: 'qiniu',
                                    editorType:vm.article.editorType,
                                    patternType:vm.product.patternType,
                                }, function (res) {
                                    vm.article.document = res;
                                    vm.replace = res.replace;

                                    angular.forEach(vm.article.document.pages.page, function (page, i) {
                                        if(!page.backup){
                                            angular.forEach(page.levels.level, function (level) {
                                                if (level.imagebox && level.imagebox.geometry) {
                                                    vm.counts++;
                                                }
                                            })
                                        }
                                    });
                                    $scope.book();
                                    vm.threeLoading = false;
                                });
                            }else {
                                MessageService.error(res.message);
                            }
                        });
                    });
                },function (error) {
                    if(error.status === 403){//token失效
                        return $state.go('404',{storeId:vm.storeId},{location: 'replace'});
                    }
                    if(error.data.status === 404){//未找到作品
                        $state.go('404',{storeId:vm.storeId,tips:error.data.message},{location: 'replace'});
                    }
                    if(error.data.status === 410){//作品编辑器失效
                        $state.go('404',{storeId:vm.storeId,tips:'编辑器失效'},{location: 'replace'});
                    }
                })
                loadAll('isNull');
            }
            vm.page1=false;
            vm.page2 = false;
            vm.page4 = false;
            vm.page5 = false;

            $scope.qiniuId = localStorage.getItem("gallery") ? JSON.parse(localStorage.getItem("gallery")) : [];
        }
        function getProduct(id,callback){
            Product.get({id: id, cancelled: false}, function (res) {
                vm.product = res.data;
                vm.forceFill = res.data.forceFill;
                if(callback){callback()}
            });
        }

        $q.all([$scope.domains.$promise,vm.platformSetting.$promise]).then(function () {
            $scope.domain = 'https://' + $scope.domains.domains[0] + '/';
            vm.platformSetting = vm.platformSetting.data;

            vm.lagnuages =[];
            if ($localStorage.lagnuages) {
                for(var i = 0 ; i<$localStorage.lagnuages.length; i++ ){
                    var lang = $localStorage.lagnuages[i];
                    var langObj = {key:lang};
                    if (lang == 'zh-cn') {
                        langObj.value = "中文";
                    }
                    if (lang == 'en') {
                        langObj.value = "English";
                    }
                    if (vm.lang == lang) {
                        vm.langValue = langObj.value;
                        langObj.selected = true;
                    }
                    vm.lagnuages.push(langObj);
                }
            }


            /**
             * wechat api
             */
            if (wx) {
                var url = window.location.hash && window.location.href.slice(0, -window.location.hash.length) || window.location.href;
                WxJS.get({url: url}, function (res) {
                    if(res.status==200) {
                        $scope.agentIos = browserVersions();
                        var config = res.data;
                        wx.config({
                            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                            appId: config.appId, // 必填，公众号的唯一标识
                            timestamp: config.timestamp, // 必填，生成签名的时间戳
                            nonceStr: config.nonceStr, // 必填，生成签名的随机串
                            signature: config.signature,// 必填，签名，见附录1
                            jsApiList: ['chooseImage', 'uploadImage', 'hideMenuItems'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                        });
                        wx.ready(function () {
                            console.log('wechat api ready!');

                            wx.hideMenuItems({
                                menuList: ["menuItem:copyUrl", "menuItem:share:timeline", "menuItem:share:appMessage", "menuItem:share:qq", "menuItem:share:appMessage", "menuItem:share:QZone"]
                            });
                        });
                        wx.error(function (res) {
                            console.log(res)
                        });
                    }
                }, function () {
                    console.log("wx config error");
                });
            }

            //获取照片旋转角度使用
            //消息列表
            $timeout(function () {
                qInit();
            })
            vm.isIPhoneX = Iphone;
            photoAllInfo();
            websocket()
        });
        //------------------------------------------------  page0 ------------------------------------------------
        vm.isUploadNeedKnow = false;
        $scope.uploadNeedKnowClick = function () {
            vm.isUploadNeedKnow = true;
        }
        $scope.uploadNeedKnowHide = function () {
            vm.isUploadNeedKnow = false;
        }
        vm.isPage0Upload = false;
        $scope.page0Upload = function(){
            uploadAble(StoreStorages,vm.storeId, function (res) {
                if(res.status == 200){
                    vm.isPage0Upload = true;
                    if($scope.agentIos){
                        $rootScope.$broadcast('clickAndroidUpload',true);
                    }else {
                        $timeout(function () {
                            $("#uploadImagePhotobook").trigger("click");
                        })
                    }
                }else{
                    if(res.status == 400){
                        threeInfo('系统出错');
                    } else {
                        threeInfo(res.data||'系统出错');
                    }
                }
            })
        }
        // 选择完图片之后接收回调，切换到page1显示进度条 禅道bug #14514
        $scope.onUploadStart = function () {
            if(vm.isPage0Upload){
                vm.page0 = false;
                vm.page1 = true;
                vm.isPage0Upload = false;
            }
        }
        $scope.uploadSuccess = function(res){
            vm.photoAll.unshift(res)
            getPagePhoto();
        }
        $scope.$on('uoloadFinished', function(event, args) {
            if(args){
                if(vm.isPage0Upload){
                    vm.page0 = false;
                    vm.page1 = true;
                    vm.isPage0Upload = false;
                }
                if(vm.fullMap){
                    vm.photoSelectAll.forEach(function (item) {
                        item.selected = true;
                        var _exists = false;
                        for (var j = 0; j < vm.photoSelectAll2.length; j++) {
                            if (vm.photoSelectAll2[j].id == item.id) {
                                _exists = true;
                                break;
                            }
                        }
                        if (!_exists) {
                            vm.photoSelectAll2.push(item)
                        }
                    })
                }
                updatePic();
            }
        });
        vm.uploadPhotoItem=[];

        // 监听重复图片事件
        $scope.$on('duplicateImages', function(event, duplicateList,flag,currentFileList) {
            if (duplicateList && duplicateList.length > 0) {
                vm.duplicateList = duplicateList;
                MessageService.confirm({
                    title: '提示',
                    cancel: '取消',
                    confirm: '确认',
                    msg: '检测到图库中有' + vm.duplicateList.length + '张重复图片，是否需要自动去重？',
                    html: '<span class="themecolor themecolor-btn">查看重复图片</span>'
                }, function(res) {
                    if (res == 'htmlClick') {
                        vm.isDuplicateList = true;
                    } else {
                        var ids = [];
                        vm.duplicateList.forEach(function(item) {
                            ids.push(item.id);
                        });
                        Gallery.batchDelete(ids, function() {
                            // 上传的全是重复图
                           if(ids.length == vm.photoSelectAll.length){
                                MessageService.success('去重成功！');
                                vm.duplicateList = [];
                                vm.photoAll = [];
                                vm.photoSelectAll = []
                                vm.indexNum = 0;
                                vm.maxId = null;
                                vm.photoCompleted = false;
                                loadAll('isNull');
                        }else{
                            var deletedIds = {};
                            currentFileList.forEach(function(_v){
                                if(_v.duplicate){
                                    deletedIds[_v.id] = true;
                                }
                            });
                            vm.photoSelectAll = vm.photoSelectAll.filter(function(img){
                                return !deletedIds[img.id];
                            });
                            $rootScope.$broadcast('uoloadFinished',flag);
                        }
                        $rootScope.$broadcast('duplicateGalleryRefresh');
                        }, function(error) {
                            MessageService.error('删除失败！');
                            vm.duplicateList = [];
                        });
                    }
                }, function() {
                    vm.duplicateList = [];
                    $rootScope.$broadcast('uoloadFinished',flag);
                });
            }
        });
        $scope.duplicateChange = function(val) {
            var _val = JSON.parse(val)
            // val 可能是: 0(关闭), 1(全部删除), 数组(部分删除)
            // 当删除部分图片时，从已选列表中移除对应图片，避免重新加载后这些图片被重新选中
            if(Array.isArray(_val) && _val.length){
                var deletedIds = {};
                _val.forEach(function(_v){
                    deletedIds[_v.id] = true;
                });
                vm.photoSelectAll = vm.photoSelectAll.filter(function(img){
                    return !deletedIds[img.id];
                });
            }
            vm.isDuplicateList = false;
            vm.duplicateList = [];
            vm.indexNum = 0;
            vm.maxId = null;
            vm.photoCompleted = false;
            loadAll('isNull');
            $rootScope.$broadcast('duplicateGalleryRefresh');
        };

        $scope.uploadPhoto = function () {
            uploadAble(StoreStorages,vm.storeId, function (res) {
                if(res.status == 200){
                    if($scope.agentIos){
                        $rootScope.$broadcast('clickAndroidUpload',true);
                    }else{
                        $timeout(function () {
                            $("#uploadImagePhotobook").trigger("click");
                        })
                    }
                }else{
                    if(res.status == 400){
                        threeInfo('系统出错');
                    } else {
                        threeInfo(res.data||'系统出错');
                    }
                }
            })
        }
        //------------------------------------------------  page1 ------------------------------------------------
        $scope.showGallery = function () {
            $('.c-productThree2-head3-page2').animate({
                scrollTop: 0
            }, 200);
            vm.page0 = false;
            vm.page1 = false;
            vm.page2 = true;
            vm.page3 = false;
            vm.page4 = false;
            vm.currentNav = 'gallery';//folder
            vm.photoAll=[];
            vm.indexNum = 0;
            vm.maxId = null;
            vm.photoCompleted = false;
            vm.isShowGallery = true;
            loadAll('isNull');
        }

        var longPressTimer = null;
        vm.draggable = false;
        var sort1 = null;
        function photoAllInfo() {
            sort1 = new Sortable(document.getElementById('photoAllId'), {
                swap: false,
                filter: '.filtered',
                animation: 150,
                forceFallback: false,
                delay: 500, // 设置长按时间为0.5秒
                onEnd: function (/**Event*/evt) {
                    sortArray = [];
                    angular.forEach($('#photoAllId').find(".sortingPageView"), function (item, index) {
                        var page = item.getAttribute("data-page");
                        sortArray.push(JSON.parse(page));
                    });
                    if(sortArray && sortArray.length>0){
                        vm.photoSelectAll = [];
                        $timeout(function () {
                            vm.photoSelectAll = angular.copy(sortArray);
                            sortArray = [];
                        })
                    }
                    // longPressTimer = setTimeout(function() {
                    //     sort1.option("delay", 500);
                    //     vm.draggable = false;
                    //     $scope.$apply();
                    // }, 1000);
                },
                // 元素被选中
                onChoose: function (/**Event*/evt) {
                    vm.draggable = true;
                    $scope.$apply();
                    sort1.option("delay", 0);
                    // clearTimeout(longPressTimer);
                },
            });
        }

        $scope.completeSort = function(){
            sort1.option("delay", 500);
            vm.draggable = false;
            // $scope.$apply();
        }

        $scope.photoReverse = function () {
            if(vm.photoSelectAll && vm.photoSelectAll.length>0){
                vm.photoSelectAll.reverse();
            }
        }
        //------------------------------------------------  page2 ------------------------------------------------
        var sort = null;
        $scope.getBack = function (item) {
            if(item == 'page2'){
                vm.page1 = true;
                vm.page2 = false;
            }
            if(item == 'page7'){
                vm.page7 = false;
                vm.page3 = true;
                sort.destroy();
            }
            if(item == 'page9'){
                vm.page2 = true;
                vm.page9 = false;
                vm.folderOne = null;
            }
        }
        $scope.galleryNavSel = function (item) {
            vm.currentNav = item;
            vm.indexNum = 0;
            vm.maxId = null;
            vm.photoCompleted = false;
            vm.photoAll = [];
            vm.folderOne = null;
            if(item == 'gallery'){
                loadAll('isNull')
            }
            if(item == 'folder'){
                loadFolders()
            }
        };

        function qInit(){
            $('.c-productThree2-head3-page2').on('scroll', function(event){
                var realScrollHeight=event.currentTarget.clientHeight+event.currentTarget.scrollTop;
                if(!vm.photoCompleted){
                    if((event.currentTarget.scrollHeight-1)<realScrollHeight && realScrollHeight < (event.currentTarget.scrollHeight+1)){
                        vm.indexNum++;
                        loadAll('isNull');
                    }
                }
            })
            $('.c-productThree2-head3-page9').on('scroll', function(event){
                var realScrollHeight=event.currentTarget.clientHeight+event.currentTarget.scrollTop;
                if(!vm.photoCompleted){
                    if((event.currentTarget.scrollHeight-1)<realScrollHeight && realScrollHeight < (event.currentTarget.scrollHeight+1)){
                        vm.indexNum++;
                        loadAll(vm.folderOne.id);
                    }
                }
                $scope.$digest();
            })
        }
        // 增加文件夹
        $scope.addFolder = function () {
            swal({
                title: $translate.instant("editorCommon.addPhotoAlbumPop"),
                text: "",
                type: "input",
                showCancelButton: true,
                closeOnConfirm: false,
                confirmButtonText: $translate.instant("button.confirm"),
                cancelButtonText: $translate.instant("button.cancel"),
                animation: "slide-from-top",
                inputPlaceholder: $translate.instant("editorCommon.pleaseFolderName")
            }, function (inputValue) {
                if (inputValue === false) {
                    $(".folder-footer").show();
                    return false;
                }
                if (inputValue === "") {
                    swal.showInputError($translate.instant("editorCommon.pleaseName"));
                    return false
                }
                if (inputValue.indexOf(" ") != -1) {
                    swal.showInputError($translate.instant("editorCommon.pleaseEnterTheContent"));
                    return false
                }
                Folder.save({
                    articleId:vm.article.id,
                    name: inputValue,
                    type: 'Gallery'
                }, function (resp) {
                    $scope.Folders.push(resp.data);
                    console.log($scope.Folders)
                    swal.close();
                }, function () {
                    swal.showInputError($translate.instant("editorCommon.pleaseEnterTheCorrectFileName"));
                })
            });
        };
        //文件夹多选
        vm.isChoiceFolder = false;
        $scope.choiceFolder = function () {
            vm.isChoiceFolder = true;
        }
        $scope.cancelFolder = function () {
            vm.isChoiceFolder = false;
            vm.folderSelectData = "";
            $scope.Folders.forEach(function (data) {
                data.selected = false;
            })
        }
        vm.isEditFolderName = false;
        $scope.editFolder = function () {
            if(!vm.folderSelectData && vm.folderListSelect.length != 1){
                threeInfo($translate.instant("editorCommon.pleaseSelectAFolder"));
                return
            }
            vm.isEditFolderName = true;
        }
        $scope.editFolderNameHide = function () {
            vm.isEditFolderName = false;
        }
        $scope.editFolderNameSave = function () {
            vm.isEditFolderName = false;
            if (!vm.folderSelectData || !vm.folderSelectData.name) {
                threeInfo($translate.instant("editorCommon.pleaseName"));
                return false
            }
            if (vm.folderSelectData.name.indexOf(" ") != -1) {
                threeInfo($translate.instant("editorCommon.pleaseEnterTheContent"));
                return false
            }
            Folder.update(vm.folderSelectData, function (resp) {
                threeInfo($translate.instant("editorCommon.folderNameSuccess"));
                $scope.cancelFolder();
                loadFolders();
                swal.close();
            }, function () {
                threeInfo($translate.instant("editorCommon.pleaseEnterTheCorrectFileName"));
            })
        }


        $scope.Folders = [];
        function loadFolders() {
            Folder.storeGetAllByCondition({
                items: [{key: "type", op: "=", value: "Gallery"},{key: "articleId", op: "=", value: vm.article.id}],
                sort: ["id,asc"]
            }, function (resp) {
                $scope.Folders = resp.data || [];
            })
        }
        vm.folderSelectData = "";
        $scope.folderSelect = function (item) {
            vm.photoCompleted = false;
            if(vm.isChoiceFolder){
                item.selected = !item.selected ? true : false;
                foldersInfo()
            }else {
                vm.folderOne = item;
                vm.photoAll = [];
                vm.photoArray = [];
                vm.indexNum = 0;
                vm.maxId = null;
                loadAll(item.id)
                vm.page2 = false;
                vm.page9 = true;
            }
        }
        vm.folderListSelect = [];
        function foldersInfo(){
            vm.folderListSelect = [];
            $scope.Folders.forEach(function (data) {
                if(data.selected){
                    vm.folderSelectData = data;
                    vm.folderListSelect.push(data);
                }
            })
        }
        $scope.folderSave = function () {
            if(vm.fullMap){
                if(vm.photoSelectAll.length > vm.fullMapNumber){
                    threeInfo($translate.instant("hint.imagesMaxQuantity"))
                    return
                }
                vm.threeLoading = true;
                vm.threeLoadingText = "加载中";
                photoSave1(vm.photoSelectAll,0,function () {
                    vm.threeLoading = false;
                    $scope.fullMapHide();
                });
                return
            }
            vm.page1 = true;
            vm.page2 = false;
            vm.page9 = false;
            vm.folderOne = null;
            for(var i=0; i<vm.photoSelectAll.length; i++){
                vm.photoSelectAll[i].seq = i+1;
            };
        }
        $scope.folderSave1 = function(){
            vm.threeLoading = true;
            vm.threeLoadingText = $translate.instant("hint.loadingText");
            $scope.cancelFolder();
            angular.forEach(vm.folderListSelect, function (item) {
                folderSave1Info(item)
            })
        }
        function folderSave1Info(item){
            Gallery.storeByCondition({
                items: [{key: "folderId", op: "=", value: item.id}],
                page: vm.indexNum,
                size: vm.itemsPerPage,
                sort: sorts()
            }, function (res) {
                for (var i = 0; i < res.length; i++) {
                    if (!res[i].cancelled) {
                        res[i].selected = true;
                        photoSelect(res[i].selected, res[i])
                    }
                };
                vm.threeLoading = false;
                vm.threeLoadingText = '';
                vm.page2 = false;
                vm.page1 = true;
            },function () {

            });
        }
        //------------------------------------------------  page3 ------------------------------------------------
        vm.sortingPage = [];
        var sortArray = [];
        $scope.getSortIndex = function (index) {
            var sortIndexList = sort.toArray();
            var _index = sortIndexList.findIndex(function(item){
                return item == index
            })
            return _index + 1;
        }
        $scope.sortingPage = function () {
            var _unreplacePage=[];
            for(var i=0; i<$scope.template.pages.page.length; i++){
                if(!$scope.template.pages.page[i].unreplace){
                    _unreplacePage.push($scope.template.pages.page[i])
                }
            }
            if(_unreplacePage.length<2 || !vm.replace){
                swal({
                    title: $translate.instant("editorCommon.describe27"),
                    text: "",
                    imageUrl: Theme.sweetHintImg(),
                    timer: 2000,
                    showConfirmButton: false
                });
                return
            }

            vm.sortingPage = [];
            sortArray = [];
            vm.page7 = true;
            vm.page3 = false;
            $timeout(function () {
                vm.sortingPage = angular.copy($scope.template.pages.page);
                var currentId = null;
                var originalId = null;
                var currentSpread = null;
                var originalSpread = null;
                var moveTimer = null;
                sort = new Sortable(document.getElementById('my-ui-list1'), {
                    swap: true,
                    filter: '.filtered',
                    cancel: ".notDrag",
                    animation: 150,
                    onMove:function (evt,originalEvent) {
                        currentSpread = evt.dragged.dataset.spread;
                        originalSpread = originalEvent.target.dataset.spread;
                        currentId = evt.dragged.dataset.id;
                        originalId = originalEvent.target.dataset.id;
                        var itemDomList = document.getElementById("my-ui-list1").children;
                        var currentIndex = null;
                        var originalIndex = null;
                        for(var i=0;i< itemDomList.length -1;i++){
                            $(originalEvent.target).find(".sort-item-mask").css({
                                display:'none'
                            });
                            $(itemDomList[i]).find(".sort-item-cell").css({
                                display:'none'
                            })
                            if(itemDomList[i].dataset.id === currentId){
                                currentIndex = i;
                            }
                            if(itemDomList[i].dataset.id === originalId){
                                originalIndex = i;
                            }
                        }
                        //给禁用的项加蒙版
                        if(currentSpread !== originalSpread){
                            $(originalEvent.target).find(".sort-item-mask").css({
                                display:'flex'
                            });
                            for(var i=0;i< itemDomList.length -1;i++){
                                $(itemDomList[i]).find(".sort-item-cell").css({
                                    display:'none'
                                })
                            }
                        }else{//给可插入的加插入线
                            for(var i=0;i< itemDomList.length -1;i++){
                                $(itemDomList[i]).find(".sort-item-mask").css({
                                    display:'none'
                                })
                            }
                            if(currentIndex > originalIndex){//加左边插入线
                                $(originalEvent.target).find(".sort-item-cell").css({
                                    left:'-10px',
                                    right:'auto',
                                    display:'block'
                                })
                            }else{
                                //加右侧插入线
                                $(originalEvent.target).find(".sort-item-cell").css({
                                    right:'-10px',
                                    left:'auto',
                                    display:'block'
                                })
                            }

                        }
                        if(moveTimer){
                            clearTimeout(moveTimer);
                            moveTimer = null;
                        }
                        moveTimer = setTimeout(function () {
                            currentId = null;
                            for(var i=0;i< itemDomList.length -1;i++){
                                $(itemDomList[i]).find(".sort-item-cell").css({
                                    display:'none'
                                })
                                $(itemDomList[i]).find(".sort-item-mask").css({
                                    display:'none'
                                })
                            }
                        },100)
                        return false;

                    },
                    onEnd: function (/**Event*/evt) {
                        //排序结束
                        if(!currentId) return;
                        var itemDomList = document.getElementById("my-ui-list1").children;
                        var moveList = [];
                        var lockList = [];
                        for(var i=0;i< itemDomList.length;i++){
                            $(itemDomList[i]).find(".sort-item-mask").css({
                                display:'none'
                            });
                            $(itemDomList[i]).find(".sort-item-cell").css({
                                display:'none'
                            })
                            if(itemDomList[i].dataset.spread === currentSpread){
                                moveList.push(itemDomList[i].dataset.id);
                            }else{
                                lockList.push({
                                    id:itemDomList[i].dataset.id,
                                    index:i
                                })
                            }
                        }
                        var currendIndex = moveList.findIndex(function(item){ return item === currentId});
                        var originalIndex = moveList.findIndex(function(item){ return item === originalId});
                        if(currendIndex < 0 || originalIndex < 0) return;
                        //两个元素相邻，做交换操作
                        if(currendIndex + 1 === originalIndex || originalIndex + 1 === currendIndex){
                            var temp = moveList[currendIndex];
                            moveList[currendIndex] = moveList[originalIndex];
                            moveList[originalIndex] = temp;
                        }else{
                            //先删除当前的元素
                            moveList.splice(currendIndex,1);
                            originalIndex = moveList.findIndex(function(item){ return item === originalId});
                            if(currendIndex < originalIndex){//向下移动，插入到后面
                                moveList.splice(originalIndex+ 1,0,currentId);
                            }else{//向上移动，插入到目标元素前面
                                moveList.splice(originalIndex,0,currentId);
                            }
                        }
                        //把不可动的元素按之前的索引重新插入
                        lockList.forEach(function(item){
                            moveList.splice(item.index,0,item.id);
                        });
                        currentId = null;
                        sort.sort(moveList,true);
                        $scope.$apply();
                        sortArray = [];
                        var arr = sort.toArray();
                        if(arr.length < vm.sortingPage.length){
                            var _arr1 = [];
                            for(var i=0; i<vm.sortingPage.length; i++){
                                var exist = false;
                                for(var j=0; j<arr.length; j++){
                                    if(arr[j] == i){
                                        exist = true;
                                        break
                                    }
                                }
                                if(!exist){
                                    _arr1.push(i)
                                }
                            }
                            _arr1.forEach(function (arrItem, arrIndex) {
                                arr.splice(arrItem, 0, arrItem);
                            })
                        }
                        arr.forEach(function (item) {
                            sortArray.push(vm.sortingPage[item])
                        })
                        // vm.sortingPage = [];
                        // $timeout(function () {
                        //     vm.sortingPage = angular.copy(sortArray);
                        // })
                    }
                });
            })
        };
        $scope.restorePage7 = function () {
            vm.page7 = false;
            $timeout(function () {
                sort.destroy();
                $scope.sortingPage();
            })
        }
        $scope.savePage7 = function () {
            if(sortArray && sortArray.length>0){
                $scope.template.pages.page = [];
                $timeout(function () {
                    $scope.template.pages.page = angular.copy(sortArray);
                })
            }
            vm.page7 = false;
            vm.page3 = true;
            vm.sortingPage = [];
            sort.destroy();
        }


        // 上传图片后更新图片库/文件夹
        function updatePic() {
            if (vm.folderOne && vm.folderOne.id) {
                // $scope.showFolderContent(vm.folderOne);
                vm.photoAll = [];
                vm.galleryPage = [];
                loadAll(vm.folderOne.id);
            } else {
                vm.photoAll=[];
                vm.galleryPage=[];
                vm.indexNum = 0;
                vm.maxId = null;
                vm.photoCompleted = false;
                // vm.isShowGallery = true;
                loadAll('isNull');
            }
        }

        function loadAll(folderId) {
            var items = [];
            items.push({ key: "articleId", op: "=", value: vm.aid });
            if (folderId == 'isNull') {
                items.push({key: "folderId", op: "isNull", value: ''})
            } else {
                items.push({ key: "folderId", op: "=", value: folderId })
            }
            if (vm.maxId) {
                items.push({key: "id", op: "<=",value: vm.maxId});
            }
            Gallery.storeByCondition({
                items: items,
                page: vm.indexNum,
                size: vm.itemsPerPage,
                sort: sorts()
            }, onSuccess, onError);
        }

        function sorts() {
            return ["id,desc"];
        }

        function onSuccess(res) {
            if (vm.maxId == null && res.data.length > 0) {
                vm.maxId = res.data[0].id;
            }
            for (var i = 0; i < res.data.length; i++) {
                if (!res.data[i].cancelled) {
                    res.data[i].identifier = $scope.domain + res.data[i].identifier;
                    if(res.data[i].largeFlag){
                        res.data[i].identifier1 = $scope.domain + res.data[i].thumbnailKey;
                    }
                    if(vm.photoAll){
                        vm.photoAll.push(res.data[i])
                    }
                    // for(var j=0; j<vm.photoSelectAll.length; j++){
                    //     if(vm.photoSelectAll[j].id == res.data[i].id){
                    //         vm.photoSelectAll[j] = res.data[i];
                    //     }
                    // }
                }
            }
            if (res.data.length < vm.itemsPerPage) {
                vm.photoCompleted = true;
            }
            getPagePhoto();
        }

        function onError(data) {
            if(data.status !== 403){
                MessageService.hint($translate.instant("editorCommon.failedToObtainThePhotoGallery"));
            }
        }

        // websocket接收上传的图片（多端互通实时更新）
        function websocket(){
            var urlws = vm.platformSetting.editorNotifyUrl.split("://")[1];
            urlws = urlws.split("/")[0];
            var ws = $websocket("wss://"+ urlws +"/widget/ws/websocket?uid=Gallery"+vm.aid);
            ws.onOpen(function() {
                console.log('WebSocket连接已打开, url:'+ws.url);
            });
            ws.onMessage(function(message) {
                var photo = JSON.parse(message.data);
                if (photo.folderId == vm.folderId || (photo.folderId == null && vm.folderId == '')) {
                    var _photo = null;
                    for (var i = 0; i < vm.photoAll.length; i++) {
                        if (vm.photoAll[i].id == photo.id) {
                            _photo = vm.photoAll[i];
                            break;
                        }
                    }
                    var _photo1 = null;
                    for (var i = 0; i < vm.photoSelectAll.length; i++) {
                        if (vm.photoSelectAll[i].id == photo.id) {
                            _photo1 = vm.photoSelectAll[i];
                            break;
                        }
                    }
                    if (_photo) {
                        _photo.largeStatus = photo.largeStatus;
                        _photo.stripKey = photo.stripKey;
                        _photo.thumbnailKey = photo.thumbnailKey;
                        _photo.identifier1 = $scope.domain + photo.thumbnailKey
                        if(_photo.convertFlag){
                            _photo.convertStatus = photo.convertStatus;
                            // 色彩转换完成后资源identifier会变化，需同步更新（photo.identifier未带域名）
                            _photo.identifier = $scope.domain + photo.identifier;
                        }
                    }
                    if (_photo1) {
                        _photo1.largeStatus = photo.largeStatus;
                        _photo1.stripKey = photo.stripKey;
                        _photo1.thumbnailKey = photo.thumbnailKey;
                        _photo1.identifier1 = $scope.domain + photo.thumbnailKey
                        if(_photo1.convertFlag){
                            _photo1.convertStatus = photo.convertStatus;
                            _photo1.identifier = $scope.domain + photo.identifier;
                        }
                    }
                    // 同步更新已选列表副本（图库已选tab、全屏选图）中的大图/色彩转换状态
                    angular.forEach([vm.photoSelectAll1, vm.photoSelectAll2], function (list) {
                        if (!list || !list.length) return;
                        for (var k = 0; k < list.length; k++) {
                            if (list[k].id == photo.id) {
                                list[k].largeStatus = photo.largeStatus;
                                list[k].stripKey = photo.stripKey;
                                list[k].thumbnailKey = photo.thumbnailKey;
                                list[k].identifier1 = $scope.domain + photo.thumbnailKey;
                                if (list[k].convertFlag) {
                                    list[k].convertStatus = photo.convertStatus;
                                    list[k].identifier = $scope.domain + photo.identifier;
                                }
                            }
                        }
                    });
                }
            });
            ws.onError(function(error) {
                console.log('WebSocket错误：', error);
            });
            ws.onClose(function() {
                console.log('WebSocket连接已关闭');
            });
        }
        function getPagePhoto() {
            var timeList=[];
            vm.photoArray = [];
            for(var i=0; i<vm.photoAll.length; i++){
                var photoCreatedDate = new Date(vm.photoAll[i].createdDate);
                if (checkExist(timeList, photoCreatedDate)) {
                    timeList.push(photoCreatedDate);
                }
            }
            //将相同日期下的照片整合
            for (var m = 0; m < timeList.length; m++) {
                var tempObj = {};
                var tempItems = [];
                for (var j = 0; j < vm.photoAll.length; j++) {
                    var createdDate = new Date(vm.photoAll[j].createdDate);
                    if (timeList[m].getFullYear() == createdDate.getFullYear() &&
                        timeList[m].getMonth() == createdDate.getMonth() &&
                        timeList[m].getDate() == createdDate.getDate()) {
                        tempItems.push(vm.photoAll[j])
                    }
                }
                var time = timeList[m].getFullYear() + '-' + (timeList[m].getMonth() + 1) + '-' + timeList[m].getDate();
                tempObj = {"createDate": time, "galleries": tempItems};
                vm.photoArray.push(tempObj);
            }
            getPagePhotoSelected();
            photoArrayAllSelect();
        }
        function getPagePhotoSelected() {
            for(var i=0; i<vm.photoArray.length; i++){
                vm.photoArray[i].selected = true;
                for(var j=0; j<vm.photoArray[i].galleries.length; j++){
                    vm.photoArray[i].galleries[j].selected = false;
                    for(var k=0; k<vm.photoSelectAll.length; k++){
                        if(vm.photoArray[i].galleries[j].id == vm.photoSelectAll[k].id){
                            vm.photoArray[i].galleries[j].selected = true;
                        }
                    }
                    if(!vm.photoArray[i].galleries[j].selected){
                        vm.photoArray[i].selected = false;
                    }
                }
            }
            photoSelectAllInit(true)
        }
        // 判断是否重复
        function checkExist(list, obj) {
            if (list == null || list.length == 0) {
                return true;
            }
            for (var i = 0; i < list.length; i++) {
                if (list[i].getFullYear() == obj.getFullYear() &&
                    list[i].getMonth() == obj.getMonth() &&
                    list[i].getDate() == obj.getDate()) {
                    return false;
                }
            }
            return true;
        }
        //全选当前图片
        $scope.photoAllCb = function (item) {
            item.selected = !item.selected ? true : false;
            for(var i=0; i<item.galleries.length; i++){
                item.galleries[i].selected = item.selected;
                photoSelect(item.galleries[i].selected, item.galleries[i])
            }
            photoArrayAllSelect()
        }
        //选中当前图片
        $scope.photoOneCb = function (item) {
            if(vm.fullMap && !item.selected && vm.photoSelectAll.length >= vm.fullMapNumber){
                threeInfo($translate.instant("hint.imagesMaxQuantity"))
                return
            }
            item.selected = !item.selected ? true : false;
            photoSelect(item.selected, item);
            photoArrayAllSelect()
        }
        function photoSelect(select, data) {
            if (vm.photoSelectAll == null) {
                var _index = [].findIndex(function(item) {
                    return item.id === data.id
                });
            }else{
                var _index = vm.photoSelectAll.findIndex(function(item) {
                    return item.id === data.id
                });
            }

            if(select){
                if(_index == -1){
                    vm.photoSelectAll.push(data)
                }
            }else {
                if(_index>-1){
                    vm.photoSelectAll.splice(_index,1);
                }
            }
        }
        function photoArrayAllSelect(){
            for(var i=0; i<vm.photoArray.length; i++){
                vm.photoArray[i].selected = true;
                for(var j=0; j<vm.photoArray[i].galleries.length; j++) {
                    if (!vm.photoArray[i].galleries[j].selected) {
                        vm.photoArray[i].selected = false;
                    }
                }
            }
        }
        //添加图片
        $scope.photoSave = function () {
            if(vm.isShowGallery1){
                vm.page2 = false;
                vm.page7 = true;
                vm.page1 = false;
                vm.isShowGallery1 = false;
            }
            if(vm.isShowGallery){
                vm.page1 = true;
                vm.page2 = false;
                vm.isShowGallery = false;
            }
            for(var i=0; i<vm.photoSelectAll.length; i++){
                vm.photoSelectAll[i].seq = i+1;
            }
        }
        $scope.deletePhotoSelect = function (e,index, item) {
            if(item.selectSeq){
                for(var i=0; i<$scope.pages.pages.page[item.page-1].levels.level.length; i++){
                    var _level = $scope.pages.pages.page[item.page-1].levels.level[i];
                    _level.imageboxSum = 1;
                    if(_level.imagebox){
                        if(_level.imageboxSum == item.number){
                            _level.imagebox.selectSeq = false;
                            break;
                        }
                        _level.imageboxSum++;
                    }
                }
            }
            vm.photoSelectAll.splice(index, 1);
            fn(e);
        }

        // 图库照片处理状态：大图处理中/失败、色彩转换中/失败，无特殊状态返回''（正常展示照片）
        $scope.photoStatus = function (photo) {
            if (!photo) return '';
            if (photo.convertFlag == true && photo.convertStatus == 'running') return 'convertRunning';
            if (photo.convertStatus == 'error') return 'convertError';
            if (photo.largeFlag && photo.largeStatus == 'running') return 'largeRunning';
            if (photo.largeFlag && photo.largeStatus == 'error') return 'largeError';
            return '';
        };
        // 是否处理失败状态（大图处理失败、色彩转换失败）
        $scope.isPhotoFailed = function (photo) {
            var status = $scope.photoStatus(photo);
            return status === 'largeError' || status === 'convertError';
        };
        // 处理中的照片不可选中/添加到画布，处理失败的照片点击弹出删除确认框
        $scope.onPhotoStatusClick = function (photo, event) {
            if (event) {
                event.stopPropagation();
            }
            if ($scope.isPhotoFailed(photo)) {
                vm.pendingDeletePhoto = photo;
                vm.deletePhotoSure = true;
            }
        };
        // 确认删除处理失败的照片，取消则仅关闭弹框
        $scope.deletePhotoConfirm = function () {
            var photo = vm.pendingDeletePhoto;
            if (!photo || !photo.id) {
                vm.deletePhotoSure = false;
                vm.pendingDeletePhoto = null;
                return;
            }
            var id = photo.id;
            Gallery.batchDelete([id], function () {
                MessageService.success($translate.instant('nav.photograph.content.deletePhoto.success'));
                // 清除画布中引用该照片的图片框
                var clearCanvasRefs = function (pages) {
                    if (!pages || !pages.length) return;
                    angular.forEach(pages, function (pageItem) {
                        if (pageItem && pageItem.levels && pageItem.levels.level) {
                            angular.forEach(pageItem.levels.level, function (level) {
                                if (level.imagebox && level.imagebox.image &&
                                    (level.imagebox.image.resourceid == id ||
                                    (photo.sourceId != null && level.imagebox.image.resourceid == photo.sourceId))) {
                                    var box = level.imagebox;
                                    box.blurredrectangle = {
                                        x: 0,
                                        y: 0,
                                        width: box.geometry ? box.geometry.width : '',
                                        height: box.geometry ? box.geometry.height : ''
                                    };
                                    box.imgUrl = 'content/images/mask_souce.png';
                                    box.image = {
                                        resource: {
                                            identifier: '',
                                            provider: ''
                                        },
                                        filterResource: {
                                            identifier: '',
                                            provider: ''
                                        },
                                        offsetx: 0,
                                        offsety: 0,
                                        width: '',
                                        height: '',
                                        imgsize: '',
                                        index: '',
                                        parameter: [],
                                        scale: 1,
                                        angle: 0
                                    };
                                }
                            });
                        }
                    });
                };
                if (vm.pageData && vm.pageData.length) {
                    clearCanvasRefs(vm.pageData);
                }
                if ($scope.pages && $scope.pages.pages && $scope.pages.pages.page) {
                    clearCanvasRefs($scope.pages.pages.page);
                }
                // 从本地图库列表及各选中集合中移除
                var removeFromList = function (list) {
                    if (!list || !list.length) return;
                    for (var i = list.length - 1; i >= 0; i--) {
                        if (list[i].id === id) {
                            list.splice(i, 1);
                        }
                    }
                };
                removeFromList(vm.photoAll);
                removeFromList(vm.photoSelectAll);
                removeFromList(vm.photoSelectAll1);
                removeFromList(vm.photoSelectAll2);
                getPagePhoto();
                photoSelectAllInit();
                // 通知子组件（editor-gallery）从其本地photoAll移除并刷新
                $rootScope.$broadcast('photoDeletedRefresh', id);
                vm.deletePhotoSure = false;
                vm.pendingDeletePhoto = null;
            }, function () {
                vm.deletePhotoSure = false;
                vm.pendingDeletePhoto = null;
                MessageService.error($translate.instant('nav.photograph.content.deletePhoto.failed'));
            });
        };

        // 子组件（editor-gallery）点击处理失败的照片时emit此事件，由父级弹出删除确认框
        $scope.$on('requestDeletePhoto', function (event, photo) {
            if (photo && $scope.isPhotoFailed(photo)) {
                vm.pendingDeletePhoto = photo;
                vm.deletePhotoSure = true;
            }
        });


        //获取dpi
        js_getDPI(function (dpi) {
            vm.windowDpi = dpi;
        });

        //一键成书
        $scope.book = function (onePage) {
            if(templateEdit){
                localStorage.removeItem("templateEdit");
                abook();
                return;
            }
            vm.onePage = onePage;
            var pages = {};
            if (vm.isEdit) {
                pages = angular.copy(vm.article.document);
            } else {
                pages = angular.copy($scope.pages);
            }
            if(pages.config.productType == 'BOOK' && !vm.isEdit && vm.product.aiFill && !vm.onePage){
                if(vm.photoSelectAll.length == 0 && vm.productXmlLine.minPicQuantity == 0){
                    localStorage.removeItem("templateEdit");
                    abook();
                    return;
                }
                if(vm.photoSelectAll.length < vm.productXmlLine.minPicQuantity){
                    SweetAlert.swal({
                        title: "请至少选择" + vm.productXmlLine.minPicQuantity + "张照片，再尝试一键成书！",
                        imageUrl: Theme.sweetHintImg(),
                        timer: 1500,
                        showConfirmButton: false
                    });
                    return;
                }
                smartLayout2($scope.pages.pages,$scope.pages.backupPages.list, Algorithm, vm.photoSelectAll, 'photoAlbum', function (pages,backupPages, photoSelectAll){
                    $scope.pages.pages.page = pages;
                    vm.photoSelectAll = photoSelectAll;
                    localStorage.removeItem("templateEdit");
                    abook();
                });
            }else{
                if(!vm.isEdit && vm.forceFill && vm.photoSelectAll.length < vm.counts && !vm.onePage){
                    SweetAlert.swal({
                        title: "请选择" + vm.counts + "张照片，再尝试一键成书！",
                        imageUrl: Theme.sweetHintImg(),
                        timer: 1500,
                        showConfirmButton: false
                    });
                    return;
                }
                localStorage.removeItem("templateEdit");
                abook();
            }
        };
        vm.pageData = null;
        vm.pageIndex = 0;
        $scope.template = null;
        vm.reservePage=[];
        vm.standbyPage = [];
        function abook() {
            vm.page1 = false;
            vm.page8 = true;
            var pages = [];
            if (vm.isEdit) {
                pages = angular.copy(vm.article.document);
            } else {
                pages = angular.copy($scope.pages);
            }
            pages.backupPages.list.forEach(function (item) {
                var _page1 = angular.copy(item);
                getPageType(_page1)
                _page1.numberOfHoles = 0;
                if(_page1.levels && _page1.levels.level && _page1.levels.level.length>0){
                    _page1.levels.level.forEach(function (level){
                        if(level.imagebox && level.imagebox.geometry){
                            _page1.numberOfHoles++;
                        }
                    });
                }
                vm.reservePage.push(_page1);
            })
            var _pages = {
                config:pages.config,
                pages:{
                    page:[]
                }
            }
            pages.pages.page.forEach(function (item) {
                if(!item.backup){
                    var _page1 = angular.copy(item);
                    _pages.pages.page.push(_page1);
                }
            });
            documentAnalysis($scope, $http, vm, _pages,FontManagement,'other', function(page){
                ratioInfo(page)
            }, function () {
                $timeout(function () {
                    $scope.template = angular.copy(pages);
                    $scope.template.config.startYear = pages.config.startYear;
                    $scope.template.config.startMonth = pages.config.startMonth;
                    $scope.template.pages.page=[];
                    _pages.pages.page.forEach(function (item) {
                        var _page = item;
                        _page.seq = $scope.template.pages.page.length;
                        $scope.template.pages.page.push(_page);
                    });
                    vm.page8 = false;
                    vm.page3 = true;
                    vm.pageSum = $scope.template.pages.page.length - 1;
                    vm.isGuidePage = true;
                    vm.guidePage = 1;
                    imageboxLow();
                    recommendInit($scope.template.pages.page);
                    vm.windowWidth2 = ($(window).width() - 75)/2;
                    if($scope.template.config.productType == 'CALENDAR'){
                        vm.windowWidth2 = ($(window).width() - 60);
                    }
                    var _width = $scope.template.pages.page[0].custom.width;
                    for(var i=0; i<$scope.template.pages.page.length; i++){
                        if($scope.template.pages.page[i].config.partid == 'P'){
                            if(!$scope.template.pages.page[i].spread){
                                _width = $scope.template.pages.page[i].custom.width;
                                break
                            }else{
                                _width = $scope.template.pages.page[i].custom.width;
                            }
                        }
                    }
                    vm.ratio = vm.windowWidth2 / _width;
                    $scope.template.config.parts.list.forEach(function (part) {
                        if(!part.slideable){
                            for(var i=0; i<$scope.template.pages.page.length; i++){
                                if($scope.template.pages.page[i].config.partid == part.id){
                                    if($scope.template.pages.page[i].custom.width*vm.ratio>($(window).width() - 59)){
                                        part.slideable = true;
                                        break
                                    }
                                }
                            }
                        }
                    })
                }, 2000)
            })
        }

        function recommendInit(pages) {
            pages.forEach(function (page) {
                page.numberOfHoles = 0;
                page.recommendLayout = [];
                page.levels.level.forEach(function (level){
                    if(level.imagebox && level.imagebox.geometry){
                        page.numberOfHoles++;
                    }
                });
            });
            vm.reservePage.forEach(function (page) {
                for(var i=0; i<pages.length; i++){
                    if(pages[i].numberOfHoles === page.numberOfHoles && pages[i].uuid != page.uuid && pages[i].spread == page.spread && page.config.partid == pages[i].config.partid){
                        pages[i].recommendLayout.push(page)
                    }
                }
            });
        }
        $scope.pageChange = function (item, index) {
            var _recommendLayout = [];
            item.recommendLayout.forEach(function (recommendLayoutItem) {
                if(recommendLayoutItem.uuid != item.uuid){
                    _recommendLayout.push(recommendLayoutItem)
                }
            })
            if(_recommendLayout.length > 0){
                var x = _recommendLayout.length-1;
                var y = 0;
                var rand = parseInt(Math.random() * (x - y + 1) + y);
                vm.pageData = $scope.template.pages.page;
                vm.pageIndex = index;
                $scope.layoutCb(_recommendLayout[rand], function () {
                    $scope.template.pages.page = [];
                    $timeout(function(){
                        $scope.template.pages.page = vm.pageData
                    })
                })
            }
        }

        function imageboxLow() {
            $scope.template.pages.page.forEach(function (page) {
                if(page && page.levels && page.levels.level){
                    page.levels.level.forEach(function (level) {
                        if(level.imagebox&&level.imagebox.image && level.imagebox.image.resource && level.imagebox.image.resource.identifier){
                            pxInsufficient(level.imagebox, vm.imgSize, vm.imgDpi)
                        }
                    })
                }
            })
        }

        vm.ratioInfo = ratioInfo;
        function ratioInfo(item) {
            if(item.config.partid != 'P' || item.spread){
                vm.windowWidth1 = ($(window).width() - 60);
            }else{
                vm.windowWidth1 = ($(window).width() - 75)/2;
            }
            vm.windowWidth = $(window).width() * 0.8;
            vm.windowHeight = $(window).height() * 0.91 - 205;
            if(vm.islayout ||vm.mapDepot || vm.isMaterial || (vm.istemplate && vm.page4)){
                vm.windowHeight = document.body.clientHeight - 265 - (document.body.clientHeight*0.02);
                if(vm.isIPhoneX){
                    vm.windowHeight = vm.windowHeight - 30;
                }
                if(vm.mapDepot){
                    vm.windowHeight = vm.windowHeight - 20;
                }
            }
            var ratio = item.custom.width / item.custom.height;
            var ratio1 = vm.windowWidth / vm.windowHeight;
            item.custom.ratio = vm.windowWidth1 / item.custom.width;
            if (ratio >= ratio1) {
                item.custom.ratio1 = vm.windowWidth / item.custom.width;
            } else {
                item.custom.ratio1 = vm.windowHeight / item.custom.height;
            }
            item.custom.thumbnailScale = 300 / item.custom.width;
        }

        $scope.editPageCb = function (index) {
            vm.isDocumentTextDetection = false;
            vm.isGuidePage = true;
            vm.guidePage = 4;
            vm.page1 = false;
            vm.page2 = false;
            vm.page3 = false;
            vm.page4 = true;
            vm.pageData = angular.copy($scope.template.pages.page);
            vm.pageIndex = index;
            layoutInfo();
            $scope.makeBody();
            photoSelectAllInit();
        }

        $scope.previousPage = function () {
            vm.pageIndex--;
            ratioInfo(vm.pageData[vm.pageIndex]);
        }
        $scope.nextPage = function () {
            vm.pageIndex++;
            ratioInfo(vm.pageData[vm.pageIndex]);
        }

        /*******************************************布局*************************************************************************/
        vm.islayout = false;
        $scope.layout = function(){
            vm.islayout = true;
            ratioInfo(vm.pageData[vm.pageIndex]);
            $scope.layoutFn(true);
        }
        $scope.layoutHide = function(){
            vm.islayout = false;
            ratioInfo(vm.pageData[vm.pageIndex])
        }
        $scope.layoutFn = function(item){
            if(item){
                var numberOfHoles = 0;
                vm.recommendLayout = [];
                vm.pageData[vm.pageIndex].levels.level.forEach(function (level){
                    if(level.imagebox && level.imagebox.geometry){
                        numberOfHoles++;
                    }
                });
                vm.reservePage.forEach(function (page) {
                    if(page.numberOfHoles === numberOfHoles && vm.pageData[vm.pageIndex].spread == page.spread && page.config.partid == vm.pageData[vm.pageIndex].config.partid){
                        vm.recommendLayout.push(page);
                    }
                });
                vm.islayout1 = true;
                vm.islayout2 = false;
            }else{
                vm.islayout1 = false;
                vm.islayout2 = true;
            }
        }
        $scope.layoutCb = function(item, callback){
            if(item.uuid != vm.pageData[vm.pageIndex].uuid){
                vm.threeLoading = true;
                vm.threeLoadingText = $translate.instant("editorCommon.loadingText2");
                $scope.layoutHide();
                item.config = vm.pageData[vm.pageIndex].config;
                var pages = {
                    config:$scope.template.config,
                    pages:{
                        page: [angular.copy(item)]
                    }
                }
                documentAnalysis($scope, $http, vm, pages,FontManagement,'other', function(page){
                    ratioInfo(page)
                }, function () {
                    $timeout(function () {
                        vm.threeLoading = false;
                        vm.threeLoadingText = '';
                        var layoutPage = pages.pages.page[0];
                        layoutPage.backup = false;
                        layoutPage.unreplace = false;
                        pageDataInfo(layoutPage, function () {
                            imageboxLow();
                            recommendInit(vm.pageData)
                            if(callback){callback()}
                        })
                    }, 200);
                })
            }
        }
        function pageDataInfo(page, callback) {
            vm.threeLoading = true;
            vm.threeLoadingText = $translate.instant("editorCommon.loadingText2");
            var _pageData = angular.copy(vm.pageData[vm.pageIndex]);
            var _pageDataImageboxImage = [];
            var _pageDataImageboxImageSum = 0;
            for(var i=0; i<_pageData.levels.level.length; i++){
                var _lecel = _pageData.levels.level[i];
                if(_lecel.imagebox && _lecel.imagebox.image && _lecel.imagebox.image.resource && _lecel.imagebox.image.resource.identifier){
                    _lecel.imagebox.imgRatio = _lecel.imagebox.image.width/_lecel.imagebox.image.height;
                    _pageDataImageboxImage.push(_lecel.imagebox)
                }
            }
            if(!page.levels.level){
                page.levels.level=[];
            }
            _pageDataImageboxImage = imageboxAdapt(page.levels.level, _pageDataImageboxImage);
            angular.forEach(page.levels.level, function (level, i) {
                if (level.imagebox) {
                    var _imagebox = null;
                    for(var j=0; j<_pageDataImageboxImage.length; j++){
                        if(_pageDataImageboxImage[j].imageboxIndex == _pageDataImageboxImageSum){
                            _imagebox = _pageDataImageboxImage[j];
                            break
                        }
                    }
                    _pageDataImageboxImageSum++;
                    if (_imagebox) {
                        level.imagebox.bokehtype = level.imagebox.bokehtype || vm.article.bokehtype || 'None';
                        level.imagebox.image = {
                            blurredrectangle: {
                                width: 0,
                                height: 0,
                                x: 0,
                                y: 0
                            },
                            resource: {
                                identifier: _imagebox ? _imagebox.image.resource.identifier : '',
                                provider: _imagebox ? _imagebox.image.resource.provider : 'qiniu'
                            },
                            resourceid:_imagebox ? _imagebox.image.resourceid : '',
                            filterResource: {
                                identifier: '',
                                provider: 'qiniu'
                            },
                            angle: 0,
                            offsetx: 0,
                            offsety: 0,
                            imageInfo: _imagebox? _imagebox.image.imageInfo : '',
                            width: _imagebox ? _imagebox.image.width : '',
                            height: _imagebox ? _imagebox.image.height : '',
                            imgSize: _imagebox ? _imagebox.image.imgSize : '',
                            index: _imagebox ? _imagebox.image.seq : '',
                            parameter: _imagebox ? angular.fromJson(_imagebox.image.parameter) : [],
                            scale: 1
                        }
                        if (level.imagebox.image.resource.identifier) {

                            addImagebox($http, level.imagebox, function () {})
                            // getBackgroundSource3(level.imagebox, level.imagebox.geometry.width, level.imagebox.geometry.height, level.imagebox.image, level.imagebox.bokehtype, $scope)
                        }
                    } else {
                        level.imagebox.image = {
                            resource: {
                                identifier: '',
                                provider: ''
                            },
                            resourceid:"",
                            filterResource: {
                                identifier: '',
                                provider: ''
                            },
                            width: '',
                            height: '',
                            imgSize: '',
                            offsetx: 0,
                            offsety: 0,
                            index: '',
                            parameter: [],
                            scale: 1,
                            angle: 0,
                        }
                    }
                }
            })
            $timeout(function () {
                vm.pageData[vm.pageIndex] = page;
                vm.threeLoading = false;
                vm.threeLoadingText = '';
                threeInfo1($translate.instant("editorCommon.changePageSuccess"));
                layoutInfo();
                if(callback){callback()}
            },200)
        }
        function layoutInfo(){
            vm.reservePage.forEach(function (item) {
                item.layoutQuantity=0;
            })
            vm.pageData.forEach(function (template) {
                vm.reservePage.forEach(function (reservePage) {
                    if(reservePage.uuid == template.uuid){
                        reservePage.layoutQuantity++
                    }
                })
            })
        }
        /*******************************************点击模板*************************************************************************/
        $scope.templateShow = function () {
            vm.istemplate = true;
            productInit()
            ratioInfo(vm.pageData[vm.pageIndex])
        }
        $scope.templateHide = function () {
            vm.istemplate = false;
            ratioInfo(vm.pageData[vm.pageIndex])
        }
        $scope.tempInfo = tempInfo;

        function productInit() {
            vm.modelTab=[{name:$translate.instant("editorCommon.all"), id:''}];
            ItemValue.get({id: vm.article.itemValueId}, function (res) {
                vm.tempList = res.data.productXmlLines;
                vm.tempList.forEach(function (item) {
                    if (item.themeClassifies && !item.cancelled && item.paid) {
                        item.themeClassifies.forEach(function (themeClassifie) {
                            var _not = true;
                            for(var i=0; i<vm.modelTab.length; i++){
                                if(themeClassifie.id == vm.modelTab[i].id){
                                    _not = false;
                                    break
                                }
                            }
                            if(_not){
                                vm.modelTab.push(themeClassifie)
                            }
                        })
                    }
                })
                tempInfo(vm.modelTab[0])
            })
        }
        function tempInfo(item){
            vm.temps=[];
            vm.productXmlThemeId=item.id;
            vm.tempList.forEach(function (data) {
                if(!vm.productXmlThemeId){
                    vm.temps.push(data)
                }else{
                    var _not = false;
                    data.themeClassifies.forEach(function (themeClassifie) {
                        if(themeClassifie.id == vm.productXmlThemeId){
                            _not = true;
                        }
                    })
                    if(_not){
                        vm.temps.push(data)
                    }
                }
            })
            vm.temps.sort(sortNavTitle("seq"));
        }
        function sortNavTitle(propertyName) {
            return function(object1, object2) {
                var value1 = object1[propertyName];
                var value2 = object2[propertyName];
                return value1 - value2;
            }
        }


        vm.imgs = [];
        var templateSwiper = null;
        $scope.templateCb = function (temp) {
            if (vm.article.productXmlId == temp.productXmlId) {
                vm.threeIsModal1 = true;
                vm.threeModalText1 = $translate.instant("editorCommon.alreadyExistTemplate");
                return
            }
            vm.xmlShowPic = true;
            $scope.chooseTemp = temp;
            ProductXml.get({id: temp.productXmlId}, function (res) {
                if (res.data.documentPics && res.data.documentPics.length > 0) {
                    res.data.documentPics.sort(function (a, b) {
                        return a.seq - b.seq;
                    });
                }
                vm.imgs = res.data.documentPics;
                if(vm.imgs.length > 0){
                    $timeout(function () {
                        templateSwiperInit();
                        templateSwiper.init();//现在才初始化
                    },200)
                }
            }, function () {

            })
        }
        function templateSwiperInit() {
            templateSwiper = new Swiper ('.swiper-template-view-content', {
                // 如果需要前进后退按钮
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                }
            })
        }

        var inits = 0, num = 0;
        $scope.previewClose = function () {
            vm.xmlShowPic = false;
        };
        $scope.changeAllTemp = function () {
            vm.threeIsModal = true;
            vm.threeModalText = $translate.instant("editorCommon.whetherReplaceTemplate");
        }

        function templateReplace() {
            if(vm.isEdit){
                vm.threeLoading = true;
                vm.pageData.forEach(function (page) {
                    if(page.levels.level){
                        page.levels.level.forEach(function (level) {
                            if (level.imagebox && level.imagebox.image && level.imagebox.image.resource && level.imagebox.image.resource.identifier) {
                                vm.photoSelectAll.push({
                                    height: level.imagebox.image.resource.height,
                                    id: level.imagebox.image.resourceid,
                                    imageInfo: level.imagebox.image.imageInfo,
                                    identifier: level.imagebox.image.resource.identifier.indexOf('http') > -1 ? level.imagebox.image.resource.identifier.substring(level.imagebox.image.resource.identifier.lastIndexOf('/')+1) : level.imagebox.image.resource.identifier,
                                    imgsize: level.imagebox.image.imgsize,
                                    name: null,
                                    provider: "qiniu",
                                    usenum: 1,
                                    width: level.imagebox.image.resource.width
                                });
                            }
                        })
                    }
                })
                Convert.xmlToDocument2({
                    identifier: $scope.chooseTemp.productXmlIdentifier,
                    provider: "qiniu",
                    editorType:vm.article.editorType,
                    patternType:vm.product.patternType,
                }, function (res) {
                    if($scope.template && $scope.template.config && res.config){
                        res.config.startYear = $scope.template.config.startYear;
                        res.config.startMonth = $scope.template.config.startMonth;
                    }
                    vm.article.document = res;
                    vm.replace = res.replace;

                    angular.forEach(vm.article.document.pages.page, function (page, i) {
                        if(!page.backup){
                            angular.forEach(page.levels.level, function (level) {
                                if (level.imagebox && level.imagebox.geometry) {
                                    vm.counts++;
                                }
                            })
                        }
                    });

                    vm.productXmlLine = angular.copy($scope.chooseTemp);
                    vm.modelBlendentUuid=vm.productXmlLine.modelBlendentUuid;
                    vm.article.modelBlendentUuid= vm.productXmlLine.modelBlendentUuid;
                    vm.article.cover= vm.productXmlLine.coverImg;
                    vm.article.themeClassifyId= vm.productXmlLine.productXmlThemeId;
                    vm.article.themeClassifyName= vm.productXmlLine.productXmlThemeName;
                    vm.article.productXmlId= vm.productXmlLine.productXmlId;
                    vm.article.productXmlName= vm.productXmlLine.productXmlName;
                    vm.article.productXmlLineId= vm.productXmlLine.id;
                    if(vm.productXmlLine && vm.productXmlLine.musicIdentify){
                        vm.article.musicIdentify= vm.productXmlLine.musicIdentify;
                    }
                    $scope.savePage4Return();
                    vm.editProductXml = true;
                    vm.reservePage=[];
                    abook();
                    $scope.previewClose();
                    vm.threeLoading = false;
                });
            }else{
                localStorage.setItem("templateEdit", 'true');
                // window.location.href = vm.platformSetting.editorNotifyUrl+'/#/'+vm.storeId+'/'+vm.pid+'/'+vm.vid+'/'+$scope.chooseTemp.id+'/'+vm.aid+'/editorPhotoAlbum';
                $state.go('editorPhotoAlbumM', {storeId: vm.storeId, pid: vm.pid, vid: vm.vid, xmlId: $scope.chooseTemp.id, aid: vm.aid},{location: 'replace'});
                // window.location.reload();
                localStorage.setItem("photoSelectAll", JSON.stringify(vm.photoSelectAll));
            }
        }

        /*******************************************点击图片库*************************************************************************/
        vm.mapDepot = false;
        $scope.photoGalleryShow = function () {
            vm.mapDepot = true;
            vm.mapDepot1 = true;
            vm.mapDepot2 = false;
            updatePic()
            ratioInfo(vm.pageData[vm.pageIndex])
            photoSelectAllInit(true)
        }
        $scope.photoGalleryHide = function () {
            vm.mapDepot = false;
            ratioInfo(vm.pageData[vm.pageIndex])
        }
        $('#photoGallery').on('scroll', function(event){
            var realScrollHeight=event.currentTarget.clientHeight+event.currentTarget.scrollTop;
            if(!vm.photoCompleted){
                if((event.currentTarget.scrollHeight-1)<realScrollHeight && realScrollHeight < (event.currentTarget.scrollHeight+1)){
                    vm.indexNum++
                    loadAll("isNull")
                }
            }
        })


        /*******************************************素材处理*************************************************************************/
        $scope.makeBody = vm.makeBody = function (event) {
            $timeout(function () {
                vm.levelIndex = null;
                vm.levelType = null;
                vm.isImageboxSelectItem = false;
                vm.textStyleShow = false;
                vm.textboxSelect = false;
                vm.filterShow = false;
                if(vm.mapDepot || vm.isMaterial || vm.istemplate || vm.islayout){
                    vm.istemplate = false;
                    vm.isMaterial = false;
                    vm.mapDepot = false;
                    vm.islayout = false;
                    ratioInfo(vm.pageData[vm.pageIndex]);
                }else {
                    vm.istemplate = false;
                    vm.isMaterial = false;
                    vm.mapDepot = false;
                    vm.islayout = false;
                }
            })
            fn(event)
        }
        vm.levelDome = function(item){
            vm.isImageboxSelectItem = false;
            vm.filterShow = false;
            vm.textStyleShow = false;
            vm.istemplate = false;
            vm.isMaterial = false;
            vm.textboxSelect = false;
            vm.mapDepot = false;
            vm.isAddImagebox = false;
            vm.islayout = false;
            if(item){
                vm[item] = true;
            }
        }

        vm.isMaterial = false;
        $scope.materialShow = function () {
            vm.isMaterial = true;
            vm.materialPage = 0;
            vm.materialSum = 20;
            vm.materialData = [];
            //分类
            ThemeClassify.getAllByCondition4({type: 'ClipArt',storeId:vm.storeId}, function (res) {
                vm.classify = [];
                if($scope.template.cliparts && $scope.template.cliparts.clipart && $scope.template.cliparts.clipart.length>0){
                    vm.classify = [{
                        id: "",
                        name: $translate.instant("editorCommon.recommend"),
                        seq: 0,
                        type: "CLIPART",
                        used: true
                    }]
                }
                if(!res.data){res.data=[]}
                res.data.forEach(function (item) {
                    vm.classify.push(item)
                })
                vm.classifyW = res.data.length * 86;
                if(vm.classify && vm.classify.length>0){
                    initMaterial(vm.classify[0].id)
                }
            });
            ratioInfo(vm.pageData[vm.pageIndex])
        }
        $scope.classifyCb = function (item) {
            vm.materialPage = 0;
            vm.materialData = [];
            initMaterial(item.id)
        }
        //获取素材
        vm.isMaterial1 = false;

        function initMaterial(id) {
            vm.classifyId = id;
            if(id){
                ClipArt.byCondition3({
                    items: [
                        {key: "themeClassify.id", op: "=", value: id}],
                    page: vm.materialPage,
                    size: vm.materialSum,
                    sort: ["seq,asc"]
                }, function (res) {
                    angular.forEach(res.data, function (resp) {
                        var arr = {
                            name: resp.name,
                            identifier: $scope.domain + resp.identifier,
                            provider: resp.provider,
                            themeClassifyName: resp.themeClassifyName,
                            themeClassifyId: resp.themeClassifyId,
                            resource: {
                                identifier: $scope.domain + resp.identifier,
                                provider: resp.provider
                            }
                        }
                        vm.materialData.push(arr);
                    })
                    vm.materialW = vm.materialData.length * 90 + 20;
                    if (res.data.length < vm.materialSum) {
                        vm.isMaterial1 = true;
                    }else {
                        vm.isMaterial1 = false;
                    }
                });
            }else{
                $scope.template.cliparts.clipart.forEach(function (clipart) {
                    var arr = {
                        name: "",
                        identifier: clipart.resource.identifier,
                        provider: "",
                        themeClassifyName: $translate.instant("editorCommon.recommend"),
                        themeClassifyId: "",
                        resource: clipart.resource
                    }
                    vm.materialData.push(arr);
                })
                vm.materialW = vm.materialData.length * 90 + 20;
                vm.isMaterial1 = true;
            }
        }
        $('#materialView').on('scroll', function(event){
            var realScrollHeight=event.currentTarget.clientHeight+event.currentTarget.scrollTop;
            if(!vm.isMaterial1){
                if((event.currentTarget.scrollHeight-1)<realScrollHeight && realScrollHeight < (event.currentTarget.scrollHeight+1)){
                    vm.materialPage++;
                    initMaterial(vm.classifyId)
                }
            }
        })
        $scope.materialHide = function () {
            vm.isMaterial = false;
            ratioInfo(vm.pageData[vm.pageIndex])
        }

        //添加素材
        vm.repeatAddNumber = 0;
        $scope.addImageart = function (item){
            vm.threeLoading = true;
            vm.threeLoadingText=$translate.instant("hint.loadingText");
            imageartAdd($http, item.resource.identifier, vm.pageData[vm.pageIndex].trimbox, function(imageart){
                if(vm.repeatAddNumber>4){
                    vm.repeatAddNumber = 0;
                }
                var _num = 10*vm.repeatAddNumber;
                imageart.geometry.x += _num/vm.pageData[vm.pageIndex].custom.ratio1;
                imageart.geometry.y += _num/vm.pageData[vm.pageIndex].custom.ratio1;
                var _level = {
                    seq: vm.pageData[vm.pageIndex].levels.level.length + 1,
                    imageart: imageart
                }
                vm.pageData[vm.pageIndex].levels.level.push(_level);
                vm.threeLoading = false;
                vm.repeatAddNumber++;
            }, vm.pageData[vm.pageIndex].custom.ratio1)
        }
        $scope.savePage4 = function(){
            // vm.pageData = angular.copy($scope.template.pages.page);
            $scope.template.pages.page = vm.pageData;
            vm.page4 = false;
            vm.page3 = true;
        }
        $scope.savePage4Return = function(){
            vm.page4 = false;
            vm.page3 = true;
        }
        /*******************************************文字处理*************************************************************************/
        $scope.colorList = ['#ff001e', '#ff5c00', '#ff9700', '#61734d', '#838c97', '#8d4ac8', '#b8e986', '#7e6565', '#ffffff', '#f1e7d9', '#b5ce99', '#82c281', '#dac2ef', '#000', '#797979', '#7c330a', '#eec78d', '#444444', '#589ceb', '#4a7bc8', '#ddabab'];
        $scope.selectedColor = $scope.colorList[0];

        vm.textboxSelect = false;
        vm.textStyleTab = [
            {name: $translate.instant("font.textStyleTabFont"), id: 'textStyleTabFont'},
            {name: $translate.instant("font.textStyleTabSize"), id: 'textStyleTabSize'},
            {name: $translate.instant("font.textStyleTabType"), id: 'textStyleTabType'},
            {name: $translate.instant("font.textStyleTabColor"), id: 'textStyleTabColor'},
        ];
        vm.textStyleItem = 'textStyleTabFont';
        //添加文字
        $scope.fontShow = function () {
            vm.page5 = true;
            vm.fontTab = 'fontColor';
            $scope.selectedColor = $scope.colorList[0];

            // var _level ={
            //     seq: vm.pageData[vm.pageIndex].levels.level.length+1,
            //     textbox: textbox
            // }
            vm.fontData = {
                seq: vm.pageData[vm.pageIndex].levels.level.length + 1,
                textbox: {
                    type: 'add',
                    geometry: {
                        x: '0',
                        y: '0',
                        width: 100,
                        height: 20
                    },
                    rotation: {
                        angle: '0'
                    },
                    text: '',
                    style: {
                        font: "",
                        size: 20,
                        color: $scope.selectedColor,
                        bold: false,
                        italic: false,
                        lineheight: 20,
                        letterspacing: 0,
                        align: 'left',
                        writingmode:'horizontal-tb'
                    },
                    fontuuid: vm.fontItem.uuid,
                    identifier: "",
                    editable: true,
                    movable: true,
                    lock: false,
                    version: '2.0',
                    transparency: 1,
                    useradded: true
                }
            }
            var _fontStyle = [];
            for (var j = 0; j < vm.fontList[0].fontStyles.length; j++) {
                _fontStyle.push(vm.fontList[0].fontStyles[j].style)
            }
            if (_fontStyle.indexOf('NORMAL') != '-1') {
                vm.fontData.textbox.style.bold = false;
                vm.fontData.textbox.style.italic = false;
            } else {
                if (_fontStyle.indexOf('BOLD_ITALIC') != '-1') {
                    vm.fontData.textbox.style.bold = true;
                    vm.fontData.textbox.style.italic = true;
                } else {
                    if (_fontStyle.indexOf('ITALIC') != '-1') {
                        vm.fontData.textbox.style.italic = true;
                        vm.fontData.textbox.style.bold = false;
                    }
                    if (_fontStyle.indexOf('BOLD') != '-1') {
                        vm.fontData.textbox.style.bold = true;
                        vm.fontData.textbox.style.italic = false;
                    }
                }
            }
            vm.text = '';
            $timeout(function () {
                $('textarea.three-font-body-input').focus()
            },100);
        };

        //切换字体
        $scope.updateTextFont = function (data) {
            if (data == undefined) {
                threeInfo($translate.instant("font.failedAddText"));
                return
            }
            if (!data.enable) {
                threeInfo($translate.instant("font.fontChange"));
                return
            }
            var text = JSON.parse(JSON.stringify(vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox));
            vm.fontStyle = [];
            for (var i = 0; i < vm.fontList.length; i++) {
                if (vm.fontList[i].uuid == data.uuid) {
                    for (var j = 0; j < vm.fontList[i].fontStyles.length; j++) {
                        vm.fontStyle.push(vm.fontList[i].fontStyles[j].style)
                    }
                }
            }
            text.style.bold = false;
            text.style.italic = false;
            if (vm.fontStyle.indexOf('NORMAL') != '-1') {
                text.style.bold = false;
                text.style.italic = false;
            } else {
                if (vm.fontStyle.indexOf('BOLD_ITALIC') != '-1') {
                    text.style.bold = true;
                    text.style.italic = true;
                } else {
                    if (vm.fontStyle.indexOf('ITALIC') != '-1') {
                        text.style.italic = true;
                    }
                    if (vm.fontStyle.indexOf('BOLD') != '-1') {
                        text.style.bold = true;
                    }
                }
            }
            text.style.font = data.family;
            text.fontuuid = data.uuid;
            text.identifier = $scope.domain + data.fontStyles[0].identifier;
            vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.loading = true;
            FontSupport2(FontManagement, text, function (res) {
                var msg = res.data;
                if (res.status == 200) {
                    if (!msg.success || msg.failed) {
                        MessageService.minConfirm({
                            confirm:$translate.instant("button.returnCorrection"),
                            msg:$translate.instant("font.pleaseChangeFonts1") +
                                    '<span class="theme-color">'+msg.failed+'</span>' + $translate.instant("font.pleaseChangeFonts2")
                        })
                    }else {
                        vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox = text;
                        getFontCSS(FontManagement, vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox, $scope);
                        $timeout(function () {
                            sizeHeight();
                            fontStyle(data.uuid);
                        })
                    }
                }
                vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.loading = false;
            })
        };

        function fontStyle(fontuuid) {
            var text = vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox;
            vm.fontStyle = [];
            for (var i = 0; i < vm.fontList.length; i++) {
                if (vm.fontList[i].uuid == fontuuid) {
                    for (var j = 0; j < vm.fontList[i].fontStyles.length; j++) {
                        vm.fontStyle.push(vm.fontList[i].fontStyles[j].style)
                    }
                }
            }
            text.style.bold1 = false;
            text.style.italic1 = false;
            if (vm.fontStyle.indexOf('NORMAL') == '-1') {
                text.style.normal = false;
            } else {
                text.style.normal = true;
            }
            if (vm.fontStyle.indexOf('BOLD_ITALIC') != '-1') {
                text.style.bold1 = true;
                text.style.italic1 = true;
            } else {
                if (vm.fontStyle.indexOf('ITALIC') != '-1') {
                    text.style.italic1 = true;
                }
                if (vm.fontStyle.indexOf('BOLD') != '-1') {
                    text.style.bold1 = true;
                }
            }
        }

        window.densityInput = function (e) {
            var val = $('#rangeChange').val();
            if (vm.pageData[vm.pageIndex].levels.level[vm.levelIndex] && vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox) {
                vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.size = parseInt(val);
                vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.lineheight = parseInt(val);
            }

            var currentPage = vm.pageData[vm.pageIndex].levels.level;
            var item = currentPage[vm.levelIndex].textbox;

            if (item.geometry.width < parseInt(item.style.size)) {
                item.geometry.width = (Number(parseInt(item.style.size)) + Number(5));
            }
            if (item.geometry.width > vm.pageData[vm.pageIndex].editbox.width) {
                item.geometry.width = vm.pageData[vm.pageIndex].editbox.width;
                // item.geometry.x = 0;
            }
            sizeHeight();
            $scope.$digest();
        }
        window.textStyleTransparency = function (e) {
            var val = $('#textStyleTransparency').val();
            if (vm.pageData[vm.pageIndex].levels.level[vm.levelIndex] && vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox) {
                vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.transparency = parseInt(val) / 100;
                vm.transparency = parseInt(val);
            }
        }
        //斜体
        $scope.operationItalic = function () {
            var text = vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox;
            if (vm.fontStyle.indexOf('NORMAL') != '-1') {
                text.style.italic = !text.style.italic;
                $timeout(function () {
                    sizeHeight();
                }, 200)
            } else {
                if (vm.fontStyle.indexOf('BOLD_ITALIC') != '-1' || vm.fontStyle.indexOf('BOLD') != '-1') {
                    if (text.style.bold) {
                        text.style.italic = !text.style.italic;
                        $timeout(function () {
                            sizeHeight();
                        }, 200)
                    }
                }
            }
        }
        //粗体
        $scope.operationBold = function () {
            var text = vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox;
            if (vm.fontStyle.indexOf('NORMAL') != '-1') {
                text.style.bold = !text.style.bold;
                $timeout(function () {
                    sizeHeight();
                }, 200)
            } else {
                if (vm.fontStyle.indexOf('BOLD_ITALIC') != '-1' || vm.fontStyle.indexOf('ITALIC') != '-1') {
                    if (text.style.italic) {
                        text.style.bold = !text.style.bold;
                        $timeout(function () {
                            sizeHeight();
                        }, 200)
                    }
                }
            }
        }
        $scope.operationBarDir = function (item) {
            var text = vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox;
            text.style.align = item;
        };
        $scope.fontColorCb = function (item) {
            var text = vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox;
            text.style.color = item;
        }
        //获取所有字体
        vm.fontList = [];
        vm.fontItem = null;
        getAllFont();

        function getAllFont() {
            vm.fontList = [];
            vm.fontItem = null;
            FontManagement.getAll({}, function (res) {
                vm.fontList = res;
                if(vm.fontList && vm.fontList.length>0){
                    vm.fontItem = vm.fontList[0];
                    vm.fontList.forEach(function (item){
                        if(item.defaultShow){
                            vm.fontItem = item;
                        }
                    })
                }
            });
        }

        //判断是ios or Android
        var u = navigator.userAgent;
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

        var textFlag = true;
        var inputEle = document.getElementById('three-font-body-input');

        // 兼容安卓文字输入（首行空格不显示bug）
        $scope.changeText = function (e) {
            if (isAndroid == true && isiOS == false) {
                fn(e);
                var targ = e.currentTarget ? e.currentTarget : e.srcElement;
                vm.text = vm.fontData.textbox.text = targ.value;
            }
        }

        /**
         * 兼容iOS文字输入
         */
        inputEle.addEventListener('compositionstart', function () {
            textFlag = false;
        });
        inputEle.addEventListener('compositionend', function (event) {
            textFlag = true;
            // compositionend 事件发生在 input 之后，故此需要此处调用 input 中逻辑
            if (isAndroid == false && isiOS == true) {
                vm.text = event.target.value;
            }
        });
        inputEle.addEventListener('input', function (event) {
            // 忽略一切非直接输入，不做逻辑处理
            if (textFlag) {
                if (isAndroid == false && isiOS == true) {
                    vm.text = event.target.value;
                }
            };
        });

        $scope.savePage5 = function () {
            if (!vm.fontData.textbox.text) {
                vm.page4 = true;
                vm.page5 = false;
                return
            }
            if(vm.text){
                vm.fontData.textbox.text =  vm.text;
            }
            FontSupport2(FontManagement, vm.fontData.textbox, function (res) {
                var msg = res.data;
                if (res.status == 200) {
                    if (!msg.success || msg.failed) {
                        MessageService.minConfirm({
                            confirm:$translate.instant("button.returnCorrection"),
                            msg:$translate.instant("font.pleaseChangeFonts1") +
                                    '<span class="theme-color">'+msg.failed+'</span>' + $translate.instant("font.pleaseChangeFonts2")
                        })
                    } else {
                        vm.page4 = true;
                        vm.page5 = false;
                        vm.fontData.textbox.style.color = $scope.selectedColor;
                        if (vm.fontData.textbox.type == 'add') {
                            vm.fontData.textbox.geometry.width = Number($("#c-xml-page-material-fontId").width()) + Number(10);
                            vm.fontData.textbox.geometry.x = (vm.pageData[vm.pageIndex].editbox.width - vm.fontData.textbox.geometry.width) / 2 + vm.pageData[vm.pageIndex].editbox.x;
                            vm.fontData.textbox.geometry.y = (vm.pageData[vm.pageIndex].editbox.height - vm.fontData.textbox.geometry.height) / 2 + vm.pageData[vm.pageIndex].editbox.y;
                            vm.pageData[vm.pageIndex].levels.level.push(vm.fontData)
                            vm.levelIndex = vm.pageData[vm.pageIndex].levels.level.length-1;
                        }
                        if (vm.fontData.textbox.type == 'edit') {
                            vm.pageData[vm.pageIndex].levels.level[vm.levelIndex] = vm.fontData;
                        }
                        sizeHeight1()
                    }
                }
            })
        };
        //删除文字
        $scope.deleteTextbox = function (e) {
            fn(e)
            if (vm.pageData[vm.pageIndex].levels.level[vm.levelIndex] && vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox) {
                vm.pageData[vm.pageIndex].levels.level.splice(vm.levelIndex, 1);
                vm.levelIndex = null;
                vm.levelType = null;
                $scope.makeBody();
            }
        }
        $scope.editTextbox = function (e, index, item) {
            fn(e)
            vm.page5 = true;
            vm.fontData = vm.pageData[vm.pageIndex].levels.level[vm.levelIndex];
            vm.fontData.textbox.type = 'edit';
            $scope.selectedColor = vm.fontData.textbox.style.color;
            vm.fontTab = 'fontColor';
            vm.text = vm.fontData.textbox.text;
            $timeout(function () {
                $('textarea.three-font-body-input').focus()
            },100);
        }
        //文字样式
        $scope.textStyleTextbox = function () {
            vm.textStyleShow = true;
        }
        function sizeHeight() {
            if(vm.pageData[vm.pageIndex] && vm.pageData[vm.pageIndex].levels && vm.pageData[vm.pageIndex].levels.level && vm.pageData[vm.pageIndex].levels.level[vm.levelIndex] && vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox){
                getTextHeight(vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox, $scope)
            }
        }
        vm.sizeHeight1 = sizeHeight1;
        function sizeHeight1() {
            if(vm.pageData[vm.pageIndex] && vm.pageData[vm.pageIndex].levels && vm.pageData[vm.pageIndex].levels.level && vm.pageData[vm.pageIndex].levels.level[vm.levelIndex] && vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox){
                getTextHeight(vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox, $scope)
            }
        }
        //字体样式
        $scope.textStyleTabCb = function (item) {
            vm.textStyleItem = item.id;
        }
        $scope.textStyleHide = function () {
            vm.textStyleShow = false;
        }
        /*******************************************照片框处理*************************************************************************/
        //展开
        vm.isModeOut = false;
        $scope.modeIn = function () {
            var _imagebox = vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox;
            if (_imagebox.bokehtype != 'None') {
                if (_imagebox.image && _imagebox.image.resource.identifier) {
                    imageboxModeIn(_imagebox, function (imagebox) {
                        vm.isModeOut = true;
                    })
                }
            }
        };
        //缩放
        $scope.modeOut = function () {
            var _imagebox = vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox;
            if (_imagebox.bokehtype == 'None') {
                if (_imagebox.image && _imagebox.image.resource.identifier) {
                    imageboxModeOut(_imagebox, function (imagebox) {
                        vm.isModeOut = false;
                        getBackgroundSource3(_imagebox, _imagebox.geometry.width, _imagebox.geometry.height, _imagebox.image, _imagebox.bokehtypes, $scope);
                    })
                }
            }
        };

        $scope.cropImageboxMassive = function () {
            imageboxMassive(vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox);
        }
        $scope.cropImageboxMin = function () {
            imageboxMin(vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox);
        }
        $scope.cropImageboxRotate = function (flag) {
            imageboxRotate($scope, vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox, flag);
        }
        $scope.cropImagRestore = function () {
            imagRestore($scope, vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox, $http);
        }
        $scope.overturnImagebox = function () {
            imageboxOverturn(vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox);
        };

        vm.filterShow = false;
        vm.filterType='';
        vm.filterList=[
            {img:'content/images/filter1.png',type:''},
            {img:'content/images/filter2.png',type:'selfie_anime'},
            {img:'content/images/filter3.png',type:'wave'},
            {img:'content/images/filter4.png',type:'warm'},
            {img:'content/images/filter5.png',type:'scream'},
            {img:'content/images/filter6.png',type:'gothic'},
            {img:'content/images/filter7.png',type:'lavender'},
        ];
        $scope.filterCb = function(item){
            if(!vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox || !vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image || !vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.resource.identifier){
                return;
            }
            vm.threeLoading = true;
            vm.threeLoadingText = $translate.instant("hint.loadingText");
            var _imagebox = vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox;
            if(_imagebox.image.resourceid){
                Gallery.getOne({id:_imagebox.image.resourceid},function (res) {
                    // if(res.imgSize / 1024 > 1024*4){
                    //     threeInfo("图片不能大于4M")
                    //     vm.threeLoading = false;
                    //     vm.threeLoadingText = '';
                    //     return
                    // }
                    var _identifier = $scope.domain + res.identifier;
                    if(!item.type){
                        vm.filterType=item.type;
                        vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.resource.identifier = _identifier;
                        vm.threeLoading = false;
                        vm.threeLoadingText = '';
                    }else {
                        Convert.imageEnhance({
                            imageUrl: _identifier,
                            type: item.type
                        }, function (resp) {
                            if(resp.status == 200){
                                vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.resource.identifier = $scope.domain + resp.message;
                                vm.filterType=item.type;
                            }else{
                                threeInfo(resp.message)
                            }
                            vm.threeLoading = false;
                            vm.threeLoadingText = '';
                        }, function () {
                            vm.threeLoading = false;
                            vm.threeLoadingText = '';
                            threeInfo($translate.instant("editorCommon.loadError"))
                        });
                    }
                }, function () {
                    vm.threeLoading = false;
                    vm.threeLoadingText = '';
                    threeInfo($translate.instant("editorCommon.loadError"))
                })
            }else {
                if(!_imagebox.image.resource.identifier1){
                    _imagebox.image.resource.identifier1 = angular.copy(_imagebox.image.resource.identifier);
                }
                if(!item.type){
                    vm.filterType=item.type;
                    vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.resource.identifier = _imagebox.image.resource.identifier1;
                    vm.threeLoading = false;
                    vm.threeLoadingText = '';
                }else {
                    Convert.imageEnhance({
                        imageUrl: _imagebox.image.resource.identifier1,
                        type: item.type
                    }, function (resp) {
                        if(resp.status == 200){
                            vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.resource.identifier = $scope.domain + resp.message;
                            vm.filterType=item.type;
                        }else{
                            threeInfo(resp.message)
                        }
                        vm.threeLoading = false;
                        vm.threeLoadingText = '';
                    }, function () {
                        vm.threeLoading = false;
                        vm.threeLoadingText = '';
                        threeInfo($translate.instant("editorCommon.loadError"))
                    });
                }
            }
        };
        function threeInfo(item){
            vm.threeError = true;
            vm.threeErrorText=item;
            $timeout(function () {
                vm.threeError = false;
                vm.threeErrorText="";
            },1500)
        }
        function threeInfo1(item){
            vm.threeError1 = true;
            vm.threeErrorText1=item;
            $timeout(function () {
                vm.threeError1 = false;
                vm.threeErrorText1="";
            },1500)
        }
        $scope.cutImage = function () {
            $timeout(function () {
                vm.filterShow = true;
            })
        };
        $scope.filterChoose = function (item) {
            switch (item) {
                case 'selfie_anime':
                    return $translate.instant("editorBtn.selfieAnime");
                    break;
                case 'warm':
                    return $translate.instant("editorBtn.warm");
                    break;
                case 'wave':
                    return $translate.instant("editorBtn.wave");
                    break;
                case 'lavender':
                    return $translate.instant("editorBtn.lavender");
                    break;
                case 'scream':
                    return $translate.instant("editorBtn.scream");
                    break;
                case 'gothic':
                    return $translate.instant("editorBtn.gothic");
                    break;
                case 'body_seg':
                    return $translate.instant("editorBtn.bodySeg");
                    break;
                default:
                    return $translate.instant("editorBtn.originalPainting");
            }
        }

        var dragGal = {};
        var drag = false;
        var startChangeTimeout;
        vm.isSmallPic = false;
        window.startChange = function (e) {
            startChangeTimeout = setTimeout(function() {
                vm.isSmallPic = true;
                $scope.$digest();
            }, 200);
            drag = true;
            var i = e.target.dataset.imgindex;
            if(i >=0){
                if(vm.mapDepot1){
                    $scope.galleryArr = vm.photoSelectAll1[i];
                    $scope.galleryChoose = vm.photoSelectAll1[i].identifier;
                    if(vm.photoSelectAll1[i].largeFlag){
                        $scope.galleryChoose = vm.photoSelectAll1[i].identifier+'.thumbnail.jpg';
                    }
                }
                if(vm.mapDepot2){
                    $scope.galleryArr = vm.photoAll[i];
                    $scope.galleryChoose = vm.photoAll[i].identifier;
                    if(vm.photoAll[i].largeFlag){
                        $scope.galleryChoose = vm.photoAll[i].identifier+'.thumbnail.jpg';
                    }
                }

                $scope.galleryId = i;
                $scope.galleryX = e.changedTouches[0].clientX ? e.changedTouches[0].clientX - 53 : 0;
                $scope.galleryY = e.changedTouches[0].clientY ? e.changedTouches[0].clientY - 40 : 0;
                dragGal.clientX = e.changedTouches[0].clientX ? e.changedTouches[0].clientX : 0;
                dragGal.clientY = e.changedTouches[0].clientY ? e.changedTouches[0].clientY : 0;
                dragGal.pageX = e.changedTouches[0].pageX ? e.changedTouches[0].pageX : 0;
                dragGal.pageY = e.changedTouches[0].pageY ? e.changedTouches[0].pageY : 0;
                dragGal.coordX = $scope.galleryX;
                dragGal.coordY = $scope.galleryY;
                $scope.$digest();
                return false;
            }
        };

        window.dragChange = function (e) {
            clearTimeout(startChangeTimeout);
            if (drag) {
                //手指离开屏幕
                $scope.galleryX = (dragGal.coordX + (e.changedTouches[0].clientX - dragGal.clientX));
                $scope.galleryY = (dragGal.coordY + (e.changedTouches[0].clientY - dragGal.clientY));

                // if (Math.abs($scope.galleryY - dragGal.coordY) > 100) {
                //     vm.isSmallPic = true;
                // }


                //向上滑动;
                if ($scope.galleryY <= 0) {
                    $scope.galleryY = 0;
                }
                //向左滑动;        <-----
                if ($scope.galleryX <= 0) {
                    $scope.galleryX = 0;
                }
                //向下滑动;
                if ($scope.galleryY >= $scope.dHeight - 62) {
                    $scope.galleryY = $scope.dHeight - 62;
                }
                // 向右滑动;    ---->
                if ($scope.galleryX >= $scope.dWidth - 62) {
                    $scope.galleryX = $scope.dWidth - 62;
                }

                var _picTop = $("#small-pic").offset().top;
                var _picLeft = $("#small-pic").offset().left;
                var _exist = false;
                for (var i1 = vm.pageData[vm.pageIndex].levels.level.length-1; i1 >= 0; i1--) {
                    var _level = vm.pageData[vm.pageIndex].levels.level[i1];
                    if (_level.imagebox) {
                        var _imageboxLeft = $(".imagebox" + i1).offset().left;
                        var _imageboxTop = $(".imagebox" + i1).offset().top;
                        var _imageboxRight = _imageboxLeft + $(".imagebox" + i1).width();
                        var _imageboxBottom = _imageboxTop + $(".imagebox" + i1).height();
                        if ((_imageboxTop < _picTop) && (_picTop < _imageboxBottom) && (_imageboxLeft < _picLeft) && (_picLeft < _imageboxRight) && !_exist) {
                            _exist = true;
                            $(".imagebox" + i1).find(".imageboxHint").css("background", "rgba(103, 106, 108, 0.8)")
                            break;
                        }else{
                            $(".imagebox" + i1).find(".imageboxHint").css("background", "rgba(0,0,0,0.2)")
                        }
                    }
                }
                $scope.$digest();
                return false;
            }
        };
        window.stopChange = function (e) {
            clearTimeout(startChangeTimeout);
            if (!drag) {
                return
            }
            drag = false;
            var _picTop = $("#small-pic").offset().top;
            var _picLeft = $("#small-pic").offset().left;
            for (var i1 = vm.pageData[vm.pageIndex].levels.level.length-1; i1 >= 0; i1--) {
                var _level = vm.pageData[vm.pageIndex].levels.level[i1];
                if (_level.imagebox) {
                    var _imageboxLeft = $(".imagebox" + i1).offset().left;
                    var _imageboxTop = $(".imagebox" + i1).offset().top;
                    var _imageboxRight = _imageboxLeft + $(".imagebox" + i1).width();
                    var _imageboxBottom = _imageboxTop + $(".imagebox" + i1).height();
                    if ((_imageboxTop < _picTop) && (_picTop < _imageboxBottom) && (_imageboxLeft < _picLeft) && (_picLeft < _imageboxRight)) {
                        $scope.replaceImagebox1($scope.galleryArr, i1)
                        break;
                    }
                }
            }
            vm.isSmallPic = false;
            $scope.$digest();
        };


        $scope.addImageboxImg = function (item,callback) {
            if(vm.pageData[vm.pageIndex] && vm.pageData[vm.pageIndex].levels.level && vm.pageData[vm.pageIndex].levels.level[vm.levelIndex] && vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox){
                replaceImagebox(item,function () {
                    if(callback){callback()}
                })
            }else {
                for (var i = 0; i < vm.pageData[vm.pageIndex].levels.level.length; i++) {
                    var _level = vm.pageData[vm.pageIndex].levels.level[i];
                    if (_level.imagebox && _level.imagebox.image && !_level.imagebox.image.resource.identifier) {
                        vm.levelIndex = i;
                        replaceImagebox(item, function () {
                            vm.levelIndex = null;
                            if(callback){callback()}
                        });
                        break;
                    }
                }
            }
            console.log(vm.pageData[vm.pageIndex].levels.level);
        };

        vm.fullMap = false;
        vm.fullMap1 = false;
        vm.fullMap2 = false;
        vm.fullMapNumber = 0;
        $scope.fullMapSelection = vm.fullMapSelection = function(){
            vm.fullMapNumber = 0;
            if(vm.pageData[vm.pageIndex] && vm.pageData[vm.pageIndex].levels.level && vm.pageData[vm.pageIndex].levels.level[vm.levelIndex] && vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox){
                vm.fullMapNumber = 1;
            }else {
                for (var i = 0; i < vm.pageData[vm.pageIndex].levels.level.length; i++) {
                    var _level = vm.pageData[vm.pageIndex].levels.level[i];
                    if (_level.imagebox && _level.imagebox.image && !_level.imagebox.image.resource.identifier) {
                        vm.fullMapNumber++
                    }
                }
            }
            vm.photoSelectAll2 = angular.copy(vm.photoSelectAll) || [];
            console.log('vm.photoSelectAll',vm.photoSelectAll);
            vm.photoSelectAll = [];
            vm.fullMap = true;
            vm.page4 = false;
            vm.mapDepot = false;
            $scope.fullMapCb1();
            vm.ratioInfo(vm.pageData[vm.pageIndex]);
        };
        $scope.fullMapHide = function(){
            vm.page2 = false;
            vm.page9 = false;
            vm.fullMap = false;
            vm.fullMap1 = false;
            vm.fullMap2 = false;
            vm.page4 = true;
            var _photoSelectAll = vm.photoSelectAll;
            vm.photoSelectAll2.forEach(function (photoSelectAll2) {
                var _exist = false;
                for(var i=0; i<vm.photoSelectAll.length; i++){
                    if(vm.photoSelectAll[i].id == photoSelectAll2.id){
                        _exist = true;
                        break
                    }
                }
                if(!_exist){
                    _photoSelectAll.push(photoSelectAll2)
                }
            })
            vm.photoSelectAll = angular.copy(_photoSelectAll);
        };
        $scope.fullMapCb1 = function(){
            vm.fullMap1 = true;
            vm.fullMap2 = false;
            vm.page2 = false;
            vm.page9 = false;
            vm.photoSelectAll2.forEach(function (photoSelectAll2) {
                photoSelectAll2.selected = false;
                for(var i=0; i<vm.photoSelectAll.length; i++){
                    if(vm.photoSelectAll[i].id == photoSelectAll2.id){
                        photoSelectAll2.selected = true;
                        break
                    }
                }
            })
        }
        $scope.fullMapCb2 = function(){
            vm.fullMap1 = false;
            vm.fullMap2 = true;
            vm.page2 = true;
            vm.page9 = false;
            $scope.galleryNavSel('gallery');
        }
        $scope.replaceImagebox1 = function (data, index) {
            vm.levelIndex = index;
            replaceImagebox(data)
        }

        function replaceImagebox(data, callback) {
            var item = angular.copy(data);
            var _imagebox = vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox;
            var identifier = _imagebox.mask.resource.identifier;
            _imagebox.image = {
                resource: {
                    identifier: item.identifier,
                    provider: 'qiniu'
                },
                resourceid:item.sourceId,
                filterResource: {
                    identifier: '',
                    provider: 'qiniu'
                },
                imageInfo: item.imageInfo,
                width: item.width,
                height: item.height,
                imgSize: item.imgSize,
                index: item.seq,
                parameter: angular.fromJson(item.parameter),
                scale: 1,
                angle: 0,
                largeFlag: item.largeFlag,
                largeStatus: item.largeStatus,
                stripKey: item.stripKey
            }
            addImagebox($http, _imagebox, function () {
                data.selected = true;
                photoSelect(data.selected, data)
                photoSelectAllInit();
                if(callback){callback()}
            })
        }

        function photoSelectAllInit(isSort) {
            if(!vm.pageData){
                return
            }
            vm.photoSelectAll.forEach(function (item) {
                item.frequency = 0;
                for (var i = 0; i < vm.pageData.length; i++) {
                    var _page = vm.pageData[i];
                    if (_page.levels.level) {
                        for (var j = 0; j < _page.levels.level.length; j++) {
                            var _level = _page.levels.level[j];
                            if (_level.imagebox && _level.imagebox.image) {
                                if (_level.imagebox.image.resource && _level.imagebox.image.resource.identifier) {
                                    if(_level.imagebox.image.resourceid == item.sourceId){
                                        item.frequency++
                                    }
                                }
                            }
                        }
                    }
                }
            })
            vm.photoAll.forEach(function (item) {
                item.frequency = 0;
                for (var i = 0; i < vm.pageData.length; i++) {
                    var _page = vm.pageData[i];
                    if (_page.levels.level) {
                        for (var j = 0; j < _page.levels.level.length; j++) {
                            var _level = _page.levels.level[j];
                            if (_level.imagebox && _level.imagebox.image) {
                                if (_level.imagebox.image.resource && _level.imagebox.image.resource.identifier) {
                                    if(_level.imagebox.image.resourceid == item.sourceId){
                                        item.frequency++
                                    }
                                }
                            }
                        }
                    }
                }
            })
            if(isSort){
                vm.photoSelectAll1 = angular.copy(vm.photoSelectAll);
                vm.photoSelectAll1 = vm.photoSelectAll1.sort(sortNavTitle("frequency"));
            }else{
                if(vm.photoSelectAll1){
                    vm.photoSelectAll1.forEach(function (item) {
                        item.frequency = 0;
                        for (var i = 0; i < vm.pageData.length; i++) {
                            var _page = vm.pageData[i];
                            if (_page.levels.level) {
                                for (var j = 0; j < _page.levels.level.length; j++) {
                                    var _level = _page.levels.level[j];
                                    if (_level.imagebox && _level.imagebox.image) {
                                        if (_level.imagebox.image.resource && _level.imagebox.image.resource.identifier) {
                                            if(_level.imagebox.image.resourceid == item.sourceId){
                                                item.frequency++
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    })
                }
            }
        }


        //保存
        function articleOverdue(callback){
            Article.get({id: vm.article.id}, function (article) {
                if(article.data.fileName != vm.article.fileName){
                    MessageService.minConfirm({
                        cancel:$translate.instant("button.cancel"),
                        confirm:$translate.instant("button.refresh"),
                        msg:$translate.instant("hint.articleOverdue")
                    },function(){
                        $state.go("editorPhotoAlbumEditM", {storeId: vm.storeId, aid:  vm.article.id},{reload:true,location: 'replace'});
                    })
                }else{
                    callback();
                }
            })
        }
        $scope.isSave = false;
        vm.isDocumentTextDetection = false;
        $scope.save = function () {
            articleOverdue(function () {
                if ($scope.isSave) {
                    return;
                }
                var _documentTextDetection = documentTextDetection1($scope.template.pages.page);
                if(!_documentTextDetection.pass){
                    vm.isDocumentTextDetection = true;
                    vm.documentTextDetection = _documentTextDetection.pages;
                    return;
                }
                if(!vm.isPageWarnExamine && pageWarnExamine($scope.template.pages.page, vm.imgSize, vm.imgDpi)){
                    SweetAlert.swal({
                        title: $translate.instant("editorCommon.hint"),
                        imageUrl: Theme.sweetHintImg(),
                        text: $translate.instant("editorCommon.lackPixelsMessage"),
                        showCancelButton: true,
                        confirmButtonText: $translate.instant("button.confirm"),
                        cancelButtonText: $translate.instant("button.cancel"),
                        closeOnConfirm: true,
                        closeOnCancel: true
                    }, function (isConfirm) {
                        if (isConfirm) {
                            vm.isPageWarnExamine = true;
                            $timeout(function () {
                                $scope.save();
                            },200)
                        }
                    })
                    return
                }
                vm.isPageWarnExamine = false;
                if ($scope.template.pages.page.length < $scope.PAGELEN) {
                    SweetAlert.swal({
                        title: $translate.instant("hint.loadingText"),
                        imageUrl: Theme.sweetHintImg(),
                        text: "",
                        timer: 2000,
                        showConfirmButton: false
                    });
                    return
                }

                if (vm.article.ordered) {
                    SweetAlert.swal({
                        title: $translate.instant("font.warmPrompt"),
                        imageUrl: Theme.sweetHintImg(),
                        text: $translate.instant("editorCommon.newWork"),
                        timer: 2000,
                        showConfirmButton: false
                    });
                }
                //判断是否有图片未上传  且是否继续保存
                if (!$scope.isContinue()) {
                    // vm.completed = false;
                    SweetAlert.swal({
                        title: $translate.instant("editorCommon.saveSure"),
                        imageUrl: Theme.sweetHintImg(),
                        showCancelButton: true,
                        confirmButtonText: $translate.instant("button.confirm"),
                        cancelButtonText: $translate.instant("button.cancel"),
                        closeOnConfirm: true,
                        closeOnCancel: true
                    }, function (isConfirm) {
                        if (isConfirm) {
                            $timeout(function () {
                                generateJsonFile();
                            }, 500);
                            return;
                        }
                    })
                } else {
                    // vm.completed = true;
                    generateJsonFile();
                }
            })
        }
        function generateJsonFile() {
            vm.threeLoading = true;
            vm.threeLoadingText=$translate.instant("hint.loadingText");
            thumbnailInit(function (res){
                generateJsonFile1()
            })
        }
        var generateJsonFile1 = function (){
            $scope.isSave = true;
            vm.threeLoading = true;
            vm.threeLoadingText=$translate.instant("hint.loadingText");
            var template = saveData();
            template.hostinfo = hostInfo();
            template.replace= vm.replace;
            Convert.articleUploadDocument(template, function (res) {
                vm.article.articleStatus = vm.completed;
                vm.article.fileName = res.data.identifier;
                vm.article.id = vm.aid;
                vm.article.pageCount = $scope.template.pages.page.length;
                vm.article.saveUserName = localStorage.getItem('saveUserName') || ''
                Article.update(vm.article, function (resp) {
                    $scope.isSave = true;
                    vm.threeLoading = false;
                    vm.threeLoadingText = '';
                    $scope.isSave = false;
                    swal({
                        title: $translate.instant("editorCommon.modifySuccess"),
                        text: $translate.instant("editorCommon.synchronizationOfWorks"),
                        imageUrl: Theme.sweetSuccedImg(),
                        timer: 2000,
                        showConfirmButton: false
                    });
                    $state.go("product-view-ec", {storeId: vm.storeId, aid: resp.data.id},{location: 'replace'});
                }, function () {
                    $scope.isSave = false;
                    vm.threeLoading = false;
                    vm.threeLoadingText = '';
                    swal({
                        title: $translate.instant("editorCommon.saveError"),
                        text: $translate.instant("editorCommon.saveError1"),
                        imageUrl: Theme.sweetHintImg(),
                        timer: 2000,
                        showConfirmButton: false
                    });
                })
            }, function () {
                $scope.isSave = false;
                vm.threeLoading = false;
                vm.threeLoadingText = '';
                swal({
                    title: $translate.instant("editorCommon.saveError"),
                    text: $translate.instant("editorCommon.saveError1"),
                    imageUrl: Theme.sweetHintImg(),
                    timer: 2000,
                    showConfirmButton: false
                });
            })
            localStorage.removeItem("photoSelectAll");
        }

        $scope.isContinue = function () {
            var hasEmpty = true;
            vm.unFilledCount = 0;
            for (var i = 0; i < $scope.template.pages.page.length; i++) {
                var _page = $scope.template.pages.page[i];
                if (_page.levels.level) {
                    for (var j = 0; j < _page.levels.level.length; j++) {
                        var _level = _page.levels.level[j];
                        if (_level.imagebox) {
                            if (!_level.imagebox.image || !_level.imagebox.image.resource || !_level.imagebox.image.resource.identifier) {
                                hasEmpty = false;
                                vm.unFilledCount++;
                            }
                        }
                    }
                }
            }
            vm.completed = hasEmpty ? 'COMPLETED' : 'EDITING';
            return hasEmpty;
        };

        function saveData() {
            return documentMM($scope.template)
        }
        $scope.threeModalHide = function () {
            vm.threeIsModal = false;
            vm.threeModalText = "";
            vm.threeIsModal1 = false;
            vm.threeModalText1 = "";
        }
        $scope.threeModalSave = function () {
            vm.threeIsModal = false;
            vm.threeModalText = "";
            vm.threeIsModal1 = false;
            vm.threeModalText1 = "";
            templateReplace();
        }
        $scope.textLayout = function(item){
            var text = vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox;
            var text1 = angular.copy(vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox);
            text.style.writingmode = item;
            $timeout(function () {
                text.geometry.width = text1.geometry.height;
                text.geometry.height = text1.geometry.width;
            },200)
        }
        $scope.writingmodeInit = function (item) {
            if(item == 'vertical-lr' || item == 'vertical-rl'){
                return true
            }else{
                return false
            }
        }
        //像素不足提醒
        vm.imgSize = 150;
        vm.imgDpi = 150;
        StoreWorkEditConfig.storeId({storeId: vm.storeId}, function (res) {
            if(res.status == 200){
                vm.imgSize = res.data.imgSize;
                vm.imgDpi = res.data.imgDpi;
            }
        });
        //生成缩略图
        function thumbnailInit(callback){
            thumbnailInit1(function (res){
                if(res){
                    vm.article.covered=true;
                    vm.article.cover=res;
                }else{
                    vm.article.covered=false;
                    vm.article.cover=null;
                }
                callback(res);
            })
        }
        function thumbnailInit1(callback) {
            $timeout(function (){
                html2canvas_adapt(document.getElementById('thumbnail-view'), {
                    onrendered: function (canvas) {
                        if(canvas){
                            QiniuToken.uploadThumbnail(canvas, function (data) {
                                var identifier = data.key;
                                callback(identifier)
                            }, function () {
                                if (callback) {callback()};
                            });
                        }else{
                            if (callback) {callback()};
                        }
                    },
                    error:function(){
                        if (callback) {callback()};
                    },
                    letterRendering: true,
                    useCORS: true,
                    width: $scope.template.pages.page[0].custom.width*$scope.template.pages.page[0].custom.thumbnailScale,
                    height: $scope.template.pages.page[0].custom.height*$scope.template.pages.page[0].custom.thumbnailScale,
                    windowWidth: document.body.scrollWidth,
                    windowHeight: document.body.scrollHeight,
                    x: 0,
                    y: 0,
                    backgroundColor: "rgba(0, 0, 0, 0)"
                });
            })
        }
        vm.onArticleChange = onArticleChange;
        function onArticleChange() {}
        // 监听组件内图库返回按钮
        $scope.$on('closeGallery', function(event,close) {
            if (close) {
                $scope.getBack('page2')
            }
        });
        // 监听选择图片确认按钮
        $scope.$on('confirmGallery',function(event,photoSelectAll){
            if(vm.fullMap){
                vm.threeLoading = true;
                vm.threeLoadingText = "加载中";
                photoSave1(vm.photoSelectAll,0,function () {
                    vm.threeLoading = false;
                    $scope.fullMapHide();
                });
                return
            }
            vm.photoSelectAll = photoSelectAll;
            vm.data = [];
            $scope.photoSave();
        })
        function photoSave1(photoSelectAll,index,callback){
            if(photoSelectAll.length == index){
                callback();
                return
            }
            $scope.addImageboxImg(photoSelectAll[index],function () {
                var _index = index+1;
                photoSave1(photoSelectAll,_index,callback)
            })
        }

        $scope.$on('changeLanguage', function () {
            if(vm.istemplate){
                $scope.templateShow();
            }
            if(vm.isMaterial){
                $scope.materialShow();
            }
            getAllFont();
            vm.textStyleTab = [
                {name: $translate.instant("font.textStyleTabFont"), id: 'textStyleTabFont'},
                {name: $translate.instant("font.textStyleTabSize"), id: 'textStyleTabSize'},
                {name: $translate.instant("font.textStyleTabType"), id: 'textStyleTabType'},
                {name: $translate.instant("font.textStyleTabColor"), id: 'textStyleTabColor'},
            ];
        });
        //内页叶序
        $scope.getIndex = function(index){
            var _index = 0;
            for(var i=0; i<$scope.template.pages.page.length; i++){
                var _page = $scope.template.pages.page[i];
                if(_page.config.partid == "P"){
                    break
                }else{
                    _index +=1;
                }
            }
            return Number(index)-Number(_index)+1;
        }
        //部件名
        $scope.partName = function (partid) {
            if (!$scope.template||!$scope.template.config||!$scope.template.config.parts||!$scope.template.config.parts.list) {
                return
            }
            var partName = "";
            for(var i=0; i<$scope.template.config.parts.list.length; i++){
                if($scope.template.config.parts.list[i].id == partid){
                    partName = $scope.template.config.parts.list[i].name;
                }
            }
            return partName
        }
        /*
        * 动态日历
        * */
        vm.years=[];
        vm.months=[1,2,3,4,5,6,7,8,9,10,11,12];
        vm.yearIndex=2024;
        vm.monthIndex=1;
        vm.monthIndex1=0;
        vm.isCalendar=false;
        vm.yearPage = 1;
        vm.yearSize = 10;
        vm.isYear = false;
        function yearInfo() {
            $scope.pages.pages.page.forEach(function (page) {
                if(vm.monthIndex1 < page.config.monthIndex){
                    vm.monthIndex1 = page.config.monthIndex
                }
            })
            var date = new Date();
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var year1 = 2000;
            for(var i=0;i<100-Math.floor(vm.monthIndex1/13);i++){
                vm.years.push(year1+i);
            }
            vm.yearSize = Math.ceil(vm.years.length/10);
            if(month>5){
                vm.yearIndex = year+1;
            }else{
                vm.yearIndex = year;
            }
        }
        $scope.getEndYear = function (month) {
            return getDay('year',vm.yearIndex,month||vm.monthIndex,vm.monthIndex1)
        }
        $scope.getEndMonth = function (month) {
            return getDay('month',vm.yearIndex,month||vm.monthIndex,vm.monthIndex1)
        }
        $scope.yearIndex = function(item){
            if(item == 'subtract'){
                vm.yearIndex = vm.yearIndex<=2000?2000:vm.yearIndex-1;
            }
            if(item == 'add'){
                vm.yearIndex = vm.yearIndex>=vm.years[vm.years.length-1]?vm.years[vm.years.length-1]:vm.yearIndex+1;
            }
            monthInfo()
        }
        $scope.yearPageCb = function(item){
            if(item == 'subtract'){
                vm.yearPage = vm.yearPage<2?1:vm.yearPage-1;
            }
            if(item == 'add'){
                vm.yearPage = vm.yearPage>=vm.yearSize?vm.yearSize:vm.yearPage+1;
            }
        }
        $scope.yearIndexSave = function(e,item){
            if(item){
                vm.yearIndex = item;
                vm.isYear=false;
                monthInfo()
            }
            fn(e)
        }
        var a = null;
        $scope.yearPageChange = function(){
            if (a !== null) {
                clearTimeout(a)
            }
            a = setTimeout(function () {
                $timeout(function () {
                    var regex = /^[1-9]\d*$/;
                    if(!regex.test(vm.yearPage)){
                        vm.yearPage = 1;
                    }
                    if(vm.yearPage>=vm.yearSize){
                        vm.yearPage=vm.yearSize
                    }
                    if(vm.yearPage<2){
                        vm.yearPage=1;
                    }
                })
            },500)
        }
        function monthInfo(){
            // if($scope.getEndYear(12)>2099){
            //     vm.months=[];
            //     vm.monthIndex=1;
            //     for(var i=1;i<=12-$scope.getEndMonth(12);i++){
            //         vm.months.push(i)
            //     }
            // }else{
            //     vm.months=[1,2,3,4,5,6,7,8,9,10,11,12];
            // }
        }
        $scope.isYearHide = function(e){
            vm.isYear = false;
            fn(e);
        }
        $scope.isYearShow = function(e){
            vm.isYear = true;
            fn(e);
        }
        $scope.mathFloor = function(item){
            if(item>=0){
                return Math.floor(item/10)+1
            }
        }
        $scope.calendarSave = function () {
            var page = $scope.pages;
            if($scope.template){
                page = $scope.template;
            }
            page.config.startYear = vm.yearIndex;
            page.config.startMonth = vm.monthIndex;
            page.pages.page.forEach(function (page) {
                page.levels.level.forEach(function (level) {
                    if (level.calMonthBox && level.calMonthBox.geometry) {
                        var calMonthBox = level.calMonthBox;
                        calMonthBox.obj=null;
                        calMonthBox.sampleYear = getDay('year',vm.yearIndex,vm.monthIndex,page.config.monthIndex);
                        calMonthBox.sampleMonth = getDay('month',vm.yearIndex,vm.monthIndex,page.config.monthIndex);
                    }
                    if (level.calTitleBox && level.calTitleBox.geometry) {
                        var calTitleBox = level.calTitleBox;
                        calTitleBox.obj=null;
                        calTitleBox.sampleYear = getDay('year',vm.yearIndex,vm.monthIndex,page.config.monthIndex);
                        calTitleBox.sampleMonth = getDay('month',vm.yearIndex,vm.monthIndex,page.config.monthIndex);
                    }
                })
            })
            vm.isCalendar=false;
        }
        // 抠图
        $scope.mattingOpen = function () {
            vm.imageboxCutout = {
                image: vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.resource.identifier,
                mattingMask: vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.mattingMask,
                resourceid: vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.resourceid,
                angle: vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.angle,
                flip: vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.flip,
            }
            vm.isShowImageCutout = true;
        };
        $scope.imageCutoutChange = function(text){
            if(text){
                vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.resource.identifier = text.result;
                vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.mattingMask = text.mattingMask;
                vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.angle = text.angle;
                vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.flip = text.flip;
            }
        }
        $scope.imageCutoutSave = function(text){
            vm.isShowImageCutout = false;
            if(text){
                vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.resource.identifier = text.result;
                vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.mattingMask = text.mattingMask;
                vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.angle = text.angle;
                vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.flip = text.flip;
            }
        }
    }
})();

(function () {
    'use strict';

    var editorPhotoUploadPopupC = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/product-ec/editor-photo-upload-popup.html',
        controllerAs: 'vm',
        bindings: {
            product: '<',
            onChange: '&',
        },

        controller: ['$scope', function ($scope){
            var vm = this;
            $scope.product = vm.product;
            $scope.popupSave = function (){
                vm.onChange();
            }
        }]
    };

    angular
        .module('editorApp')
        .component('editorPhotoUploadPopup', editorPhotoUploadPopupC);
})();

(function () {
    'use strict';

    angular
        .module('editorApp')
        .controller('EditorPhotoPreviewController', EditorPhotoPreviewController);

    EditorPhotoPreviewController.$inject = ['$state', '$scope', '$q', '$stateParams', 'Convert', 'Qinius', 'OrderArticle', 'Gallery', 'ItemValue', 'SweetAlert', 'Theme', '$localStorage', '$timeout', 'FontManagement', '$rootScope'
        , 'ImageService', 'ClipArt', 'PlatformWechatSetting', 'UidService', 'Store', 'Article', 'CommonService', '$http', 'Folder','MessageNotification', 'Product', 'Music', 'StoreConfig','Cart', 'Iphone', 'StoreWorkEditConfig',
        'ModulesService', '$translate'];

    function EditorPhotoPreviewController($state, $scope, $q, $stateParams, Convert, Qinius, OrderArticle, Gallery, ItemValue, SweetAlert, Theme, $localStorage, $timeout, FontManagement, $rootScope
        , ImageService, ClipArt, PlatformWechatSetting, UidService, Store, Article, CommonService, $http, Folder,MessageNotification, Product, Music, StoreConfig,Cart, Iphone, StoreWorkEditConfig,
                                          ModulesService, $translate) {
        var vm = this;
        //初始化
        $(".navbar-gallery").hide();
        $(".wrap").addClass('no-margins');
        $(".well").css({'margin-bottom': 0});
        $scope.dWidth = document.documentElement.clientWidth;
        $("body").css({width: $scope.dWidth, 'min-width': $scope.dWidth});
        vm.returnurl = localStorage.getItem('returnurl');
        vm.returnurl1 = localStorage.getItem('returnurl1');
        vm.returnurl2 = localStorage.getItem('returnurl2');
        vm.source = localStorage.getItem('source');
        vm.returnurl2Text = localStorage.getItem('returnurl2Text') || $translate.instant("button.buttonText");

        vm.storeId = $stateParams.storeId;
        vm.aid = $stateParams.aid;
        vm.orderArticleId = $stateParams.orderArticleId;


        var audio = document.getElementById('audio');
        audio.crossOrigin = 'anonymous';

        $scope.domains = Qinius.getDomain();
        PlatformWechatSetting.get({}, function (res) {
            vm.platformSetting = res.data;
        });
        vm.store = Store.get({id: vm.storeId});

        // vm.storeCart = StoreConfig.byStoreIdAndType({
        //     storeId: vm.storeId,
        //     type:'SHOPPINGCART'
        // });

        StoreWorkEditConfig.storeId({storeId: vm.storeId}, function (res) {
            if(res.status == 200){
                vm.returnurl2Text = localStorage.getItem('returnurl2Text') || res.data.buttonText;
            }else{
                swal.showInputError(res.message);
            }
        });
        $q.all([$scope.domains.$promise]).then(function () {
            $scope.domain = 'https://' + $scope.domains.domains[0] + '/';
            vm.isIPhoneX = Iphone;
            init();
            document.addEventListener('UniAppJSBridgeReady', function() {})
            //获取自定义颜色
            ModulesService.getToneSettings(vm.storeId,function (res) {
                vm.toneSettings = res;
            });
        });
        vm.windowDpi = js_getDPI();
        //主页
        function init(){
            if(vm.orderArticleId){
                OrderArticle.get({id: vm.orderArticleId}, function (res) {
                    vm.article = res.data;
                    if(vm.article.invalid){//作品失效
                        $state.go('articlesFailure',{storeId:vm.storeId},{location: 'replace'});
                        return
                    }
                    $(document).attr("title",vm.article.name);
                    Product.get({id: vm.article.productId}, function (resP) {
                        Convert.xmlToDocument2({
                            identifier: res.data.fileName,
                            provider: "qiniu",
                            editorType:vm.article.editorType,
                            pictureType:resP.data.pictureType,
                            patternType:resP.data.patternType,
                        }, function (resp1) {
                            vm.previewArticle = resp1;
                            vm.page = resp1.pages.page;
                            // abook()
                            getItemValue();
                        })
                    })
                })
            }else{
                Article.get({id: vm.aid}, function (res) {
                    vm.article = res.data;
                    if(vm.article.invalid){//作品失效
                        $state.go('articlesFailure',{storeId:vm.storeId},{location: 'replace'});
                        return
                    }
                    $(document).attr("title",vm.article.name);
                    Product.get({id: vm.article.productId}, function (resP) {
                        Convert.xmlToDocument2({
                            identifier: res.data.fileName,
                            provider: "qiniu",
                            editorType:vm.article.editorType,
                            pictureType:resP.data.pictureType,
                            patternType:resP.data.patternType,
                        }, function (resp1) {
                            vm.previewArticle = resp1;
                            vm.page = resp1.pages.page;
                            // abook()
                            getItemValue();
                        })
                    })
                })
            }

            var monthStr = new Date().getMonth() + 1;
            var dayStr = new Date().getDate();
            var timestr = new Date().getFullYear() + "-" + (monthStr > 9 ? monthStr : "0" + monthStr) + "-" + (dayStr > 9 ? dayStr : "0" + dayStr);
            MessageNotification.getAllByCondition2({
                items: [{key: "available", op: "=", value: "true"}, {
                    key: "validate",
                    op: ">=",
                    value: timestr
                }, {key: "pageType", op: "=", value: "View"}]
            }, function (res) {
                res.data.sort(compare('seq'))
                vm.message = angular.copy(res.data);
                vm.messageText = "\xa0\xa0\xa0\xa0\xa0\xa0";
                angular.forEach(res.data, function (resp) {
                    vm.messageText += resp.content + "\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0"
                })
            });


            Music.allByCondition({
                items: [],
                sort: ["id,asc"]
            }, function (resp) {
                $scope.Musics = resp.data;
            });
        }

        function compare(property) {
            return function (a, b) {
                var value1 = a[property];
                var value2 = b[property];
                return value1 - value2;
            }
        }
        vm.isHideMusicBtn = false;
        vm.isPlayBack = false;

        var timer = null;
        var rot = 10 - 0;
        function getItemValue(){
            ItemValue.get({id: vm.article.itemValueId}, function (msg) {
                vm.itemValue = msg;
                $scope.price = msg.data.price;
                if (vm.article.musicIdentify) {
                    audio.src = $scope.domain + vm.article.musicIdentify;
                } else {
                    if ( msg.data.productXmlLines) {
                        for (var i = msg.data.productXmlLines.length - 1; i >= 0; i--) {
                            var xml = msg.data.productXmlLines[i];
                            if (xml.productXmlId == vm.article.productXmlId && xml.musicIdentify) {
                                audio.src = $scope.domain + xml.musicIdentify;
                            }
                        }
                    } else {
                        audio.src = '';
                        vm.isHideMusicBtn = true;
                    }
                }
                if(!vm.isHideMusicBtn){
                    Play();
                }
            });
        }

        function Play() {
            audio.play().then(function () {
                $(".PanelRight").removeClass('hide1');
                timer = window.setInterval(begin, 10);
            }).catch(function (error) {
                console.log(error);
            });
        }

        var rot = 10 - 0;
        function begin() {
            var micon = document.getElementById("music-icon");
            if (micon == null) {
                window.clearInterval(timer);
                return;
            }
            micon.style.transform = "rotate(" + rot + "deg)";
            rot += 1;
        }

        $("#Play").on('click', function () {
            window.clearInterval(timer);
            if (audio.paused) {
                audio.play();
                Play();
                $("#Play").children("img").removeClass("play").addClass("pause");
            }
            else {
                $("#Play").children("img").removeClass("pause").addClass("play");
                audio.pause();
            }
        });

        function abook() {
            var windowRatio = 0.4;
            angular.forEach(vm.page, function (page) {
                page.mediabox = {
                    height: transitionPx(page.mediabox.height),
                    width: transitionPx(page.mediabox.width),
                    x: transitionPx(page.mediabox.x),
                    y: transitionPx(page.mediabox.y)
                }
                page.ratio = $scope.dWidth * windowRatio / page.mediabox.width;
                angular.forEach(page.levels.level, function (level) {
                    if(level.imagebox){
                        level.imagebox.blurredrectangle={
                            height: transitionPx(level.imagebox.blurredrectangle.height),
                            width: transitionPx(level.imagebox.blurredrectangle.width),
                            x: transitionPx(level.imagebox.blurredrectangle.x),
                            y: transitionPx(level.imagebox.blurredrectangle.y)
                        }
                    }
                })
            })
        }
        $scope.openMusicList = function () {
            $scope.musicPage = true;
            vm.musicIdentify = angular.copy(vm.article.musicIdentify);
        };
        $scope.backTo = function(){
            if(vm.article.musicIdentify != vm.musicIdentify){
                audio.src = $scope.domain + vm.article.musicIdentify;
            }
            $scope.musicPage = false;
        }
        $scope.playList = function (identify, index) {
            // audioTest.pause();
            audio.src = $scope.domain + identify;
            vm.musicIdentify = identify;
        };
        $scope.saveMusic = function(){
            if(vm.article.musicIdentify != vm.musicIdentify){
                vm.article.musicIdentify = vm.musicIdentify;
                audio.src = $scope.domain + vm.article.musicIdentify;
            }
            $scope.musicPage = false;
        }

        $scope.editorPhoto = function () {
            Product.get({id: vm.article.productId}, function (product) {
                $state.go("editorPhotoBothEdit", {storeId: vm.storeId, aid:  vm.article.id},{location: 'replace'});
            })
        }

        $scope.goToCustomer = function () {
            if(vm.source){
                uni.redirectTo({
                    url: vm.returnurl1
                })
                return
            }
            window.location.href = vm.returnurl1;
        };
        $scope.save = function () {
            if(vm.source){
                uni.redirectTo({
                    url: vm.returnurl2
                })
                return
            }
            window.location.href = vm.returnurl2;
        }
        //边框
        $scope.imageboxW = function (imagebox) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.geometry.width) + Number(imagebox.border.lineWidth) * 2
                }
                if (imagebox.border.type == 'Pic') {
                    return imagebox.geometry.width
                    // return Number(imagebox.geometry.width) + (Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100) + (Number(imagebox.geometry.width) * Number(imagebox.border.edge.right) / 100)
                }
            } else {
                return imagebox.geometry.width
            }
        }
        $scope.imageboxH = function (imagebox) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.geometry.height) + Number(imagebox.border.lineWidth) * 2
                }
                if (imagebox.border.type == 'Pic') {
                    return imagebox.geometry.height
                    // return Number(imagebox.geometry.height) + (Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100) + (Number(imagebox.geometry.height) * Number(imagebox.border.edge.bottom) / 100)
                }
            } else {
                return imagebox.geometry.height
            }
        }
        $scope.imageboxL = function (imagebox) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.geometry.x) - Number(imagebox.border.lineWidth)
                }
                if (imagebox.border.type == 'Pic') {
                    return imagebox.geometry.x
                    // return Number(imagebox.geometry.x) - (Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100)
                }
            } else {
                return imagebox.geometry.x
            }
        }
        $scope.imageboxT = function (imagebox) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.geometry.y) - Number(imagebox.border.lineWidth)
                }
                if (imagebox.border.type == 'Pic') {
                    return imagebox.geometry.y
                    // return Number(imagebox.geometry.y) - (Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100)
                }
            } else {
                return imagebox.geometry.y
            }
        }
        $scope.imageboxWEdge = function (imagebox, edge) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.border.lineWidth)
                }
                if (imagebox.border.type == 'Pic') {
                    if (edge == 'left') {
                        return Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100
                    }
                    if (edge == 'top') {
                        return Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100
                    }
                    if (edge == 'right') {
                        return Number(imagebox.geometry.width) * Number(imagebox.border.edge.right) / 100
                    }
                    if (edge == 'bottom') {
                        return Number(imagebox.geometry.height) * Number(imagebox.border.edge.bottom) / 100
                    }
                }
            } else {
                return 0
            }
        }
        $scope.imageboxWRadius = function (imagebox, radius, ratio, ratio1) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                var _ratio = 1;
                if(ratio && ratio1){
                    if(imagebox.geometry.width > imagebox.geometry.height){
                        _ratio = ratio1
                    }else{
                        _ratio = ratio
                    }
                }
                if(ratio && !ratio1){
                    _ratio = ratio
                }
                if (imagebox.border.shape == 'Ellipse') {
                    return '50%'
                }
                if (imagebox.border.radius.filletType == 'Fixed') {//圆角固定值
                    var _radius = imagebox.border.radius[radius];
                    return _radius > 0 ?  (_radius + Number(imagebox.border.lineWidth)/2) * _ratio : 0;
                }else{
                    var radiusW = imagebox.geometry.width > imagebox.geometry.height ? imagebox.geometry.height : imagebox.geometry.width;
                    radiusW = radiusW + imagebox.border.lineWidth;
                    var _r = radiusW * imagebox.border.radius[radius] / 100;
                    return _r > 0 ? (_r + Number(imagebox.border.lineWidth)/2) * _ratio : 0
                }
            } else {
                return 0
            }
        }
        $scope.imageboxWRadius1 = function (imagebox, radius, ratio, ratio1) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                var _ratio = 1;
                if(ratio && ratio1){
                    if(imagebox.geometry.width > imagebox.geometry.height){
                        _ratio = ratio1
                    }else{
                        _ratio = ratio
                    }
                }
                if(ratio && !ratio1){
                    _ratio = ratio
                }
                if (imagebox.border.shape == 'Ellipse') {
                    return '50%'
                }
                if (imagebox.border.radius.filletType == 'Fixed') {//圆角固定值
                    var _radius = imagebox.border.radius[radius];
                    return  (_radius - Number(imagebox.border.lineWidth)/2) > 0 ? (_radius - Number(imagebox.border.lineWidth)/2) * _ratio : 0;
                }else{
                    var radiusW = imagebox.geometry.width > imagebox.geometry.height ? imagebox.geometry.height : imagebox.geometry.width;
                    radiusW = radiusW + imagebox.border.lineWidth;
                    var _r = radiusW * imagebox.border.radius[radius] / 100;
                    return (_r - Number(imagebox.border.lineWidth)/2) > 0 ? (_r - Number(imagebox.border.lineWidth)/2) * _ratio : 0
                }
            } else {
                return 0
            }
        }
        $scope.dropShadow = function(imagebox,ratio,ratio1){
            if (imagebox.shadow == null) {
                return
            }
            var width = $scope.imageboxW(imagebox) * ratio;
            var height =$scope.imageboxH(imagebox) * ratio1;
            return dropShadow(imagebox,width,height)
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('editorApp')
        .controller('EditorPhotoBothController', EditorPhotoBothController);

    EditorPhotoBothController.$inject = ['$state', '$scope', '$q', '$stateParams', 'Convert', 'Qinius', 'QiniuToken', 'WxJS', 'Gallery', 'ItemValue', 'RecommendPics', 'Theme', '$localStorage', '$timeout', 'FontManagement', '$rootScope'
        , 'ImageService', 'ClipArt', 'PlatformWechatSetting', 'UidService', 'Store', 'Article', 'CommonService', '$http', 'ThemeClassify', 'MessageNotification', 'Product',
        'entity', 'StoreWorkEditConfig', '$translate','IMAGE_SUPPORTED_MIME','MessageService','StoreStorages','$websocket'];

    function EditorPhotoBothController($state, $scope, $q, $stateParams, Convert, Qinius, QiniuToken, WxJS, Gallery, ItemValue, RecommendPics, Theme, $localStorage, $timeout, FontManagement, $rootScope
        , ImageService, ClipArt, PlatformWechatSetting, UidService, Store, Article, CommonService, $http, ThemeClassify, MessageNotification, Product,
                                       entity, StoreWorkEditConfig, $translate,IMAGE_SUPPORTED_MIME,MessageService,StoreStorages,$websocket) {
        //初始化
        $(".navbar-gallery").hide();
        $(".wrap").show().addClass('no-margins');
        $(".well").css({'margin-bottom': 0});
        $scope.dWidth = document.documentElement.clientWidth;
        $("body").css({width: $scope.dWidth, 'min-width': $scope.dWidth});
        var vm = this;
        vm.isEdit = entity.type == 'edit' ? true : false;
        vm.storeId = $stateParams.storeId;
        vm.pid = $stateParams.pid;
        vm.aid = $stateParams.aid;
        vm.vid = $stateParams.vid;
        vm.xmlId = $stateParams.xmlId;
        vm.productLine = {};
        $scope.domains = Qinius.getDomain();
        var unsubQiniuToken = QiniuToken.subscribe('get', {}, function (token) {
            vm.token = token;
        });
        $scope.$on('$destroy', unsubQiniuToken);
        PlatformWechatSetting.get({}, function (res) {
            vm.platformSetting = res.data;
        });
        vm.photoArray = [];
        vm.photoSelectAll = [];
        vm.isPhone = false;
        $scope.qiniuId = JSON.parse(localStorage.getItem("gallery")) != null ? JSON.parse(localStorage.getItem("gallery")) : [];
        $scope.status = localStorage.getItem('Production');
        vm.page1 = true;
        vm.page2 = false;
        vm.store = Store.get({id: vm.storeId});
        vm.photoAll = [];
        vm.loading = true;
        $scope.agentIos = false;
        vm.isIPhone6 = isIPhone6();
        vm.supportedMimeTypes = IMAGE_SUPPORTED_MIME;
        vm.duplicateList = []; //重复图片
        vm.isDuplicateList = false; //重复图片弹框
        vm.threeLoading = false;
        vm.threeLoadingText=$translate.instant("hint.loadingText");
        vm.backPhotoNotFilledMsg=$translate.instant("editorCommon.backPhotoNotFilled");
        vm.recommendPics = [];
        vm.deletePhotoSure = false; //删除处理失败照片确认框
        vm.pendingDeletePhoto = null; //待删除的处理失败照片

        //阻止微信端长按赋值保存图片
        document.oncontextmenu = function (e) {
            //或者return false;
            e.preventDefault();
        };

        /**
         * wechat api
         */

        // var ua = navigator.userAgent.toLowerCase();
        // if(ua.match(/MicroMessenger/i)=="micromessenger") {
        //     $scope.agentIos = browserVersions();
        // }

        $q.all([$scope.domains.$promise, vm.store.$promise]).then(function () {
            $scope.domain = 'https://' + $scope.domains.domains[0] + '/';
            // token过期

            vm.lagnuages =[];
            if ($localStorage.lagnuages) {
                for(var i = 0 ; i<$localStorage.lagnuages.length; i++ ){
                    var lang = $localStorage.lagnuages[i];
                    var langObj = {key:lang};
                    if (lang == 'zh-cn') {
                        langObj.value = $translate.instant("language.zh-cn");
                    }
                    if (lang == 'en') {
                        langObj.value = $translate.instant("language.en");
                    }
                    if (vm.lang == lang) {
                        vm.langValue = langObj.value;
                        langObj.selected = true;
                    }
                    vm.lagnuages.push(langObj);
                }
            }

            // token过期 — QiniuToken 单例自动刷新
            if (wx) {
                var url = window.location.hash && window.location.href.slice(0, -window.location.hash.length) || window.location.href;
                // var url = "https://stage.fotavatar.com/10/143/1230321120340111/editorPhotoBoth";
                WxJS.get({url: url}, function (res) {
                    if (res.status == 200) {
                        $scope.agentIos = browserVersions();
                        var config = res.data;
                        wx.config({
                            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                            appId: config.appId, // 必填，公众号的唯一标识
                            timestamp: config.timestamp, // 必填，生成签名的时间戳
                            nonceStr: config.nonceStr, // 必填，生成签名的随机串
                            signature: config.signature,// 必填，签名，见附录1
                            jsApiList: ['chooseImage', 'uploadImage', 'hideMenuItems'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                        });
                        wx.ready(function () {
                            console.log('wechat api ready!');

                            // wx.hideMenuItems({
                            //     menuList: ["menuItem:copyUrl", "menuItem:share:timeline", "menuItem:share:appMessage", "menuItem:share:qq", "menuItem:share:appMessage", "menuItem:share:QZone"]
                            // });
                        });
                        wx.error(function (res) {
                            console.log(res)
                        });
                    }
                }, function () {
                    console.log("wx config error");
                });
            }

            //判断是ios or Android
            function isIphoneX() {
                return /iphone/gi.test(window.navigator.userAgent) && window.screen.width === 375 && (window.screen.height === 812 || window.screen.height == 724);
            }

            $scope.isIphoneX = isIphoneX();

            RecommendPics.getAllByCondition2({items:[{key: "cancelled", op: "=", value: "false"}],sort: ["seq,asc"]},function(res){
                if(res && res.data){
                    res.data.forEach(function(item){
                        item.identifier = $scope.domain + item.identifier;
                    })
                    vm.recommendPics = res.data;
                }
            })
            init();
            // $timeout(function () {
            //     qInit();
            // })
        websocket()
        });

        // websocket接收上传的图片（多端互通实时更新）
        function websocket(){
            var urlws = vm.platformSetting.editorNotifyUrl.split("://")[1];
            urlws = urlws.split("/")[0];
            var ws = $websocket("wss://"+ urlws +"/widget/ws/websocket?uid=Gallery"+vm.aid);
            ws.onOpen(function() {
                console.log('WebSocket连接已打开, url:'+ws.url);
            });
            ws.onMessage(function(message) {
                var photo = JSON.parse(message.data);
                console.log(photo);
                if (photo.folderId == vm.folderId || (photo.folderId == null && vm.folderId == '')) {
                    var _photo = null;
                    for (var i = 0; i < vm.photoAll.length; i++) {
                        if (vm.photoAll[i].id == photo.id) {
                            _photo = vm.photoAll[i];
                            break;
                        }
                    }
                    if (_photo) {
                        _photo.largeStatus = photo.largeStatus;
                        _photo.stripKey = photo.stripKey;
                        _photo.thumbnailKey = photo.thumbnailKey;
                        _photo.identifier1 = $scope.domain + photo.thumbnailKey
                        if(_photo.convertFlag){
                            _photo.convertStatus = photo.convertStatus;
                            // 色彩转换完成后资源identifier会变化，需同步更新（photo.identifier未带域名）
                            _photo.identifier = $scope.domain + photo.identifier;
                        }
                    }
                    var _photo1 = null;
                    for (var i = 0; i < vm.photoSelectAll.length; i++) {
                        if (vm.photoSelectAll[i].id == photo.id) {
                            _photo1 = vm.photoSelectAll[i];
                            break;
                        }
                    }
                    if (_photo1) {
                        _photo1.largeStatus = photo.largeStatus;
                        _photo1.stripKey = photo.stripKey;
                        _photo1.thumbnailKey = photo.thumbnailKey;
                        _photo1.identifier1 = $scope.domain + photo.thumbnailKey
                        if(_photo1.convertFlag){
                            _photo1.convertStatus = photo.convertStatus;
                            _photo1.identifier = $scope.domain + photo.identifier;
                        }
                    }
                    // 同步更新已选列表（图库已选tab）中的大图/色彩转换状态
                    if (vm.photoSelectAll1 && vm.photoSelectAll1.length) {
                        for (var k = 0; k < vm.photoSelectAll1.length; k++) {
                            if (vm.photoSelectAll1[k].id == photo.id) {
                                vm.photoSelectAll1[k].largeStatus = photo.largeStatus;
                                vm.photoSelectAll1[k].stripKey = photo.stripKey;
                                vm.photoSelectAll1[k].thumbnailKey = photo.thumbnailKey;
                                vm.photoSelectAll1[k].identifier1 = $scope.domain + photo.thumbnailKey;
                                if (vm.photoSelectAll1[k].convertFlag) {
                                    vm.photoSelectAll1[k].convertStatus = photo.convertStatus;
                                    vm.photoSelectAll1[k].identifier = $scope.domain + photo.identifier;
                                }
                            }
                        }
                    }
                    // 同步更新 imagebox.image 中的大图处理状态，确保编辑组件实时显示
                    if (vm.singleData) {
                        for (var sp = 0; sp < vm.singleData.length; sp++) {
                            var page = vm.singleData[sp];
                            if (page.levels && page.levels.level) {
                                for (var sl = 0; sl < page.levels.level.length; sl++) {
                                    var level = page.levels.level[sl];
                                    if (level.imagebox && level.imagebox.image &&
                                        level.imagebox.image.resourceid == photo.id) {
                                        level.imagebox.image.largeStatus = photo.largeStatus;
                                        level.imagebox.image.stripKey = photo.stripKey;
                                    }
                                }
                            }
                        }
                    }
                    vm.data.forEach(function(_data){
                        for (var sp = 0; sp < _data.length; sp++) {
                            var page = _data[sp];
                            if (page.levels && page.levels.level) {
                                for (var sl = 0; sl < page.levels.level.length; sl++) {
                                    var level = page.levels.level[sl];
                                    if (level.imagebox && level.imagebox.image &&
                                        level.imagebox.image.resourceid == photo.id) {
                                        level.imagebox.image.largeStatus = photo.largeStatus;
                                        level.imagebox.image.stripKey = photo.stripKey;
                                    }
                                }
                            }
                        }
                    })
                    $scope.$applyAsync();
                }
            });
            ws.onError(function(error) {
                console.log('WebSocket错误：', error);
            });
            ws.onClose(function() {
                console.log('WebSocket连接已关闭');
            });
        }

        vm.isEditorPhotoUploadPopup = false;
        $scope.showGallery = function () {
            if(vm.product.editTip && vm.data.length == 0){
                vm.isEditorPhotoUploadPopup = true;
            }else{
                $scope.uploadPhoto(true)
            }
        }
        $scope.editorPhotoUploadPopupChange = function (){
            vm.isEditorPhotoUploadPopup = false;
            $scope.uploadPhoto(true)
        }
        vm.uploadPhotoItem=[];
        vm.isAddImg = false;
        $scope.uploadPhoto = function (type) {
            vm.isAddImg = type;
            uploadAble(StoreStorages,vm.storeId, function (res) {
                if(res.status == 200){
                    if($scope.agentIos){
                        $rootScope.$broadcast('clickAndroidUpload',true);
                    }else{
                        $timeout(function () {
                            $("#uploadImageMutiple-page0").trigger("click");
                        })
                    }
                }else{
                    if(res.status == 400){
                        threeInfo($translate.instant('editorCommon.systemError'));
                    } else {
                        threeInfo(res.data||$translate.instant('editorCommon.systemError'));
                    }
                }
            })
        }
        $scope.$on('uoloadFinished', function(event, args) {
            if(args){
                if (vm.isAddImg && vm.pictureType == 'spread' && vm.photoSelectAll && vm.photoSelectAll.length>0) {
                    if(!vm.product.allowNegativeUnify && vm.photoSelectAll && vm.photoSelectAll.length==1){
                        $scope.photoSave();
                    }else{
                        vm.page1 = false;
                        vm.page2 = true;
                    }
                }

                vm.photoAll = [];
                vm.indexNum = 0;
                vm.photoCompleted = false;
                loadAll('isNull');
            }
        });
        $scope.pageSortCb = function (text){
            var _obj = JSON.parse(text);//photoAll: vm.photoAll,sideUnification:sideUnification
            vm.photoSelectAll = _obj.photoAll;
            var sideUnification = _obj.sideUnification || false;
            vm.page1 = true;
            vm.page2 = false;
            if(vm.photoSelectAll && vm.photoSelectAll.length>0){
                $scope.photoSave(sideUnification);
            }
        }
        $scope.uploadPhotoCb = function (text){
            if(text){
                vm.photoAll.unshift(text)
            }
            if(vm.isAddImg && text){
                if(vm.pictureType == 'single'){
                    var img = text;
                    if(img && img.identifier){
                        abook([img])
                    }
                }
            }
        }

        // 监听重复图片事件
        $scope.$on('duplicateImages', function(event, duplicateList,flag,currentFileList) {
            if (duplicateList && duplicateList.length > 0) {
                vm.duplicateList = duplicateList;
                MessageService.confirm({
                    title: $translate.instant('hint.prompt'),
                    cancel: $translate.instant('button.cancel'),
                    confirm: $translate.instant('button.confirm'),
                    msg: $translate.instant('gallery.duplicateDetected', {count: vm.duplicateList.length}),
                    html: '<span class="themecolor themecolor-btn">' + $translate.instant('gallery.viewDuplicatePhotos') + '</span>'
                }, function(res) {
                    if (res == 'htmlClick') {
                        vm.isDuplicateList = true;
                    } else {
                        var ids = [];
                        vm.duplicateList.forEach(function(item) {
                            ids.push(item.id);
                        });
                        Gallery.batchDelete(ids, function() {
                            // 上传的全是重复图
                           if(ids.length == vm.photoAll.length){
                                MessageService.success($translate.instant('gallery.deduplicateSuccess'));
                                vm.duplicateList = [];
                                var deletedIds = {};
                                currentFileList.forEach(function(_v){
                                    if(_v.duplicate){
                                        deletedIds[_v.id] = true;
                                    }
                                });
                                vm.photoAll = vm.photoAll.filter(function(img){
                                    return !deletedIds[img.id];
                                });
                                vm.photoSelectAll = vm.photoSelectAll.filter(function(img){
                                    return !deletedIds[img.id];
                                });
                                vm.indexNum = 0;
                                vm.maxId = null;
                                vm.photoCompleted = false;
                                loadAll('isNull');
                           }else{
                            // 去重
                            var deletedIds = {};
                            currentFileList.forEach(function(_v){
                                if(_v.duplicate){
                                    deletedIds[_v.id] = true;
                                }
                            });
                            vm.photoAll = vm.photoAll.filter(function(img){
                                return !deletedIds[img.id];
                            });
                            vm.photoSelectAll = vm.photoSelectAll.filter(function(img){
                                return !deletedIds[img.id];
                            });
                            $rootScope.$broadcast('uoloadFinished',flag);
                           }
                        }, function(error) {
                            MessageService.error($translate.instant('gallery.deleteFailed'));
                            vm.duplicateList = [];
                        });
                    }
                }, function() {
                    vm.duplicateList = [];
                    $rootScope.$broadcast('uoloadFinished',flag);
                });
            }
        });
        $scope.duplicateChange = function(val) {
            var _val = JSON.parse(val)
            // val 可能是: 0(关闭), 1(全部删除), 数组(部分删除)
            // 当删除部分图片时，从已选列表中移除对应图片，避免重新加载后这些图片被重新选中
            if(Array.isArray(_val) && _val.length){
                var deletedIds = {};
                _val.forEach(function(_v){
                    deletedIds[_v.id] = true;
                });
                vm.photoSelectAll = vm.photoSelectAll.filter(function(img){
                    return !deletedIds[img.id];
                });
            }
            vm.isDuplicateList = false;
            vm.duplicateList = [];
            vm.photoAll = [];
            vm.indexNum = 0;
            vm.maxId = null;
            vm.photoCompleted = false;
            loadAll('isNull');
        };

        vm.itemsPerPage = 40;//分页数量
        function loadAll(folderId) {
            if (folderId == 'isNull') {
                Gallery.storeByCondition({
                    items: [{key: "folderId", op: "isNull", value: ''}, {key: "articleId", op: "=", value: vm.aid}],
                    page: vm.indexNum,
                    size: vm.itemsPerPage,
                    sort: sorts()
                }, onSuccess, onError);
            } else {
                Gallery.storeByCondition({
                    items: [{key: "folderId", op: "=", value: folderId}, {key: "articleId", op: "=", value: vm.aid}],
                    page: vm.indexNum,
                    size: vm.itemsPerPage,
                    sort: sorts()
                }, onSuccess, onError);
            }
        }

        function sorts() {
            return ["id,desc"];
        }

        function onSuccess(res) {
            for (var i = 0; i < res.data.length; i++) {
                if (!res.data[i].cancelled) {
                    res.data[i].identifier = $scope.domain + res.data[i].identifier;
                    if(res.data[i].largeFlag || $scope.isLarge(res.data[i].imageInfo)){
                        res.data[i].identifier1 = res.data[i].identifier + '.thumbnail.jpg';
                    }
                    vm.photoAll.push(res.data[i])
                }
            }
            if (res.data.length < vm.itemsPerPage) {
                vm.photoCompleted = true;
            }
            getPagePhoto();
        }

        function onError(data) {
            if(data.status !== 403){
                MessageService.hint($translate.instant("editorCommon.failedToObtainThePhotoGallery"));
            }
        }

        function getPagePhoto() {
            var timeList = [];
            vm.photoArray = [];
            for (var i = 0; i < vm.photoAll.length; i++) {
                var photoCreatedDate = new Date(vm.photoAll[i].createdDate);
                if (checkExist(timeList, photoCreatedDate)) {
                    timeList.push(photoCreatedDate);
                }
            }
            //将相同日期下的照片整合
            for (var m = 0; m < timeList.length; m++) {
                var tempObj = {};
                var tempItems = [];
                for (var j = 0; j < vm.photoAll.length; j++) {
                    var createdDate = new Date(vm.photoAll[j].createdDate);
                    if (timeList[m].getFullYear() == createdDate.getFullYear() &&
                        timeList[m].getMonth() == createdDate.getMonth() &&
                        timeList[m].getDate() == createdDate.getDate()) {
                        tempItems.push(vm.photoAll[j])
                    }
                }
                var time = timeList[m].getFullYear() + '-' + (timeList[m].getMonth() + 1) + '-' + timeList[m].getDate();
                tempObj = {"createDate": time, "galleries": tempItems};
                vm.photoArray.push(tempObj);
            }
            getPagePhotoSelected();
        }

        function getPagePhotoSelected() {
            for (var i = 0; i < vm.photoArray.length; i++) {
                for (var j = 0; j < vm.photoArray[i].galleries.length; j++) {
                    vm.photoArray[i].galleries[j].selected = false;
                    for (var k = 0; k < vm.photoSelectAll.length; k++) {
                        if (vm.photoArray[i].galleries[j].id == vm.photoSelectAll[k].id) {
                            vm.photoArray[i].galleries[j].selected = true;
                        }
                    }
                }
            }
            photoArrayAllSelect();
        }

        // 判断是否重复
        function checkExist(list, obj) {
            if (list == null || list.length == 0) {
                return true;
            }
            for (var i = 0; i < list.length; i++) {
                if (list[i].getFullYear() == obj.getFullYear() &&
                    list[i].getMonth() == obj.getMonth() &&
                    list[i].getDate() == obj.getDate()) {
                    return false;
                }
            }
            return true;
        }

        //全选当前图片
        $scope.photoAllCb = function (item) {
            item.selected = !item.selected ? true : false;
            for (var i = 0; i < item.galleries.length; i++) {
                item.galleries[i].selected = item.selected;
            }
            if (item.selected) {
                photoSelect()
            } else {
                item.galleries.forEach(function (gallerie) {
                    deletePhotoSelect(gallerie)
                })
            }
        }
        //选中当前图片
        $scope.photoOneCb = function (item) {
            item.selected = !item.selected ? true : false;
            if (item.selected) {
                photoSelect()
            } else {
                deletePhotoSelect(item);
            }
            photoArrayAllSelect();
        }

        function photoSelect() {
            // vm.photoSelectAll = [];
            // var photoSelectAll = angular.copy(vm.photoSelectAll);
            for (var i = 0; i < vm.photoArray.length; i++) {
                for (var j = 0; j < vm.photoArray[i].galleries.length; j++) {
                    if (vm.photoArray[i].galleries[j].selected) {
                        var isPhoto = false;
                        for (var k = 0; k < vm.photoSelectAll.length; k++) {
                            if (vm.photoSelectAll[k].id == vm.photoArray[i].galleries[j].id) {
                                isPhoto = true;
                                break
                            }
                        }
                        if (!isPhoto) {
                            vm.photoSelectAll.push(vm.photoArray[i].galleries[j])
                        }
                    }
                }
            }
        }

        function deletePhotoSelect(item) {
            var index = null;
            for (var i = 0; i < vm.photoSelectAll.length; i++) {
                if (vm.photoSelectAll[i].id == item.id) {
                    index = i;
                    break
                }
            }
            vm.photoSelectAll.splice(index, 1);
        }

        function photoArrayAllSelect() {
            for (var i = 0; i < vm.photoArray.length; i++) {
                vm.photoArray[i].selected = true;
                for (var j = 0; j < vm.photoArray[i].galleries.length; j++) {
                    if (!vm.photoArray[i].galleries[j].selected) {
                        vm.photoArray[i].selected = false;
                    }
                }
            }
        }

        $scope.photoIndex = function (item) {
            var index = null;
            for (var i = 0; i < vm.photoSelectAll.length; i++) {
                if (vm.photoSelectAll[i].id == item.id) {
                    index = i;
                    break
                }
            }
            return index + 1;
        }
        //添加图片
        $scope.photoSave = function (sideUnification) {
            vm.page1 = true;
            for (var i = 0; i < vm.photoSelectAll.length; i++) {
                vm.photoSelectAll[i].seq = i + 1;
            }
            abook(vm.photoSelectAll, false, sideUnification);
        }
        vm.windowDpi = js_getDPI();


        //主页
        vm.finalArray = [];
        vm.totalPrice = 0;
        vm.currentNavtab = 0;
        vm.product = {};
        vm.productXmlLines = [];

        function init() {
            if (!vm.isEdit) {
                Article.getByUser({id: $stateParams.aid}, function (article) {
                    if (article.status == 200) {
                        vm.article = article.data;
                        document.title = vm.article.productName;
                        if(vm.article.invalid){//作品失效
                            $state.go('articlesFailure',{storeId:vm.storeId},{location: 'replace'});
                            return
                        }
                        Product.get({id: vm.pid, cancelled: false}, function (res) {
                            var product = res.data;
                            vm.product = res.data;
                            vm.pictureType = res.data.pictureType;
                            if(!vm.pictureType){vm.pictureType = 'single'}
                            ItemValue.get({id: $stateParams.vid}, function (res1) {
                                vm.itemValue = res1.data;
                                getPropertyValue();
                                vm.productXmlLines = angular.copy(res1.data.productXmlLines);
                                vm.productXmlLine = angular.copy(res1.data.productXmlLines[0]);
                                angular.forEach(res1.data.productXmlLines, function (line) {
                                    if (line.id == vm.xmlId) {
                                        vm.productXmlLine = angular.copy(line);
                                    }
                                })

                                Gallery.all({
                                    items: [{key: "articleId", op: "=", value: vm.aid}],
                                    sort: sorts()
                                }, function (res){
                                    vm.photoSelectAll = [];
                                    if(res.data){
                                        res.data.forEach(function (item){
                                            item.galleries.forEach(function (gallerie){
                                                if (!gallerie.cancelled) {
                                                    gallerie.identifier = $scope.domain + gallerie.identifier;
                                                    vm.photoSelectAll.push(gallerie)
                                                }
                                            })
                                        })
                                    }
                                    getXmlToDucoment(vm.productXmlLine);
                                }, function (){

                                });
                            })
                        })
                    }
                },function(error){
                    if(error.status === 403){//token失效
                        return $state.go('404',{storeId:vm.storeId},{location: 'replace'});
                    }
                    if(error.data.status === 404){//未找到作品
                        $state.go('404',{storeId:vm.storeId,tips:error.data.message},{location: 'replace'});
                    }
                    if(error.data.status === 410){//作品编辑器失效
                        $state.go('404',{storeId:vm.storeId,tips:'编辑器失效'},{location: 'replace'});
                    }
                })
            } else {
                Article.getByUser({id: $stateParams.aid}, function (res) {
                    vm.article = res.data;
                    document.title = vm.article.productName;
                    if(vm.article.invalid){//作品失效
                        $state.go('articlesFailure',{storeId:vm.storeId},{location: 'replace'});
                        return
                    }
                    ItemValue.get({id: res.data.itemValueId}, function (resp) {
                        vm.itemValue = resp.data;
                        getPropertyValue();
                        vm.article.skuNumber = resp.data.skuNumber;
                        vm.article.productBokeh = resp.data.productBokeh;
                        vm.article.productBokehType = resp.data.productBokehType;
                        vm.article.bokehtype = 'None';
                        vm.productXmlLines = [];
                        resp.data.productXmlLines.forEach(function (productXmlLine) {
                            if (!productXmlLine.cancelled) {
                                vm.productXmlLines.push(productXmlLine)
                            }
                        })
                        angular.forEach(vm.productXmlLines, function (line) {
                            if (line.productXmlId == vm.article.productXmlId) {
                                vm.productXmlLine = angular.copy(line);
                            }
                        });
                        getProduct(resp.data.productId, function () {
                            Convert.xmlToDocument2({
                                identifier: res.data.fileName,
                                provider: "qiniu",
                                editorType:vm.article.editorType,
                                pictureType:vm.pictureType,
                                // patternType:vm.product.patternType,
                            }, function (resp1) {
                                vm.counts = 0;
                                angular.forEach(resp1.pages.page, function (page, i) {
                                    if(!page.backup){
                                        angular.forEach(page.levels.level, function (level) {
                                            if (level.imagebox && level.imagebox.geometry) {
                                                vm.counts++;
                                            }
                                        })
                                    }
                                });
                                if (!resp1.pages.page || resp1.pages.page.length == 0) {
                                    swal({
                                        title: $translate.instant("font.warmPrompt"),
                                        text: $translate.instant("editorCommon.getTemplateError"),
                                        imageUrl: Theme.sweetHintImg(),
                                        timer: 3000,
                                        showConfirmButton: false
                                    });
                                    vm.placeOrder = false;
                                    return
                                }
                                $scope.template = angular.copy(resp1);
                                // 复制模板备份页面列表，避免直接修改原始数据
                                var backupPagesList = angular.copy($scope.template.backupPages.list);
                                // 过滤备份页面列表，只保留 uuid 等于模板页面的 uuid1 或 uuid2，并且 uuid 不为 null 的页面
                                backupPagesList = backupPagesList.filter(function(backupPage){
                                    return (backupPage.uuid == $scope.template.pages.uuid1 || backupPage.uuid == $scope.template.pages.uuid2) && backupPage.uuid != null
                                })
                                var mergedArray = $scope.template.pages.page.concat(backupPagesList);
                                $scope.template.pages.page = mergedArray;
                                documentAnalysis($scope, $http, vm, $scope.template, FontManagement, 'processing', function (page) {
                                    ratioInfo(page)
                                }, function () {
                                    $timeout(function () {
                                        var num = $scope.template.pages.page.length - backupPagesList.length;
                                        $scope.template.pages.page.splice(num);
                                        vm.loading = false;
                                        vm.windowH = window.innerHeight;
                                        vm.windowW = window.innerWidth;
                                        vm.placeOrder = true;
                                        vm.signalPage1 = $scope.template.pages.uuid1 ? getPage1($scope.template.pages.uuid1,$scope.template.pages.page,backupPagesList,0) : getPage('P0',$scope.template.pages.page);
                                        vm.signalPage2 = $scope.template.pages.uuid2 ? getPage1($scope.template.pages.uuid2,$scope.template.pages.page,backupPagesList,1) : getPage('P1',$scope.template.pages.page);
                                        imageboxQuantity();
                                        var documentPage = $scope.template.pages.page;
                                        vm.data = [];
                                        if (vm.pictureType == 'single') {
                                            for (var i = 0; i < documentPage.length; i++) {
                                                if(!documentPage[i].backup){
                                                    var isRepetition = false;
                                                    for (var j = 0; j < vm.data.length; j++) {
                                                        if (documentPage[i].uuid === vm.data[j].uuid) {
                                                            isRepetition = true;
                                                            vm.data[j].quantity++
                                                            break;
                                                        }
                                                    }
                                                    if (!isRepetition) {
                                                        documentPage[i].quantity = 1;
                                                        vm.data.push(documentPage[i])
                                                    }
                                                }
                                            }
                                            ;
                                        }
                                        if (vm.pictureType == 'spread') {
                                            var _data = [];
                                            for (var i = 0; i < documentPage.length; i++) {
                                                var _documentPage2 = documentPage[i];
                                                if(!_documentPage2.backup){
                                                    var isRepetition1 = false;
                                                    if (i % 2 === 0) {
                                                        //偶数
                                                        for (var j = 0; j < vm.data.length; j++) {
                                                            if (_documentPage2.uuid === vm.data[j][0].uuid) {
                                                                vm.data[j][0].quantity++;
                                                                isRepetition1 = true;
                                                                break;
                                                            }
                                                        }
                                                        if (!isRepetition1) {
                                                            _documentPage2.quantity = 1;
                                                            _data.push(_documentPage2);
                                                        }
                                                    } else if (i % 2 === 1) {
                                                        //奇数
                                                        if (_data.length > 0) {
                                                            _data.push(_documentPage2);
                                                            vm.data.push(_data);
                                                            _data = [];
                                                        }
                                                    }
                                                }
                                            }
                                            ;
                                        }
                                        if (vm.data.length > 0) {
                                            getCostMethod();
                                        }
                                        reserveInit($scope.template.pages.page)
                                        $scope.$apply();
                                    }, 1000)
                                })
                            });
                        })
                    });
                },function (error) {
                    if(error.status === 403){//token失效
                        return $state.go('404',{storeId:vm.storeId},{location: 'replace'});
                    }
                    if(error.data.status === 404){//未找到作品
                        $state.go('404',{storeId:vm.storeId,tips:error.data.message},{location: 'replace'});
                    }
                    if(error.data.status === 410){//作品编辑器失效
                        $state.go('404',{storeId:vm.storeId,tips:'编辑器失效'},{location: 'replace'});
                    }
                })
            }
        }

        function reserveInit(page) {
            var _page = angular.copy(page);
            vm.reservePage = [];
            _page.forEach(function (item) {
                if(item.backup){
                    vm.reservePage.push(item);
                }
            });
        }
        function getProduct(productId, callback) {
            Product.get({id: productId}, function (res) {
                vm.product = res.data;
                vm.pictureType = res.data.pictureType;
                if(!vm.pictureType){vm.pictureType = 'single'}
                if (callback) {
                    callback()
                }
            })
        }

        vm.templateView = false;
        $scope.productXmlLineClick = function (item) {
            if(item.productXmlId == vm.article.productXmlId){
                vm.threeIsModal1 = true;
                vm.threeModalText1 = $translate.instant("editorCommon.alreadyExistTemplate");
                return
            }
            vm.temporaryTemplate = item;
            vm.isTemplate = true;
        };
        $scope.threeModalHide = function(){
            vm.threeIsModal1 = false;
        }
        $scope.templateReplace = function (data) {
            var singleData = angular.copy(vm.data);
            vm.loading = true;
            vm.isTemplate = false;
            vm.article.cover = vm.temporaryTemplate.coverImg;
            vm.article.themeClassifyId = vm.temporaryTemplate.productXmlThemeId;
            vm.article.themeClassifyName = vm.temporaryTemplate.productXmlThemeName;
            vm.article.productXmlId = vm.temporaryTemplate.productXmlId;
            vm.article.productXmlName = vm.temporaryTemplate.productXmlName;
            vm.article.musicIdentify = vm.temporaryTemplate.musicIdentify;
            vm.article.itemValueId = vm.temporaryTemplate.itemValueId;
            getXmlToDucoment(vm.temporaryTemplate,function () {
                vm.counts = 0;
                angular.forEach($scope.template.pages.page, function (page, i) {
                    if(!page.backup){
                        angular.forEach(page.levels.level, function (level) {
                            if (level.imagebox && level.imagebox.geometry) {
                                vm.counts++;
                            }
                        })
                    }
                });
                $scope.photos = [];
                vm.data = [];
                var _photo = [];
                var _photo1 = [];
                if (vm.pictureType == 'single') {
                    singleData.forEach(function (data) {
                        data.levels.level.forEach(function (level) {
                            if(level.imagebox && level.imagebox.image && level.imagebox.image.resource && level.imagebox.image.resource.identifier){
                                var photo = {
                                    identifier:level.imagebox.image.resource.identifier,
                                    width:level.imagebox.image.imgWidth,
                                    height:level.imagebox.image.imgHeight,
                                    imgSize:level.imagebox.image.size,
                                    imageInfo:level.imagebox.image.imageInfo,
                                    quantity:data.quantity,
                                    uuid:data.uuid,
                                    resourceid:level.imagebox.image.resourceid,
                                    id:level.imagebox.image.resourceid,
                                    sourceId:level.imagebox.image.resourceid
                                }
                                _photo.push(photo)
                            }
                        })
                    })
                }
                if (vm.pictureType == 'spread') {
                    singleData.forEach(function (singleData1) {
                        singleData1.forEach(function (data, dataIndex) {
                            data.levels.level.forEach(function (level) {
                                if(level.imagebox && level.imagebox.image && level.imagebox.image.resource && level.imagebox.image.resource.identifier){
                                    var photo = {
                                        identifier:level.imagebox.image.resource.identifier,
                                        width:level.imagebox.image.imgWidth,
                                        height:level.imagebox.image.imgHeight,
                                        imgSize:level.imagebox.image.size,
                                        imageInfo:level.imagebox.image.imageInfo,
                                        quantity:data.quantity,
                                        uuid:data.uuid,
                                        resourceid:level.imagebox.image.resourceid,
                                        id:level.imagebox.image.resourceid,
                                        sourceId:level.imagebox.image.resourceid
                                    }
                                    _photo.push(photo)
                                }
                            })
                        })
                    })
                }
                abook(_photo,function () {
                    $timeout(function () {
                        vm.loading = false;
                        vm.isTemplate = false;
                        vm.templateView = false;
                        vm.page1 = true;
                        vm.page3 = false;
                        vm.levelIndex = null;
                        getCostMethod()
                    }, 1000)
                })
            });
        }
        $scope.getBack = function (item) {
            vm.levelIndex = null;
            if (item == 'page2') {
                vm.page1 = true;
                vm.page2 = false;
            }
            if (item == 'page3') {
                vm.page1 = true;
                vm.page3 = false;
                scroll('page'+vm.singleIndex)
            }
            $scope.photoGalleryHide();
        };

        //获取模版信息
        function getXmlToDucoment(xml,callback) {
            vm.article.cover = xml.coverImg;
            vm.article.themeClassifyId = xml.productXmlThemeId;
            vm.article.themeClassifyName = xml.productXmlThemeName;
            vm.article.productXmlId = xml.productXmlId;
            vm.article.productXmlName = xml.productXmlName;
            vm.article.musicIdentify = xml.musicIdentify;
            vm.article.itemValueId = xml.itemValueId;
            getPropertyValue();
            Convert.xmlToDocument2({
                identifier: xml.productXmlIdentifier,
                provider: "qiniu",
                editorType:vm.article.editorType,
                pictureType:vm.pictureType,
            }, function (res) {
                vm.counts = 0;
                angular.forEach(res.pages.page, function (page, i) {
                    if(!page.backup){
                        angular.forEach(page.levels.level, function (level) {
                            if (level.imagebox && level.imagebox.geometry) {
                                vm.counts++;
                            }
                        })
                    }
                });
                if (!res.status) {
                    if (!res.pages.page || res.pages.page.length == 0) {
                        swal({
                            title: $translate.instant("font.warmPrompt"),
                            text: $translate.instant("editorCommon.getTemplateError"),
                            imageUrl: Theme.sweetHintImg(),
                            timer: 3000,
                            showConfirmButton: false
                        });
                        vm.placeOrder = false;
                        return
                    }
                    $scope.template = angular.copy(res);
                    documentAnalysis($scope, $http, vm, $scope.template, FontManagement, 'processing', function (page) {
                        ratioInfo(page)
                    }, function () {
                        $timeout(function () {
                            vm.loading = false;
                            vm.placeOrder = true;
                            vm.signalPage1 = $scope.template.pages.uuid1 ? getPage1($scope.template.pages.uuid1,$scope.template.pages.page,$scope.template.backupPages.list,0) : getPage('P0',$scope.template.pages.page);
                            vm.signalPage2 = $scope.template.pages.uuid2 ? getPage1($scope.template.pages.uuid2,$scope.template.pages.page,$scope.template.backupPages.list,1) : getPage('P1',$scope.template.pages.page);
                            if(vm.article.editorType == 'PICTURE_PRO_P'){
                                if(vm.signalPage2.outline && vm.signalPage2.outline.mirrorCutline){
                                    vm.signalPage2.outline.cutline = angular.copy(vm.signalPage1.outline.mirrorCutline);
                                }
                                if(vm.propertyValue && vm.propertyValue.outline && vm.propertyValue.outline.length){
                                    if(vm.signalPage1.outline && vm.signalPage1.outline.cutline){
                                        if(!vm.signalPage1.outline.cutline.color){
                                            vm.signalPage1.outline.cutline.color = vm.propertyValue.outline[0].spotColor;
                                            vm.signalPage1.outline.cutline.colorValue = vm.propertyValue.outline[0].color;
                                        }
                                    }
                                    if(vm.signalPage2.outline && vm.signalPage2.outline.cutline){
                                        if(!vm.signalPage2.outline.cutline.color){
                                            vm.signalPage2.outline.cutline.color = vm.propertyValue.outline[0].spotColor;
                                            vm.signalPage2.outline.cutline.colorValue = vm.propertyValue.outline[0].color;
                                        }
                                    }
                                }
                            }
                            imageboxQuantity();
                            if(callback){
                                callback();
                                return
                            }
                            reserveInit($scope.template.pages.page)
                            abook(vm.photoSelectAll);
                        }, 1000)
                    })
                } else {
                    swal({
                        title: $translate.instant("font.warmPrompt"),
                        text: res.message,
                        imageUrl: Theme.sweetHintImg(),
                        timer: 3000,
                        showConfirmButton: false
                    });
                }
            });
        }

        vm.ratioInfo = ratioInfo;

        function ratioInfo(item) {

            var windowRatio = 0.4;
            var windowRatio1 = 0.9;
            item.custom.ratio = $scope.dWidth * windowRatio / item.custom.width;
            // item.custom.ratio1 = $scope.dWidth * windowRatio1 / item.custom.width;


            vm.windowWidth = $(window).width() * 0.9;
            vm.windowHeight = $(window).height() - 300;
            var ratio = item.custom.width / item.custom.height;
            var ratio1 = vm.windowWidth / vm.windowHeight;
            if (ratio >= ratio1) {
                item.custom.ratio1 = vm.windowWidth / item.custom.width;
            } else {
                item.custom.ratio1 = vm.windowHeight / item.custom.height;
            }

            item.custom.thumbnailScale = 300 / item.custom.width;
        }

        vm.data = [];
        function imageboxQuantity(){
            if(vm.signalPage1){
                vm.signalPage1.imageboxQuantity = 0;
                vm.signalPage1.backup = false;
                if(vm.signalPage1.levels && vm.signalPage1.levels.level){
                    vm.signalPage1.levels.level.forEach(function (level) {
                        if (level.imagebox) {
                            level.imagebox.image = null;
                            vm.signalPage1.imageboxQuantity++;
                        }
                    })
                }
            }
            if(vm.signalPage2){
                vm.signalPage2.imageboxQuantity = 0;
                vm.signalPage2.backup = false;
                if(vm.signalPage2.levels && vm.signalPage2.levels.level){
                    vm.signalPage2.levels.level.forEach(function (level) {
                        if (level.imagebox) {
                            level.imagebox.image = null;
                            vm.signalPage2.imageboxQuantity++;
                        }
                    })
                }
            }
        }
        function abook(gallaryPic,callback,sideUnification) {
            var images = gallaryPic;
            if(vm.pictureType == 'single'){
                var _pageCount = Math.ceil(images.length / vm.signalPage1.imageboxQuantity);
                var data = [];
                for(var i = 0; i < _pageCount; i++){
                    var _page = JSON.parse(JSON.stringify(vm.signalPage1));
                    _page.quantity = 1;
                    _page.uuid = uuid();
                    data.push(_page)
                }
                pageImagebox(data, images, sideUnification)
            }else{
                var _pageCount = Math.ceil(images.length / (vm.signalPage1.imageboxQuantity + vm.signalPage2.imageboxQuantity));
                if(sideUnification && vm.signalPage1.imageboxQuantity){
                    _pageCount = Math.ceil(images.length / vm.signalPage1.imageboxQuantity);
                }
                var data = [];
                for(var i = 0; i < _pageCount; i++){
                    var _page1 = JSON.parse(JSON.stringify(vm.signalPage1));
                    var _page2 = JSON.parse(JSON.stringify(vm.signalPage2));
                    _page1.quantity = 1;
                    _page1.uuid = uuid();
                    _page2.quantity = 1;
                    _page2.uuid = uuid();
                    data.push([_page1,_page2])
                }
                pageImagebox(data, images, sideUnification)
            }
            vm.photoSelectAll = [];
            if (vm.data.length > 0) {
                getCostMethod();
            }
            if(callback){callback()}
        }
        function pageImagebox(data, images, sideUnification){
            if(vm.pictureType == 'single'){
                for (var i2 = 0; i2 < data.length; i2++) {
                    if (data[i2].levels.level) {
                        for (var j = 0; j < data[i2].levels.level.length; j++) {
                            var _level = data[i2].levels.level[j];
                            if (images.length>0 && _level.imagebox) {
                                if ( !_level.imagebox.image || !_level.imagebox.image.resource || !_level.imagebox.image.resource.identifier) {
                                    vm.replacePageIndex2 = i2;
                                    vm.replaceTextIndex = j;
                                    replaceImagebox1(images[0], data)
                                    images.shift();
                                }
                            }
                        }
                    }
                    vm.data.push(data[i2]);
                }
            }else{
                for (var i3 = 0; i3 < data.length; i3++) {
                    for(var i1 = 0; i1<data[i3].length; i1++){
                        if(sideUnification && i1 ==0 || !sideUnification){
                            var page2 = data[i3][i1];
                            if (page2.levels.level) {
                                for (var j = 0; j < page2.levels.level.length; j++) {
                                    var _level = page2.levels.level[j];
                                    if (images.length>0 && _level.imagebox) {
                                        if ( !_level.imagebox.image || !_level.imagebox.image.resource || !_level.imagebox.image.resource.identifier) {
                                            vm.replacePageArrIndex = i3;
                                            vm.replacePageIndex = i1;
                                            vm.replaceTextIndex = j;
                                            replaceImagebox1(images[0], data)
                                            images.shift();
                                        }
                                    }
                                }
                            }
                        }
                    }
                    vm.data.push(data[i3]);
                }
            }
            return images;
        }
        function replaceImagebox1(item, data){
            var item = angular.copy(item);
            if(vm.pictureType == 'single'){
                var _imagebox = data[vm.replacePageIndex2].levels.level[vm.replaceTextIndex].imagebox;
            }else{
                var _imagebox = data[vm.replacePageArrIndex][vm.replacePageIndex].levels.level[vm.replaceTextIndex].imagebox;
            }
            if(!_imagebox.bokehtype){
                _imagebox.bokehtype = 'None';
            }
            _imagebox.whiteInk = null;
            _imagebox.whiteInk2 = null;
            _imagebox.image = {
                resource: {
                    identifier: item.identifier,
                    provider: 'qiniu'
                },
                filterResource: {
                    identifier: '',
                    provider: 'qiniu'
                },
                offsetx:0,
                offsety:0,
                resourceid:item.sourceId,
                width: item.width,
                height: item.height,
                imageInfo: item.imageInfo,
                imgSize: item.imgSize,
                index: item.seq,
                parameter: angular.fromJson(item.parameter),
                scale: 1,
                angle: 0,
                largeFlag: item.largeFlag,
                largeStatus: item.largeStatus,
                convertFlag: item.convertFlag,
                convertStatus: item.convertStatus,
                stripKey: item.stripKey,
                thumbnailKey: item.thumbnailKey
            }
            _imagebox.blurredrectangle = {
                width: '',
                height: '',
                x: '',
                y: '',
            };
            if(vm.pictureType == 'spread'){
                getBlurredrectangle(_imagebox, $scope.zfInit() ? 1 : 0);
            }else{
                getBlurredrectangle(_imagebox, 0);
            }
        }

        function uuid() {
            var s = [];
            var hexDigits = "0123456789abcdef";
            for (var i = 0; i < 36; i++) {
                s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
            }
            s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
            s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
            s[8] = s[13] = s[18] = s[23] = "-";

            var uuid = s.join("");
            return uuid;
        };

        function getBlurredrectangle(imagebox, index) {
            var item = imagebox;
            if (!item.image) {
                return
            }
            addImagebox($http, imagebox, function () {
                var newImg = angular.copy({
                    width: imagebox.image.width,
                    height: imagebox.image.height
                })
                if ((imagebox.geometry.width - imagebox.geometry.height) * (newImg.width - newImg.height) < 0) {
                    if (index % 2 === 0) {
                        if (imagebox.flip) {
                            imagebox.image.angle = imagebox.image.angle + 90;
                        } else {
                            imagebox.image.angle = imagebox.image.angle - 90;
                        }
                        imagebox.image.width = newImg.height;
                        imagebox.image.height = newImg.width;
                    }
                    if (index % 2 === 1) {
                        if (imagebox.flip) {
                            imagebox.image.angle = imagebox.image.angle - 90;
                        } else {
                            imagebox.image.angle = imagebox.image.angle + 90;
                        }
                        imagebox.image.width = newImg.height;
                        imagebox.image.height = newImg.width;
                    }
                } else {
                    imagebox.image.angle = imagebox.image.angle;
                }
                if(vm.product.bokehType != 'None'){
                    imagebox.bokehtype = 'Transparent';
                    imagebox.image.scale = 1;
                    if(imagebox.blurredrectangle){
                        imagebox.blurredrectangle.x = 0;
                        imagebox.blurredrectangle.y = 0;
                    }
                }
                getBackgroundSource3(imagebox, imagebox.geometry.width, imagebox.geometry.height, imagebox.image, imagebox.bokehtype, $scope);
            },true);
            photoSelectAllInit();
        }

        function getBlurredrectangle1(data, callback) {
            var item = data.levels.level[0].imagebox;
            var newImg = new Image();
            newImg.crossOrigin = "Anonymous";
            newImg.src = item.image.resource.identifier;
            newImg.onload = function () {
                item.image.width = newImg.width;
                item.image.height = newImg.height;
                callback()
            };
        }

        $scope.single = function (index, pageIndex) {
            if(vm.isCopyBack){return}
            vm.singleData = [];
            if(vm.article.editorType == 'PICTURE'){
                vm.levelIndex = 0;
            }
            if (vm.pictureType == 'single') {
                vm.singleData = angular.copy(vm.data);
                vm.singleIndex = index;
            }
            if (vm.pictureType == 'spread') {
                vm.data.forEach(function (data) {
                    data.forEach(function (page) {
                        vm.singleData.push(angular.copy(page))
                    })
                })
                vm.singleIndex = index * 2 + pageIndex;
            }
            vm.page1 = false;
            vm.page3 = true;
        }
        $scope.singleIndexClick = function (item) {
            if(vm.article.editorType == 'PICTURE'|| vm.article.editorType == 'PICTURE_PRO' || vm.article.editorType == 'PICTURE_PRO_P'){
                vm.levelIndex = 0;
            }
            if ($scope.zfInit() != item) {
                if (item) {
                    vm.singleIndex++
                } else {
                    vm.singleIndex--
                }
            }
            $scope.photoGalleryHide();
        }
        $scope.previousPage = function () {
            if (vm.pictureType == 'spread') {
                if (!$scope.zfInit()) {
                    vm.singleIndex -= 2;
                } else {
                    vm.singleIndex--
                }
            } else {
                vm.singleIndex--;
            }
            if (vm.singleIndex < 0) {
                vm.singleIndex = 0;
            }
            vm.levelIndex = 0;
            $scope.photoGalleryHide();
        }
        $scope.nextPage = function () {
            if (vm.pictureType == 'spread') {
                if (!$scope.zfInit()) {
                    vm.singleIndex += 2;
                } else {
                    vm.singleIndex++;
                }
            } else {
                vm.singleIndex++;
            }

            if (vm.singleIndex > vm.singleData.length - 1) {
                vm.singleIndex = vm.singleData.length - 1;
            }
            vm.levelIndex = 0;
            $scope.photoGalleryHide();
        }

        $scope.zfInit = function () {
            if (vm.singleIndex % 2 === 0) {
                return false
            } else if (vm.singleIndex % 2 === 1) {
                return true
            }
        }
        $scope.singleInit = function (index) {
            if (vm.pictureType == 'spread') {
                return Math.ceil(index / 2)
            }
            return index
        }
        $scope.subtractDeleteTab = function ($event, index) {
            vm.data.splice(index, 1);
            getCostMethod()
            fn($event)
        }
        $scope.subtractQuantityTab = function (data) {
            if (data.quantity > 1) {
                data.quantity--;
                getCostMethod()
            }
        }
        $scope.pushQuantityTab = function (data) {
            data.quantity++;
            getCostMethod()
        }
        $scope.quantityChange = function (data) {
            getCostMethod()
        }

        //获取价格
        function getCostMethod() {
            vm.totalCount = 0;
            for (var k = 0; k < vm.data.length; k++) {
                if (vm.pictureType == 'spread') {
                    vm.totalCount += vm.data[k][0].quantity;
                } else {
                    vm.totalCount += vm.data[k].quantity;
                }
            }
            vm.totalCount *= 2;
        }

        $scope.fillImagebox = function () {
            vm.singleData[vm.singleIndex].levels.level.forEach(function (level, i) {
                if (level.imagebox && i == vm.levelIndex) {
                    var item = level.imagebox;
                    item.bokehtype = 'Transparent';
                    item.image.scale = 1;
                    if(item.blurredrectangle){
                        item.blurredrectangle.x = 0;
                        item.blurredrectangle.y = 0;
                    }
                    vm.imageboxLoad = true;
                    getBackgroundSource3(item, item.geometry.width, item.geometry.height, item.image, item.bokehtype, $scope, function () {
                        vm.imageboxLoad = false;
                    });
                }
            })
        }
        $scope.cutImagebox = function () {
            vm.singleData[vm.singleIndex].levels.level.forEach(function (level, i) {
                if (level.imagebox && i == vm.levelIndex) {
                    var item = level.imagebox;
                    item.bokehtype = 'None';
                    item.image.scale = 1;
                    if(item.blurredrectangle){
                        item.blurredrectangle.x = 0;
                        item.blurredrectangle.y = 0;
                    }
                    vm.imageboxLoad = true;
                    getBackgroundSource3(item, item.geometry.width, item.geometry.height, item.image, item.bokehtype, $scope, function () {
                        vm.imageboxLoad = false;
                    });
                }
            })
        }
        $scope.rotateImagebox = function () {
            if (vm.singleData[vm.singleIndex].levels.level[vm.levelIndex] && vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox) {
                var imagebox = vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox;
                imageboxRotate($scope, imagebox);
            }
        }
        $scope.imageboxFlip = function(){
            if (vm.singleData[vm.singleIndex].levels.level[vm.levelIndex] && vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox) {
                vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.flip = !vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.flip;
            }
        }

        /*******************************************照片框处理*************************************************************************/
        var isImagebox = false;
        var stickerDragBox = {};
        window.moveImageboxStart = function (e) {
            fn(e);
            var targ = e.currentTarget ? e.currentTarget : e.srcElement;
            var textIndex = targ.dataset.index;
            textIndex = parseInt(textIndex);
            vm.levelIndex = textIndex;
            var sticker = vm.singleData[vm.singleIndex].levels.level[textIndex].imagebox;
            $scope.$apply();
            if (sticker.bokehtype != 'None') {
                return
            }

            stickerDragBox.x = e.changedTouches[0].clientX != null ? e.changedTouches[0].clientX : 0;          //鼠标到页面左边的距离
            stickerDragBox.y = e.changedTouches[0].clientY != null ? e.changedTouches[0].clientY : 0;          //鼠标到页面顶部的距离
            stickerDragBox.l = sticker.image.offsetx * vm.ratio1;
            stickerDragBox.t = sticker.image.offsety * vm.ratio1;
            stickerDragBox.r = -(sticker.image.width - vm.singleData[vm.singleIndex].levels.level[textIndex].imagebox.geometry.width) * vm.ratio1;
            stickerDragBox.b = -(sticker.image.height - vm.singleData[vm.singleIndex].levels.level[textIndex].imagebox.geometry.height) * vm.ratio1;
            isImagebox = true;
            $scope.$digest();
        }
        window.moveImageboxOn = function (e) {
            var targ = e.currentTarget ? e.currentTarget : e.srcElement;
            var textIndex = targ.dataset.index;
            textIndex = parseInt(textIndex);
            var sticker = vm.singleData[vm.singleIndex].levels.level[textIndex].imagebox;
            if (vm.singleData[vm.singleIndex].levels.level[textIndex].imagebox.bokehtype != 'None') {
                return
            }
            fn(e);
            var angle = Number(sticker.rotation.angle);
            var cx = (stickerDragBox.l + stickerDragBox.r) / 2;
            var cy = (stickerDragBox.t + stickerDragBox.b) / 2;
            var pt0 = rotatePoint({x: stickerDragBox.x, y: stickerDragBox.y}, {x: cx, y: cy}, -angle);
            var pt1 = rotatePoint({x: e.touches[0].pageX, y: e.touches[0].pageY}, {x: cx, y: cy}, -angle);
            var deltaX = pt1.x - pt0.x;
            var deltaY = pt1.y - pt0.y;
            var nl = stickerDragBox.l + deltaX;
            var nt = stickerDragBox.t + deltaY;
            if (nl < stickerDragBox.r) {
                nl = stickerDragBox.r
            }
            ;
            if (nl > 0) {
                nl = 0
            }
            ;
            if (nt < stickerDragBox.b) {
                nt = stickerDragBox.b
            }
            ;
            if (nt > 0) {
                nt = 0
            }
            ;

            sticker.image.offsetx = nl / vm.ratio1;
            sticker.image.offsety = nt / vm.ratio1;
            $scope.$digest();
        }
        window.moveImageboxEnd = function (e) {
            fn(e);
            isImagebox = false;
            stickerDragBox = {}
        }
        $scope.singleSave = function () {
            vm.levelIndex = null;
            vm.data = [];
            if (vm.pictureType == 'single') {
                vm.data = vm.singleData;
            }
            if (vm.pictureType == 'spread') {
                var _data = [];
                vm.singleData.forEach(function (data, index) {
                    if (index % 2 === 0) {
                        //偶数
                        _data.push(data);
                    } else if (index % 2 === 1) {
                        //奇数
                        _data.push(data);
                        vm.data.push(_data);
                        _data = [];
                    }
                })
            }
            vm.page1 = true;
            vm.page3 = false;
            $scope.photoGalleryHide();
            scroll('page'+vm.singleIndex)
        };

        function scroll(id){
            $timeout(function () {
                var _top = $("#"+id).offset().top-60;
                $("html, body").animate({
                    scrollTop: _top + "px"
                }, {
                    duration: 0,
                    easing: "swing"
                });
            })
            return false;
        }
        $scope.isSave = false;
        function articleOverdue(callback){
            Article.get({id: vm.article.id}, function (article) {
                if(article.data.fileName != vm.article.fileName){
                    MessageService.minConfirm({
                        cancel:$translate.instant("button.cancel"),
                        confirm:$translate.instant("button.refresh"),
                        msg:$translate.instant("hint.articleOverdue")
                    },function(){
                        $state.go("editorPhotoEdit", {storeId: vm.storeId, aid:  vm.article.id},{reload:true,location: 'replace'});
                    })
                }else{
                    callback();
                }
            })
        }

        $scope.saveTab = function () {
            if(!vm.data ||vm.data.length==0){
                MessageService.hint($translate.instant('editorCommon.pleaseAddImage'));
                return
            }
            articleOverdue(function () {
                var _data = [];
                var _data1 = angular.copy(vm.data);
                var pageCount = 0;
                if (vm.pictureType == 'single') {
                    angular.forEach(_data1, function (item) {
                        for (var i = 0; i < item.quantity; i++) {
                            var itemData = angular.copy(item);
                            _data.push(itemData)
                        }
                    });
                    _data.forEach(function (data) {
                        data.quantity = 1;
                    })
                    pageCount = _data.length;
                }
                if (vm.pictureType == 'spread') {
                    _data1.forEach(function (data) {
                        for (var i = 0; i < data[0].quantity; i++) {
                            _data.push(data[0])
                            _data.push(data[1])
                        }
                    })
                    _data.forEach(function (data) {
                        data.quantity = 1;
                    })
                    pageCount = _data.length/2;
                }
                vm.article.articleStatus = "EDITING";
                if (vm.article.multiple) {//先编辑
                    if(vm.article.expectPageCount && vm.article.expectPageCount >= 0){
                        if(pageCount % vm.article.expectPageCount === 0){
                            vm.article.articleStatus = "COMPLETED";
                        }else{
                            MessageService.hint($translate.instant('editorCommon.printQuantityInfo', {pageCount: pageCount, expectPageCount: vm.article.expectPageCount}));
                            return
                        }
                    }else{
                        vm.article.articleStatus = "COMPLETED";
                    }
                }else{//先下单
                    if(vm.article.expectPageCount && vm.article.expectPageCount >= 0){
                        if(pageCount > vm.article.expectPageCount){
                            MessageService.hint($translate.instant('editorCommon.photoCountExceeded', {max: vm.article.expectPageCount}));
                            return
                        }
                        if(pageCount == vm.article.expectPageCount){
                            vm.article.articleStatus = "COMPLETED";
                        }
                    }else{
                        vm.article.articleStatus = "COMPLETED";
                    }
                }
                for (var i = 0; i < _data.length; i++) {
                    var _page = _data[i];
                    if (_page.levels.level) {
                        for (var j = 0; j < _page.levels.level.length; j++) {
                            var _level = _page.levels.level[j];
                            if (_level.imagebox) {
                                if (!_level.imagebox.image || !_level.imagebox.image.resource || !_level.imagebox.image.resource.identifier) {
                                    vm.article.articleStatus = "EDITING";
                                    break
                                }
                            }
                        }
                    }
                }
                if (!vm.placeOrder && !$scope.isSave) {
                    return
                }
                // 生成缩略图保存作品
                vm.threeLoading = true;
                thumbnailInit1(function () {
                    if (_data && _data.length > 0) {
                        var _page = [];
                        angular.forEach(_data, function (_data1) {
                            var item = angular.copy(_data1);
                            _page.push(item)
                        })
                        $scope.template.pages.page = _page;
                        $scope.template = documentMM($scope.template, null, null);
                        var backupPages = documentMM({pages:{page:[vm.signalPage1,vm.signalPage2]}}, null, null);
                        var list = $scope.template.backupPages && $scope.template.backupPages.list ? $scope.template.backupPages.list : [];
                        if(!list.some(function(item){return item.uuid == vm.signalPage1.uuid})){
                            list.push(backupPages.pages.page[0]);
                        }
                        if(!list.some(function(item){return item.uuid == vm.signalPage2.uuid})){
                            list.push(backupPages.pages.page[1]);
                        }
                        $scope.template.backupPages = {
                            list:list
                        }
                        $scope.isSave = true;
                        $scope.template.hostinfo = hostInfo();
                        $scope.template.pages.uuid1 = vm.signalPage1.uuid;
                        $scope.template.pages.uuid2 = vm.signalPage2.uuid;
                        Convert.articleUploadDocument($scope.template, function (res) {
                            vm.article.id = vm.aid;
                            vm.article.productType = 'CustomPrint';
                            vm.article.fileName = res.data.identifier;
                            vm.article.unFilledCount = 0;
                            vm.article.version = '2.0';
                            vm.article.pageCount = 0;
                            _page.forEach(function (itemPage) {
                                if(!itemPage.backup){
                                    vm.article.pageCount++
                                }
                            })
                            vm.article.saveUserName = localStorage.getItem('saveUserName') || ''
                            Article.update(vm.article, function (resp) {
                                vm.threeLoading = false;
                                $scope.isSave = false;
                                swal({
                                    title: $translate.instant("editorCommon.modifySuccess"),
                                    text: $translate.instant("editorCommon.synchronizationOfWorks"),
                                    imageUrl: Theme.sweetSuccedImg(),
                                    timer: 2000,
                                    showConfirmButton: false
                                });
                                $state.go("editorPhotoPreview", {storeId: vm.storeId, aid: resp.data.id},{location: 'replace'});
                            }, function () {
                                vm.threeLoading = false;
                                $scope.isSave = false;
                                swal({
                                    title: $translate.instant("editorCommon.saveError"),
                                    text: $translate.instant("editorCommon.saveError1"),
                                    imageUrl: Theme.sweetHintImg(),
                                    timer: 2000,
                                    showConfirmButton: false
                                });
                            })
                        }, function () {
                            $scope.isSave = false;
                            vm.threeLoading = false;
                            swal({
                                title: $translate.instant("editorCommon.saveError"),
                                text: $translate.instant("editorCommon.saveError1"),
                                imageUrl: Theme.sweetHintImg(),
                                timer: 2000,
                                showConfirmButton: false
                            });
                        })
                    }else{
                        vm.threeLoading = false;
                    }
                })
            })
        }
        function threeInfo(item) {
            vm.threeError = true;
            vm.threeErrorText = item;
            $timeout(function () {
                vm.threeError = false;
                vm.threeErrorText = "";
            }, 1500)
        }

        //像素不足提醒
        vm.imgSize = 150;
        vm.imgDpi = 150;
        StoreWorkEditConfig.storeId({storeId: vm.storeId}, function (res) {
            if (res.status == 200) {
                vm.imgSize = res.data.imgSize;
                vm.imgDpi = res.data.imgDpi;
            }
        });
        var throttledResize = angular.throttle(function (item) {
            console.log('No browser drain at each event please.');
            return pxInsufficient(item, vm.imgSize, vm.imgDpi)
        }, 1000);

        $scope.pxInsufficient = function (item) {
            // return throttledResize(item);
            return pxInsufficient(item, vm.imgSize, vm.imgDpi);
        }
        //边框
        $scope.imageboxW = function (imagebox) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.geometry.width) + Number(imagebox.border.lineWidth) * 2
                }
                if (imagebox.border.type == 'Pic') {
                    return imagebox.geometry.width
                    // return Number(imagebox.geometry.width) + (Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100) + (Number(imagebox.geometry.width) * Number(imagebox.border.edge.right) / 100)
                }
            } else {
                return imagebox.geometry.width
            }
        }
        $scope.imageboxH = function (imagebox) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.geometry.height) + Number(imagebox.border.lineWidth) * 2
                }
                if (imagebox.border.type == 'Pic') {
                    return imagebox.geometry.height
                    // return Number(imagebox.geometry.height) + (Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100) + (Number(imagebox.geometry.height) * Number(imagebox.border.edge.bottom) / 100)
                }
            } else {
                return imagebox.geometry.height
            }
        }
        $scope.imageboxL = function (imagebox) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.geometry.x) - Number(imagebox.border.lineWidth)
                }
                if (imagebox.border.type == 'Pic') {
                    return imagebox.geometry.x
                    // return Number(imagebox.geometry.x) - (Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100)
                }
            } else {
                return imagebox.geometry.x
            }
        }
        $scope.imageboxT = function (imagebox) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.geometry.y) - Number(imagebox.border.lineWidth)
                }
                if (imagebox.border.type == 'Pic') {
                    return imagebox.geometry.y
                    // return Number(imagebox.geometry.y) - (Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100)
                }
            } else {
                return imagebox.geometry.y
            }
        }
        $scope.imageboxWEdge = function (imagebox, edge) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.border.lineWidth)
                }
                if (imagebox.border.type == 'Pic') {
                    if (edge == 'left') {
                        return Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100
                    }
                    if (edge == 'top') {
                        return Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100
                    }
                    if (edge == 'right') {
                        return Number(imagebox.geometry.width) * Number(imagebox.border.edge.right) / 100
                    }
                    if (edge == 'bottom') {
                        return Number(imagebox.geometry.height) * Number(imagebox.border.edge.bottom) / 100
                    }
                }
            } else {
                return 0
            }
        }
        $scope.imageboxWRadius = function (imagebox, radius, ratio, ratio1) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                var _ratio = 1;
                if(ratio && ratio1){
                    if(imagebox.geometry.width > imagebox.geometry.height){
                        _ratio = ratio1
                    }else{
                        _ratio = ratio
                    }
                }
                if(ratio && !ratio1){
                    _ratio = ratio
                }
                if (imagebox.border.shape == 'Ellipse') {
                    return '50%'
                }
                if (imagebox.border.radius.filletType == 'Fixed') {//圆角固定值
                    var _radius = imagebox.border.radius[radius];
                    return _radius > 0 ?  (_radius + Number(imagebox.border.lineWidth)/2) * _ratio : 0;
                }else{
                    var radiusW = imagebox.geometry.width > imagebox.geometry.height ? imagebox.geometry.height : imagebox.geometry.width;
                    radiusW = radiusW + imagebox.border.lineWidth;
                    var _r = radiusW * imagebox.border.radius[radius] / 100;
                    return _r > 0 ? (_r + Number(imagebox.border.lineWidth)/2) * _ratio : 0
                }
            } else {
                return 0
            }
        }
        $scope.imageboxWRadius1 = function (imagebox, radius, ratio, ratio1) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                var _ratio = 1;
                if(ratio && ratio1){
                    if(imagebox.geometry.width > imagebox.geometry.height){
                        _ratio = ratio1
                    }else{
                        _ratio = ratio
                    }
                }
                if(ratio && !ratio1){
                    _ratio = ratio
                }
                if (imagebox.border.shape == 'Ellipse') {
                    return '50%'
                }
                if (imagebox.border.radius.filletType == 'Fixed') {//圆角固定值
                    var _radius = imagebox.border.radius[radius];
                    return  (_radius - Number(imagebox.border.lineWidth)/2) > 0 ? (_radius - Number(imagebox.border.lineWidth)/2) * _ratio : 0;
                }else{
                    var radiusW = imagebox.geometry.width > imagebox.geometry.height ? imagebox.geometry.height : imagebox.geometry.width;
                    radiusW = radiusW + imagebox.border.lineWidth;
                    var _r = radiusW * imagebox.border.radius[radius] / 100;
                    return (_r - Number(imagebox.border.lineWidth)/2) > 0 ? (_r - Number(imagebox.border.lineWidth)/2) * _ratio : 0
                }
            } else {
                return 0
            }
        }
        $scope.dropShadow = function (imagebox, ratio, ratio1) {
            if (imagebox.shadow == null) {
                return
            }
            var width = $scope.imageboxW(imagebox) * ratio;
            var height = $scope.imageboxH(imagebox) * ratio1;
            return dropShadow(imagebox, width, height)
        }
        //图片框的操作
        $scope.imageboxSite = function (item) {
            if (!vm.singleData[vm.singleIndex].levels.level[vm.levelIndex] || vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.bokehtype != 'None') {
                return
            }
            var _imagebox = vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox;
            if (item == 'center') {
                _imagebox.image.offsetx = -(_imagebox.image.width * _imagebox.image.scale - _imagebox.geometry.width) / 2 / _imagebox.image.scale;
                _imagebox.image.offsety = -(_imagebox.image.height * _imagebox.image.scale - _imagebox.geometry.height) / 2 / _imagebox.image.scale;
            }
            if (_imagebox.image.offsetx > 0) {
                _imagebox.image.offsetx = 0;
            }
            if (_imagebox.image.offsety > 0) {
                _imagebox.image.offsety = 0;
            }
        }

        //生成封面图
        function thumbnailInit1(callback) {
            $timeout(function () {
                html2canvas_adapt(document.getElementById('thumbnail-view1'), {
                    onrendered: function (canvas) {
                        if(canvas){
                            QiniuToken.uploadThumbnail(canvas, function (data) {
                                var identifier = data.key;
                                vm.article.covered = true;
                                vm.article.cover = identifier;
                                if (callback) {callback()};
                            }, function () {
                                vm.article.covered=false;
                                vm.article.cover=null;
                                if (callback) {callback()};
                            });
                        }else{
                            vm.article.covered=false;
                            vm.article.cover=null;
                            if (callback) {callback()};
                        }
                    },
                    error:function(){
                        vm.article.covered=false;
                        vm.article.cover=null;
                        if (callback) {callback()};
                    },
                    letterRendering: true,
                    useCORS: true,
                    width: $scope.template.pages.page[0].custom.width * $scope.template.pages.page[0].custom.thumbnailScale,
                    height: $scope.template.pages.page[0].custom.height * $scope.template.pages.page[0].custom.thumbnailScale,
                    windowWidth: document.body.scrollWidth,
                    windowHeight: document.body.scrollHeight,
                    x: 0,
                    y: 0,
                    backgroundColor: "rgba(0, 0, 0, 0)"
                });
            })
        }
        /*******************************************点击素材*************************************************************************/
        $scope.materialShow = function (){
            vm.isClassify = true;
        }
        vm.repeatAddNumber = 0;
        $scope.addMaterial = function (text){
            var item = JSON.parse(text);
            vm.singleData[vm.singleIndex].levels.level.push(item);
        }
        $scope.closeMaterial = function (text){
            vm.isClassify = false;
        }
        /*******************************************点击素材end*************************************************************************/
        /*******************************************文字*************************************************************************/
        //获取所有字体
        getAllFont();
        vm.fontList = [];
        function getAllFont() {
            vm.fontList = [];
            FontManagement.getAll({}, function (res) {
                vm.fontList = res;
            });
        }
        vm.textboxType = null;
        $scope.fontShow = function (){
            vm.textboxType = 'add';
        }
        $scope.textboxAdd = function (text){
            // var item = JSON.parse(text);
            $scope.photoGalleryHide();
        }
        $scope.textboxEdit = function (text){
            var item = JSON.parse(text);
            vm.singleData[vm.singleIndex].levels.level = item;
        }
        $scope.textboxDelete = function (){
            if (vm.singleData[vm.singleIndex].levels.level[vm.levelIndex] && vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].textbox) {
                vm.singleData[vm.singleIndex].levels.level.splice(vm.levelIndex, 1);
                $scope.photoGalleryHide()
            }
        }
        vm.sizeHeight1 = sizeHeight1;
        function sizeHeight1() {
            $timeout(function () {
                var _h = Number($("#c-xml-page-material-fontId1 span").height()) + Number(10);
                var _w = Number($("#c-xml-page-material-fontId1 span").width()) + Number(10);
                var _sizeWidth = getTextWidthInternal(vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].textbox.text, vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].textbox.style.bold, vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].textbox.style.italic, vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].textbox.style.size, vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].textbox.fontuuid);
                if(!writingmodeInit(vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].textbox.style.writingmode)){
                    vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].textbox.geometry.height = _h;
                    if(vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].textbox.geometry.width < vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].textbox.style.size){
                        vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].textbox.geometry.width = vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].textbox.style.size;
                    }
                    if(vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].textbox.geometry.width < _sizeWidth){
                        item.geometry.width = (Number(_sizeWidth) + Number(5));
                        return;
                    }
                }
                if(writingmodeInit(vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].textbox.style.writingmode)){
                    vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].textbox.geometry.width = _w;
                    if(vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].textbox.geometry.height < _sizeWidth){
                        vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].textbox.geometry.height = _sizeWidth;
                    }
                }
            })
        }
        /*******************************************文字end*************************************************************************/
        /*******************************************点击图片库*************************************************************************/
        vm.mapDepot = false;
        vm.isRecommend = false;
        $scope.photoGalleryShow = function (isRecommend) {
            vm.isRecommend = isRecommend;
            vm.mapDepot = true;
            vm.mapDepot2 = true;
            vm.mapDepot1 = false;
            if(!isRecommend){
                vm.photoAll = [];
                vm.indexNum = 0;
                vm.photoCompleted = false;
                loadAll('isNull');
            }else{
                ThemeClassify.getAllByCondition4({
                    type: 'RECOMMENDPIC',
                    storeId: vm.storeId
                }, function (res) {
                    if(res.data){
                        vm.recommendClassify = res.data;
                        vm.recommendClassifyItem = res.data[0];
                    }
                });
            }
        }

        vm.levelDome = function(item){
            vm.isClassify = false;
        }
        $scope.photoGalleryHide = function () {
            vm.mapDepot = false;
            vm.isClassify = false;
            vm.textboxSelect = false;
            vm.isLayout = false;
            vm.textboxType = null;
            if(vm.article.editorType == 'PICTURE_PRO' || vm.article.editorType == 'PICTURE_PRO_P'){
                vm.levelIndex = null;
            }
        }
        $('#photoGallery').on('scroll', function(event){
            var realScrollHeight=event.currentTarget.clientHeight+event.currentTarget.scrollTop;
            if(!vm.photoCompleted){
                if((event.currentTarget.scrollHeight-1)<realScrollHeight && realScrollHeight < (event.currentTarget.scrollHeight+1)){
                    vm.indexNum++
                    loadAll("isNull")
                }
            }
        })
        var dragGal = {};
        var drag = false;
        var startChangeTimeout;
        vm.isSmallPic = false;
        window.startChange = function (e) {
            startChangeTimeout = setTimeout(function() {
                vm.isSmallPic = true;
                $scope.$digest();
            }, 200);
            drag = true;
            var i = e.target.dataset.imgindex;
            if(i >=0){
                if(vm.mapDepot1){
                    $scope.galleryArr = vm.photoSelectAll1[i];
                    $scope.galleryChoose = vm.photoSelectAll1[i].identifier;
                    if(vm.photoAll[i].largeFlag){
                        $scope.galleryChoose = vm.photoAll[i].identifier+'.thumbnail.jpg';
                    }
                }
                if(vm.isRecommend){
                    $scope.galleryArr = vm.recommendPics[i];
                    $scope.galleryChoose = vm.recommendPics[i].identifier;
                }else{
                    $scope.galleryArr = vm.photoAll[i];
                    $scope.galleryChoose = vm.photoAll[i].identifier;
                    if(vm.photoAll[i].largeFlag){
                        $scope.galleryChoose = vm.photoAll[i].identifier+'.thumbnail.jpg';
                    }
                }

                $scope.galleryId = i;
                $scope.galleryX = e.changedTouches[0].clientX ? e.changedTouches[0].clientX - 53 : 0;
                $scope.galleryY = e.changedTouches[0].clientY ? e.changedTouches[0].clientY - 40 : 0;
                dragGal.clientX = e.changedTouches[0].clientX ? e.changedTouches[0].clientX : 0;
                dragGal.clientY = e.changedTouches[0].clientY ? e.changedTouches[0].clientY : 0;
                dragGal.pageX = e.changedTouches[0].pageX ? e.changedTouches[0].pageX : 0;
                dragGal.pageY = e.changedTouches[0].pageY ? e.changedTouches[0].pageY : 0;
                dragGal.coordX = $scope.galleryX;
                dragGal.coordY = $scope.galleryY;
                $scope.$digest();
                return false;
            }
        };

        window.dragChange = function (e) {
            clearTimeout(startChangeTimeout);
            if (drag) {
                //手指离开屏幕
                $scope.galleryX = (dragGal.coordX + (e.changedTouches[0].clientX - dragGal.clientX));
                $scope.galleryY = (dragGal.coordY + (e.changedTouches[0].clientY - dragGal.clientY));

                // if (Math.abs($scope.galleryY - dragGal.coordY) > 100) {
                //     vm.isSmallPic = true;
                // }


                //向上滑动;
                if ($scope.galleryY <= 0) {
                    $scope.galleryY = 0;
                }
                //向左滑动;        <-----
                if ($scope.galleryX <= 0) {
                    $scope.galleryX = 0;
                }
                //向下滑动;
                if ($scope.galleryY >= $scope.dHeight - 62) {
                    $scope.galleryY = $scope.dHeight - 62;
                }
                // 向右滑动;    ---->
                if ($scope.galleryX >= $scope.dWidth - 62) {
                    $scope.galleryX = $scope.dWidth - 62;
                }

                var _picTop = $("#small-pic").offset().top;
                var _picLeft = $("#small-pic").offset().left;
                var _exist = false;
                for (var i1 = vm.singleData[vm.singleIndex].levels.level.length-1; i1 >= 0; i1--) {
                    var _level = vm.singleData[vm.singleIndex].levels.level[i1];
                    if (_level.imagebox) {
                        var _imageboxLeft = $(".imagebox" + i1).offset().left;
                        var _imageboxTop = $(".imagebox" + i1).offset().top;
                        var _imageboxRight = _imageboxLeft + $(".imagebox" + i1).width();
                        var _imageboxBottom = _imageboxTop + $(".imagebox" + i1).height();
                        if ((_imageboxTop < _picTop) && (_picTop < _imageboxBottom) && (_imageboxLeft < _picLeft) && (_picLeft < _imageboxRight) && !_exist) {
                            _exist = true;
                            $(".imagebox" + i1).find(".imageboxHint").css("background", "rgba(103, 106, 108, 0.8)")
                            break;
                        }else{
                            $(".imagebox" + i1).find(".imageboxHint").css("background", "rgba(0,0,0,0.2)")
                        }
                    }
                }
                $scope.$digest();
                return false;
            }
        };
        window.stopChange = function (e) {
            clearTimeout(startChangeTimeout);
            if (!drag) {
                return
            }
            drag = false;
            var _picTop = $("#small-pic").offset().top;
            var _picLeft = $("#small-pic").offset().left;
            for (var i1 = vm.singleData[vm.singleIndex].levels.level.length-1; i1 >= 0; i1--) {
                var _level = vm.singleData[vm.singleIndex].levels.level[i1];
                if (_level.imagebox) {
                    var _imageboxLeft = $(".imagebox" + i1).offset().left;
                    var _imageboxTop = $(".imagebox" + i1).offset().top;
                    var _imageboxRight = _imageboxLeft + $(".imagebox" + i1).width();
                    var _imageboxBottom = _imageboxTop + $(".imagebox" + i1).height();
                    if ((_imageboxTop < _picTop) && (_picTop < _imageboxBottom) && (_imageboxLeft < _picLeft) && (_picLeft < _imageboxRight)) {
                        $scope.replaceImagebox1($scope.galleryArr, i1)
                        break;
                    }
                }
            }
            vm.isSmallPic = false;
            $scope.$digest();
        };

        $scope.replaceImagebox1 = function (data, index) {
            vm.levelIndex = index;
            replaceImagebox(data)
        }

        function replaceImagebox(data, callback) {
            var item = angular.copy(data);
            var _imagebox = vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox;
            _imagebox.whiteInk = null;
            _imagebox.whiteInk2 = null;
            _imagebox.image = {
                resource: {
                    identifier: item.identifier,
                    provider: 'qiniu'
                },
                resourceid:item.sourceId,
                filterResource: {
                    identifier: '',
                    provider: 'qiniu'
                },
                imageInfo: item.imageInfo,
                width: item.width,
                height: item.height,
                imgSize: item.imgSize,
                index: item.seq,
                parameter: angular.fromJson(item.parameter),
                scale: 1,
                angle: 0,
                largeFlag: item.largeFlag,
                largeStatus: item.largeStatus,
                convertFlag: item.convertFlag,
                convertStatus: item.convertStatus,
                stripKey: item.stripKey,
                thumbnailKey: item.thumbnailKey
            }
            _imagebox.blurredrectangle = {
                width: '',
                height: '',
                x: '',
                y: '',
            };
            if(vm.pictureType == 'spread'){
                getBlurredrectangle(_imagebox, $scope.zfInit() ? 1 : 0);
            }else{
                getBlurredrectangle(_imagebox, 0);
            }
        }
        function photoSelectAllInit() {
            vm.photoSelectAll1 = [];
            if(vm.singleData){
                vm.singleData.forEach(function (page) {
                    page.levels.level.forEach(function (level) {
                        if(level.imagebox && level.imagebox.image && level.imagebox.image.resource && level.imagebox.image.resource.identifier){
                            var _img = level.imagebox.image;
                            var photo = {
                                identifier:_img.resource.identifier,
                                width:_img.imgWidth,
                                height:_img.imgHeight,
                                imgSize:_img.size,
                                imageInfo:_img.imageInfo,
                                resourceid:_img.resourceid,
                                id:_img.resourceid,
                                largeFlag:_img.largeFlag,
                                largeStatus:_img.largeStatus,
                                convertFlag:_img.convertFlag,
                                convertStatus:_img.convertStatus,
                                stripKey:_img.stripKey,
                                thumbnailKey:_img.thumbnailKey
                            }
                            // 大图/色彩转换需要展示缩略图identifier1
                            if(photo.largeFlag || photo.thumbnailKey){
                                photo.identifier1 = photo.largeFlag
                                    ? (photo.identifier + '.thumbnail.jpg')
                                    : ($scope.domain + photo.thumbnailKey);
                            }
                            var _is = false;
                            for(var i=0; i<vm.photoSelectAll1.length; i++){
                                if(vm.photoSelectAll1[i].id == level.imagebox.image.resourceid){
                                    _is = true;
                                    break
                                }
                            }
                            if(!_is){
                                vm.photoSelectAll1.push(photo)
                            }
                        }
                    })
                })
            }
        }

        $scope.addImageboxImg = function (item) {
            if(vm.singleData && vm.singleData[vm.singleIndex] && vm.singleData[vm.singleIndex].levels.level && vm.singleData[vm.singleIndex].levels.level[vm.levelIndex] && vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox){
                replaceImagebox(item)
            }
        };

        // 图库照片处理状态：大图处理中/失败、色彩转换中/失败，无特殊状态返回''（正常展示照片）
        $scope.photoStatus = function (photo) {
            if (!photo) return '';
            if (photo.convertFlag == true && photo.convertStatus == 'running') return 'convertRunning';
            if (photo.convertStatus == 'error') return 'convertError';
            if (photo.largeFlag && photo.largeStatus == 'running') return 'largeRunning';
            if (photo.largeFlag && photo.largeStatus == 'error') return 'largeError';
            return '';
        };
        // 是否处理失败状态（大图处理失败、色彩转换失败）
        $scope.isPhotoFailed = function (photo) {
            var status = $scope.photoStatus(photo);
            return status === 'largeError' || status === 'convertError';
        };
        // 处理中的照片不可选中/添加到画布，处理失败的照片点击弹出删除确认框
        $scope.onPhotoStatusClick = function (photo, event) {
            if (event) {
                event.stopPropagation();
            }
            if ($scope.isPhotoFailed(photo)) {
                vm.pendingDeletePhoto = photo;
                vm.deletePhotoSure = true;
            }
        };
        // 确认删除处理失败的照片，取消则仅关闭弹框
        $scope.deletePhotoConfirm = function () {
            var photo = vm.pendingDeletePhoto;
            if (!photo || !photo.id) {
                vm.deletePhotoSure = false;
                vm.pendingDeletePhoto = null;
                return;
            }
            var id = photo.id;
            Gallery.batchDelete([id], function () {
                MessageService.success($translate.instant('nav.photograph.content.deletePhoto.success'));
                // 清除画布中引用该照片的图片框（兼容 single/spread 两种 pages 结构）
                var clearCanvasRefs = function (pages) {
                    if (!pages || !pages.length) return;
                    angular.forEach(pages, function (pageItem) {
                        // spread 类型 pageItem 为 [frontPage, versoPage] 数组；single 类型 pageItem 为单页对象
                        var pageList = Array.isArray(pageItem) ? pageItem : [pageItem];
                        angular.forEach(pageList, function (page) {
                            if (page && page.levels && page.levels.level) {
                                angular.forEach(page.levels.level, function (level) {
                                    if (level.imagebox && level.imagebox.image &&
                                        (level.imagebox.image.resourceid == id ||
                                        (photo.sourceId != null && level.imagebox.image.resourceid == photo.sourceId))) {
                                        var box = level.imagebox;
                                        box.blurredrectangle = {
                                            x: 0,
                                            y: 0,
                                            width: box.geometry ? box.geometry.width : '',
                                            height: box.geometry ? box.geometry.height : ''
                                        };
                                        box.imgUrl = 'content/images/mask_souce.png';
                                        box.image = {
                                            resource: {
                                                identifier: '',
                                                provider: ''
                                            },
                                            filterResource: {
                                                identifier: '',
                                                provider: ''
                                            },
                                            offsetx: 0,
                                            offsety: 0,
                                            width: '',
                                            height: '',
                                            imgsize: '',
                                            index: '',
                                            parameter: [],
                                            scale: 1,
                                            angle: 0
                                        };
                                    }
                                });
                            }
                        });
                    });
                };
                if (vm.singleData && vm.singleData.length) {
                    clearCanvasRefs(vm.singleData);
                }
                if (vm.data && vm.data.length) {
                    clearCanvasRefs(vm.data);
                }
                // 从本地图库列表及已选集合中移除
                var removeFromList = function (list) {
                    if (!list || !list.length) return;
                    for (var i = list.length - 1; i >= 0; i--) {
                        if (list[i].id === id) {
                            list.splice(i, 1);
                        }
                    }
                };
                removeFromList(vm.photoAll);
                removeFromList(vm.photoSelectAll);
                removeFromList(vm.photoSelectAll1);
                getPagePhoto();
                photoSelectAllInit();
                vm.deletePhotoSure = false;
                vm.pendingDeletePhoto = null;
            }, function () {
                vm.deletePhotoSure = false;
                vm.pendingDeletePhoto = null;
                MessageService.error($translate.instant('nav.photograph.content.deletePhoto.failed'));
            });
        };

        // 子组件点击处理失败的照片时emit此事件，由父级弹出删除确认框
        $scope.$on('requestDeletePhoto', function (event, photo) {
            if (photo && $scope.isPhotoFailed(photo)) {
                vm.pendingDeletePhoto = photo;
                vm.deletePhotoSure = true;
            }
        });

        //复制背面
        vm.isCopyBack = false;
        vm.copyBackIndex == null;
        $scope.copyBack = function($event, index){
            fn($event)
            vm.isCopyBack = true;
            vm.copyBackIndex = index;
        }
        $scope.copyHide = function(){
            vm.isCopyBack = false;
            vm.copyBackIndex == null;
            vm.data.forEach(function(data){
                data[1].isCopyBack = false;
            })
        }
        $scope.copyAll = function(){
            vm.data.forEach(function(data,dataIndex){
                if(dataIndex != vm.copyBackIndex){
                    var outline = JSON.parse(JSON.stringify(data[1].outline));
                    data[1] = JSON.parse(JSON.stringify(vm.data[vm.copyBackIndex][1]));
                    data[1].uuid = uuid();
                    data[1].outline = outline;
                    data[1].isCopyBack = true;
                }
            })
            MessageService.hint($translate.instant("editorCommon.copySuccess"))
        }
        $scope.editorPageCopyHere = function($event, index){
            fn($event)
            var outline = JSON.parse(JSON.stringify(vm.data[index][1].outline));
            vm.data[index][1] = JSON.parse(JSON.stringify(vm.data[vm.copyBackIndex][1]));
            vm.data[index][1].uuid = uuid();
            vm.data[index][1].outline = outline;
            vm.data[index][1].isCopyBack = true;
            MessageService.hint($translate.instant("editorCommon.copySuccess"))
        }
        //布局库
        vm.isLayout = false;
        $scope.reserveShow = function(){
            vm.isLayout = true;
        }
        $scope.layoutCb = function(item){
            if(vm.singleData[vm.singleIndex].config.partid!=item.config.partid){
                MessageService.hint($translate.instant("editorMessage.不是相同部件的版式不可替换"));
                return
            }
            if(item.uuid != vm.singleData[vm.singleIndex].uuid){
                vm.threeLoading = true;
                vm.threeLoadingText = $translate.instant("editorCommon.loadingText2");
                item.config = vm.singleData[vm.singleIndex].config;
                var pages = {
                    config:$scope.template.config,
                    pages:{
                        page: [angular.copy(item)]
                    }
                }
                documentAnalysis($scope, $http, vm, pages,FontManagement,'processing', function(page){
                    ratioInfo(page)
                }, function () {
                    $timeout(function () {
                        var layoutPage = pages.pages.page[0];
                        layoutPage.backup = false;
                        layoutPage.unreplace = false;
                        layoutPage.quantity = vm.singleData[vm.singleIndex].quantity;
                        pageDataInfo(layoutPage)
                    },200)
                })
            }
        }
        function pageDataInfo(page) {
            vm.threeLoading = true;
            vm.threeLoadingText = $translate.instant("editorCommon.loadingText2");
            page.uuid = getUuid();
            var _pageData = angular.copy(vm.singleData[vm.singleIndex]);
            var _pageDataImageboxImage = [];
            var _pageDataImageboxImageSum = 0;
            for(var i=0; i<_pageData.levels.level.length; i++){
                var _lecel = _pageData.levels.level[i];
                if(_lecel.imagebox && _lecel.imagebox.image && _lecel.imagebox.image.resource && _lecel.imagebox.image.resource.identifier){
                    _lecel.imagebox.imgRatio = _lecel.imagebox.image.width/_lecel.imagebox.image.height;
                    _pageDataImageboxImage.push(_lecel.imagebox)
                }
            }
            if(!page.levels.level){
                page.levels.level=[];
            }
            _pageDataImageboxImage = imageboxAdapt(page.levels.level, _pageDataImageboxImage);
            angular.forEach(page.levels.level, function (level, i) {
                if (level.imagebox) {
                    var _imagebox = null;
                    for(var j=0; j<_pageDataImageboxImage.length; j++){
                        if(_pageDataImageboxImage[j].imageboxIndex == _pageDataImageboxImageSum){
                            _imagebox = _pageDataImageboxImage[j];
                            break
                        }
                    }
                    _pageDataImageboxImageSum++;
                    if (_imagebox) {
                        level.imagebox.bokehtype = level.imagebox.bokehtype || vm.article.bokehtype || 'None';
                        level.imagebox.whiteInk = null;
                        level.imagebox.whiteInk2 = null;
                        level.imagebox.image = {
                            blurredrectangle: {
                                width: 0,
                                height: 0,
                                x: 0,
                                y: 0
                            },
                            resource: {
                                identifier: _imagebox ? _imagebox.image.resource.identifier : '',
                                provider: _imagebox ? _imagebox.image.resource.provider : 'qiniu'
                            },
                            resourceid:_imagebox ? _imagebox.image.resourceid : '',
                            filterResource: {
                                identifier: '',
                                provider: 'qiniu'
                            },
                            angle: 0,
                            offsetx: 0,
                            offsety: 0,
                            imageInfo: _imagebox? _imagebox.image.imageInfo : '',
                            width: _imagebox ? _imagebox.image.width : '',
                            height: _imagebox ? _imagebox.image.height : '',
                            imgSize: _imagebox ? _imagebox.image.imgSize : '',
                            index: _imagebox ? _imagebox.image.seq : '',
                            parameter: _imagebox ? angular.fromJson(_imagebox.image.parameter) : [],
                            scale: 1,
                            brightness:_imagebox ?_imagebox.image.brightness : 0,
                            contrast: _imagebox ?_imagebox.image.contrast : 0,
                            saturate: _imagebox ?_imagebox.image.saturate : 0,
                            temperature: _imagebox ?_imagebox.image.temperature : 0,
                            hue: _imagebox ?_imagebox.image.hue : 0
                        }
                        level.imagebox.blurredrectangle = {
                            width:'',
                            height:'',
                            x:'',
                            y:'',
                        };
                        if (level.imagebox.image.resource.identifier) {
                            if(vm.pictureType == 'spread'){
                                getBlurredrectangle(level.imagebox, $scope.zfInit() ? 1 : 0);
                            }else{
                                getBlurredrectangle(level.imagebox, 0);
                            }
                        }
                    } else {
                        level.imagebox.bokehtype = level.imagebox.bokehtype || vm.article.bokehtype || 'None';
                        level.imagebox.whiteInk = null;
                        level.imagebox.whiteInk2 = null;
                        level.imagebox.image = {
                            resource: {
                                identifier: '',
                                provider: ''
                            },
                            resourceid:"",
                            filterResource: {
                                identifier: '',
                                provider: ''
                            },
                            width: '',
                            height: '',
                            imgSize: '',
                            offsetx: 0,
                            offsety: 0,
                            index: '',
                            parameter: [],
                            scale: 1,
                            angle: 0,
                        }
                    }
                }
            })
            $timeout(function () {
                vm.singleData[vm.singleIndex] = page;
                vm.singleData[vm.singleIndex].backup = false;
                vm.singleData[vm.singleIndex].unreplace = false;
                vm.threeLoading = false;
                vm.threeLoadingText = '';
                MessageService.hint($translate.instant("editorCommon.changePageSuccess"));
            },200)
        }
        // 抠图
        $scope.mattingOpen = function () {
            vm.imageboxCutout = {
                image: vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.image.resource.identifier,
                mattingMask: vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.image.mattingMask,
                resourceid: vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.image.resourceid,
                angle: vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.image.angle,
                flip: vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.flip,
            }
            vm.isShowImageCutout = true;
        };
        $scope.imageCutoutChange = function(text){
            if(text){
                vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.image.resource.identifier = text.result;
                vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.image.mattingMask = text.mattingMask;
                vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.image.angle = text.angle;
                vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.flip = text.flip;
            }
        }
        $scope.imageCutoutSave = function(text){
            vm.isShowImageCutout = false;
            if(text){
                vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.image.resource.identifier = text.result;
                vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.image.mattingMask = text.mattingMask;
                vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.image.angle = text.angle;
                vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.flip = text.flip;
                if(vm.propertyValue.white && vm.propertyValue.white.length){
                    setProcessImages(vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox,vm.propertyValue.white[0]);
                }
            }
        }
        
        function setProcessImages(imagebox,white){
            vm.threeLoading=true;
            vm.threeLoadingText = $translate.instant("editorCommon.loadingText5");
            if(imagebox.image && imagebox.image.resource && imagebox.image.resource.identifier){
                processImages(imagebox.image.resource.identifier,null,function(res){
                    var blob = base64ToBlob(res, 'image/' + imagebox.image.imageInfo.format);
                    var _file = blobToFile(blob); 
                    ImageService.backendUploadPics(_file, $scope.domain, vm.token, function(data){
                        vm.threeLoading=false;
                        imagebox.whiteInk = null;
                        imagebox.whiteInk2 = {
                            resource:{
                                identifier:$scope.domain +data.key
                            },
                            growMethod: white.epitaxy,
                            growValue: white.epitaxyValue,
                            unit: white.unit,
                            color: white.spotColor,
                            colorValue: white.color,
                        };
                        $scope.$apply();
                    },function(err){
                        vm.threeLoading=false;
                        $scope.$apply();
                    })
                },function(error){
                    vm.threeLoading=false;
                    MessageService.error(error);
                })
            }else{
                vm.threeLoading=false;
                MessageService.error($translate.instant('chalk.message.addImageFirst'));
            }
        }
        // 是否大图
        $scope.isLarge = function(imageInfo){
            if(!imageInfo)return
            return imageInfo.size >= 20971520 || imageInfo.width > 30000 || imageInfo.height > 30000 || (imageInfo.width*imageInfo.height)>150000000
        }
        function getPropertyValue(){
            vm.propertyValue = {
                white:[],
                hotStamp:[],
                uv:[],
                fluore:[],
                outline:[]
            };
            if(vm.article.editorType == 'PICTURE_PRO_P' && vm.itemValue && vm.itemValue.objectValues){
                var skuNumber = vm.itemValue.skuNumber.split('-');
                vm.itemValue.objectValues.forEach(function (object) {
                    object.propertyValues.forEach(function (propertyValue) {
                        var _skuNumber = propertyValue.propertyId + '_' + propertyValue.id;
                        if(skuNumber.indexOf(_skuNumber) > -1){
                            var processOperation = {
                                id:object.processOperationId,
                                name:object.processOperationName,
                                type:object.processOperationType,
                                epitaxy:null,
                                epitaxyValue:object.processOperationEpitaxyValue,
                                spotColor:propertyValue.spotColor,
                                operationValueAlias:propertyValue.operationValueAlias,
                                color:propertyValue.color,
                                value:propertyValue.value,
                                unit:'mm',
                                uuid: _skuNumber
                            }
                            switch (object.processOperationEpitaxy) {
                            case 'EXTENSION':
                                processOperation.epitaxy = 'expand';
                                break;
                            case 'SHRINKAGE':
                                processOperation.epitaxy = 'shrink';
                                break;
                            default:
                                processOperation.epitaxy = null;
                            }
                            if(object.processOperationUnit == 'px'){
                                processOperation.epitaxyValue = PxTurnMm(processOperation.epitaxyValue);
                            }
                            if(object.processOperationType == 'WHITE_INK'){
                                vm.propertyValue.white.push(processOperation);
                            }
                            if(object.processOperationType == 'HOT_STAMP'){
                                vm.propertyValue.hotStamp.push(processOperation);
                            }
                            if(object.processOperationType == 'UV'){
                                vm.propertyValue.uv.push(processOperation);
                            }
                            if(object.processOperationType == 'FLUORESCENT'){
                                vm.propertyValue.fluore.push(processOperation);
                            }
                            if(object.processOperationType == 'DIE_LINE'){
                                vm.propertyValue.outline.push(processOperation);
                            }
                        }
                    })
                })
            }
        }
        
        vm.operationTab = 'picture';
        $scope.operationTabCb = function(item){
            vm.operationTab = item;
        }
        vm.chalkImagebox = null;
        vm.chalkImageart = null;
        vm.chalkWidth = null;
        vm.chalkHeight = null;
        vm.chalkPropertyValue = null;
        $scope.editChalkImagebox = function(type, propertyValue){
            if(type){
                vm.chalkImageart = angular.copy($scope.getImageart(vm.singleData[vm.singleIndex],vm.operationTab, propertyValue) || {});
                vm.chalkWidth = vm.singleData[vm.singleIndex].mediabox.width;
                vm.chalkHeight = vm.singleData[vm.singleIndex].mediabox.height;
                vm.chalkPropertyValue = propertyValue;
                return
            }
            if(vm.propertyValue.white && vm.propertyValue.white.length){
                vm.chalkPropertyValue = vm.propertyValue.white[0];
            }
            if(!vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.image || !vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.image || !vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.image.resource || !vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.image.resource.identifier){
                MessageService.hint($translate.instant("editorCommon.pleaseAddImage"));
                return
            }
            vm.chalkImagebox = angular.copy(vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox);
            vm.chalkWidth = vm.chalkImagebox.image.imageInfo.width;
            vm.chalkHeight = vm.chalkImagebox.image.imageInfo.height;
        }
        $scope.chalkChange = function(text){
            if(text){
                if(vm.operationTab == 'uv' || vm.operationTab == 'fluore'){
                    var imageart = $scope.getImageart(vm.singleData[vm.singleIndex],vm.operationTab, vm.chalkPropertyValue);
                    if(imageart){
                        imageart = text;
                    }else{
                        vm.singleData[vm.singleIndex].levels.level.push({
                            seq: vm.singleData[vm.singleIndex].levels.level.length + 1,
                            imageart: text
                        });
                    }
                }else{
                    vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox = text;
                }
            }
            vm.chalkImagebox = null;
            vm.chalkImageart = null;
        }
        
        window.uploadColor = function ($event,hotStamp) {
            var file = $event.target.files[0]; // 获取上传的文件
            if(hotStamp){hotStamp = JSON.parse(hotStamp)}
            if (!file.type.startsWith('image/png')) {
                MessageService.hint($translate.instant("editorCommon.hotStampingPngOnly", {type: file.type}));
                return;
            }
            ImageService.backendUploadPics(file, $scope.domain, vm.token, function(data){
                imageartAdd($http, $scope.domain +data.key, vm.singleData[vm.singleIndex].trimbox, function(imageart){
                    if(vm.repeatAddNumber>4){
                        vm.repeatAddNumber = 0;
                    }
                    var _num = 10*vm.repeatAddNumber;
                    imageart.geometry.x += _num/vm.singleData[vm.singleIndex].custom.ratio1;
                    imageart.geometry.y += _num/vm.singleData[vm.singleIndex].custom.ratio1;
                    if(vm.operationTab == 'TECHNIQUE' && hotStamp){
                        imageart.spotColor = {
                            color: hotStamp.color,
                            code: hotStamp.spotColor,
                            name: hotStamp.value,
                            growMethod: hotStamp.epitaxy,
                            growValue: hotStamp.epitaxyValue,
                            unit: hotStamp.unit,
                            uuid: hotStamp.uuid
                        };
                        imageart.serviceType = "stamping";
                    }
                    var _level = {
                        seq: vm.singleData[vm.singleIndex].levels.level.length + 1,
                        imageart: imageart
                    }
                    vm.singleData[vm.singleIndex].levels.level.push(_level);
                    vm.repeatAddNumber++;
                }, vm.singleData[vm.singleIndex].custom.ratio1)
                $scope.$apply();
            },function(err){
                MessageService.error($translate.instant("editorCommon.whiteInkSizeMismatch"));
                $scope.$apply();
            })
        };
        $scope.getImageart = function(page,serviceType,propertyValue){
            var imageart = null;
            if(page && page.levels && page.levels.level){
                for(var i=0; i<page.levels.level.length; i++){
                    if(page.levels.level[i].imageart && page.levels.level[i].imageart.spotColor && page.levels.level[i].imageart.serviceType === serviceType && page.levels.level[i].imageart.spotColor.uuid == propertyValue.uuid){
                        imageart = page.levels.level[i].imageart;
                        break
                    }
                }
            }
            return imageart;
        }
        $scope.getImageartSize = function(type, propertyValue){
            var imageart = $scope.getImageart(vm.singleData[vm.singleIndex],vm.operationTab, propertyValue);
            if(imageart){
                var size = 60;
                if(imageart.geometry.width > imageart.geometry.height){
                    if(type == 'width'){
                        return size
                    }else{
                        return size * imageart.geometry.height / imageart.geometry.width
                    }
                }else{
                    if(type == 'width'){
                        return size * imageart.geometry.width / imageart.geometry.height
                    }else{
                        return size
                    }
                }
            }
        }
        $scope.goldFoil = function(color){
            if(color){
                return goldFoil(color)
            }
        }
        vm.isOutline = false;
        $scope.setOutline = function(){
            vm.isOutline = true;
        }
        $scope.outlineChange = function(text){
            vm.isOutline = false;
            if(text){
                vm.singleData[vm.singleIndex].outline = text.outline;
                if(vm.product.pictureType == 'spread' && vm.singleData[vm.singleIndex+1]){
                    vm.singleData[vm.singleIndex+1].outline = text.outlineSpread;
                }
            }
        }
        $scope.ifCopyBack = function(index) {
            var _r = vm.pictureType == 'spread' && !vm.isCopyBack && (vm.article.editorType == 'PICTURE_PRO' || vm.article.editorType == 'PICTURE_PRO_P')
            if(vm.data && vm.data[index] && vm.data[index][1] && vm.data[index][1].levels && vm.data[index][1].levels.level && vm.data[index][1].levels.level.length > 0){
                for(var i=0;i<vm.data[index][1].levels.level.length;i++){
                    var level = vm.data[index][1].levels.level[i];
                    if(level.imagebox && (!level.imagebox.image || !level.imagebox.image.resource || !level.imagebox.image.resource.identifier)){
                        _r = false;
                        break
                    }
                }
            }
            return _r;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('editorApp')
        .controller('EditorFormController', EditorFormController);

    EditorFormController.$inject = ['$state', '$scope', '$q', '$stateParams', 'Convert', 'Qinius', 'QiniuToken', 'WxJS', 'Gallery', 'ItemValue', 'SweetAlert', 'Theme', '$localStorage', '$timeout', 'FontManagement', '$rootScope'
        , 'ImageService', 'ClipArt', 'PlatformWechatSetting', 'UidService', 'Store', 'Article', 'CommonService', '$http', 'Folder', 'MessageNotification', 'ThemeClassify', 'entity', 'Product', 'ProductXml', 'DateUtils',
        'Iphone','$websocket','RecommendPics','$translate','StoreWorkEditConfig','MessageService','IMAGE_SUPPORTED_MIME','StoreStorages'];

    function EditorFormController($state, $scope, $q, $stateParams, Convert, Qinius, QiniuToken, WxJS, Gallery, ItemValue, SweetAlert, Theme, $localStorage, $timeout, FontManagement, $rootScope
        , ImageService, ClipArt, PlatformWechatSetting, UidService, Store, Article, CommonService, $http, Folder, MessageNotification, ThemeClassify, entity, Product, ProductXml, DateUtils,
                                  Iphone, $websocket, RecommendPics,$translate,StoreWorkEditConfig,MessageService,IMAGE_SUPPORTED_MIME,StoreStorages) {
        //初始化
        $(".navbar-gallery").hide();
        $(".wrap").addClass('no-margins');
        $(".well").css({'margin-bottom': 0});
        $scope.dWidth = document.documentElement.clientWidth;
        $("body").css({width: $scope.dWidth, 'min-width': $scope.dWidth});

        var vm = this;
        vm.isIPhone6 = isIPhone6();
        vm.isEdit = entity.type == 'edit' ? true : false;
        vm.storeId = $stateParams.storeId;
        vm.pid = $stateParams.pid;
        vm.aid = $stateParams.aid;
        vm.vid = $stateParams.vid;
        vm.xmlId = $stateParams.xmlId;
        vm.counts = 0;
        vm.indexNum = 0;
        vm.itemsPerPage = 40;
        vm.photoAll = [];
        $scope.domains = Qinius.getDomain();
        vm.supportedMimeTypes = IMAGE_SUPPORTED_MIME;
        var unsubQiniuToken = QiniuToken.subscribe('get', {}, function (token) {
            vm.token = token;
        });
        $scope.$on('$destroy', unsubQiniuToken);
        vm.platformSetting = PlatformWechatSetting.get();
        vm.photoArray = [];
        vm.photoSelectAll = localStorage.getItem("photoSelectAll") ? JSON.parse(localStorage.getItem("photoSelectAll")) : [];
        vm.isPhone = false;
        vm.threeIsModal = false;
        vm.threeModalText = "";
        vm.threeLoading = true;
        vm.threeLoadingText=$translate.instant("hint.loadingText");
        vm.threeError = false;
        vm.threeErrorText=$translate.instant("hint.loadingText");
        vm.duplicateList = []; //重复图片
        vm.isDuplicateList = false; //重复图片弹框
        vm.deletePhotoSure = false; //删除处理失败照片确认框
        vm.pendingDeletePhoto = null; //待删除的处理失败照片
        vm.store = Store.get({id: vm.storeId});
        vm.fontList = [];
        $scope.agentIos = false;
        //阻止微信端长按赋值保存图片
        document.oncontextmenu = function (e) {
            //或者return false;
            e.preventDefault();
        };

        function threeInfo(item){
            vm.threeError = true;
            vm.threeErrorText=item;
            $timeout(function () {
                vm.threeError = false;
                vm.threeErrorText="";
            },1500)
        }
        $q.all([$scope.domains.$promise,vm.platformSetting.$promise]).then(function () {
            $scope.domain = 'https://' + $scope.domains.domains[0] + '/';

            vm.platformSetting = vm.platformSetting.data;
            vm.lagnuages =[];
            if ($localStorage.lagnuages) {
                for(var i = 0 ; i<$localStorage.lagnuages.length; i++ ){
                    var lang = $localStorage.lagnuages[i];
                    var langObj = {key:lang};
                    if (lang == 'zh-cn') {
                        langObj.value = "中文";
                    }
                    if (lang == 'en') {
                        langObj.value = "English";
                    }
                    if (vm.lang == lang) {
                        vm.langValue = langObj.value;
                        langObj.selected = true;
                    }
                    vm.lagnuages.push(langObj);
                }
            }

            if (wx) {
                var url = window.location.hash && window.location.href.slice(0, -window.location.hash.length) || window.location.href;
                WxJS.get({url: url}, function (res) {
                    if(res.status==200) {
                        $scope.agentIos = browserVersions();
                        var config = res.data;
                        wx.config({
                            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                            appId: config.appId, // 必填，公众号的唯一标识
                            timestamp: config.timestamp, // 必填，生成签名的时间戳
                            nonceStr: config.nonceStr, // 必填，生成签名的随机串
                            signature: config.signature,// 必填，签名，见附录1
                            jsApiList: ['chooseImage', 'uploadImage', 'hideMenuItems'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                        });
                        wx.ready(function () {
                            console.log('wechat api ready!');

                            wx.hideMenuItems({
                                menuList: ["menuItem:copyUrl", "menuItem:share:timeline", "menuItem:share:appMessage", "menuItem:share:qq", "menuItem:share:appMessage", "menuItem:share:QZone"]
                            });
                        });
                        wx.error(function (res) {
                            console.log(res)
                        });
                    }
                }, function () {
                    console.log("wx config error");
                });
            }
            websocket()
        });
        //像素不足提醒
        vm.imgSize = 150;
        vm.imgDpi = 150;
        StoreWorkEditConfig.storeId({storeId: vm.storeId}, function (res) {
            if(res.status == 200){
                vm.imgSize = res.data.imgSize;
                vm.imgDpi = res.data.imgDpi;
            }
        });
        init()
        function init() {
            if (!vm.isEdit) {
                Article.getByUser({id: $stateParams.aid}, function (resp) {
                    if (resp.status == 200) {
                        vm.article = resp.data;
                        if(vm.article.invalid){//作品失效
                            $state.go('articlesFailure',{storeId:vm.storeId},{location: 'replace'});
                            return
                        }
                        getProduct(function () {
                            ItemValue.get({id: $stateParams.vid}, function (res) {
                                $("body").toggleClass('bg');
                                vm.pattern = res.data.patternType;
                                $scope.status = localStorage.getItem('Production');
                                vm.productXmlLine = angular.copy(res.data.productXmlLines[0]);
                                angular.forEach(res.data.productXmlLines, function (line) {
                                    if (line.id == vm.xmlId) {
                                        vm.productXmlLine = angular.copy(line);
                                    }
                                })
                                vm.article.modelBlendentUuid = vm.productXmlLine.modelBlendentUuid;
                                vm.article.cover = vm.productXmlLine.coverImg;
                                vm.article.themeClassifyId = vm.productXmlLine.productXmlThemeId;
                                vm.article.themeClassifyName = vm.productXmlLine.productXmlThemeName;
                                vm.article.productXmlId = vm.productXmlLine.productXmlId;
                                vm.article.productXmlName = vm.productXmlLine.productXmlName;
                                vm.article.musicIdentify = vm.productXmlLine ? vm.productXmlLine.musicIdentify : res.data.musicIdentify;
                                vm.article.editorType= res.data.productEditorType;
                                vm.article.itemValueId= res.data.itemValueId || vm.vid;
                                if (!res.data.productBokehType) {
                                    vm.article.bokehtype = 'None';
                                } else {
                                    vm.article.bokehtype = res.data.productBokehType;
                                }
                                Convert.xmlToDocument2({
                                    identifier: vm.productXmlLine.productXmlIdentifier,
                                    provider: "qiniu",
                                    editorType:vm.article.editorType,
                                    patternType:vm.product.patternType,
                                }, function (res) {
                                    vm.replace = res.replace;
                                    vm.counts = 0;
                                    $scope.pages = res;
                                    angular.forEach(res.pages.page, function (page, i) {
                                        if(!page.backup){
                                            angular.forEach(page.levels.level, function (level) {
                                                if (level.imagebox && level.imagebox.geometry) {
                                                    vm.counts++;
                                                }
                                                if (level.textbox && level.textbox.geometry) {
                                                    level.textbox.maxLength = level.textbox.text.length>20 ? level.textbox.text.length : 20;
                                                }
                                            })
                                        }
                                    });
                                    abook();
                                    vm.threeLoading = false;
                                });
                            });
                        });
                    }
                },function (error) {
                    if(error.status === 403){//token失效
                        return $state.go('404',{storeId:vm.storeId},{location: 'replace'});
                    }
                    if(error.data.status === 404){//未找到作品
                        $state.go('404',{storeId:vm.storeId,tips:error.data.message},{location: 'replace'});
                    }
                    if(error.data.status === 410){//作品编辑器失效
                        $state.go('404',{storeId:vm.storeId,tips:'编辑器失效'},{location: 'replace'});
                    }
                })
            } else {
                vm.page8 = true;
                Article.getByUser({id: $stateParams.aid}, function (res) {
                    vm.article = res;
                    if(vm.article.invalid){//作品失效
                        $state.go('articlesFailure',{storeId:vm.storeId},{location: 'replace'});
                        return
                    }
                    getProduct()
                    angular.forEach(res.document.pages.page, function (page, i) {
                        if(!page.backup) {
                            angular.forEach(page.levels.level, function (level) {
                                if (level.imagebox && level.imagebox.geometry) {
                                    vm.counts++;
                                }
                            })
                        }
                    });
                    abook();
                },function (error) {
                    if(error.status === 403){//token失效
                        return $state.go('404',{storeId:vm.storeId},{location: 'replace'});
                    }
                    if(error.data.status === 404){//未找到作品
                        $state.go('404',{storeId:vm.storeId,tips:error.data.message},{location: 'replace'});
                    }
                    if(error.data.status === 410){//作品编辑器失效
                        $state.go('404',{storeId:vm.storeId,tips:'编辑器失效'},{location: 'replace'});
                    }
                })
            }
        }

        function getProduct(callback) {
            Product.get({id: vm.article.productId, cancelled: false}, function (res) {
                vm.product = res.data;
                if(callback){callback()}
            })
        }

        $q.all([$scope.domains.$promise]).then(function () {
            $scope.domain = 'https://' + $scope.domains.domains[0] + '/';
            // token过期 — QiniuToken 单例自动刷新

            //获取图片库
            loadAll('isNull');
            platformImg();
            vm.isIPhoneX = Iphone;
        });

        $scope.uploadPhoto = function () {
            uploadAble(StoreStorages,vm.storeId, function (res) {
                if(res.status == 200){
                    if($scope.agentIos){
                        $rootScope.$broadcast('clickAndroidUpload',true);
                    }else{
                        $timeout(function () {
                            $("#uploadImageMutipleId").trigger("click");
                        })
                    }
                }else{
                    if(res.status == 400){
                        threeInfo('系统出错');
                    } else {
                        threeInfo(res.data||'系统出错');
                    }
                }
            })
        }
        vm.uploadPhotoItem=[];
        $scope.$on('uoloadFinished', function(event, args) {
            if(args){
                angular.forEach(vm.photoAll,function (qin) {
                    if(qin.blobCover){
                        qin.blobCover = null;
                    }
                })
                // updatePic();
            }
        });
        $scope.uploadSuccess = function(res){
            if(res.largeFlag || $scope.isLarge(res.imageInfo)){
                res.identifier1 = res.identifier + '.thumbnail.jpg';
            }
            vm.photoAll.unshift(res)
        }

        // websocket接收上传的图片（多端互通实时更新）
        function websocket(){
            var urlws = vm.platformSetting.editorNotifyUrl.split("://")[1];
            urlws = urlws.split("/")[0];
            var ws = $websocket("wss://"+ urlws +"/widget/ws/websocket?uid=Gallery"+vm.aid);
            ws.onOpen(function() {
                console.log('WebSocket连接已打开, url:'+ws.url);
            });
            ws.onMessage(function(message) {
                var photo = JSON.parse(message.data);
                // if (photo.folderId == vm.folderId || (photo.folderId == null && vm.folderId == '')) {

                // }
                // 同步某张照片的大图/色彩转换处理状态
                var syncPhoto = function (target) {
                    if (!target) return;
                    target.largeStatus = photo.largeStatus;
                    target.stripKey = photo.stripKey;
                    target.thumbnailKey = photo.thumbnailKey;
                    target.identifier1 = $scope.domain + photo.thumbnailKey;
                    if (target.convertFlag) {
                        target.convertStatus = photo.convertStatus;
                        // 色彩转换完成后资源identifier会变化，需同步更新（photo.identifier未带域名）
                        target.identifier = $scope.domain + photo.identifier;
                    }
                };
                // 同步图库列表
                for (var i = 0; i < vm.photoAll.length; i++) {
                    if (vm.photoAll[i].id == photo.id) {
                        syncPhoto(vm.photoAll[i]);
                        break;
                    }
                }
                // 同步已选集合
                if (vm.photoSelectAll && vm.photoSelectAll.length) {
                    for (var j = 0; j < vm.photoSelectAll.length; j++) {
                        if (vm.photoSelectAll[j].id == photo.id) {
                            syncPhoto(vm.photoSelectAll[j]);
                        }
                    }
                }
                // 同步更新画布图片框中的大图处理状态，确保编辑组件实时显示
                if (vm.pageData && vm.pageData.length) {
                    angular.forEach(vm.pageData, function (page) {
                        if (page.levels && page.levels.level) {
                            angular.forEach(page.levels.level, function (level) {
                                if (level.imagebox && level.imagebox.image &&
                                    level.imagebox.image.resourceid == photo.id) {
                                    level.imagebox.image.largeStatus = photo.largeStatus;
                                    level.imagebox.image.stripKey = photo.stripKey;
                                }
                            });
                        }
                    });
                }
                $scope.$applyAsync();
            });
            ws.onError(function(error) {
                console.log('WebSocket错误：', error);
            });
            ws.onClose(function() {
                console.log('WebSocket连接已关闭');
            });
        }

        // 监听重复图片事件
        $scope.$on('duplicateImages', function(event, duplicateList,flag,currentFileList) {
            if (duplicateList && duplicateList.length > 0) {
                vm.duplicateList = duplicateList;
                MessageService.confirm({
                    title: '提示',
                    cancel: '取消',
                    confirm: '确认',
                    msg: '检测到图库中有' + vm.duplicateList.length + '张重复图片，是否需要自动去重？',
                    html: '<span class="themecolor themecolor-btn">查看重复图片</span>'
                }, function(res) {
                    if (res == 'htmlClick') {
                        vm.isDuplicateList = true;
                    } else {
                        var ids = [];
                        vm.duplicateList.forEach(function(item) {
                            ids.push(item.id);
                        });
                        Gallery.batchDelete(ids, function() {
                            // 上传的全是重复图
                           if(ids.length == vm.photoAll.length){
                                MessageService.success('去重成功！');
                                vm.duplicateList = [];
                                vm.photoAll = [];
                                vm.photoSelectAll = []
                                vm.indexNum = 0;
                                vm.maxId = null;
                                vm.photoCompleted = false;
                                loadAll();
                           }else{
                            // 去重
                            var deletedIds = {};
                            currentFileList.forEach(function(_v){
                                if(_v.duplicate){
                                    deletedIds[_v.id] = true;
                                }
                            });
                            vm.photoAll = vm.photoAll.filter(function(img){
                                return !deletedIds[img.id];
                            });
                            $rootScope.$broadcast('uoloadFinished',flag);
                           }
                        }, function(error) {
                            MessageService.error('删除失败！');
                            vm.duplicateList = [];
                        });
                    }
                }, function() {
                    vm.duplicateList = [];
                    $rootScope.$broadcast('uoloadFinished',flag);
                });
            }
        });
        $scope.duplicateChange = function(val) {
            var _val = JSON.parse(val)
            // val 可能是: 0(关闭), 1(全部删除), 数组(部分删除)
            // 当删除部分图片时，从已选列表中移除对应图片，避免重新加载后这些图片被重新选中
            if(Array.isArray(_val) && _val.length){
                var deletedIds = {};
                _val.forEach(function(_v){
                    deletedIds[_v.id] = true;
                });
                vm.photoAll = vm.photoSelectAll.filter(function(img){
                    return !deletedIds[img.id];
                });
            }
            vm.isDuplicateList = false;
            vm.duplicateList = [];
            // vm.photoAll = [];
            vm.indexNum = 0;
            vm.maxId = null;
            vm.photoCompleted = false;
            loadAll();
        };

        // 上传图片后更新图片库/文件夹
        function updatePic() {
            vm.photoAll=[];
            vm.indexNum = 0;
            vm.photoCompleted = false;
            loadAll();
        }
        function loadAll() {
            var items = [];
            items.push({key: "folderId", op: "isNull", value: ''})
            items.push({key: "articleId", op: "=", value: vm.aid})
            if (vm.maxId) {
                items.push({key: "id", op: "<=",value: vm.maxId});
            }
            Gallery.storeByCondition({
                items: [],
                page: vm.indexNum,
                size: vm.itemsPerPage,
                sort: sorts()
            }, onSuccess, onError);
        }

        function sorts() {
            return ["id,desc"];
        }

        function onSuccess(res) {
            if (vm.maxId == null && res.data.length > 0) {
                vm.maxId = res.data[0].id;
            }
            for (var i = 0; i < res.data.length; i++) {
                if (!res.data[i].cancelled) {
                    res.data[i].identifier = $scope.domain + res.data[i].identifier;
                    if(res.data[i].largeFlag || $scope.isLarge(res.data[i].imageInfo)){
                        res.data[i].identifier1 = res.data[i].identifier + '.thumbnail.jpg';
                    }
                    vm.photoAll.push(res.data[i])
                }
            }
            if (res.data.length < vm.itemsPerPage) {
                vm.photoCompleted = true;
            }
        }

        function onError(data) {
            if(data.status !== 403){
                MessageService.hint($translate.instant("editorCommon.failedToObtainThePhotoGallery"));
            }

        }


        //获取dpi
        js_getDPI(function (dpi) {
            vm.windowDpi = dpi;
        });
        vm.pageData = null;
        vm.pageIndex = 0;
        $scope.template = null;
        function abook() {
            productXmlGet();
            if (vm.isEdit) {
                $scope.template = angular.copy(vm.article.document);
                $scope.template.pages.page=[];
                vm.article.document.pages.page.forEach(function (page) {
                    if(!page.backup){
                        var _page = page;
                        _page.seq = $scope.template.pages.page.length;
                        $scope.template.pages.page.push(_page);
                    }
                })
            } else {
                $scope.template = angular.copy($scope.pages);
                $scope.template.pages.page=[];
                $scope.pages.pages.page.forEach(function (page) {
                    if(!page.backup){
                        var _page = page;
                        _page.seq = $scope.template.pages.page.length;
                        $scope.template.pages.page.push(_page);
                    }
                })
            }
            documentAnalysis($scope, $http, vm, $scope.template,FontManagement,'other', function(page){
                ratioInfo(page)
            }, function () {
                vm.pageData = [];
                $timeout(function () {
                    vm.pageData = $scope.template.pages.page;
                    vm.pageSum = $scope.template.pages.page.length - 1;
                    vm.pageIndex = 0;
                    thumbnailInit();
                    vm.threeLoading = false;
                }, 1000)
            })
        }
        function productXmlGet(){
            ProductXml.get({id:vm.article.productXmlId}, function (productXml) {
                vm.productXmlData = productXml.data;
            })
        }
        vm.windowWidth = document.body.clientWidth;
        vm.windowHeight = document.body.clientHeight;
        vm.windowHeight1 = 350;
        function ratioInfo(item) {
            var ratio = item.custom.width / item.custom.height;
            var ratio1 = vm.windowWidth / vm.windowHeight1;
            if (ratio >= ratio1) {
                item.custom.ratio1 = vm.windowWidth / item.custom.width;
            } else {
                item.custom.ratio1 = vm.windowHeight1 / item.custom.height;
            }
            item.custom.thumbnailScale = 300 / item.custom.width;
        }

        $scope.previousPage = function () {
            thumbnailInit(function () {
                vm.pageIndex--;
                ratioInfo(vm.pageData[vm.pageIndex]);
            })
        }
        $scope.nextPage = function () {
            thumbnailInit(function () {
                vm.pageIndex++;
                ratioInfo(vm.pageData[vm.pageIndex]);
            })
        }
        $scope.goPageContent = function (index) {
            vm.isDocumentTextDetection=false;
            thumbnailInit(function () {
                vm.pageIndex = index;
                ratioInfo(vm.pageData[vm.pageIndex]);
            })
        }
        /*******************************************点击图片库*************************************************************************/
        $scope.imageboxCb = function(imagebox){
            console.log(imagebox);
            vm.isGallery = true;
            vm.isPlatformPhoto = false;
            vm.imageboxItem = imagebox;
        };
        $scope.imageboxHide = function(){
            vm.isGallery = false;
            vm.isPlatformPhoto = false;
            vm.imageboxItem = null;
        };
        $scope.mapDepot = function(item){
            if(item){
                vm.isGallery = true;
                vm.isPlatformPhoto=false;
            }else{
                vm.isGallery = false;
                vm.isPlatformPhoto=true;
            }
        }
        vm.recommendPicIndex = 0;
        vm.recommendPicSize = 20;
        vm.recommendPicCompleted = false;
        vm.recommendPics=[];
        function platformImg(){
            RecommendPics.byCondition2({
                items: [],
                page: vm.recommendPicIndex,
                size: vm.recommendPicSize,
                sort: ["seq,asc"]
            }, function (res, headers) {
                var _sum = headers('X-Total-Count');
                for (var i = 0; i < res.data.length; i++) {
                    if (!res.data[i].cancelled) {
                        res.data[i].identifier = $scope.domain + res.data[i].identifier;
                        vm.recommendPics.push(res.data[i])
                    }
                }
                if(vm.recommendPics.length>= _sum){
                    vm.recommendPicCompleted = true;
                }
            }, function () {

            });
        }
        $('#photoGalleryId').on('scroll', function(event){
            var realScrollHeight=event.currentTarget.clientHeight+event.currentTarget.scrollTop;
            if(!vm.photoCompleted){
                if((event.currentTarget.scrollHeight-1)<realScrollHeight && realScrollHeight < (event.currentTarget.scrollHeight+1)){
                    vm.indexNum++
                    loadAll()
                }
            }
        });
        $('#platformPhotoId').on('scroll', function(event){
            var realScrollHeight=event.currentTarget.clientHeight+event.currentTarget.scrollTop;
            if(!vm.recommendPicCompleted){
                if((event.currentTarget.scrollHeight-1)<realScrollHeight && realScrollHeight < (event.currentTarget.scrollHeight+1)){
                    vm.recommendPicIndex++
                    platformImg()
                }
            }
        });


        $scope.addImageboxImg = function (item) {
            replaceImagebox(item)
        };
        function replaceImagebox(data) {
            var item = angular.copy(data);
            var _imagebox = vm.imageboxItem;
            _imagebox.image = {
                resource: {
                    identifier: item.identifier,
                    provider: 'qiniu'
                },
                resourceid:item.sourceId,
                filterResource: {
                    identifier: '',
                    provider: 'qiniu'
                },
                imageInfo:item.imageInfo,
                width: item.width,
                height: item.height,
                imgSize: item.imgSize,
                index: item.seq,
                parameter: angular.fromJson(item.parameter),
                scale: 1,
                angle: 0,
                largeFlag: item.largeFlag,
                largeStatus: item.largeStatus,
                convertFlag: item.convertFlag,
                convertStatus: item.convertStatus,
                stripKey: item.stripKey,
                thumbnailKey: item.thumbnailKey
            }
            addImagebox($http, _imagebox, function () {
                thumbnailInit()
                imageSelectInit();
                $scope.imageboxHide();
            });
        }

        // 图库照片处理状态：大图处理中/失败、色彩转换中/失败，无特殊状态返回''（正常展示照片）
        $scope.photoStatus = function (photo) {
            if (!photo) return '';
            if (photo.convertFlag == true && photo.convertStatus == 'running') return 'convertRunning';
            if (photo.convertStatus == 'error') return 'convertError';
            if (photo.largeFlag && photo.largeStatus == 'running') return 'largeRunning';
            if (photo.largeFlag && photo.largeStatus == 'error') return 'largeError';
            return '';
        };
        // 是否处理失败状态（大图处理失败、色彩转换失败）
        $scope.isPhotoFailed = function (photo) {
            var status = $scope.photoStatus(photo);
            return status === 'largeError' || status === 'convertError';
        };
        // 处理中的照片不可选中/添加到图片框，处理失败的照片点击弹出删除确认框
        $scope.onPhotoStatusClick = function (photo, event) {
            if (event) {
                event.stopPropagation();
            }
            if ($scope.isPhotoFailed(photo)) {
                vm.pendingDeletePhoto = photo;
                vm.deletePhotoSure = true;
            }
        };
        // 确认删除处理失败的照片，取消则仅关闭弹框
        $scope.deletePhotoConfirm = function () {
            var photo = vm.pendingDeletePhoto;
            if (!photo || !photo.id) {
                vm.deletePhotoSure = false;
                vm.pendingDeletePhoto = null;
                return;
            }
            var id = photo.id;
            Gallery.batchDelete([id], function () {
                MessageService.success($translate.instant('nav.photograph.content.deletePhoto.success'));
                // 清除图片框中引用该照片的图片
                if (vm.pageData && vm.pageData.length) {
                    angular.forEach(vm.pageData, function (page) {
                        if (page && page.levels && page.levels.level) {
                            angular.forEach(page.levels.level, function (level) {
                                if (level.imagebox && level.imagebox.image &&
                                    (level.imagebox.image.resourceid == id ||
                                    (photo.sourceId != null && level.imagebox.image.resourceid == photo.sourceId))) {
                                    level.imagebox.image = {
                                        resource: {
                                            identifier: '',
                                            provider: ''
                                        },
                                        filterResource: {
                                            identifier: '',
                                            provider: ''
                                        },
                                        offsetx: 0,
                                        offsety: 0,
                                        width: '',
                                        height: '',
                                        imgsize: '',
                                        index: '',
                                        parameter: [],
                                        scale: 1,
                                        angle: 0
                                    };
                                }
                            });
                        }
                    });
                }
                // 从本地图库列表及已选集合中移除
                var removeFromList = function (list) {
                    if (!list || !list.length) return;
                    for (var i = list.length - 1; i >= 0; i--) {
                        if (list[i].id === id) {
                            list.splice(i, 1);
                        }
                    }
                };
                removeFromList(vm.photoAll);
                removeFromList(vm.photoSelectAll);
                imageSelectInit();
                vm.deletePhotoSure = false;
                vm.pendingDeletePhoto = null;
            }, function () {
                vm.deletePhotoSure = false;
                vm.pendingDeletePhoto = null;
                MessageService.error($translate.instant('nav.photograph.content.deletePhoto.failed'));
            });
        };

        // 子组件点击处理失败的照片时emit此事件，由父级弹出删除确认框
        $scope.$on('requestDeletePhoto', function (event, photo) {
            if (photo && $scope.isPhotoFailed(photo)) {
                vm.pendingDeletePhoto = photo;
                vm.deletePhotoSure = true;
            }
        });

        function imageSelectInit() {
            vm.photoSelectAll = [];
            for (var i = 0; i < vm.pageData.length; i++) {
                for (var j = 0; j < vm.pageData[i].levels.level.length; j++) {
                    var _level = vm.pageData[i].levels.level[j];
                    if (_level.imagebox) {
                        for (var k = 0; k < vm.photoAll.length; k++) {
                            if (_level.imagebox.image.resourceId == vm.photoAll[k].sourceId) {
                                vm.photoSelectAll.push(vm.photoAll[k]);
                                break
                            }
                        }
                    }
                }
            }
        }
        //文字编辑
        $scope.textboxFocus = function(textbox){
            $timeout(function () {
                vm.textbox = textbox;
            })
        };
        $scope.textboxBlur = function(textbox){
            $timeout(function () {
                vm.textbox = null;
            })
        };
        $scope.textboxChange = function(textbox){
            if(textbox.text.length > textbox.maxLength){
                textbox.text = textbox.text.substring(0, textbox.maxLength)
            }
            sizeHeight()
        }

        function sizeHeight() {
            $timeout(function () {
                var _h = Number($("#c-xml-page-material-fontId1 span").height()) + Number(10);
                var _w = Number($("#c-xml-page-material-fontId1 span").width()) + Number(10);
                if(!writingmodeInit(vm.textbox.style.writingmode)){
                    vm.textbox.geometry.height = _h;
                }
                if(writingmodeInit(vm.textbox.style.writingmode)){
                    vm.textbox.geometry.width = _w;
                }
                thumbnailInit();
            })
        }
        //保存
        $scope.isSave = false;
        vm.isDocumentTextDetection = false;
        function articleOverdue(callback){
            Article.get({id: vm.article.id}, function (article) {
                if(article.data.fileName != vm.article.fileName){
                    MessageService.minConfirm({
                        cancel:$translate.instant("button.cancel"),
                        confirm:$translate.instant("button.refresh"),
                        msg:$translate.instant("hint.articleOverdue")
                    },function(){
                        $state.go("product-choosesThree-ec", {storeId: vm.storeId, aid:  vm.article.id},{reload:true,location: 'replace'});
                    })
                }else{
                    callback();
                }
            })
        }
        $scope.save = function () {
            articleOverdue(function () {
                vm.threeLoading = true;
                vm.threeLoadingText=$translate.instant("hint.loadingText");
                var _documentTextDetection = documentTextDetection1($scope.template.pages.page);
                if(!_documentTextDetection.pass){
                    vm.isDocumentTextDetection = true;
                    vm.documentTextDetection = _documentTextDetection.pages;
                    vm.threeLoading = false;
                    vm.threeLoadingText = '';
                    return;
                }
                if(!vm.isPageWarnExamine && pageWarnExamine($scope.template.pages.page, vm.imgSize, vm.imgDpi)){
                    SweetAlert.swal({
                        title: $translate.instant("editorCommon.hint"),
                        imageUrl: Theme.sweetHintImg(),
                        text: $translate.instant("editorCommon.lackPixelsMessage"),
                        showCancelButton: true,
                        confirmButtonText: $translate.instant("button.confirm"),
                        cancelButtonText: $translate.instant("button.cancel"),
                        closeOnConfirm: true,
                        closeOnCancel: true
                    }, function (isConfirm) {
                        if (isConfirm) {
                            vm.isPageWarnExamine = true;
                            $timeout(function () {
                                $scope.save();
                            },200)
                        }
                    })
                    vm.threeLoading = false;
                    vm.threeLoadingText = '';
                    return
                }
                vm.isPageWarnExamine = false;
                if ($scope.template.pages.page.length < $scope.PAGELEN) {
                    SweetAlert.swal({
                        title: $translate.instant("hint.loadingText"),
                        imageUrl: Theme.sweetHintImg(),
                        text: "",
                        timer: 2000,
                        showConfirmButton: false
                    });
                    vm.threeLoading = false;
                    vm.threeLoadingText = '';
                    return
                }

                if (vm.article.ordered) {
                    SweetAlert.swal({
                        title: $translate.instant("font.warmPrompt"),
                        imageUrl: Theme.sweetHintImg(),
                        text: $translate.instant("editorCommon.newWork"),
                        timer: 2000,
                        showConfirmButton: false
                    });
                }
                //判断是否有图片未上传  且是否继续保存
                if (!$scope.isContinue()) {
                    // vm.completed = false;
                    SweetAlert.swal({
                        title: $translate.instant("editorCommon.saveSure"),
                        imageUrl: Theme.sweetHintImg(),
                        showCancelButton: true,
                        confirmButtonText: $translate.instant("button.confirm"),
                        cancelButtonText: $translate.instant("button.cancel"),
                        closeOnConfirm: true,
                        closeOnCancel: true
                    }, function (isConfirm) {
                        if (isConfirm) {
                            $timeout(function () {
                                generateJsonFile();
                            }, 500);
                            return;
                        }else{
                            vm.threeLoading = false;
                            vm.threeLoadingText = '';
                        }
                    })
                } else {
                    // vm.completed = true;
                    generateJsonFile();
                }
            })
        }
        $scope.save1 = generateJsonFile;
        vm.isPageWarnExamine = false;
        function generateJsonFile() {
            // vm.deleteList = 0;
            // var  gallieryIds = [];
            // for (var i = $scope.template.pages.page.length - 1; i >= 0; i--) {
            //     var page = $scope.template.pages.page[i];
            //     if (page.backup || page.levels == null || page.levels.level == null || page.levels.level.length == 0) {
            //         continue;
            //     }
            //     for (var j = page.levels.level.length - 1; j >= 0; j--) {
            //         var level = page.levels.level[j];
            //         if (level.imagebox == null || level.imagebox.image == null || !level.imagebox.image.resourceid) {
            //             continue;
            //         }
            //         gallieryIds.push(level.imagebox.image.resourceid);
            //     }
            // }
            // if (gallieryIds.length>0) {
            //     Gallery.checkDeleted(gallieryIds, function(list){
            //         // vm.deleteList = [{id:gallieryIds[0]}];
            //         // vm.completed = false;
            //         // vm.isDestroyed = true;
            //         if (list == null|| list.length ==0) {
            //             generateJsonFile1()
            //         }else{
            //             vm.deleteList = list;
            //             vm.completed = false;
            //             vm.isDestroyed = true;
            //             return;
            //         }
            //     }, function(){
            //         MessageService.error("检测图片失败，请稍后再试。");
            //     })
            // }else{
                generateJsonFile1()
            // }
        }

        $scope.removeGallery = function(){
            if (vm.deleteList == null || vm.deleteList.length == 0) {
                return;
            }
            for (var z = vm.deleteList.length - 1; z >= 0; z--) {
                var g = vm.deleteList[z];
                for (var i = $scope.template.pages.page.length - 1; i >= 0; i--) {
                    var page = $scope.template.pages.page[i];
                    if (page.backup || page.levels == null || page.levels.level == null || page.levels.level.length == 0) {
                        continue;
                    }
                    for (var j = page.levels.level.length - 1; j >= 0; j--) {
                        var level = page.levels.level[j];
                        if (level.imagebox == null || level.imagebox.image == null || !level.imagebox.image.resourceid) {
                            continue;
                        }
                        if (level.imagebox.image.resourceid == g.sourceId) {
                            level.imagebox.image.resource.identifier = "";
                            level.imagebox.image.resource.adaptation = "";
                            level.imagebox.image.resource.provider = "";
                            level.imagebox.image.resource.offsetx = 0;
                            level.imagebox.image.resource.offsety = 0;
                            level.imagebox.image.resource.height = "";
                            level.imagebox.image.resource.width = "";
                            level.imagebox.image.resource.scale = 1;
                            level.imagebox.image.resource.imgSize = "";
                            level.imagebox.image.resourceid = null;
                            level.imagebox.image.imageInfo = null;
                            break;
                        }
                    }
                }
            }
            imageSelectInit();
        }

        $scope.galleryDestroyConfirm = function(){
            $scope.removeGallery();
            generateJsonFile1();
        };

        function generateJsonFile1(){
            if ($scope.isSave) {
                return;
            }
            $scope.isSave = true;
            thumbnailInit(function (){
                vm.threeLoading = true;
                vm.threeLoadingText=$translate.instant("hint.loadingText");
                var template = saveData();
                template.hostinfo = hostInfo();
                template.replace= vm.replace;
                Convert.articleUploadDocument(template, function (res) {
                    vm.article.articleStatus = vm.completed;
                    vm.article.fileName = res.data.identifier;
                    vm.article.id = vm.aid;
                    vm.article.pageCount = $scope.template.pages.page.length;
                    vm.article.saveUserName = localStorage.getItem('saveUserName') || ''
                    Article.update(vm.article, function (resp) {
                        $scope.isSave = true;
                        vm.threeLoading = false;
                        vm.threeLoadingText = '';
                        $scope.isSave = false;
                        swal({
                            title: $translate.instant("editorCommon.modifySuccess"),
                            text: $translate.instant("editorCommon.synchronizationOfWorks"),
                            imageUrl: Theme.sweetSuccedImg(),
                            timer: 2000,
                            showConfirmButton: false
                        });
                        $state.go("product-view5-ec", {storeId: vm.storeId, aid: resp.data.id}, {reload: true,location: 'replace'});
                    }, function () {
                        $scope.isSave = false;
                        vm.threeLoading = false;
                        vm.threeLoadingText = '';
                        swal({
                            title: $translate.instant("editorCommon.saveError"),
                            text: $translate.instant("editorCommon.saveError1"),
                            imageUrl: Theme.sweetHintImg(),
                            timer: 2000,
                            showConfirmButton: false
                        });
                    })
                }, function () {
                    $scope.isSave = false;
                    vm.threeLoading = false;
                    vm.threeLoadingText = '';
                    swal({
                        title: $translate.instant("editorCommon.saveError"),
                        text: $translate.instant("editorCommon.saveError1"),
                        imageUrl: Theme.sweetHintImg(),
                        timer: 2000,
                        showConfirmButton: false
                    });
                })
                localStorage.removeItem("photoSelectAll");
            })
        }

        $scope.isContinue = function () {
            var hasEmpty = true;
            vm.unFilledCount = 0;
            for (var i = 0; i < $scope.template.pages.page.length; i++) {
                var _page = $scope.template.pages.page[i];
                if (_page.levels.level) {
                    for (var j = 0; j < _page.levels.level.length; j++) {
                        var _level = _page.levels.level[j];
                        if (_level.imagebox) {
                            if (!_level.imagebox.image || !_level.imagebox.image.resource || !_level.imagebox.image.resource.identifier) {
                                hasEmpty = false;
                                vm.unFilledCount++;
                            }
                        }
                    }
                }
            }
            vm.completed = hasEmpty ? 'COMPLETED' : 'EDITING';
            return hasEmpty;
        };

        function saveData() {
            return documentMM($scope.template, [], null);
        }
        //生成缩略图
        vm.isHtml2canvas = false;
        vm.isThreeView3d1 = false;
        vm.isThreeView3d = true;
        vm.threeView3dW=110;
        vm.threeView3dH=110;
        vm.pageData1 = [];
        vm.threeView3d={
            top: 50,
            right: 5
        }

        $scope.threeView3d1Cb = function () {
            vm.isThreeView3d1=true;
            vm.threeView3dW=$(window).width();
            vm.threeView3dH=400;
        }
        $scope.threeView3d1CbHide = function () {
            vm.isThreeView3d1=false;
            vm.threeView3dW=110;
            vm.threeView3dH=110;
        };
        var a = null;
        function thumbnailInit(callback) {
            if(vm.productXmlData && vm.productXmlData.modelType === 'THREE'){
                if (a !== null) {
                    clearTimeout(a)
                }
                a = setTimeout(function() {
                    vm.thumbnailPageData = angular.copy(vm.pageData[vm.pageNumber]);
                    pageTrimbox(vm.thumbnailPageData)
                    $timeout(function () {
                        html2canvas_adapt(document.getElementById('thumbnail-view'), {
                            onrendered: function (canvas) {
                                if(canvas){
                                    QiniuToken.uploadThumbnail(canvas, function (data) {
                                        vm.pageData[vm.pageIndex].pagecover = {
                                            identifier: $scope.domain + data.key,
                                            provider: 'qiniu'
                                        }
                                        if(vm.pageIndex == 0){
                                            vm.article.covered=true;
                                            vm.article.cover=data.key;
                                        }
                                        vm.isHtml2canvas = true;
                                        vm.pageData1 = angular.copy(vm.pageData);
                                        if(callback){callback()};
                                    }, function () {
                                        vm.article.covered=false;
                                        vm.article.cover=null;
                                        if (callback) {callback()};
                                    });
                                }else{
                                    vm.article.covered=false;
                                    vm.article.cover=null;
                                    if (callback) {callback()};
                                }
                            },
                            letterRendering: true,
                            useCORS: true,
                            width: vm.pageData[vm.pageIndex].custom.width*vm.pageData[vm.pageIndex].custom.thumbnailScale,
                            height: vm.pageData[vm.pageIndex].custom.height*vm.pageData[vm.pageIndex].custom.thumbnailScale,
                            windowWidth: document.body.scrollWidth,
                            windowHeight: document.body.scrollHeight,
                            x: 0,
                            y: 0,
                            backgroundColor: "rgba(0, 0, 0, 0)"
                        });
                    },1000)
                },1000)
            }else{
                if(callback){callback()}
            }
        }

        window.threeView3dStart = function (e) {
            vm.threeView3d1 = angular.copy(vm.threeView3d);
            vm.threeView3d1.x = e.changedTouches[0].clientX != null ? e.changedTouches[0].clientX: 0;          //鼠标到页面左边的距离
            vm.threeView3d1.y = e.changedTouches[0].clientY != null ? e.changedTouches[0].clientY: 0;           //鼠标到页面顶部的距离
            $scope.$digest();
        };
        window.threeView3dOn = function (e) {
            $timeout(function () {
                var nx = e.changedTouches[0].clientX != null ? e.changedTouches[0].clientX: 0;
                var ny = e.changedTouches[0].clientY != null ? e.changedTouches[0].clientY: 0;
                //计算移动后的左偏移量和顶部的偏移量
                var nl = nx - vm.threeView3d1.x;
                var nt = ny - vm.threeView3d1.y;
                vm.threeView3d.right = vm.threeView3d1.right - nl;
                vm.threeView3d.top = vm.threeView3d1.top + nt;
            })
        }
        //部件名
        $scope.partName = function (partid) {
            var partName = "";
            for(var i=0; i<$scope.template.config.parts.list.length; i++){
                if($scope.template.config.parts.list[i].id == partid){
                    partName = $scope.template.config.parts.list[i].name;
                }
            }
            return partName
        }

        // 调出手机键盘导致输入框不可见问题修复
        var element = document.getElementById('pageHeight');
        var elementHeight = element.clientHeight; // 获取元素的客户端高度
        vm.textFouched = false;
        // 监测窗口大小变化
        window.addEventListener('resize', function(event) {
            $timeout(function(){
                if (element.clientHeight < elementHeight) {
                    vm.textFouched = true;
                }else{
                    vm.textFouched = false;
                }
            })
        });

        // 大图判断
        $scope.isLarge = function(imageInfo){
            if(!imageInfo)return
            return imageInfo.size >= 20971520 || imageInfo.width > 30000 || imageInfo.height > 30000 || (imageInfo.width*imageInfo.height)>150000000
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('editorApp')
        .controller('VariableDataController', VariableDataController);

    VariableDataController.$inject = ['$scope', 'Category', '$uibModalInstance', 'MessageService','entity'];

    function VariableDataController( $scope, Category, $uibModalInstance, MessageService,entity) {

        var vm = this;
        vm.data = entity.data;
        console.log(entity)
        console.log(vm.data)

        vm.clear = clear;


        function clear() {
            $uibModalInstance.dismiss('cancel');
        }


    }

})();

(function () {
    'use strict';

    angular
        .module('editorApp')
        .controller('UploadFailedImageListPopupController', UploadFailedImageListPopupController);

        UploadFailedImageListPopupController.$inject = ['$scope', '$uibModalInstance', 'MessageService','entity'];

    function UploadFailedImageListPopupController( $scope, $uibModalInstance, MessageService,entity) {

        var vm = this;
        vm.uploadFailedList = entity;
        vm.uploadFailedList.forEach(function(errorFile){
            errorFile.blobCover = URL.createObjectURL(errorFile);
        });


        $scope.close = function() {
            $uibModalInstance.close(false);
        }

        $scope.upload = function() {
            $uibModalInstance.close(true);
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('editorApp')
        .controller('ThumbnailatorController', ThumbnailatorController);

    ThumbnailatorController.$inject = ['$scope', 'Category', '$uibModalInstance', 'MessageService','entity',
    'CommonService', 'Qinius', 'Base64Image'];

    function ThumbnailatorController( $scope, Category, $uibModalInstance, MessageService,entity,
     CommonService, Qinius, Base64Image) {

        var vm = this;
        // vm.isEnd = true;
        vm.files = entity.files;
        vm.folderId = entity.folderId;
        vm.aid = entity.aid;
        vm.token = entity.token;
        $scope.domain = entity.domain;

        $scope.photos = [];

        angular.forEach(vm.files,function (f) {
            // 先用原始 blob URL 作为默认值，避免 ng-src 为空
            f.blobCover = URL.createObjectURL(f);
            // 异步生成缩略图，成功后替换为大图中的第一帧缩略图
            createThumbnailBlob(f, 400, 400, function(thumbnailUrl) {
                if (thumbnailUrl) {
                    f.blobCover = thumbnailUrl;
                    $scope.$apply();
                }
            });
        })

        /**
         * 将图片文件缩小到指定尺寸，避免原图过大导致浏览器解码失败显示破图
         * 使用 URL.createObjectURL 加载原图（零拷贝），解码后通过 Canvas 缩放到指定尺寸
         */
        function createThumbnailBlob(file, maxWidth, maxHeight, callback) {
            var objectUrl = URL.createObjectURL(file);
            var img = new Image();
            img.onload = function() {
                var width = img.width;
                var height = img.height;

                // 只在原图超出限制时才缩放
                if (width > maxWidth || height > maxHeight) {
                    var ratio = Math.min(maxWidth / width, maxHeight / height);
                    width = Math.round(width * ratio);
                    height = Math.round(height * ratio);

                    var canvas = document.createElement('canvas');
                    canvas.width = width;
                    canvas.height = height;
                    var ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0, width, height);

                    canvas.toBlob(function(blob) {
                        URL.revokeObjectURL(objectUrl);
                        if (blob) {
                            callback(URL.createObjectURL(blob));
                        } else {
                            callback(null); // toBlob 失败则不替换
                        }
                    }, file.type || 'image/jpeg');
                } else {
                    // 图片尺寸在限制内，无需替换
                    URL.revokeObjectURL(objectUrl);
                    callback(null);
                }
            };
            img.onerror = function() {
                // 解码失败，保持原始 blob URL
                URL.revokeObjectURL(objectUrl);
                callback(null);
            };
            img.src = objectUrl;
        }

        vm.clear = clear;
        vm.save = save;

        $scope.deletePic = function ($index) {
            vm.files.splice($index,1)
        }

        function blobToFile(theBlob, fileName) {
            theBlob.lastModifiedDate = new Date();
            theBlob.name = fileName;
            return theBlob;
        };

        $scope.compression = function () {
            vm.loading = true;
            var f = 0;
            angular.forEach(vm.files,function (file,i) {
                var img = new  Image();
                img.src = file.blobCover;
                Base64Image.compress(file.blobCover, img.height, 0.9, function(newBase64) {
                    var compressedSize = Base64Image.getSize(newBase64);
                    var blob = dataURLtoBlob(newBase64);
                    var aasfile = blobToFile(blob, file["name"]);
                    var aafile = new File([aasfile], file["name"], { type: file["type"] });
                    console.log("compress: " + file.size + " ==> " + aafile.size);

                    CommonService.UpdateQiniuService([aafile], 0, 1, $scope.domain, vm.token, vm.folderId,vm.aid,function (resp) {
                        file.lowerSize = Math.ceil(compressedSize/1024/1024);
                        file.newSize = compressedSize;

                        // var arr = resp.data;
                        // var identifier = angular.copy(arr.identifier)
                        // arr.identifier = $scope.domain + arr.identifier;
                        // arr.usenum = 0;
                        // arr.imgsize = arr.imgSize;
                        // $scope.photos.unshift(arr);
                        i++;
                        if(i == vm.files.length){
                            vm.isEnd = true;
                            vm.loading = false;
                            $scope.$digest();
                        }
                    }, function(){
                        i++;
                        if(i == vm.files.length){
                            vm.isEnd = true;
                            vm.loading = false;
                            $scope.$digest();
                        }
                    })
                });

            })
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            console.log($scope.photos)
            $uibModalInstance.close($scope.photos);
            vm.isSaving = false;
            // onSaveSuccess(vm.files);
        }


        function onSaveSuccess(result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('editorApp')
        .controller('QrcodeController', QrcodeController);

    QrcodeController.$inject = ['$scope', 'Category', '$uibModalInstance', 'MessageService','entity'];

    function QrcodeController( $scope, Category, $uibModalInstance, MessageService,entity) {

        var vm = this;

        vm.code = entity.code;
        vm.clear = clear;
        vm.save = save;

        vm.data={
            range:'this',
            generLoc:'all'
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        $scope.validate = function () {
            console.log(vm.code)
            if(vm.code.width==''||vm.code.width==null){
                MessageService.error("请输入二维码宽度");
                return
            }
            if(vm.code.height==''||vm.code.height==null){
                MessageService.error("请输入二维码高度");
                return
            }
            if(vm.code.value==''||vm.code.value==null){
                MessageService.error("请输入二维码内容");
                return
            }
            return true;
        };

        function save() {
            if (!$scope.validate()) {
                return;
            }
            onSaveSuccess(vm.code);
        }


        function onSaveSuccess(result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

    }

})();

(function () {
    'use strict';

    var picOperation = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        controllerAs: '$scope',
        bindings: {
            document: '=',
            template: '=',
            arrI: '=',
            pageI: '=',
            currentPage: '=',
            ctrlKeyArray: '=',
            selectBox: '=',
            hasText: '=',
            fontOn: '=',
            fontDocOn: '=',
            isReplaceShow: '=',
            hint:'='
        },

        controller: ['$scope', 'ImageService', '$q', 'Qinius', 'Store', '$http', '$rootScope', 'Article', 'FontManagement', '$state',
            function ($scope, ImageService, $q, Qinius, Store, $http, $rootScope, Article, FontManagement, $state) {
                var vm = this;
                var drag = false;
                var dragBox = {};

                window.moveImgStart = function (e) {
                    fn(e);
                    if(vm.fontOn||vm.fontDocOn){
                        return
                    }
                    vm.hasText = false;
                    var targ = e.target ? e.target : e.srcElement;
                    var imgIndex = targ.dataset.imgindex || vm.template.levelI;
                    vm.pageI = targ.dataset.docindex;
                    vm.arrI = targ.dataset.arrindex;
                    var page = vm.document.pages[vm.pageI];
                    vm.currentPage = page.arr;
                    if (vm.arrI == 2) {
                        vm.currentPage = page.arr2;
                    }
                    vm.template.levelI = imgIndex;
                    var currentImg = vm.currentPage.levels.level[vm.template.levelI].imagebox;

                    if (currentImg.lock) {
                        return
                    }

                    getChooseBox(currentImg, 'imagebox');

                    dragBox.clientX = e.clientX || 0;
                    dragBox.clientY = e.clientY || 0;
                    if(currentImg.image&&currentImg.image.resource&&currentImg.image.resource.identifier){
                        dragBox.coordX = targ.offsetParent.offsetParent.offsetParent.offsetLeft;
                        dragBox.coordY = targ.offsetParent.offsetParent.offsetParent.offsetTop;
                    }else{
                        dragBox.coordX = targ.offsetParent.offsetParent.offsetLeft;
                        dragBox.coordY = targ.offsetParent.offsetParent.offsetTop;
                    }
                    dragBox.slideW = $(".slide" + vm.arrI + vm.pageI).width();
                    dragBox.slideH = $(".slide" + vm.arrI + vm.pageI).height();
                    drag = true;
                    if (currentImg.rotation.angle >= 360) {
                        currentImg.rotation.angle %= 360;
                    }
                    dragBox.geometryX = angular.copy(currentImg.geometry.x);
                    dragBox.geometryY = angular.copy(currentImg.geometry.y);
                    var all = getAllCtrlKeyArray();
                    if (all.length) {
                        dragBox.ctrlKey = true;
                    }
                    if(currentImg.ctrlKey){
                        levelMove(e)
                    }else{
                        document.addEventListener("mousemove", moveImgOn, true);
                        document.addEventListener("mouseup", moveImgEnd, true);
                    }
                    $scope.$apply();
                };

                //move 事件
                function moveImgOn(e) {
                    fn(e);
                    if (e.target.nodeName == 'SPAN') {
                        return;
                    }
                    if (drag) {
                        var page = vm.document.pages[vm.pageI];
                        var currentPage = vm.currentPage;
                        var pressImg = currentPage.levels.level[vm.template.levelI].imagebox;

                        var clientX = e.clientX - dragBox.clientX;
                        var clientY = e.clientY - dragBox.clientY;
                        var imgOffsetX = (dragBox.coordX + e.clientX - dragBox.clientX);
                        var imgOffsetY = (dragBox.coordY + e.clientY - dragBox.clientY);
                        var imgWidth = pressImg.geometry.width * currentPage.pageScaleW * page.scale;
                        var imgHeight = pressImg.geometry.height * currentPage.pageScaleH * page.scale;
                        var x = currentPage.editbox.x * currentPage.pageScaleW * page.scale;
                        var y = currentPage.editbox.y * currentPage.pageScaleW * page.scale;

                        // $(".move-tip").hide();
                        // if (imgOffsetX <= 0) {
                        //     imgOffsetX = 0;
                        // }
                        //
                        // if (imgOffsetX <= x || imgOffsetY <= y) {
                        //     $(".move-tip").show();
                        // }
                        // if (imgOffsetY >= (dragBox.slideH - imgHeight - y)) {
                        //     $(".move-tip").show();
                        // }
                        //
                        //
                        // if (imgOffsetX >= dragBox.slideW - imgWidth) {
                        //     imgOffsetX = dragBox.slideW - imgWidth;
                        // }
                        // if (imgOffsetX >= dragBox.slideW - imgWidth - x) {
                        //     $(".move-tip").show();
                        // }
                        //
                        // if (imgOffsetY <= 0) {
                        //     imgOffsetY = 0;
                        // }
                        //
                        // if (imgOffsetY >= (dragBox.slideH - imgHeight)) {
                        //     imgOffsetY = dragBox.slideH - imgHeight;
                        // }

                        if (dragBox.ctrlKey) {
                            moveTogether(currentPage, clientX, clientY,dragBox);
                        } else {
                            pressImg.geometry.x = dragBox.geometryX + imgOffsetX / currentPage.pageScaleW / page.scale;
                            pressImg.geometry.y = dragBox.geometryY + imgOffsetY / currentPage.pageScaleH / page.scale;
                        }

                        vm.currentPage = currentPage;
                        vm.hint = !editboxIn(vm.currentPage.editboxes.editbox , pressImg.geometry, pressImg.rotation.angle);
                        console.log(pressImg.geometry.x)
                        $scope.$apply();
                    }
                    return false;
                }

                //鼠标松开事件
                function moveImgEnd() {
                    if (dragBox.ctrlKey) {
                        moveTogetherEnd();
                    }
                    drag = false;
                    dragBox = {};
                    $(".move-tip").hide();
                    uploadRightPlanel();
                    $scope.$parent.updateHistory();
                    document.removeEventListener("mousemove", moveImgOn, true);
                    document.removeEventListener("mouseup", moveImgEnd, true);
                    vm.hint = false;
                    $scope.$digest();
                }

                function uploadRightPlanel() {
                    // $scope.template.pages.page[$scope.currentPage.seq - 1] = angular.copy($scope.currentPage);
                    var p = [];
                    angular.forEach(vm.document.pages, function (item, index) {
                        p.push(item.arr);
                        if (item.arr2) {
                            p.push(item.arr2);
                        }
                    });
                    vm.template.pages.page = p;
                }

                function getChooseBox(box, attr) {
                    vm.selectBox = box;
                    vm.selectBox.current = attr;
                    hideChangeBtn();
                }

                function hideChangeBtn() {
                    $(".change-btn").hide();
                    vm.isReplaceShow = true;
                }

                function getAllCtrlKeyArray() {
                    var imageboxes = vm.ctrlKeyArray.imageboxes,
                        textboxes = vm.ctrlKeyArray.textboxes,
                        imagearts = vm.ctrlKeyArray.imagearts,
                        all = [];
                    var barcode = vm.ctrlKeyArray.barcode;
                    angular.forEach(vm.currentPage.levels.level, function (level, i) {
                        if(level.imageart && level.imageart.ctrlKey){
                            all.push(level.imageart)
                        }
                        if(level.imagebox && level.imagebox.ctrlKey){
                            all.push(level.imagebox)
                        }
                        if(level.textbox && level.textbox.ctrlKey){
                            all.push(level.textbox)
                        }
                        if (level.textdocument && level.textdocument.ctrlKey) {
                            all.push(level.textdocument)
                        }
                        if (level.textdocument && level.textdocument.ctrlKey) {
                            all.push(level.textdocument)
                        }
                        if (level.code && level.code.ctrlKey) {
                            all.push(level.code)
                        }
                    })
                    return all;
                }

                function moveTogether(currentPage, clientX, clientY,dragbox) {
                    var page = vm.document.pages[vm.pageI];
                    var imgWidth = 0, imgHeight = 0, x = 0, y = 0, pro = currentPage.pageScaleW * page.scale;
                    angular.forEach(vm.ctrlKeyArray.imageboxes, function (imagebox, i) {
                        // 当前页所有占位框
                        var box = currentPage.levels.level[imagebox.levelI].imagebox;
                        boxSetting(box, imagebox);
                    })

                    angular.forEach(vm.ctrlKeyArray.imagearts, function (imageart, i) {
                        // 当前页所有素材
                        var box = currentPage.levels.level[imageart.levelI].imageart;
                        boxSetting(box, imageart);
                    })

                    angular.forEach(vm.ctrlKeyArray.textboxes, function (textbox, i) {
                        // 当前页所有文字
                        var box = currentPage.levels.level[textbox.levelI].textbox;
                        boxSetting(box, textbox);
                    })

                    angular.forEach(vm.ctrlKeyArray.textdocuments, function (textdocument, i) {
                        // 当前页所有文字
                        var box = currentPage.levels.level[textdocument.levelI].textdocument;
                        boxSetting(box, textdocument);
                    })

                    function boxSetting(box, CtrlKeyBox) {
                        if(!box.lock){
                            console.log(box)
                            imgWidth = box.geometry.width * pro;
                            imgHeight = box.geometry.height * pro;
                            x = CtrlKeyBox.geometry.x * pro + clientX;
                            y = CtrlKeyBox.geometry.y * pro + clientY;
                            // if (x <= 0) {
                            //     x = 0;
                            // }
                            // if (x >= (dragbox.slideW - imgWidth)) {
                            //     x = dragbox.slideW - imgWidth;
                            // }
                            // if (y <= 0) {
                            //     y = 0;
                            // }
                            //
                            // if (y >= (dragbox.slideH - imgHeight)) {
                            //     y = dragbox.slideH - imgHeight;
                            // }
                            box.geometry.x = x / pro
                            box.geometry.y = y / pro
                        }
                    }
                }

                function moveTogetherEnd() {
                    angular.forEach(vm.ctrlKeyArray.imageboxes, function (imagebox, i) {
                        // 当前页所有占位框
                        var box = vm.currentPage.levels.level[imagebox.levelI].imagebox;
                        ctrlKeySetting(box, imagebox);
                    })

                    angular.forEach(vm.ctrlKeyArray.imagearts, function (imageart, i) {
                        // 当前页所有素材
                        var box = vm.currentPage.levels.level[imageart.levelI].imageart;
                        ctrlKeySetting(box, imageart);
                    })

                    angular.forEach(vm.ctrlKeyArray.textboxes, function (textbox, i) {
                        // 当前页所有文字
                        var box = vm.currentPage.levels.level[textbox.levelI].textbox;
                        ctrlKeySetting(box, textbox);
                    })

                    angular.forEach(vm.ctrlKeyArray.textdocuments, function (textdocument, i) {
                        // 当前页所有文字
                        var box = vm.currentPage.levels.level[textdocument.levelI].textdocument;
                        ctrlKeySetting(box, textdocument);
                    });

                    function ctrlKeySetting(box, CtrlKeyBox) {
                        CtrlKeyBox.geometry.x = box.geometry.x;
                        CtrlKeyBox.geometry.y = box.geometry.y;
                    }
                }

                function levelMove(event) {
                    var ratio = 1;
                    if(vm.arrI == 1){
                        ratio = vm.document.pages[vm.pageI].arr.pageScaleW*vm.document.pages[vm.pageI].scale
                    }
                    if(vm.arrI == 2){
                        ratio = vm.document.pages[vm.pageI].arr2.pageScaleW*vm.document.pages[vm.pageI].scale
                    }
                    angular.forEach(vm.currentPage.levels.level, function (level, i) {
                        if(level.imageart && level.imageart.ctrlKey && !level.imageart.lock && !level.imageart.edit){
                            moveWebdown($scope, event,level.imageart, vm.currentPage.trimbox,ratio, function () {

                            })
                        }
                        if(level.imagebox && level.imagebox.ctrlKey && !level.imagebox.lock){
                            // level.imagebox.ctrlKey = false;
                            moveWebdown($scope, event,level.imagebox, vm.currentPage.trimbox,ratio, function () {

                            })
                        }
                        if(level.textbox && level.textbox.ctrlKey && !level.textbox.lock){
                            // level.textbox.ctrlKey = false;
                            moveWebdown($scope, event,level.textbox, vm.currentPage.trimbox,ratio, function () {

                            })
                        }
                        if (level.textdocument && level.textdocument.ctrlKey && !level.textdocument.lock) {
                            // level.textdocument.ctrlKey = false;
                            moveWebdown($scope, event,level.textdocument, vm.currentPage.trimbox,ratio, function () {

                            })
                        }
                        if (level.code && level.code.ctrlKey && !level.code.lock) {
                            // level.textdocument.ctrlKey = false;
                            moveWebdown($scope, event,level.code, vm.currentPage.trimbox,ratio, function () {

                            })
                        }
                    })
                }
                //防止事件冒泡，默认事件
                function fn(e) {
                    // e = e || window.event;
                    // e.cancelBubble = true;
                    // e.stopPropagation();
                    // e.returnValue = false;
                    // e.preventDefault();
                    if (e && e.stopPropagation) {
                        // 因此它支持W3C的stopPropagation()方法
                        e.stopPropagation();
                    } else {
                        // 否则，我们需要使用IE的方式来取消事件冒泡
                        window.event.cancelBubble = true;
                    }

                    // 阻止默认浏览器动作(W3C)
                    if (e && e.preventDefault) {
                        e.preventDefault();
                    } else {
                        // IE中阻止函数器默认动作的方式
                        window.event.returnValue = false;
                    }
                }
            }],
        link:function () {

        }
    };

    angular
        .module('editorApp')
        .component('picOperation', picOperation);
})();

window.angular.module('modules.service', []).factory('ModulesService',
    ['FontManagement', 'MessageService', '$timeout', '$rootScope', '$state', 'ToneSettings', '$uibModal', '$stateParams','$translate', '$translatePartialLoader',
    function (FontManagement, MessageService, $timeout, $rootScope, $state, ToneSettings, $uibModal, $stateParams,$translate, $translatePartialLoader) {

        var vm = this;
        this.storeId = $stateParams.storeId;
        this.pid = $stateParams.pid;
        console.log($stateParams)

        this.sorts = function (predicate, reverse) {
            // return ["createdDate,desc"];
            return [predicate + ',' + (reverse ? 'asc' : 'desc')];
        }

        this.fn = function (e) {
            // e = e || window.event;
            // e.cancelBubble = true;
            // e.stopPropagation();
            // e.returnValue = false;
            // e.preventDefault();
            if (e && e.stopPropagation) {
                // 因此它支持W3C的stopPropagation()方法
                e.stopPropagation();
            } else {
                // 否则，我们需要使用IE的方式来取消事件冒泡
                window.event.cancelBubble = true;
            }

            // 阻止默认浏览器动作(W3C)
            if (e && e.preventDefault) {
                e.preventDefault();
            } else {
                // IE中阻止函数器默认动作的方式
                window.event.returnValue = false;
            }
        }

        // 得到浏览器dpi
        this.getDPI = function () {
            var arrDPI = new Array();
            if (window.screen.deviceXDPI != undefined) {
                arrDPI[0] = window.screen.deviceXDPI;
                arrDPI[1] = window.screen.deviceYDPI;
            } else {
                var tmpNode = document.createElement("DIV");
                tmpNode.style.cssText = "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
                document.body.appendChild(tmpNode);
                arrDPI[0] = parseInt(tmpNode.offsetWidth);
                arrDPI[1] = parseInt(tmpNode.offsetHeight);
                tmpNode.parentNode.removeChild(tmpNode);
            }
            // vm.windowDpiW = 300;
            // vm.windowDpiH = 300;
            return arrDPI;
        }

        // 判断是哪个浏览器
        this.myBrowser = function () {
            var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
            var isOpera = userAgent.indexOf("Opera") > -1;
            if (isOpera) {
                return "Opera"
            }
            ; //判断是否Opera浏览器
            if (userAgent.indexOf("Firefox") > -1) {
                return "FF";
            } //判断是否Firefox浏览器
            if (userAgent.indexOf("Chrome") > -1) {
                return "Chrome";
            }
            if (userAgent.indexOf("Safari") > -1) {
                return "Safari";
            } //判断是否Safari浏览器
            if (userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera) {
                return "IE";
            }
            ; //判断是否IE浏览器
        }

        // 进度条
        this.rangeValue = function (elem) {
            return elem.value
        }

        // mm换算成px
        this.unitTransform = function (mm) {
            // mm换算成px  Math.ceil(mm / 25.4 * 300);
            // return (mm * 3) - 0;
            var dpi = this.getDPI();
            return mm / 25.4 * dpi[0];
        }

        // px换算成mm
        this.unitTransformPx = function (px) {
            // px换算成mm  Math.floor(px / 300 * 25.4)
            // return (px * 1 / 3).toFixed(2) - 0;
            var dpi = this.getDPI();
            return px / dpi[0] * 25.4;
        }

        this.getGeometryToPx = function (obj) {
            return {
                height: this.unitTransform(obj.height),
                width: this.unitTransform(obj.width),
                x: this.unitTransform(obj.x),
                y: this.unitTransform(obj.y)
            }
        }

        // px---mm
        this.threeHundredDpiToMm = function (attr1, attr2) {
            var dpi = this.getDPI();
            var mm1 = parseFloat((attr1 / dpi[0] * 25.4 - 0)).toFixed(2) - 0;
            var mm2 = parseFloat((attr2 / dpi[0] * 25.4 - 0)).toFixed(2) - 0;
            return {
                mm1: mm1,
                mm2: mm2
            }
        }

        // 获取图片dpi
        this.getPicDpi = function (box) {
            var boxW = 0, boxH = 0, picW = 0, picH = 0, scale = 0;
            boxW = this.unitTransformPx(box.geometry.width);
            boxH = this.unitTransformPx(box.geometry.height);
            picW = box.image.width;
            picH = box.image.height;
            scale = box.image.scale;
            var x = 0, y = 0;
            // 宽度适配
            if (box.adaptation == 'Width') {
                x = picW / (boxW / 25.4) / scale;
                y = boxH * picW / boxW / (boxH / 25.4) / scale;
            } else {
                x = boxW * picH / boxH / (boxW / 25.4) / scale;
                y = picH / (boxH / 25.4) / scale;
            }
            if (x < 150 || y < 150) {
                return true
            } else {
                return false
            }
        }

        // 获取文字样式
        this.getFontCSS = function (item, attr) {
            item.loading = true;
            FontManagement.getCss({uuid: item.fontuuid}, function (res) {
                if (res.status == 200) {
                    var style = document.createElement("style");
                    style.type = 'text/css';
                    try {
                        style.appendChild(document.createTextNode(res.data));
                    } catch (ex) {
                        style.stylesheet.cssText = res.data;
                    }
                    var Head = document.getElementsByTagName("head")[0];
                    Head.appendChild(style);
                    document.fonts.ready.then(function () {
                        item.loading = false;
                        if (attr) {
                            // console.log($rootScope)
                            // updateHistorys();
                        }
                        $rootScope.$apply();
                    });
                } else {
                    MessageService.error(res.message);
                }
            });
        }

        // 获取logo，颜色
        this.getToneSettings = function (storeId, callback) {
            ToneSettings.byStoreId({id: storeId}, function (res) {
                if (res.status == 200) {
                    if (res.data) {
                        for (var key in  res.data) {
                            if (res.data[key]) {
                                document.body.style.setProperty('--' + key, res.data[key]);
                            }
                        }
                        callback.call(this, res.data);
                    }
                } else {
                    MessageService.error(res.message)
                }
            }, function (error) {
            });
        }

        // 全屏
        this.toggleFullScreen = function (attr) {
            if (!attr) {
                //进入全屏
                var de = document.documentElement;
                if (de.requestFullscreen) {
                    de.requestFullscreen();
                } else if (de.mozRequestFullScreen) {
                    de.mozRequestFullScreen();
                } else if (de.webkitRequestFullScreen) {
                    de.webkitRequestFullScreen();
                }
                return true
            } else {
                //退出全屏
                var de = document;
                if (de.exitFullscreen) {
                    de.exitFullscreen();
                } else if (de.mozCancelFullScreen) {
                    de.mozCancelFullScreen();
                } else if (de.webkitCancelFullScreen) {
                    de.webkitCancelFullScreen();
                }
                return false
            }
        }

        // 鼠标放大缩小
        this.bbimg = function (delta, box) {
            if (box.bokehtype != 'None') {
                return
            }

            if (delta < 0 || delta == undefined && event.wheelDelta > 0) {
                box.image.scale *= 1.01;
            } else {
                box.image.scale /= 1.01;
                if (box.image.scale <= 1) {
                    box.image.scale = 1;
                }
            }
            var x = box.image.offsetx * box.image.scale;
            var y = box.image.offsety * box.image.scale;

            //向上滑动;
            if (-y >= (box.image.height * box.image.scale - box.geometry.height)) {
                y = -(box.image.height * box.image.scale - box.geometry.height);
            }
            //向左滑动;        <-----
            if (-x >= (box.image.width * box.image.scale - box.geometry.width)) {
                x = -(box.image.width * box.image.scale - box.geometry.width);
            }
            //向下滑动;
            if (y >= 0) {
                y = 0;
            }
            // 向右滑动;    ---->
            if (x >= 0) {
                x = 0;
            }
            box.image.offsetx = x / box.image.scale;
            box.image.offsety = y / box.image.scale;

            return box;
        }

        // 获取文字style
        this.setFontStyle = function (fontList, uuid, text) {
            var fontStyle = [];
            for (var i = 0; i < fontList.length; i++) {
                if (fontList[i].uuid == uuid) {
                    for (var j = 0; j < fontList[i].fontStyles.length; j++) {
                        fontStyle.push(fontList[i].fontStyles[j].style)
                    }
                }
            }
            text.style.bold = false;
            text.style.italic = false;
            if (fontStyle.indexOf('NORMAL') != '-1') {
                text.style.bold = false;
                text.style.italic = false;
            } else {
                if (fontStyle.indexOf('BOLD_ITALIC') != '-1') {
                    text.style.bold = true;
                    text.style.italic = true;
                } else {
                    if (fontStyle.indexOf('ITALIC') != '-1') {
                        text.style.italic = true;
                    }
                    if (fontStyle.indexOf('BOLD') != '-1') {
                        text.style.bold = true;
                    }
                }
            }

            return {
                fontStyle: fontStyle,
                style: text.style
            }
        }

        // 预览
        this.pagePreview = function (temp,isShowbotton) {
            $uibModal.open({
                templateUrl: 'app/entities/commodity/commodity-preview.html',
                controller: 'CommodityPreviewController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: [function () {
                        var _obj = {
                            storeId: this.storeId,
                            pid: this.pid,
                            value: temp,
                            type: 'temp',
                            isShowbotton: isShowbotton
                        }
                        return _obj;
                    }],
                    translatePartialLoader: [function () {
                        $translatePartialLoader.addPart('commodityPage');
                        $translatePartialLoader.addPart('common');
                        return $translate.refresh();
                    }],
                }
            }).result.then(function (backData) {
                console.log(backData);
            });
        }

        this.setPageHistory = function () {
            $(".save-page").addClass('hide1');
            $(".used-pic-mask").show();
            var mb = vm.myBrowser();
            if (mb == 'FF') {
                $(".leftPanel-con li").addClass('mar-left-6');
            }
        }

        // 获取占位框宽高
        this.imgScale = function (imagebox, x, y, attr) {
            var img = imagebox.image.resource.identifier + '?imageMogr2/exifModify/eyJPcmllbnRhdGlvbiI6IjEifQ==/thumbnail/!40p';
            if (imagebox.image.angle != 0) {
                img += '/rotate/' + imagebox.image.angle
            }
            if (!imagebox.image.width && !imagebox.image.height) {
            }

            imagebox.image.orignIdentifier = angular.copy(imagebox.image.resource.identifier);
            var width = imagebox.image.width;
            var height = imagebox.image.height;
            var wOrigin = angular.copy(width);
            var hOrigin = angular.copy(height);
            // 单页编辑占位框宽高
            var maskWidth = imagebox.geometry.width;
            var maskHight = imagebox.geometry.height;
            if ((wOrigin <= hOrigin || maskWidth <= maskHight) && (wOrigin / hOrigin < maskWidth / maskHight) || wOrigin >= hOrigin && maskWidth >= maskHight && (wOrigin / hOrigin < maskWidth / maskHight)) {
                imagebox.adaptation = 'Width';
                imagebox.image.width = imagebox.geometry.width;
                imagebox.image.height = imagebox.geometry.width * height / width;
                imagebox.image.offsetx = x;
                imagebox.image.offsety = (imagebox.geometry.height - imagebox.geometry.width * height / width) / 2;
                imagebox.blurredrectangle = {
                    width: imagebox.geometry.height * width / height,
                    height: imagebox.geometry.height,
                    x: (imagebox.geometry.width - imagebox.geometry.height * width / height) / 2,
                    y: 0,
                }
            } else {
                imagebox.adaptation = 'Height';
                imagebox.image.width = imagebox.geometry.height * width / height;
                imagebox.image.height = imagebox.geometry.height;
                imagebox.image.offsetx = (imagebox.geometry.width - imagebox.geometry.height * width / height) / 2;
                imagebox.image.offsety = y;
                imagebox.blurredrectangle = {
                    width: imagebox.geometry.width,
                    height: imagebox.geometry.width * height / width,
                    x: 0,
                    y: (imagebox.geometry.height - imagebox.geometry.width * height / width) / 2,
                }
            }
            if (imagebox.bokehtype != 'None') {
                imagebox.image.offsetx = 0;
                imagebox.image.offsety = 0;
                imagebox.image.scale = 1;
            }
            imagebox.image.lowSize = this.getPicDpi(imagebox);

            // f++;
            // if (f == vm.counts) {
            //     vm.setPageHistory();
            // }
            $timeout(function () {
                imagebox.loading = false;
                // 拖拽进占位框时记录下历史纪录
                if (attr) {
                    // updateHistorys()
                }
            }, 400)
            // return
        }

        // 拖拽占位框
        var isZoomDown = false;
        this.imageboxZoom = function ($event, item, direction, pro, index, slide, $scope) {
            var x = $event.clientX;
            var y = $event.clientY;
            //获取w和h
            var nw = angular.copy(item.geometry.width) * pro;
            var nh = angular.copy(item.geometry.height) * pro;
            var nw1 = item.image ? angular.copy(item.image.width) * pro : 0;
            var nh1 = item.image ? angular.copy(item.image.height) * pro : 0;
            var nw2 = item.image ? angular.copy(item.image.width) * pro : 1;
            var nh2 = item.image ? angular.copy(item.image.height) * pro : 1;
            var x1 = item.image ? angular.copy(item.image.offsetx * pro) : 0;
            var y1 = item.image ? angular.copy(item.image.offsety * pro) : 0;
            var x2 = item.geometry.x * pro;
            var y2 = item.geometry.y * pro;
            var _scale = item.image ? angular.copy(item.image.scale) : 1;
            var maxX = $($event.target).parents('.slide-content').width();
            var maxY = $($event.target).parents('.slide-content').height();

            //开关打开
            isZoomDown = true;
            //鼠标移动
            window.onmousemove = function (e) {
                if (isZoomDown == false) {
                    return;
                }
                //获取x和y
                var nx = e.clientX;
                //计算移动后的左偏移量和顶部的偏移量
                var nl = nx - x;

                if (direction == 'bottom' || direction == 'left') {
                    var _w = (Number(nw) - Number(nl));
                }
                if (direction == 'top' || direction == 'right') {
                    var _w = (Number(nw) + Number(nl));
                }
                var _h = _w / nw * nh;
                // if(_w > ($scope.currentPage.width+$scope.wahBorder/$scope.currentPage.proportion)*$scope.currentPage.scale){
                //     _w = ($scope.currentPage.width+$scope.wahBorder/$scope.currentPage.proportion)*$scope.currentPage.scale;
                //     _h = _w / nw * nh;
                // }
                // if(_h > ($scope.currentPage.height+$scope.xayBorder/$scope.currentPage.proportion)*$scope.currentPage.scale){
                //     _h = ($scope.currentPage.height+$scope.xayBorder/$scope.currentPage.proportion)*$scope.currentPage.scale;
                //     _w = _h / nh * nw;
                // }
                // if (_w > maxX) {
                //     _w = maxX;
                //     _h = _w / nw * nh;
                // }
                // if (_h > maxY) {
                //     _h = maxY;
                //     _w = _h / nh * nw;
                // }
                item.geometry.width = _w / pro;
                item.geometry.height = _h / pro;
                if (item.image && item.image.resource && item.image.resource.identifier) {
                    var _offsetx = (_w / (nw / nw1)) / (nw1 / x1) / pro;
                    var _offsety = (_h / (nh / nh1)) / (nh1 / y1) / pro;
                    vm.imgScale(item, _offsetx, _offsety, false);
                }
                if (direction == 'left') {
                    item.geometry.x = (Number(x2) - Number(_w - nw)) / pro;
                    item.geometry.y = (Number(y2) - Number(_h - nh)) / pro;
                    // if (item.geometry.x < 0) {
                    //     item.geometry.x = 0;
                    // }
                    // if (item.geometry.y < 0) {
                    //     item.geometry.y = 0;
                    // }
                }
                if (direction == 'top') {
                    // if (item.geometry.width * pro > maxX - item.geometry.x * pro) {
                    //     item.geometry.width = (maxX - item.geometry.x * pro) / pro;
                    // }
                    item.geometry.y = (Number(y2) - Number(_h - nh)) / pro;
                    // if (item.geometry.y < 0) {
                    //     item.geometry.y = 0;
                    // }
                }
                if (direction == 'right') {
                    // if (item.geometry.width * pro > maxX - item.geometry.x * pro) {
                    //     item.geometry.width = (maxX - item.geometry.x * pro) / pro;
                    // }
                    // if (Number(item.geometry.height * pro) + Number(item.geometry.y * pro) > maxY) {
                    //     item.geometry.height = (maxY - Number(item.geometry.y * pro)) / pro;
                    //     item.geometry.width = item.geometry.height / nh * nw;
                    //     return;
                    // }
                }
                if (direction == 'bottom') {
                    // if (Number(item.geometry.height * pro) + Number(item.geometry.y * pro) > maxY) {
                    //     item.geometry.height = (maxY - Number(item.geometry.y * pro)) / pro;
                    //     item.geometry.width = item.geometry.height / nh * nw;
                    //     return;
                    // }
                    item.geometry.x = (Number(x2) - Number(_w - nw)) / pro;
                    // if (item.geometry.x < 0) {
                    //     item.geometry.x = 0;
                    // }
                }
                // $scope.template.levelI = index;
                // $scope.currentPage.levels.level[$scope.template.levelI].imagebox = item;
                $rootScope.$digest();
            }
            //鼠标抬起事件
            window.onmouseup = function ($event) {
                if(item.image && item.image.resource && item.image.resource.identifier){
                    getBackgroundWebSource3($scope,item,item.geometry.width,item.geometry.height,item.image, item.bokehtype);
                }
                $event.stopPropagation();
                isZoomDown = false;
            }
        }
        this.imageboxZoom1 = function ($event, item, direction, pro, index, slide, $scope) {
            var x = $event.clientX;
            var y = $event.clientY;
            //获取w和h
            var nw = angular.copy(item.geometry.width) * pro;
            var nh = angular.copy(item.geometry.height) * pro;
            var nw1 = item.image ? angular.copy(item.image.width) * pro : 0;
            var nh1 = item.image ? angular.copy(item.image.height) * pro : 0;
            var nw2 = item.image ? angular.copy(item.image.width) * pro : 1;
            var nh2 = item.image ? angular.copy(item.image.height) * pro : 1;
            var x1 = item.image ? angular.copy(item.image.offsetx * pro) : 0;
            var y1 = item.image ? angular.copy(item.image.offsety * pro) : 0;
            var x2 = item.geometry.x * pro;
            var y2 = item.geometry.y * pro;
            var _scale = item.image ? angular.copy(item.image.scale) : 1;
            var maxX = $($event.target).parents('.slide-content').width();
            var maxY = $($event.target).parents('.slide-content').height();
            //开关打开
            isZoomDown = true;
            //鼠标移动
            window.onmousemove = function (e) {
                if (isZoomDown == false) {
                    return;
                }
                //获取x和y
                var nx = e.clientX;
                var ny = e.clientY;
                //计算移动后的左偏移量和顶部的偏移量
                var nl = nx - x;
                var nt = ny - y;

                if (direction == 'left') {
                    var _w = (Number(nw) - Number(nl));
                }
                if (direction == 'right') {
                    var _w = (Number(nw) + Number(nl));
                }
                if (direction == 'top') {
                    var _h = (Number(nh) - Number(nt));
                }
                if (direction == 'bottom') {
                    var _h = (Number(nh) + Number(nt));
                }
                // if(_w > ($scope.currentPage.width+$scope.wahBorder/$scope.currentPage.proportion)*$scope.currentPage.scale){
                //     _w = ($scope.currentPage.width+$scope.wahBorder/$scope.currentPage.proportion)*$scope.currentPage.scale;
                // }
                // if(_h > ($scope.currentPage.height+$scope.xayBorder/$scope.currentPage.proportion)*$scope.currentPage.scale){
                //     _h = ($scope.currentPage.height+$scope.xayBorder/$scope.currentPage.proportion)*$scope.currentPage.scale;
                // }


                if (item.image && item.image.resource && item.image.resource.identifier) {
                    item.image.angle = 0;
                    vm.imgScale(item, 0, 0, false);
                }
                if (direction == 'left') {
                    item.geometry.x = (Number(x2) - Number(_w - nw)) / pro;
                    item.geometry.width = _w / pro;
                    // if (item.geometry.x < 0) {
                    //     item.geometry.x = 0;
                    // }
                }
                if (direction == 'top') {
                    item.geometry.y = (Number(y2) - Number(_h - nh)) / pro;
                    item.geometry.height = _h / pro;
                    // if (item.geometry.y < 0) {
                    //     item.geometry.y = 0;
                    // }
                }
                if (direction == 'right') {
                    item.geometry.width = _w / pro;
                }
                if (direction == 'bottom') {
                    item.geometry.height = _h / pro;
                }
                // if (item.geometry.width * pro > maxX - item.geometry.x * pro) {
                //     item.geometry.width = (maxX - item.geometry.x * pro) / pro;
                // }
                // if (item.geometry.height * pro > maxY - item.geometry.y * pro) {
                //     item.geometry.height = (maxY - item.geometry.y * pro) / pro;
                // }
                // $scope.template.levelI = index || $scope.template.levelI;
                // $scope.currentPage.levels.level[$scope.template.levelI].imagebox = item;
                $rootScope.$digest();
            }
            //鼠标抬起事件
            window.onmouseup = function ($event) {
                if(item.image && item.image.resource && item.image.resource.identifier) {
                    getBackgroundWebSource3($scope, item, item.geometry.width, item.geometry.height, item.image, item.bokehtype)
                }
                $event.stopPropagation();
                isZoomDown = false;
            }
        }

        // 旋转角度
        this.getAngle = function (px, py, mx, my) {//获得人物中心和鼠标坐标连线，与y轴正半轴之间的夹角
            var x = Math.abs(px - mx);
            var y = Math.abs(py - my);
            var z = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
            var cos = y / z;
            var radina = Math.acos(cos);//用反三角函数求弧度
            var angle = Math.floor(180 / (Math.PI / radina));//将弧度转换成角度
            if (mx < px && my > py) {//鼠标在第三象限
                angle = angle;
            }
            if (mx < px && my < py) {
                angle = 180 - angle;
            }
            if (mx > px && my < py) {
                angle = 180 + angle;
            }
            if (mx > px && my > py) {
                angle = 360 - angle;
            }
            return angle;

        }

        this.keycodeArrow = function (keyCode, currentPage, level, selectBox) {
            // var box = [];
            // if (selectBox.current == 'imagebox') {
            //     box = level.imagebox;
            // }
            // if (selectBox.current == 'textbox') {
            //     box = level.textbox;
            // }
            // if (selectBox.current == 'imageart') {
            //     box = level.imageart;
            // }
            // if (selectBox.current == 'textdocument') {
            //     box = level.textdocument;
            // }
            // if (box.lock || box.movable==false) {
            //     return
            // }

            if(selectBox.lock  || selectBox.movable==false){
                return
            }
            // 上
            if (keyCode == 38 && selectBox.geometry.y > 0) {
                selectBox.geometry.y--;
            }
            // 下
            if (keyCode == 40 && selectBox.geometry.y < currentPage.mediabox.height - selectBox.geometry.height) {
                selectBox.geometry.y++;

            }
            // 左
            if (keyCode == 37 && selectBox.geometry.x > 0) {
                selectBox.geometry.x--;
            }
            // 右
            if (keyCode == 39 && selectBox.geometry.x < currentPage.mediabox.width - selectBox.geometry.width) {
                selectBox.geometry.x++;
            }
            $rootScope.$apply();
        }

        this.doubleClickClipart = function (e,item,ratio) {
            var imageartTrim = angular.copy(item);
            imageartTrim.geometry.width1 = angular.copy(item.geometry.width);
            imageartTrim.geometry.height1 = angular.copy(item.geometry.height);
            imageartTrim.geometry.x1 = angular.copy(item.geometry.x);
            imageartTrim.geometry.y1 = angular.copy(item.geometry.y);
            if(imageartTrim.geometry.width * ratio == imageartTrim.geometry.width1 * ratio * imageartTrim.scale){
                imageartTrim.geometry.width = imageartTrim.geometry.width * 0.8;
                imageartTrim.geometry.height = imageartTrim.geometry.height * 0.8;
                imageartTrim.geometry.x = Number(imageartTrim.geometry.x) + Number(imageartTrim.geometry.width / 0.8 * 0.2 / 2);
                imageartTrim.geometry.y = Number(imageartTrim.geometry.y) + Number(imageartTrim.geometry.height / 0.8 * 0.2 / 2);
            }
            return imageartTrim;
        }

        this.generQRCode = function (ele,code) {
            var qrcode = new QRCode(ele, {
                width: code.geometry.width,
                height: code.geometry.height
            });
            qrcode.makeCode(code.value);
        }

        this.splitFileName = function (text) {
            var pattern = /\.{1}[a-z]{1,}$/;
            if (pattern.exec(text) !== null) {
                return (text.slice(0, pattern.exec(text).index));
            } else {
                return text;
            }
        }

        this.setLayoutQuantity = function (res) {
            var arr = [],map = {}

            for (var i = 0; i < res.length; i++) {
                var ai = res[i];
                var quantity = ai.quantity;
                if(ai.quantity>8){
                    quantity = 9;
                }
                if (!map[quantity]) {
                    map[quantity] = [ai]
                } else {
                    map[quantity].push(ai)
                }
            }

            Object.keys(map).forEach(function (key) {
                var name = key + "张照片";
                if(key==9){
                    name = key + "张及以上";
                }
                arr.push({
                    name: name,
                    quantity: Number(key),
                    data: map[key],
                })
            })
            return arr.sort(this.compare('quantity'))
        }

        this.compare = function (property) {
            return function (a, b) {
                var value1 = a[property];
                var value2 = b[property];
                return value1 - value2;
            }
        }

        this.getPageImageboxNums = function (page) {
            var num = 0,arr=[];
            angular.forEach(page.levels.level,function (level) {
                if(level.imagebox&&level.imagebox.image&&level.imagebox.image.resource&&level.imagebox.image.resource.identifier){
                    // var image = level.imagebox.image;
                    // if(!image||image&&(!image.resource||image.resource&&image.resource.identifier)){
                        num++;
                    arr.push(level.imagebox)
                    // }
                }
            })
            return {
                num:num,
                imagebox:arr
            };
        }

        this.arrayAccumulate =function (values,attr) {
            var sum = values.reduce(function(prev, cur, index, array){
                // debugger
                return prev + cur;
            });//求数组中所有值的和
            return sum
        }

        this.minCoinChange = function (coins, amount, pageNums) {
            var result = null;
            if (!amount) return result;

            var makeChange = function(index, value, min) {
                if(index<0) return
                var coin = coins[index];
                var newAmount = Math.floor(value / coin);
                if (newAmount) min[coin] = newAmount;
                if (value % coin !== 0) {
                    makeChange(--index, value - coin * newAmount, min);
                }
            };

            var arr = [];
            for (var i = 0; i < coins.length; i++) {
                var cache = {};
                makeChange(i, amount, cache);
                arr.push(cache);
            }

            console.log(arr);
            var minArr = [];
            arr.forEach(function (item) {
                var min = 0;
                for (var v in item) min += item[v];
                console.log("min: "+min)
                if(min == pageNums){
                    minArr.push(item);
                    result = item;
                }
            });

            console.log(minArr)
            var index = Math.floor((Math.random()*minArr.length));
            console.log(minArr[index])
            console.log("-----------------")

            if(minArr[index]){
                return minArr[index]
            }else{
                return result;
            }

        }

        return this;

    }]);

(function () {
    'use strict';

    angular
        .module('editorApp')
        .controller('BoxCopyController', BoxCopyController);

    BoxCopyController.$inject = ['$scope', 'Category', '$uibModalInstance', 'MessageService','$translate'];

    function BoxCopyController( $scope, Category, $uibModalInstance, MessageService,$translate) {

        var vm = this;

        vm.clear = clear;
        vm.save = save;
        vm.types = [
            {name: $translate.instant("editorMessage.startWithTheCurrentPage"), page: 'this'},
            {name: $translate.instant("editorMessage.startWithTheFirstPage"), page: 'first'}
        ];

        vm.data={
            range:'this',
            generLoc:'all'
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        $scope.validate = function () {
            console.log(vm.data)
            if (vm.data.range == null || vm.data.range == "") {
                MessageService.error($translate.instant("editorMessage.pleaseSelectRange"));
                return false;
            }
            if (vm.data.generLoc == null || vm.data.generLoc == "") {
                MessageService.error($translate.instant("editorMessage.selectABuildLocation"));
                return false;
            }
            return true;
        };

        function save() {
            if (!$scope.validate()) {
                return;
            }
            onSaveSuccess(vm.data);
        }


        function onSaveSuccess(result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

    }

})();

(function () {
    'use strict';

    var bgOperation = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        controllerAs: 'vm',
        bindings: {
            document: '=',
            arrI: '=',
            pageI: '=',
            currentPage: '=',
            showBg: '=',
            bgw: '=',
            bgh: '=',
            slideW: '=',
            slideH: '=',
            bgl: '=',
            bgt: '=',
        },

        controller: ['$scope', 'ImageService', '$q', 'Qinius', 'Store', '$http', '$rootScope', 'Article', 'FontManagement', '$state',
            function ($scope, ImageService, $q, Qinius, Store, $http, $rootScope, Article, FontManagement, $state) {
                var vm = this;
                var drag = false;
                var dragBox = {};

                window.doubleClickbgImg = function (e) {
                    fn(e);
                    var currentPage = vm.currentPage;
                    if (currentPage.background && currentPage.background.resource && currentPage.background.resource.identifier) {
                        $scope.cutBgImg(currentPage, vm.pageI);
                    }
                    return
                }

                /**
                 * 进入图片编辑模式
                 */
                $scope.cutBgImg = function (page, pageI) {
                    var page = vm.document.pages[vm.pageI];
                    var arr = page.arr;
                    if (vm.arrI == 2) {
                        arr = page.arr2
                    }

                    vm.currentPage = arr;

                    vm.showBg = true;
                    console.log(vm)

                    vm.bgw = $('.bg-image' + vm.arrI + pageI).width();
                    vm.bgh = $('.bg-image' + vm.arrI + pageI).height();
                    vm.slideW = $(".slide" + vm.arrI + pageI).width();
                    vm.slideH = $(".slide" + vm.arrI + pageI).height();


                    $("#cut-mask-bg").attr('src', '');

                    var background = arr.background;
                    background.width = vm.bgw / arr.pageScaleW / page.scale;
                    background.height = vm.bgh / arr.pageScaleH / page.scale;

                    // 显示区域（包含上/下页按钮）
                    var bodyW = $(".web-con").width();
                    var bodyH = $(".web-con").height();

                    // 裁切框显示位置
                    var left = parseFloat($(".page-center").css('marginLeft')) + parseFloat($(".page-center").css('left')) + parseFloat($(".web" + vm.pageI).css('marginLeft'));
                    // var top = bodyH / 2 - $(".page-center").height() / 2;
                    var top = parseFloat($(".page-center").css('marginTop')) + parseFloat($(".page-center").css('top'));
                    if (vm.arrI == 2) {
                        left += $(".slide1" + vm.pageI).width();
                    }
                    vm.bgl = left;
                    vm.bgt = top;
                    $("#cut-bg").css({
                        left: left + background.offsetx * arr.pageScaleW * page.scale,
                        top: top + background.offsety * arr.pageScaleH / page.scale
                    });

                    ImageService.convertImgToBase64('content/images/white.png', function (s) {
                        var imagecanvas = $("#mask-canvas")[0];
                        var imagecontext = imagecanvas.getContext('2d');
                        var newImg = document.createElement('img');
                        // newImg.crossOrigin = "Anonymous";
                        newImg.src = 'content/images/zhezhao1.png';
                        newImg.onload = function () {
                            newImg.onload = null;
                            var masks = document.createElement('img');
                            masks.src = s;
                            // masks.crossOrigin = "Anonymous";
                            masks.onload = function () {
                                masks.onload = null;
                                imagecanvas.width = bodyW;
                                imagecanvas.height = bodyH;
                                imagecontext.drawImage(masks, left, top, vm.slideW, vm.slideH);
                                imagecontext.globalCompositeOperation = 'source-out';
                                imagecontext.drawImage(newImg, 0, 0, bodyW, bodyH);

                                $("#cut-mask-bg").attr('src', ImageService.dataURLtoBlob(imagecanvas.toDataURL()));

                                $scope.$digest();
                            };
                            // masks.src = box.maskUrl;
                        };
                        newImg.src = 'content/images/zhezhao1.png';
                    });
                    $scope.$apply();
                };

                /**
                 * 拖拽编辑的图片
                 */
                window.startBgEdit = function (e) {
                    fn(e);

                    // $scope.bgw = $('.bg-image' + vm.arrI + vm.pageI).width();
                    // $scope.bgh = $('.bg-image' + vm.arrI + vm.pageI).height();
                    // $scope.slideW = $(".slide" + vm.arrI + vm.pageI).width();
                    // $scope.slideH = $(".slide" + vm.arrI + vm.pageI).height();

                    var page = vm.document.pages[vm.pageI];
                    dragBox.clientX = e.clientX ? e.clientX : 0;
                    dragBox.clientY = e.clientY ? e.clientY : 0;
                    dragBox.picW = $("#cut-bg").width();
                    dragBox.picH = $("#cut-bg").height();
                    var background = vm.currentPage.background;
                    dragBox.coordX = background.offsetx * vm.currentPage.pageScaleW * page.scale;
                    dragBox.coordY = background.offsety * vm.currentPage.pageScaleH * page.scale;

                    drag = true;
                    document.addEventListener("mousemove", dragBgEdit, true);
                    document.addEventListener("mouseup", stopBgEdit, true);
                };

                function dragBgEdit(e) {

                    if (drag) {
                        var page = vm.document.pages[vm.pageI];
                        var background = vm.currentPage.background;
                        var x = 0, y = 0;

                        //手指离开屏幕
                        if (background.resource.adaptation == 'Height') {    //宽图
                            x = (dragBox.coordX + (e.clientX - dragBox.clientX));
                            //向左滑动;        <-----
                            if (-x >= (vm.bgw - vm.slideW)) {
                                x = -(vm.bgw - vm.slideW);
                            }
                            // 向右滑动;    ---->
                            if (x >= 0) {
                                x = 0;
                            }
                        } else {     //高图
                            y = (dragBox.coordY + (e.clientY - dragBox.clientY));
                            //向上滑动;
                            if (-y >= (vm.bgh - vm.slideH)) {
                                y = -(vm.bgh - vm.slideH);
                            }
                            //向下滑动;
                            if (y >= 0) {
                                y = 0;
                            }
                        }

                        $("#cut-bg").css({left: x + vm.bgl, top: y + vm.bgt});

                        background.offsetx = x / (vm.currentPage.pageScaleW * page.scale);
                        background.offsety = y / (vm.currentPage.pageScaleH * page.scale);

                        $scope.$digest();
                        e.stopPropagation();
                        e.preventDefault();
                        return false;

                    }

                };

                function stopBgEdit() {
                    drag = false;
                    dragBox = {};
                    document.removeEventListener("mousemove", dragBgEdit, true);
                    document.removeEventListener("mouseup", stopBgEdit, true);
                };

                //防止事件冒泡，默认事件
                function fn(e) {
                    // e = e || window.event;
                    // e.cancelBubble = true;
                    // e.stopPropagation();
                    // e.returnValue = false;
                    // e.preventDefault();
                    if (e && e.stopPropagation) {
                        // 因此它支持W3C的stopPropagation()方法
                        e.stopPropagation();
                    } else {
                        // 否则，我们需要使用IE的方式来取消事件冒泡
                        window.event.cancelBubble = true;
                    }

                    // 阻止默认浏览器动作(W3C)
                    if (e && e.preventDefault) {
                        e.preventDefault();
                    } else {
                        // IE中阻止函数器默认动作的方式
                        window.event.returnValue = false;
                    }
                }
            }]
    };

    angular
        .module('editorApp')
        .component('bgOperation', bgOperation);
})();

(function () {
    'use strict';

    var artOperation = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        controllerAs: '$scope',
        bindings: {
            document: '=',
            template: '=',
            arrI: '=',
            pageI: '=',
            currentPage: '=',
            ctrlKeyArray: '=',
            selectBox: '=',
            hasText: '=',
            fontOn: '=',
            fontDocOn: '=',
            isReplaceShow: '=',
        },

        controller: ['$scope', 'ImageService', '$q', 'Qinius', 'Store', '$http', '$rootScope', 'Article', 'FontManagement', '$state',
            function ($scope, ImageService, $q, Qinius, Store, $http, $rootScope, Article, FontManagement, $state) {
                var vm = this;
                var drag = false;
                var dragArt = {};
                console.log($scope)
                $scope.testt = function(){
                    console.log("-----------")
                }

                // 素材鼠标事件
                window.moveArtStart = function (e) {
                    fn(e);
                    if(vm.fontOn||vm.fontDocOn){
                        return
                    }
                    vm.hasText = false;
                    $scope.$parent.hasImgUrl = false;
                    var targ = e.target ? e.target : e.srcElement;
                    var imgIndex = targ.dataset.index || vm.template.levelI;
                    vm.arrI = targ.dataset.arrindex;
                    vm.template.levelI = imgIndex;

                    var page = vm.document.pages[vm.pageI];
                    if (vm.arrI == 1) {
                        vm.currentPage = page.arr;
                    } else {
                        vm.currentPage = page.arr2;
                    }

                    var imageart = vm.currentPage.levels.level[imgIndex].imageart;
                    getChooseBox(imageart, 'imageart');
                    $scope.$parent.removeContented()

                    if (imageart.lock || !imageart.movable) {
                        return
                    }

                    dragArt.clientX = e.clientX || 0;
                    dragArt.clientY = e.clientY || 0;
                    dragArt.coordX = targ.offsetParent.offsetParent.offsetLeft;
                    dragArt.coordY = targ.offsetParent.offsetParent.offsetTop;
                    dragArt.slideW = $(".slide" + vm.arrI + vm.pageI).width();
                    dragArt.slideH = $(".slide" + vm.arrI + vm.pageI).height();
                    drag = true;
                    var all = getAllCtrlKeyArray();
                    if (all.length) {
                        dragArt.ctrlKey = true;
                    } else {
                        dragArt.ctrlKey = false;
                    }
                    document.addEventListener("mousemove", moveArtOn, true);
                    document.addEventListener("mouseup", moveArtEnd, true);
                };

                //move事件
                function moveArtOn(e) {
                    fn(e);
                    if (e.target.nodeName == 'SPAN') {
                        return;
                    }
                    if (drag) {
                        var currentPage = vm.currentPage;
                        var page = vm.document.pages[vm.pageI];
                        var pressArt = currentPage.levels.level[vm.template.levelI].imageart;
                        var clientX = e.clientX - dragArt.clientX;
                        var clientY = e.clientY - dragArt.clientY;

                        var imgOffsetX = (dragArt.coordX + clientX);
                        var imgOffsetY = (dragArt.coordY + clientY);
                        var imgWidth = pressArt.geometry.width * currentPage.pageScaleW * page.scale;
                        var imgHeight = pressArt.geometry.height * currentPage.pageScaleH * page.scale;
                        var x = currentPage.editbox.x * currentPage.pageScaleW * page.scale;
                        var y = currentPage.editbox.y * currentPage.pageScaleW * page.scale;

                        // $(".move-tip").hide();
                        //中心点
                        var xcenter = imgWidth / 2 + imgOffsetX;
                        var ycenter = imgHeight / 2 + imgOffsetY;

                        var artx = 0, arty = 0;

                        if (pressArt.rotation.angle == 0) {

                            // if (imgOffsetX <= 0) {
                            //     imgOffsetX = 0;
                            // }
                            //
                            // if (imgOffsetX <= x || imgOffsetY <= y) {
                            //     $(".move-tip").show();
                            // }
                            // if (imgOffsetY >= (dragArt.slideH - imgHeight - y)) {
                            //     $(".move-tip").show();
                            // }
                            //
                            // if (imgOffsetX >= dragArt.slideW - imgWidth) {
                            //     imgOffsetX = dragArt.slideW - imgWidth;
                            // }
                            // if (imgOffsetX >= dragArt.slideW - imgWidth - x) {
                            //     $(".move-tip").show();
                            // }
                            //
                            // if (imgOffsetY <= 0) {
                            //     imgOffsetY = 0;
                            // }
                            //
                            // if (imgOffsetY >= (dragArt.slideH - imgHeight)) {
                            //     imgOffsetY = dragArt.slideH - imgHeight;
                            // }
                            artx = imgOffsetX / currentPage.pageScaleW / page.scale;
                            arty = imgOffsetY / currentPage.pageScaleH / page.scale
                        } else {
                            // if (xcenter <= 0) {
                            //     xcenter = 0;
                            // }
                            //
                            // if (xcenter >= dragArt.slideW) {
                            //     xcenter = dragArt.slideW;
                            // }
                            //
                            // if (ycenter <= 0) {
                            //     ycenter = 0;
                            // }
                            //
                            // if (ycenter >= dragArt.slideH) {
                            //     ycenter = dragArt.slideH;
                            // }
                            artx = (xcenter - imgWidth / 2) / currentPage.pageScaleW / page.scale;
                            arty = (ycenter - imgHeight / 2) / currentPage.pageScaleH / page.scale;
                        }

                        if (dragArt.ctrlKey) {
                            moveTogether(currentPage, clientX, clientY,dragArt);
                        } else {

                            pressArt.geometry.x = artx;
                            pressArt.geometry.y = arty;

                        }

                        $scope.$apply();

                    }
                    return false;
                }

                //鼠标松开事件
                function moveArtEnd() {
                    if (dragArt.ctrlKey) {
                        moveTogetherEnd();
                    }
                    drag = false;
                    dragArt = {};
                    $(".move-tip").hide();
                    uploadRightPlanel();
                    $scope.$parent.updateHistory();
                    document.removeEventListener("mousemove", moveArtOn, true);
                    document.removeEventListener("mouseup", moveArtEnd, true);
                    $scope.$digest();
                }

                function uploadRightPlanel() {
                    // $scope.template.pages.page[$scope.currentPage.seq - 1] = angular.copy($scope.currentPage);
                    var p = [];
                    angular.forEach(vm.document.pages, function (item, index) {
                        p.push(item.arr);
                        if (item.arr2) {
                            p.push(item.arr2);
                        }
                    });
                    vm.template.pages.page = p;
                }

                function getChooseBox(box, attr) {
                    vm.selectBox = box;
                    vm.selectBox.current = attr;
                    hideChangeBtn();
                }

                function hideChangeBtn() {
                    $(".change-btn").hide();
                    vm.isReplaceShow = true;
                }

                function getAllCtrlKeyArray() {
                    var imageboxes = vm.ctrlKeyArray.imageboxes,
                        textboxes = vm.ctrlKeyArray.textboxes,
                        imagearts = vm.ctrlKeyArray.imagearts,
                        all = [];
                    var barcode = vm.ctrlKeyArray.barcode;
                    //选中的占位框
                    for (var i = 0; i < imageboxes.length; i++) {
                        if (imageboxes[i]) {
                            all.push(imageboxes[i]);
                        }
                    }
                    //选中的文本框
                    for (var i = 0; i < textboxes.length; i++) {
                        if (textboxes[i]) {
                            all.push(textboxes[i]);
                        }
                    }
                    //选中的素材
                    for (var i = 0; i < imagearts.length; i++) {
                        if (imagearts[i]) {
                            all.push(imagearts[i]);
                        }
                    }
                    //选中的条码
                    for (var i = 0; i < barcode.length; i++) {
                        all.push(barcode[i]);
                    }
                    return all;
                }

                function moveTogether(currentPage, clientX, clientY,dragbox) {
                    var page = vm.document.pages[vm.pageI];
                    var imgWidth = 0, imgHeight = 0, x = 0, y = 0, pro = currentPage.pageScaleW * page.scale;
                    angular.forEach(vm.ctrlKeyArray.imageboxes, function (imagebox, i) {
                        // 当前页所有占位框
                        var box = currentPage.levels.level[imagebox.levelI].imagebox;
                        boxSetting(box, imagebox);
                    })

                    angular.forEach(vm.ctrlKeyArray.imagearts, function (imageart, i) {
                        // 当前页所有素材
                        var box = currentPage.levels.level[imageart.levelI].imageart;
                        boxSetting(box, imageart);
                    })

                    angular.forEach(vm.ctrlKeyArray.textboxes, function (textbox, i) {
                        // 当前页所有文字
                        var box = currentPage.levels.level[textbox.levelI].textbox;
                        boxSetting(box, textbox);
                    })

                    angular.forEach(vm.ctrlKeyArray.textdocuments, function (textdocument, i) {
                        // 当前页所有文字
                        var box = currentPage.levels.level[textdocument.levelI].textdocument;
                        boxSetting(box, textdocument);
                    })

                    function boxSetting(box, CtrlKeyBox) {
                        imgWidth = box.geometry.width * pro;
                        imgHeight = box.geometry.height * pro;
                        x = CtrlKeyBox.geometry.x * pro + clientX;
                        y = CtrlKeyBox.geometry.y * pro + clientY;
                        if (x <= 0) {
                            x = 0;
                        }
                        if (x >= (dragbox.slideW - imgWidth)) {
                            x = dragbox.slideW - imgWidth;
                        }
                        if (y <= 0) {
                            y = 0;
                        }

                        if (y >= (dragbox.slideH - imgHeight)) {
                            y = dragbox.slideH - imgHeight;
                        }
                        box.geometry.x = x / pro
                        box.geometry.y = y / pro
                    }
                }

                function moveTogetherEnd() {
                    angular.forEach(vm.ctrlKeyArray.imageboxes, function (imagebox, i) {
                        // 当前页所有占位框
                        var box = vm.currentPage.levels.level[imagebox.levelI].imagebox;
                        ctrlKeySetting(box, imagebox);
                    })

                    angular.forEach(vm.ctrlKeyArray.imagearts, function (imageart, i) {
                        // 当前页所有素材
                        var box = vm.currentPage.levels.level[imageart.levelI].imageart;
                        ctrlKeySetting(box, imageart);
                    })

                    angular.forEach(vm.ctrlKeyArray.textboxes, function (textbox, i) {
                        // 当前页所有文字
                        var box = vm.currentPage.levels.level[textbox.levelI].textbox;
                        ctrlKeySetting(box, textbox);
                    })

                    angular.forEach(vm.ctrlKeyArray.textdocuments, function (textdocument, i) {
                        // 当前页所有文字
                        var box = vm.currentPage.levels.level[textdocument.levelI].textdocument;
                        ctrlKeySetting(box, textdocument);
                    })

                    function ctrlKeySetting(box, CtrlKeyBox) {
                        CtrlKeyBox.geometry.x = box.geometry.x;
                        CtrlKeyBox.geometry.y = box.geometry.y;
                    }
                }

                //防止事件冒泡，默认事件
                function fn(e) {
                    // e = e || window.event;
                    // e.cancelBubble = true;
                    // e.stopPropagation();
                    // e.returnValue = false;
                    // e.preventDefault();
                    if (e && e.stopPropagation) {
                        // 因此它支持W3C的stopPropagation()方法
                        e.stopPropagation();
                    } else {
                        // 否则，我们需要使用IE的方式来取消事件冒泡
                        window.event.cancelBubble = true;
                    }

                    // 阻止默认浏览器动作(W3C)
                    if (e && e.preventDefault) {
                        e.preventDefault();
                    } else {
                        // IE中阻止函数器默认动作的方式
                        window.event.returnValue = false;
                    }
                }
            }],
        link:function () {

        }
    };

    angular
        .module('editorApp')
        .component('artOperation', artOperation);
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .factory('ThreeEnv', ThreeEnv);

    ThreeEnv.$inject = ['$q'];

    function ThreeEnv ($q) {
        var environments = [{
            id: 'comfy-cafe-1',
            name: 'Comfy Cafe',
            path: 'lib/three/env/comfy_cafe_1k.hdr',
            format: '.hdr'
        }, {
            id: 'comfy-cafe-2',
            name: 'Comfy Cafe 2K',
            path: 'lib/three/env/comfy_cafe_2k.hdr',
            format: '.hdr'
        }, {
            id: 'venice-sunset',
            name: 'Venice Sunset',
            path: 'lib/three/env/venice_sunset_1k.hdr',
            format: '.hdr'
        }];
        var envIndex = 0;

        var service = {
            getEnvMap: getEnvMap
        };

        return service;

        function getEnvMap (renderer) {
            if (envIndex < 0) {
                envIndex = 0;
            }
            if (envIndex >= environments.length) {
                envIndex = environments.length - 1;
            }
            var env = environments[envIndex];
            return getCubeMapTexture(renderer, env);
        }

        function getCubeMapTexture (renderer, environment) {
            var path = environment.path;

            var deferred = $q.defer();
            // no envmap
            if ( ! path ) {
                deferred.resolve( { envMap: null } );
                return deferred.promise;
            }
            console.log("try to loading environment: " + environment.id);
            new THREE.RGBELoader()
            .setDataType( THREE.HalfFloatType )
            .load( path, 
                function ( texture ) {
                    var pmremGenerator = new THREE.PMREMGenerator( renderer );
                    pmremGenerator.compileEquirectangularShader();
                    const envMap = pmremGenerator.fromEquirectangular( texture ).texture;
                    pmremGenerator.dispose();

                    var data = {envMap: envMap};
                    deferred.resolve(data);

                }, 
                undefined, // progress
                deferred.reject );

            return deferred.promise;

        }
    }
})();

(function () {
    'use strict';

    angular
        .module('editorApp')
        .controller('PageViewArticleController', PageViewArticleController);

    PageViewArticleController.$inject = ['$scope', '$stateParams', 'Qinius', '$q', 'ImageService', 'PlatformWechatSetting',
        'Article', 'Music', 'MessageService','$state', 'ProductXml', 'ItemValue', 'Convert', 'Product','StoreWorkEditConfig','OrderArticle', 'ModulesService','$localStorage','$translate'];

    function PageViewArticleController($scope, $stateParams, Qinius, $q, ImageService, PlatformWechatSetting,
                                       Article, Music, MessageService,$state, ProductXml, ItemValue, Convert, Product, StoreWorkEditConfig,OrderArticle, ModulesService,$localStorage,$translate) {
        var vm = this;
        $(".navbar").hide();
        $(".wrap").addClass('no-margins').css({height:'100vh',background:'#fff'});
        vm.storeId = $stateParams.storeId;
        vm.aid = $stateParams.aid;
        vm.orderArticleId = $stateParams.orderArticleId;
        if($stateParams.authorization){
            $localStorage.authenticationToken = $stateParams.authorization;
        }
        vm.isNav = false;
        if (vm.aid) {
            vm.article = Article.get({id: vm.aid});
        } else {
            vm.isNav = true;
            vm.article = OrderArticle.get({id: vm.orderArticleId});
        }

        vm.itemValue={};
        vm.watchSure = false;
        function getProductXml() {
            ProductXml.get({id:vm.article.productXmlId}, function (productXml) {
                if(productXml.status == 200){
                    vm.fileName = vm.article.fileName;
                    if(productXml.data.modelType && productXml.data.modelType === 'THREE'){
                        if(!productXml.data.modelPath){
                            MessageService.error($translate.instant("editorMessage.not3D"));
                            return
                        }
                        vm.threeProductXmlData = productXml.data;
                        vm.threeView = true;
                    }else if(vm.article.editorType == 'PICTURE' || vm.article.editorType == 'PICTURE_PRO' || vm.article.editorType == 'PICTURE_PRO_P'){
                        vm.picture = true;
                    }else {
                        vm.watchSure = true;
                        // vm.previewArticle = template;
                        ItemValue.get({id: vm.article.itemValueId}, function (resp) {
                            vm.itemValue = resp.data;
                        })
                    }
                }else {
                    MessageService.error(productXml.message)
                }
            })
        }

        // return
        vm.musicPage = false;
        var audio = document.getElementById("audio");
        var timer = null;


        var returnurl = localStorage.getItem('returnurl');
        vm.returnurl = localStorage.getItem('returnurl');
        vm.returnurl1 = localStorage.getItem('returnurl1');
        vm.returnurl2 = localStorage.getItem('returnurl2');
        vm.returnurl2Text = localStorage.getItem('returnurl2Text') || $translate.instant("button.buttonText");
        $scope.domains = Qinius.getDomain();
        vm.platformSetting = PlatformWechatSetting.get();


        $scope.gotoOrder = function(){
            window.location.href = vm.returnurl2;
        }
        StoreWorkEditConfig.storeId({storeId: vm.storeId}, function (res) {
            if(res.status == 200){
                vm.returnurl2Text = localStorage.getItem('returnurl2Text') || res.data.buttonText;
            }else{
                swal.showInputError(res.message);
            }
        });

        $(".modal-content").addClass('opacity0');
        vm.isHideMusicBtn = true;
        $q.all([$scope.domains.$promise, vm.platformSetting.$promise, vm.article.$promise]).then(function () {
            vm.article = vm.article.data;
            if(vm.article.invalid){//作品失效
                $state.go('articlesFailure',{storeId:vm.storeId},{location: 'replace'});
                return
            }
            // 作品不存在
            if(!vm.article.productXmlId){
                MessageService.error($translate.instant("editorMessage.workNotExist"));
                return
            }
            Product.get({id: vm.article.productId}, function (resP) {
                vm.product = resP.data;
                Convert.xmlToDocument2({
                    identifier: vm.article.fileName,
                    provider: 'qiniu',
                    editorType:vm.article.editorType,
                    pictureType:resP.data.pictureType,
                    patternType:resP.data.patternType,
                }, function (resp) {
                    vm.previewArticle = resp;
                    vm.previewArticle.pages.page.forEach(function (page, index){
                        page.seq = index;
                    })
                    console.log(vm.previewArticle)
                },function (error) {
                    if(error.data.status === 403){//未授权
                        $state.go('404',{storeId:vm.storeId},{location: 'replace'});
                    }
                });

                vm.platformSetting = vm.platformSetting.data;
                $scope.domain = 'https://' + $scope.domains.domains[0] + '/';
                getProductXml();

                if (vm.article.musicIdentify) {
                    vm.isHideMusicBtn = false;
                    audio.src = $scope.domain + vm.article.musicIdentify;
                    console.log(audio.src)
                    // 自动播放音乐
                    Play();
                } else {
                    audio.src = '';
                    // vm.isHideMusicBtn = true;
                }


                if(vm.article.editorType == "POSTER"){
                    vm.isPoster = true;
                    $('#qrcode1').qrcode({
                        render: "canvas",
                        width: 100,
                        height: 100,
                        text: '' + vm.platformSetting.editorNotifyUrl + "/#/" + vm.storeId + "/" + vm.aid + "/viewShare"
                    });
                }else {
                    vm.isPoster = false;
                    // 分享二维码
                    $('#qrcode1').qrcode({
                        render: "canvas",
                        width: 100,
                        height: 100,
                        text: '' + vm.platformSetting.editorNotifyUrl + "/#/" + vm.storeId + "/" + vm.aid + "/view2/0"
                    });
                }
                Music.allByCondition({
                    items: [],
                    sort: ["id,asc"]
                }, function (resp) {
                    if(resp.status==200){
                        $scope.Musics = resp.data;
                    }

                });

                //获取自定义颜色
                ModulesService.getToneSettings(vm.storeId,function (res) {
                    vm.toneSettings = res;
                });
            })
        });

        $scope.edit = function(){
            if(vm.article.editorType == "PICTURE" || vm.article.editorType == "PICTURE_PRO" || vm.article.editorType == "PICTURE_PRO_P"){
                Product.get({id: vm.article.productId}, function (product) {
                    $state.go("editorPhotoBothWebEdit", {storeId: vm.storeId, aid:  vm.aid},{location: 'replace'});
                })
            } else {
                $state.go('editorPhotoAlbumEdit', {storeId:vm.storeId,aid:vm.aid},{location: 'replace'})
            }
        }
        vm.isPlay = true;
        //音乐
        function Play() {
            audio.play().then(function () {
                vm.isPlay = true;
                $scope.$digest();
                $(".PanelRight").removeClass('hide1');
                timer = window.setInterval(begin, 10);

            }).catch(function (error) {
                console.log(error);
            });
        }

        function Pause() {
            audio.pause();
            vm.isPlay = false;
            $scope.$digest();
        }

        var rot = 10 - 0;
        function begin() {
            var micon = document.getElementById("music-icon");
            if (micon == null) {
                window.clearInterval(timer);
                return;
            }
            micon.style.transform = "rotate(" + rot + "deg)";
            rot += 1;
        }

        $("#Play").on('click', function () {
            window.clearInterval(timer);
            if (audio.paused) {
                if ($(this).children().hasClass('play')) {
                    $("#Play").children("img").removeClass("play").addClass("pause");
                    Play();
                }
            } else {
                $("#Play").children("img").removeClass("pause").addClass("play");
                Pause();
            }
        });

        var audioTest = null;
        $scope.openMusicList = function () {
            vm.musicPage = true;
            audio.pause();
            vm.musicIdentify = vm.article.musicIdentify;
            if (vm.article.musicIdentify) {
                angular.forEach($scope.Musics, function (music, i) {
                    if (music.identify == vm.article.musicIdentify) {
                        $(".music-current").hide();
                        $(".music-current" + i).show();
                        setMusicStyle(i)
                    }
                })
            }

            audioTest = document.getElementById("audition");
            audioTest.crossOrigin = 'anonymous';
        };

        $scope.playList = function (identify, index) {
            // audioTest.pause();
            audioTest.src = $scope.domain + identify;
            vm.musicIdentify = identify;
            audioTest.play();
            setMusicStyle(index);
        };

        function setMusicStyle(index) {
            $(".music-name").removeClass('music-active2');
            $(".music-name" + index).addClass('music-active2');
            $(".music-li").removeClass('music-bgActive2');
            $(".music-li" + index).addClass('music-bgActive2');
            $(".music-icon").hide();
            $(".music-icon" + index).show();
        }

        $scope.saveMusic = function () {
            if (vm.musicIdentify == null || vm.musicIdentify == "") {
                vm.musicPage = false;
            } else {
                Article.updateMusic({id: vm.article.id, musicIdentify: vm.musicIdentify}, function (res) {
                    if(res.status == 200){
                        vm.article = res.data;
                        vm.musicPage = false;
                        audio.src = $scope.domain + vm.article.musicIdentify;
                        audioTest.pause();
                        audio.play();
                        Play();
                    }else {
                        MessageService.error(res.message);
                    }
                }, function () {

                })
            }

        };

        $scope.cancel = function () {
            vm.musicPage = false;
            audioTest.pause();
            audio.play();
        };

        vm.qrcodeShow = false
        $scope.shareParents = function () {
            vm.qrcodeShow = !vm.qrcodeShow;
        }

        $scope.reorder = function(){
            window.location.href = vm.returnurl2;
        }

        $scope.openViewList = function () {
            $scope.viewPage=!$scope.viewPage
        }

        $scope.backToList = function () {
            window.location.href = vm.returnurl1;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('editorApp')
        .controller('PageMySuffixCreateController', PageMySuffixCreateController);

    PageMySuffixCreateController.$inject = ['$scope', 'Category', '$uibModalInstance', 'MessageService','entity','$translate'];

    function PageMySuffixCreateController( $scope, Category, $uibModalInstance, MessageService, entity ,$translate) {

        var vm = this;
        console.log(entity);
        vm.type = entity.type;
        vm.name = entity.name || '';
        vm.clear = clear;
        vm.save = save;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        $scope.validate = function () {
            if (vm.name == null || vm.name == "") {
                MessageService.error($translate.instant("editorMessage.pleaseEnterFolderName"));
                return false;
            }
            return true;
        };

        function save() {
            if (!$scope.validate()) {
                return;
            }
            onSaveSuccess(vm.name);
        }


        function onSaveSuccess(result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('editorApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('articlesFailure',{
                parent:'entity',
                url:'/{storeId}/articlesFailure',
                data:{
                    authorities: [],
                    pageTitle: ''
                },
                views:{
                    'navbar@': {
                        templateUrl: 'app/entities/page/articles-failure.html',
                        params:{'tips':null},
                        controller: 'Page404Controller',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    tips: {

                    }
                }
            })
            .state('404',{
                parent:'entity',
                url:'/{storeId}/404',
                data:{
                    authorities: [],
                    pageTitle: ''
                },
                views:{
                    'navbar@': {
                        templateUrl: 'app/entities/page/page-404.html',
                        params:{'tips':null},
                        controller: 'Page404Controller',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    tips: {

                    }
                }
            })
            .state('page-view', {
                parent: 'entity',
                url: '/{storeId}/webView/{aid}',
                data: {
                    authorities: [],
                    pageTitle: 'editorApp.product.detail.viewTitle'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/page/page-view-article.html',
                        controller: 'PageViewArticleController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('editorWeb');
                        $translatePartialLoader.addPart('common');
                        return $translate.refresh();
                    }],
                    // entity: ['$stateParams', 'Article', function ($stateParams, Article) {
                    //     return Article.get({id: $stateParams.aid}).$promise;
                    // }]
                }
            })
            .state('page-view2', {
                parent: 'entity',
                url: '/{storeId}/webView2/{orderArticleId}?&authorization',
                data: {
                    authorities: [],
                    pageTitle: 'editorApp.product.detail.viewTitle'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/page/page-view-article.html',
                        controller: 'PageViewArticleController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('editorWeb');
                        $translatePartialLoader.addPart('common');
                        return $translate.refresh();
                    }],
                    // entity: ['$stateParams', 'Article', function ($stateParams, Article) {
                    //     return Article.get({id: $stateParams.orderArticleId}).$promise;
                    // }]
                }
            })
            .state('editorPhotoWeb', {
                parent: 'entity',
                url: '/{storeId}/print/{pid}/{vid}/{xmlId}/{aid}',
                data: {
                    authorities: [],
                    pageTitle: 'editorApp.page.home.title'
                },
                views: {
                    'content2@': {
                        templateUrl: 'app/entities/page/editor-photo-both-web.html',
                        controller: 'EditorPhotoBothWebController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('editorWeb');
                        $translatePartialLoader.addPart('common');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            type: 'add'
                        };
                    }
                }
            })
            .state('editorPhotoWebEdit1', {
                parent: 'app',
                url: '/{storeId}/{orderArticleId}/printOrder?authorization',
                data: {
                    authorities: [],
                    pageTitle: 'editorApp.page.home.title'
                },
                views: {
                    'content2@': {
                        templateUrl: 'app/entities/page/editor-photo-both-web.html',
                        controller: 'EditorPhotoBothWebController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('editorWeb');
                        $translatePartialLoader.addPart('common');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            type: 'edit'
                        };
                    }
                }
            })
            .state('editorPhotoBothWeb', {
                parent: 'entity',
                url: '/{storeId}/print/{pid}/{vid}/{xmlId}/{aid}',
                data: {
                    authorities: [],
                    pageTitle: 'editorApp.page.home.title'
                },
                views: {
                    'content2@': {
                        templateUrl: 'app/entities/page/editor-photo-both-web.html',
                        controller: 'EditorPhotoBothWebController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('editorWeb');
                        $translatePartialLoader.addPart('common');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            type: 'add'
                        };
                    }
                }
            })
            .state('editorPhotoBothWebEdit', {
                parent: 'app',
                url: '/{storeId}/{aid}/print',
                data: {
                    authorities: [],
                    pageTitle: 'editorApp.page.home.title'
                },
                views: {
                    'content2@': {
                        templateUrl: 'app/entities/page/editor-photo-both-web.html',
                        controller: 'EditorPhotoBothWebController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('editorWeb');
                        $translatePartialLoader.addPart('common');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            type: 'edit'
                        };
                    }
                }
            })
            .state('editorPhotoBothWebEdit1', {
                parent: 'app',
                url: '/{storeId}/{orderArticleId}/printOrder?authorization',
                data: {
                    authorities: [],
                    pageTitle: 'editorApp.page.home.title'
                },
                views: {
                    'content2@': {
                        templateUrl: 'app/entities/page/editor-photo-both-web.html',
                        controller: 'EditorPhotoBothWebController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('editorWeb');
                        $translatePartialLoader.addPart('common');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            type: 'edit'
                        };
                    }
                }
            })

            .state('editorPhotoAlbum', {
                parent: 'entity',
                url: '/{storeId}/photobook/{pid}/{vid}/{xmlId}/{aid}',
                data: {
                    authorities: [],
                    pageTitle: 'editorApp.page.home.title'
                },
                views: {
                    'content2@': {
                        templateUrl: 'app/entities/page/editor-photo-album.html',
                        controller: 'EditorPhotoAlbumController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('editorWeb');
                        $translatePartialLoader.addPart('common');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            id: null,
                            type: 'add'
                        };
                    }
                }
            })
            .state('editorPhotoAlbumEdit', {
                parent: 'app',
                url: '/{storeId}/photobook/{aid}',
                data: {
                    authorities: [],
                    pageTitle: 'editorApp.page.home.title'
                },
                views: {
                    'content2@': {
                        templateUrl: 'app/entities/page/editor-photo-album.html',
                        controller: 'EditorPhotoAlbumController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('editorWeb');
                        $translatePartialLoader.addPart('common');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            id: null,
                            type: 'edit'
                        };
                    }
                }
            })
            .state('editorPhotoAlbumEdit1', {
                parent: 'app',
                url: '/{storeId}/{orderArticleId}/photobookOrder?authorization',
                data: {
                    authorities: [],
                    pageTitle: 'editorApp.page.home.title'
                },
                views: {
                    'content2@': {
                        templateUrl: 'app/entities/page/editor-photo-album.html',
                        controller: 'EditorPhotoAlbumController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('editorWeb');
                        $translatePartialLoader.addPart('common');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            id: null,
                            type: 'edit'
                        };
                    }
                }
            })
        ;
    }

})();

(function() {
    'use strict';
    angular
        .module('editorApp')
        .factory('Page', Page)
        .factory('Category', Category)
        .factory('FontManagement', FontManagement)
        .factory('FontXmlsManger', FontXmlsManger)
        .factory('FontXmlsFileServes', FontXmlsFileServes)
        .factory('ClipArt', ClipArt)
        .factory('Backgrounds', Backgrounds)
        .factory('Material', Material)
        .factory('Article', Article)
        .factory('Music', Music)
        .factory('XmlToImg', XmlToImg)
        .factory('StoreWorkEditConfig', StoreWorkEditConfig)
        .factory('FrameConfigs', FrameConfigs)
        .factory('Algorithm', Algorithm)
        .factory('StoreStorages', StoreStorages)
        .factory('CalendarService', CalendarService)
        .factory('MattingBgByKey', MattingBgByKey)
        .factory('Faces', Faces);

    Page.$inject = ['$resource'];
    Category.$inject = ['$resource'];
    FontManagement.$inject = ['$resource'];
    FontXmlsManger.$inject = ['$resource'];
    FontXmlsFileServes.$inject = ['$resource'];
    ClipArt.$inject = ['$resource', 'DateUtils'];
    Backgrounds.$inject = ['$resource', 'DateUtils'];
    Material.$inject = ['$resource'];
    Article.$inject = ['$resource'];
    Music.$inject = ['$resource'];
    XmlToImg.$inject = ['$resource'];
    StoreWorkEditConfig.$inject = ['$resource'];
    FrameConfigs.$inject = ['$resource'];
    Algorithm.$inject = ['$resource'];
    CalendarService.$inject = ['$resource'];
    StoreStorages.$inject = ['$resource'];
    MattingBgByKey.$inject = ['$resource'];
    Faces.$inject = ['$resource'];

    function Faces($resource) {
        var resourceUrl = 'faces/' + 'api/:path';
        return $resource(resourceUrl, {}, {
            "detectByUrl": {
                method: "GET",
                params: {
                    path: "detect_by_url"
                }
            },
        });
    }
    function MattingBgByKey($resource) {
        var resourceUrl = 'matting/' + 'api/matting_by_key/:path';
        return $resource(resourceUrl, {}, {
            "get": {
                method: "GET"
            },
        });
    }

    function StoreStorages($resource) {
        var resourceUrl = 'manager/' + 'api/store-storages/:path';
        return $resource(resourceUrl, {}, {
            "uploadAble": {
                method: "GET",
                params: {
                    path: "uploadAble"
                }
            },
        });
    }

    function Algorithm($resource) {
        var resourceUrl = 'service/' + 'api/algorithm/:path/:id';
        return $resource(resourceUrl, {}, {
            "pageSelect": {
                method: "POST",
                params: {
                    path: "pageSelect"
                }
            },
            "pageSelectV2": {
                method: "POST",
                params: {
                    path: "pageSelectV2"
                }
            },
        });
    }
    function FrameConfigs ($resource) {
        var resourceUrl =  'manager/' + 'api/frame-configs/:path/:id';

        return $resource(resourceUrl, {}, {
            'byCondition3': {
                method: 'POST',
                params: {
                    path: 'byCondition3'
                }
            },
            'byCondition': {
                method: 'POST',
                params: {
                    path: 'byCondition'
                }
            },
            "getAllByCondition":{
                method:"POST",
                params:{
                    path:"getAllByCondition"
                }
            },
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'uploadAble': {
                method:'GET',
                params: {
                    path: 'uploadAble'
                },
            },
            'update': { method:'PUT' }
        });
    }
    function Page ($resource) {
        var resourceUrl =  'api/pages/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET'},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
    function Category ($resource) {
        var resourceUrl =  'manager/' + 'api/categories/:path/:id';

        return $resource(resourceUrl, {}, {
            'byCondition': {
                method: 'POST',
                params: {
                    path: 'byCondition'
                }
            },
            "getAllByCondition":{
                method:"POST",
                params:{
                    path:"getAllByCondition"
                }
            },
            'query': { method: 'GET'},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
    function FontManagement ($resource) {
        var resourceUrl =  'manager/' + 'api/font-managements/:path/:id';

        return $resource(resourceUrl, {}, {
            "fontSupport2":{
                method:"POST",
                params:{
                    path:"font-support2"
                }
            },
            "fontSupport":{
                method:"GET",
                params:{
                    path:"font-support"
                }
            },
            "getDefaultShow":{
                method:"GET",
                params:{
                    path:"getDefaultShow"
                }
            },
            "getCss": {
                method: "GET",
                params: {
                    path: "getCss2"
                }
            },
            "getAll": {
                method: "GET",
                params: {
                    path: "getAllForClient"
                },
                isArray:true
            },
            'query': { method: 'GET'},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
    function FontXmlsManger($resource) {
        var resourceUrl = 'manager/' + 'api/font-xmls/:path/:id';

        return $resource(resourceUrl, {}, {
            "save": {
                method: 'POST'
            },
            "delete": {
                method: 'DELETE'
            },
            "release": {
                method: 'POST',
                params:{
                    path:"release"
                },
            },
            "byCondition":{
                method:"POST",
                params:{
                    path:"byCondition"
                }
            },
            "getAll":{
                method:"POST",
                params:{
                    path:"getAll"
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT'
            },
            'onlyRelease': {
                method: 'GET',
                params:{
                    path:"onlyRelease"
                },
            },
            'share': {
                method: 'GET',
                params:{
                    path:"share"
                },
            },
            'auditing': {
                method: 'GET',
                params:{
                    path:"auditing"
                },
            },
        });
    }
    function FontXmlsFileServes($resource) {
        var resourceUrl = 'fileserves/' + 'api/font-xmls/:path/:id';

        return $resource(resourceUrl, {}, {
            "save": {
                method: 'POST'
            },
            "delete": {
                method: 'DELETE'
            },
            "release": {
                method: 'POST',
                params:{
                    path:"release"
                },
            },
            "byCondition":{
                method:"POST",
                params:{
                    path:"byCondition"
                }
            },
            "byCondition2":{
                method:"POST",
                params:{
                    path:"byCondition2"
                }
            },
            "getAll":{
                method:"POST",
                params:{
                    path:"getAll"
                }
            },
            "getAll2":{
                method:"POST",
                params:{
                    path:"getAll2"
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT'
            },
            'onlyRelease': {
                method: 'GET',
                params:{
                    path:"onlyRelease"
                },
            },
            'share': {
                method: 'GET',
                params:{
                    path:"share"
                },
            },
            'auditing': {
                method: 'GET',
                params:{
                    path:"auditing"
                },
            },
        });
    }
    function ClipArt($resource, DateUtils) {
        var resourceUrl = 'manager/' + 'api/clipArt/:path/:id';

        return $resource(resourceUrl, {}, {
            'byCondition': {
                method: 'POST',
                params: {
                    path: 'byCondition'
                }
            },
            'byCondition3': {
                method: 'POST',
                params: {
                    path: 'byCondition3'
                }
            },
            'byCondition4': {
                method: 'POST',
                params: {
                    path: 'byCondition4'
                }
            },
            "getAllByCondition": {
                method: "POST",
                params: {
                    path: "getAllByCondition"
                }
            },
            "updateType": {
                method: "GET",
                params: {
                    path: "updateType"
                }
            },
            'get': {
                method: 'GET',
                params: {
                    path: 'getone'
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                params: {
                    path: 'update'
                },
                transformRequest: function(data) {
                    var copy = angular.copy(data);
                    copy.startTime = DateUtils.convertLocalDateToServer(copy.startTime);
                    copy.endTime = DateUtils.convertLocalDateToServer(copy.endTime);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                params: {
                    path: 'save'
                },
                transformRequest: function(data) {
                    var copy = angular.copy(data);
                    copy.startTime = DateUtils.convertLocalDateToServer(copy.startTime);
                    copy.endTime = DateUtils.convertLocalDateToServer(copy.endTime);
                    return angular.toJson(copy);
                }
            },
            'batchCreate':{
                method: 'GET',
                params: {
                    path: 'batchCreate'
                }
            },
            'delete': {
                method: 'DELETE',
                params: {
                    path: 'delete'
                }
            }
        });
    }
    function Backgrounds($resource) {
        var service = $resource('manager/api/backgrounds/:path/:id', {}, {
            'getAll': {
                method: 'POST',
                params: {
                    path: 'getAll'
                }
            },
            "byCondition":{
                method:"POST",
                params:{
                    path:"byCondition"
                }
            },
            "byCondition3":{
                method:"POST",
                params:{
                    path:"byCondition3"
                }
            },
            'query': { method: 'GET'},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
        return service;
    }
    function Material ($resource) {
        var resourceUrl =  'manager/' + 'api/materials/:path/:id';

        return $resource(resourceUrl, {}, {
            'byCondition': {
                method: 'POST',
                params: {
                    path: 'byCondition'
                }
            },
            "getAllByCondition": {
                method: "POST",
                params: {
                    path: "getAllByCondition"
                }
            },
            'query': { method: 'GET'},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getAll': {
                method: 'POST',
                params: {
                    path: 'getAll'
                }
            },
            "byCondition3":{
                method:"POST",
                params:{
                    path:"byCondition3"
                }
            }
        });
    }
    function Article($resource) {
        var resourceUrl = 'service/' + 'api/articles/:path/:id';

        return $resource(resourceUrl, {}, {
            "updateMusic":{
                method:"GET",
                params:{
                    path:"updateMusic"
                }
            },
            "standardCreate":{
                method:"GET",
                params:{
                    path:"standardCreate"
                }
            },
            "getAllByCondition": {
                method: "POST",
                params: {
                    path: "getAllByCondition"
                }
            },
            "byCondition": {
                method: "POST",
                params: {
                    path: "byCondition"
                }
            },
            "updateName": {
                method: "GET",
                params: {
                    path: "updateName"
                },
            },
            'query': {method: 'GET'},
            'get': {
                method: 'GET',
                cancellable: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getByUser': {
                method: 'GET',
                params: {
                    path: 'getByUser'
                }
            },
            'update': {method: 'PUT'},
            'delete': {
                method: 'DELETE'
            },
            'moveFolder': {
                method: "GET",
                params: {
                    path: "moveFolder"
                },
            },
            'batchDelete': {
                method: 'GET',
                params: {
                    path: "batchDelete"
                }
            },
            "getPhonePicToken":{
                method: 'GET',
                params: {
                    path: 'getPhonePicToken'
                },
            },
            'shareCallBack':{
                method: 'GET',
                params: {
                    path: "shareCallBack"
                }
            },
            'getToken': {
                method: 'GET',
                params: {
                    path: 'getToken'
                }
            }
        });
    }
    function Music($resource, DateUtils) {
        var resourceUrl = 'manager/' + 'api/music/:path/:id';

        return $resource(resourceUrl, {}, {
            'getAll': {
                method: 'POST',
                params: {
                    path: 'byCondition'
                }
            },
            'allByCondition': {
                method: 'POST',
                params: {
                    path: 'getAllByCondition'
                }
            },
            'update': {
                method: 'GET',
                params: {
                    path: 'update'
                }
            },
            'save': {
                method: 'POST'
            },
            'get': {
                method: 'GET'
            },
            'del': {
                method: 'DELETE'
            }
        });
    }
    function XmlToImg ($resource) {
        var resourceUrl = 'justify/' + 'api/:path/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                params: {
                    path: 'xmlToImg'
                }
            },
            'documentToImg': {
                method: 'POST',
                params: {
                    path: 'documentToImg'
                }
            }
        });
    }

    function StoreWorkEditConfig($resource) {
        var resourceUrl = 'manager/' + 'api/store-work-edit-configs/:path/:id';

        return $resource(resourceUrl, {}, {
            'getCurrent': {
                method: 'GET',
                params: {
                    path: "current"
                },
            },
            "getAllByCondition": {
                method: "POST",
                params: {
                    path: "getAllByCondition"
                },
                isArray: true
            },
            'update': {
                method: 'PUT',
            },
            'storeId': {
                method: 'GET',
                params: {
                    path: "storeId"
                },
            }
        });
    }
    function CalendarService($resource) {
        var resourceUrl = 'manager/api/calendar-service/:path';
        return $resource(resourceUrl, {}, {
            "getYear":{
                method:"GET",
                params:{
                    path:"getYear"
                },
                isArray:true
            },
            "getYears":{
                method:"GET",
                params:{
                    path:"getYears"
                },
                isArray:true
            },
            "getMonth":{
                method:"GET",
                params:{
                    path:"getMonth"
                }
            },
            'getMonthsOfYear': {
                method: 'GET',
                params:{
                    path:'getMonthsOfYear'
                }
            },
            'getDate': {
                method: 'GET',
                params:{
                    path:'getDate'
                }
            },
            'getDatesOfMonth': {
                method: 'GET',
                params:{
                    path:'getDatesOfMonth'
                }
            },
            'getDatesOfTable': {
                method: 'GET',
                params:{
                    path:'getDatesOfTable'
                }
            },
            'getWeekday': {
                method: 'GET',
                params:{
                    path:'getWeekday'
                }
            },
            'getWeekdays': {
                method: 'GET',
                params:{
                    path:'getWeekdays'
                }
            },
            'queryYearMonthSet': {
                method: "POST",
                params: {
                    path: "queryYearMonthSet"
                }
            },
            'queryWeekdaysSet': {
                method: "POST",
                params: {
                    path: "queryWeekdaysSet"
                }
            },
            'queryMonthdaysSet': {
                method: "POST",
                params: {
                    path: "queryMonthdaysSet"
                }
            },
            'queryMonthTable': {
                method: "POST",
                params: {
                    path: "queryMonthTable"
                }
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('editorApp')
        .controller('Page404Controller', Page404Controller);

    Page404Controller.$inject = ['$scope', '$stateParams'];

    function Page404Controller($scope, $stateParams) {
        var vm = this;
        vm.tips = "抱歉，该链接已失效";
        console.log($stateParams);
        if($stateParams.tips && typeof $stateParams.tips === "string"){
            vm.tips = $stateParams.tips;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('editorApp')
        .controller('ReferenceController', ReferenceController);

    ReferenceController.$inject = ['$scope', '$uibModalInstance', '$state', '$stateParams','MessageService'];

    function ReferenceController($scope, $uibModalInstance, $state, $stateParams, MessageService) {
        var vm = this;
        vm.clear = clear;
        vm.save = save;
        vm.dpiChoose = [{data: 'mm', id: 0}, {data: 'px', id: 1}, {data: '英寸', id: 2}];
        vm.dpi = vm.dpiChoose[0];
        vm.dpi1 = vm.dpiChoose[0];
        vm.direction = 'y';
        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        $scope.updateDpi = function (data) {
            if(vm.dpi.id == 1){
                vm.place = PxTurnMm(vm.place);
            }else if(vm.dpi.id == 2){
                vm.place = InTurnMm(vm.place);
            }
            if (data.id == 1) {
                vm.place = MmTurnPx(vm.place);
            } else if(data.id == 2) {
                vm.place = MmTurnIn(vm.place);
            }
            vm.dpi = data;
        }

        function save() {
            if (!vm.place) {
                MessageService.error("请输入位置");
                return;
            }
            $scope.updateDpi(vm.dpiChoose[1]);
            $uibModalInstance.close({
                direction:vm.direction,
                place:vm.place
            });
        }

    }

})();

(function () {
    'use strict';

    var editorPhotoPreview = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/page/editor-photo-preview.html',
        // controller: 'articlePreviewController',
        controllerAs: 'vm',
        bindings: {
            previewArticle: '=',
            article:'='
        },
        controller: ['$scope', '$stateParams', 'Product', '$http', 'FontManagement', '$timeout',
            function ($scope, $stateParams, Product, $http, FontManagement, $timeout) {
                var vm = this;
                vm.isEdit = true;
                Product.get({id: vm.article.productId}, function (res) {
                    vm.product = res.data;
                    $scope.template = angular.copy(vm.previewArticle);
                    documentAnalysis($scope, $http, vm, $scope.template,FontManagement,'processing', function(page){}, function () {
                        $scope.template.pages.page.forEach(function (page) {
                            if (!page.scene && vm.product.editorType != 'PICTURE_PRO_P') {
                                pageTrimbox(page)
                            }
                        })
                        $timeout(function () {
                            vm.loading = false;
                            var _top = vm.messageList > 0 ? 132 :92;
                            vm.windowH = window.innerHeight - _top;
                            vm.windowW = window.innerWidth - 460;
                            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
                                vm.windowW1 = window.innerWidth/2-50;
                                $(".preview-div").css({'justify-content': 'center'});
                            } else {
                                vm.windowW1 = 200;
                            }

                            vm.placeOrder = true;
                            vm.signalPage = $scope.template.pages.page[0];
                            var windowRatio = 0.8;
                            var custom = $scope.template.pages.page[0].custom;
                            vm.pageWidth = custom.width;
                            vm.pageHeight = custom.height;
                            if(vm.windowH / vm.pageHeight >= vm.windowW / vm.pageWidth ){
                                vm.ratio = vm.windowW / vm.pageWidth * windowRatio;
                            }else {
                                vm.ratio = vm.windowH / vm.pageHeight * windowRatio;
                            }
                            vm.ratio1 = vm.windowW1 / vm.pageWidth;
                            var documentPage = $scope.template.pages.page;
                            vm.data = [];
                            vm.data1 = [];
                            var _data = [];
                            for (var i = 0; i < documentPage.length; i++) {
                                if(!documentPage[i].backup){
                                    if(!vm.product.pictureType || vm.product.pictureType == 'single'){
                                        var isRepetition = false;
                                        var _documentPage1 = documentPage[i];
                                        for(var j=0; j<vm.data.length; j++){
                                            if (_documentPage1.uuid === vm.data[j].uuid) {
                                                isRepetition = true;
                                                vm.data[j].quantity++;
                                                break;
                                            }
                                        }
                                        if(!isRepetition){
                                            _documentPage1.quantity = 1;
                                            vm.data.push(_documentPage1);
                                        }
                                    }
                                    if(vm.product.pictureType == 'spread'){
                                        //双面
                                        var _documentPage2 = documentPage[i];
                                        var isRepetition1 = false;
                                        if (i % 2 === 0){
                                            //偶数

                                            for(var j=0; j<vm.data1.length; j++){
                                                if (_documentPage2.uuid === vm.data1[j][0].uuid) {
                                                    vm.data1[j][0].quantity++;
                                                    isRepetition1 = true;
                                                    break;
                                                }
                                            }
                                            if(!isRepetition1){
                                                _documentPage2.quantity = 1;
                                                _data.push(_documentPage2);
                                            }
                                        } else if (i % 2 === 1){
                                            //奇数
                                            if(_data.length>0){
                                                _data.push(_documentPage2);
                                                vm.data1.push(_data);
                                                _data = [];
                                            }
                                        }
                                    }
                                }
                            };
                            console.log(vm.data1)
                        }, 1000)
                    })
                });
                //边框
                $scope.imageboxW = function (imagebox) {
                    if (!imagebox) {
                        return
                    }
                    if (imagebox.border) {
                        if (imagebox.border.type == 'Color') {
                            return Number(imagebox.geometry.width) + Number(imagebox.border.lineWidth) * 2
                        }
                        if (imagebox.border.type == 'Pic') {
                            return imagebox.geometry.width
                            // return Number(imagebox.geometry.width) + (Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100) + (Number(imagebox.geometry.width) * Number(imagebox.border.edge.right) / 100)
                        }
                    } else {
                        return imagebox.geometry.width
                    }
                }
                $scope.imageboxH = function (imagebox) {
                    if (!imagebox) {
                        return
                    }
                    if (imagebox.border) {
                        if (imagebox.border.type == 'Color') {
                            return Number(imagebox.geometry.height) + Number(imagebox.border.lineWidth) * 2
                        }
                        if (imagebox.border.type == 'Pic') {
                            return imagebox.geometry.height
                            // return Number(imagebox.geometry.height) + (Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100) + (Number(imagebox.geometry.height) * Number(imagebox.border.edge.bottom) / 100)
                        }
                    } else {
                        return imagebox.geometry.height
                    }
                }
                $scope.imageboxL = function (imagebox) {
                    if (!imagebox) {
                        return
                    }
                    if (imagebox.border) {
                        if (imagebox.border.type == 'Color') {
                            return Number(imagebox.geometry.x) - Number(imagebox.border.lineWidth)
                        }
                        if (imagebox.border.type == 'Pic') {
                            return imagebox.geometry.x
                            // return Number(imagebox.geometry.x) - (Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100)
                        }
                    } else {
                        return imagebox.geometry.x
                    }
                }
                $scope.imageboxT = function (imagebox) {
                    if (!imagebox) {
                        return
                    }
                    if (imagebox.border) {
                        if (imagebox.border.type == 'Color') {
                            return Number(imagebox.geometry.y) - Number(imagebox.border.lineWidth)
                        }
                        if (imagebox.border.type == 'Pic') {
                            return imagebox.geometry.y
                            // return Number(imagebox.geometry.y) - (Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100)
                        }
                    } else {
                        return imagebox.geometry.y
                    }
                }
                $scope.imageboxWEdge = function (imagebox, edge) {
                    if (!imagebox) {
                        return
                    }
                    if (imagebox.border) {
                        if (imagebox.border.type == 'Color') {
                            return Number(imagebox.border.lineWidth)
                        }
                        if (imagebox.border.type == 'Pic') {
                            if (edge == 'left') {
                                return Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100
                            }
                            if (edge == 'top') {
                                return Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100
                            }
                            if (edge == 'right') {
                                return Number(imagebox.geometry.width) * Number(imagebox.border.edge.right) / 100
                            }
                            if (edge == 'bottom') {
                                return Number(imagebox.geometry.height) * Number(imagebox.border.edge.bottom) / 100
                            }
                        }
                    } else {
                        return 0
                    }
                }
                $scope.imageboxWRadius = function (imagebox, radius, ratio, ratio1) {
                    if (!imagebox) {
                        return
                    }
                    if (imagebox.border) {
                        var _ratio = 1;
                        if(ratio && ratio1){
                            if(imagebox.geometry.width > imagebox.geometry.height){
                                _ratio = ratio1
                            }else{
                                _ratio = ratio
                            }
                        }
                        if(ratio && !ratio1){
                            _ratio = ratio
                        }
                        if (imagebox.border.shape == 'Ellipse') {
                            return '50%'
                        }
                        if (imagebox.border.radius.filletType == 'Fixed') {//圆角固定值
                            var _radius = imagebox.border.radius[radius];
                            return _radius > 0 ?  (_radius + Number(imagebox.border.lineWidth)/2) * _ratio : 0;
                        }else{
                            var radiusW = imagebox.geometry.width > imagebox.geometry.height ? imagebox.geometry.height : imagebox.geometry.width;
                            radiusW = radiusW + imagebox.border.lineWidth;
                            var _r = radiusW * imagebox.border.radius[radius] / 100;
                            return _r > 0 ? (_r + Number(imagebox.border.lineWidth)/2) * _ratio : 0
                        }
                    } else {
                        return 0
                    }
                }
                $scope.imageboxWRadius1 = function (imagebox, radius, ratio, ratio1) {
                    if (!imagebox) {
                        return
                    }
                    if (imagebox.border) {
                        var _ratio = 1;
                        if(ratio && ratio1){
                            if(imagebox.geometry.width > imagebox.geometry.height){
                                _ratio = ratio1
                            }else{
                                _ratio = ratio
                            }
                        }
                        if(ratio && !ratio1){
                            _ratio = ratio
                        }
                        if (imagebox.border.shape == 'Ellipse') {
                            return '50%'
                        }
                        if (imagebox.border.radius.filletType == 'Fixed') {//圆角固定值
                            var _radius = imagebox.border.radius[radius];
                            return  (_radius - Number(imagebox.border.lineWidth)/2) > 0 ? (_radius - Number(imagebox.border.lineWidth)/2) * _ratio : 0;
                        }else{
                            var radiusW = imagebox.geometry.width > imagebox.geometry.height ? imagebox.geometry.height : imagebox.geometry.width;
                            radiusW = radiusW + imagebox.border.lineWidth;
                            var _r = radiusW * imagebox.border.radius[radius] / 100;
                            return (_r - Number(imagebox.border.lineWidth)/2) > 0 ? (_r - Number(imagebox.border.lineWidth)/2) * _ratio : 0
                        }
                    } else {
                        return 0
                    }
                }
                $scope.dropShadow = function(imagebox,ratio,ratio1){
                    if (imagebox.shadow == null) {
                        return
                    }
                    var width = $scope.imageboxW(imagebox) * ratio;
                    var height =$scope.imageboxH(imagebox) * ratio1;
                    return dropShadow(imagebox,width,height)
                }
            }
        ]
    };

    angular
        .module('editorApp')
        .component('editorPhotoPreview', editorPhotoPreview);
})();

(function () {
    'use strict';

    angular
        .module('editorApp')
        .controller('EditorPhotoBothWebController', EditorPhotoBothWebController);
    EditorPhotoBothWebController.$inject = ['$scope', 'FontManagement', 'UidService', 'MessageService', '$stateParams', '$q',
    'ThemeClassify', 'ProductXml', 'Store', 'PlatformWechatSetting','Qinius','QiniuToken','Folder','$uibModal', 'Gallery', '$localStorage', 'Material', 'ClipArt', 'FontXmlsManger','Backgrounds','Product',
    'ItemValue', 'Convert', '$http', '$timeout', 'FontXmlsFileServes', 'Article', 'entity', '$state', 'SweetAlert', 'Theme',
    'MessageNotification', 'DateUtils','ListService','ImageService', 'CommonService','OrderArticle', 'StoreWorkEditConfig',
     '$translate', '$cookies', 'translationStorageProvider', 'IMAGE_SUPPORTED_MIME','StoreStorages','$websocket'];

    function EditorPhotoBothWebController( $scope, FontManagement, UidService, MessageService, $stateParams, $q,
        ThemeClassify, ProductXml, Store, PlatformWechatSetting, Qinius, QiniuToken, Folder, $uibModal, Gallery, $localStorage, Material, ClipArt, FontXmlsManger,Backgrounds,Product,
      ItemValue, Convert, $http, $timeout, FontXmlsFileServes, Article, entity, $state, SweetAlert, Theme,
      MessageNotification, DateUtils,ListService,ImageService, CommonService, OrderArticle, StoreWorkEditConfig,
      $translate, $cookies, translationStorageProvider, IMAGE_SUPPORTED_MIME,StoreStorages, $websocket) {
        var vm = this;
        vm.page = [0,1];
        vm.editorDialog = false;
        $(".navbar").hide();
        $(".save-page").removeClass('hide1');
        $(".wrap").hide();
        if($stateParams.authorization){
            $localStorage.authenticationToken = $stateParams.authorization;
        };
        vm.uploadFailedList = [];//上传图片失败的列表
        vm.duplicateList = []; //重复图片
        vm.isDuplicateList = false//重复图片弹框
        vm.errorAlertPopup = false;//显示左下角蓝色弹窗
        vm.templateReplace = null;
        vm.isEdit = entity.type == 'edit' ? true : false;
        vm.storeId = $stateParams.storeId;
        vm.pid = $stateParams.pid;
        vm.aid = $stateParams.aid;
        vm.articleId = null;//当orderArticle 时有值；
        vm.vid = $stateParams.vid;
        vm.xmlId = $stateParams.xmlId;
        vm.supportedMimeTypes = IMAGE_SUPPORTED_MIME;
        if ($localStorage.user != null) {
            vm.userId = $localStorage.user.id
        }
        var arr = localStorage.getItem('save-article');
        if (arr && vm.pid) {
            $state.go("editorAllEdit", {storeId: vm.storeId, aid: arr},{location: 'replace'});
        }
        localStorage.removeItem('save-article');
        $scope.domains = Qinius.getDomain();
        var unsubQiniuToken = QiniuToken.subscribe('get', {}, function (token) {
            vm.token = token;
        });
        $scope.$on('$destroy', unsubQiniuToken);
        vm.platformSetting = PlatformWechatSetting.get();
        vm.store = Store.get({id: vm.storeId});
        try {
            var gallaryPicCache = JSON.parse(localStorage.getItem("photoSelectAll"));
            $scope.gallaryPic = Array.isArray(gallaryPicCache) ? gallaryPicCache : [];
        } catch (e) {
            $scope.gallaryPic = [];
        }
        // 缓存中的已选照片 id，列表分页加载时据此回填 select（回填后仍会被 syncGallerySelection 过滤掉异常照片）。
        // 用户一旦手动改动过选择（choosePhoto / whetherChoose），就清空它，避免后续分页加载时又把旧的缓存选中态塞回来。
        var cachedSelectIds = [];
        ($scope.gallaryPic || []).forEach(function (p) {
            if (p && p.id != null) {
                cachedSelectIds.push(p.id);
            }
        });
        vm.pageIndex = 0;
        vm.data = [];


        //测试时使用
        // $localStorage.lagnuages = ['zh-cn', 'en'];
        $scope.showLagnuages = function(){
            vm.showLagnuages = !vm.showLagnuages;
            if (vm.showLagnuages) {
                $(".lang-icn").css({'transform': 'rotate(270deg)'});
            }else{
                $(".lang-icn").css({'transform': 'rotate(90deg)'});
            }
        }

        lagnuageInit();
        function lagnuageInit() {
            vm.lang = $cookies.getObject("NG_TRANSLATE_LANG_KEY");
            vm.lagnuages =[];
            if ($localStorage.lagnuages) {
                for(var i = 0 ; i<$localStorage.lagnuages.length; i++ ){
                    var lang = $localStorage.lagnuages[i];
                    var result = translationStorageProvider.getLanguageType(lang);
                    if (!!result) {
                        if (vm.lang == result.value) {
                            vm.langKey = result.key;
                            result.selected = true;
                        }
                        vm.lagnuages.push(result);
                    }
                }
            }
        }

        function getProductXmlLine(callback){
            ItemValue.get({id: vm.article.itemValueId}, function (res) {
                angular.forEach(res.data.productXmlLines, function (line) {
                    if (line.productXmlId == vm.article.productXmlId) {
                        vm.productXmlLine = angular.copy(line);
                    }
                });
                if(callback){callback()}
            })
            Product.get({id: vm.article.productId, cancelled: false}, function (res) {
                vm.product = res.data;
                vm.pictureType = res.data.pictureType;
                vm.productTitle = res.data.name;
            })
        }
        $scope.changeLagnuage = function(lang){
            $timeout(function () {
                if (lang == null || lang.key == vm.langKey ) {
                    return;
                }
                angular.forEach(vm.lagnuages, function(item){
                    item.selected =false;
                });
                lang.selected = true;
                vm.langKey = lang.key;
                $translate.use(lang.value);
                vm.showLagnuages =false;
                $timeout(function () {
                    lagnuageInit();
                    getProductXmlLine();
                },100)
            })
        }



        /***************页面处理************start*****************/
        $q.all([$scope.domains.$promise, vm.store.$promise, vm.platformSetting.$promise]).then(function () {
            // token过期 — QiniuToken 单例自动刷新
            vm.platformSetting = vm.platformSetting.data;
            vm.store = vm.store.data;
            $(".navbar").hide();
            $(".save-page").removeClass('hide1');
            $(".wrap").hide();
            $scope.domain = 'https://' + $scope.domains.domains[0] + '/';
            vm.logo = vm.store.menuLogo ? $scope.domain + vm.store.menuLogo : 'content/images/momentsgo.png';
            js_getDPI()

            //消息列表
            vm.messageList = "";
            MessageNotification.getAllByCondition({
                items:[
                    {key:"pageType", op : "=", value:"Edit"},
                    {key:"storeId", op : "=", value:vm.storeId},
                    {key:"available", op : "=", value:"true"},
                    {key:"validate", op : ">=", value: DateUtils.convertLocalDateToServer(new Date())}]
                }, function (res) {
                    if(res.status == 200){
                        res.data.forEach(function (item, index) {
                            vm.messageList += (index+1) + ":" + item.content + "\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0";
                        })
                    }
                }
            )
            //获取数据
            init()
        });
        vm.navSelect = function(item){
            vm.nav = item;
        }
        vm.templateView = false;
        $scope.productXmlLineClick = function(item){
            if (item.productXmlId === vm.article.productXmlId) {
                MessageService.error($translate.instant("editorMessage.canNotBeReplacedTemplate"));
                return
            }
            vm.temporaryTemplate = item;
            vm.isTemplate = true;
            vm.templateReplace= true;
        };
        $scope.templateReplace = function(data){
            var singleData = angular.copy(vm.data);
            vm.loading = true;
            vm.isTemplate = false;
            vm.templateReplace = null;
            vm.article.productXmlId = vm.temporaryTemplate.productXmlId;
            getXmlToDucoment(vm.temporaryTemplate,function () {
                // $scope.photos = [];
                vm.data = [];
                var _photo = [];
                var _photo1 = [];
                if (vm.pictureType == 'single') {
                    singleData.forEach(function (data) {
                        data.levels.level.forEach(function (level) {
                            if(level.imagebox && level.imagebox.image && level.imagebox.image.resource && level.imagebox.image.resource.identifier){
                                var photo = {
                                    identifier:level.imagebox.image.resource.identifier,
                                    width:level.imagebox.image.imgWidth,
                                    height:level.imagebox.image.imgHeight,
                                    imgSize:level.imagebox.image.size,
                                    imageInfo:level.imagebox.image.imageInfo,
                                    quantity:data.quantity,
                                    uuid:data.uuid,
                                    resourceid:level.imagebox.image.resourceid,
                                    id:level.imagebox.image.resourceid,
                                    sourceId:level.imagebox.image.resourceid
                                }
                                _photo.push(photo)
                            }
                        })
                    })
                }
                if (vm.pictureType == 'spread') {
                    singleData.forEach(function (singleData1) {
                        singleData1.forEach(function (data,dataIndex) {
                            data.levels.level.forEach(function (level) {
                                if(level.imagebox && level.imagebox.image && level.imagebox.image.resource && level.imagebox.image.resource.identifier){
                                    var photo = {
                                        identifier:level.imagebox.image.resource.identifier,
                                        width:level.imagebox.image.imgWidth,
                                        height:level.imagebox.image.imgHeight,
                                        imgSize:level.imagebox.image.size,
                                        imageInfo:level.imagebox.image.imageInfo,
                                        quantity:data.quantity,
                                        uuid:data.uuid,
                                        resourceid:level.imagebox.image.resourceid,
                                        id:level.imagebox.image.resourceid,
                                        sourceId:level.imagebox.image.resourceid
                                    }
                                    _photo.push(photo)
                                }
                            })
                        })
                    })
                }
                abook(_photo,function () {
                    $timeout(function () {
                        vm.loading = false;
                        vm.page1 = true;
                        vm.page3 = false;
                        vm.levelIndex = null;
                    }, 1000)
                })
            });
        }

        /***********************  编辑区域  ****************************/
        vm.finalArray = [];
        vm.currentNavtab = 0;
        vm.productXmlLines = [];
        vm.itemValue = null;
        function init(){
            vm.loading = true;
            if(!vm.isEdit){
                Article.getByUser({id: $stateParams.aid}, function (article) {
                    if(article.status == 200) {
                        vm.article = article.data;
                        //获取照片文件夹
                        loadFolders();
                        websocket();
                        if(vm.article.invalid){//作品失效
                            $state.go('articlesFailure',{storeId:vm.storeId},{location: 'replace'});
                            return
                        }
                        CommonService.setDocumentTitle((vm.article.name || vm.article.productXmlName)+'-'+$translate.instant("title"));
                        ItemValue.get({id: vm.vid}, function (res) {
                            vm.itemValue = res.data;
                            $scope.status = localStorage.getItem('Production');
                            vm.productXmlLines = res.data.productXmlLines;
                            vm.productTitle = res.data.productName;
                            getPropertyValue()
                            angular.forEach(res.data.productXmlLines,function (line) {
                                if(line.id==vm.xmlId){
                                    vm.productXmlLine = angular.copy(line);
                                }
                            })
                            if(!vm.productXmlLine){
                                angular.forEach(res.data.productXmlLines,function (line) {
                                    if(!line.cancelled){
                                        vm.productXmlLine = angular.copy(line);
                                    }
                                })
                            }
                            vm.article.cover = vm.productXmlLine.coverImg;
                            vm.article.themeClassifyId = vm.productXmlLine.productXmlThemeId;
                            vm.article.themeClassifyName = vm.productXmlLine.productXmlThemeName;
                            vm.article.productXmlId = vm.productXmlLine.productXmlId;
                            vm.article.productXmlName = vm.productXmlLine.productXmlName;
                            vm.article.musicIdentify = vm.productXmlLine.musicIdentify;
                            vm.article.itemValueId = res.data.id || vm.vid;
                            getProduct(function () {
                                getXmlToDucoment(vm.productXmlLine);
                            })
                        });
                    }
                },function (error) {
                    if(error.status === 403){//token失效
                        return $state.go('404',{storeId:vm.storeId},{location: 'replace'});
                    }
                    if(error.data.status === 404){//未找到作品
                        $state.go('404',{storeId:vm.storeId,tips:error.data.message},{location: 'replace'});
                    }
                    if(error.data.status === 410){//作品编辑器失效
                        $state.go('404',{storeId:vm.storeId,tips:'编辑器失效'},{location: 'replace'});
                    }
                })
            }else{
                if($stateParams.aid){
                    Article.getByUser({id: $stateParams.aid}, function (res) {
                        vm.article = res.data;
                        //获取照片文件夹
                        loadFolders();
                        websocket();
                        if(vm.article.invalid){//作品失效
                            $state.go('articlesFailure',{storeId:vm.storeId},{location: 'replace'});
                            return
                        }
                        CommonService.setDocumentTitle((vm.article.name || vm.article.productXmlName)+'-'+$translate.instant("title"));
                        ItemValue.get({id: res.data.itemValueId}, function (resp) {
                            vm.itemValue = resp.data;
                            vm.article.skuNumber = resp.data.skuNumber;
                            vm.productTitle = resp.data.productName;
                            vm.article.productBokeh = resp.data.productBokeh;
                            vm.article.productBokehType = resp.data.productBokehType;
                            vm.article.bokehtype = 'None';
                            vm.productXmlLines = resp.data.productXmlLines;
                            getPropertyValue()
                            angular.forEach(vm.productXmlLines, function (line) {
                                if (line.productXmlId == vm.article.productXmlId) {
                                    vm.productXmlLine = angular.copy(line);
                                }
                            });
                            getProduct(function () {
                                Convert.xmlToDocument2({
                                    identifier: res.data.fileName,
                                    provider: "qiniu",
                                    editorType:vm.article.editorType,
                                    pictureType:vm.pictureType,
                                    // patternType:vm.product.patternType,
                                }, function (resp1) {
                                    if(!resp1.pages.page || resp1.pages.page.length == 0){
                                        swal({
                                            title: $translate.instant("editorCommon.hint"),
                                            text: $translate.instant("editorMessage.templateFailure"),
                                            imageUrl: Theme.sweetHintImg(),
                                            timer: 3000,
                                            showConfirmButton: false
                                        });
                                        vm.placeOrder = false;
                                        return
                                    }
                                    editDocument(resp1)
                                }, function (error) {
                                    if(error.data.status === 403){//未授权
                                        $state.go('404',{storeId:vm.storeId},{location: 'replace'});
                                    }
                                    MessageService.error(error.data.message || $translate.instant("editorMessage.templateFailure"));
                                });
                            })
                        });
                    },function (error) {
                        if(error.status === 403){//token失效
                            return $state.go('404',{storeId:vm.storeId},{location: 'replace'});
                        }
                        if(error.data.status === 404){//未找到作品
                            $state.go('404',{storeId:vm.storeId,tips:error.data.message},{location: 'replace'});
                        }
                        if(error.data.status === 410){//作品编辑器失效
                            $state.go('404',{storeId:vm.storeId,tips:'编辑器失效'},{location: 'replace'});
                        }
                    })
                }else if($stateParams.orderArticleId){
                    OrderArticle.getByUser({id: $stateParams.orderArticleId}, function (res) {
                        vm.article = res.data;
                        websocket();
                        if(vm.article.invalid){//作品失效
                            $state.go('articlesFailure',{storeId:vm.storeId},{location: 'replace'});
                            return
                        }
                        CommonService.setDocumentTitle((vm.article.name || vm.article.productXmlName)+'-'+$translate.instant("title"));
                        vm.articleId = res.data.articleId;
                        //获取照片文件夹
                        loadFolders();
                        ItemValue.get({id: res.data.itemValueId}, function (resp) {
                            vm.itemValue = resp.data;
                            vm.article.skuNumber = resp.data.skuNumber;
                            vm.productTitle = resp.data.productName;
                            vm.article.productBokeh = resp.data.productBokeh;
                            vm.article.productBokehType = resp.data.productBokehType;
                            vm.article.bokehtype = 'None';
                            vm.productXmlLines = resp.data.productXmlLines;
                            getPropertyValue()
                            angular.forEach(vm.productXmlLines, function (line) {
                                if (line.productXmlId == vm.article.productXmlId) {
                                    vm.productXmlLine = angular.copy(line);
                                }
                            });
                            getProduct(function () {
                                Convert.xmlToDocument2({
                                    identifier: res.data.fileName,
                                    provider: "qiniu",
                                    editorType:vm.article.editorType,
                                    pictureType:vm.pictureType,
                                    // patternType:vm.product.patternType,
                                }, function (resp1) {
                                    if(!resp1.pages.page || resp1.pages.page.length == 0){
                                        swal({
                                            title: $translate.instant("editorCommon.hint"),
                                            text: $translate.instant("editorMessage.templateFailure"),
                                            imageUrl: Theme.sweetHintImg(),
                                            timer: 3000,
                                            showConfirmButton: false
                                        });
                                        vm.placeOrder = false;
                                        return
                                    }
                                    editDocument(resp1)
                                }, function (error) {
                                    if(error.data.status === 403){//未授权
                                        $state.go('404',{storeId:vm.storeId},{location: 'replace'});
                                    }
                                    MessageService.error(error.data.message || $translate.instant("editorMessage.templateFailure"));
                                });
                            })
                        });
                    },function (error) {
                        if(error.status === 403){//token失效
                            return $state.go('404',{storeId:vm.storeId},{location: 'replace'});
                        }
                        if(error.data.status === 404){//未找到作品
                            $state.go('404',{storeId:vm.storeId,tips:error.data.message},{location: 'replace'});
                        }
                        if(error.data.status === 410){//作品编辑器失效
                            $state.go('404',{storeId:vm.storeId,tips:'编辑器失效'},{location: 'replace'});
                        }
                    })
                }
            }
        }
        function getPropertyValue(){
            vm.propertyValue = {
                white:[],
                hotStamp:[],
                uv:[],
                fluore:[],
                outline:[]
            };
            if(vm.article.editorType == 'PICTURE_PRO_P' && vm.itemValue && vm.itemValue.objectValues){
                var skuNumber = vm.itemValue.skuNumber.split('-');
                vm.itemValue.objectValues.forEach(function (object) {
                    object.propertyValues.forEach(function (propertyValue) {
                        var _skuNumber = propertyValue.propertyId + '_' + propertyValue.id;
                        if(skuNumber.indexOf(_skuNumber) > -1){
                            var processOperation = {
                                id:object.processOperationId,
                                name:object.processOperationName,
                                type:object.processOperationType,
                                epitaxy:null,
                                epitaxyValue:object.processOperationEpitaxyValue,
                                spotColor:propertyValue.spotColor,
                                operationValueAlias:propertyValue.operationValueAlias,
                                color:propertyValue.color,
                                value:propertyValue.value,
                                unit:'mm',
                                uuid:_skuNumber
                            }
                            switch (object.processOperationEpitaxy) {
                            case 'EXTENSION':
                                processOperation.epitaxy = 'expand';
                                break;
                            case 'SHRINKAGE':
                                processOperation.epitaxy = 'shrink';
                                break;
                            default:
                                processOperation.epitaxy = null;
                            }
                            if(object.processOperationUnit == 'px'){
                                processOperation.epitaxyValue = PxTurnMm(processOperation.epitaxyValue);
                            }
                            if(object.processOperationType == 'WHITE_INK'){
                                vm.propertyValue.white.push(processOperation);
                            }
                            if(object.processOperationType == 'HOT_STAMP'){
                                vm.propertyValue.hotStamp.push(processOperation);
                            }
                            if(object.processOperationType == 'UV'){
                                vm.propertyValue.uv.push(processOperation);
                            }
                            if(object.processOperationType == 'FLUORESCENT'){
                                vm.propertyValue.fluore.push(processOperation);
                            }
                            if(object.processOperationType == 'DIE_LINE'){
                                vm.propertyValue.outline.push(processOperation);
                            }
                        }
                    })
                })
            }
            console.log(vm.propertyValue)
        }
        function getProduct(callback) {
            Product.get({id: vm.itemValue.productId}, function (res) {
                vm.product = res.data;
                vm.pictureType = res.data.pictureType;
                if(callback){callback()}
            })
        }

        function editDocument(resp1) {
            $scope.template = angular.copy(resp1);
            vm.photoSelectAll = $scope.gallaryPic;
            // 复制模板备份页面列表，避免直接修改原始数据
            var backupPagesList = angular.copy($scope.template.backupPages.list);
            // 过滤备份页面列表，只保留 uuid 等于模板页面的 uuid1 或 uuid2，并且 uuid 不为 null 的页面
            backupPagesList = backupPagesList.filter(function(backupPage){
                return (backupPage.uuid == $scope.template.pages.uuid1 || backupPage.uuid == $scope.template.pages.uuid2) && backupPage.uuid != null
            })
            var mergedArray = $scope.template.pages.page.concat(backupPagesList);
            $scope.template.pages.page = mergedArray;
            documentAnalysis($scope, $http, vm, $scope.template,FontManagement,'processing', function(page){}, function () {
                $timeout(function () {
                    var num = $scope.template.pages.page.length - backupPagesList.length;
                    $scope.template.pages.page.splice(num);
                    vm.windowH = 668;
                    vm.windowW = 1132;
                    vm.windowW1 = 232;
                    vm.placeOrder = true;
                    vm.signalPage1 = $scope.template.pages.uuid1 ? getPage1($scope.template.pages.uuid1,$scope.template.pages.page,backupPagesList,0) : getPage('P0',$scope.template.pages.page);
                    vm.signalPage2 = $scope.template.pages.uuid2 ? getPage1($scope.template.pages.uuid2,$scope.template.pages.page,backupPagesList,1) : getPage('P1',$scope.template.pages.page);
                    imageboxQuantity();
                    var windowRatio = 0.95;
                    var custom = $scope.template.pages.page[0].custom;
                    vm.pageWidth = custom.width;
                    vm.pageHeight = custom.height;
                    if(vm.windowH / vm.pageHeight >= vm.windowW / vm.pageWidth ){
                        vm.ratio = vm.windowW / vm.pageWidth * windowRatio;
                    }else {
                        vm.ratio = vm.windowH / vm.pageHeight * windowRatio;
                    }
                    vm.ratio1 = vm.windowW1 / vm.pageWidth;
                    var documentPage = $scope.template.pages.page;
                    vm.data = [];
                    if(vm.pictureType == 'single'){
                        for (var i = 0; i < documentPage.length; i++) {
                            if(!documentPage[i].backup){
                                var isRepetition = false;
                                for(var j=0; j<vm.data.length; j++){
                                    if (documentPage[i].uuid === vm.data[j].uuid) {
                                        isRepetition = true;
                                        vm.data[j].quantity++
                                        break;
                                    }
                                }
                                if(!isRepetition){
                                    documentPage[i].quantity = 1;
                                    vm.data.push(documentPage[i])
                                }
                            }
                        };
                    }
                    if(vm.pictureType == 'spread'){
                        var _data = [];
                        for (var i = 0; i < documentPage.length; i++) {
                            if(!documentPage[i].backup){
                                var _documentPage2 = documentPage[i];
                                var isRepetition1 = false;
                                if (i % 2 === 0){
                                    //偶数
                                    for(var j=0; j<vm.data.length; j++){
                                        if (_documentPage2.uuid === vm.data[j][0].uuid) {
                                            vm.data[j][0].quantity++;
                                            isRepetition1 = true;
                                            break;
                                        }
                                    }
                                    if(!isRepetition1){
                                        _documentPage2.quantity = 1;
                                        _data.push(_documentPage2);
                                    }
                                } else if (i % 2 === 1){
                                    //奇数
                                    if(_data.length>0){
                                        _data.push(_documentPage2);
                                        vm.data.push(_data);
                                        _data = [];
                                    }
                                }
                            }
                        };
                    }
                    vm.pageSum = vm.data.length - 1;
                    loadAll('isNull');
                    reserveInit($scope.template.pages.page);
                    vm.loading = false;
                    $scope.$apply();
                },1000)
            })
        }

        //获取模版信息
        function getXmlToDucoment(productXml,callback){
            Convert.xmlToDocument2({
                identifier: productXml.productXmlIdentifier,
                provider: "qiniu",
                editorType:vm.article.editorType,
                pictureType:vm.pictureType,
                // patternType:vm.product.patternType,
            }, function (res) {
                $scope.template = angular.copy(res);
                vm.photoSelectAll = $scope.gallaryPic;
                var backupPagesList = angular.copy($scope.template.backupPages.list);
                backupPagesList = backupPagesList.filter(function (backupPage) {
                    return (backupPage.uuid == $scope.template.pages.uuid1 || backupPage.uuid == $scope.template.pages.uuid2) && backupPage.uuid != null;
                });
                $scope.template.pages.page = $scope.template.pages.page.concat(backupPagesList);
                documentAnalysis($scope, $http, vm, $scope.template,FontManagement,'processing', function(page){}, function () {
                    $timeout(function () {
                        var pageCount = $scope.template.pages.page.length - backupPagesList.length;
                        $scope.template.pages.page.splice(pageCount);
                        vm.windowH = 668;
                        vm.windowW = 1132;
                        vm.windowW1 = 232;
                        vm.placeOrder = true;
                        $scope.template.pages.page.forEach(function (page) {
                            page.backup = true;
                        })
                        vm.signalPage1 = $scope.template.pages.uuid1 ? getPage1($scope.template.pages.uuid1,$scope.template.pages.page,backupPagesList,0) : getPage('P0',$scope.template.pages.page);
                        vm.signalPage2 = $scope.template.pages.uuid2 ? getPage1($scope.template.pages.uuid2,$scope.template.pages.page,backupPagesList,1) : getPage('P1',$scope.template.pages.page);
                        if(vm.article.editorType == 'PICTURE_PRO_P'){
                            vm.signalPage1.notTrimbox = true;
                            vm.signalPage2.notTrimbox = true;
                            if(vm.signalPage2.outline && vm.signalPage2.outline.mirrorCutline){
                                vm.signalPage2.outline.cutline = angular.copy(vm.signalPage1.outline.mirrorCutline);
                            }
                            if(vm.propertyValue && vm.propertyValue.outline && vm.propertyValue.outline.length>0){
                                if(vm.signalPage1.outline && vm.signalPage1.outline.cutline){
                                    if(!vm.signalPage1.outline.cutline.color){
                                        vm.signalPage1.outline.cutline.color = vm.propertyValue.outline[0].spotColor;
                                        vm.signalPage1.outline.cutline.colorValue = vm.propertyValue.outline[0].color;
                                    }
                                }
                                if(vm.signalPage2.outline && vm.signalPage2.outline.cutline){
                                    if(!vm.signalPage2.outline.cutline.color){
                                        vm.signalPage2.outline.cutline.color = vm.propertyValue.outline[0].spotColor;
                                        vm.signalPage2.outline.cutline.colorValue = vm.propertyValue.outline[0].color;
                                    }
                                }
                            }
                        }
                        imageboxQuantity();
                        var windowRatio = 0.95;
                        var custom = $scope.template.pages.page[0].custom;
                        vm.pageWidth = custom.width;
                        vm.pageHeight = custom.height;
                        if(vm.windowH / vm.pageHeight >= vm.windowW / vm.pageWidth ){
                            vm.ratio = vm.windowW / vm.pageWidth * windowRatio;
                        }else {
                            vm.ratio = vm.windowH / vm.pageHeight * windowRatio;
                        }
                        vm.ratio1 = vm.windowW1 / vm.pageWidth;
                        vm.loading = false;
                        if (!callback) {
                            loadAll('isNull');
                        }
                        reserveInit($scope.template.pages.page);
                        if(callback){callback()}
                    }, 1000)
                })
            }, function (error) {
                if(error.data.status === 403){//未授权
                    $state.go('404',{storeId:vm.storeId},{location: 'replace'});
                }
                MessageService.error(error.data.message || $translate.instant("editorMessage.templateFailure"));
            });
        }
        function imageboxQuantity(){
            if(vm.signalPage1){
                vm.signalPage1.imageboxQuantity = 0;
                vm.signalPage1.backup = false;
                if(vm.signalPage1.levels && vm.signalPage1.levels.level){
                    vm.signalPage1.levels.level.forEach(function (level) {
                        if (level.imagebox) {
                            level.imagebox.image = null;
                            vm.signalPage1.imageboxQuantity++;
                        }
                    })
                }
            }
            if(vm.signalPage2){
                vm.signalPage2.imageboxQuantity = 0;
                vm.signalPage2.backup = false;
                if(vm.signalPage2.levels && vm.signalPage2.levels.level){
                    vm.signalPage2.levels.level.forEach(function (level) {
                        if (level.imagebox) {
                            level.imagebox.image = null;
                            vm.signalPage2.imageboxQuantity++;
                        }
                    })
                }
            }
        }

        function abook(gallaryPic,callback,sideUnification) {
            var images = gallaryPic;
            var _pageCount = 0;
            if(vm.pictureType == 'single'){
                if(vm.signalPage1.imageboxQuantity){
                    _pageCount = Math.ceil(images.length / vm.signalPage1.imageboxQuantity);
                }
                var data = [];
                for(var i = 0; i < _pageCount; i++){
                    var _page = JSON.parse(JSON.stringify(vm.signalPage1));
                    _page.quantity = 1;
                    _page.uuid = uuid();
                    data.push(_page)
                }
                pageImagebox(data,images,sideUnification)
            }else{
                if(vm.signalPage1.imageboxQuantity || vm.signalPage2.imageboxQuantity){
                    _pageCount = Math.ceil(images.length / (vm.signalPage1.imageboxQuantity + vm.signalPage2.imageboxQuantity));
                }
                if(sideUnification && vm.signalPage1.imageboxQuantity){
                    _pageCount = Math.ceil(images.length / vm.signalPage1.imageboxQuantity);
                }
                var data = [];
                for(var i = 0; i < _pageCount; i++){
                    var _page1 = JSON.parse(JSON.stringify(vm.signalPage1));
                    var _page2 = JSON.parse(JSON.stringify(vm.signalPage2));
                    _page1.quantity = 1;
                    _page1.uuid = uuid();
                    _page2.quantity = 1;
                    _page2.uuid = uuid();
                    data.push([_page1,_page2])
                }
                pageImagebox(data,images,sideUnification)
            }
            gallaryPic = [];
            $scope.photos.forEach(function (photo) {
                photo.select = false;
            })
            if(vm.data.length>0){
                vm.pageSum = vm.data.length - 1;
            }
            photosNum();
            $scope.whetherChoose(false);
            if(callback){callback()}
        }
        function pageImagebox(data,images,sideUnification){
            if(vm.pictureType == 'single'){
                for (var i2 = 0; i2 < data.length; i2++) {
                    if (data[i2].levels.level) {
                        for (var j = 0; j < data[i2].levels.level.length; j++) {
                            var _level = data[i2].levels.level[j];
                            if (images.length>0 && _level.imagebox) {
                                if ( !_level.imagebox.image || !_level.imagebox.image.resource || !_level.imagebox.image.resource.identifier) {
                                    vm.replacePageIndex2 = i2;
                                    vm.replaceTextIndex = j;
                                    replaceImagebox(images[0], data)
                                    images.shift();
                                }
                            }
                        }
                    }
                    vm.data.push(data[i2]);
                }
            }else{
                for (var i3 = 0; i3 < data.length; i3++) {
                    for(var i1 = 0; i1<data[i3].length; i1++){
                        if(sideUnification && i1 ==0 || !sideUnification){
                            var page2 = data[i3][i1];
                            if (page2.levels.level) {
                                for (var j = 0; j < page2.levels.level.length; j++) {
                                    var _level = page2.levels.level[j];
                                    if (images.length>0 && _level.imagebox) {
                                        if ( !_level.imagebox.image || !_level.imagebox.image.resource || !_level.imagebox.image.resource.identifier) {
                                            vm.replacePageArrIndex = i3;
                                            vm.replacePageIndex = i1;
                                            vm.replaceTextIndex = j;
                                            replaceImagebox(images[0], data)
                                            images.shift();
                                        }
                                    }
                                }
                            }
                        }
                    }
                    vm.data.push(data[i3]);
                }
            }
            return images;
        }
        function reserveInit(page) {
            var _page = angular.copy(page);
            vm.reservePage = [];
            _page.forEach(function (item) {
                if(item.backup){
                    vm.reservePage.push(item);
                }
            });
        }
        function uuid() {
            var s = [];
            var hexDigits = "0123456789abcdef";
            for (var i = 0; i < 36; i++) {
                s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
            }
            s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
            s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
            s[8] = s[13] = s[18] = s[23] = "-";

            var uuid = s.join("");
            return uuid;
        };
        function getBlurredrectangle(imagebox, index) {
            var item = imagebox;
            if(!item.image){
                return
            }
            addImagebox($http, imagebox, function () {
                var newImg = angular.copy({
                    width: imagebox.image.width,
                    height: imagebox.image.height
                })
                if ((imagebox.geometry.width - imagebox.geometry.height) * (newImg.width - newImg.height) < 0) {
                    if (index % 2 === 0){
                        if(imagebox.flip){
                            imagebox.image.angle = imagebox.image.angle+90;
                        }else{
                            imagebox.image.angle = imagebox.image.angle-90;
                        }
                        imagebox.image.width = newImg.height;
                        imagebox.image.height = newImg.width;
                    }
                    if (index % 2 === 1){
                        if(imagebox.flip){
                            imagebox.image.angle = imagebox.image.angle-90;
                        }else{
                            imagebox.image.angle = imagebox.image.angle+90;
                        }
                        imagebox.image.width = newImg.height;
                        imagebox.image.height = newImg.width;
                    }
                } else {
                    imagebox.image.angle = imagebox.image.angle;
                }
                if(vm.product.bokehType != 'None'){
                    imagebox.bokehtype = 'Transparent';
                    imagebox.image.scale = 1;
                    if(imagebox.blurredrectangle){
                        imagebox.blurredrectangle.x = 0;
                        imagebox.blurredrectangle.y = 0;
                    }
                }
                getBackgroundSource3(imagebox, imagebox.geometry.width, imagebox.geometry.height, imagebox.image, imagebox.bokehtype, $scope);
            },true);
        }

        $scope.fillImagebox = function () {
            var item = vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox;
            item.image.scale = 1;
            if(item.blurredrectangle){
                item.blurredrectangle.x = 0;
                item.blurredrectangle.y = 0;
            }
            item.bokehtype = 'Transparent';
            vm.imageboxLoad = true;
            getBackgroundSource3(item, item.geometry.width, item.geometry.height, item.image, item.bokehtype, $scope, function () {
                vm.imageboxLoad = false;
                // $scope.$apply();
            });
        }
        $scope.cutImagebox = function () {
            var item = vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox;
            item.image.scale = 1;
            if(item.blurredrectangle){
                item.blurredrectangle.x = 0;
                item.blurredrectangle.y = 0;
            }
            item.bokehtype = 'None';
            vm.imageboxLoad = true;
            getBackgroundSource3(item, item.geometry.width, item.geometry.height, item.image, item.bokehtype, $scope, function () {
                vm.imageboxLoad = false;
                // $scope.$apply();
            });
        }
        $scope.rotateImagebox = function () {
            imageboxRotate($scope, vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox);
        }
        $scope.previousPage = function () {
            vm.pageLoading = true;
            if(vm.pictureType == 'spread'){
                if(!$scope.zfInit()){
                    vm.pageIndex -= 2;
                }else{
                    vm.pageIndex--
                }
            }else{
                vm.pageIndex--;
            }
            if(vm.pageIndex<0){
                vm.pageIndex = 0;
            }
            vm.levelIndex = 0;
            $timeout(function () {
                vm.pageLoading = false;
            },100)
        }
        $scope.nextPage = function () {
            vm.pageLoading = true;
            if(vm.pictureType == 'spread'){
                if(!$scope.zfInit()){
                    vm.pageIndex += 2;
                }else{
                    vm.pageIndex++;
                }
            }else{
                vm.pageIndex++;
            }

            if(vm.pageIndex>vm.editorPageList.length-1){
                vm.pageIndex = vm.editorPageList.length-1;
            }
            vm.levelIndex = 0;
            $timeout(function () {
                vm.pageLoading = false;
            },100)
        }
        $scope.turning = function (index) {
            vm.pageLoading = true;
            vm.pageIndex = index;
            vm.levelIndex = null;
            $timeout(function () {
                vm.pageLoading = false;
            },100)
        }
        $scope.editorDialogHide = function () {
            vm.editorDialog=false;
            $timeout(function () {
                var element = document.getElementById('page'+vm.pageIndex);
                element.scrollIntoView();
            })
        }
        $scope.singleIndexClick = function (item) {
            vm.levelIndex = null;
            if($scope.zfInit() != item){
                if(item){
                    vm.pageIndex++
                }else{
                    vm.pageIndex--
                }
            }
        }
        function js_getDPI() {
            var arrDPI = new Array();
            if (window.screen.deviceXDPI != undefined) {
                arrDPI[0] = window.screen.deviceXDPI;
                arrDPI[1] = window.screen.deviceYDPI;
            }
            else {
                var tmpNode = document.createElement("DIV");
                tmpNode.style.cssText = "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
                document.body.appendChild(tmpNode);
                arrDPI[0] = parseInt(tmpNode.offsetWidth);
                arrDPI[1] = parseInt(tmpNode.offsetHeight);
                tmpNode.parentNode.removeChild(tmpNode);
            }
            vm.windowDpi = arrDPI[1];
            // vm.windowDpi = 300;
            return arrDPI;
        }

        /*******************************************  照片框处理  *************************************************************************/
        var isImagebox = false;
        vm.isImageboxTrim = false;
        var stickerDragBox = {};
        $scope.moveImageboxStart = function (index, $event) {
            vm.levelIndex = index;
            fn($event);
            var sticker = vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox;
            if(sticker.bokehtype != 'None' || !sticker.image){
                return
            }
            var x = $event.clientX;
            var y = $event.clientY;
            var proW = vm.ratio*sticker.image.scale;
            var proH = vm.ratio*sticker.image.scale;

            var l = sticker.image.offsetx * proW * sticker.image.scale;
            var t = sticker.image.offsety * proH * sticker.image.scale;
            var r = -(sticker.image.width * sticker.image.scale - sticker.geometry.width) * proW;
            var b = - (sticker.image.height * sticker.image.scale - sticker.geometry.height) * proH;
            var angle = Number(sticker.rotation.angle);
            //开关打开
            isImagebox = true;
            vm.isImageboxTrim = true;
            //鼠标移动
            window.onmousemove = function (e) {
                if (isImagebox == false) {
                    return;
                }
                fn(e);
                var cx = (l + r) / 2;
                var cy = (t + b) / 2;
                var pt0 = rotatePoint({x: x, y: y}, {x: cx, y: cy}, -angle);
                var pt1 = rotatePoint({x: e.clientX, y: e.clientY}, {x: cx, y: cy}, -angle);
                var deltaX = pt1.x - pt0.x;
                var deltaY = pt1.y - pt0.y;
                var nl = l + deltaX;
                var nt = t + deltaY;
                if (nl < r) {
                    nl = r
                };
                if (nl > 0) {
                    nl = 0
                };
                if (nt < b) {
                    nt = b
                };
                if (nt > 0) {
                    nt = 0
                };

                sticker.image.offsetx = nl/proW/sticker.image.scale;
                sticker.image.offsety = nt/proH/sticker.image.scale;
                $scope.$digest();
            }
            //鼠标抬起事件
            window.onmouseup = function ($event) {
                isImagebox = false;
                vm.isImageboxTrim = false;
                stickerDragBox = {}
            }
        }
        //防止事件冒泡，默认事件
        function fn(e) {
            if (e && e.stopPropagation) {
                // 因此它支持W3C的stopPropagation()方法
                e.stopPropagation();
            } else {
                // 否则，我们需要使用IE的方式来取消事件冒泡
                window.event.cancelBubble = true;
            }

            // 阻止默认浏览器动作(W3C)
            if (e && e.preventDefault) {
                e.preventDefault();
            } else {
                // IE中阻止函数器默认动作的方式
                window.event.returnValue = false;
            }
        }
        /***********************  左侧菜单  ****************************/
        vm.nav = "picture";
        /***********************  照片  ****************************/
        vm.folderShow = false;
        vm.indexNum = 0;
        vm.maxId = null;
        vm.minId = null;
        vm.totalPhotoItems = null;
        vm.itemsPerPage = 40;
        $scope.photos = [];
        // gallaryPic 在控制器顶部已由 localStorage 缓存初始化，此处仅做兜底，避免被置为非数组
        if (!angular.isArray($scope.gallaryPic)) {
            $scope.gallaryPic = [];
        }
        $scope.moveGalleryIds = [];
        vm.picLoading = false;
        vm.deleteSure = false;
        vm.folderIds = "";
        vm.folderId = "";
        vm.photosTab='all';
        function loadFolders() {
            var articleId = vm.article ? (vm.article.articleId || vm.article.id) : vm.articleId;
            Folder.storeGetAllByCondition({
                items: [{key: "type", op: "=", value: "Gallery"},{key: "articleId", op: "=", value: articleId}],
                sort: ["id,asc"]
            }, function (resp) {
                if(resp.status == 200){
                    $scope.Folders = resp.data;
                }else {
                    MessageService.error(resp.message);
                }
            })
        }
        $scope.folderOn = function () {
            vm.folderShow = !vm.folderShow;
        };
        // 增加文件夹
        $scope.addFolder = function () {
            $uibModal.open({
                templateUrl: "app/entities/page/pagesmySuffix-create.html",
                controller: "PageMySuffixCreateController",
                backdrop: 'static',
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: 'vm',
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page)
                        };
                    }],
                    entity: [function() {
                        return {
                            type: "NEW"
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('editorWeb');
                        return $translate.refresh();
                    }]
                }
            }).result.then(function (backData) {
                Folder.save({
                    name: backData,
                    type: 'Gallery',
                    articleId:vm.article.id
                }, function (resp) {
                    $scope.Folders.push(resp.data);
                })
            });
        }
        vm.folderName = ''
        //选择文件夹
        $scope.showFolderContent = function (folder) {
            vm.unusedQuantity = null;
            vm.oldQuantity = null;
            vm.indexNum = 0;
            vm.maxId = null;
            vm.minId = null;
            vm.totalPhotoItems = null;
            $scope.photos = [];
            $scope.gallaryPic = [];
            $scope.moveGalleryIds = [];
            vm.folderId = folder ? folder.id : '';
            vm.folderName = folder ? folder.name : '';
            if (folder) {
                loadAll(folder.id);
            } else {
                loadAll('isNull');
            }

        };
        $scope.deleteShow = function (ids,event) {
            event.stopPropagation();
            vm.folderIds=ids;
            vm.deleteSure = true;
        }
        $scope.photoCb = function () {
            vm.indexNum++;
            loadAll('isNull');
        }
        $scope.updateFloders = function(folder,event){
            event.stopPropagation();
            $uibModal.open({
                templateUrl: 'app/entities/page/pagesmySuffix-create.html',
                controller: 'PageMySuffixCreateController',
                backdrop: 'static',
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: 'vm',
                resolve: {
                    entity: [function() {
                        return {
                            type: "EDITOR",
                            name: folder.name
                        };
                    }]
                }
            }).result.then(function (data) {
                folder.name = data;
                Folder.update(folder, function (resp) {
                    if(resp.status == 200){
                        loadFolders();
                        vm.indexNum = 0;
                        vm.maxId = null;
                        vm.minId = null;
                        vm.totalPhotoItems = null;
                        $scope.photos = [];
                        loadAll('isNull');
                        MessageService.success($translate.instant("editorMessage.modifySuccess"));
                    }else {
                        MessageService.error(resp.message);
                    }
                },function () {
                    swal.showInputError($translate.instant("editorMessage.pleaseEnterTheCorrectFileName"));
                })
            }, function(){

            });

        }

        vm.photoSort = '1';
        $scope.photoSortChange = function (value) {
            vm.photoSort = value;
            vm.indexNum = 0;
            vm.maxId = null;
            vm.minId = null;
            vm.totalPhotoItems = null;
            $scope.photos = [];
            if(vm.folderId){
                loadAll(vm.folderId);
            }else{
                loadAll('isNull');
            }
        }
        vm.refreshPhotos = function () {
            vm.refreshing = true;
            var navEl = $('#navId')[0];
            vm._refreshScrollTop = navEl ? navEl.scrollTop : 0;
            vm.indexNum = 0;
            vm.maxId = null;
            vm.minId = null;
            vm.totalPhotoItems = null;
            $scope.photos = [];
            loadAll(vm.folderId || 'isNull');
        }
        function loadAll(folderId) {
            vm.picLoading = true;
            //$scope.gallaryPic = [];
            //$scope.moveGalleryIds = [];
            var sort = ["id,desc"];
            if(vm.photoSort == 1){
                sort = ["id,desc"]
            }else if(vm.photoSort == 2){
                sort = ["name,desc"]
            }else if(vm.photoSort == 3){
                sort = ["name,asc"]
            }
            var items = [];
            var articleId = vm.article ? (vm.article.articleId || vm.article.id) : vm.articleId;
            if (folderId == 'isNull') {
                items.push({key: "folderId", op: "isNull", value: ''})
            }else{
                items.push({key: "folderId", op: "=",value: folderId});
            }
            items.push({key: "articleId", op: "=", value: articleId})
            if (vm.maxId) {
                items.push({key: "id", op: "<=",value: vm.maxId});
            }
            if (vm.minId) {
                items.push({key: "id", op: "<",value: vm.minId});
            }
            if (folderId == 'isNull') {
                $scope.selectFolder = $translate.instant("editorCommon.selectFolder");
                Gallery.storeByCondition({
                    items: items,
                    page: vm.indexNum,
                    size: vm.itemsPerPage,
                    sort: sort
                }, onSuccess, onError);
            } else {
                Gallery.storeByCondition({
                    items: items,
                    page: vm.indexNum,
                    size: vm.itemsPerPage,
                    sort: sort
                }, onSuccess, onError);
            }
        }
        function onSuccess(data, headers) {
            if (vm.totalPhotoItems == null) {
                vm.totalPhotoItems = Number(headers('X-Total-Count'));
            }
            if (vm.maxId == null && vm.photoSort == 1 && data.data.length > 0) {
                vm.maxId = data.data[0].id;
            }
            vm.picLoading = false;
            vm.refreshing = false;
            var len = $scope.photos.length;
            angular.forEach(data.data, function (item, i) {
                item.identifier = $scope.domain + item.identifier;
                item.index = i + len;
                item.usenum = 0;
                item.type = 'picture';
                // 按缓存 id 回填选中态（原实现 some 回调漏了 return，回填恒不生效）
                item.select = cachedSelectIds.indexOf(item.id) > -1;
                $scope.photos.push(item);
            });
            // 按最新的处理状态重算选中集合，剔除处理中 / 处理失败的照片
            syncGallerySelection();
            photosNum();
            if($scope.photos.length < vm.totalPhotoItems){
                vm.isPhotoFinish = false;
            }else {
                vm.isPhotoFinish = true;
            }
            if($scope.photos.length > 0){
                newCreateDate = new Date($scope.photos[0].createdDate).getTime();
            }else {
                newCreateDate = new Date().getTime();
            }
            // 刷新场景下恢复滚动位置，等 DOM 渲染后再设置（onSuccess 会在每次 loadAll 后执行，仅当 _refreshScrollTop 有值时恢复）
            if (vm._refreshScrollTop != null) {
                var targetTop = vm._refreshScrollTop;
                vm._refreshScrollTop = null;
                $timeout(function () {
                    var el = $('#navId')[0];
                    if (el) {
                        el.scrollTop = targetTop;
                    }
                });
            }
        }

        function onError(error) {
            vm.picLoading = false;
            vm.refreshing = false;
            MessageService.error($translate.instant("editorMessage.failedToObtainThePhotoGallery"));
        }
        //删除多个文件夹
        $scope.deleteFolders = function () {
            vm.deleteSure = false;
            Folder.batchDelete({ids: vm.folderIds}, function () {
                vm.indexNum = 0;
                vm.maxId = null;
                vm.minId = null;
                vm.totalPhotoItems = null;
                vm.maxId = null;
                vm.minId = null;
                vm.totalPhotoItems = null;
                $scope.photos = [];
                loadAll('isNull');
                loadFolders();
                MessageService.success($translate.instant("editorMessage.deleteSuccess"));
            }, function () {
                MessageService.error($translate.instant("editorMessage.deleteError"));
            });
        };
        $scope.choosePhoto = function (photo, event) {
            if (!photo) return;
            cachedSelectIds = [];
            // 处理失败 / 处理中的照片均不可使用，禁止选中
            if (!isPhotoSelectable(photo)) {
                photo.select = false;
                syncGallerySelection();
                MessageService.error($translate.instant(isPhotoFailed(photo)
                    ? "nav.photograph.content.js.photoUnavailable"
                    : "nav.photograph.content.js.photoProcessing"));
                if (event && event.stopPropagation) {
                    event.stopPropagation();
                }
                return;
            }
            photo.select = !photo.select;
            syncGallerySelection();
        }
        $scope.switchBgTab = function (attr) {
            vm.photosTab = attr;
            if(vm.photosTab!='all'){
                vm.unUsedImageboxsNum = 0;
                angular.forEach($scope.photos,function (p) {
                    if(p.usenum==0){
                        vm.unUsedImageboxsNum++;
                    }
                })
            }
            getGallery();
            $scope.whetherChoose(false);
        }
        // 全选 / 取消全选：处理中、处理失败的照片不参与选中
        $scope.whetherChoose = function (attr) {
            cachedSelectIds = [];
            var photos = angular.isArray($scope.photos) ? $scope.photos : [];
            var hasSkipped = false;
            angular.forEach(photos, function (p) {
                if (!p) return;
                if (attr && isPhotoSelectable(p)) {
                    p.select = true;
                } else {
                    if (attr && isPhotoVisible(p) && !isPhotoSelectable(p)) {
                        hasSkipped = true;
                    }
                    p.select = false;
                }
            });
            syncGallerySelection();
            if (attr && hasSkipped) {
                MessageService.error($translate.instant("nav.photograph.content.js.photoSkip"));
            }
        }
        $scope.deleteBatchPhotos = function () {
            if (!$scope.moveGalleryIds.length) {
                MessageService.error($translate.instant("editorMessage.pleaseSelectAPhoto"));
                return
            }
            Gallery.batchDelete($scope.moveGalleryIds, function () {
                MessageService.success($translate.instant("editorMessage.deleteSuccess"));
                // 若被选中的pic被删除，就重新生成该数组
                // vm.totalPhotoItems = vm.totalPhotoItems - $scope.moveGalleryIds.length
                vm.unusedQuantity = null;
                vm.oldQuantity = null;
                $scope.gallaryPic = [];
                $scope.moveGalleryIds = [];
                $scope.photos = [];
                //没有数据，页码置为0，重新调接口查询
                vm.indexNum = 0;
                vm.maxId = null;
                vm.minId = null;
                vm.totalPhotoItems = null;
                if (vm.folderId) {
                    loadAll(vm.folderId);
                } else {
                    loadAll('isNull');
                }
            }, function (error) {
                MessageService.error($translate.instant("editorMessage.deleteError"));
            });
        }
        // 图库照片处理状态：大图处理中/失败、色彩转换中/失败，无特殊状态返回''（正常展示照片）
        function getPhotoStatus(photo) {
            if (!photo) return '';
            if (photo.convertFlag == true && photo.convertStatus == 'running') return 'convertRunning';
            if (photo.convertStatus == 'error') return 'convertError';
            if ($scope.isLarge(photo.imageInfo)) {
                if (photo.largeFlag && photo.largeStatus == 'running') return 'largeRunning';
                if (photo.largeFlag && photo.largeStatus == 'error') return 'largeError';
            }
            return '';
        };
        // 是否处理失败状态（大图处理失败、色彩转换失败）
        function isPhotoFailed(photo) {
            var status = getPhotoStatus(photo);
            return status === 'largeError' || status === 'convertError';
        };
        // 当前 tab 下照片是否可见（"未使用" tab 会过滤掉已使用的照片）
        function isPhotoVisible(photo) {
            return !!photo && (vm.photosTab == 'all' || photo.usenum == 0);
        };
        // 照片是否允许被选中：当前 tab 可见 && 无任何处理中/失败状态（photoStatus 为 '' 才是正常可用）
        function isPhotoSelectable(photo) {
            return isPhotoVisible(photo) && getPhotoStatus(photo) === '';
        };
        // 选中集合的唯一出口：只把「当前可见 && 状态正常 && 已勾选」的照片计入 gallaryPic / moveGalleryIds。
        // choosePhoto、whetherChoose、ws 状态变更、列表重新加载都必须走这里，
        // 否则各入口各自维护会出现「UI 显示选中 / 实际不可用」或反之的不一致。
        function syncGallerySelection() {
            var gallaryPic = [];
            var moveGalleryIds = [];
            var photos = angular.isArray($scope.photos) ? $scope.photos : [];
            angular.forEach(photos, function (p) {
                if (!p || !isPhotoVisible(p)) return;
                // 照片可能在被选中之后才异步变成处理中/失败，此时强制取消选中
                if (!isPhotoSelectable(p)) {
                    p.select = false;
                    return;
                }
                if (p.select) {
                    gallaryPic.push(p);      //选择导入图片的数组
                    moveGalleryIds.push(p.id);
                }
            });
            $scope.gallaryPic = gallaryPic;
            $scope.moveGalleryIds = moveGalleryIds;
        };
        $scope.photoStatus = getPhotoStatus;
        $scope.isPhotoFailed = isPhotoFailed;
        $scope.isPhotoSelectable = isPhotoSelectable;
        // 处理失败的照片：点击弹出是否删除照片的确认框
        $scope.showDeletePhotoPop = function (photo, event) {
            if (event) {
                event.stopPropagation();
            }
            vm.pendingDeletePhoto = photo;
            vm.deletePhotoSure = true;
        };
        // 确认删除处理失败的照片，取消则仅关闭弹框
        $scope.deletePhotoConfirm = function () {
            var photo = vm.pendingDeletePhoto;
            if (!photo || !photo.id) {
                vm.deletePhotoSure = false;
                vm.pendingDeletePhoto = null;
                return;
            }
            var id = photo.id;
            Gallery.batchDelete([id], function () {
                MessageService.success($translate.instant("editorMessage.deleteSuccess"));
                // 清除画布中引用该照片的图片框
                angular.forEach(vm.data, function (dataItem) {
                    var pages = vm.pictureType == 'spread' ? dataItem : [dataItem];
                    angular.forEach(pages, function (item) {
                        angular.forEach(item.levels.level, function (level) {
                            if (level.imagebox && level.imagebox.image && level.imagebox.image.resourceid == id) {
                                var box = level.imagebox;
                                box.blurredrectangle = {
                                    x: 0,
                                    y: 0,
                                    width: box.geometry.width,
                                    height: box.geometry.height
                                };
                                box.imgUrl = "content/images/mask_souce.png";
                                box.image = {
                                    resource: {
                                        identifier: "",
                                        provider: ''
                                    },
                                    filterResource: {
                                        identifier: '',
                                        provider: ''
                                    },
                                    offsetx: 0,
                                    offsety: 0,
                                    width: '',
                                    height: '',
                                    imgsize: '',
                                    index: '',
                                    parameter: [],
                                    scale: 1,
                                    angle: 0
                                };
                            }
                        });
                    });
                });
                var photos = angular.isArray($scope.photos) ? $scope.photos : ($scope.photos = []);
                for (var i = photos.length - 1; i >= 0; i--) {
                    if (photos[i] && photos[i].id === id) {
                        photos.splice(i, 1);
                    }
                }
                var gallaryPic = angular.isArray($scope.gallaryPic) ? $scope.gallaryPic : ($scope.gallaryPic = []);
                var picIndex = -1;
                for (var pi = 0; pi < gallaryPic.length; pi++) {
                    if (gallaryPic[pi] === photo || (gallaryPic[pi] && gallaryPic[pi].id === id)) {
                        picIndex = pi;
                        break;
                    }
                }
                if (picIndex > -1) {
                    gallaryPic.splice(picIndex, 1);
                }
                var moveGalleryIds = angular.isArray($scope.moveGalleryIds) ? $scope.moveGalleryIds : ($scope.moveGalleryIds = []);
                var idIndex = moveGalleryIds.indexOf(id);
                if (idIndex > -1) {
                    moveGalleryIds.splice(idIndex, 1);
                }
                if (vm.totalPhotoItems != null && vm.totalPhotoItems > 0) {
                    vm.totalPhotoItems--;
                }
                if (photo.usenum == 0) {
                    if (vm.unusedQuantity) {
                        vm.unusedQuantity = Math.max(0, vm.unusedQuantity - 1);
                    }
                    if (vm.unUsedImageboxsNum) {
                        vm.unUsedImageboxsNum = Math.max(0, vm.unUsedImageboxsNum - 1);
                    }
                }
                if (!$scope.photos.length) {
                    vm.isPhotoFinish = true;
                }
                vm.deletePhotoSure = false;
                vm.pendingDeletePhoto = null;
            }, function () {
                vm.deletePhotoSure = false;
                vm.pendingDeletePhoto = null;
                MessageService.error($translate.instant("editorMessage.deleteError"));
            });
        };
        //一键填充
        $scope.directFill= function(sideUnification){
            if(!$scope.gallaryPic ||$scope.gallaryPic.length < 1){
                MessageService.confirm({
                    title:$translate.instant('editorPop.selectPhoto.title'),
                    confirm:$translate.instant('editorPop.selectPhoto.confirm'),
                    msg:$translate.instant('editorPop.selectPhoto.msg')
                },function(){})
                return
            }
            for(var i=0; i<$scope.gallaryPic.length; i++){
                $scope.gallaryPic[i].seq = i+1;
            }
            abook($scope.gallaryPic, false, sideUnification);
        }
        function photosNum(){
            for(var i=0; i<$scope.photos.length; i++){
                var _photo = $scope.photos[i];
                _photo.usenum=0;
                angular.forEach(vm.data, function (data, index) {
                    if(vm.pictureType == 'spread'){
                        angular.forEach(data,function (page) {
                            angular.forEach(page.levels.level, function (level, i) {
                                if(level.imagebox && level.imagebox.image && level.imagebox.image.resourceid) {
                                    if (level.imagebox.image.resourceid == _photo.sourceId) {
                                        _photo.usenum++
                                    }
                                }
                            })
                        })
                    }else{
                        angular.forEach(data.levels.level, function (level, i) {
                            if(level.imagebox && level.imagebox.image && level.imagebox.image.resourceid) {
                                if (level.imagebox.image.resourceid == _photo.sourceId) {
                                    _photo.usenum++
                                }
                            }
                        })
                    }
                })
            }
            if(vm.photosTab!='all'){
                $scope.switchBgTab();
            }
            unusedQuantity();
        }
        // 背景图和素材的上传
        $scope.uploadPic = function () {
            uploadAble(StoreStorages,vm.storeId, function (res) {
                if(res.status == 200){
                    $timeout(function () {
                        var uploadInput = document.getElementById('uploadImg2');
                        if (uploadInput) {
                            uploadInput.click();
                        }
                    }, 0, false);
                }else{
                    if(res.status == 400){MessageService.error($translate.instant('editorCommon.systemError'));}
                    else {
                        MessageService.error(res.data||$translate.instant('editorCommon.systemError'));
                    }
                }
            });

        }

        $scope.uploadImage = function(e){
            e.stopPropagation();
            e.preventDefault();
            if (!vm.product.editTip || !vm.product.editTipPic || $localStorage.dotRemindEditorTipPic) {
                $scope.uploadPic();
                return
            }
            $uibModal.open({
                templateUrl: 'app/entities/components/controls/editorTipPicModal.html',
                controller: 'EditorTipPicModalController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function () {
                        return {
                            url: vm.product.editTipPic,
                        };
                    },
                }
            }).result.then(function() {
                $scope.uploadPic();
            });
        }
        var bigSizePics = [];
        window.updatePic = function ($event) {
            vm.duplicateList = []; //重置重复图片列表
            vm.successNumber = 0;//上传成功数量
            vm.errorNumber = 0;//上传失败数量
            var oldlength = $event.target.files.length;
            filterFiles($event.target.files).then(function(filterFilesList) {
            var newlength = filterFilesList.length;
            if (newlength < oldlength) {
                MessageService.error($translate.instant("editorMessage.updatePicError"));
            }
            $timeout(function () {
                vm.picLoading = true;
                var len = $scope.photos.length;
                var files = [];
                var higherSize = [];
                bigSizePics = [];
                var uploadPromises = [];
                // vm.totalPhotoItems = (vm.totalPhotoItems - 0) + (filterFilesList.length-0)
                for (var i = 0; i < filterFilesList.length; i++) {
                    var f = filterFilesList[i];
                    f.imageSize = Math.ceil(f.size/1024/1024);
                    files.push(f)
                }
                if (files.length == 0) {
                    vm.picLoading = false;
                    return
                }
                for (var i = 0; i < files.length; i++) {
                    var file = files[i];
                    if (file.size>=50*1024*1024 || (file.width*file.height > 400000000)){
                        file.imageSize= Math.ceil(file.size/1024/1024);
                        bigSizePics.push(file);
                    }else{
                        uploadPromises.push(getBgImg(files, i, len));
                        if (bigSizePics.length==0 && i == (files.length-1)) {
                            setTimeout(function () {
                                angular.forEach($scope.photos, function (item, j) {
                                    item.index = j;
                                });
                            }, 400)
                        }
                    }
                }
                // 等待所有上传完成后进行重复图片检测
                Promise.all(uploadPromises).then(function() {
                    if(vm.duplicateList.length > 0){
                        MessageService.confirm({
                            title :$translate.instant('hint.prompt'),
                            cancel :$translate.instant('button.cancel'),
                            confirm :$translate.instant('button.confirm'),
                            msg :$translate.instant('gallery.duplicateDetected', {count: vm.duplicateList.length}),
                            html: '<span class="themecolor themecolor-btn">' + $translate.instant('gallery.viewDuplicatePhotos') + '</span>'
                        }, function(res) {
                            if(res == 'htmlClick'){
                                vm.isDuplicateList = true;
                            }else{
                                var ids = [];
                                vm.duplicateList.forEach(function (item){
                                    ids.push(item.id)
                                })
                                Gallery.batchDelete(ids, function () {
                                    MessageService.success($translate.instant("gallery.deduplicateSuccess"));
                                    $scope.gallaryPic = [];
                                    $scope.moveGalleryIds = [];
                                    vm.indexNum = 0;
                                    vm.totalPhotoItems = null;
                                    vm.maxId = null;
                                    vm.minId = null;
                                    $scope.photos = [];
                                    vm.duplicateList=[];
                                    if (vm.folderId) {
                                        loadAll(vm.folderId);
                                    } else {
                                        loadAll('isNull');
                                    }
                                }, function (error) {
                                    MessageService.error($translate.instant("gallery.deleteFailed"));
                                    vm.duplicateList=[];
                                });
                            }
                        },function (){
                            vm.duplicateList=[];
                        })
                    }
                    if (bigSizePics.length > 0) {
                        thumbnailatorPic();
                    }
                });
                $event.srcElement.value = "";
            })
            });
        };
        var uploadFailedList = []; //临时存储上传失败图片
        function getBgImg(files, i, len) {
            return new Promise(function(resolve) {
                CommonService.UpdateQiniuService(files, i, len, $scope.domain, vm.token, vm.folderId,(vm.article.articleId || vm.article.id),function (resp) {
                    if(resp.data.duplicate){
                        vm.duplicateList.push(resp.data)
                    }
                    vm.successNumber++;
                    if (vm.successNumber + vm.errorNumber >= files.length) {
                        vm.picLoading = false;
                        document.getElementById('uploadImg2').value = '';//上传完清空输入框
                        if (vm.errorNumber > 0) {
                            vm.errorAlertPopup = true;
                        }
                        $scope.photoSortChange(vm.photoSort);
                    }
                    resolve(resp);
                },function(errorFile,executionCompleted){
                    uploadFailedList.push(errorFile);
                    vm.errorNumber++;
                    if (vm.successNumber + vm.errorNumber >= files.length) {
                        $timeout(function(){
                            vm.picLoading = false;
                            vm.uploadFailedList = uploadFailedList;
                            uploadFailedList = [];
                            vm.errorAlertPopup = true;
                            document.getElementById('uploadImg2').value = '';//上传完清空输入框
                            $scope.photoSortChange(vm.photoSort);
                            $scope.$apply();
                        })
                    };
                    resolve();
                },true)
            });
        }

        $scope.duplicateChange = function (){
            vm.isDuplicateList = false;
            vm.duplicateList=[];
            vm.maxId = null;
            vm.minId = null;
            vm.totalPhotoItems = null;
            $scope.gallaryPic = [];
            $scope.moveGalleryIds = [];
            $scope.photos = [];
            vm.indexNum = 0;
            if(vm.folderId){
                loadAll(vm.folderId);
            } else {
                loadAll('isNull');
            }
            if (bigSizePics.length >0) {
                thumbnailatorPic();
            }
        }
        $scope.errorAlertPopupClose = function(){
            vm.errorAlertPopup = false;
            vm.uploadFailedList = [];
        }

        $scope.errorPhotoView = function(){
            $uibModal.open({
                templateUrl: 'app/entities/page-compontents/uploadFailedImageListPopup.html',
                controller: 'UploadFailedImageListPopupController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: [function() {
                        return vm.uploadFailedList;
                    }]
                }
            }).result.then(function (flag) {
                if (flag) {
                    var files = vm.uploadFailedList;
                    for (var i = 0; i < files.length; i++) {
                        getBgImg(files, i);
                    }
                    vm.successNumber = 0;//上传成功数量
                    vm.errorNumber = 0;//上传失败数量
                    vm.picLoading = true;
                    vm.errorAlertPopup = false;
                    vm.uploadFailedList = [];
                }else{
                    vm.errorAlertPopup = false;
                    vm.uploadFailedList = [];
                }
            });
        }

        function thumbnailatorPic(){
            $uibModal.open({
                templateUrl: 'app/entities/page-compontents/thumbnailator.html',
                controller: 'ThumbnailatorController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: [function() {
                        return {
                            files: bigSizePics,
                            aid:(vm.article.articleId || vm.article.id),
                            folderId:vm.folderId,
                            domain:$scope.domain,
                            token:vm.token,
                            detectFaces:false
                        };
                    }]
                }
            }).result.then(function (values) {
                bigSizePics=[];
                vm.picLoading = false;
                // if(values){
                //     for (var j = 0; j < values.length; j++) {
                //         var value = values[j];
                //         value.bgImg = value.identifier;
                //         $scope.photos.unshift(value);
                //     }
                //     vm.picLoading = false;
                //     setTimeout(function () {
                //         angular.forEach($scope.photos, function (item, z) {
                //             item.index = z;
                //         });
                //     }, 400)
                // }
            }, function(){
                vm.picLoading = false;
                vm.refreshPhotos()
            });
        }

        //转移照片
        $scope.moveToFolder = function () {
            if ($scope.gallaryPic.length < 1) {
                MessageService.error($translate.instant("editorMessage.pleaseSelectAPhoto"));
                return
            }
            vm.isMoveToFolder = true;
        }

        $scope.chooseFolder2 = function(){
            angular.forEach($scope.Folders, function (f, i) {
                f.selected = false;
            })
            vm.selectFolderId = -1;
        }
        $scope.chooseFolder = function (folder, index) {
            vm.selectFolderId = null;
            folder.selected = !folder.selected;
            angular.forEach($scope.Folders, function (f, i) {
                if (index != i) {
                    f.selected = false;
                }
            })
            if (folder.selected) {
                vm.selectFolderId = folder.id;
            }
        }
        $scope.saveMoveToFolder = function () {
            if (vm.selectFolderId == null) {
                MessageService.error($translate.instant("editorMessage.pleaseSelectAFolder"));
                return
            }
            $scope.moveGalleryIds = [];
            angular.forEach($scope.gallaryPic, function (p, i) {
                $scope.moveGalleryIds.push(p.id);
            })

            Gallery.moveFolder({
                galleries: $scope.moveGalleryIds,
                folderId: vm.selectFolderId === -1 ? null : vm.selectFolderId
            }, function () {
                angular.forEach($scope.Folders, function (f, i) {
                    f.selected = false;
                })
                $scope.gallaryPic = [];
                $scope.moveGalleryIds = [];
                vm.unusedQuantity = null;
                vm.oldQuantity = null;
                vm.indexNum = 0;
                vm.maxId = null;
                vm.minId = null;
                vm.totalPhotoItems = null;
                $scope.photos = [];
                vm.isMoveToFolder = false;
                if (vm.folderId) {
                    loadAll(vm.folderId);
                } else {
                    loadAll('isNull');
                }
            })
        }

        //手机传图
        vm.qrcodeShow = false;
        vm.fid = 0;
        var qrcode = null;
        var phonetimer = null;
        var newCreateDate = 0;
        $scope.uploadByPhone = function () {
            uploadAble(StoreStorages,vm.storeId, function (res) {
                if(res.status == 200){
                    vm.qrcodeShow = !vm.qrcodeShow;
                    if (qrcode != null) {
                        // qrcode.clear();
                        $('#qrcode1').html("");
                    }

                    //vm.folderId -----某一文件夹信息
                    if (vm.folderId == undefined || vm.folderId == null) {
                        vm.fid = 0;
                    } else {
                        vm.fid = vm.folderId;
                    }

                    Article.getPhonePicToken({id:(vm.article.articleId || vm.article.id)}, function(data){
                        // 手机传图二维码
                        qrcode = $('#qrcode1').qrcode({
                            render: "canvas",
                            width: 150,
                            height: 150,
                            text: '' + vm.platformSetting.editorNotifyUrl + "/#/" + vm.storeId + "/" + vm.fid + "/gallery/" + (vm.article.articleId || vm.article.id)+'?auth='+data.data
                        });
                    },function(){
                    })
                    // // 手机传图二维码
                    // qrcode = $('#qrcode1').qrcode({
                    //     render: "canvas",
                    //     width: 150,
                    //     height: 150,
                    //     text: '' + vm.platformSetting.storeNotifyUrl + "/#/" + vm.storeId + "/" + vm.fid + "/gallery/" + vm.userId
                    // });
                    // // (new Date("2012/12/25 20:11:11")).getTime()

                    // if (vm.qrcodeShow) {
                    //     phonetimer = setInterval(function () {
                    //         var gallery_items = [{key: "storeId", op: "=", value: vm.storeId},{key: "articleId", op: "=", value: vm.aid}];
                    //         if (vm.folderId) {
                    //             gallery_items.push({key: "folderId", op: "=", value: vm.folderId});
                    //         } else {
                    //             gallery_items.push({key: "folderId", op: "isNull", value: 1});
                    //         }
                    //         Gallery.storeByCondition({
                    //             items: gallery_items,
                    //             page: 0,
                    //             size: vm.itemsPerPage,
                    //             sort: ["createdDate,desc"]
                    //         }, onSuccessToPhone, onError);
                    //     }, 3000);
                    // } else {
                    //     clearInterval(phonetimer);
                    //     phonetimer = null;
                    // }
                }else{
                    if(res.status == 400){MessageService.error($translate.instant('editorCommon.systemError'));}
                    else {
                        MessageService.error(res.data||$translate.instant('editorCommon.systemError'));
                    }
                }
            })
        }

        function onSuccessToPhone(res) {
            var data = res.data;
            if (data == null || data.length == 0) {
                return;
            }
            var loadCreateDate = new Date(data[0].createdDate).getTime();
            for (var i = 0; i < data.length; i++) {
                var d = data[i];
                if (new Date(d.createdDate).getTime() > newCreateDate) {
                    d.identifier = $scope.domain + d.identifier;
                    d.select = false;
                    d.index = i;
                    $scope.photos.unshift(d);
                } else {
                    newCreateDate = loadCreateDate;
                    break;
                }
            }
            if (newCreateDate == 0) {
                newCreateDate = loadCreateDate;
            }
        }
        $scope.uploadByPhone1 = function(){
            vm.qrcodeShow = false;
            $scope.photoSortChange(vm.photoSort)
            // clearInterval(phonetimer);
        }
        /***********************  照片结束  ****************************/


        //全屏
        $scope.toggleFullScreen = function(){
            if (!vm.fullFlag) {
                //进入全屏
                var de = document.documentElement;
                if (de.requestFullscreen) {
                    de.requestFullscreen();
                } else if (de.mozRequestFullScreen) {
                    de.mozRequestFullScreen();
                } else if (de.webkitRequestFullScreen) {
                    de.webkitRequestFullScreen();
                }
                vm.fullFlag = true;
            } else {
                //退出全屏
                var de = document;
                if (de.exitFullscreen) {
                    de.exitFullscreen();
                } else if (de.mozCancelFullScreen) {
                    de.mozCancelFullScreen();
                } else if (de.webkitCancelFullScreen) {
                    de.webkitCancelFullScreen();
                }
                vm.fullFlag = false;
            }
        }
        //删除
        $scope.deleteBox = function ($event) {
            vm.data.splice(vm.pageIndex, 1);
            vm.pageSum = vm.data.length - 1 < 0 ? 0 : vm.data.length - 1;
            if(vm.pageIndex > vm.pageSum){
                vm.pageIndex = vm.pageSum;
            }
            photosNum();
        }
        $scope.subtractDeleteTab = function($event, index){
            fn($event)
            vm.data.splice(index, 1);
            vm.pageSum = vm.data.length - 1 < 0 ? 0 : vm.data.length - 1;
            if(vm.pageIndex > vm.pageSum){
                vm.pageIndex = vm.pageSum;
            }
            photosNum();
        }

        $scope.subtractQuantityTab = function ($event, data) {
            fn($event)
            if(data.quantity>1){
                data.quantity--;
            }
        }
        $scope.pushQuantityTab = function ($event, data) {
            fn($event)
            data.quantity++;
        }
        //复制背面
        vm.isCopyBack = false;
        vm.copyBackIndex == null;
        $scope.copyBack = function($event, index){
            fn($event)
            vm.isCopyBack = true;
            vm.copyBackIndex = index;
        }
        $scope.copyHide = function(){
            vm.isCopyBack = false;
            vm.copyBackIndex == null;
            vm.data.forEach(function(data){
                data[1].isCopyBack = false;
            })
        }
        $scope.copyAll = function(){
            vm.data.forEach(function(data,dataIndex){
                if(dataIndex != vm.copyBackIndex){
                    var outline = JSON.parse(JSON.stringify(data[1].outline));
                    data[1] = JSON.parse(JSON.stringify(vm.data[vm.copyBackIndex][1]));
                    data[1].uuid = uuid();
                    data[1].outline = outline;
                    data[1].isCopyBack = true;
                }
            })
            MessageService.success($translate.instant("editorCommon.copySuccess"))
            photosNum();
        }
        $scope.editorPageCopyHere = function(index){
            var outline = JSON.parse(JSON.stringify(vm.data[index][1].outline));
            vm.data[index][1] = JSON.parse(JSON.stringify(vm.data[vm.copyBackIndex][1]));
            vm.data[index][1].uuid = uuid();
            vm.data[index][1].outline = outline;
            vm.data[index][1].isCopyBack = true;
            MessageService.success($translate.instant("editorCommon.copySuccess"))
            photosNum();
        }
        //保存
        $scope.isSave = false;
        vm.isPageWarnExamine = false;
        $scope.save = function () {
            articleOverdue(function () {
                if(vm.data.length == 0 || !vm.data){
                    MessageService.error($translate.instant("editorCommon.pleaseAddImage"))
                    return;
                }
                var _data = [];
                var _data1 = angular.copy(vm.data);
                var pageCount = 0;
                if(vm.pictureType == 'single'){
                    angular.forEach(_data1, function (item) {
                        for(var i=0; i<item.quantity; i++){
                            var itemData = angular.copy(item);
                            _data.push(itemData)
                        }
                    });
                    _data.forEach(function (data) {
                        data.quantity = 1;
                    })
                    pageCount = _data.length;
                }
                if(vm.pictureType == 'spread'){
                    _data1.forEach(function (data) {
                        for(var i=0; i<data[0].quantity; i++){
                            _data.push(data[0])
                            _data.push(data[1])
                        }
                    })
                    _data.forEach(function (data) {
                        data.quantity = 1;
                    })
                    pageCount = _data.length/2;
                }
                vm.article.articleStatus = "EDITING";
                if (vm.article.multiple) {//先编辑
                    if(vm.article.expectPageCount && vm.article.expectPageCount >= 0){
                        if(pageCount % vm.article.expectPageCount === 0){
                            vm.article.articleStatus = "COMPLETED";
                        }else{
                            MessageService.hint($translate.instant('editorCommon.printQuantityInfo', {pageCount: pageCount, expectPageCount: vm.article.expectPageCount}));
                            return
                        }
                    }else{
                        vm.article.articleStatus = "COMPLETED";
                    }
                }else{//先下单
                    if(vm.article.expectPageCount && vm.article.expectPageCount >= 0){
                        if(pageCount > vm.article.expectPageCount){
                            MessageService.hint($translate.instant('editorCommon.photoCountExceeded', {max: vm.article.expectPageCount}));
                            return
                        }
                        if(pageCount == vm.article.expectPageCount){
                            vm.article.articleStatus = "COMPLETED";
                        }
                    }else{
                        vm.article.articleStatus = "COMPLETED";
                    }
                }


                if(!vm.isPageWarnExamine && pageWarnExamine(_data, vm.imgSize, vm.imgDpi)){
                    MessageService.confirm({
                        title:$translate.instant("editorCommon.hint"),
                        cancel:$translate.instant("button.amend"),
                        confirm:$translate.instant("button.continueSave"),
                        msg:$translate.instant("editorMessage.lackPixelsMessage")
                    },function(){
                        vm.isPageWarnExamine = true;
                        $scope.save();
                    })
                    return
                }
                //判断是否有图片未上传  且是否继续保存
                for (var i = 0; i < _data.length; i++) {
                    var _page = _data[i];
                    if (_page.levels.level) {
                        for (var j = 0; j < _page.levels.level.length; j++) {
                            var _level = _page.levels.level[j];
                            if (_level.imagebox) {
                                if (!_level.imagebox.image || !_level.imagebox.image.resource || !_level.imagebox.image.resource.identifier) {
                                    vm.article.articleStatus = "EDITING";
                                }
                            }
                        }
                    }
                }
                if(!vm.placeOrder){
                    return
                }
                save1(_data);
            })
        }
        function articleOverdue(callback){
            if($stateParams.aid){
                Article.get({id: $stateParams.aid}, function (article) {
                    if(article.data.fileName != vm.article.fileName){
                        MessageService.confirm({
                            title:$translate.instant("editorCommon.hint"),
                            cancel:$translate.instant("button.cancel"),
                            confirm:$translate.instant("button.refresh"),
                            msg:$translate.instant("hint.articleOverdue")
                        },function(){
                            $state.go("editorPhotoBothWebEdit", {storeId: vm.storeId, aid:  vm.article.id},{reload:true,location: 'replace'});
                        })
                    }else{
                        callback();
                    }
                })
            }
            if($stateParams.orderArticleId) {
                OrderArticle.getByUser({id: $stateParams.orderArticleId}, function (article) {
                    if(article.data.fileName != vm.article.fileName){
                        MessageService.confirm({
                            title:$translate.instant("editorCommon.hint"),
                            cancel:$translate.instant("button.cancel"),
                            confirm:$translate.instant("button.refresh"),
                            msg:$translate.instant("hint.articleOverdue")
                        },function(){
                            $state.go("editorPhotoBothWebEdit1", {storeId: vm.storeId, orderArticleId:  $stateParams.orderArticleId},{reload:true,location: 'replace'});
                        })
                    }else{
                        callback();
                    }
                })
            }
        }
        function save1(data){
            vm.loading = true;
            thumbnailInit1(function (){
                if(data && data.length > 0){
                    var _page = [];
                    angular.forEach(data, function (item) {
                        var itemData = angular.copy(item);
                        _page.push(itemData)
                    });
                    var _template = angular.copy($scope.template);
                    _template.pages.page = _page;
                    _template.pages.uuid1 = vm.signalPage1.uuid;
                    _template.pages.uuid2 = vm.signalPage2.uuid;
                    var backupPages = documentMM({pages:{page:[vm.signalPage1,vm.signalPage2]}}, null, null);
                    var list = _template.backupPages && _template.backupPages.list ? _template.backupPages.list : [];
                    if(!list.some(function(item){return item.uuid == vm.signalPage1.uuid})){
                        list.push(backupPages.pages.page[0]);
                    }
                    if(!list.some(function(item){return item.uuid == vm.signalPage2.uuid})){
                        list.push(backupPages.pages.page[1]);
                    }
                    _template.backupPages = {
                        list:list
                    }
                    _template = documentMM(_template, null, null);

                    if (!_template) {
                        vm.loading = false;
                        return;
                    }
                    $scope.isSave = true;
                    _template.hostinfo = hostInfo();
                    Convert.articleUploadDocument(_template, function (res) {
                        vm.article.productType = 'CustomPrint';
                        vm.article.fileName = res.data.identifier;
                        vm.article.unFilledCount = 0;
                        vm.article.version = '2.0';
                        vm.article.pageCount = 0;
                        vm.article.saveUserName = localStorage.getItem('saveUserName') || ''
                        _page.forEach(function (itemPage) {
                            if(!itemPage.backup){
                                vm.article.pageCount++
                            }
                        })
                        if($stateParams.aid){
                            vm.article.id = vm.aid;
                            Article.update(vm.article, function (resp) {
                                $scope.isSave = false;
                                vm.loading = false;
                                swal({
                                    title: $translate.instant("editorMessage.modifySuccess"),
                                    text: $translate.instant("editorMessage.synchronizationOfWorks"),
                                    imageUrl: Theme.sweetSuccedImg(),
                                    timer: 2000,
                                    showConfirmButton: false
                                });
                                $(".wrap").show();
                                $(".navbar").show();
                                var screenW = document.body.clientWidth;
                                //web 端
                                if(screenW>1000){
                                    $state.go("page-view", {storeId: vm.storeId, aid:  resp.data.id},{location: 'replace'});
                                }else{
                                    $state.go("editorPhotoPreview", {storeId: vm.storeId, aid:  resp.data.id},{location: 'replace'});
                                }
                            }, function () {
                                $scope.isSave = false;
                                vm.loading = false;
                                swal({
                                    title: $translate.instant("editorMessage.saveError"),
                                    text: $translate.instant("editorMessage.saveError1"),
                                    imageUrl: Theme.sweetHintImg(),
                                    timer: 2000,
                                    showConfirmButton: false
                                });
                            })
                        }else if($stateParams.orderArticleId){
                            OrderArticle.update(vm.article, function (resp) {
                                $scope.isSave = false;
                                vm.loading = false;
                                swal({
                                    title: $translate.instant("editorMessage.modifySuccess"),
                                    text: $translate.instant("editorMessage.synchronizationOfWorks"),
                                    imageUrl: Theme.sweetSuccedImg(),
                                    timer: 2000,
                                    showConfirmButton: false
                                });
                                $(".wrap").show();
                                $(".navbar").show();
                                $state.go("page-view2", {storeId: vm.storeId, orderArticleId:  resp.data.id},{location: 'replace'});
                            }, function () {
                                $scope.isSave = false;
                                vm.loading = false;
                                swal({
                                    title: $translate.instant("editorMessage.saveError"),
                                    text: $translate.instant("editorMessage.saveError1"),
                                    imageUrl: Theme.sweetHintImg(),
                                    timer: 2000,
                                    showConfirmButton: false
                                });
                            })
                        }
                    }, function () {
                        $scope.isSave = false;
                        vm.loading = false;
                        swal({
                            title: $translate.instant("editorMessage.saveError"),
                            text: $translate.instant("editorMessage.saveError1"),
                            imageUrl: Theme.sweetHintImg(),
                            timer: 2000,
                            showConfirmButton: false
                        });
                    })
                }else{
                    vm.loading = false;
                }
            })
        }
        $scope.exitWork = function (e) {
            vm.exitSure = true;
        }
        $scope.exitPageCancel = function (isSave) {
            vm.exitSure = false
            if(isSave){
                $scope.save()
            }
        }
        $scope.exitPage = function () {
            localStorage.removeItem("photoSelectAll");
            if (vm.pid) {
                $(".wrap").show();
                $(".navbar").show();
                $state.go("commoditySelect", {
                    storeId: vm.storeId,
                    pid: vm.pid,
                    vid: vm.vid,
                    aid: vm.aid,
                }, {reload: true,location: 'replace'});
            } else {
                window.location.href = localStorage.getItem('returnurl');
            }
        }
        //像素不足提醒
        vm.imgSize = 150;
        vm.imgDpi = 150;
        StoreWorkEditConfig.storeId({storeId: vm.storeId}, function (res) {
            if(res.status == 200){
                vm.imgSize = res.data.imgSize;
                vm.imgDpi = res.data.imgDpi;
            }
        });
        var throttledResize = angular.throttle(function (item) {
            return pxInsufficient(item, vm.imgSize, vm.imgDpi)
        }, 1000);

        $scope.pxInsufficient = function (item) {
            // return throttledResize(item);
            return pxInsufficient(item, vm.imgSize, vm.imgDpi);
        }
        //边框
        $scope.imageboxW = function (imagebox) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.geometry.width) + Number(imagebox.border.lineWidth) * 2
                }
                if (imagebox.border.type == 'Pic') {
                    return imagebox.geometry.width
                    // return Number(imagebox.geometry.width) + (Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100) + (Number(imagebox.geometry.width) * Number(imagebox.border.edge.right) / 100)
                }
            } else {
                return imagebox.geometry.width
            }
        }
        $scope.imageboxH = function (imagebox) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.geometry.height) + Number(imagebox.border.lineWidth) * 2
                }
                if (imagebox.border.type == 'Pic') {
                    return imagebox.geometry.height
                    // return Number(imagebox.geometry.height) + (Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100) + (Number(imagebox.geometry.height) * Number(imagebox.border.edge.bottom) / 100)
                }
            } else {
                return imagebox.geometry.height
            }
        }
        $scope.imageboxL = function (imagebox) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.geometry.x) - Number(imagebox.border.lineWidth)
                }
                if (imagebox.border.type == 'Pic') {
                    return imagebox.geometry.x
                    // return Number(imagebox.geometry.x) - (Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100)
                }
            } else {
                return imagebox.geometry.x
            }
        }
        $scope.imageboxT = function (imagebox) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.geometry.y) - Number(imagebox.border.lineWidth)
                }
                if (imagebox.border.type == 'Pic') {
                    return imagebox.geometry.y
                    // return Number(imagebox.geometry.y) - (Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100)
                }
            } else {
                return imagebox.geometry.y
            }
        }
        $scope.imageboxWEdge = function (imagebox, edge) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.border.lineWidth)
                }
                if (imagebox.border.type == 'Pic') {
                    if (edge == 'left') {
                        return Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100
                    }
                    if (edge == 'top') {
                        return Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100
                    }
                    if (edge == 'right') {
                        return Number(imagebox.geometry.width) * Number(imagebox.border.edge.right) / 100
                    }
                    if (edge == 'bottom') {
                        return Number(imagebox.geometry.height) * Number(imagebox.border.edge.bottom) / 100
                    }
                }
            } else {
                return 0
            }
        }
        $scope.imageboxWRadius = function (imagebox, radius, ratio, ratio1) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                var _ratio = 1;
                if(ratio && ratio1){
                    if(imagebox.geometry.width > imagebox.geometry.height){
                        _ratio = ratio1
                    }else{
                        _ratio = ratio
                    }
                }
                if(ratio && !ratio1){
                    _ratio = ratio
                }
                if (imagebox.border.shape == 'Ellipse') {
                    return '50%'
                }
                if (imagebox.border.radius.filletType == 'Fixed') {//圆角固定值
                    var _radius = imagebox.border.radius[radius];
                    return _radius > 0 ?  (_radius + Number(imagebox.border.lineWidth)/2) * _ratio : 0;
                }else{
                    var radiusW = imagebox.geometry.width > imagebox.geometry.height ? imagebox.geometry.height : imagebox.geometry.width;
                    radiusW = radiusW + imagebox.border.lineWidth;
                    var _r = radiusW * imagebox.border.radius[radius] / 100;
                    return _r > 0 ? (_r + Number(imagebox.border.lineWidth)/2) * _ratio : 0
                }
            } else {
                return 0
            }
        }
        $scope.imageboxWRadius1 = function (imagebox, radius, ratio, ratio1) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                var _ratio = 1;
                if(ratio && ratio1){
                    if(imagebox.geometry.width > imagebox.geometry.height){
                        _ratio = ratio1
                    }else{
                        _ratio = ratio
                    }
                }
                if(ratio && !ratio1){
                    _ratio = ratio
                }
                if (imagebox.border.shape == 'Ellipse') {
                    return '50%'
                }
                if (imagebox.border.radius.filletType == 'Fixed') {//圆角固定值
                    var _radius = imagebox.border.radius[radius];
                    return  (_radius - Number(imagebox.border.lineWidth)/2) > 0 ? (_radius - Number(imagebox.border.lineWidth)/2) * _ratio : 0;
                }else{
                    var radiusW = imagebox.geometry.width > imagebox.geometry.height ? imagebox.geometry.height : imagebox.geometry.width;
                    radiusW = radiusW + imagebox.border.lineWidth;
                    var _r = radiusW * imagebox.border.radius[radius] / 100;
                    return (_r - Number(imagebox.border.lineWidth)/2) > 0 ? (_r - Number(imagebox.border.lineWidth)/2) * _ratio : 0
                }
            } else {
                return 0
            }
        }
        $scope.dropShadow = function(imagebox,ratio,ratio1){
            if (imagebox.shadow == null) {
                return
            }
            var width = $scope.imageboxW(imagebox) * ratio;
            var height =$scope.imageboxH(imagebox) * ratio1;
            return dropShadow(imagebox,width,height)
        }
        $scope.editorPageDialog = function (index,i) {
            vm.editorPageList = [];
            if(vm.pictureType == 'single'){
                vm.editorPageList = vm.data;
                vm.pageIndex = index+i;
            }
            if(vm.pictureType == 'spread'){
                vm.data.forEach(function (data) {
                    data.forEach(function (page) {
                        vm.editorPageList.push(page)
                    })
                })
                vm.pageIndex = index*2+i;
            }
            if(vm.article.editorType == 'PICTURE_PRO' || vm.article.editorType == 'PICTURE_PRO_P'){
                vm.editorDialog1 = true;
            }else{
                vm.editorDialog = true;
                vm.levelIndex = 0;
            }

        }
        $scope.pagePhotoCb = function (text){
            vm.editorDialog1 = false;
            if(text){
                if(vm.pictureType == 'single'){
                    vm.data[vm.pageIndex] = JSON.parse(JSON.stringify(text))
                }
                if(vm.pictureType == 'spread'){
                    var i=0;
                    var a = -1;
                    vm.data.forEach(function (data,index) {
                        if(a == -1){
                            for(var j=0;j<2;j++){
                                if(i == vm.pageIndex){
                                    a = index;
                                    data[j] = JSON.parse(JSON.stringify(text))
                                    if(j === 0){
                                        if(data[0].outlineSpread){
                                            data[1].outline = data[0].outlineSpread
                                        }else if(!data[0].outline){
                                            data[1].outline = null
                                        }
                                    }
                                    break
                                }
                                i++
                            }
                        }
                    })
                }
                photosNum();
            }
            ondragenter();
        }

        $scope.zfInit = function(){
            if (vm.pageIndex % 2 === 0){
                return false
            } else if (vm.pageIndex % 2 === 1){
                return true
            }
        }
        //图片框缩放
        window.bbimg = function (delta) {
            if (!vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex] || vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.bokehtype != 'None') {
                return
            }
            var _image = angular.copy(vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image);
            if (delta < 0 || delta == undefined && event.wheelDelta > 0) {
                vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.scale *= 1.01;
            } else {
                vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.scale /= 1.01;
                if (vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.scale <= 1) {
                    vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.scale = 1;
                }
            }
            ImageboxCb(_image, vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox, vm.data[vm.pageIndex]);
            $scope.$apply();
            return false;
        };
        //图片框的操作
        $scope.imageboxSite = function (item) {
            if (!vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex] || vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.bokehtype != 'None') {
                return
            }
            var _imagebox = vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox;
            if(item == 'center'){
                _imagebox.image.offsetx = -(_imagebox.image.width*_imagebox.image.scale - _imagebox.geometry.width)/2/_imagebox.image.scale;
                _imagebox.image.offsety = -(_imagebox.image.height*_imagebox.image.scale - _imagebox.geometry.height)/2/_imagebox.image.scale;
            }
            if(_imagebox.image.offsetx > 0){
                _imagebox.image.offsetx = 0;
            }
            if(_imagebox.image.offsety > 0){
                _imagebox.image.offsety = 0;
            }
        }
        vm.isWatchName = false;
        $scope.watchGalleryName = function(state){
            vm.isWatchName = state;
            // setTimeout(function () {
            //     waterFallPic('main5');
            //     $(".photo-imgs").height($scope.photoHight);
            // }, 200);
        }

        $('#navId').on('scroll', function(event){
            if(vm.nav=='picture'){
                var realScrollHeight=event.currentTarget.clientHeight+event.currentTarget.scrollTop;
                if($scope.photos.length < vm.totalPhotoItems){
                    if((event.currentTarget.scrollHeight-1)<realScrollHeight && realScrollHeight < (event.currentTarget.scrollHeight+1)){
                        vm.indexNum++;
                        if(vm.folderId){
                            loadAll(vm.folderId);
                        } else {
                            loadAll('isNull');
                        }
                    }
                }
            }
        });
        //拖拽图片
        ondragenter();
        function ondragenter(){
            $timeout(function () {
                var content = $(".editor-photo-body")[0]
                if(content){
                    content.ondragenter = ignoreDrag;
                    // 拖动文件的鼠标指针位置放置区之上时发生
                    content.ondragover = ignoreDrag;
                    content.ondrop = drop;
                }
            },1000)

            window.dragStart = function (event) {
                var target = event.target;
                event.dataTransfer.setData("img", target.id);
                $timeout(function () {
                    if(target.id.indexOf('dragtargetPhoto')>-1){
                        vm.dragDom = true;
                    }
                    if(target.id.indexOf('reservePage')>-1){
                        vm.dragDom1 = true;
                    }
                })
            };
            window.dragOn = function(event){
                $timeout(function () {
                    vm.dragDom = false;
                    vm.dragDom1 = false;
                    $(".imageboxView").removeClass('selected-blue')
                    $(".c-page-view-li-img").removeClass('selected-blue');
                })
            }
            $timeout(function () {
                document.body.ondrop = function(event) {
                    event.preventDefault();
                    event.stopPropagation();
                };
            })
        }
        function ignoreDrag(e) {
            // 确保其他元素不会取得该事件
            e.stopPropagation();
            e.preventDefault();
            var dataset = e.target.dataset;
            if ((vm.dragDom && (e.target.nodeName == 'IMG' || ($(e.target).attr('class') && $(e.target).attr('class').indexOf('image-placeholder-class') > -1))&&dataset.imgindex) || (vm.dragDom1 && $(e.target).parents(".c-page-view-li-img"))) {
                var textIndex = dataset.imgindex;
                if(vm.dragDom){
                    $(".imageboxView").removeClass('selected-blue')
                    var pageIndex2 = $(e.target).parents('.c-page-view-li-img').attr('page-index2');
                    $(".imageboxView"+pageIndex2+textIndex).addClass('selected-blue');
                    return
                }
                if(vm.dragDom1){
                    $(".c-page-view-li-img").removeClass('selected-blue');
                    $(e.target).parents(".c-page-view-li-img").addClass('selected-blue');
                    return
                }
            }else{
                $(".imageboxView").removeClass('selected-blue')
                $(".c-page-view-li-img").removeClass('selected-blue');
            }
        }
        vm.replacePageIndex = 0;
        vm.replacePageArrIndex = 0;
        vm.replaceTextIndex = 0;
        vm.replacePageIndex2 = 0;
        function drop(e) {
            var data = e.dataTransfer.getData("img");
            $timeout(function () {
                $(".imageboxView").removeClass('selected-blue');
                $(".c-page-view-li-img").removeClass('selected-blue');
                if(vm.dragDom){
                    var _pageArrIndex = $(e.target).parents('.c-page-view-li-img').attr('data-pageArrIndex');
                    var _pageIndex = $(e.target).parents('.c-page-view-li-img').attr('data-pageIndex');
                    var _pageIndex2 = $(e.target).parents('.c-page-view-li-img').attr('page-index2');
                    var dataset = e.target.dataset;
                    var textIndex = dataset.imgindex;
                    vm.replacePageIndex = _pageIndex;
                    vm.replacePageArrIndex = _pageArrIndex;
                    vm.replaceTextIndex = textIndex;
                    vm.replacePageIndex2 =_pageIndex2;
                    if(!_pageIndex && !_pageIndex2){
                        return
                    }
                    ignoreDrag(e);
                    //拖拽图片进入占位框
                    if (data.indexOf('dragtargetPhoto') != '-1') {
                        var imgindex = e.target.dataset.imgindex;
                        if(imgindex == null){
                            return
                        }else {
                            vm.levelIndex = imgindex;
                            var item = JSON.parse($('#' + data).attr('data-item'));
                            replaceImagebox(item, vm.data);
                            $timeout(function () {
                                photosNum();
                            })
                        }
                    }
                }
                if(vm.dragDom1){
                    var item = JSON.parse($('#' + data).attr('data-item'));
                    var pageIndex = $(e.target).parents('.c-page-view-li-img').attr('data-pageArrIndex');
                    var pageNumber = $(e.target).parents('.c-page-view-li-img').attr('data-pageindex') || null;
                    layoutCb(item, pageIndex, pageNumber)
                }
            })
        }

        function replaceImagebox(item,data){
            var item = angular.copy(item);
            if(vm.pictureType == 'single'){
                var _imagebox = data[vm.replacePageIndex2].levels.level[vm.replaceTextIndex].imagebox;
            }else{
                var _imagebox = data[vm.replacePageArrIndex][vm.replacePageIndex].levels.level[vm.replaceTextIndex].imagebox;
            }
            if(!_imagebox.bokehtype){
                _imagebox.bokehtype = 'None';
            }
            _imagebox.whiteInk = null;
            _imagebox.whiteInk2 = null;
            _imagebox.image = {
                resource: {
                    identifier: item.identifier,
                    provider: 'qiniu'
                },
                filterResource: {
                    identifier: '',
                    provider: 'qiniu'
                },
                offsetx:0,
                offsety:0,
                resourceid:item.sourceId,
                width: item.width,
                height: item.height,
                imageInfo: item.imageInfo,
                imgSize: item.imgSize,
                index: item.seq,
                parameter: angular.fromJson(item.parameter),
                scale: 1,
                angle: 0,
            }
            if(vm.pictureType == 'single'){
                getBlurredrectangle(_imagebox,0)
            }else{
                getBlurredrectangle(_imagebox,vm.replacePageIndex)
            }
        }

        //生成封面图
        function thumbnailInit1(callback) {
            $timeout(function (){
                html2canvas_adapt(document.getElementById('thumbnail-view1'), {
                    onrendered: function (canvas) {
                        QiniuToken.uploadThumbnail(canvas, function (data) {
                            var identifier = data.key;
                            vm.article.covered=true;
                            vm.article.cover=identifier;
                            if(callback){callback()};
                        });
                    },
                    letterRendering: true,
                    useCORS: true,
                    width: vm.pageWidth * vm.ratio,
                    height: vm.pageHeight * vm.ratio,
                    windowWidth: document.body.scrollWidth,
                    windowHeight: document.body.scrollHeight,
                    x: 0,
                    y: 0,
                    backgroundColor: "rgba(0, 0, 0, 0)"
                });
            })
        }

        /***********************  版式  ****************************/
        function layoutCb(item, pageIndex, pageNumber){
            vm.loading = true;
            var layoutPage = angular.copy(item);
            layoutPage.backup = false;
            layoutPage.unreplace = false;
            pageDataInfo(layoutPage,pageIndex,pageNumber)
        }
        function pageDataInfo(page, pageIndex,pageNumber) {
            if(vm.pictureType == 'spread'){
                var _pageData = angular.copy(vm.data[pageIndex][pageNumber]);
            }else{
                var _pageData = angular.copy(vm.data[pageIndex]);
            }
            var _pageDataImageboxImage = [];
            var _pageDataImageboxImageSum = 0;
            for(var i=0; i<_pageData.levels.level.length; i++){
                var _lecel = _pageData.levels.level[i];
                if(_lecel.imagebox && _lecel.imagebox.image && _lecel.imagebox.image.resource && _lecel.imagebox.image.resource.identifier){
                    _lecel.imagebox.imgRatio = _lecel.imagebox.image.width/_lecel.imagebox.image.height;
                    _pageDataImageboxImage.push(_lecel.imagebox)
                }
            }
            if(!page.levels.level){
                page.levels.level=[];
            }
            _pageDataImageboxImage = imageboxAdapt(page.levels.level, _pageDataImageboxImage);
            angular.forEach(page.levels.level, function (level, i) {
                if (level.imagebox) {
                    var _imagebox = _pageDataImageboxImage[0];
                    for(var j=0; j<_pageDataImageboxImage.length; j++){
                        if(_pageDataImageboxImage[j].imageboxIndex == _pageDataImageboxImageSum){
                            _imagebox = _pageDataImageboxImage[j];
                            break
                        }
                    }
                    _pageDataImageboxImageSum++;
                    if (_imagebox) {
                        level.imagebox.bokehtype = level.imagebox.bokehtype || vm.article.bokehtype || 'None';
                        level.imagebox.image = {
                            blurredrectangle: {
                                width: 0,
                                height: 0,
                                x: 0,
                                y: 0
                            },
                            resource: {
                                identifier: _imagebox ? _imagebox.image.resource.identifier : '',
                                provider: _imagebox ? _imagebox.image.resource.provider : 'qiniu'
                            },
                            resourceid:_imagebox ? _imagebox.image.resourceid : '',
                            filterResource: {
                                identifier: '',
                                provider: 'qiniu'
                            },
                            angle: 0,
                            offsetx: 0,
                            offsety: 0,
                            imageInfo: _imagebox? _imagebox.image.imageInfo : '',
                            width: _imagebox ? _imagebox.image.width : '',
                            height: _imagebox ? _imagebox.image.height : '',
                            imgSize: _imagebox ? _imagebox.image.imgSize : '',
                            index: _imagebox ? _imagebox.image.seq : '',
                            parameter: _imagebox ? angular.fromJson(_imagebox.image.parameter) : [],
                            scale: 1
                        }
                        if (level.imagebox.image.resource.identifier) {
                            getBlurredrectangle(level.imagebox,(pageNumber||0))
                            // addImagebox($http, level.imagebox, function () {})
                            // getBackgroundSource3(level.imagebox, level.imagebox.geometry.width, level.imagebox.geometry.height, level.imagebox.image, level.imagebox.bokehtype, $scope)
                        }
                    } else {
                        level.imagebox.bokehtype = level.imagebox.bokehtype || vm.article.bokehtype || 'None';
                        level.imagebox.image = {
                            resource: {
                                identifier: '',
                                provider: ''
                            },
                            resourceid:"",
                            filterResource: {
                                identifier: '',
                                provider: ''
                            },
                            width: '',
                            height: '',
                            imgSize: '',
                            offsetx: 0,
                            offsety: 0,
                            index: '',
                            parameter: [],
                            scale: 1,
                            angle: 0,
                        }
                    }
                }
            })
            $timeout(function () {
                if(vm.pictureType == 'spread'){
                    vm.data[pageIndex][pageNumber] = page;
                }else{
                    vm.data[pageIndex] = page;
                }
                photosNum();
                vm.loading = false;
                MessageService.success($translate.instant("editorMessage.formatReplacementSucceeded"));
            },200)
        }
        /***********************  版式end  ****************************/


        // 计算图片使用数量
        vm.unusedQuantity = null;
        function unusedQuantity(){
            var galleryIdList = [];
            angular.forEach(vm.data, function (data, i) {
                if(vm.pictureType == 'spread'){
                    angular.forEach(data,function (page) {
                        angular.forEach(page.levels.level, function (level, i) {
                            if(level.imagebox && level.imagebox.image && level.imagebox.image.resourceid) {
                                galleryIdList.push(level.imagebox.image.resourceid)
                            }
                        })
                    })
                }else{
                    angular.forEach(data.levels.level, function (level, i) {
                        if(level.imagebox && level.imagebox.image && level.imagebox.image.resourceid) {
                            galleryIdList.push(level.imagebox.image.resourceid)
                        }
                    })
                }
            })

            var newArr = galleryIdList.filter(function(item,index){
                return galleryIdList.indexOf(item) === index;  // 因为indexOf 只能查找到第一个
            });
            Gallery.unUsed({
                galleryIdList:newArr,
                folderId: vm.folderId,
                articleId: (vm.article.articleId || vm.article.id)
            },function (res) {
                if(res.status == 200){
                    vm.unusedQuantity = res.data;
                    getGallery();
                }
            })
        }
        // 切换未使用tab后数量不够分页加载下一页
        function getGallery(){
            if(vm.photosTab!='all' && $scope.photos.length < vm.totalPhotoItems){
                var _photoQuantity = 0;
                $scope.photos.forEach(function (item) {
                    if(item.usenum==0||!item.usenum){
                        _photoQuantity++
                    }
                })
                if(_photoQuantity < vm.itemsPerPage){
                    vm.indexNum++;
                    if(vm.folderId){
                        loadAll(vm.folderId);
                    }else{
                        loadAll('isNull');
                    }
                }
            }
        }
        // websocket接收上传的图片（多端互通实时更新）
        function websocket(){
            var urlws = vm.platformSetting.editorNotifyUrl.split("://")[1];
            urlws = urlws.split("/")[0];
            var ws = $websocket("wss://"+ urlws +"/widget/ws/websocket?uid=Gallery"+(vm.article ? (vm.article.articleId || vm.article.id) : vm.articleId));

            ws.onOpen(function() {
            });

            ws.onMessage(function(message) {
                var photo = JSON.parse(message.data);
                if (photo.folderId == vm.folderId || (photo.folderId == null && vm.folderId == '')) {
                    var len = $scope.photos.length;
                    photo.identifier = $scope.domain + photo.identifier;
                    photo.select = false;
                    photo.index = len;
                    photo.usenum = 0;
                    photo.type = 'picture';
                    // $scope.photos.unshift(photo);
                    var _photo = null;
                    for (var i = 0; i < $scope.photos.length; i++) {
                        if ($scope.photos[i].id == photo.id) {
                            _photo = $scope.photos[i];
                            break;
                        }
                    }
                    if ((!photo.largeFlag && !_photo) || (photo.largeFlag && photo.largeStatus == 'done' && !_photo)) {
                        vm.unusedQuantity++;//增加未使用数
                        vm.totalPhotoItems++;
                        $scope.photos.unshift(photo);
                    }
                    if (_photo) {
                        _photo.largeStatus = photo.largeStatus;
                        if(_photo.convertFlag){
                            _photo.convertStatus = photo.convertStatus;
                            _photo.identifier =  photo.identifier;
                        }
                        // 状态可能由处理中变为失败，已被选中的要即时踢出
                        syncGallerySelection();
                    }
                    if (vm.photoSort != 1 && vm.minId==null) {
                        vm.minId = photo.id;
                    }
                }
            });

            ws.onError(function(error) {
                console.log('WebSocket错误：', error);
            });

            ws.onClose(function() {
                console.log('WebSocket连接已关闭');
            });
        }

        $scope.getTotalCountText = getTotalCountText;
        function getTotalCountText(){
            var num = getTotalCount();
            var expectPageCount = vm.article ? vm.article.expectPageCount : 0;
            var text = '';
            if(vm.article){
                if (vm.article.expectPageCount>1) {
                    text = num + ' / ' + expectPageCount;
                } else {
                    text = num;
                }
            }
            return text;
        }

        function getTotalCount(){
            var num = 0;
            if (vm.pictureType == 'spread') {
                vm.data.forEach(function(page){
                    if (page[0].quantity) {
                        num += Number(page[0].quantity);
                    }
                })
            }else {
                vm.data.forEach(function(page){
                    if (page.quantity) {
                        num += Number(page.quantity);
                    }
                })
            }
            return num;
        }
        // 是否大图
        $scope.isLarge = function(imageInfo){
            if(!imageInfo)return
            return imageInfo.size >= 20971520 || imageInfo.width > 30000 || imageInfo.height > 30000 || (imageInfo.width*imageInfo.height)>150000000
        }
        vm.chooseMenuStyle = false;
        $scope.showChooseMenu = function() {
            vm.chooseMenuStyle = true;
        };
        $scope.hideChooseMenu = function() {
            vm.chooseMenuStyle = false;
        };
        $scope.ifCopyBack = function(index) {
            var _r = vm.pictureType == 'spread' && !vm.isCopyBack && (vm.article.editorType == 'PICTURE_PRO' || vm.article.editorType == 'PICTURE_PRO_P')
            if(vm.data && vm.data[index] && vm.data[index][1] && vm.data[index][1].levels && vm.data[index][1].levels.level && vm.data[index][1].levels.level.length > 0){
                for(var i=0;i<vm.data[index][1].levels.level.length;i++){
                    var level = vm.data[index][1].levels.level[i];
                    if(level.imagebox && (!level.imagebox.image || !level.imagebox.image.resource || !level.imagebox.image.resource.identifier)){
                        _r = false;
                        break
                    }
                }
            }
            return _r;
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('editorApp')
        .controller('EditorPhotoAlbumController', EditorPhotoAlbumController)
        .filter('reverse', function() {
            return function(items) {
                if(items){
                    return items.slice().reverse();
                }
            };
        });
    EditorPhotoAlbumController.$inject = ['$scope', 'FontManagement', 'MessageService', '$stateParams', '$q', 'ModulesService','ListService',
    'ThemeClassify', 'ProductXml', 'Store', 'PlatformWechatSetting','Qinius','QiniuToken','Folder','$uibModal', 'Gallery', '$localStorage', 'Material', 'ClipArt', 'FontXmlsManger','Backgrounds','Product',
    'ItemValue', 'Convert', '$http', '$timeout', 'FontXmlsFileServes', 'Article', 'entity', '$state', 'SweetAlert', 'Theme','CommonService', 'OrderArticle', 'StoreWorkEditConfig', 'UidService',
        'FrameConfigs','Upload','$rootScope','Algorithm','$translate', 'Principal', '$cookies', 'translationStorageProvider', 'IMAGE_SUPPORTED_MIME','StoreStorages','$websocket','$location'];

    function EditorPhotoAlbumController( $scope, FontManagement, MessageService, $stateParams, $q, ModulesService,ListService,
        ThemeClassify, ProductXml, Store, PlatformWechatSetting,Qinius,QiniuToken,Folder,$uibModal, Gallery, $localStorage, Material, ClipArt, FontXmlsManger,Backgrounds,Product,
      ItemValue, Convert, $http, $timeout, FontXmlsFileServes, Article, entity, $state, SweetAlert, Theme,CommonService,OrderArticle, StoreWorkEditConfig, UidService,
                                         FrameConfigs,Upload,$rootScope,Algorithm,$translate, Principal, $cookies, translationStorageProvider, IMAGE_SUPPORTED_MIME,StoreStorages, $websocket, $location) {
        var vm = this;
        if($stateParams.authorization){
            $localStorage.authenticationToken = $stateParams.authorization;
        };
        $(".navbar").hide();
        $(".save-page").removeClass('hide1');
        $(".wrap").hide();
        var variableDatas = JSON.parse(localStorage.getItem('variableData'));
        $scope.variableTextDatas = vm.variableTextDatas = [];
        $scope.variableBoxDatas=[];
        vm.leftShow = true;//菜单栏隐藏
        vm.rightShow = true;//菜单栏隐藏
        vm.uploadFailedList = [];//上传图片失败的列表
        vm.errorAlertPopup = false;//显示左下角蓝色弹窗
        vm.isEdit = entity.type == 'edit' ? true : false;
        vm.storeId = $stateParams.storeId;
        vm.pid = $stateParams.pid;
        vm.aid = $stateParams.aid;
        vm.articleId = null;//当orderArticle 时有值；
        vm.vid = $stateParams.vid;
        vm.xmlId = $stateParams.xmlId;
        vm.watchSure = false;
        vm.general = false;
        vm.fontXmlList = []
        vm.duplicateList = [] //重复图片
        vm.isDuplicateList = false//重复图片弹框
        vm.supportedMimeTypes = IMAGE_SUPPORTED_MIME;
        if ($localStorage.user != null) {
            vm.userId = $localStorage.user.id
        }
        var saveArticle = $location.search().saveArticle;
        if (saveArticle && vm.pid) {
            $state.go("editorPhotoAlbumEdit", {storeId: vm.storeId, aid: saveArticle},{location: 'replace'});
        }
        $scope.domains = Qinius.getDomain();
        var unsubQiniuToken = QiniuToken.subscribe('get', {}, function (token) {
            vm.token = token;
        });
        $scope.$on('$destroy', unsubQiniuToken);
        vm.platformSetting = PlatformWechatSetting.get();
        vm.store = Store.get({id: vm.storeId});
        vm.photoSelectAll = [];
        vm.elementOn = {
            index:0,
            pageIndex:0,
            name:'',
            item:null
        };
        vm.levelAll=[];
        vm.articleChanged = true;
        vm.maskType='recommend';
        vm.loadAll = loadAll
        //测试时使用
        // $localStorage.lagnuages = ['zh-cn', 'en'];
        $scope.showLagnuages = function(){
            vm.showLagnuages = !vm.showLagnuages;
            if (vm.showLagnuages) {
                $(".lang-icn").css({'transform': 'rotate(270deg)'});
            }else{
                $(".lang-icn").css({'transform': 'rotate(90deg)'});
            }
        }
        lagnuageInit();
        function lagnuageInit() {
            vm.lang = $cookies.getObject("NG_TRANSLATE_LANG_KEY");
            vm.lagnuages =[];
            if ($localStorage.lagnuages) {
                for(var i = 0 ; i<$localStorage.lagnuages.length; i++ ){
                    var lang = $localStorage.lagnuages[i];
                    var result = translationStorageProvider.getLanguageType(lang);
                    if (!!result) {
                        if (vm.lang == result.value) {
                            vm.langKey = result.key;
                            result.selected = true;
                        }
                        vm.lagnuages.push(result);
                    }
                }
            }
        }

        $scope.changeLagnuage = function(lang){
            $timeout(function () {
                if (lang == null || lang.key == vm.langKey ) {
                    return;
                }
                angular.forEach(vm.lagnuages, function(item){
                    item.selected =false;
                });
                lang.selected = true;
                vm.langKey = lang.key;
                $translate.use(lang.value).then(function(){
                    vm.showLagnuages =false;
                    lagnuageInit();
                    navSelect(vm.nav);
                    getProductXmlLine();
                },100)
            })
        }

        $scope.getIndex = function(page){
            var _index = 0;
            for(var i=0; i<vm.pageData.length; i++){
                var _page = vm.pageData[i];
                if(page.config.partid == _page.config.partid){
                    _index+=1;
                    if(_page.uuid == page.uuid){
                        break
                    }
                }
            }
            if (_index < 10) {
                return "0"+ _index;
            }
            return _index;
        }
        $scope.getIndex1 = function(index){
            if(vm.pageData && vm.pageData.length>0){
                var _index = 0;
                for(var i=0; i<vm.pageData.length; i++){
                    var _page = vm.pageData[i];
                    if(_page && _page.config && _page.config.partid == 'P'){
                        _index+=1;
                        if(index == i){
                            break
                        }
                    }
                }
                if (_index < 10) {
                    return "0"+ _index;
                }
                return _index;
            }
        }
        //部件名
        $scope.partNamt = function (partid) {
            var partName = "";
            for(var i=0; i<$scope.template.config.parts.list.length; i++){
                if($scope.template.config.parts.list[i].id == partid){
                    partName = $scope.template.config.parts.list[i].name;
                }
            }
            return partName
        }
        /***************页面处理************start*****************/
        $q.all([$scope.domains.$promise, vm.store.$promise, vm.platformSetting.$promise]).then(function () {
            // token过期 — QiniuToken 单例自动刷新
            vm.platformSetting = vm.platformSetting.data;
            vm.store = vm.store.data;
            $(".navbar").hide();
            $(".save-page").removeClass('hide1');
            $(".wrap").hide();
            $scope.domain = 'https://' + $scope.domains.domains[0] + '/';
            vm.logo = vm.store.menuLogo ? $scope.domain + vm.store.menuLogo : 'content/images/momentsgo.png';

            //获取字体
            FontManagement.getAll({family: ""}, function (res) {
                vm.fontList = angular.copy(res);
                vm.fontList1 = angular.copy(res);
                $scope.item = vm.fontList[0];
                vm.defaultFont = res[0];
                res.forEach(function (item) {
                    if(item.defaultShow){
                        vm.defaultFont = item;
                    }
                })
            });
            vm.windowDpi = js_getDPI();
            //获取数据
            init();
            //获取自定义颜色
            ModulesService.getToneSettings(vm.storeId,function (res) {
                vm.toneSettings = res;
            });
            vm.generalMask=[{
                cancelled: false,
                id: 646,
                resource:{
                    identifier: $scope.domain + "clipArt-d1a8bc1c-53f0-4aa5-cb2b-33ea628866f9",
                },
                identifier: $scope.domain + "clipArt-d1a8bc1c-53f0-4aa5-cb2b-33ea628866f9",
                name: $translate.instant("nav.mask.content.圆形蒙版"),
                opened: true,
                provider: "qiniu",
                themeClassifyId: '',
                themeClassifyName: "",
                type: "masking",
                type1:'round'
            },{
                cancelled: false,
                id: 646,
                resource:{
                    identifier: $scope.domain + "material-9c6fd5de-f1b0-48c5-996e-2eb5758f19cc",
                },
                identifier: $scope.domain + "material-9c6fd5de-f1b0-48c5-996e-2eb5758f19cc",
                name: $translate.instant("nav.mask.content.方形蒙版"),
                opened: true,
                provider: "qiniu",
                themeClassifyId: '',
                themeClassifyName: "",
                type: "masking",
                type1: "square",
            }]
        }).catch(function(error){
            console.log(error,"err")
        });

        /***********************  编辑区域  ****************************/
        var productId = null;
        function init(){
            vm.threeLoading = true;
            if(vm.pid){
                Article.getByUser({id: $stateParams.aid}, function (resp) {
                    if (resp.status == 200) {
                        vm.article = resp.data;
                        if(vm.article.invalid){//作品失效
                            $state.go('articlesFailure',{storeId:vm.storeId},{location: 'replace'});
                            return
                        }

                        websocket();
                        getProduct(function () {
                            CommonService.setDocumentTitle((vm.article.name || vm.article.productXmlName)+'-'+$translate.instant("title"));
                            ItemValue.get({id: vm.vid}, function (res) {
                                vm.bindingtype = res.data.bindingType;
                                $scope.status = localStorage.getItem('Production');
                                vm.productXmlLine = angular.copy(res.data.productXmlLines[0]);
                                angular.forEach(res.data.productXmlLines,function (line) {
                                    if(line.id==vm.xmlId){
                                        vm.productXmlLine = angular.copy(line);
                                    }
                                });
                                vm.article.modelBlendentUuid = vm.productXmlLine.modelBlendentUuid;
                                vm.article.cover = vm.productXmlLine.coverImg;
                                vm.article.themeClassifyId = vm.productXmlLine.productXmlThemeId;
                                vm.article.themeClassifyName = vm.productXmlLine.productXmlThemeName;
                                vm.article.productXmlId = vm.productXmlLine.productXmlId;
                                vm.article.productXmlName = vm.productXmlLine.productXmlName;
                                vm.article.musicIdentify = vm.productXmlLine ? vm.productXmlLine.musicIdentify : res.data.musicIdentify;
                                vm.article.editorType= res.data.productEditorType;
                                vm.article.itemValueId= res.data.itemValueId || vm.vid;
                                if(!res.data.productBokehType){
                                    vm.article.bokehtype='None';
                                }else{
                                    vm.article.bokehtype=res.data.productBokehType;
                                }
                                var result = ListService.inList(vm.article, variableDatas, ["productXmlId"]);
                                if(result&&result.data&&result.data.length){
                                    angular.forEach(result.data,function (va,i) {
                                        if(va.type=='text'){
                                            $scope.variableTextDatas.push(va);
                                            vm.variableTextDatas.push(va);
                                        }
                                        if(va.type=='box'){
                                            $scope.variableBoxDatas.push(va)
                                        }
                                    })
                                }

                                Convert.xmlToDocument2({
                                    identifier: vm.productXmlLine?vm.productXmlLine.productXmlIdentifier:res.productXmlIdentifier,
                                    provider: "qiniu",
                                    editorType:vm.article.editorType,
                                    patternType:vm.product.patternType,
                                }, function (resp) {
                                    setUuid(resp);
                                    vm.counts = 0;
                                    $scope.pages = resp;
                                    if($scope.pages.config.productType == 'CALENDAR'&&$scope.pages.config.dynamic){
                                        vm.isCalendar = true;
                                    }
                                    productId = vm.pid;
                                    vm.pageSize = [];
                                    resp.pages.page.forEach(function(page){
                                        if(page.levels && page.levels.level && page.levels.level.length>0){
                                            page.levels.level.sort(compare('seq', true));
                                        }
                                        var o = {
                                            width:page.mediabox.width,
                                            height:page.mediabox.height
                                        }
                                        vm.pageSize.push(o);
                                    })
                                    angular.forEach(resp.pages.page, function (page, i) {
                                        angular.forEach(page.levels.level,function (level) {
                                            if(level.imagebox&&level.imagebox.geometry){
                                                vm.counts++;
                                            }
                                        })
                                    });
                                    abook(resp,function () {
                                        yearInfo()
                                    });
                                    templateInit();
                                    loadAll('isNull');
                                    //获取照片文件夹
                                    loadFolders();
                                });
                            },function (error) {
                                if(error.data.status === 403){//未授权
                                    $state.go('404',{storeId:vm.storeId},{location: 'replace'});
                                }
                            });
                        })
                    }
                },function(error){
                    if(error.status === 403){//token失效
                        return $state.go('404',{storeId:vm.storeId},{location: 'replace'});
                    }
                    if(error.data.status === 404){//未找到作品
                        $state.go('404',{storeId:vm.storeId,tips:error.data.message},{location: 'replace'});
                    }
                    if(error.data.status === 410){//作品编辑器失效
                        $state.go('404',{storeId:vm.storeId,tips:'编辑器失效'},{location: 'replace'});
                    }
                })
            }else {
                vm.counts = 0;
                if($stateParams.aid){
                    Article.getByUser({id: $stateParams.aid}, function (res) {
                        vm.article = res.data;
                        if(vm.article.invalid){//作品失效
                            $state.go('articlesFailure',{storeId:vm.storeId},{location: 'replace'});
                            return
                        }

                        websocket();
                        getProductXmlLine(function () {
                            CommonService.setDocumentTitle((vm.article.name || vm.article.productXmlName)+'-'+$translate.instant("title"));
                            productId = res.data.productId;
                            Convert.xmlToDocument2({
                                identifier: res.data.fileName,
                                provider: 'qiniu',
                                editorType:vm.article.editorType,
                                patternType:vm.product.patternType,
                            }, function (resp) {
                                setUuid(resp);
                                vm.pageSize = [];
                                resp.pages.page.forEach(function(page){
                                    if(page.levels && page.levels.level && page.levels.level.length>0){
                                        page.levels.level.sort(compare('seq', true));
                                    }
                                    var o = {
                                        width:page.mediabox.width,
                                        height:page.mediabox.height
                                    }
                                    vm.pageSize.push(o);
                                })
                                angular.forEach(resp.pages.page, function (page, i) {
                                    angular.forEach(page.levels.level, function (level) {
                                        if (level.imagebox && level.imagebox.geometry) {
                                            vm.counts++;
                                        }
                                    })
                                });
                                abook(resp,function () {
                                    if($scope.template && $scope.template.config && $scope.template.config.productType == 'CALENDAR' && $scope.template.config.dynamic){
                                        vm.yearIndex=$scope.template.config.startYear;
                                        vm.monthIndex=$scope.template.config.startMonth;
                                        $scope.template.pages.page.forEach(function (page) {
                                            if(vm.monthIndex1 < page.config.monthIndex){
                                                vm.monthIndex1 = page.config.monthIndex
                                            }
                                        })
                                    }
                                });
                                loadAll('isNull');
                                //获取照片文件夹
                                loadFolders();
                            },function(error){
                                if(error.data.status === 403){//未授权
                                    $state.go('404',{storeId:vm.storeId},{location: 'replace'});
                                }
                            });
                            templateInit();
                        });
                    },function(error){
                        if(error.status === 403){//token失效
                            return $state.go('404',{storeId:vm.storeId},{location: 'replace'});
                        }
                        if(error.data.status === 404){//未找到作品
                            $state.go('404',{storeId:vm.storeId,tips:error.data.message},{location: 'replace'});
                        }
                        if(error.data.status === 410){//作品编辑器失效
                            $state.go('404',{storeId:vm.storeId,tips:'编辑器失效'},{location: 'replace'});
                        }
                    })
                }else if($stateParams.orderArticleId){
                    OrderArticle.getByUser({id: $stateParams.orderArticleId}, function (res) {
                        vm.article = res.data;
                        if(vm.article.invalid){//作品失效
                            $state.go('articlesFailure',{storeId:vm.storeId},{location: 'replace'});
                            return
                        }

                        websocket();
                        getProductXmlLine(function () {
                            CommonService.setDocumentTitle((vm.article.name || vm.article.productXmlName)+'-'+$translate.instant("title"));
                            productId = res.data.productId;
                            vm.articleId = res.data.articleId;
                            loadAll('isNull');
                            //获取照片文件夹
                            loadFolders();
                            Convert.xmlToDocument2({
                                identifier: res.data.fileName,
                                provider: 'qiniu',
                                editorType:vm.article.editorType,
                                patternType:vm.product.patternType,
                            }, function (resp) {
                                setUuid(resp);
                                vm.pageSize = [];
                                resp.pages.page.forEach(function(page){
                                    if(page.levels && page.levels.level && page.levels.level.length>0){
                                        page.levels.level.sort(compare('seq', true));
                                    }
                                    var o = {
                                        width:page.mediabox.width,
                                        height:page.mediabox.height
                                    }
                                    vm.pageSize.push(o);
                                })
                                angular.forEach(resp.pages.page, function (page, i) {
                                    angular.forEach(page.levels.level, function (level) {
                                        if (level.imagebox && level.imagebox.geometry) {
                                            vm.counts++;
                                        }
                                    })
                                });
                                abook(resp,function () {
                                    if($scope.template && $scope.template.config && $scope.template.config.productType == 'CALENDAR' && $scope.template.config.dynamic){
                                        vm.yearIndex=$scope.template.config.startYear;
                                        vm.monthIndex=$scope.template.config.startMonth;
                                        $scope.template.pages.page.forEach(function (page) {
                                            if(vm.monthIndex1 < page.config.monthIndex){
                                                vm.monthIndex1 = page.config.monthIndex
                                            }
                                        })
                                    }
                                });
                            },function (error) {
                                if(error.data.status === 403){//未授权
                                    $state.go('404',{storeId:vm.storeId},{location: 'replace'});
                                }
                            });
                            templateInit();
                        });
                    },function(error){
                        if(error.status === 403){//token失效
                            return $state.go('404',{storeId:vm.storeId},{location: 'replace'});
                        }
                        if(error.data.status === 404){//未找到作品
                            $state.go('404',{storeId:vm.storeId,tips:error.data.message},{location: 'replace'});
                        }
                        if(error.data.status === 410){//作品编辑器失效
                            $state.go('404',{storeId:vm.storeId,tips:'编辑器失效'},{location: 'replace'});
                        }
                    })
                }
            }
        }
        function setUuid(document) {
            if(document && document.backupPages && document.backupPages.list){
                document.backupPages.list.forEach(function (page) {
                    page.pageUuid = getUuid();
                })
            }
            if(document && document.pages && document.pages.page){
                document.pages.page.forEach(function (page) {
                    page.pageUuid = getUuid();
                })
            }
        }
        function demoPage() {
            $scope.template.config = {
                "innerOffset":1,
                "parts":{
                    "list":[
                        {
                            "counter":1,
                            "id":"B1",
                            "mediabox":{
                                "height":200,
                                "invisible":false,
                                "width":200,
                                "x":0,
                                "y":0
                            },
                            "name":"封面",
                            "required":false,
                            "seq":3,
                            "spread": false,
                            "custom": false
                        },
                        {
                            "counter":10,
                            "id":"P",
                            "name":"内页",
                            "required":false,
                            "seq":5,
                            "spread": false,
                            "custom": false
                        },
                        {
                            "counter":1,
                            "id":"B2",
                            "name":"封底",
                            "required":false,
                            "seq":9,
                            "spread": false,
                            "custom": false
                        }
                    ]
                },
                "productType":"BOOK",
                "lastCustomSeq": 10
            };
            $scope.template.pages.page.forEach(function(page,index){
                page.config={
                    "dynamic":false,
                    "monthIndex":0,
                    "monthMultiple":false,
                    "partid":'P'
                }
                if(index == 0){
                    page.config.partid = 'B1';
                }
                if(index == $scope.template.pages.page.length-1){
                    page.config.partid = 'B2';
                }
            })
        }
        function getProduct(callback) {
            Product.get({id: vm.article.productId, cancelled: false}, function (res) {
                vm.product = res.data;
                vm.productTitle = res.data.name;
                if(callback){callback()}
            })
        }
        function getProductXmlLine(callback){
            ItemValue.get({id: vm.article.itemValueId}, function (res) {
                vm.bindingtype = res.data.bindingType;
                angular.forEach(res.data.productXmlLines, function (line) {
                    if (line.productXmlId == vm.article.productXmlId) {
                        vm.productXmlLine = angular.copy(line);
                    }
                });
                getProduct(function () {
                    if(callback){callback()}
                });
            })
            fontuuid();
        }
        vm.windowH = window.innerHeight - 92;
        vm.windowW = window.innerWidth - 460;
        vm.windowW1 = 150;//设置右侧缩略图大小
        vm.cookies=[];
        vm.cookieIndex = 0;
        vm.pageNumber = 0;
        vm.picLayoutXmlsList = [];
        function abook(obj,callback) {
            vm.article.xml = obj;
            if(vm.article.xml.piclayouts&&vm.article.xml.piclayouts.piclayout){
                vm.picLayoutXmlsList = ModulesService.setLayoutQuantity(vm.article.xml.piclayouts.piclayout);
                vm.picLayoutXmlGroup = vm.picLayoutXmlsList[0];
            }
            productXmlGet()
            if(vm.isEdit){
                $scope.template = angular.copy(obj);
            }else {
                $scope.template = angular.copy($scope.pages);
            }
            if(!$scope.template.xLines || !$scope.template.xLines.line){
                $scope.template.xLines = {line:[]}
            }
            if(!$scope.template.yLines || !$scope.template.yLines.line){
                $scope.template.yLines = {line:[]}
            }
            reserveInit($scope.template.backupPages.list);
            var _page=angular.copy($scope.template.pages.page);
            $scope.template.pages.page = [];
            _page.forEach(function (page) {
                if(!page.backup){
                    $scope.template.pages.page.push(page);
                }
            })
            documentAnalysis($scope, $http, vm, $scope.template,FontManagement,'other', function(page) {
                ratioInfo(page)
            },function () {
                $timeout(function () {
                    vm.pageData = [];
                    vm.pageData = $scope.template.pages.page;
                    vm.pageSum = $scope.template.pages.page.length - 1;
                    pageDataInit();
                    vm.pageMaxWidth = $scope.template.pages.page[0].custom.width*$scope.template.pages.page[0].custom.ratio;
                    vm.pageMaxHeight = $scope.template.pages.page[0].custom.height*$scope.template.pages.page[0].custom.ratio;
                    $scope.template.pages.page.forEach(function (page) {
                        if(vm.pageMaxWidth<page.custom.width*page.custom.ratio){
                            vm.pageMaxWidth=page.custom.width*page.custom.ratio
                        }
                        if(vm.pageMaxHeight<page.custom.height*page.custom.ratio){
                            vm.pageMaxHeight=page.custom.height*page.custom.ratio
                        }
                    })
                    vm.partid = $scope.template.config.parts.list[0].id;
                    fontSizeInit(vm.pageData[0].trimbox.height);
                    pageListDrag1();
                    reserveQuantity();
                    vm.cookies=[];
                    var _data = angular.copy(vm.pageData[vm.pageNumber]);
                    vm.cookies.push(_data);
                    vm.cookieIndex = 0;
                    vm.threeLoading = false;
                    $timeout(function () {
                        if(!$scope.template.config.dynamic){
                            pageListDrag();
                        }
                        measureRulerInit();
                    },1000)
                    if(callback){callback()}
                    classifyInit('BORDER')//判断边框是否有数据，如果无则不显示边框
                    $scope.$apply();
                },100)
            })
        }
        function recommendInit(template) {
            if(template && template.backupPages && template.backupPages.list && template.backupPages.list.length>0){
                template.backupPages.list.forEach(function (item) {
                    var _page1 = item;
                    getPageType(_page1)
                    _page1.numberOfHoles = 0;
                    backupPagesPartQuantity(item.config.partid);
                    if(_page1.levels && _page1.levels.level && _page1.levels.level.length>0){
                        _page1.levels.level.forEach(function (level){
                            if(level.imagebox && level.imagebox.geometry){
                                _page1.numberOfHoles++;
                            }
                        });
                    }
                })
                template.pages.page.forEach(function (page) {
                    page.numberOfHoles = 0;
                    page.recommendLayout = [];
                    page.levels.level.forEach(function (level){
                        if(level.imagebox && level.imagebox.geometry){
                            page.numberOfHoles++;
                        }
                    });
                    var _page = angular.copy(page);
                    page.recommendLayout.push(_page)
                });
                template.backupPages.list.forEach(function (page) {
                    for(var i=0; i<template.pages.page.length; i++){
                        if(page.uuid != template.pages.page[i].uuid && template.pages.page[i].numberOfHoles === page.numberOfHoles && template.pages.page[i].spread == page.spread && page.config.partid == template.pages.page[i].config.partid){
                            template.pages.page[i].recommendLayout.push(page)
                        }
                    }
                });
            }
        }
        function backupPagesPartQuantity(partid) {
            if($scope.template&&$scope.template.config&&$scope.template.config.parts&&$scope.template.config.parts.list){
                for(var i=0; i<$scope.template.config.parts.list.length; i++){
                    if($scope.template.config.parts.list[i].id == partid){
                        if(!$scope.template.config.parts.list[i].backupPagesQuantity){
                            $scope.template.config.parts.list[i].backupPagesQuantity = 1;
                        }else{
                            $scope.template.config.parts.list[i].backupPagesQuantity++
                        }
                    }
                }
            }
        }
        function pageDataInit() {
            vm.pageIndex = 0;
            vm.templatePages = [];
            var _pageData = vm.pageData;
            var _pageIndex = 0;
            _pageData.forEach(function (page) {
                page.isUse = false;
            })
            _pageData.forEach(function (page, index) {
                if(!page.isUse){
                    _pageIndex++
                    if(page.config.partid == 'P' && vm.product.patternType == "BOOK"){
                        if(page.spread || ($scope.template.config.innerOffset == 1 && $scope.getIndex(page) == 1)){
                            page.isUse = true;
                            page.seq = index;
                            ratioInfo(page,true)
                            vm.templatePages.push({
                                page1:page,
                                page2:null,
                                spread: true,
                                pageIndex: _pageIndex
                            })
                        }else{
                            var _page1 = _pageData[index];
                            var _page2 = index+1 >= _pageData.length ? null : _pageData[index+1];
                            _page1.isUse = true;
                            _page1.seq = index;
                            if(_page2 && !_page2.spread && _page2.config.partid == 'P'){
                                _page2.isUse = true;
                                _page2.seq = index+1;
                                ratioInfo(_page1,false)
                                ratioInfo(_page2,false)
                                vm.templatePages.push({
                                    page1:_page1,
                                    page2:_page2,
                                    spread:false,
                                    pageIndex: _pageIndex
                                })
                            }else{
                                ratioInfo(_page1,true)
                                vm.templatePages.push({
                                    page1:_page1,
                                    page2:null,
                                    spread:true,
                                    pageIndex: _pageIndex
                                })
                            }
                        }
                    }else{
                        page.isUse = true;
                        page.seq = index;
                        ratioInfo(page,true)
                        vm.templatePages.push({
                            page1:page,
                            page2:null,
                            spread: true,
                            pageIndex: _pageIndex
                        })
                    }
                }
            })
            if(vm.pageIndex > vm.templatePages.length){
                vm.pageIndex = vm.templatePages.length-1;
            }
            pageNumberInit()
            magnitudeBox();
        }
        function pageNumberInit() {
            vm.pageNumber1 = -1;
            vm.pageNumber2 = -1;
            vm.pageNumberMax = -1;
            if(vm.templatePages[vm.pageIndex].page1){
                vm.pageNumber1 = vm.pageNumberMax = vm.templatePages[vm.pageIndex].page1.seq;
            }
            if(vm.templatePages[vm.pageIndex].page2){
                vm.pageNumber2 = vm.pageNumberMax = vm.templatePages[vm.pageIndex].page2.seq;
            }
            if (vm.pageData[vm.pageIndex].scene) {
                ratioInfo(vm.pageData[vm.pageIndex])
            }
            if(vm.pageData[vm.pageNumber1]){
                vm.pageData[vm.pageNumber1].custom.ratio = vm.pageData[vm.pageNumber1].custom.ratio2/100 + vm.ratio;
            }
            if(vm.pageData[vm.pageNumber2]){
                vm.pageData[vm.pageNumber2].custom.ratio = vm.pageData[vm.pageNumber2].custom.ratio2/100 + vm.ratio;
            }
            updateMeasureRuler();
        }
        $scope.onRatioinfo = function (){
            if(!vm.pageData[vm.pageIndex].isEditboxMagnify){
                vm.pageData[vm.pageIndex].isEditboxMagnify = true;
                vm.pageData[vm.pageIndex].scene = null;
                ratioInfo(vm.pageData[vm.pageIndex])
            }
        }
        $scope.onRatioinfo1 = function (){
            if(vm.pageData[vm.pageIndex].isEditboxMagnify){
                vm.pageData[vm.pageIndex].isEditboxMagnify = false;
                vm.pageData[vm.pageIndex].scene = vm.pageData[vm.pageIndex].sceneCopy;
                ratioInfo(vm.pageData[vm.pageIndex])
            }
        }
        function ratioInfo(page,spread) {
            vm.windowH = $(document).height() - 210;
            vm.windowW = $(document).width() - 750;
            vm.windowW1 = 230;
            if(!spread){
                vm.windowW = vm.windowW/2;
            }
            if (page.scene) {
                page.custom.width = page.scene.geometry.width;
                page.custom.height = page.scene.geometry.height;
            } else {
                page.custom.width = page.mediabox.width;
                page.custom.height = page.mediabox.height;
            }
            if(vm.windowH / page.custom.height >= vm.windowW / page.custom.width ){
                page.custom.ratio = vm.windowW / page.custom.width;
            }else {
                page.custom.ratio = vm.windowH / page.custom.height;
            }
            page.custom.ratio1 = vm.windowW1 / page.custom.width;
            page.custom.ratio2 = Math.round(Number(page.custom.ratio)*100);
            page.custom.ratio3 = angular.copy(page.custom.ratio2);
            page.custom.thumbnailScale = 300 / page.custom.width;
            updateMeasureRuler()
        }
        function reserveInit(page) {
            vm.reservePage = angular.copy(page) || [];
            vm.reservePage.forEach(function (page) {
                getPageType(page)
            })
        }
        vm.isReservePage = false;
        function reserveQuantity() {
            vm.reservePage.forEach(function (page) {
                page.count = 0;
                $scope.template.pages.page.forEach(function (page1) {
                    if(page.uuid == page1.uuid){
                        page.count++
                    }
                })
            });
            vm.isReservePage = vm.reservePage.some(function (page) {return !page.count});
        }
        function productXmlGet(){
            ProductXml.get({id:vm.article.productXmlId}, function (productXml) {
                vm.productXmlData = productXml.data;
            })
        }
        $scope.pageInfo = function(item){
            vm.pageNumber = item;
            if(!vm.textFont){
                $scope.editorBodyView();
            }
        };
        $scope.previousPage = vm.previousPage = function (e) {
            e.target.blur();
            if(vm.pageNumber1 > 0){
                if (vm.pageData[vm.pageIndex].sceneCopy&&vm.pageData[vm.pageIndex].isEditboxMagnify) {
                    vm.pageData[vm.pageIndex].scene = angular.copy(vm.pageData[vm.pageIndex].sceneCopy);
                    vm.pageData[vm.pageIndex].isEditboxMagnify = false;
                    ratioInfo(vm.pageData[vm.pageIndex])
                }
                thumbnailInit2(vm.pageData[vm.pageIndex],function(){
                    vm.isCut = true;
                    $rootScope.$broadcast('onKeyDownCallback');
                    $timeout(function () {
                        vm.moveCanvasObj = {
                            x:0,
                            y:0
                        };
                        $scope.ratioInit();
                        vm.pageIndex--;
                        pageNumberInit();
                        $scope.template.pages.page = vm.pageData;
                        $scope.editorBodyView();
                        vm.pageNumber = vm.pageNumber1;
                        vm.cookies=[];
                        var _data = angular.copy(vm.pageData[vm.pageNumber]);
                        vm.cookies.push(_data);
                        vm.cookieIndex = 0;
                        vm.isCut = false;
                    })
                })
            }
        }
        $scope.nextPage = vm.nextPage = function (e) {
            e.target.blur();
            if(vm.pageNumberMax > -1 && vm.pageNumberMax < vm.pageSum){
                if (vm.pageData[vm.pageIndex].sceneCopy&&vm.pageData[vm.pageIndex].isEditboxMagnify) {
                    vm.pageData[vm.pageIndex].scene = angular.copy(vm.pageData[vm.pageIndex].sceneCopy);
                    vm.pageData[vm.pageIndex].isEditboxMagnify = false;
                    ratioInfo(vm.pageData[vm.pageIndex])
                }
                thumbnailInit2(vm.pageData[vm.pageIndex],function(){
                    vm.isCut = true;
                    $rootScope.$broadcast('onKeyDownCallback');
                    $timeout(function () {
                        vm.moveCanvasObj = {
                            x:0,
                            y:0
                        };
                        $scope.ratioInit();
                        vm.pageIndex++;
                        pageNumberInit()
                        $scope.template.pages.page = vm.pageData;
                        $scope.editorBodyView();
                        vm.pageNumber = vm.pageNumber1;
                        vm.cookies=[];
                        var _data = angular.copy(vm.pageData[vm.pageNumber]);
                        vm.cookies.push(_data);
                        vm.cookieIndex = 0;
                        vm.isCut = false;
                    })
                })
            }
        }
        $scope.turning = function (index) {
            vm.elementOn = {
                index:"",
                pageIndex:"",
                name:"",
                item:""
            };
            if (vm.pageData[vm.pageIndex].sceneCopy&&vm.pageData[vm.pageIndex].isEditboxMagnify) {
                vm.pageData[vm.pageIndex].scene = angular.copy(vm.pageData[vm.pageIndex].sceneCopy);
                vm.pageData[vm.pageIndex].isEditboxMagnify = false;
                ratioInfo(vm.pageData[vm.pageIndex])
            }
            thumbnailInit2(vm.pageData[vm.pageIndex],function(){
                vm.isCut = true;
                $rootScope.$broadcast('onKeyDownCallback');
                $timeout(function () {
                    vm.moveCanvasObj = {
                        x:0,
                        y:0
                    };
                    $scope.ratioInit();
                    vm.pageNumber = Number(index);
                    vm.templatePages.forEach(function (item, index1) {
                        if(item.page1 && item.page1.seq == index){
                            vm.pageIndex = index1;
                        }
                        if(item.page2 && item.page2.seq == index){
                            vm.pageIndex = index1;
                        }
                    })
                    pageNumberInit();
                    vm.cookies=[];
                    var _data = angular.copy(vm.pageData[vm.pageNumber]);
                    vm.cookies.push(_data);
                    vm.cookieIndex = 0;
                    vm.isCut = false;
                    multiSelect()
                })
            })
        }

        //拖拽排序
        var sort = null;
        var sortArray = [];
        vm.isSort = false;
        function pageListDrag() {
            $timeout(function () {
                vm.sortingPage = angular.copy(vm.pageData);
                sort = new Sortable(document.getElementById('pageList'), {
                    swap: false,
                    filter: '.filtered',
                    cancel: ".notDrag",
                    preventOnFilter: true,
                    animation: 150,
                    scroll:true,
                    onStart: function(evt){
                        vm.sortPartid = vm.pageData[evt.oldIndex].config.partid;
                        vm.pageSpread = vm.pageData[evt.oldIndex].spread;
                    },
                    onMove: function (/**Event*/evt, /**Event*/originalEvent) {
                        $timeout(function () {
                            var order = sort.toArray();
                            vm.pageData.forEach(function (page, index) {
                                if (!(!page.unreplace&&$scope.template.replace&&vm.sortPartid == page.config.partid?true:false)||(vm.pageSpread != page.spread)) {
                                    var _index = order.indexOf((index + 1).toString());
                                    order.splice(_index, 1)
                                }
                            })
                            vm.pageData.forEach(function (page, index) {
                                if (!(!page.unreplace&&$scope.template.replace&&vm.sortPartid == page.config.partid?true:false)||(vm.pageSpread != page.spread)) {
                                    order.splice(index, 0, (index + 1).toString())
                                }
                            })
                            sort.sort(order)
                        },150)
                        var _uuid = $(evt.related).attr("data-page");
                        var _page = getPageUuid(_uuid);
                        if(!(!_page.unreplace&&$scope.template.replace&&vm.sortPartid == _page.config.partid?true:false)||(vm.pageSpread != _page.spread)){
                            return false
                        }
                    },
                    onEnd: function (/**Event*/evt) {
                        $timeout(function () {
                            var _top = angular.copy($('.c-editor-page-pageList').scrollTop());
                            vm.pageListLoading = true;
                            $timeout(function () {
                                sortArray = [];
                                angular.forEach($('#pageList').find(".sortingPageView"), function (item, index) {
                                    var uuid = item.getAttribute("data-page");
                                    var page = getPageUuid(uuid);
                                    sortArray.push(page);
                                });
                                if(sortArray && sortArray.length>0){
                                    sortArray.forEach(function (value, index) {
                                        value.seq = index;
                                        // ratioInfo(value);
                                    })
                                    vm.pageData = [];
                                    $timeout(function () {
                                        vm.pageData = angular.copy(sortArray);
                                        sortArray = [];
                                        $timeout(function () {
                                            $('.c-editor-page-pageList').scrollTop(_top)
                                            vm.pageListLoading = false;
                                            pageListDrag();
                                        },200)
                                    })
                                }
                            },500)
                        })
                    }
                });
            })
        }
        function getPageUuid(uuid) {
            var page = null;
            for(var i=0; i<vm.pageData.length; i++){
                if(vm.pageData[i].pageUuid == uuid){
                    page = angular.copy(vm.pageData[i]);
                    break
                }
            }
            return page
        }
        //mm转px
        function transitionPx(item) {
            return item * vm.windowDpi / 25.4;
        }
        //px转mm
        $scope.transitionMm = transitionMm;
        $scope.editorBodyView = function(e){
            vm.isChangePage1 = false;
            if(e){
                fn(e);
            }
            vm.elementOn = {
                index:"",
                pageIndex:"",
                name:"",
                item:""
            };
            vm.copyArray = {imageboxes: [], textboxes: [], imagearts: [], barcode: [], qrcode: [], textdocuments: [], calTitleBoxs: [], calMonthBoxs: []};
            levelInif();
            toolbarStatus();
            clearCode();
        }

        //拖拽图片
        $timeout(function () {
            var content = $("#pageCanvas")[0];
            if(content){
                content.ondragenter = ignoreDrag;
                // 拖动文件的鼠标指针位置放置区之上时发生
                content.ondragover = ignoreDrag;
                content.ondrop = drop;
            }
        },1000)
        window.dragStart = function (event) {
            var target = event.target;
            event.dataTransfer.setData("img", target.id);
            if (target.id.indexOf('dragtargetClipArt') != '-1') {
                event.dataTransfer.setData("Art", target.dataset.clipart);
            }
            $timeout(function () {
                vm.dragDom = true;
            })
        };
        window.dragOn = function(event){
            $timeout(function () {
                vm.dragDom = false;
            })
        }
        $timeout(function () {
            document.body.ondrop = function(event) {
                event.preventDefault();
                event.stopPropagation();
            };
        })
        function ignoreDrag(e) {
            // 确保其他元素不会取得该事件
            e.stopPropagation();
            e.preventDefault();
            var dataset = e.target.dataset;
            if (vm.dragDom && (e.target.nodeName == 'IMG' || ($(e.target).attr('class') && $(e.target).attr('class').indexOf('image-placeholder-class') > -1))&&dataset.imgindex) {
                var textIndex = dataset.imgindex;
                $(".imageboxView").removeClass('selected-blue')
                var _pageIndex = $(e.target).parents('.pageCanvasItem').attr('data-pageIndex');
                $(".imageboxView"+_pageIndex+textIndex).addClass('selected-blue');
            }else{
                $(".imageboxView").removeClass('selected-blue')
            }

        }
        function drop(e) {
            var data = e.dataTransfer.getData("img");
            $(".imageboxView").removeClass('selected-blue')
            if(!data){
                return
            }
            var dataIndex = $('#' + data)[0].getAttribute('data-index');
            $timeout(function () {
                var _pageIndex = $(e.target).parents('.pageCanvasItem').attr('data-pageIndex1');
                var _pageIndex1 = $(e.target).parents('.pageCanvasItem').attr('data-pageIndex');
                if(!_pageIndex){
                    return
                }
                if(vm.pageNumber != _pageIndex1){
                    vm.pageNumber = _pageIndex1;
                    cookieInfo()
                }
                ignoreDrag(e);
                $(".imageboxView").removeClass('selected-blue');
                var offsetX= e.clientX;
                var offsetY= e.clientY;
                if(_pageIndex == 1){
                    offsetX -= parseFloat($(".pageCanvasItem1").offset().left);
                    offsetY -= parseFloat($(".pageCanvasItem1").offset().top);
                }
                if(_pageIndex == 2){
                    offsetX -= parseFloat($(".pageCanvasItem2").offset().left);
                    offsetY -= parseFloat($(".pageCanvasItem2").offset().top);
                }
                if(vm.pageData[vm.pageNumber].scene){
                    offsetX -= vm.pageData[vm.pageNumber].scene.imagebox.geometry.x * vm.pageData[vm.pageNumber].custom.ratio;
                    offsetY -= vm.pageData[vm.pageNumber].scene.imagebox.geometry.y * vm.pageData[vm.pageNumber].custom.ratio;
                }
                //拖拽图片进入占位框
                if (data.indexOf('dragtargetPhoto') != '-1') {
                    var imgindex = e.target.dataset.imgindex;
                    if(imgindex == null){
                        var item = $('#' + data).attr('data-item');
                        replaceImagebox1(offsetX, offsetY, JSON.parse(item));
                    }else {
                        vm.levelIndex = imgindex;
                        var item = JSON.parse($('#' + data).attr('data-item'));
                        var _imagebox = vm.pageData[vm.pageNumber].levels.level[vm.levelIndex].imagebox;
                        var identifier = _imagebox.mask.resource.identifier;
                        replaceImagebox(item);
                    }
                }
                //边框
                if (data.indexOf('dragtargetFrameConfig') != '-1') {
                    var item = $('#' + data).attr('data-item');
                    var imgindex = e.target.dataset.imgindex;
                    if(imgindex == null){
                        var borderList = vm.borderList[$('#' + data).attr('data-index')];
                        $http({url: borderList.img + '?imageInfo'}).success(function (data) {
                            var imgZoom = 1;
                            if (data.width > data.height) {
                                imgZoom = 200 / data.width
                            } else {
                                imgZoom = 200 / data.height
                            }
                            var _w2 = (imgZoom * data.width) / (1 + borderList.marginLeft / 100 + borderList.marginRight / 100) / vm.pageData[vm.pageNumber].custom.ratio;
                            var _h2 = (imgZoom * data.height) / (1 + borderList.marginBottom / 100 + borderList.marginTop / 100) / vm.pageData[vm.pageNumber].custom.ratio;
                            var _level = {
                                imagebox:{},
                                seq: vm.pageData[vm.pageNumber].levels.level.length + Number(1)
                            }
                            var _imagebox = {
                                blurredrectangle:null,
                                bokehtype:vm.article.bokehtype,
                                bokehtypes:vm.article.bokehtype,
                                geometry:{
                                    width: _w2,
                                    height: _h2,
                                    x:(offsetX/vm.pageData[vm.pageNumber].custom.ratio - _w2 / 2) || 0,
                                    y:(offsetY/vm.pageData[vm.pageNumber].custom.ratio - _h2 / 2) || 0
                                },
                                image: {
                                    resource: {
                                        identifier: item.identifier,
                                        provider: 'qiniu'
                                    },
                                    filterResource: {
                                        identifier: '',
                                        provider: 'qiniu'
                                    },
                                    width: item.width,
                                    height: item.height,
                                    imgSize: item.imgSize,
                                    index: item.seq,
                                    parameter: angular.fromJson(item.parameter),
                                    scale: 1,
                                    angle: 0
                                },
                                mask: {
                                    resource:{
                                        identifier: '',
                                        provider: '',
                                    }
                                },
                                rotation:{
                                    angle: 0
                                },

                                border: {
                                    shape: borderList.shape || 'Rectangle',
                                    radius: {
                                        lt: 0,
                                        rt: 0,
                                        rb: 0,
                                        lb: 0,
                                        all: 0,
                                        filletType: 'Fixed'
                                    },
                                    "edge": {
                                        top: borderList.marginTop,
                                        right: borderList.marginRight,
                                        bottom: borderList.marginBottom,
                                        left: borderList.marginLeft
                                    },
                                    lineWidth: 0,
                                    type: "Pic",
                                    resource: {
                                        "identifier": borderList.img
                                    },
                                    color: '',
                                },
                                transparency:1,
                                shadow:{
                                    color:'#777777',
                                    x:0,
                                    y:0,
                                    blur:0
                                },
                                useradded: true
                            }
                            _level.imagebox = _imagebox;
                            vm.pageData[vm.pageNumber].levels.level.push(_level);
                            magnitudeBox();
                            $timeout(function () {
                                cookie();
                            },500)
                        })
                    }else {
                        vm.levelIndex = imgindex;
                        var borderList = vm.borderList[$('#' + data).attr('data-index')];
                        vm.pageData[vm.pageNumber].levels.level[vm.levelIndex].imagebox.border = {
                            shape: borderList.shape || 'Rectangle',
                            radius: {
                                lt: 0,
                                rt: 0,
                                rb: 0,
                                lb: 0,
                                all: 0,
                                filletType: 'Fixed'
                            },
                            "edge": {
                                top: borderList.marginTop,
                                right: borderList.marginRight,
                                bottom: borderList.marginBottom,
                                left: borderList.marginLeft
                            },
                            lineWidth: 0,
                            type: "Pic",
                            resource: {
                                "identifier": borderList.img
                            },
                            color: '',
                        }
                    }
                    $timeout(function () {
                        cookie();
                    },500)
                }

                // 判读是否是占位框
                if (data.indexOf('dragtargetMask') != '-1') {
                    var item = $('#' + data).attr('data-item');
                    var imgindex = e.target.dataset.imgindex;
                    if(imgindex == null){
                        var border = null;
                        if (data.indexOf('Round') > '-1') {
                            border = {
                                shape: 'Ellipse',
                                radius: {
                                    lt: 0,
                                    rt: 0,
                                    rb: 0,
                                    lb: 0,
                                    all: 0,
                                    filletType: 'Fixed'
                                },
                                "edge": {
                                    top: 0,
                                    right: 0,
                                    bottom: 0,
                                    left: 0
                                },
                                lineWidth: 0,
                                type: "Color",
                                lineType:"solid",
                                resource: {
                                    "identifier": ''
                                },
                                color: '#000000',
                            };
                        } else if (data.indexOf('Rectangle') > '-1') {
                            border = {
                                shape: 'Rectangle',
                                radius: {
                                    lt: 0,
                                    rt: 0,
                                    rb: 0,
                                    lb: 0,
                                    all: 0,
                                    filletType: 'Fixed'
                                },
                                "edge": {
                                    top: 0,
                                    right: 0,
                                    bottom: 0,
                                    left: 0
                                },
                                lineWidth: 0,
                                type: "Color",
                                lineType:"solid",
                                resource: {
                                    "identifier": ''
                                },
                                color: '#000000',
                            };
                        }else{
                            border = {
                                shape: 'Rectangle',
                                radius: {
                                    lt: 0,
                                    rt: 0,
                                    rb: 0,
                                    lb: 0,
                                    all: 0,
                                    filletType: 'Fixed'
                                },
                                "edge": {
                                    top: 0,
                                    right: 0,
                                    bottom: 0,
                                    left: 0
                                },
                                lineWidth: 0,
                                type: "Color",
                                lineType:"solid",
                                resource: {
                                    "identifier": ''
                                },
                                color: '#000000',
                            };
                        }
                        replaceImagebox1(offsetX, offsetY, JSON.parse(item), border);
                    }else {
                        vm.levelIndex = imgindex;
                        var item = JSON.parse($('#' + data).attr('data-item'));
                        vm.pageData[vm.pageNumber].levels.level[vm.levelIndex].imagebox.mask.resource.identifier = item.resource.identifier;
                        if (data.indexOf('Round') > '-1') {
                            if(vm.pageData[vm.pageNumber].levels.level[vm.levelIndex].imagebox.border){
                                vm.pageData[vm.pageNumber].levels.level[vm.levelIndex].imagebox.border.shape = 'Ellipse';
                            }else{
                                vm.pageData[vm.pageNumber].levels.level[vm.levelIndex].imagebox.border= {
                                    shape: 'Ellipse',
                                    radius: {
                                        lt: 0,
                                        rt: 0,
                                        rb: 0,
                                        lb: 0,
                                        all: 0,
                                        filletType: 'Fixed'
                                    },
                                    "edge": {
                                        top: 0,
                                        right: 0,
                                        bottom: 0,
                                        left: 0
                                    },
                                    lineWidth: 0,
                                    type: "Color",
                                    lineType:"solid",
                                    resource: {
                                        "identifier": ''
                                    },
                                    color: '#000000',
                                };
                            }

                            vm.pageData[vm.pageNumber].levels.level[vm.levelIndex].imagebox.shadow= {
                                color:'#777777',
                                x:0,
                                y:0,
                                blur:0
                            }
                        } else if (data.indexOf('Rectangle') > '-1') {
                            if(vm.pageData[vm.pageNumber].levels.level[vm.levelIndex].imagebox.border){
                                vm.pageData[vm.pageNumber].levels.level[vm.levelIndex].imagebox.border.shape = 'Rectangle';
                            }else{
                                vm.pageData[vm.pageNumber].levels.level[vm.levelIndex].imagebox.border= {
                                    shape: 'Rectangle',
                                    radius: {
                                        lt: 0,
                                        rt: 0,
                                        rb: 0,
                                        lb: 0,
                                        all: 0,
                                        filletType: 'Fixed'
                                    },
                                    "edge": {
                                        top: 0,
                                        right: 0,
                                        bottom: 0,
                                        left: 0
                                    },
                                    lineWidth: 0,
                                    type: "Color",
                                    lineType:"solid",
                                    resource: {
                                        "identifier": ''
                                    },
                                    color: '#000000',
                                };
                            }

                            vm.pageData[vm.pageNumber].levels.level[vm.levelIndex].imagebox.border= {
                                shape: 'Rectangle',
                                radius: {
                                    lt: 0,
                                    rt: 0,
                                    rb: 0,
                                    lb: 0,
                                    all: 0,
                                    filletType: 'Fixed'
                                },
                                "edge": {
                                    top: 0,
                                    right: 0,
                                    bottom: 0,
                                    left: 0
                                },
                                lineWidth: 0,
                                type: "Color",
                                lineType:"solid",
                                resource: {
                                    "identifier": ''
                                },
                                color: '#000000',
                            };
                            vm.pageData[vm.pageNumber].levels.level[vm.levelIndex].imagebox.shadow= {
                                color:'#777777',
                                x:0,
                                y:0,
                                blur:0
                            }
                        }
                    }
                    $timeout(function () {
                        cookie();
                    },500)
                }
                //判读是否是素材
                if (data.indexOf('dragtargetClipArt') != '-1') {
                    $scope.materialCb(vm.clipArtsList[dataIndex], offsetX,offsetY, true);
                    $scope.$digest();
                }
                // 可变数据
                if (data.indexOf('dragtargetVariable') != '-1'){
                    var arr = vm.variableData.titles.title[dataIndex];
                    if(arr.select){
                        var border = {
                            shape: 'Rectangle',
                            radius: {
                                lt: 0,
                                rt: 0,
                                rb: 0,
                                lb: 0,
                                all: 0,
                                filletType: 'Fixed'
                            },
                            "edge": {
                                top: 0,
                                right: 0,
                                bottom: 0,
                                left: 0
                            },
                            lineWidth: 0,
                            type: "Color",
                            lineType:"solid",
                            resource: {
                                "identifier": ''
                            },
                            color: '#000000',
                        };
                        replaceImagebox1(offsetX, offsetY, vm.generalMask[1], border,arr.value);
                    }else{
                        var value = '#'+$('#' + data)[0].getAttribute('data-value')+'#';
                        $scope.addText(24,value);
                    }
                }
            })
        }

        $scope.replaceImagebox1=function(e,data,index){
            if(data.type=="masking"){
                return
            }
            vm.levelIndex = index;
            replaceImagebox(data)
        }
        function replaceImagebox(data){
            var item = angular.copy(data);
            var _imagebox = angular.copy(vm.pageData[vm.pageNumber].levels.level[vm.levelIndex].imagebox);
            _imagebox.image = {
                resource: {
                    identifier: item.identifier,
                    provider: 'qiniu'
                },
                filterResource: {
                    identifier: '',
                    provider: 'qiniu'
                },
                offsetx:0,
                offsety:0,
                resourceid:item.sourceId,
                width: item.width,
                height: item.height,
                imageInfo: item.imageInfo,
                imgSize: item.imgSize,
                index: item.seq,
                parameter: angular.fromJson(item.parameter),
                scale: 1,
                angle: 0,
                mattingMask: null,
            }
            addImagebox($http, _imagebox, function () {
                vm.pageData[vm.pageNumber].levels.level[vm.levelIndex].imagebox = _imagebox;
                onArticleChange();
                thumbnailInit();
                $timeout(function () {
                    cookie();
                    if(vm.elementOn && vm.elementOn.name == 'imagebox'){
                        elementInit(vm.levelIndex,vm.pageNumber,vm.pageData[vm.pageNumber].levels.level[vm.levelIndex].imagebox,'imagebox');
                    }
                },100)
            });
            imageSelectInit();
            magnitudeBox();
        }
        vm.imageSelectInit = imageSelectInit;
        function imageSelectInit(){
            vm.photoSelectAll = [];
            for(var i=0; i<vm.pageData.length; i++){
                for(var j=0; j<vm.pageData[i].levels.level.length; j++){
                    var _level = vm.pageData[i].levels.level[j];
                    if(_level.imagebox && _level.imagebox.image && _level.imagebox.image.resourceid){
                        for(var k=0; k<$scope.photos.length; k++){
                            if(_level.imagebox.image.resourceid == $scope.photos[k].sourceId){
                                vm.photoSelectAll.push($scope.photos[k]);
                                break
                            }
                        }
                    }
                }
            }
        }
        function replaceImagebox1(offsetX, offsetY, data, border, value){
            if (!border) {
                border = {
                    shape: 'Rectangle',
                    radius: {
                        lt: 0,
                        rt: 0,
                        rb: 0,
                        lb: 0,
                        all: 0,
                        filletType: 'Fixed'
                    },
                    "edge": {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0
                    },
                    lineWidth: 0,
                    type: "Color",
                    lineType:"solid",
                    resource: {
                        "identifier": ''
                    },
                    color: '#000000',
                };
            }
            var item = angular.copy(data);
            if(item.type=='picture'){
                var _level = {
                    imagebox:{},
                    seq: vm.pageData[vm.pageNumber].levels.level.length + Number(1)
                }
                var _imagebox = {
                    value: value,
                    blurredrectangle:null,
                    bokehtype: angular.copy(vm.article.bokehtype),
                    geometry:{
                        width:0,
                        height:0,
                        x:0,
                        y:0
                    },
                    border: border,
                    shadow:{
                        color:'#777777',
                        x:0,
                        y:0,
                        blur:0
                    },
                    image: {
                        resource: {
                            identifier: item.identifier,
                            provider: 'qiniu'
                        },
                        filterResource: {
                            identifier: '',
                            provider: 'qiniu'
                        },
                        resourceid:item.sourceId,
                        width: item.width,
                        height: item.height,
                        imageInfo: item.imageInfo,
                        imgSize: item.imgSize,
                        index: item.seq,
                        parameter: angular.fromJson(item.parameter),
                        scale: 1,
                        angle: 0,
                    },
                    transparency:1,
                    mask: {
                        resource:{
                            identifier: '',
                            provider: '',
                        }
                    },
                    rotation:{
                        angle: 0
                    }
                }

                var w = 200 / vm.pageData[vm.pageNumber].custom.ratio;
                var h = 200 / vm.pageData[vm.pageNumber].custom.ratio;
                var imgR = w/h;
                var imgR1 = item.width/item.height;

                if(imgR >= imgR1){
                    _imagebox.geometry.width= h/item.height*item.width;
                    _imagebox.geometry.height= h;
                }else {
                    _imagebox.geometry.width= w;
                    _imagebox.geometry.height= w/item.width*item.height;
                }

                _imagebox.geometry.x = (offsetX/vm.pageData[vm.pageNumber].custom.ratio-_imagebox.geometry.width/2);
                _imagebox.geometry.y = (offsetY/vm.pageData[vm.pageNumber].custom.ratio-_imagebox.geometry.height/2);
                _level.imagebox = _imagebox;
                addImagebox($http, _level.imagebox, function () {
                    vm.pageData[vm.pageNumber].levels.level.push(_level);
                    setLayout()
                    magnitudeBox();
                    $timeout(function () {
                        cookie();
                    },500)
                });
            }
            if(item.type=="masking"){
                var newImg = new Image();
                newImg.crossOrigin = "Anonymous";
                newImg.src = (item.resource.identifier.indexOf('http') == -1 ? $scope.domain : '') + item.resource.identifier + '?imageMogr2/exifModify/eyJPcmllbnRhdGlvbiI6IjEifQ==/rotate';
                newImg.onload = function () {
                    var _level = {
                        imagebox:{},
                        seq: vm.pageData[vm.pageNumber].levels.level.length + Number(1)
                    }
                    var _imagebox = {
                        value: value,
                        blurredrectangle:null,
                        bokehtype: angular.copy(vm.article.bokehtype),
                        geometry:{
                            width:0,
                            height:0,
                            x:0,
                            y:0
                        },
                        border:border,
                        image: {
                            resource: {
                                identifier: '',
                                provider: ''
                            },
                            filterResource: {
                                identifier: '',
                                provider: 'qiniu'
                            },
                            scale: 1,
                            angle: 0
                        },
                        mask: {
                            resource:{
                                identifier: item.resource.identifier,
                                provider: 'qiniu',
                            }
                        },
                        rotation:{
                            angle: 0
                        },
                        transparency:1,
                        shadow:{
                            color:'#777777',
                            x:0,
                            y:0,
                            blur:0
                        },
                    };
                    var w = 200 / vm.pageData[vm.pageNumber].custom.ratio;
                    var h = 200 / vm.pageData[vm.pageNumber].custom.ratio;
                    var imgR = w/h;
                    var imgR1 = newImg.width/newImg.height;

                    if(imgR >= imgR1){
                        _imagebox.geometry.width= h/newImg.height*newImg.width;
                        _imagebox.geometry.height= h;
                    }else {
                        _imagebox.geometry.width= w;
                        _imagebox.geometry.height= w/newImg.width*newImg.height;
                    }
                    _imagebox.geometry.x = (offsetX/vm.pageData[vm.pageNumber].custom.ratio-_imagebox.geometry.width/2);
                    _imagebox.geometry.y = (offsetY/vm.pageData[vm.pageNumber].custom.ratio-_imagebox.geometry.height/2);
                    _level.imagebox = _imagebox;
                    vm.pageData[vm.pageNumber].levels.level.push(_level);
                    // getBackgroundWebSource3($scope,vm.pageData[vm.pageNumber].levels.level[_level.seq].imagebox,vm.pageData[vm.pageNumber].levels.level[_level.seq].imagebox.geometry.width,vm.pageData[vm.pageNumber].levels.level[_level.seq].imagebox.geometry.height,vm.pageData[vm.pageNumber].levels.level[_level.seq].imagebox.image, vm.pageData[vm.pageNumber].levels.level[_level.seq].imagebox.bokehtype);
                    magnitudeBox();
                    $timeout(function () {
                        cookie();
                    },500)
                    $scope.$digest();
                };
            }
        }

        vm.magnitudeBox = magnitudeBox;
        function magnitudeBox(){
            vm.counts = 0;
            vm.current = 0;
            angular.forEach(vm.pageData, function (page, i) {
                angular.forEach(page.levels.level, function (level, i) {
                    if(level.imagebox&&level.imagebox.geometry){
                        vm.counts++;
                    }
                    if(level.imagebox && level.imagebox.image && level.imagebox.image.resource &&  level.imagebox.image.resource.identifier){
                        vm.current++;
                    }
                });
            });
            onArticleChange();
            photosNum();
        }
        vm.elementInit = elementInit;
        function elementInit(index,pageIndex,item,name,isDrop){
            clearCode();
            vm.clickNum = 0;
            vm.elementOn = {
                index:index,
                pageIndex:pageIndex,
                name:name,
                item:item
            };
            // if(vm.elementOn.item.image && vm.elementOn.item.image.resourceid && !vm.elementOn.item.image.resource.primary) {
            //     Gallery.getOne({id:vm.elementOn.item.image.resourceid},function (res){
            //         vm.elementOn.item.image.resource.primary = res.data.identifier
            //     })
            // }
            if(vm.pageNumber != pageIndex){
                $rootScope.$broadcast('onKeyDownCallback');
                $timeout(function () {
                    vm.pageNumber = pageIndex;
                    vm.cookies=[];
                    var _data = angular.copy(vm.pageData[vm.pageNumber]);
                    vm.cookies.push(_data);
                    vm.cookieIndex = 0;
                })
            }
            if(!isDrop){
                scrollIntoViewElement();
            }
            scrollIntoView();
            variableNumber();
            toolbarStatus();
        }
        /***********************  素材  ****************************/
        //添加素材
        $scope.materialCb = function(item, x, y, isDrop){
            webAddImageart($scope,$http,item,vm.pageData[vm.pageNumber].trimbox, function (_imageart) {
                if(x && y){
                    _imageart.geometry.x = (x-_imageart.geometry.width/2)/vm.pageData[vm.pageNumber].custom.ratio;
                    _imageart.geometry.y = (y-_imageart.geometry.height/2)/vm.pageData[vm.pageNumber].custom.ratio;
                }
                if(!isDrop) {
                    var _num = 0;
                    vm.pageData[vm.pageNumber].levels.level.forEach(function (level) {
                        if (level.imageart) {
                            _num += 10;
                        }
                    });
                    _imageart.geometry.x += _num / vm.pageData[vm.pageNumber].custom.ratio;
                    _imageart.geometry.y += _num / vm.pageData[vm.pageNumber].custom.ratio;
                }
                _imageart.geometry.width = _imageart.geometry.width/vm.pageData[vm.pageNumber].custom.ratio;
                _imageart.geometry.height = _imageart.geometry.height/vm.pageData[vm.pageNumber].custom.ratio;
                var _level ={
                    seq: vm.pageData[vm.pageNumber].levels.level.length+1,
                    imageart: _imageart
                }
                vm.pageData[vm.pageNumber].levels.level.push(_level);
                elementInit(_level.seq-1,vm.pageNumber,_level.imageart,'imageart');
                cookie();
            })
        }

        /***********************  文字  ****************************/
        fontuuid()
        vm.selectFont = '';
        vm.selectFontBtn = fontuuid;
        vm.selectFontName = selectFontName;
        vm.chineseSupport = true;
        function fontuuid(){
            vm.fontuuid = [];
            FontManagement.getAll({family: vm.selectFont}, function (res) {
                vm.fontuuid = res;
            });
        }
        function selectFontName(item){
            if(item){
                for(var i=0;i<vm.fontuuid.length; i++){
                    if(vm.fontuuid[i].uuid == item){
                        return vm.fontuuid[i].family
                    }
                }
            }
        }
        $scope.updateTextFont = function (data) {
            if (data == undefined) {
                MessageService.error($translate.instant("editorMessage.failedAddText"));
                return
            }
            if (!data.enable) {
                MessageService.error($translate.instant("editorMessage.fontChange"));
                return
            }
            var text = angular.copy(vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].textbox);
            if (text.lock) {
                return
            }
            vm.fontStyle = [];
            for(var i=0; i<vm.fontuuid.length; i++){
                if(vm.fontuuid[i].uuid == data.uuid){
                    for(var j=0; j<vm.fontuuid[i].fontStyles.length; j++){
                        vm.fontStyle.push(vm.fontuuid[i].fontStyles[j].style)
                    }
                }
            }
            text.style.bold = false;
            text.style.italic = false;
            if(vm.fontStyle.indexOf('NORMAL') != '-1'){
                text.style.bold = false;
                text.style.italic = false;
            }else {
                if(vm.fontStyle.indexOf('BOLD_ITALIC') != '-1'){
                    text.style.bold = true;
                    text.style.italic = true;
                }else {
                    if(vm.fontStyle.indexOf('ITALIC') != '-1'){
                        text.style.italic = true;
                        text.style.bold = false;
                    }
                    if(vm.fontStyle.indexOf('BOLD') != '-1'){
                        text.style.bold = true;
                        text.style.italic = false;
                    }
                }
            }
            text.style.font = data.family;
            text.fontuuid = data.uuid;
            text.identifier = $scope.domain + data.fontStyles[0].identifier;
            vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].textbox.loading = true;
            FontSupport2(FontManagement, text, function (res) {
                var msg = res.data;
                if (res.status == 200) {
                    if ((!msg.success ||  msg.failed) && !msg.error) {
                        MessageService.confirm({
                            title:$translate.instant("editorMessage.warmPrompt"),
                            confirm:$translate.instant("button.returnCorrection"),
                            msg:$translate.instant("editorMessage.pleaseChangeFonts1") +
                                    '<span class="theme-color">'+msg.failed+'</span>' + $translate.instant("editorMessage.pleaseChangeFonts2")
                        })
                    }else if(!msg.success && msg.error){
                        MessageService.confirm({
                            title:$translate.instant("editorMessage.fontFileErrorTitle"),
                            confirm:$translate.instant("editorMessage.fontFileErrorConfirm"),
                            msg:$translate.instant("editorMessage.fontFileErrorMessage1") +
                                    '<span class="theme-color">'+msg.error+'</span>' + $translate.instant("editorMessage.fontFileErrorMessage2")
                        })
                    }else{
                        vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].textbox.style.font = data.family;
                        vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].textbox.fontuuid = data.uuid;
                        vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].textbox.identifier = $scope.domain + data.fontStyles[0].identifier;
                        ModulesService.getFontCSS(vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].textbox);
                        sizeHeight()
                        fontStyle(data.uuid);
                        cookie();
                    }
                }
                vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].textbox.loading = false;
            })
        };
        //添加文字
        $scope.addText = function (size, value) {
            textboxWebAdd(vm.defaultFont, vm.defaultFont.fontStyles, size, function (_font) {
                if(value){
                    _font.text = value;
                    _font.value = value;
                }else{
                    _font.text = $translate.instant("editorCommon.doubleClickType");
                    _font.value = $translate.instant("editorCommon.doubleClickType");
                }
                var _level ={
                    seq: vm.pageData[vm.pageNumber].levels.level.length+1,
                    textbox: _font
                }
                vm.pageData[vm.pageNumber].levels.level.push(_level);
                elementInit(_level.seq-1,vm.pageNumber,_level.textbox,'textbox');
                $timeout(function () {
                    // vm.pageData[vm.pageNumber].levels.level[_level.seq-1].textbox.geometry.width = (Number($("#c-xml-page-material-fontId").width() / (3/4) / vm.pageData[vm.pageNumber].custom.ratio * (1 / 12 * vm.elementOn.item.style.size * vm.pageData[vm.pageNumber].custom.ratio > 1 ? 1 : 1 / 12 * vm.elementOn.item.style.size * vm.pageData[vm.pageNumber].custom.ratio)) + Number(5));
                    // vm.pageData[vm.pageNumber].levels.level[_level.seq-1].textbox.geometry.height = Number($("#c-xml-page-material-fontId").height() / (3/4) / vm.pageData[vm.pageNumber].custom.ratio) * (1 / 12 * vm.elementOn.item.style.size * vm.pageData[vm.pageNumber].custom.ratio > 1 ? 1 : 1 / 12 * vm.elementOn.item.style.size * vm.pageData[vm.pageNumber].custom.ratio) + Number(10);
                    vm.pageData[vm.pageNumber].levels.level[_level.seq-1].textbox.geometry.width = Number($("#c-xml-page-material-fontId").width()) + Number(10);
                    vm.pageData[vm.pageNumber].levels.level[_level.seq-1].textbox.geometry.height = (Number($("#c-xml-page-material-fontId").height()) + Number(10));
                    vm.pageData[vm.pageNumber].levels.level[_level.seq-1].textbox.geometry.x = (vm.pageData[vm.pageNumber].trimbox.width - vm.pageData[vm.pageNumber].levels.level[_level.seq-1].textbox.geometry.width) / 2 + vm.pageData[vm.pageNumber].trimbox.x;
                    vm.pageData[vm.pageNumber].levels.level[_level.seq-1].textbox.geometry.y = (vm.pageData[vm.pageNumber].trimbox.height - vm.pageData[vm.pageNumber].levels.level[_level.seq-1].textbox.geometry.height) / 2 + vm.pageData[vm.pageNumber].trimbox.y;

                    var _num = 0;
                    vm.pageData[vm.pageNumber].levels.level.forEach(function (level) {
                        if(level.textbox){
                            _num+=10;
                        }
                    });
                    vm.pageData[vm.pageNumber].levels.level[_level.seq-1].textbox.geometry.x += _num/vm.pageData[vm.pageNumber].custom.ratio;
                    vm.pageData[vm.pageNumber].levels.level[_level.seq-1].textbox.geometry.y += _num/vm.pageData[vm.pageNumber].custom.ratio;
                    getFontCSS(FontManagement, vm.pageData[vm.pageNumber].levels.level[_level.seq-1].textbox, $scope)
                    // sizeHeight();
                    cookie();
                    fontStyle(vm.pageData[vm.pageNumber].levels.level[_level.seq-1].textbox.fontuuid)
                })
            })
        }
        vm.fontStyleCb = fontStyle;
        function fontStyle(fontuuid){
            if(vm.elementOn.name != "textbox"){
                return
            }
            var text = vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].textbox;
            vm.fontStyle = [];
            for(var i=0; i<vm.fontuuid.length; i++){
                if(vm.fontuuid[i].uuid == fontuuid){
                    for(var j=0; j<vm.fontuuid[i].fontStyles.length; j++){
                        vm.fontStyle.push(vm.fontuuid[i].fontStyles[j].style)
                    }
                }
            }
            text.style.bold1 = false;
            text.style.italic1= false;
            if(vm.fontStyle.indexOf('NORMAL') == '-1'){
                text.style.normal = false;
            }else {
                text.style.normal = true;
            }
            if(vm.fontStyle.indexOf('BOLD_ITALIC') != '-1'){
                text.style.bold1 = true;
                text.style.italic1= true;
            }else {
                if(vm.fontStyle.indexOf('ITALIC') != '-1'){
                    text.style.italic1= true;
                }
                if(vm.fontStyle.indexOf('BOLD') != '-1'){
                    text.style.bold1 = true;
                }
            }
        }
        vm.sizeHeight = sizeHeight;
        function sizeHeight(){
            if(vm.pageData[vm.pageNumber] && vm.pageData[vm.pageNumber].levels && vm.pageData[vm.pageNumber].levels.level && vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index] && vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].textbox){
                getTextHeight(vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].textbox, $scope)
            }
        }
        /***********************  文字模板  ****************************/
        $scope.addTextDoc = function (text,e) {
            FontXmlsFileServes.get({id: text.id}, function (res) {
                var level = {
                    seq: vm.pageData[vm.pageNumber].levels.level.length+1,
                    textdocument: {}
                }
                textDocWebAdd($scope,$http,level, res.data.textDocument, vm.pageData[vm.pageNumber].trimbox, vm.pageData[vm.pageNumber].mediabox, function (level) {
                    vm.pageData[vm.pageNumber].levels.level.push(level);
                    elementInit(level.seq-1,vm.pageNumber,level.textdocument,'textdocument');
                    cookie();
                }, function (text) {
                    getFontCSS(FontManagement, text, $scope)
                })
            })
        };
        //拆分组合
        $scope.slipGroup = function () {
            var textdocument = angular.copy(vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].textdocument);
            if(textdocument.lock){
                return
            }
            $scope.deleteBox();
            var textGeo = textdocument.geometry;
            if (textdocument.background && textdocument.background.resource && textdocument.background.resource.identifier) {
                $http({url: (textdocument.background.resource.identifier.indexOf('http') == -1 ? $scope.domain : '') + textdocument.background.resource.identifier + '?imageInfo'}).success(function (data) {
                    var resource = textdocument.background.resource;
                    var angle = 0;
                    if (textdocument.rotation.angle) {
                        angle = textdocument.rotation.angle;
                    }
                    var scale = 1;
                    if (textdocument.background.resource.adaptation == "Height") {
                        // scale = data.width / textdocument.geometry.width;
                        // scale = textdocument.geometry.width/data.width*data.height / textdocument.geometry.height;
                        scale = textdocument.geometry.height/data.height * data.width / textdocument.geometry.width;
                    }
                    var _imageart = {
                        movable: true,
                        editable: true,
                        onlyshow: false,
                        offsetx: textdocument.background.offsetx,
                        offsety: textdocument.background.offsety,
                        transparency: '1',
                        geometry: {
                            width: textdocument.geometry.width,
                            height: textdocument.geometry.height,
                            x: textdocument.geometry.x,
                            y: textdocument.geometry.y
                        },
                        rotation: {
                            angle: angle
                        },
                        resource: {
                            identifier: resource.identifier,
                            provider: 'qiniu',
                        },
                        width: data.width,
                        height: data.height,
                        imageInfo: data,
                        scale: scale,
                        useradded: true
                    }
                    var _level ={
                        seq: vm.pageData[vm.pageNumber].levels.level.length+1,
                        imageart: _imageart
                    }
                    vm.pageData[vm.pageNumber].levels.level.push(_level);
                    elementInit(_level.seq-1,vm.pageNumber,_level.imageart,'imageart');
                }).error(function (error) {});
            }
            angular.forEach(textdocument.levels.level, function (level, i) {
                if (level.imageart) {
                    $http({url: (level.imageart.resource.identifier.indexOf('http') == -1 ? $scope.domain : '') + level.imageart.resource.identifier + '?imageInfo'}).success(function (data) {
                        var resource = level.imageart.resource;
                        var angle = 0;
                        if (textdocument.rotation.angle) {
                            angle = textdocument.rotation.angle;
                        }
                        var _imageart = {
                            movable: true,
                            editable: true,
                            onlyshow: false,
                            offsetx: level.imageart.offsetx,
                            offsety: level.imageart.offsety,
                            transparency: '1',
                            geometry: {
                                width: level.imageart.geometry.width,
                                height: level.imageart.geometry.height,
                                x: level.imageart.geometry.x + textGeo.x,
                                y: level.imageart.geometry.y + textGeo.y
                            },
                            rotation: {
                                angle: angle
                            },
                            resource: {
                                identifier: resource.identifier,
                                provider: 'qiniu',
                                width: data.width,
                                height: data.height
                            },
                            scale: level.imageart.scale,
                            useradded: true
                        }
                        var _level ={
                            seq: vm.pageData[vm.pageNumber].levels.level.length+1,
                            imageart: _imageart
                        }
                        vm.pageData[vm.pageNumber].levels.level.push(_level);
                        elementInit(_level.seq-1,vm.pageNumber,_level.imageart,'imageart');
                    }).error(function (error) {});
                }
                if (level.textbox) {
                    var currentLevel ={
                        seq: vm.pageData[vm.pageNumber].levels.level.length+1,
                        textbox: angular.copy(level.textbox)
                    }
                    currentLevel.textbox.style.size = Math.trunc(currentLevel.textbox.style.size);
                    currentLevel.textbox.movable = textdocument.movable;
                    currentLevel.textbox.useradded = true;
                    currentLevel.textbox.editable = textdocument.editable;
                    currentLevel.textbox.levelI = $scope.template.levelI;
                    currentLevel.textbox.pageI = $scope.pageI;
                    currentLevel.textbox.current = 'textbox';
                    currentLevel.textbox.parentCurrent = null;
                    currentLevel.textbox.lock = false;
                    currentLevel.textbox.geometry.x = level.textbox.geometry.x + textGeo.x;
                    currentLevel.textbox.geometry.y = level.textbox.geometry.y + textGeo.y;
                    currentLevel.textbox.rotation.angle = textdocument.rotation.angle ? textdocument.rotation.angle : 0;

                    vm.pageData[vm.pageNumber].levels.level.push(currentLevel);
                    elementInit(currentLevel.seq-1,vm.pageNumber,currentLevel.textbox,'textbox');
                    $timeout(function () {
                        // vm.pageData[vm.pageNumber].levels.level[currentLevel.seq-1].textbox.geometry.width = (Number($("#c-xml-page-material-fontId").width() / (3/4) / vm.pageData[vm.pageNumber].custom.ratio * (1 / 12 * vm.elementOn.item.style.size * vm.pageData[vm.pageNumber].custom.ratio > 1 ? 1 : 1 / 12 * vm.elementOn.item.style.size * vm.pageData[vm.pageNumber].custom.ratio)) + Number(5));
                        // vm.pageData[vm.pageNumber].levels.level[currentLevel.seq-1].textbox.geometry.height = Number($("#c-xml-page-material-fontId").height() / (3/4) / vm.pageData[vm.pageNumber].custom.ratio) * (1 / 12 * vm.elementOn.item.style.size * vm.pageData[vm.pageNumber].custom.ratio > 1 ? 1 : 1 / 12 * vm.elementOn.item.style.size * vm.pageData[vm.pageNumber].custom.ratio);

                        vm.pageData[vm.pageNumber].levels.level[currentLevel.seq-1].textbox.geometry.width = Number($("#c-xml-page-material-fontId").width()) + Number(10);
                        vm.pageData[vm.pageNumber].levels.level[currentLevel.seq-1].textbox.geometry.height = (Number($("#c-xml-page-material-fontId").height()) + Number(10));
                        // ModulesService.getFontCSS(vm.pageData[vm.pageNumber].levels.level[currentLevel.seq-1].textbox);
                    })
                }
                $timeout(function () {
                    cookie();
                },500)
            })

        }

        /***********************  背景  ****************************/
        $scope.chooseBgColor = function(color){
            vm.pageData[vm.pageNumber].background.type = "Color";
            vm.pageData[vm.pageNumber].background.color = color;
            vm.pageData[vm.pageNumber].background.resource.identifier = "";
            vm.pageData[vm.pageNumber].background.offsetx = 0;
            vm.pageData[vm.pageNumber].background.offsety = 0;
            cookie();
        }
        $scope.chooseBgColor1 = function(color){
            vm.pageData[vm.pageNumber].background.type = "Color";
            vm.pageData[vm.pageNumber].background.color = "";
            vm.pageData[vm.pageNumber].background.resource.identifier = "";
            vm.pageData[vm.pageNumber].background.resource.provider = "";
            vm.pageData[vm.pageNumber].background.offsetx = 0;
            vm.pageData[vm.pageNumber].background.offsety = 0;
            cookie();
        }
        $scope.chooseColor = function () {
            $scope.chooseBgColor(vm.bgColor);
            vm.bgColor = null;
        }
        $scope.chooseBgimg = function(data){
            vm.pageData[vm.pageNumber].background.type = "Pic";
            vm.pageData[vm.pageNumber].background.resource.identifier = data.identifier;
            vm.pageData[vm.pageNumber].background.resource.provider = 'qiniu';
            vm.pageData[vm.pageNumber].background.offsetx = 0;
            vm.pageData[vm.pageNumber].background.offsety = 0;
            bgImg(data);
        };
        function bgImg(data){
            var newImg = new Image();
            newImg.crossOrigin = "Anonymous";
            newImg.src = (data.identifier.indexOf('http') == -1 ? $scope.domain : '') + data.identifier;
            newImg.onload = function () {
                var bgImgW = vm.pageData[vm.pageNumber].trimbox.width * vm.pageData[vm.pageNumber].custom.ratio;
                var bgImgH = vm.pageData[vm.pageNumber].trimbox.height * vm.pageData[vm.pageNumber].custom.ratio;
                var bgImgR = bgImgW/bgImgH;
                var bgImgR1 = newImg.width/newImg.height;
                vm.pageData[vm.pageNumber].background.width = newImg.width;
                vm.pageData[vm.pageNumber].background.height = newImg.height;
                if(bgImgR >= bgImgR1){
                    vm.pageData[vm.pageNumber].background.resource.adaptation = 'Width';
                    vm.pageData[vm.pageNumber].background.scale = 1;
                }else {
                    vm.pageData[vm.pageNumber].background.resource.adaptation = 'Height';
                    vm.pageData[vm.pageNumber].background.scale = 1;
                }
                $scope.$digest();
                cookie();
            };
        }

        /***********************  左侧菜单  ****************************/
        vm.nav = "picture";
        vm.navSelect = navSelect;
        function navSelect(item) {
            vm.nav = item;
            vm.leftShow = true;
            $scope.editorBodyView();
            $(".editor-nav-view").scrollTop(0);
            if(item == 'rahmen'){
                classifyInit('Material')
            }
            if(item == 'material'){
                classifyInit('ClipArt')
            }
            if(item == 'text'){
                classifyInit('FONT')
            }
            if(item == 'bgImg'){
                classifyInit('Background')
            }
            if(item == 'template'){
                templateInit()
            }
            if(item == 'border'){
                classifyInit('BORDER')
            }
            if(item == 'qrcode'){
                clearCode();
            }
            if(item == 'reserve'){
                vm.partid = vm.pageData[vm.pageNumber].config.partid;
            }
        }
        /***********************  照片  ****************************/
        vm.folderShow = false;
        vm.indexNum = 0;
        vm.maxId = null;
        vm.minId = null;
        vm.totalPhotoItems = null;
        vm.itemsPerPage = 40;
        $scope.photos = [];
        $scope.gallaryPic = [];
        $scope.moveGalleryIds = [];
        vm.picLoading = false;
        vm.deleteSure = false;
        vm.deletePhotoSure = false;
        vm.pendingDeletePhoto = null;
        vm.folderIds = "";
        vm.folderId = "";
        vm.photosTab='all';
        function loadFolders() {
            var articleId = vm.article ? (vm.article.articleId || vm.article.id) : vm.articleId;
            Folder.storeGetAllByCondition({
                items: [{key: "type", op: "=", value: "Gallery"},{key: "articleId", op: "=", value: articleId}],
                sort: ["id,asc"]
            }, function (resp) {
                if(resp.status == 200){
                    $scope.Folders = resp.data;
                }else {
                    MessageService.error(resp.message);
                }
            })
        }
        $scope.folderOn = function () {
            vm.folderShow = !vm.folderShow;
        };
        // 增加文件夹
        $scope.addFolder = function () {
            $uibModal.open({
                templateUrl: "app/entities/page/pagesmySuffix-create.html",
                controller: "PageMySuffixCreateController",
                backdrop: 'static',
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: 'vm',
                resolve: {
                    entity: [function() {
                        return {
                            type: "NEW"
                        };
                    }],
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('editorWeb');
                        return $translate.refresh();
                    }]
                }
            }).result.then(function (backData) {
                Folder.save({
                    name: backData,
                    type: 'Gallery',
                    articleId:vm.article.id
                }, function (resp) {
                    $scope.Folders.push(resp.data);
                })
            });
        }

        $scope.updateFloders = function(folder,event){
            event.stopPropagation();
            $uibModal.open({
                templateUrl: 'app/entities/page/pagesmySuffix-create.html',
                controller: 'PageMySuffixCreateController',
                backdrop: 'static',
                keyboard: true,
                windowClass: "jh-modal-md",
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('editorWeb');
                        return $translate.refresh();
                    }],
                    entity: [function() {
                        return {
                            type: "EDITOR",
                            name: folder.name
                        };
                    }]
                }
            }).result.then(function (data) {
                folder.name = data;
                Folder.update(folder, function (resp) {
                    if(resp.status == 200){
                        loadFolders();
                        vm.indexNum = 0;
                        vm.maxId = null;
                        vm.minId = null;
                        vm.totalPhotoItems = null;
                        vm.galleryPage = [];
                        $scope.photos = [];
                        loadAll('isNull');
                        MessageService.success($translate.instant("editorMessage.modifySuccess"));
                    }else {
                        MessageService.error(resp.message);
                    }
                },function () {
                    swal.showInputError($translate.instant("editorMessage.pleaseEnterTheCorrectFileName"));
                })
            }, function(){
            });
        }
        //选择文件夹
        $scope.showFolderContent = function (folder) {
            vm.indexNum = 0;
            vm.unusedQuantity = null;
            vm.oldQuantity = null;
            vm.maxId = null;
            vm.minId = null;
            vm.totalPhotoItems = null;
            $scope.photos = [];
            $scope.gallaryPic = [];
            $scope.moveGalleryIds = [];
            vm.folderId = folder ? folder.id : '';
            vm.folderName = folder ? folder.name : '';
            if (folder) {
                loadAll(folder.id);
            } else {
                loadAll('isNull');
            }

        };
        $scope.deleteShow = function (ids,event) {
            event.stopPropagation();
            vm.folderIds=ids;
            vm.deleteSure = true;
        }
        $scope.photoCb = function () {
            loadAll('isNull');
        }

        vm.photoSort = '2';
        $scope.photoSortChange = function (num) {
            vm.indexNum = 0;
            vm.maxId = null;
            vm.minId = null;
            vm.totalPhotoItems = null;
            vm.photoSort = num;
            $scope.photos = [];
            $scope.gallaryPic = [];
            $scope.moveGalleryIds = [];
            if(vm.folderId){
                loadAll(vm.folderId);
            }else{
                loadAll('isNull');
            }
        }
        vm.refreshPhotos = function () {
            vm.refreshing = true;
            var navEl = $('#navId')[0];
            vm._refreshScrollTop = navEl ? navEl.scrollTop : 0;
            vm.indexNum = 0;
            vm.maxId = null;
            vm.minId = null;
            vm.totalPhotoItems = null;
            $scope.photos = [];
            $scope.gallaryPic = [];
            $scope.moveGalleryIds = [];
            loadAll(vm.folderId || 'isNull');
        }
        $('#navId').on('scroll', function(event){
            if(vm.nav=='picture'){
                var realScrollHeight=event.currentTarget.clientHeight+event.currentTarget.scrollTop;
                if($scope.photos.length < vm.totalPhotoItems && !vm.picLoading){
                    if((event.currentTarget.scrollHeight-1)<realScrollHeight && realScrollHeight < (event.currentTarget.scrollHeight+1)){
                        if(vm.folderId){
                            loadAll(vm.folderId);
                        } else {
                            loadAll('isNull');
                        }
                    }
                }
            }
        });
        function loadAll(folderId) {
            vm.picLoading = true;
            //$scope.gallaryPic = [];
            //$scope.moveGalleryIds = [];
            var sort = ["id,asc"];
            if(vm.photoSort == 1){
                sort = ["id,desc"]
            }else if(vm.photoSort == 2){
                sort = ["name,asc"]
            }else if(vm.photoSort == 3){
                sort = ["name,desc"]
            }
            var items = [];
            var articleId = vm.article ? (vm.article.articleId || vm.article.id) : vm.articleId;
            if (folderId == 'isNull') {
                items.push({key: "folderId", op: "isNull", value: ''})
            }else{
                items.push({key: "folderId", op: "=",value: folderId});
            }
            items.push({key: "articleId", op: "=", value: articleId})
            if (vm.maxId) {
                items.push({key: "id", op: "<=",value: vm.maxId});
            }
            if (vm.minId) {
                items.push({key: "id", op: "<",value: vm.minId});
            }
            if (folderId == 'isNull') {
                $scope.selectFolder = '已传照片';
                Gallery.storeByCondition({
                    items: items,
                    page: vm.indexNum,
                    size: vm.indexNum < 2 ? 80 : vm.itemsPerPage,
                    sort: sort
                }, onSuccess, onError);
            } else {
                Gallery.storeByCondition({
                    items: items,
                    page: vm.indexNum,
                    size: vm.indexNum < 2 ? 80 : vm.itemsPerPage,
                    sort: sort
                }, onSuccess, onError);
            }
        }
        function onSuccess(data, headers) {
            if (vm.totalPhotoItems == null) {
                vm.totalPhotoItems = Number(headers('X-Total-Count'));
            }
            if (vm.maxId == null && vm.photoSort == 1 && data.data.length > 0) {
                vm.maxId = data.data[0].id;
            }
           if(vm.indexNum == 0){
                vm.indexNum+=2;
            }else{
                vm.indexNum++;
            }
            vm.picLoading = false;
            vm.refreshing = false;
            var len = $scope.photos.length;
            console.log(data.data);
            angular.forEach(data.data, function (item, i) {
                item.identifier = $scope.domain + item.identifier;
                item.select = false;
                item.index = i + len;
                item.usenum = 0;
                item.type = 'picture';
                $scope.photos.push(item);
            });
            // 列表刷新后按最新的处理状态重算选中集合（刷新的照片对象已被替换，旧的选中引用要丢弃）
            syncGallerySelection();
            photosNum();
            if($scope.photos.length < vm.totalPhotoItems){
                vm.isPhotoFinish = false;
            }else {
                vm.isPhotoFinish = true;
            }
            if($scope.photos.length > 0){
                newCreateDate = new Date($scope.photos[0].createdDate).getTime();
            }else {
                newCreateDate = new Date().getTime();
            }
            // 刷新场景下恢复滚动位置，等 DOM 渲染后再设置（onSuccess 会在每次 loadAll 后执行，仅当 _refreshScrollTop 有值时恢复）
            if (vm._refreshScrollTop != null) {
                var targetTop = vm._refreshScrollTop;
                vm._refreshScrollTop = null;
                $timeout(function () {
                    var el = $('#navId')[0];
                    if (el) {
                        el.scrollTop = targetTop;
                    }
                });
            }
        }

        function onError(error) {
            vm.picLoading = false;
            vm.refreshing = false;
            MessageService.error($translate.instant("editorMessage.failedToObtainThePhotoGallery"));
        }
        //删除多个文件夹
        $scope.deleteFolders = function () {
            vm.deleteSure = false;
            Folder.batchDelete({ids: vm.folderIds}, function () {
                vm.indexNum = 0;
                vm.maxId = null;
                vm.minId = null;
                vm.totalPhotoItems = null;
                $scope.photos = [];
                loadAll('isNull');
                loadFolders();
                MessageService.success($translate.instant("editorMessage.deleteSuccess"));
            }, function () {
                MessageService.error($translate.instant("editorMessage.deleteError"));
            });
        };
        $scope.choosePhoto = function (photo, event) {
            if (!photo) return;
            // 处理失败 / 处理中的照片均不可使用，禁止选中
            if (!isPhotoSelectable(photo)) {
                photo.select = false;
                syncGallerySelection();
                MessageService.error($translate.instant(isPhotoFailed(photo)
                    ? "nav.photograph.content.js.photoUnavailable"
                    : "nav.photograph.content.js.photoProcessing"));
                if (event && event.stopPropagation) {
                    event.stopPropagation();
                }
                return;
            }
            photo.select = !photo.select;
            syncGallerySelection();
        }
        $scope.switchBgTab = function (attr) {
            vm.photosTab = attr;
            if(vm.photosTab!='all'){
                vm.unUsedImageboxsNum = 0;
                angular.forEach($scope.photos,function (p) {
                    if(p.usenum==0){
                        vm.unUsedImageboxsNum++;
                    }
                })
                getGallery();
                $scope.whetherChoose(false);
                return;
            }
            // 切回"全部"后可见范围变化，重算选中集合
            syncGallerySelection();
        }
        // 全选 / 取消全选：处理中、处理失败的照片不参与选中
        $scope.whetherChoose = function (attr) {
            var photos = angular.isArray($scope.photos) ? $scope.photos : [];
            var hasSkipped = false;
            angular.forEach(photos, function (p) {
                if (!p) return;
                if (attr && isPhotoSelectable(p)) {
                    p.select = true;
                } else {
                    if (attr && isPhotoVisible(p) && !isPhotoSelectable(p)) {
                        hasSkipped = true;
                    }
                    p.select = false;
                }
            });
            syncGallerySelection();
            if (attr && hasSkipped) {
                MessageService.error($translate.instant("nav.photograph.content.js.photoSkip"));
            }
        }
        $scope.deleteBatchPhotos = function () {
            if (!$scope.moveGalleryIds.length) {
                MessageService.error($translate.instant("editorMessage.pleaseSelectAPhoto"));
                return
            }
            angular.forEach($scope.moveGalleryIds, function(id){
                angular.forEach($scope.template.pages.page, function (item, index) {
                    angular.forEach(item.levels.level, function (level) {
                        if (level.imagebox && level.imagebox.image && level.imagebox.image.resourceid == id) {
                            var box = level.imagebox
                            box.blurredrectangle = {
                                x: 0,
                                y: 0,
                                width: box.geometry.width,
                                height: box.geometry.height
                            }
                            box.imgUrl = "content/images/mask_souce.png";
                            box.image = {
                                resource: {
                                    identifier:"",
                                    provider: ''
                                },
                                filterResource: {
                                    identifier: '',
                                    provider: ''
                                },
                                offsetx: 0,
                                offsety: 0,
                                width: '',
                                height: '',
                                imgsize: '',
                                index: '',
                                parameter: [],
                                scale: 1,
                                angle: 0,
                            }
                        }
                    })
                });
            });
            Gallery.batchDelete($scope.moveGalleryIds, function () {
                MessageService.success($translate.instant("editorMessage.deleteSuccess"));
                // 若被选中的pic被删除，就重新生成该数组
                // vm.totalPhotoItems = vm.totalPhotoItems - $scope.moveGalleryIds.length
                vm.unusedQuantity = null;
                vm.oldQuantity = null;
                $scope.gallaryPic = [];
                $scope.moveGalleryIds = [];
                $scope.photos = [];
                //没有数据，页码置为0，重新调接口查询
                vm.indexNum = 0;
                vm.maxId = null;
                vm.minId = null;
                vm.totalPhotoItems = null;
                if (vm.folderId) {
                    loadAll(vm.folderId);
                } else {
                    loadAll('isNull');
                }
                magnitudeBox();
            }, function (error) {
                MessageService.error($translate.instant("editorMessage.deleteError"));
            });
        }
        // 图库照片处理状态：大图处理中/失败、色彩转换中/失败，无特殊状态返回''（正常展示照片）
        function getPhotoStatus(photo) {
            if (!photo) return '';
            if (photo.convertFlag == true && photo.convertStatus == 'running') return 'convertRunning';
            if (photo.convertStatus == 'error') return 'convertError';
            if ($scope.isLarge(photo.imageInfo)) {
                if (photo.largeFlag && photo.largeStatus == 'running') return 'largeRunning';
                if (photo.largeFlag && photo.largeStatus == 'error') return 'largeError';
            }
            return '';
        };
        // 是否处理失败状态（大图处理失败、色彩转换失败）
        function isPhotoFailed(photo) {
            var status = getPhotoStatus(photo);
            return status === 'largeError' || status === 'convertError';
        };
        // 当前 tab 下照片是否可见（"未使用" tab 会过滤掉已使用的照片）
        function isPhotoVisible(photo) {
            return !!photo && (vm.photosTab == 'all' || photo.usenum == 0);
        };
        // 照片是否允许被选中：当前 tab 可见 && 无任何处理中/失败状态（photoStatus 为 '' 才是正常可用）
        function isPhotoSelectable(photo) {
            return isPhotoVisible(photo) && getPhotoStatus(photo) === '';
        };
        // 选中集合的唯一出口：只把「当前可见 && 状态正常 && 已勾选」的照片计入 gallaryPic / moveGalleryIds。
        // choosePhoto、whetherChoose、ws 状态变更、列表重新加载都必须走这里，
        // 否则各入口各自维护会出现「UI 显示选中 / 实际不可用」或反之的不一致。
        function syncGallerySelection() {
            var gallaryPic = [];
            var moveGalleryIds = [];
            var photos = angular.isArray($scope.photos) ? $scope.photos : [];
            angular.forEach(photos, function (p) {
                if (!p || !isPhotoVisible(p)) return;
                // 照片可能在被选中之后才异步变成处理中/失败，此时强制取消选中
                if (!isPhotoSelectable(p)) {
                    p.select = false;
                    return;
                }
                if (p.select) {
                    gallaryPic.push(p);      //选择导入图片的数组
                    moveGalleryIds.push(p.id);
                }
            });
            $scope.gallaryPic = gallaryPic;
            $scope.moveGalleryIds = moveGalleryIds;
        };
        $scope.photoStatus = getPhotoStatus;
        $scope.isPhotoFailed = isPhotoFailed;
        $scope.isPhotoSelectable = isPhotoSelectable;
        // 处理失败的照片：点击弹出是否删除照片的确认框
        $scope.showDeletePhotoPop = function (photo, event) {
            if (event) {
                event.stopPropagation();
            }
            vm.pendingDeletePhoto = photo;
            vm.deletePhotoSure = true;
        };
        // 确认删除处理失败的照片，取消则仅关闭弹框
        $scope.deletePhotoConfirm = function () {
            var photo = vm.pendingDeletePhoto;
            if (!photo || !photo.id) {
                vm.deletePhotoSure = false;
                vm.pendingDeletePhoto = null;
                return;
            }
            var id = photo.id;
            Gallery.batchDelete([id], function () {
                MessageService.success($translate.instant("editorMessage.deleteSuccess"));
                // 清除画布中引用该照片的图片框
                angular.forEach($scope.template.pages.page, function (item) {
                    angular.forEach(item.levels.level, function (level) {
                        if (level.imagebox && level.imagebox.image && level.imagebox.image.resourceid == id) {
                            var box = level.imagebox;
                            box.blurredrectangle = {
                                x: 0,
                                y: 0,
                                width: box.geometry.width,
                                height: box.geometry.height
                            };
                            box.imgUrl = "content/images/mask_souce.png";
                            box.image = {
                                resource: {
                                    identifier: "",
                                    provider: ''
                                },
                                filterResource: {
                                    identifier: '',
                                    provider: ''
                                },
                                offsetx: 0,
                                offsety: 0,
                                width: '',
                                height: '',
                                imgsize: '',
                                index: '',
                                parameter: [],
                                scale: 1,
                                angle: 0
                            };
                        }
                    });
                });
                // 从本地列表及选中集合中移除
                var photos = angular.isArray($scope.photos) ? $scope.photos : ($scope.photos = []);
                for (var i = photos.length - 1; i >= 0; i--) {
                    if (photos[i] && photos[i].id === id) {
                        photos.splice(i, 1);
                    }
                }
                var gallaryPic = angular.isArray($scope.gallaryPic) ? $scope.gallaryPic : ($scope.gallaryPic = []);
                var picIndex = -1;
                for (var pi = 0; pi < gallaryPic.length; pi++) {
                    if (gallaryPic[pi] === photo || (gallaryPic[pi] && gallaryPic[pi].id === id)) {
                        picIndex = pi;
                        break;
                    }
                }
                if (picIndex > -1) {
                    gallaryPic.splice(picIndex, 1);
                }
                var moveGalleryIds = angular.isArray($scope.moveGalleryIds) ? $scope.moveGalleryIds : ($scope.moveGalleryIds = []);
                var idIndex = moveGalleryIds.indexOf(id);
                if (idIndex > -1) {
                    moveGalleryIds.splice(idIndex, 1);
                }
                if (vm.totalPhotoItems != null && vm.totalPhotoItems > 0) {
                    vm.totalPhotoItems--;
                }
                if (photo.usenum == 0) {
                    if (vm.unusedQuantity) {
                        vm.unusedQuantity = Math.max(0, vm.unusedQuantity - 1);
                    }
                    if (vm.unUsedImageboxsNum) {
                        vm.unUsedImageboxsNum = Math.max(0, vm.unUsedImageboxsNum - 1);
                    }
                }
                if (!$scope.photos.length) {
                    vm.isPhotoFinish = true;
                }
                magnitudeBox();
                vm.deletePhotoSure = false;
                vm.pendingDeletePhoto = null;
            }, function () {
                vm.deletePhotoSure = false;
                vm.pendingDeletePhoto = null;
                MessageService.error($translate.instant("editorMessage.deleteError"));
            });
        };
        //一键填充
        $scope.directFill= function(){
            vm.sumIndex = 0;
            if(!$scope.gallaryPic ||$scope.gallaryPic.length < 1){
                MessageService.confirm({
                    title:$translate.instant("editorPop.selectPhoto.title"),
                    confirm:$translate.instant("editorPop.selectPhoto.confirm"),
                    msg:$translate.instant("editorPop.selectPhoto.msg")
                },function(){})
                return
            }
            if($scope.gallaryPic.length < vm.counts-vm.current){
                vm.isDirectFill = true;
                return
            }
            directFill1()
        };
        $scope.directFillPage = function(){
            vm.sumIndex = 0;
            var picLayoutXmls = null;
            if(vm.picLayoutXmlsList && vm.picLayoutXmlsList.length>0 && !vm.pageData[vm.pageNumber].unreplace){
                var _imageboxNum = $scope.gallaryPic.length || 0;
                vm.pageData[vm.pageNumber].levels.level.forEach(function (level) {
                    if (level.imagebox && level.imagebox.image &&level.imagebox.image.resource && level.imagebox.image.resource.identifier) {
                        _imageboxNum++
                    }
                })
                for(var i=0; i<vm.picLayoutXmlsList.length; i++){
                    if(vm.picLayoutXmlsList[i].quantity == _imageboxNum){
                        if(vm.picLayoutXmlsList[i].data && vm.picLayoutXmlsList[i].data.length>0){
                            var picLayoutXmls = vm.picLayoutXmlsList[i].data[0];
                        }
                        break
                    }
                }
            }
            var notImageCounts = 0;
            vm.pageData[vm.pageNumber].levels.level.forEach(function (level) {
                if (level.imagebox && (!level.imagebox.image || !level.imagebox.image.resource || !level.imagebox.image.resource.identifier)) {
                    notImageCounts++;
                }
            })
            if(picLayoutXmls && vm.isLayout && notImageCounts < $scope.gallaryPic.length){
                setLevelImgeboxImg(vm.pageData[vm.pageNumber], $scope.gallaryPic);
                var galleryPic = $scope.gallaryPic.slice(vm.sumIndex);
                galleryPic.forEach(function (item, i) {
                    var _level = {
                        imagebox:{},
                        seq: vm.pageData[vm.pageNumber].levels.level.length + Number(1)
                    }
                    var _imagebox = {
                        blurredrectangle:null,
                        bokehtype: angular.copy(vm.article.bokehtype),
                        geometry:{
                            width:0,
                            height:0,
                            x:0,
                            y:0
                        },
                        border: null,
                        shadow:{
                            color:'#777777',
                            x:0,
                            y:0,
                            blur:0
                        },
                        image: {
                            resource: {
                                identifier: item.identifier,
                                provider: 'qiniu'
                            },
                            filterResource: {
                                identifier: '',
                                provider: 'qiniu'
                            },
                            resourceid:item.sourceId,
                            width: item.width,
                            height: item.height,
                            imageInfo: item.imageInfo,
                            imgSize: item.imgSize,
                            index: item.seq,
                            parameter: angular.fromJson(item.parameter),
                            scale: 1,
                            angle: 0,
                        },
                        transparency:1,
                        mask: {
                            resource:{
                                identifier: '',
                                provider: '',
                            }
                        },
                        rotation:{
                            angle: 0
                        }
                    }
                    var w = 200 / vm.pageData[vm.pageNumber].custom.ratio;
                    var h = 200 / vm.pageData[vm.pageNumber].custom.ratio;
                    var imgR = w/h;
                    var imgR1 = item.width/item.height;
                    if(imgR >= imgR1){
                        _imagebox.geometry.width= h/item.height*item.width;
                        _imagebox.geometry.height= h;
                    }else {
                        _imagebox.geometry.width= w;
                        _imagebox.geometry.height= w/item.width*item.height;
                    }
                    _imagebox.geometry.x = 0;
                    _imagebox.geometry.y = 0;
                    _level.imagebox = _imagebox;
                    addImagebox($http, _level.imagebox,function(){
                        vm.pageData[vm.pageNumber].levels.level.push(_level);
                    });
                })
                $timeout(function () {
                    $scope.addLayout(picLayoutXmls);
                    photosNum();
                    imageSelectInit();
                    magnitudeBox();
                    onArticleChange();
                    thumbnailInit();
                    $scope.whetherChoose(false);
                })
                return
            }
            if(notImageCounts == 0){
                MessageService.error("页面已填充满");
            }else{
                setLevelImgeboxImg(vm.pageData[vm.pageNumber], $scope.gallaryPic);
                photosNum();
                imageSelectInit();
                magnitudeBox();
                onArticleChange();
                thumbnailInit();
                $scope.whetherChoose(false);
            }
        }
        $scope.fillPage = function(){
            directFill1()
        }
        function directFill1(){
            vm.isDirectFill = false;
            if(vm.isLayout && ($scope.gallaryPic.length > vm.counts-vm.current && vm.picLayoutXmlsList.length>0) && (vm.article.editorType == 'BOOK_JUNIOR' || vm.article.editorType == 'BOOK_SENIOR' || vm.article.editorType == 'NEW_EDITOR' || vm.article.editorType == 'CALENDAR_EDITOR')){
                angular.forEach(vm.pageData, function (page) {page.isFill = false;})
                directFillCb1($scope.gallaryPic)
            }else{
                angular.forEach(vm.pageData, function (page) {
                    setLevelImgeboxImg(page, $scope.gallaryPic);
                })
                photosNum();
                imageSelectInit();
                magnitudeBox();
                onArticleChange();
                thumbnailInit();
                $scope.whetherChoose(false);
            }
        }
        //随机布局
        $scope.stochastic = function () {
            vm.sumIndex = 0;
            vm.galleriesAll = [];
            angular.forEach(vm.pageData, function (page) {
                page.isFill = false;
                angular.forEach(page.levels.level, function (level, i) {
                    if (level.imagebox) {
                        if (level.imagebox.image && level.imagebox.image.resource && level.imagebox.image.resource.identifier) {
                            vm.galleriesAll.push({
                                imageInfo: level.imagebox.image.imageInfo,
                                height: level.imagebox.image.height,
                                id: level.imagebox.image.resourceid,
                                identifier: level.imagebox.image.resource.identifier,
                                imgsize: level.imagebox.image.imgsize,
                                name: null,
                                provider: "qiniu",
                                width: level.imagebox.image.width
                            })
                            level.imagebox.image.imageInfo = null;
                            level.imagebox.image.resourceid = null;
                            level.imagebox.image.resource.identifier = null;
                            level.imagebox.image.imgsize = null;
                            level.imagebox.image.height = null;
                            level.imagebox.image.width = null;
                        }
                    }
                })
            })
            directFillCb1(vm.galleriesAll)
        }
        function directFillCb1(gallaryPic){
            directFillCb(true, gallaryPic);
            var notPageCounts=0;
            var pages=[];
            angular.forEach(vm.pageData, function (page, index) {
                page.uuid1 = getUuid();
                if(!page.isFill){
                    notPageCounts++;
                    pages.push(page)
                }
            });
            if(pages.length == 0){
                MessageService.error($translate.instant("editorMessage.fillWith"));
                photosNum();
                imageSelectInit();
                magnitudeBox();
                $scope.whetherChoose(false);
                return;
            }
            randomPlacement(Convert,Algorithm, pages,vm.picLayoutXmlsList,gallaryPic, vm.sumIndex, function (pages, notLike) {
                if(notLike){
                    MessageService.error($translate.instant("editorMessage.layoutNotFound"));
                }
                angular.forEach(pages, function (page) {
                    page.isFill = true;
                    setLevelImgeboxImg(page, gallaryPic);
                })
                photosNum();
                imageSelectInit();
                magnitudeBox();
                $scope.whetherChoose(false);
            })
        }
        function directFillCb(item, gallaryPic){
            angular.forEach(vm.pageData, function (page, index) {
                if(item == page.unreplace){
                    page.isFill = true;
                    setLevelImgeboxImg(page, gallaryPic);
                }else{
                    var _isNotImg = false;
                    var _isNotImg1 = false;
                    angular.forEach(page.levels.level, function (level, i) {
                        if(level.imagebox){
                            if(level.imagebox.image && level.imagebox.image.resource && level.imagebox.image.resource.identifier){
                                _isNotImg = true;
                            }else{
                                _isNotImg1 = true;
                            }
                        }
                    });
                    if(_isNotImg && _isNotImg1){
                        page.isFill = true;
                        setLevelImgeboxImg(page, gallaryPic);
                    }
                    if(_isNotImg && !_isNotImg1){
                        page.isFill = true;
                    }
                }
            })
        }
        function setLevelImgeboxImg(page, gallaryPic){
            angular.forEach(page.levels.level, function (level, i) {
                if(level.imagebox){
                    if(!level.imagebox.image){
                        level.imagebox.image= {
                            resource: {
                                identifier: '',
                                provider: ''
                            },
                            filterResource: {
                                identifier: '',
                                provider: 'qiniu'
                            },
                            scale: 1,
                            angle: 0
                        };
                    }
                    if(!level.imagebox.image.resource){
                        level.imagebox.image.resource = {
                            identifier:''
                        }
                    }
                    if(!level.imagebox.image.resource.identifier){
                        var _imagebox = angular.copy(gallaryPic[vm.sumIndex]);
                        if(!_imagebox){
                            return false
                        }
                        vm.sumIndex++
                        level.imagebox.image.resourceid = _imagebox ? _imagebox.id : '';
                        level.imagebox.image.resource.identifier = _imagebox ? _imagebox.identifier : '';
                        level.imagebox.image.resource.provider = _imagebox ? _imagebox.provider : 'qiniu';
                        level.imagebox.image.width = _imagebox ? _imagebox.width : '';
                        level.imagebox.image.height = _imagebox ? _imagebox.height : '';
                        level.imagebox.image.imageInfo = _imagebox ? _imagebox.imageInfo : '';
                        level.imagebox.image.imgSize = _imagebox ? _imagebox.imgSize : '';
                        level.imagebox.image.index = _imagebox ? _imagebox.seq : '';
                        level.imagebox.image.parameter = _imagebox ? angular.fromJson(_imagebox.parameter) : [];
                        if(level.imagebox.image.resource.identifier){
                            addImagebox($http, level.imagebox, function () {})
                        }
                    }
                }
            })
        }

        vm.photosNum = photosNum;
        function photosNum(){
            for(var i=0; i<$scope.photos.length; i++){
                var _photo = $scope.photos[i];
                _photo.usenum=0;
                angular.forEach(vm.pageData, function (page, index) {
                    angular.forEach(page.levels.level, function (level, i) {
                        if(level.imagebox && level.imagebox.image && level.imagebox.image.resourceid) {
                            if (level.imagebox.image.resourceid == _photo.sourceId) {
                                _photo.usenum++
                            }
                        }
                    })
                })
            }
            if(vm.photosTab!='all'){
                $scope.switchBgTab();
            }
            recommendInit($scope.template);
            unusedQuantity();
        }

        $scope.uploadPic = function () {
            uploadAble(StoreStorages,vm.storeId, function (res) {
                if(res.status == 200){
                    $timeout(function () {
                        var uploadInput = document.getElementById('uploadImg2');
                        if (uploadInput) {
                            uploadInput.click();
                        }
                    }, 0, false);
                }else{
                    if(res.status == 400){MessageService.error('系统出错');}
                    else {
                        MessageService.error(res.data||'系统出错');
                    }
                }
            })
        }
        /**
         * 从文件对象中获取图片宽高（解决浏览器对超大图无法自动获取尺寸的问题）
         * 对于超大图(>100M像素)，通过解析图片文件头部信息来获取尺寸，避免浏览器解码限制
         */
        function getImageDimensions(file) {
            return new Promise(function(resolve) {
                // 如果浏览器已经提供了width和height，且值合法，直接使用
                if (file.width > 0 && file.height > 0) {
                    resolve({ width: file.width, height: file.height });
                    return;
                }
                var url = window.URL || window.webkitURL;
                var objectUrl = url.createObjectURL(file);
                var img = new Image();
                img.onload = function() {
                    url.revokeObjectURL(objectUrl);
                    resolve({ width: img.naturalWidth || img.width, height: img.naturalHeight || img.height });
                };
                img.onerror = function() {
                    url.revokeObjectURL(objectUrl);
                    // Image解码失败（通常是因为图片太大超出浏览器canvas限制）
                    // 回退：通过解析文件头部的二进制数据获取尺寸
                    parseImageHeaderForDimensions(file).then(resolve).catch(function() {
                        resolve({ width: 0, height: 0 }); // 彻底失败时返回0，会被当作大图处理
                    });
                };
                img.src = objectUrl;
            });
        }

        /**
         * 通过解析图片文件头部二进制数据获取宽高（不需要完整解码图片）
         * 支持JPEG、PNG格式，适用于超大图
         */
        function parseImageHeaderForDimensions(file) {
            return new Promise(function(resolve, reject) {
                var reader = new FileReader();
                reader.onload = function(e) {
                    try {
                        var buffer = new Uint8Array(e.target.result);
                        var result;
                        if (buffer[0] === 0xFF && buffer[1] === 0xD8) {
                            // JPEG 格式 - 查找 SOF0 标记
                            result = parseJpegDimensions(buffer);
                        } else if (buffer[0] === 0x89 && buffer[1] === 0x50) {
                            // PNG 格式 - IHDR chunk
                            result = parsePngDimensions(buffer);
                        } else {
                            throw new Error('Unsupported format');
                        }
                        if (result) {
                            resolve(result);
                        } else {
                            reject(new Error('Cannot parse dimensions'));
                        }
                    } catch(err) {
                        reject(err);
                    }
                };
                // 只读取前64KB就足够获取大多数图片的尺寸信息
                reader.readAsArrayBuffer(file.slice(0, 65536));
            });
        }

        /** 解析JPEG文件头部获取宽高 */
        function parseJpegDimensions(buffer) {
            var offset = 2;
            while (offset < buffer.length) {
                if (buffer[offset] !== 0xFF) { offset++; continue; }
                var marker = buffer[offset + 1];
                if (marker === 0xC0 || marker === 0xC2) {
                    // SOF0 (baseline) 或 SOF2 (progressive)
                    var height = (buffer[offset + 5] << 8) | buffer[offset + 6];
                    var width = (buffer[offset + 7] << 8) | buffer[offset + 8];
                    return { width: width, height: height };
                }
                // 跳过其他标记段
                var segLength = (buffer[offset + 2] << 8) | buffer[offset + 3];
                offset += 2 + segLength;
            }
            return null;
        }

        /** 解析PNG文件IHDR chunk获取宽高 */
        function parsePngDimensions(buffer) {
            // PNG签名后8字节是IHDR长度(固定为13)，再后面4字节是"IHDR"
            // 然后是4字节width + 4字节height（大端序）
            if (buffer.length < 24) return null;
            var width = (buffer[16] << 24) | (buffer[17] << 16) | (buffer[18] << 8) | buffer[19];
            var height = (buffer[20] << 24) | (buffer[21] << 16) | (buffer[22] << 8) | buffer[23];
            return { width: width, height: height };
        }

        var bigSizePics = [];
        window.updatePic = function ($event) {
            vm.successNumber = 0;//上传成功数量
            vm.errorNumber = 0;//上传失败数量
            var oldlength = $event.target.files.length;
            filterFiles($event.target.files).then(function(filterFilesList) {
            var newlength = filterFilesList.length;
            if (newlength < oldlength) {
                MessageService.error($translate.instant("editorMessage.updatePicError"));
            }
            $timeout(function () {
                vm.picLoading = true;
                var len = $scope.photos.length;
                var files = [];
                bigSizePics = [];

                for (var i = 0; i < filterFilesList.length; i++) {
                    var f = filterFilesList[i];
                    f.imageSize = Math.ceil(f.size/1024/1024);
                    files.push(f)
                }
                if (files.length == 0) {
                    vm.picLoading = false;
                    return
                }

                // 先批量获取所有文件的图片尺寸，然后再分类处理
                var dimPromises = files.map(function(file) {
                    return getImageDimensions(file).then(function(dim) {
                        file.width = dim.width;
                        file.height = dim.height;
                        return file;
                    });
                });

                Promise.all(dimPromises).then(function(processedFiles) {
                    console.log('processedFiles with dimensions:', processedFiles.map(function(f){return {name:f.name,w:f.width,h:f.height};}));
                    var uploadPromises = [];
                    for (var i = 0; i < processedFiles.length; i++) {
                        var file = processedFiles[i];
                        if (file.size>=50*1024*1024 || (file.width*file.height > 400000000)){
                            file.imageSize= Math.ceil(file.size/1024/1024);
                            bigSizePics.push(file);
                        }else{
                            uploadPromises.push(getBgImg(processedFiles, i, len));
                            if (bigSizePics.length==0 && i == (processedFiles.length-1)) {
                                setTimeout(function () {
                                    angular.forEach($scope.photos, function (item, j) {
                                        item.index = j;
                                    });
                                }, 400)
                            }
                        }
                    }
                    // 等待所有上传完成后打印重复图片列表
                    Promise.all(uploadPromises).then(function() {
                        console.log('重复图片列表:', vm.duplicateList);
                        if(vm.duplicateList.length > 0){
                            MessageService.confirm({
                                title :'提示',
                                cancel :'取消',
                                confirm :'确认',
                                msg :'检测到图库中有'+vm.duplicateList.length+'张重复图片，是否需要自动去重？',
                                html: '<span class="themecolor themecolor-btn" style="color: {{webMainButtonBackColor}}">查看重复图片</span>'
                            }, function(res) {
                                if(res == 'htmlClick'){
                                    vm.isDuplicateList = true;
                                    console.log('vm.isDuplicateList',vm.isDuplicateList);
                                }else{
                                    var ids = [];
                                    vm.duplicateList.forEach(function (item){
                                        ids.push(item.id)
                                    })
                                    Gallery.batchDelete(ids, function () {
                                        MessageService.success("去重成功！");
                                        $scope.gallaryPic = [];
                                        $scope.moveGalleryIds = [];
                                        vm.indexNum = 0;
                                        vm.totalPhotoItems = null;
                                        vm.maxId = null;
                                        vm.minId = null;
                                        $scope.photos = [];
                                        vm.duplicateList=[];
                                        if (vm.folderId) {
                                            loadAll(vm.folderId);
                                        } else {
                                            loadAll('isNull');
                                        }
                                    }, function (error) {
                                        MessageService.error("删除失败！");
                                        vm.duplicateList=[];
                                    });
                                }
                            },function (){
                                vm.duplicateList=[];
                            })
                        }
                        if (bigSizePics.length > 0) {
                            thumbnailatorPic();
                        }
                    });
                    $event.srcElement.value = "";
                }).catch(function(err) {
                    console.error('获取图片尺寸出错:', err);
                    // 出错时将所有文件当作普通图处理
                    for (var i = 0; i < files.length; i++) {
                        getBgImg(files, i, len);
                        if (i == (files.length-1)) {
                            setTimeout(function () {
                                angular.forEach($scope.photos, function (item, j) {
                                    item.index = j;
                                });
                            }, 400)
                        }
                    }
                    $event.srcElement.value = "";
                });
            })
            });
        };

        var uploadFailedList = []; //临时存储上传失败图片
        function getBgImg(files, i, len) {
            return new Promise(function(resolve) {
                CommonService.UpdateQiniuService(files, i, len, $scope.domain, vm.token, vm.folderId,(vm.article.articleId || vm.article.id),function (resp) {
                    console.log(resp);
                    if(resp.data.duplicate){
                        vm.duplicateList.push(resp.data)
                    }
                    vm.successNumber++;
                    if (vm.successNumber + vm.errorNumber >= files.length) {
                        vm.picLoading = false;
                        document.getElementById('uploadImg2').value = '';
                        if (vm.errorNumber > 0) {
                            vm.errorAlertPopup = true;
                        }
                        $scope.photoSortChange(vm.photoSort);
                    }
                    resolve(resp);
                },function(errorFile,executionCompleted){
                    uploadFailedList.push(errorFile);
                    vm.errorNumber++;
                    if (vm.successNumber + vm.errorNumber >= files.length) {
                        $timeout(function(){
                            vm.picLoading = false;
                            vm.uploadFailedList = uploadFailedList;
                            uploadFailedList = [];
                            vm.errorAlertPopup = true;
                            document.getElementById('uploadImg2').value = '';
                            $scope.photoSortChange(vm.photoSort);
                            $scope.$apply();
                        })
                    };
                    resolve();
                },true)
            });
        }

        $scope.duplicateChange = function (){
            vm.isDuplicateList = false;
            vm.duplicateList=[];
            vm.maxId = null;
            vm.minId = null;
            vm.totalPhotoItems = null;
            $scope.gallaryPic = [];
            $scope.moveGalleryIds = [];
            $scope.photos = [];
            vm.indexNum = 0;
            if(vm.folderId){
                loadAll(vm.folderId);
            } else {
                loadAll('isNull');
            }
            if (bigSizePics.length >0) {
                thumbnailatorPic();
            }
        }

        $scope.errorAlertPopupClose = function(){
            vm.errorAlertPopup = false;
            vm.uploadFailedList = [];
        }

        $scope.errorPhotoView = function(){
            $uibModal.open({
                templateUrl: 'app/entities/page-compontents/uploadFailedImageListPopup.html',
                controller: 'UploadFailedImageListPopupController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: [function() {
                        return vm.uploadFailedList;
                    }]
                }
            }).result.then(function (flag) {
                if (flag) {
                    var files = vm.uploadFailedList;
                    for (var i = 0; i < files.length; i++) {
                        getBgImg(files, i);
                    }
                    vm.successNumber = 0;//上传成功数量
                    vm.errorNumber = 0;//上传失败数量
                    vm.picLoading = true;
                    vm.errorAlertPopup = false;
                    vm.uploadFailedList = [];
                }else{
                    vm.errorAlertPopup = false;
                    vm.uploadFailedList = [];
                }
            });
        }

        function thumbnailatorPic(){
            $uibModal.open({
                templateUrl: 'app/entities/page-compontents/thumbnailator.html',
                controller: 'ThumbnailatorController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('editorWeb');
                        return $translate.refresh();
                    }],
                    entity: [function() {
                        return {
                            files: bigSizePics,
                            aid:(vm.article.articleId || vm.article.id),
                            folderId:vm.folderId,
                            domain:$scope.domain,
                            token:vm.token,
                            detectFaces:false
                        };
                    }]
                }
            }).result.then(function (values) {
                bigSizePics=[];
                if(values){
                    for (var j = 0; j < values.length; j++) {
                        var value = values[j];
                        $scope.photos.unshift(value);
                    }
                    vm.picLoading = false;
                    setTimeout(function () {
                        angular.forEach($scope.photos, function (item, z) {
                            item.index = z;
                        });
                    }, 400)
                }
            }, function(){
                vm.picLoading = false;
                vm.refreshPhotos()
            });
        }

        //转移照片
        $scope.moveToFolder = function () {
            if ($scope.gallaryPic.length < 1) {
                MessageService.error($translate.instant("editorMessage.pleaseSelectAPhoto"));
                return
            }
            vm.isMoveToFolder = true;
        }
        $scope.chooseFolder = function (folder, index) {
            vm.selectFolderId = null;
            folder.selected = !folder.selected;
            angular.forEach($scope.Folders, function (f, i) {
                if (index != i) {
                    f.selected = false;
                }
            })
            if (folder.selected) {
                vm.selectFolderId = folder.id;
            }
        }

        $scope.chooseFolder2 = function(){
            angular.forEach($scope.Folders, function (f, i) {
                f.selected = false;
            })
            vm.selectFolderId = -1;
        }
        $scope.saveMoveToFolder = function () {
            if (vm.selectFolderId == null) {
                MessageService.error($translate.instant("editorMessage.pleaseSelectAFolder"));
                return
            }
            $scope.moveGalleryIds = [];
            angular.forEach($scope.gallaryPic, function (p, i) {
                $scope.moveGalleryIds.push(p.id);
            })

            Gallery.moveFolder({
                galleries: $scope.moveGalleryIds,
                folderId: vm.selectFolderId === -1 ? null : vm.selectFolderId
            }, function () {
                angular.forEach($scope.Folders, function (f, i) {
                    f.selected = false;
                })
                $scope.gallaryPic = [];
                $scope.moveGalleryIds = [];
                vm.unusedQuantity = null;
                vm.oldQuantity = null;
                vm.indexNum = 0;
                vm.maxId = null;
                vm.minId = null;
                vm.totalPhotoItems = null;
                $scope.photos = [];
                vm.isMoveToFolder = false;
                if (vm.folderId) {
                    loadAll(vm.folderId);
                } else {
                    loadAll('isNull');
                }
            })
        }

        //手机传图
        vm.qrcodeShow = false;
        vm.fid = 0;
        var qrcode = null;
        var newCreateDate = 0;
        $scope.uploadByPhone = function () {
            uploadAble(StoreStorages,vm.storeId, function (res) {
                if(res.status == 200){
                    vm.qrcodeShow = !vm.qrcodeShow;
                    if (qrcode != null) {
                        // qrcode.clear();
                        $('#qrcode1').html("");
                    }

                    //vm.folderId -----某一文件夹信息
                    if (vm.folderId == undefined || vm.folderId == null) {
                        vm.fid = 0;
                    } else {
                        vm.fid = vm.folderId;
                    }
                    console.log('' + vm.platformSetting.editorNotifyUrl + "/" + vm.storeId + "/" + vm.fid + "/gallery/" + (vm.article.articleId || vm.article.id)+'?ticket='+vm.article.ticket);
                    if (vm.article.ticket) {
                        qrcode = $('#qrcode1').qrcode({
                                render: "canvas",
                                width: 150,
                                height: 150,
                                text: '' + vm.platformSetting.editorNotifyUrl + "/" + vm.storeId + "/" + vm.fid + "/gallery/" + (vm.article.articleId || vm.article.id)+'?ticket='+vm.article.ticket
                            });
                    }else{
                        Article.getPhonePicToken({id:(vm.article.articleId || vm.article.id)}, function(data){
                            // 手机传图二维码
                            qrcode = $('#qrcode1').qrcode({
                                render: "canvas",
                                width: 150,
                                height: 150,
                                text: '' + vm.platformSetting.editorNotifyUrl + "/" + vm.storeId + "/" + vm.fid + "/gallery/" + (vm.article.articleId || vm.article.id)+'?auth='+data.data
                            });
                        },function(){
                    })
                    }
                }else{
                    if(res.status == 400){MessageService.error('系统出错');}
                    else {
                        MessageService.error(res.data||'系统出错');
                    }
                }
            })
        }

        function onSuccessToPhone(data) {
            if (data.data == null || data.data.length == 0) {
                return;
            }
            var loadCreateDate = new Date(data.data[0].createdDate).getTime();
            for (var i = 0; i < data.data.length; i++) {
                var d = data.data[i];
                if(vm.temp.indexOf(d.id)<0){
                    if (new Date(d.createdDate).getTime() > newCreateDate) {
                        d.identifier = $scope.domain + d.identifier;
                        d.select = false;
                        d.index = i;
                        d.name2 = ModulesService.splitFileName(d.name);
                        $scope.photos.unshift(d);
                        vm.totalPhotoItems++
                    } else {
                        newCreateDate = loadCreateDate;
                        break;
                    }
                }
            }
            if (newCreateDate == 0) {
                newCreateDate = loadCreateDate;
            }
        }
        $scope.uploadByPhone1 = function(){
            vm.qrcodeShow = false;
            $scope.photoSortChange(vm.photoSort)
            // clearInterval(phonetimer);
        }
        /***********************  相框  ****************************/
        vm.rahmenPage = 0;
        vm.rahmenInit = rahmenInit;
        vm.masklabelsFulfill = false;
        $scope.showMaskLabels = false;
        vm.maskLoading = false;
        vm.masklabelCb = masklabelCb;
        vm.maskList = [];
        $scope.showMoreMaskLabels = function () {
            $scope.showMaskLabels = !$scope.showMaskLabels;
        }
        function rahmenInit(item) {
            vm.maskLoading = true;
            vm.masklabelChooseId = item;
            if(item.id){
                Material.byCondition3({
                    items: [
                        {key: "themeClassify.id", op: "=", value: item.id}],
                    page: vm.rahmenPage,
                    size: vm.itemsPerPage,
                    sort: ["seq,asc"]
                }, function (res, headers) {
                    var _sum = headers('X-Total-Count');
                    angular.forEach(res.data, function (resp) {
                        var arr = {
                            type:'masking',
                            name: resp.name,
                            identifier: $scope.domain + resp.identifier,
                            provider: resp.provider,
                            themeClassifyName: resp.themeClassifyName,
                            themeClassifyId: resp.themeClassifyId,
                            resource: {
                                identifier: $scope.domain + resp.identifier,
                                provider: resp.provider,
                            }
                        }
                        vm.maskList.push(arr);
                    })
                    vm.maskLoading = false;
                    if(vm.maskList.length < _sum){
                        vm.masklabelsFulfill = true;
                    }else {
                        vm.masklabelsFulfill = false;
                    }
                }, function () {
                    vm.maskLoading = false;
                })
            }else{
                $scope.template.masks.mask.forEach(function (mask) {
                    var arr = {
                        type:'masking',
                        name: "",
                        identifier: mask.resource.identifier,
                        provider: "",
                        themeClassifyName: $translate.instant("button.recommend"),
                        themeClassifyId: "",
                        resource: {
                            identifier: mask.resource.identifier,
                            provider: mask.resource.provider,
                        }
                    }
                    vm.maskList.push(arr);
                })
                vm.maskLoading = false;
            }
        }
        function masklabelCb(item){
            vm.maskList = [];
            vm.rahmenPage = 0;
            rahmenInit(item)
        }
        $scope.loadMoreMasks = function () {
            vm.rahmenPage++;
            rahmenInit(vm.masklabelChooseId)
        }


        /***********************  素材  ****************************/
        vm.clipArtsList = [];
        vm.clipArtsPage = 0;
        vm.clipArtLoading = false;
        vm.clipArtChooseId = "";
        vm.clipArtCb = clipArtCb;
        function clipArtInit(item) {
            if(!item){return}
            vm.clipArtChooseId = item;
            if(item.id){
                vm.clipArtLoading = true;
                ClipArt.byCondition3({
                    items: [
                        {key: "themeClassify.id", op: "=", value: item.id}],
                    page: vm.clipArtsPage,
                    size: vm.itemsPerPage,
                    sort: ["seq,asc"]
                }, function (res, headers) {
                    var _sum = headers('X-Total-Count');
                    angular.forEach(res.data, function (resp) {
                        var arr = {
                            name: resp.name,
                            identifier: $scope.domain + resp.identifier,
                            provider: resp.provider,
                            themeClassifyName: resp.themeClassifyName,
                            themeClassifyId: resp.themeClassifyId,
                            resource: {
                                identifier: $scope.domain + resp.identifier,
                                provider: resp.provider,
                            }
                        }
                        vm.clipArtsList.push(arr);
                    })
                    vm.clipArtLoading = false;
                    if(vm.clipArtsList.length < _sum){
                        vm.clipArtFulfill = true;
                    }else {
                        vm.clipArtFulfill = false;
                    }
                }, function () {
                    vm.clipArtLoading = false;
                })
            }else{
                $scope.template.cliparts.clipart.forEach(function (clipart) {
                    var arr = {
                        name: "",
                        identifier: clipart.resource.identifier,
                        provider: "",
                        themeClassifyName: $translate.instant("button.recommend"),
                        themeClassifyId: "",
                        resource: clipart.resource
                    }
                    vm.clipArtsList.push(arr);
                })
                vm.clipArtLoading = false;
            }
        }
        function clipArtCb(item){
            vm.clipArtsList = [];
            vm.clipArtsPage = 0;
            clipArtInit(item)
        }
        $scope.loadMoreClipArt = function () {
            vm.clipArtsPage++;
            clipArtInit(vm.clipArtChooseId)
        }
        /***********************  文字  ****************************/
        vm.fontXmlList = [];
        vm.fontPage = 0;
        vm.fontLoading = false;
        vm.fontChooseId = "";
        $scope.showfontdocLabels = false;
        vm.fontlabelCb = fontlabelCb;
        function fontInit(item) {
            if(!item){
                return
            }
            vm.fontLoading = true;
            vm.fontChooseId = item;
            FontXmlsManger.byCondition({
                items: [
                    {key: "themeClassify.id", op: "=", value: item.id}],
                page: vm.fontPage,
                size: vm.itemsPerPage,
                sort: ["id,desc"]
            }, function (res, headers) {
                var _sum = headers('X-Total-Count');
                vm.fontXmlList = res.data;
                vm.fontLoading = false;
                if(vm.fontXmlList.length < _sum){
                    vm.fontFulfill = true;
                }else {
                    vm.fontFulfill = false;
                }
            }, function () {
                vm.fontLoading = false;
            })
        }
        function fontlabelCb(item){
            vm.fontXmlList = [];
            vm.fontPage = 0;
            fontInit(item)
        }
        // $scope.loadMoreClipArt = function () {
        //     vm.fontPage++;
        //     fontInit(vm.fontChooseId)
        // }
        $scope.showMorefontdocLabels = function () {
            $scope.showfontdocLabels = !$scope.showfontdocLabels;
        }

        $scope.editFont = function () {
            vm.editFailedFont = false;
            // $scope.doubleClicktext(vm.failedFontArr.e,vm.failedFontArr.textbox)
        }
        /***********************  背景  ****************************/
        vm.colorArr1 = ['#ffffff', '#666666', '#7babaf', '#e69594', '#93a9da', '#eac8fb'];
        vm.colorArr2 = ['#000000', '#666666', '#a8a8a8', '#d9d9d9', '#ffffff', '#647c6e', '#ff5b5c', '#ffbd4a', '#fef952', '#99e264', '#36b72a', '#44d9e5', '#c27171', '#2fb3ff', '#b760a6'];

        vm.bgImgList = [];
        vm.bgImgPage = 0;
        vm.bgImgChooseId = "";
        $scope.showbgImgdocLabels = false;
        vm.bgImglabelCb = bgImglabelCb;
        function bgImgInit(item) {
            if(!item){
                return
            }
            vm.bgImgChooseId = item;
            if(item.id){
                Backgrounds.byCondition3({
                    items: [
                        {key: "themeClassify.id", op: "=", value: item.id}],
                    page: vm.bgImgPage,
                    size: vm.itemsPerPage,
                    sort: ["seq,asc"]
                }, function (res, headers) {
                    angular.forEach(res.data, function (resp) {
                        var arr = {
                            name: resp.name,
                            identifier: $scope.domain + resp.identifier,
                            provider: resp.provider,
                            themeClassifyName: resp.themeClassifyName,
                            themeClassifyId: resp.themeClassifyId,
                            resource: {
                                identifier: $scope.domain + resp.identifier,
                                provider: resp.provider,
                            }
                        }
                        vm.bgImgList.push(arr);
                    })
                    var _sum = headers('X-Total-Count');
                    if(vm.bgImgList.length < _sum){
                        vm.bgImgFulfill = true;
                    }else {
                        vm.bgImgFulfill = false;
                    }
                }, function () {
                })
            }else{
                $scope.template.bgimgs2.bgimg.forEach(function (bgimg) {
                    var arr = {
                        name: "",
                        identifier: bgimg.identifier,
                        provider: "",
                        themeClassifyName: $translate.instant("button.recommend"),
                        themeClassifyId: "",
                        resource: {
                            identifier: bgimg.identifier,
                            provider: bgimg.provider,
                        }
                    }
                    vm.bgImgList.push(arr);
                })
                vm.bgImgFulfill = false;
            }
        }
        function bgImglabelCb(item){
            vm.bgImgList = [];
            vm.bgImgPage = 0;
            bgImgInit(item)
        }
        $scope.loadMoreBgImg = function () {
            vm.bgImgPage++;
            bgImgInit(vm.bgImgChooseId)
        }
        $scope.showMorebgImgdocLabels = function () {
            $scope.showbgImgdocLabels = !$scope.showbgImgdocLabels;
        }
        /***********************  换书  ****************************/
        vm.tempCategories = [];
        vm.tempList = {};
        function templateInit() {
            vm.tempCategories = [];
            Product.get({id: productId, cancelled: false}, function (res) {
                vm.product = res.data;
                vm.productTitle = res.data.name;
                // vm.article.productBokeh = resp.data.productBokeh;
                // vm.article.productBokehType = resp.data.productBokehType;
                // if (!resp.data.productBokeh) {
                //     vm.article.bokehtype = 'None';
                // } else {
                //     vm.article.bokehtype = resp.data.productBokehType;
                // }
                vm.article.productBokeh = res.data.bokehType;
                vm.article.productBokehType = res.data.bokehType;
                if (!res.data.bokehType) {
                    vm.article.bokehtype = 'None';
                } else {
                    vm.article.bokehtype = res.data.bokehType;
                }


                for (var i = 0; i < res.data.itemValues.length; i++) {
                    var itemValue = res.data.itemValues[i];
                    if (itemValue.cancelled) {
                        continue;
                    }
                    if (itemValue.id == vm.article.itemValueId && itemValue.productXmlLines && itemValue.productXmlLines.length>0) {
                        vm.tempList = angular.copy(itemValue);
                    }
                }
                if(vm.tempList && vm.tempList.productXmlLines){
                    angular.forEach(vm.tempList.productXmlLines, function (line, i) {
                        if (line.themeClassifies && !line.cancelled && line.paid) {
                            line.themeClassifies.forEach(function (themeClassifie) {
                                if (vm.tempCategories.indexOf(themeClassifie.name) == -1 && themeClassifie.name != null) {
                                    vm.tempCategories.push(themeClassifie.name);
                                }
                            })
                        }
                    })
                    if (vm.tempCategories.length) {
                        $scope.selectCategory(vm.tempCategories[0])
                    }
                }
            })
        }
        $scope.showCategories = false;
        $scope.showMoreCategories = function () {
            $scope.showCategories = !$scope.showCategories;
        }
        $scope.selectCategory = function (c) {
            $scope.categoryNow = {
                label: c
            };
        };
        $scope.productXmlShow = function(themeClassifies){
            var _exist = false;
            themeClassifies.forEach(function (themeClassifie) {
                if ($scope.categoryNow.label ==  themeClassifie.name) {
                    _exist = true;
                }
            })
            return _exist
        }
        //预览
        $scope.tempPreview = function (temp) {
            ModulesService.pagePreview(temp,false);
        };
        //分类
        function classifyInit(item){
            ThemeClassify.getAllByCondition4({
                type: item,
                storeId: vm.storeId
            }, function (res) {
                if(item == 'Material'){
                    vm.masklabels = [];
                    if($scope.template.masks && $scope.template.masks.mask && $scope.template.masks.mask.length>0){
                        vm.masklabels.push({
                            id: "",
                            name: $translate.instant("button.recommend"),
                            seq: 0,
                            type: "MASK",
                            used: true,
                        });
                    }
                    vm.masklabels = vm.masklabels.concat(res.data || []);
                    vm.rahmenPage = 0;
                    vm.maskList = [];
                    rahmenInit(vm.masklabels[0])
                }
                if(item == 'ClipArt'){
                    vm.clipArts = [];
                    if($scope.template.cliparts && $scope.template.cliparts.clipart && $scope.template.cliparts.clipart.length>0){
                        vm.clipArts = [{
                            id: "",
                            name: $translate.instant("button.recommend"),
                            seq: 0,
                            type: "CLIPART",
                            used: true
                        }]
                    }
                    res.data.forEach(function (item) {
                        if(item.storeId){
                            vm.clipArts.push(item)
                        }
                    })
                    res.data.forEach(function (item) {
                        if(!item.storeId){
                            vm.clipArts.push(item)
                        }
                    })
                    vm.clipArtsPage = 0;
                    vm.clipArtsList = [];
                    clipArtInit(vm.clipArts[0]);
                }
                if(item == 'FONT'){
                    vm.fontlabels = res.data;
                    vm.fontlabelPage = 0;
                    vm.fontlabelList = [];
                    fontInit(res.data[0])
                }
                if(item == 'Background'){
                    vm.bgImglabels = [];
                    if($scope.template.bgimgs2 && $scope.template.bgimgs2.bgimg && $scope.template.bgimgs2.bgimg.length>0){
                        vm.bgImglabels = [{
                            id: "",
                            name: $translate.instant("button.recommend"),
                            seq: 0,
                            type: "Background",
                            used: true
                        }]
                    }
                    res.data.forEach(function (item) {
                        vm.bgImglabels.push(item)
                    })

                    vm.bgImgPage = 0;
                    vm.bgImgList = [];
                    bgImgInit(vm.bgImglabels[0])
                }
                if(item == 'BORDER'){
                    vm.borderLabels = res.data;
                    if($scope.template.frameConfigs && $scope.template.frameConfigs.frameConfig.length>0){
                        vm.borderLabels.unshift({
                            cancelled: false,
                            id: null,
                            name: $translate.instant("button.recommend"),
                            seq: '',
                            storeId: 10,
                            type: "BORDER",
                            used: true
                        })
                    }
                    vm.borderPage = 0;
                    vm.borderList = [];
                    borderInit(vm.borderLabels[0])
                }
            });
        }

        /***********************  边框  ****************************/
        vm.borderUnfold = false;
        $scope.bordersCb = function(label, index){
            vm.borderId = label;
            vm.borderPage = 0;
            vm.borderList = [];
            borderInit(vm.borderId);
        }
        $scope.loadMoreBorder = function () {
            vm.borderPage++;
            borderInit(vm.borderId);
        }
        function borderInit(item){
            vm.borderId = item;
            if(!vm.borderId){
                angular.forEach($scope.template.frameConfigs.frameConfig, function (data) {
                    vm.borderList.push(data);
                })
                return
            }
            vm.borderLoading = true;
            FrameConfigs.byCondition3({
                items: [{key: "themeClassify.id", op: "=", value: item.id},{key: "enable", op: "=", value: true},{key: "status", op: "=", value: 'Approved'}],
                page: vm.borderPage,
                size: vm.itemsPerPage,
                sort: ["seq,asc"]
            }, function (res, headers) {
                vm.borderLoading = false;
                angular.forEach(res.data, function (resp) {
                    vm.borderList.push(resp);
                })
                var _sum = headers('X-Total-Count');
                if(vm.borderList.length < _sum){
                    vm.borderFulfill = true;
                }else {
                    vm.borderFulfill = false;
                }
            }, function () {
            })
        }
        /***********************  版式  ****************************/
        $scope.partCb = function(item){
            vm.partid = item.id;
        }
        $scope.layoutCb = function(item){
            if(vm.pageData[vm.pageNumber].config.partid!=item.config.partid){
                MessageService.error($translate.instant("editorMessage.不是相同部件的版式不可替换"));
                return
            }
            if(item.uuid != vm.pageData[vm.pageNumber].uuid){
                vm.threeLoading = true;
                vm.threeLoadingText = $translate.instant("editorCommon.loadingText1");
                item.config = vm.pageData[vm.pageNumber].config;
                var pages = {
                    config:$scope.template.config,
                    pages:{
                        page: [angular.copy(item)]
                    }
                }
                documentAnalysis($scope, $http, vm, pages,FontManagement,'other', function(page){
                    ratioInfo(page,vm.pageNumber2 > -1?false:true)
                }, function () {
                    $timeout(function () {
                        var layoutPage = pages.pages.page[0];
                        layoutPage.backup = false;
                        layoutPage.unreplace = false;
                        pageDataInfo(layoutPage)
                    },200)
                })
            }
        }
        function pageDataInfo(page) {
            vm.threeLoading = true;
            vm.minLoading = true;
            vm.threeLoadingText = $translate.instant("editorCommon.loadingText1");
            page.pageUuid = getUuid();
            var _pageData = angular.copy(vm.pageData[vm.pageNumber]);
            var _pageDataImageboxImage = [];
            var _pageDataImageboxImageSum = 0;
            for(var i=0; i<_pageData.levels.level.length; i++){
                var _lecel = _pageData.levels.level[i];
                if(_lecel.imagebox && _lecel.imagebox.image && _lecel.imagebox.image.resource && _lecel.imagebox.image.resource.identifier){
                    _lecel.imagebox.imgRatio = _lecel.imagebox.image.width/_lecel.imagebox.image.height;
                    _pageDataImageboxImage.push(_lecel.imagebox)
                }
            }
            if(!page.levels.level){
                page.levels.level=[];
            }
            _pageDataImageboxImage = imageboxAdapt(page.levels.level, _pageDataImageboxImage);
            angular.forEach(page.levels.level, function (level, i) {
                if (level.imagebox) {
                    var _imagebox = null;
                    for(var j=0; j<_pageDataImageboxImage.length; j++){
                        if(_pageDataImageboxImage[j].imageboxIndex == _pageDataImageboxImageSum){
                            _imagebox = _pageDataImageboxImage[j];
                            break
                        }
                    }
                    _pageDataImageboxImageSum++;
                    if (_imagebox) {
                        level.imagebox.bokehtype = level.imagebox.bokehtype || vm.article.bokehtype || 'None';
                        level.imagebox.image = {
                            blurredrectangle: {
                                width: 0,
                                height: 0,
                                x: 0,
                                y: 0
                            },
                            resource: {
                                identifier: _imagebox ? _imagebox.image.resource.identifier : '',
                                provider: _imagebox ? _imagebox.image.resource.provider : 'qiniu'
                            },
                            resourceid:_imagebox ? _imagebox.image.resourceid : '',
                            filterResource: {
                                identifier: '',
                                provider: 'qiniu'
                            },
                            angle: 0,
                            offsetx: 0,
                            offsety: 0,
                            imageInfo: _imagebox? _imagebox.image.imageInfo : '',
                            width: _imagebox ? _imagebox.image.width : '',
                            height: _imagebox ? _imagebox.image.height : '',
                            imgSize: _imagebox ? _imagebox.image.imgSize : '',
                            index: _imagebox ? _imagebox.image.seq : '',
                            parameter: _imagebox ? angular.fromJson(_imagebox.image.parameter) : [],
                            scale: 1,
                            brightness:_imagebox ?_imagebox.image.brightness : 0,
                            contrast: _imagebox ?_imagebox.image.contrast : 0,
                            saturate: _imagebox ?_imagebox.image.saturate : 0,
                            temperature: _imagebox ?_imagebox.image.temperature : 0,
                            hue: _imagebox ?_imagebox.image.hue : 0
                        }
                        if (level.imagebox.image.resource.identifier) {

                            addImagebox($http, level.imagebox, function () {})
                            // getBackgroundSource3(level.imagebox, level.imagebox.geometry.width, level.imagebox.geometry.height, level.imagebox.image, level.imagebox.bokehtype, $scope)
                        }
                    } else {
                        level.imagebox.bokehtype = level.imagebox.bokehtype || vm.article.bokehtype || 'None';
                        level.imagebox.image = {
                            resource: {
                                identifier: '',
                                provider: ''
                            },
                            resourceid:"",
                            filterResource: {
                                identifier: '',
                                provider: ''
                            },
                            width: '',
                            height: '',
                            imgSize: '',
                            offsetx: 0,
                            offsety: 0,
                            index: '',
                            parameter: [],
                            scale: 1,
                            angle: 0,
                        }
                    }
                }
            })
            vm.isCut = true;
            $timeout(function () {
                vm.pageData[vm.pageNumber] = page;
                vm.pageData.forEach(function (value, index) {
                    value.seq = index;
                    ratioInfo(value,vm.pageNumber2 > -1?false:true);
                })
                MessageService.success($translate.instant("editorMessage.formatReplacementSucceeded"));
                reserveQuantity();
                magnitudeBox();
                vm.isCut = false;
                vm.threeLoading = false;
                vm.threeLoadingText = '';
                $timeout(function () {
                    vm.minLoading = false;
                },500)
            },200)
        }
        //换一换
        $scope.changePage = function(index){
            vm.isChangePage1 = false;
            $scope.pageInfo(index);
            var _recommendLayout = [];
            vm.pageData[vm.pageNumber].recommendLayout.forEach(function (recommendLayoutItem) {
                if(recommendLayoutItem.uuid != vm.pageData[vm.pageNumber].uuid){
                    _recommendLayout.push(recommendLayoutItem)
                }
            })
            if(_recommendLayout.length > 0){
                var x = _recommendLayout.length-1;
                var y = 0;
                var rand = parseInt(Math.random() * (x - y + 1) + y);
                $scope.layoutCb(_recommendLayout[rand])
            }
        }
        vm.isChangePage1 = false;
        $scope.changePage1 = function(e){
            vm.isChangePage1 = !vm.isChangePage1;
            fn(e)
        }
        /***********************  版式end  ****************************/
        /***********************  二维码  ****************************/
        function clearCode(){
            vm.code={
                width: '',
                height: '',
                value: null
            }
            vm.addQrcode = true;
            vm.editorQrcode = false;
        }
        $scope.addQrcode = function () {
            if(!vm.code.value){
                MessageService.error($translate.instant("editorMessage.pleaseEnterTheContent"));
                return
            }
            if(!vm.code.width){
                MessageService.error($translate.instant("editorMessage.pleaseEnterTheWidth"));
                return
            }
            if(!vm.code.height){
                MessageService.error($translate.instant("editorMessage.pleaseEnterTheHeight"));
                return
            }
            if(vm.code.width<10){
                MessageService.error($translate.instant("editorMessage.codeWidth"));
                return
            }
            if(vm.code.height<10){
                MessageService.error($translate.instant("editorMessage.codeHeight"));
                return
            }
            var w = transitionPx(angular.copy(vm.code.width));
            var h = transitionPx(angular.copy(vm.code.height));
            if(vm.elementOn.name == 'code'){
                vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].code.geometry.width = w;
                vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].code.geometry.height = h;
                vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].code.value = vm.code.value;
            }else{
                var code = ({
                    value:vm.code.value,
                    geometry: {
                        width: w,
                        height: h,
                        x: 0,
                        y: 0
                    },
                    rotation: {
                        angle: 0
                    },
                    lock: false
                });
                code.geometry.x = (vm.pageData[vm.pageNumber].mediabox.width - w)/2;
                code.geometry.y = (vm.pageData[vm.pageNumber].mediabox.height - h)/2;
                var _level ={
                    seq: vm.pageData[vm.pageNumber].levels.level.length+1,
                    code: code
                }
                vm.pageData[vm.pageNumber].levels.level.push(_level);
            }
            $rootScope.$broadcast('refreshCodeQrcode');
        };
        /***********************  二维码end  ****************************/
        /***********************  布局库  ****************************/
        $scope.selectLayoutLabel = function (label, index) {
            vm.picLayoutXmlGroup = label;
        };
        function setLayout(){
            if(vm.picLayoutXmlsList && vm.picLayoutXmlsList.length>0 && !vm.pageData[vm.pageNumber].unreplace){
                var _imageboxNum = 0;
                vm.pageData[vm.pageNumber].levels.level.forEach(function (level) {
                    if(level.imagebox){
                        _imageboxNum++
                    }
                })
                for(var i=0; i<vm.picLayoutXmlsList.length; i++){
                    if(vm.picLayoutXmlsList[i].quantity == _imageboxNum){
                        if(vm.picLayoutXmlsList[i].data && vm.picLayoutXmlsList[i].data.length>0){
                            $scope.addLayout(vm.picLayoutXmlsList[i].data[0]);
                        }
                        break
                    }
                }
            }
        }
        $scope.addLayout = function(data,isLayout){
            if(vm.pageData[vm.pageNumber].unreplace){
                MessageService.error($translate.instant("editorMessage.theCurrentPageIsNotReplaceableLayout"));
                return
            }
            if(!vm.isLayout){
                if(isLayout){
                    MessageService.error($translate.instant("editorMessage.theCurrentPageIsNotReplaceableLayout1"));
                }
                return;
            }
            vm.threeLoading = true;
            vm.threeLoadingText = $translate.instant("editorCommon.loadingText");
            Convert.xmlToPicLayoutDocument({url: data.resource.identifier}, function (res) {
                var mediabox = ModulesService.getGeometryToPx(res.mediabox);
                var _pageData = angular.copy(vm.pageData[vm.pageNumber]);
                var _pageDataImageboxImage = [];
                var _pageDataImageboxImageSum = 0;
                for(var i=0; i<_pageData.levels.level.length; i++){
                    var _lecel = _pageData.levels.level[i];
                    if(_lecel.imagebox && _lecel.imagebox.image && _lecel.imagebox.image.resource && _lecel.imagebox.image.resource.identifier){
                        _lecel.imagebox.imgRatio = _lecel.imagebox.image.width/_lecel.imagebox.image.height;
                        _pageDataImageboxImage.push(_lecel.imagebox)
                    }
                }

                var _ratio = 1;
                if(_pageData.mediabox.height / mediabox.height >= _pageData.mediabox.width / mediabox.width ){
                    _ratio = _pageData.mediabox.width / mediabox.width;
                }else {
                    _ratio = _pageData.mediabox.height / mediabox.height;
                }

                if(!_pageData.levels.level){
                    _pageData.levels.level=[];
                }
                for(var i=_pageData.levels.level.length-1; i>=0; i--){
                    if(_pageData.levels.level[i].imagebox){
                        _pageData.levels.level.splice(i,1)
                    }
                }
                res.levels.level.forEach(function (level) {
                    if(level.imagebox){
                        level.imagebox.geometry={
                            width: transitionPx(level.imagebox.geometry.width*_ratio),
                            height: transitionPx(level.imagebox.geometry.height*_ratio),
                            x: transitionPx(level.imagebox.geometry.x*_ratio),
                            y: transitionPx(level.imagebox.geometry.y*_ratio),
                        }
                        level.seq = _pageData.levels.level.length-1;
                        _pageData.levels.level.push(level)
                    }
                })
                _pageDataImageboxImage = imageboxAdapt(_pageData.levels.level, _pageDataImageboxImage);
                angular.forEach(_pageData.levels.level, function (level, i) {
                    if (level.imagebox) {
                        var _imagebox = null;
                        for(var j=0; j<_pageDataImageboxImage.length; j++){
                            if(_pageDataImageboxImage[j].imageboxIndex == _pageDataImageboxImageSum){
                                _imagebox = _pageDataImageboxImage[j];
                                break
                            }
                        }
                        _pageDataImageboxImageSum++;
                        if (_imagebox) {
                            level.imagebox.bokehtype = level.imagebox.bokehtype || vm.article.bokehtype || 'None';
                            level.imagebox.image = {
                                blurredrectangle: {
                                    width: 0,
                                    height: 0,
                                    x: 0,
                                    y: 0
                                },
                                resource: {
                                    identifier: _imagebox ? _imagebox.image.resource.identifier : '',
                                    provider: _imagebox ? _imagebox.image.resource.provider : 'qiniu'
                                },
                                resourceid:_imagebox ? _imagebox.image.resourceid : '',
                                filterResource: {
                                    identifier: '',
                                    provider: 'qiniu'
                                },
                                angle: 0,
                                offsetx: 0,
                                offsety: 0,
                                imageInfo: _imagebox? _imagebox.image.imageInfo : '',
                                width: _imagebox ? _imagebox.image.width : '',
                                height: _imagebox ? _imagebox.image.height : '',
                                imgSize: _imagebox ? _imagebox.image.imgSize : '',
                                index: _imagebox ? _imagebox.image.seq : '',
                                parameter: _imagebox ? angular.fromJson(_imagebox.image.parameter) : [],
                                scale: 1,
                                brightness:_imagebox ?_imagebox.image.brightness : 0,
                                contrast: _imagebox ?_imagebox.image.contrast : 0,
                                saturate: _imagebox ?_imagebox.image.saturate : 0,
                                temperature: _imagebox ?_imagebox.image.temperature : 0,
                                hue: _imagebox ?_imagebox.image.hue : 0
                            }
                            if (level.imagebox.image.resource.identifier) {

                                addImagebox($http, level.imagebox, function () {})
                                // getBackgroundSource3(level.imagebox, level.imagebox.geometry.width, level.imagebox.geometry.height, level.imagebox.image, level.imagebox.bokehtype, $scope)
                            }
                        } else {
                            level.imagebox.image = {
                                resource: {
                                    identifier: '',
                                    provider: ''
                                },
                                resourceid:"",
                                filterResource: {
                                    identifier: '',
                                    provider: ''
                                },
                                width: '',
                                height: '',
                                imgSize: '',
                                offsetx: 0,
                                offsety: 0,
                                index: '',
                                parameter: [],
                                scale: 1,
                                angle: 0,
                            }
                        }
                    }
                })
                $timeout(function () {
                    vm.pageData[vm.pageNumber] = _pageData;
                    vm.threeLoading = false;
                    vm.threeLoadingText = '';
                    MessageService.success($translate.instant("editorMessage.layoutReplacementSucceeded"));
                    magnitudeBox();
                },200)
            })
        }
        /***********************  布局库end  ****************************/
        /***********************  可变数据  ****************************/
        $scope.downloadFile = function(){
            $http({
                url: 'fileserves/api/convert/document/downTemp',
                method: "GET",
                headers: {
                    'Content-type': 'application/json',
                },
                responseType: 'blob'
            }).success(function(data, status, headers, config) {
                var blob = new Blob([data], {
                    type: "application/vnd.ms-excel"
                });
                var objectUrl = URL.createObjectURL(blob);
                var a = document.createElement('a');
                document.body.appendChild(a);
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', objectUrl);
                var filename = $translate.instant("editorCommon.variableDataTemplate") + ".xls";
                a.setAttribute('download', filename);
                a.click();
                URL.revokeObjectURL(objectUrl);
                document.body.removeChild(a);
            }).error(function(data, status, headers, config) {});
        }


        $scope.uploadFile = function(fileWatched){
            Upload.upload({
                type: 'POST',
                url: 'fileserves/api/convert/document/importData', //上传路径
                data: {
                    file: fileWatched,
                    name: fileWatched.name,
                }
            }).then(function successCallback(res) {
                if (res.status && res.status == 200) {
                    vm.variableData = res.data;
                    vm.variableName = fileWatched.name;
                }
            }, function errorCallback(response) {
                MessageService.error($translate.instant("editorMessage.importingATemplateFails"));
            });

        }

        //转为位组合
        $scope.transformGroup = function(){
            var uuid = UidService.get();
            for(var i=0;i<vm.pageData[vm.pageNumber].levels.level.length;i++) {
                var level = vm.pageData[vm.pageNumber].levels.level[i];
                if(level.imagebox && level.imagebox.ctrlKey&&level.imagebox.value){
                    level.group = true;
                    level.guid = uuid;
                }
                if(level.textbox && level.textbox.ctrlKey&&level.textbox.value){
                    level.group = true;
                    level.guid = uuid;
                }
            }
        }
        //查看全部数据
        $scope.watchVariable = function(){
            $uibModal.open({
                templateUrl: 'app/entities/page-compontents/variable-data.html',
                controller: 'VariableDataController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('editorWeb');
                        return $translate.refresh();
                    }],
                    entity: [function() {
                        return {
                            data: vm.variableData
                        };
                    }]
                }
            }).result.then(function (data) {
                // var box2 = angular.copy(box);
                if(data){
                    //从当前页：this  ;   从第一页：one
                    var index = 0;
                    if(data.range=='this'){
                        index = vm.pageNumber;
                    }

                    for (var i = index; i < vm.pageData.length; i++) {
                        var page = vm.pageData[i];
                        // var arr = {
                        //     seq: page.arr.levels.level.length - 0 + 1,
                        //     imagebox: null,
                        //     textbox: null,
                        //     textdocument: null,
                        //     imageart:null,
                        //     code: null
                        // }
                        // arr[box.current] = box2;
                        // arr[box.current].pageI = page.arr.seq - 1;
                        // arr[box.current].levelI = page.arr.levels.level.length;
                        //
                        // //从第一页开始,全部增加
                        // if(data.generLoc == 'all'){
                        //     // 判断左右页
                        //     if(i == $scope.pageI&&$scope.arrI&&page.arr2&&$scope.arrI!=2){
                        //         setBox(arr,box,page)
                        //     }
                        //     if(i!= $scope.pageI){
                        //         var arr2 = angular.copy(arr)
                        //         page.arr.levels.level.push(arr2);
                        //         if(page.arr2){
                        //             setBox(arr,box,page)
                        //         }
                        //     }
                        // }else if(data.generLoc=='next'){
                        //     var boxSeq = $scope.template.pages[$scope.pageI].arr.seq;
                        //     if($scope.arrI == 2){
                        //         boxSeq = $scope.template.pages[$scope.pageI].arr2.seq;
                        //     }
                        //
                        //     if(i != $scope.pageI){
                        //         if(page.arr.seq % 2 == boxSeq % 2){
                        //             var arr2 = angular.copy(arr)
                        //             page.arr.levels.level.push(arr2);
                        //         }
                        //         if(page.arr2.seq % 2 == boxSeq % 2){
                        //             setBox(arr,box,page)
                        //         }
                        //     }
                        // }
                    }
                }
            });
        }
        /**
         * index 从第N页开始生成
         * x1 共有几个组合
         * maxlen 可生成N页
         */
        $scope.generVariable = function (e) {
            fn(e)
            if(!vm.variableData) { return }
            var variables = angular.copy(vm.variableData)
            var index = vm.pageNumber;
            var pages = $scope.template.pages.page;
            var page = pages[index];
            var levels = angular.copy(page.levels.level);
            var a1 = {}, x1 = 0, pageLen = pages.length;
            if(page.config.partid != 'P'){
                MessageService.error($translate.instant("editorMessage.addVariableData"));
                return
            }
            // 封底不参与生成
            if(pages[pages.length-1].type=='BackCover'){
                pageLen--
            }
            for (var j1 = 0; j1 < levels.length; j1++) {
                if(levels[j1].guid){
                    if (!a1[levels[j1].guid]) {
                        a1[levels[j1].guid] = [levels[j1]];
                        x1++;
                    } else {
                        a1[levels[j1].guid].push(levels[j1]);
                    }
                }
            }

            if(x1==0){
                MessageService.error($translate.instant("editorMessage.combinationOfTransformation"));
                return;
            }
            var maxlen = index+Math.ceil(variables.values.value.length/x1);

            if(maxlen > pageLen){
                for(var i = pageLen; i<maxlen;i++){
                    var p = angular.copy(page)
                    p.background={
                        color: "#ffffff",
                        offsetx: 0,
                        offsety: 0,
                        resource: {provider: null, identifier: null},
                        scale: 0,
                        type: "Color"
                    }
                    p.unreplace = false;
                    p.type = null;
                    p.levels = {level:[]};
                    p.pagecover = {provider: "qiniu", identifier: ""}
                    p.uuid = UidService.get();
                    vm.pageData.splice(index,0,p)
                }
                angular.forEach(vm.pageData, function (obj, index1) {
                    obj.seq = index1;
                    ratioInfo(obj);
                });
                vm.pageSum = vm.pageData.length - 1;
                pageDataInit();
                $scope.turning(index)
            }
            for (var i = index; i < maxlen; i++) {
                var uuid = angular.copy(pages[i].uuid);
                var type = angular.copy(pages[i].type);
                pages[i] = angular.copy(page);
                pages[i].uuid = uuid;
                pages[i].type = type;
                pages[i].seq = i+1;

                var a = {}, x = 0;
                var levels = pages[i].levels.level;
                for (var j = 0; j < levels.length; j++) {
                    if(levels[j].guid){
                        if (!a[levels[j].guid]) {
                            a[levels[j].guid] = [levels[j]];
                            x++;
                        } else {
                            a[levels[j].guid].push(levels[j]);
                        }
                    }
                }
                Object.keys(a).forEach(function(key,ii,v){
                    angular.forEach(a[key],function (levelItem) {
                        (function(level){
                            //占位框
                            if(level.imagebox&&level.imagebox.geometry&&level.imagebox.value){
                                // 取得占位框中的value
                                var value = level.imagebox.value.replace(/#/g, '');
                                // 根据value 拿到可变数据中对应的内容
                                var _index = variables.titles.title.findIndex(function (t) {
                                    return t.value == value
                                })

                                //根据筛选到的可变数据，从照片库中获取对应的照片
                                var varValue = null,dataIndex=null;
                                if(variables.values.value[ii]&&variables.values.value[ii].values){
                                    varValue = variables.values.value[ii].values;
                                    dataIndex = $scope.photos.findIndex(function (p) {
                                        return ModulesService.splitFileName(p.name) == varValue[_index].value
                                    })
                                }

                                // 生成照片到占位框
                                if(dataIndex!=null&&dataIndex>=0){
                                    $scope.picArr = angular.copy($scope.photos);
                                    level.imagebox.image= {
                                        resource: {
                                            identifier: $scope.picArr[dataIndex].identifier,
                                                provider: 'qiniu'
                                        },
                                        filterResource: {
                                            identifier: '',
                                                provider: 'qiniu'
                                        },
                                        resourceid:$scope.picArr[dataIndex].sourceId,
                                        width: $scope.picArr[dataIndex].width,
                                        height: $scope.picArr[dataIndex].height,
                                        imageInfo: $scope.picArr[dataIndex].imageInfo,
                                        imgSize: $scope.picArr[dataIndex].imgSize,
                                        index: $scope.picArr[dataIndex].seq,
                                        parameter: angular.fromJson($scope.picArr[dataIndex].parameter),
                                        scale: 1,
                                        angle: 0,
                                    };
                                    addImagebox($http, level.imagebox, function () {});
                                }
                            }
                            //文本框
                            if(level.textbox&&level.textbox.geometry&&level.textbox.value){
                                var value = level.textbox.value.replace(/#/g, '');
                                // 根据value 拿到可变数据中对应的文字内容
                                var _index = variables.titles.title.findIndex(function (t) {
                                    return t.value == value
                                });
                                //根据筛选到的可变数据，生成对应的文字
                                if(_index > -1 && variables.values.value[ii]&&variables.values.value[ii].values){
                                    var varValue = variables.values.value[ii].values;
                                    level.textbox.text = varValue[_index].value;
                                    vm.elementOn.item = level.textbox;
                                    getTextHeight(level.textbox, $scope);
                                }
                            }
                        })(levelItem)
                    })
                })
                // 可变数据比页数多时
                if(variables.values.value.length<x){
                    MessageService.success($translate.instant("editorMessage.completionOfGeneration",{number:(x-variables.values.value.length)}));
                }
                variables.values.value.splice(0,x);
            }
            photosNum();
        }


        vm.isTransformGroup = false;
        function variableNumber(){
            vm.isTransformGroup = false;
            var all = getAllCtrlKeyArray();
            if(all && all.length>1){
                vm.isTransformGroup = true;
                all.forEach(function (level) {
                    if(!level.value){
                        vm.isTransformGroup = false;
                    }
                })
            }
        }
        /***********************  可变数据end  ****************************/
        vm.fullFlag = false;
        //全屏
        $scope.toggleFullScreen = function(){
            vm.fullFlag = ModulesService.toggleFullScreen(vm.fullFlag);
        }
        //删除
        $scope.deleteBox = vm.deleteBox = function ($event) {
            if(vm.elementOn.name == ""||vm.elementOn.name == "calTitleBox"||vm.elementOn.name == "calMonthBox"){
                MessageService.error($translate.instant("editorMessage.pleaseSelectTheContentToDelete"));
                return
            }
            if(vm.elementOn.item.lock){
                return;
            }
            var currentPageIndex = vm.pageNumber;
            vm.pageData[currentPageIndex].levels.level.splice(vm.elementOn.index, 1);
            var newPageData = angular.copy(vm.pageData);
            vm.pageData = [];
            $timeout(function() {
                vm.pageData = newPageData;
                $scope.template.pages.page = angular.copy(vm.pageData);
                if(vm.elementOn&&vm.elementOn.name == 'imagebox'){
                    setLayout();
                }
                $scope.editorBodyView();
                magnitudeBox();
                cookie();
            }, 0);
        }
        //复制
        $scope.copyimg = vm.copyimg = function ($event) {
            if(!vm.copyBtn){
                return;
            }
            var all = getAllCtrlKeyArray();
            if(!vm.clickNum){
                vm.clickNum = 0;
            }
            vm.clickNum+=10;
            if(all.length>0){
                all.forEach(function (item) {
                    (function (item1) {
                        var _level = {
                            seq: vm.pageData[vm.pageNumber].levels.level.length + 1,
                        }
                        _level[item1.current] = angular.copy(item1);
                        _level[item1.current].lock = false;
                        _level[item1.current].ctrlKey = false;
                        _level[item1.current].geometry.x += vm.clickNum/vm.pageData[vm.pageNumber].custom.ratio;
                        _level[item1.current].geometry.y += vm.clickNum/vm.pageData[vm.pageNumber].custom.ratio;
                        vm.pageData[vm.pageNumber].levels.level.push(_level);
                    })(item)
                })
            }else{
                if(!vm.elementOn.item){return}
                var _level = {
                    seq: vm.pageData[vm.pageNumber].levels.level.length + 1
                }
                if(vm.elementOn.name == "imagebox"){
                    _level.imagebox = angular.copy(vm.elementOn.item);
                    _level.imagebox.geometry.x += vm.clickNum/vm.pageData[vm.pageNumber].custom.ratio;
                    _level.imagebox.geometry.y += vm.clickNum/vm.pageData[vm.pageNumber].custom.ratio;
                }
                if(vm.elementOn.name == "imageart"){
                    _level.imageart = angular.copy(vm.elementOn.item);
                    _level.imageart.geometry.x += vm.clickNum/vm.pageData[vm.pageNumber].custom.ratio;
                    _level.imageart.geometry.y += vm.clickNum/vm.pageData[vm.pageNumber].custom.ratio;
                }
                if(vm.elementOn.name == "textbox"){
                    _level.textbox = angular.copy(vm.elementOn.item);
                    _level.textbox.geometry.x += vm.clickNum/vm.pageData[vm.pageNumber].custom.ratio;
                    _level.textbox.geometry.y += vm.clickNum/vm.pageData[vm.pageNumber].custom.ratio;
                }
                if(vm.elementOn.name == "textdocument"){
                    _level.textdocument = angular.copy(vm.elementOn.item);
                    _level.textdocument.geometry.x += vm.clickNum/vm.pageData[vm.pageNumber].custom.ratio;
                    _level.textdocument.geometry.y += vm.clickNum/vm.pageData[vm.pageNumber].custom.ratio;
                }
                if(vm.elementOn.name == "calMonthBox"){
                    _level.calMonthBox = angular.copy(vm.elementOn.item);
                    _level.calMonthBox.geometry.x += vm.clickNum/vm.pageData[vm.pageNumber].custom.ratio;
                    _level.calMonthBox.geometry.y += vm.clickNum/vm.pageData[vm.pageNumber].custom.ratio;
                }
                if(vm.elementOn.name == "calTitleBox"){
                    _level.calTitleBox = angular.copy(vm.elementOn.item);
                    _level.calTitleBox.geometry.x += vm.clickNum/vm.pageData[vm.pageNumber].custom.ratio;
                    _level.calTitleBox.geometry.y += vm.clickNum/vm.pageData[vm.pageNumber].custom.ratio;
                }
                vm.pageData[vm.pageNumber].levels.level.push(_level);
            }
            var currentPageIndex = vm.pageNumber;
            var newPageData = angular.copy(vm.pageData);
            vm.pageData = [];
            $timeout(function() {
                vm.pageData = newPageData;
                $scope.template.pages.page = angular.copy(vm.pageData);
                magnitudeBox();
                cookie();
                photosNum();
            }, 0);
        }
        vm.copyArray = {imageboxes: [], textboxes: [], imagearts: [], barcode: [], qrcode: [], textdocuments: [], calTitleBoxs: [], calMonthBoxs: []};
        // 复制元素
        vm.copyElement = function(){
            if(vm.copyArray.imageboxes.length == 0 && vm.copyArray.imagearts.length == 0 && vm.copyArray.textboxes.length == 0){
                return;
            }
            copyTogether();
        }

        // 多选调用
        function copyTogether(){
            angular.forEach(vm.copyArray.imageboxes, function (imagebox, i) {
                if(imagebox&&imagebox.geometry){
                    // 当前页所有占位框
                    var box = angular.copy(imagebox);
                    var _level = {
                        seq: vm.pageData[vm.pageNumber].levels.level.length + 1
                    }
                    _level.imagebox = angular.copy(copyDetail(box));
                    vm.pageData[vm.pageNumber].levels.level.push(_level)
                    for (var j = 0; j < $scope.photos.length; j++) {
                        var arr = $scope.photos[j];
                        if (arr.sourceId == box.image.resourceid) {
                            arr.usenum++;
                        }
                    }
                }

            })

            angular.forEach(vm.copyArray.imagearts, function (imageart, i) {
                if(imageart&&imageart.geometry){
                    // 当前页所有素材
                    var box = angular.copy(imageart);
                    var _level = {
                        seq: vm.pageData[vm.pageNumber].levels.level.length + 1
                    }
                    _level.imageart = angular.copy(copyDetail(box));
                    vm.pageData[vm.pageNumber].levels.level.push(_level)
                }

            })

            angular.forEach(vm.copyArray.textboxes, function (textbox, i) {
                if(textbox&&textbox.geometry){
                    // 当前页所有文字
                    var box = angular.copy(textbox);
                    var _level = {
                        seq: vm.pageData[vm.pageNumber].levels.level.length + 1
                    }
                    _level.textbox = angular.copy(copyDetail(box));
                    vm.pageData[vm.pageNumber].levels.level.push(_level)
                }

            })
        }
        function copyDetail(box) {
            box.levelI = vm.pageData[vm.pageNumber].levels.level.length-1;
            box.lock = false;
            box.ctrlKey = false;
            var repeatEle = false;
            vm.pageData[vm.pageNumber].levels.level.forEach(function(item){
                if(item.imagebox && item.imagebox.geometry.x == box.geometry.x && item.imagebox.geometry.y == box.geometry.y){
                    repeatEle = true;
                }
                if(item.imageart && item.imageart.geometry.x == box.geometry.x && item.imageart.geometry.y == box.geometry.y){
                    repeatEle = true;
                }
                if(item.textbox && item.textbox.geometry.x == box.geometry.x && item.textbox.geometry.y == box.geometry.y){
                    repeatEle = true;
                }
                if(item.code && item.code.geometry.x == box.geometry.x && item.code.geometry.y == box.geometry.y){
                    repeatEle = true;
                }
            })
            if(!repeatEle){
                return box
            }
            // 复制上一次的位置
            if (box.current == 'imagebox') {
                vm.copyArray.imageboxes.forEach(function(imagebox){
                    if(imagebox && imagebox.geometry.x == box.geometry.x && imagebox.geometry.y == box.geometry.y){
                        var x = PxTurnMm(imagebox.geometry.x) + 1;
                        var y = PxTurnMm(imagebox.geometry.y) + 1;
                        imagebox.geometry.x = MmTurnPx(x);
                        imagebox.geometry.y = MmTurnPx(y);
                    }
                })
            }
            if (box.current == 'imageart') {
                vm.copyArray.imagearts.forEach(function(imageart){
                    if(imageart && imageart.geometry.x == box.geometry.x && imageart.geometry.y == box.geometry.y){
                        var x = PxTurnMm(imageart.geometry.x) + 1;
                        var y = PxTurnMm(imageart.geometry.y) + 1;
                        imageart.geometry.x = MmTurnPx(x);
                        imageart.geometry.y = MmTurnPx(y);
                    }
                })
            }
            if(box.current == 'textbox'){
                vm.copyArray.textboxes.forEach(function(textbox){
                    if(textbox && textbox.geometry.x == box.geometry.x && textbox.geometry.y == box.geometry.y){
                        var x = PxTurnMm(textbox.geometry.x) + 1;
                        var y = PxTurnMm(textbox.geometry.y) + 1;
                        textbox.geometry.x = MmTurnPx(x);
                        textbox.geometry.y = MmTurnPx(y);
                    }
                })
            }
            // 新元素
            var x = PxTurnMm(box.geometry.x) + 1;
            var y = PxTurnMm(box.geometry.y) + 1;
            box.geometry.x = MmTurnPx(x);
            box.geometry.y = MmTurnPx(y);
            return box
        }
        //锁定
        $scope.locking = vm.locking = function(e){
            fn(e);
            if(vm.elementOn.item){
                vm.elementOn.item.lock = !vm.elementOn.item.lock;
                if(vm.elementOn.name === 'imagebox'){
                    vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].imagebox.lock = vm.elementOn.item.lock;
                }
                multiSelect()
            }
        }
        //重复生成

        $scope.generBox = function(e){
            fn(e)
            if(!vm.elementOn.item){
                MessageService.error($translate.instant("editorMessage.pleaseChooseLevel"));
                return
            }
            if(vm.elementOn.name!='imagebox'&&vm.elementOn.name!='imageart'&&vm.elementOn.name!='textbox'&&vm.elementOn.name!='code'){
                MessageService.error($translate.instant("editorMessage.pleaseChooseLevel"));
                return;
            }
            $uibModal.open({
                templateUrl: 'app/entities/page-compontents/box-copy.html',
                controller: 'BoxCopyController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('editorWeb');
                        return $translate.refresh();
                    }],
                    entity: [function() {
                        return {
                            box: vm.elementOn.item,
                            pageI:vm.pageNumber
                        };
                    }]
                }
            }).result.then(function (data) {
                if(data){
                    var all = getAllCtrlKeyArray();
                    if(all.length>0){
                        all.forEach(function (item) {
                            (function (item1) {
                                var _level = {
                                    seq: vm.pageData[vm.pageNumber].levels.level.length + 1,
                                }
                                _level[item1.current] = angular.copy(item1);
                                _level[item1.current].lock = false;
                                _level[item1.current].ctrlKey = false;
                                BoxCopyInit(_level,data)
                            })(item)
                        })
                    }else{
                        var _level = vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index];
                        BoxCopyInit(_level,data)
                    }
                }
            });
        }
        function BoxCopyInit(level, data) {
            var _level = angular.copy(level);
            vm.pageData.forEach(function (page, index) {
                if(data.range == 'this'){
                    if(data.generLoc == 'all'){
                        if(vm.pageNumber<index){
                            _level.seq = vm.pageData[vm.pageNumber].levels.level.length + 1;
                            vm.pageData[index].levels.level.push(angular.copy(_level))
                        }
                    }
                    if(data.generLoc == 'next'){
                        if(vm.pageNumber<index && index%2===vm.pageNumber%2){
                            _level.seq = vm.pageData[vm.pageNumber].levels.level.length + 1;
                            vm.pageData[index].levels.level.push(angular.copy(_level))
                        }
                    }
                }
                if(data.range == 'first' && vm.pageNumber != index){
                    if(data.generLoc == 'all'){
                        _level.seq = vm.pageData[vm.pageNumber].levels.level.length + 1;
                        vm.pageData[index].levels.level.push(angular.copy(_level))
                    }
                    if(data.generLoc == 'next'){
                        if(index%2===0%2){
                            _level.seq = vm.pageData[vm.pageNumber].levels.level.length + 1;
                            vm.pageData[index].levels.level.push(angular.copy(_level))
                        }
                    }
                }
            })
            photosNum();
        }
        //图层
        vm.isCoverage = false;
        $scope.coverageMove = coverageMove;
        $scope.coverageSelect = function (attr) {
            if(vm.elementOn.item.lock){return}
            toolbarStatus()
            vm.isCoverage = attr;
        }
        function coverageMove(data){
            if(vm.elementOn.item.lock){return}
            var _seq = Number(vm.pageData[vm.pageNumber].levels.level.length);
            if(data == "up"){
                if(vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].seq == _seq){
                    MessageService.error($translate.instant("editorMessage.topLevel"));
                    return;
                }
                var seq = angular.copy(vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].seq+1);
                vm.pageData[vm.pageNumber].levels.level.forEach(function (level) {
                    if(level.seq == seq){
                        level.seq--
                    }
                })
                vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].seq++
            }
            if(data == "down"){
                if(vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].seq <2){
                    MessageService.error($translate.instant("editorMessage.bottomLevel"));
                    return;
                }
                var seq = angular.copy(vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].seq-1);
                vm.pageData[vm.pageNumber].levels.level.forEach(function (level) {
                    if(level.seq == seq){
                        level.seq++
                    }
                });
                vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].seq--
            }
            if(data == "top"){
                if(vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].seq == _seq){
                    MessageService.error($translate.instant("editorMessage.topLevel"));
                    return;
                }
                var seq = angular.copy(vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].seq);
                for (var i = 0; i < vm.pageData[vm.pageNumber].levels.level.length; i++) {
                    if(vm.pageData[vm.pageNumber].levels.level[i].seq > seq){
                        vm.pageData[vm.pageNumber].levels.level[i].seq--;
                    }
                }
                vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].seq = _seq
            }
            if(data == "bottom"){
                if(vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].seq == 0){
                    MessageService.error($translate.instant("editorMessage.bottomLevel"));
                    return;
                }

                var seq = angular.copy(vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].seq);
                for (var i = 0; i < vm.pageData[vm.pageNumber].levels.level.length; i++) {
                    if(vm.pageData[vm.pageNumber].levels.level[i].seq < seq){
                        vm.pageData[vm.pageNumber].levels.level[i].seq+=1;
                    }
                }
                vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].seq = 1;
            }

            var _seq = angular.copy(vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].seq);
            var _levelI = vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].seq - 1;
            vm.pageData[vm.pageNumber].levels.level.sort(compare('seq', true));
            for (var i = 0; i < vm.pageData[vm.pageNumber].levels.level.length; i++) {
                if(vm.pageData[vm.pageNumber].levels.level[i].seq == _seq){
                    _levelI = i;
                    break
                }
            }
            vm.elementOn.index = _levelI;
            cookie();
        }
        function compare(property) {
            return function (a, b) {
                var value1 = a[property];
                var value2 = b[property];
                return value1 - value2;
            }
        }
        // 透明度
        vm.isTransp = false;
        $scope.transparencySelect = function () {
            if(vm.isRoundedSet || vm.borderSet)cookie()
            var _isTransp = angular.copy(vm.isTransp);
            toolbarStatus()
            if(vm.elementOn.name !='imageart' && vm.elementOn.name !='textbox' && vm.elementOn.name !='imagebox' ){
                MessageService.error($translate.instant("editorMessage.pleaseChooseLevel1"));
                return
            }
            vm.isTransp = !_isTransp;
            if(vm.isTransp){
                var _transparency = 0;
                if(vm.elementOn.name =='imagebox'){
                    _transparency = vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].imagebox.transparency;
                }
                if(vm.elementOn.name =='imageart'){
                    _transparency = vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].imageart.transparency;
                }
                if(vm.elementOn.name =='textbox' ){
                    _transparency = vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].textbox.transparency;
                }
                $(".transparency-range").val(_transparency);
                $(".transparency-num").val(_transparency * 100);
                vm.transparency = _transparency * 100;
            }
        }
        $timeout(function () {
            var elem = document.querySelector('input[type="range"].transparency-range');

            if(elem){
                // input 事件：只更新视图，不保存快照（避免拖动时产生大量中间快照）
                elem.addEventListener("input", function () {
                    var value = ModulesService.rangeValue(elem);
                    $(".transparency-num").val(value * 100);
                    vm.transparency = value * 100;

                    var all = getAllCtrlKeyArray();
                    if(all.length>0){
                        levelMove(null, 'transparency')
                    }else{
                        transparencyInitNoSave();
                    }
                    $scope.$digest();
                });
                // change 事件：松开后才保存一次快照
                elem.addEventListener("change", function () {
                    var value = ModulesService.rangeValue(elem);
                    vm.transparency = value * 100;
                    var all = getAllCtrlKeyArray();
                    if(all.length>0){
                        levelMove(null, 'transparency')
                    }else{
                        transparencyInit();
                    }
                    $scope.$digest();
                });
            }
        },1000)

        $scope.transparencyChange = function () {
            if (vm.transparency > 100) {
                MessageService.error($translate.instant("editorMessage.transparencyInvalid"));
                vm.transparency = 100;
            }
            if (vm.transparency < 0) {
                MessageService.error($translate.instant("editorMessage.transparencyInvalid"));
                vm.transparency = 0;
            }
            transparencyInit(vm.transparency)
        }
        // 透明度：仅更新视图值，不保存快照（拖动过程中使用）
        function transparencyInitNoSave() {
            if(vm.elementOn.name =='imagebox'){
                vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].imagebox.transparency = vm.transparency/100;
                return
            }
            if(vm.elementOn.name =='imageart'){
                vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].imageart.transparency = vm.transparency/100;
                return
            }
            if(vm.elementOn.name =='textbox' ){
                vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].textbox.transparency = vm.transparency/100;
                return
            }
        }
        // 透明度：更新值并保存快照（松开后或手动输入时使用）
        function transparencyInit() {
            if(vm.elementOn.name =='imagebox'){
                vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].imagebox.transparency = vm.transparency/100;
                cookie();
                return
            }
            if(vm.elementOn.name =='imageart'){
                vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].imageart.transparency = vm.transparency/100;
                cookie();
                return
            }
            if(vm.elementOn.name =='textbox' ){
                vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].textbox.transparency = vm.transparency/100;
                cookie();
                return
            }
        }

        //字体
        vm.isOperationColor = false;
        vm.colorList = [
            {name: '#000000', id: '#000000'},
            {name: '#666666', id: '#666666'},
            {name: '#a8a8a8', id: '#a8a8a8'},
            {name: '#d9d9d9', id: '#d9d9d9'},
            {name: '#ffffff', id: '#ffffff'},
            {name: '#647c6e', id: '#647c6e'},
            {name: '#ffbd4a', id: '#ffbd4a'},
            {name: '#fef952', id: '#fef952'},
            {name: '#99e264', id: '#99e264'},
            {name: '#36b72a', id: '#36b72a'},
            {name: '#44d9e5', id: '#44d9e5'},
            {name: '#c27171', id: '#c27171'},
            {name: '#2fb3ff', id: '#2fb3ff'},
            {name: '#b760a6', id: '#b760a6'},
        ];
        $scope.operationColorOpen = function ($event) {
            vm.isOperationColor = !vm.isOperationColor;
            fn($event)
        }
        $scope.operationColor = function (item) {
            vm.elementOn.item.style.color = item.id;
            vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].textbox = vm.elementOn.item;
        }
        $scope.chooseTextColor = function () {
            vm.elementOn.item.style.color = vm.textColor;
            vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].textbox = vm.elementOn.item;
            vm.textColor = null;
        }
        function fontSizeInit(size){
            var _size = 101;
            var _size1 = Math.floor(size/2);
            $scope.fontSizes = [];
            for (var f = 6; f < _size; f++) {
                $scope.fontSizes.push(f);
            }
            if(_size1 > _size){
                $scope.fontSizes.push(_size1);
            }
        }
        var a = null;
        $scope.updateTextSize = function (size) {
            if (a !== null) {
                clearTimeout(a)
            }
            a = setTimeout(function () {
                if (size <= 6) {
                    size = 6
                }
                vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].textbox.style.size = size;
                vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].textbox.style.lineheight = vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].textbox.style.size;
                vm.elementOn.item = vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].textbox;
                $timeout(function () {
                    // vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].textbox.geometry.width = (Number($("#c-xml-page-material-fontId").width() / (3/4) / vm.pageData[vm.pageNumber].custom.ratio * (1 / 12 * vm.elementOn.item.style.size * vm.pageData[vm.pageNumber].custom.ratio > 1 ? 1 : 1 / 12 * vm.elementOn.item.style.size * vm.pageData[vm.pageNumber].custom.ratio)) + Number(5));
                    // vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].textbox.geometry.height = Number($("#c-xml-page-material-fontId").height() / (3/4) / vm.pageData[vm.pageNumber].custom.ratio) * (1 / 12 * vm.elementOn.item.style.size * vm.pageData[vm.pageNumber].custom.ratio > 1 ? 1 : 1 / 12 * vm.elementOn.item.style.size * vm.pageData[vm.pageNumber].custom.ratio) + Number(10);
                    if(vm.elementOn.item.geometry.width < ptToPx( vm.elementOn.item.style.size)){
                       vm.elementOn.item.geometry.width = ptToPx( vm.elementOn.item.style.size)+10;
                    }

                    sizeHeight();
                    // $scope.$digest();
                    cookie();
                })
            },500)
        }
        vm.isOperationSpacing = false;
        $scope.operationSpacing = function (item) {
            vm.isOperationSpacing = item;
            vm.isOperationDir = false;
            $timeout(function () {
                var text = vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].textbox;
                $(".block-width").css({left: text.style.letterspacing});
                $(".block-height").css({left: text.style.lineheight});
                $scope.template.letterspacing =text.style.letterspacing;
                $scope.template.lineheight = text.style.lineheight;
            })
        }
        //斜体
        $scope.operationItalic = function () {
            var text = vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].textbox;
            if (text) {
                if(text.style.italic){
                    if(vm.fontStyle.indexOf('NORMAL') > -1){
                        text.style.italic = false;
                        if (vm.fontStyle.indexOf('BOLD') == '-1') {
                            text.style.bold = false;
                        }
                    }else{
                        if(text.style.bold){
                            text.style.italic = false;
                        }
                    }
                }else{
                    if(vm.fontStyle.indexOf('ITALIC') > -1){
                        text.style.italic = true;
                        if(text.style.bold){
                            if(vm.fontStyle.indexOf('BOLD_ITALIC') == -1){
                                text.style.bold = false;
                            }
                        }else{
                            // if( vm.fontStyle.indexOf('BOLD_ITALIC') > -1){
                            //     text.style.bold = true;
                            // }
                        }
                    }else if (vm.fontStyle.indexOf('BOLD_ITALIC') > -1) {
                        text.style.bold = true;
                        text.style.italic = true;
                    }
                }
                $timeout(function () {
                    sizeHeight();
                },200)
            }
        }
        //粗体
        $scope.operationBold = function () {
            var text = vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].textbox;
            if (text) {
                if(text.style.bold){
                    if(vm.fontStyle.indexOf('NORMAL') > -1){
                        text.style.bold = !text.style.bold;
                        if (vm.fontStyle.indexOf('ITALIC') == '-1') {
                            text.style.italic = text.style.bold;
                        }
                    }else{
                        if(text.style.italic){
                            text.style.bold = !text.style.bold;
                        }
                    }
                }else{
                    if(vm.fontStyle.indexOf('BOLD') > -1){
                        text.style.bold = true;
                        if(text.style.italic){
                            if(vm.fontStyle.indexOf('BOLD_ITALIC') == -1){
                                text.style.italic = false;
                            }
                        }else{
                            // if( vm.fontStyle.indexOf('BOLD_ITALIC') > -1){
                            //     text.style.italic = true;
                            // }
                        }
                    }else if (vm.fontStyle.indexOf('BOLD_ITALIC') > -1) {
                        text.style.bold = true;
                        text.style.italic = true;
                    }
                }
                $timeout(function () {
                    sizeHeight();
                },200)
            }
        }

        // 字/行间距鼠标点击移动
        var spacingW = {};
        var flagSpacing = false
        window.resizeSpacingStart = function (e) {
            fn(e);
            var targ = e.target ? e.target : e.srcElement;
            spacingW.clientX = e.clientX || 0;
            spacingW.originLeft = targ.offsetLeft;
            spacingW.value = targ.dataset.value;
            var text = vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].textbox;
            if (text.lock) {
                return
            }
            flagSpacing = true;
            document.addEventListener("mousemove", resizeSpacingOn, true);
            document.addEventListener("mouseup", resizeSpacingEnd, true);
        }

        function resizeSpacingOn(e) {
            if (flagSpacing) {
                var text = vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].textbox;
                var l = spacingW.originLeft + e.clientX - spacingW.clientX;
                if (spacingW.value == 'height' && l < text.style.size) {
                    l = text.style.size;
                } else if (spacingW.value == 'width' && l < 0) {
                    l = 0;
                }
                if (l > 110) {
                    l = 110
                }
                if (spacingW.value == 'width') {
                    $(".block-width").css({left: l});
                    text.style.letterspacing = $scope.template.letterspacing = l;
                } else {
                    $(".block-height").css({left: l});
                    text.style.lineheight = $scope.template.lineheight = l;
                }
                sizeHeight();
                // var h = Number($('.selectedBorder').find('.c-xml-page-textboxe-text').height());
                // text.geometry.height = h / vm.pageData[vm.pageNumber].custom.ratio * (1 / 12 * vm.elementOn.item.style.size * vm.pageData[vm.pageNumber].custom.ratio > 1 ? 1 : 1 / 12 * vm.elementOn.item.style.size * vm.pageData[vm.pageNumber].custom.ratio) + Number(5);
                $scope.$digest();
            }
        }
        function resizeSpacingEnd() {
            if(flagSpacing){
                cookie();
            }
            spacingW = {}
            flagSpacing = false;
            document.removeEventListener("mousemove", resizeSpacingOn, true);
            document.removeEventListener("mouseup", resizeSpacingEnd, true);
        }
        vm.isOperationDir = false;
        $scope.operationDir = function (item) {
            vm.isOperationDir = item;
            vm.isOperationSpacing = false;
        }
        //左对齐
        $scope.operationBarDir = function (item) {
            var text = vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].textbox;
            text.style.align = item;
        }
        //横版
        $scope.textHengban = function () {
            var text = vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].textbox;
            var text1 = angular.copy(text);
            text.style.writingmode = 'horizontal-tb';
            text.geometry.width = text1.geometry.height;
            text.geometry.height = text1.geometry.width;
        }
        //竖版
        $scope.textShuban = function (item) {
            var text = vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].textbox;
            var text1 = angular.copy(text);
            var _writingmode = angular.copy(text.style.writingmode);
            text.style.writingmode = item;
            $timeout(function () {
                if(writingmodeInit(_writingmode) && writingmodeInit(text.style.writingmode)){
                }else{
                    text.geometry.width = text1.geometry.height;
                    text.geometry.height = text1.geometry.width;
                }
            },200)
        }

        //缓存每一步
        vm.cookie=cookie;
        function cookieInfo() {
            vm.cookies=[];
            var _data = angular.copy(vm.pageData[vm.pageNumber]);
            vm.cookies.push(_data);
            vm.cookieIndex = 0;
        }
        function cookie(){
            var _data = angular.copy(vm.pageData[vm.pageNumber]);
            // 如果当前不在栈顶（做过撤回后又执行了新操作），截断后面的历史
            if(vm.cookieIndex < vm.cookies.length - 1){
                vm.cookies = vm.cookies.slice(0, vm.cookieIndex + 1);
            }
            vm.cookies.push(_data);
            vm.cookieIndex = vm.cookies.length - 1;
            onArticleChange();
            pageUpdate();
        }
        //上一步
        $scope.rollback = function(){
            if(vm.cookieIndex <= 0){
                return;
            }
            vm.cookieIndex--;
            vm.pageData[vm.pageNumber] = null;
            vm.isCut = true;
            $timeout(function () {
                vm.pageData[vm.pageNumber] = angular.copy(vm.cookies[vm.cookieIndex]);
                magnitudeBox();
                vm.isCut = false;
            }, 0, false);
        };
        //恢复
        $scope.xmlNextStep = function(){
            vm.pageData[vm.pageNumber] = vm.cookies[0];
            vm.cookies=[];
            var _data = angular.copy(vm.pageData[vm.pageNumber]);
            vm.cookies.push(_data);
            vm.cookieIndex = 0;
            magnitudeBox();
        };

        //换书
        $scope.changeAllTemp = function ($event,line) {
            if(line.productXmlId == vm.article.productXmlId){
                MessageService.success("已是当前模板");
                return
            }
            MessageService.confirm({
                title:$translate.instant("editorCommon.replacementTemplate"),
                cancel:$translate.instant("button.cancel"),
                confirm:$translate.instant("button.confirm"),
                msg:$translate.instant("editorMessage.confirmReplace")
            },function(){
                templateReplace(line)
            })
        }
        function templateReplace(line) {
            if(vm.isEdit){
                vm.threeLoading = true;
                vm.photoSelectAll = [];
                vm.pageData.forEach(function (page) {
                    if(page.levels.level){
                        page.levels.level.forEach(function (level) {
                            if (level.imagebox && level.imagebox.image && level.imagebox.image.resource && level.imagebox.image.resource.identifier) {
                                vm.photoSelectAll.push({
                                    height: level.imagebox.image.resource.height,
                                    id: level.imagebox.image.resourceid,
                                    imageInfo: level.imagebox.image.imageInfo,
                                    identifier: level.imagebox.image.resource.identifier,
                                    imgsize: level.imagebox.image.imgsize,
                                    name: null,
                                    provider: "qiniu",
                                    usenum: 1,
                                    width: level.imagebox.image.resource.width
                                });
                            }
                        })
                    }
                })
                Convert.xmlToDocument2({
                    identifier: line.productXmlIdentifier,
                    provider: "qiniu",
                    editorType:vm.article.editorType,
                    patternType:vm.product.patternType,
                }, function (res) {
                    vm.pageSize = [];
                    res.pages.page.forEach(function(page){
                        if(page.levels && page.levels.level && page.levels.level.length>0){
                            page.levels.level.sort(compare('seq', true));
                        }
                        var o = {
                            width:page.mediabox.width,
                            height:page.mediabox.height
                        }
                        vm.pageSize.push(o);
                    })
                    angular.forEach(res.pages.page, function (page, i) {
                        angular.forEach(page.levels.level, function (level) {
                            if (level.imagebox && level.imagebox.geometry) {
                                vm.counts++;
                            }
                        })
                    });
                    vm.editProductXml = true;
                    vm.isHtml2canvas = false;
                    vm.article.document = res;
                    vm.productXmlLine = angular.copy(line);
                    vm.modelBlendentUuid=vm.productXmlLine.modelBlendentUuid;
                    vm.article.modelBlendentUuid= vm.productXmlLine.modelBlendentUuid;
                    vm.article.cover= vm.productXmlLine.coverImg;
                    vm.article.themeClassifyId= vm.productXmlLine.productXmlThemeId;
                    vm.article.themeClassifyName= vm.productXmlLine.productXmlThemeName;
                    vm.article.productXmlId= vm.productXmlLine.productXmlId;
                    vm.article.productXmlName= vm.productXmlLine.productXmlName;
                    vm.article.productXmlLineId= vm.productXmlLine.id;
                    if(vm.productXmlLine && vm.productXmlLine.musicIdentify){
                        vm.article.musicIdentify= vm.productXmlLine.musicIdentify;
                    }
                    res.config.startYear = vm.yearIndex;
                    res.config.startMonth = vm.monthIndex;
                    abook(res);
                });
            }else{
                $state.go("editorPhotoAlbum", {
                    storeId: vm.storeId,
                    pid: vm.pid,
                    vid: vm.vid,
                    xmlId: line.id
                },{location: 'replace'});
                localStorage.setItem("photoSelectAll", JSON.stringify(vm.photoSelectAll));
            }
        }

        // 即时保存
        $scope.immediateSave = function (e) {
            articleOverdue(function () {
                $scope.template.pages.page = vm.pageData;
                localStorage.setItem("photoSelectAll", JSON.stringify(vm.photoSelectAll));
                $scope.isContinue();
                generateJsonFile(true);
            })
        }
        //保存
        $scope.isSave = false;

        $scope.saveClick = function(){
            generateJsonFile();
            localStorage.removeItem("photoSelectAll");
        }
        vm.isPageWarnExamine = false;
        $scope.save = function () {
            articleOverdue(function () {
                $scope.template.pages.page = vm.pageData;
                if($scope.isSave){
                    return;
                }
                if(!vm.isPageWarnExamine && pageWarnExamine($scope.template.pages.page, vm.imgSize, vm.imgDpi)){
                    MessageService.confirm({
                        title:$translate.instant("editorCommon.hint"),
                        cancel:$translate.instant("button.amend"),
                        confirm:$translate.instant("button.continueSave"),
                        msg:$translate.instant("editorMessage.lackPixelsMessage")
                    },function(){
                        vm.isPageWarnExamine = true;
                        $scope.save();
                    })
                    return
                }
                vm.isPageWarnExamine = false;

                if(vm.article.ordered){
                    SweetAlert.swal({
                        title: $translate.instant("editorMessage.warmPrompt"),
                        imageUrl: Theme.sweetHintImg(),
                        text: $translate.instant("editorMessage.newWork"),
                        timer: 2000,
                        showConfirmButton: false
                    });
                }
                //判断是否有图片未上传  且是否继续保存
                if (!$scope.isContinue()) {
                    vm.saveSure = true;
                } else {
                    generateJsonFile();
                    localStorage.removeItem("photoSelectAll");
                }
            })
        }
        function articleOverdue(callback){
            if($stateParams.aid){
                Article.get({id: $stateParams.aid}, function (article) {
                    if(article.data.fileName != vm.article.fileName){
                        MessageService.confirm({
                            title:$translate.instant("editorCommon.hint"),
                            cancel:$translate.instant("button.cancel"),
                            confirm:$translate.instant("button.refresh"),
                            msg:$translate.instant("hint.articleOverdue")
                        },function(){
                            $state.go("editorPhotoAlbumEdit", {storeId: vm.storeId, aid:  vm.article.id},{reload:true,location: 'replace'});
                        })
                    }else{
                        callback();
                    }
                })
            }
            if($stateParams.orderArticleId) {
                OrderArticle.getByUser({id: $stateParams.orderArticleId}, function (article) {
                    if(article.data.fileName != vm.article.fileName){
                        MessageService.confirm({
                            title:$translate.instant("editorCommon.hint"),
                            cancel:$translate.instant("button.cancel"),
                            confirm:$translate.instant("button.refresh"),
                            msg:$translate.instant("hint.articleOverdue")
                        },function(){
                            $state.go("editorPhotoAlbumEdit1", {storeId: vm.storeId, orderArticleId:  $stateParams.orderArticleId},{reload:true,location: 'replace'});
                        })
                    }else{
                        callback();
                    }
                })
            }
        }
        vm.documentDetection = {
            pass: true
        };
        vm.documentDetectionTab="text";
        function generateJsonFile(flag){
            vm.documentDetection = documentTextDetection($scope.template.pages.page);
            if(!vm.documentDetection.pass){
                if(vm.documentDetection.isText){
                    vm.documentDetectionTab="text";
                }else{
                    vm.documentDetectionTab="repetition";
                }
                return;
            }
            thumbnailInit1(function (){
                pagecover(0,flag)
            })
        }
        function pagecover(index,flag){
            if(index > $scope.template.pages.page.length-1){
                generateJsonFile1(flag)
            }else{
                if(index == vm.pageNumber || !$scope.template.pages.page[index].pagecover || !$scope.template.pages.page[index].pagecover.thumbnailInit2){
                    thumbnailInit2($scope.template.pages.page[index],function(){
                        index++
                        pagecover(index,flag)
                    })
                }else{
                    index++
                    pagecover(index,flag)
                }
            }
        }
        function generateJsonFile1(flag){
            $scope.isSave = true;
            var template = saveData();
            // if(vm.reservePage){
            //     vm.reservePage.forEach(function (page){
            //         template.pages.page.push(page);
            //     });
            // }
            template.hostinfo = hostInfo();
            vm.threeLoading = true;
            Convert.articleUploadDocument(template, function (res) {
                vm.article.articleStatus = vm.completed;
                vm.article.productType = 'CustomPrint';
                vm.article.fileName = res.data.identifier;
                vm.article.unFilledCount = vm.unFilledCount;
                vm.article.version = '4.0';
                vm.article.pageCount = vm.pageData.length;
                vm.article.saveUserName = localStorage.getItem('saveUserName') || ''
                if($stateParams.aid){
                    Article.update(vm.article, function (resp) {
                        vm.article.fileName = resp.data.fileName;
                        $scope.isSave = false;
                        vm.threeLoading = false;
                        if (flag) {
                            MessageService.success($translate.instant("editorMessage.saveSuccess"));
                            $location.search({
                                'saveArticle': vm.article.id,
                            });
                        } else {
                            swal({
                                title: $translate.instant("editorMessage.modifySuccess"),
                                text: $translate.instant("editorMessage.synchronizationOfWorks"),
                                imageUrl: Theme.sweetSuccedImg(),
                                timer: 2000,
                                showConfirmButton: false
                            });
                            $(".wrap").show();
                            $(".navbar").show();
                            var screenW = document.body.clientWidth;
                            //web 端
                            if(screenW>1000){
                                $state.go("page-view", {storeId: vm.storeId, aid:  resp.data.id},{location: 'replace'});
                            }else{
                                $state.go("product-view5-ec", {storeId: vm.storeId, aid:  resp.data.id},{location: 'replace'});
                            }

                            // return
                            // $state.go("page-view", {storeId: vm.storeId, aid: resp.data.id}, {reload: true,location: 'replace'});

                        }
                    }, function () {
                        $scope.isSave = false;
                        vm.threeLoading = false;
                        swal({
                            title: $translate.instant("editorMessage.saveError"),
                            text: $translate.instant("editorMessage.saveError1"),
                            imageUrl: Theme.sweetHintImg(),
                            timer: 2000,
                            showConfirmButton: false
                        });
                    })
                }else if($stateParams.orderArticleId){
                    OrderArticle.update(vm.article, function (resp) {
                        vm.article.fileName = resp.data.fileName;
                        $scope.isSave = false;
                        vm.threeLoading = false;
                        if (flag) {
                            MessageService.success($translate.instant("editorMessage.saveSuccess"));
                            $location.search({
                                'saveArticle': vm.article.id,
                            });
                        } else {
                            swal({
                                title: $translate.instant("editorMessage.modifySuccess"),
                                text: $translate.instant("editorMessage.synchronizationOfWorks"),
                                imageUrl: Theme.sweetSuccedImg(),
                                timer: 2000,
                                showConfirmButton: false
                            });
                            $(".wrap").show();
                            $(".navbar").show();
                            var screenW = document.body.clientWidth;
                            //web 端
                            $state.go("page-view2", {storeId: vm.storeId, orderArticleId:  resp.data.id},{location: 'replace'});

                        }
                    }, function () {
                        $scope.isSave = false;
                        vm.threeLoading = false;
                        swal({
                            title: $translate.instant("editorMessage.saveError"),
                            text: $translate.instant("editorMessage.saveError1"),
                            imageUrl: Theme.sweetHintImg(),
                            timer: 2000,
                            showConfirmButton: false
                        });
                    })
                }
            }, function () {
                $scope.isSave = false;
                vm.threeLoading = false;
                swal({
                    title: $translate.instant("editorMessage.saveError"),
                    text: $translate.instant("editorMessage.saveError1"),
                    imageUrl: Theme.sweetHintImg(),
                    timer: 2000,
                    showConfirmButton: false
                });
            })
        }
        $scope.isContinue = function () {
            var hasEmpty = true;
            vm.unFilledCount = 0;
            for(var i=0; i<$scope.template.pages.page.length; i++){
                var _page = $scope.template.pages.page[i];
                if(_page.levels.level){
                    for(var j=0; j<_page.levels.level.length; j++){
                        var _level = _page.levels.level[j];
                        if(_level.imagebox){
                            if(!_level.imagebox.image || !_level.imagebox.image.resource || !_level.imagebox.image.resource.identifier){
                                hasEmpty = false;
                                vm.unFilledCount++
                            }
                        }
                    }
                }
            }
            vm.completed = hasEmpty ? 'COMPLETED' : 'EDITING';
            return hasEmpty;
        };
        $scope.exitWork = function (e) {
            vm.exitSure = true;
        }

        $scope.exitPageCancel = function (isSave) {
            vm.exitSure = false
            if(isSave){
                $scope.save()
            }
        }
        $scope.exitPage = function () {
            localStorage.removeItem("photoSelectAll");
            if (vm.pid) {
                $(".wrap").show();
                $(".navbar").show();
                $state.go("commoditySelect", {
                    storeId: vm.storeId,
                    pid: vm.pid,
                    vid: vm.vid,
                    aid: vm.aid,
                }, {reload: true,location: 'replace'});
            } else {
                window.location.href = localStorage.getItem('returnurl');
            }
        }
        function saveData() {
            return documentMM($scope.template);
        }

        //预览
        $scope.previewTab = function () {
            if(vm.productXmlData.modelType && vm.productXmlData.modelType === 'THREE'){
                if(!vm.productXmlData.modelPath){
                    MessageService.error($translate.instant("editorMessage.not3D"));
                    return
                }
                vm.threeView = true;
            }else {
                $scope.template.pages.page = vm.pageData;
                vm.previewArticle = saveData();
                vm.watchSure = true;
            }
        }



        //画布操作
        vm.moveCanvasView = false;
        vm.ratio = 0;
        $scope.ratioJia = function(){
            vm.ratio += 0.02;
            if(vm.ratio >3){
                vm.ratio = 3;
            }
            if(vm.pageData[vm.pageNumber1]){
                vm.pageData[vm.pageNumber1].custom.ratio = vm.pageData[vm.pageNumber1].custom.ratio2/100 + vm.ratio;
            }
            if(vm.pageData[vm.pageNumber2]){
                vm.pageData[vm.pageNumber2].custom.ratio = vm.pageData[vm.pageNumber2].custom.ratio2/100 + vm.ratio;
            }
            updateMeasureRuler();
        }
        $scope.ratioJian = function(){
            vm.ratio -= 0.02;
            if(vm.ratio < -0.1){
                vm.ratio = -0.1;
            }
            if(vm.pageData[vm.pageNumber1]){
                vm.pageData[vm.pageNumber1].custom.ratio = Number(vm.pageData[vm.pageNumber1].custom.ratio2/100) + vm.ratio;
            }
            if(vm.pageData[vm.pageNumber2]){
                vm.pageData[vm.pageNumber2].custom.ratio = vm.pageData[vm.pageNumber2].custom.ratio2/100 + vm.ratio;
            }
            updateMeasureRuler();
        };
        $scope.ratioInit = function(isRatio){
            if(isRatio){
                vm.ratio = 0
            }
            if(vm.pageData[vm.pageNumber1]){
                vm.pageData[vm.pageNumber1].custom.ratio2 = vm.pageData[vm.pageNumber1].custom.ratio3;
                vm.pageData[vm.pageNumber1].custom.ratio = vm.pageData[vm.pageNumber1].custom.ratio2/100;
            }
            if(vm.pageData[vm.pageNumber2]){
                vm.pageData[vm.pageNumber2].custom.ratio2 = vm.pageData[vm.pageNumber2].custom.ratio3;
                vm.pageData[vm.pageNumber2].custom.ratio = vm.pageData[vm.pageNumber2].custom.ratio2/100;
            }
            updateMeasureRuler();
        }
        $scope.ratioOriginal = function(){
            if(vm.pageData[vm.pageNumber1]){
                vm.pageData[vm.pageNumber1].custom.ratio2 = 100;
                vm.pageData[vm.pageNumber1].custom.ratio = vm.pageData[vm.pageNumber1].custom.ratio2/100;
            }
            if(vm.pageData[vm.pageNumber2]){
                vm.pageData[vm.pageNumber2].custom.ratio2 = 100;
                vm.pageData[vm.pageNumber2].custom.ratio = vm.pageData[vm.pageNumber2].custom.ratio2/100;
            }
            updateMeasureRuler();
        }
        $scope.moveCanvasCb = function(){
            vm.moveCanvasView = !vm.moveCanvasView;
        }
        // 保存滚轮事件处理函数的变量
        var mousewheelHandler = function(event){
            if (event.ctrlKey === true || event.metaKey) {
                var wheelDelta = event.wheelDelta ? (event.wheelDelta / 120) : ( - event.detail / 3);
                if(wheelDelta>0){
                    $scope.ratioJia();
                }else{
                    $scope.ratioJian();
                }
                $scope.$apply();
                event.preventDefault();
            }
        }
        originalEventRatio();
        vm.textFont = false;
        function originalEventRatio(){
            window.addEventListener('mousewheel', mousewheelHandler,{ passive: false});

            document.onkeydown = function (event) {
                if (event.keyCode == 32 && !vm.moveCanvasView && !vm.textFont) {
                    $timeout(function () {
                        vm.moveCanvasView = true;
                    })
                    return false
                }
            }
            $(document).keyup(function(event){
                vm.moveCanvasView = false;
                $scope.$apply();
                return false
            });
        }
        //移动画布
        vm.moveCanvasObj = {
            x:0,
            y:0
        };
        $scope.moveCanvas = function(e){
            if(!vm.moveCanvasView){
                return
            }
            var _moveCanvasObj = angular.copy(vm.moveCanvasObj);
            moveCanvas(e, function (x, y) {
                vm.moveCanvasObj.x = _moveCanvasObj.x + x;
                vm.moveCanvasObj.y = _moveCanvasObj.y + y;
                $timeout(function () {
                    updateMeasureRuler();
                })
            })
        }


        $scope.writingmodeInit = function (item) {
            if(item == 'vertical-lr' || item == 'vertical-rl'){
                return true
            }else{
                return false
            }
        }


        //像素不足提醒
        vm.imgSize = 150;
        vm.imgDpi = 150;
        StoreWorkEditConfig.storeId({storeId: vm.storeId}, function (res) {
            if(res.status == 200){
                vm.imgSize = res.data.imgSize;
                vm.imgDpi = res.data.imgDpi;
            }
        });
        $scope.onArticleChange = onArticleChange;
        vm.onArticleChange = onArticleChange;
        function onArticleChange() {
            vm.articleChanged = true;
        }

        //生成缩略图
        function startThumbnailTimer() {
            $timeout(handleThumbnailForThree, 3000); // every 3 seconds
        }
        function handleThumbnailForThree() {
            if (vm.productXmlData && vm.productXmlData.modelType === 'THREE' && vm.articleChanged) {
                vm.articleChanged = false;
                try {
                    thumbnailInit();
                }
                catch (error) {
                    console.log("Error to handleThumbnailForThree", error);
                }
            }
            startThumbnailTimer();
        }

        startThumbnailTimer();
        vm.isHtml2canvas = false;
        vm.pageData1 = [];
        vm.thumbnailInit = thumbnailInit;
        var a = null;
        function thumbnailInit() {
            if(!vm.productXmlData || vm.productXmlData.modelType != 'THREE'){
                return
            }
            if (a !== null) {
                clearTimeout(a)
            }
            a = setTimeout(function() {
                vm.thumbnailPageData = angular.copy(vm.pageData[vm.pageNumber]);
                pageTrimbox(vm.thumbnailPageData,$translate.instant("editorCommon.doubleClickType"))
                $timeout(function () {
                    html2canvas_adapt(document.getElementById('thumbnail-view'), {
                        onrendered: function (canvas) {
                            QiniuToken.uploadThumbnail(canvas, function (data) {
                                vm.pageData[vm.pageIndex].pagecover = {
                                    identifier: $scope.domain + data.key,
                                    provider: 'qiniu'
                                }
                                vm.isHtml2canvas = true;
                                vm.pageData1 = angular.copy(vm.pageData);
                            });
                        },
                        letterRendering: true,
                        useCORS: true,
                        width: vm.thumbnailPageData.mediabox.width*vm.thumbnailPageData.custom.thumbnailScale,
                        height: vm.thumbnailPageData.mediabox.height*vm.thumbnailPageData.custom.thumbnailScale,
                        windowWidth: document.body.scrollWidth,
                        windowHeight: document.body.scrollHeight,
                        x: 0,
                        y: 0,
                        backgroundColor: "rgba(0, 0, 0, 0)"
                    });
                },1000)
            }, 3000);
        }
        //生成封面图
        function thumbnailInit1(callback) {
            vm.threeLoading = true;
            vm.threeLoadingText = $translate.instant("editorCommon.loadingText");
            vm.thumbnailPageData1 = angular.copy(vm.pageData[0]);
            pageTrimbox(vm.thumbnailPageData1,$translate.instant("editorCommon.doubleClickType"))
            $timeout(function (){
                html2canvas_adapt(document.getElementById('thumbnail-view1'), {
                    onrendered: function (canvas) {
                        QiniuToken.uploadThumbnail(canvas, function (data) {
                            vm.threeLoading = false;
                            var identifier = data.key;
                            vm.article.covered=true;
                            vm.article.cover=identifier;
                            if(callback){callback()};
                        });
                    },
                    letterRendering: true,
                    useCORS: true,
                    width: vm.thumbnailPageData1.mediabox.width*vm.thumbnailPageData1.custom.thumbnailScale,
                    height: vm.thumbnailPageData1.mediabox.height*vm.thumbnailPageData1.custom.thumbnailScale,
                    windowWidth: document.body.scrollWidth,
                    windowHeight: document.body.scrollHeight,
                    x: 0,
                    y: 0,
                    backgroundColor: "rgba(0, 0, 0, 0)"
                });
            },1000)
        }
        //生成封面图
        function thumbnailInit2(page,callback) {
            if(!page.scene || !page.scene.geometry){
                callback()
                return
            }
            vm.threeLoading = true;
            vm.threeLoadingText = "";
            vm.thumbnailPageData = angular.copy(page);
            $timeout(function (){
                html2canvas_adapt(document.getElementById('thumbnail-view'), {
                    onrendered: function (canvas) {
                        QiniuToken.uploadThumbnail(canvas, function (data) {
                            vm.threeLoading = false;
                            page.pagecover = {
                                identifier: $scope.domain + data.key,
                                provider: 'qiniu',
                                thumbnailInit2:true
                            }
                            callback()
                        });
                    },
                    letterRendering: true,
                    useCORS: true,
                    width: vm.thumbnailPageData.custom.width*vm.thumbnailPageData.custom.thumbnailScale,
                    height: vm.thumbnailPageData.custom.height*vm.thumbnailPageData.custom.thumbnailScale,
                    windowWidth: document.body.scrollWidth,
                    windowHeight: document.body.scrollHeight,
                    x: 0,
                    y: 0,
                    backgroundColor: "rgba(0, 0, 0, 0)"
                });
            },1000)
        }


        //页面元素
        vm.isEditorPageElementBody = true;
        $scope.levelInfo = function (level, index) {
            var item = "";
            index = completeIndex(index)
            var i = index+1;
            if(level.imagebox){
                item += $translate.instant("editorCommon.imagebox")
            }
            if(level.imageart){
                item += $translate.instant("editorCommon.imageart")
            }
            if(level.textbox){
                item += level.textbox.text || ""
            }
            if(level.textdocument){
                item += $translate.instant("editorCommon.textdocument")
            }
            if(level.calMonthBox){
                item += $translate.instant("editorCommon.calMonthBox")
            }
            if(level.calTitleBox){
                item += $translate.instant("editorCommon.calTitleBox")
            }
            return item
        };
        function levelInfo1(level) {
            var item = "";
            if(level.imagebox){
                item = "imagebox"
            }
            if(level.imageart){
                item = "imageart"
            }
            if(level.textbox){
                item = 'textbox'
            }
            if(level.textdocument){
                item = "textdocument"
            }
            if(level.calTitleBox){
                item = "calTitleBox"
            }
            if(level.calMonthBox){
                item = "calMonthBox"
            }
            return item
        };
        $scope.levelDelete = function (index) {
            var levels = vm.pageData[vm.pageNumber].levels.level.splice(completeIndex(index), 1);
            if(levels && levels[0] && levels[0].imagebox){
                setLayout();
            }
            if (levels && levels[0] && levels[0].imagebox && levels[0].imagebox.image&& levels[0].imagebox.image.resourceid) {
                for (var j = 0; j < $scope.photos.length; j++) {
                    var arr = $scope.photos[j];
                    if (arr.sourceId == levels[0].imagebox.image.resourceid) {
                        arr.usenum == 0 ? 0 : arr.usenum--;
                    }
                }
            }
            magnitudeBox()
            cookie();
        };
        $scope.levelHidden = function (e, level) {
            level.isHidden = !level.isHidden;
            fn(e)
        }

        //页面元素移动
        var isBoxDown = false;
        vm.pageElementW = $('.editor-page-element-title').width();
        vm.pageElementH = $('.editor-page-element-title').height();
        vm.pageElementL = $(window).width() - vm.pageElementW - 160;
        vm.pageElementT = 110;
        $scope.movePageElement = function (e) {
            fn(e);
            var x = e.clientX;
            var y = e.clientY;
            var l = angular.copy(vm.pageElementL);
            var t = angular.copy(vm.pageElementT);
            isBoxDown = true;
            window.onmousemove = function (e) {
                if (isBoxDown && $("#canvasView") && $("#canvasView").offset()) {
                    var nx = e.clientX;
                    var ny = e.clientY;
                    var nl = nx - (x - l);
                    var nt = ny - (y - t);
                    if(nl < $("#canvasView").offset().left){
                        nl = $("#canvasView").offset().left
                    }
                    if(nl > ($("#canvasView").offset().left + $("#canvasView").width() - vm.pageElementW)){
                        nl = ($("#canvasView").offset().left + $("#canvasView").width() - vm.pageElementW)
                    }
                    if(nt < $("#canvasView").offset().top){
                        nt = $("#canvasView").offset().top
                    }
                    if(nt > ($("#canvasView").offset().top + $("#canvasView").height() - vm.pageElementH)){
                        nt = ($("#canvasView").offset().top + $("#canvasView").height() - vm.pageElementH)
                    }
                    vm.pageElementL = nl;
                    vm.pageElementT = nt;
                    $scope.$apply();
                }

            }
            window.onmouseup = function (e) {
                isBoxDown = false;
                e.stopPropagation();
                $scope.$apply();
            }
        };
        //页面元素拖拽
        var sort1 = null;
        var sortArray1 = [];
        function pageListDrag1() {
            $timeout(function () {
                vm.sortingLevel = angular.copy(vm.pageData[vm.pageNumber].levels.level);
                sort1 = new Sortable(document.getElementById('pageList1'), {
                    swap: false,
                    filter: '.filtered',
                    cancel: ".notDrag",
                    preventOnFilter: true,
                    animation: 150,
                    onEnd: function (/**Event*/evt) {
                        sortArray1 = [];
                        angular.forEach($('#pageList1').find(".sortingPageView"), function (item, index) {
                            var page = item.getAttribute("data-page");
                            sortArray1.push(JSON.parse(page));
                        });
                        if(sortArray1 && sortArray1.length>0){
                            vm.pageData[vm.pageNumber].levels.level = [];
                            $timeout(function () {
                                vm.pageData[vm.pageNumber].levels.level = angular.copy(sortArray1.reverse());
                                vm.pageData[vm.pageNumber].levels.level.forEach(function (value, index) {
                                    value.seq = index+1;
                                })
                                sortArray1 = [];
                                $scope.editorBodyView();
                            })
                        }
                    }
                });
            })
        }
        $scope.dragCompleteClick = function (e, level, index) {
            fn(e)
            elementInit((vm.pageData[vm.pageNumber].levels.level.length-1-index),vm.pageNumber,level[levelInfo1(level)],levelInfo1(level),true);
        };
        vm.completeIndex = completeIndex;
        function completeIndex(index) {
            if(vm.pageData[vm.pageNumber] && vm.pageData[vm.pageNumber].levels && vm.pageData[vm.pageNumber].levels.level){
                return vm.pageData[vm.pageNumber].levels.level.length-1-index
            }
        }
        function scrollIntoView() {
            multiSelect();
            $timeout(function () {
                if(vm.elementOn.index>=0){
                    if(document.getElementById('editor-page-element-body-view' + vm.elementOn.index)){
                        document.getElementById('editor-page-element-body-view' + vm.elementOn.index).scrollIntoView()
                    }
                }
            })
        }

        vm.multiSelect = multiSelect;
        function multiSelect() {
            var all = getAllCtrlKeyArray();
            vm.transparencyBtn = true;//透明度
            vm.lockingBtn = true;//锁定
            vm.generBoxBtn = true;//重复生成
            vm.coverageBtn = true;//图层
            vm.copyBtn = true;//复制
            vm.deleteBtn = true;//删除
            vm.textboxBtn = true;//文字
            vm.toobarAlignmentBtn = false;//对齐
            vm.isAlignHover = false;// 对齐方式
            vm.isDistributeHover = false;//分布
            vm.hasImgBtn = false; //裁切交换
            vm.distribute = false;//分布
            if(all.length>0){
                vm.textboxBtn = false;
                vm.lockingBtn = false;
                vm.coverageBtn = false;
                vm.deleteBtn = false;
                if (all.length>1) {
                    vm.toobarAlignmentBtn = true;
                }
                if (all.length>2) {
                    vm.distribute = true;
                }
                angular.forEach(all, function (level) {
                    if (level.code && level.code.ctrlKey) {
                        vm.transparencyBtn = false;
                    }
                })
            }else{
                if(!vm.elementOn || !vm.elementOn.name || vm.elementOn.name == 'calTitleBox' || vm.elementOn.name == 'calMonthBox'){
                    vm.transparencyBtn = false;
                    vm.lockingBtn = false;
                    vm.generBoxBtn = false;
                    vm.coverageBtn = false;
                    vm.copyBtn = false;
                    vm.deleteBtn = false;
                }
                if(vm.elementOn.name == 'textdocument'){
                    vm.copyBtn = false;
                }
                if(vm.elementOn && vm.elementOn.item && vm.elementOn.item.lock){
                    vm.textboxBtn = false;
                    vm.coverageBtn = false;
                    vm.deleteBtn = false;
                }
                if(vm.elementOn && vm.elementOn.name == 'imagebox' && vm.elementOn.item && vm.elementOn.item.image && vm.elementOn.item.image.resource && vm.elementOn.item.image.resource.identifier){
                    vm.hasImgBtn = true;
                }
            }
        }
        //边框
        $scope.imageboxW = function (imagebox) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.geometry.width) + Number(imagebox.border.lineWidth) * 2
                }
                if (imagebox.border.type == 'Pic') {
                    return imagebox.geometry.width
                    // return Number(imagebox.geometry.width) + (Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100) + (Number(imagebox.geometry.width) * Number(imagebox.border.edge.right) / 100)
                }
            } else {
                return imagebox.geometry.width
            }
        }
        $scope.imageboxH = function (imagebox) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.geometry.height) + Number(imagebox.border.lineWidth) * 2
                }
                if (imagebox.border.type == 'Pic') {
                    return imagebox.geometry.height
                    // return Number(imagebox.geometry.height) + (Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100) + (Number(imagebox.geometry.height) * Number(imagebox.border.edge.bottom) / 100)
                }
            } else {
                return imagebox.geometry.height
            }
        }
        $scope.imageboxL = function (imagebox) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.geometry.x) - Number(imagebox.border.lineWidth)
                }
                if (imagebox.border.type == 'Pic') {
                    return imagebox.geometry.x
                    // return Number(imagebox.geometry.x) - (Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100)
                }
            } else {
                return imagebox.geometry.x
            }
        }
        $scope.imageboxT = function (imagebox) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.geometry.y) - Number(imagebox.border.lineWidth)
                }
                if (imagebox.border.type == 'Pic') {
                    return imagebox.geometry.y
                    // return Number(imagebox.geometry.y) - (Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100)
                }
            } else {
                return imagebox.geometry.y
            }
        }
        $scope.imageboxWEdge = function (imagebox, edge) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                if (imagebox.border.type == 'Color') {
                    return Number(imagebox.border.lineWidth)
                }
                if (imagebox.border.type == 'Pic') {
                    if (edge == 'left') {
                        return Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100
                    }
                    if (edge == 'top') {
                        return Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100
                    }
                    if (edge == 'right') {
                        return Number(imagebox.geometry.width) * Number(imagebox.border.edge.right) / 100
                    }
                    if (edge == 'bottom') {
                        return Number(imagebox.geometry.height) * Number(imagebox.border.edge.bottom) / 100
                    }
                }
            } else {
                return 0
            }
        }
        $scope.imageboxWRadius = function (imagebox, radius, ratio, ratio1) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                var _ratio = 1;
                if(ratio && ratio1){
                    if(imagebox.geometry.width > imagebox.geometry.height){
                        _ratio = ratio1
                    }else{
                        _ratio = ratio
                    }
                }
                if(ratio && !ratio1){
                    _ratio = ratio
                }
                if (imagebox.border.shape == 'Ellipse') {
                    return '50%'
                }
                if (imagebox.border.radius.filletType == 'Fixed') {//圆角固定值
                    var _radius = imagebox.border.radius[radius];
                    return _radius > 0 ?  (_radius + Number(imagebox.border.lineWidth)/2) * _ratio : 0;
                }else{
                    var radiusW = imagebox.geometry.width > imagebox.geometry.height ? imagebox.geometry.height : imagebox.geometry.width;
                    radiusW = radiusW + imagebox.border.lineWidth;
                    var _r = radiusW * imagebox.border.radius[radius] / 100;
                    return _r > 0 ? (_r + Number(imagebox.border.lineWidth)/2) * _ratio : 0
                }
            } else {
                return 0
            }
        }
        $scope.imageboxWRadius1 = function (imagebox, radius, ratio, ratio1) {
            if (!imagebox) {
                return
            }
            if (imagebox.border) {
                var _ratio = 1;
                if(ratio && ratio1){
                    if(imagebox.geometry.width > imagebox.geometry.height){
                        _ratio = ratio1
                    }else{
                        _ratio = ratio
                    }
                }
                if(ratio && !ratio1){
                    _ratio = ratio
                }
                if (imagebox.border.shape == 'Ellipse') {
                    return '50%'
                }
                if (imagebox.border.radius.filletType == 'Fixed') {//圆角固定值
                    var _radius = imagebox.border.radius[radius];
                    return  (_radius - Number(imagebox.border.lineWidth)/2) > 0 ? (_radius - Number(imagebox.border.lineWidth)/2) * _ratio : 0;
                }else{
                    var radiusW = imagebox.geometry.width > imagebox.geometry.height ? imagebox.geometry.height : imagebox.geometry.width;
                    radiusW = radiusW + imagebox.border.lineWidth;
                    var _r = radiusW * imagebox.border.radius[radius] / 100;
                    return (_r - Number(imagebox.border.lineWidth)/2) > 0 ? (_r - Number(imagebox.border.lineWidth)/2) * _ratio : 0
                }
            } else {
                return 0
            }
        }

        //元素全选
        vm.levelInif = levelInif;
        function levelInif() {
            vm.ctrlKey = false;
            angular.forEach($scope.template.pages.page, function (page) {
                angular.forEach(page.levels.level, function (level, i) {
                        if(level.code&&level.code.geometry){
                            level.code.ctrlKey = false;
                        }
                        if(level.imageart){
                            level.imageart.ctrlKey = false;
                        }
                        if(level.imagebox){
                            level.imagebox.exchange = false;
                            level.imagebox.ctrlKey = false;
                        }
                        if(level.textbox){
                            level.textbox.ctrlKey = false;
                        }
                        if (level.textdocument && level.textdocument.geometry) {
                            level.textdocument.ctrlKey = false;
                        }
                        if (level.calMonthBox && level.calMonthBox.geometry) {
                            level.calMonthBox.ctrlKey = false;
                        }
                        if (level.calTitleBox && level.calTitleBox.geometry) {
                            level.calTitleBox.ctrlKey = false;
                        }
                    })
            })
            multiSelect();
        }
        vm.levelInif1 = levelInif1;
        function levelInif1() {
            $timeout(function () {
                angular.forEach($scope.template.pages.page, function (page, index) {
                    if(index != vm.pageNumber){
                        angular.forEach(page.levels.level, function (level, i) {
                            if(level.code&&level.code.geometry){
                                level.code.ctrlKey = false;
                            }
                            if(level.imageart){
                                level.imageart.ctrlKey = false;
                            }
                            if(level.imagebox){
                                level.imagebox.exchange = false;
                                level.imagebox.ctrlKey = false;
                            }
                            if(level.textbox){
                                level.textbox.ctrlKey = false;
                            }
                            if (level.textdocument && level.textdocument.geometry) {
                                level.textdocument.ctrlKey = false;
                            }
                            if (level.calTitleBox && level.calTitleBox.geometry) {
                                level.calTitleBox.ctrlKey = false;
                            }
                            if (level.calMonthBox && level.calMonthBox.geometry) {
                                level.calMonthBox.ctrlKey = false;
                            }
                        })
                    }
                })
                multiSelect();
            })
        };

        vm.levelMove = levelMove;
        function levelMove(event, operation) {
            angular.forEach($scope.template.pages.page, function (page) {
                angular.forEach(page.levels.level, function (level, i) {
                    if(level.imageart && level.imageart.ctrlKey && !level.imageart.edit){
                        if(operation == 'transparency'){
                            level.imageart.transparency = parseFloat(vm.transparency/100);
                            return
                        }
                        if(!level.imageart.lock) {
                            moveWebdown($scope, event, level.imageart, vm.pageData[vm.pageNumber].trimbox, vm.pageData[vm.pageNumber].custom.ratio, function () {
                                cookie()
                            })
                        }
                    }
                    if(level.imagebox && level.imagebox.ctrlKey){
                        if(operation == 'transparency'){
                            level.imagebox.transparency = parseFloat(vm.transparency/100);
                            return
                        }
                        if(!level.imagebox.lock) {
                            moveWebdown($scope, event, level.imagebox, vm.pageData[vm.pageNumber].trimbox, vm.pageData[vm.pageNumber].custom.ratio, function () {
                                cookie()
                            })
                        }
                    }
                    if(level.textbox && level.textbox.ctrlKey){
                        if(operation == 'transparency'){
                            level.textbox.transparency = parseFloat(vm.transparency/100);
                            return
                        }
                        if(!level.textbox.lock) {
                            moveWebdown($scope, event, level.textbox, vm.pageData[vm.pageNumber].trimbox, vm.pageData[vm.pageNumber].custom.ratio, function () {
                                cookie()
                            })
                        }
                    }
                    if (level.textdocument && level.textdocument.ctrlKey) {
                        if(operation == 'transparency'){
                            level.textdocument.transparency = parseFloat(vm.transparency/100);
                            return
                        }
                        if(!level.textdocument.lock) {
                            moveWebdown($scope, event, level.textdocument, vm.pageData[vm.pageNumber].trimbox, vm.pageData[vm.pageNumber].custom.ratio, function () {
                                cookie()
                            })
                        }
                    }
                    if (level.calMonthBox && level.calMonthBox.ctrlKey) {
                        if(operation == 'transparency'){
                            level.calMonthBox.transparency = parseFloat(vm.transparency/100);
                            return
                        }
                        if(!level.calMonthBox.lock) {
                            moveWebdown($scope, event, level.calMonthBox, vm.pageData[vm.pageNumber].trimbox, vm.pageData[vm.pageNumber].custom.ratio, function () {
                                cookie()
                            })
                        }
                    }
                    if (level.calTitleBox && level.calTitleBox.ctrlKey) {
                        if(operation == 'transparency'){
                            level.calTitleBox.transparency = parseFloat(vm.transparency/100);
                            return
                        }
                        if(!level.calTitleBox.lock) {
                            moveWebdown($scope, event, level.calTitleBox, vm.pageData[vm.pageNumber].trimbox, vm.pageData[vm.pageNumber].custom.ratio, function () {
                                cookie()
                            })
                        }
                    }
                })
            })
        }
        //对齐
        vm.isAlignHover = false;
        $scope.alignHover = function () {
            vm.isAlignHover = !vm.isAlignHover;
            vm.isDistributeHover = false;
        }
        //裁切
        $scope.doubleClickImagebox = function (event) {
            $rootScope.$broadcast('doubleClickImageboxCallback',{
                event: event,
                index: vm.elementOn.index,
                item: vm.elementOn.item,
                pageIndex: vm.elementOn.pageIndex,
            });
            toolbarStatus();
        };
        //交换
        $scope.exchange = function () {
            vm.pageData[vm.pageNumber].levels.level.forEach(function (level, index) {
                if(level.imagebox){
                    if(index!=vm.elementOn.index){
                        level.imagebox.exchange = true;
                    }else{
                        level.imagebox.exchange = false;
                    }
                }
            })
            toolbarStatus();
        };
        //智能抠图
        $scope.mattingOpen = function () {
            if (!vm.elementOn || vm.elementOn.name !== 'imagebox' || !vm.elementOn.item) return;
            $timeout(function(){
                var div = document.getElementsByClassName('selected');
                if (div.length > 0) {
                    var rect = div[0].getBoundingClientRect();
                    vm.imageboxCutout = {
                        image: vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].imagebox.image.resource.identifier,
                        mattingMask: vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].imagebox.image.mattingMask,
                        resourceid: vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].imagebox.image.resourceid,
                        x: rect.left,
                        y: rect.top,
                        width: rect.width,
                        height: rect.height,
                        angle: vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].imagebox.image.angle,
                        flip: vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].imagebox.flip,
                    }
                    vm.isShowImageCutout = true;
                }
            })
        };
        $scope.imageCutoutChange = function(text){
            if(text){
                vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].imagebox.image.resource.identifier = text.result;
                vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].imagebox.image.mattingMask = text.mattingMask;
                vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].imagebox.image.angle = text.angle;
                vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].imagebox.flip = text.flip;
            }
        }
        $scope.imageCutoutSave = function(text){
            vm.isShowImageCutout = false;
            if(text){
                vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].imagebox.image.resource.identifier = text.result;
                vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].imagebox.image.mattingMask = text.mattingMask;
                vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].imagebox.image.angle = text.angle;
                vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].imagebox.flip = text.flip;
            }
        }

        function compare2(property, attr) {
            return function (a, b) {
                var value1 = a.geometry[property];
                var value2 = b.geometry[property];
                if (attr) {
                    return value1 - value2;
                }
                else {
                    return value2 - value1;
                }
            }
        }
        vm.getAllCtrlKeyArray=getAllCtrlKeyArray;
        function getAllCtrlKeyArray() {
            var all = [];
            angular.forEach($scope.template.pages.page, function (page) {
                angular.forEach(page.levels.level, function (level, i) {
                    if(level.imageart && level.imageart.ctrlKey){
                        level.imageart.levelI = i;
                        level.imageart.current = 'imageart';
                        all.push(level.imageart)
                    }
                    if(level.imagebox && level.imagebox.ctrlKey){
                        level.imagebox.levelI = i;
                        level.imagebox.current = 'imagebox';
                        all.push(level.imagebox)
                    }
                    if(level.textbox && level.textbox.ctrlKey){
                        level.textbox.levelI = i;
                        level.textbox.current = 'textbox';
                        all.push(level.textbox)
                    }
                    if (level.textdocument && level.textdocument.ctrlKey) {
                        level.textdocument.levelI = i;
                        level.textdocument.current = 'textdocument';
                        all.push(level.textdocument)
                    }
                    if (level.calTitleBox && level.calTitleBox.ctrlKey) {
                        level.calTitleBox.levelI = i;
                        level.calTitleBox.current = 'calTitleBox';
                        all.push(level.calTitleBox)
                    }
                    if (level.calMonthBox && level.calMonthBox.ctrlKey) {
                        level.calMonthBox.levelI = i;
                        level.calMonthBox.current = 'calMonthBox';
                        all.push(level.calMonthBox)
                    }
                })
            })
            return all;
        }

        function clearAllCtrlKey(){
            angular.forEach($scope.template.pages.page, function (page) {
                angular.forEach(page.levels.level, function (level, i) {
                    if(level.imageart && level.imageart.ctrlKey){
                        level.imageart.ctrlKey = false;
                    }
                    if(level.imagebox && level.imagebox.ctrlKey){
                        level.imagebox.ctrlKey = false;
                    }
                    if(level.textbox && level.textbox.ctrlKey){
                        level.textbox.ctrlKey = false;
                    }
                    if (level.textdocument && level.textdocument.ctrlKey) {
                        level.textdocument.ctrlKey = false;
                    }
                    if (level.calMonthBox && level.calMonthBox.ctrlKey) {
                        level.calMonthBox.ctrlKey = false;
                    }
                    if (level.calTitleBox && level.calTitleBox.ctrlKey) {
                        level.calTitleBox.ctrlKey = false;
                    }
                })
            })
        }
        $scope.boxAlignment = function (attr) {
            var levels = vm.pageData[vm.pageNumber].levels;
            var all = getAllCtrlKeyArray();
            if(all.length == 1){
                if (attr == 'left') {
                    all[0].geometry.x = elementAlign(all[0].geometry , all[0].rotation.angle , 'left' , vm.pageData[vm.pageIndex].mediabox.width , vm.pageData[vm.pageIndex].mediabox.height);
                } else if (attr == 'right') {
                    all[0].geometry.x = elementAlign(all[0].geometry , all[0].rotation.angle , 'right' , vm.pageData[vm.pageIndex].mediabox.width , vm.pageData[vm.pageIndex].mediabox.height);
                } else if (attr == 'top') {
                    all[0].geometry.y = elementAlign(all[0].geometry , all[0].rotation.angle , 'top' , vm.pageData[vm.pageIndex].mediabox.width , vm.pageData[vm.pageIndex].mediabox.height);
                } else if (attr == 'bottom') {
                    all[0].geometry.y = elementAlign(all[0].geometry , all[0].rotation.angle , 'bottom' , vm.pageData[vm.pageIndex].mediabox.width , vm.pageData[vm.pageIndex].mediabox.height);
                } else if (attr == 'vertical') {
                    all[0].geometry.y = (vm.pageData[vm.pageIndex].mediabox.height - all[0].geometry.height) / 2;
                } else {
                    all[0].geometry.x = (vm.pageData[vm.pageIndex].mediabox.width - all[0].geometry.width) / 2;
                }
                return
            }
            if (attr == 'left') {
                all.sort(compare2('x', true));
            } else if (attr == 'right') {
                all.sort(compare2('width', false));
                all.sort(compare2('x', false));
            } else if (attr == 'top') {
                all.sort(compare2('y', true));
            } else if (attr == 'bottom') {
                all.sort(compare2('height', false));
                all.sort(compare2('y', false));
            }
            if(attr == 'vertical' && all.length>0){
                var verticalY = horizontalAndVerticalCenter(attr, all);
            }
            if(attr == 'standard' && all.length>0){
                var standardX = horizontalAndVerticalCenter(attr, all);
            }

            for (var i = 0; i < all.length; i++) {
                if(!all[i].lock) {
                    if (attr == 'left') {
                        all[i].geometry.x = all[0].geometry.x;
                    } else if (attr == 'right') {
                        all[i].geometry.x = all[0].geometry.x + all[0].geometry.width - all[i].geometry.width;

                    } else if (attr == 'top') {
                        all[i].geometry.y = all[0].geometry.y;

                    } else if (attr == 'bottom') {
                        all[i].geometry.y = all[0].geometry.y + all[0].geometry.height - all[i].geometry.height;

                    } else if (attr == 'vertical') {
                        all[i].geometry.y = verticalY - all[i].geometry.height / 2;
                    } else {
                        all[i].geometry.x = standardX - all[i].geometry.width / 2;
                    }

                    if (all[i].current == 'imagebox') {
                        levels.level[all[i].levelI].imagebox = all[i];
                    } else if (all[i].current == 'textbox') {
                        levels.level[all[i].levelI].textbox = all[i];
                    } else {
                        levels.level[all[i].levelI].imageart = all[i];
                    }
                }
            }
            // levelInif()
            cookie()
        }

        window.onresize = function () {
            $timeout(function () {
                if($("#canvasView") && $("#canvasView").offset()){
                    var l = angular.copy(vm.pageElementL);
                    var t = angular.copy(vm.pageElementT);
                    if(l < $("#canvasView").offset().left){
                        l = $("#canvasView").offset().left
                    }
                    if(l > ($("#canvasView").offset().left + $("#canvasView").width() - vm.pageElementW)){
                        l = ($("#canvasView").offset().left + $("#canvasView").width() - vm.pageElementW)
                    }
                    if(t < $("#canvasView").offset().top){
                        t = $("#canvasView").offset().top
                    }
                    if(t > ($("#canvasView").offset().top + $("#canvasView").height() - vm.pageElementH)){
                        t = ($("#canvasView").offset().top + $("#canvasView").height() - vm.pageElementH)
                    }
                    vm.pageElementL = l;
                    vm.pageElementT = t;
                }
                updateMeasureRuler();
            })
        }

        $scope.changeFilletType = function(type){
            if (vm.elementOn.item.border.radius.filletType == type) {
                return
            }
            vm.elementOn.item.border.radius.filletType = type;
            switchToRoundedMode(vm.elementOn.item,vm.borderRadiusAllbtn);//切换圆角显示模式
            cookie();
        }

        vm.borderRadiusAllbtn = true
        $scope.borderRadiusAll = function () {
             vm.elementOn.item.border.radius.lt =  vm.elementOn.item.border.radius.all;
             vm.elementOn.item.border.radius.rt =  vm.elementOn.item.border.radius.all;
             vm.elementOn.item.border.radius.rb =  vm.elementOn.item.border.radius.all;
             vm.elementOn.item.border.radius.lb =  vm.elementOn.item.border.radius.all;
             cookie();
        }
        $scope.borderRadiusAllbtn = function(){
            vm.borderRadiusAllbtn = true;
             vm.elementOn.item.border.radius.rt =  vm.elementOn.item.border.radius.lt;
             vm.elementOn.item.border.radius.rb =  vm.elementOn.item.border.radius.lt;
             vm.elementOn.item.border.radius.lb =  vm.elementOn.item.border.radius.lt;
             vm.elementOn.item.border.radius.all =  vm.elementOn.item.border.radius.lt;
             cookie();
        }
        // 圆角设置
        vm.isRoundedSet = false;
        $scope.roundedSet = function(attr){
            if(vm.isBorderSet || vm.isTransp)cookie()
            toolbarStatus();
            vm.isRoundedSet = attr;
            vm.borderRadiusAllbtn = false;
        }
        // 圆角滑块防抖保存快照（ng-change 拖动时连续触发，防抖确保每次拖动只保存一次）
        var radiusDebounceTimer = null;
        $scope.borderRadiusCookie = function(){
            if (radiusDebounceTimer) {
                $timeout.cancel(radiusDebounceTimer);
            }
            radiusDebounceTimer = $timeout(function() {
                cookie();
                radiusDebounceTimer = null;
            }, 300);
        }
        // "统一圆角"滑块变化时：同步四个角 + 防抖保存快照
        $scope.borderRadiusAllChange = function() {
            vm.elementOn.item.border.radius.lt = vm.elementOn.item.border.radius.all;
            vm.elementOn.item.border.radius.rt = vm.elementOn.item.border.radius.all;
            vm.elementOn.item.border.radius.rb = vm.elementOn.item.border.radius.all;
            vm.elementOn.item.border.radius.lb = vm.elementOn.item.border.radius.all;
            if (radiusDebounceTimer) {
                $timeout.cancel(radiusDebounceTimer);
            }
            radiusDebounceTimer = $timeout(function() {
                cookie();
                radiusDebounceTimer = null;
            }, 300);
        }

        // 边框设置
        vm.isBorderSet = false;
        $scope.borderSet = function(attr){
            if(vm.isRoundedSet || vm.isTransp)cookie()
            toolbarStatus();
            vm.isBorderSet = attr;
        }

        // 阴影设置
        vm.isShadowSet = false;
        $scope.shadowSet = function(attr){
            toolbarStatus();
            vm.isShadowSet = attr;
        }

        function toolbarStatus(){
            vm.isTransp = false;
            vm.isRoundedSet = false;
            vm.isBorderSet = false;
            vm.isShadowSet = false;
            vm.isCoverage = false;
            vm.isOptimiza = false;
            vm.isAlign = false;
            //文字
            vm.isOperationSpacing = false;
            vm.isOperationDir = false;
        }

        $scope.lineTypeChenge = function(lineType){
            vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].imagebox.border.lineType = lineType;
            // onArticleChange()
            cookie();
        }
        $scope.dropShadow = function(imagebox,ratio){
            if (imagebox.shadow == null) {
                imagebox.shadow={
                    color:'#777777',
                    x:0,
                    y:0,
                    blur:0
                }
            }
            var width = $scope.imageboxW(imagebox) * ratio;
            var height =$scope.imageboxH(imagebox) * ratio;
            return dropShadow(imagebox,width,height)
        }
        $scope.clearOperate = function(){
            toolbarStatus()
        }
        vm.editorMiniPage = 'page';
        vm.editorNav3Top = 0;
        $scope.editorMiniPageCb = function (item) {
            //记录滚动条$(".editor-nav3")的位置
            if(vm.editorMiniPage == 'page'){
                vm.editorNav3Top = $(".editor-nav3").scrollTop();
            }
            vm.editorMiniPage = item;
            $timeout(function() {
                if(vm.editorMiniPage == 'page'){
                    $(".editor-nav3").scrollTop(vm.editorNav3Top);
                }else{
                    //获取.editor-nav3下的.nav-active所在的锚点，然后滚动到这个锚点位置
                    var $nav3 = $(".editor-nav3");
                    var $navActive = $nav3.find(".nav-active:visible");
                    if ($navActive.length) {
                        $nav3.scrollTop($navActive.offset().top - $nav3.offset().top + $nav3.scrollTop() - ($nav3.height() - $navActive.outerHeight()) / 2);
                    }
                }
            }, 50);
        }
        vm.isWatchName = true;
        $scope.watchGalleryName = function(state){
            vm.isWatchName = state;
            // setTimeout(function () {
            //     waterFallPic('main5');
            //     $(".photo-imgs").height($scope.photoHight);
            // }, 200);
        }

        function scrollIntoViewElement(){
            var $nav3 = $(".editor-nav3");
            var $navActive = $nav3.find(".nav-active:visible");
            if ($navActive.length) {
                $nav3.scrollTop($navActive.offset().top - $nav3.offset().top + $nav3.scrollTop() - ($nav3.height() - $navActive.outerHeight()) / 2);
            }
            // var element = document.getElementById('c-editor-page-view-li' + completeIndex(vm.elementOn.index));
            // if(element){
            //     element.scrollIntoView()
            //     // 回退60px，避免元素紧贴滚动容器顶部
            //     var scroller = element.closest('.hover-scrollbar');
            //     console.log(scroller)
            //     if (scroller) {
            //         scroller.scrollTop += 60;
            //     }
            // }
        }


        function pageUpdate() {
            vm.isPageUpdate = true;
            $timeout(function () {
                vm.isPageUpdate = false;
            })
        }

        // 单个元素对齐
        vm.isAlign = false;
        $scope.alignHover2 = function () {
            if(vm.elementOn.name == ''){
                MessageService.error($translate.instant("editorMessage.pleaseSelectAElement"));
                return
            }
            if (vm.elementOn.item.lock) {
                MessageService.error($translate.instant("editorMessage.pleaseSelectALock"));
                return
            }
            toolbarStatus();
            vm.isAlign = !vm.isAlign;
        }

        $scope.singleBoxAlignment = function (attr) {
            if(vm.toobarAlignmentBtn){
                $scope.boxAlignment(attr);
                return
            }
            if (vm.elementOn.item.lock) {
                MessageService.error($translate.instant("editorMessage.pleaseSelectALock"));
                return
            }
            if (attr == 'left') {
                vm.elementOn.item.geometry.x = elementAlign(vm.elementOn.item.geometry , vm.elementOn.item.rotation.angle , 'left' , vm.pageData[vm.pageIndex].mediabox.width , vm.pageData[vm.pageIndex].mediabox.height);
            } else if (attr == 'right') {
                vm.elementOn.item.geometry.x = elementAlign(vm.elementOn.item.geometry , vm.elementOn.item.rotation.angle , 'right' , vm.pageData[vm.pageIndex].mediabox.width , vm.pageData[vm.pageIndex].mediabox.height);
            } else if (attr == 'top') {
                vm.elementOn.item.geometry.y = elementAlign(vm.elementOn.item.geometry , vm.elementOn.item.rotation.angle , 'top' , vm.pageData[vm.pageIndex].mediabox.width , vm.pageData[vm.pageIndex].mediabox.height);
            } else if (attr == 'bottom') {
                vm.elementOn.item.geometry.y = elementAlign(vm.elementOn.item.geometry , vm.elementOn.item.rotation.angle , 'bottom' , vm.pageData[vm.pageIndex].mediabox.width , vm.pageData[vm.pageIndex].mediabox.height);
            } else if (attr == 'vertical') {
                vm.elementOn.item.geometry.y = (vm.pageData[vm.pageIndex].mediabox.height - vm.elementOn.item.geometry.height) / 2;
            } else {
                vm.elementOn.item.geometry.x = (vm.pageData[vm.pageIndex].mediabox.width - vm.elementOn.item.geometry.width) / 2;
            }
            cookie()
        }


        // 元素水平垂直分布
        vm.isDistributeHover = false;
        $scope.distribute = function(){
            vm.isDistributeHover = !vm.isDistributeHover;
            vm.isAlignHover = false;
        }
        $scope.boxDistribute = function (direction){
            var all1 = getAllCtrlKeyArray();
            var all = [];
            all1.forEach(function(box){
                if (!box.lock) {
                    all.push(box)
                }
            })
            if (all.length < 3) {
                MessageService.error($translate.instant("editorMessage.请选择3个以上非锁定状态的元素"));
                return
            }
            if(direction == 'horizontal'){
                setAllCtrlKeyArray(all, 'x')
            }
            if(direction == 'vertical'){
                setAllCtrlKeyArray(all, 'y')
            }
        }
        function setAllCtrlKeyArray(all, attr) {
            var len = all.length - 1;
            all.sort(compare2(attr, true));
            if (attr == 'x') {
                var elementAllWidth = 0;
                for (var i = 1; i < len; i++) {
                    elementAllWidth+=all[i].geometry.width;
                }
                var spacingPx = (all[len].geometry.x - all[0].geometry.x - all[0].geometry.width - elementAllWidth) / len;
                for (var i = 1; i < len; i++) {
                    all[i].geometry.x = all[i-1].geometry.x + all[i-1].geometry.width + spacingPx;
                }
            }
            if (attr == 'y') {
                var elementAllHeight = 0;
                for (var i = 1; i < len; i++) {
                    elementAllHeight+=all[i].geometry.height;
                }
                var spacingPx = (all[len].geometry.y - all[0].geometry.y - all[0].geometry.height - elementAllHeight) / len;
                for (var i = 1; i < len; i++) {
                    all[i].geometry.y = all[i-1].geometry.y + all[i-1].geometry.height + spacingPx;
                }
            }
        }

        $scope.addPages1 = function(){
            if(!vm.pageData[vm.pageNumber]){
                MessageService.error($translate.instant("editorMessage.pleaseSelectAddPagePosition"));
                return
            }
            if (vm.article.xml && (!vm.article.xml.addpage /* false */ || !vm.article.xml.addunit /* 0 */)) {
                MessageService.error($translate.instant("editorMessage.noAddPage"));
                return
            }
            if($scope.template.pages.page.length >= vm.article.xml.maxpage){
                MessageService.error($translate.instant("editorMessage.beSatisfiedMax"));
                return
            }
            $scope.addPages(vm.pageData[vm.pageNumber],vm.pageNumber+1);
        }
        $scope.addPages = function(page,index){
            var _pindex = -1;
            for (var i = vm.pageData.length - 1; i >= 0; i--) {
                if (vm.pageData[i].config.partid == 'P') {
                    _pindex = i+1;
                    break;
                }
            }
            for (var i = 0; i < vm.article.xml.addunit; i++) {
                if(vm.pageData.length<vm.article.xml.maxpage){
                    var p = angular.copy(page)

                    p.background={
                        color: "#ffffff",
                        offsetx: 0,
                        offsety: 0,
                        resource: {provider: null, identifier: null},
                        scale: 0,
                        type: "Color"
                    }
                    p.unreplace = false;
                    p.type = null;
                    p.levels = {level:[]};
                    p.pagecover = {provider: "qiniu", identifier: ""}
                    p.uuid = UidService.get();
                    vm.pageData.splice(_pindex,0,p)
                }
            }
            $timeout(function(){
                angular.forEach(vm.pageData, function (obj, index1) {
                    obj.seq = index1;
                    ratioInfo(obj);
                });
                vm.pageSum = vm.pageData.length - 1;
                pageDataInit();
                $scope.turning(index)
            })
        }
        $scope.delAddPage = function(index){
            if(vm.pageData[index].unreplace){
                MessageService.error($translate.instant("editorMessage.notDelete"));
                return
            }
            if(vm.pageData.length > vm.article.xml.minpage){
                vm.pageData.splice(index,1)
            }
            angular.forEach(vm.pageData, function (obj, index) {
                obj.seq = index;
                ratioInfo(obj);
            });
            vm.pageSum--;
            pageDataInit();
            if(vm.pageNumber > vm.pageData.length-1){
                $scope.turning(vm.pageData.length-1)
            }
        }

        var codeWidthDebounceTimer = null;
        $scope.codeWidth = function () {
            if (codeWidthDebounceTimer !== null) {
                clearTimeout(codeWidthDebounceTimer)
            }
            codeWidthDebounceTimer = setTimeout(function() {
                if (vm.code.width <= 10) {
                    vm.code.width = 10
                }
            }, 300);
        }

        var codeHeightDebounceTimer = null;
        $scope.codeHeight = function () {
            if (codeHeightDebounceTimer !== null) {
                clearTimeout(codeHeightDebounceTimer)
            }
            codeHeightDebounceTimer = setTimeout(function() {
                if (vm.code.height <= 10) {
                    vm.code.height = 10
                }
            }, 300);
        }
        /*
        * 动态日历
        * */
        vm.years=[];
        vm.months=[1,2,3,4,5,6,7,8,9,10,11,12];
        vm.yearIndex=2024;
        vm.monthIndex=1;
        vm.isCalendar=false;
        vm.monthIndex1 = 0;
        vm.yearPage = 1;
        vm.yearSize = 10;
        vm.isYear = false;
        function yearInfo() {
            if($scope.template.config.productType == 'CALENDAR'&&$scope.template.config.dynamic){
                $scope.template.pages.page.forEach(function (page) {
                    if(vm.monthIndex1 < page.config.monthIndex){
                        vm.monthIndex1 = page.config.monthIndex
                    }
                })
                var date = new Date();
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var year1 = 2000;
                for(var i=0;i<100-Math.floor(vm.monthIndex1/13);i++){
                    vm.years.push(year1+i);
                }
                vm.yearSize = Math.ceil(vm.years.length/10);
                if(month>5){
                    vm.yearIndex = year+1;
                }else{
                    vm.yearIndex = year;
                }
            }
        }
        $scope.getEndYear = function (month) {
            return getDay('year',vm.yearIndex,month||vm.monthIndex,vm.monthIndex1)
        }
        $scope.getEndMonth = function (month) {
            return getDay('month',vm.yearIndex,month||vm.monthIndex,vm.monthIndex1)
        }
        $scope.yearIndex = function(item){
            if(item == 'subtract'){
                vm.yearIndex = vm.yearIndex<=2000?2000:vm.yearIndex-1;
            }
            if(item == 'add'){
                vm.yearIndex = vm.yearIndex>=vm.years[vm.years.length-1]?vm.years[vm.years.length-1]:vm.yearIndex+1;
            }
            monthInfo()
        }
        $scope.yearPageCb = function(item){
            if(item == 'subtract'){
                vm.yearPage = vm.yearPage<2?1:vm.yearPage-1;
            }
            if(item == 'add'){
                vm.yearPage = vm.yearPage>=vm.yearSize?vm.yearSize:Number(vm.yearPage)+1;
            }
        }
        var a = null;
        $scope.yearPageChange = function(){
            if (a !== null) {
                clearTimeout(a)
            }
            a = setTimeout(function () {
                $timeout(function () {
                    var regex = /^[1-9]\d*$/;
                    if(!regex.test(vm.yearPage)){
                        vm.yearPage = 1;
                    }
                    if(vm.yearPage>=vm.yearSize){
                        vm.yearPage=vm.yearSize
                    }
                    if(vm.yearPage<2){
                        vm.yearPage=1;
                    }
                })
            },500)
        }
        $scope.yearIndexSave = function(e,item){
            if(item){
                vm.yearIndex = item;
                vm.isYear=false;
                monthInfo()
            }
            fn(e)
        }
        $scope.isYearHide = function(e){
            vm.isYear = false;
            fn(e);
        }
        $scope.isYearShow = function(e){
            vm.isYear = true;
            fn(e);
        }
        function monthInfo(){
            // if($scope.getEndYear(12)>2099){
            //     vm.months=[];
            //     vm.monthIndex=1;
            //     for(var i=1;i<=12-$scope.getEndMonth(12);i++){
            //         vm.months.push(i)
            //     }
            // }else{
            //     vm.months=[1,2,3,4,5,6,7,8,9,10,11,12];
            // }
        }
        $scope.mathFloor = function(item){
            if(item>=0){
                return Math.floor(item/10)+1
            }
        }
        $scope.calendarSave = function () {
            $scope.template.config.startYear = vm.yearIndex;
            $scope.template.config.startMonth = vm.monthIndex;
            $scope.template.pages.page.forEach(function (page) {
                page.levels.level.forEach(function (level) {
                    if (level.calMonthBox && level.calMonthBox.geometry) {
                        var calMonthBox = level.calMonthBox;
                        calMonthBox.obj=null;
                        calMonthBox.sampleYear = getDay('year',$scope.template.config.startYear,$scope.template.config.startMonth,page.config.monthIndex);
                        calMonthBox.sampleMonth = getDay('month',$scope.template.config.startYear,$scope.template.config.startMonth,page.config.monthIndex);
                    }
                    if (level.calTitleBox && level.calTitleBox.geometry) {
                        var calTitleBox = level.calTitleBox;
                        calTitleBox.obj=null;
                        calTitleBox.sampleYear = getDay('year',$scope.template.config.startYear,$scope.template.config.startMonth,page.config.monthIndex);
                        calTitleBox.sampleMonth = getDay('month',$scope.template.config.startYear,$scope.template.config.startMonth,page.config.monthIndex);
                    }
                })
            })
            vm.isCalendar=false;
            vm.isCalendar1=false;
            vm.minLoading = true;
            $timeout(function () {
                vm.minLoading = false;
            },2000)
        }

        vm.showCanvasImageFilter = false;
        // 图片优化
        $scope.optimizationSelect = function (attr) {
           if (!vm.elementOn.name=='imagebox') {
               MessageService.error($translate.instant("editorMessage.pleaseSelectAImagebox"));
               return
           }
           if(vm.elementOn.item.image && vm.elementOn.item.image.resourceid) {
               // 获取原图信息
               Gallery.getOne({id:vm.elementOn.item.image.resourceid},function (res){
                   vm.elementOn.item.image.resource.primary = res.data.identifier;
                   // 图片优化
                   if (vm.elementOn.item.image && vm.elementOn.item.image.resource && vm.elementOn.item.image.resource.identifier) {
                       toolbarStatus();
                       var current = vm.elementOn.item;
                       if (current.image) {
                           vm.showCanvasImageFilter = true;
                           window.removeEventListener('mousewheel', mousewheelHandler);
                           if(vm.elementOn.item.optimizations){
                               vm.optimizations = vm.elementOn.item.optimizations;
                           }
                       } else {
                           MessageService.error($translate.instant("editorMessage.pleaseSelectAImagebox"));
                       }
                   }
               })
           }
       }

        // 图片优化
        $rootScope.$on('editorApp.closeImageFilter', function () {
            vm.showCanvasImageFilter = false;
            window.addEventListener('mousewheel', mousewheelHandler,{ passive: false});
        });
        $rootScope.$on('editorApp.saveImageFilter', function (event,imgUrl) {
            vm.showCanvasImageFilter = false;
            window.addEventListener('mousewheel', mousewheelHandler,{ passive: false});
            filterImgUpdate(imgUrl);
        });

        function filterImgUpdate(img){
            vm.elementOn.item.imageLoading = true;
            QiniuToken.uploadThumbnail(img, function (data) {
                $.ajax({
                    type: "GET",
                    url: (vm.elementOn.item.image.resource.identifier.indexOf('http') == -1 ? $scope.domain : '') + vm.elementOn.item.image.resource.identifier + "?imageInfo",
                    async: false,
                    success: function (va) {
                        var identifier = $scope.domain + data.key;
                        vm.elementOn.item.image.resource.identifier = identifier;
                        vm.elementOn.item.imageLoading = false;
                        cookie();
                        $timeout(function() {
                            vm.elementOn.item.imageLoading = false;
                        })
                        if(va.orientation){
                            imageboxImgInit();
                        }
                    }
                })
            });
        }
        function imageboxImgInit(){
            $.ajax({
                type: "GET",
                url: $scope.domain + vm.elementOn.item.image.resource.primary + "?imageInfo",
                async: false,
                success: function (va1) {
                    var angle = (vm.elementOn.item.image.angle + 360 - orientationInit1(va1.orientation).angle) % 360;
                    if (vm.elementOn.item.flip) {
                        vm.elementOn.item.image.angle = -angle;
                        vm.elementOn.item.flip = false;
                    }else{
                        vm.elementOn.item.image.angle = angle;
                    }
                }
            });
        }

        vm.unusedQuantity = null;
        function unusedQuantity(){
            var galleryIdList = [];
            angular.forEach(vm.pageData, function (page, i) {
                angular.forEach(page.levels.level, function (level, i) {
                    if(level.imagebox && level.imagebox.image && level.imagebox.image.resourceid){
                        galleryIdList.push(level.imagebox.image.resourceid)
                    }
                });
            });
            var newArr = galleryIdList.filter(function(item,index){
                return galleryIdList.indexOf(item) === index;  // 因为indexOf 只能查找到第一个
            });
            Gallery.unUsed({
                galleryIdList:newArr,
                folderId: vm.folderId,
                articleId: (vm.article.articleId || vm.article.id)
            },function (res) {
                if(res.status == 200){
                    vm.unusedQuantity = res.data;
                    getGallery();
                }
            })
        }

        function getGallery(){
            if(vm.photosTab!='all' && $scope.photos.length < vm.totalPhotoItems){
                var _photoQuantity = 0;
                $scope.photos.forEach(function (item) {
                    if(item.usenum==0||!item.usenum){
                        _photoQuantity++
                    }
                })
                if(_photoQuantity < vm.itemsPerPage){
                    if(vm.folderId){
                        loadAll(vm.folderId);
                    }else{
                        loadAll('isNull');
                    }
                }
            }
        }

        function websocket(){
            var urlws = vm.platformSetting.editorNotifyUrl.split("://")[1];
            urlws = urlws.split("/")[0];
            var ws = $websocket("wss://"+ urlws +"/widget/ws/websocket?uid=Gallery"+(vm.article ? (vm.article.articleId || vm.article.id) : vm.articleId));

            ws.onOpen(function() {
                console.log('WebSocket连接已打开, url:'+ws.url);
            });

            ws.onMessage(function(message) {
                var photo = JSON.parse(message.data);
                console.log('photo',photo);
                if (photo.folderId == vm.folderId || (photo.folderId == null && vm.folderId == '')) {
                    var len = $scope.photos.length;
                    photo.identifier = $scope.domain + photo.identifier;
                    photo.select = false;
                    photo.index = len;
                    photo.usenum = 0;
                    photo.type = 'picture';
                    var _photo = null;
                    for (var i = 0; i < $scope.photos.length; i++) {
                        if ($scope.photos[i].id == photo.id) {
                            _photo = $scope.photos[i];
                            break;
                        }
                    }
                    if ((!photo.largeFlag && !_photo) || (photo.largeFlag && photo.largeStatus == 'done' && !_photo)) {
                        vm.unusedQuantity++;
                        vm.totalPhotoItems++;
                        $scope.photos.unshift(photo);
                    }
                    if (_photo) {
                        _photo.largeStatus = photo.largeStatus;
                        if(_photo.convertFlag){
                            _photo.convertStatus = photo.convertStatus;
                            _photo.identifier =  photo.identifier;
                        }
                        // 状态可能由处理中变为失败，已被选中的要即时踢出
                        syncGallerySelection();
                    }
                    // 同时更新重复图列表中的大图状态，确保重复图弹框中的大图也能正确展示
                    if (vm.isDuplicateList && vm.duplicateList.length > 0) {
                        for (var d = 0; d < vm.duplicateList.length; d++) {
                            if (vm.duplicateList[d].id == photo.id) {
                                vm.duplicateList[d].largeStatus = photo.largeStatus;
                                vm.duplicateList[d].convertStatus = photo.convertStatus;
                                // 大图处理完成后，更新identifier确保缩略图URL正确（photo.identifier已带域名）
                                if (photo.largeStatus && photo.largeStatus !== 'running') {
                                    vm.duplicateList[d].largeFlag = true;
                                }
                                vm.duplicateList[d].identifier = photo.identifier;
                                break;
                            }
                        }
                    }
                    if (vm.photoSort != 1 && vm.minId==null) {
                        vm.minId = photo.id;
                    }
                }
            });

            ws.onError(function(error) {
                console.log('WebSocket错误：', error);
            });

            ws.onClose(function() {
                console.log('WebSocket连接已关闭');
            });
        }

        vm.chooseMenuStyle = false;
        $scope.showChooseMenu = function() {
            vm.chooseMenuStyle = true;
        };
        $scope.hideChooseMenu = function() {
            vm.chooseMenuStyle = false;
        };
        // 是否大图
        $scope.isLarge = function(imageInfo){
            if(!imageInfo)return
            return imageInfo.size >= 20971520 || imageInfo.width > 30000 || imageInfo.height > 30000 || (imageInfo.width*imageInfo.height)>150000000
        }

        /*刻度尺*/
        vm.staff = true;
        var measureRuler = null;
        var measureRuler2 = null;

        // 画布位置X
        $scope.canvasCoordX = function (){
            var width = vm.pageData[vm.pageNumber1].custom.width * vm.pageData[vm.pageNumber1].custom.ratio;
            var width1 = $('.editor-body').width();
            if(vm.pageData[vm.pageNumber2]){
                width += vm.pageData[vm.pageNumber2].custom.width * vm.pageData[vm.pageNumber2].custom.ratio;
            }
            if (!width) {
                return 0;
            }
            var x = (width1-(width || 0))/2 + vm.moveCanvasObj.x;
            if(vm.pageData[vm.pageNumber1].scene){
                x = x + vm.pageData[vm.pageNumber1].scene.imagebox.geometry.x * vm.pageData[vm.pageNumber1].custom.ratio
            }
            return x;
        }
        // 画布位置Y
        $scope.canvasCoordY = function (){
            var height = vm.pageData[vm.pageNumber1].custom.height * vm.pageData[vm.pageNumber1].custom.ratio;
            if(vm.pageData[vm.pageNumber2]){
                height = height < vm.pageData[vm.pageNumber2].custom.height * vm.pageData[vm.pageNumber2].custom.ratio ? vm.pageData[vm.pageNumber2].custom.height * vm.pageData[vm.pageNumber2].custom.ratio : height;
            }
            var height1 = $('.editor-body').height();
            if (!height) {
                return 0;
            }
            var y = (height1-(height || 0))/2  + vm.moveCanvasObj.y;
            if(vm.pageData[vm.pageNumber1].scene){
                y = y + vm.pageData[vm.pageNumber1].scene.imagebox.geometry.y * vm.pageData[vm.pageNumber1].custom.ratio
            }
            return y;
        }
        function measureRulerInit() {
            if(vm.pageData[vm.pageNumber1]){
                var page = vm.pageData[vm.pageNumber1];
                var width = $("#pageCanvas").width();
                var height = $("#pageCanvas").height();
                var _w = PxTurnMm(width) < 1000 ? 1000 : PxTurnMm(width);
                var _h = PxTurnMm(height) < 1000 ? 1000 : PxTurnMm(height);
                var _mult = MmTurnPx(1)*page.custom.ratio/10;
                var _left = $scope.canvasCoordX();
                var _top = $scope.canvasCoordY();
                measureRuler =new MeasureRuler({
                    wrapperId:"graduatedScale-cross",     //容器ID，页面中写一个DIV就行 (必须)
                    max:_w,  //刻度尺最大的刻度    (非必须，默认为1000)
                    unitSet:unitInit(_mult),//刻度尺单元长度    (非必须，默认是10)
                    mult:_mult,  //刻度值倍数，默认是最小刻度值为10px，如果定mult为3则最小刻度为30px (非必须，默认为1)
                    left:_left,
                    click:function (item) {
                        var _item = item/page.custom.ratio;
                        if(sublinesInfo(_item,'x')){
                            $scope.template.xLines.line.push(_item);
                        }
                        $scope.$apply();
                    }
                })
                measureRuler2 =new MeasureRuler({
                    wrapperId:"graduatedScale-vertical",     //容器ID，页面中写一个DIV就行 (必须)
                    max:_h,                     //刻度尺最大的刻度    (非必须，默认为1000)
                    unitSet:unitInit(_mult),                   //刻度尺单元长度    (非必须，默认是10)
                    mult:_mult,                   //刻度值倍数，默认是最小刻度值为10px，如果定mult为3则最小刻度为30px (非必须，默认为1)
                    vertical:true,
                    top:_top,
                    yClick:function (item) {
                        var _item = item/page.custom.ratio;
                        if(sublinesInfo(_item,'y')){
                            $scope.template.yLines.line.push(_item);
                        }
                        $scope.$apply();
                    }
                })
            }
        }
        $scope.$watchGroup(['vm.leftShow', 'vm.rightShow'], function (newVal, oldVal) {
            updateMeasureRuler()
        })
        function updateMeasureRuler() {
            if(measureRuler&&measureRuler2){
                var page = vm.pageData[vm.pageNumber1];
                var _mult = MmTurnPx(1)*page.custom.ratio/10;
                var _left = $scope.canvasCoordX();
                var _top = $scope.canvasCoordY();
                measureRuler.reDrawRuler({
                    unitSet:unitInit(_mult),//刻度尺单元长度    (非必须，默认是10)
                    mult:_mult,  //刻度值倍数，默认是最小刻度值为10px，如果定mult为3则最小刻度为30px (非必须，默认为1)
                    left:_left,
                    click:function (item) {
                        if (a !== null) {
                            clearTimeout(a)
                        }
                        a = setTimeout(function () {
                            var _item = item/page.custom.ratio;
                            if(sublinesInfo(_item,'x')){
                                $scope.template.xLines.line.push(_item);
                            }
                            $scope.$apply();
                        },200)
                    }
                });
                measureRuler2.reDrawRuler({
                    unitSet:unitInit(_mult),
                    mult:_mult,
                    top:_top,
                    yClick:function (item) {
                        if (a !== null) {
                            clearTimeout(a)
                        }
                        a = setTimeout(function () {
                            var _item = item/page.custom.ratio;
                            if(sublinesInfo(_item,'y')){
                                $scope.template.yLines.line.push(_item);
                            }
                            $scope.$apply();
                        },200)
                    }
                });
            }
        }

        //新增参考线
        $scope.addLineReference = function () {
            $uibModal.open({
                templateUrl: "app/entities/page/model/reference.html",
                controller: "ReferenceController",
                backdrop: 'static',
                controllerAs: 'vm',
            }).result.then(function (data) {
                if(data){
                    var page = vm.pageData[vm.pageNumber1];
                    if(data.direction == 'x' && sublinesInfo(data.place,'x')){
                        $scope.template.xLines.line.push(data.place);
                    }
                    if(data.direction == 'y' && sublinesInfo(data.place,'y')){
                        $scope.template.yLines.line.push(data.place);
                    }
                    vm.staff = true;
                }
            });
        }
        function unitInit(_mult) {
            var _unitSet = 10;
            if(_mult>0.6){
                _unitSet = 10;
            }
            if(_mult<0.6){
                _unitSet = 30;
            }
            if(_mult<0.5){
                _unitSet = 30;
            }
            if(_mult<0.4){
                _unitSet = 50;
            }
            if(_mult<0.3){
                _unitSet = 80;
            }
            if(_mult<0.2){
                _unitSet = 100;
            }
            if(_mult<0.1){
                _unitSet = 200;
            }
            return _unitSet
        }
        //参考线移动
        vm.lineReferenceIndex = 0;
        vm.lineReferenceType = null;
        vm.lineReferenceData = {};
        vm.isLineReference = false;
        $scope.moveLineReference = function (e, item, index, type) {
            var page = vm.pageData[vm.pageNumber1];
            if(vm.textFont || !page){
                return;
            }
            fn(e);
            vm.lineReferenceIndex = index;
            vm.lineReferenceType = type;
            vm.lineReferenceData.clientX = e.clientX || 0;
            vm.lineReferenceData.clientY = e.clientY || 0;
            vm.lineReferenceData.coordinates = item*page.custom.ratio;
            vm.isLineReference = true;
            document.addEventListener("mousemove", moveLineReferenceOn, true);
            document.addEventListener("mouseup", moveLineReferenceEnd, true);
        };
        $scope.moveLineReference1 = function (e, type) {
            var page = vm.pageData[vm.pageNumber1];
            if(vm.textFont || !page){
                return;
            }
            fn(e);
            var pageCanvasOffset = $("#pageCanvasView").offset() || {
                left: 0,
                top: 0
            };
            var sceneGeometry = page.scene ? page.scene.imagebox.geometry : {
                x: 0,
                y: 0
            };
            if(type === 'x'){
                var yItem = (e.clientY - pageCanvasOffset.top - sceneGeometry.y * page.custom.ratio) / page.custom.ratio;
                // x 入口创建横向参考线，写入 Y 轴参考线集合
                vm.lineReferenceIndex = $scope.template.yLines.line.push(yItem) - 1;
                vm.lineReferenceData.coordinates = yItem * page.custom.ratio;
                vm.lineReferenceType = 'y';
            }
            if(type === 'y'){
                var xItem = (e.clientX - pageCanvasOffset.left - sceneGeometry.x * page.custom.ratio) / page.custom.ratio;
                // y 入口创建纵向参考线，写入 X 轴参考线集合
                vm.lineReferenceIndex = $scope.template.xLines.line.push(xItem) - 1;
                vm.lineReferenceData.coordinates = xItem * page.custom.ratio;
                vm.lineReferenceType = 'x';
            }
            vm.lineReferenceData.clientX = e.clientX || 0;
            vm.lineReferenceData.clientY = e.clientY || 0;
            vm.isLineReference = true;
            document.addEventListener("mousemove", moveLineReferenceOn, true);
            document.addEventListener("mouseup", moveLineReferenceEnd, true);
        }
        //move 事件
        function moveLineReferenceOn(e) {
            fn(e);
            if (vm.isLineReference) {
                var page = vm.pageData[vm.pageNumber1];
                if(vm.lineReferenceType == 'x'){
                    var _item = (Number(vm.lineReferenceData.coordinates) + (e.clientX - vm.lineReferenceData.clientX));
                    $scope.template.xLines.line[vm.lineReferenceIndex] = _item/page.custom.ratio;
                }
                if(vm.lineReferenceType == 'y'){
                    var _item = Number(vm.lineReferenceData.coordinates) + (e.clientY - vm.lineReferenceData.clientY);
                    $scope.template.yLines.line[vm.lineReferenceIndex] = _item/page.custom.ratio;
                }
            }
            $scope.$apply();
        }
        //鼠标松开事件
        function moveLineReferenceEnd() {
            if(vm.lineReferenceType == 'x'){
                if(!sublinesInfo($scope.template.xLines.line[vm.lineReferenceIndex],'x')){
                    $scope.template.xLines.line.splice(vm.lineReferenceIndex,1)
                }
            }
            if(vm.lineReferenceType == 'y'){
                if(!sublinesInfo($scope.template.yLines.line[vm.lineReferenceIndex],'y')){
                    $scope.template.yLines.line.splice(vm.lineReferenceIndex,1)
                }
            }
            vm.lineReferenceIndex = 0;
            vm.lineReferenceType = null;
            vm.lineReferenceData = {};
            vm.isLineReference = false;
            document.removeEventListener("mousemove", moveLineReferenceOn, true);
            document.removeEventListener("mouseup", moveLineReferenceEnd, true);
            $scope.$apply();
        }
        function sublinesInfo(item, type) {
            var _isS = true;
            var width = vm.pageData[vm.pageNumber1].mediabox.width;
            var width1 = $('.editor-body').width();
            if(vm.pageData[vm.pageNumber2]){
                width += vm.pageData[vm.pageNumber2].mediabox.width;
            }
            var height = vm.pageData[vm.pageNumber1].mediabox.height;
            if(vm.pageData[vm.pageNumber2]){
                height = height < vm.pageData[vm.pageNumber2].mediabox.height ? vm.pageData[vm.pageNumber2].mediabox.height : height;
            }
            width = width.toFixed(2);
            height = height.toFixed(2);
            if(type == 'x'){
                if(item<0 || item>width){
                    _isS = false
                }
            }
            if(type == 'y'){
                if(item<0 || item>height){
                    _isS = false
                }
            }
            return _isS
        }
        $scope.PxTurnMm = function (item) {
            return PxTurnMm(item)
        }
    }
})();

(function () {
    'use strict';

    var uploadImage = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/gallery/uplpadImage.html',
        controllerAs: 'userCtrl',
        bindings: {
            aid:'=',
            tag:'=',
            domain:'=',
            onUploadphoto:'&',
            photoAll:'=',
            folderOne:'=',
            status:'=',
            qiniuId:'=',
            choose:'=',
            uploadPhotoItem:'=',
            onUploadStart:'&'
        },

        controller: ['$scope', '$stateParams', '$q', '$localStorage', 'Qinius', 'QiniuToken', 'WxJS', 'Theme', 'Gallery','SweetAlert','$rootScope','ImageService','UidService','Upload','$timeout','$translate','$state',
            function ($scope, $stateParams, $q, $localStorage, Qinius, QiniuToken, WxJS, Theme, Gallery, SweetAlert,$rootScope,ImageService,UidService,Upload,$timeout,$translate,$state) {
                var vm = this;

                vm.duplicateList = []
                vm.currentFileList = []
                // 初始化大图提示相关状态
                $scope.bigSizeTip = false;
                $scope.higherSizeLen = 0;

                // 关闭大图提示弹框
                $scope.filterBigSize = function () {
                    $scope.bigSizeTip = false;
                    vm.higherSize = [];
                    $scope.higherSizeLen = 0;
                };

                // 成功多少张
                vm.indd = 0;
                vm.errorImageArr = [];
                vm.filesLength = 0;
                if (window.location.href.indexOf("?") > -1) {
                    // localStorage.removeItem('guide-step');
                    var r = window.location.href.split('?')[1];
                    var typeFlag = r.split('&')[0].split('=')[1];
                    var distinguish = decodeURIComponent(typeFlag);
                    if (distinguish == 'weChatApplet' || distinguish == 'weChatAppletMake') {
                        vm.uploadType = 'wechat';
                    }else if(distinguish == 'toutiaoApp'){
                        vm.uploadType = 'byteDance';
                    }else if(distinguish == 'alipayApp'){
                        vm.uploadType = 'ali';
                    }
                }else{
                    vm.uploadType = 'wechat';
                }

                if (wx) {
                    var url = window.location.hash && window.location.href.slice(0, -window.location.hash.length) || window.location.href;
                    // var url = "https://stage.fotavatar.com/10/143/1230321120340111/editorPhotoBoth";
                    WxJS.get({url: url}, function (config) {
                        wx.config({
                            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                            appId: config.data.appId, // 必填，公众号的唯一标识
                            timestamp: config.data.timestamp, // 必填，生成签名的时间戳
                            nonceStr: config.data.nonceStr, // 必填，生成签名的随机串
                            signature: config.data.signature,// 必填，签名，见附录1
                            jsApiList: ['chooseImage', 'previewImage', 'uploadImage','getLocalImgData'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                        });
                        wx.ready(function () {
                            // console.log('editor: wechat api ready!');
                        });
                        wx.error(function (res) {
                            // alert("wx.error: "+res.errMsg)
                            // console.log(res);
                        });
                    }, function (res) {
                        // alert("data: "+res.data);
                        // alert("status: "+res.status);
                        // alert("statusText: "+res.statusText);
                        // console.log("editor: wx config error");
                    });
                }

                $scope.domains = Qinius.getDomain();
                vm.tokens = QiniuToken.getPromise('get', {"mimeLimit":"image/jpeg;image/png;image/jpg;image/heic"});
                $q.all([$scope.domains.$promise, vm.tokens.$promise]).then(function(){
                    $scope.domain = 'https://' + $scope.domains.domains[0] + '/';
                    vm.token = vm.tokens.token;
                    //安卓
                    $scope.$on('clickAndroidUpload', function(event, args) {
                        if(vm.uploadType=='ail'){
                            // my.postMessage({name:"测试web-view"});
                            ap.chooseImage(9, function(res){
                                vm.onUploadStart();
                                var files = []
                                for (var i = 0; i < res.apFilePaths.length; i++) {
                                    var tempFile = res.tempFiles[i];
                                    var fileName = tempFile.name || tempFile.fileName || tempFile.path && tempFile.path.split('/').pop() || '';
                                    files.push({
                                        localId:res.apFilePaths[i],
                                        blobCover:res.apFilePaths[i],
                                        imgSize:tempFile.size,
                                        fileName: fileName || 'IMG_' + Date.now() + '_' + i + '.jpg'
                                    })
                                }
                                var index = 0;
                                // readImages(index);
                                // function readImages(index){
                                //     ap.uploadFile({
                                //         url: ' /fileserves/api/convert/downloadImg4AliAngUpload7Niu',
                                //         fileType: 'image',
                                //         fileName: 'file',
                                //         filePath: '...',
                                //         header: {
                                //             'Content-Type': 'application/x-www-form-urlencoded',
                                //         },
                                //         success: function (resBackData) {
                                //             // alert(resBackData)
                                //         },
                                //         fail: function (res) {
                                //             // alert(res.errMsg);
                                //             console.warn("getLocalImgData fail",res);
                                //             $(".save-pages2").addClass('hide1');
                                //         }
                                //     });
                                // }
                                Gallery.upload({
                                    identifiers: res.apFilePaths[0],
                                    provider: "QINIU",
                                    fileName: files[0] && files[0].fileName ? files[0].fileName : generateFileName(),
                                    imgSize: files[0] && files[0].imgSize ? files[0].imgSize : 0,
                                    folderId: vm.folderOne ? vm.folderOne.id : null,
                                    check: true,
                                    type: vm.uploadType,
                                    articleId:vm.aid,
                                    hash:data.hash
                                }, function (resp) {

                                })
                                return
                            });
                            return;
                        }
                        vm.indd = 0;  //成功的张数
                        vm.errorImageArr = [];  //错误的张数
                        vm.duplicateList = []; //重复的张数

                        /********************************************
                         * 微信端上传图片功能
                         * 使用原生 <input type="file" multiple> 替代 wx.chooseImage + wx.getLocalImgData
                         * 优势：1) 可获取原始文件名  2) 可获取原图数据（不经微信JSSDK压缩）
                         * 与 iOS 端 uploadImageMutiple 流程保持一致
                         ********************************************/

                        // 创建隐藏的 file input 用于微信端选图
                        var wechatFileInput = document.createElement('input');
                        wechatFileInput.type = 'file';
                        wechatFileInput.accept = 'image/png, image/jpeg, image/jpg, .heic, .heif, .livp';
                        wechatFileInput.multiple = true;
                        wechatFileInput.style.display = 'none';
                        wechatFileInput.id = 'wechatUploadInput_directive';
                        document.body.appendChild(wechatFileInput);

                        wechatFileInput.onchange = function(event) {
                            $timeout(function() {
                                vm.onUploadStart();
                                $scope.bigSizeTip = false;
                                var files = [];
                                var rawFiles = event.target.files;
                                for (var i = 0; i < rawFiles.length; i++) {
                                    var file = rawFiles[i];
                                    var lowerName = (file.name || '').toLowerCase();
                                    var isValidImage = file.type === 'image/png' || file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/heic';
                                    var isHeicExt = !file.type && (lowerName.endsWith('.heic') || lowerName.endsWith('.heif'));
                                    var isLivp = !file.type && lowerName.endsWith('.livp');
                                    if (isValidImage || isHeicExt || isLivp) {
                                        file.usenum = 0;
                                        file.percent = 0;
                                        file.blobCover = URL.createObjectURL(file);
                                        files.push(file);
                                    }
                                }

                                if (files.length === 0) {
                                    try { document.body.removeChild(wechatFileInput); } catch (e) {}
                                    return;
                                }

                                $(".save-pages2").removeClass('hide1');

                                // 检查图片大小（文件大小 + 像素维度）
                                vm.higherSize = [];
                                var checkPromises = [];
                                angular.forEach(files, function (item) {
                                    item.imgSize = item.size;
                                    checkPromises.push(
                                        checkIsBigImage(item).then(function (isBig) {
                                            if (isBig) {
                                                vm.higherSize.push(item);
                                            }
                                        })
                                    );
                                });

                                $q.all(checkPromises).then(function () {
                                    if (vm.higherSize.length > 0) {
                                        $scope.bigSizeTip = true;
                                        $scope.higherSizeLen = vm.higherSize.length;
                                        $(".save-pages2").addClass('hide1');
                                        $timeout(function(){
                                            $scope.$digest();
                                        })
                                    } else {
                                        if (files.length > 0) {
                                            filterUpload(files);
                                        }
                                    }
                                    try { document.body.removeChild(wechatFileInput); } catch (e) {}
                                });
                            });
                        };

                        // 触发文件选择
                        wechatFileInput.click();
                    });

                    /**
                     * iOS上传
                     * 使用自带的上传图片功能  不调用微信的jssdk
                     * 非调用微信公众号上传图片 无9张限制 可多张上传 上传到七牛  并且可以返回路径在页面显示
                     * @param $event
                     */
                    window.uploadImageMutiple = function ($event) {
                        $timeout(function () {
                            vm.onUploadStart();
                            $scope.bigSizeTip = false;
                            var files = [];
                            for (var i = 0; i < $event.target.files.length; i++) {
                                var file = $event.target.files[i];
                                var lowerName = (file.name || '').toLowerCase();
                                var isValidImage = file.type === 'image/png' || file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/heic';
                                var isHeicOrLivp = !file.type && (lowerName.endsWith('.heic') || lowerName.endsWith('.heif') || lowerName.endsWith('.livp'));
                                if (isValidImage || isHeicOrLivp || !file.type) {
                                    file.usenum = 0;
                                    file.percent = 0;
                                    file.blobCover = URL.createObjectURL(file);
                                    files.push(file)
                                }
                            }

                            // 检查图片大小（文件大小 + 像素维度）
                            vm.higherSize = [];
                            var iosCheckPromises = [];
                            angular.forEach(files, function (item) {
                                item.imgSize = item.size;
                                iosCheckPromises.push(
                                    checkIsBigImage(item).then(function (isBig) {
                                        if (isBig) {
                                            vm.higherSize.push(item);
                                        }
                                    })
                                );
                            });
                            $q.all(iosCheckPromises).then(function () {
                                if (vm.higherSize.length > 0) {
                                    $scope.bigSizeTip = true;
                                    $scope.higherSizeLen = vm.higherSize.length;
                                    $(".save-pages2").addClass('hide1');
                                    $timeout(function(){
                                        $scope.$digest();
                                    })
                                } else {
                                    if (files.length > 0) {
                                        filterUpload(files);
                                    }
                                }
                            });
                        })

                    };
                });


                // 检测图片是否为大图（文件大小 > 50MB 或 像素数 > 4亿）
                function checkIsBigImage(item) {
                    return $q(function (resolve) {
                        // 文件大小检查
                        // 鸿蒙等系统可能存在 File.size 不可用的情况（为0或undefined），
                        // 此时先不做文件大小判断，改为通过 Image 加载后在 onload 中获取 blob 实际大小来判断
                        var fileSize = item.size;
                        if (fileSize && fileSize / 1024 > 51200) {
                            resolve(true);
                            return;
                        }

                        // 像素检查：width * height > 4亿
                        try {
                            var img = new Image();
                            var objectUrl = item.blobCover;
                            img.onload = function () {
                                var imgSrc = img.src;
                                // 先检查像素维度
                                if (this.naturalWidth * this.naturalHeight > 400000000) {
                                    URL.revokeObjectURL(imgSrc);
                                    resolve(true);
                                    return;
                                }
                                // 如果 File.size 不可用（为0或空），尝试通过 blob URL 估算实际文件大小
                                if (!fileSize || fileSize === 0) {
                                    // 通过 canvas 估算解码后的数据量作为参考
                                    // 如果 width * height * 4（RGBA字节数）> 50MB，也可以认为是大图
                                    // 50MB = 50 * 1024 * 1024 bytes
                                    var estimatedSize = this.naturalWidth * this.naturalHeight * 4;
                                    if (estimatedSize > 50 * 1024 * 1024) {
                                        URL.revokeObjectURL(imgSrc);
                                        resolve(true);
                                        return;
                                    }
                                }
                                URL.revokeObjectURL(imgSrc);
                                resolve(false);
                            };
                            img.onerror = function () {
                                URL.revokeObjectURL(img.src);
                                // 如果 file.size 本身就已经超过 50MB，直接判定为大图
                                if (fileSize && fileSize / 1024 > 51200) {
                                    resolve(true);
                                    return;
                                }
                                // 图片加载失败但文件大小未超标：很可能是像素过大导致浏览器无法解码
                                // 此时通过直接解析文件头部获取真实宽高，避免漏判大图
                                readDimensionsFromHeader(item).then(function(dims) {
                                    if (dims && dims.width * dims.height > 400000000) {
                                        resolve(true);
                                    } else {
                                        // 无法获取维度或维度正常，可能是图片损坏等其他原因导致加载失败
                                        resolve(false);
                                    }
                                }).catch(function() {
                                    resolve(false);
                                });
                            };
                            img.src = objectUrl;
                        } catch (e) {
                            // 异常兜底：如果能从 item 拿到 size 信息，就基于它判断
                            if (fileSize && fileSize / 1024 > 51200) {
                                resolve(true);
                            } else {
                                resolve(false);
                            }
                        }
                    });
                }

                /**
                 * 通过读取文件头部二进制数据，直接解析 JPEG/PNG 图片的宽高
                 * 用于 Image 对象解码失败时（如图片像素过大导致浏览器内存不足）的兜底方案
                 * @param {File|Blob} file - 图片文件对象
                 * @returns {Promise<{width: number, height: number}|null>}
                 */
                function readDimensionsFromHeader(file) {
                    return $q(function(resolve) {
                        // SVG 等非位图格式或空文件直接返回 null
                        if (!file || !file.type) {
                            resolve(null);
                            return;
                        }
                        // 只处理 JPEG 和 PNG
                        if (file.type.indexOf('image/jpeg') === -1 && file.type.indexOf('image/png') === -1 && file.type.indexOf('image/jpg') === -1) {
                            resolve(null);
                            return;
                        }

                        try {
                            var reader = new FileReader();
                            reader.onload = function(e) {
                                try {
                                    var arr = new Uint8Array(e.target.result);
                                    var view = new DataView(arr.buffer);
                                    var width, height;

                                    // PNG: 前8字节签名 0x89 50 4E 47 0D 0A 1A 0A
                                    // IHDR chunk 在 offset 8 处，宽高为 offset 16/20，各4字节 big-endian
                                    if (arr[0] === 0x89 && arr[1] === 0x50 && arr[2] === 0x4E && arr[3] === 0x47) {
                                        width = view.getUint32(16);
                                        height = view.getUint32(20);
                                        resolve({ width: width, height: height });
                                        return;
                                    }

                                    // JPEG: 以 0xFF 0xD8 0xFF 开头
                                    // 搜索 SOF (Start of Frame) marker，宽高紧随其后
                                    if (arr[0] === 0xFF && arr[1] === 0xD8 && arr[2] === 0xFF) {
                                        var offset = 2;
                                        var limit = Math.min(arr.length - 9, 65536);
                                        while (offset < limit) {
                                            if (arr[offset] !== 0xFF) {
                                                break;
                                            }
                                            var marker = arr[offset + 1];
                                            // SOF markers: 0xC0 ~ 0xCF (跳过 0xC4 DHT, 0xC8 JPG 扩展)
                                            if ((marker >= 0xC0 && marker <= 0xC3) || (marker >= 0xC5 && marker <= 0xC7) || (marker >= 0xC9 && marker <= 0xCF)) {
                                                height = view.getUint16(offset + 5);
                                                width = view.getUint16(offset + 7);
                                                resolve({ width: width, height: height });
                                                return;
                                            }
                                            // 跳过当前 segment：segment长度(2字节) + marker(2字节)
                                            var segLen = view.getUint16(offset + 2);
                                            if (segLen < 2) break;
                                            offset += 2 + segLen;
                                        }
                                    }

                                    resolve(null);
                                } catch (innerErr) {
                                    resolve(null);
                                }
                            };
                            reader.onerror = function() {
                                resolve(null);
                            };
                            // 只需读取前 64KB 即可找到图片尺寸信息
                            var blob = (typeof file.slice === 'function') ? file.slice(0, 65536) : file;
                            reader.readAsArrayBuffer(blob);
                        } catch (err) {
                            resolve(null);
                        }
                    });
                }

                function filterUpload(files) {
                    $(".save-pages2").removeClass('hide1');
                    // 预处理 .livp 文件：解包提取 HEIC 图片后替换，后续流程无感知
                    extractLivpFiles(files).then(function(processedFiles) {
                        if (processedFiles.length === 0) {
                            $(".save-pages2").addClass('hide1');
                            return;
                        }
                        asyncUpload(processedFiles);
                    });
                }

                // 遍历文件列表，将 .livp 文件解包为真实图片文件，非 .livp 文件原样返回
                function extractLivpFiles(files) {
                    var promises = [];
                    for (var i = 0; i < files.length; i++) {
                        var file = files[i];
                        var fileName = (file.name || '').toLowerCase();
                        if (fileName.endsWith('.livp')) {
                            promises.push(_extractHeicFromLivp(file));
                        } else {
                            promises.push(Promise.resolve(file));
                        }
                    }
                    return Promise.all(promises).then(function(results) {
                        return results.filter(function(f) { return f !== null; });
                    });
                }

                // 从 .livp 压缩包中提取 HEIC 图片，保留原始 .livp 文件名
                function _extractHeicFromLivp(file) {
                    return JSZip.loadAsync(file).then(function(zip) {
                        var imageFileName = null;
                        zip.forEach(function(relativePath, zipEntry) {
                            if (!zipEntry.dir && !imageFileName) {
                                var lowerName = relativePath.toLowerCase();
                                if (lowerName.endsWith('.heic') || lowerName.endsWith('.heif') ||
                                    lowerName.endsWith('.jpg') || lowerName.endsWith('.jpeg') ||
                                    lowerName.endsWith('.png')) {
                                    imageFileName = relativePath;
                                }
                            }
                        });

                        if (!imageFileName) {
                            console.warn('No image found in .livp package:', file.name);
                            return null;
                        }

                        return zip.file(imageFileName).async('blob').then(function(blob) {
                            // 提取内部图片的扩展名
                            var internalExt = '';
                            var internalLower = imageFileName.toLowerCase();
                            if (internalLower.endsWith('.heic')) internalExt = '.heic';
                            else if (internalLower.endsWith('.heif')) internalExt = '.heif';
                            else if (internalLower.endsWith('.jpg') || internalLower.endsWith('.jpeg')) internalExt = '.jpg';
                            else if (internalLower.endsWith('.png')) internalExt = '.png';
                            // 用原始 .livp 文件名替换扩展名
                            var newName = file.name.replace(/\.livp$/i, '') + internalExt;
                            var newFile = new File([blob], newName, { type: blob.type || 'image/heic' });
                            newFile.usenum = 0;
                            newFile.percent = 0;
                            newFile.blobCover = URL.createObjectURL(newFile);
                            newFile.imgSize = blob.size;
                            return newFile;
                        });
                    }).catch(function(err) {
                        console.error('Failed to extract .livp:', file.name, err);
                        return null;
                    });
                }

                function asyncUpload(files) {
                    vm.uploadPhotoItem = files;
                    vm.indd = 0;
                    vm.errorImageArr = [];
                    vm.duplicateList = [];
                    vm.currentFileList = [];
                    $rootScope.$broadcast('uploadStart',true);
                    vm.filesLength = vm.uploadPhotoItem.length;
                    // 并发5个上传：同时启动前5张，之后每完成一张补位启动下一张
                    for (var i = 0; i < 5 && i < files.length; i++) {
                        qiniuUpload(files[i], files, i);
                    }
                }

                // function qiniuUpload(file, files, index_) {
                //     var formData = new FormData();
                //     formData.append('file', file);
                //     formData.append('unique_names', false);
                //     formData.append('key', "gallery-" + UidService.get());
                //     formData.append('token', vm.token);
                //     var reader2 = new FileReader();
                //     reader2.readAsArrayBuffer(file)
                //     file.percent = 20;
                //     reader2.onloadend = function (e) {
                //         formData.append('crc32', CRC32.buf(new Uint8Array(this.result)));
                //         return $.ajax({
                //             // cache: true,
                //             type: "POST",
                //             url: 'https://upload.qiniup.com/',
                //             data: formData,
                //             async: true,
                //             contentType: false,
                //             processData: false,
                //             xhr:function(){
                //                 var myXhr = $.ajaxSettings.xhr();
                //                 if(myXhr.upload){ // check if upload property exists
                //                     myXhr.upload.addEventListener('progress',function(e){
                //                         var loaded = e.loaded;                  //已经上传大小情况
                //                         var total = e.total;                      //附件总大小
                //                         var percent = Math.floor(100*loaded/total)+"%";     //已经上传的百分比
                //                         file.percent = parseInt(100*loaded/total)/2;
                //                     }, false); // for handling the progress of the upload
                //                 }
                //                 return myXhr;
                //             },
                //             success: function (data) {
                //                 vm.uploadPhotoItem[index_].blobCover = $scope.domain +data.key + '?imageView2/1/w/150/h/150';
                //                 file.percent = 80;
                //                 assignGalleries(file, files, index_, data)
                //             },
                //             error: function (request) {
                //                 file.state = 'error';
                //                 vm.errorImageArr.push(files[index_]);
                //                 //最后一个失败了的话
                //                 if (files.length == (Number(vm.indd) + Number(vm.errorImageArr.length))) {
                //                     $timeout(function () {
                //                         $scope.loadingAllSuccess = true;
                //                         updatePic();
                //                     })
                //                 }else{
                //                     var _index1 = Number(index_) + 1;
                //                     if (files.length > _index1) {
                //                         var f = files[index_ + 1];
                //                         qiniuUpload(f, files, _index1);
                //                     }
                //                 }
                //             }
                //         });
                //     }
                // }

                function qiniuUpload(file, files , index_){
                    // 上传前检查图片是否过大，注意此时可能获取不到图片宽高，checkIsBigImage 内部已做兼容处理
                    checkIsBigImage(file).then(function(isBig) {
                        if (isBig) {
                            vm.higherSize.push(file);
                        } else {
                            // 符合规范，执行正常上传流程
                            doUpload(file, files, index_);
                        }
                    });
                }

                // 执行实际上传
                function doUpload(file, files, index_) {
                    ImageService.backendUploadPics(file, $scope.domain, vm.token, function(data, f){
                        file.percent = 80;
                        assignGalleries(file, files, index_, data)
                    },function(err){
                        file.state = 'error';
                        vm.errorImageArr.push(files[index_]);
                        proceedToNext(file, files, index_);
                    })
                }

                // 处理当前文件后继续下一张
                function proceedToNext(file, files, index_) {
                    //最后一个失败了的话
                    if (files.length == (Number(vm.indd) + Number(vm.errorImageArr.length))) {
                        $timeout(function () {
                            $scope.loadingAllSuccess = true;
                            updatePic();
                        })
                    }else{
                        // 并发5：前5张已同时启动，此后每完成一张（index_ >= 4）补位启动下一张
                        if (files.length > Number(index_) + 1 && index_ >= 4) {
                            var f = files[Number(index_) + 1];
                            qiniuUpload(f, files, Number(index_) + 1);
                        }
                    }
                }

                function serviceUpload(data, file,callback) {
                    //非冲印的上传 需要增加detectFaces为true
                    var detectFaces = $state.current.name !== "editorPhotoBothEdit" && $state.current.name !== 'editorPhotoBoth'

                    Gallery.upload({
                        identifiers: data.key,
                        provider: "QINIU",
                        fileName: file.name,
                        imgSize: file.size,
                        width: file.width,
                        height: file.height,
                        folderId: vm.folderOne ? vm.folderOne.id : '',
                        check: true,
                        type: vm.uploadType,
                        articleId:vm.aid,
                        hash: data.hash,
                        detectFaces:detectFaces
                    }, function (resp1) {
                        file.percent = 100;
                        var resp = resp1.data;
                        file.id = resp.id;
                        file.cancelled = resp.cancelled;
                        vm.indd++;
                        file.state = 'success';
                        if (!resp.cancelled) {
                            resp.identifier = $scope.domain +resp.identifier;
                            if(resp.duplicate){
                                vm.duplicateList.push(resp)
                            }
                            if(vm.photoAll){
                                vm.photoAll.push(resp)
                            }
                            if(vm.qiniuId){
                                resp.usenum = 0;
                                resp.loading = true;
                                vm.qiniuId.push(resp)
                            }
                            if(vm.onUploadphoto){
                                vm.onUploadphoto({text:resp})
                            }
                            vm.currentFileList.push(resp)

                        }
                        if(callback){callback()}
                    }, function (error) {
                        file.state = 'error';
                        vm.errorImageArr.push(file);
                        if(callback){callback()}
                    });
                }


                function assignGalleries(file, files, index_, data) {
                    serviceUpload(data, file,function () {
                        if (files.length == (Number(vm.indd) + Number(vm.errorImageArr.length))) {
                            $timeout(function () {
                                $scope.loadingAllSuccess = true;
                                updatePic();
                            })
                        }else{
                            // 并发5：前5张已同时启动，此后每完成一张（index_ >= 4）补位启动下一张
                            if (files.length > Number(index_) + 1 && index_ >= 4) {
                                var f = files[Number(index_) + 1];
                                qiniuUpload(f, files, Number(index_) + 1);
                            }
                        }
                    });
                }
                $scope.errorImageArr_=[];
                $scope.reUpload = function () {
                    $scope.errorImageArr_.forEach(function (item) {
                        item.percent = 0;
                        item.state = null;
                    });
                    $scope.errorImageHide();
                    $(".save-pages2").removeClass('hide1');
                    asyncUpload($scope.errorImageArr_);
                }
                // 上传图片后更新图片库/文件夹
                vm.successSum = 0;
                function updatePic() {
                    $scope.isLookErrorImages = false;
                    $(".save-pages2").addClass('hide1');
                    vm.uploadPhotoItem = [];
                    // 广播重复图片列表
                    if (vm.duplicateList && vm.duplicateList.length > 0) {
                        $rootScope.$broadcast('duplicateImages', angular.copy(vm.duplicateList),vm.errorImageArr.length>0 ? false : true,vm.currentFileList);
                    }else{
                        $rootScope.$broadcast('uoloadFinished',vm.errorImageArr.length>0 ? false : true);
                    }

                    console.log(vm.errorImageArr)
                    vm.successSum = angular.copy(vm.indd);
                    $timeout(function () {
                        vm.indd = 0;
                        vm.filesLength = 0;
                        //如果没有上传错误图片，关闭提示框
                        if(vm.errorImageArr.length === 0){
                            $scope.loadingAllSuccess = false;
                        }else{
                            $scope.loadingAllSuccess = true;
                        }
                    },2000)
                }
                //关闭上传错误弹窗
                $scope.closeErrorMoadl = function (){
                    var target = event.target;
                    if($(target).hasClass("z-modal") || $(target).hasClass("close-btn") || $(target).hasClass("close-icon1")){
                        $scope.loadingAllSuccess = false;
                    }
                    if(vm.duplicateList.length == 0){
                        $rootScope.$broadcast('uoloadFinished',true);
                    }
                }
                //上传进度获取
                $scope.schedule = function () {
                    if(vm.filesLength > 0){
                        return Number(vm.indd)+vm.errorImageArr.length + '/' + vm.filesLength
                    }
                }
                $scope.errorImageArrCb = function () {
                    return vm.errorImageArr.length
                }
                $scope.successImageArrCb = function () {
                    return vm.indd || vm.successSum
                }
                $scope.isLookErrorImages = false;
                $scope.lookErrorImages = function () {
                    $scope.isLookErrorImages = true;
                    $scope.loadingAllSuccess = false;
                    $scope.errorImageArr_ = vm.errorImageArr;
                    $scope.errorImageArr_.forEach(function (item) {
                        item.percent = 0;
                    })
                };
                $scope.errorImageHide = function () {
                    $scope.isLookErrorImages = false;
                    $rootScope.$broadcast('uoloadFinished',true);
                }

                function threeInfo(item){
                    $scope.threeError = true;
                    $scope.threeErrorText=item;
                    $timeout(function () {
                        $scope.threeError = false;
                        $scope.threeErrorText="";
                    },1500)
                }
            }]
    };

    angular
        .module('editorApp')
        .component('uploadImage', uploadImage);
})();

(function () {
    'use strict';

    angular
        .module('editorApp')
        .controller('GalleryUpload0PageController', GalleryUpload0PageController);

    GalleryUpload0PageController.$inject = ['$scope', '$q', '$stateParams', '$state', '$localStorage', 'StoreWechatSetting', '$http', 'PlatformWechatSetting', 'AuthServerProvider', 'Store', 'Article'];

    function GalleryUpload0PageController($scope, $q, $stateParams, $state, $localStorage, StoreWechatSetting, $http, PlatformWechatSetting, AuthServerProvider, Store, Article) {
        var vm = this;
        $(".navbar").hide();
        $(".wrap").hide();
        var storeId = $stateParams.storeId;
        var fid = $stateParams.fid;
        var aid = $stateParams.aid;
        localStorage.setItem('themeFlag', 'two');

        if ($stateParams.auth) {
            AuthServerProvider.storeAuthenticationToken($stateParams.auth, true);
            init();
        }
        else if ($stateParams.ticket) {
            var token = getToken($stateParams.ticket, function(token) {
                if (token) {
                    AuthServerProvider.storeAuthenticationToken(token, true);
                    init();
                } else {
                    // illegal
                    console.error("Cannot open article with failure of getToken");
                }
            });
        } else {
            // illegal
            console.error("Cannot open article with nothing ticket or auth");
        }

        function getToken(ticket, callback) {
            Article.getToken({ticket: ticket}, function (res) {
                if (res.status == 200) {
                    var token = res.data;
                    if (token && callback) {
                        callback(token);
                    } else {
                        console.log("Invalid token or callback, token=" + token);
                    }
                } else {
                    console.log("Error to getToken with ticket: " + ticket + ", article=" + aid);
                }
            });
        }

        function init() {
            $state.go('galleryUploadPage', {storeId: storeId, fid: fid, aid: aid})
        }
        // /{storeId}/{fid}/gallery/uploading/{userId}
    }
})();

(function () {
    'use strict';

    angular
        .module('editorApp')
        .controller('GalleryUploadPageController', GalleryUploadPageController);

    GalleryUploadPageController.$inject = ['$scope', '$q', 'Gallery', '$stateParams', '$localStorage', 'StoreWechatSetting', '$http','ModulesService',
        'PlatformWechatSetting', 'AuthServerProvider', 'Store', 'CommonService', 'Qinius', 'QiniuToken', 'Theme', '$websocket','WxJS','$rootScope','MessageService', '$translate'];

    function GalleryUploadPageController($scope, $q, Gallery, $stateParams, $localStorage, StoreWechatSetting, $http, ModulesService,
                                         PlatformWechatSetting, AuthServerProvider, Store, CommonService, Qinius, QiniuToken, Theme, $websocket,WxJS, $rootScope, MessageService, $translate) {
        var vm = this;
        $(".navbar-gallery").hide();
        $(".wrap").show().addClass('no-margins');
        $(".well").css({'margin-bottom': 0});
        vm.uploadPhotoItem = [];
        $scope.agentIos = false;
        console.log(window.screen.width)
        vm.duplicateList = []; //重复图片
        vm.isDuplicateList = false; //重复图片弹框
        vm.storeId = $stateParams.storeId;
        vm.aid = $stateParams.aid;
        vm.fid = $stateParams.fid;
        $scope.photos = [];
        if (vm.storeId == null) {
            return;
        }
        ;
        if (vm.fid == 0) {
            vm.fid = null;
        }

        vm.platformSetting = PlatformWechatSetting.get();
        CommonService.setDocumentTitle($translate.instant('gallery.photoUploadTitle'));
        //风格切换  引入不同的css文件
        Theme.judge();
        vm.closePage = closePage;

        function closePage() {
            console.log(123);
        }

        // 成功多少张
        var indd = 0;
        var errorImageArr = [];
        var repeatCount = 0;

        //阻止微信端长按赋值保存图片
        document.oncontextmenu = function (e) {
            //或者return false;
            e.preventDefault();
        };

        $scope.deletePic = function (id, index) {
            console.log($scope.photos);
            Gallery.delete({id: id}, function () {
                $scope.photos.splice(index, 1);
            }, function () {

            });
        }


        vm.domains = Qinius.getDomain();
        vm.tokens = QiniuToken.getPromise('get');
        $q.all([vm.domains.$promise, vm.tokens.$promise,vm.platformSetting.$promise]).then(function () {
            vm.domain = 'https://' + vm.domains.domains[0] + '/';
            vm.token = vm.tokens.token;
            vm.platformSetting = vm.platformSetting.data;
            /**
             * wechat api
             */
            if (wx) {
                var url = window.location.hash && window.location.href.slice(0, -window.location.hash.length) || window.location.href;
                WxJS.get({url: url}, function (res) {
                    if(res.status==200) {
                        $scope.agentIos = browserVersions();
                        var config = res.data;
                        wx.config({
                            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                            appId: config.appId, // 必填，公众号的唯一标识
                            timestamp: config.timestamp, // 必填，生成签名的时间戳
                            nonceStr: config.nonceStr, // 必填，生成签名的随机串
                            signature: config.signature,// 必填，签名，见附录1
                            jsApiList: ['chooseImage', 'uploadImage', 'hideMenuItems'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                        });
                        wx.ready(function () {
                            console.log('wechat api ready!');

                            wx.hideMenuItems({
                                menuList: ["menuItem:copyUrl", "menuItem:share:timeline", "menuItem:share:appMessage", "menuItem:share:qq", "menuItem:share:appMessage", "menuItem:share:QZone"]
                            });
                        });
                        wx.error(function (res) {
                            console.log(res)
                        });
                    }
                }, function () {
                    console.log("wx config error");
                });
            }
            //获取自定义颜色
            ModulesService.getToneSettings(vm.storeId,function (res) {
                vm.toneSettings = res;
            });
            console.log('vm.platformSetting',vm.platformSetting);
            websocket();
        });


        //非调用微信公众号上传图片 无9张限制 可多张上传 上传到七牛  并且可以返回路径在页面显示
        // window.uploadImageMutiple = function ($event) {
        //     var files = [];
        //     for (var i = 0; i < $event.target.files.length; i++) {
        //         files.push($event.target.files[i])
        //     }
        //     vm.higherSize = [];
        //     angular.forEach(files, function (item, index) {
        //         if (item.size / 1024 > 20480) {
        //             vm.higherSize.push(index + 1);
        //         }
        //     });

        //     //系统检测到{{}}张大于20M的图片，已自动过滤\n请压缩后再尝试上传！
        //     if (vm.higherSize.length > 0) {
        //         $scope.bigSizeTip = true;
        //         $scope.higherSizeLen = vm.higherSize.length;
        //         $scope.$digest();
        //     } else {
        //         $(".save-pages").removeClass('hide1');
        //         filterUpload(files);
        //     }

        //     $scope.filterBigSize = function () {
        //         $scope.bigSizeTip = false;
        //         console.log(files)
        //         files = files.filter(function (item, index) {
        //             return item.size / 1024 < 20480;
        //         });
        //         if (files.length == 0) {
        //             updatePic();
        //         } else {
        //             filterUpload(files);
        //         }
        //     }

        //     function filterUpload(files) {
        //         $(".save-pages").addClass('hide1');

        //         //七牛异步 本地同步 9张图 使用时间 7s+      9s
        //         // halfAsyncUpload(files);
        //         //完全异步 9张图  使用时间  6s+    8s
        //         asyncUpload(files);

        //         //完全同步 9张图 使用时间 14s+    12s
        //         // fileGet(0, files);
        //     }


        //     function asyncUpload(files) {
        //         indd = 0;
        //         errorImageArr = [];
        //         setTimeout(function () {
        //             swal({
        //                 title: "开始上传中(1/" + files.length + ")....",
        //                 text: "大图片上传相对缓慢\n请耐心等候...",
        //                 showConfirmButton: false,
        //                 type: "info"
        //             });
        //         }, 500);
        //         var len = files.length;
        //         for (var i = 0; i < 5 && i < files.length; i++) {
        //             var file = files[i];
        //             qiniuUpload(file, files, i);
        //         }
        //     }

        //     function qiniuUpload(file, files, index_) {

        //         var formData = new FormData();
        //         formData.append('file', file);
        //         formData.append('unique_names', false);
        //         formData.append('token', vm.token);
        //         $.ajax({
        //             cache: true,
        //             type: "POST",
        //             url: 'https://upload.qiniup.com/',
        //             data: formData,
        //             async: true,
        //             contentType: false,
        //             processData: false,
        //             success: function (data) {
        //                 swal({
        //                     title: "开始上传中(" + (indd + 1 + errorImageArr.length) + "/" + files.length + ")....",
        //                     text: "大图片上传相对缓慢\n请耐心等候...",
        //                     showConfirmButton: false,
        //                     type: "info"
        //                 });
        //                 console.log(vm.domain + data.key + "?imageInfo");
        //                 $.ajax({
        //                     type: "GET",
        //                     url: vm.domain + data.key + "?imageInfo",
        //                     success: function (va) {
        //                         if (va.orientation == "Left-bottom" || va.orientation == "Right-top") {
        //                             file.width = va.height;
        //                             file.height = va.width;
        //                         } else {
        //                             file.width = va.width;
        //                             file.height = va.height;
        //                         }
        //                         console.log("获取成功");
        //                         console.log(file);
        //                         serviceUpload(data, file, files.length);
        //                     },
        //                     error: function (request) {
        //                         console.log("获取失败");
        //                         serviceUpload(data, file, files.length);
        //                     }
        //                 });
        //                 if (files.length > index_ + 1 && index_ >= 4) {
        //                     var f = files[index_ + 1];
        //                     qiniuUpload(f, files, index_ + 1);
        //                 }
        //             },
        //             error: function (request) {
        //                 errorImageArr.push(file);
        //                 swal({
        //                     title: "图片上传中(" + (indd + 1) + "/" + files.length + ")....",
        //                     text: "大图片上传相对缓慢\n请耐心等候...",
        //                     showConfirmButton: false,
        //                     type: "info"
        //                 });
        //                 //最后一个失败了的话
        //                 if (files.length == (indd + errorImageArr.length)) {
        //                     SweetAlert.swal({
        //                         title: '上传完成',
        //                         text: "存在" + errorImageArr.length + "张照片中断\n请重新选择上传",
        //                         imageUrl: Theme.sweetHintImg(),
        //                         showCancelButton: true,
        //                         confirmButtonText: "确认",
        //                         cancelButtonText: "取消"
        //                     }, function (isConfirm) {
        //                         if (isConfirm) {
        //                             asyncUpload(errorImageArr);
        //                         } else {
        //                             SweetAlert.swal({
        //                                 title: '图片已经取消上传',
        //                                 imageUrl: Theme.sweetHintImg(),
        //                                 text: "",
        //                                 timer: 2000,
        //                                 showConfirmButton: false
        //                             });
        //                         }
        //                     })
        //                 }
        //             }
        //         });
        //     }

        //     function serviceUpload(data, file, len) {
        //         Gallery.upload({
        //             identifiers: data.key,
        //             provider: "QINIU",
        //             fileName: file.name,
        //             imgSize: file.size,
        //             width: file.width,
        //             height: file.height,
        //             userId: vm.userId,
        //             folderId: vm.fid,
        //             articleId: vm.aid
        //         }, function (resp) {
        //             if (resp.status == 200) {
        //                 if (resp.data[0].state == '1') {
        //                     repeatCount += 1;
        //                 }
        //                 $scope.photos = $scope.photos.concat(resp.data);
        //                 indd++;
        //                 if (len == (indd + errorImageArr.length) && errorImageArr.length == 0) {
        //                     setTimeout(function () {
        //                         swal({
        //                             title: "上传完成",
        //                             text: repeatCount > 0 ? "存在" + (repeatCount + "张照片重复\n请重新选择上传") : '',
        //                             imageUrl: Theme.sweetSuccedImg(),
        //                             confirmButtonText: "确认"
        //                         });
        //                     }, 1000)
        //                 } else if (len == (indd + errorImageArr.length) && errorImageArr.length != 0) {
        //                     SweetAlert.swal({
        //                         title: '上传完成',
        //                         text: "存在" + errorImageArr.length + "张照片中断\n请重新选择上传",
        //                         imageUrl: Theme.sweetHintImg(),
        //                         showCancelButton: true,
        //                         confirmButtonText: "确认",
        //                         cancelButtonText: "取消"
        //                     }, function (isConfirm) {
        //                         if (isConfirm) {
        //                             asyncUpload(errorImageArr);
        //                         } else {
        //                             SweetAlert.swal({
        //                                 title: '图片已经取消上传',
        //                                 imageUrl: Theme.sweetHintImg(),
        //                                 text: "",
        //                                 timer: 2000,
        //                                 showConfirmButton: false
        //                             });
        //                         }
        //                     })
        //                 }
        //             }

        //         }, function (error) {
        //             errorImageArr.push(file);
        //             //最后一个失败了的话
        //             if (len == (indd + errorImageArr.length)) {
        //                 SweetAlert.swal({
        //                     title: '上传完成',
        //                     text: "存在" + errorImageArr.length + "张照片中断\n请重新选择上传",
        //                     imageUrl: Theme.sweetHintImg(),
        //                     showCancelButton: true,
        //                     confirmButtonText: "确认",
        //                     cancelButtonText: "取消"
        //                 }, function (isConfirm) {
        //                     if (isConfirm) {
        //                         asyncUpload(errorImageArr);
        //                     } else {
        //                         SweetAlert.swal({
        //                             title: '图片已经取消上传',
        //                             imageUrl: Theme.sweetHintImg(),
        //                             text: "",
        //                             timer: 2000,
        //                             showConfirmButton: false
        //                         });
        //                     }
        //                 })
        //             }
        //         });
        //     }
        // };

        // $scope.chooseWx = function () {
        //     console.log('android upload');
        //     var currentIndex = 0;
        //     wx.chooseImage({
        //         count: 9, // 默认9
        //         sizeType: ['original'], // 可以指定是原图还是压缩图，默认二者都有
        //         sourceType: ['album'], // 可以指定来源是相册还是相机，默认二者都有
        //         success: function (res) {
        //             var localIds = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
        //             $(".save-pages").removeClass('hide1');
        //             //异步上传     9张  18s+
        //             asyncGetImg(localIds);

        //             function asyncGetImg(datas) {
        //                 $(".save-pages").addClass('hide1');
        //                 setTimeout(function () {
        //                     swal({
        //                         title: "开始上传中(1/" + datas.length + ")....",
        //                         text: "大图片上传相对缓慢\n请耐心等候...",
        //                         showConfirmButton: false,
        //                         type: "info"
        //                     });
        //                 }, 500);
        //                 indd = 0;  //成功的张数
        //                 errorImageArr = [];  //错误的张数
        //                 var index_ = 0;   //上传到第几张
        //                 if (datas.length > index_) {
        //                     getImg2(datas, index_);
        //                 }
        //             }

        //             function getImg2(datas, index_) {
        //                 //上传到微信服务器
        //                 wx.uploadImage({
        //                     localId: datas[index_],
        //                     isShowProgressTips: 1,
        //                     success: function (res) {
        //                         index_++;
        //                         if (datas.length > index_) {
        //                             getImg2(datas, index_);
        //                         }
        //                         swal({
        //                             title: "图片上传中(" + (indd + 1) + "/" + datas.length + ")....",
        //                             text: "大图片上传相对缓慢\n请耐心等候...",
        //                             showConfirmButton: false,
        //                             type: "info"
        //                         });
        //                         console.log(res.serverId);
        //                         Gallery.upload({
        //                             identifiers: res.serverId,
        //                             provider: "QINIU",
        //                             fileName: '',
        //                             imgSize: 0,
        //                             folderId: $scope.folderOne ? $scope.folderOne.id : '',
        //                             articleId:vm.aid,
        //                         }, function (resp) {
        //                             if(resp.status==200){
        //                                 $scope.photos = $scope.photos.concat(resp.data);
        //                                 if (resp.data[0].state == '1') {
        //                                     repeatCount += 1;
        //                                 }
        //                                 indd++;
        //                                 if (indd == datas.length) {
        //                                     setTimeout(function () {
        //                                         swal({
        //                                             title: "上传完成",
        //                                             text: repeatCount > 0 ? "存在" + (repeatCount + "张照片重复\n请重新选择上传") : '',
        //                                             imageUrl: Theme.sweetSuccedImg(),
        //                                             confirmButtonText: "确认"
        //                                         });
        //                                     }, 1000);
        //                                 } else if (indd == (datas.length + errorImageArr.length) && errorImageArr.length != 0) {
        //                                     SweetAlert.swal({
        //                                         title: '上传完成',
        //                                         text: "存在" + errorImageArr.length + "张照片中断\n请重新选择上传",
        //                                         imageUrl: Theme.sweetHintImg(),
        //                                         showCancelButton: true,
        //                                         confirmButtonText: "确认",
        //                                         cancelButtonText: "取消"
        //                                     }, function (isConfirm) {
        //                                         if (isConfirm) {
        //                                             asyncGetImg(errorImageArr);
        //                                         } else {
        //                                             SweetAlert.swal({
        //                                                 title: '图片已经取消上传',
        //                                                 imageUrl: Theme.sweetHintImg(),
        //                                                 text: "",
        //                                                 timer: 2000,
        //                                                 showConfirmButton: false
        //                                             });
        //                                         }
        //                                     })

        //                                 }
        //                             }
        //                         }, function (error) {
        //                             errorImageArr.push(file);
        //                             //最后一个失败了的话
        //                             if (datas.length == (indd + errorImageArr.length)) {
        //                                 SweetAlert.swal({
        //                                     title: '上传完成',
        //                                     text: "存在" + errorImageArr.length + "张照片中断\n请重新选择上传",
        //                                     imageUrl: Theme.sweetHintImg(),
        //                                     showCancelButton: true,
        //                                     confirmButtonText: "确认",
        //                                     cancelButtonText: "取消"
        //                                 }, function (isConfirm) {
        //                                     if (isConfirm) {
        //                                         asyncGetImg(errorImageArr);
        //                                     } else {
        //                                         SweetAlert.swal({
        //                                             title: '图片已经取消上传',
        //                                             imageUrl: Theme.sweetHintImg(),
        //                                             text: "",
        //                                             timer: 2000,
        //                                             showConfirmButton: false
        //                                         });
        //                                     }
        //                                 })
        //                             }
        //                         });
        //                     },
        //                     error: function (error) {
        //                         swal({
        //                             title: "图片上传中(" + (indd + 1 + errorImageArr.length) + "/" + datas.length + ")....",
        //                             text: "大图片上传相对缓慢\n请耐心等候...",
        //                             showConfirmButton: false,
        //                             type: "info"
        //                         });
        //                         errorImageArr.push(file);
        //                         //最后一个失败了的话
        //                         if (datas.length == (indd + errorImageArr.length)) {
        //                             SweetAlert.swal({
        //                                 title: '上传完成',
        //                                 text: "存在" + errorImageArr.length + "张照片中断\n请重新选择上传",
        //                                 imageUrl: Theme.sweetHintImg(),
        //                                 showCancelButton: true,
        //                                 confirmButtonText: "确认",
        //                                 cancelButtonText: "取消"
        //                             }, function (isConfirm) {
        //                                 if (isConfirm) {
        //                                     asyncGetImg(errorImageArr);
        //                                 } else {
        //                                     SweetAlert.swal({
        //                                         title: '图片已经取消上传',
        //                                         imageUrl: Theme.sweetHintImg(),
        //                                         text: "",
        //                                         timer: 2000,
        //                                         showConfirmButton: false
        //                                     });
        //                                 }
        //                             })
        //                         }
        //                     }
        //                 });
        //             }
        //         },
        //         error: function () {
        //             console.log("error");
        //         }
        //     });
        // };

        $scope.uploadPhoto = function () {
            if($scope.agentIos){
                $rootScope.$broadcast('clickAndroidUpload',true);
            }else {
                $timeout(function () {
                    $("#uploadImg").trigger("click");
                })
            }
        }

        var pendingUploadFiles = null;

        // 添加上传文件到照片列表
        function addUploadFiles(files, skipDuplicates) {
            if (files && files.length > 0) {
                // 构建已有照片的id集合，用于去重
                var existingIds = {};
                for (var k = 0; k < $scope.photos.length; k++) {
                    if ($scope.photos[k].id) {
                        existingIds[$scope.photos[k].id] = true;
                    }
                }
                for (var i = files.length - 1; i >= 0; i--) {
                    var file = files[i];
                    if (file.state == 'success') {
                        if (skipDuplicates && file.duplicate) continue;
                        // 去重：如果id已存在则跳过
                        if (file.id && existingIds[file.id]) continue;
                        if (file.id) existingIds[file.id] = true;
                        $scope.photos.unshift(file);
                    }
                }
            }
        }

        // 监听重复图片事件
        $scope.$on('duplicateImages', function(event, duplicateList, flag, files,currentUploadFiles) {
            if (duplicateList && duplicateList.length > 0) {
                if (files && files.length > 0) {
                    for (var i = files.length-1; i >= 0; i--) {
                        var file = files[i];
                        currentUploadFiles.forEach(function(img){
                            if(img.id == file.id){
                                file.largeFlag = img.largeFlag
                                file.largeStatus = img.largeStatus
                            }
                        })
                    }
                }
                vm.duplicateList = duplicateList;
                pendingUploadFiles = files;

                MessageService.confirm({
                    title: $translate.instant('hint.prompt'),
                    cancel: $translate.instant('button.cancel'),
                    confirm: $translate.instant('button.confirm'),
                    msg: $translate.instant('gallery.duplicateDetected', {count: vm.duplicateList.length}),
                    html: '<span class="themecolor themecolor-btn">' + $translate.instant('gallery.viewDuplicatePhotos') + '</span>'
                }, function(res) {
                    if (res == 'htmlClick') {
                        // 保存原始重复图片ID，用于关闭弹窗后过滤 pendingUploadFiles
                        vm._allDuplicateIds = {};
                        vm.duplicateList.forEach(function(item) {
                            vm._allDuplicateIds[item.id] = true;
                        });
                        vm.isDuplicateList = true;
                    } else {
                        var ids = [];
                        vm.duplicateList.forEach(function(item) {
                            ids.push(item.id);
                        });
                        Gallery.batchDelete(ids, function() {
                            MessageService.success($translate.instant('gallery.deduplicateSuccess'));
                            vm.duplicateList = [];
                            // 从 pendingUploadFiles 中过滤掉被删除的重复图片
                            var duplicateIds = {};
                            ids.forEach(function(id) {
                                duplicateIds[id] = true;
                            });
                            addUploadFiles(pendingUploadFiles.filter(function(f) {
                                return !duplicateIds[f.id];
                            }), false);
                            pendingUploadFiles = null;
                            $rootScope.$broadcast('duplicateGalleryRefresh');
                        }, function(error) {
                            MessageService.error($translate.instant('gallery.deleteFailed'));
                            vm.duplicateList = [];
                        });
                    }
                }, function() {
                    vm.duplicateList = [];
                    addUploadFiles(pendingUploadFiles, false);
                    pendingUploadFiles = null;
                });
            }
        });

        $scope.duplicateChange = function(val) {
            var _val = JSON.parse(val);
            var deletedIds = {};
            if (Array.isArray(_val) && _val.length) {
                // 部分删除：记录被删除的图片ID
                _val.forEach(function(_v) {
                    deletedIds[_v.id] = true;
                });
                $scope.photos = $scope.photos.filter(function(img) {
                    return !deletedIds[img.id];
                });
            } else if (_val === 1) {
                // 全部删除：使用弹窗打开时保存的原始重复ID
                deletedIds = vm._allDuplicateIds || {};
            }
            // _val === 0: 关闭弹窗未删除，deletedIds 为空对象，不过滤任何文件

            vm.isDuplicateList = false;
            vm.duplicateList = [];
            vm._allDuplicateIds = null;
            addUploadFiles(pendingUploadFiles.filter(function(f) {
                return !deletedIds[f.id];
            }), false);
            pendingUploadFiles = null;
            $rootScope.$broadcast('duplicateGalleryRefresh');
        };

        $scope.$on('uoloadFinished', function(event, args, files,currentUploadFiles) {
            console.log('files',files,currentUploadFiles);

            if(args){
                if (files && files.length > 0) {
                    // 构建已有照片的id集合，用于去重
                    var existingIds = {};
                    for (var k = 0; k < $scope.photos.length; k++) {
                        if ($scope.photos[k].id) {
                            existingIds[$scope.photos[k].id] = true;
                        }
                    }
                    for (var i = files.length-1; i >= 0; i--) {
                        var file = files[i];
                        currentUploadFiles.forEach(function(img){
                            if(img.id == file.id){
                                file.largeFlag = img.largeFlag
                                file.largeStatus = img.largeStatus
                            }
                        })
                        if (file.state == 'success') {
                            // 去重：如果id已存在则跳过
                            if (file.id && existingIds[file.id]) continue;
                            if (file.id) existingIds[file.id] = true;
                            $scope.photos.unshift(file);
                        }
                    }
                }
            }
        });

        function websocket(){
            console.log('vm.platformSetting');
            var urlws = vm.platformSetting.editorNotifyUrl.split("://")[1];
            urlws = urlws.split("/")[0];
            var ws = $websocket("wss://"+ urlws +"/widget/ws/websocket?uid=Gallery"+vm.aid);

            ws.onOpen(function() {
                console.log('WebSocket连接已打开, url:'+ws.url);
            });

            ws.onMessage(function(message) {
                var photo = JSON.parse(message.data);
                console.log('photo',photo);
                if (photo.folderId == vm.folderId || (photo.folderId == null && vm.folderId == '')) {
                    // var len = $scope.photos.length;
                    // photo.identifier = $scope.domain + photo.identifier;
                    // photo.select = false;
                    // photo.index = len;
                    // photo.usenum = 0;
                    // photo.type = 'picture';
                    var _photo = null;
                    for (var i = 0; i < $scope.photos.length; i++) {
                        if ($scope.photos[i].id == photo.id) {
                            _photo = $scope.photos[i];
                            break;
                        }
                    }
                    // if ((!photo.largeFlag && !_photo) || (photo.largeFlag && photo.largeStatus == 'done' && !_photo)) {
                    //     vm.unusedQuantity++;
                    //     vm.totalPhotoItems++;
                    //     $scope.photos.unshift(photo);
                    // }
                    if (_photo) {
                        // // 'https://photoavatar-pic-dev.deltazo.com/file-gallery-04e76478-dcd3-4662-88e8-3c3aad92147f-1250910102902864-xl?imageView2/1/w/150/h/150'
                        // _photo.blobCover = _photo.blobCover.indexOf('-xl')
                        // // .thumbnail.jpg
                        if (_photo.blobCover.includes('-xl')) {
                            _photo.blobCover = _photo.blobCover.replace('-xl', '-xl.thumbnail.jpg');
                        }
                        _photo.largeStatus = photo.largeStatus;
                    }
                    // // 同时更新重复图列表中的大图状态，确保重复图弹框中的大图也能正确展示
                    // if (vm.isDuplicateList && vm.duplicateList.length > 0) {
                    //     for (var d = 0; d < vm.duplicateList.length; d++) {
                    //         if (vm.duplicateList[d].id == photo.id) {
                    //             vm.duplicateList[d].largeStatus = photo.largeStatus;
                    //             // 大图处理完成后，更新identifier确保缩略图URL正确（photo.identifier已带域名）
                    //             if (photo.largeStatus && photo.largeStatus !== 'running') {
                    //                 vm.duplicateList[d].largeFlag = true;
                    //             }
                    //             vm.duplicateList[d].identifier = photo.identifier;
                    //             break;
                    //         }
                    //     }
                    // }
                    // if (vm.photoSort != 1 && vm.minId==null) {
                    //     vm.minId = photo.id;
                    // }
                }
            });

            ws.onError(function(error) {
                console.log('WebSocket错误：', error);
            });

            ws.onClose(function() {
                console.log('WebSocket连接已关闭');
            });
        }
        // 大图判断
        $scope.isLarge = function(imageInfo){
            if(!imageInfo)return
            return imageInfo.size >= 20971520 || imageInfo.width > 30000 || imageInfo.height > 30000 || (imageInfo.width*imageInfo.height)>150000000
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('gallery', {
            parent: 'entity',
            url: '/{storeId}/gallery',
            data: {
                authorities: [],
                pageTitle: 'editorApp.gallery.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/gallery/gallery.html',
                    controller: 'GalleryController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('gallery');
                    $translatePartialLoader.addPart('common');
                    return $translate.refresh();
                }]
            }
        }).state('gallery.choose', {
            parent: 'entity',
            url: '/{storeId}/{pid}/gallery',
            data: {
                authorities: [],
                pageTitle: 'editorApp.gallery.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/gallery/gallery.html',
                    controller: 'GalleryController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('gallery');
                    $translatePartialLoader.addPart('common');
                    return $translate.refresh();
                }]
            }
        }).state('gallery.chooses', {
            parent: 'entity',
            url: '/{storeId}/{aid}/gallerys',
            data: {
                authorities: [],
                pageTitle: 'editorApp.gallery.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/gallery/gallery.html',
                    controller: 'GalleryController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('gallery');
                    $translatePartialLoader.addPart('common');
                    return $translate.refresh();
                }]
            }
        })
        .state('gallery-edit', {
            parent: 'entity',
            url: '/{storeId}/cart/editGallery',
            data: {
                authorities: [],
                pageTitle: 'editorApp.gallery.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/cart/gallery-dialog.html',
                    controller: 'GalleryDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('gallery');
                    $translatePartialLoader.addPart('common');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Gallery', function($stateParams, Gallery) {
                    return Gallery.get().$promise;
                }]
            }
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('editorApp')
        .factory('Gallery', Gallery)
        .factory('VerifyCode', VerifyCode)
        .factory('Customer', Customer)

        .factory('Folder', Folder);

    Gallery.$inject = ['$resource'];
    Folder.$inject = ['$resource'];
    Customer.$inject = ['$resource'];
    VerifyCode.$inject = ['$resource', 'DateUtils']

    function Customer ($resource, DateUtils) {
        var resourceUrl =  'manager/' + 'api/customers/:path/:id';

        return $resource(resourceUrl, {}, {
            "getLocation":{
                method:"GET",
                params:{
                    path:"getLocation"
                }
            },
            "addLocation":{
                method:"POST",
                params:{
                    path:"addLocation"
                }
            },
            "updateLocation":{
                method:"POST",
                params:{
                    path:"updateLocation"
                }
            },
            "setDefaultLocation":{
                method:"GET",
                params:{
                    path:"setDefaultLocation"
                }
            },
            "removeLocation":{
                method:"GET",
                params:{
                    path:"removeLocation"
                }
            },
            "current":{
                method:"GET",
                params:{
                    path:"current"
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.lastLogin = DateUtils.convertDateTimeFromServer(data.lastLogin);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'setPhone': {
                method: 'GET',
                params: {
                    path:"setPhone"
                }
            },
            "register":{
                method:"POST",
                params:{
                    path:"register"
                }
            },
            "register2":{
                method:"POST",
                params:{
                    path:"register2"
                }
            },

            "checkPhone":{
                method:"GET",
                params:{
                    path:"checkPhone"
                }
            },
            "checkPassword":{
                method:"GET",
                params:{
                    path:"checkPassword"
                }
            },
            "changePassword":{
                method:"POST",
                params:{
                    path:"changePassword"
                }
            },
            "authenticate":{
                method:"GET",
                params:{
                    path:"authenticate"
                }
            }
        });
    }


    function VerifyCode ($resource, DateUtils){
        var resourceUrl = 'manager'+ '/api/verify-codes/:path/:id';
        return $resource(resourceUrl,{},{
            "getVerifyCode":{
                method:"GET",
                params:{
                    path:"getVerifyCode"
                }
            },
            "check":{
                method:"GET",
                params:{
                    path:"check"
                }
            }
        })
    }

    function Gallery ($resource) {
        var resourceUrl =  'service/' + 'api/gallery/:store/:path/:id';

        return $resource(resourceUrl, {}, {
            'detectFaces': {
                method: 'GET',
                params: {
                    path: 'detectFaces'
                },
            },
            'unUsed': {
                method: 'POST',
                params: {
                    path: 'unUsed'
                },
            },
            'update': {
                method: 'GET',
                params: {
                    path: 'update'
                },
            },
            'batchDelete':{
                method: 'POST',
                params: {
                    path: 'batchDelete'
                }
            },
            "delete":{
                method:"DELETE"
            },
            'get': {
                method: 'GET',
                params: {
                    path: 'all'
                }
            },
            'getPage': {
                method: 'POST',
                params: {
                    path: 'byCondition'
                }
            },
            'upload':{
                method:'GET',
                params:{
                    path:'upload'
                }
            },
            'getOne':{
                method:'GET',
                params:{
                    path:'getOne'
                }
            },
            'updateNum':{
                method:'POST'
            },
            'moveFolder': {
                method: "GET",
                params: {
                    path: "moveFolder"
                },
            },
            'all': {
                method: "POST",
                params: {
                    path: "all"
                }
            },
            "storeByCondition": {
                method: "POST",
                params: {
                    path: "byCondition",
                    store:"store"
                }
            }
        });
    }

    function Folder($resource) {
        var resourceUrl = 'service/' + 'api/folders/:store/:path/:id';

        return $resource(resourceUrl, {}, {
            "getAllByCondition": {
                method: "POST",
                params: {
                    path: "getAllByCondition"
                }
            },
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'delete': {
                method: 'DELETE'
            },
            'batchDelete': {
                method: 'GET',
                params: {
                    path: "batchDelete"
                }
            },
            "storeGetAllByCondition": {
                method: "POST",
                params: {
                    path: "getAllByCondition",
                    store:"store"
                }
            },
            "getAllByConditionAndQuantity": {
                method: "GET",
                params: {
                    path: "getAllByConditionAndQuantity"
                },
            },
        });
    }
})();

(function () {
    'use strict';
    angular
        .module('editorApp')
        .controller('GalleryController', GalleryController)
        .filter('dateFilter', dateFilter);
    GalleryController.$inject = ['$scope', '$state', 'Gallery', '$q', '$stateParams', '$localStorage', 'Qinius', 'QiniuToken', 'SweetAlert',
        '$timeout', 'UidService', 'MessageService', 'Theme', 'CommonService', 'Folder', '$translate'];
    function GalleryController($scope, $state, Gallery, $q, $stateParams, $localStorage, Qinius, QiniuToken, SweetAlert,
                               $timeout, UidService, MessageService, Theme, CommonService, Folder, $translate) {

        // 数据存储结构
        // $scope.photos -- for -- photo -- photo.galleries -- for -- gallery
        var vm = this;

        //这一步是分页下拉  刷新滚动条置顶
        window.scrollTo(0, 0);

        wx.hideOptionMenu();
        vm.storeId = $stateParams.storeId || $localStorage.storeId;
        $scope.currentNav = 'gallery';
        // 是否进入相册内
        $scope.folderInside = false;
        // 选中的某一相册信息
        $scope.folderOne = {};
        // 是否点击移动按钮
        $scope.moveGallery = false
        // 相册点击
        $scope.folderClick = false;
        $scope.selectAllFolder = false;
        $scope.selectOne = {
            folderId: '',
            selected: false
        };
        $scope.selectAllGallery = false;
        $scope.moveGalleryIds = [];
        $scope.folderIds = [];
        $scope.editFolderNameArr = [];

        //区别小程序、公众号
        if (window.location.href.indexOf("?") == -1) {
            localStorage.setItem('distinguish', '');
            var storeAuth = localStorage.getItem('store-' + vm.storeId + '-authenticationToken');
            localStorage.setItem('editor-' + vm.storeId + '-authenticationToken', storeAuth);
        } else {
            var r = window.location.href.split('?')[1];
            var A = r.split('&')[0].split('=')[1];
            var B = r.split('&')[1].split('=')[1];
            var distinguish = decodeURIComponent(A);
            var tempAuthorization = decodeURIComponent(B);
            var Authorization = tempAuthorization.slice(7, tempAuthorization.length);
            if (distinguish == 'weChatApplet' || distinguish == 'weChatAppletMake') {
                localStorage.setItem('Production', 'gallery');
                localStorage.setItem('distinguish', distinguish);
                $localStorage.authenticationToken = Authorization;
            } else {
                localStorage.setItem('distinguish', '');
            }
        }

        //避免重复调用
        var production = localStorage.getItem('Production');
        if (production == 'make') {
            return;
        }

        $(".navbar-gallery").hide();
        $(".wrap").show().addClass('no-margins');
        $scope.agentIos = true;

        // $scope.photos = Gallery.get();
        $scope.domains = Qinius.getDomain();
        vm.tokens = QiniuToken.getPromise('get');
        vm.galleryPage = [];
        var tempArr = [];

        // 成功多少张
        var indd = 0;
        var errorImageArr = [];
        vm.loadMore = loadMore;
        var repeatCount = 0;
        vm.indexNum = 0;
        vm.itemsPerPage = 20;
        // var Orientation = 0;
        vm.more = true;
        CommonService.setDocumentTitle($translate.instant("galleryContent.iCloudAlbums"));
        var flag = true;//用来标志是否滑动到底 加载完成
        function loadAll(folderId) {
            if (folderId == 'isNull') {
                Gallery.getPage({
                    items: [{key: "folderId", op: "isNull", value: ''}],
                    page: vm.indexNum,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Gallery.getPage({
                    items: [{key: "folderId", op: "=", value: folderId}],
                    page: vm.indexNum,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }

            function sort() {
                return ["createdDate,desc"];
            }

            function onSuccess(res) {
                if(res.status == 200){
                    if (vm.indexNum == 0 && res.data != null && res.data.length != 0) {
                        $scope.noPic = false;
                    } else {
                        // $scope.noPic = true;
                    }
                    if (res.data.length < vm.itemsPerPage) {
                        vm.more = false;
                        flag = false;
                    } else {
                        vm.more = true;
                        flag = true;
                    }

                    angular.forEach(res.data, function (item) {
                        vm.galleryPage.push(item);
                    });
                    getPagePhoto();
                }else {
                    MessageService.error(res.message);
                }
            }

            function onError(error) {
                if(error.status !== 403){
                    MessageService.hint($translate.instant("galleryMessage.failedToObtainThePhotoGallery"));
                }
            }
        }

        function loadMore() {
            vm.indexNum++;
            if ($scope.folderInside) {
                loadAll($scope.folderOne.id);
            } else {
                loadAll('isNull');
            }
        }

        //阻止微信端长按赋值保存图片
        document.oncontextmenu = function (e) {
            //或者return false;
            e.preventDefault();
        };

        //判断是ios or Android
        var u = navigator.userAgent;
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        //风格切换  引入不同的css文件
        Theme.judge();
        console.log(localStorage.getItem('distinguish'));

        //获取分页图片 (删除、上传都会重新刷新获取一定数量的照片)
        function getPagePhoto() {
            console.log(vm.galleryPage);//这个是分页限制的数据格式 每次只显示10条
            var timeList = [];
            vm.photoArray = [];
            //判断日期是否重复
            for (var i = 0; i < vm.galleryPage.length; i++) {
                var photoCreatedDate = new Date(vm.galleryPage[i].createdDate);
                if (checkExist(timeList, photoCreatedDate)) {
                    timeList.push(photoCreatedDate);
                }
            }
            //将相同日期下的照片整合
            for (var m = 0; m < timeList.length; m++) {
                var tempObj = {};
                var tempItems = [];
                for (var j = 0; j < vm.galleryPage.length; j++) {
                    var createdDate = new Date(vm.galleryPage[j].createdDate);
                    if (timeList[m].getFullYear() == createdDate.getFullYear() &&
                        timeList[m].getMonth() == createdDate.getMonth() &&
                        timeList[m].getDate() == createdDate.getDate()) {
                        tempItems.push(vm.galleryPage[j])
                    }
                }
                var time = timeList[m].getFullYear() + '年' + (timeList[m].getMonth() + 1) + '月' + timeList[m].getDate() + '日';
                tempObj = {"createDate": time, "galleries": tempItems};
                vm.photoArray.push(tempObj);
            }
            $scope.photos = vm.photoArray;
            $(".photo-show").show();
        };

        $q.all([$scope.domains.$promise, vm.tokens.$promise]).then(function () {
            loadAll('isNull');
            loadFolders();
            $scope.domain = 'https://' + $scope.domains.domains[0] + '/';
            vm.token = vm.tokens.token;
            $scope.select_photo = false;
            $scope.delBar = false;
            $scope.select_photoAll = false;
            $scope.photoCount = false;
            // if (!!$scope.photos.length) {
            //     $scope.noPic = false;
            // }

            if (isAndroid == true && isiOS == false) {
                console.log('android');
                $scope.agentIos = true;
                /********************************************
                 * 上传图片功能   后台会返回上传图片的日期
                 * @type {boolean}
                 * 图片接口    chooseImage拍照、本地选图
                 ********************************************/
                $scope.uploadPhoto = function () {
                    var currentIndex = 0;
                    wx.chooseImage({
                        count: 9, // 默认9
                        sizeType: ['original'], // 可以指定是原图还是压缩图，默认二者都有
                        sourceType: ['album'], // 可以指定来源是相册还是相机，默认二者都有
                        success: function (res) {
                            var localIds = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
                            $(".save-pages").removeClass('hide1');
                            //异步上传     9张  18s+
                            asyncGetImg(localIds);

                            function asyncGetImg(datas) {
                                $(".save-pages").addClass('hide1');
                                setTimeout(function () {
                                    swal({
                                        title: $translate.instant("uploadContent.startUploading",{datasLength:datas.length}),
                                        text: $translate.instant("uploadContent.greatBeach"),
                                        showConfirmButton: false,
                                        type: "info"
                                    });
                                }, 500);
                                indd = 0;  //成功的张数
                                errorImageArr = [];  //错误的张数
                                var index_ = 0;   //上传到第几张
                                if (datas.length > index_) {
                                    getImg2(datas, index_);
                                }
                            }

                            function getImg2(datas, index_) {
                                //上传到微信服务器
                                wx.uploadImage({
                                    localId: datas[index_],
                                    isShowProgressTips: 1,
                                    success: function (res) {
                                        index_++;
                                        if (datas.length > index_) {
                                            getImg2(datas, index_);
                                        }
                                        swal({
                                            title: $translate.instant("uploadContent.illegalContent",{datasLength:datas.length}),
                                            text: $translate.instant("uploadContent.greatBeach"),
                                            showConfirmButton: false,
                                            type: "info"
                                        });
                                        Gallery.upload({
                                            identifiers: res.serverId,
                                            provider: "QINIU",
                                            fileName: '',
                                            imgSize: 0,
                                            folderId: $scope.folderOne ? $scope.folderOne.id : ''
                                        }, function (resp) {
                                            if(resp.status == 200){
                                                if (resp.data[0].state == '1') {
                                                    repeatCount += 1;
                                                }
                                                indd++;
                                                if (indd == datas.length) {
                                                    setTimeout(function () {
                                                        swal({
                                                            title: $translate.instant("uploadContent.uploadCompleted"),
                                                            text: repeatCount > 0 ? $translate.instant("uploadContent.illegalContent",{repeatCount:repeatCount}) : '',
                                                            imageUrl: Theme.sweetSuccedImg(),
                                                            confirmButtonText: $translate.instant("uploadContent.confirm")
                                                        });
                                                        updatePic();
                                                    }, 1000);
                                                } else if (indd == (datas.length + errorImageArr.length) && errorImageArr.length != 0) {
                                                    SweetAlert.swal({
                                                        title: $translate.instant("uploadContent.uploadCompleted"),
                                                        text: $translate.instant("uploadContent.breakUpload",{breakUpload:errorImageArr.length}),
                                                        imageUrl: Theme.sweetHintImg(),
                                                        showCancelButton: true,
                                                        confirmButtonText: $translate.instant("uploadContent.confirm"),
                                                        cancelButtonText: $translate.instant("uploadContent.cancel"),
                                                    }, function (isConfirm) {
                                                        if (isConfirm) {
                                                            asyncGetImg(errorImageArr);
                                                        } else {
                                                            SweetAlert.swal({
                                                                title: $translate.instant("uploadContent.uploadCancle"),
                                                                imageUrl: Theme.sweetHintImg(),
                                                                text: "",
                                                                timer: 2000,
                                                                showConfirmButton: false
                                                            });
                                                            updatePic();
                                                        }
                                                    })

                                                }
                                            }else {
                                                MessageService.error(res.message);
                                            }
                                        }, function (error) {
                                            errorImageArr.push(datas[index_]);
                                            //最后一个失败了的话
                                            if (datas.length == (indd + errorImageArr.length)) {
                                                SweetAlert.swal({
                                                    title: $translate.instant("uploadContent.uploadCompleted"),
                                                    text: $translate.instant("uploadContent.breakUpload",{breakUpload:errorImageArr.length}),
                                                    imageUrl: Theme.sweetHintImg(),
                                                    showCancelButton: true,
                                                    confirmButtonText: $translate.instant("uploadContent.confirm"),
                                                    cancelButtonText: $translate.instant("uploadContent.cancel"),
                                                }, function (isConfirm) {
                                                    if (isConfirm) {
                                                        asyncGetImg(errorImageArr);
                                                    } else {
                                                        SweetAlert.swal({
                                                            title: $translate.instant("uploadContent.uploadCancle"),
                                                            imageUrl: Theme.sweetHintImg(),
                                                            text: "",
                                                            timer: 2000,
                                                            showConfirmButton: false
                                                        });
                                                        updatePic();
                                                    }
                                                })
                                            }
                                        });
                                    },
                                    error: function (error) {
                                        swal({
                                            // title: "图片上传中(" + (indd + 1 + errorImageArr.length) + "/" + datas.length + ")....",
                                            title: $translate.instant("uploadContent.startUploading2",{currentLenght:indd + 1 + errorImageArr.length,datasLength:datas.length}),
                                            text: $translate.instant("uploadContent.greatBeach"),
                                            showConfirmButton: false,
                                            type: "info"
                                        });
                                        errorImageArr.push(datas[index_]);
                                        //最后一个失败了的话
                                        if (datas.length == (indd + errorImageArr.length)) {
                                            SweetAlert.swal({
                                                title: $translate.instant("uploadContent.uploadCompleted"),
                                                text: $translate.instant("uploadContent.breakUpload",{breakUpload:errorImageArr.length}),
                                                imageUrl: Theme.sweetHintImg(),
                                                showCancelButton: true,
                                                confirmButtonText: $translate.instant("uploadContent.confirm"),
                                                cancelButtonText: $translate.instant("uploadContent.cancel"),
                                            }, function (isConfirm) {
                                                if (isConfirm) {
                                                    asyncGetImg(errorImageArr);
                                                } else {
                                                    SweetAlert.swal({
                                                        title: $translate.instant("uploadContent.uploadCancle"),
                                                        imageUrl: Theme.sweetHintImg(),
                                                        text: "",
                                                        timer: 2000,
                                                        showConfirmButton: false
                                                    });
                                                    updatePic();
                                                }
                                            })
                                        }
                                    }
                                });
                            }
                        },
                        error: function () {
                            console.log("error");
                        }
                    });
                };

            } else if (isAndroid == false && isiOS == true) {
                console.log('ios');
                // 使用自带的上传图片功能  不调用微信的jssdk
                $scope.agentIos = false;
                //非调用微信公众号上传图片 无9张限制 可多张上传 上传到七牛  并且可以返回路径在页面显示
                window.uploadImageMutiple = function ($event) {
                    var files = [];
                    for (var i = 0; i < $event.target.files.length; i++) {
                        files.push($event.target.files[i])
                    }
                    var lowerSize = [];
                    angular.forEach(files, function (item, index) {
                        if (item.size / 1024 < 150 || item.size / 1024 > 20480) {
                            lowerSize.push(index + 1);
                        }
                    });
                    if (lowerSize.length > 0) {
                        swal({
                                // title: '存在' + lowerSize.length + '张图片小于150k或大于20M\n确认上传？',
                                title: $translate.instant("uploadContent.pictureError",{lowerSizeLenght:lowerSize.length}),
                                imageUrl: Theme.sweetHintImg(),
                                showCancelButton: true,
                                confirmButtonText: $translate.instant("uploadContent.confirm"),
                                cancelButtonText: $translate.instant("uploadContent.cancel"),
                            },
                            function (isConfirm) {
                                $(".save-pages").removeClass('hide1');
                                if (isConfirm) {
                                    filterUpload(files);
                                } else {
                                    files = files.filter(function (item, index) {
                                        return item.size / 1024 >= 150;
                                    });
                                    files = files.filter(function (item, index) {
                                        return item.size / 1024 < 20480;
                                    });
                                    if (files.length == 0) {
                                        updatePic();
                                        // $state.go('gallery', {storeId: vm.storeId}, {reload: true});
                                    } else {
                                        filterUpload(files);
                                    }
                                }
                            })
                    } else {
                        $(".save-pages").removeClass('hide1');
                        filterUpload(files);
                    }
                    function filterUpload(files) {
                        $(".save-pages").addClass('hide1');

                        //七牛异步 本地同步 9张图 使用时间 7s+      9s
                        // halfAsyncUpload(files);
                        //完全异步 9张图  使用时间  6s+    8s
                        asyncUpload(files);

                        //完全同步 9张图 使用时间 14s+    12s
                        // fileGet(0, files);
                    }


                    function asyncUpload(files) {
                        indd = 0;
                        errorImageArr = [];
                        setTimeout(function () {
                            swal({
                                title: $translate.instant("uploadContent.startUploading",{datasLength:files.length}),
                                text: $translate.instant("uploadContent.greatBeach"),
                                showConfirmButton: false,
                                type: "info"
                            });
                        }, 500);
                        var len = files.length;
                        for (var i = 0; i < 5 && i < files.length; i++) {
                            var file = files[i];
                            qiniuUpload(file, files, i);
                        }
                    }

                    function qiniuUpload(file, files, index_) {

                        var formData = new FormData();
                        formData.append('file', file);
                        formData.append('unique_names', false);
                        formData.append('key', "gallery-" + UidService.get());
                        formData.append('token', vm.token);
                        var reader = new FileReader();
                        reader.readAsArrayBuffer(file)
                        reader.onloadend = function (e) {
                            formData.append('crc32', CRC32.buf(new Uint8Array(this.result)));
                            return $.ajax({
                                cache: true,
                                type: "POST",
                                url: 'https://upload.qiniup.com/',
                                data: formData,
                                async: true,
                                contentType: false,
                                processData: false,
                                success: function (data) {
                                    swal({
                                        title: $translate.instant("uploadContent.startUploading2",{currentLenght:indd + 1 + errorImageArr.length,datasLength:files.length}),
                                        text: $translate.instant("uploadContent.greatBeach"),
                                        showConfirmButton: false,
                                        type: "info"
                                    });
                                    $.ajax({
                                        type: "GET",
                                        url: $scope.domain + data.key + "?imageInfo",
                                        success: function (va) {
                                            if (va.orientation == "Left-bottom" || va.orientation == "Right-top") {
                                                file.width = va.height;
                                                file.height = va.width;
                                            } else {
                                                file.width = va.width;
                                                file.height = va.height;
                                            }
                                            serviceUpload(data, file, files.length);
                                        },
                                        error: function (request) {
                                            serviceUpload(data, file, files.length);
                                        }
                                    });
                                    if (files.length > index_ + 1 && index_ >= 4) {
                                        var f = files[index_ + 1];
                                        qiniuUpload(f, files, index_ + 1);
                                    }
                                },
                                error: function (request) {
                                    errorImageArr.push(file);
                                    swal({
                                        // title: "图片上传中(" + (indd + 1) + "/" + files.length + ")....",
                                        title: $translate.instant("uploadContent.pictureUpload",{currentLenght:indd + 1,datasLength:files.length}),
                                        text: $translate.instant("uploadContent.greatBeach"),
                                        showConfirmButton: false,
                                        type: "info"
                                    });
                                    //最后一个失败了的话
                                    if (files.length == (indd + errorImageArr.length)) {
                                        SweetAlert.swal({
                                            title: $translate.instant("uploadContent.uploadCompleted"),
                                            text: $translate.instant("uploadContent.breakUpload",{breakUpload:errorImageArr.length}),
                                            imageUrl: Theme.sweetHintImg(),
                                            showCancelButton: true,
                                            confirmButtonText: $translate.instant("uploadContent.confirm"),
                                            cancelButtonText: $translate.instant("uploadContent.cancel"),
                                        }, function (isConfirm) {
                                            if (isConfirm) {
                                                asyncUpload(errorImageArr);
                                            } else {
                                                SweetAlert.swal({
                                                    title: $translate.instant("uploadContent.uploadCancle"),
                                                    imageUrl: Theme.sweetHintImg(),
                                                    text: "",
                                                    timer: 2000,
                                                    showConfirmButton: false
                                                });
                                                updatePic();
                                                // $state.go('gallery', {storeId: vm.storeId}, {reload: true});
                                            }
                                        })
                                    }
                                }
                            });
                        }
                    }

                    function serviceUpload(data, file, len) {
                        Gallery.upload({
                            identifiers: data.key,
                            provider: "QINIU",
                            fileName: file.name,
                            imgSize: file.size,
                            width: file.width,
                            height: file.height,
                            folderId: $scope.folderOne ? $scope.folderOne.id : ''
                        }, function (resp) {
                            if(resp.status == 200){
                                if (resp.data[0].state == '1') {
                                    repeatCount += 1;
                                }
                                indd++;
                                if (len == (indd + errorImageArr.length) && errorImageArr.length == 0) {
                                    setTimeout(function () {
                                        swal({
                                            title: $translate.instant("uploadContent.uploadCompleted"),
                                            text: repeatCount > 0 ? $translate.instant("uploadContent.illegalContent",{repeatCount:repeatCount}) : '',
                                            imageUrl: Theme.sweetSuccedImg(),
                                            confirmButtonText: $translate.instant("uploadContent.confirm")
                                        });
                                        updatePic();
                                    }, 1000)
                                } else if (len == (indd + errorImageArr.length) && errorImageArr.length != 0) {
                                    SweetAlert.swal({
                                        title: $translate.instant("uploadContent.uploadCompleted"),
                                        text: $translate.instant("uploadContent.breakUpload",{breakUpload:errorImageArr.length}),
                                        imageUrl: Theme.sweetHintImg(),
                                        showCancelButton: true,
                                        confirmButtonText: $translate.instant("uploadContent.confirm"),
                                        cancelButtonText: $translate.instant("uploadContent.cancel"),
                                    }, function (isConfirm) {
                                        if (isConfirm) {
                                            asyncUpload(errorImageArr);
                                        } else {
                                            SweetAlert.swal({
                                                title: $translate.instant("uploadContent.uploadCancle"),
                                                imageUrl: Theme.sweetHintImg(),
                                                text: "",
                                                timer: 2000,
                                                showConfirmButton: false
                                            });
                                            updatePic();
                                        }
                                    })
                                }
                            }else {
                                MessageService.error(res.message);
                            }
                        }, function (error) {
                            errorImageArr.push(file);
                            //最后一个失败了的话
                            if (len == (indd + errorImageArr.length)) {
                                SweetAlert.swal({
                                    title: $translate.instant("uploadContent.uploadCompleted"),
                                    text: $translate.instant("uploadContent.breakUpload",{breakUpload:errorImageArr.length}),
                                    imageUrl: Theme.sweetHintImg(),
                                    showCancelButton: true,
                                    confirmButtonText: $translate.instant("uploadContent.confirm"),
                                    cancelButtonText: $translate.instant("uploadContent.cancel"),
                                }, function (isConfirm) {
                                    if (isConfirm) {
                                        asyncUpload(errorImageArr);
                                    } else {
                                        SweetAlert.swal({
                                            title: $translate.instant("uploadContent.uploadCancle"),
                                            imageUrl: Theme.sweetHintImg(),
                                            text: "",
                                            timer: 2000,
                                            showConfirmButton: false
                                        });
                                        updatePic();
                                    }
                                })
                            }
                        });
                    }
                };
            }
        });


        $scope.noPic = true;
        // var select = true;
        vm.aid = $stateParams.aid;
        vm.vid = '';
        vm.pid = '';
        $scope.dHeight = document.documentElement.clientHeight;
        $scope.dWidth = document.documentElement.clientWidth;
        $("body").css({width: $scope.dWidth, 'min-width': $scope.dWidth});
        if ($stateParams.pid) {
            vm.pid = $stateParams.pid;
            vm.vid = $stateParams.vid;
        }
        $scope.gallaryPic = [];         //个人图片库选择
        $scope.counts = localStorage.getItem('maskCounts');

        //个人图片库单张选中当前图片
        $scope.selectThis = function (gallery, photo, index) {
            console.log('personal gallery');
            $scope.gallaryPic = [];
            $scope.moveGalleryIds = [];
            gallery.select_photo = !gallery.select_photo;
            for (var i = 0; i < photo.galleries.length; i++) {
                if (!photo.galleries[i].select_photo) {
                    photo.select_photoAll = false;
                    break;
                } else if (i == photo.galleries.length - 1) {
                    photo.select_photoAll = true;
                }
            }
            var t = 0;
            angular.forEach($scope.photos, function (p) {
                angular.forEach(p.galleries, function (g) {
                    if (g.select_photo) {
                        t++;
                        $scope.gallaryPic.push(g);       //选择导入图片的数组
                        $scope.moveGalleryIds.push(g.id);
                    }
                })
            });
            $scope.select_photo = t ? true : false;         //确认按钮的显示
            $scope.delBar = t ? true : false; //删除栏的显示
        };

        //个人图片库全选   这里也不一定就会有图片  说不定就是现场上传图片
        $scope.selectedPhoto = function (index, photo) {
            console.log('personal gallery');
            $scope.gallaryPic = [];
            $scope.moveGalleryIds = [];
            if ($scope.photos == '' || $scope.photos == null) {
                return;
            } else {
                if (photo.select_photoAll == null) {
                    photo.select_photoAll = true;
                } else {
                    photo.select_photoAll = !photo.select_photoAll;
                }
                $scope.delBar = true;
                angular.forEach(photo.galleries, function (g, i) {
                    g.select_photo = photo.select_photoAll;
                });

                if (photo.select_photoAll) {
                    $scope.select_photoAll = true;
                } else {
                    $scope.select_photoAll = false;
                }

                var t = 0;
                angular.forEach($scope.photos, function (p, i) {
                    angular.forEach(p.galleries, function (g, j) {
                        if (g.select_photo == true) {
                            $scope.gallaryPic.push(g);      //选择导入图片的数组
                            $scope.moveGalleryIds.push(g.id);
                        }
                    });
                    if (!p.select_photoAll) {
                        t++;
                    }
                    if (i == $scope.photos.length - 1) {
                        if (t == $scope.photos.length && $scope.gallaryPic.length == 0) {
                            $scope.delBar = false;
                        }
                    }
                });

            }
        };

        //显示图片选择图标以及删除栏
        $scope.showDeleteBtn = function () {
            $scope.selectAllGallery = !$scope.selectAllGallery;
            $scope.delBar = $scope.selectAllGallery;
            isShowSelectDot($scope.selectAllGallery);
        };

        function isShowSelectDot(flag) {
            angular.forEach($scope.photos, function (p) {
                p.select_photoAll = flag;
                angular.forEach(p.galleries, function (g) {
                    g.select_photo = flag;
                    if (flag) {
                        $scope.gallaryPic.push(g);       //选择导入图片的数组
                        $scope.moveGalleryIds.push(g.id);
                    } else {
                        $scope.gallaryPic = [];
                        $scope.moveGalleryIds = [];
                    }
                });
            });
        }

        //删除图库图片（数据库）
        $scope.deleteThis = function () {
            var del_str = '';
            angular.forEach($scope.photos, function (photo, index) {
                angular.forEach(photo.galleries, function (gallery, i) {
                    if (gallery.select_photo) {
                        del_str += gallery.id + ','
                    }
                })
            });
            if (!del_str) {
                swal({
                    title: $translate.instant("uploadContent.operationFailure"),
                    text: $translate.instant("uploadContent.atLeastPicture"),
                    imageUrl: Theme.sweetHintImg(),
                    timer: 1500,
                    showConfirmButton: false
                });
                return
            }
            swal({
                    title: $translate.instant("uploadContent.deleteThePicture"),
                    text: "",
                    imageUrl: Theme.sweetHintImg(),
                    showCancelButton: true,
                    confirmButtonText: $translate.instant("uploadContent.confirm"),
                    cancelButtonText: $translate.instant("uploadContent.cancel"),
                    closeOnConfirm: false
                },
                function (isConfirm) {
                    if (isConfirm) {
                        swal.close();
                        Gallery.delete({id: del_str}, function (res) {
                            if(res.status == 200){
                                swal({
                                    title: $translate.instant("uploadContent.deletedSuccess"),
                                    text: "",
                                    imageUrl: Theme.sweetSuccedImg(),
                                    timer: 2000,
                                    showConfirmButton: false
                                });
                                updatePic();
                            }else {
                                MessageService.error(res.message);
                            }
                        }, function () {
                            swal({
                                title: $translate.instant("uploadContent.deleteFailed"),
                                text: "",
                                imageUrl: Theme.sweetHintImg(),
                                timer: 2000,
                                showConfirmButton: false
                            });
                        });
                    } else {
                        console.log('取消');
                    }
                });
        };

        function isIphoneX() {
            return /iphone/gi.test(navigator.userAgent) && (screen.height == 812 && screen.width == 375)
            // return /iphone/gi.test(navigator.userAgent)
        }

        $scope.isIphoneX = isIphoneX();

        var windowH = $(window).height();
        localStorage.setItem('windowH', windowH);

        $(window).scroll(function () {
            if ($scope.isIphoneX) {
                var wh = $(window).height(); //页面可视化区域高度
                if (wh > windowH) {
                    $(".iphoneX-content").height(36);
                    $(".footer-del").height(96);
                } else {
                    $(".iphoneX-content").height(0);
                    $(".footer-del").height(60);
                }
            }

            //    向下滑动加载照片
            var scrollTop = $(window).scrollTop();
            var widH = $(window).height();
            var docH = $(document).height();
            if (scrollTop + widH == docH) {
                if (flag == true) {
                    loadMore();
                } else {
                    return;
                }
            } else {
                return;
            }
        })

        function loadFolders() {
            Folder.getAllByCondition({
                items: [{key: "type", op: "=", value: "Gallery"}],
                sort: ["id,asc"]
            }, function (resp) {
                if(resp.status == 200){
                    $scope.Folders = resp.data;
                }else {
                    MessageService.error(resp.message);
                }
            })
        }

        // 增加相册
        $scope.addFolder = function () {
            addAlertClass();
            $(".folder-footer").hide();
            swal({
                title: $translate.instant("uploadContent.createAlbum"),
                text: "",
                type: "input",
                showCancelButton: true,
                closeOnConfirm: false,
                confirmButtonText: $translate.instant("uploadContent.confirm"),
                cancelButtonText: $translate.instant("uploadContent.cancel"),
                animation: "slide-from-top",
                inputPlaceholder: $translate.instant("uploadContent.pleaseEnterTheAlbumName"),
            }, function (inputValue) {
                if (inputValue === false) {
                    $(".folder-footer").show();
                    removeAlertClass();
                    return false;
                }
                if (inputValue === "") {
                    swal.showInputError($translate.instant("uploadContent.pleaseEnterName"));
                    return false
                }
                if (inputValue.indexOf(" ") != -1) {
                    swal.showInputError($translate.instant("uploadContent.pleaseDoNotEnterSpaces"));
                    return false
                }
                Folder.save({
                    name: inputValue,
                    type: 'Gallery'
                }, function (resp) {
                    if(resp.status == 200){
                        $scope.Folders.push(resp.data);
                        $(".folder-footer").show();
                        swal.close();
                        removeAlertClass();
                    }else {
                        MessageService.error(resp.message);
                    }
                },function () {
                    swal.showInputError($translate.instant("uploadContent.pleaseEnterTheCorrectFileName"));
                })
            });
        }
        function addAlertClass() {
            setTimeout(function () {
                $(".sweet-alert").addClass('folder-alert');
                $(".sa-button-container").addClass('folder-alert-top')
                $(".sa-button-container .cancel").addClass('folder-alert-right')
            },200)
        }
        function removeAlertClass() {
            setTimeout(function () {
                $(".sweet-alert").removeClass('folder-alert');
                $(".sa-button-container").removeClass('folder-alert-top')
                $(".sa-button-container .cancel").removeClass('folder-alert-right')
            },200)
        }

        // 修改相册名
        $scope.editFolder = function () {
            addAlertClass();
            var len = $scope.folderIds.length;
            if (len > 1 || !len) {
                return
            }
            var folder = $scope.editFolderNameArr;
            $(".folder-footer").hide();
            $(".folder-footer").hide();
            swal({
                title: $translate.instant("galleryContent.rechristen"),
                text: "",
                type: "input",
                showCancelButton: true,
                closeOnConfirm: false,
                confirmButtonText: $translate.instant("uploadContent.confirm"),
                cancelButtonText: $translate.instant("uploadContent.cancel"),
                animation: "slide-from-top",
                inputPlaceholder: $translate.instant("uploadContent.pleaseEnterTheAlbumName"),
                inputValue: folder.name
            }, function (inputValue) {
                if (inputValue === false) {
                    $(".folder-footer").show();
                    removeAlertClass();
                    return false;
                }
                if (inputValue === "") {
                    swal.showInputError($translate.instant("uploadContent.pleaseEnterName"));
                    return false
                }
                if (inputValue.indexOf(" ") != -1) {
                    swal.showInputError($translate.instant("uploadContent.pleaseDoNotEnterSpaces"));
                    return false
                }
                if (inputValue === folder.name) {
                    swal.showInputError($translate.instant("uploadContent.PleaseEnterADifferentAlbumName"));
                    return false
                }
                Folder.update({
                    name: inputValue,
                    type: 'Gallery',
                    id: folder.id
                }, function (resp) {
                    if(resp.status == 200){
                        cancelSelectFolders();
                        folder.name = resp.data.name;
                        $(".folder-footer").show();
                        swal.close();
                        removeAlertClass();
                    }else {
                        MessageService.error(resp.message);
                    }
                },function () {
                    swal.showInputError($translate.instant("uploadContent.pleaseEnterTheCorrectFileName"));
                })
            });
        }

        /**
         * 单选
         * @param item
         * @param flag-----   true：相册     false:作品
         * @param y
         * @param d
         * @param i
         */
        $scope.selectSingle = function (item, flag, y, d, i) {
            if (!item) {
                $scope.selectOne = {
                    folderId: '',
                    selected: true
                };
                angular.forEach($scope.Folders, function (folder, index) {
                    folder.selected = false;
                });
                return
            }
            item.selected = !item.selected;
            // 移动状态中
            if ($scope.moveGallery) {

                $scope.selectOne = {
                    folderId: item.id,
                    selected: item.selected
                };

                angular.forEach($scope.Folders, function (folder, index) {
                    folder.selected = false;
                });
                item.selected = $scope.selectOne.selected;
                if(item.selected){
                    $scope.folderOne = angular.copy(item);
                }
                return
            }

            $scope.selectOne = {
                folderId: '',
                selected: false
            };
            //未选中时
            if (!item.selected) {
                // 相册
                if (flag) {
                    $scope.selectAllFolder = false;
                    var ind = $scope.folderIds.indexOf(item.id);
                    if (ind >= 0) {
                        $scope.folderIds.splice(ind, 1);
                    }
                } else {
                    $scope.selectAllAritle = false;
                    var ind = $scope.moveGalleryIds.indexOf(item.id);
                    if (ind >= 0) {
                        $scope.moveGalleryIds.splice(ind, 1);
                    }
                }
            } else {
                if (flag) {
                    $scope.folderIds.push(item.id);

                }else{
                    // 选中状态时的作品列表
                    // var arr = vm.yearDateList[y].data[d].items[i];
                    // $scope.moveGalleryIds.push(arr.id);
                }
            }
        }

        $scope.selectFolders = function (item) {
            item.selected = !item.selected;

            $scope.selectOne = {
                folderId: '',
                selected: false
            };
            //未选中时
            if (!item.selected) {
                $scope.selectAllFolder = false;
                var ind = $scope.folderIds.indexOf(item.id);
                if (ind >= 0) {
                    $scope.folderIds.splice(ind, 1);
                }

                $scope.editFolderNameArr = [];

            } else {
                $scope.folderIds.push(item.id);
                $scope.editFolderNameArr = item;
            }
        }

        function cancelSelectFolders() {
            $scope.folderIds = [];
            angular.forEach($scope.Folders, function (item) {
                item.selected = false;
            });
        }

        /**
         * 全选
         * @param flag-----  true：相册     false:作品
         */
        $scope.chooseAll = function (flag) {
            if (flag) {
                $scope.editFolderNameArr = [];
                $scope.selectAllFolder = !$scope.selectAllFolder;
                angular.forEach($scope.Folders, function (item, index) {
                    if ($scope.selectAllFolder) {
                        item.selected = true;
                        $scope.folderIds.push(item.id);
                    } else {
                        item.selected = false;
                        $scope.folderIds = [];
                    }
                });
            } else {
                $scope.selectAllGallery = !$scope.selectAllGallery;
                angular.forEach($scope.photos, function (photo) {
                    angular.forEach(photo.galleries, function (item) {
                        if ($scope.selectAllGallery) {
                            item.select_photo = true;
                            photo.select_photoAll = true
                        } else {
                            item.select_photo = false;
                            photo.select_photoAll = false
                        }
                    })
                })
            }

        }

        $scope.saveMove = function () {
            if (!$scope.selectOne.selected) {
                swal({
                    title: $translate.instant("uploadContent.operationFailure"),
                    text:  $translate.instant("uploadContent.pleaseSelectAnAlbum"),
                    imageUrl: Theme.sweetHintImg(),
                    timer: 1500,
                    showConfirmButton: false
                });
                return
            }
            angular.forEach($scope.Folders, function (folder, index) {
                folder.selected = false;
            });
            Gallery.moveFolder({
                galleries: $scope.moveGalleryIds,
                folderId: $scope.selectOne.folderId
            }, function (res) {
                if(res.status == 200){
                    $(".photo-show").hide();
                    $scope.currentNav = 'gallery';
                    $scope.gallaryPic = [];
                    $scope.moveGallery = false;
                    $scope.delBar = false;
                    $scope.moveGalleryIds = [];
                    if ($scope.selectOne.folderId) {
                        $scope.folderInside = true;
                        vm.indexNum = 0;
                        vm.galleryPage = [];
                        loadAll($scope.folderOne.id);
                    } else {
                        $scope.folderInside = false;
                        vm.galleryPage = [];
                        vm.indexNum = 0;
                        loadAll('isNull');
                    }
                    $scope.selectOne = {
                        folderId: '',
                        selected: false
                    };
                }else {
                    MessageService.error(res.message);
                }
            })
        }

        $scope.backTo = function () {
            $scope.currentNav = 'gallery';
            $scope.moveGallery = false;
            $scope.delBar = false;
            $scope.selectOne = {
                folderId: '',
                selected: false
            };
            angular.forEach($scope.Folders, function (folder) {
                folder.selected = false;
            });
            clearGalleryAdd();
        }

        //删除多个相册
        $scope.deleteFolders = function () {
            if (!$scope.folderIds.length) {
                swal({
                    title: $translate.instant("uploadContent.operationFailure"),
                    text: $translate.instant("uploadContent.atLeastAlbum"),
                    imageUrl: Theme.sweetHintImg(),
                    timer: 1500,
                    showConfirmButton: false
                });
                return
            }
            swal({
                    title: $translate.instant("uploadContent.deleteAlbumHint"),
                    text: "",
                    imageUrl: Theme.sweetHintImg(),
                    showCancelButton: true,
                    confirmButtonText: $translate.instant("uploadContent.confirm"),
                    cancelButtonText: $translate.instant("uploadContent.cancel"),
                    closeOnConfirm: false
                },
                function (isConfirm) {
                    if (isConfirm) {
                        swal.close();
                        Folder.batchDelete({ids: $scope.folderIds}, function (res) {
                            if(res.status == 200){
                                swal({
                                    title: $translate.instant("uploadContent.deletedSuccess"),
                                    text: "",
                                    imageUrl: Theme.sweetSuccedImg(),
                                    timer: 2000,
                                    showConfirmButton: false
                                });
                                loadFolders();
                                cancelSelectFolders();
                            }else {
                                MessageService.error(res.message);
                            }
                        }, function () {
                            swal({
                                title: $translate.instant("uploadContent.deleteFailed"),
                                text: "",
                                imageUrl: Theme.sweetHintImg(),
                                timer: 2000,
                                showConfirmButton: false
                            });
                        });
                    } else {
                        console.log('取消');
                    }
                });
        };

        $scope.moveToFolder = function () {
            if (!$scope.gallaryPic.length) {
                swal({
                    title: $translate.instant("uploadContent.moveFailure"),
                    text: $translate.instant("uploadContent.atLeastPicture"),
                    imageUrl: Theme.sweetHintImg(),
                    timer: 2000,
                    showConfirmButton: false
                });
                return
            }
            $scope.moveGallery = true;
            $scope.folderInside = false;
            $scope.currentNav = 'folder';
        }

        function clearGalleryAdd() {
            // $scope.gallaryPic = [];
            $scope.moveGalleryIds = [];
            $scope.selectAllGallery = false;
            angular.forEach($scope.photos, function (photo) {
                photo.select_photoAll = false
                angular.forEach(photo.galleries, function (item) {
                    item.select_photo = false;
                })
            })
        }

        // 进入某一相册中
        $scope.showFolderContent = function (folder) {
            if (folder.selected) {
                folder.selected = false;
                $scope.selectAllGallery = false;
                $scope.selectOne = {
                    folderId: '',
                    selected: false
                };

                $scope.selectAllFolder = false;
                var ind = $scope.folderIds.indexOf(folder.id);
                if (ind >= 0) {
                    $scope.folderIds.splice(ind, 1);
                }
                $scope.editFolderNameArr = [];
                return
            }
            $scope.folderInside = true;
            $scope.currentNav = 'gallery';
            $scope.folderOne = angular.copy(folder);
            vm.indexNum = 0;
            vm.galleryPage = [];
            $(".photo-show").hide();
            loadAll(folder.id);
        }
        // 从某一相册出去
        $scope.hideFolderContent = function () {
            $scope.folderInside = false;
            $scope.moveGallery = false;
            $scope.currentNav = 'folder';
            $scope.folderOne = {};
            $scope.selectAllGallery = $scope.delBar = false;
        }
        // 图片库nav 点击
        $scope.galleryNavSel = function () {
            vm.galleryPage = [];
            $(".photo-show").hide();
            $scope.currentNav = 'gallery';
            $(".folder-editbar").addClass('hide1');
            $(".arrow-btn").removeClass('folder-arrow-up');
            angular.forEach($scope.Folders, function (folder, index) {
                folder.selected = false;
            });
            $scope.folderIds = [];
            $scope.folderClick = false;
            vm.indexNum = 0;
            loadAll('isNull');
        }

        // 图片库nav 点击
        $scope.folderNavSel = function () {
            vm.galleryPage = [];
            $scope.currentNav = 'folder';
            $scope.selectAllGallery = $scope.delBar = false;
        }

        // 上传图片后更新图片库/相册
        function updatePic() {
            if ($scope.folderOne && $scope.folderOne.id) {
                $scope.showFolderContent($scope.folderOne);
            } else {
                $scope.folderInside = false;
                $scope.currentNav = 'gallery';
                $scope.moveGallery = false;
                vm.galleryPage = [];
                vm.indexNum = 0;
                loadAll('isNull');
            }
        }

    }

    function dateFilter() {
        return function (input) {
            var year = input.split('年')[0];
            var mon = input.split('年')[1].split('月')[0];
            var day = input.split('年')[1].split('月')[1].split('日')[0];
            if (mon < 10) {
                mon = '0' + mon;
            }
            if (day < 10) {
                day = '0' + day;
            }
            input = year + '年' + mon + '月' + day + '日';
            return input;
        }
    }

    // 判断是否重复
    function checkExist(list, obj) {
        if (list == null || list.length == 0) {
            return true;
        }
        for (var i = 0; i < list.length; i++) {
            if (list[i].getFullYear() == obj.getFullYear() &&
                list[i].getMonth() == obj.getMonth() &&
                list[i].getDate() == obj.getDate()) {
                return false;
            }
        }
        return true;
    }


})();

(function () {
    'use strict';

    var uploadImage2 = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/gallery/components/uplpadImage.html',
        controllerAs: 'userCtrl',
        bindings: {
            photoAll:'=',
            folderId:'=',
            qiniuId:'=',
            uploadPhotoItem:'=',
            aid:'='
        },

        controller: ['$scope', '$stateParams', '$q', '$localStorage', 'Qinius','QiniuToken','PlatformWechatSetting', 'Customer', 'WxJS', 'Theme', 'Gallery','SweetAlert','$rootScope','ImageService','UidService','Convert','$timeout','$state','CommonService',
            function ($scope, $stateParams, $q, $localStorage, Qinius, QiniuToken, PlatformWechatSetting, Customer, WxJS, Theme, Gallery, SweetAlert,$rootScope,ImageService,UidService,Convert,$timeout,$state,CommonService) {
                var vm = this;
                // 成功多少张
                console.log(vm.folderId,'folder');
                vm.indd = 0;
                vm.errorImageArr = [];
                vm.duplicateList = [];
                vm.filesLength = 0;
                vm.detectFaces = $state.current.name !== "editorPhotoBothEdit" && $state.current.name !== 'editorPhotoBoth'
                var repeatCount = 0;
                var cancelledCount = 0;
                var localIdsArr = [];
                vm.uploadFiles = []
                if (window.location.href.indexOf("?") > -1) {
                    var r = window.location.href.split('?')[1];
                    var typeFlag = r.split('&')[0].split('=')[1];
                    var distinguish = decodeURIComponent(typeFlag);
                    if (distinguish == 'weChatApplet' || distinguish == 'weChatAppletMake') {
                        vm.uploadType = 'wechat';
                    }else if(distinguish == 'toutiaoApp'){
                        vm.uploadType = 'byteDance';
                    }else if(distinguish == 'alipayApp'){
                        vm.uploadType = 'ali';
                    }
                }else{
                    vm.uploadType = 'wechat';
                }
                function addAlertClass() {
                    setTimeout(function () {
                        $(".sweet-alert").addClass('folder-alert').addClass('whiteBg');
                    })
                }
                function removeAlertClass() {
                    setTimeout(function () {
                        $(".sweet-alert").removeClass('folder-alert').removeClass('whiteBg');
                        $(".sa-button-container").removeClass('folder-alert-top')
                        $(".sa-button-container .cancel").removeClass('folder-alert-right')
                    },200)
                }

                //生成缩略图
                function dataURLtoBlob(dataurl) {
                    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
                    while (n--) {
                        u8arr[n] = bstr.charCodeAt(n);
                    }
                    return new Blob([u8arr], {type: mime});
                }
                if (wx) {
                    var url = window.location.hash && window.location.href.slice(0, -window.location.hash.length) || window.location.href;
                    // var url = "https://stage.fotavatar.com/10/544/gallery/uploading/1230814023448763";
                    WxJS.get({url: url}, function (config) {
                        wx.config({
                            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                            appId: config.data.appId, // 必填，公众号的唯一标识
                            timestamp: config.data.timestamp, // 必填，生成签名的时间戳
                            nonceStr: config.data.nonceStr, // 必填，生成签名的随机串
                            signature: config.data.signature,// 必填，签名，见附录1
                            jsApiList: ['chooseImage', 'previewImage', 'uploadImage','getLocalImgData'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                        });
                        wx.ready(function () {
                            // console.log('editor: wechat api ready!');
                        });
                        wx.error(function (res) {
                            // alert("wx.error: "+res.errMsg)
                            // console.log(res);
                        });
                    }, function (res) {
                    });
                }

                $scope.domains = Qinius.getDomain();
                var unsubQiniuToken = QiniuToken.subscribe('tokenWithPolicy', {"mimeLimit":"image/jpeg;image/png"}, function (token) {
                    vm.token = token;
                });
                $scope.$on('$destroy', unsubQiniuToken);

                vm.storeId = $stateParams.storeId;
                vm.platformSetting = PlatformWechatSetting.get();
                vm.customer = Customer.current();
                $q.all([$scope.domains.$promise]).then(function(){
                    $scope.domain = 'https://' + $scope.domains.domains[0] + '/';
                    // token过期 — QiniuToken 单例自动刷新
                    //安卓
                    $scope.$on('clickAndroidUpload', function(event, args) {
                        vm.indd = 0;
                        if(vm.uploadType=='ali'){
                            ap.chooseImage({
                                sourceType: ['camera', 'album'],
                                sizeType: ['original'],
                                count: 9
                            }, function(res){
                                var files = []
                                for (var i = 0; i < res.apFilePaths.length; i++) {
                                    var tempFile = res.tempFiles[i];
                                    var fileName = tempFile.name || tempFile.fileName || tempFile.path && tempFile.path.split('/').pop() || '';
                                    files.push({
                                        localId:res.apFilePaths[i],
                                        blobCover:res.apFilePaths[i],
                                        imgSize:tempFile.size,
                                        fileName: fileName || 'IMG_' + Date.now() + '_' + i + '.jpg'
                                    })
                                }
                                vm.indd = 0;
                                vm.errorImageArr = [];
                                vm.duplicateList = [];
                                vm.filesLength = files.length;
                                $(".save-pages2").removeClass('hide1');

                                angular.forEach(files,function (file1,index1) {
                                    (function (file,index) {
                                        toBase64(file,index)
                                    })(file1,index1)
                                })
                                function toBase64(file,i) {
                                    var image = new Image();
                                    image.crossOrigin = 'anonymous';
                                    image.size = file.imgSize
                                    image.onload = function() {
                                        var canvas = document.createElement('CANVAS');
                                        var context = canvas.getContext('2d');
                                        canvas.height = image.height;
                                        canvas.width = image.width;
                                        context.drawImage(image, 0, 0);
                                        try {
                                            var dataURL = canvas.toDataURL('image/jpeg');
                                            file.blobCover = dataURL;
                                            Convert.downloadImg4AliH5AngUpload7Niu({
                                                base64:dataURL,
                                                type:"gallery"
                                            },function (res) {
                                                uploadGalleries(file, res, i)
                                            })
                                        } catch (e) {
                                            if(i==files.length-1){
                                                updatePic()
                                            }
                                        }
                                        canvas = null;
                                    }
                                    image.src = file.localId;
                                }

                                function uploadGalleries(file, res, i) {
                                    var originalFileName = file.fileName || ('IMG_' + Date.now() + '_' + i + '.jpg');
                                    var params = {
                                        articleId:vm.aid,
                                        identifiers: res.message,
                                        provider: "QINIU",
                                        fileName: originalFileName,
                                        folderId: vm.folderId ? vm.folderId : '',
                                        check: true,
                                        type: vm.uploadType,
                                        hash:res.hash,
                                        detectFaces:vm.detectFaces
                                    };
                                    Gallery.upload(params, function (resp) {
                                        if (resp.data.cancelled) {
                                            cancelledCount += 1;
                                        }

                                        file.loading = true;
                                        file.usenum = 0;
                                        file.id = resp.data.id;
                                        file.width = resp.data.width;
                                        file.height = resp.data.height;
                                        file.imgsize = resp.data.imgSize;
                                        file.cancelled = resp.data.cancelled;
                                        file.identifier = resp.data.identifier;
                                        if(resp.data.duplicate){
                                            vm.duplicateList.push(resp)
                                        }
                                        vm.uploadFiles.push(resp)
                                        vm.indd++;
                                        // 上传成功
                                        if (files.length == (vm.indd + vm.errorImageArr.length)) {
                                            $timeout(function () {
                                                $scope.loadingAllSuccess = true;
                                                updatePic();
                                            },500);
                                        }

                                    },function () {
                                        vm.errorImageArr.push(file);
                                        if (files.length == (vm.indd + vm.errorImageArr.length)) {
                                            $timeout(function () {
                                                $scope.loadingAllSuccess = true;
                                                updatePic();
                                            },500);
                                        }
                                    })
                                }
                            });
                        }else{

                            /********************************************
                             * 微信端上传图片功能
                             * 使用原生 <input type="file" multiple> 替代 wx.chooseImage + wx.getLocalImgData
                             * 优势：1) 可获取原始文件名  2) 可获取原图数据（不经微信JSSDK压缩）
                             * 与 iOS 端 uploadImageMutiple 流程保持一致
                             ********************************************/
                            vm.indd = 0;  //成功的张数
                            vm.errorImageArr = [];  //错误的张数

                            // 创建隐藏的 file input 用于微信端选图
                            var wechatFileInput = document.createElement('input');
                            wechatFileInput.type = 'file';
                            wechatFileInput.accept = 'image/png, image/jpeg, image/jpg, .heic, .heif, .livp';
                            wechatFileInput.multiple = true;
                            wechatFileInput.style.display = 'none';
                            wechatFileInput.id = 'wechatUploadInput';
                            document.body.appendChild(wechatFileInput);
                            console.log(1111111);
                            wechatFileInput.onchange = function(event) {
                                $timeout(function() {
                                    $scope.bigSizeTip = false;
                                    var files = [];
                                    cancelledCount = 0;
                                    var rawFiles = event.target.files;
                                    for (var i = 0; i < rawFiles.length; i++) {
                                        var file = rawFiles[i];
                                        // 过滤非图片文件
                                        var lowerName = (file.name || '').toLowerCase();
                                        var isValidImage = file.type === 'image/png' || file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/heic';
                                        var isHeicExt = !file.type && (lowerName.endsWith('.heic') || lowerName.endsWith('.heif'));
                                        var isLivp = !file.type && lowerName.endsWith('.livp');
                                        if (isValidImage || isHeicExt || isLivp) {
                                            file.usenum = 0;
                                            file.percent = 0;
                                            file.blobCover = URL.createObjectURL(file);
                                            files.push(file);
                                        }
                                    }

                                    if (files.length === 0) {
                                        // 清理临时 input
                                        document.body.removeChild(wechatFileInput);
                                        return;
                                    }

                                    $(".save-pages2").removeClass('hide1');

                                    // 检查图片大小
                                    vm.higherSize = [];
                                    angular.forEach(files, function (item, index) {
                                        item.imgSize = item.size;
                                        if (item.size / 1024 > 51200) {
                                            vm.higherSize.push(item);
                                        }
                                    });

                                    // 系统检测到大于20M的图片
                                    if (vm.higherSize.length > 0) {
                                        $scope.bigSizeTip = true;
                                        $scope.higherSizeLen = vm.higherSize.length;
                                        $scope.$digest();
                                    } else {
                                        if (files.length > 0) {
                                            filterUpload(files);
                                        }
                                    }

                                    $scope.filterBigSize = function () {
                                        $scope.bigSizeTip = false;
                                        files = files.filter(function (item, index) {
                                            return item.size / 1024 < 51200;
                                        });
                                        if (files.length === 0) {
                                            updatePic();
                                        } else {
                                            filterUpload(files);
                                        }
                                    };

                                    // 清理临时 input
                                    try {
                                        document.body.removeChild(wechatFileInput);
                                    } catch (e) {}
                                });
                            };

                            // 触发文件选择
                            wechatFileInput.click();
                        }
                    });

                    /**
                     * iOS上传
                     * 使用自带的上传图片功能  不调用微信的jssdk
                     * 非调用微信公众号上传图片 无9张限制 可多张上传 上传到七牛  并且可以返回路径在页面显示
                     * @param $event
                     */
                    window.uploadImageMutiple = function ($event) {
                        $timeout(function () {
                            uploadImageMutipleCb($event)
                        })
                    };
                });


                function uploadImageMutipleCb($event) {
                    $scope.bigSizeTip = false;
                    var files = [];
                    cancelledCount = 0;
                    for (var i = 0; i < $event.target.files.length; i++) {
                        var file = $event.target.files[i];
                        // image/png, image/jpeg, image/jpg, image/heic, .heic, .heif, .livp
                        var lowerName = (file.name || '').toLowerCase();
                        var isValidImage = file.type === 'image/png' || file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/heic';
                        var isHeicOrLivp = !file.type && (lowerName.endsWith('.heic') || lowerName.endsWith('.heif') || lowerName.endsWith('.livp'));
                        if (isValidImage || isHeicOrLivp) {
                            file.usenum = 0;
                            file.percent = 0;
                            file.blobCover = URL.createObjectURL(file);
                            files.push(file)
                        }
                    }
                    if(files.length == 0){
                        return
                    }

                    vm.higherSize = [];
                    angular.forEach(files, function (item, index) {
                        item.imgSize = item.size;
                        if (item.size / 1024 > 51200) {
                            vm.higherSize.push(item);
                        }
                    });
                    //系统检测到{{}}张大于20M的图片，已自动过滤\n请压缩后再尝试上传！
                    if (vm.higherSize.length > 0) {
                        $scope.bigSizeTip = true;
                        $scope.higherSizeLen = vm.higherSize.length;
                        $scope.$digest();
                    } else {
                        filterUpload(files);
                    }

                    $scope.filterBigSize = function () {
                        $scope.bigSizeTip = false;
                        files = files.filter(function (item, index) {
                            return item.size / 1024 < 51200;
                        });
                        if (files.length == 0) {
                            updatePic();
                        } else {
                            filterUpload(files);
                        }
                    }
                }

                function filterUpload(files) {
                    $(".save-pages2").removeClass('hide1');
                    // 预处理 .livp 文件：解包提取 HEIC 图片后替换，后续流程无感知
                    extractLivpFiles(files).then(function(processedFiles) {
                        if (processedFiles.length === 0) {
                            $(".save-pages2").addClass('hide1');
                            return;
                        }
                        asyncUpload(processedFiles);
                    });
                }

                // 遍历文件列表，将 .livp 文件解包为真实图片文件，非 .livp 文件原样返回
                function extractLivpFiles(files) {
                    var promises = [];
                    for (var i = 0; i < files.length; i++) {
                        var file = files[i];
                        var fileName = (file.name || '').toLowerCase();
                        if (fileName.endsWith('.livp')) {
                            promises.push(_extractHeicFromLivp(file));
                        } else {
                            promises.push(Promise.resolve(file));
                        }
                    }
                    return Promise.all(promises).then(function(results) {
                        return results.filter(function(f) { return f !== null; });
                    });
                }

                // 从 .livp 压缩包中提取 HEIC 图片，保留原始 .livp 文件名
                function _extractHeicFromLivp(file) {
                    return JSZip.loadAsync(file).then(function(zip) {
                        var imageFileName = null;
                        zip.forEach(function(relativePath, zipEntry) {
                            if (!zipEntry.dir && !imageFileName) {
                                var lowerName = relativePath.toLowerCase();
                                if (lowerName.endsWith('.heic') || lowerName.endsWith('.heif') ||
                                    lowerName.endsWith('.jpg') || lowerName.endsWith('.jpeg') ||
                                    lowerName.endsWith('.png')) {
                                    imageFileName = relativePath;
                                }
                            }
                        });

                        if (!imageFileName) {
                            console.warn('No image found in .livp package:', file.name);
                            return null;
                        }

                        return zip.file(imageFileName).async('blob').then(function(blob) {
                            // 提取内部图片的扩展名
                            var internalExt = '';
                            var internalLower = imageFileName.toLowerCase();
                            if (internalLower.endsWith('.heic')) internalExt = '.heic';
                            else if (internalLower.endsWith('.heif')) internalExt = '.heif';
                            else if (internalLower.endsWith('.jpg') || internalLower.endsWith('.jpeg')) internalExt = '.jpg';
                            else if (internalLower.endsWith('.png')) internalExt = '.png';
                            // 用原始 .livp 文件名替换扩展名
                            var newName = file.name.replace(/\.livp$/i, '') + internalExt;
                            var newFile = new File([blob], newName, { type: blob.type || 'image/heic' });
                            newFile.usenum = 0;
                            newFile.percent = 0;
                            newFile.blobCover = URL.createObjectURL(newFile);
                            newFile.imgSize = blob.size;
                            return newFile;
                        });
                    }).catch(function(err) {
                        console.error('Failed to extract .livp:', file.name, err);
                        return null;
                    });
                }

                function asyncUpload(files) {
                    vm.uploadPhotoItem = files;
                    vm.indd = 0;
                    vm.errorImageArr = [];
                    vm.duplicateList = [];
                    vm.uploadFiles = [];  // 重置已上传文件列表，避免旧数据残留
                    $rootScope.$broadcast('uploadStart',true);
                    vm.filesLength = vm.uploadPhotoItem.length;
                    qiniuUpload(vm.uploadPhotoItem[0], vm.uploadPhotoItem, 0);

                }

                /**
                 * 上传前先补齐图片真实宽高：
                 * width/height 不是 File 原生属性，可能是调用方没赋值，也可能异步还没回来，
                 * 直接判断会变成 undefined > 30000 = false，导致大图漏判。
                 * 这里统一走 缓存 -> Image 解码 -> 文件头解析 三级兜底，拿到宽高后再上传。
                 */
                function qiniuUpload(file, files, index_) {
                    var startUpload = function () {
                        doQiniuUpload(file, files, index_);
                    };
                    try {
                        CommonService.readImageDimensions(file).then(function (dim) {
                            if (dim && dim.width > 0 && dim.height > 0) {
                                file.width = dim.width;
                                file.height = dim.height;
                            }
                            startUpload();
                        }, startUpload);
                    } catch (e) {
                        // 兜底：读取宽高异常时不能阻塞上传，仅按文件大小判断
                        startUpload();
                    }
                }

                function doQiniuUpload(file, files, index_) {
                    var formData = new FormData();
                    formData.append('file', file);
                    formData.append('unique_names', false);
                    var _key ="gallery-" + UidService.get()
                    // 超过20M / 单边超过30000 / 超过1.5亿像素 增加xl大图标识
                    // 宽高实在拿不到时（返回0）由文件大小兜底，避免 NaN 导致判断失效
                    var fileWidth = Number(file.width) || 0;
                    var fileHeight = Number(file.height) || 0;
                    var isXL = CommonService.isExtraLargeImage(file);
                    console.log('[upload]' + file.name, 'size:' + (file.size || 0), 'width:' + fileWidth, 'height:' + fileHeight, 'isXL:' + isXL);
                    if(isXL){
                        _key += '-xl'
                    }
                    formData.append('key', _key);
                    formData.append('token', vm.token);
                    file.percent = 20;

                    var reader = new FileReader();
                    reader.readAsArrayBuffer(file)
                    reader.onloadend = function (e) {
                        formData.append('crc32', CRC32.buf(new Uint8Array(this.result)));
                        return $.ajax({
                            // cache: true,
                            type: "POST",
                            url: 'https://upload.qiniup.com/',
                            data: formData,
                            async: true,
                            contentType: false,
                            processData: false,
                            xhr:function(){
                                var myXhr = $.ajaxSettings.xhr();
                                if(myXhr.upload){ // check if upload property exists
                                    myXhr.upload.addEventListener('progress',function(e){
                                        var loaded = e.loaded;                  //已经上传大小情况
                                        var total = e.total;                      //附件总大小
                                        var percent = Math.floor(100*loaded/total)+"%";     //已经上传的百分比
                                        file.percent = parseInt(100*loaded/total)/2;
                                    }, false); // for handling the progress of the upload
                                }
                                return myXhr;
                            },
                            success: function (data) {
                                vm.uploadPhotoItem[index_].blobCover = $scope.domain +data.key + '?imageView2/1/w/150/h/150';
                                file.percent = 80;
                                if (files.length > Number(index_) + 1) {
                                    var f = files[index_ + 1];
                                    qiniuUpload(f, files, index_ + 1);
                                }
                                assignGalleries(file, files, index_, data)
                            },
                            error: function (request) {
                                file.state = 'error';
                                vm.errorImageArr.push(files[index_]);
                                //最后一个失败了的话
                                if (files.length == (vm.indd + vm.errorImageArr.length)) {
                                    $timeout(function () {
                                        $scope.loadingAllSuccess = true;
                                        updatePic();
                                    })
                                }else{
                                    if (files.length > Number(index_) + 1) {
                                        var f = files[index_ + 1];
                                        qiniuUpload(f, files, index_ + 1);
                                    }
                                }
                            }
                        });
                    }
                }

                function serviceUpload(data, file, callback) {
                    // 兜底：若 file.name 为空（微信JSSDK限制导致），生成时间戳文件名
                    var finalFileName = file.name || ('IMG_' + (function(){
                        var now = new Date();
                        var pad = function(n){ return n < 10 ? '0' + n : '' + n; };
                        return now.getFullYear().toString() + pad(now.getMonth()+1) + pad(now.getDate())
                            + '_' + pad(now.getHours()) + pad(now.getMinutes()) + pad(now.getSeconds());
                    })() + '.jpg');
                    Gallery.upload({
                        identifiers: data.key,
                        provider: "QINIU",
                        fileName: finalFileName,
                        imgSize: file.size,
                        width: file.width,
                        height: file.height,
                        folderId: vm.folderId ? vm.folderId : '',
                        check: true,
                        type: vm.uploadType,
                        articleId:vm.aid,
                        hash:data.hash,
                        detectFaces:vm.detectFaces
                    }, function (resp) {
                        file.percent = 100;
                        file.id = resp.data.id;
                        file.cancelled = resp.data.cancelled;
                        vm.indd++;
                        file.state = 'success';
                        $timeout(function () {
                            if (!resp.data.cancelled) {
                                if(vm.photoAll){
                                    vm.photoAll.push(resp.data)
                                }
                                if(vm.qiniuId){
                                    resp.data.identifier = $scope.domain +resp.data.identifier;
                                    resp.data.usenum = 0;
                                    resp.data.loading = 0;
                                    vm.qiniuId.push(resp.data)
                                }
                                vm.uploadFiles.push(resp.data)
                            }
                            if(resp.data.duplicate){
                                vm.duplicateList.push(resp.data)
                            }
                            if(callback){callback()}

                        },1000)
                    }, function (error) {
                        file.state = 'error';
                        vm.errorImageArr.push(file);
                        if(callback){callback()}
                    });
                }


                function assignGalleries(file, files, index_, data) {
                    serviceUpload(data, file,function () {
                        if (files.length == (vm.indd + vm.errorImageArr.length)) {
                            $timeout(function () {
                                $scope.loadingAllSuccess = true;
                                updatePic(files);
                            },500)
                        }else{
                            // if (files.length > Number(index_) + 1) {
                            //     var f = files[index_ + 1];
                            //     qiniuUpload(f, files, index_ + 1);
                            // }
                        }
                    });
                }
                $scope.reUpload = function () {
                    $scope.errorImageArr_.forEach(function (item) {
                        item.percent = 0;
                        item.state = null;
                    })
                    asyncUpload($scope.errorImageArr_);
                    $scope.errorImageHide();
                    $(".save-pages2").removeClass('hide1');
                }
                // 上传图片后更新图片库/文件夹
                function updatePic(files) {
                    $scope.isLookErrorImages = false;
                    if (vm.duplicateList && vm.duplicateList.length > 0) {
                        if(files.length == (vm.indd + vm.errorImageArr.length)){
                            $timeout(function(){
                                $rootScope.$broadcast('duplicateImages', angular.copy(vm.duplicateList),true,files,vm.uploadFiles);
                            })
                        }
                    }else{
                        $rootScope.$broadcast('uoloadFinished',true,files,vm.uploadFiles);
                    }
                    vm.uploadPhotoItem = [];
                    $(".save-pages2").addClass('hide1');
                    vm.indd = 0;
                    vm.filesLength = 0;
                    $timeout(function () {
                        //如果没有上传错误图片，关闭提示框
                        if(vm.errorImageArr.length === 0){
                            $scope.loadingAllSuccess = false;
                            if(!$scope.isLookErrorImages){
                                vm.errorImageArr = [];
                            }
                        }
                    },2000)

                }
                //关闭上传错误弹窗
                $scope.closeErrorMoadl = function (){
                    var target = event.target;
                    if($(target).hasClass("z-modal") || $(target).hasClass("close-btn") || $(target).hasClass("close-icon1")){
                        $scope.loadingAllSuccess = false;
                    }

                }
                //上传进度获取
                $scope.schedule = function () {
                    if(vm.filesLength > 0){
                        return Number(vm.indd)+vm.errorImageArr.length + '/' + vm.filesLength
                    }
                }
                $scope.errorImageArrCb = function () {
                    return vm.errorImageArr.length
                }
                $scope.successImageArrCb = function () {
                    return vm.indd
                }
                $scope.isLookErrorImages = false;
                $scope.lookErrorImages = function () {
                    $scope.isLookErrorImages = true;
                    $scope.loadingAllSuccess = false;
                    $scope.errorImageArr_ = vm.errorImageArr;
                    $scope.errorImageArr_.forEach(function (item) {
                        item.percent = 0;
                    })
                };
                $scope.errorImageHide = function () {
                    $scope.isLookErrorImages = false;
                }

                function threeInfo(item){
                    $scope.threeError = true;
                    $scope.threeErrorText=item;
                    $timeout(function () {
                        $scope.threeError = false;
                        $scope.threeErrorText="";
                    },1500)
                }
            }]
    };

    angular
        .module('editorApp')
        .component('uploadImage2', uploadImage2);
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });  
        $stateProvider.state('templateManagement', { abstract: true, parent: 'app'}); 
    }
})();

(function () {
    'use strict';

    var trimboxPop = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/components/trimbox-pop.html',
        controllerAs: 'vm',
        bindings: {
        },
        controller: ['$scope',
            function ($scope) {
                var vm = this;
                var lsTrimboxPop = localStorage.getItem('trimbox-pop');
                vm.isTrimbox = lsTrimboxPop && lsTrimboxPop == "false" ? false : true;
                vm.checkbox = false;
                $scope.checkbox = function () {
                    vm.checkbox = !vm.checkbox;
                }
                $scope.save = function () {
                    vm.isTrimbox = false;
                    if(vm.checkbox){
                        localStorage.setItem('trimbox-pop', false);
                    }else{
                        localStorage.setItem('trimbox-pop', true);
                    }
                }
            }
        ]
    };

    angular
        .module('editorApp')
        .component('trimboxPop', trimboxPop);
})();


(function () {
    'use strict';

    var threePreview4 = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/components/three-preview4.html',
        // controller: 'articlePreviewController',
        controllerAs: 'vm',
        bindings: {
            height: '<',
            width: '<',
            moulds: '<',
            modelPath: '<',
            modelBlendents: '<',
            modelData: '<',
            modelBlendentUuid: '<',
            pages: '<',
            source: '<',
            onChange:"&"
        },
        controller: ['$timeout','$scope',
            function ($timeout, $scope) {
                var vm = this;
                vm.viewTab = 'Three';
                vm.mouldIndex = 0;
                vm.isLoading = true;
                vm.$onInit = function(){
                    if(!vm.width){vm.width = $(window).width()}
                    if(!vm.height){vm.height = $(window).width()}
                }
                vm.$onChanges = function(data) {
                    if (data.height&&data.height.currentValue) {
                        vm.height = data.height.currentValue;
                    }
                    if (data.width&&data.width.currentValue) {
                        vm.width = data.width.currentValue;
                    }
                    if (data.moulds&&data.moulds.currentValue) {
                        vm.moulds = data.moulds.currentValue;
                    }
                    if (data.modelPath&&data.modelPath.currentValue) {
                        vm.modelPath = data.modelPath.currentValue;
                    }
                    if (data.modelBlendents&&data.modelBlendents.currentValue) {
                        vm.modelBlendents = data.modelBlendents.currentValue;
                    }
                    if (data.modelData&&data.modelData.currentValue) {
                        vm.modelData = data.modelData.currentValue;
                    }
                    if (data.modelBlendentUuid&&data.modelBlendentUuid.currentValue) {
                        vm.modelBlendentUuid = data.modelBlendentUuid.currentValue;
                    }
                    if (data.pages&&data.pages.currentValue) {
                        vm.pages = null;
                        vm.isUpdate = false;
                        $timeout(function () {
                            vm.pages = data.pages.currentValue;
                        })
                    }
                };

                $scope.viewTabCb = function () {
                    vm.viewTab = 'Two';
                }
                $scope.flipOver=function (item) {
                    if(item == 'prev' && vm.mouldIndex>0){
                        vm.mouldIndex--
                        vm.isLoading = false;
                        $timeout(function () {
                            vm.isLoading = true;
                        })
                    }
                    if(item == 'next' && vm.moulds.length-1){
                        vm.mouldIndex++
                        vm.isLoading = false;
                        $timeout(function () {
                            vm.isLoading = true;
                        })
                    }
                }
            }
        ]
    };

    angular
        .module('editorApp')
        .component('threePreview4', threePreview4);
})();

(function () {
    'use strict';

    var threePreview3 = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/components/three-preview3.html',
        // controller: 'articlePreviewController',
        controllerAs: 'vm',
        bindings: {
            height: '<',
            width: '<',
            moulds: '<',
            modelPath: '<',
            modelBlendents: '<',
            modelData: '<',
            modelBlendentUuid: '<',
            pages: '<',
            onChange:"&"
        },
        controller: ['$timeout','$scope',
            function ($timeout, $scope) {
                var vm = this;
                vm.viewTab = 'Three';
                vm.$onInit = function(){
                    if(!vm.width){vm.width = $(window).width()}
                    if(!vm.height){vm.height = $(window).height()}
                }
                vm.$onChanges = function(data) {
                    if (data.height&&data.height.currentValue) {
                        vm.height = data.height.currentValue;
                    }
                    if (data.width&&data.width.currentValue) {
                        vm.width = data.width.currentValue;
                    }
                    if (data.moulds&&data.moulds.currentValue) {
                        vm.moulds = data.moulds.currentValue;
                    }
                    if (data.modelPath&&data.modelPath.currentValue) {
                        vm.modelPath = data.modelPath.currentValue;
                    }
                    if (data.modelBlendents&&data.modelBlendents.currentValue) {
                        vm.modelBlendents = data.modelBlendents.currentValue;
                    }
                    if (data.modelData&&data.modelData.currentValue) {
                        vm.modelData = data.modelData.currentValue;
                    }
                    if (data.modelBlendentUuid&&data.modelBlendentUuid.currentValue) {
                        vm.modelBlendentUuid = data.modelBlendentUuid.currentValue;
                    }
                    if (data.pages&&data.pages.currentValue) {
                        vm.pages = data.pages.currentValue;
                    }
                    vm.isUpdate = false;
                    $timeout(function () {
                        vm.isUpdate = true;
                    })
                };

                $scope.viewTabCb = function () {
                    vm.viewTab = 'Two';
                    swiper1()
                }
                vm.isWebMaxThree = false;
                function swiper1() {
                    vm.mouldIndex = 0;
                    if(vm.moulds&&vm.moulds.length>0){
                        $timeout(function () {
                            var webMaxSwiper = new Swiper('.swiper-container-webmin', {
                                slidesPerView: 5,
                                spaceBetween: 16,
                                navigation: {
                                    nextEl: '.swiper-button-next-webmin',
                                    prevEl: '.swiper-button-prev-webmin',
                                },
                                on: {
                                    init: function(swiper){
                                        vm.mouldIndex = this.activeIndex;
                                        console.log(vm.mouldIndex)
                                        webMaxThreeInit()
                                        $scope.$apply();
                                    }
                                },
                            });
                        })
                    }
                }
                $scope.webMaxSwiper = function (item) {
                    if(item==='prev'){
                        if(vm.mouldIndex>0){
                            vm.mouldIndex--
                        }
                    } else if(item==='next'){
                        if(vm.mouldIndex<vm.moulds.length-1){
                            vm.mouldIndex++
                        }
                    }else{
                        vm.mouldIndex = item;
                    }
                    webMaxThreeInit()
                }
                function webMaxThreeInit(){
                    vm.isWebMaxThree = false;
                    $timeout(function () {
                        vm.isWebMaxThree = true;
                    })
                }
            }
        ]
    };

    angular
        .module('editorApp')
        .component('threePreview3', threePreview3);
})();

(function () {
    'use strict';

    var threePreview2 = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/components/three-preview2.html',
        // controller: 'articlePreviewController',
        controllerAs: 'vm',
        bindings: {
            height: '<',
            width: '<',
            moulds: '<',
            modelPath: '<',
            modelBlendents: '<',
            modelData: '<',
            modelBlendentUuid: '<',
            pages: '<',
            onChange:"&"
        },
        controller: ['$timeout','$scope',
            function ($timeout, $scope) {
                var vm = this;
                vm.viewTab = 'Three';
                vm.$onInit = function(){
                    if(!vm.width){vm.width = $(window).width()}
                    if(!vm.height){vm.height = $(window).height()}
                }
                vm.$onChanges = function(data) {
                    if (data.height&&data.height.currentValue) {
                        vm.height = data.height.currentValue;
                    }
                    if (data.width&&data.width.currentValue) {
                        vm.width = data.width.currentValue;
                    }
                    if (data.moulds&&data.moulds.currentValue) {
                        vm.moulds = data.moulds.currentValue;
                    }
                    if (data.modelPath&&data.modelPath.currentValue) {
                        vm.modelPath = data.modelPath.currentValue;
                    }
                    if (data.modelBlendents&&data.modelBlendents.currentValue) {
                        vm.modelBlendents = data.modelBlendents.currentValue;
                    }
                    if (data.modelData&&data.modelData.currentValue) {
                        vm.modelData = data.modelData.currentValue;
                    }
                    if (data.modelBlendentUuid&&data.modelBlendentUuid.currentValue) {
                        vm.modelBlendentUuid = data.modelBlendentUuid.currentValue;
                    }
                    if (data.pages&&data.pages.currentValue) {
                        vm.pages = null;
                        vm.isUpdate = false;
                        $timeout(function () {
                            vm.pages = data.pages.currentValue;
                        })
                    }
                };

                $scope.viewTabCb = function () {
                    vm.viewTab = 'Two';
                    swiper()
                }
                function swiper() {
                    vm.mouldIndex = 0;
                    if(vm.moulds&&vm.moulds.length>0){
                        $timeout(function () {
                            var swiper = new Swiper('.swiper-container-webmin1', {
                                pagination: {
                                    el: '.swiper-pagination',
                                    type: 'bullets',
                                },
                                navigation: {
                                    nextEl: '.swiper-button-next-webmin1',
                                    prevEl: '.swiper-button-prev-webmin1',
                                },
                                on: {
                                    init: function(swiper){
                                        vm.mouldIndex = this.activeIndex;
                                        $scope.$apply();
                                    },
                                    touchEnd: function(swiper1,event){
                                        $timeout(function () {
                                            vm.mouldIndex = swiper.activeIndex;
                                        })
                                    },
                                },
                            });
                        })
                    }
                }
                $scope.previewTab = function () {
                    vm.onChange();
                }
            }
        ]
    };

    angular
        .module('editorApp')
        .component('threePreview2', threePreview2);
})();

(function () {
    'use strict';

    var threePreview1 = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/components/three-preview1.html',
        // controller: 'articlePreviewController',
        controllerAs: 'vm',
        bindings: {
            height: '<',
            width: '<',
            modelPath: '<',
            modelBlendents: '<',
            modelData: '<',
            modelBlendentUuid: '<',
            pages: '<',
        },
        controller: ['$scope','$timeout', 'ThreeEnv',
            function ($scope,$timeout, ThreeEnv) {
                var vm = this;
                vm.loading = true;
                vm.error = false;
                vm.data = "";
                vm.viewWidth = vm.width || $(window).width();
                vm.viewHeight = vm.height || $(window).height();
                vm.gltf = null;
                vm.$onDestroy = function(){
                    cancelAnimationFrame(vm.animateFrame);
                }
                vm.$onChanges = function(data) {
                    if(scene){
                        if (data.pages) {
                            var pages = data.pages.currentValue;
                            if(pages && vm.modelData){
                                if(pages.length == 1){
                                    for(var i=0; i<vm.modelData.length; i++){
                                        if(vm.modelData[i].page > 0 || (vm.modelData[i].page == 0 && vm.modelData[i].page!=='')){
                                            vm.modelData[i].img = pages[0].pagecover.identifier;
                                        }
                                    }
                                }else{
                                    for(var i=0; i<vm.modelData.length; i++){
                                        for(var j=0; j<pages.length; j++){
                                            if(vm.modelData[i].page == j&&vm.modelData[i].page!==''){
                                                vm.modelData[i].img = pages[j].pagecover.identifier;
                                            }
                                        }
                                    }
                                }
                                initContent1();
                            }
                        }
                        if (data.width && data.width.previousValue>0) {
                            vm.viewWidth = data.width.currentValue;
                            vm.viewHeight = data.height.currentValue;
                            document.getElementById("threeView1").appendChild(renderer.domElement);
                            onWindowResize()
                        }
                    }
                };
                vm.$onInit = function(){
                    if(vm.modelBlendents){
                        vm.modelBlendents.forEach(function (item) {
                            if(item.uuid == vm.modelBlendentUuid){
                                vm.modelBlendent = item;
                            }
                        })
                    }
                    if(vm.modelData){
                        if(vm.pages){
                            if(vm.pages.length == 1){
                                for(var i=0; i<vm.modelData.length; i++){
                                    if(vm.modelData[i].page > 0 || (vm.modelData[i].page == 0 && vm.modelData[i].page!=='')){
                                        vm.modelData[i].img = vm.pages[0].pagecover.identifier;
                                    }
                                }
                            }else {
                                for (var i = 0; i < vm.modelData.length; i++) {
                                    for (var j = 0; j < vm.pages.length; j++) {
                                        if (vm.modelData[i].page == j && vm.modelData[i].page !== '') {
                                            vm.modelData[i].img = vm.pages[j].pagecover.identifier;
                                        }
                                    }
                                }
                            }
                        }
                        if(vm.modelBlendent){
                            for(var i=0; i<vm.modelData.length; i++){
                                for(var j=0; j<vm.modelBlendent.modelData.length; j++){
                                    if(vm.modelData[i].materialName === vm.modelBlendent.modelData[j].materialName){
                                        vm.modelData[i].color = vm.modelBlendent.modelData[j].color;
                                    }
                                }
                            }
                        }else{
                            for(var i=0; i<vm.modelData.length; i++){
                                vm.modelData[i].color = null;
                            }
                        }
                        init();
                    }
                }

                function loaddingError(message) {
                    vm.loading = false;
                    vm.error = true;
                    vm.errorText = message;
                }
                function loaddingSuccess() {
                    vm.loading = false;
                    vm.error = false;
                }

                var scene, camera, renderer, controls, guiControls;
                // var stats = initStats();

                /* 场景 */
                function initScene() {
                    scene = new THREE.Scene();
                    // scene.background = new THREE.Color(0xB3CEFB);
                    // scene.fog = new THREE.Fog(scene.background, 0.1, 1);
                }

                /* 相机 */
                function initCamera(clientWidth, clientHeight) {
                    try {
                        camera = new THREE.PerspectiveCamera(50, clientWidth / clientHeight, 0.1, 1000);
                        var l1 = new THREE.AmbientLight(0xffffff, 0.3);
                        l1.name = 'a-light';
                        camera.add(l1);
                        var l2 = new THREE.DirectionalLight(0xffffff, 0.8 * Math.PI);
                        l2.position.set(6, 0, 6); // ~60º
                        l2.name = 'm-light';
                        l2.castShadow = true;
                        camera.add(l2);
                        var l3 = new THREE.HemisphereLight(0xffffff, 0x000000, 1);
                        l3.name = 'h-light';
                        camera.add(l3);
                        scene.add(camera);
                    }catch (e) {
                        init();
                    }

                }

                /* 渲染器 */
                function initRender() {
                    renderer = new THREE.WebGLRenderer({
                        antialias: true,
                        alpha:true,
                        precision: 'highp',
                        preserveDrawingBuffer: true
                    });
                    renderer.setClearColor(new THREE.Color(0xf3f3f3),0.0);
                    renderer.setSize(vm.viewWidth, vm.viewHeight);
                    renderer.shadowMap.enabled = true;
                    renderer.physicallyCorrectLights = true;
                    renderer.outputEncoding = THREE.sRGBEncoding;
                    renderer.minFilter = THREE.LinearFilter;
                    renderer.gammaOutput = true;
                    renderer.setPixelRatio( window.devicePixelRatio );

                    $timeout(function () {
                        document.getElementById("threeView1").appendChild(renderer.domElement);
                        onWindowResize()
                        initContent();
                        loaddingSuccess();
                        $scope.$apply();
                    })
                }

                /* 灯光 */
                function initLight() {
                    scene.add(new THREE.AmbientLight(0xdddddd));
                    var directionalLight = new THREE.DirectionalLight(0xdddddd, 0.1);
                    directionalLight.position.set(-4, 8, 4);
                    var dhelper = new THREE.DirectionalLightHelper(directionalLight, 5, 0xff0000);

                    var hemisphereLight = new THREE.HemisphereLight(0xffffff, 0xffffff, 0.6);
                    hemisphereLight.position.set(0, 8, 0);
                    var hHelper = new THREE.HemisphereLightHelper(hemisphereLight, 5);

                    // directionalLight.castShadow = true;
                    // directionalLight.shadow.mapSize = new THREE.Vector2(100000, 100);
                    // directionalLight.shadow.bias = -0.1;
                    // scene.add(hemisphereLight);
                    scene.add(directionalLight);


                    // let floorGeometry = new THREE.PlaneGeometry(500, 500, 32);
                    // var material = new THREE.MeshBasicMaterial( {color: 0xffff00, side: THREE.DoubleSide} );
                    // let floorMaterial = new THREE.MeshPhongMaterial({
                    //     color: 0xffff00,
                    //     shininess: 0,
                    //     // wireframe: true
                    // });
                    // let floor = new THREE.Mesh(floorGeometry, material);
                    // floor.rotation.x = -0.5 * Math.PI;
                    // floor.position.y = -120;
                    // floor.receiveShadow = true;
                    // scene.add(floor);
                }

                /* 控制器 */
                function initControls() {
                    controls = new THREE.OrbitControls(camera, renderer.domElement);
                    controls.autoRotate = true;
                    controls.autoRotateSpeed = -6;
                }

                /* 调试插件 */
                function initGui() {
                    guiControls = new function () {};
                    var controls = new dat.GUI({width: 200});
                }

                /* 场景中的内容 */
                function initContent() {
                    // 加载 glTF 格式的模型
                    var loader = new THREE.GLTFLoader();
                    if (THREE.DRACOLoader) {
                        var dracoLoader = new THREE.DRACOLoader();
                        if (dracoLoader) {
                            dracoLoader.setDecoderPath("lib/three/draco/");
                            loader.setDRACOLoader( dracoLoader );
                        }
                    }
                    loader.load(vm.modelPath, function (gltf) {
                        var metalness = checkGltfMetalness(gltf);
                        var gltfScene = gltf.scene || gltf.scenes[0];
                        var clips = gltf.animations || [];
                        gltfScene.updateMatrixWorld();
                        var box = new THREE.Box3().setFromObject(gltfScene);
                        var size = box.getSize(new THREE.Vector3()).length();
                        var center = box.getCenter(new THREE.Vector3());
                        // controls.reset();
                        gltfScene.position.x += gltfScene.position.x - center.x;
                        gltfScene.position.y += gltfScene.position.y - center.y;
                        gltfScene.position.z += gltfScene.position.z - center.z;

                        // 重新设置相机参数
                        controls.maxDistance = size * 10;
                        camera.near = size / 80;
                        camera.far = size * 80;
                        camera.updateProjectionMatrix();

                        camera.position.copy(center);
                        camera.position.x += size / 1.0;
                        camera.position.y += size / 1.0;
                        camera.position.z += size / 1.0;
                        camera.lookAt(center);

                        gltf.scene.traverse(function(child){
                            if (child.isMesh) {
                                child.material.depthWrite = !child.material.transparent;
                                var materials = Array.isArray(child.material) ? child.material : [child.material];
                                materials.forEach(function (node) {
                                    for(var i=0; i<vm.modelData.length; i++){
                                        if(vm.modelData[i].materialName === node.name){
                                            if(vm.modelData[i].img){
                                                var textureLoader = new THREE.TextureLoader();
                                                var map = textureLoader.load(vm.modelData[i].img);
                                                map.minFilter = THREE.LinearFilter;
                                                map.flipY = false;

                                                if (node.map) {
                                                    // copy current map repeat and offset to the new map
                                                    // this is for gltfpack (meshoptimizer) compressed models
                                                    // Also, in the model, you need to embed a texture image so that we can retrieve it here.
                                                    map.repeat.copy(node.map.repeat);
                                                    map.offset.copy(node.map.offset);
                                                }

                                                // copy texture encoding from existing one to the loaded texture
                                                map.encoding = node.map ? node.map.encoding : THREE.sRGBEncoding;

                                                node.map = map;
                                                node.needsUpdate = true;
                                            }else{
                                                if(vm.modelData[i].color){
                                                    node.color = new THREE.Color(vm.modelData[i].color);
                                                }
                                            }
                                        }
                                    }
                                });
                            }
                        })
                        scene.add(gltf.scene);
                        vm.gltf = gltf;
                        if (metalness > 0) {
                            console.log("metalness=" + metalness);
                            updateEnvironment();
                        }
                        // 判断当前的gltf问价中是否有动画
                        if (clips.length !== 0) {
                            var mixer = new THREE.AnimationMixer(gltfScene);
                            mixer.clipAction(gltf.animations[0]).play();
                        }
                    }, function (xhr) {
                        // console.log((xhr.loaded / xhr.total * 100) + '% loaded');
                    }, function (error) {
                        // console.log(error)
                        loaddingError();
                    })

                }
                function initContent1() {
                    if (vm.gltf) {
                        refreshTextures();
                        return;
                    }

                    // 加载 glTF 格式的模型
                    var loader = new THREE.GLTFLoader();
                    if (THREE.DRACOLoader) {
                        var dracoLoader = new THREE.DRACOLoader();
                        if (dracoLoader) {
                            dracoLoader.setDecoderPath("lib/three/draco/");
                            loader.setDRACOLoader( dracoLoader );
                        }
                    }
                    loader.load(vm.modelPath, function (gltf) {
                        var metalness = checkGltfMetalness(gltf);
                        var gltfScene = gltf.scene || gltf.scenes[0];
                        var clips = gltf.animations || [];
                        gltfScene.updateMatrixWorld();
                        var box = new THREE.Box3().setFromObject(gltfScene);
                        var size = box.getSize(new THREE.Vector3()).length();
                        var center = box.getCenter(new THREE.Vector3());
                        gltfScene.position.x += gltfScene.position.x - center.x;
                        gltfScene.position.y += gltfScene.position.y - center.y;
                        gltfScene.position.z += gltfScene.position.z - center.z;

                        gltf.scene.traverse(function(child){
                            if (child.isMesh) {
                                child.material.depthWrite = !child.material.transparent;
                                var materials = Array.isArray(child.material) ? child.material : [child.material];
                                materials.forEach(function (node) {
                                    for(var i=0; i<vm.modelData.length; i++){
                                        if(vm.modelData[i].materialName === node.name){
                                            if(vm.modelData[i].img){
                                                var textureLoader = new THREE.TextureLoader();
                                                var map = textureLoader.load(vm.modelData[i].img);
                                                map.minFilter = THREE.LinearFilter;
                                                map.flipY = false;

                                                if (node.map) {
                                                    // copy current map repeat and offset to the new map
                                                    // this is for gltfpack (meshoptimizer) compressed models
                                                    // Also, in the model, you need to embed a texture image so that we can retrieve it here.
                                                    map.repeat.copy(node.map.repeat);
                                                    map.offset.copy(node.map.offset);
                                                }

                                                // copy texture encoding from existing one to the loaded texture
                                                map.encoding = node.map ? node.map.encoding : THREE.sRGBEncoding;

                                                node.map = map;
                                                node.needsUpdate = true;
                                            }else{
                                                if(vm.modelData[i].color){
                                                    node.color = new THREE.Color(vm.modelData[i].color);
                                                }
                                            }
                                        }
                                    }
                                });
                            }
                        })
                        scene.add(gltf.scene);
                        vm.gltf = gltf;
                        if (metalness > 0) {
                            console.log("metalness=" + metalness);
                            updateEnvironment();
                        }
                    }, function (xhr) {
                        // console.log((xhr.loaded / xhr.total * 100) + '% loaded');
                    }, function (error) {
                        // console.log(error)
                        loaddingError();
                    })

                }

                function refreshTextures() {
                    if (!vm.gltf) {
                        return;
                    }
                    var gltf = vm.gltf;
                    gltf.scene.traverse(function(child){
                        if (child.isMesh) {
                            child.material.depthWrite = !child.material.transparent;
                            var materials = Array.isArray(child.material) ? child.material : [child.material];
                            materials.forEach(function (node) {
                                for(var i=0; i<vm.modelData.length; i++){
                                    if(vm.modelData[i].materialName === node.name){
                                        if(vm.modelData[i].img){
                                            var textureLoader = new THREE.TextureLoader();
                                            var map = textureLoader.load(vm.modelData[i].img);
                                            map.minFilter = THREE.LinearFilter;
                                            map.flipY = false;
                                            if (node.map) {
                                                // copy current map repeat and offset to the new map
                                                // this is for gltfpack (meshoptimizer) compressed models
                                                // Also, in the model, you need to embed a texture image so that we can retrieve it here.
                                                map.repeat.copy(node.map.repeat);
                                                map.offset.copy(node.map.offset);
                                            }

                                            // copy texture encoding from existing one to the loaded texture
                                            map.encoding = node.map ? node.map.encoding : THREE.sRGBEncoding;

                                            node.map = map;
                                            node.needsUpdate = true;
                                        }else{
                                            if(vm.modelData[i].color){
                                                node.color = new THREE.Color(vm.modelData[i].color);
                                            }
                                        }
                                    }
                                }
                            });
                        }
                    })
                }

                function traverseMaterials(object, callback) {
                    object.traverse(function(node){
                        if (!node.isMesh) return;
                        var materials = Array.isArray(node.material)
                            ? node.material
                            : [node.material];
                        materials.forEach(callback);
                    });
                }

                function getWebGLErrorMessage() {
                    var element = document.createElement('div');
                    element.id = 'webgl-error-message';
                    element.style.fontFamily = 'monospace';
                    element.style.fontSize = '13px';
                    element.style.fontWeight = 'normal';
                    element.style.textAlign = 'center';
                    element.style.background = '#fff';
                    element.style.color = '#000';
                    element.style.padding = '1.5em';
                    element.style.width = '400px';
                    element.style.margin = '5em auto 0';
                    if (!this.webgl) {
                        element.innerHTML = window.WebGLRenderingContext ? [
                            'Your graphics card does not seem to support <a href="http://khronos.org/webgl/wiki/Getting_a_WebGL_Implementation" style="color:#000">WebGL</a>.<br />',
                            'Find out how to get it <a href="http://get.webgl.org/" style="color:#000">here</a>.'
                        ].join('\n') : [
                            'Your browser does not seem to support <a href="http://khronos.org/webgl/wiki/Getting_a_WebGL_Implementation" style="color:#000">WebGL</a>.<br/>',
                            'Find out how to get it <a href="http://get.webgl.org/" style="color:#000">here</a>.'
                        ].join('\n');
                    }
                    return element;
                };

                /* 性能插件 */
                function initStats() {
                    // var stats = new Stats();
                    // // document.body.appendChild(stats.domElement);
                    // $timeout(function () {
                    //     document.getElementById("threeView1").appendChild(stats.domElement);
                    // })
                    // return stats;
                }

                /* 窗口变动触发 */
                function onWindowResize() {
                    var width =vm.viewWidth;
                    var height = vm.viewHeight;
                    camera.aspect = width / height;
                    camera.updateProjectionMatrix();
                    renderer.setSize(width, height);
                }

                /* 数据更新 */
                // function update() {
                //     stats.update();
                // }
                /* 初始化 */
                function init() {
                    var container = document.getElementById("threeView1");
                    initScene();
                    initCamera(container.clientWidth, container.clientHeight);
                    initRender();
                    // initLight();
                    initControls();
                    // initGui();
                    /* 监听事件 */
                    window.addEventListener('resize', onWindowResize, false);
                    animate();
                }

                /* 循环渲染 */
                function animate() {

                    // 每次取消动画
                    cancelAnimationFrame(vm.animateFrame);

                    var r = function (){
                        if (!renderer) {
                            return;
                        }
                        vm.animateFrame = requestAnimationFrame(r);
                        // scene.scale.z += 10;
                        renderer.render(scene, camera);
                        controls.update();
                    };
                    r();


                    // requestAnimationFrame(animate);
                    // scene.position.x += 10;
                    // renderer.render(scene, camera);
                }
                $scope.onMouseOver = function () {
                    controls.autoRotate = false;
                }
                $scope.onMouseOut = function () {
                    controls.autoRotate = true;
                }

                function checkGltfMetalness(gltf) {
                    var metalness = 0;
                    if (gltf && gltf.scene) {
                        metalness = parseGroupMetalness(gltf.scene);
                    }
                    return metalness;
                }

                function parseGroupMetalness(group) {
                    var metalness = 0;
                    if (!group.children) {
                        return metalness;
                    }
                    for (var i = 0; i < group.children.length; i++) {
                        var child = group.children[i];
                        if (child.type == 'Mesh') {
                            if (child.material && child.material.metalness > metalness) {
                                metalness = child.material.metalness;
                            }
                        }
                        else if (child.type == 'Group') {
                            var val = parseGroupMetalness(child);
                            if (val > metalness) {
                                metalness = val;
                            }
                        }
                    }
                    return metalness;
                }

                function updateEnvironment () {
                    ThreeEnv.getEnvMap(renderer).then(
                        function (data) {
                            if (data && data.envMap) {
                                scene.environment = data.envMap;
                            }
                        }
                    );
                }
            }
        ]
    };

    angular
        .module('editorApp')
        .component('threePreview1', threePreview1);
})();

(function () {
    'use strict';

    var threePreview2d = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/components/three-preview-2d.html',
        // controller: 'articlePreviewController',
        controllerAs: 'vm',
        bindings: {
            index: '<',
            height: '<',
            width: '<',
            modelData: '<',
            modelPath: '<',
            modelBlendent: '<',
            pages:'<',
            backgroundImg:'<',
            cameraPosition:'<',
            targetPosition:'<',
        },
        controller: ['$scope','$timeout', 'ThreeEnv',
            function ($scope, $timeout, ThreeEnv) {
                var vm = this;
                vm.loading = true;
                vm.error = false;
                vm.viewWidth = vm.width || $(window).width();
                vm.viewHeight = vm.height || $(window).height();
                vm.$onInit = function() {
                    if(vm.modelData){
                        if(vm.pages){
                            for(var i=0; i<vm.modelData.length; i++){
                                for(var j=0; j<vm.pages.length; j++){
                                    if(vm.modelData[i].page == j&&vm.modelData[i].page!==''){
                                        vm.modelData[i].img = vm.pages[j].pagecover.identifier;
                                    }
                                }
                            }
                        }
                        if(vm.modelBlendent){
                            for(var i=0; i<vm.modelData.length; i++){
                                for(var j=0; j<vm.modelBlendent.modelData.length; j++){
                                    if(vm.modelData[i].materialName === vm.modelBlendent.modelData[j].materialName){
                                        vm.modelData[i].color = vm.modelBlendent.modelData[j].color;
                                    }
                                }
                            }
                        }else{
                            for(var i=0; i<vm.modelData.length; i++){
                                vm.modelData[i].color = null;
                            }
                        }
                        $timeout(function () {
                            init();
                        })
                    }
                }
                vm.$onChanges = function(data) {
                    if (data.backgroundImg) {
                        vm.backgroundImg = data.backgroundImg.currentValue;
                    }
                    if (data.modelData&&data.modelData.currentValue) {
                        vm.modelData = data.modelData.currentValue;
                    }
                    if (vm.pages&&data.pages.currentValue) {
                        vm.pages = data.pages.currentValue;
                        if(vm.modelData){
                            for(var i=0; i<vm.modelData.length; i++){
                                for(var j=0; j<vm.pages.length; j++){
                                    if(vm.modelData[i].page == j&&vm.modelData[i].page!==''){
                                        vm.modelData[i].img = vm.pages[j].pagecover.identifier;
                                    }
                                }
                            }
                        }
                    }

                    initContent1();
                };

                function loaddingError(message) {
                    vm.loading = false;
                    vm.error = true;
                    vm.errorText = message;
                }
                function loaddingSuccess() {
                    vm.loading = false;
                    vm.error = false;
                }

                var scene, camera, renderer, controls, gltfScene;
                /* 场景 */
                function initScene() {
                    scene = new THREE.Scene();
                }

                /* 相机 */
                function initCamera(clientWidth, clientHeight) {
                    camera = new THREE.PerspectiveCamera(50, clientWidth / clientHeight, 0.1, 1000);
                    var l1 = new THREE.AmbientLight(0xffffff, 0.3);
                    l1.name = 'a-light';
                    camera.add(l1);
                    var l2 = new THREE.DirectionalLight(0xffffff, 0.8 * Math.PI );
                    l2.position.set(6, 0, 6); // ~60º
                    l2.name = 'm-light';
                    l2.castShadow = true;
                    camera.add(l2);
                    var l3 = new THREE.HemisphereLight(0xffffff, 0x000000, 1);
                    l3.name = 'h-light';
                    camera.add(l3);
                    scene.add(camera);

                }

                /* 渲染器 */
                function initRender() {
                    renderer = new THREE.WebGLRenderer({
                        antialias: true,
                        alpha:true,
                        precision: 'highp',
                        preserveDrawingBuffer: true
                    });
                    renderer.setClearColor(new THREE.Color(0xf3f3f3),0.0);
                    renderer.setSize(vm.viewWidth, vm.viewHeight);
                    renderer.shadowMap.enabled = true;
                    renderer.physicallyCorrectLights = true;
                    renderer.outputEncoding = THREE.sRGBEncoding;
                    renderer.minFilter = THREE.LinearFilter;
                    renderer.gammaOutput = true;
                    renderer.setPixelRatio( window.devicePixelRatio );

                    $timeout(function () {
                        document.getElementById("threeView2d"+vm.index).appendChild(renderer.domElement);
                        onWindowResize()
                        initContent();
                        loaddingSuccess();
                        $scope.$apply();
                    })
                }
                /* 控制器 */
                function initControls() {
                    controls = new THREE.OrbitControls(camera, renderer.domElement);
                }

                /* 场景中的内容 */
                function initContent() {
                    // 加载 glTF 格式的模型
                    var loader = new THREE.GLTFLoader();
                    if (THREE.DRACOLoader) {
                        var dracoLoader = new THREE.DRACOLoader();
                        if (dracoLoader) {
                            dracoLoader.setDecoderPath("lib/three/draco/");
                            loader.setDRACOLoader( dracoLoader );
                        }
                    }
                    loader.load(vm.modelPath, function (gltf) {
                        gltfScene = angular.copy(gltf.scene || gltf.scenes[0]);
                        gltf.scene.updateMatrixWorld();
                        var box = new THREE.Box3().setFromObject(gltf.scene);
                        var size = box.getSize(new THREE.Vector3()).length();
                        var center = box.getCenter(new THREE.Vector3());
                        controls.reset();
                        gltf.scene.position.x += gltf.scene.position.x - center.x;
                        gltf.scene.position.y += gltf.scene.position.y - center.y;
                        gltf.scene.position.z += gltf.scene.position.z - center.z;
                        // 重新设置相机参数
                        controls.maxDistance = size * 10;
                        camera.near = size / 80;
                        camera.far = size * 80;
                        camera.updateProjectionMatrix();

                        camera.position.copy(center);
                        // camera.position.x += size / 1.0;
                        // camera.position.y += size / 1.0;
                        // camera.position.z += size / 1.0;
                        camera.position.set(vm.cameraPosition.x,vm.cameraPosition.y,vm.cameraPosition.z);
                        camera.lookAt(center);
                        controls.target.set(vm.targetPosition.x, vm.targetPosition.y, vm.targetPosition.z);
                        controls.update();
                        gltf.scene.traverse(function(child){
                            if (child.isMesh) {
                                child.material.depthWrite = !child.material.transparent;
                                var materials = Array.isArray(child.material) ? child.material : [child.material];
                                materials.forEach(function (node) {
                                    for(var i=0; i<vm.modelData.length; i++){
                                        if(vm.modelData[i].materialName === node.name){
                                            if(vm.modelData[i].img){
                                                var textureLoader = new THREE.TextureLoader();
                                                var map = textureLoader.load(vm.modelData[i].img);
                                                map.minFilter = THREE.LinearFilter;
                                                map.flipY = false;
                                                if (node.map) {
                                                    // copy current map repeat and offset to the new map
                                                    // this is for gltfpack (meshoptimizer) compressed models
                                                    // Also, in the model, you need to embed a texture image so that we can retrieve it here.
                                                    map.repeat.copy(node.map.repeat);
                                                    map.offset.copy(node.map.offset);
                                                }

                                                // copy texture encoding from existing one to the loaded texture
                                                map.encoding = node.map ? node.map.encoding : THREE.sRGBEncoding;

                                                node.map = map;
                                                node.needsUpdate = true;
                                            }else{
                                                if(vm.modelData[i].color){
                                                    node.color = new THREE.Color(vm.modelData[i].color);
                                                }
                                            }
                                        }
                                    }
                                });
                            }
                        })
                        scene.add(gltf.scene);
                    }, function (xhr) {
                    }, function (error) {
                        loaddingError();
                    })

                }

                function initContent1() {
                    // 加载 glTF 格式的模型
                    if(!vm.modelData){
                        return
                    }
                    var loader = new THREE.GLTFLoader();
                    if (THREE.DRACOLoader) {
                        var dracoLoader = new THREE.DRACOLoader();
                        if (dracoLoader) {
                            dracoLoader.setDecoderPath("lib/three/draco/");
                            loader.setDRACOLoader( dracoLoader );
                        }
                    }
                    loader.load(vm.modelPath, function (gltf) {
                        var gltfScene = gltf.scene || gltf.scenes[0];
                        var clips = gltf.animations || [];
                        gltfScene.updateMatrixWorld();
                        var box = new THREE.Box3().setFromObject(gltfScene);
                        var size = box.getSize(new THREE.Vector3()).length();
                        var center = box.getCenter(new THREE.Vector3());
                        gltfScene.position.x += gltfScene.position.x - center.x;
                        gltfScene.position.y += gltfScene.position.y - center.y;
                        gltfScene.position.z += gltfScene.position.z - center.z;
                        gltfScene.traverse(function(child){
                            if (child.isMesh) {
                                var materials = Array.isArray(child.material) ? child.material : [child.material];
                                materials.forEach(function (node) {
                                    for(var i=0; i<vm.modelData.length; i++){
                                        if(vm.modelData[i].materialName === node.name){
                                            if(vm.modelData[i].img){
                                                var textureLoader = new THREE.TextureLoader();
                                                var map = textureLoader.load(vm.modelData[i].img);
                                                map.minFilter = THREE.LinearFilter;
                                                map.flipY = false;

                                                if (node.map) {
                                                    // copy current map repeat and offset to the new map
                                                    // this is for gltfpack (meshoptimizer) compressed models
                                                    // Also, in the model, you need to embed a texture image so that we can retrieve it here.
                                                    map.repeat.copy(node.map.repeat);
                                                    map.offset.copy(node.map.offset);
                                                }

                                                // copy texture encoding from existing one to the loaded texture
                                                map.encoding = node.map ? node.map.encoding : THREE.sRGBEncoding;

                                                node.map = map;
                                                node.needsUpdate = true;
                                            }else{
                                                if(vm.modelData[i].color){
                                                    node.color = new THREE.Color(vm.modelData[i].color);
                                                }
                                            }
                                        }
                                    }
                                });
                            }
                        })
                        scene.add(gltfScene);
                    }, function (xhr) {
                    }, function (error) {
                        loaddingError();
                    })

                }
                /* 窗口变动触发 */
                function onWindowResize() {
                    var width =vm.viewWidth;
                    var height = vm.viewHeight;
                    camera.aspect = width / height;
                    camera.updateProjectionMatrix();
                    renderer.setSize(width, height);
                }
                /* 初始化 */
                function init() {
                    var container = document.getElementById("threeView2d"+vm.index);
                    initScene();
                    initCamera(vm.viewWidth, vm.viewHeight);
                    initRender();
                    initControls();
                    animate();
                }

                /* 循环渲染 */
                function animate() {
                    // 每次取消动画
                    cancelAnimationFrame(vm.animateFrame);
                    var r = function (){
                        if (!renderer) {
                            return;
                        }
                        vm.animateFrame = requestAnimationFrame(r);
                        renderer.render(scene, camera);
                        // controls.update();
                    };
                    r();
                }
                vm.$onDestroy = function(){
                    cancelAnimationFrame(vm.animateFrame);
                }
            }
        ]
    };

    angular
        .module('editorApp')
        .component('threePreview2d', threePreview2d);
})();


(function () {
    'use strict';

    var threePreview = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/components/three-preview.html',
        // controller: 'articlePreviewController',
        controllerAs: 'vm',
        bindings: {
            height: '<',
            width: '<',
            modelPath: '<',
            modelBlendents: '<',
            modelData: '<',
            modelBlendentUuid: '<',
            pages: '<',
        },
        controller: ['$scope', '$stateParams', 'Qinius', '$http', '$q', 'ImageService', 'PlatformWechatSetting',
            'Article', 'Music', 'ItemValue', 'Store', 'MessageService','$state', '$compile','$timeout', 'ThreeEnv',
            function ($scope, $stateParams, Qinius, $http, $q, ImageService, PlatformWechatSetting,
                      Article, Music, ItemValue, Store, MessageService,$state, $compile,$timeout, ThreeEnv) {
                var vm = this;
                $scope.domains = Qinius.getDomain();
                vm.loading = true;
                vm.error = false;
                vm.data = "";
                vm.viewWidth = vm.width || $(window).width();
                vm.viewHeight = vm.height || $(window).height();
                vm.$onChanges = function(data) {
                    if (data.pages) {
                        var pages = data.pages.currentValue;
                        if(pages && vm.modelData){
                            if(pages.length == 1){
                                for(var i=0; i<vm.modelData.length; i++){
                                    if(vm.modelData[i].page > 0 || (vm.modelData[i].page == 0 && vm.modelData[i].page!=='')){
                                        vm.modelData[i].img = pages[0].pagecover.identifier;
                                    }
                                }
                            }else {
                                for (var i = 0; i < vm.modelData.length; i++) {
                                    for (var j = 0; j < pages.length; j++) {
                                        if (vm.modelData[i].page == j && vm.modelData[i].page !== '') {
                                            vm.modelData[i].img = pages[j].pagecover.identifier;
                                        }
                                    }
                                }
                            }
                            initContent1();
                        }
                    }
                    if (data.width && data.width.previousValue>0) {
                        vm.viewWidth = data.width.currentValue;
                        vm.viewHeight = data.height.currentValue;
                        document.getElementById("threeView").appendChild(renderer.domElement);
                        onWindowResize()
                    }
                };

                vm.$onDestroy = function(){
                    cancelAnimationFrame(vm.animateFrame);
                }
                vm.$onInit = function(){
                    if(vm.modelBlendents){
                        vm.modelBlendents.forEach(function (item) {
                            if(item.uuid == vm.modelBlendentUuid){
                                vm.modelBlendent = item;
                            }
                        })
                    }
                    if(vm.pages.length == 1){
                        for(var i=0; i<vm.modelData.length; i++){
                            if(vm.modelData[i].page > 0 || (vm.modelData[i].page == 0 && vm.modelData[i].page!=='')){
                                vm.modelData[i].img = vm.pages[0].pagecover.identifier;
                            }
                        }
                    }else{
                        for(var i=0; i<vm.modelData.length; i++){
                            for(var j=0; j<vm.pages.length; j++){
                                if(vm.modelData[i].page == j&&vm.modelData[i].page!==''){
                                    vm.modelData[i].img = vm.pages[j].pagecover.identifier;
                                }
                            }
                        }
                    }
                    if(vm.modelBlendent){
                        for(var i=0; i<vm.modelData.length; i++){
                            for(var j=0; j<vm.modelBlendent.modelData.length; j++){
                                if(vm.modelData[i].materialName === vm.modelBlendent.modelData[j].materialName){
                                    vm.modelData[i].color = vm.modelBlendent.modelData[j].color;
                                }
                            }
                        }
                    }else{
                        for(var i=0; i<vm.modelData.length; i++){
                            vm.modelData[i].color = null;
                        }
                    }
                    init();
                }

                function loaddingError(message) {
                    vm.loading = false;
                    vm.error = true;
                    vm.errorText = message;
                }
                function loaddingSuccess() {
                    vm.loading = false;
                    vm.error = false;
                }

                var scene, camera, renderer, controls, guiControls;
                // var stats = initStats();

                /* 场景 */
                function initScene() {
                    scene = new THREE.Scene();
                    // scene.background = new THREE.Color(0xB3CEFB);
                    // scene.fog = new THREE.Fog(scene.background, 0.1, 1);
                }

                /* 相机 */
                function initCamera(clientWidth, clientHeight) {
                    // camera = new THREE.PerspectiveCamera(45, vm.viewWidth / vm.viewHeight, 0.1, 100000);
                    // camera.position.z = 15;
                    // camera.lookAt(new THREE.Vector3(0, 10, 0));



                    camera = new THREE.PerspectiveCamera(50, clientWidth / clientHeight, 0.1, 1000);
                    var l1 = new THREE.AmbientLight(0xffffff, 0.3);
                    l1.name = 'a-light';
                    camera.add(l1);
                    var l2 = new THREE.DirectionalLight(0xffffff, 0.8 * Math.PI);
                    l2.position.set(6, 0, 6); // ~60º
                    l2.name = 'm-light';
                    l2.castShadow = true;
                    camera.add(l2);
                    var l3 = new THREE.HemisphereLight(0xffffff, 0x000000, 1);
                    l3.name = 'h-light';
                    camera.add(l3);
                    scene.add(camera);

                }

                /* 渲染器 */
                function initRender() {
                    renderer = new THREE.WebGLRenderer({
                        antialias: true,
                        alpha:true,
                        precision: 'highp',
                        preserveDrawingBuffer: true
                    });
                    renderer.setClearColor(new THREE.Color(0xf3f3f3),0.0);
                    renderer.setSize(vm.viewWidth, vm.viewHeight);
                    renderer.shadowMap.enabled = true;
                    renderer.physicallyCorrectLights = true;
                    renderer.outputEncoding = THREE.sRGBEncoding;
                    renderer.minFilter = THREE.LinearFilter;
                    renderer.gammaOutput = true;
                    renderer.setPixelRatio( window.devicePixelRatio );

                    $timeout(function () {
                        document.getElementById("threeView").appendChild(renderer.domElement);
                        onWindowResize()
                        initContent();
                        loaddingSuccess();
                        $scope.$apply();
                    })
                }

                /* 灯光 */
                function initLight() {
                    scene.add(new THREE.AmbientLight(0xdddddd));
                    var directionalLight = new THREE.DirectionalLight(0xdddddd, 0.1);
                    directionalLight.position.set(-4, 8, 4);
                    var dhelper = new THREE.DirectionalLightHelper(directionalLight, 5, 0xff0000);

                    var hemisphereLight = new THREE.HemisphereLight(0xffffff, 0xffffff, 0.6);
                    hemisphereLight.position.set(0, 8, 0);
                    var hHelper = new THREE.HemisphereLightHelper(hemisphereLight, 5);

                    // directionalLight.castShadow = true;
                    // directionalLight.shadow.mapSize = new THREE.Vector2(100000, 100);
                    // directionalLight.shadow.bias = -0.1;
                    // scene.add(hemisphereLight);
                    scene.add(directionalLight);


                    // let floorGeometry = new THREE.PlaneGeometry(500, 500, 32);
                    // var material = new THREE.MeshBasicMaterial( {color: 0xffff00, side: THREE.DoubleSide} );
                    // let floorMaterial = new THREE.MeshPhongMaterial({
                    //     color: 0xffff00,
                    //     shininess: 0,
                    //     // wireframe: true
                    // });
                    // let floor = new THREE.Mesh(floorGeometry, material);
                    // floor.rotation.x = -0.5 * Math.PI;
                    // floor.position.y = -120;
                    // floor.receiveShadow = true;
                    // scene.add(floor);
                }

                /* 控制器 */
                function initControls() {
                    controls = new THREE.OrbitControls(camera, renderer.domElement);
                    controls.autoRotate = true;
                    controls.autoRotateSpeed = -6;
                }

                /* 场景中的内容 */
                function initContent() {
                    // 加载 glTF 格式的模型
                    var loader = new THREE.GLTFLoader();
                    if (THREE.DRACOLoader) {
                        var dracoLoader = new THREE.DRACOLoader();
                        if (dracoLoader) {
                            dracoLoader.setDecoderPath("lib/three/draco/");
                            loader.setDRACOLoader( dracoLoader );
                        }
                    }
                    loader.load(vm.modelPath, function (gltf) {
                        var metalness = checkGltfMetalness(gltf);
                        var gltfScene = gltf.scene || gltf.scenes[0];
                        var clips = gltf.animations || [];
                        gltfScene.updateMatrixWorld();
                        var box = new THREE.Box3().setFromObject(gltfScene);
                        var size = box.getSize(new THREE.Vector3()).length();
                        var center = box.getCenter(new THREE.Vector3());
                        // controls.reset();
                        gltfScene.position.x += gltfScene.position.x - center.x;
                        gltfScene.position.y += gltfScene.position.y - center.y;
                        gltfScene.position.z += gltfScene.position.z - center.z;

                        // 重新设置相机参数
                        controls.maxDistance = size * 10;
                        camera.near = size / 80;
                        camera.far = size * 80;
                        camera.updateProjectionMatrix();

                        camera.position.copy(center);
                        camera.position.x += size / 1.0;
                        camera.position.y += size / 1.0;
                        camera.position.z += size / 1.0;
                        camera.lookAt(center);

                        gltf.scene.traverse(function(child){
                            if (child.isMesh) {
                                child.material.depthWrite = !child.material.transparent;
                                var materials = Array.isArray(child.material) ? child.material : [child.material];
                                materials.forEach(function (node) {
                                    for(var i=0; i<vm.modelData.length; i++){
                                        if(vm.modelData[i].materialName === node.name){
                                            if(vm.modelData[i].img){
                                                var textureLoader = new THREE.TextureLoader();
                                                var map = textureLoader.load(vm.modelData[i].img);
                                                map.minFilter = THREE.LinearFilter;
                                                map.flipY = false;
                                                if (node.map) {
                                                    // copy current map repeat and offset to the new map
                                                    // this is for gltfpack (meshoptimizer) compressed models
                                                    // Also, in the model, you need to embed a texture image so that we can retrieve it here.
                                                    map.repeat.copy(node.map.repeat);
                                                    map.offset.copy(node.map.offset);
                                                }

                                                // copy texture encoding from existing one to the loaded texture
                                                map.encoding = node.map ? node.map.encoding : THREE.sRGBEncoding;

                                                node.map = map;
                                                node.needsUpdate = true;
                                            }else{
                                                if(vm.modelData[i].color){
                                                    node.color = new THREE.Color(vm.modelData[i].color);
                                                }
                                            }
                                        }
                                    }
                                });
                            }
                        })
                        scene.add(gltf.scene);
                        if (metalness > 0) {
                            console.log("metalness=" + metalness);
                            updateEnvironment();
                        }
                        // 判断当前的gltf问价中是否有动画
                        if (clips.length !== 0) {
                            var mixer = new THREE.AnimationMixer(gltfScene);
                            mixer.clipAction(gltf.animations[0]).play();
                        }
                    }, function (xhr) {
                        // console.log((xhr.loaded / xhr.total * 100) + '% loaded');
                    }, function (error) {
                        // console.log(error)
                        loaddingError();
                    })

                }
                function initContent1() {
                    // 加载 glTF 格式的模型
                    var loader = new THREE.GLTFLoader();
                    if (THREE.DRACOLoader) {
                        var dracoLoader = new THREE.DRACOLoader();
                        if (dracoLoader) {
                            dracoLoader.setDecoderPath("lib/three/draco/");
                            loader.setDRACOLoader( dracoLoader );
                        }
                    }
                    loader.load(vm.modelPath, function (gltf) {
                        var gltfScene = gltf.scene || gltf.scenes[0];
                        var clips = gltf.animations || [];
                        gltfScene.updateMatrixWorld();
                        var box = new THREE.Box3().setFromObject(gltfScene);
                        var size = box.getSize(new THREE.Vector3()).length();
                        var center = box.getCenter(new THREE.Vector3());
                        gltfScene.position.x += gltfScene.position.x - center.x;
                        gltfScene.position.y += gltfScene.position.y - center.y;
                        gltfScene.position.z += gltfScene.position.z - center.z;

                        gltf.scene.traverse(function(child){
                            if (child.isMesh) {
                                var materials = Array.isArray(child.material) ? child.material : [child.material];
                                materials.forEach(function (node) {
                                    for(var i=0; i<vm.modelData.length; i++){
                                        if(vm.modelData[i].materialName === node.name){
                                            if(vm.modelData[i].img){
                                                var textureLoader = new THREE.TextureLoader();
                                                var map = textureLoader.load(vm.modelData[i].img);
                                                map.minFilter = THREE.LinearFilter;
                                                map.flipY = false;

                                                if (node.map) {
                                                    // copy current map repeat and offset to the new map
                                                    // this is for gltfpack (meshoptimizer) compressed models
                                                    // Also, in the model, you need to embed a texture image so that we can retrieve it here.
                                                    map.repeat.copy(node.map.repeat);
                                                    map.offset.copy(node.map.offset);
                                                }

                                                // copy texture encoding from existing one to the loaded texture
                                                map.encoding = node.map ? node.map.encoding : THREE.sRGBEncoding;

                                                node.map = map;
                                                node.needsUpdate = true;
                                            }else{
                                                if(vm.modelData[i].color){
                                                    node.color = new THREE.Color(vm.modelData[i].color);
                                                }
                                            }
                                        }
                                    }
                                });
                            }
                        })
                        scene.add(gltf.scene);
                    }, function (xhr) {
                        // console.log((xhr.loaded / xhr.total * 100) + '% loaded');
                    }, function (error) {
                        // console.log(error)
                        loaddingError();
                    })

                }

                /* 窗口变动触发 */
                function onWindowResize() {
                    var width =vm.viewWidth;
                    var height = vm.viewHeight;
                    camera.aspect = width / height;
                    camera.updateProjectionMatrix();
                    renderer.setSize(width, height);
                }

                /* 数据更新 */
                // function update() {
                //     stats.update();
                // }
                /* 初始化 */
                function init() {
                    var container = document.getElementById("threeView");
                    initScene();
                    initCamera(container.clientWidth, container.clientHeight);
                    initRender();
                    // initLight();
                    initControls();
                    // initGui();
                    /* 监听事件 */
                    window.addEventListener('resize', onWindowResize, false);
                    animate();
                }

                /* 循环渲染 */
                function animate() {

                    // 每次取消动画
                    cancelAnimationFrame(vm.animateFrame);

                    var r = function (){
                        if (!renderer) {
                            return;
                        }
                        vm.animateFrame = requestAnimationFrame(r);
                        renderer.render(scene, camera);
                        controls.update();
                    };
                    r();


                    // scene.rotation.y += 0.01;
                    // renderer.render(scene, camera);
                    // controls.update();
                    // requestAnimationFrame(animate);
                }

                $scope.onMouseOver = function () {
                    controls.autoRotate = false;
                }
                $scope.onMouseOut = function () {
                    controls.autoRotate = true;
                }

                function checkGltfMetalness(gltf) {
                    var metalness = 0;
                    if (gltf && gltf.scene) {
                        metalness = parseGroupMetalness(gltf.scene);
                    }
                    return metalness;
                }

                function parseGroupMetalness(group) {
                    var metalness = 0;
                    if (!group.children) {
                        return metalness;
                    }
                    for (var i = 0; i < group.children.length; i++) {
                        var child = group.children[i];
                        if (child.type == 'Mesh') {
                            if (child.material && child.material.metalness > metalness) {
                                metalness = child.material.metalness;
                            }
                        }
                        else if (child.type == 'Group') {
                            var val = parseGroupMetalness(child);
                            if (val > metalness) {
                                metalness = val;
                            }
                        }
                    }
                    return metalness;
                }

                function updateEnvironment () {
                    ThreeEnv.getEnvMap(renderer).then(
                        function (data) {
                            if (data && data.envMap) {
                                scene.environment = data.envMap;
                            }
                        }
                    );
                }
            }
        ]
    };

    angular
        .module('editorApp')
        .component('threePreview', threePreview);
})();

(function () {
    'use strict';

    var TextboxEcControl = {
    	restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/components/textbox-ec.html',
        controllerAs: 'vm',
        bindings: {
            fontList:'<',
            type:'<',
            textboxSelect:'<',
            pageData:'=',
            pageIndex:'=',
            levelIndex:'=',
            onAdd:'&',
            onEdit:'&',
            onDelete:'&',
        },

        controller: ['$scope','ModulesService','$timeout', '$http', '$translate', 'MessageService','FontManagement',
            function ($scope,ModulesService,$timeout,$http, $translate, MessageService,FontManagement) {
            var vm = this;
            vm.fontItem = null;
            vm.$onChanges = function (data){
                console.log(data)
                vm.type = "";
                vm.textboxSelect = false;
                vm.textStyleShow = false;
                if(data.fontList){
                    vm.fontList = data.fontList.currentValue;
                }
                if(vm.fontList && vm.fontList.length>0){
                    vm.fontItem = vm.fontList[0];
                    vm.fontList.forEach(function (item){
                        if(item.defaultShow){
                            vm.fontItem = item;
                        }
                    })
                }
                if(data.pageData){
                    vm.pageData = data.pageData.currentValue;
                }
                if(data.pageIndex){
                    vm.pageIndex = data.pageIndex.currentValue;
                }
                if(data.levelIndex){
                    vm.levelIndex = data.levelIndex.currentValue;
                }
                if(data.type){
                    vm.type = data.type.currentValue;
                }
                if(vm.pageData[vm.pageIndex].levels.level[vm.levelIndex]&&vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox){
                    vm.textboxSelect = true;
                }
                if(vm.type == 'add'){
                    $scope.fontShow();
                }
            }

            $scope.colorList = ['#ff001e', '#ff5c00', '#ff9700', '#61734d', '#838c97', '#8d4ac8', '#b8e986', '#7e6565', '#ffffff', '#f1e7d9', '#b5ce99', '#82c281', '#dac2ef', '#000', '#797979', '#7c330a', '#eec78d', '#444444', '#589ceb', '#4a7bc8', '#ddabab'];
            $scope.selectedColor = $scope.colorList[0];

            vm.textboxSelect = false;
            vm.textStyleTab = [
                {name: $translate.instant("font.textStyleTabFont"), id: 'textStyleTabFont'},
                {name: $translate.instant("font.textStyleTabSize"), id: 'textStyleTabSize'},
                {name: $translate.instant("font.textStyleTabType"), id: 'textStyleTabType'},
                {name: $translate.instant("font.textStyleTabColor"), id: 'textStyleTabColor'},
            ];
            vm.textStyleItem = 'textStyleTabFont';
            //添加文字
            $scope.fontShow = function () {
                vm.editbox = true;
                vm.fontTab = 'fontColor';
                $scope.selectedColor = $scope.colorList[0];
                vm.fontData = {
                    seq: vm.pageData[vm.pageIndex].levels.level.length + 1,
                    textbox: {
                        type: 'add',
                        geometry: {
                            x: '0',
                            y: '0',
                            width: 100,
                            height: 20
                        },
                        rotation: {
                            angle: '0'
                        },
                        text: '',
                        style: {
                            font: "",
                            size: 20,
                            color: $scope.selectedColor,
                            bold: false,
                            italic: false,
                            lineheight: 20,
                            letterspacing: 0,
                            align: 'left',
                            writingmode:'horizontal-tb'
                        },
                        fontuuid: vm.fontItem.uuid,
                        identifier: "",
                        editable: true,
                        movable: true,
                        lock: false,
                        version: '2.0',
                        transparency: 1,
                        useradded: true
                    }
                }
                var _fontStyle = [];
                _fontStyle.push(vm.fontItem.style)
                if (_fontStyle.indexOf('NORMAL') != '-1') {
                    vm.fontData.textbox.style.bold = false;
                    vm.fontData.textbox.style.italic = false;
                } else {
                    if (_fontStyle.indexOf('BOLD_ITALIC') != '-1') {
                        vm.fontData.textbox.style.bold = true;
                        vm.fontData.textbox.style.italic = true;
                    } else {
                        if (_fontStyle.indexOf('ITALIC') != '-1') {
                            vm.fontData.textbox.style.italic = true;
                            vm.fontData.textbox.style.bold = false;
                        }
                        if (_fontStyle.indexOf('BOLD') != '-1') {
                            vm.fontData.textbox.style.bold = true;
                            vm.fontData.textbox.style.italic = false;
                        }
                    }
                }
                vm.text = '';
                $timeout(function () {
                    $('textarea.three-font-body-input').focus()
                },100);
            };
            //切换字体
            $scope.updateTextFont = function (data) {
                if (data == undefined) {
                    threeInfo($translate.instant("font.failedAddText"));
                    return
                }
                if (!data.enable) {
                    threeInfo($translate.instant("font.fontChange"));
                    return
                }
                var text = angular.copy(vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox);
                vm.fontStyle = [];
                for (var i = 0; i < vm.fontList.length; i++) {
                    if (vm.fontList[i].uuid == data.uuid) {
                        for (var j = 0; j < vm.fontList[i].fontStyles.length; j++) {
                            vm.fontStyle.push(vm.fontList[i].fontStyles[j].style)
                        }
                    }
                }
                text.style.bold = false;
                text.style.italic = false;
                if (vm.fontStyle.indexOf('NORMAL') != '-1') {
                    text.style.bold = false;
                    text.style.italic = false;
                } else {
                    if (vm.fontStyle.indexOf('BOLD_ITALIC') != '-1') {
                        text.style.bold = true;
                        text.style.italic = true;
                    } else {
                        if (vm.fontStyle.indexOf('ITALIC') != '-1') {
                            text.style.italic = true;
                        }
                        if (vm.fontStyle.indexOf('BOLD') != '-1') {
                            text.style.bold = true;
                        }
                    }
                }
                text.style.font = data.family;
                text.fontuuid = data.uuid;
                text.identifier = $scope.domain + data.fontStyles[0].identifier;
                vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.loading = true;
                FontSupport2(FontManagement, text, function (res) {
                    var msg = res.data;
                    if (res.status == 200) {
                        if (!msg.success || msg.failed) {
                            MessageService.minConfirm({
                                confirm:$translate.instant("button.returnCorrection"),
                                msg:$translate.instant("font.pleaseChangeFonts1") + 
                                    '<span class="theme-color">'+msg.failed+'</span>' + $translate.instant("font.pleaseChangeFonts2")
                            })
                        }else {
                            vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox = text;
                            getFontCSS(FontManagement, vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox, $scope);
                            $timeout(function () {
                                sizeHeight();
                                fontStyle(data.uuid);
                            })
                        }
                    }
                    vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.loading = false;
                })
            };

            function fontStyle(fontuuid) {
                var text = angular.copy(vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox);
                vm.fontStyle = [];
                for (var i = 0; i < vm.fontList.length; i++) {
                    if (vm.fontList[i].uuid == fontuuid) {
                        for (var j = 0; j < vm.fontList[i].fontStyles.length; j++) {
                            vm.fontStyle.push(vm.fontList[i].fontStyles[j].style)
                        }
                    }
                }
                text.style.bold1 = false;
                text.style.italic1 = false;
                if (vm.fontStyle.indexOf('NORMAL') == '-1') {
                    text.style.normal = false;
                } else {
                    text.style.normal = true;
                }
                if (vm.fontStyle.indexOf('BOLD_ITALIC') != '-1') {
                    text.style.bold1 = true;
                    text.style.italic1 = true;
                } else {
                    if (vm.fontStyle.indexOf('ITALIC') != '-1') {
                        text.style.italic1 = true;
                    }
                    if (vm.fontStyle.indexOf('BOLD') != '-1') {
                        text.style.bold1 = true;
                    }
                }
            }

            window.densityInput = function (e) {
                var val = $('#rangeChange').val();
                if (vm.pageData[vm.pageIndex].levels.level[vm.levelIndex] && vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox) {
                    vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.size = parseInt(val);
                    vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.lineheight = parseInt(val);
                }

                var currentPage = vm.pageData[vm.pageIndex].levels.level;
                var item = currentPage[vm.levelIndex].textbox;

                if (item.geometry.width < parseInt(item.style.size)) {
                    item.geometry.width = (Number(parseInt(item.style.size)) + Number(5));
                }
                if (item.geometry.width > vm.pageData[vm.pageIndex].editbox.width) {
                    item.geometry.width = vm.pageData[vm.pageIndex].editbox.width;
                    // item.geometry.x = 0;
                }
                sizeHeight1();
                $scope.$digest();
            }
            window.textStyleTransparency = function (e) {
                var val = $('#textStyleTransparency').val();
                if (vm.pageData[vm.pageIndex].levels.level[vm.levelIndex] && vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox) {
                    vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.transparency = parseInt(val) / 100;
                    vm.transparency = parseInt(val);
                }
                sizeHeight1();
                $scope.$digest();
            }
            //斜体
            $scope.operationItalic = function () {
                var text = vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox;
                if (vm.fontStyle.indexOf('NORMAL') != '-1') {
                    text.style.italic = !text.style.italic;
                    $timeout(function () {
                        sizeHeight();
                    }, 200)
                } else {
                    if (vm.fontStyle.indexOf('BOLD_ITALIC') != '-1' || vm.fontStyle.indexOf('BOLD') != '-1') {
                        if (text.style.bold) {
                            text.style.italic = !text.style.italic;
                            $timeout(function () {
                                sizeHeight();
                            }, 200)
                        }
                    }
                }
            }
            //粗体
            $scope.operationBold = function () {
                var text = vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox;
                if (vm.fontStyle.indexOf('NORMAL') != '-1') {
                    text.style.bold = !text.style.bold;
                    $timeout(function () {
                        sizeHeight();
                    }, 200)
                } else {
                    if (vm.fontStyle.indexOf('BOLD_ITALIC') != '-1' || vm.fontStyle.indexOf('ITALIC') != '-1') {
                        if (text.style.italic) {
                            text.style.bold = !text.style.bold;
                            $timeout(function () {
                                sizeHeight();
                            }, 200)
                        }
                    }
                }
            }
            $scope.operationBarDir = function (item) {
                var text = vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox;
                text.style.align = item;
            };
            $scope.fontColorCb = function (item) {
                var text = vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox;
                text.style.color = item;
            }

            //判断是ios or Android
            var u = navigator.userAgent;
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
            var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

            var textFlag = true;
            var inputEle = document.getElementById('three-font-body-input');

            // 兼容安卓文字输入（首行空格不显示bug）
            $scope.changeText = function (e) {
                if (isAndroid == true && isiOS == false) {
                    fn(e);
                    var targ = e.currentTarget ? e.currentTarget : e.srcElement;
                    vm.text = vm.fontData.textbox.text = targ.value;
                }
            }

            /**
             * 兼容iOS文字输入
             */
            inputEle.addEventListener('compositionstart', function () {
                textFlag = false;
            });
            inputEle.addEventListener('compositionend', function (event) {
                textFlag = true;
                // compositionend 事件发生在 input 之后，故此需要此处调用 input 中逻辑
                if (isAndroid == false && isiOS == true) {
                    vm.text = event.target.value;
                }
            });
            inputEle.addEventListener('input', function (event) {
                // 忽略一切非直接输入，不做逻辑处理
                if (textFlag) {
                    if (isAndroid == false && isiOS == true) {
                        vm.text = event.target.value;
                    }
                };
            });

            $scope.savePage5 = function () {
                if (!vm.fontData.textbox.text) {
                    vm.editbox = false;
                    return
                }
                if(vm.text){
                    vm.fontData.textbox.text =  vm.text;
                }
                FontSupport2(FontManagement, vm.fontData.textbox, function (res) {
                    var msg = res.data;
                    if (res.status == 200) {
                        if (!msg.success || msg.failed) {
                            MessageService.minConfirm({
                                confirm:$translate.instant("button.returnCorrection"),
                                msg:$translate.instant("font.pleaseChangeFonts1") + 
                                    '<span class="theme-color">'+msg.failed+'</span>' + $translate.instant("font.pleaseChangeFonts2")
                            })
                        } else {
                            vm.editbox = false;
                            vm.fontData.textbox.style.color = $scope.selectedColor;
                            if (vm.fontData.textbox.type == 'add') {
                                vm.fontData.textbox.geometry.width = Number($("#c-xml-page-material-fontId").width()) + Number(10);
                                vm.fontData.textbox.geometry.x = (vm.pageData[vm.pageIndex].editbox.width - vm.fontData.textbox.geometry.width) / 2 + vm.pageData[vm.pageIndex].editbox.x;
                                vm.fontData.textbox.geometry.y = (vm.pageData[vm.pageIndex].editbox.height - vm.fontData.textbox.geometry.height) / 2 + vm.pageData[vm.pageIndex].editbox.y;
                                vm.pageData[vm.pageIndex].levels.level.push(vm.fontData)
                                vm.levelIndex = vm.pageData[vm.pageIndex].levels.level.length-1;
                            }
                            if (vm.fontData.textbox.type == 'edit') {
                                vm.pageData[vm.pageIndex].levels.level[vm.levelIndex] = vm.fontData;
                            }
                            sizeHeight1(vm.type)
                        }
                    }
                })
            };
            //删除文字
            $scope.deleteTextbox = function (e) {
                fn(e)
                if (vm.pageData[vm.pageIndex].levels.level[vm.levelIndex] && vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox) {
                    vm.onDelete();
                }
            }
            $scope.editTextbox = function (e, index, item) {
                fn(e)
                vm.editbox = true;
                vm.fontData = vm.pageData[vm.pageIndex].levels.level[vm.levelIndex];
                vm.fontData.textbox.type = 'edit';
                $scope.selectedColor = vm.fontData.textbox.style.color;
                vm.fontTab = 'fontColor';
                vm.text = vm.fontData.textbox.text;
                $timeout(function () {
                    $('textarea.three-font-body-input').focus()
                },100);
            }
            //文字样式
            $scope.textStyleTextbox = function () {
                vm.textStyleShow = true;
            }
            function sizeHeight() {
                if(vm.pageData[vm.pageIndex] && vm.pageData[vm.pageIndex].levels && vm.pageData[vm.pageIndex].levels.level && vm.pageData[vm.pageIndex].levels.level[vm.levelIndex] && vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox){
                    getTextHeight(vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox, $scope)
                }
            }
            vm.sizeHeight1 = sizeHeight1;
            function sizeHeight1() {
                if(vm.pageData[vm.pageIndex] && vm.pageData[vm.pageIndex].levels && vm.pageData[vm.pageIndex].levels.level && vm.pageData[vm.pageIndex].levels.level[vm.levelIndex] && vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox){
                    getTextHeight(vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox, $scope)
                }
            }
            //字体样式
            $scope.textStyleTabCb = function (item) {
                vm.textStyleItem = item.id;
            }
            $scope.textStyleHide = function () {
                vm.textStyleShow = false;
            }
        }]
    };

    angular.module('editorApp')
    	.component('textboxEc', TextboxEcControl);

})();

(function () {
    'use strict';

    var ProgresViewControl = {
    	restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/components/progres-view.html',
        controllerAs: 'vm',
        bindings: {
            progres: '<',
            src: '<',
        },

        controller: ['$scope','FontManagement','$timeout', '$http', function ($scope,FontManagement,$timeout,$http){
    	    var vm = this;
    	    var percent = vm.progres || 0;
    	    var rate = 0;
    	    vm.transform1 = 'rotate(0)';
    	    vm.transform2 = 'rotate(0)';
    	    vm.borderColor = '';
    	    vm.borderColor1 = '';
            vm.$onInit = function() {
                renderRightRate()
            }
            vm.$onChanges = function(data) {
                if(data.progres && data.progres.currentValue){
                    percent = data.progres.currentValue;
                    renderRightRate()
                }
            }
            function renderRightRate(){
                rate += 1;
                if (rate < 50) {
                    vm.transform2 = 'rotate(' + 3.6 * rate + 'deg)';
                    vm.borderColor1 = '';
                } else {
                    vm.transform2 = 'rotate(0)';
                    vm.borderColor1 = 'var(--genericColor)';
                    vm.transform1 = 'rotate(' + 3.6 * (rate - 50) + 'deg)';
                }
                if(rate<percent){
                    $timeout(renderRightRate,5)
                }
            };
        }]
    };

    angular.module('editorApp')
    	.component('progresView', ProgresViewControl);

})();

(function () {
    'use strict';

    var PictureControl = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/components/picture.html',
        controllerAs: 'vm',
        bindings: {
            pages:'<',
            article:'<',
            product:'<',
            onAdd: '&'
        },
        controller: ['$scope', 'Folder', '$timeout', 'MessageService','Gallery','$uibModal','PlatformWechatSetting','StoreStorages','$stateParams','Customer','$localStorage','Article','CommonService','QiniuToken', '$websocket', '$q', '$translate',
            function ($scope, Folder, $timeout, MessageService,Gallery,$uibModal,PlatformWechatSetting,StoreStorages,
                $stateParams,Customer,$localStorage, Article,CommonService, QiniuToken, $websocket, $q, $translate) {
                var vm = this;
                vm.folderShow = false;
                vm.indexNum = 0;
                vm.itemsPerPage = 40;
                $scope.photos = [];
                vm.picLoading = false;
                vm.deleteSure = false;
                vm.folderIds = "";
                vm.folderId = "";
                vm.duplicateList = []; //重复图片
                vm.isDuplicateList = false//重复图片弹框
                vm.photosTab='all';
                vm.photoSort = '1';
                vm.totalPhotoItems = null;
                vm.maxId = null;
                vm.minId = null;
                $scope.gallaryPic = [];
                var newCreateDate = 0;
                vm.platformSetting = PlatformWechatSetting.get();
                vm.storeId = $stateParams.storeId;
                vm.customer = Customer.current();
                $scope.domain = localStorage.getItem('editor-domain');
                QiniuToken.get('get', {}, function (token) {
                    vm.token = token;
                });
                vm.$onInit = function() {
                    $q.all([vm.platformSetting.$promise, vm.customer.$promise]).then(function() {
                        loadFolders();
                        websocket();
                        loadAll('isNull');
                        $timeout(function() {
                            $('.page-photo-view2').on('scroll', function(event){
                                var realScrollHeight=event.currentTarget.clientHeight+event.currentTarget.scrollTop;
                                if($scope.photos.length < vm.totalPhotoItems){
                                    if((event.currentTarget.scrollHeight-10)<realScrollHeight && realScrollHeight < (event.currentTarget.scrollHeight+1)){
                                        vm.indexNum++;
                                        if(vm.folderId){
                                            loadAll(vm.folderId);
                                        } else {
                                            loadAll('isNull');
                                        }
                                    }
                                }
                            });
                        });
                    })
                    
                    // 监听 pages 对象的深层次值变化
                    $scope.$watch(function() {
                        return vm.pages;
                    }, function(newVal, oldVal) {
                        if (newVal !== oldVal && $scope.photos && $scope.photos.length > 0) {
                            // 当 pages 的深层次值发生变化时，重新计算照片使用数量
                            photosNum();
                        }
                    }, true); // 第三个参数 true 表示深度监听
                }
                
                function loadFolders() {
                    Folder.storeGetAllByCondition({
                        items: [{key: "type", op: "=", value: "Gallery"},{key: "articleId", op: "=", value: vm.article.id}],
                        sort: ["id,asc"]
                    }, function (resp) {
                        if(resp.status == 200){
                            $scope.Folders = resp.data;
                        }else {
                            MessageService.error(resp.message);
                        }
                    })
                }
                $scope.folderOn = function () {
                    vm.folderShow = !vm.folderShow;
                };
                // 增加文件夹
                $scope.addFolder = function () {
                    $uibModal.open({
                        templateUrl: "app/entities/page/pagesmySuffix-create.html",
                        controller: "PageMySuffixCreateController",
                        backdrop: 'static',
                        keyboard: true,
                        windowClass: "jh-modal-md",
                        controllerAs: 'vm',
                        resolve: {
                            pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                                return {
                                    page: PaginationUtil.parsePage($stateParams.page)
                                };
                            }],
                            entity: [function() {
                                return {
                                    type: "NEW"
                                };
                            }],
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('editorWeb');
                                return $translate.refresh();
                            }]
                        }
                    }).result.then(function (backData) {
                        Folder.save({
                            name: backData,
                            type: 'Gallery',
                            articleId:vm.article.id
                        }, function (resp) {
                            $scope.Folders.push(resp.data);
                        })
                    });
                }
                //选择文件夹
                $scope.showFolderContent = function (folder) {
                    vm.indexNum = 0;
                    $scope.photos = [];
                    $scope.gallaryPic = [];
                    vm.folderId = folder ? folder.id : '';
                    vm.folderName = folder ? folder.name : '';
                    vm.totalPhotoItems = null;
                    vm.maxId = null;
                    vm.minId = null;
                    vm.unusedQuantity = null;
        
                    if (folder) {
                        loadAll(folder.id);
                    } else {
                        loadAll('isNull');
                    }
        
                };
                $scope.deleteShow = function (ids,event) {
                    fn(event)
                    vm.folderIds=ids;
                    MessageService.confirm({
                        title : $translate.instant("nav.photograph.content.folders.btn.cancelPop.title"),
                        cancel :$translate.instant("button.cancel"),
                        confirm :$translate.instant("button.confirm"),
                        msg :$translate.instant("nav.photograph.content.folders.btn.cancelPop.content")
                    }, function() {
                        Folder.batchDelete({ids: vm.folderIds}, function () {
                            vm.indexNum = 0;
                            vm.maxId = null;
                            vm.minId = null;
                            $scope.photos = [];
                            loadAll('isNull');
                            loadFolders();
                            MessageService.success($translate.instant("button.success"));
                        }, function () {
                            MessageService.error($translate.instant("button.error"));
                        });
                    })
                }
                $scope.updateFloders = function(folder,event){
                    event.stopPropagation();
                    $uibModal.open({
                        templateUrl: 'app/entities/page/pagesmySuffix-create.html',
                        controller: 'PageMySuffixCreateController',
                        backdrop: 'static',
                        keyboard: true,
                        windowClass: "jh-modal-md",
                        controllerAs: 'vm',
                        resolve: {
                            entity: [function() {
                                return {
                                    type: "EDITOR",
                                    name: folder.name
                                };
                            }]
                        }
                    }).result.then(function (data) {
                        folder.name = data;
                        Folder.update(folder, function (resp) {
                            if(resp.status == 200){
                                loadFolders();
                                vm.indexNum = 0;
                                vm.maxId = null;
                                vm.minId = null;
                                vm.totalPhotoItems = null;
                                $scope.photos = [];
                                loadAll('isNull');
                                MessageService.success($translate.instant("editorMessage.modifySuccess"));
                            }else {
                                MessageService.error(resp.message);
                            }
                        },function () {
                            MessageService.error($translate.instant("editorMessage.pleaseEnterTheCorrectFileName"));
                        })
                    }, function(){

                    });
                }
                $scope.photoSortChange = function (num) {
                    vm.indexNum = 0;
                    vm.photoSort = num;
                    vm.totalPhotoItems = null;
                    vm.maxId = null;
                    vm.minId = null;
                    $scope.photos = [];
                    if(vm.folderId){
                        loadAll(vm.folderId);
                    }else{
                        loadAll('isNull');
                    }
                }
                function loadAll(folderId) {
                    vm.picLoading = true;
                    var sort = ["id,desc"];
                    if(vm.photoSort == 1){
                        sort = ["id,desc"]
                    }else if(vm.photoSort == 2){
                        sort = ["name,desc"]
                    }else if(vm.photoSort == 3){
                        sort = ["name,asc"]
                    }
                    var items = [];
                    if (folderId == 'isNull') {
                        items.push({key: "folderId", op: "isNull", value: 1})
                    }else{
                        items.push({key: "folderId", op: "=",value: folderId});
                    }
                    if (vm.maxId) {
                        items.push({key: "id", op: "<=",value: vm.maxId});
                    }
                    if (vm.minId) {
                        items.push({key: "id", op: "<",value: vm.minId});
                    }
                    items.push({key: "articleId", op: "=", value: vm.article.articleId || vm.article.id})
                    if (folderId == 'isNull') {
                        $scope.selectFolder = $translate.instant("editorCommon.selectFolder");
                        Gallery.storeByCondition({
                            items: items,
                            page: vm.indexNum,
                            size: vm.itemsPerPage,
                            sort: sort
                        }, onSuccess, onError);
                    } else {
                        Gallery.storeByCondition({
                            items: items,
                            page: vm.indexNum,
                            size: vm.itemsPerPage,
                            sort: sort
                        }, onSuccess, onError);
                    }
                }
                function onSuccess(data, headers) {
                    if (vm.totalPhotoItems == null) {
                        vm.totalPhotoItems = Number(headers('X-Total-Count'));
                    }
                    if (data.data.length > 0 && vm.maxId == null && vm.photoSort == 1) {
                        vm.maxId = data.data[0].id;
                    }
                    vm.picLoading = false;
                    var len = $scope.photos.length;
                    angular.forEach(data.data, function (item, i) {
                        item.identifier = $scope.domain + item.identifier;
                        item.index = i + len;
                        item.usenum = 0;
                        item.type = 'picture';
                        if($scope.gallaryPic.some(function(item1){
                            item1.id === item.id
                        })){
                            item.select = true
                        }else{
                            item.select = false
                        }
                        $scope.photos.push(item);
                    });
                    if($scope.photos.length < vm.totalPhotoItems){
                        vm.isPhotoFinish = false;
                    }else {
                        vm.isPhotoFinish = true;
                    }
                    if ($scope.photos && $scope.photos.length>0) {
                        newCreateDate = new Date($scope.photos[0].createdDate).getTime();
                    }
                    photosNum();
                    $scope.whetherChoose(false);
                }
        
                function onError(error) {
                    vm.picLoading = false;
                    MessageService.error($translate.instant("editorMessage.failedToObtainThePhotoGallery"));
                }
                function photosNum(){
                    for(var i=0; i<$scope.photos.length; i++){
                        var _photo = $scope.photos[i];
                        _photo.usenum=0;
                        angular.forEach(vm.pages, function (data, index) {
                            if(Array.isArray(data)){
                                angular.forEach(data,function (page) {
                                    angular.forEach(page.levels.level, function (level, i) {
                                        if(level.imagebox && level.imagebox.image && level.imagebox.image.resourceid) {
                                            if (level.imagebox.image.resourceid == _photo.id) {
                                                _photo.usenum++
                                            }
                                        }
                                    })
                                })
                            }else{
                                angular.forEach(data.levels.level, function (level, i) {
                                    if(level.imagebox && level.imagebox.image && level.imagebox.image.resourceid) {
                                        if (level.imagebox.image.resourceid == _photo.id) {
                                            _photo.usenum++
                                        }
                                    }
                                })
                            }
                        })
                    }
                    unusedQuantity();
                }
                function unusedQuantity(){
                    var galleryIdList = [];
                    angular.forEach(vm.pages, function (data, i) {
                        if(Array.isArray(data)){
                            angular.forEach(data,function (page) {
                                angular.forEach(page.levels.level, function (level, i) {
                                    if(level.imagebox && level.imagebox.image && level.imagebox.image.resourceid) {
                                        galleryIdList.push(level.imagebox.image.resourceid)
                                    }
                                })
                            })
                        }else{
                            angular.forEach(data.levels.level, function (level, i) {
                                if(level.imagebox && level.imagebox.image && level.imagebox.image.resourceid) {
                                    galleryIdList.push(level.imagebox.image.resourceid)
                                }
                            })
                        }
                    })
                    var newArr = galleryIdList.filter(function(item,index){
                        return galleryIdList.indexOf(item) === index;  // 因为indexOf 只能查找到第一个
                    });
                    Gallery.unUsed({
                        galleryIdList:newArr,
                        folderId: vm.folderId,
                        articleId: (vm.article.articleId || vm.article.id)
                    },function (res) {
                        if(res.status == 200){
                            vm.unusedQuantity = res.data;
                        }
                    })
                }
                $scope.switchBgTab = function (attr) {
                    vm.photosTab = attr;
                    if(vm.photosTab!='all'){
                        vm.unUsedImageboxsNum = 0;
                        angular.forEach($scope.photos,function (p) {
                            if(p.usenum==0){
                                vm.unUsedImageboxsNum++;
                            }
                        })
                    }else{
                        $scope.gallaryPic = [];
                        vm.indexNum = 0;
                        $scope.photos = [];
                        if (vm.folderId) {
                            loadAll(vm.folderId);
                        } else {
                            loadAll('isNull');
                        }
                    }
                }
                $scope.whetherChoose = function (attr) {
                    $scope.gallaryPic = [];
                    $scope.photos.some(function (p, i) {
                        if(vm.photosTab!='all'){
                            if(p.usenum==0||!p.usenum){
                                if (attr) {
                                    p.select = true;
                                    $scope.gallaryPic.push(p);      //选择导入图片的数组
                                } else {
                                    p.select = false;
                                    $scope.gallaryPic = [];      //选择导入图片的数组
                                }
                            }
                        }else{
                            if (attr) {
                                p.select = true;
                                $scope.gallaryPic.push(p);      //选择导入图片的数组
                            } else {
                                p.select = false;
                                $scope.gallaryPic = [];      //选择导入图片的数组
                            }
                        }
                    })
                }
                //手机传图
                vm.qrcodeShow = false;
                vm.fid = 0;
                var qrcode = null;
                var phonetimer = null;
                var newCreateDate = 0;
                $scope.uploadByPhone = function () {
                    uploadAble(StoreStorages,vm.storeId, function (res) {
                        if(res.status == 200){
                            vm.qrcodeShow = !vm.qrcodeShow;
                            if (qrcode != null) {
                                // qrcode.clear();
                                $('#qrcode1').html("");
                            }

                            //vm.folderId -----某一文件夹信息
                            if (vm.folderId == undefined || vm.folderId == null) {
                                vm.fid = 0;
                            } else {
                                vm.fid = vm.folderId;
                            }

                            Article.getPhonePicToken({id:(vm.article.articleId || vm.article.id)}, function(data){
                                // 手机传图二维码
                                qrcode = $('#qrcode1').qrcode({
                                    render: "canvas",
                                    width: 150,
                                    height: 150,
                                    text: '' + vm.platformSetting.data.editorNotifyUrl + "/#/" + vm.storeId + "/" + vm.fid + "/gallery/" + (vm.article.articleId || vm.article.id)+'?auth='+data.data
                                });
                            },function(){
                            })
                        }else{
                            if(res.status == 400){MessageService.error('系统出错');}
                            else {
                                MessageService.error(res.data||'系统出错');
                            }
                        }
                    })
                }
        
                $scope.uploadByPhone1 = function(){
                    vm.qrcodeShow = false;
                    clearInterval(phonetimer);
                    $scope.gallaryPic = [];
                    vm.indexNum = 0;
                    vm.maxId = null;
                    vm.minId = null;
                    $scope.photos = [];
                    if (vm.folderId) {
                        loadAll(vm.folderId);
                    } else {
                        loadAll('isNull');
                    }
                }

                
                //转移照片
                $scope.moveToFolder = function () {
                    if ($scope.gallaryPic.length < 1) {
                        MessageService.error($translate.instant("editorMessage.pleaseSelectAPhoto"));
                        return
                    }
                    $uibModal.open({
                        templateUrl: 'app/entities/web-folder/entity-move-folder.html',
                        controller: 'EntityMoveFolderController',
                        backdrop: 'static',
                        keyboard: true,
                        windowClass: "jh-modal-md",
                        controllerAs: 'vm',
                        resolve: {
                            entity: {
                                type: 'Gallery',
                                ids: $scope.gallaryPic.map(function(item){return item.id}),
                                folderId: vm.folderId,
                                articleId: (vm.article.articleId || vm.article.id)
                            },
                        }
                    }).result.then(
                        function() {
                            angular.forEach($scope.Folders, function (f, i) {
                                f.selected = false;
                            })
                            $scope.gallaryPic = [];
                            $scope.moveGalleryIds = [];
                            vm.unusedQuantity = null;
                            vm.oldQuantity = null;
                            vm.indexNum = 0;
                            vm.maxId = null;
                            vm.minId = null;
                            vm.totalPhotoItems = null;
                            $scope.photos = [];
                            vm.isMoveToFolder = false;
                            if (vm.folderId) {
                                loadAll(vm.folderId);
                            } else {
                                loadAll('isNull');
                            }
                        }
                    );
                }
                $scope.choosePhoto = function (photo) {
                    $scope.gallaryPic = [];
                    photo.select = !photo.select;
                    angular.forEach($scope.photos, function (p, i) {
                        if (p.select) {
                            $scope.gallaryPic.push(p);
                        }
                    });
                }
                $scope.directFill = function(){
                    if(!$scope.gallaryPic || $scope.gallaryPic.length === 0){
                        MessageService.error($translate.instant("editorMessage.pleaseSelectAPhoto"));
                        return;
                    }
                    if(vm.onAdd){
                        vm.onAdd({
                            photos: $scope.gallaryPic
                        });
                    }
                }
                $scope.deleteBatchPhotos = function () {
                    if (!$scope.gallaryPic.length) {
                        MessageService.error($translate.instant("editorMessage.pleaseSelectAPhoto"));
                        return
                    }
                    var _isExist = false;
                    angular.forEach(vm.pages, function (data, index) {
                        if(Array.isArray(data)){
                            angular.forEach(data,function (page) {
                                angular.forEach(page.levels.level, function (level, i) {
                                    if(level.imagebox && level.imagebox.image && level.imagebox.image.resourceid) {
                                        if ($scope.gallaryPic.some(function(item){return item.id == level.imagebox.image.resourceid})) {
                                            _isExist = true
                                        }
                                    }
                                })
                            })
                        }else{
                            angular.forEach(data.levels.level, function (level, i) {
                                if(level.imagebox && level.imagebox.image && level.imagebox.image.resourceid) {
                                    if ($scope.gallaryPic.some(function(item){return item.id == level.imagebox.image.resourceid})) {
                                        _isExist = true
                                    }
                                }
                            })
                        }
                    })
                    if(_isExist){
                        MessageService.error($translate.instant("editorMessage.deleteBatchPhotosError"));
                        return
                    }
                    MessageService.confirm({
                        title :$translate.instant("button.prompt"),
                        cancel :$translate.instant("button.cancel"),
                        confirm :$translate.instant("button.delete"),
                        msg :$translate.instant("editorMessage.deleteBatchPhotosError1")
                    }, function(){
                        Gallery.batchDelete($scope.gallaryPic.map(function(item){return item.id}), function () {
                            MessageService.success($translate.instant("editorMessage.deleteSuccess"));
                            // 若被选中的pic被删除，就重新生成该数组
                            vm.unusedQuantity = null;
                            vm.maxId = null;
                            vm.minId = null;
                            vm.totalPhotoItems = null;
                            $scope.gallaryPic = [];
                            $scope.photos = [];
                            vm.indexNum = 0;
                            if(vm.folderId){
                                loadAll(vm.folderId);
                            } else {
                                loadAll('isNull');
                            }
                        }, function (error) {
                            MessageService.error($translate.instant("editorMessage.deleteError"));
                        });
                    })
                }
                vm.isWatchName = false;
                $scope.watchGalleryName = function(state){
                    vm.isWatchName = state;
                }

                
                $scope.uploadImage = function(e){
                    e.stopPropagation();
                    e.preventDefault();
                    if (!vm.product.editTip || !vm.product.editTipPic || $localStorage.dotRemindEditorTipPic) {
                        $scope.uploadPic();
                        return
                    }
                    $uibModal.open({
                        templateUrl: 'app/entities/components/controls/editorTipPicModal.html',
                        controller: 'EditorTipPicModalController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    url: vm.product.editTipPic,
                                };
                            },
                        }
                    }).result.then(function() {
                        $scope.uploadPic();
                    });
                }
                $scope.uploadPic = function () {
                    uploadAble(StoreStorages,vm.storeId, function (res) {
                        if(res.status == 200){
                            $("#uploadImg2").trigger("click");
                        }else{
                            if(res.status == 400){MessageService.error('系统出错');}
                            else {
                                MessageService.error(res.data||'系统出错');
                            }
                        }
                    });
                }
                var bigSizePics = [];
                window.updatePic = function ($event) {
                    vm.duplicateList = []; //重置重复图片列表
                    vm.successNumber = 0;//上传成功数量
                    vm.errorNumber = 0;//上传失败数量
                    var oldlength = $event.target.files.length;
                    filterFiles($event.target.files).then(function(filterFilesList) {
                    var newlength = filterFilesList.length;
                    if (newlength < oldlength) {
                        MessageService.error($translate.instant("editorMessage.updatePicError"));
                    }
                    $timeout(function () {
                        vm.picLoading = true;
                        var len = $scope.photos.length;
                        var files = [];
                        var higherSize = [];
                        bigSizePics = [];
                        var uploadPromises = [];
                        // vm.totalPhotoItems = (vm.totalPhotoItems - 0) + (filterFilesList.length-0)
                        for (var i = 0; i < filterFilesList.length; i++) {
                            var f = filterFilesList[i];
                            f.imageSize = Math.ceil(f.size/1024/1024);
                            files.push(f)
                        }
                        if (files.length == 0) {
                            vm.picLoading = false;
                            return
                        }
                        for (var i = 0; i < files.length; i++) {
                            var file = files[i];
                            if (file.size>=50*1024*1024 || (file.width*file.height > 400000000)){
                                file.imageSize= Math.ceil(file.size/1024/1024);
                                bigSizePics.push(file);
                            }else{
                                uploadPromises.push(getBgImg(files, i, len));
                                if (bigSizePics.length==0 && i == (files.length-1)) {
                                    // vm.picLoading = false;
                                    setTimeout(function () {
                                        angular.forEach($scope.photos, function (item, j) {
                                            item.index = j;
                                        });
                                    }, 400)
                                }
                            }
                        }
                        // 等待所有上传完成后进行重复图片检测
                        Promise.all(uploadPromises).then(function() {
                            if(vm.duplicateList.length > 0){
                                MessageService.confirm({
                                    title :'提示',
                                    cancel :'取消',
                                    confirm :'确认',
                                    msg :'检测到图库中有'+vm.duplicateList.length+'张重复图片，是否需要自动去重？',
                                    html: '<span class="themecolor themecolor-btn">查看重复图片</span>'
                                }, function(res) {
                                    if(res == 'htmlClick'){
                                        vm.isDuplicateList = true;
                                    }else{
                                        var ids = [];
                                        vm.duplicateList.forEach(function (item){
                                            ids.push(item.id)
                                        })
                                        Gallery.batchDelete(ids, function () {
                                            MessageService.success("去重成功！");
                                            $scope.gallaryPic = [];
                                            vm.indexNum = 0;
                                            vm.totalPhotoItems = null;
                                            vm.maxId = null;
                                            vm.minId = null;
                                            $scope.photos = [];
                                            vm.duplicateList=[];
                                            if (vm.folderId) {
                                                loadAll(vm.folderId);
                                            } else {
                                                loadAll('isNull');
                                            }
                                        }, function (error) {
                                            MessageService.error("删除失败！");
                                            vm.duplicateList=[];
                                        });
                                    }
                                },function (){
                                    vm.duplicateList=[];
                                })
                            }
                            if (bigSizePics.length > 0) {
                                thumbnailatorPic();
                            }
                        });
                        $event.srcElement.value = "";
                    })
                    });
                };
                var uploadFailedList = []; //临时存储上传失败图片
                function getBgImg(files, i, len) {
                    return new Promise(function(resolve) {
                        CommonService.UpdateQiniuService(files, i, len, $scope.domain, vm.token, vm.folderId,(vm.article.articleId || vm.article.id),function (resp) {
                            if(resp.data.duplicate){
                                vm.duplicateList.push(resp.data)
                            }
                            vm.successNumber++;
                            if (vm.successNumber + vm.errorNumber >= files.length) {
                                vm.picLoading = false;
                                document.getElementById('uploadImg2').value = '';//上传完清空输入框
                                if (vm.errorNumber > 0) {
                                    vm.errorAlertPopup = true;
                                }
                            };
                            resolve(resp);
                        },function(errorFile,executionCompleted){
                            uploadFailedList.push(errorFile);
                            vm.errorNumber++;
                            if (vm.successNumber + vm.errorNumber >= files.length) {
                                $timeout(function(){
                                    vm.picLoading = false;
                                    vm.uploadFailedList = uploadFailedList;
                                    uploadFailedList = [];
                                    vm.errorAlertPopup = true;
                                    document.getElementById('uploadImg2').value = '';//上传完清空输入框
                                })
                            };
                            resolve();
                        },false)
                    });
                }

                $scope.errorAlertPopupClose = function(){
                    vm.errorAlertPopup = false;
                    vm.uploadFailedList = [];
                }

                $scope.duplicateChange = function (){
                    vm.isDuplicateList = false;
                    vm.duplicateList=[];
                    vm.maxId = null;
                    vm.minId = null;
                    vm.totalPhotoItems = null;
                    $scope.gallaryPic = [];
                    $scope.photos = [];
                    vm.indexNum = 0;
                    if(vm.folderId){
                        loadAll(vm.folderId);
                    } else {
                        loadAll('isNull');
                    }
                }

                $scope.errorPhotoView = function(){
                    $uibModal.open({
                        templateUrl: 'app/entities/page-compontents/uploadFailedImageListPopup.html',
                        controller: 'UploadFailedImageListPopupController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: [function() {
                                return vm.uploadFailedList;
                            }]
                        }
                    }).result.then(function (flag) {
                        if (flag) {
                            var files = vm.uploadFailedList;
                            for (var i = 0; i < files.length; i++) {
                                getBgImg(files, i);
                            }
                            vm.successNumber = 0;//上传成功数量
                            vm.errorNumber = 0;//上传失败数量
                            vm.picLoading = true;
                            vm.errorAlertPopup = false;
                            vm.uploadFailedList = [];
                        }else{
                            vm.errorAlertPopup = false;
                            vm.uploadFailedList = [];
                        }
                    });
                }

                function thumbnailatorPic(){
                    $uibModal.open({
                        templateUrl: 'app/entities/page-compontents/thumbnailator.html',
                        controller: 'ThumbnailatorController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: [function() {
                                return {
                                    files: bigSizePics,
                                    aid:(vm.article.articleId || vm.article.id),
                                    folderId:vm.folderId,
                                    domain:$scope.domain,
                                    token:vm.token,
                                    detectFaces:false
                                };
                            }]
                        }
                    }).result.then(function (values) {
                        bigSizePics=[];
                        vm.picLoading = false;
                        // if(values){
                        //     for (var j = 0; j < values.length; j++) {
                        //         var value = values[j];
                        //         value.bgImg = value.identifier;
                        //         $scope.photos.unshift(value);
                        //     }
                        //     vm.picLoading = false;
                        //     setTimeout(function () {
                        //         angular.forEach($scope.photos, function (item, z) {
                        //             item.index = z;
                        //         });
                        //     }, 400)
                        // }
                    }, function(){
                        vm.picLoading = false;
                    });
                }
                // websocket接收上传的图片（多端互通实时更新）
                function websocket(){
                    var urlws = vm.platformSetting.data.editorNotifyUrl.split("://")[1];
                    urlws = urlws.split("/")[0];
                    var ws = $websocket("wss://"+ urlws +"/widget/ws/websocket?uid=Gallery"+(vm.article ? (vm.article.articleId || vm.article.id) : vm.articleId));

                    ws.onOpen(function() {
                    });

                    ws.onMessage(function(message) {
                        var photo = JSON.parse(message.data);
                        if (photo.folderId == vm.folderId || (photo.folderId == null && vm.folderId == '')) {
                            vm.totalPhotoItems++;
                            vm.unusedQuantity++;//增加未使用数
                            var len = $scope.photos.length;
                            photo.identifier = $scope.domain + photo.identifier;
                            photo.select = false;
                            photo.index = len;
                            photo.usenum = 0;
                            photo.type = 'picture';
                            var _photo = null;
                            for (var i = 0; i < $scope.photos.length; i++) {
                                if ($scope.photos[i].id == photo.id) {
                                    _photo = $scope.photos[i];
                                    break;
                                }
                            }
                            if ((!photo.largeFlag && !_photo) || (photo.largeFlag && photo.largeStatus == 'done' && !_photo)) {
                                $scope.photos.unshift(photo);
                            }
                            if (_photo) {
                                _photo.largeStatus = photo.largeStatus;
                            }
                            if (vm.photoSort != 1 && vm.minId==null) {
                                vm.minId = photo.id;
                            }
                        }
                    });

                    ws.onError(function(error) {
                    });

                    ws.onClose(function() {
                    });
                }
            }]
    };

    angular.module('editorApp')
        .component('picture', PictureControl);

})();

(function () {
    'use strict';

    var PageSortControl = {
    	restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/components/page-sort.html',
        controllerAs: 'vm',
        bindings: {
            photoAll: '<',
            agentIos: '<',
            isIPhone6: '<',
            storeId: '<',
            aid: '<',
            product: '<',
            onChange: '&',
        },

        controller: ['$scope','ModulesService','FontManagement','$timeout', 'StoreStorages', '$translate', 'MessageService','$rootScope',
            function ($scope,ModulesService,FontManagement,$timeout,StoreStorages, $translate, MessageService, $rootScope) {
            var vm = this;
            console.log(vm.product)
            vm.$onChanges = function(data) {
                photoAllInfo();
            }
            this.uploadPhotoItem = [];
            $scope.uploadPhoto = function () {
                uploadAble(StoreStorages,vm.storeId, function (res) {
                    if(res.status == 200){
                        if(vm.agentIos){
                            $rootScope.$broadcast('clickAndroidUpload',true);
                        }else{
                            $timeout(function () {
                                $("#page-sort-upload-id").trigger("click");
                            })
                        }
                    }else{
                        if(res.status == 400){
                            MessageService.hint('系统出错');
                        } else {
                            MessageService.hint(res.data||'系统出错');
                        }
                    }
                })
            }
            $scope.book = function (sideUnification){
                vm.onChange({text: JSON.stringify({photoAll: vm.photoAll,sideUnification:sideUnification})});
            }

            var sortArray = [];
            vm.draggable = false;
            var sort1 = null;
            function photoAllInfo() {
                sort1 = new Sortable(document.getElementById('photoAllId'), {
                    swap: false,
                    filter: '.filtered',
                    animation: 150,
                    forceFallback: false,
                    delay: 500, // 设置长按时间为0.5秒
                    onEnd: function (/**Event*/evt) {
                        sortArray = [];
                        angular.forEach($('#photoAllId').find(".sortingPageView"), function (item, index) {
                            var page = item.getAttribute("data-page");
                            sortArray.push(JSON.parse(page));
                        });
                        if(sortArray && sortArray.length>0){
                            vm.photoAll = [];
                            $timeout(function () {
                                vm.photoAll = angular.copy(sortArray);
                                sortArray = [];
                            })
                        }
                    },
                    // 元素被选中
                    onChoose: function (/**Event*/evt) {
                        vm.draggable = true;
                        $scope.$apply();
                        sort1.option("delay", 0);
                    },
                });
            }
            $scope.completeSort = function(){
                sort1.option("delay", 500);
                vm.draggable = false;
            }
            $scope.photoReverse = function () {
                if(vm.photoAll && vm.photoAll.length>0){
                    vm.photoAll.reverse();
                }
            }
            $scope.deletePhotoSelect = function (e,index) {
                vm.photoAll.splice(index, 1);
                fn(e);
            }
        }]
    };

    angular.module('editorApp')
    	.component('pageSort', PageSortControl);

})();

(function () {
    'use strict';

    var PagePreviewControl = {
    	restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/components/page-preview.html',
        controllerAs: 'vm',
        bindings: {
            page: '<',
            scale: '<',
            cover: '<',
            pageIndex: '<',
            imgSize: '<',
            imgDpi: '<',
            isImageboxNot: '<',
            thumbnail: '<',
            isPageTrimbox: '<', //是否裁切出血线
            editorType: '<', //编辑器类型
            isOutline: '<'
        },

        controller: ['$scope', function ($scope) {
            var vm = this;
            function syncPageData() {
                if (vm.page) {
                    vm.pageData = angular.copy(vm.page);
                    if(vm.isPageTrimbox && !vm.pageData.scene && !vm.pageData.notTrimbox && vm.editorType != 'PICTURE_PRO_P'){
                        pageTrimbox(vm.pageData);
                    }
                } else {
                    vm.pageData = null;
                }
            }
            $scope.maskSize = function () {
                var maskSize = '100% 100%';
                if(vm.pageData && vm.pageData.mediabox1){
                    maskSize = (vm.pageData.mediabox1.width * vm.scale) + 'px ' + (vm.pageData.mediabox1.height * vm.scale) + 'px';
                }
                return maskSize;
            }

            vm.$onInit = function () {
                syncPageData();
                $scope.$watch(function () {
                    return vm.page;
                }, syncPageData, true);
            };
            //像素不足提醒
            var throttledResize = angular.throttle(function (item) {
                if(vm.imgSize && vm.imgDpi) {
                    return pxInsufficient(item, vm.imgSize, vm.imgDpi)
                }
            }, 1000);

            $scope.pxInsufficient = function (item) {
                if(vm.imgSize && vm.imgDpi){
                    return pxInsufficient(item, vm.imgSize, vm.imgDpi);
                }
            }
            //边框
            $scope.imageboxW = function (imagebox) {
                if (!imagebox) {
                    return
                }
                if (imagebox.border) {
                    if (imagebox.border.type == 'Color') {
                        return Number(imagebox.geometry.width) + Number(imagebox.border.lineWidth) * 2
                    }
                    if (imagebox.border.type == 'Pic') {
                        return imagebox.geometry.width
                        // return Number(imagebox.geometry.width) + (Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100) + (Number(imagebox.geometry.width) * Number(imagebox.border.edge.right) / 100)
                    }
                } else {
                    return imagebox.geometry.width
                }
            }
            $scope.imageboxH = function (imagebox) {
                if (!imagebox) {
                    return
                }
                if (imagebox.border) {
                    if (imagebox.border.type == 'Color') {
                        return Number(imagebox.geometry.height) + Number(imagebox.border.lineWidth) * 2
                    }
                    if (imagebox.border.type == 'Pic') {
                        return imagebox.geometry.height
                        // return Number(imagebox.geometry.height) + (Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100) + (Number(imagebox.geometry.height) * Number(imagebox.border.edge.bottom) / 100)
                    }
                } else {
                    return imagebox.geometry.height
                }
            }
            $scope.imageboxL = function (imagebox) {
                if (!imagebox) {
                    return
                }
                if (imagebox.border) {
                    if (imagebox.border.type == 'Color') {
                        return Number(imagebox.geometry.x) - Number(imagebox.border.lineWidth)
                    }
                    if (imagebox.border.type == 'Pic') {
                        return imagebox.geometry.x
                        // return Number(imagebox.geometry.x) - (Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100)
                    }
                } else {
                    return imagebox.geometry.x
                }
            }
            $scope.imageboxT = function (imagebox) {
                if (!imagebox) {
                    return
                }
                if (imagebox.border) {
                    if (imagebox.border.type == 'Color') {
                        return Number(imagebox.geometry.y) - Number(imagebox.border.lineWidth)
                    }
                    if (imagebox.border.type == 'Pic') {
                        return imagebox.geometry.y
                        // return Number(imagebox.geometry.y) - (Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100)
                    }
                } else {
                    return imagebox.geometry.y
                }
            }
            $scope.imageboxWEdge = function (imagebox, edge) {
                if (!imagebox) {
                    return
                }
                if (imagebox.border) {
                    if (imagebox.border.type == 'Color') {
                        return Number(imagebox.border.lineWidth)
                    }
                    if (imagebox.border.type == 'Pic') {
                        if (edge == 'left') {
                            return Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100
                        }
                        if (edge == 'top') {
                            return Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100
                        }
                        if (edge == 'right') {
                            return Number(imagebox.geometry.width) * Number(imagebox.border.edge.right) / 100
                        }
                        if (edge == 'bottom') {
                            return Number(imagebox.geometry.height) * Number(imagebox.border.edge.bottom) / 100
                        }
                    }
                } else {
                    return 0
                }
            }
            $scope.imageboxWRadius = function (imagebox, radius, ratio, ratio1) {
                if (!imagebox) {
                    return
                }
                if (imagebox.border) {
                    var _ratio = 1;
                    if(ratio && ratio1){
                        if(imagebox.geometry.width > imagebox.geometry.height){
                            _ratio = ratio1
                        }else{
                            _ratio = ratio
                        }
                    }
                    if(ratio && !ratio1){
                        _ratio = ratio
                    }
                    if (imagebox.border.shape == 'Ellipse') {
                        return '50%'
                    }
                    if (imagebox.border.radius.filletType == 'Fixed') {//圆角固定值
                        var _radius = imagebox.border.radius[radius];
                        return _radius > 0 ?  (_radius + Number(imagebox.border.lineWidth)/2) * _ratio : 0;
                    }else{
                        var radiusW = imagebox.geometry.width > imagebox.geometry.height ? imagebox.geometry.height : imagebox.geometry.width;
                        radiusW = radiusW + imagebox.border.lineWidth;
                        var _r = radiusW * imagebox.border.radius[radius] / 100;
                        return _r > 0 ? (_r + Number(imagebox.border.lineWidth)/2) * _ratio : 0
                    }
                } else {
                    return 0
                }
            }
            $scope.imageboxWRadius1 = function (imagebox, radius, ratio, ratio1) {
                if (!imagebox) {
                    return
                }
                if (imagebox.border) {
                    var _ratio = 1;
                    if(ratio && ratio1){
                        if(imagebox.geometry.width > imagebox.geometry.height){
                            _ratio = ratio1
                        }else{
                            _ratio = ratio
                        }
                    }
                    if(ratio && !ratio1){
                        _ratio = ratio
                    }
                    if (imagebox.border.shape == 'Ellipse') {
                        return '50%'
                    }
                    if (imagebox.border.radius.filletType == 'Fixed') {//圆角固定值
                        var _radius = imagebox.border.radius[radius];
                        return  (_radius - Number(imagebox.border.lineWidth)/2) > 0 ? (_radius - Number(imagebox.border.lineWidth)/2) * _ratio : 0;
                    }else{
                        var radiusW = imagebox.geometry.width > imagebox.geometry.height ? imagebox.geometry.height : imagebox.geometry.width;
                        radiusW = radiusW + imagebox.border.lineWidth;
                        var _r = radiusW * imagebox.border.radius[radius] / 100;
                        return (_r - Number(imagebox.border.lineWidth)/2) > 0 ? (_r - Number(imagebox.border.lineWidth)/2) * _ratio : 0
                    }
                } else {
                    return 0
                }
            }
            $scope.dropShadow = function(imagebox,ratio){
                if (imagebox.shadow == null) {
                    imagebox.shadow={
                        color:'#777777',
                        x:0,
                        y:0,
                        blur:0
                    }
                }
                var width = $scope.imageboxW(imagebox) * ratio;
                var height =$scope.imageboxH(imagebox) * ratio;
                return dropShadow(imagebox,width,height)
            }
            // 大图判断
            $scope.isLarge = function(imageInfo){
                if(!imageInfo)return
                return imageInfo.size >= 20971520 || imageInfo.width > 30000 || imageInfo.height > 30000 || (imageInfo.width*imageInfo.height)>150000000
            }
            $scope.goldFoil = function(color){
                if(color){
                    return goldFoil(color)
                }
            }
            $scope.transitionPx = transitionPx;
            $scope.pageStyle = function(){
                if(vm.pageData && vm.pageData.mediabox){
                    var _style= {
                        'position': 'absolute',
                        'width': vm.pageData.mediabox.width * vm.scale,
                        'height': vm.pageData.mediabox.height * vm.scale,
                        'left': vm.pageData.scene && !vm.cover ? vm.pageData.scene.imagebox.geometry.x * vm.scale : vm.pageData.mediabox.x * vm.scale,
                        'top': vm.pageData.scene && !vm.cover ? vm.pageData.scene.imagebox.geometry.y * vm.scale : vm.pageData.mediabox.y * vm.scale,
                        'background': vm.pageData.background && vm.pageData.background.color&&vm.pageData.background.type == 'Color' ? vm.pageData.background.color : '',
                    }
                    if(vm.editorType == 'PICTURE_PRO_P'){
                        // '-webkit-mask-image': !vm.pageData.outline ? 'unset' : 'url(' + vm.pageData.outline.mask.resource.identifier + ')',
                        // '-webkit-mask-size': maskSize(),
                        // '-webkit-mask-position-x': vm.pageData.mediabox1 ? -vm.pageData.trimbox.x * vm.scale + 'px' : 'unset',
                        // '-webkit-mask-position-y': vm.pageData.mediabox1 ? -vm.pageData.trimbox.y * vm.scale + 'px' : 'unset',
                        if(vm.pageData.outline){
                            if(vm.pageData.outline.mask && vm.pageData.outline.mask.resource && vm.pageData.outline.mask.resource.identifier){
                                _style['-webkit-mask-image']= 'url(' + vm.pageData.outline.mask.resource.identifier + ')';
                                _style['-webkit-mask-size'] = transitionPx(vm.pageData.outline.geometry.width) * vm.scale + 'px ' + transitionPx(vm.pageData.outline.geometry.height) * vm.scale + 'px';
                                _style['-webkit-mask-position-x']= transitionPx(vm.pageData.outline.geometry.x) * vm.scale + 'px';
                                _style['-webkit-mask-position-y']= transitionPx(vm.pageData.outline.geometry.y) * vm.scale + 'px';
                            }
                        }else{
                            if(!vm.isOutline){
                                _style['-webkit-mask-image'] = 'linear-gradient(black, black)';
                                _style['-webkit-mask-size']= (vm.pageData.trimbox.width*vm.scale) + 'px ' + (vm.pageData.trimbox.height*vm.scale) + 'px';
                                _style['-webkit-mask-repeat']= 'no-repeat';
                                _style['-webkit-mask-position']= (vm.pageData.trimbox.x*vm.scale) + 'px ' + (vm.pageData.trimbox.y*vm.scale) + 'px'; // 默认 0 0，可根据需要给 x/y 定位
                            }

                        }
                    }
                    return _style
                }
            }
        }]
    };
    angular.module('editorApp')
    	.component('pagePreview', PagePreviewControl);

})();

(function () {
    'use strict';

    var PagePhotoControl = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/components/page-photo.html',
        controllerAs: 'vm',
        bindings: {
            pageList: '<',
            pageIndex: '<',
            template: '<',
            imgSize: '<',
            imgDpi: '<',
            editorType: '<',
            article:'<',
            product:'<',
            propertyValue:'<',
            onChange: '&'
        },
        controller: ['$scope', 'ModulesService', 'FontManagement', '$timeout', '$http', '$translate', 'MessageService','ThemeClassify','FontXmlsManger','ClipArt','RecommendPics','$stateParams', 'FrameConfigs', '$rootScope', 'Gallery', 'UidService','QiniuToken','$uibModal','ImageService',
            function ($scope, ModulesService, FontManagement, $timeout, $http, $translate, MessageService,ThemeClassify,FontXmlsManger,ClipArt,RecommendPics,$stateParams, FrameConfigs, $rootScope, Gallery, UidService, QiniuToken, $uibModal, ImageService) {
                var vm = this;
                vm.showEditorDialog = true;
                vm.storeId = $stateParams.storeId;
                vm.domain = localStorage.getItem('editor-domain');
                vm.isOutlineBtn = false;
                if(vm.propertyValue.outline && vm.propertyValue.outline.length>0 && (vm.product.pictureType == 'single' || (vm.product.pictureType == 'spread' && vm.pageIndex % 2 == 0))){
                    vm.isOutlineBtn = true;
                }
                QiniuToken.get('get', {}, function (token) {
                    vm.token = token;
                });
                vm.$onChanges = function (data){
                    vm.pages = angular.copy(vm.pageList);
                    vm.levelIndex = 0;
                    vm.menuIndex = 3;
                    vm.elementOn = {
                        index:0,
                        pageIndex:0,
                        name:'',
                        item:null
                    };
                    vm.windowH = $('.page-photo-view3-2').height()*0.9;
                    vm.windowW = $('.page-photo-view3-2').width()*0.9;
                    if(vm.windowH / vm.pages[vm.pageIndex].custom.height >= vm.windowW / vm.pages[vm.pageIndex].custom.width ){
                        vm.pages[vm.pageIndex].custom.ratio = vm.windowW / vm.pages[vm.pageIndex].custom.width;
                    }else {
                        vm.pages[vm.pageIndex].custom.ratio = vm.windowH / vm.pages[vm.pageIndex].custom.height;
                    }
                    vm.pages.forEach(function(page){
                        if (page.levels && page.levels.level) {
                            for (var j = 0; j < page.levels.level.length; j++) {
                                var _level = page.levels.level[j];
                                if (_level.textbox && _level.textbox.editable) {
                                    _level.textbox.lock = false;
                                }
                                if (_level.imageart && _level.imageart.editable) {
                                    _level.imageart.lock = false;
                                }
                            }
                        }
                    })
                    $timeout(function (){
                        pageListDrag1()
                    })
                    classifyInit('BORDER');
                }
                //获取字体
                FontManagement.getAll({family: ""}, function (res) {
                    vm.fontList = angular.copy(res);
                    vm.fontList1 = angular.copy(res);
                    $scope.item = vm.fontList[0];
                    vm.defaultFont = res[0];
                    res.forEach(function (item) {
                        if(item.defaultShow){
                            vm.defaultFont = item;
                        }
                    })
                });
                vm.recommendPics = [];
                RecommendPics.getAllByCondition2({items:[{key: "cancelled", op: "=", value: "false"}],sort: ["seq,asc"]},function(res){
                    if(res && res.data){
                        res.data.forEach(function(item){
                            item.identifier = vm.domain + item.identifier;
                        })
                        vm.recommendPics = res.data;
                    }
                })
                $scope.menuCb = function (item) {
                    vm.menuIndex = item;
                    if (vm.menuIndex != 'backupPages' && vm.menuIndex != 'white') {
                        classifyInit();
                    }
                }
                $scope.editorDialogHide = function () {
                    vm.onChange()
                }
                $scope.save = function (){
                    vm.onChange({text:JSON.parse(JSON.stringify(vm.pages[vm.pageIndex]))});
                }

                $scope.rotateImagebox = function () {
                    imageboxRotate($scope, vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox);
                }
                $scope.imageboxSite = function (item) {
                    if (!vm.pages[vm.pageIndex].levels.level[vm.levelIndex] || vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox.bokehtype != 'None') {
                        return
                    }
                    var _imagebox = vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox;
                    if (item == 'center') {
                        _imagebox.image.offsetx = -(_imagebox.image.width * _imagebox.image.scale - _imagebox.geometry.width) / 2 / _imagebox.image.scale;
                        _imagebox.image.offsety = -(_imagebox.image.height * _imagebox.image.scale - _imagebox.geometry.height) / 2 / _imagebox.image.scale;
                    }
                    if (_imagebox.image.offsetx > 0) {
                        _imagebox.image.offsetx = 0;
                    }
                    if (_imagebox.image.offsety > 0) {
                        _imagebox.image.offsety = 0;
                    }
                }
                $scope.cutImagebox = function () {
                    var item = vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox;
                    vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.scale = 1;
                    vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox.blurredrectangle.x = 0;
                    vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox.blurredrectangle.y = 0;
                    item.bokehtype = 'None';
                    vm.imageboxLoad = true;
                    getBackgroundSource3(item, item.geometry.width, item.geometry.height, item.image, item.bokehtype, $scope, function () {
                        vm.imageboxLoad = false;
                        // $scope.$apply();
                    });
                }
                $scope.fillImagebox = function () {
                    var item = vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox;
                    vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.scale = 1;
                    vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox.blurredrectangle.x = 0;
                    vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox.blurredrectangle.y = 0;
                    item.bokehtype = 'Transparent';
                    vm.imageboxLoad = true;
                    getBackgroundSource3(item, item.geometry.width, item.geometry.height, item.image, item.bokehtype, $scope, function () {
                        vm.imageboxLoad = false;
                        // $scope.$apply();
                    });
                }

                //文字
                function classifyInit(type) {
                    ThemeClassify.getAllByCondition4({
                        type: type || vm.menuIndex,
                        storeId: vm.storeId
                    }, function (res) {
                        if (vm.menuIndex == 'ClipArt' || vm.menuIndex == 'TECHNIQUE') {
                            vm.clipArts = [];
                            if(vm.template.cliparts && vm.template.cliparts.clipart && vm.template.cliparts.clipart.length>0){
                                vm.clipArts = [{
                                    id: "",
                                    name: $translate.instant("button.recommend"),
                                    seq: 0,
                                    type: "CLIPART",
                                    used: true
                                }]
                            }
                            if(res.data){
                                res.data.forEach(function (item) {
                                    if(item.storeId){
                                        vm.clipArts.push(item)
                                    }
                                })
                                res.data.forEach(function (item) {
                                    if(!item.storeId){
                                        vm.clipArts.push(item)
                                    }
                                })
                            }
                            vm.clipArtsPage = 0;
                            vm.clipArtsList = [];
                            clipArtInit(vm.clipArts[0]);
                        }
                        if (vm.menuIndex == 'FONT') {
                            vm.fontlabels = res.data;
                            vm.fontlabelPage = 0;
                            vm.fontlabelList = [];
                            fontInit(res.data[0])
                        }
                        if (vm.menuIndex == 'RECOMMENDPIC') {
                            vm.recommendClassify = res.data;
                            vm.recommendClassifyItem = res.data[0];
                        }
                        if(vm.menuIndex == 'BORDER' || type === 'BORDER'){
                            vm.borderLabels = res.data;
                            if(vm.template.frameConfigs && vm.template.frameConfigs.frameConfig.length>0){
                                vm.borderLabels.unshift({
                                    cancelled: false,
                                    id: null,
                                    name: $translate.instant("button.recommend"),
                                    seq: '',
                                    storeId: 10,
                                    type: "BORDER",
                                    used: true
                                })
                            }
                            vm.borderPage = 0;
                            vm.borderList = [];
                            if(vm.borderLabels && vm.borderLabels.length>0 && !type){
                                borderInit(vm.borderLabels[0])
                            }
                        }
                    });
                }
                vm.fontList = [];
                vm.fontPage = 0;
                vm.itemsPerPage = 40;
                vm.fontLoading = false;
                vm.fontChooseId = "";
                $scope.showfontdocLabels = false;
                vm.fontlabelCb = fontlabelCb;
                function fontInit(item) {
                    if(!item){
                        return
                    }
                    vm.fontLoading = true;
                    vm.fontChooseId = item;
                    FontXmlsManger.byCondition({
                        items: [
                            {key: "themeClassify.id", op: "=", value: item.id}],
                        page: vm.fontPage,
                        size: vm.itemsPerPage,
                        sort: ["id,desc"]
                    }, function (res, headers) {
                        var _sum = headers('X-Total-Count');
                        vm.fontList = res.data;
                        vm.fontLoading = false;
                        if(vm.fontList.length < _sum){
                            vm.fontFulfill = true;
                        }else {
                            vm.fontFulfill = false;
                        }
                    }, function () {
                        vm.fontLoading = false;
                    })
                }
                function fontlabelCb(item){
                    vm.fontList = [];
                    vm.fontPage = 0;
                    fontInit(item)
                }
                $scope.showMorefontdocLabels = function () {
                    $scope.showfontdocLabels = !$scope.showfontdocLabels;
                }/***********************  素材  ****************************/
                vm.clipArtsList = [];
                vm.clipArtsPage = 0;
                vm.clipArtLoading = false;
                vm.clipArtChooseId = "";
                vm.clipArtCb = clipArtCb;
                function clipArtInit(item) {
                    if(!item){return}
                    vm.clipArtChooseId = item;
                    if(item.id){
                        vm.clipArtLoading = true;
                        ClipArt.byCondition3({
                            items: [
                                {key: "themeClassify.id", op: "=", value: item.id}],
                            page: vm.clipArtsPage,
                            size: vm.itemsPerPage,
                            sort: ["seq,asc"]
                        }, function (res, headers) {
                            var _sum = headers('X-Total-Count');
                            angular.forEach(res.data, function (resp) {
                                var arr = {
                                    name: resp.name,
                                    identifier: vm.domain + resp.identifier,
                                    provider: resp.provider,
                                    themeClassifyName: resp.themeClassifyName,
                                    themeClassifyId: resp.themeClassifyId,
                                    resource: {
                                        identifier: vm.domain + resp.identifier,
                                        provider: resp.provider,
                                    }
                                }
                                vm.clipArtsList.push(arr);
                            })
                            vm.clipArtLoading = false;
                            if(vm.clipArtsList.length < _sum){
                                vm.clipArtFulfill = true;
                            }else {
                                vm.clipArtFulfill = false;
                            }
                        }, function () {
                            vm.clipArtLoading = false;
                        })
                    }else{
                        vm.template.cliparts.clipart.forEach(function (clipart) {
                            var arr = {
                                name: "",
                                identifier: clipart.resource.identifier,
                                provider: "",
                                themeClassifyName: $translate.instant("button.recommend"),
                                themeClassifyId: "",
                                resource: clipart.resource
                            }
                            vm.clipArtsList.push(arr);
                        })
                        vm.clipArtLoading = false;
                    }
                }
                function clipArtCb(item){
                    vm.clipArtsList = [];
                    vm.clipArtsPage = 0;
                    clipArtInit(item)
                }
                $scope.loadMoreClipArt = function () {
                    vm.clipArtsPage++;
                    clipArtInit(vm.clipArtChooseId)
                }

                $scope.isClip = false;
                $scope.clipMoreCb = function(item){
                    $scope.isClip = item;
                }
                //页面元素
                vm.isEditorPageElementBody = true;
                $scope.levelInfo = function (level, index) {
                    var item = "";
                    index = completeIndex(index)
                    var i = index+1;
                    if(level.imagebox){
                        item += $translate.instant("editorCommon.imagebox")
                    }
                    if(level.imageart){
                        item += $translate.instant("editorCommon.imageart")
                    }
                    if(level.textbox){
                        item += level.textbox.text || ""
                    }
                    if(level.textdocument){
                        item += $translate.instant("editorCommon.textdocument")
                    }
                    if(level.calMonthBox){
                        item += $translate.instant("editorCommon.calMonthBox")
                    }
                    if(level.calTitleBox){
                        item += $translate.instant("editorCommon.calTitleBox")
                    }
                    return item
                };
                function levelInfo1(level) {
                    var item = "";
                    if(level.imagebox){
                        item = "imagebox"
                    }
                    if(level.imageart){
                        item = "imageart"
                    }
                    if(level.textbox){
                        item = 'textbox'
                    }
                    if(level.textdocument){
                        item = "textdocument"
                    }
                    if(level.calTitleBox){
                        item = "calTitleBox"
                    }
                    if(level.calMonthBox){
                        item = "calMonthBox"
                    }
                    return item
                };
                $scope.levelDelete = function (index) {
                    var levels = vm.pages[vm.pageIndex].levels.level.splice(completeIndex(index), 1);
                    if(levels && levels[0] && levels[0].imagebox){
                        setLayout();
                    }
                    cookie();
                };
                $scope.levelHidden = function (e, level) {
                    level.isHidden = !level.isHidden;
                    fn(e)
                }

                //页面元素移动
                var isBoxDown = false;
                vm.pageElementW = $('.editor-page-element-title').width();
                vm.pageElementH = $('.editor-page-element-title').height();
                vm.pageElementL = $(window).width() - vm.pageElementW - 160;
                vm.pageElementT = 110;
                $scope.movePageElement = function (e) {
                    fn(e);
                    var x = e.clientX;
                    var y = e.clientY;
                    var l = angular.copy(vm.pageElementL);
                    var t = angular.copy(vm.pageElementT);
                    isBoxDown = true;
                    window.onmousemove = function (e) {
                        if (isBoxDown) {
                            var nx = e.clientX;
                            var ny = e.clientY;
                            var nl = nx - (x - l);
                            var nt = ny - (y - t);
                            if(nl < $("#canvasView").offset().left){
                                nl = $("#canvasView").offset().left
                            }
                            if(nl > ($("#canvasView").offset().left + $("#canvasView").width() - vm.pageElementW)){
                                nl = ($("#canvasView").offset().left + $("#canvasView").width() - vm.pageElementW)
                            }
                            if(nt < $("#canvasView").offset().top){
                                nt = $("#canvasView").offset().top
                            }
                            if(nt > ($("#canvasView").offset().top + $("#canvasView").height() - vm.pageElementH)){
                                nt = ($("#canvasView").offset().top + $("#canvasView").height() - vm.pageElementH)
                            }
                            vm.pageElementL = nl;
                            vm.pageElementT = nt;
                            $scope.$apply();
                        }

                    }
                    window.onmouseup = function (e) {
                        isBoxDown = false;
                        e.stopPropagation();
                        $scope.$apply();
                    }
                };
                //页面元素拖拽
                var sort1 = null;
                var sortArray1 = [];
                function pageListDrag1() {
                    $timeout(function () {
                        vm.sortingLevel = angular.copy(vm.pages[vm.pageIndex].levels.level);
                        sort1 = new Sortable(document.getElementById('pageList1'), {
                            swap: false,
                            filter: '.filtered',
                            cancel: ".notDrag",
                            preventOnFilter: true,
                            animation: 150,
                            onMove: function(evt) {
                                // 阻止不可移动项目的拖动
                                return !evt.related.classList.contains('filtered');
                            },
                            onEnd: function (/**Event*/evt) {
                                sortArray1 = [];
                                angular.forEach($('#pageList1').find(".sortingPageView"), function (item, index) {
                                    var page = item.getAttribute("data-page");
                                    sortArray1.push(JSON.parse(page));
                                });
                                if(sortArray1 && sortArray1.length>0){
                                    vm.pages[vm.pageIndex].levels.level = [];
                                    $timeout(function () {
                                        vm.pages[vm.pageIndex].levels.level = angular.copy(sortArray1.reverse());
                                        vm.pages[vm.pageIndex].levels.level.forEach(function (value, index) {
                                            value.seq = index+1;
                                        })
                                        sortArray1 = [];
                                        $scope.editorBodyView();
                                    })
                                }
                            }
                        });
                    })
                }
                $scope.dragCompleteClick = function (e, level, index) {
                    fn(e)
                    elementInit((vm.pages[vm.pageIndex].levels.level.length-1-index),vm.pageIndex,level[levelInfo1(level)],levelInfo1(level));
                };
                vm.completeIndex = completeIndex;
                function completeIndex(index) {
                    return vm.pages[vm.pageIndex].levels.level.length-1-index
                }

                //画布操作

                vm.elementInit = elementInit;
                function elementInit(index,pageIndex,item,name){
                    vm.elementOn = {
                        index:index,
                        pageIndex:pageIndex,
                        name:name,
                        item:item
                    };
                    vm.levelIndex = index;
                    multiSelect();
                    if ($scope && !$scope.$$phase && !$scope.$root.$$phase) {
                        $scope.$apply();
                    }
                }
                //锁定
                $scope.locking = vm.locking = function(e){
                    fn(e);
                    if(vm.elementOn.item){
                        vm.elementOn.item.lock = !vm.elementOn.item.lock;
                        if(vm.elementOn.name === 'imagebox'){
                            vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.lock = vm.elementOn.item.lock;
                        }
                        multiSelect()
                    }
                }
                //缓存每一步
                vm.cookie=cookie;
                vm.cookies=[];
                function cookie(){
                    var _data = angular.copy(vm.pages[vm.pageIndex]);
                    vm.cookies.push(_data);
                }
                $scope.editorBodyView = function(e){
                    if(e){
                        fn(e);
                    }
                    if(!vm.textFont){
                        vm.elementOn = {
                            index:"",
                            pageIndex:"",
                            name:"",
                            item:""
                        };
                        vm.levelIndex = "";
                        vm.isOperationColor = false;
                        vm.isOperationSpacing = false;
                        vm.isOperationDir = false;
                        levelInif();
                    }
                    toolbarStatus();
                }
                $scope.levelInif = vm.levelInif = levelInif;
                function levelInif() {
                    angular.forEach(vm.pages, function (page) {
                        angular.forEach(page.levels.level, function (level, i) {
                            if(level.code&&level.code.geometry){
                                level.code.ctrlKey = false;
                            }
                            if(level.imageart){
                                level.imageart.ctrlKey = false;
                            }
                            if(level.imagebox){
                                level.imagebox.exchange = false;
                                level.imagebox.ctrlKey = false;
                            }
                            if(level.textbox){
                                level.textbox.ctrlKey = false;
                            }
                            if (level.textdocument && level.textdocument.geometry) {
                                level.textdocument.ctrlKey = false;
                            }
                            if (level.calMonthBox && level.calMonthBox.geometry) {
                                level.calMonthBox.ctrlKey = false;
                            }
                            if (level.calTitleBox && level.calTitleBox.geometry) {
                                level.calTitleBox.ctrlKey = false;
                            }
                        })
                    })
                    multiSelect();
                }
                
                vm.levelMove = levelMove;
                var cookieCalled = false;
                function levelMove(event, operation) {
                    cookieCalled = false;
                    angular.forEach(vm.pages, function (page) {
                        angular.forEach(page.levels.level, function (level, i) {
                            if(level.imageart && level.imageart.ctrlKey && !level.imageart.edit){
                                if(operation == 'transparency'){
                                    level.imageart.transparency = parseFloat(vm.transparency/100);
                                    return
                                }
                                if(!level.imageart.lock) {
                                    moveWebdown($scope, event, level.imageart, vm.pages[vm.pageIndex].trimbox, vm.pages[vm.pageIndex].custom.ratio, function () {
                                        if (!cookieCalled) { cookie(); cookieCalled = true; }
                                    })
                                }
                            }
                            if(level.imagebox && level.imagebox.ctrlKey){
                                if(operation == 'transparency'){
                                    level.imagebox.transparency = parseFloat(vm.transparency/100);
                                    return
                                }
                                if(!level.imagebox.lock) {
                                    moveWebdown($scope, event, level.imagebox, vm.pages[vm.pageIndex].trimbox, vm.pages[vm.pageIndex].custom.ratio, function () {
                                        if (!cookieCalled) { cookie(); cookieCalled = true; }
                                    })
                                }
                            }
                            if(level.textbox && level.textbox.ctrlKey){
                                if(operation == 'transparency'){
                                    level.textbox.transparency = parseFloat(vm.transparency/100);
                                    return
                                }
                                if(!level.textbox.lock) {
                                    moveWebdown($scope, event, level.textbox, vm.pages[vm.pageIndex].trimbox, vm.pages[vm.pageIndex].custom.ratio, function () {
                                        if (!cookieCalled) { cookie(); cookieCalled = true; }
                                    })
                                }
                            }
                            if (level.textdocument && level.textdocument.ctrlKey) {
                                if(operation == 'transparency'){
                                    level.textdocument.transparency = parseFloat(vm.transparency/100);
                                    return
                                }
                                if(!level.textdocument.lock) {
                                    moveWebdown($scope, event, level.textdocument, vm.pages[vm.pageIndex].trimbox, vm.pages[vm.pageIndex].custom.ratio, function () {
                                        if (!cookieCalled) { cookie(); cookieCalled = true; }
                                    })
                                }
                            }
                            if (level.calMonthBox && level.calMonthBox.ctrlKey) {
                                if(operation == 'transparency'){
                                    level.calMonthBox.transparency = parseFloat(vm.transparency/100);
                                    return
                                }
                                if(!level.calMonthBox.lock) {
                                    moveWebdown($scope, event, level.calMonthBox, vm.pages[vm.pageIndex].trimbox, vm.pages[vm.pageIndex].custom.ratio, function () {
                                        if (!cookieCalled) { cookie(); cookieCalled = true; }
                                    })
                                }
                            }
                            if (level.calTitleBox && level.calTitleBox.ctrlKey) {
                                if(operation == 'transparency'){
                                    level.calTitleBox.transparency = parseFloat(vm.transparency/100);
                                    return
                                }
                                if(!level.calTitleBox.lock) {
                                    moveWebdown($scope, event, level.calTitleBox, vm.pages[vm.pageIndex].trimbox, vm.pages[vm.pageIndex].custom.ratio, function () {
                                        if (!cookieCalled) { cookie(); cookieCalled = true; }
                                    })
                                }
                            }
                        })
                    })
                }
                vm.multiSelect =multiSelect;
                function multiSelect() {
                    var all = getAllCtrlKeyArray();
                    vm.transparencyBtn = true;//透明度
                    vm.lockingBtn = true;//锁定
                    vm.generBoxBtn = true;//重复生成
                    vm.coverageBtn = true;//图层
                    vm.copyBtn = true;//复制
                    vm.deleteBtn = true;//删除
                    vm.textboxBtn = true;//文字
                    vm.toobarAlignmentBtn = false;//对齐
                    vm.hasImgBtn = false; //裁切交换
                    vm.distribute = false;//分布
                    toolbarStatus()
                    if(all.length>0){
                        vm.textboxBtn = false;
                        vm.lockingBtn = false;
                        vm.coverageBtn = false;
                        vm.deleteBtn = false;
                        if (all.length>1) {
                            vm.toobarAlignmentBtn = true;
                        }
                        if (all.length>2) {
                            vm.distribute = true;
                        }
                        angular.forEach(all, function (level) {
                            if (level.code && level.code.ctrlKey) {
                                vm.transparencyBtn = false;
                            }
                        })
                    }else{
                        if(!vm.elementOn || !vm.elementOn.name || vm.elementOn.name == 'calTitleBox' || vm.elementOn.name == 'calMonthBox'){
                            vm.transparencyBtn = false;
                            vm.lockingBtn = false;
                            vm.coverageBtn = false;
                            vm.copyBtn = false;
                            vm.deleteBtn = false;
                            vm.generBoxBtn = false;
                        }
                        if(vm.elementOn && vm.elementOn.item && vm.elementOn.item.lock){
                            vm.textboxBtn = false;
                            vm.coverageBtn = false;
                            vm.deleteBtn = false;
                        }
                        if(vm.elementOn && vm.elementOn.item && vm.elementOn.name == 'textbox' && !vm.elementOn.item.lock){
                            vm.textboxBtn = true;
                        }
                        if(vm.elementOn && vm.elementOn.name == 'imagebox' && vm.elementOn.item && vm.elementOn.item.image && vm.elementOn.item.image.resource && vm.elementOn.item.image.resource.identifier){
                            vm.hasImgBtn = true;
                        }
                    }
                }
                vm.getAllCtrlKeyArray=getAllCtrlKeyArray;
                function getAllCtrlKeyArray() {
                    var all = [];
                    vm.pages.forEach(function (page) {
                        angular.forEach(page.levels.level, function (level, i) {
                            if(level.imageart && level.imageart.ctrlKey){
                                level.imageart.levelI = i;
                                level.imageart.current = 'imageart';
                                all.push(level.imageart);
                            }
                            if(level.imagebox && level.imagebox.ctrlKey){
                                level.imagebox.levelI = i;
                                level.imagebox.current = 'imagebox';
                                all.push(level.imagebox);
                            }
                            if(level.textbox && level.textbox.ctrlKey){
                                level.textbox.levelI = i;
                                level.textbox.current = 'textbox';
                                all.push(level.textbox);
                            }
                            if (level.textdocument && level.textdocument.ctrlKey) {
                                level.textdocument.levelI = i;
                                level.textdocument.current = 'textdocument';
                                all.push(level.textdocument);
                            }
                            if (level.calTitleBox && level.calTitleBox.ctrlKey) {
                                level.calTitleBox.levelI = i;
                                level.calTitleBox.current = 'calTitleBox';
                                all.push(level.calTitleBox);
                            }
                            if (level.calMonthBox && level.calMonthBox.ctrlKey) {
                                level.calMonthBox.levelI = i;
                                level.calMonthBox.current = 'calMonthBox';
                                all.push(level.calMonthBox);
                            }
                        });
                    })
                    return all;
                }
                /***********************  文字  ****************************/
                fontuuid()
                vm.selectFont = '';
                vm.selectFontBtn = fontuuid;
                vm.selectFontName = selectFontName;
                vm.chineseSupport = true;
                function fontuuid(){
                    vm.fontuuid = [];
                    FontManagement.getAll({family: vm.selectFont}, function (res) {
                        vm.fontuuid = res;
                    });
                }
                function selectFontName(item){
                    if(item){
                        for(var i=0;i<vm.fontuuid.length; i++){
                            if(vm.fontuuid[i].uuid == item){
                                return vm.fontuuid[i].family
                            }
                        }
                    }
                }
                $scope.updateTextFont = function (data) {
                    if (data == undefined) {
                        MessageService.error($translate.instant("editorMessage.failedAddText"));
                        return
                    }
                    if (!data.enable) {
                        MessageService.error($translate.instant("editorMessage.fontChange"));
                        return
                    }
                    var text = angular.copy(vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox);
                    if (text.lock) {
                        return
                    }
                    vm.fontStyle = [];
                    for(var i=0; i<vm.fontuuid.length; i++){
                        if(vm.fontuuid[i].uuid == data.uuid){
                            for(var j=0; j<vm.fontuuid[i].fontStyles.length; j++){
                                vm.fontStyle.push(vm.fontuuid[i].fontStyles[j].style)
                            }
                        }
                    }
                    text.style.bold = false;
                    text.style.italic = false;
                    if(vm.fontStyle.indexOf('NORMAL') != '-1'){
                        text.style.bold = false;
                        text.style.italic = false;
                    }else {
                        if(vm.fontStyle.indexOf('BOLD_ITALIC') != '-1'){
                            text.style.bold = true;
                            text.style.italic = true;
                        }else {
                            if(vm.fontStyle.indexOf('ITALIC') != '-1'){
                                text.style.italic = true;
                                text.style.bold = false;
                            }
                            if(vm.fontStyle.indexOf('BOLD') != '-1'){
                                text.style.bold = true;
                                text.style.italic = false;
                            }
                        }
                    }
                    text.style.font = data.family;
                    text.fontuuid = data.uuid;
                    text.identifier = vm.domain + data.fontStyles[0].identifier;
                    vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox.loading = true;
                    FontSupport2(FontManagement, text, function (res) {
                        var msg = res.data;
                        if (res.status == 200) {
                            $timeout(function(){
                                vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox.loading = false;
                                if (!msg.success || msg.failed) {
                                    vm.editFailedFont = false;
                                    vm.failedFontArr = null;
                                    MessageService.confirm({
                                        title:$translate.instant("editorMessage.warmPrompt"),
                                        confirm:$translate.instant("button.returnCorrection"),
                                        msg:$translate.instant("editorMessage.pleaseChangeFonts1") + 
                                        '<span class="theme-color">'+msg.failed+'</span>' + $translate.instant("editorMessage.pleaseChangeFonts2")
                                    })
                                }else{
                                    text.text = (!msg.passed || msg.passed == "") ? $translate.instant("editorMessage.pleaseEnterText") : msg.passed;
                                    vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox = text;
                                    vm.editFailedFont = false;
                                    vm.failedFontArr = null;
                                    ModulesService.getFontCSS(vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox);
                                    cookie();
                                    $timeout(function () {
                                        sizeHeight()
                                        fontStyle(data.uuid);
                                    },200)
                                }
                            },0)
                        }
                    })
                };
                //添加文字
                $scope.addText = function (size, value) {
                    textboxWebAdd(vm.defaultFont, vm.defaultFont.fontStyles, size, function (_font) {
                        if(value){
                            _font.text = value;
                            _font.value = value;
                        }else{
                            _font.text = $translate.instant("editorCommon.doubleClickType");
                            _font.value = $translate.instant("editorCommon.doubleClickType");
                        }
                        var _level ={
                            seq: vm.pages[vm.pageIndex].levels.level.length+1,
                            textbox: _font
                        }
                        vm.pages[vm.pageIndex].levels.level.push(_level);
                        elementInit(_level.seq-1,vm.pageIndex,_level.textbox,'textbox');
                        $timeout(function () {
                            // vm.pages[vm.pageIndex].levels.level[_level.seq-1].textbox.geometry.width = (Number($("#c-xml-page-material-fontId").width() / (3/4) / vm.pages[vm.pageIndex].custom.ratio * (1 / 12 * vm.elementOn.item.style.size * vm.pages[vm.pageIndex].custom.ratio > 1 ? 1 : 1 / 12 * vm.elementOn.item.style.size * vm.pages[vm.pageIndex].custom.ratio)) + Number(5));
                            // vm.pages[vm.pageIndex].levels.level[_level.seq-1].textbox.geometry.height = Number($("#c-xml-page-material-fontId").height() / (3/4) / vm.pages[vm.pageIndex].custom.ratio) * (1 / 12 * vm.elementOn.item.style.size * vm.pages[vm.pageIndex].custom.ratio > 1 ? 1 : 1 / 12 * vm.elementOn.item.style.size * vm.pages[vm.pageIndex].custom.ratio) + Number(10);
                            vm.pages[vm.pageIndex].levels.level[_level.seq-1].textbox.geometry.width = Number($("#c-xml-page-material-fontId").width()) + Number(10);
                            vm.pages[vm.pageIndex].levels.level[_level.seq-1].textbox.geometry.height = (Number($("#c-xml-page-material-fontId").height()) + Number(10));
                            vm.pages[vm.pageIndex].levels.level[_level.seq-1].textbox.geometry.x = (vm.pages[vm.pageIndex].trimbox.width - vm.pages[vm.pageIndex].levels.level[_level.seq-1].textbox.geometry.width) / 2 + vm.pages[vm.pageIndex].trimbox.x;
                            vm.pages[vm.pageIndex].levels.level[_level.seq-1].textbox.geometry.y = (vm.pages[vm.pageIndex].trimbox.height - vm.pages[vm.pageIndex].levels.level[_level.seq-1].textbox.geometry.height) / 2 + vm.pages[vm.pageIndex].trimbox.y;

                            var _num = 0;
                            vm.pages[vm.pageIndex].levels.level.forEach(function (level) {
                                if(level.textbox){
                                    _num+=10;
                                }
                            });
                            vm.pages[vm.pageIndex].levels.level[_level.seq-1].textbox.geometry.x += _num/vm.pages[vm.pageIndex].custom.ratio;
                            vm.pages[vm.pageIndex].levels.level[_level.seq-1].textbox.geometry.y += _num/vm.pages[vm.pageIndex].custom.ratio;
                            getFontCSS(FontManagement, vm.pages[vm.pageIndex].levels.level[_level.seq-1].textbox, $scope)
                            // sizeHeight();
                            cookie();
                            fontStyle(vm.pages[vm.pageIndex].levels.level[_level.seq-1].textbox.fontuuid)
                        })
                    })
                }
                vm.fontStyleCb = fontStyle;
                function fontStyle(fontuuid){
                    if(vm.elementOn.name != "textbox"){
                        return
                    }
                    var text = vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox;
                    vm.fontStyle = [];
                    for(var i=0; i<vm.fontuuid.length; i++){
                        if(vm.fontuuid[i].uuid == fontuuid){
                            for(var j=0; j<vm.fontuuid[i].fontStyles.length; j++){
                                vm.fontStyle.push(vm.fontuuid[i].fontStyles[j].style)
                            }
                        }
                    }
                    text.style.bold1 = false;
                    text.style.italic1= false;
                    if(vm.fontStyle.indexOf('NORMAL') == '-1'){
                        text.style.normal = false;
                    }else {
                        text.style.normal = true;
                    }
                    if(vm.fontStyle.indexOf('BOLD_ITALIC') != '-1'){
                        text.style.bold1 = true;
                        text.style.italic1= true;
                    }else {
                        if(vm.fontStyle.indexOf('ITALIC') != '-1'){
                            text.style.italic1= true;
                        }
                        if(vm.fontStyle.indexOf('BOLD') != '-1'){
                            text.style.bold1 = true;
                        }
                    }
                }
                vm.sizeHeight = sizeHeight;
                function sizeHeight(){
                    $timeout(function () {
                        var _h = Number($("#c-xml-page-material-fontId1").height());
                        var _w = Number($("#c-xml-page-material-fontId1").width());
                        var _h1 = Number($("#c-xml-page-material-fontId2").height());
                        var _w1 = Number($("#c-xml-page-material-fontId2").width());
                        if(_h<_h1){_h=_h1};
                        if(_w<_w1){_w=_w1};
                        if(vm.elementOn.name == 'textbox') {
                            if(!writingmodeInit(vm.elementOn.item.style.writingmode)){
                                vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox.geometry.height = _h + Number(10);
                            }
                            if(writingmodeInit(vm.elementOn.item.style.writingmode)){
                                vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox.geometry.width = _w + Number(10);
                            }
                        }
                    },200)
                }
                function sizeHeight2(textbox){
                    $timeout(function () {
                        var _h = Number($("#c-xml-page-material-fontId1").height()) + Number(10);
                        var _w = Number($("#c-xml-page-material-fontId1").width()) + Number(10);
                        if(!writingmodeInit(vm.elementOn.item.style.writingmode)){
                            textbox.geometry.height = _h;
                        }
                        if(writingmodeInit(vm.elementOn.item.style.writingmode)){
                            textbox.geometry.width = _w;
                        }
                    },200)
                }
                $scope.writingmodeInit = writingmodeInit;
                /***********************  文字end  ****************************/
                /***********************  素材  ****************************/
                //添加素材
                $scope.materialCb = function(item, x, y, isDrop, hotStamp){
                    webAddImageart($scope,$http,item,vm.pages[vm.pageIndex].trimbox, function (_imageart) {
                        if(x && y){
                            _imageart.geometry.x = (x-_imageart.geometry.width/2)/vm.pages[vm.pageIndex].custom.ratio;
                            _imageart.geometry.y = (y-_imageart.geometry.height/2)/vm.pages[vm.pageIndex].custom.ratio;
                        }
                        if(!isDrop) {
                            var _num = 0;
                            vm.pages[vm.pageIndex].levels.level.forEach(function (level) {
                                if (level.imageart) {
                                    _num += 10;
                                }
                            });
                            _imageart.geometry.x += _num / vm.pages[vm.pageIndex].custom.ratio;
                            _imageart.geometry.y += _num / vm.pages[vm.pageIndex].custom.ratio;
                        }
                        _imageart.geometry.width = _imageart.geometry.width/vm.pages[vm.pageIndex].custom.ratio;
                        _imageart.geometry.height = _imageart.geometry.height/vm.pages[vm.pageIndex].custom.ratio;
                        if(vm.menuIndex == 'TECHNIQUE' && hotStamp){
                            _imageart.spotColor = {
                                color: hotStamp.color,
                                code: hotStamp.spotColor,
                                name: hotStamp.value,
                                growMethod: hotStamp.epitaxy,
                                growValue: hotStamp.epitaxyValue,
                                unit: hotStamp.unit,
                                uuid: hotStamp.uuid
                            };
                            _imageart.serviceType = "stamping"
                        }
                        var _level ={
                            seq: vm.pages[vm.pageIndex].levels.level.length+1,
                            imageart: _imageart
                        }
                        vm.pages[vm.pageIndex].levels.level.push(_level);
                        elementInit(_level.seq-1,vm.pageIndex,_level.imageart,'imageart');
                        cookie();
                    })
                }
                window.updateGold = function ($event, hotStampIndex) {
                    $timeout(function () {
                        var hotStamp = (vm.propertyValue.hotStamp || [])[hotStampIndex];
                        var file = $event.target.files[0]; // 获取上传的文件
                        if (!file.type.startsWith('image/png')) {
                            MessageService.error($translate.instant("pagePhoto.message.techniqueFormat", {fileType: file.type}));
                            return;
                        }
                        ImageService.backendUploadPics(file, vm.domain, vm.token, function(data){
                            var clipArt = {
                                resource:{
                                    identifier: vm.domain + data.key
                                }
                            }
                            $scope.materialCb(clipArt, null, null, false, hotStamp); // 释放URL对象
                            $scope.$apply();
                        },function(err){
                            MessageService.error($translate.instant("pagePhoto.message.whiteInkSizeMismatch"));
                            $scope.$apply();
                        })
                    })
                };
                /***********************  素材end  ****************************/
                /***********************  文字编辑  ****************************/
                //字体
                vm.isOperationColor = false;
                vm.colorList = [
                    {name: '#000000', id: '#000000'},
                    {name: '#666666', id: '#666666'},
                    {name: '#a8a8a8', id: '#a8a8a8'},
                    {name: '#d9d9d9', id: '#d9d9d9'},
                    {name: '#ffffff', id: '#ffffff'},
                    {name: '#647c6e', id: '#647c6e'},
                    {name: '#ffbd4a', id: '#ffbd4a'},
                    {name: '#fef952', id: '#fef952'},
                    {name: '#99e264', id: '#99e264'},
                    {name: '#36b72a', id: '#36b72a'},
                    {name: '#44d9e5', id: '#44d9e5'},
                    {name: '#c27171', id: '#c27171'},
                    {name: '#2fb3ff', id: '#2fb3ff'},
                    {name: '#b760a6', id: '#b760a6'},
                ];
                $scope.operationColorOpen = function ($event) {
                    vm.isOperationColor = !vm.isOperationColor;
                    fn($event)
                }
                $scope.operationColor = function (item) {
                    vm.elementOn.item.style.color = item.id;
                    vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox = vm.elementOn.item;
                }
                $scope.chooseTextColor = function () {
                    vm.elementOn.item.style.color = vm.textColor;
                    vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox = vm.elementOn.item;
                    vm.textColor = null;
                }
                fontSizeInit();
                function fontSizeInit(size){
                    var _size = 101;
                    var _size1 = Math.floor(size/2);
                    $scope.fontSizes = [];
                    for (var f = 6; f < _size; f++) {
                        $scope.fontSizes.push(f);
                    }
                    if(_size1 > _size){
                        $scope.fontSizes.push(_size1);
                    }
                }
                var a = null;
                $scope.updateTextSize = function (size) {
                    if (a !== null) {
                        clearTimeout(a)
                    }
                    a = setTimeout(function () {
                        if (size <= 6) {
                            size = 6
                        }
                        vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox.style.size = size;
                        vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox.style.lineheight = vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox.style.size;
                        vm.elementOn.item = vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox;
                        $timeout(function () {
                            // vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox.geometry.width = (Number($("#c-xml-page-material-fontId").width() / (3/4) / vm.pages[vm.pageIndex].custom.ratio * (1 / 12 * vm.elementOn.item.style.size * vm.pages[vm.pageIndex].custom.ratio > 1 ? 1 : 1 / 12 * vm.elementOn.item.style.size * vm.pages[vm.pageIndex].custom.ratio)) + Number(5));
                            // vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox.geometry.height = Number($("#c-xml-page-material-fontId").height() / (3/4) / vm.pages[vm.pageIndex].custom.ratio) * (1 / 12 * vm.elementOn.item.style.size * vm.pages[vm.pageIndex].custom.ratio > 1 ? 1 : 1 / 12 * vm.elementOn.item.style.size * vm.pages[vm.pageIndex].custom.ratio) + Number(10);
                            if(vm.elementOn.item.geometry.width < ptToPx( vm.elementOn.item.style.size)){
                                vm.elementOn.item.geometry.width = ptToPx( vm.elementOn.item.style.size)+10;
                            }

                            sizeHeight();
                            // $scope.$digest();
                            cookie();
                        })
                    },500)
                }
                vm.isOperationSpacing = false;
                $scope.operationSpacing = function (item) {
                    vm.isOperationSpacing = item;
                    vm.isOperationDir = false;
                    $timeout(function () {
                        var text = vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox;
                        $(".block-width").css({left: text.style.letterspacing});
                        $(".block-height").css({left: text.style.lineheight});
                        vm.template.letterspacing =text.style.letterspacing;
                        vm.template.lineheight = text.style.lineheight;
                    })
                }
                //斜体
                $scope.operationItalic = function () {
                    var text = vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox;
                    if (text) {
                        if(text.style.italic){
                            if(vm.fontStyle.indexOf('NORMAL') > -1){
                                text.style.italic = false;
                                if (vm.fontStyle.indexOf('BOLD') == '-1') {
                                    text.style.bold = false;
                                }
                            }else{
                                if(text.style.bold){
                                    text.style.italic = false;
                                }
                            }
                        }else{
                            if(vm.fontStyle.indexOf('ITALIC') > -1){
                                text.style.italic = true;
                                if(text.style.bold){
                                    if(vm.fontStyle.indexOf('BOLD_ITALIC') == -1){
                                        text.style.bold = false;
                                    }
                                }else{
                                    // if( vm.fontStyle.indexOf('BOLD_ITALIC') > -1){
                                    //     text.style.bold = true;
                                    // }
                                }
                            }else if (vm.fontStyle.indexOf('BOLD_ITALIC') > -1) {
                                text.style.bold = true;
                                text.style.italic = true;
                            }
                        }
                        $timeout(function () {
                            sizeHeight();
                        },200)
                    }
                }
                //粗体
                $scope.operationBold = function () {
                    var text = vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox;
                    if (text) {
                        if(text.style.bold){
                            if(vm.fontStyle.indexOf('NORMAL') > -1){
                                text.style.bold = !text.style.bold;
                                if (vm.fontStyle.indexOf('ITALIC') == '-1') {
                                    text.style.italic = text.style.bold;
                                }
                            }else{
                                if(text.style.italic){
                                    text.style.bold = !text.style.bold;
                                }
                            }
                        }else{
                            if(vm.fontStyle.indexOf('BOLD') > -1){
                                text.style.bold = true;
                                if(text.style.italic){
                                    if(vm.fontStyle.indexOf('BOLD_ITALIC') == -1){
                                        text.style.italic = false;
                                    }
                                }else{
                                    // if( vm.fontStyle.indexOf('BOLD_ITALIC') > -1){
                                    //     text.style.italic = true;
                                    // }
                                }
                            }else if (vm.fontStyle.indexOf('BOLD_ITALIC') > -1) {
                                text.style.bold = true;
                                text.style.italic = true;
                            }
                        }
                        $timeout(function () {
                            sizeHeight();
                        },200)
                    }
                }

                // 字/行间距鼠标点击移动
                var spacingW = {};
                var flagSpacing = false
                window.resizeSpacingStart = function (e) {
                    fn(e);
                    var targ = e.target ? e.target : e.srcElement;
                    spacingW.clientX = e.clientX || 0;
                    spacingW.originLeft = targ.offsetLeft;
                    spacingW.value = targ.dataset.value;
                    var text = vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox;
                    if (text.lock) {
                        return
                    }
                    flagSpacing = true;
                    document.addEventListener("mousemove", resizeSpacingOn, true);
                    document.addEventListener("mouseup", resizeSpacingEnd, true);
                }

                function resizeSpacingOn(e) {
                    if (flagSpacing) {
                        var text = vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox;
                        var l = spacingW.originLeft + e.clientX - spacingW.clientX;
                        if (spacingW.value == 'height' && l < text.style.size) {
                            l = text.style.size;
                        } else if (spacingW.value == 'width' && l < 0) {
                            l = 0;
                        }
                        if (l > 110) {
                            l = 110
                        }
                        if (spacingW.value == 'width') {
                            $(".block-width").css({left: l});
                            text.style.letterspacing = vm.template.letterspacing = l;
                        } else {
                            $(".block-height").css({left: l});
                            text.style.lineheight = vm.template.lineheight = l;
                        }
                        sizeHeight();
                        // var h = Number($('.selectedBorder').find('.c-xml-page-textboxe-text').height());
                        // text.geometry.height = h / vm.pages[vm.pageIndex].custom.ratio * (1 / 12 * vm.elementOn.item.style.size * vm.pages[vm.pageIndex].custom.ratio > 1 ? 1 : 1 / 12 * vm.elementOn.item.style.size * vm.pages[vm.pageIndex].custom.ratio) + Number(5);
                        $scope.$digest();
                    }
                }
                function resizeSpacingEnd() {
                    if(flagSpacing){
                        cookie();
                    }
                    spacingW = {}
                    flagSpacing = false;
                    document.removeEventListener("mousemove", resizeSpacingOn, true);
                    document.removeEventListener("mouseup", resizeSpacingEnd, true);
                }
                vm.isOperationDir = false;
                $scope.operationDir = function (item) {
                    vm.isOperationDir = item;
                    vm.isOperationSpacing = false;
                }
                //左对齐
                $scope.operationBarDir = function (item) {
                    var text = vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox;
                    text.style.align = item;
                }
                //横版
                $scope.textHengban = function () {
                    var text = vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox;
                    var text1 = angular.copy(text);
                    text.style.writingmode = 'horizontal-tb';
                    text.geometry.width = text1.geometry.height;
                    text.geometry.height = text1.geometry.width;
                }
                //竖版
                $scope.textShuban = function (item) {
                    var text = vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox;
                    var text1 = angular.copy(text);
                    var _writingmode = angular.copy(text.style.writingmode);
                    text.style.writingmode = item;
                    $timeout(function () {
                        if(writingmodeInit(_writingmode) && writingmodeInit(text.style.writingmode)){
                        }else{
                            text.geometry.width = text1.geometry.height;
                            text.geometry.height = text1.geometry.width;
                        }
                    },200)
                }
                /***********************  文字编辑end  ****************************/

                //删除
                $scope.deleteBox = vm.deleteBox = function ($event) {
                    if(vm.elementOn.item.lock){
                        return;
                    }
                    vm.pages[vm.pageIndex].levels.level.splice(vm.elementOn.index, 1);
                    $scope.editorBodyView();
                    cookie();
                }

                
                //拖拽图片
                $timeout(function () {
                    var content = $(".page-photo-view3-2")[0]
                    if(content){
                        content.ondragenter = ignoreDrag;
                        // 拖动文件的鼠标指针位置放置区之上时发生
                        content.ondragover = ignoreDrag;
                        content.ondrop = drop;
                    }
                },1000)

                window.dragStart = function (event) {
                    var target = event.target;
                    event.dataTransfer.setData("img", target.id);
                    if (target.id.indexOf('dragtargetClipArt') != '-1') {
                        event.dataTransfer.setData("Art", target.dataset.clipart);
                    }
                    $timeout(function () {
                        if(target.id.indexOf('dragtargetRecommendPic')>-1 || target.id.indexOf('dragtargetMask')>-1 || target.id.indexOf('dragtargetFrameConfig')>-1 || target.id.indexOf('dragtargetClipArt')>-1){
                            vm.dragDom = true;
                        }
                    })
                };
                window.dragOn = function(event){
                    $timeout(function () {
                        vm.dragDom = false;
                        $(".imageboxView").removeClass('selected-blue')
                    })
                }
                $timeout(function () {
                    document.body.ondrop = function(event) {
                        event.preventDefault();
                        event.stopPropagation();
                    };
                })
                function ignoreDrag(e) {
                    // 确保其他元素不会取得该事件
                    e.stopPropagation();
                    e.preventDefault();
                    var dataset = e.target.dataset;
                    if ((vm.dragDom && (e.target.nodeName == 'IMG' || ($(e.target).attr('class') && $(e.target).attr('class').indexOf('image-placeholder-class') > -1))&&dataset.imgindex)) {
                        var textIndex = dataset.imgindex;
                        if(vm.dragDom){
                            $(".imageboxView").removeClass('selected-blue')
                            $(".imageboxView"+vm.pageIndex+textIndex).addClass('selected-blue');
                            return
                        }
                    }else{
                        $(".imageboxView").removeClass('selected-blue')
                    }
                }
                vm.replacePageIndex = 0;
                vm.replacePageArrIndex = 0;
                vm.replaceTextIndex = 0;
                vm.replacePageIndex2 = 0;
                function drop(e) {
                    var data = e.dataTransfer.getData("img");
                    $timeout(function () {
                        $(".imageboxView").removeClass('selected-blue');
                        var offsetX= e.clientX;
                        var offsetY= e.clientY;
                        offsetX -= parseFloat($(".page-edit-view").offset().left);
                        offsetY -= parseFloat($(".page-edit-view").offset().top);
                        if(vm.pages[vm.pageIndex].scene){
                            offsetX -= vm.pages[vm.pageIndex].scene.imagebox.geometry.x * vm.pages[vm.pageIndex].custom.ratio;
                            offsetY -= vm.pages[vm.pageIndex].scene.imagebox.geometry.y * vm.pages[vm.pageIndex].custom.ratio;
                        }
                        if(vm.dragDom){
                            ignoreDrag(e);
                            //拖拽图片进入占位框
                            if (data.indexOf('dragtargetRecommendPic') != '-1') {
                                var levelIndex = e.target.dataset.imgindex;
                                if(levelIndex){
                                    var item = JSON.parse($('#' + data).attr('data-item'));
                                    replaceImagebox(item,levelIndex);
                                }
                            }
                            
                            // 判读是否是占位框
                            if (data.indexOf('dragtargetMask') != '-1') {
                                var item = $('#' + data).attr('data-item');
                                var imgindex = e.target.dataset.imgindex;
                                if(imgindex == null){
                                    var border = null;
                                    if (data.indexOf('Round') > '-1') {
                                        border = {
                                            shape: 'Ellipse',
                                            radius: {
                                                lt: 0,
                                                rt: 0,
                                                rb: 0,
                                                lb: 0,
                                                all: 0,
                                                filletType: 'Fixed'
                                            },
                                            "edge": {
                                                top: 0,
                                                right: 0,
                                                bottom: 0,
                                                left: 0
                                            },
                                            lineWidth: 0,
                                            type: "Color",
                                            lineType:"solid",
                                            resource: {
                                                "identifier": '',
                                                "provider": ''
                                            },
                                            color: '#000000',
                                        };
                                    } else if (data.indexOf('Rectangle') > '-1') {
                                        border = {
                                            shape: 'Rectangle',
                                            radius: {
                                                lt: 0,
                                                rt: 0,
                                                rb: 0,
                                                lb: 0,
                                                all: 0,
                                                filletType: 'Fixed'
                                            },
                                            "edge": {
                                                top: 0,
                                                right: 0,
                                                bottom: 0,
                                                left: 0
                                            },
                                            lineWidth: 0,
                                            type: "Color",
                                            lineType:"solid",
                                            resource: {
                                                "identifier": '',
                                                "provider": ''
                                            },
                                            color: '#000000',
                                        };
                                    }else{
                                        border = {
                                            shape: 'Rectangle',
                                            radius: {
                                                lt: 0,
                                                rt: 0,
                                                rb: 0,
                                                lb: 0,
                                                all: 0,
                                                filletType: 'Fixed'
                                            },
                                            "edge": {
                                                top: 0,
                                                right: 0,
                                                bottom: 0,
                                                left: 0
                                            },
                                            lineWidth: 0,
                                            type: "Color",
                                            lineType:"solid",
                                            resource: {
                                                "identifier": '',
                                                "provider": ''
                                            },
                                            color: '#000000',
                                        };
                                    }
                                    replaceImagebox1(offsetX, offsetY, JSON.parse(item), border);
                                }else {
                                    vm.levelIndex = imgindex;
                                    var item = JSON.parse($('#' + data).attr('data-item'));
                                    vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox.mask.resource.identifier = item.resource.identifier;
                                    if (data.indexOf('Round') > '-1') {
                                        if(vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox.border){
                                            vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox.border.shape = 'Ellipse';
                                        }else{
                                            vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox.border= {
                                                shape: 'Ellipse',
                                                radius: {
                                                    lt: 0,
                                                    rt: 0,
                                                    rb: 0,
                                                    lb: 0,
                                                    all: 0,
                                                    filletType: 'Fixed'
                                                },
                                                "edge": {
                                                    top: 0,
                                                    right: 0,
                                                    bottom: 0,
                                                    left: 0
                                                },
                                                lineWidth: 0,
                                                type: "Color",
                                                lineType:"solid",
                                                resource: {
                                                    "identifier": '',
                                                    "provider": ''
                                                },
                                                color: '#000000',
                                            };
                                        }

                                        vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox.shadow= {
                                            color:'#777777',
                                            x:0,
                                            y:0,
                                            blur:0
                                        }
                                    } else if (data.indexOf('Rectangle') > '-1') {
                                        if(vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox.border){
                                            vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox.border.shape = 'Rectangle';
                                        }else{
                                            vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox.border= {
                                                shape: 'Rectangle',
                                                radius: {
                                                    lt: 0,
                                                    rt: 0,
                                                    rb: 0,
                                                    lb: 0,
                                                    all: 0,
                                                    filletType: 'Fixed'
                                                },
                                                "edge": {
                                                    top: 0,
                                                    right: 0,
                                                    bottom: 0,
                                                    left: 0
                                                },
                                                lineWidth: 0,
                                                type: "Color",
                                                lineType:"solid",
                                                resource: {
                                                    "identifier": '',
                                                    "provider": ''
                                                },
                                                color: '#000000',
                                            };
                                        }

                                        vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox.border= {
                                            shape: 'Rectangle',
                                            radius: {
                                                lt: 0,
                                                rt: 0,
                                                rb: 0,
                                                lb: 0,
                                                all: 0,
                                                filletType: 'Fixed'
                                            },
                                            "edge": {
                                                top: 0,
                                                right: 0,
                                                bottom: 0,
                                                left: 0
                                            },
                                            lineWidth: 0,
                                            type: "Color",
                                            lineType:"solid",
                                            resource: {
                                                "identifier": '',
                                                "provider": ''
                                            },
                                            color: '#000000',
                                        };
                                        vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox.shadow= {
                                            color:'#777777',
                                            x:0,
                                            y:0,
                                            blur:0
                                        }
                                    }
                                }
                                $timeout(function () {
                                    cookie();
                                },500)
                            }
                            //边框
                            if (data.indexOf('dragtargetFrameConfig') != '-1') {
                                var item = $('#' + data).attr('data-item');
                                var imgindex = e.target.dataset.imgindex;
                                if(imgindex == null){
                                    var borderList = vm.borderList[$('#' + data).attr('data-index')];
                                    getImageInfo(borderList.resource).then(function (data1) {
                                        var imgZoom = 1;
                                        if (data1.width > data1.height) {
                                            imgZoom = 200 / data1.width
                                        } else {
                                            imgZoom = 200 / data1.height
                                        }
                                        var _w2 = (imgZoom * data1.width) / (1 + borderList.marginLeft / 100 + borderList.marginRight / 100) / vm.pages[vm.pageIndex].custom.ratio;
                                        var _h2 = (imgZoom * data1.height) / (1 + borderList.marginBottom / 100 + borderList.marginTop / 100) / vm.pages[vm.pageIndex].custom.ratio;
                                        var _level = {
                                            imagebox:{},
                                            seq: vm.pages[vm.pageIndex].levels.level.length + Number(1)
                                        }
                                        var _imagebox = {
                                            blurredrectangle:null,
                                            bokehtype:'None',
                                            bokehtypes:'None',
                                            geometry:{
                                                width: _w2,
                                                height: _h2,
                                                x:(offsetX/vm.pages[vm.pageIndex].custom.ratio - _w2 / 2) || 0,
                                                y:(offsetY/vm.pages[vm.pageIndex].custom.ratio - _h2 / 2) || 0
                                            },
                                            image: {
                                                resource: {
                                                    identifier: item.identifier,
                                                    provider: item.provider
                                                },
                                                filterResource: {
                                                    identifier: '',
                                                    provider: ''
                                                },
                                                width: item.width,
                                                height: item.height,
                                                imgSize: item.imgSize,
                                                index: item.seq,
                                                parameter: angular.fromJson(item.parameter),
                                                scale: 1,
                                                angle: 0
                                            },
                                            mask: {
                                                resource:{
                                                    identifier: '',
                                                    provider: '',
                                                }
                                            },
                                            rotation:{
                                                angle: 0
                                            },
            
                                            border: {
                                                shape: borderList.shape || 'Rectangle',
                                                radius: {
                                                    lt: 0,
                                                    rt: 0,
                                                    rb: 0,
                                                    lb: 0,
                                                    all: 0,
                                                    filletType: 'Fixed'
                                                },
                                                "edge": {
                                                    top: borderList.marginTop,
                                                    right: borderList.marginRight,
                                                    bottom: borderList.marginBottom,
                                                    left: borderList.marginLeft
                                                },
                                                lineWidth: 0,
                                                type: "Pic",
                                                resource: {
                                                    "identifier": borderList.img,
                                                    "provider": borderList.provider
                                                },
                                                color: null,
                                            },
                                            transparency:1,
                                            shadow:{
                                                color:'#777777',
                                                x:0,
                                                y:0,
                                                blur:0
                                            },
                                            useradded: true
                                        }
                                        _level.imagebox = _imagebox;
                                        vm.pages[vm.pageIndex].levels.level.push(_level);
                                    })
                                }else {
                                    vm.levelIndex = imgindex;
                                    var borderList = vm.borderList[$('#' + data).attr('data-index')];
                                    vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox.border = {
                                        shape: borderList.shape || 'Rectangle',
                                        radius: {
                                            lt: 0,
                                            rt: 0,
                                            rb: 0,
                                            lb: 0,
                                            all: 0,
                                            filletType: 'Fixed'
                                        },
                                        "edge": {
                                            top: borderList.marginTop,
                                            right: borderList.marginRight,
                                            bottom: borderList.marginBottom,
                                            left: borderList.marginLeft
                                        },
                                        lineWidth: 0,
                                        type: "Pic",
                                        resource: {
                                            "identifier": borderList.img,
                                            "provider": borderList.provider
                                        },
                                        color: null,
                                    }
                                }
                                $timeout(function () {
                                    cookie();
                                },500)
                            }
                            //判读是否是素材
                            if (data.indexOf('dragtargetClipArt') != '-1') {
                                var dataIndex = $('#' + data)[0].getAttribute('data-index');
                                $scope.materialCb(vm.clipArtsList[dataIndex], offsetX,offsetY, true);
                                $scope.$apply();
                            }
                        }
                    })
                }
                $scope.addPhoto = function(photos){
                    if(photos && Array.isArray(photos) && photos.length > 0){
                        for(var i=0; i<photos.length; i++){
                            var photo = photos[i];
                            $scope.recommendPicsCb(photo);
                        }
                    }
                }
                
                function replaceImagebox1(offsetX, offsetY, data, border, value){
                    if (!border) {
                        border = {
                            shape: 'Rectangle',
                            radius: {
                                lt: 0,
                                rt: 0,
                                rb: 0,
                                lb: 0,
                                all: 0,
                                filletType: 'Fixed'
                            },
                            "edge": {
                                top: 0,
                                right: 0,
                                bottom: 0,
                                left: 0
                            },
                            lineWidth: 0,
                            type: "Color",
                            lineType:"solid",
                            resource: {
                                "identifier": ''
                            },
                            color: '#000000',
                        };
                    }
                    var item = angular.copy(data);
                    if(item.type=='picture'){
                        var _level = {
                            imagebox:{},
                            seq: vm.pages[vm.pageIndex].levels.level.length + Number(1)
                        }
                        var _imagebox = {
                            value: value,
                            blurredrectangle:null,
                            bokehtype: angular.copy(vm.article.bokehtype),
                            geometry:{
                                width:0,
                                height:0,
                                x:0,
                                y:0
                            },
                            border: border,
                            shadow:{
                                color:'#777777',
                                x:0,
                                y:0,
                                blur:0
                            },
                            image: {
                                resource: {
                                    identifier: item.identifier,
                                    provider: 'qiniu'
                                },
                                filterResource: {
                                    identifier: '',
                                    provider: 'qiniu'
                                },
                                resourceid:item.sourceId,
                                width: item.width,
                                height: item.height,
                                imageInfo: item.imageInfo,
                                imgSize: item.imgSize,
                                index: item.seq,
                                parameter: angular.fromJson(item.parameter),
                                scale: 1,
                                angle: 0,
                            },
                            transparency:1,
                            mask: {
                                resource:{
                                    identifier: '',
                                    provider: '',
                                }
                            },
                            rotation:{
                                angle: 0
                            }
                        }

                        var w = 200 / vm.pages[vm.pageIndex].custom.ratio;
                        var h = 200 / vm.pages[vm.pageIndex].custom.ratio;
                        var imgR = w/h;
                        var imgR1 = item.width/item.height;

                        if(imgR >= imgR1){
                            _imagebox.geometry.width= h/item.height*item.width;
                            _imagebox.geometry.height= h;
                        }else {
                            _imagebox.geometry.width= w;
                            _imagebox.geometry.height= w/item.width*item.height;
                        }

                        _imagebox.geometry.x = (offsetX/vm.pages[vm.pageIndex].custom.ratio-_imagebox.geometry.width/2);
                        _imagebox.geometry.y = (offsetY/vm.pages[vm.pageIndex].custom.ratio-_imagebox.geometry.height/2);
                        _level.imagebox = _imagebox;
                        addImagebox($http, _level.imagebox, function () {
                            vm.pages[vm.pageIndex].levels.level.push(_level);
                        });
                    }
                    if(item.type=="masking"){
                        var newImg = new Image();
                        newImg.crossOrigin = "Anonymous";
                        newImg.src = (item.resource.identifier.indexOf('http') == -1 ? vm.domain : '') + item.resource.identifier + '?imageMogr2/exifModify/eyJPcmllbnRhdGlvbiI6IjEifQ==/rotate';
                        newImg.onload = function () {
                            var _level = {
                                imagebox:{},
                                seq: vm.pages[vm.pageIndex].levels.level.length + Number(1)
                            }
                            var _imagebox = {
                                value: value,
                                blurredrectangle:null,
                                bokehtype: angular.copy(vm.article.bokehtype),
                                geometry:{
                                    width:0,
                                    height:0,
                                    x:0,
                                    y:0
                                },
                                border:border,
                                image: {
                                    resource: {
                                        identifier: '',
                                        provider: ''
                                    },
                                    filterResource: {
                                        identifier: '',
                                        provider: 'qiniu'
                                    },
                                    scale: 1,
                                    angle: 0
                                },
                                mask: {
                                    resource:{
                                        identifier: item.resource.identifier,
                                        provider: 'qiniu',
                                    }
                                },
                                rotation:{
                                    angle: 0
                                },
                                transparency:1,
                                shadow:{
                                    color:'#777777',
                                    x:0,
                                    y:0,
                                    blur:0
                                },
                            };
                            var w = 200 / vm.pages[vm.pageIndex].custom.ratio;
                            var h = 200 / vm.pages[vm.pageIndex].custom.ratio;
                            var imgR = w/h;
                            var imgR1 = newImg.width/newImg.height;

                            if(imgR >= imgR1){
                                _imagebox.geometry.width= h/newImg.height*newImg.width;
                                _imagebox.geometry.height= h;
                            }else {
                                _imagebox.geometry.width= w;
                                _imagebox.geometry.height= w/newImg.width*newImg.height;
                            }
                            _imagebox.geometry.x = (offsetX/vm.pages[vm.pageIndex].custom.ratio-_imagebox.geometry.width/2);
                            _imagebox.geometry.y = (offsetY/vm.pages[vm.pageIndex].custom.ratio-_imagebox.geometry.height/2);
                            _level.imagebox = _imagebox;
                            vm.pages[vm.pageIndex].levels.level.push(_level);
                            $scope.$digest();
                        };
                    }
                }
                $scope.recommendPicsCb = function(item){
                    if(vm.elementOn.name == 'imagebox'){
                        replaceImagebox(item,vm.elementOn.index);
                    }else{
                        vm.pages[vm.pageIndex].levels.level.forEach(function(level,levelIndex){
                            (function(level1,levelIndex1){
                                if (level1.imagebox && level1.imagebox.geometry) {
                                    replaceImagebox(item,levelIndex1);
                                }
                            })(level,levelIndex)
                        })
                    }
                }
                function replaceImagebox(data,levelIndex){
                    var item = angular.copy(data);
                    var _imagebox = vm.pages[vm.pageIndex].levels.level[levelIndex].imagebox;
                    if(!_imagebox.bokehtype){
                        _imagebox.bokehtype = 'None';
                    }
                    _imagebox.whiteInk = null;
                    _imagebox.whiteInk2 = null;
                    _imagebox.image = {
                        resource: {
                            identifier: item.identifier,
                            provider: 'qiniu'
                        },
                        filterResource: {
                            identifier: '',
                            provider: 'qiniu'
                        },
                        offsetx:0,
                        offsety:0,
                        resourceid:item.sourceId,
                        width: item.width,
                        height: item.height,
                        imageInfo: item.imageInfo,
                        imgSize: item.imgSize,
                        index: item.seq,
                        parameter: angular.fromJson(item.parameter),
                        scale: 1,
                        angle: 0,
                    }
                    getBlurredrectangle(_imagebox,vm.pageIndex)
                }
                function getBlurredrectangle(imagebox, index) {
                    var item = imagebox;
                    if(!item.image){
                        return
                    }
                    addImagebox($http, imagebox, function () {
                        var newImg = angular.copy({
                            width: imagebox.image.width,
                            height: imagebox.image.height
                        })
                        if ((imagebox.geometry.width - imagebox.geometry.height) * (newImg.width - newImg.height) < 0) {
                            if (index % 2 === 0){
                                if(imagebox.flip){
                                    imagebox.image.angle = imagebox.image.angle+90;
                                }else{
                                    imagebox.image.angle = imagebox.image.angle-90;
                                }
                                imagebox.image.width = newImg.height;
                                imagebox.image.height = newImg.width;
                            }
                            if (index % 2 === 1){
                                if(imagebox.flip){
                                    imagebox.image.angle = imagebox.image.angle-90;
                                }else{
                                    imagebox.image.angle = imagebox.image.angle+90;
                                }
                                imagebox.image.width = newImg.height;
                                imagebox.image.height = newImg.width;
                            }
                        } else {
                            imagebox.image.angle = imagebox.image.angle;
                        }
                        getBackgroundSource3(imagebox, imagebox.geometry.width, imagebox.geometry.height, imagebox.image, imagebox.bokehtype, $scope);
                    },true);
                }
                $scope.layoutCb = function(item){
                    if(!item.config || !item.config.partid){
                        MessageService.error($translate.instant("pagePhoto.message.layoutError"));
                        return
                    }
                    if(vm.pages[vm.pageIndex].config.partid!=item.config.partid){
                        MessageService.error($translate.instant("editorMessage.不是相同部件的版式不可替换"));
                        return
                    }
                    if(item.uuid != vm.pages[vm.pageIndex].uuid){
                        vm.threeLoading = true;
                        vm.threeLoadingText = $translate.instant("editorCommon.loadingText1");
                        item.config = vm.pages[vm.pageIndex].config;
                        var pages = {
                            config:vm.template.config,
                            pages:{
                                page: [angular.copy(item)]
                            }
                        }
                        documentAnalysis($scope, $http, vm, pages,FontManagement,'processing', function(page){
                            if(vm.windowH / page.custom.height >= vm.windowW / page.custom.width ){
                                page.custom.ratio = vm.windowW / page.custom.width;
                            }else {
                                page.custom.ratio = vm.windowH / page.custom.height;
                            }
                        }, function () {
                            $timeout(function () {
                                var layoutPage = pages.pages.page[0];
                                layoutPage.backup = false;
                                layoutPage.unreplace = false;
                                layoutPage.quantity = vm.pages[vm.pageIndex].quantity;
                                pageDataInfo(layoutPage)
                            },200)
                        })
                    }
                }
                function pageDataInfo(page) {
                    vm.threeLoading = true;
                    vm.threeLoadingText = $translate.instant("editorCommon.loadingText1");
                    page.uuid = getUuid();
                    var _pageData = angular.copy(vm.pages[vm.pageIndex]);
                    var _pageDataImageboxImage = [];
                    var _pageDataImageboxImageSum = 0;
                    for(var i=0; i<_pageData.levels.level.length; i++){
                        var _lecel = _pageData.levels.level[i];
                        if(_lecel.imagebox && _lecel.imagebox.image && _lecel.imagebox.image.resource && _lecel.imagebox.image.resource.identifier){
                            _lecel.imagebox.imgRatio = _lecel.imagebox.image.width/_lecel.imagebox.image.height;
                            _pageDataImageboxImage.push(_lecel.imagebox)
                        }
                    }
                    if(!page.levels.level){
                        page.levels.level=[];
                    }
                    _pageDataImageboxImage = imageboxAdapt(page.levels.level, _pageDataImageboxImage);
                    angular.forEach(page.levels.level, function (level, i) {
                        if (level.imagebox) {
                            var _imagebox = null;
                            for(var j=0; j<_pageDataImageboxImage.length; j++){
                                if(_pageDataImageboxImage[j].imageboxIndex == _pageDataImageboxImageSum){
                                    _imagebox = _pageDataImageboxImage[j];
                                    break
                                }
                            }
                            _pageDataImageboxImageSum++;
                            if (_imagebox) {
                                level.imagebox.bokehtype = level.imagebox.bokehtype || vm.article.bokehtype || 'None';
                                level.imagebox.whiteInk = null;
                                level.imagebox.whiteInk2 = null;
                                level.imagebox.image = {
                                    blurredrectangle: {
                                        width: 0,
                                        height: 0,
                                        x: 0,
                                        y: 0
                                    },
                                    resource: {
                                        identifier: _imagebox ? _imagebox.image.resource.identifier : '',
                                        provider: _imagebox ? _imagebox.image.resource.provider : 'qiniu'
                                    },
                                    resourceid:_imagebox ? _imagebox.image.resourceid : '',
                                    filterResource: {
                                        identifier: '',
                                        provider: 'qiniu'
                                    },
                                    angle: 0,
                                    offsetx: 0,
                                    offsety: 0,
                                    imageInfo: _imagebox? _imagebox.image.imageInfo : '',
                                    width: _imagebox ? _imagebox.image.width : '',
                                    height: _imagebox ? _imagebox.image.height : '',
                                    imgSize: _imagebox ? _imagebox.image.imgSize : '',
                                    index: _imagebox ? _imagebox.image.seq : '',
                                    parameter: _imagebox ? angular.fromJson(_imagebox.image.parameter) : [],
                                    scale: 1,
                                    brightness:_imagebox ?_imagebox.image.brightness : 0,
                                    contrast: _imagebox ?_imagebox.image.contrast : 0,
                                    saturate: _imagebox ?_imagebox.image.saturate : 0,
                                    temperature: _imagebox ?_imagebox.image.temperature : 0,
                                    hue: _imagebox ?_imagebox.image.hue : 0
                                }
                                if (level.imagebox.image.resource.identifier) {
                                    getBlurredrectangle(level.imagebox,(vm.pageIndex % 2 === 0 ? 0 : 1))
                                }
                            } else {
                                level.imagebox.bokehtype = level.imagebox.bokehtype || vm.article.bokehtype || 'None';
                                level.imagebox.whiteInk = null;
                                level.imagebox.whiteInk2 = null;
                                level.imagebox.image = {
                                    resource: {
                                        identifier: '',
                                        provider: ''
                                    },
                                    resourceid:"",
                                    filterResource: {
                                        identifier: '',
                                        provider: ''
                                    },
                                    width: '',
                                    height: '',
                                    imgSize: '',
                                    offsetx: 0,
                                    offsety: 0,
                                    index: '',
                                    parameter: [],
                                    scale: 1,
                                    angle: 0,
                                }
                            }
                        }
                    })
                    $timeout(function () {
                        vm.pages[vm.pageIndex] = page;
                        vm.pages[vm.pageIndex].backup = false;
                        vm.pages[vm.pageIndex].unreplace = false;
                        vm.threeLoading = false;
                        vm.threeLoadingText = '';
                        MessageService.success($translate.instant("editorMessage.formatReplacementSucceeded"));
                    },200)
                }
                /***********************  边框  ****************************/
                vm.borderUnfold = false;
                $scope.bordersCb = function(label, index){
                    vm.borderId = label;
                    vm.borderPage = 0;
                    vm.borderList = [];
                    borderInit(vm.borderId);
                }
                $scope.loadMoreBorder = function () {
                    vm.borderPage++;
                    borderInit(vm.borderId);
                }
                function borderInit(item){
                    vm.borderId = item;
                    if(!vm.borderId){
                        angular.forEach(vm.template.frameConfigs.frameConfig, function (data) {
                            vm.borderList.push(data);
                        })
                        return
                    }
                    vm.borderLoading = true;
                    FrameConfigs.byCondition3({
                        items: [{key: "themeClassify.id", op: "=", value: item.id},{key: "enable", op: "=", value: true},{key: "status", op: "=", value: 'Approved'}],
                        page: vm.borderPage,
                        size: vm.itemsPerPage,
                        sort: ["seq,asc"]
                    }, function (res, headers) {
                        vm.borderLoading = false;
                        angular.forEach(res.data, function (resp) {
                            vm.borderList.push(resp);
                        })
                        var _sum = headers('X-Total-Count');
                        if(vm.borderList.length < _sum){
                            vm.borderFulfill = true;
                        }else {
                            vm.borderFulfill = false;
                        }
                    }, function () {
                    })
                }
                /***********************  边框end  ****************************/
                /***********************  背景  ****************************/
                
                $scope.backgroundColor = function(color){
                    vm.pages[vm.pageIndex].background.color = color ? color : null;
                    vm.pages[vm.pageIndex].background.type = "Color";
                    vm.pages[vm.pageIndex].background.resource.identifier = "";
                    vm.pages[vm.pageIndex].background.resource.provider = '';
                    vm.pages[vm.pageIndex].background.offsetx = 0;
                    vm.pages[vm.pageIndex].background.offsety = 0;
                    cookie();
                }
                $scope.backgroundImage = function(data){
                    vm.pages[vm.pageIndex].background.type = "Pic";
                    vm.pages[vm.pageIndex].background.resource.identifier = data.identifier;
                    vm.pages[vm.pageIndex].background.resource.provider = data.provider;
                    vm.pages[vm.pageIndex].background.offsetx = 0;
                    vm.pages[vm.pageIndex].background.offsety = 0;
                    vm.pages[vm.pageIndex].background.imageInfo = null;
                    getBackgroundSource($http,vm.pages[vm.pageIndex].background.resource, vm.pages[vm.pageIndex].trimbox.width, vm.pages[vm.pageIndex].trimbox.height, vm.pages[vm.pageIndex].background, function () {
                        cookie();
                    })
                }
                /***********************  背景end  ****************************/
                /***********************  顶部操作  ****************************/
                function toolbarStatus(){
                    vm.isTransp = false;
                    vm.isRoundedSet = false;
                    vm.isBorderSet = false;
                    vm.isShadowSet = false;
                    vm.isCoverage = false;
                    vm.isAlign = false;
                    vm.isOperationSpacing = false;
                    vm.isOperationDir = false;
                    vm.isOperationColor = false;
                }
                // 圆角设置
                vm.isRoundedSet = false;
                $scope.roundedSet = function(attr){
                    toolbarStatus();
                    vm.borderRadiusAllbtn = false;
                    vm.isRoundedSet = attr;
                }
                $scope.changeFilletType = function(type){
                    if (vm.elementOn.item.border.radius.filletType == type) {
                        return
                    }
                    vm.elementOn.item.border.radius.filletType = type;
                    switchToRoundedMode(vm.elementOn.item,vm.borderRadiusAllbtn);//切换圆角显示模式
                }
                vm.borderRadiusAllbtn = false
                $scope.borderRadiusAll = function () {
                    vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.border.radius.lt = vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.border.radius.all;
                    vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.border.radius.rt = vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.border.radius.all;
                    vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.border.radius.rb = vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.border.radius.all;
                    vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.border.radius.lb = vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.border.radius.all;
                }
                $scope.borderRadiusAllbtn = function(){
                    vm.borderRadiusAllbtn = true;
                    vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.border.radius.rt = vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.border.radius.lt;
                    vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.border.radius.rb = vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.border.radius.lt;
                    vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.border.radius.lb = vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.border.radius.lt;
                    vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.border.radius.all = vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.border.radius.lt
                }
                // 边框设置
                vm.isBorderSet = false;
                $scope.borderSet = function(attr){
                    toolbarStatus();
                    vm.isBorderSet = attr;
                }
                $scope.lineTypeChenge = function(lineType){
                    vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.border.lineType = lineType;
                }
                // 阴影设置
                vm.isShadowSet = false;
                $scope.shadowSet = function(attr){
                    toolbarStatus();
                    vm.isShadowSet = attr;
                }
                //图片优化
                vm.showCanvasImageFilter = false;
                // 图片优化
                $scope.optimizationSelect = function (attr) {
                    if (!vm.elementOn.name=='imagebox') {
                        MessageService.error($translate.instant("editorMessage.请选中一个照片"));
                        return
                    }
                    if(vm.elementOn.item.image && vm.elementOn.item.image.resourceid) {
                        // 获取原图信息
                        Gallery.getOne({id:vm.elementOn.item.image.resourceid},function (res){
                            vm.elementOn.item.image.resource.primary = res.data.identifier;
                            // 图片优化
                            if (vm.elementOn.item.image && vm.elementOn.item.image.resource && vm.elementOn.item.image.resource.identifier) {
                                toolbarStatus();
                                var current = vm.elementOn.item;
                                if (current.image) {
                                    vm.showCanvasImageFilter = true;
                                    if(vm.elementOn.item.optimizations){
                                        vm.optimizations = vm.elementOn.item.optimizations;
                                    }
                                } else {
                                    MessageService.error($translate.instant("editorMessage.请选择一个相框"));
                                }
                            }
                        })
                    }
                }

                $rootScope.$on('editorApp.closeImageFilter', function () {
                    vm.showCanvasImageFilter = false;
                });
                $rootScope.$on('editorApp.saveImageFilter', function (event,imgUrl) {
                    vm.showCanvasImageFilter = false;
                    filterImgUpdate(imgUrl);
                });

                function filterImgUpdate(img){
                    vm.elementOn.item.imageLoading = true;
                    QiniuToken.uploadThumbnail(img, function (data) {
                        $.ajax({
                            type: "GET",
                            url: vm.elementOn.item.image.resource.identifier + "?imageInfo",
                            async: false,
                            success: function (va) {
                                var identifier = vm.domain + data.key;
                                vm.elementOn.item.image.resource.identifier = identifier;
                                vm.elementOn.item.imageLoading = false;
                                cookie();
                                $timeout(function() {
                                    vm.elementOn.item.imageLoading = false;
                                })
                                if(va.orientation){
                                    imageboxImgInit();
                                }
                            }
                        })
                    });
                }
                function imageboxImgInit(){
                    $.ajax({
                        type: "GET",
                        url: vm.domain + vm.elementOn.item.image.resource.primary + "?imageInfo",
                        async: false,
                        success: function (va1) {
                            var angle = (vm.elementOn.item.image.angle + 360 - orientationInit1(va1.orientation).angle) % 360;
                            if (vm.elementOn.item.flip) {
                                vm.elementOn.item.image.angle = -angle;
                                vm.elementOn.item.flip = false;
                            }else{
                                vm.elementOn.item.image.angle = angle;
                            }
                        }
                    });
                }
                // 透明度
                vm.isTransp = false;
                $scope.transparencySelect = function () {
                    toolbarStatus()
                    if(!vm.isTransp && vm.elementOn.name !='imageart' && vm.elementOn.name !='textbox' && vm.elementOn.name !='imagebox' ){
                        MessageService.error($translate.instant("editorMessage.pleaseChooseLevel1"));
                        return
                    }
                    vm.isTransp = !vm.isTransp;
                    if(vm.isTransp){
                        var _transparency = 0;
                        if(vm.elementOn.name =='imagebox'){
                            _transparency = vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.transparency || 1;
                        }
                        if(vm.elementOn.name =='imageart'){
                            _transparency = vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imageart.transparency || 1;
                        }
                        if(vm.elementOn.name =='textbox' ){
                            _transparency = vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox.transparency || 1;
                        }
                        $timeout(function () {
                            $(".text-range-140").val(_transparency);
                            $(".transparency-num").val(_transparency * 100);
                            vm.transparency = _transparency * 100;
                        })
                    }
                }
                var elem = document.querySelector('input[type="range"]');
                var rangeValue = function () {
                    $(".transparency-num").val(elem.value * 100);
                    vm.transparency = elem.value * 100;
                    var all = getAllCtrlKeyArray();
                    if(all.length>0){
                        levelMove(null, 'transparency')
                    }else{
                        transparencyInit();
                    }
                    $scope.$apply();
                };
        
                elem.addEventListener("input", rangeValue);
                $scope.transparencyChange = function () {
                    if (vm.transparency > 100) {
                        MessageService.error($translate.instant("editorMessage.transparencyInvalid"));
                        vm.transparency = 100;
                    }
                    if (vm.transparency < 0) {
                        MessageService.error($translate.instant("editorMessage.transparencyInvalid"));
                        vm.transparency = 0;
                    }
                    transparencyInit(vm.transparency)
                }
                function transparencyInit() {
                    if(vm.elementOn.name =='imagebox'){
                        vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.transparency = vm.transparency/100;
                        return
                    }
                    if(vm.elementOn.name =='imageart'){
                        vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imageart.transparency = vm.transparency/100;
                        return
                    }
                    if(vm.elementOn.name =='textbox' ){
                        vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox.transparency = vm.transparency/100;
                        return
                    }
                }
                // 单个元素对齐
                vm.isAlign = false;
                $scope.alignHover2 = function () {
                    if(vm.elementOn.name == ''){
                        MessageService.error($translate.instant("editorMessage.pleaseSelectAElement"));
                        return
                    }
                    toolbarStatus();
                    vm.isAlign = !vm.isAlign;
                }

                $scope.singleBoxAlignment = function (attr) {
                    if(vm.toobarAlignmentBtn){
                        $scope.boxAlignment(attr);
                        return
                    }
                    if (vm.elementOn.item.lock) {
                        MessageService.error($translate.instant("editorMessage.pleaseSelectALock"));
                        return
                    }
                    if (attr == 'left') {
                        vm.elementOn.item.geometry.x = elementAlign(vm.elementOn.item.geometry , vm.elementOn.item.rotation.angle , 'left' , vm.pages[vm.pageIndex].custom.width , vm.pages[vm.pageIndex].custom.height);
                    } else if (attr == 'right') {
                        vm.elementOn.item.geometry.x = elementAlign(vm.elementOn.item.geometry , vm.elementOn.item.rotation.angle , 'right' , vm.pages[vm.pageIndex].custom.width , vm.pages[vm.pageIndex].custom.height);
                    } else if (attr == 'top') {
                        vm.elementOn.item.geometry.y = elementAlign(vm.elementOn.item.geometry , vm.elementOn.item.rotation.angle , 'top' , vm.pages[vm.pageIndex].custom.width , vm.pages[vm.pageIndex].custom.height);
                    } else if (attr == 'bottom') {
                        vm.elementOn.item.geometry.y = elementAlign(vm.elementOn.item.geometry , vm.elementOn.item.rotation.angle , 'bottom' , vm.pages[vm.pageIndex].custom.width , vm.pages[vm.pageIndex].custom.height);
                    } else if (attr == 'vertical') {
                        vm.elementOn.item.geometry.y = (vm.pages[vm.pageIndex].custom.height - vm.elementOn.item.geometry.height) / 2;
                    } else {
                        vm.elementOn.item.geometry.x = (vm.pages[vm.pageIndex].custom.width - vm.elementOn.item.geometry.width) / 2;
                    }
                    cookie()
                }
                $scope.boxAlignment = function (attr) {
                    var levels = vm.pages[vm.pageIndex].levels;
                    var all = getAllCtrlKeyArray();
                    if (attr == 'left') {
                        all.sort(compare2('x', true));
                    } else if (attr == 'right') {
                        all.sort(compare2('width', false));
                        all.sort(compare2('x', false));
                    } else if (attr == 'top') {
                        all.sort(compare2('y', true));
                    } else if (attr == 'bottom') {
                        all.sort(compare2('height', false));
                        all.sort(compare2('y', false));
                    }
                    if(attr == 'vertical' && all.length>0){
                        var verticalY = horizontalAndVerticalCenter(attr, all);
                    }
                    if(attr == 'standard' && all.length>0){
                        var standardX = horizontalAndVerticalCenter(attr, all);
                    }
        
                    for (var i = 0; i < all.length; i++) {
                        if(!all[i].lock){
                            if (attr == 'left') {
                                all[i].geometry.x = all[0].geometry.x;
        
                            } else if (attr == 'right') {
                                all[i].geometry.x = all[0].geometry.x + all[0].geometry.width - all[i].geometry.width;
        
                            } else if (attr == 'top') {
                                all[i].geometry.y = all[0].geometry.y;
        
                            } else if (attr == 'bottom') {
                                all[i].geometry.y = all[0].geometry.y + all[0].geometry.height - all[i].geometry.height;
        
                            } else if (attr == 'vertical') {
                                all[i].geometry.y = verticalY - all[i].geometry.height / 2;
                            } else {
                                all[i].geometry.x = standardX - all[i].geometry.width / 2;
                            }
        
        
                            if (all[i].current == 'imagebox') {
                                levels.level[all[i].levelI].imagebox = all[i];
                            } else if (all[i].current == 'textbox') {
                                levels.level[all[i].levelI].textbox = all[i];
                            } else {
                                levels.level[all[i].levelI].imageart = all[i];
                            }
                        }
                    }
                    // levelInif()
                    cookie()
                }
                // 元素水平垂直分布
                vm.isDistributeHover = false;
                $scope.distribute = function(){
                    vm.isDistributeHover = !vm.isDistributeHover;
                    vm.isAlignHover = false;
                }
                $scope.boxDistribute = function (direction){
                    var all1 = getAllCtrlKeyArray();
                    var all = [];
                    all1.forEach(function(box){
                        if (!box.lock) {
                            all.push(box)
                        }
                    })
                    if (all.length < 3) {
                        MessageService.error($translate.instant("editorMessage.请选择3个以上非锁定状态的元素"));
                        return
                    }
                    if(direction == 'horizontal'){
                        setAllCtrlKeyArray(all, 'x')
                    }
                    if(direction == 'vertical'){
                        setAllCtrlKeyArray(all, 'y')
                    }
                }
                function setAllCtrlKeyArray(all, attr) {
                    var len = all.length - 1;
                    all.sort(compare2(attr, true));
                    if (attr == 'x') {
                        var elementAllWidth = 0;
                        for (var i = 1; i < len; i++) {
                            elementAllWidth+=all[i].geometry.width;
                        }
                        var spacingPx = (all[len].geometry.x - all[0].geometry.x - all[0].geometry.width - elementAllWidth) / len;
                        for (var i = 1; i < len; i++) {
                            all[i].geometry.x = all[i-1].geometry.x + all[i-1].geometry.width + spacingPx;
                        }
                    }
                    if (attr == 'y') {
                        var elementAllHeight = 0;
                        for (var i = 1; i < len; i++) {
                            elementAllHeight+=all[i].geometry.height;
                        }
                        var spacingPx = (all[len].geometry.y - all[0].geometry.y - all[0].geometry.height - elementAllHeight) / len;
                        for (var i = 1; i < len; i++) {
                            all[i].geometry.y = all[i-1].geometry.y + all[i-1].geometry.height + spacingPx;
                        }
                    }
                }
                //图层
                vm.isCoverage = false;
                $scope.coverageMove = coverageMove;
                $scope.coverageSelect = function (attr) {
                    if(vm.elementOn.name == ''){
                        MessageService.error($translate.instant("editorMessage.pleaseSelectAElement"));
                        return
                    }
                    if(vm.elementOn.item.lock){return}
                    toolbarStatus();
                    vm.isCoverage = attr;
                }
                function coverageMove(data){
                    if(vm.elementOn.item.lock){return}
                    var _seq = Number(vm.pages[vm.pageIndex].levels.level.length);
                    if(data == "up"){
                        if(vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].seq == _seq){
                            MessageService.error($translate.instant("editorMessage.topLevel"));
                            return;
                        }
                        var seq = angular.copy(vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].seq+1);
                        vm.pages[vm.pageIndex].levels.level.forEach(function (level) {
                            if(level.seq == seq){
                                level.seq--
                            }
                        })
                        vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].seq++
                    }
                    if(data == "down"){
                        if(vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].seq <2){
                            MessageService.error($translate.instant("editorMessage.bottomLevel"));
                            return;
                        }
                        var seq = angular.copy(vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].seq-1);
                        vm.pages[vm.pageIndex].levels.level.forEach(function (level) {
                            if(level.seq == seq){
                                level.seq++
                            }
                        });
                        vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].seq--
                    }
                    if(data == "top"){
                        if(vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].seq == _seq){
                            MessageService.error($translate.instant("editorMessage.topLevel"));
                            return;
                        }
                        var seq = angular.copy(vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].seq);
                        for (var i = 0; i < vm.pages[vm.pageIndex].levels.level.length; i++) {
                            if(vm.pages[vm.pageIndex].levels.level[i].seq > seq){
                                vm.pages[vm.pageIndex].levels.level[i].seq--;
                            }
                        }
                        vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].seq = _seq
                    }
                    if(data == "bottom"){
                        if(vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].seq == 0){
                            MessageService.error($translate.instant("editorMessage.bottomLevel"));
                            return;
                        }
        
                        var seq = angular.copy(vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].seq);
                        for (var i = 0; i < vm.pages[vm.pageIndex].levels.level.length; i++) {
                            if(vm.pages[vm.pageIndex].levels.level[i].seq < seq){
                                vm.pages[vm.pageIndex].levels.level[i].seq+=1;
                            }
                        }
                        vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].seq = 1;
                    }
        
                    var _seq = angular.copy(vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].seq);
                    var _levelI = vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].seq - 1;
                    vm.pages[vm.pageIndex].levels.level.sort(compare('seq', true));
                    for (var i = 0; i < vm.pages[vm.pageIndex].levels.level.length; i++) {
                        if(vm.pages[vm.pageIndex].levels.level[i].seq == _seq){
                            _levelI = i;
                            break
                        }
                    }
                    vm.elementOn.index = _levelI;
                    cookie();
                }
                function compare(property) {
                    return function (a, b) {
                        var value1 = a[property];
                        var value2 = b[property];
                        return value1 - value2;
                    }
                }
                //复制
                $scope.copyimg = vm.copyimg = function ($event) {
                    var all = getAllCtrlKeyArray();
                    if(!vm.clickNum){
                        vm.clickNum = 0;
                    }
                    vm.clickNum+=10;
                    if(all.length>0){
                        all.forEach(function (item) {
                            (function (item1) {
                                var _level = {
                                    seq: vm.pages[vm.pageIndex].levels.level.length + 1,
                                }
                                _level[item1.current] = angular.copy(item1);
                                _level[item1.current].lock = false;
                                _level[item1.current].ctrlKey = false;
                                _level[item1.current].geometry.x += vm.clickNum/vm.pages[vm.pageIndex].custom.ratio;
                                _level[item1.current].geometry.y += vm.clickNum/vm.pages[vm.pageIndex].custom.ratio;
                                vm.pages[vm.pageIndex].levels.level.push(_level);
                            })(item)
                        })
                    }else{
                        if(!vm.elementOn.item){return}
                        var _level = {
                            seq: vm.pages[vm.pageIndex].levels.level.length + 1
                        }
                        if(vm.elementOn.name == "imagebox"){
                            _level.imagebox = angular.copy(vm.elementOn.item);
                            _level.imagebox.lock = false;
                            _level.imagebox.geometry.x += vm.clickNum/vm.pages[vm.pageIndex].custom.ratio;
                            _level.imagebox.geometry.y += vm.clickNum/vm.pages[vm.pageIndex].custom.ratio;
                        }
                        if(vm.elementOn.name == "imageart"){
                            _level.imageart = angular.copy(vm.elementOn.item);
                            _level.imageart.lock = false;
                            _level.imageart.geometry.x += vm.clickNum/vm.pages[vm.pageIndex].custom.ratio;
                            _level.imageart.geometry.y += vm.clickNum/vm.pages[vm.pageIndex].custom.ratio;
                        }
                        if(vm.elementOn.name == "textbox"){
                            _level.textbox = angular.copy(vm.elementOn.item);
                            _level.textbox.lock = false;
                            _level.textbox.geometry.x += vm.clickNum/vm.pages[vm.pageIndex].custom.ratio;
                            _level.textbox.geometry.y += vm.clickNum/vm.pages[vm.pageIndex].custom.ratio;
                        }
                        vm.pages[vm.pageIndex].levels.level.push(_level);
                    }
                    levelSeqSort(vm.pages[vm.pageIndex].levels.level);
                    cookie();
                }
                function levelSeqSort(levels){
                    if(levels){
                        var seq = 0;
                        levels.forEach(function(level){
                            level.seq = seq;
                            seq++
                        })
                        levels.sort(compare('seq', true));
                    }
                }
                
                vm.copyArray = {imageboxes: [], textboxes: [], imagearts: [], barcode: [], qrcode: [], textdocuments: []};
                // 复制元素
                vm.copyElement = function(){
                    if(vm.copyArray.imageboxes.length == 0 && vm.copyArray.imagearts.length == 0 && vm.copyArray.textboxes.length == 0){
                        return;
                    }
                    copyTogether();
                }

                // 多选调用
                function copyTogether(){
                    angular.forEach(vm.copyArray.imageboxes, function (imagebox, i) {
                        if(imagebox&&imagebox.geometry){
                            // 当前页所有占位框
                            var box = angular.copy(imagebox);
                            var _level = {
                                seq: vm.pages[vm.pageIndex].levels.level.length + 1
                            }
                            _level.imagebox = angular.copy(copyDetail(box));
                            vm.pages[vm.pageIndex].levels.level.push(_level)
                        }

                    })

                    angular.forEach(vm.copyArray.imagearts, function (imageart, i) {
                        if(imageart&&imageart.geometry){
                            if(imageart.serviceType){
                                return
                            }
                            // 当前页所有素材
                            var box = angular.copy(imageart);
                            var _level = {
                                seq: vm.pages[vm.pageIndex].levels.level.length + 1
                            }
                            _level.imageart = angular.copy(copyDetail(box));
                            vm.pages[vm.pageIndex].levels.level.push(_level)
                        }
                    })

                    angular.forEach(vm.copyArray.textboxes, function (textbox, i) {
                        if(textbox&&textbox.geometry){
                            // 当前页所有文字
                            var box = angular.copy(textbox);
                            var _level = {
                                seq: vm.pages[vm.pageIndex].levels.level.length + 1
                            }
                            _level.textbox = angular.copy(copyDetail(box));
                            vm.pages[vm.pageIndex].levels.level.push(_level)
                        }

                    })
                    levelSeqSort(vm.pages[vm.pageIndex].levels.level);
                }
                function copyDetail(box) {
                    box.levelI = vm.pages[vm.pageIndex].levels.level.length-1;
                    box.lock = false;
                    box.ctrlKey = false;
                    var repeatEle = false;
                    vm.pages[vm.pageIndex].levels.level.forEach(function(item){
                        if(item.imagebox && item.imagebox.geometry.x == box.geometry.x && item.imagebox.geometry.y == box.geometry.y){
                            repeatEle = true;
                        }
                        if(item.imageart && item.imageart.geometry.x == box.geometry.x && item.imageart.geometry.y == box.geometry.y){
                            repeatEle = true;
                        }
                        if(item.textbox && item.textbox.geometry.x == box.geometry.x && item.textbox.geometry.y == box.geometry.y){
                            repeatEle = true;
                        }
                        if(item.code && item.code.geometry.x == box.geometry.x && item.code.geometry.y == box.geometry.y){
                            repeatEle = true;
                        }
                    })
                    if(!repeatEle){
                        return box
                    }
                    // 复制上一次的位置
                    if (box.current == 'imagebox') {
                        vm.copyArray.imageboxes.forEach(function(imagebox){
                            if(imagebox && imagebox.geometry.x == box.geometry.x && imagebox.geometry.y == box.geometry.y){
                                var x = PxTurnMm(imagebox.geometry.x) + 1;
                                var y = PxTurnMm(imagebox.geometry.y) + 1;
                                imagebox.geometry.x = MmTurnPx(x);
                                imagebox.geometry.y = MmTurnPx(y);
                            }
                        })
                    }
                    if (box.current == 'imageart') {
                        vm.copyArray.imagearts.forEach(function(imageart){
                            if(imageart && imageart.geometry.x == box.geometry.x && imageart.geometry.y == box.geometry.y){
                                var x = PxTurnMm(imageart.geometry.x) + 1;
                                var y = PxTurnMm(imageart.geometry.y) + 1;
                                imageart.geometry.x = MmTurnPx(x);
                                imageart.geometry.y = MmTurnPx(y);
                            }
                        })
                    }
                    if(box.current == 'textbox'){
                        vm.copyArray.textboxes.forEach(function(textbox){
                            if(textbox && textbox.geometry.x == box.geometry.x && textbox.geometry.y == box.geometry.y){
                                var x = PxTurnMm(textbox.geometry.x) + 1;
                                var y = PxTurnMm(textbox.geometry.y) + 1;
                                textbox.geometry.x = MmTurnPx(x);
                                textbox.geometry.y = MmTurnPx(y);
                            }
                        })
                    }
                    // 新元素
                    var x = PxTurnMm(box.geometry.x) + 1;
                    var y = PxTurnMm(box.geometry.y) + 1;
                    box.geometry.x = MmTurnPx(x);
                    box.geometry.y = MmTurnPx(y);
                    return box
                }
                //裁切
                $scope.doubleClickImagebox = function (event) {
                    $rootScope.$broadcast('doubleClickImageboxCallback',{
                        event: event,
                        index: vm.elementOn.index,
                        item: vm.elementOn.item,
                        pageIndex: vm.elementOn.pageIndex,
                    });
                };
                //交换
                $scope.exchange = function () {
                    vm.pages[vm.pageIndex].levels.level.forEach(function (level, index) {
                        if(level.imagebox){
                            if(index!=vm.elementOn.index){
                                level.imagebox.exchange = true;
                            }else{
                                level.imagebox.exchange = false;
                            }
                        }
                    })
                };
                //智能抠图
                $scope.mattingOpen = function () {
                    if (!vm.elementOn || vm.elementOn.name !== 'imagebox' || !vm.elementOn.item) return;
                    $timeout(function(){
                        var div = document.getElementsByClassName('selected');
                        if (div.length > 0) {
                            var rect = div[0].getBoundingClientRect();
                            vm.imageboxCutout = {
                                image: vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.image.resource.identifier,
                                mattingMask: vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.image.mattingMask,
                                resourceid: vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.image.resourceid,
                                x: rect.left,
                                y: rect.top,
                                width: rect.width,
                                height: rect.height,
                                angle: vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.image.angle,
                                flip: vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.flip,
                            }
                            vm.isShowImageCutout = true;
                        }
                    })
                };
                $scope.imageCutoutChange = function(text){
                    if(text){
                        vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.image.resource.identifier = text.result;
                        vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.image.mattingMask = text.mattingMask;
                        vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.image.angle = text.angle;
                        vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.flip = text.flip;
                    }
                }
                $scope.imageCutoutSave = function(text){
                    vm.isShowImageCutout = false;
                    if(text){
                        vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.image.resource.identifier = text.result;
                        vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.image.mattingMask = text.mattingMask;
                        vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.image.angle = text.angle;
                        vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.flip = text.flip;
                        if(vm.propertyValue.white && vm.propertyValue.white.length){
                            $scope.setProcessImages(vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox);
                        }
                    }
                }
                // 大图判断
                $scope.isLarge = function(imageInfo){
                    if(!imageInfo)return
                    return imageInfo.size >= 20971520 || imageInfo.width > 30000 || imageInfo.height > 30000 || (imageInfo.width*imageInfo.height)>150000000
                }
                /***********************  顶部操作end  ****************************/
                
                $scope.setProcessImages = function(imagebox){
                    if(imagebox.image && imagebox.image.resource && imagebox.image.resource.identifier){
                        processImages(imagebox.image.resource.identifier,null,function(res){
                            var blob = base64ToBlob(res, 'image/' + imagebox.image.imageInfo.format);
                            var _file = blobToFile(blob); 
                            ImageService.backendUploadPics(_file, vm.domain, vm.token, function(data){
                                imagebox.whiteInk = null;
                                imagebox.whiteInk2 = {
                                    resource:{
                                        identifier:vm.domain +data.key
                                    },
                                    growMethod: vm.propertyValue.white[0].epitaxy,
                                    growValue: vm.propertyValue.white[0].epitaxyValue,
                                    unit: vm.propertyValue.white[0].unit,
                                    color: vm.propertyValue.white[0].spotColor,
                                    colorValue: vm.propertyValue.white[0].color,
                                };
                                $scope.$apply();
                            },function(err){
                                MessageService.error($translate.instant("pagePhoto.message.whiteInkSizeMismatch"));
                                $scope.$apply();
                            })
                        },function(error){
                            MessageService.error(error);
                        })
                    }else{
                        MessageService.error($translate.instant("pagePhoto.message.addImageFirst"));
                    }
                }

                vm.chalkItem = null;
                vm.chalkImageart = null;
                vm.chalkWidth = null;
                vm.chalkHeight = null;
                vm.chalkPropertyValue = null;
                $scope.editProcessImages = function(imagebox,propertyValue){
                    if(vm.menuIndex == 'uv' || vm.menuIndex == 'fluore'){
                        vm.chalkImageart = angular.copy($scope.getImageart(vm.pages[vm.pageIndex],vm.menuIndex,propertyValue) || {});
                        vm.chalkWidth = vm.pages[vm.pageIndex].mediabox.width;
                        vm.chalkHeight = vm.pages[vm.pageIndex].mediabox.height;
                        vm.chalkPropertyValue = propertyValue;
                        return
                    }else{
                        if(vm.propertyValue.white && vm.propertyValue.white.length){
                            vm.chalkPropertyValue = vm.propertyValue.white[0];
                        }
                    }
                    if(imagebox.image && imagebox.image.resource && imagebox.image.resource.identifier){
                        vm.chalkItem = imagebox;
                        vm.chalkWidth = vm.chalkItem.image.imageInfo.width;
                        vm.chalkHeight = vm.chalkItem.image.imageInfo.height;
                    }else{
                        MessageService.error($translate.instant("pagePhoto.message.addImageFirst"));
                    }
                }
                $scope.deleteProcessImages = function(item){
                    var index = $scope.getImageart(vm.pages[vm.pageIndex],vm.menuIndex,item,true);
                    if(index >= 0){
                        vm.pages[vm.pageIndex].levels.level.splice(index, 1);
                        $scope.editorBodyView();
                    }
                }
                vm.chalkChange = function(text){
                    if(text){
                        if(vm.menuIndex == 'uv' || vm.menuIndex == 'fluore'){
                            var index = $scope.getImageart(vm.pages[vm.pageIndex],vm.menuIndex,vm.chalkPropertyValue,true);
                            if(index !== null && index > -1){
                                vm.pages[vm.pageIndex].levels.level[index].imageart = text;
                            }else{
                                vm.pages[vm.pageIndex].levels.level.push({
                                    seq: vm.pages[vm.pageIndex].levels.level.length+1,
                                    imageart: text
                                });
                            }
                        }
                    }
                    vm.chalkItem = null;
                    vm.chalkImageart = null;
                }
                $scope.goldFoil = function(color){
                    if(color){
                        return goldFoil(color)
                    }
                }
                $scope.getImageart = function(page,serviceType,propertyValue,isIndex){
                    var imageart = null;
                    if(page && page.levels && page.levels.level){
                        for(var i=0; i<page.levels.level.length; i++){
                            if(page.levels.level[i].imageart && page.levels.level[i].imageart.spotColor && page.levels.level[i].imageart.serviceType === serviceType && page.levels.level[i].imageart.spotColor.uuid == propertyValue.uuid){
                                if(isIndex){
                                    imageart = i;
                                }else{
                                    imageart = page.levels.level[i].imageart;
                                }
                                break
                            }
                        }
                    }
                    return imageart;
                }
                $scope.getImageartSize = function(type,propertyValue){
                    var imageart = $scope.getImageart(vm.pages[vm.pageIndex], vm.menuIndex, propertyValue);
                    if(imageart){
                        var size = 280;
                        if(imageart.geometry.width > imageart.geometry.height){
                            if(type == 'width'){
                                return size
                            }else{
                                return size * imageart.geometry.height / imageart.geometry.width
                            }
                        }else{
                            if(type == 'width'){
                                return size * imageart.geometry.width / imageart.geometry.height
                            }else{
                                return size
                            }
                        }
                    }
                }
                vm.isOutline = false;
                $scope.setOutline = function(){
                    vm.isOutline = true;
                }
                $scope.outlineChange = function(text){
                    vm.isOutline = false;
                    if(text){
                        vm.pages[vm.pageIndex].outline = text.outline;
                        vm.pages[vm.pageIndex].outlineSpread = text.outlineSpread;
                    }
                }
                //缩略图最长边尺寸
                var chalkViewSize = 146;
                $scope.chalkSize = function(imagebox,type){
                    if(!imagebox || !type){
                        return;
                    }
                    //白墨层由整张原图生成，预览要按图片自身比例缩放；geometry 是图片框（裁剪窗口），比例与图片可能不一致
                    var geometry = imagebox.geometry || {};
                    var image = imagebox.image || {};
                    var width = image.width1 || image.width || geometry.width;
                    var height = image.height1 || image.height || geometry.height;
                    var longSide = Math.max(width, height);
                    if(!longSide){
                        return;
                    }
                    return (type == 'width' ? width : height) * chalkViewSize / longSide;
                }
            }]
    };

    angular.module('editorApp')
        .component('pagePhoto', PagePhotoControl);

})();

(function () {
    'use strict';

    var PageMobileEditControl = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/components/page-mobile-edit.html',
        controllerAs: 'vm',
        bindings: {
            editorType: '<',
            pageData: '=',
            pageIndex: '=',
            levelIndex: '=',
            levelType: '=',
            that: '=',
            imgSize: '<',
            imgDpi: '<',
            isSmallPic: '=', //拖动图片图片框显示‘拖拽到此处替换图片’
            transparency: '=', //文字透明度
            isImageboxLock: '=', //照片框的解锁按钮
            notImageboxTip: '=',
        },

        controller: ['$scope','FontManagement','$timeout', function ($scope,FontManagement,$timeout) {
            var vm = this;
            //像素不足提醒
            var throttledResize = angular.throttle(function (item) {
                return pxInsufficient(item, vm.imgSize, vm.imgDpi)
            }, 1000);

            $scope.pxInsufficient = function (item) {
                return pxInsufficient(item, vm.imgSize, vm.imgDpi);
            }
            /***********************  图片框  ****************************/
            //边框
            $scope.imageboxW = function (imagebox) {
                if (!imagebox) {
                    return
                }
                if (imagebox.border) {
                    if (imagebox.border.type == 'Color') {
                        return Number(imagebox.geometry.width) + Number(imagebox.border.lineWidth) * 2
                    }
                    if (imagebox.border.type == 'Pic') {
                        return imagebox.geometry.width
                        // return Number(imagebox.geometry.width) + (Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100) + (Number(imagebox.geometry.width) * Number(imagebox.border.edge.right) / 100)
                    }
                } else {
                    return imagebox.geometry.width
                }
            }
            $scope.imageboxH = function (imagebox) {
                if (!imagebox) {
                    return
                }
                if (imagebox.border) {
                    if (imagebox.border.type == 'Color') {
                        return Number(imagebox.geometry.height) + Number(imagebox.border.lineWidth) * 2
                    }
                    if (imagebox.border.type == 'Pic') {
                        return imagebox.geometry.height
                        // return Number(imagebox.geometry.height) + (Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100) + (Number(imagebox.geometry.height) * Number(imagebox.border.edge.bottom) / 100)
                    }
                } else {
                    return imagebox.geometry.height
                }
            }
            $scope.imageboxL = function (imagebox) {
                if (!imagebox) {
                    return
                }
                if (imagebox.border) {
                    if (imagebox.border.type == 'Color') {
                        return Number(imagebox.geometry.x) - Number(imagebox.border.lineWidth)
                    }
                    if (imagebox.border.type == 'Pic') {
                        return imagebox.geometry.x
                        // return Number(imagebox.geometry.x) - (Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100)
                    }
                } else {
                    return imagebox.geometry.x
                }
            }
            $scope.imageboxT = function (imagebox) {
                if (!imagebox) {
                    return
                }
                if (imagebox.border) {
                    if (imagebox.border.type == 'Color') {
                        return Number(imagebox.geometry.y) - Number(imagebox.border.lineWidth)
                    }
                    if (imagebox.border.type == 'Pic') {
                        return imagebox.geometry.y
                        // return Number(imagebox.geometry.y) - (Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100)
                    }
                } else {
                    return imagebox.geometry.y
                }
            }
            $scope.imageboxWEdge = function (imagebox, edge,ratio) {
                if (!imagebox) {
                    return
                }
                if (imagebox.border) {
                    if (imagebox.border.type == 'Color') {
                        return Number(imagebox.border.lineWidth)
                    }
                    if (imagebox.border.type == 'Pic') {
                        if (edge == 'left') {
                            return Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100 * ratio
                        }
                        if (edge == 'top') {
                            return Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100 * ratio
                        }
                        if (edge == 'right') {
                            return Number(imagebox.geometry.width) * Number(imagebox.border.edge.right) / 100 * ratio
                        }
                        if (edge == 'bottom') {
                            return Number(imagebox.geometry.height) * Number(imagebox.border.edge.bottom) / 100 * ratio
                        }
                    }
                } else {
                    return 0
                }
            }
            $scope.imageboxWRadius = function (imagebox, radius, ratio, ratio1) {
                if (!imagebox) {
                    return
                }
                if (imagebox.border) {
                    var _ratio = 1;
                    if(ratio && ratio1){
                        if(imagebox.geometry.width > imagebox.geometry.height){
                            _ratio = ratio1
                        }else{
                            _ratio = ratio
                        }
                    }
                    if(ratio && !ratio1){
                        _ratio = ratio
                    }
                    if (imagebox.border.shape == 'Ellipse') {
                        return '50%'
                    }
                    if (imagebox.border.radius.filletType == 'Fixed') {//圆角固定值
                        var _radius = imagebox.border.radius[radius];
                        return _radius > 0 ?  (_radius + Number(imagebox.border.lineWidth)/2) * _ratio : 0;
                    }else{
                        var radiusW = imagebox.geometry.width > imagebox.geometry.height ? imagebox.geometry.height : imagebox.geometry.width;
                        radiusW = radiusW + imagebox.border.lineWidth;
                        var _r = radiusW * imagebox.border.radius[radius] / 100;
                        return _r > 0 ? (_r + Number(imagebox.border.lineWidth)/2) * _ratio : 0
                    }
                } else {
                    return 0
                }
            }
            $scope.imageboxWRadius1 = function (imagebox, radius, ratio, ratio1) {
                if (!imagebox) {
                    return
                }
                if (imagebox.border) {
                    var _ratio = 1;
                    if(ratio && ratio1){
                        if(imagebox.geometry.width > imagebox.geometry.height){
                            _ratio = ratio1
                        }else{
                            _ratio = ratio
                        }
                    }
                    if(ratio && !ratio1){
                        _ratio = ratio
                    }
                    if (imagebox.border.shape == 'Ellipse') {
                        return '50%'
                    }
                    if (imagebox.border.radius.filletType == 'Fixed') {//圆角固定值
                        var _radius = imagebox.border.radius[radius];
                        return  (_radius - Number(imagebox.border.lineWidth)/2) > 0 ? (_radius - Number(imagebox.border.lineWidth)/2) * _ratio : 0;
                    }else{
                        var radiusW = imagebox.geometry.width > imagebox.geometry.height ? imagebox.geometry.height : imagebox.geometry.width;
                        radiusW = radiusW + imagebox.border.lineWidth;
                        var _r = radiusW * imagebox.border.radius[radius] / 100;
                        return (_r - Number(imagebox.border.lineWidth)/2) > 0 ? (_r - Number(imagebox.border.lineWidth)/2) * _ratio : 0
                    }
                } else {
                    return 0
                }
            }
            $scope.dropShadow = function(imagebox,ratio){
                if (imagebox.shadow == null) {
                    imagebox.shadow={
                        color:'#777777',
                        x:0,
                        y:0,
                        blur:0
                    }
                }
                var width = $scope.imageboxW(imagebox) * ratio;
                var height =$scope.imageboxH(imagebox) * ratio;
                return dropShadow(imagebox,width,height)
            }

            vm.imageboxTip = false;
            $(".page-mobile-view").on("touchstart",".imageboxview", function (e) {
                fn(e);
                vm.imageboxTip = true;
                if(vm.that.levelDome){vm.that.levelDome()};
                var targ = e.target ? e.target : e.srcElement;
                var imgIndex = targ.dataset.index || vm.levelIndex;
                vm.levelIndex = parseInt(imgIndex);
                vm.levelType = 'imagebox';
                imageboxTouchStart(e, vm.levelIndex, vm.pageData[vm.pageIndex].custom.ratio1, vm.pageData[vm.pageIndex].levels.level, function (imgIndex) {
                    vm.levelIndex = parseInt(imgIndex);
                    vm.levelType = 'imagebox';
                }, function (imgIndex) {
                    vm.that.cropImagebox = vm.pageData[vm.pageIndex].levels.level[imgIndex].imagebox;
                }, function () {
                    if(vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.lock){
                        vm.isImageboxTrim = true;
                    }
                })
                $scope.$apply();
            })
            $(".page-mobile-view").on("touchmove",".imageboxview", function (e) {
                fn(e);
                var targ = e.target ? e.target : e.srcElement;
                var imgIndex = targ.dataset.index || vm.levelIndex;
                vm.levelIndex = parseInt(imgIndex);
                vm.levelType = 'imagebox';
                imageboxTouchmove(e, vm.levelIndex, vm.pageData[vm.pageIndex].custom.ratio1, vm.pageData[vm.pageIndex].levels.level, vm.pageData[vm.pageIndex], function (imgIndex) {
                    $scope.$apply();
                })
            })
            $(".page-mobile-view").on("touchend",".imageboxview", function (e) {
                var targ = e.target ? e.target : e.srcElement;
                var imgIndex = targ.dataset.index || vm.levelIndex;
                vm.levelIndex = parseInt(imgIndex);
                vm.levelType = 'imagebox';
                vm.imageboxTip = false;
                vm.isImageboxTrim = false;
                imageboxTouchend()
                var currentPage = vm.pageData[vm.pageIndex].levels.level;
                var sticker = currentPage[vm.levelIndex].imagebox;
                if(!sticker){
                    return
                }
                if(vm.that.thumbnailInit){vm.that.thumbnailInit()};
                if (sticker.image && sticker.image.resource && sticker.image.resource.identifier) {
                    if(!vm.that.operationTab || vm.that.operationTab == 'picture'){
                        vm.that.isImageboxSelectItem = true;
                    }
                    vm.that.mapDepot = false;
                } else {
                    if(vm.that.fullMapSelection){
                        vm.that.fullMapSelection();
                    }
                }
                fn(e)
                $scope.$apply();
            })
            $scope.imageboxLock = function(e, item, imagebox){
                imagebox.lock = item;
                fn(e)
            }
            //缩放图片框
            window.imageboxScaleStart = function (e) {
                imageboxZoomStart(e, vm.pageData[vm.pageIndex].levels.level, 'pitch', vm.pageData[vm.pageIndex].custom.ratio1,function (textIndex) {
                    vm.levelIndex = parseInt(textIndex);
                    vm.levelType = 'imagebox';
                })
                fn(e);
            };
            window.imageboxScaleOn = function (e) {
                fn(e);
                var currentPage = vm.pageData[vm.pageIndex].levels.level;
                var imagebox = currentPage[vm.levelIndex][vm.levelType];
                imageboxZoomMove(e, imagebox, vm.pageData[vm.pageIndex].custom.ratio1,vm.pageData[vm.pageIndex].trimbox);
                $scope.$apply();
                e.stopPropagation();
                e.preventDefault();
                return false;
            };
            window.imageboxScaleEnd = function (e) {
                imageboxZoomEnd(function () {
                    if(vm.that.thumbnailInit){vm.that.thumbnailInit()};
                })
            };

            window.imageboxStartStart = function (e) {
                var targ = e.currentTarget ? e.currentTarget : e.srcElement;
                var site = targ.dataset.site;
                var imagebox = vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox;
                imageboxStartStartCu(e, imagebox);
                fn(e);
            };
            window.imageboxStartOn = function (e) {
                var targ = e.currentTarget ? e.currentTarget : e.srcElement;
                var site = targ.dataset.site;
                var imagebox = vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox;
                imageboxStartOnCu(e, imagebox, site, vm.pageData[vm.pageIndex].custom.ratio1, function () {
                    $scope.$apply();
                });
                fn(e);
            };
            window.imageboxStartEnd = function (e) {
                imageboxStartEndCu(e, function () {
                    var currentPage = vm.pageData[vm.pageIndex].levels.level;
                    var imagebox = currentPage[vm.levelIndex][vm.levelType];
                    getBackgroundSource3(imagebox, imagebox.geometry.width, imagebox.geometry.height, imagebox.image, imagebox.bokehtype, $scope, function () {
                        if(vm.that.thumbnailInit){vm.that.thumbnailInit()};
                    });
                    $scope.$apply();
                });
                fn(e);
            };
            //删除图片框
            $scope.imageboxDelete = function(e, index){
                fn(e)
                vm.pageData[vm.pageIndex].levels.level.splice(index, 1);
                vm.levelIndex = null;
                vm.levelType = null;
                if(vm.that.thumbnailInit){vm.that.thumbnailInit()};
                vm.that.makeBody();
            };
            $scope.isLarge = function(imageInfo){
                if(!imageInfo)return
                return imageInfo.size >= 20971520 || imageInfo.width > 30000 || imageInfo.height > 30000 || (imageInfo.width*imageInfo.height)>150000000
            }
            /***********************  图片框end  ****************************/
            /***********************  素材  ****************************/
            //移动素材
            $scope.imageartSelect = function(e,index,imageart){
                fn(e)
                if(vm.editorType && (vm.editorType == 'PICTURE' || vm.editorType == 'FORM_EDITOR' || vm.editorType == 'PHOTO_EDITOR')){
                    return
                }
                if(!imageart.useradded){
                    return
                }
                vm.levelIndex = index;
                vm.levelType = 'imageart';
            }
            $(".page-mobile-view").on("touchstart",".imageartview img", function (e) {
                if(vm.editorType && (vm.editorType == 'PICTURE' || vm.editorType == 'FORM_EDITOR' || vm.editorType == 'PHOTO_EDITOR')){
                    return
                }
                if(vm.that.levelDome){vm.that.levelDome()};
                imageartTouchstartStart(e, vm.levelIndex, vm.pageData[vm.pageIndex].levels.level, vm.pageData[vm.pageIndex].custom.ratio1,vm.pageData[vm.pageIndex].trimbox, function (imgIndex) {
                    vm.levelIndex = imgIndex;
                    vm.levelType = 'imageart';
                })
                fn(e);
                $scope.$apply();
            })
            $(".page-mobile-view").on("touchmove",".imageartview", function (e) {
                if (!e.originalEvent || e.originalEvent.touches.length == 1) {
                    imagearOne(e, vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imageart, vm.pageData[vm.pageIndex].custom.ratio1,vm.pageData[vm.pageIndex].trimbox, function () {
                        vm.hint = !editboxIn(vm.pageData[vm.pageIndex].editboxes.editbox , vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imageart.geometry, vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imageart.rotation.angle);
                    });
                    $scope.$apply();
                };
                if (e.originalEvent && e.originalEvent.touches.length >= 2) {
                    var now = e.originalEvent.touches;
                    Math.abs(e.originalEvent.touches[0].pageX - e.originalEvent.touches[1].pageX);
                    imagearTouchstartTwo(function (imageartZoomItem) {
                        imagearTwo(e,getDistance(now[0], now[1]) - getDistance(imageartZoomItem.start[0], imageartZoomItem.start[1]),vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imageart, vm.pageData[vm.pageIndex].trimbox, vm.pageData[vm.pageIndex].custom.ratio1)
                    })
                    $scope.$apply();
                }
            })
            $(".page-mobile-view").on("touchend",".imageartview", function (e) {
                vm.hint = false;
                imageartZoomEnd();
                if(vm.that.thumbnailInit){vm.that.thumbnailInit()};
                $scope.$apply();
            })

            //删除素材
            $scope.deleteImageart = function (e, index) {
                fn(e)
                vm.pageData[vm.pageIndex].levels.level.splice(index, 1);
                vm.levelIndex = null;
                vm.levelType = null;
                if(vm.that.thumbnailInit){vm.that.thumbnailInit()};
            };
            //翻转素材
            $scope.overturnImageart = function (e, imageart) {
                imageartOverturn(imageart);
                if(vm.that.thumbnailInit){vm.that.thumbnailInit()};
                fn(e)
            };
            //复制素材
            $scope.copyImageart = function (e, level) {
                imageartCopys(vm.pageData[vm.pageIndex].levels.level, level);
                vm.levelIndex = vm.pageData[vm.pageIndex].levels.level.length-1;
                if(vm.that.thumbnailInit){vm.that.thumbnailInit()};
                fn(e)
            };
            //缩放素材
            window.resizeStickerStart = function (e) {
                imageartZoomStart(e, vm.pageData[vm.pageIndex].levels.level, 'pitch', vm.pageData[vm.pageIndex].custom.ratio1,function (textIndex) {
                    vm.levelIndex = parseInt(textIndex);
                    vm.levelType = 'imageart';
                })
                fn(e);
            };
            window.resizeStickerOn = function (e) {
                fn(e);
                var currentPage = vm.pageData[vm.pageIndex].levels.level;
                var imageart = currentPage[vm.levelIndex][vm.levelType];
                imageartZoomMove(e, imageart, vm.pageData[vm.pageIndex].custom.ratio1,vm.pageData[vm.pageIndex].trimbox);
                $scope.$apply();
            };
            window.resizeStickerEnd = function (e) {
                imageartZoomEnd();
                if(vm.that.thumbnailInit){vm.that.thumbnailInit()};
            };
            /***********************  素材end  ****************************/
            /***********************  文字  ****************************/
            window.moveTextBoxStart = function (e) {
                if(vm.editorType && (vm.editorType == 'PICTURE' || vm.editorType == 'FORM_EDITOR' || vm.editorType == 'PHOTO_EDITOR')){
                    return
                }
                if(vm.that.levelDome){vm.that.levelDome()};
                textBoxMoveStart(e, vm.levelIndex, vm.pageData[vm.pageIndex].levels.level, vm.pageData[vm.pageIndex].custom.ratio1, vm.pageData[vm.pageIndex].trimbox, function (textIndex) {
                    vm.levelIndex = parseInt(textIndex);
                    vm.levelType = 'textbox';
                    vm.transparency = parseInt(vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.transparency * 100);
                    if(vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.editable){
                        vm.that.textboxSelect = true;
                    }else if(!vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.editable){
                        vm.that.textboxSelect = false;
                    }
                    $scope.$apply();
                })
                fn(e);
            }
            window.moveTextBoxOn = function (e) {
                if(vm.pageData[vm.pageIndex] && vm.pageData[vm.pageIndex].levels && vm.pageData[vm.pageIndex].levels.level[vm.levelIndex]) {
                    textBoxMoveOn(e, vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox, vm.pageData[vm.pageIndex].custom.ratio1, vm.pageData[vm.pageIndex].trimbox,function () {
                        vm.hint = !editboxIn(vm.pageData[vm.pageIndex].editboxes.editbox , vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.geometry, vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.rotation.angle);
                    })
                    fn(e);
                    $scope.$apply();
                }
            }
            window.moveTextBoxEnd = function (e) {
                fn(e);
                vm.hint = false;
                textBoxMoveEnd();
                if(vm.that.thumbnailInit){vm.that.thumbnailInit()};
            }


            //旋转文字
            window.textboxStart = function (e) {
                textboxRotateStart(e, vm.levelIndex, vm.pageData[vm.pageIndex].levels.level, function (textIndex) {
                    vm.levelIndex = parseInt(textIndex);
                    vm.levelType = 'textbox';
                })
                fn(e);
            }
            window.textboxStickerOn = function (e) {
                textboxRotateOn(e, vm.levelIndex, vm.pageData[vm.pageIndex].levels.level, vm.pageData[vm.pageIndex].custom.ratio1, "pitch1",function (textIndex) {
                    $scope.$apply();
                })
                e.stopPropagation();
                e.preventDefault();
                return false;
            };
            window.textboxStickerEnd = function (e) {
                var currentPage = vm.pageData[vm.pageIndex].levels.level;
                var sticker = currentPage[vm.levelIndex].textbox;
                sticker.rotation.angle = sticker.rotation.angle;
                textBoxMoveEnd();
                if(vm.that.thumbnailInit){vm.that.thumbnailInit()};
            };

            window.textboxZoomOnStart = function (e) {
                textboxZoomStart1(e, vm.levelIndex, vm.pageData[vm.pageIndex].levels.level, vm.pageData[vm.pageIndex].custom.ratio1, "pitch1", function (textIndex) {
                    vm.levelIndex = parseInt(textIndex);
                    vm.levelType = 'textbox';
                })
                fn(e);
            }
            window.textboxZoomRight1 = function (e) {
                textboxZoom2(e, vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox, vm.pageData[vm.pageIndex].custom.ratio1, function (nl) {
                    if(vm.that.sizeHeight1){vm.that.sizeHeight1()};
                    $scope.$apply();
                });
                fn(e);
            }
            window.textboxZoomRightStatr = function (e) {
                textboxZoomRightStart(e, vm.levelIndex, vm.pageData[vm.pageIndex].levels.level, vm.pageData[vm.pageIndex].custom.ratio1, "pitch1", function (textIndex) {
                    vm.levelIndex = parseInt(textIndex);
                    vm.levelType = 'textbox';
                })
                fn(e);
            }


            window.textboxZoomLeftStatr = function (e) {
                textboxZoomLeftStart(e, vm.levelIndex, vm.pageData[vm.pageIndex].levels.level, vm.pageData[vm.pageIndex].custom.ratio1, "pitch1", function (textIndex) {
                    vm.levelIndex = parseInt(textIndex);
                    vm.levelType = 'textbox';
                })
                fn(e);
            }
            window.textboxZoomRight = function (e) {
                var currentPage = vm.pageData[vm.pageIndex].levels.level;
                var sticker = currentPage[vm.levelIndex].textbox;
                textboxZoom(e, sticker, 'right',vm.pageData[vm.pageIndex].custom.ratio1, vm.pageData[vm.pageIndex].trimbox, function (accomplish) {
                    if(accomplish){
                        if(vm.that.sizeHeight1){vm.that.sizeHeight1()};
                    }
                    $scope.$apply();
                })
                fn(e);
            }
            window.textboxZoomTop = function (e) {
                var currentPage = vm.pageData[vm.pageIndex].levels.level;
                var sticker = currentPage[vm.levelIndex].textbox;
                textboxZoom(e, sticker, 'top',vm.pageData[vm.pageIndex].custom.ratio1, vm.pageData[vm.pageIndex].trimbox, function (accomplish) {
                    if(accomplish){
                        if(vm.that.sizeHeight1){vm.that.sizeHeight1()};
                    }
                    $scope.$apply();
                })
                fn(e);
            }
            window.textboxZoomLeft = function (e) {
                var currentPage = vm.pageData[vm.pageIndex].levels.level;
                var sticker = currentPage[vm.levelIndex].textbox;
                textboxZoom(e, sticker, 'left',vm.pageData[vm.pageIndex].custom.ratio1, vm.pageData[vm.pageIndex].trimbox, function (accomplish) {
                    if(accomplish){
                        if(vm.that.sizeHeight1){vm.that.sizeHeight1()};
                    }
                    $scope.$apply();
                })
                fn(e);
            }

            //鼠标抬起事件
            window.textboxZoomEnd = function (e) {
                textBoxMoveEnd();
                if(vm.that.thumbnailInit){vm.that.thumbnailInit()};
                e.stopPropagation();
            }

            $scope.writingmodeInit = function (item) {
                if(item == 'vertical-lr' || item == 'vertical-rl'){
                    return true
                }else{
                    return false
                }
            }
            /***********************  文字end  ****************************/
            /***********************  文字模板  ****************************/
            /***********************  文字模板end  ****************************/
            //移除画布透明效果
            $scope.opacityElement = function(mediabox, geometry){
                var opacity = 1;
                if(!geometry || !mediabox){
                    return 1
                }
                if(geometry.x > -geometry.width && geometry.y > -geometry.height && geometry.x < mediabox.width && geometry.y < mediabox.height){
                    opacity = 1;
                }else {
                    opacity = 0.3;
                }
                return opacity
            }
            $scope.goldFoil = function(color){
                if(color){
                    return goldFoil(color)
                }
            }
            $scope.transitionPx = transitionPx;
            $scope.pageStyle = function(){
                if(vm.pageData && vm.pageData[vm.pageIndex]){
                    var _style= {
                        'position': 'absolute',
                        'width': vm.pageData[vm.pageIndex].mediabox.width * vm.pageData[vm.pageIndex].custom.ratio1,
                        'height': vm.pageData[vm.pageIndex].mediabox.height * vm.pageData[vm.pageIndex].custom.ratio1,
                        'left': vm.pageData[vm.pageIndex].scene ? vm.pageData[vm.pageIndex].scene.imagebox.geometry.x * vm.pageData[vm.pageIndex].custom.ratio1 : vm.pageData[vm.pageIndex].mediabox.x * vm.pageData[vm.pageIndex].custom.ratio1,
                        'top': vm.pageData[vm.pageIndex].scene ? vm.pageData[vm.pageIndex].scene.imagebox.geometry.y * vm.pageData[vm.pageIndex].custom.ratio1 : vm.pageData[vm.pageIndex].mediabox.y * vm.pageData[vm.pageIndex].custom.ratio1,
                        'background': vm.pageData[vm.pageIndex].background.color&&vm.pageData[vm.pageIndex].background.type == 'Color' ? vm.pageData[vm.pageIndex].background.color : 'none',
                        'z-index': vm.pageData[vm.pageIndex].scene && vm.pageData[vm.pageIndex].scene.hierarchy == 'TOP' && !vm.levelType ? 0 : 1,
                    }
                    if(vm.editorType == 'PICTURE_PRO_P'){
                        if(vm.pageData[vm.pageIndex].outline){
                            if(vm.pageData[vm.pageIndex].outline.mask && vm.pageData[vm.pageIndex].outline.mask.resource && vm.pageData[vm.pageIndex].outline.mask.resource.identifier){
                                _style['-webkit-mask-image']= 'url(' + vm.pageData[vm.pageIndex].outline.mask.resource.identifier + ')';
                                _style['-webkit-mask-size'] = transitionPx(vm.pageData[vm.pageIndex].outline.geometry.width) * vm.pageData[vm.pageIndex].custom.ratio1 + 'px ' + transitionPx(vm.pageData[vm.pageIndex].outline.geometry.height) * vm.pageData[vm.pageIndex].custom.ratio1 + 'px';
                                _style['-webkit-mask-position-x']= transitionPx(vm.pageData[vm.pageIndex].outline.geometry.x) * vm.pageData[vm.pageIndex].custom.ratio1 + 'px';
                                _style['-webkit-mask-position-y']= transitionPx(vm.pageData[vm.pageIndex].outline.geometry.y) * vm.pageData[vm.pageIndex].custom.ratio1 + 'px';
                                _style['-webkit-mask-repeat']= 'no-repeat';
                            }
                        }else{
                            // _style['-webkit-mask-image'] = 'linear-gradient(black, black)';
                            // _style['-webkit-mask-size']= (vm.pageData[vm.pageIndex].trimbox.width*vm.pageData[vm.pageIndex].custom.ratio1+1) + 'px ' + (vm.pageData[vm.pageIndex].trimbox.height*vm.pageData[vm.pageIndex].custom.ratio1+1) + 'px';
                            // _style['-webkit-mask-repeat']= 'no-repeat';
                            // _style['-webkit-mask-position']= (vm.pageData[vm.pageIndex].trimbox.x*vm.pageData[vm.pageIndex].custom.ratio1) + 'px ' + (vm.pageData[vm.pageIndex].trimbox.y*vm.pageData[vm.pageIndex].custom.ratio1) + 'px';

                        }
                    }
                    return _style
                }
            }
        }]
    };

    angular.module('editorApp')
        .component('pageMobileEdit', PageMobileEditControl);

})();

(function () {
    'use strict';

    var PageEditControl = {
    	restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/components/page-edit.html',
        controllerAs: 'vm',
        bindings: {
            pageData: '=',
            pageIndex: '=',
            pageNumber:'<',
            that: '=',
            elementOn: '=',
            imgSize: '<',
            imgDpi: '<',
            editorType: '<',
            onRatioinfo:'&'
        },

        controller: ['$scope','$element','ModulesService','FontManagement','$timeout', '$http', '$translate', 'MessageService','$rootScope', 'Qinius', 'QiniuToken', 'UidService', '$q', 'Gallery',
            function ($scope,$element,ModulesService,FontManagement,$timeout,$http, $translate, MessageService,$rootScope, Qinius, QiniuToken, UidService, $q, Gallery) {
            var vm = this;
            //像素不足提醒
            var throttledResize = angular.throttle(function (item) {
                return pxInsufficient(item, vm.imgSize, vm.imgDpi)
            }, 1000);

            vm.$onInit = function() {
                document.addEventListener("keydown", onKeyDown)
            }
            vm.$postLink = function () {
                angular.element(window).on('resize', syncEditorBodyPosition);
                vm.qiniuToken = null;
                vm.qiniuDomain = null;

                var domains = Qinius.getDomain();
                $q.all([domains.$promise]).then(function () {
                    vm.qiniuDomain = 'https://' + domains.domains[0] + '/';
                    localStorage.setItem('editor-domain', vm.qiniuDomain);
                    $scope.processQiniuUploadQueue();
                });

                unsubQiniuToken = QiniuToken.subscribe('get', {}, function (token) {
                    vm.qiniuToken = token;
                    $scope.processQiniuUploadQueue();
                });
                $scope.$watch(function(){
                    if(vm.pageData && vm.pageData[vm.pageIndex] && vm.pageData[vm.pageIndex].levels && vm.pageData[vm.pageIndex].levels.level){
                        var codes = vm.pageData[vm.pageIndex].levels.level.filter(function(level){
                            return level.code && level.code.value;
                        });
                        return codes.length + '|' + codes.map(function(level){
                            return level.code.value;
                        }).join('|');
                    }
                    return '';
                }, function(){
                    $timeout(function(){
                        if(vm.pageData && vm.pageData[vm.pageIndex] && vm.pageData[vm.pageIndex].levels && vm.pageData[vm.pageIndex].levels.level){
                            vm.pageData[vm.pageIndex].levels.level.forEach(function(level, index){
                                if(level.code && level.code.geometry){
                                    $scope.initCodeQrcode(index, level.code);
                                }
                            });
                        }
                    }, 100);
                });

                refreshCodeQrcodeListener = $rootScope.$on('refreshCodeQrcode', function(event, data){
                    $timeout(function(){
                        if(vm.pageData && vm.pageData[vm.pageIndex] && vm.pageData[vm.pageIndex].levels && vm.pageData[vm.pageIndex].levels.level){
                            vm.pageData[vm.pageIndex].levels.level.forEach(function(level, index){
                                if(level.code && level.code.geometry){
                                    $scope.initCodeQrcode(index, level.code);
                                }
                            });
                        }
                    }, 100);
                });
            }

            var refreshCodeQrcodeListener;
            var unsubQiniuToken;

            vm.$onDestroy = function () {
                angular.element(window).off('resize', syncEditorBodyPosition);
                document.removeEventListener("keydown", onKeyDown);
                if(refreshCodeQrcodeListener){
                    refreshCodeQrcodeListener();
                }
                if(unsubQiniuToken){
                    unsubQiniuToken();
                }
            }

            function applyEditorBodyPosition() {
                var pageEditView = $element[0];
                if (!pageEditView) { return; }
                var rect = pageEditView.getBoundingClientRect();
                var parent = pageEditView.parentNode;
                if (!parent) { return; }
                var style = {
                    top: rect.top + 'px',
                    left: rect.left + 'px',
                    width: rect.width + 'px',
                    height: rect.height + 'px'
                };
                angular.forEach(parent.querySelectorAll('.editor-body1'), function (el) {
                    el.style.top = style.top;
                    el.style.left = style.left;
                    el.style.width = style.width;
                    el.style.height = style.height;
                });
            }

            function syncEditorBodyPosition() {
                //双击进入裁切时 .editor-body1 由 ng-if 在本次 digest 中才创建，
                //只用 $timeout 定位的话，浏览器会先按 css 里的 top:0/left:0 绘制一帧，元素会从左上角跳到目标位置。
                //所以在 digest 中补一次 $$postDigest 定位，它在本次 digest 结束、浏览器绘制之前执行。
                if ($rootScope.$$phase) {
                    $scope.$$postDigest(applyEditorBodyPosition);
                }
                $timeout(applyEditorBodyPosition);
            }

            $scope.pxInsufficient = function (item) {
                // return throttledResize(item);
                return pxInsufficient(item, vm.imgSize, vm.imgDpi);
            }
            /***********************  图片框  ****************************/
            $scope.imageboxClick = function($event, imagebox, index, pageIndex){
                if(vm.that.levelInif1){vm.that.levelInif1()};
                if(vm.that.ctrlKey){
                    imagebox.ctrlKey = true;
                }else{
                    if(!imagebox.ctrlKey){
                        if(vm.that.levelInif){vm.that.levelInif()}
                    }
                }
                vm.that.elementInit(index,(pageIndex ? pageIndex : vm.pageIndex),imagebox,'imagebox');
                fn($event);
            }
            //缩放
            $scope.resizeStartRigth = function($event, item,pro,index,slide){
                if(item.lock){return}
                fn($event);
                editorBoxZoom($event, item, 'rightBottom', pro, $($event.target).parents('.selected'), function (it) {
                    vm.pageData[vm.pageIndex].levels.level[vm.elementOn.index].imagebox = it;
                    vm.that.hint = !editboxIn(vm.pageData[vm.pageIndex].editboxes.editbox , item.geometry, item.rotation.angle);
                    $scope.$apply();
                }, function (it) {
                    vm.that.hint = false;
                    if(it.image && it.image.resource&& it.image.resource.identifier){
                        getBackgroundSource3(it, it.geometry.width,it.geometry.height, it.image, it.bokehtype, $scope, function () {});
                        vm.that.cookie();
                        $scope.$apply();
                    }
                });
            }
            $scope.resizeStartLeft = function ($event, item,pro,index,slide) {
                if(item.lock){return}
                fn($event);
                editorBoxZoom($event, item, 'leftTop', pro, $($event.target).parents('.selected'), function (it) {
                    vm.pageData[vm.pageIndex].levels.level[vm.elementOn.index].imagebox = it;
                    vm.that.hint = !editboxIn(vm.pageData[vm.pageIndex].editboxes.editbox , item.geometry, item.rotation.angle);
                    $scope.$apply();
                }, function (it) {
                    vm.that.hint = false;
                    if(it.image && it.image.resource&& it.image.resource.identifier){
                        getBackgroundSource3(it, it.geometry.width,it.geometry.height, it.image, it.bokehtype, $scope, function () {});
                        vm.that.cookie();
                        $scope.$apply();
                    }
                });
            }
            $scope.resizeStartTop = function ($event, item,pro,index,slide) {
                if(item.lock){return}
                fn($event);
                editorBoxZoom($event, item, 'rightTop', pro, $($event.target).parents('.selected'), function (it) {
                    vm.pageData[vm.pageIndex].levels.level[vm.elementOn.index].imagebox = it;
                    vm.that.hint = !editboxIn(vm.pageData[vm.pageIndex].editboxes.editbox , item.geometry, item.rotation.angle);
                    $scope.$apply();
                }, function (it) {
                    vm.that.hint = false;
                    if(it.image && it.image.resource&& it.image.resource.identifier){
                        getBackgroundSource3(it, it.geometry.width,it.geometry.height, it.image, it.bokehtype, $scope, function () {});
                        vm.that.cookie();
                        $scope.$apply();
                    }
                });
            }
            $scope.resizeStartBottom = function ($event, item,pro,index,slide) {
                if(item.lock){return}
                fn($event);
                editorBoxZoom($event, item, 'leftBottom', pro, $($event.target).parents('.selected'), function (it) {
                    vm.pageData[vm.pageIndex].levels.level[vm.elementOn.index].imagebox = it;
                    vm.that.hint = !editboxIn(vm.pageData[vm.pageIndex].editboxes.editbox , item.geometry, item.rotation.angle);
                    $scope.$apply();
                }, function (it) {
                    vm.that.hint = false;
                    if(it.image && it.image.resource&& it.image.resource.identifier){
                        getBackgroundSource3(it, it.geometry.width,it.geometry.height, it.image, it.bokehtype, $scope, function () {});
                        vm.that.cookie();
                        $scope.$apply();
                    }
                });
            }
            $scope.resizeStartLeft1 = function ($event, item,pro,index,slide) {
                if(item.lock){return}
                fn($event);
                editorBoxZoom($event, item, 'left', pro, $($event.target).parents('.selected'), function (it) {
                    vm.pageData[vm.pageIndex].levels.level[vm.elementOn.index].imagebox = it;
                    vm.that.hint = !editboxIn(vm.pageData[vm.pageIndex].editboxes.editbox , item.geometry, item.rotation.angle);
                    $scope.$apply();
                }, function (it) {
                    vm.that.hint = false;
                    if(it.image && it.image.resource&& it.image.resource.identifier){
                        it.image.offsetx = 0;
                        it.image.offsety = 0;
                        getBackgroundSource3(it, it.geometry.width,it.geometry.height, it.image, it.bokehtype, $scope, function () {});
                    }
                    vm.that.cookie();
                    $scope.$apply();
                });
            }
            $scope.resizeStartTop1 = function ($event, item,pro,index,slide) {
                if(item.lock){return}
                fn($event);
                editorBoxZoom($event, item, 'top', pro, $($event.target).parents('.selected'), function (it) {
                    vm.pageData[vm.pageIndex].levels.level[vm.elementOn.index].imagebox = it;
                    vm.that.hint = !editboxIn(vm.pageData[vm.pageIndex].editboxes.editbox , item.geometry, item.rotation.angle);
                    $scope.$apply();
                }, function (it) {
                    vm.that.hint = false;
                    if(it.image && it.image.resource&& it.image.resource.identifier){
                        it.image.offsetx = 0;
                        it.image.offsety = 0;
                        getBackgroundSource3(it, it.geometry.width,it.geometry.height, it.image, it.bokehtype, $scope, function () {});
                    }
                    vm.that.cookie();
                    $scope.$apply();
                });
            }
            $scope.resizeStartRight1 = function ($event, item,pro,index,slide) {
                if(item.lock){return}
                fn($event);
                editorBoxZoom($event, item, 'right', pro, $($event.target).parents('.selected'), function (it) {
                    vm.pageData[vm.pageIndex].levels.level[vm.elementOn.index].imagebox = it;
                    vm.that.hint = !editboxIn(vm.pageData[vm.pageIndex].editboxes.editbox , item.geometry, item.rotation.angle);
                    $scope.$apply();
                }, function (it) {
                    vm.that.hint = false;
                    if(it.image && it.image.resource&& it.image.resource.identifier){
                        it.image.offsetx = 0;
                        it.image.offsety = 0;
                        getBackgroundSource3(it, it.geometry.width,it.geometry.height, it.image, it.bokehtype, $scope, function () {});
                    }
                    vm.that.cookie();
                    $scope.$apply();
                });
            }
            $scope.resizeStartBottom1 = function ($event, item,pro,index,slide) {
                if(item.lock){return}
                fn($event);
                editorBoxZoom($event, item, 'bottom', pro, $($event.target).parents('.selected'), function (it) {
                    vm.pageData[vm.pageIndex].levels.level[vm.elementOn.index].imagebox = it;
                    vm.that.hint = !editboxIn(vm.pageData[vm.pageIndex].editboxes.editbox , item.geometry, item.rotation.angle);
                    $scope.$apply();
                }, function (it) {
                    vm.that.hint = false;
                    if(it.image && it.image.resource&& it.image.resource.identifier){
                        it.image.offsetx = 0;
                        it.image.offsety = 0;
                        getBackgroundSource3(it, it.geometry.width,it.geometry.height, it.image, it.bokehtype, $scope, function () {});
                    }
                    vm.that.cookie();
                    $scope.$apply();
                });
            }
            $scope.imageboxdownRotate = function ($event, item) {
                if(item.lock){return}
                fn($event);
                var _top = $($event.target).parents('.imageboxView').offset().top + (item.geometry.height * vm.pageData[vm.pageIndex].custom.ratio / 2);
                var _left = $($event.target).parents('.imageboxView').offset().left + (item.geometry.width * vm.pageData[vm.pageIndex].custom.ratio / 2);
                webRotate($scope, $event, item, _top, _left, ModulesService, function () {
                    vm.that.cookie();
                    $scope.$apply();
                })
            }

            //双击编辑图片框图片
            $scope.$on('doubleClickImageboxCallback', function(event, item) {
                $scope.doubleClickImagebox(item.event, item.index, item.item, item.pageIndex)
            })
            $scope.doubleClickImagebox = function ($event,index, item, pageIndex) {
                fn($event);
                // if(vm.pageData[vm.pageIndex].scene){
                //     if(vm.onRatioinfo){
                //         vm.onRatioinfo();
                //     }
                //     return
                // }
                if((pageIndex>=0 && pageIndex == vm.pageIndex) || pageIndex == null){
                    if(item.image && item.image.resource && item.image.resource.identifier){
                        vm.imageboxDouble1 = index;
                        vm.imageboxDouble = angular.copy(item);
                        vm.isImageboxTrim = true;
                        vm.that.showEditorDialog = false;
                        syncEditorBodyPosition();
                        scaleViewRange(vm.imageboxDouble.image.scale);
                        scaleViewRangeInfo();
                    }
                }
            }
            $scope.imageboxFalseClick = function (e) {
                fn(e);
                if(e && e.keyCode){
                    return
                }
                vm.isImageboxTrim = false;
                vm.that.showEditorDialog = true;
            };
            $scope.imageboxTrueClick = function (e) {
                fn(e);
                if(e && e.keyCode){
                    return
                }
                vm.pageData[vm.pageIndex].levels.level[vm.imageboxDouble1].imagebox = vm.imageboxDouble;
                if($scope.$parent.outlineHint){$scope.$parent.outlineHint()}
                vm.isImageboxTrim = false;
                vm.that.showEditorDialog = true;
                if(vm.that.onArticleChange){vm.that.onArticleChange()};
                if(vm.that.thumbnailInit){vm.that.thumbnailInit()};
            };
            var isImageboxMouseDown = false;
            $scope.imageboxMouseDown = function ($event) {
                fn($event)
                if (vm.imageboxDouble.bokehtype != 'None') {
                    return
                }
                var x = $event.clientX;
                var y = $event.clientY;
                var proW = vm.pageData[vm.pageIndex].custom.ratio*vm.imageboxDouble.image.scale;
                var proH = vm.pageData[vm.pageIndex].custom.ratio*vm.imageboxDouble.image.scale;

                var l = vm.imageboxDouble.image.offsetx * proW * vm.imageboxDouble.image.scale;
                var t = vm.imageboxDouble.image.offsety * proH * vm.imageboxDouble.image.scale;
                var r = -(vm.imageboxDouble.image.width * vm.imageboxDouble.image.scale - vm.imageboxDouble.geometry.width) * proW;
                var b = - (vm.imageboxDouble.image.height * vm.imageboxDouble.image.scale - vm.imageboxDouble.geometry.height) * proH;
                var angle = Number(vm.imageboxDouble.rotation.angle);
                //开关打开
                isImageboxMouseDown = true;
                //鼠标移动
                window.onmousemove = function (e) {
                    if (isImageboxMouseDown == false) {
                        return;
                    }
                    fn(e);
                    var cx = (l + r) / 2;
                    var cy = (t + b) / 2;
                    var pt0 = rotatePoint({x: x, y: y}, {x: cx, y: cy}, -angle);
                    var pt1 = rotatePoint({x: e.clientX, y: e.clientY}, {x: cx, y: cy}, -angle);
                    var deltaX = pt1.x - pt0.x;
                    var deltaY = pt1.y - pt0.y;
                    var nl = l + deltaX;
                    var nt = t + deltaY;
                    if (nl < r) {
                        nl = r
                    };
                    if (nl > 0) {
                        nl = 0
                    };
                    if (nt < b) {
                        nt = b
                    };
                    if (nt > 0) {
                        nt = 0
                    };

                    vm.imageboxDouble.image.offsetx = nl/proW/vm.imageboxDouble.image.scale;
                    vm.imageboxDouble.image.offsety = nt/proH/vm.imageboxDouble.image.scale;
                    $scope.$digest();
                }
                //鼠标抬起事件
                window.onmouseup = function ($event) {
                    if(isImageboxMouseDown){
                        $scope.$digest();
                    }
                    isImageboxMouseDown = false;
                }
            }
            $scope.rotateImagebox = function (e) {
                if(e && e.keyCode){
                    return
                }
                imageboxRotate($scope, vm.imageboxDouble);
            }
            $scope.changeBlurred = function (e) {
                fn(e);
                if(e && e.keyCode){
                    return
                }
                if (vm.imageboxDouble.bokehtype == 'None') {
                    vm.imageboxDouble.bokehtype = (vm.that.article && vm.that.article.bokehtype && vm.that.article.bokehtype != 'None') ? angular.copy(vm.that.article.bokehtype) : 'Transparent';
                } else {
                    vm.imageboxDouble.bokehtype = 'None';
                }
                vm.imageboxDouble.image.scale = 1;
                if(vm.imageboxDouble.blurredrectangle){
                    vm.imageboxDouble.blurredrectangle.x = 0;
                    vm.imageboxDouble.blurredrectangle.y = 0;
                }
                if(vm.imageboxDouble.image.resource && vm.imageboxDouble.image.resource.identifier){
                    getBackgroundSource3(vm.imageboxDouble, vm.imageboxDouble.geometry.width, vm.imageboxDouble.geometry.height, vm.imageboxDouble.image, vm.imageboxDouble.bokehtype);
                }
            }
            $scope.deleteImage = function(e){
                fn(e);
                if(e && e.keyCode){
                    return
                }
                vm.imageboxDouble.image.resourceid = "";
                vm.imageboxDouble.image.resource.identifier = "";
                vm.imageboxDouble.image.resource.adaptation = "";
                vm.imageboxDouble.image.resource.provider = "";
                vm.imageboxDouble.image.resource.offsetx = 0;
                vm.imageboxDouble.image.resource.offsety = 0;
                vm.imageboxDouble.image.resource.height = "";
                vm.imageboxDouble.image.resource.width = "";
                vm.imageboxDouble.image.resource.scale = 1;
                vm.imageboxDouble.image.resource.imgSize = "";
                vm.pageData[vm.pageIndex].levels.level[vm.imageboxDouble1].imagebox = vm.imageboxDouble;
                vm.pageData[vm.pageIndex].updateThumbnail = true;
                vm.isImageboxTrim = false;
                vm.that.showEditorDialog = true;
                vm.that.photosNum();
                vm.that.imageSelectInit();
                vm.that.magnitudeBox();
            }
            //居中
            $scope.imageboxSite = function (e) {
                fn(e);
                if(e && e.keyCode){
                    return
                }
                if (!vm.imageboxDouble || vm.imageboxDouble.bokehtype != 'None') {
                    return
                }
                vm.imageboxDouble.image.offsetx = -(vm.imageboxDouble.image.width * vm.imageboxDouble.image.scale - vm.imageboxDouble.geometry.width) / 2 / vm.imageboxDouble.image.scale;
                vm.imageboxDouble.image.offsety = -(vm.imageboxDouble.image.height * vm.imageboxDouble.image.scale - vm.imageboxDouble.geometry.height) / 2 / vm.imageboxDouble.image.scale;
                if (vm.imageboxDouble.image.offsetx > 0) {
                    vm.imageboxDouble.image.offsetx = 0;
                }
                if (vm.imageboxDouble.image.offsety > 0) {
                    vm.imageboxDouble.image.offsety = 0;
                }
            }
            //镜像
            $scope.imageboxFlip = function(e){
                fn(e);
                if(e && e.keyCode){
                    return
                }
                vm.imageboxDouble.flip = !vm.imageboxDouble.flip;
            }
            // 滚动放大
            function scaleViewRangeInfo(){
                $timeout(function () {
                    $('#scaleViewRange' + vm.pageIndex).on('input propertychange',function(e){
                        var val=($('#scaleViewRange' + vm.pageIndex).val()/100 +1).toFixed(2);
                        vm.imageboxDouble.image.scale = val;
                        scaleViewRange(vm.imageboxDouble.image.scale);
                        $scope.$apply();
                    })
                })
                $scope.scale = 1;
                window.bbimg = function (delta) {
                    if (vm.imageboxDouble.bokehtype != 'None' || vm.that.ctrlKey) {
                        return
                    }
                    if (delta < 0 || delta == undefined && event.wheelDelta > 0) {
                        vm.imageboxDouble.image.scale *= 1.01;
                    } else {
                        vm.imageboxDouble.image.scale /= 1.01;
                        if (vm.imageboxDouble.image.scale <= 1) {
                            vm.imageboxDouble.image.scale = 1;
                        }
                    }
                    scaleViewRange(vm.imageboxDouble.image.scale);
                    $scope.$digest();
                    return false;
                };
            }
            function scaleViewRange(scale){
                $('#scaleViewRange' + vm.pageIndex).val(((scale-1)*100).toFixed(0));

                var x = vm.imageboxDouble.image.offsetx*vm.imageboxDouble.image.scale;
                var y = vm.imageboxDouble.image.offsety*vm.imageboxDouble.image.scale;

                //向上滑动;
                if (-y >= (vm.imageboxDouble.image.height*vm.imageboxDouble.image.scale - vm.imageboxDouble.geometry.height)) {
                    y = -(vm.imageboxDouble.image.height*vm.imageboxDouble.image.scale - vm.imageboxDouble.geometry.height);
                }
                //向左滑动;        <-----
                if (-x >= (vm.imageboxDouble.image.width*vm.imageboxDouble.image.scale - vm.imageboxDouble.geometry.width)) {
                    x = -(vm.imageboxDouble.image.width*vm.imageboxDouble.image.scale - vm.imageboxDouble.geometry.width);
                }
                //向下滑动;
                if (y >= 0) {
                    y = 0;
                }
                // 向右滑动;    ---->
                if (x >= 0) {
                    x = 0;
                }
                vm.imageboxDouble.image.offsetx = x/vm.imageboxDouble.image.scale;
                vm.imageboxDouble.image.offsety = y/vm.imageboxDouble.image.scale;
            }


            // 切换占位框图片
            $scope.changeMaskImage = function (e, i) {
                fn(e);
                // 需要切换的占位框
                var box0 = vm.pageData[vm.pageIndex].levels.level[vm.elementOn.index].imagebox;
                var img1={
                    imageInfo: box0.image.imageInfo,
                    height: box0.image.height,
                    id: box0.image.resourceid,
                    identifier: box0.image.resource.identifier,
                    imgsize: box0.image.imgsize,
                    name: null,
                    provider: "qiniu",
                    width: box0.image.width,
                    brightness:box0.image.brightness,
                    contrast: box0.image.contrast,
                    saturate: box0.image.saturate,
                    temperature: box0.image.temperature,
                    hue: box0.image.hue
                };
                box0.image.imageInfo = null;
                box0.image.resourceid = null;
                box0.image.resource.identifier = null;
                box0.image.imgsize = null;
                box0.image.height = null;
                box0.image.width = null;

                // 被切换的占位框
                var box = vm.pageData[vm.pageIndex].levels.level[i].imagebox;
                var img={
                    imageInfo: box.image.imageInfo,
                    height: box.image.height,
                    id: box.image.resourceid,
                    identifier: box.image.resource.identifier,
                    imgsize: box.image.imgsize,
                    name: null,
                    provider: "qiniu",
                    width: box.image.width,
                    brightness:box.image.brightness,
                    contrast: box.image.contrast,
                    saturate: box.image.saturate,
                    temperature: box.image.temperature,
                    hue: box.image.hue
                }
                box.image.imageInfo = null;
                box.image.resourceid = null;
                box.image.resource.identifier = null;
                box.image.imgsize = null;
                box.image.height = null;
                box.image.width = null;
                swapBox(box0,img);
                swapBox(box,img1);
                vm.pageData[vm.pageIndex].levels.level.forEach(function (level) {
                    if(level.imagebox){
                        level.imagebox.exchange = false;
                    }
                })
                if($scope.$parent.outlineHint){$scope.$parent.outlineHint()}
            };
            function swapBox(imagebox, img){
                imagebox.image.resourceid = img ? img.id : '';
                imagebox.image.resource.identifier = img ? img.identifier : '';
                imagebox.image.resource.provider = img ? img.provider : 'qiniu';
                imagebox.image.width = img ? img.width : '';
                imagebox.image.height = img ? img.height : '';
                imagebox.image.imageInfo = img ? img.imageInfo : '';
                imagebox.image.imgSize = img ? img.imgSize : '';
                imagebox.image.index = img ? img.seq : '';
                imagebox.image.parameter = img ? angular.fromJson(img.parameter) : [];
                imagebox.image.scale = 1;
                imagebox.image.brightness = img ? img.brightness : 0;
                imagebox.image.contrast = img ? img.contrast : 0;
                imagebox.image.saturate = img ? img.saturate : 0;
                imagebox.image.temperature = img ? img.temperature : 0;
                imagebox.image.hue = img ? img.hue : 0;

                if(imagebox.image.resource.identifier){
                    addImagebox($http, imagebox, function () {})
                }
            }
            // 大图判断
            $scope.isLarge = function(imageInfo){
                if(!imageInfo)return
                return imageInfo.size >= 20971520 || imageInfo.width > 30000 || imageInfo.height > 30000 || (imageInfo.width*imageInfo.height)>150000000
            }
            /***********************  图片框end  ****************************/
            /***********************  二维码  ****************************/
            $scope.codeClick = function($event, code, index, pageIndex){
                if(vm.that.levelInif1){vm.that.levelInif1()};
                if(vm.that.ctrlKey){
                    code.ctrlKey = true;
                }else{
                    if(!code.ctrlKey){
                        if(vm.that.levelInif){vm.that.levelInif()}
                    }
                }
                vm.that.elementInit(index,(pageIndex ? pageIndex : vm.pageIndex),code,'code');
                vm.that.code={
                    width: transitionMm(code.geometry.width),
                    height: transitionMm(code.geometry.height),
                    value: code.value
                };
                fn($event)
            }
            $scope.codeDblclick = function($event, code, index, pageIndex){
                if(vm.pageData[vm.pageIndex].scene){
                    if(vm.onRatioinfo){
                        vm.onRatioinfo();
                    }
                    return
                }
                vm.that.elementInit(index,(pageIndex ? pageIndex : vm.pageIndex),code,'code');
                vm.that.code={
                    width: transitionMm(code.geometry.width),
                    height: transitionMm(code.geometry.height),
                    value: code.value
                };
                vm.that.nav='qrcode';
                fn($event)
            }
            $scope.initCodeQrcode = function(index, code){
                $timeout(function(){
                    var id = 'code-qrcode-' + vm.pageIndex + '-' + index;
                    var el = document.getElementById(id);
                    if(el){
                        el.innerHTML = '';
                        if(code && code.value){
                            var scale = window.devicePixelRatio || 1;
                            var targetWidth = Math.floor(code.geometry.width * vm.pageData[vm.pageIndex].custom.ratio);
                            var targetHeight = Math.floor(code.geometry.height * vm.pageData[vm.pageIndex].custom.ratio);

                            var tempDiv = document.createElement('div');
                            var qrcodeInst = new QRCode(tempDiv, {
                                text: code.value,
                                width: 256,
                                height: 256,
                                colorDark: '#000000',
                                colorLight: '#ffffff',
                                correctLevel: QRCode.CorrectLevel.M
                            });

                            var qr = qrcodeInst._oQRCode;
                            var moduleCount = qr.getModuleCount();
                            var moduleSize = Math.max(2, Math.floor(targetWidth / moduleCount));
                            var canvasWidth = moduleCount * moduleSize * scale;
                            var canvasHeight = moduleCount * moduleSize * scale;

                            var canvas = document.createElement('canvas');
                            canvas.width = canvasWidth;
                            canvas.height = canvasHeight;

                            var ctx = canvas.getContext('2d');
                            ctx.imageSmoothingEnabled = false;
                            ctx.mozImageSmoothingEnabled = false;
                            ctx.webkitImageSmoothingEnabled = false;

                            for(var row = 0; row < moduleCount; row++){
                                for(var col = 0; col < moduleCount; col++){
                                    if(qr.isDark(row, col)){
                                        ctx.fillStyle = '#000000';
                                    }else{
                                        ctx.fillStyle = '#ffffff';
                                    }
                                    ctx.fillRect(col * moduleSize * scale, row * moduleSize * scale, moduleSize * scale, moduleSize * scale);
                                }
                            }

                            var base64Data = canvas.toDataURL('image/png');
                            var img = document.createElement('img');
                            img.src = base64Data;
                            img.style.width = '100%';
                            img.style.height = '100%';
                            img.style.display = 'block';
                            img.style.imageRendering = '-webkit-optimize-contrast';
                            img.style.imageRendering = 'crisp-edges';
                            img.style.imageRendering = 'pixelated';

                            el.appendChild(img);

                            $scope.uploadQrcodeToQiniu(base64Data, code);
                        }
                    }
                }, 0);
            }
            $scope.uploadQrcodeToQiniu = function(base64Data, code) {
                if (!code || !code.value) {
                    return;
                }

                if (!vm.qiniuToken || !vm.qiniuDomain) {
                    if (!vm.qiniuUploadQueue) {
                        vm.qiniuUploadQueue = [];
                    }
                    vm.qiniuUploadQueue.push({ base64Data: base64Data, code: code });
                    return;
                }

                if (code.imageUrl && code.imageUrl !== '' && code.lastUploadedValue === code.value) {
                    return;
                }

                var base64 = base64Data.split(',')[1];
                var byteString = atob(base64);
                var mimeType = base64Data.split(',')[0].split(':')[1].split(';')[0];
                var ab = new ArrayBuffer(byteString.length);
                var ia = new Uint8Array(ab);
                for (var i = 0; i < byteString.length; i++) {
                    ia[i] = byteString.charCodeAt(i);
                }
                var blob = new Blob([ab], { type: mimeType });
                var file = new File([blob], 'qrcode-' + Date.now() + '.png', { type: mimeType });

                var formData = new FormData();
                formData.append('file', file);
                formData.append('key', "file-" + UidService.get());
                formData.append('token', vm.qiniuToken);

                var reader = new FileReader();
                reader.readAsArrayBuffer(file);
                reader.onloadend = function (e) {
                    formData.append('crc32', CRC32.buf(new Uint8Array(this.result)));
                    $.ajax({
                        cache: true,
                        type: "POST",
                        url: 'https://upload.qiniup.com/',
                        data: formData,
                        async: true,
                        contentType: false,
                        processData: false,
                        success: function (data) {
                            code.previewImage = vm.qiniuDomain + data.key;
                            // code.lastUploadedValue = code.value;
                            $scope.processQiniuUploadQueue();
                        },
                        error: function (request) {
                            console.error('Qiniu upload failed');
                        }
                    });
                };
            }

            $scope.processQiniuUploadQueue = function() {
                if (vm.qiniuUploadQueue && vm.qiniuUploadQueue.length > 0 && vm.qiniuToken && vm.qiniuDomain) {
                    var item = vm.qiniuUploadQueue.shift();
                    $scope.uploadQrcodeToQiniu(item.base64Data, item.code);
                }
            }

            /***********************  二维码end  ****************************/
            /***********************  素材  ****************************/
            $scope.imageartClick = function($event, imageart, index, pageIndex){
                if(imageart.onlyshow){
                    return
                }
                if(vm.that.levelInif1){vm.that.levelInif1()};
                if(vm.that.ctrlKey){
                    imageart.ctrlKey = true;
                }else{
                    if(!imageart.ctrlKey){
                        if(vm.that.levelInif){vm.that.levelInif()}
                    }
                }
                vm.that.elementInit(index,(pageIndex ? pageIndex : vm.pageIndex),imageart,'imageart');
                fn($event)
            }
            //素材缩放right
            $scope.imageartdownZoomRight = function($event, item){
                editorBoxZoom($event, item, 'rightBottom', vm.pageData[vm.pageIndex].custom.ratio, $($event.target).parents('.selected'), function (it) {
                    calMonthBoxW()
                    vm.that.hint = !editboxIn(vm.pageData[vm.pageIndex].editboxes.editbox , item.geometry, item.rotation.angle);
                    $scope.$apply();
                }, function (it) {
                    vm.that.hint = false;
                    calMonthBoxW()
                    vm.that.cookie()
                });
                fn($event)
            }
            //素材缩放left
            $scope.imageartdownZoomLeft = function ($event, item) {
                editorBoxZoom($event, item, 'leftTop', vm.pageData[vm.pageIndex].custom.ratio, $($event.target).parents('.selected'), function (it) {
                    calMonthBoxW()
                    vm.that.hint = !editboxIn(vm.pageData[vm.pageIndex].editboxes.editbox , item.geometry, item.rotation.angle);
                    $scope.$apply();
                }, function (it) {
                    vm.that.hint = false;
                    calMonthBoxW()
                    vm.that.cookie()
                });
                fn($event)
            }
            //素材缩放top
            $scope.imageartdownZoomTop = function ($event, item) {
                editorBoxZoom($event, item, 'rightTop', vm.pageData[vm.pageIndex].custom.ratio, $($event.target).parents('.selected'), function (it) {
                    calMonthBoxW()
                    vm.that.hint = !editboxIn(vm.pageData[vm.pageIndex].editboxes.editbox , item.geometry, item.rotation.angle);
                    $scope.$apply();
                }, function (it) {
                    vm.that.hint = false;
                    calMonthBoxW()
                    vm.that.cookie()
                });
                fn($event)
            }
            //素材缩放bottom
            $scope.imageartdownZoomBottom = function ($event, item) {
                editorBoxZoom($event, item, 'leftBottom', vm.pageData[vm.pageIndex].custom.ratio, $($event.target).parents('.selected'), function (it) {
                    calMonthBoxW()
                    vm.that.hint = !editboxIn(vm.pageData[vm.pageIndex].editboxes.editbox , item.geometry, item.rotation.angle);
                    $scope.$apply();
                }, function (it) {
                    vm.that.hint = false;
                    calMonthBoxW()
                    vm.that.cookie()
                });
                fn($event)
            }
            function calMonthBoxW(item){
                if(item && item.geometry && vm.elementOn && vm.elementOn.name && vm.elementOn.name == 'calMonthBox'){
                    var _width = angular.copy(item.geometry.width);
                    var _height = angular.copy(item.geometry.height);
                    item.geometry.width = Math.floor(item.geometry.width/7) * 7;
                    item.geometry.height = item.geometry.width*_height/_width;
                }
            }
            //素材旋转
            $scope.imageartdownRotate = function($event, item){
                if(item.lock){return}
                var _top = $($event.target).parents('.c-xml-page-material').offset().top + (item.geometry.height * vm.pageData[vm.pageIndex].custom.ratio / 2);
                var _left = $($event.target).parents('.c-xml-page-material').offset().left + (item.geometry.width * vm.pageData[vm.pageIndex].custom.ratio / 2);
                webRotate($scope, $event, item, _top, _left, ModulesService, function () {
                    vm.that.cookie()
                })
                fn($event);
            }
            //双击素材裁切
            $scope.imageartDblclick = function($event, item){
                fn($event)
                // if(vm.pageData[vm.pageIndex].scene){
                //     if(vm.onRatioinfo){
                //         vm.onRatioinfo();
                //     }
                //     return
                // }
                if(item.lock){return}
                vm.isImageartTrim = true;
                vm.that.showEditorDialog = false;
                syncEditorBodyPosition();
                vm.isImageartTrimIndex = angular.copy(vm.elementOn.index);
                vm.imageartTrim = ModulesService.doubleClickClipart($event, item, vm.pageData[vm.pageIndex].custom.ratio);
            }

            //拖动素材裁切
            var isImageartTrim = false;
            $scope.imageartTrimdown = function ($event) {
                var $event = $event || window.event;
                if($event && $event.preventDefault){
                    $event.preventDefault();
                }
                else {
                    window.event.returnValue = false;
                    return false;
                }
                var x = $event.clientX;
                var y = $event.clientY;
                var l = vm.imageartTrim.geometry.x * vm.pageData[vm.pageIndex].custom.ratio;
                var t = vm.imageartTrim.geometry.y * vm.pageData[vm.pageIndex].custom.ratio;
                var r = (vm.imageartTrim.geometry.width1 * vm.imageartTrim.scale - vm.imageartTrim.geometry.width) * vm.pageData[vm.pageIndex].custom.ratio;
                var b = (($("#c-xml-imageart-trim-img").find('img').height()) / vm.pageData[vm.pageIndex].custom.ratio - vm.imageartTrim.geometry.height) * vm.pageData[vm.pageIndex].custom.ratio;
                var x1 = (Number(vm.imageartTrim.geometry.x1) + Number(vm.imageartTrim.offsetx)) * vm.pageData[vm.pageIndex].custom.ratio;
                var y1 = (Number(vm.imageartTrim.geometry.y1) + Number(vm.imageartTrim.offsety)) * vm.pageData[vm.pageIndex].custom.ratio;
                //开关打开
                isImageartTrim = true;
                //鼠标移动
                window.onmousemove = function (e) {
                    if (isImageartTrim == false) {
                        return;
                    }
                    //获取x和y
                    var nx = e.clientX;
                    var ny = e.clientY;
                    //计算移动后的左偏移量和顶部的偏移量
                    var nl = nx - (x - l);
                    var nt = ny - (y - t);

                    if(nl< x1){ nl = x1};
                    if(nl > Number(r) + Number(x1)){ nl = Number(r) + Number(x1)};
                    if(nt < y1){ nt = y1};
                    if(nt > Number(b) + Number(y1)){ nt = Number(b) + Number(y1)};

                    vm.imageartTrim.geometry.x = nl / vm.pageData[vm.pageIndex].custom.ratio;
                    vm.imageartTrim.geometry.y = nt / vm.pageData[vm.pageIndex].custom.ratio;
                    $scope.$digest();
                }
                //鼠标抬起事件
                window.onmouseup = function ($event) {
                    isImageartTrim = false;
                    $event.stopPropagation();
                }
            }

            //素材裁切放大缩小
            var isImageartTrimRight = false;
            $scope.imageartTrimRight = function($event, item){
                var $event = $event || window.event;                  // IE、火狐获取事件对象
                //防止浏览器默认行为(W3C)
                if($event && $event.preventDefault){
                    $event.preventDefault();
                }
                //IE中组织浏览器行为
                else {
                    window.event.returnValue = false;
                    return false;
                }
                $event.stopPropagation();
                var x = $event.clientX;
                var y = $event.clientY;
                //获取w和h
                var nw = Number(vm.imageartTrim.geometry.width * vm.pageData[vm.pageIndex].custom.ratio) + Number(vm.imageartTrim.geometry.x * vm.pageData[vm.pageIndex].custom.ratio);
                var nh = Number(vm.imageartTrim.geometry.height * vm.pageData[vm.pageIndex].custom.ratio) + Number(vm.imageartTrim.geometry.y * vm.pageData[vm.pageIndex].custom.ratio);
                var _l = vm.imageartTrim.geometry.x * vm.pageData[vm.pageIndex].custom.ratio;
                var _t = vm.imageartTrim.geometry.y * vm.pageData[vm.pageIndex].custom.ratio;

                var r = Number(vm.imageartTrim.geometry.x1 * vm.pageData[vm.pageIndex].custom.ratio) + Number(vm.imageartTrim.offsetx * vm.pageData[vm.pageIndex].custom.ratio) + Number(vm.imageartTrim.geometry.width1 * vm.pageData[vm.pageIndex].custom.ratio * vm.imageartTrim.scale);
                var b = Number(vm.imageartTrim.geometry.y1 * vm.pageData[vm.pageIndex].custom.ratio) + Number(vm.imageartTrim.offsety * vm.pageData[vm.pageIndex].custom.ratio) + Number($("#imageartTrimRight1").height());
                //开关打开
                isImageartTrimRight = true;

                //鼠标移动
                window.onmousemove = function (e) {
                    if (isImageartTrimRight == false) {
                        return;
                    }
                    //获取x和y
                    var nx = e.clientX;
                    var ny = e.clientY;
                    //计算移动后的左偏移量和顶部的偏移量
                    var nl = Number(nw) + Number(nx - x);
                    var nt = Number(nh) + Number(ny - y);

                    if(nl >= r){nl = r}
                    if(nt >= b){ nt = b}

                    item.geometry.width = (nl - _l) / vm.pageData[vm.pageIndex].custom.ratio;
                    item.geometry.height = (nt - _t) / vm.pageData[vm.pageIndex].custom.ratio;
                    $scope.$digest();
                }
                //鼠标抬起事件
                window.onmouseup = function ($event) {
                    isImageartTrimRight = false;
                    $event.stopPropagation();
                }
            }
            $scope.imageartTrimRight1 = function($event, item){
                var $event = $event || window.event;                  // IE、火狐获取事件对象
                //防止浏览器默认行为(W3C)
                if($event && $event.preventDefault){
                    $event.preventDefault();
                }
                //IE中组织浏览器行为
                else {
                    window.event.returnValue = false;
                    return false;
                }
                $event.stopPropagation();
                var x = $event.clientX;
                var y = $event.clientY;
                //获取w和h
                var nw = item.geometry.width1 * vm.pageData[vm.pageIndex].custom.ratio * vm.imageartTrim.scale;
                var nh = item.geometry.height1 * vm.pageData[vm.pageIndex].custom.ratio * vm.imageartTrim.scale;

                var r = Number($("#c-xml-imageart-div").offset().left) + Number(vm.pageData[vm.pageIndex].levels.level[vm.elementOn.index].imageart.geometry.width * vm.pageData[vm.pageIndex].custom.ratio);
                var x2 = (Number(item.geometry.x1 * vm.pageData[vm.pageIndex].custom.ratio) + Number($("#c-xml-imageart-trim-div").width()) - (Number(item.geometry.x * vm.pageData[vm.pageIndex].custom.ratio) + Number(item.geometry.width * vm.pageData[vm.pageIndex].custom.ratio)));
                var y2 = (Number(item.geometry.y1 * vm.pageData[vm.pageIndex].custom.ratio) + Number($("#c-xml-imageart-trim-div").height()) - (Number(item.geometry.y * vm.pageData[vm.pageIndex].custom.ratio) + Number(item.geometry.height * vm.pageData[vm.pageIndex].custom.ratio)));
                if(x2 < y2){
                    var r1 = Number($("#c-xml-imageart-div").offset().left) + Number(item.geometry.x * vm.pageData[vm.pageIndex].custom.ratio) + Number(item.geometry.width * vm.pageData[vm.pageIndex].custom.ratio);
                }else {
                    var r1 = Number($("#c-xml-imageart-div").offset().left) + Number(item.geometry.x * vm.pageData[vm.pageIndex].custom.ratio) + Number(item.geometry.width * vm.pageData[vm.pageIndex].custom.ratio) + (x2 - y2);
                }
                //开关打开
                isImageartTrimRight = true;

                //鼠标移动
                window.onmousemove = function (e) {
                    if (isImageartTrimRight == false) {
                        return;
                    }
                    //获取x和y
                    var nx = e.clientX;
                    var ny = e.clientY;
                    if(nx >= r){nx = r}
                    if(nx <= r1){nx = r1}

                    //计算移动后的左偏移量和顶部的偏移量
                    var nl = nx - x;
                    var nt = ny - y;

                    item.geometry.width1 = ((Number(nw) + Number(nl))) / vm.pageData[vm.pageIndex].custom.ratio / vm.imageartTrim.scale;
                    item.geometry.height1 = (Number(nh) + Number(nt)) / vm.pageData[vm.pageIndex].custom.ratio / vm.imageartTrim.scale;
                    $scope.$digest();
                }
                //鼠标抬起事件
                window.onmouseup = function ($event) {
                    isImageartTrimRight = false;
                    $event.stopPropagation();
                }
            }
            $scope.imageartTrimTrueClick = function(){
                vm.isImageartTrim = false;
                vm.that.showEditorDialog = true;
                vm.imageartTrim.scale = (vm.imageartTrim.geometry.width1 * vm.pageData[vm.pageIndex].custom.ratio * vm.imageartTrim.scale)/(vm.imageartTrim.geometry.width * vm.pageData[vm.pageIndex].custom.ratio);
                vm.imageartTrim.offsetx = (Number(-(vm.imageartTrim.geometry.x - vm.imageartTrim.geometry.x1)) + Number(vm.imageartTrim.offsetx)).toFixed(2);
                vm.imageartTrim.offsety = (Number(-(vm.imageartTrim.geometry.y - vm.imageartTrim.geometry.y1)) + Number(vm.imageartTrim.offsety)).toFixed(2);
                if(vm.imageartTrim.offsetx > 0){
                    vm.imageartTrim.offsetx = 0;
                }
                if(vm.imageartTrim.offsety > 0){
                    vm.imageartTrim.offsety = 0;
                }
                if(vm.imageartTrim.scale < 1){
                    vm.imageartTrim.scale = 1;
                }
                // if(vm.imageartTrim.geometry.width > vm.imageartTrim.geometry.width1 * vm.imageartTrim.scale){
                //     vm.imageartTrim.geometry.width = vm.imageartTrim.geometry.width1 * vm.imageartTrim.scale;
                // }
                vm.imageartTrim.geometry.x = vm.pageData[vm.pageIndex].levels.level[vm.isImageartTrimIndex].imageart.geometry.x;
                vm.imageartTrim.geometry.y = vm.pageData[vm.pageIndex].levels.level[vm.isImageartTrimIndex].imageart.geometry.y;
                vm.pageData[vm.pageIndex].levels.level[vm.isImageartTrimIndex].imageart = vm.imageartTrim;
                vm.that.cookie();
            }
            $scope.imageartTrimFalseClick = function(){
                vm.isImageartTrim = false;
                vm.that.showEditorDialog = true;
            }
            /***********************  素材end  ****************************/
            /***********************  背景  ****************************/

            //双击作品框
            vm.isXmlDblclick = false;
            $scope.editboxDblclick = function($event){
                if(vm.pageData[vm.pageIndex].scene){
                    if(vm.onRatioinfo){
                        vm.onRatioinfo();
                    }
                }else{
                    if(vm.pageData[vm.pageIndex].background.resource.identifier){
                        vm.bgImg = angular.copy(vm.pageData[vm.pageIndex].background);
                        vm.isXmlDblclick = true;
                        vm.that.showEditorDialog = false;
                        syncEditorBodyPosition();
                    }
                }
                fn($event);
            }
            //拖动背景
            var isBgImgMouseDown = false;
            var oldX = 0;
            var oldY = 0;
            //鼠标按下事件
            $scope.bgImgMouseDown = function ($event) {
                var $event = $event || window.event;
                if($event && $event.preventDefault){
                    $event.preventDefault();
                }
                else {
                    window.event.returnValue = false;
                    return false;
                }
                $event.stopPropagation();
                var x = $event.clientX;
                var y = $event.clientY;
                var l = $event.target.offsetParent.offsetLeft;
                var t = $event.target.offsetParent.offsetTop;

                var x1 = $event.target.offsetLeft;
                var y1 = $event.target.offsetTop;
                oldX = $event.target.offsetLeft;
                oldY = $event.target.offsetTop;

                var l1 = -($($event.target).width() - vm.pageData[vm.pageIndex].mediabox.width * vm.pageData[vm.pageIndex].custom.ratio);
                var t1 = -($($event.target).height() - vm.pageData[vm.pageIndex].mediabox.height * vm.pageData[vm.pageIndex].custom.ratio);
                //开关打开
                isBgImgMouseDown = true;
                //鼠标移动
                window.onmousemove = function (e) {
                    if (isBgImgMouseDown == false) {
                        return;
                    }
                    //获取x和y
                    var nx = e.clientX;
                    var ny = e.clientY;
                    //计算移动后的左偏移量和顶部的偏移量
                    var nl = Number(nx - (x - l)) + Number(x1);
                    var nt = Number(ny - (y - t)) + Number(y1);

                    if(vm.bgImg.resource.adaptation == 'Height'){
                        // if(nl == 0){ return;}
                        if(nl < l1){nl = Number(l1) + Number(1);}
                        if(nl > 0){nl = 0;}
                        vm.bgImg.offsetx = nl / vm.pageData[vm.pageIndex].custom.ratio;
                        $($event.target).css({
                            left: nl + 'px'
                        });
                    }
                    if(vm.bgImg.resource.adaptation == 'Width'){
                        // if(nt == 0){ return;}
                        if(nt <= t1){nt = Number(t1) + Number(1);}
                        if(nt > 0){nt = 0;}
                        vm.bgImg.offsety = nt / vm.pageData[vm.pageIndex].custom.ratio;
                        $($event.target).css({
                            top: nt + 'px'
                        });
                    }
                    $scope.$digest();
                }
                //鼠标抬起事件
                window.onmouseup = function ($event) {
                    if(isBgImgMouseDown){
                        vm.that.cookie();
                    }
                    isBgImgMouseDown = false;
                    $event.stopPropagation();
                }
            }
            $scope.bgImgTrueClick = function () {
                vm.isXmlDblclick = false;
                vm.that.showEditorDialog = true;
                vm.pageData[vm.pageIndex].background = vm.bgImg;
                vm.pageData[vm.pageIndex].background.color="";
                vm.that.cookie();
            }
            $scope.bgImgFalseClick = function () {
                vm.isXmlDblclick = false;
                vm.that.showEditorDialog = true;
            }
            /***********************  背景end  ****************************/
            /***********************  文字  ****************************/


            $scope.writingmodeInit = function (item) {
                if(item == 'vertical-lr' || item == 'vertical-rl'){
                    return true
                }else{
                    return false
                }
            }
            //选中文字
            $scope.textboxClick = function(e, item, index, pageIndex){
                if (vm.that.textFont) {
                    return
                }
                if(vm.that.levelInif1){vm.that.levelInif1()};
                if(vm.that.ctrlKey){
                    item.ctrlKey = true;
                }else{
                    if(!item.ctrlKey){
                        if(vm.that.levelInif){vm.that.levelInif()}
                    }
                }
                if (e && e.stopPropagation) {
                    e.stopPropagation();
                } else {
                    window.event.cancelBubble = true;
                }
                // if(vm.elementOn.name=='textbox' && vm.elementOn.index == index){
                //     return
                // }
                vm.that.elementInit(index,(pageIndex ? pageIndex : vm.pageIndex),item,'textbox');
                vm.that.fontStyleCb(item.fontuuid);
            }
            //文字放大缩小
            $scope.textboxZoomRight = function($event, item){
                editorBoxZoom($event, item, 'right', vm.pageData[vm.pageIndex].custom.ratio, $($event.target).parents('.selected'), function (it) {
                    vm.elementOn.item = it;
                    vm.that.sizeHeight();
                    vm.that.hint = !editboxIn(vm.pageData[vm.pageIndex].editboxes.editbox , item.geometry, item.rotation.angle);
                    $scope.$digest();
                }, function (it) {
                    vm.that.hint = false;
                    vm.that.cookie()
                });
            }
            $scope.textboxZoomLeft = function($event, item){
                editorBoxZoom($event, item, 'left', vm.pageData[vm.pageIndex].custom.ratio, $($event.target).parents('.selected'), function (it) {
                    vm.elementOn.item = it;
                    vm.that.sizeHeight();
                    vm.that.hint = !editboxIn(vm.pageData[vm.pageIndex].editboxes.editbox , item.geometry, item.rotation.angle);
                    $scope.$digest();
                }, function (it) {
                    vm.that.hint = false;
                    vm.that.cookie()
                });
            }

            $scope.textboxZoomTop = function($event, item){
                editorBoxZoom($event, item, 'top', vm.pageData[vm.pageIndex].custom.ratio, $($event.target).parents('.selected'), function (it) {
                    vm.elementOn.item = it;
                    vm.that.sizeHeight();
                    vm.that.hint = !editboxIn(vm.pageData[vm.pageIndex].editboxes.editbox , item.geometry, item.rotation.angle);
                    $scope.$digest();
                }, function (it) {
                    vm.that.hint = false;
                    vm.that.cookie()
                });
            }
            $scope.textboxZoomBottom = function($event, item){
                editorBoxZoom($event, item, 'bottom', vm.pageData[vm.pageIndex].custom.ratio, $($event.target).parents('.selected'), function (it) {
                    vm.elementOn.item = it;
                    vm.that.sizeHeight();
                    vm.that.hint = !editboxIn(vm.pageData[vm.pageIndex].editboxes.editbox , item.geometry, item.rotation.angle);
                    $scope.$digest();
                }, function (it) {
                    vm.that.hint = false;
                    vm.that.cookie()
                });
            }
            $scope.textboxZoomLeft1 = function($event, item){
                editorBoxZoom($event, item, 'leftTop', vm.pageData[vm.pageIndex].custom.ratio, $($event.target).parents('.selected'), function (it) {
                    vm.elementOn.item = it;
                    vm.that.sizeHeight();
                    vm.that.hint = !editboxIn(vm.pageData[vm.pageIndex].editboxes.editbox , item.geometry, item.rotation.angle);
                    $scope.$digest();
                }, function (it) {
                    vm.that.hint = false;
                    vm.that.cookie()
                });
            };
            $scope.textboxZoomTop1 = function($event, item){
                editorBoxZoom($event, item, 'rightTop', vm.pageData[vm.pageIndex].custom.ratio, $($event.target).parents('.selected'), function (it) {
                    vm.elementOn.item = it;
                    vm.that.sizeHeight();
                    vm.that.hint = !editboxIn(vm.pageData[vm.pageIndex].editboxes.editbox , item.geometry, item.rotation.angle);
                    $scope.$digest();
                }, function (it) {
                    vm.that.hint = false;
                    vm.that.cookie()
                });
            };
            $scope.textboxZoomRight1 = function($event, item){
                editorBoxZoom($event, item, 'rightBottom', vm.pageData[vm.pageIndex].custom.ratio, $($event.target).parents('.selected'), function (it) {
                    vm.elementOn.item = it;
                    vm.that.sizeHeight();
                    vm.that.hint = !editboxIn(vm.pageData[vm.pageIndex].editboxes.editbox , item.geometry, item.rotation.angle);
                    $scope.$digest();
                }, function (it) {
                    vm.that.hint = false;
                    vm.that.cookie()
                });
            };
            $scope.textboxZoomBottom1 = function($event, item){
                editorBoxZoom($event, item, 'leftBottom', vm.pageData[vm.pageIndex].custom.ratio, $($event.target).parents('.selected'), function (it) {
                    vm.elementOn.item = it;
                    vm.that.sizeHeight();
                    vm.that.hint = !editboxIn(vm.pageData[vm.pageIndex].editboxes.editbox , item.geometry, item.rotation.angle);
                    $scope.$digest();
                }, function (it) {
                    vm.that.hint = false;
                    vm.that.cookie()
                });
            };
            //文字旋转
            $scope.textboxRotate = function($event, item){
                if(item.lock){return}
                var _top = $($event.target).parents('.c-xml-page-textboxe').offset().top + (item.geometry.height * vm.pageData[vm.pageIndex].custom.ratio / 2);
                var _left = $($event.target).parents('.c-xml-page-textboxe').offset().left + (item.geometry.width * vm.pageData[vm.pageIndex].custom.ratio / 2);
                webRotate($scope, $event, item, _top, _left, ModulesService, function () {
                    vm.that.cookie()
                })
                fn($event)
            }
            $scope.doubleClicktext = function (e, item) {
                fn(e);
                // if(vm.pageData[vm.pageIndex].scene){
                //     if(vm.onRatioinfo){
                //         vm.onRatioinfo();
                //     }
                //     return
                // }
                if (item.lock || !item.editable || vm.that.textFont) {
                    return
                }
                item.edit = true;
                item.textCopy = angular.copy(item.text);
                vm.that.fontOn = $(e.target).parents('.c-xml-page-textboxe');
                var span = vm.that.fontOn.find('span');
                span[0].innerHTML = '';
                span.focus();
                vm.that.textFont = true;
                span[0].innerHTML = item.text;
                $(span[0]).css({'cursor':'text'});
                span[0].setAttribute("contenteditable", "true");
                if (document.selection) {
                    var range = document.body.createTextRange();
                    range.moveToElementText(span[0]);
                    range.select();
                } else if (window.getSelection) {
                    var range = document.createRange();
                    range.selectNodeContents(span[0]);
                    window.getSelection().removeAllRanges();
                    window.getSelection().addRange(range);
                }
                // $scope.$apply();
            }
            $scope.blur = function (e, item, i) {
                fn(e);
                $timeout(function () {
                    item.edit = false;
                    var fontOn = $(e.target).parents('.c-xml-page-textboxe');
                    var span = fontOn.find('span');
                    $(span[0]).css({'cursor':'pointer'});
                    span[0].setAttribute("contenteditable", "false");
                    var textbox = angular.copy(item);
                    textbox.text = $(e.target).text();
                    textbox.text = textbox.text.replace(/&nbsp;/g,' ').replace(reg1,'').replace(/<br>/g,'\n').replace(reg,'');
                    FontManagement.fontSupport2({uuid:textbox.fontuuid,bold:textbox.style.bold,italic:textbox.style.italic,content:textbox.text},function (res) {
                        var msg = res.data;
                        if(res.status==200){
                            if (!msg.success || msg.failed) {
                                MessageService.confirm({
                                    title:$translate.instant("editorMessage.warmPrompt"),
                                    confirm:$translate.instant("button.returnCorrection"),
                                    msg:$translate.instant("editorMessage.pleaseChangeFonts1") +
                                    '<span class="theme-color">'+msg.failed+'</span>' + $translate.instant("editorMessage.pleaseChangeFonts2")
                                })
                                item.text = angular.copy(item.textCopy);
                                $(e.target).html(item.text)
                                $timeout(function () {
                                    vm.that.sizeHeight();
                                    vm.that.textFont = false;
                                })
                            }else{
                                item.text = msg.passed == "" ?  $translate.instant("editorMessage.pleaseEnterText") : msg.passed;
                                $(e.target).html(item.text)
                                $("#pageCanvas").css({'z-index': 9})
                                $(".editor-body").css({'z-index': 9})
                                vm.editFailedFont = false;
                                vm.that.showEditorDialog = true;
                                vm.failedFontArr = null;
                                $timeout(function () {
                                    vm.that.sizeHeight();
                                    vm.that.textFont = false;
                                    $timeout(function () {
                                        vm.that.cookie();
                                    },500)
                                },200)
                            }
                        }
                    })
                })
            }
            $scope.editFont = function (e) {
                fn(e);
                vm.editFailedFont = false;
                vm.that.showEditorDialog = true;
                $("#pageCanvas").css({'z-index': 9});
                $(".editor-body").css({'z-index': 9})
                // $scope.doubleClicktext(vm.failedFontArr.e,vm.failedFontArr.textbox)
            }
            // //去除所有html标签，只保留文字
            var reg=/<\/?.+?\/?>/g;
            // 过滤style行内标签
            var reg1=/ style\s*?=\s*?(['"])[\s\S]*?\1/g;
            window.textPaste = function (e) {
                textPaste1(e)
            };
            $scope.changeHeight = function(e,item){
                if(e && $(e.target)){
                    vm.elementOn.item.text = $(e.target).text();
                    vm.elementOn.item.text = vm.elementOn.item.text.replace(/&nbsp;/g,' ').replace(reg1,'').replace(/<br>/g,'\n').replace(reg,'');
                    vm.that.sizeHeight();
                }
            }
            document.body.onpaste=function(e){
                var data = e.clipboardData.getData("Text");
                if(vm.elementOn.item.current == "textbox"){
                    vm.elementOn.item.text = data;
                    vm.elementOn.item.text = vm.elementOn.item.text.replace(/&nbsp;/g,' ').replace(reg1,'').replace(/<br>/g,'\n').replace(reg,'');
                    vm.that.sizeHeight();
                    $scope.$apply();
                }
            }
            /***********************  文字end  ****************************/
            /***********************  文字模板  ****************************/
            $scope.textdocumentClick = function($event, item, index, pageIndex){
                vm.that.elementInit(index,(pageIndex ? pageIndex : vm.pageIndex),item,'textdocument');
                fn($event)
            };
            var dragDocFlag = false, dragDoc = {}, textdocW = 1, textdocH = 1, textdocument = null;
            window.resizeDocStart = function (e) {
                fn(e);
                var targ = e.target ? e.target : e.srcElement;
                vm.elementOn.index = targ.dataset.index;
                textdocument = angular.copy(vm.pageData[vm.pageIndex].levels.level[vm.elementOn.index].textdocument);
                if (textdocument.lock) {
                    return
                }
                dragDoc.clientX = e.clientX || 0;          //鼠标到页面左边的距离
                dragDoc.clientY = e.clientY || 0;          //鼠标到页面顶部的距离
                dragDoc.coordX = targ.offsetParent.offsetLeft + targ.offsetLeft;        //鼠标到模板左边的距离
                dragDoc.coordY = targ.offsetParent.offsetTop + targ.offsetTop;         //鼠标到模板顶部的距离
                dragDoc.maxX = vm.pageData[vm.pageIndex].trimbox.width * vm.pageData[vm.pageIndex].custom.ratio;
                dragDoc.maxY = vm.pageData[vm.pageIndex].trimbox.height * vm.pageData[vm.pageIndex].custom.ratio;
                dragDocFlag = true;
                textdocW = angular.copy(textdocument.geometry.width);
                textdocH = angular.copy(textdocument.geometry.height);

                document.addEventListener("mousemove", resizeDocOn, true);
                document.addEventListener("mouseup", resizeDocEnd, true);
                // setZindex(e.target.dataset.index);
            };
            function resizeDocOn(e) {
                if (dragDocFlag) {
                    fn(e);
                    // 是否按住shift键
                    dragDoc.shiftKey = e.shiftKey;
                    var targ = e.target ? e.target : e.srcElement;
                    if (targ == null) {
                        return;
                    }
                    var pressImg = vm.pageData[vm.pageIndex].levels.level[vm.elementOn.index].textdocument;
                    if (pressImg == null) {
                        return;
                    }

                    var w = (dragDoc.coordX + 10 + e.clientX - dragDoc.clientX - pressImg.geometry.x * vm.pageData[vm.pageIndex].custom.ratio) / vm.pageData[vm.pageIndex].custom.ratio;
                    var h = w / pressImg.geometry.width * pressImg.geometry.height
                    if (w < 40 || h < 40) {
                        return
                    }

                    var moveW = (dragDoc.maxX - pressImg.geometry.x * vm.pageData[vm.pageIndex].custom.ratio) / (vm.pageData[vm.pageIndex].custom.ratio);
                    var moveH = (dragDoc.maxY - pressImg.geometry.y * vm.pageData[vm.pageIndex].custom.ratio) / (vm.pageData[vm.pageIndex].custom.ratio);

                    if (w < moveW && h < moveH) {
                        pressImg.geometry.width = w;
                        pressImg.geometry.height = h;
                    }

                    // if (e.clientX < dragDoc.maxX && e.clientY < dragDoc.maxY) {

                    // }

                    resizeLevelWaH();
                }
                $scope.$digest();
                return false;
            }
            function resizeDocEnd() {
                if(dragDocFlag){
                    vm.that.cookie();
                }
                dragDocFlag = false;
                dragDoc = {};
                document.removeEventListener("mousemove", resizeDocOn, true);
                document.removeEventListener("mouseup", resizeDocEnd, true);
                $scope.$digest();
            }
            function resizeLevelWaH() {
                var doc = vm.pageData[vm.pageIndex].levels.level[vm.elementOn.index].textdocument;
                doc.background.offsetx = textdocument.background.offsetx * doc.geometry.width / textdocW;
                doc.background.offsety = textdocument.background.offsety * doc.geometry.height / textdocH;
                // doc.background.width = textdocument.background.width * doc.geometry.width / textdocW;
                // doc.background.height = textdocument.background.height * doc.geometry.height / textdocH;

                angular.forEach(doc.levels.level, function (level, l) {
                    var textdoc = textdocument.levels.level[l];
                    if (level.imageart) {
                        var geo = {
                            width: textdoc.imageart.geometry.width * doc.geometry.width / textdocW,
                            height: textdoc.imageart.geometry.height * doc.geometry.height / textdocH,
                            x: textdoc.imageart.geometry.x * doc.geometry.width / textdocW,
                            y: textdoc.imageart.geometry.y * doc.geometry.height / textdocH,
                        }
                        level.imageart.geometry = geo;
                        level.imageart.offsetx = textdoc.imageart.offsetx * doc.geometry.width / textdocW;
                        level.imageart.offsety = textdoc.imageart.offsety * doc.geometry.height / textdocH;
                    }
                    if (level.textbox) {
                        var textGeo = {
                            width: textdoc.textbox.geometry.width * doc.geometry.width / textdocW,
                            height: textdoc.textbox.geometry.height * doc.geometry.height / textdocH,
                            x: textdoc.textbox.geometry.x * doc.geometry.width / textdocW,
                            y: textdoc.textbox.geometry.y * doc.geometry.height / textdocH,
                        }
                        level.textbox.geometry = textGeo;
                        level.textbox.style.size = textdoc.textbox.style.size * doc.geometry.width / textdocW;
                        level.textbox.style.lineheight = textdoc.textbox.style.lineheight * doc.geometry.width / textdocW;
                        level.textbox.style.letterspacing = textdoc.textbox.style.letterspacing * doc.geometry.width / textdocW;
                    }
                })
            }
            /***********************  文字end  ****************************/
            /***********************  日历  ****************************/
            $scope.calMonthBoxClick = function($event, item, index, pageIndex){
                if(item.onlyshow){
                    return
                }
                if(vm.that.levelInif1){vm.that.levelInif1()};
                if(vm.that.ctrlKey){
                    item.ctrlKey = true;
                }else{
                    if(!item.ctrlKey){
                        if(vm.that.levelInif){vm.that.levelInif()}
                    }
                }
                vm.that.elementInit(index,(pageIndex ? pageIndex : vm.pageIndex),item,'calMonthBox');
                fn($event)
            }
            /***********************  日历end  ****************************/
            /***********************  日历标题  ****************************/
            $scope.calTitleBoxClick = function($event, item, index, pageIndex){
                if(item.onlyshow){
                    return
                }
                if(vm.that.levelInif1){vm.that.levelInif1()};
                if(vm.that.ctrlKey){
                    item.ctrlKey = true;
                }else{
                    if(!item.ctrlKey){
                        if(vm.that.levelInif){vm.that.levelInif()}
                    }
                }
                vm.that.elementInit(index,(pageIndex ? pageIndex : vm.pageIndex),item,'calTitleBox');
                fn($event)
            }
            /***********************  日历标题end  ****************************/
            //解锁
            $scope.locking = function(e){
                vm.that.locking(e);
            }
            //图片框、素材、文字等元素事件
            $scope.moveWebdown = function ($event, item) {
                if (vm.that.textFont) {
                    return
                }
                // 移动时选中当前元素
                var _levels = vm.pageData[vm.pageIndex].levels.level;
                var _elementTypes = ['imagebox', 'imageart', 'code', 'textbox', 'textdocument', 'calMonthBox', 'calTitleBox'];
                for (var _i = 0; _i < _levels.length; _i++) {
                    var _found = false;
                    for (var _t = 0; _t < _elementTypes.length; _t++) {
                        if (_levels[_i][_elementTypes[_t]] === item) {
                            if (vm.that.levelInif1) { vm.that.levelInif1(); }
                            if (vm.that.ctrlKey) {
                                item.ctrlKey = true;
                            } else {
                                if (!item.ctrlKey) {
                                    if (vm.that.levelInif) { vm.that.levelInif(); }
                                }
                            }
                            vm.that.elementInit(_i, vm.pageIndex, item, _elementTypes[_t]);
                            _found = true;
                            break;
                        }
                    }
                    if (_found) { break; }
                }
                if(!item.ctrlKey){
                    if(item.lock || item.edit){return}
                    //获取当前元素的父节点class="pageCanvasItem"在祖先节点id="pageCanvasView"中的位置
                    var $pageCanvasItem = $($event.target).closest('.pageCanvasItem');
                    var left = 0;
                    if($pageCanvasItem.position()){
                        left = $pageCanvasItem.position().left / vm.pageData[vm.pageIndex].custom.ratio || 0;
                    }
                    if(vm.that.staff){
                        vm.coordinates = coordinates(vm.pageData[vm.pageIndex],vm.elementOn.index);
                        var sublinesX = ($scope.$parent.template.xLines.line || []).map(function (x) {
                            return x - left;
                        });
                        vm.coordinates.x = vm.coordinates.x.concat(sublinesX);
                        vm.coordinates.y = vm.coordinates.y.concat($scope.$parent.template.yLines.line || []);
                    }
                    moveWebdown($scope, $event,item, vm.pageData[vm.pageIndex].trimbox,vm.pageData[vm.pageIndex].custom.ratio, function () {
                        if($scope.$parent.outlineHint && vm.elementOn.name === 'imagebox'){$scope.$parent.outlineHint()}
                        vm.that.lineReferenceX = null;
                        vm.that.lineReferenceY = null;
                        vm.that.cookie()
                        vm.that.hint = false;
                    }, function () {
                        if(vm.that.staff && vm.elementOn.name && vm.pageData[vm.pageIndex].levels.level[vm.elementOn.index][vm.elementOn.name]){
                            vm.that.lineReferenceX = null;
                            vm.that.lineReferenceY = null;
                            getItemCoordinates(vm.pageData[vm.pageIndex].levels.level[vm.elementOn.index][vm.elementOn.name],vm.coordinates,function (item) {
                                if(item.x){
                                    vm.that.lineReferenceX = left + item.x.closestNum;
                                    vm.pageData[vm.pageIndex].levels.level[vm.elementOn.index][vm.elementOn.name].geometry.x = vm.pageData[vm.pageIndex].levels.level[vm.elementOn.index][vm.elementOn.name].geometry.x + item.x.diff;
                                }
                                if(item.y){
                                    vm.that.lineReferenceY = item.y.closestNum;
                                    vm.pageData[vm.pageIndex].levels.level[vm.elementOn.index][vm.elementOn.name].geometry.y = vm.pageData[vm.pageIndex].levels.level[vm.elementOn.index][vm.elementOn.name].geometry.y + item.y.diff;
                                }
                            });
                        }
                        vm.that.hint = !editboxIn(vm.pageData[vm.pageIndex].editboxes.editbox , item.geometry, item.rotation.angle);
                    })
                }else{
                    vm.that.levelMove($event)
                }
                fn($event)
            }
            $scope.canvasCb = function (e) {
                $scope.bgImgFalseClick();
                $scope.imageartTrimFalseClick();
                $scope.imageboxFalseClick();
                fn(e)
            }

            //元素精度和位置
            $scope.activeImageDpi = function (item) {
                return activeImageDpi(item)
            }
            $scope.transitionMm = function (item) {
                return transitionMm(item).toFixed(0) > -1 ? Math.abs(transitionMm(item).toFixed(0)) : transitionMm(item).toFixed(0)
            }
            //边框
            $scope.imageboxW = function (imagebox) {
                if (!imagebox) {
                    return
                }
                if (imagebox.border) {
                    if (imagebox.border.type == 'Color') {
                        return Number(imagebox.geometry.width) + Number(imagebox.border.lineWidth) * 2
                    }
                    if (imagebox.border.type == 'Pic') {
                        return imagebox.geometry.width
                        // return Number(imagebox.geometry.width) + (Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100) + (Number(imagebox.geometry.width) * Number(imagebox.border.edge.right) / 100)
                    }
                } else {
                    return imagebox.geometry.width
                }
            }
            $scope.imageboxH = function (imagebox) {
                if (!imagebox) {
                    return
                }
                if (imagebox.border) {
                    if (imagebox.border.type == 'Color') {
                        return Number(imagebox.geometry.height) + Number(imagebox.border.lineWidth) * 2
                    }
                    if (imagebox.border.type == 'Pic') {
                        return imagebox.geometry.height
                        // return Number(imagebox.geometry.height) + (Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100) + (Number(imagebox.geometry.height) * Number(imagebox.border.edge.bottom) / 100)
                    }
                } else {
                    return imagebox.geometry.height
                }
            }
            $scope.imageboxL = function (imagebox) {
                if (!imagebox) {
                    return
                }
                if (imagebox.border) {
                    if (imagebox.border.type == 'Color') {
                        return Number(imagebox.geometry.x) - Number(imagebox.border.lineWidth)
                    }
                    if (imagebox.border.type == 'Pic') {
                        return imagebox.geometry.x
                        // return Number(imagebox.geometry.x) - (Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100)
                    }
                } else {
                    return imagebox.geometry.x
                }
            }
            $scope.imageboxT = function (imagebox) {
                if (!imagebox) {
                    return
                }
                if (imagebox.border) {
                    if (imagebox.border.type == 'Color') {
                        return Number(imagebox.geometry.y) - Number(imagebox.border.lineWidth)
                    }
                    if (imagebox.border.type == 'Pic') {
                        return imagebox.geometry.y
                        // return Number(imagebox.geometry.y) - (Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100)
                    }
                } else {
                    return imagebox.geometry.y
                }
            }
            $scope.imageboxWEdge = function (imagebox, edge) {
                if (!imagebox) {
                    return
                }
                if (imagebox.border) {
                    if (imagebox.border.type == 'Color') {
                        return Number(imagebox.border.lineWidth)
                    }
                    if (imagebox.border.type == 'Pic') {
                        if (edge == 'left') {
                            return Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100
                        }
                        if (edge == 'top') {
                            return Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100
                        }
                        if (edge == 'right') {
                            return Number(imagebox.geometry.width) * Number(imagebox.border.edge.right) / 100
                        }
                        if (edge == 'bottom') {
                            return Number(imagebox.geometry.height) * Number(imagebox.border.edge.bottom) / 100
                        }
                    }
                } else {
                    return 0
                }
            }
            $scope.imageboxWRadius = function (imagebox, radius, ratio, ratio1) {
                if (!imagebox) {
                    return
                }
                if (imagebox.border) {
                    var _ratio = 1;
                    if(ratio && ratio1){
                        if(imagebox.geometry.width > imagebox.geometry.height){
                            _ratio = ratio1
                        }else{
                            _ratio = ratio
                        }
                    }
                    if(ratio && !ratio1){
                        _ratio = ratio
                    }
                    if (imagebox.border.shape == 'Ellipse') {
                        return '50%'
                    }
                    if (imagebox.border.radius.filletType == 'Fixed') {//圆角固定值
                        var _radius = imagebox.border.radius[radius];
                        return _radius > 0 ?  (_radius + Number(imagebox.border.lineWidth)/2) * _ratio : 0;
                    }else{
                        var radiusW = imagebox.geometry.width > imagebox.geometry.height ? imagebox.geometry.height : imagebox.geometry.width;
                        radiusW = radiusW + imagebox.border.lineWidth;
                        var _r = radiusW * imagebox.border.radius[radius] / 100;
                        return _r > 0 ? (_r + Number(imagebox.border.lineWidth)/2) * _ratio : 0
                    }
                } else {
                    return 0
                }
            }
            $scope.imageboxWRadius1 = function (imagebox, radius, ratio, ratio1) {
                if (!imagebox) {
                    return
                }
                if (imagebox.border) {
                    var _ratio = 1;
                    if(ratio && ratio1){
                        if(imagebox.geometry.width > imagebox.geometry.height){
                            _ratio = ratio1
                        }else{
                            _ratio = ratio
                        }
                    }
                    if(ratio && !ratio1){
                        _ratio = ratio
                    }
                    if (imagebox.border.shape == 'Ellipse') {
                        return '50%'
                    }
                    if (imagebox.border.radius.filletType == 'Fixed') {//圆角固定值
                        var _radius = imagebox.border.radius[radius];
                        return  (_radius - Number(imagebox.border.lineWidth)/2) > 0 ? (_radius - Number(imagebox.border.lineWidth)/2) * _ratio : 0;
                    }else{
                        var radiusW = imagebox.geometry.width > imagebox.geometry.height ? imagebox.geometry.height : imagebox.geometry.width;
                        radiusW = radiusW + imagebox.border.lineWidth;
                        var _r = radiusW * imagebox.border.radius[radius] / 100;
                        return (_r - Number(imagebox.border.lineWidth)/2) > 0 ? (_r - Number(imagebox.border.lineWidth)/2) * _ratio : 0
                    }
                } else {
                    return 0
                }
            }

            $scope.dropShadow = function(imagebox,ratio){
                if (imagebox.shadow == null) {
                    imagebox.shadow={
                        color:'#777777',
                        x:0,
                        y:0,
                        blur:0
                    }
                }
                var width = $scope.imageboxW(imagebox) * ratio;
                var height =$scope.imageboxH(imagebox) * ratio;
                return dropShadow(imagebox,width,height)
            }
            //移除画布透明效果
            $scope.opacityElement = function(mediabox, geometry){
                var opacity = 1;
                if(!geometry || !mediabox){
                    return 1
                }
                if(geometry.x > -geometry.width && geometry.y > -geometry.height && geometry.x < mediabox.width && geometry.y < mediabox.height){
                    opacity = 1;
                }else {
                    opacity = 0.3;
                }
                return opacity
            }
            //键盘事件
            $scope.$on('onKeyDownCallback', function() {
                onKeyDown({keyCode:13})
            });
            function onKeyDown(event) {
                if(!window.event){
                    return
                }
                var key = window.event.keyCode;
                if(vm.pageNumber && vm.pageNumber != vm.pageIndex){
                    return
                }
                if (vm.that.textFont) {
                    return
                }
                if (event.keyCode == 13) {
                    fn(event)
                    $timeout(function () {
                        if (vm.isImageartTrim) {
                            $scope.imageartTrimTrueClick();
                        }
                        if (vm.isImageboxTrim) {
                            $scope.imageboxTrueClick();
                        }
                        if (vm.isXmlDblclick) {
                            $scope.bgImgTrueClick();
                        }
                    })
                    return false;
                }
                $timeout(function () {
                    if (event.keyCode == 27) {
                        if (vm.fullFlag) {
                            vm.fullFlag = false;
                        }
                        $scope.canvasCb(event);
                    }
                    if(event.ctrlKey) {
                        vm.that.ctrlKey = true;
                        vm.that.multiSelect();
                        if(vm.elementOn.index>=0 && vm.elementOn.index != '' && vm.elementOn.index != null){
                            if(vm.pageData[vm.elementOn.pageIndex].levels.level[vm.elementOn.index] && vm.pageData[vm.elementOn.pageIndex].levels.level[vm.elementOn.index].imagebox && !vm.pageData[vm.elementOn.pageIndex].levels.level[vm.elementOn.index].imagebox.ctrlKey){
                                $scope.imageboxClick(event, vm.pageData[vm.elementOn.pageIndex].levels.level[vm.elementOn.index].imagebox, vm.elementOn.index, vm.elementOn.pageIndex)
                            }
                            if(vm.pageData[vm.elementOn.pageIndex].levels.level[vm.elementOn.index] && vm.pageData[vm.elementOn.pageIndex].levels.level[vm.elementOn.index].imageart && !vm.pageData[vm.elementOn.pageIndex].levels.level[vm.elementOn.index].imageart.ctrlKey){
                                $scope.imageartClick(event, vm.pageData[vm.elementOn.pageIndex].levels.level[vm.elementOn.index].imageart, vm.elementOn.index, vm.elementOn.pageIndex)
                            }
                            if(vm.pageData[vm.elementOn.pageIndex].levels.level[vm.elementOn.index] && vm.pageData[vm.elementOn.pageIndex].levels.level[vm.elementOn.index].textbox && !vm.pageData[vm.elementOn.pageIndex].levels.level[vm.elementOn.index].textbox.ctrlKey){
                                $scope.textboxClick(event, vm.pageData[vm.elementOn.pageIndex].levels.level[vm.elementOn.index].textbox, vm.elementOn.index, vm.elementOn.pageIndex)
                            }
                            if(vm.pageData[vm.elementOn.pageIndex].levels.level[vm.elementOn.index] && vm.pageData[vm.elementOn.pageIndex].levels.level[vm.elementOn.index].textdocument && !vm.pageData[vm.elementOn.pageIndex].levels.level[vm.elementOn.index].textdocument.ctrlKey){
                                $scope.textdocumentClick(event, vm.pageData[vm.elementOn.pageIndex].levels.level[vm.elementOn.index].textdocument, vm.elementOn.index, vm.elementOn.pageIndex)
                            }
                            if (vm.pageData[vm.elementOn.pageIndex].levels.level[vm.elementOn.index] && vm.pageData[vm.elementOn.pageIndex].levels.level[vm.elementOn.index].calMonthBox && !vm.pageData[vm.elementOn.pageIndex].levels.level[vm.elementOn.index].calMonthBox.ctrlKey) {
                                $scope.calMonthBoxClick(event, vm.pageData[vm.elementOn.pageIndex].levels.level[vm.elementOn.index].calMonthBox, vm.elementOn.index, vm.elementOn.pageIndex)
                            }
                            if (vm.pageData[vm.elementOn.pageIndex].levels.level[vm.elementOn.index] && vm.pageData[vm.elementOn.pageIndex].levels.level[vm.elementOn.index].calTitleBox && !vm.pageData[vm.elementOn.pageIndex].levels.level[vm.elementOn.index].calTitleBox.ctrlKey) {
                                $scope.calTitleBoxClick(event, vm.pageData[vm.elementOn.pageIndex].levels.level[vm.elementOn.index].calTitleBox, vm.elementOn.index, vm.elementOn.pageIndex)
                            }
                        }

                    }
                    //ctrl + c
                    if (event.ctrlKey && key == 67) {
                        var all = vm.that.getAllCtrlKeyArray();
                        var copyArray = {imageboxes: [], textboxes: [], imagearts: []};
                        if(all.length > 0){
                            all.forEach(function(box){
                                if(box.current == "imagebox"){
                                    copyArray.imageboxes.push(box);
                                }
                                if(box.current == "textbox"){
                                    copyArray.textboxes.push(box);
                                }
                                if(box.current == "imageart"){
                                    copyArray.imagearts.push(box);
                                }
                            })
                        }else{
                            if(vm.elementOn.name == "imagebox"){
                                copyArray.imageboxes.push(vm.elementOn.item)
                            }
                            if(vm.elementOn.name == "imageart"){
                                copyArray.imagearts.push(vm.elementOn.item)
                            }
                            if(vm.elementOn.name == "textbox"){
                                copyArray.textboxes.push(vm.elementOn.item)
                            }
                        }
                        if(vm.that.copyArray){
                            vm.that.copyArray = angular.copy(copyArray);
                        }
                        // vm.keyboardItem = null;
                        // if(vm.elementOn.item.lock || !vm.elementOn.item){return}
                        // vm.keyboardItem = angular.copy(vm.elementOn);
                    }
                    // 删除
                    if (event.keyCode == 46) {
                        if(vm.that.deleteBox){vm.that.deleteBox()};
                    }
                })
                //ctrl + v
                if (event.ctrlKey && key == 86 && !vm.that.textFont) {
                    vm.that.copyElement()
                    event.preventDefault();
                }
                // 左键
                if(event.keyCode == 37){
                    event.preventDefault();
                    var all = vm.that.getAllCtrlKeyArray();
                    if (all.length > 0) {
                        all.forEach(function(box){
                            ModulesService.keycodeArrow(37, vm.pageData[vm.elementOn.pageIndex], vm.pageData[vm.elementOn.pageIndex].levels.level, box);
                        })
                    }else{
                        if(vm.elementOn.item){
                            ModulesService.keycodeArrow(37, vm.pageData[vm.elementOn.pageIndex], vm.pageData[vm.elementOn.pageIndex].levels.level, vm.elementOn.item);
                        }
                    }
                }
                // 上键
                if(event.keyCode == 38){
                    event.preventDefault();
                    var all = vm.that.getAllCtrlKeyArray();
                    if (all.length > 0) {
                        all.forEach(function(box){
                            ModulesService.keycodeArrow(38, vm.pageData[vm.elementOn.pageIndex], vm.pageData[vm.elementOn.pageIndex].levels.level, box);
                        })
                    }else{
                        if(vm.elementOn.item){
                            ModulesService.keycodeArrow(38, vm.pageData[vm.elementOn.pageIndex], vm.pageData[vm.elementOn.pageIndex].levels.level, vm.elementOn.item);
                        }else{
                            if(vm.that.previousPage){
                                vm.that.previousPage(event)
                            }
                        }
                    }

                }
                // 右键
                if(event.keyCode == 39){
                    event.preventDefault();
                    var all = vm.that.getAllCtrlKeyArray();
                    if (all.length > 0) {
                        all.forEach(function(box){
                            ModulesService.keycodeArrow(39, vm.pageData[vm.elementOn.pageIndex], vm.pageData[vm.elementOn.pageIndex].levels.level, box);
                        })
                    }else{
                        if(vm.elementOn.item){
                            ModulesService.keycodeArrow(39, vm.pageData[vm.elementOn.pageIndex], vm.pageData[vm.elementOn.pageIndex].levels.level, vm.elementOn.item);
                        }
                    }

                }
                // 下键
                if(event.keyCode == 40){
                    event.preventDefault();
                    var all = vm.that.getAllCtrlKeyArray();
                    if (all.length > 0) {
                        all.forEach(function(box){
                            ModulesService.keycodeArrow(40, vm.pageData[vm.elementOn.pageIndex], vm.pageData[vm.elementOn.pageIndex].levels.level, box);
                        })
                    }else{
                        if(vm.elementOn.item){
                            ModulesService.keycodeArrow(40, vm.pageData[vm.elementOn.pageIndex], vm.pageData[vm.elementOn.pageIndex].levels.level, vm.elementOn.item);
                        }else{
                            if(vm.that.nextPage){
                                vm.that.nextPage(event)
                            }
                        }
                    }
                }
            }
            document.onkeyup = function(event){
                $timeout(function () {
                    vm.that.ctrlKey = false;
                })
            }
            //元素四角拖拽
            $scope.cursor = function (angle, source, boolean) {
                return cursorInfo(angle, source, boolean);
            }
            $scope.goldFoil = function(color){
                if(color){
                    return goldFoil(color)
                }
            }
            $scope.transitionPx = transitionPx;
            $scope.pageStyle = function(page){
                var _style= {
                    'position': 'absolute',
                    'width': page.mediabox.width * page.custom.ratio,
                    'height': page.mediabox.height * page.custom.ratio,
                    'left': page.scene ? page.scene.imagebox.geometry.x * page.custom.ratio : page.mediabox.x * page.custom.ratio,
                    'top': page.scene ? page.scene.imagebox.geometry.y * page.custom.ratio : page.mediabox.y * page.custom.ratio,
                    'background': page.background.color&&page.background.type == 'Color' ? page.background.color : ' ',
                }
                if(vm.editorType == 'PICTURE_PRO_P' && page){
                    if(page.outline){
                        if(page.outline.mask && page.outline.mask.resource && page.outline.mask.resource.identifier){
                            _style['-webkit-mask-image']= 'url(' + page.outline.mask.resource.identifier + ')';
                            _style['-webkit-mask-size'] = transitionPx(page.outline.geometry.width) * page.custom.ratio + 'px ' + transitionPx(page.outline.geometry.height) * page.custom.ratio + 'px';
                            _style['-webkit-mask-position-x']= transitionPx(page.outline.geometry.x) * page.custom.ratio + 'px';
                            _style['-webkit-mask-position-y']= transitionPx(page.outline.geometry.y) * page.custom.ratio + 'px';
                        }
                    }else{
                        // _style['-webkit-mask-image'] = 'linear-gradient(black, black)';
                        // _style['-webkit-mask-size']= (page.trimbox.width*page.custom.ratio+1) + 'px ' + (page.trimbox.height*page.custom.ratio+1) + 'px';
                        // _style['-webkit-mask-repeat']= 'no-repeat';
                        // _style['-webkit-mask-position']= (page.trimbox.x*page.custom.ratio) + 'px ' + (page.trimbox.y*page.custom.ratio) + 'px'; // 默认 0 0，可根据需要给 x/y 定位

                    }
                }
                return _style
            }
        }]
    };

    angular.module('editorApp').component('pageEdit', PageEditControl);

})();

(function () {
    'use strict';

    var OutlineViewControl = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/components/outline-view.html',
        controllerAs: 'vm',
        bindings: {
            page: '<',
            propertyValue:'<',
            pictureType:'<',
            contourWidth: '<',
            onChange: '&'
        },
        controller: ['$scope', 'ImageService', '$timeout', 'Qinius', 'QiniuToken', 'MessageService', 'UidService', 'FontXmlsManger', 'ClipArt', 'RecommendPics', '$stateParams', '$translate', '$filter','$http','ImgprocContours', '$q',
            function ($scope, ImageService, $timeout, Qinius, QiniuToken, MessageService, UidService, FontXmlsManger, ClipArt, RecommendPics, $stateParams, $translate, $filter, $http, ImgprocContours, $q) {
                var vm = this;
                vm.page = angular.copy(vm.page);
                vm.page.background = null;
                vm.errorImage = null;
                vm.contourWidth = Number(vm.contourWidth || 0);
                if(vm.page.levels.level && vm.page.levels.level.length > 0){
                    vm.page.levels.level = vm.page.levels.level.filter(function(item){
                        return item.imagebox
                    });
                    if(!vm.page.levels.level.length){
                        MessageService[vm.isMobile ? 'hint' : 'error']($translate.instant('outline.message.noImageBox'));
                        vm.onChange();
                        return false;
                    }
                    for(var i=0;i<vm.page.levels.level.length;i++){
                        var imagebox = vm.page.levels.level[i].imagebox;
                        if(!imagebox.image || !imagebox.image.resource || !imagebox.image.resource.identifier){
                            MessageService[vm.isMobile ? 'hint' : 'error']($translate.instant('outline.message.blankImageBox'));
                            vm.onChange();
                            return false;
                        }
                    }
                }else{
                    MessageService[vm.isMobile ? 'hint' : 'error']($translate.instant('outline.message.blankPage'));
                    vm.onChange();
                    return false;
                }
                vm.width = PxTurnMm(vm.page.mediabox.width);
                vm.height = PxTurnMm(vm.page.mediabox.height);
                vm.threeLoading=false;
                vm.threeLoadingText = $translate.instant('outline.loading.generating');
                $scope.domain = Qinius.getDomain();
                vm.token = QiniuToken.getPromise('tokenWithPolicy', {"mimeLimit":"image/jpeg;image/png"});
                var userAgent = navigator.userAgent || navigator.vendor || window.opera;
                // 移动设备判断关键字
                vm.isMobile = /iPad|iPhone|iPod|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone/.test(userAgent);
                vm.scale = 1;
                vm.scale1 = 1;
                vm.thumbnailScale = 1;
                vm.windowWidth = vm.isMobile ? 343 : 600;
                if (vm.page.mediabox.width > vm.page.mediabox.height) {
                    vm.scale = vm.windowWidth / vm.page.mediabox.width;
                } else {
                    vm.scale = vm.windowWidth / vm.page.mediabox.height;
                }
                vm.windowWidth1 = vm.isMobile ? 260 : 360;
                if (vm.page.mediabox.width > vm.page.mediabox.height) {
                    vm.scale1 = vm.windowWidth1 / vm.page.mediabox.width;
                } else {
                    vm.scale1 = vm.windowWidth1 / vm.page.mediabox.height;
                }
                
                $q.all([$scope.domain.$promise, vm.token.$promise]).then(function () {
                    vm.token = vm.token.token;
                    $scope.domain = 'https://' + $scope.domain.domains[0] + '/';
                    $scope.page = vm.page;
                    $scope.page.notTrimbox = true;
                    if($scope.page.outline && $scope.page.outline.contourWidth >= 0){
                        vm.contourWidth = $scope.page.outline.contourWidth || 0;
                    }
                    if(!$scope.page.outline){
                        vm.threeLoading=true;
                        thumbnailInit(function(url){
                            generateContour(url);
                        })
                    }
                });
                function generateContour(url){
                    ImgprocContours.generateContour({
                        "page": {
                            "front": url  // 必填，图像URL或base64数据
                        },
                        "pageSize": {          // 可选，期望输出尺寸（毫米）
                            "width": vm.width,
                            "height": vm.height
                        },
                        "contourWidth": Number(vm.contourWidth),   // 可选，描边宽度（毫米），默认2.0
                        "smoothFactor": 5,      // 可选，平滑因子，默认0
                        "mirrorable": vm.pictureType === 'spread'
                    },function(res){
                        if(res && res.data){
                            res.data.image = url;
                        }
                        imgprocSuccess(res,'cutline');
                    },imgprocError)
                }
                function imgprocSuccess(res,type) {
                    vm.threeLoading=false;
                    if(res.success){
                        if(res.data && res.data.success){
                            $scope.page.outline = {
                                type: type,
                                contourWidth: vm.contourWidth,
                                geometry: res.data.mmRect,
                                mask:{
                                    resource:{
                                        identifier: res.data.contourMask
                                    }
                                },
                                cutline:{
                                    resource:{
                                        identifier: res.data.contourUrl
                                    },
                                    color: vm.propertyValue.spotColor,
                                    colorValue: vm.propertyValue.color
                                }
                            }
                            if(res.data.mirror){
                                $scope.page.outlineSpread = {
                                    type: type,
                                    contourWidth: vm.contourWidth,
                                    geometry: res.data.mirror.mmRect,
                                    mask:{
                                        resource:{
                                            identifier: res.data.mirror.contourMask
                                        }
                                    },
                                    cutline: {
                                        resource:{
                                            identifier: res.data.mirror.contourUrl
                                        },
                                        color: vm.propertyValue.spotColor,
                                        colorValue: vm.propertyValue.color
                                    }
                                }
                            }
                        }else{
                            vm.errorImage = res.data;
                        }
                    }else{
                        MessageService[vm.isMobile ? 'hint' : 'error'](res.error);
                    }
                }
                function imgprocError(err) {
                    if($scope.page.outline && $scope.page.outline.contourWidth >= 0){
                        vm.contourWidth = $scope.page.outline.contourWidth;
                    }
                    vm.threeLoading=false;
                    MessageService[vm.isMobile ? 'hint' : 'error'](err.data.error || $translate.instant('outline.message.generationFailed'));
                }
                //生成封面图
                function thumbnailInit(callback) {
                    $timeout(function () {
                        html2canvas_adapt(document.getElementById('thumbnail-outline'), {
                            onrendered: function (canvas) {
                                if(canvas){
                                    QiniuToken.uploadThumbnail(canvas, function (data) {
                                        callback($scope.domain + data.key)
                                    }, function () {
                                        callback()
                                    }, 'tokenWithPolicy', {"mimeLimit":"image/jpeg;image/png"});
                                }else{
                                    callback()
                                }
                            },
                            error:function(){
                                callback()
                            },
                            letterRendering: true,
                            useCORS: true,
                            width: $scope.page.custom.width * vm.thumbnailScale,
                            height: $scope.page.custom.height * vm.thumbnailScale,
                            windowWidth: document.body.scrollWidth,
                            windowHeight: document.body.scrollHeight,
                            x: 0,
                            y: 0,
                            backgroundColor: "rgba(0, 0, 0, 0)",
                            dpi:300
                        });
                    })
                }
                $scope.resetOutline = function () {
                    $scope.page.outline = null;
                    $scope.page.outlineSpread = null;
                    vm.threeLoading=true;
                    thumbnailInit(function(url){
                        generateContour(url,'cutline');
                    })
                }
                $scope.removeOutline = function () {
                    $scope.page.outline = null;
                    $scope.page.outlineSpread = null;
                }
                window.updatePicOutline = function ($event) {
                    $timeout(function () {
                        vm.errorImage = null;
                        var file = $event.target.files[0]; // 获取上传的文件
                        if (!file.type.startsWith('image/png')) {
                            if(vm.isMobile){
                                MessageService.hint($translate.instant('outline.message.invalidFormat', {fileType: file.type, serviceType: $filter('serviceType')(vm.type)}));
                            }else{
                                MessageService[vm.isMobile ? 'hint' : 'error']($translate.instant('outline.message.invalidFormat', {fileType: file.type, serviceType: $filter('serviceType')(vm.type)}));
                            }
                            return;
                        }
                        vm.threeLoading=true;
                        vm.threeLoadingText = $translate.instant('outline.loading.uploading');
                        ImageService.backendUploadPics(file, $scope.domain, vm.token, function(data){
                            if(data && data.key){
                                ImgprocContours.parseContour({
                                    "page": {
                                        "contour": $scope.domain + data.key
                                    },
                                    "pageSize": {          // 可选，期望输出尺寸（毫米）
                                        "width": vm.width,
                                        "height": vm.height
                                    },
                                    "contourWidth": vm.contourWidth,   // 可选，描边宽度（毫米），默认2.0
                                    "smoothFactor": 5,      // 可选，平滑因子，默认0
                                    "mirrorable": vm.pictureType === 'spread'
                                },function(res){
                                    if(res && res.data){
                                        res.data.image = $scope.domain + data.key
                                    }
                                    imgprocSuccess(res,'customized');
                                },imgprocError)
                            }else{
                                vm.threeLoading=false;
                                MessageService[vm.isMobile ? 'hint' : 'error']($translate.instant('outline.message.uploadFailed'));
                                $scope.$apply();
                            }
                        },function(err){
                            vm.threeLoading=false;
                            MessageService[vm.isMobile ? 'hint' : 'error']($translate.instant('outline.message.uploadFailed'));
                            $scope.$apply();
                        })
                    })
                };
                var outlineWidthDebounce;
                vm.changeOutlineWidth = function () {
                    var contourWidth = Number(vm.contourWidth);
                    if (!$scope.page || contourWidth < 0 || contourWidth > 5 || isNaN(contourWidth)) {
                        return;
                    }
                    if (outlineWidthDebounce) {
                        $timeout.cancel(outlineWidthDebounce);
                    }
                    outlineWidthDebounce = $timeout(function () {
                        vm.threeLoading = true;
                        thumbnailInit(function(url){
                            generateContour(url);
                        });
                    }, 500);
                };
                $scope.modalHide = function () {
                    vm.onChange();
                }
                $scope.save = function(){
                    vm.onChange({text:$scope.page});
                }
            }]
    };

    angular.module('editorApp')
        .component('outlineView', OutlineViewControl);

})();

(function () {
    'use strict';

    var MaterialListControl = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/components/material-list.html',
        controllerAs: 'vm',
        bindings: {
            onAdd: '&'
        },
        controller: ['$scope', 'ThemeClassify', 'Material', '$stateParams','$translate',
            function ($scope, ThemeClassify, Material, $stateParams, $translate) {
                var vm = this;
                vm.maskType='recommend';
                vm.storeId = $stateParams.storeId;
                vm.generalMask=[{
                    cancelled: false,
                    id: 646,
                    resource:{
                        identifier: localStorage.getItem('editor-domain') + "clipArt-d1a8bc1c-53f0-4aa5-cb2b-33ea628866f9",
                    },
                    identifier: localStorage.getItem('editor-domain') + "clipArt-d1a8bc1c-53f0-4aa5-cb2b-33ea628866f9",
                    name: $translate.instant("nav.mask.content.圆形蒙版"),
                    opened: true,
                    provider: "qiniu",
                    themeClassifyId: '',
                    themeClassifyName: "",
                    type: "masking",
                    type1:'round'
                },{
                    cancelled: false,
                    id: 646,
                    resource:{
                        identifier: localStorage.getItem('editor-domain') + "material-9c6fd5de-f1b0-48c5-996e-2eb5758f19cc",
                    },
                    identifier: localStorage.getItem('editor-domain') + "material-9c6fd5de-f1b0-48c5-996e-2eb5758f19cc",
                    name: $translate.instant("nav.mask.content.方形蒙版"),
                    opened: true,
                    provider: "qiniu",
                    themeClassifyId: '',
                    themeClassifyName: "",
                    type: "masking",
                    type1: "square",
                }]
                vm.$onInit = function() {
                    classifyInit();
                }
                //分类
                function classifyInit(){
                    ThemeClassify.getAllByCondition4({
                        type: 'Material',
                        storeId: vm.storeId
                    }, function (res) {
                        vm.masklabels = res.data;
                        vm.rahmenPage = 0;
                        vm.maskList = [];
                        rahmenInit(vm.masklabels[0])
                    });
                }


                vm.rahmenPage = 0;
                vm.masklabelsFulfill = false;
                $scope.showMaskLabels = false;
                vm.maskLoading = false;
                vm.masklabelCb = masklabelCb;
                vm.maskList = [];
                $scope.showMoreMaskLabels = function () {
                    $scope.showMaskLabels = !$scope.showMaskLabels;
                }
                function rahmenInit(item) {
                    vm.maskLoading = true;
                    vm.masklabelChooseId = item;
                    Material.byCondition3({
                        items: [
                            {key: "themeClassify.id", op: "=", value: item.id}],
                        page: vm.rahmenPage,
                        size: vm.itemsPerPage
                    }, function (res, headers) {
                        var _sum = headers('X-Total-Count');
                        angular.forEach(res.data, function (resp) {
                            var arr = {
                                type:'masking',
                                name: resp.name,
                                identifier: localStorage.getItem('editor-domain') + resp.identifier,
                                provider: resp.provider,
                                themeClassifyName: resp.themeClassifyName,
                                themeClassifyId: resp.themeClassifyId,
                                resource: {
                                    identifier: localStorage.getItem('editor-domain') + resp.identifier,
                                    provider: resp.provider,
                                }
                            }
                            vm.maskList.push(arr);
                        })
                        vm.maskLoading = false;
                        if(vm.maskList.length < _sum){
                            vm.masklabelsFulfill = true;
                        }else {
                            vm.masklabelsFulfill = false;
                        }
                    }, function () {
                        vm.maskLoading = false;
                    })
                }
                function masklabelCb(item){
                    vm.maskList = [];
                    vm.rahmenPage = 0;
                    rahmenInit(item)
                }
                $scope.loadMoreMasks = function () {
                    vm.rahmenPage++;
                    rahmenInit(vm.masklabelChooseId)
                }
            }]
    };

    angular.module('editorApp')
        .component('materialList', MaterialListControl);

})();

(function () {
    'use strict';

    var language = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/components/language.html',
        controllerAs: 'vm',
        bindings: {
            isShow: '='
        },

        controller: ['$scope', '$stateParams', '$q', 'MessageService', '$translate', '$localStorage', '$cookies', 'translationStorageProvider', '$timeout',
            function ($scope, $stateParams, $q, MessageService, $translate, $localStorage, $cookies, translationStorageProvider, $timeout) {
                var vm = this;
                vm.lang = $cookies.getObject("NG_TRANSLATE_LANG_KEY");
                vm.lagnuages =[];
                if ($localStorage.lagnuages) {
                    for(var i = 0 ; i<$localStorage.lagnuages.length; i++ ){
                        var lang = $localStorage.lagnuages[i];
                        var result = translationStorageProvider.getLanguageType(lang);
                        if (!!result) {
                            if (vm.lang == result.value) {
                                vm.langKey = result.key;
                                result.selected = true;
                            }
                            vm.lagnuages.push(result);
                        }
                    }
                }
                $scope.changeLagnuage = function(lang){
                    if (lang == null || lang.key == vm.langKey ) {
                        return;
                    }
                    angular.forEach(vm.lagnuages, function(item){
                        item.selected =false;
                    });
                    lang.selected = true;
                    vm.langKey = lang.key;
                    $translate.use(lang.value).then(function () {
                        $scope.$emit('changeLanguage', lang);
                        vm.isShow = false;
                    });
                    
                };

                $scope.cancel = function () {
                    vm.isShow = false;
                }
                $scope.save = function () {
                    vm.isShow = false;
                }
        }]
    };

    angular
        .module('editorApp')
        .component('language', language);
})();

(function () {
    'use strict';

    var imageMasking = {
        restrict: 'E',
        replace: true,
        templateUrl: 'app/entities/components/imageMasking.html',
        controllerAs: 'vm',
        bindings: {
            url: '<',
            maskUrl: '<',
            onSave: '&',
            onClose: '&'
        },
        controller: ImageMaskingController
    };

    ImageMaskingController.$inject = ['$timeout', '$element', 'ImageService', 'QiniuToken'];
    function ImageMaskingController($timeout, $element, ImageService, QiniuToken) {
        var vm = this;
        vm.token = '';
        QiniuToken.get('get', {}, function (token) {
            vm.token = token;
        });
        vm.domain = localStorage.getItem('editor-domain');
        var CONFIG = {
            MASK_GREEN: { r: 16, g: 141, b: 254 },
            MAX_HISTORY: 20,
            MIN_ZOOM: 0.3, MAX_ZOOM: 5, ZOOM_STEP: 0.08,
            TOAST_DURATION: 1500,
            MAX_UPLOAD_BYTES: 20 * 1024 * 1024,
        };

        // ==================== UI 绑定属性 ====================
        vm.brushSize = 20;
        vm.hardness = 80;
        vm.opacity = 100;
        vm.toolMode = 'repair';
        vm.viewMode = 'original';
        vm.dragMode = false;
        vm.undoEnabled = false;
        vm.redoEnabled = false;
        vm.brushHintVisible = false;
        vm.popupVisible = false;
        vm.toastText = '';
        vm.toastVisible = false;

        // 滑块背景渐变
        function buildSliderBg(val, min, max) {
            var pct = (val - min) / (max - min) * 100;
            return 'linear-gradient(to right, #BABDC0 0%, #BABDC0 ' + pct + '%, #EAECF1 ' + pct + '%, #EAECF1 100%)';
        }
        vm.brushSizeBg = buildSliderBg(vm.brushSize, 1, 100);
        vm.hardnessBg = buildSliderBg(vm.hardness, 0, 100);
        vm.opacityBg = buildSliderBg(vm.opacity, 10, 100);

        // ==================== 内部状态 ====================
        var state = {
            isDrawing: false,
            history: [], historyIndex: -1,
            displayW: 0, displayH: 0,
            originalImg: null, maskImg: null,
            initialMask: null,
            zoom: 1, panX: 0, panY: 0,
            isPanning: false, panStart: null, panScreenStart: null,
            spaceHeld: false,
            isPinching: false, pinchStartDist: 0, pinchLastMid: null,
        };

        // DOM 引用
        var imageCanvas, imageCtx, overlayCanvas, overlayCtx;
        var brushCursor, canvasWrapper, canvasContainer, loadingOverlay;
        var maskCanvas, maskCtx;
        var strokeCanvas, strokeCtx, strokeBaseCanvas, strokeBaseCtx;
        var canvasFloats;
        var brushTipCache = null, brushTipCacheKey = '';
        var hintTimer = null, toastTimer = null;
        var undoRedoDigestTimer = null;

        // ==================== 公开方法 ====================
        vm.close = function() { vm.onClose(); };

        vm.confirm = function() {
            if (!maskCanvas) { vm.onSave({ data: null }); return; }
            try {
                var w = maskCanvas.width, h = maskCanvas.height;
                var result = document.createElement('canvas');
                result.width = w; result.height = h;
                var rCtx = result.getContext('2d');
                rCtx.drawImage(imageCanvas, 0, 0);
                rCtx.globalCompositeOperation = 'destination-in';
                rCtx.drawImage(maskCanvas, 0, 0);
                
                var file = canvasToUploadFile(result, 'matting-result.png');
                
                uploadMattingFiles(file, createMaskFile(), function(result) {
                    vm.onSave({ data: result });
                }, function() {
                    console.error('抠图结果上传失败');
                    showToast('保存失败');
                });
            } catch (e) {
                console.error('抠图结果生成失败:', e);
                showToast('保存失败');
            }
        };
        
        function createMaskFile() {
            var w = maskCanvas.width, h = maskCanvas.height;
            var maskExport = document.createElement('canvas');
            maskExport.width = w; maskExport.height = h;
            var exportCtx = maskExport.getContext('2d', { willReadFrequently: true });
            var maskData = maskCtx.getImageData(0, 0, w, h);
            var out = exportCtx.createImageData(w, h);
            for (var i = 0; i < maskData.data.length; i += 4) {
                var alpha = maskData.data[i + 3];
                var gray = alpha === 0 ? 0 : (alpha === 255 ? 255 : Math.round(30 + alpha * 180 / 255));
                out.data[i] = gray;
                out.data[i + 1] = gray;
                out.data[i + 2] = gray;
                out.data[i + 3] = 255;
            }
            exportCtx.putImageData(out, 0, 0);
            return canvasToUploadFile(maskExport, 'matting-mask.png');
        }

        function uploadMattingFiles(resultFile, maskFile, onSuccess, onError) {
            Promise.all([resultFile, maskFile]).then(function(files) {
                ImageService.backendUploadPics(files[0], vm.domain, vm.token, function(resultData) {
                    var resultUrl = vm.domain + resultData.key;
                    ImageService.backendUploadPics(files[1], vm.domain, vm.token, function(maskData) {
                        onSuccess({
                            url: resultUrl,
                            maskUrl: vm.domain + maskData.key
                        });
                    }, onError);
                }, onError);
            }).catch(onError);
        }

        function canvasToUploadFile(canvas, filename) {
            return canvasToBlob(canvas, filename).then(function(blob) {
                if (blob.size <= CONFIG.MAX_UPLOAD_BYTES) {
                    return blobToFile(blob, filename);
                }
                return compressCanvasToFile(canvas, filename, blob);
            });
        }

        function compressCanvasToFile(sourceCanvas, filename, sourceBlob) {
            var currentCanvas = sourceCanvas;
            function compress(blob) {
                if (blob.size <= CONFIG.MAX_UPLOAD_BYTES || currentCanvas.width <= 1 || currentCanvas.height <= 1) {
                    return blobToFile(blob, filename);
                }
                var scale = Math.sqrt(CONFIG.MAX_UPLOAD_BYTES / blob.size) * 0.92;
                scale = Math.max(0.1, Math.min(0.92, scale));
                var nextW = Math.max(1, Math.floor(currentCanvas.width * scale));
                var nextH = Math.max(1, Math.floor(currentCanvas.height * scale));
                if (nextW === currentCanvas.width && nextW > 1) nextW--;
                if (nextH === currentCanvas.height && nextH > 1) nextH--;

                var nextCanvas = document.createElement('canvas');
                nextCanvas.width = nextW;
                nextCanvas.height = nextH;
                nextCanvas.getContext('2d').drawImage(currentCanvas, 0, 0, nextW, nextH);
                currentCanvas = nextCanvas;
                return canvasToBlob(currentCanvas, filename).then(compress);
            }
            return compress(sourceBlob);
        }

        function canvasToBlob(canvas, filename) {
            return new Promise(function(resolve, reject) {
                if (canvas.toBlob) {
                    canvas.toBlob(function(blob) {
                        if (blob) resolve(blob);
                        else reject(new Error('canvas toBlob failed'));
                    }, 'image/png');
                    return;
                }
                try {
                    resolve(dataURLtoFile(canvas.toDataURL('image/png'), filename));
                } catch (error) {
                    reject(error);
                }
            });
        }

        function blobToFile(blob, filename) {
            return new File([blob], filename, { type: blob.type || 'image/png' });
        }

        function dataURLtoFile(dataurl, filename) {
            var arr = dataurl.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]), 
                n = bstr.length, 
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
        }

        vm.setToolMode = function(mode) {
            if (vm.toolMode === mode && vm.popupVisible) {
                vm.popupVisible = false;
                return;
            }
            vm.toolMode = mode;
            vm.popupVisible = true;
            if (vm.dragMode) {
                vm.dragMode = false;
                overlayCanvas.style.cursor = 'none';
                brushCursor.style.display = 'block';
            }
        };

        vm.toggleDragMode = function() {
            vm.dragMode = !vm.dragMode;
            if (vm.dragMode) {
                stopDrawing();
                vm.popupVisible = false;
                overlayCanvas.style.cursor = 'grab';
                brushCursor.style.display = 'none';
            } else {
                overlayCanvas.style.cursor = 'none';
                brushCursor.style.display = 'block';
            }
        };

        vm.zoomReset = function() {
            state.zoom = 1;
            state.panX = 0;
            state.panY = 0;
            invalidateBrushCache();
            updateTransform();
            updateBrushCursor();
            showToast('1:1');
        };

        vm.switchView = function(mode) {
            if (vm.viewMode === mode) return;
            vm.viewMode = mode;
            renderCurrentView();
            showToast(mode === 'original' ? '原图编辑' : '效果图编辑');
        };

        vm.undo = function() { undo(); };
        vm.redo = function() { redo(); };
        vm.resetMask = function() {
            if (!state.maskImg) return;
            vm.zoomReset();
            pushHistory();
            initMaskFromImage(state.maskImg);
            renderCurrentView();
            showToast('已重置');
        };

        vm.onBrushSizeChange = function() {
            vm.brushSizeBg = buildSliderBg(vm.brushSize, 1, 100);
            invalidateBrushCache(); showBrushSizeHint();
        };
        vm.onHardnessChange = function() {
            vm.hardnessBg = buildSliderBg(vm.hardness, 0, 100);
            invalidateBrushCache();
        };
        vm.onOpacityChange = function() {
            vm.opacityBg = buildSliderBg(vm.opacity, 10, 100);
        };

        // ==================== Toast ====================
        function showToast(msg) {
            vm.toastText = msg;
            vm.toastVisible = true;
            if (toastTimer) $timeout.cancel(toastTimer);
            toastTimer = $timeout(function() {
                vm.toastVisible = false;
            }, CONFIG.TOAST_DURATION);
        }

        // ==================== 初始化 ====================
        function init() {
            var el = $element[0];
            imageCanvas = el.querySelector('#imImageCanvas');
            imageCtx = imageCanvas.getContext('2d');
            overlayCanvas = el.querySelector('#imOverlayCanvas');
            overlayCtx = overlayCanvas.getContext('2d');
            brushCursor = el.querySelector('#imBrushCursor');
            canvasWrapper = el.querySelector('#imCanvasWrapper');
            canvasContainer = el.querySelector('#imCanvasContainer');
            loadingOverlay = el.querySelector('#imLoadingOverlay');
            canvasFloats = el.querySelectorAll('.im-view-toggle, .im-undo-redo, .im-zoom-group');

            setupEvents();
            updateBrushCursor();
            brushCursor.style.display = 'none';
            loadImages();
        }

        // ==================== 图片加载 ====================
        function loadImage(src) {
            return new Promise(function(resolve, reject) {
                var img = new Image();
                img.crossOrigin = 'anonymous';
                img.onload = function() { resolve(img); };
                img.onerror = reject;
                img.src = src;
            });
        }

        function initMaskFromImage(maskImg) {
            var w = maskCanvas.width, h = maskCanvas.height;
            var tmp = document.createElement('canvas');
            tmp.width = w; tmp.height = h;
            var tCtx = tmp.getContext('2d', { willReadFrequently: true });
            tCtx.drawImage(maskImg, 0, 0, w, h);
            var data = tCtx.getImageData(0, 0, w, h).data;
            var out = maskCtx.createImageData(w, h);
            for (var i = 0; i < data.length; i += 4) {
                var bright = (data[i] + data[i + 1] + data[i + 2]) / 3;
                out.data[i] = CONFIG.MASK_GREEN.r;
                out.data[i + 1] = CONFIG.MASK_GREEN.g;
                out.data[i + 2] = CONFIG.MASK_GREEN.b;
                if (bright < 30) out.data[i + 3] = 0;
                else if (bright > 210) out.data[i + 3] = 255;
                else out.data[i + 3] = Math.floor(255 * (bright - 30) / 180);
            }
            maskCtx.putImageData(out, 0, 0);
        }

        function loadImages() {
            Promise.all([
                loadImage(vm.url),
                loadImage(vm.maskUrl)
            ]).then(function(results) {
                var orig = results[0], mask = results[1];
                state.originalImg = orig; state.maskImg = mask;

                var cr = canvasContainer.getBoundingClientRect();
                var cW = cr.width - 16, cH = cr.height - 16;
                var aspect = orig.width / orig.height;
                var dW, dH;
                if (cW / cH > aspect) { dH = cH; dW = dH * aspect; }
                else { dW = cW; dH = dW / aspect; }
                state.displayW = dW; state.displayH = dH;

                maskCanvas = document.createElement('canvas');
                maskCanvas.width = orig.width;
                maskCanvas.height = orig.height;
                maskCtx = maskCanvas.getContext('2d', { willReadFrequently: true });

                imageCanvas.width = orig.width;
                imageCanvas.height = orig.height;
                overlayCanvas.width = orig.width;
                overlayCanvas.height = orig.height;
                imageCanvas.style.width = dW + 'px';
                imageCanvas.style.height = dH + 'px';
                overlayCanvas.style.width = dW + 'px';
                overlayCanvas.style.height = dH + 'px';

                imageCtx.drawImage(orig, 0, 0);
                initMaskFromImage(mask);
                state.initialMask = document.createElement('canvas');
                state.initialMask.width = maskCanvas.width;
                state.initialMask.height = maskCanvas.height;
                state.initialMask.getContext('2d').drawImage(maskCanvas, 0, 0);
                renderOriginalView();
                pushHistory();
                loadingOverlay.style.display = 'none';
            }).catch(function(err) {
                loadingOverlay.innerHTML = '<span>加载失败，请刷新重试</span>';
                console.error(err);
            });
        }

        // ==================== 视图渲染 ====================
        function isCanvasReady() {
            return !!(maskCanvas && maskCtx && imageCanvas && overlayCanvas);
        }

        function syncOverlayFromMask() {
            if (!isCanvasReady()) return;
            overlayCtx.clearRect(0, 0, overlayCanvas.width, overlayCanvas.height);
            overlayCtx.drawImage(maskCanvas, 0, 0);
        }

        function renderCurrentView() {
            if (vm.viewMode === 'original') renderOriginalView();
            else renderEffectView();
        }

        function renderOriginalView() {
            imageCanvas.style.visibility = 'visible';
            syncOverlayFromMask();
            overlayCanvas.style.opacity = '0.5';
            overlayCanvas.style.display = 'block';
        }

        function renderEffectView() {
            var w = overlayCanvas.width, h = overlayCanvas.height;
            overlayCtx.clearRect(0, 0, w, h);
            overlayCtx.drawImage(imageCanvas, 0, 0);
            overlayCtx.globalCompositeOperation = 'destination-in';
            overlayCtx.drawImage(maskCanvas, 0, 0);
            overlayCtx.globalCompositeOperation = 'source-over';
            imageCanvas.style.visibility = 'hidden';
            overlayCanvas.style.opacity = '1';
            overlayCanvas.style.display = 'block';
        }

        // ==================== 画笔缓存 ====================
        function invalidateBrushCache() { brushTipCacheKey = ''; }

        function getBrushTip() {
            if (!isCanvasReady()) return null;
            var ratio = maskCanvas.width / state.displayW / state.zoom;
            var brushRadius = Math.max(1, vm.brushSize / 2 * ratio);
            var hardness = vm.hardness / 100;
            var innerR = brushRadius * hardness;
            var outerR = Math.max(brushRadius, innerR + 1);
            var size = Math.ceil(outerR * 2);
            var key = brushRadius.toFixed(2) + '|' + hardness.toFixed(2);

            if (brushTipCacheKey === key && brushTipCache) return { tip: brushTipCache, outerR: outerR };

            brushTipCacheKey = key;
            if (!brushTipCache || brushTipCache.width !== size || brushTipCache.height !== size) {
                brushTipCache = document.createElement('canvas');
                brushTipCache.width = size; brushTipCache.height = size;
            }
            var tctx = brushTipCache.getContext('2d');
            tctx.clearRect(0, 0, brushTipCache.width, brushTipCache.height);
            var cx = outerR, cy = outerR;
            var mc = CONFIG.MASK_GREEN;
            var solidColor = 'rgb(' + mc.r + ',' + mc.g + ',' + mc.b + ')';
            var fadeColor = 'rgba(' + mc.r + ',' + mc.g + ',' + mc.b + ',0)';
            if (innerR >= outerR - 0.5) {
                tctx.fillStyle = solidColor;
                tctx.beginPath(); tctx.arc(cx, cy, brushRadius, 0, Math.PI * 2); tctx.fill();
            } else {
                var grad = tctx.createRadialGradient(cx, cy, innerR, cx, cy, outerR);
                grad.addColorStop(0, solidColor);
                grad.addColorStop(1, fadeColor);
                tctx.fillStyle = grad;
                tctx.beginPath(); tctx.arc(cx, cy, outerR, 0, Math.PI * 2); tctx.fill();
            }
            return { tip: brushTipCache, outerR: outerR };
        }

        // ==================== 坐标与变换 ====================
        function updateTransform() {
            var t = 'scale(' + state.zoom + ') translate(' + state.panX + 'px, ' + state.panY + 'px)';
            canvasWrapper.style.transformOrigin = '0 0';
            canvasWrapper.style.transform = t;
        }

        function zoomAtPoint(clientX, clientY, newZoom) {
            newZoom = Math.max(CONFIG.MIN_ZOOM, Math.min(CONFIG.MAX_ZOOM, newZoom));
            var rect = canvasWrapper.getBoundingClientRect();
            var lx = (clientX - rect.left) / state.zoom;
            var ly = (clientY - rect.top) / state.zoom;
            state.panX = (lx + state.panX) * state.zoom / newZoom - lx;
            state.panY = (ly + state.panY) * state.zoom / newZoom - ly;
            state.zoom = newZoom;
            invalidateBrushCache();
            updateTransform();
            updateBrushCursor();
        }

        function getCanvasPos(e, rect) {
            if (!isCanvasReady()) return null;
            rect = rect || canvasWrapper.getBoundingClientRect();
            var clientX = e.touches ? e.touches[0].clientX : e.clientX;
            var clientY = e.touches ? e.touches[0].clientY : e.clientY;
            var ratio = maskCanvas.width / state.displayW;
            return {
                x: (clientX - rect.left) / state.zoom * ratio,
                y: (clientY - rect.top) / state.zoom * ratio,
            };
        }

        // ==================== 历史记录 ====================
        function pushHistory() {
            if (!isCanvasReady()) return;
            state.history.length = state.historyIndex + 1;
            var snap = document.createElement('canvas');
            snap.width = maskCanvas.width; snap.height = maskCanvas.height;
            snap.getContext('2d').drawImage(maskCanvas, 0, 0);
            state.history.push(snap);
            if (state.history.length > CONFIG.MAX_HISTORY) { state.history.shift(); }
            else { state.historyIndex = state.history.length - 1; }
            updateUndoRedoState();
        }

        function undo() {
            if (state.historyIndex <= 0) return;
            state.historyIndex--;
            restoreMaskFromHistory();
        }
        function redo() {
            if (state.historyIndex >= state.history.length - 1) return;
            state.historyIndex++;
            restoreMaskFromHistory();
        }
        function restoreMaskFromHistory() {
            maskCtx.clearRect(0, 0, maskCanvas.width, maskCanvas.height);
            maskCtx.drawImage(state.history[state.historyIndex], 0, 0);
            updateUndoRedoState();
            renderCurrentView();
        }
        function updateUndoRedoState() {
            vm.undoEnabled = state.historyIndex > 0;
            vm.redoEnabled = state.historyIndex < state.history.length - 1;
            scheduleUndoRedoDigest();
        }

        function scheduleUndoRedoDigest() {
            if (undoRedoDigestTimer) return;
            undoRedoDigestTimer = $timeout(function() {
                undoRedoDigestTimer = null;
            }, 0);
        }

        // ==================== 绘画核心 ====================
        function ensureStrokeCanvases() {
            if (!isCanvasReady()) return;
            if (strokeCanvas && strokeCanvas.width === maskCanvas.width && strokeCanvas.height === maskCanvas.height) return;
            strokeCanvas = document.createElement('canvas');
            strokeCanvas.width = maskCanvas.width;
            strokeCanvas.height = maskCanvas.height;
            strokeCtx = strokeCanvas.getContext('2d');

            strokeBaseCanvas = document.createElement('canvas');
            strokeBaseCanvas.width = maskCanvas.width;
            strokeBaseCanvas.height = maskCanvas.height;
            strokeBaseCtx = strokeBaseCanvas.getContext('2d');
        }

        function beginStroke() {
            ensureStrokeCanvases();
            if (!strokeCanvas || !strokeBaseCanvas) return;
            strokeBaseCtx.clearRect(0, 0, strokeBaseCanvas.width, strokeBaseCanvas.height);
            strokeBaseCtx.drawImage(maskCanvas, 0, 0);
            strokeCtx.clearRect(0, 0, strokeCanvas.width, strokeCanvas.height);
        }

        function drawBrushStamp(x, y) {
            var td = getBrushTip();
            if (!td || !strokeCtx) return;
            strokeCtx.drawImage(td.tip, x - td.outerR, y - td.outerR);
        }

        function renderStrokeToMask() {
            if (!isCanvasReady() || !strokeCanvas || !strokeBaseCanvas) return;
            maskCtx.clearRect(0, 0, maskCanvas.width, maskCanvas.height);
            maskCtx.drawImage(strokeBaseCanvas, 0, 0);
            maskCtx.save();
            maskCtx.globalAlpha = vm.opacity / 100;
            if (vm.toolMode === 'erase') maskCtx.globalCompositeOperation = 'destination-out';
            maskCtx.drawImage(strokeCanvas, 0, 0);
            maskCtx.restore();
        }

        function drawBrushAt(x, y) {
            drawBrushStamp(x, y);
        }

        function drawLine(from, to) {
            var dx = to.x - from.x, dy = to.y - from.y;
            var dist = Math.sqrt(dx * dx + dy * dy);
            if (dist === 0) { drawBrushAt(from.x, from.y); return; }
            var steps = Math.ceil(dist / 5);
            for (var i = 0; i <= steps; i++) {
                var t = i / steps;
                drawBrushAt(from.x + dx * t, from.y + dy * t);
            }
        }

        var pendingRafPos = null, lastRafDrawnPos = null, rafDrawId = null;

        function flushRafDraw() {
            rafDrawId = null;
            if (!state.isDrawing || !pendingRafPos) return;
            var target = pendingRafPos;
            pendingRafPos = null;
            if (lastRafDrawnPos) { drawLine(lastRafDrawnPos, target); }
            else { drawBrushAt(target.x, target.y); }
            lastRafDrawnPos = target;
            renderStrokeToMask();
            renderCurrentView();
        }

        function scheduleDraw(pos) {
            if (!state.isDrawing || !pos) return;
            pendingRafPos = pos;
            if (!rafDrawId) rafDrawId = requestAnimationFrame(flushRafDraw);
        }

        function startDrawing(e) {
            if (!isCanvasReady()) return;
            state.isDrawing = true;
            beginStroke();
            var pos = getCanvasPos(e);
            if (!pos) {
                state.isDrawing = false;
                return;
            }
            lastRafDrawnPos = pos;
            pendingRafPos = null;
            canvasFloats.forEach(function(el) { el.classList.add('im-float-hidden'); });
            $timeout(function() { vm.popupVisible = false; });
            scheduleDraw(pos);
        }

        function stopDrawing() {
            var hadDrawing = state.isDrawing || rafDrawId || pendingRafPos || lastRafDrawnPos;
            if (rafDrawId) {
                cancelAnimationFrame(rafDrawId);
                rafDrawId = null;
                if (pendingRafPos && lastRafDrawnPos) {
                    drawLine(lastRafDrawnPos, pendingRafPos);
                    renderStrokeToMask();
                }
            }
            state.isDrawing = false;
            pendingRafPos = null; lastRafDrawnPos = null;
            if (vm.viewMode === 'effect') {
                renderEffectView();
            } else {
                syncOverlayFromMask();
            }
            if (hadDrawing) pushHistory();
            canvasFloats.forEach(function(el) { el.classList.remove('im-float-hidden'); });
        }

        // ==================== 光标 ====================
        var lastMouseX = -1, lastMouseY = -1;

        function updateBrushCursor(e, rect) {
            rect = rect || canvasWrapper.getBoundingClientRect();
            var cx, cy;
            if (e) {
                cx = e.touches ? e.touches[0].clientX : e.clientX;
                cy = e.touches ? e.touches[0].clientY : e.clientY;
                lastMouseX = cx; lastMouseY = cy;
            } else if (lastMouseX >= 0) {
                cx = lastMouseX; cy = lastMouseY;
            } else {
                cx = rect.left + rect.width / 2; cy = rect.top + rect.height / 2;
            }
            brushCursor.style.left = ((cx - rect.left) / state.zoom) + 'px';
            brushCursor.style.top = ((cy - rect.top) / state.zoom) + 'px';
            var cs = vm.brushSize / state.zoom;
            brushCursor.style.width = cs + 'px'; brushCursor.style.height = cs + 'px';
        }

        function showBrushSizeHint() {
            vm.brushHintVisible = true;
            if (hintTimer) $timeout.cancel(hintTimer);
            hintTimer = $timeout(function() {
                vm.brushHintVisible = false;
            }, 800);
        }

        // ==================== 事件绑定 ====================
        function setupEvents() {
            // 滚轮缩放
            canvasContainer.addEventListener('wheel', function(e) {
                e.preventDefault();
                var d = e.deltaY > 0 ? -CONFIG.ZOOM_STEP : CONFIG.ZOOM_STEP;
                zoomAtPoint(e.clientX, e.clientY, state.zoom + d);
            }, { passive: false });

            // 鼠标
            overlayCanvas.addEventListener('mouseenter', function() {
                if (!state.spaceHeld && !vm.dragMode) brushCursor.style.display = 'block';
            });
            overlayCanvas.addEventListener('mouseleave', function() {
                stopDrawing(); brushCursor.style.display = 'none';
            });
            overlayCanvas.addEventListener('mousedown', function(e) {
                if (state.spaceHeld || vm.dragMode) {
                    state.isPanning = true;
                    state.panStart = { x: state.panX, y: state.panY };
                    state.panScreenStart = { x: e.clientX, y: e.clientY };
                    overlayCanvas.style.cursor = 'grabbing';
                    brushCursor.style.display = 'none';
                    $timeout(function() { vm.popupVisible = false; });
                    return;
                }
                startDrawing(e);
            });
            overlayCanvas.addEventListener('mousemove', function(e) {
                if (state.isPanning) {
                    state.panX = state.panStart.x + (e.clientX - state.panScreenStart.x) / state.zoom;
                    state.panY = state.panStart.y + (e.clientY - state.panScreenStart.y) / state.zoom;
                    updateTransform(); return;
                }
                var rect = canvasWrapper.getBoundingClientRect();
                updateBrushCursor(e, rect); scheduleDraw(getCanvasPos(e, rect));
            });
            overlayCanvas.addEventListener('mouseup', function() {
                if (state.isPanning) {
                    state.isPanning = false;
                    overlayCanvas.style.cursor = (vm.dragMode || state.spaceHeld) ? 'grab' : 'none';
                    if (!vm.dragMode && !state.spaceHeld) brushCursor.style.display = 'block';
                    return;
                }
                stopDrawing();
            });

            // 触摸
            function touchDist(e) {
                var dx = e.touches[0].clientX - e.touches[1].clientX;
                var dy = e.touches[0].clientY - e.touches[1].clientY;
                return Math.sqrt(dx * dx + dy * dy);
            }
            function touchMid(e) {
                return {
                    x: (e.touches[0].clientX + e.touches[1].clientX) / 2,
                    y: (e.touches[0].clientY + e.touches[1].clientY) / 2
                };
            }

            overlayCanvas.addEventListener('touchstart', function(e) {
                e.preventDefault();
                if (e.touches.length >= 2) {
                    stopDrawing(); state.isPinching = true;
                    state.pinchStartDist = touchDist(e);
                    state.pinchLastMid = touchMid(e);
                    brushCursor.style.display = 'none';
                    $timeout(function() { vm.popupVisible = false; });
                    return;
                }
                if (vm.dragMode) {
                    state.isPanning = true;
                    state.panStart = { x: state.panX, y: state.panY };
                    state.panScreenStart = { x: e.touches[0].clientX, y: e.touches[0].clientY };
                    brushCursor.style.display = 'none';
                    $timeout(function() { vm.popupVisible = false; });
                    return;
                }
                brushCursor.style.display = 'block';
                updateBrushCursor(e); startDrawing(e);
            }, { passive: false });

            overlayCanvas.addEventListener('touchmove', function(e) {
                e.preventDefault();
                if (e.touches.length >= 2 && state.isPinching) {
                    var nd = touchDist(e), mid = touchMid(e);
                    zoomAtPoint(mid.x, mid.y, state.zoom * (nd / state.pinchStartDist));
                    if (state.pinchLastMid) {
                        state.panX += (mid.x - state.pinchLastMid.x) / state.zoom;
                        state.panY += (mid.y - state.pinchLastMid.y) / state.zoom;
                        updateTransform();
                    }
                    state.pinchStartDist = nd; state.pinchLastMid = mid; return;
                }
                if (e.touches.length === 1 && state.isPanning) {
                    state.panX = state.panStart.x + (e.touches[0].clientX - state.panScreenStart.x) / state.zoom;
                    state.panY = state.panStart.y + (e.touches[0].clientY - state.panScreenStart.y) / state.zoom;
                    updateTransform(); return;
                }
                if (e.touches.length === 1 && !state.isPinching) {
                    var rect = canvasWrapper.getBoundingClientRect();
                    updateBrushCursor(e, rect); scheduleDraw(getCanvasPos(e, rect));
                }
            }, { passive: false });

            overlayCanvas.addEventListener('touchend', function(e) {
                if (e.touches.length === 0) {
                    state.isPinching = false; state.isPanning = false;
                    stopDrawing(); brushCursor.style.display = 'none';
                } else if (e.touches.length === 1 && state.isPinching) {
                    state.isPinching = false;
                }
            });

            // 键盘
            function onKeyDown(e) {
                if (e.target.tagName === 'INPUT') return;
                if (e.code === 'Space' && !state.spaceHeld) {
                    e.preventDefault(); state.spaceHeld = true;
                    stopDrawing();
                    overlayCanvas.style.cursor = 'grab';
                    brushCursor.style.display = 'none';
                }
                if ((e.ctrlKey || e.metaKey) && e.key === 'z' && !e.shiftKey) { e.preventDefault(); undo(); }
                if ((e.ctrlKey || e.metaKey) && (e.key === 'y' || (e.key === 'z' && e.shiftKey))) { e.preventDefault(); redo(); }
            }
            function onKeyUp(e) {
                if (e.code === 'Space') {
                    state.spaceHeld = false; state.isPanning = false;
                    if (!vm.dragMode) {
                        overlayCanvas.style.cursor = 'none';
                        brushCursor.style.display = 'block';
                    }
                }
            }
            document.addEventListener('keydown', onKeyDown);
            document.addEventListener('keyup', onKeyUp);

            $element.on('$destroy', function() {
                document.removeEventListener('keydown', onKeyDown);
                document.removeEventListener('keyup', onKeyUp);
            });

            updateUndoRedoState();
        }

        // ==================== 启动 ====================
        $timeout(init);
    }

    angular
        .module('editorApp')
        .component('imageMasking', imageMasking);
})();

(function () {
    'use strict';

    var imageCutoutC = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/components/image-cutout.html',
        controllerAs: 'vm',
        bindings: {
            imagebox: '<',
            onChange: '&',
            onSave: '&',
        },

        controller: ['$scope', '$timeout', 'MessageService', 'MattingBgByKey', 'Gallery', '$uibModal',
            function ($scope, $timeout, MessageService, MattingBgByKey, Gallery, $uibModal) {
                var vm = this;
                var articleRequest = false;
                vm.isMobile = isMobile();
                vm.image = null;
                vm.domain = localStorage.getItem('editor-domain');
                vm.loading = false;
                function init() {
                    vm.loading = true;
                    Gallery.getOne({ id: vm.imagebox.resourceid }, function (res) {
                        console.log(vm.imagebox);
                        if(vm.imagebox.mattingMask){
                            vm.loading = false;
                            vm.image = {
                                angle: vm.imagebox.angle,
                                flip: vm.imagebox.flip,
                                source_key: vm.domain + res.data.identifier,
                                result_key: vm.imagebox.result,
                                mask_key: vm.imagebox.mattingMask,
                            };
                            $scope.editImage()
                            if(!vm.isMobile){
                                vm.onSave();
                            }
                            return;
                        }
                        MattingBgByKey.get({ qiniu_key: res.data.identifier }, function (res) {
                            if(!articleRequest){
                                if (res && res.data) {
                                    imageboxImgInit(function (obj) {
                                        res.data.angle = obj.angle;
                                        res.data.flip = false;
                                        if (res.data.source_key) { res.data.source_key = vm.domain + res.data.source_key }
                                        if (res.data.result_key) { res.data.result_key = vm.domain + res.data.result_key }
                                        if (res.data.mask_key) { res.data.mask_key = vm.domain + res.data.mask_key }
                                        vm.image = res.data;
                                        vm.onChange({ text: {
                                            result: res.data.result_key,
                                            mattingMask: res.data.mask_key,
                                            angle: res.data.angle,
                                            flip: res.data.flip,
                                        } })
                                        vm.loading = false;
                                    })
                                } else {
                                    vm.loading = false;
                                    $scope.hideImage()
                                    if (vm.isMobile) {
                                        MessageService.hint('抠图失败:' + res.message);
                                    } else {
                                        MessageService.error('抠图失败:' + res.message);
                                    }
                                }
                            }
                        }, function (err) {
                            vm.loading = false;
                            $scope.hideImage()
                            if (vm.isMobile) {
                                MessageService.hint('抠图失败:' + err.data.message);
                            } else {
                                MessageService.error('抠图失败:' + err.data.message);
                            }
                        });
                    })
                }
                vm.isShowImageMasking = false;
                vm.isEditImage = false;
                $scope.editImage = function () {
                    if(vm.loading){
                        return;
                    }
                    vm.isEditImage = true;
                    if (vm.isMobile) {
                        vm.isShowImageMasking = true;
                    } else {
                        $uibModal.open({
                            templateUrl: 'app/entities/components/controls/matting-modal.html',
                            controller: 'MattingModalController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            keyboard: false,
                            windowClass: 'matting-modal',
                            resolve: {
                                entity: function () {
                                    return {
                                        originalImage: vm.image.source_key,
                                        maskImage: vm.image.mask_key
                                    };
                                }
                            }
                        }).result.then(function (res) {
                            vm.isEditImage = false;
                            if (res) {
                                if(res === 'cancel'){
                                    return;
                                }
                                applyMattingResult(res);
                                $scope.saveImage()
                            } else {
                                $scope.hideImage()
                            }
                        });
                    }
                }
                function applyMattingResult(data) {
                    if (data && data.url) {
                        vm.image.result_key = data.url;
                        if (data.maskUrl) {
                            vm.image.mask_key = data.maskUrl;
                        }
                        return;
                    }
                }
                $scope.imageMaskingSave = function (data) {
                    vm.isEditImage = false;
                    applyMattingResult(data);
                    vm.isShowImageMasking = false;
                    $scope.saveImage()
                }
                $scope.imageMaskingClose = function () {
                    vm.isEditImage = false;
                    vm.isShowImageMasking = false;
                    $scope.hideImage()
                }
                $scope.hideImage = function () {
                    articleRequest = true;
                    vm.onSave({ text: {
                        result: vm.imagebox.image,
                        mattingMask: vm.imagebox.mattingMask,
                        angle: vm.imagebox.angle,
                        flip: vm.imagebox.flip,
                    } });
                }
                $scope.saveImage = function () {
                    if(vm.loading){
                        return;
                    }
                    vm.onSave({ text: {
                        result: vm.image.result_key,
                        mattingMask: vm.image.mask_key,
                        angle: vm.image.angle,
                        flip: vm.image.flip,
                    } });
                }
                $scope.exitView = function (e) {
                    if(vm.loading && vm.isMobile){
                        return;
                    }
                    e.stopPropagation();
                    e.preventDefault();
                    if (!vm.isEditImage) {
                        if (vm.isMobile) {
                            MessageService.minConfirm({
                                cancel: "取消抠图",
                                confirm: "应用",
                                msg: "是否应用抠图效果"
                            }, function () {
                                $scope.saveImage();
                            }, function () {
                                $scope.hideImage();
                            })
                        } else {
                            MessageService.confirm({
                                title: "提示",
                                cancel: "取消抠图",
                                confirm: "应用",
                                msg: "是否应用抠图效果"
                            }, function () {
                                $scope.saveImage();
                            }, function () {
                                $scope.hideImage();
                            })
                        }
                    }
                }

                function imageboxImgInit(callback){
                    $.ajax({
                        type: "GET",
                        url: vm.imagebox.image + "?imageInfo",
                        async: false,
                        success: function (va1) {
                            var angle = (vm.imagebox.angle + 360 - orientationInit1(va1.orientation).angle) % 360;
                            var obj = {}
                            if (vm.imagebox.flip) {
                                obj.angle = -angle;
                            }else{
                                obj.angle = angle;
                            }
                            callback(obj);
                        }
                    });
                }
                init();
            }]
    };

    angular
        .module('editorApp')
        .component('imageCutout', imageCutoutC);
})();

(function () {
    'use strict';

    var editorPreviewMini = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/components/editor-preview-mini.html',
        // controller: 'articlePreviewController',
        controllerAs: 'vm',
        bindings: {
            documentPage: '<',
            article: '<',
            fileName: '=',
            isNav: '<',
        },
        controller: ['$scope', 'Qinius', '$http', '$q', 'FontManagement', 'MessageService', '$timeout',
            function ($scope, Qinius, $http, $q, FontManagement, MessageService, $timeout) {
                var vm = this;
                vm.loading = true;
                $scope.domains = Qinius.getDomain();
                $scope.isPull = true;
                vm.landscape = false;
                vm.thisPage = 0;
                vm.partData = {};
                vm.bindingtypes = [
                    {id:'LeftNew',name:'左右滑动'},
                    {id:'Tile',name:'平铺展示'},
                ]
                vm.bindingtype = 'LeftNew';
                $q.all([$scope.domains.$promise]).then(function () {
                    $scope.domain = 'https://' + $scope.domains.domains[0] + '/';
                    editorInit()
                });
                function editorInit() {
                    vm.windowW1 = 140;
                    vm.windowH1 = 140;
                    vm.items = [];
                    $scope.template = angular.copy(vm.documentPage);
                    vm.parts = $scope.template.config.parts.list;
                    $scope.template.pages.page=[];
                    vm.documentPage.pages.page.forEach(function (page) {
                        if(!page.backup){
                            $scope.template.pages.page.push(angular.copy(page));
                        }
                    })
                    vm.isEdit = true;
                    documentAnalysis($scope, $http, vm, $scope.template,FontManagement,'other', function(page){
                        page.custom.ratio1 = 140 / page.custom.width;
                    }, function () {
                        $scope.template.pages.page.forEach(function (page) {
                            if (!page.scene) {
                                pageTrimbox(page)
                            }
                        })
                        ratioInfo()
                        $timeout(function () {
                            loadApp();
                            $timeout(function () {
                                vm.loading = false;
                            },100)
                        },1000)
                    })
                }
                function ratioInfo() {
                    vm.windowH = window.innerHeight-300;
                    vm.windowW = window.innerWidth*0.8;
                    vm.pageMaxWidth = 0;
                    vm.pageMaxHeight = 0;
                    var pageMaxWidtTile = 0;
                    $scope.template.pages.page.forEach(function (page) {
                        page.isUse = false;
                        if (pageMaxWidtTile < page.custom.width) {
                            pageMaxWidtTile = page.custom.width;
                        }
                    })
                    vm.ratioTile = vm.windowW / pageMaxWidtTile;
                    $scope.template.pages.page.forEach(function (page) {
                        page.isUse = false;
                        if(page.config.partid == 'P'){
                            if(vm.pageMaxWidth < (page.spread ? page.custom.width : page.custom.width*2)){
                                vm.pageMaxWidth = (page.spread ? page.custom.width : page.custom.width*2);
                            }
                            if(vm.pageMaxHeight < page.custom.height){
                                vm.pageMaxHeight = page.custom.height;
                            }
                        }
                    })
                    if(!vm.landscape){
                        if(vm.windowH / vm.pageMaxHeight >= vm.windowW / vm.pageMaxWidth ){
                            vm.ratio = vm.windowW / vm.pageMaxWidth;
                        }else {
                            vm.ratio = vm.windowH / vm.pageMaxHeight;
                        }
                    }else{
                        if(vm.windowH / vm.pageMaxWidth >= vm.windowW / vm.pageMaxHeight ){
                            vm.ratio = vm.windowW / vm.pageMaxHeight;
                        }else {
                            vm.ratio = vm.windowH / vm.pageMaxWidth;
                        }
                    }
                    vm.ratio1 = 80 / vm.pageMaxHeight;
                    vm.pageMaxWidth = vm.pageMaxWidth*vm.ratio;
                    vm.pageMaxHeight = vm.pageMaxHeight*vm.ratio;
                    vm.pageMaxWidth1 = vm.pageMaxWidth;
                    vm.pageMaxHeight1 = vm.pageMaxHeight;
                    $scope.template.pages.page.forEach(function (page,index) {
                        if(page.config.partid == 'P'){
                            page.ratio = vm.ratio;
                        }else{
                            var _width = (page.spread || page.config.partid != 'P' ? page.custom.width : page.custom.width*2);
                            var _height = page.custom.height;
                            if(!vm.landscape){
                                if(vm.windowH / _height >= vm.windowW / _width ){
                                    page.ratio = vm.windowW / _width;
                                }else {
                                    page.ratio = vm.windowH / _height;
                                }
                            }else{
                                if(vm.windowH / _width >= vm.windowW / _height ){
                                    page.ratio = vm.windowW / _height;
                                }else {
                                    page.ratio = vm.windowH / _width;
                                }
                            }
                        }
                        // if(index == 0){
                        //     vm.pageMaxWidth = _width * page.ratio;
                        //     vm.pageMaxHeight = _height * page.ratio;
                        // }else{
                            if(vm.pageMaxWidth < _width * page.ratio){
                                vm.pageMaxWidth = _width * page.ratio;
                            }
                            if(vm.pageMaxHeight < _height * page.ratio){
                                vm.pageMaxHeight = _height * page.ratio;
                            }
                        // }
                        for(var i=0; i<vm.parts.length; i++){
                            if(vm.parts[i].id == page.config.partid){
                                if(!vm.parts[i].pages){
                                    vm.parts[i].pages = [];
                                }
                                vm.parts[i].pages.push(page)
                                break
                            }
                        }
                    })
                    vm.insidePages = [];
                    for(var i=0; i<vm.parts.length; i++){
                        if(vm.parts[i].pages &&vm.parts[i].pages.length>0){
                            vm.parts[i].marginLeft = -i*vm.pageMaxWidth - i*50;
                            var _pages = [];
                            if(vm.parts[i].id == 'P'){
                                vm.parts[i].pages.forEach(function (page, index) {
                                    var emptyPage = angular.copy(page);
                                    if(!emptyPage.background){
                                        emptyPage.background = {
                                            color:'#000000',
                                            resource:{
                                                identifier:''
                                            }
                                        }
                                    }else{
                                        emptyPage.background.color = "#000000";
                                        emptyPage.background.resource.identifier="";
                                    }
                                    emptyPage.barcode = null;
                                    emptyPage.qrcode = null;
                                    emptyPage.levels = {
                                        level: []
                                    };
                                    emptyPage.marginLeft = 0;
                                    if(index == 0){
                                        var _emptyPage = angular.copy(emptyPage);
                                        _emptyPage.background.color = "#ddd";
                                        _pages.push({
                                            page:angular.copy(_emptyPage),
                                            partid: vm.parts[i].id,
                                            spread:false
                                        })
                                    }
                                    if(!page.isUse){
                                        if(index == 0 && $scope.template.config.innerOffset == 1){
                                            page.isUse = true;
                                            emptyPage.uuid = page.uuid;
                                            emptyPage.marginLeft = (vm.pageMaxWidth1/2-emptyPage.custom.width * emptyPage.ratio);
                                            _pages.push({
                                                page:emptyPage,
                                                partid: vm.parts[i].id,
                                                spread:false
                                            })
                                            page.marginLeft = 0;
                                            setPageOrder(page)
                                            _pages.push({
                                                page:page,
                                                partid: vm.parts[i].id,
                                                spread:false
                                            })
                                            vm.insidePages.push({
                                                page1:emptyPage,
                                                page2:page,
                                                partid: vm.parts[i].id,
                                                spread:false
                                            })
                                        }else{
                                            if(page.spread){
                                                page.isUse = true;
                                                page.marginLeft = (vm.pageMaxWidth1-page.custom.width * page.ratio) / 2;
                                                var _page = angular.copy(page);
                                                _page.marginLeft = -_page.custom.width*_page.ratio/2;
                                                _pages.push({
                                                    page:page,
                                                    partid: vm.parts[i].id,
                                                    spread:true
                                                })
                                                _pages.push({
                                                    page:_page,
                                                    partid: vm.parts[i].id,
                                                    spread:true
                                                })
                                                setPageOrder(page)
                                                setPageOrder(_page)
                                                vm.insidePages.push({
                                                    page1:page,
                                                    page2:_page,
                                                    partid: vm.parts[i].id,
                                                    spread:true
                                                })
                                            }else{
                                                var _page1 = vm.parts[i].pages[index];
                                                var _page2 = index+1 >= vm.parts[i].pages.length ? null : vm.parts[i].pages[index+1];
                                                _page1.isUse = true;
                                                _page1.marginLeft = vm.pageMaxWidth1/2-_page1.custom.width * _page1.ratio;
                                                setPageOrder(_page1)
                                                if(_page2 && !_page2.spread){
                                                    _page2.isUse = true;
                                                    _page2.marginLeft = 0;
                                                    setPageOrder(_page2)
                                                    _pages.push({
                                                        page:_page1,
                                                        partid: vm.parts[i].id,
                                                        spread:false
                                                    })
                                                    _pages.push({
                                                        page:_page2,
                                                        partid: vm.parts[i].id,
                                                        spread:false
                                                    })
                                                    vm.insidePages.push({
                                                        page1:_page1,
                                                        page2:_page2,
                                                        partid: vm.parts[i].id,
                                                        spread:false
                                                    })
                                                }else{
                                                    _pages.push({
                                                        page:_page1,
                                                        partid: vm.parts[i].id,
                                                        spread:false
                                                    })
                                                    emptyPage.marginLeft = 0;
                                                    emptyPage.uuid = _page1.uuid;
                                                    _pages.push({
                                                        page:emptyPage,
                                                        partid: vm.parts[i].id,
                                                        spread:false
                                                    })
                                                    vm.insidePages.push({
                                                        page1:_page1,
                                                        page2:emptyPage,
                                                        partid: vm.parts[i].id,
                                                        spread:false
                                                    })
                                                }
                                            }
                                        }
                                    }
                                });
                            }else{
                                vm.parts[i].pages.forEach(function (page, index) {
                                    page.pageNumber=index;
                                    page.isUse = true;
                                    page.marginLeft = (vm.pageMaxWidth-page.custom.width * page.ratio) / 2;
                                    _pages.push({
                                        page:page,
                                        partid: vm.parts[i].id,
                                        spread:false
                                    })
                                })
                            }
                            vm.parts[i].pages = _pages;
                        }
                    }
                    vm.partData = vm.parts[0];
                }
                var pageOrder = 0;
                function setPageOrder(page){
                    pageOrder++;
                    page.pageNumber=pageOrder<10?'0'+pageOrder:pageOrder;
                }
                vm.pageInfo = "";
                function loadApp() {
                    $('.flipbook').turn({
                        width: vm.pageMaxWidth1,
                        height: vm.pageMaxHeight1,
                        accelerator: true,
                        when:{
                            turning: function (e, page, view) {
                                vm.turningView = view;
                            },
                            turned: function(event, page, pageObject){
                                vm.thisPage = Math.floor(page/2)-1;
                                if(page == 1){
                                    $('.flipbook').turn("page",2).stop();
                                }
                                $timeout(function () {
                                    if(vm.turningView){
                                        $('.page-wrapper').hide();
                                        $('.page-wrapper[page=' + vm.turningView[0] + ']').show();
                                        $('.page-wrapper[page=' + vm.turningView[1] + ']').show();
                                    }
                                })
                                vm.firstPage = pageObject[0];
                                vm.lastPage = pageObject[1];
                            },
                            start:function(a,b,c){
                                // $timeout(function () {
                                //     if(b.next == 1){
                                //         $scope.prevPart();
                                //     }
                                // })
                            }
                        }
                    });
                }
                //横屏竖屏
                vm.landscape = false;
                vm.windowR = 1;
                $scope.landscape = function (item) {
                    if(item == !vm.landscape){return};
                    vm.landscape = !item;
                    if(vm.landscape){
                        vm.windowH = window.innerHeight-200;
                        vm.windowW = window.innerWidth*0.8;
                        var pageW = vm.pageMaxWidth;
                        var pageH = vm.pageMaxHeight;
                        var r = vm.windowW / vm.windowH;
                        var r1 = pageW / pageH;
                        if (r1 >= r) {
                            vm.windowR = vm.windowW/pageH;
                        } else {
                            vm.windowR = vm.windowH/pageW;
                        }
                    }else{
                        vm.windowR = 1;
                    }
                }
                $scope.jumpPage = function (part, uuid) {
                    vm.partData = part;
                    if(vm.partData.id != 'P'){
                        vm.thisPage = 1;
                        $('.flipbook').turn("page",1);
                    }else{
                        var _pageIndex = 0;
                        for(var i=0; i<vm.insidePages.length; i++){
                            if(vm.insidePages[i].page1.uuid == uuid){
                                // vm.thisPage = i;
                                break
                            }else{
                                _pageIndex += 1;
                            }
                            if(vm.insidePages[i].page2.uuid == uuid){
                                // vm.thisPage = i;
                                break
                            }else{
                                _pageIndex += 1;
                            }
                        }
                        $('.flipbook').turn("page",_pageIndex+2);
                    }
                }
                $scope.prevPartShow = function (item) {
                    if(!vm.parts || vm.parts.length < 2 || !vm.partData || !vm.partData.id){
                        return
                    }
                    var _returnItem = false;
                    if(item == 'prev'){
                        for(var i=0; i<vm.parts.length; i++){
                            if(vm.partData.id == vm.parts[i].id && i>0){
                                _returnItem = true;
                                break
                            }
                        }
                    }
                    if(item == 'next'){
                        for(var i=0; i<vm.parts.length; i++){
                            if(vm.partData.id == vm.parts[i].id && i<vm.parts.length-1){
                                _returnItem = true;
                                break
                            }
                        }
                    }
                    return _returnItem
                }
                $scope.nextPart = function (e) {
                    fn(e)
                    if(!vm.partData || !vm.partData.id){
                        return
                    }
                    for(var i=0; i<vm.parts.length; i++){
                        if(vm.partData.id == vm.parts[i].id && vm.parts[i+1]){
                            vm.partData = vm.parts[i+1];
                            break
                        }
                    }
                }
                $scope.prevPart = function (e) {
                    fn(e)
                    if(!vm.partData || !vm.partData.id){
                        return
                    }
                    for(var i=0; i<vm.parts.length; i++){
                        if(vm.partData.id == vm.parts[i].id && vm.parts[i-1]){
                            vm.partData = vm.parts[i-1];
                            break
                        }
                    }
                }
                $scope.flipbookViewportPage = function(e){
                    fn(e)
                    if(!vm.partData || !vm.partData.id){
                        return
                    }
                        if(!vm.landscape){
                            var _w = $(".c-preview-landscape").width();
                            if(e.pageX-$(".c-preview-landscape").offset().left > _w / 2){
                                if(($scope.prevPartShow('next') || vm.thisPage<vm.insidePages.length-1)){
                                    if(vm.partData.id == 'P' && vm.lastPage < vm.partData.pages.length){
                                        $('.flipbook').turn("next");
                                    }else{
                                        $scope.nextPart();
                                    }
                                }else{
                                    if(vm.windowW>800){
                                        MessageService.error("最后一页");
                                    }
                                }
                            }else{
                                if($scope.prevPartShow('prev') || vm.thisPage>0){
                                    if(vm.partData.id == 'P' && vm.lastPage > 3){
                                        $('.flipbook').turn("previous");
                                    }else{
                                        $scope.prevPart();
                                    }
                                }else{
                                    if(vm.windowW>800){
                                        MessageService.error("第一页");
                                    }
                                }
                            }
                        }else{
                            var _h = $(".c-preview-landscape").height();
                            if(e.pageY-$(".c-preview-landscape").offset().top > _h / 2){
                                if(vm.partData.id == 'P' && vm.lastPage < vm.partData.pages.length){
                                    $('.flipbook').turn("next");
                                }else{
                                    $scope.nextPart();
                                }
                            }else{
                                if(vm.partData.id == 'P' && vm.lastPage > 3){
                                    $('.flipbook').turn("previous");
                                }else{
                                    $scope.prevPart();
                                }
                            }
                        }
                }
                $scope.bindingtypeInfo = function () {
                    var _name = "";
                    vm.bindingtypes.forEach(function (item) {
                        if(vm.bindingtype == item.id){
                            _name = item.name;
                        }
                    })
                    return _name
                };
                $scope.bindingtypeSelect = function (item) {
                    vm.bindingtype = item.id;
                }
            }
        ]
    };

    angular
        .module('editorApp')
        .component('editorPreviewMini', editorPreviewMini);
})();

(function () {
    'use strict';

    var editorGallery = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/components/editor-gallery-ec.html',
        controllerAs: 'vm',
        bindings: {
            product:'<',
            photoSelectAll: '<',//已选图片
            article:'<',//作品
            productXmlLine:'<',//模板
            counts:'=',//照片数量
            agentIos:'=',//
            fullMap:'<',
            fullMapNumber:'<'
        },

        controller: ['$scope', '$stateParams', '$q', '$localStorage', 'Qinius', 'Store', '$http', '$rootScope', 'Theme', 'Article',
            '$timeout', 'ModulesService', 'MessageService', '$translate', 'Folder', 'Gallery','SweetAlert','IMAGE_SUPPORTED_MIME','StoreStorages','$websocket','PlatformWechatSetting',
            function ($scope, $stateParams, $q, $localStorage, Qinius, Store, $http, $rootScope, Theme, Article,
                $timeout, ModulesService, MessageService, $translate, Folder, Gallery, SweetAlert, IMAGE_SUPPORTED_MIME,StoreStorages, $websocket, PlatformWechatSetting) {
                var vm = this;
                console.log(vm.fullMap)
                vm.insideFolder = false;
                vm.currentNav = 'gallery';
                vm.photoAll = [];
                vm.indexNum = 0;
                $scope.domains = Qinius.getDomain();
                vm.store = Store.get({id: vm.storeId});
                vm.storeId = $stateParams.storeId;
                vm.pid = $stateParams.pid;
                vm.aid = $stateParams.aid;
                $scope.folderIds = [];
                $scope.agentIos = vm.agentIos;
                vm.isIPhone6 = isIPhone6();
                vm.supportedMimeTypes = IMAGE_SUPPORTED_MIME;
                vm.platformSetting = PlatformWechatSetting.get();
                $q.all([$scope.domains.$promise, vm.store.$promise ,vm.platformSetting.$promise]).then(function () {
                    $scope.domain = 'https://' + $scope.domains.domains[0] + '/';
                    vm.platformSetting = vm.platformSetting.data;
                    loadAll('isNull')
                    qInit()
                    websocket();
                })
                $scope.uploadPhoto = function () {
                    uploadAble(StoreStorages,vm.storeId, function (res) {
                        if(res.status == 200){
                            if($scope.agentIos){
                                $rootScope.$broadcast('clickAndroidUpload', true);
                            }else{
                                $timeout(function () {
                                    $("#uploadImageMutipleId").trigger("click");
                                })
                            }
                        }else{
                            if(res.status == 400){
                                threeInfo('系统出错');
                            } else {
                                threeInfo(res.data||'系统出错');
                            }
                        }
                    })
                }
                $scope.$on('uoloadBroken', function (event, args) {
                    if (args) {
                        // updatePic();
                    }
                });
                $scope.$on('uoloadFinished', function (event, args) {
                    if (args) {
                        // updatePic();
                    }
                });
                vm.uploadPhotoItem=[];
                vm.today = "";
                $scope.$on('uploadStart',function(){
                    var date = new Date();
                    vm.today = date.getFullYear() + '-'+ (date.getMonth() + 1) + '-' + date.getDate();
                    if(vm.photoArray.length > 0 && vm.photoArray[0].createDate === vm.today){
                        return;
                    }
                    //造一个空的今日title项
                    vm.photoArray.unshift({
                        createDate: vm.today,
                        galleries:[]
                    })

                })

                // 上传图片后更新图片库/文件夹
                function updatePic() {
                    if (vm.folderOne && vm.folderOne.id) {
                        vm.photoAll = [];
                        loadAll(vm.folderOne.id);
                    } else {
                        vm.photoAll = [];
                        vm.indexNum = 0;
                        vm.maxId = null;
                        vm.photoCompleted = false;
                        loadAll('isNull');
                    }
                }

                $scope.galleryNavSel = function (item) {
                    vm.currentNav = item;
                    vm.indexNum = 0;
                    vm.maxId = null;
                    vm.photoCompleted = false;
                    vm.photoAll = [];
                    vm.folderOne = null;
                    if (item == 'gallery') {
                        loadAll('isNull')
                    }
                    if (item == 'folder') {
                        loadFolders()
                    }
                };

                function qInit() {
                    $('.c-productThree2-head3-page2').on('scroll', function (event) {
                        var realScrollHeight = event.currentTarget.clientHeight + event.currentTarget.scrollTop;
                        vm.realScrollHeight = realScrollHeight;
                        if (!vm.photoCompleted) {
                            if ((event.currentTarget.scrollHeight - 1) < realScrollHeight && realScrollHeight < (event.currentTarget.scrollHeight + 1)) {
                                vm.indexNum++;
                                loadAll('isNull');
                            }
                        }
                    })
                    $('.c-productThree2-head3-page9').on('scroll', function (event) {
                        var realScrollHeight = event.currentTarget.clientHeight + event.currentTarget.scrollTop;
                        vm.realScrollHeight = realScrollHeight;
                        if (!vm.photoCompleted) {
                            if ((event.currentTarget.scrollHeight - 1) < realScrollHeight && realScrollHeight < (event.currentTarget.scrollHeight + 1)) {
                                vm.indexNum++;
                                loadAll(vm.folderOne.id);
                            }
                        }
                        $scope.$digest();
                    })
                }

                // 增加文件夹
                $scope.addFolder = function () {
                    swal({
                        title: $translate.instant("editorCommon.addPhotoAlbumPop"),
                        text: "",
                        type: "input",
                        showCancelButton: true,
                        closeOnConfirm: false,
                        confirmButtonText: $translate.instant("button.confirm"),
                        cancelButtonText: $translate.instant("button.cancel"),
                        animation: "slide-from-top",
                        inputPlaceholder: $translate.instant("editorCommon.pleaseFolderName")
                    }, function (inputValue) {
                        if (inputValue === false) {
                            $(".folder-footer").show();
                            return false;
                        }
                        if (inputValue === "") {
                            swal.showInputError($translate.instant("editorCommon.pleaseName"));
                            return false
                        }
                        if (inputValue.indexOf(" ") != -1) {
                            swal.showInputError($translate.instant("editorCommon.pleaseEnterTheContent"));
                            return false
                        }
                        Folder.save({
                            articleId: vm.article.id,
                            name: inputValue,
                            type: 'Gallery',
                        }, function (resp) {
                            // $scope.Folders.push(resp.data);
                            loadFolders();
                            swal.close();
                        }, function () {
                            swal.showInputError($translate.instant("editorCommon.pleaseEnterTheCorrectFileName"));
                        })
                    });
                };
                $scope.chooseAll = function(){
                    if ($scope.folderIds.length == $scope.Folders.length) {
                        $scope.Folders.forEach(function (data) {
                            data.selected = false;
                        })
                        $scope.folderIds = [];
                    }else{
                        $scope.folderIds = [];
                        $scope.Folders.forEach(function (data) {
                            data.selected = true;
                            $scope.folderIds.push(data.id)
                        })
                    }
                }
                //文件夹多选
                vm.isChoiceFolder = false;
                $scope.choiceFolder = function () {
                    vm.isChoiceFolder = true;
                }
                $scope.cancelFolder = function () {
                    vm.isChoiceFolder = false;
                    vm.folderSelectData = "";
                    $scope.folderIds= [];
                    $scope.Folders.forEach(function (data) {
                        data.selected = false;
                    })
                }
                vm.isEditFolderName = false;
                $scope.editFolder = function () {
                    if($scope.folderIds.length!=1){
                        console.log($scope.folderIds);
                        return
                    }
                    $scope.Folders.forEach(function (data) {
                        if ($scope.folderIds[0] == data.id) {
                            vm.folderSelectData = angular.copy(data);
                        }
                    })
                    if (!vm.folderSelectData) {
                        threeInfo($translate.instant("editorCommon.pleaseSelectAFolder"));
                        return
                    }
                    vm.isEditFolderName = true;
                }

                function threeInfo(item) {
                    vm.threeError = true;
                    vm.threeErrorText = item;
                    $scope.folderIds= [];
                    vm.folderSelectData = "";
                    $timeout(function () {
                        vm.threeError = false;
                        vm.threeErrorText = "";
                    }, 1500)
                }
                $scope.editFolderNameHide = function () {
                    vm.isEditFolderName = false;
                }
                $scope.editFolderNameSave = function () {
                    vm.isEditFolderName = false;
                    if (!vm.folderSelectData || !vm.folderSelectData.name) {
                        threeInfo($translate.instant("editorCommon.pleaseName"));
                        return false
                    }
                    if (vm.folderSelectData.name.indexOf(" ") != -1) {
                        threeInfo($translate.instant("editorCommon.pleaseEnterTheContent"));
                        return false
                    }
                    vm.folderSelectData.articleId = vm.article.id;
                    Folder.update(vm.folderSelectData, function (resp) {
                        threeInfo($translate.instant("editorCommon.folderNameSuccess"));
                        $scope.cancelFolder();
                        loadFolders();
                        swal.close();
                    }, function () {
                        threeInfo($translate.instant("editorCommon.pleaseEnterTheCorrectFileName"));
                    })
                }

                function loadFolders() {
                    $scope.Folders = [];
                    Folder.getAllByConditionAndQuantity({articleId:vm.article.id}, function (resp) {
                        $scope.Folders = resp.data || [];
                    })
                }
                vm.folderSelectData = "";
                $scope.folderSelect = function (item) {
                    vm.photoCompleted = false;
                    if (vm.isChoiceFolder) {
                        $scope.folderIds = [];
                        $scope.Folders.forEach(function (data) {
                            if (item.id == data.id) {
                                data.selected = !data.selected ? true : false;
                            }
                            if (data.selected) {
                                $scope.folderIds.push(data.id)
                            }
                        })
                        console.log($scope.folderIds);
                    } else {
                        vm.folderOne = item;
                        vm.photoAll = [];
                        vm.photoArray = [];
                        vm.indexNum = 0;
                        vm.maxId = null;
                        loadAll(item.id)
                        vm.insideFolder = true;
                    }
                }
                vm.maxId = null;
                vm.itemsPerPage = 40;//分页大小
                function loadAll(folderId) {
                    var items = [];
                    items.push({ key: "articleId", op: "=", value: vm.aid });
                    if (folderId == 'isNull') {
                        items.push({key: "folderId", op: "isNull", value: ''})
                    } else {
                        items.push({ key: "folderId", op: "=", value: folderId })
                    }
                    if (vm.maxId) {
                        items.push({key: "id", op: "<=",value: vm.maxId});
                    }
                    Gallery.storeByCondition({
                        items: items,
                        page: vm.indexNum,
                        size: vm.itemsPerPage,
                        sort: sorts()
                    }, onSuccess, onError);
                }

                function sorts() {
                    return ["id,desc"];
                }

                function onSuccess(res) {
                    if (vm.maxId == null && res.data.length > 0) {
                        vm.maxId = res.data[0].id;
                    }
                    for (var i = 0; i < res.data.length; i++) {
                        if (!res.data[i].cancelled) {
                            // 按id去重，避免占位数据与服务端数据重复
                            var existsInPhotoAll = false;
                            for (var k = 0; k < vm.photoAll.length; k++) {
                                if (vm.photoAll[k].id == res.data[i].id) {
                                    existsInPhotoAll = true;
                                    break;
                                }
                            }
                            if (!existsInPhotoAll) {
                                res.data[i].identifier = $scope.domain + res.data[i].identifier;
                                if(res.data[i].largeFlag){
                                    res.data[i].identifier1 = $scope.domain + res.data[i].thumbnailKey;
                                }
                                vm.photoAll.push(res.data[i])
                            }
                        }
                    }
                    if (res.data.length < vm.itemsPerPage) {
                        vm.photoCompleted = true;
                    }
                    getPagePhoto();
                }

                function onError(data) {
                    if(data.status !== 403){
                        MessageService.hint($translate.instant("editorCommon.failedToObtainThePhotoGallery"));
                    }

                }

                function getPagePhoto() {
                    var timeList = [];
                    vm.photoArray = [];
                    for (var i = 0; i < vm.photoAll.length; i++) {
                        var photoCreatedDate = new Date(vm.photoAll[i].createdDate);
                        if (checkExist(timeList, photoCreatedDate)) {
                            timeList.push(photoCreatedDate);
                        }
                    }
                    //将相同日期下的照片整合
                    for (var m = 0; m < timeList.length; m++) {
                        var tempObj = {};
                        var tempItems = [];
                        for (var j = 0; j < vm.photoAll.length; j++) {
                            var createdDate = new Date(vm.photoAll[j].createdDate);
                            if (timeList[m].getFullYear() == createdDate.getFullYear() &&
                                timeList[m].getMonth() == createdDate.getMonth() &&
                                timeList[m].getDate() == createdDate.getDate()) {
                                tempItems.push(vm.photoAll[j])
                            }
                        }
                        var time = timeList[m].getFullYear() + '-' + (timeList[m].getMonth() + 1) + '-' + timeList[m].getDate();
                        tempObj = { "createDate": time, "galleries": tempItems };
                        vm.photoArray.push(tempObj);
                    }
                    getPagePhotoSelected();
                }

                function getPagePhotoSelected() {
                    vm.phoneAllSelected = true;
                    for(var i = 0; i < vm.photoArray.length; i++){
                        vm.photoArray[i].selected = true;
                        for(var j=0; j<vm.photoArray[i].galleries.length; j++){
                            vm.photoArray[i].galleries[j].selected = false;
                            for(var k=0; k<vm.photoSelectAll.length; k++){
                                if(vm.photoArray[i].galleries[j].id == vm.photoSelectAll[k].id){
                                    vm.photoArray[i].galleries[j].selected = true;
                                    // 同步大图/色彩转换状态，确保图库中展示与已选列表一致
                                    vm.photoArray[i].galleries[j].largeStatus  = vm.photoSelectAll[k].largeStatus
                                    if (vm.photoSelectAll[k].convertFlag) {
                                        vm.photoArray[i].galleries[j].convertFlag = vm.photoSelectAll[k].convertFlag;
                                        vm.photoArray[i].galleries[j].convertStatus = vm.photoSelectAll[k].convertStatus;
                                        vm.photoArray[i].galleries[j].identifier = vm.photoSelectAll[k].identifier;
                                    }
                                }
                            }
                            if(!vm.photoArray[i].galleries[j].selected){
                                vm.photoArray[i].selected = false;
                                vm.phoneAllSelected = false;
                            }
                        }
                    }
                    photoArrayAllSelect();
                }

                // 判断是否重复
                function checkExist(list, obj) {
                    if (list == null || list.length == 0) {
                        return true;
                    }
                    for (var i = 0; i < list.length; i++) {
                        if (list[i].getFullYear() == obj.getFullYear() &&
                            list[i].getMonth() == obj.getMonth() &&
                            list[i].getDate() == obj.getDate()) {
                            return false;
                        }
                    }
                    return true;
                }

                $scope.photoAllCb = function (item) {
                    item.selected = !item.selected ? true : false;
                    for(var i=0; i<item.galleries.length; i++){
                        item.galleries[i].selected = item.selected;
                        photoSelect(item.galleries[i])
                    }

                    selectAllBtnState()
                }
                //全选
                vm.phoneAllSelected = false;
                $scope.photoAllSelect = function () {
                    vm.phoneAllSelected = !vm.phoneAllSelected;
                    vm.photoArray.forEach(function (item) {
                        item.selected = vm.phoneAllSelected;
                        for(var i=0; i<item.galleries.length; i++){
                            item.galleries[i].selected = vm.phoneAllSelected;
                            photoSelect(item.galleries[i])
                        }
                    })
                }
                //选中当前图片
                $scope.photoOneCb = function (item) {
                    if(vm.fullMap && !item.selected && vm.photoSelectAll.length >= vm.fullMapNumber){
                        threeInfo($translate.instant("hint.imagesMaxQuantity"))
                        return
                    }
                    item.selected = !item.selected ? true : false;
                    photoSelect(item);
                    selectAllBtnState()
                }

                // 图库照片处理状态：大图处理中/失败、色彩转换中/失败，无特殊状态返回''（正常展示照片）
                $scope.photoStatus = function (photo) {
                    if (!photo) return '';
                    if (photo.convertFlag == true && photo.convertStatus == 'running') return 'convertRunning';
                    if (photo.convertStatus == 'error') return 'convertError';
                    if (photo.largeFlag && photo.largeStatus == 'running') return 'largeRunning';
                    if (photo.largeFlag && photo.largeStatus == 'error') return 'largeError';
                    return '';
                };
                // 是否处理失败状态（大图处理失败、色彩转换失败）
                $scope.isPhotoFailed = function (photo) {
                    var status = $scope.photoStatus(photo);
                    return status === 'largeError' || status === 'convertError';
                };
                // 处理中的照片不可选中，处理失败的照片点击向父级emit弹出删除确认框
                $scope.onPhotoStatusClick = function (photo, event) {
                    if (event) {
                        event.stopPropagation();
                    }
                    if ($scope.isPhotoFailed(photo)) {
                        $scope.$emit('requestDeletePhoto', photo);
                    }
                };

                function selectAllBtnState(){
                    // 多选按钮状态
                    vm.phoneAllSelected = true;
                    for(var i=0; i<vm.photoArray.length; i++){
                        vm.photoArray[i].selected = true;
                        for(var j=0; j<vm.photoArray[i].galleries.length; j++){
                            if(!vm.photoArray[i].galleries[j].selected){
                                vm.photoArray[i].selected = false;
                                vm.phoneAllSelected = false;
                            }
                        }
                    }
                }

                function photoSelect(item) {
                    // 图片选中判断是否有图片没有再添加
                    if (item.selected) {
                        var isExist = false;
                        for(var i=0; i<vm.photoSelectAll.length;i++){
                            var photoSelect = vm.photoSelectAll[i];
                            if (photoSelect.id == item.id) {
                                isExist=true;
                                break
                            }
                        }
                        if (!isExist) {
                            vm.photoSelectAll.push(item)
                        }
                        return
                    }
                    // 取消选择图片
                    for(var i=0; i<vm.photoSelectAll.length;i++){
                        var photoSelect = vm.photoSelectAll[i];
                        if (photoSelect.id == item.id) {
                            vm.photoSelectAll.splice(i,1);
                            return
                        }
                    }
                }

                function deletePhotoSelect(item) {
                    var index = null;
                    for (var i = 0; i < vm.photoSelectAll.length; i++) {
                        if (vm.photoSelectAll[i].id == item.id) {
                            index = i;
                            break
                        }
                    }
                    vm.photoSelectAll.splice(index, 1);
                }

                 //删除多个文件夹
                $scope.deleteFolders = function () {
                    if ($scope.folderIds.length == 0) {
                        return;
                    }
                    SweetAlert.swal({
                        title: $translate.instant("editorCommon.hint"),
                        text: $translate.instant("editorCommon.deleteFoldeHint"),
                        showCancelButton: true,
                        confirmButtonText: $translate.instant("editorBtn.delete"),
                        cancelButtonText: $translate.instant("editorBtn.back"),
                    }, function (isConfirm) {
                        if (isConfirm) {
                            Folder.batchDelete({ids: $scope.folderIds}, function () {
                                loadFolders();
                                $scope.cancelFolder();
                            }, function () {

                            });
                        } else {
                            return;
                        }
                    }
                )

                };

                function photoArrayAllSelect() {
                    for (var i = 0; i < vm.photoArray.length; i++) {
                        vm.photoArray[i].selected = true;
                        for (var j = 0; j < vm.photoArray[i].galleries.length; j++) {
                            if (!vm.photoArray[i].galleries[j].selected) {
                                vm.photoArray[i].selected = false;
                            }
                        }
                    }
                }

                $scope.photoIndex = function (item) {
                    var index = null;
                    for (var i = 0; i < vm.photoSelectAll.length; i++) {
                        if (vm.photoSelectAll[i].id == item.id) {
                            index = i;
                            break
                        }
                    }
                    return index + 1;
                }

                vm.windowDpi = js_getDPI();

                $scope.galleryNavSel = function (item) {
                    vm.currentNav = item;
                    vm.indexNum = 0;
                    vm.maxId = null;
                    vm.photoCompleted = false;
                    vm.photoAll = [];
                    vm.folderOne = null;
                    if (item == 'gallery') {
                        loadAll('isNull')
                    }
                    if (item == 'folder') {
                        loadFolders()
                    }
                };
                //添加图片
                $scope.photoSave = function () {
                    if(vm.fullMap && vm.photoSelectAll.length > vm.fullMapNumber){
                        threeInfo($translate.instant("hint.imagesMaxQuantity"))
                        return
                    }
                    $scope.$emit('confirmGallery', vm.photoSelectAll);
                }

                // 事件通知
                $scope.folderSave = function () {
                    if(vm.fullMap && vm.photoSelectAll.length > vm.fullMapNumber){
                        threeInfo($translate.instant("hint.imagesMaxQuantity"))
                        return
                    }
                    $scope.$emit('confirmGallery', vm.photoSelectAll);

                }
                // 返回按钮事件通知
                $scope.getBack = function () {
                    if (vm.insideFolder) {
                        vm.insideFolder = false;
                        loadFolders()
                    }else{
                        $scope.$emit('closeGallery',  true);
                    }
                };
                $scope.$on('uoloadFinished', function(event, args) {
                    // 大图需要异步处理 先unshift到vm.photoAll进行占位
                    addNewBigPhoto()
                    if(args){
                        getPagePhoto();
                    }
                });
                // 监听父组件去重后的刷新事件，重新加载图库并触发getPagePhoto
                $scope.$on('duplicateGalleryRefresh', function() {
                    vm.indexNum = 0;
                    vm.maxId = null;
                    vm.photoCompleted = false;
                    vm.photoAll = [];
                    vm.folderOne = null;
                    loadAll('isNull');
                });
                // 监听父组件删除照片后的刷新事件，从本地photoAll移除并重新分组
                $scope.$on('photoDeletedRefresh', function(event, photoId) {
                    if (photoId) {
                        for (var i = vm.photoAll.length - 1; i >= 0; i--) {
                            if (vm.photoAll[i].id == photoId) {
                                vm.photoAll.splice(i, 1);
                            }
                        }
                    }
                    getPagePhoto();
                });
                function addNewBigPhoto(){
                    var missing = [];
                    for (var i = 0; i < vm.photoSelectAll.length; i++) {
                        var item = vm.photoSelectAll[i];
                        var existsInPhotoAll = false;
                        for (var k = 0; k < vm.photoAll.length; k++) {
                            if (vm.photoAll[k].id == item.id) {
                                existsInPhotoAll = true;
                                break;
                            }
                        }
                        if (!existsInPhotoAll && item.largeFlag) {
                            missing.push(item);
                        }
                    }
                    for (var j = missing.length - 1; j >= 0; j--) {
                        vm.photoAll.unshift(missing[j]);
                    }
                }
                // websocket接收上传的图片（多端互通实时更新）
                function websocket(){
                    var urlws = vm.platformSetting.editorNotifyUrl.split("://")[1];
                    urlws = urlws.split("/")[0];
                    var ws = $websocket("wss://"+ urlws +"/widget/ws/websocket?uid=Gallery"+vm.aid);

                    ws.onOpen(function() {
                        console.log('WebSocket连接已打开, url:'+ws.url);
                    });

                    ws.onMessage(function(message) {
                        var photo = JSON.parse(message.data);
                        console.log(photo);
                        if ((photo.folderId == null && vm.folderOne==null) || (photo.folderId == vm.folderOne.id)) {
                            photo.identifier = $scope.domain + photo.identifier;
                            photo.identifier1 = $scope.domain + photo.thumbnailKey;
                            photo.selected = true;
                            // 先按id查找是否已有占位/旧数据，避免重复添加
                            var _photo = null;
                            for (var i = 0; i < vm.photoAll.length; i++) {
                                if (vm.photoAll[i].id == photo.id) {
                                    _photo = vm.photoAll[i];
                                    break;
                                }
                            }
                            if (_photo) {
                                // 更新已有数据（大图处理完成时更新各项字段）
                                _photo.largeStatus = photo.largeStatus;
                                _photo.stripKey = photo.stripKey;
                                _photo.thumbnailKey = photo.thumbnailKey;
                                _photo.identifier1 = $scope.domain + photo.thumbnailKey;
                                // 色彩转换：同步转换状态和新的identifier
                                if (_photo.convertFlag || photo.convertFlag) {
                                    _photo.convertFlag = photo.convertFlag;
                                    _photo.convertStatus = photo.convertStatus;
                                    _photo.identifier = $scope.domain + photo.identifier;
                                }
                                if (!photo.largeFlag) {
                                    _photo.largeFlag = photo.largeFlag;
                                    _photo.identifier = photo.identifier;
                                    _photo.identifier1 = photo.identifier1;
                                }
                            } else if (photo && !photo.largeFlag) {
                                vm.photoAll.unshift(photo);
                            }
                            getPagePhoto();
                        }
                    });

                    ws.onError(function(error) {
                        console.log('WebSocket错误：', error);
                    });

                    ws.onClose(function() {
                        console.log('WebSocket连接已关闭');
                    });
                }
            }]
    };

    angular
        .module('editorApp')
        .component('editorGallery', editorGallery);
})();

(function () {
    'use strict';

    var DuplicateListControl = {
    	restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/components/duplicate-list.html',
        controllerAs: 'vm',
        bindings: {
            list: '=',
            domainUrl: '=',
            onChange:'&'
        },

        controller: ['$scope','FontManagement','$timeout', 'Gallery','MessageService', function ($scope,FontManagement,$timeout,Gallery,MessageService){
            var vm = this;
            vm.list.forEach(function(pic){
                pic.identifier = pic.identifier.indexOf('http') == -1 ? vm.domainUrl + pic.identifier : pic.identifier;
            })
            $scope.deleteImg = function (index){
                var _item = angular.copy([vm.list[index]]);
                console.log(_item)
                deleteImgs([vm.list[index].id],function (){
                    vm.list.splice(index,1);
                    vm.onChange({text:JSON.stringify(_item)})
                });
            }
            function deleteImgs(ids,callback){
                Gallery.batchDelete(ids,function (res){
                    callback();
                    MessageService.success("去重成功！");
                });
            }
            $scope.modalHide = function (){
                vm.onChange({text:0})
            }
            vm.loading = false;
            $scope.modalSubmint = function (){
                vm.loading = true;
                var ids = [];
                vm.list.forEach(function (item){
                    ids.push(item.id)
                })
                deleteImgs(ids,function (){
                    if(vm.list&&vm.list.length>0){
                        vm.onChange({text:JSON.stringify(vm.list)})
                    }else{
                        vm.onChange({text:1})
                    }
                    vm.loading = false;
                })
            }
        }]
    };

    angular.module('editorApp')
    	.component('duplicateList', DuplicateListControl);

})();

(function () {
    'use strict';

    var weekCellControl = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/components/controls/week-cell.control.html',
        controllerAs: 'vm',
        bindings: {
            obj: "<",
            layout: "<",
            settings: "<",
            width: "<",
            height: "<",
            index: "<",
            weekConfig: "<"
        },

        controller: ['$scope', 'FontManagement','$timeout', function ($scope, FontManagement,$timeout) {
            var vm = this;
            vm.data = {
                width: 100,
                height: 50,
                items: []
            };

            vm.$onInit = function() {
                // var settings = vm.settings || {};
                // constructCell(vm.layout, settings, vm.obj);
            }
            // 每當 one-way binding 更新時，changesObj 就是改變前後的差異
            vm.$onChanges = function(data) {
                if (data.layout && data.layout.currentValue) {
                    vm.layout = data.layout.currentValue;
                }
                if (data.settings && data.settings.currentValue) {
                    vm.settings = data.settings.currentValue;
                }
                if (data.obj && data.obj.currentValue) {
                    vm.obj = data.obj.currentValue;
                }
                if (data.weekConfig && data.weekConfig.currentValue) {
                    vm.weekConfig = data.weekConfig.currentValue;
                }
                constructCell(vm.layout, vm.settings, vm.obj);
            }
            vm.$postLink = function () {

            }
            vm.$doCheck = function() {
                // deep watch
            }
            vm.$onDestroy = function () {

            }

            function textStyleObj(obj) {
                var styles = {
                    'position': 'absolute',
                    'left': obj.x + 'px',
                    'top': obj.y + 'px',
                    'line-height': (obj.textSize > 12 ? obj.h : obj.h / (1 / 12 * obj.textSize)) + 'px',
                    'fontSize': (obj.textSize > 12 ? obj.textSize : 12) + 'px',
                    'font-family': obj.textFontUuid,
                    'color': obj.textColor,
                    'text-align': obj.textAlign || 'center',
                    'transform':'scale('+(1 / 12 * obj.textSize > 1 ? 1 : 1 / 12 * obj.textSize)+')',
                    'transform-origin': '0 0',
                    'width': obj.textSize > 12 ? obj.w : obj.w / (1 / 12 * obj.textSize) + 'px',
                    'height': obj.textSize > 12 ? obj.h : obj.h / (1 / 12 * obj.textSize) + 'px',
                };
                if (obj.textWeight) {
                    styles['font-weight'] = obj.textWeight;
                }
                if (obj.textStyle) {
                    styles['font-style'] = obj.textStyle;
                }
                if (obj.backgroundColor) {
                    styles['background-color'] = obj.backgroundColor;
                }
                if (obj.debug) {
                    styles['border'] = '1px dotted #ccc';
                }
                return styles;
            }
            function imageStyleObj(obj) {
                var styles = {
                    'position': 'absolute',
                    'left': obj.x + 'px',
                    'top': obj.y + 'px',
                    'width': obj.w + 'px',
                    'height': obj.h + 'px'
                };
                if (obj.debug) {
                    styles['border'] = '1px dotted #ccc';
                }

                return styles;
            }

            function findItemFromSettings(settings, itemName) {
                if (!settings || !settings.items || !settings.items.length || !itemName) {
                    return {};
                }
                for (var i = 0; i < settings.items.length; i++) {
                    var item = settings.items[i];
                    if (item.name == itemName) {
                        return item;
                    }
                }

                return {};
            }

            function findDataFromObj(obj, type, format) {
                if (!obj || !obj.items || !obj.items.length) {
                    return {};
                }
                for (var i = 0; i < obj.items.length; i++) {
                    var item = obj.items[i];
                    if (item.type == type && item.format == format) {
                        return item;
                    }
                }
                return {};
            }

            function constructCell(layout, settings, myObj) {
                var cw = layout.width || 100;
                var ch = layout.height || 50;
                var width = vm.width || 100;
                var height = vm.height || 50;
                vm.data = {
                    width: width,
                    height: height,
                    styles: {
                        width: angular.copy(width),
                        height: angular.copy(height)
                    },
                    items: []
                };
                if (settings.backgroundColor) {
                    vm.data.styles['background-color'] = settings.backgroundColor;
                }
                var lineW = 0;
                if (settings && settings.items && settings.items.length) {
                    var border = settings.border;
                    if (settings.border && settings.border.lineType && settings.border.lineWidth && border.color) {
                        lineW = (border.lineWidth)*2;
                        vm.data.styles['border'] = (border.lineWidth) + 'px ' + border.lineType + " "  + border.color;
                        if(vm.weekConfig){
                            if(vm.weekConfig.removeBorderOverlap){
                                if(vm.index > 0){
                                    lineW = border.lineWidth;
                                    vm.data.styles['border-left'] = 0 + 'px ' + border.lineType + " "  + border.color;
                                }
                            }
                            if(vm.weekConfig.removeBorderBottom){
                                vm.data.styles['border-bottom'] = 0 + 'px ' + border.lineType + " "  + border.color;
                            }
                        }
                    }
                    if (border.tlRadius) {
                        vm.data.styles['border-top-left-radius'] = border.tlRadius * Math.min(width / cw, height / ch) + 'px';
                    }
                    if (border.trRadius) {
                        vm.data.styles['border-top-right-radius'] = border.trRadius * Math.min(width / cw, height / ch) + 'px';
                    }
                    if (border.blRadius) {
                        vm.data.styles['border-bottom-left-radius'] = border.blRadius * Math.min(width / cw, height / ch) + 'px';
                    }
                    if (border.brRadius) {
                        vm.data.styles['border-bottom-right-radius'] = border.brRadius * Math.min(width / cw, height / ch) + 'px';
                    }
                    width = width - lineW;
                    height = height - lineW;
                    for (var i = 0; i < settings.items.length; i++) {
                        var ci = settings.items[i];
                        var ci1 = layout.items[i];
                        if (ci.type == "image" || ci.type == 'userimage') {
                            var element = {
                                x: ci.x * width / cw,
                                y: ci.y * height / ch,
                                w: ci.w * width / cw,
                                h: ci.h * height / ch
                            };
                            if (settings.debug) {
                                element.debug = true;
                            }
                            var img = {
                                type: ci.type,
                                url: ci.url,
                                styles: imageStyleObj(element)
                            };
                            vm.data.items.push(img);
                        }
                        else if (ci.type) {
                            var element = {
                                x: ci.x * width / cw,
                                y: ci.y * height / ch,
                                w: ci.w * width / cw,
                                h: ci.h * height / ch,
                                textSize: Number.parseInt(ci.textSize) * width / cw,
                                textFont: ci.textFont,
                                textColor: ci.textColor,
                                textAlign: ci.textAlign,
                                textWeight: ci.textWeight,
                                textFontUuid: ci.textFontUuid,
                                backgroundColor: ci.backgroundColor
                            };
                            var item = findItemFromSettings(settings, ci.name) || {};
                            if (item.textFontUuid) {
                                element.textFontUuid = item.textFontUuid;
                                getFontCSS(FontManagement, {
                                    fontuuid: element.textFontUuid
                                }, $scope)
                            }
                            if (item.textSize) {
                                element.textSize = Number.parseInt(item.textSize) * width / cw;
                            }
                            if (item.textFont) {
                                element.textFont = item.textFont;
                            }
                            if (item.textColor) {
                                element.textColor = item.textColor;
                            }
                            if (item.textAlign) {
                                element.textAlign = item.textAlign;
                            }
                            if (item.textBold) {
                                element.textWeight = "600";
                            }
                            if (item.textItalic) {
                                element.textStyle = "italic";
                            }
                            if (item.backgroundColor) {
                                element.backgroundColor = item.backgroundColor;
                            }
                            if (settings.debug) {
                                element.debug = true;
                            }

                            var data = findDataFromObj(myObj || vm.obj, ci.type, ci1.format) || {};

                            var text = {
                                type: ci.type,
                                format: ci1.format,
                                value: data.value || ci.value || ci.sample || ci.name,
                                styles: textStyleObj(element)
                            };
                            vm.data.items.push(text);
                        }

                    }
                } else {
                    var t = {
                        type: "week",
                        format: "$cnWeek",
                        value: "星期日",
                        textSize: 18 * width / 100,
                        textFont: '',
                        textFontUuid: '',
                        textColor: '#000000',
                        textWeight: 600,
                        x: 5 * width / 100,
                        y: 10 * height / 50,
                        w: 90 * width / 100,
                        h: 30  * height / 50,
                        fixedTo: ''
                    };
                    vm.data.items.push({
                        type: t.type,
                        format: t.format,
                        value: t.value || t.sample,
                        styles: textStyleObj(t)
                    });
                }
            }
            $scope.itemValue = function (item) {
                // console.log(item)
                if(item&&item.value){
                    return item.value
                }
            }
        }]
    };
    angular.module('editorApp')
        .component('weekCell', weekCellControl);

})();

(function () {
    'use strict';

    var titleCellControl = {
    	restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/components/controls/title-cell.control.html',
        controllerAs: 'vm',
        bindings: {
            widget: "=",
            width: "<",
            height: "<",
            year: "<",
            month: "<",
            scale: "<"
        },

        controller: ['$scope', '$timeout','FontManagement','CalendarService', function ($scope, $timeout,FontManagement,CalendarService) {
            var vm = this;
            vm.data = {
                width: 200,
                height: 80,
                items: []
            };

            vm.$onInit = function() {
            }
            // 每當 one-way binding 更新時，changesObj 就是改變前後的差異
            vm.$onChanges = function(data) {
                if(data.year&&data.year.currentValue&&data.year.previousValue>0){vm.year = data.year.currentValue; vm.widget.obj = null;}
                if(data.month&&data.month.currentValue&&data.month.previousValue>0){vm.month = data.month.currentValue; vm.widget.obj = null;}
                if (data.widget && data.widget.currentValue) {
                    vm.widget = data.widget.currentValue;
                }
                if(vm.widget){
                    if(!vm.widget.ctrl){
                        vm.widget.ctrl = {}
                    }
                    if(vm.widget.geometry){
                        vm.widget.width = vm.widget.geometry.width;
                        vm.widget.height = vm.widget.geometry.height;
                        if(vm.widget.layout){
                            vm.widget.layout.width = vm.widget.layout.geometry.width;
                            vm.widget.layout.height = vm.widget.layout.geometry.height;
                            if(vm.widget.layout.items&&vm.widget.layout.items.item){
                                vm.widget.layout.items = vm.widget.layout.items.item;
                                vm.widget.layout.items.forEach(function (item) {
                                    item.w = item.geometry.width;
                                    item.h = item.geometry.height;
                                    item.x = item.geometry.x;
                                    item.y = item.geometry.y;
                                })
                            }
                        }
                        if(vm.widget.settings){
                            if(vm.widget.settings.items&&vm.widget.settings.items.item){
                                vm.widget.settings.items = vm.widget.settings.items.item;
                                vm.widget.settings.items.forEach(function (item) {
                                    if(item.geometry){
                                        item.w = item.geometry.width;
                                        item.h = item.geometry.height;
                                        item.x = item.geometry.x;
                                        item.y = item.geometry.y;
                                    }
                                })
                            }
                        }
                    }
                    queryYearMonthDataset(function () {
                        vm.widget.ctrl.settings = vm.widget.settings;
                        vm.widget.ctrl.obj = vm.widget.obj || [];
                        constructCell(vm.widget.layout, vm.widget.ctrl.settings, vm.widget.ctrl.obj);
                    })
                }
            }
            vm.$postLink = function () {

            }
            vm.$doCheck = function() {
                // deep watch
            }
            vm.$onDestroy = function () {

            }
            function queryYearMonthDataset(callback) {
                if(vm.widget.obj){
                    if(callback){callback()}
                    return
                }
                vm.widget.obj = null;
                var req = {
                    year: vm.widget.sampleYear || 2023,
                    month: vm.widget.sampleMonth || 1
                };
                var formats = [];
                var layout = vm.widget.layout || {};
                if (layout.items && layout.items.length) {
                    for (var i = 0; i < layout.items.length; i++) {
                        var item = layout.items[i];
                        if (item.type == 'year' || item.type == 'month') {
                            formats.push({type: item.type, format: item.format});
                        }
                    }
                }
                req.formats = formats;
                CalendarService.queryYearMonthSet(req, function (res) {
                    vm.widget.obj = res.data || null;
                    if(callback){callback()}
                });
            }

            function textStyleObj(obj) {
                var styles = {
                    'position': 'absolute',
                    'left': obj.x + 'px',
                    'top': obj.y + 'px',
                    'width': obj.textSize > 12 ? obj.w : obj.w / (1 / 12 * obj.textSize) + 'px',
                    'height': obj.textSize > 12 ? obj.h : obj.h / (1 / 12 * obj.textSize) + 'px',
                    'line-height': (obj.textSize > 12 ? obj.h : obj.h / (1 / 12 * obj.textSize)) + 'px',
                    'fontSize': (obj.textSize > 12 ? obj.textSize : 12) + 'px',
                    'font-family': obj.textFontUuid,
                    'color': obj.textColor,
                    'text-align': obj.textAlign || 'center',
                    'transform':'scale('+(1 / 12 * obj.textSize > 1 ? 1 : 1 / 12 * obj.textSize)+')',
                    'transform-origin': '0 0',
                };
                if (obj.textWeight) {
                    styles['font-weight'] = obj.textWeight;
                }
                if (obj.textStyle) {
                    styles['font-style'] = obj.textStyle;
                }
                if (obj.backgroundColor) {
                    styles['background-color'] = obj.backgroundColor;
                }
                if (obj.debug) {
                    styles['border'] = '1px dotted #ccc';
                }
                if (obj.vertical) {
                    styles['writing-mode'] = "vertical-lr";
                    styles['line-height'] = (obj.textSize > 12 ? obj.w : obj.w / (1 / 12 * obj.textSize)) + 'px';
                }
                return styles;
            }
            function imageStyleObj(obj) {
                var styles = {
                    'position': 'absolute',
                    'left': obj.x + 'px',
                    'top': obj.y + 'px',
                    'width': obj.w + 'px',
                    'height': obj.h + 'px'
                };
                if (obj.debug) {
                    styles['border'] = '1px dotted #ccc';
                }

                return styles;
            }

            function findItemFromSettings(settings, itemName) {
                if (!settings || !settings.items || !settings.items.length || !itemName) {
                    return {};
                }
                for (var i = 0; i < settings.items.length; i++) {
                    var item = settings.items[i];
                    if (item.name == itemName) {
                        return item;
                    }
                }

                return {};
            }

            function findDataFromObj(obj, type, format) {
                if (!obj || !obj.items || !obj.items.length) {
                    return {};
                }
                for (var i = 0; i < obj.items.length; i++) {
                    var item = obj.items[i];
                    if (item.type == type && item.format == format) {
                        return item;
                    }
                }
                return {};
            }

            function constructCell(layout, settings, myObj) {
                settings.width = layout.width;
                settings.height = layout.height;
                var width = vm.width || settings.width || 200;
                var height = vm.height || settings.height || 80;
                vm.data = {
                    width: width,
                    height: height,
                    styles: {
                        width: width + 'px',
                        height: height + 'px',
                        'transform' : 'scale('+(vm.scale || 1) + ')',
                        'transform-origin' : '0px 0px',
                        'overflow': 'hidden'
                    },
                    items: []
                };
                if (settings.backgroundColor) {
                    vm.data.styles['background-color'] = settings.backgroundColor;
                }
                if (settings.border && settings.border.lineType && settings.border.lineWidth) {
                    var border = settings.border;
                    vm.data.styles['border'] = border.lineWidth + 'px ' + border.lineType + " " + border.color;
                    if (border.tlRadius) {
                        vm.data.styles['border-top-left-radius'] = border.tlRadius + 'px';
                    }
                    if (border.trRadius) {
                        vm.data.styles['border-top-right-radius'] = border.trRadius + 'px';
                    }
                    if (border.blRadius) {
                        vm.data.styles['border-bottom-left-radius'] = border.blRadius + 'px';
                    }
                    if (border.brRadius) {
                        vm.data.styles['border-bottom-right-radius'] = border.brRadius + 'px';
                    }
                }
                if (settings && settings.items && settings.items.length) {
                    var cw = settings.width || 200;
                    var ch = settings.height || 80;
                    for (var i = 0; i < settings.items.length; i++) {
                        var ci = settings.items[i];
                        if(!ci.format){
                            ci.format = layout.items[i].format;
                        }
                        if(!ci.w || !ci.h){
                            ci.w = layout.items[i].w;
                            ci.h = layout.items[i].h;
                            ci.x = layout.items[i].x;
                            ci.y = layout.items[i].y;
                        }
                        if (ci.type == "image") {
                            var element = {
                                x: ci.x * width / cw,
                                y: ci.y * height / ch,
                                w: ci.w * width / cw,
                                h: ci.h * height / ch
                            };
                            if (settings.debug) {
                                element.debug = true;
                            }
                            var img = {
                                type: ci.type,
                                url: ci.url,
                                styles: imageStyleObj(element)
                            };
                            vm.data.items.push(img);
                        }
                        else if (ci.type) {
                            var element = {
                                x: ci.x * width / cw,
                                y: ci.y * height / ch,
                                w: ci.w * width / cw,
                                h: ci.h * height / ch,
                                textSize: ci.textSize * Math.min(width / cw, height / ch),
                                textFont: ci.textFont,
                                textColor: ci.textColor,
                                textAlign: ci.textAlign,
                                textWeight: ci.textWeight,
                                textFontUuid: ci.textFontUuid,
                                vertical:ci.vertical
                            };
                            var item = findItemFromSettings(settings, ci.name) || {};
                            if (item.textFontUuid) {
                                element.textFontUuid = item.textFontUuid;
                                getFontCSS(FontManagement, {
                                    fontuuid: element.textFontUuid
                                }, $scope)
                            }
                            if (item.textSize) {
                                element.textSize = item.textSize * Math.min(width / cw, height / ch);
                            }
                            if (item.textFont) {
                                element.textFont = item.textFont;
                            }
                            if (item.textColor) {
                                element.textColor = item.textColor;
                            }
                            if (item.textAlign) {
                                element.textAlign = item.textAlign;
                            }
                            if (item.textBold) {
                                element.textWeight = "600";
                            }
                            if (item.textItalic) {
                                element.textStyle = "italic";
                            }
                            if (item.backgroundColor) {
                                element.backgroundColor = item.backgroundColor;
                            }

                            if (settings.debug) {
                                element.debug = true;
                            }

                            var data = findDataFromObj(myObj, ci.type, ci.format) || {};

                            var text = {
                                type: ci.type,
                                format: ci.format,
                                value: data.value || ci.value || ci.sample,
                                styles: textStyleObj(element)
                            };
                            vm.data.items.push(text);
                        }

                    }
                } else {
                    var t = {
                        type: "year",
                        format: "$yyyy",
                        value: "2023",
                        textSize: 18 * width / 100,
                        textFont: '',
                        textFontUuid: '',
                        textColor: '#000000',
                        x: 5 * width / 200,
                        y: 10 * height / 80,
                        w: 90 * width / 200,
                        h: 30  * height / 80,
                        fixedTo: '',
                        vertical:false
                    };
                    vm.data.items.push({
                        type: t.type,
                        format: t.format,
                        value: t.value || t.sample,
                        styles: textStyleObj(t)
                    });
                }
            } // end of constructCell

        }]
    };
    angular.module('editorApp')
        .component('titleCell', titleCellControl);

})();

(function () {
    'use strict';

    var styleSettingControl = {
    	restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/components/controls/style-setting.control.html',
        controllerAs: 'vm',
        bindings: {
            style:'<',
            options:'<',
            obj:'<',
            settings:'<',
            onChange:'&'
        },

        controller: ['$scope','$timeout', function ($scope,$timeout) {
            var vm = this;
            vm.data = {};
            vm.textAligns=[
                {id:'left',value:'左对齐'},
                {id:'center',value:'居中'},
                {id:'right',value:'右对齐'},
            ]

            vm.$onInit = function() {
                // vm.data.settings = vm.settings;
                // if (vm.data.settings && !vm.data.settings.border.lineType) {
                //     vm.data.settings.border.lineType = 'solid';
                // }
            }
            // 每當 one-way binding 更新時，changesObj 就是改變前後的差異
            vm.$onChanges = function(data) {
                if(data.settings&&data.settings.currentValue){
                    vm.data.settings = data.settings.currentValue;
                }
                if (vm.data.settings && !vm.data.settings.border.lineType) {
                    vm.data.settings.border.lineType = 'solid';
                }
            }
            vm.$postLink = function () {

            }
            vm.$doCheck = function() {
                // deep watch
            }
            vm.$onDestroy = function () {

            }

            $scope.onCheckboxChange = function() {
                onSettingsChange();
            }

            $scope.onBorderInputChange = function(num) {
                onSettingsChange();
            }

            $scope.onColorChange = function(text) {
                onSettingsChange();
            }
            var a = null;
            $scope.onInputChange = function(num, index) {
                if (a !== null) {
                    clearTimeout(a)
                }
                a = setTimeout(function () {
                    if(!num || num == 'undefined'){
                        vm.data.settings.items[index].textSize = 12;
                    }
                    $scope.onItemChange();
                },800)
            }

            $scope.onItemChange = function() {
                $timeout(function () {
                    onSettingsChange();
                })
            }

            function onSettingsChange() {
                if (vm.onChange) {
                    vm.onChange({text: JSON.stringify(vm.data.settings)});
                }
            }

        }]
    };
    angular.module('editorApp')
        .component('styleSetting', styleSettingControl);

})();

(function () {
    'use strict';

    var monthTableControl = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/components/controls/month-table.html',
        controllerAs: 'vm',
        bindings: {
            widget: "=",
            year:'<',
            month:'<',
            week:'<',
            scale:'<',
            width:'<',
            height:'<',
            thumbnail:'<',
        },

        controller: ['$scope', '$timeout','CalendarService','$rootScope', function ($scope, $timeout,CalendarService,$rootScope) {
            var vm = this;
            vm.data = {
                cols: 7,
                rows: 5,
                clientWidth: 426,
                clientHeight: 396,
                headCellWidth: 60,
                headCellHeight: 30,
                headCellMargin: 0,
                dateCellWidth: 60,
                dateCellHeight: 60,
                dateCellMargin: 0,
                heads: [],
                dates: []
            };

            vm.$onInit = function() {
                if(vm.widget){
                    dataInfo()
                    vm.widget.ctrl.displayType = vm.widget.displayType || "C7";
                    vm.widget.ctrl.width = vm.widget.width || 426;
                    vm.widget.ctrl.height = vm.widget.height || 396;
                    vm.widget.ctrl.weekLayout = orMockWeekLayout(vm.widget.weekLayout);
                    vm.widget.ctrl.dateLayout = orMockDateLayout(vm.widget.dateLayout);
                    queryMonthdaysDataset(function () {
                        reconstructTable();
                    })
                }
            }
            // 每當 one-way binding 更新時，changesObj 就是改變前後的差異
            vm.$onChanges = function(data) {
                if(vm.widget){
                    if(!vm.widget.ctrl){
                        vm.widget.ctrl={}
                    }
                    if(data.year&&data.year.currentValue&&data.year.previousValue>0){vm.year = data.year.currentValue; vm.widget.obj=null;}
                    if(data.month&&data.month.currentValue&&data.month.previousValue>0){vm.month = data.month.currentValue; vm.widget.obj=null;}
                    if(data.week&&data.week.currentValue){vm.week = data.week.currentValue}
                    if(data.widget&&data.widget.currentValue){vm.widget = data.widget.currentValue}

                    if(data.width&&data.width.currentValue&&data.width.previousValue>0&&data.height&&data.height.currentValue&&data.height.previousValue>0){
                        vm.widget.ctrl.width = data.width.currentValue;
                        vm.widget.ctrl.height = data.height.currentValue;
                    }
                    // if(data.scale&&data.scale.currentValue){
                    //     vm.widget.ctrl.width = vm.widget.geometry.width * vm.scale;
                    //     vm.widget.ctrl.height = vm.widget.geometry.height * vm.scale;
                    // }
                    queryMonthdaysDataset(function () {
                        reconstructTable();
                    })
                }
            }
            vm.$postLink = function () {

            }
            vm.$doCheck = function() {
                // deep watch
            }
            vm.$onDestroy = function () {

            }

            function dataInfo() {
                if(vm.widget.geometry){
                    vm.widget.width = vm.widget.geometry.width;
                    vm.widget.height = vm.widget.geometry.height;
                    if(vm.widget.weekLayout.geometry){
                        vm.widget.weekLayout.width = vm.widget.weekLayout.geometry.width;
                        vm.widget.weekLayout.height = vm.widget.weekLayout.geometry.height;
                    }
                    if(vm.widget.weekLayout.items&&vm.widget.weekLayout.items.item){
                        vm.widget.weekLayout.items = vm.widget.weekLayout.items.item;
                        vm.widget.weekLayout.items.forEach(function (weekLayout) {
                            weekLayout.w = weekLayout.geometry.width;
                            weekLayout.h = weekLayout.geometry.height;
                            weekLayout.x = weekLayout.geometry.x;
                            weekLayout.y = weekLayout.geometry.y;
                        })
                    }
                    if(vm.widget.dateLayout.geometry){
                        vm.widget.dateLayout.width = vm.widget.dateLayout.geometry.width;
                        vm.widget.dateLayout.height = vm.widget.dateLayout.geometry.height;
                    }
                    if(vm.widget.dateLayout.items&&vm.widget.dateLayout.items.item){
                        vm.widget.dateLayout.items = vm.widget.dateLayout.items.item;
                        vm.widget.dateLayout.items.forEach(function (dateLayout) {
                            dateLayout.w = dateLayout.geometry.width;
                            dateLayout.h = dateLayout.geometry.height;
                            dateLayout.x = dateLayout.geometry.x;
                            dateLayout.y = dateLayout.geometry.y;
                        })
                    }
                    if(vm.widget.weekStyles&&vm.widget.weekStyles.item){
                        vm.widget.weekStyles = vm.widget.weekStyles.item;
                    }
                    if(vm.widget.weekStyles){
                        vm.widget.weekStyles.forEach(function (weekStyle) {
                            if(weekStyle.items.item){
                                weekStyle.items = weekStyle.items.item;
                                weekStyle.items.forEach(function (item){
                                    if(item.geometry){
                                        item.w = item.geometry.width;
                                        item.h = item.geometry.height;
                                        item.x = item.geometry.x;
                                        item.y = item.geometry.y;
                                    }
                                })
                            }
                        })
                    }
                    if(vm.widget.dateStyles&&vm.widget.dateStyles.item){
                        vm.widget.dateStyles = vm.widget.dateStyles.item;
                    }
                    if(vm.widget.dateStyles){
                        vm.widget.dateStyles.forEach(function (dateStyle) {
                            if(dateStyle.items.item){
                                dateStyle.items = dateStyle.items.item;
                                dateStyle.items.forEach(function (item,index){
                                    if(item.geometry){
                                        item.w = item.geometry.width;
                                        item.h = item.geometry.height;
                                        item.x = item.geometry.x;
                                        item.y = item.geometry.y;
                                    }
                                })
                            }
                        })
                    }
                }
                if(!vm.widget.ctrl){
                    vm.widget.ctrl={}
                }
            }
            function onCellSizeChange(callback,isNew) {
                if(vm.widget.obj&&vm.widget.obj.heads&&vm.widget.obj.days){
                    var column = vm.widget.obj.heads.length || 7;
                    var row = Math.ceil(vm.widget.obj.days.length/column);
                    var wc = vm.widget.weekConfig;
                    var dc = vm.widget.dateConfig;
                    var headWidth = Number.parseInt(wc.cellWidth || 40) * column + Number.parseInt(wc.margin || 0) * (column-1);
                    var bodyWidth = Number.parseInt(dc.cellWidth || 40) * column + Number.parseInt(dc.margin || 0) * (column-1);
                    var bodyHeight = (Number(dc.cellHeight || 40)) * row + Number(dc.margin || 0) * (row-1);
                    var headHeight = (Number(wc.cellHeight || 20)) + Number(dc.headSpacing || 0);

                    var tableHeight = bodyHeight + headHeight;

                    var width = Math.max(headWidth, bodyWidth);

                    vm.widget.width = width;
                    vm.widget.height = tableHeight;
                    vm.widget.headWidth = headWidth;
                    vm.widget.bodyWidth = bodyWidth;
                    vm.widget.headHeight = headHeight;
                    vm.widget.bodyHeight = bodyHeight;
                    if(isNew && !vm.widget.geometry){
                        vm.widget.ctrl.width = vm.widget.width;
                        vm.widget.ctrl.height = vm.widget.height;
                    }
                    if(callback){callback()}
                }
            }
            function queryMonthdaysDataset(callback) {
                if(vm.widget.ctrl.dateLayout && vm.widget.ctrl.weekLayout){
                    if(vm.widget.obj){
                        onCellSizeChange(function () {
                            if(callback){callback()}
                        })
                        return
                    }
                    vm.widget.obj = null;
                    var req = {
                        year: vm.year || 2023,
                        month: vm.month || 1,
                        startOfWeek: vm.week || 0,
                    };
                    var dateFormats = [];
                    var dateLayout = vm.widget.dateLayout || {};
                    if (dateLayout.items && dateLayout.items.length) {
                        for (var i = 0; i < dateLayout.items.length; i++) {
                            var item = dateLayout.items[i];
                            if (item.type == 'date') {
                                dateFormats.push({type: item.type, format: item.format});
                            }
                        }
                    }
                    var weekFormats = [];
                    var weekLayout = vm.widget.weekLayout || {};
                    if (weekLayout.items && weekLayout.items.length) {
                        for (var i = 0; i < weekLayout.items.length; i++) {
                            var item = weekLayout.items[i];
                            if (item.type == 'week') {
                                weekFormats.push({type: item.type, format: item.format});
                            }
                        }
                    }

                    req.dateFormats = dateFormats;
                    req.weekFormats = weekFormats;
                    CalendarService.queryMonthTable(req, function (res) {
                        var _heads = [];
                        for(var i=0; i<displayType(vm.widget.displayType)/7; i++){
                            res.data.heads.forEach(function (item) {
                                _heads.push(item)
                            })
                        }
                        res.data.heads = _heads;
                        vm.widget.obj = res.data || null;
                        onCellSizeChange(function () {
                            if(callback){callback()}
                        },true)
                    });
                }
            }
            var a = null;
            function reconstructTable() {
                if (!vm.widget.obj) {
                    return;
                }
                if (!vm.widget.obj.heads || !vm.widget.obj.heads.length) {
                    return;
                }
                if (!vm.widget.obj.days || !vm.widget.obj.days.length) {
                    return;
                }
                if (!vm.widget) {
                    return;
                }
                if (!vm.widget.weekConfig || !vm.widget.dateConfig) {
                    return;
                }
                var scaleW = vm.widget.ctrl.width / vm.widget.width;
                vm.data.clientWidth = vm.widget.ctrl.width;
                vm.data.clientHeight = vm.widget.ctrl.height;
                vm.data.headCellWidth = (vm.widget.weekConfig.cellWidth || 60) * scaleW;
                vm.data.headCellMargin = (vm.widget.weekConfig.margin || 0) * scaleW;
                vm.data.headCellHeight = (vm.widget.weekConfig.cellHeight || 30) * scaleW;
                vm.data.headSpacing = (vm.widget.dateConfig.headSpacing || 0) * scaleW;
                var bodyHeight = vm.widget.ctrl.height - vm.data.headCellHeight - vm.data.headSpacing;
                var scaleH = bodyHeight / vm.widget.bodyHeight;
                vm.data.dateCellWidth = (vm.widget.dateConfig.cellWidth || 60) * scaleW;
                vm.data.dateCellHeight = (vm.widget.dateConfig.cellHeight || 60) * scaleH;
                vm.data.dateCellMargin = (vm.widget.dateConfig.margin || 0) * scaleW;
                vm.data.dateCellMarginH = (vm.widget.dateConfig.margin || 0) * scaleH;
                var column = vm.widget.obj.heads.length || 7;
                vm.data.headWidth = Number(vm.data.headCellWidth) * column + vm.data.headCellMargin * (column-1);
                vm.data.bodyWidth = Number(vm.data.dateCellWidth) * column + vm.data.dateCellMargin * (column-1);

                var dayCount = vm.widget.obj.days.length;
                var cols = displayType(vm.widget.displayType);
                var rows = Math.ceil(dayCount / cols);

                vm.data.cols = cols;
                vm.data.rows = rows;
                vm.data.heads = [];
                vm.data.dates = [];

                var index = 0;
                for (var r = 0; r < rows; r++) {

                    var dateRow = [];
                    for (var c = 0; c < cols; c++) {

                        if (r == 0) {
                            var headObj = vm.widget.obj.heads[c];
                            var headSettings = findHeadSettings(c, headObj);
                            var head = {
                                width: vm.data.headCellWidth,
                                height: vm.data.headCellHeight,
                                margin: vm.data.headCellMargin,
                                obj: headObj,
                                settings: headSettings,
                                layout: vm.widget.ctrl.weekLayout
                            };
                            vm.data.heads.push(head);
                        }

                        // for dates
                        index = r * cols + c;
                        var dateObj = vm.widget.obj.days[index];
                        if(dateObj){
                            var dateSettings = findDateSettings(c, dateObj);
                            var date = {
                                width: vm.data.dateCellWidth,
                                height: vm.data.dateCellHeight,
                                margin: vm.data.dateCellMargin,
                                marginH: vm.data.dateCellMarginH,
                                obj: dateObj,
                                settings: dateSettings,
                                layout: vm.widget.ctrl.dateLayout
                            };
                            dateRow.push(date);
                        }else{
                            var date = {
                                width: vm.data.dateCellWidth,
                                height: vm.data.dateCellHeight,
                                margin: vm.data.dateCellMargin,
                                marginH: vm.data.dateCellMarginH,
                                obj: null,
                                settings: null,
                                layout: vm.widget.ctrl.dateLayout
                            };
                            dateRow.push(date);
                        }
                    }
                    vm.data.dates.push(dateRow);
                }

                vm.data.bodyHeight = vm.data.dateCellHeight * rows + vm.data.dateCellMarginH * (rows-1);
                vm.data.clientHeight = vm.data.bodyHeight + vm.data.headCellHeight + vm.data.headSpacing;
                
                if(vm.widget.geometry){
                    vm.widget.geometry.height = vm.data.clientHeight;
                }
                //判断是ios or Android
                var u = navigator.userAgent;
                var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                if(vm.thumbnail || isiOS){
                    vm.data.styles = {
                        width: vm.data.clientWidth + 'px',
                        height: vm.data.clientHeight + 'px',
                        'transform' : 'scale('+(vm.scale || 1) + ')',
                        'transform-origin' : '0px 0px',
                    };
                }else{
                    vm.data.styles = {
                        width: vm.data.clientWidth + 'px',
                        height: vm.data.clientHeight + 'px',
                        zoom:vm.scale || 1,
                        transform: 'translateZ(0)',
                    };
                }
                if (vm.widget.backgroundColor) {
                    vm.data.styles['background-color'] = vm.widget.backgroundColor;
                }
                vm.loading = true;
                if (a !== null) {
                    clearTimeout(a)
                }
                a = $timeout(function () {
                    vm.loading = false;
                },500)
            }

            function findHeadSettings (indexOfWeek, headObj) {
                var styleUuid;

                if (vm.widget && vm.widget.weekConfig) {
                    var w = indexOfWeek;
                    if (vm.widget.startOfWeek == 1) {
                        // 每周从周一开始
                        w += 1;
                    }
                    else if (indexOfWeek == 0) {
                        // 周日
                        w = 7;
                    }
                    w = w - Math.trunc((w-1)/7)*7;
                    styleUuid = vm.widget.weekConfig["w" + w];
                }
                if (!styleUuid) {
                    styleUuid = "default";
                }
                var defaultStyle;
                if (vm.widget.weekStyles && vm.widget.weekStyles.length) {
                    for (var i = 0; i < vm.widget.weekStyles.length; i++) {
                        var style = vm.widget.weekStyles[i];
                        if (style.defaultStyle) {
                            defaultStyle = style;
                            if ("default" == styleUuid) {
                                return style;
                            }
                        }
                        if (style.uuid == styleUuid) {
                            return style;
                        }
                    }
                    if (!defaultStyle) {
                        defaultStyle = vm.widget.weekStyles[0];
                    }
                }
                if (defaultStyle) {
                    return defaultStyle;
                }
                return { debug: true};
            }
            function findDateSettings (indexOfWeek, dateObj) {
                var others = false;
                if (dateObj.year != vm.widget.obj.year || dateObj.month != vm.widget.obj.month) {
                    others = true;
                }
                var styleUuid;
                if (vm.widget && vm.widget.dateConfig) {
                    if (others) {
                        styleUuid = vm.widget.dateConfig.others;
                    } else {
                        var w = indexOfWeek;
                        if (vm.widget.startOfWeek == 1) {
                            // 每周从周一开始
                            w += 1;
                        }
                        else if (indexOfWeek == 0) {
                            // 周日
                            w = 7;
                        }
                        w = w - Math.trunc((w-1)/7)*7;
                        styleUuid = vm.widget.dateConfig["w" + w];
                    }
                }
                if (!styleUuid) {
                    styleUuid = "default";
                }
                if(dateObj.holiday && !others && dateObj.dayOfWeek!=7 && dateObj.dayOfWeek!=6){
                    styleUuid = vm.widget.dateConfig.holiday;
                }
                var defaultStyle;
                if (vm.widget.dateStyles && vm.widget.dateStyles.length) {
                    for (var i = 0; i < vm.widget.dateStyles.length; i++) {
                        var style = vm.widget.dateStyles[i];
                        if (style.defaultStyle) {
                            if ("default" == styleUuid) {
                                defaultStyle = angular.copy(style);
                                break
                            }
                        }
                        if (style.uuid == styleUuid) {
                            defaultStyle = angular.copy(style);
                            break
                        }
                    }
                    if (!defaultStyle) {
                        defaultStyle = angular.copy(vm.widget.dateStyles[0]);
                    }
                }
                if (defaultStyle) {
                    defaultStyle.showOthers = true;
                    if(others){
                        defaultStyle.showOthers = vm.widget.showOthers;
                    }
                    if(!others && (dateObj.dayOfWeek==7 || dateObj.dayOfWeek==6) && dateObj.holiday){
                        var lunarStyle=null;
                        for (var i = 0; i < vm.widget.dateStyles.length; i++) {
                            var style = vm.widget.dateStyles[i];
                            if (style.uuid == vm.widget.dateConfig.holiday) {
                                style.items.forEach(function(item){
                                    if(item.name == '农历日'){
                                        lunarStyle = angular.copy(item);
                                    }
                                })
                                break
                            }
                        }
                        if(lunarStyle){
                            defaultStyle.items.forEach(function(item,index){
                                if(item.name == '农历日'){
                                    defaultStyle.items[index] = angular.copy(lunarStyle);
                                }
                            })
                        }
                    }
                    return angular.copy(defaultStyle);
                }
                return { debug: true};
            }

            function orMockWeekLayout(layout) {
                if (layout) {
                    return layout;
                }
                else {
                    var l = {
                        type: "WEEK",
                        width: 100,
                        height: 50,
                        items: [{
                            type: "week",
                            format: "$cnWeek",
                            value: "星期日",
                            textSize: 18,
                            textFont: '',
                            textColor: '#000000',
                            textWeight: 500,
                            x: 5,
                            y: 10,
                            w: 90,
                            h: 30
                        }]
                    };
                    return l;
                }
            }
            function orMockDateLayout(layout) {
                if (layout) {
                    return layout;
                }
                else {
                    var l = {
                        type: "DATE",
                        width: 100,
                        height: 100,
                        items: [{
                            type: "date",
                            format: "$dd",
                            value: "01",
                            textSize: 18,
                            textFont: '',
                            textColor: '#ff0000',
                            textWeight: 500,
                            x: 5,
                            y: 15,
                            w: 90,
                            h: 40
                        }]
                    };
                    return l;
                }
            }

        }]
    };
    angular.module('editorApp')
        .component('monthTable', monthTableControl);

})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .controller('MattingModalController', MattingModalController);

    MattingModalController.$inject = ['$uibModalInstance', 'entity', '$timeout', 'ImageService', 'QiniuToken', 'MessageService'];

    function MattingModalController($uibModalInstance, entity, $timeout, ImageService, QiniuToken, MessageService) {
        var vm = this;
        vm.token = '';
        QiniuToken.get('get', {}, function (token) {
            vm.token = token;
        });
        vm.domain = localStorage.getItem('editor-domain');
        var CONFIG = {
            MASK_GREEN: { r: 16, g: 141, b: 254 },
            MAX_HISTORY: 20,
            MIN_ZOOM: 0.3, MAX_ZOOM: 5, ZOOM_STEP: 0.08,
            MAX_UPLOAD_BYTES: 20 * 1024 * 1024,
        };

        // ==================== UI 绑定属性 ====================
        vm.brushSize = 20;
        vm.hardness = 80;
        vm.opacity = 100;
        vm.toolMode = 'repair';
        vm.panMode = false;
        vm.zoomPercent = '100%';
        vm.undoEnabled = false;
        vm.redoEnabled = false;
        vm.brushHintVisible = false;

        // ==================== 内部状态 ====================
        var state = {
            isDrawing: false,
            history: [], historyIndex: -1,
            displayW: 0, displayH: 0,
            originalImg: null, maskImg: null,
            initialMask: null,
            zoom: 1, panX: 0, panY: 0,
            isPanning: false, panStart: null, panScreenStart: null,
            spaceHeld: false,
            isPinching: false, pinchStartDist: 0, pinchLastMid: null,
            activeSide: 'left',
        };

        // DOM 引用
        var imageCanvas, imageCtx, overlayCanvas, overlayCtx;
        var effectCanvas, effectCtx, effectOverlay, effectOverlayCtx;
        var brushCursorL, brushCursorR;
        var wrapperL, wrapperR, canvasContainer, loadingOverlay;
        var maskCanvas, maskCtx;
        var strokeCanvas, strokeCtx, strokeBaseCanvas, strokeBaseCtx, strokeAlphaData;
        var effectPatchCanvas, effectPatchCtx;
        var canvasFloats;
        var brushTipCache = null, brushTipCacheKey = '';
        var cursorHideTimer = null;
        var hintTimer = null;
        var undoRedoDigestTimer = null;

        // ==================== 公开方法 ====================
        vm.close = function() { $uibModalInstance.close('cancel'); };

        vm.confirm = function() {
            if (!maskCanvas) { $uibModalInstance.close(null); return; }
            try {
                var w = maskCanvas.width, h = maskCanvas.height;
                var result = document.createElement('canvas');
                result.width = w; result.height = h;
                var rCtx = result.getContext('2d');
                rCtx.drawImage(imageCanvas, 0, 0);
                rCtx.globalCompositeOperation = 'destination-in';
                rCtx.drawImage(maskCanvas, 0, 0);
                
                var file = canvasToUploadFile(result, 'matting-result.png');

                uploadMattingFiles(file, createMaskFile(), function(result) {
                    $uibModalInstance.close(result);
                }, function() {
                    console.error('抠图结果上传失败');
                    $uibModalInstance.dismiss('error');
                });
            } catch (error) {
                console.error('抠图结果生成失败:', error);
                $uibModalInstance.dismiss('error');
            }
        };

        
        
        function createMaskFile() {
            var w = maskCanvas.width, h = maskCanvas.height;
            var maskExport = document.createElement('canvas');
            maskExport.width = w; maskExport.height = h;
            var exportCtx = maskExport.getContext('2d', { willReadFrequently: true });
            var maskData = maskCtx.getImageData(0, 0, w, h);
            var out = exportCtx.createImageData(w, h);
            for (var i = 0; i < maskData.data.length; i += 4) {
                var alpha = maskData.data[i + 3];
                var gray = alpha === 0 ? 0 : (alpha === 255 ? 255 : Math.round(30 + alpha * 180 / 255));
                out.data[i] = gray;
                out.data[i + 1] = gray;
                out.data[i + 2] = gray;
                out.data[i + 3] = 255;
            }
            exportCtx.putImageData(out, 0, 0);
            return canvasToUploadFile(maskExport, 'matting-mask.png');
        }

        function uploadMattingFiles(resultFile, maskFile, onSuccess, onError) {
            Promise.all([resultFile, maskFile]).then(function(files) {
                ImageService.backendUploadPics(files[0], vm.domain, vm.token, function(resultData) {
                    var resultUrl = vm.domain + resultData.key;
                    ImageService.backendUploadPics(files[1], vm.domain, vm.token, function(maskData) {
                        onSuccess({
                            url: resultUrl,
                            maskUrl: vm.domain + maskData.key
                        });
                    }, onError);
                }, onError);
            }).catch(onError);
        }

        function canvasToUploadFile(canvas, filename) {
            return canvasToBlob(canvas, filename).then(function(blob) {
                if (blob.size <= CONFIG.MAX_UPLOAD_BYTES) {
                    return blobToFile(blob, filename);
                }
                return compressCanvasToFile(canvas, filename, blob);
            });
        }

        function compressCanvasToFile(sourceCanvas, filename, sourceBlob) {
            var currentCanvas = sourceCanvas;
            function compress(blob) {
                if (blob.size <= CONFIG.MAX_UPLOAD_BYTES || currentCanvas.width <= 1 || currentCanvas.height <= 1) {
                    return blobToFile(blob, filename);
                }
                var scale = Math.sqrt(CONFIG.MAX_UPLOAD_BYTES / blob.size) * 0.92;
                scale = Math.max(0.1, Math.min(0.92, scale));
                var nextW = Math.max(1, Math.floor(currentCanvas.width * scale));
                var nextH = Math.max(1, Math.floor(currentCanvas.height * scale));
                if (nextW === currentCanvas.width && nextW > 1) nextW--;
                if (nextH === currentCanvas.height && nextH > 1) nextH--;

                var nextCanvas = document.createElement('canvas');
                nextCanvas.width = nextW;
                nextCanvas.height = nextH;
                nextCanvas.getContext('2d').drawImage(currentCanvas, 0, 0, nextW, nextH);
                currentCanvas = nextCanvas;
                return canvasToBlob(currentCanvas, filename).then(compress);
            }
            return compress(sourceBlob);
        }

        function canvasToBlob(canvas, filename) {
            return new Promise(function(resolve, reject) {
                if (canvas.toBlob) {
                    canvas.toBlob(function(blob) {
                        if (blob) resolve(blob);
                        else reject(new Error('canvas toBlob failed'));
                    }, 'image/png');
                    return;
                }
                try {
                    resolve(dataURLtoFile(canvas.toDataURL('image/png'), filename));
                } catch (error) {
                    reject(error);
                }
            });
        }

        function blobToFile(blob, filename) {
            return new File([blob], filename, { type: blob.type || 'image/png' });
        }

        function dataURLtoFile(dataurl, filename) {
            var arr = dataurl.split(','),
                mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]), 
                n = bstr.length, 
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
        }

        vm.setToolMode = function(mode) {
            vm.toolMode = mode;
        };

        vm.togglePanMode = function() {
            vm.panMode = !vm.panMode;
            if (vm.panMode) {
                stopDrawing();
                overlayCanvas.style.cursor = 'grab';
                effectOverlay.style.cursor = 'grab';
                brushCursorL.style.display = 'none';
                brushCursorR.style.display = 'none';
            } else {
                overlayCanvas.style.cursor = 'none';
                effectOverlay.style.cursor = 'none';
                brushCursorL.style.display = 'block';
                brushCursorR.style.display = 'block';
            }
        };

        vm.undo = function() { undo(); };
        vm.redo = function() { redo(); };
        vm.resetMask = function() { resetMask(); };

        vm.zoomIn = function() {
            var rect = wrapperL.getBoundingClientRect();
            zoomAtPoint(rect.left + rect.width / 2, rect.top + rect.height / 2, state.zoom + CONFIG.ZOOM_STEP);
        };
        vm.zoomOut = function() {
            var rect = wrapperL.getBoundingClientRect();
            zoomAtPoint(rect.left + rect.width / 2, rect.top + rect.height / 2, state.zoom - CONFIG.ZOOM_STEP);
        };
        vm.zoomReset = function() {
            state.zoom = 1; state.panX = 0; state.panY = 0;
            invalidateBrushCache(); updateTransform();
            vm.zoomPercent = '100%';
            updateBrushCursor();
        };

        function buildSliderBg(val, min, max) {
            var pct = (val - min) / (max - min) * 100;
            return 'linear-gradient(to right, #BABDC0 0%, #BABDC0 ' + pct + '%, #EAECF1 ' + pct + '%, #EAECF1 100%)';
        }

        vm.brushSizeBg = buildSliderBg(vm.brushSize, 1, 100);
        vm.hardnessBg = buildSliderBg(vm.hardness, 0, 100);
        vm.opacityBg = buildSliderBg(vm.opacity, 10, 100);

        vm.onBrushSizeChange = function() {
            vm.brushSizeBg = buildSliderBg(vm.brushSize, 1, 100);
            invalidateBrushCache(); showBrushSizeHint();
        };
        vm.onHardnessChange = function() {
            vm.hardnessBg = buildSliderBg(vm.hardness, 0, 100);
            invalidateBrushCache();
        };
        vm.onOpacityChange = function() {
            vm.opacityBg = buildSliderBg(vm.opacity, 10, 100);
        };

        // ==================== 初始化 ====================
        function init() {
            imageCanvas = document.getElementById('mattingImageCanvas');
            imageCtx = imageCanvas.getContext('2d');
            overlayCanvas = document.getElementById('mattingOverlayCanvas');
            overlayCtx = overlayCanvas.getContext('2d');
            effectCanvas = document.getElementById('mattingEffectCanvas');
            effectCtx = effectCanvas.getContext('2d');
            effectOverlay = document.getElementById('mattingEffectOverlay');
            effectOverlayCtx = effectOverlay.getContext('2d');

            brushCursorL = document.getElementById('mattingBrushCursorLeft');
            brushCursorR = document.getElementById('mattingBrushCursorRight');
            wrapperL = document.getElementById('mattingCanvasWrapperLeft');
            wrapperR = document.getElementById('mattingCanvasWrapperRight');
            canvasContainer = document.getElementById('mattingCanvasContainer');
            loadingOverlay = document.getElementById('mattingLoadingOverlay');
            canvasFloats = document.querySelectorAll('.matting-zoom, .matting-panel-label');

            setupEvents();
            updateBrushCursor();
            brushCursorL.style.display = 'none';
            brushCursorR.style.display = 'none';
            loadImages();
        }

        // ==================== 图片加载 ====================
        function loadImage(src) {
            return new Promise(function(resolve, reject) {
                var img = new Image();
                img.crossOrigin = 'anonymous';
                img.onload = function() { resolve(img); };
                img.onerror = reject;
                img.src = src;
            });
        }

        function initMaskFromImage(maskImg) {
            var w = maskCanvas.width, h = maskCanvas.height;
            var tmp = document.createElement('canvas');
            tmp.width = w; tmp.height = h;
            var tCtx = tmp.getContext('2d', { willReadFrequently: true });
            tCtx.drawImage(maskImg, 0, 0, w, h);
            var data = tCtx.getImageData(0, 0, w, h).data;
            var out = maskCtx.createImageData(w, h);
            for (var i = 0; i < data.length; i += 4) {
                var bright = (data[i] + data[i + 1] + data[i + 2]) / 3;
                out.data[i] = CONFIG.MASK_GREEN.r;
                out.data[i + 1] = CONFIG.MASK_GREEN.g;
                out.data[i + 2] = CONFIG.MASK_GREEN.b;
                if (bright < 30) out.data[i + 3] = 0;
                else if (bright > 210) out.data[i + 3] = 255;
                else out.data[i + 3] = Math.floor(255 * (bright - 30) / 180);
            }
            maskCtx.putImageData(out, 0, 0);
        }

        function loadImages() {
            Promise.all([
                loadImage(entity.originalImage),
                loadImage(entity.maskImage)
            ]).then(function(results) {
                var orig = results[0], mask = results[1];
                state.originalImg = orig; state.maskImg = mask;

                var cr = canvasContainer.getBoundingClientRect();
                var panelW = (cr.width - 16 - 4) / 2;
                var panelH = cr.height - 40;
                var aspect = orig.width / orig.height;
                var dW, dH;
                if (panelW / panelH > aspect) { dH = panelH; dW = dH * aspect; }
                else { dW = panelW; dH = dW / aspect; }
                state.displayW = dW; state.displayH = dH;

                maskCanvas = document.createElement('canvas');
                maskCanvas.width = orig.width;
                maskCanvas.height = orig.height;
                maskCtx = maskCanvas.getContext('2d', { willReadFrequently: true });

                [imageCanvas, effectCanvas, overlayCanvas, effectOverlay].forEach(function(c) {
                    c.width = orig.width;
                    c.height = orig.height;
                });

                var sizeCss = [imageCanvas, effectCanvas, overlayCanvas, effectOverlay];
                sizeCss.forEach(function(c) {
                    c.style.width = dW + 'px';
                    c.style.height = dH + 'px';
                });

                imageCtx.drawImage(orig, 0, 0);
                initMaskFromImage(mask);
                state.initialMask = document.createElement('canvas');
                state.initialMask.width = maskCanvas.width;
                state.initialMask.height = maskCanvas.height;
                state.initialMask.getContext('2d').drawImage(maskCanvas, 0, 0);
                renderBoth();
                pushHistory();
                loadingOverlay.style.display = 'none';
            }).catch(function(err) {
                loadingOverlay.innerHTML = '<span>加载失败，请刷新重试</span>';
                console.error(err);
            });
        }

        // ==================== 渲染 ====================
        function isCanvasReady() {
            return !!(maskCanvas && maskCtx && imageCanvas && overlayCanvas && effectCanvas && effectOverlay);
        }

        function renderBoth() {
            if (!isCanvasReady()) return;
            overlayCtx.clearRect(0, 0, overlayCanvas.width, overlayCanvas.height);
            overlayCtx.drawImage(maskCanvas, 0, 0);
            imageCanvas.style.visibility = 'visible';
            overlayCanvas.style.opacity = '0.5';
            overlayCanvas.style.display = 'block';

            var w = effectCanvas.width, h = effectCanvas.height;
            effectCtx.clearRect(0, 0, w, h);
            effectCtx.drawImage(imageCanvas, 0, 0);
            effectCtx.globalCompositeOperation = 'destination-in';
            effectCtx.drawImage(maskCanvas, 0, 0);
            effectCtx.globalCompositeOperation = 'source-over';

            effectOverlayCtx.clearRect(0, 0, w, h);
            effectOverlay.style.opacity = '1';
            effectOverlay.style.display = 'block';
        }

        // ==================== 画笔缓存 ====================
        function invalidateBrushCache() { brushTipCacheKey = ''; }

        function getBrushTip() {
            if (!isCanvasReady()) return null;
            var ratio = maskCanvas.width / state.displayW / state.zoom;
            var brushRadius = Math.max(1, vm.brushSize / 2 * ratio);
            var hardness = vm.hardness / 100;
            var innerR = brushRadius * hardness;
            var outerR = Math.max(brushRadius, innerR + 1);
            var size = Math.ceil(outerR * 2);
            var key = brushRadius.toFixed(2) + '|' + hardness.toFixed(2);

            if (brushTipCacheKey === key && brushTipCache) return { tip: brushTipCache, innerR: innerR, outerR: outerR };

            brushTipCacheKey = key;
            if (!brushTipCache || brushTipCache.width !== size || brushTipCache.height !== size) {
                brushTipCache = document.createElement('canvas');
                brushTipCache.width = size; brushTipCache.height = size;
            }
            var tctx = brushTipCache.getContext('2d');
            tctx.clearRect(0, 0, brushTipCache.width, brushTipCache.height);
            var cx = outerR, cy = outerR;
            var mc = CONFIG.MASK_GREEN;
            var solidColor = 'rgb(' + mc.r + ',' + mc.g + ',' + mc.b + ')';
            var fadeColor = 'rgba(' + mc.r + ',' + mc.g + ',' + mc.b + ',0)';
            if (innerR >= outerR - 0.5) {
                tctx.fillStyle = solidColor;
                tctx.beginPath(); tctx.arc(cx, cy, brushRadius, 0, Math.PI * 2); tctx.fill();
            } else {
                var grad = tctx.createRadialGradient(cx, cy, innerR, cx, cy, outerR);
                grad.addColorStop(0, solidColor);
                grad.addColorStop(1, fadeColor);
                tctx.fillStyle = grad;
                tctx.beginPath(); tctx.arc(cx, cy, outerR, 0, Math.PI * 2); tctx.fill();
            }
            return { tip: brushTipCache, innerR: innerR, outerR: outerR };
        }

        // ==================== 坐标 ====================
        function updateTransform() {
            var t = 'scale(' + state.zoom + ') translate(' + state.panX + 'px, ' + state.panY + 'px)';
            wrapperL.style.transformOrigin = '0 0';
            wrapperL.style.transform = t;
            wrapperR.style.transformOrigin = '0 0';
            wrapperR.style.transform = t;
        }

        function zoomAtPoint(clientX, clientY, newZoom) {
            newZoom = Math.max(CONFIG.MIN_ZOOM, Math.min(CONFIG.MAX_ZOOM, newZoom));
            var lPanelRect = document.getElementById('mattingLeftPanel').getBoundingClientRect();
            var isOverRight = clientX > lPanelRect.right;
            var rect = isOverRight ? wrapperR.getBoundingClientRect() : wrapperL.getBoundingClientRect();
            var lx = (clientX - rect.left) / state.zoom;
            var ly = (clientY - rect.top) / state.zoom;
            state.panX = (lx + state.panX) * state.zoom / newZoom - lx;
            state.panY = (ly + state.panY) * state.zoom / newZoom - ly;
            state.zoom = newZoom;
            invalidateBrushCache();
            updateTransform();
            vm.zoomPercent = Math.round(state.zoom * 100) + '%';
            updateBrushCursor({ clientX: clientX, clientY: clientY });
        }

        function getCanvasPos(e, wrapper) {
            if (!isCanvasReady()) return null;
            var rect = wrapper.getBoundingClientRect();
            var clientX = e.touches ? e.touches[0].clientX : e.clientX;
            var clientY = e.touches ? e.touches[0].clientY : e.clientY;
            var ratio = maskCanvas.width / state.displayW;
            return {
                x: (clientX - rect.left) / state.zoom * ratio,
                y: (clientY - rect.top) / state.zoom * ratio,
            };
        }

        // ==================== 历史 ====================
        function pushHistory() {
            if (!isCanvasReady()) return;
            state.history.length = state.historyIndex + 1;
            var snap = document.createElement('canvas');
            snap.width = maskCanvas.width; snap.height = maskCanvas.height;
            snap.getContext('2d').drawImage(maskCanvas, 0, 0);
            state.history.push(snap);
            if (state.history.length > CONFIG.MAX_HISTORY) { state.history.shift(); }
            else { state.historyIndex = state.history.length - 1; }
            updateUndoRedoState();
        }

        function undo() {
            if (state.historyIndex <= 0) return;
            state.historyIndex--;
            restoreMaskFromHistory();
        }
        function redo() {
            if (state.historyIndex >= state.history.length - 1) return;
            state.historyIndex++;
            restoreMaskFromHistory();
        }
        function restoreMaskFromHistory() {
            maskCtx.clearRect(0, 0, maskCanvas.width, maskCanvas.height);
            maskCtx.drawImage(state.history[state.historyIndex], 0, 0);
            updateUndoRedoState();
            renderBoth();
        }
        function resetMask() {
            if (!state.initialMask) return;
            maskCtx.clearRect(0, 0, maskCanvas.width, maskCanvas.height);
            maskCtx.drawImage(state.initialMask, 0, 0);
            pushHistory();
            renderBoth();
            vm.zoomReset();
            MessageService.success('已重置');
        }
        function updateUndoRedoState() {
            vm.undoEnabled = state.historyIndex > 0;
            vm.redoEnabled = state.historyIndex < state.history.length - 1;
            scheduleUndoRedoDigest();
        }

        function scheduleUndoRedoDigest() {
            if (undoRedoDigestTimer) return;
            undoRedoDigestTimer = $timeout(function() {
                undoRedoDigestTimer = null;
            }, 0);
        }

        // ==================== 绘画 ====================
        function ensureStrokeCanvases() {
            if (!isCanvasReady()) return;
            if (strokeCanvas && strokeCanvas.width === maskCanvas.width && strokeCanvas.height === maskCanvas.height && strokeAlphaData) return;
            strokeCanvas = document.createElement('canvas');
            strokeCanvas.width = maskCanvas.width;
            strokeCanvas.height = maskCanvas.height;
            strokeCtx = strokeCanvas.getContext('2d');
            strokeAlphaData = new Uint8ClampedArray(maskCanvas.width * maskCanvas.height);

            strokeBaseCanvas = document.createElement('canvas');
            strokeBaseCanvas.width = maskCanvas.width;
            strokeBaseCanvas.height = maskCanvas.height;
            strokeBaseCtx = strokeBaseCanvas.getContext('2d');
        }

        function beginStroke() {
            ensureStrokeCanvases();
            if (!strokeCanvas || !strokeBaseCanvas) return;
            strokeBaseCtx.clearRect(0, 0, strokeBaseCanvas.width, strokeBaseCanvas.height);
            strokeBaseCtx.drawImage(maskCanvas, 0, 0);
            strokeCtx.clearRect(0, 0, strokeCanvas.width, strokeCanvas.height);
            strokeAlphaData.fill(0);
            strokeDirtyRect = null;
        }

        function getBrushPixelAlpha(distance, td) {
            if (distance <= td.innerR) return 255;
            if (distance >= td.outerR) return 0;
            return Math.round(255 * (1 - (distance - td.innerR) / (td.outerR - td.innerR)));
        }

        function drawBrushStamp(x, y, td) {
            td = td || getBrushTip();
            if (!td || !strokeAlphaData) return;
            var x1 = Math.max(0, Math.floor(x - td.outerR));
            var y1 = Math.max(0, Math.floor(y - td.outerR));
            var x2 = Math.min(strokeCanvas.width, Math.ceil(x + td.outerR));
            var y2 = Math.min(strokeCanvas.height, Math.ceil(y + td.outerR));
            for (var py = y1; py < y2; py++) {
                for (var px = x1; px < x2; px++) {
                    var dx = px + 0.5 - x;
                    var dy = py + 0.5 - y;
                    var distance = Math.sqrt(dx * dx + dy * dy);
                    var alpha = getBrushPixelAlpha(distance, td);
                    if (!alpha) continue;
                    var index = py * strokeCanvas.width + px;
                    if (alpha > strokeAlphaData[index]) strokeAlphaData[index] = alpha;
                }
            }
            addStrokeDirtyRect(x, y, td.outerR);
        }

        function syncStrokeCanvasRect(rect) {
            if (!strokeAlphaData || !strokeCtx) return;
            var imageData = strokeCtx.createImageData(rect.w, rect.h);
            var data = imageData.data;
            var mc = CONFIG.MASK_GREEN;
            var di = 0;
            for (var y = 0; y < rect.h; y++) {
                var si = (rect.y + y) * strokeCanvas.width + rect.x;
                for (var x = 0; x < rect.w; x++, si++, di += 4) {
                    var alpha = strokeAlphaData[si];
                    data[di] = mc.r;
                    data[di + 1] = mc.g;
                    data[di + 2] = mc.b;
                    data[di + 3] = alpha;
                }
            }
            strokeCtx.putImageData(imageData, rect.x, rect.y);
        }

        function ensureEffectPatchCanvas(w, h) {
            if (!effectPatchCanvas) {
                effectPatchCanvas = document.createElement('canvas');
                effectPatchCtx = effectPatchCanvas.getContext('2d');
            }
            if (effectPatchCanvas.width < w) effectPatchCanvas.width = w;
            if (effectPatchCanvas.height < h) effectPatchCanvas.height = h;
        }

        function renderEffectRect(rect) {
            ensureEffectPatchCanvas(rect.w, rect.h);
            effectPatchCtx.clearRect(0, 0, rect.w, rect.h);
            effectPatchCtx.save();
            effectPatchCtx.globalCompositeOperation = 'source-over';
            effectPatchCtx.drawImage(imageCanvas, rect.x, rect.y, rect.w, rect.h, 0, 0, rect.w, rect.h);
            effectPatchCtx.globalCompositeOperation = 'destination-in';
            effectPatchCtx.drawImage(maskCanvas, rect.x, rect.y, rect.w, rect.h, 0, 0, rect.w, rect.h);
            effectPatchCtx.restore();

            effectCtx.clearRect(rect.x, rect.y, rect.w, rect.h);
            effectCtx.drawImage(effectPatchCanvas, 0, 0, rect.w, rect.h, rect.x, rect.y, rect.w, rect.h);
        }

        function renderStrokeToMask() {
            if (!isCanvasReady() || !strokeCanvas || !strokeBaseCanvas || !strokeDirtyRect) return;
            var rect = {
                x: strokeDirtyRect.x,
                y: strokeDirtyRect.y,
                w: strokeDirtyRect.x2 - strokeDirtyRect.x,
                h: strokeDirtyRect.y2 - strokeDirtyRect.y
            };
            strokeDirtyRect = null;
            syncStrokeCanvasRect(rect);

            maskCtx.clearRect(rect.x, rect.y, rect.w, rect.h);
            maskCtx.drawImage(strokeBaseCanvas, rect.x, rect.y, rect.w, rect.h, rect.x, rect.y, rect.w, rect.h);
            maskCtx.save();
            maskCtx.globalAlpha = vm.opacity / 100;
            if (vm.toolMode === 'erase') maskCtx.globalCompositeOperation = 'destination-out';
            maskCtx.drawImage(strokeCanvas, rect.x, rect.y, rect.w, rect.h, rect.x, rect.y, rect.w, rect.h);
            maskCtx.restore();

            if (state.activeSide === 'right') {
                effectOverlayCtx.clearRect(rect.x, rect.y, rect.w, rect.h);
                renderEffectRect(rect);
            } else {
                overlayCtx.clearRect(rect.x, rect.y, rect.w, rect.h);
                overlayCtx.drawImage(maskCanvas, rect.x, rect.y, rect.w, rect.h, rect.x, rect.y, rect.w, rect.h);
            }
        }

        function drawBrushAt(x, y, td) {
            drawBrushStamp(x, y, td);
        }

        function getBrushStampSpacing(td) {
            if (!td || !maskCanvas || !state.displayW) return 3;
            var imagePxPerScreenPx = maskCanvas.width / state.displayW / state.zoom;
            var screenGap = Math.max(1.5, Math.min(3, vm.brushSize * 0.1));
            return Math.max(1, Math.min(td.outerR * 0.25, screenGap * imagePxPerScreenPx));
        }

        function drawLine(from, to) {
            var dx = to.x - from.x, dy = to.y - from.y;
            var dist = Math.sqrt(dx * dx + dy * dy);
            var td = getBrushTip();
            if (dist === 0) { drawBrushAt(from.x, from.y, td); return; }
            var spacing = getBrushStampSpacing(td);
            var steps = Math.ceil(dist / spacing);
            for (var i = 0; i <= steps; i++) {
                var t = i / steps;
                drawBrushAt(from.x + dx * t, from.y + dy * t, td);
            }
        }

        var pendingRafPos = null, lastRafDrawnPos = null, rafDrawId = null;
        var strokeDirtyRect = null;
        var lastDrawFrameTime = 0;

        function addStrokeDirtyRect(x, y, radius) {
            if (!isCanvasReady()) return;
            var x1 = Math.max(0, Math.floor(x - radius - 1));
            var y1 = Math.max(0, Math.floor(y - radius - 1));
            var x2 = Math.min(maskCanvas.width, Math.ceil(x + radius + 1));
            var y2 = Math.min(maskCanvas.height, Math.ceil(y + radius + 1));
            if (x2 <= x1 || y2 <= y1) return;
            if (!strokeDirtyRect) {
                strokeDirtyRect = { x: x1, y: y1, x2: x2, y2: y2 };
                return;
            }
            strokeDirtyRect.x = Math.min(strokeDirtyRect.x, x1);
            strokeDirtyRect.y = Math.min(strokeDirtyRect.y, y1);
            strokeDirtyRect.x2 = Math.max(strokeDirtyRect.x2, x2);
            strokeDirtyRect.y2 = Math.max(strokeDirtyRect.y2, y2);
        }

        function flushRafDraw(frameTime) {
            rafDrawId = null;
            if (!state.isDrawing || !pendingRafPos) return;
            frameTime = frameTime || Date.now();
            if (lastDrawFrameTime && frameTime - lastDrawFrameTime < 24) {
                rafDrawId = requestAnimationFrame(flushRafDraw);
                return;
            }
            lastDrawFrameTime = frameTime;
            var target = pendingRafPos;
            pendingRafPos = null;
            if (lastRafDrawnPos) { drawLine(lastRafDrawnPos, target); }
            else { drawBrushAt(target.x, target.y); }
            renderStrokeToMask();
            lastRafDrawnPos = target;
        }

        function scheduleDraw(pos) {
            if (!state.isDrawing || !pos) return;
            pendingRafPos = pos;
            if (!rafDrawId) rafDrawId = requestAnimationFrame(flushRafDraw);
        }

        function startDrawing(e, wrapper) {
            if (!isCanvasReady()) return;
            state.isDrawing = true;
            state.activeSide = (wrapper === wrapperL) ? 'left' : 'right';
            beginStroke();
            lastDrawFrameTime = 0;
            var pos = getCanvasPos(e, wrapper);
            if (!pos) {
                state.isDrawing = false;
                return;
            }
            lastRafDrawnPos = pos;
            pendingRafPos = null;
            canvasFloats.forEach(function(el) { el.classList.add('matting-float-hidden'); });
            scheduleDraw(pos);
        }

        function stopDrawing() {
            var hadDrawing = state.isDrawing || rafDrawId || pendingRafPos || lastRafDrawnPos;
            if (rafDrawId) {
                cancelAnimationFrame(rafDrawId);
                rafDrawId = null;
                if (pendingRafPos && lastRafDrawnPos) {
                    drawLine(lastRafDrawnPos, pendingRafPos);
                    renderStrokeToMask();
                }
            }
            state.isDrawing = false;
            pendingRafPos = null; lastRafDrawnPos = null;
            strokeDirtyRect = null;
            lastDrawFrameTime = 0;
            if (hadDrawing) {
                renderBoth();
                pushHistory();
            }
            canvasFloats.forEach(function(el) { el.classList.remove('matting-float-hidden'); });
        }

        // ==================== 光标 ====================
        var lastMouseX = -1, lastMouseY = -1;

        function updateBrushCursor(e) {
            var cx, cy;
            if (e) {
                cx = e.touches ? e.touches[0].clientX : e.clientX;
                cy = e.touches ? e.touches[0].clientY : e.clientY;
                lastMouseX = cx; lastMouseY = cy;
            } else if (lastMouseX >= 0) {
                cx = lastMouseX; cy = lastMouseY;
            } else { return; }

            var lPanelRect = document.getElementById('mattingLeftPanel').getBoundingClientRect();
            var lRect = wrapperL.getBoundingClientRect();
            var rRect = wrapperR.getBoundingClientRect();

            [brushCursorL, brushCursorR].forEach(function(c) {
                var rect = (c === brushCursorR) ? rRect : lRect;
                c.style.left = ((cx - rect.left) / state.zoom) + 'px';
                c.style.top = ((cy - rect.top) / state.zoom) + 'px';
                var cs = vm.brushSize / state.zoom;
                c.style.width = cs + 'px'; c.style.height = cs + 'px';
            });

            if (!vm.panMode && !state.spaceHeld) {
                brushCursorL.style.display = 'block';
                brushCursorR.style.display = 'block';
            }
        }

        function showBrushSizeHint() {
            vm.brushHintVisible = true;
            if (hintTimer) $timeout.cancel(hintTimer);
            hintTimer = $timeout(function() {
                vm.brushHintVisible = false;
            }, 800);
        }

        // ==================== 事件绑定 ====================
        function setupEvents() {
            canvasContainer.addEventListener('wheel', function(e) {
                e.preventDefault();
                var d = e.deltaY > 0 ? -CONFIG.ZOOM_STEP : CONFIG.ZOOM_STEP;
                zoomAtPoint(e.clientX, e.clientY, state.zoom + d);
            }, { passive: false });

            bindCanvasEvents(overlayCanvas, wrapperL);
            bindCanvasEvents(effectOverlay, wrapperR);

            canvasContainer.addEventListener('mouseenter', function() {
                clearTimeout(cursorHideTimer);
                cursorHideTimer = null;
                if (!vm.panMode && !state.spaceHeld) { brushCursorL.style.display = 'block'; brushCursorR.style.display = 'block'; }
            });
            canvasContainer.addEventListener('mouseleave', function() {
                stopDrawing();
                cursorHideTimer = setTimeout(function() {
                    brushCursorL.style.display = 'none'; brushCursorR.style.display = 'none';
                }, 80);
            });

            document.addEventListener('keydown', function(e) {
                if (e.target.tagName === 'INPUT') return;
                if (e.code === 'Space' && !state.spaceHeld) {
                    e.preventDefault(); state.spaceHeld = true;
                    if (!vm.panMode) {
                        stopDrawing();
                        overlayCanvas.style.cursor = 'grab';
                        effectOverlay.style.cursor = 'grab';
                        brushCursorL.style.display = 'none';
                        brushCursorR.style.display = 'none';
                    }
                }
                if ((e.ctrlKey || e.metaKey) && e.key === 'z' && !e.shiftKey) { e.preventDefault(); undo(); }
                if ((e.ctrlKey || e.metaKey) && (e.key === 'y' || (e.key === 'z' && e.shiftKey))) { e.preventDefault(); redo(); }
            });
            document.addEventListener('keyup', function(e) {
                if (e.code === 'Space') {
                    state.spaceHeld = false; state.isPanning = false;
                    if (!vm.panMode) {
                        overlayCanvas.style.cursor = 'none';
                        effectOverlay.style.cursor = 'none';
                        brushCursorL.style.display = 'block';
                        brushCursorR.style.display = 'block';
                    }
                }
            });

            updateUndoRedoState();
        }

        function bindCanvasEvents(canvas, wrapper) {
            canvas.addEventListener('mousedown', function(e) {
                if (vm.panMode || state.spaceHeld) {
                    state.isPanning = true;
                    state.panStart = { x: state.panX, y: state.panY };
                    state.panScreenStart = { x: e.clientX, y: e.clientY };
                    canvas.style.cursor = 'grabbing';
                    brushCursorL.style.display = 'none'; brushCursorR.style.display = 'none';
                    return;
                }
                startDrawing(e, wrapper);
            });
            canvas.addEventListener('mousemove', function(e) {
                if (state.isPanning) {
                    state.panX = state.panStart.x + (e.clientX - state.panScreenStart.x) / state.zoom;
                    state.panY = state.panStart.y + (e.clientY - state.panScreenStart.y) / state.zoom;
                    updateTransform(); return;
                }
                updateBrushCursor(e);
                if (state.isDrawing) scheduleDraw(getCanvasPos(e, wrapper));
            });
            canvas.addEventListener('mouseup', function() {
                if (state.isPanning) {
                    state.isPanning = false;
                    canvas.style.cursor = (vm.panMode || state.spaceHeld) ? 'grab' : 'none';
                    if (!vm.panMode && !state.spaceHeld) { brushCursorL.style.display = 'block'; brushCursorR.style.display = 'block'; }
                    return;
                }
                stopDrawing();
            });

            canvas.addEventListener('touchstart', function(e) {
                e.preventDefault();
                if (e.touches.length >= 2) {
                    stopDrawing(); state.isPinching = true;
                    state.pinchStartDist = touchDist(e);
                    state.pinchLastMid = touchMid(e);
                    brushCursorL.style.display = 'none'; brushCursorR.style.display = 'none';
                    return;
                }
                brushCursorL.style.display = 'block'; brushCursorR.style.display = 'block';
                updateBrushCursor(e); startDrawing(e, wrapper);
            }, { passive: false });

            canvas.addEventListener('touchmove', function(e) {
                e.preventDefault();
                if (e.touches.length >= 2 && state.isPinching) {
                    var nd = touchDist(e), mid = touchMid(e);
                    zoomAtPoint(mid.x, mid.y, state.zoom * (nd / state.pinchStartDist));
                    if (state.pinchLastMid) {
                        state.panX += (mid.x - state.pinchLastMid.x) / state.zoom;
                        state.panY += (mid.y - state.pinchLastMid.y) / state.zoom;
                        updateTransform();
                    }
                    state.pinchStartDist = nd; state.pinchLastMid = mid; return;
                }
                if (e.touches.length === 1 && !state.isPinching) {
                    updateBrushCursor(e);
                    if (state.isDrawing) scheduleDraw(getCanvasPos(e, wrapper));
                }
            }, { passive: false });

            canvas.addEventListener('touchend', function(e) {
                if (e.touches.length === 0) {
                    state.isPinching = false;
                    stopDrawing();
                    brushCursorL.style.display = 'none'; brushCursorR.style.display = 'none';
                } else if (e.touches.length === 1 && state.isPinching) {
                    state.isPinching = false;
                }
            });
        }

        function touchDist(e) {
            var dx = e.touches[0].clientX - e.touches[1].clientX;
            var dy = e.touches[0].clientY - e.touches[1].clientY;
            return Math.sqrt(dx * dx + dy * dy);
        }
        function touchMid(e) {
            return {
                x: (e.touches[0].clientX + e.touches[1].clientX) / 2,
                y: (e.touches[0].clientY + e.touches[1].clientY) / 2
            };
        }

        // ==================== 启动 ====================
        $timeout(init);
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .controller('LayoutSelectController', LayoutSelectController);

    LayoutSelectController.$inject = ['$timeout', '$scope', 'MessageService', '$uibModalInstance', 'msg', 'CalendarLayout', 'Qinius', 'UidService', '$q'];

    function LayoutSelectController ($timeout, $scope, MessageService, $uibModalInstance, msg, CalendarLayout, Qinius, UidService, $q) {
        var vm = this;

        vm.type = msg.type || 'DATE';
        vm.layouts = [];
        vm.selectedId = null;
        vm.selectedLayout = null;

        vm.clear = clear;
        vm.save = save;
        vm.onLayoutSelect = onLayoutSelect;

        init();

        function init() {
        	CalendarLayout.getLayouts({type: vm.type, available: true}, function (res) {
                if (res.status == 200 && res.message && res.message.length) {
                    vm.layouts = res.message || [];
                }
            });
        }

        function onLayoutSelect(item) {
        	if (item) {
        		vm.selectedId = item.id;
        		vm.selectedLayout = item;
        	} else {
        		vm.selectedId = null;
        		vm.selectedLayout = null;
        	}
        }

        function clear() {
        	$uibModalInstance.dismiss();
        }

        function save() {
        	if (!vm.selectedLayout) {
        		MessageService.error("请选择一个布局");
        		return;
        	}
        	$uibModalInstance.close(vm.selectedLayout);
        }

    }
})();

(function () {
    'use strict';

    var FontFamilyControl = {
    	restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/components/controls/font-family.html',
        controllerAs: 'vm',
        bindings: {
            family: "=",
            onChange:'&'
        },

        controller: ['$scope', 'FontManagement', '$q', 'Qinius', function ($scope, FontManagement, $q, Qinius) {
            var vm = this;
            $scope.domains = Qinius.getDomain();
            $q.all([$scope.domains.$promise]).then(function () {
                vm.url = $scope.domains.domain;
            })
            //获取字体
            vm.fontList = [];
            vm.fontList1 = [];
            FontManagement.getAll({family: ""}, function (res) {
                vm.fontList = angular.copy(res);
                vm.fontList1 = angular.copy(vm.fontList);
            });
            $scope.selectFontName = function (item) {
                if (item) {
                    for (var i = 0; i < vm.fontList1.length; i++) {
                        if (vm.fontList1[i].uuid == item) {
                            return vm.fontList1[i].family
                        }
                    }
                }
            }
            vm.selectFont = '';
            vm.selectFontBtn = fontInit;
            var a = null;
            function fontInit() {
                if (a !== null) {
                    clearTimeout(a)
                }
                a = setTimeout(function () {
                    vm.fontList = [];
                    FontManagement.getAll({family: vm.selectFont}, function (res) {
                        vm.fontList = angular.copy(res);
                    });
                },800)
            }

            $scope.updateTextFont = function (data) {
                vm.family = data.uuid;
                vm.onChange({text: vm.family});
                getFontCSS(FontManagement, {
                    fontuuid: vm.family
                }, $scope)
            }

        }]
    };
    angular.module('editorApp')
        .component('fontFamily', FontFamilyControl);

})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .controller('EditorTipPicModalController', EditorTipPicModalController);

        EditorTipPicModalController.$inject = ['$uibModalInstance', 'entity','$localStorage'];

    function EditorTipPicModalController ($uibModalInstance, entity, $localStorage) {
        var vm = this;
        vm.url = entity.url;
        vm.dotRemindEditorTipPic = false;
        vm.save = function(){
            $localStorage.dotRemindEditorTipPic = vm.dotRemindEditorTipPic;
            $uibModalInstance.close();
        }
    }
})();

(function () {
    'use strict';

    var dateCellControl = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/components/controls/date-cell.control.html',
        controllerAs: 'vm',
        bindings: {
            obj: "<",
            layout: "<",
            settings: "<",
            width: "<",
            height: "<",
            trIndex: "<",
            tdIndex: "<",
            dateConfig: "<",
        },

        controller: ['$scope','FontManagement', function ($scope, FontManagement) {
            var vm = this;
            vm.data = {
                width: 100,
                height: 100,
                items: []
            };

            vm.$onInit = function() {
                var settings = vm.settings || {};
                constructCell(vm.layout, settings, vm.obj);

            }
            // 每當 one-way binding 更新時，changesObj 就是改變前後的差異
            vm.$onChanges = function(data) {
                if (data.settings && data.settings.currentValue) {
                    constructCell(vm.layout, vm.settings, vm.obj);
                }
                else if (data.obj && data.obj.currentValue) {
                    constructCell(vm.layout, vm.settings, vm.obj);
                }

            }
            vm.$postLink = function () {

            }
            vm.$doCheck = function() {
                // deep watch
            }
            vm.$onDestroy = function () {

            }

            function textStyleObj(obj) {
                var styles = {
                    'position': 'absolute',
                    'left': obj.x + 'px',
                    'top': obj.y + 'px',
                    'line-height': (obj.textSize > 12 ? obj.h : obj.h / (1 / 12 * obj.textSize)) + 'px',
                    'fontSize': (obj.textSize > 12 ? obj.textSize : 12) + 'px',
                    'font-family': obj.textFontUuid,
                    'color': obj.textColor,
                    'text-align': obj.textAlign || 'center',
                    'transform':'scale('+(1 / 12 * obj.textSize > 1 ? 1 : 1 / 12 * obj.textSize)+')',
                    'transform-origin': '0 0',
                    'width': obj.textSize > 12 ? obj.w : obj.w / (1 / 12 * obj.textSize) + 'px',
                    'height': obj.textSize > 12 ? obj.h : obj.h / (1 / 12 * obj.textSize) + 'px',
                };
                if (obj.textFontUuid) {
                    styles['font-family'] = obj.textFontUuid;
                }
                if (obj.textWeight) {
                    styles['font-weight'] = obj.textWeight;
                }
                if (obj.textStyle) {
                    styles['font-style'] = obj.textStyle;
                }
                if (obj.backgroundColor) {
                    styles['background-color'] = obj.backgroundColor;
                }
                if (obj.debug) {
                    styles['border'] = '1px dotted #ccc';
                }
                return styles;
            }
            function imageStyleObj(obj) {
                var styles = {
                    'position': 'absolute',
                    'left': obj.x + 'px',
                    'top': obj.y + 'px',
                    'width': obj.w + 'px',
                    'height': obj.h + 'px'
                };
                if (obj.debug) {
                    styles['border'] = '1px dotted #ccc';
                }

                return styles;
            }

            function findItemFromSettings(settings, itemName) {
                if (!settings || !settings.items || !settings.items.length || !itemName) {
                    return {};
                }
                for (var i = 0; i < settings.items.length; i++) {
                    var item = settings.items[i];
                    if (item.name == itemName) {
                        return item;
                    }
                }

                return {};
            }

            function findDataFromObj(obj, type, format) {
                if (!obj || !obj.items || !obj.items.length) {
                    return {};
                }
                for (var i = 0; i < obj.items.length; i++) {
                    var item = obj.items[i];
                    if (item.type == type && item.format == format) {
                        return item;
                    }
                }
                return {};
            }

            function constructCell(layout, settings, myObj) {
                var cw = layout.width || 100;
                var ch = layout.height || 50;
                var width = vm.width || 100;
                var height = vm.height || 100;
                vm.data = {
                    width: width,
                    height: height,
                    styles: {
                        width: width + 'px',
                        height: height + 'px'
                    },
                    showOthers:settings.showOthers,
                    items: []
                };
                if (settings.backgroundColor) {
                    vm.data.styles['background-color'] = settings.backgroundColor;
                }
                var lineW = 0;
                if (settings.border && settings.border.lineType) {
                    var border = settings.border;
                    if (settings.border && settings.border.lineType && settings.border.lineWidth && border.color) {
                        vm.data.styles['border'] = (border.lineWidth) + 'px ' + border.lineType + " "  + border.color;
                        lineW = (border.lineWidth)*2;
                        if(vm.dateConfig && vm.dateConfig.removeBorderOverlap){
                            if(vm.trIndex > 0){
                                vm.data.styles['border-top'] = 0 + 'px ' + border.lineType + " "  + border.color;
                            }
                            if(vm.tdIndex > 0){
                                lineW = border.lineWidth;
                                vm.data.styles['border-left'] = 0 + 'px ' + border.lineType + " "  + border.color;
                            }
                        }
                    }
                    if (border.tlRadius) {
                        vm.data.styles['border-top-left-radius'] = border.tlRadius * Math.min(width / cw, height / ch) + 'px';
                    }
                    if (border.trRadius) {
                        vm.data.styles['border-top-right-radius'] = border.trRadius * Math.min(width / cw, height / ch) + 'px';
                    }
                    if (border.blRadius) {
                        vm.data.styles['border-bottom-left-radius'] = border.blRadius * Math.min(width / cw, height / ch) + 'px';
                    }
                    if (border.brRadius) {
                        vm.data.styles['border-bottom-right-radius'] = border.brRadius * Math.min(width / cw, height / ch) + 'px';
                    }
                }
                if (settings && settings.items && settings.items.length) {
                    width = width - lineW;
                    height = height - lineW;
                    for (var i = 0; i < settings.items.length; i++) {
                        var ci = settings.items[i];
                        var ci1 = layout.items[i];
                        if (ci.type == "image" || ci.type == 'userimage') {
                            var element = {
                                x: ci.x * width / cw,
                                y: ci.y * height / ch,
                                w: ci.w * width / cw,
                                h: ci.h * height / ch
                            };
                            if (settings.debug) {
                                element.debug = true;
                            }
                            var img = {
                                type: ci.type,
                                url: ci.url,
                                styles: imageStyleObj(element)
                            };

                            vm.data.items.push(img);
                        }
                        else if (ci.type) {
                            var element = {
                                x: ci.x * width / cw,
                                y: ci.y * height / ch,
                                w: ci.w * width / cw,
                                h: ci.h * height / ch,
                                textSize: Number.parseInt(ci.textSize) * width / cw,
                                textFont: ci.textFont,
                                textColor: ci.textColor,
                                textAlign: ci.textAlign,
                                textWeight: ci.textWeight,
                                textFontUuid: ci.textFontUuid
                            };
                            var item = findItemFromSettings(settings, ci.name) || {};
                            if (item.textSize) {
                                element.textSize = Number.parseInt(item.textSize) * width / cw;
                            }
                            if (item.textFontUuid) {
                                element.textFontUuid = item.textFontUuid;
                                getFontCSS(FontManagement, {
                                    fontuuid: element.textFontUuid
                                }, $scope)
                            }
                            if (item.textFont) {
                                element.textFont = item.textFont;
                            }
                            if (item.textColor) {
                                element.textColor = item.textColor;
                            }
                            if (item.textAlign) {
                                element.textAlign = item.textAlign;
                            }
                            if (item.textBold) {
                                element.textWeight = "600";
                            }
                            if (item.textItalic) {
                                element.textStyle = "italic";
                            }
                            if (item.backgroundColor) {
                                element.backgroundColor = item.backgroundColor;
                            }

                            if (settings.debug) {
                                element.debug = true;
                            }

                            var data = findDataFromObj(myObj || vm.obj, ci.type, ci1.format) || {};
                            if (!data.type && ci.type == 'event') {
                                data = {
                                    value: ' '
                                };
                            }

                            var text = {
                                type: ci.type,
                                format: ci1.format,
                                value: data.value || ci.value || ci.sample,
                                styles: textStyleObj(element)
                            };
                            vm.data.items.push(text);
                        }

                    }
                } else {
                    var t = {
                        type: "date",
                        format: "$dd",
                        value: "01",
                        textSize: 18 * width / 100,
                        textFont: '',
                        textFontUuid: '',
                        textColor: '#ff0000',
                        textWeight: 600,
                        x: 5 * width / 100,
                        y: 15 * height / 100,
                        w: 90 * width / 100,
                        h: 40  * height / 100,
                        fixedTo: ''
                    };
                    vm.data.items.push({
                        type: t.type,
                        format: t.format,
                        value: t.value || t.sample,
                        styles: textStyleObj(t)
                    });
                }
            } // end of constructCell

        }]
    };
    angular.module('editorApp')
        .component('dateCell', dateCellControl);

})();

(function () {
    'use strict';

    var colorPickControl = {
    	restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/components/controls/color-pick.control.html',
        controllerAs: 'vm',
        bindings: {
            color: '=',
            transparent: '<',
            onUpdate:'&'
        },

        controller: ['$scope', '$timeout', function ($scope, $timeout) {
            var vm = this;
            vm.colorOptions = [
                {value: "#FFFFFF"},
                {value: "#FFECBF"},
                {value: "#F5D351"},
                {value: "#F58B48"},
                {value: "#F55B1D"},
                {value: "#9ED969"},

                {value: "#819E22"},

                {value: "#6BCBA4"},
                {value: "#2C7FD3"},
                {value: "#272792"},
                {value: "#F2A5E1"},
                {value: "#AF6DF3"},
            ];
            vm.data = {
                color: null
            };

            vm.$onInit = function() {
                vm.data.color = vm.color;
                vm.data.transparent = !!vm.transparent;

            }
            // 每當 one-way binding 更新時，changesObj 就是改變前後的差異
            vm.$onChanges = function(data) {

            }
            vm.$postLink = function () {

            }
            vm.$doCheck = function() {
                // deep watch
            }
            vm.$onDestroy = function () {

            }

            $scope.onClick = function (color) {
                vm.data.color = color.value;
                vm.color = vm.data.color;
                $timeout(function() {
                    if (vm.onUpdate) {
                        vm.onUpdate({text: vm.data.color});
                    }
                }, 100);
            }
            $scope.onClean = function () {
                vm.data.color = null;
                vm.color = null;
                $timeout(function() {
                    if (vm.onUpdate) {
                        vm.onUpdate({text: null});
                    }
                }, 100);
            }
            $scope.onInputChange = function() {
                vm.color = vm.data.color;
                $timeout(function() {
                    if (vm.onUpdate) {
                        vm.onUpdate({text: vm.data.color});
                    }
                }, 100);
            }

        }]
    };
    angular.module('editorApp')
        .component('colorPick', colorPickControl);

})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .controller('CellSettingsModalController', CellSettingsModalController);

    CellSettingsModalController.$inject = ['$timeout', '$scope', 'MessageService', '$uibModalInstance', 'msg'];

    function CellSettingsModalController ($timeout, $scope, MessageService, $uibModalInstance, msg) {
        var vm = this;

        vm.data = {
            obj: msg.obj || {type: '', value: null},
            layout: msg.layout,
            settings: buildSettings(msg.settings || {}, msg.layout),
            name: msg.name
        };
        vm.clear = clear;
        vm.save = save;

        function clear () {
            console.log('clear')
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            console.log('save')
            $uibModalInstance.close(vm.data);
        }

        function buildSettings(intial, layout) {
            var settings = angular.copy(intial);
            if (!settings.items) {
                settings.items = [];
            }

            if (layout || layout.items && layout.items.length) {
                for (var i = 0; i < layout.items.length; i++) {
                    var ti = layout.items[i];
                    if (!ti.name) {
                        continue;
                    }

                    var found = null;
                    for (var j = 0; j < settings.items.length; j++) {
                        var sj = settings.items[j];
                        if (ti.name == sj.name) {
                            found = sj;
                            break;
                        }
                    }

                    if (!found) {
                        var item = {
                            name: ti.name,
                            type: ti.type,
                            textSize: ti.textSize,
                            textFont: ti.textFont,
                            textColor: ti.textColor,
                            textAlign: ti.textAlign || 'center',
                            textBold: ti.textWeight && (ti.textWeight >= 500 || ti.textWeight == 'bold'),
                            textItalic: undefined
                        };
                        settings.items.push(item);
                    }
                }
            }
            if (!settings.border) {
                settings.border = {
                    lineType: 'solid',
                    lineWidth: 0,
                    color: '#000000',
                    tlRadius: 0,
                    trRadius: 0,
                    blRadius: 0,
                    brRadius: 0
                };
            }
            settings.showOthers = true;
            return settings;
        }

        $scope.onSettingsChange = function (text) {
            console.log(text);
            var data = JSON.parse(text);
            if (data) {
                vm.data.settings = data;

                $timeout(function() {
                    $scope.$apply();
                }, 100);

            }
        }

    }
})();

(function () {
    'use strict';

    var calendarSetControl = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/components/controls/calendar-set.control.html',
        controllerAs: 'vm',
        bindings: {
            data: '=',
            onChange:'&'
        },

        controller: ['$scope', '$timeout', '$uibModal','UidService', function ($scope, $timeout, $uibModal,UidService) {
            var vm = this;
            vm.weekStyleKeys = [
                {id:'w1',value:'星期一'},
                {id:'w2',value:'星期二'},
                {id:'w3',value:'星期三'},
                {id:'w4',value:'星期四'},
                {id:'w5',value:'星期五'},
                {id:'w6',value:'星期六'},
                {id:'w7',value:'星期日'},
            ];
            vm.weekStyleKey = "w1";
            vm.dateConfigKeys = [
                {id:'w1',value:'星期一'},
                {id:'w2',value:'星期二'},
                {id:'w3',value:'星期三'},
                {id:'w4',value:'星期四'},
                {id:'w5',value:'星期五'},
                {id:'w6',value:'星期六'},
                {id:'w7',value:'星期日'},
                {id:'others',value:'其它月'},
            ];
            vm.sampleYears = [
                {id:'2020',value:'2020'},
                {id:'2021',value:'2021'},
                {id:'2022',value:'2022'},
                {id:'2023',value:'2023'},
                {id:'2024',value:'2024'},
                {id:'2025',value:'2025'},
                {id:'2026',value:'2026'},
                {id:'2027',value:'2027'},
                {id:'2028',value:'2028'},
                {id:'2029',value:'2029'},
                {id:'2030',value:'2030'},
            ];
            vm.sampleMonths = [
                {id:'1',value:'1'},
                {id:'2',value:'2'},
                {id:'3',value:'3'},
                {id:'4',value:'4'},
                {id:'5',value:'5'},
                {id:'6',value:'6'},
                {id:'7',value:'7'},
                {id:'8',value:'8'},
                {id:'9',value:'9'},
                {id:'10',value:'10'},
            ];
            vm.dateConfigKey = "w1";
            vm.$onInit = function(data) {
                updateWeekStyleOptions();
                updateDateStyleOptions();
            }
            vm.$onChanges = function(data) {
                if(data.data&&data.data.currentValue){
                    vm.data = data.data.currentValue;
                }
            }

            function updateWeekStyleOptions() {
                var options = [];
                for (var i = 0; i < vm.data.weekStyles.length; i++) {
                    var style = vm.data.weekStyles[i];
                    options.push({name: style.name, uuid: style.uuid});
                }
                vm.weekStyleOptions = options;
            }

            function updateDateStyleOptions() {
                var options = [
                    {name: "默认样式", uuid: 'default'}
                ];
                for (var i = 0; i < vm.data.dateStyles.length; i++) {
                    var style = vm.data.dateStyles[i];
                    options.push({name: style.name, uuid: style.uuid});
                }
                vm.dateStyleOptions = options;
            }
            //属性栏
            vm.tag = 1;
            $scope.tagClick = function(item){
                vm.tag = item;
            }
            $scope.showOthersCb = function(item){
                vm.data.showOthers = item;
                $scope.widgetUpdate();
            }
            //周设置
            $scope.selectWeekLayout = function() {
                $uibModal.open({
                    templateUrl: 'app/entities/calendar/controls/layout-select.html',
                    controller: 'LayoutSelectController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        msg: function() {
                            return {
                                type: 'WEEK'
                            };
                        }
                    }
                }).result.then(function(res) {
                    if (res.id != vm.data.weekLayoutId) {
                        vm.data.weekLayout = res;
                        vm.data.weekLayoutId = res.id;
                        resetWeekStyles();
                    }
                });
            }
            function resetWeekStyles() {
                for (var k = 0; k < vm.data.weekStyles.length; k++) {
                    var style = vm.data.weekStyles[k];

                    style.items = [];
                    if (vm.data.weekLayout && vm.data.weekLayout.items) {
                        for (var i = 0; i < vm.data.weekLayout.items.length; i++) {
                            var item = vm.data.weekLayout.items[i];

                            style.items.push({
                                name: item.name,
                                type: item.type,
                                format: item.format,
                                sample: item.sample,
                                textFontUuid: "",
                                textFamily: "",
                                textSize: item.textSize,
                                textColor: item.textColor,
                                textAlign: item.textAlign,
                                url: item.url
                            });
                        }
                    }
                }
                $scope.widgetUpdate();
            }
            vm.addWeekStyle = function () {
                var style = {
                    name: "样式" + randomString(),
                    uuid: UidService.get(),
                    backgroundColor: null,
                    border: {
                        lineType: null,
                        lineWidth: 0,
                        color: "#cccccc"
                    },
                    items:[]
                };

                if (vm.data.weekLayout && vm.data.weekLayout.items) {
                    for (var i = 0; i < vm.data.weekLayout.items.length; i++) {
                        var item = vm.data.weekLayout.items[i];

                        style.items.push({
                            name: item.name,
                            type: item.type,
                            format: item.format,
                            sample: item.sample,
                            textFontUuid: "",
                            textFamily: "",
                            textSize: item.textSize,
                            textColor: item.textColor,
                            textAlign: item.textAlign,
                            url: item.url
                        });
                    }
                }
                vm.data.weekStyles.push(style);
                updateWeekStyleOptions();
            }
            vm.editWeekStyle = function (style, $index) {
                var layout = vm.data.weekLayout;
                var myStyle = vm.data.weekStyles[$index];
                var data = {
                    obj: null,
                    settings: myStyle,
                    layout: layout,
                    name:style.name
                };
                $uibModal.open({
                    templateUrl: 'app/entities/calendar/controls/cell-settings-modal.html',
                    controller: 'CellSettingsModalController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    resolve: {
                        msg: function() {
                            return data;
                        }
                    }
                }).result.then(function(res) {
                    style.name = res.name;
                    if (res.settings) {
                        vm.data.weekStyles[$index].debug = res.settings.debug;
                        vm.data.weekStyles[$index].backgroundColor = res.settings.backgroundColor;
                        if (res.settings.border) {
                            vm.data.weekStyles[$index].border = res.settings.border;
                        }
                        if (res.settings.items) {
                            vm.data.weekStyles[$index].items = res.settings.items || style.items;
                        }
                        $scope.widgetUpdate();
                    }
                });
            }
            vm.removeWeekStyle = function ($index) {
                MessageService.confirm({
                    title:'提示',
                    cancel:'取消',
                    confirm:'确认',
                    msg:'确认删除？'
                },function(){
                    var wc = vm.data.weekConfig;
                    var s = vm.data.weekStyles[$index];
                    if (!wc.w1 || wc.w1 == s.uuid) {
                        wc.w1 = 'default';
                    }
                    if (!wc.w2 || wc.w2 == s.uuid) {
                        wc.w2 = 'default';
                    }
                    if (!wc.w3 || wc.w3 == s.uuid) {
                        wc.w3 = 'default';
                    }
                    if (!wc.w4 || wc.w4 == s.uuid) {
                        wc.w4 = 'default';
                    }
                    if (!wc.w5 || wc.w5 == s.uuid) {
                        wc.w5 = 'default';
                    }
                    if (!wc.w6 || wc.w6 == s.uuid) {
                        wc.w6 = 'default';
                    }
                    if (!wc.w7 || wc.w7 == s.uuid) {
                        wc.w7 = 'default';
                    }
                    vm.data.weekStyles.splice($index, 1);
                    updateWeekStyleOptions();
                    $scope.widgetUpdate();
                })
            }
            //日设置
            $scope.selectDateLayout = function() {
                $uibModal.open({
                    templateUrl: 'app/entities/calendar/controls/layout-select.html',
                    controller: 'LayoutSelectController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        msg: function() {
                            return {
                                type: 'DATE'
                            };
                        }
                    }
                }).result.then(function(res) {
                    if (res.id != vm.data.dateLayoutId) {
                        vm.data.dateLayout = res;
                        vm.data.dateLayoutId = res.id;
                        resetDateStyles();
                    }
                });
            }
            function resetDateStyles() {
                for (var k = 0; k < vm.data.dateStyles.length; k++) {
                    var style = vm.data.dateStyles[k];

                    style.items = [];
                    if (vm.data.dateLayout && vm.data.dateLayout.items) {
                        for (var i = 0; i < vm.data.dateLayout.items.length; i++) {
                            var item = vm.data.dateLayout.items[i];

                            style.items.push({
                                name: item.name,
                                type: item.type,
                                format: item.format,
                                sample: item.sample,
                                textFontUuid: "",
                                textFamily: "",
                                textSize: item.textSize,
                                textColor: item.textColor,
                                textAlign: item.textAlign,
                                url: item.url
                            });
                        }
                    }
                }
                $scope.widgetUpdate();
            }
            vm.addDateStyle = function () {
                var style = {
                    name: "样式" + randomString(),
                    uuid: UidService.get(),
                    backgroundColor: null,
                    border: {
                        lineType: null,
                        lineWidth: 0,
                        color: "#cccccc"
                    },
                    items:[]
                };

                if (vm.data.dateLayout && vm.data.dateLayout.items) {
                    for (var i = 0; i < vm.data.dateLayout.items.length; i++) {
                        var item = vm.data.dateLayout.items[i];

                        style.items.push({
                            name: item.name,
                            type: item.type,
                            format: item.format,
                            sample: item.sample,
                            textFontUuid: "",
                            textFamily: "",
                            textSize: item.textSize,
                            textColor: item.textColor,
                            textAlign: item.textAlign,
                            url: item.url
                        });
                    }
                }
                vm.data.dateStyles.push(style);
                updateDateStyleOptions();
            }
            vm.editDateStyle = function (style, $index) {

                var layout = vm.data.dateLayout;
                var myStyle = vm.data.dateStyles[$index];

                var data = {
                    obj: null,
                    settings: myStyle,
                    layout: layout
                };
                $uibModal.open({
                    templateUrl: 'app/entities/calendar/controls/cell-settings-modal.html',
                    controller: 'CellSettingsModalController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        msg: function() {
                            return data;
                        }
                    }
                }).result.then(function(res) {
                    if (res.settings) {
                        vm.data.dateStyles[$index].debug = res.settings.debug;
                        vm.data.dateStyles[$index].backgroundColor = res.settings.backgroundColor;
                        if (res.settings.border) {
                            vm.data.dateStyles[$index].border = res.settings.border;
                        }
                        if (res.settings.items) {
                            vm.data.dateStyles[$index].items = res.settings.items || style.items;
                        }
                        $scope.widgetUpdate();
                    }
                });
            }
            vm.removeDateStyle = function ($index) {
                MessageService.confirm({
                    title:'提示',
                    cancel:'取消',
                    confirm:'确认',
                    msg:'确认删除？'
                },function(){
                    var dc = vm.data.dateConfig;
                    var s = vm.data.dateStyles[$index];
                    if (!dc.w1 || dc.w1 == s.uuid) {
                        dc.w1 = 'default';
                    }
                    if (!dc.w2 || dc.w2 == s.uuid) {
                        dc.w2 = 'default';
                    }
                    if (!dc.w3 || dc.w3 == s.uuid) {
                        dc.w3 = 'default';
                    }
                    if (!dc.w4 || dc.w4 == s.uuid) {
                        dc.w4 = 'default';
                    }
                    if (!dc.w5 || dc.w5 == s.uuid) {
                        dc.w5 = 'default';
                    }
                    if (!dc.w6 || dc.w6 == s.uuid) {
                        dc.w6 = 'default';
                    }
                    if (!dc.w7 || dc.w7 == s.uuid) {
                        dc.w7 = 'default';
                    }
                    if (!dc.others || dc.others == s.uuid) {
                        dc.others = 'default';
                    }
                    vm.data.dateStyles.splice($index, 1);
                    updateDateStyleOptions();
                    $scope.widgetUpdate();
                })
            }
            function randomString() {
                return Math.random().toString(36).slice(-5);
            }
            $scope.widgetUpdate = function() {
                $timeout(function () {
                    vm.onChange({text: JSON.stringify(vm.data)});
                })
            }

        }]
    };
    angular.module('editorApp')
        .component('calendarSet', calendarSetControl);

})();

(function () {
    'use strict';

    var ClassifyEcControl = {
    	restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/components/classify-ec.html',
        controllerAs: 'vm',
        bindings: {
            cliparts:'<',
            page:'<',
            domain:'<',
            type:'<',
            propertyValue:'<',
            onSave:'&',
            onClose:'&',
        },

        controller: ['$scope','ModulesService','ThemeClassify','$timeout', '$http', '$translate', 'MessageService','ClipArt','$stateParams',
            function ($scope,ModulesService,ThemeClassify,$timeout,$http, $translate, MessageService,ClipArt,$stateParams) {
            var vm = this;
            vm.storeId = $stateParams.storeId;
            var type = vm.type == 'TECHNIQUE' ? 'TECHNIQUE' :'ClipArt';
            vm.classify = [];
            vm.isMaterial1 = false;
            vm.$onInit = function (){
                getClassify();
                $('#materialView').on('scroll', function(event){
                    var realScrollHeight=event.currentTarget.clientHeight+event.currentTarget.scrollTop;
                    if(!vm.isMaterial1){
                        if((event.currentTarget.scrollHeight-1)<realScrollHeight && realScrollHeight < (event.currentTarget.scrollHeight+1)){
                            vm.materialPage++;
                            initMaterial(vm.classifyId)
                        }
                    }
                })
            }
            //分类
            function getClassify(){
                vm.classify = [];
                var item = {type: type,storeId:vm.storeId};
                if(vm.type == 'TECHNIQUE'){
                    item.techniqueType = 'gold';
                }
                ThemeClassify.getAllByCondition4(item, function (res) {
                    if(vm.cliparts && vm.cliparts.clipart && vm.cliparts.clipart.length>0){
                        vm.classify = [{
                            id: "",
                            name: $translate.instant("editorCommon.recommend"),
                            seq: 0,
                            type: type,
                            used: true
                        }]
                    }
                    if(res.data && res.data.length>0){
                        res.data.forEach(function (item) {
                            vm.classify.push(item)
                        })
                    }
                    if(vm.classify.length>0){
                        initMaterial(vm.classify[0].id)
                    }
                });
            }
            vm.materialPage = 0;
            vm.materialSum = 20;
            vm.materialData = [];
            $scope.classifyCb = function (id){
                vm.materialPage = 0;
                vm.materialData = [];
                initMaterial(id)
            }
            //获取素材
            function initMaterial(id) {
                vm.classifyId = id;
                var items = [];
                if(vm.classifyId){
                    items.push({key: "themeClassify.id", op: "=", value: id})
                }
                ClipArt.byCondition3({
                    items:items,
                    page: vm.materialPage,
                    size: vm.materialSum,
                    sort: ["seq,asc"]
                }, function (res) {
                    angular.forEach(res.data, function (resp) {
                        var arr = {
                            name: resp.name,
                            identifier: vm.domain + resp.identifier,
                            provider: resp.provider,
                            themeClassifyName: resp.themeClassifyName,
                            themeClassifyId: resp.themeClassifyId,
                            resource: {
                                identifier: vm.domain + resp.identifier,
                                provider: resp.provider
                            }
                        }
                        vm.materialData.push(arr);
                    })
                    if (res.data.length < vm.materialSum) {
                        vm.isMaterial1 = true;
                    }else {
                        vm.isMaterial1 = false;
                    }
                });
            };
            vm.repeatAddNumber = 0;
            $scope.addImageart = function (item){
                imageartAdd($http, item.resource.identifier, vm.page.trimbox, function(imageart){
                    if(vm.repeatAddNumber>4){
                        vm.repeatAddNumber = 0;
                    }
                    var _num = 10*vm.repeatAddNumber;
                    imageart.geometry.x += _num/vm.page.custom.ratio1;
                    imageart.geometry.y += _num/vm.page.custom.ratio1;
                    var _classify = vm.classify.find(function(i){return i.id == vm.classifyId}) 
                    if(_classify && _classify.type == "TECHNIQUE" && vm.propertyValue){
                        _imageart.spotColor = {
                            color: vm.propertyValue.color,
                            code: vm.propertyValue.spotColor,
                            name: vm.propertyValue.value,
                            growMethod: vm.propertyValue.epitaxy,
                            growValue: vm.propertyValue.epitaxyValue,
                            unit: vm.propertyValue.unit,
                            serviceType: "stamping",
                            uuid: vm.propertyValue.uuid
                        };
                    }
                    var _level = {
                        seq: vm.page.levels.level.length + 1,
                        imageart: imageart
                    }
                    if (vm.onSave) {
                        vm.onSave({text: JSON.stringify(_level)});
                    }
                    vm.repeatAddNumber++;
                }, vm.page.custom.ratio1)
            }
            $scope.materialHide = function (){
                if (vm.onClose) {
                    vm.onClose();
                }
            }
        }]
    };

    angular.module('editorApp')
    	.component('classifyEc', ClassifyEcControl);

})();

(function () {
    'use strict';

    var ChalkViewControl = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/components/chalk-view.html',
        controllerAs: 'vm',
        bindings: {
            imagebox: '=',
            imageart: '<',
            type: '<',
            width: '<',
            height:'<',
            propertyValue:'<',
            onChange: '&'
        },
        controller: ['$scope', 'ImageService', '$timeout', 'Qinius', 'QiniuToken', 'MessageService', 'UidService', 'FontXmlsManger', 'ClipArt', 'RecommendPics', '$stateParams', '$translate', '$filter','$http', 'ImgprocContours',
            function ($scope, ImageService, $timeout, Qinius, QiniuToken, MessageService, UidService, FontXmlsManger, ClipArt, RecommendPics, $stateParams, $translate, $filter, $http, ImgprocContours) {
                var vm = this;
                Qinius.getDomain({},function(res){
                    $scope.domain = 'https://' + res.domains[0] + '/';
                });
                QiniuToken.get('tokenWithPolicy', {"mimeLimit":"image/jpeg;image/png"}, function (token) {
                    vm.token = token;
                });
                $scope.imagebox = vm.imagebox;
                $scope.imageart = vm.imageart;
                $scope.type = vm.type;
                $scope.width = Math.round(vm.width);
                $scope.height = Math.round(vm.height);
                var userAgent = navigator.userAgent || navigator.vendor || window.opera;
                // 移动设备判断关键字
                vm.isMobile = /iPad|iPhone|iPod|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone/.test(userAgent);
                vm.scale = 1;
                vm.windowWidth = vm.isMobile ? 343 : 530;
                if ($scope.width > $scope.height) {
                    vm.scale = vm.windowWidth / $scope.width;
                } else {
                    vm.scale = vm.windowWidth / $scope.height;
                }
                window.updateWhite = function ($event) {
                    $timeout(function () {
                        var file = $event.target.files[0]; // 获取上传的文件
                        if (!file.type.startsWith('image/png')) {
                            if(vm.isMobile){
                                MessageService.hint($translate.instant('chalk.message.invalidFormat', {fileType: file.type, type: $filter('serviceType')(vm.type)}));
                            }else{
                                MessageService.error($translate.instant('chalk.message.invalidFormat', {fileType: file.type, type: $filter('serviceType')(vm.type)}));
                            }
                            return;
                        }
                        vm.threeLoading=true;
                        vm.threeLoadingText = $translate.instant('chalk.loading.uploading', {type: $filter('serviceType')(vm.type)});
                        ImageService.backendUploadPics(file, $scope.domain, vm.token, function(data){
                            if($scope.type == 'uv' || $scope.type == 'fluore'){
                                //判断图片尺寸与原图尺寸是否一致
                                // var _img = new Image();
                                // _img.onload = function() {
                                    // var float = 5;
                                    // if (Math.abs(Math.round(_img.width) - $scope.width) > float || Math.abs(Math.round(_img.height) - $scope.height) > float) {
                                    //     vm.threeLoading = false;
                                    //     if (vm.isMobile) {
                                    //         vm.isError = _img.width + 'x' + _img.height + '≠' + $scope.width + 'x' + $scope.height;
                                    //     } else {
                                    //         MessageService.error($translate.instant('chalk.message.sizeMismatchUpload', {type: $filter('serviceType')(vm.type)}));
                                    //     }
                                    //     $scope.$apply();
                                    //     return;
                                    // }
                                    ImgprocContours.buildServiceImage({
                                        image: $scope.domain + data.key,
                                        "pageSize": {
                                            "width": PxTurnMm($scope.width),
                                            "height": PxTurnMm($scope.height)
                                        }
                                    },function(res){
                                        if(res.success){
                                            imageartAdd($http, res.data.serviceImage, null, function(imageart){
                                                imageart.geometry.x = 0;
                                                imageart.geometry.y = 0;
                                                imageart.geometry.width = $scope.width;
                                                imageart.geometry.height = $scope.height;
                                                if(vm.propertyValue){
                                                    imageart.spotColor = {
                                                        color: vm.propertyValue.color,
                                                        code: vm.propertyValue.spotColor,
                                                        name: vm.propertyValue.value,
                                                        growMethod: vm.propertyValue.epitaxy,
                                                        growValue: vm.propertyValue.epitaxyValue,
                                                        unit: vm.propertyValue.unit,
                                                        uuid: vm.propertyValue.uuid
                                                    };
                                                    imageart.serviceType = $scope.type;
                                                }
                                                $scope.imageart = imageart;
                                                vm.threeLoading = false;
                                            }, 1, true);
                                        }else{
                                            vm.threeLoading = false;
                                            MessageService.error($translate.instant('chalk.message.uploadFailed'));
                                        }
                                    },function(err){
                                        vm.threeLoading = false;
                                        MessageService.error($translate.instant('chalk.message.uploadFailed'));
                                    })
                                // };
                                // _img.onerror = function() {
                                //     vm.threeLoading = false;
                                //     MessageService.error($translate.instant('chalk.message.loadFailed', {type: $filter('serviceType')(vm.type)}));
                                //     $scope.$apply();
                                // };
                                // _img.src = $scope.domain + data.key;
                                return
                            }
                            $scope.imagebox.whiteInk = {
                                resource:{
                                    identifier:$scope.domain +data.key
                                },
                                growMethod: vm.propertyValue.epitaxy,
                                growValue: vm.propertyValue.epitaxyValue,
                                unit: vm.propertyValue.unit,
                                color: vm.propertyValue.spotColor,
                                colorValue: vm.propertyValue.color,
                            };
                            processImages($scope.imagebox.image.resource.identifier, $scope.imagebox.whiteInk.resource.identifier, function (res) {
                                var blob = base64ToBlob(res, file.type);
                                var _file = blobToFile(blob, file.name); 
                                ImageService.backendUploadPics(_file, $scope.domain, vm.token, function(data){
                                    vm.threeLoading=false;
                                    $scope.imagebox.whiteInk2 = {
                                        resource:{
                                            identifier:$scope.domain +data.key
                                        },
                                        growMethod: vm.propertyValue.epitaxy,
                                        growValue: vm.propertyValue.epitaxyValue,
                                        unit: vm.propertyValue.unit,
                                        color: vm.propertyValue.spotColor,
                                        colorValue: vm.propertyValue.color,
                                    };
                                    $scope.$apply();
                                },function(err){
                                    vm.threeLoading=false;
                                    MessageService.error($translate.instant('chalk.message.sizeMismatchUpload', {type: $filter('serviceType')(vm.type)}));
                                    $scope.$apply();
                                })
                            }, function (error) {
                                vm.threeLoading=false;
                                if(vm.isMobile){
                                    vm.isError = error;
                                }else{
                                    MessageService.error($translate.instant('chalk.message.sizeMismatchUpload', {type: $filter('serviceType')(vm.type)}));
                                }
                                $scope.$apply();
                            })
                        },function(err){
                            vm.threeLoading=false;
                            MessageService.error($translate.instant('chalk.message.sizeMismatchUpload', {type: $filter('serviceType')(vm.type)}));
                            $scope.$apply();
                        })
                    })
                };
                vm.threeLoading=false;
                vm.threeLoadingText = $translate.instant('chalk.loading.loading');
                $scope.setProcessImages = function(){
                    vm.threeLoading=true;
                    vm.threeLoadingText = $translate.instant('chalk.loading.generating', {type: $filter('serviceType')(vm.type)});
                    if($scope.imagebox.image && $scope.imagebox.image.resource && $scope.imagebox.image.resource.identifier){
                        processImages($scope.imagebox.image.resource.identifier,null,function(res){
                            var blob = base64ToBlob(res, 'image/' + $scope.imagebox.image.imageInfo.format);
                            var _file = blobToFile(blob); 
                            ImageService.backendUploadPics(_file, $scope.domain, vm.token, function(data){
                                vm.threeLoading=false;
                                $scope.imagebox.whiteInk = null;
                                $scope.imagebox.whiteInk2 = {
                                    resource:{
                                        identifier:$scope.domain +data.key
                                    },
                                    growMethod: vm.propertyValue.epitaxy,
                                    growValue: vm.propertyValue.epitaxyValue,
                                    unit: vm.propertyValue.unit,
                                    color: vm.propertyValue.spotColor,
                                    colorValue: vm.propertyValue.color,
                                };
                                $scope.$apply();
                            },function(err){
                                vm.threeLoading=false;
                                MessageService.error($translate.instant('chalk.message.sizeMismatchUpload', {type: $filter('serviceType')(vm.type)}));
                                $scope.$apply();
                            })
                        },function(error){
                            vm.threeLoading=false;
                            MessageService.error(error);
                        })
                    }else{
                        vm.threeLoading=false;
                        MessageService.error($translate.instant('chalk.message.addImageFirst'));
                    }
                }
                $scope.imageartDelete = function () {
                    if($scope.imageart){
                        $scope.imageart = null;
                    }
                }
                $scope.modalHide = function () {
                    vm.onChange();
                }
                $scope.save = function(){
                    if($scope.type != 'white'){
                        if(!$scope.imageart || !$scope.imageart.resource || !$scope.imageart.resource.identifier){
                            MessageService.error($translate.instant('chalk.message.addImageFirst'));
                            return;
                        }
                        vm.onChange({text:$scope.imageart});
                    }else{
                        vm.onChange({text:$scope.imagebox});
                    }
                }
                $scope.goldFoil = function(color){
                    if(color){
                        return goldFoil(color)
                    }
                }
                $scope.sizeMm = function(){
                    if($scope.width && $scope.height){
                        return Math.round(PxTurnMm($scope.width)) + "x" + Math.round(PxTurnMm($scope.height)) + 'mm';
                    }
                }
                $scope.sizePx = function(){
                    if($scope.width && $scope.height){
                        return Math.round(PxTurnMm($scope.width) / 25.4 * 300) + "x" + Math.round(PxTurnMm($scope.height) / 25.4 * 300) + 'px';
                    }
                }
            }]
    };

    angular.module('editorApp')
        .component('chalkView', ChalkViewControl);

})();

(function () {
    'use strict';

    var canvasImageFilter = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/components/canvas-image-filter.html',
        controllerAs: 'vm',
        bindings: {
            productTitle:'<',
            productXmlLine:'<',
            logo:'<',
            elementOn:'='
        },

        controller: ['$scope', '$timeout', 'MessageService', '$translate','$window','$rootScope',
            function ($scope, $timeout, MessageService, $translate, $window, $rootScope) {
                var vm = this;
                vm.isPng = false;
                vm.loading = true;
                vm.imgUrl = '';
                vm.imgWidth = 0;
                vm.imgHeight = 0;
                vm.scale = 0;
                vm.contrast = false;
                vm.loading = false;
                vm.domain = localStorage.getItem('editor-domain');
                init();
                vm.$onInit = function() {
                    var imageInfo2 = orientationInit(angular.copy(vm.elementOn.item.image.imageInfo))
                    vm.imgWidth = imageInfo2.width;
                    vm.imgHeight = imageInfo2.height;
                    // 判断png
                    $.ajax({
                        type: "GET",
                        url: vm.elementOn.item.image.resource.identifier + "?imageInfo",
                        async: false,
                        success: function (va) {
                            if(va.format == "png"){
                                vm.isPng = true;
                            }
                            vm.changeImageFilter();
                        }
                    })
                }
                angular.element($window).bind('resize', function() {
                    $scope.$apply(function() {
                        init();
                    });
                });
                $scope.mouseDown = function() {
                    // 鼠标按下时执行的操作
                    vm.contrast = true;
                };
                
                $scope.mouseUp = function() {
                    // 鼠标抬起时执行的操作
                    vm.contrast = false;
                };
                angular.element(document).on('mouseup', function() {
                    // vm.contrast = false;
                    $scope.$apply(function() {
                        vm.contrast = false;
                    });
                });

                // 保存事件处理函数的变量
                var mousewheelHandler = function(event){
                    if (event.ctrlKey === true || event.metaKey) {
                        var wheelDelta = event.wheelDelta ? (event.wheelDelta / 120) : ( - event.detail / 3);
                        if(wheelDelta>0){
                            vm.scale += vm.scale * 0.1;
                        }else{
                            vm.scale -= vm.scale * 0.1;
                        }
                        $scope.$apply();
                        event.preventDefault();
                        event.stopPropagation();
                    }
                };

                // 添加事件监听器
                window.addEventListener('mousewheel', mousewheelHandler, { passive: false });
                $scope.ratioJian = function(){
                    vm.scale -= vm.scale * 0.1;
                }
                $scope.ratioJia = function(){
                    vm.scale += vm.scale * 0.1;
                }
                $scope.ratioInit = function(){
                    init();
                }
                $scope.ratioOriginal = function(){
                    vm.scale = 1;
                }
                function init(){
                    var imageInfo2 = orientationInit(angular.copy(vm.elementOn.item.image.imageInfo))
                    var imgWidth = imageInfo2.width;
                    var imgHeight = imageInfo2.height;
                
                    // 获取canvas的父元素div的宽度和高度
                    var canvasParent = document.getElementById('canvas');
                    var parentWidth = canvasParent.offsetWidth - 150;
                    var parentHeight = canvasParent.offsetHeight - 150;
                
                    // 计算缩放比例
                    var scaleWidth = parentWidth / imgWidth;
                    var scaleHeight = parentHeight / imgHeight;
                    var scale = Math.min(scaleWidth, scaleHeight);
                    vm.scale = scale;
                }
                // 防抖，防止500毫秒内重复触发事件
                var timer = null;
                $scope.changeOperation = function () {
                    vm.loading = true;
                    if (timer !== null) {
                        clearTimeout(timer)
                    }
                    timer = setTimeout(function() {
                        vm.changeImageFilter()
                    }, 1000);
                }

                vm.changeImageFilter =  function (){
                    vm.loading = true;
                    vm.imgUrl = '';
                    var imgUrl = vm.domain + vm.elementOn.item.image.resource.primary;
                    var brightness = vm.elementOn.item.image.brightness == null ? 0 : vm.elementOn.item.image.brightness;
                    var contrast = vm.elementOn.item.image.contrast == null ? 0 : vm.elementOn.item.image.contrast;
                    var saturate = vm.elementOn.item.image.saturate == null ? 0 : vm.elementOn.item.image.saturate;
                    var hue = vm.elementOn.item.image.hue == null ? 0 : vm.elementOn.item.image.hue;
                    var temperature = vm.elementOn.item.image.temperature == null ? 0 : vm.elementOn.item.image.temperature;
                    canvasImageFilter(imgUrl,vm.imgWidth,vm.imgHeight,brightness,contrast,saturate,hue,temperature,vm.isPng)
                }

                function canvasImageFilter(imgUrl,imgWidth,imgHeight,brightness,contrast,saturate,hue,temperature,isPng){
                    var cav = $('#imageFilter')[0],
                    ctx = cav.getContext('2d',{ willReadFrequently: true });
                    cav.width = imgWidth;
                    cav.height = imgHeight;
                    var img = new Image();
                    var base64 = '';
                    img.crossOrigin = '*';
                    img.onload = function () {
                        ctx.filter = "brightness("+(Number(brightness)+100)+"%) contrast("+(Number(contrast)+100)+"%) saturate("+(Number(saturate)+100)+"%) hue-rotate("+ hue +"deg)";
                            ctx.drawImage(img, 0, 0);
                            var imageData = ctx.getImageData(0, 0, imgWidth, imgHeight);
                            var data = imageData.data;
                            for (var i = 0; i < data.length; i += 4) {
                                data[i] = data[i] + data[i]*temperature*0.005;     // red
                                data[i + 1] = data[i + 1]; // green
                                data[i + 2] = data[i + 2] - data[i + 2] * temperature * 0.005; // blue
                            }
                            ctx.putImageData(imageData, 0, 0);
                        try {
                            if (isPng) {
                                base64 = cav.toDataURL("image/png", 0.9);
                            }else{
                                base64 = cav.toDataURL("image/jpeg", 0.9);
                            }
                        } catch (err) {
                        }
                        $scope.$apply(function() {
                            vm.loading = false;
                            vm.imgUrl = base64;
                        });
                    }
                    img.src = imgUrl;
                }


                // 清空画布内容删除画布，移除监听事件
                function clearCanvasComponent(){
                    var cav = $('#imageFilter')[0];
                    var ctx = cav.getContext('2d');
                    ctx.clearRect(0, 0, cav.width, cav.height);
                    cav.remove()
                    angular.element($window).unbind('resize');
                    window.removeEventListener('mousewheel', mousewheelHandler);
                }

                $scope.close = function(){
                    clearCanvasComponent();
                    $rootScope.$emit('editorApp.closeImageFilter');
                }
                $scope.save = function(){
                    if (!vm.imgUrl || vm.loading) {
                        return MessageService.error('图片处理中请稍后');
                    }
                    clearCanvasComponent();
                    $rootScope.$emit('editorApp.saveImageFilter',vm.imgUrl);
                }
            }]
    };

    angular
        .module('editorApp')
        .component('canvasImageFilter', canvasImageFilter);
})();

(function () {
    'use strict';

    var backgroundListControl = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/components/background-list.html',
        controllerAs: 'vm',
        bindings: {
            onColor: '&',
            onImage: '&'
        },
        controller: ['$scope', 'ThemeClassify', 'Backgrounds', '$stateParams',
            function ($scope, ThemeClassify, Backgrounds, $stateParams) {
                var vm = this;
                vm.storeId = $stateParams.storeId;
                vm.$onInit = function() {
                    classifyInit();
                }
                //分类
                function classifyInit(){
                    ThemeClassify.getAllByCondition4({
                        type: 'Background',
                        storeId: vm.storeId
                    }, function (res) {
                        vm.bgImglabels = res.data;
                        vm.bgImgPage = 0;
                        vm.bgImgList = [];
                        bgImgInit(res.data[0])
                    });
                }
                vm.colorArr1 = ['#ffffff', '#666666', '#7babaf', '#e69594', '#93a9da', '#eac8fb'];
                vm.colorArr2 = ['#000000', '#666666', '#a8a8a8', '#d9d9d9', '#ffffff', '#647c6e', '#ff5b5c', '#ffbd4a', '#fef952', '#99e264', '#36b72a', '#44d9e5', '#c27171', '#2fb3ff', '#b760a6'];
        
                vm.bgImgList = [];
                vm.bgImgPage = 0;
                vm.bgImgChooseId = "";
                $scope.showbgImgdocLabels = false;
                vm.bgImglabelCb = bgImglabelCb;
                function bgImgInit(item) {
                    vm.bgImgChooseId = item;
                    Backgrounds.byCondition3({
                        items: [
                            {key: "themeClassify.id", op: "=", value: item.id}],
                        page: vm.bgImgPage,
                        size: vm.itemsPerPage
                    }, function (res, headers) {
                        angular.forEach(res.data, function (resp) {
                            var arr = {
                                name: resp.name,
                                identifier: localStorage.getItem('editor-domain') + resp.identifier,
                                provider: resp.provider,
                                themeClassifyName: resp.themeClassifyName,
                                themeClassifyId: resp.themeClassifyId,
                                resource: {
                                    identifier: localStorage.getItem('editor-domain') + resp.identifier,
                                    provider: resp.provider,
                                }
                            }
                            vm.bgImgList.push(arr);
                        })
                        var _sum = headers('X-Total-Count');
                        if(vm.bgImgList.length < _sum){
                            vm.bgImgFulfill = true;
                        }else {
                            vm.bgImgFulfill = false;
                        }
                    }, function () {
                    })
                }
                function bgImglabelCb(item){
                    vm.bgImgList = [];
                    vm.bgImgPage = 0;
                    bgImgInit(item)
                }
                $scope.loadMoreBgImg = function () {
                    vm.bgImgPage++;
                    bgImgInit(vm.bgImgChooseId)
                }
                $scope.showMorebgImgdocLabels = function () {
                    $scope.showbgImgdocLabels = !$scope.showbgImgdocLabels;
                }

                
                $scope.chooseBgColor = function(color){
                    if(vm.onColor){vm.onColor({text:color})}
                }
                $scope.chooseColor = function () {
                    if (vm.bgColor) {
                        $scope.chooseBgColor({text:vm.bgColor});
                    }
                    vm.bgColor = '#000000';
                }
                $scope.chooseBgimg = function(data){
                    if(vm.onImage){vm.onImage({text:data})}
                };
            }]
    };

    angular.module('editorApp')
        .component('backgroundList', backgroundListControl);

})();

(function () {
    'use strict';

    var articlePreview = {
        restrict: 'EAC',
        replace: true,
        transclude: true,
        templateUrl: 'app/entities/components/article-preview.html',
        controllerAs: 'vm',
        bindings: {
            documentPage: '<',
            editorType: '<',
            article: '<',
            isLandscape: '<',
            isNav: '<',
            bindingtype: '<',
        },

        controller: ['$scope', '$stateParams', '$q', '$localStorage', 'Qinius', 'Store', '$http', '$rootScope', 'Theme', 'Article',
            'FontManagement','OrderArticle', 'Convert', '$timeout', 'ModulesService', 'MessageService', '$translate',
            function ($scope, $stateParams, $q, $localStorage, Qinius, Store, $http, $rootScope, Theme, Article,
                      FontManagement, OrderArticle, Convert, $timeout, ModulesService, MessageService, $translate) {
                var vm = this;
                vm.loading = true;
                $scope.domains = Qinius.getDomain();
                vm.landscape = false;
                vm.thisPage = 0;
                vm.bindingtypes = [{id:'Tile',name:'平铺模式'}];
                $q.all([$scope.domains.$promise]).then(function () {
                    $scope.domain = 'https://' + $scope.domains.domains[0] + '/';
                    if(vm.documentPage.config.productType == 'BOOK'){
                        vm.bindingtype = 'Left';
                        vm.bindingtypes = [
                            {id:'Left',name:'左右滑动'},
                            {id:'Tile',name:'平铺展示'},
                        ]
                    }
                    if(vm.documentPage.config.productType == 'CALENDAR'){
                        vm.bindingtype = 'Top';
                        vm.bindingtypes = [
                            {id:'Top',name:'上下滑动'},
                            {id:'Tile',name:'平铺模式'},
                        ]
                    }
                    if(!vm.bindingtype){
                        vm.bindingtype = 'Tile'
                    }
                    editorInit()
                });
                function editorInit() {
                    vm.windowW1 = 140;
                    vm.windowH1 = 140;
                    vm.insidePages = [];
                    $scope.template = angular.copy(vm.documentPage);
                    vm.parts = $scope.template.config.parts.list;
                    $scope.template.pages.page=[];
                    vm.documentPage.pages.page.forEach(function (page) {
                        if(!page.backup){
                            $scope.template.pages.page.push(angular.copy(page));
                        }
                    })
                    vm.isEdit = true;
                    documentAnalysis($scope, $http, vm, $scope.template,FontManagement,'other', function(page){
                        page.custom.ratio1 = 140 / page.custom.width;
                        if(window.innerWidth*0.9>800){
                            page.custom.ratio = 800 / page.custom.width;
                        }else{
                            page.custom.ratio = window.innerWidth*0.9 / page.custom.width;
                        }
                    }, function () {
                        $scope.template.pages.page.forEach(function (page) {
                            if (!page.scene) {
                                pageTrimbox(page)
                            }
                        })
                        $timeout(function () {
                            ratioInfo()
                            $timeout(function () {
                                if(vm.bindingtype == 'Left'||vm.bindingtype == 'Top'){
                                    Page.init();
                                }
                                $timeout(function () {
                                    vm.loading = false;
                                },100)
                            },500)
                        },1000)
                    })
                }
                function ratioInfo() {
                    vm.windowH = window.innerHeight-300;
                    if(vm.isLandscape){
                        vm.windowW = window.innerWidth-32;
                    }else{
                        vm.windowW = window.innerWidth*0.8;
                    }
                    vm.pageMaxWidth = 0;
                    vm.pageMaxHeight = 0;
                    var pageMaxWidtTile = 0;
                    $scope.template.pages.page.forEach(function (page) {
                        page.isUse = false;
                        if (pageMaxWidtTile < page.custom.width) {
                            pageMaxWidtTile = page.custom.width;
                        }
                    })
                    vm.ratioTile = vm.windowW * 0.7 / pageMaxWidtTile;
                    if(vm.bindingtype == "Left" || vm.bindingtype == "Tile"){
                        $scope.template.pages.page.forEach(function (page) {
                            page.isUse = false;
                            if(page.config.partid != 'P'){
                                if(page.config.partid == 'B1' || page.config.partid == 'B2') {
                                    if (vm.pageMaxWidth < page.custom.width) {
                                        vm.pageMaxWidth = page.custom.width;
                                    }
                                    if (vm.pageMaxHeight < page.custom.height) {
                                        vm.pageMaxHeight = page.custom.height;
                                    }
                                }
                            }else{
                                if(vm.pageMaxWidth < (page.spread ? page.custom.width : page.custom.width*2)){
                                    vm.pageMaxWidth = (page.spread ? page.custom.width : page.custom.width*2);
                                }
                                if(vm.pageMaxHeight < page.custom.height){
                                    vm.pageMaxHeight = page.custom.height;
                                }
                            }
                        })
                    }
                    if(vm.bindingtype == "Top"){
                        $scope.template.pages.page.forEach(function (page) {
                            page.isUse = false;
                            if(vm.pageMaxWidth < page.custom.width){
                                vm.pageMaxWidth = page.custom.width;
                            }
                            if(vm.pageMaxHeight < (page.spread ? page.custom.height : page.custom.height*2)){
                                vm.pageMaxHeight = (page.spread ? page.custom.height : page.custom.height*2);
                            }
                        })
                    }
                    if(!vm.landscape){
                        if(vm.windowH / vm.pageMaxHeight >= vm.windowW / vm.pageMaxWidth ){
                            vm.ratio = vm.windowW / vm.pageMaxWidth;
                        }else {
                            vm.ratio = vm.windowH / vm.pageMaxHeight;
                        }
                    }else{
                        if(vm.windowH / vm.pageMaxWidth >= vm.windowW / vm.pageMaxHeight ){
                            vm.ratio = vm.windowW / vm.pageMaxHeight;
                        }else {
                            vm.ratio = vm.windowH / vm.pageMaxWidth;
                        }
                    }
                    if(vm.bindingtype == "Top"){
                        vm.ratio1 = 160 / vm.pageMaxHeight;
                    }else{
                        vm.ratio1 = 80 / vm.pageMaxHeight;
                    }
                    vm.pageMaxWidth = vm.pageMaxWidth*vm.ratio;
                    vm.pageMaxHeight = vm.pageMaxHeight*vm.ratio;
                    $scope.template.pages.page.forEach(function (page, index) {
                        // if(page.config.partid == 'P' || page.config.partid == 'B1' || page.config.partid == 'B2'){
                        //     page.ratio = vm.ratio;
                        // }else{
                            var _width = (page.spread || page.config.partid != 'P' ? page.custom.width : page.custom.width*2);
                            var _height = page.custom.height;
                            if(vm.bindingtype == "Top"){
                                _width = page.custom.width;
                                _height = page.custom.height*2
                            }
                            if(!vm.landscape){
                                if(vm.windowH / _height >= vm.windowW / _width ){
                                    page.ratio = vm.windowW / _width;
                                }else {
                                    page.ratio = vm.windowH / _height;
                                }
                            }else{
                                if(vm.windowH / _width >= vm.windowW / _height ){
                                    page.ratio = vm.windowW / _height;
                                }else {
                                    page.ratio = vm.windowH / _width;
                                }
                            }
                        // }
                        // if(index == 0){
                        //     vm.pageMaxWidth = _width * page.ratio;
                        //     vm.pageMaxHeight = _height * page.ratio;
                        // }else{
                            if(vm.pageMaxWidth < _width * page.ratio){
                                vm.pageMaxWidth = _width * page.ratio;
                            }
                            if(vm.pageMaxHeight < _height * page.ratio){
                                vm.pageMaxHeight = _height * page.ratio;
                            }
                        // }
                        for(var i=0; i<vm.parts.length; i++){
                            if(vm.parts[i].id == page.config.partid){
                                if(!vm.parts[i].pages){
                                    vm.parts[i].pages = [];
                                }
                                vm.parts[i].pages.push(page)
                                break
                            }
                        }
                    })
                    if($scope.template.config.productType == 'BOOK'||$scope.template.config.productType == 'CALENDAR'){
                        for(var i=0; i<vm.parts.length; i++){
                            if(vm.parts[i].pages &&vm.parts[i].pages.length>0){
                                if(vm.parts[i].id == 'P'){
                                    vm.parts[i].pages.forEach(function (page, index) {
                                        var emptyPage = angular.copy(page);
                                        if(!emptyPage.background){
                                            emptyPage.background = {
                                                color:'#000000',
                                                resource:{
                                                    identifier:''
                                                }
                                            }
                                        }else{
                                            emptyPage.background.color = "#000000";
                                            emptyPage.background.resource.identifier="";
                                        }
                                        emptyPage.barcode = null;
                                        emptyPage.qrcode = null;
                                        emptyPage.levels = {
                                            level: []
                                        };
                                        emptyPage.marginLeft = 0;
                                        if(!page.isUse){
                                            if(index == 0 && $scope.template.config.innerOffset == 1 && !page.spread){
                                                page.isUse = true;
                                                page.marginLeft = 0;
                                                if(page.spread){
                                                    page.custom.width = page.custom.width/2;
                                                    page.spread = false;
                                                }
                                                if(emptyPage.spread){
                                                    emptyPage.custom.width = emptyPage.custom.width/2;
                                                    emptyPage.spread = false;
                                                }
                                                emptyPage.marginLeft = vm.bindingtype == 'Left' ? vm.pageMaxWidth/2-emptyPage.custom.width * emptyPage.ratio : vm.pageMaxHeight/2-emptyPage.custom.height * emptyPage.ratio;
                                                setPageOrder(page)
                                                vm.insidePages.push({
                                                    page1:emptyPage,
                                                    page2:page,
                                                    partid: vm.parts[i].id,
                                                    spread:false
                                                })
                                            }else{
                                                if(page.spread){
                                                    page.isUse = true;
                                                    page.marginLeft = vm.bindingtype == 'Left' ? (vm.pageMaxWidth-page.custom.width * page.ratio) / 2 : (vm.pageMaxHeight-page.custom.height * page.ratio) / 2;
                                                    var _page = angular.copy(page);
                                                    _page.marginLeft = vm.bindingtype == 'Left' ? -_page.custom.width*_page.ratio/2 : -_page.custom.height*_page.ratio/2;
                                                    setPageOrder(page)
                                                    setPageOrder(_page)
                                                    vm.insidePages.push({
                                                        page1:page,
                                                        page2:_page,
                                                        partid: vm.parts[i].id,
                                                        spread:true
                                                    })
                                                }else{
                                                    var _page1 = vm.parts[i].pages[index];
                                                    var _page2 = index+1 >= vm.parts[i].pages.length ? null : vm.parts[i].pages[index+1];
                                                    _page1.isUse = true;
                                                    _page1.marginLeft = vm.bindingtype == 'Left' ? vm.pageMaxWidth/2-_page1.custom.width * _page1.ratio : vm.pageMaxHeight/2-_page1.custom.height * _page1.ratio;
                                                    setPageOrder(_page1)
                                                    if(_page2 && !_page2.spread){
                                                        _page2.isUse = true;
                                                        _page2.marginLeft = 0;
                                                        setPageOrder(_page2)
                                                        vm.insidePages.push({
                                                            page1:_page1,
                                                            page2:_page2,
                                                            partid: vm.parts[i].id,
                                                            spread:false
                                                        })
                                                    }else{
                                                        emptyPage.marginLeft = 0;
                                                        vm.insidePages.push({
                                                            page1:_page1,
                                                            page2:emptyPage,
                                                            partid: vm.parts[i].id,
                                                            spread:false
                                                        })
                                                    }
                                                }
                                            }
                                        }
                                    });
                                }else{
                                    vm.parts[i].pages.forEach(function (page, index) {
                                        if($scope.template.config.productType == 'CALENDAR' && (vm.parts[i].id == 'B1' || vm.parts[i].id == 'B2')){
                                            if(page.spread){
                                                page.isUse = true;
                                                page.marginLeft = vm.bindingtype == 'Left' ? (vm.pageMaxWidth-page.custom.width * page.ratio) / 2 : (vm.pageMaxHeight-page.custom.height * page.ratio) / 2;
                                                var _page = angular.copy(page);
                                                _page.marginLeft = vm.bindingtype == 'Left' ? -_page.custom.width*_page.ratio/2 : -_page.custom.height*_page.ratio/2;
                                                vm.insidePages.push({
                                                    page1:emptyPage,
                                                    page2:page,
                                                    partid: vm.parts[i].id,
                                                    spread:false
                                                })
                                            }else{
                                                var emptyPage = angular.copy(page);
                                                if(!emptyPage.background){
                                                    emptyPage.background = {
                                                        color:'',
                                                        resource:{
                                                            identifier:''
                                                        }
                                                    }
                                                }else{
                                                    emptyPage.background.color = "";
                                                    emptyPage.background.resource.identifier="";
                                                }
                                                emptyPage.boxShadow = true;
                                                emptyPage.barcode = null;
                                                emptyPage.qrcode = null;
                                                emptyPage.levels = {
                                                    level: []
                                                };
                                                emptyPage.marginLeft = 0;
                                                page.isUse = true;
                                                if(vm.parts[i].id == 'B1'){
                                                    page.marginLeft = 0;
                                                    emptyPage.marginLeft = vm.bindingtype == 'Left' ? vm.pageMaxWidth/2-emptyPage.custom.width * emptyPage.ratio : vm.pageMaxHeight/2-emptyPage.custom.height * emptyPage.ratio;
                                                    vm.insidePages.push({
                                                        page1:emptyPage,
                                                        page2:page,
                                                        partid: vm.parts[i].id,
                                                        spread:true
                                                    })
                                                }
                                                if(vm.parts[i].id == 'B2'){
                                                    emptyPage.marginLeft = 0;
                                                    page.marginLeft = vm.bindingtype == 'Left' ? vm.pageMaxWidth/2-page.custom.width * page.ratio : vm.pageMaxHeight/2-page.custom.height * page.ratio;
                                                    vm.insidePages.push({
                                                        page1:page,
                                                        page2:emptyPage,
                                                        partid: vm.parts[i].id,
                                                        spread:false
                                                    })
                                                }
                                            }
                                        }else{
                                            page.pageNumber=index;
                                            page.isUse = true;
                                            page.marginLeft = vm.bindingtype == 'Left' ? (vm.pageMaxWidth-page.custom.width * page.ratio) / 2 : (vm.pageMaxHeight-page.custom.height * page.ratio) / 2;
                                            var _page = angular.copy(page);
                                            _page.marginLeft = vm.bindingtype == 'Left' ? -_page.custom.width*_page.ratio/2 : -_page.custom.height*_page.ratio/2;
                                            vm.insidePages.push({
                                                page1:page,
                                                page2:_page,
                                                partid: vm.parts[i].id,
                                                spread:false
                                            })
                                        }
                                    })
                                }
                            }
                        }
                        vm.navParts = angular.copy(vm.parts);
                    }
                }
                var pageOrder = 0;
                function setPageOrder(page){
                    pageOrder++;
                    page.pageNumber=pageOrder<10?'0'+pageOrder:pageOrder;
                }
                $scope.bindingtypeInfo = function () {
                    var _name = "";
                    vm.bindingtypes.forEach(function (item) {
                        if(vm.bindingtype == item.id){
                            _name = item.name;
                        }
                    })
                    return _name
                };
                $scope.bindingtypeSelect = function (item) {
                    vm.bindingtype = item.id;
                    if(vm.bindingtype == 'Left'||vm.bindingtype == 'Top'){
                        vm.loading = true;
                        $timeout(function () {
                            vm.thisPage = 0;
                            config.$bookBlock.bookblock('update');
                            config.$bookBlock.bookblock('jump', (vm.thisPage-0+1));
                            vm.loading = false;
                        },100)
                    }
                }
                var config = {
                    $bookBlock: $('#bb-bookblock'),
                    $navNext: $('#bb-nav-next'),
                    $navPrev: $('#bb-nav-prev'),
                    $slide1: $('#slide1'),
                    $slide2: $('#slide2')
                };
                var Page = (function() {
                    var config = {
                            $bookBlock : $( '#bb-bookblock' ),
                            $navNext : $( '#bb-nav-next' ),
                            $navPrev : $( '#bb-nav-prev' )
                        },
                        init = function() {
                            config.$bookBlock.bookblock( {
                                orientation : vm.bindingtype == "Left" ? 'vertical' : 'horizontal',
                                speed : 800,
                                shadowSides : 0.8,
                                shadowFlip : 0.7,
                                onBeforeFlip: function(page) {
                                    vm.isBefore = true;
                                },
                                onEndFlip: function(page, isLimit) {
                                    vm.isBefore = false;
                                    return false;
                                },
                            } );
                            initEvents();
                            $scope.$apply();
                        },
                        initEvents = function() {
                            var $slides = config.$bookBlock.children();
                            // add navigation events
                            config.$navNext.on( 'click touchstart', function() {
                                config.$bookBlock.bookblock( 'next' );
                                return false;
                            } );

                            config.$navPrev.on( 'click touchstart', function() {
                                config.$bookBlock.bookblock( 'prev' );
                                return false;
                            } );

                            // add keyboard events
                            $(document).keydown( function(e) {
                                var keyCode = e.keyCode || e.which,
                                    arrow = {
                                        left : 37,
                                        up : 38,
                                        right : 39,
                                        down : 40
                                    };

                                if(vm.bindingtype =='Top') {
                                    switch (keyCode) {
                                        case arrow.up:
                                            config.$bookBlock.bookblock('prev');
                                            e.preventDefault();
                                            break;
                                        case arrow.down:
                                            config.$bookBlock.bookblock('next');
                                            e.preventDefault();
                                            break;
                                    }
                                }
                                if(vm.bindingtype =='Left'){
                                    switch (keyCode) {
                                        case arrow.left:
                                            config.$bookBlock.bookblock( 'prev' );
                                            e.preventDefault();
                                            break;
                                        case arrow.right:
                                            config.$bookBlock.bookblock( 'next' );
                                            e.preventDefault();
                                            break;
                                    }
                                }

                            } );
                        };

                    return { init : init };

                })();
                $scope.nextPage = function(index){
                    if(vm.isBefore){
                        return;
                    }
                    if(index==vm.insidePages.length-1){
                        MessageService.error("最后一页");
                        return
                    }
                    vm.thisPage = index+1;
                    config.$bookBlock.bookblock('next');
                    firstPageInit()
                };
                $scope.prevPage = function(index){
                    if(vm.isBefore){
                        return;
                    }
                    if(index==0){
                        if(window.innerWidth>1000){
                            MessageService.error("第一页");
                        }
                        return
                    }
                    vm.thisPage = index-1;
                    config.$bookBlock.bookblock('prev');
                    firstPageInit()
                };
                var a = null;
                $scope.landscape = function (item) {
                    if(vm.isBefore){
                        return;
                    }
                    if (a !== null) {
                        clearTimeout(a)
                    }
                    a = setTimeout(function () {
                        vm.landscape = item;
                        vm.insidePages = [];
                        for(var i=0; i<vm.parts.length; i++){
                            vm.parts[i].pages = [];
                        }
                        ratioInfo();
                        $timeout(function () {
                            vm.thisPage = 0;
                            Page.init();
                        },100)
                        $scope.$apply();
                    },200)
                };

                $scope.firstPageCb = function () {
                    if(vm.thisPage==0){
                        MessageService.error("第一页");
                        return
                    }
                    vm.thisPage = 0;
                    config.$bookBlock.bookblock('first');
                    firstPageInit()
                };
                $scope.lastPageCb = function () {
                    if(vm.thisPage==vm.insidePages.length-1){
                        MessageService.error("最后一页");
                        return
                    }
                    vm.thisPage = vm.insidePages.length-1;
                    config.$bookBlock.bookblock('last');
                    firstPageInit()
                };
                function firstPageInit(){
                    // console.log(vm.thisPage)
                }
                // 滚动导航栏
                function scrollNavToSelected() {
                    var $nav = $('.preview-view-left-2');
                    if (!$nav.length) return;
                    var $selected = $nav.find('.pageSelect');
                    if (!$selected.length) return;
                    var navEl = $nav[0];
                    var el = $selected[0];
                    var elRect = el.getBoundingClientRect();
                    var navRect = navEl.getBoundingClientRect();
                    var elLeft = elRect.left - navRect.left + navEl.scrollLeft;
                    var elRight = elLeft + elRect.width;
                    var viewLeft = navEl.scrollLeft;
                    var viewRight = viewLeft + navEl.clientWidth;
                    if (elLeft >= viewLeft && elRight <= viewRight) return;
                    var targetLeft = elLeft - (navEl.clientWidth - elRect.width) / 2;
                    if (targetLeft < 0) targetLeft = 0;
                    if (typeof navEl.scrollTo === 'function') {
                        try {
                            navEl.scrollTo({ left: targetLeft, behavior: 'smooth' });
                            return;
                        } catch (e) {}
                    }
                    navEl.scrollLeft = targetLeft;
                }
                $scope.$watch(function () { return vm.thisPage; }, function (newVal, oldVal) {
                    if (newVal === oldVal) return;
                    $timeout(scrollNavToSelected);
                });
                $scope.jumpPage = function (partid, index) {
                    if(vm.isBefore){
                        return
                    }
                    var _pageIndex = 0;
                    if(partid != 'P'){
                        for(var i=0; i<vm.insidePages.length; i++){
                            if(vm.insidePages[i].partid == partid){
                                _pageIndex = i;
                                break
                            }
                        }
                    }else{
                        _pageIndex = index;
                    }
                    vm.thisPage = _pageIndex;
                    config.$bookBlock.bookblock('jump', (_pageIndex-0+1));
                    firstPageInit()
                }
                $scope.prevPartShow = function (item) {
                    if(!vm.insidePages || vm.insidePages.length == 0 || !vm.insidePages[vm.thisPage]){
                        return
                    }
                    var _part = vm.insidePages[vm.thisPage].partid;
                    var _returnItem = false;
                    if(item == 'prev'){
                        for(var i=0; i<vm.thisPage; i++){
                            if(vm.insidePages[i].partid != _part){
                                _returnItem = true;
                                break
                            }
                        }
                    }
                    if(item == 'next'){
                        for(var i=vm.thisPage; i<vm.insidePages.length; i++){
                            if(vm.insidePages[i].partid != _part){
                                _returnItem = true;
                                break
                            }
                        }
                    }
                    return _returnItem
                }
                $scope.prevPart = function () {
                    if(vm.isBefore){
                        return
                    }
                    var _part = vm.insidePages[vm.thisPage].partid;
                    for(var i=vm.thisPage; i>=0; i--){
                        if(vm.insidePages[i].partid != _part){
                            vm.thisPage = i;
                            config.$bookBlock.bookblock('jump', (vm.thisPage-0+1));
                            break
                        }
                    }
                }
                $scope.nextPart = function () {
                    if(vm.isBefore){
                        return
                    }
                    var _part = vm.insidePages[vm.thisPage].partid;
                    for(var i=vm.thisPage; i<vm.insidePages.length; i++){
                        if(vm.insidePages[i].partid != _part){
                            vm.thisPage = i;
                            config.$bookBlock.bookblock('jump', (vm.thisPage-0+1));
                            break
                        }
                    }
                }
                $scope.flipPage = function(event,index, bindingtype){
                    console.log('bindingtype',bindingtype);
                    var element = $("#bb-bookblock");
                    if(bindingtype){
                        var clickX = event.clientY;
                        var elementX = element.offset().top;
                        var halfWidth = element.outerHeight() / 2;
                        if (clickX < elementX + halfWidth) {
                            $scope.prevPage(index)
                        } else {
                            $scope.nextPage(index)
                        }
                    }else{
                        if(!vm.landscape){
                            var clickX = event.clientX;
                            var elementX = element.offset().left;
                            var halfWidth = element.outerWidth() / 2;
                            if (clickX < elementX + halfWidth) {
                                $scope.prevPage(index)
                            } else {
                                $scope.nextPage(index)
                            }
                        }else{
                            var _h = $("#bb-bookblock").width();
                            if(event.pageY-$("#bb-bookblock").offset().top > _h / 2){
                                $scope.nextPage(index)
                            }else{
                                $scope.prevPage(index)
                            }
                        }
                    }
                    vm.isBefore = true;
                    $timeout(function () {
                        vm.isBefore = false;
                    },800)
                }
            }]
    };

    angular
        .module('editorApp')
        .component('articlePreview', articlePreview)
        .directive('dragScroll', function () {
            return {
                restrict: 'A',
                link: function (scope, element) {
                    var el = element[0];
                    var isDown = false;
                    var startX = 0;
                    var startScrollLeft = 0;
                    var moved = false;
                    var DRAG_THRESHOLD = 4;

                    // 鼠标按下：记录起点与初始 scrollLeft，准备拖动
                    function onMouseDown(e) {
                        if (e.button !== 0) return; // 仅响应左键
                        isDown = true;
                        moved = false;
                        startX = e.pageX;
                        startScrollLeft = el.scrollLeft;
                        el.style.cursor = 'grabbing';
                        el.style.userSelect = 'none';
                        e.preventDefault();
                    }

                    // 鼠标移动：按位移量改写 scrollLeft 实现横向拖动滚动
                    function onMouseMove(e) {
                        if (!isDown) return;
                        var dx = e.pageX - startX;
                        if (Math.abs(dx) > DRAG_THRESHOLD) {
                            moved = true;
                        }
                        el.scrollLeft = startScrollLeft - dx;
                    }

                    // 结束拖动，恢复光标
                    function stopDrag() {
                        if (!isDown) return;
                        isDown = false;
                        el.style.cursor = '';
                        el.style.userSelect = '';
                    }

                    // 拖动发生后在捕获阶段拦截 click，避免触发缩略图 ng-click 跳转
                    function onClickCapture(e) {
                        if (moved) {
                            e.stopPropagation();
                            e.preventDefault();
                            moved = false;
                        }
                    }

                    element.on('mousedown', onMouseDown);
                    el.addEventListener('click', onClickCapture, true);
                    $(document).on('mousemove', onMouseMove);
                    $(document).on('mouseup', stopDrag);

                    scope.$on('$destroy', function () {
                        element.off('mousedown', onMouseDown);
                        el.removeEventListener('click', onClickCapture, true);
                        $(document).off('mousemove', onMouseMove);
                        $(document).off('mouseup', stopDrag);
                    });
                }
            };
        });
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .factory('Editors', Editors);

    Editors.$inject = ['$state', 'Product'];

    function Editors ($state, Product) {

        var service = {
            navigateTo: navigateTo,
            navigateSelect: navigateSelect
        };

        return service;


        function startMobileMade(pid, vid, xmlId) {
            localStorage.removeItem("delPic");
            localStorage.removeItem("picArrChoose");
            localStorage.removeItem("picArrChoose2");
            localStorage.removeItem("gallery2");
            localStorage.removeItem("picArrCopy");
            localStorage.removeItem("picArr");
            localStorage.removeItem("isSort");
            var workSave = JSON.parse(localStorage.getItem('work-save'));
            if (workSave) {
                var nearHour = (new Date().getTime() - workSave.date) / 1000 / 3600;
                console.log(nearHour);
                if (workSave.pid == pid && workSave.vid == vid && (workSave.xmlId == xmlId || workSave.xmlId == "null" && xmlId == null) && nearHour <= 3) {
                    return
                }
            }

            localStorage.setItem("Production", "start");
            localStorage.removeItem("choose");
            localStorage.removeItem("multipartUpload");
            localStorage.removeItem("index");
            localStorage.removeItem("i");
            localStorage.removeItem("go");
            localStorage.removeItem("single");
            localStorage.removeItem("pages");
            localStorage.removeItem("marginLeft");
            localStorage.removeItem("$index");
            localStorage.removeItem("next");
            localStorage.removeItem("gallery");
            localStorage.removeItem("galleryCopy");
            localStorage.removeItem("saveOldPage");
            localStorage.removeItem("saveOldPageIndex");
            localStorage.removeItem("reviewPages");
            localStorage.removeItem("pageAllPx");
            localStorage.removeItem("pageAllMm");
            localStorage.removeItem("work-save");
            localStorage.setItem('countN', 1);

            var gallerys = JSON.parse(localStorage.getItem('gallery'));
            angular.forEach(gallerys, function (gallery) {
                gallery.useNum = 0;       //次数清零
            });
            localStorage.setItem('gallery', JSON.stringify(gallerys));
        };

        /*
        *   导航到编辑器
        *   storeId - 商户id - 必需
        *   options:
        *       editorType - 编辑器类型 - 必需
        *       pid - 产品ID - 必需
        *       vid - skuID - 必需
        *       xmlId - 模版ID - 必需
        *       aid - 作品ID - 可选
        *       pictureType - 冲印单双面 - 可选
        *       mobile - 是否移动端, true/false
        */
        function navigateTo (storeId, options) {
            if (!storeId || !options || !options.pid || !options.vid || !options.xmlId) {
                console.log("can't navigate to editor!!!!, storeId=" + storeId + ", options:", options);
                return;
            }
            var isMobile = !!options.mobile;
            var editorType = options.editorType || '';

            if (!isMobile) {
                if (editorType == "PICTURE" || editorType == "PICTURE_PRO" || editorType == "PICTURE_PRO_P") {
                    $state.go("editorPhotoBothWeb", {storeId: storeId, pid: options.pid, vid: options.vid, xmlId: options.xmlId, aid: options.aid}, {location: 'replace'});
                }else{
                    $state.go("editorPhotoAlbum", {storeId: storeId, pid: options.pid, vid: options.vid, xmlId: options.xmlId, aid: options.aid}, {location: 'replace'});
                }
            }
            else {
                startMobileMade(options.pid, options.vid, options.xmlId);
                if (editorType == null || editorType == "" || editorType == "BOOK_SENIOR") {
                    $state.go('product-chooseNew-ec', {storeId: storeId, pid: options.pid, vid: options.vid, xmlId: options.xmlId, aid: options.aid}, {location: 'replace'});
                } else if (editorType == "BOOK_JUNIOR") {
                    $state.go('product-choose-ec', {storeId: storeId, pid: options.pid, vid: options.vid, xmlId: options.xmlId, aid: options.aid}, {location: 'replace'});
                }  else if (editorType == "PICTURE" || editorType == "PICTURE_PRO" || editorType == "PICTURE_PRO_P") {
                    $state.go('editorPhotoBoth', {storeId: storeId, pid: options.pid, vid: options.vid, xmlId: options.xmlId, aid: options.aid}, {location: 'replace'});
                } else if (editorType == "PHOTO_EDITOR") {
                    $state.go('idPhoto', {storeId: storeId, pid: options.pid, vid: options.vid, xmlId: options.xmlId, aid: options.aid}, {location: 'replace'});
                } else if (editorType == "POSTER" || editorType == "DIY_EDITOR") {
                    $state.go('product-chooseThree-ec', {storeId: storeId, pid: options.pid, vid: options.vid, xmlId: options.xmlId, aid: options.aid}, {location: 'replace'});
                } else if (editorType == "FORM_EDITOR") {
                    $state.go('editorForm', {storeId: storeId, pid: options.pid, vid: options.vid, xmlId: options.xmlId, aid: options.aid}, {location: 'replace'});
                } else if (editorType == "NEW_EDITOR"||editorType == "CALENDAR_EDITOR") {
                    $state.go('editorPhotoAlbumM', {storeId: storeId, pid: options.pid, vid: options.vid, xmlId: options.xmlId, aid: options.aid}, {location: 'replace'});
                } else {
                    $state.go('product-chooseNew-ec', {storeId: storeId, pid: options.pid, vid: options.vid, xmlId: options.xmlId, aid: options.aid}, {location: 'replace'});
                }
            }
        }

        /*
        *   导航到模版选择或者编辑器
        *   storeId - 商户id - 必需
        *   options:
        *       editorType - 编辑器类型 - 必需
        *       pid - 产品ID - 必需
        *       vid - skuID - 必需
        *       xmlId - 模版ID - 必需
        *       aid - 作品ID - 可选
        *       pictureType - 冲印单双面 - 可选
        *       mobile - 是否移动端, true/false
        *       selectState - 选择器 - 必需
        */
        function navigateSelect(storeId, options) {
            if (!storeId || !options || !options.pid || !options.vid) {
                console.log("can't navigate to editor!!!!, storeId=" + storeId + ", options=" + options);
                return;
            }
            var vm = this;

            var selectState = options.selectState || 'commoditySelect';
            Product.get({id: options.pid}, function(res) {
                var product = res.data;

                var xmlCount = 0;
                var xml = null;
                if (product.itemValues != null && product.itemValues.length > 0) {
                    for (var i = 0; i < product.itemValues.length; i++) {
                        var itemValue = product.itemValues[i];
                        if (itemValue.id == options.vid) {
                            if (itemValue.productXmlLines && itemValue.productXmlLines.length) {
                                for (var j = 0; j < itemValue.productXmlLines.length; j++) {
                                    var line = itemValue.productXmlLines[j];
                                    if (!line.cancelled) {
                                        xmlCount++;
                                        xml = line;
                                    }
                                }
                                if (xmlCount == 1 && xml) {
                                    var editorType = itemValue.productEditorType || product.productEditorType || options.editorType;
                                    vm.navigateTo(storeId, {editorType: editorType, pid: options.pid, vid: options.vid, xmlId: xml.id, aid: options.aid, pictureType: product.pictureType, mobile: options.mobile});
                                    return;
                                }
                            }
                            break;
                        }
                    }
                }

                $state.go(selectState, {storeId: storeId, pid: options.pid, vid: options.vid, xmlId: null, aid: options.aid}, {location: 'replace'});
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .controller('CommoditySelectController', CommoditySelectController);

    CommoditySelectController.$inject = ['$scope', 'Principal', 'Product', '$state', 'MessageService', '$localStorage',
        '$stateParams', '$uibModal', 'Qinius', '$q', '$timeout','$translate', '$translatePartialLoader', '$cookies', 'translationStorageProvider'];

    function CommoditySelectController ($scope, Principal, Product, $state, MessageService, $localStorage,
                                        $stateParams, $uibModal, Qinius, $q, $timeout,$translate, $translatePartialLoader, $cookies, translationStorageProvider) {
        var vm = this;

        $(".navbar-gallery").hide();
        $(".wrap").show().addClass('no-margins');
        $(".well").css({'margin-bottom': 0});

        vm.storeId = $stateParams.storeId;
        vm.pid = $stateParams.pid;
        vm.aid = $stateParams.aid;
        vm.vid = $stateParams.vid;
        // vm.product = entity.data;
        vm.domains = Qinius.getDomain({storeId:vm.storeId});
        vm.themeId = 'all';
        vm.themeList = [{id: 'all', name: $translate.instant("commodity.theme.all")}];
        vm.itemValue = null;
        vm.productXmlList = [];  //页面展示的集合
        vm.productXmlListCB = [];  //当前属性的模板集合
        vm.properties = [];
        vm.returnurl1 = localStorage.getItem('returnurl1') || null;


        //测试时使用
        // $localStorage.lagnuages = ['zh-cn', 'en'];
        $scope.showLagnuages = function(){
            vm.showLagnuages = !vm.showLagnuages;
            if (vm.showLagnuages) {
                $(".lang-icn").css({'transform': 'rotate(270deg)'});
            }else{
                $(".lang-icn").css({'transform': 'rotate(90deg)'});
            }
        }

        lagnuageInit();
        function lagnuageInit() {
            vm.lang = $cookies.getObject("NG_TRANSLATE_LANG_KEY");
            vm.lagnuages =[];
            if ($localStorage.lagnuages) {
                for(var i = 0 ; i<$localStorage.lagnuages.length; i++ ){
                    var lang = $localStorage.lagnuages[i];
                    var result = translationStorageProvider.getLanguageType(lang);
                    if (!!result) {
                        if (vm.lang == result.value) {
                            vm.langKey = result.key;
                            result.selected = true;
                        }
                        vm.lagnuages.push(result);
                    }
                }
            }
            vm.productEntity = Product.get({id: $stateParams.pid});
            $q.all([vm.productEntity.$promise, vm.domains.$promise]).then(function () {
                vm.product = vm.productEntity.data;
                $scope.init();
            });
        }
        //swiper
        function swiper() {
            var swiper = new Swiper('.swiper-container1', {
                slidesPerView: 7,
                slidesPerGroup : 7,
                spaceBetween : 36,
                navigation: {
                    nextEl: '.swiper-button-next1',
                    prevEl: '.swiper-button-prev1',
                },
            });
        }

        $scope.changeLagnuage = function(lang){
            $timeout(function () {
                if (lang == null || lang.key == vm.langKey ) {
                    return;
                }
                angular.forEach(vm.lagnuages, function(item){
                    item.selected =false;
                });
                lang.selected = true;
                vm.langKey = lang.key;
                $translate.use(lang.value);
                vm.showLagnuages =false;
                $timeout(function () {
                    lagnuageInit();
                },100)
            })
        }



        $scope.returnurl1 = function(){
            if(vm.returnurl1){
                window.location.href = vm.returnurl1;
            }
        }

         //商户：先编辑后支付 且 商品：定制 点选属性值事件
        $scope.switchPaper = function (value , pValue) {
            if (!pValue.available) {
                return;
            }
            for (var i = value.propertyValues.length - 1; i >= 0; i--) {
                if (value.propertyValues[i].id == pValue.id) {
                    continue;
                }
                value.propertyValues[i].selected = false;
            }
            pValue.selected  = !pValue.selected;
            if (pValue.selected) {
                value.selected = true;
            }else{
                value.selected = false;
            }

            $scope.restoreAvailable(vm.product.itemValue.objectValues);
            $scope.getAvailable(vm.product.itemValues, vm.product.itemValue.objectValues);

            var valueArray = [];
            for (var i = vm.product.itemValue.objectValues.length - 1; i >= 0; i--) {
                var value = vm.product.itemValue.objectValues[i];
                for (var j = value.propertyValues.length - 1; j >= 0; j--) {
                    var pv = value.propertyValues[j];
                    if (pv.selected) {
                        valueArray.push(pv.propertyId + "_" + pv.id);
                    }
                }
            }
            vm.product.itemValue.valueArray = valueArray;
            vm.itemValue = null;
            for(var i=0;i<vm.product.itemValues.length;i++){
                var itemValue = vm.product.itemValues[i];
                if (itemValue.cancelled) {
                    continue;
                }
                if (JSON.stringify(itemValue.valueArray.sort()) === JSON.stringify(vm.product.itemValue.valueArray.sort())) {
                    vm.itemValue = itemValue;

                }
            }
            $scope.getProductXmlList();
            paging();
            $scope.getThemeList();
        }

        $scope.getProductXmlList = function(){
            vm.productXmlListCB = [];
            if (vm.itemValue == null) {
                return;
            }
            for (var i = 0 ; i<vm.itemValue.productXmlLines.length ; i++) {
                var productXmlLine = vm.itemValue.productXmlLines[i];
                if (productXmlLine.cancelled) {
                    continue;
                }
                vm.productXmlListCB.push(productXmlLine);
            }
            vm.productXmlListCB = vm.productXmlListCB.sort(function(a, b ){
                return a.seq-b.seq;
            })
        }

        $scope.includePropertyValue = function(propertyValues, obValue){
            if (propertyValues == null || propertyValues.length == 0) {
                return false;
            }
            for (var i = propertyValues.length - 1; i >= 0; i--) {
                var pValue = propertyValues[i];
                if (pValue.id == obValue.propertyValueId ) {
                    return true;
                }
            }
            return false;
        }

        $scope.isInclude = function(elememt, array) {
            if (array.indexOf(elememt)>=0) {
                return true;
            }
            return false;
        }


        $scope.setPropertyValue = function(item, obValue){
            if (item == null || item.objectValues == null || item.objectValues.length == 0) {
                return null;
            }
            for (var i = item.objectValues.length - 1; i >= 0; i--) {
                var objectValue = item.objectValues[i];
                if (objectValue.propertyId == obValue.propertyId) {
                    if (!$scope.includePropertyValue(objectValue.propertyValues, obValue)) {
                        objectValue.propertyValues.push({
                            id:obValue.propertyValueId,
                            value :obValue.propertyValueValue,
                            propertyId:obValue.propertyId,
                            propertyName: obValue.propertyName
                        })
                    }
                }
            }
        }

         //先将所有可选项置为可选择的
        $scope.restoreAvailable = function(values) {
            for (var i = values.length - 1; i >= 0; i--) {
                var value = values[i];
                for (var j = value.propertyValues.length - 1; j >= 0; j--) {
                    value.propertyValues[j].available = true;
                }
            }
        }

        //判断余下属性值是否可以点选
        $scope.getAvailable = function(arrayValues, values) {
            var selectedValue = [];
            for (var i = values.length - 1; i >= 0; i--) {
                var value = values[i];
                for (var j = value.propertyValues.length - 1; j >= 0; j--) {
                    var pv = value.propertyValues[j];
                    if (!$scope.isAvailable(arrayValues, [pv.propertyId + "_" + pv.id])) {
                        value.propertyValues[j].available = false;
                    }
                }
            }

            //先将选择的都拿出来
            for (var i = values.length - 1; i >= 0; i--) {
                var value = values[i];
                if (value.selected) {
                    for (var j = value.propertyValues.length - 1; j >= 0; j--) {
                        var pv = value.propertyValues[j];
                        if (pv.selected) {
                            selectedValue.push(pv.propertyId + "_" + pv.id);
                        }
                    }
                }
            }
            //没有选中的行 选项是否可以被选择
            for (var i = values.length - 1; i >= 0; i--) {
                var value = values[i];
                if (!value.selected) {
                    for (var z = value.propertyValues.length - 1; z >= 0; z--) {
                        var pv = value.propertyValues[z];
                        if (!pv.available) {
                            continue;
                        }
                        var selectedValueBack = angular.copy(selectedValue);
                        selectedValueBack.push((pv.propertyId + "_" + pv.id));
                        if (!$scope.isAvailable(arrayValues, selectedValueBack)) {
                            pv.available = false;
                        }
                    }
                }
            }
            //选中的行  将本行取出 拿本行其他选项与 其他行已经选中的搭配看是否可以选中
            for (var i = values.length - 1; i >= 0; i--) {
                var value = values[i];
                if (value.selected ) {
                    var selectedValueBack = angular.copy(selectedValue);
                    for (var j = selectedValueBack.length - 1; j >= 0; j--) {
                        var selectV = selectedValueBack[j];  //3_10
                        if (selectV.split("_")[0]== value.propertyId) {
                            selectedValueBack.splice(j,1);
                            for (var z = value.propertyValues.length - 1; z >= 0; z--) {
                                var pValue = value.propertyValues[z];
                                if (pValue.selected || !pValue.available) {
                                    continue;
                                }
                                var selectedValueBack2 = angular.copy(selectedValueBack);
                                selectedValueBack2.push(pValue.propertyId + "_" + pValue.id);
                                if (!$scope.isAvailable(arrayValues, selectedValueBack2)) {
                                    pValue.available = false;
                                }
                            }
                        }
                    }
                }
            }
        }

        //判断属性值是否可以点选
        $scope.isAvailable = function(arrayValues, selectedValueBack) {
            for (var z = arrayValues.length - 1; z >= 0; z--) {
                var l = arrayValues[z];
                if (l.cancelled) {
                    continue;
                }

                var includes = true;
                for (var i = selectedValueBack.length - 1; i >= 0; i--) {
                    var el = selectedValueBack[i];
                    if (!$scope.isInclude(el, l.valueArray)) {
                        includes = false;
                        break;
                    }
                }
                if (includes) {
                    return true;
                }
            }
            return false;
        }

        $scope.init = function(){
            $scope.domain = 'https://' + vm.domains.domains[0] + '/';
            vm.editorType = vm.product.editorType;

            for (var i = 0; i < vm.product.itemValues.length; i++) {
                var item = vm.product.itemValues[i];
                if (item.cancelled || item.id != vm.vid) {
                    continue;
                }
                vm.product.itemValue = angular.copy(item);
                vm.product.itemValue.valueArray = vm.product.itemValue.skuNumber.split("-");
                vm.itemValue = angular.copy(item);
                if (vm.product.itemValue.objectValues && vm.product.itemValue.objectValues.length > 0) {
                    for (var z = vm.product.itemValue.objectValues.length - 1; z >= 0; z--) {
                        var value = vm.product.itemValue.objectValues[z];
                        value.selected = true;
                        for (var j = value.propertyValues.length - 1; j >= 0; j--) {
                            if (value.propertyValueId == value.propertyValues[j].id) {
                                value.propertyValues[j].selected = true;
                            }
                        }
                    }
                }
                break;
            }

            if (vm.product.itemValues && vm.product.itemValues.length>0) {
                for (var i = vm.product.itemValues.length - 1; i >= 0; i--) {
                    var item = vm.product.itemValues[i];
                    if (item.cancelled) {
                        continue;
                    }
                    item.valueArray = item.skuNumber.split("-");
                }
            }

            if (vm.product.itemValue) {
                for (var i = vm.product.itemValue.objectValues.length - 1; i >= 0; i--) {
                    var objectValue = vm.product.itemValue.objectValues[i];
                    for (var j = objectValue.propertyValues.length - 1; j >= 0; j--) {
                        var value = objectValue.propertyValues[j];
                        if (!value.selected) {
                            objectValue.propertyValues.splice(j, 1);
                        }
                    }
                }
                for (var i = vm.product.itemValues.length - 1; i >= 0; i--) {
                    var itL = vm.product.itemValues[i];
                    if (itL.cancelled) {
                        continue;
                    }
                    for (var j = itL.objectValues.length - 1; j >= 0; j--) {
                        var ov = itL.objectValues[j];
                        $scope.setPropertyValue(vm.product.itemValue, ov);
                    }
                }
                $scope.restoreAvailable(vm.product.itemValue.objectValues);
                $scope.getAvailable(vm.product.itemValues, vm.product.itemValue.objectValues);
            }

            $scope.getProductXmlList();
            paging();
            $scope.getThemeList();

            setTimeout(function () {
                var _h = $("#c-commodity-top-content").height();
                if(_h > 35){
                    $("#c-commodity-top-content").css({height: '35px'});
                    $("#c-commodity-top-btn").show();
                }
                $("#c-commodity-top-btn").on('click', function () {
                    if($("#c-commodity-top-content").height() > 35){
                        $("#c-commodity-top-content").css({height: '35px'});
                    }else {
                        $("#c-commodity-top-content").css({height: 'auto'});
                    }
                });

                $(".c-commodity-top1").each(function () {
                    var _that = this;
                    var _h1 = $(this).find(".c-commodity-top-content").height();
                    if(_h1 > 35){
                        $(this).find(".c-commodity-top-content").css({height: '35px'});
                        $(this).find(".c-commodity-top-btn").show();
                    }
                    $(this).find(".c-commodity-top-btn").on('click', function () {
                        if($(_that).find(".c-commodity-top-content").height() > 35){
                            $(_that).find(".c-commodity-top-content").css({height: '35px'});
                        }else {
                            $(_that).find(".c-commodity-top-content").css({height: 'auto'});
                        }
                    });
                })
            }, 500);
            $scope.themeCb(vm.themeList[0]);

            $timeout(function () {
                swiper();
            },300);
        }

        // $q.all([vm.product.$promise, vm.domains.$promise]).then(function () {
        //     $scope.init();
        // });

        $scope.getThemeList = function(){
            vm.themeList = [{id: 'all', name: $translate.instant("commodity.theme.all")}];
            if (vm.itemValue == null) {
                return;
            }

            if (vm.itemValue.productXmlLines != null && vm.itemValue.productXmlLines.length>0) {
                for (var i = 0; i < vm.itemValue.productXmlLines.length; i++) {
                    var xmlLine = vm.itemValue.productXmlLines[i];
                    if (!xmlLine.themeClassifies || xmlLine.cancelled||!xmlLine.paid) {
                        continue;
                    }
                    xmlLine.themeClassifies.forEach(function (themeClassifie) {
                        if(!checkRepetition(themeClassifie.id)){
                            vm.themeList.push({
                                id: themeClassifie.id,
                                name: themeClassifie.name,
                                seq: Number(xmlLine.productXmlThemeSeq) + Number(themeClassifie.seq)
                            });
                        }
                    })
                }
            }
            vm.themeList.sort(function (a, b) {
                return a.seq - b.seq;
            });
        }

        $scope.themeCb = function (data) {
            if (vm.themeId == data.id) {
                return ;
            }
            vm.themeId = data.id;
            formatting();
        };

        function formatting() {
            vm.page = 1;
            vm.productXmlListCB = [];  //用来确认是那些 可以展示的 xmllines  将会通过 cancelled、themeId过滤
            $scope.getThemeList();
            if(vm.themeId != 'all'){
                if (vm.itemValue.productXmlLines != null && vm.itemValue.productXmlLines.length>0) {
                    for (var i = 0; i< vm.itemValue.productXmlLines.length ;i++) {
                        var xmlLine = vm.itemValue.productXmlLines[i];
                        if(!xmlLine.notAvailable&&!xmlLine.cancelled&&xmlLine.paid){
                            var _exist = false;
                            xmlLine.themeClassifies.forEach(function (themeClassifie) {
                                if (vm.themeId ==  themeClassifie.id) {
                                    _exist = true;
                                }
                            })
                            if (_exist) {
                                vm.productXmlListCB.push(xmlLine);
                            }
                        }
                    }
                }
            } else{
                if (vm.itemValue.productXmlLines != null && vm.itemValue.productXmlLines.length>0) {
                    for (var i = 0; i< vm.itemValue.productXmlLines.length ;i++) {
                        var xmlLine = vm.itemValue.productXmlLines[i];
                        if(!xmlLine.notAvailable&&!xmlLine.cancelled&&xmlLine.paid){
                            vm.productXmlListCB.push(xmlLine);
                        }
                    }
                }
            }
            vm.productXmlListCB = vm.productXmlListCB.sort(function(a, b ){
                return a.seq-b.seq;
            })
            paging();
        }

        function paging() {
                var nums = 10; //每页出现的数量
                var pages = Math.ceil(vm.productXmlListCB.length/nums); //得到总页数
                var thisDate = function(curr){
                    //此处只是演示，实际场景通常是返回已经当前页已经分组好的数据
                    var str = [], last = curr*nums - 1;
                    last = last >= vm.productXmlListCB.length ? (vm.productXmlListCB.length-1) : last;
                    for(var i = (curr*nums - nums); i <= last; i++){
                        str.push(vm.productXmlListCB[i]);
                    }
                    if (str.length>0) {
                        str = str.sort(function(a, b ){
                            return a.seq-b.seq;
                        })
                    }
                    return str;
                };

                //调用分页
                laypage({
                    cont: 'biuuu_city',
                    curr: vm.page, //初始化当前页
                    pages: pages,
                    skip: true, //是否开启跳页
                    first: false,
                    last: false,
                    jump: function(obj){
                        $timeout(function () {
                            vm.productXmlList = thisDate(obj.curr);
                            vm.productXmlList.sort(sortNavTitle("seq"));
                            vm.page = obj.curr;
                        })
                    }
                });
        }

        function sortNavTitle(propertyName) {
            return function(object1, object2) {
                var value1 = object1[propertyName];
                var value2 = object2[propertyName];
                return value1 - value2;
            }
        }
        // 检查是否存在重复--vm.themeList
        function checkRepetition(id) {
            if (vm.themeList.length == 0) {
                return false;
            } else {
                for (var i = 0; i < vm.themeList.length; i++) {
                    if (vm.themeList[i].id == id) {
                        return true;
                    }
                }
            }
            return false;
        }
        //预览
        $scope.commodityPreview = function (value){
            $uibModal.open({
                templateUrl: 'app/entities/commodity/commodity-preview.html',
                controller: 'CommodityPreviewController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: [function() {
                        var _obj = {
                            storeId :vm.storeId,
                            pid :vm.pid,
                            value: value,
                            itemValueId: vm.itemValue.id,
                            aid:vm.aid,
                            vid:vm.vid,
                            editorType:vm.product.editorType
                        }
                        return _obj;
                    }],
                    translatePartialLoader: [function () {
                        $translatePartialLoader.addPart('commodityPage');
                        $translatePartialLoader.addPart('common');
                        return $translate.refresh();
                    }],
                }
            }).result.then(function (backData) {
                console.log(backData);
            });
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .controller('CommodityPreviewController', CommodityPreviewController);

    CommodityPreviewController.$inject = ['$scope', 'Principal', 'Product', '$state', 'MessageService', 'Customer', '$rootScope', 'entity', '$stateParams', '$uibModalInstance', 'ProductXml', 'Qinius', '$q'];

    function CommodityPreviewController ($scope, Principal, Product, $state, MessageService, Customer, $rootScope, entity, $stateParams, $uibModalInstance, ProductXml, Qinius, $q) {
        var vm = this;
        $(".wrap").show();
        $(".navbar").show();
        vm.itemValue = entity.value;
        vm.storeId = entity.storeId;
        vm.pid = entity.pid;
        vm.vid = entity.vid;
        vm.aid = entity.aid;
        vm.isMake = entity.isMake || false;
        vm.itemId = entity.itemValueId;
        vm.editorType = entity.editorType;

        if (entity.isShowbotton != null) {
            vm.isShowbotton = entity.isShowbotton
        }else{
            vm.isShowbotton = true;
        }
        console.log(entity);
        vm.height = 937; document.body.clientHeight ;
        vm.domains = Qinius.getDomain({storeId:vm.storeId});

        Product.get({id: vm.pid}, function (res) {
            vm.product = res.data;
        })
        $q.all([vm.domains.$promise]).then(function () {
            $scope.domain = 'https://' + vm.domains.domains[0] + '/';
            init()
        });
        //初始化
        function init(){

            //获取预览图片
            ProductXml.get({id:vm.itemValue.productXmlId},function(res){
                if(res.status == 200){
                    if (res.data.documentPics && res.data.documentPics.length > 0) {
                        res.data.documentPics.sort(function (a, b) {
                            return a.seq - b.seq;
                        });
                    }
                    vm.imgs = res.data.documentPics;
                    setTimeout(function () {
                        swiper();
                    },300);
                }else {
                    MessageService.error(res.message);
                }

            },function(){

            });
        };
        $scope.modalHide = function(){
            $uibModalInstance.close();
        };
        $scope.modalSubmint = function(){
            var vid = vm.vid;
            if(vm.itemId){
                vid = vm.itemId
            }
            if (vm.editorType == "PICTURE" || vm.editorType == "PICTURE_PRO" || vm.editorType == "PICTURE_PRO_P") {
                $state.go("editorPhotoBothWeb", {storeId: vm.storeId, pid: vm.pid, vid: vid, xmlId: vm.itemValue.id, aid: vm.aid},{location: 'replace'});
            }else{
                $state.go("editorPhotoAlbum", {storeId: vm.storeId, pid: vm.pid, vid: vid, xmlId: vm.itemValue.id, aid: vm.aid},{location: 'replace'});
            }
            $uibModalInstance.close();
        };
        //swiper
        function swiper() {
            var swiper = new Swiper('.swiper-container', {
                pagination: {
                    el: '.swiper-pagination',
                    type: 'fraction',
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            });
        }
        $scope.valueSeleted = function () {
            var url = $state.href("page-my-suffix-edit", {storeId: vm.storeId, pid: vm.pid, vid: vm.itemValue.itemValueId, aid: vm.aid});
            window.open(url,'_blank');
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('commodity', {
                parent: 'account',
                url: '/{storeId}/commodity',
                data: {
                    authorities: [],
                    pageTitle: 'global.menu.entities.commodity-center'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/commodity/commodity.html',
                        controller: 'CommodityController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('commodityPage');
                        $translatePartialLoader.addPart('common');
                        return $translate.refresh();
                    }]
                }
            })

            .state('commoditySelect', {
                parent: 'account',
                url: '/{storeId}/{pid}/{vid}/{aid}/commoditySelect',
                data: {
                    authorities: [],
                    pageTitle: 'commodity.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/commodity/commodity-select.html',
                        controller: 'CommoditySelectController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('commodityPage');
                        $translatePartialLoader.addPart('common');
                        return $translate.refresh();
                    }],
                    // entity: ['$stateParams', 'Product', function ($stateParams, Product) {
                    //     return Product.get({id: $stateParams.pid}).$promise;
                    // }]
                }
            })
        ;
    }
})();

!function(a,b,c){function d(a){var c="default";a.self_redirect===!0?c="true":a.self_redirect===!1&&(c="false");var d=b.createElement("iframe"),e="https://open.weixin.qq.com/connect/qrconnect?appid="+a.appid+"&scope="+a.scope+"&redirect_uri="+a.redirect_uri+"&state="+a.state+"&login_type=jssdk&self_redirect="+c;e+=a.style?"&style="+a.style:"",e+=a.href?"&href="+a.href:"",d.src=e,d.frameBorder="0",d.allowTransparency="true",d.scrolling="no",d.width="300px",d.height="400px";var f=b.getElementById(a.id);f.innerHTML="",f.appendChild(d)}a.WxLogin=d}(window,document);
(function(){
	'use strict';
	angular
	.module('editorApp')
	.factory('UidService',UidService);

	UidService.$inject = ['$localStorage'];
	
	function UidService($localStorage){
		console.log($localStorage)
		var service={
			get:get
		}
		function get(){
			
			var d = new Date().getTime();
			var uid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
				var r = (d + Math.random() * 16) % 16 | 0;
				d = Math.floor(d / 16);
				return (c == 'x' ? r : (r & 0x7 | 0x8)).toString(16);
			});
			if($localStorage && $localStorage.article && $localStorage.article.id){
				uid += '-' + $localStorage.article.id;
			}
			return uid;
		}
		return service;
	}

})();
/**
 * turn.js 4th release
 * turnjs.com
 * turnjs.com/license.txt
 *
 * Copyright (C) 2012 Emmanuel Garcia
 * All rights reserved
 **/

(function($) {

    'use strict';

    var has3d,

        hasRot,

        vendor = '',

        version = '4.1.0',

        PI = Math.PI,

        A90 = PI/2,

        isTouch = 'ontouchstart' in window,

        mouseEvents = (isTouch) ?
            {
                down: 'touchstart',
                move: 'touchmove',
                up: 'touchend',
                over: 'touchstart',
                out: 'touchend'
            }
            :
            {
                down: 'mousedown',
                move: 'mousemove',
                up: 'mouseup',
                over: 'mouseover',
                out: 'mouseout'
            },

        // Contansts used for each corner
        //   | tl * tr |
        // l | *     * | r
        //   | bl * br |

        corners = {
            backward: ['bl', 'tl'],
            forward: ['br', 'tr'],
            all: ['tl', 'bl', 'tr', 'br', 'l', 'r']
        },

        // Display values

        displays = ['single', 'double'],

        // Direction values

        directions = ['ltr', 'rtl'],

        // Default options

        turnOptions = {

            // Enables hardware acceleration

            acceleration: true,

            // Display

            display: 'double',

            // Duration of transition in milliseconds

            duration: 600,

            // First page

            page: 1,

            // Enables gradients

            gradients: true,

            // Corners used when turning the page

            turnCorners: 'bl,br',

            // Events

            when: null
        },

        flipOptions = {

            // Size of the active zone of each corner

            cornerSize: 100

        },

        // Number of pages in the DOM, minimum value: 6

        pagesInDOM = 6,


        turnMethods = {

            // Singleton constructor
            // $('#selector').turn([options]);

            init: function(options) {

                // Define constants

                has3d = 'WebKitCSSMatrix' in window || 'MozPerspective' in document.body.style;
                hasRot = rotationAvailable();
                vendor = getPrefix();

                var i, that = this, pageNum = 0, data = this.data(), ch = this.children();

                // Set initial configuration

                options = $.extend({
                    width: this.width(),
                    height: this.height(),
                    direction: this.attr('dir') || this.css('direction') || 'ltr'
                }, turnOptions, options);

                data.opts = options;
                data.pageObjs = {};
                data.pages = {};
                data.pageWrap = {};
                data.pageZoom = {};
                data.pagePlace = {};
                data.pageMv = [];
                data.zoom = 1;
                data.totalPages = options.pages || 0;
                data.eventHandlers = {
                    touchStart: $.proxy(turnMethods._touchStart, this),
                    touchMove: $.proxy(turnMethods._touchMove, this),
                    touchEnd: $.proxy(turnMethods._touchEnd, this),
                    start: $.proxy(turnMethods._eventStart, this)
                };



                // Add event listeners

                if (options.when)
                    for (i in options.when)
                        if (has(i, options.when))
                            this.bind(i, options.when[i]);

                // Set the css

                this.css({position: 'relative', width: options.width, height: options.height});

                // Set the initial display

                this.turn('display', options.display);

                // Set the direction

                if (options.direction!=='')
                    this.turn('direction', options.direction);

                // Prevent blue screen problems of switching to hardware acceleration mode
                // By forcing hardware acceleration for ever

                if (has3d && !isTouch && options.acceleration)
                    this.transform(translate(0, 0, true));

                // Add pages from the DOM

                for (i = 0; i<ch.length; i++) {
                    if ($(ch[i]).attr('ignore')!='1') {
                        this.turn('addPage', ch[i], ++pageNum);
                    }
                }

                // Event listeners

                $(this).bind(mouseEvents.down, data.eventHandlers.touchStart).
                bind('end', turnMethods._eventEnd).
                bind('pressed', turnMethods._eventPressed).
                bind('released', turnMethods._eventReleased).
                bind('flip', turnMethods._flip);

                $(this).parent().bind('start', data.eventHandlers.start);

                $(document).bind(mouseEvents.move, data.eventHandlers.touchMove).
                bind(mouseEvents.up, data.eventHandlers.touchEnd);

                // Set the initial page

                this.turn('page', options.page);

                // This flipbook is ready

                data.done = true;

                return this;
            },

            // Adds a page from external data

            addPage: function(element, page) {

                var currentPage,
                    className,
                    incPages = false,
                    data = this.data(),
                    lastPage = data.totalPages+1;

                if (data.destroying)
                    return false;

                // Read the page number from the className of `element` - format: p[0-9]+

                if ((currentPage = /\bp([0-9]+)\b/.exec($(element).attr('class'))))
                    page = parseInt(currentPage[1], 10);

                if (page) {

                    if (page==lastPage)
                        incPages = true;
                    else if (page>lastPage)
                        throw turnError('Page "'+page+'" cannot be inserted');

                } else {

                    page = lastPage;
                    incPages = true;

                }

                if (page>=1 && page<=lastPage) {

                    if (data.display=='double')
                        className = (page%2) ? ' odd' : ' even';
                    else
                        className = '';

                    // Stop animations
                    if (data.done)
                        this.turn('stop');

                    // Move pages if it's necessary
                    if (page in data.pageObjs)
                        turnMethods._movePages.call(this, page, 1);

                    // Increase the number of pages
                    if (incPages)
                        data.totalPages = lastPage;

                    // Add element
                    data.pageObjs[page] = $(element).
                    css({'float': 'left'}).
                    addClass('page p' + page + className);

                    if (!hasHardPage() &&  data.pageObjs[page].hasClass('hard')) {
                        data.pageObjs[page].removeClass('hard');
                    }

                    // Add page
                    turnMethods._addPage.call(this, page);

                    // Remove pages out of range
                    turnMethods._removeFromDOM.call(this);
                }

                return this;
            },

            // Adds a page

            _addPage: function(page) {

                var data = this.data(),
                    element = data.pageObjs[page];

                if (element)
                    if (turnMethods._necessPage.call(this, page)) {

                        if (!data.pageWrap[page]) {

                            // Wrapper
                            data.pageWrap[page] = $('<div/>',
                                {'class': 'page-wrapper',
                                    page: page,
                                    css: {position: 'absolute',
                                        overflow: 'hidden'}});

                            // Append to this flipbook
                            this.append(data.pageWrap[page]);

                            if (!data.pagePlace[page]) {

                                data.pagePlace[page] = page;
                                // Move `pageObjs[page]` to wrapper
                                data.pageObjs[page].appendTo(data.pageWrap[page]);

                            }

                            // Set the size of the page
                            var prop = turnMethods._pageSize.call(this, page, true);
                            element.css({width: prop.width, height: prop.height});
                            data.pageWrap[page].css(prop);

                        }

                        if (data.pagePlace[page] == page) {

                            // If the page isn't in another place, create the flip effect
                            turnMethods._makeFlip.call(this, page);

                        }

                    } else {

                        // Place
                        data.pagePlace[page] = 0;

                        // Remove element from the DOM
                        if (data.pageObjs[page])
                            data.pageObjs[page].remove();

                    }

            },

            // Checks if a page is in memory

            hasPage: function(page) {

                return has(page, this.data().pageObjs);

            },

            // Centers the flipbook

            center: function(page) {

                var data = this.data(),
                    size = $(this).turn('size'),
                    left = 0;

                if (!data.noCenter) {
                    if (data.display=='double') {
                        var view = this.turn('view', page || data.tpage || data.page);

                        if (data.direction=='ltr') {
                            if (!view[0])
                                left -= size.width/4;
                            else if (!view[1])
                                left += size.width/4;
                        } else {
                            if (!view[0])
                                left += size.width/4;
                            else if (!view[1])
                                left -= size.width/4;
                        }

                    }

                    $(this).css({marginLeft: left});
                }

                return this;

            },

            // Destroys the flipbook

            destroy: function () {

                var page,
                    flipbook = this,
                    data = this.data(),
                    events = [
                        'end', 'first', 'flip', 'last', 'pressed',
                        'released', 'start', 'turning', 'turned',
                        'zooming', 'missing'];

                if (trigger('destroying', this)=='prevented')
                    return;

                data.destroying = true;

                $.each(events, function(index, eventName) {
                    flipbook.unbind(eventName);
                });

                this.parent().unbind('start', data.eventHandlers.start);

                $(document).unbind(mouseEvents.move, data.eventHandlers.touchMove).
                unbind(mouseEvents.up, data.eventHandlers.touchEnd);

                while (data.totalPages!==0) {
                    this.turn('removePage', data.totalPages);
                }

                if (data.fparent)
                    data.fparent.remove();

                if (data.shadow)
                    data.shadow.remove();

                this.removeData();
                data = null;

                return this;

            },

            // Checks if this element is a flipbook

            is: function() {

                return typeof(this.data().pages)=='object';

            },

            // Sets and gets the zoom value

            zoom: function(newZoom) {

                var data = this.data();

                if (typeof(newZoom)=='number') {

                    if (newZoom<0.001 || newZoom>100)
                        throw turnError(newZoom+ ' is not a value for zoom');

                    if (trigger('zooming', this, [newZoom, data.zoom])=='prevented')
                        return this;

                    var size = this.turn('size'),
                        currentView = this.turn('view'),
                        iz = 1/data.zoom,
                        newWidth = Math.round(size.width * iz * newZoom),
                        newHeight = Math.round(size.height * iz * newZoom);

                    data.zoom = newZoom;

                    $(this).turn('stop').
                    turn('size', newWidth, newHeight);
                    /*.
                    css({marginTop: size.height * iz / 2 - newHeight / 2});*/

                    if (data.opts.autoCenter)
                        this.turn('center');
                    /*else
                      $(this).css({marginLeft: size.width * iz / 2 - newWidth / 2});*/

                    turnMethods._updateShadow.call(this);

                    for (var i = 0; i<currentView.length; i++) {
                        if (currentView[i] && data.pageZoom[currentView[i]]!=data.zoom) {

                            this.trigger('zoomed',[
                                currentView[i],
                                currentView,
                                data.pageZoom[currentView[i]],
                                data.zoom]);

                            data.pageZoom[currentView[i]] = data.zoom;
                        }
                    }

                    return this;

                } else
                    return data.zoom;

            },

            // Gets the size of a page

            _pageSize: function(page, position) {

                var data = this.data(),
                    prop = {};

                if (data.display=='single') {

                    prop.width = this.width();
                    prop.height = this.height();

                    if (position) {
                        prop.top = 0;
                        prop.left = 0;
                        prop.right = 'auto';
                    }

                } else {

                    var pageWidth = this.width()/2,
                        pageHeight = this.height();

                    if (data.pageObjs[page].hasClass('own-size')) {
                        prop.width = data.pageObjs[page].width();
                        prop.height = data.pageObjs[page].height();
                    } else {
                        prop.width = pageWidth;
                        prop.height = pageHeight;
                    }

                    if (position) {
                        var odd = page%2;
                        prop.top = (pageHeight-prop.height)/2;

                        if (data.direction=='ltr') {

                            prop[(odd) ? 'right' : 'left'] = pageWidth-prop.width;
                            prop[(odd) ? 'left' : 'right'] = 'auto';

                        } else {

                            prop[(odd) ? 'left' : 'right'] = pageWidth-prop.width;
                            prop[(odd) ? 'right' : 'left'] = 'auto';

                        }

                    }
                }

                return prop;

            },

            // Prepares the flip effect for a page

            _makeFlip: function(page) {

                var data = this.data();

                if (!data.pages[page] && data.pagePlace[page]==page) {

                    var single = data.display=='single',
                        odd = page%2;

                    data.pages[page] = data.pageObjs[page].
                    css(turnMethods._pageSize.call(this, page)).
                    flip({
                        page: page,
                        next: (odd || single) ? page+1 : page-1,
                        turn: this
                    }).
                    flip('disable', data.disabled);

                    // Issue about z-index
                    turnMethods._setPageLoc.call(this, page);

                    data.pageZoom[page] = data.zoom;

                }

                return data.pages[page];
            },

            // Makes pages within a range

            _makeRange: function() {

                var page, range,
                    data = this.data();

                if (data.totalPages<1)
                    return;

                range = this.turn('range');

                for (page = range[0]; page<=range[1]; page++)
                    turnMethods._addPage.call(this, page);

            },

            // Returns a range of pages that should be in the DOM
            // Example:
            // - page in the current view, return true
            // * page is in the range, return true
            // Otherwise, return false
            //
            // 1 2-3 4-5 6-7 8-9 10-11 12-13
            //   **  **  --   **  **

            range: function(page) {

                var remainingPages, left, right, view,
                    data = this.data();

                page = page || data.tpage || data.page || 1;
                view = turnMethods._view.call(this, page);

                if (page<1 || page>data.totalPages)
                    throw turnError('"'+page+'" is not a valid page');


                view[1] = view[1] || view[0];

                if (view[0]>=1 && view[1]<=data.totalPages) {

                    remainingPages = Math.floor((pagesInDOM-2)/2);

                    if (data.totalPages-view[1] > view[0]) {
                        left = Math.min(view[0]-1, remainingPages);
                        right = 2*remainingPages-left;
                    } else {
                        right = Math.min(data.totalPages-view[1], remainingPages);
                        left = 2*remainingPages-right;
                    }

                } else {
                    left = pagesInDOM-1;
                    right = pagesInDOM-1;
                }

                return [Math.max(1, view[0]-left),
                    Math.min(data.totalPages, view[1]+right)];

            },

            // Detects if a page is within the range of `pagesInDOM` from the current view

            _necessPage: function(page) {

                if (page===0)
                    return true;

                var range = this.turn('range');

                return this.data().pageObjs[page].hasClass('fixed') ||
                    (page>=range[0] && page<=range[1]);

            },

            // Releases memory by removing pages from the DOM

            _removeFromDOM: function() {

                var page, data = this.data();

                for (page in data.pageWrap)
                    if (has(page, data.pageWrap) &&
                        !turnMethods._necessPage.call(this, page))
                        turnMethods._removePageFromDOM.call(this, page);

            },

            // Removes a page from DOM and its internal references

            _removePageFromDOM: function(page) {

                var data = this.data();

                if (data.pages[page]) {
                    var dd = data.pages[page].data();

                    flipMethods._moveFoldingPage.call(data.pages[page], false);

                    if (dd.f && dd.f.fwrapper)
                        dd.f.fwrapper.remove();

                    data.pages[page].removeData();
                    data.pages[page].remove();
                    delete data.pages[page];
                }

                if (data.pageObjs[page])
                    data.pageObjs[page].remove();

                if (data.pageWrap[page]) {
                    data.pageWrap[page].remove();
                    delete data.pageWrap[page];
                }

                turnMethods._removeMv.call(this, page);

                delete data.pagePlace[page];
                delete data.pageZoom[page];

            },

            // Removes a page

            removePage: function(page) {

                var data = this.data();

                // Delete all the pages
                if (page=='*') {

                    while (data.totalPages!==0) {
                        this.turn('removePage', data.totalPages);
                    }

                } else {

                    if (page<1 || page>data.totalPages)
                        throw turnError('The page '+ page + ' doesn\'t exist');

                    if (data.pageObjs[page]) {

                        // Stop animations
                        this.turn('stop');

                        // Remove `page`
                        turnMethods._removePageFromDOM.call(this, page);

                        delete data.pageObjs[page];

                    }

                    // Move the pages
                    turnMethods._movePages.call(this, page, -1);

                    // Resize the size of this flipbook
                    data.totalPages = data.totalPages-1;

                    // Check the current view

                    if (data.page>data.totalPages) {

                        data.page = null;
                        turnMethods._fitPage.call(this, data.totalPages);

                    } else {

                        turnMethods._makeRange.call(this);
                        this.turn('update');

                    }
                }

                return this;

            },

            // Moves pages

            _movePages: function(from, change) {

                var page,
                    that = this,
                    data = this.data(),
                    single = data.display=='single',
                    move = function(page) {

                        var next = page + change,
                            odd = next%2,
                            className = (odd) ? ' odd ' : ' even ';

                        if (data.pageObjs[page])
                            data.pageObjs[next] = data.pageObjs[page].
                            removeClass('p' + page + ' odd even').
                            addClass('p' + next + className);

                        if (data.pagePlace[page] && data.pageWrap[page]) {

                            data.pagePlace[next] = next;

                            if (data.pageObjs[next].hasClass('fixed'))
                                data.pageWrap[next] = data.pageWrap[page].
                                attr('page', next);
                            else
                                data.pageWrap[next] = data.pageWrap[page].
                                css(turnMethods._pageSize.call(that, next, true)).
                                attr('page', next);

                            if (data.pages[page])
                                data.pages[next] = data.pages[page].
                                flip('options', {
                                    page: next,
                                    next: (single || odd) ? next+1 : next-1
                                });

                            if (change) {
                                delete data.pages[page];
                                delete data.pagePlace[page];
                                delete data.pageZoom[page];
                                delete data.pageObjs[page];
                                delete data.pageWrap[page];
                            }

                        }

                    };

                if (change>0)
                    for (page=data.totalPages; page>=from; page--)
                        move(page);
                else
                    for (page=from; page<=data.totalPages; page++)
                        move(page);

            },

            // Sets or Gets the display mode

            display: function(display) {

                var data = this.data(),
                    currentDisplay = data.display;

                if (display===undefined) {

                    return currentDisplay;

                } else {

                    if ($.inArray(display, displays)==-1)
                        throw turnError('"'+display + '" is not a value for display');

                    switch(display) {
                        case 'single':

                            // Create a temporal page to use as folded page

                            if (!data.pageObjs[0]) {
                                this.turn('stop').
                                css({'overflow': 'hidden'});

                                data.pageObjs[0] = $('<div />',
                                    {'class': 'page p-temporal'}).
                                css({width: this.width(), height: this.height()}).
                                appendTo(this);
                            }

                            this.addClass('shadow');

                            break;
                        case 'double':

                            // Remove the temporal page

                            if (data.pageObjs[0]) {
                                this.turn('stop').css({'overflow': ''});
                                data.pageObjs[0].remove();
                                delete data.pageObjs[0];
                            }

                            this.removeClass('shadow');

                            break;
                    }


                    data.display = display;

                    if (currentDisplay) {
                        var size = this.turn('size');
                        turnMethods._movePages.call(this, 1, 0);
                        this.turn('size', size.width, size.height).
                        turn('update');
                    }

                    return this;

                }

            },

            // Gets and sets the direction of the flipbook

            direction: function(dir) {

                var data = this.data();

                if (dir===undefined) {

                    return data.direction;

                } else {

                    dir = dir.toLowerCase();

                    if ($.inArray(dir, directions)==-1)
                        throw turnError('"' + dir + '" is not a value for direction');

                    if (dir=='rtl') {
                        $(this).attr('dir', 'ltr').
                        css({direction: 'ltr'});
                    }

                    data.direction = dir;

                    if (data.done)
                        this.turn('size', $(this).width(), $(this).height());

                    return this;
                }

            },

            // Detects animation

            animating: function() {

                return this.data().pageMv.length>0;

            },

            // Gets the current activated corner

            corner: function() {

                var corner,
                    page,
                    data = this.data();

                for (page in data.pages) {
                    if (has(page, data.pages))
                        if ((corner = data.pages[page].flip('corner'))) {
                            return corner;
                        }
                }

                return false;
            },

            // Gets the data stored in the flipbook

            data: function() {

                return this.data();

            },

            // Disables and enables the effect

            disable: function(disable) {

                var page,
                    data = this.data(),
                    view = this.turn('view');

                data.disabled = disable===undefined || disable===true;

                for (page in data.pages) {
                    if (has(page, data.pages))
                        data.pages[page].flip('disable',
                            (data.disabled) ? true : $.inArray(parseInt(page, 10), view)==-1);
                }

                return this;

            },

            // Disables and enables the effect

            disabled: function(disable) {

                if (disable===undefined) {
                    return this.data().disabled===true;
                } else {
                    return this.turn('disable', disable);
                }

            },

            // Gets and sets the size

            size: function(width, height) {

                if (width===undefined || height===undefined) {

                    return {width: this.width(), height: this.height()};

                } else {

                    this.turn('stop');

                    var page, prop,
                        data = this.data(),
                        pageWidth = (data.display=='double') ? width/2 : width;

                    this.css({width: width, height: height});

                    if (data.pageObjs[0])
                        data.pageObjs[0].css({width: pageWidth, height: height});

                    for (page in data.pageWrap) {
                        if (!has(page, data.pageWrap)) continue;

                        prop = turnMethods._pageSize.call(this, page, true);

                        data.pageObjs[page].css({width: prop.width, height: prop.height});
                        data.pageWrap[page].css(prop);

                        if (data.pages[page])
                            data.pages[page].css({width: prop.width, height: prop.height});
                    }

                    this.turn('resize');

                    return this;

                }
            },

            // Resizes each page

            resize: function() {

                var page, data = this.data();

                if (data.pages[0]) {
                    data.pageWrap[0].css({left: -this.width()});
                    data.pages[0].flip('resize', true);
                }

                for (page = 1; page <= data.totalPages; page++)
                    if (data.pages[page])
                        data.pages[page].flip('resize', true);

                turnMethods._updateShadow.call(this);

                if (data.opts.autoCenter)
                    this.turn('center');

            },

            // Removes an animation from the cache

            _removeMv: function(page) {

                var i, data = this.data();

                for (i=0; i<data.pageMv.length; i++)
                    if (data.pageMv[i]==page) {
                        data.pageMv.splice(i, 1);
                        return true;
                    }

                return false;

            },

            // Adds an animation to the cache

            _addMv: function(page) {

                var data = this.data();

                turnMethods._removeMv.call(this, page);
                data.pageMv.push(page);

            },

            // Gets indexes for a view

            _view: function(page) {

                var data = this.data();

                page = page || data.page;

                if (data.display=='double')
                    return (page%2) ? [page-1, page] : [page, page+1];
                else
                    return [page];

            },

            // Gets a view

            view: function(page) {

                var data = this.data(),
                    view = turnMethods._view.call(this, page);

                if (data.display=='double')
                    return [(view[0]>0) ? view[0] : 0,
                        (view[1]<=data.totalPages) ? view[1] : 0];
                else
                    return [(view[0]>0 && view[0]<=data.totalPages) ? view[0] : 0];

            },

            // Stops animations

            stop: function(ignore, animate) {

                if (this.turn('animating')) {

                    var i, opts, page,
                        data = this.data();

                    if (data.tpage) {
                        data.page = data.tpage;
                        delete data['tpage'];
                    }

                    for (i = 0; i<data.pageMv.length; i++) {

                        if (!data.pageMv[i] || data.pageMv[i]===ignore)
                            continue;

                        page = data.pages[data.pageMv[i]];
                        opts = page.data().f.opts;

                        page.flip('hideFoldedPage', animate);

                        if (!animate)
                            flipMethods._moveFoldingPage.call(page, false);

                        if (opts.force) {
                            opts.next = (opts.page%2===0) ? opts.page-1 : opts.page+1;
                            delete opts['force'];
                        }

                    }
                }

                this.turn('update');

                return this;
            },

            // Gets and sets the number of pages

            pages: function(pages) {

                var data = this.data();

                if (pages) {

                    if (pages<data.totalPages) {

                        for (var page = data.totalPages; page>pages; page--)
                            this.turn('removePage', page);

                    }

                    data.totalPages = pages;
                    turnMethods._fitPage.call(this, data.page);

                    return this;

                } else
                    return data.totalPages;

            },

            // Checks missing pages

            _missing : function(page) {

                var data = this.data();

                if (data.totalPages<1)
                    return;

                var p,
                    range = this.turn('range', page),
                    missing = [];

                for (p = range[0]; p<=range[1]; p++) {
                    if (!data.pageObjs[p])
                        missing.push(p);
                }

                if (missing.length>0)
                    this.trigger('missing', [missing]);

            },

            // Sets a page without effect

            _fitPage: function(page) {

                var data = this.data(),
                    newView = this.turn('view', page);

                turnMethods._missing.call(this, page);

                if (!data.pageObjs[page])
                    return;

                data.page = page;

                this.turn('stop');

                for (var i = 0; i<newView.length; i++) {

                    if (newView[i] && data.pageZoom[newView[i]]!=data.zoom) {

                        this.trigger('zoomed',[
                            newView[i],
                            newView,
                            data.pageZoom[newView[i]],
                            data.zoom]);

                        data.pageZoom[newView[i]] = data.zoom;

                    }
                }

                turnMethods._removeFromDOM.call(this);
                turnMethods._makeRange.call(this);
                turnMethods._updateShadow.call(this);
                this.trigger('turned', [page, newView]);
                this.turn('update');

                if (data.opts.autoCenter)
                    this.turn('center');

            },

            // Turns the page

            _turnPage: function(page) {

                var current,
                    next,
                    data = this.data(),
                    place = data.pagePlace[page],
                    view = this.turn('view'),
                    newView = this.turn('view', page);


                if (data.page!=page) {

                    var currentPage = data.page;

                    if (trigger('turning', this, [page, newView])=='prevented') {

                        if (currentPage==data.page && $.inArray(place, data.pageMv)!=-1)
                            data.pages[place].flip('hideFoldedPage', true);

                        return;

                    }

                    if ($.inArray(1, newView)!=-1)
                        this.trigger('first');
                    if ($.inArray(data.totalPages, newView)!=-1)
                        this.trigger('last');

                }

                if (data.display=='single') {
                    current = view[0];
                    next = newView[0];
                } else if (view[1] && page>view[1]) {
                    current = view[1];
                    next = newView[0];
                } else if (view[0] && page<view[0]) {
                    current = view[0];
                    next = newView[1];
                }

                var optsCorners = data.opts.turnCorners.split(','),
                    flipData = data.pages[current].data().f,
                    opts = flipData.opts,
                    actualPoint = flipData.point;

                turnMethods._missing.call(this, page);

                if (!data.pageObjs[page])
                    return;

                this.turn('stop');

                data.page = page;

                turnMethods._makeRange.call(this);

                data.tpage = next;

                if (opts.next!=next) {
                    opts.next = next;
                    opts.force = true;
                }

                this.turn('update');

                flipData.point = actualPoint;

                if (flipData.effect=='hard')
                    if (data.direction=='ltr')
                        data.pages[current].flip('turnPage',
                            (page>current) ? 'r' : 'l');
                    else
                        data.pages[current].flip('turnPage',
                            (page>current) ? 'l' : 'r');
                else {
                    if (data.direction=='ltr')
                        data.pages[current].flip('turnPage',
                            optsCorners[(page>current) ? 1 : 0]);
                    else
                        data.pages[current].flip('turnPage',
                            optsCorners[(page>current) ? 0 : 1]);
                }

            },

            // Gets and sets a page

            page: function(page) {

                var data = this.data();

                if (page===undefined) {

                    return data.page;

                } else {

                    if (!data.disabled && !data.destroying) {

                        page = parseInt(page, 10);

                        if (page>0 && page<=data.totalPages) {

                            if (page!=data.page) {
                                if (!data.done || $.inArray(page, this.turn('view'))!=-1)
                                    turnMethods._fitPage.call(this, page);
                                else
                                    turnMethods._turnPage.call(this, page);
                            }

                            return this;

                        } else {

                            throw turnError('The page ' + page + ' does not exist');

                        }

                    }

                }

            },

            // Turns to the next view

            next: function() {

                return this.turn('page', Math.min(this.data().totalPages,
                    turnMethods._view.call(this, this.data().page).pop() + 1));

            },

            // Turns to the previous view

            previous: function() {

                return this.turn('page', Math.max(1,
                    turnMethods._view.call(this, this.data().page).shift() - 1));

            },

            // Shows a peeling corner

            peel: function(corner, animate) {

                var data = this.data(),
                    view = this.turn('view');

                animate = (animate===undefined) ? true : animate===true;

                if (corner===false) {

                    this.turn('stop', null, animate);

                } else {

                    if (data.display=='single') {

                        data.pages[data.page].flip('peel', corner, animate);

                    } else {

                        var page;

                        if (data.direction=='ltr') {

                            page = (corner.indexOf('l')!=-1) ? view[0] : view[1];

                        } else {

                            page = (corner.indexOf('l')!=-1) ? view[1] : view[0];

                        }

                        if (data.pages[page])
                            data.pages[page].flip('peel', corner, animate);

                    }
                }

                return this;

            },

            // Adds a motion to the internal list
            // This event is called in context of flip

            _addMotionPage: function() {

                var opts = $(this).data().f.opts,
                    turn = opts.turn,
                    dd = turn.data();

                turnMethods._addMv.call(turn, opts.page);

            },

            // This event is called in context of flip

            _eventStart: function(e, opts, corner) {

                var data = opts.turn.data(),
                    actualZoom = data.pageZoom[opts.page];

                if (e.isDefaultPrevented()) {
                    turnMethods._updateShadow.call(opts.turn);
                    return;
                }

                if (actualZoom && actualZoom!=data.zoom) {

                    opts.turn.trigger('zoomed',[
                        opts.page,
                        opts.turn.turn('view', opts.page),
                        actualZoom,
                        data.zoom]);

                    data.pageZoom[opts.page] = data.zoom;

                }

                if (data.display=='single' && corner) {

                    if ((corner.charAt(1)=='l' && data.direction=='ltr') ||
                        (corner.charAt(1)=='r' && data.direction=='rtl'))
                    {

                        opts.next = (opts.next<opts.page) ? opts.next : opts.page-1;
                        opts.force = true;

                    } else {

                        opts.next = (opts.next>opts.page) ? opts.next : opts.page+1;

                    }

                }

                turnMethods._addMotionPage.call(e.target);
                turnMethods._updateShadow.call(opts.turn);
            },

            // This event is called in context of flip

            _eventEnd: function(e, opts, turned) {

                var that = $(e.target),
                    data = that.data().f,
                    turn = opts.turn,
                    dd = turn.data();

                if (turned) {

                    var tpage = dd.tpage || dd.page;

                    if (tpage==opts.next || tpage==opts.page) {
                        delete dd.tpage;

                        turnMethods._fitPage.call(turn, tpage || opts.next, true);
                    }

                } else {

                    turnMethods._removeMv.call(turn, opts.page);
                    turnMethods._updateShadow.call(turn);
                    turn.turn('update');

                }

            },

            // This event is called in context of flip

            _eventPressed: function(e) {

                var page,
                    data = $(e.target).data().f,
                    turn = data.opts.turn,
                    turnData = turn.data(),
                    pages = turnData.pages;

                turnData.mouseAction = true;

                turn.turn('update');

                return data.time = new Date().getTime();

            },

            // This event is called in context of flip

            _eventReleased: function(e, point) {

                var outArea,
                    page = $(e.target),
                    data = page.data().f,
                    turn = data.opts.turn,
                    turnData = turn.data();

                if (turnData.display=='single') {
                    outArea = (point.corner=='br' || point.corner=='tr') ?
                        point.x<page.width()/2:
                        point.x>page.width()/2;
                } else {
                    outArea = point.x<0 || point.x>page.width();
                }

                if ((new Date()).getTime()-data.time<200 || outArea) {

                    e.preventDefault();
                    turnMethods._turnPage.call(turn, data.opts.next);

                }

                turnData.mouseAction = false;

            },

            // This event is called in context of flip

            _flip: function(e) {

                e.stopPropagation();

                var opts = $(e.target).data().f.opts;

                opts.turn.trigger('turn', [opts.next]);

                if (opts.turn.data().opts.autoCenter) {
                    opts.turn.turn('center', opts.next);
                }

            },

            //
            _touchStart: function() {
                var data = this.data();
                for (var page in data.pages) {
                    if (has(page, data.pages) &&
                        flipMethods._eventStart.apply(data.pages[page], arguments)===false) {
                        return false;
                    }
                }
            },

            //
            _touchMove: function() {
                var data = this.data();
                for (var page in data.pages) {
                    if (has(page, data.pages)) {
                        flipMethods._eventMove.apply(data.pages[page], arguments);
                    }
                }
            },

            //
            _touchEnd: function() {
                var data = this.data();
                for (var page in data.pages) {
                    if (has(page, data.pages)) {
                        flipMethods._eventEnd.apply(data.pages[page], arguments);
                    }
                }
            },

            // Calculate the z-index value for pages during the animation

            calculateZ: function(mv) {

                var i, page, nextPage, placePage, dpage,
                    that = this,
                    data = this.data(),
                    view = this.turn('view'),
                    currentPage = view[0] || view[1],
                    total = mv.length-1,
                    r = {pageZ: {}, partZ: {}, pageV: {}},

                    addView = function(page) {
                        var view = that.turn('view', page);
                        if (view[0]) r.pageV[view[0]] = true;
                        if (view[1]) r.pageV[view[1]] = true;
                    };

                for (i = 0; i<=total; i++) {
                    page = mv[i];
                    nextPage = data.pages[page].data().f.opts.next;
                    placePage = data.pagePlace[page];
                    addView(page);
                    addView(nextPage);
                    dpage = (data.pagePlace[nextPage]==nextPage) ? nextPage : page;
                    r.pageZ[dpage] = data.totalPages - Math.abs(currentPage-dpage);
                    r.partZ[placePage] = data.totalPages*2 -  total + i;
                }

                return r;
            },

            // Updates the z-index and display property of every page

            update: function() {

                var page,
                    data = this.data();

                if (this.turn('animating') && data.pageMv[0]!==0) {

                    // Update motion

                    var p, apage, fixed,
                        pos = this.turn('calculateZ', data.pageMv),
                        corner = this.turn('corner'),
                        actualView = this.turn('view'),
                        newView = this.turn('view', data.tpage);

                    for (page in data.pageWrap) {

                        if (!has(page, data.pageWrap))
                            continue;

                        fixed = data.pageObjs[page].hasClass('fixed');

                        data.pageWrap[page].css({
                            display: (pos.pageV[page] || fixed) ? '' : 'none',
                            zIndex:
                                (data.pageObjs[page].hasClass('hard') ?
                                        pos.partZ[page]
                                        :
                                        pos.pageZ[page]
                                ) || (fixed ? -1 : 0)
                        });

                        if ((p = data.pages[page])) {

                            p.flip('z', pos.partZ[page] || null);

                            if (pos.pageV[page])
                                p.flip('resize');

                            if (data.tpage) { // Is it turning the page to `tpage`?

                                p.flip('hover', false).
                                flip('disable',
                                    $.inArray(parseInt(page, 10), data.pageMv)==-1 &&
                                    page!=newView[0] &&
                                    page!=newView[1]);

                            } else {

                                p.flip('hover', corner===false).
                                flip('disable', page!=actualView[0] && page!=actualView[1]);

                            }

                        }

                    }

                } else {

                    // Update static pages

                    for (page in data.pageWrap) {

                        if (!has(page, data.pageWrap))
                            continue;

                        var pageLocation = turnMethods._setPageLoc.call(this, page);

                        if (data.pages[page]) {
                            data.pages[page].
                            flip('disable', data.disabled || pageLocation!=1).
                            flip('hover', true).
                            flip('z', null);
                        }
                    }
                }

                return this;
            },

            // Updates the position and size of the flipbook's shadow

            _updateShadow: function() {

                var view, view2, shadow,
                    data = this.data(),
                    width = this.width(),
                    height = this.height(),
                    pageWidth = (data.display=='single') ? width : width/2;

                view = this.turn('view');

                if (!data.shadow) {
                    data.shadow = $('<div />', {
                        'class': 'shadow',
                        'css': divAtt(0, 0, 0).css
                    }).
                    appendTo(this);
                }

                for (var i = 0; i<data.pageMv.length; i++) {
                    if (!view[0] || !view[1])
                        break;

                    view = this.turn('view', data.pages[data.pageMv[i]].data().f.opts.next);
                    view2 = this.turn('view', data.pageMv[i]);

                    view[0] = view[0] && view2[0];
                    view[1] = view[1] && view2[1];
                }

                if (!view[0]) shadow = (data.direction=='ltr') ? 1 : 2;
                else if (!view[1]) shadow = (data.direction=='ltr') ? 2 : 1;
                else shadow = 3;

                switch (shadow) {
                    case 1:
                        data.shadow.css({
                            width: pageWidth,
                            height: height,
                            top: 0,
                            left: pageWidth
                        });
                        break;
                    case 2:
                        data.shadow.css({
                            width: pageWidth,
                            height: height,
                            top: 0,
                            left: 0
                        });
                        break;
                    case 3:
                        data.shadow.css({
                            width: width,
                            height: height,
                            top: 0,
                            left: 0
                        });
                        break;
                }

            },

            // Sets the z-index and display property of a page
            // It depends on the current view

            _setPageLoc: function(page) {

                var data = this.data(),
                    view = this.turn('view'),
                    loc = 0;


                if (page==view[0] || page==view[1])
                    loc = 1;
                else if (
                    (data.display=='single' && page==view[0]+1) ||
                    (data.display=='double' && page==view[0]-2 || page==view[1]+2)
                )
                    loc = 2;

                if (!this.turn('animating'))
                    switch (loc) {
                        case 1:
                            data.pageWrap[page].css(
                                {
                                    zIndex: data.totalPages,
                                    display: ''
                                });
                            break;
                        case 2:
                            data.pageWrap[page].css(
                                {
                                    zIndex: data.totalPages-1,
                                    display: ''
                                });
                            break;
                        case 0:
                            data.pageWrap[page].css(
                                {
                                    zIndex: 0,
                                    display: (data.pageObjs[page].hasClass('fixed')) ? '' : 'none'}
                            );
                            break;
                    }

                return loc;
            },

            // Gets and sets the options

            options: function(options) {

                if (options===undefined) {

                    return this.data().opts;

                } else {

                    var data = this.data();

                    // Set new values

                    $.extend(data.opts, options);

                    // Set pages

                    if (options.pages)
                        this.turn('pages', options.pages);

                    // Set page

                    if (options.page)
                        this.turn('page', options.page);

                    // Set display

                    if (options.display)
                        this.turn('display', options.display);

                    // Set direction

                    if (options.direction)
                        this.turn('direction', options.direction);

                    // Set size

                    if (options.width && options.height)
                        this.turn('size', options.width, options.height);

                    // Add event listeners

                    if (options.when)
                        for (var eventName in options.when)
                            if (has(eventName, options.when)) {
                                this.unbind(eventName).
                                bind(eventName, options.when[eventName]);
                            }

                    return this;
                }

            },

            // Gets the current version

            version: function() {

                return version;

            }
        },

// Methods and properties for the flip page effect

        flipMethods = {

            // Constructor

            init: function(opts) {

                this.data({f: {
                        disabled: false,
                        hover: false,
                        effect: (this.hasClass('hard')) ? 'hard' : 'sheet'
                    }});

                this.flip('options', opts);

                flipMethods._addPageWrapper.call(this);

                return this;
            },

            setData: function(d) {

                var data = this.data();

                data.f = $.extend(data.f, d);

                return this;
            },

            options: function(opts) {

                var data = this.data().f;

                if (opts) {
                    flipMethods.setData.call(this,
                        {opts: $.extend({}, data.opts || flipOptions, opts)});
                    return this;
                } else
                    return data.opts;

            },

            z: function(z) {

                var data = this.data().f;

                data.opts['z-index'] = z;

                if (data.fwrapper)
                    data.fwrapper.css({
                        zIndex: z || parseInt(data.parent.css('z-index'), 10) || 0
                    });

                return this;
            },

            _cAllowed: function() {

                var data = this.data().f,
                    page = data.opts.page,
                    turnData = data.opts.turn.data(),
                    odd = page%2;

                if (data.effect=='hard') {

                    return (turnData.direction=='ltr') ?
                        [(odd) ? 'r' : 'l'] :
                        [(odd) ? 'l' : 'r'];

                } else {

                    if (turnData.display=='single') {

                        if (page==1)
                            return (turnData.direction=='ltr') ?
                                corners['forward'] : corners['backward'];
                        else if (page==turnData.totalPages)
                            return (turnData.direction=='ltr') ?
                                corners['backward'] : corners['forward'];
                        else
                            return corners['all'];

                    } else {

                        return (turnData.direction=='ltr') ?
                            corners[(odd) ? 'forward' : 'backward']
                            :
                            corners[(odd) ? 'backward' : 'forward'];

                    }

                }

            },

            _cornerActivated: function(p) {

                var data = this.data().f,
                    width = this.width(),
                    height = this.height(),
                    point = {x: p.x, y: p.y, corner: ''},
                    csz = data.opts.cornerSize;

                if (point.x<=0 || point.y<=0 || point.x>=width || point.y>=height)
                    return false;

                var allowedCorners = flipMethods._cAllowed.call(this);

                switch (data.effect) {
                    case 'hard':

                        if (point.x>width-csz)
                            point.corner = 'r';
                        else if (point.x<csz)
                            point.corner = 'l';
                        else
                            return false;

                        break;

                    case 'sheet':

                        if (point.y<csz)
                            point.corner+= 't';
                        else if (point.y>=height-csz)
                            point.corner+= 'b';
                        else
                            return false;

                        if (point.x<=csz)
                            point.corner+= 'l';
                        else if (point.x>=width-csz)
                            point.corner+= 'r';
                        else
                            return false;

                        break;
                }

                return (!point.corner || $.inArray(point.corner, allowedCorners)==-1) ?
                    false : point;

            },

            _isIArea: function(e) {

                var pos = this.data().f.parent.offset();

                e = (isTouch && e.originalEvent) ? e.originalEvent.touches[0] : e;

                return flipMethods._cornerActivated.call(this,
                    {
                        x: e.pageX-pos.left,
                        y: e.pageY-pos.top
                    });

            },

            _c: function(corner, opts) {

                opts = opts || 0;

                switch (corner) {
                    case 'tl':
                        return point2D(opts, opts);
                    case 'tr':
                        return point2D(this.width()-opts, opts);
                    case 'bl':
                        return point2D(opts, this.height()-opts);
                    case 'br':
                        return point2D(this.width()-opts, this.height()-opts);
                    case 'l':
                        return point2D(opts, 0);
                    case 'r':
                        return point2D(this.width()-opts, 0);
                }

            },

            _c2: function(corner) {

                switch (corner) {
                    case 'tl':
                        return point2D(this.width()*2, 0);
                    case 'tr':
                        return point2D(-this.width(), 0);
                    case 'bl':
                        return point2D(this.width()*2, this.height());
                    case 'br':
                        return point2D(-this.width(), this.height());
                    case 'l':
                        return point2D(this.width()*2, 0);
                    case 'r':
                        return point2D(-this.width(), 0);
                }

            },

            _foldingPage: function() {

                var data = this.data().f;

                if (!data)
                    return;

                var opts = data.opts;

                if (opts.turn) {
                    data = opts.turn.data();
                    if (data.display == 'single')
                        return (opts.next>1 || opts.page>1) ? data.pageObjs[0] : null;
                    else
                        return data.pageObjs[opts.next];
                }

            },

            _backGradient: function() {

                var data = this.data().f,
                    turnData = data.opts.turn.data(),
                    gradient =  turnData.opts.gradients && (turnData.display=='single' ||
                        (data.opts.page!=2 && data.opts.page!=turnData.totalPages-1));

                if (gradient && !data.bshadow)
                    data.bshadow = $('<div/>', divAtt(0, 0, 1)).
                    css({'position': '', width: this.width(), height: this.height()}).
                    appendTo(data.parent);

                return gradient;

            },

            type: function () {

                return this.data().f.effect;

            },

            resize: function(full) {

                var data = this.data().f,
                    turnData = data.opts.turn.data(),
                    width = this.width(),
                    height = this.height();

                switch (data.effect) {
                    case 'hard':

                        if (full) {
                            data.wrapper.css({width: width, height: height});
                            data.fpage.css({width: width, height: height});
                            if (turnData.opts.gradients) {
                                data.ashadow.css({width: width, height: height});
                                data.bshadow.css({width: width, height: height});
                            }
                        }

                        break;
                    case 'sheet':

                        if (full) {
                            var size = Math.round(Math.sqrt(Math.pow(width, 2)+Math.pow(height, 2)));

                            data.wrapper.css({width: size, height: size});
                            data.fwrapper.css({width: size, height: size}).
                            children(':first-child').
                            css({width: width, height: height});

                            data.fpage.css({width: width, height: height});

                            if (turnData.opts.gradients)
                                data.ashadow.css({width: width, height: height});

                            if (flipMethods._backGradient.call(this))
                                data.bshadow.css({width: width, height: height});
                        }

                        if (data.parent.is(':visible')) {
                            var offset = findPos(data.parent[0]);

                            data.fwrapper.css({top: offset.top,
                                left: offset.left});

                            //if (data.opts.turn) {
                            offset = findPos(data.opts.turn[0]);
                            data.fparent.css({top: -offset.top, left: -offset.left});
                            //}
                        }

                        this.flip('z', data.opts['z-index']);

                        break;
                }

            },

            // Prepares the page by adding a general wrapper and another objects

            _addPageWrapper: function() {

                var att,
                    data = this.data().f,
                    turnData = data.opts.turn.data(),
                    parent = this.parent();

                data.parent = parent;

                if (!data.wrapper)
                    switch (data.effect) {
                        case 'hard':

                            var cssProperties = {};
                            cssProperties[vendor + 'transform-style'] = 'preserve-3d';
                            cssProperties[vendor + 'backface-visibility'] = 'hidden';

                            data.wrapper = $('<div/>', divAtt(0, 0, 2)).
                            css(cssProperties).
                            appendTo(parent).
                            prepend(this);

                            data.fpage = $('<div/>', divAtt(0, 0, 1)).
                            css(cssProperties).
                            appendTo(parent);

                            if (turnData.opts.gradients) {
                                data.ashadow = $('<div/>', divAtt(0, 0,  0)).
                                hide().
                                appendTo(parent);

                                data.bshadow = $('<div/>', divAtt(0, 0,  0));
                            }

                            break;
                        case 'sheet':

                            var width = this.width(),
                                height = this.height(),
                                size = Math.round(Math.sqrt(Math.pow(width, 2)+Math.pow(height, 2)));

                            data.fparent = data.opts.turn.data().fparent;

                            if (!data.fparent) {
                                var fparent = $('<div/>', {css: {'pointer-events': 'none'}}).hide();
                                fparent.data().flips = 0;
                                fparent.css(divAtt(0, 0, 'auto', 'visible').css).
                                appendTo(data.opts.turn);

                                data.opts.turn.data().fparent = fparent;
                                data.fparent = fparent;
                            }

                            this.css({position: 'absolute', top: 0, left: 0, bottom: 'auto', right: 'auto'});

                            data.wrapper = $('<div/>', divAtt(0, 0, this.css('z-index'))).
                            appendTo(parent).
                            prepend(this);

                            data.fwrapper = $('<div/>', divAtt(parent.offset().top, parent.offset().left)).
                            hide().
                            appendTo(data.fparent);

                            data.fpage = $('<div/>', divAtt(0, 0, 0, 'visible')).
                            css({cursor: 'default'}).
                            appendTo(data.fwrapper);

                            if (turnData.opts.gradients)
                                data.ashadow = $('<div/>', divAtt(0, 0,  1)).
                                appendTo(data.fpage);

                            flipMethods.setData.call(this, data);

                            break;
                    }

                // Set size
                flipMethods.resize.call(this, true);

            },

            // Takes a 2P point from the screen and applies the transformation

            _fold: function(point) {

                var data = this.data().f,
                    turnData = data.opts.turn.data(),
                    o = flipMethods._c.call(this, point.corner),
                    width = this.width(),
                    height = this.height();

                switch (data.effect) {

                    case 'hard':

                        if (point.corner=='l')
                            point.x = Math.min(Math.max(point.x, 0), width*2);
                        else
                            point.x = Math.max(Math.min(point.x, width), -width);

                        var leftPos,
                            shadow,
                            gradientX,
                            fpageOrigin,
                            parentOrigin,
                            totalPages = turnData.totalPages,
                            zIndex = data.opts['z-index'] || totalPages,
                            parentCss = {'overflow': 'visible'},
                            relX = (o.x) ? (o.x - point.x)/width : point.x/width,
                            angle = relX * 90,
                            half = angle<90;

                        switch (point.corner) {
                            case 'l':

                                fpageOrigin =  '0% 50%';
                                parentOrigin =  '100% 50%';

                                if (half) {
                                    leftPos = 0;
                                    shadow = data.opts.next-1>0;
                                    gradientX = 1;
                                } else {
                                    leftPos = '100%';
                                    shadow = data.opts.page+1<totalPages;
                                    gradientX = 0;
                                }

                                break;
                            case 'r':

                                fpageOrigin =  '100% 50%';
                                parentOrigin =  '0% 50%';
                                angle = -angle;
                                width = -width;

                                if (half) {
                                    leftPos = 0;
                                    shadow = data.opts.next+1<totalPages;
                                    gradientX = 0;
                                } else {
                                    leftPos = '-100%';
                                    shadow = data.opts.page!=1;
                                    gradientX = 1;
                                }

                                break;
                        }

                        parentCss[vendor+'perspective-origin'] = parentOrigin;

                        data.wrapper.transform('rotateY('+angle+'deg)' +
                            'translate3d(0px, 0px, '+(this.attr('depth')||0)+'px)', parentOrigin);

                        data.fpage.transform('translateX('+width+'px) rotateY('+(180+angle)+'deg)', fpageOrigin);

                        data.parent.css(parentCss);

                        if (half) {
                            relX = -relX+1;
                            data.wrapper.css({zIndex: zIndex+1});
                            data.fpage.css({zIndex: zIndex});
                        } else {
                            relX = relX-1;
                            data.wrapper.css({zIndex: zIndex});
                            data.fpage.css({zIndex: zIndex+1});
                        }

                        if (turnData.opts.gradients) {
                            if (shadow)
                                data.ashadow.css({
                                    display: '',
                                    left: leftPos,
                                    backgroundColor: 'rgba(0,0,0,'+(0.5*relX)+')'
                                }).
                                transform('rotateY(0deg)');
                            else
                                data.ashadow.hide();

                            data.bshadow.css({opacity:-relX + 1});

                            if (half) {
                                if (data.bshadow.parent()[0]!=data.wrapper[0]) {
                                    data.bshadow.appendTo(data.wrapper);
                                }
                            } else {
                                if (data.bshadow.parent()[0]!=data.fpage[0]) {
                                    data.bshadow.appendTo(data.fpage);
                                }
                            }
                            /*data.bshadow.css({
                              backgroundColor: 'rgba(0,0,0,'+(0.1)+')'
                            })*/
                            gradient(data.bshadow, point2D(gradientX * 100, 0), point2D((-gradientX + 1)*100, 0),
                                [[0, 'rgba(0,0,0,0.3)'],[1, 'rgba(0,0,0,0)']],2);

                        }

                        break;
                    case 'sheet':

                        var that = this,
                            a = 0,
                            alpha = 0,
                            beta,
                            px,
                            gradientEndPointA,
                            gradientEndPointB,
                            gradientStartVal,
                            gradientSize,
                            gradientOpacity,
                            shadowVal,
                            mv = point2D(0, 0),
                            df = point2D(0, 0),
                            tr = point2D(0, 0),
                            folding = flipMethods._foldingPage.call(this),
                            tan = Math.tan(alpha),
                            ac = turnData.opts.acceleration,
                            h = data.wrapper.height(),
                            top = point.corner.substr(0, 1) == 't',
                            left = point.corner.substr(1, 1) == 'l',

                            compute = function() {

                                var rel = point2D(0, 0);
                                var middle = point2D(0, 0);

                                rel.x = (o.x) ? o.x - point.x : point.x;

                                if (!hasRot) {
                                    rel.y = 0;
                                } else {
                                    rel.y = (o.y) ? o.y - point.y : point.y;
                                }

                                middle.x = (left)? width - rel.x/2 : point.x + rel.x/2;
                                middle.y = rel.y/2;

                                var alpha =  A90-Math.atan2(rel.y, rel.x),
                                    gamma = alpha - Math.atan2(middle.y, middle.x),
                                    distance =  Math.max(0, Math.sin(gamma) * Math.sqrt(Math.pow(middle.x, 2) + Math.pow(middle.y, 2)));

                                a = deg(alpha);

                                tr = point2D(distance * Math.sin(alpha), distance * Math.cos(alpha));

                                if (alpha > A90) {
                                    tr.x = tr.x + Math.abs(tr.y * rel.y/rel.x);
                                    tr.y = 0;
                                    if (Math.round(tr.x*Math.tan(PI-alpha)) < height) {
                                        point.y = Math.sqrt(Math.pow(height, 2)+2 * middle.x * rel.x);
                                        if (top) point.y =  height - point.y;
                                        return compute();
                                    }
                                }

                                if (alpha>A90) {
                                    var beta = PI-alpha, dd = h - height/Math.sin(beta);
                                    mv = point2D(Math.round(dd*Math.cos(beta)), Math.round(dd*Math.sin(beta)));
                                    if (left) mv.x = - mv.x;
                                    if (top) mv.y = - mv.y;
                                }

                                px = Math.round(tr.y/Math.tan(alpha) + tr.x);

                                var side = width - px,
                                    sideX = side*Math.cos(alpha*2),
                                    sideY = side*Math.sin(alpha*2);
                                df = point2D(
                                    Math.round((left ? side -sideX : px+sideX)),
                                    Math.round((top) ? sideY : height - sideY));

                                // Gradients
                                if (turnData.opts.gradients) {

                                    gradientSize = side*Math.sin(alpha);

                                    var endingPoint = flipMethods._c2.call(that, point.corner),
                                        far = Math.sqrt(Math.pow(endingPoint.x-point.x, 2)+Math.pow(endingPoint.y-point.y, 2))/width;

                                    shadowVal = Math.sin(A90*((far>1) ? 2 - far : far));

                                    gradientOpacity = Math.min(far, 1);


                                    gradientStartVal = gradientSize>100 ? (gradientSize-100)/gradientSize : 0;

                                    gradientEndPointA = point2D(
                                        gradientSize*Math.sin(alpha)/width*100,
                                        gradientSize*Math.cos(alpha)/height*100);


                                    if (flipMethods._backGradient.call(that)) {

                                        gradientEndPointB = point2D(
                                            gradientSize*1.2*Math.sin(alpha)/width*100,
                                            gradientSize*1.2*Math.cos(alpha)/height*100);

                                        if (!left) gradientEndPointB.x = 100-gradientEndPointB.x;
                                        if (!top) gradientEndPointB.y = 100-gradientEndPointB.y;

                                    }

                                }

                                tr.x = Math.round(tr.x);
                                tr.y = Math.round(tr.y);

                                return true;
                            },

                            transform = function(tr, c, x, a) {

                                var f = ['0', 'auto'], mvW = (width-h)*x[0]/100, mvH = (height-h)*x[1]/100,
                                    cssA = {left: f[c[0]], top: f[c[1]], right: f[c[2]], bottom: f[c[3]]},
                                    cssB = {},
                                    aliasingFk = (a!=90 && a!=-90) ? (left ? -1 : 1) : 0,
                                    origin = x[0] + '% ' + x[1] + '%';

                                that.css(cssA).
                                transform(rotate(a) + translate(tr.x + aliasingFk, tr.y, ac), origin);

                                data.fpage.css(cssA).transform(
                                    rotate(a) +
                                    translate(tr.x + df.x - mv.x - width*x[0]/100, tr.y + df.y - mv.y - height*x[1]/100, ac) +
                                    rotate((180/a - 2)*a),
                                    origin);

                                data.wrapper.transform(translate(-tr.x + mvW-aliasingFk, -tr.y + mvH, ac) + rotate(-a), origin);

                                data.fwrapper.transform(translate(-tr.x + mv.x + mvW, -tr.y + mv.y + mvH, ac) + rotate(-a), origin);

                                if (turnData.opts.gradients) {

                                    if (x[0])
                                        gradientEndPointA.x = 100-gradientEndPointA.x;

                                    if (x[1])
                                        gradientEndPointA.y = (100-gradientEndPointA.y);

                                    cssB['box-shadow'] = '0 0 20px rgba(0,0,0,'+(0.5*shadowVal)+')';
                                    folding.css(cssB);

                                    gradient(data.ashadow,
                                        point2D(left?100:0, top?0:100),
                                        point2D(gradientEndPointA.x, gradientEndPointA.y),
                                        [[gradientStartVal, 'rgba(0,0,0,0)'],
                                            [((1-gradientStartVal)*0.8)+gradientStartVal, 'rgba(0,0,0,'+(0.2*gradientOpacity)+')'],
                                            [1, 'rgba(255,255,255,'+(0.2*gradientOpacity)+')']],
                                        3,
                                        alpha);

                                    if (flipMethods._backGradient.call(that))
                                        gradient(data.bshadow,
                                            point2D(left?0:100, top?0:100),
                                            point2D(gradientEndPointB.x, gradientEndPointB.y),
                                            [[0.6, 'rgba(0,0,0,0)'],
                                                [0.8, 'rgba(0,0,0,'+(0.3*gradientOpacity)+')'],
                                                [1, 'rgba(0,0,0,0)']
                                            ],
                                            3);
                                }

                            };

                        switch (point.corner) {
                            case 'l' :


                                break;
                            case 'r' :


                                break;
                            case 'tl' :
                                point.x = Math.max(point.x, 1);
                                compute();
                                transform(tr, [1,0,0,1], [100, 0], a);
                                break;
                            case 'tr' :
                                point.x = Math.min(point.x, width-1);
                                compute();
                                transform(point2D(-tr.x, tr.y), [0,0,0,1], [0, 0], -a);
                                break;
                            case 'bl' :
                                point.x = Math.max(point.x, 1);
                                compute();
                                transform(point2D(tr.x, -tr.y), [1,1,0,0], [100, 100], -a);
                                break;
                            case 'br' :
                                point.x = Math.min(point.x, width-1);
                                compute();
                                transform(point2D(-tr.x, -tr.y), [0,1,1,0], [0, 100], a);
                                break;
                        }

                        break;
                }

                data.point = point;

            },

            _moveFoldingPage: function(move) {

                var data = this.data().f;

                if (!data)
                    return;

                var turn = data.opts.turn,
                    turnData = turn.data(),
                    place = turnData.pagePlace;

                if (move) {

                    var nextPage = data.opts.next;

                    if (place[nextPage]!=data.opts.page) {

                        if (data.folding)
                            flipMethods._moveFoldingPage.call(this, false);

                        var folding = flipMethods._foldingPage.call(this);

                        folding.appendTo(data.fpage);
                        place[nextPage] = data.opts.page;
                        data.folding = nextPage;
                    }

                    turn.turn('update');

                } else {

                    if (data.folding) {

                        if (turnData.pages[data.folding]) {

                            // If we have flip available

                            var flipData = turnData.pages[data.folding].data().f;

                            turnData.pageObjs[data.folding].
                            appendTo(flipData.wrapper);

                        } else if (turnData.pageWrap[data.folding]) {

                            // If we have the pageWrapper

                            turnData.pageObjs[data.folding].
                            appendTo(turnData.pageWrap[data.folding]);

                        }

                        if (data.folding in place) {
                            place[data.folding] = data.folding;
                        }

                        delete data.folding;

                    }
                }
            },

            _showFoldedPage: function(c, animate) {

                var folding = flipMethods._foldingPage.call(this),
                    dd = this.data(),
                    data = dd.f,
                    visible = data.visible;

                if (folding) {

                    if (!visible || !data.point || data.point.corner!=c.corner) {

                        var corner = (
                            data.status=='hover' ||
                            data.status=='peel' ||
                            data.opts.turn.data().mouseAction) ?
                            c.corner : null;

                        visible = false;

                        if (trigger('start', this, [data.opts, corner])=='prevented')
                            return false;

                    }

                    if (animate) {

                        var that = this,
                            point = (data.point && data.point.corner==c.corner) ?
                                data.point : flipMethods._c.call(this, c.corner, 1);

                        this.animatef({
                            from: [point.x, point.y],
                            to: [c.x, c.y],
                            duration: 500,
                            frame: function(v) {
                                c.x = Math.round(v[0]);
                                c.y = Math.round(v[1]);
                                flipMethods._fold.call(that, c);
                            }
                        });

                    } else  {

                        flipMethods._fold.call(this, c);

                        if (dd.effect && !dd.effect.turning)
                            this.animatef(false);

                    }

                    if (!visible) {

                        switch(data.effect) {
                            case 'hard':

                                data.visible = true;
                                flipMethods._moveFoldingPage.call(this, true);
                                data.fpage.show();
                                if (data.opts.shadows)
                                    data.bshadow.show();

                                break;
                            case 'sheet':

                                data.visible = true;
                                data.fparent.show().data().flips++;
                                flipMethods._moveFoldingPage.call(this, true);
                                data.fwrapper.show();
                                if (data.bshadow)
                                    data.bshadow.show();

                                break;
                        }

                    }

                    return true;

                }

                return false;
            },

            hide: function() {

                var data = this.data().f,
                    turnData = data.opts.turn.data(),
                    folding = flipMethods._foldingPage.call(this);

                switch (data.effect) {
                    case 'hard':

                        if (turnData.opts.gradients) {
                            data.bshadowLoc = 0;
                            data.bshadow.remove();
                            data.ashadow.hide();
                        }

                        data.wrapper.transform('');
                        data.fpage.hide();

                        break;
                    case 'sheet':

                        if ((--data.fparent.data().flips)===0)
                            data.fparent.hide();

                        this.css({left: 0, top: 0, right: 'auto', bottom: 'auto'}).
                        transform('');

                        data.wrapper.transform('');

                        data.fwrapper.hide();

                        if (data.bshadow)
                            data.bshadow.hide();

                        folding.transform('');

                        break;
                }

                data.visible = false;

                return this;
            },

            hideFoldedPage: function(animate) {

                var data = this.data().f;

                if (!data.point) return;

                var that = this,
                    p1 = data.point,
                    hide = function() {
                        data.point = null;
                        data.status = '';
                        that.flip('hide');
                        that.trigger('end', [data.opts, false]);
                    };

                if (animate) {

                    var p4 = flipMethods._c.call(this, p1.corner),
                        top = (p1.corner.substr(0,1)=='t'),
                        delta = (top) ? Math.min(0, p1.y-p4.y)/2 : Math.max(0, p1.y-p4.y)/2,
                        p2 = point2D(p1.x, p1.y+delta),
                        p3 = point2D(p4.x, p4.y-delta);

                    this.animatef({
                        from: 0,
                        to: 1,
                        frame: function(v) {
                            var np = bezier(p1, p2, p3, p4, v);
                            p1.x = np.x;
                            p1.y = np.y;
                            flipMethods._fold.call(that, p1);
                        },
                        complete: hide,
                        duration: 800,
                        hiding: true
                    });

                } else {

                    this.animatef(false);
                    hide();

                }
            },

            turnPage: function(corner) {

                var that = this,
                    data = this.data().f,
                    turnData = data.opts.turn.data();

                corner = {corner: (data.corner) ?
                        data.corner.corner :
                        corner || flipMethods._cAllowed.call(this)[0]};

                var p1 = data.point ||
                    flipMethods._c.call(this,
                        corner.corner,
                        (data.opts.turn) ? turnData.opts.elevation : 0),
                    p4 = flipMethods._c2.call(this, corner.corner);

                this.trigger('flip').
                animatef({
                    from: 0,
                    to: 1,
                    frame: function(v) {

                        var np = bezier(p1, p1, p4, p4, v);
                        corner.x = np.x;
                        corner.y = np.y;
                        flipMethods._showFoldedPage.call(that, corner);

                    },
                    complete: function() {

                        that.trigger('end', [data.opts, true]);

                    },
                    duration: turnData.opts.duration,
                    turning: true
                });

                data.corner = null;
            },

            moving: function() {

                return 'effect' in this.data();

            },

            isTurning: function() {

                return this.flip('moving') && this.data().effect.turning;

            },

            corner: function() {

                return this.data().f.corner;

            },

            _eventStart: function(e) {

                var data = this.data().f,
                    turn = data.opts.turn;

                if (!data.corner && !data.disabled && !this.flip('isTurning') &&
                    data.opts.page==turn.data().pagePlace[data.opts.page])
                {

                    data.corner = flipMethods._isIArea.call(this, e);

                    if (data.corner && flipMethods._foldingPage.call(this)) {

                        this.trigger('pressed', [data.point]);
                        flipMethods._showFoldedPage.call(this, data.corner);

                        return false;

                    } else
                        data.corner = null;

                }

            },

            _eventMove: function(e) {

                var data = this.data().f;

                if (!data.disabled) {

                    e = (isTouch) ? e.originalEvent.touches : [e];

                    if (data.corner) {

                        var pos = data.parent.offset();
                        data.corner.x = e[0].pageX-pos.left;
                        data.corner.y = e[0].pageY-pos.top;
                        flipMethods._showFoldedPage.call(this, data.corner);

                    } else if (data.hover && !this.data().effect && this.is(':visible')) {

                        var point = flipMethods._isIArea.call(this, e[0]);

                        if (point) {

                            if ((data.effect=='sheet' && point.corner.length==2)  || data.effect=='hard') {
                                data.status = 'hover';
                                var origin = flipMethods._c.call(this, point.corner, data.opts.cornerSize/2);
                                point.x = origin.x;
                                point.y = origin.y;
                                flipMethods._showFoldedPage.call(this, point, true);
                            }

                        } else {

                            if (data.status=='hover') {
                                data.status = '';
                                flipMethods.hideFoldedPage.call(this, true);
                            }

                        }

                    }

                }

            },

            _eventEnd: function() {

                var data = this.data().f,
                    corner = data.corner;

                if (!data.disabled && corner) {
                    if (trigger('released', this, [data.point || corner])!='prevented') {
                        flipMethods.hideFoldedPage.call(this, true);
                    }
                }

                data.corner = null;

            },

            disable: function(disable) {

                flipMethods.setData.call(this, {'disabled': disable});
                return this;

            },

            hover: function(hover) {

                flipMethods.setData.call(this, {'hover': hover});
                return this;

            },

            peel: function (corner, animate) {

                var data = this.data().f;

                if (corner) {

                    if ($.inArray(corner, corners.all)==-1)
                        throw turnError('Corner '+corner+' is not permitted');

                    if ($.inArray(corner, flipMethods._cAllowed.call(this))!=-1) {

                        var point = flipMethods._c.call(this, corner, data.opts.cornerSize/2);

                        data.status = 'peel';

                        flipMethods._showFoldedPage.call(this,
                            {
                                corner: corner,
                                x: point.x,
                                y: point.y
                            }, animate);

                    }


                } else {

                    data.status = '';

                    flipMethods.hideFoldedPage.call(this, animate);

                }

                return this;
            }
        };


// Processes classes

    function dec(that, methods, args) {

        if (!args[0] || typeof(args[0])=='object')
            return methods.init.apply(that, args);

        else if (methods[args[0]])
            return methods[args[0]].apply(that, Array.prototype.slice.call(args, 1));

        else
            throw turnError(args[0] + ' is not a method or property');

    }


// Attributes for a layer

    function divAtt(top, left, zIndex, overf) {

        return {'css': {
                position: 'absolute',
                top: top,
                left: left,
                'overflow': overf || 'hidden',
                zIndex: zIndex || 'auto'
            }
        };

    }

// Gets a 2D point from a bezier curve of four points

    function bezier(p1, p2, p3, p4, t) {

        var a = 1 - t,
            b = a * a * a,
            c = t * t * t;

        return point2D(Math.round(b*p1.x + 3*t*a*a*p2.x + 3*t*t*a*p3.x + c*p4.x),
            Math.round(b*p1.y + 3*t*a*a*p2.y + 3*t*t*a*p3.y + c*p4.y));

    }

// Converts an angle from degrees to radians

    function rad(degrees) {

        return degrees/180*PI;

    }

// Converts an angle from radians to degrees

    function deg(radians) {

        return radians/PI*180;

    }

// Gets a 2D point

    function point2D(x, y) {

        return {x: x, y: y};

    }

// Webkit 534.3 on Android wrongly repaints elements that use overflow:hidden + rotation

    function rotationAvailable() {
        var parts;

        if ((parts = /AppleWebkit\/([0-9\.]+)/i.exec(navigator.userAgent))) {
            var webkitVersion = parseFloat(parts[1]);
            return (webkitVersion>534.3);
        } else {
            return true;
        }
    }

// Returns the traslate value

    function translate(x, y, use3d) {

        return (has3d && use3d) ? ' translate3d(' + x + 'px,' + y + 'px, 0px) '
            : ' translate(' + x + 'px, ' + y + 'px) ';

    }

// Returns the rotation value

    function rotate(degrees) {

        return ' rotate(' + degrees + 'deg) ';

    }

// Checks if a property belongs to an object

    function has(property, object) {

        return Object.prototype.hasOwnProperty.call(object, property);

    }

// Gets the CSS3 vendor prefix

    function getPrefix() {

        var vendorPrefixes = ['Moz','Webkit','Khtml','O','ms'],
            len = vendorPrefixes.length,
            vendor = '';

        while (len--)
            if ((vendorPrefixes[len] + 'Transform') in document.body.style)
                vendor='-'+vendorPrefixes[len].toLowerCase()+'-';

        return vendor;

    }

// Detects the transitionEnd Event

    function getTransitionEnd() {

        var t,
            el = document.createElement('fakeelement'),
            transitions = {
                'transition':'transitionend',
                'OTransition':'oTransitionEnd',
                'MSTransition':'transitionend',
                'MozTransition':'transitionend',
                'WebkitTransition':'webkitTransitionEnd'
            };

        for (t in transitions) {
            if (el.style[t] !== undefined) {
                return transitions[t];
            }
        }
    }

// Gradients

    function gradient(obj, p0, p1, colors, numColors) {

        var j, cols = [];

        if (vendor=='-webkit-') {

            for (j = 0; j<numColors; j++)
                cols.push('color-stop('+colors[j][0]+', '+colors[j][1]+')');

            obj.css({'background-image':
                    '-webkit-gradient(linear, '+
                    p0.x+'% '+
                    p0.y+'%,'+
                    p1.x+'% '+
                    p1.y+'%, '+
                    cols.join(',') + ' )'});
        } else {

            p0 = {x:p0.x/100 * obj.width(), y:p0.y/100 * obj.height()};
            p1 = {x:p1.x/100 * obj.width(), y:p1.y/100 * obj.height()};

            var dx = p1.x-p0.x,
                dy = p1.y-p0.y,
                angle = Math.atan2(dy, dx),
                angle2 = angle - Math.PI/2,
                diagonal = Math.abs(obj.width()*Math.sin(angle2))+Math.abs(obj.height()*Math.cos(angle2)),
                gradientDiagonal = Math.sqrt(dy*dy + dx*dx),
                corner = point2D((p1.x<p0.x) ? obj.width() : 0, (p1.y<p0.y) ? obj.height() : 0),
                slope = Math.tan(angle),
                inverse = -1/slope,
                x = (inverse*corner.x - corner.y - slope*p0.x + p0.y)/(inverse-slope),
                c = {x: x, y: inverse*x - inverse*corner.x + corner.y},
                segA = (Math.sqrt( Math.pow(c.x-p0.x,2) + Math.pow(c.y-p0.y,2)));

            for (j = 0; j<numColors; j++)
                cols.push(' '+colors[j][1]+' '+((segA + gradientDiagonal*colors[j][0])*100/diagonal)+'%');

            obj.css({'background-image': vendor+'linear-gradient(' + (-angle) + 'rad,' + cols.join(',') + ')'});
        }
    }


// Triggers an event

    function trigger(eventName, context, args) {

        var event = $.Event(eventName);
        context.trigger(event, args);
        if (event.isDefaultPrevented())
            return 'prevented';
        else if (event.isPropagationStopped())
            return 'stopped';
        else
            return '';
    }

// JS Errors

    function turnError(message) {

        function TurnJsError(message) {
            this.name = "TurnJsError";
            this.message = message;
        }

        TurnJsError.prototype = new Error();
        TurnJsError.prototype.constructor = TurnJsError;
        return new TurnJsError(message);

    }

// Find the offset of an element ignoring its transformation

    function findPos(obj) {

        var offset = {top: 0, left: 0};

        do{
            offset.left += obj.offsetLeft;
            offset.top += obj.offsetTop;
        } while ((obj = obj.offsetParent));

        return offset;

    }

// Checks if there's hard page compatibility
// IE9 is the only browser that does not support hard pages

    function hasHardPage() {
        return (navigator.userAgent.indexOf('MSIE 9.0')==-1);
    }

// Request an animation

    window.requestAnim = (function() {
        return window.requestAnimationFrame ||
            window.webkitRequestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            window.oRequestAnimationFrame ||
            window.msRequestAnimationFrame ||
            function(callback) {
                window.setTimeout(callback, 1000 / 60);
            };

    })();

// Extend $.fn

    $.extend($.fn, {

        flip: function() {
            return dec($(this[0]), flipMethods, arguments);
        },

        turn: function() {
            return dec($(this[0]), turnMethods, arguments);
        },

        transform: function(transform, origin) {

            var properties = {};

            if (origin)
                properties[vendor+'transform-origin'] = origin;

            properties[vendor+'transform'] = transform;

            return this.css(properties);

        },

        animatef: function(point) {

            var data = this.data();

            if (data.effect)
                data.effect.stop();

            if (point) {

                if (!point.to.length) point.to = [point.to];
                if (!point.from.length) point.from = [point.from];

                var diff = [],
                    len = point.to.length,
                    animating = true,
                    that = this,
                    time = (new Date()).getTime(),
                    frame = function() {

                        if (!data.effect || !animating)
                            return;

                        var v = [],
                            timeDiff = Math.min(point.duration, (new Date()).getTime() - time);

                        for (var i = 0; i < len; i++)
                            v.push(data.effect.easing(1, timeDiff, point.from[i], diff[i], point.duration));

                        point.frame((len==1) ? v[0] : v);

                        if (timeDiff==point.duration) {
                            delete data['effect'];
                            that.data(data);
                            if (point.complete)
                                point.complete();
                        } else {
                            window.requestAnim(frame);
                        }
                    };

                for (var i = 0; i < len; i++)
                    diff.push(point.to[i] - point.from[i]);

                data.effect = $.extend({
                    stop: function() {
                        animating = false;
                    },
                    easing: function (x, t, b, c, data) {
                        return c * Math.sqrt(1 - (t=t/data-1)*t) + b;
                    }
                }, point);

                this.data(data);

                frame();

            } else {

                delete data['effect'];

            }
        }
    });

// Export some globals

    $.isTouch = isTouch;
    $.mouseEvents = mouseEvents;
    $.cssPrefix = getPrefix;
    $.cssTransitionEnd = getTransitionEnd;
    $.findPos = findPos;

})(jQuery);

(function() {
    'use strict';

    angular
        .module('editorApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

// stats.js - http://github.com/mrdoob/stats.js
var Stats = function() {
    function h(a) {
        c.appendChild(a.dom);
        return a
    }
    function k(a) {
        for (var d = 0; d < c.children.length; d++)
            c.children[d].style.display = d === a ? "block" : "none";
        l = a
    }
    var l = 0
        , c = document.createElement("div");
    c.style.cssText = "position:fixed;top:0;left:0;cursor:pointer;opacity:0.9;z-index:10000";
    c.addEventListener("click", function(a) {
        a.preventDefault();
        k(++l % c.children.length)
    }, !1);
    var g = (performance || Date).now()
        , e = g
        , a = 0
        , r = h(new Stats.Panel("FPS","#0ff","#002"))
        , f = h(new Stats.Panel("MS","#0f0","#020"));
    if (self.performance && self.performance.memory)
        var t = h(new Stats.Panel("MB","#f08","#201"));
    k(0);
    return {
        REVISION: 16,
        dom: c,
        addPanel: h,
        showPanel: k,
        begin: function() {
            g = (performance || Date).now()
        },
        end: function() {
            a++;
            var c = (performance || Date).now();
            f.update(c - g, 200);
            if (c > e + 1E3 && (r.update(1E3 * a / (c - e), 100),
                e = c,
                a = 0,
                t)) {
                var d = performance.memory;
                t.update(d.usedJSHeapSize / 1048576, d.jsHeapSizeLimit / 1048576)
            }
            return c
        },
        update: function() {
            g = this.end()
        },
        domElement: c,
        setMode: k
    }
};
Stats.Panel = function(h, k, l) {
    var c = Infinity
        , g = 0
        , e = Math.round
        , a = e(window.devicePixelRatio || 1)
        , r = 80 * a
        , f = 48 * a
        , t = 3 * a
        , u = 2 * a
        , d = 3 * a
        , m = 15 * a
        , n = 74 * a
        , p = 30 * a
        , q = document.createElement("canvas");
    q.width = r;
    q.height = f;
    q.style.cssText = "width:80px;height:48px";
    var b = q.getContext("2d");
    b.font = "bold " + 9 * a + "px Helvetica,Arial,sans-serif";
    b.textBaseline = "top";
    b.fillStyle = l;
    b.fillRect(0, 0, r, f);
    b.fillStyle = k;
    b.fillText(h, t, u);
    b.fillRect(d, m, n, p);
    b.fillStyle = l;
    b.globalAlpha = .9;
    b.fillRect(d, m, n, p);
    return {
        dom: q,
        update: function(f, v) {
            c = Math.min(c, f);
            g = Math.max(g, f);
            b.fillStyle = l;
            b.globalAlpha = 1;
            b.fillRect(0, 0, r, m);
            b.fillStyle = k;
            b.fillText(e(f) + " " + h + " (" + e(c) + "-" + e(g) + ")", t, u);
            b.drawImage(q, d + a, m, n - a, p, d, m, n - a, p);
            b.fillRect(d + n - a, m, a, p);
            b.fillStyle = l;
            b.globalAlpha = .9;
            b.fillRect(d + n - a, m, a, e((1 - f / v) * p))
        }
    }
}
;
"object" === typeof module && (module.exports = Stats);

/*
 jQuery UI Sortable plugin wrapper

 @param [ui-sortable] {object} Options to pass to $.fn.sortable() merged onto ui.config
 */
angular
  .module('ui.sortable', [])
  .value('uiSortableConfig', {
    // the default for jquery-ui sortable is "> *", we need to restrict this to
    // ng-repeat items
    // if the user uses
    items: '> [ng-repeat],> [data-ng-repeat],> [x-ng-repeat]'
  })
  .directive('uiSortable', [
    'uiSortableConfig',
    '$timeout',
    '$log',
    function(uiSortableConfig, $timeout, $log) {
      return {
        require: '?ngModel',
        scope: {
          ngModel: '=',
          uiSortable: '=',
          ////Expression bindings from html.
          create: '&uiSortableCreate',
          // helper:'&uiSortableHelper',
          start: '&uiSortableStart',
          activate: '&uiSortableActivate',
          // sort:'&uiSortableSort',
          // change:'&uiSortableChange',
          // over:'&uiSortableOver',
          // out:'&uiSortableOut',
          beforeStop: '&uiSortableBeforeStop',
          update: '&uiSortableUpdate',
          remove: '&uiSortableRemove',
          receive: '&uiSortableReceive',
          deactivate: '&uiSortableDeactivate',
          stop: '&uiSortableStop'
        },
        link: function(scope, element, attrs, ngModel) {
          var savedNodes;
          var helper;

          function combineCallbacks(first, second) {
            var firstIsFunc = typeof first === 'function';
            var secondIsFunc = typeof second === 'function';
            if (firstIsFunc && secondIsFunc) {
              return function() {
                first.apply(this, arguments);
                second.apply(this, arguments);
              };
            } else if (secondIsFunc) {
              return second;
            }
            return first;
          }

          function getSortableWidgetInstance(element) {
            // this is a fix to support jquery-ui prior to v1.11.x
            // otherwise we should be using `element.sortable('instance')`
            var data = element.data('ui-sortable');
            if (
              data &&
              typeof data === 'object' &&
              data.widgetFullName === 'ui-sortable'
            ) {
              return data;
            }
            return null;
          }

          function setItemChildrenWidth(item) {
            item.children().each(function() {
              var $el = angular.element(this);

              // Preserve the with of the element
              $el.width($el.width());
            });
          }

          function dummyHelper(e, item) {
            return item;
          }

          function patchSortableOption(key, value) {
            if (callbacks[key]) {
              if (key === 'stop') {
                // call apply after stop
                value = combineCallbacks(value, function() {
                  scope.$apply();
                });

                value = combineCallbacks(value, afterStop);
              }
              // wrap the callback
              value = combineCallbacks(callbacks[key], value);
            } else if (wrappers[key]) {
              value = wrappers[key](value);
            }

            // patch the options that need to have values set
            if (!value && (key === 'items' || key === 'ui-model-items')) {
              value = uiSortableConfig.items;
            }

            return value;
          }

          function patchUISortableOptions(
            newOpts,
            oldOpts,
            sortableWidgetInstance
          ) {
            function addDummyOptionKey(value, key) {
              if (!(key in opts)) {
                // add the key in the opts object so that
                // the patch function detects and handles it
                opts[key] = null;
              }
            }
            // for this directive to work we have to attach some callbacks
            angular.forEach(callbacks, addDummyOptionKey);

            // only initialize it in case we have to
            // update some options of the sortable
            var optsDiff = null;

            if (oldOpts) {
              // reset deleted options to default
              var defaultOptions;
              angular.forEach(oldOpts, function(oldValue, key) {
                if (!newOpts || !(key in newOpts)) {
                  if (key in directiveOpts) {
                    if (key === 'ui-floating') {
                      opts[key] = 'auto';
                    } else {
                      opts[key] = patchSortableOption(key, undefined);
                    }
                    return;
                  }

                  if (!defaultOptions) {
                    defaultOptions = angular.element.ui.sortable().options;
                  }
                  var defaultValue = defaultOptions[key];
                  defaultValue = patchSortableOption(key, defaultValue);

                  if (!optsDiff) {
                    optsDiff = {};
                  }
                  optsDiff[key] = defaultValue;
                  opts[key] = defaultValue;
                }
              });
            }

            newOpts = angular.extend({}, newOpts);
            // update changed options
            // handle the custom option of the directive first
            angular.forEach(newOpts, function(value, key) {
              if (key in directiveOpts) {
                if (
                  key === 'ui-floating' &&
                  (value === false || value === true) &&
                  sortableWidgetInstance
                ) {
                  sortableWidgetInstance.floating = value;
                }

                if (
                  key === 'ui-preserve-size' &&
                  (value === false || value === true)
                ) {
                  var userProvidedHelper = opts.helper;
                  newOpts.helper = function(e, item) {
                    if (opts['ui-preserve-size'] === true) {
                      setItemChildrenWidth(item);
                    }
                    return (userProvidedHelper || dummyHelper).apply(
                      this,
                      arguments
                    );
                  };
                }

                opts[key] = patchSortableOption(key, value);
              }
            });

            // handle the normal option of the directive
            angular.forEach(newOpts, function(value, key) {
              if (key in directiveOpts) {
                // the custom option of the directive are already handled
                return;
              }

              value = patchSortableOption(key, value);

              if (!optsDiff) {
                optsDiff = {};
              }
              optsDiff[key] = value;
              opts[key] = value;
            });

            return optsDiff;
          }

          function getPlaceholderElement(element) {
            var placeholder = element.sortable('option', 'placeholder');

            // placeholder.element will be a function if the placeholder, has
            // been created (placeholder will be an object).  If it hasn't
            // been created, either placeholder will be false if no
            // placeholder class was given or placeholder.element will be
            // undefined if a class was given (placeholder will be a string)
            if (
              placeholder &&
              placeholder.element &&
              typeof placeholder.element === 'function'
            ) {
              var result = placeholder.element();
              // workaround for jquery ui 1.9.x,
              // not returning jquery collection
              result = angular.element(result);
              return result;
            }
            return null;
          }

          function getPlaceholderExcludesludes(element, placeholder) {
            // exact match with the placeholder's class attribute to handle
            // the case that multiple connected sortables exist and
            // the placeholder option equals the class of sortable items
            var notCssSelector = opts['ui-model-items'].replace(/[^,]*>/g, '');
            var excludes = element.find(
              '[class="' +
                placeholder.attr('class') +
                '"]:not(' +
                notCssSelector +
                ')'
            );
            return excludes;
          }

          function hasSortingHelper(element, ui) {
            var helperOption = element.sortable('option', 'helper');
            return (
              helperOption === 'clone' ||
              (typeof helperOption === 'function' &&
                ui.item.sortable.isCustomHelperUsed())
            );
          }

          function getSortingHelper(element, ui /*, savedNodes*/) {
            var result = null;
            if (
              hasSortingHelper(element, ui) &&
              element.sortable('option', 'appendTo') === 'parent'
            ) {
              // The .ui-sortable-helper element (that's the default class name)
              result = helper;
            }
            return result;
          }

          // thanks jquery-ui
          function isFloating(item) {
            return (
              /left|right/.test(item.css('float')) ||
              /inline|table-cell/.test(item.css('display'))
            );
          }

          function getElementContext(elementScopes, element) {
            for (var i = 0; i < elementScopes.length; i++) {
              var c = elementScopes[i];
              if (c.element[0] === element[0]) {
                return c;
              }
            }
          }

          function afterStop(e, ui) {
            ui.item.sortable._destroy();
          }

          // return the index of ui.item among the items
          // we can't just do ui.item.index() because there it might have siblings
          // which are not items
          function getItemIndex(item) {
            return item
              .parent()
              .find(opts['ui-model-items'])
              .index(item);
          }

          var opts = {};

          // directive specific options
          var directiveOpts = {
            'ui-floating': undefined,
            'ui-model-items': uiSortableConfig.items,
            'ui-preserve-size': undefined
          };

          var callbacks = {
            create: null,
            start: null,
            activate: null,
            // sort: null,
            // change: null,
            // over: null,
            // out: null,
            beforeStop: null,
            update: null,
            remove: null,
            receive: null,
            deactivate: null,
            stop: null
          };

          var wrappers = {
            helper: null
          };

          angular.extend(
            opts,
            directiveOpts,
            uiSortableConfig,
            scope.uiSortable
          );

          if (!angular.element.fn || !angular.element.fn.jquery) {
            $log.error(
              'ui.sortable: jQuery should be included before AngularJS!'
            );
            return;
          }

          function wireUp() {
            // When we add or remove elements, we need the sortable to 'refresh'
            // so it can find the new/removed elements.
            scope.$watchCollection('ngModel', function() {
              // Timeout to let ng-repeat modify the DOM
              $timeout(
                function() {
                  // ensure that the jquery-ui-sortable widget instance
                  // is still bound to the directive's element
                  if (!!getSortableWidgetInstance(element)) {
                    element.sortable('refresh');
                  }
                },
                0,
                false
              );
            });

            callbacks.start = function(e, ui) {
              if (opts['ui-floating'] === 'auto') {
                // since the drag has started, the element will be
                // absolutely positioned, so we check its siblings
                var siblings = ui.item.siblings();
                var sortableWidgetInstance = getSortableWidgetInstance(
                  angular.element(e.target)
                );
                sortableWidgetInstance.floating = isFloating(siblings);
              }

              // Save the starting position of dragged item
              var index = getItemIndex(ui.item);
              ui.item.sortable = {
                model: ngModel.$modelValue[index],
                index: index,
                source: element,
                sourceList: ui.item.parent(),
                sourceModel: ngModel.$modelValue,
                cancel: function() {
                  ui.item.sortable._isCanceled = true;
                },
                isCanceled: function() {
                  return ui.item.sortable._isCanceled;
                },
                isCustomHelperUsed: function() {
                  return !!ui.item.sortable._isCustomHelperUsed;
                },
                _isCanceled: false,
                _isCustomHelperUsed: ui.item.sortable._isCustomHelperUsed,
                _destroy: function() {
                  angular.forEach(ui.item.sortable, function(value, key) {
                    ui.item.sortable[key] = undefined;
                  });
                },
                _connectedSortables: [],
                _getElementContext: function(element) {
                  return getElementContext(this._connectedSortables, element);
                }
              };
            };

            callbacks.activate = function(e, ui) {
              var isSourceContext = ui.item.sortable.source === element;
              var savedNodesOrigin = isSourceContext
                ? ui.item.sortable.sourceList
                : element;
              var elementContext = {
                element: element,
                scope: scope,
                isSourceContext: isSourceContext,
                savedNodesOrigin: savedNodesOrigin
              };
              // save the directive's scope so that it is accessible from ui.item.sortable
              ui.item.sortable._connectedSortables.push(elementContext);

              // We need to make a copy of the current element's contents so
              // we can restore it after sortable has messed it up.
              // This is inside activate (instead of start) in order to save
              // both lists when dragging between connected lists.
              savedNodes = savedNodesOrigin.contents();
              helper = ui.helper;

              // If this list has a placeholder (the connected lists won't),
              // don't inlcude it in saved nodes.
              var placeholder = getPlaceholderElement(element);
              if (placeholder && placeholder.length) {
                var excludes = getPlaceholderExcludesludes(
                  element,
                  placeholder
                );
                savedNodes = savedNodes.not(excludes);
              }
            };

            callbacks.update = function(e, ui) {
              // Save current drop position but only if this is not a second
              // update that happens when moving between lists because then
              // the value will be overwritten with the old value
              if (!ui.item.sortable.received) {
                ui.item.sortable.dropindex = getItemIndex(ui.item);
                var droptarget = ui.item
                  .parent()
                  .closest(
                    '[ui-sortable], [data-ui-sortable], [x-ui-sortable]'
                  );
                ui.item.sortable.droptarget = droptarget;
                ui.item.sortable.droptargetList = ui.item.parent();

                var droptargetContext = ui.item.sortable._getElementContext(
                  droptarget
                );
                ui.item.sortable.droptargetModel =
                  droptargetContext.scope.ngModel;

                // Cancel the sort (let ng-repeat do the sort for us)
                // Don't cancel if this is the received list because it has
                // already been canceled in the other list, and trying to cancel
                // here will mess up the DOM.
                element.sortable('cancel');
              }

              // Put the nodes back exactly the way they started (this is very
              // important because ng-repeat uses comment elements to delineate
              // the start and stop of repeat sections and sortable doesn't
              // respect their order (even if we cancel, the order of the
              // comments are still messed up).
              var sortingHelper =
                !ui.item.sortable.received &&
                getSortingHelper(element, ui, savedNodes);
              if (sortingHelper && sortingHelper.length) {
                // Restore all the savedNodes except from the sorting helper element.
                // That way it will be garbage collected.
                savedNodes = savedNodes.not(sortingHelper);
              }
              var elementContext = ui.item.sortable._getElementContext(element);
              savedNodes.appendTo(elementContext.savedNodesOrigin);

              // If this is the target connected list then
              // it's safe to clear the restored nodes since:
              // update is currently running and
              // stop is not called for the target list.
              if (ui.item.sortable.received) {
                savedNodes = null;
              }

              // If received is true (an item was dropped in from another list)
              // then we add the new item to this list otherwise wait until the
              // stop event where we will know if it was a sort or item was
              // moved here from another list
              if (ui.item.sortable.received && !ui.item.sortable.isCanceled()) {
                scope.$apply(function() {
                  ngModel.$modelValue.splice(
                    ui.item.sortable.dropindex,
                    0,
                    ui.item.sortable.moved
                  );
                });
                scope.$emit('ui-sortable:moved', ui);
              }
            };

            callbacks.stop = function(e, ui) {
              // If the received flag hasn't be set on the item, this is a
              // normal sort, if dropindex is set, the item was moved, so move
              // the items in the list.
              var wasMoved =
                'dropindex' in ui.item.sortable &&
                !ui.item.sortable.isCanceled();

              if (wasMoved && !ui.item.sortable.received) {
                scope.$apply(function() {
                  ngModel.$modelValue.splice(
                    ui.item.sortable.dropindex,
                    0,
                    ngModel.$modelValue.splice(ui.item.sortable.index, 1)[0]
                  );
                });
                scope.$emit('ui-sortable:moved', ui);
              } else if (
                !wasMoved &&
                !angular.equals(
                  element.contents().toArray(),
                  savedNodes.toArray()
                )
              ) {
                // if the item was not moved
                // and the DOM element order has changed,
                // then restore the elements
                // so that the ngRepeat's comment are correct.

                var sortingHelper = getSortingHelper(element, ui, savedNodes);
                if (sortingHelper && sortingHelper.length) {
                  // Restore all the savedNodes except from the sorting helper element.
                  // That way it will be garbage collected.
                  savedNodes = savedNodes.not(sortingHelper);
                }
                var elementContext = ui.item.sortable._getElementContext(
                  element
                );
                savedNodes.appendTo(elementContext.savedNodesOrigin);
              }

              // It's now safe to clear the savedNodes and helper
              // since stop is the last callback.
              savedNodes = null;
              helper = null;
            };

            callbacks.receive = function(e, ui) {
              // An item was dropped here from another list, set a flag on the
              // item.
              ui.item.sortable.received = true;
            };

            callbacks.remove = function(e, ui) {
              // Workaround for a problem observed in nested connected lists.
              // There should be an 'update' event before 'remove' when moving
              // elements. If the event did not fire, cancel sorting.
              if (!('dropindex' in ui.item.sortable)) {
                element.sortable('cancel');
                ui.item.sortable.cancel();
              }

              // Remove the item from this list's model and copy data into item,
              // so the next list can retrive it
              if (!ui.item.sortable.isCanceled()) {
                scope.$apply(function() {
                  ui.item.sortable.moved = ngModel.$modelValue.splice(
                    ui.item.sortable.index,
                    1
                  )[0];
                });
              }
            };

            // setup attribute handlers
            angular.forEach(callbacks, function(value, key) {
              callbacks[key] = combineCallbacks(callbacks[key], function() {
                var attrHandler = scope[key];
                var attrHandlerFn;
                if (
                  typeof attrHandler === 'function' &&
                  (
                    'uiSortable' +
                    key.substring(0, 1).toUpperCase() +
                    key.substring(1)
                  ).length &&
                  typeof (attrHandlerFn = attrHandler()) === 'function'
                ) {
                  attrHandlerFn.apply(this, arguments);
                }
              });
            });

            wrappers.helper = function(inner) {
              if (inner && typeof inner === 'function') {
                return function(e, item) {
                  var oldItemSortable = item.sortable;
                  var index = getItemIndex(item);

                  item.sortable = {
                    model: ngModel.$modelValue[index],
                    index: index,
                    source: element,
                    sourceList: item.parent(),
                    sourceModel: ngModel.$modelValue,
                    _restore: function() {
                      angular.forEach(item.sortable, function(value, key) {
                        item.sortable[key] = undefined;
                      });

                      item.sortable = oldItemSortable;
                    }
                  };

                  var innerResult = inner.apply(this, arguments);
                  item.sortable._restore();
                  item.sortable._isCustomHelperUsed = item !== innerResult;
                  return innerResult;
                };
              }
              return inner;
            };

            scope.$watchCollection(
              'uiSortable',
              function(newOpts, oldOpts) {
                // ensure that the jquery-ui-sortable widget instance
                // is still bound to the directive's element
                var sortableWidgetInstance = getSortableWidgetInstance(element);
                if (!!sortableWidgetInstance) {
                  var optsDiff = patchUISortableOptions(
                    newOpts,
                    oldOpts,
                    sortableWidgetInstance
                  );

                  if (optsDiff) {
                    element.sortable('option', optsDiff);
                  }
                }
              },
              true
            );

            patchUISortableOptions(opts);
          }

          function init() {
            if (ngModel) {
              wireUp();
            } else {
              $log.info('ui.sortable: ngModel not provided!', element);
            }

            // Create sortable
            element.sortable(opts);
          }

          function initIfEnabled() {
            if (scope.uiSortable && scope.uiSortable.disabled) {
              return false;
            }

            init();

            // Stop Watcher
            initIfEnabled.cancelWatcher();
            initIfEnabled.cancelWatcher = angular.noop;

            return true;
          }

          initIfEnabled.cancelWatcher = angular.noop;

          if (!initIfEnabled()) {
            initIfEnabled.cancelWatcher = scope.$watch(
              'uiSortable.disabled',
              initIfEnabled
            );
          }
        }
      };
    }
  ]);

(function() {
    'use strict';

    angular
        .module('editorApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

/*
 * [js-sha1]{@link https://github.com/emn178/js-sha1}
 *
 * @version 0.4.1
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2014-2016
 * @license MIT
 */
/*jslint bitwise: true */
(function() {
  'use strict';

  var root = typeof window === 'object' ? window : {};
  var NODE_JS = !root.JS_SHA1_NO_NODE_JS && typeof process === 'object' && process.versions && process.versions.node;
  if (NODE_JS) {
    root = global;
  }
  var COMMON_JS = !root.JS_SHA1_NO_COMMON_JS && typeof module === 'object' && module.exports;
  var AMD = typeof define === 'function' && define.amd;
  var HEX_CHARS = '0123456789abcdef'.split('');
  var EXTRA = [-2147483648, 8388608, 32768, 128];
  var SHIFT = [24, 16, 8, 0];
  var OUTPUT_TYPES = ['hex', 'array', 'digest', 'arrayBuffer'];

  var blocks = [];

  var createOutputMethod = function (outputType) {
    return function (message) {
      return new Sha1(true).update(message)[outputType]();
    };
  };

  var createMethod = function () {
    var method = createOutputMethod('hex');
    if (NODE_JS) {
      method = nodeWrap(method);
    }
    method.create = function () {
      return new Sha1();
    };
    method.update = function (message) {
      return method.create().update(message);
    };
    for (var i = 0; i < OUTPUT_TYPES.length; ++i) {
      var type = OUTPUT_TYPES[i];
      method[type] = createOutputMethod(type);
    }
    return method;
  };

  var nodeWrap = function (method) {
    var crypto = require('crypto');
    var Buffer = require('buffer').Buffer;
    var nodeMethod = function (message) {
      if (typeof message === 'string') {
        return crypto.createHash('sha1').update(message, 'utf8').digest('hex');
      } else if (message.constructor === ArrayBuffer) {
        message = new Uint8Array(message);
      } else if (message.length === undefined) {
        return method(message);
      }
      return crypto.createHash('sha1').update(new Buffer(message)).digest('hex');
    };
    return nodeMethod;
  };

  function Sha1(sharedMemory) {
    if (sharedMemory) {
      blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] =
      blocks[4] = blocks[5] = blocks[6] = blocks[7] =
      blocks[8] = blocks[9] = blocks[10] = blocks[11] =
      blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
      this.blocks = blocks;
    } else {
      this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    }

    this.h0 = 0x67452301;
    this.h1 = 0xEFCDAB89;
    this.h2 = 0x98BADCFE;
    this.h3 = 0x10325476;
    this.h4 = 0xC3D2E1F0;

    this.block = this.start = this.bytes = 0;
    this.finalized = this.hashed = false;
    this.first = true;
  }

  Sha1.prototype.update = function (message) {
    if (this.finalized) {
      return;
    }
    var notString = typeof(message) !== 'string';
    if (notString && message.constructor === root.ArrayBuffer) {
      message = new Uint8Array(message);
    }
    var code, index = 0, i, length = message.length || 0, blocks = this.blocks;

    while (index < length) {
      if (this.hashed) {
        this.hashed = false;
        blocks[0] = this.block;
        blocks[16] = blocks[1] = blocks[2] = blocks[3] =
        blocks[4] = blocks[5] = blocks[6] = blocks[7] =
        blocks[8] = blocks[9] = blocks[10] = blocks[11] =
        blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
      }

      if(notString) {
        for (i = this.start; index < length && i < 64; ++index) {
          blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
        }
      } else {
        for (i = this.start; index < length && i < 64; ++index) {
          code = message.charCodeAt(index);
          if (code < 0x80) {
            blocks[i >> 2] |= code << SHIFT[i++ & 3];
          } else if (code < 0x800) {
            blocks[i >> 2] |= (0xc0 | (code >> 6)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
          } else if (code < 0xd800 || code >= 0xe000) {
            blocks[i >> 2] |= (0xe0 | (code >> 12)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | ((code >> 6) & 0x3f)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
          } else {
            code = 0x10000 + (((code & 0x3ff) << 10) | (message.charCodeAt(++index) & 0x3ff));
            blocks[i >> 2] |= (0xf0 | (code >> 18)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | ((code >> 12) & 0x3f)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | ((code >> 6) & 0x3f)) << SHIFT[i++ & 3];
            blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
          }
        }
      }

      this.lastByteIndex = i;
      this.bytes += i - this.start;
      if (i >= 64) {
        this.block = blocks[16];
        this.start = i - 64;
        this.hash();
        this.hashed = true;
      } else {
        this.start = i;
      }
    }
    return this;
  };

  Sha1.prototype.finalize = function () {
    if (this.finalized) {
      return;
    }
    this.finalized = true;
    var blocks = this.blocks, i = this.lastByteIndex;
    blocks[16] = this.block;
    blocks[i >> 2] |= EXTRA[i & 3];
    this.block = blocks[16];
    if (i >= 56) {
      if (!this.hashed) {
        this.hash();
      }
      blocks[0] = this.block;
      blocks[16] = blocks[1] = blocks[2] = blocks[3] =
      blocks[4] = blocks[5] = blocks[6] = blocks[7] =
      blocks[8] = blocks[9] = blocks[10] = blocks[11] =
      blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
    }
    blocks[15] = this.bytes << 3;
    this.hash();
  };

  Sha1.prototype.hash = function () {
    var a = this.h0, b = this.h1, c = this.h2, d = this.h3, e = this.h4;
    var f, j, t, blocks = this.blocks;

    for(j = 16; j < 80; ++j) {
      t = blocks[j - 3] ^ blocks[j - 8] ^ blocks[j - 14] ^ blocks[j - 16];
      blocks[j] =  (t << 1) | (t >>> 31);
    }

    for(j = 0; j < 20; j += 5) {
      f = (b & c) | ((~b) & d);
      t = (a << 5) | (a >>> 27);
      e = t + f + e + 1518500249 + blocks[j] << 0;
      b = (b << 30) | (b >>> 2);

      f = (a & b) | ((~a) & c);
      t = (e << 5) | (e >>> 27);
      d = t + f + d + 1518500249 + blocks[j + 1] << 0;
      a = (a << 30) | (a >>> 2);

      f = (e & a) | ((~e) & b);
      t = (d << 5) | (d >>> 27);
      c = t + f + c + 1518500249 + blocks[j + 2] << 0;
      e = (e << 30) | (e >>> 2);

      f = (d & e) | ((~d) & a);
      t = (c << 5) | (c >>> 27);
      b = t + f + b + 1518500249 + blocks[j + 3] << 0;
      d = (d << 30) | (d >>> 2);

      f = (c & d) | ((~c) & e);
      t = (b << 5) | (b >>> 27);
      a = t + f + a + 1518500249 + blocks[j + 4] << 0;
      c = (c << 30) | (c >>> 2);
    }

    for(; j < 40; j += 5) {
      f = b ^ c ^ d;
      t = (a << 5) | (a >>> 27);
      e = t + f + e + 1859775393 + blocks[j] << 0;
      b = (b << 30) | (b >>> 2);

      f = a ^ b ^ c;
      t = (e << 5) | (e >>> 27);
      d = t + f + d + 1859775393 + blocks[j + 1] << 0;
      a = (a << 30) | (a >>> 2);

      f = e ^ a ^ b;
      t = (d << 5) | (d >>> 27);
      c = t + f + c + 1859775393 + blocks[j + 2] << 0;
      e = (e << 30) | (e >>> 2);

      f = d ^ e ^ a;
      t = (c << 5) | (c >>> 27);
      b = t + f + b + 1859775393 + blocks[j + 3] << 0;
      d = (d << 30) | (d >>> 2);

      f = c ^ d ^ e;
      t = (b << 5) | (b >>> 27);
      a = t + f + a + 1859775393 + blocks[j + 4] << 0;
      c = (c << 30) | (c >>> 2);
    }

    for(; j < 60; j += 5) {
      f = (b & c) | (b & d) | (c & d);
      t = (a << 5) | (a >>> 27);
      e = t + f + e - 1894007588 + blocks[j] << 0;
      b = (b << 30) | (b >>> 2);

      f = (a & b) | (a & c) | (b & c);
      t = (e << 5) | (e >>> 27);
      d = t + f + d - 1894007588 + blocks[j + 1] << 0;
      a = (a << 30) | (a >>> 2);

      f = (e & a) | (e & b) | (a & b);
      t = (d << 5) | (d >>> 27);
      c = t + f + c - 1894007588 + blocks[j + 2] << 0;
      e = (e << 30) | (e >>> 2);

      f = (d & e) | (d & a) | (e & a);
      t = (c << 5) | (c >>> 27);
      b = t + f + b - 1894007588 + blocks[j + 3] << 0;
      d = (d << 30) | (d >>> 2);

      f = (c & d) | (c & e) | (d & e);
      t = (b << 5) | (b >>> 27);
      a = t + f + a - 1894007588 + blocks[j + 4] << 0;
      c = (c << 30) | (c >>> 2);
    }

    for(; j < 80; j += 5) {
      f = b ^ c ^ d;
      t = (a << 5) | (a >>> 27);
      e = t + f + e - 899497514 + blocks[j] << 0;
      b = (b << 30) | (b >>> 2);

      f = a ^ b ^ c;
      t = (e << 5) | (e >>> 27);
      d = t + f + d - 899497514 + blocks[j + 1] << 0;
      a = (a << 30) | (a >>> 2);

      f = e ^ a ^ b;
      t = (d << 5) | (d >>> 27);
      c = t + f + c - 899497514 + blocks[j + 2] << 0;
      e = (e << 30) | (e >>> 2);

      f = d ^ e ^ a;
      t = (c << 5) | (c >>> 27);
      b = t + f + b - 899497514 + blocks[j + 3] << 0;
      d = (d << 30) | (d >>> 2);

      f = c ^ d ^ e;
      t = (b << 5) | (b >>> 27);
      a = t + f + a - 899497514 + blocks[j + 4] << 0;
      c = (c << 30) | (c >>> 2);
    }

    this.h0 = this.h0 + a << 0;
    this.h1 = this.h1 + b << 0;
    this.h2 = this.h2 + c << 0;
    this.h3 = this.h3 + d << 0;
    this.h4 = this.h4 + e << 0;
  };

  Sha1.prototype.hex = function () {
    this.finalize();

    var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4;

    return HEX_CHARS[(h0 >> 28) & 0x0F] + HEX_CHARS[(h0 >> 24) & 0x0F] +
           HEX_CHARS[(h0 >> 20) & 0x0F] + HEX_CHARS[(h0 >> 16) & 0x0F] +
           HEX_CHARS[(h0 >> 12) & 0x0F] + HEX_CHARS[(h0 >> 8) & 0x0F] +
           HEX_CHARS[(h0 >> 4) & 0x0F] + HEX_CHARS[h0 & 0x0F] +
           HEX_CHARS[(h1 >> 28) & 0x0F] + HEX_CHARS[(h1 >> 24) & 0x0F] +
           HEX_CHARS[(h1 >> 20) & 0x0F] + HEX_CHARS[(h1 >> 16) & 0x0F] +
           HEX_CHARS[(h1 >> 12) & 0x0F] + HEX_CHARS[(h1 >> 8) & 0x0F] +
           HEX_CHARS[(h1 >> 4) & 0x0F] + HEX_CHARS[h1 & 0x0F] +
           HEX_CHARS[(h2 >> 28) & 0x0F] + HEX_CHARS[(h2 >> 24) & 0x0F] +
           HEX_CHARS[(h2 >> 20) & 0x0F] + HEX_CHARS[(h2 >> 16) & 0x0F] +
           HEX_CHARS[(h2 >> 12) & 0x0F] + HEX_CHARS[(h2 >> 8) & 0x0F] +
           HEX_CHARS[(h2 >> 4) & 0x0F] + HEX_CHARS[h2 & 0x0F] +
           HEX_CHARS[(h3 >> 28) & 0x0F] + HEX_CHARS[(h3 >> 24) & 0x0F] +
           HEX_CHARS[(h3 >> 20) & 0x0F] + HEX_CHARS[(h3 >> 16) & 0x0F] +
           HEX_CHARS[(h3 >> 12) & 0x0F] + HEX_CHARS[(h3 >> 8) & 0x0F] +
           HEX_CHARS[(h3 >> 4) & 0x0F] + HEX_CHARS[h3 & 0x0F] +
           HEX_CHARS[(h4 >> 28) & 0x0F] + HEX_CHARS[(h4 >> 24) & 0x0F] +
           HEX_CHARS[(h4 >> 20) & 0x0F] + HEX_CHARS[(h4 >> 16) & 0x0F] +
           HEX_CHARS[(h4 >> 12) & 0x0F] + HEX_CHARS[(h4 >> 8) & 0x0F] +
           HEX_CHARS[(h4 >> 4) & 0x0F] + HEX_CHARS[h4 & 0x0F];
  };

  Sha1.prototype.toString = Sha1.prototype.hex;

  Sha1.prototype.digest = function () {
    this.finalize();

    var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4;

    return [
      (h0 >> 24) & 0xFF, (h0 >> 16) & 0xFF, (h0 >> 8) & 0xFF, h0 & 0xFF,
      (h1 >> 24) & 0xFF, (h1 >> 16) & 0xFF, (h1 >> 8) & 0xFF, h1 & 0xFF,
      (h2 >> 24) & 0xFF, (h2 >> 16) & 0xFF, (h2 >> 8) & 0xFF, h2 & 0xFF,
      (h3 >> 24) & 0xFF, (h3 >> 16) & 0xFF, (h3 >> 8) & 0xFF, h3 & 0xFF,
      (h4 >> 24) & 0xFF, (h4 >> 16) & 0xFF, (h4 >> 8) & 0xFF, h4 & 0xFF
    ];
  };

  Sha1.prototype.array = Sha1.prototype.digest;

  Sha1.prototype.arrayBuffer = function () {
    this.finalize();

    var buffer = new ArrayBuffer(20);
    var dataView = new DataView(buffer);
    dataView.setUint32(0, this.h0);
    dataView.setUint32(4, this.h1);
    dataView.setUint32(8, this.h2);
    dataView.setUint32(12, this.h3);
    dataView.setUint32(16, this.h4);
    return buffer;
  };

  var exports = createMethod();

  if (COMMON_JS) {
    module.exports = exports;
  } else {
    root.sha1 = exports;
    if (AMD) {
      define(function () {
        return exports;
      });
    }
  }
})();

function MeasureRuler(dParam){
    var param={
        wrapperId:"rulerWrapper",   //标尺ID
        max:1000,      //标尺最大刻度
        minUnit:1,     //标尺最小单位刻度
        unitSet:10,    //标尺单位单位刻度组
        min:0,         //最小值
        mult:1,         //标尺单位刻度的倍数 最小是1 即每一刻度占10px
        vertical:false, //是否垂直
        left:0,
        topOffset:0,
        click:function () {},
        yClick:function () {},
    }
    $.extend(param,dParam);

    var limitLeft=0;
    var scrollerWidth=0;
    var wrapperWidth=0;
    var pleft=0;
    var firstRand=true;
    var self=this;
    var fixedLen=param.minUnit.toString().split(".")[1]?param.minUnit.toString().split(".")[1].length:0;
    this.initRuler=function(){
        if(param.min>param.max) param.min=0
        var nhtml="";
        limitLeft=0;
        scrollerWidth=0;
        wrapperWidth=0;
        if(!param.vertical){
            $("#"+param.wrapperId).addClass("rulerWrapper")
            $("#"+param.wrapperId).append('<div class="rulerScroller"></div><div class="rulerPointer"></div>')
            var setLen=Math.ceil((param.max-param.min)/(param.unitSet*param.minUnit))+6;
            var setWidth=param.unitSet*10*param.mult;
            param.left = param.left-setWidth;
            for(var i=0;i<setLen;i++){
                nhtml+="<span class='sizeNo' style='left:"+(i*setWidth-setWidth/2)+"px;width:"+setWidth+"px'></span><ul  style='width:"+setWidth+"px'>";
                if(10*param.mult > 4) {
                    for (var j = 0; j < (param.unitSet - 1); j++) {
                        nhtml += "<li style='width:" + 10 * param.mult + "px'></li>";
                    }
                }
                nhtml+="<div class='rulerPointer-hr'></div></ul>";
            }
        }else{
            $("#"+param.wrapperId).addClass("rulerWrapper1")
            $("#"+param.wrapperId).append('<div class="rulerScroller"></div><div class="rulerPointer"></div>')
            var setLen=Math.ceil((param.max-param.min)/(param.unitSet*param.minUnit))+6;
            var setWidth=param.unitSet*10*param.mult;
            param.top = param.top-setWidth;
            for(var i=0;i<setLen;i++){
                nhtml+="<span class='sizeNo' style='top:"+(i*setWidth-setWidth/2)+"px;height:"+setWidth+"px'></span><ul  style='height:"+setWidth+"px'>";
                if(10*param.mult > 4){
                    for(var j=0;j<(param.unitSet-1);j++){
                        nhtml+="<li style='height:"+10*param.mult+"px'></li>";
                    }
                }
                nhtml+="<div class='rulerPointer-hr'></div></ul>";
            }
        }
        $("#"+param.wrapperId+" .rulerScroller").append(nhtml);
        var st;
        wrapperWidth=$("#"+param.wrapperId).width();
        scrollerWidth=setLen*10*param.unitSet*param.mult;

        // $("#"+param.wrapperId).on('touchstart',function(e){
        //     var touch = e.originalEvent.targetTouches[0];
        //     st = touch.pageX;
        // })

        // $("#"+param.wrapperId).on('touchmove',function(e){
        //     var touch = e.originalEvent.targetTouches[0];
        //     var x = touch.pageX;
        //     var lf=$("#"+param.wrapperId+" .rulerScroller").position().left;
        //     var nlf=lf+x-st;
        //
        //     //超过最左或者最右标尺不可滑动
        //     if(lf-50 > limitLeft || wrapperWidth-scrollerWidth>lf+50){
        //         return;
        //     }
        //     var pointerVal=Math.floor((limitLeft-nlf)/(10*param.mult))>0?Math.floor((limitLeft-nlf)/(10*param.mult)):0;
        //         pointerVal=param.minUnit*pointerVal+param.min;
        //
        //     if(fixedLen) pointerVal=pointerVal.toFixed(fixedLen);
        //     if(param.callback)  param.callback(pointerVal)
        //     $("#"+param.wrapperId+" .rulerScroller").css("left",nlf);
        //
        // })
        //
        // $("#"+param.wrapperId).on('touchend',function(e){
        //
        //     var lf=$("#"+param.wrapperId+" .rulerScroller").position().left;
        //     if(lf > limitLeft){
        //         $("#"+param.wrapperId+" .rulerScroller").css("left",limitLeft);
        //         if(param.callback) param.callback(param.min);
        //         return;
        //     }else if(wrapperWidth-scrollerWidth>lf){
        //         self.setValue(param.max);
        //         return;
        //     }
        //     var lf=$("#"+param.wrapperId+" .rulerScroller").position().left;
        //     var disNo=Math.round((lf-pleft)/(10*param.mult));
        //     var nDis=disNo*10*param.mult+pleft;
        //     $("#"+param.wrapperId+" .rulerScroller").css("left",nDis);
        //     var pointerVal=Math.floor((limitLeft-nDis)/(10*param.mult));
        //     pointerVal=param.minUnit*pointerVal+param.min;
        //     if(fixedLen) pointerVal=pointerVal.toFixed(fixedLen);
        //     if(param.callback)  param.callback(pointerVal)
        // })

        //中间标志的位置
        // if(firstRand){
        //     pleft=$("#"+param.wrapperId+" .rulerPointer").position().left;
        // }
        var rulerLNo=0;
        for(var z=1;z<setLen;z++){
            if(z*setWidth>pleft) {
                limitLeft=pleft-z*setWidth;
                rulerLNo=z;
                break;
            }
        }

        //标尺初始化数值
        this.setValue(param.value);

        //标尺刻度值
        $("#"+param.wrapperId+" .sizeNo").each(function(idx,ele){
            if(idx>=rulerLNo && idx<setLen-1){
                var iv=(idx-rulerLNo)*param.minUnit*param.unitSet+param.min;
                if(fixedLen) iv=iv.toFixed(fixedLen);
                $(ele).html(iv);
            }
        })
        //刻度尺鼠标移入事件
        $("#"+param.wrapperId).on('mousemove',function (e) {
            if(!param.vertical){
                $('.c-ruler-left').remove()
                var _value = (e.pageX - $(this).offset().left - param.left - param.unitSet*10*param.mult)/param.mult/10;
                var _li = '<span class="c-ruler-left" style="left:'+ (e.pageX - $(this).offset().left) +'px">'+Math.round(_value)+'</span>';
                $(this).append(_li);
            }else{
                $('.c-ruler-y').remove()
                var _value = (e.pageY - $(this).offset().top - param.top - param.unitSet*10*param.mult)/param.mult/10;
                var _li = '<span class="c-ruler-y" style="top:'+ (e.pageY - $(this).offset().top - 20) +'px">'+Math.round(_value)+'</span>';
                $(this).append(_li);
            }
        })
        $("#"+param.wrapperId).on('mouseleave',function (e) {
            $('.c-ruler-left').remove()
            $('.c-ruler-y').remove()
        })
        $("#"+param.wrapperId).on('click',function (e) {
            if(!param.vertical) {
                param.click((e.pageX - $(this).offset().left - param.left - param.unitSet * 10 * param.mult))
            }else{
                param.yClick((e.pageY - $(this).offset().top - param.top - param.unitSet * 10 * param.mult))
            }
        })
    }
    this.setValue=function(val){
        var nval=val?val:param.min;
        if(nval>param.max) nval=param.max;
        if(nval<param.min) nval=param.min;

        var nlval=nval-param.min;

        if(!param.vertical){
            $("#"+param.wrapperId+" .rulerScroller").css("left",param.left);
        }else{
            $("#"+param.wrapperId+" .rulerScroller").css("top",param.top);
        }
         if(param.callback)  param.callback(nval)
    };

    this.reDrawRuler=function(nParam){
        nParam.value=nParam.value?nParam.value:0;
        firstRand=false;
        if(nParam){
            $.extend(param,nParam)
        }

        fixedLen=param.minUnit.toString().split(".")[1]?param.minUnit.toString().split(".")[1].length:0;
        $("#"+param.wrapperId).html("");
        $("#"+param.wrapperId).unbind('touchstart');
        $("#"+param.wrapperId).unbind('touchend');
        $("#"+param.wrapperId).unbind('touchmove');
        this.initRuler();
    };

    this.initRuler();

}

/**
 * @fileoverview
 * - Using the 'QRCode for Javascript library'
 * - Fixed dataset of 'QRCode for Javascript library' for support full-spec.
 * - this library has no dependencies.
 * 
 * @author davidshimjs
 * @see <a href="http://www.d-project.com/" target="_blank">http://www.d-project.com/</a>
 * @see <a href="http://jeromeetienne.github.com/jquery-qrcode/" target="_blank">http://jeromeetienne.github.com/jquery-qrcode/</a>
 */
var QRCode;

(function () {
	//---------------------------------------------------------------------
	// QRCode for JavaScript
	//
	// Copyright (c) 2009 Kazuhiko Arase
	//
	// URL: http://www.d-project.com/
	//
	// Licensed under the MIT license:
	//   http://www.opensource.org/licenses/mit-license.php
	//
	// The word "QR Code" is registered trademark of 
	// DENSO WAVE INCORPORATED
	//   http://www.denso-wave.com/qrcode/faqpatent-e.html
	//
	//---------------------------------------------------------------------
	function QR8bitByte(data) {
		this.mode = QRMode.MODE_8BIT_BYTE;
		this.data = data;
		this.parsedData = [];

		// Added to support UTF-8 Characters
		for (var i = 0, l = this.data.length; i < l; i++) {
			var byteArray = [];
			var code = this.data.charCodeAt(i);

			if (code > 0x10000) {
				byteArray[0] = 0xF0 | ((code & 0x1C0000) >>> 18);
				byteArray[1] = 0x80 | ((code & 0x3F000) >>> 12);
				byteArray[2] = 0x80 | ((code & 0xFC0) >>> 6);
				byteArray[3] = 0x80 | (code & 0x3F);
			} else if (code > 0x800) {
				byteArray[0] = 0xE0 | ((code & 0xF000) >>> 12);
				byteArray[1] = 0x80 | ((code & 0xFC0) >>> 6);
				byteArray[2] = 0x80 | (code & 0x3F);
			} else if (code > 0x80) {
				byteArray[0] = 0xC0 | ((code & 0x7C0) >>> 6);
				byteArray[1] = 0x80 | (code & 0x3F);
			} else {
				byteArray[0] = code;
			}

			this.parsedData.push(byteArray);
		}

		this.parsedData = Array.prototype.concat.apply([], this.parsedData);

		if (this.parsedData.length != this.data.length) {
			this.parsedData.unshift(191);
			this.parsedData.unshift(187);
			this.parsedData.unshift(239);
		}
	}

	QR8bitByte.prototype = {
		getLength: function (buffer) {
			return this.parsedData.length;
		},
		write: function (buffer) {
			for (var i = 0, l = this.parsedData.length; i < l; i++) {
				buffer.put(this.parsedData[i], 8);
			}
		}
	};

	function QRCodeModel(typeNumber, errorCorrectLevel) {
		this.typeNumber = typeNumber;
		this.errorCorrectLevel = errorCorrectLevel;
		this.modules = null;
		this.moduleCount = 0;
		this.dataCache = null;
		this.dataList = [];
	}

	QRCodeModel.prototype={addData:function(data){var newData=new QR8bitByte(data);this.dataList.push(newData);this.dataCache=null;},isDark:function(row,col){if(row<0||this.moduleCount<=row||col<0||this.moduleCount<=col){throw new Error(row+","+col);}
	return this.modules[row][col];},getModuleCount:function(){return this.moduleCount;},make:function(){this.makeImpl(false,this.getBestMaskPattern());},makeImpl:function(test,maskPattern){this.moduleCount=this.typeNumber*4+17;this.modules=new Array(this.moduleCount);for(var row=0;row<this.moduleCount;row++){this.modules[row]=new Array(this.moduleCount);for(var col=0;col<this.moduleCount;col++){this.modules[row][col]=null;}}
	this.setupPositionProbePattern(0,0);this.setupPositionProbePattern(this.moduleCount-7,0);this.setupPositionProbePattern(0,this.moduleCount-7);this.setupPositionAdjustPattern();this.setupTimingPattern();this.setupTypeInfo(test,maskPattern);if(this.typeNumber>=7){this.setupTypeNumber(test);}
	if(this.dataCache==null){this.dataCache=QRCodeModel.createData(this.typeNumber,this.errorCorrectLevel,this.dataList);}
	this.mapData(this.dataCache,maskPattern);},setupPositionProbePattern:function(row,col){for(var r=-1;r<=7;r++){if(row+r<=-1||this.moduleCount<=row+r)continue;for(var c=-1;c<=7;c++){if(col+c<=-1||this.moduleCount<=col+c)continue;if((0<=r&&r<=6&&(c==0||c==6))||(0<=c&&c<=6&&(r==0||r==6))||(2<=r&&r<=4&&2<=c&&c<=4)){this.modules[row+r][col+c]=true;}else{this.modules[row+r][col+c]=false;}}}},getBestMaskPattern:function(){var minLostPoint=0;var pattern=0;for(var i=0;i<8;i++){this.makeImpl(true,i);var lostPoint=QRUtil.getLostPoint(this);if(i==0||minLostPoint>lostPoint){minLostPoint=lostPoint;pattern=i;}}
	return pattern;},createMovieClip:function(target_mc,instance_name,depth){var qr_mc=target_mc.createEmptyMovieClip(instance_name,depth);var cs=1;this.make();for(var row=0;row<this.modules.length;row++){var y=row*cs;for(var col=0;col<this.modules[row].length;col++){var x=col*cs;var dark=this.modules[row][col];if(dark){qr_mc.beginFill(0,100);qr_mc.moveTo(x,y);qr_mc.lineTo(x+cs,y);qr_mc.lineTo(x+cs,y+cs);qr_mc.lineTo(x,y+cs);qr_mc.endFill();}}}
	return qr_mc;},setupTimingPattern:function(){for(var r=8;r<this.moduleCount-8;r++){if(this.modules[r][6]!=null){continue;}
	this.modules[r][6]=(r%2==0);}
	for(var c=8;c<this.moduleCount-8;c++){if(this.modules[6][c]!=null){continue;}
	this.modules[6][c]=(c%2==0);}},setupPositionAdjustPattern:function(){var pos=QRUtil.getPatternPosition(this.typeNumber);for(var i=0;i<pos.length;i++){for(var j=0;j<pos.length;j++){var row=pos[i];var col=pos[j];if(this.modules[row][col]!=null){continue;}
	for(var r=-2;r<=2;r++){for(var c=-2;c<=2;c++){if(r==-2||r==2||c==-2||c==2||(r==0&&c==0)){this.modules[row+r][col+c]=true;}else{this.modules[row+r][col+c]=false;}}}}}},setupTypeNumber:function(test){var bits=QRUtil.getBCHTypeNumber(this.typeNumber);for(var i=0;i<18;i++){var mod=(!test&&((bits>>i)&1)==1);this.modules[Math.floor(i/3)][i%3+this.moduleCount-8-3]=mod;}
	for(var i=0;i<18;i++){var mod=(!test&&((bits>>i)&1)==1);this.modules[i%3+this.moduleCount-8-3][Math.floor(i/3)]=mod;}},setupTypeInfo:function(test,maskPattern){var data=(this.errorCorrectLevel<<3)|maskPattern;var bits=QRUtil.getBCHTypeInfo(data);for(var i=0;i<15;i++){var mod=(!test&&((bits>>i)&1)==1);if(i<6){this.modules[i][8]=mod;}else if(i<8){this.modules[i+1][8]=mod;}else{this.modules[this.moduleCount-15+i][8]=mod;}}
	for(var i=0;i<15;i++){var mod=(!test&&((bits>>i)&1)==1);if(i<8){this.modules[8][this.moduleCount-i-1]=mod;}else if(i<9){this.modules[8][15-i-1+1]=mod;}else{this.modules[8][15-i-1]=mod;}}
	this.modules[this.moduleCount-8][8]=(!test);},mapData:function(data,maskPattern){var inc=-1;var row=this.moduleCount-1;var bitIndex=7;var byteIndex=0;for(var col=this.moduleCount-1;col>0;col-=2){if(col==6)col--;while(true){for(var c=0;c<2;c++){if(this.modules[row][col-c]==null){var dark=false;if(byteIndex<data.length){dark=(((data[byteIndex]>>>bitIndex)&1)==1);}
	var mask=QRUtil.getMask(maskPattern,row,col-c);if(mask){dark=!dark;}
	this.modules[row][col-c]=dark;bitIndex--;if(bitIndex==-1){byteIndex++;bitIndex=7;}}}
	row+=inc;if(row<0||this.moduleCount<=row){row-=inc;inc=-inc;break;}}}}};QRCodeModel.PAD0=0xEC;QRCodeModel.PAD1=0x11;QRCodeModel.createData=function(typeNumber,errorCorrectLevel,dataList){var rsBlocks=QRRSBlock.getRSBlocks(typeNumber,errorCorrectLevel);var buffer=new QRBitBuffer();for(var i=0;i<dataList.length;i++){var data=dataList[i];buffer.put(data.mode,4);buffer.put(data.getLength(),QRUtil.getLengthInBits(data.mode,typeNumber));data.write(buffer);}
	var totalDataCount=0;for(var i=0;i<rsBlocks.length;i++){totalDataCount+=rsBlocks[i].dataCount;}
	if(buffer.getLengthInBits()>totalDataCount*8){throw new Error("code length overflow. ("
	+buffer.getLengthInBits()
	+">"
	+totalDataCount*8
	+")");}
	if(buffer.getLengthInBits()+4<=totalDataCount*8){buffer.put(0,4);}
	while(buffer.getLengthInBits()%8!=0){buffer.putBit(false);}
	while(true){if(buffer.getLengthInBits()>=totalDataCount*8){break;}
	buffer.put(QRCodeModel.PAD0,8);if(buffer.getLengthInBits()>=totalDataCount*8){break;}
	buffer.put(QRCodeModel.PAD1,8);}
	return QRCodeModel.createBytes(buffer,rsBlocks);};QRCodeModel.createBytes=function(buffer,rsBlocks){var offset=0;var maxDcCount=0;var maxEcCount=0;var dcdata=new Array(rsBlocks.length);var ecdata=new Array(rsBlocks.length);for(var r=0;r<rsBlocks.length;r++){var dcCount=rsBlocks[r].dataCount;var ecCount=rsBlocks[r].totalCount-dcCount;maxDcCount=Math.max(maxDcCount,dcCount);maxEcCount=Math.max(maxEcCount,ecCount);dcdata[r]=new Array(dcCount);for(var i=0;i<dcdata[r].length;i++){dcdata[r][i]=0xff&buffer.buffer[i+offset];}
	offset+=dcCount;var rsPoly=QRUtil.getErrorCorrectPolynomial(ecCount);var rawPoly=new QRPolynomial(dcdata[r],rsPoly.getLength()-1);var modPoly=rawPoly.mod(rsPoly);ecdata[r]=new Array(rsPoly.getLength()-1);for(var i=0;i<ecdata[r].length;i++){var modIndex=i+modPoly.getLength()-ecdata[r].length;ecdata[r][i]=(modIndex>=0)?modPoly.get(modIndex):0;}}
	var totalCodeCount=0;for(var i=0;i<rsBlocks.length;i++){totalCodeCount+=rsBlocks[i].totalCount;}
	var data=new Array(totalCodeCount);var index=0;for(var i=0;i<maxDcCount;i++){for(var r=0;r<rsBlocks.length;r++){if(i<dcdata[r].length){data[index++]=dcdata[r][i];}}}
	for(var i=0;i<maxEcCount;i++){for(var r=0;r<rsBlocks.length;r++){if(i<ecdata[r].length){data[index++]=ecdata[r][i];}}}
	return data;};var QRMode={MODE_NUMBER:1<<0,MODE_ALPHA_NUM:1<<1,MODE_8BIT_BYTE:1<<2,MODE_KANJI:1<<3};var QRErrorCorrectLevel={L:1,M:0,Q:3,H:2};var QRMaskPattern={PATTERN000:0,PATTERN001:1,PATTERN010:2,PATTERN011:3,PATTERN100:4,PATTERN101:5,PATTERN110:6,PATTERN111:7};var QRUtil={PATTERN_POSITION_TABLE:[[],[6,18],[6,22],[6,26],[6,30],[6,34],[6,22,38],[6,24,42],[6,26,46],[6,28,50],[6,30,54],[6,32,58],[6,34,62],[6,26,46,66],[6,26,48,70],[6,26,50,74],[6,30,54,78],[6,30,56,82],[6,30,58,86],[6,34,62,90],[6,28,50,72,94],[6,26,50,74,98],[6,30,54,78,102],[6,28,54,80,106],[6,32,58,84,110],[6,30,58,86,114],[6,34,62,90,118],[6,26,50,74,98,122],[6,30,54,78,102,126],[6,26,52,78,104,130],[6,30,56,82,108,134],[6,34,60,86,112,138],[6,30,58,86,114,142],[6,34,62,90,118,146],[6,30,54,78,102,126,150],[6,24,50,76,102,128,154],[6,28,54,80,106,132,158],[6,32,58,84,110,136,162],[6,26,54,82,110,138,166],[6,30,58,86,114,142,170]],G15:(1<<10)|(1<<8)|(1<<5)|(1<<4)|(1<<2)|(1<<1)|(1<<0),G18:(1<<12)|(1<<11)|(1<<10)|(1<<9)|(1<<8)|(1<<5)|(1<<2)|(1<<0),G15_MASK:(1<<14)|(1<<12)|(1<<10)|(1<<4)|(1<<1),getBCHTypeInfo:function(data){var d=data<<10;while(QRUtil.getBCHDigit(d)-QRUtil.getBCHDigit(QRUtil.G15)>=0){d^=(QRUtil.G15<<(QRUtil.getBCHDigit(d)-QRUtil.getBCHDigit(QRUtil.G15)));}
	return((data<<10)|d)^QRUtil.G15_MASK;},getBCHTypeNumber:function(data){var d=data<<12;while(QRUtil.getBCHDigit(d)-QRUtil.getBCHDigit(QRUtil.G18)>=0){d^=(QRUtil.G18<<(QRUtil.getBCHDigit(d)-QRUtil.getBCHDigit(QRUtil.G18)));}
	return(data<<12)|d;},getBCHDigit:function(data){var digit=0;while(data!=0){digit++;data>>>=1;}
	return digit;},getPatternPosition:function(typeNumber){return QRUtil.PATTERN_POSITION_TABLE[typeNumber-1];},getMask:function(maskPattern,i,j){switch(maskPattern){case QRMaskPattern.PATTERN000:return(i+j)%2==0;case QRMaskPattern.PATTERN001:return i%2==0;case QRMaskPattern.PATTERN010:return j%3==0;case QRMaskPattern.PATTERN011:return(i+j)%3==0;case QRMaskPattern.PATTERN100:return(Math.floor(i/2)+Math.floor(j/3))%2==0;case QRMaskPattern.PATTERN101:return(i*j)%2+(i*j)%3==0;case QRMaskPattern.PATTERN110:return((i*j)%2+(i*j)%3)%2==0;case QRMaskPattern.PATTERN111:return((i*j)%3+(i+j)%2)%2==0;default:throw new Error("bad maskPattern:"+maskPattern);}},getErrorCorrectPolynomial:function(errorCorrectLength){var a=new QRPolynomial([1],0);for(var i=0;i<errorCorrectLength;i++){a=a.multiply(new QRPolynomial([1,QRMath.gexp(i)],0));}
	return a;},getLengthInBits:function(mode,type){if(1<=type&&type<10){switch(mode){case QRMode.MODE_NUMBER:return 10;case QRMode.MODE_ALPHA_NUM:return 9;case QRMode.MODE_8BIT_BYTE:return 8;case QRMode.MODE_KANJI:return 8;default:throw new Error("mode:"+mode);}}else if(type<27){switch(mode){case QRMode.MODE_NUMBER:return 12;case QRMode.MODE_ALPHA_NUM:return 11;case QRMode.MODE_8BIT_BYTE:return 16;case QRMode.MODE_KANJI:return 10;default:throw new Error("mode:"+mode);}}else if(type<41){switch(mode){case QRMode.MODE_NUMBER:return 14;case QRMode.MODE_ALPHA_NUM:return 13;case QRMode.MODE_8BIT_BYTE:return 16;case QRMode.MODE_KANJI:return 12;default:throw new Error("mode:"+mode);}}else{throw new Error("type:"+type);}},getLostPoint:function(qrCode){var moduleCount=qrCode.getModuleCount();var lostPoint=0;for(var row=0;row<moduleCount;row++){for(var col=0;col<moduleCount;col++){var sameCount=0;var dark=qrCode.isDark(row,col);for(var r=-1;r<=1;r++){if(row+r<0||moduleCount<=row+r){continue;}
	for(var c=-1;c<=1;c++){if(col+c<0||moduleCount<=col+c){continue;}
	if(r==0&&c==0){continue;}
	if(dark==qrCode.isDark(row+r,col+c)){sameCount++;}}}
	if(sameCount>5){lostPoint+=(3+sameCount-5);}}}
	for(var row=0;row<moduleCount-1;row++){for(var col=0;col<moduleCount-1;col++){var count=0;if(qrCode.isDark(row,col))count++;if(qrCode.isDark(row+1,col))count++;if(qrCode.isDark(row,col+1))count++;if(qrCode.isDark(row+1,col+1))count++;if(count==0||count==4){lostPoint+=3;}}}
	for(var row=0;row<moduleCount;row++){for(var col=0;col<moduleCount-6;col++){if(qrCode.isDark(row,col)&&!qrCode.isDark(row,col+1)&&qrCode.isDark(row,col+2)&&qrCode.isDark(row,col+3)&&qrCode.isDark(row,col+4)&&!qrCode.isDark(row,col+5)&&qrCode.isDark(row,col+6)){lostPoint+=40;}}}
	for(var col=0;col<moduleCount;col++){for(var row=0;row<moduleCount-6;row++){if(qrCode.isDark(row,col)&&!qrCode.isDark(row+1,col)&&qrCode.isDark(row+2,col)&&qrCode.isDark(row+3,col)&&qrCode.isDark(row+4,col)&&!qrCode.isDark(row+5,col)&&qrCode.isDark(row+6,col)){lostPoint+=40;}}}
	var darkCount=0;for(var col=0;col<moduleCount;col++){for(var row=0;row<moduleCount;row++){if(qrCode.isDark(row,col)){darkCount++;}}}
	var ratio=Math.abs(100*darkCount/moduleCount/moduleCount-50)/5;lostPoint+=ratio*10;return lostPoint;}};var QRMath={glog:function(n){if(n<1){throw new Error("glog("+n+")");}
	return QRMath.LOG_TABLE[n];},gexp:function(n){while(n<0){n+=255;}
	while(n>=256){n-=255;}
	return QRMath.EXP_TABLE[n];},EXP_TABLE:new Array(256),LOG_TABLE:new Array(256)};for(var i=0;i<8;i++){QRMath.EXP_TABLE[i]=1<<i;}
	for(var i=8;i<256;i++){QRMath.EXP_TABLE[i]=QRMath.EXP_TABLE[i-4]^QRMath.EXP_TABLE[i-5]^QRMath.EXP_TABLE[i-6]^QRMath.EXP_TABLE[i-8];}
	for(var i=0;i<255;i++){QRMath.LOG_TABLE[QRMath.EXP_TABLE[i]]=i;}
	function QRPolynomial(num,shift){if(num.length==undefined){throw new Error(num.length+"/"+shift);}
	var offset=0;while(offset<num.length&&num[offset]==0){offset++;}
	this.num=new Array(num.length-offset+shift);for(var i=0;i<num.length-offset;i++){this.num[i]=num[i+offset];}}
	QRPolynomial.prototype={get:function(index){return this.num[index];},getLength:function(){return this.num.length;},multiply:function(e){var num=new Array(this.getLength()+e.getLength()-1);for(var i=0;i<this.getLength();i++){for(var j=0;j<e.getLength();j++){num[i+j]^=QRMath.gexp(QRMath.glog(this.get(i))+QRMath.glog(e.get(j)));}}
	return new QRPolynomial(num,0);},mod:function(e){if(this.getLength()-e.getLength()<0){return this;}
	var ratio=QRMath.glog(this.get(0))-QRMath.glog(e.get(0));var num=new Array(this.getLength());for(var i=0;i<this.getLength();i++){num[i]=this.get(i);}
	for(var i=0;i<e.getLength();i++){num[i]^=QRMath.gexp(QRMath.glog(e.get(i))+ratio);}
	return new QRPolynomial(num,0).mod(e);}};function QRRSBlock(totalCount,dataCount){this.totalCount=totalCount;this.dataCount=dataCount;}
	QRRSBlock.RS_BLOCK_TABLE=[[1,26,19],[1,26,16],[1,26,13],[1,26,9],[1,44,34],[1,44,28],[1,44,22],[1,44,16],[1,70,55],[1,70,44],[2,35,17],[2,35,13],[1,100,80],[2,50,32],[2,50,24],[4,25,9],[1,134,108],[2,67,43],[2,33,15,2,34,16],[2,33,11,2,34,12],[2,86,68],[4,43,27],[4,43,19],[4,43,15],[2,98,78],[4,49,31],[2,32,14,4,33,15],[4,39,13,1,40,14],[2,121,97],[2,60,38,2,61,39],[4,40,18,2,41,19],[4,40,14,2,41,15],[2,146,116],[3,58,36,2,59,37],[4,36,16,4,37,17],[4,36,12,4,37,13],[2,86,68,2,87,69],[4,69,43,1,70,44],[6,43,19,2,44,20],[6,43,15,2,44,16],[4,101,81],[1,80,50,4,81,51],[4,50,22,4,51,23],[3,36,12,8,37,13],[2,116,92,2,117,93],[6,58,36,2,59,37],[4,46,20,6,47,21],[7,42,14,4,43,15],[4,133,107],[8,59,37,1,60,38],[8,44,20,4,45,21],[12,33,11,4,34,12],[3,145,115,1,146,116],[4,64,40,5,65,41],[11,36,16,5,37,17],[11,36,12,5,37,13],[5,109,87,1,110,88],[5,65,41,5,66,42],[5,54,24,7,55,25],[11,36,12],[5,122,98,1,123,99],[7,73,45,3,74,46],[15,43,19,2,44,20],[3,45,15,13,46,16],[1,135,107,5,136,108],[10,74,46,1,75,47],[1,50,22,15,51,23],[2,42,14,17,43,15],[5,150,120,1,151,121],[9,69,43,4,70,44],[17,50,22,1,51,23],[2,42,14,19,43,15],[3,141,113,4,142,114],[3,70,44,11,71,45],[17,47,21,4,48,22],[9,39,13,16,40,14],[3,135,107,5,136,108],[3,67,41,13,68,42],[15,54,24,5,55,25],[15,43,15,10,44,16],[4,144,116,4,145,117],[17,68,42],[17,50,22,6,51,23],[19,46,16,6,47,17],[2,139,111,7,140,112],[17,74,46],[7,54,24,16,55,25],[34,37,13],[4,151,121,5,152,122],[4,75,47,14,76,48],[11,54,24,14,55,25],[16,45,15,14,46,16],[6,147,117,4,148,118],[6,73,45,14,74,46],[11,54,24,16,55,25],[30,46,16,2,47,17],[8,132,106,4,133,107],[8,75,47,13,76,48],[7,54,24,22,55,25],[22,45,15,13,46,16],[10,142,114,2,143,115],[19,74,46,4,75,47],[28,50,22,6,51,23],[33,46,16,4,47,17],[8,152,122,4,153,123],[22,73,45,3,74,46],[8,53,23,26,54,24],[12,45,15,28,46,16],[3,147,117,10,148,118],[3,73,45,23,74,46],[4,54,24,31,55,25],[11,45,15,31,46,16],[7,146,116,7,147,117],[21,73,45,7,74,46],[1,53,23,37,54,24],[19,45,15,26,46,16],[5,145,115,10,146,116],[19,75,47,10,76,48],[15,54,24,25,55,25],[23,45,15,25,46,16],[13,145,115,3,146,116],[2,74,46,29,75,47],[42,54,24,1,55,25],[23,45,15,28,46,16],[17,145,115],[10,74,46,23,75,47],[10,54,24,35,55,25],[19,45,15,35,46,16],[17,145,115,1,146,116],[14,74,46,21,75,47],[29,54,24,19,55,25],[11,45,15,46,46,16],[13,145,115,6,146,116],[14,74,46,23,75,47],[44,54,24,7,55,25],[59,46,16,1,47,17],[12,151,121,7,152,122],[12,75,47,26,76,48],[39,54,24,14,55,25],[22,45,15,41,46,16],[6,151,121,14,152,122],[6,75,47,34,76,48],[46,54,24,10,55,25],[2,45,15,64,46,16],[17,152,122,4,153,123],[29,74,46,14,75,47],[49,54,24,10,55,25],[24,45,15,46,46,16],[4,152,122,18,153,123],[13,74,46,32,75,47],[48,54,24,14,55,25],[42,45,15,32,46,16],[20,147,117,4,148,118],[40,75,47,7,76,48],[43,54,24,22,55,25],[10,45,15,67,46,16],[19,148,118,6,149,119],[18,75,47,31,76,48],[34,54,24,34,55,25],[20,45,15,61,46,16]];QRRSBlock.getRSBlocks=function(typeNumber,errorCorrectLevel){var rsBlock=QRRSBlock.getRsBlockTable(typeNumber,errorCorrectLevel);if(rsBlock==undefined){throw new Error("bad rs block @ typeNumber:"+typeNumber+"/errorCorrectLevel:"+errorCorrectLevel);}
	var length=rsBlock.length/3;var list=[];for(var i=0;i<length;i++){var count=rsBlock[i*3+0];var totalCount=rsBlock[i*3+1];var dataCount=rsBlock[i*3+2];for(var j=0;j<count;j++){list.push(new QRRSBlock(totalCount,dataCount));}}
	return list;};QRRSBlock.getRsBlockTable=function(typeNumber,errorCorrectLevel){switch(errorCorrectLevel){case QRErrorCorrectLevel.L:return QRRSBlock.RS_BLOCK_TABLE[(typeNumber-1)*4+0];case QRErrorCorrectLevel.M:return QRRSBlock.RS_BLOCK_TABLE[(typeNumber-1)*4+1];case QRErrorCorrectLevel.Q:return QRRSBlock.RS_BLOCK_TABLE[(typeNumber-1)*4+2];case QRErrorCorrectLevel.H:return QRRSBlock.RS_BLOCK_TABLE[(typeNumber-1)*4+3];default:return undefined;}};function QRBitBuffer(){this.buffer=[];this.length=0;}
	QRBitBuffer.prototype={get:function(index){var bufIndex=Math.floor(index/8);return((this.buffer[bufIndex]>>>(7-index%8))&1)==1;},put:function(num,length){for(var i=0;i<length;i++){this.putBit(((num>>>(length-i-1))&1)==1);}},getLengthInBits:function(){return this.length;},putBit:function(bit){var bufIndex=Math.floor(this.length/8);if(this.buffer.length<=bufIndex){this.buffer.push(0);}
	if(bit){this.buffer[bufIndex]|=(0x80>>>(this.length%8));}
	this.length++;}};var QRCodeLimitLength=[[17,14,11,7],[32,26,20,14],[53,42,32,24],[78,62,46,34],[106,84,60,44],[134,106,74,58],[154,122,86,64],[192,152,108,84],[230,180,130,98],[271,213,151,119],[321,251,177,137],[367,287,203,155],[425,331,241,177],[458,362,258,194],[520,412,292,220],[586,450,322,250],[644,504,364,280],[718,560,394,310],[792,624,442,338],[858,666,482,382],[929,711,509,403],[1003,779,565,439],[1091,857,611,461],[1171,911,661,511],[1273,997,715,535],[1367,1059,751,593],[1465,1125,805,625],[1528,1190,868,658],[1628,1264,908,698],[1732,1370,982,742],[1840,1452,1030,790],[1952,1538,1112,842],[2068,1628,1168,898],[2188,1722,1228,958],[2303,1809,1283,983],[2431,1911,1351,1051],[2563,1989,1423,1093],[2699,2099,1499,1139],[2809,2213,1579,1219],[2953,2331,1663,1273]];
	
	function _isSupportCanvas() {
		return typeof CanvasRenderingContext2D != "undefined";
	}
	
	// android 2.x doesn't support Data-URI spec
	function _getAndroid() {
		var android = false;
		var sAgent = navigator.userAgent;
		
		if (/android/i.test(sAgent)) { // android
			android = true;
			var aMat = sAgent.toString().match(/android ([0-9]\.[0-9])/i);
			
			if (aMat && aMat[1]) {
				android = parseFloat(aMat[1]);
			}
		}
		
		return android;
	}
	
	var svgDrawer = (function() {

		var Drawing = function (el, htOption) {
			this._el = el;
			this._htOption = htOption;
		};

		Drawing.prototype.draw = function (oQRCode) {
			var _htOption = this._htOption;
			var _el = this._el;
			var nCount = oQRCode.getModuleCount();
			var nWidth = Math.floor(_htOption.width / nCount);
			var nHeight = Math.floor(_htOption.height / nCount);

			this.clear();

			function makeSVG(tag, attrs) {
				var el = document.createElementNS('http://www.w3.org/2000/svg', tag);
				for (var k in attrs)
					if (attrs.hasOwnProperty(k)) el.setAttribute(k, attrs[k]);
				return el;
			}

			var svg = makeSVG("svg" , {'viewBox': '0 0 ' + String(nCount) + " " + String(nCount), 'width': '100%', 'height': '100%', 'fill': _htOption.colorLight});
			svg.setAttributeNS("http://www.w3.org/2000/xmlns/", "xmlns:xlink", "http://www.w3.org/1999/xlink");
			_el.appendChild(svg);

			svg.appendChild(makeSVG("rect", {"fill": _htOption.colorLight, "width": "100%", "height": "100%"}));
			svg.appendChild(makeSVG("rect", {"fill": _htOption.colorDark, "width": "1", "height": "1", "id": "template"}));

			for (var row = 0; row < nCount; row++) {
				for (var col = 0; col < nCount; col++) {
					if (oQRCode.isDark(row, col)) {
						var child = makeSVG("use", {"x": String(col), "y": String(row)});
						child.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#template")
						svg.appendChild(child);
					}
				}
			}
		};
		Drawing.prototype.clear = function () {
			while (this._el.hasChildNodes())
				this._el.removeChild(this._el.lastChild);
		};
		return Drawing;
	})();

	var useSVG = document.documentElement.tagName.toLowerCase() === "svg";

	// Drawing in DOM by using Table tag
	var Drawing = useSVG ? svgDrawer : !_isSupportCanvas() ? (function () {
		var Drawing = function (el, htOption) {
			this._el = el;
			this._htOption = htOption;
		};
			
		/**
		 * Draw the QRCode
		 * 
		 * @param {QRCode} oQRCode
		 */
		Drawing.prototype.draw = function (oQRCode) {
            var _htOption = this._htOption;
            var _el = this._el;
			var nCount = oQRCode.getModuleCount();
			var nWidth = Math.floor(_htOption.width / nCount);
			var nHeight = Math.floor(_htOption.height / nCount);
			var aHTML = ['<table style="border:0;border-collapse:collapse;">'];
			
			for (var row = 0; row < nCount; row++) {
				aHTML.push('<tr>');
				
				for (var col = 0; col < nCount; col++) {
					aHTML.push('<td style="border:0;border-collapse:collapse;padding:0;margin:0;width:' + nWidth + 'px;height:' + nHeight + 'px;background-color:' + (oQRCode.isDark(row, col) ? _htOption.colorDark : _htOption.colorLight) + ';"></td>');
				}
				
				aHTML.push('</tr>');
			}
			
			aHTML.push('</table>');
			_el.innerHTML = aHTML.join('');
			
			// Fix the margin values as real size.
			var elTable = _el.childNodes[0];
			var nLeftMarginTable = (_htOption.width - elTable.offsetWidth) / 2;
			var nTopMarginTable = (_htOption.height - elTable.offsetHeight) / 2;
			
			if (nLeftMarginTable > 0 && nTopMarginTable > 0) {
				elTable.style.margin = nTopMarginTable + "px " + nLeftMarginTable + "px";	
			}
		};
		
		/**
		 * Clear the QRCode
		 */
		Drawing.prototype.clear = function () {
			this._el.innerHTML = '';
		};
		
		return Drawing;
	})() : (function () { // Drawing in Canvas
		function _onMakeImage() {
			this._elImage.src = this._elCanvas.toDataURL("image/png");
			this._elImage.style.display = "block";
			this._elCanvas.style.display = "none";			
		}
		
		// Android 2.1 bug workaround
		// http://code.google.com/p/android/issues/detail?id=5141
		if (this._android && this._android <= 2.1) {
	    	var factor = 1 / window.devicePixelRatio;
	        var drawImage = CanvasRenderingContext2D.prototype.drawImage; 
	    	CanvasRenderingContext2D.prototype.drawImage = function (image, sx, sy, sw, sh, dx, dy, dw, dh) {
	    		if (("nodeName" in image) && /img/i.test(image.nodeName)) {
		        	for (var i = arguments.length - 1; i >= 1; i--) {
		            	arguments[i] = arguments[i] * factor;
		        	}
	    		} else if (typeof dw == "undefined") {
	    			arguments[1] *= factor;
	    			arguments[2] *= factor;
	    			arguments[3] *= factor;
	    			arguments[4] *= factor;
	    		}
	    		
	        	drawImage.apply(this, arguments); 
	    	};
		}
		
		/**
		 * Check whether the user's browser supports Data URI or not
		 * 
		 * @private
		 * @param {Function} fSuccess Occurs if it supports Data URI
		 * @param {Function} fFail Occurs if it doesn't support Data URI
		 */
		function _safeSetDataURI(fSuccess, fFail) {
            var self = this;
            self._fFail = fFail;
            self._fSuccess = fSuccess;

            // Check it just once
            if (self._bSupportDataURI === null) {
                var el = document.createElement("img");
                var fOnError = function() {
                    self._bSupportDataURI = false;

                    if (self._fFail) {
                        self._fFail.call(self);
                    }
                };
                var fOnSuccess = function() {
                    self._bSupportDataURI = true;

                    if (self._fSuccess) {
                        self._fSuccess.call(self);
                    }
                };

                el.onabort = fOnError;
                el.onerror = fOnError;
                el.onload = fOnSuccess;
                el.src = "data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHElEQVQI12P4//8/w38GIAXDIBKE0DHxgljNBAAO9TXL0Y4OHwAAAABJRU5ErkJggg=="; // the Image contains 1px data.
                return;
            } else if (self._bSupportDataURI === true && self._fSuccess) {
                self._fSuccess.call(self);
            } else if (self._bSupportDataURI === false && self._fFail) {
                self._fFail.call(self);
            }
		};
		
		/**
		 * Drawing QRCode by using canvas
		 * 
		 * @constructor
		 * @param {HTMLElement} el
		 * @param {Object} htOption QRCode Options 
		 */
		var Drawing = function (el, htOption) {
    		this._bIsPainted = false;
    		this._android = _getAndroid();
		
			this._htOption = htOption;
			this._elCanvas = document.createElement("canvas");
			this._elCanvas.width = htOption.width;
			this._elCanvas.height = htOption.height;
			el.appendChild(this._elCanvas);
			this._el = el;
			this._oContext = this._elCanvas.getContext("2d");
			this._bIsPainted = false;
			this._elImage = document.createElement("img");
			this._elImage.alt = "Scan me!";
			this._elImage.style.display = "none";
			this._el.appendChild(this._elImage);
			this._bSupportDataURI = null;
		};
			
		/**
		 * Draw the QRCode
		 * 
		 * @param {QRCode} oQRCode 
		 */
		Drawing.prototype.draw = function (oQRCode) {
            var _elImage = this._elImage;
            var _oContext = this._oContext;
            var _htOption = this._htOption;
            
			var nCount = oQRCode.getModuleCount();
			var nWidth = _htOption.width / nCount;
			var nHeight = _htOption.height / nCount;
			var nRoundedWidth = Math.round(nWidth);
			var nRoundedHeight = Math.round(nHeight);

			_elImage.style.display = "none";
			this.clear();
			
			for (var row = 0; row < nCount; row++) {
				for (var col = 0; col < nCount; col++) {
					var bIsDark = oQRCode.isDark(row, col);
					var nLeft = col * nWidth;
					var nTop = row * nHeight;
					_oContext.strokeStyle = bIsDark ? _htOption.colorDark : _htOption.colorLight;
					_oContext.lineWidth = 1;
					_oContext.fillStyle = bIsDark ? _htOption.colorDark : _htOption.colorLight;					
					_oContext.fillRect(nLeft, nTop, nWidth, nHeight);
					
					// 안티 앨리어싱 방지 처리
					_oContext.strokeRect(
						Math.floor(nLeft) + 0.5,
						Math.floor(nTop) + 0.5,
						nRoundedWidth,
						nRoundedHeight
					);
					
					_oContext.strokeRect(
						Math.ceil(nLeft) - 0.5,
						Math.ceil(nTop) - 0.5,
						nRoundedWidth,
						nRoundedHeight
					);
				}
			}
			
			this._bIsPainted = true;
		};
			
		/**
		 * Make the image from Canvas if the browser supports Data URI.
		 */
		Drawing.prototype.makeImage = function () {
			if (this._bIsPainted) {
				_safeSetDataURI.call(this, _onMakeImage);
			}
		};
			
		/**
		 * Return whether the QRCode is painted or not
		 * 
		 * @return {Boolean}
		 */
		Drawing.prototype.isPainted = function () {
			return this._bIsPainted;
		};
		
		/**
		 * Clear the QRCode
		 */
		Drawing.prototype.clear = function () {
			this._oContext.clearRect(0, 0, this._elCanvas.width, this._elCanvas.height);
			this._bIsPainted = false;
		};
		
		/**
		 * @private
		 * @param {Number} nNumber
		 */
		Drawing.prototype.round = function (nNumber) {
			if (!nNumber) {
				return nNumber;
			}
			
			return Math.floor(nNumber * 1000) / 1000;
		};
		
		return Drawing;
	})();
	
	/**
	 * Get the type by string length
	 * 
	 * @private
	 * @param {String} sText
	 * @param {Number} nCorrectLevel
	 * @return {Number} type
	 */
	function _getTypeNumber(sText, nCorrectLevel) {			
		var nType = 1;
		var length = _getUTF8Length(sText);
		
		for (var i = 0, len = QRCodeLimitLength.length; i <= len; i++) {
			var nLimit = 0;
			
			switch (nCorrectLevel) {
				case QRErrorCorrectLevel.L :
					nLimit = QRCodeLimitLength[i][0];
					break;
				case QRErrorCorrectLevel.M :
					nLimit = QRCodeLimitLength[i][1];
					break;
				case QRErrorCorrectLevel.Q :
					nLimit = QRCodeLimitLength[i][2];
					break;
				case QRErrorCorrectLevel.H :
					nLimit = QRCodeLimitLength[i][3];
					break;
			}
			
			if (length <= nLimit) {
				break;
			} else {
				nType++;
			}
		}
		
		if (nType > QRCodeLimitLength.length) {
			throw new Error("Too long data");
		}
		
		return nType;
	}

	function _getUTF8Length(sText) {
		var replacedText = encodeURI(sText).toString().replace(/\%[0-9a-fA-F]{2}/g, 'a');
		return replacedText.length + (replacedText.length != sText ? 3 : 0);
	}
	
	/**
	 * @class QRCode
	 * @constructor
	 * @example 
	 * new QRCode(document.getElementById("test"), "http://jindo.dev.naver.com/collie");
	 *
	 * @example
	 * var oQRCode = new QRCode("test", {
	 *    text : "http://naver.com",
	 *    width : 128,
	 *    height : 128
	 * });
	 * 
	 * oQRCode.clear(); // Clear the QRCode.
	 * oQRCode.makeCode("http://map.naver.com"); // Re-create the QRCode.
	 *
	 * @param {HTMLElement|String} el target element or 'id' attribute of element.
	 * @param {Object|String} vOption
	 * @param {String} vOption.text QRCode link data
	 * @param {Number} [vOption.width=256]
	 * @param {Number} [vOption.height=256]
	 * @param {String} [vOption.colorDark="#000000"]
	 * @param {String} [vOption.colorLight="#ffffff"]
	 * @param {QRCode.CorrectLevel} [vOption.correctLevel=QRCode.CorrectLevel.H] [L|M|Q|H] 
	 */
	QRCode = function (el, vOption) {
		this._htOption = {
			width : 256, 
			height : 256,
			typeNumber : 4,
			colorDark : "#000000",
			colorLight : "#ffffff",
			correctLevel : QRErrorCorrectLevel.H
		};
		
		if (typeof vOption === 'string') {
			vOption	= {
				text : vOption
			};
		}
		
		// Overwrites options
		if (vOption) {
			for (var i in vOption) {
				this._htOption[i] = vOption[i];
			}
		}
		
		if (typeof el == "string") {
			el = document.getElementById(el);
		}

		if (this._htOption.useSVG) {
			Drawing = svgDrawer;
		}
		
		this._android = _getAndroid();
		this._el = el;
		this._oQRCode = null;
		this._oDrawing = new Drawing(this._el, this._htOption);
		
		if (this._htOption.text) {
			this.makeCode(this._htOption.text);	
		}
	};
	
	/**
	 * Make the QRCode
	 * 
	 * @param {String} sText link data
	 */
	QRCode.prototype.makeCode = function (sText) {
		this._oQRCode = new QRCodeModel(_getTypeNumber(sText, this._htOption.correctLevel), this._htOption.correctLevel);
		this._oQRCode.addData(sText);
		this._oQRCode.make();
		this._el.title = sText;
		this._oDrawing.draw(this._oQRCode);			
		this.makeImage();
	};
	
	/**
	 * Make the Image from Canvas element
	 * - It occurs automatically
	 * - Android below 3 doesn't support Data-URI spec.
	 * 
	 * @private
	 */
	QRCode.prototype.makeImage = function () {
		if (typeof this._oDrawing.makeImage == "function" && (!this._android || this._android >= 3)) {
			this._oDrawing.makeImage();
		}
	};
	
	/**
	 * Clear the QRCode
	 */
	QRCode.prototype.clear = function () {
		this._oDrawing.clear();
	};
	
	/**
	 * @name QRCode.CorrectLevel
	 */
	QRCode.CorrectLevel = QRErrorCorrectLevel;
})();

(function () {
    'use strict';

    angular
        .module('editorApp')
        .factory('QiniuToken', QiniuToken);

    QiniuToken.$inject = ['Qinius', '$q', 'UidService', '$rootScope'];

    /**
     * 七牛上传 token 公共管理服务：
     * 全局缓存 token，按 action+params 分 key，
     * 到期前自动刷新，订阅者（subscribe）在刷新后自动拿到新 token。
     * 使用原生 setTimeout（token 不做模板绑定，无需 digest，与原各处循环行为一致）。
     */
    function QiniuToken(Qinius, $q, UidService, $rootScope) {
        // key -> { token, expireAt, timerId, inFlight, action, params, subscribers: [] }
        var records = {};

        var MIN_WAIT_MS = 1000;          // expireAt 异常时的下限，避免热循环
        var DEFAULT_TTL_MS = 3600000;    // expireAt 缺失时兜底 1 小时
        var FETCH_ERROR_RETRY_MS = 30000;// 后端获取失败时 30s 后重试，保持单例存活

        var service = {
            subscribe: subscribe,
            get: get,
            getPromise: getPromise,
            getSync: getSync,
            refresh: refresh,
            uploadThumbnail: uploadThumbnail
        };

        return service;

        // ---------------- 公共 API ----------------

        /**
         * fn(token字符串) 在缓存新鲜时立即回调（同步），否则等获取完成后回调；
         * 之后每次自动刷新都会再次回调。返回取消订阅函数。
         */
        function subscribe(action, params, fn) {
            var key = makeKey(action, params);
            var rec = ensureRecord(key);
            rec.subscribers.push(fn);
            if (isFresh(rec)) {
                notify(fn, rec.token);
            } else {
                ensureFetch(action, params, key, rec);
            }
            ensureTimer(key, rec);
            return function unsubscribe() {
                var idx = rec.subscribers.indexOf(fn);
                if (idx !== -1) {
                    rec.subscribers.splice(idx, 1);
                }
                // 没有订阅者时暂停定时器，缓存保留供 get()/getSync() 使用
                if (rec.subscribers.length === 0 && !rec.inFlight) {
                    clearTimeout(rec.timerId);
                    rec.timerId = null;
                }
            };
        }

        /**
         * 一次性获取：fn(token字符串)，缓存新鲜时同步回调，否则获取完成后回调。不保留订阅。
         */
        function get(action, params, fn) {
            var key = makeKey(action, params);
            var rec = ensureRecord(key);
            if (isFresh(rec)) {
                notify(fn, rec.token);
                ensureTimer(key, rec);
                return;
            }
            ensureFetch(action, params, key, rec).then(function (token) {
                notify(fn, token);
            });
        }

        /**
         * 兼容原 $resource promise 用法：返回 { token, $promise }，
         * token 在 $promise resolve 前就填充好，
         * 可直接替换 vm.tokens = Qinius.get(...) + $q.all + vm.tokens.token。
         */
        function getPromise(action, params) {
            var key = makeKey(action, params);
            var rec = ensureRecord(key);
            var obj = { token: isFresh(rec) ? rec.token : null, $promise: null };
            if (isFresh(rec)) {
                obj.$promise = $q.when(rec.token);
                ensureTimer(key, rec);
            } else {
                obj.$promise = ensureFetch(action, params, key, rec).then(function (token) {
                    obj.token = token;
                    return token;
                });
            }
            return obj;
        }

        /**
         * 同步读取缓存 token（不发请求）；缓存不存在或已过期返回 undefined。
         */
        function getSync(action, params) {
            var rec = records[makeKey(action, params)];
            return (rec && isFresh(rec)) ? rec.token : undefined;
        }

        /**
         * 强制重新获取（绕过缓存），成功后通知订阅者并回调 fn(token字符串)。
         */
        function refresh(action, params, fn) {
            var key = makeKey(action, params);
            var rec = ensureRecord(key);
            if (rec.inFlight) {
                rec.inFlight.then(function (token) {
                    notify(fn, token);
                });
                return;
            }
            clearTimeout(rec.timerId);
            rec.timerId = null;
            ensureFetch(action, params, key, rec, true).then(function (token) {
                notify(fn, token);
            });
        }

        /**
         * 上传缩略图到七牛（key '3dThumbnail-' + UidService.get()）。
         * input 可为 canvas 或 dataURL 字符串；token 失效(401/"expired token")时
         * 自动 refresh 对应 action 的 token 并重试一次；
         * errorback 仅在非 token 错误或重试仍失败时触发。
         */
        function uploadThumbnail(input, callback, errorback, action, params) {
            var url = typeof input === 'string' ? input : input.toDataURL("image/png");
            doUploadThumbnail(dataURLtoBlob(url), '3dThumbnail-' + UidService.get(), callback, errorback, action || 'get', params || {}, false);
        }

        function doUploadThumbnail(blob, key, callback, errorback, action, params, isRetry) {
            var formData = new FormData();
            formData.append('file', blob);
            formData.append('key', key);
            formData.append('token', getSync(action, params) || '');
            $.ajax({
                cache: true,
                type: "POST",
                url: 'https://upload.qiniup.com/',
                data: formData,
                async: false,
                contentType: false,
                processData: false,
                success: function (data) {
                    if (callback) { callback(data); }
                    safeApply();
                },
                error: function (request) {
                    if (!isRetry && request) {
                        refresh(action, params, function () {
                            doUploadThumbnail(blob, key, callback, errorback, action, params, true);
                        });
                    } else {
                        if (errorback) { errorback(request); }
                        safeApply();
                    }
                }
            });
        }

        function safeApply() {
            // 首次尝试运行在 html2canvas 回调（无 digest）→ 触发 apply；
            // 重试路径运行在 $resource 回调（digest 进行中）→ 守卫跳过，避免 $digest already in progress
            if (!$rootScope.$$phase) {
                $rootScope.$apply();
            }
        }

        // ---------------- 内部实现 ----------------

        function makeKey(action, params) {
            return action + '|' + JSON.stringify(params || {});
        }

        function ensureRecord(key) {
            if (!records[key]) {
                records[key] = { token: null, expireAt: 0, timerId: null, inFlight: null, action: null, params: null, subscribers: [] };
            }
            return records[key];
        }

        function isFresh(rec) {
            return !!rec.token && rec.expireAt > new Date().getTime();
        }

        function ensureFetch(action, params, key, rec, force) {
            if (!force && (rec.inFlight || isFresh(rec))) {
                return rec.inFlight || $q.when(rec.token);
            }
            rec.action = action;
            rec.params = params;
            var promise = $q(function (resolve, reject) {
                var ok = function (msg) {
                    if (rec.inFlight !== promise) {
                        return;
                    }
                    rec.token = msg.token;
                    rec.expireAt = msg.expireAt || (new Date().getTime() + DEFAULT_TTL_MS);
                    rec.inFlight = null;
                    ensureTimer(key, rec);
                    rec.subscribers.forEach(function (fn) {
                        notify(fn, rec.token);
                    });
                    resolve(rec.token);
                };
                var fail = function () {
                    if (rec.inFlight !== promise) {
                        return;
                    }
                    rec.inFlight = null;
                    ensureTimer(key, rec, FETCH_ERROR_RETRY_MS);
                    reject();
                };
                Qinius[action](params || {}, ok, fail);
            });
            rec.inFlight = promise;
            return promise;
        }

        function notify(fn, token) {
            if (typeof fn === 'function') {
                fn(token);
            }
        }

        function ensureTimer(key, rec, delay) {
            clearTimeout(rec.timerId);
            rec.timerId = null;
            if (delay) {
                rec.timerId = setTimeout(function () {
                    rec.timerId = null;
                    ensureFetch(rec.action, rec.params, key, rec);
                }, delay);
            } else if (rec.subscribers.length > 0 && rec.expireAt) {
                var wait = Math.max(MIN_WAIT_MS, rec.expireAt - new Date().getTime());
                rec.timerId = setTimeout(function () {
                    rec.timerId = null;
                    ensureFetch(rec.action, rec.params, key, rec);
                }, wait);
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('editorApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('editorApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

/*
 *
 * https://github.com/fatlinesofcode/ngDraggable
 */
angular.module("ngDraggable", [])
    .service('ngDraggable', [function() {


        var scope = this;
        scope.inputEvent = function(event) {
            if (angular.isDefined(event.touches)) {
                return event.touches[0];
            }
            //Checking both is not redundent. If only check if touches isDefined, angularjs isDefnied will return error and stop the remaining scripty if event.originalEvent is not defined.
            else if (angular.isDefined(event.originalEvent) && angular.isDefined(event.originalEvent.touches)) {
                return event.originalEvent.touches[0];
            }
            return event;
        };

        scope.touchTimeout = 100;

    }])
    .directive('ngDrag', ['$rootScope', '$parse', '$document', '$window', 'ngDraggable', function ($rootScope, $parse, $document, $window, ngDraggable) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                scope.value = attrs.ngDrag;
                var offset,_centerAnchor=false,_mx,_my,_tx,_ty,_mrx,_mry;
                var _hasTouch = ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch;
                var _pressEvents = 'touchstart mousedown';
                var _moveEvents = 'touchmove mousemove';
                var _releaseEvents = 'touchend mouseup';
                var _dragHandle;

                // to identify the element in order to prevent getting superflous events when a single element has both drag and drop directives on it.
                var _myid = scope.$id;
                var _data = null;

                var _dragOffset = null;

                var _dragEnabled = false;

                var _pressTimer = null;

                var onDragStartCallback = $parse(attrs.ngDragStart) || null;
                var onDragStopCallback = $parse(attrs.ngDragStop) || null;
                var onDragSuccessCallback = $parse(attrs.ngDragSuccess) || null;
                var allowTransform = angular.isDefined(attrs.allowTransform) ? scope.$eval(attrs.allowTransform) : true;

                var getDragData = $parse(attrs.ngDragData);

                // deregistration function for mouse move events in $rootScope triggered by jqLite trigger handler
                var _deregisterRootMoveListener = angular.noop;

                var initialize = function () {
                    element.attr('draggable', 'false'); // prevent native drag
                    // check to see if drag handle(s) was specified
                    // if querySelectorAll is available, we use this instead of find
                    // as JQLite find is limited to tagnames
                    if (element[0].querySelectorAll) {
                        var dragHandles = angular.element(element[0].querySelectorAll('[ng-drag-handle]'));
                    } else {
                        var dragHandles = element.find('[ng-drag-handle]');
                    }
                    if (dragHandles.length) {
                        _dragHandle = dragHandles;
                    }
                    toggleListeners(true);
                };

                var toggleListeners = function (enable) {
                    if (!enable)return;
                    // add listeners.

                    scope.$on('$destroy', onDestroy);
                    scope.$watch(attrs.ngDrag, onEnableChange);
                    scope.$watch(attrs.ngCenterAnchor, onCenterAnchor);
                    // wire up touch events
                    if (_dragHandle) {
                        // handle(s) specified, use those to initiate drag
                        _dragHandle.on(_pressEvents, onpress);
                    } else {
                        // no handle(s) specified, use the element as the handle
                        element.on(_pressEvents, onpress);
                    }
                    // if(! _hasTouch && element[0].nodeName.toLowerCase() == "img"){
                    if( element[0].nodeName.toLowerCase() == "img"){
                        element.on('mousedown', function(){ return false;}); // prevent native drag for images
                    }
                };
                var onDestroy = function (enable) {
                    toggleListeners(false);
                };
                var onEnableChange = function (newVal, oldVal) {
                    _dragEnabled = (newVal);
                };
                var onCenterAnchor = function (newVal, oldVal) {
                    if(angular.isDefined(newVal))
                        _centerAnchor = (newVal || 'true');
                };

                var isClickableElement = function (evt) {
                    return (
                        angular.isDefined(angular.element(evt.target).attr("ng-cancel-drag"))
                    );
                };
                /*
                 * When the element is clicked start the drag behaviour
                 * On touch devices as a small delay so as not to prevent native window scrolling
                 */
                var onpress = function(evt) {
                    // console.log("110"+" onpress: "+Math.random()+" "+ evt.type);
                    if(! _dragEnabled)return;

                    if (isClickableElement(evt)) {
                        return;
                    }

                    if (evt.type == "mousedown" && evt.button != 0) {
                        // Do not start dragging on right-click
                        return;
                    }

                    var useTouch = evt.type === 'touchstart' ? true : false;


                    if(useTouch){
                        cancelPress();
                        _pressTimer = setTimeout(function(){
                            cancelPress();
                            onlongpress(evt);
                        },ngDraggable.touchTimeout);
                        $document.on(_moveEvents, cancelPress);
                        $document.on(_releaseEvents, cancelPress);
                    }else{
                        onlongpress(evt);
                    }

                };

                var cancelPress = function() {
                    clearTimeout(_pressTimer);
                    $document.off(_moveEvents, cancelPress);
                    $document.off(_releaseEvents, cancelPress);
                };

                var onlongpress = function(evt) {
                    if(! _dragEnabled)return;
                    evt.preventDefault();

                    offset = element[0].getBoundingClientRect();
                    if(allowTransform)
                        _dragOffset = offset;
                    else{
                        _dragOffset = {left:document.body.scrollLeft, top:document.body.scrollTop};
                    }


                    element.centerX = element[0].offsetWidth / 2;
                    element.centerY = element[0].offsetHeight / 2;

                    _mx = ngDraggable.inputEvent(evt).pageX;//ngDraggable.getEventProp(evt, 'pageX');
                    _my = ngDraggable.inputEvent(evt).pageY;//ngDraggable.getEventProp(evt, 'pageY');
                    _mrx = _mx - offset.left;
                    _mry = _my - offset.top;
                    if (_centerAnchor) {
                        _tx = _mx - element.centerX - $window.pageXOffset;
                        _ty = _my - element.centerY - $window.pageYOffset;
                    } else {
                        _tx = _mx - _mrx - $window.pageXOffset;
                        _ty = _my - _mry - $window.pageYOffset;
                    }

                    $document.on(_moveEvents, onmove);
                    $document.on(_releaseEvents, onrelease);
                    // This event is used to receive manually triggered mouse move events
                    // jqLite unfortunately only supports triggerHandler(...)
                    // See http://api.jquery.com/triggerHandler/
                    // _deregisterRootMoveListener = $rootScope.$on('draggable:_triggerHandlerMove', onmove);
                    _deregisterRootMoveListener = $rootScope.$on('draggable:_triggerHandlerMove', function(event, origEvent) {
                        onmove(origEvent);
                    });
                };

                var onmove = function (evt) {
                    if (!_dragEnabled)return;
                    evt.preventDefault();

                    if (!element.hasClass('dragging')) {
                        _data = getDragData(scope);
                        element.addClass('dragging');
                        $rootScope.$broadcast('draggable:start', {x:_mx, y:_my, tx:_tx, ty:_ty, event:evt, element:element, data:_data});

                        if (onDragStartCallback ){
                            scope.$apply(function () {
                                onDragStartCallback(scope, {$data: _data, $event: evt});
                            });
                        }
                    }

                    _mx = ngDraggable.inputEvent(evt).pageX;//ngDraggable.getEventProp(evt, 'pageX');
                    _my = ngDraggable.inputEvent(evt).pageY;//ngDraggable.getEventProp(evt, 'pageY');

                    if (_centerAnchor) {
                        _tx = _mx - element.centerX - _dragOffset.left;
                        _ty = _my - element.centerY - _dragOffset.top;
                    } else {
                        _tx = _mx - _mrx - _dragOffset.left;
                        _ty = _my - _mry - _dragOffset.top;
                    }

                    moveElement(_tx, _ty);

                    $rootScope.$broadcast('draggable:move', { x: _mx, y: _my, tx: _tx, ty: _ty, event: evt, element: element, data: _data, uid: _myid, dragOffset: _dragOffset });
                };

                var onrelease = function(evt) {
                    if (!_dragEnabled)
                        return;
                    evt.preventDefault();
                    $rootScope.$broadcast('draggable:end', {x:_mx, y:_my, tx:_tx, ty:_ty, event:evt, element:element, data:_data, callback:onDragComplete, uid: _myid});
                    element.removeClass('dragging');
                    element.parent().find('.drag-enter').removeClass('drag-enter');
                    reset();
                    $document.off(_moveEvents, onmove);
                    $document.off(_releaseEvents, onrelease);

                    if (onDragStopCallback ){
                        scope.$apply(function () {
                            onDragStopCallback(scope, {$data: _data, $event: evt});
                        });
                    }

                    _deregisterRootMoveListener();
                };

                var onDragComplete = function(evt) {


                    if (!onDragSuccessCallback )return;

                    scope.$apply(function () {
                        onDragSuccessCallback(scope, {$data: _data, $event: evt});
                    });
                };

                var reset = function() {
                    if(allowTransform)
                        element.css({transform:'', 'z-index':'', '-webkit-transform':'', '-ms-transform':''});
                    else
                        element.css({'position':'',top:'',left:''});
                };

                var moveElement = function (x, y) {
                    if(allowTransform) {
                        element.css({
                            transform: 'matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, ' + x + ', ' + y + ', 0, 1)',
                            'z-index': 99999,
                            '-webkit-transform': 'matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, ' + x + ', ' + y + ', 0, 1)',
                            '-ms-transform': 'matrix(1, 0, 0, 1, ' + x + ', ' + y + ')'
                        });
                    }else{
                        element.css({'left':x+'px','top':y+'px', 'position':'fixed'});
                    }
                };
                initialize();
            }
        };
    }])

    .directive('ngDrop', ['$parse', '$timeout', '$window', '$document', 'ngDraggable', function ($parse, $timeout, $window, $document, ngDraggable) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                scope.value = attrs.ngDrop;
                scope.isTouching = false;

                var _lastDropTouch=null;

                var _myid = scope.$id;

                var _dropEnabled=false;

                var onDropCallback = $parse(attrs.ngDropSuccess);// || function(){};

                var onDragStartCallback = $parse(attrs.ngDragStart);
                var onDragStopCallback = $parse(attrs.ngDragStop);
                var onDragMoveCallback = $parse(attrs.ngDragMove);

                var initialize = function () {
                    toggleListeners(true);
                };

                var toggleListeners = function (enable) {
                    // remove listeners

                    if (!enable)return;
                    // add listeners.
                    scope.$watch(attrs.ngDrop, onEnableChange);
                    scope.$on('$destroy', onDestroy);
                    scope.$on('draggable:start', onDragStart);
                    scope.$on('draggable:move', onDragMove);
                    scope.$on('draggable:end', onDragEnd);
                };

                var onDestroy = function (enable) {
                    toggleListeners(false);
                };
                var onEnableChange = function (newVal, oldVal) {
                    _dropEnabled=newVal;
                };
                var onDragStart = function(evt, obj) {
                    if(! _dropEnabled)return;
                    isTouching(obj.x,obj.y,obj.element);

                    if (attrs.ngDragStart) {
                        $timeout(function(){
                            onDragStartCallback(scope, {$data: obj.data, $event: obj});
                        });
                    }
                };
                var onDragMove = function(evt, obj) {
                    if(! _dropEnabled)return;
                    isTouching(obj.x,obj.y,obj.element);

                    if (attrs.ngDragMove) {
                        $timeout(function(){
                            onDragMoveCallback(scope, {$data: obj.data, $event: obj});
                        });
                    }
                };

                var onDragEnd = function (evt, obj) {

                    // don't listen to drop events if this is the element being dragged
                    // only update the styles and return
                    if (!_dropEnabled || _myid === obj.uid) {
                        updateDragStyles(false, obj.element);
                        return;
                    }
                    if (isTouching(obj.x, obj.y, obj.element)) {
                        // call the ngDraggable ngDragSuccess element callback
                        if(obj.callback){
                            obj.callback(obj);
                        }

                        if (attrs.ngDropSuccess) {
                            $timeout(function(){
                                onDropCallback(scope, {$data: obj.data, $event: obj, $target: scope.$eval(scope.value)});
                            });
                        }
                    }

                    if (attrs.ngDragStop) {
                        $timeout(function(){
                            onDragStopCallback(scope, {$data: obj.data, $event: obj});
                        });
                    }

                    updateDragStyles(false, obj.element);
                };

                var isTouching = function(mouseX, mouseY, dragElement) {
                    var touching= hitTest(mouseX, mouseY);
                    scope.isTouching = touching;
                    if(touching){
                        _lastDropTouch = element;
                    }
                    updateDragStyles(touching, dragElement);
                    return touching;
                };

                var updateDragStyles = function(touching, dragElement) {
                    if(touching){
                        element.addClass('drag-enter');
                        dragElement.addClass('drag-over');
                    }else if(_lastDropTouch == element){
                        _lastDropTouch=null;
                        element.removeClass('drag-enter');
                        dragElement.removeClass('drag-over');
                    }
                };

                var hitTest = function(x, y) {
                    var bounds = element[0].getBoundingClientRect();// ngDraggable.getPrivOffset(element);
                    x -= $document[0].body.scrollLeft + $document[0].documentElement.scrollLeft;
                    y -= $document[0].body.scrollTop + $document[0].documentElement.scrollTop;
                    return  x >= bounds.left
                        && x <= bounds.right
                        && y <= bounds.bottom
                        && y >= bounds.top;
                };

                initialize();
            }
        };
    }])
    .directive('ngDragClone', ['$parse', '$timeout', 'ngDraggable', function ($parse, $timeout, ngDraggable) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var img, _allowClone=true;
                var _dragOffset = null;
                scope.clonedData = {};
                var initialize = function () {

                    img = element.find('img');
                    element.attr('draggable', 'false');
                    img.attr('draggable', 'false');
                    reset();
                    toggleListeners(true);
                };


                var toggleListeners = function (enable) {
                    // remove listeners

                    if (!enable)return;
                    // add listeners.
                    scope.$on('draggable:start', onDragStart);
                    scope.$on('draggable:move', onDragMove);
                    scope.$on('draggable:end', onDragEnd);
                    preventContextMenu();

                };
                var preventContextMenu = function() {
                    //  element.off('mousedown touchstart touchmove touchend touchcancel', absorbEvent_);
                    img.off('mousedown touchstart touchmove touchend touchcancel', absorbEvent_);
                    //  element.on('mousedown touchstart touchmove touchend touchcancel', absorbEvent_);
                    img.on('mousedown touchstart touchmove touchend touchcancel', absorbEvent_);
                };
                var onDragStart = function(evt, obj, elm) {
                    _allowClone=true;
                    if(angular.isDefined(obj.data.allowClone)){
                        _allowClone=obj.data.allowClone;
                    }
                    if(_allowClone) {
                        scope.$apply(function () {
                            scope.clonedData = obj.data;
                        });
                        element.css('width', obj.element[0].offsetWidth);
                        element.css('height', obj.element[0].offsetHeight);

                        moveElement(obj.tx, obj.ty);
                    }

                };
                var onDragMove = function(evt, obj) {
                    if(_allowClone) {

                        _tx = obj.tx + obj.dragOffset.left;
                        _ty = obj.ty + obj.dragOffset.top;

                        moveElement(_tx, _ty);
                    }
                };
                var onDragEnd = function(evt, obj) {
                    //moveElement(obj.tx,obj.ty);
                    if(_allowClone) {
                        reset();
                    }
                };

                var reset = function() {
                    element.css({left:0,top:0, position:'fixed', 'z-index':-1, visibility:'hidden'});
                };
                var moveElement = function(x,y) {
                    element.css({
                        transform: 'matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, '+x+', '+y+', 0, 1)', 'z-index': 99999, 'visibility': 'visible',
                        '-webkit-transform': 'matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, '+x+', '+y+', 0, 1)',
                        '-ms-transform': 'matrix(1, 0, 0, 1, '+x+', '+y+')'
                        //,margin: '0'  don't monkey with the margin,
                    });
                };

                var absorbEvent_ = function (event) {
                    var e = event;//.originalEvent;
                    e.preventDefault && e.preventDefault();
                    e.stopPropagation && e.stopPropagation();
                    e.cancelBubble = true;
                    e.returnValue = false;
                    return false;
                };

                initialize();
            }
        };
    }])
    .directive('ngPreventDrag', ['$parse', '$timeout', function ($parse, $timeout) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var initialize = function () {

                    element.attr('draggable', 'false');
                    toggleListeners(true);
                };


                var toggleListeners = function (enable) {
                    // remove listeners

                    if (!enable)return;
                    // add listeners.
                    element.on('mousedown touchstart touchmove touchend touchcancel', absorbEvent_);
                };


                var absorbEvent_ = function (event) {
                    var e = event.originalEvent;
                    e.preventDefault && e.preventDefault();
                    e.stopPropagation && e.stopPropagation();
                    e.cancelBubble = true;
                    e.returnValue = false;
                    return false;
                };

                initialize();
            }
        };
    }])
    .directive('ngCancelDrag', [function () {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                element.find('*').attr('ng-cancel-drag', 'ng-cancel-drag');
            }
        };
    }])
    .directive('ngDragScroll', ['$window', '$interval', '$timeout', '$document', '$rootScope', function($window, $interval, $timeout, $document, $rootScope) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var intervalPromise = null;
                var lastMouseEvent = null;

                var config = {
                    verticalScroll: attrs.verticalScroll || true,
                    horizontalScroll: attrs.horizontalScroll || true,
                    activationDistance: attrs.activationDistance || 75,
                    scrollDistance: attrs.scrollDistance || 15
                };


                var reqAnimFrame = (function() {
                    return window.requestAnimationFrame ||
                        window.webkitRequestAnimationFrame ||
                        window.mozRequestAnimationFrame ||
                        window.oRequestAnimationFrame ||
                        window.msRequestAnimationFrame ||
                        function( /* function FrameRequestCallback */ callback, /* DOMElement Element */ element ) {
                            window.setTimeout(callback, 1000 / 60);
                        };
                })();

                var animationIsOn = false;
                var createInterval = function() {
                    animationIsOn = true;

                    function nextFrame(callback) {
                        var args = Array.prototype.slice.call(arguments);
                        if(animationIsOn) {
                            reqAnimFrame(function () {
                                $rootScope.$apply(function () {
                                    callback.apply(null, args);
                                    nextFrame(callback);
                                });
                            })
                        }
                    }

                    nextFrame(function() {
                        if (!lastMouseEvent) return;

                        var viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
                        var viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

                        var scrollX = 0;
                        var scrollY = 0;

                        if (config.horizontalScroll) {
                            // If horizontal scrolling is active.
                            if (lastMouseEvent.clientX < config.activationDistance) {
                                // If the mouse is on the left of the viewport within the activation distance.
                                scrollX = -config.scrollDistance;
                            }
                            else if (lastMouseEvent.clientX > viewportWidth - config.activationDistance) {
                                // If the mouse is on the right of the viewport within the activation distance.
                                scrollX = config.scrollDistance;
                            }
                        }

                        if (config.verticalScroll) {
                            // If vertical scrolling is active.
                            if (lastMouseEvent.clientY < config.activationDistance) {
                                // If the mouse is on the top of the viewport within the activation distance.
                                scrollY = -config.scrollDistance;
                            }
                            else if (lastMouseEvent.clientY > viewportHeight - config.activationDistance) {
                                // If the mouse is on the bottom of the viewport within the activation distance.
                                scrollY = config.scrollDistance;
                            }
                        }



                        if (scrollX !== 0 || scrollY !== 0) {
                            // Record the current scroll position.
                            var currentScrollLeft = ($window.pageXOffset || $document[0].documentElement.scrollLeft);
                            var currentScrollTop = ($window.pageYOffset || $document[0].documentElement.scrollTop);

                            // Remove the transformation from the element, scroll the window by the scroll distance
                            // record how far we scrolled, then reapply the element transformation.
                            var elementTransform = element.css('transform');
                            element.css('transform', 'initial');

                            $window.scrollBy(scrollX, scrollY);

                            var horizontalScrollAmount = ($window.pageXOffset || $document[0].documentElement.scrollLeft) - currentScrollLeft;
                            var verticalScrollAmount =  ($window.pageYOffset || $document[0].documentElement.scrollTop) - currentScrollTop;

                            element.css('transform', elementTransform);

                            lastMouseEvent.pageX += horizontalScrollAmount;
                            lastMouseEvent.pageY += verticalScrollAmount;

                            $rootScope.$emit('draggable:_triggerHandlerMove', lastMouseEvent);
                        }

                    });
                };

                var clearInterval = function() {
                    animationIsOn = false;
                };

                scope.$on('draggable:start', function(event, obj) {
                    // Ignore this event if it's not for this element.
                    if (obj.element[0] !== element[0]) return;

                    if (!animationIsOn) createInterval();
                });

                scope.$on('draggable:end', function(event, obj) {
                    // Ignore this event if it's not for this element.
                    if (obj.element[0] !== element[0]) return;

                    if (animationIsOn) clearInterval();
                });

                scope.$on('draggable:move', function(event, obj) {
                    // Ignore this event if it's not for this element.
                    if (obj.element[0] !== element[0]) return;

                    lastMouseEvent = obj.event;
                });
            }
        };
    }]);

/**
 * Created by appian on 2016/11/4.
 */
(function (wid, dcm) {
	var win = wid;
	var doc = dcm;

	function $id(id) {
		return doc.getElementById(id);
	}

	function $class(name) {
		return doc.getElementsByClassName(name);
	}

	function loop(begin, length, fuc) {
		for ( var i = begin; i < length; i++ ) {
			if (fuc(i)) break;
		}
	}

	function on(action, selector, callback) {
		doc.addEventListener(action, function (e) {
			if (selector == e.target.tagName.toLowerCase() || selector == e.target.className || selector == e.target.id) {
				callback(e);
			}
		})
	}

	function MultiPicker(config) {
		this.input     = config.input;
		this.container = config.container;
		this.jsonData  = config.jsonData;
		this.success   = config.success;

		this.ulCount   = 0;
		this.ulIdx     = 0;
		this.ulDomArr  = [];
		this.idxArr    = [];
		this.jsonArr   = [];
		this.liHeight  = wid.lib ? Number(doc.getElementsByTagName('HTML')[0].style.fontSize.replace('px', '')) * 1 : 40;
		this.maxHeight = [];
		this.distance  = [];
		this.start     = {
			Y: 0,
			time: ''
		};
		this.move      = {
			Y: 0,
			speed: []
		};
		this.end       = {
			Y: 0,
			status: true
		};
		this.resultArr = [];
		this.initDomFuc();
		this.initReady(0, this.jsonData[0]);
		this.initBinding();
	}

	MultiPicker.prototype = {
		constructor: MultiPicker,
		generateArrData: function (targetArr) {
			var tempArr = [];
			loop(0, targetArr.length, function (i) {
				tempArr.push({
					"id": targetArr[i].id,
					"value": targetArr[i].value,
					"uuid": targetArr[i].uuid,
                    "path":targetArr[i].path,
                    "en":targetArr[i].en,
                    "identifier":targetArr[i].identifier,
                    "domain":targetArr[i].domain
				})
			});
            return tempArr;
		},
		checkArrDeep: function (parent) {
			var _this = this;
			if ('child' in parent && parent.child.length > 0) {
				_this.jsonArr.push(_this.generateArrData(parent.child));
				_this.checkArrDeep(parent.child[0]);
			}
			_this.idxArr.push(this.ulIdx++);
		},
		insertLiArr: function (targetUl, arr, flag) {
			var html    = '';
			var nullObj = {
				id: '-99',
				value: '',
                path:arr.path,
                "en":arr.en,
                "uuid": arr.uuid,
                "identifier":arr.identifier,
                "domain":arr.domain
			};
			arr.unshift(nullObj, nullObj);
			arr.push(nullObj, nullObj);
			loop(0, arr.length, function (i) {
			    if(!flag||!arr[i].identifier){
                    html += '<li data-id="' + arr[i].id + '">' + arr[i].value + '</li>';
                }else{
                    html += '<li data-id="' + arr[i].id + '">' +'<img src="'+arr[i].domain+arr[i].identifier+'" class="mar-top-6">'+ '</li>';
                }
			});
			targetUl.innerHTML = html;
		},
		initDomFuc: function () {
			var _this                      = this;
			var html                       = '';
			html += '<div class="multi-picker-bg" id="multi-picker-bg-' + _this.container + '">'
				+ '<div  class="multi-picker-container" id="multi-picker-container-' + _this.container + '">'
				+ '<div class="multi-picker-btn-box">'
				+ '<div class="multi-picker-btn" id="multi-picker-btn-cancel">返回</div>'
				+ '<div class="multi-picker-btn" id="multi-picker-btn-save-' + _this.container + '">确定</div>'
				+ '</div>'
				+ '<div class="multi-picker-content">'
				+ '<div class="multi-picker-up-shadow"></div>'
				+ '<div class="multi-picker-down-shadow"></div>'
				+ '<div class="multi-picker-line"></div>'
				+ '</div></div></div>';
			$id(_this.container).innerHTML = html;
			_this.jsonArr.push(_this.generateArrData(_this.jsonData));
		},
		initReady: function (idx, target) {
			var _this            = this;
			this.ulIdx           = 0;
			this.idxArr.length   = idx;
			_this.jsonArr.length = idx + 1;
			_this.checkArrDeep(target);
			var parentNode = $id('multi-picker-container-' + _this.container).children[1];
			var tempMax    = _this.ulCount <= _this.idxArr.length ? _this.ulCount : _this.idxArr.length;
			loop(idx + 1, tempMax, function (i) {
				var $picker = $id('multi-picker-' + _this.container + '-' + i);
				_this.insertLiArr($picker, _this.jsonArr[i], i);
				_this.distance[i]             = 0;
				$picker.style.transform       = 'translate3d(0, 0, 0)';
				$picker.style.webkitTransform = 'translate3d(0, 0, 0)';
			});
			if (_this.ulCount <= _this.idxArr.length) {
				loop(_this.ulCount, _this.idxArr.length, function (i) {
					var newPickerDiv = document.createElement('div');
					newPickerDiv.setAttribute('class', 'multi-picker');
					newPickerDiv.innerHTML = '<ul id="multi-picker-' + _this.container + '-' + i + '"></ul>';
					parentNode.insertBefore(newPickerDiv, parentNode.children[parentNode.children.length - 3]);
					var tempDomUl = $id('multi-picker-' + _this.container + '-' + i);
					_this.ulDomArr.push(tempDomUl);
					_this.distance.push(0);
					_this.insertLiArr(tempDomUl, _this.jsonArr[i], i);

					var tempArray = _this.jsonArr[i];
					tempDomUl.addEventListener('touchstart', function () {
						_this.touch(event, _this, tempDomUl, tempArray, i);
					}, false);
					tempDomUl.addEventListener('touchmove', function () {
						_this.touch(event, _this, tempDomUl, tempArray, i);
					}, false);
					tempDomUl.addEventListener('touchend', function () {
						_this.touch(event, _this, tempDomUl, tempArray, i);
					}, true);
				});
			} else {
				for ( var j = _this.ulCount - 1; j > _this.idxArr.length - 1; j-- ) {
					var oldPicker = $id(_this.container).querySelectorAll('.multi-picker')[j];
					oldPicker.parentNode.removeChild(oldPicker);
					_this.ulDomArr.pop();
					_this.distance.pop();
				}
			}

            $(".multi-picker-btn-box").hide();
			_this.maxHeight.length = 0;
			_this.resultArr.length = 0;
			loop(0, _this.idxArr.length, function (i) {
				$id(_this.container).querySelectorAll('.multi-picker')[i].style.width = 100 / _this.idxArr.length + '%';
				_this.maxHeight.push($id('multi-picker-' + _this.container + '-' + i).childNodes.length * _this.liHeight);
				_this.resultArr.push({
					"id": _this.jsonArr[i][_this.distance[i] / _this.liHeight + 2].id,
					"value": _this.jsonArr[i][_this.distance[i] / _this.liHeight + 2].value,
					"index": _this.distance[i] / _this.liHeight,
                    "path":_this.jsonArr[i][_this.distance[i] / _this.liHeight + 2].path,
                    "en":_this.jsonArr[i][_this.distance[i] / _this.liHeight + 2].en,
                    "uuid":_this.jsonArr[i][_this.distance[i] / _this.liHeight + 2].uuid,
                    "identifier":_this.jsonArr[i][_this.distance[i] / _this.liHeight + 2].identifier,
                    "domain":_this.jsonArr[i][_this.distance[i] / _this.liHeight + 2].domain
				});
			});
			_this.ulCount = _this.idxArr.length;
		},
		initBinding: function () {
			var _this     = this;
			var bg        = $id('multi-picker-bg-' + _this.container);
			var container = $id('multi-picker-container-' + _this.container);
			var body      = doc.body;
			on('touchstart', _this.input, function () {
			    bg.style.display = "block";
				bg.classList.add('multi-picker-bg-up', 'multi-picker-bg-delay');
				container.classList.add('multi-picker-container-up');
				body.classList.add('multi-picker-locked');
			}, false);

			on('touchstart', 'multi-picker-btn-save-' + _this.container, function () {
                bg.style.display='none';
				_this.success(_this.resultArr);
				bg.classList.remove('multi-picker-bg-up');
				container.classList.remove('multi-picker-container-up');
				setTimeout(function () {
					bg.classList.remove('multi-picker-bg-delay');
				}, 350);
				body.classList.remove('multi-picker-locked');
			}, false);

			on('touchstart', 'multi-picker-bg-' + _this.container, function () {
				bg.classList.remove('multi-picker-bg-up');
				container.classList.remove('multi-picker-container-up');
				setTimeout(function () {
					bg.classList.remove('multi-picker-bg-delay');
				}, 350);
				body.classList.remove('multi-picker-locked');
			}, false);

			on('touchstart', 'multi-picker-btn-cancel', function () {
			    bg.style.display='none';
				bg.classList.remove('multi-picker-bg-up');
				container.classList.remove('multi-picker-container-up');
				setTimeout(function () {
					bg.classList.remove('multi-picker-bg-delay');
				}, 350);
				body.classList.remove('multi-picker-locked');
			}, false);
		},
		checkRange: function (idx) {
			var _this     = this;
			var tempObj   = _this.jsonData;
			var targetIdx = 0;
			loop(0, idx + 1, function (i) {
				targetIdx = _this.distance[i] / _this.liHeight;
				tempObj   = i == 0 ? tempObj[targetIdx] : tempObj.child[targetIdx];
			});
			_this.initReady(idx, tempObj);
		},
		initPosition: function (dis, max, idx) {
			dis     = dis < 0 ? 0 : dis;
			dis     = dis > max ? max : dis;
			var sub = dis % this.liHeight;
			if (sub < this.liHeight / 2) {
				this.distance[idx] = dis - sub;
			} else {
				this.distance[idx] = dis + (this.liHeight - sub);
			}
			return this;
		},
		initSpeed: function (arr, dir, max, idx) {
			var variance = 0;
			var sum      = 0;
			var rate     = 0;
			for ( var i in arr ) {
				sum += arr[i] - 0;
			}
			for ( var j in arr ) {
				variance += (arr[j] - (sum / arr.length)) * (arr[j] - (sum / arr.length));
			}
			if ((variance / arr.length).toFixed(2) > .1) {
				rate = max > this.liHeight * 15 ? dir * 2 : 0;
				this.initPosition(this.distance[idx] + rate, max - this.liHeight * 5, idx);
				this.move.speed[0] = .2;
			} else {
				this.initPosition(this.distance[idx], max, idx);
				this.move.speed[0] = this.move.speed[0] > 0.2 ? .2 : this.move.speed[0];
			}
		},
		touch: function (event, that, $picker, array, idx) {
			event = event || window.event;
			event.preventDefault();
			switch (event.type) {
				case "touchstart":
					if (that.end.status) {
						that.end.status = !that.end.status;
						event.preventDefault();
						that.move.speed = [];
						that.start.Y    = event.touches[0].clientY;
						that.start.time = Date.now();
					}

					break;
				case "touchend":
					that.end.Y         = Math.abs(event.changedTouches[0].clientY);
					var tempDis        = that.distance[idx] + (that.start.Y - that.end.Y);
					var temp           = that.distance[idx];
					that.distance[idx] = tempDis < 0 ? 0 : (tempDis < that.maxHeight[idx] - this.liHeight * 5 ? tempDis : that.maxHeight[idx] - this.liHeight * 5);
					that.initSpeed(that.move.speed, that.start.Y - that.end.Y, that.maxHeight[idx], idx);

					$picker.style.transform        = 'translate3d(0,-' + that.distance[idx] + 'px, 0)';
					$picker.style.webkitTransform  = 'translate3d(0,-' + that.distance[idx] + 'px, 0)';
					$picker.style.transition       = 'transform ' + that.move.speed[0] + 's ease-out';
					$picker.style.webkitTransition = '-webkit-transform ' + that.move.speed[0] + 's ease-out';
					if (temp != that.distance[idx]) that.checkRange(idx);
					setTimeout(function () {
                        that.success(that.resultArr);
						that.end.status = true;
					}, that.move.speed[0] * 1000);
					break;
				case "touchmove":
					event.preventDefault();
					that.move.Y = event.touches[0].clientY;
					var offset  = that.start.Y - that.move.Y;
					if (that.distance[idx] == 0 && offset < 0) {
						$picker.style.transform        = 'translate3d(0,' + 1.5 * that.liHeight + 'px, 0)';
						$picker.style.webkitTransform  = 'translate3d(0,' + 1.5 * that.liHeight + 'px, 0)';
						$picker.style.transition       = 'transform 0.2s ease-out';
						$picker.style.webkitTransition = '-webkit-transform 0.2s ease-out';
					} else {
						$picker.style.transform       = 'translate3d(0,-' + (offset + that.distance[idx]) + 'px, 0)';
						$picker.style.webkitTransform = 'translate3d(0,-' + (offset + that.distance[idx]) + 'px, 0)';
					}
					if (Math.abs(offset).toFixed(0) % 5 === 0) {
						var time = Date.now();
						that.move.speed.push((Math.abs(offset) / (time - that.start.time)).toFixed(2));
					}
					break;
			}
		}
	};
	if (typeof exports == "object") {
		module.exports = MultiPicker;
	} else if (typeof define == "function" && define.amd) {
		define([], function () {
			return MultiPicker;
		})
	} else {
		win.MultiPicker = MultiPicker;
	}
})(window, document);


/* Modernizr 2.6.2 (Custom Build) | MIT & BSD
 * Build: http://modernizr.com/download/#-csstransforms3d-csstransitions-shiv-cssclasses-prefixed-teststyles-testprop-testallprops-prefixes-domprefixes-load
 */
;window.Modernizr=function(a,b,c){function z(a){j.cssText=a}function A(a,b){return z(m.join(a+";")+(b||""))}function B(a,b){return typeof a===b}function C(a,b){return!!~(""+a).indexOf(b)}function D(a,b){for(var d in a){var e=a[d];if(!C(e,"-")&&j[e]!==c)return b=="pfx"?e:!0}return!1}function E(a,b,d){for(var e in a){var f=b[a[e]];if(f!==c)return d===!1?a[e]:B(f,"function")?f.bind(d||b):f}return!1}function F(a,b,c){var d=a.charAt(0).toUpperCase()+a.slice(1),e=(a+" "+o.join(d+" ")+d).split(" ");return B(b,"string")||B(b,"undefined")?D(e,b):(e=(a+" "+p.join(d+" ")+d).split(" "),E(e,b,c))}var d="2.6.2",e={},f=!0,g=b.documentElement,h="modernizr",i=b.createElement(h),j=i.style,k,l={}.toString,m=" -webkit- -moz- -o- -ms- ".split(" "),n="Webkit Moz O ms",o=n.split(" "),p=n.toLowerCase().split(" "),q={},r={},s={},t=[],u=t.slice,v,w=function(a,c,d,e){var f,i,j,k,l=b.createElement("div"),m=b.body,n=m||b.createElement("body");if(parseInt(d,10))while(d--)j=b.createElement("div"),j.id=e?e[d]:h+(d+1),l.appendChild(j);return f=["&#173;",'<style id="s',h,'">',a,"</style>"].join(""),l.id=h,(m?l:n).innerHTML+=f,n.appendChild(l),m||(n.style.background="",n.style.overflow="hidden",k=g.style.overflow,g.style.overflow="hidden",g.appendChild(n)),i=c(l,a),m?l.parentNode.removeChild(l):(n.parentNode.removeChild(n),g.style.overflow=k),!!i},x={}.hasOwnProperty,y;!B(x,"undefined")&&!B(x.call,"undefined")?y=function(a,b){return x.call(a,b)}:y=function(a,b){return b in a&&B(a.constructor.prototype[b],"undefined")},Function.prototype.bind||(Function.prototype.bind=function(b){var c=this;if(typeof c!="function")throw new TypeError;var d=u.call(arguments,1),e=function(){if(this instanceof e){var a=function(){};a.prototype=c.prototype;var f=new a,g=c.apply(f,d.concat(u.call(arguments)));return Object(g)===g?g:f}return c.apply(b,d.concat(u.call(arguments)))};return e}),q.csstransforms3d=function(){var a=!!F("perspective");return a&&"webkitPerspective"in g.style&&w("@media (transform-3d),(-webkit-transform-3d){#modernizr{left:9px;position:absolute;height:3px;}}",function(b,c){a=b.offsetLeft===9&&b.offsetHeight===3}),a},q.csstransitions=function(){return F("transition")};for(var G in q)y(q,G)&&(v=G.toLowerCase(),e[v]=q[G](),t.push((e[v]?"":"no-")+v));return e.addTest=function(a,b){if(typeof a=="object")for(var d in a)y(a,d)&&e.addTest(d,a[d]);else{a=a.toLowerCase();if(e[a]!==c)return e;b=typeof b=="function"?b():b,typeof f!="undefined"&&f&&(g.className+=" "+(b?"":"no-")+a),e[a]=b}return e},z(""),i=k=null,function(a,b){function k(a,b){var c=a.createElement("p"),d=a.getElementsByTagName("head")[0]||a.documentElement;return c.innerHTML="x<style>"+b+"</style>",d.insertBefore(c.lastChild,d.firstChild)}function l(){var a=r.elements;return typeof a=="string"?a.split(" "):a}function m(a){var b=i[a[g]];return b||(b={},h++,a[g]=h,i[h]=b),b}function n(a,c,f){c||(c=b);if(j)return c.createElement(a);f||(f=m(c));var g;return f.cache[a]?g=f.cache[a].cloneNode():e.test(a)?g=(f.cache[a]=f.createElem(a)).cloneNode():g=f.createElem(a),g.canHaveChildren&&!d.test(a)?f.frag.appendChild(g):g}function o(a,c){a||(a=b);if(j)return a.createDocumentFragment();c=c||m(a);var d=c.frag.cloneNode(),e=0,f=l(),g=f.length;for(;e<g;e++)d.createElement(f[e]);return d}function p(a,b){b.cache||(b.cache={},b.createElem=a.createElement,b.createFrag=a.createDocumentFragment,b.frag=b.createFrag()),a.createElement=function(c){return r.shivMethods?n(c,a,b):b.createElem(c)},a.createDocumentFragment=Function("h,f","return function(){var n=f.cloneNode(),c=n.createElement;h.shivMethods&&("+l().join().replace(/\w+/g,function(a){return b.createElem(a),b.frag.createElement(a),'c("'+a+'")'})+");return n}")(r,b.frag)}function q(a){a||(a=b);var c=m(a);return r.shivCSS&&!f&&!c.hasCSS&&(c.hasCSS=!!k(a,"article,aside,figcaption,figure,footer,header,hgroup,nav,section{display:block}mark{background:#FF0;color:#000}")),j||p(a,c),a}var c=a.html5||{},d=/^<|^(?:button|map|select|textarea|object|iframe|option|optgroup)$/i,e=/^(?:a|b|code|div|fieldset|h1|h2|h3|h4|h5|h6|i|label|li|ol|p|q|span|strong|style|table|tbody|td|th|tr|ul)$/i,f,g="_html5shiv",h=0,i={},j;(function(){try{var a=b.createElement("a");a.innerHTML="<xyz></xyz>",f="hidden"in a,j=a.childNodes.length==1||function(){b.createElement("a");var a=b.createDocumentFragment();return typeof a.cloneNode=="undefined"||typeof a.createDocumentFragment=="undefined"||typeof a.createElement=="undefined"}()}catch(c){f=!0,j=!0}})();var r={elements:c.elements||"abbr article aside audio bdi canvas data datalist details figcaption figure footer header hgroup mark meter nav output progress section summary time video",shivCSS:c.shivCSS!==!1,supportsUnknownElements:j,shivMethods:c.shivMethods!==!1,type:"default",shivDocument:q,createElement:n,createDocumentFragment:o};a.html5=r,q(b)}(this,b),e._version=d,e._prefixes=m,e._domPrefixes=p,e._cssomPrefixes=o,e.testProp=function(a){return D([a])},e.testAllProps=F,e.testStyles=w,e.prefixed=function(a,b,c){return b?F(a,b,c):F(a,"pfx")},g.className=g.className.replace(/(^|\s)no-js(\s|$)/,"$1$2")+(f?" js "+t.join(" "):""),e}(this,this.document),function(a,b,c){function d(a){return"[object Function]"==o.call(a)}function e(a){return"string"==typeof a}function f(){}function g(a){return!a||"loaded"==a||"complete"==a||"uninitialized"==a}function h(){var a=p.shift();q=1,a?a.t?m(function(){("c"==a.t?B.injectCss:B.injectJs)(a.s,0,a.a,a.x,a.e,1)},0):(a(),h()):q=0}function i(a,c,d,e,f,i,j){function k(b){if(!o&&g(l.readyState)&&(u.r=o=1,!q&&h(),l.onload=l.onreadystatechange=null,b)){"img"!=a&&m(function(){t.removeChild(l)},50);for(var d in y[c])y[c].hasOwnProperty(d)&&y[c][d].onload()}}var j=j||B.errorTimeout,l=b.createElement(a),o=0,r=0,u={t:d,s:c,e:f,a:i,x:j};1===y[c]&&(r=1,y[c]=[]),"object"==a?l.data=c:(l.src=c,l.type=a),l.width=l.height="0",l.onerror=l.onload=l.onreadystatechange=function(){k.call(this,r)},p.splice(e,0,u),"img"!=a&&(r||2===y[c]?(t.insertBefore(l,s?null:n),m(k,j)):y[c].push(l))}function j(a,b,c,d,f){return q=0,b=b||"j",e(a)?i("c"==b?v:u,a,b,this.i++,c,d,f):(p.splice(this.i++,0,a),1==p.length&&h()),this}function k(){var a=B;return a.loader={load:j,i:0},a}var l=b.documentElement,m=a.setTimeout,n=b.getElementsByTagName("script")[0],o={}.toString,p=[],q=0,r="MozAppearance"in l.style,s=r&&!!b.createRange().compareNode,t=s?l:n.parentNode,l=a.opera&&"[object Opera]"==o.call(a.opera),l=!!b.attachEvent&&!l,u=r?"object":l?"script":"img",v=l?"script":u,w=Array.isArray||function(a){return"[object Array]"==o.call(a)},x=[],y={},z={timeout:function(a,b){return b.length&&(a.timeout=b[0]),a}},A,B;B=function(a){function b(a){var a=a.split("!"),b=x.length,c=a.pop(),d=a.length,c={url:c,origUrl:c,prefixes:a},e,f,g;for(f=0;f<d;f++)g=a[f].split("="),(e=z[g.shift()])&&(c=e(c,g));for(f=0;f<b;f++)c=x[f](c);return c}function g(a,e,f,g,h){var i=b(a),j=i.autoCallback;i.url.split(".").pop().split("?").shift(),i.bypass||(e&&(e=d(e)?e:e[a]||e[g]||e[a.split("/").pop().split("?")[0]]),i.instead?i.instead(a,e,f,g,h):(y[i.url]?i.noexec=!0:y[i.url]=1,f.load(i.url,i.forceCSS||!i.forceJS&&"css"==i.url.split(".").pop().split("?").shift()?"c":c,i.noexec,i.attrs,i.timeout),(d(e)||d(j))&&f.load(function(){k(),e&&e(i.origUrl,h,g),j&&j(i.origUrl,h,g),y[i.url]=2})))}function h(a,b){function c(a,c){if(a){if(e(a))c||(j=function(){var a=[].slice.call(arguments);k.apply(this,a),l()}),g(a,j,b,0,h);else if(Object(a)===a)for(n in m=function(){var b=0,c;for(c in a)a.hasOwnProperty(c)&&b++;return b}(),a)a.hasOwnProperty(n)&&(!c&&!--m&&(d(j)?j=function(){var a=[].slice.call(arguments);k.apply(this,a),l()}:j[n]=function(a){return function(){var b=[].slice.call(arguments);a&&a.apply(this,b),l()}}(k[n])),g(a[n],j,b,n,h))}else!c&&l()}var h=!!a.test,i=a.load||a.both,j=a.callback||f,k=j,l=a.complete||f,m,n;c(h?a.yep:a.nope,!!i),i&&c(i)}var i,j,l=this.yepnope.loader;if(e(a))g(a,0,l,0);else if(w(a))for(i=0;i<a.length;i++)j=a[i],e(j)?g(j,0,l,0):w(j)?B(j):Object(j)===j&&h(j,l);else Object(a)===a&&h(a,l)},B.addPrefix=function(a,b){z[a]=b},B.addFilter=function(a){x.push(a)},B.errorTimeout=1e4,null==b.readyState&&b.addEventListener&&(b.readyState="loading",b.addEventListener("DOMContentLoaded",A=function(){b.removeEventListener("DOMContentLoaded",A,0),b.readyState="complete"},0)),a.yepnope=k(),a.yepnope.executeStack=h,a.yepnope.injectJs=function(a,c,d,e,i,j){var k=b.createElement("script"),l,o,e=e||B.errorTimeout;k.src=a;for(o in d)k.setAttribute(o,d[o]);c=j?h:c||f,k.onreadystatechange=k.onload=function(){!l&&g(k.readyState)&&(l=1,c(),k.onload=k.onreadystatechange=null)},m(function(){l||(l=1,c(1))},e),i?k.onload():n.parentNode.insertBefore(k,n)},a.yepnope.injectCss=function(a,c,d,e,g,i){var e=b.createElement("link"),j,c=i?h:c||f;e.href=a,e.rel="stylesheet",e.type="text/css";for(j in d)e.setAttribute(j,d[j]);g||(n.parentNode.insertBefore(e,n),m(c,0))}}(this,document),Modernizr.load=function(){yepnope.apply(window,[].slice.call(arguments,0))};

(function() {
    'use strict';
    angular
        .module('editorApp')
        .factory('MessageService', MessageService);

    MessageService.$inject = ['$uibModal', '$translate'];

    function MessageService($uibModal, $translate) {
        var service = {
            confirm: confirm,
            minConfirm: minConfirm,
            successConfirm: successConfirm,
            comment:comment,
            loading:loading,
            error:error,
            notice:notice,
            info:info,
            success:success,
            notify:notify,
            hint:hint


        };

        var settings = {
            title: 'The notice title.', // The notice's title.
            title_escape: false, // Whether to escape the content of the title. (Not allow HTML.)
            // text: 'The notice text.', // The notice's text.
            text_escape: false, // Whether to escape the content of the text. (Not allow HTML.)
            styling: "bootstrap3", // What styling classes to use. (Can be either jqueryui or bootstrap or bootstrap3.)
            // addclass: "", // Additional classes to be added to the notice. (For custom styling.)
            // cornerclass: "", // Class to be added to the notice for corner styling.
            // nonblock: false, // Create a non-blocking notice. It lets the user click elements underneath it.
            // nonblock_opacity: .2, // The opacity of the notice (if it's non-blocking) when the mouse is over it.
            history: false, // Display a pull down menu to redisplay previous notices, and place the notice in the history.
            // width: "300px", // Width of the notice.
            // min_height: "16px", // Minimum height of the notice. It will expand to fit content.
            type: "notice", // Type of the notice. "notice", "info", "success", or "error".
            icon: true, // Set icon to true to use the default icon for the selected style/type, false for no icon, or a string for your own icon class.
            // animation: "fade", // The animation to use when displaying and hiding the notice. "none", "show", "fade", and "slide" are built in to jQuery. Others require jQuery UI. Use an object with effect_in and effect_out to use different effects.
            // animate_speed: "slow", // Speed at which the notice animates in and out. "slow", "def" or "normal", "fast" or number of milliseconds.
            // opacity: 1, // Opacity of the notice.
            // shadow: true, // Display a drop shadow.
            // closer: true, // Provide a button for the user to manually close the notice.
            // closer_hover: true, // Only show the closer button on hover.
            // sticker: true, // Provide a button for the user to manually stick the notice.
            // sticker_hover: true, // Only show the sticker button on hover.
            // hide: true, // After a delay, remove the notice.
            delay: 5000 // Delay in milliseconds before the notice is removed.
                // mouse_reset: true, // Reset the hide timer if the mouse moves over the notice.
                // remove: true, // Remove the notice's elements from the DOM after it is removed.
                // insert_brs: true, // Change new lines to br tags.
                // stack: {"dir1": "down", "dir2": "left", "push": "bottom", "spacing1": 25, "spacing2": 25}
        };
        var current;

        function hint(content,time) {
            var _time = time || 2000;
            var _html = '<div class="three-modal2" id="c-modal1">\n' +
                '    <div class="three-modal2-body">\n' +
                '        <div>'+content+'</div>\n' +
                '    </div>\n' +
                '</div>';
            $("body").append(_html);
            setTimeout(function () {
                $("#c-modal1").remove();
            },_time)
        };
        function notice(content) {
            var hash = angular.copy(settings);
            hash.type = 'notice';
            hash.title = content;
            hash.nonblock = {
                nonblock: true,
                nonblock_opacity: .2
            };
            return this.notify(hash);
        };

        function info(content) {
            var hash = angular.copy(settings);
            hash.type = 'info';
            hash.title = content;
            hash.nonblock = {
                nonblock: true,
                nonblock_opacity: .2
            };
            return this.notify(hash);
        };

        function success(content) {
            var hash = angular.copy(settings);
            hash.type = 'success';
            hash.title = content;
            hash.nonblock = {
                nonblock: true,
                nonblock_opacity: .2
            };
            return this.notify(hash);
        };

        function error(content) {
            var hash = angular.copy(settings);
            hash.type = 'error';
            hash.title = content;
            return this.notify(hash);
        };

        function notify(hash) {
            if (current) {
                current.remove();
            }
            current = new PNotify(hash);
            return current;

            var modalInstance = $uibModal.open({
                template: '<div class="modal-body">' + //
                    '<div class="row" style="text-align:center;">' + //
                    '<h3>' + hash.title + '</h3>' + //
                    '</div>' + //
                    '</div>',
            });
        };

        function loading() {
            return $uibModal.open({
                template: '<i class="fa fa-5x fa-spinner fa-spin fa-white"></i>',
                backdrop: 'static',
                keyboard: false,
                windowClass: 'loading-window'
            });
        };

        function confirm(obj,confirmCallback, cancelCallback, translate) {
            var ModalInstanceCtrl = ['$scope', '$uibModalInstance',
                function($scope, $uibModalInstance) {
                    $scope.ok = function() {
                        $uibModalInstance.close('ok');
                    };
                    $scope.cancel = function(value) {
                        $uibModalInstance.dismiss({cancel: true, value: value});
                    };
                    $scope.htmlClick = function() {
                        $uibModalInstance.close('htmlClick');
                    };
                }
            ];
            var htmlPart = obj.html ? ('<span class="themeColor-pointer" ng-click="htmlClick()">'+obj.html+'</span>') : '';
            var backdropConfig = obj.html ? 'static' : true;
            if(!!translate){
                var modalInstance = $uibModal.open({
                    template: '<div class="confirm-dialog">' + //
                        '<div class="confirm-dialog-header">' + //
                        '<div class="confirm-dialog-title">'+obj.title+'</div>' + //
                        '<span class="iconfont iconcloseicon1" ng-click="cancel(true)"></span>' + //
                        '</div>' + //
                        '<div class="confirm-dialog-content">'+obj.msg+ htmlPart +
                        '</div>'+
                        '<div class="confirm-dialog-footer">'+
                        (obj.cancel ? '<button class="confirm-dialog-footer-cancel" translate="entity.action.cancel" ng-click="cancel(false)">'+obj.cancel+'</button>' : '') +
                        '<button class="confirm-dialog-footer-delete" ng-click="ok()">'+obj.confirm+'</button>'+
                        '</div>'+
                        '</div>'+
                        '<style>.modal-content{width: 528px;}</style>',
                    controller: ModalInstanceCtrl,
                    backdrop: backdropConfig
                });
            }else{
                var modalInstance = $uibModal.open({
                    template: '<div class="confirm-dialog">' + //
                    '<div class="confirm-dialog-header">' + //
                    '<div class="confirm-dialog-title">'+obj.title+'</div>' + //
                    '<span class="iconfont iconcloseicon1" ng-click="cancel(true)"></span>' + //
                    '</div>' + //
                    '<div class="confirm-dialog-content">'+obj.msg+ htmlPart +
                    '</div>'+
                    '<div class="confirm-dialog-footer">'+
                    (obj.cancel ? '<button class="confirm-dialog-footer-cancel" ng-click="cancel(false)">'+obj.cancel+'</button>' : '') +
                    '<button class="confirm-dialog-footer-delete" ng-click="ok()">'+obj.confirm+'</button>'+
                    '</div>'+
                    '</div>'+
                    '<style>.modal-content{width: 528px;}</style>',
                    controller: ModalInstanceCtrl,
                    backdrop: backdropConfig
                });
            }


            modalInstance.result.then(function(res) {
                if (typeof confirmCallback == 'function') {
                    confirmCallback(res);
                }
            }, function(res) {
                if (res && res.cancel) {
                    if (typeof cancelCallback == 'function') {
                        cancelCallback(res.value);
                    }
                }
            });

        };
        function minConfirm(obj,confirmCallback, cancelCallback, translate) {
            var ModalInstanceCtrl = ['$scope', '$uibModalInstance',
                function($scope, $uibModalInstance) {

                    $scope.ok = function() {
                        $uibModalInstance.close('ok');
                    };

                    $scope.cancel = function(value) {
                        $uibModalInstance.dismiss({cancel: true, value: value});
                    };
                }
            ];
            var modalInstance = $uibModal.open({
                template: '<div class="confirm-dialog" style="padding: 0;">' + //
                    (obj.hide ? '<span class="iconfont iconguanbi11" ng-click="cancel(true)" style="position: absolute;left: 50%;bottom: -40px;color: #fff;margin-left: -12px;font-size: 24px;"></span>' : '') +
                    '<div class="confirm-dialog-content" style="padding: 24px;">'+obj.msg+
                    '</div>'+
                    '<div class="confirm-dialog-footer" style=" justify-content: center;border-top: 1px solid #ddd;">'+
                    (obj.cancel ? '<button class="confirm-dialog-footer-cancel" ng-click="cancel(false)" style=" width: 100%;border-radius: 0;background: none;color: #333;border-right: 1px solid #ddd;">'+obj.cancel+'</button>' : '') +
                    '<button class="confirm-dialog-footer-delete" ng-click="ok()" style=" width: 100%;margin: 0;border-radius: 0;background: none;color: var(--webMainButtonBackColor);">'+obj.confirm+'</button>'+
                    '</div>'+
                    '</div>'+
                    '<style>.modal-content{width: 528px !important;overflow: unset !important;}</style>',
                controller: ModalInstanceCtrl
            });


            modalInstance.result.then(function() {
                if (typeof confirmCallback == 'function') {
                    confirmCallback();
                }
            }, function(res) {
                if (res && res.cancel) {
                    if (typeof cancelCallback == 'function') {
                        cancelCallback(res.value);
                    }
                }
            });

        };

        function successConfirm(msg, confirmCallback, translate) {
            var ModalInstanceCtrl = ['$scope', '$uibModalInstance',
                function($scope, $uibModalInstance) {

                    $scope.ok = function() {
                        $uibModalInstance.close('ok');
                    };

                }
            ];

            if(!!translate){
                 var modalInstance = $uibModal.open({
                    template: '<div class="modal-body">' + //
                        '<div class="row" style="text-align:center;">' + //
                        '<h3 style="cursor:pointer;" ng-click="ok()"><label translate='+msg+'></label></h3>',
                    controller: ModalInstanceCtrl
                });
            }else{
                var modalInstance = $uibModal.open({
                    template: '<div class="modal-body">' + //
                        '<div class="row" style="text-align:center;">' + //
                        '<h3 style="cursor:pointer;" ng-click="ok()">' + msg + '</h3>',
                    controller: ModalInstanceCtrl
                });
            }



            modalInstance.result.then(function() {
                if (typeof confirmCallback == 'function') {
                    confirmCallback();
                }
            });
        };

        function comment(msg, confirmCallback, cancelCallback, commentMust, translate) {
            var ModalInstanceCtrl = ['$scope', '$uibModalInstance', '$timeout',
                function($scope, $uibModalInstance, $timeout) {
                    $scope.ok = function(comment) {
                        if (commentMust && !comment) {
                            // return self.error('评论必填');
                            $scope.error = true;
                            return;
                        }
                        $scope.error = false;
                        $uibModalInstance.close(comment);
                    };
                    if (commentMust) {
                        $scope.placeholderMsg = $translate.instant("hint.commentRequired");
                    } else {
                        $scope.placeholderMsg = $translate.instant("hint.commentOptional");
                    }

                    $scope.cancel = function() {
                        $uibModalInstance.dismiss('cancel');
                    };
                    $timeout(function() {
                        $scope.$apply();
                    });
                }
            ];

            if(!!translate){
                var modalInstance = $uibModal.open({
                    template: '<div class="modal-body">' + //
                        '<div class="row" style="text-align:center;">' + //
                        '<h3><label translate='+msg+'></label></h3>' + //
                        '<input type="text" class="form-control highlight" ng-model="comment" placeholder="{{placeholderMsg}}">' + //
                        '<span style="color:red;float:left;margin-left:10px;" ng-show="error" translate="hint.required">必填</span>' + //
                        '</div>' + //
                        '<div class="row">' + //
                        '<button class="btn btn-warning pull-right" ng-click="cancel()" translate="button.cancel">取消</button>' + //
                        '<button class="btn btn-primary pull-right" ng-click="ok(comment)" translate="button.confirm">确认</button>' + //
                        '</div>' + //
                        '</div>',
                    controller: ModalInstanceCtrl
                });
            }else{
                var modalInstance = $uibModal.open({
                    template: '<div class="modal-body">' + //
                        '<div class="row" style="text-align:center;">' + //
                        '<h3>' + msg + '</h3>' + //
                        '<input type="text" class="form-control highlight" ng-model="comment" placeholder="{{placeholderMsg}}">' + //
                        '<span style="color:red;float:left;margin-left:10px;" ng-show="error" translate="hint.required">必填</span>' + //
                        '</div>' + //
                        '<div class="row">' + //
                        '<button class="btn btn-warning pull-right" ng-click="cancel()" translate="button.cancel">取消</button>' + //
                        '<button class="btn btn-primary pull-right" ng-click="ok(comment)" translate="button.confirm">确认</button>' + //
                        '</div>' + //
                        '</div>',
                    controller: ModalInstanceCtrl
                });
            }

            modalInstance.result.then(function(comment) {
                if (typeof confirmCallback == 'function') {
                    confirmCallback(comment);
                }
            }, function() {
                if (typeof cancelCallback == 'function') {
                    cancelCallback();
                }
            });
        };
        return service;
    }

})();

(function() {
	'use strict';
	angular
		.module('editorApp')
		.factory('ListService', ListService);

	ListService.$inject = [];

	function ListService() {
		var service = {
			inList: inList,
			inList2 :inList2,
			removeEmptyInList: removeEmptyInList
		};
		return service;

		function inList2(value, list, valueAttr , listAttr) {
			if (list) {
				for (var i = list.length - 1; i >= 0; i--) {
					var v = list[i];
					if (valueAttr && listAttr) {
						if (v && value[valueAttr] == v[listAttr]) {
							return v;
						};
					} else {
						if (v && v.id == value.id) {
							return v;
						}
					}
				}
			}
		}

		function inList(value, list, attrList) {
			if (list) {
				for (var i = list.length - 1; i >= 0; i--) {
					var v = list[i];
					if (attrList) {
						if (v) {
							var match = 0;
							for (var j = 0; attrList && j < attrList.length; j++) {
								var attr = attrList[j];
								if (attr) {
									if (v[attr] == value[attr]) {
										match++;
									} else {
										break;
									}
								}
							}
							if (match == attrList.length) {
								return v;
							}
						}
					} else {
						if (v && v.id == value.id) {
							return v;
						}
					}
				}
			}
		}

		function removeEmptyInList(list, key) {
			if (!list) return;
			for (var i = 0; i < list.length; i++) {
				var item = list[i];
				if (item && !item[key]) {
					list.splice(i, 1);
					i--;
				}
			}
		}
	}



})();

/*! layPage-v1.3.0 分页组件 License MIT  http://laypage.layui.com/ By 贤心 */
;!function () {
    "use strict";

    function a(d) {
        var e = "laypagecss";
        a.dir = "dir" in a ? a.dir : f.getpath + "/skin/laypages.css", new f(d), a.dir && !b[c](e) && f.use(a.dir, e)
    }

    a.v = "1.3";
    var b = document, c = "getElementById", d = "getElementsByTagName", e = 0, f = function (a) {
        var b = this, c = b.config = a || {};
        c.item = e++, b.render(!0)
    };
    f.on = function (a, b, c) {
        return a.attachEvent ? a.attachEvent("on" + b, function () {
            c.call(a, window.even)
        }) : a.addEventListener(b, c, !1), f
    }, f.getpath = function () {
        var a = document.scripts, b = a[a.length - 1].src;
        return b.substring(0, b.lastIndexOf("/") + 1)
    }(), f.use = function (c, e) {
        // var f = b.createElement("link");
        // f.type = "text/css", f.rel = "stylesheet", f.href = a.dir, e && (f.id = e), b[d]("head")[0].appendChild(f), f = null
    }, f.prototype.type = function () {
        var a = this.config;
        return "object" == typeof a.cont ? void 0 === a.cont.length ? 2 : 3 : void 0
    }, f.prototype.view = function () {
        var b = this, c = b.config, d = [], e = {};
        if (c.pages = 0 | c.pages, c.curr = 0 | c.curr || 1, c.groups = "groups" in c ? 0 | c.groups : 5, c.first = "first" in c ? c.first : "&#x9996;&#x9875;", c.last = "last" in c ? c.last : "&#x5C3E;&#x9875;", c.prev = "prev" in c ? c.prev : "&#x4E0A;&#x4E00;&#x9875;", c.next = "next" in c ? c.next : "&#x4E0B;&#x4E00;&#x9875;", c.pages <= 1) return "";
        for (c.groups > c.pages && (c.groups = c.pages), e.index = Math.ceil((c.curr + (c.groups > 1 && c.groups !== c.pages ? 1 : 0)) / (0 === c.groups ? 1 : c.groups)), c.curr > 1 && c.prev && d.push('<a href="javascript:;" class="laypage_prev" data-page="' + (c.curr - 1) + '">' + c.prev + "</a>"), e.index > 1 && c.first && 0 !== c.groups && d.push('<a href="javascript:;" class="laypage_first" data-page="1"  title="&#x9996;&#x9875;">' + c.first + "</a><span>&#x2026;</span>"), e.poor = Math.floor((c.groups - 1) / 2), e.start = e.index > 1 ? c.curr - e.poor : 1, e.end = e.index > 1 ? function () {
            var a = c.curr + (c.groups - e.poor - 1);
            return a > c.pages ? c.pages : a
        }() : c.groups, e.end - e.start < c.groups - 1 && (e.start = e.end - c.groups + 1); e.start <= e.end; e.start++) e.start === c.curr ? d.push('<span class="laypage_curr" ' + (/^#/.test(c.skin) ? 'style="background-color:' + c.skin + '"' : "") + ">" + e.start + "</span>") : d.push('<a href="javascript:;" data-page="' + e.start + '">' + e.start + "</a>");
        return c.pages > c.groups && e.end < c.pages && c.last && 0 !== c.groups && d.push('<span>&#x2026;</span><a href="javascript:;" class="laypage_last" title="&#x5C3E;&#x9875;"  data-page="' + c.pages + '">' + c.last + "</a>"), e.flow = !c.prev && 0 === c.groups, (c.curr !== c.pages && c.next || e.flow) && d.push(function () {
            return e.flow && c.curr === c.pages ? '<span class="page_nomore" title="&#x5DF2;&#x6CA1;&#x6709;&#x66F4;&#x591A;">' + c.next + "</span>" : '<a href="javascript:;" class="laypage_next" data-page="' + (c.curr + 1) + '">' + c.next + "</a>"
        }()), '<div name="laypage' + a.v + '" class="laypage_main laypageskin_' + (c.skin ? function (a) {
            return /^#/.test(a) ? "molv" : a
        }(c.skin) : "default") + '" id="laypage_' + b.config.item + '">' + d.join("") + function () {
            return c.skip ? '<span class="laypage_total"><label>&#x5230;&#x7B2C;</label><input type="number" min="1" onkeyup="this.value=this.value.replace(/\\D/, \'\');" class="laypage_skip"><label>&#x9875;</label><button type="button" class="laypage_btn">&#x786e;&#x5b9a</button></span>' : ""
        }() + "</div>"
    }, f.prototype.jump = function (a) {
        if (a) {
            for (var b = this, c = b.config, e = a.children, g = a[d]("button")[0], h = a[d]("input")[0], i = 0, j = e.length; j > i; i++) "a" === e[i].nodeName.toLowerCase() && f.on(e[i], "click", function () {
                var a = 0 | this.getAttribute("data-page");
                c.curr = a, b.render()
            });
            g && f.on(g, "click", function () {
                var a = 0 | h.value.replace(/\s|\D/g, "");
                a && a <= c.pages && (c.curr = a, b.render())
            })
        }
    }, f.prototype.render = function (a) {
        var d = this, e = d.config, f = d.type(), g = d.view();
        2 === f ? e.cont.innerHTML = g : 3 === f ? e.cont.html(g) : b[c](e.cont).innerHTML = g, e.jump && e.jump(e, a), d.jump(b[c]("laypage_" + e.item)), e.hash && !a && (location.hash = "!" + e.hash + "=" + e.curr)
    }, "function" == typeof define ? define(function () {
        return a
    }) : "undefined" != typeof exports ? module.exports = a : window.laypage = a
}();

!function(e,n){"function"==typeof define&&(define.amd||define.cmd)?define(function(){return n(e)}):n(e,!0)}(this,function(e,n){function i(n,i,t){e.WeixinJSBridge?WeixinJSBridge.invoke(n,o(i),function(e){c(n,e,t)}):u(n,t)}function t(n,i,t){e.WeixinJSBridge?WeixinJSBridge.on(n,function(e){t&&t.trigger&&t.trigger(e),c(n,e,i)}):t?u(n,t):u(n,i)}function o(e){return e=e||{},e.appId=C.appId,e.verifyAppId=C.appId,e.verifySignType="sha1",e.verifyTimestamp=C.timestamp+"",e.verifyNonceStr=C.nonceStr,e.verifySignature=C.signature,e}function r(e){return{timeStamp:e.timestamp+"",nonceStr:e.nonceStr,package:e.package,paySign:e.paySign,signType:e.signType||"SHA1"}}function a(e){return e.postalCode=e.addressPostalCode,delete e.addressPostalCode,e.provinceName=e.proviceFirstStageName,delete e.proviceFirstStageName,e.cityName=e.addressCitySecondStageName,delete e.addressCitySecondStageName,e.countryName=e.addressCountiesThirdStageName,delete e.addressCountiesThirdStageName,e.detailInfo=e.addressDetailInfo,delete e.addressDetailInfo,e}function c(e,n,i){"openEnterpriseChat"==e&&(n.errCode=n.err_code),delete n.err_code,delete n.err_desc,delete n.err_detail;var t=n.errMsg;t||(t=n.err_msg,delete n.err_msg,t=s(e,t),n.errMsg=t),(i=i||{})._complete&&(i._complete(n),delete i._complete),t=n.errMsg||"",C.debug&&!i.isInnerInvoke&&alert(JSON.stringify(n));var o=t.indexOf(":");switch(t.substring(o+1)){case"ok":i.success&&i.success(n);break;case"cancel":i.cancel&&i.cancel(n);break;default:i.fail&&i.fail(n)}i.complete&&i.complete(n)}function s(e,n){var i=e,t=v[i];t&&(i=t);var o="ok";if(n){var r=n.indexOf(":");"confirm"==(o=n.substring(r+1))&&(o="ok"),"failed"==o&&(o="fail"),-1!=o.indexOf("failed_")&&(o=o.substring(7)),-1!=o.indexOf("fail_")&&(o=o.substring(5)),"access denied"!=(o=(o=o.replace(/_/g," ")).toLowerCase())&&"no permission to execute"!=o||(o="permission denied"),"config"==i&&"function not exist"==o&&(o="ok"),""==o&&(o="fail")}return n=i+":"+o}function d(e){if(e){for(var n=0,i=e.length;n<i;++n){var t=e[n],o=h[t];o&&(e[n]=o)}return e}}function u(e,n){if(!(!C.debug||n&&n.isInnerInvoke)){var i=v[e];i&&(e=i),n&&n._complete&&delete n._complete,console.log('"'+e+'",',n||"")}}function l(e){if(!(k||w||C.debug||x<"6.0.2"||V.systemType<0)){var n=new Image;V.appId=C.appId,V.initTime=A.initEndTime-A.initStartTime,V.preVerifyTime=A.preVerifyEndTime-A.preVerifyStartTime,N.getNetworkType({isInnerInvoke:!0,success:function(e){V.networkType=e.networkType;var i="https://open.weixin.qq.com/sdk/report?v="+V.version+"&o="+V.isPreVerifyOk+"&s="+V.systemType+"&c="+V.clientVersion+"&a="+V.appId+"&n="+V.networkType+"&i="+V.initTime+"&p="+V.preVerifyTime+"&u="+V.url;n.src=i}})}}function p(){return(new Date).getTime()}function f(n){T&&(e.WeixinJSBridge?n():S.addEventListener&&S.addEventListener("WeixinJSBridgeReady",n,!1))}function m(){N.invoke||(N.invoke=function(n,i,t){e.WeixinJSBridge&&WeixinJSBridge.invoke(n,o(i),t)},N.on=function(n,i){e.WeixinJSBridge&&WeixinJSBridge.on(n,i)})}function g(e){if("string"==typeof e&&e.length>0){var n=e.split("?")[0],i=e.split("?")[1];return n+=".html",void 0!==i?n+"?"+i:n}}if(!e.jWeixin){var h={config:"preVerifyJSAPI",onMenuShareTimeline:"menu:share:timeline",onMenuShareAppMessage:"menu:share:appmessage",onMenuShareQQ:"menu:share:qq",onMenuShareWeibo:"menu:share:weiboApp",onMenuShareQZone:"menu:share:QZone",previewImage:"imagePreview",getLocation:"geoLocation",openProductSpecificView:"openProductViewWithPid",addCard:"batchAddCard",openCard:"batchViewCard",chooseWXPay:"getBrandWCPayRequest",openEnterpriseRedPacket:"getRecevieBizHongBaoRequest",startSearchBeacons:"startMonitoringBeacons",stopSearchBeacons:"stopMonitoringBeacons",onSearchBeacons:"onBeaconsInRange",consumeAndShareCard:"consumedShareCard",openAddress:"editAddress"},v=function(){var e={};for(var n in h)e[h[n]]=n;return e}(),S=e.document,I=S.title,y=navigator.userAgent.toLowerCase(),_=navigator.platform.toLowerCase(),k=!(!_.match("mac")&&!_.match("win")),w=-1!=y.indexOf("wxdebugger"),T=-1!=y.indexOf("micromessenger"),M=-1!=y.indexOf("android"),P=-1!=y.indexOf("iphone")||-1!=y.indexOf("ipad"),x=function(){var e=y.match(/micromessenger\/(\d+\.\d+\.\d+)/)||y.match(/micromessenger\/(\d+\.\d+)/);return e?e[1]:""}(),A={initStartTime:p(),initEndTime:0,preVerifyStartTime:0,preVerifyEndTime:0},V={version:1,appId:"",initTime:0,preVerifyTime:0,networkType:"",isPreVerifyOk:1,systemType:P?1:M?2:-1,clientVersion:x,url:encodeURIComponent(location.href)},C={},L={_completes:[]},B={state:0,data:{}};f(function(){A.initEndTime=p()});var O=!1,E=[],N={config:function(e){C=e,u("config",e);var n=!1!==C.check;f(function(){if(n)i(h.config,{verifyJsApiList:d(C.jsApiList)},function(){L._complete=function(e){A.preVerifyEndTime=p(),B.state=1,B.data=e},L.success=function(e){V.isPreVerifyOk=0},L.fail=function(e){L._fail?L._fail(e):B.state=-1};var e=L._completes;return e.push(function(){l()}),L.complete=function(n){for(var i=0,t=e.length;i<t;++i)e[i]();L._completes=[]},L}()),A.preVerifyStartTime=p();else{B.state=1;for(var e=L._completes,t=0,o=e.length;t<o;++t)e[t]();L._completes=[]}}),m()},ready:function(e){0!=B.state?e():(L._completes.push(e),!T&&C.debug&&e())},error:function(e){x<"6.0.2"||(-1==B.state?e(B.data):L._fail=e)},checkJsApi:function(e){var n=function(e){var n=e.checkResult;for(var i in n){var t=v[i];t&&(n[t]=n[i],delete n[i])}return e};i("checkJsApi",{jsApiList:d(e.jsApiList)},(e._complete=function(e){if(M){var i=e.checkResult;i&&(e.checkResult=JSON.parse(i))}e=n(e)},e))},onMenuShareTimeline:function(e){t(h.onMenuShareTimeline,{complete:function(){i("shareTimeline",{title:e.title||I,desc:e.title||I,img_url:e.imgUrl||"",link:e.link||location.href,type:e.type||"link",data_url:e.dataUrl||""},e)}},e)},onMenuShareAppMessage:function(e){t(h.onMenuShareAppMessage,{complete:function(n){"favorite"===n.scene?i("sendAppMessage",{title:e.title||I,desc:e.desc||"",link:e.link||location.href,img_url:e.imgUrl||"",type:e.type||"link",data_url:e.dataUrl||""}):i("sendAppMessage",{title:e.title||I,desc:e.desc||"",link:e.link||location.href,img_url:e.imgUrl||"",type:e.type||"link",data_url:e.dataUrl||""},e)}},e)},onMenuShareQQ:function(e){t(h.onMenuShareQQ,{complete:function(){i("shareQQ",{title:e.title||I,desc:e.desc||"",img_url:e.imgUrl||"",link:e.link||location.href},e)}},e)},onMenuShareWeibo:function(e){t(h.onMenuShareWeibo,{complete:function(){i("shareWeiboApp",{title:e.title||I,desc:e.desc||"",img_url:e.imgUrl||"",link:e.link||location.href},e)}},e)},onMenuShareQZone:function(e){t(h.onMenuShareQZone,{complete:function(){i("shareQZone",{title:e.title||I,desc:e.desc||"",img_url:e.imgUrl||"",link:e.link||location.href},e)}},e)},updateTimelineShareData:function(e){i("updateTimelineShareData",{title:e.title,link:e.link,imgUrl:e.imgUrl},e)},updateAppMessageShareData:function(e){i("updateAppMessageShareData",{title:e.title,desc:e.desc,link:e.link,imgUrl:e.imgUrl},e)},startRecord:function(e){i("startRecord",{},e)},stopRecord:function(e){i("stopRecord",{},e)},onVoiceRecordEnd:function(e){t("onVoiceRecordEnd",e)},playVoice:function(e){i("playVoice",{localId:e.localId},e)},pauseVoice:function(e){i("pauseVoice",{localId:e.localId},e)},stopVoice:function(e){i("stopVoice",{localId:e.localId},e)},onVoicePlayEnd:function(e){t("onVoicePlayEnd",e)},uploadVoice:function(e){i("uploadVoice",{localId:e.localId,isShowProgressTips:0==e.isShowProgressTips?0:1},e)},downloadVoice:function(e){i("downloadVoice",{serverId:e.serverId,isShowProgressTips:0==e.isShowProgressTips?0:1},e)},translateVoice:function(e){i("translateVoice",{localId:e.localId,isShowProgressTips:0==e.isShowProgressTips?0:1},e)},chooseImage:function(e){i("chooseImage",{scene:"1|2",count:e.count||9,sizeType:e.sizeType||["original","compressed"],sourceType:e.sourceType||["album","camera"]},(e._complete=function(e){if(M){var n=e.localIds;try{n&&(e.localIds=JSON.parse(n))}catch(e){}}},e))},getLocation:function(e){},previewImage:function(e){i(h.previewImage,{current:e.current,urls:e.urls},e)},uploadImage:function(e){i("uploadImage",{localId:e.localId,isShowProgressTips:0==e.isShowProgressTips?0:1},e)},downloadImage:function(e){i("downloadImage",{serverId:e.serverId,isShowProgressTips:0==e.isShowProgressTips?0:1},e)},getLocalImgData:function(e){!1===O?(O=!0,i("getLocalImgData",{localId:e.localId},(e._complete=function(e){if(O=!1,E.length>0){var n=E.shift();wx.getLocalImgData(n)}},e))):E.push(e)},getNetworkType:function(e){var n=function(e){var n=e.errMsg;e.errMsg="getNetworkType:ok";var i=e.subtype;if(delete e.subtype,i)e.networkType=i;else{var t=n.indexOf(":"),o=n.substring(t+1);switch(o){case"wifi":case"edge":case"wwan":e.networkType=o;break;default:e.errMsg="getNetworkType:fail"}}return e};i("getNetworkType",{},(e._complete=function(e){e=n(e)},e))},openLocation:function(e){i("openLocation",{latitude:e.latitude,longitude:e.longitude,name:e.name||"",address:e.address||"",scale:e.scale||28,infoUrl:e.infoUrl||""},e)},getLocation:function(e){e=e||{},i(h.getLocation,{type:e.type||"wgs84"},(e._complete=function(e){delete e.type},e))},hideOptionMenu:function(e){i("hideOptionMenu",{},e)},showOptionMenu:function(e){i("showOptionMenu",{},e)},closeWindow:function(e){i("closeWindow",{},e=e||{})},hideMenuItems:function(e){i("hideMenuItems",{menuList:e.menuList},e)},showMenuItems:function(e){i("showMenuItems",{menuList:e.menuList},e)},hideAllNonBaseMenuItem:function(e){i("hideAllNonBaseMenuItem",{},e)},showAllNonBaseMenuItem:function(e){i("showAllNonBaseMenuItem",{},e)},scanQRCode:function(e){i("scanQRCode",{needResult:(e=e||{}).needResult||0,scanType:e.scanType||["qrCode","barCode"]},(e._complete=function(e){if(P){var n=e.resultStr;if(n){var i=JSON.parse(n);e.resultStr=i&&i.scan_code&&i.scan_code.scan_result}}},e))},openAddress:function(e){i(h.openAddress,{},(e._complete=function(e){e=a(e)},e))},openProductSpecificView:function(e){i(h.openProductSpecificView,{pid:e.productId,view_type:e.viewType||0,ext_info:e.extInfo},e)},addCard:function(e){for(var n=e.cardList,t=[],o=0,r=n.length;o<r;++o){var a=n[o],c={card_id:a.cardId,card_ext:a.cardExt};t.push(c)}i(h.addCard,{card_list:t},(e._complete=function(e){var n=e.card_list;if(n){for(var i=0,t=(n=JSON.parse(n)).length;i<t;++i){var o=n[i];o.cardId=o.card_id,o.cardExt=o.card_ext,o.isSuccess=!!o.is_succ,delete o.card_id,delete o.card_ext,delete o.is_succ}e.cardList=n,delete e.card_list}},e))},chooseCard:function(e){i("chooseCard",{app_id:C.appId,location_id:e.shopId||"",sign_type:e.signType||"SHA1",card_id:e.cardId||"",card_type:e.cardType||"",card_sign:e.cardSign,time_stamp:e.timestamp+"",nonce_str:e.nonceStr},(e._complete=function(e){e.cardList=e.choose_card_info,delete e.choose_card_info},e))},openCard:function(e){for(var n=e.cardList,t=[],o=0,r=n.length;o<r;++o){var a=n[o],c={card_id:a.cardId,code:a.code};t.push(c)}i(h.openCard,{card_list:t},e)},consumeAndShareCard:function(e){i(h.consumeAndShareCard,{consumedCardId:e.cardId,consumedCode:e.code},e)},chooseWXPay:function(e){i(h.chooseWXPay,r(e),e)},openEnterpriseRedPacket:function(e){i(h.openEnterpriseRedPacket,r(e),e)},startSearchBeacons:function(e){i(h.startSearchBeacons,{ticket:e.ticket},e)},stopSearchBeacons:function(e){i(h.stopSearchBeacons,{},e)},onSearchBeacons:function(e){t(h.onSearchBeacons,e)},openEnterpriseChat:function(e){i("openEnterpriseChat",{useridlist:e.userIds,chatname:e.groupName},e)},launchMiniProgram:function(e){i("launchMiniProgram",{targetAppId:e.targetAppId,path:g(e.path),envVersion:e.envVersion},e)},miniProgram:{navigateBack:function(e){e=e||{},f(function(){i("invokeMiniProgramAPI",{name:"navigateBack",arg:{delta:e.delta||1}},e)})},navigateTo:function(e){f(function(){i("invokeMiniProgramAPI",{name:"navigateTo",arg:{url:e.url}},e)})},redirectTo:function(e){f(function(){i("invokeMiniProgramAPI",{name:"redirectTo",arg:{url:e.url}},e)})},switchTab:function(e){f(function(){i("invokeMiniProgramAPI",{name:"switchTab",arg:{url:e.url}},e)})},reLaunch:function(e){f(function(){i("invokeMiniProgramAPI",{name:"reLaunch",arg:{url:e.url}},e)})},postMessage:function(e){f(function(){i("invokeMiniProgramAPI",{name:"postMessage",arg:e.data||{}},e)})},getEnv:function(n){f(function(){n({miniprogram:"miniprogram"===e.__wxjs_environment})})}}},b=1,R={};return S.addEventListener("error",function(e){if(!M){var n=e.target,i=n.tagName,t=n.src;if(("IMG"==i||"VIDEO"==i||"AUDIO"==i||"SOURCE"==i)&&-1!=t.indexOf("wxlocalresource://")){e.preventDefault(),e.stopPropagation();var o=n["wx-id"];if(o||(o=b++,n["wx-id"]=o),R[o])return;R[o]=!0,wx.ready(function(){wx.getLocalImgData({localId:t,success:function(e){n.src=e.localData}})})}}},!0),S.addEventListener("load",function(e){if(!M){var n=e.target,i=n.tagName;n.src;if("IMG"==i||"VIDEO"==i||"AUDIO"==i||"SOURCE"==i){var t=n["wx-id"];t&&(R[t]=!1)}}},!0),n&&(e.wx=e.jWeixin=N),N}});

(function() {

    var event = jQuery.event,

        //helper that finds handlers by type and calls back a function, this is basically handle
        // events - the events object
        // types - an array of event types to look for
        // callback(type, handlerFunc, selector) - a callback
        // selector - an optional selector to filter with, if there, matches by selector
        //     if null, matches anything, otherwise, matches with no selector
        findHelper = function( events, types, callback, selector ) {
            var t, type, typeHandlers, all, h, handle,
                namespaces, namespace,
                match;
            for ( t = 0; t < types.length; t++ ) {
                type = types[t];
                all = type.indexOf(".") < 0;
                if (!all ) {
                    namespaces = type.split(".");
                    type = namespaces.shift();
                    namespace = new RegExp("(^|\\.)" + namespaces.slice(0).sort().join("\\.(?:.*\\.)?") + "(\\.|$)");
                }
                typeHandlers = (events[type] || []).slice(0);

                for ( h = 0; h < typeHandlers.length; h++ ) {
                    handle = typeHandlers[h];

                    match = (all || namespace.test(handle.namespace));

                    if(match){
                        if(selector){
                            if (handle.selector === selector  ) {
                                callback(type, handle.origHandler || handle.handler);
                            }
                        } else if (selector === null){
                            callback(type, handle.origHandler || handle.handler, handle.selector);
                        }
                        else if (!handle.selector ) {
                            callback(type, handle.origHandler || handle.handler);

                        }
                    }


                }
            }
        };

    /**
     * Finds event handlers of a given type on an element.
     * @param {HTMLElement} el
     * @param {Array} types an array of event names
     * @param {String} [selector] optional selector
     * @return {Array} an array of event handlers
     */
    event.find = function( el, types, selector ) {
        var events = ( $._data(el) || {} ).events,
            handlers = [],
            t, liver, live;

        if (!events ) {
            return handlers;
        }
        findHelper(events, types, function( type, handler ) {
            handlers.push(handler);
        }, selector);
        return handlers;
    };
    /**
     * Finds all events.  Group by selector.
     * @param {HTMLElement} el the element
     * @param {Array} types event types
     */
    event.findBySelector = function( el, types ) {
        var events = $._data(el).events,
            selectors = {},
            //adds a handler for a given selector and event
            add = function( selector, event, handler ) {
                var select = selectors[selector] || (selectors[selector] = {}),
                    events = select[event] || (select[event] = []);
                events.push(handler);
            };

        if (!events ) {
            return selectors;
        }
        //first check live:
        /*$.each(events.live || [], function( i, live ) {
            if ( $.inArray(live.origType, types) !== -1 ) {
                add(live.selector, live.origType, live.origHandler || live.handler);
            }
        });*/
        //then check straight binds
        findHelper(events, types, function( type, handler, selector ) {
            add(selector || "", type, handler);
        }, null);

        return selectors;
    };
    event.supportTouch = "ontouchend" in document;

    $.fn.respondsTo = function( events ) {
        if (!this.length ) {
            return false;
        } else {
            //add default ?
            return event.find(this[0], $.isArray(events) ? events : [events]).length > 0;
        }
    };
    $.fn.triggerHandled = function( event, data ) {
        event = (typeof event == "string" ? $.Event(event) : event);
        this.trigger(event, data);
        return event.handled;
    };
    /**
     * Only attaches one event handler for all types ...
     * @param {Array} types llist of types that will delegate here
     * @param {Object} startingEvent the first event to start listening to
     * @param {Object} onFirst a function to call
     */
    event.setupHelper = function( types, startingEvent, onFirst ) {
        if (!onFirst ) {
            onFirst = startingEvent;
            startingEvent = null;
        }
        var add = function( handleObj ) {

                var bySelector, selector = handleObj.selector || "";
                if ( selector ) {
                    bySelector = event.find(this, types, selector);
                    if (!bySelector.length ) {
                        $(this).delegate(selector, startingEvent, onFirst);
                    }
                }
                else {
                    //var bySelector = event.find(this, types, selector);
                    if (!event.find(this, types, selector).length ) {
                        event.add(this, startingEvent, onFirst, {
                            selector: selector,
                            delegate: this
                        });
                    }

                }

            },
            remove = function( handleObj ) {
                var bySelector, selector = handleObj.selector || "";
                if ( selector ) {
                    bySelector = event.find(this, types, selector);
                    if (!bySelector.length ) {
                        $(this).undelegate(selector, startingEvent, onFirst);
                    }
                }
                else {
                    if (!event.find(this, types, selector).length ) {
                        event.remove(this, startingEvent, onFirst, {
                            selector: selector,
                            delegate: this
                        });
                    }
                }
            };
        $.each(types, function() {
            event.special[this] = {
                add: add,
                remove: remove,
                setup: function() {},
                teardown: function() {}
            };
        });
    };
})(jQuery);
(function($){
    var isPhantom = /Phantom/.test(navigator.userAgent),
        supportTouch = !isPhantom && "ontouchend" in document,
        scrollEvent = "touchmove scroll",
        // Use touch events or map it to mouse events
        touchStartEvent = supportTouch ? "touchstart" : "mousedown",
        touchStopEvent = supportTouch ? "touchend" : "mouseup",
        touchMoveEvent = supportTouch ? "touchmove" : "mousemove",
        data = function(event){
            var d = event.originalEvent.touches ?
                event.originalEvent.touches[ 0 ] :
                event;
            return {
                time: (new Date).getTime(),
                coords: [ d.pageX, d.pageY ],
                origin: $( event.target )
            };
        };

    /**
     * @add jQuery.event.swipe
     */
    var swipe = $.event.swipe = {
        /**
         * @attribute delay
         * Delay is the upper limit of time the swipe motion can take in milliseconds.  This defaults to 500.
         *
         * A user must perform the swipe motion in this much time.
         */
        delay : 500,
        /**
         * @attribute max
         * The maximum distance the pointer must travel in pixels.  The default is 75 pixels.
         */
        max : 75,
        /**
         * @attribute min
         * The minimum distance the pointer must travel in pixels.  The default is 30 pixels.
         */
        min : 30
    };

    $.event.setupHelper( [

        /**
         * @hide
         * @attribute swipe
         */
        "swipe",
        /**
         * @hide
         * @attribute swipeleft
         */
        'swipeleft',
        /**
         * @hide
         * @attribute swiperight
         */
        'swiperight',
        /**
         * @hide
         * @attribute swipeup
         */
        'swipeup',
        /**
         * @hide
         * @attribute swipedown
         */
        'swipedown'], touchStartEvent, function(ev){
        var
            // update with data when the event was started
            start = data(ev),
            stop,
            delegate = ev.delegateTarget || ev.currentTarget,
            selector = ev.handleObj.selector,
            entered = this;

        function moveHandler(event){
            if ( !start ) {
                return;
            }
            // update stop with the data from the current event
            stop = data(event);

            // prevent scrolling
            if ( Math.abs( start.coords[0] - stop.coords[0] ) > 10 ) {
                event.preventDefault();
            }
        };

        // Attach to the touch move events
        $(document.documentElement).bind(touchMoveEvent, moveHandler)
            .one(touchStopEvent, function(event){
                $(this).unbind( touchMoveEvent, moveHandler);
                // if start and stop contain data figure out if we have a swipe event
                if ( start && stop ) {
                    // calculate the distance between start and stop data
                    var deltaX = Math.abs(start.coords[0] - stop.coords[0]),
                        deltaY = Math.abs(start.coords[1] - stop.coords[1]),
                        distance = Math.sqrt(deltaX*deltaX+deltaY*deltaY);

                    // check if the delay and distance are matched
                    if ( stop.time - start.time < swipe.delay && distance >= swipe.min ) {
                        var events = ['swipe'];
                        // check if we moved horizontally
                        if( deltaX >= swipe.min && deltaY < swipe.min) {
                            // based on the x coordinate check if we moved left or right
                            events.push( start.coords[0] > stop.coords[0] ? "swipeleft" : "swiperight" );
                        } else
                            // check if we moved vertically
                        if(deltaY >= swipe.min && deltaX < swipe.min){
                            // based on the y coordinate check if we moved up or down
                            events.push( start.coords[1] < stop.coords[1] ? "swipedown" : "swipeup" );
                        }

                        // trigger swipe events on this guy
                        $.each($.event.find(delegate, events, selector), function(){
                            this.call(entered, ev, {start : start, end: stop})
                        })

                    }
                }
                // reset start and stop
                start = stop = undefined;
            })
    });

})(jQuery)

/*! jQuery v2.2.4 | (c) jQuery Foundation | jquery.org/license */
!function(a,b){"object"==typeof module&&"object"==typeof module.exports?module.exports=a.document?b(a,!0):function(a){if(!a.document)throw new Error("jQuery requires a window with a document");return b(a)}:b(a)}("undefined"!=typeof window?window:this,function(a,b){var c=[],d=a.document,e=c.slice,f=c.concat,g=c.push,h=c.indexOf,i={},j=i.toString,k=i.hasOwnProperty,l={},m="2.2.4",n=function(a,b){return new n.fn.init(a,b)},o=/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,p=/^-ms-/,q=/-([\da-z])/gi,r=function(a,b){return b.toUpperCase()};n.fn=n.prototype={jquery:m,constructor:n,selector:"",length:0,toArray:function(){return e.call(this)},get:function(a){return null!=a?0>a?this[a+this.length]:this[a]:e.call(this)},pushStack:function(a){var b=n.merge(this.constructor(),a);return b.prevObject=this,b.context=this.context,b},each:function(a){return n.each(this,a)},map:function(a){return this.pushStack(n.map(this,function(b,c){return a.call(b,c,b)}))},slice:function(){return this.pushStack(e.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},eq:function(a){var b=this.length,c=+a+(0>a?b:0);return this.pushStack(c>=0&&b>c?[this[c]]:[])},end:function(){return this.prevObject||this.constructor()},push:g,sort:c.sort,splice:c.splice},n.extend=n.fn.extend=function(){var a,b,c,d,e,f,g=arguments[0]||{},h=1,i=arguments.length,j=!1;for("boolean"==typeof g&&(j=g,g=arguments[h]||{},h++),"object"==typeof g||n.isFunction(g)||(g={}),h===i&&(g=this,h--);i>h;h++)if(null!=(a=arguments[h]))for(b in a)c=g[b],d=a[b],g!==d&&(j&&d&&(n.isPlainObject(d)||(e=n.isArray(d)))?(e?(e=!1,f=c&&n.isArray(c)?c:[]):f=c&&n.isPlainObject(c)?c:{},g[b]=n.extend(j,f,d)):void 0!==d&&(g[b]=d));return g},n.extend({expando:"jQuery"+(m+Math.random()).replace(/\D/g,""),isReady:!0,error:function(a){throw new Error(a)},noop:function(){},isFunction:function(a){return"function"===n.type(a)},isArray:Array.isArray,isWindow:function(a){return null!=a&&a===a.window},isNumeric:function(a){var b=a&&a.toString();return!n.isArray(a)&&b-parseFloat(b)+1>=0},isPlainObject:function(a){var b;if("object"!==n.type(a)||a.nodeType||n.isWindow(a))return!1;if(a.constructor&&!k.call(a,"constructor")&&!k.call(a.constructor.prototype||{},"isPrototypeOf"))return!1;for(b in a);return void 0===b||k.call(a,b)},isEmptyObject:function(a){var b;for(b in a)return!1;return!0},type:function(a){return null==a?a+"":"object"==typeof a||"function"==typeof a?i[j.call(a)]||"object":typeof a},globalEval:function(a){var b,c=eval;a=n.trim(a),a&&(1===a.indexOf("use strict")?(b=d.createElement("script"),b.text=a,d.head.appendChild(b).parentNode.removeChild(b)):c(a))},camelCase:function(a){return a.replace(p,"ms-").replace(q,r)},nodeName:function(a,b){return a.nodeName&&a.nodeName.toLowerCase()===b.toLowerCase()},each:function(a,b){var c,d=0;if(s(a)){for(c=a.length;c>d;d++)if(b.call(a[d],d,a[d])===!1)break}else for(d in a)if(b.call(a[d],d,a[d])===!1)break;return a},trim:function(a){return null==a?"":(a+"").replace(o,"")},makeArray:function(a,b){var c=b||[];return null!=a&&(s(Object(a))?n.merge(c,"string"==typeof a?[a]:a):g.call(c,a)),c},inArray:function(a,b,c){return null==b?-1:h.call(b,a,c)},merge:function(a,b){for(var c=+b.length,d=0,e=a.length;c>d;d++)a[e++]=b[d];return a.length=e,a},grep:function(a,b,c){for(var d,e=[],f=0,g=a.length,h=!c;g>f;f++)d=!b(a[f],f),d!==h&&e.push(a[f]);return e},map:function(a,b,c){var d,e,g=0,h=[];if(s(a))for(d=a.length;d>g;g++)e=b(a[g],g,c),null!=e&&h.push(e);else for(g in a)e=b(a[g],g,c),null!=e&&h.push(e);return f.apply([],h)},guid:1,proxy:function(a,b){var c,d,f;return"string"==typeof b&&(c=a[b],b=a,a=c),n.isFunction(a)?(d=e.call(arguments,2),f=function(){return a.apply(b||this,d.concat(e.call(arguments)))},f.guid=a.guid=a.guid||n.guid++,f):void 0},now:Date.now,support:l}),"function"==typeof Symbol&&(n.fn[Symbol.iterator]=c[Symbol.iterator]),n.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),function(a,b){i["[object "+b+"]"]=b.toLowerCase()});function s(a){var b=!!a&&"length"in a&&a.length,c=n.type(a);return"function"===c||n.isWindow(a)?!1:"array"===c||0===b||"number"==typeof b&&b>0&&b-1 in a}var t=function(a){var b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u="sizzle"+1*new Date,v=a.document,w=0,x=0,y=ga(),z=ga(),A=ga(),B=function(a,b){return a===b&&(l=!0),0},C=1<<31,D={}.hasOwnProperty,E=[],F=E.pop,G=E.push,H=E.push,I=E.slice,J=function(a,b){for(var c=0,d=a.length;d>c;c++)if(a[c]===b)return c;return-1},K="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",L="[\\x20\\t\\r\\n\\f]",M="(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",N="\\["+L+"*("+M+")(?:"+L+"*([*^$|!~]?=)"+L+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+M+"))|)"+L+"*\\]",O=":("+M+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+N+")*)|.*)\\)|)",P=new RegExp(L+"+","g"),Q=new RegExp("^"+L+"+|((?:^|[^\\\\])(?:\\\\.)*)"+L+"+$","g"),R=new RegExp("^"+L+"*,"+L+"*"),S=new RegExp("^"+L+"*([>+~]|"+L+")"+L+"*"),T=new RegExp("="+L+"*([^\\]'\"]*?)"+L+"*\\]","g"),U=new RegExp(O),V=new RegExp("^"+M+"$"),W={ID:new RegExp("^#("+M+")"),CLASS:new RegExp("^\\.("+M+")"),TAG:new RegExp("^("+M+"|[*])"),ATTR:new RegExp("^"+N),PSEUDO:new RegExp("^"+O),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+L+"*(even|odd|(([+-]|)(\\d*)n|)"+L+"*(?:([+-]|)"+L+"*(\\d+)|))"+L+"*\\)|)","i"),bool:new RegExp("^(?:"+K+")$","i"),needsContext:new RegExp("^"+L+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+L+"*((?:-\\d)?\\d*)"+L+"*\\)|)(?=[^-]|$)","i")},X=/^(?:input|select|textarea|button)$/i,Y=/^h\d$/i,Z=/^[^{]+\{\s*\[native \w/,$=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,_=/[+~]/,aa=/'|\\/g,ba=new RegExp("\\\\([\\da-f]{1,6}"+L+"?|("+L+")|.)","ig"),ca=function(a,b,c){var d="0x"+b-65536;return d!==d||c?b:0>d?String.fromCharCode(d+65536):String.fromCharCode(d>>10|55296,1023&d|56320)},da=function(){m()};try{H.apply(E=I.call(v.childNodes),v.childNodes),E[v.childNodes.length].nodeType}catch(ea){H={apply:E.length?function(a,b){G.apply(a,I.call(b))}:function(a,b){var c=a.length,d=0;while(a[c++]=b[d++]);a.length=c-1}}}function fa(a,b,d,e){var f,h,j,k,l,o,r,s,w=b&&b.ownerDocument,x=b?b.nodeType:9;if(d=d||[],"string"!=typeof a||!a||1!==x&&9!==x&&11!==x)return d;if(!e&&((b?b.ownerDocument||b:v)!==n&&m(b),b=b||n,p)){if(11!==x&&(o=$.exec(a)))if(f=o[1]){if(9===x){if(!(j=b.getElementById(f)))return d;if(j.id===f)return d.push(j),d}else if(w&&(j=w.getElementById(f))&&t(b,j)&&j.id===f)return d.push(j),d}else{if(o[2])return H.apply(d,b.getElementsByTagName(a)),d;if((f=o[3])&&c.getElementsByClassName&&b.getElementsByClassName)return H.apply(d,b.getElementsByClassName(f)),d}if(c.qsa&&!A[a+" "]&&(!q||!q.test(a))){if(1!==x)w=b,s=a;else if("object"!==b.nodeName.toLowerCase()){(k=b.getAttribute("id"))?k=k.replace(aa,"\\$&"):b.setAttribute("id",k=u),r=g(a),h=r.length,l=V.test(k)?"#"+k:"[id='"+k+"']";while(h--)r[h]=l+" "+qa(r[h]);s=r.join(","),w=_.test(a)&&oa(b.parentNode)||b}if(s)try{return H.apply(d,w.querySelectorAll(s)),d}catch(y){}finally{k===u&&b.removeAttribute("id")}}}return i(a.replace(Q,"$1"),b,d,e)}function ga(){var a=[];function b(c,e){return a.push(c+" ")>d.cacheLength&&delete b[a.shift()],b[c+" "]=e}return b}function ha(a){return a[u]=!0,a}function ia(a){var b=n.createElement("div");try{return!!a(b)}catch(c){return!1}finally{b.parentNode&&b.parentNode.removeChild(b),b=null}}function ja(a,b){var c=a.split("|"),e=c.length;while(e--)d.attrHandle[c[e]]=b}function ka(a,b){var c=b&&a,d=c&&1===a.nodeType&&1===b.nodeType&&(~b.sourceIndex||C)-(~a.sourceIndex||C);if(d)return d;if(c)while(c=c.nextSibling)if(c===b)return-1;return a?1:-1}function la(a){return function(b){var c=b.nodeName.toLowerCase();return"input"===c&&b.type===a}}function ma(a){return function(b){var c=b.nodeName.toLowerCase();return("input"===c||"button"===c)&&b.type===a}}function na(a){return ha(function(b){return b=+b,ha(function(c,d){var e,f=a([],c.length,b),g=f.length;while(g--)c[e=f[g]]&&(c[e]=!(d[e]=c[e]))})})}function oa(a){return a&&"undefined"!=typeof a.getElementsByTagName&&a}c=fa.support={},f=fa.isXML=function(a){var b=a&&(a.ownerDocument||a).documentElement;return b?"HTML"!==b.nodeName:!1},m=fa.setDocument=function(a){var b,e,g=a?a.ownerDocument||a:v;return g!==n&&9===g.nodeType&&g.documentElement?(n=g,o=n.documentElement,p=!f(n),(e=n.defaultView)&&e.top!==e&&(e.addEventListener?e.addEventListener("unload",da,!1):e.attachEvent&&e.attachEvent("onunload",da)),c.attributes=ia(function(a){return a.className="i",!a.getAttribute("className")}),c.getElementsByTagName=ia(function(a){return a.appendChild(n.createComment("")),!a.getElementsByTagName("*").length}),c.getElementsByClassName=Z.test(n.getElementsByClassName),c.getById=ia(function(a){return o.appendChild(a).id=u,!n.getElementsByName||!n.getElementsByName(u).length}),c.getById?(d.find.ID=function(a,b){if("undefined"!=typeof b.getElementById&&p){var c=b.getElementById(a);return c?[c]:[]}},d.filter.ID=function(a){var b=a.replace(ba,ca);return function(a){return a.getAttribute("id")===b}}):(delete d.find.ID,d.filter.ID=function(a){var b=a.replace(ba,ca);return function(a){var c="undefined"!=typeof a.getAttributeNode&&a.getAttributeNode("id");return c&&c.value===b}}),d.find.TAG=c.getElementsByTagName?function(a,b){return"undefined"!=typeof b.getElementsByTagName?b.getElementsByTagName(a):c.qsa?b.querySelectorAll(a):void 0}:function(a,b){var c,d=[],e=0,f=b.getElementsByTagName(a);if("*"===a){while(c=f[e++])1===c.nodeType&&d.push(c);return d}return f},d.find.CLASS=c.getElementsByClassName&&function(a,b){return"undefined"!=typeof b.getElementsByClassName&&p?b.getElementsByClassName(a):void 0},r=[],q=[],(c.qsa=Z.test(n.querySelectorAll))&&(ia(function(a){o.appendChild(a).innerHTML="<a id='"+u+"'></a><select id='"+u+"-\r\\' msallowcapture=''><option selected=''></option></select>",a.querySelectorAll("[msallowcapture^='']").length&&q.push("[*^$]="+L+"*(?:''|\"\")"),a.querySelectorAll("[selected]").length||q.push("\\["+L+"*(?:value|"+K+")"),a.querySelectorAll("[id~="+u+"-]").length||q.push("~="),a.querySelectorAll(":checked").length||q.push(":checked"),a.querySelectorAll("a#"+u+"+*").length||q.push(".#.+[+~]")}),ia(function(a){var b=n.createElement("input");b.setAttribute("type","hidden"),a.appendChild(b).setAttribute("name","D"),a.querySelectorAll("[name=d]").length&&q.push("name"+L+"*[*^$|!~]?="),a.querySelectorAll(":enabled").length||q.push(":enabled",":disabled"),a.querySelectorAll("*,:x"),q.push(",.*:")})),(c.matchesSelector=Z.test(s=o.matches||o.webkitMatchesSelector||o.mozMatchesSelector||o.oMatchesSelector||o.msMatchesSelector))&&ia(function(a){c.disconnectedMatch=s.call(a,"div"),s.call(a,"[s!='']:x"),r.push("!=",O)}),q=q.length&&new RegExp(q.join("|")),r=r.length&&new RegExp(r.join("|")),b=Z.test(o.compareDocumentPosition),t=b||Z.test(o.contains)?function(a,b){var c=9===a.nodeType?a.documentElement:a,d=b&&b.parentNode;return a===d||!(!d||1!==d.nodeType||!(c.contains?c.contains(d):a.compareDocumentPosition&&16&a.compareDocumentPosition(d)))}:function(a,b){if(b)while(b=b.parentNode)if(b===a)return!0;return!1},B=b?function(a,b){if(a===b)return l=!0,0;var d=!a.compareDocumentPosition-!b.compareDocumentPosition;return d?d:(d=(a.ownerDocument||a)===(b.ownerDocument||b)?a.compareDocumentPosition(b):1,1&d||!c.sortDetached&&b.compareDocumentPosition(a)===d?a===n||a.ownerDocument===v&&t(v,a)?-1:b===n||b.ownerDocument===v&&t(v,b)?1:k?J(k,a)-J(k,b):0:4&d?-1:1)}:function(a,b){if(a===b)return l=!0,0;var c,d=0,e=a.parentNode,f=b.parentNode,g=[a],h=[b];if(!e||!f)return a===n?-1:b===n?1:e?-1:f?1:k?J(k,a)-J(k,b):0;if(e===f)return ka(a,b);c=a;while(c=c.parentNode)g.unshift(c);c=b;while(c=c.parentNode)h.unshift(c);while(g[d]===h[d])d++;return d?ka(g[d],h[d]):g[d]===v?-1:h[d]===v?1:0},n):n},fa.matches=function(a,b){return fa(a,null,null,b)},fa.matchesSelector=function(a,b){if((a.ownerDocument||a)!==n&&m(a),b=b.replace(T,"='$1']"),c.matchesSelector&&p&&!A[b+" "]&&(!r||!r.test(b))&&(!q||!q.test(b)))try{var d=s.call(a,b);if(d||c.disconnectedMatch||a.document&&11!==a.document.nodeType)return d}catch(e){}return fa(b,n,null,[a]).length>0},fa.contains=function(a,b){return(a.ownerDocument||a)!==n&&m(a),t(a,b)},fa.attr=function(a,b){(a.ownerDocument||a)!==n&&m(a);var e=d.attrHandle[b.toLowerCase()],f=e&&D.call(d.attrHandle,b.toLowerCase())?e(a,b,!p):void 0;return void 0!==f?f:c.attributes||!p?a.getAttribute(b):(f=a.getAttributeNode(b))&&f.specified?f.value:null},fa.error=function(a){throw new Error("Syntax error, unrecognized expression: "+a)},fa.uniqueSort=function(a){var b,d=[],e=0,f=0;if(l=!c.detectDuplicates,k=!c.sortStable&&a.slice(0),a.sort(B),l){while(b=a[f++])b===a[f]&&(e=d.push(f));while(e--)a.splice(d[e],1)}return k=null,a},e=fa.getText=function(a){var b,c="",d=0,f=a.nodeType;if(f){if(1===f||9===f||11===f){if("string"==typeof a.textContent)return a.textContent;for(a=a.firstChild;a;a=a.nextSibling)c+=e(a)}else if(3===f||4===f)return a.nodeValue}else while(b=a[d++])c+=e(b);return c},d=fa.selectors={cacheLength:50,createPseudo:ha,match:W,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(a){return a[1]=a[1].replace(ba,ca),a[3]=(a[3]||a[4]||a[5]||"").replace(ba,ca),"~="===a[2]&&(a[3]=" "+a[3]+" "),a.slice(0,4)},CHILD:function(a){return a[1]=a[1].toLowerCase(),"nth"===a[1].slice(0,3)?(a[3]||fa.error(a[0]),a[4]=+(a[4]?a[5]+(a[6]||1):2*("even"===a[3]||"odd"===a[3])),a[5]=+(a[7]+a[8]||"odd"===a[3])):a[3]&&fa.error(a[0]),a},PSEUDO:function(a){var b,c=!a[6]&&a[2];return W.CHILD.test(a[0])?null:(a[3]?a[2]=a[4]||a[5]||"":c&&U.test(c)&&(b=g(c,!0))&&(b=c.indexOf(")",c.length-b)-c.length)&&(a[0]=a[0].slice(0,b),a[2]=c.slice(0,b)),a.slice(0,3))}},filter:{TAG:function(a){var b=a.replace(ba,ca).toLowerCase();return"*"===a?function(){return!0}:function(a){return a.nodeName&&a.nodeName.toLowerCase()===b}},CLASS:function(a){var b=y[a+" "];return b||(b=new RegExp("(^|"+L+")"+a+"("+L+"|$)"))&&y(a,function(a){return b.test("string"==typeof a.className&&a.className||"undefined"!=typeof a.getAttribute&&a.getAttribute("class")||"")})},ATTR:function(a,b,c){return function(d){var e=fa.attr(d,a);return null==e?"!="===b:b?(e+="","="===b?e===c:"!="===b?e!==c:"^="===b?c&&0===e.indexOf(c):"*="===b?c&&e.indexOf(c)>-1:"$="===b?c&&e.slice(-c.length)===c:"~="===b?(" "+e.replace(P," ")+" ").indexOf(c)>-1:"|="===b?e===c||e.slice(0,c.length+1)===c+"-":!1):!0}},CHILD:function(a,b,c,d,e){var f="nth"!==a.slice(0,3),g="last"!==a.slice(-4),h="of-type"===b;return 1===d&&0===e?function(a){return!!a.parentNode}:function(b,c,i){var j,k,l,m,n,o,p=f!==g?"nextSibling":"previousSibling",q=b.parentNode,r=h&&b.nodeName.toLowerCase(),s=!i&&!h,t=!1;if(q){if(f){while(p){m=b;while(m=m[p])if(h?m.nodeName.toLowerCase()===r:1===m.nodeType)return!1;o=p="only"===a&&!o&&"nextSibling"}return!0}if(o=[g?q.firstChild:q.lastChild],g&&s){m=q,l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),j=k[a]||[],n=j[0]===w&&j[1],t=n&&j[2],m=n&&q.childNodes[n];while(m=++n&&m&&m[p]||(t=n=0)||o.pop())if(1===m.nodeType&&++t&&m===b){k[a]=[w,n,t];break}}else if(s&&(m=b,l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),j=k[a]||[],n=j[0]===w&&j[1],t=n),t===!1)while(m=++n&&m&&m[p]||(t=n=0)||o.pop())if((h?m.nodeName.toLowerCase()===r:1===m.nodeType)&&++t&&(s&&(l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),k[a]=[w,t]),m===b))break;return t-=e,t===d||t%d===0&&t/d>=0}}},PSEUDO:function(a,b){var c,e=d.pseudos[a]||d.setFilters[a.toLowerCase()]||fa.error("unsupported pseudo: "+a);return e[u]?e(b):e.length>1?(c=[a,a,"",b],d.setFilters.hasOwnProperty(a.toLowerCase())?ha(function(a,c){var d,f=e(a,b),g=f.length;while(g--)d=J(a,f[g]),a[d]=!(c[d]=f[g])}):function(a){return e(a,0,c)}):e}},pseudos:{not:ha(function(a){var b=[],c=[],d=h(a.replace(Q,"$1"));return d[u]?ha(function(a,b,c,e){var f,g=d(a,null,e,[]),h=a.length;while(h--)(f=g[h])&&(a[h]=!(b[h]=f))}):function(a,e,f){return b[0]=a,d(b,null,f,c),b[0]=null,!c.pop()}}),has:ha(function(a){return function(b){return fa(a,b).length>0}}),contains:ha(function(a){return a=a.replace(ba,ca),function(b){return(b.textContent||b.innerText||e(b)).indexOf(a)>-1}}),lang:ha(function(a){return V.test(a||"")||fa.error("unsupported lang: "+a),a=a.replace(ba,ca).toLowerCase(),function(b){var c;do if(c=p?b.lang:b.getAttribute("xml:lang")||b.getAttribute("lang"))return c=c.toLowerCase(),c===a||0===c.indexOf(a+"-");while((b=b.parentNode)&&1===b.nodeType);return!1}}),target:function(b){var c=a.location&&a.location.hash;return c&&c.slice(1)===b.id},root:function(a){return a===o},focus:function(a){return a===n.activeElement&&(!n.hasFocus||n.hasFocus())&&!!(a.type||a.href||~a.tabIndex)},enabled:function(a){return a.disabled===!1},disabled:function(a){return a.disabled===!0},checked:function(a){var b=a.nodeName.toLowerCase();return"input"===b&&!!a.checked||"option"===b&&!!a.selected},selected:function(a){return a.parentNode&&a.parentNode.selectedIndex,a.selected===!0},empty:function(a){for(a=a.firstChild;a;a=a.nextSibling)if(a.nodeType<6)return!1;return!0},parent:function(a){return!d.pseudos.empty(a)},header:function(a){return Y.test(a.nodeName)},input:function(a){return X.test(a.nodeName)},button:function(a){var b=a.nodeName.toLowerCase();return"input"===b&&"button"===a.type||"button"===b},text:function(a){var b;return"input"===a.nodeName.toLowerCase()&&"text"===a.type&&(null==(b=a.getAttribute("type"))||"text"===b.toLowerCase())},first:na(function(){return[0]}),last:na(function(a,b){return[b-1]}),eq:na(function(a,b,c){return[0>c?c+b:c]}),even:na(function(a,b){for(var c=0;b>c;c+=2)a.push(c);return a}),odd:na(function(a,b){for(var c=1;b>c;c+=2)a.push(c);return a}),lt:na(function(a,b,c){for(var d=0>c?c+b:c;--d>=0;)a.push(d);return a}),gt:na(function(a,b,c){for(var d=0>c?c+b:c;++d<b;)a.push(d);return a})}},d.pseudos.nth=d.pseudos.eq;for(b in{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})d.pseudos[b]=la(b);for(b in{submit:!0,reset:!0})d.pseudos[b]=ma(b);function pa(){}pa.prototype=d.filters=d.pseudos,d.setFilters=new pa,g=fa.tokenize=function(a,b){var c,e,f,g,h,i,j,k=z[a+" "];if(k)return b?0:k.slice(0);h=a,i=[],j=d.preFilter;while(h){c&&!(e=R.exec(h))||(e&&(h=h.slice(e[0].length)||h),i.push(f=[])),c=!1,(e=S.exec(h))&&(c=e.shift(),f.push({value:c,type:e[0].replace(Q," ")}),h=h.slice(c.length));for(g in d.filter)!(e=W[g].exec(h))||j[g]&&!(e=j[g](e))||(c=e.shift(),f.push({value:c,type:g,matches:e}),h=h.slice(c.length));if(!c)break}return b?h.length:h?fa.error(a):z(a,i).slice(0)};function qa(a){for(var b=0,c=a.length,d="";c>b;b++)d+=a[b].value;return d}function ra(a,b,c){var d=b.dir,e=c&&"parentNode"===d,f=x++;return b.first?function(b,c,f){while(b=b[d])if(1===b.nodeType||e)return a(b,c,f)}:function(b,c,g){var h,i,j,k=[w,f];if(g){while(b=b[d])if((1===b.nodeType||e)&&a(b,c,g))return!0}else while(b=b[d])if(1===b.nodeType||e){if(j=b[u]||(b[u]={}),i=j[b.uniqueID]||(j[b.uniqueID]={}),(h=i[d])&&h[0]===w&&h[1]===f)return k[2]=h[2];if(i[d]=k,k[2]=a(b,c,g))return!0}}}function sa(a){return a.length>1?function(b,c,d){var e=a.length;while(e--)if(!a[e](b,c,d))return!1;return!0}:a[0]}function ta(a,b,c){for(var d=0,e=b.length;e>d;d++)fa(a,b[d],c);return c}function ua(a,b,c,d,e){for(var f,g=[],h=0,i=a.length,j=null!=b;i>h;h++)(f=a[h])&&(c&&!c(f,d,e)||(g.push(f),j&&b.push(h)));return g}function va(a,b,c,d,e,f){return d&&!d[u]&&(d=va(d)),e&&!e[u]&&(e=va(e,f)),ha(function(f,g,h,i){var j,k,l,m=[],n=[],o=g.length,p=f||ta(b||"*",h.nodeType?[h]:h,[]),q=!a||!f&&b?p:ua(p,m,a,h,i),r=c?e||(f?a:o||d)?[]:g:q;if(c&&c(q,r,h,i),d){j=ua(r,n),d(j,[],h,i),k=j.length;while(k--)(l=j[k])&&(r[n[k]]=!(q[n[k]]=l))}if(f){if(e||a){if(e){j=[],k=r.length;while(k--)(l=r[k])&&j.push(q[k]=l);e(null,r=[],j,i)}k=r.length;while(k--)(l=r[k])&&(j=e?J(f,l):m[k])>-1&&(f[j]=!(g[j]=l))}}else r=ua(r===g?r.splice(o,r.length):r),e?e(null,g,r,i):H.apply(g,r)})}function wa(a){for(var b,c,e,f=a.length,g=d.relative[a[0].type],h=g||d.relative[" "],i=g?1:0,k=ra(function(a){return a===b},h,!0),l=ra(function(a){return J(b,a)>-1},h,!0),m=[function(a,c,d){var e=!g&&(d||c!==j)||((b=c).nodeType?k(a,c,d):l(a,c,d));return b=null,e}];f>i;i++)if(c=d.relative[a[i].type])m=[ra(sa(m),c)];else{if(c=d.filter[a[i].type].apply(null,a[i].matches),c[u]){for(e=++i;f>e;e++)if(d.relative[a[e].type])break;return va(i>1&&sa(m),i>1&&qa(a.slice(0,i-1).concat({value:" "===a[i-2].type?"*":""})).replace(Q,"$1"),c,e>i&&wa(a.slice(i,e)),f>e&&wa(a=a.slice(e)),f>e&&qa(a))}m.push(c)}return sa(m)}function xa(a,b){var c=b.length>0,e=a.length>0,f=function(f,g,h,i,k){var l,o,q,r=0,s="0",t=f&&[],u=[],v=j,x=f||e&&d.find.TAG("*",k),y=w+=null==v?1:Math.random()||.1,z=x.length;for(k&&(j=g===n||g||k);s!==z&&null!=(l=x[s]);s++){if(e&&l){o=0,g||l.ownerDocument===n||(m(l),h=!p);while(q=a[o++])if(q(l,g||n,h)){i.push(l);break}k&&(w=y)}c&&((l=!q&&l)&&r--,f&&t.push(l))}if(r+=s,c&&s!==r){o=0;while(q=b[o++])q(t,u,g,h);if(f){if(r>0)while(s--)t[s]||u[s]||(u[s]=F.call(i));u=ua(u)}H.apply(i,u),k&&!f&&u.length>0&&r+b.length>1&&fa.uniqueSort(i)}return k&&(w=y,j=v),t};return c?ha(f):f}return h=fa.compile=function(a,b){var c,d=[],e=[],f=A[a+" "];if(!f){b||(b=g(a)),c=b.length;while(c--)f=wa(b[c]),f[u]?d.push(f):e.push(f);f=A(a,xa(e,d)),f.selector=a}return f},i=fa.select=function(a,b,e,f){var i,j,k,l,m,n="function"==typeof a&&a,o=!f&&g(a=n.selector||a);if(e=e||[],1===o.length){if(j=o[0]=o[0].slice(0),j.length>2&&"ID"===(k=j[0]).type&&c.getById&&9===b.nodeType&&p&&d.relative[j[1].type]){if(b=(d.find.ID(k.matches[0].replace(ba,ca),b)||[])[0],!b)return e;n&&(b=b.parentNode),a=a.slice(j.shift().value.length)}i=W.needsContext.test(a)?0:j.length;while(i--){if(k=j[i],d.relative[l=k.type])break;if((m=d.find[l])&&(f=m(k.matches[0].replace(ba,ca),_.test(j[0].type)&&oa(b.parentNode)||b))){if(j.splice(i,1),a=f.length&&qa(j),!a)return H.apply(e,f),e;break}}}return(n||h(a,o))(f,b,!p,e,!b||_.test(a)&&oa(b.parentNode)||b),e},c.sortStable=u.split("").sort(B).join("")===u,c.detectDuplicates=!!l,m(),c.sortDetached=ia(function(a){return 1&a.compareDocumentPosition(n.createElement("div"))}),ia(function(a){return a.innerHTML="<a href='#'></a>","#"===a.firstChild.getAttribute("href")})||ja("type|href|height|width",function(a,b,c){return c?void 0:a.getAttribute(b,"type"===b.toLowerCase()?1:2)}),c.attributes&&ia(function(a){return a.innerHTML="<input/>",a.firstChild.setAttribute("value",""),""===a.firstChild.getAttribute("value")})||ja("value",function(a,b,c){return c||"input"!==a.nodeName.toLowerCase()?void 0:a.defaultValue}),ia(function(a){return null==a.getAttribute("disabled")})||ja(K,function(a,b,c){var d;return c?void 0:a[b]===!0?b.toLowerCase():(d=a.getAttributeNode(b))&&d.specified?d.value:null}),fa}(a);n.find=t,n.expr=t.selectors,n.expr[":"]=n.expr.pseudos,n.uniqueSort=n.unique=t.uniqueSort,n.text=t.getText,n.isXMLDoc=t.isXML,n.contains=t.contains;var u=function(a,b,c){var d=[],e=void 0!==c;while((a=a[b])&&9!==a.nodeType)if(1===a.nodeType){if(e&&n(a).is(c))break;d.push(a)}return d},v=function(a,b){for(var c=[];a;a=a.nextSibling)1===a.nodeType&&a!==b&&c.push(a);return c},w=n.expr.match.needsContext,x=/^<([\w-]+)\s*\/?>(?:<\/\1>|)$/,y=/^.[^:#\[\.,]*$/;function z(a,b,c){if(n.isFunction(b))return n.grep(a,function(a,d){return!!b.call(a,d,a)!==c});if(b.nodeType)return n.grep(a,function(a){return a===b!==c});if("string"==typeof b){if(y.test(b))return n.filter(b,a,c);b=n.filter(b,a)}return n.grep(a,function(a){return h.call(b,a)>-1!==c})}n.filter=function(a,b,c){var d=b[0];return c&&(a=":not("+a+")"),1===b.length&&1===d.nodeType?n.find.matchesSelector(d,a)?[d]:[]:n.find.matches(a,n.grep(b,function(a){return 1===a.nodeType}))},n.fn.extend({find:function(a){var b,c=this.length,d=[],e=this;if("string"!=typeof a)return this.pushStack(n(a).filter(function(){for(b=0;c>b;b++)if(n.contains(e[b],this))return!0}));for(b=0;c>b;b++)n.find(a,e[b],d);return d=this.pushStack(c>1?n.unique(d):d),d.selector=this.selector?this.selector+" "+a:a,d},filter:function(a){return this.pushStack(z(this,a||[],!1))},not:function(a){return this.pushStack(z(this,a||[],!0))},is:function(a){return!!z(this,"string"==typeof a&&w.test(a)?n(a):a||[],!1).length}});var A,B=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,C=n.fn.init=function(a,b,c){var e,f;if(!a)return this;if(c=c||A,"string"==typeof a){if(e="<"===a[0]&&">"===a[a.length-1]&&a.length>=3?[null,a,null]:B.exec(a),!e||!e[1]&&b)return!b||b.jquery?(b||c).find(a):this.constructor(b).find(a);if(e[1]){if(b=b instanceof n?b[0]:b,n.merge(this,n.parseHTML(e[1],b&&b.nodeType?b.ownerDocument||b:d,!0)),x.test(e[1])&&n.isPlainObject(b))for(e in b)n.isFunction(this[e])?this[e](b[e]):this.attr(e,b[e]);return this}return f=d.getElementById(e[2]),f&&f.parentNode&&(this.length=1,this[0]=f),this.context=d,this.selector=a,this}return a.nodeType?(this.context=this[0]=a,this.length=1,this):n.isFunction(a)?void 0!==c.ready?c.ready(a):a(n):(void 0!==a.selector&&(this.selector=a.selector,this.context=a.context),n.makeArray(a,this))};C.prototype=n.fn,A=n(d);var D=/^(?:parents|prev(?:Until|All))/,E={children:!0,contents:!0,next:!0,prev:!0};n.fn.extend({has:function(a){var b=n(a,this),c=b.length;return this.filter(function(){for(var a=0;c>a;a++)if(n.contains(this,b[a]))return!0})},closest:function(a,b){for(var c,d=0,e=this.length,f=[],g=w.test(a)||"string"!=typeof a?n(a,b||this.context):0;e>d;d++)for(c=this[d];c&&c!==b;c=c.parentNode)if(c.nodeType<11&&(g?g.index(c)>-1:1===c.nodeType&&n.find.matchesSelector(c,a))){f.push(c);break}return this.pushStack(f.length>1?n.uniqueSort(f):f)},index:function(a){return a?"string"==typeof a?h.call(n(a),this[0]):h.call(this,a.jquery?a[0]:a):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(a,b){return this.pushStack(n.uniqueSort(n.merge(this.get(),n(a,b))))},addBack:function(a){return this.add(null==a?this.prevObject:this.prevObject.filter(a))}});function F(a,b){while((a=a[b])&&1!==a.nodeType);return a}n.each({parent:function(a){var b=a.parentNode;return b&&11!==b.nodeType?b:null},parents:function(a){return u(a,"parentNode")},parentsUntil:function(a,b,c){return u(a,"parentNode",c)},next:function(a){return F(a,"nextSibling")},prev:function(a){return F(a,"previousSibling")},nextAll:function(a){return u(a,"nextSibling")},prevAll:function(a){return u(a,"previousSibling")},nextUntil:function(a,b,c){return u(a,"nextSibling",c)},prevUntil:function(a,b,c){return u(a,"previousSibling",c)},siblings:function(a){return v((a.parentNode||{}).firstChild,a)},children:function(a){return v(a.firstChild)},contents:function(a){return a.contentDocument||n.merge([],a.childNodes)}},function(a,b){n.fn[a]=function(c,d){var e=n.map(this,b,c);return"Until"!==a.slice(-5)&&(d=c),d&&"string"==typeof d&&(e=n.filter(d,e)),this.length>1&&(E[a]||n.uniqueSort(e),D.test(a)&&e.reverse()),this.pushStack(e)}});var G=/\S+/g;function H(a){var b={};return n.each(a.match(G)||[],function(a,c){b[c]=!0}),b}n.Callbacks=function(a){a="string"==typeof a?H(a):n.extend({},a);var b,c,d,e,f=[],g=[],h=-1,i=function(){for(e=a.once,d=b=!0;g.length;h=-1){c=g.shift();while(++h<f.length)f[h].apply(c[0],c[1])===!1&&a.stopOnFalse&&(h=f.length,c=!1)}a.memory||(c=!1),b=!1,e&&(f=c?[]:"")},j={add:function(){return f&&(c&&!b&&(h=f.length-1,g.push(c)),function d(b){n.each(b,function(b,c){n.isFunction(c)?a.unique&&j.has(c)||f.push(c):c&&c.length&&"string"!==n.type(c)&&d(c)})}(arguments),c&&!b&&i()),this},remove:function(){return n.each(arguments,function(a,b){var c;while((c=n.inArray(b,f,c))>-1)f.splice(c,1),h>=c&&h--}),this},has:function(a){return a?n.inArray(a,f)>-1:f.length>0},empty:function(){return f&&(f=[]),this},disable:function(){return e=g=[],f=c="",this},disabled:function(){return!f},lock:function(){return e=g=[],c||(f=c=""),this},locked:function(){return!!e},fireWith:function(a,c){return e||(c=c||[],c=[a,c.slice?c.slice():c],g.push(c),b||i()),this},fire:function(){return j.fireWith(this,arguments),this},fired:function(){return!!d}};return j},n.extend({Deferred:function(a){var b=[["resolve","done",n.Callbacks("once memory"),"resolved"],["reject","fail",n.Callbacks("once memory"),"rejected"],["notify","progress",n.Callbacks("memory")]],c="pending",d={state:function(){return c},always:function(){return e.done(arguments).fail(arguments),this},then:function(){var a=arguments;return n.Deferred(function(c){n.each(b,function(b,f){var g=n.isFunction(a[b])&&a[b];e[f[1]](function(){var a=g&&g.apply(this,arguments);a&&n.isFunction(a.promise)?a.promise().progress(c.notify).done(c.resolve).fail(c.reject):c[f[0]+"With"](this===d?c.promise():this,g?[a]:arguments)})}),a=null}).promise()},promise:function(a){return null!=a?n.extend(a,d):d}},e={};return d.pipe=d.then,n.each(b,function(a,f){var g=f[2],h=f[3];d[f[1]]=g.add,h&&g.add(function(){c=h},b[1^a][2].disable,b[2][2].lock),e[f[0]]=function(){return e[f[0]+"With"](this===e?d:this,arguments),this},e[f[0]+"With"]=g.fireWith}),d.promise(e),a&&a.call(e,e),e},when:function(a){var b=0,c=e.call(arguments),d=c.length,f=1!==d||a&&n.isFunction(a.promise)?d:0,g=1===f?a:n.Deferred(),h=function(a,b,c){return function(d){b[a]=this,c[a]=arguments.length>1?e.call(arguments):d,c===i?g.notifyWith(b,c):--f||g.resolveWith(b,c)}},i,j,k;if(d>1)for(i=new Array(d),j=new Array(d),k=new Array(d);d>b;b++)c[b]&&n.isFunction(c[b].promise)?c[b].promise().progress(h(b,j,i)).done(h(b,k,c)).fail(g.reject):--f;return f||g.resolveWith(k,c),g.promise()}});var I;n.fn.ready=function(a){return n.ready.promise().done(a),this},n.extend({isReady:!1,readyWait:1,holdReady:function(a){a?n.readyWait++:n.ready(!0)},ready:function(a){(a===!0?--n.readyWait:n.isReady)||(n.isReady=!0,a!==!0&&--n.readyWait>0||(I.resolveWith(d,[n]),n.fn.triggerHandler&&(n(d).triggerHandler("ready"),n(d).off("ready"))))}});function J(){d.removeEventListener("DOMContentLoaded",J),a.removeEventListener("load",J),n.ready()}n.ready.promise=function(b){return I||(I=n.Deferred(),"complete"===d.readyState||"loading"!==d.readyState&&!d.documentElement.doScroll?a.setTimeout(n.ready):(d.addEventListener("DOMContentLoaded",J),a.addEventListener("load",J))),I.promise(b)},n.ready.promise();var K=function(a,b,c,d,e,f,g){var h=0,i=a.length,j=null==c;if("object"===n.type(c)){e=!0;for(h in c)K(a,b,h,c[h],!0,f,g)}else if(void 0!==d&&(e=!0,n.isFunction(d)||(g=!0),j&&(g?(b.call(a,d),b=null):(j=b,b=function(a,b,c){return j.call(n(a),c)})),b))for(;i>h;h++)b(a[h],c,g?d:d.call(a[h],h,b(a[h],c)));return e?a:j?b.call(a):i?b(a[0],c):f},L=function(a){return 1===a.nodeType||9===a.nodeType||!+a.nodeType};function M(){this.expando=n.expando+M.uid++}M.uid=1,M.prototype={register:function(a,b){var c=b||{};return a.nodeType?a[this.expando]=c:Object.defineProperty(a,this.expando,{value:c,writable:!0,configurable:!0}),a[this.expando]},cache:function(a){if(!L(a))return{};var b=a[this.expando];return b||(b={},L(a)&&(a.nodeType?a[this.expando]=b:Object.defineProperty(a,this.expando,{value:b,configurable:!0}))),b},set:function(a,b,c){var d,e=this.cache(a);if("string"==typeof b)e[b]=c;else for(d in b)e[d]=b[d];return e},get:function(a,b){return void 0===b?this.cache(a):a[this.expando]&&a[this.expando][b]},access:function(a,b,c){var d;return void 0===b||b&&"string"==typeof b&&void 0===c?(d=this.get(a,b),void 0!==d?d:this.get(a,n.camelCase(b))):(this.set(a,b,c),void 0!==c?c:b)},remove:function(a,b){var c,d,e,f=a[this.expando];if(void 0!==f){if(void 0===b)this.register(a);else{n.isArray(b)?d=b.concat(b.map(n.camelCase)):(e=n.camelCase(b),b in f?d=[b,e]:(d=e,d=d in f?[d]:d.match(G)||[])),c=d.length;while(c--)delete f[d[c]]}(void 0===b||n.isEmptyObject(f))&&(a.nodeType?a[this.expando]=void 0:delete a[this.expando])}},hasData:function(a){var b=a[this.expando];return void 0!==b&&!n.isEmptyObject(b)}};var N=new M,O=new M,P=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,Q=/[A-Z]/g;function R(a,b,c){var d;if(void 0===c&&1===a.nodeType)if(d="data-"+b.replace(Q,"-$&").toLowerCase(),c=a.getAttribute(d),"string"==typeof c){try{c="true"===c?!0:"false"===c?!1:"null"===c?null:+c+""===c?+c:P.test(c)?n.parseJSON(c):c;
}catch(e){}O.set(a,b,c)}else c=void 0;return c}n.extend({hasData:function(a){return O.hasData(a)||N.hasData(a)},data:function(a,b,c){return O.access(a,b,c)},removeData:function(a,b){O.remove(a,b)},_data:function(a,b,c){return N.access(a,b,c)},_removeData:function(a,b){N.remove(a,b)}}),n.fn.extend({data:function(a,b){var c,d,e,f=this[0],g=f&&f.attributes;if(void 0===a){if(this.length&&(e=O.get(f),1===f.nodeType&&!N.get(f,"hasDataAttrs"))){c=g.length;while(c--)g[c]&&(d=g[c].name,0===d.indexOf("data-")&&(d=n.camelCase(d.slice(5)),R(f,d,e[d])));N.set(f,"hasDataAttrs",!0)}return e}return"object"==typeof a?this.each(function(){O.set(this,a)}):K(this,function(b){var c,d;if(f&&void 0===b){if(c=O.get(f,a)||O.get(f,a.replace(Q,"-$&").toLowerCase()),void 0!==c)return c;if(d=n.camelCase(a),c=O.get(f,d),void 0!==c)return c;if(c=R(f,d,void 0),void 0!==c)return c}else d=n.camelCase(a),this.each(function(){var c=O.get(this,d);O.set(this,d,b),a.indexOf("-")>-1&&void 0!==c&&O.set(this,a,b)})},null,b,arguments.length>1,null,!0)},removeData:function(a){return this.each(function(){O.remove(this,a)})}}),n.extend({queue:function(a,b,c){var d;return a?(b=(b||"fx")+"queue",d=N.get(a,b),c&&(!d||n.isArray(c)?d=N.access(a,b,n.makeArray(c)):d.push(c)),d||[]):void 0},dequeue:function(a,b){b=b||"fx";var c=n.queue(a,b),d=c.length,e=c.shift(),f=n._queueHooks(a,b),g=function(){n.dequeue(a,b)};"inprogress"===e&&(e=c.shift(),d--),e&&("fx"===b&&c.unshift("inprogress"),delete f.stop,e.call(a,g,f)),!d&&f&&f.empty.fire()},_queueHooks:function(a,b){var c=b+"queueHooks";return N.get(a,c)||N.access(a,c,{empty:n.Callbacks("once memory").add(function(){N.remove(a,[b+"queue",c])})})}}),n.fn.extend({queue:function(a,b){var c=2;return"string"!=typeof a&&(b=a,a="fx",c--),arguments.length<c?n.queue(this[0],a):void 0===b?this:this.each(function(){var c=n.queue(this,a,b);n._queueHooks(this,a),"fx"===a&&"inprogress"!==c[0]&&n.dequeue(this,a)})},dequeue:function(a){return this.each(function(){n.dequeue(this,a)})},clearQueue:function(a){return this.queue(a||"fx",[])},promise:function(a,b){var c,d=1,e=n.Deferred(),f=this,g=this.length,h=function(){--d||e.resolveWith(f,[f])};"string"!=typeof a&&(b=a,a=void 0),a=a||"fx";while(g--)c=N.get(f[g],a+"queueHooks"),c&&c.empty&&(d++,c.empty.add(h));return h(),e.promise(b)}});var S=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,T=new RegExp("^(?:([+-])=|)("+S+")([a-z%]*)$","i"),U=["Top","Right","Bottom","Left"],V=function(a,b){return a=b||a,"none"===n.css(a,"display")||!n.contains(a.ownerDocument,a)};function W(a,b,c,d){var e,f=1,g=20,h=d?function(){return d.cur()}:function(){return n.css(a,b,"")},i=h(),j=c&&c[3]||(n.cssNumber[b]?"":"px"),k=(n.cssNumber[b]||"px"!==j&&+i)&&T.exec(n.css(a,b));if(k&&k[3]!==j){j=j||k[3],c=c||[],k=+i||1;do f=f||".5",k/=f,n.style(a,b,k+j);while(f!==(f=h()/i)&&1!==f&&--g)}return c&&(k=+k||+i||0,e=c[1]?k+(c[1]+1)*c[2]:+c[2],d&&(d.unit=j,d.start=k,d.end=e)),e}var X=/^(?:checkbox|radio)$/i,Y=/<([\w:-]+)/,Z=/^$|\/(?:java|ecma)script/i,$={option:[1,"<select multiple='multiple'>","</select>"],thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};$.optgroup=$.option,$.tbody=$.tfoot=$.colgroup=$.caption=$.thead,$.th=$.td;function _(a,b){var c="undefined"!=typeof a.getElementsByTagName?a.getElementsByTagName(b||"*"):"undefined"!=typeof a.querySelectorAll?a.querySelectorAll(b||"*"):[];return void 0===b||b&&n.nodeName(a,b)?n.merge([a],c):c}function aa(a,b){for(var c=0,d=a.length;d>c;c++)N.set(a[c],"globalEval",!b||N.get(b[c],"globalEval"))}var ba=/<|&#?\w+;/;function ca(a,b,c,d,e){for(var f,g,h,i,j,k,l=b.createDocumentFragment(),m=[],o=0,p=a.length;p>o;o++)if(f=a[o],f||0===f)if("object"===n.type(f))n.merge(m,f.nodeType?[f]:f);else if(ba.test(f)){g=g||l.appendChild(b.createElement("div")),h=(Y.exec(f)||["",""])[1].toLowerCase(),i=$[h]||$._default,g.innerHTML=i[1]+n.htmlPrefilter(f)+i[2],k=i[0];while(k--)g=g.lastChild;n.merge(m,g.childNodes),g=l.firstChild,g.textContent=""}else m.push(b.createTextNode(f));l.textContent="",o=0;while(f=m[o++])if(d&&n.inArray(f,d)>-1)e&&e.push(f);else if(j=n.contains(f.ownerDocument,f),g=_(l.appendChild(f),"script"),j&&aa(g),c){k=0;while(f=g[k++])Z.test(f.type||"")&&c.push(f)}return l}!function(){var a=d.createDocumentFragment(),b=a.appendChild(d.createElement("div")),c=d.createElement("input");c.setAttribute("type","radio"),c.setAttribute("checked","checked"),c.setAttribute("name","t"),b.appendChild(c),l.checkClone=b.cloneNode(!0).cloneNode(!0).lastChild.checked,b.innerHTML="<textarea>x</textarea>",l.noCloneChecked=!!b.cloneNode(!0).lastChild.defaultValue}();var da=/^key/,ea=/^(?:mouse|pointer|contextmenu|drag|drop)|click/,fa=/^([^.]*)(?:\.(.+)|)/;function ga(){return!0}function ha(){return!1}function ia(){try{return d.activeElement}catch(a){}}function ja(a,b,c,d,e,f){var g,h;if("object"==typeof b){"string"!=typeof c&&(d=d||c,c=void 0);for(h in b)ja(a,h,c,d,b[h],f);return a}if(null==d&&null==e?(e=c,d=c=void 0):null==e&&("string"==typeof c?(e=d,d=void 0):(e=d,d=c,c=void 0)),e===!1)e=ha;else if(!e)return a;return 1===f&&(g=e,e=function(a){return n().off(a),g.apply(this,arguments)},e.guid=g.guid||(g.guid=n.guid++)),a.each(function(){n.event.add(this,b,e,d,c)})}n.event={global:{},add:function(a,b,c,d,e){var f,g,h,i,j,k,l,m,o,p,q,r=N.get(a);if(r){c.handler&&(f=c,c=f.handler,e=f.selector),c.guid||(c.guid=n.guid++),(i=r.events)||(i=r.events={}),(g=r.handle)||(g=r.handle=function(b){return"undefined"!=typeof n&&n.event.triggered!==b.type?n.event.dispatch.apply(a,arguments):void 0}),b=(b||"").match(G)||[""],j=b.length;while(j--)h=fa.exec(b[j])||[],o=q=h[1],p=(h[2]||"").split(".").sort(),o&&(l=n.event.special[o]||{},o=(e?l.delegateType:l.bindType)||o,l=n.event.special[o]||{},k=n.extend({type:o,origType:q,data:d,handler:c,guid:c.guid,selector:e,needsContext:e&&n.expr.match.needsContext.test(e),namespace:p.join(".")},f),(m=i[o])||(m=i[o]=[],m.delegateCount=0,l.setup&&l.setup.call(a,d,p,g)!==!1||a.addEventListener&&a.addEventListener(o,g)),l.add&&(l.add.call(a,k),k.handler.guid||(k.handler.guid=c.guid)),e?m.splice(m.delegateCount++,0,k):m.push(k),n.event.global[o]=!0)}},remove:function(a,b,c,d,e){var f,g,h,i,j,k,l,m,o,p,q,r=N.hasData(a)&&N.get(a);if(r&&(i=r.events)){b=(b||"").match(G)||[""],j=b.length;while(j--)if(h=fa.exec(b[j])||[],o=q=h[1],p=(h[2]||"").split(".").sort(),o){l=n.event.special[o]||{},o=(d?l.delegateType:l.bindType)||o,m=i[o]||[],h=h[2]&&new RegExp("(^|\\.)"+p.join("\\.(?:.*\\.|)")+"(\\.|$)"),g=f=m.length;while(f--)k=m[f],!e&&q!==k.origType||c&&c.guid!==k.guid||h&&!h.test(k.namespace)||d&&d!==k.selector&&("**"!==d||!k.selector)||(m.splice(f,1),k.selector&&m.delegateCount--,l.remove&&l.remove.call(a,k));g&&!m.length&&(l.teardown&&l.teardown.call(a,p,r.handle)!==!1||n.removeEvent(a,o,r.handle),delete i[o])}else for(o in i)n.event.remove(a,o+b[j],c,d,!0);n.isEmptyObject(i)&&N.remove(a,"handle events")}},dispatch:function(a){a=n.event.fix(a);var b,c,d,f,g,h=[],i=e.call(arguments),j=(N.get(this,"events")||{})[a.type]||[],k=n.event.special[a.type]||{};if(i[0]=a,a.delegateTarget=this,!k.preDispatch||k.preDispatch.call(this,a)!==!1){h=n.event.handlers.call(this,a,j),b=0;while((f=h[b++])&&!a.isPropagationStopped()){a.currentTarget=f.elem,c=0;while((g=f.handlers[c++])&&!a.isImmediatePropagationStopped())a.rnamespace&&!a.rnamespace.test(g.namespace)||(a.handleObj=g,a.data=g.data,d=((n.event.special[g.origType]||{}).handle||g.handler).apply(f.elem,i),void 0!==d&&(a.result=d)===!1&&(a.preventDefault(),a.stopPropagation()))}return k.postDispatch&&k.postDispatch.call(this,a),a.result}},handlers:function(a,b){var c,d,e,f,g=[],h=b.delegateCount,i=a.target;if(h&&i.nodeType&&("click"!==a.type||isNaN(a.button)||a.button<1))for(;i!==this;i=i.parentNode||this)if(1===i.nodeType&&(i.disabled!==!0||"click"!==a.type)){for(d=[],c=0;h>c;c++)f=b[c],e=f.selector+" ",void 0===d[e]&&(d[e]=f.needsContext?n(e,this).index(i)>-1:n.find(e,this,null,[i]).length),d[e]&&d.push(f);d.length&&g.push({elem:i,handlers:d})}return h<b.length&&g.push({elem:this,handlers:b.slice(h)}),g},props:"altKey bubbles cancelable ctrlKey currentTarget detail eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),fixHooks:{},keyHooks:{props:"char charCode key keyCode".split(" "),filter:function(a,b){return null==a.which&&(a.which=null!=b.charCode?b.charCode:b.keyCode),a}},mouseHooks:{props:"button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(" "),filter:function(a,b){var c,e,f,g=b.button;return null==a.pageX&&null!=b.clientX&&(c=a.target.ownerDocument||d,e=c.documentElement,f=c.body,a.pageX=b.clientX+(e&&e.scrollLeft||f&&f.scrollLeft||0)-(e&&e.clientLeft||f&&f.clientLeft||0),a.pageY=b.clientY+(e&&e.scrollTop||f&&f.scrollTop||0)-(e&&e.clientTop||f&&f.clientTop||0)),a.which||void 0===g||(a.which=1&g?1:2&g?3:4&g?2:0),a}},fix:function(a){if(a[n.expando])return a;var b,c,e,f=a.type,g=a,h=this.fixHooks[f];h||(this.fixHooks[f]=h=ea.test(f)?this.mouseHooks:da.test(f)?this.keyHooks:{}),e=h.props?this.props.concat(h.props):this.props,a=new n.Event(g),b=e.length;while(b--)c=e[b],a[c]=g[c];return a.target||(a.target=d),3===a.target.nodeType&&(a.target=a.target.parentNode),h.filter?h.filter(a,g):a},special:{load:{noBubble:!0},focus:{trigger:function(){return this!==ia()&&this.focus?(this.focus(),!1):void 0},delegateType:"focusin"},blur:{trigger:function(){return this===ia()&&this.blur?(this.blur(),!1):void 0},delegateType:"focusout"},click:{trigger:function(){return"checkbox"===this.type&&this.click&&n.nodeName(this,"input")?(this.click(),!1):void 0},_default:function(a){return n.nodeName(a.target,"a")}},beforeunload:{postDispatch:function(a){void 0!==a.result&&a.originalEvent&&(a.originalEvent.returnValue=a.result)}}}},n.removeEvent=function(a,b,c){a.removeEventListener&&a.removeEventListener(b,c)},n.Event=function(a,b){return this instanceof n.Event?(a&&a.type?(this.originalEvent=a,this.type=a.type,this.isDefaultPrevented=a.defaultPrevented||void 0===a.defaultPrevented&&a.returnValue===!1?ga:ha):this.type=a,b&&n.extend(this,b),this.timeStamp=a&&a.timeStamp||n.now(),void(this[n.expando]=!0)):new n.Event(a,b)},n.Event.prototype={constructor:n.Event,isDefaultPrevented:ha,isPropagationStopped:ha,isImmediatePropagationStopped:ha,isSimulated:!1,preventDefault:function(){var a=this.originalEvent;this.isDefaultPrevented=ga,a&&!this.isSimulated&&a.preventDefault()},stopPropagation:function(){var a=this.originalEvent;this.isPropagationStopped=ga,a&&!this.isSimulated&&a.stopPropagation()},stopImmediatePropagation:function(){var a=this.originalEvent;this.isImmediatePropagationStopped=ga,a&&!this.isSimulated&&a.stopImmediatePropagation(),this.stopPropagation()}},n.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(a,b){n.event.special[a]={delegateType:b,bindType:b,handle:function(a){var c,d=this,e=a.relatedTarget,f=a.handleObj;return e&&(e===d||n.contains(d,e))||(a.type=f.origType,c=f.handler.apply(this,arguments),a.type=b),c}}}),n.fn.extend({on:function(a,b,c,d){return ja(this,a,b,c,d)},one:function(a,b,c,d){return ja(this,a,b,c,d,1)},off:function(a,b,c){var d,e;if(a&&a.preventDefault&&a.handleObj)return d=a.handleObj,n(a.delegateTarget).off(d.namespace?d.origType+"."+d.namespace:d.origType,d.selector,d.handler),this;if("object"==typeof a){for(e in a)this.off(e,b,a[e]);return this}return b!==!1&&"function"!=typeof b||(c=b,b=void 0),c===!1&&(c=ha),this.each(function(){n.event.remove(this,a,c,b)})}});var ka=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,la=/<script|<style|<link/i,ma=/checked\s*(?:[^=]|=\s*.checked.)/i,na=/^true\/(.*)/,oa=/^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;function pa(a,b){return n.nodeName(a,"table")&&n.nodeName(11!==b.nodeType?b:b.firstChild,"tr")?a.getElementsByTagName("tbody")[0]||a.appendChild(a.ownerDocument.createElement("tbody")):a}function qa(a){return a.type=(null!==a.getAttribute("type"))+"/"+a.type,a}function ra(a){var b=na.exec(a.type);return b?a.type=b[1]:a.removeAttribute("type"),a}function sa(a,b){var c,d,e,f,g,h,i,j;if(1===b.nodeType){if(N.hasData(a)&&(f=N.access(a),g=N.set(b,f),j=f.events)){delete g.handle,g.events={};for(e in j)for(c=0,d=j[e].length;d>c;c++)n.event.add(b,e,j[e][c])}O.hasData(a)&&(h=O.access(a),i=n.extend({},h),O.set(b,i))}}function ta(a,b){var c=b.nodeName.toLowerCase();"input"===c&&X.test(a.type)?b.checked=a.checked:"input"!==c&&"textarea"!==c||(b.defaultValue=a.defaultValue)}function ua(a,b,c,d){b=f.apply([],b);var e,g,h,i,j,k,m=0,o=a.length,p=o-1,q=b[0],r=n.isFunction(q);if(r||o>1&&"string"==typeof q&&!l.checkClone&&ma.test(q))return a.each(function(e){var f=a.eq(e);r&&(b[0]=q.call(this,e,f.html())),ua(f,b,c,d)});if(o&&(e=ca(b,a[0].ownerDocument,!1,a,d),g=e.firstChild,1===e.childNodes.length&&(e=g),g||d)){for(h=n.map(_(e,"script"),qa),i=h.length;o>m;m++)j=e,m!==p&&(j=n.clone(j,!0,!0),i&&n.merge(h,_(j,"script"))),c.call(a[m],j,m);if(i)for(k=h[h.length-1].ownerDocument,n.map(h,ra),m=0;i>m;m++)j=h[m],Z.test(j.type||"")&&!N.access(j,"globalEval")&&n.contains(k,j)&&(j.src?n._evalUrl&&n._evalUrl(j.src):n.globalEval(j.textContent.replace(oa,"")))}return a}function va(a,b,c){for(var d,e=b?n.filter(b,a):a,f=0;null!=(d=e[f]);f++)c||1!==d.nodeType||n.cleanData(_(d)),d.parentNode&&(c&&n.contains(d.ownerDocument,d)&&aa(_(d,"script")),d.parentNode.removeChild(d));return a}n.extend({htmlPrefilter:function(a){return a.replace(ka,"<$1></$2>")},clone:function(a,b,c){var d,e,f,g,h=a.cloneNode(!0),i=n.contains(a.ownerDocument,a);if(!(l.noCloneChecked||1!==a.nodeType&&11!==a.nodeType||n.isXMLDoc(a)))for(g=_(h),f=_(a),d=0,e=f.length;e>d;d++)ta(f[d],g[d]);if(b)if(c)for(f=f||_(a),g=g||_(h),d=0,e=f.length;e>d;d++)sa(f[d],g[d]);else sa(a,h);return g=_(h,"script"),g.length>0&&aa(g,!i&&_(a,"script")),h},cleanData:function(a){for(var b,c,d,e=n.event.special,f=0;void 0!==(c=a[f]);f++)if(L(c)){if(b=c[N.expando]){if(b.events)for(d in b.events)e[d]?n.event.remove(c,d):n.removeEvent(c,d,b.handle);c[N.expando]=void 0}c[O.expando]&&(c[O.expando]=void 0)}}}),n.fn.extend({domManip:ua,detach:function(a){return va(this,a,!0)},remove:function(a){return va(this,a)},text:function(a){return K(this,function(a){return void 0===a?n.text(this):this.empty().each(function(){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||(this.textContent=a)})},null,a,arguments.length)},append:function(){return ua(this,arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=pa(this,a);b.appendChild(a)}})},prepend:function(){return ua(this,arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=pa(this,a);b.insertBefore(a,b.firstChild)}})},before:function(){return ua(this,arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this)})},after:function(){return ua(this,arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this.nextSibling)})},empty:function(){for(var a,b=0;null!=(a=this[b]);b++)1===a.nodeType&&(n.cleanData(_(a,!1)),a.textContent="");return this},clone:function(a,b){return a=null==a?!1:a,b=null==b?a:b,this.map(function(){return n.clone(this,a,b)})},html:function(a){return K(this,function(a){var b=this[0]||{},c=0,d=this.length;if(void 0===a&&1===b.nodeType)return b.innerHTML;if("string"==typeof a&&!la.test(a)&&!$[(Y.exec(a)||["",""])[1].toLowerCase()]){a=n.htmlPrefilter(a);try{for(;d>c;c++)b=this[c]||{},1===b.nodeType&&(n.cleanData(_(b,!1)),b.innerHTML=a);b=0}catch(e){}}b&&this.empty().append(a)},null,a,arguments.length)},replaceWith:function(){var a=[];return ua(this,arguments,function(b){var c=this.parentNode;n.inArray(this,a)<0&&(n.cleanData(_(this)),c&&c.replaceChild(b,this))},a)}}),n.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(a,b){n.fn[a]=function(a){for(var c,d=[],e=n(a),f=e.length-1,h=0;f>=h;h++)c=h===f?this:this.clone(!0),n(e[h])[b](c),g.apply(d,c.get());return this.pushStack(d)}});var wa,xa={HTML:"block",BODY:"block"};function ya(a,b){var c=n(b.createElement(a)).appendTo(b.body),d=n.css(c[0],"display");return c.detach(),d}function za(a){var b=d,c=xa[a];return c||(c=ya(a,b),"none"!==c&&c||(wa=(wa||n("<iframe frameborder='0' width='0' height='0'/>")).appendTo(b.documentElement),b=wa[0].contentDocument,b.write(),b.close(),c=ya(a,b),wa.detach()),xa[a]=c),c}var Aa=/^margin/,Ba=new RegExp("^("+S+")(?!px)[a-z%]+$","i"),Ca=function(b){var c=b.ownerDocument.defaultView;return c&&c.opener||(c=a),c.getComputedStyle(b)},Da=function(a,b,c,d){var e,f,g={};for(f in b)g[f]=a.style[f],a.style[f]=b[f];e=c.apply(a,d||[]);for(f in b)a.style[f]=g[f];return e},Ea=d.documentElement;!function(){var b,c,e,f,g=d.createElement("div"),h=d.createElement("div");if(h.style){h.style.backgroundClip="content-box",h.cloneNode(!0).style.backgroundClip="",l.clearCloneStyle="content-box"===h.style.backgroundClip,g.style.cssText="border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute",g.appendChild(h);function i(){h.style.cssText="-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%",h.innerHTML="",Ea.appendChild(g);var d=a.getComputedStyle(h);b="1%"!==d.top,f="2px"===d.marginLeft,c="4px"===d.width,h.style.marginRight="50%",e="4px"===d.marginRight,Ea.removeChild(g)}n.extend(l,{pixelPosition:function(){return i(),b},boxSizingReliable:function(){return null==c&&i(),c},pixelMarginRight:function(){return null==c&&i(),e},reliableMarginLeft:function(){return null==c&&i(),f},reliableMarginRight:function(){var b,c=h.appendChild(d.createElement("div"));return c.style.cssText=h.style.cssText="-webkit-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0",c.style.marginRight=c.style.width="0",h.style.width="1px",Ea.appendChild(g),b=!parseFloat(a.getComputedStyle(c).marginRight),Ea.removeChild(g),h.removeChild(c),b}})}}();function Fa(a,b,c){var d,e,f,g,h=a.style;return c=c||Ca(a),g=c?c.getPropertyValue(b)||c[b]:void 0,""!==g&&void 0!==g||n.contains(a.ownerDocument,a)||(g=n.style(a,b)),c&&!l.pixelMarginRight()&&Ba.test(g)&&Aa.test(b)&&(d=h.width,e=h.minWidth,f=h.maxWidth,h.minWidth=h.maxWidth=h.width=g,g=c.width,h.width=d,h.minWidth=e,h.maxWidth=f),void 0!==g?g+"":g}function Ga(a,b){return{get:function(){return a()?void delete this.get:(this.get=b).apply(this,arguments)}}}var Ha=/^(none|table(?!-c[ea]).+)/,Ia={position:"absolute",visibility:"hidden",display:"block"},Ja={letterSpacing:"0",fontWeight:"400"},Ka=["Webkit","O","Moz","ms"],La=d.createElement("div").style;function Ma(a){if(a in La)return a;var b=a[0].toUpperCase()+a.slice(1),c=Ka.length;while(c--)if(a=Ka[c]+b,a in La)return a}function Na(a,b,c){var d=T.exec(b);return d?Math.max(0,d[2]-(c||0))+(d[3]||"px"):b}function Oa(a,b,c,d,e){for(var f=c===(d?"border":"content")?4:"width"===b?1:0,g=0;4>f;f+=2)"margin"===c&&(g+=n.css(a,c+U[f],!0,e)),d?("content"===c&&(g-=n.css(a,"padding"+U[f],!0,e)),"margin"!==c&&(g-=n.css(a,"border"+U[f]+"Width",!0,e))):(g+=n.css(a,"padding"+U[f],!0,e),"padding"!==c&&(g+=n.css(a,"border"+U[f]+"Width",!0,e)));return g}function Pa(a,b,c){var d=!0,e="width"===b?a.offsetWidth:a.offsetHeight,f=Ca(a),g="border-box"===n.css(a,"boxSizing",!1,f);if(0>=e||null==e){if(e=Fa(a,b,f),(0>e||null==e)&&(e=a.style[b]),Ba.test(e))return e;d=g&&(l.boxSizingReliable()||e===a.style[b]),e=parseFloat(e)||0}return e+Oa(a,b,c||(g?"border":"content"),d,f)+"px"}function Qa(a,b){for(var c,d,e,f=[],g=0,h=a.length;h>g;g++)d=a[g],d.style&&(f[g]=N.get(d,"olddisplay"),c=d.style.display,b?(f[g]||"none"!==c||(d.style.display=""),""===d.style.display&&V(d)&&(f[g]=N.access(d,"olddisplay",za(d.nodeName)))):(e=V(d),"none"===c&&e||N.set(d,"olddisplay",e?c:n.css(d,"display"))));for(g=0;h>g;g++)d=a[g],d.style&&(b&&"none"!==d.style.display&&""!==d.style.display||(d.style.display=b?f[g]||"":"none"));return a}n.extend({cssHooks:{opacity:{get:function(a,b){if(b){var c=Fa(a,"opacity");return""===c?"1":c}}}},cssNumber:{animationIterationCount:!0,columnCount:!0,fillOpacity:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{"float":"cssFloat"},style:function(a,b,c,d){if(a&&3!==a.nodeType&&8!==a.nodeType&&a.style){var e,f,g,h=n.camelCase(b),i=a.style;return b=n.cssProps[h]||(n.cssProps[h]=Ma(h)||h),g=n.cssHooks[b]||n.cssHooks[h],void 0===c?g&&"get"in g&&void 0!==(e=g.get(a,!1,d))?e:i[b]:(f=typeof c,"string"===f&&(e=T.exec(c))&&e[1]&&(c=W(a,b,e),f="number"),null!=c&&c===c&&("number"===f&&(c+=e&&e[3]||(n.cssNumber[h]?"":"px")),l.clearCloneStyle||""!==c||0!==b.indexOf("background")||(i[b]="inherit"),g&&"set"in g&&void 0===(c=g.set(a,c,d))||(i[b]=c)),void 0)}},css:function(a,b,c,d){var e,f,g,h=n.camelCase(b);return b=n.cssProps[h]||(n.cssProps[h]=Ma(h)||h),g=n.cssHooks[b]||n.cssHooks[h],g&&"get"in g&&(e=g.get(a,!0,c)),void 0===e&&(e=Fa(a,b,d)),"normal"===e&&b in Ja&&(e=Ja[b]),""===c||c?(f=parseFloat(e),c===!0||isFinite(f)?f||0:e):e}}),n.each(["height","width"],function(a,b){n.cssHooks[b]={get:function(a,c,d){return c?Ha.test(n.css(a,"display"))&&0===a.offsetWidth?Da(a,Ia,function(){return Pa(a,b,d)}):Pa(a,b,d):void 0},set:function(a,c,d){var e,f=d&&Ca(a),g=d&&Oa(a,b,d,"border-box"===n.css(a,"boxSizing",!1,f),f);return g&&(e=T.exec(c))&&"px"!==(e[3]||"px")&&(a.style[b]=c,c=n.css(a,b)),Na(a,c,g)}}}),n.cssHooks.marginLeft=Ga(l.reliableMarginLeft,function(a,b){return b?(parseFloat(Fa(a,"marginLeft"))||a.getBoundingClientRect().left-Da(a,{marginLeft:0},function(){return a.getBoundingClientRect().left}))+"px":void 0}),n.cssHooks.marginRight=Ga(l.reliableMarginRight,function(a,b){return b?Da(a,{display:"inline-block"},Fa,[a,"marginRight"]):void 0}),n.each({margin:"",padding:"",border:"Width"},function(a,b){n.cssHooks[a+b]={expand:function(c){for(var d=0,e={},f="string"==typeof c?c.split(" "):[c];4>d;d++)e[a+U[d]+b]=f[d]||f[d-2]||f[0];return e}},Aa.test(a)||(n.cssHooks[a+b].set=Na)}),n.fn.extend({css:function(a,b){return K(this,function(a,b,c){var d,e,f={},g=0;if(n.isArray(b)){for(d=Ca(a),e=b.length;e>g;g++)f[b[g]]=n.css(a,b[g],!1,d);return f}return void 0!==c?n.style(a,b,c):n.css(a,b)},a,b,arguments.length>1)},show:function(){return Qa(this,!0)},hide:function(){return Qa(this)},toggle:function(a){return"boolean"==typeof a?a?this.show():this.hide():this.each(function(){V(this)?n(this).show():n(this).hide()})}});function Ra(a,b,c,d,e){return new Ra.prototype.init(a,b,c,d,e)}n.Tween=Ra,Ra.prototype={constructor:Ra,init:function(a,b,c,d,e,f){this.elem=a,this.prop=c,this.easing=e||n.easing._default,this.options=b,this.start=this.now=this.cur(),this.end=d,this.unit=f||(n.cssNumber[c]?"":"px")},cur:function(){var a=Ra.propHooks[this.prop];return a&&a.get?a.get(this):Ra.propHooks._default.get(this)},run:function(a){var b,c=Ra.propHooks[this.prop];return this.options.duration?this.pos=b=n.easing[this.easing](a,this.options.duration*a,0,1,this.options.duration):this.pos=b=a,this.now=(this.end-this.start)*b+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),c&&c.set?c.set(this):Ra.propHooks._default.set(this),this}},Ra.prototype.init.prototype=Ra.prototype,Ra.propHooks={_default:{get:function(a){var b;return 1!==a.elem.nodeType||null!=a.elem[a.prop]&&null==a.elem.style[a.prop]?a.elem[a.prop]:(b=n.css(a.elem,a.prop,""),b&&"auto"!==b?b:0)},set:function(a){n.fx.step[a.prop]?n.fx.step[a.prop](a):1!==a.elem.nodeType||null==a.elem.style[n.cssProps[a.prop]]&&!n.cssHooks[a.prop]?a.elem[a.prop]=a.now:n.style(a.elem,a.prop,a.now+a.unit)}}},Ra.propHooks.scrollTop=Ra.propHooks.scrollLeft={set:function(a){a.elem.nodeType&&a.elem.parentNode&&(a.elem[a.prop]=a.now)}},n.easing={linear:function(a){return a},swing:function(a){return.5-Math.cos(a*Math.PI)/2},_default:"swing"},n.fx=Ra.prototype.init,n.fx.step={};var Sa,Ta,Ua=/^(?:toggle|show|hide)$/,Va=/queueHooks$/;function Wa(){return a.setTimeout(function(){Sa=void 0}),Sa=n.now()}function Xa(a,b){var c,d=0,e={height:a};for(b=b?1:0;4>d;d+=2-b)c=U[d],e["margin"+c]=e["padding"+c]=a;return b&&(e.opacity=e.width=a),e}function Ya(a,b,c){for(var d,e=(_a.tweeners[b]||[]).concat(_a.tweeners["*"]),f=0,g=e.length;g>f;f++)if(d=e[f].call(c,b,a))return d}function Za(a,b,c){var d,e,f,g,h,i,j,k,l=this,m={},o=a.style,p=a.nodeType&&V(a),q=N.get(a,"fxshow");c.queue||(h=n._queueHooks(a,"fx"),null==h.unqueued&&(h.unqueued=0,i=h.empty.fire,h.empty.fire=function(){h.unqueued||i()}),h.unqueued++,l.always(function(){l.always(function(){h.unqueued--,n.queue(a,"fx").length||h.empty.fire()})})),1===a.nodeType&&("height"in b||"width"in b)&&(c.overflow=[o.overflow,o.overflowX,o.overflowY],j=n.css(a,"display"),k="none"===j?N.get(a,"olddisplay")||za(a.nodeName):j,"inline"===k&&"none"===n.css(a,"float")&&(o.display="inline-block")),c.overflow&&(o.overflow="hidden",l.always(function(){o.overflow=c.overflow[0],o.overflowX=c.overflow[1],o.overflowY=c.overflow[2]}));for(d in b)if(e=b[d],Ua.exec(e)){if(delete b[d],f=f||"toggle"===e,e===(p?"hide":"show")){if("show"!==e||!q||void 0===q[d])continue;p=!0}m[d]=q&&q[d]||n.style(a,d)}else j=void 0;if(n.isEmptyObject(m))"inline"===("none"===j?za(a.nodeName):j)&&(o.display=j);else{q?"hidden"in q&&(p=q.hidden):q=N.access(a,"fxshow",{}),f&&(q.hidden=!p),p?n(a).show():l.done(function(){n(a).hide()}),l.done(function(){var b;N.remove(a,"fxshow");for(b in m)n.style(a,b,m[b])});for(d in m)g=Ya(p?q[d]:0,d,l),d in q||(q[d]=g.start,p&&(g.end=g.start,g.start="width"===d||"height"===d?1:0))}}function $a(a,b){var c,d,e,f,g;for(c in a)if(d=n.camelCase(c),e=b[d],f=a[c],n.isArray(f)&&(e=f[1],f=a[c]=f[0]),c!==d&&(a[d]=f,delete a[c]),g=n.cssHooks[d],g&&"expand"in g){f=g.expand(f),delete a[d];for(c in f)c in a||(a[c]=f[c],b[c]=e)}else b[d]=e}function _a(a,b,c){var d,e,f=0,g=_a.prefilters.length,h=n.Deferred().always(function(){delete i.elem}),i=function(){if(e)return!1;for(var b=Sa||Wa(),c=Math.max(0,j.startTime+j.duration-b),d=c/j.duration||0,f=1-d,g=0,i=j.tweens.length;i>g;g++)j.tweens[g].run(f);return h.notifyWith(a,[j,f,c]),1>f&&i?c:(h.resolveWith(a,[j]),!1)},j=h.promise({elem:a,props:n.extend({},b),opts:n.extend(!0,{specialEasing:{},easing:n.easing._default},c),originalProperties:b,originalOptions:c,startTime:Sa||Wa(),duration:c.duration,tweens:[],createTween:function(b,c){var d=n.Tween(a,j.opts,b,c,j.opts.specialEasing[b]||j.opts.easing);return j.tweens.push(d),d},stop:function(b){var c=0,d=b?j.tweens.length:0;if(e)return this;for(e=!0;d>c;c++)j.tweens[c].run(1);return b?(h.notifyWith(a,[j,1,0]),h.resolveWith(a,[j,b])):h.rejectWith(a,[j,b]),this}}),k=j.props;for($a(k,j.opts.specialEasing);g>f;f++)if(d=_a.prefilters[f].call(j,a,k,j.opts))return n.isFunction(d.stop)&&(n._queueHooks(j.elem,j.opts.queue).stop=n.proxy(d.stop,d)),d;return n.map(k,Ya,j),n.isFunction(j.opts.start)&&j.opts.start.call(a,j),n.fx.timer(n.extend(i,{elem:a,anim:j,queue:j.opts.queue})),j.progress(j.opts.progress).done(j.opts.done,j.opts.complete).fail(j.opts.fail).always(j.opts.always)}n.Animation=n.extend(_a,{tweeners:{"*":[function(a,b){var c=this.createTween(a,b);return W(c.elem,a,T.exec(b),c),c}]},tweener:function(a,b){n.isFunction(a)?(b=a,a=["*"]):a=a.match(G);for(var c,d=0,e=a.length;e>d;d++)c=a[d],_a.tweeners[c]=_a.tweeners[c]||[],_a.tweeners[c].unshift(b)},prefilters:[Za],prefilter:function(a,b){b?_a.prefilters.unshift(a):_a.prefilters.push(a)}}),n.speed=function(a,b,c){var d=a&&"object"==typeof a?n.extend({},a):{complete:c||!c&&b||n.isFunction(a)&&a,duration:a,easing:c&&b||b&&!n.isFunction(b)&&b};return d.duration=n.fx.off?0:"number"==typeof d.duration?d.duration:d.duration in n.fx.speeds?n.fx.speeds[d.duration]:n.fx.speeds._default,null!=d.queue&&d.queue!==!0||(d.queue="fx"),d.old=d.complete,d.complete=function(){n.isFunction(d.old)&&d.old.call(this),d.queue&&n.dequeue(this,d.queue)},d},n.fn.extend({fadeTo:function(a,b,c,d){return this.filter(V).css("opacity",0).show().end().animate({opacity:b},a,c,d)},animate:function(a,b,c,d){var e=n.isEmptyObject(a),f=n.speed(b,c,d),g=function(){var b=_a(this,n.extend({},a),f);(e||N.get(this,"finish"))&&b.stop(!0)};return g.finish=g,e||f.queue===!1?this.each(g):this.queue(f.queue,g)},stop:function(a,b,c){var d=function(a){var b=a.stop;delete a.stop,b(c)};return"string"!=typeof a&&(c=b,b=a,a=void 0),b&&a!==!1&&this.queue(a||"fx",[]),this.each(function(){var b=!0,e=null!=a&&a+"queueHooks",f=n.timers,g=N.get(this);if(e)g[e]&&g[e].stop&&d(g[e]);else for(e in g)g[e]&&g[e].stop&&Va.test(e)&&d(g[e]);for(e=f.length;e--;)f[e].elem!==this||null!=a&&f[e].queue!==a||(f[e].anim.stop(c),b=!1,f.splice(e,1));!b&&c||n.dequeue(this,a)})},finish:function(a){return a!==!1&&(a=a||"fx"),this.each(function(){var b,c=N.get(this),d=c[a+"queue"],e=c[a+"queueHooks"],f=n.timers,g=d?d.length:0;for(c.finish=!0,n.queue(this,a,[]),e&&e.stop&&e.stop.call(this,!0),b=f.length;b--;)f[b].elem===this&&f[b].queue===a&&(f[b].anim.stop(!0),f.splice(b,1));for(b=0;g>b;b++)d[b]&&d[b].finish&&d[b].finish.call(this);delete c.finish})}}),n.each(["toggle","show","hide"],function(a,b){var c=n.fn[b];n.fn[b]=function(a,d,e){return null==a||"boolean"==typeof a?c.apply(this,arguments):this.animate(Xa(b,!0),a,d,e)}}),n.each({slideDown:Xa("show"),slideUp:Xa("hide"),slideToggle:Xa("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(a,b){n.fn[a]=function(a,c,d){return this.animate(b,a,c,d)}}),n.timers=[],n.fx.tick=function(){var a,b=0,c=n.timers;for(Sa=n.now();b<c.length;b++)a=c[b],a()||c[b]!==a||c.splice(b--,1);c.length||n.fx.stop(),Sa=void 0},n.fx.timer=function(a){n.timers.push(a),a()?n.fx.start():n.timers.pop()},n.fx.interval=13,n.fx.start=function(){Ta||(Ta=a.setInterval(n.fx.tick,n.fx.interval))},n.fx.stop=function(){a.clearInterval(Ta),Ta=null},n.fx.speeds={slow:600,fast:200,_default:400},n.fn.delay=function(b,c){return b=n.fx?n.fx.speeds[b]||b:b,c=c||"fx",this.queue(c,function(c,d){var e=a.setTimeout(c,b);d.stop=function(){a.clearTimeout(e)}})},function(){var a=d.createElement("input"),b=d.createElement("select"),c=b.appendChild(d.createElement("option"));a.type="checkbox",l.checkOn=""!==a.value,l.optSelected=c.selected,b.disabled=!0,l.optDisabled=!c.disabled,a=d.createElement("input"),a.value="t",a.type="radio",l.radioValue="t"===a.value}();var ab,bb=n.expr.attrHandle;n.fn.extend({attr:function(a,b){return K(this,n.attr,a,b,arguments.length>1)},removeAttr:function(a){return this.each(function(){n.removeAttr(this,a)})}}),n.extend({attr:function(a,b,c){var d,e,f=a.nodeType;if(3!==f&&8!==f&&2!==f)return"undefined"==typeof a.getAttribute?n.prop(a,b,c):(1===f&&n.isXMLDoc(a)||(b=b.toLowerCase(),e=n.attrHooks[b]||(n.expr.match.bool.test(b)?ab:void 0)),void 0!==c?null===c?void n.removeAttr(a,b):e&&"set"in e&&void 0!==(d=e.set(a,c,b))?d:(a.setAttribute(b,c+""),c):e&&"get"in e&&null!==(d=e.get(a,b))?d:(d=n.find.attr(a,b),null==d?void 0:d))},attrHooks:{type:{set:function(a,b){if(!l.radioValue&&"radio"===b&&n.nodeName(a,"input")){var c=a.value;return a.setAttribute("type",b),c&&(a.value=c),b}}}},removeAttr:function(a,b){var c,d,e=0,f=b&&b.match(G);if(f&&1===a.nodeType)while(c=f[e++])d=n.propFix[c]||c,n.expr.match.bool.test(c)&&(a[d]=!1),a.removeAttribute(c)}}),ab={set:function(a,b,c){return b===!1?n.removeAttr(a,c):a.setAttribute(c,c),c}},n.each(n.expr.match.bool.source.match(/\w+/g),function(a,b){var c=bb[b]||n.find.attr;bb[b]=function(a,b,d){var e,f;return d||(f=bb[b],bb[b]=e,e=null!=c(a,b,d)?b.toLowerCase():null,bb[b]=f),e}});var cb=/^(?:input|select|textarea|button)$/i,db=/^(?:a|area)$/i;n.fn.extend({prop:function(a,b){return K(this,n.prop,a,b,arguments.length>1)},removeProp:function(a){return this.each(function(){delete this[n.propFix[a]||a]})}}),n.extend({prop:function(a,b,c){var d,e,f=a.nodeType;if(3!==f&&8!==f&&2!==f)return 1===f&&n.isXMLDoc(a)||(b=n.propFix[b]||b,e=n.propHooks[b]),
void 0!==c?e&&"set"in e&&void 0!==(d=e.set(a,c,b))?d:a[b]=c:e&&"get"in e&&null!==(d=e.get(a,b))?d:a[b]},propHooks:{tabIndex:{get:function(a){var b=n.find.attr(a,"tabindex");return b?parseInt(b,10):cb.test(a.nodeName)||db.test(a.nodeName)&&a.href?0:-1}}},propFix:{"for":"htmlFor","class":"className"}}),l.optSelected||(n.propHooks.selected={get:function(a){var b=a.parentNode;return b&&b.parentNode&&b.parentNode.selectedIndex,null},set:function(a){var b=a.parentNode;b&&(b.selectedIndex,b.parentNode&&b.parentNode.selectedIndex)}}),n.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){n.propFix[this.toLowerCase()]=this});var eb=/[\t\r\n\f]/g;function fb(a){return a.getAttribute&&a.getAttribute("class")||""}n.fn.extend({addClass:function(a){var b,c,d,e,f,g,h,i=0;if(n.isFunction(a))return this.each(function(b){n(this).addClass(a.call(this,b,fb(this)))});if("string"==typeof a&&a){b=a.match(G)||[];while(c=this[i++])if(e=fb(c),d=1===c.nodeType&&(" "+e+" ").replace(eb," ")){g=0;while(f=b[g++])d.indexOf(" "+f+" ")<0&&(d+=f+" ");h=n.trim(d),e!==h&&c.setAttribute("class",h)}}return this},removeClass:function(a){var b,c,d,e,f,g,h,i=0;if(n.isFunction(a))return this.each(function(b){n(this).removeClass(a.call(this,b,fb(this)))});if(!arguments.length)return this.attr("class","");if("string"==typeof a&&a){b=a.match(G)||[];while(c=this[i++])if(e=fb(c),d=1===c.nodeType&&(" "+e+" ").replace(eb," ")){g=0;while(f=b[g++])while(d.indexOf(" "+f+" ")>-1)d=d.replace(" "+f+" "," ");h=n.trim(d),e!==h&&c.setAttribute("class",h)}}return this},toggleClass:function(a,b){var c=typeof a;return"boolean"==typeof b&&"string"===c?b?this.addClass(a):this.removeClass(a):n.isFunction(a)?this.each(function(c){n(this).toggleClass(a.call(this,c,fb(this),b),b)}):this.each(function(){var b,d,e,f;if("string"===c){d=0,e=n(this),f=a.match(G)||[];while(b=f[d++])e.hasClass(b)?e.removeClass(b):e.addClass(b)}else void 0!==a&&"boolean"!==c||(b=fb(this),b&&N.set(this,"__className__",b),this.setAttribute&&this.setAttribute("class",b||a===!1?"":N.get(this,"__className__")||""))})},hasClass:function(a){var b,c,d=0;b=" "+a+" ";while(c=this[d++])if(1===c.nodeType&&(" "+fb(c)+" ").replace(eb," ").indexOf(b)>-1)return!0;return!1}});var gb=/\r/g,hb=/[\x20\t\r\n\f]+/g;n.fn.extend({val:function(a){var b,c,d,e=this[0];{if(arguments.length)return d=n.isFunction(a),this.each(function(c){var e;1===this.nodeType&&(e=d?a.call(this,c,n(this).val()):a,null==e?e="":"number"==typeof e?e+="":n.isArray(e)&&(e=n.map(e,function(a){return null==a?"":a+""})),b=n.valHooks[this.type]||n.valHooks[this.nodeName.toLowerCase()],b&&"set"in b&&void 0!==b.set(this,e,"value")||(this.value=e))});if(e)return b=n.valHooks[e.type]||n.valHooks[e.nodeName.toLowerCase()],b&&"get"in b&&void 0!==(c=b.get(e,"value"))?c:(c=e.value,"string"==typeof c?c.replace(gb,""):null==c?"":c)}}}),n.extend({valHooks:{option:{get:function(a){var b=n.find.attr(a,"value");return null!=b?b:n.trim(n.text(a)).replace(hb," ")}},select:{get:function(a){for(var b,c,d=a.options,e=a.selectedIndex,f="select-one"===a.type||0>e,g=f?null:[],h=f?e+1:d.length,i=0>e?h:f?e:0;h>i;i++)if(c=d[i],(c.selected||i===e)&&(l.optDisabled?!c.disabled:null===c.getAttribute("disabled"))&&(!c.parentNode.disabled||!n.nodeName(c.parentNode,"optgroup"))){if(b=n(c).val(),f)return b;g.push(b)}return g},set:function(a,b){var c,d,e=a.options,f=n.makeArray(b),g=e.length;while(g--)d=e[g],(d.selected=n.inArray(n.valHooks.option.get(d),f)>-1)&&(c=!0);return c||(a.selectedIndex=-1),f}}}}),n.each(["radio","checkbox"],function(){n.valHooks[this]={set:function(a,b){return n.isArray(b)?a.checked=n.inArray(n(a).val(),b)>-1:void 0}},l.checkOn||(n.valHooks[this].get=function(a){return null===a.getAttribute("value")?"on":a.value})});var ib=/^(?:focusinfocus|focusoutblur)$/;n.extend(n.event,{trigger:function(b,c,e,f){var g,h,i,j,l,m,o,p=[e||d],q=k.call(b,"type")?b.type:b,r=k.call(b,"namespace")?b.namespace.split("."):[];if(h=i=e=e||d,3!==e.nodeType&&8!==e.nodeType&&!ib.test(q+n.event.triggered)&&(q.indexOf(".")>-1&&(r=q.split("."),q=r.shift(),r.sort()),l=q.indexOf(":")<0&&"on"+q,b=b[n.expando]?b:new n.Event(q,"object"==typeof b&&b),b.isTrigger=f?2:3,b.namespace=r.join("."),b.rnamespace=b.namespace?new RegExp("(^|\\.)"+r.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,b.result=void 0,b.target||(b.target=e),c=null==c?[b]:n.makeArray(c,[b]),o=n.event.special[q]||{},f||!o.trigger||o.trigger.apply(e,c)!==!1)){if(!f&&!o.noBubble&&!n.isWindow(e)){for(j=o.delegateType||q,ib.test(j+q)||(h=h.parentNode);h;h=h.parentNode)p.push(h),i=h;i===(e.ownerDocument||d)&&p.push(i.defaultView||i.parentWindow||a)}g=0;while((h=p[g++])&&!b.isPropagationStopped())b.type=g>1?j:o.bindType||q,m=(N.get(h,"events")||{})[b.type]&&N.get(h,"handle"),m&&m.apply(h,c),m=l&&h[l],m&&m.apply&&L(h)&&(b.result=m.apply(h,c),b.result===!1&&b.preventDefault());return b.type=q,f||b.isDefaultPrevented()||o._default&&o._default.apply(p.pop(),c)!==!1||!L(e)||l&&n.isFunction(e[q])&&!n.isWindow(e)&&(i=e[l],i&&(e[l]=null),n.event.triggered=q,e[q](),n.event.triggered=void 0,i&&(e[l]=i)),b.result}},simulate:function(a,b,c){var d=n.extend(new n.Event,c,{type:a,isSimulated:!0});n.event.trigger(d,null,b)}}),n.fn.extend({trigger:function(a,b){return this.each(function(){n.event.trigger(a,b,this)})},triggerHandler:function(a,b){var c=this[0];return c?n.event.trigger(a,b,c,!0):void 0}}),n.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "),function(a,b){n.fn[b]=function(a,c){return arguments.length>0?this.on(b,null,a,c):this.trigger(b)}}),n.fn.extend({hover:function(a,b){return this.mouseenter(a).mouseleave(b||a)}}),l.focusin="onfocusin"in a,l.focusin||n.each({focus:"focusin",blur:"focusout"},function(a,b){var c=function(a){n.event.simulate(b,a.target,n.event.fix(a))};n.event.special[b]={setup:function(){var d=this.ownerDocument||this,e=N.access(d,b);e||d.addEventListener(a,c,!0),N.access(d,b,(e||0)+1)},teardown:function(){var d=this.ownerDocument||this,e=N.access(d,b)-1;e?N.access(d,b,e):(d.removeEventListener(a,c,!0),N.remove(d,b))}}});var jb=a.location,kb=n.now(),lb=/\?/;n.parseJSON=function(a){return JSON.parse(a+"")},n.parseXML=function(b){var c;if(!b||"string"!=typeof b)return null;try{c=(new a.DOMParser).parseFromString(b,"text/xml")}catch(d){c=void 0}return c&&!c.getElementsByTagName("parsererror").length||n.error("Invalid XML: "+b),c};var mb=/#.*$/,nb=/([?&])_=[^&]*/,ob=/^(.*?):[ \t]*([^\r\n]*)$/gm,pb=/^(?:about|app|app-storage|.+-extension|file|res|widget):$/,qb=/^(?:GET|HEAD)$/,rb=/^\/\//,sb={},tb={},ub="*/".concat("*"),vb=d.createElement("a");vb.href=jb.href;function wb(a){return function(b,c){"string"!=typeof b&&(c=b,b="*");var d,e=0,f=b.toLowerCase().match(G)||[];if(n.isFunction(c))while(d=f[e++])"+"===d[0]?(d=d.slice(1)||"*",(a[d]=a[d]||[]).unshift(c)):(a[d]=a[d]||[]).push(c)}}function xb(a,b,c,d){var e={},f=a===tb;function g(h){var i;return e[h]=!0,n.each(a[h]||[],function(a,h){var j=h(b,c,d);return"string"!=typeof j||f||e[j]?f?!(i=j):void 0:(b.dataTypes.unshift(j),g(j),!1)}),i}return g(b.dataTypes[0])||!e["*"]&&g("*")}function yb(a,b){var c,d,e=n.ajaxSettings.flatOptions||{};for(c in b)void 0!==b[c]&&((e[c]?a:d||(d={}))[c]=b[c]);return d&&n.extend(!0,a,d),a}function zb(a,b,c){var d,e,f,g,h=a.contents,i=a.dataTypes;while("*"===i[0])i.shift(),void 0===d&&(d=a.mimeType||b.getResponseHeader("Content-Type"));if(d)for(e in h)if(h[e]&&h[e].test(d)){i.unshift(e);break}if(i[0]in c)f=i[0];else{for(e in c){if(!i[0]||a.converters[e+" "+i[0]]){f=e;break}g||(g=e)}f=f||g}return f?(f!==i[0]&&i.unshift(f),c[f]):void 0}function Ab(a,b,c,d){var e,f,g,h,i,j={},k=a.dataTypes.slice();if(k[1])for(g in a.converters)j[g.toLowerCase()]=a.converters[g];f=k.shift();while(f)if(a.responseFields[f]&&(c[a.responseFields[f]]=b),!i&&d&&a.dataFilter&&(b=a.dataFilter(b,a.dataType)),i=f,f=k.shift())if("*"===f)f=i;else if("*"!==i&&i!==f){if(g=j[i+" "+f]||j["* "+f],!g)for(e in j)if(h=e.split(" "),h[1]===f&&(g=j[i+" "+h[0]]||j["* "+h[0]])){g===!0?g=j[e]:j[e]!==!0&&(f=h[0],k.unshift(h[1]));break}if(g!==!0)if(g&&a["throws"])b=g(b);else try{b=g(b)}catch(l){return{state:"parsererror",error:g?l:"No conversion from "+i+" to "+f}}}return{state:"success",data:b}}n.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:jb.href,type:"GET",isLocal:pb.test(jb.protocol),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":ub,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/\bxml\b/,html:/\bhtml/,json:/\bjson\b/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":n.parseJSON,"text xml":n.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(a,b){return b?yb(yb(a,n.ajaxSettings),b):yb(n.ajaxSettings,a)},ajaxPrefilter:wb(sb),ajaxTransport:wb(tb),ajax:function(b,c){"object"==typeof b&&(c=b,b=void 0),c=c||{};var e,f,g,h,i,j,k,l,m=n.ajaxSetup({},c),o=m.context||m,p=m.context&&(o.nodeType||o.jquery)?n(o):n.event,q=n.Deferred(),r=n.Callbacks("once memory"),s=m.statusCode||{},t={},u={},v=0,w="canceled",x={readyState:0,getResponseHeader:function(a){var b;if(2===v){if(!h){h={};while(b=ob.exec(g))h[b[1].toLowerCase()]=b[2]}b=h[a.toLowerCase()]}return null==b?null:b},getAllResponseHeaders:function(){return 2===v?g:null},setRequestHeader:function(a,b){var c=a.toLowerCase();return v||(a=u[c]=u[c]||a,t[a]=b),this},overrideMimeType:function(a){return v||(m.mimeType=a),this},statusCode:function(a){var b;if(a)if(2>v)for(b in a)s[b]=[s[b],a[b]];else x.always(a[x.status]);return this},abort:function(a){var b=a||w;return e&&e.abort(b),z(0,b),this}};if(q.promise(x).complete=r.add,x.success=x.done,x.error=x.fail,m.url=((b||m.url||jb.href)+"").replace(mb,"").replace(rb,jb.protocol+"//"),m.type=c.method||c.type||m.method||m.type,m.dataTypes=n.trim(m.dataType||"*").toLowerCase().match(G)||[""],null==m.crossDomain){j=d.createElement("a");try{j.href=m.url,j.href=j.href,m.crossDomain=vb.protocol+"//"+vb.host!=j.protocol+"//"+j.host}catch(y){m.crossDomain=!0}}if(m.data&&m.processData&&"string"!=typeof m.data&&(m.data=n.param(m.data,m.traditional)),xb(sb,m,c,x),2===v)return x;k=n.event&&m.global,k&&0===n.active++&&n.event.trigger("ajaxStart"),m.type=m.type.toUpperCase(),m.hasContent=!qb.test(m.type),f=m.url,m.hasContent||(m.data&&(f=m.url+=(lb.test(f)?"&":"?")+m.data,delete m.data),m.cache===!1&&(m.url=nb.test(f)?f.replace(nb,"$1_="+kb++):f+(lb.test(f)?"&":"?")+"_="+kb++)),m.ifModified&&(n.lastModified[f]&&x.setRequestHeader("If-Modified-Since",n.lastModified[f]),n.etag[f]&&x.setRequestHeader("If-None-Match",n.etag[f])),(m.data&&m.hasContent&&m.contentType!==!1||c.contentType)&&x.setRequestHeader("Content-Type",m.contentType),x.setRequestHeader("Accept",m.dataTypes[0]&&m.accepts[m.dataTypes[0]]?m.accepts[m.dataTypes[0]]+("*"!==m.dataTypes[0]?", "+ub+"; q=0.01":""):m.accepts["*"]);for(l in m.headers)x.setRequestHeader(l,m.headers[l]);if(m.beforeSend&&(m.beforeSend.call(o,x,m)===!1||2===v))return x.abort();w="abort";for(l in{success:1,error:1,complete:1})x[l](m[l]);if(e=xb(tb,m,c,x)){if(x.readyState=1,k&&p.trigger("ajaxSend",[x,m]),2===v)return x;m.async&&m.timeout>0&&(i=a.setTimeout(function(){x.abort("timeout")},m.timeout));try{v=1,e.send(t,z)}catch(y){if(!(2>v))throw y;z(-1,y)}}else z(-1,"No Transport");function z(b,c,d,h){var j,l,t,u,w,y=c;2!==v&&(v=2,i&&a.clearTimeout(i),e=void 0,g=h||"",x.readyState=b>0?4:0,j=b>=200&&300>b||304===b,d&&(u=zb(m,x,d)),u=Ab(m,u,x,j),j?(m.ifModified&&(w=x.getResponseHeader("Last-Modified"),w&&(n.lastModified[f]=w),w=x.getResponseHeader("etag"),w&&(n.etag[f]=w)),204===b||"HEAD"===m.type?y="nocontent":304===b?y="notmodified":(y=u.state,l=u.data,t=u.error,j=!t)):(t=y,!b&&y||(y="error",0>b&&(b=0))),x.status=b,x.statusText=(c||y)+"",j?q.resolveWith(o,[l,y,x]):q.rejectWith(o,[x,y,t]),x.statusCode(s),s=void 0,k&&p.trigger(j?"ajaxSuccess":"ajaxError",[x,m,j?l:t]),r.fireWith(o,[x,y]),k&&(p.trigger("ajaxComplete",[x,m]),--n.active||n.event.trigger("ajaxStop")))}return x},getJSON:function(a,b,c){return n.get(a,b,c,"json")},getScript:function(a,b){return n.get(a,void 0,b,"script")}}),n.each(["get","post"],function(a,b){n[b]=function(a,c,d,e){return n.isFunction(c)&&(e=e||d,d=c,c=void 0),n.ajax(n.extend({url:a,type:b,dataType:e,data:c,success:d},n.isPlainObject(a)&&a))}}),n._evalUrl=function(a){return n.ajax({url:a,type:"GET",dataType:"script",async:!1,global:!1,"throws":!0})},n.fn.extend({wrapAll:function(a){var b;return n.isFunction(a)?this.each(function(b){n(this).wrapAll(a.call(this,b))}):(this[0]&&(b=n(a,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&b.insertBefore(this[0]),b.map(function(){var a=this;while(a.firstElementChild)a=a.firstElementChild;return a}).append(this)),this)},wrapInner:function(a){return n.isFunction(a)?this.each(function(b){n(this).wrapInner(a.call(this,b))}):this.each(function(){var b=n(this),c=b.contents();c.length?c.wrapAll(a):b.append(a)})},wrap:function(a){var b=n.isFunction(a);return this.each(function(c){n(this).wrapAll(b?a.call(this,c):a)})},unwrap:function(){return this.parent().each(function(){n.nodeName(this,"body")||n(this).replaceWith(this.childNodes)}).end()}}),n.expr.filters.hidden=function(a){return!n.expr.filters.visible(a)},n.expr.filters.visible=function(a){return a.offsetWidth>0||a.offsetHeight>0||a.getClientRects().length>0};var Bb=/%20/g,Cb=/\[\]$/,Db=/\r?\n/g,Eb=/^(?:submit|button|image|reset|file)$/i,Fb=/^(?:input|select|textarea|keygen)/i;function Gb(a,b,c,d){var e;if(n.isArray(b))n.each(b,function(b,e){c||Cb.test(a)?d(a,e):Gb(a+"["+("object"==typeof e&&null!=e?b:"")+"]",e,c,d)});else if(c||"object"!==n.type(b))d(a,b);else for(e in b)Gb(a+"["+e+"]",b[e],c,d)}n.param=function(a,b){var c,d=[],e=function(a,b){b=n.isFunction(b)?b():null==b?"":b,d[d.length]=encodeURIComponent(a)+"="+encodeURIComponent(b)};if(void 0===b&&(b=n.ajaxSettings&&n.ajaxSettings.traditional),n.isArray(a)||a.jquery&&!n.isPlainObject(a))n.each(a,function(){e(this.name,this.value)});else for(c in a)Gb(c,a[c],b,e);return d.join("&").replace(Bb,"+")},n.fn.extend({serialize:function(){return n.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var a=n.prop(this,"elements");return a?n.makeArray(a):this}).filter(function(){var a=this.type;return this.name&&!n(this).is(":disabled")&&Fb.test(this.nodeName)&&!Eb.test(a)&&(this.checked||!X.test(a))}).map(function(a,b){var c=n(this).val();return null==c?null:n.isArray(c)?n.map(c,function(a){return{name:b.name,value:a.replace(Db,"\r\n")}}):{name:b.name,value:c.replace(Db,"\r\n")}}).get()}}),n.ajaxSettings.xhr=function(){try{return new a.XMLHttpRequest}catch(b){}};var Hb={0:200,1223:204},Ib=n.ajaxSettings.xhr();l.cors=!!Ib&&"withCredentials"in Ib,l.ajax=Ib=!!Ib,n.ajaxTransport(function(b){var c,d;return l.cors||Ib&&!b.crossDomain?{send:function(e,f){var g,h=b.xhr();if(h.open(b.type,b.url,b.async,b.username,b.password),b.xhrFields)for(g in b.xhrFields)h[g]=b.xhrFields[g];b.mimeType&&h.overrideMimeType&&h.overrideMimeType(b.mimeType),b.crossDomain||e["X-Requested-With"]||(e["X-Requested-With"]="XMLHttpRequest");for(g in e)h.setRequestHeader(g,e[g]);c=function(a){return function(){c&&(c=d=h.onload=h.onerror=h.onabort=h.onreadystatechange=null,"abort"===a?h.abort():"error"===a?"number"!=typeof h.status?f(0,"error"):f(h.status,h.statusText):f(Hb[h.status]||h.status,h.statusText,"text"!==(h.responseType||"text")||"string"!=typeof h.responseText?{binary:h.response}:{text:h.responseText},h.getAllResponseHeaders()))}},h.onload=c(),d=h.onerror=c("error"),void 0!==h.onabort?h.onabort=d:h.onreadystatechange=function(){4===h.readyState&&a.setTimeout(function(){c&&d()})},c=c("abort");try{h.send(b.hasContent&&b.data||null)}catch(i){if(c)throw i}},abort:function(){c&&c()}}:void 0}),n.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/\b(?:java|ecma)script\b/},converters:{"text script":function(a){return n.globalEval(a),a}}}),n.ajaxPrefilter("script",function(a){void 0===a.cache&&(a.cache=!1),a.crossDomain&&(a.type="GET")}),n.ajaxTransport("script",function(a){if(a.crossDomain){var b,c;return{send:function(e,f){b=n("<script>").prop({charset:a.scriptCharset,src:a.url}).on("load error",c=function(a){b.remove(),c=null,a&&f("error"===a.type?404:200,a.type)}),d.head.appendChild(b[0])},abort:function(){c&&c()}}}});var Jb=[],Kb=/(=)\?(?=&|$)|\?\?/;n.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var a=Jb.pop()||n.expando+"_"+kb++;return this[a]=!0,a}}),n.ajaxPrefilter("json jsonp",function(b,c,d){var e,f,g,h=b.jsonp!==!1&&(Kb.test(b.url)?"url":"string"==typeof b.data&&0===(b.contentType||"").indexOf("application/x-www-form-urlencoded")&&Kb.test(b.data)&&"data");return h||"jsonp"===b.dataTypes[0]?(e=b.jsonpCallback=n.isFunction(b.jsonpCallback)?b.jsonpCallback():b.jsonpCallback,h?b[h]=b[h].replace(Kb,"$1"+e):b.jsonp!==!1&&(b.url+=(lb.test(b.url)?"&":"?")+b.jsonp+"="+e),b.converters["script json"]=function(){return g||n.error(e+" was not called"),g[0]},b.dataTypes[0]="json",f=a[e],a[e]=function(){g=arguments},d.always(function(){void 0===f?n(a).removeProp(e):a[e]=f,b[e]&&(b.jsonpCallback=c.jsonpCallback,Jb.push(e)),g&&n.isFunction(f)&&f(g[0]),g=f=void 0}),"script"):void 0}),n.parseHTML=function(a,b,c){if(!a||"string"!=typeof a)return null;"boolean"==typeof b&&(c=b,b=!1),b=b||d;var e=x.exec(a),f=!c&&[];return e?[b.createElement(e[1])]:(e=ca([a],b,f),f&&f.length&&n(f).remove(),n.merge([],e.childNodes))};var Lb=n.fn.load;n.fn.load=function(a,b,c){if("string"!=typeof a&&Lb)return Lb.apply(this,arguments);var d,e,f,g=this,h=a.indexOf(" ");return h>-1&&(d=n.trim(a.slice(h)),a=a.slice(0,h)),n.isFunction(b)?(c=b,b=void 0):b&&"object"==typeof b&&(e="POST"),g.length>0&&n.ajax({url:a,type:e||"GET",dataType:"html",data:b}).done(function(a){f=arguments,g.html(d?n("<div>").append(n.parseHTML(a)).find(d):a)}).always(c&&function(a,b){g.each(function(){c.apply(this,f||[a.responseText,b,a])})}),this},n.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(a,b){n.fn[b]=function(a){return this.on(b,a)}}),n.expr.filters.animated=function(a){return n.grep(n.timers,function(b){return a===b.elem}).length};function Mb(a){return n.isWindow(a)?a:9===a.nodeType&&a.defaultView}n.offset={setOffset:function(a,b,c){var d,e,f,g,h,i,j,k=n.css(a,"position"),l=n(a),m={};"static"===k&&(a.style.position="relative"),h=l.offset(),f=n.css(a,"top"),i=n.css(a,"left"),j=("absolute"===k||"fixed"===k)&&(f+i).indexOf("auto")>-1,j?(d=l.position(),g=d.top,e=d.left):(g=parseFloat(f)||0,e=parseFloat(i)||0),n.isFunction(b)&&(b=b.call(a,c,n.extend({},h))),null!=b.top&&(m.top=b.top-h.top+g),null!=b.left&&(m.left=b.left-h.left+e),"using"in b?b.using.call(a,m):l.css(m)}},n.fn.extend({offset:function(a){if(arguments.length)return void 0===a?this:this.each(function(b){n.offset.setOffset(this,a,b)});var b,c,d=this[0],e={top:0,left:0},f=d&&d.ownerDocument;if(f)return b=f.documentElement,n.contains(b,d)?(e=d.getBoundingClientRect(),c=Mb(f),{top:e.top+c.pageYOffset-b.clientTop,left:e.left+c.pageXOffset-b.clientLeft}):e},position:function(){if(this[0]){var a,b,c=this[0],d={top:0,left:0};return"fixed"===n.css(c,"position")?b=c.getBoundingClientRect():(a=this.offsetParent(),b=this.offset(),n.nodeName(a[0],"html")||(d=a.offset()),d.top+=n.css(a[0],"borderTopWidth",!0),d.left+=n.css(a[0],"borderLeftWidth",!0)),{top:b.top-d.top-n.css(c,"marginTop",!0),left:b.left-d.left-n.css(c,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var a=this.offsetParent;while(a&&"static"===n.css(a,"position"))a=a.offsetParent;return a||Ea})}}),n.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(a,b){var c="pageYOffset"===b;n.fn[a]=function(d){return K(this,function(a,d,e){var f=Mb(a);return void 0===e?f?f[b]:a[d]:void(f?f.scrollTo(c?f.pageXOffset:e,c?e:f.pageYOffset):a[d]=e)},a,d,arguments.length)}}),n.each(["top","left"],function(a,b){n.cssHooks[b]=Ga(l.pixelPosition,function(a,c){return c?(c=Fa(a,b),Ba.test(c)?n(a).position()[b]+"px":c):void 0})}),n.each({Height:"height",Width:"width"},function(a,b){n.each({padding:"inner"+a,content:b,"":"outer"+a},function(c,d){n.fn[d]=function(d,e){var f=arguments.length&&(c||"boolean"!=typeof d),g=c||(d===!0||e===!0?"margin":"border");return K(this,function(b,c,d){var e;return n.isWindow(b)?b.document.documentElement["client"+a]:9===b.nodeType?(e=b.documentElement,Math.max(b.body["scroll"+a],e["scroll"+a],b.body["offset"+a],e["offset"+a],e["client"+a])):void 0===d?n.css(b,c,g):n.style(b,c,d,g)},b,f?d:void 0,f,null)}})}),n.fn.extend({bind:function(a,b,c){return this.on(a,null,b,c)},unbind:function(a,b){return this.off(a,null,b)},delegate:function(a,b,c,d){return this.on(b,a,c,d)},undelegate:function(a,b,c){return 1===arguments.length?this.off(a,"**"):this.off(b,a||"**",c)},size:function(){return this.length}}),n.fn.andSelf=n.fn.addBack,"function"==typeof define&&define.amd&&define("jquery",[],function(){return n});var Nb=a.jQuery,Ob=a.$;return n.noConflict=function(b){return a.$===n&&(a.$=Ob),b&&a.jQuery===n&&(a.jQuery=Nb),n},b||(a.jQuery=a.$=n),n});

(function(r){r.fn.qrcode=function(h){var s;function u(a){this.mode=s;this.data=a}function o(a,c){this.typeNumber=a;this.errorCorrectLevel=c;this.modules=null;this.moduleCount=0;this.dataCache=null;this.dataList=[]}function q(a,c){if(void 0==a.length)throw Error(a.length+"/"+c);for(var d=0;d<a.length&&0==a[d];)d++;this.num=Array(a.length-d+c);for(var b=0;b<a.length-d;b++)this.num[b]=a[b+d]}function p(a,c){this.totalCount=a;this.dataCount=c}function t(){this.buffer=[];this.length=0}u.prototype={getLength:function(){return this.data.length},
write:function(a){for(var c=0;c<this.data.length;c++)a.put(this.data.charCodeAt(c),8)}};o.prototype={addData:function(a){this.dataList.push(new u(a));this.dataCache=null},isDark:function(a,c){if(0>a||this.moduleCount<=a||0>c||this.moduleCount<=c)throw Error(a+","+c);return this.modules[a][c]},getModuleCount:function(){return this.moduleCount},make:function(){if(1>this.typeNumber){for(var a=1,a=1;40>a;a++){for(var c=p.getRSBlocks(a,this.errorCorrectLevel),d=new t,b=0,e=0;e<c.length;e++)b+=c[e].dataCount;
for(e=0;e<this.dataList.length;e++)c=this.dataList[e],d.put(c.mode,4),d.put(c.getLength(),j.getLengthInBits(c.mode,a)),c.write(d);if(d.getLengthInBits()<=8*b)break}this.typeNumber=a}this.makeImpl(!1,this.getBestMaskPattern())},makeImpl:function(a,c){this.moduleCount=4*this.typeNumber+17;this.modules=Array(this.moduleCount);for(var d=0;d<this.moduleCount;d++){this.modules[d]=Array(this.moduleCount);for(var b=0;b<this.moduleCount;b++)this.modules[d][b]=null}this.setupPositionProbePattern(0,0);this.setupPositionProbePattern(this.moduleCount-
7,0);this.setupPositionProbePattern(0,this.moduleCount-7);this.setupPositionAdjustPattern();this.setupTimingPattern();this.setupTypeInfo(a,c);7<=this.typeNumber&&this.setupTypeNumber(a);null==this.dataCache&&(this.dataCache=o.createData(this.typeNumber,this.errorCorrectLevel,this.dataList));this.mapData(this.dataCache,c)},setupPositionProbePattern:function(a,c){for(var d=-1;7>=d;d++)if(!(-1>=a+d||this.moduleCount<=a+d))for(var b=-1;7>=b;b++)-1>=c+b||this.moduleCount<=c+b||(this.modules[a+d][c+b]=
0<=d&&6>=d&&(0==b||6==b)||0<=b&&6>=b&&(0==d||6==d)||2<=d&&4>=d&&2<=b&&4>=b?!0:!1)},getBestMaskPattern:function(){for(var a=0,c=0,d=0;8>d;d++){this.makeImpl(!0,d);var b=j.getLostPoint(this);if(0==d||a>b)a=b,c=d}return c},createMovieClip:function(a,c,d){a=a.createEmptyMovieClip(c,d);this.make();for(c=0;c<this.modules.length;c++)for(var d=1*c,b=0;b<this.modules[c].length;b++){var e=1*b;this.modules[c][b]&&(a.beginFill(0,100),a.moveTo(e,d),a.lineTo(e+1,d),a.lineTo(e+1,d+1),a.lineTo(e,d+1),a.endFill())}return a},
setupTimingPattern:function(){for(var a=8;a<this.moduleCount-8;a++)null==this.modules[a][6]&&(this.modules[a][6]=0==a%2);for(a=8;a<this.moduleCount-8;a++)null==this.modules[6][a]&&(this.modules[6][a]=0==a%2)},setupPositionAdjustPattern:function(){for(var a=j.getPatternPosition(this.typeNumber),c=0;c<a.length;c++)for(var d=0;d<a.length;d++){var b=a[c],e=a[d];if(null==this.modules[b][e])for(var f=-2;2>=f;f++)for(var i=-2;2>=i;i++)this.modules[b+f][e+i]=-2==f||2==f||-2==i||2==i||0==f&&0==i?!0:!1}},setupTypeNumber:function(a){for(var c=
j.getBCHTypeNumber(this.typeNumber),d=0;18>d;d++){var b=!a&&1==(c>>d&1);this.modules[Math.floor(d/3)][d%3+this.moduleCount-8-3]=b}for(d=0;18>d;d++)b=!a&&1==(c>>d&1),this.modules[d%3+this.moduleCount-8-3][Math.floor(d/3)]=b},setupTypeInfo:function(a,c){for(var d=j.getBCHTypeInfo(this.errorCorrectLevel<<3|c),b=0;15>b;b++){var e=!a&&1==(d>>b&1);6>b?this.modules[b][8]=e:8>b?this.modules[b+1][8]=e:this.modules[this.moduleCount-15+b][8]=e}for(b=0;15>b;b++)e=!a&&1==(d>>b&1),8>b?this.modules[8][this.moduleCount-
b-1]=e:9>b?this.modules[8][15-b-1+1]=e:this.modules[8][15-b-1]=e;this.modules[this.moduleCount-8][8]=!a},mapData:function(a,c){for(var d=-1,b=this.moduleCount-1,e=7,f=0,i=this.moduleCount-1;0<i;i-=2)for(6==i&&i--;;){for(var g=0;2>g;g++)if(null==this.modules[b][i-g]){var n=!1;f<a.length&&(n=1==(a[f]>>>e&1));j.getMask(c,b,i-g)&&(n=!n);this.modules[b][i-g]=n;e--; -1==e&&(f++,e=7)}b+=d;if(0>b||this.moduleCount<=b){b-=d;d=-d;break}}}};o.PAD0=236;o.PAD1=17;o.createData=function(a,c,d){for(var c=p.getRSBlocks(a,
c),b=new t,e=0;e<d.length;e++){var f=d[e];b.put(f.mode,4);b.put(f.getLength(),j.getLengthInBits(f.mode,a));f.write(b)}for(e=a=0;e<c.length;e++)a+=c[e].dataCount;if(b.getLengthInBits()>8*a)throw Error("code length overflow. ("+b.getLengthInBits()+">"+8*a+")");for(b.getLengthInBits()+4<=8*a&&b.put(0,4);0!=b.getLengthInBits()%8;)b.putBit(!1);for(;!(b.getLengthInBits()>=8*a);){b.put(o.PAD0,8);if(b.getLengthInBits()>=8*a)break;b.put(o.PAD1,8)}return o.createBytes(b,c)};o.createBytes=function(a,c){for(var d=
0,b=0,e=0,f=Array(c.length),i=Array(c.length),g=0;g<c.length;g++){var n=c[g].dataCount,h=c[g].totalCount-n,b=Math.max(b,n),e=Math.max(e,h);f[g]=Array(n);for(var k=0;k<f[g].length;k++)f[g][k]=255&a.buffer[k+d];d+=n;k=j.getErrorCorrectPolynomial(h);n=(new q(f[g],k.getLength()-1)).mod(k);i[g]=Array(k.getLength()-1);for(k=0;k<i[g].length;k++)h=k+n.getLength()-i[g].length,i[g][k]=0<=h?n.get(h):0}for(k=g=0;k<c.length;k++)g+=c[k].totalCount;d=Array(g);for(k=n=0;k<b;k++)for(g=0;g<c.length;g++)k<f[g].length&&
(d[n++]=f[g][k]);for(k=0;k<e;k++)for(g=0;g<c.length;g++)k<i[g].length&&(d[n++]=i[g][k]);return d};s=4;for(var j={PATTERN_POSITION_TABLE:[[],[6,18],[6,22],[6,26],[6,30],[6,34],[6,22,38],[6,24,42],[6,26,46],[6,28,50],[6,30,54],[6,32,58],[6,34,62],[6,26,46,66],[6,26,48,70],[6,26,50,74],[6,30,54,78],[6,30,56,82],[6,30,58,86],[6,34,62,90],[6,28,50,72,94],[6,26,50,74,98],[6,30,54,78,102],[6,28,54,80,106],[6,32,58,84,110],[6,30,58,86,114],[6,34,62,90,118],[6,26,50,74,98,122],[6,30,54,78,102,126],[6,26,52,
78,104,130],[6,30,56,82,108,134],[6,34,60,86,112,138],[6,30,58,86,114,142],[6,34,62,90,118,146],[6,30,54,78,102,126,150],[6,24,50,76,102,128,154],[6,28,54,80,106,132,158],[6,32,58,84,110,136,162],[6,26,54,82,110,138,166],[6,30,58,86,114,142,170]],G15:1335,G18:7973,G15_MASK:21522,getBCHTypeInfo:function(a){for(var c=a<<10;0<=j.getBCHDigit(c)-j.getBCHDigit(j.G15);)c^=j.G15<<j.getBCHDigit(c)-j.getBCHDigit(j.G15);return(a<<10|c)^j.G15_MASK},getBCHTypeNumber:function(a){for(var c=a<<12;0<=j.getBCHDigit(c)-
j.getBCHDigit(j.G18);)c^=j.G18<<j.getBCHDigit(c)-j.getBCHDigit(j.G18);return a<<12|c},getBCHDigit:function(a){for(var c=0;0!=a;)c++,a>>>=1;return c},getPatternPosition:function(a){return j.PATTERN_POSITION_TABLE[a-1]},getMask:function(a,c,d){switch(a){case 0:return 0==(c+d)%2;case 1:return 0==c%2;case 2:return 0==d%3;case 3:return 0==(c+d)%3;case 4:return 0==(Math.floor(c/2)+Math.floor(d/3))%2;case 5:return 0==c*d%2+c*d%3;case 6:return 0==(c*d%2+c*d%3)%2;case 7:return 0==(c*d%3+(c+d)%2)%2;default:throw Error("bad maskPattern:"+
a);}},getErrorCorrectPolynomial:function(a){for(var c=new q([1],0),d=0;d<a;d++)c=c.multiply(new q([1,l.gexp(d)],0));return c},getLengthInBits:function(a,c){if(1<=c&&10>c)switch(a){case 1:return 10;case 2:return 9;case s:return 8;case 8:return 8;default:throw Error("mode:"+a);}else if(27>c)switch(a){case 1:return 12;case 2:return 11;case s:return 16;case 8:return 10;default:throw Error("mode:"+a);}else if(41>c)switch(a){case 1:return 14;case 2:return 13;case s:return 16;case 8:return 12;default:throw Error("mode:"+
a);}else throw Error("type:"+c);},getLostPoint:function(a){for(var c=a.getModuleCount(),d=0,b=0;b<c;b++)for(var e=0;e<c;e++){for(var f=0,i=a.isDark(b,e),g=-1;1>=g;g++)if(!(0>b+g||c<=b+g))for(var h=-1;1>=h;h++)0>e+h||c<=e+h||0==g&&0==h||i==a.isDark(b+g,e+h)&&f++;5<f&&(d+=3+f-5)}for(b=0;b<c-1;b++)for(e=0;e<c-1;e++)if(f=0,a.isDark(b,e)&&f++,a.isDark(b+1,e)&&f++,a.isDark(b,e+1)&&f++,a.isDark(b+1,e+1)&&f++,0==f||4==f)d+=3;for(b=0;b<c;b++)for(e=0;e<c-6;e++)a.isDark(b,e)&&!a.isDark(b,e+1)&&a.isDark(b,e+
2)&&a.isDark(b,e+3)&&a.isDark(b,e+4)&&!a.isDark(b,e+5)&&a.isDark(b,e+6)&&(d+=40);for(e=0;e<c;e++)for(b=0;b<c-6;b++)a.isDark(b,e)&&!a.isDark(b+1,e)&&a.isDark(b+2,e)&&a.isDark(b+3,e)&&a.isDark(b+4,e)&&!a.isDark(b+5,e)&&a.isDark(b+6,e)&&(d+=40);for(e=f=0;e<c;e++)for(b=0;b<c;b++)a.isDark(b,e)&&f++;a=Math.abs(100*f/c/c-50)/5;return d+10*a}},l={glog:function(a){if(1>a)throw Error("glog("+a+")");return l.LOG_TABLE[a]},gexp:function(a){for(;0>a;)a+=255;for(;256<=a;)a-=255;return l.EXP_TABLE[a]},EXP_TABLE:Array(256),
LOG_TABLE:Array(256)},m=0;8>m;m++)l.EXP_TABLE[m]=1<<m;for(m=8;256>m;m++)l.EXP_TABLE[m]=l.EXP_TABLE[m-4]^l.EXP_TABLE[m-5]^l.EXP_TABLE[m-6]^l.EXP_TABLE[m-8];for(m=0;255>m;m++)l.LOG_TABLE[l.EXP_TABLE[m]]=m;q.prototype={get:function(a){return this.num[a]},getLength:function(){return this.num.length},multiply:function(a){for(var c=Array(this.getLength()+a.getLength()-1),d=0;d<this.getLength();d++)for(var b=0;b<a.getLength();b++)c[d+b]^=l.gexp(l.glog(this.get(d))+l.glog(a.get(b)));return new q(c,0)},mod:function(a){if(0>
this.getLength()-a.getLength())return this;for(var c=l.glog(this.get(0))-l.glog(a.get(0)),d=Array(this.getLength()),b=0;b<this.getLength();b++)d[b]=this.get(b);for(b=0;b<a.getLength();b++)d[b]^=l.gexp(l.glog(a.get(b))+c);return(new q(d,0)).mod(a)}};p.RS_BLOCK_TABLE=[[1,26,19],[1,26,16],[1,26,13],[1,26,9],[1,44,34],[1,44,28],[1,44,22],[1,44,16],[1,70,55],[1,70,44],[2,35,17],[2,35,13],[1,100,80],[2,50,32],[2,50,24],[4,25,9],[1,134,108],[2,67,43],[2,33,15,2,34,16],[2,33,11,2,34,12],[2,86,68],[4,43,27],
[4,43,19],[4,43,15],[2,98,78],[4,49,31],[2,32,14,4,33,15],[4,39,13,1,40,14],[2,121,97],[2,60,38,2,61,39],[4,40,18,2,41,19],[4,40,14,2,41,15],[2,146,116],[3,58,36,2,59,37],[4,36,16,4,37,17],[4,36,12,4,37,13],[2,86,68,2,87,69],[4,69,43,1,70,44],[6,43,19,2,44,20],[6,43,15,2,44,16],[4,101,81],[1,80,50,4,81,51],[4,50,22,4,51,23],[3,36,12,8,37,13],[2,116,92,2,117,93],[6,58,36,2,59,37],[4,46,20,6,47,21],[7,42,14,4,43,15],[4,133,107],[8,59,37,1,60,38],[8,44,20,4,45,21],[12,33,11,4,34,12],[3,145,115,1,146,
116],[4,64,40,5,65,41],[11,36,16,5,37,17],[11,36,12,5,37,13],[5,109,87,1,110,88],[5,65,41,5,66,42],[5,54,24,7,55,25],[11,36,12],[5,122,98,1,123,99],[7,73,45,3,74,46],[15,43,19,2,44,20],[3,45,15,13,46,16],[1,135,107,5,136,108],[10,74,46,1,75,47],[1,50,22,15,51,23],[2,42,14,17,43,15],[5,150,120,1,151,121],[9,69,43,4,70,44],[17,50,22,1,51,23],[2,42,14,19,43,15],[3,141,113,4,142,114],[3,70,44,11,71,45],[17,47,21,4,48,22],[9,39,13,16,40,14],[3,135,107,5,136,108],[3,67,41,13,68,42],[15,54,24,5,55,25],[15,
43,15,10,44,16],[4,144,116,4,145,117],[17,68,42],[17,50,22,6,51,23],[19,46,16,6,47,17],[2,139,111,7,140,112],[17,74,46],[7,54,24,16,55,25],[34,37,13],[4,151,121,5,152,122],[4,75,47,14,76,48],[11,54,24,14,55,25],[16,45,15,14,46,16],[6,147,117,4,148,118],[6,73,45,14,74,46],[11,54,24,16,55,25],[30,46,16,2,47,17],[8,132,106,4,133,107],[8,75,47,13,76,48],[7,54,24,22,55,25],[22,45,15,13,46,16],[10,142,114,2,143,115],[19,74,46,4,75,47],[28,50,22,6,51,23],[33,46,16,4,47,17],[8,152,122,4,153,123],[22,73,45,
3,74,46],[8,53,23,26,54,24],[12,45,15,28,46,16],[3,147,117,10,148,118],[3,73,45,23,74,46],[4,54,24,31,55,25],[11,45,15,31,46,16],[7,146,116,7,147,117],[21,73,45,7,74,46],[1,53,23,37,54,24],[19,45,15,26,46,16],[5,145,115,10,146,116],[19,75,47,10,76,48],[15,54,24,25,55,25],[23,45,15,25,46,16],[13,145,115,3,146,116],[2,74,46,29,75,47],[42,54,24,1,55,25],[23,45,15,28,46,16],[17,145,115],[10,74,46,23,75,47],[10,54,24,35,55,25],[19,45,15,35,46,16],[17,145,115,1,146,116],[14,74,46,21,75,47],[29,54,24,19,
55,25],[11,45,15,46,46,16],[13,145,115,6,146,116],[14,74,46,23,75,47],[44,54,24,7,55,25],[59,46,16,1,47,17],[12,151,121,7,152,122],[12,75,47,26,76,48],[39,54,24,14,55,25],[22,45,15,41,46,16],[6,151,121,14,152,122],[6,75,47,34,76,48],[46,54,24,10,55,25],[2,45,15,64,46,16],[17,152,122,4,153,123],[29,74,46,14,75,47],[49,54,24,10,55,25],[24,45,15,46,46,16],[4,152,122,18,153,123],[13,74,46,32,75,47],[48,54,24,14,55,25],[42,45,15,32,46,16],[20,147,117,4,148,118],[40,75,47,7,76,48],[43,54,24,22,55,25],[10,
45,15,67,46,16],[19,148,118,6,149,119],[18,75,47,31,76,48],[34,54,24,34,55,25],[20,45,15,61,46,16]];p.getRSBlocks=function(a,c){var d=p.getRsBlockTable(a,c);if(void 0==d)throw Error("bad rs block @ typeNumber:"+a+"/errorCorrectLevel:"+c);for(var b=d.length/3,e=[],f=0;f<b;f++)for(var h=d[3*f+0],g=d[3*f+1],j=d[3*f+2],l=0;l<h;l++)e.push(new p(g,j));return e};p.getRsBlockTable=function(a,c){switch(c){case 1:return p.RS_BLOCK_TABLE[4*(a-1)+0];case 0:return p.RS_BLOCK_TABLE[4*(a-1)+1];case 3:return p.RS_BLOCK_TABLE[4*
(a-1)+2];case 2:return p.RS_BLOCK_TABLE[4*(a-1)+3]}};t.prototype={get:function(a){return 1==(this.buffer[Math.floor(a/8)]>>>7-a%8&1)},put:function(a,c){for(var d=0;d<c;d++)this.putBit(1==(a>>>c-d-1&1))},getLengthInBits:function(){return this.length},putBit:function(a){var c=Math.floor(this.length/8);this.buffer.length<=c&&this.buffer.push(0);a&&(this.buffer[c]|=128>>>this.length%8);this.length++}};"string"===typeof h&&(h={text:h});h=r.extend({},{render:"canvas",width:256,height:256,typeNumber:-1,
correctLevel:2,background:"#ffffff",foreground:"#000000"},h);return this.each(function(){var a;if("canvas"==h.render){a=new o(h.typeNumber,h.correctLevel);a.addData(h.text);a.make();var c=document.createElement("canvas");c.width=h.width;c.height=h.height;for(var d=c.getContext("2d"),b=h.width/a.getModuleCount(),e=h.height/a.getModuleCount(),f=0;f<a.getModuleCount();f++)for(var i=0;i<a.getModuleCount();i++){d.fillStyle=a.isDark(f,i)?h.foreground:h.background;var g=Math.ceil((i+1)*b)-Math.floor(i*b),
j=Math.ceil((f+1)*b)-Math.floor(f*b);d.fillRect(Math.round(i*b),Math.round(f*e),g,j)}}else{a=new o(h.typeNumber,h.correctLevel);a.addData(h.text);a.make();c=r("<table></table>").css("width",h.width+"px").css("height",h.height+"px").css("border","0px").css("border-collapse","collapse").css("background-color",h.background);d=h.width/a.getModuleCount();b=h.height/a.getModuleCount();for(e=0;e<a.getModuleCount();e++){f=r("<tr></tr>").css("height",b+"px").appendTo(c);for(i=0;i<a.getModuleCount();i++)r("<td></td>").css("width",
d+"px").css("background-color",a.isDark(e,i)?h.foreground:h.background).appendTo(f)}}a=c;jQuery(a).appendTo(this)})}})(jQuery);

/**
 * jquery.bookblock.min.js v2.0.1
 * http://www.codrops.com
 *
 * Licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 *
 * Copyright 2013, Codrops
 * http://www.codrops.com
 */
(function(f,g,d){var c=f(g),e=g.Modernizr;e.addTest("csstransformspreserve3d",function(){var l=e.prefixed("transformStyle");var k="preserve-3d";var j;if(!l){return false}l=l.replace(/([A-Z])/g,function(n,m){return"-"+m.toLowerCase()}).replace(/^ms-/,"-ms-");e.testStyles("#modernizr{"+l+":"+k+";}",function(m,n){j=g.getComputedStyle?getComputedStyle(m,null).getPropertyValue(l):""});return(j===k)});var a=f.event,b,i;b=a.special.debouncedresize={setup:function(){f(this).on("resize",b.handler)},teardown:function(){f(this).off("resize",b.handler)},handler:function(n,j){var m=this,l=arguments,k=function(){n.type="debouncedresize";a.dispatch.apply(m,l)};if(i){clearTimeout(i)}j?k():i=setTimeout(k,b.threshold)},threshold:150};f.BookBlock=function(j,k){this.$el=f(k);this._init(j)};f.BookBlock.defaults={orientation:"vertical",direction:"ltr",speed:1000,easing:"ease-in-out",shadows:true,shadowSides:0.2,shadowFlip:0.1,circular:false,nextEl:"",prevEl:"",autoplay:false,interval:3000,onEndFlip:function(j,l,k){return false},onBeforeFlip:function(j){return false}};f.BookBlock.prototype={_init:function(j){this.options=f.extend(true,{},f.BookBlock.defaults,j);this.$el.addClass("bb-"+this.options.orientation);this.$items=this.$el.children(".bb-item").hide();this.itemsCount=this.$items.length;this.current=0;this.previous=-1;this.$current=this.$items.eq(this.current).show();this.elWidth=this.$el.width();var k={WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"oTransitionEnd",msTransition:"MSTransitionEnd",transition:"transitionend"};this.transEndEventName=k[e.prefixed("transition")]+".bookblock";this.support=e.csstransitions&&e.csstransforms3d&&e.csstransformspreserve3d;this._initEvents();if(this.options.autoplay){this.options.circular=true;this._startSlideshow()}},_initEvents:function(){var j=this;if(this.options.nextEl!==""){f(this.options.nextEl).on("click.bookblock touchstart.bookblock",function(){j._action("next");return false})}if(this.options.prevEl!==""){f(this.options.prevEl).on("click.bookblock touchstart.bookblock",function(){j._action("prev");return false})}c.on("debouncedresize",function(){j.elWidth=j.$el.width()})},_action:function(j,k){this._stopSlideshow();this._navigate(j,k)},_navigate:function(j,k){if(this.isAnimating){return false}this.options.onBeforeFlip(this.current);this.isAnimating=true;this.$current=this.$items.eq(this.current);if(k!==d){this.current=k}else{if(j==="next"&&this.options.direction==="ltr"||j==="prev"&&this.options.direction==="rtl"){if(!this.options.circular&&this.current===this.itemsCount-1){this.end=true}else{this.previous=this.current;this.current=this.current<this.itemsCount-1?this.current+1:0}}else{if(j==="prev"&&this.options.direction==="ltr"||j==="next"&&this.options.direction==="rtl"){if(!this.options.circular&&this.current===0){this.end=true}else{this.previous=this.current;this.current=this.current>0?this.current-1:this.itemsCount-1}}}}this.$nextItem=!this.options.circular&&this.end?this.$current:this.$items.eq(this.current);if(!this.support){this._layoutNoSupport(j)}else{this._layout(j)}},_layoutNoSupport:function(k){this.$items.hide();this.$nextItem.show();this.end=false;this.isAnimating=false;var j=k==="next"&&this.current===this.itemsCount-1||k==="prev"&&this.current===0;this.options.onEndFlip(this.previous,this.current,j)},_layout:function(l){var v=this,u=this._addSide("left",l),o=this._addSide("middle",l),j=this._addSide("right",l),r=u.find("div.bb-overlay"),t=o.find("div.bb-flipoverlay:first"),w=o.find("div.bb-flipoverlay:last"),s=j.find("div.bb-overlay"),k=this.end?400:this.options.speed;this.$items.hide();this.$el.prepend(u,o,j);o.css({transitionDuration:k+"ms",transitionTimingFunction:this.options.easing}).on(this.transEndEventName,function(y){if(f(y.target).hasClass("bb-page")){v.$el.children(".bb-page").remove();v.$nextItem.show();v.end=false;v.isAnimating=false;var x=l==="next"&&v.current===v.itemsCount-1||l==="prev"&&v.current===0;v.options.onEndFlip(v.previous,v.current,x)}});if(l==="prev"){o.addClass("bb-flip-initial")}if(this.options.shadows&&!this.end){var n=(l==="next")?{transition:"opacity "+this.options.speed/2+"ms linear "+this.options.speed/2+"ms"}:{transition:"opacity "+this.options.speed/2+"ms linear",opacity:this.options.shadowSides},q=(l==="next")?{transition:"opacity "+this.options.speed/2+"ms linear"}:{transition:"opacity "+this.options.speed/2+"ms linear "+this.options.speed/2+"ms",opacity:this.options.shadowFlip},m=(l==="next")?{transition:"opacity "+this.options.speed/2+"ms linear "+this.options.speed/2+"ms",opacity:this.options.shadowFlip}:{transition:"opacity "+this.options.speed/2+"ms linear"},p=(l==="next")?{transition:"opacity "+this.options.speed/2+"ms linear",opacity:this.options.shadowSides}:{transition:"opacity "+this.options.speed/2+"ms linear "+this.options.speed/2+"ms"};t.css(q);w.css(m);r.css(n);s.css(p)}setTimeout(function(){o.addClass(v.end?"bb-flip-"+l+"-end":"bb-flip-"+l);if(v.options.shadows&&!v.end){t.css({opacity:l==="next"?v.options.shadowFlip:0});w.css({opacity:l==="next"?0:v.options.shadowFlip});r.css({opacity:l==="next"?v.options.shadowSides:0});s.css({opacity:l==="next"?0:v.options.shadowSides})}},25)},_addSide:function(l,k){var j;switch(l){case"left":j=f('<div class="bb-page"><div class="bb-back"><div class="bb-outer"><div class="bb-content"><div class="bb-inner">'+(k==="next"?this.$current.html():this.$nextItem.html())+'</div></div><div class="bb-overlay"></div></div></div></div>').css("z-index",102);break;case"middle":j=f('<div class="bb-page"><div class="bb-front"><div class="bb-outer"><div class="bb-content"><div class="bb-inner">'+(k==="next"?this.$current.html():this.$nextItem.html())+'</div></div><div class="bb-flipoverlay"></div></div></div><div class="bb-back"><div class="bb-outer"><div class="bb-content" style="width:'+this.elWidth+'px"><div class="bb-inner">'+(k==="next"?this.$nextItem.html():this.$current.html())+'</div></div><div class="bb-flipoverlay"></div></div></div></div>').css("z-index",103);break;case"right":j=f('<div class="bb-page"><div class="bb-front"><div class="bb-outer"><div class="bb-content"><div class="bb-inner">'+(k==="next"?this.$nextItem.html():this.$current.html())+'</div></div><div class="bb-overlay"></div></div></div></div>').css("z-index",101);break}return j},_startSlideshow:function(){var j=this;this.slideshow=setTimeout(function(){j._navigate("next");if(j.options.autoplay){j._startSlideshow()}},this.options.interval)},_stopSlideshow:function(){if(this.options.autoplay){clearTimeout(this.slideshow);this.options.autoplay=false}},next:function(){this._action(this.options.direction==="ltr"?"next":"prev")},prev:function(){this._action(this.options.direction==="ltr"?"prev":"next")},jump:function(k){k-=1;if(k===this.current||k>=this.itemsCount||k<0){return false}var j;if(this.options.direction==="ltr"){j=k>this.current?"next":"prev"}else{j=k>this.current?"prev":"next"}this._action(j,k)},last:function(){this.jump(this.itemsCount)},first:function(){this.jump(1)},isActive:function(){return this.isAnimating},update:function(){var j=this.$items.eq(this.current);this.$items=this.$el.children(".bb-item");this.itemsCount=this.$items.length;this.current=j.index()},destroy:function(){if(this.options.autoplay){this._stopSlideshow()}this.$el.removeClass("bb-"+this.options.orientation);this.$items.show();if(this.options.nextEl!==""){f(this.options.nextEl).off(".bookblock")}if(this.options.prevEl!==""){f(this.options.prevEl).off(".bookblock")}c.off("debouncedresize")}};var h=function(j){if(g.console){g.console.error(j)}};f.fn.bookblock=function(k){if(typeof k==="string"){var j=Array.prototype.slice.call(arguments,1);this.each(function(){var l=f.data(this,"bookblock");if(!l){h("cannot call methods on bookblock prior to initialization; attempted to call method '"+k+"'");return}if(!f.isFunction(l[k])||k.charAt(0)==="_"){h("no such method '"+k+"' for bookblock instance");return}l[k].apply(l,j)})}else{this.each(function(){var l=f.data(this,"bookblock");if(l){l._init()}else{l=f.data(this,"bookblock",new f.BookBlock(k,this))}})}return this}})(jQuery,window);

/**
 * jquery.bookblock.js v2.0.1
 * http://www.codrops.com
 *
 * Licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 *
 * Copyright 2013, Codrops
 * http://www.codrops.com
 */
;( function( $, window, undefined ) {

    'use strict';

    // global
    var $window = $(window),
        Modernizr = window.Modernizr;

    // https://gist.github.com/edankwan/4389601
    Modernizr.addTest('csstransformspreserve3d', function () {
        var prop = Modernizr.prefixed('transformStyle');
        var val = 'preserve-3d';
        var computedStyle;
        if(!prop) return false;

        prop = prop.replace(/([A-Z])/g, function(str,m1){ return '-' + m1.toLowerCase(); }).replace(/^ms-/,'-ms-');

        Modernizr.testStyles('#modernizr{' + prop + ':' + val + ';}', function (el, rule) {
            computedStyle = window.getComputedStyle ? getComputedStyle(el, null).getPropertyValue(prop) : '';
        });

        return (computedStyle === val);
    });

    /*
    * debouncedresize: special jQuery event that happens once after a window resize
    *
    * latest version and complete README available on Github:
    * https://github.com/louisremi/jquery-smartresize
    *
    * Copyright 2012 @louis_remi
    * Licensed under the MIT license.
    *
    * This saved you an hour of work?
    * Send me music http://www.amazon.co.uk/wishlist/HNTU0468LQON
    */
    var $event = $.event,
        $special,
        resizeTimeout;

    $special = $event.special.debouncedresize = {
        setup: function() {
            $( this ).on( "resize", $special.handler );
        },
        teardown: function() {
            $( this ).off( "resize", $special.handler );
        },
        handler: function( event, execAsap ) {
            // Save the context
            var context = this,
                args = arguments,
                dispatch = function() {
                    // set correct event type
                    event.type = "debouncedresize";
                    $event.dispatch.apply( context, args );
                };

            if ( resizeTimeout ) {
                clearTimeout( resizeTimeout );
            }

            execAsap ?
                dispatch() :
                resizeTimeout = setTimeout( dispatch, $special.threshold );
        },
        threshold: 150
    };

    $.BookBlock = function( options, element ) {
        this.$el = $( element );
        this._init( options );
    };

    // the options
    $.BookBlock.defaults = {
        // vertical or horizontal flip
        orientation : 'vertical',
        // ltr (left to right) or rtl (right to left)
        direction : 'ltr',
        // speed for the flip transition in ms
        speed : 1000,
        // easing for the flip transition
        easing : 'ease-in-out',
        // if set to true, both the flipping page and the sides will have an overlay to simulate shadows
        shadows : true,
        // opacity value for the "shadow" on both sides (when the flipping page is over it)
        // value : 0.1 - 1
        shadowSides : 0.2,
        // opacity value for the "shadow" on the flipping page (while it is flipping)
        // value : 0.1 - 1
        shadowFlip : 0.1,
        // if we should show the first item after reaching the end
        circular : false,
        // if we want to specify a selector that triggers the next() function. example: ´#bb-nav-next´
        nextEl : '',
        // if we want to specify a selector that triggers the prev() function
        prevEl : '',
        // autoplay. If true it overwrites the circular option to true
        autoplay : false,
        // time (ms) between page switch, if autoplay is true
        interval : 3000,
        // callback after the flip transition
        // old is the index of the previous item
        // page is the current item´s index
        // isLimit is true if the current page is the last one (or the first one)
        onEndFlip : function(old, page, isLimit) { return false; },
        // callback before the flip transition
        // page is the current item´s index
        onBeforeFlip : function(page) { return false; }
    };

    $.BookBlock.prototype = {
        _init : function(options) {
            // options
            this.options = $.extend( true, {}, $.BookBlock.defaults, options );
            // orientation class
            this.$el.addClass( 'bb-' + this.options.orientation );
            // items
            this.$items = this.$el.children( '.bb-item' ).hide();
            // total items
            this.itemsCount = this.$items.length;
            // current item´s index
            this.current = 0;
            // previous item´s index
            this.previous = -1;
            // show first item
            this.$current = this.$items.eq( this.current ).show();
            // get width of this.$el
            // this will be necessary to create the flipping layout
            this.elWidth = this.$el.width();
            var transEndEventNames = {
                'WebkitTransition': 'webkitTransitionEnd',
                'MozTransition': 'transitionend',
                'OTransition': 'oTransitionEnd',
                'msTransition': 'MSTransitionEnd',
                'transition': 'transitionend'
            };
            this.transEndEventName = transEndEventNames[Modernizr.prefixed( 'transition' )] + '.bookblock';
            // support css 3d transforms && css transitions && Modernizr.csstransformspreserve3d
            this.support = Modernizr.csstransitions && Modernizr.csstransforms3d && Modernizr.csstransformspreserve3d;
            // initialize/bind some events
            this._initEvents();
            // start slideshow
            if ( this.options.autoplay ) {
                this.options.circular = true;
                this._startSlideshow();
            }
        },
        _initEvents : function() {

            var self = this;

            if ( this.options.nextEl !== '' ) {
                $( this.options.nextEl ).on( 'click.bookblock touchstart.bookblock', function() { self._action( 'next' ); return false; } );
            }

            if ( this.options.prevEl !== '' ) {
                $( this.options.prevEl ).on( 'click.bookblock touchstart.bookblock', function() { self._action( 'prev' ); return false; } );
            }

            $window.on( 'debouncedresize', function() {
                // update width value
                self.elWidth = self.$el.width();
            } );

        },
        _action : function( dir, page ) {
            this._stopSlideshow();
            this._navigate( dir, page );
        },
        _navigate : function( dir, page ) {

            if ( this.isAnimating ) {
                return false;
            }

            // callback trigger
            this.options.onBeforeFlip( this.current );

            this.isAnimating = true;
            // update current value
            this.$current = this.$items.eq( this.current );

            if ( page !== undefined ) {
                this.current = page;
            }
            else if ( dir === 'next' && this.options.direction === 'ltr' || dir === 'prev' && this.options.direction === 'rtl' ) {
                if ( !this.options.circular && this.current === this.itemsCount - 1 ) {
                    this.end = true;
                }
                else {
                    this.previous = this.current;
                    this.current = this.current < this.itemsCount - 1 ? this.current + 1 : 0;
                }
            }
            else if ( dir === 'prev' && this.options.direction === 'ltr' || dir === 'next' && this.options.direction === 'rtl' ) {
                if ( !this.options.circular && this.current === 0 ) {
                    this.end = true;
                }
                else {
                    this.previous = this.current;
                    this.current = this.current > 0 ? this.current - 1 : this.itemsCount - 1;
                }
            }

            this.$nextItem = !this.options.circular && this.end ? this.$current : this.$items.eq( this.current );

            if ( !this.support ) {
                this._layoutNoSupport( dir );
            } else {
                this._layout( dir );
            }

        },
        _layoutNoSupport : function(dir) {
            this.$items.hide();
            this.$nextItem.show();
            this.end = false;
            this.isAnimating = false;
            var isLimit = dir === 'next' && this.current === this.itemsCount - 1 || dir === 'prev' && this.current === 0;
            // callback trigger
            this.options.onEndFlip( this.previous, this.current, isLimit );
        },
        // creates the necessary layout for the 3d structure
        _layout : function(dir) {

            var self = this,
                // basic structure: 1 element for the left side.
                $s_left = this._addSide( 'left', dir ),
                // 1 element for the flipping/middle page
                $s_middle = this._addSide( 'middle', dir ),
                // 1 element for the right side
                $s_right = this._addSide( 'right', dir ),
                // overlays
                $o_left = $s_left.find( 'div.bb-overlay' ),
                $o_middle_f = $s_middle.find( 'div.bb-flipoverlay:first' ),
                $o_middle_b = $s_middle.find( 'div.bb-flipoverlay:last' ),
                $o_right = $s_right.find( 'div.bb-overlay' ),
                speed = this.end ? 400 : this.options.speed;
            var partid = this.$current.data('partid');
            var nextPartId = this.$nextItem.data("partid");
            var productType = this.$current.data("producttype");
            if((partid && nextPartId && !productType) || (productType == 'CALENDAR' && ((partid != 'P' && partid != 'B1') || (nextPartId != 'P' && nextPartId != 'B1')))){
                if(partid !== nextPartId){
                    $s_middle.find(".bb-outer").css({overflow: 'inherit'});
                    $s_left.hide();
                    $s_right.hide();
                }
                if(partid !== "P"){
                    if(this.previous === 0 && this.current === 1){
                        $s_right.css({'opacity':0});
                    }
                    if(this.previous === this.itemsCount - 1 &&  this.current === this.itemsCount - 2){
                        $s_left.css({'opacity':0});
                    }
                }
            }
            this.$items.hide();
            this.$el.prepend( $s_left, $s_middle, $s_right );

            $s_middle.css({
                transitionDuration: speed + 'ms',
                transitionTimingFunction : this.options.easing
            }).on( this.transEndEventName, function( event ) {
                if ( $( event.target ).hasClass( 'bb-page' ) ) {
                    self.$el.children( '.bb-page' ).remove();
                    self.$nextItem.show();
                    self.end = false;
                    self.isAnimating = false;
                    var isLimit = dir === 'next' && self.current === self.itemsCount - 1 || dir === 'prev' && self.current === 0;
                    // callback trigger
                    self.options.onEndFlip( self.previous, self.current, isLimit );
                }
            });

            if ( dir === 'prev' ) {
                $s_middle.addClass( 'bb-flip-initial' );
            }

            // overlays
            if (this.options.shadows && !this.end) {

                var o_left_style = (dir === 'next') ? {
                        transition: 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear' + ' ' + this.options.speed / 2 + 'ms'
                    } : {
                        transition: 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear',
                        opacity: this.options.shadowSides
                    },
                    o_middle_f_style = (dir === 'next') ? {
                        transition: 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear'
                    } : {
                        transition: 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear' + ' ' + this.options.speed / 2 + 'ms',
                        opacity: this.options.shadowFlip
                    },
                    o_middle_b_style = (dir === 'next') ? {
                        transition: 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear' + ' ' + this.options.speed / 2 + 'ms',
                        opacity: this.options.shadowFlip
                    } : {
                        transition: 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear'
                    },
                    o_right_style = (dir === 'next') ? {
                        transition: 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear',
                        opacity: this.options.shadowSides
                    } : {
                        transition: 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear' + ' ' + this.options.speed / 2 + 'ms'
                    };

                $o_middle_f.css(o_middle_f_style);
                $o_middle_b.css(o_middle_b_style);
                $o_left.css(o_left_style);
                $o_right.css(o_right_style);

            }

            setTimeout( function() {
                // first && last pages lift slightly up when we can't go further
                $s_middle.addClass( self.end ? 'bb-flip-' + dir + '-end' : 'bb-flip-' + dir );

                // overlays
                if ( self.options.shadows && !self.end ) {

                    $o_middle_f.css({
                        opacity: dir === 'next' ? self.options.shadowFlip : 0
                    });

                    $o_middle_b.css({
                        opacity: dir === 'next' ? 0 : self.options.shadowFlip
                    });

                    $o_left.css({
                        opacity: dir === 'next' ? self.options.shadowSides : 0
                    });

                    $o_right.css({
                        opacity: dir === 'next' ? 0 : self.options.shadowSides
                    });

                }
            }, 25 );
        },
        // adds the necessary sides (bb-page) to the layout
        _addSide : function( side, dir ) {
            var $side;

            switch (side) {
                case 'left':
                    /*
                    <div class="bb-page" style="z-index:102;">
                        <div class="bb-back">
                            <div class="bb-outer">
                                <div class="bb-content">
                                    <div class="bb-inner">
                                        dir==='next' ? [content of current page] : [content of next page]
                                    </div>
                                </div>
                                <div class="bb-overlay"></div>
                            </div>
                        </div>
                    </div>
                    */
                    $side = $('<div class="bb-page"><div class="bb-back"><div class="bb-outer"><div class="bb-content"><div class="bb-inner">' + ( dir === 'next' ? this.$current.html() : this.$nextItem.html() ) + '</div></div><div class="bb-overlay"></div></div></div></div>').css( 'z-index', 102 );
                    break;
                case 'middle':
                    /*
                    <div class="bb-page" style="z-index:103;">
                        <div class="bb-front">
                            <div class="bb-outer">
                                <div class="bb-content">
                                    <div class="bb-inner">
                                        dir==='next' ? [content of current page] : [content of next page]
                                    </div>
                                </div>
                                <div class="bb-flipoverlay"></div>
                            </div>
                        </div>
                        <div class="bb-back">
                            <div class="bb-outer">
                                <div class="bb-content">
                                    <div class="bb-inner">
                                        dir==='next' ? [content of next page] : [content of current page]
                                    </div>
                                </div>
                                <div class="bb-flipoverlay"></div>
                            </div>
                        </div>
                    </div>
                    */
                    $side = $('<div class="bb-page"><div class="bb-front"><div class="bb-outer"><div class="bb-content"><div class="bb-inner">' + (dir === 'next' ? this.$current.html() : this.$nextItem.html()) + '</div></div><div class="bb-flipoverlay"></div></div></div><div class="bb-back"><div class="bb-outer"><div class="bb-content" style="width:' + this.elWidth + 'px"><div class="bb-inner">' + ( dir === 'next' ? this.$nextItem.html() : this.$current.html() ) + '</div></div><div class="bb-flipoverlay"></div></div></div></div>').css( 'z-index', 103 );
                    break;
                case 'right':
                    /*
                    <div class="bb-page" style="z-index:101;">
                        <div class="bb-front">
                            <div class="bb-outer">
                                <div class="bb-content">
                                    <div class="bb-inner">
                                        dir==='next' ? [content of next page] : [content of current page]
                                    </div>
                                </div>
                                <div class="bb-overlay"></div>
                            </div>
                        </div>
                    </div>
                    */
                    $side = $('<div class="bb-page"><div class="bb-front"><div class="bb-outer"><div class="bb-content"><div class="bb-inner">' + ( dir === 'next' ? this.$nextItem.html() : this.$current.html() ) + '</div></div><div class="bb-overlay"></div></div></div></div>').css( 'z-index', 101 );
                    break;
            }

            return $side;
        },
        _startSlideshow : function() {
            var self = this;
            this.slideshow = setTimeout( function() {
                self._navigate( 'next' );
                if ( self.options.autoplay ) {
                    self._startSlideshow();
                }
            }, this.options.interval );
        },
        _stopSlideshow : function() {
            if ( this.options.autoplay ) {
                clearTimeout( this.slideshow );
                this.options.autoplay = false;
            }
        },
        // public method: flips next
        next : function() {
            this._action( this.options.direction === 'ltr' ? 'next' : 'prev' );
        },
        // public method: flips back
        prev : function() {
            this._action( this.options.direction === 'ltr' ? 'prev' : 'next' );
        },
        // public method: goes to a specific page
        jump : function( page ) {

            page -= 1;

            if ( page === this.current || page >= this.itemsCount || page < 0 ) {
                return false;
            }

            var dir;
            if( this.options.direction === 'ltr' ) {
                dir = page > this.current ? 'next' : 'prev';
            }
            else {
                dir = page > this.current ? 'prev' : 'next';
            }
            this._action( dir, page );

        },
        // public method: goes to the last page
        last : function() {
            this.jump( this.itemsCount );
        },
        // public method: goes to the first page
        first : function() {
            this.jump( 1 );
        },
        // public method: check if isAnimating is true
        isActive: function() {
            return this.isAnimating;
        },
        // public method: dynamically adds new elements
        // call this method after inserting new "bb-item" elements inside the BookBlock
        update : function () {
            var $currentItem = this.$items.eq( this.current );
            this.$items = this.$el.children( '.bb-item' );
            this.itemsCount = this.$items.length;
            this.current = $currentItem.index();
        },
        destroy : function() {
            if ( this.options.autoplay ) {
                this._stopSlideshow();
            }
            this.$el.removeClass( 'bb-' + this.options.orientation );
            this.$items.show();

            if ( this.options.nextEl !== '' ) {
                $( this.options.nextEl ).off( '.bookblock' );
            }

            if ( this.options.prevEl !== '' ) {
                $( this.options.prevEl ).off( '.bookblock' );
            }

            $window.off( 'debouncedresize' );
        }
    }

    var logError = function( message ) {
        if ( window.console ) {
            window.console.error( message );
        }
    };

    $.fn.bookblock = function( options ) {
        if ( typeof options === 'string' ) {
            var args = Array.prototype.slice.call( arguments, 1 );
            this.each(function() {
                var instance = $.data( this, 'bookblock' );
                if ( !instance ) {
                    logError( "cannot call methods on bookblock prior to initialization; " +
                        "attempted to call method '" + options + "'" );
                    return;
                }
                if ( !$.isFunction( instance[options] ) || options.charAt(0) === "_" ) {
                    logError( "no such method '" + options + "' for bookblock instance" );
                    return;
                }
                instance[ options ].apply( instance, args );
            });
        }
        else {
            this.each(function() {
                var instance = $.data( this, 'bookblock' );
                if ( instance ) {
                    instance._init();
                }
                else {
                    instance = $.data( this, 'bookblock', new $.BookBlock( options, this ) );
                }
            });
        }
        return this;
    };

} )( jQuery, window );

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info" data-translate="global.item-count" ' +
        'translate-value-first="{{(($ctrl.page - 1) * $ctrl.itemsPerPage) === 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}}" ' +
        'translate-value-second="{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}}" ' +
        'translate-value-total="{{$ctrl.queryCount}}">' +
        'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
        '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
        'of {{$ctrl.queryCount}} items.' +
        '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('editorApp')
        .component('jhiItemCount', jhiItemCount);
})();


var Image2Path = (function() {

	var threshold = 100;
	var bm = null,
      pathlist = [],
      callback,
      renderID = -1,
      info = {
        isReady: false,
        turnpolicy: "minority", 
        turdsize: 2,
        optcurve: true,
        alphamax: 1,
        opttolerance: 0.2
      };

	function Point(x, y) {
	    this.x = x;
	    this.y = y;
	}
	  
	Point.prototype.copy = function(){
	    return new Point(this.x, this.y);
	};

	function Bitmap(w, h) {
	    this.w = w;
	    this.h = h;
	    this.size = w * h;
	    this.arraybuffer = new ArrayBuffer(this.size);
	    this.data = new Int8Array(this.arraybuffer);
	}

	Bitmap.prototype.at = function (x, y) {
	    return (x >= 0 && x < this.w && y >=0 && y < this.h) && 
	        this.data[this.w * y + x] === 1;
	};

	Bitmap.prototype.index = function(i) {
	    var point = new Point();
	    point.y = Math.floor(i / this.w);
	    point.x = i - point.y * this.w;
	    return point;
	};

	Bitmap.prototype.flip = function(x, y) {
	    if (this.at(x, y)) {
	      this.data[this.w * y + x] = 0;
	    } else {
	      this.data[this.w * y + x] = 1;
	    }
	};
	    
	Bitmap.prototype.copy = function() {
	    var bm = new Bitmap(this.w, this.h), i;
	    for (i = 0; i < this.size; i++) {
	      bm.data[i] = this.data[i];
	    }
	    return bm;
	};

	function Path() {
	    this.area = 0;
	    this.len = 0;
	    this.curve = {};
	    this.pt = [];
	    this.minX = 100000;
	    this.minY = 100000;
	    this.maxX= -1;
	    this.maxY = -1;
	}

	function Curve(n) {
	    this.n = n;
	    this.tag = new Array(n);
	    this.c = new Array(n * 3);
	    this.alphaCurve = 0;
	    this.vertex = new Array(n);
	    this.alpha = new Array(n);
	    this.alpha0 = new Array(n);
	    this.beta = new Array(n);
	}

	function fetchPathFromImage(imageUrl, w, h) {
		return internalFetch(imageUrl, w, h);
	}

	function internalFetch(imageUrl, w, h) {
		var promise = new Promise(function (resolve, reject) {
			try {
				getPathFromImage(imageUrl, w, h, function (data) {
					resolve(data);
				});
			} catch (e) {
				reject(e);
			}

		});
		return promise;
	}

	function getPathFromImage(imageUrl, w, h, callback) {
		if (info.isReady) {
			clear();
		}
		if (!imageUrl) {
			if (callback) {
				callback(null, "invalid imageUrl");
			}
		}
		
		// image load
		var image = new Image();
		image.onerror = function (err) {
			if (callback) {
				callback(null, err);
			}
		}
		image.src = imageUrl;
		image.setAttribute("crossOrigin",'Anonymous');
		image.onload = function() {
			var width = image.width;
			var height = image.height;
			if (w && w > 0) {
				width = w;
			}
			if (h && h > 0) {
				height = h;
			}
			var canvas = document.createElement("canvas");
			canvas.width = width;
			canvas.height = height;

			var context = canvas.getContext('2d');
			context.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);

			var pixels = context.getImageData(0, 0, width, height);
			var data = pixels.data;
			for (var i = 0; i < data.length; i += 4) {
				var red = data[i];
				var green = data[i+1];
				var blue = data[i+2];
				var alpha = data[i+3];

				// 转为白底黑色内容
				if (alpha > threshold) {
					// 不透明的为黑色内容
					// if (( 0.2126 * red + 0.7152 * green + 0.0722 * blue ) >= threshold) {
					// 	data[i] = data[i+1] = data[i+2] = 0;
					// } else {
					// 	data[i] = data[i+1] = data[i+2] = 255;
					// }
					data[i] = data[i + 1] = data[i + 2] = 0;
				}
				else {
					// 透明的为白底
					data[i] = data[i + 1] = data[i+2] = 255;
				}
				data[i+3] = 255;
			}

			context.putImageData(pixels, 0, 0 );

			loadBm(canvas);

			try {
				process(function (res) {
					if (res && res.done) {
						if (callback) {
							callback(pathlist);
						}
					} 
				});
			} catch (e) {
				if (callback) {
					callback(null, e);
				}
			}
		}

		
	}

	function loadBm(canvas) {
		var ctx = canvas.getContext('2d');
	    bm = new Bitmap(canvas.width, canvas.height);
	    var imgdataobj = ctx.getImageData(0, 0, bm.w, bm.h);
	    var l = imgdataobj.data.length, i, j, color;
	    for (i = 0, j = 0; i < l; i += 4, j++) {
	      color = 0.2126 * imgdataobj.data[i] + 0.7153 * imgdataobj.data[i + 1] +
	          0.0721 * imgdataobj.data[i + 2];
	      bm.data[j] = (color < 128 ? 1 : 0);
	    }
	    info.isReady = true;
	}

	function clear() {
	    bm = null;
	    pathlist = [];
	    info.isReady = false;
	    renderID = -1;
	}

	function bmToPathlist() {
	    var bm1 = bm.copy(),
	      currentPoint = new Point(0, 0),
	      path;
	    
	    function findNext(point) {
	      var i = bm1.w * point.y + point.x;
	      while (i < bm1.size && bm1.data[i] !== 1) {
	        i++;
	      }

	      return i < bm1.size && bm1.index(i);
	    }
	    
	    function majority(x, y) {
	      var i, a, ct;
	      for (i = 2; i < 5; i++) {
	        ct = 0;
	        for (a = -i + 1; a <= i - 1; a++) {
	          ct += bm1.at(x + a, y + i - 1) ? 1 : -1;
	          ct += bm1.at(x + i - 1, y + a - 1) ? 1 : -1;
	          ct += bm1.at(x + a - 1, y - i) ? 1 : -1;
	          ct += bm1.at(x - i, y + a) ? 1 : -1;
	        }
	        if (ct > 0) {
	          return 1;
	        } else if (ct < 0) {
	          return 0;
	        }
	      }
	      return 0;
	    }
	    
	    function findPath(point) {
	      var path = new Path(),
	        x = point.x, y = point.y,
	        dirx = 0, diry = 1, tmp;
	      
	      path.sign = bm.at(point.x, point.y) ? "+" : "-";
	      
	      while (1) {
	        path.pt.push(new Point(x, y));
	        if (x > path.maxX)
	          path.maxX = x;
	        if (x < path.minX)
	          path.minX = x;
	        if (y > path.maxY)
	          path.maxY = y;
	        if (y < path.minY)
	          path.minY = y;
	        path.len++;
	        
	        x += dirx;
	        y += diry;
	        path.area -= x * diry;
	        
	        if (x === point.x && y === point.y)
	          break;
	        
	        var l = bm1.at(x + (dirx + diry - 1 ) / 2, y + (diry - dirx - 1) / 2);
	        var r = bm1.at(x + (dirx - diry - 1) / 2, y + (diry + dirx - 1) / 2);
	        
	        if (r && !l) {
	          if (info.turnpolicy === "right" ||
	          (info.turnpolicy === "black" && path.sign === '+') ||
	          (info.turnpolicy === "white" && path.sign === '-') ||
	          (info.turnpolicy === "majority" && majority(x, y)) ||
	          (info.turnpolicy === "minority" && !majority(x, y))) {
	            tmp = dirx;
	            dirx = -diry;
	            diry = tmp;
	          } else {
	            tmp = dirx;
	            dirx = diry;
	            diry = -tmp;
	          }
	        } else if (r) {
	          tmp = dirx;
	          dirx = -diry;
	          diry = tmp;
	        } else if (!l) {
	          tmp = dirx;
	          dirx = diry;
	          diry = -tmp;
	        }
	      }
	      return path;
	    }
	    
	    function xorPath(path){
	      var y1 = path.pt[0].y,
	        len = path.len,
	        x, y, maxX, minY, i, j;
	      for (i = 1; i < len; i++) {
	        x = path.pt[i].x;
	        y = path.pt[i].y;
	        
	        if (y !== y1) {
	          minY = y1 < y ? y1 : y;
	          maxX = path.maxX;
	          for (j = x; j < maxX; j++) {
	            bm1.flip(j, minY);
	          }
	          y1 = y;
	        }
	      }
	      
	    }
	    
	    while (currentPoint = findNext(currentPoint)) {

	      path = findPath(currentPoint);
	      
	      xorPath(path);
	      
	      if (path.area > info.turdsize) {
	        pathlist.push(path);
	      }
	    }
	    
	  }
	  

	  function processPath( firstPathIndex, thisRenderID, doneCallback ) {
	    //cancel render process if another has been started
	    if ( thisRenderID !== renderID ) {
	      if ( callback ) callback ( { aborted: true, renderID: thisRenderID } )
	      return;
	    }
	  
	    function Quad() {
	      this.data = [0,0,0,0,0,0,0,0,0];
	    }

	    Quad.prototype.at = function(x, y) {
	      return this.data[x * 3 + y];
	    };
	    
	    function Sum(x, y, xy, x2, y2) {
	      this.x = x;
	      this.y = y;
	      this.xy = xy;
	      this.x2 = x2;
	      this.y2 = y2;
	    }
	    
	    function mod(a, n) {
	        return a >= n ? a % n : a>=0 ? a : n-1-(-1-a) % n;
	    }
	  
	    function xprod(p1, p2) {
	      return p1.x * p2.y - p1.y * p2.x;
	    }
	    
	    function cyclic(a, b, c) {
	      if (a <= c) {
	        return (a <= b && b < c);
	      } else {
	        return (a <= b || b < c);
	      }
	    }
	      
	    function sign(i) {
	      return i > 0 ? 1 : i < 0 ? -1 : 0;
	    }
	    
	    function quadform(Q, w) {
	      var v = new Array(3), i, j, sum;
	    
	      v[0] = w.x;
	      v[1] = w.y;
	      v[2] = 1;
	      sum = 0.0;
	    
	      for (i=0; i<3; i++) {
	        for (j=0; j<3; j++) {
	          sum += v[i] * Q.at(i, j) * v[j];
	        }
	      }
	      return sum;
	    }
	  
	    function interval(lambda, a, b) {
	      var res = new Point();
	    
	      res.x = a.x + lambda * (b.x - a.x);
	      res.y = a.y + lambda * (b.y - a.y);
	      return res;
	    }
	    
	    function dorth_infty(p0, p2) {
	      var r = new Point();
	      
	      r.y = sign(p2.x - p0.x);
	      r.x = -sign(p2.y - p0.y);
	    
	      return r;
	    }
	    
	    function ddenom(p0, p2) {
	      var r = dorth_infty(p0, p2);
	    
	      return r.y * (p2.x - p0.x) - r.x * (p2.y - p0.y);
	    }
	    
	    function dpara(p0, p1, p2) {
	      var x1, y1, x2, y2;
	    
	      x1 = p1.x - p0.x;
	      y1 = p1.y - p0.y;
	      x2 = p2.x - p0.x;
	      y2 = p2.y - p0.y;
	    
	      return x1 * y2 - x2 * y1;
	    }
	    
	    function cprod(p0, p1, p2, p3) {
	      var x1, y1, x2, y2;
	    
	      x1 = p1.x - p0.x;
	      y1 = p1.y - p0.y;
	      x2 = p3.x - p2.x;
	      y2 = p3.y - p2.y;
	    
	      return x1 * y2 - x2 * y1;
	    }
	      
	    function iprod(p0, p1, p2) {
	      var x1, y1, x2, y2;
	    
	      x1 = p1.x - p0.x;
	      y1 = p1.y - p0.y;
	      x2 = p2.x - p0.x;
	      y2 = p2.y - p0.y;
	    
	      return x1*x2 + y1*y2;
	    }
	      
	    function iprod1(p0, p1, p2, p3) {
	      var x1, y1, x2, y2;
	    
	      x1 = p1.x - p0.x;
	      y1 = p1.y - p0.y;
	      x2 = p3.x - p2.x;
	      y2 = p3.y - p2.y;
	    
	      return x1 * x2 + y1 * y2;
	    }
	    
	    function ddist(p, q) {
	      return Math.sqrt((p.x - q.x) * (p.x - q.x) + (p.y - q.y) * (p.y - q.y));
	    }
	    
	    function bezier(t, p0, p1, p2, p3) {
	      var s = 1 - t, res = new Point();
	    
	      res.x = s*s*s*p0.x + 3*(s*s*t)*p1.x + 3*(t*t*s)*p2.x + t*t*t*p3.x;
	      res.y = s*s*s*p0.y + 3*(s*s*t)*p1.y + 3*(t*t*s)*p2.y + t*t*t*p3.y;
	    
	      return res;
	    }
	  
	    function tangent(p0, p1, p2, p3, q0, q1) {
	      var A, B, C, a, b, c, d, s, r1, r2;
	    
	      A = cprod(p0, p1, q0, q1);
	      B = cprod(p1, p2, q0, q1);
	      C = cprod(p2, p3, q0, q1);
	    
	      a = A - 2 * B + C;
	      b = -2 * A + 2 * B;
	      c = A;
	      
	      d = b * b - 4 * a * c;
	    
	      if (a===0 || d<0) {
	        return -1.0;
	      }
	    
	      s = Math.sqrt(d);
	    
	      r1 = (-b + s) / (2 * a);
	      r2 = (-b - s) / (2 * a);
	    
	      if (r1 >= 0 && r1 <= 1) {
	        return r1;
	      } else if (r2 >= 0 && r2 <= 1) {
	        return r2;
	      } else {
	        return -1.0;
	      }
	    }
	    
	    function calcSums(path) {
	      var i, x, y;
	      path.x0 = path.pt[0].x;
	      path.y0 = path.pt[0].y;
	      
	      path.sums = [];
	      var s = path.sums;
	      s.push(new Sum(0, 0, 0, 0, 0));
	      for(i = 0; i < path.len; i++){
	        x = path.pt[i].x - path.x0;
	        y = path.pt[i].y - path.y0;
	        s.push(new Sum(s[i].x + x, s[i].y + y, s[i].xy + x * y,
	            s[i].x2 + x * x, s[i].y2 + y * y));
	      }
	    }
	   
	    function calcLon(path) {
	      
	      var n = path.len, pt = path.pt, dir,
	        pivk = new Array(n),
	        nc = new Array(n),
	        ct = new Array(4);
	      path.lon = new Array(n);
	      
	      var constraint = [new Point(), new Point()],
	          cur = new Point(),
	          off = new Point(),
	          dk = new Point(),
	          foundk;
	      
	      var i, j, k1, a, b, c, d, k = 0;
	      for(i = n - 1; i >= 0; i--){
	        if (pt[i].x != pt[k].x && pt[i].y != pt[k].y) {
	          k = i + 1;
	        }
	        nc[i] = k;
	      }
	      
	      for (i = n - 1; i >= 0; i--) {
	        ct[0] = ct[1] = ct[2] = ct[3] = 0;
	        dir = (3 + 3 * (pt[mod(i + 1, n)].x - pt[i].x) + 
	            (pt[mod(i + 1, n)].y - pt[i].y)) / 2;
	        ct[dir]++;
	        
	        constraint[0].x = 0;
	        constraint[0].y = 0;
	        constraint[1].x = 0;
	        constraint[1].y = 0;
	        
	        k = nc[i];
	        k1 = i;
	        while (1) {
	          foundk = 0;
	          dir =  (3 + 3 * sign(pt[k].x - pt[k1].x) + 
	              sign(pt[k].y - pt[k1].y)) / 2;
	          ct[dir]++;
	          
	          if (ct[0] && ct[1] && ct[2] && ct[3]) {
	            pivk[i] = k1;
	            foundk = 1;
	            break;
	          }
	          
	          cur.x = pt[k].x - pt[i].x;
	          cur.y = pt[k].y - pt[i].y;
	          
	          if (xprod(constraint[0], cur) < 0 || xprod(constraint[1], cur) > 0) {
	            break;
	          }
	              
	          if (Math.abs(cur.x) <= 1 && Math.abs(cur.y) <= 1) {
	          
	          } else {
	            off.x = cur.x + ((cur.y >= 0 && (cur.y > 0 || cur.x < 0)) ? 1 : -1);
	            off.y = cur.y + ((cur.x <= 0 && (cur.x < 0 || cur.y < 0)) ? 1 : -1);
	            if (xprod(constraint[0], off) >= 0) {
	              constraint[0].x = off.x;
	              constraint[0].y = off.y;
	            }
	            off.x = cur.x + ((cur.y <= 0 && (cur.y < 0 || cur.x < 0)) ? 1 : -1);
	            off.y = cur.y + ((cur.x >= 0 && (cur.x > 0 || cur.y < 0)) ? 1 : -1);
	            if (xprod(constraint[1], off) <= 0) {
	              constraint[1].x = off.x;
	              constraint[1].y = off.y;
	            }
	          }
	          k1 = k;
	          k = nc[k1];
	          if (!cyclic(k, i, k1)) {
	            break;
	          }
	        }
	        if (foundk === 0) {
	          dk.x = sign(pt[k].x-pt[k1].x);
	          dk.y = sign(pt[k].y-pt[k1].y);
	          cur.x = pt[k1].x - pt[i].x;
	          cur.y = pt[k1].y - pt[i].y;
	  
	          a = xprod(constraint[0], cur);
	          b = xprod(constraint[0], dk);
	          c = xprod(constraint[1], cur);
	          d = xprod(constraint[1], dk);
	  
	          j = 10000000;
	          if (b < 0) {
	            j = Math.floor(a / -b);
	          }
	          if (d > 0) {
	            j = Math.min(j, Math.floor(-c / d));
	          }
	          pivk[i] = mod(k1+j,n);
	        }
	      }
	      
	      j=pivk[n-1];
	      path.lon[n-1]=j;
	      for (i=n-2; i>=0; i--) {
	        if (cyclic(i+1,pivk[i],j)) {
	          j=pivk[i];
	        }
	        path.lon[i]=j;
	      }
	  
	      for (i=n-1; cyclic(mod(i+1,n),j,path.lon[i]); i--) {
	        path.lon[i] = j;
	      }
	    }
	    
	    function bestPolygon(path) {
	      
	      function penalty3(path, i, j) {
	        
	        var n = path.len, pt = path.pt, sums = path.sums;
	        var x, y, xy, x2, y2,
	          k, a, b, c, s,
	          px, py, ex, ey,
	          r = 0;
	        if (j>=n) {
	          j -= n;
	          r = 1;
	        }
	        
	        if (r === 0) {
	          x = sums[j+1].x - sums[i].x;
	          y = sums[j+1].y - sums[i].y;
	          x2 = sums[j+1].x2 - sums[i].x2;
	          xy = sums[j+1].xy - sums[i].xy;
	          y2 = sums[j+1].y2 - sums[i].y2;
	          k = j+1 - i;
	        } else {
	          x = sums[j+1].x - sums[i].x + sums[n].x;
	          y = sums[j+1].y - sums[i].y + sums[n].y;
	          x2 = sums[j+1].x2 - sums[i].x2 + sums[n].x2;
	          xy = sums[j+1].xy - sums[i].xy + sums[n].xy;
	          y2 = sums[j+1].y2 - sums[i].y2 + sums[n].y2;
	          k = j+1 - i + n;
	        } 
	      
	        px = (pt[i].x + pt[j].x) / 2.0 - pt[0].x;
	        py = (pt[i].y + pt[j].y) / 2.0 - pt[0].y;
	        ey = (pt[j].x - pt[i].x);
	        ex = -(pt[j].y - pt[i].y);
	      
	        a = ((x2 - 2*x*px) / k + px*px);
	        b = ((xy - x*py - y*px) / k + px*py);
	        c = ((y2 - 2*y*py) / k + py*py);
	        
	        s = ex*ex*a + 2*ex*ey*b + ey*ey*c;
	      
	        return Math.sqrt(s);
	      }
	      
	      var i, j, m, k,    
	      n = path.len,
	      pen = new Array(n + 1),
	      prev = new Array(n + 1),
	      clip0 = new Array(n),
	      clip1 = new Array(n + 1),
	      seg0 = new Array (n + 1),
	      seg1 = new Array(n + 1),
	      thispen, best, c;
	      
	      for (i=0; i<n; i++) {
	        c = mod(path.lon[mod(i-1,n)]-1,n);
	        if (c == i) {
	          c = mod(i+1,n);
	        }
	        if (c < i) {
	          clip0[i] = n;
	        } else {
	          clip0[i] = c;
	        }
	      }
	      
	      j = 1;
	      for (i=0; i<n; i++) {
	        while (j <= clip0[i]) {
	          clip1[j] = i;
	          j++;
	        }
	      }
	      
	      i = 0;
	      for (j=0; i<n; j++) {
	        seg0[j] = i;
	        i = clip0[i];
	      }
	      seg0[j] = n;
	      m = j;
	    
	      i = n;
	      for (j=m; j>0; j--) {
	        seg1[j] = i;
	        i = clip1[i];
	      }
	      seg1[0] = 0;
	      
	      pen[0]=0;
	      for (j=1; j<=m; j++) {
	        for (i=seg1[j]; i<=seg0[j]; i++) {
	          best = -1;
	          for (k=seg0[j-1]; k>=clip1[i]; k--) {
	            thispen = penalty3(path, k, i) + pen[k];
	            if (best < 0 || thispen < best) {
	              prev[i] = k;
	              best = thispen;
	            }
	          }
	          pen[i] = best;
	        }
	      }
	      path.m = m;
	      path.po = new Array(m);
	    
	      for (i=n, j=m-1; i>0; j--) {
	        i = prev[i];
	        path.po[j] = i;
	      }
	    }
	    
	    function adjustVertices(path) {
	      
	      function pointslope(path, i, j, ctr, dir) {
	    
	        var n = path.len, sums = path.sums,
	          x, y, x2, xy, y2,
	          k, a, b, c, lambda2, l, r=0;
	      
	        while (j>=n) {
	          j-=n;
	          r+=1;
	        }
	        while (i>=n) {
	          i-=n;
	          r-=1;
	        }
	        while (j<0) {
	          j+=n;
	          r-=1;
	        }
	        while (i<0) {
	          i+=n;
	          r+=1;
	        }
	        
	        x = sums[j+1].x-sums[i].x+r*sums[n].x;
	        y = sums[j+1].y-sums[i].y+r*sums[n].y;
	        x2 = sums[j+1].x2-sums[i].x2+r*sums[n].x2;
	        xy = sums[j+1].xy-sums[i].xy+r*sums[n].xy;
	        y2 = sums[j+1].y2-sums[i].y2+r*sums[n].y2;
	        k = j+1-i+r*n;
	        
	        ctr.x = x/k;
	        ctr.y = y/k;
	      
	        a = (x2-x*x/k)/k;
	        b = (xy-x*y/k)/k;
	        c = (y2-y*y/k)/k;
	        
	        lambda2 = (a+c+Math.sqrt((a-c)*(a-c)+4*b*b))/2;
	      
	        a -= lambda2;
	        c -= lambda2;
	      
	        if (Math.abs(a) >= Math.abs(c)) {
	          l = Math.sqrt(a*a+b*b);
	          if (l!==0) {
	            dir.x = -b/l;
	            dir.y = a/l;
	          }
	        } else {
	          l = Math.sqrt(c*c+b*b);
	          if (l!==0) {
	            dir.x = -c/l;
	            dir.y = b/l;
	          }
	        }
	        if (l===0) {
	          dir.x = dir.y = 0; 
	        }
	      }
	      
	      var m = path.m, po = path.po, n = path.len, pt = path.pt,
	        x0 = path.x0, y0 = path.y0,
	        ctr = new Array(m), dir = new Array(m),
	        q = new Array(m),
	        v = new Array(3), d, i, j, k, l,
	        s = new Point();
	      
	      path.curve = new Curve(m);
	  
	      for (i=0; i<m; i++) {
	        j = po[mod(i+1,m)];
	        j = mod(j-po[i],n)+po[i];
	        ctr[i] = new Point();
	        dir[i] = new Point();
	        pointslope(path, po[i], j, ctr[i], dir[i]);
	      }
	    
	      for (i=0; i<m; i++) {
	        q[i] = new Quad();
	        d = dir[i].x * dir[i].x + dir[i].y * dir[i].y;
	        if (d === 0.0) {
	          for (j=0; j<3; j++) {
	            for (k=0; k<3; k++) {
	              q[i].data[j * 3 + k] = 0;
	            }
	          }
	        } else {
	          v[0] = dir[i].y;
	          v[1] = -dir[i].x;
	          v[2] = - v[1] * ctr[i].y - v[0] * ctr[i].x;
	          for (l=0; l<3; l++) {
	            for (k=0; k<3; k++) {
	              q[i].data[l * 3 + k] = v[l] * v[k] / d;
	            }
	          }
	        }
	      }
	     
	      var Q, w, dx, dy, det, min, cand, xmin, ymin, z;
	      for (i=0; i<m; i++) {
	        Q = new Quad();
	        w = new Point();
	    
	        s.x = pt[po[i]].x-x0;
	        s.y = pt[po[i]].y-y0;
	    
	        j = mod(i-1,m);
	        
	        for (l=0; l<3; l++) {
	          for (k=0; k<3; k++) {
	            Q.data[l * 3 + k] = q[j].at(l, k) + q[i].at(l, k);
	          }
	        }
	        
	        while(1) {
	          
	          det = Q.at(0, 0)*Q.at(1, 1) - Q.at(0, 1)*Q.at(1, 0);
	          if (det !== 0.0) {
	            w.x = (-Q.at(0, 2)*Q.at(1, 1) + Q.at(1, 2)*Q.at(0, 1)) / det;
	            w.y = ( Q.at(0, 2)*Q.at(1, 0) - Q.at(1, 2)*Q.at(0, 0)) / det;
	            break;
	          }
	    
	          if (Q.at(0, 0)>Q.at(1, 1)) {
	            v[0] = -Q.at(0, 1);
	            v[1] = Q.at(0, 0);
	          } else if (Q.at(1, 1)) {
	            v[0] = -Q.at(1, 1);
	            v[1] = Q.at(1, 0);
	          } else {
	            v[0] = 1;
	            v[1] = 0;
	          }
	          d = v[0] * v[0] + v[1] * v[1];
	          v[2] = - v[1] * s.y - v[0] * s.x;
	          for (l=0; l<3; l++) {
	            for (k=0; k<3; k++) {
	              Q.data[l * 3 + k] += v[l] * v[k] / d;
	            }
	          }
	        }
	        dx = Math.abs(w.x-s.x);
	        dy = Math.abs(w.y-s.y);
	        if (dx <= 0.5 && dy <= 0.5) {
	          path.curve.vertex[i] = new Point(w.x+x0, w.y+y0);
	          continue;
	        }
	    
	        min = quadform(Q, s);
	        xmin = s.x;
	        ymin = s.y;
	    
	        if (Q.at(0, 0) !== 0.0) {
	          for (z=0; z<2; z++) {
	            w.y = s.y-0.5+z;
	            w.x = - (Q.at(0, 1) * w.y + Q.at(0, 2)) / Q.at(0, 0);
	            dx = Math.abs(w.x-s.x);
	            cand = quadform(Q, w);
	            if (dx <= 0.5 && cand < min) {
	              min = cand;
	              xmin = w.x;
	              ymin = w.y;
	            }
	          }
	        }
	  
	        if (Q.at(1, 1) !== 0.0) {
	          for (z=0; z<2; z++) {
	            w.x = s.x-0.5+z;
	            w.y = - (Q.at(1, 0) * w.x + Q.at(1, 2)) / Q.at(1, 1);
	            dy = Math.abs(w.y-s.y);
	            cand = quadform(Q, w);
	            if (dy <= 0.5 && cand < min) {
	              min = cand;
	              xmin = w.x;
	              ymin = w.y;
	            }
	          }
	        }
	  
	        for (l=0; l<2; l++) {
	          for (k=0; k<2; k++) {
	            w.x = s.x-0.5+l;
	            w.y = s.y-0.5+k;
	            cand = quadform(Q, w);
	            if (cand < min) {
	              min = cand;
	              xmin = w.x;
	              ymin = w.y;
	            }
	          }
	        }
	    
	        path.curve.vertex[i] = new Point(xmin + x0, ymin + y0);
	      }
	    }
	    
	    function reverse(path) {
	      var curve = path.curve, m = curve.n, v = curve.vertex, i, j, tmp;
	    
	      for (i=0, j=m-1; i<j; i++, j--) {
	        tmp = v[i];
	        v[i] = v[j];
	        v[j] = tmp;
	      }
	    }
	    
	    function smooth(path) {
	      var m = path.curve.n, curve = path.curve;

	      var i, j, k, dd, denom, alpha,
	        p2, p3, p4;
	    
	      for (i=0; i<m; i++) {
	        j = mod(i+1, m);
	        k = mod(i+2, m);
	        p4 = interval(1/2.0, curve.vertex[k], curve.vertex[j]);
	    
	        denom = ddenom(curve.vertex[i], curve.vertex[k]);
	        if (denom !== 0.0) {
	          dd = dpara(curve.vertex[i], curve.vertex[j], curve.vertex[k]) / denom;
	          dd = Math.abs(dd);
	          alpha = dd>1 ? (1 - 1.0/dd) : 0;
	          alpha = alpha / 0.75;
	        } else {
	          alpha = 4/3.0;
	        }
	        curve.alpha0[j] = alpha;
	    
	        if (alpha >= info.alphamax) { 
	          curve.tag[j] = "CORNER";
	          curve.c[3 * j + 1] = curve.vertex[j];
	          curve.c[3 * j + 2] = p4;
	        } else {
	          if (alpha < 0.55) {
	            alpha = 0.55;
	          } else if (alpha > 1) {
	            alpha = 1;
	          }
	          p2 = interval(0.5+0.5*alpha, curve.vertex[i], curve.vertex[j]);
	          p3 = interval(0.5+0.5*alpha, curve.vertex[k], curve.vertex[j]);
	          curve.tag[j] = "CURVE";
	          curve.c[3 * j + 0] = p2;
	          curve.c[3 * j + 1] = p3;
	          curve.c[3 * j + 2] = p4;
	        }
	        curve.alpha[j] = alpha;  
	        curve.beta[j] = 0.5;
	      }
	      curve.alphacurve = 1;
	    }
	    
	    function optiCurve(path) {
	      function Opti(){
	        this.pen = 0;
	        this.c = [new Point(), new Point()];
	        this.t = 0;
	        this.s = 0;
	        this.alpha = 0;
	      }
	      
	      function opti_penalty(path, i, j, res, opttolerance, convc, areac) {
	        var m = path.curve.n, curve = path.curve, vertex = curve.vertex, 
	          k, k1, k2, conv, i1,
	          area, alpha, d, d1, d2,
	          p0, p1, p2, p3, pt,
	          A, R, A1, A2, A3, A4,
	          s, t;
	      
	        if (i==j) {
	          return 1;
	        }
	      
	        k = i;
	        i1 = mod(i+1, m);
	        k1 = mod(k+1, m);
	        conv = convc[k1];
	        if (conv === 0) {
	          return 1;
	        }
	        d = ddist(vertex[i], vertex[i1]);
	        for (k=k1; k!=j; k=k1) {
	          k1 = mod(k+1, m);
	          k2 = mod(k+2, m);
	          if (convc[k1] != conv) {
	            return 1;
	          }
	          if (sign(cprod(vertex[i], vertex[i1], vertex[k1], vertex[k2])) !=
	              conv) {
	            return 1;
	          }
	          if (iprod1(vertex[i], vertex[i1], vertex[k1], vertex[k2]) <
	              d * ddist(vertex[k1], vertex[k2]) * -0.999847695156) {
	            return 1;
	          }
	        }
	    
	        p0 = curve.c[mod(i,m) * 3 + 2].copy();
	        p1 = vertex[mod(i+1,m)].copy();
	        p2 = vertex[mod(j,m)].copy();
	        p3 = curve.c[mod(j,m) * 3 + 2].copy();
	      
	        area = areac[j] - areac[i];
	        area -= dpara(vertex[0], curve.c[i * 3 + 2], curve.c[j * 3 + 2])/2;
	        if (i>=j) {
	          area += areac[m];
	        }
	      
	        A1 = dpara(p0, p1, p2);
	        A2 = dpara(p0, p1, p3);
	        A3 = dpara(p0, p2, p3);
	  
	        A4 = A1+A3-A2;    
	        
	        if (A2 == A1) {
	          return 1;
	        }
	      
	        t = A3/(A3-A4);
	        s = A2/(A2-A1);
	        A = A2 * t / 2.0;
	        
	        if (A === 0.0) {
	          return 1;
	        }
	      
	        R = area / A;
	        alpha = 2 - Math.sqrt(4 - R / 0.3);
	      
	        res.c[0] = interval(t * alpha, p0, p1);
	        res.c[1] = interval(s * alpha, p3, p2);
	        res.alpha = alpha;
	        res.t = t;
	        res.s = s;
	      
	        p1 = res.c[0].copy();
	        p2 = res.c[1].copy(); 
	      
	        res.pen = 0;
	      
	        for (k=mod(i+1,m); k!=j; k=k1) {
	          k1 = mod(k+1,m);
	          t = tangent(p0, p1, p2, p3, vertex[k], vertex[k1]);
	          if (t<-0.5) {
	            return 1;
	          }
	          pt = bezier(t, p0, p1, p2, p3);
	          d = ddist(vertex[k], vertex[k1]);
	          if (d === 0.0) {
	            return 1;
	          }
	          d1 = dpara(vertex[k], vertex[k1], pt) / d;
	          if (Math.abs(d1) > opttolerance) {
	            return 1;
	          }
	          if (iprod(vertex[k], vertex[k1], pt) < 0 ||
	              iprod(vertex[k1], vertex[k], pt) < 0) {
	            return 1;
	          }
	          res.pen += d1 * d1;
	        }
	      
	        for (k=i; k!=j; k=k1) {
	          k1 = mod(k+1,m);
	          t = tangent(p0, p1, p2, p3, curve.c[k * 3 + 2], curve.c[k1 * 3 + 2]);
	          if (t<-0.5) {
	            return 1;
	          }
	          pt = bezier(t, p0, p1, p2, p3);
	          d = ddist(curve.c[k * 3 + 2], curve.c[k1 * 3 + 2]);
	          if (d === 0.0) {
	            return 1;
	          }
	          d1 = dpara(curve.c[k * 3 + 2], curve.c[k1 * 3 + 2], pt) / d;
	          d2 = dpara(curve.c[k * 3 + 2], curve.c[k1 * 3 + 2], vertex[k1]) / d;
	          d2 *= 0.75 * curve.alpha[k1];
	          if (d2 < 0) {
	            d1 = -d1;
	            d2 = -d2;
	          }
	          if (d1 < d2 - opttolerance) {
	            return 1;
	          }
	          if (d1 < d2) {
	            res.pen += (d1 - d2) * (d1 - d2);
	          }
	        }
	      
	        return 0;
	      }
	    
	      var curve = path.curve, m = curve.n, vert = curve.vertex, 
	        pt = new Array(m + 1),
	        pen = new Array(m + 1),
	        len = new Array(m + 1),
	        opt = new Array(m + 1),
	        om, i,j,r,
	        o = new Opti(), p0,
	        i1, area, alpha, ocurve,
	        s, t;
	      
	      var convc = new Array(m), areac = new Array(m + 1);
	      
	      for (i=0; i<m; i++) {
	        if (curve.tag[i] == "CURVE") {
	          convc[i] = sign(dpara(vert[mod(i-1,m)], vert[i], vert[mod(i+1,m)]));
	        } else {
	          convc[i] = 0;
	        }
	      }
	    
	      area = 0.0;
	      areac[0] = 0.0;
	      p0 = curve.vertex[0];
	      for (i=0; i<m; i++) {
	        i1 = mod(i+1, m);
	        if (curve.tag[i1] == "CURVE") {
	          alpha = curve.alpha[i1];
	          area += 0.3 * alpha * (4-alpha) *
	              dpara(curve.c[i * 3 + 2], vert[i1], curve.c[i1 * 3 + 2])/2;
	          area += dpara(p0, curve.c[i * 3 + 2], curve.c[i1 * 3 + 2])/2;
	        }
	        areac[i+1] = area;
	      }
	    
	      pt[0] = -1;
	      pen[0] = 0;
	      len[0] = 0;
	    
	    
	      for (j=1; j<=m; j++) {
	        pt[j] = j-1;
	        pen[j] = pen[j-1];
	        len[j] = len[j-1]+1;
	    
	        for (i=j-2; i>=0; i--) {
	          r = opti_penalty(path, i, mod(j,m), o, info.opttolerance, convc, 
	              areac);
	          if (r) {
	            break;
	          }
	            if (len[j] > len[i]+1 ||
	                (len[j] == len[i]+1 && pen[j] > pen[i] + o.pen)) {
	              pt[j] = i;
	              pen[j] = pen[i] + o.pen;
	              len[j] = len[i] + 1;
	              opt[j] = o;
	              o = new Opti();
	            }
	        }
	      }
	      om = len[m];
	      ocurve = new Curve(om);
	      s = new Array(om);
	      t = new Array(om);
	    
	      j = m;
	      for (i=om-1; i>=0; i--) {
	        if (pt[j]==j-1) {
	          ocurve.tag[i]     = curve.tag[mod(j,m)];
	          ocurve.c[i * 3 + 0]    = curve.c[mod(j,m) * 3 + 0];
	          ocurve.c[i * 3 + 1]    = curve.c[mod(j,m) * 3 + 1];
	          ocurve.c[i * 3 + 2]    = curve.c[mod(j,m) * 3 + 2];
	          ocurve.vertex[i]  = curve.vertex[mod(j,m)];
	          ocurve.alpha[i]   = curve.alpha[mod(j,m)];
	          ocurve.alpha0[i]  = curve.alpha0[mod(j,m)];
	          ocurve.beta[i]    = curve.beta[mod(j,m)];
	          s[i] = t[i] = 1.0;
	        } else {
	          ocurve.tag[i] = "CURVE";
	          ocurve.c[i * 3 + 0] = opt[j].c[0];
	          ocurve.c[i * 3 + 1] = opt[j].c[1];
	          ocurve.c[i * 3 + 2] = curve.c[mod(j,m) * 3 + 2];
	          ocurve.vertex[i] = interval(opt[j].s, curve.c[mod(j,m) * 3 + 2],
	                                       vert[mod(j,m)]);
	          ocurve.alpha[i] = opt[j].alpha;
	          ocurve.alpha0[i] = opt[j].alpha;
	          s[i] = opt[j].s;
	          t[i] = opt[j].t;
	        }
	        j = pt[j];
	      }
	    
	      for (i=0; i<om; i++) {
	        i1 = mod(i+1,om);
	        ocurve.beta[i] = s[i] / (s[i] + t[i1]);
	      }
	      ocurve.alphacurve = 1;
	      path.curve = ocurve;
	    }

	    var percent = parseInt( pathlist.length / 20 );

	    for (var i = firstPathIndex || 0; i < pathlist.length; i++) {
	      var path = pathlist[i];
	      calcSums(path);
	      calcLon(path);
	      bestPolygon(path);
	      adjustVertices(path);
	      
	      if (path.sign === "-") {
	        reverse(path);
	      }
	      
	      smooth(path);
	      
	      if (info.optcurve) {
	        optiCurve(path);
	      }

	      //call callback on every 2.5% percentage change of progress
	      if ( i && ! ( i % percent ) && typeof callback === 'function' ) {
	        callback( {
	          progress: parseInt( Math.ceil( i * 100 / pathlist.length ) ),
	          continueProcess: function() {
	            processPath( i + 1, thisRenderID, doneCallback );
	          }
	        } );

	        break;
	      }
	    }

	    if ( i === pathlist.length && typeof doneCallback === 'function' ) doneCallback();
	  
	}

	function process(callback) {
		//store render ID so we can cancel any outstanding renders
		renderID++;

		bmToPathlist();
		processPath( 0, renderID, function() {
			if (callback) {
		  		callback( { done:true } );
				}
		} );

		return renderID;
	}

	return {
		fetchPathFromImage: fetchPathFromImage,
		getPathFromImage: getPathFromImage
	}

})();
// browserify support
if ( typeof module === 'object' ) {

  module.exports = Image2Path;

}
/**
 * Created by rae on 3/26/2018.
 */
window.angular.module('image.service', []).
factory('ImageService', ['$location', '$http', 'SweetAlert', '$timeout', '$rootScope', '$state','UidService', 'QiniuToken',
    function ($location, $http, SweetAlert, $timeout, $rootScope, $state, UidService, QiniuToken) {

        /**
         * png,jpg等图片格式转base64
         * @param url
         * @param callback
         * @param outputFormat
         */
        this.convertImgToBase64 = function (url, callback, outputFormat) {
            var canvas = document.createElement('CANVAS'),
                ctx = canvas.getContext('2d'),
                img = new Image;
            img.crossOrigin = 'Anonymous';
            img.setAttribute('crossOrigin', 'anonymous');
            img.onload = function () {
                canvas.height = img.height;
                canvas.width = img.width;
                ctx.imageSmoothingEnabled = true;
                ctx.mozImageSmoothingEnabled = true;
                ctx.webkitImageSmoothingEnabled = true;
                ctx.msImageSmoothingEnabled = true;
                ctx.drawImage(img, 0, 0);
                var dataURL = canvas.toDataURL(outputFormat || 'image/png');
                // callback.call(this, dataURL);
                callback.call(this, dataURLtoBlobs(dataURL));
                canvas = null;
            };
            img.src = url;
        };

        /**
         * base64转Blob
         * @param dataurl
         * @returns {*}
         */
        this.dataURLtoBlob=function(dataurl) {
            return dataURLtoBlobs(dataurl);
        };
        function dataURLtoBlobs(dataurl) {
            var arr = dataurl.split(','),
                bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            var createObjectURL = function (blob) {
                return window[window.webkitURL ? 'webkitURL' : 'URL']['createObjectURL'](blob);
            };
            var fileURL = URL.createObjectURL(new Blob([u8arr], {type: 'image/*'}));
            return fileURL;
        }

        this.backendUploadPics = function(file, domain, token, callback, errorback) {
            // 如果 file 上已经有宽高信息则直接使用，否则加载图片获取尺寸
            if (file.width !== undefined && file.height !== undefined) {
                doUpload(file.width, file.height, token, false);
            } else {
                var img = new Image();
                var objectUrl = URL.createObjectURL(file);
                img.onload = function() {
                    URL.revokeObjectURL(objectUrl);
                    doUpload(img.width, img.height, token, false);
                };
                img.onerror = function() {
                    URL.revokeObjectURL(objectUrl);
                    // 加载失败时兜底，仅按文件大小判断
                    doUpload(0, 0, token, false);
                };
                img.src = objectUrl;
            }

            function doUpload(width, height, uploadToken, isRetry) {
                var formData = new FormData();
                var _key ="gallery-" + UidService.get()
                // 超过50M 或超大尺寸 增加xl大图标识
                if(file.size >= 20971520 || width > 30000 || height > 30000 || (width*height)>150000000){
                    _key += '-xl'
                }
                formData.append('file', file);
                formData.append('unique_names', false);
                formData.append('key', _key);
                formData.append('token',  uploadToken);
                var reader2 = new FileReader();
                reader2.readAsArrayBuffer(file)
                reader2.onloadend = function(e) {
                    formData.append('crc32', CRC32.buf(new Uint8Array(this.result)));
                    $.ajax({
                        cache: true,
                        type: "POST",
                        url: 'https://upload.qiniup.com/',
                        data: formData,
                        async: true,
                        contentType: false,
                        processData: false,
                        success: function(data) {
                            callback.call(this, data, file);
                        },
                        error: function(request) {
                            if (!isRetry && isTokenError(request)) {
                                // 401 / "expired token" -> 刷新token后重试一次
                                QiniuToken.refresh('get', {}, function(newToken) {
                                    doUpload(width, height, newToken, true);
                                });
                            } else {
                                errorback.call(this, file)
                            }
                        }
                    });
                };
            }
        }

        function isTokenError(request) {
            return request && (request.status === 401 ||
                (request.responseText && request.responseText.indexOf('expired token') !== -1));
        }

        return this;

    }]);

/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */
(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.html2canvas = factory());
}(this, (function () { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || from);
    }

    var Bounds = /** @class */ (function () {
        function Bounds(left, top, width, height) {
            this.left = left;
            this.top = top;
            this.width = width;
            this.height = height;
        }
        Bounds.prototype.add = function (x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function (context, clientRect) {
            return new Bounds(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
        };
        Bounds.fromDOMRectList = function (context, domRectList) {
            var domRect = Array.from(domRectList).find(function (rect) { return rect.width !== 0; });
            return domRect
                ? new Bounds(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height)
                : Bounds.EMPTY;
        };
        Bounds.EMPTY = new Bounds(0, 0, 0, 0);
        return Bounds;
    }());
    var parseBounds = function (context, node) {
        return Bounds.fromClientRect(context, node.getBoundingClientRect());
    };
    var parseDocumentSize = function (document) {
        var body = document.body;
        var documentElement = document.documentElement;
        if (!body || !documentElement) {
            throw new Error("Unable to get document size");
        }
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };

    /*
     * css-line-break 2.1.0 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var toCodePoints$1 = function (str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while (i < length) {
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) {
                    codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                }
                else {
                    codePoints.push(value);
                    i--;
                }
            }
            else {
                codePoints.push(value);
            }
        }
        return codePoints;
    };
    var fromCodePoint$1 = function () {
        var codePoints = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            codePoints[_i] = arguments[_i];
        }
        if (String.fromCodePoint) {
            return String.fromCodePoint.apply(String, codePoints);
        }
        var length = codePoints.length;
        if (!length) {
            return '';
        }
        var codeUnits = [];
        var index = -1;
        var result = '';
        while (++index < length) {
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) {
                codeUnits.push(codePoint);
            }
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, (codePoint % 0x400) + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars$2 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$2 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$2 = 0; i$2 < chars$2.length; i$2++) {
        lookup$2[chars$2.charCodeAt(i$2)] = i$2;
    }

    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars$1$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++) {
        lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
    }
    var decode$1 = function (base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') {
                bufferLength--;
            }
        }
        var buffer = typeof ArrayBuffer !== 'undefined' &&
            typeof Uint8Array !== 'undefined' &&
            typeof Uint8Array.prototype.slice !== 'undefined'
            ? new ArrayBuffer(bufferLength)
            : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for (i = 0; i < len; i += 4) {
            encoded1 = lookup$1$1[base64.charCodeAt(i)];
            encoded2 = lookup$1$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1$1[base64.charCodeAt(i + 3)];
            bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
            bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
            bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
        }
        return buffer;
    };
    var polyUint16Array$1 = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 2) {
            bytes.push((buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };
    var polyUint32Array$1 = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 4) {
            bytes.push((buffer[i + 3] << 24) | (buffer[i + 2] << 16) | (buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };

    /** Shift size for getting the index-2 table offset. */
    var UTRIE2_SHIFT_2$1 = 5;
    /** Shift size for getting the index-1 table offset. */
    var UTRIE2_SHIFT_1$1 = 6 + 5;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */
    var UTRIE2_INDEX_SHIFT$1 = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */
    var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */
    var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1;
    /** Number of entries in a data block. 32=0x20 */
    var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
    /** Mask for getting the lower bits for the in-data-block offset. */
    var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1;
    /** Count the lengths of both BMP pieces. 2080=0x820 */
    var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */
    var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 0x800 >> 6; /* U+0800 is the first code point after 2-byte UTF-8 */
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */
    var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */
    var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1;
    /** Number of entries in an index-2 block. 64=0x40 */
    var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
    /** Mask for getting the lower bits for the in-index-2-block offset. */
    var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
    var slice16$1 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32$1 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64$1 = function (base64, _byteLength) {
        var buffer = decode$1(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2
            ? slice16$1(view16, (headerLength + view32[4]) / 2)
            : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie$1 = /** @class */ (function () {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */
        Trie.prototype.get = function (codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || (codePoint > 0x0dbff && codePoint <= 0x0ffff)) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + ((codePoint - 0xd800) >> UTRIE2_SHIFT_2$1)];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                    ix = this.index[ix];
                    ix += (codePoint >> UTRIE2_SHIFT_2$1) & UTRIE2_INDEX_2_MASK$1;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) {
                    return this.data[this.highValueIndex];
                }
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }());

    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars$3 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$3 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$3 = 0; i$3 < chars$3.length; i$3++) {
        lookup$3[chars$3.charCodeAt(i$3)] = i$3;
    }

    var base64$1 = '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';

    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR$1 = 2; //  Cause a line break (after), except between CR and LF
    var LF$1 = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ$1 = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI$1 = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var ea_OP = [0x2329, 0xff08];
    var BREAK_MANDATORY = '!';
    var BREAK_NOT_ALLOWED$1 = '×';
    var BREAK_ALLOWED$1 = '÷';
    var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
    var ALPHABETICS = [AL, HL];
    var HARD_LINE_BREAKS = [BK, CR$1, LF$1, NL];
    var SPACE$1 = [SP, ZW];
    var PREFIX_POSTFIX = [PR, PO];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
    var KOREAN_SYLLABLE_BLOCK = [JL, JV, JT, H2, H3];
    var HYPHEN = [HY, BA];
    var codePointsToCharacterClasses = function (codePoints, lineBreak) {
        if (lineBreak === void 0) { lineBreak = 'strict'; }
        var types = [];
        var indices = [];
        var categories = [];
        codePoints.forEach(function (codePoint, index) {
            var classType = UnicodeTrie$1.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            }
            else {
                categories.push(false);
            }
            if (['normal', 'auto', 'loose'].indexOf(lineBreak) !== -1) {
                // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
                if ([0x2010, 0x2013, 0x301c, 0x30a0].indexOf(codePoint) !== -1) {
                    indices.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ$1) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indices.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indices.push(indices[index - 1]);
                    return types.push(prev);
                }
                indices.push(index);
                return types.push(AL);
            }
            indices.push(index);
            if (classType === CJ) {
                return types.push(lineBreak === 'strict' ? NS : ID);
            }
            if (classType === SA) {
                return types.push(AL);
            }
            if (classType === AI) {
                return types.push(AL);
            }
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if ((codePoint >= 0x20000 && codePoint <= 0x2fffd) || (codePoint >= 0x30000 && codePoint <= 0x3fffd)) {
                    return types.push(ID);
                }
                else {
                    return types.push(AL);
                }
            }
            types.push(classType);
        });
        return [indices, types, categories];
    };
    var isAdjacentWithSpaceIgnored = function (a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while (i <= classTypes.length) {
                i++;
                var next = classTypes[i];
                if (next === b) {
                    return true;
                }
                if (next !== SP) {
                    break;
                }
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while (i > 0) {
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while (n <= classTypes.length) {
                        n++;
                        var next = classTypes[n];
                        if (next === b) {
                            return true;
                        }
                        if (next !== SP) {
                            break;
                        }
                    }
                }
                if (prev !== SP) {
                    break;
                }
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function (currentIndex, classTypes) {
        var i = currentIndex;
        while (i >= 0) {
            var type = classTypes[i];
            if (type === SP) {
                i--;
            }
            else {
                return type;
            }
        }
        return 0;
    };
    var _lineBreakAtIndex = function (codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) {
            return BREAK_NOT_ALLOWED$1;
        }
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) {
            return BREAK_NOT_ALLOWED$1;
        }
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR$1 && next === LF$1) {
            return BREAK_NOT_ALLOWED$1;
        }
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) {
            return BREAK_MANDATORY;
        }
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB7 Do not break before spaces or zero width space.
        if (SPACE$1.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) {
            return BREAK_ALLOWED$1;
        }
        // LB8a Do not break after a zero width joiner.
        if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // zwj emojis
        if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([SP, BA, HY].indexOf(current) === -1 && next === GL) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([CL, CP, EX, IS, SY].indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([CL, CP], NS, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB18 Break after spaces.
        if (current === SP) {
            return BREAK_ALLOWED$1;
        }
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) {
            return BREAK_ALLOWED$1;
        }
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([BA, HY, NS].indexOf(next) !== -1 || current === BB) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB22 Do not break before ellipsis.
        if (next === IN) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB23 Do not break between digits and letters.
        if ((ALPHABETICS.indexOf(next) !== -1 && current === NU) || (ALPHABETICS.indexOf(current) !== -1 && next === NU)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if ((current === PR && [ID, EB, EM].indexOf(next) !== -1) ||
            ([ID, EB, EM].indexOf(current) !== -1 && next === PO)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if ((ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1) ||
            (PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (
        // (PR | PO) × ( OP | HY )? NU
        ([PR, PO].indexOf(current) !== -1 &&
            (next === NU || ([OP, HY].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU))) ||
            // ( OP | HY ) × NU
            ([OP, HY].indexOf(current) !== -1 && next === NU) ||
            // NU ×	(NU | SY | IS)
            (current === NU && [NU, SY, IS].indexOf(next) !== -1)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([NU, SY, IS, CL, CP].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while (prevIndex >= 0) {
                var type = classTypes[prevIndex];
                if (type === NU) {
                    return BREAK_NOT_ALLOWED$1;
                }
                else if ([SY, IS].indexOf(type) !== -1) {
                    prevIndex--;
                }
                else {
                    break;
                }
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([PR, PO].indexOf(next) !== -1) {
            var prevIndex = [CL, CP].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while (prevIndex >= 0) {
                var type = classTypes[prevIndex];
                if (type === NU) {
                    return BREAK_NOT_ALLOWED$1;
                }
                else if ([SY, IS].indexOf(type) !== -1) {
                    prevIndex--;
                }
                else {
                    break;
                }
            }
        }
        // LB26 Do not break a Korean syllable.
        if ((JL === current && [JL, JV, H2, H3].indexOf(next) !== -1) ||
            ([JV, H2].indexOf(current) !== -1 && [JV, JT].indexOf(next) !== -1) ||
            ([JT, H3].indexOf(current) !== -1 && next === JT)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB27 Treat a Korean Syllable Block the same as ID.
        if ((KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [IN, PO].indexOf(next) !== -1) ||
            (KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if ((ALPHABETICS.concat(NU).indexOf(current) !== -1 &&
            next === OP &&
            ea_OP.indexOf(codePoints[afterIndex]) === -1) ||
            (ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI$1 && next === RI$1) {
            var i = indicies[currentIndex];
            var count = 1;
            while (i > 0) {
                i--;
                if (classTypes[i] === RI$1) {
                    count++;
                }
                else {
                    break;
                }
            }
            if (count % 2 !== 0) {
                return BREAK_NOT_ALLOWED$1;
            }
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) {
            return BREAK_NOT_ALLOWED$1;
        }
        return BREAK_ALLOWED$1;
    };
    var cssFormattedClasses = function (codePoints, options) {
        if (!options) {
            options = { lineBreak: 'normal', wordBreak: 'normal' };
        }
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') {
            classTypes = classTypes.map(function (type) { return ([NU, AL, SA].indexOf(type) !== -1 ? ID : type); });
        }
        var forbiddenBreakpoints = options.wordBreak === 'keep-all'
            ? isLetterNumber.map(function (letterNumber, i) {
                return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
            })
            : undefined;
        return [indicies, classTypes, forbiddenBreakpoints];
    };
    var Break = /** @class */ (function () {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function () {
            return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }());
    var LineBreaker = function (str, options) {
        var codePoints = toCodePoints$1(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function () {
                if (nextIndex >= length) {
                    return { done: true, value: null };
                }
                var lineBreak = BREAK_NOT_ALLOWED$1;
                while (nextIndex < length &&
                    (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) ===
                        BREAK_NOT_ALLOWED$1) { }
                if (lineBreak !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return { value: value, done: false };
                }
                return { done: true, value: null };
            },
        };
    };

    // https://www.w3.org/TR/css-syntax-3
    var FLAG_UNRESTRICTED = 1 << 0;
    var FLAG_ID = 1 << 1;
    var FLAG_INTEGER = 1 << 2;
    var FLAG_NUMBER = 1 << 3;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function (codePoint) { return codePoint >= ZERO && codePoint <= 0x0039; };
    var isSurrogateCodePoint = function (codePoint) { return codePoint >= 0xd800 && codePoint <= 0xdfff; };
    var isHex = function (codePoint) {
        return isDigit(codePoint) || (codePoint >= A && codePoint <= F) || (codePoint >= a && codePoint <= f);
    };
    var isLowerCaseLetter = function (codePoint) { return codePoint >= a && codePoint <= z; };
    var isUpperCaseLetter = function (codePoint) { return codePoint >= A && codePoint <= Z; };
    var isLetter = function (codePoint) { return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint); };
    var isNonASCIICodePoint = function (codePoint) { return codePoint >= CONTROL; };
    var isWhiteSpace = function (codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
    };
    var isNameStartCodePoint = function (codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function (codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function (codePoint) {
        return ((codePoint >= NULL && codePoint <= BACKSPACE) ||
            codePoint === LINE_TABULATION ||
            (codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE) ||
            codePoint === DELETE);
    };
    var isValidEscape = function (c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) {
            return false;
        }
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function (c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) {
            return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        }
        else if (isNameStartCodePoint(c1)) {
            return true;
        }
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) {
            return true;
        }
        return false;
    };
    var isNumberStart = function (c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) {
                return true;
            }
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) {
            return isDigit(c2);
        }
        return isDigit(c1);
    };
    var stringToNumber = function (codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) {
                sign = -1;
            }
            c++;
        }
        var integers = [];
        while (isDigit(codePoints[c])) {
            integers.push(codePoints[c++]);
        }
        var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) {
            c++;
        }
        var fraction = [];
        while (isDigit(codePoints[c])) {
            fraction.push(codePoints[c++]);
        }
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) {
            c++;
        }
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) {
                expsign = -1;
            }
            c++;
        }
        var exponent = [];
        while (isDigit(codePoints[c])) {
            exponent.push(codePoints[c++]);
        }
        var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: 2 /* LEFT_PARENTHESIS_TOKEN */
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: 3 /* RIGHT_PARENTHESIS_TOKEN */
    };
    var COMMA_TOKEN = { type: 4 /* COMMA_TOKEN */ };
    var SUFFIX_MATCH_TOKEN = { type: 13 /* SUFFIX_MATCH_TOKEN */ };
    var PREFIX_MATCH_TOKEN = { type: 8 /* PREFIX_MATCH_TOKEN */ };
    var COLUMN_TOKEN = { type: 21 /* COLUMN_TOKEN */ };
    var DASH_MATCH_TOKEN = { type: 9 /* DASH_MATCH_TOKEN */ };
    var INCLUDE_MATCH_TOKEN = { type: 10 /* INCLUDE_MATCH_TOKEN */ };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: 11 /* LEFT_CURLY_BRACKET_TOKEN */
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: 12 /* RIGHT_CURLY_BRACKET_TOKEN */
    };
    var SUBSTRING_MATCH_TOKEN = { type: 14 /* SUBSTRING_MATCH_TOKEN */ };
    var BAD_URL_TOKEN = { type: 23 /* BAD_URL_TOKEN */ };
    var BAD_STRING_TOKEN = { type: 1 /* BAD_STRING_TOKEN */ };
    var CDO_TOKEN = { type: 25 /* CDO_TOKEN */ };
    var CDC_TOKEN = { type: 24 /* CDC_TOKEN */ };
    var COLON_TOKEN = { type: 26 /* COLON_TOKEN */ };
    var SEMICOLON_TOKEN = { type: 27 /* SEMICOLON_TOKEN */ };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: 28 /* LEFT_SQUARE_BRACKET_TOKEN */
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: 29 /* RIGHT_SQUARE_BRACKET_TOKEN */
    };
    var WHITESPACE_TOKEN = { type: 31 /* WHITESPACE_TOKEN */ };
    var EOF_TOKEN = { type: 32 /* EOF_TOKEN */ };
    var Tokenizer = /** @class */ (function () {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function (chunk) {
            this._value = this._value.concat(toCodePoints$1(chunk));
        };
        Tokenizer.prototype.read = function () {
            var tokens = [];
            var token = this.consumeToken();
            while (token !== EOF_TOKEN) {
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function () {
            var codePoint = this.consumeCodePoint();
            switch (codePoint) {
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return { type: 5 /* HASH_TOKEN */, value: value, flags: flags };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while (true) {
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) {
                                    return this.consumeToken();
                                }
                            }
                            if (c === EOF) {
                                return this.consumeToken();
                            }
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK &&
                        this.peekCodePoint(1) === HYPHEN_MINUS &&
                        this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return { type: 7 /* AT_KEYWORD_TOKEN */, value: value };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return { type: 6 /* DELIM_TOKEN */, value: fromCodePoint$1(codePoint) };
        };
        Tokenizer.prototype.consumeCodePoint = function () {
            var value = this._value.shift();
            return typeof value === 'undefined' ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function (codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function (delta) {
            if (delta >= this._value.length) {
                return -1;
            }
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function () {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while (isHex(codePoint) && digits.length < 6) {
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while (codePoint === QUESTION_MARK && digits.length < 6) {
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function (digit) { return (digit === QUESTION_MARK ? ZERO : digit); })), 16);
                var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function (digit) { return (digit === QUESTION_MARK ? F : digit); })), 16);
                return { type: 30 /* UNICODE_RANGE_TOKEN */, start: start_1, end: end };
            }
            var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while (isHex(codePoint) && endDigits.length < 6) {
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
                return { type: 30 /* UNICODE_RANGE_TOKEN */, start: start, end: end };
            }
            else {
                return { type: 30 /* UNICODE_RANGE_TOKEN */, start: start, end: start };
            }
        };
        Tokenizer.prototype.consumeIdentLikeToken = function () {
            var value = this.consumeName();
            if (value.toLowerCase() === 'url' && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            }
            else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return { type: 19 /* FUNCTION_TOKEN */, value: value };
            }
            return { type: 20 /* IDENT_TOKEN */, value: value };
        };
        Tokenizer.prototype.consumeUrlToken = function () {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) {
                return { type: 22 /* URL_TOKEN */, value: '' };
            }
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === 0 /* STRING_TOKEN */) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return { type: 22 /* URL_TOKEN */, value: stringToken.value };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) {
                    return { type: 22 /* URL_TOKEN */, value: fromCodePoint$1.apply(void 0, value) };
                }
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return { type: 22 /* URL_TOKEN */, value: fromCodePoint$1.apply(void 0, value) };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                }
                else if (codePoint === QUOTATION_MARK ||
                    codePoint === APOSTROPHE ||
                    codePoint === LEFT_PARENTHESIS ||
                    isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                }
                else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        value.push(this.consumeEscapedCodePoint());
                    }
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                }
                else {
                    value.push(codePoint);
                }
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function () {
            while (isWhiteSpace(this.peekCodePoint(0))) {
                this.consumeCodePoint();
            }
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function () {
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) {
                    return;
                }
                if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                    this.consumeEscapedCodePoint();
                }
            }
        };
        Tokenizer.prototype.consumeStringSlice = function (count) {
            var SLICE_STACK_SIZE = 50000;
            var value = '';
            while (count > 0) {
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function (endingCodePoint) {
            var value = '';
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return { type: 0 /* STRING_TOKEN */, value: value };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        }
                        else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint$1(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            } while (true);
        };
        Tokenizer.prototype.consumeNumber = function () {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
                repr.push(this.consumeCodePoint());
            }
            while (isDigit(this.peekCodePoint(0))) {
                repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while (isDigit(this.peekCodePoint(0))) {
                    repr.push(this.consumeCodePoint());
                }
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && (((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3)) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while (isDigit(this.peekCodePoint(0))) {
                    repr.push(this.consumeCodePoint());
                }
            }
            return [stringToNumber(repr), type];
        };
        Tokenizer.prototype.consumeNumericToken = function () {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return { type: 15 /* DIMENSION_TOKEN */, number: number, flags: flags, unit: unit };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return { type: 16 /* PERCENTAGE_TOKEN */, number: number, flags: flags };
            }
            return { type: 17 /* NUMBER_TOKEN */, number: number, flags: flags };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function () {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint$1(codePoint);
                while (isHex(this.peekCodePoint(0)) && hex.length < 6) {
                    hex += fromCodePoint$1(this.consumeCodePoint());
                }
                if (isWhiteSpace(this.peekCodePoint(0))) {
                    this.consumeCodePoint();
                }
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) {
                    return REPLACEMENT_CHARACTER;
                }
                return hexCodePoint;
            }
            if (codePoint === EOF) {
                return REPLACEMENT_CHARACTER;
            }
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function () {
            var result = '';
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) {
                    result += fromCodePoint$1(codePoint);
                }
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                    result += fromCodePoint$1(this.consumeEscapedCodePoint());
                }
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }());

    var Parser = /** @class */ (function () {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function (value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function (value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function (value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function () {
            var token = this.consumeToken();
            while (token.type === 31 /* WHITESPACE_TOKEN */) {
                token = this.consumeToken();
            }
            if (token.type === 32 /* EOF_TOKEN */) {
                throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            }
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do {
                token = this.consumeToken();
            } while (token.type === 31 /* WHITESPACE_TOKEN */);
            if (token.type === 32 /* EOF_TOKEN */) {
                return value;
            }
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function () {
            var values = [];
            while (true) {
                var value = this.consumeComponentValue();
                if (value.type === 32 /* EOF_TOKEN */) {
                    return values;
                }
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function () {
            var token = this.consumeToken();
            switch (token.type) {
                case 11 /* LEFT_CURLY_BRACKET_TOKEN */:
                case 28 /* LEFT_SQUARE_BRACKET_TOKEN */:
                case 2 /* LEFT_PARENTHESIS_TOKEN */:
                    return this.consumeSimpleBlock(token.type);
                case 19 /* FUNCTION_TOKEN */:
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function (type) {
            var block = { type: type, values: [] };
            var token = this.consumeToken();
            while (true) {
                if (token.type === 32 /* EOF_TOKEN */ || isEndingTokenFor(token, type)) {
                    return block;
                }
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function (functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: 18 /* FUNCTION */
            };
            while (true) {
                var token = this.consumeToken();
                if (token.type === 32 /* EOF_TOKEN */ || token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */) {
                    return cssFunction;
                }
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function () {
            var token = this._tokens.shift();
            return typeof token === 'undefined' ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function (token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }());
    var isDimensionToken = function (token) { return token.type === 15 /* DIMENSION_TOKEN */; };
    var isNumberToken = function (token) { return token.type === 17 /* NUMBER_TOKEN */; };
    var isIdentToken = function (token) { return token.type === 20 /* IDENT_TOKEN */; };
    var isStringToken = function (token) { return token.type === 0 /* STRING_TOKEN */; };
    var isIdentWithValue = function (token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function (token) { return token.type !== 31 /* WHITESPACE_TOKEN */; };
    var nonFunctionArgSeparator = function (token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */ && token.type !== 4 /* COMMA_TOKEN */;
    };
    var parseFunctionArgs = function (tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function (token) {
            if (token.type === 4 /* COMMA_TOKEN */) {
                if (arg.length === 0) {
                    throw new Error("Error parsing function args, zero tokens for arg");
                }
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== 31 /* WHITESPACE_TOKEN */) {
                arg.push(token);
            }
        });
        if (arg.length) {
            args.push(arg);
        }
        return args;
    };
    var isEndingTokenFor = function (token, type) {
        if (type === 11 /* LEFT_CURLY_BRACKET_TOKEN */ && token.type === 12 /* RIGHT_CURLY_BRACKET_TOKEN */) {
            return true;
        }
        if (type === 28 /* LEFT_SQUARE_BRACKET_TOKEN */ && token.type === 29 /* RIGHT_SQUARE_BRACKET_TOKEN */) {
            return true;
        }
        return type === 2 /* LEFT_PARENTHESIS_TOKEN */ && token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */;
    };

    var isLength = function (token) {
        return token.type === 17 /* NUMBER_TOKEN */ || token.type === 15 /* DIMENSION_TOKEN */;
    };

    var isLengthPercentage = function (token) {
        return token.type === 16 /* PERCENTAGE_TOKEN */ || isLength(token);
    };
    var parseLengthPercentageTuple = function (tokens) {
        return tokens.length > 1 ? [tokens[0], tokens[1]] : [tokens[0]];
    };
    var ZERO_LENGTH = {
        type: 17 /* NUMBER_TOKEN */,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function (tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [getAbsoluteValue(x, width), getAbsoluteValue(typeof y !== 'undefined' ? y : x, height)];
    };
    var getAbsoluteValue = function (token, parent) {
        if (token.type === 16 /* PERCENTAGE_TOKEN */) {
            return (token.number / 100) * parent;
        }
        if (isDimensionToken(token)) {
            switch (token.unit) {
                case 'rem':
                case 'em':
                    return 16 * token.number; // TODO use correct font-size
                case 'px':
                default:
                    return token.number;
            }
        }
        return token.number;
    };

    var DEG = 'deg';
    var GRAD = 'grad';
    var RAD = 'rad';
    var TURN = 'turn';
    var angle = {
        name: 'angle',
        parse: function (_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */) {
                switch (value.unit) {
                    case DEG:
                        return (Math.PI * value.number) / 180;
                    case GRAD:
                        return (Math.PI / 200) * value.number;
                    case RAD:
                        return value.number;
                    case TURN:
                        return Math.PI * 2 * value.number;
                }
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function (value) {
        if (value.type === 15 /* DIMENSION_TOKEN */) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) {
                return true;
            }
        }
        return false;
    };
    var parseNamedSide = function (tokens) {
        var sideOrCorner = tokens
            .filter(isIdentToken)
            .map(function (ident) { return ident.value; })
            .join(' ');
        switch (sideOrCorner) {
            case 'to bottom right':
            case 'to right bottom':
            case 'left top':
            case 'top left':
                return [ZERO_LENGTH, ZERO_LENGTH];
            case 'to top':
            case 'bottom':
                return deg(0);
            case 'to bottom left':
            case 'to left bottom':
            case 'right top':
            case 'top right':
                return [ZERO_LENGTH, HUNDRED_PERCENT];
            case 'to right':
            case 'left':
                return deg(90);
            case 'to top left':
            case 'to left top':
            case 'right bottom':
            case 'bottom right':
                return [HUNDRED_PERCENT, HUNDRED_PERCENT];
            case 'to bottom':
            case 'top':
                return deg(180);
            case 'to top right':
            case 'to right top':
            case 'left bottom':
            case 'bottom left':
                return [HUNDRED_PERCENT, ZERO_LENGTH];
            case 'to left':
            case 'right':
                return deg(270);
        }
        return 0;
    };
    var deg = function (deg) { return (Math.PI * deg) / 180; };

    var color$1 = {
        name: 'color',
        parse: function (context, value) {
            if (value.type === 18 /* FUNCTION */) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported color function \"" + value.name + "\"");
                }
                return colorFunction(context, value.values);
            }
            if (value.type === 5 /* HASH_TOKEN */) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === 20 /* IDENT_TOKEN */) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== 'undefined') {
                    return namedColor;
                }
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function (color) { return (0xff & color) === 0; };
    var asString = function (color) {
        var alpha = 0xff & color;
        var blue = 0xff & (color >> 8);
        var green = 0xff & (color >> 16);
        var red = 0xff & (color >> 24);
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var asColorString = function (color, alpha) {
        var alpha = 0xff & alpha;
        var blue = 0xff & (color >> 8);
        var green = 0xff & (color >> 16);
        var red = 0xff & (color >> 24);
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function (r, g, b, a) {
        return ((r << 24) | (g << 16) | (b << 8) | (Math.round(a * 255) << 0)) >>> 0;
    };
    var getTokenColorValue = function (token, i) {
        if (token.type === 17 /* NUMBER_TOKEN */) {
            return token.number;
        }
        if (token.type === 16 /* PERCENTAGE_TOKEN */) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? (token.number / 100) * max : Math.round((token.number / 100) * max);
        }
        return 0;
    };
    var rgb = function (_context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) {
            hue += 1;
        }
        if (hue >= 1) {
            hue -= 1;
        }
        if (hue < 1 / 6) {
            return (t2 - t1) * hue * 6 + t1;
        }
        else if (hue < 1 / 2) {
            return t2;
        }
        else if (hue < 2 / 3) {
            return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        }
        else {
            return t1;
        }
    }
    var hsl = function (context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === 17 /* NUMBER_TOKEN */ ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== 'undefined' && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) {
            return pack(l * 255, l * 255, l * 255, 1);
        }
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var parseColor = function (context, value) {
        return color$1.parse(context, Parser.create(value).parseComponentValue());
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };

    var backgroundClip = {
        name: 'background-clip',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.map(function (token) {
                if (isIdentToken(token)) {
                    switch (token.value) {
                        case 'padding-box':
                            return 1 /* PADDING_BOX */;
                        case 'content-box':
                            return 2 /* CONTENT_BOX */;
                    }
                }
                return 0 /* BORDER_BOX */;
            });
        }
    };

    var backgroundColor = {
        name: "background-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var parseColorStop = function (context, args) {
        var color = color$1.parse(context, args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? { color: color, stop: stop } : { color: color, stop: null };
    };
    var processColorStops = function (stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) {
            first.stop = ZERO_LENGTH;
        }
        if (last.stop === null) {
            last.stop = HUNDRED_PERCENT;
        }
        var processStops = [];
        var previous = 0;
        for (var i = 0; i < stops.length; i++) {
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) {
                    processStops.push(absoluteValue);
                }
                else {
                    processStops.push(previous);
                }
                previous = absoluteValue;
            }
            else {
                processStops.push(null);
            }
        }
        var gapBegin = null;
        for (var i = 0; i < processStops.length; i++) {
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) {
                    gapBegin = i;
                }
            }
            else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for (var g = 1; g <= gapLength; g++) {
                    processStops[gapBegin + g - 1] = gapValue * g;
                }
                gapBegin = null;
            }
        }
        return stops.map(function (_a, i) {
            var color = _a.color;
            return { color: color, stop: Math.max(Math.min(1, processStops[i] / lineLength), 0) };
        });
    };
    var getAngleFromCorner = function (corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function (angle, width, height) {
        var radian = typeof angle === 'number' ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [lineLength, halfWidth - xDiff, halfWidth + xDiff, halfHeight - yDiff, halfHeight + yDiff];
    };
    var distance = function (a, b) { return Math.sqrt(a * a + b * b); };
    var findCorner = function (width, height, x, y, closest) {
        var corners = [
            [0, 0],
            [0, height],
            [width, 0],
            [width, height]
        ];
        return corners.reduce(function (stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) {
                return {
                    optimumCorner: corner,
                    optimumDistance: d
                };
            }
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function (gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch (gradient.size) {
            case 0 /* CLOSEST_SIDE */:
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 2 /* CLOSEST_CORNER */:
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case 1 /* FARTHEST_SIDE */:
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 3 /* FARTHEST_CORNER */:
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [rx, ry];
    };

    var linearGradient = function (context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */ && firstToken.value === 'to') {
                    angle$1 = parseNamedSide(arg);
                    return;
                }
                else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(context, firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return { angle: angle$1, stops: stops, type: 1 /* LINEAR_GRADIENT */ };
    };

    var prefixLinearGradient = function (context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */ &&
                    ['top', 'left', 'right', 'bottom'].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                }
                else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */
        };
    };

    var webkitGradient = function (context, tokens) {
        var angle = deg(180);
        var stops = [];
        var type = 1 /* LINEAR_GRADIENT */;
        var shape = 0 /* CIRCLE */;
        var size = 3 /* FARTHEST_CORNER */;
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === 'linear') {
                    type = 1 /* LINEAR_GRADIENT */;
                    return;
                }
                else if (isIdentToken(firstToken) && firstToken.value === 'radial') {
                    type = 2 /* RADIAL_GRADIENT */;
                    return;
                }
            }
            if (firstToken.type === 18 /* FUNCTION */) {
                if (firstToken.name === 'from') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({ stop: ZERO_LENGTH, color: color });
                }
                else if (firstToken.name === 'to') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({ stop: HUNDRED_PERCENT, color: color });
                }
                else if (firstToken.name === 'color-stop') {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color = color$1.parse(context, values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) {
                            stops.push({
                                stop: { type: 16 /* PERCENTAGE_TOKEN */, number: stop_1.number * 100, flags: stop_1.flags },
                                color: color
                            });
                        }
                    }
                }
            }
        });
        return type === 1 /* LINEAR_GRADIENT */
            ? {
                angle: (angle + deg(180)) % deg(360),
                stops: stops,
                type: type
            }
            : { size: size, shape: shape, stops: stops, position: position, type: type };
    };

    var CLOSEST_SIDE = 'closest-side';
    var FARTHEST_SIDE = 'farthest-side';
    var CLOSEST_CORNER = 'closest-corner';
    var FARTHEST_CORNER = 'farthest-corner';
    var CIRCLE = 'circle';
    var ELLIPSE = 'ellipse';
    var COVER = 'cover';
    var CONTAIN = 'contain';
    var radialGradient = function (context, tokens) {
        var shape = 0 /* CIRCLE */;
        var size = 3 /* FARTHEST_CORNER */;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function (acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) {
                            switch (token.value) {
                                case 'center':
                                    position.push(FIFTY_PERCENT);
                                    return acc;
                                case 'top':
                                case 'left':
                                    position.push(ZERO_LENGTH);
                                    return acc;
                                case 'right':
                                case 'bottom':
                                    position.push(HUNDRED_PERCENT);
                                    return acc;
                            }
                        }
                        else if (isLengthPercentage(token) || isLength(token)) {
                            position.push(token);
                        }
                    }
                    else if (isIdentToken(token)) {
                        switch (token.value) {
                            case CIRCLE:
                                shape = 0 /* CIRCLE */;
                                return false;
                            case ELLIPSE:
                                shape = 1 /* ELLIPSE */;
                                return false;
                            case 'at':
                                isAtPosition_1 = true;
                                return false;
                            case CLOSEST_SIDE:
                                size = 0 /* CLOSEST_SIDE */;
                                return false;
                            case COVER:
                            case FARTHEST_SIDE:
                                size = 1 /* FARTHEST_SIDE */;
                                return false;
                            case CONTAIN:
                            case CLOSEST_CORNER:
                                size = 2 /* CLOSEST_CORNER */;
                                return false;
                            case FARTHEST_CORNER:
                                size = 3 /* FARTHEST_CORNER */;
                                return false;
                        }
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) {
                            size = [];
                        }
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return { size: size, shape: shape, stops: stops, position: position, type: 2 /* RADIAL_GRADIENT */ };
    };

    var prefixRadialGradient = function (context, tokens) {
        var shape = 0 /* CIRCLE */;
        var size = 3 /* FARTHEST_CORNER */;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var isColorStop = true;
            if (i === 0) {
                isColorStop = arg.reduce(function (acc, token) {
                    if (isIdentToken(token)) {
                        switch (token.value) {
                            case 'center':
                                position.push(FIFTY_PERCENT);
                                return false;
                            case 'top':
                            case 'left':
                                position.push(ZERO_LENGTH);
                                return false;
                            case 'right':
                            case 'bottom':
                                position.push(HUNDRED_PERCENT);
                                return false;
                        }
                    }
                    else if (isLengthPercentage(token) || isLength(token)) {
                        position.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            else if (i === 1) {
                isColorStop = arg.reduce(function (acc, token) {
                    if (isIdentToken(token)) {
                        switch (token.value) {
                            case CIRCLE:
                                shape = 0 /* CIRCLE */;
                                return false;
                            case ELLIPSE:
                                shape = 1 /* ELLIPSE */;
                                return false;
                            case CONTAIN:
                            case CLOSEST_SIDE:
                                size = 0 /* CLOSEST_SIDE */;
                                return false;
                            case FARTHEST_SIDE:
                                size = 1 /* FARTHEST_SIDE */;
                                return false;
                            case CLOSEST_CORNER:
                                size = 2 /* CLOSEST_CORNER */;
                                return false;
                            case COVER:
                            case FARTHEST_CORNER:
                                size = 3 /* FARTHEST_CORNER */;
                                return false;
                        }
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) {
                            size = [];
                        }
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return { size: size, shape: shape, stops: stops, position: position, type: 2 /* RADIAL_GRADIENT */ };
    };

    var isLinearGradient = function (background) {
        return background.type === 1 /* LINEAR_GRADIENT */;
    };
    var isRadialGradient = function (background) {
        return background.type === 2 /* RADIAL_GRADIENT */;
    };
    var image = {
        name: 'image',
        parse: function (context, value) {
            if (value.type === 22 /* URL_TOKEN */) {
                var image_1 = { url: value.value, type: 0 /* URL */ };
                context.cache.addImage(value.value);
                return image_1;
            }
            if (value.type === 18 /* FUNCTION */) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported image function \"" + value.name + "\"");
                }
                return imageFunction(context, value.values);
            }
            throw new Error("Unsupported image type " + value.type);
        }
    };
    function isSupportedImage(value) {
        return (!(value.type === 20 /* IDENT_TOKEN */ && value.value === 'none') &&
            (value.type !== 18 /* FUNCTION */ || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]));
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        'linear-gradient': linearGradient,
        '-moz-linear-gradient': prefixLinearGradient,
        '-ms-linear-gradient': prefixLinearGradient,
        '-o-linear-gradient': prefixLinearGradient,
        '-webkit-linear-gradient': prefixLinearGradient,
        'radial-gradient': radialGradient,
        '-moz-radial-gradient': prefixRadialGradient,
        '-ms-radial-gradient': prefixRadialGradient,
        '-o-radial-gradient': prefixRadialGradient,
        '-webkit-radial-gradient': prefixRadialGradient,
        '-webkit-gradient': webkitGradient
    };

    var backgroundImage = {
        name: 'background-image',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (context, tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return [];
            }
            return tokens
                .filter(function (value) { return nonFunctionArgSeparator(value) && isSupportedImage(value); })
                .map(function (value) { return image.parse(context, value); });
        }
    };

    var backgroundOrigin = {
        name: 'background-origin',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.map(function (token) {
                if (isIdentToken(token)) {
                    switch (token.value) {
                        case 'padding-box':
                            return 1 /* PADDING_BOX */;
                        case 'content-box':
                            return 2 /* CONTENT_BOX */;
                    }
                }
                return 0 /* BORDER_BOX */;
            });
        }
    };

    var backgroundPosition = {
        name: 'background-position',
        initialValue: '0% 0%',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (_context, tokens) {
            return parseFunctionArgs(tokens)
                .map(function (values) { return values.filter(isLengthPercentage); })
                .map(parseLengthPercentageTuple);
        }
    };

    var backgroundRepeat = {
        name: 'background-repeat',
        initialValue: 'repeat',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return parseFunctionArgs(tokens)
                .map(function (values) {
                return values
                    .filter(isIdentToken)
                    .map(function (token) { return token.value; })
                    .join(' ');
            })
                .map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function (value) {
        switch (value) {
            case 'no-repeat':
                return 1 /* NO_REPEAT */;
            case 'repeat-x':
            case 'repeat no-repeat':
                return 2 /* REPEAT_X */;
            case 'repeat-y':
            case 'no-repeat repeat':
                return 3 /* REPEAT_Y */;
            case 'repeat':
            default:
                return 0 /* REPEAT */;
        }
    };

    var BACKGROUND_SIZE;
    (function (BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: 'background-size',
        initialValue: '0',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return parseFunctionArgs(tokens).map(function (values) { return values.filter(isBackgroundSizeInfoToken); });
        }
    };
    var isBackgroundSizeInfoToken = function (value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };

    var borderColorForSide = function (side) { return ({
        name: "border-" + side + "-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    }); };
    var borderTopColor = borderColorForSide('top');
    var borderRightColor = borderColorForSide('right');
    var borderBottomColor = borderColorForSide('bottom');
    var borderLeftColor = borderColorForSide('left');

    var borderRadiusForSide = function (side) { return ({
        name: "border-radius-" + side,
        initialValue: '0 0',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
        }
    }); };
    var borderTopLeftRadius = borderRadiusForSide('top-left');
    var borderTopRightRadius = borderRadiusForSide('top-right');
    var borderBottomRightRadius = borderRadiusForSide('bottom-right');
    var borderBottomLeftRadius = borderRadiusForSide('bottom-left');

    var borderStyleForSide = function (side) { return ({
        name: "border-" + side + "-style",
        initialValue: 'solid',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, style) {
            switch (style) {
                case 'none':
                    return 0 /* NONE */;
                case 'dashed':
                    return 2 /* DASHED */;
                case 'dotted':
                    return 3 /* DOTTED */;
                case 'double':
                    return 4 /* DOUBLE */;
            }
            return 1 /* SOLID */;
        }
    }); };
    var borderTopStyle = borderStyleForSide('top');
    var borderRightStyle = borderStyleForSide('right');
    var borderBottomStyle = borderStyleForSide('bottom');
    var borderLeftStyle = borderStyleForSide('left');

    var borderWidthForSide = function (side) { return ({
        name: "border-" + side + "-width",
        initialValue: '0',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isDimensionToken(token)) {
                return token.number;
            }
            return 0;
        }
    }); };
    var borderTopWidth = borderWidthForSide('top');
    var borderRightWidth = borderWidthForSide('right');
    var borderBottomWidth = borderWidthForSide('bottom');
    var borderLeftWidth = borderWidthForSide('left');

    var color = {
        name: "color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var direction = {
        name: 'direction',
        initialValue: 'ltr',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, direction) {
            switch (direction) {
                case 'rtl':
                    return 1 /* RTL */;
                case 'ltr':
                default:
                    return 0 /* LTR */;
            }
        }
    };

    var display = {
        name: 'display',
        initialValue: 'inline-block',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.filter(isIdentToken).reduce(function (bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */);
        }
    };
    var parseDisplayValue = function (display) {
        switch (display) {
            case 'block':
            case '-webkit-box':
                return 2 /* BLOCK */;
            case 'inline':
                return 4 /* INLINE */;
            case 'run-in':
                return 8 /* RUN_IN */;
            case 'flow':
                return 16 /* FLOW */;
            case 'flow-root':
                return 32 /* FLOW_ROOT */;
            case 'table':
                return 64 /* TABLE */;
            case 'flex':
            case '-webkit-flex':
                return 128 /* FLEX */;
            case 'grid':
            case '-ms-grid':
                return 256 /* GRID */;
            case 'ruby':
                return 512 /* RUBY */;
            case 'subgrid':
                return 1024 /* SUBGRID */;
            case 'list-item':
                return 2048 /* LIST_ITEM */;
            case 'table-row-group':
                return 4096 /* TABLE_ROW_GROUP */;
            case 'table-header-group':
                return 8192 /* TABLE_HEADER_GROUP */;
            case 'table-footer-group':
                return 16384 /* TABLE_FOOTER_GROUP */;
            case 'table-row':
                return 32768 /* TABLE_ROW */;
            case 'table-cell':
                return 65536 /* TABLE_CELL */;
            case 'table-column-group':
                return 131072 /* TABLE_COLUMN_GROUP */;
            case 'table-column':
                return 262144 /* TABLE_COLUMN */;
            case 'table-caption':
                return 524288 /* TABLE_CAPTION */;
            case 'ruby-base':
                return 1048576 /* RUBY_BASE */;
            case 'ruby-text':
                return 2097152 /* RUBY_TEXT */;
            case 'ruby-base-container':
                return 4194304 /* RUBY_BASE_CONTAINER */;
            case 'ruby-text-container':
                return 8388608 /* RUBY_TEXT_CONTAINER */;
            case 'contents':
                return 16777216 /* CONTENTS */;
            case 'inline-block':
                return 33554432 /* INLINE_BLOCK */;
            case 'inline-list-item':
                return 67108864 /* INLINE_LIST_ITEM */;
            case 'inline-table':
                return 134217728 /* INLINE_TABLE */;
            case 'inline-flex':
                return 268435456 /* INLINE_FLEX */;
            case 'inline-grid':
                return 536870912 /* INLINE_GRID */;
        }
        return 0 /* NONE */;
    };

    var float = {
        name: 'float',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, float) {
            switch (float) {
                case 'left':
                    return 1 /* LEFT */;
                case 'right':
                    return 2 /* RIGHT */;
                case 'inline-start':
                    return 3 /* INLINE_START */;
                case 'inline-end':
                    return 4 /* INLINE_END */;
            }
            return 0 /* NONE */;
        }
    };

    var letterSpacing = {
        name: 'letter-spacing',
        initialValue: '0',
        prefix: false,
        type: 0 /* VALUE */,
        parse: function (_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ && token.value === 'normal') {
                return 0;
            }
            if (token.type === 17 /* NUMBER_TOKEN */) {
                return token.number;
            }
            if (token.type === 15 /* DIMENSION_TOKEN */) {
                return token.number;
            }
            return 0;
        }
    };

    var LINE_BREAK;
    (function (LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: 'line-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, lineBreak) {
            switch (lineBreak) {
                case 'strict':
                    return LINE_BREAK.STRICT;
                case 'normal':
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };

    var lineHeight = {
        name: 'line-height',
        initialValue: 'normal',
        prefix: false,
        type: 4 /* TOKEN_VALUE */
    };
    var computeLineHeight = function (token, fontSize) {
        if (isIdentToken(token) && token.value === 'normal') {
            return 1.2 * fontSize;
        }
        else if (token.type === 17 /* NUMBER_TOKEN */) {
            return fontSize * token.number;
        }
        else if (isLengthPercentage(token)) {
            return getAbsoluteValue(token, fontSize);
        }
        return fontSize;
    };

    var listStyleImage = {
        name: 'list-style-image',
        initialValue: 'none',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ && token.value === 'none') {
                return null;
            }
            return image.parse(context, token);
        }
    };

    var listStylePosition = {
        name: 'list-style-position',
        initialValue: 'outside',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, position) {
            switch (position) {
                case 'inside':
                    return 0 /* INSIDE */;
                case 'outside':
                default:
                    return 1 /* OUTSIDE */;
            }
        }
    };

    var listStyleType = {
        name: 'list-style-type',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, type) {
            switch (type) {
                case 'disc':
                    return 0 /* DISC */;
                case 'circle':
                    return 1 /* CIRCLE */;
                case 'square':
                    return 2 /* SQUARE */;
                case 'decimal':
                    return 3 /* DECIMAL */;
                case 'cjk-decimal':
                    return 4 /* CJK_DECIMAL */;
                case 'decimal-leading-zero':
                    return 5 /* DECIMAL_LEADING_ZERO */;
                case 'lower-roman':
                    return 6 /* LOWER_ROMAN */;
                case 'upper-roman':
                    return 7 /* UPPER_ROMAN */;
                case 'lower-greek':
                    return 8 /* LOWER_GREEK */;
                case 'lower-alpha':
                    return 9 /* LOWER_ALPHA */;
                case 'upper-alpha':
                    return 10 /* UPPER_ALPHA */;
                case 'arabic-indic':
                    return 11 /* ARABIC_INDIC */;
                case 'armenian':
                    return 12 /* ARMENIAN */;
                case 'bengali':
                    return 13 /* BENGALI */;
                case 'cambodian':
                    return 14 /* CAMBODIAN */;
                case 'cjk-earthly-branch':
                    return 15 /* CJK_EARTHLY_BRANCH */;
                case 'cjk-heavenly-stem':
                    return 16 /* CJK_HEAVENLY_STEM */;
                case 'cjk-ideographic':
                    return 17 /* CJK_IDEOGRAPHIC */;
                case 'devanagari':
                    return 18 /* DEVANAGARI */;
                case 'ethiopic-numeric':
                    return 19 /* ETHIOPIC_NUMERIC */;
                case 'georgian':
                    return 20 /* GEORGIAN */;
                case 'gujarati':
                    return 21 /* GUJARATI */;
                case 'gurmukhi':
                    return 22 /* GURMUKHI */;
                case 'hebrew':
                    return 22 /* HEBREW */;
                case 'hiragana':
                    return 23 /* HIRAGANA */;
                case 'hiragana-iroha':
                    return 24 /* HIRAGANA_IROHA */;
                case 'japanese-formal':
                    return 25 /* JAPANESE_FORMAL */;
                case 'japanese-informal':
                    return 26 /* JAPANESE_INFORMAL */;
                case 'kannada':
                    return 27 /* KANNADA */;
                case 'katakana':
                    return 28 /* KATAKANA */;
                case 'katakana-iroha':
                    return 29 /* KATAKANA_IROHA */;
                case 'khmer':
                    return 30 /* KHMER */;
                case 'korean-hangul-formal':
                    return 31 /* KOREAN_HANGUL_FORMAL */;
                case 'korean-hanja-formal':
                    return 32 /* KOREAN_HANJA_FORMAL */;
                case 'korean-hanja-informal':
                    return 33 /* KOREAN_HANJA_INFORMAL */;
                case 'lao':
                    return 34 /* LAO */;
                case 'lower-armenian':
                    return 35 /* LOWER_ARMENIAN */;
                case 'malayalam':
                    return 36 /* MALAYALAM */;
                case 'mongolian':
                    return 37 /* MONGOLIAN */;
                case 'myanmar':
                    return 38 /* MYANMAR */;
                case 'oriya':
                    return 39 /* ORIYA */;
                case 'persian':
                    return 40 /* PERSIAN */;
                case 'simp-chinese-formal':
                    return 41 /* SIMP_CHINESE_FORMAL */;
                case 'simp-chinese-informal':
                    return 42 /* SIMP_CHINESE_INFORMAL */;
                case 'tamil':
                    return 43 /* TAMIL */;
                case 'telugu':
                    return 44 /* TELUGU */;
                case 'thai':
                    return 45 /* THAI */;
                case 'tibetan':
                    return 46 /* TIBETAN */;
                case 'trad-chinese-formal':
                    return 47 /* TRAD_CHINESE_FORMAL */;
                case 'trad-chinese-informal':
                    return 48 /* TRAD_CHINESE_INFORMAL */;
                case 'upper-armenian':
                    return 49 /* UPPER_ARMENIAN */;
                case 'disclosure-open':
                    return 50 /* DISCLOSURE_OPEN */;
                case 'disclosure-closed':
                    return 51 /* DISCLOSURE_CLOSED */;
                case 'none':
                default:
                    return -1 /* NONE */;
            }
        }
    };

    var marginForSide = function (side) { return ({
        name: "margin-" + side,
        initialValue: '0',
        prefix: false,
        type: 4 /* TOKEN_VALUE */
    }); };
    var marginTop = marginForSide('top');
    var marginRight = marginForSide('right');
    var marginBottom = marginForSide('bottom');
    var marginLeft = marginForSide('left');

    var overflow = {
        name: 'overflow',
        initialValue: 'visible',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.filter(isIdentToken).map(function (overflow) {
                switch (overflow.value) {
                    case 'hidden':
                        return 1 /* HIDDEN */;
                    case 'scroll':
                        return 2 /* SCROLL */;
                    case 'clip':
                        return 3 /* CLIP */;
                    case 'auto':
                        return 4 /* AUTO */;
                    case 'visible':
                    default:
                        return 0 /* VISIBLE */;
                }
            });
        }
    };

    var overflowWrap = {
        name: 'overflow-wrap',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, overflow) {
            switch (overflow) {
                case 'break-word':
                    return "break-word" /* BREAK_WORD */;
                case 'normal':
                default:
                    return "normal" /* NORMAL */;
            }
        }
    };

    var paddingForSide = function (side) { return ({
        name: "padding-" + side,
        initialValue: '0',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'length-percentage'
    }); };
    var paddingTop = paddingForSide('top');
    var paddingRight = paddingForSide('right');
    var paddingBottom = paddingForSide('bottom');
    var paddingLeft = paddingForSide('left');

    var textAlign = {
        name: 'text-align',
        initialValue: 'left',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, textAlign) {
            switch (textAlign) {
                case 'right':
                    return 2 /* RIGHT */;
                case 'center':
                case 'justify':
                    return 1 /* CENTER */;
                case 'left':
                default:
                    return 0 /* LEFT */;
            }
        }
    };

    var position = {
        name: 'position',
        initialValue: 'static',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, position) {
            switch (position) {
                case 'relative':
                    return 1 /* RELATIVE */;
                case 'absolute':
                    return 2 /* ABSOLUTE */;
                case 'fixed':
                    return 3 /* FIXED */;
                case 'sticky':
                    return 4 /* STICKY */;
            }
            return 0 /* STATIC */;
        }
    };

    var textShadow = {
        name: 'text-shadow',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) {
                return [];
            }
            return parseFunctionArgs(tokens).map(function (values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for (var i = 0; i < values.length; i++) {
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) {
                            shadow.offsetX = token;
                        }
                        else if (c === 1) {
                            shadow.offsetY = token;
                        }
                        else {
                            shadow.blur = token;
                        }
                        c++;
                    }
                    else {
                        shadow.color = color$1.parse(context, token);
                    }
                }
                return shadow;
            });
        }
    };

    var textTransform = {
        name: 'text-transform',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, textTransform) {
            switch (textTransform) {
                case 'uppercase':
                    return 2 /* UPPERCASE */;
                case 'lowercase':
                    return 1 /* LOWERCASE */;
                case 'capitalize':
                    return 3 /* CAPITALIZE */;
            }
            return 0 /* NONE */;
        }
    };

    var transform$1 = {
        name: 'transform',
        initialValue: 'none',
        prefix: true,
        type: 0 /* VALUE */,
        parse: function (_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ && token.value === 'none') {
                return null;
            }
            if (token.type === 18 /* FUNCTION */) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported transform function \"" + token.name + "\"");
                }
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function (args) {
        var values = args.filter(function (arg) { return arg.type === 17 /* NUMBER_TOKEN */; }).map(function (arg) { return arg.number; });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function (args) {
        var values = args.filter(function (arg) { return arg.type === 17 /* NUMBER_TOKEN */; }).map(function (arg) { return arg.number; });
        var a1 = values[0], b1 = values[1]; values[2]; values[3]; var a2 = values[4], b2 = values[5]; values[6]; values[7]; values[8]; values[9]; values[10]; values[11]; var a4 = values[12], b4 = values[13]; values[14]; values[15];
        return values.length === 16 ? [a1, b1, a2, b2, a4, b4] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };

    var DEFAULT_VALUE = {
        type: 16 /* PERCENTAGE_TOKEN */,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [DEFAULT_VALUE, DEFAULT_VALUE];
    var transformOrigin = {
        name: 'transform-origin',
        initialValue: '50% 50%',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) {
                return DEFAULT;
            }
            return [origins[0], origins[1]];
        }
    };

    var visibility = {
        name: 'visible',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, visibility) {
            switch (visibility) {
                case 'hidden':
                    return 1 /* HIDDEN */;
                case 'collapse':
                    return 2 /* COLLAPSE */;
                case 'visible':
                default:
                    return 0 /* VISIBLE */;
            }
        }
    };

    var WORD_BREAK;
    (function (WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: 'word-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, wordBreak) {
            switch (wordBreak) {
                case 'break-all':
                    return WORD_BREAK.BREAK_ALL;
                case 'keep-all':
                    return WORD_BREAK.KEEP_ALL;
                case 'normal':
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };

    var zIndex = {
        name: 'z-index',
        initialValue: 'auto',
        prefix: false,
        type: 0 /* VALUE */,
        parse: function (_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */) {
                return { auto: true, order: 0 };
            }
            if (isNumberToken(token)) {
                return { auto: false, order: token.number };
            }
            throw new Error("Invalid z-index number parsed");
        }
    };

    var time = {
        name: 'time',
        parse: function (_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */) {
                switch (value.unit.toLowerCase()) {
                    case 's':
                        return 1000 * value.number;
                    case 'ms':
                        return value.number;
                }
            }
            throw new Error("Unsupported time type");
        }
    };

    var opacity = {
        name: 'opacity',
        initialValue: '1',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isNumberToken(token)) {
                return token.number;
            }
            return 1;
        }
    };

    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var textDecorationLine = {
        name: 'text-decoration-line',
        initialValue: 'none',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens
                .filter(isIdentToken)
                .map(function (token) {
                switch (token.value) {
                    case 'underline':
                        return 1 /* UNDERLINE */;
                    case 'overline':
                        return 2 /* OVERLINE */;
                    case 'line-through':
                        return 3 /* LINE_THROUGH */;
                    case 'none':
                        return 4 /* BLINK */;
                }
                return 0 /* NONE */;
            })
                .filter(function (line) { return line !== 0 /* NONE */; });
        }
    };

    var fontFamily = {
        name: "font-family",
        initialValue: '',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function (token) {
                switch (token.type) {
                    case 20 /* IDENT_TOKEN */:
                    case 0 /* STRING_TOKEN */:
                        accumulator.push(token.value);
                        break;
                    case 17 /* NUMBER_TOKEN */:
                        accumulator.push(token.number.toString());
                        break;
                    case 4 /* COMMA_TOKEN */:
                        results.push(accumulator.join(' '));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) {
                results.push(accumulator.join(' '));
            }
            return results.map(function (result) { return (result.indexOf(' ') === -1 ? result : "'" + result + "'"); });
        }
    };

    var fontSize = {
        name: "font-size",
        initialValue: '0',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'length'
    };

    var fontWeight = {
        name: 'font-weight',
        initialValue: 'normal',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isNumberToken(token)) {
                return token.number;
            }
            if (isIdentToken(token)) {
                switch (token.value) {
                    case 'bold':
                        return 700;
                    case 'normal':
                    default:
                        return 400;
                }
            }
            return 400;
        }
    };

    var fontVariant = {
        name: 'font-variant',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (_context, tokens) {
            return tokens.filter(isIdentToken).map(function (token) { return token.value; });
        }
    };

    var fontStyle = {
        name: 'font-style',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, overflow) {
            switch (overflow) {
                case 'oblique':
                    return "oblique" /* OBLIQUE */;
                case 'italic':
                    return "italic" /* ITALIC */;
                case 'normal':
                default:
                    return "normal" /* NORMAL */;
            }
        }
    };

    var contains = function (bit, value) { return (bit & value) !== 0; };

    var content = {
        name: 'content',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return [];
            }
            return tokens;
        }
    };

    var counterIncrement = {
        name: 'counter-increment',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return null;
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return null;
            }
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for (var i = 0; i < filtered.length; i++) {
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === 20 /* IDENT_TOKEN */) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({ counter: counter.value, increment: increment });
                }
            }
            return increments;
        }
    };

    var counterReset = {
        name: 'counter-reset',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for (var i = 0; i < filtered.length; i++) {
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== 'none') {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({ counter: counter.value, reset: reset });
                }
            }
            return resets;
        }
    };

    var duration = {
        name: 'duration',
        initialValue: '0s',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (context, tokens) {
            return tokens.filter(isDimensionToken).map(function (token) { return time.parse(context, token); });
        }
    };

    var quotes = {
        name: 'quotes',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return null;
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return null;
            }
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) {
                return null;
            }
            for (var i = 0; i < filtered.length; i += 2) {
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({ open: open_1, close: close_1 });
            }
            return quotes;
        }
    };
    var getQuote = function (quotes, depth, open) {
        if (!quotes) {
            return '';
        }
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) {
            return '';
        }
        return open ? quote.open : quote.close;
    };

    var dropShadowFilter = {
        name: 'filter',
        initialValue: 'none',
        type: 1, /* LIST */
        prefix: false,
        parse: function (context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) {
                return [];
            }
            return parseFunctionArgs(tokens).map(function (values) {

                var firstToken = values[0];
                if (firstToken.type == 18  /* FUNCTION */) {
                    if (firstToken.name == 'drop-shadow') {
                        return dropShadowFunction(context, firstToken.values);
                    }
                }
                return null;
            });

        }
    };

    var dropShadowFunction = function(context, values) {
        var shadow = {
            color: 0x777777ff,
            offsetX: ZERO_LENGTH,
            offsetY: ZERO_LENGTH,
            blur: ZERO_LENGTH,
            inset: false
        };
        var c = 0;
        for (var i = 0; i < values.length; i++) {
            var token = values[i];
            if (isIdentWithValue(token, 'inset')) {
                shadow.inset = true;
            }
            else if (token.type == 31 /* White Space */) {
                continue;
            }
            else if (isLength(token)) {
                if (c === 0) {
                    shadow.offsetX = token;
                }
                else if (c === 1) {
                    shadow.offsetY = token;
                }
                else {
                    shadow.blur = token;
                }
                c++;
            }
            else {
                shadow.color = color$1.parse(context, token);
            }
        }
        return shadow;
    }

    var boxShadow = {
        name: 'box-shadow',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) {
                return [];
            }
            return parseFunctionArgs(tokens).map(function (values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for (var i = 0; i < values.length; i++) {
                    var token = values[i];
                    if (isIdentWithValue(token, 'inset')) {
                        shadow.inset = true;
                    }
                    else if (isLength(token)) {
                        if (c === 0) {
                            shadow.offsetX = token;
                        }
                        else if (c === 1) {
                            shadow.offsetY = token;
                        }
                        else if (c === 2) {
                            shadow.blur = token;
                        }
                        else {
                            shadow.spread = token;
                        }
                        c++;
                    }
                    else {
                        shadow.color = color$1.parse(context, token);
                    }
                }
                return shadow;
            });
        }
    };

    var paintOrder = {
        name: 'paint-order',
        initialValue: 'normal',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            var DEFAULT_VALUE = [0 /* FILL */, 1 /* STROKE */, 2 /* MARKERS */];
            var layers = [];
            tokens.filter(isIdentToken).forEach(function (token) {
                switch (token.value) {
                    case 'stroke':
                        layers.push(1 /* STROKE */);
                        break;
                    case 'fill':
                        layers.push(0 /* FILL */);
                        break;
                    case 'markers':
                        layers.push(2 /* MARKERS */);
                        break;
                }
            });
            DEFAULT_VALUE.forEach(function (value) {
                if (layers.indexOf(value) === -1) {
                    layers.push(value);
                }
            });
            return layers;
        }
    };

    var webkitTextStrokeColor = {
        name: "-webkit-text-stroke-color",
        initialValue: 'currentcolor',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var webkitTextStrokeWidth = {
        name: "-webkit-text-stroke-width",
        initialValue: '0',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isDimensionToken(token)) {
                return token.number;
            }
            return 0;
        }
    };

    var webkitMaskImage = {
        name: "-webkit-mask-image",
        initialValue: 'none',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (context, tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return [];
            }
            return tokens
                .filter(function (value) { return nonFunctionArgSeparator(value) && isSupportedImage(value); })
                .map(function (value) { return image.parse(context, value); });
        }
    };

    var CSSParsedDeclaration = /** @class */ (function () {
        function CSSParsedDeclaration(context, declaration) {
            var _a, _b;
            this.animationDuration = parse(context, duration, declaration.animationDuration);
            this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
            this.dropShadow = parse(context, dropShadowFilter, declaration.filter);
            this.color = parse(context, color, declaration.color);
            this.direction = parse(context, direction, declaration.direction);
            this.display = parse(context, display, declaration.display);
            this.float = parse(context, float, declaration.cssFloat);
            this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
            this.fontSize = parse(context, fontSize, declaration.fontSize);
            this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
            this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
            this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
            this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
            this.marginTop = parse(context, marginTop, declaration.marginTop);
            this.marginRight = parse(context, marginRight, declaration.marginRight);
            this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
            this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
            this.opacity = parse(context, opacity, declaration.opacity);
            var overflowTuple = parse(context, overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
            this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
            this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
            this.position = parse(context, position, declaration.position);
            this.textAlign = parse(context, textAlign, declaration.textAlign);
            this.textDecorationColor = parse(context, textDecorationColor, (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color);
            this.textDecorationLine = parse(context, textDecorationLine, (_b = declaration.textDecorationLine) !== null && _b !== void 0 ? _b : declaration.textDecoration);
            this.textShadow = parse(context, textShadow, declaration.textShadow);
            this.textTransform = parse(context, textTransform, declaration.textTransform);
            this.transform = parse(context, transform$1, declaration.transform);
            this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
            this.visibility = parse(context, visibility, declaration.visibility);
            this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
            this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
            this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
            this.zIndex = parse(context, zIndex, declaration.zIndex);
            this.webkitMaskImage = parse(context, webkitMaskImage, declaration.webkitMaskImage);
        }
        CSSParsedDeclaration.prototype.isVisible = function () {
            return this.display > 0 && this.opacity > 0 && this.visibility === 0 /* VISIBLE */;
        };
        CSSParsedDeclaration.prototype.isTransparent = function () {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function () {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function () {
            return this.position !== 0 /* STATIC */;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function () {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function () {
            return this.float !== 0 /* NONE */;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function () {
            return (contains(this.display, 4 /* INLINE */) ||
                contains(this.display, 33554432 /* INLINE_BLOCK */) ||
                contains(this.display, 268435456 /* INLINE_FLEX */) ||
                contains(this.display, 536870912 /* INLINE_GRID */) ||
                contains(this.display, 67108864 /* INLINE_LIST_ITEM */) ||
                contains(this.display, 134217728 /* INLINE_TABLE */));
        };
        return CSSParsedDeclaration;
    }());
    var CSSParsedPseudoDeclaration = /** @class */ (function () {
        function CSSParsedPseudoDeclaration(context, declaration) {
            this.content = parse(context, content, declaration.content);
            this.quotes = parse(context, quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }());
    var CSSParsedCounterDeclaration = /** @class */ (function () {
        function CSSParsedCounterDeclaration(context, declaration) {
            this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(context, counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }());
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function (context, descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== 'undefined' ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch (descriptor.type) {
            case 2 /* IDENT_VALUE */:
                var token = parser.parseComponentValue();
                return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
            case 0 /* VALUE */:
                return descriptor.parse(context, parser.parseComponentValue());
            case 1 /* LIST */:
                return descriptor.parse(context, parser.parseComponentValues());
            case 4 /* TOKEN_VALUE */:
                return parser.parseComponentValue();
            case 3 /* TYPE_VALUE */:
                switch (descriptor.format) {
                    case 'angle':
                        return angle.parse(context, parser.parseComponentValue());
                    case 'color':
                        return color$1.parse(context, parser.parseComponentValue());
                    case 'image':
                        return image.parse(context, parser.parseComponentValue());
                    case 'length':
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case 'length-percentage':
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                    case 'time':
                        return time.parse(context, parser.parseComponentValue());
                }
                break;
        }
    };

    var elementDebuggerAttribute = 'data-html2canvas-debug';
    var getElementDebugType = function (element) {
        var attribute = element.getAttribute(elementDebuggerAttribute);
        switch (attribute) {
            case 'all':
                return 1 /* ALL */;
            case 'clone':
                return 2 /* CLONE */;
            case 'parse':
                return 3 /* PARSE */;
            case 'render':
                return 4 /* RENDER */;
            default:
                return 0 /* NONE */;
        }
    };
    var isDebugging = function (element, type) {
        var elementType = getElementDebugType(element);
        return elementType === 1 /* ALL */ || type === elementType;
    };

    var ElementContainer = /** @class */ (function () {
        function ElementContainer(context, element) {
            this.context = context;
            this.textNodes = [];
            this.elements = [];
            this.flags = 0;
            if (isDebugging(element, 3 /* PARSE */)) {
                debugger;
            }
            this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
            if (isHTMLElementNode(element)) {
                if (this.styles.animationDuration.some(function (duration) { return duration > 0; })) {
                    element.style.animationDuration = '0s';
                }
                if (this.styles.transform !== null) {
                    // getBoundingClientRect takes transforms into account
                    element.style.transform = 'none';
                }
            }
            this.bounds = parseBounds(this.context, element);

            if (element.hasAttribute('data-html2canvas-hole')) {
                this.isHole = true;
            }
            if (element.hasAttribute('data-html2canvas-target')) {
                this.isTarget = true;
            }

            if (isDebugging(element, 4 /* RENDER */)) {
                this.flags |= 16 /* DEBUG_RENDER */;
            }
        }
        return ElementContainer;
    }());

    /*
     * text-segmentation 1.0.3 <https://github.com/niklasvh/text-segmentation>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var base64 = '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';

    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$1 = 0; i$1 < chars$1.length; i$1++) {
        lookup$1[chars$1.charCodeAt(i$1)] = i$1;
    }
    var decode = function (base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') {
                bufferLength--;
            }
        }
        var buffer = typeof ArrayBuffer !== 'undefined' &&
            typeof Uint8Array !== 'undefined' &&
            typeof Uint8Array.prototype.slice !== 'undefined'
            ? new ArrayBuffer(bufferLength)
            : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for (i = 0; i < len; i += 4) {
            encoded1 = lookup$1[base64.charCodeAt(i)];
            encoded2 = lookup$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1[base64.charCodeAt(i + 3)];
            bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
            bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
            bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
        }
        return buffer;
    };
    var polyUint16Array = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 2) {
            bytes.push((buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };
    var polyUint32Array = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 4) {
            bytes.push((buffer[i + 3] << 24) | (buffer[i + 2] << 16) | (buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };

    /** Shift size for getting the index-2 table offset. */
    var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */
    var UTRIE2_SHIFT_1 = 6 + 5;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */
    var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */
    var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */
    var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */
    var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */
    var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */
    var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */
    var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 0x800 >> 6; /* U+0800 is the first code point after 2-byte UTF-8 */
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */
    var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */
    var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */
    var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */
    var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function (base64, _byteLength) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2
            ? slice16(view16, (headerLength + view32[4]) / 2)
            : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ (function () {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */
        Trie.prototype.get = function (codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || (codePoint > 0x0dbff && codePoint <= 0x0ffff)) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + ((codePoint - 0xd800) >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += (codePoint >> UTRIE2_SHIFT_2) & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) {
                    return this.data[this.highValueIndex];
                }
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }());

    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i = 0; i < chars.length; i++) {
        lookup[chars.charCodeAt(i)] = i;
    }

    var Prepend = 1;
    var CR = 2;
    var LF = 3;
    var Control = 4;
    var Extend = 5;
    var SpacingMark = 7;
    var L = 8;
    var V = 9;
    var T = 10;
    var LV = 11;
    var LVT = 12;
    var ZWJ = 13;
    var Extended_Pictographic = 14;
    var RI = 15;
    var toCodePoints = function (str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while (i < length) {
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) {
                    codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                }
                else {
                    codePoints.push(value);
                    i--;
                }
            }
            else {
                codePoints.push(value);
            }
        }
        return codePoints;
    };
    var fromCodePoint = function () {
        var codePoints = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            codePoints[_i] = arguments[_i];
        }
        if (String.fromCodePoint) {
            return String.fromCodePoint.apply(String, codePoints);
        }
        var length = codePoints.length;
        if (!length) {
            return '';
        }
        var codeUnits = [];
        var index = -1;
        var result = '';
        while (++index < length) {
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) {
                codeUnits.push(codePoint);
            }
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, (codePoint % 0x400) + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var UnicodeTrie = createTrieFromBase64(base64);
    var BREAK_NOT_ALLOWED = '×';
    var BREAK_ALLOWED = '÷';
    var codePointToClass = function (codePoint) { return UnicodeTrie.get(codePoint); };
    var _graphemeBreakAtIndex = function (_codePoints, classTypes, index) {
        var prevIndex = index - 2;
        var prev = classTypes[prevIndex];
        var current = classTypes[index - 1];
        var next = classTypes[index];
        // GB3 Do not break between a CR and LF
        if (current === CR && next === LF) {
            return BREAK_NOT_ALLOWED;
        }
        // GB4 Otherwise, break before and after controls.
        if (current === CR || current === LF || current === Control) {
            return BREAK_ALLOWED;
        }
        // GB5
        if (next === CR || next === LF || next === Control) {
            return BREAK_ALLOWED;
        }
        // Do not break Hangul syllable sequences.
        // GB6
        if (current === L && [L, V, LV, LVT].indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED;
        }
        // GB7
        if ((current === LV || current === V) && (next === V || next === T)) {
            return BREAK_NOT_ALLOWED;
        }
        // GB8
        if ((current === LVT || current === T) && next === T) {
            return BREAK_NOT_ALLOWED;
        }
        // GB9 Do not break before extending characters or ZWJ.
        if (next === ZWJ || next === Extend) {
            return BREAK_NOT_ALLOWED;
        }
        // Do not break before SpacingMarks, or after Prepend characters.
        // GB9a
        if (next === SpacingMark) {
            return BREAK_NOT_ALLOWED;
        }
        // GB9a
        if (current === Prepend) {
            return BREAK_NOT_ALLOWED;
        }
        // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
        if (current === ZWJ && next === Extended_Pictographic) {
            while (prev === Extend) {
                prev = classTypes[--prevIndex];
            }
            if (prev === Extended_Pictographic) {
                return BREAK_NOT_ALLOWED;
            }
        }
        // GB12 Do not break within emoji flag sequences.
        // That is, do not break between regional indicator (RI) symbols
        // if there is an odd number of RI characters before the break point.
        if (current === RI && next === RI) {
            var countRI = 0;
            while (prev === RI) {
                countRI++;
                prev = classTypes[--prevIndex];
            }
            if (countRI % 2 === 0) {
                return BREAK_NOT_ALLOWED;
            }
        }
        return BREAK_ALLOWED;
    };
    var GraphemeBreaker = function (str) {
        var codePoints = toCodePoints(str);
        var length = codePoints.length;
        var index = 0;
        var lastEnd = 0;
        var classTypes = codePoints.map(codePointToClass);
        return {
            next: function () {
                if (index >= length) {
                    return { done: true, value: null };
                }
                var graphemeBreak = BREAK_NOT_ALLOWED;
                while (index < length &&
                    (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) === BREAK_NOT_ALLOWED) { }
                if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
                    var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index));
                    lastEnd = index;
                    return { value: value, done: false };
                }
                return { done: true, value: null };
            },
        };
    };
    var splitGraphemes = function (str) {
        var breaker = GraphemeBreaker(str);
        var graphemes = [];
        var bk;
        while (!(bk = breaker.next()).done) {
            if (bk.value) {
                graphemes.push(bk.value.slice());
            }
        }
        return graphemes;
    };

    var testRangeBounds = function (document) {
        var TEST_HEIGHT = 123;
        if (document.createRange) {
            var range = document.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document.createElement('boundtest');
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = 'block';
                document.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) {
                    return true;
                }
            }
        }
        return false;
    };
    var testIOSLineBreak = function (document) {
        var testElement = document.createElement('boundtest');
        testElement.style.width = '50px';
        testElement.style.display = 'block';
        testElement.style.fontSize = '12px';
        testElement.style.letterSpacing = '0px';
        testElement.style.wordSpacing = '0px';
        document.body.appendChild(testElement);
        var range = document.createRange();
        testElement.innerHTML = typeof ''.repeat === 'function' ? '&#128104;'.repeat(10) : '';
        var node = testElement.firstChild;
        var textList = toCodePoints$1(node.data).map(function (i) { return fromCodePoint$1(i); });
        var offset = 0;
        var prev = {};
        // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
        var supports = textList.every(function (text, i) {
            range.setStart(node, offset);
            range.setEnd(node, offset + text.length);
            var rect = range.getBoundingClientRect();
            offset += text.length;
            var boundAhead = rect.x > prev.x || rect.y > prev.y;
            prev = rect;
            if (i === 0) {
                return true;
            }
            return boundAhead;
        });
        document.body.removeChild(testElement);
        return supports;
    };
    var testCORS = function () { return typeof new Image().crossOrigin !== 'undefined'; };
    var testResponseType = function () { return typeof new XMLHttpRequest().responseType === 'string'; };
    var testSVG = function (document) {
        var img = new Image();
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        if (!ctx) {
            return false;
        }
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        }
        catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function (data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function (document) {
        var canvas = document.createElement('canvas');
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext('2d');
        if (!ctx) {
            return Promise.reject(false);
        }
        ctx.fillStyle = 'rgb(0, 255, 0)';
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = 'red';
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG$1(svg)
            .then(function (img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = 'red';
            ctx.fillRect(0, 0, size, size);
            var node = document.createElement('div');
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data)
                ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node))
                : Promise.reject(false);
        })
            .then(function (img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        })
            .catch(function () { return false; });
    };
    var createForeignObjectSVG = function (width, height, x, y, node) {
        var xmlns = 'http://www.w3.org/2000/svg';
        var svg = document.createElementNS(xmlns, 'svg');
        var foreignObject = document.createElementNS(xmlns, 'foreignObject');
        svg.setAttributeNS(null, 'width', width.toString());
        svg.setAttributeNS(null, 'height', height.toString());
        foreignObject.setAttributeNS(null, 'width', '100%');
        foreignObject.setAttributeNS(null, 'height', '100%');
        foreignObject.setAttributeNS(null, 'x', x.toString());
        foreignObject.setAttributeNS(null, 'y', y.toString());
        foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG$1 = function (svg) {
        return new Promise(function (resolve, reject) {
            var img = new Image();
            img.onload = function () { return resolve(img); };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS() {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', { value: value });
            return value;
        },
        get SUPPORT_WORD_BREAKING() {
            var value = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
            Object.defineProperty(FEATURES, 'SUPPORT_WORD_BREAKING', { value: value });
            return value;
        },
        get SUPPORT_SVG_DRAWING() {
            var value = testSVG(document);
            Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', { value: value });
            return value;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING() {
            var value = typeof Array.from === 'function' && typeof window.fetch === 'function'
                ? testForeignObject(document)
                : Promise.resolve(false);
            Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', { value: value });
            return value;
        },
        get SUPPORT_CORS_IMAGES() {
            var value = testCORS();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', { value: value });
            return value;
        },
        get SUPPORT_RESPONSE_TYPE() {
            var value = testResponseType();
            Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', { value: value });
            return value;
        },
        get SUPPORT_CORS_XHR() {
            var value = 'withCredentials' in new XMLHttpRequest();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', { value: value });
            return value;
        },
        get SUPPORT_NATIVE_TEXT_SEGMENTATION() {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var value = !!(typeof Intl !== 'undefined' && Intl.Segmenter);
            Object.defineProperty(FEATURES, 'SUPPORT_NATIVE_TEXT_SEGMENTATION', { value: value });
            return value;
        }
    };

    var TextBounds = /** @class */ (function () {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }());
    var parseTextBounds = function (context, value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function (text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    var clientRects = createRange(node, offset, text.length).getClientRects();
                    if (clientRects.length > 1) {
                        var subSegments = segmentGraphemes(text);
                        var subOffset_1 = 0;
                        subSegments.forEach(function (subSegment) {
                            textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset, subSegment.length).getClientRects())));
                            subOffset_1 += subSegment.length;
                        });
                    }
                    else {
                        textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
                    }
                }
                else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
                    node = replacementNode;
                }
            }
            else if (!FEATURES.SUPPORT_RANGE_BOUNDS) {
                node = node.splitText(text.length);
            }
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function (context, node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement('html2canvaswrapper');
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(context, wrapper);
                if (wrapper.firstChild) {
                    parentNode.replaceChild(wrapper.firstChild, wrapper);
                }
                return bounds;
            }
        }
        return Bounds.EMPTY;
    };
    var createRange = function (node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) {
            throw new Error('Node has no owner document');
        }
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return range;
    };
    var segmentGraphemes = function (value) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, { granularity: 'grapheme' });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function (segment) { return segment.segment; });
        }
        return splitGraphemes(value);
    };
    var segmentWords = function (value, styles) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'word'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function (segment) { return segment.segment; });
        }
        return breakWords(value, styles);
    };
    var breakText = function (value, styles) {
        return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
    };
    // https://drafts.csswg.org/css-text/#word-separator
    var wordSeparators = [0x0020, 0x00a0, 0x1361, 0x10100, 0x10101, 0x1039, 0x1091];
    var breakWords = function (str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === "break-word" /* BREAK_WORD */ ? 'break-word' : styles.wordBreak
        });
        var words = [];
        var bk;
        var _loop_1 = function () {
            if (bk.value) {
                var value = bk.value.slice();
                var codePoints = toCodePoints$1(value);
                var word_1 = '';
                codePoints.forEach(function (codePoint) {
                    if (wordSeparators.indexOf(codePoint) === -1) {
                        word_1 += fromCodePoint$1(codePoint);
                    }
                    else {
                        if (word_1.length) {
                            words.push(word_1);
                        }
                        words.push(fromCodePoint$1(codePoint));
                        word_1 = '';
                    }
                });
                if (word_1.length) {
                    words.push(word_1);
                }
            }
        };
        while (!(bk = breaker.next()).done) {
            _loop_1();
        }
        return words;
    };

    var TextContainer = /** @class */ (function () {
        function isValidWritingMode(mode) {
            if (!mode) {
                return false;
            }
            switch (mode) {
                case 'none':
                case 'unset':
                case 'inherit': 
                case 'initial':
                    return false;
                default:
                    return true;
            }
            if ('unset' == mode) {
                return false;
            }
            if ('none' == mode) {
                return false;
            }
            if ('inherit' == mode) {
                return false;
            }
        }
        function TextContainer(context, node, styles) {
            this.text = transform(node.data, styles.textTransform);
            if (isValidWritingMode(node.parentElement.style.writingMode)) {
                styles.writingMode = node.parentElement.style.writingMode;
            } 
            else if (isValidWritingMode(node.parentElement.parentElement.style.writingMode)) {
                styles.writingMode = node.parentElement.parentElement.style.writingMode;
            }
            this.textBounds = parseTextBounds(context, this.text, styles, node);
        }
        return TextContainer;
    }());
    var transform = function (text, transform) {
        switch (transform) {
            case 1 /* LOWERCASE */:
                return text.toLowerCase();
            case 3 /* CAPITALIZE */:
                return text.replace(CAPITALIZE, capitalize);
            case 2 /* UPPERCASE */:
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function (m, p1, p2) {
        if (m.length > 0) {
            return p1 + p2.toUpperCase();
        }
        return m;
    };

    var ImageElementContainer = /** @class */ (function (_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            _this.context.cache.addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer));

    var CanvasElementContainer = /** @class */ (function (_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(context, canvas) {
            var _this = _super.call(this, context, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer));

    var SVGElementContainer = /** @class */ (function (_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            var s = new XMLSerializer();
            var bounds = parseBounds(context, img);
            img.setAttribute('width', bounds.width + "px");
            img.setAttribute('height', bounds.height + "px");
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            _this.context.cache.addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer));

    var LIElementContainer = /** @class */ (function (_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer));

    var OLElementContainer = /** @class */ (function (_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === 'boolean' && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer));

    var CHECKBOX_BORDER_RADIUS = [
        {
            type: 15 /* DIMENSION_TOKEN */,
            flags: 0,
            unit: 'px',
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: 16 /* PERCENTAGE_TOKEN */,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function (bounds) {
        if (bounds.width > bounds.height) {
            return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        }
        else if (bounds.width < bounds.height) {
            return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        }
        return bounds;
    };
    var getInputValue = function (node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join('\u2022') : node.value;
        return value.length === 0 ? node.placeholder || '' : value;
    };
    var CHECKBOX = 'checkbox';
    var RADIO = 'radio';
    var PASSWORD = 'password';
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ (function (_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(context, input) {
            var _this = _super.call(this, context, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor =
                    _this.styles.borderRightColor =
                        _this.styles.borderBottomColor =
                            _this.styles.borderLeftColor =
                                0xa5a5a5ff;
                _this.styles.borderTopWidth =
                    _this.styles.borderRightWidth =
                        _this.styles.borderBottomWidth =
                            _this.styles.borderLeftWidth =
                                1;
                _this.styles.borderTopStyle =
                    _this.styles.borderRightStyle =
                        _this.styles.borderBottomStyle =
                            _this.styles.borderLeftStyle =
                                1 /* SOLID */;
                _this.styles.backgroundClip = [0 /* BORDER_BOX */];
                _this.styles.backgroundOrigin = [0 /* BORDER_BOX */];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch (_this.type) {
                case CHECKBOX:
                    _this.styles.borderTopRightRadius =
                        _this.styles.borderTopLeftRadius =
                            _this.styles.borderBottomRightRadius =
                                _this.styles.borderBottomLeftRadius =
                                    CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius =
                        _this.styles.borderTopLeftRadius =
                            _this.styles.borderBottomRightRadius =
                                _this.styles.borderBottomLeftRadius =
                                    RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer));

    var SelectElementContainer = /** @class */ (function (_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || '' : '';
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer));

    var TextareaElementContainer = /** @class */ (function (_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer));

    var IFrameElementContainer = /** @class */ (function (_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(context, iframe) {
            var _this = _super.call(this, context, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow &&
                    iframe.contentWindow.document &&
                    iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement
                        ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor)
                        : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body
                        ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor)
                        : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor)
                        ? isTransparent(bodyBackgroundColor)
                            ? _this.styles.backgroundColor
                            : bodyBackgroundColor
                        : documentBackgroundColor;
                }
            }
            catch (e) { }
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer));

    var LIST_OWNERS = ['OL', 'UL', 'MENU'];
    var parseNodeTree = function (context, node, parent, root) {
        for (var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode) {
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) {
                parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
            }
            else if (isElementNode(childNode)) {
                if (isSlotElement(childNode) && childNode.assignedNodes) {
                    childNode.assignedNodes().forEach(function (childNode) { return parseNodeTree(context, childNode, parent, root); });
                }
                else {
                    var container = createContainer(context, childNode);
                    if (container.styles.isVisible()) {
                        if (createsRealStackingContext(childNode, container, root)) {
                            container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */;
                        }
                        else if (createsStackingContext(container.styles)) {
                            container.flags |= 2 /* CREATES_STACKING_CONTEXT */;
                        }
                        if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) {
                            container.flags |= 8 /* IS_LIST_OWNER */;
                        }
                        parent.elements.push(container);
                        childNode.slot;
                        if (childNode.shadowRoot) {
                            parseNodeTree(context, childNode.shadowRoot, container, root);
                        }
                        else if (!isTextareaElement(childNode) &&
                            !isSVGElement(childNode) &&
                            !isSelectElement(childNode)) {
                            parseNodeTree(context, childNode, container, root);
                        }
                    }
                }
            }
        }
    };
    var createContainer = function (context, element) {
        if (isImageElement(element)) {
            return new ImageElementContainer(context, element);
        }
        if (isCanvasElement(element)) {
            return new CanvasElementContainer(context, element);
        }
        if (isSVGElement(element)) {
            return new SVGElementContainer(context, element);
        }
        if (isLIElement(element)) {
            return new LIElementContainer(context, element);
        }
        if (isOLElement(element)) {
            return new OLElementContainer(context, element);
        }
        if (isInputElement(element)) {
            return new InputElementContainer(context, element);
        }
        if (isSelectElement(element)) {
            return new SelectElementContainer(context, element);
        }
        if (isTextareaElement(element)) {
            return new TextareaElementContainer(context, element);
        }
        if (isIFrameElement(element)) {
            return new IFrameElementContainer(context, element);
        }
        return new ElementContainer(context, element);
    };
    var parseTree = function (context, element) {
        var container = createContainer(context, element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */;
        parseNodeTree(context, element, container, container);
        return container;
    };
    var createsRealStackingContext = function (node, container, root) {
        return (container.styles.isPositionedWithZIndex() ||
            container.styles.opacity < 1 ||
            container.styles.isTransformed() ||
            (isBodyElement(node) && root.styles.isTransparent()));
    };
    var createsStackingContext = function (styles) { return styles.isPositioned() || styles.isFloating(); };
    var isTextNode = function (node) { return node.nodeType === Node.TEXT_NODE; };
    var isElementNode = function (node) { return node.nodeType === Node.ELEMENT_NODE; };
    var isHTMLElementNode = function (node) {
        return isElementNode(node) && typeof node.style !== 'undefined' && !isSVGElementNode(node);
    };
    var isSVGElementNode = function (element) {
        return typeof element.className === 'object';
    };
    var isLIElement = function (node) { return node.tagName === 'LI'; };
    var isOLElement = function (node) { return node.tagName === 'OL'; };
    var isInputElement = function (node) { return node.tagName === 'INPUT'; };
    var isHTMLElement = function (node) { return node.tagName === 'HTML'; };
    var isSVGElement = function (node) { return node.tagName === 'svg'; };
    var isBodyElement = function (node) { return node.tagName === 'BODY'; };
    var isCanvasElement = function (node) { return node.tagName === 'CANVAS'; };
    var isVideoElement = function (node) { return node.tagName === 'VIDEO'; };
    var isImageElement = function (node) { return node.tagName === 'IMG'; };
    var isIFrameElement = function (node) { return node.tagName === 'IFRAME'; };
    var isStyleElement = function (node) { return node.tagName === 'STYLE'; };
    var isScriptElement = function (node) { return node.tagName === 'SCRIPT'; };
    var isTextareaElement = function (node) { return node.tagName === 'TEXTAREA'; };
    var isSelectElement = function (node) { return node.tagName === 'SELECT'; };
    var isSlotElement = function (node) { return node.tagName === 'SLOT'; };
    // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
    var isCustomElement = function (node) { return node.tagName.indexOf('-') > 0; };

    var CounterState = /** @class */ (function () {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function (name) {
            var counter = this.counters[name];
            if (counter && counter.length) {
                return counter[counter.length - 1];
            }
            return 1;
        };
        CounterState.prototype.getCounterValues = function (name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function (counters) {
            var _this = this;
            counters.forEach(function (counter) { return _this.counters[counter].pop(); });
        };
        CounterState.prototype.parse = function (style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) {
                counterIncrement.forEach(function (entry) {
                    var counter = _this.counters[entry.counter];
                    if (counter && entry.increment !== 0) {
                        canReset = false;
                        if (!counter.length) {
                            counter.push(1);
                        }
                        counter[Math.max(0, counter.length - 1)] += entry.increment;
                    }
                });
            }
            var counterNames = [];
            if (canReset) {
                counterReset.forEach(function (entry) {
                    var counter = _this.counters[entry.counter];
                    counterNames.push(entry.counter);
                    if (!counter) {
                        counter = _this.counters[entry.counter] = [];
                    }
                    counter.push(entry.reset);
                });
            }
            return counterNames;
        };
        return CounterState;
    }());
    var ROMAN_UPPER = {
        integers: [1000, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1],
        values: ['M', 'CM', 'D', 'CD', 'C', 'XC', 'L', 'XL', 'X', 'IX', 'V', 'IV', 'I']
    };
    var ARMENIAN = {
        integers: [
            9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90, 80, 70,
            60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1
        ],
        values: [
            'Ք',
            'Փ',
            'Ւ',
            'Ց',
            'Ր',
            'Տ',
            'Վ',
            'Ս',
            'Ռ',
            'Ջ',
            'Պ',
            'Չ',
            'Ո',
            'Շ',
            'Ն',
            'Յ',
            'Մ',
            'Ճ',
            'Ղ',
            'Ձ',
            'Հ',
            'Կ',
            'Ծ',
            'Խ',
            'Լ',
            'Ի',
            'Ժ',
            'Թ',
            'Ը',
            'Է',
            'Զ',
            'Ե',
            'Դ',
            'Գ',
            'Բ',
            'Ա'
        ]
    };
    var HEBREW = {
        integers: [
            10000, 9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30, 20,
            19, 18, 17, 16, 15, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1
        ],
        values: [
            'י׳',
            'ט׳',
            'ח׳',
            'ז׳',
            'ו׳',
            'ה׳',
            'ד׳',
            'ג׳',
            'ב׳',
            'א׳',
            'ת',
            'ש',
            'ר',
            'ק',
            'צ',
            'פ',
            'ע',
            'ס',
            'נ',
            'מ',
            'ל',
            'כ',
            'יט',
            'יח',
            'יז',
            'טז',
            'טו',
            'י',
            'ט',
            'ח',
            'ז',
            'ו',
            'ה',
            'ד',
            'ג',
            'ב',
            'א'
        ]
    };
    var GEORGIAN = {
        integers: [
            10000, 9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90,
            80, 70, 60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1
        ],
        values: [
            'ჵ',
            'ჰ',
            'ჯ',
            'ჴ',
            'ხ',
            'ჭ',
            'წ',
            'ძ',
            'ც',
            'ჩ',
            'შ',
            'ყ',
            'ღ',
            'ქ',
            'ფ',
            'ჳ',
            'ტ',
            'ს',
            'რ',
            'ჟ',
            'პ',
            'ო',
            'ჲ',
            'ნ',
            'მ',
            'ლ',
            'კ',
            'ი',
            'თ',
            'ჱ',
            'ზ',
            'ვ',
            'ე',
            'დ',
            'გ',
            'ბ',
            'ა'
        ]
    };
    var createAdditiveCounter = function (value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) {
            return createCounterText(value, fallback, suffix.length > 0);
        }
        return (symbols.integers.reduce(function (string, integer, index) {
            while (value >= integer) {
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, '') + suffix);
    };
    var createCounterStyleWithSymbolResolver = function (value, codePointRangeLength, isNumeric, resolver) {
        var string = '';
        do {
            if (!isNumeric) {
                value--;
            }
            string = resolver(value) + string;
            value /= codePointRangeLength;
        } while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function (value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return ((value < 0 ? '-' : '') +
            (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function (codePoint) {
                return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
            }) +
                suffix));
    };
    var createCounterStyleFromSymbols = function (value, symbols, suffix) {
        if (suffix === void 0) { suffix = '. '; }
        var codePointRangeLength = symbols.length;
        return (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function (codePoint) { return symbols[Math.floor(codePoint % codePointRangeLength)]; }) + suffix);
    };
    var CJK_ZEROS = 1 << 0;
    var CJK_TEN_COEFFICIENTS = 1 << 1;
    var CJK_TEN_HIGH_COEFFICIENTS = 1 << 2;
    var CJK_HUNDRED_COEFFICIENTS = 1 << 3;
    var createCJKCounter = function (value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) {
            return createCounterText(value, 4 /* CJK_DECIMAL */, suffix.length > 0);
        }
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) {
            return numbers[0] + string;
        }
        for (var digit = 0; tmp > 0 && digit <= 4; digit++) {
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== '') {
                string = numbers[coefficient] + string;
            }
            else if (coefficient > 1 ||
                (coefficient === 1 && digit === 0) ||
                (coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS)) ||
                (coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100) ||
                (coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS))) {
                string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;
            }
            else if (coefficient === 1 && digit > 0) {
                string = multipliers[digit - 1] + string;
            }
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : '') + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = '十百千萬';
    var CHINESE_FORMAL_MULTIPLIERS = '拾佰仟萬';
    var JAPANESE_NEGATIVE = 'マイナス';
    var KOREAN_NEGATIVE = '마이너스';
    var createCounterText = function (value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? '. ' : '';
        var cjkSuffix = appendSuffix ? '、' : '';
        var koreanSuffix = appendSuffix ? ', ' : '';
        var spaceSuffix = appendSuffix ? ' ' : '';
        switch (type) {
            case 0 /* DISC */:
                return '•' + spaceSuffix;
            case 1 /* CIRCLE */:
                return '◦' + spaceSuffix;
            case 2 /* SQUARE */:
                return '◾' + spaceSuffix;
            case 5 /* DECIMAL_LEADING_ZERO */:
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case 4 /* CJK_DECIMAL */:
                return createCounterStyleFromSymbols(value, '〇一二三四五六七八九', cjkSuffix);
            case 6 /* LOWER_ROMAN */:
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */, defaultSuffix).toLowerCase();
            case 7 /* UPPER_ROMAN */:
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */, defaultSuffix);
            case 8 /* LOWER_GREEK */:
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case 9 /* LOWER_ALPHA */:
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case 10 /* UPPER_ALPHA */:
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case 11 /* ARABIC_INDIC */:
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case 12 /* ARMENIAN */:
            case 49 /* UPPER_ARMENIAN */:
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */, defaultSuffix);
            case 35 /* LOWER_ARMENIAN */:
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */, defaultSuffix).toLowerCase();
            case 13 /* BENGALI */:
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case 14 /* CAMBODIAN */:
            case 30 /* KHMER */:
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case 15 /* CJK_EARTHLY_BRANCH */:
                return createCounterStyleFromSymbols(value, '子丑寅卯辰巳午未申酉戌亥', cjkSuffix);
            case 16 /* CJK_HEAVENLY_STEM */:
                return createCounterStyleFromSymbols(value, '甲乙丙丁戊己庚辛壬癸', cjkSuffix);
            case 17 /* CJK_IDEOGRAPHIC */:
            case 48 /* TRAD_CHINESE_INFORMAL */:
                return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 47 /* TRAD_CHINESE_FORMAL */:
                return createCJKCounter(value, '零壹貳參肆伍陸柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 42 /* SIMP_CHINESE_INFORMAL */:
                return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 41 /* SIMP_CHINESE_FORMAL */:
                return createCJKCounter(value, '零壹贰叁肆伍陆柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 26 /* JAPANESE_INFORMAL */:
                return createCJKCounter(value, '〇一二三四五六七八九', '十百千万', JAPANESE_NEGATIVE, cjkSuffix, 0);
            case 25 /* JAPANESE_FORMAL */:
                return createCJKCounter(value, '零壱弐参四伍六七八九', '拾百千万', JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 31 /* KOREAN_HANGUL_FORMAL */:
                return createCJKCounter(value, '영일이삼사오육칠팔구', '십백천만', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 33 /* KOREAN_HANJA_INFORMAL */:
                return createCJKCounter(value, '零一二三四五六七八九', '十百千萬', KOREAN_NEGATIVE, koreanSuffix, 0);
            case 32 /* KOREAN_HANJA_FORMAL */:
                return createCJKCounter(value, '零壹貳參四五六七八九', '拾百千', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 18 /* DEVANAGARI */:
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case 20 /* GEORGIAN */:
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3 /* DECIMAL */, defaultSuffix);
            case 21 /* GUJARATI */:
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case 22 /* GURMUKHI */:
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case 22 /* HEBREW */:
                return createAdditiveCounter(value, 1, 10999, HEBREW, 3 /* DECIMAL */, defaultSuffix);
            case 23 /* HIRAGANA */:
                return createCounterStyleFromSymbols(value, 'あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん');
            case 24 /* HIRAGANA_IROHA */:
                return createCounterStyleFromSymbols(value, 'いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす');
            case 27 /* KANNADA */:
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case 28 /* KATAKANA */:
                return createCounterStyleFromSymbols(value, 'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン', cjkSuffix);
            case 29 /* KATAKANA_IROHA */:
                return createCounterStyleFromSymbols(value, 'イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス', cjkSuffix);
            case 34 /* LAO */:
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case 37 /* MONGOLIAN */:
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case 38 /* MYANMAR */:
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case 39 /* ORIYA */:
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case 40 /* PERSIAN */:
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case 43 /* TAMIL */:
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case 44 /* TELUGU */:
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case 45 /* THAI */:
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case 46 /* TIBETAN */:
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case 3 /* DECIMAL */:
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };

    var IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';
    var DocumentCloner = /** @class */ (function () {
        function DocumentCloner(context, element, options) {
            this.context = context;
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) {
                throw new Error('Cloned element does not have an owner document');
            }
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
        }
        DocumentCloner.prototype.toIFrame = function (ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) {
                return Promise.reject("Unable to find iframe window");
            }
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */
            var iframeLoad = iframeLoader(iframe).then(function () { return __awaiter(_this, void 0, void 0, function () {
                var onclone, referenceElement;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.scrolledElements.forEach(restoreNodeScroll);
                            if (cloneWindow) {
                                cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) &&
                                    (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                    this.context.logger.warn('Unable to restore scroll position for cloned document');
                                    this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                                }
                            }
                            onclone = this.options.onclone;
                            referenceElement = this.clonedReferenceElement;
                            if (typeof referenceElement === 'undefined') {
                                return [2 /*return*/, Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")];
                            }
                            if (!(documentClone.fonts && documentClone.fonts.ready)) return [3 /*break*/, 2];
                            return [4 /*yield*/, documentClone.fonts.ready];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [3 /*break*/, 4];
                            return [4 /*yield*/, imagesReady(documentClone)];
                        case 3:
                            _a.sent();
                            _a.label = 4;
                        case 4:
                            if (typeof onclone === 'function') {
                                return [2 /*return*/, Promise.resolve()
                                        .then(function () { return onclone(documentClone, referenceElement); })
                                        .then(function () { return iframe; })];
                            }
                            return [2 /*return*/, iframe];
                    }
                });
            }); });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function (node) {
            if (isDebugging(node, 2 /* CLONE */)) {
                debugger;
            }
            if (isCanvasElement(node)) {
                return this.createCanvasClone(node);
            }
            if (isVideoElement(node)) {
                return this.createVideoClone(node);
            }
            if (isStyleElement(node)) {
                return this.createStyleClone(node);
            }
            var clone = node.cloneNode(false);
            if (isImageElement(clone)) {
                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
                    clone.src = node.currentSrc;
                    clone.srcset = '';
                }
                if (clone.loading === 'lazy') {
                    clone.loading = 'eager';
                }
            }
            if (isCustomElement(clone)) {
                return this.createCustomElementClone(clone);
            }
            return clone;
        };
        DocumentCloner.prototype.createCustomElementClone = function (node) {
            var clone = document.createElement('html2canvascustomelement');
            copyCSSStyles(node.style, clone);
            return clone;
        };
        DocumentCloner.prototype.createStyleClone = function (node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function (css, rule) {
                        if (rule && typeof rule.cssText === 'string') {
                            return css + rule.cssText;
                        }
                        return css;
                    }, '');
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            }
            catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                this.context.logger.error('Unable to access cssRules property', e);
                if (e.name !== 'SecurityError') {
                    throw e;
                }
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function (canvas) {
            var _a;
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement('img');
                try {
                    img.src = canvas.toDataURL();
                    return img;
                }
                catch (e) {
                    this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext('2d');
                var clonedCtx = clonedCanvas.getContext('2d');
                if (clonedCtx) {
                    if (!this.options.allowTaint && ctx) {
                        clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    }
                    else {
                        var gl = (_a = canvas.getContext('webgl2')) !== null && _a !== void 0 ? _a : canvas.getContext('webgl');
                        if (gl) {
                            var attribs = gl.getContextAttributes();
                            if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) {
                                this.context.logger.warn('Unable to clone WebGL context as it has preserveDrawingBuffer=false', canvas);
                            }
                        }
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            }
            catch (e) {
                this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
            }
            return clonedCanvas;
        };
        DocumentCloner.prototype.createVideoClone = function (video) {
            var canvas = video.ownerDocument.createElement('canvas');
            canvas.width = video.offsetWidth;
            canvas.height = video.offsetHeight;
            var ctx = canvas.getContext('2d');
            try {
                if (ctx) {
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    if (!this.options.allowTaint) {
                        ctx.getImageData(0, 0, canvas.width, canvas.height);
                    }
                }
                return canvas;
            }
            catch (e) {
                this.context.logger.info("Unable to clone video as it is tainted", video);
            }
            var blankCanvas = video.ownerDocument.createElement('canvas');
            blankCanvas.width = video.offsetWidth;
            blankCanvas.height = video.offsetHeight;
            return blankCanvas;
        };
        DocumentCloner.prototype.appendChildNode = function (clone, child, copyStyles) {
            if (!isElementNode(child) ||
                (!isScriptElement(child) &&
                    !child.hasAttribute(IGNORE_ATTRIBUTE) &&
                    (typeof this.options.ignoreElements !== 'function' || !this.options.ignoreElements(child)))) {
                if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) {
                    clone.appendChild(this.cloneNode(child, copyStyles));
                }
            }
        };
        DocumentCloner.prototype.cloneChildNodes = function (node, clone, copyStyles) {
            var _this = this;
            for (var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild; child; child = child.nextSibling) {
                if (isElementNode(child) && isSlotElement(child) && typeof child.assignedNodes === 'function') {
                    var assignedNodes = child.assignedNodes();
                    if (assignedNodes.length) {
                        assignedNodes.forEach(function (assignedNode) { return _this.appendChildNode(clone, assignedNode, copyStyles); });
                    }
                }
                else {
                    this.appendChildNode(clone, child, copyStyles);
                }
            }
        };
        DocumentCloner.prototype.cloneNode = function (node, copyStyles) {
            if (isTextNode(node)) {
                return document.createTextNode(node.data);
            }
            if (!node.ownerDocument) {
                return node.cloneNode(false);
            }
            var window = node.ownerDocument.defaultView;
            if (window && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone = this.createElementClone(node);
                clone.style.transitionProperty = 'none';
                var style = window.getComputedStyle(node);
                var styleBefore = window.getComputedStyle(node, ':before');
                var styleAfter = window.getComputedStyle(node, ':after');
                if (this.referenceElement === node && isHTMLElementNode(clone)) {
                    this.clonedReferenceElement = clone;
                }
                if (isBodyElement(clone)) {
                    createPseudoHideStyles(clone);
                }
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                if (isCustomElement(node)) {
                    copyStyles = true;
                }
                if (!isVideoElement(node)) {
                    this.cloneChildNodes(node, clone, copyStyles);
                }
                if (before) {
                    clone.insertBefore(before, clone.firstChild);
                }
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) {
                    clone.appendChild(after);
                }
                this.counters.pop(counters);
                if ((style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node)) ||
                    copyStyles) {
                    copyCSSStyles(style, clone);
                }
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) {
                    this.scrolledElements.push([clone, node.scrollLeft, node.scrollTop]);
                }
                if ((isTextareaElement(node) || isSelectElement(node)) &&
                    (isTextareaElement(clone) || isSelectElement(clone))) {
                    clone.value = node.value;
                }
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function (node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) {
                return;
            }
            var value = style.content;
            var document = clone.ownerDocument;
            if (!document || !value || value === 'none' || value === '-moz-alt-content' || style.display === 'none') {
                return;
            }
            this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
            var declaration = new CSSParsedPseudoDeclaration(this.context, style);
            var anonymousReplacedElement = document.createElement('html2canvaspseudoelement');
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function (token) {
                if (token.type === 0 /* STRING_TOKEN */) {
                    anonymousReplacedElement.appendChild(document.createTextNode(token.value));
                }
                else if (token.type === 22 /* URL_TOKEN */) {
                    var img = document.createElement('img');
                    img.src = token.value;
                    img.style.opacity = '1';
                    anonymousReplacedElement.appendChild(img);
                }
                else if (token.type === 18 /* FUNCTION */) {
                    if (token.name === 'attr') {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) {
                            anonymousReplacedElement.appendChild(document.createTextNode(node.getAttribute(attr[0].value) || ''));
                        }
                    }
                    else if (token.name === 'counter') {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle)
                                ? listStyleType.parse(_this.context, counterStyle.value)
                                : 3 /* DECIMAL */;
                            anonymousReplacedElement.appendChild(document.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    }
                    else if (token.name === 'counters') {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle)
                                ? listStyleType.parse(_this.context, counterStyle.value)
                                : 3 /* DECIMAL */;
                            var separator = delim && delim.type === 0 /* STRING_TOKEN */ ? delim.value : '';
                            var text = counterStates
                                .map(function (value) { return createCounterText(value, counterType_1, false); })
                                .join(separator);
                            anonymousReplacedElement.appendChild(document.createTextNode(text));
                        }
                    }
                    else ;
                }
                else if (token.type === 20 /* IDENT_TOKEN */) {
                    switch (token.value) {
                        case 'open-quote':
                            anonymousReplacedElement.appendChild(document.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                            break;
                        case 'close-quote':
                            anonymousReplacedElement.appendChild(document.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                            break;
                        default:
                            // safari doesn't parse string tokens correctly because of lack of quotes
                            anonymousReplacedElement.appendChild(document.createTextNode(token.value));
                    }
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE
                ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE
                : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) {
                clone.className.baseValue += newClassName;
            }
            else {
                clone.className += newClassName;
            }
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function (container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }());
    var PseudoElementType;
    (function (PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function (ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement('iframe');
        cloneIframeContainer.className = 'html2canvas-container';
        cloneIframeContainer.style.visibility = 'hidden';
        cloneIframeContainer.style.position = 'fixed';
        cloneIframeContainer.style.left = '-10000px';
        cloneIframeContainer.style.top = '0px';
        cloneIframeContainer.style.border = '0';
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true');
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var imageReady = function (img) {
        return new Promise(function (resolve) {
            if (img.complete) {
                resolve();
                return;
            }
            if (!img.src) {
                resolve();
                return;
            }
            img.onload = resolve;
            img.onerror = resolve;
        });
    };
    var imagesReady = function (document) {
        return Promise.all([].slice.call(document.images, 0).map(imageReady));
    };
    var iframeLoader = function (iframe) {
        return new Promise(function (resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) {
                return reject("No window assigned for iframe");
            }
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = function () {
                cloneWindow.onload = iframe.onload = null;
                var interval = setInterval(function () {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var ignoredStyleProperties = [
        'all',
        'd',
        'content' // Safari shows pseudoelements if content is set
    ];
    var copyCSSStyles = function (style, target) {
        // Edge does not provide value for cssText
        for (var i = style.length - 1; i >= 0; i--) {
            var property = style.item(i);
            if (ignoredStyleProperties.indexOf(property) === -1) {
                target.style.setProperty(property, style.getPropertyValue(property));
            }
        }
        return target;
    };
    var serializeDoctype = function (doctype) {
        var str = '';
        if (doctype) {
            str += '<!DOCTYPE ';
            if (doctype.name) {
                str += doctype.name;
            }
            if (doctype.internalSubset) {
                str += doctype.internalSubset;
            }
            if (doctype.publicId) {
                str += "\"" + doctype.publicId + "\"";
            }
            if (doctype.systemId) {
                str += "\"" + doctype.systemId + "\"";
            }
            str += '>';
        }
        return str;
    };
    var restoreOwnerScroll = function (ownerDocument, x, y) {
        if (ownerDocument &&
            ownerDocument.defaultView &&
            (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) {
            ownerDocument.defaultView.scrollTo(x, y);
        }
    };
    var restoreNodeScroll = function (_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ':before';
    var PSEUDO_AFTER = ':after';
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';
    var PSEUDO_HIDE_ELEMENT_STYLE = "{\n    content: \"\" !important;\n    display: none !important;\n}";
    var createPseudoHideStyles = function (body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function (body, styles) {
        var document = body.ownerDocument;
        if (document) {
            var style = document.createElement('style');
            style.textContent = styles;
            body.appendChild(style);
        }
    };

    var CacheStorage = /** @class */ (function () {
        function CacheStorage() {
        }
        CacheStorage.getOrigin = function (url) {
            var link = CacheStorage._link;
            if (!link) {
                return 'about:blank';
            }
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function (src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function (window) {
            CacheStorage._link = window.document.createElement('a');
            CacheStorage._origin = CacheStorage.getOrigin(window.location.href);
        };
        CacheStorage._origin = 'about:blank';
        return CacheStorage;
    }());
    var Cache = /** @class */ (function () {
        function Cache(context, _options) {
            this.context = context;
            this._options = _options;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._cache = {};
        }
        Cache.prototype.addImage = function (src) {
            var result = Promise.resolve();
            if (this.has(src)) {
                return result;
            }
            if (isBlobImage(src) || isRenderable(src)) {
                (this._cache[src] = this.loadImage(src)).catch(function () {
                    // prevent unhandled rejection
                });
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function (src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function (key) {
            return __awaiter(this, void 0, void 0, function () {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) &&
                                !isSameOrigin &&
                                !isBlobImage(key) &&
                                typeof this._options.proxy === 'string' &&
                                FEATURES.SUPPORT_CORS_XHR &&
                                !useCORS;
                            if (!isSameOrigin &&
                                this._options.allowTaint === false &&
                                !isInlineImage(key) &&
                                !isBlobImage(key) &&
                                !useProxy &&
                                !useCORS) {
                                return [2 /*return*/];
                            }
                            src = key;
                            if (!useProxy) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.proxy(src)];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            this.context.logger.debug("Added image " + key.substring(0, 256));
                            return [4 /*yield*/, new Promise(function (resolve, reject) {
                                    var img = new Image();
                                    img.onload = function () { return resolve(img); };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) {
                                        img.crossOrigin = 'anonymous';
                                    }
                                    img.src = src;
                                    if (img.complete === true) {
                                        // Inline XML images may fail to parse, throwing an Error later on
                                        setTimeout(function () { return resolve(img); }, 500);
                                    }
                                    if (_this._options.imageTimeout > 0) {
                                        setTimeout(function () { return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image"); }, _this._options.imageTimeout);
                                    }
                                })];
                        case 3: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        Cache.prototype.has = function (key) {
            return typeof this._cache[key] !== 'undefined';
        };
        Cache.prototype.keys = function () {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function (src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) {
                throw new Error('No proxy defined');
            }
            var key = src.substring(0, 256);
            return new Promise(function (resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
                var xhr = new XMLHttpRequest();
                xhr.onload = function () {
                    if (xhr.status === 200) {
                        if (responseType === 'text') {
                            resolve(xhr.response);
                        }
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener('load', function () { return resolve(reader_1.result); }, false);
                            reader_1.addEventListener('error', function (e) { return reject(e); }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    }
                    else {
                        reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                    }
                };
                xhr.onerror = reject;
                var queryString = proxy.indexOf('?') > -1 ? '&' : '?';
                xhr.open('GET', "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== 'text' && xhr instanceof XMLHttpRequest) {
                    xhr.responseType = responseType;
                }
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function () { return reject("Timed out (" + timeout_1 + "ms) proxying " + key); };
                }
                xhr.send();
            });
        };
        return Cache;
    }());
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function (src) { return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src); };
    var isInlineImage = function (src) { return INLINE_IMG.test(src); };
    var isInlineBase64Image = function (src) { return INLINE_BASE64.test(src); };
    var isBlobImage = function (src) { return src.substr(0, 4) === 'blob'; };
    var isSVG = function (src) { return src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src); };

    var Vector = /** @class */ (function () {
        function Vector(x, y) {
            this.type = 0 /* VECTOR */;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function (deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }());

    var lerp = function (a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ (function () {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = 1 /* BEZIER_CURVE */;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function (t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function (deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function () {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }());
    var isBezierCurve = function (path) { return path.type === 1 /* BEZIER_CURVE */; };

    var BoundCurves = /** @class */ (function () {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
            this.topRightBorderDoubleOuterBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
            this.bottomRightBorderDoubleOuterBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.bottomLeftBorderDoubleOuterBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.topLeftBorderDoubleInnerBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + (borderTopWidth * 2) / 3, tlh - (borderLeftWidth * 2) / 3, tlv - (borderTopWidth * 2) / 3, CORNER.TOP_LEFT)
                    : new Vector(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + (borderTopWidth * 2) / 3);
            this.topRightBorderDoubleInnerBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top + (borderTopWidth * 2) / 3, trh - (borderRightWidth * 2) / 3, trv - (borderTopWidth * 2) / 3, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth * 2) / 3, bounds.top + (borderTopWidth * 2) / 3);
            this.bottomRightBorderDoubleInnerBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - (borderRightWidth * 2) / 3, brv - (borderBottomWidth * 2) / 3, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth * 2) / 3, bounds.top + bounds.height - (borderBottomWidth * 2) / 3);
            this.bottomLeftBorderDoubleInnerBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + leftHeight, blh - (borderLeftWidth * 2) / 3, blv - (borderBottomWidth * 2) / 3, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + bounds.height - (borderBottomWidth * 2) / 3);
            this.topLeftBorderStroke =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
            this.topRightBorderStroke =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
            this.bottomRightBorderStroke =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.bottomLeftBorderStroke =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.topLeftBorderBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT)
                    : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width -( borderLeftWidth + paddingLeft)), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width - borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height - (borderTopWidth + paddingTop)), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));

            // customize by Caravan
        }
        return BoundCurves;
    }());
    var CORNER;
    (function (CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function (x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch (position) {
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function (curves) {
        return [curves.topLeftBorderBox, curves.topRightBorderBox, curves.bottomRightBorderBox, curves.bottomLeftBorderBox];
    };
    var calculateContentBoxPath = function (curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function (curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };

    var TransformEffect = /** @class */ (function () {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.type = 0 /* TRANSFORM */;
            this.target = 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */;
        }
        return TransformEffect;
    }());
    var ClipEffect = /** @class */ (function () {
        function ClipEffect(path, target) {
            this.path = path;
            this.target = target;
            this.type = 1 /* CLIP */;
        }
        return ClipEffect;
    }());
    var OpacityEffect = /** @class */ (function () {
        function OpacityEffect(opacity) {
            this.opacity = opacity;
            this.type = 2 /* OPACITY */;
            this.target = 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */;
        }
        return OpacityEffect;
    }());
    var isTransformEffect = function (effect) {
        return effect.type === 0 /* TRANSFORM */;
    };
    var isClipEffect = function (effect) { return effect.type === 1 /* CLIP */; };
    var isOpacityEffect = function (effect) { return effect.type === 2 /* OPACITY */; };

    var equalPath = function (a, b) {
        if (a.length === b.length) {
            return a.some(function (v, i) { return v === b[i]; });
        }
        return false;
    };
    var transformPath = function (path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function (point, index) {
            switch (index) {
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };

    var StackingContext = /** @class */ (function () {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }());
    var ElementPaint = /** @class */ (function () {
        function ElementPaint(container, parent) {
            this.container = container;
            this.parent = parent;
            this.effects = [];
            this.curves = new BoundCurves(this.container);
            if (this.container.styles.opacity < 1) {
                this.effects.push(new OpacityEffect(this.container.styles.opacity));
            }
            if (this.container.styles.transform !== null) {
                var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
                var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
                var matrix = this.container.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (this.container.styles.overflowX !== 0 /* VISIBLE */) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */));
                }
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */));
                }
            }
            if (this.container.isHole) {
                var target = this.parent;
                while (target) {
                    if (target.container.isTarget) {
                        target.container.holeCurves = this.curves;
                        break;
                    } 
                    else {
                        target = target.parent;
                    }
                }
            }
        }
        ElementPaint.prototype.getEffects = function (target) {
            var inFlow = [2 /* ABSOLUTE */, 3 /* FIXED */].indexOf(this.container.styles.position) === -1;
            var parent = this.parent;
            var effects = this.effects.slice(0);
            while (parent) {
                var croplessEffects = parent.effects.filter(function (effect) { return !isClipEffect(effect); });
                if (inFlow || parent.container.styles.position !== 0 /* STATIC */ || !parent.parent) {
                    effects.unshift.apply(effects, croplessEffects);
                    inFlow = [2 /* ABSOLUTE */, 3 /* FIXED */].indexOf(parent.container.styles.position) === -1;
                    if (parent.container.styles.overflowX !== 0 /* VISIBLE */) {
                        var borderBox = calculateBorderBoxPath(parent.curves);
                        var paddingBox = calculatePaddingBoxPath(parent.curves);
                        if (!equalPath(borderBox, paddingBox)) {
                            effects.unshift(new ClipEffect(paddingBox, 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */));
                        }
                    }
                }
                else {
                    effects.unshift.apply(effects, croplessEffects);
                }
                parent = parent.parent;
            }
            return effects.filter(function (effect) { return contains(effect.target, target); });
        };
        return ElementPaint;
    }());
    var parseStackTree = function (parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function (child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */);
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */);
            var paintContainer = new ElementPaint(child, parent);
            if (contains(child.styles.display, 2048 /* LIST_ITEM */)) {
                listItems.push(paintContainer);
            }
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function (current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            }
                            else if (index_1 > 0) {
                                return true;
                            }
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    }
                    else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function (current, i) {
                            if (order_1 >= current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            }
                            else if (index_2 > 0) {
                                return true;
                            }
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    }
                    else {
                        parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                    }
                }
                else {
                    if (child.styles.isFloating()) {
                        parentStack.nonPositionedFloats.push(stack);
                    }
                    else {
                        parentStack.nonPositionedInlineLevel.push(stack);
                    }
                }
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            }
            else {
                if (child.styles.isInlineLevel()) {
                    stackingContext.inlineLevel.push(paintContainer);
                }
                else {
                    stackingContext.nonInlineLevel.push(paintContainer);
                }
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */)) {
                processListItems(child, listOwnerItems);
            }
        });
    };
    var processListItems = function (owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for (var i = 0; i < elements.length; i++) {
            var item = elements[i];
            if (item.container instanceof LIElementContainer &&
                typeof item.container.value === 'number' &&
                item.container.value !== 0) {
                numbering = item.container.value;
            }
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function (container) {
        var paintContainer = new ElementPaint(container, null);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };

    var parsePathForBorder = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderDoubleOuter = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
        }
    };
    var parsePathForBorderDoubleInner = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderStroke = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
        }
    };
    var createStrokePathFromCurves = function (outer1, outer2) {
        var path = [];
        if (isBezierCurve(outer1)) {
            path.push(outer1.subdivide(0.5, false));
        }
        else {
            path.push(outer1);
        }
        if (isBezierCurve(outer2)) {
            path.push(outer2.subdivide(0.5, true));
        }
        else {
            path.push(outer2);
        }
        return path;
    };
    var createPathFromCurves = function (outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) {
            path.push(outer1.subdivide(0.5, false));
        }
        else {
            path.push(outer1);
        }
        if (isBezierCurve(outer2)) {
            path.push(outer2.subdivide(0.5, true));
        }
        else {
            path.push(outer2);
        }
        if (isBezierCurve(inner2)) {
            path.push(inner2.subdivide(0.5, true).reverse());
        }
        else {
            path.push(inner2);
        }
        if (isBezierCurve(inner1)) {
            path.push(inner1.subdivide(0.5, false).reverse());
        }
        else {
            path.push(inner1);
        }
        return path;
    };

    var reversePath = function (paths) {
        var list = [];
        if (paths.length > 0) {
            for (var i = paths.length - 1; i >= 0; i--) {
                var p = paths[i];
                if (isBezierCurve(p)) {
                    var rc = p.reverse();
                    list.push(rc);
                }
                else {
                    list.push(new Vector(p.x, p.y));
                }
            }
        }
        return list;
    };

    var paddingBox = function (element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function (element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };

    var calculateBackgroundPositioningArea = function (backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */) {
            return element.bounds;
        }
        if (backgroundOrigin === 2 /* CONTENT_BOX */) {
            return contentBox(element);
        }
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function (backgroundClip, element) {
        if (backgroundClip === 0 /* BORDER_BOX */) {
            return element.bounds;
        }
        if (backgroundClip === 2 /* CONTENT_BOX */) {
            return contentBox(element);
        }
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function (container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [path, offsetX, offsetY, sizeWidth, sizeHeight];
    };
    var isAuto = function (token) { return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO; };
    var hasIntrinsicValue = function (value) { return typeof value === 'number'; };
    var calculateBackgroundSize = function (size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (!first) {
            return [0, 0];
        }
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) {
            return [getAbsoluteValue(first, bounds.width), getAbsoluteValue(second, bounds.height)];
        }
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER)
                    ? [bounds.width, bounds.width / intrinsicProportion]
                    : [bounds.height * intrinsicProportion, bounds.height];
            }
            return [bounds.width, bounds.height];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) {
                return [intrinsicWidth, intrinsicHeight];
            }
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) {
                return [bounds.width, bounds.height];
            }
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth
                    ? intrinsicWidth
                    : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight
                    ? intrinsicHeight
                    : intrinsicWidth / intrinsicProportion;
                return [width_1, height_1];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [width_2, height_2];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) {
                width_3 = getAbsoluteValue(first, bounds.width);
            }
            else if (isLengthPercentage(second)) {
                height_3 = getAbsoluteValue(second, bounds.height);
            }
            if (isAuto(first)) {
                width_3 = height_3 * intrinsicProportion;
            }
            else if (!second || isAuto(second)) {
                height_3 = width_3 / intrinsicProportion;
            }
            return [width_3, height_3];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) {
            width = getAbsoluteValue(first, bounds.width);
        }
        else if (second && isLengthPercentage(second)) {
            height = getAbsoluteValue(second, bounds.height);
        }
        if (width !== null && (!second || isAuto(second))) {
            height =
                hasIntrinsicWidth && hasIntrinsicHeight
                    ? (width / intrinsicWidth) * intrinsicHeight
                    : bounds.height;
        }
        if (height !== null && isAuto(first)) {
            width =
                hasIntrinsicWidth && hasIntrinsicHeight
                    ? (height / intrinsicHeight) * intrinsicWidth
                    : bounds.width;
        }
        if (width !== null && height !== null) {
            return [width, height];
        }
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function (values, index) {
        var value = values[index];
        if (typeof value === 'undefined') {
            return values[0];
        }
        return value;
    };
    var calculateBackgroundRepeatPath = function (repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch (repeat) {
            case 2 /* REPEAT_X */:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case 3 /* REPEAT_Y */:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case 1 /* NO_REPEAT */:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };

    var SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

    var SAMPLE_TEXT = 'Hidden Text';
    var FontMetrics = /** @class */ (function () {
        function FontMetrics(document) {
            this._data = {};
            this._document = document;
        }
        FontMetrics.prototype.parseMetrics = function (fontFamily, fontSize) {
            var container = this._document.createElement('div');
            var img = this._document.createElement('img');
            var span = this._document.createElement('span');
            var body = this._document.body;
            container.style.visibility = 'hidden';
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = '0';
            container.style.padding = '0';
            container.style.whiteSpace = 'nowrap';
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = '0';
            img.style.padding = '0';
            img.style.verticalAlign = 'baseline';
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = '0';
            span.style.padding = '0';
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = 'normal';
            img.style.verticalAlign = 'super';
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return { baseline: baseline, middle: middle };
        };
        FontMetrics.prototype.getMetrics = function (fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === 'undefined') {
                this._data[key] = this.parseMetrics(fontFamily, fontSize);
            }
            return this._data[key];
        };
        return FontMetrics;
    }());

    var Renderer = /** @class */ (function () {
        function Renderer(context, options) {
            this.context = context;
            this.options = options;
        }
        return Renderer;
    }());

    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ (function (_super) {
        __extends(CanvasRenderer, _super);
        function CanvasRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this._activeEffects = [];
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            if (!options.canvas) {
                _this.canvas.width = Math.floor(options.width * options.scale);
                _this.canvas.height = Math.floor(options.height * options.scale);
                _this.canvas.style.width = options.width + "px";
                _this.canvas.style.height = options.height + "px";
            }
            _this.fontMetrics = new FontMetrics(document);
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.ctx.textBaseline = 'bottom';
            _this._activeEffects = [];
            _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
            return _this;
        }
        CanvasRenderer.prototype.applyEffects = function (effects) {
            var _this = this;
            while (this._activeEffects.length) {
                this.popEffect();
            }
            effects.forEach(function (effect) { return _this.applyEffect(effect); });
        };
        CanvasRenderer.prototype.applyEffect = function (effect) {
            this.ctx.save();
            if (isOpacityEffect(effect)) {
                this.ctx.globalAlpha = effect.opacity;
            }
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function () {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function (stack, topMaskCurves) {
            var _this = this;
            return __awaiter(this, void 0, void 0, function () {
                var paint, styles, bounds, maskImageUrl, ratio = 1, borderLeft = 0, borderTop = 0, n, curve, maskCurves, pathCurves, pathList, pt0, pt;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            paint = stack.element;
                            bounds = paint.container.bounds || {left: 0, top: 0, width: 100, height: 100};
                            styles = paint.container.styles;
                            if (!styles.isVisible()) return [3 /*break*/, 5];
                            if (paint.container.isHole) {
                                return [3 /*break*/, 5]; // ignore content
                            }
                            if (paint.parent && paint.parent.container.isHole) {
                                return [3 /*break*/, 5]; // ignore content
                            }
                            if (styles.dropShadow && styles.dropShadow.length > 0) {
                                return [4 /*yield*/, this.renderNodeDropShadow(stack.element)];
                            } else {
                                _a.sent();
                                _a.label = 1;
                            }
                        case 1: 
                            ratio = (_this.options.ratio * _this.options.scale);
                            borderLeft = (styles.borderLeftWidth || 0)  * ratio;
                            borderTop = (styles.borderTopWidth || 0)  * ratio;
                            if (styles.webkitMaskImage && styles.webkitMaskImage.length > 0) {
                                if (styles.webkitMaskImage[0].url) {
                                    maskImageUrl = styles.webkitMaskImage[0].url;
                                }
                            }
                            if (maskImageUrl) {
                                return [4, Image2Path.fetchPathFromImage(maskImageUrl, bounds.width, bounds.height)]; // 异步获取image的path数据
                            }
                            else {
                                return [3 /*break*/, 3];
                            }
                        case 2:
                            pathList = _a.sent();
                            if (pathList && pathList.length > 0) {
                                maskCurves = [];
                                for (var p = 0; p < pathList.length; p++) {
                                    pathCurves = [];
                                    curve = pathList[p].curve;
                                    n = curve.n;

                                    pt = new Vector(
                                        curve.c[(n - 1) * 3 + 2].x + bounds.left - borderLeft, 
                                        curve.c[(n - 1) * 3 + 2].y + bounds.top - borderTop
                                    ); 
                                    pathCurves.push(pt);
                                    
                                    for (var i = 0; i < n; i++) {
                                        if (curve.tag[i] === "CORNER") {
                                            pt0 = new Vector(
                                                curve.c[i * 3 + 1].x + bounds.left - borderLeft, 
                                                curve.c[i * 3 + 1].y + bounds.top - borderTop);

                                            pathCurves.push(pt0);

                                            pt = new Vector(
                                                curve.c[i * 3 + 2].x + bounds.left - borderLeft, 
                                                curve.c[i * 3 + 2].y + bounds.top - borderTop);

                                            pathCurves.push(pt);
                                        }
                                        else if (curve.tag[i] === "CURVE") {
                                            pt0 = pt;
                                            pt = new Vector(
                                                curve.c[i * 3 + 2].x + bounds.left - borderLeft, 
                                                curve.c[i * 3 + 2].y + bounds.top - borderTop);

                                            pathCurves.push(new BezierCurve(
                                                pt0,
                                                new Vector(
                                                    curve.c[i * 3 + 0].x + bounds.left - borderLeft, 
                                                    curve.c[i * 3 + 0].y + bounds.top - borderTop),
                                                new Vector(
                                                    curve.c[i * 3 + 1].x + bounds.left - borderLeft, 
                                                    curve.c[i * 3 + 1].y + bounds.top - borderTop),
                                                pt));
                                        }
                                    }
                                    if (pathCurves.length > 0) {
                                        maskCurves.push(pathCurves);
                                    }
                                }
                                paint.maskCurves = maskCurves;
                            }
                            _a.label = 3;
                        case 3:
                            return [4 /*yield*/, this.renderStackContent(stack, paint.maskCurves || topMaskCurves)];
                        case 4:
                            _a.sent();
                            _a.label = 5;
                        case 5: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function (paint, maskCurves) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (contains(paint.container.flags, 16 /* DEBUG_RENDER */)) {
                                debugger;
                            }
                            if (!paint.container.styles.isVisible()) return [3 /*break*/, 3];
                            if (paint.container.isHole) {
                                return [3 /*break*/, 3]; // ignore node content 
                            }
                            if (paint.parent && paint.parent.container.isHole) {
                                return [3 /*break*/, 3]; // ignore content
                            }
                            return [4 /*yield*/, this.renderNodeBackgroundAndBorders(paint, maskCurves)];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, this.renderNodeContent(paint, maskCurves)];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        function isSpecialPunctuation(text) {
            switch (text) {
                case '（':
                case '）':
                case '「':
                case '」':
                case '【':
                case '】':
                    return true;
                default:
                    return false;
            }
        }
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function (text, letterSpacing, baseline, textIsVertical) {
            var _this = this;
            if (textIsVertical) {
                this.ctx.save();
                var textIsAscii = false;
                if (text.text && text.text.match(/[\u0000-\u00ff]/g)) {
                    textIsAscii = true;
                }
                if (textIsAscii || isSpecialPunctuation(text.text)) {
                    this.ctx.translate(text.bounds.left + text.bounds.width / 2, text.bounds.top + text.bounds.height / 2);
                    this.ctx.rotate(Math.PI / 2, Math.PI / 2);
                    this.ctx.fillText(text.text, -text.bounds.height / 2 , -text.bounds.width / 2 + baseline);
                } else {
                    for (var i = 0; i < text.text.length; i++) {
                        var character = text.text[i];
                        var charHeight = baseline + baseline / 8;
                        var newBounds = {
                            left: text.bounds.left,
                            top: text.bounds.top + (charHeight + letterSpacing) * i,
                            width: text.bounds.width,
                            height: charHeight
                        };
                        var size = baseline;
                        switch (character) {
                            case '，':
                            case '。':
                            case '、':
                            case '·':
                            case '“':
                            case '”':
                            case '‘':
                            case '’':
                                size = baseline / 2;
                                newBounds.left += baseline / 2;
                                break;
                            case '？':
                            case '！':
                            case '：':
                            case '；':
                                size = baseline * 3 / 4;
                                newBounds.left += baseline / 2;
                                break;
                            default:
                                ;

                        }
                        this.ctx.fillText(character, newBounds.left, newBounds.top + size);
                    }
                }
                this.ctx.restore();
            } else {
                if (letterSpacing === 0) {
                    this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
                }
                else {
                    var letters = segmentGraphemes(text.text);
                    letters.reduce(function (left, letter) {
                        _this.ctx.fillText(letter, left, text.bounds.top + baseline);
                        return left + _this.ctx.measureText(letter).width;
                    }, text.bounds.left);
                }
            }
        };
        CanvasRenderer.prototype.createFontStyle = function (styles) {
            var fontVariant = styles.fontVariant
                .filter(function (variant) { return variant === 'normal' || variant === 'small-caps'; })
                .join('');
            var fontFamily = fixIOSSystemFonts(styles.fontFamily).join(', ');
            var fontSize = isDimensionToken(styles.fontSize)
                ? "" + styles.fontSize.number + styles.fontSize.unit
                : styles.fontSize.number + "px";
            return [
                [styles.fontStyle, fontVariant, styles.fontWeight, fontSize, fontFamily].join(' '),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function (text, styles) {
            return __awaiter(this, void 0, void 0, function () {
                var _a, font, fontFamily, fontSize, _b, baseline, middle, paintOrder,textIsVertical;
                var _this = this;
                return __generator(this, function (_c) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    this.ctx.direction = styles.direction === 1 /* RTL */ ? 'rtl' : 'ltr';
                    this.ctx.textAlign = 'left';
                    this.ctx.textBaseline = 'alphabetic';
                    _b = this.fontMetrics.getMetrics(fontFamily, fontSize), baseline = _b.baseline, middle = _b.middle;
                    paintOrder = styles.paintOrder;
                    var writingmode = styles.writingMode || 'unset';
                    if (writingmode == 'vertical-lr' || writingmode == 'vertical-rl') {
                        textIsVertical = true;
                    }
                    text.textBounds.forEach(function (text) {
                        paintOrder.forEach(function (paintOrderLayer) {
                            switch (paintOrderLayer) {
                                case 0 /* FILL */:
                                    _this.ctx.fillStyle = asString(styles.color);
                                    _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline, textIsVertical);
                                    var textShadows = styles.textShadow;
                                    if (textShadows.length && text.text.trim().length) {
                                        textShadows
                                            .slice(0)
                                            .reverse()
                                            .forEach(function (textShadow) {
                                            _this.ctx.shadowColor = asString(textShadow.color);
                                            _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                            _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                            _this.ctx.shadowBlur = textShadow.blur.number;
                                            _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline, textIsVertical);
                                        });
                                        _this.ctx.shadowColor = '';
                                        _this.ctx.shadowOffsetX = 0;
                                        _this.ctx.shadowOffsetY = 0;
                                        _this.ctx.shadowBlur = 0;
                                    }
                                    if (styles.textDecorationLine.length) {
                                        _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                                        styles.textDecorationLine.forEach(function (textDecorationLine) {
                                            switch (textDecorationLine) {
                                                case 1 /* UNDERLINE */:
                                                    // Draws a line at the baseline of the font
                                                    // TODO As some browsers display the line as more than 1px if the font-size is big,
                                                    // need to take that into account both in position and size
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                                    break;
                                                case 2 /* OVERLINE */:
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                                    break;
                                                case 3 /* LINE_THROUGH */:
                                                    // TODO try and find exact position for line-through
                                                    _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                                    break;
                                            }
                                        });
                                    }
                                    break;
                                case 1 /* STROKE */:
                                    if (styles.webkitTextStrokeWidth && text.text.trim().length) {
                                        _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                        _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        _this.ctx.lineJoin = !!window.chrome ? 'miter' : 'round';
                                        _this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline);
                                    }
                                    _this.ctx.strokeStyle = '';
                                    _this.ctx.lineWidth = 0;
                                    _this.ctx.lineJoin = 'miter';
                                    break;
                            }
                        });
                    });
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function (container, curves, image, maskCurves) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path;
                if (!maskCurves) {
                    path = calculatePaddingBoxPath(curves);
                    this.path(path);
                } else {
                    path = maskCurves;
                    this.pathList(path);
                }
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function (paint, maskCurves) {
            return __awaiter(this, void 0, void 0, function () {
                var container, curves, styles, _i, _a, child, image, image, iframeRenderer, canvas, size, _b, fontFamily, fontSize, baseline, bounds, x, textBounds, img, image, url, fontFamily, bounds;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            this.applyEffects(paint.getEffects(4 /* CONTENT */));
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [3 /*break*/, 4];
                            child = _a[_i];
                            return [4 /*yield*/, this.renderTextNode(child, styles)];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [3 /*break*/, 8];
                            _c.label = 5;
                        case 5:
                            _c.trys.push([5, 7, , 8]);
                            return [4 /*yield*/, this.context.cache.match(container.src)];
                        case 6:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image, maskCurves);
                            return [3 /*break*/, 8];
                        case 7:
                            _c.sent();
                            this.context.logger.error("Error loading image " + container.src);
                            return [3 /*break*/, 8];
                        case 8:
                            if (container instanceof CanvasElementContainer) {
                                this.renderReplacedElement(container, curves, container.canvas);
                            }
                            if (!(container instanceof SVGElementContainer)) return [3 /*break*/, 12];
                            _c.label = 9;
                        case 9:
                            _c.trys.push([9, 11, , 12]);
                            return [4 /*yield*/, this.context.cache.match(container.svg)];
                        case 10:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [3 /*break*/, 12];
                        case 11:
                            _c.sent();
                            this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
                            return [3 /*break*/, 12];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [3 /*break*/, 14];
                            iframeRenderer = new CanvasRenderer(this.context, {
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                width: container.width,
                                height: container.height
                            });
                            return [4 /*yield*/, iframeRenderer.render(container.tree)];
                        case 13:
                            canvas = _c.sent();
                            if (container.width && container.height) {
                                this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            }
                            _c.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                                else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                _b = this.createFontStyle(styles), fontFamily = _b[0], fontSize = _b[1];
                                baseline = this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch (container.styles.textAlign) {
                                    case 1 /* CENTER */:
                                        x += bounds.width / 2;
                                        break;
                                    case 2 /* RIGHT */:
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                                this.ctx.restore();
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = 'left';
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */)) return [3 /*break*/, 20];
                            if (!(container.styles.listStyleImage !== null)) return [3 /*break*/, 19];
                            img = container.styles.listStyleImage;
                            if (!(img.type === 0 /* URL */)) return [3 /*break*/, 18];
                            image = void 0;
                            url = img.url;
                            _c.label = 15;
                        case 15:
                            _c.trys.push([15, 17, , 18]);
                            return [4 /*yield*/, this.context.cache.match(url)];
                        case 16:
                            image = _c.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [3 /*break*/, 18];
                        case 17:
                            _c.sent();
                            this.context.logger.error("Error loading list-style-image " + url);
                            return [3 /*break*/, 18];
                        case 18: return [3 /*break*/, 20];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== -1 /* NONE */) {
                                fontFamily = this.createFontStyle(styles)[0];
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'middle';
                                this.ctx.textAlign = 'right';
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                                this.ctx.textBaseline = 'bottom';
                                this.ctx.textAlign = 'left';
                            }
                            _c.label = 20;
                        case 20: return [2 /*return*/];
                    }
                });
            });
        };
        var getImageContainer = function (container) {
            if (!container) {
                return null;
            }
            if (container instanceof ImageElementContainer && container.src) {
                return container;
            }
            for (var i = 0; i < container.elements.length; i++) {
                var element = container.elements[i];
                if (element) {
                    var c = getImageContainer(element);
                    if (c) {
                        return c;
                    }
                }
            }
            return null;
        }
        var getMaskImage = function (container) {
            if (!container) {
                return null;
            }
            if (container.styles && container.styles.webkitMaskImage && container.styles.webkitMaskImage.length > 0) {
                return container.styles.webkitMaskImage[0].url;
            }
            if (container instanceof ImageElementContainer && container.src) {
                if (container.src.startsWith("blob:http")) {
                    return container.src;
                }
            }
            for (var i = 0; i < container.elements.length; i++) {
                var element = container.elements[i];
                if (element) {
                    var c = getMaskImage(element);
                    if (c) {
                        return c;
                    }
                }
            }
            return null;
        }
        CanvasRenderer.prototype.renderNodeDropShadow = function (paint) {
            var _this = this;
            return __awaiter(this, void 0, void 0, function () {
                var styles, container, bounds, ratio, maskOffset = 0, borderBoxArea, shadowPaintingArea, shadow, pathList, imageContainer, imageUrl, n, curve, path_ready = false, borderLeft = 0, borderTop = 0, canvasOffsetX = 0, canvasOffsetY = 0;
                canvasOffsetX = -_this.canvas.width;
                canvasOffsetY = -_this.canvas.height;
                return __generator(this, function (_p) {
                    switch (_p.label) {
                        case 0:
                            // console.log("renderNodeDropShadow: label=0");
                            container = paint.container;
                            bounds = container.bounds || {left: 0, top: 0, width: 100, height: 100};
                            styles = container.styles;
                            if (!styles || !styles.dropShadow || styles.dropShadow.length == 0) {
                                return [3, 3]; // 结束
                            }
                            shadow = styles.dropShadow[0];
                            if (!shadow || !(
                                (shadow.offsetX && Math.abs(shadow.offsetX.number) > 0) || 
                                (shadow.offsetY && Math.abs(shadow.offsetY.number) > 0) || 
                                (shadow.blur && shadow.blur.number > 0)
                            )) {
                                return [3, 3]; // 结束
                            }

                            // * test client *
                            // _this.ctx.beginPath();
                            // _this.ctx.moveTo(canvasOffsetX, canvasOffsetY);
                            // _this.ctx.lineTo(canvasOffsetX + _this.canvas.width, canvasOffsetY);
                            // _this.ctx.lineTo(canvasOffsetX + _this.canvas.width, canvasOffsetY + _this.canvas.height);
                            // _this.ctx.lineTo(canvasOffsetX, canvasOffsetY + _this.canvas.height);
                            // _this.ctx.lineTo(canvasOffsetX, canvasOffsetY);
                            // _this.ctx.fillStyle = 'red';
                            // _this.ctx.fill();


                            _this.ctx.save();
                            
                            ratio = (_this.options.ratio * _this.options.scale);
                            borderLeft = (styles.borderLeftWidth || 0)  * ratio;
                            borderTop = (styles.borderTopWidth || 0)  * ratio;
                            borderBoxArea = calculateBorderBoxPath(paint.curves);
                            maskOffset = 0; //MASK_OFFSET;
                            shadowPaintingArea = transformPath(borderBoxArea, -maskOffset, 0, 0, 0);
                            imageUrl = getMaskImage(paint.container);
                            if (imageUrl) {
                                return [4, Image2Path.fetchPathFromImage(imageUrl, bounds.width, bounds.height)]; // 异步获取image的path数据
                            } else {

                                return [3, 2]; // 跳转到step-2, 根据box形状画阴影
                            }
                                
                        case 1:
                            // console.log("renderNodeDropShadow: label=1");
                            pathList = _p.sent();
                            if (pathList && pathList.length > 0) {
                                _this.ctx.beginPath();
                                _this.ctx.moveTo(canvasOffsetX, canvasOffsetY);
                                _this.ctx.lineTo(_this.canvas.width - canvasOffsetX, canvasOffsetY);
                                _this.ctx.lineTo(_this.canvas.width - canvasOffsetX, _this.canvas.height - canvasOffsetY);
                                _this.ctx.lineTo(canvasOffsetX, _this.canvas.height - canvasOffsetY);
                                _this.ctx.lineTo(canvasOffsetX, canvasOffsetY);
                                for (var p = 0; p < pathList.length; p++) {
                                    curve = pathList[p].curve;
                                    n = curve.n;

                                    _this.ctx.moveTo(
                                        curve.c[(n - 1) * 3 + 2].x + bounds.left - borderLeft, 
                                        curve.c[(n - 1) * 3 + 2].y + bounds.top - borderTop);
                                    for (var i = 0; i < n; i++) {
                                        if (curve.tag[i] === "CORNER") {
                                            _this.ctx.lineTo(
                                                curve.c[i * 3 + 1].x + bounds.left - borderLeft, 
                                                curve.c[i * 3 + 1].y + bounds.top - borderTop);
                                            _this.ctx.lineTo(
                                                curve.c[i * 3 + 2].x + bounds.left - borderLeft, 
                                                curve.c[i * 3 + 2].y + bounds.top - borderTop);
                                        }
                                        else if (curve.tag[i] === "CURVE") {
                                            _this.ctx.bezierCurveTo(
                                                curve.c[i * 3 + 0].x + bounds.left - borderLeft, 
                                                curve.c[i * 3 + 0].y + bounds.top - borderTop,
                                                curve.c[i * 3 + 1].x + bounds.left - borderLeft, 
                                                curve.c[i * 3 + 1].y + bounds.top - borderTop,
                                                curve.c[i * 3 + 2].x + bounds.left - borderLeft, 
                                                curve.c[i * 3 + 2].y + bounds.top - borderTop);
                                        }
                                    }
                                }
                                _this.ctx.clip('evenodd');

                                _this.ctx.beginPath();
                                for (var p = 0; p < pathList.length; p++) {
                                    curve = pathList[p].curve;
                                    n = curve.n;

                                    _this.ctx.moveTo(
                                        curve.c[(n - 1) * 3 + 2].x + bounds.left - borderLeft, 
                                        curve.c[(n - 1) * 3 + 2].y + bounds.top - borderTop);
                                    for (var i = 0; i < n; i++) {
                                        if (curve.tag[i] === "CORNER") {
                                            _this.ctx.lineTo(
                                                curve.c[i * 3 + 1].x + bounds.left - borderLeft, 
                                                curve.c[i * 3 + 1].y + bounds.top - borderTop);
                                            _this.ctx.lineTo(
                                                curve.c[i * 3 + 2].x + bounds.left - borderLeft, 
                                                curve.c[i * 3 + 2].y + bounds.top - borderTop);
                                        }
                                        else if (curve.tag[i] === "CURVE") {
                                            _this.ctx.bezierCurveTo(
                                                curve.c[i * 3 + 0].x + bounds.left - borderLeft, 
                                                curve.c[i * 3 + 0].y + bounds.top - borderTop,
                                                curve.c[i * 3 + 1].x + bounds.left - borderLeft, 
                                                curve.c[i * 3 + 1].y + bounds.top - borderTop,
                                                curve.c[i * 3 + 2].x + bounds.left - borderLeft, 
                                                curve.c[i * 3 + 2].y + bounds.top - borderTop);
                                        }
                                    }
                                }
                                _this.ctx.closePath();
                                path_ready = true;
                            }
                            _p.label = 2;
                        case 2:
                            // console.log("renderNodeDropShadow: label=2");
                            if (!path_ready) {
                                _this.mask2(borderBoxArea);
                                _this.ctx.clip("evenodd");
                                _this.path2(shadowPaintingArea);
                            }
                            _this.ctx.shadowOffsetX = (ratio * shadow.offsetX.number) + maskOffset;
                            _this.ctx.shadowOffsetY = (ratio * shadow.offsetY.number);
                            _this.ctx.shadowColor = asString(shadow.color);
                            _this.ctx.shadowBlur = ratio * shadow.blur.number * 2;
                            _this.ctx.fillStyle = asString(shadow.color); //asString(shadow.color);
                            _this.ctx.fill();
                            _this.ctx.restore();
                            _p.sent();
                            _p.label = 3;
                        case 3:
                            return [2 /*return*/];
                    }
                });
            });
        }
        CanvasRenderer.prototype.renderStackContent = function (stack, maskCurves) {
            var _this = this;
            return __awaiter(this, void 0, void 0, function () {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                var stackMaskCurves;
                return __generator(this, function (_p) {
                    switch (_p.label) {
                        case 0:
                            if (contains(stack.element.container.flags, 16 /* DEBUG_RENDER */)) {
                                debugger;
                            }
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            return [4 /*yield*/, this.renderNodeBackgroundAndBorders(stack.element, maskCurves)];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [3 /*break*/, 5];
                            child = _a[_i];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [3 /*break*/, 2];
                        case 5: 
                        // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                        return [4 /*yield*/, this.renderNodeContent(stack.element, maskCurves)];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [3 /*break*/, 10];
                            child = _c[_b];
                            return [4 /*yield*/, this.renderNode(child, maskCurves)];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [3 /*break*/, 7];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [3 /*break*/, 14];
                            child = _e[_d];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [3 /*break*/, 11];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [3 /*break*/, 18];
                            child = _g[_f];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [3 /*break*/, 15];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [3 /*break*/, 22];
                            child = _j[_h];
                            return [4 /*yield*/, this.renderNode(child, maskCurves)];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [3 /*break*/, 19];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            stackMaskCurves = null;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [3 /*break*/, 26];
                            child = _l[_k];
                            return [4 /*yield*/, this.renderStack(child, stackMaskCurves || maskCurves)];
                        case 24:
                            _p.sent();
                            if (child.element.maskCurves && child.element.maskCurves.length) {
                                stackMaskCurves = child.element.maskCurves;
                            }
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [3 /*break*/, 23];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            stackMaskCurves = null;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [3 /*break*/, 30];
                            child = _o[_m];
                            return [4 /*yield*/, this.renderStack(child, stackMaskCurves || maskCurves)];
                        case 28:
                            _p.sent();
                            if (child.element.maskCurves && child.element.maskCurves.length) {
                                stackMaskCurves = child.element.maskCurves;
                            }
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [3 /*break*/, 27];
                        case 30: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function (paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(reversePath(paths.slice(0)));
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.mask2 = function (paths) {
            var offsetX = -this.canvas.width;
            var offsetY = -this.canvas.height;
            this.ctx.beginPath();
            this.ctx.moveTo(offsetX, offsetY);
            this.ctx.lineTo(this.canvas.width - offsetX , offsetY);
            this.ctx.lineTo(this.canvas.width - offsetX, this.canvas.height - offsetY);
            this.ctx.lineTo(offsetX, this.canvas.height - offsetY);
            this.ctx.lineTo(offsetX, offsetY);
            this.formatPath(reversePath(paths.slice(0)));
            this.ctx.closePath();
        };

        CanvasRenderer.prototype.pathHole = function(paths, holes) {
            this.ctx.beginPath();
            this.formatPath(paths);
            if (holes) {
                this.formatPath(reversePath(holes));
            }
            this.ctx.closePath();
        }

        CanvasRenderer.prototype.path = function (paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path2 = function (paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };

        CanvasRenderer.prototype.pathList = function (paths) {
            this.ctx.beginPath();
            for (var i = 0; i < paths.length; i++) {
                this.formatPath(paths[i]);
                this.ctx.closePath();
            }
        };

        CanvasRenderer.prototype.formatPath = function (paths) {
            var _this = this;
            paths.forEach(function (point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) {
                    _this.ctx.moveTo(start.x, start.y);
                }
                else {
                    _this.ctx.lineTo(start.x, start.y);
                }
                if (isBezierCurve(point)) {
                    _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
                }
            });
        };
        CanvasRenderer.prototype.renderRepeat = function (path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function (image, width, height) {
            var _a;
            if (image.width === width && image.height === height) {
                return image;
            }
            var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document;
            var canvas = ownerDocument.createElement('canvas');
            canvas.width = Math.max(1, width);
            canvas.height = Math.max(1, height);
            var ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function (container) {
            return __awaiter(this, void 0, void 0, function () {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function (backgroundImage) {
                                var image, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position, x, y, _g, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function (_h) {
                                    switch (_h.label) {
                                        case 0:
                                            if (!(backgroundImage.type === 0 /* URL */)) return [3 /*break*/, 5];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _h.label = 1;
                                        case 1:
                                            _h.trys.push([1, 3, , 4]);
                                            return [4 /*yield*/, this_1.context.cache.match(url)];
                                        case 2:
                                            image = _h.sent();
                                            return [3 /*break*/, 4];
                                        case 3:
                                            _h.sent();
                                            this_1.context.logger.error("Error loading background-image " + url);
                                            return [3 /*break*/, 4];
                                        case 4:
                                            if (image) {
                                                _c = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), 'repeat');
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [3 /*break*/, 6];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [null, null, null]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
                                                _e = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                                                canvas = document.createElement('canvas');
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext('2d');
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function (colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, 'repeat');
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            }
                                            else if (isRadialGradient(backgroundImage)) {
                                                _f = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                                                position = backgroundImage.position.length === 0 ? [FIFTY_PERCENT] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _g = calculateRadius(backgroundImage, x, y, width, height), rx = _g[0], ry = _g[1];
                                                if (rx > 0 && ry > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function (colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    }
                                                    else {
                                                        this_1.ctx.fill();
                                                    }
                                                }
                                            }
                                            _h.label = 6;
                                        case 6:
                                            index--;
                                            return [2 /*return*/];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [3 /*break*/, 4];
                            backgroundImage = _a[_i];
                            return [5 /*yield**/, _loop_1(backgroundImage)];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderSolidBorder = function (color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.ctx.save();
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();

                    //var oldLineWidth = this.ctx.lineWidth;
                    //var oldStrokeStyle = this.ctx.strokeStyle;
                    this.ctx.lineWidth = 2;
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    //this.ctx.lineWidth = oldLineWidth;
                    //this.ctx.strokeStyle = oldStrokeStyle;
                    this.ctx.restore();
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.renderDoubleBorder = function (color, width, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function () {
                var outerPaths, innerPaths;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(width < 3)) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.renderSolidBorder(color, side, curvePoints)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                        case 2:
                            this.ctx.save();
                            outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                            this.path(outerPaths);
                            this.ctx.fillStyle = asString(color);
                            this.ctx.fill();
                            innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                            this.path(innerPaths);
                            this.ctx.fill();
                            this.ctx.restore();
                            return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function (paint, maskCurves) {
            return __awaiter(this, void 0, void 0, function () {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border, holeBorderBoxPath;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.applyEffects(paint.getEffects(2 /* BACKGROUND_BORDERS */));
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                { style: styles.borderTopStyle, color: styles.borderTopColor, width: styles.borderTopWidth },
                                { style: styles.borderRightStyle, color: styles.borderRightColor, width: styles.borderRightWidth },
                                { style: styles.borderBottomStyle, color: styles.borderBottomColor, width: styles.borderBottomWidth },
                                { style: styles.borderLeftStyle, color: styles.borderLeftColor, width: styles.borderLeftWidth }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [3 /*break*/, 2];
                            this.ctx.save();

                            if (maskCurves) {
                                this.pathList(maskCurves);
                            }
                            else if (paint.container.holeCurves) {
                                holeBorderBoxPath = calculateBorderBoxPath(paint.container.holeCurves);
                                this.pathHole(backgroundPaintingArea, holeBorderBoxPath);
                            } else {
                                this.path(backgroundPaintingArea);
                            }
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [4 /*yield*/, this.renderBackgroundImage(paint.container)];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow
                                .slice(0)
                                .reverse()
                                .forEach(function (shadow) {
                                    if ((shadow.offsetX && Math.abs(shadow.offsetX.number) > 0) || (shadow.offsetY && Math.abs(shadow.offsetY.number) > 0) || (shadow.blur && shadow.blur.number > 0)) {
                                        _this.ctx.save();
                                        var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                        var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                        var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                        if (shadow.inset) {
                                            _this.path2(borderBoxArea);
                                            _this.ctx.clip();
                                            _this.mask2(shadowPaintingArea);
                                        }
                                        else {
                                            _this.mask2(borderBoxArea);
                                            _this.ctx.clip();
                                            _this.path2(shadowPaintingArea);
                                        }
                                        _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                        _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                        _this.ctx.shadowColor = asString(shadow.color);
                                        _this.ctx.shadowBlur = shadow.blur.number;
                                        _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : 'rgba(0,0,0,1)';
                                        _this.ctx.fill();
                                        _this.ctx.restore();
                                    }
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [3 /*break*/, 13];
                            border = borders_1[_i];
                            if (!(border.style !== 0 /* NONE */ && !isTransparent(border.color) && border.width > 0)) return [3 /*break*/, 11];
                            if (!(border.style === 2 /* DASHED */)) return [3 /*break*/, 5];
                            return [4 /*yield*/, this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 2 /* DASHED */)];
                        case 4:
                            _a.sent();
                            return [3 /*break*/, 11];
                        case 5:
                            if (!(border.style === 3 /* DOTTED */)) return [3 /*break*/, 7];
                            return [4 /*yield*/, this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 3 /* DOTTED */)];
                        case 6:
                            _a.sent();
                            return [3 /*break*/, 11];
                        case 7:
                            if (!(border.style === 4 /* DOUBLE */)) return [3 /*break*/, 9];
                            return [4 /*yield*/, this.renderDoubleBorder(border.color, border.width, side, paint.curves)];
                        case 8:
                            _a.sent();
                            return [3 /*break*/, 11];
                        case 9: return [4 /*yield*/, this.renderSolidBorder(border.color, side, paint.curves)];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            side++;
                            _a.label = 12;
                        case 12:
                            _i++;
                            return [3 /*break*/, 3];
                        case 13: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderDashedDottedBorder = function (color, width, side, curvePoints, style) {
            return __awaiter(this, void 0, void 0, function () {
                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
                return __generator(this, function (_a) {
                    this.ctx.save();
                    strokePaths = parsePathForBorderStroke(curvePoints, side);
                    boxPaths = parsePathForBorder(curvePoints, side);
                    if (style === 2 /* DASHED */) {
                        this.path(boxPaths);
                        this.ctx.clip();
                    }
                    if (isBezierCurve(boxPaths[0])) {
                        startX = boxPaths[0].start.x;
                        startY = boxPaths[0].start.y;
                    }
                    else {
                        startX = boxPaths[0].x;
                        startY = boxPaths[0].y;
                    }
                    if (isBezierCurve(boxPaths[1])) {
                        endX = boxPaths[1].end.x;
                        endY = boxPaths[1].end.y;
                    }
                    else {
                        endX = boxPaths[1].x;
                        endY = boxPaths[1].y;
                    }
                    if (side === 0 || side === 2) {
                        length = Math.abs(startX - endX);
                    }
                    else {
                        length = Math.abs(startY - endY);
                    }
                    this.ctx.beginPath();
                    if (style === 3 /* DOTTED */) {
                        this.formatPath(strokePaths);
                    }
                    else {
                        this.formatPath(boxPaths.slice(0, 2));
                    }
                    dashLength = width < 3 ? width * 3 : width * 2;
                    spaceLength = width < 3 ? width * 2 : width;
                    if (style === 3 /* DOTTED */) {
                        dashLength = width;
                        spaceLength = width;
                    }
                    useLineDash = true;
                    if (length <= dashLength * 2) {
                        useLineDash = false;
                    }
                    else if (length <= dashLength * 2 + spaceLength) {
                        multiplier = length / (2 * dashLength + spaceLength);
                        dashLength *= multiplier;
                        spaceLength *= multiplier;
                    }
                    else {
                        numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                        minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                        maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                        spaceLength =
                            maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace)
                                ? minSpace
                                : maxSpace;
                    }
                    if (useLineDash) {
                        if (style === 3 /* DOTTED */) {
                            this.ctx.setLineDash([0, dashLength + spaceLength]);
                        }
                        else {
                            this.ctx.setLineDash([dashLength, spaceLength]);
                        }
                    }
                    if (style === 3 /* DOTTED */) {
                        this.ctx.lineCap = 'round';
                        this.ctx.lineWidth = width;
                    }
                    else {
                        this.ctx.lineWidth = width * 2 + 1.1;
                    }
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    this.ctx.setLineDash([]);
                    // dashed round edge gap
                    if (style === 2 /* DASHED */) {
                        if (isBezierCurve(boxPaths[0])) {
                            path1 = boxPaths[3];
                            path2 = boxPaths[0];
                            this.ctx.beginPath();
                            this.formatPath([new Vector(path1.end.x, path1.end.y), new Vector(path2.start.x, path2.start.y)]);
                            this.ctx.stroke();
                        }
                        if (isBezierCurve(boxPaths[1])) {
                            path1 = boxPaths[1];
                            path2 = boxPaths[2];
                            this.ctx.beginPath();
                            this.formatPath([new Vector(path1.end.x, path1.end.y), new Vector(path2.start.x, path2.start.y)]);
                            this.ctx.stroke();
                        }
                    }
                    this.ctx.restore();
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.render = function (element) {
            return __awaiter(this, void 0, void 0, function () {
                var stack;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [4 /*yield*/, this.renderStack(stack)];
                        case 1:
                            _a.sent();
                            this.applyEffects([]);
                            return [2 /*return*/, this.canvas];
                    }
                });
            });
        };
        return CanvasRenderer;
    }(Renderer));
    var isTextInputElement = function (container) {
        if (container instanceof TextareaElementContainer) {
            return true;
        }
        else if (container instanceof SelectElementContainer) {
            return true;
        }
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) {
            return true;
        }
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function (clip, curves) {
        switch (clip) {
            case 0 /* BORDER_BOX */:
                return calculateBorderBoxPath(curves);
            case 2 /* CONTENT_BOX */:
                return calculateContentBoxPath(curves);
            case 1 /* PADDING_BOX */:
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function (textAlign) {
        switch (textAlign) {
            case 1 /* CENTER */:
                return 'center';
            case 2 /* RIGHT */:
                return 'right';
            case 0 /* LEFT */:
            default:
                return 'left';
        }
    };
    // see https://github.com/niklasvh/html2canvas/pull/2645
    var iOSBrokenFonts = ['-apple-system', 'system-ui'];
    var fixIOSSystemFonts = function (fontFamilies) {
        return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent)
            ? fontFamilies.filter(function (fontFamily) { return iOSBrokenFonts.indexOf(fontFamily) === -1; })
            : fontFamilies;
    };

    var ForeignObjectRenderer = /** @class */ (function (_super) {
        __extends(ForeignObjectRenderer, _super);
        function ForeignObjectRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            _this.options = options;
            _this.canvas.width = Math.floor(options.width * options.scale);
            _this.canvas.height = Math.floor(options.height * options.scale);
            _this.canvas.style.width = options.width + "px";
            _this.canvas.style.height = options.height + "px";
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
            return _this;
        }
        ForeignObjectRenderer.prototype.render = function (element) {
            return __awaiter(this, void 0, void 0, function () {
                var svg, img;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
                            return [4 /*yield*/, loadSerializedSVG(svg)];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [2 /*return*/, this.canvas];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }(Renderer));
    var loadSerializedSVG = function (svg) {
        return new Promise(function (resolve, reject) {
            var img = new Image();
            img.onload = function () {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };

    var Logger = /** @class */ (function () {
        function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.debug === 'function') {
                    // eslint-disable-next-line no-console
                    console.debug.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        Logger.prototype.getTime = function () {
            return Date.now() - this.start;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.info === 'function') {
                    // eslint-disable-next-line no-console
                    console.info.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.warn = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.warn === 'function') {
                    // eslint-disable-next-line no-console
                    console.warn.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.error === 'function') {
                    // eslint-disable-next-line no-console
                    console.error.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        Logger.instances = {};
        return Logger;
    }());

    var Context = /** @class */ (function () {
        function Context(options, windowBounds) {
            var _a;
            this.windowBounds = windowBounds;
            this.instanceName = "#" + Context.instanceCount++;
            this.logger = new Logger({ id: this.instanceName, enabled: options.logging });
            this.cache = (_a = options.cache) !== null && _a !== void 0 ? _a : new Cache(this, options);
        }
        Context.instanceCount = 1;
        return Context;
    }());

    var html2canvas = function (element, options) {
        if (options === void 0) { options = {}; }
        return renderElement(element, options);
    };
    if (typeof window !== 'undefined') {
        CacheStorage.setContext(window);
    }
    var renderElement = function (element, opts) { return __awaiter(void 0, void 0, void 0, function () {
        var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a, width, height, left, top, backgroundColor, renderOptions, canvas, renderer, root, renderer;
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        return __generator(this, function (_u) {
            switch (_u.label) {
                case 0:
                    if (!element || typeof element !== 'object') {
                        return [2 /*return*/, Promise.reject('Invalid element provided as first argument')];
                    }
                    ownerDocument = element.ownerDocument;
                    if (!ownerDocument) {
                        throw new Error("Element is not attached to a Document");
                    }
                    defaultView = ownerDocument.defaultView;
                    if (!defaultView) {
                        throw new Error("Document is not attached to a Window");
                    }
                    resourceOptions = {
                        allowTaint: (_b = opts.allowTaint) !== null && _b !== void 0 ? _b : false,
                        imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15000,
                        proxy: opts.proxy,
                        useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
                    };
                    contextOptions = __assign({ logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true, cache: opts.cache }, resourceOptions);
                    windowOptions = {
                        windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
                        windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
                        scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
                        scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
                    };
                    windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
                    context = new Context(contextOptions, windowBounds);
                    foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
                    cloneOptions = {
                        allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
                        onclone: opts.onclone,
                        ignoreElements: opts.ignoreElements,
                        inlineImages: foreignObjectRendering,
                        copyStyles: foreignObjectRendering
                    };
                    context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
                    documentCloner = new DocumentCloner(context, element, cloneOptions);
                    clonedElement = documentCloner.clonedReferenceElement;
                    if (!clonedElement) {
                        return [2 /*return*/, Promise.reject("Unable to find element in cloned iframe")];
                    }
                    return [4 /*yield*/, documentCloner.toIFrame(ownerDocument, windowBounds)];
                case 1:
                    container = _u.sent();
                    _a = isBodyElement(clonedElement) || isHTMLElement(clonedElement)
                        ? parseDocumentSize(clonedElement.ownerDocument)
                        : parseBounds(context, clonedElement), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                    backgroundColor = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
                    renderOptions = {
                        canvas: opts.canvas,
                        backgroundColor: backgroundColor,
                        scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
                        x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
                        y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
                        width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
                        height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height),
                        ratio: opts.ratio || 1
                    };
                    if (!foreignObjectRendering) return [3 /*break*/, 3];
                    context.logger.debug("Document cloned, using foreign object rendering");
                    renderer = new ForeignObjectRenderer(context, renderOptions);
                    return [4 /*yield*/, renderer.render(clonedElement)];
                case 2:
                    canvas = _u.sent();
                    return [3 /*break*/, 5];
                case 3:
                    context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
                    context.logger.debug("Starting DOM parsing");
                    root = parseTree(context, clonedElement);
                    if (backgroundColor === root.styles.backgroundColor) {
                        root.styles.backgroundColor = COLORS.TRANSPARENT;
                    }
                    context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
                    renderer = new CanvasRenderer(context, renderOptions);
                    return [4 /*yield*/, renderer.render(root)];
                case 4:
                    canvas = _u.sent();
                    _u.label = 5;
                case 5:
                    if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
                        if (!DocumentCloner.destroy(container)) {
                            context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                    }
                    context.logger.debug("Finished rendering");
                    return [2 /*return*/, canvas];
            }
        });
    }); };
    var parseBackgroundColor = function (context, element, backgroundColorOverride) {
        var ownerDocument = element.ownerDocument;
        // http://www.w3.org/TR/css3-background/#special-backgrounds
        var documentBackgroundColor = ownerDocument.documentElement
            ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor)
            : COLORS.TRANSPARENT;
        var bodyBackgroundColor = ownerDocument.body
            ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor)
            : COLORS.TRANSPARENT;
        var defaultBackgroundColor = typeof backgroundColorOverride === 'string'
            ? parseColor(context, backgroundColorOverride)
            : backgroundColorOverride === null
                ? COLORS.TRANSPARENT
                : 0xffffffff;
        return element === ownerDocument.documentElement
            ? isTransparent(documentBackgroundColor)
                ? isTransparent(bodyBackgroundColor)
                    ? defaultBackgroundColor
                    : bodyBackgroundColor
                : documentBackgroundColor
            : defaultBackgroundColor;
    };

    return html2canvas;

})));




function html2canvas_adapt(node, options) {
	// https://github.com/niklasvh/html2canvas/blob/v1.4.1/docs/configuration.md
	options.allowTaint = true;
	options.useCORS = true;
	options.x = 0;
	options.y = 0;
	options.onclone = onElementClone;
	options.logging = true;
	// 支持自定义DPI（屏幕96DPI），不传则默认96
	if (options.dpi && !options.scale) {
		options.scale = options.dpi / 96;
	}
	html2canvas(node, options)
	.then(function (canvas) {
		if (options.onrendered) {
			options.onrendered(canvas);
		}
	});

	function onElementClone (element) {
		// console.log(element);
		// if (options.error) {
		// 	options.error();
		// }
	}
}

(function(){
    'user strict';
    angular.module('editorApp')
    .directive('fileread', fileread);

    function fileread() {
        var directive = {
            restrict: 'A',
            scope: false,
            link: linkFunc
        };
        return directive;
        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind("change", function(changeEvent) {
                scope.$parent.upLoading = true;
                scope.uploadFile(changeEvent.target.files[0], changeEvent.target.id);
            });
        }
    }
})();



(function() {

    var debug = false;

    var root = this;

    var EXIF = function(obj) {
        if (obj instanceof EXIF) return obj;
        if (!(this instanceof EXIF)) return new EXIF(obj);
        this.EXIFwrapped = obj;
    };

    if (typeof exports !== 'undefined') {
        if (typeof module !== 'undefined' && module.exports) {
            exports = module.exports = EXIF;
        }
        exports.EXIF = EXIF;
    } else {
        root.EXIF = EXIF;
    }

    var ExifTags = EXIF.Tags = {

        // version tags
        0x9000 : "ExifVersion",             // EXIF version
        0xA000 : "FlashpixVersion",         // Flashpix format version

        // colorspace tags
        0xA001 : "ColorSpace",              // Color space information tag

        // image configuration
        0xA002 : "PixelXDimension",         // Valid width of meaningful image
        0xA003 : "PixelYDimension",         // Valid height of meaningful image
        0x9101 : "ComponentsConfiguration", // Information about channels
        0x9102 : "CompressedBitsPerPixel",  // Compressed bits per pixel

        // user information
        0x927C : "MakerNote",               // Any desired information written by the manufacturer
        0x9286 : "UserComment",             // Comments by user

        // related file
        0xA004 : "RelatedSoundFile",        // Name of related sound file

        // date and time
        0x9003 : "DateTimeOriginal",        // Date and time when the original image was generated
        0x9004 : "DateTimeDigitized",       // Date and time when the image was stored digitally
        0x9290 : "SubsecTime",              // Fractions of seconds for DateTime
        0x9291 : "SubsecTimeOriginal",      // Fractions of seconds for DateTimeOriginal
        0x9292 : "SubsecTimeDigitized",     // Fractions of seconds for DateTimeDigitized

        // picture-taking conditions
        0x829A : "ExposureTime",            // Exposure time (in seconds)
        0x829D : "FNumber",                 // F number
        0x8822 : "ExposureProgram",         // Exposure program
        0x8824 : "SpectralSensitivity",     // Spectral sensitivity
        0x8827 : "ISOSpeedRatings",         // ISO speed rating
        0x8828 : "OECF",                    // Optoelectric conversion factor
        0x9201 : "ShutterSpeedValue",       // Shutter speed
        0x9202 : "ApertureValue",           // Lens aperture
        0x9203 : "BrightnessValue",         // Value of brightness
        0x9204 : "ExposureBias",            // Exposure bias
        0x9205 : "MaxApertureValue",        // Smallest F number of lens
        0x9206 : "SubjectDistance",         // Distance to subject in meters
        0x9207 : "MeteringMode",            // Metering mode
        0x9208 : "LightSource",             // Kind of light source
        0x9209 : "Flash",                   // Flash status
        0x9214 : "SubjectArea",             // Location and area of main subject
        0x920A : "FocalLength",             // Focal length of the lens in mm
        0xA20B : "FlashEnergy",             // Strobe energy in BCPS
        0xA20C : "SpatialFrequencyResponse",    //
        0xA20E : "FocalPlaneXResolution",   // Number of pixels in width direction per FocalPlaneResolutionUnit
        0xA20F : "FocalPlaneYResolution",   // Number of pixels in height direction per FocalPlaneResolutionUnit
        0xA210 : "FocalPlaneResolutionUnit",    // Unit for measuring FocalPlaneXResolution and FocalPlaneYResolution
        0xA214 : "SubjectLocation",         // Location of subject in image
        0xA215 : "ExposureIndex",           // Exposure index selected on camera
        0xA217 : "SensingMethod",           // Image sensor type
        0xA300 : "FileSource",              // Image source (3 == DSC)
        0xA301 : "SceneType",               // Scene type (1 == directly photographed)
        0xA302 : "CFAPattern",              // Color filter array geometric pattern
        0xA401 : "CustomRendered",          // Special processing
        0xA402 : "ExposureMode",            // Exposure mode
        0xA403 : "WhiteBalance",            // 1 = auto white balance, 2 = manual
        0xA404 : "DigitalZoomRation",       // Digital zoom ratio
        0xA405 : "FocalLengthIn35mmFilm",   // Equivalent foacl length assuming 35mm film camera (in mm)
        0xA406 : "SceneCaptureType",        // Type of scene
        0xA407 : "GainControl",             // Degree of overall image gain adjustment
        0xA408 : "Contrast",                // Direction of contrast processing applied by camera
        0xA409 : "Saturation",              // Direction of saturation processing applied by camera
        0xA40A : "Sharpness",               // Direction of sharpness processing applied by camera
        0xA40B : "DeviceSettingDescription",    //
        0xA40C : "SubjectDistanceRange",    // Distance to subject

        // other tags
        0xA005 : "InteroperabilityIFDPointer",
        0xA420 : "ImageUniqueID"            // Identifier assigned uniquely to each image
    };

    var TiffTags = EXIF.TiffTags = {
        0x0100 : "ImageWidth",
        0x0101 : "ImageHeight",
        0x8769 : "ExifIFDPointer",
        0x8825 : "GPSInfoIFDPointer",
        0xA005 : "InteroperabilityIFDPointer",
        0x0102 : "BitsPerSample",
        0x0103 : "Compression",
        0x0106 : "PhotometricInterpretation",
        0x0112 : "Orientation",
        0x0115 : "SamplesPerPixel",
        0x011C : "PlanarConfiguration",
        0x0212 : "YCbCrSubSampling",
        0x0213 : "YCbCrPositioning",
        0x011A : "XResolution",
        0x011B : "YResolution",
        0x0128 : "ResolutionUnit",
        0x0111 : "StripOffsets",
        0x0116 : "RowsPerStrip",
        0x0117 : "StripByteCounts",
        0x0201 : "JPEGInterchangeFormat",
        0x0202 : "JPEGInterchangeFormatLength",
        0x012D : "TransferFunction",
        0x013E : "WhitePoint",
        0x013F : "PrimaryChromaticities",
        0x0211 : "YCbCrCoefficients",
        0x0214 : "ReferenceBlackWhite",
        0x0132 : "DateTime",
        0x010E : "ImageDescription",
        0x010F : "Make",
        0x0110 : "Model",
        0x0131 : "Software",
        0x013B : "Artist",
        0x8298 : "Copyright"
    };

    var GPSTags = EXIF.GPSTags = {
        0x0000 : "GPSVersionID",
        0x0001 : "GPSLatitudeRef",
        0x0002 : "GPSLatitude",
        0x0003 : "GPSLongitudeRef",
        0x0004 : "GPSLongitude",
        0x0005 : "GPSAltitudeRef",
        0x0006 : "GPSAltitude",
        0x0007 : "GPSTimeStamp",
        0x0008 : "GPSSatellites",
        0x0009 : "GPSStatus",
        0x000A : "GPSMeasureMode",
        0x000B : "GPSDOP",
        0x000C : "GPSSpeedRef",
        0x000D : "GPSSpeed",
        0x000E : "GPSTrackRef",
        0x000F : "GPSTrack",
        0x0010 : "GPSImgDirectionRef",
        0x0011 : "GPSImgDirection",
        0x0012 : "GPSMapDatum",
        0x0013 : "GPSDestLatitudeRef",
        0x0014 : "GPSDestLatitude",
        0x0015 : "GPSDestLongitudeRef",
        0x0016 : "GPSDestLongitude",
        0x0017 : "GPSDestBearingRef",
        0x0018 : "GPSDestBearing",
        0x0019 : "GPSDestDistanceRef",
        0x001A : "GPSDestDistance",
        0x001B : "GPSProcessingMethod",
        0x001C : "GPSAreaInformation",
        0x001D : "GPSDateStamp",
        0x001E : "GPSDifferential"
    };

    var StringValues = EXIF.StringValues = {
        ExposureProgram : {
            0 : "Not defined",
            1 : "Manual",
            2 : "Normal program",
            3 : "Aperture priority",
            4 : "Shutter priority",
            5 : "Creative program",
            6 : "Action program",
            7 : "Portrait mode",
            8 : "Landscape mode"
        },
        MeteringMode : {
            0 : "Unknown",
            1 : "Average",
            2 : "CenterWeightedAverage",
            3 : "Spot",
            4 : "MultiSpot",
            5 : "Pattern",
            6 : "Partial",
            255 : "Other"
        },
        LightSource : {
            0 : "Unknown",
            1 : "Daylight",
            2 : "Fluorescent",
            3 : "Tungsten (incandescent light)",
            4 : "Flash",
            9 : "Fine weather",
            10 : "Cloudy weather",
            11 : "Shade",
            12 : "Daylight fluorescent (D 5700 - 7100K)",
            13 : "Day white fluorescent (N 4600 - 5400K)",
            14 : "Cool white fluorescent (W 3900 - 4500K)",
            15 : "White fluorescent (WW 3200 - 3700K)",
            17 : "Standard light A",
            18 : "Standard light B",
            19 : "Standard light C",
            20 : "D55",
            21 : "D65",
            22 : "D75",
            23 : "D50",
            24 : "ISO studio tungsten",
            255 : "Other"
        },
        Flash : {
            0x0000 : "Flash did not fire",
            0x0001 : "Flash fired",
            0x0005 : "Strobe return light not detected",
            0x0007 : "Strobe return light detected",
            0x0009 : "Flash fired, compulsory flash mode",
            0x000D : "Flash fired, compulsory flash mode, return light not detected",
            0x000F : "Flash fired, compulsory flash mode, return light detected",
            0x0010 : "Flash did not fire, compulsory flash mode",
            0x0018 : "Flash did not fire, auto mode",
            0x0019 : "Flash fired, auto mode",
            0x001D : "Flash fired, auto mode, return light not detected",
            0x001F : "Flash fired, auto mode, return light detected",
            0x0020 : "No flash function",
            0x0041 : "Flash fired, red-eye reduction mode",
            0x0045 : "Flash fired, red-eye reduction mode, return light not detected",
            0x0047 : "Flash fired, red-eye reduction mode, return light detected",
            0x0049 : "Flash fired, compulsory flash mode, red-eye reduction mode",
            0x004D : "Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected",
            0x004F : "Flash fired, compulsory flash mode, red-eye reduction mode, return light detected",
            0x0059 : "Flash fired, auto mode, red-eye reduction mode",
            0x005D : "Flash fired, auto mode, return light not detected, red-eye reduction mode",
            0x005F : "Flash fired, auto mode, return light detected, red-eye reduction mode"
        },
        SensingMethod : {
            1 : "Not defined",
            2 : "One-chip color area sensor",
            3 : "Two-chip color area sensor",
            4 : "Three-chip color area sensor",
            5 : "Color sequential area sensor",
            7 : "Trilinear sensor",
            8 : "Color sequential linear sensor"
        },
        SceneCaptureType : {
            0 : "Standard",
            1 : "Landscape",
            2 : "Portrait",
            3 : "Night scene"
        },
        SceneType : {
            1 : "Directly photographed"
        },
        CustomRendered : {
            0 : "Normal process",
            1 : "Custom process"
        },
        WhiteBalance : {
            0 : "Auto white balance",
            1 : "Manual white balance"
        },
        GainControl : {
            0 : "None",
            1 : "Low gain up",
            2 : "High gain up",
            3 : "Low gain down",
            4 : "High gain down"
        },
        Contrast : {
            0 : "Normal",
            1 : "Soft",
            2 : "Hard"
        },
        Saturation : {
            0 : "Normal",
            1 : "Low saturation",
            2 : "High saturation"
        },
        Sharpness : {
            0 : "Normal",
            1 : "Soft",
            2 : "Hard"
        },
        SubjectDistanceRange : {
            0 : "Unknown",
            1 : "Macro",
            2 : "Close view",
            3 : "Distant view"
        },
        FileSource : {
            3 : "DSC"
        },

        Components : {
            0 : "",
            1 : "Y",
            2 : "Cb",
            3 : "Cr",
            4 : "R",
            5 : "G",
            6 : "B"
        }
    };

    function addEvent(element, event, handler) {
        if (element.addEventListener) {
            element.addEventListener(event, handler, false);
        } else if (element.attachEvent) {
            element.attachEvent("on" + event, handler);
        }
    }

    function imageHasData(img) {
        return !!(img.exifdata);
    }


    function base64ToArrayBuffer(base64, contentType) {
        contentType = contentType || base64.match(/^data\:([^\;]+)\;base64,/mi)[1] || ''; // e.g. 'data:image/jpeg;base64,...' => 'image/jpeg'
        base64 = base64.replace(/^data\:([^\;]+)\;base64,/gmi, '');
        var binary = atob(base64);
        var len = binary.length;
        var buffer = new ArrayBuffer(len);
        var view = new Uint8Array(buffer);
        for (var i = 0; i < len; i++) {
            view[i] = binary.charCodeAt(i);
        }
        return buffer;
    }

    function objectURLToBlob(url, callback) {
        var http = new XMLHttpRequest();
        http.open("GET", url, true);
        http.responseType = "blob";
        http.onload = function(e) {
            if (this.status == 200 || this.status === 0) {
                callback(this.response);
            }
        };
        http.send();
    }

    function getImageData(img, callback) {
        function handleBinaryFile(binFile) {
            var data = findEXIFinJPEG(binFile);
            var iptcdata = findIPTCinJPEG(binFile);
            img.exifdata = data || {};
            img.iptcdata = iptcdata || {};
            if (callback) {
                callback.call(img);
            }
        }

        if (img.src) {
            if (/^data\:/i.test(img.src)) { // Data URI
                var arrayBuffer = base64ToArrayBuffer(img.src);
                handleBinaryFile(arrayBuffer);

            } else if (/^blob\:/i.test(img.src)) { // Object URL
                var fileReader = new FileReader();
                fileReader.onload = function(e) {
                    handleBinaryFile(e.target.result);
                };
                objectURLToBlob(img.src, function (blob) {
                    fileReader.readAsArrayBuffer(blob);
                });
            } else {
                var http = new XMLHttpRequest();
                http.onload = function() {
                    if (this.status == 200 || this.status === 0) {
                        handleBinaryFile(http.response);
                    } else {
                        throw "Could not load image";
                    }
                    http = null;
                };
                http.open("GET", img.src, true);
                http.responseType = "arraybuffer";
                http.send(null);
            }
        } else if (window.FileReader && (img instanceof window.Blob || img instanceof window.File)) {
            var fileReader = new FileReader();
            fileReader.onload = function(e) {
                if (debug) console.log("Got file of length " + e.target.result.byteLength);
                handleBinaryFile(e.target.result);
            };

            fileReader.readAsArrayBuffer(img);
        }
    }

    function findEXIFinJPEG(file) {
        var dataView = new DataView(file);

        if (debug) console.log("Got file of length " + file.byteLength);
        if ((dataView.getUint8(0) != 0xFF) || (dataView.getUint8(1) != 0xD8)) {
            if (debug) console.log("Not a valid JPEG");
            return false; // not a valid jpeg
        }

        var offset = 2,
            length = file.byteLength,
            marker;

        while (offset < length) {
            if (dataView.getUint8(offset) != 0xFF) {
                if (debug) console.log("Not a valid marker at offset " + offset + ", found: " + dataView.getUint8(offset));
                return false; // not a valid marker, something is wrong
            }

            marker = dataView.getUint8(offset + 1);
            if (debug) console.log(marker);

            // we could implement handling for other markers here,
            // but we're only looking for 0xFFE1 for EXIF data

            if (marker == 225) {
                if (debug) console.log("Found 0xFFE1 marker");

                return readEXIFData(dataView, offset + 4, dataView.getUint16(offset + 2) - 2);

                // offset += 2 + file.getShortAt(offset+2, true);

            } else {
                offset += 2 + dataView.getUint16(offset+2);
            }

        }

    }

    function findIPTCinJPEG(file) {
        var dataView = new DataView(file);

        if (debug) console.log("Got file of length " + file.byteLength);
        if ((dataView.getUint8(0) != 0xFF) || (dataView.getUint8(1) != 0xD8)) {
            if (debug) console.log("Not a valid JPEG");
            return false; // not a valid jpeg
        }

        var offset = 2,
            length = file.byteLength;


        var isFieldSegmentStart = function(dataView, offset){
            return (
                dataView.getUint8(offset) === 0x38 &&
                dataView.getUint8(offset+1) === 0x42 &&
                dataView.getUint8(offset+2) === 0x49 &&
                dataView.getUint8(offset+3) === 0x4D &&
                dataView.getUint8(offset+4) === 0x04 &&
                dataView.getUint8(offset+5) === 0x04
            );
        };

        while (offset < length) {

            if ( isFieldSegmentStart(dataView, offset )){

                // Get the length of the name header (which is padded to an even number of bytes)
                var nameHeaderLength = dataView.getUint8(offset+7);
                if(nameHeaderLength % 2 !== 0) nameHeaderLength += 1;
                // Check for pre photoshop 6 format
                if(nameHeaderLength === 0) {
                    // Always 4
                    nameHeaderLength = 4;
                }

                var startOffset = offset + 8 + nameHeaderLength;
                var sectionLength = dataView.getUint16(offset + 6 + nameHeaderLength);

                return readIPTCData(file, startOffset, sectionLength);

                break;

            }


            // Not the marker, continue searching
            offset++;

        }

    }
    var IptcFieldMap = {
        0x78 : 'caption',
        0x6E : 'credit',
        0x19 : 'keywords',
        0x37 : 'dateCreated',
        0x50 : 'byline',
        0x55 : 'bylineTitle',
        0x7A : 'captionWriter',
        0x69 : 'headline',
        0x74 : 'copyright',
        0x0F : 'category'
    };
    function readIPTCData(file, startOffset, sectionLength){
        var dataView = new DataView(file);
        var data = {};
        var fieldValue, fieldName, dataSize, segmentType, segmentSize;
        var segmentStartPos = startOffset;
        while(segmentStartPos < startOffset+sectionLength) {
            if(dataView.getUint8(segmentStartPos) === 0x1C && dataView.getUint8(segmentStartPos+1) === 0x02){
                segmentType = dataView.getUint8(segmentStartPos+2);
                if(segmentType in IptcFieldMap) {
                    dataSize = dataView.getInt16(segmentStartPos+3);
                    segmentSize = dataSize + 5;
                    fieldName = IptcFieldMap[segmentType];
                    fieldValue = getStringFromDB(dataView, segmentStartPos+5, dataSize);
                    // Check if we already stored a value with this name
                    if(data.hasOwnProperty(fieldName)) {
                        // Value already stored with this name, create multivalue field
                        if(data[fieldName] instanceof Array) {
                            data[fieldName].push(fieldValue);
                        }
                        else {
                            data[fieldName] = [data[fieldName], fieldValue];
                        }
                    }
                    else {
                        data[fieldName] = fieldValue;
                    }
                }

            }
            segmentStartPos++;
        }
        return data;
    }



    function readTags(file, tiffStart, dirStart, strings, bigEnd) {
        var entries = file.getUint16(dirStart, !bigEnd),
            tags = {},
            entryOffset, tag,
            i;

        for (i=0;i<entries;i++) {
            entryOffset = dirStart + i*12 + 2;
            tag = strings[file.getUint16(entryOffset, !bigEnd)];
            if (!tag && debug) console.log("Unknown tag: " + file.getUint16(entryOffset, !bigEnd));
            tags[tag] = readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd);
        }
        return tags;
    }


    function readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd) {
        var type = file.getUint16(entryOffset+2, !bigEnd),
            numValues = file.getUint32(entryOffset+4, !bigEnd),
            valueOffset = file.getUint32(entryOffset+8, !bigEnd) + tiffStart,
            offset,
            vals, val, n,
            numerator, denominator;

        switch (type) {
            case 1: // byte, 8-bit unsigned int
            case 7: // undefined, 8-bit byte, value depending on field
                if (numValues == 1) {
                    return file.getUint8(entryOffset + 8, !bigEnd);
                } else {
                    offset = numValues > 4 ? valueOffset : (entryOffset + 8);
                    vals = [];
                    for (n=0;n<numValues;n++) {
                        vals[n] = file.getUint8(offset + n);
                    }
                    return vals;
                }

            case 2: // ascii, 8-bit byte
                offset = numValues > 4 ? valueOffset : (entryOffset + 8);
                return getStringFromDB(file, offset, numValues-1);

            case 3: // short, 16 bit int
                if (numValues == 1) {
                    return file.getUint16(entryOffset + 8, !bigEnd);
                } else {
                    offset = numValues > 2 ? valueOffset : (entryOffset + 8);
                    vals = [];
                    for (n=0;n<numValues;n++) {
                        vals[n] = file.getUint16(offset + 2*n, !bigEnd);
                    }
                    return vals;
                }

            case 4: // long, 32 bit int
                if (numValues == 1) {
                    return file.getUint32(entryOffset + 8, !bigEnd);
                } else {
                    vals = [];
                    for (n=0;n<numValues;n++) {
                        vals[n] = file.getUint32(valueOffset + 4*n, !bigEnd);
                    }
                    return vals;
                }

            case 5:    // rational = two long values, first is numerator, second is denominator
                if (numValues == 1) {
                    numerator = file.getUint32(valueOffset, !bigEnd);
                    denominator = file.getUint32(valueOffset+4, !bigEnd);
                    val = new Number(numerator / denominator);
                    val.numerator = numerator;
                    val.denominator = denominator;
                    return val;
                } else {
                    vals = [];
                    for (n=0;n<numValues;n++) {
                        numerator = file.getUint32(valueOffset + 8*n, !bigEnd);
                        denominator = file.getUint32(valueOffset+4 + 8*n, !bigEnd);
                        vals[n] = new Number(numerator / denominator);
                        vals[n].numerator = numerator;
                        vals[n].denominator = denominator;
                    }
                    return vals;
                }

            case 9: // slong, 32 bit signed int
                if (numValues == 1) {
                    return file.getInt32(entryOffset + 8, !bigEnd);
                } else {
                    vals = [];
                    for (n=0;n<numValues;n++) {
                        vals[n] = file.getInt32(valueOffset + 4*n, !bigEnd);
                    }
                    return vals;
                }

            case 10: // signed rational, two slongs, first is numerator, second is denominator
                if (numValues == 1) {
                    return file.getInt32(valueOffset, !bigEnd) / file.getInt32(valueOffset+4, !bigEnd);
                } else {
                    vals = [];
                    for (n=0;n<numValues;n++) {
                        vals[n] = file.getInt32(valueOffset + 8*n, !bigEnd) / file.getInt32(valueOffset+4 + 8*n, !bigEnd);
                    }
                    return vals;
                }
        }
    }

    function getStringFromDB(buffer, start, length) {
        var outstr = "";
        for (n = start; n < start+length; n++) {
            outstr += String.fromCharCode(buffer.getUint8(n));
        }
        return outstr;
    }

    function readEXIFData(file, start) {
        if (getStringFromDB(file, start, 4) != "Exif") {
            if (debug) console.log("Not valid EXIF data! " + getStringFromDB(file, start, 4));
            return false;
        }

        var bigEnd,
            tags, tag,
            exifData, gpsData,
            tiffOffset = start + 6;

        // test for TIFF validity and endianness
        if (file.getUint16(tiffOffset) == 0x4949) {
            bigEnd = false;
        } else if (file.getUint16(tiffOffset) == 0x4D4D) {
            bigEnd = true;
        } else {
            if (debug) console.log("Not valid TIFF data! (no 0x4949 or 0x4D4D)");
            return false;
        }

        if (file.getUint16(tiffOffset+2, !bigEnd) != 0x002A) {
            if (debug) console.log("Not valid TIFF data! (no 0x002A)");
            return false;
        }

        var firstIFDOffset = file.getUint32(tiffOffset+4, !bigEnd);

        if (firstIFDOffset < 0x00000008) {
            if (debug) console.log("Not valid TIFF data! (First offset less than 8)", file.getUint32(tiffOffset+4, !bigEnd));
            return false;
        }

        tags = readTags(file, tiffOffset, tiffOffset + firstIFDOffset, TiffTags, bigEnd);

        if (tags.ExifIFDPointer) {
            exifData = readTags(file, tiffOffset, tiffOffset + tags.ExifIFDPointer, ExifTags, bigEnd);
            for (tag in exifData) {
                switch (tag) {
                    case "LightSource" :
                    case "Flash" :
                    case "MeteringMode" :
                    case "ExposureProgram" :
                    case "SensingMethod" :
                    case "SceneCaptureType" :
                    case "SceneType" :
                    case "CustomRendered" :
                    case "WhiteBalance" :
                    case "GainControl" :
                    case "Contrast" :
                    case "Saturation" :
                    case "Sharpness" :
                    case "SubjectDistanceRange" :
                    case "FileSource" :
                        exifData[tag] = StringValues[tag][exifData[tag]];
                        break;

                    case "ExifVersion" :
                    case "FlashpixVersion" :
                        exifData[tag] = String.fromCharCode(exifData[tag][0], exifData[tag][1], exifData[tag][2], exifData[tag][3]);
                        break;

                    case "ComponentsConfiguration" :
                        exifData[tag] =
                            StringValues.Components[exifData[tag][0]] +
                            StringValues.Components[exifData[tag][1]] +
                            StringValues.Components[exifData[tag][2]] +
                            StringValues.Components[exifData[tag][3]];
                        break;
                }
                tags[tag] = exifData[tag];
            }
        }

        if (tags.GPSInfoIFDPointer) {
            gpsData = readTags(file, tiffOffset, tiffOffset + tags.GPSInfoIFDPointer, GPSTags, bigEnd);
            for (tag in gpsData) {
                switch (tag) {
                    case "GPSVersionID" :
                        gpsData[tag] = gpsData[tag][0] +
                            "." + gpsData[tag][1] +
                            "." + gpsData[tag][2] +
                            "." + gpsData[tag][3];
                        break;
                }
                tags[tag] = gpsData[tag];
            }
        }

        return tags;
    }

    EXIF.getData = function(img, callback) {
        if ((img instanceof Image || img instanceof HTMLImageElement) && !img.complete) return false;

        if (!imageHasData(img)) {
            getImageData(img, callback);
        } else {
            if (callback) {
                callback.call(img);
            }
        }
        return true;
    }

    EXIF.getTag = function(img, tag) {
        if (!imageHasData(img)) return;
        return img.exifdata[tag];
    }

    EXIF.getAllTags = function(img) {
        if (!imageHasData(img)) return {};
        var a,
            data = img.exifdata,
            tags = {};
        for (a in data) {
            if (data.hasOwnProperty(a)) {
                tags[a] = data[a];
            }
        }
        return tags;
    }

    EXIF.pretty = function(img) {
        if (!imageHasData(img)) return "";
        var a,
            data = img.exifdata,
            strPretty = "";
        for (a in data) {
            if (data.hasOwnProperty(a)) {
                if (typeof data[a] == "object") {
                    if (data[a] instanceof Number) {
                        strPretty += a + " : " + data[a] + " [" + data[a].numerator + "/" + data[a].denominator + "]\r\n";
                    } else {
                        strPretty += a + " : [" + data[a].length + " values]\r\n";
                    }
                } else {
                    strPretty += a + " : " + data[a] + "\r\n";
                }
            }
        }
        return strPretty;
    }

    EXIF.readFromBinaryFile = function(file) {
        return findEXIFinJPEG(file);
    }

    if (typeof define === 'function' && define.amd) {
        define('exif-js', [], function() {
            return EXIF;
        });
    }
}.call(this));


(function() {
    'use strict';

    angular
        .module('editorApp')
        .constant('errorConstants', (function() {
            var problemBaseUrl = 'http://www.jhipster.tech/problem';
            return {
                EMAIL_ALREADY_USED_TYPE: problemBaseUrl + '/email-already-used',
                LOGIN_ALREADY_USED_TYPE: problemBaseUrl + '/login-already-used',
                EMAIL_NOT_FOUND_TYPE: problemBaseUrl + '/email-not-found'
            }
        })());
})();

/**
 * @author alteredq / http://alteredqualia.com/
 * @author mr.doob / http://mrdoob.com/
 */

var Detector = {

  canvas: !! window.CanvasRenderingContext2D,
  webgl: ( function () {

    try {

      var canvas = document.createElement( 'canvas' ); return !! ( window.WebGLRenderingContext && ( canvas.getContext( 'webgl' ) || canvas.getContext( 'experimental-webgl' ) ) );

    } catch ( e ) {

      return false;

    }

  } )(),
  workers: !! window.Worker,
  fileapi: window.File && window.FileReader && window.FileList && window.Blob,

  getWebGLErrorMessage: function () {

    var element = document.createElement( 'div' );
    element.id = 'webgl-error-message';
    element.style.fontFamily = 'monospace';
    element.style.fontSize = '13px';
    element.style.fontWeight = 'normal';
    element.style.textAlign = 'center';
    element.style.background = '#fff';
    element.style.color = '#000';
    element.style.padding = '1.5em';
    element.style.width = '400px';
    element.style.margin = '5em auto 0';

    if ( ! this.webgl ) {

      element.innerHTML = window.WebGLRenderingContext ? [
        'Your graphics card does not seem to support <a href="http://khronos.org/webgl/wiki/Getting_a_WebGL_Implementation" style="color:#000">WebGL</a>.<br />',
        'Find out how to get it <a href="http://get.webgl.org/" style="color:#000">here</a>.'
      ].join( '\n' ) : [
        'Your browser does not seem to support <a href="http://khronos.org/webgl/wiki/Getting_a_WebGL_Implementation" style="color:#000">WebGL</a>.<br/>',
        'Find out how to get it <a href="http://get.webgl.org/" style="color:#000">here</a>.'
      ].join( '\n' );

    }

    return element;

  },

  addGetWebGLMessage: function ( parameters ) {

    var parent, id, element;

    parameters = parameters || {};

    parent = parameters.parent !== undefined ? parameters.parent : document.body;
    id = parameters.id !== undefined ? parameters.id : 'oldie';

    element = Detector.getWebGLErrorMessage();
    element.id = id;

    parent.appendChild( element );

  }

};

// browserify support
if ( typeof module === 'object' ) {

  module.exports = Detector;

}

(function() {
    'use strict';

    angular
        .module('editorApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils($filter) {

        var service = {
            convertDateTimeFromServer: convertDateTimeFromServer,
            convertLocalDateFromServer: convertLocalDateFromServer,
            convertLocalDateToServer: convertLocalDateToServer,
            dateformat: dateformat
        };

        return service;

        function convertDateTimeFromServer(date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer(date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat() {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

/**
 * dat-gui JavaScript Controller Library
 * https://github.com/dataarts/dat.gui
 *
 * Copyright 2016 Data Arts Team, Google Creative Lab
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */
!function(e, t) {
    "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.dat = t() : e.dat = t()
}(this, function() {
    return function(e) {
        function t(o) {
            if (n[o])
                return n[o].exports;
            var i = n[o] = {
                exports: {},
                id: o,
                loaded: !1
            };
            return e[o].call(i.exports, i, i.exports, t),
                i.loaded = !0,
                i.exports
        }
        var n = {};
        return t.m = e,
            t.c = n,
            t.p = "",
            t(0)
    }([function(e, t, n) {
        "use strict";
        function o(e) {
            return e && e.__esModule ? e : {
                "default": e
            }
        }
        var i = n(1)
            , r = o(i);
        e.exports = r["default"]
    }
        , function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    "default": e
                }
            }
            t.__esModule = !0;
            var i = n(2)
                , r = o(i)
                , a = n(6)
                , l = o(a)
                , s = n(3)
                , u = o(s)
                , d = n(7)
                , c = o(d)
                , f = n(8)
                , _ = o(f)
                , p = n(10)
                , h = o(p)
                , m = n(11)
                , b = o(m)
                , g = n(12)
                , v = o(g)
                , y = n(13)
                , w = o(y)
                , x = n(14)
                , E = o(x)
                , C = n(15)
                , A = o(C)
                , S = n(16)
                , k = o(S)
                , O = n(9)
                , T = o(O)
                , R = n(17)
                , L = o(R);
            t["default"] = {
                color: {
                    Color: r["default"],
                    math: l["default"],
                    interpret: u["default"]
                },
                controllers: {
                    Controller: c["default"],
                    BooleanController: _["default"],
                    OptionController: h["default"],
                    StringController: b["default"],
                    NumberController: v["default"],
                    NumberControllerBox: w["default"],
                    NumberControllerSlider: E["default"],
                    FunctionController: A["default"],
                    ColorController: k["default"]
                },
                dom: {
                    dom: T["default"]
                },
                gui: {
                    GUI: L["default"]
                },
                GUI: L["default"]
            }
        }
        , function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    "default": e
                }
            }
            function i(e, t) {
                if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function")
            }
            function r(e, t, n) {
                Object.defineProperty(e, t, {
                    get: function() {
                        return "RGB" === this.__state.space ? this.__state[t] : (h.recalculateRGB(this, t, n),
                            this.__state[t])
                    },
                    set: function(e) {
                        "RGB" !== this.__state.space && (h.recalculateRGB(this, t, n),
                            this.__state.space = "RGB"),
                            this.__state[t] = e
                    }
                })
            }
            function a(e, t) {
                Object.defineProperty(e, t, {
                    get: function() {
                        return "HSV" === this.__state.space ? this.__state[t] : (h.recalculateHSV(this),
                            this.__state[t])
                    },
                    set: function(e) {
                        "HSV" !== this.__state.space && (h.recalculateHSV(this),
                            this.__state.space = "HSV"),
                            this.__state[t] = e
                    }
                })
            }
            t.__esModule = !0;
            var l = n(3)
                , s = o(l)
                , u = n(6)
                , d = o(u)
                , c = n(4)
                , f = o(c)
                , _ = n(5)
                , p = o(_)
                , h = function() {
                function e() {
                    if (i(this, e),
                        this.__state = s["default"].apply(this, arguments),
                    this.__state === !1)
                        throw new Error("Failed to interpret color arguments");
                    this.__state.a = this.__state.a || 1
                }
                return e.prototype.toString = function() {
                    return (0,
                        f["default"])(this)
                }
                    ,
                    e.prototype.toHexString = function() {
                        return (0,
                            f["default"])(this, !0)
                    }
                    ,
                    e.prototype.toOriginal = function() {
                        return this.__state.conversion.write(this)
                    }
                    ,
                    e
            }();
            h.recalculateRGB = function(e, t, n) {
                if ("HEX" === e.__state.space)
                    e.__state[t] = d["default"].component_from_hex(e.__state.hex, n);
                else {
                    if ("HSV" !== e.__state.space)
                        throw new Error("Corrupted color state");
                    p["default"].extend(e.__state, d["default"].hsv_to_rgb(e.__state.h, e.__state.s, e.__state.v))
                }
            }
                ,
                h.recalculateHSV = function(e) {
                    var t = d["default"].rgb_to_hsv(e.r, e.g, e.b);
                    p["default"].extend(e.__state, {
                        s: t.s,
                        v: t.v
                    }),
                        p["default"].isNaN(t.h) ? p["default"].isUndefined(e.__state.h) && (e.__state.h = 0) : e.__state.h = t.h
                }
                ,
                h.COMPONENTS = ["r", "g", "b", "h", "s", "v", "hex", "a"],
                r(h.prototype, "r", 2),
                r(h.prototype, "g", 1),
                r(h.prototype, "b", 0),
                a(h.prototype, "h"),
                a(h.prototype, "s"),
                a(h.prototype, "v"),
                Object.defineProperty(h.prototype, "a", {
                    get: function() {
                        return this.__state.a
                    },
                    set: function(e) {
                        this.__state.a = e
                    }
                }),
                Object.defineProperty(h.prototype, "hex", {
                    get: function() {
                        return "HEX" !== !this.__state.space && (this.__state.hex = d["default"].rgb_to_hex(this.r, this.g, this.b)),
                            this.__state.hex
                    },
                    set: function(e) {
                        this.__state.space = "HEX",
                            this.__state.hex = e
                    }
                }),
                t["default"] = h
        }
        , function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    "default": e
                }
            }
            t.__esModule = !0;
            var i = n(4)
                , r = o(i)
                , a = n(5)
                , l = o(a)
                , s = [{
                litmus: l["default"].isString,
                conversions: {
                    THREE_CHAR_HEX: {
                        read: function(e) {
                            var t = e.match(/^#([A-F0-9])([A-F0-9])([A-F0-9])$/i);
                            return null !== t && {
                                space: "HEX",
                                hex: parseInt("0x" + t[1].toString() + t[1].toString() + t[2].toString() + t[2].toString() + t[3].toString() + t[3].toString(), 0)
                            }
                        },
                        write: r["default"]
                    },
                    SIX_CHAR_HEX: {
                        read: function(e) {
                            var t = e.match(/^#([A-F0-9]{6})$/i);
                            return null !== t && {
                                space: "HEX",
                                hex: parseInt("0x" + t[1].toString(), 0)
                            }
                        },
                        write: r["default"]
                    },
                    CSS_RGB: {
                        read: function(e) {
                            var t = e.match(/^rgb\(\s*(.+)\s*,\s*(.+)\s*,\s*(.+)\s*\)/);
                            return null !== t && {
                                space: "RGB",
                                r: parseFloat(t[1]),
                                g: parseFloat(t[2]),
                                b: parseFloat(t[3])
                            }
                        },
                        write: r["default"]
                    },
                    CSS_RGBA: {
                        read: function(e) {
                            var t = e.match(/^rgba\(\s*(.+)\s*,\s*(.+)\s*,\s*(.+)\s*,\s*(.+)\s*\)/);
                            return null !== t && {
                                space: "RGB",
                                r: parseFloat(t[1]),
                                g: parseFloat(t[2]),
                                b: parseFloat(t[3]),
                                a: parseFloat(t[4])
                            }
                        },
                        write: r["default"]
                    }
                }
            }, {
                litmus: l["default"].isNumber,
                conversions: {
                    HEX: {
                        read: function(e) {
                            return {
                                space: "HEX",
                                hex: e,
                                conversionName: "HEX"
                            }
                        },
                        write: function(e) {
                            return e.hex
                        }
                    }
                }
            }, {
                litmus: l["default"].isArray,
                conversions: {
                    RGB_ARRAY: {
                        read: function(e) {
                            return 3 === e.length && {
                                space: "RGB",
                                r: e[0],
                                g: e[1],
                                b: e[2]
                            }
                        },
                        write: function(e) {
                            return [e.r, e.g, e.b]
                        }
                    },
                    RGBA_ARRAY: {
                        read: function(e) {
                            return 4 === e.length && {
                                space: "RGB",
                                r: e[0],
                                g: e[1],
                                b: e[2],
                                a: e[3]
                            }
                        },
                        write: function(e) {
                            return [e.r, e.g, e.b, e.a]
                        }
                    }
                }
            }, {
                litmus: l["default"].isObject,
                conversions: {
                    RGBA_OBJ: {
                        read: function(e) {
                            return !!(l["default"].isNumber(e.r) && l["default"].isNumber(e.g) && l["default"].isNumber(e.b) && l["default"].isNumber(e.a)) && {
                                space: "RGB",
                                r: e.r,
                                g: e.g,
                                b: e.b,
                                a: e.a
                            }
                        },
                        write: function(e) {
                            return {
                                r: e.r,
                                g: e.g,
                                b: e.b,
                                a: e.a
                            }
                        }
                    },
                    RGB_OBJ: {
                        read: function(e) {
                            return !!(l["default"].isNumber(e.r) && l["default"].isNumber(e.g) && l["default"].isNumber(e.b)) && {
                                space: "RGB",
                                r: e.r,
                                g: e.g,
                                b: e.b
                            }
                        },
                        write: function(e) {
                            return {
                                r: e.r,
                                g: e.g,
                                b: e.b
                            }
                        }
                    },
                    HSVA_OBJ: {
                        read: function(e) {
                            return !!(l["default"].isNumber(e.h) && l["default"].isNumber(e.s) && l["default"].isNumber(e.v) && l["default"].isNumber(e.a)) && {
                                space: "HSV",
                                h: e.h,
                                s: e.s,
                                v: e.v,
                                a: e.a
                            }
                        },
                        write: function(e) {
                            return {
                                h: e.h,
                                s: e.s,
                                v: e.v,
                                a: e.a
                            }
                        }
                    },
                    HSV_OBJ: {
                        read: function(e) {
                            return !!(l["default"].isNumber(e.h) && l["default"].isNumber(e.s) && l["default"].isNumber(e.v)) && {
                                space: "HSV",
                                h: e.h,
                                s: e.s,
                                v: e.v
                            }
                        },
                        write: function(e) {
                            return {
                                h: e.h,
                                s: e.s,
                                v: e.v
                            }
                        }
                    }
                }
            }]
                , u = void 0
                , d = void 0
                , c = function() {
                d = !1;
                var e = arguments.length > 1 ? l["default"].toArray(arguments) : arguments[0];
                return l["default"].each(s, function(t) {
                    if (t.litmus(e))
                        return l["default"].each(t.conversions, function(t, n) {
                            if (u = t.read(e),
                            d === !1 && u !== !1)
                                return d = u,
                                    u.conversionName = n,
                                    u.conversion = t,
                                    l["default"].BREAK
                        }),
                            l["default"].BREAK
                }),
                    d
            };
            t["default"] = c
        }
        , function(e, t) {
            "use strict";
            t.__esModule = !0,
                t["default"] = function(e, t) {
                    var n = e.__state.conversionName.toString()
                        , o = Math.round(e.r)
                        , i = Math.round(e.g)
                        , r = Math.round(e.b)
                        , a = e.a
                        , l = Math.round(e.h)
                        , s = e.s.toFixed(1)
                        , u = e.v.toFixed(1);
                    if (t || "THREE_CHAR_HEX" === n || "SIX_CHAR_HEX" === n) {
                        for (var d = e.hex.toString(16); d.length < 6; )
                            d = "0" + d;
                        return "#" + d
                    }
                    return "CSS_RGB" === n ? "rgb(" + o + "," + i + "," + r + ")" : "CSS_RGBA" === n ? "rgba(" + o + "," + i + "," + r + "," + a + ")" : "HEX" === n ? "0x" + e.hex.toString(16) : "RGB_ARRAY" === n ? "[" + o + "," + i + "," + r + "]" : "RGBA_ARRAY" === n ? "[" + o + "," + i + "," + r + "," + a + "]" : "RGB_OBJ" === n ? "{r:" + o + ",g:" + i + ",b:" + r + "}" : "RGBA_OBJ" === n ? "{r:" + o + ",g:" + i + ",b:" + r + ",a:" + a + "}" : "HSV_OBJ" === n ? "{h:" + l + ",s:" + s + ",v:" + u + "}" : "HSVA_OBJ" === n ? "{h:" + l + ",s:" + s + ",v:" + u + ",a:" + a + "}" : "unknown format"
                }
        }
        , function(e, t) {
            "use strict";
            t.__esModule = !0;
            var n = Array.prototype.forEach
                , o = Array.prototype.slice
                , i = {
                BREAK: {},
                extend: function(e) {
                    return this.each(o.call(arguments, 1), function(t) {
                        var n = this.isObject(t) ? Object.keys(t) : [];
                        n.forEach(function(n) {
                            this.isUndefined(t[n]) || (e[n] = t[n])
                        }
                            .bind(this))
                    }, this),
                        e
                },
                defaults: function(e) {
                    return this.each(o.call(arguments, 1), function(t) {
                        var n = this.isObject(t) ? Object.keys(t) : [];
                        n.forEach(function(n) {
                            this.isUndefined(e[n]) && (e[n] = t[n])
                        }
                            .bind(this))
                    }, this),
                        e
                },
                compose: function() {
                    var e = o.call(arguments);
                    return function() {
                        for (var t = o.call(arguments), n = e.length - 1; n >= 0; n--)
                            t = [e[n].apply(this, t)];
                        return t[0]
                    }
                },
                each: function(e, t, o) {
                    if (e)
                        if (n && e.forEach && e.forEach === n)
                            e.forEach(t, o);
                        else if (e.length === e.length + 0) {
                            var i = void 0
                                , r = void 0;
                            for (i = 0,
                                     r = e.length; i < r; i++)
                                if (i in e && t.call(o, e[i], i) === this.BREAK)
                                    return
                        } else
                            for (var a in e)
                                if (t.call(o, e[a], a) === this.BREAK)
                                    return
                },
                defer: function(e) {
                    setTimeout(e, 0)
                },
                debounce: function(e, t) {
                    var n = void 0;
                    return function() {
                        function o() {
                            n = null
                        }
                        var i = this
                            , r = arguments
                            , a = !n;
                        clearTimeout(n),
                            n = setTimeout(o, t),
                        a && e.apply(i, r)
                    }
                },
                toArray: function(e) {
                    return e.toArray ? e.toArray() : o.call(e)
                },
                isUndefined: function(e) {
                    return void 0 === e
                },
                isNull: function(e) {
                    return null === e
                },
                isNaN: function(e) {
                    function t(t) {
                        return e.apply(this, arguments)
                    }
                    return t.toString = function() {
                        return e.toString()
                    }
                        ,
                        t
                }(function(e) {
                    return isNaN(e)
                }),
                isArray: Array.isArray || function(e) {
                    return e.constructor === Array
                }
                ,
                isObject: function(e) {
                    return e === Object(e)
                },
                isNumber: function(e) {
                    return e === e + 0
                },
                isString: function(e) {
                    return e === e + ""
                },
                isBoolean: function(e) {
                    return e === !1 || e === !0
                },
                isFunction: function(e) {
                    return "[object Function]" === Object.prototype.toString.call(e)
                }
            };
            t["default"] = i
        }
        , function(e, t) {
            "use strict";
            t.__esModule = !0;
            var n = void 0
                , o = {
                hsv_to_rgb: function(e, t, n) {
                    var o = Math.floor(e / 60) % 6
                        , i = e / 60 - Math.floor(e / 60)
                        , r = n * (1 - t)
                        , a = n * (1 - i * t)
                        , l = n * (1 - (1 - i) * t)
                        , s = [[n, l, r], [a, n, r], [r, n, l], [r, a, n], [l, r, n], [n, r, a]][o];
                    return {
                        r: 255 * s[0],
                        g: 255 * s[1],
                        b: 255 * s[2]
                    }
                },
                rgb_to_hsv: function(e, t, n) {
                    var o = Math.min(e, t, n)
                        , i = Math.max(e, t, n)
                        , r = i - o
                        , a = void 0
                        , l = void 0;
                    return 0 === i ? {
                        h: NaN,
                        s: 0,
                        v: 0
                    } : (l = r / i,
                        a = e === i ? (t - n) / r : t === i ? 2 + (n - e) / r : 4 + (e - t) / r,
                        a /= 6,
                    a < 0 && (a += 1),
                        {
                            h: 360 * a,
                            s: l,
                            v: i / 255
                        })
                },
                rgb_to_hex: function(e, t, n) {
                    var o = this.hex_with_component(0, 2, e);
                    return o = this.hex_with_component(o, 1, t),
                        o = this.hex_with_component(o, 0, n)
                },
                component_from_hex: function(e, t) {
                    return e >> 8 * t & 255
                },
                hex_with_component: function(e, t, o) {
                    return o << (n = 8 * t) | e & ~(255 << n)
                }
            };
            t["default"] = o
        }
        , function(e, t) {
            "use strict";
            function n(e, t) {
                if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function")
            }
            t.__esModule = !0;
            var o = function() {
                function e(t, o) {
                    n(this, e),
                        this.initialValue = t[o],
                        this.domElement = document.createElement("div"),
                        this.object = t,
                        this.property = o,
                        this.__onChange = void 0,
                        this.__onFinishChange = void 0
                }
                return e.prototype.onChange = function(e) {
                    return this.__onChange = e,
                        this
                }
                    ,
                    e.prototype.onFinishChange = function(e) {
                        return this.__onFinishChange = e,
                            this
                    }
                    ,
                    e.prototype.setValue = function(e) {
                        return this.object[this.property] = e,
                        this.__onChange && this.__onChange.call(this, e),
                            this.updateDisplay(),
                            this
                    }
                    ,
                    e.prototype.getValue = function() {
                        return this.object[this.property]
                    }
                    ,
                    e.prototype.updateDisplay = function() {
                        return this
                    }
                    ,
                    e.prototype.isModified = function() {
                        return this.initialValue !== this.getValue()
                    }
                    ,
                    e
            }();
            t["default"] = o
        }
        , function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    "default": e
                }
            }
            function i(e, t) {
                if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function")
            }
            function r(e, t) {
                if (!e)
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !t || "object" != typeof t && "function" != typeof t ? e : t
            }
            function a(e, t) {
                if ("function" != typeof t && null !== t)
                    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
            }
            t.__esModule = !0;
            var l = n(7)
                , s = o(l)
                , u = n(9)
                , d = o(u)
                , c = function(e) {
                function t(n, o) {
                    function a() {
                        s.setValue(!s.__prev)
                    }
                    i(this, t);
                    var l = r(this, e.call(this, n, o))
                        , s = l;
                    return l.__prev = l.getValue(),
                        l.__checkbox = document.createElement("input"),
                        l.__checkbox.setAttribute("type", "checkbox"),
                        d["default"].bind(l.__checkbox, "change", a, !1),
                        l.domElement.appendChild(l.__checkbox),
                        l.updateDisplay(),
                        l
                }
                return a(t, e),
                    t.prototype.setValue = function(t) {
                        var n = e.prototype.setValue.call(this, t);
                        return this.__onFinishChange && this.__onFinishChange.call(this, this.getValue()),
                            this.__prev = this.getValue(),
                            n
                    }
                    ,
                    t.prototype.updateDisplay = function() {
                        return this.getValue() === !0 ? (this.__checkbox.setAttribute("checked", "checked"),
                            this.__checkbox.checked = !0) : this.__checkbox.checked = !1,
                            e.prototype.updateDisplay.call(this)
                    }
                    ,
                    t
            }(s["default"]);
            t["default"] = c
        }
        , function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    "default": e
                }
            }
            function i(e) {
                if ("0" === e || a["default"].isUndefined(e))
                    return 0;
                var t = e.match(u);
                return a["default"].isNull(t) ? 0 : parseFloat(t[1])
            }
            t.__esModule = !0;
            var r = n(5)
                , a = o(r)
                , l = {
                HTMLEvents: ["change"],
                MouseEvents: ["click", "mousemove", "mousedown", "mouseup", "mouseover"],
                KeyboardEvents: ["keydown"]
            }
                , s = {};
            a["default"].each(l, function(e, t) {
                a["default"].each(e, function(e) {
                    s[e] = t
                })
            });
            var u = /(\d+(\.\d+)?)px/
                , d = {
                makeSelectable: function(e, t) {
                    void 0 !== e && void 0 !== e.style && (e.onselectstart = t ? function() {
                            return !1
                        }
                        : function() {}
                        ,
                        e.style.MozUserSelect = t ? "auto" : "none",
                        e.style.KhtmlUserSelect = t ? "auto" : "none",
                        e.unselectable = t ? "on" : "off")
                },
                makeFullscreen: function(e, t, n) {
                    var o = n
                        , i = t;
                    a["default"].isUndefined(i) && (i = !0),
                    a["default"].isUndefined(o) && (o = !0),
                        e.style.position = "absolute",
                    i && (e.style.left = 0,
                        e.style.right = 0),
                    o && (e.style.top = 0,
                        e.style.bottom = 0)
                },
                fakeEvent: function(e, t, n, o) {
                    var i = n || {}
                        , r = s[t];
                    if (!r)
                        throw new Error("Event type " + t + " not supported.");
                    var l = document.createEvent(r);
                    switch (r) {
                        case "MouseEvents":
                            var u = i.x || i.clientX || 0
                                , d = i.y || i.clientY || 0;
                            l.initMouseEvent(t, i.bubbles || !1, i.cancelable || !0, window, i.clickCount || 1, 0, 0, u, d, !1, !1, !1, !1, 0, null);
                            break;
                        case "KeyboardEvents":
                            var c = l.initKeyboardEvent || l.initKeyEvent;
                            a["default"].defaults(i, {
                                cancelable: !0,
                                ctrlKey: !1,
                                altKey: !1,
                                shiftKey: !1,
                                metaKey: !1,
                                keyCode: void 0,
                                charCode: void 0
                            }),
                                c(t, i.bubbles || !1, i.cancelable, window, i.ctrlKey, i.altKey, i.shiftKey, i.metaKey, i.keyCode, i.charCode);
                            break;
                        default:
                            l.initEvent(t, i.bubbles || !1, i.cancelable || !0)
                    }
                    a["default"].defaults(l, o),
                        e.dispatchEvent(l)
                },
                bind: function(e, t, n, o) {
                    var i = o || !1;
                    return e.addEventListener ? e.addEventListener(t, n, i) : e.attachEvent && e.attachEvent("on" + t, n),
                        d
                },
                unbind: function(e, t, n, o) {
                    var i = o || !1;
                    return e.removeEventListener ? e.removeEventListener(t, n, i) : e.detachEvent && e.detachEvent("on" + t, n),
                        d
                },
                addClass: function(e, t) {
                    if (void 0 === e.className)
                        e.className = t;
                    else if (e.className !== t) {
                        var n = e.className.split(/ +/);
                        n.indexOf(t) === -1 && (n.push(t),
                            e.className = n.join(" ").replace(/^\s+/, "").replace(/\s+$/, ""))
                    }
                    return d
                },
                removeClass: function(e, t) {
                    if (t)
                        if (e.className === t)
                            e.removeAttribute("class");
                        else {
                            var n = e.className.split(/ +/)
                                , o = n.indexOf(t);
                            o !== -1 && (n.splice(o, 1),
                                e.className = n.join(" "))
                        }
                    else
                        e.className = void 0;
                    return d
                },
                hasClass: function(e, t) {
                    return new RegExp("(?:^|\\s+)" + t + "(?:\\s+|$)").test(e.className) || !1
                },
                getWidth: function(e) {
                    var t = getComputedStyle(e);
                    return i(t["border-left-width"]) + i(t["border-right-width"]) + i(t["padding-left"]) + i(t["padding-right"]) + i(t.width)
                },
                getHeight: function(e) {
                    var t = getComputedStyle(e);
                    return i(t["border-top-width"]) + i(t["border-bottom-width"]) + i(t["padding-top"]) + i(t["padding-bottom"]) + i(t.height)
                },
                getOffset: function(e) {
                    var t = e
                        , n = {
                        left: 0,
                        top: 0
                    };
                    if (t.offsetParent)
                        do
                            n.left += t.offsetLeft,
                                n.top += t.offsetTop,
                                t = t.offsetParent;
                        while (t);return n
                },
                isActive: function(e) {
                    return e === document.activeElement && (e.type || e.href)
                }
            };
            t["default"] = d
        }
        , function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    "default": e
                }
            }
            function i(e, t) {
                if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function")
            }
            function r(e, t) {
                if (!e)
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !t || "object" != typeof t && "function" != typeof t ? e : t
            }
            function a(e, t) {
                if ("function" != typeof t && null !== t)
                    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
            }
            t.__esModule = !0;
            var l = n(7)
                , s = o(l)
                , u = n(9)
                , d = o(u)
                , c = n(5)
                , f = o(c)
                , _ = function(e) {
                function t(n, o, a) {
                    i(this, t);
                    var l = r(this, e.call(this, n, o))
                        , s = a
                        , u = l;
                    return l.__select = document.createElement("select"),
                    f["default"].isArray(s) && !function() {
                        var e = {};
                        f["default"].each(s, function(t) {
                            e[t] = t
                        }),
                            s = e
                    }(),
                        f["default"].each(s, function(e, t) {
                            var n = document.createElement("option");
                            n.innerHTML = t,
                                n.setAttribute("value", e),
                                u.__select.appendChild(n)
                        }),
                        l.updateDisplay(),
                        d["default"].bind(l.__select, "change", function() {
                            var e = this.options[this.selectedIndex].value;
                            u.setValue(e)
                        }),
                        l.domElement.appendChild(l.__select),
                        l
                }
                return a(t, e),
                    t.prototype.setValue = function(t) {
                        var n = e.prototype.setValue.call(this, t);
                        return this.__onFinishChange && this.__onFinishChange.call(this, this.getValue()),
                            n
                    }
                    ,
                    t.prototype.updateDisplay = function() {
                        return d["default"].isActive(this.__select) ? this : (this.__select.value = this.getValue(),
                            e.prototype.updateDisplay.call(this))
                    }
                    ,
                    t
            }(s["default"]);
            t["default"] = _
        }
        , function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    "default": e
                }
            }
            function i(e, t) {
                if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function")
            }
            function r(e, t) {
                if (!e)
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !t || "object" != typeof t && "function" != typeof t ? e : t
            }
            function a(e, t) {
                if ("function" != typeof t && null !== t)
                    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
            }
            t.__esModule = !0;
            var l = n(7)
                , s = o(l)
                , u = n(9)
                , d = o(u)
                , c = function(e) {
                function t(n, o) {
                    function a() {
                        u.setValue(u.__input.value)
                    }
                    function l() {
                        u.__onFinishChange && u.__onFinishChange.call(u, u.getValue())
                    }
                    i(this, t);
                    var s = r(this, e.call(this, n, o))
                        , u = s;
                    return s.__input = document.createElement("input"),
                        s.__input.setAttribute("type", "text"),
                        d["default"].bind(s.__input, "keyup", a),
                        d["default"].bind(s.__input, "change", a),
                        d["default"].bind(s.__input, "blur", l),
                        d["default"].bind(s.__input, "keydown", function(e) {
                            13 === e.keyCode && this.blur()
                        }),
                        s.updateDisplay(),
                        s.domElement.appendChild(s.__input),
                        s
                }
                return a(t, e),
                    t.prototype.updateDisplay = function() {
                        return d["default"].isActive(this.__input) || (this.__input.value = this.getValue()),
                            e.prototype.updateDisplay.call(this)
                    }
                    ,
                    t
            }(s["default"]);
            t["default"] = c
        }
        , function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    "default": e
                }
            }
            function i(e, t) {
                if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function")
            }
            function r(e, t) {
                if (!e)
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !t || "object" != typeof t && "function" != typeof t ? e : t
            }
            function a(e, t) {
                if ("function" != typeof t && null !== t)
                    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
            }
            function l(e) {
                var t = e.toString();
                return t.indexOf(".") > -1 ? t.length - t.indexOf(".") - 1 : 0
            }
            t.__esModule = !0;
            var s = n(7)
                , u = o(s)
                , d = n(5)
                , c = o(d)
                , f = function(e) {
                function t(n, o, a) {
                    i(this, t);
                    var s = r(this, e.call(this, n, o))
                        , u = a || {};
                    return s.__min = u.min,
                        s.__max = u.max,
                        s.__step = u.step,
                        c["default"].isUndefined(s.__step) ? 0 === s.initialValue ? s.__impliedStep = 1 : s.__impliedStep = Math.pow(10, Math.floor(Math.log(Math.abs(s.initialValue)) / Math.LN10)) / 10 : s.__impliedStep = s.__step,
                        s.__precision = l(s.__impliedStep),
                        s
                }
                return a(t, e),
                    t.prototype.setValue = function(t) {
                        var n = t;
                        return void 0 !== this.__min && n < this.__min ? n = this.__min : void 0 !== this.__max && n > this.__max && (n = this.__max),
                        void 0 !== this.__step && n % this.__step !== 0 && (n = Math.round(n / this.__step) * this.__step),
                            e.prototype.setValue.call(this, n)
                    }
                    ,
                    t.prototype.min = function(e) {
                        return this.__min = e,
                            this
                    }
                    ,
                    t.prototype.max = function(e) {
                        return this.__max = e,
                            this
                    }
                    ,
                    t.prototype.step = function(e) {
                        return this.__step = e,
                            this.__impliedStep = e,
                            this.__precision = l(e),
                            this
                    }
                    ,
                    t
            }(u["default"]);
            t["default"] = f
        }
        , function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    "default": e
                }
            }
            function i(e, t) {
                if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function")
            }
            function r(e, t) {
                if (!e)
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !t || "object" != typeof t && "function" != typeof t ? e : t
            }
            function a(e, t) {
                if ("function" != typeof t && null !== t)
                    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
            }
            function l(e, t) {
                var n = Math.pow(10, t);
                return Math.round(e * n) / n
            }
            t.__esModule = !0;
            var s = n(12)
                , u = o(s)
                , d = n(9)
                , c = o(d)
                , f = n(5)
                , _ = o(f)
                , p = function(e) {
                function t(n, o, a) {
                    function l() {
                        var e = parseFloat(m.__input.value);
                        _["default"].isNaN(e) || m.setValue(e)
                    }
                    function s() {
                        m.__onFinishChange && m.__onFinishChange.call(m, m.getValue())
                    }
                    function u() {
                        s()
                    }
                    function d(e) {
                        var t = b - e.clientY;
                        m.setValue(m.getValue() + t * m.__impliedStep),
                            b = e.clientY
                    }
                    function f() {
                        c["default"].unbind(window, "mousemove", d),
                            c["default"].unbind(window, "mouseup", f),
                            s()
                    }
                    function p(e) {
                        c["default"].bind(window, "mousemove", d),
                            c["default"].bind(window, "mouseup", f),
                            b = e.clientY
                    }
                    i(this, t);
                    var h = r(this, e.call(this, n, o, a));
                    h.__truncationSuspended = !1;
                    var m = h
                        , b = void 0;
                    return h.__input = document.createElement("input"),
                        h.__input.setAttribute("type", "text"),
                        c["default"].bind(h.__input, "change", l),
                        c["default"].bind(h.__input, "blur", u),
                        c["default"].bind(h.__input, "mousedown", p),
                        c["default"].bind(h.__input, "keydown", function(e) {
                            13 === e.keyCode && (m.__truncationSuspended = !0,
                                this.blur(),
                                m.__truncationSuspended = !1,
                                s())
                        }),
                        h.updateDisplay(),
                        h.domElement.appendChild(h.__input),
                        h
                }
                return a(t, e),
                    t.prototype.updateDisplay = function() {
                        return this.__input.value = this.__truncationSuspended ? this.getValue() : l(this.getValue(), this.__precision),
                            e.prototype.updateDisplay.call(this)
                    }
                    ,
                    t
            }(u["default"]);
            t["default"] = p
        }
        , function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    "default": e
                }
            }
            function i(e, t) {
                if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function")
            }
            function r(e, t) {
                if (!e)
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !t || "object" != typeof t && "function" != typeof t ? e : t
            }
            function a(e, t) {
                if ("function" != typeof t && null !== t)
                    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
            }
            function l(e, t, n, o, i) {
                return o + (i - o) * ((e - t) / (n - t))
            }
            t.__esModule = !0;
            var s = n(12)
                , u = o(s)
                , d = n(9)
                , c = o(d)
                , f = function(e) {
                function t(n, o, a, s, u) {
                    function d(e) {
                        document.activeElement.blur(),
                            c["default"].bind(window, "mousemove", f),
                            c["default"].bind(window, "mouseup", _),
                            f(e)
                    }
                    function f(e) {
                        e.preventDefault();
                        var t = h.__background.getBoundingClientRect();
                        return h.setValue(l(e.clientX, t.left, t.right, h.__min, h.__max)),
                            !1
                    }
                    function _() {
                        c["default"].unbind(window, "mousemove", f),
                            c["default"].unbind(window, "mouseup", _),
                        h.__onFinishChange && h.__onFinishChange.call(h, h.getValue())
                    }
                    i(this, t);
                    var p = r(this, e.call(this, n, o, {
                        min: a,
                        max: s,
                        step: u
                    }))
                        , h = p;
                    return p.__background = document.createElement("div"),
                        p.__foreground = document.createElement("div"),
                        c["default"].bind(p.__background, "mousedown", d),
                        c["default"].addClass(p.__background, "slider"),
                        c["default"].addClass(p.__foreground, "slider-fg"),
                        p.updateDisplay(),
                        p.__background.appendChild(p.__foreground),
                        p.domElement.appendChild(p.__background),
                        p
                }
                return a(t, e),
                    t.prototype.updateDisplay = function() {
                        var t = (this.getValue() - this.__min) / (this.__max - this.__min);
                        return this.__foreground.style.width = 100 * t + "%",
                            e.prototype.updateDisplay.call(this)
                    }
                    ,
                    t
            }(u["default"]);
            t["default"] = f
        }
        , function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    "default": e
                }
            }
            function i(e, t) {
                if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function")
            }
            function r(e, t) {
                if (!e)
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !t || "object" != typeof t && "function" != typeof t ? e : t
            }
            function a(e, t) {
                if ("function" != typeof t && null !== t)
                    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
            }
            t.__esModule = !0;
            var l = n(7)
                , s = o(l)
                , u = n(9)
                , d = o(u)
                , c = function(e) {
                function t(n, o, a) {
                    i(this, t);
                    var l = r(this, e.call(this, n, o))
                        , s = l;
                    return l.__button = document.createElement("div"),
                        l.__button.innerHTML = void 0 === a ? "Fire" : a,
                        d["default"].bind(l.__button, "click", function(e) {
                            return e.preventDefault(),
                                s.fire(),
                                !1
                        }),
                        d["default"].addClass(l.__button, "button"),
                        l.domElement.appendChild(l.__button),
                        l
                }
                return a(t, e),
                    t.prototype.fire = function() {
                        this.__onChange && this.__onChange.call(this),
                            this.getValue().call(this.object),
                        this.__onFinishChange && this.__onFinishChange.call(this, this.getValue())
                    }
                    ,
                    t
            }(s["default"]);
            t["default"] = c
        }
        , function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    "default": e
                }
            }
            function i(e, t) {
                if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function")
            }
            function r(e, t) {
                if (!e)
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !t || "object" != typeof t && "function" != typeof t ? e : t
            }
            function a(e, t) {
                if ("function" != typeof t && null !== t)
                    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }),
                t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
            }
            function l(e, t, n, o) {
                e.style.background = "",
                    g["default"].each(y, function(i) {
                        e.style.cssText += "background: " + i + "linear-gradient(" + t + ", " + n + " 0%, " + o + " 100%); "
                    })
            }
            function s(e) {
                e.style.background = "",
                    e.style.cssText += "background: -moz-linear-gradient(top,  #ff0000 0%, #ff00ff 17%, #0000ff 34%, #00ffff 50%, #00ff00 67%, #ffff00 84%, #ff0000 100%);",
                    e.style.cssText += "background: -webkit-linear-gradient(top,  #ff0000 0%,#ff00ff 17%,#0000ff 34%,#00ffff 50%,#00ff00 67%,#ffff00 84%,#ff0000 100%);",
                    e.style.cssText += "background: -o-linear-gradient(top,  #ff0000 0%,#ff00ff 17%,#0000ff 34%,#00ffff 50%,#00ff00 67%,#ffff00 84%,#ff0000 100%);",
                    e.style.cssText += "background: -ms-linear-gradient(top,  #ff0000 0%,#ff00ff 17%,#0000ff 34%,#00ffff 50%,#00ff00 67%,#ffff00 84%,#ff0000 100%);",
                    e.style.cssText += "background: linear-gradient(top,  #ff0000 0%,#ff00ff 17%,#0000ff 34%,#00ffff 50%,#00ff00 67%,#ffff00 84%,#ff0000 100%);"
            }
            t.__esModule = !0;
            var u = n(7)
                , d = o(u)
                , c = n(9)
                , f = o(c)
                , _ = n(2)
                , p = o(_)
                , h = n(3)
                , m = o(h)
                , b = n(5)
                , g = o(b)
                , v = function(e) {
                function t(n, o) {
                    function a(e) {
                        h(e),
                            f["default"].bind(window, "mousemove", h),
                            f["default"].bind(window, "mouseup", u)
                    }
                    function u() {
                        f["default"].unbind(window, "mousemove", h),
                            f["default"].unbind(window, "mouseup", u),
                            _()
                    }
                    function d() {
                        var e = (0,
                            m["default"])(this.value);
                        e !== !1 ? (y.__color.__state = e,
                            y.setValue(y.__color.toOriginal())) : this.value = y.__color.toString()
                    }
                    function c() {
                        f["default"].unbind(window, "mousemove", b),
                            f["default"].unbind(window, "mouseup", c),
                            _()
                    }
                    function _() {
                        y.__onFinishChange && y.__onFinishChange.call(y, y.__color.toOriginal())
                    }
                    function h(e) {
                        e.preventDefault();
                        var t = y.__saturation_field.getBoundingClientRect()
                            , n = (e.clientX - t.left) / (t.right - t.left)
                            , o = 1 - (e.clientY - t.top) / (t.bottom - t.top);
                        return o > 1 ? o = 1 : o < 0 && (o = 0),
                            n > 1 ? n = 1 : n < 0 && (n = 0),
                            y.__color.v = o,
                            y.__color.s = n,
                            y.setValue(y.__color.toOriginal()),
                            !1
                    }
                    function b(e) {
                        e.preventDefault();
                        var t = y.__hue_field.getBoundingClientRect()
                            , n = 1 - (e.clientY - t.top) / (t.bottom - t.top);
                        return n > 1 ? n = 1 : n < 0 && (n = 0),
                            y.__color.h = 360 * n,
                            y.setValue(y.__color.toOriginal()),
                            !1
                    }
                    i(this, t);
                    var v = r(this, e.call(this, n, o));
                    v.__color = new p["default"](v.getValue()),
                        v.__temp = new p["default"](0);
                    var y = v;
                    v.domElement = document.createElement("div"),
                        f["default"].makeSelectable(v.domElement, !1),
                        v.__selector = document.createElement("div"),
                        v.__selector.className = "selector",
                        v.__saturation_field = document.createElement("div"),
                        v.__saturation_field.className = "saturation-field",
                        v.__field_knob = document.createElement("div"),
                        v.__field_knob.className = "field-knob",
                        v.__field_knob_border = "2px solid ",
                        v.__hue_knob = document.createElement("div"),
                        v.__hue_knob.className = "hue-knob",
                        v.__hue_field = document.createElement("div"),
                        v.__hue_field.className = "hue-field",
                        v.__input = document.createElement("input"),
                        v.__input.type = "text",
                        v.__input_textShadow = "0 1px 1px ",
                        f["default"].bind(v.__input, "keydown", function(e) {
                            13 === e.keyCode && d.call(this)
                        }),
                        f["default"].bind(v.__input, "blur", d),
                        f["default"].bind(v.__selector, "mousedown", function() {
                            f["default"].addClass(this, "drag").bind(window, "mouseup", function() {
                                f["default"].removeClass(y.__selector, "drag")
                            })
                        });
                    var w = document.createElement("div");
                    return g["default"].extend(v.__selector.style, {
                        width: "122px",
                        height: "102px",
                        padding: "3px",
                        backgroundColor: "#222",
                        boxShadow: "0px 1px 3px rgba(0,0,0,0.3)"
                    }),
                        g["default"].extend(v.__field_knob.style, {
                            position: "absolute",
                            width: "12px",
                            height: "12px",
                            border: v.__field_knob_border + (v.__color.v < .5 ? "#fff" : "#000"),
                            boxShadow: "0px 1px 3px rgba(0,0,0,0.5)",
                            borderRadius: "12px",
                            zIndex: 1
                        }),
                        g["default"].extend(v.__hue_knob.style, {
                            position: "absolute",
                            width: "15px",
                            height: "2px",
                            borderRight: "4px solid #fff",
                            zIndex: 1
                        }),
                        g["default"].extend(v.__saturation_field.style, {
                            width: "100px",
                            height: "100px",
                            border: "1px solid #555",
                            marginRight: "3px",
                            display: "inline-block",
                            cursor: "pointer"
                        }),
                        g["default"].extend(w.style, {
                            width: "100%",
                            height: "100%",
                            background: "none"
                        }),
                        l(w, "top", "rgba(0,0,0,0)", "#000"),
                        g["default"].extend(v.__hue_field.style, {
                            width: "15px",
                            height: "100px",
                            border: "1px solid #555",
                            cursor: "ns-resize",
                            position: "absolute",
                            top: "3px",
                            right: "3px"
                        }),
                        s(v.__hue_field),
                        g["default"].extend(v.__input.style, {
                            outline: "none",
                            textAlign: "center",
                            color: "#fff",
                            border: 0,
                            fontWeight: "bold",
                            textShadow: v.__input_textShadow + "rgba(0,0,0,0.7)"
                        }),
                        f["default"].bind(v.__saturation_field, "mousedown", a),
                        f["default"].bind(v.__field_knob, "mousedown", a),
                        f["default"].bind(v.__hue_field, "mousedown", function(e) {
                            b(e),
                                f["default"].bind(window, "mousemove", b),
                                f["default"].bind(window, "mouseup", c)
                        }),
                        v.__saturation_field.appendChild(w),
                        v.__selector.appendChild(v.__field_knob),
                        v.__selector.appendChild(v.__saturation_field),
                        v.__selector.appendChild(v.__hue_field),
                        v.__hue_field.appendChild(v.__hue_knob),
                        v.domElement.appendChild(v.__input),
                        v.domElement.appendChild(v.__selector),
                        v.updateDisplay(),
                        v
                }
                return a(t, e),
                    t.prototype.updateDisplay = function() {
                        var e = (0,
                            m["default"])(this.getValue());
                        if (e !== !1) {
                            var t = !1;
                            g["default"].each(p["default"].COMPONENTS, function(n) {
                                if (!g["default"].isUndefined(e[n]) && !g["default"].isUndefined(this.__color.__state[n]) && e[n] !== this.__color.__state[n])
                                    return t = !0,
                                        {}
                            }, this),
                            t && g["default"].extend(this.__color.__state, e)
                        }
                        g["default"].extend(this.__temp.__state, this.__color.__state),
                            this.__temp.a = 1;
                        var n = this.__color.v < .5 || this.__color.s > .5 ? 255 : 0
                            , o = 255 - n;
                        g["default"].extend(this.__field_knob.style, {
                            marginLeft: 100 * this.__color.s - 7 + "px",
                            marginTop: 100 * (1 - this.__color.v) - 7 + "px",
                            backgroundColor: this.__temp.toHexString(),
                            border: this.__field_knob_border + "rgb(" + n + "," + n + "," + n + ")"
                        }),
                            this.__hue_knob.style.marginTop = 100 * (1 - this.__color.h / 360) + "px",
                            this.__temp.s = 1,
                            this.__temp.v = 1,
                            l(this.__saturation_field, "left", "#fff", this.__temp.toHexString()),
                            this.__input.value = this.__color.toString(),
                            g["default"].extend(this.__input.style, {
                                backgroundColor: this.__color.toHexString(),
                                color: "rgb(" + n + "," + n + "," + n + ")",
                                textShadow: this.__input_textShadow + "rgba(" + o + "," + o + "," + o + ",.7)"
                            })
                    }
                    ,
                    t
            }(d["default"])
                , y = ["-moz-", "-o-", "-webkit-", "-ms-", ""];
            t["default"] = v
        }
        , function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    "default": e
                }
            }
            function i(e, t, n) {
                var o = document.createElement("li");
                return t && o.appendChild(t),
                    n ? e.__ul.insertBefore(o, n) : e.__ul.appendChild(o),
                    e.onResize(),
                    o
            }
            function r(e, t) {
                var n = e.__preset_select[e.__preset_select.selectedIndex];
                t ? n.innerHTML = n.value + "*" : n.innerHTML = n.value
            }
            function a(e, t, n) {
                if (n.__li = t,
                    n.__gui = e,
                    U["default"].extend(n, {
                        options: function(t) {
                            if (arguments.length > 1) {
                                var o = n.__li.nextElementSibling;
                                return n.remove(),
                                    s(e, n.object, n.property, {
                                        before: o,
                                        factoryArgs: [U["default"].toArray(arguments)]
                                    })
                            }
                            if (U["default"].isArray(t) || U["default"].isObject(t)) {
                                var i = n.__li.nextElementSibling;
                                return n.remove(),
                                    s(e, n.object, n.property, {
                                        before: i,
                                        factoryArgs: [t]
                                    })
                            }
                        },
                        name: function(e) {
                            return n.__li.firstElementChild.firstElementChild.innerHTML = e,
                                n
                        },
                        listen: function() {
                            return n.__gui.listen(n),
                                n
                        },
                        remove: function() {
                            return n.__gui.remove(n),
                                n
                        }
                    }),
                n instanceof B["default"])
                    !function() {
                        var e = new N["default"](n.object,n.property,{
                            min: n.__min,
                            max: n.__max,
                            step: n.__step
                        });
                        U["default"].each(["updateDisplay", "onChange", "onFinishChange", "step"], function(t) {
                            var o = n[t]
                                , i = e[t];
                            n[t] = e[t] = function() {
                                var t = Array.prototype.slice.call(arguments);
                                return i.apply(e, t),
                                    o.apply(n, t)
                            }
                        }),
                            z["default"].addClass(t, "has-slider"),
                            n.domElement.insertBefore(e.domElement, n.domElement.firstElementChild)
                    }();
                else if (n instanceof N["default"]) {
                    var o = function(t) {
                        if (U["default"].isNumber(n.__min) && U["default"].isNumber(n.__max)) {
                            var o = n.__li.firstElementChild.firstElementChild.innerHTML
                                , i = n.__gui.__listening.indexOf(n) > -1;
                            n.remove();
                            var r = s(e, n.object, n.property, {
                                before: n.__li.nextElementSibling,
                                factoryArgs: [n.__min, n.__max, n.__step]
                            });
                            return r.name(o),
                            i && r.listen(),
                                r
                        }
                        return t
                    };
                    n.min = U["default"].compose(o, n.min),
                        n.max = U["default"].compose(o, n.max)
                } else
                    n instanceof O["default"] ? (z["default"].bind(t, "click", function() {
                        z["default"].fakeEvent(n.__checkbox, "click")
                    }),
                        z["default"].bind(n.__checkbox, "click", function(e) {
                            e.stopPropagation()
                        })) : n instanceof R["default"] ? (z["default"].bind(t, "click", function() {
                        z["default"].fakeEvent(n.__button, "click")
                    }),
                        z["default"].bind(t, "mouseover", function() {
                            z["default"].addClass(n.__button, "hover")
                        }),
                        z["default"].bind(t, "mouseout", function() {
                            z["default"].removeClass(n.__button, "hover")
                        })) : n instanceof j["default"] && (z["default"].addClass(t, "color"),
                        n.updateDisplay = U["default"].compose(function(e) {
                            return t.style.borderLeftColor = n.__color.toString(),
                                e
                        }, n.updateDisplay),
                        n.updateDisplay());
                n.setValue = U["default"].compose(function(t) {
                    return e.getRoot().__preset_select && n.isModified() && r(e.getRoot(), !0),
                        t
                }, n.setValue)
            }
            function l(e, t) {
                var n = e.getRoot()
                    , o = n.__rememberedObjects.indexOf(t.object);
                if (o !== -1) {
                    var i = n.__rememberedObjectIndecesToControllers[o];
                    if (void 0 === i && (i = {},
                        n.__rememberedObjectIndecesToControllers[o] = i),
                        i[t.property] = t,
                    n.load && n.load.remembered) {
                        var r = n.load.remembered
                            , a = void 0;
                        if (r[e.preset])
                            a = r[e.preset];
                        else {
                            if (!r[Q])
                                return;
                            a = r[Q]
                        }
                        if (a[o] && void 0 !== a[o][t.property]) {
                            var l = a[o][t.property];
                            t.initialValue = l,
                                t.setValue(l)
                        }
                    }
                }
            }
            function s(e, t, n, o) {
                if (void 0 === t[n])
                    throw new Error('Object "' + t + '" has no property "' + n + '"');
                var r = void 0;
                if (o.color)
                    r = new j["default"](t,n);
                else {
                    var s = [t, n].concat(o.factoryArgs);
                    r = C["default"].apply(e, s)
                }
                o.before instanceof S["default"] && (o.before = o.before.__li),
                    l(e, r),
                    z["default"].addClass(r.domElement, "c");
                var u = document.createElement("span");
                z["default"].addClass(u, "property-name"),
                    u.innerHTML = r.property;
                var d = document.createElement("div");
                d.appendChild(u),
                    d.appendChild(r.domElement);
                var c = i(e, d, o.before);
                return z["default"].addClass(c, oe.CLASS_CONTROLLER_ROW),
                    r instanceof j["default"] ? z["default"].addClass(c, "color") : z["default"].addClass(c, g(r.getValue())),
                    a(e, c, r),
                    e.__controllers.push(r),
                    r
            }
            function u(e, t) {
                return document.location.href + "." + t
            }
            function d(e, t, n) {
                var o = document.createElement("option");
                o.innerHTML = t,
                    o.value = t,
                    e.__preset_select.appendChild(o),
                n && (e.__preset_select.selectedIndex = e.__preset_select.length - 1)
            }
            function c(e, t) {
                t.style.display = e.useLocalStorage ? "block" : "none"
            }
            function f(e) {
                var t = e.__save_row = document.createElement("li");
                z["default"].addClass(e.domElement, "has-save"),
                    e.__ul.insertBefore(t, e.__ul.firstChild),
                    z["default"].addClass(t, "save-row");
                var n = document.createElement("span");
                n.innerHTML = "&nbsp;",
                    z["default"].addClass(n, "button gears");
                var o = document.createElement("span");
                o.innerHTML = "Save",
                    z["default"].addClass(o, "button"),
                    z["default"].addClass(o, "save");
                var i = document.createElement("span");
                i.innerHTML = "New",
                    z["default"].addClass(i, "button"),
                    z["default"].addClass(i, "save-as");
                var r = document.createElement("span");
                r.innerHTML = "Revert",
                    z["default"].addClass(r, "button"),
                    z["default"].addClass(r, "revert");
                var a = e.__preset_select = document.createElement("select");
                e.load && e.load.remembered ? U["default"].each(e.load.remembered, function(t, n) {
                    d(e, n, n === e.preset)
                }) : d(e, Q, !1),
                    z["default"].bind(a, "change", function() {
                        for (var t = 0; t < e.__preset_select.length; t++)
                            e.__preset_select[t].innerHTML = e.__preset_select[t].value;
                        e.preset = this.value
                    }),
                    t.appendChild(a),
                    t.appendChild(n),
                    t.appendChild(o),
                    t.appendChild(i),
                    t.appendChild(r),
                q && !function() {
                    var t = document.getElementById("dg-local-explain")
                        , n = document.getElementById("dg-local-storage")
                        , o = document.getElementById("dg-save-locally");
                    o.style.display = "block",
                    "true" === localStorage.getItem(u(e, "isLocal")) && n.setAttribute("checked", "checked"),
                        c(e, t),
                        z["default"].bind(n, "change", function() {
                            e.useLocalStorage = !e.useLocalStorage,
                                c(e, t)
                        })
                }();
                var l = document.getElementById("dg-new-constructor");
                z["default"].bind(l, "keydown", function(e) {
                    !e.metaKey || 67 !== e.which && 67 !== e.keyCode || Z.hide()
                }),
                    z["default"].bind(n, "click", function() {
                        l.innerHTML = JSON.stringify(e.getSaveObject(), void 0, 2),
                            Z.show(),
                            l.focus(),
                            l.select()
                    }),
                    z["default"].bind(o, "click", function() {
                        e.save()
                    }),
                    z["default"].bind(i, "click", function() {
                        var t = prompt("Enter a new preset name.");
                        t && e.saveAs(t)
                    }),
                    z["default"].bind(r, "click", function() {
                        e.revert()
                    })
            }
            function _(e) {
                function t(t) {
                    return t.preventDefault(),
                        e.width += i - t.clientX,
                        e.onResize(),
                        i = t.clientX,
                        !1
                }
                function n() {
                    z["default"].removeClass(e.__closeButton, oe.CLASS_DRAG),
                        z["default"].unbind(window, "mousemove", t),
                        z["default"].unbind(window, "mouseup", n)
                }
                function o(o) {
                    return o.preventDefault(),
                        i = o.clientX,
                        z["default"].addClass(e.__closeButton, oe.CLASS_DRAG),
                        z["default"].bind(window, "mousemove", t),
                        z["default"].bind(window, "mouseup", n),
                        !1
                }
                var i = void 0;
                e.__resize_handle = document.createElement("div"),
                    U["default"].extend(e.__resize_handle.style, {
                        width: "6px",
                        marginLeft: "-3px",
                        height: "200px",
                        cursor: "ew-resize",
                        position: "absolute"
                    }),
                    z["default"].bind(e.__resize_handle, "mousedown", o),
                    z["default"].bind(e.__closeButton, "mousedown", o),
                    e.domElement.insertBefore(e.__resize_handle, e.domElement.firstElementChild)
            }
            function p(e, t) {
                e.domElement.style.width = t + "px",
                e.__save_row && e.autoPlace && (e.__save_row.style.width = t + "px"),
                e.__closeButton && (e.__closeButton.style.width = t + "px")
            }
            function h(e, t) {
                var n = {};
                return U["default"].each(e.__rememberedObjects, function(o, i) {
                    var r = {}
                        , a = e.__rememberedObjectIndecesToControllers[i];
                    U["default"].each(a, function(e, n) {
                        r[n] = t ? e.initialValue : e.getValue()
                    }),
                        n[i] = r
                }),
                    n
            }
            function m(e) {
                for (var t = 0; t < e.__preset_select.length; t++)
                    e.__preset_select[t].value === e.preset && (e.__preset_select.selectedIndex = t)
            }
            function b(e) {
                0 !== e.length && D["default"].call(window, function() {
                    b(e)
                }),
                    U["default"].each(e, function(e) {
                        e.updateDisplay()
                    })
            }
            var g = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e
                }
                : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e
                }
                , v = n(18)
                , y = o(v)
                , w = n(19)
                , x = o(w)
                , E = n(20)
                , C = o(E)
                , A = n(7)
                , S = o(A)
                , k = n(8)
                , O = o(k)
                , T = n(15)
                , R = o(T)
                , L = n(13)
                , N = o(L)
                , M = n(14)
                , B = o(M)
                , H = n(16)
                , j = o(H)
                , P = n(21)
                , D = o(P)
                , V = n(22)
                , F = o(V)
                , I = n(9)
                , z = o(I)
                , G = n(5)
                , U = o(G)
                , X = n(23)
                , K = o(X);
            y["default"].inject(K["default"]);
            var Y = "dg"
                , J = 72
                , W = 20
                , Q = "Default"
                , q = function() {
                try {
                    return "localStorage"in window && null !== window.localStorage
                } catch (e) {
                    return !1
                }
            }()
                , Z = void 0
                , $ = !0
                , ee = void 0
                , te = !1
                , ne = []
                , oe = function ie(e) {
                function t() {
                    var e = n.getRoot();
                    e.width += 1,
                        U["default"].defer(function() {
                            e.width -= 1
                        })
                }
                var n = this
                    , o = e || {};
                this.domElement = document.createElement("div"),
                    this.__ul = document.createElement("ul"),
                    this.domElement.appendChild(this.__ul),
                    z["default"].addClass(this.domElement, Y),
                    this.__folders = {},
                    this.__controllers = [],
                    this.__rememberedObjects = [],
                    this.__rememberedObjectIndecesToControllers = [],
                    this.__listening = [],
                    o = U["default"].defaults(o, {
                        autoPlace: !0,
                        width: ie.DEFAULT_WIDTH
                    }),
                    o = U["default"].defaults(o, {
                        resizable: o.autoPlace,
                        hideable: o.autoPlace
                    }),
                    U["default"].isUndefined(o.load) ? o.load = {
                        preset: Q
                    } : o.preset && (o.load.preset = o.preset),
                U["default"].isUndefined(o.parent) && o.hideable && ne.push(this),
                    o.resizable = U["default"].isUndefined(o.parent) && o.resizable,
                o.autoPlace && U["default"].isUndefined(o.scrollable) && (o.scrollable = !0);
                var r = q && "true" === localStorage.getItem(u(this, "isLocal"))
                    , a = void 0;
                if (Object.defineProperties(this, {
                    parent: {
                        get: function() {
                            return o.parent
                        }
                    },
                    scrollable: {
                        get: function() {
                            return o.scrollable
                        }
                    },
                    autoPlace: {
                        get: function() {
                            return o.autoPlace
                        }
                    },
                    preset: {
                        get: function() {
                            return n.parent ? n.getRoot().preset : o.load.preset
                        },
                        set: function(e) {
                            n.parent ? n.getRoot().preset = e : o.load.preset = e,
                                m(this),
                                n.revert()
                        }
                    },
                    width: {
                        get: function() {
                            return o.width
                        },
                        set: function(e) {
                            o.width = e,
                                p(n, e)
                        }
                    },
                    name: {
                        get: function() {
                            return o.name
                        },
                        set: function(e) {
                            o.name = e,
                            titleRowName && (titleRowName.innerHTML = o.name)
                        }
                    },
                    closed: {
                        get: function() {
                            return o.closed
                        },
                        set: function(e) {
                            o.closed = e,
                                o.closed ? z["default"].addClass(n.__ul, ie.CLASS_CLOSED) : z["default"].removeClass(n.__ul, ie.CLASS_CLOSED),
                                this.onResize(),
                            n.__closeButton && (n.__closeButton.innerHTML = e ? ie.TEXT_OPEN : ie.TEXT_CLOSED)
                        }
                    },
                    load: {
                        get: function() {
                            return o.load
                        }
                    },
                    useLocalStorage: {
                        get: function() {
                            return r
                        },
                        set: function(e) {
                            q && (r = e,
                                e ? z["default"].bind(window, "unload", a) : z["default"].unbind(window, "unload", a),
                                localStorage.setItem(u(n, "isLocal"), e))
                        }
                    }
                }),
                    U["default"].isUndefined(o.parent)) {
                    if (o.closed = !1,
                        z["default"].addClass(this.domElement, ie.CLASS_MAIN),
                        z["default"].makeSelectable(this.domElement, !1),
                    q && r) {
                        n.useLocalStorage = !0;
                        var l = localStorage.getItem(u(this, "gui"));
                        l && (o.load = JSON.parse(l))
                    }
                    this.__closeButton = document.createElement("div"),
                        this.__closeButton.innerHTML = ie.TEXT_CLOSED,
                        z["default"].addClass(this.__closeButton, ie.CLASS_CLOSE_BUTTON),
                        this.domElement.appendChild(this.__closeButton),
                        z["default"].bind(this.__closeButton, "click", function() {
                            n.closed = !n.closed
                        })
                } else {
                    void 0 === o.closed && (o.closed = !0);
                    var s = document.createTextNode(o.name);
                    z["default"].addClass(s, "controller-name");
                    var d = i(n, s)
                        , c = function(e) {
                        return e.preventDefault(),
                            n.closed = !n.closed,
                            !1
                    };
                    z["default"].addClass(this.__ul, ie.CLASS_CLOSED),
                        z["default"].addClass(d, "title"),
                        z["default"].bind(d, "click", c),
                    o.closed || (this.closed = !1)
                }
                o.autoPlace && (U["default"].isUndefined(o.parent) && ($ && (ee = document.createElement("div"),
                    z["default"].addClass(ee, Y),
                    z["default"].addClass(ee, ie.CLASS_AUTO_PLACE_CONTAINER),
                    document.body.appendChild(ee),
                    $ = !1),
                    ee.appendChild(this.domElement),
                    z["default"].addClass(this.domElement, ie.CLASS_AUTO_PLACE)),
                this.parent || p(n, o.width)),
                    this.__resizeHandler = function() {
                        n.onResizeDebounced()
                    }
                    ,
                    z["default"].bind(window, "resize", this.__resizeHandler),
                    z["default"].bind(this.__ul, "webkitTransitionEnd", this.__resizeHandler),
                    z["default"].bind(this.__ul, "transitionend", this.__resizeHandler),
                    z["default"].bind(this.__ul, "oTransitionEnd", this.__resizeHandler),
                    this.onResize(),
                o.resizable && _(this),
                    a = function() {
                        q && "true" === localStorage.getItem(u(n, "isLocal")) && localStorage.setItem(u(n, "gui"), JSON.stringify(n.getSaveObject()))
                    }
                    ,
                    this.saveToLocalStorageIfPossible = a,
                o.parent || t()
            };
            oe.toggleHide = function() {
                te = !te,
                    U["default"].each(ne, function(e) {
                        e.domElement.style.display = te ? "none" : ""
                    })
            }
                ,
                oe.CLASS_AUTO_PLACE = "a",
                oe.CLASS_AUTO_PLACE_CONTAINER = "ac",
                oe.CLASS_MAIN = "main",
                oe.CLASS_CONTROLLER_ROW = "cr",
                oe.CLASS_TOO_TALL = "taller-than-window",
                oe.CLASS_CLOSED = "closed",
                oe.CLASS_CLOSE_BUTTON = "close-button",
                oe.CLASS_DRAG = "drag",
                oe.DEFAULT_WIDTH = 245,
                oe.TEXT_CLOSED = "Close Controls",
                oe.TEXT_OPEN = "Open Controls",
                oe._keydownHandler = function(e) {
                    "text" === document.activeElement.type || e.which !== J && e.keyCode !== J || oe.toggleHide()
                }
                ,
                z["default"].bind(window, "keydown", oe._keydownHandler, !1),
                U["default"].extend(oe.prototype, {
                    add: function(e, t) {
                        return s(this, e, t, {
                            factoryArgs: Array.prototype.slice.call(arguments, 2)
                        })
                    },
                    addColor: function(e, t) {
                        return s(this, e, t, {
                            color: !0
                        })
                    },
                    remove: function(e) {
                        this.__ul.removeChild(e.__li),
                            this.__controllers.splice(this.__controllers.indexOf(e), 1);
                        var t = this;
                        U["default"].defer(function() {
                            t.onResize()
                        })
                    },
                    destroy: function() {
                        this.autoPlace && ee.removeChild(this.domElement),
                            z["default"].unbind(window, "keydown", oe._keydownHandler, !1),
                            z["default"].unbind(window, "resize", this.__resizeHandler),
                        this.saveToLocalStorageIfPossible && z["default"].unbind(window, "unload", this.saveToLocalStorageIfPossible)
                    },
                    addFolder: function(e) {
                        if (void 0 !== this.__folders[e])
                            throw new Error('You already have a folder in this GUI by the name "' + e + '"');
                        var t = {
                            name: e,
                            parent: this
                        };
                        t.autoPlace = this.autoPlace,
                        this.load && this.load.folders && this.load.folders[e] && (t.closed = this.load.folders[e].closed,
                            t.load = this.load.folders[e]);
                        var n = new oe(t);
                        this.__folders[e] = n;
                        var o = i(this, n.domElement);
                        return z["default"].addClass(o, "folder"),
                            n
                    },
                    open: function() {
                        this.closed = !1
                    },
                    close: function() {
                        this.closed = !0
                    },
                    onResize: function() {
                        var e = this.getRoot();
                        if (e.scrollable) {
                            var t = z["default"].getOffset(e.__ul).top
                                , n = 0;
                            U["default"].each(e.__ul.childNodes, function(t) {
                                e.autoPlace && t === e.__save_row || (n += z["default"].getHeight(t))
                            }),
                                window.innerHeight - t - W < n ? (z["default"].addClass(e.domElement, oe.CLASS_TOO_TALL),
                                    e.__ul.style.height = window.innerHeight - t - W + "px") : (z["default"].removeClass(e.domElement, oe.CLASS_TOO_TALL),
                                    e.__ul.style.height = "auto")
                        }
                        e.__resize_handle && U["default"].defer(function() {
                            e.__resize_handle.style.height = e.__ul.offsetHeight + "px"
                        }),
                        e.__closeButton && (e.__closeButton.style.width = e.width + "px")
                    },
                    onResizeDebounced: U["default"].debounce(function() {
                        this.onResize()
                    }, 200),
                    remember: function() {
                        if (U["default"].isUndefined(Z) && (Z = new F["default"],
                            Z.domElement.innerHTML = x["default"]),
                            this.parent)
                            throw new Error("You can only call remember on a top level GUI.");
                        var e = this;
                        U["default"].each(Array.prototype.slice.call(arguments), function(t) {
                            0 === e.__rememberedObjects.length && f(e),
                            e.__rememberedObjects.indexOf(t) === -1 && e.__rememberedObjects.push(t)
                        }),
                        this.autoPlace && p(this, this.width)
                    },
                    getRoot: function() {
                        for (var e = this; e.parent; )
                            e = e.parent;
                        return e
                    },
                    getSaveObject: function() {
                        var e = this.load;
                        return e.closed = this.closed,
                        this.__rememberedObjects.length > 0 && (e.preset = this.preset,
                        e.remembered || (e.remembered = {}),
                            e.remembered[this.preset] = h(this)),
                            e.folders = {},
                            U["default"].each(this.__folders, function(t, n) {
                                e.folders[n] = t.getSaveObject()
                            }),
                            e
                    },
                    save: function() {
                        this.load.remembered || (this.load.remembered = {}),
                            this.load.remembered[this.preset] = h(this),
                            r(this, !1),
                            this.saveToLocalStorageIfPossible()
                    },
                    saveAs: function(e) {
                        this.load.remembered || (this.load.remembered = {},
                            this.load.remembered[Q] = h(this, !0)),
                            this.load.remembered[e] = h(this),
                            this.preset = e,
                            d(this, e, !0),
                            this.saveToLocalStorageIfPossible()
                    },
                    revert: function(e) {
                        U["default"].each(this.__controllers, function(t) {
                            this.getRoot().load.remembered ? l(e || this.getRoot(), t) : t.setValue(t.initialValue),
                            t.__onFinishChange && t.__onFinishChange.call(t, t.getValue())
                        }, this),
                            U["default"].each(this.__folders, function(e) {
                                e.revert(e)
                            }),
                        e || r(this.getRoot(), !1)
                    },
                    listen: function(e) {
                        var t = 0 === this.__listening.length;
                        this.__listening.push(e),
                        t && b(this.__listening)
                    },
                    updateDisplay: function() {
                        U["default"].each(this.__controllers, function(e) {
                            e.updateDisplay()
                        }),
                            U["default"].each(this.__folders, function(e) {
                                e.updateDisplay()
                            })
                    }
                }),
                e.exports = oe
        }
        , function(e, t) {
            "use strict";
            e.exports = {
                load: function(e, t) {
                    var n = t || document
                        , o = n.createElement("link");
                    o.type = "text/css",
                        o.rel = "stylesheet",
                        o.href = e,
                        n.getElementsByTagName("head")[0].appendChild(o)
                },
                inject: function(e, t) {
                    var n = t || document
                        , o = document.createElement("style");
                    o.type = "text/css",
                        o.innerHTML = e;
                    var i = n.getElementsByTagName("head")[0];
                    try {
                        i.appendChild(o)
                    } catch (r) {}
                }
            }
        }
        , function(e, t) {
            e.exports = "<div id=dg-save class=\"dg dialogue\"> Here's the new load parameter for your <code>GUI</code>'s constructor: <textarea id=dg-new-constructor></textarea> <div id=dg-save-locally> <input id=dg-local-storage type=checkbox /> Automatically save values to <code>localStorage</code> on exit. <div id=dg-local-explain>The values saved to <code>localStorage</code> will override those passed to <code>dat.GUI</code>'s constructor. This makes it easier to work incrementally, but <code>localStorage</code> is fragile, and your friends may not see the same values you do. </div> </div> </div>"
        }
        , function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    "default": e
                }
            }
            t.__esModule = !0;
            var i = n(10)
                , r = o(i)
                , a = n(13)
                , l = o(a)
                , s = n(14)
                , u = o(s)
                , d = n(11)
                , c = o(d)
                , f = n(15)
                , _ = o(f)
                , p = n(8)
                , h = o(p)
                , m = n(5)
                , b = o(m)
                , g = function(e, t) {
                var n = e[t];
                return b["default"].isArray(arguments[2]) || b["default"].isObject(arguments[2]) ? new r["default"](e,t,arguments[2]) : b["default"].isNumber(n) ? b["default"].isNumber(arguments[2]) && b["default"].isNumber(arguments[3]) ? b["default"].isNumber(arguments[4]) ? new u["default"](e,t,arguments[2],arguments[3],arguments[4]) : new u["default"](e,t,arguments[2],arguments[3]) : b["default"].isNumber(arguments[4]) ? new l["default"](e,t,{
                    min: arguments[2],
                    max: arguments[3],
                    step: arguments[4]
                }) : new l["default"](e,t,{
                    min: arguments[2],
                    max: arguments[3]
                }) : b["default"].isString(n) ? new c["default"](e,t) : b["default"].isFunction(n) ? new _["default"](e,t,"") : b["default"].isBoolean(n) ? new h["default"](e,t) : null
            };
            t["default"] = g
        }
        , function(e, t) {
            "use strict";
            function n(e) {
                setTimeout(e, 1e3 / 60)
            }
            t.__esModule = !0,
                t["default"] = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || n
        }
        , function(e, t, n) {
            "use strict";
            function o(e) {
                return e && e.__esModule ? e : {
                    "default": e
                }
            }
            function i(e, t) {
                if (!(e instanceof t))
                    throw new TypeError("Cannot call a class as a function")
            }
            t.__esModule = !0;
            var r = n(9)
                , a = o(r)
                , l = n(5)
                , s = o(l)
                , u = function() {
                function e() {
                    i(this, e),
                        this.backgroundElement = document.createElement("div"),
                        s["default"].extend(this.backgroundElement.style, {
                            backgroundColor: "rgba(0,0,0,0.8)",
                            top: 0,
                            left: 0,
                            display: "none",
                            zIndex: "1000",
                            opacity: 0,
                            WebkitTransition: "opacity 0.2s linear",
                            transition: "opacity 0.2s linear"
                        }),
                        a["default"].makeFullscreen(this.backgroundElement),
                        this.backgroundElement.style.position = "fixed",
                        this.domElement = document.createElement("div"),
                        s["default"].extend(this.domElement.style, {
                            position: "fixed",
                            display: "none",
                            zIndex: "1001",
                            opacity: 0,
                            WebkitTransition: "-webkit-transform 0.2s ease-out, opacity 0.2s linear",
                            transition: "transform 0.2s ease-out, opacity 0.2s linear"
                        }),
                        document.body.appendChild(this.backgroundElement),
                        document.body.appendChild(this.domElement);
                    var t = this;
                    a["default"].bind(this.backgroundElement, "click", function() {
                        t.hide()
                    })
                }
                return e.prototype.show = function() {
                    var e = this;
                    this.backgroundElement.style.display = "block",
                        this.domElement.style.display = "block",
                        this.domElement.style.opacity = 0,
                        this.domElement.style.webkitTransform = "scale(1.1)",
                        this.layout(),
                        s["default"].defer(function() {
                            e.backgroundElement.style.opacity = 1,
                                e.domElement.style.opacity = 1,
                                e.domElement.style.webkitTransform = "scale(1)"
                        })
                }
                    ,
                    e.prototype.hide = function t() {
                        var e = this
                            , t = function n() {
                            e.domElement.style.display = "none",
                                e.backgroundElement.style.display = "none",
                                a["default"].unbind(e.domElement, "webkitTransitionEnd", n),
                                a["default"].unbind(e.domElement, "transitionend", n),
                                a["default"].unbind(e.domElement, "oTransitionEnd", n)
                        };
                        a["default"].bind(this.domElement, "webkitTransitionEnd", t),
                            a["default"].bind(this.domElement, "transitionend", t),
                            a["default"].bind(this.domElement, "oTransitionEnd", t),
                            this.backgroundElement.style.opacity = 0,
                            this.domElement.style.opacity = 0,
                            this.domElement.style.webkitTransform = "scale(1.1)"
                    }
                    ,
                    e.prototype.layout = function() {
                        this.domElement.style.left = window.innerWidth / 2 - a["default"].getWidth(this.domElement) / 2 + "px",
                            this.domElement.style.top = window.innerHeight / 2 - a["default"].getHeight(this.domElement) / 2 + "px"
                    }
                    ,
                    e
            }();
            t["default"] = u
        }
        , function(e, t, n) {
            t = e.exports = n(24)(),
                t.push([e.id, ".dg ul{list-style:none;margin:0;padding:0;width:100%;clear:both}.dg.ac{position:fixed;top:0;left:0;right:0;height:0;z-index:0}.dg:not(.ac) .main{overflow:hidden}.dg.main{-webkit-transition:opacity .1s linear;transition:opacity .1s linear}.dg.main.taller-than-window{overflow-y:auto}.dg.main.taller-than-window .close-button{opacity:1;margin-top:-1px;border-top:1px solid #2c2c2c}.dg.main ul.closed .close-button{opacity:1!important}.dg.main .close-button.drag,.dg.main:hover .close-button{opacity:1}.dg.main .close-button{-webkit-transition:opacity .1s linear;transition:opacity .1s linear;border:0;position:absolute;line-height:19px;height:20px;cursor:pointer;text-align:center;background-color:#000}.dg.main .close-button:hover{background-color:#111}.dg.a{float:right;margin-right:15px;overflow-x:hidden}.dg.a.has-save>ul{margin-top:27px}.dg.a.has-save>ul.closed{margin-top:0}.dg.a .save-row{position:fixed;top:0;z-index:1002}.dg li{-webkit-transition:height .1s ease-out;transition:height .1s ease-out}.dg li:not(.folder){cursor:auto;height:27px;line-height:27px;overflow:hidden;padding:0 4px 0 5px}.dg li.folder{padding:0;border-left:4px solid transparent}.dg li.title{cursor:pointer;margin-left:-4px}.dg .closed li:not(.title),.dg .closed ul li,.dg .closed ul li>*{height:0;overflow:hidden;border:0}.dg .cr{clear:both;padding-left:3px;height:27px}.dg .property-name{cursor:default;float:left;clear:left;width:40%;overflow:hidden;text-overflow:ellipsis}.dg .c{float:left;width:60%}.dg .c input[type=text]{border:0;margin-top:4px;padding:3px;width:100%;float:right}.dg .has-slider input[type=text]{width:30%;margin-left:0}.dg .slider{float:left;width:66%;margin-left:-5px;margin-right:0;height:19px;margin-top:4px}.dg .slider-fg{height:100%}.dg .c input[type=checkbox]{margin-top:9px}.dg .c select{margin-top:5px}.dg .cr.boolean,.dg .cr.boolean *,.dg .cr.function,.dg .cr.function *,.dg .cr.function .property-name{cursor:pointer}.dg .selector{display:none;position:absolute;margin-left:-9px;margin-top:23px;z-index:10}.dg .c:hover .selector,.dg .selector.drag{display:block}.dg li.save-row{padding:0}.dg li.save-row .button{display:inline-block;padding:0 6px}.dg.dialogue{background-color:#222;width:460px;padding:15px;font-size:13px;line-height:15px}#dg-new-constructor{padding:10px;color:#222;font-family:Monaco,monospace;font-size:10px;border:0;resize:none;box-shadow:inset 1px 1px 1px #888;word-wrap:break-word;margin:12px 0;display:block;width:440px;overflow-y:scroll;height:100px;position:relative}#dg-local-explain{display:none;font-size:11px;line-height:17px;border-radius:3px;background-color:#333;padding:8px;margin-top:10px}#dg-local-explain code{font-size:10px}#dat-gui-save-locally{display:none}.dg{color:#eee;font:11px Lucida Grande,sans-serif;text-shadow:0 -1px 0 #111}.dg.main::-webkit-scrollbar{width:5px;background:#1a1a1a}.dg.main::-webkit-scrollbar-corner{height:0;display:none}.dg.main::-webkit-scrollbar-thumb{border-radius:5px;background:#676767}.dg li:not(.folder){background:#1a1a1a;border-bottom:1px solid #2c2c2c}.dg li.save-row{line-height:25px;background:#dad5cb;border:0}.dg li.save-row select{margin-left:5px;width:108px}.dg li.save-row .button{margin-left:5px;margin-top:1px;border-radius:2px;font-size:9px;line-height:7px;padding:4px 4px 5px;background:#c5bdad;color:#fff;text-shadow:0 1px 0 #b0a58f;box-shadow:0 -1px 0 #b0a58f;cursor:pointer}.dg li.save-row .button.gears{background:#c5bdad url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAANCAYAAAB/9ZQ7AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAQJJREFUeNpiYKAU/P//PwGIC/ApCABiBSAW+I8AClAcgKxQ4T9hoMAEUrxx2QSGN6+egDX+/vWT4e7N82AMYoPAx/evwWoYoSYbACX2s7KxCxzcsezDh3evFoDEBYTEEqycggWAzA9AuUSQQgeYPa9fPv6/YWm/Acx5IPb7ty/fw+QZblw67vDs8R0YHyQhgObx+yAJkBqmG5dPPDh1aPOGR/eugW0G4vlIoTIfyFcA+QekhhHJhPdQxbiAIguMBTQZrPD7108M6roWYDFQiIAAv6Aow/1bFwXgis+f2LUAynwoIaNcz8XNx3Dl7MEJUDGQpx9gtQ8YCueB+D26OECAAQDadt7e46D42QAAAABJRU5ErkJggg==) 2px 1px no-repeat;height:7px;width:8px}.dg li.save-row .button:hover{background-color:#bab19e;box-shadow:0 -1px 0 #b0a58f}.dg li.folder{border-bottom:0}.dg li.title{padding-left:16px;background:#000 url(data:image/gif;base64,R0lGODlhBQAFAJEAAP////Pz8////////yH5BAEAAAIALAAAAAAFAAUAAAIIlI+hKgFxoCgAOw==) 6px 10px no-repeat;cursor:pointer;border-bottom:1px solid hsla(0,0%,100%,.2)}.dg .closed li.title{background-image:url(data:image/gif;base64,R0lGODlhBQAFAJEAAP////Pz8////////yH5BAEAAAIALAAAAAAFAAUAAAIIlGIWqMCbWAEAOw==)}.dg .cr.boolean{border-left:3px solid #806787}.dg .cr.color{border-left:3px solid}.dg .cr.function{border-left:3px solid #e61d5f}.dg .cr.number{border-left:3px solid #2fa1d6}.dg .cr.number input[type=text]{color:#2fa1d6}.dg .cr.string{border-left:3px solid #1ed36f}.dg .cr.string input[type=text]{color:#1ed36f}.dg .cr.boolean:hover,.dg .cr.function:hover{background:#111}.dg .c input[type=text]{background:#303030;outline:none}.dg .c input[type=text]:hover{background:#3c3c3c}.dg .c input[type=text]:focus{background:#494949;color:#fff}.dg .c .slider{background:#303030;cursor:ew-resize}.dg .c .slider-fg{background:#2fa1d6;max-width:100%}.dg .c .slider:hover{background:#3c3c3c}.dg .c .slider:hover .slider-fg{background:#44abda}", ""])
        }
        , function(e, t) {
            e.exports = function() {
                var e = [];
                return e.toString = function() {
                    for (var e = [], t = 0; t < this.length; t++) {
                        var n = this[t];
                        n[2] ? e.push("@media " + n[2] + "{" + n[1] + "}") : e.push(n[1])
                    }
                    return e.join("")
                }
                    ,
                    e.i = function(t, n) {
                        "string" == typeof t && (t = [[null, t, ""]]);
                        for (var o = {}, i = 0; i < this.length; i++) {
                            var r = this[i][0];
                            "number" == typeof r && (o[r] = !0)
                        }
                        for (i = 0; i < t.length; i++) {
                            var a = t[i];
                            "number" == typeof a[0] && o[a[0]] || (n && !a[2] ? a[2] = n : n && (a[2] = "(" + a[2] + ") and (" + n + ")"),
                                e.push(a))
                        }
                    }
                    ,
                    e
            }
        }
    ])
});

/***********************************************************/
// 通用的缩放算法
// $event: 鼠标事件
// item: 用户数据，item.geometry可用
// stick :  left - 左
//          leftTop - 左上
//          top - 上
//          rightTop - 右上
//          right - 右
//          rightBottom - 右下
//          bottom - 下
//          leftBottom - 左下
//
//      leftTop ---------- top ----------- rightTop
//          |                                   |
//          |                                   |
//         left                               right
//          |                                   |
//          |                                   |
//       leftBottom ----- bottom ---------- rightBottom
//
//  boxElement: box框元素，可以用来计算box的位置和尺寸
var boxZoomStickDown = false;
//pt换算成px
function ptToPx(pt) {
    var px = pt * this.getDPI() / 72;
    return px;
}

function getDPI() {
    var arrDPI = new Array();
    if (window.screen.deviceXDPI != undefined) {
        arrDPI[0] = window.screen.deviceXDPI;
        arrDPI[1] = window.screen.deviceYDPI;
    } else {
        var tmpNode = document.createElement("DIV");
        tmpNode.style.cssText = "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
        document.body.appendChild(tmpNode);
        arrDPI[0] = parseInt(tmpNode.offsetWidth);
        arrDPI[1] = parseInt(tmpNode.offsetHeight);
        tmpNode.parentNode.removeChild(tmpNode);
    }
    return arrDPI[0];
}

function editorBoxZoom($event, item, stick, scale, boxElement, moveCallback, upCallback) {
    if (!item || !stick || !boxElement) {
        return;
    }
    var element;
    if (boxElement.offset) {
        // 元素组
        element = boxElement[0];
    } else if (boxElement.offsetLeft) {
        element = boxElement;
    }
    boxZoomStickDown = true;
    var l0 = element.offsetLeft;
    var t0 = element.offsetTop;
    var w0 = element.offsetWidth;
    var h0 = element.offsetHeight;
    var cx = l0 + w0 / 2;   // 原中心点x
    var cy = t0 + h0 / 2;   // 原中心点y
    var angle = Number(item.rotation.angle);
    var pt0 = rotatePoint({x: $event.clientX, y: $event.clientY}, {x: cx, y: cy}, -angle);
    var dx = 0;     // 框left变化
    var dy = 0;     // 框top变化
    var dw = 0;     // 框长变化
    var dh = 0;     // 框高变化
    var dcx = 0;    // 中心点x向偏移
    var dcy = 0;    // 中心点y向偏移

    var gx = item.geometry.x;
    var gy = item.geometry.y;
    var gw = item.geometry.width;
    var gh = item.geometry.height;
    if(item.offsetx || item.offsety){
        var nw = angular.copy(item.geometry.width);
        var nh = angular.copy(item.geometry.height);
        var nw1 = angular.copy(item.width);
        var nh1 = angular.copy(item.height);
        var x1 = angular.copy(item.offsetx);
        var y1 = angular.copy(item.offsety);
    }

    if(item.style){
        var nw = angular.copy(item.geometry.width);
        var nh = angular.copy(item.geometry.height);
        var _size = angular.copy(parseInt(item.style.size));
        var _lineheight = angular.copy(parseInt(item.style.lineheight));
    }


    function px2mm(pixels) {
        return (pixels || 0) * 25.4 / 96;
    }

    window.onmousemove = function (e) {
        if (!boxZoomStickDown) {
            e.stopPropagation();
            return;
        }
        var pt1 = rotatePoint({x: e.clientX, y: e.clientY}, {x: cx, y: cy}, -angle);
        if (stick == 'left') {
            dx = pt1.x - pt0.x;
            dw = -dx;
            dcx = dx/2;
        }
        else if (stick == 'top') {
            dy = pt1.y - pt0.y;
            dh = -dy;
            dcy = dy/2;
        }
        else if (stick == 'right') {
            dw = pt1.x - pt0.x;
            dcx = dw / 2;
        }
        else if (stick == 'bottom') {
            dh = pt1.y - pt0.y;
            dcy = dh / 2;
        }
        else if (stick == 'leftTop') {
            var offsetX = pt1.x - pt0.x;
            var offsetY = pt1.y - pt0.y;
            if ((gw - offsetX / scale) * gh  > (gh - offsetY / scale) * gw ) {
                offsetX = offsetY * gw / gh;
            } else {
                offsetY = offsetX * gh / gw;
            }

            dx = offsetX;
            dy = offsetY;

            dw = -dx;
            dh = -dy;
            dcx = dx / 2;
            dcy = dy / 2;
        }
        else if (stick == 'leftBottom') {
            var offsetX = pt1.x - pt0.x;
            var offsetY = pt1.y - pt0.y;
            if ((gw - offsetX / scale) * gh  > (gh + offsetY / scale) * gw ) {
                offsetX = -1 * offsetY * gw / gh;
            } else {
                offsetY = -1 * offsetX * gh / gw;
            }

            dx = offsetX;
            dw = -dx;
            dh = offsetY;
            dcx = dx / 2;
            dcy = dh / 2;
        }
        else if (stick == 'rightTop') {
            var offsetX = pt1.x - pt0.x;
            var offsetY = pt1.y - pt0.y;
            if ((gw + offsetX / scale) * gh  > (gh - offsetY / scale) * gw ) {
                offsetX = -1 * offsetY * gw / gh;
            } else {
                offsetY = -1 * offsetX * gh / gw;
            }

            dy = offsetY;
            dw = offsetX;
            dh = -dy;
            dcx = dw / 2;
            dcy = dy / 2;
        }
        else if (stick == 'rightBottom') {
            var offsetX = pt1.x - pt0.x;
            var offsetY = pt1.y - pt0.y;
            if ((gw + offsetX / scale) * gh  > (gh + offsetY / scale) * gw ) {
                offsetX = offsetY * gw / gh;
            } else {
                offsetY = offsetX * gh / gw;
            }

            dw = offsetX;
            dh = offsetY;
            dcx = dw / 2;
            dcy = dh / 2;
        }
        else {
            e.stopPropagation();
            return;
        }
        // 如果框尺寸小于5mm, 不处理
        if (gw + (dw / scale) < 5 || gh + (dh / scale) < 5) {
            e.stopPropagation();
            return;
        }
        // 中心点偏移dc1
        var dc1 = rotatePoint({x: dcx, y: dcy}, {x: 0, y: 0}, angle);
        // 偏移补偿
        var cx_fix =  dc1.x - dcx;
        var cy_fix = dc1.y - dcy;

        if(item.style){
            if(item.geometry.width > ptToPx(item.style.size)){
                item.geometry.x = gx + ((dx + cx_fix) / scale);
                item.geometry.y = gy + ((dy + cy_fix) / scale);
            }
        }else{
            item.geometry.x = gx + ((dx + cx_fix) / scale);
            item.geometry.y = gy + ((dy + cy_fix) / scale);
        }
        // item.geometry.x = gx + ((dx + cx_fix) / scale);
        // item.geometry.y = gy + ((dy + cy_fix) / scale);
        item.geometry.width = gw + (dw / scale);
        item.geometry.height = gh + (dh / scale);
        if(item.offsetx || item.offsety){
            item.offsetx = ((gw + dw / scale) / (nw / nw1)) / (nw1 / x1);
            item.offsety = ((gh + dh / scale) / (nh / nh1)) / (nh1 / y1);
        }

        if(item.style){
            if((stick != 'left' && stick != 'top' && stick != 'right' && stick != 'bottom')){
                var size1 = Math.ceil((gw + (dw / scale)) / nw * _size);
                if(size1<6){
                    size1 = 6;
                    item.style.size = size1;
                    item.style.lineheight = Math.floor((size1 / _size * _lineheight));
                    boxZoomStickDown = false;
                    if (upCallback) {
                        upCallback(item);
                    }
                    return false
                }
                item.style.size = size1;
                item.style.lineheight = Math.floor((size1 / _size * _lineheight));
            }
            if(stick == 'left'|| stick == 'right'){
                if(item.geometry.width < ptToPx(item.style.size)){
                    item.geometry.width = ptToPx(item.style.size)+10;
                    boxZoomStickDown = false;
                    if (upCallback) {
                        upCallback(item);
                    }
                }
            }
            if(stick == 'top' || stick == 'bottom'){
                if(item.geometry.height < ptToPx(item.style.size)){
                    item.geometry.height = ptToPx(item.style.size)+10;
                    boxZoomStickDown = false;
                    if (upCallback) {
                        upCallback(item);
                    }
                }
            }
        }

        // if(item.style && (stick != 'left' && stick != 'top' && stick != 'right' && stick != 'bottom')){
        //     var size1 = Math.ceil((gw + (dw / scale)) / nw * _size);
        //     if (size1 <= 6) {
        //         size1 = 6
        //     }
        //     item.style.size = size1;
        //     item.style.lineheight = Math.floor((size1 / _size * _lineheight));
        // }


        if (moveCallback) {
            moveCallback(item);
        }
        e.stopPropagation();
    }

    window.onmouseup = function (e) {
        if (!boxZoomStickDown) {
            e.stopPropagation();
            return;
        }
        var pt1 = rotatePoint({x: e.clientX, y: e.clientY}, {x: cx, y: cy}, -angle);
        if (stick == 'left') {
            dx = pt1.x - pt0.x;
            dw = -dx;
            dcx = dx/2;
        }
        else if (stick == 'top') {
            dy = pt1.y - pt0.y;
            dh = -dy;
            dcy = dy/2;
        }
        else if (stick == 'right') {
            dw = pt1.x - pt0.x;
            dcx = dw / 2;
        }
        else if (stick == 'bottom') {
            dh = pt1.y - pt0.y;
            dcy = dh / 2;
        }
        else if (stick == 'leftTop') {
            var offsetX = pt1.x - pt0.x;
            var offsetY = pt1.y - pt0.y;
            if ((gw - offsetX / scale) * gh  > (gh - offsetY / scale) * gw ) {
                offsetX = offsetY * gw / gh;
            } else {
                offsetY = offsetX * gh / gw;
            }

            dx = offsetX;
            dy = offsetY;

            dw = -dx;
            dh = -dy;
            dcx = dx / 2;
            dcy = dy / 2;
        }
        else if (stick == 'leftBottom') {
            var offsetX = pt1.x - pt0.x;
            var offsetY = pt1.y - pt0.y;
            if ((gw - offsetX / scale) * gh  > (gh + offsetY / scale) * gw ) {
                offsetX = -1 * offsetY * gw / gh;
            } else {
                offsetY = -1 * offsetX * gh / gw;
            }

            dx = offsetX;
            dw = -dx;
            dh = offsetY;
            dcx = dx / 2;
            dcy = dh / 2;
        }
        else if (stick == 'rightTop') {
            var offsetX = pt1.x - pt0.x;
            var offsetY = pt1.y - pt0.y;
            if ((gw + offsetX / scale) * gh  > (gh - offsetY / scale) * gw ) {
                offsetX = -1 * offsetY * gw / gh;
            } else {
                offsetY = -1 * offsetX * gh / gw;
            }

            dy = offsetY;
            dw = offsetX;
            dh = -dy;
            dcx = dw / 2;
            dcy = dy / 2;
        }
        else if (stick == 'rightBottom') {
            var offsetX = pt1.x - pt0.x;
            var offsetY = pt1.y - pt0.y;
            if ((gw + offsetX / scale) * gh  > (gh + offsetY / scale) * gw ) {
                offsetX = offsetY * gw / gh;
            } else {
                offsetY = offsetX * gh / gw;
            }

            dw = offsetX;
            dh = offsetY;
            dcx = dw / 2;
            dcy = dh / 2;
        }
        else {
            e.stopPropagation();
            return;
        }

        // 如果框尺寸小于5mm, 不处理
        if (gw + (dw / scale) < 5 || gh + (dh / scale) < 5) {
            e.stopPropagation();
            return;
        }

        // 中心点偏移dc1
        var dc1 = rotatePoint({x: dcx, y: dcy}, {x: 0, y: 0}, angle);
        // 偏移补偿
        var cx_fix =  dc1.x - dcx;
        var cy_fix = dc1.y - dcy;

        if(!item.style){
            item.geometry.x = gx + ((dx + cx_fix) / scale);
            item.geometry.y = gy + ((dy + cy_fix) / scale);
            item.geometry.width = gw + (dw / scale);
            item.geometry.height = gh + (dh / scale);
        }

        if (upCallback) {
            upCallback(item);
        }
        boxZoomStickDown = false;
        e.stopPropagation();
    }
}


/*******************************************初始化*************************************************************************/
//防止事件冒泡，默认事件
function fn(e) {
    if(e){
        if (e && e.stopPropagation) {
            // 因此它支持W3C的stopPropagation()方法
            e.stopPropagation();
        } else {
            // 否则，我们需要使用IE的方式来取消事件冒泡
            window.event.cancelBubble = true;
        }

        // 阻止默认浏览器动作(W3C)
        if (e && e.preventDefault) {
            e.preventDefault();
        } else {
            // IE中阻止函数器默认动作的方式
            window.event.returnValue = false;
        }
    }
}
//dpi
var _dpi = null;
var _mmToPxRatio = null;
var _pxToMmRatio = null;
function js_getDPI() {
    if(_dpi){
        return _dpi
    }
    var arrDPI = new Array();
    if (window.screen.deviceXDPI != undefined) {
        arrDPI[0] = window.screen.deviceXDPI;
        arrDPI[1] = window.screen.deviceYDPI;
    } else {
        var tmpNode = document.createElement("DIV");
        tmpNode.style.cssText = "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
        document.body.appendChild(tmpNode);
        arrDPI[0] = parseInt(tmpNode.offsetWidth);
        arrDPI[1] = parseInt(tmpNode.offsetHeight);
        tmpNode.parentNode.removeChild(tmpNode);
    }
    _dpi = arrDPI[1];
    _mmToPxRatio = _dpi / 25.4;
    _pxToMmRatio = 25.4 / _dpi;
    return arrDPI[1];
}
//mm转px
function transitionPx(item) {
    if (item == null || item === undefined || isNaN(item)) {
        return 0;
    }
    if (!_mmToPxRatio) {
        js_getDPI();
    }
    var result = item * _mmToPxRatio;
    return Number(result.toFixed(5));
}
//px转mm
function transitionMm(item) {
    if (item == null || item === undefined || isNaN(item)) {
        return 0;
    }
    if (!_pxToMmRatio) {
        js_getDPI();
    }
    var result = item * _pxToMmRatio;
    return Number(result.toFixed(5));
}
function imgWebFill(sum, photoSelectAll) {
    var _imgFillAll = angular.copy(photoSelectAll);
    return _imgFillAll[sum]
}

function addImagebox($http, item, callback,notParameter) {
    var data=item.image.imageInfo;
    if(data){
        data = data;
        addImageboxCb(item, function(){
            if(callback){
                callback()
            }
        }, data,notParameter)
        return
    }
    var _domain = (item.image.resource.identifier.indexOf('http') == -1 ? localStorage.getItem('editor-domain').replace(/"/g, '') : '');
    $http({url: _domain + item.image.resource.identifier + '?imageInfo'}).success(function (data) {
        item.image.imageInfo = data;
        addImageboxCb(item, function(){
            if(callback){
                callback()
            }
        }, data,notParameter)
    }).error(function (error) {
    });
}
function addImageboxCb(item, callback, data,notParameter) {
    item.image.angle = orientationInit1(data.orientation).angle;
    item.flip = orientationInit1(data.orientation).flip;
    data = orientationInit(data);
    // if ((item.geometry.width - item.geometry.height) * (data.width - data.height) < 0) {
    //     item.image.angle += 90;
    //     var _data = angular.copy(data);
    //     data.width = _data.height;
    //     data.height = _data.width;
    // }
    var imgR = item.geometry.width / item.geometry.height;
    var imgR1 = data.width / data.height;
    item.image.width1 = data.width;
    item.image.height1 = data.height;
    if(!item.bokehtype){item.bokehtype = 'None'}
    if (item.bokehtype == 'None') {
        if (imgR >= imgR1) {
            item.image.resource.adaptation = 'Height';
            item.image.width = item.geometry.width;
            item.image.height = item.geometry.width / data.width * data.height;
            item.image.offsetx = 0;
            item.image.offsety = -(item.image.height - item.geometry.height) / 2;
        } else {
            item.image.resource.adaptation = 'Width';
            item.image.width = item.geometry.height / data.height * data.width;
            item.image.height = item.geometry.height;
            item.image.offsetx = -(item.image.width - item.geometry.width) / 2;
            item.image.offsety = 0;
        }
    } else {
        if (imgR >= imgR1) {
            item.image.resource.adaptation = 'Height';
            item.image.width = item.geometry.width;
            item.image.height = item.geometry.width / data.width * data.height;
            item.image.offsetx = 0;
            item.image.offsety = 0;
            item.blurredrectangle = {
                width: item.geometry.height / data.height * data.width,
                height: item.geometry.height,
                x: (item.geometry.width - item.geometry.height / data.height * data.width) / 2,
                y: 0,
            }
        } else {
            item.image.resource.adaptation = 'Width';
            item.image.width = item.geometry.height / data.height * data.width;
            item.image.height = item.geometry.height;
            item.image.offsetx = 0;
            item.image.offsety = 0;
            item.blurredrectangle = {
                width: item.geometry.width,
                height: item.geometry.width / data.width * data.height,
                x: 0,
                y: (item.geometry.height - item.geometry.width / data.width * data.height) / 2,
            }
        }
    }
    if(!notParameter){
        if(item.image.parameter){
            imageOffset(item, function(){
                if(callback){
                    callback()
                }
            })
        }else{
            var Gallery = angular.element(document.body).injector().get('Gallery');
            Gallery.detectFaces({galleryId: item.image.resourceid},
                function (res) {
                    if(res && res.parameter){
                        item.image.parameter = angular.fromJson(res.parameter);
                        imageOffset(item, function(){
                            if(callback){
                                callback()
                            }
                        })
                    }else{
                        if(callback){
                            callback()
                        }
                    }
                },
                function (err) {
                    if(callback){
                        callback()
                    }
                }
            );
        }
    }else{
        if(callback){
            callback()
        }
    }
}
function imageOffset(imagebox,callback) {
    if(imagebox && imagebox.image && imagebox.image.parameter){
        /**
         * parameter的数据格式为：[{x:1,y:1,width:2,height:2},{x:3,y:3,width:2,height:2}]
         * x,y是偏移量，width,height是矩形的尺寸
         * 1、期望把这个数组中的x,y,width,height计算出外层最大的x,y,width,height合并成一个对象，
         */
        var parameter = angular.copy(imagebox.image.parameter);
        if (angular.isArray(parameter) && parameter.length > 0) {
            // EXIF orientation 驱动：在归一化坐标上完成 flip + rotate，一次性对齐人脸区域
            var orientation = imagebox.image.imageInfo.orientation;
            parameter.forEach(function (rect) {
                var _x = rect.x, _y = rect.y, _w = rect.width, _h = rect.height;
                switch (orientation) {
                case 'Top-left':
                    break;
                case 'Top-right':
                    rect.x = 1 - _x - _w;
                    break;
                case 'Bottom-right':
                    rect.x = 1 - _x - _w;
                    rect.y = 1 - _y - _h;
                    break;
                case 'Bottom-left':
                    rect.y = 1 - _y - _h;
                    break;
                case 'Right-top':       // angle=90, flip=false: 90° CCW
                    rect.x = 1 - _y - _h;
                    rect.y = _x;
                    rect.width = _h;
                    rect.height = _w;
                    break;
                case 'Left-top':
                    rect.x = _y;
                    rect.y = _x;
                    rect.width = _h;
                    rect.height = _w;
                    break;
                case 'Right-bottom':
                    rect.x = 1 - _y - _h;
                    rect.y = 1 - _x - _w;
                    rect.width = _h;
                    rect.height = _w;
                    break;
                case 'Left-bottom':     // angle=270, flip=false: 270° CCW (= 90° CW)
                    rect.x = _y;
                    rect.y = 1 - _x - _w;
                    rect.width = _h;
                    rect.height = _w;
                    break;
                }
            });
            // 用 orientation 校正后的宽高做像素缩放（width1/height1 已是 orientation 校正值）
            var W = imagebox.image.width1;
            var H = imagebox.image.height1;
            parameter.forEach(function (rect) {
                rect.x = rect.x * W;
                rect.y = rect.y * H;
                rect.width = rect.width * W;
                rect.height = rect.height * H;
            });
            // 计算出外接矩形的最小x,y和最大x,y
            var minX = parameter[0].x;
            var minY = parameter[0].y;
            var maxRight = parameter[0].x + parameter[0].width;
            var maxBottom = parameter[0].y + parameter[0].height;
            for (var i = 1; i < parameter.length; i++) {
                var rect = parameter[i];
                if (rect.x < minX) minX = rect.x;
                if (rect.y < minY) minY = rect.y;
                if (rect.x + rect.width > maxRight) maxRight = rect.x + rect.width;
                if (rect.y + rect.height > maxBottom) maxBottom = rect.y + rect.height;
            }
            var boundingRect = {
                x: minX,
                y: minY,
                width: maxRight - minX,
                height: maxBottom - minY
            };
            /**
             * 1、imagebox.geometry = {x,y,width,height}，这是图片框的宽高,
             * 2、imagebox.image.width是图片的宽，imagebox.image.height是图片的高,
             * 3、boundingRect = {x,y,width,height}，这是图片需要居中展示到图片框内的位置与大小,
             * 根据boundingRect计算出imagebox.image.offsetx,imagebox.image.offsety的值，imagebox.image.offsetx,imagebox.image.offsety的值是图片框的左上角与boundingRect的左上角的偏移量,
             * 4、要求boundingRect最好居中显示，imagebox.image.offsetx,imagebox.image.offsety的值不能大于0，
             * imagebox.image.width+imagebox.image.offsetx>=imagebox.geometry.width && imagebox.image.width+imagebox.image.offsety>=imagebox.geometry.height。其实也就是图片填充到图片框中不能超出图片框的范围,
             */
            // boundingRect 在原始像素坐标系，缩放到 mm 显示空间
            var scaleX = imagebox.image.width / imagebox.image.width1;
            var scaleY = imagebox.image.height / imagebox.image.height1;
            var brCenterX = (boundingRect.x + boundingRect.width / 2) * scaleX;
            var brCenterY = (boundingRect.y + boundingRect.height / 2) * scaleY;
            // 居中：使 boundingRect 中心对齐 frame 中心
            var offsetX = imagebox.geometry.width / 2 - brCenterX;
            var offsetY = imagebox.geometry.height / 2 - brCenterY;
            // 约束1：offset 不能大于 0（图片不能露出左上角空白）
            offsetX = Math.min(offsetX, 0);
            offsetY = Math.min(offsetY, 0);
            // 约束2：图片必须填满整个 frame（右下角不能露白）
            offsetX = Math.max(offsetX, imagebox.geometry.width - imagebox.image.width);
            offsetY = Math.max(offsetY, imagebox.geometry.height - imagebox.image.height);
            imagebox.image.offsetx = offsetX;
            imagebox.image.offsety = offsetY;
            var boundingRect1 = { x: boundingRect.x * scaleX, y: boundingRect.y * scaleY, width: boundingRect.width * scaleX, height: boundingRect.height * scaleY };
            imagebox.boundingRect1 = boundingRect1;
            if(boundingRect1.width > imagebox.geometry.width || boundingRect1.height > imagebox.geometry.height){
                //获取imagebox.image.parameter中width*height最大的数据
                var maxRect = parameter[0];
                var maxArea = maxRect.width * maxRect.height;
                for (var j = 1; j < parameter.length; j++) {
                    var area = parameter[j].width * parameter[j].height;
                    if (area > maxArea) {
                        maxArea = area;
                        maxRect = parameter[j];
                    }
                }
                // parameter 已在归一化空间完成 orientation 变换，直接用最大矩形
                boundingRect = {
                    x: maxRect.x,
                    y: maxRect.y,
                    width: maxRect.width,
                    height: maxRect.height
                };
                // 重新计算缩放后的 boundingRect 和居中偏移
                brCenterX = (boundingRect.x + boundingRect.width / 2) * scaleX;
                brCenterY = (boundingRect.y + boundingRect.height / 2) * scaleY;
                offsetX = imagebox.geometry.width / 2 - brCenterX;
                offsetY = imagebox.geometry.height / 2 - brCenterY;
                offsetX = Math.min(offsetX, 0);
                offsetY = Math.min(offsetY, 0);
                offsetX = Math.max(offsetX, imagebox.geometry.width - imagebox.image.width);
                offsetY = Math.max(offsetY, imagebox.geometry.height - imagebox.image.height);
                imagebox.image.offsetx = offsetX;
                imagebox.image.offsety = offsetY;
            }
        }
        if(callback){
            callback(imagebox)
        }
    }else{
        if(callback){
            callback(imagebox)
        }
    }
}
function getBackgroundWebSource1($scope, res,pageW,pageH,item, bokehtype, callback) {
    var newImg = new Image();
    newImg.crossOrigin = "Anonymous";
    newImg.src = res.image.resource.identifier + '?imageMogr2/exifModify/eyJPcmllbnRhdGlvbiI6IjEifQ==/rotate/' + item.angle+'/thumbnail/!40p';
    newImg.onload = function () {
        var imgR = pageW/pageH;
        var imgR1 = newImg.width/newImg.height;
        if(bokehtype == 'None'){
            if(imgR >= imgR1){
                item.resource.adaptation = 'Height';
                item.width= pageW;
                item.height= pageW/newImg.width*newImg.height;
            }else {
                item.resource.adaptation = 'Width';
                item.width= pageH/newImg.height * newImg.width;
                item.height= pageH;
            }
        }else {
            if(imgR >= imgR1){
                item.resource.adaptation = 'Height';
                item.width= pageW;
                item.height= pageW/newImg.width*newImg.height;
                item.offsetx= 0;
                item.offsety= 0;
            }else {
                item.resource.adaptation = 'Width';
                item.width= pageH/newImg.height*newImg.width;
                item.height= pageH;
                item.offsetx= 0;
                item.offsety= 0;
            }
        }
        if(callback){
            callback(item)
        }
        $scope.$apply();
    };
    newImg.onerror = function () {
        item.width = null;
        item.height = null;
        if(callback){
            callback()
        }
        $scope.$apply();
    }
}
function getBackgroundWebSource2($scope, res,pageW,pageH,item, bokehtype) {
    var newImg = new Image();
    newImg.crossOrigin = "Anonymous";
    newImg.src = res.identifier + '?imageMogr2/exifModify/eyJPcmllbnRhdGlvbiI6IjEifQ==/rotate/' + item.angle+'/thumbnail/!40p';
    newImg.onload = function () {
        var imgR = pageW/pageH;
        var imgR1 = newImg.width/newImg.height;
        if(imgR >= imgR1){
            item.resource.adaptation = 'Height';
            item.width= pageW;
            item.height= pageW/newImg.width*newImg.height;
        }else {
            item.resource.adaptation = 'Width';
            item.width= pageH/newImg.height * newImg.width;
            item.height= pageH;
        }
        $scope.$apply();
    };
}
function getBackgroundWebSource3($scope, res, pageW, pageH, item, bokehtype, callback) {
    var newImg = new Image();
    newImg.crossOrigin = "Anonymous";
    newImg.src = (res.image.resource.identifier.indexOf('http') == -1 ? $scope.domain : '') + res.image.resource.identifier + '?imageMogr2/exifModify/eyJPcmllbnRhdGlvbiI6IjEifQ==/rotate/' + item.angle + '/thumbnail/!40p';
    newImg.onload = function () {
        var imgR = pageW / pageH;
        var imgR1 = newImg.width / newImg.height;
        if (bokehtype == 'None') {
            if (imgR >= imgR1) {
                item.resource.adaptation = 'Height';
                item.width = pageW;
                item.height = pageW / newImg.width * newImg.height;
                item.offsetx = 0;
                item.offsety = 0;
            } else {
                item.resource.adaptation = 'Width';
                item.width = pageH / newImg.height * newImg.width;
                item.height = pageH;
                item.offsetx = 0;
                item.offsety = 0;
            }
        } else {
            if (imgR >= imgR1) {
                item.resource.adaptation = 'Height';
                item.width = pageW;
                item.height = pageW / newImg.width * newImg.height;
                item.offsetx = 0;
                item.offsety = 0;
                res.blurredrectangle = {
                    width: pageH / newImg.height * newImg.width,
                    height: pageH,
                    x: (pageW - pageH / newImg.height * newImg.width) / 2,
                    y: 0,
                }
            } else {
                item.resource.adaptation = 'Width';
                item.width = pageH / newImg.height * newImg.width;
                item.height = pageH;
                item.offsetx = 0;
                item.offsety = 0;
                res.blurredrectangle = {
                    width: pageW,
                    height: pageW / newImg.width * newImg.height,
                    x: 0,
                    y: (pageH - pageW / newImg.width * newImg.height) / 2,
                }
            }
        }
        if(callback){
            callback()
        }
        $scope.$apply();
    };
    newImg.onerror = function () {
        item.width = null;
        item.height = null;
        if(callback){
            callback()
        }
        $scope.$apply();
    }
}

function orientationInit(item) {
    var data = angular.copy(item);
    if((item.orientation == "Bottom-right" )){
        data.width = item.width;
        data.height = item.height;
    }
    if (item.orientation == "Left-bottom" || item.orientation == "Left-top" || item.orientation == "Right-bottom"|| item.orientation == "Right-top") {
        data.width = item.height;
        data.height = item.width;
    }
    return data
}
function orientationInit1(orientation) {
    switch (orientation) {
        case 'Top-left':
            return {angle:0, flip:false};
            break;
        case 'Top-right':
            return {angle:0, flip:true};
            break;
        case 'Bottom-right':
            return {angle:180, flip:false};
            break;
        case 'Bottom-left':
            return {angle:180, flip:true};
            break;
        case 'Left-top':
            return {angle:90, flip:true};
            break;
        case 'Right-top':
            return {angle:90, flip:false};
            break;
        case 'Right-bottom':
            return {angle:270, flip:true};
            break;
        case 'Left-bottom':
            return {angle:270, flip:false};
            break;
        default:
            return {angle:0, flip:false};
    }
}
/*******************************************图片框处理*************************************************************************/
//缩放
var isZoomDown = false;
function imageboxZoom($scope, $event,item, direction,pro,index,slide, editbox, callback, callback1) {
    var x = $event.clientX;
    var y = $event.clientY;
    //获取w和h
    var nw = angular.copy(item.geometry.width) * pro;
    var nh = angular.copy(item.geometry.height) * pro;
    var nw1 = item.image ? angular.copy(item.image.width) * pro : 0;
    var nh1 = item.image ? angular.copy(item.image.height) * pro : 0;
    var nw2 = item.image ? angular.copy(item.image.width) * pro : 1;
    var nh2 = item.image ? angular.copy(item.image.height) * pro : 1;
    var x1 = item.image ? angular.copy(item.image.offsetx * pro) : 0;
    var y1 = item.image ? angular.copy(item.image.offsety * pro) : 0;
    var x2 = item.geometry.x * pro;
    var y2 = item.geometry.y * pro;
    var _scale = item.image ? angular.copy(item.image.scale) : 1;
    // var maxX = (editbox.width + editbox.x) * pro;
    // var maxY = (editbox.height + editbox.y) * pro;
    var _left = $($event.target).parents('.selected').offset().left + (nw/2);
    var _top = $($event.target).parents('.selected').offset().top + (nh/2);

    var x3 = Math.abs(_left - $event.clientX);
    var y3 = Math.abs(_top - $event.clientY);
    var distance = Math.sqrt(Math.pow(x3, 2) + Math.pow(y3, 2));

    //开关打开
    isZoomDown = true;
    //鼠标移动
    window.onmousemove = function (e) {
        if (isZoomDown == false) {
            return false;
        }
        var nl = 0;
        var x = Math.abs(_left + nl - e.clientX);
        var y = Math.abs(_top - e.clientY);
        var z = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
        nl = (parseInt(z - distance))*2 / pro;
        var _w = (Number(nw) + Number(nl));
        var _h = _w / nw * nh;
        item.geometry.width = _w / pro;
        item.geometry.height = _h / pro;
        item.geometry.x = (x2 - (_w - nw)/2) / pro;
        item.geometry.y = (y2 - (_h - nh)/2) / pro;
        if (item.image) {
            item.image.width = _w / nw * nw2 / pro;
            item.image.height = _w / nw * nh2 / pro;
            item.image.offsetx = (_w / (nw / nw1)) / (nw1 / x1) / pro;
            item.image.offsety = (_h / (nh / nh1)) / (nh1 / y1) / pro;
        }
        callback(item)
        $scope.$apply();
    }
    //鼠标抬起事件
    window.onmouseup = function ($event) {
        if(isZoomDown){
            callback1()
        }
        isZoomDown = false;
        $scope.$apply();
        $event.stopPropagation();
    }
}
function imageboxZoom1($scope, $event,item, direction, pro,index,slide, editbox, callback) {
    var x = $event.clientX;
    var y = $event.clientY;
    //获取w和h
    var nw = angular.copy(item.geometry.width) * pro;
    var nh = angular.copy(item.geometry.height) * pro;
    var nw1 = item.image ? angular.copy(item.image.width) * pro : 0;
    var nh1 = item.image ? angular.copy(item.image.height) * pro : 0;
    var nw2 = item.image ? angular.copy(item.image.width) * pro : 1;
    var nh2 = item.image ? angular.copy(item.image.height) * pro : 1;
    var x1 = item.image ? angular.copy(item.image.offsetx * pro) : 0;
    var y1 = item.image ? angular.copy(item.image.offsety * pro) : 0;
    var x2 = item.geometry.x * pro;
    var y2 = item.geometry.y * pro;
    var _scale = item.image ? angular.copy(item.image.scale) : 1;
    var maxX = editbox.width * pro;
    var maxY = editbox.height * pro;
    var _left = $($event.target).parents('.selected').offset().left + (nw/2);
    var _top = $($event.target).parents('.selected').offset().top + (nh/2);

    var x3 = Math.abs(_left - $event.clientX);
    var y3 = Math.abs(_top - $event.clientY);
    var distance = Math.sqrt(Math.pow(x3, 2) + Math.pow(y3, 2));
    //开关打开
    isZoomDown = true;
    //鼠标移动
    window.onmousemove = function (e) {
        if (isZoomDown == false) {
            return;
        }
        //获取x和y
        var nl = 0;
        var x = Math.abs(_left + nl - e.clientX);
        var y = Math.abs(_top - e.clientY);
        var z = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
        nl = (parseInt(z - distance))*2 / pro;
        var _w = (Number(nw) + Number(nl));
        var _h = (Number(nh) + Number(nl));
        if (item.image) {
            item.image.offsetx = 0;
            item.image.offsety = 0;
        }
        if (direction == 'left' || direction == 'right') {
            item.geometry.width = _w / pro;
            item.geometry.x = (x2 - (_w - nw)/2) / pro;
        }
        if (direction == 'top' || direction == 'bottom') {
            item.geometry.height = _h / pro;
            item.geometry.y = (y2 - (_h - nh)/2) / pro;
        }
        $scope.$apply();
    }
    //鼠标抬起事件
    window.onmouseup = function ($event) {
        if (isZoomDown){
            callback()
        }
        $event.stopPropagation();
        isZoomDown = false;
    }
}
//旋转
var isRotate = false;
function webRotate($scope, $event, item, _top, _left, ModulesService, callback) {
    //开关打开
    isRotate = true;
    //鼠标移动
    window.onmousemove = function (e) {
        if (isRotate == false) {
            return;
        }
        item.rotation.angle = ModulesService.getAngle(_left,_top, e.clientX, e.clientY);

        item.rotation.angle = adsorbAngle(item.rotation.angle)
        $scope.$apply();
    }
    //鼠标抬起事件
    window.onmouseup = function (e) {
        if(isRotate){
            callback()
        }
        isRotate = false;
    };
}
/*******************************************素材处理*************************************************************************/
//添加素材
function webAddImageart($scope, $http,item, editbox, callback) {
    $http({url: item.resource.identifier + '?imageInfo'}).success(function (data) {
        var _imageart = {
            movable: true,
            editable: true,
            onlyshow: false,
            offsetx: '0',
            offsety: '0',
            transparency: '1',
            geometry: {
                x: '0',
                y: '0',
                width: data.width,
                height: data.height
            },
            rotation: {
                angle: '0'
            },
            resource: {
                provider: '',
                identifier: item.resource.identifier,
            },
            width:item.width,
            height: item.height,
            imageInfo: data,
            scale: 1,
            useradded: true,
            type: 'dynamic',
            isArt: false,
            current:'imageart'
        }

        var bgImgW = data.width;
        var bgImgH = data.height;
        var bgImgR = bgImgW/bgImgH;
        if(bgImgR >= 1){
            if(bgImgW > 200){
                _imageart.geometry.width = 200;
                _imageart.geometry.height = _imageart.geometry.width * bgImgH / bgImgW;
            }else {
                _imageart.geometry.width = bgImgW;
                _imageart.geometry.height = bgImgH;
            }
        }else {
            if(bgImgH > 200){
                _imageart.geometry.height = 200;
                _imageart.geometry.width = _imageart.geometry.height * bgImgW / bgImgH;
            }else {
                _imageart.geometry.width = bgImgW;
                _imageart.geometry.height = bgImgH;
            }
        }
        _imageart.width = _imageart.geometry.width;
        _imageart.height = _imageart.geometry.height;
        _imageart.geometry.x = (editbox.width - _imageart.geometry.width) / 2 + editbox.x;
        _imageart.geometry.y = (editbox.height - _imageart.geometry.height) / 2 + editbox.y;
        callback(_imageart)
    }).error(function (error) {});
}
//拖动
var isImageartDown = false;
var moveItem = [];
var moveCallbacks = [];
function moveWebdown($scope, $event, item, editbox, ratio, callback, moveCallback) {
    var x = $event.clientX;
    var y = $event.clientY;
    item.l = angular.copy(item.geometry.x * ratio);
    item.t = angular.copy(item.geometry.y * ratio);
    moveItem.push(item)
    if (callback) {
        moveCallbacks.push(callback);
    }
    //开关打开
    isImageartDown = true;
    isImageartMove = false;
    //鼠标移动
    window.onmousemove = function (e) {
        if (isImageartDown == false) {
            return;
        }
        //获取x和y
        moveItem.forEach(function (item1) {
            var nx = e.clientX;
            var ny = e.clientY;
            //计算移动后的左偏移量和顶部的偏移量
            var nl = nx - (x - item1.l);
            var nt = ny - (y - item1.t);
            if(item.current === "textbox" || item.text){
                //框不能超出editbox的边界，注意item.rotation.angle是旋转角度，旋转后计算上下左右的顶点不能超过editbox的边界
                var _angle = Number(item.rotation.angle || 0);
                var _boxW = item.geometry.width * ratio;
                var _boxH = item.geometry.height * ratio;
                // 计算旋转后外包矩形
                var _outer = outerRectangle2(nl, nt, nl + _boxW, nt + _boxH, _angle);

                var _editL = editbox.x * ratio;
                var _editT = editbox.y * ratio;
                var _editR = (editbox.x + editbox.width) * ratio;
                var _editB = (editbox.y + editbox.height) * ratio;

                var _outerW = _outer.maxX - _outer.minX;
                var _outerH = _outer.maxY - _outer.minY;
                var _editW = _editR - _editL;
                var _editH = _editB - _editT;

                // 仅在旋转后外包矩形能放入编辑区时才约束
                if (_outerW <= _editW) {
                    if (_outer.minX < _editL) { nl += _editL - _outer.minX; }
                    if (_outer.maxX > _editR) { nl -= _outer.maxX - _editR; }
                }
                if (_outerH <= _editH) {
                    if (_outer.minY < _editT) { nt += _editT - _outer.minY; }
                    if (_outer.maxY > _editB) { nt -= _outer.maxY - _editB; }
                }
            }

            item1.geometry.x = nl / ratio;
            item1.geometry.y = nt / ratio;
        })
        if(moveCallback){
            moveCallback()
        }
        isImageartMove = true;
        $scope.$apply();
    }
    //鼠标抬起事件
    window.onmouseup = function ($event) {
        moveItem = [];
        if(isImageartDown && isImageartMove){
            moveCallbacks.forEach(function(cb) {
                cb();
            });
        }
        moveCallbacks = [];
        isImageartMove = false;
        isImageartDown = false;
        $event.stopPropagation();
    }
}

function coordinates(page,levelI) {
    var _data={
        x:[0,page.mediabox.width],
        y:[0,page.mediabox.height],
    }
    // if(page&&page.levels.level){
    //     page.levels.level.forEach(function (level,index) {
    //         if(levelI != index){
    //             var _coordinate = null;
    //             if(level.imagebox&&level.imagebox.geometry){
    //                 _coordinate = coordinatesItem(level.imagebox.geometry,level.imagebox.rotation.angle);
    //             }
    //             if(level.imageart&&level.imageart.geometry){
    //                 _coordinate = coordinatesItem(level.imageart.geometry,level.imageart.rotation.angle);
    //             }
    //             if(level.textbox&&level.textbox.geometry){
    //                 _coordinate = coordinatesItem(level.textbox.geometry,level.textbox.rotation.angle);
    //             }
    //             if(level.textdocument&&level.textdocument.geometry){
    //                 _coordinate = coordinatesItem(level.textdocument.geometry,level.textdocument.rotation.angle);
    //             }
    //             if(level.calTitleBox&&level.calTitleBox.geometry){
    //                 _coordinate = coordinatesItem(level.calTitleBox.geometry,level.calTitleBox.rotation.angle);
    //             }
    //             if(level.calMonthBox&&level.calMonthBox.geometry){
    //                 _coordinate = coordinatesItem(level.calMonthBox.geometry,level.calMonthBox.rotation.angle);
    //             }
    //             if(_coordinate){
    //                 _data.x = _data.x.concat(_coordinate.x);
    //                 _data.y = _data.y.concat(_coordinate.y);
    //             }
    //         }
    //     })
    // }
    return _data
}
function coordinatesItem(geometry,angle) {
    var x0 = geometry.x;
    var y0 = geometry.y;
    var x1 = geometry.x + geometry.width;
    var y1 = geometry.y + geometry.height;
    var outer = outerRectangle(x0, y0, x1, y1, angle);
    return {
        x:[outer.x, outer.x1],
        y:[outer.y, outer.y1],
    }
}
function getItemCoordinates(box,coordinates,callback) {
    var _thisItem = coordinatesItem(box.geometry,box.rotation.angle);
    var _x = approach(_thisItem.x, coordinates.x);
    var _y = approach(_thisItem.y, coordinates.y);
    var _z = {};
    if(_x.minDiff < 10){
        _z.x=_x;
    }
    if(_y.minDiff < 10){
        _z.y=_y;
    }
    callback(_z)
}

function approach(a,b) {
    var _a = a[0];
    var closestNum = b[0]; // 初始化最接近的数字为b数组的第一个元素
    var minDiff = Math.abs(a[0] - closestNum); // 初始化差值绝对值为a数组第一个元素与最接近数字的差值

    for (var i = 0; i < a.length; i++) {
        for (var j = 0; j < b.length; j++) {
            var diff = Math.abs(a[i] - b[j]); // 计算差值绝对值
            if (diff < minDiff) { // 如果差值绝对值更小，更新最接近数字和最小差值绝对值
                minDiff = diff;
                closestNum = b[j];
                _a = a[i];
            }
        }
    }
    return {
        a:_a,
        closestNum:closestNum,
        minDiff:minDiff,
        diff:_a > closestNum ? -minDiff : minDiff,
    }
}
//素材缩放
var isImageartZoom = false;
function imageartZoom($scope, $event,item, direction, ratio,editbox, callback) {
    if(item.lock){return}
    var x = $event.clientX;
    var y = $event.clientY;
    //获取w和h
    var nw = angular.copy(item.geometry.width) * ratio;
    var nh = angular.copy(item.geometry.height) * ratio;
    var nw1 = angular.copy(item.width) * ratio;
    var nh1 = angular.copy(item.height) * ratio;
    var x1 = angular.copy(item.offsetx * ratio);
    var y1 = angular.copy(item.offsety * ratio);
    var x2 = item.geometry.x * ratio;
    var y2 = item.geometry.y * ratio;
    var _scale = angular.copy(item.scale);
    var _left = $($event.target).parents('.selected').offset().left + (nw/2);
    var _top = $($event.target).parents('.selected').offset().top + (nh/2);
    var x3 = Math.abs(_left - $event.clientX);
    var y3 = Math.abs(_top - $event.clientY);
    var distance = Math.sqrt(Math.pow(x3, 2) + Math.pow(y3, 2));
    //开关打开
    isImageartZoom = true;
    //鼠标移动
    window.onmousemove = function (e) {
        if (isImageartZoom == false) {
            return;
        }
        var nl = 0;
        var x = Math.abs(_left + nl - e.clientX);
        var y = Math.abs(_top - e.clientY);
        var z = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
        nl = (parseInt(z - distance)) / ratio;
        var _w = (Number(nw) + Number(nl));
        var _h = _w / nw * nh;
        if(_w > 20){
            item.geometry.width = _w / ratio;
            item.geometry.height = _h / ratio;
            item.geometry.x = (x2 - (_w - nw)/2) / ratio;
            item.geometry.y = (y2 - (_h - nh)/2) / ratio;
            item.offsetx = (_w / (nw / nw1)) / (nw1 / x1) / ratio;
            item.offsety = (_h / (nh / nh1)) / (nh1 / y1) / ratio;
        }
        $scope.$apply();
    }
    //鼠标抬起事件
    window.onmouseup = function ($event) {
        if(isImageartZoom){
            callback()
        }
        isImageartZoom = false;
        $event.stopPropagation();
    }
}

/*******************************************文字处理*************************************************************************/
//添加文字
function textboxWebAdd(defaultFont, fontStyles, size, callback) {
    var _font = {
        geometry: {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        },
        rotation: {
            angle: '0'
        },
        text: '双击输入文字',
        style: {
            font: defaultFont.family,
            size: size,
            color: '#000000',
            bold: false,
            italic: false,
            lineheight: size,
            letterspacing: 0,
            align: 'left',
            writingmode:'horizontal-tb'
        },
        fontuuid: defaultFont.uuid,
        identifier: "",
        editable: true,
        movable: true,
        lock: false,
        version: '2.0',
        transparency: '1',
        selected: true,
        loading: true,
        useradded: true,
        current: 'textbox',
    };
    var _fontStyle = [];
    for(var j=0; j<fontStyles.length; j++){
        _fontStyle.push(fontStyles[j].style)
    }
    if(_fontStyle.indexOf('NORMAL') != '-1'){
        _font.style.bold = false;
        _font.style.italic = false;
    }else {
        if(_fontStyle.indexOf('BOLD_ITALIC') != '-1'){
            _font.style.bold = true;
            _font.style.italic = true;
        }else {
            if(_fontStyle.indexOf('ITALIC') != '-1'){
                _font.style.italic = true;
                _font.style.bold = false;
            }
            if(_fontStyle.indexOf('BOLD') != '-1'){
                _font.style.bold = true;
                _font.style.italic = false;
            }
        }
    }
    callback(_font)
}

// ptSrc: 圆上某点(初始点);
// ptRotationCenter: 圆心点;
// angle: 旋转角度° -- [angle * M_PI / 180]:将角度换算为弧度
// 【注意】angle 逆时针为正，顺时针为负
function rotatePoint(ptSrc, ptRotationCenter, angle){
    var a = ptRotationCenter.x;
    var b = ptRotationCenter.y;
    var x0 = ptSrc.x;
    var y0 = ptSrc.y;
    var rx = a + (x0-a) * Math.cos(angle * Math.PI / 180) - (y0-b) * Math.sin(angle * Math.PI / 180);
    var ry = b + (x0-a) * Math.sin(angle * Math.PI / 180) + (y0-b) * Math.cos(angle * Math.PI / 180);
    var json = {x:rx,y:ry}
    return json;
}
function linePoint_by_x(x, pt0, pt1) {
    if (Math.abs(x - pt0.x) < 1) {
        return {x: x, y: pt0.y};
    }
    if (Math.abs(x - pt1.x < 1)) {
        return {x: x, y: pt1.y};
    }
    if (Math.abs(pt1.x - pt0.x) < 1) {
        return {x: x, y: pt1.y};
    }
    else {
        var y = (x - pt0.x) * (pt1.y - pt0.y) / (pt1.x - pt0.x) + pt0.y;
        return {x: x, y: y};
    }
}

function linePoint_by_y(y, pt0, pt1) {
    if (Math.abs(y - pt0.y) < 1) {
        return {x: pt0.x, y: y};
    }
    if (Math.abs(y - pt1.y) < 1) {
        return {x: pt1.x, y: y};
    }
    if (Math.abs(pt1.y - pt0.y) < 1) {
        return {x: pt1.x, y: y};
    }
    var x = (y - pt0.y) * (pt1.x - pt0.x) / (pt1.y - pt0.y) + pt0.x;
    return {x: x, y: y};

}
function linePoint(pt, pt0, pt1) {
    var pt_by_x = linePoint_by_x(pt.x, pt0, pt1);
    var pt_by_y = linePoint_by_y(pt.y, pt0, pt1);
    var distance1 = Math.pow(pt_by_x.x - pt0.x, 2) + Math.pow(pt_by_x.y - pt0.y, 2);
    var distance2 = Math.pow(pt_by_y.x - pt0.x, 2) + Math.pow(pt_by_y.y - pt0.y, 2);
    if (distance1 >= distance2) {
        return pt_by_x;
    } else {
        return pt_by_y;
    }
}

//文字左右按钮
var isTextDown = false;
function textboxWebZoom($event, item, element, ratio, editbox, callback1, callback2){
    if(item.lock){return}
    fn($event)
    var nw = angular.copy(item.geometry.width);
    var nh = angular.copy(item.geometry.height);
    var left = angular.copy(item.geometry.x);
    var top = angular.copy(item.geometry.y);
    var x2 = item.geometry.x;
    var y2 = item.geometry.y;
    var _cx = $($event.target).parents('.selected').offset().left + (nw*ratio/2);
    var _cy = $($event.target).parents('.selected').offset().top + (nh*ratio/2);
    var angle = Number(item.rotation.angle);
    var pt0 = rotatePoint({x: $event.clientX, y: $event.clientY}, {x: _cx, y: _cy}, -angle);
    // 鼠标起始点
    var x0 = pt0.x;
    var y0 = pt0.y;

    var dx0 = 1;
    var dy0 = 1;
    if (x0 < _cx) {
        dx0 = _cx - x0;
    } else {
        dx0 = x0 - _cx;
    }
    if (y0 < _cy) {
        dy0 = _cy - y0;
    } else {
        dy0 = y0 - _cy;
    }

    //开关打开
    isTextDown = true;
    //鼠标移动
    window.onmousemove = function (e) {
        if (isTextDown == false) {
            return;
        }
        var pt1 = rotatePoint({x: e.clientX, y: e.clientY}, {x: _cx, y: _cy}, -angle);
        // 鼠标坐标
        var x1 = pt1.x;
        var y1 = pt1.y;

        var dx = 0;
        var dy = 0;
        if (x0 < _cx) {
            dx = _cx - x1;
        } else {
            dx = x1 - _cx;
        }
        if (y0 < _cy) {
            dy = _cy - y1;
        } else {
            dy = y1 - _cy;
        }
        var _w ;
        if (dx0 > 1) {
            _w = (Number(nw) + Number(nw * (dx - dx0)/dx0));
        } else {
            _w = nw;
        }
        var _h;
        if (dy0 > 1) {
            _h = (Number(nh) + Number(nh * (dy - dy0)/dy0));
        } else {
            _h = nh;
        }

        if (_w < 13.175) {
            _w = 13.175;
        }
        if (_h < 13.175) {
            _h = 13.175;
        }

        if (element == 'left' || element == 'right') {
            item.geometry.width = _w;
            item.geometry.x = (x2 - (_w - nw)/2);
        }else{
            item.geometry.height = _h;
            item.geometry.y = (y2 - (_h - nh)/2);
        }
        callback1(item)
        $event.stopPropagation();
    }
    //鼠标抬起事件
    window.onmouseup = function ($event) {
        if(isTextDown){
            callback2(item)
        }
        isTextDown = false;
        $event.stopPropagation();
    }
};
function textboxWebZoom1($event, item, element, ratio, callback1, callback2){
    if(item.lock){return}
    fn($event)
    //获取w和h
    var nw = angular.copy(item.geometry.width);
    var nh = angular.copy(item.geometry.height);

    var _size = angular.copy(parseInt(item.style.size));
    var _lineheight = angular.copy(parseInt(item.style.lineheight));
    // box起始点(mm)
    var x2 = item.geometry.x;
    var y2 = item.geometry.y;
    // 中心点(屏幕缩放)
    var target = $($event.target).parents('.selected');
    var _cx = target.offset().left + target.width() / 2;
    var _cy = target.offset().top + target.height() / 2;
    var angle = (Number(item.rotation.angle) + 360) % 360;
    var pt0 = rotatePoint({x: $event.clientX, y: $event.clientY}, {x: _cx, y: _cy}, -angle);

    // 鼠标起始点
    var x0 = pt0.x;
    var y0 = pt0.y;

    var dx0 = 1;
    var dy0 = 1;
    switch (element) {
        case 'left': {// left-top
            dx0 = _cx - x0;
            dy0 = _cy - y0;
            break;
        }
        case "top": { // right-top
            dx0 = x0 - _cx;
            dy0 = _cy - y0;
            break;
        }
        case 'right':  { // right-bottom
            dx0 = x0 - _cx;
            dy0 = y0 - _cy;
            break;
        }
        case 'bottom':  {// left-bottom
            dx0 = _cx - x0;
            dy0 = y0 - _cy;
            break;
        }
        default:
            return;
    }
    var delta0 = Math.sqrt(dx0 * dx0 + dy0 * dy0);
    // if (x0 < _cx) {
    //     dx0 = _cx - x0;
    // } else {
    //     dx0 = x0 - _cx;
    // }
    // if (y0 < _cy) {
    //     dy0 = _cy - y0;
    // } else {
    //     dy0 = y0 - _cy;
    // }

    //开关打开
    isTextDown = true;
    //鼠标移动
    window.onmousemove = function (e) {
        if (isTextDown == false) {return;}
        // 鼠标坐标
        var pt1 = rotatePoint({x: e.clientX, y: e.clientY}, {x: _cx, y: _cy}, -angle);
        // pt1 = linePoint(pt11, {x: _cx, y: _cy}, pt0);
        var x1 = pt1.x;
        var y1 = pt1.y;

        var dx = 0;
        var dy = 0;
        switch (element) {
            case 'left': {// left-top
                dx = _cx - x1;
                dy = _cy - y1;
                break;
            }
            case "top": { // right-top
                dx = x1 - _cx;
                dy = _cy - y1;
                break;
            }
            case 'right':  { // right-bottom
                dx = x1 - _cx;
                dy = y1 - _cy;
                break;
            }
            case 'bottom':  {// left-bottom
                dx = _cx - x1;
                dy = y1 - _cy;
                break;
            }
            default:
                return;
        }
        if (dx*dx0 < 0 || dy*dy0 < 0) {
            return;
        }
        var delta = Math.sqrt(dx * dx + dy * dy);

        // if (x0 < _cx) {
        //     if (x1 > _cx) return;
        //     dx = _cx - x1;
        // } else {
        //     if (x1 < _cx) return;
        //     dx = x1 - _cx;
        // }
        // if (y0 < _cy) {
        //     if (y1 > _cy) return;
        //     dy = _cy - y1;
        // } else {
        //     if (y1 < _cy) return;
        //     dy = y1 - _cy;
        // }
        var _w ;
        if (Math.abs(delta0) > 1) {
            _w = Number(nw * delta / delta0);
        } else {
            _w = nw;
        }
        var _h;
        if (Math.abs(delta0) > 1) {
            _h = Number(nh * delta / delta0);
        } else {
            _h = nh;
        }

        var size1 = Math.ceil(_w / nw * _size);
        if (_w < 13.175) {
            _w = 13.175;
        }
        if (_h < 13.175) {
            _h = 13.175;
        }
        if (size1 < 9) {
            size1 = 9;
        }

        item.geometry.width = _w;
        item.geometry.height = _h;
        item.geometry.x = (x2 - (_w - nw)/2);
        item.geometry.y = (y2 - (_h - nh)/2);
        item.style.size = size1;
        item.style.lineheight = Math.floor((size1 / _size * _lineheight));
        callback1(item);
        $event.stopPropagation();
    }
    //鼠标抬起事件
    window.onmouseup = function ($event) {
        if(isTextDown){
            callback2(item)
        }
        isTextDown = false;
        $event.stopPropagation();
    }
}
/*******************************************文字模板处理*************************************************************************/

var TjTools = {
    canvas: null
}
function getTextWidthInternal(text, fontWeight, fontStyle, fontSize, fontFamily) {
    // re-use canvas object for better performance
    var canvas = TjTools.canvas || (TjTools.canvas = document.createElement('canvas'));
    var context = canvas.getContext('2d');
    context.font = (fontWeight || 'normal') + ' ' +
        (fontSize + 'pt') + ' ' +
        (fontFamily || '') + ' ' + (fontStyle || 'normal');
    var metrics = context.measureText('陈');
    return metrics.height + 6;
}
function textDocWebAdd($scope, $http, level, textdocument, editbox, mediabox, callback, callback1) {
    level.textdocument = {
        background: textdocument.background,
        geometry: {
            width: transitionPx(textdocument.geometry.width),
            height: transitionPx(textdocument.geometry.height),
            x: transitionPx(textdocument.geometry.x),
            y: transitionPx(textdocument.geometry.y)
        },
        rotation: {
            angle:-textdocument.rotation.angle||0
        },
        current: 'textdocument',
        levels: angular.copy(textdocument.levels),
        lock: false,
        transparency: textdocument.transparency,
        movable: textdocument.movable,
        useradded:true,
        editable: textdocument.editable,
        scale:textdocument.geometry.width/mediabox.width,
    }
    if (level.textdocument.background && level.textdocument.background.resource &&level.textdocument.background.resource.identifier) {
        getBackgroundSource($http, level.textdocument.background.resource, level.textdocument.geometry.width, level.textdocument.geometry.height, level.textdocument.background, $scope);
        level.textdocument.background.offsetx = transitionPx(level.textdocument.background.offsetx);
        level.textdocument.background.offsety = transitionPx(level.textdocument.background.offsety);
        level.textdocument.background.type = 'Pic'
    }

    angular.forEach(level.textdocument.levels.level, function (lev1, l1) {
        (function (lev,l) {
            if (lev.imageart && lev.imageart.geometry) {
                lev.imageart.offsetx = transitionPx(lev.imageart.offsetx);
                lev.imageart.offsety = transitionPx(lev.imageart.offsety);
                lev.imageart.geometry = {
                    width: transitionPx(lev.imageart.geometry.width),
                    height: transitionPx(lev.imageart.geometry.height),
                    x: transitionPx(lev.imageart.geometry.x),
                    y: transitionPx(lev.imageart.geometry.y)
                };
                lev.imageart.rotation.angle = -lev.imageart.rotation.angle;
                if (lev.imageart.resource.identifier) {
                    getBackgroundSource($http, lev.imageart.resource, lev.imageart.geometry.width, lev.imageart.geometry.height, lev.imageart, $scope);
                }
            }
            if (lev.textbox && lev.textbox.geometry) {
                var text = lev.textbox;
                lev.textbox.geometry = {
                    width: transitionPx(lev.textbox.geometry.width),
                    height: transitionPx(lev.textbox.geometry.height),
                    x: transitionPx(lev.textbox.geometry.x),
                    y: transitionPx(lev.textbox.geometry.y)
                };
                lev.textbox.rotation.angle = -lev.textbox.rotation.angle;
            }
        })(lev1,l1)
    })
    level.textdocument.geometry.x = (editbox.width - level.textdocument.geometry.width) / 2 + editbox.x;
    level.textdocument.geometry.y = (editbox.height - level.textdocument.geometry.height) / 2 + editbox.y;
    callback(level)
}

//保存doments转换MM
function documentWebMM(template,text) {
    var _template = angular.copy(template);
    angular.forEach(_template.pages.page, function (page, index) {
        page.recommendLayout = null;
        if (page.editbox == null) {
            page.editbox = page.trimbox;
        }
        page.editbox = {
            width: transitionMm(page.editbox.width),
            height: transitionMm(page.editbox.height),
            x: transitionMm(page.editbox.x),
            y: transitionMm(page.editbox.y)
        };
        if(page.editboxes && page.editboxes.editbox){
            page.editboxes.editbox.forEach(function (editbox, editboxIndex) {
                page.editboxes.editbox[editboxIndex] = {
                    width: transitionMm(editbox.width),
                    height: transitionMm(editbox.height),
                    x: transitionMm(editbox.x),
                    y: transitionMm(editbox.y)
                }
            })
        }
        page.mediabox = {
            width: transitionMm(page.mediabox.width),
            height: transitionMm(page.mediabox.height),
            x: transitionMm(page.mediabox.x),
            y: transitionMm(page.mediabox.y)
        };
        page.trimbox = {
            width: transitionMm(page.trimbox.width),
            height: transitionMm(page.trimbox.height),
            x: transitionMm(page.trimbox.x),
            y: transitionMm(page.trimbox.y)
        };
        page.custom = {};
        if(page.scene){
            page.scene.geometry = {
                width: transitionMm(page.scene.geometry.width),
                height: transitionMm(page.scene.geometry.height),
                x: transitionMm(page.scene.geometry.x),
                y: transitionMm(page.scene.geometry.y)
            };
            page.scene.imagebox.geometry = {
                width: transitionMm(page.scene.imagebox.geometry.width),
                height: transitionMm(page.scene.imagebox.geometry.height),
                x: transitionMm(page.scene.imagebox.geometry.x),
                y: transitionMm(page.scene.imagebox.geometry.y)
            };
        }
        //条形码
        if(page.barcode){
            page.barcode.geometry = {
                width: transitionMm(page.barcode.geometry.width),
                height: transitionMm(page.barcode.geometry.height),
                x: transitionMm(page.barcode.geometry.x),
                y: transitionMm(page.barcode.geometry.y)
            };
        }
        if(page.qrcode){
            page.qrcode.geometry = {
                width: transitionMm(page.qrcode.geometry.width),
                height: transitionMm(page.qrcode.geometry.height),
                x: transitionMm(page.qrcode.geometry.x),
                y: transitionMm(page.qrcode.geometry.y)
            };
        }

        //背景
        if(page.background && page.background.resource && page.background.resource.identifier){
            page.background.offsetx = transitionMm(page.background.offsetx);
            page.background.offsety = transitionMm(page.background.offsety);
        }
        angular.forEach(page.levels.level, function (level, i) {
            if (level.code && level.code.geometry) {
                level.code.geometry = {
                    height: transitionMm(level.code.geometry.height),
                    width: transitionMm(level.code.geometry.width),
                    x: transitionMm(level.code.geometry.x),
                    y: transitionMm(level.code.geometry.y)
                };
            }
            if(level.imageart && level.imageart.geometry){
                level.imageart.rotation.angle = -level.imageart.rotation.angle;
                level.imageart.offsetx = transitionMm(level.imageart.offsetx);
                level.imageart.offsety = transitionMm(level.imageart.offsety);
                level.imageart.geometry = {
                    width: transitionMm(level.imageart.geometry.width),
                    height: transitionMm(level.imageart.geometry.height),
                    x: transitionMm(level.imageart.geometry.x),
                    y: transitionMm(level.imageart.geometry.y)
                };
            }
            if(level.imagebox && level.imagebox.geometry){
                level.imagebox.rotation.angle = -level.imagebox.rotation.angle;
                level.imagebox.geometry = {
                    width: transitionMm(level.imagebox.geometry.width),
                    height: transitionMm(level.imagebox.geometry.height),
                    x: transitionMm(level.imagebox.geometry.x),
                    y: transitionMm(level.imagebox.geometry.y)
                };
                if(level.imagebox.blurredrectangle){
                    level.imagebox.blurredrectangle = {
                        width: transitionMm(level.imagebox.blurredrectangle.width),
                        height: transitionMm(level.imagebox.blurredrectangle.height),
                        x: transitionMm(level.imagebox.blurredrectangle.x),
                        y: transitionMm(level.imagebox.blurredrectangle.y)
                    };
                }
                if(level.imagebox.image && level.imagebox.image.resource && level.imagebox.image.resource.identifier){
                    level.imagebox.image.width = transitionMm(level.imagebox.image.width);
                    level.imagebox.image.height = transitionMm(level.imagebox.image.height);
                    level.imagebox.image.offsetx = transitionMm(level.imagebox.image.offsetx);
                    level.imagebox.image.offsety = transitionMm(level.imagebox.image.offsety);

                    if(!_template.galleriesAll){
                        _template.galleriesAll = [];
                    }
                    _template.galleriesAll.push({
                        height: level.imagebox.image.height,
                        id: level.imagebox.image.resourceid,
                        identifier: level.imagebox.image.resource.identifier,
                        imgsize: level.imagebox.image.imgsize,
                        name: null,
                        provider: "qiniu",
                        usenum: 1,
                        width: level.imagebox.image.width
                    })
                }

            }
            if(level.textbox && level.textbox.geometry){
                if (!(level.textbox.text == '' || level.textbox.text == null || level.textbox.text == '双击输入文字' || level.textbox.text == '请输入文字' || level.textbox.text == text) && (level.textbox.geometry.width != 0 && level.textbox.geometry.height != 0)) {
                    level.textbox.rotation.angle = -level.textbox.rotation.angle;
                    level.textbox.geometry = {
                        width: transitionMm(level.textbox.geometry.width),
                        height: transitionMm(level.textbox.geometry.height),
                        x: transitionMm(level.textbox.geometry.x),
                        y: transitionMm(level.textbox.geometry.y)
                    };
                }else{
                    level.textbox = null;
                }
            }
            if (level.textdocument && level.textdocument.geometry) {
                level.textdocument.rotation.angle = -level.textdocument.rotation.angle;
                level.textdocument.geometry = {
                    width: transitionMm(level.textdocument.geometry.width),
                    height: transitionMm(level.textdocument.geometry.height),
                    x: transitionMm(level.textdocument.geometry.x),
                    y: transitionMm(level.textdocument.geometry.y)
                };

                var backg = level.textdocument.background;
                if(backg.resource.identifier){
                    backg.offsetx = transitionMm(backg.offsetx);
                    backg.offsety = transitionMm(backg.offsety);
                }

                angular.forEach(level.textdocument.levels.level, function (lev, l) {
                    if (lev.imageart && lev.imageart.geometry) {
                        var art = lev.imageart;
                        art.geometry={
                            width: transitionMm(art.geometry.width),
                            height: transitionMm(art.geometry.height),
                            x: transitionMm(art.geometry.x),
                            y: transitionMm(art.geometry.y)
                        };
                        art.offsetx= transitionMm(art.offsetx);
                        art.offsety= transitionMm(art.offsety);
                    }
                    if (lev.textbox && lev.textbox.geometry) {
                        var text = lev.textbox;
                        text.geometry={
                            width: transitionMm(text.geometry.width),
                            height: transitionMm(text.geometry.height),
                            x: transitionMm(text.geometry.x),
                            y: transitionMm(text.geometry.y)
                        };
                    }
                })
            }
            if (level.calTitleBox && level.calTitleBox.geometry) {
                var _calTitleBox = angular.copy(level.calTitleBox);
                level.calTitleBox.geometry = {
                    width: transitionMm(level.calTitleBox.geometry.width),
                    height: transitionMm(level.calTitleBox.geometry.height),
                    x: transitionMm(level.calTitleBox.geometry.x),
                    y: transitionMm(level.calTitleBox.geometry.y)
                };
                level.calTitleBox.rotation.angle = -level.calTitleBox.rotation.angle;
                level.calTitleBox.settings={
                    border:level.calTitleBox.settings.border,
                    items:{
                        item:angular.copy(_calTitleBox.settings.items.item?_calTitleBox.settings.items.item:_calTitleBox.settings.items)
                    }
                };
                level.calTitleBox.layout={
                    geometry: {
                        width:level.calTitleBox.layout.width,
                        height:level.calTitleBox.layout.height,
                        x:0,
                        y:0,
                    },
                    previewUrl:level.calTitleBox.layout.previewUrl,
                    type:level.calTitleBox.layout.type,
                    items:{
                        item:angular.copy(_calTitleBox.layout.items.item?_calTitleBox.layout.items.item:_calTitleBox.layout.items),
                    }
                };
                level.calTitleBox.layout.items.item.forEach(function (item) {
                    item.geometry = {
                        width:item.w,
                        height:item.h,
                        x:item.x,
                        y:item.y,
                    }
                })
                level.calTitleBox.settings.items.item.forEach(function (item) {
                    item.geometry = {
                        width:item.w>=0?item.w:item.geometry.width,
                        height:item.h>=0?item.h:item.geometry.height,
                        x:item.x>=0?item.x:item.geometry.x,
                        y:item.y>=0?item.y:item.geometry.y,
                    }
                })
            }
            if (level.calMonthBox && level.calMonthBox.geometry) {
                var _calMonthBox = angular.copy(level.calMonthBox);
                level.calMonthBox.geometry = {
                    width: transitionMm(level.calMonthBox.geometry.width),
                    height: transitionMm(level.calMonthBox.geometry.height),
                    x: transitionMm(level.calMonthBox.geometry.x),
                    y: transitionMm(level.calMonthBox.geometry.y)
                };
                level.calMonthBox.rotation.angle = -level.calMonthBox.rotation.angle;

                level.calMonthBox.weekStyles={item:angular.copy(_calMonthBox.weekStyles.item?_calMonthBox.weekStyles.item:_calMonthBox.weekStyles)};
                level.calMonthBox.weekLayout={
                    geometry: {
                        width:level.calMonthBox.weekLayout.width,
                        height:level.calMonthBox.weekLayout.height,
                        x:0,
                        y:0,
                    },
                    items:{
                        item:angular.copy(_calMonthBox.weekLayout.items.item?_calMonthBox.weekLayout.items.item:_calMonthBox.weekLayout.items)
                    },
                    type:level.calMonthBox.weekLayout.type,
                    previewUrl:level.calMonthBox.weekLayout.previewUrl,
                };
                level.calMonthBox.weekLayout.items.item.forEach(function (weekLayout) {
                    weekLayout.geometry = {
                        width:weekLayout.w,
                        height:weekLayout.h,
                        x:weekLayout.x,
                        y:weekLayout.y,
                    }
                })
                level.calMonthBox.dateStyles={item:angular.copy(_calMonthBox.dateStyles.item?_calMonthBox.dateStyles.item:_calMonthBox.dateStyles)},
                    level.calMonthBox.dateLayout={
                        geometry: {
                            width:level.calMonthBox.dateLayout.width,
                            height:level.calMonthBox.dateLayout.height,
                            x:0,
                            y:0,
                        },
                        items:{
                            item:angular.copy(_calMonthBox.dateLayout.items.item?_calMonthBox.dateLayout.items.item:_calMonthBox.dateLayout.items)
                        },
                        type:level.calMonthBox.dateLayout.type,
                        previewUrl:level.calMonthBox.dateLayout.previewUrl
                    };
                level.calMonthBox.dateLayout.items.item.forEach(function (dateLayout) {
                    dateLayout.geometry = {
                        width:dateLayout.w,
                        height:dateLayout.h,
                        x:dateLayout.x,
                        y:dateLayout.y,
                    }
                })
                level.calMonthBox.weekStyles.item.forEach(function (weekStyle) {
                    var _items = angular.copy(weekStyle.items.item?weekStyle.items.item:weekStyle.items);
                    _items.forEach(function (_item){
                        _item.geometry = {
                            width:_item.w,
                            height:_item.h,
                            x:_item.x,
                            y:_item.y,
                        }
                    })
                    weekStyle.items = {
                        item:_items
                    }
                })
                level.calMonthBox.dateStyles.item.forEach(function (dateStyle) {
                    var _items = angular.copy(dateStyle.items.item?dateStyle.items.item:dateStyle.items);
                    _items.forEach(function (_item){
                        _item.geometry = {
                            width:_item.w,
                            height:_item.h,
                            x:_item.x,
                            y:_item.y,
                        }
                    })
                    dateStyle.items = {
                        item:_items
                    }
                })
            }
        })
    })
    _template.version= '4.0';
    return _template;
}
//排序
function sortItem(item) {
    return function(object1, object2) {
        var value1 = object1[item];
        var value2 = object2[item];
        return value1 - value2;
    }
}

//移动画布
var isMoveCanvas = false;
function moveCanvas($event, callback) {
    var x = $event.clientX;
    var y = $event.clientY;
    isMoveCanvas = true;
    //鼠标移动
    window.onmousemove = function (e) {
        if (!isMoveCanvas) {
            return;
        }
        callback(e.clientX - x, e.clientY - y)
    };
    //鼠标抬起事件
    window.onmouseup = function ($event) {
        isMoveCanvas = false;
    }
}

function writingmodeInit(item) {
    if(item == 'vertical-lr' || item == 'vertical-rl'){
        return true
    }else{
        return false
    }
}

//判断元素是否在编辑区域内
function editboxIn(editboxs, item1, angle) {
    var item = angular.copy(item1);
    if(item1.border){
        if(item1.border.type == 'Color' && item1.border.lineWidth>0){
            item.x = Number(item.x) - Number(item1.border.lineWidth);
            item.y = Number(item.y) - Number(item1.border.lineWidth);
            item.width = Number(item.width) + Number(item1.border.lineWidth)*2;
            item.height = Number(item.height) - Number(item1.border.lineWidth)*2;
        }
        // if(item1.border.type == 'Pic'){
        //     item.x = Number(item.x) - (Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100)
        //     item.y = Number(item.y) - (Number(imagebox.geometry.height) * Number(imagebox.border.edge.top) / 100)
        //     item.width = Number(item.width) + (Number(imagebox.geometry.width) * Number(imagebox.border.edge.left) / 100)
        //     item.height = Number(item.height) - Number(item1.border.lineWidth)*2
        // }
    }
    var exist = false;
    var _itemcx = item.x + item.width/2;
    var _itemcy = item.y + item.height/2;
    var _item={
        left: coordinateX(angle, item.x, item.y, _itemcx, _itemcy),
        top: coordinateX(angle,(item.x + item.width), item.y, _itemcx, _itemcy),
        right: coordinateX(angle,(item.x + item.width), (item.y + item.height), _itemcx, _itemcy),
        bottom: coordinateX(angle,item.x, (item.y + item.height), _itemcx, _itemcy),
    };
    var _editboxs=[];
    editboxs.forEach(function (editbox) {
        var cx = editbox.x + editbox.width/2;
        var cy = editbox.y + editbox.height/2;
        _editboxs.push({
            left: coordinateX(0, editbox.x, editbox.y, cx, cy),
            top: coordinateX(0,(editbox.x + editbox.width), editbox.y, cx, cy),
            right: coordinateX(0,(editbox.x + editbox.width), (editbox.y + editbox.height), cx, cy),
            bottom: coordinateX(0,editbox.x, (editbox.y + editbox.height), cx, cy),
        })
    });
    _editboxs.forEach(function (_editbox) {
        var _IsPointInMatrix = true;
        for(var key in _item){
            if(!IsPointInMatrix(_editbox.left,_editbox.top,_editbox.right,_editbox.bottom,_item[key])){
                _IsPointInMatrix = false;
                break
            }
        }
        if(_IsPointInMatrix){
            exist = true;
        }
    });
    return exist
}

function GetCross(p1, p2, p) {
    return (p2.x - p1.x) * (p.y - p1.y) - (p.x - p1.x) * (p2.y - p1.y);
}
//判断点p是否在p1p2p3p4的正方形内
function IsPointInMatrix(p1, p2, p3, p4, p) {
    var isPointIn = GetCross(p1, p2, p) * GetCross(p3, p4, p) >= 0 && GetCross(p2, p3, p) * GetCross(p4, p1, p) >= 0;
    return isPointIn;
}
// q - 旋转角度
// x1,y1 - 原始坐标
// x0，y0 - 中心点
// c - 两点距离
function coordinateX(q, x1, y1, x0, y0) {
    var angle = q || 0;
    var radius = angle * Math.PI / 180;
    var p2 = {
        x: (x1 - x0) * Math.cos(radius) + (y1 - y0) * Math.sin(radius) + x0,
        y: -(x1 - x0) * Math.sin(radius) + (y1 - y0) * Math.cos(radius) + y0
    };
    return p2;
}


/*
    x0,y0,左上角坐标
    x1,y1,右下角坐标
    angle,旋转角度
    return 旋转后大盒子宽高，坐标
*/
function outerRectangle(x0, y0, x1, y1, angle) {
    var angle = angle || 0;
    var cx = (x0 + x1) / 2;
    var cy = (y0 + y1) / 2;
    var pt0 = rotatePoint({x: x0, y: y0}, {x: cx, y: cy}, angle);
    var pt1 = rotatePoint({x: x1, y: y0}, {x: cx, y: cy}, angle);
    var pt2 = rotatePoint({x: x1, y: y1}, {x: cx, y: cy}, angle);
    var pt3 = rotatePoint({x: x0, y: y1}, {x: cx, y: cy}, angle);

    var minX = Math.min(pt0.x, pt1.x, pt2.x, pt3.x);
    var minY = Math.min(pt0.y, pt1.y, pt2.y, pt3.y);
    var maxX = Math.max(pt0.x, pt1.x, pt2.x, pt3.x);
    var maxY = Math.max(pt0.y, pt1.y, pt2.y, pt3.y);

    return {
        x: minX,
        y: minY,
        x1:maxX,
        y1:maxY,
        width: maxX - minX,
        height: maxY - minY
    };
}


//画布上下左右对齐，贴边
function elementAlign(item, angle, direction, pageWidth, pageHeight) {
    var x0 = item.x;
    var y0 = item.y;
    var x1 = item.x + item.width;
    var y1 = item.y + item.height;
    var outer = outerRectangle(x0, y0, x1, y1, angle);
    if(direction == 'left') {
        return (outer.width-item.width)/2
    }
    if(direction == 'right') {
        return pageWidth - item.width - (outer.width - item.width)/2
    }
    if(direction == 'top') {
        return (outer.height-item.height)/2
    }
    if(direction == 'bottom') {
        return pageHeight - item.height - (outer.height - item.height)/2
    }
}

/*
    计算旋转后的元素外框四点坐标
    x0,y0,左上角坐标
    x1,y1,右下角坐标
    angle,旋转角度
    return 旋转后大盒子宽高，坐标
*/
function outerRectangle2(x0, y0, x1, y1, angle) {
    var angle = angle || 0;
    var cx = (x0 + x1) / 2;
    var cy = (y0 + y1) / 2;
    var pt0 = rotatePoint({x: x0, y: y0}, {x: cx, y: cy}, angle);
    var pt1 = rotatePoint({x: x1, y: y0}, {x: cx, y: cy}, angle);
    var pt2 = rotatePoint({x: x1, y: y1}, {x: cx, y: cy}, angle);
    var pt3 = rotatePoint({x: x0, y: y1}, {x: cx, y: cy}, angle);

    var minX = Math.min(pt0.x, pt1.x, pt2.x, pt3.x);
    var minY = Math.min(pt0.y, pt1.y, pt2.y, pt3.y);
    var maxX = Math.max(pt0.x, pt1.x, pt2.x, pt3.x);
    var maxY = Math.max(pt0.y, pt1.y, pt2.y, pt3.y);

    return {
        minX: minX,
        minY: minY,
        maxX: maxX,
        maxY: maxY
    };
}


// 多元素水平垂直居中对齐
function horizontalAndVerticalCenter(attr, all){
    var allX = [];
    var allY = [];
    all.forEach(function(box){
        var outer = outerRectangle2(box.geometry.x, box.geometry.y, box.geometry.x + box.geometry.width, box.geometry.y + box.geometry.height, box.rotation.angle);
        allX.push(outer.minX);
        allY.push(outer.minY);
        allX.push(outer.maxX);
        allY.push(outer.maxY);
    })
    var minX = Math.min.apply(null, allX);
    var minY = Math.min.apply(null, allY);
    var maxX = Math.max.apply(null, allX);
    var maxY = Math.max.apply(null, allY);
    if (attr == 'vertical') {
        return maxY - (maxY - minY)/2;
    }
    if (attr == "standard") {
        return maxX - (maxX - minX)/2;
    }
}

//文字校验
function FontSupport2(FontManagement, font, callback) {
    var type = "";
    if (localStorage.getItem('distinguish') == 'weChatApplet' || localStorage.getItem('distinguish') == 'weChatAppletMake' || !localStorage.getItem('distinguish')) {
        type = "wechat"
    }
    else if (localStorage.getItem('distinguish') == 'toutiaoApp') {
        type = "byteDance"
    }
    else if (localStorage.getItem('distinguish') == 'alipayApp') {
        type = "ali"
    }
    font.success = true;
    FontManagement.fontSupport2({
        uuid: font.fontuuid,
        bold: font.style.bold,
        italic: font.style.italic,
        content: font.text,
        type:type
    }, function (res) {
        if(res.status == 200){
            font.success = res.data.success;
        }
        if(callback){callback(res)}
    }, function (error) {
        if(callback){callback()}
    })
}
function textPaste1(event) {
    event.preventDefault();
    var text;
    var clp = (event.originalEvent || event).clipboardData;
    // 兼容针对于opera ie等浏览器
    if (clp === undefined || clp === null) {
        text = window.clipboardData.getData("text") || "";
        if (text !== "") {
            if (window.getSelection) {
                // 针对于ie11 10 9 safari
                var newNode = document.createElement("span");
                newNode.innerHTML = text;
                window.getSelection().getRangeAt(0).insertNode(newNode);
            } else {
                // 兼容ie10 9 8 7 6 5
                document.selection.createRange().pasteHTML(text);
            }
        }
    } else {
        // 兼容chorme或hotfire
        text = clp.getData('text/plain') || "";
        if (text !== "") {
            document.execCommand('insertText', false, text);
        }
    }
}
function getQueryVariable(url, variable) {
    var query = window.location.href.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
            return pair[1];
        }
    }
    return (false);
}
function getUrlParam() {
    var url = window.location.href.split("?")[1]; //获取url中"?"符后的字符串包括‘？’ ，window.location.href获取的是url完整的字符串
    var theParam = new Object();
    if(url){
        var str = url.substr(0); //substr是字符串的用法之一，抽取指定字符的数目，这里抽取？后的所有字符
        strs = str.split("&"); //将获取到的字符串从&分割，输出参数数组，即输出[参数1=xx,参数2=xx,参数3=xx,...]的数组形式
        for(var i = 0; i < strs.length; i ++) { //遍历参数数组
            theParam[strs[i].split("=")[0]]=unescape(strs[i].split("=")[1]); //这里意思是抽取每个参数等号后面的值，unescape是解码的意思
        }
    }
    return theParam; //返回参数值
}
//编辑器获取dpi
var _dpi = null;
function js_getDPI() {
    if(_dpi){
        return _dpi
    }
    var arrDPI = new Array();
    if (window.screen.deviceXDPI != undefined) {
        arrDPI[0] = window.screen.deviceXDPI;
        arrDPI[1] = window.screen.deviceYDPI;
    } else {
        var tmpNode = document.createElement("DIV");
        tmpNode.style.cssText = "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
        document.body.appendChild(tmpNode);
        arrDPI[0] = parseInt(tmpNode.offsetWidth);
        arrDPI[1] = parseInt(tmpNode.offsetHeight);
        tmpNode.parentNode.removeChild(tmpNode);
    }
    _dpi = arrDPI[1];
    return arrDPI[1];

}
//解析document
function hasMediaboxPxBaseline(page) {
    if (!page.mediabox || !page.mediaboxMM) {
        return false;
    }
    var expectedWidthPx = transitionPx(page.mediaboxMM.width);
    var expectedHeightPx = transitionPx(page.mediaboxMM.height);
    var widthMatchesPx = Math.abs(page.mediabox.width - expectedWidthPx) < 1;
    var heightMatchesPx = Math.abs(page.mediabox.height - expectedHeightPx) < 1;
    return widthMatchesPx && heightMatchesPx;
}

function documentAnalysis($scope,$http, vm, document, FontManagement, flag, callbackRatio, callback) {
    var _imgSum = 0, f = 0;
    angular.forEach(document.pages.page, function (page, index) {
        (function (page, index) {
            page.seq = index;
            if(flag=='jianyi'||flag=='gaoji'){
                page.isMaxWidth = getScale($scope.dWidth, $scope.dHeight, page.mediabox.width, page.mediabox.height, index);
            }
            if (hasMediaboxPxBaseline(page)) {
                if (page.unit != 'px') {
                    console.warn('[documentAnalysis] mediabox is in px but page.unit is not px; preserving the saved mm baseline.', page.uuid);
                }
                page.unit = 'px';
            } else if (page.unit == 'px') {
                page.mediaboxMM = {
                    width: transitionMm(page.mediabox.width),
                    height: transitionMm(page.mediabox.height),
                    x: transitionMm(page.mediabox.x),
                    y: transitionMm(page.mediabox.y)
                };
            } else {
                page.mediaboxMM = angular.copy(page.mediabox);
            }
            page.mediabox = {
                width: page.unit == 'px' ? page.mediabox.width : transitionPx(page.mediabox.width),
                height: page.unit == 'px' ? page.mediabox.height : transitionPx(page.mediabox.height),
                x: page.unit == 'px' ? page.mediabox.x : transitionPx(page.mediabox.x),
                y: page.unit == 'px' ? page.mediabox.y : transitionPx(page.mediabox.y)
            };
            page.trimbox = {
                width: page.unit == 'px' ? page.trimbox.width : transitionPx(page.trimbox.width),
                height: page.unit == 'px' ? page.trimbox.height : transitionPx(page.trimbox.height),
                x: page.unit == 'px' ? page.trimbox.x : transitionPx(page.trimbox.x),
                y: page.unit == 'px' ? page.trimbox.y : transitionPx(page.trimbox.y)
            };
            // 兼容旧模板 可编辑区域
            if (!page.editbox) {
                page.editbox = angular.copy(page.trimbox);
            }else{
                page.editbox = {
                    width: page.unit == 'px' ? page.editbox.width : transitionPx(page.editbox.width),
                    height: page.unit == 'px' ? page.editbox.height : transitionPx(page.editbox.height),
                    x: page.unit == 'px' ? page.editbox.x : transitionPx(page.editbox.x),
                    y: page.unit == 'px' ? page.editbox.y : transitionPx(page.editbox.y)
                };
            }
            if(!page.editboxes || !page.editboxes.editbox){
                page.editboxes = {
                    editbox: [page.editbox]
                }
            }else{
                page.editboxes.editbox.forEach(function (editbox, editboxIndex) {
                    page.editboxes.editbox[editboxIndex] = {
                        width:  page.unit == 'px' ? editbox.width : transitionPx(editbox.width),
                        height:  page.unit == 'px' ? editbox.height : transitionPx(editbox.height),
                        x:  page.unit == 'px' ? editbox.x : transitionPx(editbox.x),
                        y:  page.unit == 'px' ? editbox.y : transitionPx(editbox.y)
                    }
                })
            }
            page.custom = {};
            if (page.scene) {
                page.scene.geometry = {
                    width:  page.unit == 'px' ? page.scene.geometry.width : transitionPx(page.scene.geometry.width),
                    height:  page.unit == 'px' ? page.scene.geometry.height : transitionPx(page.scene.geometry.height),
                    x:  page.unit == 'px' ? page.scene.geometry.x : transitionPx(page.scene.geometry.x),
                    y:  page.unit == 'px' ? page.scene.geometry.y : transitionPx(page.scene.geometry.y)
                };
                page.scene.imagebox.geometry = {
                    width:  page.unit == 'px' ? page.scene.imagebox.geometry.width : transitionPx(page.scene.imagebox.geometry.width),
                    height:  page.unit == 'px' ? page.scene.imagebox.geometry.height : transitionPx(page.scene.imagebox.geometry.height),
                    x:  page.unit == 'px' ? page.scene.imagebox.geometry.x : transitionPx(page.scene.imagebox.geometry.x),
                    y:  page.unit == 'px' ? page.scene.imagebox.geometry.y : transitionPx(page.scene.imagebox.geometry.y)
                };
                if (page.scene.resource) {
                    getBackgroundSource($http, page.scene.resource, page.scene.geometry.width, page.scene.geometry.height, document.pages.page[index].scene, $scope);
                }
                page.custom.width = page.scene.geometry.width;
                page.custom.height = page.scene.geometry.height;
                page.sceneCopy = angular.copy(page.scene);
            } else {
                page.custom.width = page.mediabox.width;
                page.custom.height = page.mediabox.height;
            }
            page.custom.thumbnailScale = 300 / page.custom.width;
            callbackRatio(page,index)
            //条形码
            if (page.barcode) {
                page.barcode.geometry = {
                    width:  page.unit == 'px' ? page.barcode.geometry.width : transitionPx(page.barcode.geometry.width),
                    height:  page.unit == 'px' ? page.barcode.geometry.height : transitionPx(page.barcode.geometry.height),
                    x:  page.unit == 'px' ? page.barcode.geometry.x : transitionPx(page.barcode.geometry.x),
                    y:  page.unit == 'px' ? page.barcode.geometry.y : transitionPx(page.barcode.geometry.y)
                };
            }
            if (page.qrcode) {
                var qrGeom = page.qrcode.geometry;
                var isQrAlreadyPx = qrGeom.width > 100 || qrGeom.height > 100 || qrGeom.x > 100 || qrGeom.y > 100;
                page.qrcode.geometry = {
                    width:  page.unit == 'px' || isQrAlreadyPx ? qrGeom.width : transitionPx(qrGeom.width),
                    height:  page.unit == 'px' || isQrAlreadyPx ? qrGeom.height : transitionPx(qrGeom.height),
                    x:  page.unit == 'px' || isQrAlreadyPx ? qrGeom.x : transitionPx(qrGeom.x),
                    y:  page.unit == 'px' || isQrAlreadyPx ? qrGeom.y : transitionPx(qrGeom.y)
                };
            }
            //背景
            if (page.background && page.background.resource &&page.background.resource.identifier) {
                getBackgroundSource($http, page.background.resource, page.mediabox.width, page.mediabox.height, document.pages.page[index].background, $scope);
                page.background.offsetx =  page.unit == 'px' ? page.background.offsetx : transitionPx(page.background.offsetx);
                page.background.offsety =  page.unit == 'px' ? page.background.offsety : transitionPx(page.background.offsety);
                page.background.type = 'Pic'
            }
            if(!page.levels.level){
                page.levels.level=[];
            }
            angular.forEach(page.levels.level, function (level, i) {
                (function (level, i) {
                    if(level.variable){
                        vm.isVariable = true;
                    }
                    if (level.code && level.code.geometry) {
                        level.code.lock = true;
                        level.code.lock = true;
                        var codeGeom = level.code.geometry;
                        var isCodeAlreadyPx = codeGeom.width > 100 || codeGeom.height > 100 || codeGeom.x > 100 || codeGeom.y > 100;
                        level.code.geometry = {
                            width:  page.unit == 'px' || isCodeAlreadyPx ? codeGeom.width : transitionPx(codeGeom.width),
                            height:  page.unit == 'px' || isCodeAlreadyPx ? codeGeom.height : transitionPx(codeGeom.height),
                            x:  page.unit == 'px' || isCodeAlreadyPx ? codeGeom.x : transitionPx(codeGeom.x),
                            y:  page.unit == 'px' || isCodeAlreadyPx ? codeGeom.y : transitionPx(codeGeom.y)
                        };
                    }
                    if (level.imageart && level.imageart.geometry) {
                        level.imageart.lock = true;
                        level.imageart.lock = true;
                        level.imageart.levelI = i;
                        level.imageart.pageI = index;
                        level.imageart.offsetx =  page.unit == 'px' ? level.imageart.offsetx : transitionPx(level.imageart.offsetx);
                        level.imageart.offsety =  page.unit == 'px' ? level.imageart.offsety : transitionPx(level.imageart.offsety);
                        level.imageart.geometry = {
                            width:  page.unit == 'px' ? level.imageart.geometry.width : transitionPx(level.imageart.geometry.width),
                            height:  page.unit == 'px' ? level.imageart.geometry.height : transitionPx(level.imageart.geometry.height),
                            x:  page.unit == 'px' ? level.imageart.geometry.x : transitionPx(level.imageart.geometry.x),
                            y:  page.unit == 'px' ? level.imageart.geometry.y : transitionPx(level.imageart.geometry.y)
                        };
                        level.imageart.rotation.angle = -level.imageart.rotation.angle;
                        if (level.imageart.resource.identifier) {
                            getBackgroundSource($http, level.imageart.resource, level.imageart.geometry.width, level.imageart.geometry.height, document.pages.page[index].levels.level[i].imageart, $scope);
                        }
                    }
                    if((flag=='jianyi'||flag=='gaoji')&&level.imagebox&&level.imagebox.geometry){
                        var img = level.imagebox;
                        page.isImagebox = true;
                        img.transparency = isNaN(img.transparency) ? 1 : img.transparency;
                        img.geometry = {
                            width:  page.unit == 'px' ? img.geometry.width : transitionPx(img.geometry.width),
                            height:  page.unit == 'px' ? img.geometry.height : transitionPx(img.geometry.height),
                            x:  page.unit == 'px' ? img.geometry.x : transitionPx(img.geometry.x),
                            y:  page.unit == 'px' ? img.geometry.y : transitionPx(img.geometry.y)
                        };
                        img.imgUrl = 'content/images/mask_souce.png';
                        img.maskUrl = 'content/images/mask_souce.png';
                        img.current = 'imagebox';
                        img.levelI = i;
                        img.pageI = index;
                        img.lock = true;
                        img.rotation.angle = -img.rotation.angle;

                        if(vm.pid){
                            img.bokehtype = vm.article.bokehtype || "None";
                        }

                        if (img.mask.resource.identifier) {
                            img.maskUrl = (img.mask.resource.identifier.indexOf('http') == -1 ? $scope.domain : '') + img.mask.resource.identifier + '?imageMogr2';
                        }

                        if((!img.image||!img.image.resource)&&level.variable&&vm.variableBoxDatas.length&&level.name){
                            for (var _i = 0; _i < vm.variableBoxDatas.length; _i++) {
                                if(vm.variableBoxDatas[_i].name==level.name){
                                    if(!vm.variableBoxDatas[_i].value){
                                        vm.variableBoxDatas[_i].value = 'https://photoavatar-pic-dev.deltazo.com/file-463ea37f-1577-4451-a903-dc534e83f5f1'
                                    }
                                    vm.variableBoxDatas[_i].identifier = vm.variableBoxDatas[_i].value;
                                    $.ajax({
                                        type: "GET",
                                        url: vm.variableBoxDatas[_i].value + "?imageInfo",
                                        async: false,
                                        success: function (va) {
                                            vm.variableBoxDatas[_i].imgSize = va.size;
                                            if (va.orientation == "Left-bottom" || va.orientation == "Right-top" || va.orientation == "Left-top" || va.orientation == "Right-bottom") {
                                                vm.variableBoxDatas[_i].width = va.height;
                                                vm.variableBoxDatas[_i].height = va.width;
                                            }else{
                                                vm.variableBoxDatas[_i].width = va.width;
                                                vm.variableBoxDatas[_i].height = va.height;
                                            }
                                            img.image = {
                                                resource: {
                                                    identifier: vm.variableBoxDatas[_i].value,
                                                    provider: 'qiniu',
                                                    width: vm.variableBoxDatas[_i].width,
                                                    height: vm.variableBoxDatas[_i].height
                                                },
                                                parameter: [],
                                                offsetx: 0,
                                                offsety: 0,
                                                angle: 0,
                                                scale: 1,
                                                index: i,
                                                imageInfo: va,
                                                width: vm.variableBoxDatas[_i].width,
                                                height: vm.variableBoxDatas[_i].height,
                                                imgSize: vm.variableBoxDatas[_i].imgSize,
                                                resourceid: '',
                                                scaleH: 1,
                                                scaleW: 1,
                                            }
                                        },
                                        error: function (request) {

                                        }
                                    });
                                    break
                                }
                            }
                        }
                        if (img.image && img.image.resource && img.image.resource.identifier) {       //qiniu
                            img.imgUrl = (img.image.resource.identifier.indexOf('http') == -1 ? $scope.domain : '') + img.image.resource.identifier;
                            img.image = {
                                resource: {
                                    identifier: img.image ? img.image.resource.identifier : '',
                                    provider: img.image ? img.image.resource.provider : 'qiniu',
                                    width: img.image.width,
                                    height: img.image.height
                                },
                                filterResource: {
                                    identifier: img.image && img.image.filterResource ? img.image.filterResource.identifier : '',
                                    provider: img.image && img.image.filterResource ? img.image.filterResource.provider : 'qiniu'
                                },
                                imgsize: img.image.imgsize == null ? '' : img.image.imgsize,
                                parameter: img.image.parameter == null ? [] : angular.fromJson(img.image.parameter),
                                filter: img.image.filter == null ? '' : img.image.filter,
                                offsetx: img.image.offsetx?( page.unit == 'px' ? img.image.offsetx : transitionPx(img.image.offsetx)):0,
                                offsety: img.image.offsety? (page.unit == 'px' ? img.image.offsety : transitionPx(img.image.offsety)):0,
                                angle: img.image && img.image.angle ? img.image.angle : 0,
                                scale: img.image.scale == 1 ? 1 : img.image.scale,
                                index: (!img.image) ? '' : img.image.index,
                                resourceid: (!img.image) ? '' : img.image.resourceid,
                                imageInfo: (!img.image) ? '' : img.image.imageInfo,
                                width: (!img.image) ? '' :  (page.unit == 'px' ? img.image.width : transitionPx(img.image.width)),
                                height: (!img.image) ? '' :  (page.unit == 'px' ? img.image.height : transitionPx(img.image.height)),
                            }
                            if(!vm.pid){
                                if(img.blurredrectangle){
                                    img.blurredrectangle={
                                        width: page.unit == 'px' ? img.blurredrectangle.width : transitionPx(img.blurredrectangle.width),
                                        height: page.unit == 'px' ? img.blurredrectangle.height : transitionPx(img.blurredrectangle.height),
                                        x: page.unit == 'px' ? img.blurredrectangle.x : transitionPx(img.blurredrectangle.x),
                                        y: page.unit == 'px' ? img.blurredrectangle.y : transitionPx(img.blurredrectangle.y)
                                    }
                                }
                                getBackgroundSource4(img,img.geometry.width,img.geometry.height,img.image,$scope,vm,f)
                            }else{
                                var attr = 'center';
                                if(page.backup){
                                    attr = 'backup'
                                }
                                if(!img.image.imageInfo){
                                    $http({url: (img.image.resource.identifier.indexOf('http') == -1 ? $scope.domain : '') + img.image.resource.identifier + '?imageInfo'}).success(function (data) {
                                        img.image.angle = orientationInit1(data.orientation).angle;
                                        img.flip = orientationInit1(data.orientation).flip;
                                        var _data = orientationInit(data);
                                        img.image.width = _data.width;
                                        img.image.height = _data.height;
                                        imgScale(img, index, i,0,0, attr,$scope,vm,f);
                                    })
                                }else{
                                    var data = img.image.imageInfo;
                                    img.image.angle = orientationInit1(data.orientation).angle;
                                    img.flip = orientationInit1(data.orientation).flip;
                                    var _data = orientationInit(data);
                                    img.image.width = _data.width;
                                    img.image.height = _data.height;
                                    imgScale(img, index, i,0,0, attr,$scope,vm,f);
                                }
                            }
                        }else{
                            img.image = {
                                resource: null,
                                filterResource: {
                                    identifier: '',
                                    provider: ''
                                },
                                offsetx: 0,
                                offsety: 0,
                                width: '',
                                height: '',
                                imgsize: '',
                                index: '',
                                parameter: [],
                                scale: 1,
                                angle: 0,
                            }
                            f++;
                            if (f >= vm.FirstSeven) {
                                showPages();
                            }
                        }
                    }else if (level.imagebox&&level.imagebox.geometry) {
                        page.isImagebox = true;
                        level.imagebox.lock = true;
                        level.imagebox.transparency = isNaN(level.imagebox.transparency) ? 1 : level.imagebox.transparency;
                        level.imagebox.geometry = {
                            width:  page.unit == 'px' ? level.imagebox.geometry.width : transitionPx(level.imagebox.geometry.width),
                            height:  page.unit == 'px' ? level.imagebox.geometry.height : transitionPx(level.imagebox.geometry.height),
                            x:  page.unit == 'px' ? level.imagebox.geometry.x : transitionPx(level.imagebox.geometry.x),
                            y:  page.unit == 'px' ? level.imagebox.geometry.y : transitionPx(level.imagebox.geometry.y)
                        };
                        level.imagebox.rotation.angle = -level.imagebox.rotation.angle;
                        level.imagebox.bokehtypes = vm.article ? angular.copy(vm.article.bokehtype) : '';
                        if (!vm.isEdit || vm.editProductXml) {
                            if(vm.variableBoxDatas && vm.variableBoxDatas.length && vm.variableBoxDatas.length>0){
                                for (var _i = 0; _i < vm.variableBoxDatas.length; _i++) {
                                    if(vm.variableBoxDatas[_i].name==level.name){
                                        if(!vm.variableBoxDatas[_i].value){
                                            vm.variableBoxDatas[_i].value = 'https://photoavatar-pic-dev.deltazo.com/file-463ea37f-1577-4451-a903-dc534e83f5f1'
                                        }
                                        vm.variableBoxDatas[_i].identifier = vm.variableBoxDatas[_i].value;
                                        level.imagebox.image = {
                                            resource: {
                                                identifier: vm.variableBoxDatas[_i].value,
                                                provider: 'qiniu',
                                            },
                                            parameter: [],
                                            offsetx: 0,
                                            offsety: 0,
                                            angle: 0,
                                            scale: 1,
                                            width: '',
                                            height: '',
                                            imgSize: '',
                                            resourceid: '',
                                            scaleH: 1,
                                            scaleW: 1,
                                        }
                                        break
                                    }
                                }
                            }
                            if (!vm.onePage && vm.photoSelectAll && vm.photoSelectAll.length > _imgSum && !page.backup) {
                                level.imagebox.bokehtype = vm.article.bokehtype;
                                if (!level.imagebox.image || !level.imagebox.image.resource) {
                                    var _imagebox = imgFill($scope, vm, _imgSum);
                                    _imgSum++
                                    level.imagebox.image = {
                                        blurredrectangle: {
                                            width: 0,
                                            height: 0,
                                            x: 0,
                                            y: 0
                                        },
                                        resource: {
                                            identifier: _imagebox ? _imagebox.identifier : '',
                                            provider: _imagebox ? _imagebox.provider : 'qiniu'
                                        },
                                        resourceid:_imagebox ? _imagebox.id : '',
                                        filterResource: {
                                            identifier: '',
                                            provider: 'qiniu'
                                        },
                                        angle: 0,
                                        offsetx: 0,
                                        offsety: 0,
                                        imageInfo: _imagebox ? _imagebox.imageInfo : '',
                                        width: _imagebox ? _imagebox.width : '',
                                        height: _imagebox ? _imagebox.height : '',
                                        imgSize: _imagebox ? _imagebox.imgSize : '',
                                        index: _imagebox ? _imagebox.seq : '',
                                        parameter: _imagebox ? angular.fromJson(_imagebox.parameter) : [],
                                        scale: 1
                                    }
                                    if (level.imagebox.image.resource.identifier) {
                                        addImagebox($http, level.imagebox, function () {})
                                    }
                                }else if (level.imagebox.image && level.imagebox.image.resource && level.imagebox.image.resource.identifier) {
                                    level.imagebox.image = {
                                        resource: {
                                            identifier: level.imagebox.image.resource.identifier,
                                            provider: level.imagebox.image.resource.provider
                                        },
                                        resourceid:level.imagebox.image.resourceid,
                                        filterResource: {
                                            identifier: '',
                                            provider: ''
                                        },
                                        width: '',
                                        height: '',
                                        imgSize: '',
                                        offsetx:  page.unit == 'px' ? level.imagebox.image.offsetx : transitionPx(level.imagebox.image.offsetx),
                                        offsety:  page.unit == 'px' ? level.imagebox.image.offsety : transitionPx(level.imagebox.image.offsety),
                                        index: '',
                                        parameter: [],
                                        scale: level.imagebox.image.scale,
                                        angle: level.imagebox.image.angle,
                                    }
                                    addImagebox($http, level.imagebox, function () {})
                                }
                            } else {
                                if (level.imagebox.image && level.imagebox.image.resource.identifier) {
                                    level.imagebox.bokehtype = level.imagebox.bokehtype || 'None';
                                    level.imagebox.image = {
                                        resource: {
                                            identifier: level.imagebox.image.resource.identifier,
                                            provider: level.imagebox.image.resource.provider
                                        },
                                        resourceid:level.imagebox.image.resourceid,
                                        filterResource: {
                                            identifier: '',
                                            provider: ''
                                        },
                                        width: '',
                                        height: '',
                                        imgSize: '',
                                        offsetx:  page.unit == 'px' ? level.imagebox.image.offsetx : transitionPx(level.imagebox.image.offsetx),
                                        offsety:  page.unit == 'px' ? level.imagebox.image.offsety : transitionPx(level.imagebox.image.offsety),
                                        index: '',
                                        parameter: [],
                                        scale: level.imagebox.image.scale,
                                        angle: level.imagebox.image.angle,
                                    }
                                    addImagebox($http, level.imagebox, function () {})
                                } else {
                                    level.imagebox.bokehtype = vm.article.bokehtype;
                                    level.imagebox.image = {
                                        resource: {
                                            identifier: '',
                                            provider: ''
                                        },
                                        resourceid:"",
                                        filterResource: {
                                            identifier: '',
                                            provider: ''
                                        },
                                        width: '',
                                        height: '',
                                        imgSize: '',
                                        offsetx: 0,
                                        offsety: 0,
                                        index: '',
                                        parameter: [],
                                        scale: 1,
                                        angle: 0,
                                    }
                                }
                            }
                        }
                        if (vm.isEdit && !vm.editProductXml) {
                            level.imagebox.bokehtype = level.imagebox.bokehtype;
                            if (level.imagebox.image) {
                                level.imagebox.image.offsetx =  page.unit == 'px' ? level.imagebox.image.offsetx : transitionPx(level.imagebox.image.offsetx);
                                level.imagebox.image.offsety =  page.unit == 'px' ? level.imagebox.image.offsety : transitionPx(level.imagebox.image.offsety);
                                if (level.imagebox.image.resource && level.imagebox.image.resource.identifier) {
                                    // if(flag == 'processing'){
                                    //     getBackgroundSource3(level.imagebox, level.imagebox.geometry.width, level.imagebox.geometry.height, level.imagebox.image, level.imagebox.bokehtype, $scope, function () {
                                    //         $scope.$apply();
                                    //     });
                                    // }else{
                                        getBackgroundSource1(level.imagebox.image.resource, level.imagebox.geometry.width, level.imagebox.geometry.height, document.pages.page[index].levels.level[i].imagebox.image, level.imagebox.bokehtype, $scope, function () {
                                        })
                                    // }
                                }
                            }
                            if (level.imagebox.blurredrectangle) {
                                level.imagebox.blurredrectangle = {
                                    width:  page.unit == 'px' ? level.imagebox.blurredrectangle.width : transitionPx(level.imagebox.blurredrectangle.width),
                                    height:  page.unit == 'px' ? level.imagebox.blurredrectangle.height : transitionPx(level.imagebox.blurredrectangle.height),
                                    x:  page.unit == 'px' ? level.imagebox.blurredrectangle.x : transitionPx(level.imagebox.blurredrectangle.x),
                                    y:  page.unit == 'px' ? level.imagebox.blurredrectangle.y : transitionPx(level.imagebox.blurredrectangle.y)
                                };
                            }
                        }
                    }
                    if (level.textbox && level.textbox.geometry) {
                        level.textbox.lock = true;
                        level.textbox.lock = true;
                        level.textbox.levelI = i;
                        level.textbox.pageI = index;
                        level.textbox.geometry = {
                            width:  page.unit == 'px' ? level.textbox.geometry.width : transitionPx(level.textbox.geometry.width),
                            height:  page.unit == 'px' ? level.textbox.geometry.height : transitionPx(level.textbox.geometry.height),
                            x:  page.unit == 'px' ? level.textbox.geometry.x : transitionPx(level.textbox.geometry.x),
                            y:  page.unit == 'px' ? level.textbox.geometry.y : transitionPx(level.textbox.geometry.y)
                        };
                        level.textbox.rotation.angle = -level.textbox.rotation.angle;
                        if (level.textbox.fontuuid) {
                            //下载字体
                            getFontCSS(FontManagement, level.textbox, $scope);
                            FontSupport2(FontManagement, level.textbox);
                        }
                        if (level.textbox.style.bold && level.textbox.style.italic) {
                            level.textbox.styles = 'BOLD_ITALIC';
                        } else if (level.textbox.style.bold) {
                            level.textbox.styles = 'BOLD';
                        } else if (level.textbox.style.italic) {
                            level.textbox.styles = 'ITALIC';
                        } else {
                            level.textbox.styles = 'NORMAL';
                        }
                        if(level.variable){
                            if(vm.variableTextDatas && vm.variableTextDatas.length&&level.name){
                                for (var _i = 0; _i < vm.variableTextDatas.length; _i++) {
                                    if(vm.variableTextDatas[_i].name==level.name){
                                        level.textbox.text = vm.variableTextDatas[_i].value;
                                        break
                                    }
                                }
                            }else if(level.name){
                                level.textbox.text = level.name;
                            }
                            // toImg(textbox, page.styleScale2);
                        }
                    }
                    if (level.textdocument && level.textdocument.geometry) {
                        var textdocument = angular.copy(level.textdocument);
                        level.textdocument = {
                            background: textdocument.background,
                            geometry: {
                                width:  page.unit == 'px' ? textdocument.geometry.width : transitionPx(textdocument.geometry.width),
                                height:  page.unit == 'px' ? textdocument.geometry.height : transitionPx(textdocument.geometry.height),
                                x:  page.unit == 'px' ? textdocument.geometry.x : transitionPx(textdocument.geometry.x),
                                y:  page.unit == 'px' ? textdocument.geometry.y : transitionPx(textdocument.geometry.y)
                            },
                            rotation: {
                                angle: -textdocument.rotation.angle!= null? -textdocument.rotation.angle : 0
                            },
                            current: 'textdocument',
                            levels: angular.copy(textdocument.levels),
                            lock: true,
                            transparency: textdocument.transparency,
                            movable: textdocument.movable,
                            useradded: textdocument.useradded,
                            editable: textdocument.editable,
                            scale: textdocument.geometry.width / page.mediabox.width,
                            levelI:i,
                            pageI: index
                        }

                        var backg = textdocument.background;
                        var pageW = textdocument.geometry.width,
                            pageH = textdocument.geometry.height;
                        if (backg.resource.identifier) {
                            getBackgroundSource($http, backg.resource, pageW, pageH, document.pages.page[index].levels.level[i].textdocument.background, $scope);
                            backg.offsetx =  page.unit == 'px' ? backg.offsetx : transitionPx(backg.offsetx);
                            backg.offsety =  page.unit == 'px' ? backg.offsety : transitionPx(backg.offsety);
                        }

                        angular.forEach(textdocument.levels.level, function (lev, l) {
                            if (lev.imageart && lev.imageart.geometry) {
                                var art = lev.imageart;
                                $http({url: (art.resource.identifier.indexOf('http') == -1 ? $scope.domain : '') + art.resource.identifier + '?imageInfo'}).success(function (data) {
                                    level.textdocument.levels.level[l].imageart = {
                                        geometry: {
                                            width:  page.unit == 'px' ? art.geometry.width : transitionPx(art.geometry.width),
                                            height:  page.unit == 'px' ? art.geometry.height : transitionPx(art.geometry.height),
                                            x:  page.unit == 'px' ? art.geometry.x : transitionPx(art.geometry.x),
                                            y:  page.unit == 'px' ? art.geometry.y : transitionPx(art.geometry.y)
                                        },
                                        rotation: angular.copy(art.rotation),
                                        type: art.type,
                                        resource: {
                                            identifier: art.resource.identifier,
                                            provider: art.resource.provider,
                                            width: data.width,
                                            height: data.height
                                        },
                                        scale: art.scale,
                                        offsetx:  page.unit == 'px' ? art.offsetx : transitionPx(art.offsetx),
                                        offsety:  page.unit == 'px' ? art.offsety : transitionPx(art.offsety),
                                        current: 'imageart',
                                        lock: false,
                                        transparency: art.transparency,
                                        onlyshow: art.onlyshow,
                                        movable: art.movable,
                                        useradded: art.useradded,
                                        editable: art.editable,
                                        levelI:i,
                                        pageI: index
                                    }
                                }).error(function (error) {
                                });
                            }
                            if (lev.textbox && lev.textbox.geometry) {
                                var text = lev.textbox;
                                level.textdocument.levels.level[l].textbox = {
                                    geometry: {
                                        width:  page.unit == 'px' ? text.geometry.width : transitionPx(text.geometry.width),
                                        height:  page.unit == 'px' ? text.geometry.height : transitionPx(text.geometry.height),
                                        x:  page.unit == 'px' ? text.geometry.x : transitionPx(text.geometry.x),
                                        y:  page.unit == 'px' ? text.geometry.y : transitionPx(text.geometry.y)
                                    },
                                    identifier: text.identifier,
                                    rotation: angular.copy(text.rotation),
                                    angle: angular.copy(text.angle),
                                    status: angular.copy(text.status),
                                    style: angular.copy(text.style),
                                    type: angular.copy(text.type),
                                    text: angular.copy(text.text),
                                    fontStyle: [{
                                        style: '',
                                        path: text.identifier
                                    }],
                                    current: 'textbox',
                                    lock: true,
                                    transparency: text.transparency,
                                    fontuuid: text.fontuuid,
                                    version: text.version,
                                    levelI:i,
                                    pageI: index
                                }
                                getFontCSS(FontManagement, text, $scope)
                            }
                        })
                    }
                    if (level.calMonthBox && level.calMonthBox.geometry) {
                        var calMonthBox = level.calMonthBox;
                        calMonthBox.lock = true;
                        calMonthBox.geometry = {
                            width:  page.unit == 'px' ? calMonthBox.geometry.width : transitionPx(calMonthBox.geometry.width),
                            height:  page.unit == 'px' ? calMonthBox.geometry.height : transitionPx(calMonthBox.geometry.height),
                            x:  page.unit == 'px' ? calMonthBox.geometry.x : transitionPx(calMonthBox.geometry.x),
                            y:  page.unit == 'px' ? calMonthBox.geometry.y : transitionPx(calMonthBox.geometry.y)
                        };

                        calMonthBox.sampleYear = getDay('year',document.config.startYear,document.config.startMonth,page.config.monthIndex);
                        calMonthBox.sampleMonth = getDay('month',document.config.startYear,document.config.startMonth,page.config.monthIndex);
                        calMonthBox.rotation ={
                            angle:0
                        };
                    }
                    if (level.calTitleBox && level.calTitleBox.geometry) {
                        var calTitleBox = level.calTitleBox;
                        calTitleBox.lock = true;
                        calTitleBox.geometry = {
                            width:  page.unit == 'px' ? calTitleBox.geometry.width : transitionPx(calTitleBox.geometry.width),
                            height:  page.unit == 'px' ? calTitleBox.geometry.height : transitionPx(calTitleBox.geometry.height),
                            x:  page.unit == 'px' ? calTitleBox.geometry.x : transitionPx(calTitleBox.geometry.x),
                            y:  page.unit == 'px' ? calTitleBox.geometry.y : transitionPx(calTitleBox.geometry.y)
                        };
                        calTitleBox.sampleYear = getDay('year',document.config.startYear,document.config.startMonth,page.config.monthIndex);
                        calTitleBox.sampleMonth = getDay('month',document.config.startYear,document.config.startMonth,page.config.monthIndex);
                        calTitleBox.rotation ={
                            angle:0
                        };
                    }
                })(level, i)
            })
            getPageType(page);
            page.unit = 'px';
        })(page, index)
    })
    _imgSum = 0;
    setTimeout(function () {
        callback.call(this,document);
        $scope.$apply();
    },1000)
}
function documentMM(template) {
    var _template = angular.copy(template);
    _template.isSize = false;
    angular.forEach(_template.pages.page, function (page, index) {
        page.recommendLayout = null;
        if (page.editbox == null) {
            page.editbox = page.trimbox;
        }
        page.editbox = {
            width: page.unit == 'mm' ? page.editbox.width : transitionMm(page.editbox.width),
            height: page.unit == 'mm' ? page.editbox.height : transitionMm(page.editbox.height),
            x: page.unit == 'mm' ? page.editbox.x : transitionMm(page.editbox.x),
            y: page.unit == 'mm' ? page.editbox.y : transitionMm(page.editbox.y)
        };
        if(page.editboxes && page.editboxes.editbox){
            page.editboxes.editbox.forEach(function (editbox, editboxIndex) {
                page.editboxes.editbox[editboxIndex] = {
                    width: page.unit == 'mm' ? editbox.width : transitionMm(editbox.width),
                    height: page.unit == 'mm' ? editbox.height : transitionMm(editbox.height),
                    x: page.unit == 'mm' ? editbox.x : transitionMm(editbox.x),
                    y: page.unit == 'mm' ? editbox.y : transitionMm(editbox.y)
                }
            })
        }
        page.mediabox = {
            width: page.unit == 'mm' ? page.mediabox.width : transitionMm(page.mediabox.width),
            height: page.unit == 'mm' ? page.mediabox.height : transitionMm(page.mediabox.height),
            x: page.unit == 'mm' ? page.mediabox.x : transitionMm(page.mediabox.x),
            y: page.unit == 'mm' ? page.mediabox.y : transitionMm(page.mediabox.y)
        };
        page.trimbox = {
            width: page.unit == 'mm' ? page.trimbox.width : transitionMm(page.trimbox.width),
            height: page.unit == 'mm' ? page.trimbox.height : transitionMm(page.trimbox.height),
            x: page.unit == 'mm' ? page.trimbox.x : transitionMm(page.trimbox.x),
            y: page.unit == 'mm' ? page.trimbox.y : transitionMm(page.trimbox.y)
        };
        page.custom = {};
        if (page.sceneCopy) {
            page.scene = angular.copy(page.sceneCopy);
        }
        if (page.scene) {
            page.scene.geometry = {
                width: page.unit == 'mm' ? page.scene.geometry.width : transitionMm(page.scene.geometry.width),
                height: page.unit == 'mm' ? page.scene.geometry.height : transitionMm(page.scene.geometry.height),
                x: page.unit == 'mm' ? page.scene.geometry.x : transitionMm(page.scene.geometry.x),
                y: page.unit == 'mm' ? page.scene.geometry.y : transitionMm(page.scene.geometry.y)
            };
            page.scene.imagebox.geometry = {
                width: page.unit == 'mm' ? page.scene.imagebox.geometry.width : transitionMm(page.scene.imagebox.geometry.width),
                height: page.unit == 'mm' ? page.scene.imagebox.geometry.height : transitionMm(page.scene.imagebox.geometry.height),
                x: page.unit == 'mm' ? page.scene.imagebox.geometry.x : transitionMm(page.scene.imagebox.geometry.x),
                y: page.unit == 'mm' ? page.scene.imagebox.geometry.y : transitionMm(page.scene.imagebox.geometry.y)
            };
        }
        //条形码
        if (page.barcode) {
            page.barcode.geometry = {
                width: page.unit == 'mm' ? page.barcode.geometry.width : transitionMm(page.barcode.geometry.width),
                height: page.unit == 'mm' ? page.barcode.geometry.height : transitionMm(page.barcode.geometry.height),
                x: page.unit == 'mm' ? page.barcode.geometry.x : transitionMm(page.barcode.geometry.x),
                y: page.unit == 'mm' ? page.barcode.geometry.y : transitionMm(page.barcode.geometry.y)
            };
        }
        if (page.qrcode) {
            page.qrcode.geometry = {
                width: page.unit == 'mm' ? page.qrcode.geometry.width : transitionMm(page.qrcode.geometry.width),
                height: page.unit == 'mm' ? page.qrcode.geometry.height : transitionMm(page.qrcode.geometry.height),
                x: page.unit == 'mm' ? page.qrcode.geometry.x : transitionMm(page.qrcode.geometry.x),
                y: page.unit == 'mm' ? page.qrcode.geometry.y : transitionMm(page.qrcode.geometry.y)
            };
        }

        //背景
        if (page.background && page.background.resource &&page.background.resource.identifier) {
            page.background.offsetx = page.unit == 'mm' ? page.background.offsetx : transitionMm(page.background.offsetx);
            page.background.offsety = page.unit == 'mm' ? page.background.offsety : transitionMm(page.background.offsety);
        }
        angular.forEach(page.levels.level, function (level, i) {
            if (level.imageart && level.imageart.geometry) {
                level.imageart.rotation.angle = -level.imageart.rotation.angle;
                level.imageart.offsetx = page.unit == 'mm' ? level.imageart.offsetx : transitionMm(level.imageart.offsetx);
                level.imageart.offsety = page.unit == 'mm' ? level.imageart.offsety : transitionMm(level.imageart.offsety);
                level.imageart.width = page.unit == 'mm' ? level.imageart.width : transitionMm(level.imageart.width);
                level.imageart.height = page.unit == 'mm' ? level.imageart.height : transitionMm(level.imageart.height);
                level.imageart.geometry = {
                    width: page.unit == 'mm' ? level.imageart.geometry.width : transitionMm(level.imageart.geometry.width),
                    height: page.unit == 'mm' ? level.imageart.geometry.height : transitionMm(level.imageart.geometry.height),
                    x: page.unit == 'mm' ? level.imageart.geometry.x : transitionMm(level.imageart.geometry.x),
                    y: page.unit == 'mm' ? level.imageart.geometry.y : transitionMm(level.imageart.geometry.y)
                };
            }
            if (level.imagebox && level.imagebox.geometry) {
                level.imagebox.rotation.angle = -level.imagebox.rotation.angle;
                level.imagebox.geometry = {
                    width: page.unit == 'mm' ? level.imagebox.geometry.width : transitionMm(level.imagebox.geometry.width),
                    height: page.unit == 'mm' ? level.imagebox.geometry.height : transitionMm(level.imagebox.geometry.height),
                    x: page.unit == 'mm' ? level.imagebox.geometry.x : transitionMm(level.imagebox.geometry.x),
                    y: page.unit == 'mm' ? level.imagebox.geometry.y : transitionMm(level.imagebox.geometry.y)
                };
                if (level.imagebox.blurredrectangle) {
                    level.imagebox.blurredrectangle = {
                        width: page.unit == 'mm' ? level.imagebox.blurredrectangle.width : transitionMm(level.imagebox.blurredrectangle.width),
                        height: page.unit == 'mm' ? level.imagebox.blurredrectangle.height : transitionMm(level.imagebox.blurredrectangle.height),
                        x: page.unit == 'mm' ? level.imagebox.blurredrectangle.x : transitionMm(level.imagebox.blurredrectangle.x),
                        y: page.unit == 'mm' ? level.imagebox.blurredrectangle.y : transitionMm(level.imagebox.blurredrectangle.y)
                    };
                }
                if (level.imagebox.image) {
                    // if(flag=='jianyi'||flag=='gaoji'){
                    //     if (level.imagebox.image.resource) {
                    //         if ((level.imagebox.geometry.width + Math.abs(level.imagebox.image.offsetx) * level.imagebox.image.scale).toFixed(4) - 0 > (level.imagebox.image.width * level.imagebox.image.scale).toFixed(4) - 0) {
                    //             level.imagebox.image.offsetx = -Math.abs(level.imagebox.image.width * level.imagebox.image.scale - level.imagebox.geometry.width) / level.imagebox.image.scale;
                    //         }
                    //         if ((level.imagebox.geometry.height + Math.abs(level.imagebox.image.offsety) * level.imagebox.image.scale).toFixed(4) - 0 > (level.imagebox.image.height * level.imagebox.image.scale).toFixed(4) - 0) {
                    //             level.imagebox.image.offsety = -Math.abs(level.imagebox.image.height * level.imagebox.image.scale - level.imagebox.geometry.height) / level.imagebox.image.scale;
                    //         }
                    //     }
                    // }
                    level.imagebox.image.width = page.unit == 'mm' ? level.imagebox.image.width : transitionMm(level.imagebox.image.width);
                    level.imagebox.image.height = page.unit == 'mm' ? level.imagebox.image.height : transitionMm(level.imagebox.image.height);
                    level.imagebox.image.offsetx = page.unit == 'mm' ? level.imagebox.image.offsetx : transitionMm(level.imagebox.image.offsetx);
                    level.imagebox.image.offsety = page.unit == 'mm' ? level.imagebox.image.offsety : transitionMm(level.imagebox.image.offsety);
                }
            }
            if (level.textbox && level.textbox.geometry) {
                if (!(level.textbox.text == '' || level.textbox.text == null || level.textbox.text == '双击输入文字' || level.textbox.text == '请输入文字') && (level.textbox.geometry.width != 0 && level.textbox.geometry.height != 0)) {
                    level.textbox.rotation.angle = -level.textbox.rotation.angle;
                    level.textbox.geometry = {
                        width: page.unit == 'mm' ? level.textbox.geometry.width : transitionMm(level.textbox.geometry.width),
                        height: page.unit == 'mm' ? level.textbox.geometry.height : transitionMm(level.textbox.geometry.height),
                        x: page.unit == 'mm' ? level.textbox.geometry.x : transitionMm(level.textbox.geometry.x),
                        y: page.unit == 'mm' ? level.textbox.geometry.y : transitionMm(level.textbox.geometry.y)
                    };
                }else{
                    level.textbox = null;
                }
            }
            if (level.textdocument && level.textdocument.geometry) {
                level.textdocument.rotation.angle = -level.textdocument.rotation.angle;
                level.textdocument.geometry = {
                    width: page.unit == 'mm' ? level.textdocument.geometry.width : transitionMm(level.textdocument.geometry.width),
                    height: page.unit == 'mm' ? level.textdocument.geometry.height : transitionMm(level.textdocument.geometry.height),
                    x: page.unit == 'mm' ? level.textdocument.geometry.x : transitionMm(level.textdocument.geometry.x),
                    y: page.unit == 'mm' ? level.textdocument.geometry.y : transitionMm(level.textdocument.geometry.y)
                };

                var backg = level.textdocument.background;
                if (backg.resource.identifier) {
                    backg.offsetx = page.unit == 'mm' ? backg.offsetx : transitionMm(backg.offsetx);
                    backg.offsety = page.unit == 'mm' ? backg.offsety : transitionMm(backg.offsety);
                }

                angular.forEach(level.textdocument.levels.level, function (lev, l) {
                    if (lev.imageart && lev.imageart.geometry) {
                        var art = lev.imageart;
                        art.geometry = {
                            width: page.unit == 'mm' ? art.geometry.width : transitionMm(art.geometry.width),
                            height: page.unit == 'mm' ? art.geometry.height : transitionMm(art.geometry.height),
                            x: page.unit == 'mm' ? art.geometry.x : transitionMm(art.geometry.x),
                            y: page.unit == 'mm' ? art.geometry.y : transitionMm(art.geometry.y)
                        };
                        art.offsetx = page.unit == 'mm' ? art.offsetx : transitionMm(art.offsetx);
                        art.offsety = page.unit == 'mm' ? art.offsety : transitionMm(art.offsety);
                    }
                    if (lev.textbox && lev.textbox.geometry) {
                        var text = lev.textbox;
                        text.geometry = {
                            width: page.unit == 'mm' ? text.geometry.width : transitionMm(text.geometry.width),
                            height: page.unit == 'mm' ? text.geometry.height : transitionMm(text.geometry.height),
                            x: page.unit == 'mm' ? text.geometry.x : transitionMm(text.geometry.x),
                            y: page.unit == 'mm' ? text.geometry.y : transitionMm(text.geometry.y)
                        };
                    }
                })
            }
            if (level.calTitleBox && level.calTitleBox.geometry) {
                var _calTitleBox = angular.copy(level.calTitleBox);
                level.calTitleBox.geometry = {
                    width: page.unit == 'mm' ? level.calTitleBox.geometry.width : transitionMm(level.calTitleBox.geometry.width),
                    height: page.unit == 'mm' ? level.calTitleBox.geometry.height : transitionMm(level.calTitleBox.geometry.height),
                    x: page.unit == 'mm' ? level.calTitleBox.geometry.x : transitionMm(level.calTitleBox.geometry.x),
                    y: page.unit == 'mm' ? level.calTitleBox.geometry.y : transitionMm(level.calTitleBox.geometry.y)
                };
                level.calTitleBox.rotation.angle = -level.calTitleBox.rotation.angle;
                level.calTitleBox.settings={
                    border:level.calTitleBox.settings.border,
                    items:{
                        item:angular.copy(_calTitleBox.settings.items.item?_calTitleBox.settings.items.item:_calTitleBox.settings.items)
                    }
                };
                level.calTitleBox.layout={
                    geometry: {
                        width:level.calTitleBox.layout.width>=0?level.calTitleBox.layout.width:level.calTitleBox.layout.geometry.width,
                        height:level.calTitleBox.layout.height>=0?level.calTitleBox.layout.height:level.calTitleBox.layout.geometry.height,
                        x:0,
                        y:0,
                    },
                    previewUrl:level.calTitleBox.layout.previewUrl,
                    type:level.calTitleBox.layout.type,
                    items:{
                        item:angular.copy(_calTitleBox.layout.items.item?_calTitleBox.layout.items.item:_calTitleBox.layout.items),
                    }
                };
                level.calTitleBox.layout.items.item.forEach(function (item) {
                    item.geometry = {
                        width:item.w>=0?item.w:item.geometry.width,
                        height:item.h>=0?item.h:item.geometry.height,
                        x:item.x>=0?item.x:item.geometry.x,
                        y:item.y>=0?item.y:item.geometry.y,
                    }
                })
                level.calTitleBox.settings.items.item.forEach(function (item) {
                    if((item.w && item.h) || item.geometry){
                        item.geometry = {
                            width:item.w>=0?item.w:item.geometry.width,
                            height:item.h>=0?item.h:item.geometry.height,
                            x:item.x>=0?item.x:item.geometry.x,
                            y:item.y>=0?item.y:item.geometry.y,
                        }
                    }
                })
            }
            if (level.calMonthBox && level.calMonthBox.geometry) {
                var _calMonthBox = angular.copy(level.calMonthBox);
                level.calMonthBox.geometry = {
                    width: page.unit == 'mm' ? level.calMonthBox.geometry.width : transitionMm(level.calMonthBox.geometry.width),
                    height: page.unit == 'mm' ? level.calMonthBox.geometry.height : transitionMm(level.calMonthBox.geometry.height),
                    x: page.unit == 'mm' ? level.calMonthBox.geometry.x : transitionMm(level.calMonthBox.geometry.x),
                    y: page.unit == 'mm' ? level.calMonthBox.geometry.y : transitionMm(level.calMonthBox.geometry.y)
                };
                level.calMonthBox.rotation.angle = -level.calMonthBox.rotation.angle;

                level.calMonthBox.weekStyles={item:angular.copy(_calMonthBox.weekStyles.item?_calMonthBox.weekStyles.item:_calMonthBox.weekStyles)};
                level.calMonthBox.weekLayout={
                    geometry: {
                        width:level.calMonthBox.weekLayout.width>=0?level.calMonthBox.weekLayout.width:level.calMonthBox.weekLayout.geometry.width,
                        height:level.calMonthBox.weekLayout.height>=0?level.calMonthBox.weekLayout.height:level.calMonthBox.weekLayout.geometry.height,
                        x:0,
                        y:0,
                    },
                    items:{
                        item:angular.copy(_calMonthBox.weekLayout.items.item?_calMonthBox.weekLayout.items.item:_calMonthBox.weekLayout.items)
                    },
                    type:level.calMonthBox.weekLayout.type,
                    previewUrl:level.calMonthBox.weekLayout.previewUrl,
                };
                level.calMonthBox.weekLayout.items.item.forEach(function (weekLayout) {
                    weekLayout.geometry = {
                        width:weekLayout.w>=0?weekLayout.w:weekLayout.geometry.width,
                        height:weekLayout.h>=0?weekLayout.h:weekLayout.geometry.height,
                        x:weekLayout.x>=0?weekLayout.x:weekLayout.geometry.x,
                        y:weekLayout.y>=0?weekLayout.y:weekLayout.geometry.y,
                    }
                })
                level.calMonthBox.dateStyles={item:angular.copy(_calMonthBox.dateStyles.item?_calMonthBox.dateStyles.item:_calMonthBox.dateStyles)},
                    level.calMonthBox.dateLayout={
                        geometry: {
                            width:level.calMonthBox.dateLayout.width>=0?level.calMonthBox.dateLayout.width:level.calMonthBox.dateLayout.geometry.width,
                            height:level.calMonthBox.dateLayout.height>=0?level.calMonthBox.dateLayout.height:level.calMonthBox.dateLayout.geometry.height,
                            x:0,
                            y:0,
                        },
                        items:{
                            item:angular.copy(_calMonthBox.dateLayout.items.item?_calMonthBox.dateLayout.items.item:_calMonthBox.dateLayout.items)
                        },
                        type:level.calMonthBox.dateLayout.type,
                        previewUrl:level.calMonthBox.dateLayout.previewUrl
                    };
                level.calMonthBox.dateLayout.items.item.forEach(function (dateLayout) {
                    dateLayout.geometry = {
                        width:dateLayout.w>=0?dateLayout.w:dateLayout.geometry.width,
                        height:dateLayout.h>=0?dateLayout.h:dateLayout.geometry.height,
                        x:dateLayout.x>=0?dateLayout.x:dateLayout.geometry.x,
                        y:dateLayout.y>=0?dateLayout.y:dateLayout.geometry.y,
                    }
                })
                level.calMonthBox.weekStyles.item.forEach(function (weekStyle) {
                    var _items = angular.copy(weekStyle.items.item?weekStyle.items.item:weekStyle.items);
                    _items.forEach(function (_item){
                        if(_item.w && _item.h){
                            _item.geometry = {
                                width:_item.w,
                                height:_item.h,
                                x:_item.x,
                                y:_item.y,
                            }
                        }
                    })
                    weekStyle.items = {
                        item:_items
                    }
                })
                level.calMonthBox.dateStyles.item.forEach(function (dateStyle) {
                    var _items = angular.copy(dateStyle.items.item?dateStyle.items.item:dateStyle.items);
                    _items.forEach(function (_item){
                        if(_item.w && _item.h){
                            _item.geometry = {
                                width:_item.w,
                                height:_item.h,
                                x:_item.x,
                                y:_item.y,
                            }
                        }
                    })
                    dateStyle.items = {
                        item:_items
                    }
                })
            }
        })
        if(Math.abs(page.mediabox.width - page.mediaboxMM.width) < 1 && Math.abs(page.mediabox.height - page.mediaboxMM.height) < 1){
            page.unit = 'mm';
        }else{
            _template.isSize = true
        }
    })
    if(!_template.isSize){
        _template.version= '4.0';
        return _template
    }else{
        alert('页面尺寸不对,请刷新重做')
    }
}
var fontuuids = [];
function getFontCSS(FontManagement, item, $scope) {
    if(fontuuids.indexOf(item.fontuuid) == -1){
        fontuuids.push(item.fontuuid);
        FontManagement.getCss({uuid: item.fontuuid}, function (res) {
            var style = document.createElement("style");
            style.type = 'text/css';
            try {
                style.appendChild(document.createTextNode(res.data));
            } catch (ex) {
                style.stylesheet.cssText = res.data;
            }
            var Head = document.getElementsByTagName("head")[0];
            Head.appendChild(style);
            document.fonts.ready.then(function () {
                item.loading = false;
                $scope.$apply();
            });
        });
    }else{
        item.loading = false;
    }
}
//获取选择图片
function imgFill($scope, vm, sum, domain) {
    var _imgFillAll = angular.copy(vm.photoSelectAll);
    if(_imgFillAll[sum].identifier.indexOf('http')==-1){
        _imgFillAll[sum].identifier = $scope.domain + _imgFillAll[sum].identifier;
    }
    return _imgFillAll[sum]
}
function getBackgroundSource($http, res, pageW, pageH, item, $scope, callback) {
    if(item.imageInfo){
        getBackgroundSourceCb(item.imageInfo)
    }else{
        $http({url: (res.identifier.indexOf('http') == -1 ? $scope.domain : '') + res.identifier + '?imageInfo'}).success(function (data1) {
            item.imageInfo =data1;
            getBackgroundSourceCb(data1)
        }).error(function (error) {
        });
    }
    function getBackgroundSourceCb(imageInfo){
        var data = orientationInit(imageInfo);
        // var bgImgW = data.width;
        // var bgImgH = data.height;
        // var bgImgR = bgImgW / bgImgH;
        // var bgImgR1 = pageW / pageH;
        // if (bgImgR >= bgImgR1) {
        //     res.adaptation = 'Width';
        // } else {
        //     res.adaptation = 'Height';
        // }
        var bgImgW = pageW;
        var bgImgH = pageH;
        var bgImgR = bgImgW/bgImgH;
        var bgImgR1 = data.width/data.height;
        if(bgImgR >= bgImgR1){
            res.adaptation = 'Width';
        }else {
            res.adaptation = 'Height';
        }


        item.width = data.width;
        item.height = data.height;
        if(callback){
            callback();
        }
    }
}
function identifierInfo(identifier, item, $scope) {
    var newImg1 = new Image();
    newImg1.crossOrigin = "Anonymous";
    newImg1.src = identifier;
    newImg1.onload = function () {
        item.imgWidth = newImg1.width;
        item.imgHeight = newImg1.height;
        $scope.$apply();
    };
}

function getBackgroundSource1(res, pageW, pageH, item, bokehtype, $scope,callback) {
    if(!item.height && !item.width){
        var newImg = new Image();
        newImg.crossOrigin = "Anonymous";
        var _domain1 = (res.identifier.indexOf('http') == -1 ? $scope.domain : '');
        newImg.src = _domain1 + res.identifier + '?imageMogr2/exifModify/eyJPcmllbnRhdGlvbiI6IjEifQ==/rotate/' + item.angle + '/thumbnail/!40p';
        newImg.onload = function () {
            getBackgroundSource1Cb(res, pageW, pageH, item, bokehtype, $scope,newImg, function () {
                if(callback){callback()};
                $scope.$apply();
            })
        };
    }else{
        var newImg = {
            width: angular.copy(item.width),
            height: angular.copy(item.height),
        }
        getBackgroundSource1Cb(res, pageW, pageH, item, bokehtype, $scope,newImg, callback)
    }
}
function getBackgroundSource1Cb(res, pageW, pageH, item, bokehtype, $scope,newImg, callback) {
    var imgR = pageW / pageH;
    var imgR1 = newImg.width / newImg.height;
    if (bokehtype == 'None') {
        if (imgR >= imgR1) {
            item.resource.adaptation = 'Height';
            item.width = pageW;
            item.height = pageW / newImg.width * newImg.height;
        } else {
            item.resource.adaptation = 'Width';
            item.width = pageH / newImg.height * newImg.width;
            item.height = pageH;
        }
    } else {
        if (imgR >= imgR1) {
            item.resource.adaptation = 'Height';
            item.width = pageW;
            item.height = pageW / newImg.width * newImg.height;
            item.offsetx = 0;
            item.offsety = 0;
            res.blurredrectangle = {
                width: pageH / newImg.height * newImg.width,
                height: pageH,
                x: (pageW - pageH / newImg.height * newImg.width) / 2,
                y: 0,
            }
        } else {
            item.resource.adaptation = 'Width';
            item.width = pageH / newImg.height * newImg.width;
            item.height = pageH;
            item.offsetx = 0;
            item.offsety = 0;
            res.blurredrectangle = {
                width: pageW,
                height: pageW / newImg.width * newImg.height,
                x: 0,
                y: (pageH - pageW / newImg.width * newImg.height) / 2,
            }
        }
    }
    if(callback){
        callback()
    }
}
function getBackgroundSource2(res, pageW, pageH, item, bokehtype, $scope, callback) {
    var newImg = new Image();
    newImg.crossOrigin = "Anonymous";
    var _domain2 = (res.image.resource.identifier.indexOf('http') == -1 ? $scope.domain : '');
    newImg.src = _domain2 + res.image.resource.identifier + '?imageMogr2/exifModify/eyJPcmllbnRhdGlvbiI6IjEifQ==/rotate/' + item.angle + '/thumbnail/!20p';
    newImg.onload = function () {
        getBackgroundSource1Cb(res, pageW, pageH, item, bokehtype, $scope,newImg, function () {
            if(callback){callback()};
            $scope.$digest();
        })
    };
}
function getBackgroundSource3(res, pageW, pageH, item, bokehtype, $scope, callback) {
    // var newImg = new Image();
    // newImg.crossOrigin = "Anonymous";
    // newImg.src = res.image.resource.identifier + '?imageMogr2/exifModify/eyJPcmllbnRhdGlvbiI6IjEifQ==/rotate/' + item.angle;
    // newImg.onload = function () {
    var newImg = {
        width : item.width,
        height: item.height,
    };
    var imgR = pageW / pageH;
    var imgR1 = newImg.width / newImg.height;
    item.imgWidth = newImg.width;
    item.imgHeight = newImg.height;
    if (bokehtype == 'None') {
        if (imgR >= imgR1) {
            item.resource.adaptation = 'Height';
            item.width = pageW;
            item.height = pageW / newImg.width * newImg.height;
            item.offsetx = 0;
            item.offsety = -(item.height - pageH) / 2;
        } else {
            item.resource.adaptation = 'Width';
            item.width = pageH / newImg.height * newImg.width;
            item.height = pageH;
            item.offsetx = -(item.width - pageW) / 2;
            item.offsety = 0;
        }
    } else {
        if (imgR >= imgR1) {
            item.resource.adaptation = 'Height';
            item.width = pageW;
            item.height = pageW / newImg.width * newImg.height;
            item.offsetx = 0;
            item.offsety = 0;
            res.blurredrectangle = {
                width: pageH / newImg.height * newImg.width,
                height: pageH,
                x: (pageW - pageH / newImg.height * newImg.width) / 2,
                y: 0,
            }
        } else {
            item.resource.adaptation = 'Width';
            item.width = pageH / newImg.height * newImg.width;
            item.height = pageH;
            item.offsetx = 0;
            item.offsety = 0;
            res.blurredrectangle = {
                width: pageW,
                height: pageW / newImg.width * newImg.height,
                x: 0,
                y: (pageH - pageW / newImg.width * newImg.height) / 2,
            }
        }
    }
    if(callback){
        callback()
    }
    // };
}
function getBackgroundSource4(res,pageW,pageH,item,$scope,vm,f) {
    var newImg = new Image();
    newImg.crossOrigin = "Anonymous";
    var _domain4 = (item.resource.identifier.indexOf('http') == -1 ? $scope.domain : '');
    newImg.src = _domain4 + item.resource.identifier + '?imageMogr2/exifModify/eyJPcmllbnRhdGlvbiI6IjEifQ==/rotate/' + item.angle + '/thumbnail/!40p';
    newImg.onload = function () {
        f++;
        if (f >= vm.counts) {
            showPages();
        }

        var w1 = 0,h1 = 0;
        w1 = newImg.width;
        h1 = newImg.height;
        item.imgsize = newImg.size;
        var width = item.width = w1;
        var height = item.height = h1;
        var wOrigin = angular.copy(width);
        var hOrigin = angular.copy(height);

        item.width1= newImg.width;
        item.height1= newImg.height;
        if ((wOrigin <= hOrigin || pageW <= pageH) && (wOrigin / hOrigin < pageW / pageH) || wOrigin >= hOrigin && pageW >= pageH && (wOrigin / hOrigin < pageW / pageH)) {
            res.adaptation = 'Width';
            item.width= pageW;
            item.height= pageW/width*height;
        }else {
            res.adaptation = 'Height';
            item.width= pageH/height * width;
            item.height= pageH;
        }
        $scope.$digest();
    }
    // $.ajax({
    //     type: "GET",
    //     url: item.resource.identifier + "?imageInfo",
    //     success: function (newImg) {
    //         f++;
    //         if (f >= vm.counts) {
    //             showPages();
    //         }
    //
    //         var w1 = 0,h1 = 0;
    //         w1 = orientationInit(newImg).width;
    //         h1 = orientationInit(newImg).height;
    //         item.imgsize = newImg.size;
    //         var width = item.width = w1;
    //         var height = item.height = h1;
    //         if(item.angle == 90||item.angle ==270){
    //             width = h1;
    //             height = w1;
    //         }
    //         var wOrigin = angular.copy(width);
    //         var hOrigin = angular.copy(height);
    //
    //         item.width1= width;
    //         item.height1= height;
    //         if ((wOrigin <= hOrigin || pageW <= pageH) && (wOrigin / hOrigin < pageW / pageH) || wOrigin >= hOrigin && pageW >= pageH && (wOrigin / hOrigin < pageW / pageH)) {
    //             res.adaptation = 'Width';
    //             item.width= pageW;
    //             item.height= pageW/width*height;
    //         }else {
    //             res.adaptation = 'Height';
    //             item.width= pageH/height * width;
    //             item.height= pageH;
    //         }
    //         getDpi(res);
    //         $scope.$digest();
    //     }
    // })
}

function imgScale(imagebox, index, id,x,y,tag,$scope,vm,f) {
    var width = imagebox.image.width;
    var height = imagebox.image.height;
    var wOrigin = angular.copy(width);
    var hOrigin = angular.copy(height);
    // 单页编辑占位框宽高
    var maskWidth = imagebox.geometry.width;
    var maskHight = imagebox.geometry.height;

    if(imagebox.bokehtype == 'None'){
        if ((wOrigin <= hOrigin || maskWidth <= maskHight) && (wOrigin / hOrigin < maskWidth / maskHight) || wOrigin >= hOrigin && maskWidth >= maskHight && (wOrigin / hOrigin < maskWidth / maskHight)) {
            imagebox.adaptation = 'Width';
            imagebox.image.width= imagebox.geometry.width;
            imagebox.image.height= imagebox.geometry.width/width*height;
            imagebox.image.offsetx= x;
            if(tag=='center' || tag=='backup'){
                imagebox.image.offsety = -(imagebox.image.height-imagebox.geometry.height)/2;
            }else{
                imagebox.image.offsety= y;
            }
        } else {
            imagebox.adaptation = 'Height';
            imagebox.image.width= imagebox.geometry.height/height*width;
            imagebox.image.height= imagebox.geometry.height;
            imagebox.image.offsety= y;
            if(tag=='center' || tag=='backup'){
                imagebox.image.offsetx = -(imagebox.image.width-imagebox.geometry.width)/2;
            }else{
                imagebox.image.offsetx= x;
            }
        }
    }else {
        if ((wOrigin <= hOrigin || maskWidth <= maskHight) && (wOrigin / hOrigin < maskWidth / maskHight) || wOrigin >= hOrigin && maskWidth >= maskHight && (wOrigin / hOrigin < maskWidth / maskHight)) {
            imagebox.adaptation = 'Width';
            imagebox.image.width = imagebox.geometry.width;
            imagebox.image.height = imagebox.geometry.width * height / width;
            imagebox.image.offsetx = 0;
            imagebox.image.offsety = 0;
            imagebox.blurredrectangle = {
                width: imagebox.geometry.height * width / height,
                height: imagebox.geometry.height,
                x: (imagebox.geometry.width - imagebox.geometry.height * width / height) / 2,
                y: 0,
            }
        } else {
            imagebox.adaptation = 'Height';
            imagebox.image.width = imagebox.geometry.height * width / height;
            imagebox.image.height = imagebox.geometry.height;
            imagebox.image.offsetx = 0;
            imagebox.image.offsety = 0;
            imagebox.blurredrectangle = {
                width: imagebox.geometry.width,
                height: imagebox.geometry.width * height / width,
                x: 0,
                y: (imagebox.geometry.height - imagebox.geometry.width * height / width) / 2,
            }
        }
    }

    imagebox.blobImage = true;
    pxInsufficient(imagebox, vm.imgSize, vm.imgDpi);
    // setTimeout(function () {
    //     $scope.$apply();
    // },0)
    // f++;
    // if (f >= vm.counts) {
    //     showPages();
    // }
}

var boxW = 0, boxH = 0, picW = 0, picH = 0, scale = 0;
function getDpi(box) {
    boxW = transitionMm(box.geometry.width);
    boxH = transitionMm(box.geometry.height);
    picW = box.image.width;
    picH = box.image.height;
    scale = box.image.scale;
    var x = 0, y = 0;
    // 宽度适配
    if (box.adaptation=='Width') {
        x = picW / (boxW / 25.4) / scale;
        y = boxH * picW / boxW / (boxH / 25.4) / scale;
    } else {
        x = boxW * picH / boxH / (boxW / 25.4) / scale;
        y = picH / (boxH / 25.4) / scale;
    }
    if (x < 150 || y < 150) {
        box.image.lowSize = true;
    } else {
        box.image.lowSize = false;
    }
}

function getScale(screenW, screenH, pageW, pageH) {
    if (screenW * 0.94 / (screenH - 240) < pageW / pageH) {
        //宽定，高不定
        return true;
    } else {
        //高定，宽不定
        return false;
    }
}

function showPages($scope) {
    // setTimeout(function () {
    //     $scope.loading = false;
    //     $(".page-loading").hide().css({'opacity': 0});
    //     // $li.show();
    //     $(".guide-view").removeClass('opacity-zero');
    //     // 等到刷新后直接赋值
    //     localStorage.setItem('pages', JSON.stringify($scope.template.pages));
    // })
}
//mm转px
function transitionPx(item) {
    if (item == null || item === undefined || isNaN(item)) {
        return 0;
    }
    var result = item * js_getDPI() / 25.4;
    return Number(result.toFixed(5));
}
//px转mm
function transitionMm(item) {
    if (item == null || item === undefined || isNaN(item)) {
        return 0;
    }
    var result = item * 25.4 / js_getDPI();
    return Number(result.toFixed(5));
}
//阻止默认事件
function fn($event) {
    if($event){
        var $event = $event || window.event;
        if ($event && $event.preventDefault) {
            $event.preventDefault();
        } else {
            window.event.returnValue = false;
            return false;
        }
        $event.stopPropagation();
    }
}
/*******************************************照片框处理*************************************************************************/
//照片框移动
var isImageboxMove = false;
var isImageboxDragging = false;
var imageboxObj = {};
function imageboxTouchStart(e, levelIndex, ratio1, level,  callback,  callback1, callback2) {
    var targ = e.target ? e.target : e.srcElement;
    var imgIndex = targ.dataset.index || levelIndex;
    callback(imgIndex)
    var sticker = level[imgIndex].imagebox;
    if(!sticker || sticker.bokehtype != 'None'){
        return
    }


    imageboxObj.x = e.originalEvent.touches[0].pageX!=null ?e.originalEvent.touches[0].pageX : 0;          //鼠标到页面左边的距离
    imageboxObj.y = e.originalEvent.touches[0].pageY !=null ?e.originalEvent.touches[0].pageY: 0;          //鼠标到页面顶部的距离
    imageboxObj.offsetx = angular.copy(sticker.image.offsetx * sticker.image.scale);
    imageboxObj.offsety = angular.copy(sticker.image.offsety * sticker.image.scale);
    imageboxObj.imageWidth = angular.copy(sticker.image.width * sticker.image.scale);
    imageboxObj.imageHeight = angular.copy(sticker.image.height * sticker.image.scale);
    imageboxObj.geometry = angular.copy(sticker.geometry);
    imageboxObj.image = angular.copy(sticker.image);
    imageboxObj.blurredrectangle = angular.copy(sticker.blurredrectangle);

    if (!e.originalEvent || e.originalEvent.touches.length == 1) {
        callback1(imgIndex)
        imageboxObj.l = sticker.image.offsetx * ratio1 * sticker.image.scale;
        imageboxObj.t = sticker.image.offsety * ratio1 * sticker.image.scale;
        imageboxObj.r = -(sticker.image.width * sticker.image.scale - sticker.geometry.width) * ratio1;
        imageboxObj.b = -(sticker.image.height * sticker.image.scale - sticker.geometry.height) * ratio1;
        imageboxObj.l1 = sticker.geometry.x * ratio1;
        imageboxObj.t1 = sticker.geometry.y * ratio1;
        isImageboxMove = true;
    };
    if (e.originalEvent && e.originalEvent.touches.length >= 2) {
        //获取w和h
        imageboxObj.nw = angular.copy(sticker.image.width) * ratio1;
        imageboxObj.nh = angular.copy(sticker.image.height) * ratio1;
        imageboxObj.scale = angular.copy(sticker.image.scale);
        imageboxObj.start = e.originalEvent.touches;
        //开关打开
        isImageboxDragging = true;
    };
    if(callback2 && sticker.image && sticker.image.resource && sticker.image.resource.identifier && sticker.bokehtype == 'None'){
        callback2()
    }
};
function imageboxTouchmove(e, levelIndex, ratio1, level, pageData,  callback) {
    var sticker = level[levelIndex].imagebox;
    if(!sticker || sticker.bokehtype != 'None'){
        return
    }
    if (!e.originalEvent || e.originalEvent.touches.length == 1) {
        if (!isImageboxMove) {
            return
        }

        if(!sticker.lock){
            //获取x和y
            var nx = e.originalEvent.touches[0].pageX != null ?e.originalEvent.touches[0].pageX: 0;
            var ny = e.originalEvent.touches[0].pageY != null ?e.originalEvent.touches[0].pageY: 0;
            //计算移动后的左偏移量和顶部的偏移量
            var nl = nx - (imageboxObj.x - imageboxObj.l1);
            var nt = ny - (imageboxObj.y - imageboxObj.t1);

            sticker.geometry.x = nl / ratio1;
            sticker.geometry.y = nt / ratio1;
        }else{
            var angle = Number(sticker.rotation.angle);
            var cx = (imageboxObj.l + imageboxObj.r) / 2;
            var cy = (imageboxObj.t + imageboxObj.b) / 2;
            var pt0 = rotatePoint({x: imageboxObj.x, y: imageboxObj.y}, {x: cx, y: cy}, -angle);
            var pt1 = rotatePoint({x: e.originalEvent.touches[0].pageX, y: e.originalEvent.touches[0].pageY}, {x: cx, y: cy}, -angle);
            var deltaX = pt1.x - pt0.x;
            var deltaY = pt1.y - pt0.y;
            var nl = imageboxObj.l + deltaX;
            var nt = imageboxObj.t + deltaY;
            if (nl < imageboxObj.r) {
                nl = imageboxObj.r
            };
            if (nl > 0) {
                nl = 0
            };
            if (nt < imageboxObj.b) {
                nt = imageboxObj.b
            };
            if (nt > 0) {
                nt = 0
            };


            sticker.image.offsetx = nl / ratio1 / sticker.image.scale;
            sticker.image.offsety = nt / ratio1 / sticker.image.scale;
        }
    };
    if (e.originalEvent && e.originalEvent.touches.length >= 2) {
        var now = e.originalEvent.touches;
        Math.abs(e.originalEvent.touches[0].pageX - e.originalEvent.touches[1].pageX);
        if(sticker.lock){
            var _width = angular.copy(Number(imageboxObj.nw) + Number(getDistance(now[0], now[1]) - getDistance(imageboxObj.start[0], imageboxObj.start[1])));
            sticker.image.scale = imageboxObj.scale + (_width/imageboxObj.nw - 1);
            if(sticker.image.scale <= 1){
                sticker.image.scale = 1;
            }

            sticker.image.offsetx = (imageboxObj.offsetx - (sticker.image.width*sticker.image.scale-imageboxObj.imageWidth)/2) / sticker.image.scale;
            sticker.image.offsety = (imageboxObj.offsety - (sticker.image.height*sticker.image.scale-imageboxObj.imageHeight)/2) / sticker.image.scale;
            if(sticker.image.width*sticker.image.scale + sticker.image.offsetx*sticker.image.scale <= sticker.geometry.width){
                sticker.image.offsetx = (sticker.geometry.width - sticker.image.width*sticker.image.scale) / sticker.image.scale;
            }
            if(sticker.image.height*sticker.image.scale + sticker.image.offsety*sticker.image.scale <= sticker.geometry.height){
                sticker.image.offsety = (sticker.geometry.height - sticker.image.height*sticker.image.scale) / sticker.image.scale;
            }
            if(sticker.image.offsetx > 0){
                sticker.image.offsetx = 0;
            }
            if(sticker.image.offsety > 0){
                sticker.image.offsety = 0;
            }
        }else{
            var _width = angular.copy(Number(imageboxObj.geometry.width) + Number(getDistance(now[0], now[1]) - getDistance(imageboxObj.start[0], imageboxObj.start[1])));
            var _w = _width;
            var _h = _w / imageboxObj.geometry.width * imageboxObj.geometry.height;

            if(sticker.image && sticker.image.resource && sticker.image.resource.identifier){
                sticker.image.width = _w / imageboxObj.geometry.width * imageboxObj.image.width;
                sticker.image.height = _w / imageboxObj.geometry.width * imageboxObj.image.height;
                sticker.image.offsetx = _w / imageboxObj.geometry.width * imageboxObj.image.offsetx;
                sticker.image.offsety = _w / imageboxObj.geometry.width * imageboxObj.image.offsety;
                if(sticker.bokehtype != 'None'){
                    sticker.image.offsetx = 0;
                    sticker.image.offsety = 0;
                    sticker.blurredrectangle.width = _w / imageboxObj.geometry.width * imageboxObj.blurredrectangle.width;
                    sticker.blurredrectangle.height = _w / imageboxObj.geometry.width * imageboxObj.blurredrectangle.height;
                    sticker.blurredrectangle.x = _w / imageboxObj.geometry.width * imageboxObj.blurredrectangle.x;
                    sticker.blurredrectangle.y = _w / imageboxObj.geometry.width * imageboxObj.blurredrectangle.y;
                }
            }
            sticker.geometry.width = _w;
            sticker.geometry.height = _h;
            sticker.geometry.x = (imageboxObj.geometry.x - (_w - imageboxObj.geometry.width)/2);
            sticker.geometry.y = (imageboxObj.geometry.y - (_h - imageboxObj.geometry.height)/2);
        }
    }
    if(callback){
        callback()
    }
}
function imageboxTouchend(e, levelIndex, ratio1, level) {
    isImageboxMove = false;
    isImageboxDragging = false;
    imageboxObj = {};
}

//图片框缩放
var imageboxZoomItem = {};
var isDragging = false;
function imageboxZoomStart(e, level, documentClass, ratio, callback) {

    var targ = e.currentTarget ? e.currentTarget : e.srcElement;
    var textIndex = targ.dataset.index;
    textIndex = parseInt(textIndex);
    var sticker = level[textIndex].imagebox;
    if(sticker.lock){
        return
    }
    callback(textIndex);

    imageboxZoomItem.nw = angular.copy(sticker.geometry.width * ratio);
    imageboxZoomItem.nh = angular.copy(sticker.geometry.height * ratio);
    if(sticker.image && sticker.image.resource && sticker.image.resource.identifier){
        imageboxZoomItem.imageboxImgW = angular.copy(sticker.image.width * ratio);
        imageboxZoomItem.imageboxImgH = angular.copy(sticker.image.height * ratio);
        imageboxZoomItem.imageboxImgX = angular.copy(sticker.image.offsetx * ratio);
        imageboxZoomItem.imageboxImgY = angular.copy(sticker.image.offsety * ratio);
        if(sticker.bokehtype != 'None'){
            imageboxZoomItem.imageboxImgblurredrectangleW = angular.copy(sticker.blurredrectangle.width * ratio);
            imageboxZoomItem.imageboxImgblurredrectangleH = angular.copy(sticker.blurredrectangle.height * ratio);
            imageboxZoomItem.imageboxImgblurredrectangleX = angular.copy(sticker.blurredrectangle.x * ratio);
            imageboxZoomItem.imageboxImgblurredrectangleY = angular.copy(sticker.blurredrectangle.y * ratio);
        }
    }
    imageboxZoomItem.x2 = sticker.geometry.x * ratio;
    imageboxZoomItem.y2 = sticker.geometry.y * ratio;
    imageboxZoomItem.top = $('.' + documentClass).offset().top + (sticker.geometry.height * ratio / 2);
    imageboxZoomItem.left = $('.' + documentClass).offset().left + (sticker.geometry.width * ratio / 2);
    imageboxZoomItem.clientX = e.changedTouches[0].clientX ? e.changedTouches[0].clientX : 0;
    imageboxZoomItem.clientY = e.changedTouches[0].clientY ? e.changedTouches[0].clientY : 0;


    var x = Math.abs(imageboxZoomItem.left - e.touches[0].pageX);
    var y = Math.abs(imageboxZoomItem.top - e.touches[0].pageY);
    imageboxZoomItem.distance = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));

    imageboxZoomItem.nc = Math.sqrt(Math.pow(imageboxZoomItem.nw, 2) + Math.pow(imageboxZoomItem.nh, 2));
    var angle1 = getAngle1(imageboxZoomItem.left, imageboxZoomItem.top, e.touches[0].pageX, e.touches[0].pageY);
    if(0 <= Number(sticker.rotation.angle) && Number(sticker.rotation.angle)< 90){
        imageboxZoomItem.angle1 = Number(angle1) + Number(sticker.rotation.angle);
    }
    else if(90 <= Number(sticker.rotation.angle) && Number(sticker.rotation.angle) < 180){
        imageboxZoomItem.angle1 = Number(angle1) + Number(sticker.rotation.angle - 90);
    }
    else if(180 <= Number(sticker.rotation.angle) && Number(sticker.rotation.angle) < 270){
        imageboxZoomItem.angle1 = Number(angle1) + Number(sticker.rotation.angle - 180);
    }
    else if(270 <= Number(sticker.rotation.angle) && Number(sticker.rotation.angle) < 360){
        imageboxZoomItem.angle1 = Number(angle1) + Number(sticker.rotation.angle - 360);
    }
    else if(360 <= Number(sticker.rotation.angle) && Number(sticker.rotation.angle) < 450){
        imageboxZoomItem.angle1 = Number(angle1) + Number(sticker.rotation.angle - 360);
    }else{
        imageboxZoomItem.angle1 = Number(angle1);
    }
    isDragging = true;
}
var adsorbNumber = 6;
function imageboxZoomMove(e, imagebox, ratio,editbox, callback) {
    if (!isDragging || imagebox.lock) {
        return
    }
    var _top1 = e.touches[0].pageY;
    var _left1 = e.touches[0].pageX;

    var x = Math.abs(imageboxZoomItem.left - e.touches[0].pageX);
    var y = Math.abs(imageboxZoomItem.top - e.touches[0].pageY);
    var z = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
    var _w = (Number(imageboxZoomItem.nw) + Number(z) - imageboxZoomItem.distance) < 30 ? 31 : (Number(imageboxZoomItem.nw) + Number(z) - imageboxZoomItem.distance);
    var _h = _w / imageboxZoomItem.nw * imageboxZoomItem.nh;
    if(_h<30){
        _h = 31;
        _w = _h / imageboxZoomItem.nh * imageboxZoomItem.nw;
    }

    if(imagebox.image && imagebox.image.resource && imagebox.image.resource.identifier){
        imagebox.image.width = _w / imageboxZoomItem.nw * imageboxZoomItem.imageboxImgW / ratio;
        imagebox.image.height = _w / imageboxZoomItem.nw * imageboxZoomItem.imageboxImgH / ratio;
        imagebox.image.offsetx = _w / imageboxZoomItem.nw * imageboxZoomItem.imageboxImgX / ratio;
        imagebox.image.offsety = _w / imageboxZoomItem.nw * imageboxZoomItem.imageboxImgY / ratio;
        if(imagebox.bokehtype != 'None'){
            imagebox.image.offsetx = 0;
            imagebox.image.offsety = 0;
            imagebox.blurredrectangle.width = _w / imageboxZoomItem.nw * imageboxZoomItem.imageboxImgblurredrectangleW / ratio;
            imagebox.blurredrectangle.height = _w / imageboxZoomItem.nw * imageboxZoomItem.imageboxImgblurredrectangleH / ratio;
            imagebox.blurredrectangle.x = _w / imageboxZoomItem.nw * imageboxZoomItem.imageboxImgblurredrectangleX / ratio;
            imagebox.blurredrectangle.y = _w / imageboxZoomItem.nw * imageboxZoomItem.imageboxImgblurredrectangleY / ratio;
        }
    }
    imagebox.geometry.width = _w / ratio;
    imagebox.geometry.height = _h / ratio;
    imagebox.geometry.x = (imageboxZoomItem.x2 - (_w - imageboxZoomItem.nw)/2) / ratio;
    imagebox.geometry.y = (imageboxZoomItem.y2 - (_h - imageboxZoomItem.nh)/2) / ratio;
    imagebox.rotation.angle = getAngle(imageboxZoomItem.left, imageboxZoomItem.top, _left1, _top1) + imageboxZoomItem.angle1;
    if(imagebox.rotation.angle>360){
        imagebox.rotation.angle = imagebox.rotation.angle - 360;
    }
    imagebox.rotation.angle = adsorbAngle(imagebox.rotation.angle)
    if(callback){
        callback()
    }
}
function adsorbAngle(angle) {
    if(-adsorbNumber < angle && angle < adsorbNumber){angle = 0}
    else if(90-adsorbNumber < angle && angle < 90+adsorbNumber){angle = 90}
    else if(180-adsorbNumber < angle && angle < 180+adsorbNumber){angle = 180}
    else if(270-adsorbNumber < angle && angle < 270+adsorbNumber){angle = 270}
    else if(360-adsorbNumber < angle && angle < 360+adsorbNumber){angle = 360}
    return angle
}
function imageboxZoomEnd(callback) {
    isDragging = false;
    imageboxZoomItem = {};
    if(callback){
        callback()
    }
}
function imageboxStartStartCu(e, item) {
    if (item.lock) {
        return;
    }
    imageboxZoomItem.l0 =  $('.pitch').offset().left;
    imageboxZoomItem.t0 = $('.pitch').offset().top;
    imageboxZoomItem.w0 = $('.pitch')[0].offsetWidth;
    imageboxZoomItem.h0 = $('.pitch')[0].offsetHeight;
    imageboxZoomItem.cx = imageboxZoomItem.l0 + imageboxZoomItem.w0 / 2;   // 原中心点x
    imageboxZoomItem.cy = imageboxZoomItem.t0 + imageboxZoomItem.h0 / 2;   // 原中心点y
    imageboxZoomItem.angle = Number(item.rotation.angle);
    imageboxZoomItem.pt0 = rotatePoint({x: e.touches[0].pageX, y: e.touches[0].pageY}, {x: imageboxZoomItem.cx, y: imageboxZoomItem.cy}, -imageboxZoomItem.angle);
    imageboxZoomItem.dx = 0;     // 框left变化
    imageboxZoomItem.dy = 0;     // 框top变化
    imageboxZoomItem.dw = 0;     // 框长变化
    imageboxZoomItem.dh = 0;     // 框高变化
    imageboxZoomItem.dcx = 0;    // 中心点x向偏移
    imageboxZoomItem.dcy = 0;    // 中心点y向偏移

    imageboxZoomItem.gx = item.geometry.x;
    imageboxZoomItem.gy = item.geometry.y;
    imageboxZoomItem.gw = item.geometry.width;
    imageboxZoomItem.gh = item.geometry.height;


    if(item.image && item.image.resource && item.image.resource.identifier){
        imageboxZoomItem.imageboxImgW = angular.copy(item.image.width);
        imageboxZoomItem.imageboxImgH = angular.copy(item.image.height);
        imageboxZoomItem.imageboxImgX = angular.copy(item.image.offsetx);
        imageboxZoomItem.imageboxImgY = angular.copy(item.image.offsety);
        if(item.bokehtype != 'None'){
            imageboxZoomItem.imageboxImgblurredrectangleW = angular.copy(item.blurredrectangle.width);
            imageboxZoomItem.imageboxImgblurredrectangleH = angular.copy(item.blurredrectangle.height);
            imageboxZoomItem.imageboxImgblurredrectangleX = angular.copy(item.blurredrectangle.x);
            imageboxZoomItem.imageboxImgblurredrectangleY = angular.copy(item.blurredrectangle.y);
        }
    }
    isDragging = true;
}
function imageboxStartOnCu(e, item, stick, scale, moveCallback) {
    if (!isDragging || item.lock) {
        return
    }
    var pt1 = rotatePoint({x: e.touches[0].pageX, y: e.touches[0].pageY}, {x: imageboxZoomItem.cx, y: imageboxZoomItem.cy}, -imageboxZoomItem.angle);
    if (stick == 'left') {
        imageboxZoomItem.dx = pt1.x - imageboxZoomItem.pt0.x;
        imageboxZoomItem.dw = -imageboxZoomItem.dx;
        imageboxZoomItem.dcx = imageboxZoomItem.dx/2;
    }
    else if (stick == 'top') {
        imageboxZoomItem.dy = pt1.y - imageboxZoomItem.pt0.y;
        imageboxZoomItem.dh = -imageboxZoomItem.dy;
        imageboxZoomItem.dcy = imageboxZoomItem.dy/2;
    }
    else if (stick == 'right') {
        imageboxZoomItem.dw = pt1.x - imageboxZoomItem.pt0.x;
        imageboxZoomItem.dcx = imageboxZoomItem.dw / 2;
    }
    else if (stick == 'bottom') {
        imageboxZoomItem.dh = pt1.y - imageboxZoomItem.pt0.y;
        imageboxZoomItem.dcy = imageboxZoomItem.dh / 2;
    }
    else if (stick == 'leftTop') {
        var offsetX = pt1.x - imageboxZoomItem.pt0.x;
        var offsetY = pt1.y - imageboxZoomItem.pt0.y;
        if ((imageboxZoomItem.gw - offsetX / scale) * imageboxZoomItem.gh  > (imageboxZoomItem.gh - offsetY / scale) * imageboxZoomItem.gw ) {
            offsetX = offsetY * imageboxZoomItem.gw / imageboxZoomItem.gh;
        } else {
            offsetY = offsetX * imageboxZoomItem.gh / imageboxZoomItem.gw;
        }

        imageboxZoomItem.dx = offsetX;
        imageboxZoomItem.dy = offsetY;

        imageboxZoomItem.dw = -imageboxZoomItem.dx;
        imageboxZoomItem.dh = -imageboxZoomItem.dy;
        imageboxZoomItem.dcx = imageboxZoomItem.dx / 2;
        imageboxZoomItem.dcy = imageboxZoomItem.dy / 2;
    }
    else if (stick == 'leftBottom') {
        var offsetX = pt1.x - imageboxZoomItem.pt0.x;
        var offsetY = pt1.y - imageboxZoomItem.pt0.y;
        if ((imageboxZoomItem.gw - offsetX / scale) * imageboxZoomItem.gh  > (imageboxZoomItem.gh + offsetY / scale) * imageboxZoomItem.gw ) {
            offsetX = -1 * offsetY * imageboxZoomItem.gw / imageboxZoomItem.gh;
        } else {
            offsetY = -1 * offsetX * imageboxZoomItem.gh / imageboxZoomItem.gw;
        }

        imageboxZoomItem.dx = offsetX;
        imageboxZoomItem.dw = -imageboxZoomItem.dx;
        imageboxZoomItem.dh = offsetY;
        imageboxZoomItem.dcx = imageboxZoomItem.dx / 2;
        imageboxZoomItem.dcy = imageboxZoomItem.dh / 2;
    }
    else if (stick == 'rightTop') {
        var offsetX = pt1.x - imageboxZoomItem.pt0.x;
        var offsetY = pt1.y - imageboxZoomItem.pt0.y;
        if ((imageboxZoomItem.gw + offsetX / scale) * imageboxZoomItem.gh  > (imageboxZoomItem.gh - offsetY / scale) * imageboxZoomItem.gw ) {
            offsetX = -1 * offsetY * imageboxZoomItem.gw / imageboxZoomItem.gh;
        } else {
            offsetY = -1 * offsetX * imageboxZoomItem.gh / imageboxZoomItem.gw;
        }

        imageboxZoomItem.dy = offsetY;
        imageboxZoomItem.dw = offsetX;
        imageboxZoomItem.dh = -imageboxZoomItem.dy;
        imageboxZoomItem.dcx = imageboxZoomItem.dw / 2;
        imageboxZoomItem.dcy = imageboxZoomItem.dy / 2;
    }
    else if (stick == 'rightBottom') {
        var offsetX = pt1.x - imageboxZoomItem.pt0.x;
        var offsetY = pt1.y - imageboxZoomItem.pt0.y;
        if ((imageboxZoomItem.gw + offsetX / scale) * imageboxZoomItem.gh  > (imageboxZoomItem.gh + offsetY / scale) * imageboxZoomItem.gw ) {
            offsetX = offsetY * imageboxZoomItem.gw / imageboxZoomItem.gh;
        } else {
            offsetY = offsetX * imageboxZoomItem.gh / imageboxZoomItem.gw;
        }

        imageboxZoomItem.dw = offsetX;
        imageboxZoomItem.dh = offsetY;
        imageboxZoomItem.dcx = imageboxZoomItem.dw / 2;
        imageboxZoomItem.dcy = imageboxZoomItem.dh / 2;
    }
    else {
        e.stopPropagation();
        return;
    }
    // 如果框尺寸小于5mm, 不处理
    if (imageboxZoomItem.gw + (imageboxZoomItem.dw / scale) < 5 || imageboxZoomItem.gh + (imageboxZoomItem.dh / scale) < 5) {
        e.stopPropagation();
        return;
    }
    // 中心点偏移dc1
    var dc1 = rotatePoint({x: imageboxZoomItem.dcx, y: imageboxZoomItem.dcy}, {x: 0, y: 0}, imageboxZoomItem.angle);
    // 偏移补偿
    var cx_fix =  dc1.x - imageboxZoomItem.dcx;
    var cy_fix = dc1.y - imageboxZoomItem.dcy;

    item.geometry.x = imageboxZoomItem.gx + ((imageboxZoomItem.dx + cx_fix) / scale);
    item.geometry.y = imageboxZoomItem.gy + ((imageboxZoomItem.dy + cy_fix) / scale);
    item.geometry.width = imageboxZoomItem.gw + (imageboxZoomItem.dw / scale);
    item.geometry.height = imageboxZoomItem.gh + (imageboxZoomItem.dh / scale);
    if(item.geometry.width*scale < 30){
        item.geometry.width = 31 / scale
    }
    if(item.geometry.height*scale < 30){
        item.geometry.height = 31 / scale
    }
    if(item.image && item.image.resource && item.image.resource.identifier){
        item.image.width = item.geometry.width / imageboxZoomItem.gw * imageboxZoomItem.imageboxImgW;
        item.image.height = item.geometry.width / imageboxZoomItem.gw * imageboxZoomItem.imageboxImgH;
        item.image.offsetx = item.geometry.width / imageboxZoomItem.gw * imageboxZoomItem.imageboxImgX;
        item.image.offsety = item.geometry.width / imageboxZoomItem.gw * imageboxZoomItem.imageboxImgY;
        if(item.bokehtype != 'None'){
            item.image.offsetx = 0;
            item.image.offsety = 0;
            item.blurredrectangle.width = item.geometry.width / imageboxZoomItem.gw * imageboxZoomItem.imageboxImgblurredrectangleW;
            item.blurredrectangle.height = item.geometry.width / imageboxZoomItem.gw * imageboxZoomItem.imageboxImgblurredrectangleH;
            item.blurredrectangle.x = item.geometry.width / imageboxZoomItem.gw * imageboxZoomItem.imageboxImgblurredrectangleX;
            item.blurredrectangle.y = item.geometry.width / imageboxZoomItem.gw * imageboxZoomItem.imageboxImgblurredrectangleY;
        }
    }
    if (moveCallback) {
        moveCallback(item);
    }
    e.stopPropagation();
}
function imageboxStartEndCu(e, upCallback) {
    isDragging = false;
    imageboxZoomItem = {};
    if (upCallback) {
        upCallback();
    }
    e.stopPropagation();
}
//照片框展开
function imageboxModeIn(imagebox, callback) {
    if (imagebox.image.resource.adaptation == 'Height') {
        imagebox.image.height = imagebox.geometry.width / imagebox.image.width * imagebox.image.height;
        imagebox.image.width = imagebox.geometry.width;
        imagebox.image.offsetx = 0;
        imagebox.image.offsety = 0;
    }
    if (imagebox.image.resource.adaptation == 'Width') {
        imagebox.image.width = imagebox.geometry.height / imagebox.image.height * imagebox.image.width;
        imagebox.image.height = imagebox.geometry.height;
        imagebox.image.offsetx = 0;
        imagebox.image.offsety = 0;
    }
    imagebox.bokehtype = 'None';
    imagebox.image.scale = 1;
    callback(imagebox)
}
//照片框缩回
function imageboxModeOut(imagebox, callback) {

    if (imagebox.image.resource.adaptation == 'Height') {
        imagebox.image.height = imagebox.geometry.width / imagebox.image.width * imagebox.image.height;
        imagebox.image.width = imagebox.geometry.width;
        imagebox.image.offsetx = 0;
        imagebox.image.offsety = 0;
    }
    if (imagebox.image.resource.adaptation == 'Width') {
        imagebox.image.width = imagebox.geometry.height / imagebox.image.height * imagebox.image.width;
        imagebox.image.height = imagebox.geometry.height;
        imagebox.image.offsetx = 0;
        imagebox.image.offsety = 0;
    }

    imagebox.bokehtype = imagebox.bokehtypes;
    imagebox.image.scale = 1;
    callback(imagebox)
}
//照片框放大
function imageboxMassive(imagebox) {
    imagebox.image.scale *= 1.2;
}
//照片框缩小
function imageboxMin(imagebox) {
    imagebox.image.scale = imagebox.image.scale / 1.2;
    imagebox.image.offsetx = 0;
    imagebox.image.offsety = 0;
    if (imagebox.image.scale < 1) {
        imagebox.image.scale = 1;
    }
}
function ImageboxCb(_image, imagebox, pageData,callback){
    imagebox.image.offsetx = (_image.offsetx * _image.scale - (imagebox.image.width*imagebox.image.scale-_image.width*_image.scale)/2) / imagebox.image.scale;
    imagebox.image.offsety = (_image.offsety * _image.scale - (imagebox.image.height*imagebox.image.scale-_image.height*_image.scale)/2) / imagebox.image.scale;
    if(imagebox.image.width*imagebox.image.scale + imagebox.image.offsetx*imagebox.image.scale <= imagebox.geometry.width){
        imagebox.image.offsetx = (imagebox.geometry.width - imagebox.image.width*imagebox.image.scale) / imagebox.image.scale;
    }
    if(imagebox.image.height*imagebox.image.scale + imagebox.image.offsety*imagebox.image.scale <= imagebox.geometry.height){
        imagebox.image.offsety = (imagebox.geometry.height - imagebox.image.height*imagebox.image.scale) / imagebox.image.scale;
    }
    if(imagebox.image.offsetx > 0){
        imagebox.image.offsetx = 0;
    }
    if(imagebox.image.offsety > 0){
        imagebox.image.offsety = 0;
    }
    if(callback){
        callback()
    }
}
//照片框旋转
function imageboxRotate($scope, imagebox, flag, callback) {
    if (imagebox.flip) {
        imagebox.image.angle -= 90;
        if (imagebox.image.angle == -90) {
            imagebox.image.angle = 270
        }
    } else {
        imagebox.image.angle += 90;
        if (Math.abs(imagebox.image.angle) == 360) {
            imagebox.image.angle = 0
        }
    }
    imagebox.image.scale = 1;
    imagebox.image.offsetx = 0;
    imagebox.image.offsety = 0;
    getBackgroundSource2(imagebox, imagebox.geometry.width, imagebox.geometry.height, imagebox.image, imagebox.bokehtype, $scope, function () {
        if(callback){
            callback()
        }
    })
}
//照片框还原
function imagRestore($scope, imagebox, $http) {
    if(imagebox && imagebox.image){
        imagebox.flip = false;
        imagebox.image.scale = 1;
        imagebox.image.angle = 0;
        imagebox.image.offsetx = 0;
        imagebox.image.offsety = 0;
        addImagebox($http, imagebox, function () {})
    }
}
//照片框翻转
function imageboxOverturn(imagebox) {
    imagebox.flip = !imagebox.flip ? true : false;
}
//添加图片框
function imageboxAdd($http, img,editbox, article, callback) {
    $http({url: img.identifier + '?imageInfo'}).success(function (data) {
        var _imagebox = {
            blurredrectangle:null,
            bokehtype:article.bokehtype || 'None',
            bokehtypes:article.bokehtype || 'None',
            geometry:{
                width: data.width,
                height: data.height,
                x:0,
                y:0
            },
            image: {
                resource: {
                    identifier: img.identifier,
                    provider: 'qiniu'
                },
                filterResource: {
                    identifier: '',
                    provider: 'qiniu'
                },
                scale: 1,
                angle: 0
            },
            mask: {
                resource:{
                    identifier: '',
                    provider: '',
                }
            },
            rotation:{
                angle: 0
            },
            useradded: true,
            lock:true,
        }

        var bgImgW = data.width;
        var bgImgH = data.height;
        var bgImgR = bgImgW / bgImgH;
        var bgImgR1 = editbox.width / editbox.height;
        if (bgImgR >= bgImgR1) {
            _imagebox.geometry.width = editbox.width * 2 / 3;
            _imagebox.geometry.height = _imagebox.geometry.width * bgImgH / bgImgW;
        } else {
            _imagebox.geometry.height = editbox.height * 2 / 3;
            _imagebox.geometry.width = _imagebox.geometry.height * bgImgW / bgImgH;
        }
        _imagebox.geometry.x = (editbox.width - _imagebox.geometry.width) / 2 + editbox.x;
        _imagebox.geometry.y = (editbox.height - _imagebox.geometry.height) / 2 + editbox.y;
        callback(_imagebox)
    }).error(function (error) {
    });
}
/*******************************************素材处理*************************************************************************/
//添加素材
function imageartAdd($http, identifier,editbox, callback, ratio, doodle) {
    ratio = ratio || 1;
    $http({url: identifier + '?imageInfo'}).success(function (data) {
        var _imageart = {
            movable: true,
            editable: true,
            onlyshow: false,
            offsetx: '0',
            offsety: '0',
            transparency: '1',
            geometry: {
                x: '0',
                y: '0',
                width: data.width,
                height: data.height
            },
            rotation: {
                angle: '0'
            },
            resource: {
                provider: '',
                identifier: identifier,
                width: '',
                height: ''
            },
            scale: 1,
            useradded: true,
            imageInfo: data
        }
        if(!doodle){
            var w = 110/ratio;
            var h = 110/ratio;
            var bgImgW = data.width;
            var bgImgH = data.height;
            var bgImgR = bgImgW / bgImgH;
            var bgImgR1 = w / h;
            if (bgImgR >= bgImgR1) {
                _imageart.geometry.width = w;
                _imageart.geometry.height = _imageart.geometry.width * bgImgH / bgImgW;
            } else {
                _imageart.geometry.height = h;
                _imageart.geometry.width = _imageart.geometry.height * bgImgW / bgImgH;
            }
            _imageart.geometry.x = (editbox.width - _imageart.geometry.width) / 2 + editbox.x;
            _imageart.geometry.y = (editbox.height - _imageart.geometry.height) / 2 + editbox.y;
        }else{
            _imageart.geometry.width = data.width / ratio;
            _imageart.geometry.height = data.height / ratio;
        }

        _imageart.width = _imageart.geometry.width;
        _imageart.height = _imageart.geometry.height;
        callback(_imageart)
    }).error(function (error) {
    });
}
//素材翻转
function imageartOverturn(imageart) {
    imageart.flip = !imageart.flip ? true : false;
}
//素材复制
function imageartCopys(level, imageart) {
    var _level = angular.copy(imageart);
    _level.seq = level.length + 1;
    level.push(_level)
}
//素材缩放
var imageartZoomItem = {};
var isDragging = false;
function imageartZoomStart(e, level, documentClass, ratio, callback) {

    var targ = e.currentTarget ? e.currentTarget : e.srcElement;
    var textIndex = targ.dataset.index;
    textIndex = parseInt(textIndex);
    var sticker = level[textIndex].imageart;
    if(!sticker.useradded){
        return
    }
    if(callback){callback(textIndex);}

    imageartZoomItem.nw = angular.copy(sticker.geometry.width * ratio);
    imageartZoomItem.nh = angular.copy(sticker.geometry.height * ratio);
    imageartZoomItem.nw1 = angular.copy(sticker.width * ratio);
    imageartZoomItem.nh1 = angular.copy(sticker.height * ratio);
    imageartZoomItem.x1 = angular.copy(sticker.offsetx * ratio);
    imageartZoomItem.y1 = angular.copy(sticker.offsety * ratio);
    imageartZoomItem.x2 = sticker.geometry.x * ratio;
    imageartZoomItem.y2 = sticker.geometry.y * ratio;
    imageartZoomItem.top = $('.' + documentClass).offset().top + (sticker.geometry.height * ratio / 2);
    imageartZoomItem.left = $('.' + documentClass).offset().left + (sticker.geometry.width * ratio / 2);
    imageartZoomItem.clientX = e.changedTouches[0].clientX ? e.changedTouches[0].clientX : 0;
    imageartZoomItem.clientY = e.changedTouches[0].clientY ? e.changedTouches[0].clientY : 0;


    var x = Math.abs(imageartZoomItem.left - e.touches[0].pageX);
    var y = Math.abs(imageartZoomItem.top - e.touches[0].pageY);
    imageartZoomItem.distance = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));

    imageartZoomItem.nc = Math.sqrt(Math.pow(imageartZoomItem.nw, 2) + Math.pow(imageartZoomItem.nh, 2));
    var angle1 = getAngle1(imageartZoomItem.left, imageartZoomItem.top, e.touches[0].pageX, e.touches[0].pageY);
    if(0 <= Number(sticker.rotation.angle) && Number(sticker.rotation.angle)< 90){
        imageartZoomItem.angle1 = Number(angle1) + Number(sticker.rotation.angle);
    }
    else if(90 <= Number(sticker.rotation.angle) && Number(sticker.rotation.angle) < 180){
        imageartZoomItem.angle1 = Number(angle1) + Number(sticker.rotation.angle - 90);
    }
    else if(180 <= Number(sticker.rotation.angle) && Number(sticker.rotation.angle) < 270){
        imageartZoomItem.angle1 = Number(angle1) + Number(sticker.rotation.angle - 180);
    }
    else if(270 <= Number(sticker.rotation.angle) && Number(sticker.rotation.angle) < 360){
        imageartZoomItem.angle1 = Number(angle1) + Number(sticker.rotation.angle - 360);
    }
    else if(360 <= Number(sticker.rotation.angle) && Number(sticker.rotation.angle) < 450){
        imageartZoomItem.angle1 = Number(angle1) + Number(sticker.rotation.angle - 360);
    }
    isDragging = true;
}
function imageartZoomMove(e, imageart, ratio,editbox, callback) {
    if (isDragging || imageart.useradded) {
        var _top1 = e.touches[0].pageY;
        var _left1 = e.touches[0].pageX;

        var x = Math.abs(imageartZoomItem.left - e.touches[0].pageX);
        var y = Math.abs(imageartZoomItem.top - e.touches[0].pageY);
        var z = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
        var _w = (Number(imageartZoomItem.nw) + Number(z) - imageartZoomItem.distance);
        var _h = _w / imageartZoomItem.nw * imageartZoomItem.nh;
        // if(_w > editbox.width * ratio){
        //     _w = editbox.width * ratio;
        //     _h = _w / imageartZoomItem.nw * imageartZoomItem.nh;
        // }
        // if(_h > editbox.height * ratio){
        //     _h = editbox.height * ratio;
        //     _w = _h / imageartZoomItem.nh * imageartZoomItem.nw;
        // }

        imageart.geometry.width = _w / ratio;
        imageart.geometry.height = _h / ratio;
        imageart.geometry.x = (imageartZoomItem.x2 - (_w - imageartZoomItem.nw)/2) / ratio;
        imageart.geometry.y = (imageartZoomItem.y2 - (_h - imageartZoomItem.nh)/2) / ratio;
        imageart.offsetx = (_w / (imageartZoomItem.nw / imageartZoomItem.nw1)) / (imageartZoomItem.nw1 / imageartZoomItem.x1) / ratio;
        imageart.offsety = (_h / (imageartZoomItem.nh / imageartZoomItem.nh1)) / (imageartZoomItem.nh1 / imageartZoomItem.y1) / ratio;
        imageart.rotation.angle = getAngle(imageartZoomItem.left, imageartZoomItem.top, _left1, _top1) + imageartZoomItem.angle1;
        if(imageart.rotation.angle>360){
            imageart.rotation.angle = imageart.rotation.angle - 360;
        }
        imageart.rotation.angle = adsorbAngle(imageart.rotation.angle)
    }
    if(callback){
        callback()
    }
}
function imageartZoomEnd(callback) {
    isDragging = false;
    imageartZoomItem = {};
    if(callback){
        callback()
    }
}
//获得人物中心和鼠标坐标连线，与y轴正半轴之间的夹角
function getAngle(px, py, mx, my) {
    var x = Math.abs(px - mx);
    var y = Math.abs(py - my);
    var z = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
    var cos = y / z;
    var radina = Math.acos(cos);//用反三角函数求弧度
    var angle = Math.floor(180 / (Math.PI / radina));//将弧度转换成角度
    if (mx < px && my > py) {//鼠标在第三象限
        angle = angle;
    }
    if (mx < px && my < py) {
        angle = 180 - angle;
    }
    if (mx > px && my < py) {
        angle = 180 + angle;
    }
    if (mx > px && my > py) {
        angle = 360 - angle;
    }
    return angle;
}
//获得人物中心和鼠标坐标连线，与y轴正半轴之间的夹角
function getAngle1(px, py, mx, my) {
    var x = Math.abs(px - mx);
    var y = Math.abs(py - my);
    var z = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
    var cos = y / z;
    var radina = Math.acos(cos);//用反三角函数求弧度
    var angle = Math.floor(180 / (Math.PI / radina));//将弧度转换成角度
    return angle;
}
//素材移动
function imageartTouchstartStart(e, levelIndex, level, ratio,editbox, callback) {
    var targ = e.target ? e.target : e.srcElement;
    var imgIndex = targ.dataset.index != null? targ.dataset.index: levelIndex;
    imgIndex = parseInt(imgIndex);
    var sticker = level[imgIndex].imageart;
    if(!sticker.useradded){
        return
    }
    callback(imgIndex)
    if (!e.originalEvent || e.originalEvent.touches.length == 1) {
        imageartZoomItem.x = e.originalEvent.touches[0].pageX || 0;          //鼠标到页面左边的距离
        imageartZoomItem.y = e.originalEvent.touches[0].pageY || 0;          //鼠标到页面顶部的距离
        imageartZoomItem.l = sticker.geometry.x * ratio;
        imageartZoomItem.t = sticker.geometry.y * ratio;
        // imageartZoomItem.l = (sticker.geometry.x + editbox.x + vm.pageData[vm.pageIndex].mediabox.x) * ratio + $scope.dWidth * 0.05;
        // imageartZoomItem.t = (sticker.geometry.y + editbox.y + vm.pageData[vm.pageIndex].mediabox.y) * ratio + $(".c-productThree4-body").offset().top;
        imageartZoomItem.r = (editbox.width + editbox.x - sticker.geometry.width) * ratio;
        imageartZoomItem.b = (editbox.height + editbox.y - sticker.geometry.height) * ratio;
        if (e.originalEvent && e.originalEvent.touches.length >= 2) {
            imageartZoomItem.start = e.originalEvent.touches;
        };
        isDragging = true;
    };
    if (e.originalEvent && e.originalEvent.touches.length >= 2) {
        imageartZoomItem.x = e.originalEvent.touches[0].pageX != e.originalEvent.touches[0].pageX ? e.originalEvent.touches[0].pageX  : 0;
        imageartZoomItem.y = e.originalEvent.touches[0].pageY != e.originalEvent.touches[0].pageY ? e.originalEvent.touches[0].pageY  : 0;
        //获取w和h
        imageartZoomItem.nw = angular.copy(sticker.geometry.width) * ratio;
        imageartZoomItem.nh = angular.copy(sticker.geometry.height) * ratio;
        imageartZoomItem.nw1 = angular.copy(sticker.width) * ratio;
        imageartZoomItem.nh1 = angular.copy(sticker.height) * ratio;
        imageartZoomItem.x1 = angular.copy(sticker.offsetx * ratio);
        imageartZoomItem.y1 = angular.copy(sticker.offsety * ratio);
        imageartZoomItem.x2 = sticker.geometry.x * ratio;
        imageartZoomItem.y2 = sticker.geometry.y * ratio;
        imageartZoomItem._scale = angular.copy(sticker.scale);
        imageartZoomItem.start = e.originalEvent.touches;
        //开关打开
        isDragging = true;
    };
}
//素材单指拖拽
function imagearOne(e, sticker, ratio, editbox, callback){
    if (!isDragging) {
        return
    }
    // fn(e);
    //获取x和y
    var nx = e.originalEvent.touches[0].pageX != null ? e.originalEvent.touches[0].pageX: 0;
    var ny = e.originalEvent.touches[0].pageY != null ? e.originalEvent.touches[0].pageY: 0;
    //计算移动后的左偏移量和顶部的偏移量
    var nl = nx - (imageartZoomItem.x - imageartZoomItem.l);
    var nt = ny - (imageartZoomItem.y - imageartZoomItem.t);

    // if (nl < editbox.x * ratio) {
    //     nl = editbox.x * ratio
    // }
    // ;
    // if (nl > imageartZoomItem.r) {
    //     nl = imageartZoomItem.r
    // }
    // ;
    // if (nt < editbox.y * ratio) {
    //     nt = editbox.y * ratio
    // }
    // ;
    // if (nt > imageartZoomItem.b) {
    //     nt = imageartZoomItem.b
    // }
    ;

    sticker.geometry.x = nl / ratio;
    sticker.geometry.y = nt / ratio;
    if(callback){
        callback()
    }
};
//素材双指拖拽
function imagearTouchstartTwo(callback) {
    if(imageartZoomItem && imageartZoomItem.start){
        callback(imageartZoomItem)
    }
}
function imagearTwo(e, nl, sticker, editbox, ratio){
    if (!isDragging || !sticker.useradded) {
        return;
    }
    var _w = (Number(imageartZoomItem.nw) + Number(nl));
    var _h = _w / imageartZoomItem.nw * imageartZoomItem.nh;
    // if(_w > editbox.width * ratio){
    //     _w = editbox.width * ratio;
    //     _h = _w / imageartZoomItem.nw * imageartZoomItem.nh;
    // }
    // if(_h > editbox.height * ratio){
    //     _h = editbox.height * ratio;
    //     _w = _h / imageartZoomItem.nh * imageartZoomItem.nw;
    // }
    sticker.geometry.width = _w / ratio;
    sticker.geometry.height = _h / ratio;
    sticker.offsetx = (_w / (imageartZoomItem.nw / imageartZoomItem.nw1)) / (imageartZoomItem.nw1 / imageartZoomItem.x1) / ratio;
    sticker.offsety = (_h / (imageartZoomItem.nh / imageartZoomItem.nh1)) / (imageartZoomItem.nh1 / imageartZoomItem.y1) / ratio;
    sticker.geometry.x = (Number(imageartZoomItem.x2) - Number((_w - imageartZoomItem.nw)/2)) / ratio;
    sticker.geometry.y = (Number(imageartZoomItem.y2) - Number((_h - imageartZoomItem.nh)/2)) / ratio;
}
function getDistance(p1, p2) {
    var x = p2.pageX - p1.pageX,
        y = p2.pageY - p1.pageY;
    return Math.sqrt((x * x) + (y * y));
};

/*******************************************文字处理*************************************************************************/
var textBoxItem = {};
var isTextbox = false;
//文字移动
function textBoxMoveStart(e, levelIndex, level, ratio, editbox, callback) {
    var targ = e.currentTarget ? e.currentTarget : e.srcElement;
    var textIndex = targ.dataset.index != null ? targ.dataset.index : levelIndex;
    textIndex = parseInt(textIndex);
    var sticker = level[textIndex].textbox;
    if(!sticker.editable && !sticker.movable){
        return
    }
    callback(textIndex)
    textBoxItem.x = e.changedTouches[0].clientX != null ? e.changedTouches[0].clientX: 0;          //鼠标到页面左边的距离
    textBoxItem.y = e.changedTouches[0].clientY != null ? e.changedTouches[0].clientY: 0;          //鼠标到页面顶部的距离
    textBoxItem.l = sticker.geometry.x * ratio;
    textBoxItem.t = sticker.geometry.y * ratio;
    textBoxItem.r = (editbox.width + editbox.x - sticker.geometry.width) * ratio;
    textBoxItem.b = (editbox.height + editbox.y - sticker.geometry.height) * ratio;
    isTextbox = true;
};
function textBoxMoveOn(e, textbox, ratio, editbox,callback) {
    if (!isTextbox || !textbox.movable) {
        return
    }
    //获取x和y
    var nx = e.changedTouches[0].clientX != null ?e.changedTouches[0].clientX : 0;
    var ny = e.changedTouches[0].clientY != null ?e.changedTouches[0].clientY : 0;
    //计算移动后的左偏移量和顶部的偏移量
    var nl = nx - (textBoxItem.x - textBoxItem.l);
    var nt = ny - (textBoxItem.y - textBoxItem.t);

    // if (nl < editbox.x * ratio) {
    //     nl = editbox.x * ratio
    // }
    // ;
    // if (nl > textBoxItem.r) {
    //     nl = textBoxItem.r
    // }
    // ;
    // if (nt < editbox.y * ratio) {
    //     nt = editbox.y * ratio
    // }
    // ;
    // if (nt > textBoxItem.b) {
    //     nt = textBoxItem.b
    // }
    // ;

    textbox.geometry.x = nl / ratio;
    textbox.geometry.y = nt / ratio;
    if(callback){callback()}
}
function textBoxMoveEnd() {
    isTextbox = false;
    textBoxItem = {};
}
//文字四角拖拽
function textboxZoomStart(e, levelIndex, level, ratio, documentClass, callback) {
    var targ = e.currentTarget ? e.currentTarget : e.srcElement;
    var textIndex = targ.dataset.index != null ?targ.dataset.index : levelIndex;
    var sticker = level[textIndex].textbox;
    callback(textIndex)
    textBoxItem.x = e.touches[0].pageX;
    textBoxItem.y = e.touches[0].pageY;
    //获取w和h
    textBoxItem.nw = angular.copy(sticker.geometry.width);
    textBoxItem.nh = angular.copy(sticker.geometry.height);
    textBoxItem._left = angular.copy(sticker.geometry.x);
    textBoxItem._top = angular.copy(sticker.geometry.y);
    textBoxItem._size = angular.copy(parseInt(sticker.style.size));
    textBoxItem._lineheight = angular.copy(parseInt(sticker.style.lineheight));

    textBoxItem.top = $('.' + documentClass).offset().top + (sticker.geometry.height * ratio / 2);
    textBoxItem.left = $('.' + documentClass).offset().left + (sticker.geometry.width * ratio / 2);
    var x = Math.abs(textBoxItem.left - e.touches[0].pageX);
    var y = Math.abs(textBoxItem.top - e.touches[0].pageY);
    textBoxItem.distance = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
    isTextbox = true;
}
//文字左右拖拽
function textboxZoomRightStart(e, levelIndex, level, ratio, documentClass, callback) {
    var targ = e.currentTarget ? e.currentTarget : e.srcElement;
    var textIndex = targ.dataset.index != null ? targ.dataset.index: levelIndex;
    callback(textIndex)
    var sticker = level[levelIndex].textbox;
    textBoxItem.x = e.touches[0].pageX;
    textBoxItem.nw = angular.copy(sticker.geometry.width) * ratio;
    textBoxItem.nh = angular.copy(sticker.geometry.height) * ratio;
    textBoxItem.left = angular.copy(sticker.geometry.x) * ratio;
    textBoxItem.top = angular.copy(sticker.geometry.y) * ratio;
    textBoxItem.top1 = $('.' + documentClass).offset().top + (sticker.geometry.height * ratio / 2);
    textBoxItem.left1 = $('.' + documentClass).offset().left + (sticker.geometry.width * ratio / 2);
    var x = Math.abs(textBoxItem.left1 - e.touches[0].pageX);
    var y = Math.abs(textBoxItem.top1 - e.touches[0].pageY);
    textBoxItem.distance = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
    //开关打开
    isTextbox = true;
}
function textboxZoomLeftStart(e, levelIndex, level, ratio, documentClass, callback) {
    var targ = e.currentTarget ? e.currentTarget : e.srcElement;
    var textIndex = targ.dataset.index != null ? targ.dataset.index : levelIndex;
    var sticker = level[textIndex].textbox;
    callback(textIndex)
    textBoxItem.x = e.touches[0].pageX;
    textBoxItem.nw = angular.copy(sticker.geometry.width) * ratio;
    textBoxItem.nh = angular.copy(sticker.geometry.height) * ratio;
    textBoxItem.left = angular.copy(sticker.geometry.x) * ratio;
    textBoxItem.top = angular.copy(sticker.geometry.y) * ratio;

    textBoxItem.top1 = $('.' + documentClass).offset().top + (sticker.geometry.height * ratio / 2);
    textBoxItem.left1 = $('.' + documentClass).offset().left + (sticker.geometry.width * ratio / 2);
    var x = Math.abs(textBoxItem.left1 - e.touches[0].pageX);
    var y = Math.abs(textBoxItem.top1 - e.touches[0].pageY);
    textBoxItem.distance = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
    //开关打开
    isTextbox = true;
}
function textboxZoom(e, item, element, ratio, editbox, callback) {
    if (isTextbox == false) {
        return;
    }
    //获取x和y
    var nx = e.touches[0].pageX;
    //计算移动后的左偏移量和顶部的偏移量
    // var nl = nx - textBoxItem.x;
    var nl = 0;
    if (element == 'left') {
        var x = Math.abs(textBoxItem.left1-nl - e.touches[0].pageX);
        var y = Math.abs(textBoxItem.top1 - e.touches[0].pageY);
        var z = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
        //计算移动后的左偏移量和顶部的偏移量
        nl = -parseInt(z - textBoxItem.distance);
        console.log(nl)
        item.geometry.x = (Number(textBoxItem.left) + Number(nl/2)) / ratio;
        item.geometry.width = (Number(textBoxItem.nw) - Number(nl)) / ratio;
        if (item.geometry.width < parseInt(item.style.size)) {
            item.geometry.width = (Number(parseInt(item.style.size)) + Number(5));
            item.geometry.x = (Number(textBoxItem.left) + Number(nl/2)) / ratio;
            isTextbox = false;
            callback()
            return;
        }
        // if (item.geometry.width > (Number(item.geometry.x) + Number(item.geometry.width))) {
        //     item.geometry.x = 0;
        //     // item.geometry.width = (Number(item.geometry.x) + Number(item.geometry.width));
        //     isTextbox = false;
        //     callback()
        //     return;
        // }
    }
    if (element == 'right') {
        var x = Math.abs(textBoxItem.left1+nl - e.touches[0].pageX);
        var y = Math.abs(textBoxItem.top1 - e.touches[0].pageY);
        var z = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
        //计算移动后的左偏移量和顶部的偏移量
        nl = parseInt(z - textBoxItem.distance);
        item.geometry.width = (Number(textBoxItem.nw) + Number(nl)) / ratio;
        item.geometry.x = (Number(textBoxItem.left) - Number(nl/2)) / ratio;
        if (item.geometry.width < parseInt(item.style.size)) {
            item.geometry.width = (Number(parseInt(item.style.size)) + Number(5));
            isTextbox = false;
            callback()
            return;
        }
        // if (item.geometry.width > editbox.width) {
        //     item.geometry.width = editbox.width;
        //     // item.geometry.x = 0;
        // }
    }
    if (element == 'top') {
        var x = Math.abs(textBoxItem.left1-nl - e.touches[0].pageX);
        var y = Math.abs(textBoxItem.top1 - e.touches[0].pageY);
        var z = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
        //计算移动后的左偏移量和顶部的偏移量
        nl = -parseInt(z - textBoxItem.distance);
        console.log(nl)
        item.geometry.y = (Number(textBoxItem.top) + Number(nl/2)) / ratio;
        item.geometry.height = (Number(textBoxItem.nh) - Number(nl)) / ratio;
        if (item.geometry.height < parseInt(item.style.size)) {
            item.geometry.height = (Number(parseInt(item.style.size)) + Number(5));
            isTextbox = false;
            callback()
            return;
        }
    }
    callback(true)
};
function textboxZoom1(e, item, element, ratio, callback) {
    //开关打开
    if (isTextbox == false) {
        return;
    }
    // if (item.style.size > 100) {
    //     item.style.size = 100;
    //     isTextbox = false;
    //     textBoxItem = {};
    //     return
    // }
    var nl = 0;
    var x = Math.abs(textBoxItem.left + nl - e.touches[0].pageX);
    var y = Math.abs(textBoxItem.top - e.touches[0].pageY);
    var z = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
    //计算移动后的左偏移量和顶部的偏移量
    nl = (parseInt(z - textBoxItem.distance)) / ratio;
    // console.log(nl + '////' + nl1)
    if (element == 'left') {
        if ((Number(textBoxItem.nw) - Number(nl)) < 20) {
            isTextbox = false;
            return;
        }
        item.geometry.width = (Number(textBoxItem.nw) - Number(nl));
        item.geometry.x = (Number(textBoxItem._left) + Number(nl));
        item.style.size = Math.ceil(((Number(textBoxItem.nw) - Number(nl)) / textBoxItem.nw * textBoxItem._size));
        item.style.lineheight =item.style.size;
        item.geometry.y = (Number(textBoxItem._top) - Number(item.geometry.height - textBoxItem.nh));
    }
    if (element == 'top') {
        if ((Number(textBoxItem.nw) + Number(nl)) < 20) {
            isTextbox = false;
            return;
        }
        item.geometry.width = (Number(textBoxItem.nw) + Number(nl));
        item.style.size = Math.ceil(((Number(textBoxItem.nw) + Number(nl)) / textBoxItem.nw * textBoxItem._size));
        item.style.lineheight =item.style.size;
        item.geometry.y = (Number(textBoxItem._top) - Number(item.geometry.height - textBoxItem.nh));
    }
    if (element == 'right') {
        if(writingmodeInit(item.style.writingmode)){
            item.geometry.height = (Number(textBoxItem.nh) + Number(nl) + Number(5));
            item.style.size = Math.ceil(((Number(textBoxItem.nh) + Number(nl)) / textBoxItem.nh * textBoxItem._size));
            item.style.lineheight = item.style.size;
        }else{
            if ((Number(textBoxItem.nw) + Number(nl)) < 20) {
                isTextbox = false;
                return;
            }
            item.geometry.width = (Number(textBoxItem.nw) + Number(nl) + Number(5));
            item.geometry.x = (Number(textBoxItem._left) - Number(nl/2));
            item.style.size = Math.ceil(((Number(textBoxItem.nw) + Number(nl)) / textBoxItem.nw * textBoxItem._size));
            item.style.lineheight = item.style.size;
        }
    }
    if (element == 'bottom') {
        if ((Number(textBoxItem.nw) - Number(nl)) < 20) {
            isTextbox = false;
            return;
        }
        item.geometry.width = (Number(textBoxItem.nw) - Number(nl));
        item.geometry.x = (Number(textBoxItem._left) + Number(nl));
        item.style.size = Math.ceil(((Number(textBoxItem.nw) - Number(nl)) / textBoxItem.nw * textBoxItem._size));
        item.style.lineheight = item.style.size;
        // item.geometry.y = (Number(textBoxItem._top) + Number(item.geometry.height - textBoxItem.nh));
    }
    callback(nl)
}
//文字旋转
function textboxRotateStart(e, levelIndex, level, callback) {
    var targ = e.currentTarget ? e.currentTarget : e.srcElement;
    var textIndex = targ.dataset.index != null ?targ.dataset.index: levelIndex;
    textIndex = parseInt(textIndex);
    var sticker = level[textIndex].textbox;
    if(!sticker.useradded){
        return
    }
    callback(textIndex)
    textBoxItem.clientX = e.changedTouches[0].clientX ? e.changedTouches[0].clientX : 0;
    textBoxItem.clientY = e.changedTouches[0].clientY ? e.changedTouches[0].clientY : 0;
    sticker.rotation.angle = -sticker.rotation.angle;
    textBoxItem.textRotate = sticker.rotation.angle ? 360 - Number(sticker.rotation.angle) : 0;
    var radius = Math.sqrt(sticker.geometry.width * sticker.geometry.width + sticker.geometry.height * sticker.geometry.height)
    textBoxItem.originalRotate = parseInt(180 * Math.asin(sticker.geometry.width / radius) / (2 * Math.asin(1))) + textBoxItem.textRotate;
    isTextbox = true;
}
function textboxRotateOn(e, levelIndex, level, ratio, documentClass, callback) {
    if (isTextbox) {
        var text = level[levelIndex].textbox;
        var _top = $('.' + documentClass).offset().top + (text.geometry.height * ratio / 2);
        var _left = $('.' + documentClass).offset().left + (text.geometry.width * ratio / 2);
        var _top1 = e.touches[0].pageY;
        var _left1 = e.touches[0].pageX;
        text.rotation.angle = getAngle(_left, _top, _left1, _top1);
        text.rotation.angle = adsorbAngle(text.rotation.angle);
    }
    callback()
}
//文字缩放
function textboxZoomStart1(e, levelIndex, level, ratio, documentClass, callback) {
    var targ = e.currentTarget ? e.currentTarget : e.srcElement;
    var textIndex = targ.dataset.index != null ?targ.dataset.index : levelIndex;
    var sticker = level[textIndex].textbox;
    callback(textIndex)
    textBoxItem.x = e.touches[0].pageX;
    textBoxItem.y = e.touches[0].pageY;
    //获取w和h
    textBoxItem.nw = angular.copy(sticker.geometry.width);
    textBoxItem.nh = angular.copy(sticker.geometry.height);
    textBoxItem._left = angular.copy(sticker.geometry.x);
    textBoxItem._top = angular.copy(sticker.geometry.y);
    textBoxItem._size = angular.copy(parseInt(sticker.style.size));
    textBoxItem._lineheight = angular.copy(parseInt(sticker.style.lineheight));

    textBoxItem.top = $('.' + documentClass).offset().top + (sticker.geometry.height * ratio / 2);
    textBoxItem.left = $('.' + documentClass).offset().left + (sticker.geometry.width * ratio / 2);
    var x = Math.abs(textBoxItem.left - e.touches[0].pageX);
    var y = Math.abs(textBoxItem.top - e.touches[0].pageY);
    textBoxItem.distance = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));

    var angle1 = getAngle1(textBoxItem.left, textBoxItem.top, e.touches[0].pageX, e.touches[0].pageY);
    if(0 <= Number(sticker.rotation.angle) && Number(sticker.rotation.angle)< 90){
        textBoxItem.angle1 = Number(angle1) + Number(sticker.rotation.angle);
    }
    else if(90 <= Number(sticker.rotation.angle) && Number(sticker.rotation.angle) < 180){
        textBoxItem.angle1 = Number(angle1) + Number(sticker.rotation.angle - 90);
    }
    else if(180 <= Number(sticker.rotation.angle) && Number(sticker.rotation.angle) < 270){
        textBoxItem.angle1 = Number(angle1) + Number(sticker.rotation.angle - 180);
    }
    else if(270 <= Number(sticker.rotation.angle) && Number(sticker.rotation.angle) < 360){
        textBoxItem.angle1 = Number(angle1) + Number(sticker.rotation.angle - 360);
    }
    else if(360 <= Number(sticker.rotation.angle) && Number(sticker.rotation.angle) < 450){
        textBoxItem.angle1 = Number(angle1) + Number(sticker.rotation.angle - 360);
    }
    isTextbox = true;
}
function textboxZoom2(e, item, ratio, callback) {
    //开关打开
    if (isTextbox == false) {
        return;
    }
    var nl = 0;
    var x = Math.abs(textBoxItem.left + nl - e.touches[0].pageX);
    var y = Math.abs(textBoxItem.top - e.touches[0].pageY);
    var z = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
    var _top1 = e.touches[0].pageY;
    var _left1 = e.touches[0].pageX;
    //计算移动后的左偏移量和顶部的偏移量
    nl = (parseInt(z - textBoxItem.distance)) / ratio;
    if(writingmodeInit(item.style.writingmode)){
        item.geometry.height = (Number(textBoxItem.nh) + Number(nl) + Number(5));
        item.style.size = Math.ceil(((Number(textBoxItem.nh) + Number(nl)) / textBoxItem.nh * textBoxItem._size));
        item.style.lineheight = item.style.size;
    }else{
        if ((Number(textBoxItem.nw) + Number(nl)) < 20) {
            isTextbox = false;
            return;
        }
        item.geometry.width = (Number(textBoxItem.nw) + Number(nl) + Number(5));
        item.geometry.x = (Number(textBoxItem._left) - Number(nl/2));
        item.style.size = Math.ceil(((Number(textBoxItem.nw) + Number(nl)) / textBoxItem.nw * textBoxItem._size));
        item.style.lineheight = item.style.size;
    }

    item.rotation.angle = getAngle(textBoxItem.left, textBoxItem.top, _left1, _top1) + textBoxItem.angle1;
    if(item.rotation.angle>360){
        item.rotation.angle = item.rotation.angle - 360;
    }
    item.rotation.angle = adsorbAngle(item.rotation.angle)
    callback(nl)
}

function browserVersions() {
    var u = navigator.userAgent, app = navigator.appVersion;
    var browser = {
        versions: function () {
            return {         //移动终端浏览器版本信息
                trident: u.indexOf('Trident') > -1, //IE内核
                presto: u.indexOf('Presto') > -1, //opera内核
                webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
                gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
                mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
                ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
                android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或uc浏览器
                iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
                iPad: u.indexOf('iPad') > -1, //是否iPad
                webApp: u.indexOf('Safari') == -1 //是否web应该程序，没有头部与底部
            };
        }(),
        language: (navigator.browserLanguage || navigator.language).toLowerCase()
    }

    var isWx = false;
    if (browser.versions.mobile) {//判断是否是移动设备打开。browser代码在下面
        var ua = navigator.userAgent.toLowerCase();//获取判断用的对象
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
            //在微信中打开
            // alert("在微信中打开")
            isWx = true;
        }else if(browser.versions.android){
            //是否在安卓浏览器打开
            // alert("是否在安卓浏览器打开")
            isWx = false;
        }
        if (ua.match(/WeiBo/i) == "weibo") {
            //在新浪微博客户端打开
        }
        if (ua.match(/QQ/i) == "qq") {
            //在QQ空间打开
        }
        if (browser.versions.ios) {
            //是否在IOS浏览器打开
            // alert("是否在IOS浏览器打开")
            isWx = false;
        }
    } else {
        //否则就是PC浏览器打开
    }
    // return isWx

    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    // alert("isAndroid: "+isAndroid + " isiOS: "+isiOS)
    // return true
    if(!isWx || isiOS){
        return false;
    } else{
        return true;
    }
}

//判断图片数量
function judgeQuantity(article, data, pictureType) {
    var retuenType = false;
    var picturePage = article.expectPageCount || 0;
    if(picturePage && picturePage>0){
        if(pictureType){
            picturePage = picturePage * 2;
        }
        var quantity=0;
        data.forEach(function (item) {
            quantity += Number(item.quantity);
        })
        if(quantity != picturePage){
            retuenType = picturePage;
        }
    }
    return retuenType
}
function judgeQuantity1(article, data, pictureType) {
    var retuenType = false;
    var picturePage = article.expectPageCount || 0;
    if(picturePage && picturePage>0){
        if(pictureType){
            picturePage = picturePage * 2;
        }
        var quantity=0;
        data.forEach(function (item) {
            quantity += Number(item.quantity);
        })
        if(quantity > picturePage){
            retuenType = picturePage;
        }
    }
    return retuenType
}

//智能检测document
function documentDetection(page) {
    var isPass = {
        pass: true,
        pageIndex: null,
        levelIndex: null,
        levelType:null
    };
    // angular.forEach(page, function (page, index) {
    //     if(isPass.pass){
    //         angular.forEach(page.levels.level, function (level, i) {
    //             if (level.imagebox&&level.imagebox.image&&level.imagebox.image.resource && isPass.pass) {
    //                 if(level.imagebox.bokehtype == 'None'){
    //                     level.imagebox.image.width = Number(level.imagebox.image.width);
    //                     level.imagebox.image.height = Number(level.imagebox.image.height);
    //                     level.imagebox.image.offsetx = Number(level.imagebox.image.offsetx);
    //                     level.imagebox.image.offsety = Number(level.imagebox.image.offsety);
    //                     if(level.imagebox.image.offsetx > 1 || level.imagebox.image.offsety > 1 || !level.imagebox.image.width || !level.imagebox.image.height || (level.imagebox.image.offsetx + level.imagebox.image.width)*level.imagebox.image.scale < level.imagebox.geometry.width || (level.imagebox.image.offsety + level.imagebox.image.height)*level.imagebox.image.scale < level.imagebox.geometry.height){
    //                         isPass.pass = false;
    //                         isPass.pageIndex = index + 1;
    //                         isPass.levelIndex = i + 1;
    //                         isPass.levelType = 'imagebox';
    //                         console.log(isPass)
    //                         return false
    //                     }
    //                 }
    //             }
    //         })
    //     }
    // })
    // console.log(isPass)
    return isPass
}
function documentDetectionBoth(document) {
    var isPass = {
        pass: true,
        pageIndex: null,
        levelIndex: null,
        levelType:null,
        both: null
    };
    // angular.forEach(document, function (data, dataIndex) {
    //     if(isPass.pass){
    //         angular.forEach(data.page, function (page, index) {
    //             if(isPass.pass){
    //                 angular.forEach(page.levels.level, function (level, i) {
    //                     if (level.imagebox&&level.imagebox.image&&level.imagebox.image.resource && isPass.pass) {
    //                         if(level.imagebox.bokehtype == 'None'){
    //                             level.imagebox.image.width = Number(level.imagebox.image.width);
    //                             level.imagebox.image.height = Number(level.imagebox.image.height);
    //                             level.imagebox.image.offsetx = Number(level.imagebox.image.offsetx);
    //                             level.imagebox.image.offsety = Number(level.imagebox.image.offsety);
    //                             if(level.imagebox.image.offsetx > 1 || level.imagebox.image.offsety > 1 || !level.imagebox.image.width || !level.imagebox.image.height || (level.imagebox.image.offsetx + level.imagebox.image.width)*level.imagebox.image.scale < level.imagebox.geometry.width || (level.imagebox.image.offsety + level.imagebox.image.height)*level.imagebox.image.scale < level.imagebox.geometry.height){
    //                                 isPass.pass = false;
    //                                 isPass.pageIndex = dataIndex + 1;
    //                                 isPass.levelIndex = i + 1;
    //                                 isPass.levelType = 'imagebox';
    //                                 isPass.bothIndex = index;
    //                                 return false
    //                             }
    //                         }
    //                     }
    //                 })
    //             }
    //         })
    //     }
    // })
    return isPass
}
function documentTextDetection(page) {
    var isPass = {
        pass: true,
        pages:[],
    };
    for(var i=0; i<page.length; i++){
        if (!page[i] || !page[i].levels || !page[i].levels.level) {
            continue;
        }
        if (!page[i].levels.level.length) {
            continue;
        }
        var _page={
            valid: false,
            pageIndex: i + 1,
            texts:[],
            repetitions:[],
        }
        for(var j=0; j<page[i].levels.level.length; j++){
            var _level = page[i].levels.level[j];
            if(_level.textbox && _level.textbox.geometry && _level.textbox.success === false){
                _page.valid = true;
                isPass.isText = true;
                _page.texts.push(_level.textbox)
            }
            var _repetition = [];
            for (var key in _level){
                if(_level[key] && (key=='imagebox'||key=='code'||key=='imageart'||key=='textbox'||key=='textdocument')){
                    _level[key].levelType = key;
                    _repetition.push(_level[key])
                }
            }
            if(_repetition.length>1){
                _page.valid = true;
                isPass.isRepetition = true;
                _page.repetitions.push(_level);
            }
        }
        if(_page.valid){
            isPass.pass = false;
            isPass.pages.push(_page)
        }
    }
    return isPass
}
function documentTextDetection1(page) {
    var isPass = {
        pass: true,
        pages:[],
    };
    for(var i=0; i<page.length; i++){
        if(!page[i].levels.level){
            page[i].levels.level = [];
        }
        for(var j=0; j<page[i].levels.level.length; j++){
            var _level = page[i].levels.level[j];
            if(_level.textbox && !_level.textbox.success){
                isPass.pass = false;
                var _isExist = false;
                for (var c=0; c<isPass.pages.length; c++){
                    if(isPass.pages[c].pageIndex == i+1){
                        _isExist = true;
                        isPass.pages[c].texts.push(_level.textbox.text)
                        break
                    }
                }
                if(!_isExist){
                    isPass.pages.push({
                        pageIndex: i + 1,
                        texts:[_level.textbox.text]
                    })
                }
            }
        }
    }
    return isPass
}

function isMobile(){
    var ua = window.navigator.userAgent;
    var isWeChat = ua.match(/MicroMessenger/i);
    if(isWeChat){
       // 检测是否为 PC 微信小程序环境（PC 小程序特有标识）
       if (/MiniProgramEnv\/Windows|MiniProgramEnv\/Mac/i.test(ua)) {
            return true; // 这就是PC 小程序 WebView
        }
        // PC微信内置浏览器（打开普通链接）
        if (/WindowsWechat|MacWechat/i.test(ua)) {
            return false;
        }
        // 手机端微信
        return true;
    }
    if(ua.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone|HarmonyOS|Harmony)/i)) {
        return true;
    }else{
        return false;
    }
}
// mm换算成px
function MmTurnPx(mm) {
    return (mm / 25.4 * this.js_getDPI()).toFixed(2) - 0;
};
// px换算成mm
function PxTurnMm(px) {
    return (px / this.js_getDPI() * 25.4).toFixed(2) - 0;
};
//px换算成英寸
function PxTurnIn(item) {
    return (item / this.js_getDPI()).toFixed(2) - 0;
};
//英寸换算成px
function InTurnPx(item) {
    return (item * this.js_getDPI()).toFixed(2) - 0;
};
//英寸换算成mm
function InTurnMm(item) {
    return unitTransformPx(InTurnPx(item));
};
//mm换算成英寸
function MmTurnIn(item) {
    return PxTurnIn(unitTransform(item));
};

//客户主机信息
function hostInfo() {
    var _arr=[
        {
            describe: '操作系统信息',
            name: getOsInfo().name,
            version: getOsInfo().version,
        },
        {
            describe: '浏览器信息',
            browserkernel: getExplore(),
            name:getExploreName()
        },
        {
            describe: '日期',
            time:new Date()
        }
    ];
    // var md = new MobileDetect(window.navigator.userAgent);
    // _arr.push({
    //     describe: '设备信息',
    //     mobile: md.mobile(),
    //     os: md.os(),
    //     userAgent: md.userAgent(),
    //     rests: md
    // });
    return JSON.stringify(_arr);
}
// 获取操作系统信息
function getOsInfo() {
    var userAgent = navigator.userAgent.toLowerCase();
    var name = 'Unknown';
    var version = 'Unknown';
    if (userAgent.indexOf('win') > -1) {
        name = 'Windows';
        if (userAgent.indexOf('windows nt 5.0') > -1) {
            version = 'Windows 2000';
        } else if (userAgent.indexOf('windows nt 5.1') > -1 || userAgent.indexOf('windows nt 5.2') > -1) {
            version = 'Windows XP';
        } else if (userAgent.indexOf('windows nt 6.0') > -1) {
            version = 'Windows Vista';
        } else if (userAgent.indexOf('windows nt 6.1') > -1 || userAgent.indexOf('windows 7') > -1) {
            version = 'Windows 7';
        } else if (userAgent.indexOf('windows nt 6.2') > -1 || userAgent.indexOf('windows 8') > -1) {
            version = 'Windows 8';
        } else if (userAgent.indexOf('windows nt 6.3') > -1) {
            version = 'Windows 8.1';
        } else if (userAgent.indexOf('windows nt 6.2') > -1 || userAgent.indexOf('windows nt 10.0') > -1) {
            version = 'Windows 10';
        } else {
            version = 'Unknown';
        }
    } else if (userAgent.indexOf('iphone') > -1) {
        name = 'Iphone';
    } else if (userAgent.indexOf('mac') > -1) {
        name = 'Mac';
    } else if (userAgent.indexOf('x11') > -1 || userAgent.indexOf('unix') > -1 || userAgent.indexOf('sunname') > -1 || userAgent.indexOf('bsd') > -1) {
        name = 'Unix';
    } else if (userAgent.indexOf('linux') > -1) {
        if (userAgent.indexOf('android') > -1) {
            name = 'Android';
        } else {
            name = 'Linux';
        }
    } else {
        name = 'Unknown';
    }
    return { name: name, version: version };
}
function getExplore(){
    var Sys = {};
    var ua = navigator.userAgent.toLowerCase();
    var s;
    (s = ua.match(/rv:([\d.]+)\) like gecko/)) ? Sys.ie = s[1] :
        (s = ua.match(/msie ([\d\.]+)/)) ? Sys.ie = s[1] :
            (s = ua.match(/edge\/([\d\.]+)/)) ? Sys.edge = s[1] :
                (s = ua.match(/firefox\/([\d\.]+)/)) ? Sys.firefox = s[1] :
                    (s = ua.match(/(?:opera|opr).([\d\.]+)/)) ? Sys.opera = s[1] :
                        (s = ua.match(/chrome\/([\d\.]+)/)) ? Sys.chrome = s[1] :
                            (s = ua.match(/version\/([\d\.]+).*safari/)) ? Sys.safari = s[1] : 0;
    // 根据关系进行判断
    if (Sys.ie) return ('IE: ' + Sys.ie);
    if (Sys.edge) return ('EDGE: ' + Sys.edge);
    if (Sys.firefox) return ('Firefox: ' + Sys.firefox);
    if (Sys.chrome) return ('Chrome: ' + Sys.chrome);
    if (Sys.opera) return ('Opera: ' + Sys.opera);
    if (Sys.safari) return ('Safari: ' + Sys.safari);
    return 'Unkonwn';
}
function getExploreName(){
    var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
    console.log(userAgent)
    var isOpera = userAgent.indexOf("Opera") > -1
        || userAgent.indexOf("OPR") > -1; //判断是否Opera浏览器

    var isQQ = userAgent.indexOf("QQBrowser") > -1; //判断是否QQBrowser浏览器

    var isUC = userAgent.indexOf("UBrowser") > -1; //判断是否UC浏览器

    var isIE = userAgent.indexOf("compatible") > -1
        && userAgent.indexOf("MSIE") > -1; //判断是否IE7~IE10浏览器

    var isIE11 = userAgent.indexOf("compatible") === -1
        && userAgent.indexOf("Trident") > -1; //判断是否IE11浏览器

    var isEdge = userAgent.indexOf("Edge") > -1; //判断是否IE的Edge浏览器

    var isFF = userAgent.indexOf("Firefox") > -1; //判断是否Firefox浏览器

    var isSafari = userAgent.indexOf("Safari") > -1
        && userAgent.indexOf("Chrome") === -1; //判断是否Safari浏览器

    var isChrome = userAgent.indexOf("Chrome") > -1
        && (userAgent.indexOf("; Win") > -1 || userAgent.indexOf("Macintosh;") > -1)
        && userAgent.indexOf("Safari") > -1; //判断Chrome浏览器

    var is360 = userAgent.indexOf("Chrome") > -1
        && userAgent.indexOf("; WOW") > -1
        && userAgent.indexOf("Safari") > -1; //判断360浏览器


    if (isIE) {
        var reIE = /MSIE (\d+)\.\d+;/;
        // match() 返回一个数组。数组第一项是匹配到的所有文本；数组第二项是正则中小括号匹配到的文本
        var matchReg = userAgent.match(reIE)
        var fIEVersion = matchReg[1];
        if (fIEVersion == 7) {
            return "IE7及其以下";
        } else if (fIEVersion == 8) {
            return "IE8";
        } else if (fIEVersion == 9) {
            return "IE9";
        } else if (fIEVersion == 10) {
            return "IE10";
        } else {
            return "0";
        }//IE版本过低
        return "IE";
    }
    if (isUC) {
        return "UC";
    }
    if (isQQ) {
        return "QQBrowser";
    }
    if (isIE11) {
        return "IE11";
    }
    if (isOpera) {
        return "Opera";
    }
    if (isEdge) {
        return "Edge";
    }
    if (isFF) {
        return "Firefox";
    }
    if (isSafari) {
        return "Safari";
    }
    if (isChrome) {
        return "Chrome";
    }
    if (is360) {
        return "360";
    }
    return "unknown";
}

//像素不足
var _identifiers = [];
function pxInsufficient(item, imgSize, dpi) {
    if(item.image.resource && item.image.resource.identifier){
        if(item.image.imageInfo){
            var imageInfo = item.image.imageInfo;
            imageInfo = orientationInit(imageInfo)
            item.lowSize=false;
            if(imageInfo.size/1024 < imgSize){
                item.lowSize = true;
                return item.lowSize;
            }
            if(item.image.angle == 90 || item.image.angle == 270){
                var _imageInfo = angular.copy(imageInfo);
                imageInfo.width = _imageInfo.height;
                imageInfo.height = _imageInfo.width;
            }
            var scale = item.image.scale || 1;
            var _dpiW = imageInfo.width*25.4/PxTurnMm(item.geometry.width) / scale;
            var _dpiH = imageInfo.height*25.4/PxTurnMm(item.geometry.height) / scale;
            var _dpi = _dpiW < _dpiH ? _dpiW : _dpiH;
            if (_dpi < dpi) {
                item.lowSize = true;
            } else {
                item.lowSize = false;
            }
            return item.lowSize;
        }else{
            if(_identifiers.indexOf(item.image.resource.identifier) == -1){
                _identifiers.push(item.image.resource.identifier)
                $.ajax({
                    type: "GET",
                    url: item.image.resource.identifier + "?imageInfo",
                    success: function (data1) {
                        item.image.imageInfo = data1;
                        _identifiers = [];
                        pxInsufficient(item, imgSize, dpi)
                    }
                })
            }
        }
    }
}

//检查每一页像素是否不足
function pageWarnExamine(pages, imgSize, imgDpi) {
    var warnIcon = false;
    pages.forEach(function (page) {
        if(page && page.levels && page.levels.level){
            page.levels.level.forEach(function (_level) {
                (function (level) {
                    if(level.imagebox && level.imagebox.image && level.imagebox.image.resource && pxInsufficient(level.imagebox,imgSize, imgDpi)){
                        warnIcon = true;
                    }
                })(_level)
            })
        }
    })
    return warnIcon
}
function activeImageDpi(item){
    var scale = item.image.scale || 1;
    var imageInfo = item.image.imageInfo;
    imageInfo = orientationInit(imageInfo);
    if(item.image.angle == 90 || item.image.angle == 270){
        var _imageInfo = angular.copy(imageInfo);
        imageInfo.width = _imageInfo.height;
        imageInfo.height = _imageInfo.width;
    }
    var _dpiW = imageInfo.width*25.4/PxTurnMm(item.geometry.width) / scale;
    var _dpiH = imageInfo.height*25.4/PxTurnMm(item.geometry.height) / scale;
    var _dpi = _dpiW < _dpiH ? _dpiW : _dpiH;
    return _dpi;
}

//生成缩略图
function dataURLtoBlob(dataurl) {
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], {type: mime});
}

//imagebox蒙版
function imageboxResourceCanvas($scope, item, callback) {
    var image = angular.copy(item);
    if(image.image && image.image.resource && image.image.resource.identifier){
        var angle = angular.copy(image.image.angle);
        if(image.flip){
            angle += 180
            if(angle>360){
                angle = angle - 360;
            }
        }
        image.imgUrl = image.image.resource.identifier + '?imageMogr2/exifModify/eyJPcmllbnRhdGlvbiI6IjEifQ==/rotate/' + angle+'/thumbnail/200x200>';
    }
    var imagecanvas = document.createElement('canvas');
    var imagecontext = imagecanvas.getContext('2d');
    var newImg = document.createElement('img');
    newImg.crossOrigin = "Anonymous";
    newImg.src = image.imgUrl || 'content/images/mask_souce.png';
    newImg.onload = function () {
        newImg.onload = null;
        var _image = getImageSource(newImg, image, image.image.resource.identifier);
        var scaleW = _image.width / newImg.width;
        var scaleH = _image.height / newImg.height;
        var masks = document.createElement('img');
        var maskUrl = 'content/images/mask_souce.png';
        if (image.mask && image.mask.resource && image.mask.resource.identifier) {
            maskUrl = image.mask.resource.identifier + '?imageMogr2/exifModify/eyJPcmllbnRhdGlvbiI6IjEifQ==/thumbnail/200x200>'
        }
        image.maskUrl = maskUrl;
        masks.src = maskUrl;
        masks.crossOrigin = "anonymous";
        masks.onload = function () {
            masks.onload = null;
            masks.width = image.geometry.width;
            masks.height = image.geometry.height;
            imagecanvas.width = masks.width;
            imagecanvas.height = masks.height;
            imagecontext.drawImage(masks, 0, 0, masks.width, masks.height);
            imagecontext.globalCompositeOperation = 'source-in';

            imagecontext.scale(scaleW, scaleH);
            imagecontext.scale(image.image.scale, image.image.scale);
            var offsetY = image.image.offsety;
            if (item.flip && item.bokehtype == 'None') {
                if (newImg.width / newImg.height < image.geometry.width / image.geometry.height) {
                    // var deltaY = (newImg.width * image.geometry.height / image.geometry.width - newImg.height) * scaleH - newImg.height * scaleH * (image.image.scale - 1) / 2;
                    var deltaY = (newImg.width / image.image.scale * image.geometry.height / image.geometry.width - newImg.height) * scaleH;
                    offsetY = deltaY - offsetY;
                } else if (image.image.scale >= 1) {
                    var deltaY = (1 - image.image.scale) * newImg.height * scaleH / image.image.scale;
                    offsetY = deltaY - offsetY;
                }
            }
            imagecontext.drawImage(newImg, image.image.offsetx / scaleW, offsetY / scaleH);
            var pic = imagecanvas.toDataURL();
            image.bgImg = dataURLtoBlob1(pic);
            item.bgImg = dataURLtoBlob1(pic);
            console.log(item.bgImg)
            if(callback){
                callback(item.bgImg)
            }
            $scope.$apply();
        };
        masks.src = maskUrl;
    };
    newImg.src = image.imgUrl;
}
function dataURLtoBlob1(dataurl) {
    var arr = dataurl.split(','),
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    var createObjectURL = function (blob) {
        return window[window.webkitURL ? 'webkitURL' : 'URL']['createObjectURL'](blob);
    };
    var fileURL = URL.createObjectURL(new Blob([u8arr], {type: 'image/*'}));
    return fileURL;
}
function getImageSource(newImg, imagebox, s1, currentPage) {
    var width = newImg.width;
    var height = newImg.height;

    var _w = imagebox.geometry.width;
    var _h = imagebox.geometry.height;
    var bgImgR = width / height;
    var bgImgR1 = _w / _h;
    var _image = {
        resource: {
            provider: 'qiniu',
            identifier: s1,
        },
        angle: 0,
        scale: 1
    }
    // if (bgImgR >= bgImgR1) {
    //     _image.adaptation = 'Height';
    //     _image.height = _h;
    //     _image.width = _h / height * width;
    // } else {
    //     _image.adaptation = 'Width';
    //     _image.width = _w;
    //     _image.height = _w / width * height;
    // }

    if (imagebox.bokehtype == 'None') {
        if (bgImgR >= bgImgR1) {
            _image.adaptation = 'Height';
            _image.height = _h;
            _image.width = _h / height * width;
        } else {
            _image.adaptation = 'Width';
            _image.width = _w;
            _image.height = _w / width * height;
        }
    } else {
        if (bgImgR >= bgImgR1) {
            _image.adaptation = 'Height';
            _image.width = _w;
            _image.height = _w / width * height;
            imagebox.image.offsetx= 0;
            imagebox.image.offsety= (_h - _w / width * height) / 2;
        } else {
            _image.adaptation = 'Width';
            _image.height = _h;
            _image.width = _h / height * width;
            imagebox.image.offsetx= (_w - _h / height * width) / 2;
            imagebox.image.offsety= 0;
        }
    }


    _image.imgWidth = width;
    _image.imgHeight = height;

    return _image
}

//鼠标样式
function cursorInfo(angle, source, boolean) {
    var _cursor = '';
    if(angle>0 && !boolean){
        angle = 360 - angle;
    }
    if(source == 'left'){
        if(337<=angle || angle<22){_cursor = 'nw-resize';}
        if(22<=angle && angle<67){_cursor = 'n-resize';}
        if(67<=angle && angle<112){_cursor = 'ne-resize';}
        if(112<=angle && angle<157){_cursor = 'e-resize';}
        if(157<=angle && angle<202){_cursor = 'se-resize';}
        if(202<=angle && angle<247){_cursor = 's-resize';}
        if(247<=angle && angle<292){_cursor = 'sw-resize';}
        if(292<=angle && angle<337){_cursor = 'w-resize';}
    }
    if(source == 'top'){
        if(337<=angle || angle<22){_cursor = 'ne-resize';}
        if(22<=angle && angle<67){_cursor = 'e-resize';}
        if(67<=angle && angle<112){_cursor = 'se-resize';}
        if(112<=angle && angle<157){_cursor = 's-resize';}
        if(157<=angle && angle<202){_cursor = 'sw-resize';}
        if(202<=angle && angle<247){_cursor = 'w-resize';}
        if(247<=angle && angle<292){_cursor = 'nw-resize';}
        if(292<=angle && angle<337){_cursor = 'n-resize';}
    }
    if (source == 'right') {
        if(337<=angle || angle<22){_cursor = 'se-resize';}
        if(22<=angle && angle<67){_cursor = 's-resize';}
        if(67<=angle && angle<112){_cursor = 'sw-resize';}
        if(112<=angle && angle<157){_cursor = 'w-resize';}
        if(157<=angle && angle<202){_cursor = 'nw-resize';}
        if(202<=angle && angle<247){_cursor = 'n-resize';}
        if(247<=angle && angle<292){_cursor = 'ne-resize';}
        if(292<=angle && angle<337){_cursor = 'e-resize';}
    }
    if (source == 'bottom'){
        if(337<=angle || angle<22){_cursor = 'sw-resize';}
        if(22<=angle && angle<67){_cursor = 'w-resize';}
        if(67<=angle && angle<112){_cursor = 'nw-resize';}
        if(112<=angle && angle<157){_cursor = 'n-resize';}
        if(157<=angle && angle<202){_cursor = 'ne-resize';}
        if(202<=angle && angle<247){_cursor = 'e-resize';}
        if(247<=angle && angle<292){_cursor = 'se-resize';}
        if(292<=angle && angle<337){_cursor = 's-resize';}
    }


    if(source == 'left1'){
        if(337<=angle || angle<22){_cursor = 'w-resize';}
        if(22<=angle && angle<67){_cursor = 'nw-resize';}
        if(67<=angle && angle<112){_cursor = 'n-resize';}
        if(112<=angle && angle<157){_cursor = 'ne-resize';}
        if(157<=angle && angle<202){_cursor = 'e-resize';}
        if(202<=angle && angle<247){_cursor = 'se-resize';}
        if(247<=angle && angle<292){_cursor = 's-resize';}
        if(292<=angle && angle<337){_cursor = 'sw-resize';}
    }

    if(source == 'top1'){
        if(337<=angle || angle<22){_cursor = 'n-resize';}
        if(22<=angle && angle<67){_cursor = 'ne-resize';}
        if(67<=angle && angle<112){_cursor = 'e-resize';}
        if(112<=angle && angle<157){_cursor = 'se-resize';}
        if(157<=angle && angle<202){_cursor = 's-resize';}
        if(202<=angle && angle<247){_cursor = 'sw-resize';}
        if(247<=angle && angle<292){_cursor = 'w-resize';}
        if(292<=angle && angle<337){_cursor = 'nw-resize';}
    }

    if (source == 'right1') {
        if(337<=angle || angle<22){_cursor = 'e-resize';}
        if(22<=angle && angle<67){_cursor = 'se-resize';}
        if(67<=angle && angle<112){_cursor = 's-resize';}
        if(112<=angle && angle<157){_cursor = 'sw-resize';}
        if(157<=angle && angle<202){_cursor = 'w-resize';}
        if(202<=angle && angle<247){_cursor = 'nw-resize';}
        if(247<=angle && angle<292){_cursor = 'n-resize';}
        if(292<=angle && angle<337){_cursor = 'ne-resize';}
    }

    if (source == 'bottom1') {
        if(337<=angle || angle<22){_cursor = 's-resize';}
        if(22<=angle && angle<67){_cursor = 'sw-resize';}
        if(67<=angle && angle<112){_cursor = 'w-resize';}
        if(112<=angle && angle<157){_cursor = 'nw-resize';}
        if(157<=angle && angle<202){_cursor = 'n-resize';}
        if(202<=angle && angle<247){_cursor = 'ne-resize';}
        if(247<=angle && angle<292){_cursor = 'e-resize';}
        if(292<=angle && angle<337){_cursor = 'se-resize';}
    }
    return _cursor
}
//page排序
function pageSeq(page, callback) {
    page.forEach(function (item, index) {
        item.seq = index + 1;
    })
    callback(page)
}

//编辑器获取消息列表
function getMessageCustom(vm, DateUtils, MessageNotification, callback) {
    MessageNotification.getAllByCondition({
            items:[
                {key:"pageType", op : "=", value:"Edit"},
                {key:"storeId", op : "=", value:vm.storeId},
                {key:"available", op : "=", value:"true"},
                {key:"validate", op : ">=", value: DateUtils.convertLocalDateToServer(new Date())}]
        }, function (res) {
            callback(res)
        }
    )
}
function dropShadow(imagebox,width,height){
    if(imagebox.shadow.x == 0 && imagebox.shadow.y == 0 && imagebox.shadow.blur == 0){
        return ''
    }
    var blur = 0;
    var x = 0;
    var y = 0;
    if (width>=height) {
        blur = width * imagebox.shadow.blur * 0.005
    }else{
        blur = height * imagebox.shadow.blur * 0.005
    }
    x = width * imagebox.shadow.x * 0.01;
    y = height * imagebox.shadow.y * 0.01;
    return 'drop-shadow('+x+'px '+y+'px '+blur+'px '+imagebox.shadow.color+')'
}

//匹配最接近的图片框
function imageboxAdapt(levels, imgs) {
    var imageboxRatios = [];
    angular.forEach(levels, function (level, i) {
        if (level.imagebox && level.imagebox.geometry) {
            imageboxRatios.push(level.imagebox.geometry.width/level.imagebox.geometry.height);
        }
    });
    var differenceValues = [];
    imageboxRatios.forEach(function (item, i) {
        imgs.forEach(function (img, i1) {
            differenceValues.push({
                value: differenceValue(img.imgRatio, item),
                imageboxIndex:i,
                img:img,
                imgIndex: i1
            })
        })
    })
    differenceValues.sort(function(a,b){return a.value-b.value});
    var differenceValues1 = [];
    differenceValues.forEach(function (item) {
        if(differenceValues1.length == 0){
            item.img.imageboxIndex = item.imageboxIndex;
            item.img.imgIndex = item.imgIndex;
            item.img.value = item.value;
            differenceValues1.push(item.img)
        }else{
            var isExist = true;
            for(var i=0; i<differenceValues1.length; i++){
                if(differenceValues1[i].imageboxIndex == item.imageboxIndex || differenceValues1[i].imgIndex == item.imgIndex){
                    isExist = false;
                    break;
                }
            }
            if(isExist){
                item.img.imageboxIndex = item.imageboxIndex;
                item.img.imgIndex = item.imgIndex;
                item.img.value = item.value;
                differenceValues1.push(item.img)
            }
        }
    })
    if(differenceValues1.length>1){
        differenceValues1.sort(function(a,b){ return a.imageboxIndex-b.imageboxIndex});
    }
    return differenceValues1;
}
function differenceValue(a, b) {
    var _c = 0;
    if(a>b){_c=a-b;}else{_c=b-a;};
    return _c
}
//随机布局
function randomPlacement(Convert,Algorithm,pages,placementList,photoSelectAll,_gallaryPicCounts,callback) {
    var _pages = pages;
    var _page = [];
    var _candidates = [];
    var images = [];
    for(var i=_gallaryPicCounts; i<photoSelectAll.length; i++){
        images.push({
            id: photoSelectAll[i].id,
            width: photoSelectAll[i].width,
            height: photoSelectAll[i].height,
        })
    }
    console.log(placementList)
    placementList.forEach(function (placemen) {
        placemen.data.forEach(function (_data) {
            _data.uuid = getUuid();
            var holes = [];
            for(var i=0; i<_data.quantity; i++){
                holes.push({
                    id: _data.uuid,
                    width: 100,
                    height: 100,
                })
            }
            _candidates.push({
                "name": _data.uuid,
                "holes": holes,
                "numberOfHoles":_data.quantity,
                "replaceable": true
            })
        })
    })
    pages.forEach(function (page){
        _page.push({
            "name":  placementList[0].uuid,
            "holes": placementList[0].holes,
            "numberOfHoles": placementList[0].quantity,
            "replaceable": true
        });
    });
    Algorithm.pageSelectV2({
        pages: _page,
        candidates: _candidates,
        numberOfExpected: images.length,
        images:images
    },function (res){
        if(res.numberOfExpected != res.numberOfHoles){
            callback(_pages, true)
            return
        }
        var _uuids = [];
        res.pages.forEach(function (page) {
            _uuids.push(page.name)
        })
        var _pageIndex = 0;
        _pages.forEach(function (page,index) {
            (function (page1,index1) {
                getPlacement(Convert,page1, _uuids[index1], placementList, function () {
                    _pageIndex++;
                    if(_pageIndex == _pages.length){
                        callback(_pages)
                    }
                })
            })(page,index)
        })
    })
}
function getPlacement(Convert,page, uuid, placementList, callback) {
    var _placement = "";
    for(var i=0; i<placementList.length; i++){
        placementList[i].data.forEach(function (_data) {
            if(uuid == _data.uuid){
                _placement = _data.resource.identifier;
            }
        })
    }
    if(!_placement){
        callback(page)
        return
    }
    Convert.xmlToPicLayoutDocument({url: _placement}, function (res) {
        var mediabox = {
            height: transitionPx(res.mediabox.height),
            width: transitionPx(res.mediabox.width),
            x: transitionPx(res.mediabox.x),
            y: transitionPx(res.mediabox.y)
        };
        var _ratio = 1;
        if(page.mediabox.height / mediabox.height >= page.mediabox.width / mediabox.width ){
            _ratio = page.mediabox.width / mediabox.width;
        }else {
            _ratio = page.mediabox.height / mediabox.height;
        }
        if(!page.levels.level){
            page.levels.level=[];
        }
        for(var i=page.levels.level.length-1; i>=0; i--){
            if(page.levels.level[i].imagebox){
                page.levels.level.splice(i,1)
            }
        }
        res.levels.level.forEach(function (level) {
            if(level.imagebox){
                level.imagebox.geometry={
                    width: transitionPx(level.imagebox.geometry.width*_ratio),
                    height: transitionPx(level.imagebox.geometry.height*_ratio),
                    x: transitionPx(level.imagebox.geometry.x*_ratio),
                    y: transitionPx(level.imagebox.geometry.y*_ratio),
                }
                level.seq = page.levels.level.length-1;
                page.levels.level.push(level)
            }
        })
        callback(page)
    })
}

function getUuid(){
    var d = new Date().getTime();
    var uid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == 'x' ? r : (r & 0x7 | 0x8)).toString(16);
    });
    return uid;
}

//裁切区域
function pageTrimbox(page, text) {
    if(page && !page.scene && page.custom && !page._trimboxed && !page.notTrimbox){
        page._trimboxed = true;
        page.mediabox1 = angular.copy(page.mediabox);
        page.custom.width = page.trimbox.width;
        page.custom.height = page.trimbox.height;
        page.mediabox.width = page.trimbox.width;
        page.mediabox.height = page.trimbox.height;
        if (page.background && page.background.resource &&page.background.resource.identifier) {
            page.background.offsetx = page.background.offsetx-page.trimbox.x;
            page.background.offsety = page.background.offsety-page.trimbox.y;
        }
        if (page.barcode) {
            page.barcode.geometry.x = page.barcode.geometry.x-page.trimbox.x;
            page.barcode.geometry.y = page.barcode.geometry.y-page.trimbox.y;
        }
        if (page.qrcode) {
            page.qrcode.geometry.x = page.qrcode.geometry.x-page.trimbox.x;
            page.qrcode.geometry.y = page.qrcode.geometry.y-page.trimbox.y;
        }
        angular.forEach(page.levels.level, function (level, i) {
            if (level.imageart) {
                level.imageart.geometry.x = level.imageart.geometry.x-page.trimbox.x;
                level.imageart.geometry.y = level.imageart.geometry.y-page.trimbox.y;
            }
            if(level.imagebox){
                level.imagebox.geometry.x = level.imagebox.geometry.x-page.trimbox.x;
                level.imagebox.geometry.y = level.imagebox.geometry.y-page.trimbox.y;
            }
            if (level.textbox) {
                if (!(level.textbox.text == '' || level.textbox.text == null || level.textbox.text == text || level.textbox.text == '双击输入文字' || level.textbox.text == '请输入文字') && (level.textbox.geometry.width != 0 && level.textbox.geometry.height != 0)) {
                    level.textbox.geometry.x = level.textbox.geometry.x-page.trimbox.x;
                    level.textbox.geometry.y = level.textbox.geometry.y-page.trimbox.y;
                }else{
                    level.textbox = null;
                }
            }
            if (level.textdocument) {
                level.textdocument.geometry.x = level.textdocument.geometry.x-page.trimbox.x;
                level.textdocument.geometry.y = level.textdocument.geometry.y-page.trimbox.y;
            }
            if (level.code) {
                level.code.geometry.x = level.code.geometry.x-page.trimbox.x;
                level.code.geometry.y = level.code.geometry.y-page.trimbox.y;
            }
            if (level.calTitleBox) {
                level.calTitleBox.geometry.x = level.calTitleBox.geometry.x-page.trimbox.x;
                level.calTitleBox.geometry.y = level.calTitleBox.geometry.y-page.trimbox.y;
            }
            if (level.calMonthBox) {
                level.calMonthBox.geometry.x = level.calMonthBox.geometry.x-page.trimbox.x;
                level.calMonthBox.geometry.y = level.calMonthBox.geometry.y-page.trimbox.y;
            }
        })
    }
}

//判断手机型号
function isIPhone6() {
    var events = navigator.userAgent;
    var _isIPhone6 = false;
    if(events.indexOf('iPhone')>-1){
        //根据尺寸进行判断 苹果的型号
        if(screen.height == 812 && screen.width == 375){
        }else if(screen.height == 736 && screen.width == 414){
            _isIPhone6 = true;
        }else if(screen.height == 667 && screen.width == 375){
            _isIPhone6 = true;
        }else if(screen.height == 568 && screen.width == 320){
            _isIPhone6 = true;
        }
    }
    return _isIPhone6
}

//智能布局
function smartLayout(pages, Algorithm, photoSelectAll, source, callback){
    pages.page.forEach(function (page){
        page.uuid1 = getUuid();
    });
    var _pages = angular.copy(pages);
    var _page = [];
    var _candidates = [];
    var images = [];
    var _photoSelectAll = [];
    photoSelectAll.forEach(function (image){
        images.push({
            id: image.id,
            width: image.width,
            height: image.height,
        })
    })
    pages.page.forEach(function (page){
        page.numberOfHoles = 0;
        page.holes = [];
        if(page.levels.level){
            page.levels.level.forEach(function (level){
                if(level.imagebox && level.imagebox.geometry){
                    if(!source || (source == 'photoAlbum' && (!level.imagebox.image || !level.imagebox.image.resource || !level.imagebox.image.resource.identifier))){
                        page.numberOfHoles++;
                        page.holes.push({
                            id: getUuid(),
                            width: level.imagebox.geometry.width,
                            height: level.imagebox.geometry.height,
                        });
                    }
                }
            })
        }
        if(!page.backup){
            _page.push({
                "name": page.uuid1,
                "holes": page.holes,
                "numberOfHoles": page.numberOfHoles,
                "replaceable": !page.unreplace
            });
        }else{
            _candidates.push({
                "name": page.uuid1,
                "holes": page.holes,
                "numberOfHoles": page.numberOfHoles,
                "replaceable": !page.unreplace
            })
        }
    });
    Algorithm.pageSelectV2({
        pages: _page,
        candidates: _candidates,
        numberOfExpected: photoSelectAll.length,
        images:images
    },function (res){
        var _page1=[];
        if(res.pages && res.pages.length>0){
            for(var i=0; i<res.pages.length; i++){
                for(var j=0; j<_pages.page.length; j++){
                    if(res.pages[i].name == _pages.page[j].uuid1){
                        var _pageData = angular.copy(_pages.page[j]);
                        _pageData.unreplace = !res.pages[i].replaceable;
                        _pageData.backup = false;
                        _page1.push(_pageData);
                        break;
                    }
                }
            }
        }
        if(res.unusedPages && res.unusedPages.length>0){
            for(var i=0; i<res.unusedPages.length; i++){
                for(var j=0; j<_pages.page.length; j++){
                    if(res.unusedPages[i].name == _pages.page[j].uuid1){
                        var _pageData1 = angular.copy(_pages.page[j]);
                        _pageData1.unreplace = !res.unusedPages[i].replaceable;
                        _pageData1.backup = true;
                        _page1.push(_pageData1);
                        break;
                    }
                }
            }
        }
        res.images.forEach(function (imageId){
            for (var i=0; i<photoSelectAll.length; i++){
                if(photoSelectAll[i].id == imageId){
                    _photoSelectAll.push(photoSelectAll[i]);
                }
            }
        })
        callback(_page1, _photoSelectAll)
    })
}
function smartLayout2(pages,backupPages, Algorithm, photoSelectAll, source, callback){
    var _pages = angular.copy(pages);
    var _backupPages = [];
    backupPages.forEach(function (page) {
        getPageType(page)
        if (_pages && _pages.page && !_pages.page.some(function(obj){obj.uuid === page.uuid})) {
            _backupPages.push(angular.copy(page));
        }
    });
    var _pages1 = [];
    _pages.page.forEach(function (page){
        getPageType(page)
        page.uuid1 = getUuid();
        page.backup = false;
        _pages1.push(page)
    });
    _backupPages.forEach(function (page){
        page.uuid1 = getUuid();
        page.backup = true;
        _pages1.push(page)
    });
    var _page = [];
    var _candidates = [];
    var images = [];
    var _photoSelectAll = [];
    photoSelectAll.forEach(function (image){
        images.push({
            id: image.id,
            width: image.width,
            height: image.height,
        })
    })
    _pages1.forEach(function (page){
        page.numberOfHoles = 0;
        page.holes = [];
        if(page.levels.level){
            page.levels.level.forEach(function (level){
                if(level.imagebox && level.imagebox.geometry){
                    if(!level.imagebox.image || !level.imagebox.image.resource || !level.imagebox.image.resource.identifier){
                        page.numberOfHoles++;
                        page.holes.push({
                            id: getUuid(),
                            width: level.imagebox.geometry.width,
                            height: level.imagebox.geometry.height,
                        });
                    }
                }
            })
        }
        if(!page.backup){
            _page.push({
                "name": page.uuid1,
                "holes": page.holes,
                "numberOfHoles": page.numberOfHoles,
                "replaceable": page.config.partid == 'P' ? !page.unreplace : false,
                "spread":page.spread
            });
        }else{
            if(page.config.partid == 'P'){
                _candidates.push({
                    "name": page.uuid1,
                    "holes": page.holes,
                    "numberOfHoles": page.numberOfHoles,
                    "replaceable": page.config.partid == 'P' ? !page.unreplace : false,
                    "spread":page.spread
                })
            }
        }
    });
    Algorithm.pageSelectV2({
        pages: _page,
        candidates: _candidates,
        numberOfExpected: photoSelectAll.length,
        images:images
    },function (res){
        var _page1=[];
        var _backupPages1=[];
        if(res.pages && res.pages.length>0){
            for(var i=0; i<res.pages.length; i++){
                for(var j=0; j<_pages1.length; j++){
                    if(res.pages[i].name == _pages1[j].uuid1){
                        var _pageData = angular.copy(_pages1[j]);
                        _pageData.unreplace = !res.pages[i].replaceable;
                        _pageData.backup = false;
                        _page1.push(_pageData);
                        break;
                    }
                }
            }
        }
        if(res.unusedPages && res.unusedPages.length>0){
            for(var i=0; i<res.unusedPages.length; i++){
                for(var j=0; j<_pages1.length; j++){
                    if(res.unusedPages[i].name == _pages1[j].uuid1){
                        var _pageData1 = angular.copy(_pages1[j]);
                        _pageData1.unreplace = !res.unusedPages[i].replaceable;
                        _pageData1.backup = true;
                        _backupPages1.push(_pageData1);
                        break;
                    }
                }
            }
        }
        res.images.forEach(function (imageId){
            for (var i=0; i<photoSelectAll.length; i++){
                if(photoSelectAll[i].id == imageId){
                    _photoSelectAll.push(photoSelectAll[i]);
                }
            }
        })
        callback(_page1,_backupPages1, _photoSelectAll)
    })
}
function getUuid(){
    var d = new Date().getTime();
    var uid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == 'x' ? r : (r & 0x7 | 0x8)).toString(16);
    });
    return uid;
}

//微信阻止字体放大
function handleFontSizeInit() {
    if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") {
        handleFontSize();
    } else {
        if (document.addEventListener) {
            document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);
        } else if (document.attachEvent) {
            document.attachEvent("WeixinJSBridgeReady", handleFontSize);
            document.attachEvent("onWeixinJSBridgeReady", handleFontSize);
        }
    }
    function handleFontSize() {
        WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize': 0 });
        WeixinJSBridge.on('menu:setfont', function () {
            WeixinJSBridge.invoke('setFontSizeCallback', { 'fontSize': 0 });
        });
    }

}


function filterFiles(fileList) {
    var allowedTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/heic', 'image/livp'];
    var allowedExtensions = ['.heic', '.heif', '.livp'];
    var filePromises = [];

    for (var i = 0; i < fileList.length; i++) {
      var file = fileList[i];
      var fileName = file.name.toLowerCase();
      var isLivp = fileName.indexOf('.livp') === fileName.length - 5;

      if (allowedTypes.includes(file.type)) {
        filePromises.push(Promise.resolve(file));
      } else if (file.type === '') {
        var hasAllowedExtension = allowedExtensions.some(function(ext) {
          return fileName.indexOf(ext) === fileName.length - ext.length;
        });
        if (hasAllowedExtension) {
          if (isLivp) {
            // .livp 是压缩包，需要用 JSZip 解包提取其中的 HEIC 图片
            filePromises.push(extractHeicFromLivp(file));
          } else {
            filePromises.push(Promise.resolve(new File([file], file.name, { type: 'image/heic' })));
          }
        } else {
          filePromises.push(new Promise(function(resolve) {
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = function() {
              var base64 = reader.result;
              var type = base64.substring(5, base64.indexOf(';'));
              if (allowedTypes.includes(type)) {
                var blob = base64ToBlob(base64);
                resolve(new File([blob], file.name, { type: type }));
              } else {
                resolve(null);
              }
            };
            reader.onerror = function() {
              resolve(null);
            };
          }));
        }
      }
    }

    return Promise.all(filePromises).then(function(files) {
      return files.filter(function(f) { return f !== null; });
    });
  }

  // 从 .livp 压缩包中提取 HEIC 图片
  function extractHeicFromLivp(file) {
    return JSZip.loadAsync(file).then(function(zip) {
      var imageFileName = null;
      zip.forEach(function(relativePath, zipEntry) {
        if (!zipEntry.dir && !imageFileName) {
          var lowerName = relativePath.toLowerCase();
          if (lowerName.endsWith('.heic') || lowerName.endsWith('.heif') ||
              lowerName.endsWith('.jpg') || lowerName.endsWith('.jpeg') ||
              lowerName.endsWith('.png')) {
            imageFileName = relativePath;
          }
        }
      });

      if (!imageFileName) {
        console.warn('No image found in .livp package:', file.name);
        return null;
      }

      return zip.file(imageFileName).async('blob').then(function(blob) {
        // 提取内部图片的扩展名
        var internalExt = '';
        var internalLower = imageFileName.toLowerCase();
        if (internalLower.endsWith('.heic')) internalExt = '.heic';
        else if (internalLower.endsWith('.heif')) internalExt = '.heif';
        else if (internalLower.endsWith('.jpg') || internalLower.endsWith('.jpeg')) internalExt = '.jpg';
        else if (internalLower.endsWith('.png')) internalExt = '.png';
        // 用原始 .livp 文件名替换扩展名
        var newName = file.name.replace(/\.livp$/i, '') + internalExt;
        return new File([blob], newName, { type: blob.type || 'image/heic' });
      });
    }).catch(function(err) {
      console.error('Failed to extract .livp:', file.name, err);
      return null;
    });
  }

  function base64ToBlob(base64) {
    var parts = base64.split(';base64,');
    var contentType = parts[0].split(':')[1];
    var raw = window.atob(parts[1]);
    var rawLength = raw.length;
    var uInt8Array = new Uint8Array(rawLength);

    for (var i = 0; i < rawLength; ++i) {
      uInt8Array[i] = raw.charCodeAt(i);
    }

    return new Blob([uInt8Array], { type: contentType });
  }
/**
 * 获取年月
 * */
function getDay(item,year,month,monthIndex) {
    var _ret = "";
    var month = month<10?"0"+month:month;
    var currentDate = new Date(year + "-" + month);
    currentDate.setMonth(currentDate.getMonth() + monthIndex-1);
    if(item=='year'){
        _ret = currentDate.getFullYear()
    }
    if(item=='month'){
        _ret = (currentDate.getMonth() + 1)
    }
    return _ret
}

//获取当前页的类型
function getPageType(page) {
    page.genre = 'original';
    if(page && page.levels && page.levels.level){
        page.levels.level.forEach(function (level) {
            if(page.genre != 'calAll'){
                if(level.calTitleBox&&level.calTitleBox.geometry){
                    if(page.genre == 'calMonth'){
                        page.genre = 'calAll';
                    }else{
                        page.genre = 'calTitle';
                    }
                }
                if(level.calMonthBox&&level.calMonthBox.geometry){
                    if(page.genre == 'calTitle'){
                        page.genre = 'calAll';
                    }else{
                        page.genre = 'calMonth';
                    }
                }
            }
        })
    }
}
//通过部件获取页
function getPage(partid,pages) {
    var page = pages[0];
    for(var i=0; i<pages.length; i++){
        if(pages[i].config.partid == partid){
            page = pages[i];
            break
        }
    }
    return JSON.parse(JSON.stringify(page))
}
//通过uuid获取页
function getPage1(uuid,pages,backupPages,index) {
    var page = null;
    for(var i=0; i<backupPages.length; i++){
        if(backupPages[i].uuid == uuid){
            page = backupPages[i];
            break
        }
    }
    if(!page){
        for(var i=0; i<pages.length; i++){
            if(pages[i].uuid == uuid){
                page = pages[i];
                break
            }
        }
    }
    if(!page){
        if(!pages[index]){
            return JSON.parse(JSON.stringify(pages[0]))
        }else{
            return JSON.parse(JSON.stringify(pages[index]))
        }
    }else{
        return JSON.parse(JSON.stringify(page))
    }
}
//获取日历一行几列
function displayType(item) {
    switch (item) {
        case 'C7':
            return 7;
        case 'C14':
            return 14;
        case 'C21':
            return 21;
        default:
            return 7;
    }
}
//判断商户存储空间
function uploadAble(StoreStorages,storeId,callback) {
    StoreStorages.uploadAble({
        storeId:storeId
    },function (res) {
        callback(res)
    },function (error) {
        callback(error)
    })
}


// 圆角切换  固定/百分比
function switchToRoundedMode(imagebox, borderRadiusAllbtn) {
    var radiusW = Math.min(imagebox.geometry.width, imagebox.geometry.height);
    radiusW = radiusW + Number(imagebox.border.lineWidth);
    if (imagebox.border.radius.filletType == 'Proportion') {// 固定值转百分比
        if (borderRadiusAllbtn == true) {
            var all = (imagebox.border.radius.all / radiusW * 100) > 100 ? 100 : Math.round(imagebox.border.radius.all / radiusW * 100);
            imagebox.border.radius.all = all;
            imagebox.border.radius.lt = all;
            imagebox.border.radius.rt = all;
            imagebox.border.radius.rb = all;
            imagebox.border.radius.lb = all;
        } else {
            var scaleDown = scaleDownTo100((imagebox.border.radius.lt / radiusW * 100), (imagebox.border.radius.rt / radiusW * 100), (imagebox.border.radius.rb / radiusW * 100), (imagebox.border.radius.lb / radiusW * 100))
            imagebox.border.radius.lt = scaleDown[0];
            imagebox.border.radius.rt = scaleDown[1];
            imagebox.border.radius.rb = scaleDown[2];
            imagebox.border.radius.lb = scaleDown[3];
        }
    } else {//百分比转固定值
        if (borderRadiusAllbtn == true) {
            var all = Math.round(imagebox.border.radius.all / 100 * radiusW);
            imagebox.border.radius.all = all;
            imagebox.border.radius.lt = all;
            imagebox.border.radius.rt = all;
            imagebox.border.radius.rb = all;
            imagebox.border.radius.lb = all;
        } else {
            imagebox.border.radius.lt = Math.round(imagebox.border.radius.lt / 100 * radiusW);
            imagebox.border.radius.rt = Math.round(imagebox.border.radius.rt / 100 * radiusW);
            imagebox.border.radius.rb = Math.round(imagebox.border.radius.rb / 100 * radiusW);
            imagebox.border.radius.lb = Math.round(imagebox.border.radius.lb / 100 * radiusW);
        }
    }


    // 等比列缩小到100以下
    function scaleDownTo100(value1, value2, value3, value4) {
        var maxValue = Math.max(value1, value2, value3, value4);
        if (maxValue < 100) {
            return [Math.round(value1), Math.round(value2), Math.round(value3), Math.round(value4)];
        }
        var scaleRatio = 100 / maxValue;

        // 缩小数值
        var scaledValue1 = Math.round(value1 * scaleRatio);
        var scaledValue2 = Math.round(value2 * scaleRatio);
        var scaledValue3 = Math.round(value3 * scaleRatio);
        var scaledValue4 = Math.round(value4 * scaleRatio);

        // 返回缩小后的数值
        return [scaledValue1, scaledValue2, scaledValue3, scaledValue4];
    }
}

function getTextHeight(textbox, $scope) {
    // 创建临时div
    var div = document.createElement('div');
    // 设置样式
    div.className = 'addDiv';
    div.style.width = writingmodeInit(textbox.style.writingmode) ? 'auto' : textbox.geometry.width + "px";
    div.style.height = !writingmodeInit(textbox.style.writingmode) ? 'auto' : textbox.geometry.height + "px";
    div.style.fontSize = textbox.style.size + "pt";
    div.style.letterSpacing = textbox.style.letterspacing + "pt";
    div.style.lineHeight = textbox.style.lineheight + "pt";
    div.style.fontFamily = textbox.fontuuid;
    div.style.writingMode = textbox.style.writingmode; // 确保自动换行
    div.style.whiteSpace = 'break-spaces'; // 确保自动换行
    div.style.wordBreak = 'break-word'; // 确保自动换行
    div.style.position = 'absolute'; // 避免影响布局
    div.style.visibility = 'hidden'; // 隐藏元素
    // 设置文本内容
    div.textContent = textbox.text;
    // 添加到DOM（必须添加到文档中才能获取高度）
    document.body.appendChild(div);

    // 获取高度（包括内边距但不包括边框和外边距）
    var height = div.clientHeight + 10;
    var width = div.clientWidth + 10;
    if(!writingmodeInit(textbox.style.writingmode)){
        textbox.geometry.height = height;
    }
    if(writingmodeInit(textbox.style.writingmode)){
        textbox.geometry.width = width;
    }
    // 清理临时元素
    document.body.removeChild(div);

    // 触发一次脏检查，保证视图同步（如果在 Angular 外部调用）
    if ($scope && !$scope.$$phase && !($scope.$root && $scope.$root.$$phase)) {
        $scope.$applyAsync();
    }
}

function imageFilterFilter(image, angle, isLarge) {
    if (!image) {
        return '';
    }
    var domain = (image.indexOf('http') == -1 ? localStorage.getItem('editor-domain').replace(/"/g, '') : '');
    var thumbnail = localStorage.getItem('editor-thumbnail') || '/thumbnail/800x800>';
    var url = domain + image + '?imageMogr2/exifModify/eyJPcmllbnRhdGlvbiI6IjEifQ==';
    if(isLarge){
        url = domain + image + '.strip_copy' + '?imageMogr2/exifModify/eyJPcmllbnRhdGlvbiI6IjEifQ==';
    }
    if(typeof angle === 'number'){
        url += '/rotate/' + angle;
    }
    if(thumbnail){
        url += thumbnail;
    }
    return url;
}

function goldFoil(color){
    if(color){
        var cList = hexToRgba(color).join(',');
        var _color = 'linear-gradient(45deg, '+cList+')';
        return _color
    }
}

/* crc32.js (C) 2014-present SheetJS -- http://sheetjs.com */
/* vim: set ts=2: */
/*exported CRC32 */
var CRC32;
(function (factory) {
	/*jshint ignore:start */
	/*eslint-disable */
	if(typeof DO_NOT_EXPORT_CRC === 'undefined') {
		if('object' === typeof exports) {
			factory(exports);
		} else if ('function' === typeof define && define.amd) {
			define(function () {
				var module = {};
				factory(module);
				return module;
			});
		} else {
			factory(CRC32 = {});
		}
	} else {
		factory(CRC32 = {});
	}
	/*eslint-enable */
	/*jshint ignore:end */
}(function(CRC32) {
CRC32.version = '1.2.0';
/* see perf/crc32table.js */
/*global Int32Array */
function signed_crc_table() {
	var c = 0, table = new Array(256);

	for(var n =0; n != 256; ++n){
		c = n;
		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
		c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
		table[n] = c;
	}

	return typeof Int32Array !== 'undefined' ? new Int32Array(table) : table;
}

var T = signed_crc_table();
function crc32_bstr(bstr, seed) {
	var C = seed ^ -1, L = bstr.length - 1;
	for(var i = 0; i < L;) {
		C = (C>>>8) ^ T[(C^bstr.charCodeAt(i++))&0xFF];
		C = (C>>>8) ^ T[(C^bstr.charCodeAt(i++))&0xFF];
	}
	if(i === L) C = (C>>>8) ^ T[(C ^ bstr.charCodeAt(i))&0xFF];
	return (C ^ (-1)) >>> 0;
}

function crc32_buf(buf, seed) {
	if(buf.length > 10000) return crc32_buf_8(buf, seed);
	var C = seed ^ -1, L = buf.length - 3;
	for(var i = 0; i < L;) {
		C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
		C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
		C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
		C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
	}
	while(i < L+3) C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
	return (C ^ (-1)) >>> 0;;
}

function crc32_buf_8(buf, seed) {
	var C = seed ^ -1, L = buf.length - 7;
	for(var i = 0; i < L;) {
		C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
		C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
		C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
		C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
		C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
		C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
		C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
		C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
	}
	while(i < L+7) C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
	return (C ^ (-1)) >>> 0;
}

function crc32_str(str, seed) {
	var C = seed ^ -1;
	for(var i = 0, L=str.length, c, d; i < L;) {
		c = str.charCodeAt(i++);
		if(c < 0x80) {
			C = (C>>>8) ^ T[(C ^ c)&0xFF];
		} else if(c < 0x800) {
			C = (C>>>8) ^ T[(C ^ (192|((c>>6)&31)))&0xFF];
			C = (C>>>8) ^ T[(C ^ (128|(c&63)))&0xFF];
		} else if(c >= 0xD800 && c < 0xE000) {
			c = (c&1023)+64; d = str.charCodeAt(i++)&1023;
			C = (C>>>8) ^ T[(C ^ (240|((c>>8)&7)))&0xFF];
			C = (C>>>8) ^ T[(C ^ (128|((c>>2)&63)))&0xFF];
			C = (C>>>8) ^ T[(C ^ (128|((d>>6)&15)|((c&3)<<4)))&0xFF];
			C = (C>>>8) ^ T[(C ^ (128|(d&63)))&0xFF];
		} else {
			C = (C>>>8) ^ T[(C ^ (224|((c>>12)&15)))&0xFF];
			C = (C>>>8) ^ T[(C ^ (128|((c>>6)&63)))&0xFF];
			C = (C>>>8) ^ T[(C ^ (128|(c&63)))&0xFF];
		}
	}
	return (C ^ (-1)) >>> 0;
}
CRC32.table = T;
// $FlowIgnore
CRC32.bstr = crc32_bstr;
// $FlowIgnore
CRC32.buf = crc32_buf;
// $FlowIgnore
CRC32.str = crc32_str;
}));

window.angular.module('common.service', []).factory('CommonService', ['$location', '$http', 'SweetAlert', '$timeout', '$rootScope', '$state', 'Gallery', 'UidService', '$translate', 'QiniuToken',
    function ($location, $http, SweetAlert, $timeout, $rootScope, $state, Gallery, UidService, $translate, QiniuToken) {
        /**
         * 封装请求后端的middleware
         * @param params
         * @param success
         * @param failure
         */
        $rootScope.requestCount = 0;
        this.request = function (params, success, failure, hideLoading, errorCodeHandler) {
            if (!hideLoading) {
                $rootScope.requestCount++;
            }
            params.header = {
                Accept: 'application/json, text/plain, */*'
            };
            try {
                $http(params).then(function (resp) {
                    if (!hideLoading) {
                        if ($rootScope.requestCount) {
                            $rootScope.requestCount--;
                        }
                    }
                    if (+resp.data.code) {
                        if (errorCodeHandler) {
                            errorCodeHandler(resp.data)
                        } else {
                            SweetAlert.swal('', resp.data.msg, 'error');
                        }
                    } else {
                        success(resp.data);
                    }
                }, function (error) {
                    if (!hideLoading) {
                        if ($rootScope.requestCount) {
                            $rootScope.requestCount--;
                        }
                    }
                    if (failure) {
                        failure(error);
                    }
                    //else {
                    //    SweetAlert.swal('', `request failed ${error.status} ${error.statusText}`, 'error');
                    //}
                })
            } catch (e) {
                console.log(e);
            }

        };


        /**
         *
         * Hack 微信中title修改不了的问题
         */
        this.setDocumentTitle = function (title) {
            document.title = title;
            if (/ip(hone|od|ad)/i.test(navigator.userAgent)) {
                var i = document.createElement('iframe');
                // i.src = '/favicon.ico';
                i.style.display = 'none';
                i.onload = function () {
                    setTimeout(function () {
                        i.remove();
                    }, 9)
                };
                document.body.appendChild(i);
            }
        };

        this.alert = function (title, text, callback, time, type) {
            SweetAlert.swal({
                title: title,
                text: text,
                imageUrl: "content/images/icons/pop_ic_msg_succeed.svg",
                timer: 2000,
                showConfirmButton: false
            });
            // SweetAlert.swal('', text, type ? type : 'success');
            $timeout(function () {
                if (callback) {
                    callback();
                }
            }, time ? time : 2000);
        };

        /**
         * 深对比对象是否相等
         */
        this.checkObjectEqual = function (origin, current) {
            var unEqual = false;
            Array.prototype.unique = function () {
                var a = this.concat();
                for (var i = 0; i < a.length; ++i) {
                    for (var j = i + 1; j < a.length; ++j) {
                        if (a[i] === a[j])
                            a.splice(j--, 1);
                    }
                }
                return a;
            };

            var checkObject = function (ori, cur) {
                if (unEqual) return;
                if (!ori || !cur) return;
                const keys1 = Object.keys(ori);
                const keys2 = Object.keys(cur);
                const keys = keys1.concat(keys2).unique();
                //console.log(keys);
                angular.forEach(keys, function (key) {
                    if (unEqual) return;
                    if (key == '$$hashKey') return;
                    if (angular.isObject(ori[key]) && angular.isObject(cur[key])) {
                        checkObject(ori[key], cur[key]);
                    } else {
                        switch (typeof ori[key]) {
                            case 'string':
                                if (ori[key].length) {
                                    unEqual = (ori[key] != cur[key]);
                                } else {
                                    unEqual = !!cur[key] || (angular.isObject(cur[key]) && Object.keys(cur[key].length));
                                }
                                break;
                            case 'number':
                                if (ori[key]) {
                                    unEqual = (ori[key] != cur[key]);
                                } else {
                                    unEqual = !!cur[key] && (cur[key] != '0');
                                }
                                break;
                            case 'object':
                                if (ori[key] == null) {
                                    unEqual = !!cur[key] || (angular.isObject(cur[key]) && Object.keys(cur[key].length));
                                } else {
                                    if (Object.keys(ori[key]).length) {
                                        unEqual = true;
                                    } else {
                                        unEqual = !!cur[key];
                                    }
                                }
                                break;
                            case 'undefined':
                                unEqual = !!cur[key] || (angular.isObject(cur[key]) && Object.keys(cur[key].length));
                                break;
                            default:
                                unEqual = (!ori[key] == !!cur[key]);
                                break;
                        }
                    }

                });
            };

            checkObject(origin, current);
            console.log(">>>>>>>>>finall--" + unEqual);
            return unEqual;

        };


        /**
         * 切换路由时检查当前是否有表单为提交
         */
        this.checkDirtyPage = function ($scope, checkFormDirty, callback) {
            $scope.$on('$stateChangeStart', function (e, toState, toParams, fromState, fromParams) {
                $('.sweet-alert').removeClass('hide-button');

                if (checkFormDirty() && !$scope.cancelCheck) {
                    e.preventDefault();
                    SweetAlert.swal({
                            title: '',
                            text: $translate.instant('confirmDialog.leavePageUnsaved'),
                            type: "warning",
                            showCancelButton: true,
                            confirmButtonText: $translate.instant('confirmDialog.leaveAnyway'),
                            cancelButtonText: $translate.instant('button.cancel'),
                            closeOnConfirm: true,
                            closeOnCancel: true
                        },
                        function () {
                            $scope.cancelCheck = true;
                            $state.go(toState.name, toParams);
                        });
                } else {
                    $('.sweet-alert .confirm').trigger("click");
                    $rootScope.leaveEditPage = true;
                }

            });
        };

        this.uploadFile = function (file, callback, shouldReadIMGInfo) {
            // var ext = '-' + ipCookie('userid') + '-' + parseInt(Math.random()*100000) + '.png';
            //
            // if (!this.instance) {
            //     var config = {
            //         bucket: window.diyUpyunConfig.bucket,
            //         expiration: parseInt((new Date().getTime() + 3600000) / 1000),
            //         form_api_secret: window.diyUpyunConfig.form_api_secret
            //     };
            //
            //     var instance = new Sand(config);
            //
            //     this.instance = instance;
            // }
            //
            // this.instance.upload('/upload/template/diy/' + parseInt((new Date().getTime() + 3600000) / 1000) + ext, file, function(resp) {
            //     if (!resp) {
            //         SweetAlert.swal('', "图片上传失败！没有返回值", 'error');
            //         return;
            //     }
            //     var path = imagePath+resp.path;
            //     if (shouldReadIMGInfo) {
            //         $http({url: path+"!imageInfo", method: 'get'}).then(function(resp) {
            //             if (!resp.data) {
            //                 SweetAlert.swal('', '获取图片信息失败！Sad...', 'error');
            //                 return;
            //             }
            //             var response = {
            //                 url: '' + path,
            //                 width: resp.data.width,
            //                 height: resp.data.height
            //             };
            //             if (resp.data.EXIF) {
            //                 var orientation = resp.data.EXIF.Orientation;
            //                 if (orientation == '6' || orientation == '8') {
            //                     response.width = resp.data.height;
            //                     response.height = resp.data.width;
            //                 }
            //             }
            //             callback(response);
            //         });
            //     } else {
            //         callback(path);
            //     }
            //
            // }, function(err) {
            //     console.error(err);
            //     $('.sweet-alert').removeClass('hide-button');
            //     SweetAlert.swal('', "图片上传失败，请重新上传", 'info');
            // });
        };

        // 超大图（xl 大图标识）判定阈值
        var XL_FILE_SIZE = 20971520;    // 20M
        var XL_MAX_SIDE = 30000;        // 单边像素
        var XL_MAX_PIXELS = 150000000;  // 1.5亿像素

        /**
         * 判断是否超大图（需要打 -xl 标识）：超过20M / 单边超过30000 / 超过1.5亿像素
         * width、height 不是 File 原生属性，可能调用方没赋值或异步未回填（undefined），
         * 这里统一兜底成 0，避免 undefined 参与运算导致判断失效
         */
        function isExtraLargeImage(file) {
            var size = Number(file && file.size) || 0;
            var width = Number(file && file.width) || 0;
            var height = Number(file && file.height) || 0;
            return size >= XL_FILE_SIZE
                || width > XL_MAX_SIDE
                || height > XL_MAX_SIDE
                || (width * height) > XL_MAX_PIXELS;
        }

        this.isExtraLargeImage = isExtraLargeImage;

        this.UpdateQiniuService = function (files, i, len, domain, token, folderId, aid, callback , errorcallback,detectFaces) {
            doUpdate(files, i, len, domain, token, folderId, aid, callback, errorcallback, detectFaces, false);
        };

        function doUpdate(files, i, len, domain, token, folderId, aid, callback, errorcallback, detectFaces, isRetry) {
            // width/height 不是 File 的原生属性，调用方可能没赋值或异步还没回来，
            // 这里统一兜底读取后再上传，避免 '-xl' 判断因 undefined 变成 NaN 而失效
            readImageDimensions(files[i]).then(function (dim) {
                files[i].width = dim.width;
                files[i].height = dim.height;
                runUpdate(files, i, len, domain, token, folderId, aid, callback, errorcallback, detectFaces, isRetry);
            });
        }

        function runUpdate(files, i, len, domain, token, folderId, aid, callback, errorcallback, detectFaces, isRetry) {
            var url = window.URL || window.webkitURL;
            var img = new Image();              //手动创建一个Image对象
            img.src = url.createObjectURL(files[i]);//创建Image的对象的url
            img.crossOrigin = "Anonymous";

            var formData = new FormData();

            var _key ="file-" + UidService.get()
            var fileSize = files[i].size || 0;
            var fileWidth = files[i].width || 0;
            var fileHeight = files[i].height || 0;
            var isXL = isExtraLargeImage(files[i]);
            // 超过20M / 单边超过30000 / 超过1.5亿像素 增加xl大图标识
            console.log('[upload]' + files[i].name, 'size:' + fileSize, 'width:' + fileWidth, 'height:' + fileHeight, 'isXL:' + isXL);
            if(isXL){
                _key += '-xl'
            }
            formData.append('file', files[i]);
            formData.append('key', _key);
            formData.append('token', token);

            var reader = new FileReader();
            reader.readAsArrayBuffer(files[i])
            reader.onloadend = function (e) {
                formData.append('crc32', CRC32.buf(new Uint8Array(this.result)));
                return $.ajax({
                    cache: true,
                    type: "POST",
                    url: 'https://upload.qiniup.com/',
                    data: formData,
                    async: true,
                    contentType: false,
                    processData: false,
                    success: function (data) {
                        return $.ajax({
                            type: "GET",
                            url: domain + data.key + "?imageInfo",
                            success: function (va) {
                                // console.log(va)
                                if (va.orientation == "Left-bottom" || va.orientation == "Right-top") {
                                    files[i].width = va.height;
                                    files[i].height = va.width;
                                } else {
                                    files[i].width = va.width;
                                    files[i].height = va.height;
                                }
                                Gallery.upload({
                                    identifiers: data.key,
                                    detectFaces: true,
                                    provider: "QINIU",
                                    fileName: files[i].name,
                                    imgSize: files[i].size,
                                    width: files[i].width,
                                    height: files[i].height,
                                    folderId: folderId ? folderId : '',
                                    articleId: aid,
                                    hash: data.hash,
                                    detectFaces:detectFaces
                                }, function (resp) {
                                    callback.call(this, resp);
                                },function(){
                                    errorcallback.call(this, files[i]); //接口保存链接失败
                                });

                            },
                            error: function (request) {
                                errorcallback.call(this, files[i]); //接口保存链接失败
                                $(".pic-loading").addClass('hide1');
                                $(".leftPanel-bg-show").removeClass('overflow-hidden');
                            }
                        });
                    },
                    error: function (request) {
                        if (!isRetry && isTokenError(request)) {
                            // 401 / "expired token" -> 刷新token后重试一次
                            QiniuToken.refresh('get', {}, function (newToken) {
                                doUpdate(files, i, len, domain, newToken, folderId, aid, callback, errorcallback, detectFaces, true);
                            });
                            return;
                        }
                        errorcallback(files[i]);
                        $(".pic-loading").addClass('hide1');
                        $(".leftPanel-bg-show").removeClass('overflow-hidden');
                    }
                });
            }
        }

        /**
         * 获取图片文件的像素宽高（内部兜底，不依赖调用方赋值）
         * 1. 优先取调用方已挂在 file 上的 width/height
         * 2. 其次用 Image 解码
         * 3. 解码失败（超大图超出浏览器解码上限 / HEIC 等不支持的格式）时回退解析文件头二进制
         */
        function readImageDimensions(file) {
            return new Promise(function (resolve) {
                if (!file) {
                    resolve({width: 0, height: 0});
                    return;
                }
                var cachedWidth = Number(file.width);
                var cachedHeight = Number(file.height);
                if (cachedWidth > 0 && cachedHeight > 0) {
                    resolve({width: cachedWidth, height: cachedHeight});
                    return;
                }
                var urlCreator = window.URL || window.webkitURL;
                var objectUrl = null;
                try {
                    objectUrl = urlCreator.createObjectURL(file);
                } catch (e) {
                    objectUrl = null;
                }
                if (!objectUrl) {
                    readDimensionsFromHeader(file).then(resolve);
                    return;
                }
                var probeImage = new Image();
                probeImage.onload = function () {
                    urlCreator.revokeObjectURL(objectUrl);
                    var w = probeImage.naturalWidth || probeImage.width;
                    var h = probeImage.naturalHeight || probeImage.height;
                    if (w > 0 && h > 0) {
                        resolve({width: w, height: h});
                    } else {
                        readDimensionsFromHeader(file).then(resolve);
                    }
                };
                probeImage.onerror = function () {
                    urlCreator.revokeObjectURL(objectUrl);
                    readDimensionsFromHeader(file).then(resolve);
                };
                probeImage.src = objectUrl;
            });
        }

        /** 对外暴露：读取图片真实像素宽高（缓存 -> Image 解码 -> 文件头解析 三级兜底） */
        this.readImageDimensions = readImageDimensions;

        /** 通过解析图片文件头部二进制获取宽高（不需要完整解码，适用于超大图） */
        function readDimensionsFromHeader(file) {
            return new Promise(function (resolve) {
                if (!file || typeof file.slice !== 'function') {
                    resolve({width: 0, height: 0});
                    return;
                }
                var reader = new FileReader();
                reader.onload = function (e) {
                    resolve(parseImageHeader(new Uint8Array(e.target.result)));
                };
                reader.onerror = function () {
                    resolve({width: 0, height: 0});
                };
                // 只读取前64KB就足够获取大多数图片的尺寸信息
                reader.readAsArrayBuffer(file.slice(0, 65536));
            });
        }

        /** 支持 JPEG / PNG / GIF / WEBP / BMP，其它格式返回 0（由文件大小兜底判断） */
        function parseImageHeader(buffer) {
            if (!buffer || buffer.length < 24) {
                return {width: 0, height: 0};
            }
            // JPEG: FFD8 开头，找 SOF 段
            if (buffer[0] === 0xFF && buffer[1] === 0xD8) {
                var offset = 2;
                while (offset + 9 < buffer.length) {
                    if (buffer[offset] !== 0xFF) {
                        offset++;
                        continue;
                    }
                    var marker = buffer[offset + 1];
                    if (marker >= 0xC0 && marker <= 0xCF && marker !== 0xC4 && marker !== 0xC8 && marker !== 0xCC) {
                        return {
                            width: (buffer[offset + 7] << 8) | buffer[offset + 8],
                            height: (buffer[offset + 5] << 8) | buffer[offset + 6]
                        };
                    }
                    if (marker === 0x01 || (marker >= 0xD0 && marker <= 0xD9)) {
                        offset += 2;
                        continue;
                    }
                    offset += 2 + ((buffer[offset + 2] << 8) | buffer[offset + 3]);
                }
                return {width: 0, height: 0};
            }
            // PNG: 签名(8) + length(4) + IHDR(4) 之后是 4字节宽 + 4字节高（大端序）
            if (buffer[0] === 0x89 && buffer[1] === 0x50 && buffer[2] === 0x4E && buffer[3] === 0x47) {
                return {
                    width: (buffer[16] << 24) | (buffer[17] << 16) | (buffer[18] << 8) | buffer[19],
                    height: (buffer[20] << 24) | (buffer[21] << 16) | (buffer[22] << 8) | buffer[23]
                };
            }
            // GIF
            if (buffer[0] === 0x47 && buffer[1] === 0x49 && buffer[2] === 0x46) {
                return {
                    width: buffer[6] | (buffer[7] << 8),
                    height: buffer[8] | (buffer[9] << 8)
                };
            }
            // WEBP: RIFF....WEBP + chunk
            if (buffer[0] === 0x52 && buffer[1] === 0x49 && buffer[2] === 0x46 && buffer[3] === 0x46
                && buffer[8] === 0x57 && buffer[9] === 0x45 && buffer[10] === 0x42 && buffer[11] === 0x50) {
                var chunk = String.fromCharCode(buffer[12], buffer[13], buffer[14], buffer[15]);
                if (chunk === 'VP8 ') {
                    return {
                        width: (buffer[26] | (buffer[27] << 8)) & 0x3FFF,
                        height: (buffer[28] | (buffer[29] << 8)) & 0x3FFF
                    };
                }
                if (chunk === 'VP8L') {
                    var bits = buffer[21] | (buffer[22] << 8) | (buffer[23] << 16) | (buffer[24] << 24);
                    return {width: (bits & 0x3FFF) + 1, height: ((bits >>> 14) & 0x3FFF) + 1};
                }
                if (chunk === 'VP8X') {
                    return {
                        width: ((buffer[24] | (buffer[25] << 8) | (buffer[26] << 16)) >>> 0) + 1,
                        height: ((buffer[27] | (buffer[28] << 8) | (buffer[29] << 16)) >>> 0) + 1
                    };
                }
                return {width: 0, height: 0};
            }
            // HEIC / HEIF / AVIF: box 结构（size(4) + type(4)），遍历查找 ispe（图像空间尺寸）
            // Chrome 等浏览器无法解码 HEIC，只能靠解析文件头拿到宽高
            if (buffer[4] === 0x66 && buffer[5] === 0x74 && buffer[6] === 0x79 && buffer[7] === 0x70) {
                var boxPos = 0;
                var maxW = 0;
                var maxH = 0;
                while (boxPos + 8 <= buffer.length) {
                    var boxSize = ((buffer[boxPos] << 24) | (buffer[boxPos + 1] << 16) | (buffer[boxPos + 2] << 8) | buffer[boxPos + 3]) >>> 0;
                    var boxHeaderSize = 8;
                    if (boxSize === 1) { // 64位扩展长度
                        if (boxPos + 16 > buffer.length) {
                            break;
                        }
                        boxHeaderSize = 16;
                        boxSize = ((buffer[boxPos + 8] << 24) | (buffer[boxPos + 9] << 16) | (buffer[boxPos + 10] << 8) | buffer[boxPos + 11]) >>> 0;
                    }
                    if (boxSize < boxHeaderSize) {
                        break;
                    }
                    // 'ispe' -> payload: version+flags(4) + width(4) + height(4)
                    var payloadPos = boxPos + boxHeaderSize;
                    if (buffer[boxPos + 4] === 0x69 && buffer[boxPos + 5] === 0x73 && buffer[boxPos + 6] === 0x70 && buffer[boxPos + 7] === 0x65
                        && payloadPos + 12 <= buffer.length) {
                        var heicW = ((buffer[payloadPos + 4] << 24) | (buffer[payloadPos + 5] << 16) | (buffer[payloadPos + 6] << 8) | buffer[payloadPos + 7]) >>> 0;
                        var heicH = ((buffer[payloadPos + 8] << 24) | (buffer[payloadPos + 9] << 16) | (buffer[payloadPos + 10] << 8) | buffer[payloadPos + 11]) >>> 0;
                        // 可能存在多个 ispe（主图 / 缩略图），取最大的一组，避免漏判大图
                        if (heicW * heicH > maxW * maxH) {
                            maxW = heicW;
                            maxH = heicH;
                        }
                    }
                    boxPos += boxSize;
                }
                return {width: maxW, height: maxH};
            }
            // BMP
            if (buffer[0] === 0x42 && buffer[1] === 0x4D) {
                return {
                    width: (buffer[18] | (buffer[19] << 8) | (buffer[20] << 16) | (buffer[21] << 24)) >>> 0,
                    height: Math.abs((buffer[22] | (buffer[23] << 8) | (buffer[24] << 16) | (buffer[25] << 24)) | 0)
                };
            }
            return {width: 0, height: 0};
        }

        function isTokenError(request) {
            return request && (request.status === 401 ||
                (request.responseText && request.responseText.indexOf('expired token') !== -1));
        }

        return this;

    }]);

/*!
 * classie - class helper functions
 * from bonzo https://github.com/ded/bonzo
 * 
 * classie.has( elem, 'my-class' ) -> true/false
 * classie.add( elem, 'my-new-class' )
 * classie.remove( elem, 'my-unwanted-class' )
 * classie.toggle( elem, 'my-class' )
 */

/*jshint browser: true, strict: true, undef: true */
/*global define: false */

( function( window ) {

'use strict';

// class helper functions from bonzo https://github.com/ded/bonzo

function classReg( className ) {
  return new RegExp("(^|\\s+)" + className + "(\\s+|$)");
}

// classList support for class management
// altho to be fair, the api sucks because it won't accept multiple classes at once
var hasClass, addClass, removeClass;

if ( 'classList' in document.documentElement ) {
  hasClass = function( elem, c ) {
    return elem.classList.contains( c );
  };
  addClass = function( elem, c ) {
    elem.classList.add( c );
  };
  removeClass = function( elem, c ) {
    elem.classList.remove( c );
  };
}
else {
  hasClass = function( elem, c ) {
    return classReg( c ).test( elem.className );
  };
  addClass = function( elem, c ) {
    if ( !hasClass( elem, c ) ) {
      elem.className = elem.className + ' ' + c;
    }
  };
  removeClass = function( elem, c ) {
    elem.className = elem.className.replace( classReg( c ), ' ' );
  };
}

function toggleClass( elem, c ) {
  var fn = hasClass( elem, c ) ? removeClass : addClass;
  fn( elem, c );
}

var classie = {
  // full names
  hasClass: hasClass,
  addClass: addClass,
  removeClass: removeClass,
  toggleClass: toggleClass,
  // short names
  has: hasClass,
  add: addClass,
  remove: removeClass,
  toggle: toggleClass
};

// transport
if ( typeof define === 'function' && define.amd ) {
  // AMD
  define( classie );
} else {
  // browser global
  window.classie = classie;
}

})( window );

(function() {
    'use strict';

    angular
        .module('editorApp')
        .filter('capitalize', capitalize)
        .filter('imageFilter', imageFilter)
        .filter('serviceType', serviceType);

    capitalize.$inject = [];
    imageFilter.$inject = [];
    serviceType.$inject = ['$translate'];

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
    function imageFilter() {
        return imageFilterFilter;
    }
    function serviceType($translate) {
        return serviceTypeFilter;

        function serviceTypeFilter (item) {
            if(item === 'uv'){
                return 'UV';
            }else if(item === 'fluore'){
                return $translate.instant('serviceType.fluore');
            }else if(item === 'white'){
                return $translate.instant('serviceType.white');
            }else{
                return item;
            }
        }
    }
})();

/**
 * bookblock.min.js v2.0.1
 * http://www.codrops.com
 *
 * Licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 * 
 * Copyright 2013, Codrops
 * http://www.codrops.com
 */
 (function(c){var a=c.document,d=c.Modernizr;d.addTest("csstransformspreserve3d",function(){var h=d.prefixed("transformStyle");var g="preserve-3d";var f;if(!h){return false}h=h.replace(/([A-Z])/g,function(j,i){return"-"+i.toLowerCase()}).replace(/^ms-/,"-ms-");d.testStyles("#modernizr{"+h+":"+g+";}",function(i,j){f=c.getComputedStyle?getComputedStyle(i,null).getPropertyValue(h):""});return(f===g)});function e(g,f){for(var h in f){if(f.hasOwnProperty(h)){g[h]=f[h]}}return g}function b(g,f){this.el=g;this.options=e(this.defaults,f);this._init()}b.prototype={defaults:{orientation:"vertical",direction:"ltr",speed:1000,easing:"ease-in-out",shadows:true,shadowSides:0.2,shadowFlip:0.1,circular:false,nextEl:"",prevEl:"",autoplay:false,interval:3000,onEndFlip:function(f,h,g){return false},onBeforeFlip:function(f){return false}},_init:function(){this.el.className+=" bb-"+this.options.orientation;this.items=Array.prototype.slice.call(this.el.querySelectorAll(".bb-item"));this.itemsCount=this.items.length;this.currentIdx=0;this.previous=-1;this.current=this.items[this.currentIdx];this.current.style.display="block";this.elWidth=this.el.offsetWidth;var f={WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"oTransitionEnd",msTransition:"MSTransitionEnd",transition:"transitionend"};this.transEndEventName=f[d.prefixed("transition")];this.support=d.csstransitions&&d.csstransforms3d&&d.csstransformspreserve3d;this._initEvents();if(this.options.autoplay){this.options.circular=true;this._startSlideshow()}},_initEvents:function(){var f=this;if(this.options.nextEl!==""){a.querySelector(this.options.nextEl).addEventListener("click",function(){f._action("next");return false});a.querySelector(this.options.nextEl).addEventListener("touchstart",function(){f._action("next");return false})}if(this.options.prevEl!==""){a.querySelector(this.options.prevEl).addEventListener("click",function(){f._action("prev");return false});a.querySelector(this.options.prevEl).addEventListener("touchstart",function(){f._action("prev");return false})}c.addEventListener("resize",function(){f._resizeHandler()})},_action:function(f,g){this._stopSlideshow();this._navigate(f,g)},_navigate:function(f,g){if(this.isAnimating){return false}this.options.onBeforeFlip(this.currentIdx);this.isAnimating=true;this.current=this.items[this.currentIdx];if(g!==undefined){this.currentIdx=g}else{if(f==="next"&&this.options.direction==="ltr"||f==="prev"&&this.options.direction==="rtl"){if(!this.options.circular&&this.currentIdx===this.itemsCount-1){this.end=true}else{this.previous=this.currentIdx;this.currentIdx=this.currentIdx<this.itemsCount-1?this.currentIdx+1:0}}else{if(f==="prev"&&this.options.direction==="ltr"||f==="next"&&this.options.direction==="rtl"){if(!this.options.circular&&this.currentIdx===0){this.end=true}else{this.previous=this.currentIdx;this.currentIdx=this.currentIdx>0?this.currentIdx-1:this.itemsCount-1}}}}this.nextItem=!this.options.circular&&this.end?this.current:this.items[this.currentIdx];this.items.forEach(function(j,h){j.style.display="none"});if(!this.support){this._layoutNoSupport(f)}else{this._layout(f)}},_layoutNoSupport:function(g){this.nextItem.style.display="block";this.end=false;this.isAnimating=false;var f=g==="next"&&this.currentIdx===this.itemsCount-1||g==="prev"&&this.currentIdx===0;this.options.onEndFlip(this.previous,this.currentIdx,f)},_layout:function(i){var o=this,j=this._addSide("left",i),p=this._addSide("middle",i),l=this._addSide("right",i),f=j.querySelector("div.bb-overlay"),m=p.querySelector("div.bb-front").querySelector("div.bb-flipoverlay"),n=p.querySelector("div.bb-back").querySelector("div.bb-flipoverlay"),k=l.querySelector("div.bb-overlay"),h=this.end?400:this.options.speed;var g=this.items[0];this.el.insertBefore(j,g);this.el.insertBefore(p,g);this.el.insertBefore(l,g);j.style.zIndex=102;p.style.zIndex=103;l.style.zIndex=101;p.style.transitionDuration=h+"ms";p.style.transitionTimingFunction=this.options.easing;p.addEventListener(this.transEndEventName,function(r){if((" "+r.target.className+" ").replace(/[\n\t]/g," ").indexOf(" bb-page ")>-1){Array.prototype.slice.call(o.el.querySelectorAll(".bb-page")).forEach(function(t,s){o.el.removeChild(t)});o.nextItem.style.display="block";o.end=false;o.isAnimating=false;var q=i==="next"&&o.currentIdx===o.itemsCount-1||i==="prev"&&o.currentIdx===0;o.options.onEndFlip(o.previous,o.currentIdx,q)}});if(i==="prev"){p.className+=" bb-flip-initial"}if(this.options.shadows&&!this.end){if(i==="next"){m.style.transition="opacity "+this.options.speed/2+"ms linear";n.style.transition="opacity "+this.options.speed/2+"ms linear "+this.options.speed/2+"ms";n.style.opacity=this.options.shadowFlip;f.style.transition="opacity "+this.options.speed/2+"ms linear "+this.options.speed/2+"ms";k.style.transition="opacity "+this.options.speed/2+"ms linear";k.style.opacity=this.options.shadowSides}else{if(i==="prev"){m.style.transition="opacity "+this.options.speed/2+"ms linear "+this.options.speed/2+"ms";m.style.opacity=this.options.shadowFlip;n.style.transition="opacity "+this.options.speed/2+"ms linear";f.style.transition="opacity "+this.options.speed/2+"ms linear";f.style.opacity=this.options.shadowSides;k.style.transition="opacity "+this.options.speed/2+"ms linear "+this.options.speed/2+"ms"}}}setTimeout(function(){p.className+=o.end?" bb-flip-"+i+"-end":" bb-flip-"+i;if(o.options.shadows&&!o.end){m.style.opacity=i==="next"?o.options.shadowFlip:0;n.style.opacity=i==="next"?0:o.options.shadowFlip;f.style.opacity=i==="next"?o.options.shadowSides:0;k.style.opacity=i==="next"?0:o.options.shadowSides}},25)},_addSide:function(h,g){var j=a.createElement("div");j.className="bb-page";switch(h){case"left":var f=g==="next"?this.current.innerHTML:this.nextItem.innerHTML;j.innerHTML='<div class="bb-back"><div class="bb-outer"><div class="bb-content"><div class="bb-inner">'+f+'</div></div><div class="bb-overlay"></div></div></div>';break;case"middle":var k=g==="next"?this.current.innerHTML:this.nextItem.innerHTML;var i=g==="next"?this.nextItem.innerHTML:this.current.innerHTML;j.innerHTML='<div class="bb-front"><div class="bb-outer"><div class="bb-content"><div class="bb-inner">'+k+'</div></div><div class="bb-flipoverlay"></div></div></div><div class="bb-back"><div class="bb-outer"><div class="bb-content" style="width:'+this.elWidth+'px"><div class="bb-inner">'+i+'</div></div><div class="bb-flipoverlay"></div></div></div>';break;case"right":var f=g==="next"?this.nextItem.innerHTML:this.current.innerHTML;j.innerHTML='<div class="bb-front"><div class="bb-outer"><div class="bb-content"><div class="bb-inner">'+f+'</div></div><div class="bb-overlay"></div></div></div>';break}return j},_startSlideshow:function(){var f=this;this.slideshow=setTimeout(function(){f._navigate("next");if(f.options.autoplay){f._startSlideshow()}},this.options.interval)},_stopSlideshow:function(){if(this.options.autoplay){clearTimeout(this.slideshow);this.options.autoplay=false}},next:function(){this._action(this.options.direction==="ltr"?"next":"prev")},prev:function(){this._action(this.options.direction==="ltr"?"prev":"next")},jump:function(g){g-=1;if(g===this.currentIdx||g>=this.itemsCount||g<0){return false}var f;if(this.options.direction==="ltr"){f=g>this.currentIdx?"next":"prev"}else{f=g>this.currentIdx?"prev":"next"}this._action(f,g)},last:function(){this.jump(this.itemsCount)},first:function(){this.jump(1)},_resizeHandler:function(){var f=this;function g(){f._resize();f._resizeTimeout=null}if(this._resizeTimeout){clearTimeout(this._resizeTimeout)}this._resizeTimeout=setTimeout(g,50)},_resize:function(){this.elWidth=this.el.offsetWidth},isActive:function(){return this.isAnimating},update:function(){var f=this.items[this.current];this.items=Array.prototype.slice.call(this.el.querySelectorAll(".bb-item"));this.itemsCount=this.items.length;this.currentIdx=this.items.indexOf(f)},destroy:function(){if(this.options.autoplay){this._stopSlideshow()}this.el.className=this.el.className.replace(new RegExp("(^|\\s+)bb-"+this.options.orientation+"(\\s+|$)")," ");this.items.forEach(function(g,f){g.style.display="block"});if(this.options.nextEl!==""){this.options.nextEl.removeEventListener("click");this.options.nextEl.removeEventListener("touchstart")}if(this.options.prevEl!==""){this.options.prevEl.removeEventListener("click");this.options.prevEl.removeEventListener("touchstart")}c.removeEventListener("debouncedresize")}};c.BookBlock=b})(window);
/**
 * bookblock.js v2.0.1
 * http://www.codrops.com
 *
 * Licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 * 
 * Copyright 2013, Codrops
 * http://www.codrops.com
 */
;( function( window ) {
	
	'use strict';

	// global
	var document = window.document,
		Modernizr = window.Modernizr;

	// https://gist.github.com/edankwan/4389601
	Modernizr.addTest('csstransformspreserve3d', function () {
		var prop = Modernizr.prefixed('transformStyle');
		var val = 'preserve-3d';
		var computedStyle;
		if(!prop) return false;

		prop = prop.replace(/([A-Z])/g, function(str,m1){ return '-' + m1.toLowerCase(); }).replace(/^ms-/,'-ms-');

		Modernizr.testStyles('#modernizr{' + prop + ':' + val + ';}', function (el, rule) {
			computedStyle = window.getComputedStyle ? getComputedStyle(el, null).getPropertyValue(prop) : '';
		});

		return (computedStyle === val);
	});

	function extend( a, b ) {
		for( var key in b ) { 
			if( b.hasOwnProperty( key ) ) {
				a[key] = b[key];
			}
		}
		return a;
	}

	function BookBlock( el, options ) {
		this.el = el;
		this.options = extend( this.defaults, options );
		this._init();
	}

	BookBlock.prototype = {
		defaults : {
			// vertical or horizontal flip
			orientation : 'vertical',
			// ltr (left to right) or rtl (right to left)
			direction : 'ltr',
			// speed for the flip transition in ms
			speed : 1000,
			// easing for the flip transition
			easing : 'ease-in-out',
			// if set to true, both the flipping page and the sides will have an overlay to simulate shadows
			shadows : true,
			// opacity value for the "shadow" on both sides (when the flipping page is over it)
			// value : 0.1 - 1
			shadowSides : 0.2,
			// opacity value for the "shadow" on the flipping page (while it is flipping)
			// value : 0.1 - 1
			shadowFlip : 0.1,
			// if we should show the first item after reaching the end
			circular : false,
			// if we want to specify a selector that triggers the next() function. example: ´#bb-nav-next´
			nextEl : '',
			// if we want to specify a selector that triggers the prev() function
			prevEl : '',
			// autoplay. If true it overwrites the circular option to true
			autoplay : false,
			// time (ms) between page switch, if autoplay is true
			interval : 3000,
			// callback after the flip transition
			// old is the index of the previous item
			// page is the current item´s index
			// isLimit is true if the current page is the last one (or the first one)
			onEndFlip : function(old, page, isLimit) { return false; },
			// callback before the flip transition
			// page is the current item´s index
			onBeforeFlip : function(page) { return false; }
		},
		_init : function() {
			// orientation class
			this.el.className += ' bb-' + this.options.orientation;
			// items
			this.items = Array.prototype.slice.call( this.el.querySelectorAll( '.bb-item' ) );
			// total items
			this.itemsCount = this.items.length;
			// current item´s index
			this.currentIdx = 0;
			// previous item´s index
			this.previous = -1;
			// show first item
			this.current = this.items[ this.currentIdx ];
			this.current.style.display = 'block';
			// get width of this.el
			// this will be necessary to create the flipping layout
			this.elWidth = this.el.offsetWidth;
			var transEndEventNames = {
				'WebkitTransition': 'webkitTransitionEnd',
				'MozTransition': 'transitionend',
				'OTransition': 'oTransitionEnd',
				'msTransition': 'MSTransitionEnd',
				'transition': 'transitionend'
			};
			this.transEndEventName = transEndEventNames[Modernizr.prefixed( 'transition' )];
			// support css 3d transforms && css transitions && Modernizr.csstransformspreserve3d
			this.support = Modernizr.csstransitions && Modernizr.csstransforms3d && Modernizr.csstransformspreserve3d;
			// initialize/bind some events
			this._initEvents();
			// start slideshow
			if ( this.options.autoplay ) {
				this.options.circular = true;
				this._startSlideshow();
			}
		},
		_initEvents : function() {

			var self = this;

			if ( this.options.nextEl !== '' ) {
				document.querySelector( this.options.nextEl ).addEventListener( 'click', function() { self._action( 'next' ); return false; } );
				document.querySelector( this.options.nextEl ).addEventListener( 'touchstart', function() { self._action( 'next' ); return false; } );
			}

			if ( this.options.prevEl !== '' ) {
				document.querySelector( this.options.prevEl ).addEventListener( 'click', function() { self._action( 'prev' ); return false; } );
				document.querySelector( this.options.prevEl ).addEventListener( 'touchstart', function() { self._action( 'prev' ); return false; } );
			}
			
			window.addEventListener( 'resize', function() { self._resizeHandler(); } );

		},
		_action : function( dir, page ) {
			this._stopSlideshow();
			this._navigate( dir, page );
		},
		_navigate : function( dir, page ) {

			if ( this.isAnimating ) {
				return false;
			}

			// callback trigger
			this.options.onBeforeFlip( this.currentIdx );

			this.isAnimating = true;
			// update current value
			this.current = this.items[ this.currentIdx ];

			if ( page !== undefined ) {
				this.currentIdx = page;
			}
			else if ( dir === 'next' && this.options.direction === 'ltr' || dir === 'prev' && this.options.direction === 'rtl' ) {
				if ( !this.options.circular && this.currentIdx === this.itemsCount - 1 ) {
					this.end = true;
				}
				else {
					this.previous = this.currentIdx;
					this.currentIdx = this.currentIdx < this.itemsCount - 1 ? this.currentIdx + 1 : 0;
				}
			}
			else if ( dir === 'prev' && this.options.direction === 'ltr' || dir === 'next' && this.options.direction === 'rtl' ) {
				if ( !this.options.circular && this.currentIdx === 0 ) {
					this.end = true;
				}
				else {
					this.previous = this.currentIdx;
					this.currentIdx = this.currentIdx > 0 ? this.currentIdx - 1 : this.itemsCount - 1;
				}
			}

			this.nextItem = !this.options.circular && this.end ? this.current : this.items[ this.currentIdx ];
			
			this.items.forEach( function( el, i ) { el.style.display = 'none'; } );
			if ( !this.support ) {
				this._layoutNoSupport( dir );
			} else {
				this._layout( dir );
			}

		},
		_layoutNoSupport : function(dir) {
			this.nextItem.style.display = 'block';
			this.end = false;
			this.isAnimating = false;
			var isLimit = dir === 'next' && this.currentIdx === this.itemsCount - 1 || dir === 'prev' && this.currentIdx === 0;
			// callback trigger
			this.options.onEndFlip( this.previous, this.currentIdx, isLimit );
		},
		// creates the necessary layout for the 3d structure and triggers the transitions
		_layout : function(dir) {

			var self = this,
				// basic structure: 1 element for the left side.
				s_left = this._addSide( 'left', dir ),
				// 1 element for the flipping/middle page
				s_middle = this._addSide( 'middle', dir ),
				// 1 element for the right side
				s_right = this._addSide( 'right', dir ),
				// overlays
				o_left = s_left.querySelector( 'div.bb-overlay' ),
				o_middle_f = s_middle.querySelector( 'div.bb-front' ).querySelector( 'div.bb-flipoverlay' ),
				o_middle_b = s_middle.querySelector( 'div.bb-back' ).querySelector( 'div.bb-flipoverlay' ),
				o_right = s_right.querySelector( 'div.bb-overlay' ),
				speed = this.end ? 400 : this.options.speed;

			var fChild = this.items[0];
			this.el.insertBefore( s_left, fChild );
			this.el.insertBefore( s_middle, fChild );
			this.el.insertBefore( s_right, fChild );
			s_left.style.zIndex = 102;
			s_middle.style.zIndex = 103;
			s_right.style.zIndex = 101;

			s_middle.style.transitionDuration = speed + 'ms';
			s_middle.style.transitionTimingFunction = this.options.easing;
			
			s_middle.addEventListener( this.transEndEventName, function( event ) {
				if ( (" " + event.target.className + " ").replace(/[\n\t]/g, " ").indexOf(" bb-page ") > -1 ) {
					Array.prototype.slice.call( self.el.querySelectorAll( '.bb-page' ) ).forEach( function( el, i ) {
						self.el.removeChild( el );
					} );
					self.nextItem.style.display = 'block';
					self.end = false;
					self.isAnimating = false;
					var isLimit = dir === 'next' && self.currentIdx === self.itemsCount - 1 || dir === 'prev' && self.currentIdx === 0;
					// callback trigger
					self.options.onEndFlip( self.previous, self.currentIdx, isLimit );
				}
			} );

			if ( dir === 'prev' ) {
				s_middle.className += ' bb-flip-initial';
			}

			// overlays
			if ( this.options.shadows && !this.end ) {
				if( dir === 'next' ) {
					o_middle_f.style.transition = 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear';
					o_middle_b.style.transition = 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear' + ' ' + this.options.speed / 2 + 'ms';
					o_middle_b.style.opacity = this.options.shadowFlip;
					o_left.style.transition = 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear' + ' ' + this.options.speed / 2 + 'ms';
					o_right.style.transition = 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear';
					o_right.style.opacity = this.options.shadowSides;
				}
				else if( dir === 'prev' ) {
					o_middle_f.style.transition = 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear' + ' ' + this.options.speed / 2 + 'ms';
					o_middle_f.style.opacity = this.options.shadowFlip;
					o_middle_b.style.transition = 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear';
					o_left.style.transition = 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear';
					o_left.style.opacity = this.options.shadowSides;
					o_right.style.transition = 'opacity ' + this.options.speed / 2 + 'ms ' + 'linear' + ' ' + this.options.speed / 2 + 'ms';
				}
			}

			setTimeout( function() {
				// first && last pages lift slightly up when we can't go further
				s_middle.className += self.end ? ' bb-flip-' + dir + '-end' : ' bb-flip-' + dir;

				// overlays
				if ( self.options.shadows && !self.end ) {
					o_middle_f.style.opacity = dir === 'next' ? self.options.shadowFlip : 0;
					o_middle_b.style.opacity = dir === 'next' ? 0 : self.options.shadowFlip;
					o_left.style.opacity = dir === 'next' ? self.options.shadowSides : 0;
					o_right.style.opacity = dir === 'next' ? 0 : self.options.shadowSides;
				}
			}, 25 );
		},
		// adds the necessary sides (bb-page) to the layout 
		_addSide : function( side, dir ) {
			var sideEl = document.createElement( 'div' );
			sideEl.className = 'bb-page';

			switch (side) {
				case 'left':
						/*
						<div class="bb-page" style="z-index:102;">
							<div class="bb-back">
								<div class="bb-outer">
									<div class="bb-content">
										<div class="bb-inner">
											dir==='next' ? [content of current page] : [content of next page]
										</div>
									</div>
									<div class="bb-overlay"></div>
								</div>
							</div>
						</div>
						*/
					var inner = dir === 'next' ? this.current.innerHTML : this.nextItem.innerHTML;
					sideEl.innerHTML = '<div class="bb-back"><div class="bb-outer"><div class="bb-content"><div class="bb-inner">' + inner + '</div></div><div class="bb-overlay"></div></div></div>';
					break;
				case 'middle':
						/*
						<div class="bb-page" style="z-index:103;">
							<div class="bb-front">
								<div class="bb-outer">
									<div class="bb-content">
										<div class="bb-inner">
											dir==='next' ? [content of current page] : [content of next page]
										</div>
									</div>
									<div class="bb-flipoverlay"></div>
								</div>
							</div>
							<div class="bb-back">
								<div class="bb-outer">
									<div class="bb-content">
										<div class="bb-inner">
											dir==='next' ? [content of next page] : [content of current page]
										</div>
									</div>
									<div class="bb-flipoverlay"></div>
								</div>
							</div>
						</div>
						*/
					var frontinner = dir === 'next' ? this.current.innerHTML : this.nextItem.innerHTML;
					var backinner = dir === 'next' ? this.nextItem.innerHTML : this.current.innerHTML; 
					sideEl.innerHTML = '<div class="bb-front"><div class="bb-outer"><div class="bb-content"><div class="bb-inner">' + frontinner + '</div></div><div class="bb-flipoverlay"></div></div></div><div class="bb-back"><div class="bb-outer"><div class="bb-content" style="width:' + this.elWidth + 'px"><div class="bb-inner">' + backinner + '</div></div><div class="bb-flipoverlay"></div></div></div>';
					break;
				case 'right':
						/*
						<div class="bb-page" style="z-index:101;">
							<div class="bb-front">
								<div class="bb-outer">
									<div class="bb-content">
										<div class="bb-inner">
											dir==='next' ? [content of next page] : [content of current page]
										</div>
									</div>
									<div class="bb-overlay"></div>
								</div>
							</div>
						</div>
						*/
					var inner = dir === 'next' ? this.nextItem.innerHTML : this.current.innerHTML;
					sideEl.innerHTML = '<div class="bb-front"><div class="bb-outer"><div class="bb-content"><div class="bb-inner">' + inner + '</div></div><div class="bb-overlay"></div></div></div>';
					break;
			}

			return sideEl;
		},
		_startSlideshow : function() {
			var self = this;
			this.slideshow = setTimeout( function() {
				self._navigate( 'next' );
				if ( self.options.autoplay ) {
					self._startSlideshow();
				}
			}, this.options.interval );
		},
		_stopSlideshow : function() {
			if ( this.options.autoplay ) {
				clearTimeout( this.slideshow );
				this.options.autoplay = false;
			}
		},
		// public method: flips next
		next : function() {
			this._action( this.options.direction === 'ltr' ? 'next' : 'prev' );
		},
		// public method: flips back
		prev : function() {
			this._action( this.options.direction === 'ltr' ? 'prev' : 'next' );
		},
		// public method: goes to a specific page
		jump : function( page ) {

			page -= 1;

			if ( page === this.currentIdx || page >= this.itemsCount || page < 0 ) {
				return false;
			}
			var dir;
			if( this.options.direction === 'ltr' ) {
				dir = page > this.currentIdx ? 'next' : 'prev';
			}
			else {
				dir = page > this.currentIdx ? 'prev' : 'next';
			}
			this._action( dir, page );

		},
		// public method: goes to the last page
		last : function() {
			this.jump( this.itemsCount );
		},
		// public method: goes to the first page
		first : function() {
			this.jump( 1 );
		},
		// taken from https://github.com/desandro/vanilla-masonry/blob/master/masonry.js by David DeSandro
		// original debounce by John Hann
    	// http://unscriptable.com/index.php/2009/03/20/debouncing-javascript-methods/
		_resizeHandler : function() {
			var self = this;
			function delayed() {
				self._resize();
				self._resizeTimeout = null;
			}
			if ( this._resizeTimeout ) {
				clearTimeout( this._resizeTimeout );
			}
			this._resizeTimeout = setTimeout( delayed, 50 );
		},
		_resize : function() {
			// update width value
			this.elWidth = this.el.offsetWidth;
		},
		// public method: check if isAnimating is true
		isActive: function() {
			return this.isAnimating;
		},
		// public method: dynamically adds new elements
		// call this method after inserting new "bb-item" elements inside the BookBlock
		update : function () {
			var currentItem = this.items[ this.current ];
			this.items = Array.prototype.slice.call( this.el.querySelectorAll( '.bb-item' ) );
			this.itemsCount = this.items.length;
			this.currentIdx = this.items.indexOf( currentItem );
		},
		destroy : function() {
			if ( this.options.autoplay ) {
				this._stopSlideshow();
			}
			this.el.className = this.el.className.replace(new RegExp("(^|\\s+)" + 'bb-' + this.options.orientation + "(\\s+|$)"), ' ');
			this.items.forEach( function( el, i ) { el.style.display = 'block'; } );

			if ( this.options.nextEl !== '' ) {
				this.options.nextEl.removeEventListener( 'click' );
				this.options.nextEl.removeEventListener( 'touchstart' );
			}

			if ( this.options.prevEl !== '' ) {
				this.options.prevEl.removeEventListener( 'click' );
				this.options.prevEl.removeEventListener( 'touchstart' );
			}

			window.removeEventListener( 'debouncedresize' );
		}
	}

	// add to global namespace
	window.BookBlock = BookBlock;

} )( window );
(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('editorApp')
        .factory('Base64Image', Base64Image);

    function Base64Image () {
        

        var service = {
            getSize: getSize,
            getMimeType: getMimeType,
            compress: compress
        };

        return service;

        function getSize(data) {
            if (!data) {
                return 0;
            }
            var start = 0;
            var end = data.length;
            var pos = data.indexOf(';base64,');

            if (pos > 0) {
                start = pos + 8;
            }
            pos = data.indexOf("=");
            if (pos > 0) {
                end = pos;
            }

            var len = end - start;
            return parseInt(len - (len/8) * 2);
        }

        function getMimeType(data) {
            var arr = data.split(',');
            var mime = arr[0].match(/:(.*?);/)[1];
            // return mime.replace("image/", "");
            return mime;
        }

        function compress(data, length, quality, callback) {
            var getMimeType = function (urlData) {
                var arr = urlData.split(',');
                var mime = arr[0].match(/:(.*?);/)[1];
                // return mime.replace("image/", "");
                return mime;
            };

            var quality_value = quality || 0.6;
            var newImage = new Image();
            var imgWidth, imgHeight;

            newImage.src = data;
            newImage.setAttribute("crossOrigin", 'Anonymous');  //url为外域时需要
            newImage.onload = function() {
                imgWidth = this.width;
                imgHeight = this.height;
                var canvas = document.createElement("canvas");
                var ctx = canvas.getContext("2d");
                if (Math.max(imgWidth, imgHeight) > length) {
                    if (imgWidth > imgHeight) {
                        canvas.width = length;
                        canvas.height = length * imgHeight / imgWidth;
                    } else {
                        canvas.height = length;
                        canvas.width = length * imgWidth / imgHeight;
                    }
                } else {
                    canvas.width = imgWidth;
                    canvas.height = imgHeight;
                }
                // 覆盖默认填充颜色 (#000)
                var fillStyle = '#fff';
                ctx.fillStyle = fillStyle;
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                ctx.drawImage(this, 0, 0, canvas.width, canvas.height);
                var base64 = canvas.toDataURL("image/jpeg", quality_value); //压缩语句

                if (callback) {
                    callback(base64);
                }
            }
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('editorApp')
        .factory('Base64', Base64)
        .factory('Md5', Md5);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
    function Md5 () {
        var hexcase = 0;  /* hex output format. 0 - lowercase; 1 - uppercase        */
        var b64pad  = ""; /* base-64 pad character. "=" for strict RFC compliance   */
        var chrsz   = 8;  /* bits per input character. 8 - ASCII; 16 - Unicode      */
        /**
         * 供外部调用的方法
         */
        var hex_md5 = function(s) {
            return binl2hex(core_md5(str2binl(s), s.length * chrsz));
        }

        return {
            hex_md5: hex_md5
        }

        /*
         * Calculate the MD5 of an array of little-endian words, and a bit length
         */
        function core_md5(x, len) {
            /* append padding */
            x[len >> 5] |= 0x80 << ((len) % 32);
            x[(((len + 64) >>> 9) << 4) + 14] = len;
            var a =  1732584193;
            var b = -271733879;
            var c = -1732584194;
            var d =  271733878;
            for(var i = 0; i < x.length; i += 16)
            {
                var olda = a;
                var oldb = b;
                var oldc = c;
                var oldd = d;
                a = md5_ff(a, b, c, d, x[i+ 0], 7 , -680876936);
                d = md5_ff(d, a, b, c, x[i+ 1], 12, -389564586);
                c = md5_ff(c, d, a, b, x[i+ 2], 17,  606105819);
                b = md5_ff(b, c, d, a, x[i+ 3], 22, -1044525330);
                a = md5_ff(a, b, c, d, x[i+ 4], 7 , -176418897);
                d = md5_ff(d, a, b, c, x[i+ 5], 12,  1200080426);
                c = md5_ff(c, d, a, b, x[i+ 6], 17, -1473231341);
                b = md5_ff(b, c, d, a, x[i+ 7], 22, -45705983);
                a = md5_ff(a, b, c, d, x[i+ 8], 7 ,  1770035416);
                d = md5_ff(d, a, b, c, x[i+ 9], 12, -1958414417);
                c = md5_ff(c, d, a, b, x[i+10], 17, -42063);
                b = md5_ff(b, c, d, a, x[i+11], 22, -1990404162);
                a = md5_ff(a, b, c, d, x[i+12], 7 ,  1804603682);
                d = md5_ff(d, a, b, c, x[i+13], 12, -40341101);
                c = md5_ff(c, d, a, b, x[i+14], 17, -1502002290);
                b = md5_ff(b, c, d, a, x[i+15], 22,  1236535329);
                a = md5_gg(a, b, c, d, x[i+ 1], 5 , -165796510);
                d = md5_gg(d, a, b, c, x[i+ 6], 9 , -1069501632);
                c = md5_gg(c, d, a, b, x[i+11], 14,  643717713);
                b = md5_gg(b, c, d, a, x[i+ 0], 20, -373897302);
                a = md5_gg(a, b, c, d, x[i+ 5], 5 , -701558691);
                d = md5_gg(d, a, b, c, x[i+10], 9 ,  38016083);
                c = md5_gg(c, d, a, b, x[i+15], 14, -660478335);
                b = md5_gg(b, c, d, a, x[i+ 4], 20, -405537848);
                a = md5_gg(a, b, c, d, x[i+ 9], 5 ,  568446438);
                d = md5_gg(d, a, b, c, x[i+14], 9 , -1019803690);
                c = md5_gg(c, d, a, b, x[i+ 3], 14, -187363961);
                b = md5_gg(b, c, d, a, x[i+ 8], 20,  1163531501);
                a = md5_gg(a, b, c, d, x[i+13], 5 , -1444681467);
                d = md5_gg(d, a, b, c, x[i+ 2], 9 , -51403784);
                c = md5_gg(c, d, a, b, x[i+ 7], 14,  1735328473);
                b = md5_gg(b, c, d, a, x[i+12], 20, -1926607734);
                a = md5_hh(a, b, c, d, x[i+ 5], 4 , -378558);
                d = md5_hh(d, a, b, c, x[i+ 8], 11, -2022574463);
                c = md5_hh(c, d, a, b, x[i+11], 16,  1839030562);
                b = md5_hh(b, c, d, a, x[i+14], 23, -35309556);
                a = md5_hh(a, b, c, d, x[i+ 1], 4 , -1530992060);
                d = md5_hh(d, a, b, c, x[i+ 4], 11,  1272893353);
                c = md5_hh(c, d, a, b, x[i+ 7], 16, -155497632);
                b = md5_hh(b, c, d, a, x[i+10], 23, -1094730640);
                a = md5_hh(a, b, c, d, x[i+13], 4 ,  681279174);
                d = md5_hh(d, a, b, c, x[i+ 0], 11, -358537222);
                c = md5_hh(c, d, a, b, x[i+ 3], 16, -722521979);
                b = md5_hh(b, c, d, a, x[i+ 6], 23,  76029189);
                a = md5_hh(a, b, c, d, x[i+ 9], 4 , -640364487);
                d = md5_hh(d, a, b, c, x[i+12], 11, -421815835);
                c = md5_hh(c, d, a, b, x[i+15], 16,  530742520);
                b = md5_hh(b, c, d, a, x[i+ 2], 23, -995338651);
                a = md5_ii(a, b, c, d, x[i+ 0], 6 , -198630844);
                d = md5_ii(d, a, b, c, x[i+ 7], 10,  1126891415);
                c = md5_ii(c, d, a, b, x[i+14], 15, -1416354905);
                b = md5_ii(b, c, d, a, x[i+ 5], 21, -57434055);
                a = md5_ii(a, b, c, d, x[i+12], 6 ,  1700485571);
                d = md5_ii(d, a, b, c, x[i+ 3], 10, -1894986606);
                c = md5_ii(c, d, a, b, x[i+10], 15, -1051523);
                b = md5_ii(b, c, d, a, x[i+ 1], 21, -2054922799);
                a = md5_ii(a, b, c, d, x[i+ 8], 6 ,  1873313359);
                d = md5_ii(d, a, b, c, x[i+15], 10, -30611744);
                c = md5_ii(c, d, a, b, x[i+ 6], 15, -1560198380);
                b = md5_ii(b, c, d, a, x[i+13], 21,  1309151649);
                a = md5_ii(a, b, c, d, x[i+ 4], 6 , -145523070);
                d = md5_ii(d, a, b, c, x[i+11], 10, -1120210379);
                c = md5_ii(c, d, a, b, x[i+ 2], 15,  718787259);
                b = md5_ii(b, c, d, a, x[i+ 9], 21, -343485551);
                a = safe_add(a, olda);
                b = safe_add(b, oldb);
                c = safe_add(c, oldc);
                d = safe_add(d, oldd);
            }
            return Array(a, b, c, d);
        }
        function md5_cmn(q, a, b, x, s, t) {
            return safe_add(bit_rol(safe_add(safe_add(a, q), safe_add(x, t)), s), b);
        }
        function md5_ff(a, b, c, d, x, s, t) {
            return md5_cmn((b & c) | ((~b) & d), a, b, x, s, t);
        }
        function md5_gg(a, b, c, d, x, s, t) {
            return md5_cmn((b & d) | (c & (~d)), a, b, x, s, t);
        }
        function md5_hh(a, b, c, d, x, s, t) {
            return md5_cmn(b ^ c ^ d, a, b, x, s, t);
        }
        function md5_ii(a, b, c, d, x, s, t) {
            return md5_cmn(c ^ (b | (~d)), a, b, x, s, t);
        }
        /*
         * Calculate the HMAC-MD5, of a key and some data
         */
        function core_hmac_md5(key, data) {
            var bkey = str2binl(key);
            if (bkey.length > 16) bkey = core_md5(bkey, key.length * chrsz);
            var ipad = Array(16),
                opad = Array(16);
            for (var i = 0; i < 16; i++) {
                ipad[i] = bkey[i] ^ 0x36363636;
                opad[i] = bkey[i] ^ 0x5C5C5C5C;
            }
            var hash = core_md5(ipad.concat(str2binl(data)), 512 + data.length * chrsz);
            return core_md5(opad.concat(hash), 512 + 128);
        }
        /*
         * Add integers, wrapping at 2^32. This uses 16-bit operations internally
         * to work around bugs in some JS interpreters.
         */
        function safe_add(x, y) {
            var lsw = (x & 0xFFFF) + (y & 0xFFFF);
            var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
            return (msw << 16) | (lsw & 0xFFFF);
        }
        /*
         * Bitwise rotate a 32-bit number to the left.
         */
        function bit_rol(num, cnt) {
            return (num << cnt) | (num >>> (32 - cnt));
        }
        /*
         * Convert a string to an array of little-endian words
         * If chrsz is ASCII, characters >255 have their hi-byte silently ignored.
         */
        function str2binl(str) {
            var bin = Array();
            var mask = (1 << chrsz) - 1;
            for (var i = 0; i < str.length * chrsz; i += chrsz)
                bin[i >> 5] |= (str.charCodeAt(i / chrsz) & mask) << (i % 32);
            return bin;
        }
        /*
         * Convert an array of little-endian words to a string
         */
        function binl2str(bin) {
            var str = "";
            var mask = (1 << chrsz) - 1;
            for (var i = 0; i < bin.length * 32; i += chrsz)
                str += String.fromCharCode((bin[i >> 5] >>> (i % 32)) & mask);
            return str;
        }
        /*
         * Convert an array of little-endian words to a hex string.
         */
        function binl2hex(binarray) {
            var hex_tab = hexcase ? "0123456789ABCDEF" : "0123456789abcdef";
            var str = "";
            for (var i = 0; i < binarray.length * 4; i++) {
                str += hex_tab.charAt((binarray[i >> 2] >> ((i % 4) * 8 + 4)) & 0xF) + hex_tab.charAt((binarray[i >> 2] >> ((i % 4) * 8)) & 0xF);
            }
            return str;
        }
        /*
         * Convert an array of little-endian words to a base-64 string
         */
        function binl2b64(binarray) {
            var tab = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
            var str = "";
            for (var i = 0; i < binarray.length * 4; i += 3) {
                var triplet = (((binarray[i >> 2] >> 8 * (i % 4)) & 0xFF) << 16) | (((binarray[i + 1 >> 2] >> 8 * ((i + 1) % 4)) & 0xFF) << 8) | ((binarray[i + 2 >> 2] >> 8 * ((i + 2) % 4)) & 0xFF);
                for (var j = 0; j < 4; j++) {
                    if (i * 8 + j * 6 > binarray.length * 32) str += b64pad;
                    else str += tab.charAt((triplet >> 6 * (3 - j)) & 0x3F);
                }
            }
            return str;
        }
    }
})();

'use strict';

/**
 * angular.throttle function
 * Big thanks to _.throttle which was mainly reused.
 */
(function (angular) {
	
	var throttle = function (func, wait, options) {

    options || (options = {});

    var context, args, result;
    var timeout = null;
    var previous = 0;

    var later = function() {
      previous = options.leading === false ? 0 : (new Date().getTime());
      timeout = null;
      result = func.apply(context, args);
      context = args = null;
    };

    return function() {

      var now = (new Date().getTime());

      if (!previous && options.leading === false) {
        previous = now;
      } 

      var remaining = wait - (now - previous);

      context = this;
      args = arguments;

      if (remaining <= 0) {

        clearTimeout(timeout);
        timeout = null;
        previous = now;
        result = func.apply(context, args);
        context = args = null;
      } else if (!timeout && options.trailing !== false) {

        timeout = setTimeout(later, remaining);
      }

      return result;
    };

	};

	angular.extend(angular, {
		throttle: throttle
	})

} (angular));
(function() {
    'use strict';

    angular
        .module('editorApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance', '$stateParams', "$cookieStore"];

    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance, $stateParams, $cookieStore) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.storeId = $stateParams.storeId || $cookieStore.get("store-id");
        if (!vm.storeId) {
            return;
        }
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home', {storeId:vm.storeId});
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is successful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('editorApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');
            deferred.resolve(language);
            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .filter('findLanguageFromKey', findLanguageFromKey)
        .filter('findLanguageRtlFromKey', findLanguageRtlFromKey);

    var languages = {
        'zh-cn': { name: '中文（简体）' },
        'en': { name: 'English' }
        // jhipster-needle-i18n-language-key-pipe - JHipster will add/remove languages in this object
    };

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return languages[lang].name;
        }
    }

    function findLanguageRtlFromKey() {
        return findLanguageRtlFromKeyFilter;

        function findLanguageRtlFromKeyFilter(lang) {
            return languages[lang].rtl;
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale', '$localStorage'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale, $localStorage) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = $localStorage.languages;
        // JhiLanguageService.getAll().then(function (languages) {
        //     vm.languages = languages;
        // });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('editorApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'en',
            'zh-cn'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('editorApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('editorApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var headers = Object.keys(httpResponse.headers()).filter(function (header) {
                    return header.indexOf('app-error', header.length - 'app-error'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var errorHeader = httpResponse.headers(headers[0]);
                var entityKey = httpResponse.headers(headers[1]);
                if (angular.isString(errorHeader)) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('editorApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('editorApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var headers = Object.keys(response.headers()).filter(function (header) {
                return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
            }).sort();
            var alertKey = response.headers(headers[0]);
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers(headers[1])});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('editorApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                delete $localStorage.user;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            if (!config || !config.url || /^http/.test(config.url)) return config;

            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
            }
            return config;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }


        // update the window title using params in the following
        // precedence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('editorApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES', '$localStorage','$injector'];

    function translationStorageProvider($cookies, $log, LANGUAGES, $localStorage,$injector) {
        return {
            get: get,
            put: put,
            getLanguageType: getLanguageType
        };

        function get(name) {
            if (name == 'NG_TRANSLATE_LANG_KEY' && $localStorage.lagnuages && $localStorage.lagnuages.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to preferred language "en"');
                var lang = navigator.language;
                if ($localStorage.store) {
                    if (!$localStorage.store.availableLangKey || $localStorage.store.availableLangKey.indexOf(lang)<0) {
                        lang = $localStorage.store.defaultLangKey;
                    }
                }
                var result = getLanguageType(lang);
                if (!!result) {
                    lang = result.value;
                }
                if (!!lang) {
                    $cookies.putObject(name, lang);
                }
            }
            var value =  $cookies.getObject(name);
            if (value == 'zh' ||!value) {
                value = 'zh-cn';
            }
            return value;
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }

        function getLanguageType(key){
            var defaultValue = {key: $injector.get('$translate').instant("language.zh-cn"), value: "zh-cn"};
            if (key == null) {
                return defaultValue;
            }
            var allLanguages = [
                {key: $injector.get('$translate').instant("language.zh-cn"), value: "zh-cn"},
                {key: $injector.get('$translate').instant("language.en"), value: "en"},
                {key: $injector.get('$translate').instant("language.zh-tw"), value: "zh-tw"},
                {key: $injector.get('$translate').instant("language.ja"), value: "ja"},
                {key: $injector.get('$translate').instant("language.ko"), value: "ko"},
                {key: $injector.get('$translate').instant("language.Deutsch"), value: "Deutsch"}
            ]
            key = key.toLowerCase();
            for (var i = allLanguages.length - 1; i >= 0; i--) {
                var l = allLanguages[i];
                if (l.value.toLowerCase() ==key) {
                    return l;
                }
            }
            if (key.indexOf("_")>0) {
                key = key.split("_")[0];
            }else if(key.indexOf("-")>0){
                key = key.split("-")[0];
            }
            for (var i =0; i<allLanguages.length; i++) {
                var l = allLanguages[i];
                if (key.indexOf(l.value.toLowerCase())>=0) {
                    return l;
                }
            }
            return defaultValue;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider', "BUILD_TIMESTAMP"];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider, BUILD_TIMESTAMP) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json?v=' + (BUILD_TIMESTAMP || "")
        });

        // $translateProvider.preferredLanguage('zh-cn');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();

/**!
 * Sortable 1.10.1
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
        typeof define === 'function' && define.amd ? define(factory) :
            (global = global || self, global.Sortable = factory());
}(this, function () { 'use strict';

    function _typeof(obj) {
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
            _typeof = function (obj) {
                return typeof obj;
            };
        } else {
            _typeof = function (obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
        }

        return _typeof(obj);
    }

    function _defineProperty(obj, key, value) {
        if (key in obj) {
            Object.defineProperty(obj, key, {
                value: value,
                enumerable: true,
                configurable: true,
                writable: true
            });
        } else {
            obj[key] = value;
        }

        return obj;
    }

    function _extends() {
        _extends = Object.assign || function (target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];

                    for (var key in source) {
                        if (Object.prototype.hasOwnProperty.call(source, key)) {
                            target[key] = source[key];
                        }
                    }
                }

                return target;
            };

        return _extends.apply(this, arguments);
    }

    function _objectSpread(target) {
        for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i] != null ? arguments[i] : {};
            var ownKeys = Object.keys(source);

            if (typeof Object.getOwnPropertySymbols === 'function') {
                ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
                    return Object.getOwnPropertyDescriptor(source, sym).enumerable;
                }));
            }

            ownKeys.forEach(function (key) {
                _defineProperty(target, key, source[key]);
            });
        }

        return target;
    }

    function _objectWithoutPropertiesLoose(source, excluded) {
        if (source == null) return {};
        var target = {};
        var sourceKeys = Object.keys(source);
        var key, i;

        for (i = 0; i < sourceKeys.length; i++) {
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            target[key] = source[key];
        }

        return target;
    }

    function _objectWithoutProperties(source, excluded) {
        if (source == null) return {};

        var target = _objectWithoutPropertiesLoose(source, excluded);

        var key, i;

        if (Object.getOwnPropertySymbols) {
            var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

            for (i = 0; i < sourceSymbolKeys.length; i++) {
                key = sourceSymbolKeys[i];
                if (excluded.indexOf(key) >= 0) continue;
                if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
                target[key] = source[key];
            }
        }

        return target;
    }

    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
    }

    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) {
            for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

            return arr2;
        }
    }

    function _iterableToArray(iter) {
        if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
    }

    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
    }

    var version = "1.10.1";

    function userAgent(pattern) {
        if (typeof window !== 'undefined' && window.navigator) {
            return !!
                /*@__PURE__*/
                navigator.userAgent.match(pattern);
        }
    }

    var IE11OrLess = userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
    var Edge = userAgent(/Edge/i);
    var FireFox = userAgent(/firefox/i);
    var Safari = userAgent(/safari/i) && !userAgent(/chrome/i) && !userAgent(/android/i);
    var IOS = userAgent(/iP(ad|od|hone)/i);
    var ChromeForAndroid = userAgent(/chrome/i) && userAgent(/android/i);

    var captureMode = {
        capture: false,
        passive: false
    };

    function on(el, event, fn) {
        el.addEventListener(event, fn, !IE11OrLess && captureMode);
    }

    function off(el, event, fn) {
        el.removeEventListener(event, fn, !IE11OrLess && captureMode);
    }

    function matches(
        /**HTMLElement*/
        el,
        /**String*/
        selector) {
        if (!selector) return;
        selector[0] === '>' && (selector = selector.substring(1));

        if (el) {
            try {
                if (el.matches) {
                    return el.matches(selector);
                } else if (el.msMatchesSelector) {
                    return el.msMatchesSelector(selector);
                } else if (el.webkitMatchesSelector) {
                    return el.webkitMatchesSelector(selector);
                }
            } catch (_) {
                return false;
            }
        }

        return false;
    }

    function getParentOrHost(el) {
        return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
    }

    function closest(
        /**HTMLElement*/
        el,
        /**String*/
        selector,
        /**HTMLElement*/
        ctx, includeCTX) {
        if (el) {
            ctx = ctx || document;

            do {
                if (selector != null && (selector[0] === '>' ? el.parentNode === ctx && matches(el, selector) : matches(el, selector)) || includeCTX && el === ctx) {
                    return el;
                }

                if (el === ctx) break;
                /* jshint boss:true */
            } while (el = getParentOrHost(el));
        }

        return null;
    }

    var R_SPACE = /\s+/g;

    function toggleClass(el, name, state) {
        if (el && name) {
            if (el.classList) {
                el.classList[state ? 'add' : 'remove'](name);
            } else {
                var className = (' ' + el.className + ' ').replace(R_SPACE, ' ').replace(' ' + name + ' ', ' ');
                el.className = (className + (state ? ' ' + name : '')).replace(R_SPACE, ' ');
            }
        }
    }

    function css(el, prop, val) {
        var style = el && el.style;

        if (style) {
            if (val === void 0) {
                if (document.defaultView && document.defaultView.getComputedStyle) {
                    val = document.defaultView.getComputedStyle(el, '');
                } else if (el.currentStyle) {
                    val = el.currentStyle;
                }

                return prop === void 0 ? val : val[prop];
            } else {
                if (!(prop in style) && prop.indexOf('webkit') === -1) {
                    prop = '-webkit-' + prop;
                }

                style[prop] = val + (typeof val === 'string' ? '' : 'px');
            }
        }
    }

    function matrix(el, selfOnly) {
        var appliedTransforms = '';

        if (typeof el === 'string') {
            appliedTransforms = el;
        } else {
            do {
                var transform = css(el, 'transform');

                if (transform && transform !== 'none') {
                    appliedTransforms = transform + ' ' + appliedTransforms;
                }
                /* jshint boss:true */

            } while (!selfOnly && (el = el.parentNode));
        }

        var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix;
        /*jshint -W056 */

        return matrixFn && new matrixFn(appliedTransforms);
    }

    function find(ctx, tagName, iterator) {
        if (ctx) {
            var list = ctx.getElementsByTagName(tagName),
                i = 0,
                n = list.length;

            if (iterator) {
                for (; i < n; i++) {
                    iterator(list[i], i);
                }
            }

            return list;
        }

        return [];
    }

    function getWindowScrollingElement() {
        if (IE11OrLess) {
            return document.documentElement;
        } else {
            return document.scrollingElement;
        }
    }
    /**
     * Returns the "bounding client rect" of given element
     * @param  {HTMLElement} el                       The element whose boundingClientRect is wanted
     * @param  {[Boolean]} relativeToContainingBlock  Whether the rect should be relative to the containing block of (including) the container
     * @param  {[Boolean]} relativeToNonStaticParent  Whether the rect should be relative to the relative parent of (including) the contaienr
     * @param  {[Boolean]} undoScale                  Whether the container's scale() should be undone
     * @param  {[HTMLElement]} container              The parent the element will be placed in
     * @return {Object}                               The boundingClientRect of el, with specified adjustments
     */


    function getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
        if (!el.getBoundingClientRect && el !== window) return;
        var elRect, top, left, bottom, right, height, width;

        if (el !== window && el !== getWindowScrollingElement()) {
            elRect = el.getBoundingClientRect();
            top = elRect.top;
            left = elRect.left;
            bottom = elRect.bottom;
            right = elRect.right;
            height = elRect.height;
            width = elRect.width;
        } else {
            top = 0;
            left = 0;
            bottom = window.innerHeight;
            right = window.innerWidth;
            height = window.innerHeight;
            width = window.innerWidth;
        }

        if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
            // Adjust for translate()
            container = container || el.parentNode; // solves #1123 (see: https://stackoverflow.com/a/37953806/6088312)
            // Not needed on <= IE11

            if (!IE11OrLess) {
                do {
                    if (container && container.getBoundingClientRect && (css(container, 'transform') !== 'none' || relativeToNonStaticParent && css(container, 'position') !== 'static')) {
                        var containerRect = container.getBoundingClientRect(); // Set relative to edges of padding box of container

                        top -= containerRect.top + parseInt(css(container, 'border-top-width'));
                        left -= containerRect.left + parseInt(css(container, 'border-left-width'));
                        bottom = top + elRect.height;
                        right = left + elRect.width;
                        break;
                    }
                    /* jshint boss:true */

                } while (container = container.parentNode);
            }
        }

        if (undoScale && el !== window) {
            // Adjust for scale()
            var elMatrix = matrix(container || el),
                scaleX = elMatrix && elMatrix.a,
                scaleY = elMatrix && elMatrix.d;

            if (elMatrix) {
                top /= scaleY;
                left /= scaleX;
                width /= scaleX;
                height /= scaleY;
                bottom = top + height;
                right = left + width;
            }
        }

        return {
            top: top,
            left: left,
            bottom: bottom,
            right: right,
            width: width,
            height: height
        };
    }
    /**
     * Checks if a side of an element is scrolled past a side of its parents
     * @param  {HTMLElement}  el           The element who's side being scrolled out of view is in question
     * @param  {String}       elSide       Side of the element in question ('top', 'left', 'right', 'bottom')
     * @param  {String}       parentSide   Side of the parent in question ('top', 'left', 'right', 'bottom')
     * @return {HTMLElement}               The parent scroll element that the el's side is scrolled past, or null if there is no such element
     */


    function isScrolledPast(el, elSide, parentSide) {
        var parent = getParentAutoScrollElement(el, true),
            elSideVal = getRect(el)[elSide];
        /* jshint boss:true */

        while (parent) {
            var parentSideVal = getRect(parent)[parentSide],
                visible = void 0;

            if (parentSide === 'top' || parentSide === 'left') {
                visible = elSideVal >= parentSideVal;
            } else {
                visible = elSideVal <= parentSideVal;
            }

            if (!visible) return parent;
            if (parent === getWindowScrollingElement()) break;
            parent = getParentAutoScrollElement(parent, false);
        }

        return false;
    }
    /**
     * Gets nth child of el, ignoring hidden children, sortable's elements (does not ignore clone if it's visible)
     * and non-draggable elements
     * @param  {HTMLElement} el       The parent element
     * @param  {Number} childNum      The index of the child
     * @param  {Object} options       Parent Sortable's options
     * @return {HTMLElement}          The child at index childNum, or null if not found
     */


    function getChild(el, childNum, options) {
        var currentChild = 0,
            i = 0,
            children = el.children;

        while (i < children.length) {
            if (children[i].style.display !== 'none' && children[i] !== Sortable.ghost && children[i] !== Sortable.dragged && closest(children[i], options.draggable, el, false)) {
                if (currentChild === childNum) {
                    return children[i];
                }

                currentChild++;
            }

            i++;
        }

        return null;
    }
    /**
     * Gets the last child in the el, ignoring ghostEl or invisible elements (clones)
     * @param  {HTMLElement} el       Parent element
     * @param  {selector} selector    Any other elements that should be ignored
     * @return {HTMLElement}          The last child, ignoring ghostEl
     */


    function lastChild(el, selector) {
        var last = el.lastElementChild;

        while (last && (last === Sortable.ghost || css(last, 'display') === 'none' || selector && !matches(last, selector))) {
            last = last.previousElementSibling;
        }

        return last || null;
    }
    /**
     * Returns the index of an element within its parent for a selected set of
     * elements
     * @param  {HTMLElement} el
     * @param  {selector} selector
     * @return {number}
     */


    function index(el, selector) {
        var index = 0;

        if (!el || !el.parentNode) {
            return -1;
        }
        /* jshint boss:true */


        while (el = el.previousElementSibling) {
            if (el.nodeName.toUpperCase() !== 'TEMPLATE' && el !== Sortable.clone && (!selector || matches(el, selector))) {
                index++;
            }
        }

        return index;
    }
    /**
     * Returns the scroll offset of the given element, added with all the scroll offsets of parent elements.
     * The value is returned in real pixels.
     * @param  {HTMLElement} el
     * @return {Array}             Offsets in the format of [left, top]
     */


    function getRelativeScrollOffset(el) {
        var offsetLeft = 0,
            offsetTop = 0,
            winScroller = getWindowScrollingElement();

        if (el) {
            do {
                var elMatrix = matrix(el),
                    scaleX = elMatrix.a,
                    scaleY = elMatrix.d;
                offsetLeft += el.scrollLeft * scaleX;
                offsetTop += el.scrollTop * scaleY;
            } while (el !== winScroller && (el = el.parentNode));
        }

        return [offsetLeft, offsetTop];
    }
    /**
     * Returns the index of the object within the given array
     * @param  {Array} arr   Array that may or may not hold the object
     * @param  {Object} obj  An object that has a key-value pair unique to and identical to a key-value pair in the object you want to find
     * @return {Number}      The index of the object in the array, or -1
     */


    function indexOfObject(arr, obj) {
        for (var i in arr) {
            if (!arr.hasOwnProperty(i)) continue;

            for (var key in obj) {
                if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
            }
        }

        return -1;
    }

    function getParentAutoScrollElement(el, includeSelf) {
        // skip to window
        if (!el || !el.getBoundingClientRect) return getWindowScrollingElement();
        var elem = el;
        var gotSelf = false;

        do {
            // we don't need to get elem css if it isn't even overflowing in the first place (performance)
            if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
                var elemCSS = css(elem);

                if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == 'auto' || elemCSS.overflowX == 'scroll') || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == 'auto' || elemCSS.overflowY == 'scroll')) {
                    if (!elem.getBoundingClientRect || elem === document.body) return getWindowScrollingElement();
                    if (gotSelf || includeSelf) return elem;
                    gotSelf = true;
                }
            }
            /* jshint boss:true */

        } while (elem = elem.parentNode);

        return getWindowScrollingElement();
    }

    function extend(dst, src) {
        if (dst && src) {
            for (var key in src) {
                if (src.hasOwnProperty(key)) {
                    dst[key] = src[key];
                }
            }
        }

        return dst;
    }

    function isRectEqual(rect1, rect2) {
        return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
    }

    var _throttleTimeout;

    function throttle(callback, ms) {
        return function () {
            if (!_throttleTimeout) {
                var args = arguments,
                    _this = this;

                if (args.length === 1) {
                    callback.call(_this, args[0]);
                } else {
                    callback.apply(_this, args);
                }

                _throttleTimeout = setTimeout(function () {
                    _throttleTimeout = void 0;
                }, ms);
            }
        };
    }

    function cancelThrottle() {
        clearTimeout(_throttleTimeout);
        _throttleTimeout = void 0;
    }

    function scrollBy(el, x, y) {
        el.scrollLeft += x;
        el.scrollTop += y;
    }

    function clone(el) {
        var Polymer = window.Polymer;
        var $ = window.jQuery || window.Zepto;

        if (Polymer && Polymer.dom) {
            return Polymer.dom(el).cloneNode(true);
        } else if ($) {
            return $(el).clone(true)[0];
        } else {
            return el.cloneNode(true);
        }
    }

    function setRect(el, rect) {
        css(el, 'position', 'absolute');
        css(el, 'top', rect.top);
        css(el, 'left', rect.left);
        css(el, 'width', rect.width);
        css(el, 'height', rect.height);
    }

    function unsetRect(el) {
        css(el, 'position', '');
        css(el, 'top', '');
        css(el, 'left', '');
        css(el, 'width', '');
        css(el, 'height', '');
    }

    var expando = 'Sortable' + new Date().getTime();

    function AnimationStateManager() {
        var animationStates = [],
            animationCallbackId;
        return {
            captureAnimationState: function captureAnimationState() {
                animationStates = [];
                if (!this.options.animation) return;
                var children = [].slice.call(this.el.children);
                children.forEach(function (child) {
                    if (css(child, 'display') === 'none' || child === Sortable.ghost) return;
                    animationStates.push({
                        target: child,
                        rect: getRect(child)
                    });

                    var fromRect = _objectSpread({}, animationStates[animationStates.length - 1].rect); // If animating: compensate for current animation


                    if (child.thisAnimationDuration) {
                        var childMatrix = matrix(child, true);

                        if (childMatrix) {
                            fromRect.top -= childMatrix.f;
                            fromRect.left -= childMatrix.e;
                        }
                    }

                    child.fromRect = fromRect;
                });
            },
            addAnimationState: function addAnimationState(state) {
                animationStates.push(state);
            },
            removeAnimationState: function removeAnimationState(target) {
                animationStates.splice(indexOfObject(animationStates, {
                    target: target
                }), 1);
            },
            animateAll: function animateAll(callback) {
                var _this = this;

                if (!this.options.animation) {
                    clearTimeout(animationCallbackId);
                    if (typeof callback === 'function') callback();
                    return;
                }

                var animating = false,
                    animationTime = 0;
                animationStates.forEach(function (state) {
                    var time = 0,
                        target = state.target,
                        fromRect = target.fromRect,
                        toRect = getRect(target),
                        prevFromRect = target.prevFromRect,
                        prevToRect = target.prevToRect,
                        animatingRect = state.rect,
                        targetMatrix = matrix(target, true);

                    if (targetMatrix) {
                        // Compensate for current animation
                        toRect.top -= targetMatrix.f;
                        toRect.left -= targetMatrix.e;
                    }

                    target.toRect = toRect;

                    if (target.thisAnimationDuration) {
                        // Could also check if animatingRect is between fromRect and toRect
                        if (isRectEqual(prevFromRect, toRect) && !isRectEqual(fromRect, toRect) && // Make sure animatingRect is on line between toRect & fromRect
                            (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) {
                            // If returning to same place as started from animation and on same axis
                            time = calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
                        }
                    } // if fromRect != toRect: animate


                    if (!isRectEqual(toRect, fromRect)) {
                        target.prevFromRect = fromRect;
                        target.prevToRect = toRect;

                        if (!time) {
                            time = _this.options.animation;
                        }

                        _this.animate(target, animatingRect, toRect, time);
                    }

                    if (time) {
                        animating = true;
                        animationTime = Math.max(animationTime, time);
                        clearTimeout(target.animationResetTimer);
                        target.animationResetTimer = setTimeout(function () {
                            target.animationTime = 0;
                            target.prevFromRect = null;
                            target.fromRect = null;
                            target.prevToRect = null;
                            target.thisAnimationDuration = null;
                        }, time);
                        target.thisAnimationDuration = time;
                    }
                });
                clearTimeout(animationCallbackId);

                if (!animating) {
                    if (typeof callback === 'function') callback();
                } else {
                    animationCallbackId = setTimeout(function () {
                        if (typeof callback === 'function') callback();
                    }, animationTime);
                }

                animationStates = [];
            },
            animate: function animate(target, currentRect, toRect, duration) {
                if (duration) {
                    css(target, 'transition', '');
                    css(target, 'transform', '');
                    var elMatrix = matrix(this.el),
                        scaleX = elMatrix && elMatrix.a,
                        scaleY = elMatrix && elMatrix.d,
                        translateX = (currentRect.left - toRect.left) / (scaleX || 1),
                        translateY = (currentRect.top - toRect.top) / (scaleY || 1);
                    target.animatingX = !!translateX;
                    target.animatingY = !!translateY;
                    css(target, 'transform', 'translate3d(' + translateX + 'px,' + translateY + 'px,0)');
                    repaint(target); // repaint

                    css(target, 'transition', 'transform ' + duration + 'ms' + (this.options.easing ? ' ' + this.options.easing : ''));
                    css(target, 'transform', 'translate3d(0,0,0)');
                    typeof target.animated === 'number' && clearTimeout(target.animated);
                    target.animated = setTimeout(function () {
                        css(target, 'transition', '');
                        css(target, 'transform', '');
                        target.animated = false;
                        target.animatingX = false;
                        target.animatingY = false;
                    }, duration);
                }
            }
        };
    }

    function repaint(target) {
        return target.offsetWidth;
    }

    function calculateRealTime(animatingRect, fromRect, toRect, options) {
        return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
    }

    var plugins = [];
    var defaults = {
        initializeByDefault: true
    };
    var PluginManager = {
        mount: function mount(plugin) {
            // Set default static properties
            for (var option in defaults) {
                if (defaults.hasOwnProperty(option) && !(option in plugin)) {
                    plugin[option] = defaults[option];
                }
            }

            plugins.push(plugin);
        },
        pluginEvent: function pluginEvent(eventName, sortable, evt) {
            var _this = this;

            this.eventCanceled = false;

            evt.cancel = function () {
                _this.eventCanceled = true;
            };

            var eventNameGlobal = eventName + 'Global';
            plugins.forEach(function (plugin) {
                if (!sortable[plugin.pluginName]) return; // Fire global events if it exists in this sortable

                if (sortable[plugin.pluginName][eventNameGlobal]) {
                    sortable[plugin.pluginName][eventNameGlobal](_objectSpread({
                        sortable: sortable
                    }, evt));
                } // Only fire plugin event if plugin is enabled in this sortable,
                // and plugin has event defined


                if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) {
                    sortable[plugin.pluginName][eventName](_objectSpread({
                        sortable: sortable
                    }, evt));
                }
            });
        },
        initializePlugins: function initializePlugins(sortable, el, defaults, options) {
            plugins.forEach(function (plugin) {
                var pluginName = plugin.pluginName;
                if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
                var initialized = new plugin(sortable, el, sortable.options);
                initialized.sortable = sortable;
                initialized.options = sortable.options;
                sortable[pluginName] = initialized; // Add default options from plugin

                _extends(defaults, initialized.defaults);
            });

            for (var option in sortable.options) {
                if (!sortable.options.hasOwnProperty(option)) continue;
                var modified = this.modifyOption(sortable, option, sortable.options[option]);

                if (typeof modified !== 'undefined') {
                    sortable.options[option] = modified;
                }
            }
        },
        getEventProperties: function getEventProperties(name, sortable) {
            var eventProperties = {};
            plugins.forEach(function (plugin) {
                if (typeof plugin.eventProperties !== 'function') return;

                _extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
            });
            return eventProperties;
        },
        modifyOption: function modifyOption(sortable, name, value) {
            var modifiedValue;
            plugins.forEach(function (plugin) {
                // Plugin must exist on the Sortable
                if (!sortable[plugin.pluginName]) return; // If static option listener exists for this option, call in the context of the Sortable's instance of this plugin

                if (plugin.optionListeners && typeof plugin.optionListeners[name] === 'function') {
                    modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
                }
            });
            return modifiedValue;
        }
    };

    function dispatchEvent(_ref) {
        var sortable = _ref.sortable,
            rootEl = _ref.rootEl,
            name = _ref.name,
            targetEl = _ref.targetEl,
            cloneEl = _ref.cloneEl,
            toEl = _ref.toEl,
            fromEl = _ref.fromEl,
            oldIndex = _ref.oldIndex,
            newIndex = _ref.newIndex,
            oldDraggableIndex = _ref.oldDraggableIndex,
            newDraggableIndex = _ref.newDraggableIndex,
            originalEvent = _ref.originalEvent,
            putSortable = _ref.putSortable,
            extraEventProperties = _ref.extraEventProperties;
        sortable = sortable || rootEl && rootEl[expando];
        if (!sortable) return;
        var evt,
            options = sortable.options,
            onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1); // Support for new CustomEvent feature

        if (window.CustomEvent && !IE11OrLess && !Edge) {
            evt = new CustomEvent(name, {
                bubbles: true,
                cancelable: true
            });
        } else {
            evt = document.createEvent('Event');
            evt.initEvent(name, true, true);
        }

        evt.to = toEl || rootEl;
        evt.from = fromEl || rootEl;
        evt.item = targetEl || rootEl;
        evt.clone = cloneEl;
        evt.oldIndex = oldIndex;
        evt.newIndex = newIndex;
        evt.oldDraggableIndex = oldDraggableIndex;
        evt.newDraggableIndex = newDraggableIndex;
        evt.originalEvent = originalEvent;
        evt.pullMode = putSortable ? putSortable.lastPutMode : undefined;

        var allEventProperties = _objectSpread({}, extraEventProperties, PluginManager.getEventProperties(name, sortable));

        for (var option in allEventProperties) {
            evt[option] = allEventProperties[option];
        }

        if (rootEl) {
            rootEl.dispatchEvent(evt);
        }

        if (options[onName]) {
            options[onName].call(sortable, evt);
        }
    }

    var pluginEvent = function pluginEvent(eventName, sortable) {
        var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
            originalEvent = _ref.evt,
            data = _objectWithoutProperties(_ref, ["evt"]);

        PluginManager.pluginEvent.bind(Sortable)(eventName, sortable, _objectSpread({
            dragEl: dragEl,
            parentEl: parentEl,
            ghostEl: ghostEl,
            rootEl: rootEl,
            nextEl: nextEl,
            lastDownEl: lastDownEl,
            cloneEl: cloneEl,
            cloneHidden: cloneHidden,
            dragStarted: moved,
            putSortable: putSortable,
            activeSortable: Sortable.active,
            originalEvent: originalEvent,
            oldIndex: oldIndex,
            oldDraggableIndex: oldDraggableIndex,
            newIndex: newIndex,
            newDraggableIndex: newDraggableIndex,
            hideGhostForTarget: _hideGhostForTarget,
            unhideGhostForTarget: _unhideGhostForTarget,
            cloneNowHidden: function cloneNowHidden() {
                cloneHidden = true;
            },
            cloneNowShown: function cloneNowShown() {
                cloneHidden = false;
            },
            dispatchSortableEvent: function dispatchSortableEvent(name) {
                _dispatchEvent({
                    sortable: sortable,
                    name: name,
                    originalEvent: originalEvent
                });
            }
        }, data));
    };

    function _dispatchEvent(info) {
        dispatchEvent(_objectSpread({
            putSortable: putSortable,
            cloneEl: cloneEl,
            targetEl: dragEl,
            rootEl: rootEl,
            oldIndex: oldIndex,
            oldDraggableIndex: oldDraggableIndex,
            newIndex: newIndex,
            newDraggableIndex: newDraggableIndex
        }, info));
    }

    var dragEl,
        parentEl,
        ghostEl,
        rootEl,
        nextEl,
        lastDownEl,
        cloneEl,
        cloneHidden,
        oldIndex,
        newIndex,
        oldDraggableIndex,
        newDraggableIndex,
        activeGroup,
        putSortable,
        awaitingDragStarted = false,
        ignoreNextClick = false,
        sortables = [],
        tapEvt,
        touchEvt,
        lastDx,
        lastDy,
        tapDistanceLeft,
        tapDistanceTop,
        moved,
        lastTarget,
        lastDirection,
        pastFirstInvertThresh = false,
        isCircumstantialInvert = false,
        targetMoveDistance,
    // For positioning ghost absolutely
        ghostRelativeParent,
        ghostRelativeParentInitialScroll = [],
    // (left, top)
        _silent = false,
        savedInputChecked = [];
    /** @const */

    var documentExists = typeof document !== 'undefined',
        PositionGhostAbsolutely = IOS,
        CSSFloatProperty = Edge || IE11OrLess ? 'cssFloat' : 'float',
    // This will not pass for IE9, because IE9 DnD only works on anchors
        supportDraggable = documentExists && !ChromeForAndroid && !IOS && 'draggable' in document.createElement('div'),
        supportCssPointerEvents = function () {
            if (!documentExists) return; // false when <= IE11

            if (IE11OrLess) {
                return false;
            }

            var el = document.createElement('x');
            el.style.cssText = 'pointer-events:auto';
            return el.style.pointerEvents === 'auto';
        }(),
        _detectDirection = function _detectDirection(el, options) {
            var elCSS = css(el),
                elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth),
                child1 = getChild(el, 0, options),
                child2 = getChild(el, 1, options),
                firstChildCSS = child1 && css(child1),
                secondChildCSS = child2 && css(child2),
                firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + getRect(child1).width,
                secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + getRect(child2).width;

            if (elCSS.display === 'flex') {
                return elCSS.flexDirection === 'column' || elCSS.flexDirection === 'column-reverse' ? 'vertical' : 'horizontal';
            }

            if (elCSS.display === 'grid') {
                return elCSS.gridTemplateColumns.split(' ').length <= 1 ? 'vertical' : 'horizontal';
            }

            if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== 'none') {
                var touchingSideChild2 = firstChildCSS["float"] === 'left' ? 'left' : 'right';
                return child2 && (secondChildCSS.clear === 'both' || secondChildCSS.clear === touchingSideChild2) ? 'vertical' : 'horizontal';
            }

            return child1 && (firstChildCSS.display === 'block' || firstChildCSS.display === 'flex' || firstChildCSS.display === 'table' || firstChildCSS.display === 'grid' || firstChildWidth >= elWidth && elCSS[CSSFloatProperty] === 'none' || child2 && elCSS[CSSFloatProperty] === 'none' && firstChildWidth + secondChildWidth > elWidth) ? 'vertical' : 'horizontal';
        },
        _dragElInRowColumn = function _dragElInRowColumn(dragRect, targetRect, vertical) {
            var dragElS1Opp = vertical ? dragRect.left : dragRect.top,
                dragElS2Opp = vertical ? dragRect.right : dragRect.bottom,
                dragElOppLength = vertical ? dragRect.width : dragRect.height,
                targetS1Opp = vertical ? targetRect.left : targetRect.top,
                targetS2Opp = vertical ? targetRect.right : targetRect.bottom,
                targetOppLength = vertical ? targetRect.width : targetRect.height;
            return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
        },

        /**
         * Detects first nearest empty sortable to X and Y position using emptyInsertThreshold.
         * @param  {Number} x      X position
         * @param  {Number} y      Y position
         * @return {HTMLElement}   Element of the first found nearest Sortable
         */
        _detectNearestEmptySortable = function _detectNearestEmptySortable(x, y) {
            var ret;
            sortables.some(function (sortable) {
                if (lastChild(sortable)) return;
                var rect = getRect(sortable),
                    threshold = sortable[expando].options.emptyInsertThreshold,
                    insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold,
                    insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;

                if (threshold && insideHorizontally && insideVertically) {
                    return ret = sortable;
                }
            });
            return ret;
        },
        _prepareGroup = function _prepareGroup(options) {
            function toFn(value, pull) {
                return function (to, from, dragEl, evt) {
                    var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;

                    if (value == null && (pull || sameGroup)) {
                        // Default pull value
                        // Default pull and put value if same group
                        return true;
                    } else if (value == null || value === false) {
                        return false;
                    } else if (pull && value === 'clone') {
                        return value;
                    } else if (typeof value === 'function') {
                        return toFn(value(to, from, dragEl, evt), pull)(to, from, dragEl, evt);
                    } else {
                        var otherGroup = (pull ? to : from).options.group.name;
                        return value === true || typeof value === 'string' && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
                    }
                };
            }

            var group = {};
            var originalGroup = options.group;

            if (!originalGroup || _typeof(originalGroup) != 'object') {
                originalGroup = {
                    name: originalGroup
                };
            }

            group.name = originalGroup.name;
            group.checkPull = toFn(originalGroup.pull, true);
            group.checkPut = toFn(originalGroup.put);
            group.revertClone = originalGroup.revertClone;
            options.group = group;
        },
        _hideGhostForTarget = function _hideGhostForTarget() {
            if (!supportCssPointerEvents && ghostEl) {
                css(ghostEl, 'display', 'none');
            }
        },
        _unhideGhostForTarget = function _unhideGhostForTarget() {
            if (!supportCssPointerEvents && ghostEl) {
                css(ghostEl, 'display', '');
            }
        }; // #1184 fix - Prevent click event on fallback if dragged but item not changed position


    if (documentExists) {
        document.addEventListener('click', function (evt) {
            if (ignoreNextClick) {
                evt.preventDefault();
                evt.stopPropagation && evt.stopPropagation();
                evt.stopImmediatePropagation && evt.stopImmediatePropagation();
                ignoreNextClick = false;
                return false;
            }
        }, true);
    }

    var nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent(evt) {
        if (dragEl) {
            evt = evt.touches ? evt.touches[0] : evt;

            var nearest = _detectNearestEmptySortable(evt.clientX, evt.clientY);

            if (nearest) {
                // Create imitation event
                var event = {};

                for (var i in evt) {
                    if (evt.hasOwnProperty(i)) {
                        event[i] = evt[i];
                    }
                }

                event.target = event.rootEl = nearest;
                event.preventDefault = void 0;
                event.stopPropagation = void 0;

                nearest[expando]._onDragOver(event);
            }
        }
    };

    var _checkOutsideTargetEl = function _checkOutsideTargetEl(evt) {
        if (dragEl) {
            dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
        }
    };
    /**
     * @class  Sortable
     * @param  {HTMLElement}  el
     * @param  {Object}       [options]
     */


    function Sortable(el, options) {
        if (!(el && el.nodeType && el.nodeType === 1)) {
            throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(el));
        }

        this.el = el; // root element

        this.options = options = _extends({}, options); // Export instance

        el[expando] = this;
        var defaults = {
            group: null,
            sort: true,
            disabled: false,
            store: null,
            handle: null,
            draggable: /^[uo]l$/i.test(el.nodeName) ? '>li' : '>*',
            swapThreshold: 1,
            // percentage; 0 <= x <= 1
            invertSwap: false,
            // invert always
            invertedSwapThreshold: null,
            // will be set to same as swapThreshold if default
            removeCloneOnHide: true,
            direction: function direction() {
                return _detectDirection(el, this.options);
            },
            ghostClass: 'sortable-ghost',
            chosenClass: 'sortable-chosen',
            dragClass: 'sortable-drag',
            ignore: 'a, img',
            filter: null,
            preventOnFilter: true,
            animation: 0,
            easing: null,
            setData: function setData(dataTransfer, dragEl) {
                dataTransfer.setData('Text', dragEl.textContent);
            },
            dropBubble: false,
            dragoverBubble: false,
            dataIdAttr: 'data-id',
            delay: 0,
            delayOnTouchOnly: false,
            touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
            forceFallback: false,
            fallbackClass: 'sortable-fallback',
            fallbackOnBody: false,
            fallbackTolerance: 0,
            fallbackOffset: {
                x: 0,
                y: 0
            },
            supportPointer: Sortable.supportPointer !== false && 'PointerEvent' in window,
            emptyInsertThreshold: 5
        };
        PluginManager.initializePlugins(this, el, defaults); // Set default options

        for (var name in defaults) {
            !(name in options) && (options[name] = defaults[name]);
        }

        _prepareGroup(options); // Bind all private methods


        for (var fn in this) {
            if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
                this[fn] = this[fn].bind(this);
            }
        } // Setup drag mode


        this.nativeDraggable = options.forceFallback ? false : supportDraggable;

        if (this.nativeDraggable) {
            // Touch start threshold cannot be greater than the native dragstart threshold
            this.options.touchStartThreshold = 1;
        } // Bind events


        if (options.supportPointer) {
            on(el, 'pointerdown', this._onTapStart);
        } else {
            on(el, 'mousedown', this._onTapStart);
            on(el, 'touchstart', this._onTapStart);
        }

        if (this.nativeDraggable) {
            on(el, 'dragover', this);
            on(el, 'dragenter', this);
        }

        sortables.push(this.el); // Restore sorting

        options.store && options.store.get && this.sort(options.store.get(this) || []); // Add animation state manager

        _extends(this, AnimationStateManager());
    }

    Sortable.prototype =
        /** @lends Sortable.prototype */
    {
        constructor: Sortable,
        _isOutsideThisEl: function _isOutsideThisEl(target) {
            if (!this.el.contains(target) && target !== this.el) {
                lastTarget = null;
            }
        },
        _getDirection: function _getDirection(evt, target) {
            return typeof this.options.direction === 'function' ? this.options.direction.call(this, evt, target, dragEl) : this.options.direction;
        },
        _onTapStart: function _onTapStart(
            /** Event|TouchEvent */
            evt) {
            if (!evt.cancelable) return;

            var _this = this,
                el = this.el,
                options = this.options,
                preventOnFilter = options.preventOnFilter,
                type = evt.type,
                touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === 'touch' && evt,
                target = (touch || evt).target,
                originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target,
                filter = options.filter;

            _saveInputCheckedState(el); // Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.


            if (dragEl) {
                return;
            }

            if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) {
                return; // only left button and enabled
            } // cancel dnd if original target is content editable


            if (originalTarget.isContentEditable) {
                return;
            }

            target = closest(target, options.draggable, el, false);

            if (target && target.animated) {
                return;
            }

            if (lastDownEl === target) {
                // Ignoring duplicate `down`
                return;
            } // Get the index of the dragged element within its parent


            oldIndex = index(target);
            oldDraggableIndex = index(target, options.draggable); // Check filter

            if (typeof filter === 'function') {
                if (filter.call(this, evt, target, this)) {
                    _dispatchEvent({
                        sortable: _this,
                        rootEl: originalTarget,
                        name: 'filter',
                        targetEl: target,
                        toEl: el,
                        fromEl: el
                    });

                    pluginEvent('filter', _this, {
                        evt: evt
                    });
                    preventOnFilter && evt.cancelable && evt.preventDefault();
                    return; // cancel dnd
                }
            } else if (filter) {
                filter = filter.split(',').some(function (criteria) {
                    criteria = closest(originalTarget, criteria.trim(), el, false);

                    if (criteria) {
                        _dispatchEvent({
                            sortable: _this,
                            rootEl: criteria,
                            name: 'filter',
                            targetEl: target,
                            fromEl: el,
                            toEl: el
                        });

                        pluginEvent('filter', _this, {
                            evt: evt
                        });
                        return true;
                    }
                });

                if (filter) {
                    preventOnFilter && evt.cancelable && evt.preventDefault();
                    return; // cancel dnd
                }
            }

            if (options.handle && !closest(originalTarget, options.handle, el, false)) {
                return;
            } // Prepare `dragstart`


            this._prepareDragStart(evt, touch, target);
        },
        _prepareDragStart: function _prepareDragStart(
            /** Event */
            evt,
            /** Touch */
            touch,
            /** HTMLElement */
            target) {
            var _this = this,
                el = _this.el,
                options = _this.options,
                ownerDocument = el.ownerDocument,
                dragStartFn;

            if (target && !dragEl && target.parentNode === el) {
                var dragRect = getRect(target);
                rootEl = el;
                dragEl = target;
                parentEl = dragEl.parentNode;
                nextEl = dragEl.nextSibling;
                lastDownEl = target;
                activeGroup = options.group;
                Sortable.dragged = dragEl;
                tapEvt = {
                    target: dragEl,
                    clientX: (touch || evt).clientX,
                    clientY: (touch || evt).clientY
                };
                tapDistanceLeft = tapEvt.clientX - dragRect.left;
                tapDistanceTop = tapEvt.clientY - dragRect.top;
                this._lastX = (touch || evt).clientX;
                this._lastY = (touch || evt).clientY;
                dragEl.style['will-change'] = 'all';

                dragStartFn = function dragStartFn() {
                    pluginEvent('delayEnded', _this, {
                        evt: evt
                    });

                    if (Sortable.eventCanceled) {
                        _this._onDrop();

                        return;
                    } // Delayed drag has been triggered
                    // we can re-enable the events: touchmove/mousemove


                    _this._disableDelayedDragEvents();

                    if (!FireFox && _this.nativeDraggable) {
                        dragEl.draggable = true;
                    } // Bind the events: dragstart/dragend


                    _this._triggerDragStart(evt, touch); // Drag start event


                    _dispatchEvent({
                        sortable: _this,
                        name: 'choose',
                        originalEvent: evt
                    }); // Chosen item


                    toggleClass(dragEl, options.chosenClass, true);
                }; // Disable "draggable"


                options.ignore.split(',').forEach(function (criteria) {
                    find(dragEl, criteria.trim(), _disableDraggable);
                });
                on(ownerDocument, 'dragover', nearestEmptyInsertDetectEvent);
                on(ownerDocument, 'mousemove', nearestEmptyInsertDetectEvent);
                on(ownerDocument, 'touchmove', nearestEmptyInsertDetectEvent);
                on(ownerDocument, 'mouseup', _this._onDrop);
                on(ownerDocument, 'touchend', _this._onDrop);
                on(ownerDocument, 'touchcancel', _this._onDrop); // Make dragEl draggable (must be before delay for FireFox)

                if (FireFox && this.nativeDraggable) {
                    this.options.touchStartThreshold = 4;
                    dragEl.draggable = true;
                }

                pluginEvent('delayStart', this, {
                    evt: evt
                }); // Delay is impossible for native DnD in Edge or IE

                if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !(Edge || IE11OrLess))) {
                    if (Sortable.eventCanceled) {
                        this._onDrop();

                        return;
                    } // If the user moves the pointer or let go the click or touch
                    // before the delay has been reached:
                    // disable the delayed drag


                    on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
                    on(ownerDocument, 'touchend', _this._disableDelayedDrag);
                    on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
                    on(ownerDocument, 'mousemove', _this._delayedDragTouchMoveHandler);
                    on(ownerDocument, 'touchmove', _this._delayedDragTouchMoveHandler);
                    options.supportPointer && on(ownerDocument, 'pointermove', _this._delayedDragTouchMoveHandler);
                    _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
                } else {
                    dragStartFn();
                }
            }
        },
        _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(
            /** TouchEvent|PointerEvent **/
            e) {
            var touch = e.touches ? e.touches[0] : e;

            if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) {
                this._disableDelayedDrag();
            }
        },
        _disableDelayedDrag: function _disableDelayedDrag() {
            dragEl && _disableDraggable(dragEl);
            clearTimeout(this._dragStartTimer);

            this._disableDelayedDragEvents();
        },
        _disableDelayedDragEvents: function _disableDelayedDragEvents() {
            var ownerDocument = this.el.ownerDocument;
            off(ownerDocument, 'mouseup', this._disableDelayedDrag);
            off(ownerDocument, 'touchend', this._disableDelayedDrag);
            off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
            off(ownerDocument, 'mousemove', this._delayedDragTouchMoveHandler);
            off(ownerDocument, 'touchmove', this._delayedDragTouchMoveHandler);
            off(ownerDocument, 'pointermove', this._delayedDragTouchMoveHandler);
        },
        _triggerDragStart: function _triggerDragStart(
            /** Event */
            evt,
            /** Touch */
            touch) {
            touch = touch || evt.pointerType == 'touch' && evt;

            if (!this.nativeDraggable || touch) {
                if (this.options.supportPointer) {
                    on(document, 'pointermove', this._onTouchMove);
                } else if (touch) {
                    on(document, 'touchmove', this._onTouchMove);
                } else {
                    on(document, 'mousemove', this._onTouchMove);
                }
            } else {
                on(dragEl, 'dragend', this);
                on(rootEl, 'dragstart', this._onDragStart);
            }

            try {
                if (document.selection) {
                    // Timeout neccessary for IE9
                    _nextTick(function () {
                        document.selection.empty();
                    });
                } else {
                    window.getSelection().removeAllRanges();
                }
            } catch (err) {}
        },
        _dragStarted: function _dragStarted(fallback, evt) {

            awaitingDragStarted = false;

            if (rootEl && dragEl) {
                pluginEvent('dragStarted', this, {
                    evt: evt
                });

                if (this.nativeDraggable) {
                    on(document, 'dragover', _checkOutsideTargetEl);
                }

                var options = this.options; // Apply effect

                !fallback && toggleClass(dragEl, options.dragClass, false);
                toggleClass(dragEl, options.ghostClass, true);
                Sortable.active = this;
                fallback && this._appendGhost(); // Drag start event

                _dispatchEvent({
                    sortable: this,
                    name: 'start',
                    originalEvent: evt
                });
            } else {
                this._nulling();
            }
        },
        _emulateDragOver: function _emulateDragOver() {
            if (touchEvt) {
                this._lastX = touchEvt.clientX;
                this._lastY = touchEvt.clientY;

                _hideGhostForTarget();

                var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
                var parent = target;

                while (target && target.shadowRoot) {
                    target = target.shadowRoot.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
                    if (target === parent) break;
                    parent = target;
                }

                dragEl.parentNode[expando]._isOutsideThisEl(target);

                if (parent) {
                    do {
                        if (parent[expando]) {
                            var inserted = void 0;
                            inserted = parent[expando]._onDragOver({
                                clientX: touchEvt.clientX,
                                clientY: touchEvt.clientY,
                                target: target,
                                rootEl: parent
                            });

                            if (inserted && !this.options.dragoverBubble) {
                                break;
                            }
                        }

                        target = parent; // store last element
                    }
                        /* jshint boss:true */
                    while (parent = parent.parentNode);
                }

                _unhideGhostForTarget();
            }
        },
        _onTouchMove: function _onTouchMove(
            /**TouchEvent*/
            evt) {
            if (tapEvt) {
                var options = this.options,
                    fallbackTolerance = options.fallbackTolerance,
                    fallbackOffset = options.fallbackOffset,
                    touch = evt.touches ? evt.touches[0] : evt,
                    ghostMatrix = ghostEl && matrix(ghostEl),
                    scaleX = ghostEl && ghostMatrix && ghostMatrix.a,
                    scaleY = ghostEl && ghostMatrix && ghostMatrix.d,
                    relativeScrollOffset = PositionGhostAbsolutely && ghostRelativeParent && getRelativeScrollOffset(ghostRelativeParent),
                    dx = (touch.clientX - tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1),
                    dy = (touch.clientY - tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1); // only set the status to dragging, when we are actually dragging

                if (!Sortable.active && !awaitingDragStarted) {
                    if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) {
                        return;
                    }

                    this._onDragStart(evt, true);
                }

                if (ghostEl) {
                    if (ghostMatrix) {
                        ghostMatrix.e += dx - (lastDx || 0);
                        ghostMatrix.f += dy - (lastDy || 0);
                    } else {
                        ghostMatrix = {
                            a: 1,
                            b: 0,
                            c: 0,
                            d: 1,
                            e: dx,
                            f: dy
                        };
                    }

                    var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
                    css(ghostEl, 'webkitTransform', cssMatrix);
                    css(ghostEl, 'mozTransform', cssMatrix);
                    css(ghostEl, 'msTransform', cssMatrix);
                    css(ghostEl, 'transform', cssMatrix);
                    lastDx = dx;
                    lastDy = dy;
                    touchEvt = touch;
                }

                evt.cancelable && evt.preventDefault();
            }
        },
        _appendGhost: function _appendGhost() {
            // Bug if using scale(): https://stackoverflow.com/questions/2637058
            // Not being adjusted for
            if (!ghostEl) {
                var container = this.options.fallbackOnBody ? document.body : rootEl,
                    rect = getRect(dragEl, true, PositionGhostAbsolutely, true, container),
                    options = this.options; // Position absolutely

                if (PositionGhostAbsolutely) {
                    // Get relatively positioned parent
                    ghostRelativeParent = container;

                    while (css(ghostRelativeParent, 'position') === 'static' && css(ghostRelativeParent, 'transform') === 'none' && ghostRelativeParent !== document) {
                        ghostRelativeParent = ghostRelativeParent.parentNode;
                    }

                    if (ghostRelativeParent !== document.body && ghostRelativeParent !== document.documentElement) {
                        if (ghostRelativeParent === document) ghostRelativeParent = getWindowScrollingElement();
                        rect.top += ghostRelativeParent.scrollTop;
                        rect.left += ghostRelativeParent.scrollLeft;
                    } else {
                        ghostRelativeParent = getWindowScrollingElement();
                    }

                    ghostRelativeParentInitialScroll = getRelativeScrollOffset(ghostRelativeParent);
                }

                ghostEl = dragEl.cloneNode(true);
                toggleClass(ghostEl, options.ghostClass, false);
                toggleClass(ghostEl, options.fallbackClass, true);
                toggleClass(ghostEl, options.dragClass, true);
                css(ghostEl, 'transition', '');
                css(ghostEl, 'transform', '');
                css(ghostEl, 'box-sizing', 'border-box');
                css(ghostEl, 'margin', 0);
                css(ghostEl, 'top', rect.top);
                css(ghostEl, 'left', rect.left);
                css(ghostEl, 'width', rect.width);
                css(ghostEl, 'height', rect.height);
                css(ghostEl, 'opacity', '0.8');
                css(ghostEl, 'position', PositionGhostAbsolutely ? 'absolute' : 'fixed');
                css(ghostEl, 'zIndex', '100000');
                css(ghostEl, 'pointerEvents', 'none');
                Sortable.ghost = ghostEl;
                container.appendChild(ghostEl); // Set transform-origin

                css(ghostEl, 'transform-origin', tapDistanceLeft / parseInt(ghostEl.style.width) * 100 + '% ' + tapDistanceTop / parseInt(ghostEl.style.height) * 100 + '%');
            }
        },
        _onDragStart: function _onDragStart(
            /**Event*/
            evt,
            /**boolean*/
            fallback) {
            var _this = this;

            var dataTransfer = evt.dataTransfer;
            var options = _this.options;
            pluginEvent('dragStart', this, {
                evt: evt
            });

            if (Sortable.eventCanceled) {
                this._onDrop();

                return;
            }

            pluginEvent('setupClone', this);

            if (!Sortable.eventCanceled) {
                cloneEl = clone(dragEl);
                cloneEl.draggable = false;
                cloneEl.style['will-change'] = '';

                this._hideClone();

                toggleClass(cloneEl, this.options.chosenClass, false);
                Sortable.clone = cloneEl;
            } // #1143: IFrame support workaround


            _this.cloneId = _nextTick(function () {
                pluginEvent('clone', _this);
                if (Sortable.eventCanceled) return;

                if (!_this.options.removeCloneOnHide) {
                    rootEl.insertBefore(cloneEl, dragEl);
                }

                _this._hideClone();

                _dispatchEvent({
                    sortable: _this,
                    name: 'clone'
                });
            });
            !fallback && toggleClass(dragEl, options.dragClass, true); // Set proper drop events

            if (fallback) {
                ignoreNextClick = true;
                _this._loopId = setInterval(_this._emulateDragOver, 50);
            } else {
                // Undo what was set in _prepareDragStart before drag started
                off(document, 'mouseup', _this._onDrop);
                off(document, 'touchend', _this._onDrop);
                off(document, 'touchcancel', _this._onDrop);

                if (dataTransfer) {
                    dataTransfer.effectAllowed = 'move';
                    options.setData && options.setData.call(_this, dataTransfer, dragEl);
                }

                on(document, 'drop', _this); // #1276 fix:

                css(dragEl, 'transform', 'translateZ(0)');
            }

            awaitingDragStarted = true;
            _this._dragStartId = _nextTick(_this._dragStarted.bind(_this, fallback, evt));
            on(document, 'selectstart', _this);
            moved = true;

            if (Safari) {
                css(document.body, 'user-select', 'none');
            }
        },
        // Returns true - if no further action is needed (either inserted or another condition)
        _onDragOver: function _onDragOver(
            /**Event*/
            evt) {
            var el = this.el,
                target = evt.target,
                dragRect,
                targetRect,
                revert,
                options = this.options,
                group = options.group,
                activeSortable = Sortable.active,
                isOwner = activeGroup === group,
                canSort = options.sort,
                fromSortable = putSortable || activeSortable,
                vertical,
                _this = this,
                completedFired = false;

            if (_silent) return;

            function dragOverEvent(name, extra) {
                pluginEvent(name, _this, _objectSpread({
                    evt: evt,
                    isOwner: isOwner,
                    axis: vertical ? 'vertical' : 'horizontal',
                    revert: revert,
                    dragRect: dragRect,
                    targetRect: targetRect,
                    canSort: canSort,
                    fromSortable: fromSortable,
                    target: target,
                    completed: completed,
                    onMove: function onMove(target, after) {
                        return _onMove(rootEl, el, dragEl, dragRect, target, getRect(target), evt, after);
                    },
                    changed: changed
                }, extra));
            } // Capture animation state


            function capture() {
                dragOverEvent('dragOverAnimationCapture');

                _this.captureAnimationState();

                if (_this !== fromSortable) {
                    fromSortable.captureAnimationState();
                }
            } // Return invocation when dragEl is inserted (or completed)


            function completed(insertion) {
                dragOverEvent('dragOverCompleted', {
                    insertion: insertion
                });

                if (insertion) {
                    // Clones must be hidden before folding animation to capture dragRectAbsolute properly
                    if (isOwner) {
                        activeSortable._hideClone();
                    } else {
                        activeSortable._showClone(_this);
                    }

                    if (_this !== fromSortable) {
                        // Set ghost class to new sortable's ghost class
                        toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
                        toggleClass(dragEl, options.ghostClass, true);
                    }

                    if (putSortable !== _this && _this !== Sortable.active) {
                        putSortable = _this;
                    } else if (_this === Sortable.active && putSortable) {
                        putSortable = null;
                    } // Animation


                    if (fromSortable === _this) {
                        _this._ignoreWhileAnimating = target;
                    }

                    _this.animateAll(function () {
                        dragOverEvent('dragOverAnimationComplete');
                        _this._ignoreWhileAnimating = null;
                    });

                    if (_this !== fromSortable) {
                        fromSortable.animateAll();
                        fromSortable._ignoreWhileAnimating = null;
                    }
                } // Null lastTarget if it is not inside a previously swapped element


                if (target === dragEl && !dragEl.animated || target === el && !target.animated) {
                    lastTarget = null;
                } // no bubbling and not fallback


                if (!options.dragoverBubble && !evt.rootEl && target !== document) {
                    dragEl.parentNode[expando]._isOutsideThisEl(evt.target); // Do not detect for empty insert if already inserted


                    !insertion && nearestEmptyInsertDetectEvent(evt);
                }

                !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
                return completedFired = true;
            } // Call when dragEl has been inserted


            function changed() {
                newIndex = index(dragEl);
                newDraggableIndex = index(dragEl, options.draggable);

                _dispatchEvent({
                    sortable: _this,
                    name: 'change',
                    toEl: el,
                    newIndex: newIndex,
                    newDraggableIndex: newDraggableIndex,
                    originalEvent: evt
                });
            }

            if (evt.preventDefault !== void 0) {
                evt.cancelable && evt.preventDefault();
            }

            target = closest(target, options.draggable, el, true);
            dragOverEvent('dragOver');
            if (Sortable.eventCanceled) return completedFired;

            if (dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) {
                return completed(false);
            }

            ignoreNextClick = false;

            if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = !rootEl.contains(dragEl)) // Reverting item into the original list
                    : putSortable === this || (this.lastPutMode = activeGroup.checkPull(this, activeSortable, dragEl, evt)) && group.checkPut(this, activeSortable, dragEl, evt))) {
                vertical = this._getDirection(evt, target) === 'vertical';
                dragRect = getRect(dragEl);
                dragOverEvent('dragOverValid');
                if (Sortable.eventCanceled) return completedFired;

                if (revert) {
                    parentEl = rootEl; // actualization

                    capture();

                    this._hideClone();

                    dragOverEvent('revert');

                    if (!Sortable.eventCanceled) {
                        if (nextEl) {
                            rootEl.insertBefore(dragEl, nextEl);
                        } else {
                            rootEl.appendChild(dragEl);
                        }
                    }

                    return completed(true);
                }

                var elLastChild = lastChild(el, options.draggable);

                if (!elLastChild || _ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
                    // If already at end of list: Do not insert
                    if (elLastChild === dragEl) {
                        return completed(false);
                    } // assign target only if condition is true


                    if (elLastChild && el === evt.target) {
                        target = elLastChild;
                    }

                    if (target) {
                        targetRect = getRect(target);
                    }

                    if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
                        capture();
                        el.appendChild(dragEl);
                        parentEl = el; // actualization

                        changed();
                        return completed(true);
                    }
                } else if (target.parentNode === el) {
                    targetRect = getRect(target);
                    var direction = 0,
                        targetBeforeFirstSwap,
                        differentLevel = dragEl.parentNode !== el,
                        differentRowCol = !_dragElInRowColumn(dragEl.animated && dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical),
                        side1 = vertical ? 'top' : 'left',
                        scrolledPastTop = isScrolledPast(target, 'top', 'top') || isScrolledPast(dragEl, 'top', 'top'),
                        scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;

                    if (lastTarget !== target) {
                        targetBeforeFirstSwap = targetRect[side1];
                        pastFirstInvertThresh = false;
                        isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
                    }

                    direction = _getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, isCircumstantialInvert, lastTarget === target);
                    var sibling;

                    if (direction !== 0) {
                        // Check if target is beside dragEl in respective direction (ignoring hidden elements)
                        var dragIndex = index(dragEl);

                        do {
                            dragIndex -= direction;
                            sibling = parentEl.children[dragIndex];
                        } while (sibling && (css(sibling, 'display') === 'none' || sibling === ghostEl));
                    } // If dragEl is already beside target: Do not insert


                    if (direction === 0 || sibling === target) {
                        return completed(false);
                    }

                    lastTarget = target;
                    lastDirection = direction;
                    var nextSibling = target.nextElementSibling,
                        after = false;
                    after = direction === 1;

                    var moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, after);

                    if (moveVector !== false) {
                        if (moveVector === 1 || moveVector === -1) {
                            after = moveVector === 1;
                        }

                        _silent = true;
                        setTimeout(_unsilent, 30);
                        capture();

                        if (after && !nextSibling) {
                            el.appendChild(dragEl);
                        } else {
                            target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
                        } // Undo chrome's scroll adjustment (has no effect on other browsers)


                        if (scrolledPastTop) {
                            scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
                        }

                        parentEl = dragEl.parentNode; // actualization
                        // must be done before animation

                        if (targetBeforeFirstSwap !== undefined && !isCircumstantialInvert) {
                            targetMoveDistance = Math.abs(targetBeforeFirstSwap - getRect(target)[side1]);
                        }

                        changed();
                        return completed(true);
                    }
                }

                if (el.contains(dragEl)) {
                    return completed(false);
                }
            }

            return false;
        },
        _ignoreWhileAnimating: null,
        _offMoveEvents: function _offMoveEvents() {
            off(document, 'mousemove', this._onTouchMove);
            off(document, 'touchmove', this._onTouchMove);
            off(document, 'pointermove', this._onTouchMove);
            off(document, 'dragover', nearestEmptyInsertDetectEvent);
            off(document, 'mousemove', nearestEmptyInsertDetectEvent);
            off(document, 'touchmove', nearestEmptyInsertDetectEvent);
        },
        _offUpEvents: function _offUpEvents() {
            var ownerDocument = this.el.ownerDocument;
            off(ownerDocument, 'mouseup', this._onDrop);
            off(ownerDocument, 'touchend', this._onDrop);
            off(ownerDocument, 'pointerup', this._onDrop);
            off(ownerDocument, 'touchcancel', this._onDrop);
            off(document, 'selectstart', this);
        },
        _onDrop: function _onDrop(
            /**Event*/
            evt) {
            var el = this.el,
                options = this.options; // Get the index of the dragged element within its parent

            newIndex = index(dragEl);
            newDraggableIndex = index(dragEl, options.draggable);
            pluginEvent('drop', this, {
                evt: evt
            });
            parentEl = dragEl && dragEl.parentNode; // Get again after plugin event

            newIndex = index(dragEl);
            newDraggableIndex = index(dragEl, options.draggable);

            if (Sortable.eventCanceled) {
                this._nulling();

                return;
            }

            awaitingDragStarted = false;
            isCircumstantialInvert = false;
            pastFirstInvertThresh = false;
            clearInterval(this._loopId);
            clearTimeout(this._dragStartTimer);

            _cancelNextTick(this.cloneId);

            _cancelNextTick(this._dragStartId); // Unbind events


            if (this.nativeDraggable) {
                off(document, 'drop', this);
                off(el, 'dragstart', this._onDragStart);
            }

            this._offMoveEvents();

            this._offUpEvents();

            if (Safari) {
                css(document.body, 'user-select', '');
            }

            if (evt) {
                if (moved) {
                    evt.cancelable && evt.preventDefault();
                    !options.dropBubble && evt.stopPropagation();
                }

                ghostEl && ghostEl.parentNode && ghostEl.parentNode.removeChild(ghostEl);

                if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
                    // Remove clone(s)
                    cloneEl && cloneEl.parentNode && cloneEl.parentNode.removeChild(cloneEl);
                }

                if (dragEl) {
                    if (this.nativeDraggable) {
                        off(dragEl, 'dragend', this);
                    }

                    _disableDraggable(dragEl);

                    dragEl.style['will-change'] = ''; // Remove classes
                    // ghostClass is added in dragStarted

                    if (moved && !awaitingDragStarted) {
                        toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : this.options.ghostClass, false);
                    }

                    toggleClass(dragEl, this.options.chosenClass, false); // Drag stop event

                    _dispatchEvent({
                        sortable: this,
                        name: 'unchoose',
                        toEl: parentEl,
                        newIndex: null,
                        newDraggableIndex: null,
                        originalEvent: evt
                    });

                    if (rootEl !== parentEl) {
                        if (newIndex >= 0) {
                            // Add event
                            _dispatchEvent({
                                rootEl: parentEl,
                                name: 'add',
                                toEl: parentEl,
                                fromEl: rootEl,
                                originalEvent: evt
                            }); // Remove event


                            _dispatchEvent({
                                sortable: this,
                                name: 'remove',
                                toEl: parentEl,
                                originalEvent: evt
                            }); // drag from one list and drop into another


                            _dispatchEvent({
                                rootEl: parentEl,
                                name: 'sort',
                                toEl: parentEl,
                                fromEl: rootEl,
                                originalEvent: evt
                            });

                            _dispatchEvent({
                                sortable: this,
                                name: 'sort',
                                toEl: parentEl,
                                originalEvent: evt
                            });
                        }

                        putSortable && putSortable.save();
                    } else {
                        if (newIndex !== oldIndex) {
                            if (newIndex >= 0) {
                                // drag & drop within the same list
                                _dispatchEvent({
                                    sortable: this,
                                    name: 'update',
                                    toEl: parentEl,
                                    originalEvent: evt
                                });

                                _dispatchEvent({
                                    sortable: this,
                                    name: 'sort',
                                    toEl: parentEl,
                                    originalEvent: evt
                                });
                            }
                        }
                    }

                    if (Sortable.active) {
                        /* jshint eqnull:true */
                        if (newIndex == null || newIndex === -1) {
                            newIndex = oldIndex;
                            newDraggableIndex = oldDraggableIndex;
                        }

                        _dispatchEvent({
                            sortable: this,
                            name: 'end',
                            toEl: parentEl,
                            originalEvent: evt
                        }); // Save sorting


                        this.save();
                    }
                }
            }

            this._nulling();
        },
        _nulling: function _nulling() {
            pluginEvent('nulling', this);
            rootEl = dragEl = parentEl = ghostEl = nextEl = cloneEl = lastDownEl = cloneHidden = tapEvt = touchEvt = moved = newIndex = newDraggableIndex = oldIndex = oldDraggableIndex = lastTarget = lastDirection = putSortable = activeGroup = Sortable.dragged = Sortable.ghost = Sortable.clone = Sortable.active = null;
            savedInputChecked.forEach(function (el) {
                el.checked = true;
            });
            savedInputChecked.length = lastDx = lastDy = 0;
        },
        handleEvent: function handleEvent(
            /**Event*/
            evt) {
            switch (evt.type) {
                case 'drop':
                case 'dragend':
                    this._onDrop(evt);

                    break;

                case 'dragenter':
                case 'dragover':
                    if (dragEl) {
                        this._onDragOver(evt);

                        _globalDragOver(evt);
                    }

                    break;

                case 'selectstart':
                    evt.preventDefault();
                    break;
            }
        },

        /**
         * Serializes the item into an array of string.
         * @returns {String[]}
         */
        toArray: function toArray() {
            var order = [],
                el,
                children = this.el.children,
                i = 0,
                n = children.length,
                options = this.options;

            for (; i < n; i++) {
                el = children[i];

                if (closest(el, options.draggable, this.el, false)) {
                    order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
                }
            }

            return order;
        },

        /**
         * Sorts the elements according to the array.
         * @param  {String[]}  order  order of the items
         */
        sort: function sort(order,useAnimation) {
            var items = {},
                rootEl = this.el;
            this.toArray().forEach(function (id, i) {
                var el = rootEl.children[i];

                if (closest(el, this.options.draggable, rootEl, false)) {
                    items[id] = el;
                }
            }, this);
            useAnimation && this.captureAnimationState();
            order.forEach(function (id) {
                if (items[id]) {
                    rootEl.removeChild(items[id]);
                    rootEl.appendChild(items[id]);
                }
            });
            useAnimation && this.animateAll();
        },

        /**
         * Save the current sorting
         */
        save: function save() {
            var store = this.options.store;
            store && store.set && store.set(this);
        },

        /**
         * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
         * @param   {HTMLElement}  el
         * @param   {String}       [selector]  default: `options.draggable`
         * @returns {HTMLElement|null}
         */
        closest: function closest$1(el, selector) {
            return closest(el, selector || this.options.draggable, this.el, false);
        },

        /**
         * Set/get option
         * @param   {string} name
         * @param   {*}      [value]
         * @returns {*}
         */
        option: function option(name, value) {
            var options = this.options;

            if (value === void 0) {
                return options[name];
            } else {
                var modifiedValue = PluginManager.modifyOption(this, name, value);

                if (typeof modifiedValue !== 'undefined') {
                    options[name] = modifiedValue;
                } else {
                    options[name] = value;
                }

                if (name === 'group') {
                    _prepareGroup(options);
                }
            }
        },

        /**
         * Destroy
         */
        destroy: function destroy() {
            pluginEvent('destroy', this);
            var el = this.el;
            el[expando] = null;
            off(el, 'mousedown', this._onTapStart);
            off(el, 'touchstart', this._onTapStart);
            off(el, 'pointerdown', this._onTapStart);

            if (this.nativeDraggable) {
                off(el, 'dragover', this);
                off(el, 'dragenter', this);
            } // Remove draggable attributes


            Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function (el) {
                el.removeAttribute('draggable');
            });

            this._onDrop();

            sortables.splice(sortables.indexOf(this.el), 1);
            this.el = el = null;
        },
        _hideClone: function _hideClone() {
            if (!cloneHidden) {
                pluginEvent('hideClone', this);
                if (Sortable.eventCanceled) return;
                css(cloneEl, 'display', 'none');

                if (this.options.removeCloneOnHide && cloneEl.parentNode) {
                    cloneEl.parentNode.removeChild(cloneEl);
                }

                cloneHidden = true;
            }
        },
        _showClone: function _showClone(putSortable) {
            if (putSortable.lastPutMode !== 'clone') {
                this._hideClone();

                return;
            }

            if (cloneHidden) {
                pluginEvent('showClone', this);
                if (Sortable.eventCanceled) return; // show clone at dragEl or original position

                if (rootEl.contains(dragEl) && !this.options.group.revertClone) {
                    rootEl.insertBefore(cloneEl, dragEl);
                } else if (nextEl) {
                    rootEl.insertBefore(cloneEl, nextEl);
                } else {
                    rootEl.appendChild(cloneEl);
                }

                if (this.options.group.revertClone) {
                    this.animate(dragEl, cloneEl);
                }

                css(cloneEl, 'display', '');
                cloneHidden = false;
            }
        }
    };

    function _globalDragOver(
        /**Event*/
        evt) {
        if (evt.dataTransfer) {
            evt.dataTransfer.dropEffect = 'move';
        }

        evt.cancelable && evt.preventDefault();
    }

    function _onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
        var evt,
            sortable = fromEl[expando],
            onMoveFn = sortable.options.onMove,
            retVal; // Support for new CustomEvent feature

        if (window.CustomEvent && !IE11OrLess && !Edge) {
            evt = new CustomEvent('move', {
                bubbles: true,
                cancelable: true
            });
        } else {
            evt = document.createEvent('Event');
            evt.initEvent('move', true, true);
        }

        evt.to = toEl;
        evt.from = fromEl;
        evt.dragged = dragEl;
        evt.draggedRect = dragRect;
        evt.related = targetEl || toEl;
        evt.relatedRect = targetRect || getRect(toEl);
        evt.willInsertAfter = willInsertAfter;
        evt.originalEvent = originalEvent;
        fromEl.dispatchEvent(evt);

        if (onMoveFn) {
            retVal = onMoveFn.call(sortable, evt, originalEvent);
        }

        return retVal;
    }

    function _disableDraggable(el) {
        el.draggable = false;
    }

    function _unsilent() {
        _silent = false;
    }

    function _ghostIsLast(evt, vertical, sortable) {
        var rect = getRect(lastChild(sortable.el, sortable.options.draggable));
        var spacer = 10;
        return vertical ? evt.clientX > rect.right + spacer || evt.clientX <= rect.right && evt.clientY > rect.bottom && evt.clientX >= rect.left : evt.clientX > rect.right && evt.clientY > rect.top || evt.clientX <= rect.right && evt.clientY > rect.bottom + spacer;
    }

    function _getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
        var mouseOnAxis = vertical ? evt.clientY : evt.clientX,
            targetLength = vertical ? targetRect.height : targetRect.width,
            targetS1 = vertical ? targetRect.top : targetRect.left,
            targetS2 = vertical ? targetRect.bottom : targetRect.right,
            invert = false;

        if (!invertSwap) {
            // Never invert or create dragEl shadow when target movemenet causes mouse to move past the end of regular swapThreshold
            if (isLastTarget && targetMoveDistance < targetLength * swapThreshold) {
                // multiplied only by swapThreshold because mouse will already be inside target by (1 - threshold) * targetLength / 2
                // check if past first invert threshold on side opposite of lastDirection
                if (!pastFirstInvertThresh && (lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) {
                    // past first invert threshold, do not restrict inverted threshold to dragEl shadow
                    pastFirstInvertThresh = true;
                }

                if (!pastFirstInvertThresh) {
                    // dragEl shadow (target move distance shadow)
                    if (lastDirection === 1 ? mouseOnAxis < targetS1 + targetMoveDistance // over dragEl shadow
                            : mouseOnAxis > targetS2 - targetMoveDistance) {
                        return -lastDirection;
                    }
                } else {
                    invert = true;
                }
            } else {
                // Regular
                if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) {
                    return _getInsertDirection(target);
                }
            }
        }

        invert = invert || invertSwap;

        if (invert) {
            // Invert of regular
            if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) {
                return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
            }
        }

        return 0;
    }
    /**
     * Gets the direction dragEl must be swapped relative to target in order to make it
     * seem that dragEl has been "inserted" into that element's position
     * @param  {HTMLElement} target       The target whose position dragEl is being inserted at
     * @return {Number}                   Direction dragEl must be swapped
     */


    function _getInsertDirection(target) {
        if (index(dragEl) < index(target)) {
            return 1;
        } else {
            return -1;
        }
    }
    /**
     * Generate id
     * @param   {HTMLElement} el
     * @returns {String}
     * @private
     */


    function _generateId(el) {
        var str = el.tagName + el.className + el.src + el.href + el.textContent,
            i = str.length,
            sum = 0;

        while (i--) {
            sum += str.charCodeAt(i);
        }

        return sum.toString(36);
    }

    function _saveInputCheckedState(root) {
        savedInputChecked.length = 0;
        var inputs = root.getElementsByTagName('input');
        var idx = inputs.length;

        while (idx--) {
            var el = inputs[idx];
            el.checked && savedInputChecked.push(el);
        }
    }

    function _nextTick(fn) {
        return setTimeout(fn, 0);
    }

    function _cancelNextTick(id) {
        return clearTimeout(id);
    } // Fixed #973:


    if (documentExists) {
        on(document, 'touchmove', function (evt) {
            if ((Sortable.active || awaitingDragStarted) && evt.cancelable) {
                evt.preventDefault();
            }
        });
    } // Export utils


    Sortable.utils = {
        on: on,
        off: off,
        css: css,
        find: find,
        is: function is(el, selector) {
            return !!closest(el, selector, el, false);
        },
        extend: extend,
        throttle: throttle,
        closest: closest,
        toggleClass: toggleClass,
        clone: clone,
        index: index,
        nextTick: _nextTick,
        cancelNextTick: _cancelNextTick,
        detectDirection: _detectDirection,
        getChild: getChild
    };
    /**
     * Get the Sortable instance of an element
     * @param  {HTMLElement} element The element
     * @return {Sortable|undefined}         The instance of Sortable
     */

    Sortable.get = function (element) {
        return element[expando];
    };
    /**
     * Mount a plugin to Sortable
     * @param  {...SortablePlugin|SortablePlugin[]} plugins       Plugins being mounted
     */


    Sortable.mount = function () {
        for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
            plugins[_key] = arguments[_key];
        }

        if (plugins[0].constructor === Array) plugins = plugins[0];
        plugins.forEach(function (plugin) {
            if (!plugin.prototype || !plugin.prototype.constructor) {
                throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(plugin));
            }

            if (plugin.utils) Sortable.utils = _objectSpread({}, Sortable.utils, plugin.utils);
            PluginManager.mount(plugin);
        });
    };
    /**
     * Create sortable instance
     * @param {HTMLElement}  el
     * @param {Object}      [options]
     */


    Sortable.create = function (el, options) {
        return new Sortable(el, options);
    }; // Export


    Sortable.version = version;

    var autoScrolls = [],
        scrollEl,
        scrollRootEl,
        scrolling = false,
        lastAutoScrollX,
        lastAutoScrollY,
        touchEvt$1,
        pointerElemChangedInterval;

    function AutoScrollPlugin() {
        function AutoScroll() {
            this.defaults = {
                scroll: true,
                scrollSensitivity: 30,
                scrollSpeed: 10,
                bubbleScroll: true
            }; // Bind all private methods

            for (var fn in this) {
                if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
                    this[fn] = this[fn].bind(this);
                }
            }
        }

        AutoScroll.prototype = {
            dragStarted: function dragStarted(_ref) {
                var originalEvent = _ref.originalEvent;

                if (this.sortable.nativeDraggable) {
                    on(document, 'dragover', this._handleAutoScroll);
                } else {
                    if (this.options.supportPointer) {
                        on(document, 'pointermove', this._handleFallbackAutoScroll);
                    } else if (originalEvent.touches) {
                        on(document, 'touchmove', this._handleFallbackAutoScroll);
                    } else {
                        on(document, 'mousemove', this._handleFallbackAutoScroll);
                    }
                }
            },
            dragOverCompleted: function dragOverCompleted(_ref2) {
                var originalEvent = _ref2.originalEvent;

                // For when bubbling is canceled and using fallback (fallback 'touchmove' always reached)
                if (!this.options.dragOverBubble && !originalEvent.rootEl) {
                    this._handleAutoScroll(originalEvent);
                }
            },
            drop: function drop() {
                if (this.sortable.nativeDraggable) {
                    off(document, 'dragover', this._handleAutoScroll);
                } else {
                    off(document, 'pointermove', this._handleFallbackAutoScroll);
                    off(document, 'touchmove', this._handleFallbackAutoScroll);
                    off(document, 'mousemove', this._handleFallbackAutoScroll);
                }

                clearPointerElemChangedInterval();
                clearAutoScrolls();
                cancelThrottle();
            },
            nulling: function nulling() {
                touchEvt$1 = scrollRootEl = scrollEl = scrolling = pointerElemChangedInterval = lastAutoScrollX = lastAutoScrollY = null;
                autoScrolls.length = 0;
            },
            _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
                this._handleAutoScroll(evt, true);
            },
            _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
                var _this = this;

                var x = (evt.touches ? evt.touches[0] : evt).clientX,
                    y = (evt.touches ? evt.touches[0] : evt).clientY,
                    elem = document.elementFromPoint(x, y);
                touchEvt$1 = evt; // IE does not seem to have native autoscroll,
                // Edge's autoscroll seems too conditional,
                // MACOS Safari does not have autoscroll,
                // Firefox and Chrome are good

                if (fallback || Edge || IE11OrLess || Safari) {
                    autoScroll(evt, this.options, elem, fallback); // Listener for pointer element change

                    var ogElemScroller = getParentAutoScrollElement(elem, true);

                    if (scrolling && (!pointerElemChangedInterval || x !== lastAutoScrollX || y !== lastAutoScrollY)) {
                        pointerElemChangedInterval && clearPointerElemChangedInterval(); // Detect for pointer elem change, emulating native DnD behaviour

                        pointerElemChangedInterval = setInterval(function () {
                            var newElem = getParentAutoScrollElement(document.elementFromPoint(x, y), true);

                            if (newElem !== ogElemScroller) {
                                ogElemScroller = newElem;
                                clearAutoScrolls();
                            }

                            autoScroll(evt, _this.options, newElem, fallback);
                        }, 10);
                        lastAutoScrollX = x;
                        lastAutoScrollY = y;
                    }
                } else {
                    // if DnD is enabled (and browser has good autoscrolling), first autoscroll will already scroll, so get parent autoscroll of first autoscroll
                    if (!this.options.bubbleScroll || getParentAutoScrollElement(elem, true) === getWindowScrollingElement()) {
                        clearAutoScrolls();
                        return;
                    }

                    autoScroll(evt, this.options, getParentAutoScrollElement(elem, false), false);
                }
            }
        };
        return _extends(AutoScroll, {
            pluginName: 'scroll',
            initializeByDefault: true
        });
    }

    function clearAutoScrolls() {
        autoScrolls.forEach(function (autoScroll) {
            clearInterval(autoScroll.pid);
        });
        autoScrolls = [];
    }

    function clearPointerElemChangedInterval() {
        clearInterval(pointerElemChangedInterval);
    }

    var autoScroll = throttle(function (evt, options, rootEl, isFallback) {
        // Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
        if (!options.scroll) return;
        var x = (evt.touches ? evt.touches[0] : evt).clientX,
            y = (evt.touches ? evt.touches[0] : evt).clientY,
            sens = options.scrollSensitivity,
            speed = options.scrollSpeed,
            winScroller = getWindowScrollingElement();
        var scrollThisInstance = false,
            scrollCustomFn; // New scroll root, set scrollEl

        if (scrollRootEl !== rootEl) {
            scrollRootEl = rootEl;
            clearAutoScrolls();
            scrollEl = options.scroll;
            scrollCustomFn = options.scrollFn;

            if (scrollEl === true) {
                scrollEl = getParentAutoScrollElement(rootEl, true);
            }
        }

        var layersOut = 0;
        var currentParent = scrollEl;

        do {
            var el = currentParent,
                rect = getRect(el),
                top = rect.top,
                bottom = rect.bottom,
                left = rect.left,
                right = rect.right,
                width = rect.width,
                height = rect.height,
                canScrollX = void 0,
                canScrollY = void 0,
                scrollWidth = el.scrollWidth,
                scrollHeight = el.scrollHeight,
                elCSS = css(el),
                scrollPosX = el.scrollLeft,
                scrollPosY = el.scrollTop;

            if (el === winScroller) {
                canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll' || elCSS.overflowX === 'visible');
                canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll' || elCSS.overflowY === 'visible');
            } else {
                canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll');
                canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll');
            }

            var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
            var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);

            if (!autoScrolls[layersOut]) {
                for (var i = 0; i <= layersOut; i++) {
                    if (!autoScrolls[i]) {
                        autoScrolls[i] = {};
                    }
                }
            }

            if (autoScrolls[layersOut].vx != vx || autoScrolls[layersOut].vy != vy || autoScrolls[layersOut].el !== el) {
                autoScrolls[layersOut].el = el;
                autoScrolls[layersOut].vx = vx;
                autoScrolls[layersOut].vy = vy;
                clearInterval(autoScrolls[layersOut].pid);

                if (vx != 0 || vy != 0) {
                    scrollThisInstance = true;
                    /* jshint loopfunc:true */

                    autoScrolls[layersOut].pid = setInterval(function () {
                        // emulate drag over during autoscroll (fallback), emulating native DnD behaviour
                        if (isFallback && this.layer === 0) {
                            Sortable.active._onTouchMove(touchEvt$1); // To move ghost if it is positioned absolutely

                        }

                        var scrollOffsetY = autoScrolls[this.layer].vy ? autoScrolls[this.layer].vy * speed : 0;
                        var scrollOffsetX = autoScrolls[this.layer].vx ? autoScrolls[this.layer].vx * speed : 0;

                        if (typeof scrollCustomFn === 'function') {
                            if (scrollCustomFn.call(Sortable.dragged.parentNode[expando], scrollOffsetX, scrollOffsetY, evt, touchEvt$1, autoScrolls[this.layer].el) !== 'continue') {
                                return;
                            }
                        }

                        scrollBy(autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
                    }.bind({
                        layer: layersOut
                    }), 24);
                }
            }

            layersOut++;
        } while (options.bubbleScroll && currentParent !== winScroller && (currentParent = getParentAutoScrollElement(currentParent, false)));

        scrolling = scrollThisInstance; // in case another function catches scrolling as false in between when it is not
    }, 30);

    var drop = function drop(_ref) {
        var originalEvent = _ref.originalEvent,
            putSortable = _ref.putSortable,
            dragEl = _ref.dragEl,
            activeSortable = _ref.activeSortable,
            dispatchSortableEvent = _ref.dispatchSortableEvent,
            hideGhostForTarget = _ref.hideGhostForTarget,
            unhideGhostForTarget = _ref.unhideGhostForTarget;
        if (!originalEvent) return;
        var toSortable = putSortable || activeSortable;
        hideGhostForTarget();
        var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
        var target = document.elementFromPoint(touch.clientX, touch.clientY);
        unhideGhostForTarget();

        if (toSortable && !toSortable.el.contains(target)) {
            dispatchSortableEvent('spill');
            this.onSpill({
                dragEl: dragEl,
                putSortable: putSortable
            });
        }
    };

    function Revert() {}

    Revert.prototype = {
        startIndex: null,
        dragStart: function dragStart(_ref2) {
            var oldDraggableIndex = _ref2.oldDraggableIndex;
            this.startIndex = oldDraggableIndex;
        },
        onSpill: function onSpill(_ref3) {
            var dragEl = _ref3.dragEl,
                putSortable = _ref3.putSortable;
            this.sortable.captureAnimationState();

            if (putSortable) {
                putSortable.captureAnimationState();
            }

            var nextSibling = getChild(this.sortable.el, this.startIndex, this.options);

            if (nextSibling) {
                this.sortable.el.insertBefore(dragEl, nextSibling);
            } else {
                this.sortable.el.appendChild(dragEl);
            }

            this.sortable.animateAll();

            if (putSortable) {
                putSortable.animateAll();
            }
        },
        drop: drop
    };

    _extends(Revert, {
        pluginName: 'revertOnSpill'
    });

    function Remove() {}

    Remove.prototype = {
        onSpill: function onSpill(_ref4) {
            var dragEl = _ref4.dragEl,
                putSortable = _ref4.putSortable;
            var parentSortable = putSortable || this.sortable;
            parentSortable.captureAnimationState();
            dragEl.parentNode && dragEl.parentNode.removeChild(dragEl);
            parentSortable.animateAll();
        },
        drop: drop
    };

    _extends(Remove, {
        pluginName: 'removeOnSpill'
    });

    var lastSwapEl;

    function SwapPlugin() {
        function Swap() {
            this.defaults = {
                swapClass: 'sortable-swap-highlight'
            };
        }

        Swap.prototype = {
            dragStart: function dragStart(_ref) {
                var dragEl = _ref.dragEl;
                lastSwapEl = dragEl;
            },
            dragOverValid: function dragOverValid(_ref2) {
                var completed = _ref2.completed,
                    target = _ref2.target,
                    onMove = _ref2.onMove,
                    activeSortable = _ref2.activeSortable,
                    changed = _ref2.changed,
                    cancel = _ref2.cancel;
                if (!activeSortable.options.swap) return;
                var el = this.sortable.el,
                    options = this.options;

                if (target && target !== el) {
                    var prevSwapEl = lastSwapEl;

                    if (onMove(target) !== false) {
                        toggleClass(target, options.swapClass, true);
                        lastSwapEl = target;
                    } else {
                        lastSwapEl = null;
                    }

                    if (prevSwapEl && prevSwapEl !== lastSwapEl) {
                        toggleClass(prevSwapEl, options.swapClass, false);
                    }
                }

                changed();
                completed(true);
                cancel();
            },
            drop: function drop(_ref3) {
                var activeSortable = _ref3.activeSortable,
                    putSortable = _ref3.putSortable,
                    dragEl = _ref3.dragEl;
                var toSortable = putSortable || this.sortable;
                var options = this.options;
                lastSwapEl && toggleClass(lastSwapEl, options.swapClass, false);

                if (lastSwapEl && (options.swap || putSortable && putSortable.options.swap)) {
                    if (dragEl !== lastSwapEl) {
                        toSortable.captureAnimationState();
                        if (toSortable !== activeSortable) activeSortable.captureAnimationState();
                        swapNodes(dragEl, lastSwapEl);
                        toSortable.animateAll();
                        if (toSortable !== activeSortable) activeSortable.animateAll();
                    }
                }
            },
            nulling: function nulling() {
                lastSwapEl = null;
            }
        };
        return _extends(Swap, {
            pluginName: 'swap',
            eventProperties: function eventProperties() {
                return {
                    swapItem: lastSwapEl
                };
            }
        });
    }

    function swapNodes(n1, n2) {
        var p1 = n1.parentNode,
            p2 = n2.parentNode,
            i1,
            i2;
        if (!p1 || !p2 || p1.isEqualNode(n2) || p2.isEqualNode(n1)) return;
        i1 = index(n1);
        i2 = index(n2);

        if (p1.isEqualNode(p2) && i1 < i2) {
            i2++;
        }

        p1.insertBefore(n2, p1.children[i1]);
        p2.insertBefore(n1, p2.children[i2]);
    }

    var multiDragElements = [],
        multiDragClones = [],
        lastMultiDragSelect,
    // for selection with modifier key down (SHIFT)
        multiDragSortable,
        initialFolding = false,
    // Initial multi-drag fold when drag started
        folding = false,
    // Folding any other time
        dragStarted = false,
        dragEl$1,
        clonesFromRect,
        clonesHidden;

    function MultiDragPlugin() {
        function MultiDrag(sortable) {
            // Bind all private methods
            for (var fn in this) {
                if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
                    this[fn] = this[fn].bind(this);
                }
            }

            if (sortable.options.supportPointer) {
                on(document, 'pointerup', this._deselectMultiDrag);
            } else {
                on(document, 'mouseup', this._deselectMultiDrag);
                on(document, 'touchend', this._deselectMultiDrag);
            }

            on(document, 'keydown', this._checkKeyDown);
            on(document, 'keyup', this._checkKeyUp);
            this.defaults = {
                selectedClass: 'sortable-selected',
                multiDragKey: null,
                setData: function setData(dataTransfer, dragEl) {
                    var data = '';

                    if (multiDragElements.length && multiDragSortable === sortable) {
                        multiDragElements.forEach(function (multiDragElement, i) {
                            data += (!i ? '' : ', ') + multiDragElement.textContent;
                        });
                    } else {
                        data = dragEl.textContent;
                    }

                    dataTransfer.setData('Text', data);
                }
            };
        }

        MultiDrag.prototype = {
            multiDragKeyDown: false,
            isMultiDrag: false,
            delayStartGlobal: function delayStartGlobal(_ref) {
                var dragged = _ref.dragEl;
                dragEl$1 = dragged;
            },
            delayEnded: function delayEnded() {
                this.isMultiDrag = ~multiDragElements.indexOf(dragEl$1);
            },
            setupClone: function setupClone(_ref2) {
                var sortable = _ref2.sortable,
                    cancel = _ref2.cancel;
                if (!this.isMultiDrag) return;

                for (var i = 0; i < multiDragElements.length; i++) {
                    multiDragClones.push(clone(multiDragElements[i]));
                    multiDragClones[i].sortableIndex = multiDragElements[i].sortableIndex;
                    multiDragClones[i].draggable = false;
                    multiDragClones[i].style['will-change'] = '';
                    toggleClass(multiDragClones[i], this.options.selectedClass, false);
                    multiDragElements[i] === dragEl$1 && toggleClass(multiDragClones[i], this.options.chosenClass, false);
                }

                sortable._hideClone();

                cancel();
            },
            clone: function clone(_ref3) {
                var sortable = _ref3.sortable,
                    rootEl = _ref3.rootEl,
                    dispatchSortableEvent = _ref3.dispatchSortableEvent,
                    cancel = _ref3.cancel;
                if (!this.isMultiDrag) return;

                if (!this.options.removeCloneOnHide) {
                    if (multiDragElements.length && multiDragSortable === sortable) {
                        insertMultiDragClones(true, rootEl);
                        dispatchSortableEvent('clone');
                        cancel();
                    }
                }
            },
            showClone: function showClone(_ref4) {
                var cloneNowShown = _ref4.cloneNowShown,
                    rootEl = _ref4.rootEl,
                    cancel = _ref4.cancel;
                if (!this.isMultiDrag) return;
                insertMultiDragClones(false, rootEl);
                multiDragClones.forEach(function (clone) {
                    css(clone, 'display', '');
                });
                cloneNowShown();
                clonesHidden = false;
                cancel();
            },
            hideClone: function hideClone(_ref5) {
                var _this = this;

                var sortable = _ref5.sortable,
                    cloneNowHidden = _ref5.cloneNowHidden,
                    cancel = _ref5.cancel;
                if (!this.isMultiDrag) return;
                multiDragClones.forEach(function (clone) {
                    css(clone, 'display', 'none');

                    if (_this.options.removeCloneOnHide && clone.parentNode) {
                        clone.parentNode.removeChild(clone);
                    }
                });
                cloneNowHidden();
                clonesHidden = true;
                cancel();
            },
            dragStartGlobal: function dragStartGlobal(_ref6) {
                var sortable = _ref6.sortable;

                if (!this.isMultiDrag && multiDragSortable) {
                    multiDragSortable.multiDrag._deselectMultiDrag();
                }

                multiDragElements.forEach(function (multiDragElement) {
                    multiDragElement.sortableIndex = index(multiDragElement);
                }); // Sort multi-drag elements

                multiDragElements = multiDragElements.sort(function (a, b) {
                    return a.sortableIndex - b.sortableIndex;
                });
                dragStarted = true;
            },
            dragStarted: function dragStarted(_ref7) {
                var _this2 = this;

                var sortable = _ref7.sortable;
                if (!this.isMultiDrag) return;

                if (this.options.sort) {
                    // Capture rects,
                    // hide multi drag elements (by positioning them absolute),
                    // set multi drag elements rects to dragRect,
                    // show multi drag elements,
                    // animate to rects,
                    // unset rects & remove from DOM
                    sortable.captureAnimationState();

                    if (this.options.animation) {
                        multiDragElements.forEach(function (multiDragElement) {
                            if (multiDragElement === dragEl$1) return;
                            css(multiDragElement, 'position', 'absolute');
                        });
                        var dragRect = getRect(dragEl$1, false, true, true);
                        multiDragElements.forEach(function (multiDragElement) {
                            if (multiDragElement === dragEl$1) return;
                            setRect(multiDragElement, dragRect);
                        });
                        folding = true;
                        initialFolding = true;
                    }
                }

                sortable.animateAll(function () {
                    folding = false;
                    initialFolding = false;

                    if (_this2.options.animation) {
                        multiDragElements.forEach(function (multiDragElement) {
                            unsetRect(multiDragElement);
                        });
                    } // Remove all auxiliary multidrag items from el, if sorting enabled


                    if (_this2.options.sort) {
                        removeMultiDragElements();
                    }
                });
            },
            dragOver: function dragOver(_ref8) {
                var target = _ref8.target,
                    completed = _ref8.completed,
                    cancel = _ref8.cancel;

                if (folding && ~multiDragElements.indexOf(target)) {
                    completed(false);
                    cancel();
                }
            },
            revert: function revert(_ref9) {
                var fromSortable = _ref9.fromSortable,
                    rootEl = _ref9.rootEl,
                    sortable = _ref9.sortable,
                    dragRect = _ref9.dragRect;

                if (multiDragElements.length > 1) {
                    // Setup unfold animation
                    multiDragElements.forEach(function (multiDragElement) {
                        sortable.addAnimationState({
                            target: multiDragElement,
                            rect: folding ? getRect(multiDragElement) : dragRect
                        });
                        unsetRect(multiDragElement);
                        multiDragElement.fromRect = dragRect;
                        fromSortable.removeAnimationState(multiDragElement);
                    });
                    folding = false;
                    insertMultiDragElements(!this.options.removeCloneOnHide, rootEl);
                }
            },
            dragOverCompleted: function dragOverCompleted(_ref10) {
                var sortable = _ref10.sortable,
                    isOwner = _ref10.isOwner,
                    insertion = _ref10.insertion,
                    activeSortable = _ref10.activeSortable,
                    parentEl = _ref10.parentEl,
                    putSortable = _ref10.putSortable;
                var options = this.options;

                if (insertion) {
                    // Clones must be hidden before folding animation to capture dragRectAbsolute properly
                    if (isOwner) {
                        activeSortable._hideClone();
                    }

                    initialFolding = false; // If leaving sort:false root, or already folding - Fold to new location

                    if (options.animation && multiDragElements.length > 1 && (folding || !isOwner && !activeSortable.options.sort && !putSortable)) {
                        // Fold: Set all multi drag elements's rects to dragEl's rect when multi-drag elements are invisible
                        var dragRectAbsolute = getRect(dragEl$1, false, true, true);
                        multiDragElements.forEach(function (multiDragElement) {
                            if (multiDragElement === dragEl$1) return;
                            setRect(multiDragElement, dragRectAbsolute); // Move element(s) to end of parentEl so that it does not interfere with multi-drag clones insertion if they are inserted
                            // while folding, and so that we can capture them again because old sortable will no longer be fromSortable

                            parentEl.appendChild(multiDragElement);
                        });
                        folding = true;
                    } // Clones must be shown (and check to remove multi drags) after folding when interfering multiDragElements are moved out


                    if (!isOwner) {
                        // Only remove if not folding (folding will remove them anyways)
                        if (!folding) {
                            removeMultiDragElements();
                        }

                        if (multiDragElements.length > 1) {
                            var clonesHiddenBefore = clonesHidden;

                            activeSortable._showClone(sortable); // Unfold animation for clones if showing from hidden


                            if (activeSortable.options.animation && !clonesHidden && clonesHiddenBefore) {
                                multiDragClones.forEach(function (clone) {
                                    activeSortable.addAnimationState({
                                        target: clone,
                                        rect: clonesFromRect
                                    });
                                    clone.fromRect = clonesFromRect;
                                    clone.thisAnimationDuration = null;
                                });
                            }
                        } else {
                            activeSortable._showClone(sortable);
                        }
                    }
                }
            },
            dragOverAnimationCapture: function dragOverAnimationCapture(_ref11) {
                var dragRect = _ref11.dragRect,
                    isOwner = _ref11.isOwner,
                    activeSortable = _ref11.activeSortable;
                multiDragElements.forEach(function (multiDragElement) {
                    multiDragElement.thisAnimationDuration = null;
                });

                if (activeSortable.options.animation && !isOwner && activeSortable.multiDrag.isMultiDrag) {
                    clonesFromRect = _extends({}, dragRect);
                    var dragMatrix = matrix(dragEl$1, true);
                    clonesFromRect.top -= dragMatrix.f;
                    clonesFromRect.left -= dragMatrix.e;
                }
            },
            dragOverAnimationComplete: function dragOverAnimationComplete() {
                if (folding) {
                    folding = false;
                    removeMultiDragElements();
                }
            },
            drop: function drop(_ref12) {
                var evt = _ref12.originalEvent,
                    rootEl = _ref12.rootEl,
                    parentEl = _ref12.parentEl,
                    sortable = _ref12.sortable,
                    dispatchSortableEvent = _ref12.dispatchSortableEvent,
                    oldIndex = _ref12.oldIndex,
                    putSortable = _ref12.putSortable;
                var toSortable = putSortable || this.sortable;
                if (!evt) return;
                var options = this.options,
                    children = parentEl.children; // Multi-drag selection

                if (!dragStarted) {
                    if (options.multiDragKey && !this.multiDragKeyDown) {
                        this._deselectMultiDrag();
                    }

                    toggleClass(dragEl$1, options.selectedClass, !~multiDragElements.indexOf(dragEl$1));

                    if (!~multiDragElements.indexOf(dragEl$1)) {
                        multiDragElements.push(dragEl$1);
                        dispatchEvent({
                            sortable: sortable,
                            rootEl: rootEl,
                            name: 'select',
                            targetEl: dragEl$1,
                            originalEvt: evt
                        }); // Modifier activated, select from last to dragEl

                        if (evt.shiftKey && lastMultiDragSelect && sortable.el.contains(lastMultiDragSelect)) {
                            var lastIndex = index(lastMultiDragSelect),
                                currentIndex = index(dragEl$1);

                            if (~lastIndex && ~currentIndex && lastIndex !== currentIndex) {
                                // Must include lastMultiDragSelect (select it), in case modified selection from no selection
                                // (but previous selection existed)
                                var n, i;

                                if (currentIndex > lastIndex) {
                                    i = lastIndex;
                                    n = currentIndex;
                                } else {
                                    i = currentIndex;
                                    n = lastIndex + 1;
                                }

                                for (; i < n; i++) {
                                    if (~multiDragElements.indexOf(children[i])) continue;
                                    toggleClass(children[i], options.selectedClass, true);
                                    multiDragElements.push(children[i]);
                                    dispatchEvent({
                                        sortable: sortable,
                                        rootEl: rootEl,
                                        name: 'select',
                                        targetEl: children[i],
                                        originalEvt: evt
                                    });
                                }
                            }
                        } else {
                            lastMultiDragSelect = dragEl$1;
                        }

                        multiDragSortable = toSortable;
                    } else {
                        multiDragElements.splice(multiDragElements.indexOf(dragEl$1), 1);
                        lastMultiDragSelect = null;
                        dispatchEvent({
                            sortable: sortable,
                            rootEl: rootEl,
                            name: 'deselect',
                            targetEl: dragEl$1,
                            originalEvt: evt
                        });
                    }
                } // Multi-drag drop


                if (dragStarted && this.isMultiDrag) {
                    // Do not "unfold" after around dragEl if reverted
                    if ((parentEl[expando].options.sort || parentEl !== rootEl) && multiDragElements.length > 1) {
                        var dragRect = getRect(dragEl$1),
                            multiDragIndex = index(dragEl$1, ':not(.' + this.options.selectedClass + ')');
                        if (!initialFolding && options.animation) dragEl$1.thisAnimationDuration = null;
                        toSortable.captureAnimationState();

                        if (!initialFolding) {
                            if (options.animation) {
                                dragEl$1.fromRect = dragRect;
                                multiDragElements.forEach(function (multiDragElement) {
                                    multiDragElement.thisAnimationDuration = null;

                                    if (multiDragElement !== dragEl$1) {
                                        var rect = folding ? getRect(multiDragElement) : dragRect;
                                        multiDragElement.fromRect = rect; // Prepare unfold animation

                                        toSortable.addAnimationState({
                                            target: multiDragElement,
                                            rect: rect
                                        });
                                    }
                                });
                            } // Multi drag elements are not necessarily removed from the DOM on drop, so to reinsert
                            // properly they must all be removed


                            removeMultiDragElements();
                            multiDragElements.forEach(function (multiDragElement) {
                                if (children[multiDragIndex]) {
                                    parentEl.insertBefore(multiDragElement, children[multiDragIndex]);
                                } else {
                                    parentEl.appendChild(multiDragElement);
                                }

                                multiDragIndex++;
                            }); // If initial folding is done, the elements may have changed position because they are now
                            // unfolding around dragEl, even though dragEl may not have his index changed, so update event
                            // must be fired here as Sortable will not.

                            if (oldIndex === index(dragEl$1)) {
                                var update = false;
                                multiDragElements.forEach(function (multiDragElement) {
                                    if (multiDragElement.sortableIndex !== index(multiDragElement)) {
                                        update = true;
                                        return;
                                    }
                                });

                                if (update) {
                                    dispatchSortableEvent('update');
                                }
                            }
                        } // Must be done after capturing individual rects (scroll bar)


                        multiDragElements.forEach(function (multiDragElement) {
                            unsetRect(multiDragElement);
                        });
                        toSortable.animateAll();
                    }

                    multiDragSortable = toSortable;
                } // Remove clones if necessary


                if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
                    multiDragClones.forEach(function (clone) {
                        clone.parentNode && clone.parentNode.removeChild(clone);
                    });
                }
            },
            nullingGlobal: function nullingGlobal() {
                this.isMultiDrag = dragStarted = false;
                multiDragClones.length = 0;
            },
            destroyGlobal: function destroyGlobal() {
                this._deselectMultiDrag();

                off(document, 'pointerup', this._deselectMultiDrag);
                off(document, 'mouseup', this._deselectMultiDrag);
                off(document, 'touchend', this._deselectMultiDrag);
                off(document, 'keydown', this._checkKeyDown);
                off(document, 'keyup', this._checkKeyUp);
            },
            _deselectMultiDrag: function _deselectMultiDrag(evt) {
                if (dragStarted) return; // Only deselect if selection is in this sortable

                if (multiDragSortable !== this.sortable) return; // Only deselect if target is not item in this sortable

                if (evt && closest(evt.target, this.options.draggable, this.sortable.el, false)) return; // Only deselect if left click

                if (evt && evt.button !== 0) return;

                while (multiDragElements.length) {
                    var el = multiDragElements[0];
                    toggleClass(el, this.options.selectedClass, false);
                    multiDragElements.shift();
                    dispatchEvent({
                        sortable: this.sortable,
                        rootEl: this.sortable.el,
                        name: 'deselect',
                        targetEl: el,
                        originalEvt: evt
                    });
                }
            },
            _checkKeyDown: function _checkKeyDown(evt) {
                if (evt.key === this.options.multiDragKey) {
                    this.multiDragKeyDown = true;
                }
            },
            _checkKeyUp: function _checkKeyUp(evt) {
                if (evt.key === this.options.multiDragKey) {
                    this.multiDragKeyDown = false;
                }
            }
        };
        return _extends(MultiDrag, {
            // Static methods & properties
            pluginName: 'multiDrag',
            utils: {
                /**
                 * Selects the provided multi-drag item
                 * @param  {HTMLElement} el    The element to be selected
                 */
                select: function select(el) {
                    var sortable = el.parentNode[expando];
                    if (!sortable || !sortable.options.multiDrag || ~multiDragElements.indexOf(el)) return;

                    if (multiDragSortable && multiDragSortable !== sortable) {
                        multiDragSortable.multiDrag._deselectMultiDrag();

                        multiDragSortable = sortable;
                    }

                    toggleClass(el, sortable.options.selectedClass, true);
                    multiDragElements.push(el);
                },

                /**
                 * Deselects the provided multi-drag item
                 * @param  {HTMLElement} el    The element to be deselected
                 */
                deselect: function deselect(el) {
                    var sortable = el.parentNode[expando],
                        index = multiDragElements.indexOf(el);
                    if (!sortable || !sortable.options.multiDrag || !~index) return;
                    toggleClass(el, sortable.options.selectedClass, false);
                    multiDragElements.splice(index, 1);
                }
            },
            eventProperties: function eventProperties() {
                var _this3 = this;

                var oldIndicies = [],
                    newIndicies = [];
                multiDragElements.forEach(function (multiDragElement) {
                    oldIndicies.push({
                        multiDragElement: multiDragElement,
                        index: multiDragElement.sortableIndex
                    }); // multiDragElements will already be sorted if folding

                    var newIndex;

                    if (folding && multiDragElement !== dragEl$1) {
                        newIndex = -1;
                    } else if (folding) {
                        newIndex = index(multiDragElement, ':not(.' + _this3.options.selectedClass + ')');
                    } else {
                        newIndex = index(multiDragElement);
                    }

                    newIndicies.push({
                        multiDragElement: multiDragElement,
                        index: newIndex
                    });
                });
                return {
                    items: _toConsumableArray(multiDragElements),
                    clones: [].concat(multiDragClones),
                    oldIndicies: oldIndicies,
                    newIndicies: newIndicies
                };
            },
            optionListeners: {
                multiDragKey: function multiDragKey(key) {
                    key = key.toLowerCase();

                    if (key === 'ctrl') {
                        key = 'Control';
                    } else if (key.length > 1) {
                        key = key.charAt(0).toUpperCase() + key.substr(1);
                    }

                    return key;
                }
            }
        });
    }

    function insertMultiDragElements(clonesInserted, rootEl) {
        multiDragElements.forEach(function (multiDragElement, i) {
            var target = rootEl.children[multiDragElement.sortableIndex + (clonesInserted ? Number(i) : 0)];

            if (target) {
                rootEl.insertBefore(multiDragElement, target);
            } else {
                rootEl.appendChild(multiDragElement);
            }
        });
    }
    /**
     * Insert multi-drag clones
     * @param  {[Boolean]} elementsInserted  Whether the multi-drag elements are inserted
     * @param  {HTMLElement} rootEl
     */


    function insertMultiDragClones(elementsInserted, rootEl) {
        multiDragClones.forEach(function (clone, i) {
            var target = rootEl.children[clone.sortableIndex + (elementsInserted ? Number(i) : 0)];

            if (target) {
                rootEl.insertBefore(clone, target);
            } else {
                rootEl.appendChild(clone);
            }
        });
    }

    function removeMultiDragElements() {
        multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            multiDragElement.parentNode && multiDragElement.parentNode.removeChild(multiDragElement);
        });
    }

    Sortable.mount(new AutoScrollPlugin());
    Sortable.mount(Remove, Revert);

    Sortable.mount(new SwapPlugin());
    Sortable.mount(new MultiDragPlugin());

    return Sortable;

}));

(function() {
    'use strict';

    angular
        .module('editorApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        if (location.hash!= null && location.hash!= "") {
            var params = location.hash.split("/");
            if (params && params.length>1) {
                var storeId = params[1];
            }
        }else if(location.pathname!= null && location.pathname!= ""){
            var params = location.pathname.split("/");
            if (params && params.length>1) {
                var storeId = params[1];
            }
        }


        function getCookie (name) {
            if (document.cookie.length > 0) {
                var begin = document.cookie.indexOf(name + '=')
                if (begin !== -1) {
                    begin += name.length + 1 // cookie值的初始位置
                    var end = document.cookie.indexOf(';', begin) // 结束位置
                    if (end === -1) {
                        end = document.cookie.length // 没有;则end为字符串结束位置
                    }
                    return unescape(document.cookie.substring(begin, end))
                }
            }
            return null
        }

        if (storeId == null || storeId=="") {
            storeId = getCookie("store-id");
        }
        console.log("localStorageConfig.storeId:"+storeId);
        $localStorageProvider.setKeyPrefix('editor-'+ storeId+"-");
        $sessionStorageProvider.setKeyPrefix('editor-'+ storeId+"-");


    }
})();

/*! jQuery UI - v1.12.1 - 2018-01-07
 * http://jqueryui.com
 * Includes: widget.js, position.js, data.js, disable-selection.js, focusable.js, form-reset-mixin.js, jquery-1-7.js, keycode.js, labels.js, scroll-parent.js, tabbable.js, unique-id.js, widgets/draggable.js, widgets/droppable.js, widgets/resizable.js, widgets/selectable.js, widgets/sortable.js, widgets/accordion.js, widgets/autocomplete.js, widgets/button.js, widgets/checkboxradio.js, widgets/controlgroup.js, widgets/datepicker.js, widgets/dialog.js, widgets/menu.js, widgets/mouse.js, widgets/progressbar.js, widgets/selectmenu.js, widgets/slider.js, widgets/spinner.js, widgets/tabs.js, widgets/tooltip.js, effect.js, effects/effect-blind.js, effects/effect-bounce.js, effects/effect-clip.js, effects/effect-drop.js, effects/effect-explode.js, effects/effect-fade.js, effects/effect-fold.js, effects/effect-highlight.js, effects/effect-puff.js, effects/effect-pulsate.js, effects/effect-scale.js, effects/effect-shake.js, effects/effect-size.js, effects/effect-slide.js, effects/effect-transfer.js
 * Copyright jQuery Foundation and other contributors; Licensed MIT */

(function (e) {
    "function" == typeof define && define.amd ? define(["jquery"], e) : e(jQuery)
})(function (e) {
    function t(e) {
        for (var t = e.css("visibility"); "inherit" === t;)e = e.parent(), t = e.css("visibility");
        return "hidden" !== t
    }

    function i(e) {
        for (var t, i; e.length && e[0] !== document;) {
            if (t = e.css("position"), ("absolute" === t || "relative" === t || "fixed" === t) && (i = parseInt(e.css("zIndex"), 10), !isNaN(i) && 0 !== i))return i;
            e = e.parent()
        }
        return 0
    }

    function s() {
        this._curInst = null, this._keyEvent = !1, this._disabledInputs = [], this._datepickerShowing = !1, this._inDialog = !1, this._mainDivId = "ui-datepicker-div", this._inlineClass = "ui-datepicker-inline", this._appendClass = "ui-datepicker-append", this._triggerClass = "ui-datepicker-trigger", this._dialogClass = "ui-datepicker-dialog", this._disableClass = "ui-datepicker-disabled", this._unselectableClass = "ui-datepicker-unselectable", this._currentClass = "ui-datepicker-current-day", this._dayOverClass = "ui-datepicker-days-cell-over", this.regional = [], this.regional[""] = {
            closeText: "Done",
            prevText: "Prev",
            nextText: "Next",
            currentText: "Today",
            monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
            monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
            dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
            weekHeader: "Wk",
            dateFormat: "mm/dd/yy",
            firstDay: 0,
            isRTL: !1,
            showMonthAfterYear: !1,
            yearSuffix: ""
        }, this._defaults = {
            showOn: "focus",
            showAnim: "fadeIn",
            showOptions: {},
            defaultDate: null,
            appendText: "",
            buttonText: "...",
            buttonImage: "",
            buttonImageOnly: !1,
            hideIfNoPrevNext: !1,
            navigationAsDateFormat: !1,
            gotoCurrent: !1,
            changeMonth: !1,
            changeYear: !1,
            yearRange: "c-10:c+10",
            showOtherMonths: !1,
            selectOtherMonths: !1,
            showWeek: !1,
            calculateWeek: this.iso8601Week,
            shortYearCutoff: "+10",
            minDate: null,
            maxDate: null,
            duration: "fast",
            beforeShowDay: null,
            beforeShow: null,
            onSelect: null,
            onChangeMonthYear: null,
            onClose: null,
            numberOfMonths: 1,
            showCurrentAtPos: 0,
            stepMonths: 1,
            stepBigMonths: 12,
            altField: "",
            altFormat: "",
            constrainInput: !0,
            showButtonPanel: !1,
            autoSize: !1,
            disabled: !1
        }, e.extend(this._defaults, this.regional[""]), this.regional.en = e.extend(!0, {}, this.regional[""]), this.regional["en-US"] = e.extend(!0, {}, this.regional.en), this.dpDiv = n(e("<div id='" + this._mainDivId + "' class='ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>"))
    }

    function n(t) {
        var i = "button, .ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-calendar td a";
        return t.on("mouseout", i, function () {
            e(this).removeClass("ui-state-hover"), -1 !== this.className.indexOf("ui-datepicker-prev") && e(this).removeClass("ui-datepicker-prev-hover"), -1 !== this.className.indexOf("ui-datepicker-next") && e(this).removeClass("ui-datepicker-next-hover")
        }).on("mouseover", i, a)
    }

    function a() {
        e.datepicker._isDisabledDatepicker(p.inline ? p.dpDiv.parent()[0] : p.input[0]) || (e(this).parents(".ui-datepicker-calendar").find("a").removeClass("ui-state-hover"), e(this).addClass("ui-state-hover"), -1 !== this.className.indexOf("ui-datepicker-prev") && e(this).addClass("ui-datepicker-prev-hover"), -1 !== this.className.indexOf("ui-datepicker-next") && e(this).addClass("ui-datepicker-next-hover"))
    }

    function o(t, i) {
        e.extend(t, i);
        for (var s in i)null == i[s] && (t[s] = i[s]);
        return t
    }

    function r(e) {
        return function () {
            var t = this.element.val();
            e.apply(this, arguments), this._refresh(), t !== this.element.val() && this._trigger("change")
        }
    }

    e.ui = e.ui || {}, e.ui.version = "1.12.1";
    var h = 0, l = Array.prototype.slice;
    e.cleanData = function (t) {
        return function (i) {
            var s, n, a;
            for (a = 0; null != (n = i[a]); a++)try {
                s = e._data(n, "events"), s && s.remove && e(n).triggerHandler("remove")
            } catch (o) {
            }
            t(i)
        }
    }(e.cleanData), e.widget = function (t, i, s) {
        var n, a, o, r = {}, h = t.split(".")[0];
        t = t.split(".")[1];
        var l = h + "-" + t;
        return s || (s = i, i = e.Widget), e.isArray(s) && (s = e.extend.apply(null, [{}].concat(s))), e.expr[":"][l.toLowerCase()] = function (t) {
            return !!e.data(t, l)
        }, e[h] = e[h] || {}, n = e[h][t], a = e[h][t] = function (e, t) {
            return this._createWidget ? (arguments.length && this._createWidget(e, t), void 0) : new a(e, t)
        }, e.extend(a, n, {
            version: s.version,
            _proto: e.extend({}, s),
            _childConstructors: []
        }), o = new i, o.options = e.widget.extend({}, o.options), e.each(s, function (t, s) {
            return e.isFunction(s) ? (r[t] = function () {
                    function e() {
                        return i.prototype[t].apply(this, arguments)
                    }

                    function n(e) {
                        return i.prototype[t].apply(this, e)
                    }

                    return function () {
                        var t, i = this._super, a = this._superApply;
                        return this._super = e, this._superApply = n, t = s.apply(this, arguments), this._super = i, this._superApply = a, t
                    }
                }(), void 0) : (r[t] = s, void 0)
        }), a.prototype = e.widget.extend(o, {widgetEventPrefix: n ? o.widgetEventPrefix || t : t}, r, {
            constructor: a,
            namespace: h,
            widgetName: t,
            widgetFullName: l
        }), n ? (e.each(n._childConstructors, function (t, i) {
                var s = i.prototype;
                e.widget(s.namespace + "." + s.widgetName, a, i._proto)
            }), delete n._childConstructors) : i._childConstructors.push(a), e.widget.bridge(t, a), a
    }, e.widget.extend = function (t) {
        for (var i, s, n = l.call(arguments, 1), a = 0, o = n.length; o > a; a++)for (i in n[a])s = n[a][i], n[a].hasOwnProperty(i) && void 0 !== s && (t[i] = e.isPlainObject(s) ? e.isPlainObject(t[i]) ? e.widget.extend({}, t[i], s) : e.widget.extend({}, s) : s);
        return t
    }, e.widget.bridge = function (t, i) {
        var s = i.prototype.widgetFullName || t;
        e.fn[t] = function (n) {
            var a = "string" == typeof n, o = l.call(arguments, 1), r = this;
            return a ? this.length || "instance" !== n ? this.each(function () {
                        var i, a = e.data(this, s);
                        return "instance" === n ? (r = a, !1) : a ? e.isFunction(a[n]) && "_" !== n.charAt(0) ? (i = a[n].apply(a, o), i !== a && void 0 !== i ? (r = i && i.jquery ? r.pushStack(i.get()) : i, !1) : void 0) : e.error("no such method '" + n + "' for " + t + " widget instance") : e.error("cannot call methods on " + t + " prior to initialization; " + "attempted to call method '" + n + "'")
                    }) : r = void 0 : (o.length && (n = e.widget.extend.apply(null, [n].concat(o))), this.each(function () {
                    var t = e.data(this, s);
                    t ? (t.option(n || {}), t._init && t._init()) : e.data(this, s, new i(n, this))
                })), r
        }
    }, e.Widget = function () {
    }, e.Widget._childConstructors = [], e.Widget.prototype = {
        widgetName: "widget",
        widgetEventPrefix: "",
        defaultElement: "<div>",
        options: {classes: {}, disabled: !1, create: null},
        _createWidget: function (t, i) {
            i = e(i || this.defaultElement || this)[0], this.element = e(i), this.uuid = h++, this.eventNamespace = "." + this.widgetName + this.uuid, this.bindings = e(), this.hoverable = e(), this.focusable = e(), this.classesElementLookup = {}, i !== this && (e.data(i, this.widgetFullName, this), this._on(!0, this.element, {
                remove: function (e) {
                    e.target === i && this.destroy()
                }
            }), this.document = e(i.style ? i.ownerDocument : i.document || i), this.window = e(this.document[0].defaultView || this.document[0].parentWindow)), this.options = e.widget.extend({}, this.options, this._getCreateOptions(), t), this._create(), this.options.disabled && this._setOptionDisabled(this.options.disabled), this._trigger("create", null, this._getCreateEventData()), this._init()
        },
        _getCreateOptions: function () {
            return {}
        },
        _getCreateEventData: e.noop,
        _create: e.noop,
        _init: e.noop,
        destroy: function () {
            var t = this;
            this._destroy(), e.each(this.classesElementLookup, function (e, i) {
                t._removeClass(i, e)
            }), this.element.off(this.eventNamespace).removeData(this.widgetFullName), this.widget().off(this.eventNamespace).removeAttr("aria-disabled"), this.bindings.off(this.eventNamespace)
        },
        _destroy: e.noop,
        widget: function () {
            return this.element
        },
        option: function (t, i) {
            var s, n, a, o = t;
            if (0 === arguments.length)return e.widget.extend({}, this.options);
            if ("string" == typeof t)if (o = {}, s = t.split("."), t = s.shift(), s.length) {
                for (n = o[t] = e.widget.extend({}, this.options[t]), a = 0; s.length - 1 > a; a++)n[s[a]] = n[s[a]] || {}, n = n[s[a]];
                if (t = s.pop(), 1 === arguments.length)return void 0 === n[t] ? null : n[t];
                n[t] = i
            } else {
                if (1 === arguments.length)return void 0 === this.options[t] ? null : this.options[t];
                o[t] = i
            }
            return this._setOptions(o), this
        },
        _setOptions: function (e) {
            var t;
            for (t in e)this._setOption(t, e[t]);
            return this
        },
        _setOption: function (e, t) {
            return "classes" === e && this._setOptionClasses(t), this.options[e] = t, "disabled" === e && this._setOptionDisabled(t), this
        },
        _setOptionClasses: function (t) {
            var i, s, n;
            for (i in t)n = this.classesElementLookup[i], t[i] !== this.options.classes[i] && n && n.length && (s = e(n.get()), this._removeClass(n, i), s.addClass(this._classes({
                element: s,
                keys: i,
                classes: t,
                add: !0
            })))
        },
        _setOptionDisabled: function (e) {
            this._toggleClass(this.widget(), this.widgetFullName + "-disabled", null, !!e), e && (this._removeClass(this.hoverable, null, "ui-state-hover"), this._removeClass(this.focusable, null, "ui-state-focus"))
        },
        enable: function () {
            return this._setOptions({disabled: !1})
        },
        disable: function () {
            return this._setOptions({disabled: !0})
        },
        _classes: function (t) {
            function i(i, a) {
                var o, r;
                for (r = 0; i.length > r; r++)o = n.classesElementLookup[i[r]] || e(), o = t.add ? e(e.unique(o.get().concat(t.element.get()))) : e(o.not(t.element).get()), n.classesElementLookup[i[r]] = o, s.push(i[r]), a && t.classes[i[r]] && s.push(t.classes[i[r]])
            }

            var s = [], n = this;
            return t = e.extend({
                element: this.element,
                classes: this.options.classes || {}
            }, t), this._on(t.element, {remove: "_untrackClassesElement"}), t.keys && i(t.keys.match(/\S+/g) || [], !0), t.extra && i(t.extra.match(/\S+/g) || []), s.join(" ")
        },
        _untrackClassesElement: function (t) {
            var i = this;
            e.each(i.classesElementLookup, function (s, n) {
                -1 !== e.inArray(t.target, n) && (i.classesElementLookup[s] = e(n.not(t.target).get()))
            })
        },
        _removeClass: function (e, t, i) {
            return this._toggleClass(e, t, i, !1)
        },
        _addClass: function (e, t, i) {
            return this._toggleClass(e, t, i, !0)
        },
        _toggleClass: function (e, t, i, s) {
            s = "boolean" == typeof s ? s : i;
            var n = "string" == typeof e || null === e, a = {
                extra: n ? t : i,
                keys: n ? e : t,
                element: n ? this.element : e,
                add: s
            };
            return a.element.toggleClass(this._classes(a), s), this
        },
        _on: function (t, i, s) {
            var n, a = this;
            "boolean" != typeof t && (s = i, i = t, t = !1), s ? (i = n = e(i), this.bindings = this.bindings.add(i)) : (s = i, i = this.element, n = this.widget()), e.each(s, function (s, o) {
                function r() {
                    return t || a.options.disabled !== !0 && !e(this).hasClass("ui-state-disabled") ? ("string" == typeof o ? a[o] : o).apply(a, arguments) : void 0
                }

                "string" != typeof o && (r.guid = o.guid = o.guid || r.guid || e.guid++);
                var h = s.match(/^([\w:-]*)\s*(.*)$/), l = h[1] + a.eventNamespace, u = h[2];
                u ? n.on(l, u, r) : i.on(l, r)
            })
        },
        _off: function (t, i) {
            i = (i || "").split(" ").join(this.eventNamespace + " ") + this.eventNamespace, t.off(i).off(i), this.bindings = e(this.bindings.not(t).get()), this.focusable = e(this.focusable.not(t).get()), this.hoverable = e(this.hoverable.not(t).get())
        },
        _delay: function (e, t) {
            function i() {
                return ("string" == typeof e ? s[e] : e).apply(s, arguments)
            }

            var s = this;
            return setTimeout(i, t || 0)
        },
        _hoverable: function (t) {
            this.hoverable = this.hoverable.add(t), this._on(t, {
                mouseenter: function (t) {
                    this._addClass(e(t.currentTarget), null, "ui-state-hover")
                }, mouseleave: function (t) {
                    this._removeClass(e(t.currentTarget), null, "ui-state-hover")
                }
            })
        },
        _focusable: function (t) {
            this.focusable = this.focusable.add(t), this._on(t, {
                focusin: function (t) {
                    this._addClass(e(t.currentTarget), null, "ui-state-focus")
                }, focusout: function (t) {
                    this._removeClass(e(t.currentTarget), null, "ui-state-focus")
                }
            })
        },
        _trigger: function (t, i, s) {
            var n, a, o = this.options[t];
            if (s = s || {}, i = e.Event(i), i.type = (t === this.widgetEventPrefix ? t : this.widgetEventPrefix + t).toLowerCase(), i.target = this.element[0], a = i.originalEvent)for (n in a)n in i || (i[n] = a[n]);
            return this.element.trigger(i, s), !(e.isFunction(o) && o.apply(this.element[0], [i].concat(s)) === !1 || i.isDefaultPrevented())
        }
    }, e.each({show: "fadeIn", hide: "fadeOut"}, function (t, i) {
        e.Widget.prototype["_" + t] = function (s, n, a) {
            "string" == typeof n && (n = {effect: n});
            var o, r = n ? n === !0 || "number" == typeof n ? i : n.effect || i : t;
            n = n || {}, "number" == typeof n && (n = {duration: n}), o = !e.isEmptyObject(n), n.complete = a, n.delay && s.delay(n.delay), o && e.effects && e.effects.effect[r] ? s[t](n) : r !== t && s[r] ? s[r](n.duration, n.easing, a) : s.queue(function (i) {
                        e(this)[t](), a && a.call(s[0]), i()
                    })
        }
    }), e.widget, function () {
        function t(e, t, i) {
            return [parseFloat(e[0]) * (c.test(e[0]) ? t / 100 : 1), parseFloat(e[1]) * (c.test(e[1]) ? i / 100 : 1)]
        }

        function i(t, i) {
            return parseInt(e.css(t, i), 10) || 0
        }

        function s(t) {
            var i = t[0];
            return 9 === i.nodeType ? {
                    width: t.width(),
                    height: t.height(),
                    offset: {top: 0, left: 0}
                } : e.isWindow(i) ? {
                        width: t.width(),
                        height: t.height(),
                        offset: {top: t.scrollTop(), left: t.scrollLeft()}
                    } : i.preventDefault ? {
                            width: 0,
                            height: 0,
                            offset: {top: i.pageY, left: i.pageX}
                        } : {width: t.outerWidth(), height: t.outerHeight(), offset: t.offset()}
        }

        var n, a = Math.max, o = Math.abs, r = /left|center|right/, h = /top|center|bottom/, l = /[\+\-]\d+(\.[\d]+)?%?/, u = /^\w+/, c = /%$/, d = e.fn.position;
        e.position = {
            scrollbarWidth: function () {
                if (void 0 !== n)return n;
                var t, i, s = e("<div style='display:block;position:absolute;width:50px;height:50px;overflow:hidden;'><div style='height:100px;width:auto;'></div></div>"), a = s.children()[0];
                return e("body").append(s), t = a.offsetWidth, s.css("overflow", "scroll"), i = a.offsetWidth, t === i && (i = s[0].clientWidth), s.remove(), n = t - i
            }, getScrollInfo: function (t) {
                var i = t.isWindow || t.isDocument ? "" : t.element.css("overflow-x"), s = t.isWindow || t.isDocument ? "" : t.element.css("overflow-y"), n = "scroll" === i || "auto" === i && t.width < t.element[0].scrollWidth, a = "scroll" === s || "auto" === s && t.height < t.element[0].scrollHeight;
                return {width: a ? e.position.scrollbarWidth() : 0, height: n ? e.position.scrollbarWidth() : 0}
            }, getWithinInfo: function (t) {
                var i = e(t || window), s = e.isWindow(i[0]), n = !!i[0] && 9 === i[0].nodeType, a = !s && !n;
                return {
                    element: i,
                    isWindow: s,
                    isDocument: n,
                    offset: a ? e(t).offset() : {left: 0, top: 0},
                    scrollLeft: i.scrollLeft(),
                    scrollTop: i.scrollTop(),
                    width: i.outerWidth(),
                    height: i.outerHeight()
                }
            }
        }, e.fn.position = function (n) {
            if (!n || !n.of)return d.apply(this, arguments);
            n = e.extend({}, n);
            var c, p, f, m, g, v, _ = e(n.of), b = e.position.getWithinInfo(n.within), y = e.position.getScrollInfo(b), x = (n.collision || "flip").split(" "), k = {};
            return v = s(_), _[0].preventDefault && (n.at = "left top"), p = v.width, f = v.height, m = v.offset, g = e.extend({}, m), e.each(["my", "at"], function () {
                var e, t, i = (n[this] || "").split(" ");
                1 === i.length && (i = r.test(i[0]) ? i.concat(["center"]) : h.test(i[0]) ? ["center"].concat(i) : ["center", "center"]), i[0] = r.test(i[0]) ? i[0] : "center", i[1] = h.test(i[1]) ? i[1] : "center", e = l.exec(i[0]), t = l.exec(i[1]), k[this] = [e ? e[0] : 0, t ? t[0] : 0], n[this] = [u.exec(i[0])[0], u.exec(i[1])[0]]
            }), 1 === x.length && (x[1] = x[0]), "right" === n.at[0] ? g.left += p : "center" === n.at[0] && (g.left += p / 2), "bottom" === n.at[1] ? g.top += f : "center" === n.at[1] && (g.top += f / 2), c = t(k.at, p, f), g.left += c[0], g.top += c[1], this.each(function () {
                var s, r, h = e(this), l = h.outerWidth(), u = h.outerHeight(), d = i(this, "marginLeft"), v = i(this, "marginTop"), w = l + d + i(this, "marginRight") + y.width, T = u + v + i(this, "marginBottom") + y.height, D = e.extend({}, g), S = t(k.my, h.outerWidth(), h.outerHeight());
                "right" === n.my[0] ? D.left -= l : "center" === n.my[0] && (D.left -= l / 2), "bottom" === n.my[1] ? D.top -= u : "center" === n.my[1] && (D.top -= u / 2), D.left += S[0], D.top += S[1], s = {
                    marginLeft: d,
                    marginTop: v
                }, e.each(["left", "top"], function (t, i) {
                    e.ui.position[x[t]] && e.ui.position[x[t]][i](D, {
                        targetWidth: p,
                        targetHeight: f,
                        elemWidth: l,
                        elemHeight: u,
                        collisionPosition: s,
                        collisionWidth: w,
                        collisionHeight: T,
                        offset: [c[0] + S[0], c[1] + S[1]],
                        my: n.my,
                        at: n.at,
                        within: b,
                        elem: h
                    })
                }), n.using && (r = function (e) {
                    var t = m.left - D.left, i = t + p - l, s = m.top - D.top, r = s + f - u, c = {
                        target: {
                            element: _,
                            left: m.left,
                            top: m.top,
                            width: p,
                            height: f
                        },
                        element: {element: h, left: D.left, top: D.top, width: l, height: u},
                        horizontal: 0 > i ? "left" : t > 0 ? "right" : "center",
                        vertical: 0 > r ? "top" : s > 0 ? "bottom" : "middle"
                    };
                    l > p && p > o(t + i) && (c.horizontal = "center"), u > f && f > o(s + r) && (c.vertical = "middle"), c.important = a(o(t), o(i)) > a(o(s), o(r)) ? "horizontal" : "vertical", n.using.call(this, e, c)
                }), h.offset(e.extend(D, {using: r}))
            })
        }, e.ui.position = {
            fit: {
                left: function (e, t) {
                    var i, s = t.within, n = s.isWindow ? s.scrollLeft : s.offset.left, o = s.width, r = e.left - t.collisionPosition.marginLeft, h = n - r, l = r + t.collisionWidth - o - n;
                    t.collisionWidth > o ? h > 0 && 0 >= l ? (i = e.left + h + t.collisionWidth - o - n, e.left += h - i) : e.left = l > 0 && 0 >= h ? n : h > l ? n + o - t.collisionWidth : n : h > 0 ? e.left += h : l > 0 ? e.left -= l : e.left = a(e.left - r, e.left)
                }, top: function (e, t) {
                    var i, s = t.within, n = s.isWindow ? s.scrollTop : s.offset.top, o = t.within.height, r = e.top - t.collisionPosition.marginTop, h = n - r, l = r + t.collisionHeight - o - n;
                    t.collisionHeight > o ? h > 0 && 0 >= l ? (i = e.top + h + t.collisionHeight - o - n, e.top += h - i) : e.top = l > 0 && 0 >= h ? n : h > l ? n + o - t.collisionHeight : n : h > 0 ? e.top += h : l > 0 ? e.top -= l : e.top = a(e.top - r, e.top)
                }
            }, flip: {
                left: function (e, t) {
                    var i, s, n = t.within, a = n.offset.left + n.scrollLeft, r = n.width, h = n.isWindow ? n.scrollLeft : n.offset.left, l = e.left - t.collisionPosition.marginLeft, u = l - h, c = l + t.collisionWidth - r - h, d = "left" === t.my[0] ? -t.elemWidth : "right" === t.my[0] ? t.elemWidth : 0, p = "left" === t.at[0] ? t.targetWidth : "right" === t.at[0] ? -t.targetWidth : 0, f = -2 * t.offset[0];
                    0 > u ? (i = e.left + d + p + f + t.collisionWidth - r - a, (0 > i || o(u) > i) && (e.left += d + p + f)) : c > 0 && (s = e.left - t.collisionPosition.marginLeft + d + p + f - h, (s > 0 || c > o(s)) && (e.left += d + p + f))
                }, top: function (e, t) {
                    var i, s, n = t.within, a = n.offset.top + n.scrollTop, r = n.height, h = n.isWindow ? n.scrollTop : n.offset.top, l = e.top - t.collisionPosition.marginTop, u = l - h, c = l + t.collisionHeight - r - h, d = "top" === t.my[1], p = d ? -t.elemHeight : "bottom" === t.my[1] ? t.elemHeight : 0, f = "top" === t.at[1] ? t.targetHeight : "bottom" === t.at[1] ? -t.targetHeight : 0, m = -2 * t.offset[1];
                    0 > u ? (s = e.top + p + f + m + t.collisionHeight - r - a, (0 > s || o(u) > s) && (e.top += p + f + m)) : c > 0 && (i = e.top - t.collisionPosition.marginTop + p + f + m - h, (i > 0 || c > o(i)) && (e.top += p + f + m))
                }
            }, flipfit: {
                left: function () {
                    e.ui.position.flip.left.apply(this, arguments), e.ui.position.fit.left.apply(this, arguments)
                }, top: function () {
                    e.ui.position.flip.top.apply(this, arguments), e.ui.position.fit.top.apply(this, arguments)
                }
            }
        }
    }(), e.ui.position, e.extend(e.expr[":"], {
        data: e.expr.createPseudo ? e.expr.createPseudo(function (t) {
                return function (i) {
                    return !!e.data(i, t)
                }
            }) : function (t, i, s) {
                return !!e.data(t, s[3])
            }
    }), e.fn.extend({
        disableSelection: function () {
            var e = "onselectstart" in document.createElement("div") ? "selectstart" : "mousedown";
            return function () {
                return this.on(e + ".ui-disableSelection", function (e) {
                    e.preventDefault()
                })
            }
        }(), enableSelection: function () {
            return this.off(".ui-disableSelection")
        }
    }), e.ui.focusable = function (i, s) {
        var n, a, o, r, h, l = i.nodeName.toLowerCase();
        return "area" === l ? (n = i.parentNode, a = n.name, i.href && a && "map" === n.nodeName.toLowerCase() ? (o = e("img[usemap='#" + a + "']"), o.length > 0 && o.is(":visible")) : !1) : (/^(input|select|textarea|button|object)$/.test(l) ? (r = !i.disabled, r && (h = e(i).closest("fieldset")[0], h && (r = !h.disabled))) : r = "a" === l ? i.href || s : s, r && e(i).is(":visible") && t(e(i)))
    }, e.extend(e.expr[":"], {
        focusable: function (t) {
            return e.ui.focusable(t, null != e.attr(t, "tabindex"))
        }
    }), e.ui.focusable, e.fn.form = function () {
        return "string" == typeof this[0].form ? this.closest("form") : e(this[0].form)
    }, e.ui.formResetMixin = {
        _formResetHandler: function () {
            var t = e(this);
            setTimeout(function () {
                var i = t.data("ui-form-reset-instances");
                e.each(i, function () {
                    this.refresh()
                })
            })
        }, _bindFormResetHandler: function () {
            if (this.form = this.element.form(), this.form.length) {
                var e = this.form.data("ui-form-reset-instances") || [];
                e.length || this.form.on("reset.ui-form-reset", this._formResetHandler), e.push(this), this.form.data("ui-form-reset-instances", e)
            }
        }, _unbindFormResetHandler: function () {
            if (this.form.length) {
                var t = this.form.data("ui-form-reset-instances");
                t.splice(e.inArray(this, t), 1), t.length ? this.form.data("ui-form-reset-instances", t) : this.form.removeData("ui-form-reset-instances").off("reset.ui-form-reset")
            }
        }
    }, "1.7" === e.fn.jquery.substring(0, 3) && (e.each(["Width", "Height"], function (t, i) {
        function s(t, i, s, a) {
            return e.each(n, function () {
                i -= parseFloat(e.css(t, "padding" + this)) || 0, s && (i -= parseFloat(e.css(t, "border" + this + "Width")) || 0), a && (i -= parseFloat(e.css(t, "margin" + this)) || 0)
            }), i
        }

        var n = "Width" === i ? ["Left", "Right"] : ["Top", "Bottom"], a = i.toLowerCase(), o = {
            innerWidth: e.fn.innerWidth,
            innerHeight: e.fn.innerHeight,
            outerWidth: e.fn.outerWidth,
            outerHeight: e.fn.outerHeight
        };
        e.fn["inner" + i] = function (t) {
            return void 0 === t ? o["inner" + i].call(this) : this.each(function () {
                    e(this).css(a, s(this, t) + "px")
                })
        }, e.fn["outer" + i] = function (t, n) {
            return "number" != typeof t ? o["outer" + i].call(this, t) : this.each(function () {
                    e(this).css(a, s(this, t, !0, n) + "px")
                })
        }
    }), e.fn.addBack = function (e) {
        return this.add(null == e ? this.prevObject : this.prevObject.filter(e))
    }), e.ui.keyCode = {
        BACKSPACE: 8,
        COMMA: 188,
        DELETE: 46,
        DOWN: 40,
        END: 35,
        ENTER: 13,
        ESCAPE: 27,
        HOME: 36,
        LEFT: 37,
        PAGE_DOWN: 34,
        PAGE_UP: 33,
        PERIOD: 190,
        RIGHT: 39,
        SPACE: 32,
        TAB: 9,
        UP: 38
    }, e.ui.escapeSelector = function () {
        var e = /([!"#$%&'()*+,./:;<=>?@[\]^`{|}~])/g;
        return function (t) {
            return t.replace(e, "\\$1")
        }
    }(), e.fn.labels = function () {
        var t, i, s, n, a;
        return this[0].labels && this[0].labels.length ? this.pushStack(this[0].labels) : (n = this.eq(0).parents("label"), s = this.attr("id"), s && (t = this.eq(0).parents().last(), a = t.add(t.length ? t.siblings() : this.siblings()), i = "label[for='" + e.ui.escapeSelector(s) + "']", n = n.add(a.find(i).addBack(i))), this.pushStack(n))
    }, e.fn.scrollParent = function (t) {
        var i = this.css("position"), s = "absolute" === i, n = t ? /(auto|scroll|hidden)/ : /(auto|scroll)/, a = this.parents().filter(function () {
            var t = e(this);
            return s && "static" === t.css("position") ? !1 : n.test(t.css("overflow") + t.css("overflow-y") + t.css("overflow-x"))
        }).eq(0);
        return "fixed" !== i && a.length ? a : e(this[0].ownerDocument || document)
    }, e.extend(e.expr[":"], {
        tabbable: function (t) {
            var i = e.attr(t, "tabindex"), s = null != i;
            return (!s || i >= 0) && e.ui.focusable(t, s)
        }
    }), e.fn.extend({
        uniqueId: function () {
            var e = 0;
            return function () {
                return this.each(function () {
                    this.id || (this.id = "ui-id-" + ++e)
                })
            }
        }(), removeUniqueId: function () {
            return this.each(function () {
                /^ui-id-\d+$/.test(this.id) && e(this).removeAttr("id")
            })
        }
    }), e.ui.ie = !!/msie [\w.]+/.exec(navigator.userAgent.toLowerCase());
    var u = !1;
    e(document).on("mouseup", function () {
        u = !1
    }), e.widget("ui.mouse", {
        version: "1.12.1",
        options: {cancel: "input, textarea, button, select, option", distance: 1, delay: 0},
        _mouseInit: function () {
            var t = this;
            this.element.on("mousedown." + this.widgetName, function (e) {
                return t._mouseDown(e)
            }).on("click." + this.widgetName, function (i) {
                return !0 === e.data(i.target, t.widgetName + ".preventClickEvent") ? (e.removeData(i.target, t.widgetName + ".preventClickEvent"), i.stopImmediatePropagation(), !1) : void 0
            }), this.started = !1
        },
        _mouseDestroy: function () {
            conso
            this.element.off("." + this.widgetName), this._mouseMoveDelegate && this.document.off("mousemove." + this.widgetName, this._mouseMoveDelegate).off("mouseup." + this.widgetName, this._mouseUpDelegate)
        },
        _mouseDown: function (t) {
            if (!u) {
                this._mouseMoved = !1, this._mouseStarted && this._mouseUp(t), this._mouseDownEvent = t;
                var i = this, s = 1 === t.which, n = "string" == typeof this.options.cancel && t.target.nodeName ? e(t.target).closest(this.options.cancel).length : !1;
                return s && !n && this._mouseCapture(t) ? (this.mouseDelayMet = !this.options.delay, this.mouseDelayMet || (this._mouseDelayTimer = setTimeout(function () {
                        i.mouseDelayMet = !0
                    }, this.options.delay)), this._mouseDistanceMet(t) && this._mouseDelayMet(t) && (this._mouseStarted = this._mouseStart(t) !== !1, !this._mouseStarted) ? (t.preventDefault(), !0) : (!0 === e.data(t.target, this.widgetName + ".preventClickEvent") && e.removeData(t.target, this.widgetName + ".preventClickEvent"), this._mouseMoveDelegate = function (e) {
                            return i._mouseMove(e)
                        }, this._mouseUpDelegate = function (e) {
                            return i._mouseUp(e)
                        }, this.document.on("mousemove." + this.widgetName, this._mouseMoveDelegate).on("mouseup." + this.widgetName, this._mouseUpDelegate), t.preventDefault(), u = !0, !0)) : !0
            }
        },
        _mouseMove: function (t) {
            if (this._mouseMoved) {
                if (e.ui.ie && (!document.documentMode || 9 > document.documentMode) && !t.button)return this._mouseUp(t);
                if (!t.which)if (t.originalEvent.altKey || t.originalEvent.ctrlKey || t.originalEvent.metaKey || t.originalEvent.shiftKey) this.ignoreMissingWhich = !0; else if (!this.ignoreMissingWhich)return this._mouseUp(t)
            }
            return (t.which || t.button) && (this._mouseMoved = !0), this._mouseStarted ? (this._mouseDrag(t), t.preventDefault()) : (this._mouseDistanceMet(t) && this._mouseDelayMet(t) && (this._mouseStarted = this._mouseStart(this._mouseDownEvent, t) !== !1, this._mouseStarted ? this._mouseDrag(t) : this._mouseUp(t)), !this._mouseStarted)
        },
        _mouseUp: function (t) {
            this.document.off("mousemove." + this.widgetName, this._mouseMoveDelegate).off("mouseup." + this.widgetName, this._mouseUpDelegate), this._mouseStarted && (this._mouseStarted = !1, t.target === this._mouseDownEvent.target && e.data(t.target, this.widgetName + ".preventClickEvent", !0), this._mouseStop(t)), this._mouseDelayTimer && (clearTimeout(this._mouseDelayTimer), delete this._mouseDelayTimer), this.ignoreMissingWhich = !1, u = !1, t.preventDefault()
        },
        _mouseDistanceMet: function (e) {
            return Math.max(Math.abs(this._mouseDownEvent.pageX - e.pageX), Math.abs(this._mouseDownEvent.pageY - e.pageY)) >= this.options.distance
        },
        _mouseDelayMet: function () {
            return this.mouseDelayMet
        },
        _mouseStart: function () {
        },
        _mouseDrag: function () {
        },
        _mouseStop: function () {
        },
        _mouseCapture: function () {
            return !0
        }
    }), e.ui.plugin = {
        add: function (t, i, s) {
            var n, a = e.ui[t].prototype;
            for (n in s)a.plugins[n] = a.plugins[n] || [], a.plugins[n].push([i, s[n]])
        }, call: function (e, t, i, s) {
            var n, a = e.plugins[t];
            if (a && (s || e.element[0].parentNode && 11 !== e.element[0].parentNode.nodeType))for (n = 0; a.length > n; n++)e.options[a[n][0]] && a[n][1].apply(e.element, i)
        }
    }, e.ui.safeActiveElement = function (e) {
        var t;
        try {
            t = e.activeElement
        } catch (i) {
            t = e.body
        }
        return t || (t = e.body), t.nodeName || (t = e.body), t
    }, e.ui.safeBlur = function (t) {
        t && "body" !== t.nodeName.toLowerCase() && e(t).trigger("blur")
    }, e.widget("ui.draggable", e.ui.mouse, {
        version: "1.12.1",
        widgetEventPrefix: "drag",
        options: {
            addClasses: !0,
            appendTo: "parent",
            axis: !1,
            connectToSortable: !1,
            containment: !1,
            cursor: "auto",
            cursorAt: !1,
            grid: !1,
            handle: !1,
            helper: "original",
            iframeFix: !1,
            opacity: !1,
            refreshPositions: !1,
            revert: !1,
            revertDuration: 500,
            scope: "default",
            scroll: !0,
            scrollSensitivity: 20,
            scrollSpeed: 20,
            snap: !1,
            snapMode: "both",
            snapTolerance: 20,
            stack: !1,
            zIndex: !1,
            drag: null,
            start: null,
            stop: null
        },
        _create: function () {
            "original" === this.options.helper && this._setPositionRelative(), this.options.addClasses && this._addClass("ui-draggable"), this._setHandleClassName(), this._mouseInit()
        },
        _setOption: function (e, t) {
            this._super(e, t), "handle" === e && (this._removeHandleClassName(), this._setHandleClassName())
        },
        _destroy: function () {
            return (this.helper || this.element).is(".ui-draggable-dragging") ? (this.destroyOnClear = !0, void 0) : (this._removeHandleClassName(), this._mouseDestroy(), void 0)
        },
        _mouseCapture: function (t) {
            var i = this.options;
            return this.helper || i.disabled || e(t.target).closest(".ui-resizable-handle").length > 0 ? !1 : (this.handle = this._getHandle(t), this.handle ? (this._blurActiveElement(t), this._blockFrames(i.iframeFix === !0 ? "iframe" : i.iframeFix), !0) : !1)
        },
        _blockFrames: function (t) {
            this.iframeBlocks = this.document.find(t).map(function () {
                var t = e(this);
                return e("<div>").css("position", "absolute").appendTo(t.parent()).outerWidth(t.outerWidth()).outerHeight(t.outerHeight()).offset(t.offset())[0]
            })
        },
        _unblockFrames: function () {
            this.iframeBlocks && (this.iframeBlocks.remove(), delete this.iframeBlocks)
        },
        _blurActiveElement: function (t) {
            var i = e.ui.safeActiveElement(this.document[0]), s = e(t.target);
            s.closest(i).length || e.ui.safeBlur(i)
        },
        _mouseStart: function (t) {
            var i = this.options;
            return this.helper = this._createHelper(t), this._addClass(this.helper, "ui-draggable-dragging"), this._cacheHelperProportions(), e.ui.ddmanager && (e.ui.ddmanager.current = this), this._cacheMargins(), this.cssPosition = this.helper.css("position"), this.scrollParent = this.helper.scrollParent(!0), this.offsetParent = this.helper.offsetParent(), this.hasFixedAncestor = this.helper.parents().filter(function () {
                    return "fixed" === e(this).css("position")
                }).length > 0, this.positionAbs = this.element.offset(), this._refreshOffsets(t), this.originalPosition = this.position = this._generatePosition(t, !1), this.originalPageX = t.pageX, this.originalPageY = t.pageY, i.cursorAt && this._adjustOffsetFromHelper(i.cursorAt), this._setContainment(), this._trigger("start", t) === !1 ? (this._clear(), !1) : (this._cacheHelperProportions(), e.ui.ddmanager && !i.dropBehaviour && e.ui.ddmanager.prepareOffsets(this, t), this._mouseDrag(t, !0), e.ui.ddmanager && e.ui.ddmanager.dragStart(this, t), !0)
        },
        _refreshOffsets: function (e) {
            this.offset = {
                top: this.positionAbs.top - this.margins.top,
                left: this.positionAbs.left - this.margins.left,
                scroll: !1,
                parent: this._getParentOffset(),
                relative: this._getRelativeOffset()
            }, this.offset.click = {left: e.pageX - this.offset.left, top: e.pageY - this.offset.top}
        },
        _mouseDrag: function (t, i) {
            if (this.hasFixedAncestor && (this.offset.parent = this._getParentOffset()), this.position = this._generatePosition(t, !0), this.positionAbs = this._convertPositionTo("absolute"), !i) {
                var s = this._uiHash();
                if (this._trigger("drag", t, s) === !1)return this._mouseUp(new e.Event("mouseup", t)), !1;
                this.position = s.position
            }
            return this.helper[0].style.left = this.position.left + "px", this.helper[0].style.top = this.position.top + "px", e.ui.ddmanager && e.ui.ddmanager.drag(this, t), !1
        },
        _mouseStop: function (t) {
            var i = this, s = !1;
            return e.ui.ddmanager && !this.options.dropBehaviour && (s = e.ui.ddmanager.drop(this, t)), this.dropped && (s = this.dropped, this.dropped = !1), "invalid" === this.options.revert && !s || "valid" === this.options.revert && s || this.options.revert === !0 || e.isFunction(this.options.revert) && this.options.revert.call(this.element, s) ? e(this.helper).animate(this.originalPosition, parseInt(this.options.revertDuration, 10), function () {
                    i._trigger("stop", t) !== !1 && i._clear()
                }) : this._trigger("stop", t) !== !1 && this._clear(), !1
        },
        _mouseUp: function (t) {
            return this._unblockFrames(), e.ui.ddmanager && e.ui.ddmanager.dragStop(this, t), this.handleElement.is(t.target) && this.element.trigger("focus"), e.ui.mouse.prototype._mouseUp.call(this, t)
        },
        cancel: function () {
            return this.helper.is(".ui-draggable-dragging") ? this._mouseUp(new e.Event("mouseup", {target: this.element[0]})) : this._clear(), this
        },
        _getHandle: function (t) {
            return this.options.handle ? !!e(t.target).closest(this.element.find(this.options.handle)).length : !0
        },
        _setHandleClassName: function () {
            this.handleElement = this.options.handle ? this.element.find(this.options.handle) : this.element, this._addClass(this.handleElement, "ui-draggable-handle")
        },
        _removeHandleClassName: function () {
            this._removeClass(this.handleElement, "ui-draggable-handle")
        },
        _createHelper: function (t) {
            var i = this.options, s = e.isFunction(i.helper), n = s ? e(i.helper.apply(this.element[0], [t])) : "clone" === i.helper ? this.element.clone().removeAttr("id") : this.element;
            return n.parents("body").length || n.appendTo("parent" === i.appendTo ? this.element[0].parentNode : i.appendTo), s && n[0] === this.element[0] && this._setPositionRelative(), n[0] === this.element[0] || /(fixed|absolute)/.test(n.css("position")) || n.css("position", "absolute"), n
        },
        _setPositionRelative: function () {
            /^(?:r|a|f)/.test(this.element.css("position")) || (this.element[0].style.position = "relative")
        },
        _adjustOffsetFromHelper: function (t) {
            "string" == typeof t && (t = t.split(" ")), e.isArray(t) && (t = {
                left: +t[0],
                top: +t[1] || 0
            }), "left" in t && (this.offset.click.left = t.left + this.margins.left), "right" in t && (this.offset.click.left = this.helperProportions.width - t.right + this.margins.left), "top" in t && (this.offset.click.top = t.top + this.margins.top), "bottom" in t && (this.offset.click.top = this.helperProportions.height - t.bottom + this.margins.top)
        },
        _isRootNode: function (e) {
            return /(html|body)/i.test(e.tagName) || e === this.document[0]
        },
        _getParentOffset: function () {
            var t = this.offsetParent.offset(), i = this.document[0];
            return "absolute" === this.cssPosition && this.scrollParent[0] !== i && e.contains(this.scrollParent[0], this.offsetParent[0]) && (t.left += this.scrollParent.scrollLeft(), t.top += this.scrollParent.scrollTop()), this._isRootNode(this.offsetParent[0]) && (t = {
                top: 0,
                left: 0
            }), {
                top: t.top + (parseInt(this.offsetParent.css("borderTopWidth"), 10) || 0),
                left: t.left + (parseInt(this.offsetParent.css("borderLeftWidth"), 10) || 0)
            }
        },
        _getRelativeOffset: function () {
            if ("relative" !== this.cssPosition)return {top: 0, left: 0};
            var e = this.element.position(), t = this._isRootNode(this.scrollParent[0]);
            return {
                top: e.top - (parseInt(this.helper.css("top"), 10) || 0) + (t ? 0 : this.scrollParent.scrollTop()),
                left: e.left - (parseInt(this.helper.css("left"), 10) || 0) + (t ? 0 : this.scrollParent.scrollLeft())
            }
        },
        _cacheMargins: function () {
            this.margins = {
                left: parseInt(this.element.css("marginLeft"), 10) || 0,
                top: parseInt(this.element.css("marginTop"), 10) || 0,
                right: parseInt(this.element.css("marginRight"), 10) || 0,
                bottom: parseInt(this.element.css("marginBottom"), 10) || 0
            }
        },
        _cacheHelperProportions: function () {
            this.helperProportions = {width: this.helper.outerWidth(), height: this.helper.outerHeight()}
        },
        _setContainment: function () {
            var t, i, s, n = this.options, a = this.document[0];
            return this.relativeContainer = null, n.containment ? "window" === n.containment ? (this.containment = [e(window).scrollLeft() - this.offset.relative.left - this.offset.parent.left, e(window).scrollTop() - this.offset.relative.top - this.offset.parent.top, e(window).scrollLeft() + e(window).width() - this.helperProportions.width - this.margins.left, e(window).scrollTop() + (e(window).height() || a.body.parentNode.scrollHeight) - this.helperProportions.height - this.margins.top], void 0) : "document" === n.containment ? (this.containment = [0, 0, e(a).width() - this.helperProportions.width - this.margins.left, (e(a).height() || a.body.parentNode.scrollHeight) - this.helperProportions.height - this.margins.top], void 0) : n.containment.constructor === Array ? (this.containment = n.containment, void 0) : ("parent" === n.containment && (n.containment = this.helper[0].parentNode), i = e(n.containment), s = i[0], s && (t = /(scroll|auto)/.test(i.css("overflow")), this.containment = [(parseInt(i.css("borderLeftWidth"), 10) || 0) + (parseInt(i.css("paddingLeft"), 10) || 0), (parseInt(i.css("borderTopWidth"), 10) || 0) + (parseInt(i.css("paddingTop"), 10) || 0), (t ? Math.max(s.scrollWidth, s.offsetWidth) : s.offsetWidth) - (parseInt(i.css("borderRightWidth"), 10) || 0) - (parseInt(i.css("paddingRight"), 10) || 0) - this.helperProportions.width - this.margins.left - this.margins.right, (t ? Math.max(s.scrollHeight, s.offsetHeight) : s.offsetHeight) - (parseInt(i.css("borderBottomWidth"), 10) || 0) - (parseInt(i.css("paddingBottom"), 10) || 0) - this.helperProportions.height - this.margins.top - this.margins.bottom], this.relativeContainer = i), void 0) : (this.containment = null, void 0)
        },
        _convertPositionTo: function (e, t) {
            t || (t = this.position);
            var i = "absolute" === e ? 1 : -1, s = this._isRootNode(this.scrollParent[0]);
            return {
                top: t.top + this.offset.relative.top * i + this.offset.parent.top * i - ("fixed" === this.cssPosition ? -this.offset.scroll.top : s ? 0 : this.offset.scroll.top) * i,
                left: t.left + this.offset.relative.left * i + this.offset.parent.left * i - ("fixed" === this.cssPosition ? -this.offset.scroll.left : s ? 0 : this.offset.scroll.left) * i
            }
        },
        _generatePosition: function (e, t) {
            var i, s, n, a, o = this.options, r = this._isRootNode(this.scrollParent[0]), h = e.pageX, l = e.pageY;
            return r && this.offset.scroll || (this.offset.scroll = {
                top: this.scrollParent.scrollTop(),
                left: this.scrollParent.scrollLeft()
            }), t && (this.containment && (this.relativeContainer ? (s = this.relativeContainer.offset(), i = [this.containment[0] + s.left, this.containment[1] + s.top, this.containment[2] + s.left, this.containment[3] + s.top]) : i = this.containment, e.pageX - this.offset.click.left < i[0] && (h = i[0] + this.offset.click.left), e.pageY - this.offset.click.top < i[1] && (l = i[1] + this.offset.click.top), e.pageX - this.offset.click.left > i[2] && (h = i[2] + this.offset.click.left), e.pageY - this.offset.click.top > i[3] && (l = i[3] + this.offset.click.top)), o.grid && (n = o.grid[1] ? this.originalPageY + Math.round((l - this.originalPageY) / o.grid[1]) * o.grid[1] : this.originalPageY, l = i ? n - this.offset.click.top >= i[1] || n - this.offset.click.top > i[3] ? n : n - this.offset.click.top >= i[1] ? n - o.grid[1] : n + o.grid[1] : n, a = o.grid[0] ? this.originalPageX + Math.round((h - this.originalPageX) / o.grid[0]) * o.grid[0] : this.originalPageX, h = i ? a - this.offset.click.left >= i[0] || a - this.offset.click.left > i[2] ? a : a - this.offset.click.left >= i[0] ? a - o.grid[0] : a + o.grid[0] : a), "y" === o.axis && (h = this.originalPageX), "x" === o.axis && (l = this.originalPageY)), {
                top: l - this.offset.click.top - this.offset.relative.top - this.offset.parent.top + ("fixed" === this.cssPosition ? -this.offset.scroll.top : r ? 0 : this.offset.scroll.top),
                left: h - this.offset.click.left - this.offset.relative.left - this.offset.parent.left + ("fixed" === this.cssPosition ? -this.offset.scroll.left : r ? 0 : this.offset.scroll.left)
            }
        },
        _clear: function () {
            this._removeClass(this.helper, "ui-draggable-dragging"), this.helper[0] === this.element[0] || this.cancelHelperRemoval || this.helper.remove(), this.helper = null, this.cancelHelperRemoval = !1, this.destroyOnClear && this.destroy()
        },
        _trigger: function (t, i, s) {
            return s = s || this._uiHash(), e.ui.plugin.call(this, t, [i, s, this], !0), /^(drag|start|stop)/.test(t) && (this.positionAbs = this._convertPositionTo("absolute"), s.offset = this.positionAbs), e.Widget.prototype._trigger.call(this, t, i, s)
        },
        plugins: {},
        _uiHash: function () {
            return {
                helper: this.helper,
                position: this.position,
                originalPosition: this.originalPosition,
                offset: this.positionAbs
            }
        }
    }), e.ui.plugin.add("draggable", "connectToSortable", {
        start: function (t, i, s) {
            var n = e.extend({}, i, {item: s.element});
            s.sortables = [], e(s.options.connectToSortable).each(function () {
                var i = e(this).sortable("instance");
                i && !i.options.disabled && (s.sortables.push(i), i.refreshPositions(), i._trigger("activate", t, n))
            })
        }, stop: function (t, i, s) {
            var n = e.extend({}, i, {item: s.element});
            s.cancelHelperRemoval = !1, e.each(s.sortables, function () {
                var e = this;
                e.isOver ? (e.isOver = 0, s.cancelHelperRemoval = !0, e.cancelHelperRemoval = !1, e._storedCSS = {
                        position: e.placeholder.css("position"),
                        top: e.placeholder.css("top"),
                        left: e.placeholder.css("left")
                    }, e._mouseStop(t), e.options.helper = e.options._helper) : (e.cancelHelperRemoval = !0, e._trigger("deactivate", t, n))
            })
        }, drag: function (t, i, s) {
            e.each(s.sortables, function () {
                var n = !1, a = this;
                a.positionAbs = s.positionAbs, a.helperProportions = s.helperProportions, a.offset.click = s.offset.click, a._intersectsWith(a.containerCache) && (n = !0, e.each(s.sortables, function () {
                    return this.positionAbs = s.positionAbs, this.helperProportions = s.helperProportions, this.offset.click = s.offset.click, this !== a && this._intersectsWith(this.containerCache) && e.contains(a.element[0], this.element[0]) && (n = !1), n
                })), n ? (a.isOver || (a.isOver = 1, s._parent = i.helper.parent(), a.currentItem = i.helper.appendTo(a.element).data("ui-sortable-item", !0), a.options._helper = a.options.helper, a.options.helper = function () {
                        return i.helper[0]
                    }, t.target = a.currentItem[0], a._mouseCapture(t, !0), a._mouseStart(t, !0, !0), a.offset.click.top = s.offset.click.top, a.offset.click.left = s.offset.click.left, a.offset.parent.left -= s.offset.parent.left - a.offset.parent.left, a.offset.parent.top -= s.offset.parent.top - a.offset.parent.top, s._trigger("toSortable", t), s.dropped = a.element, e.each(s.sortables, function () {
                        this.refreshPositions()
                    }), s.currentItem = s.element, a.fromOutside = s), a.currentItem && (a._mouseDrag(t), i.position = a.position)) : a.isOver && (a.isOver = 0, a.cancelHelperRemoval = !0, a.options._revert = a.options.revert, a.options.revert = !1, a._trigger("out", t, a._uiHash(a)), a._mouseStop(t, !0), a.options.revert = a.options._revert, a.options.helper = a.options._helper, a.placeholder && a.placeholder.remove(), i.helper.appendTo(s._parent), s._refreshOffsets(t), i.position = s._generatePosition(t, !0), s._trigger("fromSortable", t), s.dropped = !1, e.each(s.sortables, function () {
                        this.refreshPositions()
                    }))
            })
        }
    }), e.ui.plugin.add("draggable", "cursor", {
        start: function (t, i, s) {
            var n = e("body"), a = s.options;
            n.css("cursor") && (a._cursor = n.css("cursor")), n.css("cursor", a.cursor)
        }, stop: function (t, i, s) {
            var n = s.options;
            n._cursor && e("body").css("cursor", n._cursor)
        }
    }), e.ui.plugin.add("draggable", "opacity", {
        start: function (t, i, s) {
            var n = e(i.helper), a = s.options;
            n.css("opacity") && (a._opacity = n.css("opacity")), n.css("opacity", a.opacity)
        }, stop: function (t, i, s) {
            var n = s.options;
            n._opacity && e(i.helper).css("opacity", n._opacity)
        }
    }), e.ui.plugin.add("draggable", "scroll", {
        start: function (e, t, i) {
            i.scrollParentNotHidden || (i.scrollParentNotHidden = i.helper.scrollParent(!1)), i.scrollParentNotHidden[0] !== i.document[0] && "HTML" !== i.scrollParentNotHidden[0].tagName && (i.overflowOffset = i.scrollParentNotHidden.offset())
        }, drag: function (t, i, s) {
            var n = s.options, a = !1, o = s.scrollParentNotHidden[0], r = s.document[0];
            o !== r && "HTML" !== o.tagName ? (n.axis && "x" === n.axis || (s.overflowOffset.top + o.offsetHeight - t.pageY < n.scrollSensitivity ? o.scrollTop = a = o.scrollTop + n.scrollSpeed : t.pageY - s.overflowOffset.top < n.scrollSensitivity && (o.scrollTop = a = o.scrollTop - n.scrollSpeed)), n.axis && "y" === n.axis || (s.overflowOffset.left + o.offsetWidth - t.pageX < n.scrollSensitivity ? o.scrollLeft = a = o.scrollLeft + n.scrollSpeed : t.pageX - s.overflowOffset.left < n.scrollSensitivity && (o.scrollLeft = a = o.scrollLeft - n.scrollSpeed))) : (n.axis && "x" === n.axis || (t.pageY - e(r).scrollTop() < n.scrollSensitivity ? a = e(r).scrollTop(e(r).scrollTop() - n.scrollSpeed) : e(window).height() - (t.pageY - e(r).scrollTop()) < n.scrollSensitivity && (a = e(r).scrollTop(e(r).scrollTop() + n.scrollSpeed))), n.axis && "y" === n.axis || (t.pageX - e(r).scrollLeft() < n.scrollSensitivity ? a = e(r).scrollLeft(e(r).scrollLeft() - n.scrollSpeed) : e(window).width() - (t.pageX - e(r).scrollLeft()) < n.scrollSensitivity && (a = e(r).scrollLeft(e(r).scrollLeft() + n.scrollSpeed)))), a !== !1 && e.ui.ddmanager && !n.dropBehaviour && e.ui.ddmanager.prepareOffsets(s, t)
        }
    }), e.ui.plugin.add("draggable", "snap", {
        start: function (t, i, s) {
            var n = s.options;
            s.snapElements = [], e(n.snap.constructor !== String ? n.snap.items || ":data(ui-draggable)" : n.snap).each(function () {
                var t = e(this), i = t.offset();
                this !== s.element[0] && s.snapElements.push({
                    item: this,
                    width: t.outerWidth(),
                    height: t.outerHeight(),
                    top: i.top,
                    left: i.left
                })
            })
        }, drag: function (t, i, s) {
            var n, a, o, r, h, l, u, c, d, p, f = s.options, m = f.snapTolerance, g = i.offset.left, v = g + s.helperProportions.width, _ = i.offset.top, b = _ + s.helperProportions.height;
            for (d = s.snapElements.length - 1; d >= 0; d--)h = s.snapElements[d].left - s.margins.left, l = h + s.snapElements[d].width, u = s.snapElements[d].top - s.margins.top, c = u + s.snapElements[d].height, h - m > v || g > l + m || u - m > b || _ > c + m || !e.contains(s.snapElements[d].item.ownerDocument, s.snapElements[d].item) ? (s.snapElements[d].snapping && s.options.snap.release && s.options.snap.release.call(s.element, t, e.extend(s._uiHash(), {snapItem: s.snapElements[d].item})), s.snapElements[d].snapping = !1) : ("inner" !== f.snapMode && (n = m >= Math.abs(u - b), a = m >= Math.abs(c - _), o = m >= Math.abs(h - v), r = m >= Math.abs(l - g), n && (i.position.top = s._convertPositionTo("relative", {
                    top: u - s.helperProportions.height,
                    left: 0
                }).top), a && (i.position.top = s._convertPositionTo("relative", {
                    top: c,
                    left: 0
                }).top), o && (i.position.left = s._convertPositionTo("relative", {
                    top: 0,
                    left: h - s.helperProportions.width
                }).left), r && (i.position.left = s._convertPositionTo("relative", {
                    top: 0,
                    left: l
                }).left)), p = n || a || o || r, "outer" !== f.snapMode && (n = m >= Math.abs(u - _), a = m >= Math.abs(c - b), o = m >= Math.abs(h - g), r = m >= Math.abs(l - v), n && (i.position.top = s._convertPositionTo("relative", {
                    top: u,
                    left: 0
                }).top), a && (i.position.top = s._convertPositionTo("relative", {
                    top: c - s.helperProportions.height,
                    left: 0
                }).top), o && (i.position.left = s._convertPositionTo("relative", {
                    top: 0,
                    left: h
                }).left), r && (i.position.left = s._convertPositionTo("relative", {
                    top: 0,
                    left: l - s.helperProportions.width
                }).left)), !s.snapElements[d].snapping && (n || a || o || r || p) && s.options.snap.snap && s.options.snap.snap.call(s.element, t, e.extend(s._uiHash(), {snapItem: s.snapElements[d].item})), s.snapElements[d].snapping = n || a || o || r || p)
        }
    }), e.ui.plugin.add("draggable", "stack", {
        start: function (t, i, s) {
            var n, a = s.options, o = e.makeArray(e(a.stack)).sort(function (t, i) {
                return (parseInt(e(t).css("zIndex"), 10) || 0) - (parseInt(e(i).css("zIndex"), 10) || 0)
            });
            o.length && (n = parseInt(e(o[0]).css("zIndex"), 10) || 0, e(o).each(function (t) {
                e(this).css("zIndex", n + t)
            }), this.css("zIndex", n + o.length))
        }
    }), e.ui.plugin.add("draggable", "zIndex", {
        start: function (t, i, s) {
            var n = e(i.helper), a = s.options;
            n.css("zIndex") && (a._zIndex = n.css("zIndex")), n.css("zIndex", a.zIndex)
        }, stop: function (t, i, s) {
            var n = s.options;
            n._zIndex && e(i.helper).css("zIndex", n._zIndex)
        }
    }), e.ui.draggable, e.widget("ui.droppable", {
        version: "1.12.1",
        widgetEventPrefix: "drop",
        options: {
            accept: "*",
            addClasses: !0,
            greedy: !1,
            scope: "default",
            tolerance: "intersect",
            activate: null,
            deactivate: null,
            drop: null,
            out: null,
            over: null
        },
        _create: function () {
            var t, i = this.options, s = i.accept;
            this.isover = !1, this.isout = !0, this.accept = e.isFunction(s) ? s : function (e) {
                    return e.is(s)
                }, this.proportions = function () {
                return arguments.length ? (t = arguments[0], void 0) : t ? t : t = {
                            width: this.element[0].offsetWidth,
                            height: this.element[0].offsetHeight
                        }
            }, this._addToManager(i.scope), i.addClasses && this._addClass("ui-droppable")
        },
        _addToManager: function (t) {
            e.ui.ddmanager.droppables[t] = e.ui.ddmanager.droppables[t] || [], e.ui.ddmanager.droppables[t].push(this)
        },
        _splice: function (e) {
            for (var t = 0; e.length > t; t++)e[t] === this && e.splice(t, 1)
        },
        _destroy: function () {
            var t = e.ui.ddmanager.droppables[this.options.scope];
            this._splice(t)
        },
        _setOption: function (t, i) {
            if ("accept" === t) this.accept = e.isFunction(i) ? i : function (e) {
                    return e.is(i)
                }; else if ("scope" === t) {
                var s = e.ui.ddmanager.droppables[this.options.scope];
                this._splice(s), this._addToManager(i)
            }
            this._super(t, i)
        },
        _activate: function (t) {
            var i = e.ui.ddmanager.current;
            this._addActiveClass(), i && this._trigger("activate", t, this.ui(i))
        },
        _deactivate: function (t) {
            var i = e.ui.ddmanager.current;
            this._removeActiveClass(), i && this._trigger("deactivate", t, this.ui(i))
        },
        _over: function (t) {
            var i = e.ui.ddmanager.current;
            i && (i.currentItem || i.element)[0] !== this.element[0] && this.accept.call(this.element[0], i.currentItem || i.element) && (this._addHoverClass(), this._trigger("over", t, this.ui(i)))
        },
        _out: function (t) {
            var i = e.ui.ddmanager.current;
            i && (i.currentItem || i.element)[0] !== this.element[0] && this.accept.call(this.element[0], i.currentItem || i.element) && (this._removeHoverClass(), this._trigger("out", t, this.ui(i)))
        },
        _drop: function (t, i) {
            var s = i || e.ui.ddmanager.current, n = !1;
            return s && (s.currentItem || s.element)[0] !== this.element[0] ? (this.element.find(":data(ui-droppable)").not(".ui-draggable-dragging").each(function () {
                    var i = e(this).droppable("instance");
                    return i.options.greedy && !i.options.disabled && i.options.scope === s.options.scope && i.accept.call(i.element[0], s.currentItem || s.element) && c(s, e.extend(i, {offset: i.element.offset()}), i.options.tolerance, t) ? (n = !0, !1) : void 0
                }), n ? !1 : this.accept.call(this.element[0], s.currentItem || s.element) ? (this._removeActiveClass(), this._removeHoverClass(), this._trigger("drop", t, this.ui(s)), this.element) : !1) : !1
        },
        ui: function (e) {
            return {
                draggable: e.currentItem || e.element,
                helper: e.helper,
                position: e.position,
                offset: e.positionAbs
            }
        },
        _addHoverClass: function () {
            this._addClass("ui-droppable-hover")
        },
        _removeHoverClass: function () {
            this._removeClass("ui-droppable-hover")
        },
        _addActiveClass: function () {
            this._addClass("ui-droppable-active")
        },
        _removeActiveClass: function () {
            this._removeClass("ui-droppable-active")
        }
    });
    var c = e.ui.intersect = function () {
        function e(e, t, i) {
            return e >= t && t + i > e
        }

        return function (t, i, s, n) {
            if (!i.offset)return !1;
            var a = (t.positionAbs || t.position.absolute).left + t.margins.left, o = (t.positionAbs || t.position.absolute).top + t.margins.top, r = a + t.helperProportions.width, h = o + t.helperProportions.height, l = i.offset.left, u = i.offset.top, c = l + i.proportions().width, d = u + i.proportions().height;
            switch (s) {
                case"fit":
                    return a >= l && c >= r && o >= u && d >= h;
                case"intersect":
                    return a + t.helperProportions.width / 2 > l && c > r - t.helperProportions.width / 2 && o + t.helperProportions.height / 2 > u && d > h - t.helperProportions.height / 2;
                case"pointer":
                    return e(n.pageY, u, i.proportions().height) && e(n.pageX, l, i.proportions().width);
                case"touch":
                    return (o >= u && d >= o || h >= u && d >= h || u > o && h > d) && (a >= l && c >= a || r >= l && c >= r || l > a && r > c);
                default:
                    return !1
            }
        }
    }();
    e.ui.ddmanager = {
        current: null, droppables: {"default": []}, prepareOffsets: function (t, i) {
            var s, n, a = e.ui.ddmanager.droppables[t.options.scope] || [], o = i ? i.type : null, r = (t.currentItem || t.element).find(":data(ui-droppable)").addBack();
            e:for (s = 0; a.length > s; s++)if (!(a[s].options.disabled || t && !a[s].accept.call(a[s].element[0], t.currentItem || t.element))) {
                for (n = 0; r.length > n; n++)if (r[n] === a[s].element[0]) {
                    a[s].proportions().height = 0;
                    continue e
                }
                a[s].visible = "none" !== a[s].element.css("display"), a[s].visible && ("mousedown" === o && a[s]._activate.call(a[s], i), a[s].offset = a[s].element.offset(), a[s].proportions({
                    width: a[s].element[0].offsetWidth,
                    height: a[s].element[0].offsetHeight
                }))
            }
        }, drop: function (t, i) {
            var s = !1;
            return e.each((e.ui.ddmanager.droppables[t.options.scope] || []).slice(), function () {
                this.options && (!this.options.disabled && this.visible && c(t, this, this.options.tolerance, i) && (s = this._drop.call(this, i) || s), !this.options.disabled && this.visible && this.accept.call(this.element[0], t.currentItem || t.element) && (this.isout = !0, this.isover = !1, this._deactivate.call(this, i)))
            }), s
        }, dragStart: function (t, i) {
            t.element.parentsUntil("body").on("scroll.droppable", function () {
                t.options.refreshPositions || e.ui.ddmanager.prepareOffsets(t, i)
            })
        }, drag: function (t, i) {
            t.options.refreshPositions && e.ui.ddmanager.prepareOffsets(t, i), e.each(e.ui.ddmanager.droppables[t.options.scope] || [], function () {
                if (!this.options.disabled && !this.greedyChild && this.visible) {
                    var s, n, a, o = c(t, this, this.options.tolerance, i), r = !o && this.isover ? "isout" : o && !this.isover ? "isover" : null;
                    r && (this.options.greedy && (n = this.options.scope, a = this.element.parents(":data(ui-droppable)").filter(function () {
                        return e(this).droppable("instance").options.scope === n
                    }), a.length && (s = e(a[0]).droppable("instance"), s.greedyChild = "isover" === r)), s && "isover" === r && (s.isover = !1, s.isout = !0, s._out.call(s, i)), this[r] = !0, this["isout" === r ? "isover" : "isout"] = !1, this["isover" === r ? "_over" : "_out"].call(this, i), s && "isout" === r && (s.isout = !1, s.isover = !0, s._over.call(s, i)))
                }
            })
        }, dragStop: function (t, i) {
            t.element.parentsUntil("body").off("scroll.droppable"), t.options.refreshPositions || e.ui.ddmanager.prepareOffsets(t, i)
        }
    }, e.uiBackCompat !== !1 && e.widget("ui.droppable", e.ui.droppable, {
        options: {hoverClass: !1, activeClass: !1},
        _addActiveClass: function () {
            this._super(), this.options.activeClass && this.element.addClass(this.options.activeClass)
        },
        _removeActiveClass: function () {
            this._super(), this.options.activeClass && this.element.removeClass(this.options.activeClass)
        },
        _addHoverClass: function () {
            this._super(), this.options.hoverClass && this.element.addClass(this.options.hoverClass)
        },
        _removeHoverClass: function () {
            this._super(), this.options.hoverClass && this.element.removeClass(this.options.hoverClass)
        }
    }), e.ui.droppable, e.widget("ui.resizable", e.ui.mouse, {
        version: "1.12.1",
        widgetEventPrefix: "resize",
        options: {
            alsoResize: !1,
            animate: !1,
            animateDuration: "slow",
            animateEasing: "swing",
            aspectRatio: !1,
            autoHide: !1,
            classes: {"ui-resizable-se": "ui-icon ui-icon-gripsmall-diagonal-se"},
            containment: !1,
            ghost: !1,
            grid: !1,
            handles: "e,s,se",
            helper: !1,
            maxHeight: null,
            maxWidth: null,
            minHeight: 10,
            minWidth: 10,
            zIndex: 90,
            resize: null,
            start: null,
            stop: null
        },
        _num: function (e) {
            return parseFloat(e) || 0
        },
        _isNumber: function (e) {
            return !isNaN(parseFloat(e))
        },
        _hasScroll: function (t, i) {
            if ("hidden" === e(t).css("overflow"))return !1;
            var s = i && "left" === i ? "scrollLeft" : "scrollTop", n = !1;
            return t[s] > 0 ? !0 : (t[s] = 1, n = t[s] > 0, t[s] = 0, n)
        },
        _create: function () {
            var t, i = this.options, s = this;
            this._addClass("ui-resizable"), e.extend(this, {
                _aspectRatio: !!i.aspectRatio,
                aspectRatio: i.aspectRatio,
                originalElement: this.element,
                _proportionallyResizeElements: [],
                _helper: i.helper || i.ghost || i.animate ? i.helper || "ui-resizable-helper" : null
            }), this.element[0].nodeName.match(/^(canvas|textarea|input|select|button|img)$/i) && (this.element.wrap(e("<div class='ui-wrapper' style='overflow: hidden;'></div>").css({
                position: this.element.css("position"),
                width: this.element.outerWidth(),
                height: this.element.outerHeight(),
                top: this.element.css("top"),
                left: this.element.css("left")
            })), this.element = this.element.parent().data("ui-resizable", this.element.resizable("instance")), this.elementIsWrapper = !0, t = {
                marginTop: this.originalElement.css("marginTop"),
                marginRight: this.originalElement.css("marginRight"),
                marginBottom: this.originalElement.css("marginBottom"),
                marginLeft: this.originalElement.css("marginLeft")
            }, this.element.css(t), this.originalElement.css("margin", 0), this.originalResizeStyle = this.originalElement.css("resize"), this.originalElement.css("resize", "none"), this._proportionallyResizeElements.push(this.originalElement.css({
                position: "static",
                zoom: 1,
                display: "block"
            })), this.originalElement.css(t), this._proportionallyResize()), this._setupHandles(), i.autoHide && e(this.element).on("mouseenter", function () {
                i.disabled || (s._removeClass("ui-resizable-autohide"), s._handles.show())
            }).on("mouseleave", function () {
                i.disabled || s.resizing || (s._addClass("ui-resizable-autohide"), s._handles.hide())
            }), this._mouseInit()
        },
        _destroy: function () {
            this._mouseDestroy();
            var t, i = function (t) {
                e(t).removeData("resizable").removeData("ui-resizable").off(".resizable").find(".ui-resizable-handle").remove()
            };
            return this.elementIsWrapper && (i(this.element), t = this.element, this.originalElement.css({
                position: t.css("position"),
                width: t.outerWidth(),
                height: t.outerHeight(),
                top: t.css("top"),
                left: t.css("left")
            }).insertAfter(t), t.remove()), this.originalElement.css("resize", this.originalResizeStyle), i(this.originalElement), this
        },
        _setOption: function (e, t) {
            switch (this._super(e, t), e) {
                case"handles":
                    this._removeHandles(), this._setupHandles();
                    break;
                default:
            }
        },
        _setupHandles: function () {
            var t, i, s, n, a, o = this.options, r = this;
            if (this.handles = o.handles || (e(".ui-resizable-handle", this.element).length ? {
                            n: ".ui-resizable-n",
                            e: ".ui-resizable-e",
                            s: ".ui-resizable-s",
                            w: ".ui-resizable-w",
                            se: ".ui-resizable-se",
                            sw: ".ui-resizable-sw",
                            ne: ".ui-resizable-ne",
                            nw: ".ui-resizable-nw"
                        } : "e,s,se"), this._handles = e(), this.handles.constructor === String)for ("all" === this.handles && (this.handles = "n,e,s,w,se,sw,ne,nw"), s = this.handles.split(","), this.handles = {}, i = 0; s.length > i; i++)t = e.trim(s[i]), n = "ui-resizable-" + t, a = e("<div>"), this._addClass(a, "ui-resizable-handle " + n), a.css({zIndex: o.zIndex}), this.handles[t] = ".ui-resizable-" + t, this.element.append(a);
            this._renderAxis = function (t) {
                var i, s, n, a;
                t = t || this.element;
                for (i in this.handles)this.handles[i].constructor === String ? this.handles[i] = this.element.children(this.handles[i]).first().show() : (this.handles[i].jquery || this.handles[i].nodeType) && (this.handles[i] = e(this.handles[i]), this._on(this.handles[i], {mousedown: r._mouseDown})), this.elementIsWrapper && this.originalElement[0].nodeName.match(/^(textarea|input|select|button)$/i) && (s = e(this.handles[i], this.element), a = /sw|ne|nw|se|n|s/.test(i) ? s.outerHeight() : s.outerWidth(), n = ["padding", /ne|nw|n/.test(i) ? "Top" : /se|sw|s/.test(i) ? "Bottom" : /^e$/.test(i) ? "Right" : "Left"].join(""), t.css(n, a), this._proportionallyResize()), this._handles = this._handles.add(this.handles[i])
            }, this._renderAxis(this.element), this._handles = this._handles.add(this.element.find(".ui-resizable-handle")), this._handles.disableSelection(), this._handles.on("mouseover", function () {
                r.resizing || (this.className && (a = this.className.match(/ui-resizable-(se|sw|ne|nw|n|e|s|w)/i)), r.axis = a && a[1] ? a[1] : "se")
            }), o.autoHide && (this._handles.hide(), this._addClass("ui-resizable-autohide"))
        },
        _removeHandles: function () {
            this._handles.remove()
        },
        _mouseCapture: function (t) {
            var i, s, n = !1;
            for (i in this.handles)s = e(this.handles[i])[0], (s === t.target || e.contains(s, t.target)) && (n = !0);
            return !this.options.disabled && n
        },
        _mouseStart: function (t) {
            var i, s, n, a = this.options, o = this.element;
            return this.resizing = !0, this._renderProxy(), i = this._num(this.helper.css("left")), s = this._num(this.helper.css("top")), a.containment && (i += e(a.containment).scrollLeft() || 0, s += e(a.containment).scrollTop() || 0), this.offset = this.helper.offset(), this.position = {
                left: i,
                top: s
            }, this.size = this._helper ? {
                    width: this.helper.width(),
                    height: this.helper.height()
                } : {width: o.width(), height: o.height()}, this.originalSize = this._helper ? {
                    width: o.outerWidth(),
                    height: o.outerHeight()
                } : {width: o.width(), height: o.height()}, this.sizeDiff = {
                width: o.outerWidth() - o.width(),
                height: o.outerHeight() - o.height()
            }, this.originalPosition = {left: i, top: s}, this.originalMousePosition = {
                left: t.pageX,
                top: t.pageY
            }, this.aspectRatio = "number" == typeof a.aspectRatio ? a.aspectRatio : this.originalSize.width / this.originalSize.height || 1, n = e(".ui-resizable-" + this.axis).css("cursor"), e("body").css("cursor", "auto" === n ? this.axis + "-resize" : n), this._addClass("ui-resizable-resizing"), this._propagate("start", t), !0
        },
        _mouseDrag: function (t) {
            var i, s, n = this.originalMousePosition, a = this.axis, o = t.pageX - n.left || 0, r = t.pageY - n.top || 0, h = this._change[a];
            return this._updatePrevProperties(), h ? (i = h.apply(this, [t, o, r]), this._updateVirtualBoundaries(t.shiftKey), (this._aspectRatio || t.shiftKey) && (i = this._updateRatio(i, t)), i = this._respectSize(i, t), this._updateCache(i), this._propagate("resize", t), s = this._applyChanges(), !this._helper && this._proportionallyResizeElements.length && this._proportionallyResize(), e.isEmptyObject(s) || (this._updatePrevProperties(), this._trigger("resize", t, this.ui()), this._applyChanges()), !1) : !1
        },
        _mouseStop: function (t) {
            this.resizing = !1;
            var i, s, n, a, o, r, h, l = this.options, u = this;
            return this._helper && (i = this._proportionallyResizeElements, s = i.length && /textarea/i.test(i[0].nodeName), n = s && this._hasScroll(i[0], "left") ? 0 : u.sizeDiff.height, a = s ? 0 : u.sizeDiff.width, o = {
                width: u.helper.width() - a,
                height: u.helper.height() - n
            }, r = parseFloat(u.element.css("left")) + (u.position.left - u.originalPosition.left) || null, h = parseFloat(u.element.css("top")) + (u.position.top - u.originalPosition.top) || null, l.animate || this.element.css(e.extend(o, {
                top: h,
                left: r
            })), u.helper.height(u.size.height), u.helper.width(u.size.width), this._helper && !l.animate && this._proportionallyResize()), e("body").css("cursor", "auto"), this._removeClass("ui-resizable-resizing"), this._propagate("stop", t), this._helper && this.helper.remove(), !1
        },
        _updatePrevProperties: function () {
            this.prevPosition = {
                top: this.position.top,
                left: this.position.left
            }, this.prevSize = {width: this.size.width, height: this.size.height}
        },
        _applyChanges: function () {
            var e = {};
            return this.position.top !== this.prevPosition.top && (e.top = this.position.top + "px"), this.position.left !== this.prevPosition.left && (e.left = this.position.left + "px"), this.size.width !== this.prevSize.width && (e.width = this.size.width + "px"), this.size.height !== this.prevSize.height && (e.height = this.size.height + "px"), this.helper.css(e), e
        },
        _updateVirtualBoundaries: function (e) {
            var t, i, s, n, a, o = this.options;
            a = {
                minWidth: this._isNumber(o.minWidth) ? o.minWidth : 0,
                maxWidth: this._isNumber(o.maxWidth) ? o.maxWidth : 1 / 0,
                minHeight: this._isNumber(o.minHeight) ? o.minHeight : 0,
                maxHeight: this._isNumber(o.maxHeight) ? o.maxHeight : 1 / 0
            }, (this._aspectRatio || e) && (t = a.minHeight * this.aspectRatio, s = a.minWidth / this.aspectRatio, i = a.maxHeight * this.aspectRatio, n = a.maxWidth / this.aspectRatio, t > a.minWidth && (a.minWidth = t), s > a.minHeight && (a.minHeight = s), a.maxWidth > i && (a.maxWidth = i), a.maxHeight > n && (a.maxHeight = n)), this._vBoundaries = a
        },
        _updateCache: function (e) {
            this.offset = this.helper.offset(), this._isNumber(e.left) && (this.position.left = e.left), this._isNumber(e.top) && (this.position.top = e.top), this._isNumber(e.height) && (this.size.height = e.height), this._isNumber(e.width) && (this.size.width = e.width)
        },
        _updateRatio: function (e) {
            var t = this.position, i = this.size, s = this.axis;
            return this._isNumber(e.height) ? e.width = e.height * this.aspectRatio : this._isNumber(e.width) && (e.height = e.width / this.aspectRatio), "sw" === s && (e.left = t.left + (i.width - e.width), e.top = null), "nw" === s && (e.top = t.top + (i.height - e.height), e.left = t.left + (i.width - e.width)), e
        },
        _respectSize: function (e) {
            var t = this._vBoundaries, i = this.axis, s = this._isNumber(e.width) && t.maxWidth && t.maxWidth < e.width, n = this._isNumber(e.height) && t.maxHeight && t.maxHeight < e.height, a = this._isNumber(e.width) && t.minWidth && t.minWidth > e.width, o = this._isNumber(e.height) && t.minHeight && t.minHeight > e.height, r = this.originalPosition.left + this.originalSize.width, h = this.originalPosition.top + this.originalSize.height, l = /sw|nw|w/.test(i), u = /nw|ne|n/.test(i);
            return a && (e.width = t.minWidth), o && (e.height = t.minHeight), s && (e.width = t.maxWidth), n && (e.height = t.maxHeight), a && l && (e.left = r - t.minWidth), s && l && (e.left = r - t.maxWidth), o && u && (e.top = h - t.minHeight), n && u && (e.top = h - t.maxHeight), e.width || e.height || e.left || !e.top ? e.width || e.height || e.top || !e.left || (e.left = null) : e.top = null, e
        },
        _getPaddingPlusBorderDimensions: function (e) {
            for (var t = 0, i = [], s = [e.css("borderTopWidth"), e.css("borderRightWidth"), e.css("borderBottomWidth"), e.css("borderLeftWidth")], n = [e.css("paddingTop"), e.css("paddingRight"), e.css("paddingBottom"), e.css("paddingLeft")]; 4 > t; t++)i[t] = parseFloat(s[t]) || 0, i[t] += parseFloat(n[t]) || 0;
            return {height: i[0] + i[2], width: i[1] + i[3]}
        },
        _proportionallyResize: function () {
            if (this._proportionallyResizeElements.length)for (var e, t = 0, i = this.helper || this.element; this._proportionallyResizeElements.length > t; t++)e = this._proportionallyResizeElements[t], this.outerDimensions || (this.outerDimensions = this._getPaddingPlusBorderDimensions(e)), e.css({
                height: i.height() - this.outerDimensions.height || 0,
                width: i.width() - this.outerDimensions.width || 0
            })
        },
        _renderProxy: function () {
            var t = this.element, i = this.options;
            this.elementOffset = t.offset(), this._helper ? (this.helper = this.helper || e("<div style='overflow:hidden;'></div>"), this._addClass(this.helper, this._helper), this.helper.css({
                    width: this.element.outerWidth(),
                    height: this.element.outerHeight(),
                    position: "absolute",
                    left: this.elementOffset.left + "px",
                    top: this.elementOffset.top + "px",
                    zIndex: ++i.zIndex
                }), this.helper.appendTo("body").disableSelection()) : this.helper = this.element
        },
        _change: {
            e: function (e, t) {
                return {width: this.originalSize.width + t}
            }, w: function (e, t) {
                var i = this.originalSize, s = this.originalPosition;
                return {left: s.left + t, width: i.width - t}
            }, n: function (e, t, i) {
                var s = this.originalSize, n = this.originalPosition;
                return {top: n.top + i, height: s.height - i}
            }, s: function (e, t, i) {
                return {height: this.originalSize.height + i}
            }, se: function (t, i, s) {
                return e.extend(this._change.s.apply(this, arguments), this._change.e.apply(this, [t, i, s]))
            }, sw: function (t, i, s) {
                return e.extend(this._change.s.apply(this, arguments), this._change.w.apply(this, [t, i, s]))
            }, ne: function (t, i, s) {
                return e.extend(this._change.n.apply(this, arguments), this._change.e.apply(this, [t, i, s]))
            }, nw: function (t, i, s) {
                return e.extend(this._change.n.apply(this, arguments), this._change.w.apply(this, [t, i, s]))
            }
        },
        _propagate: function (t, i) {
            e.ui.plugin.call(this, t, [i, this.ui()]), "resize" !== t && this._trigger(t, i, this.ui())
        },
        plugins: {},
        ui: function () {
            return {
                originalElement: this.originalElement,
                element: this.element,
                helper: this.helper,
                position: this.position,
                size: this.size,
                originalSize: this.originalSize,
                originalPosition: this.originalPosition
            }
        }
    }), e.ui.plugin.add("resizable", "animate", {
        stop: function (t) {
            var i = e(this).resizable("instance"), s = i.options, n = i._proportionallyResizeElements, a = n.length && /textarea/i.test(n[0].nodeName), o = a && i._hasScroll(n[0], "left") ? 0 : i.sizeDiff.height, r = a ? 0 : i.sizeDiff.width, h = {
                width: i.size.width - r,
                height: i.size.height - o
            }, l = parseFloat(i.element.css("left")) + (i.position.left - i.originalPosition.left) || null, u = parseFloat(i.element.css("top")) + (i.position.top - i.originalPosition.top) || null;
            i.element.animate(e.extend(h, u && l ? {top: u, left: l} : {}), {
                duration: s.animateDuration,
                easing: s.animateEasing,
                step: function () {
                    var s = {
                        width: parseFloat(i.element.css("width")),
                        height: parseFloat(i.element.css("height")),
                        top: parseFloat(i.element.css("top")),
                        left: parseFloat(i.element.css("left"))
                    };
                    n && n.length && e(n[0]).css({
                        width: s.width,
                        height: s.height
                    }), i._updateCache(s), i._propagate("resize", t)
                }
            })
        }
    }), e.ui.plugin.add("resizable", "containment", {
        start: function () {
            var t, i, s, n, a, o, r, h = e(this).resizable("instance"), l = h.options, u = h.element, c = l.containment, d = c instanceof e ? c.get(0) : /parent/.test(c) ? u.parent().get(0) : c;
            d && (h.containerElement = e(d), /document/.test(c) || c === document ? (h.containerOffset = {
                    left: 0,
                    top: 0
                }, h.containerPosition = {left: 0, top: 0}, h.parentData = {
                    element: e(document),
                    left: 0,
                    top: 0,
                    width: e(document).width(),
                    height: e(document).height() || document.body.parentNode.scrollHeight
                }) : (t = e(d), i = [], e(["Top", "Right", "Left", "Bottom"]).each(function (e, s) {
                    i[e] = h._num(t.css("padding" + s))
                }), h.containerOffset = t.offset(), h.containerPosition = t.position(), h.containerSize = {
                    height: t.innerHeight() - i[3],
                    width: t.innerWidth() - i[1]
                }, s = h.containerOffset, n = h.containerSize.height, a = h.containerSize.width, o = h._hasScroll(d, "left") ? d.scrollWidth : a, r = h._hasScroll(d) ? d.scrollHeight : n, h.parentData = {
                    element: d,
                    left: s.left,
                    top: s.top,
                    width: o,
                    height: r
                }))
        }, resize: function (t) {
            var i, s, n, a, o = e(this).resizable("instance"), r = o.options, h = o.containerOffset, l = o.position, u = o._aspectRatio || t.shiftKey, c = {
                top: 0,
                left: 0
            }, d = o.containerElement, p = !0;
            d[0] !== document && /static/.test(d.css("position")) && (c = h), l.left < (o._helper ? h.left : 0) && (o.size.width = o.size.width + (o._helper ? o.position.left - h.left : o.position.left - c.left), u && (o.size.height = o.size.width / o.aspectRatio, p = !1), o.position.left = r.helper ? h.left : 0), l.top < (o._helper ? h.top : 0) && (o.size.height = o.size.height + (o._helper ? o.position.top - h.top : o.position.top), u && (o.size.width = o.size.height * o.aspectRatio, p = !1), o.position.top = o._helper ? h.top : 0), n = o.containerElement.get(0) === o.element.parent().get(0), a = /relative|absolute/.test(o.containerElement.css("position")), n && a ? (o.offset.left = o.parentData.left + o.position.left, o.offset.top = o.parentData.top + o.position.top) : (o.offset.left = o.element.offset().left, o.offset.top = o.element.offset().top), i = Math.abs(o.sizeDiff.width + (o._helper ? o.offset.left - c.left : o.offset.left - h.left)), s = Math.abs(o.sizeDiff.height + (o._helper ? o.offset.top - c.top : o.offset.top - h.top)), i + o.size.width >= o.parentData.width && (o.size.width = o.parentData.width - i, u && (o.size.height = o.size.width / o.aspectRatio, p = !1)), s + o.size.height >= o.parentData.height && (o.size.height = o.parentData.height - s, u && (o.size.width = o.size.height * o.aspectRatio, p = !1)), p || (o.position.left = o.prevPosition.left, o.position.top = o.prevPosition.top, o.size.width = o.prevSize.width, o.size.height = o.prevSize.height)
        }, stop: function () {
            var t = e(this).resizable("instance"), i = t.options, s = t.containerOffset, n = t.containerPosition, a = t.containerElement, o = e(t.helper), r = o.offset(), h = o.outerWidth() - t.sizeDiff.width, l = o.outerHeight() - t.sizeDiff.height;
            t._helper && !i.animate && /relative/.test(a.css("position")) && e(this).css({
                left: r.left - n.left - s.left,
                width: h,
                height: l
            }), t._helper && !i.animate && /static/.test(a.css("position")) && e(this).css({
                left: r.left - n.left - s.left,
                width: h,
                height: l
            })
        }
    }), e.ui.plugin.add("resizable", "alsoResize", {
        start: function () {
            var t = e(this).resizable("instance"), i = t.options;
            e(i.alsoResize).each(function () {
                var t = e(this);
                t.data("ui-resizable-alsoresize", {
                    width: parseFloat(t.width()),
                    height: parseFloat(t.height()),
                    left: parseFloat(t.css("left")),
                    top: parseFloat(t.css("top"))
                })
            })
        }, resize: function (t, i) {
            var s = e(this).resizable("instance"), n = s.options, a = s.originalSize, o = s.originalPosition, r = {
                height: s.size.height - a.height || 0,
                width: s.size.width - a.width || 0,
                top: s.position.top - o.top || 0,
                left: s.position.left - o.left || 0
            };
            e(n.alsoResize).each(function () {
                var t = e(this), s = e(this).data("ui-resizable-alsoresize"), n = {}, a = t.parents(i.originalElement[0]).length ? ["width", "height"] : ["width", "height", "top", "left"];
                e.each(a, function (e, t) {
                    var i = (s[t] || 0) + (r[t] || 0);
                    i && i >= 0 && (n[t] = i || null)
                }), t.css(n)
            })
        }, stop: function () {
            e(this).removeData("ui-resizable-alsoresize")
        }
    }), e.ui.plugin.add("resizable", "ghost", {
        start: function () {
            var t = e(this).resizable("instance"), i = t.size;
            t.ghost = t.originalElement.clone(), t.ghost.css({
                opacity: .25,
                display: "block",
                position: "relative",
                height: i.height,
                width: i.width,
                margin: 0,
                left: 0,
                top: 0
            }), t._addClass(t.ghost, "ui-resizable-ghost"), e.uiBackCompat !== !1 && "string" == typeof t.options.ghost && t.ghost.addClass(this.options.ghost), t.ghost.appendTo(t.helper)
        }, resize: function () {
            var t = e(this).resizable("instance");
            t.ghost && t.ghost.css({position: "relative", height: t.size.height, width: t.size.width})
        }, stop: function () {
            var t = e(this).resizable("instance");
            t.ghost && t.helper && t.helper.get(0).removeChild(t.ghost.get(0))
        }
    }), e.ui.plugin.add("resizable", "grid", {
        resize: function () {
            var t, i = e(this).resizable("instance"), s = i.options, n = i.size, a = i.originalSize, o = i.originalPosition, r = i.axis, h = "number" == typeof s.grid ? [s.grid, s.grid] : s.grid, l = h[0] || 1, u = h[1] || 1, c = Math.round((n.width - a.width) / l) * l, d = Math.round((n.height - a.height) / u) * u, p = a.width + c, f = a.height + d, m = s.maxWidth && p > s.maxWidth, g = s.maxHeight && f > s.maxHeight, v = s.minWidth && s.minWidth > p, _ = s.minHeight && s.minHeight > f;
            s.grid = h, v && (p += l), _ && (f += u), m && (p -= l), g && (f -= u), /^(se|s|e)$/.test(r) ? (i.size.width = p, i.size.height = f) : /^(ne)$/.test(r) ? (i.size.width = p, i.size.height = f, i.position.top = o.top - d) : /^(sw)$/.test(r) ? (i.size.width = p, i.size.height = f, i.position.left = o.left - c) : ((0 >= f - u || 0 >= p - l) && (t = i._getPaddingPlusBorderDimensions(this)), f - u > 0 ? (i.size.height = f, i.position.top = o.top - d) : (f = u - t.height, i.size.height = f, i.position.top = o.top + a.height - f), p - l > 0 ? (i.size.width = p, i.position.left = o.left - c) : (p = l - t.width, i.size.width = p, i.position.left = o.left + a.width - p))
        }
    }), e.ui.resizable, e.widget("ui.selectable", e.ui.mouse, {
        version: "1.12.1",
        options: {
            appendTo: "body",
            autoRefresh: !0,
            distance: 0,
            filter: "*",
            tolerance: "touch",
            selected: null,
            selecting: null,
            start: null,
            stop: null,
            unselected: null,
            unselecting: null
        },
        _create: function () {
            var t = this;
            this._addClass("ui-selectable"), this.dragged = !1, this.refresh = function () {
                t.elementPos = e(t.element[0]).offset(), t.selectees = e(t.options.filter, t.element[0]), t._addClass(t.selectees, "ui-selectee"), t.selectees.each(function () {
                    var i = e(this), s = i.offset(), n = {
                        left: s.left - t.elementPos.left,
                        top: s.top - t.elementPos.top
                    };
                    e.data(this, "selectable-item", {
                        element: this,
                        $element: i,
                        left: n.left,
                        top: n.top,
                        right: n.left + i.outerWidth(),
                        bottom: n.top + i.outerHeight(),
                        startselected: !1,
                        selected: i.hasClass("ui-selected"),
                        selecting: i.hasClass("ui-selecting"),
                        unselecting: i.hasClass("ui-unselecting")
                    })
                })
            }, this.refresh(), this._mouseInit(), this.helper = e("<div>"), this._addClass(this.helper, "ui-selectable-helper")
        },
        _destroy: function () {
            this.selectees.removeData("selectable-item"), this._mouseDestroy()
        },
        _mouseStart: function (t) {
            var i = this, s = this.options;
            this.opos = [t.pageX, t.pageY], this.elementPos = e(this.element[0]).offset(), this.options.disabled || (this.selectees = e(s.filter, this.element[0]), this._trigger("start", t), e(s.appendTo).append(this.helper), this.helper.css({
                left: t.pageX,
                top: t.pageY,
                width: 0,
                height: 0
            }), s.autoRefresh && this.refresh(), this.selectees.filter(".ui-selected").each(function () {
                var s = e.data(this, "selectable-item");
                s.startselected = !0, t.metaKey || t.ctrlKey || (i._removeClass(s.$element, "ui-selected"), s.selected = !1, i._addClass(s.$element, "ui-unselecting"), s.unselecting = !0, i._trigger("unselecting", t, {unselecting: s.element}))
            }), e(t.target).parents().addBack().each(function () {
                var s, n = e.data(this, "selectable-item");
                return n ? (s = !t.metaKey && !t.ctrlKey || !n.$element.hasClass("ui-selected"), i._removeClass(n.$element, s ? "ui-unselecting" : "ui-selected")._addClass(n.$element, s ? "ui-selecting" : "ui-unselecting"), n.unselecting = !s, n.selecting = s, n.selected = s, s ? i._trigger("selecting", t, {selecting: n.element}) : i._trigger("unselecting", t, {unselecting: n.element}), !1) : void 0
            }))
        },
        _mouseDrag: function (t) {
            if (this.dragged = !0, !this.options.disabled) {
                var i, s = this, n = this.options, a = this.opos[0], o = this.opos[1], r = t.pageX, h = t.pageY;
                return a > r && (i = r, r = a, a = i), o > h && (i = h, h = o, o = i), this.helper.css({
                    left: a,
                    top: o,
                    width: r - a,
                    height: h - o
                }), this.selectees.each(function () {
                    var i = e.data(this, "selectable-item"), l = !1, u = {};
                    i && i.element !== s.element[0] && (u.left = i.left + s.elementPos.left, u.right = i.right + s.elementPos.left, u.top = i.top + s.elementPos.top, u.bottom = i.bottom + s.elementPos.top, "touch" === n.tolerance ? l = !(u.left > r || a > u.right || u.top > h || o > u.bottom) : "fit" === n.tolerance && (l = u.left > a && r > u.right && u.top > o && h > u.bottom), l ? (i.selected && (s._removeClass(i.$element, "ui-selected"), i.selected = !1), i.unselecting && (s._removeClass(i.$element, "ui-unselecting"), i.unselecting = !1), i.selecting || (s._addClass(i.$element, "ui-selecting"), i.selecting = !0, s._trigger("selecting", t, {selecting: i.element}))) : (i.selecting && ((t.metaKey || t.ctrlKey) && i.startselected ? (s._removeClass(i.$element, "ui-selecting"), i.selecting = !1, s._addClass(i.$element, "ui-selected"), i.selected = !0) : (s._removeClass(i.$element, "ui-selecting"), i.selecting = !1, i.startselected && (s._addClass(i.$element, "ui-unselecting"), i.unselecting = !0), s._trigger("unselecting", t, {unselecting: i.element}))), i.selected && (t.metaKey || t.ctrlKey || i.startselected || (s._removeClass(i.$element, "ui-selected"), i.selected = !1, s._addClass(i.$element, "ui-unselecting"), i.unselecting = !0, s._trigger("unselecting", t, {unselecting: i.element})))))
                }), !1
            }
        },
        _mouseStop: function (t) {
            var i = this;
            return this.dragged = !1, e(".ui-unselecting", this.element[0]).each(function () {
                var s = e.data(this, "selectable-item");
                i._removeClass(s.$element, "ui-unselecting"), s.unselecting = !1, s.startselected = !1, i._trigger("unselected", t, {unselected: s.element})
            }), e(".ui-selecting", this.element[0]).each(function () {
                var s = e.data(this, "selectable-item");
                i._removeClass(s.$element, "ui-selecting")._addClass(s.$element, "ui-selected"), s.selecting = !1, s.selected = !0, s.startselected = !0, i._trigger("selected", t, {selected: s.element})
            }), this._trigger("stop", t), this.helper.remove(), !1
        }
    }), e.widget("ui.sortable", e.ui.mouse, {
        version: "1.12.1",
        widgetEventPrefix: "sort",
        ready: !1,
        options: {
            appendTo: "parent",
            axis: !1,
            connectWith: !1,
            containment: !1,
            cursor: "auto",
            cursorAt: !1,
            dropOnEmpty: !0,
            forcePlaceholderSize: !1,
            forceHelperSize: !1,
            grid: !1,
            handle: !1,
            helper: "original",
            items: "> *",
            opacity: !1,
            placeholder: !1,
            revert: !1,
            scroll: !0,
            scrollSensitivity: 20,
            scrollSpeed: 20,
            scope: "default",
            tolerance: "intersect",
            zIndex: 1e3,
            activate: null,
            beforeStop: null,
            change: null,
            deactivate: null,
            out: null,
            over: null,
            receive: null,
            remove: null,
            sort: null,
            start: null,
            stop: null,
            update: null
        },
        _isOverAxis: function (e, t, i) {
            return e >= t && t + i > e
        },
        _isFloating: function (e) {
            return /left|right/.test(e.css("float")) || /inline|table-cell/.test(e.css("display"))
        },
        _create: function () {
            this.containerCache = {}, this._addClass("ui-sortable"), this.refresh(), this.offset = this.element.offset(), this._mouseInit(), this._setHandleClassName(), this.ready = !0
        },
        _setOption: function (e, t) {
            this._super(e, t), "handle" === e && this._setHandleClassName()
        },
        _setHandleClassName: function () {
            var t = this;
            this._removeClass(this.element.find(".ui-sortable-handle"), "ui-sortable-handle"), e.each(this.items, function () {
                t._addClass(this.instance.options.handle ? this.item.find(this.instance.options.handle) : this.item, "ui-sortable-handle")
            })
        },
        _destroy: function () {
            this._mouseDestroy();
            for (var e = this.items.length - 1; e >= 0; e--)this.items[e].item.removeData(this.widgetName + "-item");
            return this
        },
        _mouseCapture: function (t, i) {
            var s = null, n = !1, a = this;
            return this.reverting ? !1 : this.options.disabled || "static" === this.options.type ? !1 : (this._refreshItems(t), e(t.target).parents().each(function () {
                        return e.data(this, a.widgetName + "-item") === a ? (s = e(this), !1) : void 0
                    }), e.data(t.target, a.widgetName + "-item") === a && (s = e(t.target)), s ? !this.options.handle || i || (e(this.options.handle, s).find("*").addBack().each(function () {
                            this === t.target && (n = !0)
                        }), n) ? (this.currentItem = s, this._removeCurrentsFromItems(), !0) : !1 : !1)
        },
        _mouseStart: function (t, i, s) {
            var n, a, o = this.options;
            if (this.currentContainer = this, this.refreshPositions(), this.helper = this._createHelper(t), this._cacheHelperProportions(), this._cacheMargins(), this.scrollParent = this.helper.scrollParent(), this.offset = this.currentItem.offset(), this.offset = {
                    top: this.offset.top - this.margins.top,
                    left: this.offset.left - this.margins.left
                }, e.extend(this.offset, {
                    click: {left: t.pageX - this.offset.left, top: t.pageY - this.offset.top},
                    parent: this._getParentOffset(),
                    relative: this._getRelativeOffset()
                }), this.helper.css("position", "absolute"), this.cssPosition = this.helper.css("position"), this.originalPosition = this._generatePosition(t), this.originalPageX = t.pageX, this.originalPageY = t.pageY, o.cursorAt && this._adjustOffsetFromHelper(o.cursorAt), this.domPosition = {
                    prev: this.currentItem.prev()[0],
                    parent: this.currentItem.parent()[0]
                }, this.helper[0] !== this.currentItem[0] && this.currentItem.hide(), this._createPlaceholder(), o.containment && this._setContainment(), o.cursor && "auto" !== o.cursor && (a = this.document.find("body"), this.storedCursor = a.css("cursor"), a.css("cursor", o.cursor), this.storedStylesheet = e("<style>*{ cursor: " + o.cursor + " !important; }</style>").appendTo(a)), o.opacity && (this.helper.css("opacity") && (this._storedOpacity = this.helper.css("opacity")), this.helper.css("opacity", o.opacity)), o.zIndex && (this.helper.css("zIndex") && (this._storedZIndex = this.helper.css("zIndex")), this.helper.css("zIndex", o.zIndex)), this.scrollParent[0] !== this.document[0] && "HTML" !== this.scrollParent[0].tagName && (this.overflowOffset = this.scrollParent.offset()), this._trigger("start", t, this._uiHash()), this._preserveHelperProportions || this._cacheHelperProportions(), !s)for (n = this.containers.length - 1; n >= 0; n--)this.containers[n]._trigger("activate", t, this._uiHash(this));
            return e.ui.ddmanager && (e.ui.ddmanager.current = this), e.ui.ddmanager && !o.dropBehaviour && e.ui.ddmanager.prepareOffsets(this, t), this.dragging = !0, this._addClass(this.helper, "ui-sortable-helper"), this._mouseDrag(t), !0
        },
        _mouseDrag: function (t) {
            var i, s, n, a, o = this.options, r = !1;
            for (this.position = this._generatePosition(t), this.positionAbs = this._convertPositionTo("absolute"), this.lastPositionAbs || (this.lastPositionAbs = this.positionAbs), this.options.scroll && (this.scrollParent[0] !== this.document[0] && "HTML" !== this.scrollParent[0].tagName ? (this.overflowOffset.top + this.scrollParent[0].offsetHeight - t.pageY < o.scrollSensitivity ? this.scrollParent[0].scrollTop = r = this.scrollParent[0].scrollTop + o.scrollSpeed : t.pageY - this.overflowOffset.top < o.scrollSensitivity && (this.scrollParent[0].scrollTop = r = this.scrollParent[0].scrollTop - o.scrollSpeed), this.overflowOffset.left + this.scrollParent[0].offsetWidth - t.pageX < o.scrollSensitivity ? this.scrollParent[0].scrollLeft = r = this.scrollParent[0].scrollLeft + o.scrollSpeed : t.pageX - this.overflowOffset.left < o.scrollSensitivity && (this.scrollParent[0].scrollLeft = r = this.scrollParent[0].scrollLeft - o.scrollSpeed)) : (t.pageY - this.document.scrollTop() < o.scrollSensitivity ? r = this.document.scrollTop(this.document.scrollTop() - o.scrollSpeed) : this.window.height() - (t.pageY - this.document.scrollTop()) < o.scrollSensitivity && (r = this.document.scrollTop(this.document.scrollTop() + o.scrollSpeed)), t.pageX - this.document.scrollLeft() < o.scrollSensitivity ? r = this.document.scrollLeft(this.document.scrollLeft() - o.scrollSpeed) : this.window.width() - (t.pageX - this.document.scrollLeft()) < o.scrollSensitivity && (r = this.document.scrollLeft(this.document.scrollLeft() + o.scrollSpeed))), r !== !1 && e.ui.ddmanager && !o.dropBehaviour && e.ui.ddmanager.prepareOffsets(this, t)), this.positionAbs = this._convertPositionTo("absolute"), this.options.axis && "y" === this.options.axis || (this.helper[0].style.left = this.position.left + "px"), this.options.axis && "x" === this.options.axis || (this.helper[0].style.top = this.position.top + "px"), i = this.items.length - 1; i >= 0; i--)if (s = this.items[i], n = s.item[0], a = this._intersectsWithPointer(s), a && s.instance === this.currentContainer && n !== this.currentItem[0] && this.placeholder[1 === a ? "next" : "prev"]()[0] !== n && !e.contains(this.placeholder[0], n) && ("semi-dynamic" === this.options.type ? !e.contains(this.element[0], n) : !0)) {
                if (this.direction = 1 === a ? "down" : "up", "pointer" !== this.options.tolerance && !this._intersectsWithSides(s))break;
                this._rearrange(t, s), this._trigger("change", t, this._uiHash());
                break
            }
            return this._contactContainers(t), e.ui.ddmanager && e.ui.ddmanager.drag(this, t), this._trigger("sort", t, this._uiHash()), this.lastPositionAbs = this.positionAbs, !1
        },
        _mouseStop: function (t, i) {
            if (t) {
                if (e.ui.ddmanager && !this.options.dropBehaviour && e.ui.ddmanager.drop(this, t), this.options.revert) {
                    var s = this, n = this.placeholder.offset(), a = this.options.axis, o = {};
                    a && "x" !== a || (o.left = n.left - this.offset.parent.left - this.margins.left + (this.offsetParent[0] === this.document[0].body ? 0 : this.offsetParent[0].scrollLeft)), a && "y" !== a || (o.top = n.top - this.offset.parent.top - this.margins.top + (this.offsetParent[0] === this.document[0].body ? 0 : this.offsetParent[0].scrollTop)), this.reverting = !0, e(this.helper).animate(o, parseInt(this.options.revert, 10) || 500, function () {
                        s._clear(t)
                    })
                } else this._clear(t, i);
                return !1
            }
        },
        cancel: function () {
            if (this.dragging) {
                this._mouseUp(new e.Event("mouseup", {target: null})), "original" === this.options.helper ? (this.currentItem.css(this._storedCSS), this._removeClass(this.currentItem, "ui-sortable-helper")) : this.currentItem.show();
                for (var t = this.containers.length - 1; t >= 0; t--)this.containers[t]._trigger("deactivate", null, this._uiHash(this)), this.containers[t].containerCache.over && (this.containers[t]._trigger("out", null, this._uiHash(this)), this.containers[t].containerCache.over = 0)
            }
            return this.placeholder && (this.placeholder[0].parentNode && this.placeholder[0].parentNode.removeChild(this.placeholder[0]), "original" !== this.options.helper && this.helper && this.helper[0].parentNode && this.helper.remove(), e.extend(this, {
                helper: null,
                dragging: !1,
                reverting: !1,
                _noFinalSort: null
            }), this.domPosition.prev ? e(this.domPosition.prev).after(this.currentItem) : e(this.domPosition.parent).prepend(this.currentItem)), this
        },
        serialize: function (t) {
            var i = this._getItemsAsjQuery(t && t.connected), s = [];
            return t = t || {}, e(i).each(function () {
                var i = (e(t.item || this).attr(t.attribute || "id") || "").match(t.expression || /(.+)[\-=_](.+)/);
                i && s.push((t.key || i[1] + "[]") + "=" + (t.key && t.expression ? i[1] : i[2]))
            }), !s.length && t.key && s.push(t.key + "="), s.join("&")
        },
        toArray: function (t) {
            var i = this._getItemsAsjQuery(t && t.connected), s = [];
            return t = t || {}, i.each(function () {
                s.push(e(t.item || this).attr(t.attribute || "id") || "")
            }), s
        },
        _intersectsWith: function (e) {
            var t = this.positionAbs.left, i = t + this.helperProportions.width, s = this.positionAbs.top, n = s + this.helperProportions.height, a = e.left, o = a + e.width, r = e.top, h = r + e.height, l = this.offset.click.top, u = this.offset.click.left, c = "x" === this.options.axis || s + l > r && h > s + l, d = "y" === this.options.axis || t + u > a && o > t + u, p = c && d;
            return "pointer" === this.options.tolerance || this.options.forcePointerForContainers || "pointer" !== this.options.tolerance && this.helperProportions[this.floating ? "width" : "height"] > e[this.floating ? "width" : "height"] ? p : t + this.helperProportions.width / 2 > a && o > i - this.helperProportions.width / 2 && s + this.helperProportions.height / 2 > r && h > n - this.helperProportions.height / 2
        },
        _intersectsWithPointer: function (e) {
            var t, i, s = "x" === this.options.axis || this._isOverAxis(this.positionAbs.top + this.offset.click.top, e.top, e.height), n = "y" === this.options.axis || this._isOverAxis(this.positionAbs.left + this.offset.click.left, e.left, e.width), a = s && n;
            return a ? (t = this._getDragVerticalDirection(), i = this._getDragHorizontalDirection(), this.floating ? "right" === i || "down" === t ? 2 : 1 : t && ("down" === t ? 2 : 1)) : !1
        },
        _intersectsWithSides: function (e) {
            var t = this._isOverAxis(this.positionAbs.top + this.offset.click.top, e.top + e.height / 2, e.height), i = this._isOverAxis(this.positionAbs.left + this.offset.click.left, e.left + e.width / 2, e.width), s = this._getDragVerticalDirection(), n = this._getDragHorizontalDirection();
            return this.floating && n ? "right" === n && i || "left" === n && !i : s && ("down" === s && t || "up" === s && !t)
        },
        _getDragVerticalDirection: function () {
            var e = this.positionAbs.top - this.lastPositionAbs.top;
            return 0 !== e && (e > 0 ? "down" : "up")
        },
        _getDragHorizontalDirection: function () {
            var e = this.positionAbs.left - this.lastPositionAbs.left;
            return 0 !== e && (e > 0 ? "right" : "left")
        },
        refresh: function (e) {
            return this._refreshItems(e), this._setHandleClassName(), this.refreshPositions(), this
        },
        _connectWith: function () {
            var e = this.options;
            return e.connectWith.constructor === String ? [e.connectWith] : e.connectWith
        },
        _getItemsAsjQuery: function (t) {
            function i() {
                r.push(this)
            }

            var s, n, a, o, r = [], h = [], l = this._connectWith();
            if (l && t)for (s = l.length - 1; s >= 0; s--)for (a = e(l[s], this.document[0]), n = a.length - 1; n >= 0; n--)o = e.data(a[n], this.widgetFullName), o && o !== this && !o.options.disabled && h.push([e.isFunction(o.options.items) ? o.options.items.call(o.element) : e(o.options.items, o.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"), o]);
            for (h.push([e.isFunction(this.options.items) ? this.options.items.call(this.element, null, {
                    options: this.options,
                    item: this.currentItem
                }) : e(this.options.items, this.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"), this]), s = h.length - 1; s >= 0; s--)h[s][0].each(i);
            return e(r)
        },
        _removeCurrentsFromItems: function () {
            var t = this.currentItem.find(":data(" + this.widgetName + "-item)");
            this.items = e.grep(this.items, function (e) {
                for (var i = 0; t.length > i; i++)if (t[i] === e.item[0])return !1;
                return !0
            })
        },
        _refreshItems: function (t) {
            this.items = [], this.containers = [this];
            var i, s, n, a, o, r, h, l, u = this.items, c = [[e.isFunction(this.options.items) ? this.options.items.call(this.element[0], t, {item: this.currentItem}) : e(this.options.items, this.element), this]], d = this._connectWith();
            if (d && this.ready)for (i = d.length - 1; i >= 0; i--)for (n = e(d[i], this.document[0]), s = n.length - 1; s >= 0; s--)a = e.data(n[s], this.widgetFullName), a && a !== this && !a.options.disabled && (c.push([e.isFunction(a.options.items) ? a.options.items.call(a.element[0], t, {item: this.currentItem}) : e(a.options.items, a.element), a]), this.containers.push(a));
            for (i = c.length - 1; i >= 0; i--)for (o = c[i][1], r = c[i][0], s = 0, l = r.length; l > s; s++)h = e(r[s]), h.data(this.widgetName + "-item", o), u.push({
                item: h,
                instance: o,
                width: 0,
                height: 0,
                left: 0,
                top: 0
            })
        },
        refreshPositions: function (t) {
            this.floating = this.items.length ? "x" === this.options.axis || this._isFloating(this.items[0].item) : !1, this.offsetParent && this.helper && (this.offset.parent = this._getParentOffset());
            var i, s, n, a;
            for (i = this.items.length - 1; i >= 0; i--)s = this.items[i], s.instance !== this.currentContainer && this.currentContainer && s.item[0] !== this.currentItem[0] || (n = this.options.toleranceElement ? e(this.options.toleranceElement, s.item) : s.item, t || (s.width = n.outerWidth(), s.height = n.outerHeight()), a = n.offset(), s.left = a.left, s.top = a.top);
            if (this.options.custom && this.options.custom.refreshContainers) this.options.custom.refreshContainers.call(this); else for (i = this.containers.length - 1; i >= 0; i--)a = this.containers[i].element.offset(), this.containers[i].containerCache.left = a.left, this.containers[i].containerCache.top = a.top, this.containers[i].containerCache.width = this.containers[i].element.outerWidth(), this.containers[i].containerCache.height = this.containers[i].element.outerHeight();
            return this
        },
        _createPlaceholder: function (t) {
            t = t || this;
            var i, s = t.options;
            s.placeholder && s.placeholder.constructor !== String || (i = s.placeholder, s.placeholder = {
                element: function () {
                    var s = t.currentItem[0].nodeName.toLowerCase(), n = e("<" + s + ">", t.document[0]);
                    return t._addClass(n, "ui-sortable-placeholder", i || t.currentItem[0].className)._removeClass(n, "ui-sortable-helper"), "tbody" === s ? t._createTrPlaceholder(t.currentItem.find("tr").eq(0), e("<tr>", t.document[0]).appendTo(n)) : "tr" === s ? t._createTrPlaceholder(t.currentItem, n) : "img" === s && n.attr("src", t.currentItem.attr("src")), i || n.css("visibility", "hidden"), n
                }, update: function (e, n) {
                    (!i || s.forcePlaceholderSize) && (n.height() || n.height(t.currentItem.innerHeight() - parseInt(t.currentItem.css("paddingTop") || 0, 10) - parseInt(t.currentItem.css("paddingBottom") || 0, 10)), n.width() || n.width(t.currentItem.innerWidth() - parseInt(t.currentItem.css("paddingLeft") || 0, 10) - parseInt(t.currentItem.css("paddingRight") || 0, 10)))
                }
            }), t.placeholder = e(s.placeholder.element.call(t.element, t.currentItem)), t.currentItem.after(t.placeholder), s.placeholder.update(t, t.placeholder)
        },
        _createTrPlaceholder: function (t, i) {
            var s = this;
            t.children().each(function () {
                e("<td>&#160;</td>", s.document[0]).attr("colspan", e(this).attr("colspan") || 1).appendTo(i)
            })
        },
        _contactContainers: function (t) {
            var i, s, n, a, o, r, h, l, u, c, d = null, p = null;
            for (i = this.containers.length - 1; i >= 0; i--)if (!e.contains(this.currentItem[0], this.containers[i].element[0]))if (this._intersectsWith(this.containers[i].containerCache)) {
                if (d && e.contains(this.containers[i].element[0], d.element[0]))continue;
                d = this.containers[i], p = i
            } else this.containers[i].containerCache.over && (this.containers[i]._trigger("out", t, this._uiHash(this)), this.containers[i].containerCache.over = 0);
            if (d)if (1 === this.containers.length) this.containers[p].containerCache.over || (this.containers[p]._trigger("over", t, this._uiHash(this)), this.containers[p].containerCache.over = 1); else {
                for (n = 1e4, a = null, u = d.floating || this._isFloating(this.currentItem), o = u ? "left" : "top", r = u ? "width" : "height", c = u ? "pageX" : "pageY", s = this.items.length - 1; s >= 0; s--)e.contains(this.containers[p].element[0], this.items[s].item[0]) && this.items[s].item[0] !== this.currentItem[0] && (h = this.items[s].item.offset()[o], l = !1, t[c] - h > this.items[s][r] / 2 && (l = !0), n > Math.abs(t[c] - h) && (n = Math.abs(t[c] - h), a = this.items[s], this.direction = l ? "up" : "down"));
                if (!a && !this.options.dropOnEmpty)return;
                if (this.currentContainer === this.containers[p])return this.currentContainer.containerCache.over || (this.containers[p]._trigger("over", t, this._uiHash()), this.currentContainer.containerCache.over = 1), void 0;
                a ? this._rearrange(t, a, null, !0) : this._rearrange(t, null, this.containers[p].element, !0), this._trigger("change", t, this._uiHash()), this.containers[p]._trigger("change", t, this._uiHash(this)), this.currentContainer = this.containers[p], this.options.placeholder.update(this.currentContainer, this.placeholder), this.containers[p]._trigger("over", t, this._uiHash(this)), this.containers[p].containerCache.over = 1
            }
        },
        _createHelper: function (t) {
            var i = this.options, s = e.isFunction(i.helper) ? e(i.helper.apply(this.element[0], [t, this.currentItem])) : "clone" === i.helper ? this.currentItem.clone() : this.currentItem;
            return s.parents("body").length || e("parent" !== i.appendTo ? i.appendTo : this.currentItem[0].parentNode)[0].appendChild(s[0]), s[0] === this.currentItem[0] && (this._storedCSS = {
                width: this.currentItem[0].style.width,
                height: this.currentItem[0].style.height,
                position: this.currentItem.css("position"),
                top: this.currentItem.css("top"),
                left: this.currentItem.css("left")
            }), (!s[0].style.width || i.forceHelperSize) && s.width(this.currentItem.width()), (!s[0].style.height || i.forceHelperSize) && s.height(this.currentItem.height()), s
        },
        _adjustOffsetFromHelper: function (t) {
            "string" == typeof t && (t = t.split(" ")), e.isArray(t) && (t = {
                left: +t[0],
                top: +t[1] || 0
            }), "left" in t && (this.offset.click.left = t.left + this.margins.left), "right" in t && (this.offset.click.left = this.helperProportions.width - t.right + this.margins.left), "top" in t && (this.offset.click.top = t.top + this.margins.top), "bottom" in t && (this.offset.click.top = this.helperProportions.height - t.bottom + this.margins.top)
        },
        _getParentOffset: function () {
            this.offsetParent = this.helper.offsetParent();
            var t = this.offsetParent.offset();
            return "absolute" === this.cssPosition && this.scrollParent[0] !== this.document[0] && e.contains(this.scrollParent[0], this.offsetParent[0]) && (t.left += this.scrollParent.scrollLeft(), t.top += this.scrollParent.scrollTop()), (this.offsetParent[0] === this.document[0].body || this.offsetParent[0].tagName && "html" === this.offsetParent[0].tagName.toLowerCase() && e.ui.ie) && (t = {
                top: 0,
                left: 0
            }), {
                top: t.top + (parseInt(this.offsetParent.css("borderTopWidth"), 10) || 0),
                left: t.left + (parseInt(this.offsetParent.css("borderLeftWidth"), 10) || 0)
            }
        },
        _getRelativeOffset: function () {
            if ("relative" === this.cssPosition) {
                var e = this.currentItem.position();
                return {
                    top: e.top - (parseInt(this.helper.css("top"), 10) || 0) + this.scrollParent.scrollTop(),
                    left: e.left - (parseInt(this.helper.css("left"), 10) || 0) + this.scrollParent.scrollLeft()
                }
            }
            return {top: 0, left: 0}
        },
        _cacheMargins: function () {
            this.margins = {
                left: parseInt(this.currentItem.css("marginLeft"), 10) || 0,
                top: parseInt(this.currentItem.css("marginTop"), 10) || 0
            }
        },
        _cacheHelperProportions: function () {
            this.helperProportions = {width: this.helper.outerWidth(), height: this.helper.outerHeight()}
        },
        _setContainment: function () {
            var t, i, s, n = this.options;
            "parent" === n.containment && (n.containment = this.helper[0].parentNode), ("document" === n.containment || "window" === n.containment) && (this.containment = [0 - this.offset.relative.left - this.offset.parent.left, 0 - this.offset.relative.top - this.offset.parent.top, "document" === n.containment ? this.document.width() : this.window.width() - this.helperProportions.width - this.margins.left, ("document" === n.containment ? this.document.height() || document.body.parentNode.scrollHeight : this.window.height() || this.document[0].body.parentNode.scrollHeight) - this.helperProportions.height - this.margins.top]), /^(document|window|parent)$/.test(n.containment) || (t = e(n.containment)[0], i = e(n.containment).offset(), s = "hidden" !== e(t).css("overflow"), this.containment = [i.left + (parseInt(e(t).css("borderLeftWidth"), 10) || 0) + (parseInt(e(t).css("paddingLeft"), 10) || 0) - this.margins.left, i.top + (parseInt(e(t).css("borderTopWidth"), 10) || 0) + (parseInt(e(t).css("paddingTop"), 10) || 0) - this.margins.top, i.left + (s ? Math.max(t.scrollWidth, t.offsetWidth) : t.offsetWidth) - (parseInt(e(t).css("borderLeftWidth"), 10) || 0) - (parseInt(e(t).css("paddingRight"), 10) || 0) - this.helperProportions.width - this.margins.left, i.top + (s ? Math.max(t.scrollHeight, t.offsetHeight) : t.offsetHeight) - (parseInt(e(t).css("borderTopWidth"), 10) || 0) - (parseInt(e(t).css("paddingBottom"), 10) || 0) - this.helperProportions.height - this.margins.top])
        },
        _convertPositionTo: function (t, i) {
            i || (i = this.position);
            var s = "absolute" === t ? 1 : -1, n = "absolute" !== this.cssPosition || this.scrollParent[0] !== this.document[0] && e.contains(this.scrollParent[0], this.offsetParent[0]) ? this.scrollParent : this.offsetParent, a = /(html|body)/i.test(n[0].tagName);
            return {
                top: i.top + this.offset.relative.top * s + this.offset.parent.top * s - ("fixed" === this.cssPosition ? -this.scrollParent.scrollTop() : a ? 0 : n.scrollTop()) * s,
                left: i.left + this.offset.relative.left * s + this.offset.parent.left * s - ("fixed" === this.cssPosition ? -this.scrollParent.scrollLeft() : a ? 0 : n.scrollLeft()) * s
            }
        },
        _generatePosition: function (t) {
            var i, s, n = this.options, a = t.pageX, o = t.pageY, r = "absolute" !== this.cssPosition || this.scrollParent[0] !== this.document[0] && e.contains(this.scrollParent[0], this.offsetParent[0]) ? this.scrollParent : this.offsetParent, h = /(html|body)/i.test(r[0].tagName);
            return "relative" !== this.cssPosition || this.scrollParent[0] !== this.document[0] && this.scrollParent[0] !== this.offsetParent[0] || (this.offset.relative = this._getRelativeOffset()), this.originalPosition && (this.containment && (t.pageX - this.offset.click.left < this.containment[0] && (a = this.containment[0] + this.offset.click.left), t.pageY - this.offset.click.top < this.containment[1] && (o = this.containment[1] + this.offset.click.top), t.pageX - this.offset.click.left > this.containment[2] && (a = this.containment[2] + this.offset.click.left), t.pageY - this.offset.click.top > this.containment[3] && (o = this.containment[3] + this.offset.click.top)), n.grid && (i = this.originalPageY + Math.round((o - this.originalPageY) / n.grid[1]) * n.grid[1], o = this.containment ? i - this.offset.click.top >= this.containment[1] && i - this.offset.click.top <= this.containment[3] ? i : i - this.offset.click.top >= this.containment[1] ? i - n.grid[1] : i + n.grid[1] : i, s = this.originalPageX + Math.round((a - this.originalPageX) / n.grid[0]) * n.grid[0], a = this.containment ? s - this.offset.click.left >= this.containment[0] && s - this.offset.click.left <= this.containment[2] ? s : s - this.offset.click.left >= this.containment[0] ? s - n.grid[0] : s + n.grid[0] : s)), {
                top: o - this.offset.click.top - this.offset.relative.top - this.offset.parent.top + ("fixed" === this.cssPosition ? -this.scrollParent.scrollTop() : h ? 0 : r.scrollTop()),
                left: a - this.offset.click.left - this.offset.relative.left - this.offset.parent.left + ("fixed" === this.cssPosition ? -this.scrollParent.scrollLeft() : h ? 0 : r.scrollLeft())
            }
        },
        _rearrange: function (e, t, i, s) {
            i ? i[0].appendChild(this.placeholder[0]) : t.item[0].parentNode.insertBefore(this.placeholder[0], "down" === this.direction ? t.item[0] : t.item[0].nextSibling), this.counter = this.counter ? ++this.counter : 1;
            var n = this.counter;
            this._delay(function () {
                n === this.counter && this.refreshPositions(!s)
            })
        },
        _clear: function (e, t) {
            function i(e, t, i) {
                return function (s) {
                    i._trigger(e, s, t._uiHash(t))
                }
            }

            this.reverting = !1;
            var s, n = [];
            if (!this._noFinalSort && this.currentItem.parent().length && this.placeholder.before(this.currentItem), this._noFinalSort = null, this.helper[0] === this.currentItem[0]) {
                for (s in this._storedCSS)("auto" === this._storedCSS[s] || "static" === this._storedCSS[s]) && (this._storedCSS[s] = "");
                this.currentItem.css(this._storedCSS), this._removeClass(this.currentItem, "ui-sortable-helper")
            } else this.currentItem.show();
            for (this.fromOutside && !t && n.push(function (e) {
                this._trigger("receive", e, this._uiHash(this.fromOutside))
            }), !this.fromOutside && this.domPosition.prev === this.currentItem.prev().not(".ui-sortable-helper")[0] && this.domPosition.parent === this.currentItem.parent()[0] || t || n.push(function (e) {
                this._trigger("update", e, this._uiHash())
            }), this !== this.currentContainer && (t || (n.push(function (e) {
                this._trigger("remove", e, this._uiHash())
            }), n.push(function (e) {
                return function (t) {
                    e._trigger("receive", t, this._uiHash(this))
                }
            }.call(this, this.currentContainer)), n.push(function (e) {
                return function (t) {
                    e._trigger("update", t, this._uiHash(this))
                }
            }.call(this, this.currentContainer)))), s = this.containers.length - 1; s >= 0; s--)t || n.push(i("deactivate", this, this.containers[s])), this.containers[s].containerCache.over && (n.push(i("out", this, this.containers[s])), this.containers[s].containerCache.over = 0);
            if (this.storedCursor && (this.document.find("body").css("cursor", this.storedCursor), this.storedStylesheet.remove()), this._storedOpacity && this.helper.css("opacity", this._storedOpacity), this._storedZIndex && this.helper.css("zIndex", "auto" === this._storedZIndex ? "" : this._storedZIndex), this.dragging = !1, t || this._trigger("beforeStop", e, this._uiHash()), this.placeholder[0].parentNode.removeChild(this.placeholder[0]), this.cancelHelperRemoval || (this.helper[0] !== this.currentItem[0] && this.helper.remove(), this.helper = null), !t) {
                for (s = 0; n.length > s; s++)n[s].call(this, e);
                this._trigger("stop", e, this._uiHash())
            }
            return this.fromOutside = !1, !this.cancelHelperRemoval
        },
        _trigger: function () {
            e.Widget.prototype._trigger.apply(this, arguments) === !1 && this.cancel()
        },
        _uiHash: function (t) {
            var i = t || this;
            return {
                helper: i.helper,
                placeholder: i.placeholder || e([]),
                position: i.position,
                originalPosition: i.originalPosition,
                offset: i.positionAbs,
                item: i.currentItem,
                sender: t ? t.element : null
            }
        }
    }), e.widget("ui.accordion", {
        version: "1.12.1",
        options: {
            active: 0,
            animate: {},
            classes: {
                "ui-accordion-header": "ui-corner-top",
                "ui-accordion-header-collapsed": "ui-corner-all",
                "ui-accordion-content": "ui-corner-bottom"
            },
            collapsible: !1,
            event: "click",
            header: "> li > :first-child, > :not(li):even",
            heightStyle: "auto",
            icons: {activeHeader: "ui-icon-triangle-1-s", header: "ui-icon-triangle-1-e"},
            activate: null,
            beforeActivate: null
        },
        hideProps: {
            borderTopWidth: "hide",
            borderBottomWidth: "hide",
            paddingTop: "hide",
            paddingBottom: "hide",
            height: "hide"
        },
        showProps: {
            borderTopWidth: "show",
            borderBottomWidth: "show",
            paddingTop: "show",
            paddingBottom: "show",
            height: "show"
        },
        _create: function () {
            var t = this.options;
            this.prevShow = this.prevHide = e(), this._addClass("ui-accordion", "ui-widget ui-helper-reset"), this.element.attr("role", "tablist"), t.collapsible || t.active !== !1 && null != t.active || (t.active = 0), this._processPanels(), 0 > t.active && (t.active += this.headers.length), this._refresh()
        },
        _getCreateEventData: function () {
            return {header: this.active, panel: this.active.length ? this.active.next() : e()}
        },
        _createIcons: function () {
            var t, i, s = this.options.icons;
            s && (t = e("<span>"), this._addClass(t, "ui-accordion-header-icon", "ui-icon " + s.header), t.prependTo(this.headers), i = this.active.children(".ui-accordion-header-icon"), this._removeClass(i, s.header)._addClass(i, null, s.activeHeader)._addClass(this.headers, "ui-accordion-icons"))
        },
        _destroyIcons: function () {
            this._removeClass(this.headers, "ui-accordion-icons"), this.headers.children(".ui-accordion-header-icon").remove()
        },
        _destroy: function () {
            var e;
            this.element.removeAttr("role"), this.headers.removeAttr("role aria-expanded aria-selected aria-controls tabIndex").removeUniqueId(), this._destroyIcons(), e = this.headers.next().css("display", "").removeAttr("role aria-hidden aria-labelledby").removeUniqueId(), "content" !== this.options.heightStyle && e.css("height", "")
        },
        _setOption: function (e, t) {
            return "active" === e ? (this._activate(t), void 0) : ("event" === e && (this.options.event && this._off(this.headers, this.options.event), this._setupEvents(t)), this._super(e, t), "collapsible" !== e || t || this.options.active !== !1 || this._activate(0), "icons" === e && (this._destroyIcons(), t && this._createIcons()), void 0)
        },
        _setOptionDisabled: function (e) {
            this._super(e), this.element.attr("aria-disabled", e), this._toggleClass(null, "ui-state-disabled", !!e), this._toggleClass(this.headers.add(this.headers.next()), null, "ui-state-disabled", !!e)
        },
        _keydown: function (t) {
            if (!t.altKey && !t.ctrlKey) {
                var i = e.ui.keyCode, s = this.headers.length, n = this.headers.index(t.target), a = !1;
                switch (t.keyCode) {
                    case i.RIGHT:
                    case i.DOWN:
                        a = this.headers[(n + 1) % s];
                        break;
                    case i.LEFT:
                    case i.UP:
                        a = this.headers[(n - 1 + s) % s];
                        break;
                    case i.SPACE:
                    case i.ENTER:
                        this._eventHandler(t);
                        break;
                    case i.HOME:
                        a = this.headers[0];
                        break;
                    case i.END:
                        a = this.headers[s - 1]
                }
                a && (e(t.target).attr("tabIndex", -1), e(a).attr("tabIndex", 0), e(a).trigger("focus"), t.preventDefault())
            }
        },
        _panelKeyDown: function (t) {
            t.keyCode === e.ui.keyCode.UP && t.ctrlKey && e(t.currentTarget).prev().trigger("focus")
        },
        refresh: function () {
            var t = this.options;
            this._processPanels(), t.active === !1 && t.collapsible === !0 || !this.headers.length ? (t.active = !1, this.active = e()) : t.active === !1 ? this._activate(0) : this.active.length && !e.contains(this.element[0], this.active[0]) ? this.headers.length === this.headers.find(".ui-state-disabled").length ? (t.active = !1, this.active = e()) : this._activate(Math.max(0, t.active - 1)) : t.active = this.headers.index(this.active), this._destroyIcons(), this._refresh()
        },
        _processPanels: function () {
            var e = this.headers, t = this.panels;
            this.headers = this.element.find(this.options.header), this._addClass(this.headers, "ui-accordion-header ui-accordion-header-collapsed", "ui-state-default"), this.panels = this.headers.next().filter(":not(.ui-accordion-content-active)").hide(), this._addClass(this.panels, "ui-accordion-content", "ui-helper-reset ui-widget-content"), t && (this._off(e.not(this.headers)), this._off(t.not(this.panels)))
        },
        _refresh: function () {
            var t, i = this.options, s = i.heightStyle, n = this.element.parent();
            this.active = this._findActive(i.active), this._addClass(this.active, "ui-accordion-header-active", "ui-state-active")._removeClass(this.active, "ui-accordion-header-collapsed"), this._addClass(this.active.next(), "ui-accordion-content-active"), this.active.next().show(), this.headers.attr("role", "tab").each(function () {
                var t = e(this), i = t.uniqueId().attr("id"), s = t.next(), n = s.uniqueId().attr("id");
                t.attr("aria-controls", n), s.attr("aria-labelledby", i)
            }).next().attr("role", "tabpanel"), this.headers.not(this.active).attr({
                "aria-selected": "false",
                "aria-expanded": "false",
                tabIndex: -1
            }).next().attr({"aria-hidden": "true"}).hide(), this.active.length ? this.active.attr({
                    "aria-selected": "true",
                    "aria-expanded": "true",
                    tabIndex: 0
                }).next().attr({"aria-hidden": "false"}) : this.headers.eq(0).attr("tabIndex", 0), this._createIcons(), this._setupEvents(i.event), "fill" === s ? (t = n.height(), this.element.siblings(":visible").each(function () {
                    var i = e(this), s = i.css("position");
                    "absolute" !== s && "fixed" !== s && (t -= i.outerHeight(!0))
                }), this.headers.each(function () {
                    t -= e(this).outerHeight(!0)
                }), this.headers.next().each(function () {
                    e(this).height(Math.max(0, t - e(this).innerHeight() + e(this).height()))
                }).css("overflow", "auto")) : "auto" === s && (t = 0, this.headers.next().each(function () {
                    var i = e(this).is(":visible");
                    i || e(this).show(), t = Math.max(t, e(this).css("height", "").height()), i || e(this).hide()
                }).height(t))
        },
        _activate: function (t) {
            var i = this._findActive(t)[0];
            i !== this.active[0] && (i = i || this.active[0], this._eventHandler({
                target: i,
                currentTarget: i,
                preventDefault: e.noop
            }))
        },
        _findActive: function (t) {
            return "number" == typeof t ? this.headers.eq(t) : e()
        },
        _setupEvents: function (t) {
            var i = {keydown: "_keydown"};
            t && e.each(t.split(" "), function (e, t) {
                i[t] = "_eventHandler"
            }), this._off(this.headers.add(this.headers.next())), this._on(this.headers, i), this._on(this.headers.next(), {keydown: "_panelKeyDown"}), this._hoverable(this.headers), this._focusable(this.headers)
        },
        _eventHandler: function (t) {
            var i, s, n = this.options, a = this.active, o = e(t.currentTarget), r = o[0] === a[0], h = r && n.collapsible, l = h ? e() : o.next(), u = a.next(), c = {
                oldHeader: a,
                oldPanel: u,
                newHeader: h ? e() : o,
                newPanel: l
            };
            t.preventDefault(), r && !n.collapsible || this._trigger("beforeActivate", t, c) === !1 || (n.active = h ? !1 : this.headers.index(o), this.active = r ? e() : o, this._toggle(c), this._removeClass(a, "ui-accordion-header-active", "ui-state-active"), n.icons && (i = a.children(".ui-accordion-header-icon"), this._removeClass(i, null, n.icons.activeHeader)._addClass(i, null, n.icons.header)), r || (this._removeClass(o, "ui-accordion-header-collapsed")._addClass(o, "ui-accordion-header-active", "ui-state-active"), n.icons && (s = o.children(".ui-accordion-header-icon"), this._removeClass(s, null, n.icons.header)._addClass(s, null, n.icons.activeHeader)), this._addClass(o.next(), "ui-accordion-content-active")))
        },
        _toggle: function (t) {
            var i = t.newPanel, s = this.prevShow.length ? this.prevShow : t.oldPanel;
            this.prevShow.add(this.prevHide).stop(!0, !0), this.prevShow = i, this.prevHide = s, this.options.animate ? this._animate(i, s, t) : (s.hide(), i.show(), this._toggleComplete(t)), s.attr({"aria-hidden": "true"}), s.prev().attr({
                "aria-selected": "false",
                "aria-expanded": "false"
            }), i.length && s.length ? s.prev().attr({
                    tabIndex: -1,
                    "aria-expanded": "false"
                }) : i.length && this.headers.filter(function () {
                    return 0 === parseInt(e(this).attr("tabIndex"), 10)
                }).attr("tabIndex", -1), i.attr("aria-hidden", "false").prev().attr({
                "aria-selected": "true",
                "aria-expanded": "true",
                tabIndex: 0
            })
        },
        _animate: function (e, t, i) {
            var s, n, a, o = this, r = 0, h = e.css("box-sizing"), l = e.length && (!t.length || e.index() < t.index()), u = this.options.animate || {}, c = l && u.down || u, d = function () {
                o._toggleComplete(i)
            };
            return "number" == typeof c && (a = c), "string" == typeof c && (n = c), n = n || c.easing || u.easing, a = a || c.duration || u.duration, t.length ? e.length ? (s = e.show().outerHeight(), t.animate(this.hideProps, {
                        duration: a,
                        easing: n,
                        step: function (e, t) {
                            t.now = Math.round(e)
                        }
                    }), e.hide().animate(this.showProps, {
                        duration: a, easing: n, complete: d, step: function (e, i) {
                            i.now = Math.round(e), "height" !== i.prop ? "content-box" === h && (r += i.now) : "content" !== o.options.heightStyle && (i.now = Math.round(s - t.outerHeight() - r), r = 0)
                        }
                    }), void 0) : t.animate(this.hideProps, a, n, d) : e.animate(this.showProps, a, n, d)
        },
        _toggleComplete: function (e) {
            var t = e.oldPanel, i = t.prev();
            this._removeClass(t, "ui-accordion-content-active"), this._removeClass(i, "ui-accordion-header-active")._addClass(i, "ui-accordion-header-collapsed"), t.length && (t.parent()[0].className = t.parent()[0].className), this._trigger("activate", null, e)
        }
    }), e.widget("ui.menu", {
        version: "1.12.1",
        defaultElement: "<ul>",
        delay: 300,
        options: {
            icons: {submenu: "ui-icon-caret-1-e"},
            items: "> *",
            menus: "ul",
            position: {my: "left top", at: "right top"},
            role: "menu",
            blur: null,
            focus: null,
            select: null
        },
        _create: function () {
            this.activeMenu = this.element, this.mouseHandled = !1, this.element.uniqueId().attr({
                role: this.options.role,
                tabIndex: 0
            }), this._addClass("ui-menu", "ui-widget ui-widget-content"), this._on({
                "mousedown .ui-menu-item": function (e) {
                    e.preventDefault()
                }, "click .ui-menu-item": function (t) {
                    var i = e(t.target), s = e(e.ui.safeActiveElement(this.document[0]));
                    !this.mouseHandled && i.not(".ui-state-disabled").length && (this.select(t), t.isPropagationStopped() || (this.mouseHandled = !0), i.has(".ui-menu").length ? this.expand(t) : !this.element.is(":focus") && s.closest(".ui-menu").length && (this.element.trigger("focus", [!0]), this.active && 1 === this.active.parents(".ui-menu").length && clearTimeout(this.timer)))
                }, "mouseenter .ui-menu-item": function (t) {
                    if (!this.previousFilter) {
                        var i = e(t.target).closest(".ui-menu-item"), s = e(t.currentTarget);
                        i[0] === s[0] && (this._removeClass(s.siblings().children(".ui-state-active"), null, "ui-state-active"), this.focus(t, s))
                    }
                }, mouseleave: "collapseAll", "mouseleave .ui-menu": "collapseAll", focus: function (e, t) {
                    var i = this.active || this.element.find(this.options.items).eq(0);
                    t || this.focus(e, i)
                }, blur: function (t) {
                    this._delay(function () {
                        var i = !e.contains(this.element[0], e.ui.safeActiveElement(this.document[0]));
                        i && this.collapseAll(t)
                    })
                }, keydown: "_keydown"
            }), this.refresh(), this._on(this.document, {
                click: function (e) {
                    this._closeOnDocumentClick(e) && this.collapseAll(e), this.mouseHandled = !1
                }
            })
        },
        _destroy: function () {
            var t = this.element.find(".ui-menu-item").removeAttr("role aria-disabled"), i = t.children(".ui-menu-item-wrapper").removeUniqueId().removeAttr("tabIndex role aria-haspopup");
            this.element.removeAttr("aria-activedescendant").find(".ui-menu").addBack().removeAttr("role aria-labelledby aria-expanded aria-hidden aria-disabled tabIndex").removeUniqueId().show(), i.children().each(function () {
                var t = e(this);
                t.data("ui-menu-submenu-caret") && t.remove()
            })
        },
        _keydown: function (t) {
            var i, s, n, a, o = !0;
            switch (t.keyCode) {
                case e.ui.keyCode.PAGE_UP:
                    this.previousPage(t);
                    break;
                case e.ui.keyCode.PAGE_DOWN:
                    this.nextPage(t);
                    break;
                case e.ui.keyCode.HOME:
                    this._move("first", "first", t);
                    break;
                case e.ui.keyCode.END:
                    this._move("last", "last", t);
                    break;
                case e.ui.keyCode.UP:
                    this.previous(t);
                    break;
                case e.ui.keyCode.DOWN:
                    this.next(t);
                    break;
                case e.ui.keyCode.LEFT:
                    this.collapse(t);
                    break;
                case e.ui.keyCode.RIGHT:
                    this.active && !this.active.is(".ui-state-disabled") && this.expand(t);
                    break;
                case e.ui.keyCode.ENTER:
                case e.ui.keyCode.SPACE:
                    this._activate(t);
                    break;
                case e.ui.keyCode.ESCAPE:
                    this.collapse(t);
                    break;
                default:
                    o = !1, s = this.previousFilter || "", a = !1, n = t.keyCode >= 96 && 105 >= t.keyCode ? "" + (t.keyCode - 96) : String.fromCharCode(t.keyCode), clearTimeout(this.filterTimer), n === s ? a = !0 : n = s + n, i = this._filterMenuItems(n), i = a && -1 !== i.index(this.active.next()) ? this.active.nextAll(".ui-menu-item") : i, i.length || (n = String.fromCharCode(t.keyCode), i = this._filterMenuItems(n)), i.length ? (this.focus(t, i), this.previousFilter = n, this.filterTimer = this._delay(function () {
                            delete this.previousFilter
                        }, 1e3)) : delete this.previousFilter
            }
            o && t.preventDefault()
        },
        _activate: function (e) {
            this.active && !this.active.is(".ui-state-disabled") && (this.active.children("[aria-haspopup='true']").length ? this.expand(e) : this.select(e))
        },
        refresh: function () {
            var t, i, s, n, a, o = this, r = this.options.icons.submenu, h = this.element.find(this.options.menus);
            this._toggleClass("ui-menu-icons", null, !!this.element.find(".ui-icon").length), s = h.filter(":not(.ui-menu)").hide().attr({
                role: this.options.role,
                "aria-hidden": "true",
                "aria-expanded": "false"
            }).each(function () {
                var t = e(this), i = t.prev(), s = e("<span>").data("ui-menu-submenu-caret", !0);
                o._addClass(s, "ui-menu-icon", "ui-icon " + r), i.attr("aria-haspopup", "true").prepend(s), t.attr("aria-labelledby", i.attr("id"))
            }), this._addClass(s, "ui-menu", "ui-widget ui-widget-content ui-front"), t = h.add(this.element), i = t.find(this.options.items), i.not(".ui-menu-item").each(function () {
                var t = e(this);
                o._isDivider(t) && o._addClass(t, "ui-menu-divider", "ui-widget-content")
            }), n = i.not(".ui-menu-item, .ui-menu-divider"), a = n.children().not(".ui-menu").uniqueId().attr({
                tabIndex: -1,
                role: this._itemRole()
            }), this._addClass(n, "ui-menu-item")._addClass(a, "ui-menu-item-wrapper"), i.filter(".ui-state-disabled").attr("aria-disabled", "true"), this.active && !e.contains(this.element[0], this.active[0]) && this.blur()
        },
        _itemRole: function () {
            return {menu: "menuitem", listbox: "option"}[this.options.role]
        },
        _setOption: function (e, t) {
            if ("icons" === e) {
                var i = this.element.find(".ui-menu-icon");
                this._removeClass(i, null, this.options.icons.submenu)._addClass(i, null, t.submenu)
            }
            this._super(e, t)
        },
        _setOptionDisabled: function (e) {
            this._super(e), this.element.attr("aria-disabled", e + ""), this._toggleClass(null, "ui-state-disabled", !!e)
        },
        focus: function (e, t) {
            var i, s, n;
            this.blur(e, e && "focus" === e.type), this._scrollIntoView(t), this.active = t.first(), s = this.active.children(".ui-menu-item-wrapper"), this._addClass(s, null, "ui-state-active"), this.options.role && this.element.attr("aria-activedescendant", s.attr("id")), n = this.active.parent().closest(".ui-menu-item").children(".ui-menu-item-wrapper"), this._addClass(n, null, "ui-state-active"), e && "keydown" === e.type ? this._close() : this.timer = this._delay(function () {
                    this._close()
                }, this.delay), i = t.children(".ui-menu"), i.length && e && /^mouse/.test(e.type) && this._startOpening(i), this.activeMenu = t.parent(), this._trigger("focus", e, {item: t})
        },
        _scrollIntoView: function (t) {
            var i, s, n, a, o, r;
            this._hasScroll() && (i = parseFloat(e.css(this.activeMenu[0], "borderTopWidth")) || 0, s = parseFloat(e.css(this.activeMenu[0], "paddingTop")) || 0, n = t.offset().top - this.activeMenu.offset().top - i - s, a = this.activeMenu.scrollTop(), o = this.activeMenu.height(), r = t.outerHeight(), 0 > n ? this.activeMenu.scrollTop(a + n) : n + r > o && this.activeMenu.scrollTop(a + n - o + r))
        },
        blur: function (e, t) {
            t || clearTimeout(this.timer), this.active && (this._removeClass(this.active.children(".ui-menu-item-wrapper"), null, "ui-state-active"), this._trigger("blur", e, {item: this.active}), this.active = null)
        },
        _startOpening: function (e) {
            clearTimeout(this.timer), "true" === e.attr("aria-hidden") && (this.timer = this._delay(function () {
                this._close(), this._open(e)
            }, this.delay))
        },
        _open: function (t) {
            var i = e.extend({of: this.active}, this.options.position);
            clearTimeout(this.timer), this.element.find(".ui-menu").not(t.parents(".ui-menu")).hide().attr("aria-hidden", "true"), t.show().removeAttr("aria-hidden").attr("aria-expanded", "true").position(i)
        },
        collapseAll: function (t, i) {
            clearTimeout(this.timer), this.timer = this._delay(function () {
                var s = i ? this.element : e(t && t.target).closest(this.element.find(".ui-menu"));
                s.length || (s = this.element), this._close(s), this.blur(t), this._removeClass(s.find(".ui-state-active"), null, "ui-state-active"), this.activeMenu = s
            }, this.delay)
        },
        _close: function (e) {
            e || (e = this.active ? this.active.parent() : this.element), e.find(".ui-menu").hide().attr("aria-hidden", "true").attr("aria-expanded", "false")
        },
        _closeOnDocumentClick: function (t) {
            return !e(t.target).closest(".ui-menu").length
        },
        _isDivider: function (e) {
            return !/[^\-\u2014\u2013\s]/.test(e.text())
        },
        collapse: function (e) {
            var t = this.active && this.active.parent().closest(".ui-menu-item", this.element);
            t && t.length && (this._close(), this.focus(e, t))
        },
        expand: function (e) {
            var t = this.active && this.active.children(".ui-menu ").find(this.options.items).first();
            t && t.length && (this._open(t.parent()), this._delay(function () {
                this.focus(e, t)
            }))
        },
        next: function (e) {
            this._move("next", "first", e)
        },
        previous: function (e) {
            this._move("prev", "last", e)
        },
        isFirstItem: function () {
            return this.active && !this.active.prevAll(".ui-menu-item").length
        },
        isLastItem: function () {
            return this.active && !this.active.nextAll(".ui-menu-item").length
        },
        _move: function (e, t, i) {
            var s;
            this.active && (s = "first" === e || "last" === e ? this.active["first" === e ? "prevAll" : "nextAll"](".ui-menu-item").eq(-1) : this.active[e + "All"](".ui-menu-item").eq(0)), s && s.length && this.active || (s = this.activeMenu.find(this.options.items)[t]()), this.focus(i, s)
        },
        nextPage: function (t) {
            var i, s, n;
            return this.active ? (this.isLastItem() || (this._hasScroll() ? (s = this.active.offset().top, n = this.element.height(), this.active.nextAll(".ui-menu-item").each(function () {
                        return i = e(this), 0 > i.offset().top - s - n
                    }), this.focus(t, i)) : this.focus(t, this.activeMenu.find(this.options.items)[this.active ? "last" : "first"]())), void 0) : (this.next(t), void 0)
        },
        previousPage: function (t) {
            var i, s, n;
            return this.active ? (this.isFirstItem() || (this._hasScroll() ? (s = this.active.offset().top, n = this.element.height(), this.active.prevAll(".ui-menu-item").each(function () {
                        return i = e(this), i.offset().top - s + n > 0
                    }), this.focus(t, i)) : this.focus(t, this.activeMenu.find(this.options.items).first())), void 0) : (this.next(t), void 0)
        },
        _hasScroll: function () {
            return this.element.outerHeight() < this.element.prop("scrollHeight")
        },
        select: function (t) {
            this.active = this.active || e(t.target).closest(".ui-menu-item");
            var i = {item: this.active};
            this.active.has(".ui-menu").length || this.collapseAll(t, !0), this._trigger("select", t, i)
        },
        _filterMenuItems: function (t) {
            var i = t.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&"), s = RegExp("^" + i, "i");
            return this.activeMenu.find(this.options.items).filter(".ui-menu-item").filter(function () {
                return s.test(e.trim(e(this).children(".ui-menu-item-wrapper").text()))
            })
        }
    }), e.widget("ui.autocomplete", {
        version: "1.12.1",
        defaultElement: "<input>",
        options: {
            appendTo: null,
            autoFocus: !1,
            delay: 300,
            minLength: 1,
            position: {my: "left top", at: "left bottom", collision: "none"},
            source: null,
            change: null,
            close: null,
            focus: null,
            open: null,
            response: null,
            search: null,
            select: null
        },
        requestIndex: 0,
        pending: 0,
        _create: function () {
            var t, i, s, n = this.element[0].nodeName.toLowerCase(), a = "textarea" === n, o = "input" === n;
            this.isMultiLine = a || !o && this._isContentEditable(this.element), this.valueMethod = this.element[a || o ? "val" : "text"], this.isNewMenu = !0, this._addClass("ui-autocomplete-input"), this.element.attr("autocomplete", "off"), this._on(this.element, {
                keydown: function (n) {
                    if (this.element.prop("readOnly"))return t = !0, s = !0, i = !0, void 0;
                    t = !1, s = !1, i = !1;
                    var a = e.ui.keyCode;
                    switch (n.keyCode) {
                        case a.PAGE_UP:
                            t = !0, this._move("previousPage", n);
                            break;
                        case a.PAGE_DOWN:
                            t = !0, this._move("nextPage", n);
                            break;
                        case a.UP:
                            t = !0, this._keyEvent("previous", n);
                            break;
                        case a.DOWN:
                            t = !0, this._keyEvent("next", n);
                            break;
                        case a.ENTER:
                            this.menu.active && (t = !0, n.preventDefault(), this.menu.select(n));
                            break;
                        case a.TAB:
                            this.menu.active && this.menu.select(n);
                            break;
                        case a.ESCAPE:
                            this.menu.element.is(":visible") && (this.isMultiLine || this._value(this.term), this.close(n), n.preventDefault());
                            break;
                        default:
                            i = !0, this._searchTimeout(n)
                    }
                }, keypress: function (s) {
                    if (t)return t = !1, (!this.isMultiLine || this.menu.element.is(":visible")) && s.preventDefault(), void 0;
                    if (!i) {
                        var n = e.ui.keyCode;
                        switch (s.keyCode) {
                            case n.PAGE_UP:
                                this._move("previousPage", s);
                                break;
                            case n.PAGE_DOWN:
                                this._move("nextPage", s);
                                break;
                            case n.UP:
                                this._keyEvent("previous", s);
                                break;
                            case n.DOWN:
                                this._keyEvent("next", s)
                        }
                    }
                }, input: function (e) {
                    return s ? (s = !1, e.preventDefault(), void 0) : (this._searchTimeout(e), void 0)
                }, focus: function () {
                    this.selectedItem = null, this.previous = this._value()
                }, blur: function (e) {
                    return this.cancelBlur ? (delete this.cancelBlur, void 0) : (clearTimeout(this.searching), this.close(e), this._change(e), void 0)
                }
            }), this._initSource(), this.menu = e("<ul>").appendTo(this._appendTo()).menu({role: null}).hide().menu("instance"), this._addClass(this.menu.element, "ui-autocomplete", "ui-front"), this._on(this.menu.element, {
                mousedown: function (t) {
                    t.preventDefault(), this.cancelBlur = !0, this._delay(function () {
                        delete this.cancelBlur, this.element[0] !== e.ui.safeActiveElement(this.document[0]) && this.element.trigger("focus")
                    })
                }, menufocus: function (t, i) {
                    var s, n;
                    return this.isNewMenu && (this.isNewMenu = !1, t.originalEvent && /^mouse/.test(t.originalEvent.type)) ? (this.menu.blur(), this.document.one("mousemove", function () {
                            e(t.target).trigger(t.originalEvent)
                        }), void 0) : (n = i.item.data("ui-autocomplete-item"), !1 !== this._trigger("focus", t, {item: n}) && t.originalEvent && /^key/.test(t.originalEvent.type) && this._value(n.value), s = i.item.attr("aria-label") || n.value, s && e.trim(s).length && (this.liveRegion.children().hide(), e("<div>").text(s).appendTo(this.liveRegion)), void 0)
                }, menuselect: function (t, i) {
                    var s = i.item.data("ui-autocomplete-item"), n = this.previous;
                    this.element[0] !== e.ui.safeActiveElement(this.document[0]) && (this.element.trigger("focus"), this.previous = n, this._delay(function () {
                        this.previous = n, this.selectedItem = s
                    })), !1 !== this._trigger("select", t, {item: s}) && this._value(s.value), this.term = this._value(), this.close(t), this.selectedItem = s
                }
            }), this.liveRegion = e("<div>", {
                role: "status",
                "aria-live": "assertive",
                "aria-relevant": "additions"
            }).appendTo(this.document[0].body), this._addClass(this.liveRegion, null, "ui-helper-hidden-accessible"), this._on(this.window, {
                beforeunload: function () {
                    this.element.removeAttr("autocomplete")
                }
            })
        },
        _destroy: function () {
            clearTimeout(this.searching), this.element.removeAttr("autocomplete"), this.menu.element.remove(), this.liveRegion.remove()
        },
        _setOption: function (e, t) {
            this._super(e, t), "source" === e && this._initSource(), "appendTo" === e && this.menu.element.appendTo(this._appendTo()), "disabled" === e && t && this.xhr && this.xhr.abort()
        },
        _isEventTargetInWidget: function (t) {
            var i = this.menu.element[0];
            return t.target === this.element[0] || t.target === i || e.contains(i, t.target)
        },
        _closeOnClickOutside: function (e) {
            this._isEventTargetInWidget(e) || this.close()
        },
        _appendTo: function () {
            var t = this.options.appendTo;
            return t && (t = t.jquery || t.nodeType ? e(t) : this.document.find(t).eq(0)), t && t[0] || (t = this.element.closest(".ui-front, dialog")), t.length || (t = this.document[0].body), t
        },
        _initSource: function () {
            var t, i, s = this;
            e.isArray(this.options.source) ? (t = this.options.source, this.source = function (i, s) {
                    s(e.ui.autocomplete.filter(t, i.term))
                }) : "string" == typeof this.options.source ? (i = this.options.source, this.source = function (t, n) {
                        s.xhr && s.xhr.abort(), s.xhr = e.ajax({
                            url: i,
                            data: t,
                            dataType: "json",
                            success: function (e) {
                                n(e)
                            },
                            error: function () {
                                n([])
                            }
                        })
                    }) : this.source = this.options.source
        },
        _searchTimeout: function (e) {
            clearTimeout(this.searching), this.searching = this._delay(function () {
                var t = this.term === this._value(), i = this.menu.element.is(":visible"), s = e.altKey || e.ctrlKey || e.metaKey || e.shiftKey;
                (!t || t && !i && !s) && (this.selectedItem = null, this.search(null, e))
            }, this.options.delay)
        },
        search: function (e, t) {
            return e = null != e ? e : this._value(), this.term = this._value(), e.length < this.options.minLength ? this.close(t) : this._trigger("search", t) !== !1 ? this._search(e) : void 0
        },
        _search: function (e) {
            this.pending++, this._addClass("ui-autocomplete-loading"), this.cancelSearch = !1, this.source({term: e}, this._response())
        },
        _response: function () {
            var t = ++this.requestIndex;
            return e.proxy(function (e) {
                t === this.requestIndex && this.__response(e), this.pending--, this.pending || this._removeClass("ui-autocomplete-loading")
            }, this)
        },
        __response: function (e) {
            e && (e = this._normalize(e)), this._trigger("response", null, {content: e}), !this.options.disabled && e && e.length && !this.cancelSearch ? (this._suggest(e), this._trigger("open")) : this._close()
        },
        close: function (e) {
            this.cancelSearch = !0, this._close(e)
        },
        _close: function (e) {
            this._off(this.document, "mousedown"), this.menu.element.is(":visible") && (this.menu.element.hide(), this.menu.blur(), this.isNewMenu = !0, this._trigger("close", e))
        },
        _change: function (e) {
            this.previous !== this._value() && this._trigger("change", e, {item: this.selectedItem})
        },
        _normalize: function (t) {
            return t.length && t[0].label && t[0].value ? t : e.map(t, function (t) {
                    return "string" == typeof t ? {label: t, value: t} : e.extend({}, t, {
                            label: t.label || t.value,
                            value: t.value || t.label
                        })
                })
        },
        _suggest: function (t) {
            var i = this.menu.element.empty();
            this._renderMenu(i, t), this.isNewMenu = !0, this.menu.refresh(), i.show(), this._resizeMenu(), i.position(e.extend({of: this.element}, this.options.position)), this.options.autoFocus && this.menu.next(), this._on(this.document, {mousedown: "_closeOnClickOutside"})
        },
        _resizeMenu: function () {
            var e = this.menu.element;
            e.outerWidth(Math.max(e.width("").outerWidth() + 1, this.element.outerWidth()))
        },
        _renderMenu: function (t, i) {
            var s = this;
            e.each(i, function (e, i) {
                s._renderItemData(t, i)
            })
        },
        _renderItemData: function (e, t) {
            return this._renderItem(e, t).data("ui-autocomplete-item", t)
        },
        _renderItem: function (t, i) {
            return e("<li>").append(e("<div>").text(i.label)).appendTo(t)
        },
        _move: function (e, t) {
            return this.menu.element.is(":visible") ? this.menu.isFirstItem() && /^previous/.test(e) || this.menu.isLastItem() && /^next/.test(e) ? (this.isMultiLine || this._value(this.term), this.menu.blur(), void 0) : (this.menu[e](t), void 0) : (this.search(null, t), void 0)
        },
        widget: function () {
            return this.menu.element
        },
        _value: function () {
            return this.valueMethod.apply(this.element, arguments)
        },
        _keyEvent: function (e, t) {
            (!this.isMultiLine || this.menu.element.is(":visible")) && (this._move(e, t), t.preventDefault())
        },
        _isContentEditable: function (e) {
            if (!e.length)return !1;
            var t = e.prop("contentEditable");
            return "inherit" === t ? this._isContentEditable(e.parent()) : "true" === t
        }
    }), e.extend(e.ui.autocomplete, {
        escapeRegex: function (e) {
            return e.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&")
        }, filter: function (t, i) {
            var s = RegExp(e.ui.autocomplete.escapeRegex(i), "i");
            return e.grep(t, function (e) {
                return s.test(e.label || e.value || e)
            })
        }
    }), e.widget("ui.autocomplete", e.ui.autocomplete, {
        options: {
            messages: {
                noResults: "No search results.",
                results: function (e) {
                    return e + (e > 1 ? " results are" : " result is") + " available, use up and down arrow keys to navigate."
                }
            }
        }, __response: function (t) {
            var i;
            this._superApply(arguments), this.options.disabled || this.cancelSearch || (i = t && t.length ? this.options.messages.results(t.length) : this.options.messages.noResults, this.liveRegion.children().hide(), e("<div>").text(i).appendTo(this.liveRegion))
        }
    }), e.ui.autocomplete;
    var d = /ui-corner-([a-z]){2,6}/g;
    e.widget("ui.controlgroup", {
        version: "1.12.1",
        defaultElement: "<div>",
        options: {
            direction: "horizontal",
            disabled: null,
            onlyVisible: !0,
            items: {
                button: "input[type=button], input[type=submit], input[type=reset], button, a",
                controlgroupLabel: ".ui-controlgroup-label",
                checkboxradio: "input[type='checkbox'], input[type='radio']",
                selectmenu: "select",
                spinner: ".ui-spinner-input"
            }
        },
        _create: function () {
            this._enhance()
        },
        _enhance: function () {
            this.element.attr("role", "toolbar"), this.refresh()
        },
        _destroy: function () {
            this._callChildMethod("destroy"), this.childWidgets.removeData("ui-controlgroup-data"), this.element.removeAttr("role"), this.options.items.controlgroupLabel && this.element.find(this.options.items.controlgroupLabel).find(".ui-controlgroup-label-contents").contents().unwrap()
        },
        _initWidgets: function () {
            var t = this, i = [];
            e.each(this.options.items, function (s, n) {
                var a, o = {};
                return n ? "controlgroupLabel" === s ? (a = t.element.find(n), a.each(function () {
                            var t = e(this);
                            t.children(".ui-controlgroup-label-contents").length || t.contents().wrapAll("<span class='ui-controlgroup-label-contents'></span>")
                        }), t._addClass(a, null, "ui-widget ui-widget-content ui-state-default"), i = i.concat(a.get()), void 0) : (e.fn[s] && (o = t["_" + s + "Options"] ? t["_" + s + "Options"]("middle") : {classes: {}}, t.element.find(n).each(function () {
                            var n = e(this), a = n[s]("instance"), r = e.widget.extend({}, o);
                            if ("button" !== s || !n.parent(".ui-spinner").length) {
                                a || (a = n[s]()[s]("instance")), a && (r.classes = t._resolveClassesValues(r.classes, a)), n[s](r);
                                var h = n[s]("widget");
                                e.data(h[0], "ui-controlgroup-data", a ? a : n[s]("instance")), i.push(h[0])
                            }
                        })), void 0) : void 0
            }), this.childWidgets = e(e.unique(i)), this._addClass(this.childWidgets, "ui-controlgroup-item")
        },
        _callChildMethod: function (t) {
            this.childWidgets.each(function () {
                var i = e(this), s = i.data("ui-controlgroup-data");
                s && s[t] && s[t]()
            })
        },
        _updateCornerClass: function (e, t) {
            var i = "ui-corner-top ui-corner-bottom ui-corner-left ui-corner-right ui-corner-all", s = this._buildSimpleOptions(t, "label").classes.label;
            this._removeClass(e, null, i), this._addClass(e, null, s)
        },
        _buildSimpleOptions: function (e, t) {
            var i = "vertical" === this.options.direction, s = {classes: {}};
            return s.classes[t] = {
                middle: "",
                first: "ui-corner-" + (i ? "top" : "left"),
                last: "ui-corner-" + (i ? "bottom" : "right"),
                only: "ui-corner-all"
            }[e], s
        },
        _spinnerOptions: function (e) {
            var t = this._buildSimpleOptions(e, "ui-spinner");
            return t.classes["ui-spinner-up"] = "", t.classes["ui-spinner-down"] = "", t
        },
        _buttonOptions: function (e) {
            return this._buildSimpleOptions(e, "ui-button")
        },
        _checkboxradioOptions: function (e) {
            return this._buildSimpleOptions(e, "ui-checkboxradio-label")
        },
        _selectmenuOptions: function (e) {
            var t = "vertical" === this.options.direction;
            return {
                width: t ? "auto" : !1,
                classes: {
                    middle: {"ui-selectmenu-button-open": "", "ui-selectmenu-button-closed": ""},
                    first: {
                        "ui-selectmenu-button-open": "ui-corner-" + (t ? "top" : "tl"),
                        "ui-selectmenu-button-closed": "ui-corner-" + (t ? "top" : "left")
                    },
                    last: {
                        "ui-selectmenu-button-open": t ? "" : "ui-corner-tr",
                        "ui-selectmenu-button-closed": "ui-corner-" + (t ? "bottom" : "right")
                    },
                    only: {"ui-selectmenu-button-open": "ui-corner-top", "ui-selectmenu-button-closed": "ui-corner-all"}
                }[e]
            }
        },
        _resolveClassesValues: function (t, i) {
            var s = {};
            return e.each(t, function (n) {
                var a = i.options.classes[n] || "";
                a = e.trim(a.replace(d, "")), s[n] = (a + " " + t[n]).replace(/\s+/g, " ")
            }), s
        },
        _setOption: function (e, t) {
            return "direction" === e && this._removeClass("ui-controlgroup-" + this.options.direction), this._super(e, t), "disabled" === e ? (this._callChildMethod(t ? "disable" : "enable"), void 0) : (this.refresh(), void 0)
        },
        refresh: function () {
            var t, i = this;
            this._addClass("ui-controlgroup ui-controlgroup-" + this.options.direction), "horizontal" === this.options.direction && this._addClass(null, "ui-helper-clearfix"), this._initWidgets(), t = this.childWidgets, this.options.onlyVisible && (t = t.filter(":visible")), t.length && (e.each(["first", "last"], function (e, s) {
                var n = t[s]().data("ui-controlgroup-data");
                if (n && i["_" + n.widgetName + "Options"]) {
                    var a = i["_" + n.widgetName + "Options"](1 === t.length ? "only" : s);
                    a.classes = i._resolveClassesValues(a.classes, n), n.element[n.widgetName](a)
                } else i._updateCornerClass(t[s](), s)
            }), this._callChildMethod("refresh"))
        }
    }), e.widget("ui.checkboxradio", [e.ui.formResetMixin, {
        version: "1.12.1",
        options: {
            disabled: null,
            label: null,
            icon: !0,
            classes: {"ui-checkboxradio-label": "ui-corner-all", "ui-checkboxradio-icon": "ui-corner-all"}
        },
        _getCreateOptions: function () {
            var t, i, s = this, n = this._super() || {};
            return this._readType(), i = this.element.labels(), this.label = e(i[i.length - 1]), this.label.length || e.error("No label found for checkboxradio widget"), this.originalLabel = "", this.label.contents().not(this.element[0]).each(function () {
                s.originalLabel += 3 === this.nodeType ? e(this).text() : this.outerHTML
            }), this.originalLabel && (n.label = this.originalLabel), t = this.element[0].disabled, null != t && (n.disabled = t), n
        },
        _create: function () {
            var e = this.element[0].checked;
            this._bindFormResetHandler(), null == this.options.disabled && (this.options.disabled = this.element[0].disabled), this._setOption("disabled", this.options.disabled), this._addClass("ui-checkboxradio", "ui-helper-hidden-accessible"), this._addClass(this.label, "ui-checkboxradio-label", "ui-button ui-widget"), "radio" === this.type && this._addClass(this.label, "ui-checkboxradio-radio-label"), this.options.label && this.options.label !== this.originalLabel ? this._updateLabel() : this.originalLabel && (this.options.label = this.originalLabel), this._enhance(), e && (this._addClass(this.label, "ui-checkboxradio-checked", "ui-state-active"), this.icon && this._addClass(this.icon, null, "ui-state-hover")), this._on({
                change: "_toggleClasses",
                focus: function () {
                    this._addClass(this.label, null, "ui-state-focus ui-visual-focus")
                },
                blur: function () {
                    this._removeClass(this.label, null, "ui-state-focus ui-visual-focus")
                }
            })
        },
        _readType: function () {
            var t = this.element[0].nodeName.toLowerCase();
            this.type = this.element[0].type, "input" === t && /radio|checkbox/.test(this.type) || e.error("Can't create checkboxradio on element.nodeName=" + t + " and element.type=" + this.type)
        },
        _enhance: function () {
            this._updateIcon(this.element[0].checked)
        },
        widget: function () {
            return this.label
        },
        _getRadioGroup: function () {
            var t, i = this.element[0].name, s = "input[name='" + e.ui.escapeSelector(i) + "']";
            return i ? (t = this.form.length ? e(this.form[0].elements).filter(s) : e(s).filter(function () {
                        return 0 === e(this).form().length
                    }), t.not(this.element)) : e([])
        },
        _toggleClasses: function () {
            var t = this.element[0].checked;
            this._toggleClass(this.label, "ui-checkboxradio-checked", "ui-state-active", t), this.options.icon && "checkbox" === this.type && this._toggleClass(this.icon, null, "ui-icon-check ui-state-checked", t)._toggleClass(this.icon, null, "ui-icon-blank", !t), "radio" === this.type && this._getRadioGroup().each(function () {
                var t = e(this).checkboxradio("instance");
                t && t._removeClass(t.label, "ui-checkboxradio-checked", "ui-state-active")
            })
        },
        _destroy: function () {
            this._unbindFormResetHandler(), this.icon && (this.icon.remove(), this.iconSpace.remove())
        },
        _setOption: function (e, t) {
            return "label" !== e || t ? (this._super(e, t), "disabled" === e ? (this._toggleClass(this.label, null, "ui-state-disabled", t), this.element[0].disabled = t, void 0) : (this.refresh(), void 0)) : void 0
        },
        _updateIcon: function (t) {
            var i = "ui-icon ui-icon-background ";
            this.options.icon ? (this.icon || (this.icon = e("<span>"), this.iconSpace = e("<span> </span>"), this._addClass(this.iconSpace, "ui-checkboxradio-icon-space")), "checkbox" === this.type ? (i += t ? "ui-icon-check ui-state-checked" : "ui-icon-blank", this._removeClass(this.icon, null, t ? "ui-icon-blank" : "ui-icon-check")) : i += "ui-icon-blank", this._addClass(this.icon, "ui-checkboxradio-icon", i), t || this._removeClass(this.icon, null, "ui-icon-check ui-state-checked"), this.icon.prependTo(this.label).after(this.iconSpace)) : void 0 !== this.icon && (this.icon.remove(), this.iconSpace.remove(), delete this.icon)
        },
        _updateLabel: function () {
            var e = this.label.contents().not(this.element[0]);
            this.icon && (e = e.not(this.icon[0])), this.iconSpace && (e = e.not(this.iconSpace[0])), e.remove(), this.label.append(this.options.label)
        },
        refresh: function () {
            var e = this.element[0].checked, t = this.element[0].disabled;
            this._updateIcon(e), this._toggleClass(this.label, "ui-checkboxradio-checked", "ui-state-active", e), null !== this.options.label && this._updateLabel(), t !== this.options.disabled && this._setOptions({disabled: t})
        }
    }]), e.ui.checkboxradio, e.widget("ui.button", {
        version: "1.12.1",
        defaultElement: "<button>",
        options: {
            classes: {"ui-button": "ui-corner-all"},
            disabled: null,
            icon: null,
            iconPosition: "beginning",
            label: null,
            showLabel: !0
        },
        _getCreateOptions: function () {
            var e, t = this._super() || {};
            return this.isInput = this.element.is("input"), e = this.element[0].disabled, null != e && (t.disabled = e), this.originalLabel = this.isInput ? this.element.val() : this.element.html(), this.originalLabel && (t.label = this.originalLabel), t
        },
        _create: function () {
            !this.option.showLabel & !this.options.icon && (this.options.showLabel = !0), null == this.options.disabled && (this.options.disabled = this.element[0].disabled || !1), this.hasTitle = !!this.element.attr("title"), this.options.label && this.options.label !== this.originalLabel && (this.isInput ? this.element.val(this.options.label) : this.element.html(this.options.label)), this._addClass("ui-button", "ui-widget"), this._setOption("disabled", this.options.disabled), this._enhance(), this.element.is("a") && this._on({
                keyup: function (t) {
                    t.keyCode === e.ui.keyCode.SPACE && (t.preventDefault(), this.element[0].click ? this.element[0].click() : this.element.trigger("click"))
                }
            })
        },
        _enhance: function () {
            this.element.is("button") || this.element.attr("role", "button"), this.options.icon && (this._updateIcon("icon", this.options.icon), this._updateTooltip())
        },
        _updateTooltip: function () {
            this.title = this.element.attr("title"), this.options.showLabel || this.title || this.element.attr("title", this.options.label)
        },
        _updateIcon: function (t, i) {
            var s = "iconPosition" !== t, n = s ? this.options.iconPosition : i, a = "top" === n || "bottom" === n;
            this.icon ? s && this._removeClass(this.icon, null, this.options.icon) : (this.icon = e("<span>"), this._addClass(this.icon, "ui-button-icon", "ui-icon"), this.options.showLabel || this._addClass("ui-button-icon-only")), s && this._addClass(this.icon, null, i), this._attachIcon(n), a ? (this._addClass(this.icon, null, "ui-widget-icon-block"), this.iconSpace && this.iconSpace.remove()) : (this.iconSpace || (this.iconSpace = e("<span> </span>"), this._addClass(this.iconSpace, "ui-button-icon-space")), this._removeClass(this.icon, null, "ui-wiget-icon-block"), this._attachIconSpace(n))
        },
        _destroy: function () {
            this.element.removeAttr("role"), this.icon && this.icon.remove(), this.iconSpace && this.iconSpace.remove(), this.hasTitle || this.element.removeAttr("title")
        },
        _attachIconSpace: function (e) {
            this.icon[/^(?:end|bottom)/.test(e) ? "before" : "after"](this.iconSpace)
        },
        _attachIcon: function (e) {
            this.element[/^(?:end|bottom)/.test(e) ? "append" : "prepend"](this.icon)
        },
        _setOptions: function (e) {
            var t = void 0 === e.showLabel ? this.options.showLabel : e.showLabel, i = void 0 === e.icon ? this.options.icon : e.icon;
            t || i || (e.showLabel = !0), this._super(e)
        },
        _setOption: function (e, t) {
            "icon" === e && (t ? this._updateIcon(e, t) : this.icon && (this.icon.remove(), this.iconSpace && this.iconSpace.remove())), "iconPosition" === e && this._updateIcon(e, t), "showLabel" === e && (this._toggleClass("ui-button-icon-only", null, !t), this._updateTooltip()), "label" === e && (this.isInput ? this.element.val(t) : (this.element.html(t), this.icon && (this._attachIcon(this.options.iconPosition), this._attachIconSpace(this.options.iconPosition)))), this._super(e, t), "disabled" === e && (this._toggleClass(null, "ui-state-disabled", t), this.element[0].disabled = t, t && this.element.blur())
        },
        refresh: function () {
            var e = this.element.is("input, button") ? this.element[0].disabled : this.element.hasClass("ui-button-disabled");
            e !== this.options.disabled && this._setOptions({disabled: e}), this._updateTooltip()
        }
    }), e.uiBackCompat !== !1 && (e.widget("ui.button", e.ui.button, {
        options: {
            text: !0,
            icons: {primary: null, secondary: null}
        }, _create: function () {
            this.options.showLabel && !this.options.text && (this.options.showLabel = this.options.text), !this.options.showLabel && this.options.text && (this.options.text = this.options.showLabel), this.options.icon || !this.options.icons.primary && !this.options.icons.secondary ? this.options.icon && (this.options.icons.primary = this.options.icon) : this.options.icons.primary ? this.options.icon = this.options.icons.primary : (this.options.icon = this.options.icons.secondary, this.options.iconPosition = "end"), this._super()
        }, _setOption: function (e, t) {
            return "text" === e ? (this._super("showLabel", t), void 0) : ("showLabel" === e && (this.options.text = t), "icon" === e && (this.options.icons.primary = t), "icons" === e && (t.primary ? (this._super("icon", t.primary), this._super("iconPosition", "beginning")) : t.secondary && (this._super("icon", t.secondary), this._super("iconPosition", "end"))), this._superApply(arguments), void 0)
        }
    }), e.fn.button = function (t) {
        return function () {
            return !this.length || this.length && "INPUT" !== this[0].tagName || this.length && "INPUT" === this[0].tagName && "checkbox" !== this.attr("type") && "radio" !== this.attr("type") ? t.apply(this, arguments) : (e.ui.checkboxradio || e.error("Checkboxradio widget missing"), 0 === arguments.length ? this.checkboxradio({icon: !1}) : this.checkboxradio.apply(this, arguments))
        }
    }(e.fn.button), e.fn.buttonset = function () {
        return e.ui.controlgroup || e.error("Controlgroup widget missing"), "option" === arguments[0] && "items" === arguments[1] && arguments[2] ? this.controlgroup.apply(this, [arguments[0], "items.button", arguments[2]]) : "option" === arguments[0] && "items" === arguments[1] ? this.controlgroup.apply(this, [arguments[0], "items.button"]) : ("object" == typeof arguments[0] && arguments[0].items && (arguments[0].items = {button: arguments[0].items}), this.controlgroup.apply(this, arguments))
    }), e.ui.button, e.extend(e.ui, {datepicker: {version: "1.12.1"}});
    var p;
    e.extend(s.prototype, {
        markerClassName: "hasDatepicker",
        maxRows: 4,
        _widgetDatepicker: function () {
            return this.dpDiv
        },
        setDefaults: function (e) {
            return o(this._defaults, e || {}), this
        },
        _attachDatepicker: function (t, i) {
            var s, n, a;
            s = t.nodeName.toLowerCase(), n = "div" === s || "span" === s, t.id || (this.uuid += 1, t.id = "dp" + this.uuid), a = this._newInst(e(t), n), a.settings = e.extend({}, i || {}), "input" === s ? this._connectDatepicker(t, a) : n && this._inlineDatepicker(t, a)
        },
        _newInst: function (t, i) {
            var s = t[0].id.replace(/([^A-Za-z0-9_\-])/g, "\\\\$1");
            return {
                id: s,
                input: t,
                selectedDay: 0,
                selectedMonth: 0,
                selectedYear: 0,
                drawMonth: 0,
                drawYear: 0,
                inline: i,
                dpDiv: i ? n(e("<div class='" + this._inlineClass + " ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>")) : this.dpDiv
            }
        },
        _connectDatepicker: function (t, i) {
            var s = e(t);
            i.append = e([]), i.trigger = e([]), s.hasClass(this.markerClassName) || (this._attachments(s, i), s.addClass(this.markerClassName).on("keydown", this._doKeyDown).on("keypress", this._doKeyPress).on("keyup", this._doKeyUp), this._autoSize(i), e.data(t, "datepicker", i), i.settings.disabled && this._disableDatepicker(t))
        },
        _attachments: function (t, i) {
            var s, n, a, o = this._get(i, "appendText"), r = this._get(i, "isRTL");
            i.append && i.append.remove(), o && (i.append = e("<span class='" + this._appendClass + "'>" + o + "</span>"), t[r ? "before" : "after"](i.append)), t.off("focus", this._showDatepicker), i.trigger && i.trigger.remove(), s = this._get(i, "showOn"), ("focus" === s || "both" === s) && t.on("focus", this._showDatepicker), ("button" === s || "both" === s) && (n = this._get(i, "buttonText"), a = this._get(i, "buttonImage"), i.trigger = e(this._get(i, "buttonImageOnly") ? e("<img/>").addClass(this._triggerClass).attr({
                    src: a,
                    alt: n,
                    title: n
                }) : e("<button type='button'></button>").addClass(this._triggerClass).html(a ? e("<img/>").attr({
                        src: a,
                        alt: n,
                        title: n
                    }) : n)), t[r ? "before" : "after"](i.trigger), i.trigger.on("click", function () {
                return e.datepicker._datepickerShowing && e.datepicker._lastInput === t[0] ? e.datepicker._hideDatepicker() : e.datepicker._datepickerShowing && e.datepicker._lastInput !== t[0] ? (e.datepicker._hideDatepicker(), e.datepicker._showDatepicker(t[0])) : e.datepicker._showDatepicker(t[0]), !1
            }))
        },
        _autoSize: function (e) {
            if (this._get(e, "autoSize") && !e.inline) {
                var t, i, s, n, a = new Date(2009, 11, 20), o = this._get(e, "dateFormat");
                o.match(/[DM]/) && (t = function (e) {
                    for (i = 0, s = 0, n = 0; e.length > n; n++)e[n].length > i && (i = e[n].length, s = n);
                    return s
                }, a.setMonth(t(this._get(e, o.match(/MM/) ? "monthNames" : "monthNamesShort"))), a.setDate(t(this._get(e, o.match(/DD/) ? "dayNames" : "dayNamesShort")) + 20 - a.getDay())), e.input.attr("size", this._formatDate(e, a).length)
            }
        },
        _inlineDatepicker: function (t, i) {
            var s = e(t);
            s.hasClass(this.markerClassName) || (s.addClass(this.markerClassName).append(i.dpDiv), e.data(t, "datepicker", i), this._setDate(i, this._getDefaultDate(i), !0), this._updateDatepicker(i), this._updateAlternate(i), i.settings.disabled && this._disableDatepicker(t), i.dpDiv.css("display", "block"))
        },
        _dialogDatepicker: function (t, i, s, n, a) {
            var r, h, l, u, c, d = this._dialogInst;
            return d || (this.uuid += 1, r = "dp" + this.uuid, this._dialogInput = e("<input type='text' id='" + r + "' style='position: absolute; top: -100px; width: 0px;'/>"), this._dialogInput.on("keydown", this._doKeyDown), e("body").append(this._dialogInput), d = this._dialogInst = this._newInst(this._dialogInput, !1), d.settings = {}, e.data(this._dialogInput[0], "datepicker", d)), o(d.settings, n || {}), i = i && i.constructor === Date ? this._formatDate(d, i) : i, this._dialogInput.val(i), this._pos = a ? a.length ? a : [a.pageX, a.pageY] : null, this._pos || (h = document.documentElement.clientWidth, l = document.documentElement.clientHeight, u = document.documentElement.scrollLeft || document.body.scrollLeft, c = document.documentElement.scrollTop || document.body.scrollTop, this._pos = [h / 2 - 100 + u, l / 2 - 150 + c]), this._dialogInput.css("left", this._pos[0] + 20 + "px").css("top", this._pos[1] + "px"), d.settings.onSelect = s, this._inDialog = !0, this.dpDiv.addClass(this._dialogClass), this._showDatepicker(this._dialogInput[0]), e.blockUI && e.blockUI(this.dpDiv), e.data(this._dialogInput[0], "datepicker", d), this
        },
        _destroyDatepicker: function (t) {
            var i, s = e(t), n = e.data(t, "datepicker");
            s.hasClass(this.markerClassName) && (i = t.nodeName.toLowerCase(), e.removeData(t, "datepicker"), "input" === i ? (n.append.remove(), n.trigger.remove(), s.removeClass(this.markerClassName).off("focus", this._showDatepicker).off("keydown", this._doKeyDown).off("keypress", this._doKeyPress).off("keyup", this._doKeyUp)) : ("div" === i || "span" === i) && s.removeClass(this.markerClassName).empty(), p === n && (p = null))
        },
        _enableDatepicker: function (t) {
            var i, s, n = e(t), a = e.data(t, "datepicker");
            n.hasClass(this.markerClassName) && (i = t.nodeName.toLowerCase(), "input" === i ? (t.disabled = !1, a.trigger.filter("button").each(function () {
                    this.disabled = !1
                }).end().filter("img").css({
                    opacity: "1.0",
                    cursor: ""
                })) : ("div" === i || "span" === i) && (s = n.children("." + this._inlineClass), s.children().removeClass("ui-state-disabled"), s.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled", !1)), this._disabledInputs = e.map(this._disabledInputs, function (e) {
                return e === t ? null : e
            }))
        },
        _disableDatepicker: function (t) {
            var i, s, n = e(t), a = e.data(t, "datepicker");
            n.hasClass(this.markerClassName) && (i = t.nodeName.toLowerCase(), "input" === i ? (t.disabled = !0, a.trigger.filter("button").each(function () {
                    this.disabled = !0
                }).end().filter("img").css({
                    opacity: "0.5",
                    cursor: "default"
                })) : ("div" === i || "span" === i) && (s = n.children("." + this._inlineClass), s.children().addClass("ui-state-disabled"), s.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled", !0)), this._disabledInputs = e.map(this._disabledInputs, function (e) {
                return e === t ? null : e
            }), this._disabledInputs[this._disabledInputs.length] = t)
        },
        _isDisabledDatepicker: function (e) {
            if (!e)return !1;
            for (var t = 0; this._disabledInputs.length > t; t++)if (this._disabledInputs[t] === e)return !0;
            return !1
        },
        _getInst: function (t) {
            try {
                return e.data(t, "datepicker")
            } catch (i) {
                throw"Missing instance data for this datepicker"
            }
        },
        _optionDatepicker: function (t, i, s) {
            var n, a, r, h, l = this._getInst(t);
            return 2 === arguments.length && "string" == typeof i ? "defaults" === i ? e.extend({}, e.datepicker._defaults) : l ? "all" === i ? e.extend({}, l.settings) : this._get(l, i) : null : (n = i || {}, "string" == typeof i && (n = {}, n[i] = s), l && (this._curInst === l && this._hideDatepicker(), a = this._getDateDatepicker(t, !0), r = this._getMinMaxDate(l, "min"), h = this._getMinMaxDate(l, "max"), o(l.settings, n), null !== r && void 0 !== n.dateFormat && void 0 === n.minDate && (l.settings.minDate = this._formatDate(l, r)), null !== h && void 0 !== n.dateFormat && void 0 === n.maxDate && (l.settings.maxDate = this._formatDate(l, h)), "disabled" in n && (n.disabled ? this._disableDatepicker(t) : this._enableDatepicker(t)), this._attachments(e(t), l), this._autoSize(l), this._setDate(l, a), this._updateAlternate(l), this._updateDatepicker(l)), void 0)
        },
        _changeDatepicker: function (e, t, i) {
            this._optionDatepicker(e, t, i)
        },
        _refreshDatepicker: function (e) {
            var t = this._getInst(e);
            t && this._updateDatepicker(t)
        },
        _setDateDatepicker: function (e, t) {
            var i = this._getInst(e);
            i && (this._setDate(i, t), this._updateDatepicker(i), this._updateAlternate(i))
        },
        _getDateDatepicker: function (e, t) {
            var i = this._getInst(e);
            return i && !i.inline && this._setDateFromField(i, t), i ? this._getDate(i) : null
        },
        _doKeyDown: function (t) {
            var i, s, n, a = e.datepicker._getInst(t.target), o = !0, r = a.dpDiv.is(".ui-datepicker-rtl");
            if (a._keyEvent = !0, e.datepicker._datepickerShowing)switch (t.keyCode) {
                case 9:
                    e.datepicker._hideDatepicker(), o = !1;
                    break;
                case 13:
                    return n = e("td." + e.datepicker._dayOverClass + ":not(." + e.datepicker._currentClass + ")", a.dpDiv), n[0] && e.datepicker._selectDay(t.target, a.selectedMonth, a.selectedYear, n[0]), i = e.datepicker._get(a, "onSelect"), i ? (s = e.datepicker._formatDate(a), i.apply(a.input ? a.input[0] : null, [s, a])) : e.datepicker._hideDatepicker(), !1;
                case 27:
                    e.datepicker._hideDatepicker();
                    break;
                case 33:
                    e.datepicker._adjustDate(t.target, t.ctrlKey ? -e.datepicker._get(a, "stepBigMonths") : -e.datepicker._get(a, "stepMonths"), "M");
                    break;
                case 34:
                    e.datepicker._adjustDate(t.target, t.ctrlKey ? +e.datepicker._get(a, "stepBigMonths") : +e.datepicker._get(a, "stepMonths"), "M");
                    break;
                case 35:
                    (t.ctrlKey || t.metaKey) && e.datepicker._clearDate(t.target), o = t.ctrlKey || t.metaKey;
                    break;
                case 36:
                    (t.ctrlKey || t.metaKey) && e.datepicker._gotoToday(t.target), o = t.ctrlKey || t.metaKey;
                    break;
                case 37:
                    (t.ctrlKey || t.metaKey) && e.datepicker._adjustDate(t.target, r ? 1 : -1, "D"), o = t.ctrlKey || t.metaKey, t.originalEvent.altKey && e.datepicker._adjustDate(t.target, t.ctrlKey ? -e.datepicker._get(a, "stepBigMonths") : -e.datepicker._get(a, "stepMonths"), "M");
                    break;
                case 38:
                    (t.ctrlKey || t.metaKey) && e.datepicker._adjustDate(t.target, -7, "D"), o = t.ctrlKey || t.metaKey;
                    break;
                case 39:
                    (t.ctrlKey || t.metaKey) && e.datepicker._adjustDate(t.target, r ? -1 : 1, "D"), o = t.ctrlKey || t.metaKey, t.originalEvent.altKey && e.datepicker._adjustDate(t.target, t.ctrlKey ? +e.datepicker._get(a, "stepBigMonths") : +e.datepicker._get(a, "stepMonths"), "M");
                    break;
                case 40:
                    (t.ctrlKey || t.metaKey) && e.datepicker._adjustDate(t.target, 7, "D"), o = t.ctrlKey || t.metaKey;
                    break;
                default:
                    o = !1
            } else 36 === t.keyCode && t.ctrlKey ? e.datepicker._showDatepicker(this) : o = !1;
            o && (t.preventDefault(), t.stopPropagation())
        },
        _doKeyPress: function (t) {
            var i, s, n = e.datepicker._getInst(t.target);
            return e.datepicker._get(n, "constrainInput") ? (i = e.datepicker._possibleChars(e.datepicker._get(n, "dateFormat")), s = String.fromCharCode(null == t.charCode ? t.keyCode : t.charCode), t.ctrlKey || t.metaKey || " " > s || !i || i.indexOf(s) > -1) : void 0
        },
        _doKeyUp: function (t) {
            var i, s = e.datepicker._getInst(t.target);
            if (s.input.val() !== s.lastVal)try {
                i = e.datepicker.parseDate(e.datepicker._get(s, "dateFormat"), s.input ? s.input.val() : null, e.datepicker._getFormatConfig(s)), i && (e.datepicker._setDateFromField(s), e.datepicker._updateAlternate(s), e.datepicker._updateDatepicker(s))
            } catch (n) {
            }
            return !0
        },
        _showDatepicker: function (t) {
            if (t = t.target || t, "input" !== t.nodeName.toLowerCase() && (t = e("input", t.parentNode)[0]), !e.datepicker._isDisabledDatepicker(t) && e.datepicker._lastInput !== t) {
                var s, n, a, r, h, l, u;
                s = e.datepicker._getInst(t), e.datepicker._curInst && e.datepicker._curInst !== s && (e.datepicker._curInst.dpDiv.stop(!0, !0), s && e.datepicker._datepickerShowing && e.datepicker._hideDatepicker(e.datepicker._curInst.input[0])), n = e.datepicker._get(s, "beforeShow"), a = n ? n.apply(t, [t, s]) : {}, a !== !1 && (o(s.settings, a), s.lastVal = null, e.datepicker._lastInput = t, e.datepicker._setDateFromField(s), e.datepicker._inDialog && (t.value = ""), e.datepicker._pos || (e.datepicker._pos = e.datepicker._findPos(t), e.datepicker._pos[1] += t.offsetHeight), r = !1, e(t).parents().each(function () {
                    return r |= "fixed" === e(this).css("position"), !r
                }), h = {
                    left: e.datepicker._pos[0],
                    top: e.datepicker._pos[1]
                }, e.datepicker._pos = null, s.dpDiv.empty(), s.dpDiv.css({
                    position: "absolute",
                    display: "block",
                    top: "-1000px"
                }), e.datepicker._updateDatepicker(s), h = e.datepicker._checkOffset(s, h, r), s.dpDiv.css({
                    position: e.datepicker._inDialog && e.blockUI ? "static" : r ? "fixed" : "absolute",
                    display: "none",
                    left: h.left + "px",
                    top: h.top + "px"
                }), s.inline || (l = e.datepicker._get(s, "showAnim"), u = e.datepicker._get(s, "duration"), s.dpDiv.css("z-index", i(e(t)) + 1), e.datepicker._datepickerShowing = !0, e.effects && e.effects.effect[l] ? s.dpDiv.show(l, e.datepicker._get(s, "showOptions"), u) : s.dpDiv[l || "show"](l ? u : null), e.datepicker._shouldFocusInput(s) && s.input.trigger("focus"), e.datepicker._curInst = s))
            }
        },
        _updateDatepicker: function (t) {
            this.maxRows = 4, p = t, t.dpDiv.empty().append(this._generateHTML(t)), this._attachHandlers(t);
            var i, s = this._getNumberOfMonths(t), n = s[1], o = 17, r = t.dpDiv.find("." + this._dayOverClass + " a");
            r.length > 0 && a.apply(r.get(0)), t.dpDiv.removeClass("ui-datepicker-multi-2 ui-datepicker-multi-3 ui-datepicker-multi-4").width(""), n > 1 && t.dpDiv.addClass("ui-datepicker-multi-" + n).css("width", o * n + "em"), t.dpDiv[(1 !== s[0] || 1 !== s[1] ? "add" : "remove") + "Class"]("ui-datepicker-multi"), t.dpDiv[(this._get(t, "isRTL") ? "add" : "remove") + "Class"]("ui-datepicker-rtl"), t === e.datepicker._curInst && e.datepicker._datepickerShowing && e.datepicker._shouldFocusInput(t) && t.input.trigger("focus"), t.yearshtml && (i = t.yearshtml, setTimeout(function () {
                i === t.yearshtml && t.yearshtml && t.dpDiv.find("select.ui-datepicker-year:first").replaceWith(t.yearshtml), i = t.yearshtml = null
            }, 0))
        },
        _shouldFocusInput: function (e) {
            return e.input && e.input.is(":visible") && !e.input.is(":disabled") && !e.input.is(":focus")
        },
        _checkOffset: function (t, i, s) {
            var n = t.dpDiv.outerWidth(), a = t.dpDiv.outerHeight(), o = t.input ? t.input.outerWidth() : 0, r = t.input ? t.input.outerHeight() : 0, h = document.documentElement.clientWidth + (s ? 0 : e(document).scrollLeft()), l = document.documentElement.clientHeight + (s ? 0 : e(document).scrollTop());
            return i.left -= this._get(t, "isRTL") ? n - o : 0, i.left -= s && i.left === t.input.offset().left ? e(document).scrollLeft() : 0, i.top -= s && i.top === t.input.offset().top + r ? e(document).scrollTop() : 0, i.left -= Math.min(i.left, i.left + n > h && h > n ? Math.abs(i.left + n - h) : 0), i.top -= Math.min(i.top, i.top + a > l && l > a ? Math.abs(a + r) : 0), i
        },
        _findPos: function (t) {
            for (var i, s = this._getInst(t), n = this._get(s, "isRTL"); t && ("hidden" === t.type || 1 !== t.nodeType || e.expr.filters.hidden(t));)t = t[n ? "previousSibling" : "nextSibling"];
            return i = e(t).offset(), [i.left, i.top]
        },
        _hideDatepicker: function (t) {
            var i, s, n, a, o = this._curInst;
            !o || t && o !== e.data(t, "datepicker") || this._datepickerShowing && (i = this._get(o, "showAnim"), s = this._get(o, "duration"), n = function () {
                e.datepicker._tidyDialog(o)
            }, e.effects && (e.effects.effect[i] || e.effects[i]) ? o.dpDiv.hide(i, e.datepicker._get(o, "showOptions"), s, n) : o.dpDiv["slideDown" === i ? "slideUp" : "fadeIn" === i ? "fadeOut" : "hide"](i ? s : null, n), i || n(), this._datepickerShowing = !1, a = this._get(o, "onClose"), a && a.apply(o.input ? o.input[0] : null, [o.input ? o.input.val() : "", o]), this._lastInput = null, this._inDialog && (this._dialogInput.css({
                position: "absolute",
                left: "0",
                top: "-100px"
            }), e.blockUI && (e.unblockUI(), e("body").append(this.dpDiv))), this._inDialog = !1)
        },
        _tidyDialog: function (e) {
            e.dpDiv.removeClass(this._dialogClass).off(".ui-datepicker-calendar")
        },
        _checkExternalClick: function (t) {
            if (e.datepicker._curInst) {
                var i = e(t.target), s = e.datepicker._getInst(i[0]);
                (i[0].id !== e.datepicker._mainDivId && 0 === i.parents("#" + e.datepicker._mainDivId).length && !i.hasClass(e.datepicker.markerClassName) && !i.closest("." + e.datepicker._triggerClass).length && e.datepicker._datepickerShowing && (!e.datepicker._inDialog || !e.blockUI) || i.hasClass(e.datepicker.markerClassName) && e.datepicker._curInst !== s) && e.datepicker._hideDatepicker()
            }
        },
        _adjustDate: function (t, i, s) {
            var n = e(t), a = this._getInst(n[0]);
            this._isDisabledDatepicker(n[0]) || (this._adjustInstDate(a, i + ("M" === s ? this._get(a, "showCurrentAtPos") : 0), s), this._updateDatepicker(a))
        },
        _gotoToday: function (t) {
            var i, s = e(t), n = this._getInst(s[0]);
            this._get(n, "gotoCurrent") && n.currentDay ? (n.selectedDay = n.currentDay, n.drawMonth = n.selectedMonth = n.currentMonth, n.drawYear = n.selectedYear = n.currentYear) : (i = new Date, n.selectedDay = i.getDate(), n.drawMonth = n.selectedMonth = i.getMonth(), n.drawYear = n.selectedYear = i.getFullYear()), this._notifyChange(n), this._adjustDate(s)
        },
        _selectMonthYear: function (t, i, s) {
            var n = e(t), a = this._getInst(n[0]);
            a["selected" + ("M" === s ? "Month" : "Year")] = a["draw" + ("M" === s ? "Month" : "Year")] = parseInt(i.options[i.selectedIndex].value, 10), this._notifyChange(a), this._adjustDate(n)
        },
        _selectDay: function (t, i, s, n) {
            var a, o = e(t);
            e(n).hasClass(this._unselectableClass) || this._isDisabledDatepicker(o[0]) || (a = this._getInst(o[0]), a.selectedDay = a.currentDay = e("a", n).html(), a.selectedMonth = a.currentMonth = i, a.selectedYear = a.currentYear = s, this._selectDate(t, this._formatDate(a, a.currentDay, a.currentMonth, a.currentYear)))
        },
        _clearDate: function (t) {
            var i = e(t);
            this._selectDate(i, "")
        },
        _selectDate: function (t, i) {
            var s, n = e(t), a = this._getInst(n[0]);
            i = null != i ? i : this._formatDate(a), a.input && a.input.val(i), this._updateAlternate(a), s = this._get(a, "onSelect"), s ? s.apply(a.input ? a.input[0] : null, [i, a]) : a.input && a.input.trigger("change"), a.inline ? this._updateDatepicker(a) : (this._hideDatepicker(), this._lastInput = a.input[0], "object" != typeof a.input[0] && a.input.trigger("focus"), this._lastInput = null)
        },
        _updateAlternate: function (t) {
            var i, s, n, a = this._get(t, "altField");
            a && (i = this._get(t, "altFormat") || this._get(t, "dateFormat"), s = this._getDate(t), n = this.formatDate(i, s, this._getFormatConfig(t)), e(a).val(n))
        },
        noWeekends: function (e) {
            var t = e.getDay();
            return [t > 0 && 6 > t, ""]
        },
        iso8601Week: function (e) {
            var t, i = new Date(e.getTime());
            return i.setDate(i.getDate() + 4 - (i.getDay() || 7)), t = i.getTime(), i.setMonth(0), i.setDate(1), Math.floor(Math.round((t - i) / 864e5) / 7) + 1
        },
        parseDate: function (t, i, s) {
            if (null == t || null == i)throw"Invalid arguments";
            if (i = "object" == typeof i ? "" + i : i + "", "" === i)return null;
            var n, a, o, r, h = 0, l = (s ? s.shortYearCutoff : null) || this._defaults.shortYearCutoff, u = "string" != typeof l ? l : (new Date).getFullYear() % 100 + parseInt(l, 10), c = (s ? s.dayNamesShort : null) || this._defaults.dayNamesShort, d = (s ? s.dayNames : null) || this._defaults.dayNames, p = (s ? s.monthNamesShort : null) || this._defaults.monthNamesShort, f = (s ? s.monthNames : null) || this._defaults.monthNames, m = -1, g = -1, v = -1, _ = -1, b = !1, y = function (e) {
                var i = t.length > n + 1 && t.charAt(n + 1) === e;
                return i && n++, i
            }, x = function (e) {
                var t = y(e), s = "@" === e ? 14 : "!" === e ? 20 : "y" === e && t ? 4 : "o" === e ? 3 : 2, n = "y" === e ? s : 1, a = RegExp("^\\d{" + n + "," + s + "}"), o = i.substring(h).match(a);
                if (!o)throw"Missing number at position " + h;
                return h += o[0].length, parseInt(o[0], 10)
            }, k = function (t, s, n) {
                var a = -1, o = e.map(y(t) ? n : s, function (e, t) {
                    return [[t, e]]
                }).sort(function (e, t) {
                    return -(e[1].length - t[1].length)
                });
                if (e.each(o, function (e, t) {
                        var s = t[1];
                        return i.substr(h, s.length).toLowerCase() === s.toLowerCase() ? (a = t[0], h += s.length, !1) : void 0
                    }), -1 !== a)return a + 1;
                throw"Unknown name at position " + h
            }, w = function () {
                if (i.charAt(h) !== t.charAt(n))throw"Unexpected literal at position " + h;
                h++
            };
            for (n = 0; t.length > n; n++)if (b) "'" !== t.charAt(n) || y("'") ? w() : b = !1; else switch (t.charAt(n)) {
                case"d":
                    v = x("d");
                    break;
                case"D":
                    k("D", c, d);
                    break;
                case"o":
                    _ = x("o");
                    break;
                case"m":
                    g = x("m");
                    break;
                case"M":
                    g = k("M", p, f);
                    break;
                case"y":
                    m = x("y");
                    break;
                case"@":
                    r = new Date(x("@")), m = r.getFullYear(), g = r.getMonth() + 1, v = r.getDate();
                    break;
                case"!":
                    r = new Date((x("!") - this._ticksTo1970) / 1e4), m = r.getFullYear(), g = r.getMonth() + 1, v = r.getDate();
                    break;
                case"'":
                    y("'") ? w() : b = !0;
                    break;
                default:
                    w()
            }
            if (i.length > h && (o = i.substr(h), !/^\s+/.test(o)))throw"Extra/unparsed characters found in date: " + o;
            if (-1 === m ? m = (new Date).getFullYear() : 100 > m && (m += (new Date).getFullYear() - (new Date).getFullYear() % 100 + (u >= m ? 0 : -100)), _ > -1)for (g = 1, v = _; ;) {
                if (a = this._getDaysInMonth(m, g - 1), a >= v)break;
                g++, v -= a
            }
            if (r = this._daylightSavingAdjust(new Date(m, g - 1, v)), r.getFullYear() !== m || r.getMonth() + 1 !== g || r.getDate() !== v)throw"Invalid date";
            return r
        },
        ATOM: "yy-mm-dd",
        COOKIE: "D, dd M yy",
        ISO_8601: "yy-mm-dd",
        RFC_822: "D, d M y",
        RFC_850: "DD, dd-M-y",
        RFC_1036: "D, d M y",
        RFC_1123: "D, d M yy",
        RFC_2822: "D, d M yy",
        RSS: "D, d M y",
        TICKS: "!",
        TIMESTAMP: "@",
        W3C: "yy-mm-dd",
        _ticksTo1970: 1e7 * 60 * 60 * 24 * (718685 + Math.floor(492.5) - Math.floor(19.7) + Math.floor(4.925)),
        formatDate: function (e, t, i) {
            if (!t)return "";
            var s, n = (i ? i.dayNamesShort : null) || this._defaults.dayNamesShort, a = (i ? i.dayNames : null) || this._defaults.dayNames, o = (i ? i.monthNamesShort : null) || this._defaults.monthNamesShort, r = (i ? i.monthNames : null) || this._defaults.monthNames, h = function (t) {
                var i = e.length > s + 1 && e.charAt(s + 1) === t;
                return i && s++, i
            }, l = function (e, t, i) {
                var s = "" + t;
                if (h(e))for (; i > s.length;)s = "0" + s;
                return s
            }, u = function (e, t, i, s) {
                return h(e) ? s[t] : i[t]
            }, c = "", d = !1;
            if (t)for (s = 0; e.length > s; s++)if (d) "'" !== e.charAt(s) || h("'") ? c += e.charAt(s) : d = !1; else switch (e.charAt(s)) {
                case"d":
                    c += l("d", t.getDate(), 2);
                    break;
                case"D":
                    c += u("D", t.getDay(), n, a);
                    break;
                case"o":
                    c += l("o", Math.round((new Date(t.getFullYear(), t.getMonth(), t.getDate()).getTime() - new Date(t.getFullYear(), 0, 0).getTime()) / 864e5), 3);
                    break;
                case"m":
                    c += l("m", t.getMonth() + 1, 2);
                    break;
                case"M":
                    c += u("M", t.getMonth(), o, r);
                    break;
                case"y":
                    c += h("y") ? t.getFullYear() : (10 > t.getFullYear() % 100 ? "0" : "") + t.getFullYear() % 100;
                    break;
                case"@":
                    c += t.getTime();
                    break;
                case"!":
                    c += 1e4 * t.getTime() + this._ticksTo1970;
                    break;
                case"'":
                    h("'") ? c += "'" : d = !0;
                    break;
                default:
                    c += e.charAt(s)
            }
            return c
        },
        _possibleChars: function (e) {
            var t, i = "", s = !1, n = function (i) {
                var s = e.length > t + 1 && e.charAt(t + 1) === i;
                return s && t++, s
            };
            for (t = 0; e.length > t; t++)if (s) "'" !== e.charAt(t) || n("'") ? i += e.charAt(t) : s = !1; else switch (e.charAt(t)) {
                case"d":
                case"m":
                case"y":
                case"@":
                    i += "0123456789";
                    break;
                case"D":
                case"M":
                    return null;
                case"'":
                    n("'") ? i += "'" : s = !0;
                    break;
                default:
                    i += e.charAt(t)
            }
            return i
        },
        _get: function (e, t) {
            return void 0 !== e.settings[t] ? e.settings[t] : this._defaults[t]
        },
        _setDateFromField: function (e, t) {
            if (e.input.val() !== e.lastVal) {
                var i = this._get(e, "dateFormat"), s = e.lastVal = e.input ? e.input.val() : null, n = this._getDefaultDate(e), a = n, o = this._getFormatConfig(e);
                try {
                    a = this.parseDate(i, s, o) || n
                } catch (r) {
                    s = t ? "" : s
                }
                e.selectedDay = a.getDate(), e.drawMonth = e.selectedMonth = a.getMonth(), e.drawYear = e.selectedYear = a.getFullYear(), e.currentDay = s ? a.getDate() : 0, e.currentMonth = s ? a.getMonth() : 0, e.currentYear = s ? a.getFullYear() : 0, this._adjustInstDate(e)
            }
        },
        _getDefaultDate: function (e) {
            return this._restrictMinMax(e, this._determineDate(e, this._get(e, "defaultDate"), new Date))
        },
        _determineDate: function (t, i, s) {
            var n = function (e) {
                var t = new Date;
                return t.setDate(t.getDate() + e), t
            }, a = function (i) {
                try {
                    return e.datepicker.parseDate(e.datepicker._get(t, "dateFormat"), i, e.datepicker._getFormatConfig(t))
                } catch (s) {
                }
                for (var n = (i.toLowerCase().match(/^c/) ? e.datepicker._getDate(t) : null) || new Date, a = n.getFullYear(), o = n.getMonth(), r = n.getDate(), h = /([+\-]?[0-9]+)\s*(d|D|w|W|m|M|y|Y)?/g, l = h.exec(i); l;) {
                    switch (l[2] || "d") {
                        case"d":
                        case"D":
                            r += parseInt(l[1], 10);
                            break;
                        case"w":
                        case"W":
                            r += 7 * parseInt(l[1], 10);
                            break;
                        case"m":
                        case"M":
                            o += parseInt(l[1], 10), r = Math.min(r, e.datepicker._getDaysInMonth(a, o));
                            break;
                        case"y":
                        case"Y":
                            a += parseInt(l[1], 10), r = Math.min(r, e.datepicker._getDaysInMonth(a, o))
                    }
                    l = h.exec(i)
                }
                return new Date(a, o, r)
            }, o = null == i || "" === i ? s : "string" == typeof i ? a(i) : "number" == typeof i ? isNaN(i) ? s : n(i) : new Date(i.getTime());
            return o = o && "Invalid Date" == "" + o ? s : o, o && (o.setHours(0), o.setMinutes(0), o.setSeconds(0), o.setMilliseconds(0)), this._daylightSavingAdjust(o)
        },
        _daylightSavingAdjust: function (e) {
            return e ? (e.setHours(e.getHours() > 12 ? e.getHours() + 2 : 0), e) : null
        },
        _setDate: function (e, t, i) {
            var s = !t, n = e.selectedMonth, a = e.selectedYear, o = this._restrictMinMax(e, this._determineDate(e, t, new Date));
            e.selectedDay = e.currentDay = o.getDate(), e.drawMonth = e.selectedMonth = e.currentMonth = o.getMonth(), e.drawYear = e.selectedYear = e.currentYear = o.getFullYear(), n === e.selectedMonth && a === e.selectedYear || i || this._notifyChange(e), this._adjustInstDate(e), e.input && e.input.val(s ? "" : this._formatDate(e))
        },
        _getDate: function (e) {
            var t = !e.currentYear || e.input && "" === e.input.val() ? null : this._daylightSavingAdjust(new Date(e.currentYear, e.currentMonth, e.currentDay));
            return t
        },
        _attachHandlers: function (t) {
            var i = this._get(t, "stepMonths"), s = "#" + t.id.replace(/\\\\/g, "\\");
            t.dpDiv.find("[data-handler]").map(function () {
                var t = {
                    prev: function () {
                        e.datepicker._adjustDate(s, -i, "M")
                    }, next: function () {
                        e.datepicker._adjustDate(s, +i, "M")
                    }, hide: function () {
                        e.datepicker._hideDatepicker()
                    }, today: function () {
                        e.datepicker._gotoToday(s)
                    }, selectDay: function () {
                        return e.datepicker._selectDay(s, +this.getAttribute("data-month"), +this.getAttribute("data-year"), this), !1
                    }, selectMonth: function () {
                        return e.datepicker._selectMonthYear(s, this, "M"), !1
                    }, selectYear: function () {
                        return e.datepicker._selectMonthYear(s, this, "Y"), !1
                    }
                };
                e(this).on(this.getAttribute("data-event"), t[this.getAttribute("data-handler")])
            })
        },
        _generateHTML: function (e) {
            var t, i, s, n, a, o, r, h, l, u, c, d, p, f, m, g, v, _, b, y, x, k, w, T, D, S, M, C, N, P, A, I, H, z, F, j, O, E, L, W = new Date, R = this._daylightSavingAdjust(new Date(W.getFullYear(), W.getMonth(), W.getDate())), Y = this._get(e, "isRTL"), B = this._get(e, "showButtonPanel"), J = this._get(e, "hideIfNoPrevNext"), Q = this._get(e, "navigationAsDateFormat"), K = this._getNumberOfMonths(e), V = this._get(e, "showCurrentAtPos"), U = this._get(e, "stepMonths"), q = 1 !== K[0] || 1 !== K[1], G = this._daylightSavingAdjust(e.currentDay ? new Date(e.currentYear, e.currentMonth, e.currentDay) : new Date(9999, 9, 9)), X = this._getMinMaxDate(e, "min"), $ = this._getMinMaxDate(e, "max"), Z = e.drawMonth - V, et = e.drawYear;
            if (0 > Z && (Z += 12, et--), $)for (t = this._daylightSavingAdjust(new Date($.getFullYear(), $.getMonth() - K[0] * K[1] + 1, $.getDate())), t = X && X > t ? X : t; this._daylightSavingAdjust(new Date(et, Z, 1)) > t;)Z--, 0 > Z && (Z = 11, et--);
            for (e.drawMonth = Z, e.drawYear = et, i = this._get(e, "prevText"), i = Q ? this.formatDate(i, this._daylightSavingAdjust(new Date(et, Z - U, 1)), this._getFormatConfig(e)) : i, s = this._canAdjustMonth(e, -1, et, Z) ? "<a class='ui-datepicker-prev ui-corner-all' data-handler='prev' data-event='click' title='" + i + "'><span class='ui-icon ui-icon-circle-triangle-" + (Y ? "e" : "w") + "'>" + i + "</span></a>" : J ? "" : "<a class='ui-datepicker-prev ui-corner-all ui-state-disabled' title='" + i + "'><span class='ui-icon ui-icon-circle-triangle-" + (Y ? "e" : "w") + "'>" + i + "</span></a>", n = this._get(e, "nextText"), n = Q ? this.formatDate(n, this._daylightSavingAdjust(new Date(et, Z + U, 1)), this._getFormatConfig(e)) : n, a = this._canAdjustMonth(e, 1, et, Z) ? "<a class='ui-datepicker-next ui-corner-all' data-handler='next' data-event='click' title='" + n + "'><span class='ui-icon ui-icon-circle-triangle-" + (Y ? "w" : "e") + "'>" + n + "</span></a>" : J ? "" : "<a class='ui-datepicker-next ui-corner-all ui-state-disabled' title='" + n + "'><span class='ui-icon ui-icon-circle-triangle-" + (Y ? "w" : "e") + "'>" + n + "</span></a>", o = this._get(e, "currentText"), r = this._get(e, "gotoCurrent") && e.currentDay ? G : R, o = Q ? this.formatDate(o, r, this._getFormatConfig(e)) : o, h = e.inline ? "" : "<button type='button' class='ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all' data-handler='hide' data-event='click'>" + this._get(e, "closeText") + "</button>", l = B ? "<div class='ui-datepicker-buttonpane ui-widget-content'>" + (Y ? h : "") + (this._isInRange(e, r) ? "<button type='button' class='ui-datepicker-current ui-state-default ui-priority-secondary ui-corner-all' data-handler='today' data-event='click'>" + o + "</button>" : "") + (Y ? "" : h) + "</div>" : "", u = parseInt(this._get(e, "firstDay"), 10), u = isNaN(u) ? 0 : u, c = this._get(e, "showWeek"), d = this._get(e, "dayNames"), p = this._get(e, "dayNamesMin"), f = this._get(e, "monthNames"), m = this._get(e, "monthNamesShort"), g = this._get(e, "beforeShowDay"), v = this._get(e, "showOtherMonths"), _ = this._get(e, "selectOtherMonths"), b = this._getDefaultDate(e), y = "", k = 0; K[0] > k; k++) {
                for (w = "", this.maxRows = 4, T = 0; K[1] > T; T++) {
                    if (D = this._daylightSavingAdjust(new Date(et, Z, e.selectedDay)), S = " ui-corner-all", M = "", q) {
                        if (M += "<div class='ui-datepicker-group", K[1] > 1)switch (T) {
                            case 0:
                                M += " ui-datepicker-group-first", S = " ui-corner-" + (Y ? "right" : "left");
                                break;
                            case K[1] - 1:
                                M += " ui-datepicker-group-last", S = " ui-corner-" + (Y ? "left" : "right");
                                break;
                            default:
                                M += " ui-datepicker-group-middle", S = ""
                        }
                        M += "'>"
                    }
                    for (M += "<div class='ui-datepicker-header ui-widget-header ui-helper-clearfix" + S + "'>" + (/all|left/.test(S) && 0 === k ? Y ? a : s : "") + (/all|right/.test(S) && 0 === k ? Y ? s : a : "") + this._generateMonthYearHeader(e, Z, et, X, $, k > 0 || T > 0, f, m) + "</div><table class='ui-datepicker-calendar'><thead>" + "<tr>", C = c ? "<th class='ui-datepicker-week-col'>" + this._get(e, "weekHeader") + "</th>" : "", x = 0; 7 > x; x++)N = (x + u) % 7, C += "<th scope='col'" + ((x + u + 6) % 7 >= 5 ? " class='ui-datepicker-week-end'" : "") + ">" + "<span title='" + d[N] + "'>" + p[N] + "</span></th>";
                    for (M += C + "</tr></thead><tbody>", P = this._getDaysInMonth(et, Z), et === e.selectedYear && Z === e.selectedMonth && (e.selectedDay = Math.min(e.selectedDay, P)), A = (this._getFirstDayOfMonth(et, Z) - u + 7) % 7, I = Math.ceil((A + P) / 7), H = q ? this.maxRows > I ? this.maxRows : I : I, this.maxRows = H, z = this._daylightSavingAdjust(new Date(et, Z, 1 - A)), F = 0; H > F; F++) {
                        for (M += "<tr>", j = c ? "<td class='ui-datepicker-week-col'>" + this._get(e, "calculateWeek")(z) + "</td>" : "", x = 0; 7 > x; x++)O = g ? g.apply(e.input ? e.input[0] : null, [z]) : [!0, ""], E = z.getMonth() !== Z, L = E && !_ || !O[0] || X && X > z || $ && z > $, j += "<td class='" + ((x + u + 6) % 7 >= 5 ? " ui-datepicker-week-end" : "") + (E ? " ui-datepicker-other-month" : "") + (z.getTime() === D.getTime() && Z === e.selectedMonth && e._keyEvent || b.getTime() === z.getTime() && b.getTime() === D.getTime() ? " " + this._dayOverClass : "") + (L ? " " + this._unselectableClass + " ui-state-disabled" : "") + (E && !v ? "" : " " + O[1] + (z.getTime() === G.getTime() ? " " + this._currentClass : "") + (z.getTime() === R.getTime() ? " ui-datepicker-today" : "")) + "'" + (E && !v || !O[2] ? "" : " title='" + O[2].replace(/'/g, "&#39;") + "'") + (L ? "" : " data-handler='selectDay' data-event='click' data-month='" + z.getMonth() + "' data-year='" + z.getFullYear() + "'") + ">" + (E && !v ? "&#xa0;" : L ? "<span class='ui-state-default'>" + z.getDate() + "</span>" : "<a class='ui-state-default" + (z.getTime() === R.getTime() ? " ui-state-highlight" : "") + (z.getTime() === G.getTime() ? " ui-state-active" : "") + (E ? " ui-priority-secondary" : "") + "' href='#'>" + z.getDate() + "</a>") + "</td>", z.setDate(z.getDate() + 1), z = this._daylightSavingAdjust(z);
                        M += j + "</tr>"
                    }
                    Z++, Z > 11 && (Z = 0, et++), M += "</tbody></table>" + (q ? "</div>" + (K[0] > 0 && T === K[1] - 1 ? "<div class='ui-datepicker-row-break'></div>" : "") : ""), w += M
                }
                y += w
            }
            return y += l, e._keyEvent = !1, y
        },
        _generateMonthYearHeader: function (e, t, i, s, n, a, o, r) {
            var h, l, u, c, d, p, f, m, g = this._get(e, "changeMonth"), v = this._get(e, "changeYear"), _ = this._get(e, "showMonthAfterYear"), b = "<div class='ui-datepicker-title'>", y = "";
            if (a || !g) y += "<span class='ui-datepicker-month'>" + o[t] + "</span>"; else {
                for (h = s && s.getFullYear() === i, l = n && n.getFullYear() === i, y += "<select class='ui-datepicker-month' data-handler='selectMonth' data-event='change'>", u = 0; 12 > u; u++)(!h || u >= s.getMonth()) && (!l || n.getMonth() >= u) && (y += "<option value='" + u + "'" + (u === t ? " selected='selected'" : "") + ">" + r[u] + "</option>");
                y += "</select>"
            }
            if (_ || (b += y + (!a && g && v ? "" : "&#xa0;")), !e.yearshtml)if (e.yearshtml = "", a || !v) b += "<span class='ui-datepicker-year'>" + i + "</span>"; else {
                for (c = this._get(e, "yearRange").split(":"), d = (new Date).getFullYear(), p = function (e) {
                    var t = e.match(/c[+\-].*/) ? i + parseInt(e.substring(1), 10) : e.match(/[+\-].*/) ? d + parseInt(e, 10) : parseInt(e, 10);
                    return isNaN(t) ? d : t
                }, f = p(c[0]), m = Math.max(f, p(c[1] || "")), f = s ? Math.max(f, s.getFullYear()) : f, m = n ? Math.min(m, n.getFullYear()) : m, e.yearshtml += "<select class='ui-datepicker-year' data-handler='selectYear' data-event='change'>"; m >= f; f++)e.yearshtml += "<option value='" + f + "'" + (f === i ? " selected='selected'" : "") + ">" + f + "</option>";
                e.yearshtml += "</select>", b += e.yearshtml, e.yearshtml = null
            }
            return b += this._get(e, "yearSuffix"), _ && (b += (!a && g && v ? "" : "&#xa0;") + y), b += "</div>"
        },
        _adjustInstDate: function (e, t, i) {
            var s = e.selectedYear + ("Y" === i ? t : 0), n = e.selectedMonth + ("M" === i ? t : 0), a = Math.min(e.selectedDay, this._getDaysInMonth(s, n)) + ("D" === i ? t : 0), o = this._restrictMinMax(e, this._daylightSavingAdjust(new Date(s, n, a)));
            e.selectedDay = o.getDate(), e.drawMonth = e.selectedMonth = o.getMonth(), e.drawYear = e.selectedYear = o.getFullYear(), ("M" === i || "Y" === i) && this._notifyChange(e)
        },
        _restrictMinMax: function (e, t) {
            var i = this._getMinMaxDate(e, "min"), s = this._getMinMaxDate(e, "max"), n = i && i > t ? i : t;
            return s && n > s ? s : n
        },
        _notifyChange: function (e) {
            var t = this._get(e, "onChangeMonthYear");
            t && t.apply(e.input ? e.input[0] : null, [e.selectedYear, e.selectedMonth + 1, e])
        },
        _getNumberOfMonths: function (e) {
            var t = this._get(e, "numberOfMonths");
            return null == t ? [1, 1] : "number" == typeof t ? [1, t] : t
        },
        _getMinMaxDate: function (e, t) {
            return this._determineDate(e, this._get(e, t + "Date"), null)
        },
        _getDaysInMonth: function (e, t) {
            return 32 - this._daylightSavingAdjust(new Date(e, t, 32)).getDate()
        },
        _getFirstDayOfMonth: function (e, t) {
            return new Date(e, t, 1).getDay()
        },
        _canAdjustMonth: function (e, t, i, s) {
            var n = this._getNumberOfMonths(e), a = this._daylightSavingAdjust(new Date(i, s + (0 > t ? t : n[0] * n[1]), 1));
            return 0 > t && a.setDate(this._getDaysInMonth(a.getFullYear(), a.getMonth())), this._isInRange(e, a)
        },
        _isInRange: function (e, t) {
            var i, s, n = this._getMinMaxDate(e, "min"), a = this._getMinMaxDate(e, "max"), o = null, r = null, h = this._get(e, "yearRange");
            return h && (i = h.split(":"), s = (new Date).getFullYear(), o = parseInt(i[0], 10), r = parseInt(i[1], 10), i[0].match(/[+\-].*/) && (o += s), i[1].match(/[+\-].*/) && (r += s)), (!n || t.getTime() >= n.getTime()) && (!a || t.getTime() <= a.getTime()) && (!o || t.getFullYear() >= o) && (!r || r >= t.getFullYear())
        },
        _getFormatConfig: function (e) {
            var t = this._get(e, "shortYearCutoff");
            return t = "string" != typeof t ? t : (new Date).getFullYear() % 100 + parseInt(t, 10), {
                shortYearCutoff: t,
                dayNamesShort: this._get(e, "dayNamesShort"),
                dayNames: this._get(e, "dayNames"),
                monthNamesShort: this._get(e, "monthNamesShort"),
                monthNames: this._get(e, "monthNames")
            }
        },
        _formatDate: function (e, t, i, s) {
            t || (e.currentDay = e.selectedDay, e.currentMonth = e.selectedMonth, e.currentYear = e.selectedYear);
            var n = t ? "object" == typeof t ? t : this._daylightSavingAdjust(new Date(s, i, t)) : this._daylightSavingAdjust(new Date(e.currentYear, e.currentMonth, e.currentDay));
            return this.formatDate(this._get(e, "dateFormat"), n, this._getFormatConfig(e))
        }
    }), e.fn.datepicker = function (t) {
        if (!this.length)return this;
        e.datepicker.initialized || (e(document).on("mousedown", e.datepicker._checkExternalClick), e.datepicker.initialized = !0), 0 === e("#" + e.datepicker._mainDivId).length && e("body").append(e.datepicker.dpDiv);
        var i = Array.prototype.slice.call(arguments, 1);
        return "string" != typeof t || "isDisabled" !== t && "getDate" !== t && "widget" !== t ? "option" === t && 2 === arguments.length && "string" == typeof arguments[1] ? e.datepicker["_" + t + "Datepicker"].apply(e.datepicker, [this[0]].concat(i)) : this.each(function () {
                    "string" == typeof t ? e.datepicker["_" + t + "Datepicker"].apply(e.datepicker, [this].concat(i)) : e.datepicker._attachDatepicker(this, t)
                }) : e.datepicker["_" + t + "Datepicker"].apply(e.datepicker, [this[0]].concat(i))
    }, e.datepicker = new s, e.datepicker.initialized = !1, e.datepicker.uuid = (new Date).getTime(), e.datepicker.version = "1.12.1", e.datepicker, e.widget("ui.dialog", {
        version: "1.12.1",
        options: {
            appendTo: "body",
            autoOpen: !0,
            buttons: [],
            classes: {"ui-dialog": "ui-corner-all", "ui-dialog-titlebar": "ui-corner-all"},
            closeOnEscape: !0,
            closeText: "Close",
            draggable: !0,
            hide: null,
            height: "auto",
            maxHeight: null,
            maxWidth: null,
            minHeight: 150,
            minWidth: 150,
            modal: !1,
            position: {
                my: "center", at: "center", of: window, collision: "fit", using: function (t) {
                    var i = e(this).css(t).offset().top;
                    0 > i && e(this).css("top", t.top - i)
                }
            },
            resizable: !0,
            show: null,
            title: null,
            width: 300,
            beforeClose: null,
            close: null,
            drag: null,
            dragStart: null,
            dragStop: null,
            focus: null,
            open: null,
            resize: null,
            resizeStart: null,
            resizeStop: null
        },
        sizeRelatedOptions: {
            buttons: !0,
            height: !0,
            maxHeight: !0,
            maxWidth: !0,
            minHeight: !0,
            minWidth: !0,
            width: !0
        },
        resizableRelatedOptions: {maxHeight: !0, maxWidth: !0, minHeight: !0, minWidth: !0},
        _create: function () {
            this.originalCss = {
                display: this.element[0].style.display,
                width: this.element[0].style.width,
                minHeight: this.element[0].style.minHeight,
                maxHeight: this.element[0].style.maxHeight,
                height: this.element[0].style.height
            }, this.originalPosition = {
                parent: this.element.parent(),
                index: this.element.parent().children().index(this.element)
            }, this.originalTitle = this.element.attr("title"), null == this.options.title && null != this.originalTitle && (this.options.title = this.originalTitle), this.options.disabled && (this.options.disabled = !1), this._createWrapper(), this.element.show().removeAttr("title").appendTo(this.uiDialog), this._addClass("ui-dialog-content", "ui-widget-content"), this._createTitlebar(), this._createButtonPane(), this.options.draggable && e.fn.draggable && this._makeDraggable(), this.options.resizable && e.fn.resizable && this._makeResizable(), this._isOpen = !1, this._trackFocus()
        },
        _init: function () {
            this.options.autoOpen && this.open()
        },
        _appendTo: function () {
            var t = this.options.appendTo;
            return t && (t.jquery || t.nodeType) ? e(t) : this.document.find(t || "body").eq(0)
        },
        _destroy: function () {
            var e, t = this.originalPosition;
            this._untrackInstance(), this._destroyOverlay(), this.element.removeUniqueId().css(this.originalCss).detach(), this.uiDialog.remove(), this.originalTitle && this.element.attr("title", this.originalTitle), e = t.parent.children().eq(t.index), e.length && e[0] !== this.element[0] ? e.before(this.element) : t.parent.append(this.element)
        },
        widget: function () {
            return this.uiDialog
        },
        disable: e.noop,
        enable: e.noop,
        close: function (t) {
            var i = this;
            this._isOpen && this._trigger("beforeClose", t) !== !1 && (this._isOpen = !1, this._focusedElement = null, this._destroyOverlay(), this._untrackInstance(), this.opener.filter(":focusable").trigger("focus").length || e.ui.safeBlur(e.ui.safeActiveElement(this.document[0])), this._hide(this.uiDialog, this.options.hide, function () {
                i._trigger("close", t)
            }))
        },
        isOpen: function () {
            return this._isOpen
        },
        moveToTop: function () {
            this._moveToTop()
        },
        _moveToTop: function (t, i) {
            var s = !1, n = this.uiDialog.siblings(".ui-front:visible").map(function () {
                return +e(this).css("z-index")
            }).get(), a = Math.max.apply(null, n);
            return a >= +this.uiDialog.css("z-index") && (this.uiDialog.css("z-index", a + 1), s = !0), s && !i && this._trigger("focus", t), s
        },
        open: function () {
            var t = this;
            return this._isOpen ? (this._moveToTop() && this._focusTabbable(), void 0) : (this._isOpen = !0, this.opener = e(e.ui.safeActiveElement(this.document[0])), this._size(), this._position(), this._createOverlay(), this._moveToTop(null, !0), this.overlay && this.overlay.css("z-index", this.uiDialog.css("z-index") - 1), this._show(this.uiDialog, this.options.show, function () {
                    t._focusTabbable(), t._trigger("focus")
                }), this._makeFocusTarget(), this._trigger("open"), void 0)
        },
        _focusTabbable: function () {
            var e = this._focusedElement;
            e || (e = this.element.find("[autofocus]")), e.length || (e = this.element.find(":tabbable")), e.length || (e = this.uiDialogButtonPane.find(":tabbable")), e.length || (e = this.uiDialogTitlebarClose.filter(":tabbable")), e.length || (e = this.uiDialog), e.eq(0).trigger("focus")
        },
        _keepFocus: function (t) {
            function i() {
                var t = e.ui.safeActiveElement(this.document[0]), i = this.uiDialog[0] === t || e.contains(this.uiDialog[0], t);
                i || this._focusTabbable()
            }

            t.preventDefault(), i.call(this), this._delay(i)
        },
        _createWrapper: function () {
            this.uiDialog = e("<div>").hide().attr({
                tabIndex: -1,
                role: "dialog"
            }).appendTo(this._appendTo()), this._addClass(this.uiDialog, "ui-dialog", "ui-widget ui-widget-content ui-front"), this._on(this.uiDialog, {
                keydown: function (t) {
                    if (this.options.closeOnEscape && !t.isDefaultPrevented() && t.keyCode && t.keyCode === e.ui.keyCode.ESCAPE)return t.preventDefault(), this.close(t), void 0;
                    if (t.keyCode === e.ui.keyCode.TAB && !t.isDefaultPrevented()) {
                        var i = this.uiDialog.find(":tabbable"), s = i.filter(":first"), n = i.filter(":last");
                        t.target !== n[0] && t.target !== this.uiDialog[0] || t.shiftKey ? t.target !== s[0] && t.target !== this.uiDialog[0] || !t.shiftKey || (this._delay(function () {
                                n.trigger("focus")
                            }), t.preventDefault()) : (this._delay(function () {
                                s.trigger("focus")
                            }), t.preventDefault())
                    }
                }, mousedown: function (e) {
                    this._moveToTop(e) && this._focusTabbable()
                }
            }), this.element.find("[aria-describedby]").length || this.uiDialog.attr({"aria-describedby": this.element.uniqueId().attr("id")})
        },
        _createTitlebar: function () {
            var t;
            this.uiDialogTitlebar = e("<div>"), this._addClass(this.uiDialogTitlebar, "ui-dialog-titlebar", "ui-widget-header ui-helper-clearfix"), this._on(this.uiDialogTitlebar, {
                mousedown: function (t) {
                    e(t.target).closest(".ui-dialog-titlebar-close") || this.uiDialog.trigger("focus")
                }
            }), this.uiDialogTitlebarClose = e("<button type='button'></button>").button({
                label: e("<a>").text(this.options.closeText).html(),
                icon: "ui-icon-closethick",
                showLabel: !1
            }).appendTo(this.uiDialogTitlebar), this._addClass(this.uiDialogTitlebarClose, "ui-dialog-titlebar-close"), this._on(this.uiDialogTitlebarClose, {
                click: function (e) {
                    e.preventDefault(), this.close(e)
                }
            }), t = e("<span>").uniqueId().prependTo(this.uiDialogTitlebar), this._addClass(t, "ui-dialog-title"), this._title(t), this.uiDialogTitlebar.prependTo(this.uiDialog), this.uiDialog.attr({"aria-labelledby": t.attr("id")})
        },
        _title: function (e) {
            this.options.title ? e.text(this.options.title) : e.html("&#160;")
        },
        _createButtonPane: function () {
            this.uiDialogButtonPane = e("<div>"), this._addClass(this.uiDialogButtonPane, "ui-dialog-buttonpane", "ui-widget-content ui-helper-clearfix"), this.uiButtonSet = e("<div>").appendTo(this.uiDialogButtonPane), this._addClass(this.uiButtonSet, "ui-dialog-buttonset"), this._createButtons()
        },
        _createButtons: function () {
            var t = this, i = this.options.buttons;
            return this.uiDialogButtonPane.remove(), this.uiButtonSet.empty(), e.isEmptyObject(i) || e.isArray(i) && !i.length ? (this._removeClass(this.uiDialog, "ui-dialog-buttons"), void 0) : (e.each(i, function (i, s) {
                    var n, a;
                    s = e.isFunction(s) ? {
                            click: s,
                            text: i
                        } : s, s = e.extend({type: "button"}, s), n = s.click, a = {
                        icon: s.icon,
                        iconPosition: s.iconPosition,
                        showLabel: s.showLabel,
                        icons: s.icons,
                        text: s.text
                    }, delete s.click, delete s.icon, delete s.iconPosition, delete s.showLabel, delete s.icons, "boolean" == typeof s.text && delete s.text, e("<button></button>", s).button(a).appendTo(t.uiButtonSet).on("click", function () {
                        n.apply(t.element[0], arguments)
                    })
                }), this._addClass(this.uiDialog, "ui-dialog-buttons"), this.uiDialogButtonPane.appendTo(this.uiDialog), void 0)
        },
        _makeDraggable: function () {
            function t(e) {
                return {position: e.position, offset: e.offset}
            }

            var i = this, s = this.options;
            this.uiDialog.draggable({
                cancel: ".ui-dialog-content, .ui-dialog-titlebar-close",
                handle: ".ui-dialog-titlebar",
                containment: "document",
                start: function (s, n) {
                    i._addClass(e(this), "ui-dialog-dragging"), i._blockFrames(), i._trigger("dragStart", s, t(n))
                },
                drag: function (e, s) {
                    i._trigger("drag", e, t(s))
                },
                stop: function (n, a) {
                    var o = a.offset.left - i.document.scrollLeft(), r = a.offset.top - i.document.scrollTop();
                    s.position = {
                        my: "left top",
                        at: "left" + (o >= 0 ? "+" : "") + o + " " + "top" + (r >= 0 ? "+" : "") + r,
                        of: i.window
                    }, i._removeClass(e(this), "ui-dialog-dragging"), i._unblockFrames(), i._trigger("dragStop", n, t(a))
                }
            })
        },
        _makeResizable: function () {
            function t(e) {
                return {
                    originalPosition: e.originalPosition,
                    originalSize: e.originalSize,
                    position: e.position,
                    size: e.size
                }
            }

            var i = this, s = this.options, n = s.resizable, a = this.uiDialog.css("position"), o = "string" == typeof n ? n : "n,e,s,w,se,sw,ne,nw";
            this.uiDialog.resizable({
                cancel: ".ui-dialog-content",
                containment: "document",
                alsoResize: this.element,
                maxWidth: s.maxWidth,
                maxHeight: s.maxHeight,
                minWidth: s.minWidth,
                minHeight: this._minHeight(),
                handles: o,
                start: function (s, n) {
                    i._addClass(e(this), "ui-dialog-resizing"), i._blockFrames(), i._trigger("resizeStart", s, t(n))
                },
                resize: function (e, s) {
                    i._trigger("resize", e, t(s))
                },
                stop: function (n, a) {
                    var o = i.uiDialog.offset(), r = o.left - i.document.scrollLeft(), h = o.top - i.document.scrollTop();
                    s.height = i.uiDialog.height(), s.width = i.uiDialog.width(), s.position = {
                        my: "left top",
                        at: "left" + (r >= 0 ? "+" : "") + r + " " + "top" + (h >= 0 ? "+" : "") + h,
                        of: i.window
                    }, i._removeClass(e(this), "ui-dialog-resizing"), i._unblockFrames(), i._trigger("resizeStop", n, t(a))
                }
            }).css("position", a)
        },
        _trackFocus: function () {
            this._on(this.widget(), {
                focusin: function (t) {
                    this._makeFocusTarget(), this._focusedElement = e(t.target)
                }
            })
        },
        _makeFocusTarget: function () {
            this._untrackInstance(), this._trackingInstances().unshift(this)
        },
        _untrackInstance: function () {
            var t = this._trackingInstances(), i = e.inArray(this, t);
            -1 !== i && t.splice(i, 1)
        },
        _trackingInstances: function () {
            var e = this.document.data("ui-dialog-instances");
            return e || (e = [], this.document.data("ui-dialog-instances", e)), e
        },
        _minHeight: function () {
            var e = this.options;
            return "auto" === e.height ? e.minHeight : Math.min(e.minHeight, e.height)
        },
        _position: function () {
            var e = this.uiDialog.is(":visible");
            e || this.uiDialog.show(), this.uiDialog.position(this.options.position), e || this.uiDialog.hide()
        },
        _setOptions: function (t) {
            var i = this, s = !1, n = {};
            e.each(t, function (e, t) {
                i._setOption(e, t), e in i.sizeRelatedOptions && (s = !0), e in i.resizableRelatedOptions && (n[e] = t)
            }), s && (this._size(), this._position()), this.uiDialog.is(":data(ui-resizable)") && this.uiDialog.resizable("option", n)
        },
        _setOption: function (t, i) {
            var s, n, a = this.uiDialog;
            "disabled" !== t && (this._super(t, i), "appendTo" === t && this.uiDialog.appendTo(this._appendTo()), "buttons" === t && this._createButtons(), "closeText" === t && this.uiDialogTitlebarClose.button({label: e("<a>").text("" + this.options.closeText).html()}), "draggable" === t && (s = a.is(":data(ui-draggable)"), s && !i && a.draggable("destroy"), !s && i && this._makeDraggable()), "position" === t && this._position(), "resizable" === t && (n = a.is(":data(ui-resizable)"), n && !i && a.resizable("destroy"), n && "string" == typeof i && a.resizable("option", "handles", i), n || i === !1 || this._makeResizable()), "title" === t && this._title(this.uiDialogTitlebar.find(".ui-dialog-title")))
        },
        _size: function () {
            var e, t, i, s = this.options;
            this.element.show().css({
                width: "auto",
                minHeight: 0,
                maxHeight: "none",
                height: 0
            }), s.minWidth > s.width && (s.width = s.minWidth), e = this.uiDialog.css({
                height: "auto",
                width: s.width
            }).outerHeight(), t = Math.max(0, s.minHeight - e), i = "number" == typeof s.maxHeight ? Math.max(0, s.maxHeight - e) : "none", "auto" === s.height ? this.element.css({
                    minHeight: t,
                    maxHeight: i,
                    height: "auto"
                }) : this.element.height(Math.max(0, s.height - e)), this.uiDialog.is(":data(ui-resizable)") && this.uiDialog.resizable("option", "minHeight", this._minHeight())
        },
        _blockFrames: function () {
            this.iframeBlocks = this.document.find("iframe").map(function () {
                var t = e(this);
                return e("<div>").css({
                    position: "absolute",
                    width: t.outerWidth(),
                    height: t.outerHeight()
                }).appendTo(t.parent()).offset(t.offset())[0]
            })
        },
        _unblockFrames: function () {
            this.iframeBlocks && (this.iframeBlocks.remove(), delete this.iframeBlocks)
        },
        _allowInteraction: function (t) {
            return e(t.target).closest(".ui-dialog").length ? !0 : !!e(t.target).closest(".ui-datepicker").length
        },
        _createOverlay: function () {
            if (this.options.modal) {
                var t = !0;
                this._delay(function () {
                    t = !1
                }), this.document.data("ui-dialog-overlays") || this._on(this.document, {
                    focusin: function (e) {
                        t || this._allowInteraction(e) || (e.preventDefault(), this._trackingInstances()[0]._focusTabbable())
                    }
                }), this.overlay = e("<div>").appendTo(this._appendTo()), this._addClass(this.overlay, null, "ui-widget-overlay ui-front"), this._on(this.overlay, {mousedown: "_keepFocus"}), this.document.data("ui-dialog-overlays", (this.document.data("ui-dialog-overlays") || 0) + 1)
            }
        },
        _destroyOverlay: function () {
            if (this.options.modal && this.overlay) {
                var e = this.document.data("ui-dialog-overlays") - 1;
                e ? this.document.data("ui-dialog-overlays", e) : (this._off(this.document, "focusin"), this.document.removeData("ui-dialog-overlays")), this.overlay.remove(), this.overlay = null
            }
        }
    }), e.uiBackCompat !== !1 && e.widget("ui.dialog", e.ui.dialog, {
        options: {dialogClass: ""},
        _createWrapper: function () {
            this._super(), this.uiDialog.addClass(this.options.dialogClass)
        },
        _setOption: function (e, t) {
            "dialogClass" === e && this.uiDialog.removeClass(this.options.dialogClass).addClass(t), this._superApply(arguments)
        }
    }), e.ui.dialog, e.widget("ui.progressbar", {
        version: "1.12.1",
        options: {
            classes: {
                "ui-progressbar": "ui-corner-all",
                "ui-progressbar-value": "ui-corner-left",
                "ui-progressbar-complete": "ui-corner-right"
            }, max: 100, value: 0, change: null, complete: null
        },
        min: 0,
        _create: function () {
            this.oldValue = this.options.value = this._constrainedValue(), this.element.attr({
                role: "progressbar",
                "aria-valuemin": this.min
            }), this._addClass("ui-progressbar", "ui-widget ui-widget-content"), this.valueDiv = e("<div>").appendTo(this.element), this._addClass(this.valueDiv, "ui-progressbar-value", "ui-widget-header"), this._refreshValue()
        },
        _destroy: function () {
            this.element.removeAttr("role aria-valuemin aria-valuemax aria-valuenow"), this.valueDiv.remove()
        },
        value: function (e) {
            return void 0 === e ? this.options.value : (this.options.value = this._constrainedValue(e), this._refreshValue(), void 0)
        },
        _constrainedValue: function (e) {
            return void 0 === e && (e = this.options.value), this.indeterminate = e === !1, "number" != typeof e && (e = 0), this.indeterminate ? !1 : Math.min(this.options.max, Math.max(this.min, e))
        },
        _setOptions: function (e) {
            var t = e.value;
            delete e.value, this._super(e), this.options.value = this._constrainedValue(t), this._refreshValue()
        },
        _setOption: function (e, t) {
            "max" === e && (t = Math.max(this.min, t)), this._super(e, t)
        },
        _setOptionDisabled: function (e) {
            this._super(e), this.element.attr("aria-disabled", e), this._toggleClass(null, "ui-state-disabled", !!e)
        },
        _percentage: function () {
            return this.indeterminate ? 100 : 100 * (this.options.value - this.min) / (this.options.max - this.min)
        },
        _refreshValue: function () {
            var t = this.options.value, i = this._percentage();
            this.valueDiv.toggle(this.indeterminate || t > this.min).width(i.toFixed(0) + "%"), this._toggleClass(this.valueDiv, "ui-progressbar-complete", null, t === this.options.max)._toggleClass("ui-progressbar-indeterminate", null, this.indeterminate), this.indeterminate ? (this.element.removeAttr("aria-valuenow"), this.overlayDiv || (this.overlayDiv = e("<div>").appendTo(this.valueDiv), this._addClass(this.overlayDiv, "ui-progressbar-overlay"))) : (this.element.attr({
                    "aria-valuemax": this.options.max,
                    "aria-valuenow": t
                }), this.overlayDiv && (this.overlayDiv.remove(), this.overlayDiv = null)), this.oldValue !== t && (this.oldValue = t, this._trigger("change")), t === this.options.max && this._trigger("complete")
        }
    }), e.widget("ui.selectmenu", [e.ui.formResetMixin, {
        version: "1.12.1",
        defaultElement: "<select>",
        options: {
            appendTo: null,
            classes: {"ui-selectmenu-button-open": "ui-corner-top", "ui-selectmenu-button-closed": "ui-corner-all"},
            disabled: null,
            icons: {button: "ui-icon-triangle-1-s"},
            position: {my: "left top", at: "left bottom", collision: "none"},
            width: !1,
            change: null,
            close: null,
            focus: null,
            open: null,
            select: null
        },
        _create: function () {
            var t = this.element.uniqueId().attr("id");
            this.ids = {
                element: t,
                button: t + "-button",
                menu: t + "-menu"
            }, this._drawButton(), this._drawMenu(), this._bindFormResetHandler(), this._rendered = !1, this.menuItems = e()
        },
        _drawButton: function () {
            var t, i = this, s = this._parseOption(this.element.find("option:selected"), this.element[0].selectedIndex);
            this.labels = this.element.labels().attr("for", this.ids.button), this._on(this.labels, {
                click: function (e) {
                    this.button.focus(), e.preventDefault()
                }
            }), this.element.hide(), this.button = e("<span>", {
                tabindex: this.options.disabled ? -1 : 0,
                id: this.ids.button,
                role: "combobox",
                "aria-expanded": "false",
                "aria-autocomplete": "list",
                "aria-owns": this.ids.menu,
                "aria-haspopup": "true",
                title: this.element.attr("title")
            }).insertAfter(this.element), this._addClass(this.button, "ui-selectmenu-button ui-selectmenu-button-closed", "ui-button ui-widget"), t = e("<span>").appendTo(this.button), this._addClass(t, "ui-selectmenu-icon", "ui-icon " + this.options.icons.button), this.buttonItem = this._renderButtonItem(s).appendTo(this.button), this.options.width !== !1 && this._resizeButton(), this._on(this.button, this._buttonEvents), this.button.one("focusin", function () {
                i._rendered || i._refreshMenu()
            })
        },
        _drawMenu: function () {
            var t = this;
            this.menu = e("<ul>", {
                "aria-hidden": "true",
                "aria-labelledby": this.ids.button,
                id: this.ids.menu
            }), this.menuWrap = e("<div>").append(this.menu), this._addClass(this.menuWrap, "ui-selectmenu-menu", "ui-front"), this.menuWrap.appendTo(this._appendTo()), this.menuInstance = this.menu.menu({
                classes: {"ui-menu": "ui-corner-bottom"},
                role: "listbox",
                select: function (e, i) {
                    e.preventDefault(), t._setSelection(), t._select(i.item.data("ui-selectmenu-item"), e)
                },
                focus: function (e, i) {
                    var s = i.item.data("ui-selectmenu-item");
                    null != t.focusIndex && s.index !== t.focusIndex && (t._trigger("focus", e, {item: s}), t.isOpen || t._select(s, e)), t.focusIndex = s.index, t.button.attr("aria-activedescendant", t.menuItems.eq(s.index).attr("id"))
                }
            }).menu("instance"), this.menuInstance._off(this.menu, "mouseleave"), this.menuInstance._closeOnDocumentClick = function () {
                return !1
            }, this.menuInstance._isDivider = function () {
                return !1
            }
        },
        refresh: function () {
            this._refreshMenu(), this.buttonItem.replaceWith(this.buttonItem = this._renderButtonItem(this._getSelectedItem().data("ui-selectmenu-item") || {})), null === this.options.width && this._resizeButton()
        },
        _refreshMenu: function () {
            var e, t = this.element.find("option");
            this.menu.empty(), this._parseOptions(t), this._renderMenu(this.menu, this.items), this.menuInstance.refresh(), this.menuItems = this.menu.find("li").not(".ui-selectmenu-optgroup").find(".ui-menu-item-wrapper"), this._rendered = !0, t.length && (e = this._getSelectedItem(), this.menuInstance.focus(null, e), this._setAria(e.data("ui-selectmenu-item")), this._setOption("disabled", this.element.prop("disabled")))
        },
        open: function (e) {
            this.options.disabled || (this._rendered ? (this._removeClass(this.menu.find(".ui-state-active"), null, "ui-state-active"), this.menuInstance.focus(null, this._getSelectedItem())) : this._refreshMenu(), this.menuItems.length && (this.isOpen = !0, this._toggleAttr(), this._resizeMenu(), this._position(), this._on(this.document, this._documentClick), this._trigger("open", e)))
        },
        _position: function () {
            this.menuWrap.position(e.extend({of: this.button}, this.options.position))
        },
        close: function (e) {
            this.isOpen && (this.isOpen = !1, this._toggleAttr(), this.range = null, this._off(this.document), this._trigger("close", e))
        },
        widget: function () {
            return this.button
        },
        menuWidget: function () {
            return this.menu
        },
        _renderButtonItem: function (t) {
            var i = e("<span>");
            return this._setText(i, t.label), this._addClass(i, "ui-selectmenu-text"), i
        },
        _renderMenu: function (t, i) {
            var s = this, n = "";
            e.each(i, function (i, a) {
                var o;
                a.optgroup !== n && (o = e("<li>", {text: a.optgroup}), s._addClass(o, "ui-selectmenu-optgroup", "ui-menu-divider" + (a.element.parent("optgroup").prop("disabled") ? " ui-state-disabled" : "")), o.appendTo(t), n = a.optgroup), s._renderItemData(t, a)
            })
        },
        _renderItemData: function (e, t) {
            return this._renderItem(e, t).data("ui-selectmenu-item", t)
        },
        _renderItem: function (t, i) {
            var s = e("<li>"), n = e("<div>", {title: i.element.attr("title")});
            return i.disabled && this._addClass(s, null, "ui-state-disabled"), this._setText(n, i.label), s.append(n).appendTo(t)
        },
        _setText: function (e, t) {
            t ? e.text(t) : e.html("&#160;")
        },
        _move: function (e, t) {
            var i, s, n = ".ui-menu-item";
            this.isOpen ? i = this.menuItems.eq(this.focusIndex).parent("li") : (i = this.menuItems.eq(this.element[0].selectedIndex).parent("li"), n += ":not(.ui-state-disabled)"), s = "first" === e || "last" === e ? i["first" === e ? "prevAll" : "nextAll"](n).eq(-1) : i[e + "All"](n).eq(0), s.length && this.menuInstance.focus(t, s)
        },
        _getSelectedItem: function () {
            return this.menuItems.eq(this.element[0].selectedIndex).parent("li")
        },
        _toggle: function (e) {
            this[this.isOpen ? "close" : "open"](e)
        },
        _setSelection: function () {
            var e;
            this.range && (window.getSelection ? (e = window.getSelection(), e.removeAllRanges(), e.addRange(this.range)) : this.range.select(), this.button.focus())
        },
        _documentClick: {
            mousedown: function (t) {
                this.isOpen && (e(t.target).closest(".ui-selectmenu-menu, #" + e.ui.escapeSelector(this.ids.button)).length || this.close(t))
            }
        },
        _buttonEvents: {
            mousedown: function () {
                var e;
                window.getSelection ? (e = window.getSelection(), e.rangeCount && (this.range = e.getRangeAt(0))) : this.range = document.selection.createRange()
            }, click: function (e) {
                this._setSelection(), this._toggle(e)
            }, keydown: function (t) {
                var i = !0;
                switch (t.keyCode) {
                    case e.ui.keyCode.TAB:
                    case e.ui.keyCode.ESCAPE:
                        this.close(t), i = !1;
                        break;
                    case e.ui.keyCode.ENTER:
                        this.isOpen && this._selectFocusedItem(t);
                        break;
                    case e.ui.keyCode.UP:
                        t.altKey ? this._toggle(t) : this._move("prev", t);
                        break;
                    case e.ui.keyCode.DOWN:
                        t.altKey ? this._toggle(t) : this._move("next", t);
                        break;
                    case e.ui.keyCode.SPACE:
                        this.isOpen ? this._selectFocusedItem(t) : this._toggle(t);
                        break;
                    case e.ui.keyCode.LEFT:
                        this._move("prev", t);
                        break;
                    case e.ui.keyCode.RIGHT:
                        this._move("next", t);
                        break;
                    case e.ui.keyCode.HOME:
                    case e.ui.keyCode.PAGE_UP:
                        this._move("first", t);
                        break;
                    case e.ui.keyCode.END:
                    case e.ui.keyCode.PAGE_DOWN:
                        this._move("last", t);
                        break;
                    default:
                        this.menu.trigger(t), i = !1
                }
                i && t.preventDefault()
            }
        },
        _selectFocusedItem: function (e) {
            var t = this.menuItems.eq(this.focusIndex).parent("li");
            t.hasClass("ui-state-disabled") || this._select(t.data("ui-selectmenu-item"), e)
        },
        _select: function (e, t) {
            var i = this.element[0].selectedIndex;
            this.element[0].selectedIndex = e.index, this.buttonItem.replaceWith(this.buttonItem = this._renderButtonItem(e)), this._setAria(e), this._trigger("select", t, {item: e}), e.index !== i && this._trigger("change", t, {item: e}), this.close(t)
        },
        _setAria: function (e) {
            var t = this.menuItems.eq(e.index).attr("id");
            this.button.attr({
                "aria-labelledby": t,
                "aria-activedescendant": t
            }), this.menu.attr("aria-activedescendant", t)
        },
        _setOption: function (e, t) {
            if ("icons" === e) {
                var i = this.button.find("span.ui-icon");
                this._removeClass(i, null, this.options.icons.button)._addClass(i, null, t.button)
            }
            this._super(e, t), "appendTo" === e && this.menuWrap.appendTo(this._appendTo()), "width" === e && this._resizeButton()
        },
        _setOptionDisabled: function (e) {
            this._super(e), this.menuInstance.option("disabled", e), this.button.attr("aria-disabled", e), this._toggleClass(this.button, null, "ui-state-disabled", e), this.element.prop("disabled", e), e ? (this.button.attr("tabindex", -1), this.close()) : this.button.attr("tabindex", 0)
        },
        _appendTo: function () {
            var t = this.options.appendTo;
            return t && (t = t.jquery || t.nodeType ? e(t) : this.document.find(t).eq(0)), t && t[0] || (t = this.element.closest(".ui-front, dialog")), t.length || (t = this.document[0].body), t
        },
        _toggleAttr: function () {
            this.button.attr("aria-expanded", this.isOpen), this._removeClass(this.button, "ui-selectmenu-button-" + (this.isOpen ? "closed" : "open"))._addClass(this.button, "ui-selectmenu-button-" + (this.isOpen ? "open" : "closed"))._toggleClass(this.menuWrap, "ui-selectmenu-open", null, this.isOpen), this.menu.attr("aria-hidden", !this.isOpen)
        },
        _resizeButton: function () {
            var e = this.options.width;
            return e === !1 ? (this.button.css("width", ""), void 0) : (null === e && (e = this.element.show().outerWidth(), this.element.hide()), this.button.outerWidth(e), void 0)
        },
        _resizeMenu: function () {
            this.menu.outerWidth(Math.max(this.button.outerWidth(), this.menu.width("").outerWidth() + 1))
        },
        _getCreateOptions: function () {
            var e = this._super();
            return e.disabled = this.element.prop("disabled"), e
        },
        _parseOptions: function (t) {
            var i = this, s = [];
            t.each(function (t, n) {
                s.push(i._parseOption(e(n), t))
            }), this.items = s
        },
        _parseOption: function (e, t) {
            var i = e.parent("optgroup");
            return {
                element: e,
                index: t,
                value: e.val(),
                label: e.text(),
                optgroup: i.attr("label") || "",
                disabled: i.prop("disabled") || e.prop("disabled")
            }
        },
        _destroy: function () {
            this._unbindFormResetHandler(), this.menuWrap.remove(), this.button.remove(), this.element.show(), this.element.removeUniqueId(), this.labels.attr("for", this.ids.element)
        }
    }]), e.widget("ui.slider", e.ui.mouse, {
        version: "1.12.1",
        widgetEventPrefix: "slide",
        options: {
            animate: !1,
            classes: {
                "ui-slider": "ui-corner-all",
                "ui-slider-handle": "ui-corner-all",
                "ui-slider-range": "ui-corner-all ui-widget-header"
            },
            distance: 0,
            max: 100,
            min: 0,
            orientation: "horizontal",
            range: !1,
            step: 1,
            value: 0,
            values: null,
            change: null,
            slide: null,
            start: null,
            stop: null
        },
        numPages: 5,
        _create: function () {
            this._keySliding = !1, this._mouseSliding = !1, this._animateOff = !0, this._handleIndex = null, this._detectOrientation(), this._mouseInit(), this._calculateNewMax(), this._addClass("ui-slider ui-slider-" + this.orientation, "ui-widget ui-widget-content"), this._refresh(), this._animateOff = !1
        },
        _refresh: function () {
            this._createRange(), this._createHandles(), this._setupEvents(), this._refreshValue()
        },
        _createHandles: function () {
            var t, i, s = this.options, n = this.element.find(".ui-slider-handle"), a = "<span tabindex='0'></span>", o = [];
            for (i = s.values && s.values.length || 1, n.length > i && (n.slice(i).remove(), n = n.slice(0, i)), t = n.length; i > t; t++)o.push(a);
            this.handles = n.add(e(o.join("")).appendTo(this.element)), this._addClass(this.handles, "ui-slider-handle", "ui-state-default"), this.handle = this.handles.eq(0), this.handles.each(function (t) {
                e(this).data("ui-slider-handle-index", t).attr("tabIndex", 0)
            })
        },
        _createRange: function () {
            var t = this.options;
            t.range ? (t.range === !0 && (t.values ? t.values.length && 2 !== t.values.length ? t.values = [t.values[0], t.values[0]] : e.isArray(t.values) && (t.values = t.values.slice(0)) : t.values = [this._valueMin(), this._valueMin()]), this.range && this.range.length ? (this._removeClass(this.range, "ui-slider-range-min ui-slider-range-max"), this.range.css({
                        left: "",
                        bottom: ""
                    })) : (this.range = e("<div>").appendTo(this.element), this._addClass(this.range, "ui-slider-range")), ("min" === t.range || "max" === t.range) && this._addClass(this.range, "ui-slider-range-" + t.range)) : (this.range && this.range.remove(), this.range = null)
        },
        _setupEvents: function () {
            this._off(this.handles), this._on(this.handles, this._handleEvents), this._hoverable(this.handles), this._focusable(this.handles)
        },
        _destroy: function () {
            this.handles.remove(), this.range && this.range.remove(), this._mouseDestroy()
        },
        _mouseCapture: function (t) {
            var i, s, n, a, o, r, h, l, u = this, c = this.options;
            return c.disabled ? !1 : (this.elementSize = {
                    width: this.element.outerWidth(),
                    height: this.element.outerHeight()
                }, this.elementOffset = this.element.offset(), i = {
                    x: t.pageX,
                    y: t.pageY
                }, s = this._normValueFromMouse(i), n = this._valueMax() - this._valueMin() + 1, this.handles.each(function (t) {
                    var i = Math.abs(s - u.values(t));
                    (n > i || n === i && (t === u._lastChangedValue || u.values(t) === c.min)) && (n = i, a = e(this), o = t)
                }), r = this._start(t, o), r === !1 ? !1 : (this._mouseSliding = !0, this._handleIndex = o, this._addClass(a, null, "ui-state-active"), a.trigger("focus"), h = a.offset(), l = !e(t.target).parents().addBack().is(".ui-slider-handle"), this._clickOffset = l ? {
                            left: 0,
                            top: 0
                        } : {
                            left: t.pageX - h.left - a.width() / 2,
                            top: t.pageY - h.top - a.height() / 2 - (parseInt(a.css("borderTopWidth"), 10) || 0) - (parseInt(a.css("borderBottomWidth"), 10) || 0) + (parseInt(a.css("marginTop"), 10) || 0)
                        }, this.handles.hasClass("ui-state-hover") || this._slide(t, o, s), this._animateOff = !0, !0))
        },
        _mouseStart: function () {
            return !0
        },
        _mouseDrag: function (e) {
            var t = {x: e.pageX, y: e.pageY}, i = this._normValueFromMouse(t);
            return this._slide(e, this._handleIndex, i), !1
        },
        _mouseStop: function (e) {
            return this._removeClass(this.handles, null, "ui-state-active"), this._mouseSliding = !1, this._stop(e, this._handleIndex), this._change(e, this._handleIndex), this._handleIndex = null, this._clickOffset = null, this._animateOff = !1, !1
        },
        _detectOrientation: function () {
            this.orientation = "vertical" === this.options.orientation ? "vertical" : "horizontal"
        },
        _normValueFromMouse: function (e) {
            var t, i, s, n, a;
            return "horizontal" === this.orientation ? (t = this.elementSize.width, i = e.x - this.elementOffset.left - (this._clickOffset ? this._clickOffset.left : 0)) : (t = this.elementSize.height, i = e.y - this.elementOffset.top - (this._clickOffset ? this._clickOffset.top : 0)), s = i / t, s > 1 && (s = 1), 0 > s && (s = 0), "vertical" === this.orientation && (s = 1 - s), n = this._valueMax() - this._valueMin(), a = this._valueMin() + s * n, this._trimAlignValue(a)
        },
        _uiHash: function (e, t, i) {
            var s = {handle: this.handles[e], handleIndex: e, value: void 0 !== t ? t : this.value()};
            return this._hasMultipleValues() && (s.value = void 0 !== t ? t : this.values(e), s.values = i || this.values()), s
        },
        _hasMultipleValues: function () {
            return this.options.values && this.options.values.length
        },
        _start: function (e, t) {
            return this._trigger("start", e, this._uiHash(t))
        },
        _slide: function (e, t, i) {
            var s, n, a = this.value(), o = this.values();
            this._hasMultipleValues() && (n = this.values(t ? 0 : 1), a = this.values(t), 2 === this.options.values.length && this.options.range === !0 && (i = 0 === t ? Math.min(n, i) : Math.max(n, i)), o[t] = i), i !== a && (s = this._trigger("slide", e, this._uiHash(t, i, o)), s !== !1 && (this._hasMultipleValues() ? this.values(t, i) : this.value(i)))
        },
        _stop: function (e, t) {
            this._trigger("stop", e, this._uiHash(t))
        },
        _change: function (e, t) {
            this._keySliding || this._mouseSliding || (this._lastChangedValue = t, this._trigger("change", e, this._uiHash(t)))
        },
        value: function (e) {
            return arguments.length ? (this.options.value = this._trimAlignValue(e), this._refreshValue(), this._change(null, 0), void 0) : this._value()
        },
        values: function (t, i) {
            var s, n, a;
            if (arguments.length > 1)return this.options.values[t] = this._trimAlignValue(i), this._refreshValue(), this._change(null, t), void 0;
            if (!arguments.length)return this._values();
            if (!e.isArray(arguments[0]))return this._hasMultipleValues() ? this._values(t) : this.value();
            for (s = this.options.values, n = arguments[0], a = 0; s.length > a; a += 1)s[a] = this._trimAlignValue(n[a]), this._change(null, a);
            this._refreshValue()
        },
        _setOption: function (t, i) {
            var s, n = 0;
            switch ("range" === t && this.options.range === !0 && ("min" === i ? (this.options.value = this._values(0), this.options.values = null) : "max" === i && (this.options.value = this._values(this.options.values.length - 1), this.options.values = null)), e.isArray(this.options.values) && (n = this.options.values.length), this._super(t, i), t) {
                case"orientation":
                    this._detectOrientation(), this._removeClass("ui-slider-horizontal ui-slider-vertical")._addClass("ui-slider-" + this.orientation), this._refreshValue(), this.options.range && this._refreshRange(i), this.handles.css("horizontal" === i ? "bottom" : "left", "");
                    break;
                case"value":
                    this._animateOff = !0, this._refreshValue(), this._change(null, 0), this._animateOff = !1;
                    break;
                case"values":
                    for (this._animateOff = !0, this._refreshValue(), s = n - 1; s >= 0; s--)this._change(null, s);
                    this._animateOff = !1;
                    break;
                case"step":
                case"min":
                case"max":
                    this._animateOff = !0, this._calculateNewMax(), this._refreshValue(), this._animateOff = !1;
                    break;
                case"range":
                    this._animateOff = !0, this._refresh(), this._animateOff = !1
            }
        },
        _setOptionDisabled: function (e) {
            this._super(e), this._toggleClass(null, "ui-state-disabled", !!e)
        },
        _value: function () {
            var e = this.options.value;
            return e = this._trimAlignValue(e)
        },
        _values: function (e) {
            var t, i, s;
            if (arguments.length)return t = this.options.values[e], t = this._trimAlignValue(t);
            if (this._hasMultipleValues()) {
                for (i = this.options.values.slice(), s = 0; i.length > s; s += 1)i[s] = this._trimAlignValue(i[s]);
                return i
            }
            return []
        },
        _trimAlignValue: function (e) {
            if (this._valueMin() >= e)return this._valueMin();
            if (e >= this._valueMax())return this._valueMax();
            var t = this.options.step > 0 ? this.options.step : 1, i = (e - this._valueMin()) % t, s = e - i;
            return 2 * Math.abs(i) >= t && (s += i > 0 ? t : -t), parseFloat(s.toFixed(5))
        },
        _calculateNewMax: function () {
            var e = this.options.max, t = this._valueMin(), i = this.options.step, s = Math.round((e - t) / i) * i;
            e = s + t, e > this.options.max && (e -= i), this.max = parseFloat(e.toFixed(this._precision()))
        },
        _precision: function () {
            var e = this._precisionOf(this.options.step);
            return null !== this.options.min && (e = Math.max(e, this._precisionOf(this.options.min))), e
        },
        _precisionOf: function (e) {
            var t = "" + e, i = t.indexOf(".");
            return -1 === i ? 0 : t.length - i - 1
        },
        _valueMin: function () {
            return this.options.min
        },
        _valueMax: function () {
            return this.max
        },
        _refreshRange: function (e) {
            "vertical" === e && this.range.css({width: "", left: ""}), "horizontal" === e && this.range.css({
                height: "",
                bottom: ""
            })
        },
        _refreshValue: function () {
            var t, i, s, n, a, o = this.options.range, r = this.options, h = this, l = this._animateOff ? !1 : r.animate, u = {};
            this._hasMultipleValues() ? this.handles.each(function (s) {
                    i = 100 * ((h.values(s) - h._valueMin()) / (h._valueMax() - h._valueMin())), u["horizontal" === h.orientation ? "left" : "bottom"] = i + "%", e(this).stop(1, 1)[l ? "animate" : "css"](u, r.animate), h.options.range === !0 && ("horizontal" === h.orientation ? (0 === s && h.range.stop(1, 1)[l ? "animate" : "css"]({left: i + "%"}, r.animate), 1 === s && h.range[l ? "animate" : "css"]({width: i - t + "%"}, {
                            queue: !1,
                            duration: r.animate
                        })) : (0 === s && h.range.stop(1, 1)[l ? "animate" : "css"]({bottom: i + "%"}, r.animate), 1 === s && h.range[l ? "animate" : "css"]({height: i - t + "%"}, {
                            queue: !1,
                            duration: r.animate
                        }))), t = i
                }) : (s = this.value(), n = this._valueMin(), a = this._valueMax(), i = a !== n ? 100 * ((s - n) / (a - n)) : 0, u["horizontal" === this.orientation ? "left" : "bottom"] = i + "%", this.handle.stop(1, 1)[l ? "animate" : "css"](u, r.animate), "min" === o && "horizontal" === this.orientation && this.range.stop(1, 1)[l ? "animate" : "css"]({width: i + "%"}, r.animate), "max" === o && "horizontal" === this.orientation && this.range.stop(1, 1)[l ? "animate" : "css"]({width: 100 - i + "%"}, r.animate), "min" === o && "vertical" === this.orientation && this.range.stop(1, 1)[l ? "animate" : "css"]({height: i + "%"}, r.animate), "max" === o && "vertical" === this.orientation && this.range.stop(1, 1)[l ? "animate" : "css"]({height: 100 - i + "%"}, r.animate))
        },
        _handleEvents: {
            keydown: function (t) {
                var i, s, n, a, o = e(t.target).data("ui-slider-handle-index");
                switch (t.keyCode) {
                    case e.ui.keyCode.HOME:
                    case e.ui.keyCode.END:
                    case e.ui.keyCode.PAGE_UP:
                    case e.ui.keyCode.PAGE_DOWN:
                    case e.ui.keyCode.UP:
                    case e.ui.keyCode.RIGHT:
                    case e.ui.keyCode.DOWN:
                    case e.ui.keyCode.LEFT:
                        if (t.preventDefault(), !this._keySliding && (this._keySliding = !0, this._addClass(e(t.target), null, "ui-state-active"), i = this._start(t, o), i === !1))return
                }
                switch (a = this.options.step, s = n = this._hasMultipleValues() ? this.values(o) : this.value(), t.keyCode) {
                    case e.ui.keyCode.HOME:
                        n = this._valueMin();
                        break;
                    case e.ui.keyCode.END:
                        n = this._valueMax();
                        break;
                    case e.ui.keyCode.PAGE_UP:
                        n = this._trimAlignValue(s + (this._valueMax() - this._valueMin()) / this.numPages);
                        break;
                    case e.ui.keyCode.PAGE_DOWN:
                        n = this._trimAlignValue(s - (this._valueMax() - this._valueMin()) / this.numPages);
                        break;
                    case e.ui.keyCode.UP:
                    case e.ui.keyCode.RIGHT:
                        if (s === this._valueMax())return;
                        n = this._trimAlignValue(s + a);
                        break;
                    case e.ui.keyCode.DOWN:
                    case e.ui.keyCode.LEFT:
                        if (s === this._valueMin())return;
                        n = this._trimAlignValue(s - a)
                }
                this._slide(t, o, n)
            }, keyup: function (t) {
                var i = e(t.target).data("ui-slider-handle-index");
                this._keySliding && (this._keySliding = !1, this._stop(t, i), this._change(t, i), this._removeClass(e(t.target), null, "ui-state-active"))
            }
        }
    }), e.widget("ui.spinner", {
        version: "1.12.1",
        defaultElement: "<input>",
        widgetEventPrefix: "spin",
        options: {
            classes: {
                "ui-spinner": "ui-corner-all",
                "ui-spinner-down": "ui-corner-br",
                "ui-spinner-up": "ui-corner-tr"
            },
            culture: null,
            icons: {down: "ui-icon-triangle-1-s", up: "ui-icon-triangle-1-n"},
            incremental: !0,
            max: null,
            min: null,
            numberFormat: null,
            page: 10,
            step: 1,
            change: null,
            spin: null,
            start: null,
            stop: null
        },
        _create: function () {
            this._setOption("max", this.options.max), this._setOption("min", this.options.min), this._setOption("step", this.options.step), "" !== this.value() && this._value(this.element.val(), !0), this._draw(), this._on(this._events), this._refresh(), this._on(this.window, {
                beforeunload: function () {
                    this.element.removeAttr("autocomplete")
                }
            })
        },
        _getCreateOptions: function () {
            var t = this._super(), i = this.element;
            return e.each(["min", "max", "step"], function (e, s) {
                var n = i.attr(s);
                null != n && n.length && (t[s] = n)
            }), t
        },
        _events: {
            keydown: function (e) {
                this._start(e) && this._keydown(e) && e.preventDefault()
            }, keyup: "_stop", focus: function () {
                this.previous = this.element.val()
            }, blur: function (e) {
                return this.cancelBlur ? (delete this.cancelBlur, void 0) : (this._stop(), this._refresh(), this.previous !== this.element.val() && this._trigger("change", e), void 0)
            }, mousewheel: function (e, t) {
                if (t) {
                    if (!this.spinning && !this._start(e))return !1;
                    this._spin((t > 0 ? 1 : -1) * this.options.step, e), clearTimeout(this.mousewheelTimer), this.mousewheelTimer = this._delay(function () {
                        this.spinning && this._stop(e)
                    }, 100), e.preventDefault()
                }
            }, "mousedown .ui-spinner-button": function (t) {
                function i() {
                    var t = this.element[0] === e.ui.safeActiveElement(this.document[0]);
                    t || (this.element.trigger("focus"), this.previous = s, this._delay(function () {
                        this.previous = s
                    }))
                }

                var s;
                s = this.element[0] === e.ui.safeActiveElement(this.document[0]) ? this.previous : this.element.val(), t.preventDefault(), i.call(this), this.cancelBlur = !0, this._delay(function () {
                    delete this.cancelBlur, i.call(this)
                }), this._start(t) !== !1 && this._repeat(null, e(t.currentTarget).hasClass("ui-spinner-up") ? 1 : -1, t)
            }, "mouseup .ui-spinner-button": "_stop", "mouseenter .ui-spinner-button": function (t) {
                return e(t.currentTarget).hasClass("ui-state-active") ? this._start(t) === !1 ? !1 : (this._repeat(null, e(t.currentTarget).hasClass("ui-spinner-up") ? 1 : -1, t), void 0) : void 0
            }, "mouseleave .ui-spinner-button": "_stop"
        },
        _enhance: function () {
            this.uiSpinner = this.element.attr("autocomplete", "off").wrap("<span>").parent().append("<a></a><a></a>")
        },
        _draw: function () {
            this._enhance(), this._addClass(this.uiSpinner, "ui-spinner", "ui-widget ui-widget-content"), this._addClass("ui-spinner-input"), this.element.attr("role", "spinbutton"), this.buttons = this.uiSpinner.children("a").attr("tabIndex", -1).attr("aria-hidden", !0).button({classes: {"ui-button": ""}}), this._removeClass(this.buttons, "ui-corner-all"), this._addClass(this.buttons.first(), "ui-spinner-button ui-spinner-up"), this._addClass(this.buttons.last(), "ui-spinner-button ui-spinner-down"), this.buttons.first().button({
                icon: this.options.icons.up,
                showLabel: !1
            }), this.buttons.last().button({
                icon: this.options.icons.down,
                showLabel: !1
            }), this.buttons.height() > Math.ceil(.5 * this.uiSpinner.height()) && this.uiSpinner.height() > 0 && this.uiSpinner.height(this.uiSpinner.height())
        },
        _keydown: function (t) {
            var i = this.options, s = e.ui.keyCode;
            switch (t.keyCode) {
                case s.UP:
                    return this._repeat(null, 1, t), !0;
                case s.DOWN:
                    return this._repeat(null, -1, t), !0;
                case s.PAGE_UP:
                    return this._repeat(null, i.page, t), !0;
                case s.PAGE_DOWN:
                    return this._repeat(null, -i.page, t), !0
            }
            return !1
        },
        _start: function (e) {
            return this.spinning || this._trigger("start", e) !== !1 ? (this.counter || (this.counter = 1), this.spinning = !0, !0) : !1
        },
        _repeat: function (e, t, i) {
            e = e || 500, clearTimeout(this.timer), this.timer = this._delay(function () {
                this._repeat(40, t, i)
            }, e), this._spin(t * this.options.step, i)
        },
        _spin: function (e, t) {
            var i = this.value() || 0;
            this.counter || (this.counter = 1), i = this._adjustValue(i + e * this._increment(this.counter)), this.spinning && this._trigger("spin", t, {value: i}) === !1 || (this._value(i), this.counter++)
        },
        _increment: function (t) {
            var i = this.options.incremental;
            return i ? e.isFunction(i) ? i(t) : Math.floor(t * t * t / 5e4 - t * t / 500 + 17 * t / 200 + 1) : 1
        },
        _precision: function () {
            var e = this._precisionOf(this.options.step);
            return null !== this.options.min && (e = Math.max(e, this._precisionOf(this.options.min))), e
        },
        _precisionOf: function (e) {
            var t = "" + e, i = t.indexOf(".");
            return -1 === i ? 0 : t.length - i - 1
        },
        _adjustValue: function (e) {
            var t, i, s = this.options;
            return t = null !== s.min ? s.min : 0, i = e - t, i = Math.round(i / s.step) * s.step, e = t + i, e = parseFloat(e.toFixed(this._precision())), null !== s.max && e > s.max ? s.max : null !== s.min && s.min > e ? s.min : e
        },
        _stop: function (e) {
            this.spinning && (clearTimeout(this.timer), clearTimeout(this.mousewheelTimer), this.counter = 0, this.spinning = !1, this._trigger("stop", e))
        },
        _setOption: function (e, t) {
            var i, s, n;
            return "culture" === e || "numberFormat" === e ? (i = this._parse(this.element.val()), this.options[e] = t, this.element.val(this._format(i)), void 0) : (("max" === e || "min" === e || "step" === e) && "string" == typeof t && (t = this._parse(t)), "icons" === e && (s = this.buttons.first().find(".ui-icon"), this._removeClass(s, null, this.options.icons.up), this._addClass(s, null, t.up), n = this.buttons.last().find(".ui-icon"), this._removeClass(n, null, this.options.icons.down), this._addClass(n, null, t.down)), this._super(e, t), void 0)
        },
        _setOptionDisabled: function (e) {
            this._super(e), this._toggleClass(this.uiSpinner, null, "ui-state-disabled", !!e), this.element.prop("disabled", !!e), this.buttons.button(e ? "disable" : "enable")
        },
        _setOptions: r(function (e) {
            this._super(e)
        }),
        _parse: function (e) {
            return "string" == typeof e && "" !== e && (e = window.Globalize && this.options.numberFormat ? Globalize.parseFloat(e, 10, this.options.culture) : +e), "" === e || isNaN(e) ? null : e
        },
        _format: function (e) {
            return "" === e ? "" : window.Globalize && this.options.numberFormat ? Globalize.format(e, this.options.numberFormat, this.options.culture) : e
        },
        _refresh: function () {
            this.element.attr({
                "aria-valuemin": this.options.min,
                "aria-valuemax": this.options.max,
                "aria-valuenow": this._parse(this.element.val())
            })
        },
        isValid: function () {
            var e = this.value();
            return null === e ? !1 : e === this._adjustValue(e)
        },
        _value: function (e, t) {
            var i;
            "" !== e && (i = this._parse(e), null !== i && (t || (i = this._adjustValue(i)), e = this._format(i))), this.element.val(e), this._refresh()
        },
        _destroy: function () {
            this.element.prop("disabled", !1).removeAttr("autocomplete role aria-valuemin aria-valuemax aria-valuenow"), this.uiSpinner.replaceWith(this.element)
        },
        stepUp: r(function (e) {
            this._stepUp(e)
        }),
        _stepUp: function (e) {
            this._start() && (this._spin((e || 1) * this.options.step), this._stop())
        },
        stepDown: r(function (e) {
            this._stepDown(e)
        }),
        _stepDown: function (e) {
            this._start() && (this._spin((e || 1) * -this.options.step), this._stop())
        },
        pageUp: r(function (e) {
            this._stepUp((e || 1) * this.options.page)
        }),
        pageDown: r(function (e) {
            this._stepDown((e || 1) * this.options.page)
        }),
        value: function (e) {
            return arguments.length ? (r(this._value).call(this, e), void 0) : this._parse(this.element.val())
        },
        widget: function () {
            return this.uiSpinner
        }
    }), e.uiBackCompat !== !1 && e.widget("ui.spinner", e.ui.spinner, {
        _enhance: function () {
            this.uiSpinner = this.element.attr("autocomplete", "off").wrap(this._uiSpinnerHtml()).parent().append(this._buttonHtml())
        }, _uiSpinnerHtml: function () {
            return "<span>"
        }, _buttonHtml: function () {
            return "<a></a><a></a>"
        }
    }), e.ui.spinner, e.widget("ui.tabs", {
        version: "1.12.1",
        delay: 300,
        options: {
            active: null,
            classes: {
                "ui-tabs": "ui-corner-all",
                "ui-tabs-nav": "ui-corner-all",
                "ui-tabs-panel": "ui-corner-bottom",
                "ui-tabs-tab": "ui-corner-top"
            },
            collapsible: !1,
            event: "click",
            heightStyle: "content",
            hide: null,
            show: null,
            activate: null,
            beforeActivate: null,
            beforeLoad: null,
            load: null
        },
        _isLocal: function () {
            var e = /#.*$/;
            return function (t) {
                var i, s;
                i = t.href.replace(e, ""), s = location.href.replace(e, "");
                try {
                    i = decodeURIComponent(i)
                } catch (n) {
                }
                try {
                    s = decodeURIComponent(s)
                } catch (n) {
                }
                return t.hash.length > 1 && i === s
            }
        }(),
        _create: function () {
            var t = this, i = this.options;
            this.running = !1, this._addClass("ui-tabs", "ui-widget ui-widget-content"), this._toggleClass("ui-tabs-collapsible", null, i.collapsible), this._processTabs(), i.active = this._initialActive(), e.isArray(i.disabled) && (i.disabled = e.unique(i.disabled.concat(e.map(this.tabs.filter(".ui-state-disabled"), function (e) {
                return t.tabs.index(e)
            }))).sort()), this.active = this.options.active !== !1 && this.anchors.length ? this._findActive(i.active) : e(), this._refresh(), this.active.length && this.load(i.active)
        },
        _initialActive: function () {
            var t = this.options.active, i = this.options.collapsible, s = location.hash.substring(1);
            return null === t && (s && this.tabs.each(function (i, n) {
                return e(n).attr("aria-controls") === s ? (t = i, !1) : void 0
            }), null === t && (t = this.tabs.index(this.tabs.filter(".ui-tabs-active"))), (null === t || -1 === t) && (t = this.tabs.length ? 0 : !1)), t !== !1 && (t = this.tabs.index(this.tabs.eq(t)), -1 === t && (t = i ? !1 : 0)), !i && t === !1 && this.anchors.length && (t = 0), t
        },
        _getCreateEventData: function () {
            return {tab: this.active, panel: this.active.length ? this._getPanelForTab(this.active) : e()}
        },
        _tabKeydown: function (t) {
            var i = e(e.ui.safeActiveElement(this.document[0])).closest("li"), s = this.tabs.index(i), n = !0;
            if (!this._handlePageNav(t)) {
                switch (t.keyCode) {
                    case e.ui.keyCode.RIGHT:
                    case e.ui.keyCode.DOWN:
                        s++;
                        break;
                    case e.ui.keyCode.UP:
                    case e.ui.keyCode.LEFT:
                        n = !1, s--;
                        break;
                    case e.ui.keyCode.END:
                        s = this.anchors.length - 1;
                        break;
                    case e.ui.keyCode.HOME:
                        s = 0;
                        break;
                    case e.ui.keyCode.SPACE:
                        return t.preventDefault(), clearTimeout(this.activating), this._activate(s), void 0;
                    case e.ui.keyCode.ENTER:
                        return t.preventDefault(), clearTimeout(this.activating), this._activate(s === this.options.active ? !1 : s), void 0;
                    default:
                        return
                }
                t.preventDefault(), clearTimeout(this.activating), s = this._focusNextTab(s, n), t.ctrlKey || t.metaKey || (i.attr("aria-selected", "false"), this.tabs.eq(s).attr("aria-selected", "true"), this.activating = this._delay(function () {
                    this.option("active", s)
                }, this.delay))
            }
        },
        _panelKeydown: function (t) {
            this._handlePageNav(t) || t.ctrlKey && t.keyCode === e.ui.keyCode.UP && (t.preventDefault(), this.active.trigger("focus"))
        },
        _handlePageNav: function (t) {
            return t.altKey && t.keyCode === e.ui.keyCode.PAGE_UP ? (this._activate(this._focusNextTab(this.options.active - 1, !1)), !0) : t.altKey && t.keyCode === e.ui.keyCode.PAGE_DOWN ? (this._activate(this._focusNextTab(this.options.active + 1, !0)), !0) : void 0
        },
        _findNextTab: function (t, i) {
            function s() {
                return t > n && (t = 0), 0 > t && (t = n), t
            }

            for (var n = this.tabs.length - 1; -1 !== e.inArray(s(), this.options.disabled);)t = i ? t + 1 : t - 1;
            return t
        },
        _focusNextTab: function (e, t) {
            return e = this._findNextTab(e, t), this.tabs.eq(e).trigger("focus"), e
        },
        _setOption: function (e, t) {
            return "active" === e ? (this._activate(t), void 0) : (this._super(e, t), "collapsible" === e && (this._toggleClass("ui-tabs-collapsible", null, t), t || this.options.active !== !1 || this._activate(0)), "event" === e && this._setupEvents(t), "heightStyle" === e && this._setupHeightStyle(t), void 0)
        },
        _sanitizeSelector: function (e) {
            return e ? e.replace(/[!"$%&'()*+,.\/:;<=>?@\[\]\^`{|}~]/g, "\\$&") : ""
        },
        refresh: function () {
            var t = this.options, i = this.tablist.children(":has(a[href])");
            t.disabled = e.map(i.filter(".ui-state-disabled"), function (e) {
                return i.index(e)
            }), this._processTabs(), t.active !== !1 && this.anchors.length ? this.active.length && !e.contains(this.tablist[0], this.active[0]) ? this.tabs.length === t.disabled.length ? (t.active = !1, this.active = e()) : this._activate(this._findNextTab(Math.max(0, t.active - 1), !1)) : t.active = this.tabs.index(this.active) : (t.active = !1, this.active = e()), this._refresh()
        },
        _refresh: function () {
            this._setOptionDisabled(this.options.disabled), this._setupEvents(this.options.event), this._setupHeightStyle(this.options.heightStyle), this.tabs.not(this.active).attr({
                "aria-selected": "false",
                "aria-expanded": "false",
                tabIndex: -1
            }), this.panels.not(this._getPanelForTab(this.active)).hide().attr({"aria-hidden": "true"}), this.active.length ? (this.active.attr({
                    "aria-selected": "true",
                    "aria-expanded": "true",
                    tabIndex: 0
                }), this._addClass(this.active, "ui-tabs-active", "ui-state-active"), this._getPanelForTab(this.active).show().attr({"aria-hidden": "false"})) : this.tabs.eq(0).attr("tabIndex", 0)
        },
        _processTabs: function () {
            var t = this, i = this.tabs, s = this.anchors, n = this.panels;
            this.tablist = this._getList().attr("role", "tablist"), this._addClass(this.tablist, "ui-tabs-nav", "ui-helper-reset ui-helper-clearfix ui-widget-header"), this.tablist.on("mousedown" + this.eventNamespace, "> li", function (t) {
                e(this).is(".ui-state-disabled") && t.preventDefault()
            }).on("focus" + this.eventNamespace, ".ui-tabs-anchor", function () {
                e(this).closest("li").is(".ui-state-disabled") && this.blur()
            }), this.tabs = this.tablist.find("> li:has(a[href])").attr({
                role: "tab",
                tabIndex: -1
            }), this._addClass(this.tabs, "ui-tabs-tab", "ui-state-default"), this.anchors = this.tabs.map(function () {
                return e("a", this)[0]
            }).attr({
                role: "presentation",
                tabIndex: -1
            }), this._addClass(this.anchors, "ui-tabs-anchor"), this.panels = e(), this.anchors.each(function (i, s) {
                var n, a, o, r = e(s).uniqueId().attr("id"), h = e(s).closest("li"), l = h.attr("aria-controls");
                t._isLocal(s) ? (n = s.hash, o = n.substring(1), a = t.element.find(t._sanitizeSelector(n))) : (o = h.attr("aria-controls") || e({}).uniqueId()[0].id, n = "#" + o, a = t.element.find(n), a.length || (a = t._createPanel(o), a.insertAfter(t.panels[i - 1] || t.tablist)), a.attr("aria-live", "polite")), a.length && (t.panels = t.panels.add(a)), l && h.data("ui-tabs-aria-controls", l), h.attr({
                    "aria-controls": o,
                    "aria-labelledby": r
                }), a.attr("aria-labelledby", r)
            }), this.panels.attr("role", "tabpanel"), this._addClass(this.panels, "ui-tabs-panel", "ui-widget-content"), i && (this._off(i.not(this.tabs)), this._off(s.not(this.anchors)), this._off(n.not(this.panels)))
        },
        _getList: function () {
            return this.tablist || this.element.find("ol, ul").eq(0)
        },
        _createPanel: function (t) {
            return e("<div>").attr("id", t).data("ui-tabs-destroy", !0)
        },
        _setOptionDisabled: function (t) {
            var i, s, n;
            for (e.isArray(t) && (t.length ? t.length === this.anchors.length && (t = !0) : t = !1), n = 0; s = this.tabs[n]; n++)i = e(s), t === !0 || -1 !== e.inArray(n, t) ? (i.attr("aria-disabled", "true"), this._addClass(i, null, "ui-state-disabled")) : (i.removeAttr("aria-disabled"), this._removeClass(i, null, "ui-state-disabled"));
            this.options.disabled = t, this._toggleClass(this.widget(), this.widgetFullName + "-disabled", null, t === !0)
        },
        _setupEvents: function (t) {
            var i = {};
            t && e.each(t.split(" "), function (e, t) {
                i[t] = "_eventHandler"
            }), this._off(this.anchors.add(this.tabs).add(this.panels)), this._on(!0, this.anchors, {
                click: function (e) {
                    e.preventDefault()
                }
            }), this._on(this.anchors, i), this._on(this.tabs, {keydown: "_tabKeydown"}), this._on(this.panels, {keydown: "_panelKeydown"}), this._focusable(this.tabs), this._hoverable(this.tabs)
        },
        _setupHeightStyle: function (t) {
            var i, s = this.element.parent();
            "fill" === t ? (i = s.height(), i -= this.element.outerHeight() - this.element.height(), this.element.siblings(":visible").each(function () {
                    var t = e(this), s = t.css("position");
                    "absolute" !== s && "fixed" !== s && (i -= t.outerHeight(!0))
                }), this.element.children().not(this.panels).each(function () {
                    i -= e(this).outerHeight(!0)
                }), this.panels.each(function () {
                    e(this).height(Math.max(0, i - e(this).innerHeight() + e(this).height()))
                }).css("overflow", "auto")) : "auto" === t && (i = 0, this.panels.each(function () {
                    i = Math.max(i, e(this).height("").height())
                }).height(i))
        },
        _eventHandler: function (t) {
            var i = this.options, s = this.active, n = e(t.currentTarget), a = n.closest("li"), o = a[0] === s[0], r = o && i.collapsible, h = r ? e() : this._getPanelForTab(a), l = s.length ? this._getPanelForTab(s) : e(), u = {
                oldTab: s,
                oldPanel: l,
                newTab: r ? e() : a,
                newPanel: h
            };
            t.preventDefault(), a.hasClass("ui-state-disabled") || a.hasClass("ui-tabs-loading") || this.running || o && !i.collapsible || this._trigger("beforeActivate", t, u) === !1 || (i.active = r ? !1 : this.tabs.index(a), this.active = o ? e() : a, this.xhr && this.xhr.abort(), l.length || h.length || e.error("jQuery UI Tabs: Mismatching fragment identifier."), h.length && this.load(this.tabs.index(a), t), this._toggle(t, u))
        },
        _toggle: function (t, i) {
            function s() {
                a.running = !1, a._trigger("activate", t, i)
            }

            function n() {
                a._addClass(i.newTab.closest("li"), "ui-tabs-active", "ui-state-active"), o.length && a.options.show ? a._show(o, a.options.show, s) : (o.show(), s())
            }

            var a = this, o = i.newPanel, r = i.oldPanel;
            this.running = !0, r.length && this.options.hide ? this._hide(r, this.options.hide, function () {
                    a._removeClass(i.oldTab.closest("li"), "ui-tabs-active", "ui-state-active"), n()
                }) : (this._removeClass(i.oldTab.closest("li"), "ui-tabs-active", "ui-state-active"), r.hide(), n()), r.attr("aria-hidden", "true"), i.oldTab.attr({
                "aria-selected": "false",
                "aria-expanded": "false"
            }), o.length && r.length ? i.oldTab.attr("tabIndex", -1) : o.length && this.tabs.filter(function () {
                    return 0 === e(this).attr("tabIndex")
                }).attr("tabIndex", -1), o.attr("aria-hidden", "false"), i.newTab.attr({
                "aria-selected": "true",
                "aria-expanded": "true",
                tabIndex: 0
            })
        },
        _activate: function (t) {
            var i, s = this._findActive(t);
            s[0] !== this.active[0] && (s.length || (s = this.active), i = s.find(".ui-tabs-anchor")[0], this._eventHandler({
                target: i,
                currentTarget: i,
                preventDefault: e.noop
            }))
        },
        _findActive: function (t) {
            return t === !1 ? e() : this.tabs.eq(t)
        },
        _getIndex: function (t) {
            return "string" == typeof t && (t = this.anchors.index(this.anchors.filter("[href$='" + e.ui.escapeSelector(t) + "']"))), t
        },
        _destroy: function () {
            this.xhr && this.xhr.abort(), this.tablist.removeAttr("role").off(this.eventNamespace), this.anchors.removeAttr("role tabIndex").removeUniqueId(), this.tabs.add(this.panels).each(function () {
                e.data(this, "ui-tabs-destroy") ? e(this).remove() : e(this).removeAttr("role tabIndex aria-live aria-busy aria-selected aria-labelledby aria-hidden aria-expanded")
            }), this.tabs.each(function () {
                var t = e(this), i = t.data("ui-tabs-aria-controls");
                i ? t.attr("aria-controls", i).removeData("ui-tabs-aria-controls") : t.removeAttr("aria-controls")
            }), this.panels.show(), "content" !== this.options.heightStyle && this.panels.css("height", "")
        },
        enable: function (t) {
            var i = this.options.disabled;
            i !== !1 && (void 0 === t ? i = !1 : (t = this._getIndex(t), i = e.isArray(i) ? e.map(i, function (e) {
                        return e !== t ? e : null
                    }) : e.map(this.tabs, function (e, i) {
                        return i !== t ? i : null
                    })), this._setOptionDisabled(i))
        },
        disable: function (t) {
            var i = this.options.disabled;
            if (i !== !0) {
                if (void 0 === t) i = !0; else {
                    if (t = this._getIndex(t), -1 !== e.inArray(t, i))return;
                    i = e.isArray(i) ? e.merge([t], i).sort() : [t]
                }
                this._setOptionDisabled(i)
            }
        },
        load: function (t, i) {
            t = this._getIndex(t);
            var s = this, n = this.tabs.eq(t), a = n.find(".ui-tabs-anchor"), o = this._getPanelForTab(n), r = {
                tab: n,
                panel: o
            }, h = function (e, t) {
                "abort" === t && s.panels.stop(!1, !0), s._removeClass(n, "ui-tabs-loading"), o.removeAttr("aria-busy"), e === s.xhr && delete s.xhr
            };
            this._isLocal(a[0]) || (this.xhr = e.ajax(this._ajaxSettings(a, i, r)), this.xhr && "canceled" !== this.xhr.statusText && (this._addClass(n, "ui-tabs-loading"), o.attr("aria-busy", "true"), this.xhr.done(function (e, t, n) {
                setTimeout(function () {
                    o.html(e), s._trigger("load", i, r), h(n, t)
                }, 1)
            }).fail(function (e, t) {
                setTimeout(function () {
                    h(e, t)
                }, 1)
            })))
        },
        _ajaxSettings: function (t, i, s) {
            var n = this;
            return {
                url: t.attr("href").replace(/#.*$/, ""), beforeSend: function (t, a) {
                    return n._trigger("beforeLoad", i, e.extend({jqXHR: t, ajaxSettings: a}, s))
                }
            }
        },
        _getPanelForTab: function (t) {
            var i = e(t).attr("aria-controls");
            return this.element.find(this._sanitizeSelector("#" + i))
        }
    }), e.uiBackCompat !== !1 && e.widget("ui.tabs", e.ui.tabs, {
        _processTabs: function () {
            this._superApply(arguments), this._addClass(this.tabs, "ui-tab")
        }
    }), e.ui.tabs, e.widget("ui.tooltip", {
        version: "1.12.1", options: {
            classes: {"ui-tooltip": "ui-corner-all ui-widget-shadow"},
            content: function () {
                var t = e(this).attr("title") || "";
                return e("<a>").text(t).html()
            },
            hide: !0,
            items: "[title]:not([disabled])",
            position: {my: "left top+15", at: "left bottom", collision: "flipfit flip"},
            show: !0,
            track: !1,
            close: null,
            open: null
        }, _addDescribedBy: function (t, i) {
            var s = (t.attr("aria-describedby") || "").split(/\s+/);
            s.push(i), t.data("ui-tooltip-id", i).attr("aria-describedby", e.trim(s.join(" ")))
        }, _removeDescribedBy: function (t) {
            var i = t.data("ui-tooltip-id"), s = (t.attr("aria-describedby") || "").split(/\s+/), n = e.inArray(i, s);
            -1 !== n && s.splice(n, 1), t.removeData("ui-tooltip-id"), s = e.trim(s.join(" ")), s ? t.attr("aria-describedby", s) : t.removeAttr("aria-describedby")
        }, _create: function () {
            this._on({
                mouseover: "open",
                focusin: "open"
            }), this.tooltips = {}, this.parents = {}, this.liveRegion = e("<div>").attr({
                role: "log",
                "aria-live": "assertive",
                "aria-relevant": "additions"
            }).appendTo(this.document[0].body), this._addClass(this.liveRegion, null, "ui-helper-hidden-accessible"), this.disabledTitles = e([])
        }, _setOption: function (t, i) {
            var s = this;
            this._super(t, i), "content" === t && e.each(this.tooltips, function (e, t) {
                s._updateContent(t.element)
            })
        }, _setOptionDisabled: function (e) {
            this[e ? "_disable" : "_enable"]()
        }, _disable: function () {
            var t = this;
            e.each(this.tooltips, function (i, s) {
                var n = e.Event("blur");
                n.target = n.currentTarget = s.element[0], t.close(n, !0)
            }), this.disabledTitles = this.disabledTitles.add(this.element.find(this.options.items).addBack().filter(function () {
                var t = e(this);
                return t.is("[title]") ? t.data("ui-tooltip-title", t.attr("title")).removeAttr("title") : void 0
            }))
        }, _enable: function () {
            this.disabledTitles.each(function () {
                var t = e(this);
                t.data("ui-tooltip-title") && t.attr("title", t.data("ui-tooltip-title"))
            }), this.disabledTitles = e([])
        }, open: function (t) {
            var i = this, s = e(t ? t.target : this.element).closest(this.options.items);
            s.length && !s.data("ui-tooltip-id") && (s.attr("title") && s.data("ui-tooltip-title", s.attr("title")), s.data("ui-tooltip-open", !0), t && "mouseover" === t.type && s.parents().each(function () {
                var t, s = e(this);
                s.data("ui-tooltip-open") && (t = e.Event("blur"), t.target = t.currentTarget = this, i.close(t, !0)), s.attr("title") && (s.uniqueId(), i.parents[this.id] = {
                    element: this,
                    title: s.attr("title")
                }, s.attr("title", ""))
            }), this._registerCloseHandlers(t, s), this._updateContent(s, t))
        }, _updateContent: function (e, t) {
            var i, s = this.options.content, n = this, a = t ? t.type : null;
            return "string" == typeof s || s.nodeType || s.jquery ? this._open(t, e, s) : (i = s.call(e[0], function (i) {
                    n._delay(function () {
                        e.data("ui-tooltip-open") && (t && (t.type = a), this._open(t, e, i))
                    })
                }), i && this._open(t, e, i), void 0)
        }, _open: function (t, i, s) {
            function n(e) {
                l.of = e, o.is(":hidden") || o.position(l)
            }

            var a, o, r, h, l = e.extend({}, this.options.position);
            if (s) {
                if (a = this._find(i))return a.tooltip.find(".ui-tooltip-content").html(s), void 0;
                i.is("[title]") && (t && "mouseover" === t.type ? i.attr("title", "") : i.removeAttr("title")), a = this._tooltip(i), o = a.tooltip, this._addDescribedBy(i, o.attr("id")), o.find(".ui-tooltip-content").html(s), this.liveRegion.children().hide(), h = e("<div>").html(o.find(".ui-tooltip-content").html()), h.removeAttr("name").find("[name]").removeAttr("name"), h.removeAttr("id").find("[id]").removeAttr("id"), h.appendTo(this.liveRegion), this.options.track && t && /^mouse/.test(t.type) ? (this._on(this.document, {mousemove: n}), n(t)) : o.position(e.extend({of: i}, this.options.position)), o.hide(), this._show(o, this.options.show), this.options.track && this.options.show && this.options.show.delay && (r = this.delayedShow = setInterval(function () {
                    o.is(":visible") && (n(l.of), clearInterval(r))
                }, e.fx.interval)), this._trigger("open", t, {tooltip: o})
            }
        }, _registerCloseHandlers: function (t, i) {
            var s = {
                keyup: function (t) {
                    if (t.keyCode === e.ui.keyCode.ESCAPE) {
                        var s = e.Event(t);
                        s.currentTarget = i[0], this.close(s, !0)
                    }
                }
            };
            i[0] !== this.element[0] && (s.remove = function () {
                this._removeTooltip(this._find(i).tooltip)
            }), t && "mouseover" !== t.type || (s.mouseleave = "close"), t && "focusin" !== t.type || (s.focusout = "close"), this._on(!0, i, s)
        }, close: function (t) {
            var i, s = this, n = e(t ? t.currentTarget : this.element), a = this._find(n);
            return a ? (i = a.tooltip, a.closing || (clearInterval(this.delayedShow), n.data("ui-tooltip-title") && !n.attr("title") && n.attr("title", n.data("ui-tooltip-title")), this._removeDescribedBy(n), a.hiding = !0, i.stop(!0), this._hide(i, this.options.hide, function () {
                    s._removeTooltip(e(this))
                }), n.removeData("ui-tooltip-open"), this._off(n, "mouseleave focusout keyup"), n[0] !== this.element[0] && this._off(n, "remove"), this._off(this.document, "mousemove"), t && "mouseleave" === t.type && e.each(this.parents, function (t, i) {
                    e(i.element).attr("title", i.title), delete s.parents[t]
                }), a.closing = !0, this._trigger("close", t, {tooltip: i}), a.hiding || (a.closing = !1)), void 0) : (n.removeData("ui-tooltip-open"), void 0)
        }, _tooltip: function (t) {
            var i = e("<div>").attr("role", "tooltip"), s = e("<div>").appendTo(i), n = i.uniqueId().attr("id");
            return this._addClass(s, "ui-tooltip-content"), this._addClass(i, "ui-tooltip", "ui-widget ui-widget-content"), i.appendTo(this._appendTo(t)), this.tooltips[n] = {
                element: t,
                tooltip: i
            }
        }, _find: function (e) {
            var t = e.data("ui-tooltip-id");
            return t ? this.tooltips[t] : null
        }, _removeTooltip: function (e) {
            e.remove(), delete this.tooltips[e.attr("id")]
        }, _appendTo: function (e) {
            var t = e.closest(".ui-front, dialog");
            return t.length || (t = this.document[0].body), t
        }, _destroy: function () {
            var t = this;
            e.each(this.tooltips, function (i, s) {
                var n = e.Event("blur"), a = s.element;
                n.target = n.currentTarget = a[0], t.close(n, !0), e("#" + i).remove(), a.data("ui-tooltip-title") && (a.attr("title") || a.attr("title", a.data("ui-tooltip-title")), a.removeData("ui-tooltip-title"))
            }), this.liveRegion.remove()
        }
    }), e.uiBackCompat !== !1 && e.widget("ui.tooltip", e.ui.tooltip, {
        options: {tooltipClass: null},
        _tooltip: function () {
            var e = this._superApply(arguments);
            return this.options.tooltipClass && e.tooltip.addClass(this.options.tooltipClass), e
        }
    }), e.ui.tooltip;
    var f = "ui-effects-", m = "ui-effects-style", g = "ui-effects-animated", v = e;
    e.effects = {effect: {}}, function (e, t) {
        function i(e, t, i) {
            var s = c[t.type] || {};
            return null == e ? i || !t.def ? null : t.def : (e = s.floor ? ~~e : parseFloat(e), isNaN(e) ? t.def : s.mod ? (e + s.mod) % s.mod : 0 > e ? 0 : e > s.max ? s.max : e)
        }

        function s(i) {
            var s = l(), n = s._rgba = [];
            return i = i.toLowerCase(), f(h, function (e, a) {
                var o, r = a.re.exec(i), h = r && a.parse(r), l = a.space || "rgba";
                return h ? (o = s[l](h), s[u[l].cache] = o[u[l].cache], n = s._rgba = o._rgba, !1) : t
            }), n.length ? ("0,0,0,0" === n.join() && e.extend(n, a.transparent), s) : a[i]
        }

        function n(e, t, i) {
            return i = (i + 1) % 1, 1 > 6 * i ? e + 6 * (t - e) * i : 1 > 2 * i ? t : 2 > 3 * i ? e + 6 * (t - e) * (2 / 3 - i) : e
        }

        var a, o = "backgroundColor borderBottomColor borderLeftColor borderRightColor borderTopColor color columnRuleColor outlineColor textDecorationColor textEmphasisColor", r = /^([\-+])=\s*(\d+\.?\d*)/, h = [{
            re: /rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
            parse: function (e) {
                return [e[1], e[2], e[3], e[4]]
            }
        }, {
            re: /rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
            parse: function (e) {
                return [2.55 * e[1], 2.55 * e[2], 2.55 * e[3], e[4]]
            }
        }, {
            re: /#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})/, parse: function (e) {
                return [parseInt(e[1], 16), parseInt(e[2], 16), parseInt(e[3], 16)]
            }
        }, {
            re: /#([a-f0-9])([a-f0-9])([a-f0-9])/, parse: function (e) {
                return [parseInt(e[1] + e[1], 16), parseInt(e[2] + e[2], 16), parseInt(e[3] + e[3], 16)]
            }
        }, {
            re: /hsla?\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
            space: "hsla",
            parse: function (e) {
                return [e[1], e[2] / 100, e[3] / 100, e[4]]
            }
        }], l = e.Color = function (t, i, s, n) {
            return new e.Color.fn.parse(t, i, s, n)
        }, u = {
            rgba: {
                props: {
                    red: {idx: 0, type: "byte"},
                    green: {idx: 1, type: "byte"},
                    blue: {idx: 2, type: "byte"}
                }
            },
            hsla: {
                props: {
                    hue: {idx: 0, type: "degrees"},
                    saturation: {idx: 1, type: "percent"},
                    lightness: {idx: 2, type: "percent"}
                }
            }
        }, c = {
            "byte": {floor: !0, max: 255},
            percent: {max: 1},
            degrees: {mod: 360, floor: !0}
        }, d = l.support = {}, p = e("<p>")[0], f = e.each;
        p.style.cssText = "background-color:rgba(1,1,1,.5)", d.rgba = p.style.backgroundColor.indexOf("rgba") > -1, f(u, function (e, t) {
            t.cache = "_" + e, t.props.alpha = {idx: 3, type: "percent", def: 1}
        }), l.fn = e.extend(l.prototype, {
            parse: function (n, o, r, h) {
                if (n === t)return this._rgba = [null, null, null, null], this;
                (n.jquery || n.nodeType) && (n = e(n).css(o), o = t);
                var c = this, d = e.type(n), p = this._rgba = [];
                return o !== t && (n = [n, o, r, h], d = "array"), "string" === d ? this.parse(s(n) || a._default) : "array" === d ? (f(u.rgba.props, function (e, t) {
                            p[t.idx] = i(n[t.idx], t)
                        }), this) : "object" === d ? (n instanceof l ? f(u, function (e, t) {
                                    n[t.cache] && (c[t.cache] = n[t.cache].slice())
                                }) : f(u, function (t, s) {
                                    var a = s.cache;
                                    f(s.props, function (e, t) {
                                        if (!c[a] && s.to) {
                                            if ("alpha" === e || null == n[e])return;
                                            c[a] = s.to(c._rgba)
                                        }
                                        c[a][t.idx] = i(n[e], t, !0)
                                    }), c[a] && 0 > e.inArray(null, c[a].slice(0, 3)) && (c[a][3] = 1, s.from && (c._rgba = s.from(c[a])))
                                }), this) : t
            }, is: function (e) {
                var i = l(e), s = !0, n = this;
                return f(u, function (e, a) {
                    var o, r = i[a.cache];
                    return r && (o = n[a.cache] || a.to && a.to(n._rgba) || [], f(a.props, function (e, i) {
                        return null != r[i.idx] ? s = r[i.idx] === o[i.idx] : t
                    })), s
                }), s
            }, _space: function () {
                var e = [], t = this;
                return f(u, function (i, s) {
                    t[s.cache] && e.push(i)
                }), e.pop()
            }, transition: function (e, t) {
                var s = l(e), n = s._space(), a = u[n], o = 0 === this.alpha() ? l("transparent") : this, r = o[a.cache] || a.to(o._rgba), h = r.slice();
                return s = s[a.cache], f(a.props, function (e, n) {
                    var a = n.idx, o = r[a], l = s[a], u = c[n.type] || {};
                    null !== l && (null === o ? h[a] = l : (u.mod && (l - o > u.mod / 2 ? o += u.mod : o - l > u.mod / 2 && (o -= u.mod)), h[a] = i((l - o) * t + o, n)))
                }), this[n](h)
            }, blend: function (t) {
                if (1 === this._rgba[3])return this;
                var i = this._rgba.slice(), s = i.pop(), n = l(t)._rgba;
                return l(e.map(i, function (e, t) {
                    return (1 - s) * n[t] + s * e
                }))
            }, toRgbaString: function () {
                var t = "rgba(", i = e.map(this._rgba, function (e, t) {
                    return null == e ? t > 2 ? 1 : 0 : e
                });
                return 1 === i[3] && (i.pop(), t = "rgb("), t + i.join() + ")"
            }, toHslaString: function () {
                var t = "hsla(", i = e.map(this.hsla(), function (e, t) {
                    return null == e && (e = t > 2 ? 1 : 0), t && 3 > t && (e = Math.round(100 * e) + "%"), e
                });
                return 1 === i[3] && (i.pop(), t = "hsl("), t + i.join() + ")"
            }, toHexString: function (t) {
                var i = this._rgba.slice(), s = i.pop();
                return t && i.push(~~(255 * s)), "#" + e.map(i, function (e) {
                    return e = (e || 0).toString(16), 1 === e.length ? "0" + e : e
                }).join("")
            }, toString: function () {
                return 0 === this._rgba[3] ? "transparent" : this.toRgbaString()
            }
        }), l.fn.parse.prototype = l.fn, u.hsla.to = function (e) {
            if (null == e[0] || null == e[1] || null == e[2])return [null, null, null, e[3]];
            var t, i, s = e[0] / 255, n = e[1] / 255, a = e[2] / 255, o = e[3], r = Math.max(s, n, a), h = Math.min(s, n, a), l = r - h, u = r + h, c = .5 * u;
            return t = h === r ? 0 : s === r ? 60 * (n - a) / l + 360 : n === r ? 60 * (a - s) / l + 120 : 60 * (s - n) / l + 240, i = 0 === l ? 0 : .5 >= c ? l / u : l / (2 - u), [Math.round(t) % 360, i, c, null == o ? 1 : o]
        }, u.hsla.from = function (e) {
            if (null == e[0] || null == e[1] || null == e[2])return [null, null, null, e[3]];
            var t = e[0] / 360, i = e[1], s = e[2], a = e[3], o = .5 >= s ? s * (1 + i) : s + i - s * i, r = 2 * s - o;
            return [Math.round(255 * n(r, o, t + 1 / 3)), Math.round(255 * n(r, o, t)), Math.round(255 * n(r, o, t - 1 / 3)), a]
        }, f(u, function (s, n) {
            var a = n.props, o = n.cache, h = n.to, u = n.from;
            l.fn[s] = function (s) {
                if (h && !this[o] && (this[o] = h(this._rgba)), s === t)return this[o].slice();
                var n, r = e.type(s), c = "array" === r || "object" === r ? s : arguments, d = this[o].slice();
                return f(a, function (e, t) {
                    var s = c["object" === r ? e : t.idx];
                    null == s && (s = d[t.idx]), d[t.idx] = i(s, t)
                }), u ? (n = l(u(d)), n[o] = d, n) : l(d)
            }, f(a, function (t, i) {
                l.fn[t] || (l.fn[t] = function (n) {
                    var a, o = e.type(n), h = "alpha" === t ? this._hsla ? "hsla" : "rgba" : s, l = this[h](), u = l[i.idx];
                    return "undefined" === o ? u : ("function" === o && (n = n.call(this, u), o = e.type(n)), null == n && i.empty ? this : ("string" === o && (a = r.exec(n), a && (n = u + parseFloat(a[2]) * ("+" === a[1] ? 1 : -1))), l[i.idx] = n, this[h](l)))
                })
            })
        }), l.hook = function (t) {
            var i = t.split(" ");
            f(i, function (t, i) {
                e.cssHooks[i] = {
                    set: function (t, n) {
                        var a, o, r = "";
                        if ("transparent" !== n && ("string" !== e.type(n) || (a = s(n)))) {
                            if (n = l(a || n), !d.rgba && 1 !== n._rgba[3]) {
                                for (o = "backgroundColor" === i ? t.parentNode : t; ("" === r || "transparent" === r) && o && o.style;)try {
                                    r = e.css(o, "backgroundColor"), o = o.parentNode
                                } catch (h) {
                                }
                                n = n.blend(r && "transparent" !== r ? r : "_default")
                            }
                            n = n.toRgbaString()
                        }
                        try {
                            t.style[i] = n
                        } catch (h) {
                        }
                    }
                }, e.fx.step[i] = function (t) {
                    t.colorInit || (t.start = l(t.elem, i), t.end = l(t.end), t.colorInit = !0), e.cssHooks[i].set(t.elem, t.start.transition(t.end, t.pos))
                }
            })
        }, l.hook(o), e.cssHooks.borderColor = {
            expand: function (e) {
                var t = {};
                return f(["Top", "Right", "Bottom", "Left"], function (i, s) {
                    t["border" + s + "Color"] = e
                }), t
            }
        }, a = e.Color.names = {
            aqua: "#00ffff",
            black: "#000000",
            blue: "#0000ff",
            fuchsia: "#ff00ff",
            gray: "#808080",
            green: "#008000",
            lime: "#00ff00",
            maroon: "#800000",
            navy: "#000080",
            olive: "#808000",
            purple: "#800080",
            red: "#ff0000",
            silver: "#c0c0c0",
            teal: "#008080",
            white: "#ffffff",
            yellow: "#ffff00",
            transparent: [null, null, null, 0],
            _default: "#ffffff"
        }
    }(v), function () {
        function t(t) {
            var i, s, n = t.ownerDocument.defaultView ? t.ownerDocument.defaultView.getComputedStyle(t, null) : t.currentStyle, a = {};
            if (n && n.length && n[0] && n[n[0]])for (s = n.length; s--;)i = n[s], "string" == typeof n[i] && (a[e.camelCase(i)] = n[i]); else for (i in n)"string" == typeof n[i] && (a[i] = n[i]);
            return a
        }

        function i(t, i) {
            var s, a, o = {};
            for (s in i)a = i[s], t[s] !== a && (n[s] || (e.fx.step[s] || !isNaN(parseFloat(a))) && (o[s] = a));
            return o
        }

        var s = ["add", "remove", "toggle"], n = {
            border: 1,
            borderBottom: 1,
            borderColor: 1,
            borderLeft: 1,
            borderRight: 1,
            borderTop: 1,
            borderWidth: 1,
            margin: 1,
            padding: 1
        };
        e.each(["borderLeftStyle", "borderRightStyle", "borderBottomStyle", "borderTopStyle"], function (t, i) {
            e.fx.step[i] = function (e) {
                ("none" !== e.end && !e.setAttr || 1 === e.pos && !e.setAttr) && (v.style(e.elem, i, e.end), e.setAttr = !0)
            }
        }), e.fn.addBack || (e.fn.addBack = function (e) {
            return this.add(null == e ? this.prevObject : this.prevObject.filter(e))
        }), e.effects.animateClass = function (n, a, o, r) {
            var h = e.speed(a, o, r);
            return this.queue(function () {
                var a, o = e(this), r = o.attr("class") || "", l = h.children ? o.find("*").addBack() : o;
                l = l.map(function () {
                    var i = e(this);
                    return {el: i, start: t(this)}
                }), a = function () {
                    e.each(s, function (e, t) {
                        n[t] && o[t + "Class"](n[t])
                    })
                }, a(), l = l.map(function () {
                    return this.end = t(this.el[0]), this.diff = i(this.start, this.end), this
                }), o.attr("class", r), l = l.map(function () {
                    var t = this, i = e.Deferred(), s = e.extend({}, h, {
                        queue: !1, complete: function () {
                            i.resolve(t)
                        }
                    });
                    return this.el.animate(this.diff, s), i.promise()
                }), e.when.apply(e, l.get()).done(function () {
                    a(), e.each(arguments, function () {
                        var t = this.el;
                        e.each(this.diff, function (e) {
                            t.css(e, "")
                        })
                    }), h.complete.call(o[0])
                })
            })
        }, e.fn.extend({
            addClass: function (t) {
                return function (i, s, n, a) {
                    return s ? e.effects.animateClass.call(this, {add: i}, s, n, a) : t.apply(this, arguments)
                }
            }(e.fn.addClass), removeClass: function (t) {
                return function (i, s, n, a) {
                    return arguments.length > 1 ? e.effects.animateClass.call(this, {remove: i}, s, n, a) : t.apply(this, arguments)
                }
            }(e.fn.removeClass), toggleClass: function (t) {
                return function (i, s, n, a, o) {
                    return "boolean" == typeof s || void 0 === s ? n ? e.effects.animateClass.call(this, s ? {add: i} : {remove: i}, n, a, o) : t.apply(this, arguments) : e.effects.animateClass.call(this, {toggle: i}, s, n, a)
                }
            }(e.fn.toggleClass), switchClass: function (t, i, s, n, a) {
                return e.effects.animateClass.call(this, {add: i, remove: t}, s, n, a)
            }
        })
    }(), function () {
        function t(t, i, s, n) {
            return e.isPlainObject(t) && (i = t, t = t.effect), t = {effect: t}, null == i && (i = {}), e.isFunction(i) && (n = i, s = null, i = {}), ("number" == typeof i || e.fx.speeds[i]) && (n = s, s = i, i = {}), e.isFunction(s) && (n = s, s = null), i && e.extend(t, i), s = s || i.duration, t.duration = e.fx.off ? 0 : "number" == typeof s ? s : s in e.fx.speeds ? e.fx.speeds[s] : e.fx.speeds._default, t.complete = n || i.complete, t
        }

        function i(t) {
            return !t || "number" == typeof t || e.fx.speeds[t] ? !0 : "string" != typeof t || e.effects.effect[t] ? e.isFunction(t) ? !0 : "object" != typeof t || t.effect ? !1 : !0 : !0
        }

        function s(e, t) {
            var i = t.outerWidth(), s = t.outerHeight(), n = /^rect\((-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto)\)$/, a = n.exec(e) || ["", 0, i, s, 0];
            return {
                top: parseFloat(a[1]) || 0,
                right: "auto" === a[2] ? i : parseFloat(a[2]),
                bottom: "auto" === a[3] ? s : parseFloat(a[3]),
                left: parseFloat(a[4]) || 0
            }
        }

        e.expr && e.expr.filters && e.expr.filters.animated && (e.expr.filters.animated = function (t) {
            return function (i) {
                return !!e(i).data(g) || t(i)
            }
        }(e.expr.filters.animated)), e.uiBackCompat !== !1 && e.extend(e.effects, {
            save: function (e, t) {
                for (var i = 0, s = t.length; s > i; i++)null !== t[i] && e.data(f + t[i], e[0].style[t[i]])
            }, restore: function (e, t) {
                for (var i, s = 0, n = t.length; n > s; s++)null !== t[s] && (i = e.data(f + t[s]), e.css(t[s], i))
            }, setMode: function (e, t) {
                return "toggle" === t && (t = e.is(":hidden") ? "show" : "hide"), t
            }, createWrapper: function (t) {
                if (t.parent().is(".ui-effects-wrapper"))return t.parent();
                var i = {
                    width: t.outerWidth(!0),
                    height: t.outerHeight(!0),
                    "float": t.css("float")
                }, s = e("<div></div>").addClass("ui-effects-wrapper").css({
                    fontSize: "100%",
                    background: "transparent",
                    border: "none",
                    margin: 0,
                    padding: 0
                }), n = {width: t.width(), height: t.height()}, a = document.activeElement;
                try {
                    a.id
                } catch (o) {
                    a = document.body
                }
                return t.wrap(s), (t[0] === a || e.contains(t[0], a)) && e(a).trigger("focus"), s = t.parent(), "static" === t.css("position") ? (s.css({position: "relative"}), t.css({position: "relative"})) : (e.extend(i, {
                        position: t.css("position"),
                        zIndex: t.css("z-index")
                    }), e.each(["top", "left", "bottom", "right"], function (e, s) {
                        i[s] = t.css(s), isNaN(parseInt(i[s], 10)) && (i[s] = "auto")
                    }), t.css({
                        position: "relative",
                        top: 0,
                        left: 0,
                        right: "auto",
                        bottom: "auto"
                    })), t.css(n), s.css(i).show()
            }, removeWrapper: function (t) {
                var i = document.activeElement;
                return t.parent().is(".ui-effects-wrapper") && (t.parent().replaceWith(t), (t[0] === i || e.contains(t[0], i)) && e(i).trigger("focus")), t
            }
        }), e.extend(e.effects, {
            version: "1.12.1", define: function (t, i, s) {
                return s || (s = i, i = "effect"), e.effects.effect[t] = s, e.effects.effect[t].mode = i, s
            }, scaledDimensions: function (e, t, i) {
                if (0 === t)return {height: 0, width: 0, outerHeight: 0, outerWidth: 0};
                var s = "horizontal" !== i ? (t || 100) / 100 : 1, n = "vertical" !== i ? (t || 100) / 100 : 1;
                return {
                    height: e.height() * n,
                    width: e.width() * s,
                    outerHeight: e.outerHeight() * n,
                    outerWidth: e.outerWidth() * s
                }
            }, clipToBox: function (e) {
                return {
                    width: e.clip.right - e.clip.left,
                    height: e.clip.bottom - e.clip.top,
                    left: e.clip.left,
                    top: e.clip.top
                }
            }, unshift: function (e, t, i) {
                var s = e.queue();
                t > 1 && s.splice.apply(s, [1, 0].concat(s.splice(t, i))), e.dequeue()
            }, saveStyle: function (e) {
                e.data(m, e[0].style.cssText)
            }, restoreStyle: function (e) {
                e[0].style.cssText = e.data(m) || "", e.removeData(m)
            }, mode: function (e, t) {
                var i = e.is(":hidden");
                return "toggle" === t && (t = i ? "show" : "hide"), (i ? "hide" === t : "show" === t) && (t = "none"), t
            }, getBaseline: function (e, t) {
                var i, s;
                switch (e[0]) {
                    case"top":
                        i = 0;
                        break;
                    case"middle":
                        i = .5;
                        break;
                    case"bottom":
                        i = 1;
                        break;
                    default:
                        i = e[0] / t.height
                }
                switch (e[1]) {
                    case"left":
                        s = 0;
                        break;
                    case"center":
                        s = .5;
                        break;
                    case"right":
                        s = 1;
                        break;
                    default:
                        s = e[1] / t.width
                }
                return {x: s, y: i}
            }, createPlaceholder: function (t) {
                var i, s = t.css("position"), n = t.position();
                return t.css({
                    marginTop: t.css("marginTop"),
                    marginBottom: t.css("marginBottom"),
                    marginLeft: t.css("marginLeft"),
                    marginRight: t.css("marginRight")
                }).outerWidth(t.outerWidth()).outerHeight(t.outerHeight()), /^(static|relative)/.test(s) && (s = "absolute", i = e("<" + t[0].nodeName + ">").insertAfter(t).css({
                    display: /^(inline|ruby)/.test(t.css("display")) ? "inline-block" : "block",
                    visibility: "hidden",
                    marginTop: t.css("marginTop"),
                    marginBottom: t.css("marginBottom"),
                    marginLeft: t.css("marginLeft"),
                    marginRight: t.css("marginRight"),
                    "float": t.css("float")
                }).outerWidth(t.outerWidth()).outerHeight(t.outerHeight()).addClass("ui-effects-placeholder"), t.data(f + "placeholder", i)), t.css({
                    position: s,
                    left: n.left,
                    top: n.top
                }), i
            }, removePlaceholder: function (e) {
                var t = f + "placeholder", i = e.data(t);
                i && (i.remove(), e.removeData(t))
            }, cleanUp: function (t) {
                e.effects.restoreStyle(t), e.effects.removePlaceholder(t)
            }, setTransition: function (t, i, s, n) {
                return n = n || {}, e.each(i, function (e, i) {
                    var a = t.cssUnit(i);
                    a[0] > 0 && (n[i] = a[0] * s + a[1])
                }), n
            }
        }), e.fn.extend({
            effect: function () {
                function i(t) {
                    function i() {
                        r.removeData(g), e.effects.cleanUp(r), "hide" === s.mode && r.hide(), o()
                    }

                    function o() {
                        e.isFunction(h) && h.call(r[0]), e.isFunction(t) && t()
                    }

                    var r = e(this);
                    s.mode = u.shift(), e.uiBackCompat === !1 || a ? "none" === s.mode ? (r[l](), o()) : n.call(r[0], s, i) : (r.is(":hidden") ? "hide" === l : "show" === l) ? (r[l](), o()) : n.call(r[0], s, o)
                }

                var s = t.apply(this, arguments), n = e.effects.effect[s.effect], a = n.mode, o = s.queue, r = o || "fx", h = s.complete, l = s.mode, u = [], c = function (t) {
                    var i = e(this), s = e.effects.mode(i, l) || a;
                    i.data(g, !0), u.push(s), a && ("show" === s || s === a && "hide" === s) && i.show(), a && "none" === s || e.effects.saveStyle(i), e.isFunction(t) && t()
                };
                return e.fx.off || !n ? l ? this[l](s.duration, h) : this.each(function () {
                            h && h.call(this)
                        }) : o === !1 ? this.each(c).each(i) : this.queue(r, c).queue(r, i)
            }, show: function (e) {
                return function (s) {
                    if (i(s))return e.apply(this, arguments);
                    var n = t.apply(this, arguments);
                    return n.mode = "show", this.effect.call(this, n)
                }
            }(e.fn.show), hide: function (e) {
                return function (s) {
                    if (i(s))return e.apply(this, arguments);
                    var n = t.apply(this, arguments);
                    return n.mode = "hide", this.effect.call(this, n)
                }
            }(e.fn.hide), toggle: function (e) {
                return function (s) {
                    if (i(s) || "boolean" == typeof s)return e.apply(this, arguments);
                    var n = t.apply(this, arguments);
                    return n.mode = "toggle", this.effect.call(this, n)
                }
            }(e.fn.toggle), cssUnit: function (t) {
                var i = this.css(t), s = [];
                return e.each(["em", "px", "%", "pt"], function (e, t) {
                    i.indexOf(t) > 0 && (s = [parseFloat(i), t])
                }), s
            }, cssClip: function (e) {
                return e ? this.css("clip", "rect(" + e.top + "px " + e.right + "px " + e.bottom + "px " + e.left + "px)") : s(this.css("clip"), this)
            }, transfer: function (t, i) {
                var s = e(this), n = e(t.to), a = "fixed" === n.css("position"), o = e("body"), r = a ? o.scrollTop() : 0, h = a ? o.scrollLeft() : 0, l = n.offset(), u = {
                    top: l.top - r,
                    left: l.left - h,
                    height: n.innerHeight(),
                    width: n.innerWidth()
                }, c = s.offset(), d = e("<div class='ui-effects-transfer'></div>").appendTo("body").addClass(t.className).css({
                    top: c.top - r,
                    left: c.left - h,
                    height: s.innerHeight(),
                    width: s.innerWidth(),
                    position: a ? "fixed" : "absolute"
                }).animate(u, t.duration, t.easing, function () {
                    d.remove(), e.isFunction(i) && i()
                })
            }
        }), e.fx.step.clip = function (t) {
            t.clipInit || (t.start = e(t.elem).cssClip(), "string" == typeof t.end && (t.end = s(t.end, t.elem)), t.clipInit = !0), e(t.elem).cssClip({
                top: t.pos * (t.end.top - t.start.top) + t.start.top,
                right: t.pos * (t.end.right - t.start.right) + t.start.right,
                bottom: t.pos * (t.end.bottom - t.start.bottom) + t.start.bottom,
                left: t.pos * (t.end.left - t.start.left) + t.start.left
            })
        }
    }(), function () {
        var t = {};
        e.each(["Quad", "Cubic", "Quart", "Quint", "Expo"], function (e, i) {
            t[i] = function (t) {
                return Math.pow(t, e + 2)
            }
        }), e.extend(t, {
            Sine: function (e) {
                return 1 - Math.cos(e * Math.PI / 2)
            }, Circ: function (e) {
                return 1 - Math.sqrt(1 - e * e)
            }, Elastic: function (e) {
                return 0 === e || 1 === e ? e : -Math.pow(2, 8 * (e - 1)) * Math.sin((80 * (e - 1) - 7.5) * Math.PI / 15)
            }, Back: function (e) {
                return e * e * (3 * e - 2)
            }, Bounce: function (e) {
                for (var t, i = 4; ((t = Math.pow(2, --i)) - 1) / 11 > e;);
                return 1 / Math.pow(4, 3 - i) - 7.5625 * Math.pow((3 * t - 2) / 22 - e, 2)
            }
        }), e.each(t, function (t, i) {
            e.easing["easeIn" + t] = i, e.easing["easeOut" + t] = function (e) {
                return 1 - i(1 - e)
            }, e.easing["easeInOut" + t] = function (e) {
                return .5 > e ? i(2 * e) / 2 : 1 - i(-2 * e + 2) / 2
            }
        })
    }();
    var _ = e.effects;
    e.effects.define("blind", "hide", function (t, i) {
        var s = {
            up: ["bottom", "top"],
            vertical: ["bottom", "top"],
            down: ["top", "bottom"],
            left: ["right", "left"],
            horizontal: ["right", "left"],
            right: ["left", "right"]
        }, n = e(this), a = t.direction || "up", o = n.cssClip(), r = {clip: e.extend({}, o)}, h = e.effects.createPlaceholder(n);
        r.clip[s[a][0]] = r.clip[s[a][1]], "show" === t.mode && (n.cssClip(r.clip), h && h.css(e.effects.clipToBox(r)), r.clip = o), h && h.animate(e.effects.clipToBox(r), t.duration, t.easing), n.animate(r, {
            queue: !1,
            duration: t.duration,
            easing: t.easing,
            complete: i
        })
    }), e.effects.define("bounce", function (t, i) {
        var s, n, a, o = e(this), r = t.mode, h = "hide" === r, l = "show" === r, u = t.direction || "up", c = t.distance, d = t.times || 5, p = 2 * d + (l || h ? 1 : 0), f = t.duration / p, m = t.easing, g = "up" === u || "down" === u ? "top" : "left", v = "up" === u || "left" === u, _ = 0, b = o.queue().length;
        for (e.effects.createPlaceholder(o), a = o.css(g), c || (c = o["top" === g ? "outerHeight" : "outerWidth"]() / 3), l && (n = {opacity: 1}, n[g] = a, o.css("opacity", 0).css(g, v ? 2 * -c : 2 * c).animate(n, f, m)), h && (c /= Math.pow(2, d - 1)), n = {}, n[g] = a; d > _; _++)s = {}, s[g] = (v ? "-=" : "+=") + c, o.animate(s, f, m).animate(n, f, m), c = h ? 2 * c : c / 2;
        h && (s = {opacity: 0}, s[g] = (v ? "-=" : "+=") + c, o.animate(s, f, m)), o.queue(i), e.effects.unshift(o, b, p + 1)
    }), e.effects.define("clip", "hide", function (t, i) {
        var s, n = {}, a = e(this), o = t.direction || "vertical", r = "both" === o, h = r || "horizontal" === o, l = r || "vertical" === o;
        s = a.cssClip(), n.clip = {
            top: l ? (s.bottom - s.top) / 2 : s.top,
            right: h ? (s.right - s.left) / 2 : s.right,
            bottom: l ? (s.bottom - s.top) / 2 : s.bottom,
            left: h ? (s.right - s.left) / 2 : s.left
        }, e.effects.createPlaceholder(a), "show" === t.mode && (a.cssClip(n.clip), n.clip = s), a.animate(n, {
            queue: !1,
            duration: t.duration,
            easing: t.easing,
            complete: i
        })
    }), e.effects.define("drop", "hide", function (t, i) {
        var s, n = e(this), a = t.mode, o = "show" === a, r = t.direction || "left", h = "up" === r || "down" === r ? "top" : "left", l = "up" === r || "left" === r ? "-=" : "+=", u = "+=" === l ? "-=" : "+=", c = {opacity: 0};
        e.effects.createPlaceholder(n), s = t.distance || n["top" === h ? "outerHeight" : "outerWidth"](!0) / 2, c[h] = l + s, o && (n.css(c), c[h] = u + s, c.opacity = 1), n.animate(c, {
            queue: !1,
            duration: t.duration,
            easing: t.easing,
            complete: i
        })
    }), e.effects.define("explode", "hide", function (t, i) {
        function s() {
            b.push(this), b.length === c * d && n()
        }

        function n() {
            p.css({visibility: "visible"}), e(b).remove(), i()
        }

        var a, o, r, h, l, u, c = t.pieces ? Math.round(Math.sqrt(t.pieces)) : 3, d = c, p = e(this), f = t.mode, m = "show" === f, g = p.show().css("visibility", "hidden").offset(), v = Math.ceil(p.outerWidth() / d), _ = Math.ceil(p.outerHeight() / c), b = [];
        for (a = 0; c > a; a++)for (h = g.top + a * _, u = a - (c - 1) / 2, o = 0; d > o; o++)r = g.left + o * v, l = o - (d - 1) / 2, p.clone().appendTo("body").wrap("<div></div>").css({
            position: "absolute",
            visibility: "visible",
            left: -o * v,
            top: -a * _
        }).parent().addClass("ui-effects-explode").css({
            position: "absolute",
            overflow: "hidden",
            width: v,
            height: _,
            left: r + (m ? l * v : 0),
            top: h + (m ? u * _ : 0),
            opacity: m ? 0 : 1
        }).animate({
            left: r + (m ? 0 : l * v),
            top: h + (m ? 0 : u * _),
            opacity: m ? 1 : 0
        }, t.duration || 500, t.easing, s)
    }), e.effects.define("fade", "toggle", function (t, i) {
        var s = "show" === t.mode;
        e(this).css("opacity", s ? 0 : 1).animate({opacity: s ? 1 : 0}, {
            queue: !1,
            duration: t.duration,
            easing: t.easing,
            complete: i
        })
    }), e.effects.define("fold", "hide", function (t, i) {
        var s = e(this), n = t.mode, a = "show" === n, o = "hide" === n, r = t.size || 15, h = /([0-9]+)%/.exec(r), l = !!t.horizFirst, u = l ? ["right", "bottom"] : ["bottom", "right"], c = t.duration / 2, d = e.effects.createPlaceholder(s), p = s.cssClip(), f = {clip: e.extend({}, p)}, m = {clip: e.extend({}, p)}, g = [p[u[0]], p[u[1]]], v = s.queue().length;
        h && (r = parseInt(h[1], 10) / 100 * g[o ? 0 : 1]), f.clip[u[0]] = r, m.clip[u[0]] = r, m.clip[u[1]] = 0, a && (s.cssClip(m.clip), d && d.css(e.effects.clipToBox(m)), m.clip = p), s.queue(function (i) {
            d && d.animate(e.effects.clipToBox(f), c, t.easing).animate(e.effects.clipToBox(m), c, t.easing), i()
        }).animate(f, c, t.easing).animate(m, c, t.easing).queue(i), e.effects.unshift(s, v, 4)
    }), e.effects.define("highlight", "show", function (t, i) {
        var s = e(this), n = {backgroundColor: s.css("backgroundColor")};
        "hide" === t.mode && (n.opacity = 0), e.effects.saveStyle(s), s.css({
            backgroundImage: "none",
            backgroundColor: t.color || "#ffff99"
        }).animate(n, {queue: !1, duration: t.duration, easing: t.easing, complete: i})
    }), e.effects.define("size", function (t, i) {
        var s, n, a, o = e(this), r = ["fontSize"], h = ["borderTopWidth", "borderBottomWidth", "paddingTop", "paddingBottom"], l = ["borderLeftWidth", "borderRightWidth", "paddingLeft", "paddingRight"], u = t.mode, c = "effect" !== u, d = t.scale || "both", p = t.origin || ["middle", "center"], f = o.css("position"), m = o.position(), g = e.effects.scaledDimensions(o), v = t.from || g, _ = t.to || e.effects.scaledDimensions(o, 0);
        e.effects.createPlaceholder(o), "show" === u && (a = v, v = _, _ = a), n = {
            from: {
                y: v.height / g.height,
                x: v.width / g.width
            }, to: {y: _.height / g.height, x: _.width / g.width}
        }, ("box" === d || "both" === d) && (n.from.y !== n.to.y && (v = e.effects.setTransition(o, h, n.from.y, v), _ = e.effects.setTransition(o, h, n.to.y, _)), n.from.x !== n.to.x && (v = e.effects.setTransition(o, l, n.from.x, v), _ = e.effects.setTransition(o, l, n.to.x, _))), ("content" === d || "both" === d) && n.from.y !== n.to.y && (v = e.effects.setTransition(o, r, n.from.y, v), _ = e.effects.setTransition(o, r, n.to.y, _)), p && (s = e.effects.getBaseline(p, g), v.top = (g.outerHeight - v.outerHeight) * s.y + m.top, v.left = (g.outerWidth - v.outerWidth) * s.x + m.left, _.top = (g.outerHeight - _.outerHeight) * s.y + m.top, _.left = (g.outerWidth - _.outerWidth) * s.x + m.left), o.css(v), ("content" === d || "both" === d) && (h = h.concat(["marginTop", "marginBottom"]).concat(r), l = l.concat(["marginLeft", "marginRight"]), o.find("*[width]").each(function () {
            var i = e(this), s = e.effects.scaledDimensions(i), a = {
                height: s.height * n.from.y,
                width: s.width * n.from.x,
                outerHeight: s.outerHeight * n.from.y,
                outerWidth: s.outerWidth * n.from.x
            }, o = {
                height: s.height * n.to.y,
                width: s.width * n.to.x,
                outerHeight: s.height * n.to.y,
                outerWidth: s.width * n.to.x
            };
            n.from.y !== n.to.y && (a = e.effects.setTransition(i, h, n.from.y, a), o = e.effects.setTransition(i, h, n.to.y, o)), n.from.x !== n.to.x && (a = e.effects.setTransition(i, l, n.from.x, a), o = e.effects.setTransition(i, l, n.to.x, o)), c && e.effects.saveStyle(i), i.css(a), i.animate(o, t.duration, t.easing, function () {
                c && e.effects.restoreStyle(i)
            })
        })), o.animate(_, {
            queue: !1, duration: t.duration, easing: t.easing, complete: function () {
                var t = o.offset();
                0 === _.opacity && o.css("opacity", v.opacity), c || (o.css("position", "static" === f ? "relative" : f).offset(t), e.effects.saveStyle(o)), i()
            }
        })
    }), e.effects.define("scale", function (t, i) {
        var s = e(this), n = t.mode, a = parseInt(t.percent, 10) || (0 === parseInt(t.percent, 10) ? 0 : "effect" !== n ? 0 : 100), o = e.extend(!0, {
            from: e.effects.scaledDimensions(s),
            to: e.effects.scaledDimensions(s, a, t.direction || "both"),
            origin: t.origin || ["middle", "center"]
        }, t);
        t.fade && (o.from.opacity = 1, o.to.opacity = 0), e.effects.effect.size.call(this, o, i)
    }), e.effects.define("puff", "hide", function (t, i) {
        var s = e.extend(!0, {}, t, {fade: !0, percent: parseInt(t.percent, 10) || 150});
        e.effects.effect.scale.call(this, s, i)
    }), e.effects.define("pulsate", "show", function (t, i) {
        var s = e(this), n = t.mode, a = "show" === n, o = "hide" === n, r = a || o, h = 2 * (t.times || 5) + (r ? 1 : 0), l = t.duration / h, u = 0, c = 1, d = s.queue().length;
        for ((a || !s.is(":visible")) && (s.css("opacity", 0).show(), u = 1); h > c; c++)s.animate({opacity: u}, l, t.easing), u = 1 - u;
        s.animate({opacity: u}, l, t.easing), s.queue(i), e.effects.unshift(s, d, h + 1)
    }), e.effects.define("shake", function (t, i) {
        var s = 1, n = e(this), a = t.direction || "left", o = t.distance || 20, r = t.times || 3, h = 2 * r + 1, l = Math.round(t.duration / h), u = "up" === a || "down" === a ? "top" : "left", c = "up" === a || "left" === a, d = {}, p = {}, f = {}, m = n.queue().length;
        for (e.effects.createPlaceholder(n), d[u] = (c ? "-=" : "+=") + o, p[u] = (c ? "+=" : "-=") + 2 * o, f[u] = (c ? "-=" : "+=") + 2 * o, n.animate(d, l, t.easing); r > s; s++)n.animate(p, l, t.easing).animate(f, l, t.easing);
        n.animate(p, l, t.easing).animate(d, l / 2, t.easing).queue(i), e.effects.unshift(n, m, h + 1)
    }), e.effects.define("slide", "show", function (t, i) {
        var s, n, a = e(this), o = {
            up: ["bottom", "top"],
            down: ["top", "bottom"],
            left: ["right", "left"],
            right: ["left", "right"]
        }, r = t.mode, h = t.direction || "left", l = "up" === h || "down" === h ? "top" : "left", u = "up" === h || "left" === h, c = t.distance || a["top" === l ? "outerHeight" : "outerWidth"](!0), d = {};
        e.effects.createPlaceholder(a), s = a.cssClip(), n = a.position()[l], d[l] = (u ? -1 : 1) * c + n, d.clip = a.cssClip(), d.clip[o[h][1]] = d.clip[o[h][0]], "show" === r && (a.cssClip(d.clip), a.css(l, d[l]), d.clip = s, d[l] = n), a.animate(d, {
            queue: !1,
            duration: t.duration,
            easing: t.easing,
            complete: i
        })
    });
    var _;
    e.uiBackCompat !== !1 && (_ = e.effects.define("transfer", function (t, i) {
        e(this).transfer(t, i)
    }))
});

/* == jquery mousewheel plugin == Version: 3.1.13, License: MIT License (MIT) */
!function(a){"function"==typeof define&&define.amd?define(["jquery"],a):"object"==typeof exports?module.exports=a:a(jQuery)}(function(a){function b(b){var g=b||window.event,h=i.call(arguments,1),j=0,l=0,m=0,n=0,o=0,p=0;if(b=a.event.fix(g),b.type="mousewheel","detail"in g&&(m=-1*g.detail),"wheelDelta"in g&&(m=g.wheelDelta),"wheelDeltaY"in g&&(m=g.wheelDeltaY),"wheelDeltaX"in g&&(l=-1*g.wheelDeltaX),"axis"in g&&g.axis===g.HORIZONTAL_AXIS&&(l=-1*m,m=0),j=0===m?l:m,"deltaY"in g&&(m=-1*g.deltaY,j=m),"deltaX"in g&&(l=g.deltaX,0===m&&(j=-1*l)),0!==m||0!==l){if(1===g.deltaMode){var q=a.data(this,"mousewheel-line-height");j*=q,m*=q,l*=q}else if(2===g.deltaMode){var r=a.data(this,"mousewheel-page-height");j*=r,m*=r,l*=r}if(n=Math.max(Math.abs(m),Math.abs(l)),(!f||f>n)&&(f=n,d(g,n)&&(f/=40)),d(g,n)&&(j/=40,l/=40,m/=40),j=Math[j>=1?"floor":"ceil"](j/f),l=Math[l>=1?"floor":"ceil"](l/f),m=Math[m>=1?"floor":"ceil"](m/f),k.settings.normalizeOffset&&this.getBoundingClientRect){var s=this.getBoundingClientRect();o=b.clientX-s.left,p=b.clientY-s.top}return b.deltaX=l,b.deltaY=m,b.deltaFactor=f,b.offsetX=o,b.offsetY=p,b.deltaMode=0,h.unshift(b,j,l,m),e&&clearTimeout(e),e=setTimeout(c,200),(a.event.dispatch||a.event.handle).apply(this,h)}}function c(){f=null}function d(a,b){return k.settings.adjustOldDeltas&&"mousewheel"===a.type&&b%120===0}var e,f,g=["wheel","mousewheel","DOMMouseScroll","MozMousePixelScroll"],h="onwheel"in document||document.documentMode>=9?["wheel"]:["mousewheel","DomMouseScroll","MozMousePixelScroll"],i=Array.prototype.slice;if(a.event.fixHooks)for(var j=g.length;j;)a.event.fixHooks[g[--j]]=a.event.mouseHooks;var k=a.event.special.mousewheel={version:"3.1.12",setup:function(){if(this.addEventListener)for(var c=h.length;c;)this.addEventListener(h[--c],b,!1);else this.onmousewheel=b;a.data(this,"mousewheel-line-height",k.getLineHeight(this)),a.data(this,"mousewheel-page-height",k.getPageHeight(this))},teardown:function(){if(this.removeEventListener)for(var c=h.length;c;)this.removeEventListener(h[--c],b,!1);else this.onmousewheel=null;a.removeData(this,"mousewheel-line-height"),a.removeData(this,"mousewheel-page-height")},getLineHeight:function(b){var c=a(b),d=c["offsetParent"in a.fn?"offsetParent":"parent"]();return d.length||(d=a("body")),parseInt(d.css("fontSize"),10)||parseInt(c.css("fontSize"),10)||16},getPageHeight:function(b){return a(b).height()},settings:{adjustOldDeltas:!0,normalizeOffset:!0}};a.fn.extend({mousewheel:function(a){return a?this.bind("mousewheel",a):this.trigger("mousewheel")},unmousewheel:function(a){return this.unbind("mousewheel",a)}})});!function(a){"function"==typeof define&&define.amd?define(["jquery"],a):"object"==typeof exports?module.exports=a:a(jQuery)}(function(a){function b(b){var g=b||window.event,h=i.call(arguments,1),j=0,l=0,m=0,n=0,o=0,p=0;if(b=a.event.fix(g),b.type="mousewheel","detail"in g&&(m=-1*g.detail),"wheelDelta"in g&&(m=g.wheelDelta),"wheelDeltaY"in g&&(m=g.wheelDeltaY),"wheelDeltaX"in g&&(l=-1*g.wheelDeltaX),"axis"in g&&g.axis===g.HORIZONTAL_AXIS&&(l=-1*m,m=0),j=0===m?l:m,"deltaY"in g&&(m=-1*g.deltaY,j=m),"deltaX"in g&&(l=g.deltaX,0===m&&(j=-1*l)),0!==m||0!==l){if(1===g.deltaMode){var q=a.data(this,"mousewheel-line-height");j*=q,m*=q,l*=q}else if(2===g.deltaMode){var r=a.data(this,"mousewheel-page-height");j*=r,m*=r,l*=r}if(n=Math.max(Math.abs(m),Math.abs(l)),(!f||f>n)&&(f=n,d(g,n)&&(f/=40)),d(g,n)&&(j/=40,l/=40,m/=40),j=Math[j>=1?"floor":"ceil"](j/f),l=Math[l>=1?"floor":"ceil"](l/f),m=Math[m>=1?"floor":"ceil"](m/f),k.settings.normalizeOffset&&this.getBoundingClientRect){var s=this.getBoundingClientRect();o=b.clientX-s.left,p=b.clientY-s.top}return b.deltaX=l,b.deltaY=m,b.deltaFactor=f,b.offsetX=o,b.offsetY=p,b.deltaMode=0,h.unshift(b,j,l,m),e&&clearTimeout(e),e=setTimeout(c,200),(a.event.dispatch||a.event.handle).apply(this,h)}}function c(){f=null}function d(a,b){return k.settings.adjustOldDeltas&&"mousewheel"===a.type&&b%120===0}var e,f,g=["wheel","mousewheel","DOMMouseScroll","MozMousePixelScroll"],h="onwheel"in document||document.documentMode>=9?["wheel"]:["mousewheel","DomMouseScroll","MozMousePixelScroll"],i=Array.prototype.slice;if(a.event.fixHooks)for(var j=g.length;j;)a.event.fixHooks[g[--j]]=a.event.mouseHooks;var k=a.event.special.mousewheel={version:"3.1.12",setup:function(){if(this.addEventListener)for(var c=h.length;c;)this.addEventListener(h[--c],b,!1);else this.onmousewheel=b;a.data(this,"mousewheel-line-height",k.getLineHeight(this)),a.data(this,"mousewheel-page-height",k.getPageHeight(this))},teardown:function(){if(this.removeEventListener)for(var c=h.length;c;)this.removeEventListener(h[--c],b,!1);else this.onmousewheel=null;a.removeData(this,"mousewheel-line-height"),a.removeData(this,"mousewheel-page-height")},getLineHeight:function(b){var c=a(b),d=c["offsetParent"in a.fn?"offsetParent":"parent"]();return d.length||(d=a("body")),parseInt(d.css("fontSize"),10)||parseInt(c.css("fontSize"),10)||16},getPageHeight:function(b){return a(b).height()},settings:{adjustOldDeltas:!0,normalizeOffset:!0}};a.fn.extend({mousewheel:function(a){return a?this.bind("mousewheel",a):this.trigger("mousewheel")},unmousewheel:function(a){return this.unbind("mousewheel",a)}})});
/* == malihu jquery custom scrollbar plugin == Version: 3.1.5, License: MIT License (MIT) */
!function(e){"function"==typeof define&&define.amd?define(["jquery"],e):"undefined"!=typeof module&&module.exports?module.exports=e:e(jQuery,window,document)}(function(e){!function(t){var o="function"==typeof define&&define.amd,a="undefined"!=typeof module&&module.exports,n="https:"==document.location.protocol?"https:":"http:",i="cdnjs.cloudflare.com/ajax/libs/jquery-mousewheel/3.1.13/jquery.mousewheel.min.js";o||(a?require("jquery-mousewheel")(e):e.event.special.mousewheel||e("head").append(decodeURI("%3Cscript src="+n+"//"+i+"%3E%3C/script%3E"))),t()}(function(){var t,o="mCustomScrollbar",a="mCS",n=".mCustomScrollbar",i={setTop:0,setLeft:0,axis:"y",scrollbarPosition:"inside",scrollInertia:950,autoDraggerLength:!0,alwaysShowScrollbar:0,snapOffset:0,mouseWheel:{enable:!0,scrollAmount:"auto",axis:"y",deltaFactor:"auto",disableOver:["select","option","keygen","datalist","textarea"]},scrollButtons:{scrollType:"stepless",scrollAmount:"auto"},keyboard:{enable:!0,scrollType:"stepless",scrollAmount:"auto"},contentTouchScroll:25,documentTouchScroll:!0,advanced:{autoScrollOnFocus:"input,textarea,select,button,datalist,keygen,a[tabindex],area,object,[contenteditable='true']",updateOnContentResize:!0,updateOnImageLoad:"auto",autoUpdateTimeout:60},theme:"light",callbacks:{onTotalScrollOffset:0,onTotalScrollBackOffset:0,alwaysTriggerOffsets:!0}},r=0,l={},s=window.attachEvent&&!window.addEventListener?1:0,c=!1,d=["mCSB_dragger_onDrag","mCSB_scrollTools_onDrag","mCS_img_loaded","mCS_disabled","mCS_destroyed","mCS_no_scrollbar","mCS-autoHide","mCS-dir-rtl","mCS_no_scrollbar_y","mCS_no_scrollbar_x","mCS_y_hidden","mCS_x_hidden","mCSB_draggerContainer","mCSB_buttonUp","mCSB_buttonDown","mCSB_buttonLeft","mCSB_buttonRight"],u={init:function(t){var t=e.extend(!0,{},i,t),o=f.call(this);if(t.live){var s=t.liveSelector||this.selector||n,c=e(s);if("off"===t.live)return void m(s);l[s]=setTimeout(function(){c.mCustomScrollbar(t),"once"===t.live&&c.length&&m(s)},500)}else m(s);return t.setWidth=t.set_width?t.set_width:t.setWidth,t.setHeight=t.set_height?t.set_height:t.setHeight,t.axis=t.horizontalScroll?"x":p(t.axis),t.scrollInertia=t.scrollInertia>0&&t.scrollInertia<17?17:t.scrollInertia,"object"!=typeof t.mouseWheel&&1==t.mouseWheel&&(t.mouseWheel={enable:!0,scrollAmount:"auto",axis:"y",preventDefault:!1,deltaFactor:"auto",normalizeDelta:!1,invert:!1}),t.mouseWheel.scrollAmount=t.mouseWheelPixels?t.mouseWheelPixels:t.mouseWheel.scrollAmount,t.mouseWheel.normalizeDelta=t.advanced.normalizeMouseWheelDelta?t.advanced.normalizeMouseWheelDelta:t.mouseWheel.normalizeDelta,t.scrollButtons.scrollType=g(t.scrollButtons.scrollType),h(t),e(o).each(function(){var o=e(this);if(!o.data(a)){o.data(a,{idx:++r,opt:t,scrollRatio:{y:null,x:null},overflowed:null,contentReset:{y:null,x:null},bindEvents:!1,tweenRunning:!1,sequential:{},langDir:o.css("direction"),cbOffsets:null,trigger:null,poll:{size:{o:0,n:0},img:{o:0,n:0},change:{o:0,n:0}}});var n=o.data(a),i=n.opt,l=o.data("mcs-axis"),s=o.data("mcs-scrollbar-position"),c=o.data("mcs-theme");l&&(i.axis=l),s&&(i.scrollbarPosition=s),c&&(i.theme=c,h(i)),v.call(this),n&&i.callbacks.onCreate&&"function"==typeof i.callbacks.onCreate&&i.callbacks.onCreate.call(this),e("#mCSB_"+n.idx+"_container img:not(."+d[2]+")").addClass(d[2]),u.update.call(null,o)}})},update:function(t,o){var n=t||f.call(this);return e(n).each(function(){var t=e(this);if(t.data(a)){var n=t.data(a),i=n.opt,r=e("#mCSB_"+n.idx+"_container"),l=e("#mCSB_"+n.idx),s=[e("#mCSB_"+n.idx+"_dragger_vertical"),e("#mCSB_"+n.idx+"_dragger_horizontal")];if(!r.length)return;n.tweenRunning&&Q(t),o&&n&&i.callbacks.onBeforeUpdate&&"function"==typeof i.callbacks.onBeforeUpdate&&i.callbacks.onBeforeUpdate.call(this),t.hasClass(d[3])&&t.removeClass(d[3]),t.hasClass(d[4])&&t.removeClass(d[4]),l.css("max-height","none"),l.height()!==t.height()&&l.css("max-height",t.height()),_.call(this),"y"===i.axis||i.advanced.autoExpandHorizontalScroll||r.css("width",x(r)),n.overflowed=y.call(this),M.call(this),i.autoDraggerLength&&S.call(this),b.call(this),T.call(this);var c=[Math.abs(r[0].offsetTop),Math.abs(r[0].offsetLeft)];"x"!==i.axis&&(n.overflowed[0]?s[0].height()>s[0].parent().height()?B.call(this):(G(t,c[0].toString(),{dir:"y",dur:0,overwrite:"none"}),n.contentReset.y=null):(B.call(this),"y"===i.axis?k.call(this):"yx"===i.axis&&n.overflowed[1]&&G(t,c[1].toString(),{dir:"x",dur:0,overwrite:"none"}))),"y"!==i.axis&&(n.overflowed[1]?s[1].width()>s[1].parent().width()?B.call(this):(G(t,c[1].toString(),{dir:"x",dur:0,overwrite:"none"}),n.contentReset.x=null):(B.call(this),"x"===i.axis?k.call(this):"yx"===i.axis&&n.overflowed[0]&&G(t,c[0].toString(),{dir:"y",dur:0,overwrite:"none"}))),o&&n&&(2===o&&i.callbacks.onImageLoad&&"function"==typeof i.callbacks.onImageLoad?i.callbacks.onImageLoad.call(this):3===o&&i.callbacks.onSelectorChange&&"function"==typeof i.callbacks.onSelectorChange?i.callbacks.onSelectorChange.call(this):i.callbacks.onUpdate&&"function"==typeof i.callbacks.onUpdate&&i.callbacks.onUpdate.call(this)),N.call(this)}})},scrollTo:function(t,o){if("undefined"!=typeof t&&null!=t){var n=f.call(this);return e(n).each(function(){var n=e(this);if(n.data(a)){var i=n.data(a),r=i.opt,l={trigger:"external",scrollInertia:r.scrollInertia,scrollEasing:"mcsEaseInOut",moveDragger:!1,timeout:60,callbacks:!0,onStart:!0,onUpdate:!0,onComplete:!0},s=e.extend(!0,{},l,o),c=Y.call(this,t),d=s.scrollInertia>0&&s.scrollInertia<17?17:s.scrollInertia;c[0]=X.call(this,c[0],"y"),c[1]=X.call(this,c[1],"x"),s.moveDragger&&(c[0]*=i.scrollRatio.y,c[1]*=i.scrollRatio.x),s.dur=ne()?0:d,setTimeout(function(){null!==c[0]&&"undefined"!=typeof c[0]&&"x"!==r.axis&&i.overflowed[0]&&(s.dir="y",s.overwrite="all",G(n,c[0].toString(),s)),null!==c[1]&&"undefined"!=typeof c[1]&&"y"!==r.axis&&i.overflowed[1]&&(s.dir="x",s.overwrite="none",G(n,c[1].toString(),s))},s.timeout)}})}},stop:function(){var t=f.call(this);return e(t).each(function(){var t=e(this);t.data(a)&&Q(t)})},disable:function(t){var o=f.call(this);return e(o).each(function(){var o=e(this);if(o.data(a)){o.data(a);N.call(this,"remove"),k.call(this),t&&B.call(this),M.call(this,!0),o.addClass(d[3])}})},destroy:function(){var t=f.call(this);return e(t).each(function(){var n=e(this);if(n.data(a)){var i=n.data(a),r=i.opt,l=e("#mCSB_"+i.idx),s=e("#mCSB_"+i.idx+"_container"),c=e(".mCSB_"+i.idx+"_scrollbar");r.live&&m(r.liveSelector||e(t).selector),N.call(this,"remove"),k.call(this),B.call(this),n.removeData(a),$(this,"mcs"),c.remove(),s.find("img."+d[2]).removeClass(d[2]),l.replaceWith(s.contents()),n.removeClass(o+" _"+a+"_"+i.idx+" "+d[6]+" "+d[7]+" "+d[5]+" "+d[3]).addClass(d[4])}})}},f=function(){return"object"!=typeof e(this)||e(this).length<1?n:this},h=function(t){var o=["rounded","rounded-dark","rounded-dots","rounded-dots-dark"],a=["rounded-dots","rounded-dots-dark","3d","3d-dark","3d-thick","3d-thick-dark","inset","inset-dark","inset-2","inset-2-dark","inset-3","inset-3-dark"],n=["minimal","minimal-dark"],i=["minimal","minimal-dark"],r=["minimal","minimal-dark"];t.autoDraggerLength=e.inArray(t.theme,o)>-1?!1:t.autoDraggerLength,t.autoExpandScrollbar=e.inArray(t.theme,a)>-1?!1:t.autoExpandScrollbar,t.scrollButtons.enable=e.inArray(t.theme,n)>-1?!1:t.scrollButtons.enable,t.autoHideScrollbar=e.inArray(t.theme,i)>-1?!0:t.autoHideScrollbar,t.scrollbarPosition=e.inArray(t.theme,r)>-1?"outside":t.scrollbarPosition},m=function(e){l[e]&&(clearTimeout(l[e]),$(l,e))},p=function(e){return"yx"===e||"xy"===e||"auto"===e?"yx":"x"===e||"horizontal"===e?"x":"y"},g=function(e){return"stepped"===e||"pixels"===e||"step"===e||"click"===e?"stepped":"stepless"},v=function(){var t=e(this),n=t.data(a),i=n.opt,r=i.autoExpandScrollbar?" "+d[1]+"_expand":"",l=["<div id='mCSB_"+n.idx+"_scrollbar_vertical' class='mCSB_scrollTools mCSB_"+n.idx+"_scrollbar mCS-"+i.theme+" mCSB_scrollTools_vertical"+r+"'><div class='"+d[12]+"'><div id='mCSB_"+n.idx+"_dragger_vertical' class='mCSB_dragger' style='position:absolute;'><div class='mCSB_dragger_bar' /></div><div class='mCSB_draggerRail' /></div></div>","<div id='mCSB_"+n.idx+"_scrollbar_horizontal' class='mCSB_scrollTools mCSB_"+n.idx+"_scrollbar mCS-"+i.theme+" mCSB_scrollTools_horizontal"+r+"'><div class='"+d[12]+"'><div id='mCSB_"+n.idx+"_dragger_horizontal' class='mCSB_dragger' style='position:absolute;'><div class='mCSB_dragger_bar' /></div><div class='mCSB_draggerRail' /></div></div>"],s="yx"===i.axis?"mCSB_vertical_horizontal":"x"===i.axis?"mCSB_horizontal":"mCSB_vertical",c="yx"===i.axis?l[0]+l[1]:"x"===i.axis?l[1]:l[0],u="yx"===i.axis?"<div id='mCSB_"+n.idx+"_container_wrapper' class='mCSB_container_wrapper' />":"",f=i.autoHideScrollbar?" "+d[6]:"",h="x"!==i.axis&&"rtl"===n.langDir?" "+d[7]:"";i.setWidth&&t.css("width",i.setWidth),i.setHeight&&t.css("height",i.setHeight),i.setLeft="y"!==i.axis&&"rtl"===n.langDir?"989999px":i.setLeft,t.addClass(o+" _"+a+"_"+n.idx+f+h).wrapInner("<div id='mCSB_"+n.idx+"' class='mCustomScrollBox mCS-"+i.theme+" "+s+"'><div id='mCSB_"+n.idx+"_container' class='mCSB_container' style='position:relative; top:"+i.setTop+"; left:"+i.setLeft+";' dir='"+n.langDir+"' /></div>");var m=e("#mCSB_"+n.idx),p=e("#mCSB_"+n.idx+"_container");"y"===i.axis||i.advanced.autoExpandHorizontalScroll||p.css("width",x(p)),"outside"===i.scrollbarPosition?("static"===t.css("position")&&t.css("position","relative"),t.css("overflow","visible"),m.addClass("mCSB_outside").after(c)):(m.addClass("mCSB_inside").append(c),p.wrap(u)),w.call(this);var g=[e("#mCSB_"+n.idx+"_dragger_vertical"),e("#mCSB_"+n.idx+"_dragger_horizontal")];g[0].css("min-height",g[0].height()),g[1].css("min-width",g[1].width())},x=function(t){var o=[t[0].scrollWidth,Math.max.apply(Math,t.children().map(function(){return e(this).outerWidth(!0)}).get())],a=t.parent().width();return o[0]>a?o[0]:o[1]>a?o[1]:"100%"},_=function(){var t=e(this),o=t.data(a),n=o.opt,i=e("#mCSB_"+o.idx+"_container");if(n.advanced.autoExpandHorizontalScroll&&"y"!==n.axis){i.css({width:"auto","min-width":0,"overflow-x":"scroll"});var r=Math.ceil(i[0].scrollWidth);3===n.advanced.autoExpandHorizontalScroll||2!==n.advanced.autoExpandHorizontalScroll&&r>i.parent().width()?i.css({width:r,"min-width":"100%","overflow-x":"inherit"}):i.css({"overflow-x":"inherit",position:"absolute"}).wrap("<div class='mCSB_h_wrapper' style='position:relative; left:0; width:999999px;' />").css({width:Math.ceil(i[0].getBoundingClientRect().right+.4)-Math.floor(i[0].getBoundingClientRect().left),"min-width":"100%",position:"relative"}).unwrap()}},w=function(){var t=e(this),o=t.data(a),n=o.opt,i=e(".mCSB_"+o.idx+"_scrollbar:first"),r=oe(n.scrollButtons.tabindex)?"tabindex='"+n.scrollButtons.tabindex+"'":"",l=["<a href='#' class='"+d[13]+"' "+r+" />","<a href='#' class='"+d[14]+"' "+r+" />","<a href='#' class='"+d[15]+"' "+r+" />","<a href='#' class='"+d[16]+"' "+r+" />"],s=["x"===n.axis?l[2]:l[0],"x"===n.axis?l[3]:l[1],l[2],l[3]];n.scrollButtons.enable&&i.prepend(s[0]).append(s[1]).next(".mCSB_scrollTools").prepend(s[2]).append(s[3])},S=function(){var t=e(this),o=t.data(a),n=e("#mCSB_"+o.idx),i=e("#mCSB_"+o.idx+"_container"),r=[e("#mCSB_"+o.idx+"_dragger_vertical"),e("#mCSB_"+o.idx+"_dragger_horizontal")],l=[n.height()/i.outerHeight(!1),n.width()/i.outerWidth(!1)],c=[parseInt(r[0].css("min-height")),Math.round(l[0]*r[0].parent().height()),parseInt(r[1].css("min-width")),Math.round(l[1]*r[1].parent().width())],d=s&&c[1]<c[0]?c[0]:c[1],u=s&&c[3]<c[2]?c[2]:c[3];r[0].css({height:d,"max-height":r[0].parent().height()-10}).find(".mCSB_dragger_bar").css({"line-height":c[0]+"px"}),r[1].css({width:u,"max-width":r[1].parent().width()-10})},b=function(){var t=e(this),o=t.data(a),n=e("#mCSB_"+o.idx),i=e("#mCSB_"+o.idx+"_container"),r=[e("#mCSB_"+o.idx+"_dragger_vertical"),e("#mCSB_"+o.idx+"_dragger_horizontal")],l=[i.outerHeight(!1)-n.height(),i.outerWidth(!1)-n.width()],s=[l[0]/(r[0].parent().height()-r[0].height()),l[1]/(r[1].parent().width()-r[1].width())];o.scrollRatio={y:s[0],x:s[1]}},C=function(e,t,o){var a=o?d[0]+"_expanded":"",n=e.closest(".mCSB_scrollTools");"active"===t?(e.toggleClass(d[0]+" "+a),n.toggleClass(d[1]),e[0]._draggable=e[0]._draggable?0:1):e[0]._draggable||("hide"===t?(e.removeClass(d[0]),n.removeClass(d[1])):(e.addClass(d[0]),n.addClass(d[1])))},y=function(){var t=e(this),o=t.data(a),n=e("#mCSB_"+o.idx),i=e("#mCSB_"+o.idx+"_container"),r=null==o.overflowed?i.height():i.outerHeight(!1),l=null==o.overflowed?i.width():i.outerWidth(!1),s=i[0].scrollHeight,c=i[0].scrollWidth;return s>r&&(r=s),c>l&&(l=c),[r>n.height(),l>n.width()]},B=function(){var t=e(this),o=t.data(a),n=o.opt,i=e("#mCSB_"+o.idx),r=e("#mCSB_"+o.idx+"_container"),l=[e("#mCSB_"+o.idx+"_dragger_vertical"),e("#mCSB_"+o.idx+"_dragger_horizontal")];if(Q(t),("x"!==n.axis&&!o.overflowed[0]||"y"===n.axis&&o.overflowed[0])&&(l[0].add(r).css("top",0),G(t,"_resetY")),"y"!==n.axis&&!o.overflowed[1]||"x"===n.axis&&o.overflowed[1]){var s=dx=0;"rtl"===o.langDir&&(s=i.width()-r.outerWidth(!1),dx=Math.abs(s/o.scrollRatio.x)),r.css("left",s),l[1].css("left",dx),G(t,"_resetX")}},T=function(){function t(){r=setTimeout(function(){e.event.special.mousewheel?(clearTimeout(r),W.call(o[0])):t()},100)}var o=e(this),n=o.data(a),i=n.opt;if(!n.bindEvents){if(I.call(this),i.contentTouchScroll&&D.call(this),E.call(this),i.mouseWheel.enable){var r;t()}P.call(this),U.call(this),i.advanced.autoScrollOnFocus&&H.call(this),i.scrollButtons.enable&&F.call(this),i.keyboard.enable&&q.call(this),n.bindEvents=!0}},k=function(){var t=e(this),o=t.data(a),n=o.opt,i=a+"_"+o.idx,r=".mCSB_"+o.idx+"_scrollbar",l=e("#mCSB_"+o.idx+",#mCSB_"+o.idx+"_container,#mCSB_"+o.idx+"_container_wrapper,"+r+" ."+d[12]+",#mCSB_"+o.idx+"_dragger_vertical,#mCSB_"+o.idx+"_dragger_horizontal,"+r+">a"),s=e("#mCSB_"+o.idx+"_container");n.advanced.releaseDraggableSelectors&&l.add(e(n.advanced.releaseDraggableSelectors)),n.advanced.extraDraggableSelectors&&l.add(e(n.advanced.extraDraggableSelectors)),o.bindEvents&&(e(document).add(e(!A()||top.document)).unbind("."+i),l.each(function(){e(this).unbind("."+i)}),clearTimeout(t[0]._focusTimeout),$(t[0],"_focusTimeout"),clearTimeout(o.sequential.step),$(o.sequential,"step"),clearTimeout(s[0].onCompleteTimeout),$(s[0],"onCompleteTimeout"),o.bindEvents=!1)},M=function(t){var o=e(this),n=o.data(a),i=n.opt,r=e("#mCSB_"+n.idx+"_container_wrapper"),l=r.length?r:e("#mCSB_"+n.idx+"_container"),s=[e("#mCSB_"+n.idx+"_scrollbar_vertical"),e("#mCSB_"+n.idx+"_scrollbar_horizontal")],c=[s[0].find(".mCSB_dragger"),s[1].find(".mCSB_dragger")];"x"!==i.axis&&(n.overflowed[0]&&!t?(s[0].add(c[0]).add(s[0].children("a")).css("display","block"),l.removeClass(d[8]+" "+d[10])):(i.alwaysShowScrollbar?(2!==i.alwaysShowScrollbar&&c[0].css("display","none"),l.removeClass(d[10])):(s[0].css("display","none"),l.addClass(d[10])),l.addClass(d[8]))),"y"!==i.axis&&(n.overflowed[1]&&!t?(s[1].add(c[1]).add(s[1].children("a")).css("display","block"),l.removeClass(d[9]+" "+d[11])):(i.alwaysShowScrollbar?(2!==i.alwaysShowScrollbar&&c[1].css("display","none"),l.removeClass(d[11])):(s[1].css("display","none"),l.addClass(d[11])),l.addClass(d[9]))),n.overflowed[0]||n.overflowed[1]?o.removeClass(d[5]):o.addClass(d[5])},O=function(t){var o=t.type,a=t.target.ownerDocument!==document&&null!==frameElement?[e(frameElement).offset().top,e(frameElement).offset().left]:null,n=A()&&t.target.ownerDocument!==top.document&&null!==frameElement?[e(t.view.frameElement).offset().top,e(t.view.frameElement).offset().left]:[0,0];switch(o){case"pointerdown":case"MSPointerDown":case"pointermove":case"MSPointerMove":case"pointerup":case"MSPointerUp":return a?[t.originalEvent.pageY-a[0]+n[0],t.originalEvent.pageX-a[1]+n[1],!1]:[t.originalEvent.pageY,t.originalEvent.pageX,!1];case"touchstart":case"touchmove":case"touchend":var i=t.originalEvent.touches[0]||t.originalEvent.changedTouches[0],r=t.originalEvent.touches.length||t.originalEvent.changedTouches.length;return t.target.ownerDocument!==document?[i.screenY,i.screenX,r>1]:[i.pageY,i.pageX,r>1];default:return a?[t.pageY-a[0]+n[0],t.pageX-a[1]+n[1],!1]:[t.pageY,t.pageX,!1]}},I=function(){function t(e,t,a,n){if(h[0].idleTimer=d.scrollInertia<233?250:0,o.attr("id")===f[1])var i="x",s=(o[0].offsetLeft-t+n)*l.scrollRatio.x;else var i="y",s=(o[0].offsetTop-e+a)*l.scrollRatio.y;G(r,s.toString(),{dir:i,drag:!0})}var o,n,i,r=e(this),l=r.data(a),d=l.opt,u=a+"_"+l.idx,f=["mCSB_"+l.idx+"_dragger_vertical","mCSB_"+l.idx+"_dragger_horizontal"],h=e("#mCSB_"+l.idx+"_container"),m=e("#"+f[0]+",#"+f[1]),p=d.advanced.releaseDraggableSelectors?m.add(e(d.advanced.releaseDraggableSelectors)):m,g=d.advanced.extraDraggableSelectors?e(!A()||top.document).add(e(d.advanced.extraDraggableSelectors)):e(!A()||top.document);m.bind("contextmenu."+u,function(e){e.preventDefault()}).bind("mousedown."+u+" touchstart."+u+" pointerdown."+u+" MSPointerDown."+u,function(t){if(t.stopImmediatePropagation(),t.preventDefault(),ee(t)){c=!0,s&&(document.onselectstart=function(){return!1}),L.call(h,!1),Q(r),o=e(this);var a=o.offset(),l=O(t)[0]-a.top,u=O(t)[1]-a.left,f=o.height()+a.top,m=o.width()+a.left;f>l&&l>0&&m>u&&u>0&&(n=l,i=u),C(o,"active",d.autoExpandScrollbar)}}).bind("touchmove."+u,function(e){e.stopImmediatePropagation(),e.preventDefault();var a=o.offset(),r=O(e)[0]-a.top,l=O(e)[1]-a.left;t(n,i,r,l)}),e(document).add(g).bind("mousemove."+u+" pointermove."+u+" MSPointerMove."+u,function(e){if(o){var a=o.offset(),r=O(e)[0]-a.top,l=O(e)[1]-a.left;if(n===r&&i===l)return;t(n,i,r,l)}}).add(p).bind("mouseup."+u+" touchend."+u+" pointerup."+u+" MSPointerUp."+u,function(){o&&(C(o,"active",d.autoExpandScrollbar),o=null),c=!1,s&&(document.onselectstart=null),L.call(h,!0)})},D=function(){function o(e){if(!te(e)||c||O(e)[2])return void(t=0);t=1,b=0,C=0,d=1,y.removeClass("mCS_touch_action");var o=I.offset();u=O(e)[0]-o.top,f=O(e)[1]-o.left,z=[O(e)[0],O(e)[1]]}function n(e){if(te(e)&&!c&&!O(e)[2]&&(T.documentTouchScroll||e.preventDefault(),e.stopImmediatePropagation(),(!C||b)&&d)){g=K();var t=M.offset(),o=O(e)[0]-t.top,a=O(e)[1]-t.left,n="mcsLinearOut";if(E.push(o),W.push(a),z[2]=Math.abs(O(e)[0]-z[0]),z[3]=Math.abs(O(e)[1]-z[1]),B.overflowed[0])var i=D[0].parent().height()-D[0].height(),r=u-o>0&&o-u>-(i*B.scrollRatio.y)&&(2*z[3]<z[2]||"yx"===T.axis);if(B.overflowed[1])var l=D[1].parent().width()-D[1].width(),h=f-a>0&&a-f>-(l*B.scrollRatio.x)&&(2*z[2]<z[3]||"yx"===T.axis);r||h?(U||e.preventDefault(),b=1):(C=1,y.addClass("mCS_touch_action")),U&&e.preventDefault(),w="yx"===T.axis?[u-o,f-a]:"x"===T.axis?[null,f-a]:[u-o,null],I[0].idleTimer=250,B.overflowed[0]&&s(w[0],R,n,"y","all",!0),B.overflowed[1]&&s(w[1],R,n,"x",L,!0)}}function i(e){if(!te(e)||c||O(e)[2])return void(t=0);t=1,e.stopImmediatePropagation(),Q(y),p=K();var o=M.offset();h=O(e)[0]-o.top,m=O(e)[1]-o.left,E=[],W=[]}function r(e){if(te(e)&&!c&&!O(e)[2]){d=0,e.stopImmediatePropagation(),b=0,C=0,v=K();var t=M.offset(),o=O(e)[0]-t.top,a=O(e)[1]-t.left;if(!(v-g>30)){_=1e3/(v-p);var n="mcsEaseOut",i=2.5>_,r=i?[E[E.length-2],W[W.length-2]]:[0,0];x=i?[o-r[0],a-r[1]]:[o-h,a-m];var u=[Math.abs(x[0]),Math.abs(x[1])];_=i?[Math.abs(x[0]/4),Math.abs(x[1]/4)]:[_,_];var f=[Math.abs(I[0].offsetTop)-x[0]*l(u[0]/_[0],_[0]),Math.abs(I[0].offsetLeft)-x[1]*l(u[1]/_[1],_[1])];w="yx"===T.axis?[f[0],f[1]]:"x"===T.axis?[null,f[1]]:[f[0],null],S=[4*u[0]+T.scrollInertia,4*u[1]+T.scrollInertia];var y=parseInt(T.contentTouchScroll)||0;w[0]=u[0]>y?w[0]:0,w[1]=u[1]>y?w[1]:0,B.overflowed[0]&&s(w[0],S[0],n,"y",L,!1),B.overflowed[1]&&s(w[1],S[1],n,"x",L,!1)}}}function l(e,t){var o=[1.5*t,2*t,t/1.5,t/2];return e>90?t>4?o[0]:o[3]:e>60?t>3?o[3]:o[2]:e>30?t>8?o[1]:t>6?o[0]:t>4?t:o[2]:t>8?t:o[3]}function s(e,t,o,a,n,i){e&&G(y,e.toString(),{dur:t,scrollEasing:o,dir:a,overwrite:n,drag:i})}var d,u,f,h,m,p,g,v,x,_,w,S,b,C,y=e(this),B=y.data(a),T=B.opt,k=a+"_"+B.idx,M=e("#mCSB_"+B.idx),I=e("#mCSB_"+B.idx+"_container"),D=[e("#mCSB_"+B.idx+"_dragger_vertical"),e("#mCSB_"+B.idx+"_dragger_horizontal")],E=[],W=[],R=0,L="yx"===T.axis?"none":"all",z=[],P=I.find("iframe"),H=["touchstart."+k+" pointerdown."+k+" MSPointerDown."+k,"touchmove."+k+" pointermove."+k+" MSPointerMove."+k,"touchend."+k+" pointerup."+k+" MSPointerUp."+k],U=void 0!==document.body.style.touchAction&&""!==document.body.style.touchAction;I.bind(H[0],function(e){o(e)}).bind(H[1],function(e){n(e)}),M.bind(H[0],function(e){i(e)}).bind(H[2],function(e){r(e)}),P.length&&P.each(function(){e(this).bind("load",function(){A(this)&&e(this.contentDocument||this.contentWindow.document).bind(H[0],function(e){o(e),i(e)}).bind(H[1],function(e){n(e)}).bind(H[2],function(e){r(e)})})})},E=function(){function o(){return window.getSelection?window.getSelection().toString():document.selection&&"Control"!=document.selection.type?document.selection.createRange().text:0}function n(e,t,o){d.type=o&&i?"stepped":"stepless",d.scrollAmount=10,j(r,e,t,"mcsLinearOut",o?60:null)}var i,r=e(this),l=r.data(a),s=l.opt,d=l.sequential,u=a+"_"+l.idx,f=e("#mCSB_"+l.idx+"_container"),h=f.parent();f.bind("mousedown."+u,function(){t||i||(i=1,c=!0)}).add(document).bind("mousemove."+u,function(e){if(!t&&i&&o()){var a=f.offset(),r=O(e)[0]-a.top+f[0].offsetTop,c=O(e)[1]-a.left+f[0].offsetLeft;r>0&&r<h.height()&&c>0&&c<h.width()?d.step&&n("off",null,"stepped"):("x"!==s.axis&&l.overflowed[0]&&(0>r?n("on",38):r>h.height()&&n("on",40)),"y"!==s.axis&&l.overflowed[1]&&(0>c?n("on",37):c>h.width()&&n("on",39)))}}).bind("mouseup."+u+" dragend."+u,function(){t||(i&&(i=0,n("off",null)),c=!1)})},W=function(){function t(t,a){if(Q(o),!z(o,t.target)){var r="auto"!==i.mouseWheel.deltaFactor?parseInt(i.mouseWheel.deltaFactor):s&&t.deltaFactor<100?100:t.deltaFactor||100,d=i.scrollInertia;if("x"===i.axis||"x"===i.mouseWheel.axis)var u="x",f=[Math.round(r*n.scrollRatio.x),parseInt(i.mouseWheel.scrollAmount)],h="auto"!==i.mouseWheel.scrollAmount?f[1]:f[0]>=l.width()?.9*l.width():f[0],m=Math.abs(e("#mCSB_"+n.idx+"_container")[0].offsetLeft),p=c[1][0].offsetLeft,g=c[1].parent().width()-c[1].width(),v="y"===i.mouseWheel.axis?t.deltaY||a:t.deltaX;else var u="y",f=[Math.round(r*n.scrollRatio.y),parseInt(i.mouseWheel.scrollAmount)],h="auto"!==i.mouseWheel.scrollAmount?f[1]:f[0]>=l.height()?.9*l.height():f[0],m=Math.abs(e("#mCSB_"+n.idx+"_container")[0].offsetTop),p=c[0][0].offsetTop,g=c[0].parent().height()-c[0].height(),v=t.deltaY||a;"y"===u&&!n.overflowed[0]||"x"===u&&!n.overflowed[1]||((i.mouseWheel.invert||t.webkitDirectionInvertedFromDevice)&&(v=-v),i.mouseWheel.normalizeDelta&&(v=0>v?-1:1),(v>0&&0!==p||0>v&&p!==g||i.mouseWheel.preventDefault)&&(t.stopImmediatePropagation(),t.preventDefault()),t.deltaFactor<5&&!i.mouseWheel.normalizeDelta&&(h=t.deltaFactor,d=17),G(o,(m-v*h).toString(),{dir:u,dur:d}))}}if(e(this).data(a)){var o=e(this),n=o.data(a),i=n.opt,r=a+"_"+n.idx,l=e("#mCSB_"+n.idx),c=[e("#mCSB_"+n.idx+"_dragger_vertical"),e("#mCSB_"+n.idx+"_dragger_horizontal")],d=e("#mCSB_"+n.idx+"_container").find("iframe");d.length&&d.each(function(){e(this).bind("load",function(){A(this)&&e(this.contentDocument||this.contentWindow.document).bind("mousewheel."+r,function(e,o){t(e,o)})})}),l.bind("mousewheel."+r,function(e,o){t(e,o)})}},R=new Object,A=function(t){var o=!1,a=!1,n=null;if(void 0===t?a="#empty":void 0!==e(t).attr("id")&&(a=e(t).attr("id")),a!==!1&&void 0!==R[a])return R[a];if(t){try{var i=t.contentDocument||t.contentWindow.document;n=i.body.innerHTML}catch(r){}o=null!==n}else{try{var i=top.document;n=i.body.innerHTML}catch(r){}o=null!==n}return a!==!1&&(R[a]=o),o},L=function(e){var t=this.find("iframe");if(t.length){var o=e?"auto":"none";t.css("pointer-events",o)}},z=function(t,o){var n=o.nodeName.toLowerCase(),i=t.data(a).opt.mouseWheel.disableOver,r=["select","textarea"];return e.inArray(n,i)>-1&&!(e.inArray(n,r)>-1&&!e(o).is(":focus"))},P=function(){var t,o=e(this),n=o.data(a),i=a+"_"+n.idx,r=e("#mCSB_"+n.idx+"_container"),l=r.parent(),s=e(".mCSB_"+n.idx+"_scrollbar ."+d[12]);s.bind("mousedown."+i+" touchstart."+i+" pointerdown."+i+" MSPointerDown."+i,function(o){c=!0,e(o.target).hasClass("mCSB_dragger")||(t=1)}).bind("touchend."+i+" pointerup."+i+" MSPointerUp."+i,function(){c=!1}).bind("click."+i,function(a){if(t&&(t=0,e(a.target).hasClass(d[12])||e(a.target).hasClass("mCSB_draggerRail"))){Q(o);var i=e(this),s=i.find(".mCSB_dragger");if(i.parent(".mCSB_scrollTools_horizontal").length>0){if(!n.overflowed[1])return;var c="x",u=a.pageX>s.offset().left?-1:1,f=Math.abs(r[0].offsetLeft)-u*(.9*l.width())}else{if(!n.overflowed[0])return;var c="y",u=a.pageY>s.offset().top?-1:1,f=Math.abs(r[0].offsetTop)-u*(.9*l.height())}G(o,f.toString(),{dir:c,scrollEasing:"mcsEaseInOut"})}})},H=function(){var t=e(this),o=t.data(a),n=o.opt,i=a+"_"+o.idx,r=e("#mCSB_"+o.idx+"_container"),l=r.parent();r.bind("focusin."+i,function(){var o=e(document.activeElement),a=r.find(".mCustomScrollBox").length,i=0;o.is(n.advanced.autoScrollOnFocus)&&(Q(t),clearTimeout(t[0]._focusTimeout),t[0]._focusTimer=a?(i+17)*a:0,t[0]._focusTimeout=setTimeout(function(){var e=[ae(o)[0],ae(o)[1]],a=[r[0].offsetTop,r[0].offsetLeft],s=[a[0]+e[0]>=0&&a[0]+e[0]<l.height()-o.outerHeight(!1),a[1]+e[1]>=0&&a[0]+e[1]<l.width()-o.outerWidth(!1)],c="yx"!==n.axis||s[0]||s[1]?"all":"none";"x"===n.axis||s[0]||G(t,e[0].toString(),{dir:"y",scrollEasing:"mcsEaseInOut",overwrite:c,dur:i}),"y"===n.axis||s[1]||G(t,e[1].toString(),{dir:"x",scrollEasing:"mcsEaseInOut",overwrite:c,dur:i})},t[0]._focusTimer))})},U=function(){var t=e(this),o=t.data(a),n=a+"_"+o.idx,i=e("#mCSB_"+o.idx+"_container").parent();i.bind("scroll."+n,function(){0===i.scrollTop()&&0===i.scrollLeft()||e(".mCSB_"+o.idx+"_scrollbar").css("visibility","hidden")})},F=function(){var t=e(this),o=t.data(a),n=o.opt,i=o.sequential,r=a+"_"+o.idx,l=".mCSB_"+o.idx+"_scrollbar",s=e(l+">a");s.bind("contextmenu."+r,function(e){e.preventDefault()}).bind("mousedown."+r+" touchstart."+r+" pointerdown."+r+" MSPointerDown."+r+" mouseup."+r+" touchend."+r+" pointerup."+r+" MSPointerUp."+r+" mouseout."+r+" pointerout."+r+" MSPointerOut."+r+" click."+r,function(a){function r(e,o){i.scrollAmount=n.scrollButtons.scrollAmount,j(t,e,o)}if(a.preventDefault(),ee(a)){var l=e(this).attr("class");switch(i.type=n.scrollButtons.scrollType,a.type){case"mousedown":case"touchstart":case"pointerdown":case"MSPointerDown":if("stepped"===i.type)return;c=!0,o.tweenRunning=!1,r("on",l);break;case"mouseup":case"touchend":case"pointerup":case"MSPointerUp":case"mouseout":case"pointerout":case"MSPointerOut":if("stepped"===i.type)return;c=!1,i.dir&&r("off",l);break;case"click":if("stepped"!==i.type||o.tweenRunning)return;r("on",l)}}})},q=function(){function t(t){function a(e,t){r.type=i.keyboard.scrollType,r.scrollAmount=i.keyboard.scrollAmount,"stepped"===r.type&&n.tweenRunning||j(o,e,t)}switch(t.type){case"blur":n.tweenRunning&&r.dir&&a("off",null);break;case"keydown":case"keyup":var l=t.keyCode?t.keyCode:t.which,s="on";if("x"!==i.axis&&(38===l||40===l)||"y"!==i.axis&&(37===l||39===l)){if((38===l||40===l)&&!n.overflowed[0]||(37===l||39===l)&&!n.overflowed[1])return;"keyup"===t.type&&(s="off"),e(document.activeElement).is(u)||(t.preventDefault(),t.stopImmediatePropagation(),a(s,l))}else if(33===l||34===l){if((n.overflowed[0]||n.overflowed[1])&&(t.preventDefault(),t.stopImmediatePropagation()),"keyup"===t.type){Q(o);var f=34===l?-1:1;if("x"===i.axis||"yx"===i.axis&&n.overflowed[1]&&!n.overflowed[0])var h="x",m=Math.abs(c[0].offsetLeft)-f*(.9*d.width());else var h="y",m=Math.abs(c[0].offsetTop)-f*(.9*d.height());G(o,m.toString(),{dir:h,scrollEasing:"mcsEaseInOut"})}}else if((35===l||36===l)&&!e(document.activeElement).is(u)&&((n.overflowed[0]||n.overflowed[1])&&(t.preventDefault(),t.stopImmediatePropagation()),"keyup"===t.type)){if("x"===i.axis||"yx"===i.axis&&n.overflowed[1]&&!n.overflowed[0])var h="x",m=35===l?Math.abs(d.width()-c.outerWidth(!1)):0;else var h="y",m=35===l?Math.abs(d.height()-c.outerHeight(!1)):0;G(o,m.toString(),{dir:h,scrollEasing:"mcsEaseInOut"})}}}var o=e(this),n=o.data(a),i=n.opt,r=n.sequential,l=a+"_"+n.idx,s=e("#mCSB_"+n.idx),c=e("#mCSB_"+n.idx+"_container"),d=c.parent(),u="input,textarea,select,datalist,keygen,[contenteditable='true']",f=c.find("iframe"),h=["blur."+l+" keydown."+l+" keyup."+l];f.length&&f.each(function(){e(this).bind("load",function(){A(this)&&e(this.contentDocument||this.contentWindow.document).bind(h[0],function(e){t(e)})})}),s.attr("tabindex","0").bind(h[0],function(e){t(e)})},j=function(t,o,n,i,r){function l(e){u.snapAmount&&(f.scrollAmount=u.snapAmount instanceof Array?"x"===f.dir[0]?u.snapAmount[1]:u.snapAmount[0]:u.snapAmount);var o="stepped"!==f.type,a=r?r:e?o?p/1.5:g:1e3/60,n=e?o?7.5:40:2.5,s=[Math.abs(h[0].offsetTop),Math.abs(h[0].offsetLeft)],d=[c.scrollRatio.y>10?10:c.scrollRatio.y,c.scrollRatio.x>10?10:c.scrollRatio.x],m="x"===f.dir[0]?s[1]+f.dir[1]*(d[1]*n):s[0]+f.dir[1]*(d[0]*n),v="x"===f.dir[0]?s[1]+f.dir[1]*parseInt(f.scrollAmount):s[0]+f.dir[1]*parseInt(f.scrollAmount),x="auto"!==f.scrollAmount?v:m,_=i?i:e?o?"mcsLinearOut":"mcsEaseInOut":"mcsLinear",w=!!e;return e&&17>a&&(x="x"===f.dir[0]?s[1]:s[0]),G(t,x.toString(),{dir:f.dir[0],scrollEasing:_,dur:a,onComplete:w}),e?void(f.dir=!1):(clearTimeout(f.step),void(f.step=setTimeout(function(){l()},a)))}function s(){clearTimeout(f.step),$(f,"step"),Q(t)}var c=t.data(a),u=c.opt,f=c.sequential,h=e("#mCSB_"+c.idx+"_container"),m="stepped"===f.type,p=u.scrollInertia<26?26:u.scrollInertia,g=u.scrollInertia<1?17:u.scrollInertia;switch(o){case"on":if(f.dir=[n===d[16]||n===d[15]||39===n||37===n?"x":"y",n===d[13]||n===d[15]||38===n||37===n?-1:1],Q(t),oe(n)&&"stepped"===f.type)return;l(m);break;case"off":s(),(m||c.tweenRunning&&f.dir)&&l(!0)}},Y=function(t){var o=e(this).data(a).opt,n=[];return"function"==typeof t&&(t=t()),t instanceof Array?n=t.length>1?[t[0],t[1]]:"x"===o.axis?[null,t[0]]:[t[0],null]:(n[0]=t.y?t.y:t.x||"x"===o.axis?null:t,n[1]=t.x?t.x:t.y||"y"===o.axis?null:t),"function"==typeof n[0]&&(n[0]=n[0]()),"function"==typeof n[1]&&(n[1]=n[1]()),n},X=function(t,o){if(null!=t&&"undefined"!=typeof t){var n=e(this),i=n.data(a),r=i.opt,l=e("#mCSB_"+i.idx+"_container"),s=l.parent(),c=typeof t;o||(o="x"===r.axis?"x":"y");var d="x"===o?l.outerWidth(!1)-s.width():l.outerHeight(!1)-s.height(),f="x"===o?l[0].offsetLeft:l[0].offsetTop,h="x"===o?"left":"top";switch(c){case"function":return t();case"object":var m=t.jquery?t:e(t);if(!m.length)return;return"x"===o?ae(m)[1]:ae(m)[0];case"string":case"number":if(oe(t))return Math.abs(t);if(-1!==t.indexOf("%"))return Math.abs(d*parseInt(t)/100);if(-1!==t.indexOf("-="))return Math.abs(f-parseInt(t.split("-=")[1]));if(-1!==t.indexOf("+=")){var p=f+parseInt(t.split("+=")[1]);return p>=0?0:Math.abs(p)}if(-1!==t.indexOf("px")&&oe(t.split("px")[0]))return Math.abs(t.split("px")[0]);if("top"===t||"left"===t)return 0;if("bottom"===t)return Math.abs(s.height()-l.outerHeight(!1));if("right"===t)return Math.abs(s.width()-l.outerWidth(!1));if("first"===t||"last"===t){var m=l.find(":"+t);return"x"===o?ae(m)[1]:ae(m)[0]}return e(t).length?"x"===o?ae(e(t))[1]:ae(e(t))[0]:(l.css(h,t),void u.update.call(null,n[0]))}}},N=function(t){function o(){return clearTimeout(f[0].autoUpdate),0===l.parents("html").length?void(l=null):void(f[0].autoUpdate=setTimeout(function(){return c.advanced.updateOnSelectorChange&&(s.poll.change.n=i(),s.poll.change.n!==s.poll.change.o)?(s.poll.change.o=s.poll.change.n,void r(3)):c.advanced.updateOnContentResize&&(s.poll.size.n=l[0].scrollHeight+l[0].scrollWidth+f[0].offsetHeight+l[0].offsetHeight+l[0].offsetWidth,s.poll.size.n!==s.poll.size.o)?(s.poll.size.o=s.poll.size.n,void r(1)):!c.advanced.updateOnImageLoad||"auto"===c.advanced.updateOnImageLoad&&"y"===c.axis||(s.poll.img.n=f.find("img").length,s.poll.img.n===s.poll.img.o)?void((c.advanced.updateOnSelectorChange||c.advanced.updateOnContentResize||c.advanced.updateOnImageLoad)&&o()):(s.poll.img.o=s.poll.img.n,void f.find("img").each(function(){n(this)}))},c.advanced.autoUpdateTimeout))}function n(t){function o(e,t){return function(){
return t.apply(e,arguments)}}function a(){this.onload=null,e(t).addClass(d[2]),r(2)}if(e(t).hasClass(d[2]))return void r();var n=new Image;n.onload=o(n,a),n.src=t.src}function i(){c.advanced.updateOnSelectorChange===!0&&(c.advanced.updateOnSelectorChange="*");var e=0,t=f.find(c.advanced.updateOnSelectorChange);return c.advanced.updateOnSelectorChange&&t.length>0&&t.each(function(){e+=this.offsetHeight+this.offsetWidth}),e}function r(e){clearTimeout(f[0].autoUpdate),u.update.call(null,l[0],e)}var l=e(this),s=l.data(a),c=s.opt,f=e("#mCSB_"+s.idx+"_container");return t?(clearTimeout(f[0].autoUpdate),void $(f[0],"autoUpdate")):void o()},V=function(e,t,o){return Math.round(e/t)*t-o},Q=function(t){var o=t.data(a),n=e("#mCSB_"+o.idx+"_container,#mCSB_"+o.idx+"_container_wrapper,#mCSB_"+o.idx+"_dragger_vertical,#mCSB_"+o.idx+"_dragger_horizontal");n.each(function(){Z.call(this)})},G=function(t,o,n){function i(e){return s&&c.callbacks[e]&&"function"==typeof c.callbacks[e]}function r(){return[c.callbacks.alwaysTriggerOffsets||w>=S[0]+y,c.callbacks.alwaysTriggerOffsets||-B>=w]}function l(){var e=[h[0].offsetTop,h[0].offsetLeft],o=[x[0].offsetTop,x[0].offsetLeft],a=[h.outerHeight(!1),h.outerWidth(!1)],i=[f.height(),f.width()];t[0].mcs={content:h,top:e[0],left:e[1],draggerTop:o[0],draggerLeft:o[1],topPct:Math.round(100*Math.abs(e[0])/(Math.abs(a[0])-i[0])),leftPct:Math.round(100*Math.abs(e[1])/(Math.abs(a[1])-i[1])),direction:n.dir}}var s=t.data(a),c=s.opt,d={trigger:"internal",dir:"y",scrollEasing:"mcsEaseOut",drag:!1,dur:c.scrollInertia,overwrite:"all",callbacks:!0,onStart:!0,onUpdate:!0,onComplete:!0},n=e.extend(d,n),u=[n.dur,n.drag?0:n.dur],f=e("#mCSB_"+s.idx),h=e("#mCSB_"+s.idx+"_container"),m=h.parent(),p=c.callbacks.onTotalScrollOffset?Y.call(t,c.callbacks.onTotalScrollOffset):[0,0],g=c.callbacks.onTotalScrollBackOffset?Y.call(t,c.callbacks.onTotalScrollBackOffset):[0,0];if(s.trigger=n.trigger,0===m.scrollTop()&&0===m.scrollLeft()||(e(".mCSB_"+s.idx+"_scrollbar").css("visibility","visible"),m.scrollTop(0).scrollLeft(0)),"_resetY"!==o||s.contentReset.y||(i("onOverflowYNone")&&c.callbacks.onOverflowYNone.call(t[0]),s.contentReset.y=1),"_resetX"!==o||s.contentReset.x||(i("onOverflowXNone")&&c.callbacks.onOverflowXNone.call(t[0]),s.contentReset.x=1),"_resetY"!==o&&"_resetX"!==o){if(!s.contentReset.y&&t[0].mcs||!s.overflowed[0]||(i("onOverflowY")&&c.callbacks.onOverflowY.call(t[0]),s.contentReset.x=null),!s.contentReset.x&&t[0].mcs||!s.overflowed[1]||(i("onOverflowX")&&c.callbacks.onOverflowX.call(t[0]),s.contentReset.x=null),c.snapAmount){var v=c.snapAmount instanceof Array?"x"===n.dir?c.snapAmount[1]:c.snapAmount[0]:c.snapAmount;o=V(o,v,c.snapOffset)}switch(n.dir){case"x":var x=e("#mCSB_"+s.idx+"_dragger_horizontal"),_="left",w=h[0].offsetLeft,S=[f.width()-h.outerWidth(!1),x.parent().width()-x.width()],b=[o,0===o?0:o/s.scrollRatio.x],y=p[1],B=g[1],T=y>0?y/s.scrollRatio.x:0,k=B>0?B/s.scrollRatio.x:0;break;case"y":var x=e("#mCSB_"+s.idx+"_dragger_vertical"),_="top",w=h[0].offsetTop,S=[f.height()-h.outerHeight(!1),x.parent().height()-x.height()],b=[o,0===o?0:o/s.scrollRatio.y],y=p[0],B=g[0],T=y>0?y/s.scrollRatio.y:0,k=B>0?B/s.scrollRatio.y:0}b[1]<0||0===b[0]&&0===b[1]?b=[0,0]:b[1]>=S[1]?b=[S[0],S[1]]:b[0]=-b[0],t[0].mcs||(l(),i("onInit")&&c.callbacks.onInit.call(t[0])),clearTimeout(h[0].onCompleteTimeout),J(x[0],_,Math.round(b[1]),u[1],n.scrollEasing),!s.tweenRunning&&(0===w&&b[0]>=0||w===S[0]&&b[0]<=S[0])||J(h[0],_,Math.round(b[0]),u[0],n.scrollEasing,n.overwrite,{onStart:function(){n.callbacks&&n.onStart&&!s.tweenRunning&&(i("onScrollStart")&&(l(),c.callbacks.onScrollStart.call(t[0])),s.tweenRunning=!0,C(x),s.cbOffsets=r())},onUpdate:function(){n.callbacks&&n.onUpdate&&i("whileScrolling")&&(l(),c.callbacks.whileScrolling.call(t[0]))},onComplete:function(){if(n.callbacks&&n.onComplete){"yx"===c.axis&&clearTimeout(h[0].onCompleteTimeout);var e=h[0].idleTimer||0;h[0].onCompleteTimeout=setTimeout(function(){i("onScroll")&&(l(),c.callbacks.onScroll.call(t[0])),i("onTotalScroll")&&b[1]>=S[1]-T&&s.cbOffsets[0]&&(l(),c.callbacks.onTotalScroll.call(t[0])),i("onTotalScrollBack")&&b[1]<=k&&s.cbOffsets[1]&&(l(),c.callbacks.onTotalScrollBack.call(t[0])),s.tweenRunning=!1,h[0].idleTimer=0,C(x,"hide")},e)}}})}},J=function(e,t,o,a,n,i,r){function l(){S.stop||(x||m.call(),x=K()-v,s(),x>=S.time&&(S.time=x>S.time?x+f-(x-S.time):x+f-1,S.time<x+1&&(S.time=x+1)),S.time<a?S.id=h(l):g.call())}function s(){a>0?(S.currVal=u(S.time,_,b,a,n),w[t]=Math.round(S.currVal)+"px"):w[t]=o+"px",p.call()}function c(){f=1e3/60,S.time=x+f,h=window.requestAnimationFrame?window.requestAnimationFrame:function(e){return s(),setTimeout(e,.01)},S.id=h(l)}function d(){null!=S.id&&(window.requestAnimationFrame?window.cancelAnimationFrame(S.id):clearTimeout(S.id),S.id=null)}function u(e,t,o,a,n){switch(n){case"linear":case"mcsLinear":return o*e/a+t;case"mcsLinearOut":return e/=a,e--,o*Math.sqrt(1-e*e)+t;case"easeInOutSmooth":return e/=a/2,1>e?o/2*e*e+t:(e--,-o/2*(e*(e-2)-1)+t);case"easeInOutStrong":return e/=a/2,1>e?o/2*Math.pow(2,10*(e-1))+t:(e--,o/2*(-Math.pow(2,-10*e)+2)+t);case"easeInOut":case"mcsEaseInOut":return e/=a/2,1>e?o/2*e*e*e+t:(e-=2,o/2*(e*e*e+2)+t);case"easeOutSmooth":return e/=a,e--,-o*(e*e*e*e-1)+t;case"easeOutStrong":return o*(-Math.pow(2,-10*e/a)+1)+t;case"easeOut":case"mcsEaseOut":default:var i=(e/=a)*e,r=i*e;return t+o*(.499999999999997*r*i+-2.5*i*i+5.5*r+-6.5*i+4*e)}}e._mTween||(e._mTween={top:{},left:{}});var f,h,r=r||{},m=r.onStart||function(){},p=r.onUpdate||function(){},g=r.onComplete||function(){},v=K(),x=0,_=e.offsetTop,w=e.style,S=e._mTween[t];"left"===t&&(_=e.offsetLeft);var b=o-_;S.stop=0,"none"!==i&&d(),c()},K=function(){return window.performance&&window.performance.now?window.performance.now():window.performance&&window.performance.webkitNow?window.performance.webkitNow():Date.now?Date.now():(new Date).getTime()},Z=function(){var e=this;e._mTween||(e._mTween={top:{},left:{}});for(var t=["top","left"],o=0;o<t.length;o++){var a=t[o];e._mTween[a].id&&(window.requestAnimationFrame?window.cancelAnimationFrame(e._mTween[a].id):clearTimeout(e._mTween[a].id),e._mTween[a].id=null,e._mTween[a].stop=1)}},$=function(e,t){try{delete e[t]}catch(o){e[t]=null}},ee=function(e){return!(e.which&&1!==e.which)},te=function(e){var t=e.originalEvent.pointerType;return!(t&&"touch"!==t&&2!==t)},oe=function(e){return!isNaN(parseFloat(e))&&isFinite(e)},ae=function(e){var t=e.parents(".mCSB_container");return[e.offset().top-t.offset().top,e.offset().left-t.offset().left]},ne=function(){function e(){var e=["webkit","moz","ms","o"];if("hidden"in document)return"hidden";for(var t=0;t<e.length;t++)if(e[t]+"Hidden"in document)return e[t]+"Hidden";return null}var t=e();return t?document[t]:!1};e.fn[o]=function(t){return u[t]?u[t].apply(this,Array.prototype.slice.call(arguments,1)):"object"!=typeof t&&t?void e.error("Method "+t+" does not exist"):u.init.apply(this,arguments)},e[o]=function(t){return u[t]?u[t].apply(this,Array.prototype.slice.call(arguments,1)):"object"!=typeof t&&t?void e.error("Method "+t+" does not exist"):u.init.apply(this,arguments)},e[o].defaults=i,window[o]=!0,e(window).bind("load",function(){e(n)[o](),e.extend(e.expr[":"],{mcsInView:e.expr[":"].mcsInView||function(t){var o,a,n=e(t),i=n.parents(".mCSB_container");if(i.length)return o=i.parent(),a=[i[0].offsetTop,i[0].offsetLeft],a[0]+ae(n)[0]>=0&&a[0]+ae(n)[0]<o.height()-n.outerHeight(!1)&&a[1]+ae(n)[1]>=0&&a[1]+ae(n)[1]<o.width()-n.outerWidth(!1)},mcsInSight:e.expr[":"].mcsInSight||function(t,o,a){var n,i,r,l,s=e(t),c=s.parents(".mCSB_container"),d="exact"===a[3]?[[1,0],[1,0]]:[[.9,.1],[.6,.4]];if(c.length)return n=[s.outerHeight(!1),s.outerWidth(!1)],r=[c[0].offsetTop+ae(s)[0],c[0].offsetLeft+ae(s)[1]],i=[c.parent()[0].offsetHeight,c.parent()[0].offsetWidth],l=[n[0]<i[0]?d[0]:d[1],n[1]<i[1]?d[0]:d[1]],r[0]-i[0]*l[0][0]<0&&r[0]+n[0]-i[0]*l[0][1]>=0&&r[1]-i[1]*l[1][0]<0&&r[1]+n[1]-i[1]*l[1][1]>=0},mcsOverflow:e.expr[":"].mcsOverflow||function(t){var o=e(t).data(a);if(o)return o.overflowed[0]||o.overflowed[1]}})})})});
;(function (window) {
    var svgSprite = '<svg><symbol id="icon-shanchu" viewBox="0 0 1024 1024"><path d="M623.076818 748.923014c-17.597797 0-31.82073-14.222933-31.82073-31.82073L591.256088 367.026164c0-17.597797 14.222933-31.826869 31.82073-31.826869s31.826869 14.229073 31.826869 31.826869l0 350.075097C654.904711 734.700081 640.675638 748.923014 623.076818 748.923014L623.076818 748.923014zM432.131975 748.923014c-17.603937 0-31.826869-14.222933-31.826869-31.82073L400.305105 367.026164c0-17.597797 14.222933-31.826869 31.826869-31.826869 17.597797 0 31.82073 14.229073 31.82073 31.826869l0 350.075097C463.952704 734.700081 449.729771 748.923014 432.131975 748.923014L432.131975 748.923014zM941.325046 207.90205l-159.124114 0 0-63.648622c0-52.639894-42.485627-95.475492-94.741781-95.475492L368.477212 48.777937c-52.633754 0-95.469352 42.835597-95.469352 95.475492l0 63.648622-159.124114 0c-17.603937 0-31.826869 14.222933-31.826869 31.826869 0 17.597797 14.222933 31.82073 31.826869 31.82073l827.441299 0c17.597797 0 31.826869-14.222933 31.826869-31.82073C973.152938 222.124983 958.923866 207.90205 941.325046 207.90205L941.325046 207.90205zM336.656483 144.253428c0-17.536398 14.286378-31.826869 31.82073-31.826869l318.981938 0c17.444301 0 31.094182 13.972223 31.094182 31.826869l0 63.648622L336.656483 207.90205 336.656483 144.253428 336.656483 144.253428zM750.506069 939.873997 304.892035 939.873997c-52.634778 0-95.470375-42.835597-95.470375-95.475492L209.42166 366.550327c0-17.569144 14.257725-31.825846 31.822776-31.825846 17.569144 0 31.825846 14.256702 31.825846 31.825846l0 477.848179c0 17.569144 14.287401 31.826869 31.822776 31.826869l445.61301 0c17.565051 0 31.822776-14.257725 31.822776-31.826869L782.328845 367.851972c0-17.565051 14.228049-31.822776 31.825846-31.822776 17.59882 0 31.826869 14.257725 31.826869 31.822776l0 476.546533C845.981561 897.0384 803.140847 939.873997 750.506069 939.873997L750.506069 939.873997z"  ></path></symbol><symbol id="icon-tuichu-copy" viewBox="0 0 1024 1024"><path d="M512 141.211c-31.726 0-57.449 25.724-57.449 57.449v287.291c0 31.726 25.724 57.449 57.449 57.449s57.449-25.724 57.449-57.449v-287.291c0-31.726-25.724-57.449-57.449-57.449z"  ></path><path d="M512 882.789c-202.96 0-368.1-165.141-368.1-368.1 0-113.438 51.145-218.812 140.274-289.169 18.701-14.692 45.793-11.541 60.532 7.138 14.738 18.679 11.564 45.793-7.137 60.532-68.294 53.88-107.459 134.619-107.459 221.5 0 155.429 126.462 281.916 281.916 281.916 155.429 0 281.892-126.485 281.892-281.916 0-86.903-39.188-167.665-107.552-221.546-18.701-14.738-21.9-41.829-7.162-60.532 14.762-18.679 41.829-21.877 60.507-7.162 89.22 70.333 140.39 175.754 140.39 289.238 0 202.96-165.141 368.101-368.1 368.101z"  ></path></symbol><symbol id="icon-tianjiajiahaowubiankuang" viewBox="0 0 1024 1024"><path d="M864 448 512 448 512 96C512 78.08 497.92 64 480 64 462.08 64 448 78.08 448 96L448 448 96 448C78.08 448 64 462.08 64 480 64 497.92 78.08 512 96 512L448 512l0 352C448 881.92 462.08 896 480 896 497.92 896 512 881.92 512 864L512 512l352 0C881.92 512 896 497.92 896 480 896 462.08 881.92 448 864 448z"  ></path></symbol><symbol id="icon-chexiao" viewBox="0 0 1024 1024"><path d="M892.544 355.30752l-313.39008 291.00032V467.23072c-92.01152 0-313.38496-13.72672-313.38496 223.8464 0 124.43136 82.52416 244.61824 201.46176 268.6208-191.12448-25.5744-335.77472-185.02656-335.77472-380.544 0-363.1872 384.32256-358.15936 447.69792-358.15936V64.30208l313.39008 291.00544z" fill="" ></path></symbol><symbol id="icon-baocun" viewBox="0 0 1024 1024"><path d="M867.113 959.333H156.918c-1.618-0.566-3.221-1.366-4.881-1.659-41.102-7.357-68.479-30.927-82.418-70.119-2.397-6.746-3.636-13.932-5.424-20.918V156.441c0.566-1.64 1.343-3.217 1.661-4.897 8.43-45.137 35.237-73.145 79.326-84.985 3.891-1.049 7.821-1.893 11.735-2.835h610.47c25.42 5.609 45.373 20.772 63.475 38.117a3147.936 3147.936 0 0 1 88.495 88.242c18.185 18.859 34.521 39.421 40.447 66.056v610.493c-0.562 1.621-1.342 3.198-1.659 4.882-8.432 45.158-35.214 73.14-79.328 85.005-3.865 1.033-7.799 1.891-11.704 2.814m-355.046-34.271c101.734 0 203.456 0.026 305.172-0.038 25.884 0 39.53-13.601 39.53-39.212 0.02-111.641 0.02-223.281 0-334.903 0-25.712-13.754-39.591-39.212-39.591-203.754-0.021-407.483-0.021-611.212 0-25.058 0.023-39.084 13.921-39.084 38.853-0.044 111.915-0.044 223.852 0.018 335.767 0 4.056 0.107 8.221 1.03 12.131 4.189 17.703 17.472 26.953 38.601 26.973 101.721 0.044 203.437 0.02 305.157 0.02m-17.559-516.556h217.689c27.881-0.02 41.297-13.37 41.297-41.164 0.02-76.064 0.02-152.116 0-228.182 0-27.983-13.143-41.145-41.189-41.145-145.131-0.02-290.247-0.02-435.36 0-27.48 0-40.914 13.288-40.934 40.618-0.064 76.343-0.064 152.683 0 229.047 0.02 27.309 13.601 40.807 40.829 40.807 72.554 0.019 145.115 0.019 217.668 0.019m87.338-275.273h101.172v239.57H581.846v-239.57m0 0z" fill="" ></path></symbol><symbol id="icon-iocnchexiao" viewBox="0 0 1024 1024"><path d="M761.856 1024C875.584 817.92 896 503.68 448 514.176L448 768 64 384l384-384 0 248.384C1024 234.432 1042.56 720.576 761.856 1024z"  ></path></symbol><symbol id="icon-fanye" viewBox="0 0 1024 1024"><path d="M512.006827 1024a511.992553 511.992553 0 1 1 511.992553-511.061657A512.597635 512.597635 0 0 1 512.006827 1024z m-90.917466-833.927264l-43.441792 41.580001 280.665008 281.285606-276.786277 279.268665 41.580002 41.580001 320.228069-320.848666z m0 0"  ></path></symbol><symbol id="icon-fanye2" viewBox="0 0 1024 1024"><path d="M511.993173 0a511.992553 511.992553 0 1 1-511.992553 511.061657A512.597635 512.597635 0 0 1 511.993173 0z m90.917466 833.927264l43.44179199-41.580001-280.66500799-281.285606 276.786277-279.268665-41.580002-41.580001-320.228069 320.848666z m0 0"  ></path></symbol><symbol id="icon-wenjian" viewBox="0 0 1024 1024"><path d="M815.104 69.632q27.648 25.6 44.032 42.496t25.088 28.672 10.752 19.968 2.048 14.336l0 16.384-151.552 0q-10.24 0-17.92-7.68t-12.8-17.92-7.68-20.992-2.56-16.896l0-126.976 3.072 0q8.192 0 16.896 2.56t19.968 9.728 28.16 20.48 42.496 35.84zM640 129.024q0 20.48 6.144 42.496t19.456 40.96 33.792 31.232 48.128 12.288l149.504 0 0 577.536q0 29.696-11.776 53.248t-31.232 39.936-43.008 25.6-46.08 9.216l-503.808 0q-19.456 0-42.496-11.264t-43.008-29.696-33.28-41.984-13.312-49.152l0-696.32q0-21.504 9.728-44.544t26.624-42.496 38.4-32.256 45.056-12.8l391.168 0 0 128zM704.512 768q26.624 0 45.056-18.944t18.432-45.568-18.432-45.056-45.056-18.432l-384 0q-26.624 0-45.056 18.432t-18.432 45.056 18.432 45.568 45.056 18.944l384 0zM768 448.512q0-26.624-18.432-45.568t-45.056-18.944l-384 0q-26.624 0-45.056 18.944t-18.432 45.568 18.432 45.056 45.056 18.432l384 0q26.624 0 45.056-18.432t18.432-45.056z"  ></path></symbol><symbol id="icon-sucaiku" viewBox="0 0 1024 1024"><path d="M549.9 541.4v416.9l409.4-209.2V332.2L549.9 541.4zM64.2 749.1l409.4 209.2V538.6L64.2 329.5v419.6zM511.8 63.2L103.7 271.7l410.7 209.8L922.5 273 511.8 63.2z" fill="" ></path></symbol><symbol id="icon-tubiaozhizuomoban" viewBox="0 0 1024 1024"><path d="M635 888.5c-41.5-4.3-63-13-78.6-25.9l-1.1-1.1c-13.5-14.6-20.5-46.9-20.5-97.6V221.6c0-7.6 5.9-14 14-14h87.3c78.2 0 83 10.8 107.7 32.9 26.9 21.1 38.8 31.9 52.8 102 1.6 6.5 7 11.3 14 11.3h5.4c8.1 0 14.5-6.5 14-14.6l-1.6-232.6H78.5c-7.6 0-13.5 5.9-14 13.5l-1.1 218.5c-0.5 8.1 5.9 14.6 14 14.6h5.4c7 0 12.4-4.8 14-11.3 14-69.6 25.9-80.4 52.8-101.4l0.5-0.5c24.3-21.6 29.6-32.4 107.3-32.4h87.3c7.6 0 14 5.9 14 14v525.6c0 60.4-6.5 96.6-20 108.4-1.1 0.5-1.6 1.6-2.2 2.2-11.9 16.1-31.8 26.4-73.2 30.7-7.6 0.5-13 6.5-13 14 0 7.6 5.9 14 14 14h369.6c7.6 0 14-5.9 14-14 0.1-7-5.3-13.5-12.9-14z m324.3-217.6l-0.7-99H638.4c-3.2 0-5.7 2.6-6 5.7l-0.5 93c-0.3 3.5 2.6 6.2 6 6.2h2.3c3 0 5.3-2.1 6-4.8 6-29.6 11-34.2 22.5-43.1l0.3-0.3c10.4-9.2 12.7-13.8 45.8-13.8h37.3c3.2 0 6 2.6 6 5.9v223.7c0 25.7-2.7 41-8.5 46.1-0.5 0.3-0.7 0.7-0.9 0.9-5 6.9-13.6 11.2-31.3 13-3.2 0.3-5.6 2.7-5.6 5.9s2.6 5.9 6 5.9h157.8c3.2 0 6-2.6 6-5.9 0-3-2.3-5.7-5.6-5.9-17.7-1.8-26.9-5.5-33.6-11l-0.5-0.5c-5.7-6.2-8.8-20-8.8-41.6V620.8c0-3.2 2.6-5.9 6-5.9h37.3c33.4 0 35.4 4.6 46 14 11.5 8.9 16.6 13.6 22.5 43.4 0.7 2.7 3 4.8 6 4.8h2.3c3.6 0 6.4-2.8 6.1-6.2z" fill="#2197D8" ></path></symbol></svg>';
    var script = function () {
        var scripts = document.getElementsByTagName("script");
        return scripts[scripts.length - 1]
    }();
    var shouldInjectCss = script.getAttribute("data-injectcss");
    var ready = function (fn) {
        if (document.addEventListener) {
            if (~["complete", "loaded", "interactive"].indexOf(document.readyState)) {
                setTimeout(fn, 0)
            } else {
                var loadFn = function () {
                    document.removeEventListener("DOMContentLoaded", loadFn, false);
                    fn()
                };
                document.addEventListener("DOMContentLoaded", loadFn, false)
            }
        } else if (document.attachEvent) {
            IEContentLoaded(window, fn)
        }
        function IEContentLoaded(w, fn) {
            var d = w.document, done = false, init = function () {
                if (!done) {
                    done = true;
                    fn()
                }
            };
            var polling = function () {
                try {
                    d.documentElement.doScroll("left")
                } catch (e) {
                    setTimeout(polling, 50);
                    return
                }
                init()
            };
            polling();
            d.onreadystatechange = function () {
                if (d.readyState == "complete") {
                    d.onreadystatechange = null;
                    init()
                }
            }
        }
    };
    var before = function (el, target) {
        target.parentNode.insertBefore(el, target)
    };
    var prepend = function (el, target) {
        if (target.firstChild) {
            before(el, target.firstChild)
        } else {
            target.appendChild(el)
        }
    };

    function appendSvg() {
        var div, svg;
        div = document.createElement("div");
        div.innerHTML = svgSprite;
        svgSprite = null;
        svg = div.getElementsByTagName("svg")[0];
        if (svg) {
            svg.setAttribute("aria-hidden", "true");
            svg.style.position = "absolute";
            svg.style.width = 0;
            svg.style.height = 0;
            svg.style.overflow = "hidden";
            prepend(svg, document.body)
        }
    }

    if (shouldInjectCss && !window.__iconfont__svg__cssinject__) {
        window.__iconfont__svg__cssinject__ = true;
        try {
            document.write("<style>.svgfont {display: inline-block;width: 1em;height: 1em;fill: currentColor;vertical-align: -0.1em;font-size:16px;}</style>")
        } catch (e) {
            console && console.log(e)
        }
    }
    ready(appendSvg)
})(window);

(function() {
    'use strict';

    angular
        .module('editorApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .constant('IMAGE_SUPPORTED_MIME', "image/png, image/jpeg, image/jpg, image/heic, .livp")
        ;


})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', '$locationProvider', '$uibTooltipProvider'];

    function stateConfig($stateProvider, $locationProvider, $uibTooltipProvider) {
        if ($uibTooltipProvider) {
            $uibTooltipProvider.options({ appendToBody: true });
        }
        $stateProvider
        .state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        })
        .state('app2', {
            abstract: true,
            views: {
                'navbar2@': {
                    templateUrl: 'app/layouts/navbar/navbar_login.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });
        $locationProvider.html5Mode({ enabled: true, requireBase: true });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('editorApp')
        .constant('VERSION', "0.0.1-SNAPSHOT")
        .constant('DEBUG_INFO_ENABLED', false)
        .constant('BUILD_TIMESTAMP', 1793693298712)
;
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/appmetrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.includes('web.rest') || key.includes('service')) {
                    vm.servicesStats[key] = value;
                }
            });

        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/apphealth',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('editorApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .factory('GatewayRoutes', GatewayRoutes);

    GatewayRoutes.$inject = ['$resource'];

    function GatewayRoutes ($resource) {
        var service = $resource('api/gateway/routes/:id', {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });

        return service;
    }

})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('gateway', {
            parent: 'admin',
            url: '/apphealth',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'gateway.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/gateway/gateway.html',
                    controller: 'GatewayController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('gateway');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .controller('GatewayController', GatewayController);

    GatewayController.$inject = ['$filter', '$interval', 'GatewayRoutes'];

    function GatewayController ($filter, $interval, GatewayRoutes) {
        var vm = this;

        vm.gatewayRoutes = null;
        vm.refresh = refresh;
        vm.updatingRoutes = null;

        vm.refresh();

        function refresh () {
            vm.updatingRoutes = true;
            GatewayRoutes.query(function(result) {
                vm.gatewayRoutes = result;
                vm.updatingRoutes = false;
            });
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('editorApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate'];

    function SettingsController (Principal, Auth, JhiLanguageService, $translate) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/{storeId}/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth', 'errorConstants', '$scope', 'MessageService', 'VerifyCode',
     '$interval', 'Customer', '$state', '$stateParams', "$cookieStore", "$translate"];

    function RequestResetController ($timeout, Auth, errorConstants, $scope, MessageService, VerifyCode,
     $interval, Customer, $state, $stateParams, $cookieStore, $translate) {
        var vm = this;

        vm.error = null;
        vm.resetPassword = resetPassword;
        $scope.paracont = $translate.instant("resetPassword.getVerifyCode");
        vm.storeId = $stateParams.storeId|| $cookieStore.get("store-id");
        if (!vm.storeId) {
            return;
        }
        vm.success = null;
        vm.checkCode = false;
        var timer = null;
        $(".navbar").hide();
        $(".wrap").css({margin:0})

        $timeout(function (){angular.element('#email').focus();});

        $scope.checkVerifyCode = function(){ 
            VerifyCode.check({
                storeId:vm.storeId,
                phone: vm.registerAccount.phone,
                code: vm.registerAccount.code,
            }, function (msg) {
                if (msg.status == 200 && msg.message==true) {
                    vm.checkCode = true;
                }else{
                    vm.checkCode = false;
                   MessageService.error($translate.instant("resetPassword.verifyCodeFailed"));
                }
            },function(){
                vm.checkCode = false;
                MessageService.error($translate.instant("resetPassword.verifyCodeFailed"));
            });
        }


        $scope.getVerifyCode = function () {
            if (vm.registerAccount.phone == null || vm.registerAccount.phone == "") {
                MessageService.error($translate.instant("resetPassword.enterPhoneFirst"));
                return;
            }
            if (vm.disabled) {
                return;
            }
            vm.countdown = 120;
            // 发送验证码到手机
            VerifyCode.getVerifyCode({
                phone: vm.registerAccount.phone,
                storeId:vm.storeId,
                incident: "忘记密码"
            }, function (msg) {
                clearInterval(timer);
                timer = $interval(function () {
                    if (vm.countdown > 0) {
                        vm.disabled = true;
                        vm.countdown -- ;
                        $scope.paracont = $translate.instant("resetPassword.resendVerifyCode") + "(" + vm.countdown + ")";
                    } else {
                        vm.disabled = false;
                        $interval.cancel(timer);
                        $scope.paracont = $translate.instant("resetPassword.resendVerifyCode");
                    }
                }, 1000);
            });
        };

        
        function resetPassword () {
            vm.error = null;
            var postData = { 
                phone:vm.registerAccount.phone,
                password:vm.registerAccount.password,
                storeId:vm.storeId
            }
            Customer.changePassword(postData,
                function(data) {
                    MessageService.success($translate.instant("resetPassword.resetSuccess"));
                    $state.go("home", {storeId:vm.storeId});
                },
                function() {
                    MessageService.error($translate.instant("resetPassword.resetFailed"));
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/{storeId}/register',
            data: {
                authorities: [],
                pageTitle: 'register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    $translatePartialLoader.addPart('common');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$translate', 'Store', 'Auth', 'Qinius', '$q', 'VerifyCode', 'PlatformWechatSetting',
    'MessageService', '$scope', '$interval', '$state', 'Customer', '$stateParams', '$rootScope', 'UidService', 'WechatAuth', 'entity', '$localStorage', '$uibModalInstance',
    'Account', "$cookieStore"];

    function RegisterController ($translate, Store, Auth, Qinius, $q, VerifyCode, PlatformWechatSetting,
        MessageService, $scope, $interval, $state, Customer, $stateParams, $rootScope, UidService, WechatAuth, entity, $localStorage, $uibModalInstance,
        Account, $cookieStore) {

        var vm = this;

        vm.loginContent = true;
        vm.loginText = true;
        vm.passwordReset = false;
        vm.userRegister = false;
        vm.userBinding = false;


        vm.rememberMe = true;
        vm.storeId = $stateParams.storeId || $cookieStore.get("store-id");
        if (!vm.storeId) {
            return;
        }
        vm.store = Store.get({id: vm.storeId});
        $scope.domains = Qinius.getDomain({storeId: vm.storeId});
        vm.login = login;
        vm.register = register;
        vm.resetPassword = resetPassword;
        vm.register2 = register2;
        vm.registerAccount = {storeId:vm.storeId};
        vm.checkCode = false;
        vm.disabled = true;
        vm.disabled2 = false;
        $scope.paracont = $translate.instant("resetPassword.getVerifyCode");

        //验证码的定时器
        var timer = null;
        //微信扫码的定时器
        var timer2 = null;
        //扫码是的uuid
        vm.uuid = null;

        vm.platformWechatSetting = PlatformWechatSetting.get();
        $q.all([$scope.domains.$promise, vm.platformWechatSetting.$promise, vm.store.$promise]).then(function () {
            vm.domain = 'https://' + $scope.domains.domains[0] + '/';
            vm.loginLogo = 'content/images/login-bg.png';
            vm.registerLogo = 'content/images/login-bg.png';
            if(vm.store.webLoginLogo){
                vm.loginLogo = vm.domain+vm.store.webLoginLogo+'?imageView2';
            }
            if(vm.store.webRegisterLogo){
                vm.registerLogo = vm.domain+vm.store.webRegisterLogo+'?imageView2';
            }
        });

        if (entity!=null && entity.type == "Register") {
            vm.loginContent = false;
            vm.userRegister = true;
            vm.passwordReset = false;
            vm.userBinding = false;

            vm.disabled = true;
            vm.disabled2 = false;
        }


        $scope.requestReset = function(){
            vm.loginContent = false;
            vm.userRegister = false;
            vm.passwordReset = true;
            vm.userBinding = false;

            vm.disabled = true;
            vm.disabled2 = false;

        }

        $scope.register = function(){
            vm.loginContent = false;
            vm.userRegister = true;
            vm.passwordReset = false;
            vm.userBinding = false;

            vm.disabled = true;
            vm.disabled2 = false;
        }

        $scope.hasUser = function(){
            vm.loginContent = true;
            vm.passwordReset = false;
            vm.userRegister = false;
            vm.userBinding = false;
            vm.loginText = true;

            vm.disabled = true;
            vm.disabled2 = false;
        }

        $scope.showPhoneLogin = function(){
            vm.loginText = true;
            $interval.cancel(timer2);
        }


        $scope.showQrCode = function(){
            vm.loginText = false;
            vm.uuid = UidService.get();
            var obj = new WxLogin({
              id: "login_container",
              appid: vm.platformWechatSetting.webAppId,
              scope: "snsapi_login",
              redirect_uri: encodeURIComponent(vm.platformWechatSetting.editorNotifyUrl+ "/#/"+ vm.storeId+"/commodity"),
              state: vm.uuid,
              style: "black",
              href: ""});
            timer2 = $interval(function () {
                if (location.hash.indexOf("?")>=0) {
                    $interval.cancel(timer2);
                    var data = {};
                    var search = location.hash.substring(location.hash.indexOf("?")+1);
                    var searchList = search.split("&");
                    if (searchList.length == 2) {
                        for (var i = searchList.length - 1; i >= 0; i--) {
                            var params = searchList[i].split("=");
                            if (params.length >= 2) {
                                data[params[0]]=params[1];
                            }
                        }
                    }
                    WechatAuth.auth_notify3({storeId:vm.storeId, code:data.code, state:data.state },function(value){
                        if (value.status == 205) {
                            vm.loginContent = false;
                            vm.passwordReset = false;
                            vm.userRegister = false;
                            vm.userBinding = true;
                            location.href =  location.href.substring(0, location.href.indexOf("?"));
                        }else if (value.status == 200){
                            $localStorage.authenticationToken = value.message;
                            Account.get().$promise.then(getAccountThen);
                            $uibModalInstance.close();
                        }
                        },function(){
                            MessageService.error($translate.instant("loginMessages.loginFailedAndRefresh"));
                        })
                }
            }, 1000);
        }

        $scope.close = function(){
            $uibModalInstance.close();
        }

        function getAccountThen (account) {
            $localStorage.user = account.data;
            $state.reload();
        }


        $scope.getVerifyCode = function () {
            if (vm.registerAccount.phone == null || vm.registerAccount.phone == "") {
                MessageService.error($translate.instant("resetPassword.enterPhoneFirst"));
                return;
            }
            if (vm.disabled) {
                return;
            }
            vm.countdown = 120;
            // 发送验证码到手机
            VerifyCode.getVerifyCode({
                phone: vm.registerAccount.phone,
                incident: "用户注册",
                storeId:vm.storeId
            }, function (msg) {
                clearInterval(timer);
                timer = $interval(function () {
                    if (vm.countdown > 0) {
                        vm.disabled = true;
                        vm.countdown -- ;
                        $scope.paracont = $translate.instant("resetPassword.resendVerifyCode") + "(" + vm.countdown + ")";
                    } else {
                        vm.disabled = false;
                        $interval.cancel(timer);
                        $scope.paracont = $translate.instant("resetPassword.resendVerifyCode");
                    }
                }, 1000);
            });
        };

        function login(event) {
            if (vm.phone == null || vm.phone == '' || vm.password == null || vm.password == '') {
                MessageService.error($translate.instant("loginMessages.enterPhoneAndPassword"));
                return;
            }
            event.preventDefault();
            Auth.login({
                phone: vm.phone,
                password: vm.password,
                storeId:vm.storeId,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $rootScope.$broadcast('authenticationSuccess');
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    // $state.go(previousState.name, previousState.params);
                }
                $uibModalInstance.close();
                $state.reload();
            }).catch(function (err) {
                MessageService.error($translate.instant("loginMessages.incorrectUsernameOrPassword"));
                vm.authenticationError = true;
            });
        }


        $scope.getVerifyCode2 = function () {
            if (vm.registerAccount.phone == null || vm.registerAccount.phone == "") {
                MessageService.error($translate.instant("resetPassword.enterPhoneFirst"));
                return;
            }
            if (vm.disabled2) {
                return;
            }
            vm.countdown = 120;
            // 发送验证码到手机
            Customer.checkPhone({phone:vm.registerAccount.phone, storeId:vm.storeId}, function(data) {
                if (data.status != 200) {
                    VerifyCode.getVerifyCode({
                        phone: vm.registerAccount.phone,
                        storeId:vm.storeId,
                        incident: "忘记密码"
                    }, function (msg) {
                        clearInterval(timer);
                        timer = $interval(function () {
                            if (vm.countdown > 0) {
                                vm.disabled2 = true;
                                vm.countdown -- ;
                                $scope.paracont = $translate.instant("resetPassword.resendVerifyCode") + "(" + vm.countdown + ")";
                            } else {
                                vm.disabled2 = false;
                                $interval.cancel(timer);
                                $scope.paracont = $translate.instant("resetPassword.resendVerifyCode");
                            }
                        }, 1000);
                    });
                } else {
                    MessageService.info($translate.instant("loginMessages.userNotFound"));
                }
            })


        };


        $scope.checkVerifyCode = function(){
            VerifyCode.check({
                phone: vm.registerAccount.phone,
                code: vm.registerAccount.code,
            }, function (msg) {
                if (msg.status == 200 && msg.message==true) {
                    vm.checkCode = true;
                }else{
                   MessageService.error($translate.instant("resetPassword.verifyCodeFailed"));
                }
            },function(){
                MessageService.error($translate.instant("resetPassword.verifyCodeFailed"));
            });
        }

        $scope.checkPhone = function(){
            if (vm.registerAccount.phone == null) {
                return;
            }
            Customer.checkPhone({phone:vm.registerAccount.phone, storeId:vm.storeId}, function(data) {
                if (data.status != 200) {
                    MessageService.error($translate.instant("register.phoneAlreadyExists"));
                    vm.disabled = true;
                    vm.disabled2 = true;
                } else {
                    MessageService.info($translate.instant("register.phoneAvailable"));
                    vm.disabled = false;
                    vm.disabled2 = false;
                }
            })
        }


        function resetPassword () {
            if (!$scope.validata()) {
                return;
            }
            var postData = {
                phone:vm.registerAccount.phone,
                password:vm.registerAccount.password,
                storeId:vm.storeId
            }
            Customer.changePassword(postData,
                function(data) {
                    vm.loginContent = true;
                    vm.passwordReset = false;
                    vm.userRegister = false;
                    MessageService.success($translate.instant("resetPassword.resetSuccess"));
                    // $state.go("home", {storeId:vm.storeId});
                },
                function() {
                    MessageService.error($translate.instant("resetPassword.resetFailed"));
                });
        }

        $scope.validata = function(){
            if (vm.registerAccount.password == null || vm.registerAccount.password !== vm.confirmPassword) {
                MessageService.error($translate.instant("resetPassword.passwordMismatch"));
                return false;
            }
            if (vm.registerAccount.password.length <=4 || vm.registerAccount.password.length>= 50) {
                MessageService.error($translate.instant("resetPassword.passwordLength"));
                return false;
            }
            return true;
        }

        function register2(){
            if (!$scope.validata()) {
                return;
            }
            vm.registerAccount.langKey = $translate.use();
            vm.doNotMatch = null;
            vm.error = null;
            vm.errorUserExists = null;
            vm.errorEmailExists = null;
            VerifyCode.check({
                phone: vm.registerAccount.phone,
                code: vm.registerAccount.code,
                incident: "用户注册"
            }, function (msg) {
                if (msg.status == 200 && msg.message==true) {
                    vm.registerAccount.uuid = vm.uuid;
                    Customer.register2(vm.registerAccount, function(data){
                        if (data.status== 200) {
                            // vm.loginContent = true;
                            // vm.passwordReset = false;
                            // vm.userRegister = false;
                            // vm.userBinding = false;
                            // vm.loginText = true;
                            $localStorage.authenticationToken = data.message;
                            Account.get().$promise.then(getAccountThen);
                            $uibModalInstance.close();
                            // MessageService.success("注册成功,请前往登录");
                        }else{
                            MessageService.error(data.message);
                        }
                    },function(){
                        MessageService.error($translate.instant("register.registerFailed"));
                    });
                }else{
                   MessageService.error($translate.instant("resetPassword.verifyCodeFailed"));
                }
            },function(){
                 MessageService.error($translate.instant("resetPassword.verifyCodeFailed"));
            });
        }

        $scope.phoneChange = function(){
            if (vm.registerAccount.phone == null || vm.registerAccount.phone == "") {
                return;
            }
            if (vm.registerAccount.phone.length == 11) {
                $scope.checkPhone();
            }

        }

        function register () {
            if (!$scope.validata()) {
                return;
            }
            vm.registerAccount.langKey = $translate.use();
            vm.doNotMatch = null;
            vm.error = null;
            vm.errorUserExists = null;
            vm.errorEmailExists = null;
            VerifyCode.check({
                phone: vm.registerAccount.phone,
                code: vm.registerAccount.code,
                incident: "用户注册"
            }, function (msg) {
                if (msg.status == 200 && msg.message==true) {
                    Customer.register(vm.registerAccount, function(data){
                        if (data.status== 200) {
                            $localStorage.authenticationToken = data.message;
                            Account.get().$promise.then(getAccountThen);
                            $uibModalInstance.close();
                            // vm.loginContent = true;
                            // vm.passwordReset = false;
                            // vm.userRegister = false;
                            // MessageService.success("注册成功,请前往登录");
                        }else{
                            MessageService.error(data.message);
                        }
                    },function(){
                        MessageService.error($translate.instant("register.registerFailed"));
                    });
                }else{
                   MessageService.error($translate.instant("resetPassword.verifyCodeFailed"));
                }
            },function(){
                 MessageService.error($translate.instant("resetPassword.verifyCodeFailed"));
            });
        }

        $scope.showOrHidePassword = function () {
            if($(".fa").hasClass("fa-eye-slash")){
                $(".fa").removeClass("fa-eye-slash").addClass("fa-eye");
                $(".input-password").attr("type", "text");
            }else{
                $(".fa").removeClass("fa-eye").addClass("fa-eye-slash");
                $(".input-password").attr("type", "password");
            }

        }

    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('editorApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small data-translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal', '$uibModalInstance', 'AccountP', '$scope', 'MessageService', '$timeout', '$state', '$stateParams', '$cookieStore'];

    function PasswordController(Auth, Principal, $uibModalInstance, AccountP, $scope, MessageService, $timeout, $state, $stateParams, $cookieStore) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;
        vm.clear = clear;
        vm.storeId = $stateParams.storeId|| $cookieStore.get("store-id");
        if (!vm.storeId) {
            return;
        }
        vm.check = {};
        vm.check.old = 0;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        Principal.identity().then(function (account) {
            vm.account = account;
        });

        $scope.checkOldPassword = function () {
            AccountP.checkPassword({id: vm.account.id, password: vm.oldPassword}, function (msg) {
                if (msg[0] == 't') {
                    vm.check.old = 1;
                    return
                }
                vm.check.old = 0;
                $(".yzmStatus i:eq(1)").show();
            })
        };

        function changePassword() {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                var user = {
                    name: vm.account.name,
                    password: vm.password
                };
                vm.doNotMatch = null;
                Auth.changePassword(user).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                    $timeout(function () {
                        $uibModalInstance.close();
                        $state.go('home');
                    }, 1000);
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
            var t1 = setInterval(function () {
                $uibModalInstance.close(true);
                window.clearTimeout(t1);
            }, 2000);

        } 
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('editorApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
(function(){angular.module('editorApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/home/home.html','<!-- <div class=" mar-top-60"> \n    <div style="width: 25%;height:80px; background-image:url(\'content/images/lose.jpg\');" >\n    </div>\n</div> --><div class="login_bgi" ng-style="{\'width\': with}" style="height: auto; background-size: contain;position: absolute"><div class="col-md-3 col-md-offset-8 login_div"><div class="col-md-12" style="margin-top: 69px; text-align: center; margin-bottom: 35px"></div></div></div>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="activate.title">Activation</h1><div class="alert alert-success" ng-show="vm.success" data-translate="activate.messages.success" translate-compile><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="activate.messages.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row row-registers"><div class="registers"><button type="button" class="pad-5 close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h2 data-translate="password.title" class="register-title"></h2></div><div class="col-md-8 col-md-offset-2 register-body" style="margin-top: 10px"><div class="alert alert-success" ng-show="vm.success" data-translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group" style="position: relative"><label class="control-label" for="oldPassword" data-translate="global.form.oldPassword">old password</label><input type="password" class="form-control" id="oldPassword" name="oldPassword" placeholder="{{\'global.form.oldPassword.placeholder\' | translate}}" ng-model="vm.oldPassword" required ng-keyup="checkOldPassword()"><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p></div><div class="yzmStatus"><i ng-show="vm.check.old==1"></i> <i ng-show="vm.check.old==0"></i></div></div><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="5" ng-maxlength="50" required ng-disabled="vm.check.old!=1" ng-style="{cursor:(vm.check.old!=1)?\'not-allowed\':\'text\'}"><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 5 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="5" ng-maxlength="50" required ng-disabled="vm.check.old!=1" ng-style="{cursor:(vm.check.old!=1)?\'not-allowed\':\'text\'}"><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 5 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><div class="modal-footer"><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary btn-save" data-translate="password.form.button">Save</button></div></form></div></div></div>');
$templateCache.put('app/account/register/register.html','<form name="editForm" role="form" novalidate class="listBGC listCreate pad-0" style="left: -25%; width: 145%; border-radius: 12px"><img src="content/images/icons/log_close.png" style="position: absolute; top: -20px; right: 20px; z-index: 5" ng-click="close()"><div class="web-login-bg"><img style="width: 100%" ng-src="{{vm.loginLogo}}" ng-if="vm.loginContent"> <img style="width: 100%" ng-src="{{vm.registerLogo}}" ng-if="vm.userRegister"> <img style="width: 100%" ng-src="{{vm.loginLogo}}" ng-if="vm.passwordReset"></div><!-- \u767B\u5F55 --><div class="web-login-content" style="height: 550px;width: 425px" ng-if="vm.loginContent"><div ng-if="vm.loginText"><div class="col-md-12 col-lg-12 col-sm-12 web-login-titel mar-bottom-50 mar-top-30" style="font-size: 26px;margin-bottom: 40px">{{\'loginMessages.login\' | translate}}</div><div class="col-md-12 col-lg-12 col-sm-12 login-right mar-bottom-70" style="font-size: 13px;margin-bottom: 20px!important;width: 425px"><div class="col-md-8 col-lg-8 col-sm-8 col-md-offset-2 form-group"><div class="input-group" style="width: 100%"><span class="col-md-3 col-lg-3 col-sm-3 text-right" for="username"><img src="content/images/account.png" style="width: 25px"> </span><input type="text" class="col-md-8 col-lg-8 col-sm-8" id="username" placeholder="{{\'loginMessages.yourPhoneNumber\' | translate}}" style="font-size: 15px" ng-model="vm.phone"></div><div style="width: 100%; margin-top: 1px;height: 1px;border-top: 1px solid rgb(229, 230, 231)"></div></div><div class="col-md-2 col-lg-2 col-sm-2"></div></div><div class="col-md-12 col-lg-12 col-sm-12 login-right mar-bottom-70" style="font-size: 13px;margin-bottom: 20px!important;width: 425px"><div class="col-md-8 col-lg-8 col-sm-8 col-md-offset-2 form-group"><div class="input-group password" style="width: 100%;position: relative"><span class="col-md-3 col-lg-3 col-sm-3 text-right" for="password"><img src="content/images/password.png" style="width: 25px"> </span><input type="password" class="col-md-8 col-lg-8 col-sm-8 input-password" id="password" placeholder="{{\'global.form.password.placeholder\' | translate}}" style="font-size: 15px" ng-model="vm.password"> <i class="fa fa-eye-slash" ng-click="showOrHidePassword()"></i></div><div style="width:100%; margin-top: 1px; height: 1px;border-top: 1px solid rgb(229, 230, 231)"></div></div><div class="col-md-2 col-lg-2 col-sm-2"></div></div><div class="col-lg-12 col-sm-12 form-group mar-bottom-30"><div class="form-group"><div class="col-md-8 col-sm-5 col-xs-8 col-md-offset-2" style="text-align: center"><button type="button" class="col-md-12 col-sm-12 col-xs-12 btn btn-primary" ng-click="vm.login($event)" style="height: 45px; font-size:13pt; border-radius: 50px" translate="global.form.button">Sign in</button></div></div></div><div class="col-lg-12 col-sm-12 form-group current-menu"><div class="col-lg-4 col-sm-4 col-md-offset-2"><div class="form-group"><span ng-click="requestReset()" style="text-decoration: underline" class="current-menu">{{\'loginMessages.forgotPasswordQ\' | translate}}</span></div></div><div class="col-lg-4 col-sm-4 col-md-offset-2"><div class="form-group"><span ng-click="register()" style="text-decoration: underline" class="current-menu">{{\'loginMessages.mobileRegistration\' | translate}}</span></div></div></div><!-- <div class="col-lg-12 col-sm-12 form-group current-menu " >\n              <div class="col-lg-12 col-sm-12 text-center form-group" >\n                <hr/>\n                <div style=" margin-top: -14px; background-color: white; width: 25%; left: 38%; position: absolute;">\u5176\u4ED6\u767B\u5F55\u65B9\u5F0F</div>\n              </div>\n              <div class="col-lg-12 col-sm-12 text-center form-group current-menu " >\n                <img src="content/images/icons/wechat.png" ng-click="showQrCode()" >\n              </div>\n            </div> --></div><div ng-show="!vm.loginText" class="text-center" style="top: 20%; position: absolute"><div class="col-lg-12 col-sm-12"><span id="login_container"></span></div><div class="col-lg-12 col-sm-12 form-group"><div class="col-lg-12 col-sm-12 text-center form-group current-menu"><hr><div style="margin-top: -14px; background-color: white; width: 25%; left: 38%; position: absolute">{{\'loginMessages.otherLoginMethods\' | translate}}</div></div><div class="col-lg-12 col-sm-12 text-center form-group"><span ng-click="showPhoneLogin()">{{\'loginMessages.phoneLogin\' | translate}}</span></div></div></div></div><!-- \u6CE8\u518C --><div class="web-login-content" ng-if="vm.userRegister" style="height: 555px;width: 425px"><div class="col-md-12 col-lg-12 col-sm-12 web-login-titel mar-bottom-30" style="font-size: 26px">{{\'loginMessages.register\' | translate}}</div><div class="col-md-12 col-lg-12 col-sm-12 login-right mar-bottom-30"><div class="col-md-9 col-lg-9 col-sm-9 col-md-offset-1 form-group"><div class="input-group" style="width: 100%"><span class="col-md-1 col-lg-1 col-sm-1 no-padding" for="username"><img src="content/images/icons/ic_phone.png"> </span><input type="text" class="col-md-7 col-lg-7 col-sm-7" id="username" name="username" placeholder="{{\'loginMessages.enterPhoneNumber\' | translate}}" ng-model="vm.registerAccount.phone" style="font-size: 15px" ng-blur="checkPhone()"> <a id="sendMobileCode" style="color: #FE5454; font-size: 10px;padding: 8px 0px 0px 0px" ng-click="getVerifyCode()" class="btn btn-10 ml10 checkLogin" ng-disabled="vm.disabled" ng-bind="paracont"></a></div><div style="width: 100%; margin-top: 1px;height: 1px;border-top: 1px solid rgb(229, 230, 231)"></div></div><div class="col-md-2 col-lg-2 col-sm-2"></div></div><div class="col-md-12 col-lg-12 col-sm-12 login-right mar-bottom-30"><div class="col-md-9 col-lg-9 col-sm-9 col-md-offset-1 form-group"><div class="input-group" style="width: 100%"><span class="col-md-1 col-lg-1 col-sm-1 no-padding" for="verifycode"><img src="content/images/icons/ic_yanzheng.png"> </span><input class="col-md-8 col-lg-8 col-sm-8" type="text" id="verifycode" name="verifycode" placeholder="{{\'loginMessages.enterVerificationCode\' | translate}}" ng-model="vm.registerAccount.code" style="font-size: 15px" ng-blur="checkVerifyCode()"></div><div style="width: 100%; margin-top: 1px;height: 1px;border-top: 1px solid rgb(229, 230, 231)"></div></div><div class="col-md-2 col-lg-2 col-sm-2"></div></div><div class="col-md-12 col-lg-12 col-sm-12 login-right mar-bottom-30"><div class="col-md-9 col-lg-9 col-sm-9 col-md-offset-1 form-group"><div class="input-group" style="width: 100%"><span class="col-md-1 col-lg-1 col-sm-1 no-padding" for="password"><img src="content/images/icons/password.png"> </span><input class="col-md-8 col-lg-8 col-sm-8" type="password" id="password" name="password" placeholder="{{\'loginMessages.enterPassword\' | translate}}" style="font-size: 15px" ng-model="vm.registerAccount.password" required></div><div style="width: 100%; margin-top: 1px;height: 1px;border-top: 1px solid rgb(229, 230, 231)"></div></div><div class="col-md-2 col-lg-2 col-sm-2"></div></div><div class="col-md-12 col-lg-12 col-sm-12 login-right mar-bottom-30"><div class="col-md-9 col-lg-9 col-sm-9 col-md-offset-1 form-group"><div class="input-group" style="width: 100%"><span class="col-md-1 col-lg-1 col-sm-1 no-padding"><img src="content/images/icons/password.png"> </span><input class="col-md-8 col-lg-8 col-sm-8" type="password" placeholder="{{\'loginMessages.repeatPassword\' | translate}}" style="font-size: 15px" ng-model="vm.confirmPassword" required></div><div style="width: 100%; margin-top: 1px; height: 1px;border-top: 1px solid rgb(229, 230, 231)"></div></div><div class="col-md-2 col-lg-2 col-sm-2"></div></div><div class="col-md-10 col-lg-10 col-sm-10 col-md-offset-1 text-center mar-bottom-30"><button type="button" class="col-md-12 col-sm-12 col-xs-12 btn btn-primary" ng-click="vm.register()" ng-disabled="!vm.checkCode" style="height: 48px; font-size:16pt; border-radius: 50px">{{\'loginMessages.register\' | translate}}</button></div><div class="col-md-12 col-lg-12 col-sm-12 text-center mar-bottom-30"><span style="cursor: pointer;color: #FE5454" ng-click="hasUser()">{{\'button.hasAccountLoginNow\' | translate}}</span></div></div><!-- \u7ED1\u5B9A\u624B\u673A\u53F7 --><div class="web-login-content" ng-if="vm.userBinding"><div class="col-md-12 col-lg-12 col-sm-12 web-login-titel mar-bottom-30">{{\'loginMessages.bindPhone\' | translate}}</div><div class="col-md-12 col-lg-12 col-sm-12 login-right mar-bottom-30"><div class="col-md-9 col-lg-9 col-sm-9 col-md-offset-1 form-group"><div class="input-group" style="width: 100%"><span class="col-md-1 col-lg-1 col-sm-1 no-padding" for="username"><img src="content/images/icons/ic_phone.png"> </span><input type="text" class="col-md-7 col-lg-7 col-sm-7" id="username" placeholder="{{\'loginMessages.enterPhoneNumber\' | translate}}" ng-model="vm.registerAccount.phone" ng-blur="checkPhone()"> <a id="sendMobileCode" style="color: #FE5454; font-size: 10px;padding: 8px 0px 0px 0px" ng-click="getVerifyCode()" class="btn btn-10 ml10 checkLogin" ng-disabled="vm.disabled" ng-bind="paracont"></a></div><div style="width: 100%; margin-top: 1px;height: 1px;border-top: 1px solid rgb(229, 230, 231)"></div></div><div class="col-md-2 col-lg-2 col-sm-2"></div></div><div class="col-md-12 col-lg-12 col-sm-12 login-right mar-bottom-30"><div class="col-md-9 col-lg-9 col-sm-9 col-md-offset-1 form-group"><div class="input-group" style="width: 100%"><span class="col-md-1 col-lg-1 col-sm-1 no-padding"><img src="content/images/icons/ic_yanzheng.png"> </span><input class="col-md-8 col-lg-8 col-sm-8" type="text" placeholder="{{\'loginMessages.enterVerificationCode\' | translate}}" ng-model="vm.registerAccount.code" ng-blur="checkVerifyCode()"></div><div style="width: 100%; margin-top: 1px;height: 1px;border-top: 1px solid rgb(229, 230, 231)"></div></div><div class="col-md-2 col-lg-2 col-sm-2"></div></div><div class="col-md-12 col-lg-12 col-sm-12 login-right mar-bottom-30"><div class="col-md-9 col-lg-9 col-sm-9 col-md-offset-1 form-group"><div class="input-group" style="width: 100%"><span class="col-md-1 col-lg-1 col-sm-1 no-padding"><img src="content/images/icons/password.png"> </span><input class="col-md-8 col-lg-8 col-sm-8" type="password" placeholder="{{\'loginMessages.enterPassword\' | translate}}" ng-model="vm.registerAccount.password" required></div><div style="width: 100%; margin-top: 1px;height: 1px;border-top: 1px solid rgb(229, 230, 231)"></div></div><div class="col-md-2 col-lg-2 col-sm-2"></div></div><div class="col-md-12 col-lg-12 col-sm-12 login-right mar-bottom-30"><div class="col-md-9 col-lg-9 col-sm-9 col-md-offset-1 form-group"><div class="input-group" style="width: 100%"><span class="col-md-1 col-lg-1 col-sm-1 no-padding"><img src="content/images/icons/password.png"> </span><input class="col-md-8 col-lg-8 col-sm-8" type="password" placeholder="{{\'loginMessages.repeatPassword\' | translate}}" ng-model="vm.confirmPassword" required></div><div style="width: 100%; margin-top: 1px; height: 1px;border-top: 1px solid rgb(229, 230, 231)"></div></div><div class="col-md-2 col-lg-2 col-sm-2"></div></div><div class="col-md-12 col-lg-12 col-sm-12 text-center mar-bottom-30"><button type="button" class="col-md-12 col-sm-12 col-xs-12 btn btn-primary" ng-click="vm.register2()" ng-disabled="!vm.checkCode" style="height: 55px; font-size:22pt; border-radius: 50px">{{\'button.bind\' | translate}}</button></div><div class="col-md-12 col-lg-12 col-sm-12 text-center mar-bottom-30"><span style="cursor: pointer;color: #FE5454" ng-click="hasUser()">{{\'button.hasAccountLoginNow\' | translate}}</span></div></div><!-- \u5FD8\u8BB0\u5BC6\u7801 --><div class="web-login-content" ng-if="vm.passwordReset"><div class="col-md-12 col-lg-12 col-sm-12 web-login-titel mar-bottom-30">{{\'loginMessages.resetPassword\' | translate}}</div><div class="col-md-12 col-lg-12 col-sm-12 login-right mar-bottom-50"><div class="col-md-9 col-lg-9 col-sm-9 col-md-offset-1 form-group"><div class="input-group" style="width: 100%"><span class="col-md-1 col-lg-1 col-sm-1 no-padding" for="username"><img src="content/images/icons/ic_phone.png"> </span><input type="text" class="col-md-7 col-lg-7 col-sm-7" id="username" placeholder="{{\'loginMessages.enterPhoneNumber\' | translate}}" ng-model="vm.registerAccount.phone"> <a id="sendMobileCode" style="color: #FE5454; font-size: 10px;padding: 8px 0px 0px 0px" ng-click="getVerifyCode2()" class="btn btn-10 ml10 checkLogin" ng-disabled="vm.disabled2" ng-bind="paracont"></a></div><div style="width: 100%; margin-top: 1px;height: 1px;border-top: 1px solid rgb(229, 230, 231)"></div></div><div class="col-md-2 col-lg-2 col-sm-2"></div></div><div class="col-md-12 col-lg-12 col-sm-12 login-right mar-bottom-30"><div class="col-md-9 col-lg-9 col-sm-9 col-md-offset-1 form-group"><div class="input-group" style="width: 100%"><span class="col-md-1 col-lg-1 col-sm-1 no-padding"><img src="content/images/icons/ic_yanzheng.png"> </span><input class="col-md-8 col-lg-8 col-sm-8" type="text" placeholder="{{\'loginMessages.enterVerificationCode\' | translate}}" ng-model="vm.registerAccount.code" ng-blur="checkVerifyCode()"></div><div style="width: 100%; margin-top: 1px;height: 1px;border-top: 1px solid rgb(229, 230, 231)"></div></div><div class="col-md-2 col-lg-2 col-sm-2"></div></div><div class="col-md-12 col-lg-12 col-sm-12 login-right mar-bottom-30"><div class="col-md-9 col-lg-9 col-sm-9 col-md-offset-1 form-group"><div class="input-group" style="width: 100%"><span class="col-md-1 col-lg-1 col-sm-1 no-padding"><img src="content/images/icons/password.png"> </span><input class="col-md-8 col-lg-8 col-sm-8" type="password" placeholder="{{\'loginMessages.enterPassword\' | translate}}" ng-model="vm.registerAccount.password" required></div><div style="width: 100%; margin-top: 1px;height: 1px;border-top: 1px solid rgb(229, 230, 231)"></div></div><div class="col-md-2 col-lg-2 col-sm-2"></div></div><div class="col-md-12 col-lg-12 col-sm-12 login-right mar-bottom-30"><div class="col-md-9 col-lg-9 col-sm-9 col-md-offset-1 form-group"><div class="input-group" style="width: 100%"><span class="col-md-1 col-lg-1 col-sm-1 no-padding"><img src="content/images/icons/password.png"> </span><input class="col-md-8 col-lg-8 col-sm-8" type="password" placeholder="{{\'loginMessages.repeatPassword\' | translate}}" ng-model="vm.confirmPassword" required></div><div style="width: 100%; margin-top: 1px; height: 1px;border-top: 1px solid rgb(229, 230, 231)"></div></div><div class="col-md-2 col-lg-2 col-sm-2"></div></div><div class="col-md-12 col-lg-12 col-sm-12 text-center mar-bottom-30"><button type="button" class="col-md-12 col-sm-12 col-xs-12 btn btn-primary" ng-click="vm.resetPassword()" ng-disabled="!vm.checkCode" style="height: 55px; font-size:22pt; border-radius: 50px">{{\'button.resetPassword\' | translate}}</button></div><div class="col-md-12 col-lg-12 col-sm-12 text-center mar-bottom-30"><span style="cursor: pointer;color: #FE5454" ng-click="hasUser()">{{\'button.loginImmediately\' | translate}}</span></div></div></form>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="settings.messages.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName" data-translate="settings.form.firstname">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" data-translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" data-translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" data-translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName" data-translate="settings.form.lastname">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" data-translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" data-translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" data-translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">Email</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your email is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your email is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your email is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your email cannot be longer than 100 characters.</p></div></div><div class="form-group"><label for="langKey" data-translate="settings.form.language">Language</label><select id="langKey" name="langKey" class="form-control" ng-model="vm.settingsAccount.langKey" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="settings.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2 data-translate="audits.title">Audits</h2><div class="row"><div class="col-md-5"><h4 data-translate="audits.filter.title">Filter by date</h4><p class="input-group"><span class="input-group-addon" data-translate="audits.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" data-translate="audits.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span data-translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span data-translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span data-translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span data-translate="audits.table.header.data">Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span data-translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2 data-translate="configuration.title">Configuration</h2><span data-translate="configuration.filter">Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><h3 ng-hide="filteredConfig.length === 0">Spring configuration</h3><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length === 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span data-translate="configuration.table.prefix">Prefix</span></th><th data-translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-success break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><h4 ng-hide="filtered.length === 0"><span>{{key}}</span></h4><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length === 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-success break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top" title="Swagger UI"></iframe>');
$templateCache.put('app/admin/gateway/gateway.html','<div><h2 data-translate="gateway.title">Gateway</h2><h3 data-translate="gateway.routes.title">Current routes</h3><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()" ng-show="vm.updatingRoutes === false"><span class="glyphicon glyphicon-refresh glyphicon-"></span>&nbsp;<span data-translate="gateway.refresh.button">Refresh</span></button> <button type="button" class="btn btn-danger" ng-show="vm.updatingRoutes"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="gateway.refresh.button">Refresh</span></button></p><table class="table table-striped table-responsive"><thead><tr><th data-translate="gateway.routes.url">URL</th><th data-translate="gateway.routes.service">Service</th><th data-translate="gateway.routes.servers">Available servers</th></tr></thead><tr ng-repeat="route in vm.gatewayRoutes"><td>{{route.path}}</td><td>{{route.serviceId}}</td><td><div ng-show="{{route.serviceInstances.length === 0}}" class="label label-danger" data-translate="gateway.routes.error">Warning: no server available!</div><table class="table table-responsive"><tr ng-repeat="instance in route.serviceInstances"><td>{{instance.host}}:{{instance.port}}</td><td ng-show="{{instance.instanceInfo.status === \'UP\'}}"><div class="label label-success">{{instance.instanceInfo.status}}</div></td><td ng-hide="{{instance.instanceInfo.status === \'UP\'}}"><div class="label label-danger">{{instance.instanceInfo.status}}</div></td></tr></table></td></tr></table></div>');
$templateCache.put('app/admin/health/health.html','<div><h2 data-translate="health.title">Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" data-translate="health.table.service">Service Name</th><th class="col-md-2 text-center" data-translate="health.table.status">Status</th><th class="col-md-2 text-center" data-translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 data-translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" data-translate="health.details.name">Name</th><th class="col-md-6 text-left" data-translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 data-translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2 data-translate="logs.title">Logs</h2><p data-translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</p><span data-translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span data-translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span data-translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2 data-translate="metrics.title">Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="metrics.refresh.button">Refresh</span></button></p><h3 data-translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b data-translate="metrics.jvm.memory.title">Memory</b><p><span data-translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span data-translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" data-translate="metrics.updating">Updating...</div><h3 data-translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span data-translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span data-translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.jvm.http.table.code">Code</th><th data-translate="metrics.jvm.http.table.count">Count</th><th class="text-right" data-translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td data-translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" data-translate="metrics.servicesstats.table.count">Count</th><th class="text-right" data-translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" data-translate="metrics.servicesstats.table.min">Min</th><th class="text-right" data-translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" data-translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" data-translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" data-translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" data-translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 data-translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span data-translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right" data-translate="metrics.datasource.count">Count</th><th class="text-right" data-translate="metrics.datasource.mean">Mean</th><th class="text-right" data-translate="metrics.datasource.min">Min</th><th class="text-right" data-translate="metrics.datasource.p50">p50</th><th class="text-right" data-translate="metrics.datasource.p75">p75</th><th class="text-right" data-translate="metrics.datasource.p95">p95</th><th class="text-right" data-translate="metrics.datasource.p99">p99</th><th class="text-right" data-translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" data-translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" data-translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th data-translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/entities/commodity/commodity-preview.html','<div class="c-modal"><div class="c-modal-head" style="border: none"><span>{{\'commodity.view.preview\' | translate}}</span> <img style="float: right" src="content/images/close.png" ng-click="modalHide()"></div><div class="c-modal-body" style="padding: 0px 40px"><div class="swiper-container" ng-style="{height: vm.height/2,width:vm.height/2}"><div class="swiper-wrapper"><div class="swiper-slide" ng-style="{ lineHeight: vm.height/2 +\'px\'}" ng-repeat="data in vm.imgs track by $index" ng-if="vm.imgs.length > 0"><img ng-if="!!domain" ng-src="{{data.identifier ? data.identifier : \'content/images/notImg.png\'}}" ng-alt="{{data.identifier}}"> <span class="noData-text">{{"hint.noData" | translate}}</span></div><div class="swiper-slide" ng-if="vm.imgs.length == 0" ng-style="{ lineHeight: vm.height/2 +\'px\'}"><img src="content/images/notImg.png" style="width: 210px"> <span class="noData-text">{{"hint.noData" | translate}}</span></div></div></div><div class="swiper-pagination" style="width: 46px;\n    float: right;\n    border-radius: 4px;\n    position: relative;\n    background: #000000;\n    opacity: 0.5;\n    color: white !important"></div><div class="swiper-button-next" style="right: 30px"></div><div class="swiper-button-prev" style="left: 30px"></div></div><div class="c-modal-foot"><button class="c-modal-btn c-modal-btn-submint" ng-if="vm.isShowbotton" ng-click="modalSubmint()">{{\'commodity.view.editImmediately\' | translate}}</button></div></div><style>.modal-content{\n        margin: 50px auto;\n    }\n    .swiper-container {\n        margin: 0 auto;\n    }\n    .swiper-button-next{\n        position: absolute;\n        right: 100px;\n    }\n    .swiper-pagination{\n        position: absolute;\n        bottom: 10px;\n        width: 100%;\n    }\n    .swiper-button-prev{\n        position: absolute;\n        left: 100px;\n    }\n    .swiper-slide {\n        text-align: center;\n        font-size: 18px;\n        background: #fff;\n    }\n    .swiper-slide img{\n        max-width: 100%;\n        max-height: 100%;\n    }</style>');
$templateCache.put('app/entities/commodity/commodity-select.html','<div class="col-md-12 col-sm-12 col-xs-12" style="min-height: 100vh"><div style="display: flex; height: 15px; align-items: center"></div><div class="col-md-12 col-sm-12 col-xs-12 pad-0"><div class="col-md-2 col-sm-2 col-xs-2"><img src="content/images/back.png" ng-click="returnurl1()"></div><div style="width: 1200px; padding-bottom:30px; margin: 0 auto"><div style="font-size: 24px"><span>{{vm.product.name}} </span><span style="float: right;position:relative" ng-show="vm.lagnuages.length>1"><div class="lang-div" ng-click="showLagnuages()"><span class="lang-icn"><i class="iconfont iconyoujian"></i> </span><span>{{vm.langKey}} &nbsp; &nbsp;</span></div><br><div class="lang-option-div" ng-show="vm.showLagnuages"><div class="lang-option" ng-repeat="lang in vm.lagnuages" ng-style="{\'color\':lang.selected ? \'var(--genericColor)\' : \'#999999\'}" ng-click="changeLagnuage(lang)">{{lang.key}}</div></div></span></div><!-- <div ng-repeat="objectValue in vm.product.itemValue.objectValues"  class="c-commodity-top" ng-show= "vm.product.editorType== \'PICTURE\' || vm.product.editorType== \'PICTURE_PRO\' || vm.product.editorType== \'PICTURE_PRO_P\'">\n                <span class="c-commodity-top-title">{{objectValue.propertyName}}</span>\n                <span style="display: inline-block;" class="c-commodity-top-content">\n                    <span ng-repeat = "pv in objectValue.propertyValues" ng-click="switchPaper(objectValue, pv)"  ng-class="{\'default-color\': pv.selected}" >{{pv.value}}</span>\n                </span>\n            </div> --></div></div><div class="col-md-12 col-sm-12 col-xs-12 pad-0"><div class="bc-ffffff" style="width: 1200px;  padding: 30px 0px; margin: 0 auto; overflow: hidden"><!--            <div class="col-md-12 col-sm-12 col-xs-12" style="justify-content: left;display: flex;">--><!--                <div class="xml-theme" ng-repeat="theme in vm.themeList track by $index" ng-class="{\'them-selected\': vm.themeId == theme.id}"  ng-click="themeCb(theme)"  >--><!--                    <span >{{theme.name}}</span>--><!--                </div>--><!--            </div>--><div class="clearfix" style="position: relative"><div class="swiper-container1 c-commodity-top-content" style="margin: 0 32px 20px 32px"><div class="swiper-wrapper" style="height: 30px;text-align: center"><div class="swiper-slide" ng-repeat="theme in vm.themeList track by $index" ng-click="themeCb(theme)"><div title="{{theme.name}}" ng-class="{\'them-selected\': vm.themeId == theme.id}" class="theme-name-view">{{theme.name}}</div></div></div></div><div class="swiper-button-prev1 swiper-pre-mask"></div><div class="swiper-button-prev1 swiper-pre-btn"></div><div class="swiper-button-next1 swiper-next-mask"></div><div class="swiper-button-next1 swiper-next-btn"></div></div><ul class="col-md-12 col-sm-12 col-xs-12 pad-0" style="margin-top:10px" ng-if="vm.productXmlList.length > 0"><li ng-repeat="data in vm.productXmlList track by $index" style="width: 233px; float: left;padding: 0px 0px 0px 33px" ng-click="commodityPreview(data)"><div class="c-works3" style="height: 295px"><div class="c-works3-img"><img ng-src="{{data.coverImg ? data.coverImg +\'?imageMogr2/interlace/1/thumbnail/400x400>\': \'content/images/icon/notImg.svg\'}}" alt=""><div class="c-works3-mask"><div class="c-works3-btn">{{\'commodity.select.goEditing\' | translate}}</div></div></div><div class="c-works3-bottom"><!-- <span class="c-works3-text1-1">{{data.name}} </span> --> <span>{{data.name}} </span><span class="c-works3-text1-2"><span class="c-works3-text1-2-span"><span ng-repeat="v in vm.itemValue.objectValues track by $index">{{v.propertyValueValue}}<span ng-show="!$last">,</span></span> <span class="c-works3-text1-2-hr" style="position: relative;top: 4px" ng-show="vm.product.editorType != \'PICTURE\' && vm.product.editorType != \'PICTURE_PRO\' && vm.product.editorType != \'PICTURE_PRO_P\'"></span> <span ng-show="vm.product.editorType != \'PICTURE\' && vm.product.editorType != \'PICTURE_PRO\' && vm.product.editorType != \'PICTURE_PRO_P\'"><span>{{\'commodity.select.photoBook\' | translate}}:</span> <span ng-show="vm.product.aiFill&& data.minPicQuantity!=data.maxPicQuantity">{{data.minPicQuantity}}~{{data.maxPicQuantity}}</span> <span ng-show="vm.product.aiFill && data.minPicQuantity == data.maxPicQuantity">{{data.minPicQuantity}}</span> <span ng-show="!vm.product.aiFill">{{data.picQuantity}}</span> <span>{{\'commodity.select.pieces\' | translate}}</span></span></span></span></div></div></li></ul><div class="c-noData" ng-if="vm.productXmlList.length == 0"><img src="content/images/noData.png" alt="" style="width: 60px"><p>{{\'commodity.select.emptyContent\' | translate}}</p></div><div id="biuuu_city" style="text-align: center"></div></div></div></div><copy-right store-id="vm.storeId"></copy-right><style>.lang-option{\n        height: 20px;\n        font-size: 14px;\n        color: #108DFE;\n        line-height: 20px;\n        margin-top: 18px;\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n    }\n\n    .lang-option:hover{\n        color:#108DFE !important;\n    }\n\n    .lang-div{\n        position: relative;\n        width: 100%;\n        height: 36px;\n        line-height: 36px;\n        background-color: #1E1F22;\n        border-radius: 22px;\n        font-size: 14px;\n        font-weight: bold;\n        padding: 0px 16px;\n        color: #ffffff;\n        border: 1px solid rgba(255,255,255,0.2);\n    }\n    .lang-icn{\n        transform: rotate(90deg);\n        position: absolute;\n        right: 10px;\n        top: 0px;\n    }\n    .lang-icn i{\n        margin: 0 !important;\n    }\n\n    .lang-option-div{\n        width: 172px;\n        height: 224px;\n        font-size: 14px;\n        font-weight: bold;\n        padding: 0px 16px;\n        color: #666666;\n        border: 1px solid rgba(255,255,255,0.2);\n        background: #FFFFFF;\n        box-shadow: 0px 2px 8px 0px rgb(0 0 0 / 14%);\n        border-radius: 8px;\n        position: absolute;\n        z-index: 100;\n    }\n\n\n    .theme-name-view{\n        font-size: 18px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n\n    .swiper-button-prev1{\n        background: url("content/images/icon/icon-previousPage.png")no-repeat;\n    }\n\n    .swiper-button-next1{\n        background: url("content/images/icon/icon-nextPage.png")no-repeat;\n    }\n\n    .swiper-button-prev1.swiper-button-disabled, .swiper-button-next1.swiper-button-disabled {\n        opacity: 0;\n        width: 1px;\n    }\n\n\n\n\n    .swiper-button-prev1 {\n        position: absolute;\n        z-index: 10;\n        background-size: 10px;\n        background-position: center;\n    }\n\n    .swiper-pre-mask{\n        left: 18px;\n        top: -5px;\n        width: 110px;\n        height: 30px;\n        background: linear-gradient(270deg, rgba(255,255,255,0.1) 0%, #FFFFFF 100%);\n        border-radius: 0;\n        pointer-events: none;\n    }\n\n    .swiper-pre-btn{\n        left: 10px;\n        top: -6px;\n        height: 30px;\n        width: 30px;\n        background-color: #fff;\n        border-radius: 15px;\n        box-shadow: 0px 2px 8px 0px rgb(0 0 0 / 9%);\n    }\n\n    .swiper-button-next1 {\n        position: absolute;\n        z-index: 10;\n        margin-top: -6px;\n        background-size: 10px;\n        background-position: center;\n    }\n\n    .swiper-next-mask{\n        width: 110px;\n        height: 30px;\n        background: linear-gradient(90deg, rgba(255,255,255,0.1) 0%, #FFFFFF 100%);\n        border-radius: 0;\n        left: 1085px;\n        top: 0;\n        pointer-events: none;\n\n    }\n\n    .swiper-next-btn{\n        left: 1160px;\n        width: 30px;\n        height: 30px;\n        top: 0;\n        background-color: #fff;\n        border-radius: 15px;\n        box-shadow: 0px 2px 8px 0px rgb(0 0 0 / 9%);\n    }</style>');
$templateCache.put('app/entities/gallery/gallery-upload.html','<div style="background: #fff;width: 100vw;min-height: 100vh;position: fixed;left: 0;top: 0;z-index: 1"><div style="width: 100%; padding-top: 25%" ng-if="vm.uploadPhotoItem.length == 0 && photos.length == 0"><div class="col-md-12 col-sm-12 col-xs-12 text-center pad-10 center-middle"><img src="content/images/phone_chuantu.svg"> <span class="col-xs-12 pad-top-20">{{\'uploadContent.selectAlbums\' | translate}}</span></div><div class="col-md-12 col-sm-12 col-xs-12 text-center" style="margin-top: 30%"><button style="width: 242px;height: 46px; border-radius: 23px; color: var(--webMainButtonTextColor); font-size: 14px; background: var(--webMainButtonBackColor); border: none" ng-if="agentIos" ng-click="uploadPhoto()">{{\'uploadContent.selectPicture\' | translate}}</button> <button style="width: 242px;height: 46px; border-radius: 23px; color: var(--webMainButtonTextColor); font-size: 14px; background: var(--webMainButtonBackColor); border: none" ng-if="!agentIos">{{\'uploadContent.selectPicture\' | translate}}</button> <input ng-if="!agentIos" onchange="uploadImageMutiple(event)" id="uploadImg" type="file" multiple="multiple" accept="image/png, image/jpeg, .livp" name="file" style="opacity:0; position:absolute;top:0;left:0"></div></div><div style="width: 100%; padding-top: 5%;overflow: auto;height: 100vh" ng-if="vm.uploadPhotoItem.length> 0 || photos.length > 0"><ul><li class="photo-content" ng-repeat="data in vm.uploadPhotoItem" ng-if="(!data.state || data.state == \'success\') && vm.uploadPhotoItem.length>0"><div><progres-view :src="data.blobCover" :progres="data.percent"></progres-view></div></li><li ng-if="!gallery.cancelled" class="photo-content" ng-repeat="gallery in photos track by $index" class="photo-content"><img src="content/images/phone_delete.svg" ng-click="deletePic(gallery.id, $index)" style="position: absolute; top: 3px; right: 3px"> <img ng-src="{{gallery.largeFlag ? (gallery.largeStatus ==\'done\' ? gallery.blobCover :\'content/images/largeLoading.jpg\') : gallery.blobCover}}" class="imgPhoto shadow-div" ng-if="gallery.blobCover"></li></ul><div class="col-md-12 col-sm-12 col-xs-12 text-center" style="bottom: 40px; position: fixed; z-index: 99"><button style="width: 242px;height: 46px; border-radius: 23px; color: var(--webMainButtonTextColor); font-size: 14px; background: var(--webMainButtonBackColor); border: none" ng-if="agentIos" ng-click="uploadPhoto()">{{\'uploadContent.continueUpload\' | translate}}</button> <button style="width: 242px;height: 46px; border-radius: 23px; color: var(--webMainButtonTextColor); font-size: 14px; background: var(--webMainButtonBackColor); border: none" ng-if="!agentIos">{{\'uploadContent.continueUpload\' | translate}}</button> <input ng-if="!agentIos" onchange="uploadImageMutiple(event)" id="uploadImg" type="file" multiple="multiple" accept="image/png, image/jpeg, .livp" name="file" style="opacity:0; position:absolute;top:0;left:0"></div></div><upload-image2 store-id="vm.storeId" upload-photo-item="vm.uploadPhotoItem" folder-id="vm.fid" aid="vm.aid"></upload-image2><!--\u91CD\u590D\u56FE\u7247--><duplicate-list domain-url="vm.domain" ng-if="vm.isDuplicateList" list="vm.duplicateList" on-change="duplicateChange(text)"></duplicate-list></div>');
$templateCache.put('app/entities/gallery/gallery.html','<div class="panel-body no-padding" style="background: #fff"><ul class="folder-nav col-md-12 col-sm-12 col-xs-12" ng-show="!moveGallery&&!folderInside"><li class="col-md-6 col-sm-6 col-xs-6" ng-click="galleryNavSel()"><div ng-class="{\'folder-head-active\':currentNav==\'gallery\'}">{{\'folder.photo\' | translate}}</div></li><li class="col-md-6 col-sm-6 col-xs-6" ng-click="folderNavSel()"><div ng-class="{\'folder-head-active\':currentNav==\'folder\'}">{{\'folder.folderText\' | translate}}</div></li></ul><header class="folder-inside" ng-show="folderInside"><div class="index-back"><span class="opacityMinus" ng-click="hideFolderContent()"><div class="tabIcons back-work"></div></span></div><span class="mar-left-54 text-ellip" style="width: 43vw">{{folderOne.name}}</span></header><div ng-show="currentNav==\'gallery\'"><div class="choose_none bg" ng-show="noPic"><span class="nonePic nonePhoto"></span><div translate="editorApp.gallery.noPicTips" class="categoryPrice"></div></div><div class="save-pages hide1"><div class="save-page1"><div class="imgLoading"><div class="loadImg"></div><p class="imgText" translate="hint.loadingImages"></p></div></div></div><div class="col-md-12 col-sm-12 col-xs-12 no-padding mar-bottom-60 photo-show mar-top-60" ng-style="{\'margin-bottom\':(delBar)?\'50px\':\'0px\'}" ng-hide="noPic"><!-- \u4E2A\u4EBA\u4E2D\u5FC3\u56FE\u5E93\u663E\u793A --><div class="photo-item" ng-repeat="photo in photos track by $index" ng-init="outerIndex = $index"><div class="photo_header">{{photo.createDate}} <span ng-click="selectedPhoto($index, photo)"><!-- \u5168\u9009\u5220\u9664 --> <span class="select-icon select-all" ng-show="!!photo.select_photoAll"></span> <span class="select-icon selectCurrent" ng-show="!photo.select_photoAll"></span></span></div><ul class="photos border-bottom" ng-cloak><li ng-repeat="gallery in photo.galleries track by $index" class="photo-content" ng-click="selectThis(gallery, photo,outerIndex)" ng-if="domain != null"><img ng-src="{{domain + gallery.identifier +\'?imageView2/1/w/150/h/150\'||\'//:0\'}}" alt="" class="imgPhoto shadow-div" style="pointer-events: none;user-select: none;-webkit-user-select: none;-webkit-touch-callout: none"> <span><!-- \u5355\u9009\u5220\u9664 --><div class="select-icon select-all" ng-show="gallery.select_photo||photos.select_photoAll"></div><div class="select-icon select-none" ng-show="!gallery.select_photo"></div></span><div ng-if="gallery.imgSize/1024 < 150 " class="lowerSize"><div style="height: 15vw;line-height: 25vw"><img src="content/images/ic_pixel2.svg" alt="" style="pointer-events: none;user-select: none;-webkit-user-select: none;-webkit-touch-callout: none"></div><div style="height: 15vw;line-height: 15vw">{{\'hint.lowResolution\' | translate}}</div></div></li></ul></div></div><div class="col-md-12 col-sm-12 col-xs-12 text-center" align="content"><img ng-if="vm.more" class="loadingPic" src="content/images/loading.gif"></div></div><div class="folder-file pad-bottom-50" ng-show="currentNav==\'folder\'"><header class="top-menu" ng-show="moveGallery" style="position: fixed;z-index:1000"><div class="index-back"><span class="opacityMinus" ng-click="backTo()"><div class="tabIcons back-work"></div></span></div><span class="top-title">{{\'hint.selectTargetFolder\' | translate}}</span><div class="floatRight commit-div edit-save" ng-click="saveMove()">{{\'button.confirm\' | translate}}</div></header><ul class="folder-list" ng-style="{\'padding-top\':\'50px\'}"><li ng-show="moveGallery"><div class="folder-namebar" ng-click="selectSingle(\'\',1)"><span class="namebar-left text-ellip"><img src="content/images/icons/folder.svg"> <span class="folder-name">{{\'folder.photo\' | translate}}</span> </span><button class="choose-one" ng-show="selectOne.folderId==\'\'&&selectOne.selected"></button></div></li><li ng-repeat="folder in Folders track by $index" class="folder-li{{$index}} folder-li"><!--\u79FB\u52A8\u56FE\u7247--><div class="folder-namebar" ng-click="selectSingle(folder,1)" ng-show="moveGallery"><span class="namebar-left text-ellip"><img src="content/images/icons/folder.svg"> <span class="folder-name{{$index}} folder-name">{{folder.name}}</span> </span><button class="choose-one" ng-show="folder.selected"></button></div><!--\u6587\u4EF6\u5939\u5904\u7406--><div class="folder-namebar" ng-show="!moveGallery"><span class="namebar-left text-ellip" ng-click="showFolderContent(folder)"><img src="content/images/icons/folder.svg"> <span class="folder-name{{$index}} folder-name">{{folder.name}}</span> </span><span ng-click="selectFolders(folder)"><i class="sel-true" ng-if="folder.selected"></i> <i class="sel-false" ng-if="!folder.selected"></i></span></div></li></ul></div><div class="col-md-12 col-sm-12 col-xs-12 footer-del pad-0"><div class="folder-footer" ng-show="currentNav==\'gallery\'"><div class="folder-add folder-btn"><span class="add-img opacityMinus" ng-if="agentIos" ng-click="uploadPhoto()"><!-- \u56FE\u7247\u5E93\u9009\u62E9\u4E0A\u4F20 --> <span class="select-icons add-photo"></span> <span data-translate="editorApp.gallery.localGallery" class="categoryPrice" style="font-size: 12px"></span> </span><span class="add-img opacityMinus" ng-if="!agentIos" style="position:relative;display:inline-block"><!-- \u56FE\u7247\u5E93\u9009\u62E9\u4E0A\u4F20 --> <span class="select-icons add-photo"></span> <span data-translate="editorApp.gallery.localGallery" class="categoryPrice" style="font-size: 12px"></span> <input onchange="uploadImageMutiple(event)" id="uploadImg" type="file" multiple="multiple" accept="{{vm.supportedMimeTypes}}" name="file" value="" style="opacity:0; position:absolute;top:0;left:0"></span></div><div class="folder-delete folder-btn" ng-click="moveToFolder()" ng-show="delBar"><img src="content/images/icons/folder-move.svg"><div class="text textActive">{{\'gallery.move\' | translate}}</div></div><div class="folder-delete folder-btn" ng-show="delBar" ng-click="deleteThis()"><img src="content/images/icons/folder-del.svg" style="width: 20px"><div class="textActive">{{\'button.delete\' | translate}}</div></div><div class="folder-all folder-btn" ng-click="showDeleteBtn()" ng-show="delBar"><img src="content/images/icons/folder-choose-all.svg"><div class="textActive">{{\'button.selectAll\' | translate}}</div></div></div><div class="folder-footer" ng-show="currentNav==\'folder\'&&!moveGallery"><div class="folder-add folder-btn" ng-click="addFolder()"><img src="content/images/icons/folder-add-sel.svg"><div class="text textActive">{{\'gallery.addFolder\' | translate}}</div></div><div class="folder-editName folder-btn2" ng-click="editFolder()" ng-show="folderIds.length>0"><img src="content/images/icons/folder-edit.svg" ng-show="folderIds.length==1"> <img src="content/images/icons/folder-edit-gray.svg" ng-show="folderIds.length>1"><div class="text textActive" ng-class="{\'folder-grayText\':folderIds.length>1}">{{\'gallery.rename\' | translate}}</div></div><div class="folder-delete folder-btn2" ng-click="deleteFolders()" ng-show="folderIds.length>0"><img src="content/images/icons/folder-del.svg" style="width: 20px"><div class="text textActive">{{\'button.delete\' | translate}}</div></div><div class="folder-all folder-btn2" ng-click="chooseAll(1)" ng-show="folderIds.length>0"><img src="content/images/icons/folder-choose-all.svg"><div class="text textActive">{{\'button.selectAll\' | translate}}</div></div></div><div class="iphoneX-content col-md-12 col-sm-12 col-xs-12 no-padding"></div></div></div>');
$templateCache.put('app/entities/gallery/uplpadImage.html','<div class="z-modal" ng-if="loadingAllSuccess" ng-class="{\'error-modal\' : errorImageArrCb() > 0}" ng-click="closeErrorMoadl()"><div class="z-modal-body" ng-class="{\'error-modal-body\' : errorImageArrCb() > 0}"><div class="close-btn" ng-if="errorImageArrCb() > 0" ng-click="closeErrorMoadl()"><i style="font-size: 26px" class="close-icon1 iconfont iconguanbi1"></i></div><div class="z-modal-body-icon"><i class="icon iconfont iconjichu01"></i></div><span>{{\'uploadContent.uploadSuccess\' | translate}}{{schedule()}}</span><div class="z-modal-body-error-view" ng-if="errorImageArrCb()>0"><span class="tips">{{\'uploadContent.uploadSuccess1\' | translate}}{{successImageArrCb()}}</span> <span class="tips">{{\'uploadContent.uploadError\' | translate}}<span style="color: #ED2121">{{errorImageArrCb()}}</span></span> <span style="color: #0A8DFE; margin-left: 8px" ng-click="lookErrorImages()">{{\'button.view\' | translate}}</span></div></div></div><div class="save-pages2 hide1"><div class="save-page2"><div class="imgLoading"><div class="loadImg2"></div><p class="imgText2" ng-if="schedule()">{{\'uploadContent.pictureUploadWait\' | translate}} {{schedule()}}</p><p class="imgText2" ng-if="!schedule()">{{\'uploadContent.pictureUploadWait1\' | translate}}</p><!--            <div class="imgText2" style="display: flex; justify-content: center; align-items: center;">--><!--                <div ng-if="errorImageArrCb() > 0" style="margin-right: 20px;">{{\'button.error\' | translate}}\uFF1A<span style="color: #9c0000;font-size: 16px; font-weight: bold;">{{errorImageArrCb()}}</span></div>--><!--                <div ng-if="successImageArrCb() > 0">{{\'button.success\' | translate}}\uFF1A<span style="color: #1ea7b2;font-size: 16px; font-weight: bold;">{{successImageArrCb()}}</span></div>--><!--            </div>--></div></div></div><!-- <div class="z-modal" ng-if="bigSizeTip">\n    <div class="z-modal-body3">\n        <div class="z-modal-body3-title">{{\'uploadContent.bigPictureTip\' | translate}}</div>\n        <div class="z-modal-body-icon">\n            <img src="content/images/high_size.png" width="65%">\n        </div>\n        <div class="z-modal-body3-tip" translate="uploadContent.pictureBigContent" translate-values="{higherSizeLen:higherSizeLen}"></div>\n        <div class="z-modal-body3-confirm" ng-click="filterBigSize()">{{\'uploadContent.confirm\' | translate}}cc</div>\n    </div>\n</div> --><div class="c-errorImage-view" ng-if="isLookErrorImages"><div class="c-errorImage-view-content"><div class="c-errorImage-view-head"><span>{{\'uploadContent.goGallery\' | translate}}</span> <i class="iconfont iconguanbi1" ng-click="errorImageHide()"></i></div><div class="c-errorImage-view-body" style="background: #FFFFFF"><div class="c-errorImage-view-body-li" ng-repeat="item in errorImageArr_ track by $index"><img ng-src="{{item.blobCover}}" alt="" class="c-image"><progres-view :progres="item.percent" ng-if="item.state != \'error\'"></progres-view></div></div><div class="c-errorImage-view-foot"><div class="c-errorImage-view-btn1" ng-click="errorImageHide()">{{\'uploadContent.goBack1\' | translate}}</div><div class="c-errorImage-view-btn" ng-click="reUpload()">{{\'uploadContent.reupload\' | translate}}</div></div></div></div><div class="c-bigSizeImage-view" ng-if="bigSizeTip"><div class="c-bigSizeImage-view-content"><div class="c-bigSizeImage-view-head"><div></div><span>{{\'gallery.bigImageTitle\' | translate}}</span> <i class="iconfont iconguanbi1" ng-click="filterBigSize()"></i></div><div class="c-bigSizeImage-view-body" style="background: #FFFFFF"><div>{{\'gallery.bigImageWarning\' | translate: {count: userCtrl.higherSize.length} }}</div><div class="c-bigSizeImage-view-body-li" ng-repeat="item in userCtrl.higherSize track by $index"><img ng-src="{{item.blobCover}}" alt="" class="c-image" onerror="this.onerror=null;this.src=\'content/images/tooLarge.png\'"><div class="c-bigsize-name" title="{{item.name}}">{{item.name}}</div><div class="c-bigsize-text-size">{{item.size / 1048576 | number:2}}M</div></div></div><div class="c-bigSizeImage-view-foot"><!-- <div class="c-bigSizeImage-view-btn1" ng-click="filterBigSize()">{{\'uploadContent.goBack1\' | translate}}</div> --><div class="c-bigSizeImage-view-btn" ng-click="filterBigSize()">{{\'button.confirm\' | translate}}</div></div></div></div><div class="three-modal2" ng-if="threeError"><div class="three-modal2-body"><div>{{threeErrorText}}</div></div></div><style>.error-modal{\n        background: rgba(0,0,0,0.5);\n    }\n    .error-modal-body{\n        background: #FFFFFF;\n        position: relative;\n    }\n    .error-modal-body .close-btn{\n        position: absolute;\n        right: 10px;\n        top: 10px;\n    }\n    .error-modal-body i,.error-modal-body span{\n        color: #999999;\n    }\n    .error-modal-body .tips{\n        color: #666666;\n    }\n\n    .c-bigSizeImage-view-body-li {\n        height: auto;\n        /* min-height: 160px; */\n        flex-direction: column;\n        justify-content: flex-start;\n        position: relative;\n        padding: 6px;\n    }\n    .c-bigSizeImage-view-body-li .c-image {\n        max-width: 100%;\n        max-height: 100px;\n        object-fit: contain;\n    }\n    .c-bigsize-name {\n        max-width: 100%;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        font-size: 12px;\n        color: #666;\n        margin-top: 6px;\n        width: 100%;\n        text-align: center;\n    }\n    .c-bigsize-text-size {\n        font-size: 11px;\n        color: #999;\n        margin-top: 2px;\n        width: 100%;\n        text-align: center;\n        position: absolute;\n        background: #000000b8;\n        bottom: 30px;\n        right: 0;\n        left: 0;\n    }</style>');
$templateCache.put('app/entities/components/article-preview.html','<!--<div class="save-page hide1" ng-cloak>--><!--    <div>--><!--        <img src="content/images/loading.gif">--><!--        <span>\u8BF7\u7A0D\u5019</span>--><!--    </div>--><!--</div>--><div class="loading-page" ng-if="vm.loading"><div class="book"><div class="book__page"><div class="book__page__fill"></div><div class="book__page__fill"></div><div class="book__page__fill"></div><div class="book__page__fill"></div><div class="book__page__fill"></div></div></div><span>{{\'editorCommon.loadingText\' | translate}}</span></div><div class="c-preview-top-btn" ng-if="(template.config.productType == \'BOOK\'&&vm.bindingtype==\'Left\') && vm.isLandscape"><div class="c-preview-top-btn-1" ng-class="{\'c-preview-top-btn-select\' : !vm.landscape}" ng-click="landscape(false)">{{\'editorCommon.porTrait\' | translate}}</div><div class="c-preview-top-btn-1" ng-class="{\'c-preview-top-btn-select\' : vm.landscape}" ng-click="landscape(true)">{{\'editorCommon.landscape\' | translate}}</div></div><div ng-cloak ng-show="!vm.loading"><div class="preview-view-tab" ng-if="vm.bindingtypes.length>1 && vm.isNav"><!--        <div class="preview-view-tab-name">{{bindingtypeInfo()}}</div>--><div class="preview-view-tab-list"><div class="preview-view-tab-list-li" ng-repeat="item in vm.bindingtypes" ng-click="bindingtypeSelect(item)" ng-class="{\'preview-view-tab-list-li-select\' : item.id == vm.bindingtype}">{{item.name}}</div></div></div><div class="c-article-preview-view" ng-show="(template.config.productType == \'BOOK\'||template.config.productType == \'CALENDAR\')&&vm.bindingtype != \'Tile\'"><div id="pageView" ng-style="{\n                width: vm.pageMaxWidth,\n                height: vm.pageMaxHeight,\n                \'transform\': \'rotateZ(\' + (!vm.landscape ? 0 : 90) + \'deg)\',\n             }"><div id="bb-bookblock" class="bb-bookblock" ng-style="{\n                width: vm.pageMaxWidth,\n                height: vm.pageMaxHeight,\n             }"><i class="iconfont iconzuoceshouqi prevImg" ng-if="(vm.bindingtype==\'Left\' || vm.bindingtype==\'LeftNew\') && vm.thisPage>0 && vm.isNav" ng-click="prevPage(vm.thisPage)"></i> <i class="iconfont iconyouceshouqi nextImg" ng-if="(vm.bindingtype==\'Left\' || vm.bindingtype==\'LeftNew\') && vm.thisPage<vm.insidePages.length-1 && vm.isNav" ng-click="nextPage(vm.thisPage)"></i><div class="bb-item" data-partid="{{page.partid}}" ng-repeat="page in vm.insidePages track by $index" style="width: 100%; display: flex; flex-wrap:nowrap" ng-if="vm.bindingtype==\'Left\' || vm.bindingtype==\'LeftNew\'" ng-click="flipPage($event, $index)"><div class="page-item" ng-if="page.page1"><div class="page-item-box-shadow" ng-style="{\n                                    \'margin-left\':page.page1.marginLeft,\n                                    \'margin-top\':(vm.pageMaxHeight-page.page1.custom.height * page.page1.ratio)/2\n                                    }"><page-preview page="page.page1" scale="page.page1.ratio"></page-preview></div></div><div class="page-item" ng-if="page.page2"><div class="page-item-box-shadow" ng-style="{\n                                    \'margin-left\':page.page2.marginLeft,\n                                    \'margin-top\':(vm.pageMaxHeight-page.page2.custom.height * page.page2.ratio)/2\n                                    }"><page-preview page="page.page2" scale="page.page2.ratio"></page-preview></div></div></div><div class="bb-item" data-partid="{{page.partid}}" data-producttype="{{vm.documentPage.config.productType}}" ng-repeat="page in vm.insidePages track by $index" style="width: 100%; display: flex; flex-wrap: wrap" ng-if="vm.bindingtype == \'Top\'" ng-click="flipPage($event, $index,\'Top\')"><div class="page-item1" ng-if="page.page1"><div class="page-item-box-shadow" ng-style="{\n                            \'margin-top\':page.page1.marginLeft,\n                            \'margin-left\':(vm.pageMaxWidth-page.page1.custom.width * page.page1.ratio)/2\n                            }"><page-preview page="page.page1" scale="page.page1.ratio"></page-preview></div></div><div class="page-item1" ng-if="page.page2"><div class="page-item-box-shadow" ng-style="{\n                        \'margin-top\':page.page2.marginLeft,\n                        \'margin-left\':(vm.pageMaxWidth-page.page2.custom.width * page.page2.ratio)/2\n                        }"><page-preview page="page.page2" scale="page.page2.ratio"></page-preview></div></div></div><div class="c-flip-top clearfix" ng-if="template.config.productType == \'CALENDAR\' && vm.bindingtype==\'Top\' && vm.isLandscape"><div class="c-flip-top-li pull-left" ng-if="vm.thisPage>0" ng-click="prevPage(vm.thisPage)"><div class="c-flip-top-li-icon"><i class="iconfont iconzuoceshouqi1"></i></div><span>{{\'gallery.previousPage\' | translate}}</span></div><div class="c-flip-top-li pull-right" ng-if="vm.thisPage<vm.insidePages.length-1" ng-click="nextPage(vm.thisPage)"><span>{{\'gallery.nextPage\' | translate}}</span><div class="c-flip-top-li-icon"><i class="iconfont iconyouceshouqi1"></i></div></div></div></div></div><div class="preview-view-left-2 hover-scrollbar hover-scrollbar1" drag-scroll ng-if="vm.isNav && !vm.loading"><div class="preview-view-left-2-part" ng-repeat="part in vm.navParts"><div class="preview-view-left-2-page" ng-if="part.id != \'P\'" ng-click="jumpPage(part.id)"><div class="preview-view-left-2-page-item" ng-repeat="pageItem in part.pages" ng-class="{\'pageSelect\' : vm.insidePages[vm.thisPage].partid == part.id}"><div class="pageIndex"><span uib-tooltip="{{part.name}}" tooltip-placement="bottom">{{part.name}}</span></div><page-preview page="pageItem" scale="vm.ratio1"></page-preview></div></div><div class="preview-view-left-2-page" ng-if="part.id == \'P\'"><div class="preview-view-left-2-page-item1" ng-repeat="page in vm.insidePages" ng-if="page.partid == \'P\'" ng-click="jumpPage(page.partid,$index)" ng-class="{\'pageSelect\' : vm.insidePages[vm.thisPage].partid == page.partid && vm.thisPage == $index}"><div class="preview-view-left-2-page-item1-view" ng-if="page.page1"><page-preview page="page.page1" scale="vm.ratio1"></page-preview></div><div class="preview-view-left-2-page-item1-view" ng-if="page.page2 && !page.page2.spread"><page-preview page="page.page2" scale="vm.ratio1"></page-preview></div><div class="pageIndex"><span ng-class="{\'pageIndex-not\' : !page.page1.pageNumber}">{{page.page1.pageNumber}}</span> <span ng-class="{\'pageIndex-not\' : !page.page2.pageNumber}">{{page.page2.pageNumber}}</span></div></div></div></div></div></div><div ng-if="template.config.productType == \'THING\'"><div style="width: fit-content;margin: 50px auto;\n    box-shadow: 0 0 10px 8px rgba(0, 0, 0, 0.1)" ng-repeat="item in template.pages.page track by $index"><page-preview page="item" scale="item.custom.ratio"></page-preview></div></div><div ng-if="template.config.productType == \'PHOTO\'" style="position: relative; z-index: 99"><editor-photo-preview preview-article="vm.documentPage" article="vm.article"></editor-photo-preview></div><div class="tile-view" ng-if="(template.config.productType == \'BOOK\'||template.config.productType == \'CALENDAR\') && vm.bindingtype == \'Tile\'"><div class="tile-view-item" ng-repeat="page in template.pages.page"><page-preview page="page" scale="vm.ratioTile"></page-preview></div></div></div><style>.page-item{\n        width: 50%;\n        height: 100%;\n        /*overflow: hidden;*/\n    }\n    .page-item1{\n        width: 100%;\n        height: 50%;\n        /*overflow: hidden;*/\n    }\n    .preview-view-left-2{\n    position: fixed;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    width: 100%;\n    background: #fff;\n    overflow-x: auto;\n    overflow-y: hidden;\n    padding: 16px;\n    display: flex;\n    flex-wrap: nowrap;\n    z-index: 1000;\n    box-shadow: 0px 0px 13px 0 rgba(0, 0, 0, 0.3);\n    cursor: grab;\n    user-select: none;\n    -webkit-user-select: none;\n}\n.preview-view-left-2-part{\n    display: flex;\n    flex-shrink: 0;\n    margin-right: 15px;\n    border-right: 1px solid #ddd;\n}\n.preview-view-left-2-part:last-child{\n    border: 0;\n}\n.preview-view-left-2-page{\n    display: flex;\n    flex-shrink: 0;\n}\n\n.preview-view-left-2-page-item{\n    margin-right: 15px;\n    position: relative;\n    flex-shrink: 0;\n}\n.preview-view-left-2-page-item1{\n    position: relative;\n    height: fit-content;\n    margin-right: 15px;\n    display: flex;\n    flex-shrink: 0;\n}\n.preview-view-left-2-page-item1-view{\n    position: relative;\n    flex-shrink: 0;\n}\n/* \u5E95\u90E8\u5BFC\u822A\u6A2A\u5411\u6EDA\u52A8\u6761\u5E38\u9A7B\u663E\u793A */\n.preview-view-left-2.hover-scrollbar::-webkit-scrollbar{\n    height: 8px;\n}\n.preview-view-left-2.hover-scrollbar::-webkit-scrollbar-track{\n    background-color: #f0f0f0;\n    border-radius: 4px;\n}\n.preview-view-left-2.hover-scrollbar::-webkit-scrollbar-thumb{\n    background-color: #969696 !important;\n    border: none !important;\n    border-radius: 4px;\n}\n.preview-view-left-2.hover-scrollbar::-webkit-scrollbar-thumb:hover{\n    background-color: #6a6a6a;\n}\n    .pageIndex{\n        position: absolute;\n        top: -10px;\n        left: 0;\n        width: 100%;\n        display: flex;\n        justify-content: space-around;\n        z-index: 9;\n    }\n    .pageIndex span{\n        display: block;\n        padding: 2px 10px;\n        background: #777;\n        border-radius: 10px;\n        font-size: 12px;\n        color: #fff;\n        max-width: 80%;\n        overflow: hidden;\n        white-space: nowrap;\n        -o-text-overflow: ellipsis;\n        text-overflow: ellipsis;\n    }\n    .pageIndex span.pageIndex-not{\n        background: none !important;\n    }\n    .pageSelect{\n        border: 1px solid #299DFF;\n    }\n    .pageSelect .pageIndex span{\n        background: #299DFF;\n    }\n    .prevImg{\n        position: absolute;\n        left: -50px;\n        top: 50%;\n        font-size: 20px;\n        margin-top: -10px;\n    }\n    .nextImg{\n        position: absolute;\n        right: -50px;\n        top: 50%;\n        font-size: 20px;\n        margin-top: -10px;\n    }\n    .page-item-box-shadow{\n        /*box-shadow: 0px 0px 13px 0 rgba(0, 0, 0, 0.3);*/\n    }\n    .c-flip-top{\n        position: absolute;\n        left: 50%;\n        bottom: -40px;\n        width: 100vw;\n        margin-left: -50vw;\n        padding: 0 6px;\n    }\n    .c-flip-top-li{\n        height: 35px;\n        display: flex;\n        align-items: center;\n    }\n    .c-flip-top-li-icon{\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        width: 30px;\n        height: 30px;\n        box-shadow: 0 0 4px 1px rgba(0,0,0,0.1);\n        color: #0a0a0a;\n        background: #fff;\n        border-radius: 15px;\n        overflow: hidden;\n        margin: 0 5px;\n    }\n    .c-flip-top-li span{\n        line-height: 20px;\n        color: #0a0a0a;\n    }</style>');
$templateCache.put('app/entities/components/background-list.html','<div class="editor-nav-view-li"><div class="bgimg-color"><div class="leftPanel-bg-text">{{\'nav.background.content.title\' | translate}}</div><div class="leftPanel-bg-head"><div id="picker"></div><input class="leftPanel-bg-choose-color leftPanel-bg-color" type="color" ng-change="chooseColor()" ng-model="vm.bgColor" value="#000000"> <button class="leftPanel-bg-color leftPanel-bg-choose-mask"></button> <button class="leftPanel-bg-color" ng-repeat="color in vm.colorArr1" ng-click="chooseBgColor(color)" ng-style="{background:color,border:$first?\'1px solid #DADADA\':none,\'margin-left\': $index == 0 ? \'7px\' : \'0\'}"></button></div><div class="leftPanel-bg-text mar-top-20">{{\'nav.background.content.title1\' | translate}}</div><div class="leftPanel-bg-head" style="margin-bottom: 20px"><button class="custom-grid2 leftPanel-bg-color" ng-click="chooseBgColor()"></button> <button class="leftPanel-bg-color" ng-repeat="color in vm.colorArr2" ng-click="chooseBgColor(color)" ng-style="{background:color,border:$index==4?\'1px solid #DADADA\':none}"></button></div></div><div class="leftPanel-head"><div class="leftPanel-privacy"><button ng-repeat="label in vm.bgImglabels track by $index" ng-click="vm.bgImglabelCb(label,$index)" data-index="{{$index}}" class="leftPanel-privacy-btn" ng-show="$index<9||showbgImgdocLabels" ng-class="{\'leftPanel-privacy-btn-active\':vm.Theme == \'Three\'&&label.id==vm.bgImgChooseId.id,\'leftPanel-privacy-btn-active\':label.id==vm.bgImgChooseId.id}">{{label.name}}</button><div class="leftPanel-privacy-btn-more" ng-if="bglabels.length >8"><div ng-if="!showbgImgdocLabels" ng-click="showMorebgImgdocLabels()"><span>{{\'button.spread\' | translate}}</span><i class="iconfont iconzhankaigengduo11 font-12"></i></div><div ng-if="showbgImgdocLabels" ng-click="showMorebgImgdocLabels()"><span>{{\'button.packUp\' | translate}}</span><i class="iconfont iconyouceshouqi11 font-12"></i></div></div></div></div><div class="nav-mask mar-top-20"><ul id="main4"><li ng-repeat="bgImg in vm.bgImgList track by $index" data-index="{{$index}}" ng-click="chooseBgimg(bgImg)" class="nav-mask-div" style="position: relative;z-index: 1"><img ng-src="{{bgImg.identifier | imageFilter}}" style="max-width: 100%;max-height:100%"></li></ul><button class="load-more" style="bottom:10px" ng-if="vm.bgImgFulfill" ng-click="loadMoreBgImg()">{{\'button.loadMore\' | translate}}</button><div class="default-diagram" ng-show="vm.bgImgList.length == 0"><img src="content/images/default-diagram.png"><div>{{\'hint.noData\' | translate}}</div></div><div class="text-center" ng-if="!vm.bgImgFulfill && vm.bgImgList.length>0"><span class="tip-text">{{\'hint.noMore\' | translate}}</span></div></div></div><style>.leftPanel-bg-text{\n        margin: 0 0 10px 0;\n        color: #333;\n    }\n    .leftPanel-bg-head{\n        padding: 0;\n    }</style>');
$templateCache.put('app/entities/components/canvas-image-filter.html','<div class="canvas-image-filter-main"><div class="editor-head" style="width: 100%"><div class="editor-head-1"><div class="editor-logo" ng-if="vm.logo"><img ng-src="{{vm.logo}}"></div><div class="editor-title" uib-tooltip="{{vm.productXmlLine.name}}" tooltip-placement="bottom-left" ng-if="vm.productTitle && vm.productXmlLine">{{vm.productTitle}}\uFF08 {{vm.productXmlLine.name}} \uFF09</div></div><div class="page-head-save" style="line-height: 36px"><span class="save-exit" ng-click="close($event)" role="button" tabindex="0">{{\'button.close\' | translate}}</span> <span class="save-release" ng-click="save($event)" role="button" tabindex="0">{{\'button.save\' | translate}}</span></div></div><div class="body"><div class="operation"><div class="roundedSet-title mar-bottom-20"><h4 class="rightPanel-title">{{\'editorBtn.imageOptimizationTitle\' | translate}}</h4></div><div><div class="col-lg-12 col-sm-12 col-xs-12 pad-0 mar-bottom-20"><div class="col-lg-12 col-sm-12 col-xs-12 optimization-body-li"><div class="col-lg-6 col-sm-6 col-xs-6 text-left optimization-body-li-text">{{\'editorBtn.luminance\' | translate}}</div><div class="col-lg-6 col-sm-6 col-xs-6 text-right optimization-body-li-num">{{vm.elementOn.item.image.brightness || 0}}</div></div><div class="col-lg-12 col-sm-12 col-xs-12 optimization-body-li"><input type="range" min="-100" max="100" step="1" value="0" class="text-range-100 rangeSize lighter-range" ng-model="vm.elementOn.item.image.brightness" ng-change="changeOperation()"></div></div><div class="col-lg-12 col-sm-12 col-xs-12 pad-0 mar-bottom-20"><div class="col-lg-12 col-sm-12 col-xs-12 optimization-body-li"><div class="col-lg-6 col-sm-6 col-xs-6 text-left optimization-body-li-text">{{\'editorBtn.contrast\' | translate}}</div><div class="col-lg-6 col-sm-6 col-xs-6 text-right optimization-body-li-num">{{vm.elementOn.item.image.contrast || 0}}</div></div><div class="col-lg-12 col-sm-12 col-xs-12 optimization-body-li"><input type="range" min="-100" max="100" step="1" value="0" class="text-range-100 rangeSize contrast-range" ng-model="vm.elementOn.item.image.contrast" ng-change="changeOperation()"></div></div><div class="col-lg-12 col-sm-12 col-xs-12 pad-0 mar-bottom-20"><div class="col-lg-12 col-sm-12 col-xs-12 optimization-body-li"><div class="col-lg-6 col-sm-6 col-xs-6 text-left optimization-body-li-text">{{\'editorBtn.colorSaturation\' | translate}}</div><div class="col-lg-6 col-sm-6 col-xs-6 text-right optimization-body-li-num">{{vm.elementOn.item.image.saturate || 0}}</div></div><div class="col-lg-12 col-sm-12 col-xs-12 optimization-body-li"><input type="range" min="-100" max="100" step="1" value="0" class="text-range-100 rangeSize saturation-range" ng-model="vm.elementOn.item.image.saturate" ng-change="changeOperation()"></div></div><div class="col-lg-12 col-sm-12 col-xs-12 pad-0 mar-bottom-20"><div class="col-lg-12 col-sm-12 col-xs-12 optimization-body-li"><div class="col-lg-6 col-sm-6 col-xs-6 text-left optimization-body-li-text">{{\'editorBtn.colorTemperature\' | translate}}</div><div class="col-lg-6 col-sm-6 col-xs-6 text-right optimization-body-li-num">{{vm.elementOn.item.image.temperature || 0}}</div></div><div class="col-lg-12 col-sm-12 col-xs-12 optimization-body-li"><input type="range" min="-100" max="100" step="1" value="0" class="text-range-100 rangeSize saturation-range" ng-model="vm.elementOn.item.image.temperature" ng-change="changeOperation()"></div></div><div class="col-lg-12 col-sm-12 col-xs-12 pad-0 mar-bottom-20"><div class="col-lg-12 col-sm-12 col-xs-12 optimization-body-li"><div class="col-lg-6 col-sm-6 col-xs-6 text-left optimization-body-li-text">{{\'editorBtn.colorHue\' | translate}}</div><div class="col-lg-6 col-sm-6 col-xs-6 text-right optimization-body-li-num">{{vm.elementOn.item.image.hue || 0}}</div></div><div class="col-lg-12 col-sm-12 col-xs-12 optimization-body-li"><input type="range" min="-100" max="100" step="1" value="0" class="text-range-100 rangeSize saturation-range" ng-model="vm.elementOn.item.image.hue" ng-change="changeOperation()"></div></div></div></div><div class="canvas" id="canvas"><div class="loading" ng-show="vm.loading" ng-style="{\'width\': vm.imgWidth + \'px\',\'height\':vm.imgHeight + \'px\',\'transform\': \'translate(-50%,-50%) scale(\' + vm.scale + \')\'}"><img src="content/images/loading.gif" style="width: 5%;transform: translate(-50%, -50%)"></div><canvas id="imageFilter" ng-style="{\'transform\': \'scale(\' + vm.scale + \')\'}"></canvas><div class="editor-body-view-ratio" style="right: 30px"><div class="editor-body-view-ratio-right"><div class="editor-body-view-ratio-icon" ng-click="ratioJian()"><i class="iconfont iconjian2"></i><div class="editor-body-view-ratio-title">{{\'editorCommon.canvasReduce\' | translate}}</div></div><span class="editor-body-view-ratio-span">{{(vm.scale * 100).toFixed(2)}}%</span><div class="editor-body-view-ratio-icon" ng-click="ratioJia()"><i class="iconfont iconjia2"></i><div class="editor-body-view-ratio-title">{{\'editorCommon.canvasMagnify\' | translate}}</div></div><div class="editor-body-view-ratio-icon" ng-click="ratioInit()"><i class="iconfont iconfangda"></i><div class="editor-body-view-ratio-title">{{\'editorCommon.initialScale\' | translate}}</div></div><div class="editor-body-view-ratio-icon" ng-click="ratioOriginal()"><i class="iconfont icona-1bi11"></i><div class="editor-body-view-ratio-title">{{\'editorCommon.canvasInitial\' | translate}}</div></div><div class="editor-body-view-ratio-icon" style="width: 52px" ng-mousedown="mouseDown()" ng-mouseup="mouseUp()">\u5BF9\u6BD4\u539F\u56FE</div></div></div><img id="oldImage" ng-src="{{vm.domain + vm.elementOn.item.image.resource.primary}}" ng-style="{\'transform\': \'translate(-50%,-50%) scale(\' + vm.scale + \')\'}" ng-show="vm.contrast"></div></div></div>');
$templateCache.put('app/entities/components/chalk-view.html','<div class="three-modal"><div class="c-modal" ng-if="!vm.isMobile"><div class="c-modal-head" style="border: none"><span style="font-weight: bold">{{"chalk.editTitle" | translate:{type:(type | serviceType)} }}</span> <img style="float: right; width: 20px" src="content/images/icons/log_close.png" ng-click="modalHide()"></div><div class="c-modal-body chalk-view" style="text-align: left"><div class="chalk-view-1" ng-if="type == \'white\'"><div class="chalk-view-1-1" ng-if="!imagebox.whiteInk2">{{"chalk.whiteNoCoverage" | translate}}</div><div class="chalk-view-1-1 chalk-view-1-2" ng-if="imagebox.whiteInk2">{{"chalk.whiteCoverage" | translate}}</div><div class="chalk-view-1-3"><div ng-style="{\n                        position: \'relative\',\n                        width: vm.scale * width,\n                        height: vm.scale * height}"><img ng-src="{{imagebox.image.resource.identifier+\'?imageMogr2/thumbnail/800x800>\'}}" style="width: 100%; height: 100%;opacity: 0.2"><div class="chalk-view-1-3-1" ng-if="imagebox.whiteInk2" ng-style="{\n                            \'-webkit-mask-image\': imagebox.whiteInk2 ? \'url(\' + imagebox.whiteInk2.resource.identifier + \')\' : \'none\',\n                            \'-webkit-mask-size\': \'100% 100%\'}"><img ng-src="{{imagebox.image.resource.identifier+\'?imageMogr2/thumbnail/800x800>\'}}" style="width: 100%; height: 100%;opacity: 0.2"></div></div></div></div><div class="chalk-view-1" ng-if="type != \'white\'"><div class="chalk-view-1-3"><div ng-style="{\n                        position: \'relative\',\n                        width: vm.scale * width,\n                        height: vm.scale * height}"><div class="gold-foil-text" ng-if="imageart.resource.identifier" style="width: 100%;height:100%" ng-style="{\n                            \'background\': goldFoil(imageart.spotColor.color),\n                            \'-webkit-mask-image\': \'url(\' + imageart.resource.identifier + \')\',\n                            \'-webkit-mask-size\': \'100% 100%\'\n                            }"><img ng-src="{{imageart.resource.identifier | imageFilter}}" style="width: 100%; height: 100%;opacity:0"></div><div class="not-text" ng-if="!imageart.resource || !imageart.resource.identifier">{{"chalk.noFile" | translate}}</div></div></div></div><div class="chalk-view-2"><div class="chalk-view-2-1" ng-if="type == \'white\'"><div class="chalk-view-2-1-1 custom-grid2"><img ng-src="{{imagebox.image.resource.identifier+\'?imageMogr2/thumbnail/800x800>\'}}" style="max-width: 100%; max-height: 100%"></div><i class="iconfont iconlianjie"></i><div class="chalk-view-2-1-1 custom-grid2"><img ng-src="{{imagebox.whiteInk2.resource.identifier}}" style="max-width: 100%; max-height: 100%" ng-if="imagebox.whiteInk2"></div></div><div class="chalk-view-2-2"><i class="iconfont iconshangchuanzhaopian1"></i> <span>{{"chalk.upload" | translate}}</span> <input onchange="updateWhite(event)" type="file" accept="image/png"></div><div class="chalk-view-2-2 chalk-view-2-2-delete" ng-click="imagebox.whiteInk2 = null" ng-if="type == \'white\' && imagebox.whiteInk2"><i class="iconfont iconqingchu"></i> <span>{{"chalk.clear" | translate}}</span></div><div class="chalk-view-2-2 chalk-view-2-2-delete" ng-click="imageartDelete()" ng-if="type != \'white\' && imageart.resource.identifier"><i class="iconfont iconqingchu"></i> <span>{{"chalk.clear" | translate}}</span></div><div class="chalk-view-2-3">{{"chalk.imageRequirements" | translate}}</div><div class="chalk-view-2-3-1" ng-if="type == \'white\'">{{"chalk.sizeRequirement" | translate:{type:(type | serviceType),width:width,height:height} }}<span style="color: #FC5722">{{width}}x{{height}}px</span></div><div class="chalk-view-2-3-1" ng-if="type != \'white\'">{{"chalk.sizeRequirement1" | translate:{type:(type | serviceType)} }}<span style="color: #FC5722">{{sizeMm()}}</span>{{"chalk.sizeRequirement1Mid" | translate}}<span style="color: #FC5722">{{sizePx()}}</span></div><div class="chalk-view-2-3-1">{{"chalk.colorRequirement" | translate:{type:(type | serviceType)} }}</div><div class="chalk-view-2-3" ng-if="type == \'white\'">{{"chalk.tutorial" | translate}}</div><div class="chalk-view-2-3-1" ng-click="vm.isQa=true" ng-if="type == \'white\'">{{"chalk.whiteKnowledge" | translate}}<span style="color: #264DF0; cursor: pointer">{{"chalk.learn" | translate}} ></span></div><div class="chalk-view-2-3-1" ng-click="vm.isQa1=true" ng-if="type == \'white\'">{{"chalk.createWhite" | translate}}<span style="color: #264DF0; cursor: pointer">{{"chalk.learn" | translate}} ></span></div></div></div><div class="c-modal-foot" ng-if="type != \'white\'"><button class="confirm-dialog-footer-cancel" ng-click="modalHide()">{{"button.cancel" | translate}}</button> <button class="confirm-dialog-footer-delete" ng-click="save()">{{"button.save" | translate}}</button></div></div><div class="c-mobile-modal" ng-if="vm.isMobile"><div class="mobile-btn" ng-click="modalHide()">{{"button.back" | translate}}</div><div class="mobile-content" ng-if="type == \'white\'"><div class="mobile-content-1" ng-if="imagebox.whiteInk2"><div ng-style="{\n                    position: \'relative\',\n                    width: vm.scale * width,\n                    height: vm.scale * height,}"><img ng-src="{{imagebox.image.resource.identifier+\'?imageMogr2/thumbnail/800x800>\'}}" style="width: 100%; height: 100%;opacity: 0.2"><div class="chalk-view-1-3-1" ng-style="{\n                        \'-webkit-mask-image\': imagebox.whiteInk2 ? \'url(\' + imagebox.whiteInk2.resource.identifier + \')\' : \'none\',\n                        \'-webkit-mask-size\': \'100% 100%\'}"><img ng-src="{{imagebox.image.resource.identifier+\'?imageMogr2/thumbnail/800x800>\'}}" style="width: 100%; height: 100%;opacity: 0.2"></div></div></div><div class="mobile-content-2" ng-if="!imagebox.whiteInk2"><div class="mobile-content-2-1"><i class="iconfont iconjia2"></i><div style="width: 100%; margin: 10px 0">{{"chalk.uploadTypeImage" | translate:{type:(type | serviceType)} }}</div><div style="width: 100%;font-weight: 400; font-size: 12px; color: #999999">{{"chalk.uploadHint" | translate:{type:(type | serviceType)} }}</div><input onchange="updateWhite(event)" type="file" accept="image/png"></div><div class="mobile-content-2-2">{{"chalk.colorHint" | translate:{type:(type | serviceType)} }}</div></div><div class="mobile-btn-1" ng-click="imagebox.whiteInk2 = null;" ng-if="imagebox.whiteInk2"><i class="iconfont iconqingchu"></i>{{"chalk.clearWhite" | translate}}</div><div class="mobile-btn-1" ng-click="setProcessImages()" ng-if="!imagebox.whiteInk2"><i class="iconfont iconqingchu"></i>{{"chalk.generate" | translate}}</div></div><div class="mobile-content" ng-if="type != \'white\'"><div class="mobile-content-1" ng-if="imageart.resource.identifier"><div ng-style="{\n                    position: \'relative\',\n                    width: vm.scale * width,\n                    height: vm.scale * height,}"><div class="gold-foil-text" style="width: 100%;height:100%" ng-style="{\n                        \'background\': goldFoil(imageart.spotColor.color),\n                        \'-webkit-mask-image\': \'url(\' + imageart.resource.identifier + \')\',\n                        \'-webkit-mask-size\': \'100% 100%\'\n                        }"><img ng-src="{{imageart.resource.identifier | imageFilter}}" style="width: 100%; height: 100%;opacity:0"></div></div></div><div class="mobile-content-2" ng-if="!imageart.resource || !imageart.resource.identifier"><div class="mobile-content-2-1"><i class="iconfont iconjia2"></i><div style="width: 100%; margin: 10px 0">{{"chalk.uploadTypeImage" | translate:{type:(type | serviceType)} }}</div><div style="width: 100%;font-weight: 400; font-size: 12px; color: #999999">{{"chalk.uploadHint" | translate:{type:(type | serviceType)} }}</div><input onchange="updateWhite(event)" type="file" accept="image/png"></div><div class="mobile-content-2-2">{{"chalk.colorHint" | translate:{type:(type | serviceType)} }}</div></div></div><div class="mobile-foot"><div class="mobile-btn-4" ng-if="!imagebox.whiteInk2" ng-click="vm.isMode=true">{{"chalk.viewRequirements" | translate}}</div><div class="mobile-btn-2" ng-if="imagebox.whiteInk2"><span>{{"chalk.uploadTypeImage" | translate:{type:(type | serviceType)} }}</span> <input onchange="updateWhite(event)" type="file" accept="image/png"></div><div class="mobile-btn-3" ng-click="save()">{{"button.save" | translate}}</div></div></div></div><div class="three-modal1" ng-if="vm.threeLoading"><img src="content/images/icon/loading.gif" alt=""><div>{{vm.threeLoadingText}}</div></div><div class="three-modal" ng-if="vm.isError" style="z-index: 1000; display: flex; justify-content: center; align-items: center"><div class="c-error-modal"><div style="font-weight: 600;font-size: 16px;color: #333333;line-height: 22px">{{"chalk.typeImageSize" | translate:{type:(type | serviceType)} }}<span style="color: #EC1D1D">{{"chalk.sizeMismatch" | translate}}</span></div><div style="margin: 16px 0 6px">{{"chalk.originalSize" | translate:{width:width,height:height} }}</div><div>{{"chalk.currentTypeSize" | translate:{type:(type | serviceType)} }}<span style="color: #EC1D1D">{{vm.isError}}</span></div><div class="mobile-btn-3" style="width: 100%; margin-top: 24px" ng-click="vm.isError = null;">{{"chalk.modify" | translate}}</div></div></div><div class="three-modal" ng-if="vm.isMode" style="z-index: 1000; display: flex; justify-content: center; align-items: flex-end"><div class="c-mode-modal"><div class="c-mode-modal-1">{{"chalk.uploadStandard" | translate}}</div><i class="iconfont iconguanbi1 c-mode-modal-2" ng-click="vm.isMode=false"></i><div class="c-mode-modal-3">{{"chalk.imageRequirements" | translate}}</div><div class="c-mode-modal-3-1" ng-if="type == \'white\'">{{"chalk.sizeRequirement" | translate:{type:(type | serviceType),width:width,height:height} }}<span style="color: #FC5722">{{width}}x{{height}}px</span></div><div class="c-mode-modal-3-1" ng-if="type != \'white\'">{{"chalk.sizeRequirement1" | translate:{type:(type | serviceType)} }}<span style="color: #FC5722">{{sizeMm()}}</span>{{"chalk.sizeRequirement1Mid" | translate}}<span style="color: #FC5722">{{sizePx()}}</span></div><div class="c-mode-modal-3-1">{{"chalk.colorRequirement" | translate:{type:(type | serviceType)} }}</div><div class="c-mode-modal-3" style="margin-top: 32px" ng-if="type == \'white\'">{{"chalk.tutorial" | translate}}</div><div class="c-mode-modal-4" ng-if="type == \'white\'"><span>{{"chalk.whiteKnowledge" | translate}}</span><div class="c-mode-modal-4-1" ng-click="vm.isQa=true">{{"chalk.learn" | translate}}</div></div><div class="c-mode-modal-4" ng-if="type == \'white\'"><span>{{"chalk.createWhite" | translate}}</span><div class="c-mode-modal-4-1" ng-click="vm.isQa1=true">{{"chalk.learn" | translate}}</div></div></div></div><div class="three-modal" ng-class="{\'c-mode-modal-mobils\' : !vm.isMobile}" ng-if="vm.isQa" style="z-index: 1001; display: flex; justify-content: center; align-items: flex-end"><div class="c-mode-modal" style="padding: 0;height: 600px"><div class="c-mode-modal-1">{{"chalk.tutorial" | translate}}</div><i class="iconfont iconguanbi1 c-mode-modal-2" ng-click="vm.isQa=false"></i><div class="c-mode-modal-5" ng-class="{\'hover-scrollbar\' : !vm.isMobile}"><img src="content/images/chalk/chalk-img1.jpg" alt=""> <img src="content/images/chalk/chalk-img2.jpg" alt=""> <img src="content/images/chalk/chalk-img3.jpg" alt=""></div></div></div><div class="three-modal" ng-class="{\'c-mode-modal-mobils\' : !vm.isMobile}" ng-if="vm.isQa1" style="z-index: 1001; display: flex; justify-content: center; align-items: flex-end"><div class="c-mode-modal" style="padding: 0;height: 600px"><div class="c-mode-modal-1">{{"chalk.tutorial" | translate}}</div><i class="iconfont iconguanbi1 c-mode-modal-2" ng-click="vm.isQa1=false"></i><div class="c-mode-modal-5" ng-class="{\'hover-scrollbar\' : !vm.isMobile}"><img src="content/images/chalk/chalk-img4.jpg" alt=""> <img src="content/images/chalk/chalk-img5.jpg" alt=""> <img src="content/images/chalk/chalk-img6.jpg" alt=""> <img src="content/images/chalk/chalk-img7.jpg" alt=""> <img src="content/images/chalk/chalk-img8.jpg" alt=""> <img src="content/images/chalk/chalk-img9.jpg" alt=""> <img src="content/images/chalk/chalk-img10.jpg" alt=""> <img src="content/images/chalk/chalk-img11.jpg" alt=""></div></div></div><style>.c-modal {\n        width: 1090px;\n        height: auto;\n        background: #fff;\n        border-radius: 8px;\n        margin: 50px auto;\n    }\n\n    .chalk-view {\n        padding: 24px;\n        height: 100%;\n        display: flex;\n        justify-content: space-between;\n    }\n\n    .chalk-view-1 {\n        width: 600px;\n        height: 600px;\n        background: #F4F5F6;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        position: relative;\n        padding-top: 30px;\n    }\n\n    .chalk-view-1-1 {\n        position: absolute;\n        top: 10px;\n        left: 50%;\n        transform: translateX(-50%);\n        padding: 6px 8px;\n        background: #264DF0;\n        color: #fff;\n        border-radius: 4px;\n    }\n\n    .chalk-view-1-1::before {\n        position: absolute;\n        top: 27px;\n        left: 50%;\n        transform: translateX(-50%);\n        content: \'\';\n        width: 0;\n        height: 0;\n        border-bottom: 10px solid #264DF0;\n        border-left: 10px solid transparent;\n        transform: rotate(45deg) translateX(-50%);\n    }\n\n    .chalk-view-1-2 {\n        background: #FC5722;\n    }\n\n    .chalk-view-1-2::before {\n        border-bottom: 10px solid #FC5722;\n    }\n\n    .chalk-view-1-3 {\n        width: 100%;\n        height: 530px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n\n    .chalk-view-1-3-1 {\n        width: 100%;\n        height: 100%;\n        position: absolute;\n        top: 0;\n        left: 0;\n        z-index: 1;\n        background: rgba(32, 32, 249, 1);\n    }\n\n    .chalk-view-2 {\n        width: 400px;\n    }\n\n    .chalk-view-2-1 {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n    }\n\n    .chalk-view-2-1-1 {\n        width: 180px;\n        height: 180px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n\n    .chalk-view-2-2 {\n        position: relative;\n        margin-top: 16px;\n        width: 100%;\n        height: 40px;\n        background: #FC5722;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        color: #fff;\n        font-size: 14px;\n        border-radius: 8px;\n        cursor: pointer;\n    }\n\n    input[type="file"] {\n        width: 100%;\n        height: 100%;\n        position: absolute;\n        top: 0;\n        left: 0;\n        opacity: 0;\n        cursor: pointer;\n        z-index: 1;\n    }\n\n    .chalk-view-2-2-delete {\n        background: #F5F7FA;\n        color: #666666;\n    }\n\n    .chalk-view-2-3 {\n        color: #333333;\n        font-weight: bold;\n        font-size: 14px;\n        margin-top: 40px;\n        line-height: 20px;\n    }\n\n    .chalk-view-2-3-1 {\n        font-size: 12px;\n        color: #666666;\n        line-height: 17px;\n        margin-top: 4px;\n    }\n\n    /* \u79FB\u52A8\u7AEF */\n    .c-mobile-modal {\n        position: relative;\n        width: 100%;\n        height: 100%;\n        background: #fff;\n        padding-top: 100px;\n    }\n\n    .mobile-btn {\n        position: absolute;\n        left: 10px;\n        top: 28px;\n        width: 60px;\n        height: 32px;\n        background: #FFFFFF;\n        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);\n        border-radius: 16px;\n        font-weight: 500;\n        font-size: 14px;\n        color: #333333;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n\n    .mobile-content {\n        width: 343px;\n        height: 343px;\n        margin: 0 auto 20px;\n        border: 1px dashed #777E90;\n    }\n\n    .mobile-content-1 {\n        width: 100%;\n        height: 100%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n\n    .mobile-btn-1 {\n        height: 32px;\n        padding: 0 16px;\n        background: #FFFFFF;\n        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);\n        border-radius: 16px;\n        font-weight: 500;\n        font-size: 14px;\n        color: #333333;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        margin: 20px auto;\n        width: fit-content;\n    }\n\n    .mobile-content-2 {\n        position: relative;\n        width: 100%;\n        height: 100%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n\n    .mobile-content-2-1 {\n        position: relative;\n        width: 100%;\n        height: 110px;\n        display: flex;\n        flex-wrap: wrap;\n        justify-content: center;\n        align-items: center;\n        color: #0A8DFE;\n        font-size: 16px;\n        font-weight: bold;\n        text-align: center;\n    }\n\n    .mobile-content-2-1 i {\n        font-size: 32px;\n    }\n\n    .mobile-content-2-2 {\n        position: absolute;\n        left: 0;\n        bottom: 28px;\n        text-align: center;\n        font-size: 14px;\n        color: #EC1D1D;\n        line-height: 20px;\n        padding: 0 16px;\n    }\n\n    .mobile-foot {\n        position: fixed;\n        left: 0;\n        bottom: 0;\n        width: 100%;\n        height: 88px;\n        background: #FFFFFF;\n        box-shadow: 0px -12px 21px -10px rgba(6, 6, 6, 0.11);\n        display: flex;\n        justify-content: space-between;\n        padding: 16px;\n    }\n\n    .mobile-btn-4 {\n        height: 40px;\n        font-size: 14px;\n        color: #333333;\n        line-height: 40px;\n    }\n\n    .mobile-btn-2 {\n        position: relative;\n        width: 50%;\n        height: 40px;\n        background: #fff;\n        color: #FB5721;\n        border: 1px solid #FB5721;\n        border-radius: 20px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        font-size: 14px;\n        font-weight: bold;\n        margin-right: 16px;\n    }\n\n    .mobile-btn-3 {\n        width: 50%;\n        height: 40px;\n        background: #FB5721;\n        color: #fff;\n        border: 1px solid #FB5721;\n        border-radius: 20px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        font-size: 14px;\n        color: #FFFFFF;\n        line-height: 20px;\n        font-weight: bold;\n    }\n\n    .c-error-modal{\n        width: 287px;\n        background: #FFFFFF;\n        border-radius: 8px;\n        padding: 28px 20px;\n        text-align: center;\n        color: #666666;\n        font-size: 14px;\n    }\n\n    .c-mode-modal{\n        position: relative;\n        width: 100%;\n        padding: 0 16px 16px;\n        border-radius: 12px 12px 0px 0px;\n        background: #FFFFFF;\n    }\n    .c-mode-modal-2{\n        position: absolute;\n        font-size: 24px;\n        font-weight: bold;\n        right: 16px;\n        top: 7px;\n    }\n    .c-mode-modal-1{\n        height: 50px;\n        line-height: 50px;\n        text-align: center;\n        font-weight: bold;\n        font-size: 16px;\n        color: #333333;\n    }\n    .c-mode-modal-3{\n        font-weight: bold;\n        font-size: 18px;\n        color: #333333;\n        line-height: 25px;\n    }\n    .c-mode-modal-3-1{\n        font-weight: 400;\n        font-size: 14px;\n        color: #666666;\n        line-height: 20px;\n        margin-top: 8px;\n    }\n    .c-mode-modal-4{\n        margin-top: 8px;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        font-size: 14px;\n        color: #333333;\n        \n    }\n    .c-mode-modal-4-1{\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        width: 64px;\n        height: 28px;\n        background: #F5F7FA;\n        border-radius: 4px;\n        font-size: 12px;\n        color: #0A8DFE; \n    }\n    .c-mode-modal-5{\n        width: 100%;\n        overflow: auto;\n        height: 550px;\n    }\n    .c-mode-modal-5 img{\n        width: 100%;\n    }\n    ::-webkit-scrollbar {\n        width: 0;\n    }\n    \n    .c-mode-modal-mobils{\n        align-items: center !important;\n    }\n    .c-mode-modal-mobils .c-mode-modal{\n        width: 1200px !important;\n        height: 800px !important;\n        border-radius: 12px !important;\n    }\n    .not-text{\n        width: 100%;\n        height: 100%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        font-size: 18px;\n    }</style>');
$templateCache.put('app/entities/components/classify-ec.html','<!--\u7D20\u6750--><div class="three-materialGallery" ng-style="{\'padding-bottom\': vm.isIPhoneX ? \'30px\' : \'0\'}"><div class="three-materialGallery-head"><ul class="three-materialGallery-head-ul"><li ng-repeat="item in vm.classify" ng-click="classifyCb(item.id)" ng-class="{\'opt\' : item.id == vm.classifyId}"><span>{{item.name}}</span></li></ul><i class="icon iconfont iconlujing8" ng-click="materialHide()"></i></div><div class="three-materialGallery-body" id="materialView"><ul class="clearfix"><li ng-repeat="item in vm.materialData" ng-click="addImageart(item)"><img ng-src="{{item.identifier+\'?imageView2/2/w/100\'}}" alt=""></li></ul></div><div class="animation-xia" ng-if="vm.materialData.length>8"><i class="icon iconfont iconxiangxia2"></i></div></div>');
$templateCache.put('app/entities/components/duplicate-list.html','<div class="c-modal-pop"><div class="c-modal"><div class="c-modal-head" style="border: none"><span style="font-weight: bold">{{\'gallery.duplicateImageList\' | translate}}</span> <img style="float: right; width: 20px" src="content/images/icons/log_close.png" ng-click="modalHide()"></div><div class="c-modal-body hover-scrollbar" style="padding: 0px 20px;display: flex;flex-wrap: wrap;max-height: 500px"><div class="list-view" ng-repeat="item in vm.list" ng-if="vm.list.length>0"><img ng-src="{{!item.largeFlag ? item.identifier + \'?imageMogr2/auto-orient/thumbnail/!20p\' : item.largeStatus == \'running\' ? \'content/images/largeLoading.jpg\' : item.identifier + \'.thumbnail.jpg\'}}" alt=""><!--                <i class="iconfont iconguanbi2" ng-click="deleteImg($index)"></i>--></div><div ng-if="vm.list && vm.list.length==0" style="width: 100%;line-height: 50px;color: #999;text-align: center">{{\'hint.noImages\' | translate}}</div></div><div class="c-modal-foot"><button class="confirm-dialog-footer-cancel" ng-click="modalHide()">{{\'gallery.keepDuplicateImages\' | translate}}</button> <button class="confirm-dialog-footer-delete" ng-click="modalSubmint()">{{\'gallery.removeDuplicateImages\' | translate}}</button></div><div class="pic-loading1" ng-if="vm.loading" style="position: absolute;left: 0; top: 0;width: 100%;height: 100%;z-index: 1"><div class="load-mask" style="display: flex; justify-content: center; align-items: center"><img src="content/images/icons/loading01.gif"></div></div></div></div><style>.c-modal{\n        max-width: 800px;\n        background: #fff;\n        height: fit-content;\n        border-radius: 8px;\n        width: 100%;\n    }\n    .list-view{\n        width: 130px;\n        height: 120px;\n        position: relative;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        margin: 10px;\n        background: #f3f3f3;\n        border-radius: 4px;\n    }\n    .list-view img{\n        max-width: 100%;\n        max-height: 100%;\n    }\n    .list-view .iconfont{\n        position: absolute;\n        right: 3px;\n        top: 3px;\n        font-size: 18px;\n    }\n    @media (max-width: 768px) {\n        .c-modal-pop{\n            align-items: flex-end;\n        }\n        .c-modal{\n            border-radius: 8px 8px 0 0;\n        }\n        .c-modal-body{\n            padding: 0 !important;\n        }\n        .c-modal-foot{\n            display: flex;\n            justify-content: space-around;\n            padding: 20px 0 10px 0;\n        }\n        .c-modal-foot .confirm-dialog-footer-cancel{\n            width: 40%;\n            border-radius: 30px;\n        }\n        .c-modal-foot .confirm-dialog-footer-delete{\n            width: 40%;\n            border-radius: 30px;\n        }\n        .list-view{\n            width: 31%;\n            margin: 1%;\n        }\n    }</style>');
$templateCache.put('app/entities/components/editor-gallery-ec.html','<input onchange="uploadImageMutiple(event)" type="file" multiple="multiple" accept="{{vm.supportedMimeTypes}}" name="file" class="input-upload2" id="uploadImageMutipleId"><!--  \u56FE\u7247\u5217\u8868\u9875  --><div class="c-productThree2" ng-show="!vm.insideFolder"><div class="c-productThree2-head1" ng-if="!vm.fullMap"><span class="arrow-prev" ng-click="getBack()" style="width: 20px; height: 20px; position: absolute; left: 10px; top: 10px"></span><div class="c-productThree2-head1-title" ng-if="vm.product.aiFill && (vm.article.editorType != \'PICTURE\' || vm.article.editorType != \'PICTURE_PRO\' || vm.article.editorType != \'PICTURE_PRO_P\')">{{\'editorCommon.imageNum\' | translate:({counts:(vm.productXmlLine.minPicQuantity + (vm.productXmlLine.maxPicQuantity > vm.productXmlLine.minPicQuantity ? \'~\' + vm.productXmlLine.maxPicQuantity : \'\'))})}}</div><div class="c-productThree2-head1-title" ng-if="(vm.article.editorType != \'PICTURE\' || vm.article.editorType != \'PICTURE_PRO\' || vm.article.editorType != \'PICTURE_PRO_P\') && (!vm.product.aiFill)">{{\'editorCommon.describe1\' | translate:({selectSum:vm.photoSelectAll.length,counts:vm.counts})}}</div><div style="position: absolute; top: 7px; right: 10px"><div class="c-productThree2-head2-btn" ng-click="uploadPhoto()" ng-if="vm.currentNav == \'gallery\'"><span>{{\'galleryContent.localGallery\' | translate}}</span> <input onchange="uploadImageMutiple(event)" type="file" multiple="multiple" accept="{{vm.supportedMimeTypes}}" name="file" ng-if="!agentIos && vm.isIPhone6" class="input-upload2"></div></div></div><!--    <div class="c-productThree2-head2 clearfix">--><!--        <div class="c-productThree2-head2-1">--><!--            <div class="c-productThree2-head2-li" ng-class="{\'c-productThree2-head2-li-select\' : vm.currentNav == \'gallery\'}" ng-click="galleryNavSel(\'gallery\')">--><!--                <span>{{\'galleryContent.gallery\' | translate}}</span>--><!--                <div class="c-productThree2-head2-li-hr"></div>--><!--            </div>--><!--            <div class="c-productThree2-head2-li" ng-class="{\'c-productThree2-head2-li-select\' : vm.currentNav == \'folder\'}" ng-click="galleryNavSel(\'folder\')">--><!--                <span>{{\'galleryContent.folder\' | translate}}</span>--><!--                <div class="c-productThree2-head2-li-hr"></div>--><!--            </div>--><!--        </div>--><!--        <div class="c-productThree2-head2-btn" ng-click="uploadPhoto()" ng-if="vm.currentNav == \'gallery\'">--><!--            <span>{{\'galleryContent.localGallery\' | translate}}</span>--><!--            <input onchange="uploadImageMutiple(event)" type="file" multiple="multiple" accept="{{vm.supportedMimeTypes}}" name="file" ng-if="!agentIos && vm.isIPhone6" class="input-upload2">--><!--        </div>--><!--        <div style="width: 90px;" ng-if="vm.currentNav == \'folder\' && vm.isChoiceFolder"></div>--><!--        <div  class="center" style="width: 50px;" ng-if="vm.currentNav == \'folder\'">--><!--            <span ng-click="choiceFolder()" ng-if="!vm.isChoiceFolder">{{\'galleryContent.select\' | translate}}</span>--><!--            <span ng-click="cancelFolder()" ng-if="vm.isChoiceFolder">{{\'galleryContent.cancel\' | translate}}</span>--><!--        </div>--><!--        <div class="c-productThree2-head2-btn" style="width: 90px;" ng-click="addFolder()" ng-if="vm.currentNav == \'folder\' && !vm.isChoiceFolder">--><!--            <span>{{\'galleryContent.addFolder\' | translate}}</span>--><!--        </div>--><!--    </div>--><div class="c-productThree2-head3 c-productThree2-head3-page2"><!--        <ul class="clearfix c-productThree2-head3-li-body" ng-if="vm.uploadPhotoItem.length>0">--><!--            <li ng-repeat="data in vm.uploadPhotoItem" ng-if="!data.state || data.state == \'success\'">--><!--                <progres-view :src="data.blobCover" :progres="data.percent"></progres-view>--><!--            </li>--><!--        </ul>--><div ng-if="vm.currentNav == \'gallery\'"><div class="c-productThree2-head3-li" ng-repeat="item in vm.photoArray"><div class="c-productThree2-head3-li-view"><div class="c-productThree2-head3-li-head" ng-if="vm.fullMap"><span>{{item.createDate}}</span></div><div class="c-productThree2-head3-li-head" ng-click="photoAllCb(item)" ng-if="!vm.fullMap"><span>{{item.createDate}}</span> <span class="c-productThree2-head3-li-head-selectOn" ng-if="item.selected"><i class="iconfont iconxuanzhong1 theme-color"></i> </span><span class="c-productThree2-head3-li-head-selectOnt" ng-if="!item.selected"><i class="iconfont iconxuanzhong"></i></span></div><ul class="clearfix c-productThree2-head3-li-body"><li ng-repeat="data in vm.uploadPhotoItem" ng-if="data.percent != 100 && (!data.state || data.state == \'success\') && vm.uploadPhotoItem.length>0 && item.createDate == vm.today"><progres-view :src="data.blobCover" :progres="data.percent"></progres-view></li><li ng-repeat="data in item.galleries track by $index" ng-click="photoOneCb(data)"><img ng-if="photoStatus(data) == \'\'" ng-src="{{(data.largeFlag ? data.identifier1 : data.identifier)+\'?imageView2/1/w/150/h/150\'||\'//:0\'}}" alt="" class="c-productThree2-head3-li-body-img"><div class="editor-photoAlbum-status" ng-if="photoStatus(data) != \'\'" ng-class="{\'is-failed\': isPhotoFailed(data)}" ng-click="onPhotoStatusClick(data, $event)"><img class="editor-photoAlbum-status-placeholder" src="content/images/placeholderImage.png" alt=""><div class="editor-photoAlbum-status-mask"><img class="editor-photoAlbum-status-icon" ng-if="photoStatus(data) == \'largeError\' || photoStatus(data) == \'convertError\'" src="content/images/close1.png" alt=""> <img class="editor-photoAlbum-status-icon" ng-if="photoStatus(data) == \'convertRunning\' || photoStatus(data) == \'largeRunning\'" src="content/images/loading1.png" alt=""> <span class="editor-photoAlbum-status-text">{{(\'nav.photograph.content.status.\' + photoStatus(data)) | translate}}</span></div></div><div class="c-productThree2-head3-li-body-selectOn" ng-if="data.selected"><i class="iconfont iconxuanzhong1 theme-color"></i></div><div class="c-productThree2-head3-li-body-selectOnt" ng-if="!data.selected"><i class="iconfont iconxuanzhong"></i></div><div class="c-imagebox-warn" ng-if="data.imgSize / 1024 < 150" style="width: 85px"><i class="icon iconfont iconwaring imageboxWarn"></i> <span>{{\'galleryContent.lackOfPixels\' | translate}}</span></div><div class="photoCount" ng-if="data.frequency>0">{{data.frequency}}\u6B21</div><div class="photoNot" ng-if="vm.fullMap && vm.photoSelectAll.length >= vm.fullMapNumber && !data.selected"></div></li></ul></div></div><!-- <div class="c-productThree2-head5" style="bottom: 20px;">\n                <button type="button" class="c-productThree2-head5-btn" ng-click="photoSave()" ng-if="vm.photoSelectAll.length>0">{{\'galleryContent.confirm\' | translate}}\uFF08{{vm.photoSelectAll.length}}\uFF09</button>\n            </div> --><div class="c-productThree2-head5-2"><div class="c-productThree2-head5-2-select" ng-click="photoAllSelect()"><i class="iconfont iconxuanzhong" ng-if="!vm.phoneAllSelected"></i> <i class="iconfont iconxuanzhong1 theme-color" ng-if="vm.phoneAllSelected"></i> <span>{{\'button.selectAll\' | translate}}</span></div><button type="button" class="c-productThree2-head5-2-btn" ng-click="photoSave()">{{\'button.confirm\' | translate}}\uFF08{{vm.photoSelectAll.length}}\uFF09</button></div></div><div class="c-folder-view" ng-if="vm.currentNav == \'folder\'" style="margin: 0"><div class="c-folder-body" ng-if="Folders.length > 0"><div class="c-folder" ng-repeat="item in Folders track by $index" ng-click="folderSelect(item)"><div class="c-folder-fl"><div class="c-folder-fl1"><img class="icon1" src="content/images/icons/folder.svg" alt=""></div><div class="c-folder-fl2"><div class="c-folder-fl2-1">{{item.name}}</div><div class="c-folder-fl2-2"><span>{{item.createdDate | date:\'yyyy-MM-dd HH:mm:ss\'}}</span> <span>{{\'galleryContent.quantity\' | translate}}\uFF1A{{item.quantity || 0}}</span></div></div></div><i class="icon iconfont iconyoujian icon2" ng-show="!vm.isChoiceFolder"></i> <i class="iconfont" ng-show="vm.isChoiceFolder" ng-class="{\'iconxuanzhong\': !item.selected, \'iconxuanzhong1 theme-color\': item.selected}"></i></div></div><div class="c-productThree2-head5" style="bottom: 20px" ng-if="vm.folderListSelect.length>0"><button type="button" class="c-productThree2-head5-btn" ng-click="folderSave1()">{{\'galleryContent.confirm\' | translate}}</button></div><div class="c-productThree2-head5" style="bottom: 0;background: #fff" ng-if="vm.currentNav == \'folder\' && vm.isChoiceFolder"><div class="folder-chooseBar"><div class="folder-chooseBar-all" ng-click="chooseAll()"><span class="iconfont iconxuanzhong textcolor3" ng-show="folderIds.length != Folders.length"></span> <span class="iconfont iconxuanzhong1 theme-color" ng-show="folderIds.length == Folders.length"></span> <span>{{\'galleryContent.checkAll\' | translate}}</span></div><div class="folder-chooseBar-btn"><div class="generalBgColor2 chooseBar-btn center" ng-style="{\'opacity\':folderIds.length>1?\'0.5\':\'\'}" ng-click="editFolder()">{{\'galleryContent.rechristen\' | translate}}</div><div class="btn1 center chooseBar-btn" ng-click="deleteFolders()">{{\'galleryContent.delete\' | translate}}</div></div></div></div></div></div></div><!--  \u6587\u4EF6\u5939\u56FE\u7247\u5217\u8868  --><div class="c-productThree2" ng-show="vm.insideFolder"><div class="c-productThree2-head1" style="border-bottom: 1px solid #dedede" ng-if="!vm.fullMap"><span class="arrow-prev" ng-click="getBack()" style="width: 20px; height: 20px; position: absolute; left: 10px; top: 10px"></span><div class="c-productThree2-head1-title" ng-if="vm.product.aiFill && (vm.article.editorType != \'PICTURE\' || vm.article.editorType != \'PICTURE_PRO\' || vm.article.editorType != \'PICTURE_PRO_P\')">{{\'editorCommon.imageNum\' | translate:({counts:(vm.productXmlLine.minPicQuantity + (vm.productXmlLine.maxPicQuantity > vm.productXmlLine.minPicQuantity ? \'~\' + vm.productXmlLine.maxPicQuantity : \'\'))})}}</div><div class="c-productThree2-head1-title" ng-if="(vm.article.editorType != \'PICTURE\' || vm.article.editorType != \'PICTURE_PRO\' || vm.article.editorType != \'PICTURE_PRO_P\') && (!vm.product.aiFill)">{{\'editorCommon.describe1\' | translate:({selectSum:vm.photoSelectAll.length,counts:vm.counts})}}</div></div><div class="c-productThree2-head2 clearfix"><div class="c-productThree2-head2-2"><div class="c-productThree2-head2-title">{{vm.folderOne.name}}</div></div><div class="c-productThree2-head2-btn" ng-click="uploadPhoto()"><span>{{\'galleryContent.localGallery\' | translate}}</span> <input onchange="uploadImageMutiple(event)" type="file" multiple="multiple" accept="{{vm.supportedMimeTypes}}" name="file" ng-if="!agentIos && vm.isIPhone6" class="input-upload2"></div></div><div class="c-productThree2-head3 c-productThree2-head3-page9" style="top: 94px"><!--        <ul class="clearfix c-productThree2-head3-li-body" ng-if="vm.uploadPhotoItem.length>0">--><!--            <li ng-repeat="data in vm.uploadPhotoItem" ng-if="!data.state || data.state == \'success\'">--><!--                <progres-view :src="data.blobCover" :progres="data.percent"></progres-view>--><!--            </li>--><!--        </ul>--><div class="c-productThree2-head3-li" ng-repeat="item in vm.photoArray" ng-if="vm.insideFolder"><div class="c-productThree2-head3-li-view"><div class="c-productThree2-head3-li-head" ng-if="vm.fullMap"><span>{{item.createDate}}</span></div><div class="c-productThree2-head3-li-head" ng-click="photoAllCb(item)" ng-if="!vm.fullMap"><span>{{item.createDate}}</span> <span class="c-productThree2-head3-li-head-selectOn" ng-if="item.selected"><i class="iconfont iconxuanzhong1 theme-color"></i> </span><span class="c-productThree2-head3-li-head-selectOnt" ng-if="!item.selected"><i class="iconfont iconxuanzhong"></i></span></div><ul class="clearfix c-productThree2-head3-li-body"><li ng-repeat="data in vm.uploadPhotoItem" ng-if="data.percent != 100 && (!data.state || data.state == \'success\') && vm.uploadPhotoItem.length>0 && item.createDate == vm.today"><progres-view :src="data.blobCover" :progres="data.percent"></progres-view></li><li ng-repeat="data in item.galleries" ng-click="photoOneCb(data)"><img ng-if="photoStatus(data) == \'\'" ng-src="{{(data.largeFlag ? data.identifier1 : data.identifier)+\'?imageView2/1/w/150/h/150\'||\'//:0\'}}" alt="" class="c-productThree2-head3-li-body-img"><div class="editor-photoAlbum-status" ng-if="photoStatus(data) != \'\'" ng-class="{\'is-failed\': isPhotoFailed(data)}" ng-click="onPhotoStatusClick(data, $event)"><img class="editor-photoAlbum-status-placeholder" src="content/images/placeholderImage.png" alt=""><div class="editor-photoAlbum-status-mask"><img class="editor-photoAlbum-status-icon" ng-if="photoStatus(data) == \'largeError\' || photoStatus(data) == \'convertError\'" src="content/images/close1.png" alt=""> <img class="editor-photoAlbum-status-icon" ng-if="photoStatus(data) == \'convertRunning\' || photoStatus(data) == \'largeRunning\'" src="content/images/loading1.png" alt=""> <span class="editor-photoAlbum-status-text">{{(\'nav.photograph.content.status.\' + photoStatus(data)) | translate}}</span></div></div><div class="c-productThree2-head3-li-body-selectOn" ng-if="data.selected"><i class="iconfont iconxuanzhong1 theme-color"></i></div><div class="c-productThree2-head3-li-body-selectOnt" ng-if="!data.selected"><i class="iconfont iconxuanzhong"></i></div><div class="c-imagebox-warn" ng-if="data.imgSize / 1024 < 150" style="width: 85px"><i class="icon iconfont iconwaring imageboxWarn"></i> <span>{{\'galleryContent.lackOfPixels\' | translate}}</span></div><div class="photoCount" ng-if="data.frequency>0">{{data.frequency}}\u6B21</div><div class="photoNot" ng-if="vm.fullMap && vm.photoSelectAll.length >= vm.fullMapNumber && !data.selected"></div></li></ul></div></div><div class="c-productThree2-head5" style="bottom: 20px"><button type="button" class="c-productThree2-head5-btn" ng-click="folderSave()" ng-if="vm.photoSelectAll.length>0">{{\'galleryContent.confirm\' | translate}}\uFF08{{vm.photoSelectAll.length}}\uFF09</button></div></div></div><div class="three-modal" ng-if="vm.isEditFolderName"><div class="three-modal-body"><div class="three-modal-body-content"><input type="text" class="c-input1" ng-model="vm.folderSelectData.name"></div><div class="three-modal-body-foot"><button type="button" class="color1" ng-click="editFolderNameHide()">{{\'button.cancel\' | translate}}</button> <button type="button" class="color2" ng-click="editFolderNameSave()">{{\'button.confirm\' | translate}}</button></div></div></div><div class="three-modal2" ng-if="vm.threeError"><div class="three-modal2-body"><div>{{vm.threeErrorText}}</div></div></div><upload-image tag="\'normalEditor\'" store-id="vm.storeId" aid="vm.aid" upload-photo-item="vm.uploadPhotoItem" photos="vm.photoArray" photo-all="vm.photoSelectAll" gallery-page="vm.photoAll" folder-one="vm.folderOne"></upload-image><style>.center{\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n    .folder-chooseBar{\n        display: flex;\n        justify-content: space-between;\n        padding: 10px;\n        align-items: center;\n    }\n    .chooseBar-btn{\n        width: 108px;\n        height: 36px;\n        background: var(--genericColor);\n        border-radius: 18px;\n        color: #fff;\n        margin: 0 5px;\n    }\n    .folder-chooseBar-btn{\n        display: flex;\n        align-items: center;\n    }\n    /* \u5927\u56FE\u5904\u7406\u4E2D/\u5931\u8D25\u3001\u8272\u5F69\u8F6C\u6362\u4E2D/\u5931\u8D25\uFF1A\u5360\u4F4D\u56FE + \u5C45\u4E2D\u72B6\u6001\u56FE\u6807\u4E0E\u6587\u6848 */\n    .editor-photoAlbum-status{\n        position: absolute;\n        left: 0;\n        top: 0;\n        z-index: 2;\n        width: 100%;\n        height: 100%;\n        overflow: hidden;\n    }\n    .editor-photoAlbum-status-placeholder{\n        position: absolute;\n        left: 0;\n        top: 0;\n        z-index: 1;\n        display: block;\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n    }\n    .editor-photoAlbum-status-mask{\n        position: absolute;\n        left: 0;\n        top: 0;\n        z-index: 2;\n        display: flex;\n        box-sizing: border-box;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        width: 100%;\n        height: 100%;\n        padding: 4px;\n        background-color: rgba(0, 0, 0, 0.25);\n    }\n    .editor-photoAlbum-status-icon{\n        display: block;\n        flex: none;\n        width: 20px;\n        height: 20px;\n        margin-bottom: 4px;\n        object-fit: contain;\n    }\n    .editor-photoAlbum-status-text{\n        max-width: 100%;\n        color: #ffffff;\n        font-size: 11px;\n        line-height: 14px;\n        text-align: center;\n        word-break: break-all;\n        text-shadow: 0 1px 4px rgba(0,0,0,0.6);\n    }\n    .editor-photoAlbum-status.is-failed{\n        cursor: pointer;\n    }</style>');
$templateCache.put('app/entities/components/editor-preview-mini.html','<div class="preview-view-tab" ng-if="vm.bindingtypes.length>1 && vm.isNav"><!--    <div class="preview-view-tab-name">{{bindingtypeInfo()}}</div>--><div class="preview-view-tab-list"><div class="preview-view-tab-list-li" ng-repeat="item in vm.bindingtypes" ng-click="bindingtypeSelect(item)" ng-class="{\'preview-view-tab-list-li-select\' : item.id == vm.bindingtype}">{{item.name}}</div></div></div><div ng-show="vm.bindingtype != \'Tile\'"><div class="threeView-body"><div class="c-preview-top-btn" ng-if="vm.windowW<700"><div class="c-preview-top-btn-1" ng-class="{\'c-preview-top-btn-select\' : !vm.landscape}" ng-click="landscape(true)">{{\'editorCommon.porTrait\' | translate}}</div><div class="c-preview-top-btn-1" ng-class="{\'c-preview-top-btn-select\' : vm.landscape}" ng-click="landscape(false)">{{\'editorCommon.landscape\' | translate}}</div></div><div class="flipbook-viewport c-preview-landscape" style="display: flex; justify-content: center; align-items: center" ng-show="!vm.loading"><div style="position: relative" ng-click="flipbookViewportPage($event)" ng-style="{\n             \'transform\': \'scale(\'+(vm.windowR)+\') rotateZ(\' + (!vm.landscape ? 0 : 90) + \'deg)\',\n                 width: vm.pageMaxWidth,\n                 height: vm.pageMaxHeight\n             }"><i class="iconfont iconzuoceshouqi prevImg" ng-if="(prevPartShow(\'prev\') || vm.thisPage>0) && vm.isNav"></i> <i class="iconfont iconyouceshouqi nextImg" ng-if="(prevPartShow(\'next\') || vm.thisPage<vm.insidePages.length-1) && vm.isNav"></i><div id="pageView" style="width: 100%; height: 100%; min-width: 100%; overflow: hidden"><div style="display: flex;transition: transform 0.5s ease-in-out; align-items: center" ng-style="{\'transform\': \'translate(\' + vm.partData.marginLeft + \'px,0)\'}" id="partView"><div style="width: 100%; height: 100%; min-width: 100%; margin: 0 50px 0 0" ng-repeat="part in vm.parts track by $index"><div ng-if="part.id !=\'P\'"><div ng-repeat="item in part.pages track by $index" style="position: relative; width: 100%; height: 100%"><div style="display: flex;\n    justify-content: center;\n    align-items: center"><page-preview page="item.page" scale="item.page.ratio"></page-preview></div></div></div><div ng-if="part.id ==\'P\'" class="flipbook"><div class="flipbook-viewport-page" ng-repeat="item in part.pages track by $index" style="position: relative; width: 100%; height: 100%; padding: 0 !important"><div ng-style="{\n                            \'margin-left\':item.page.marginLeft,\n                            \'margin-top\':(vm.pageMaxHeight1-item.page.custom.height * item.page.ratio)/2\n                        }"><page-preview page="item.page" scale="item.page.ratio"></page-preview></div></div></div></div></div></div></div></div></div><div class="preview-view-left-2 hover-scrollbar hover-scrollbar1" ng-if="vm.isNav"><div class="preview-view-left-2-part" ng-repeat="part in vm.parts"><div class="preview-view-left-2-page" ng-if="part.id != \'P\'" ng-click="jumpPage(part)"><div class="preview-view-left-2-page-item" ng-repeat="pageItem in part.pages" ng-class="{\'pageSelect\' : vm.partData.id == part.id}"><div class="pageIndex"><span>{{part.name}}</span></div><page-preview page="pageItem.page" scale="vm.ratio1"></page-preview></div></div><div class="preview-view-left-2-page" ng-if="part.id == \'P\'"><div class="preview-view-left-2-page-item1" ng-repeat="page in vm.insidePages" ng-class="{\'pageSelect\' : vm.partData.id == page.partid && vm.thisPage == $index}"><div class="preview-view-left-2-page-item1-view" ng-if="page.page1" ng-click="jumpPage(part, page.page1.uuid)"><page-preview page="page.page1" scale="vm.ratio1"></page-preview></div><div class="preview-view-left-2-page-item1-view" ng-if="page.page2 && !page.page2.spread" ng-click="jumpPage(part, page.page2.uuid)"><page-preview page="page.page2" scale="vm.ratio1"></page-preview></div><div class="pageIndex"><span ng-class="{\'pageIndex-not\' : !page.page1.pageNumber}">{{page.page1.pageNumber}}</span> <span ng-class="{\'pageIndex-not\' : !page.page2.pageNumber}">{{page.page2.pageNumber}}</span></div></div></div></div></div></div><div class="tile-view" ng-show="(template.config.productType == \'BOOK\'||template.config.productType == \'CALENDAR\') && vm.bindingtype == \'Tile\'"><div class="tile-view-item" ng-repeat="page in template.pages.page"><page-preview page="page" scale="vm.ratioTile"></page-preview></div></div><style>.flipbook-viewport .container1 {\n        position: fixed;\n        top: 50px;\n        left: 0;\n        margin: auto;\n        padding: 0;\n        width: 100%;\n        display: flex;\n        justify-content: center;\n    }\n    .flipbook-viewport .flipbook {\n        left: 0;\n        top: 0;\n        margin: 0 auto;\n    }\n    .preview-view-left-2{\n        position: fixed;\n        left: 0;\n        bottom: 0;\n        right: 0;\n        width: 100%;\n        background: #fff;\n        overflow: auto;\n        padding: 16px;\n        display: flex;\n        z-index: 1000;\n        box-shadow: 0px 0px 13px 0 rgba(0, 0, 0, 0.3);\n    }\n    .preview-view-left-2-part{\n        display: flex;\n        margin-right: 15px;\n        border-right: 1px solid #ddd;\n    }\n    .preview-view-left-2-part:last-child{\n        border: 0;\n    }\n    .preview-view-left-2-page{\n        display: flex;\n    }\n\n    .preview-view-left-2-page-item{\n        margin-right: 15px;\n        position: relative;\n    }\n    .preview-view-left-2-page-item1{\n        position: relative;\n        margin-right: 15px;\n        display: flex;\n        height: fit-content;\n    }\n    .preview-view-left-2-page-item1-view{\n        position: relative;\n    }\n    .pageIndex{\n        position: absolute;\n        top: -10px;\n        left: 0;\n        width: 100%;\n        display: flex;\n        justify-content: space-around;\n        z-index: 9;\n    }\n    .pageIndex span{\n        display: block;\n        padding: 2px 10px;\n        background: #777;\n        border-radius: 10px;\n        font-size: 12px;\n        color: #fff;\n        max-width: 80%;\n        overflow: hidden;\n        white-space: nowrap;\n        -o-text-overflow: ellipsis;\n        text-overflow: ellipsis;\n    }\n    .pageIndex span.pageIndex-not{\n        background: none !important;\n    }\n    .pageSelect{\n        border: 1px solid #299DFF;\n    }\n    .pageSelect .pageIndex span{\n        background: #299DFF;\n    }\n    .prevImg{\n        position: absolute;\n        left: -50px;\n        top: 50%;\n        font-size: 20px;\n        margin-top: -10px;\n    }\n    .nextImg{\n        position: absolute;\n        right: -50px;\n        top: 50%;\n        font-size: 20px;\n        margin-top: -10px;\n    }</style>');
$templateCache.put('app/entities/components/image-cutout.html','<div class="cutout-view" ng-click="exitView($event)"></div><div class="cutout-view-inner" ng-if="!vm.isMobile" ng-style="{\n        top: vm.imagebox.y-40 + \'px\',\n        left: vm.imagebox.x + \'px\',\n        }"><div class="cutout-view-btn" ng-class="{\'prohibit\': vm.loading}" style="background: none" ng-click="editImage()">\u7F16\u8F91\u62A0\u56FE</div><div class="cutout-view-btn" ng-click="hideImage()">\u53D6\u6D88</div><div class="cutout-view-btn" ng-class="{\'prohibit\': vm.loading}" style="color: #108DFE" ng-click="saveImage()">\u5E94\u7528</div></div><div class="cutout-view-inner-mobile" ng-if="!vm.loading && vm.isMobile"><i class="iconfont iconguanbi1" ng-click="hideImage()"></i><div ng-click="editImage()"><i class="iconfont iconhuabi_huaban1" style="font-size: 14px"></i>\u7F16\u8F91\u62A0\u56FE</div><i class="iconfont iconjichu01" ng-click="saveImage()"></i></div><div class="loading-view" ng-if="vm.loading && !vm.isMobile" ng-style="{\n        top: vm.imagebox.y + \'px\',\n        left: vm.imagebox.x + \'px\',\n        width: vm.imagebox.width + \'px\',\n        height: vm.imagebox.height + \'px\',\n        }"><img src="content/images/icons/loading-pic.gif" style="width: 24px"><div style="margin-top: 10px">\u667A\u80FD\u62A0\u56FE\u4E2D</div></div><div class="loading-view-mobile" ng-if="vm.loading && vm.isMobile"><div class="loading-view-mobile-body"><img src="content/images/icons/loading-pic.gif" style="width: 24px"><div style="margin-top: 10px">\u667A\u80FD\u62A0\u56FE\u4E2D</div></div><div class="loading-view-mobile-btn" ng-click="hideImage()"><div>\u53D6\u6D88</div></div></div><image-masking ng-if="vm.isShowImageMasking" url="vm.image.source_key" mask-url="vm.image.mask_key" on-save="imageMaskingSave(data)" on-close="imageMaskingClose()"></image-masking><style>.cutout-view{\n        position: fixed;\n        left: 0;\n        top: 0;\n        width: 100vw;\n        height: 100vh;\n        z-index: 1001;\n    }\n    .cutout-view-inner{\n        position: fixed;\n        z-index: 1002;\n        width: 172px;\n        height: 32px;\n        background: #FFFFFF;\n        box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.1);\n        border-radius: 8px;\n        display: flex;\n        align-items: center;\n        justify-content: space-around;\n    }\n    .cutout-view-btn{\n        cursor: pointer;\n        height: 24px;\n        background: #F5F7FA;\n        border-radius: 4px;\n        padding: 0 8px;\n        font-size: 12px;\n        color: #333333;\n        line-height: 24px;\n    }\n    .loading-view{\n        position: fixed;\n        z-index: 1002;\n        background: rgba(0,0,0,0.5);\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-direction:column;\n        color: #fff;\n    }\n    .loading-view-mobile{\n        position: fixed;\n        left: 50%;\n        top: 50%;\n        transform: translate(-50%, -50%);\n        z-index: 1002;\n        background: rgba(0,0,0,0.75);\n        border-radius: 6px;\n        color: #fff;\n    }\n    .loading-view-mobile-body{\n        width: 128px;\n        height: 110px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-direction:column;\n    }\n    .loading-view-mobile-btn{\n        border-top: 1px solid rgba(255,255,255,0.16);\n        height: 56px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        color: #fff;\n    }\n\n    .cutout-view-inner-mobile{\n        position: fixed;\n        left: 0;\n        bottom: 0;\n        z-index: 1002;\n        width: 100vw;\n        height: 108px;\n        background: #FFFFFF;\n        box-shadow: 0px 1px 10px 0px rgba(201,201,201,0.5);\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        padding: 0 16px;\n    }\n    .cutout-view-inner-mobile .iconfont{\n        font-size: 20px;\n    }\n    .cutout-view-inner-mobile div{\n        width: 271px;\n        height: 42px;\n        background: #F5F7F9;\n        border-radius: 20px;\n        font-size: 14px;\n        color: #999999;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n    .prohibit{\n        cursor: not-allowed;\n        color: #999999 !important;\n    }</style>');
$templateCache.put('app/entities/components/imageMasking.html','<div class="im-container"><!-- \u9876\u90E8\u5BFC\u822A --><div class="im-top-bar"><button class="im-btn-icon" ng-click="vm.close()" title="\u5173\u95ED"><i class="iconfont iconguanbi1"></i></button> <span class="im-title">\u62A0\u56FE</span> <button class="im-btn-icon im-btn-confirm" ng-click="vm.confirm()" title="\u786E\u8BA4"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></button></div><!-- \u4E3B\u533A\u57DF --><div class="im-main-area"><div class="im-canvas-container" id="imCanvasContainer"><div id="imLoadingOverlay"><div class="im-spinner"></div><span>\u52A0\u8F7D\u4E2D...</span></div><div id="imCanvasWrapper"><canvas id="imImageCanvas"></canvas><canvas id="imOverlayCanvas"></canvas><div id="imBrushCursor" ng-class="{\'erase-mode\': vm.toolMode === \'erase\'}"></div></div><div id="imBrushSizeHint" ng-style="{width: vm.brushSize + \'px\', height: vm.brushSize + \'px\'}" ng-class="{show: vm.brushHintVisible, \'erase-hint\': vm.toolMode === \'erase\'}"></div><!-- \u53F3\u4E0A\u89D2\uFF1A\u89C6\u56FE\u5207\u6362 --><div class="im-view-toggle im-float"><button class="im-vt-btn" ng-click="vm.switchView(\'original\')" ng-class="{actived: vm.viewMode === \'original\'}">\u539F\u56FE</button> <button class="im-vt-btn" ng-click="vm.switchView(\'effect\')" ng-class="{actived: vm.viewMode === \'effect\'}">\u6548\u679C\u56FE</button></div><!-- \u5DE6\u4E0B\u89D2\uFF1A\u64A4\u9500/\u91CD\u505A/\u91CD\u7F6E --><div class="im-undo-redo im-float"><button class="im-float-btn" ng-click="vm.undo()" ng-disabled="!vm.undoEnabled" title="\u4E0A\u4E00\u6B65"><i class="iconfont iconshangyibu"></i></button> <button class="im-float-btn" ng-click="vm.redo()" ng-disabled="!vm.redoEnabled" title="\u4E0B\u4E00\u6B65"><i class="iconfont iconxiayibu"></i></button> <button class="im-float-btn" ng-click="vm.resetMask()" title="\u8FD8\u539F"><i class="iconfont iconchongzhi"></i></button></div><!-- \u53F3\u4E0B\u89D2\uFF1A\u7F29\u653E\u8FD8\u539F + \u62D6\u62FD --><div class="im-zoom-group im-float"><button class="im-float-btn" ng-click="vm.zoomReset()" title="1:1\u8FD8\u539F"><i class="iconfont iconyibiyi"></i></button> <button class="im-float-btn" ng-click="vm.toggleDragMode()" ng-class="{actived: vm.dragMode}" title="\u62D6\u52A8\u753B\u5E03"><i class="iconfont iconyidong"></i></button></div></div><!-- \u5E95\u90E8\u63A7\u5236\u680F --><div class="im-bottom-bar"><div class="im-brush-popup" ng-class="{visible: vm.popupVisible}"><div class="im-popup-item"><span class="im-popup-label">\u7C97\u7EC6</span> <input type="range" ng-model="vm.brushSize" ng-change="vm.onBrushSizeChange()" ng-style="{\'background\': vm.brushSizeBg}" min="1" max="100"> <span class="im-popup-value">{{ vm.brushSize }}</span></div><div class="im-popup-item"><span class="im-popup-label">\u786C\u5EA6</span> <input type="range" ng-model="vm.hardness" ng-change="vm.onHardnessChange()" ng-style="{\'background\': vm.hardnessBg}" min="0" max="100"> <span class="im-popup-value">{{ vm.hardness }}</span></div><div class="im-popup-item"><span class="im-popup-label">\u900F\u660E\u5EA6</span> <input type="range" ng-model="vm.opacity" ng-change="vm.onOpacityChange()" ng-style="{\'background\': vm.opacityBg}" min="10" max="100"> <span class="im-popup-value">{{ vm.opacity }}</span></div></div><div class="im-tools-row"><button class="im-tool-btn" ng-click="vm.setToolMode(\'repair\')" ng-class="{actived: vm.toolMode === \'repair\'}"><i class="iconfont iconxiubu"></i> <span>\u4FEE\u8865</span></button> <button class="im-tool-btn" ng-click="vm.setToolMode(\'erase\')" ng-class="{\'erase-actived\': vm.toolMode === \'erase\'}"><i class="iconfont iconcachu"></i> <span>\u64E6\u9664</span></button></div></div></div><!-- Toast --><div class="im-toast" ng-class="{show: vm.toastVisible}">{{ vm.toastText }}</div></div>');
$templateCache.put('app/entities/components/language.html','<div class="langue-view"><div class="langue-view-modal" ng-click="cancel()"></div><div class="langue-view-content"><div class="langue-view-head"><div class="langue-view-cancel"></div><div class="langue-view-title">{{\'hint.languageTitle\' | translate}}</div><div class="langue-view-save"></div></div><div class="langue-view-body"><div class="langue-view-body-view" ng-class=" {\'langue-view-body-view-select\': lang.selected} " ng-repeat=" lang in vm.lagnuages" ng-click="changeLagnuage(lang)"><i class="iconfont iconduihao"></i> <span>{{lang.key}}</span></div></div></div></div><style>.langue-view{\n        position: fixed;\n        left: 0;\n        top: 0;\n        bottom: 0;\n        right: 0;\n        background: rgba(0,0,0,0.4);\n        z-index: 999;\n    }\n    .langue-view-modal{\n        position: fixed;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        top: 0;\n    }\n    .langue-view-content{\n        position: fixed;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        border-radius: 10px 10px 0 0;\n        overflow: hidden;\n        background: #fff;\n        z-index: 1;\n    }\n    .langue-view-head{\n        width: 100%;\n        height: 40px;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding: 0 15px;\n        box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.2);\n    }\n    .langue-view-cancel{\n        font-size: 14px;\n        color: #999;\n    }\n    .langue-view-title{\n        font-size: 16px;\n        color: #333;\n    }\n    .langue-view-save{\n        font-size: 14px;\n        color: var(--genericColor);\n    }\n    .langue-view-body{\n        max-height: 200px;\n        overflow: auto;\n        padding: 10px 0;\n    }\n    .langue-view-body-view{\n        position: relative;\n        width: 100%;\n        height: 40px;\n        display: flex;\n        align-items: center;\n        font-size: 14px;\n        color: #333;\n        padding-left: 90px;\n    }\n    .langue-view-body-view .iconfont{\n        display: none;\n        position: absolute;\n        left: 30px;\n        top: 0;\n        line-height: 40px;\n        font-size: 16px;\n    }\n    .langue-view-body-view-select{\n        color: var(--genericColor);\n    }\n    .langue-view-body-view-select .iconfont{\n        display: block;\n    }</style>');
$templateCache.put('app/entities/components/material-list.html','<div class="editor-nav-view-li"><div class="c-mask-tab"><span ng-class="{\'c-mask-tab-select\' : vm.maskType == \'recommend\',\'c-mask-tab-select-black\':vm.Theme == \'Three\'}" ng-click="vm.maskType = \'recommend\'">{{\'nav.mask.content.tab1\' | translate}}</span> <span ng-class="{\'c-mask-tab-select\' : vm.maskType == \'general\',\'c-mask-tab-select-black\':vm.Theme == \'Three\'}" ng-click="vm.maskType = \'general\'">{{\'nav.mask.content.tab2\' | translate}}</span></div><div ng-show="vm.maskType == \'recommend\'"><div class="leftPanel-head" style="padding: 0"><div class="leftPanel-privacy" style="margin: 0"><button ng-repeat="label in vm.masklabels track by $index" ng-click="vm.masklabelCb(label,$index)" data-index="{{$index}}" class="leftPanel-privacy-btn" ng-show="$index<8||showMaskLabels" ng-class="{\'leftPanel-privacy-btn-active\':vm.Theme == \'Three\'&&label.id==vm.masklabelChooseId.id,\'leftPanel-privacy-btn-active\':label.id==vm.masklabelChooseId.id}">{{label.name}}</button><div class="leftPanel-privacy-btn-more" ng-if="vm.masklabels.length >8"><div ng-if="!showMaskLabels" ng-click="showMoreMaskLabels(true)"><span>{{\'button.spread\' | translate}}</span><i class="iconfont iconzhankaigengduo11 font-12"></i></div><div ng-if="showMaskLabels" ng-click="showMoreMaskLabels(false)"><span>{{\'button.packUp\' | translate}}</span><i class="iconfont iconyouceshouqi11 font-12"></i></div></div></div></div><div class="nav-mask mar-top-10"><img src="content/images/icons/loading01.gif" class="nav-mask-loading" ng-show="vm.maskLoading"><ul ng-hide="vm.maskLoading" style="padding: 0"><li ng-repeat="mask in vm.maskList track by $index" data-index="{{$index}}"><div class="nav-mask-div" style="width: 100%;height: 100%; display: flex; justify-content: center; align-items: center; padding: 5px"><img ng-src="{{mask.identifier | imageFilter}}" alt="" style="max-width: 100%; max-height: 100%" draggable="true" ondragstart="dragStart(event)" ondragend="dragOn(event)" id="dragtargetMask{{$index}}" data-index="{{$index}}" data-item="{{mask}}"></div></li></ul><button class="load-more" style="bottom:10px" ng-if="vm.masklabelsFulfill" ng-click="loadMoreMasks()">{{\'button.loadMore\' | translate}}</button><div class="default-diagram" ng-show="vm.maskList.length == 0 && !vm.maskLoading"><img src="content/images/default-diagram.png"><div>{{\'hint.noData\' | translate}}</div></div><div class="text-center" ng-if="!vm.masklabelsFulfill && vm.maskList.length>0&& !vm.maskLoading"><span class="tip-text">{{\'hint.noMore\' | translate}}</span></div></div></div><div ng-if="vm.maskType == \'general\'"><div class="c-mask-general" style="padding: 0"><div class="" style="padding:5px" ng-repeat="mask in vm.generalMask"><div class="nav-mask-div"><img ng-src="{{mask.identifier | imageFilter}}" draggable="true" ondragstart="dragStart(event)" ondragend="dragOn(event)" id="{{mask.type1 == \'round\' ? \'dragtargetMaskRound\' : \'dragtargetMaskRectangle\'}}" data-index="{{$index}}" data-item="{{mask}}"></div></div></div></div></div><style>.c-mask-tab-select, .c-mask-tab span{\n        color: #333 !important;\n    }</style>');
$templateCache.put('app/entities/components/outline-view.html','<div class="three-modal"><div class="c-modal" ng-if="!vm.isMobile"><div class="c-modal-head" style="border: none"><span style="font-weight: bold">{{"outline.editTitle" | translate }}</span> <img style="float: right; width: 20px" src="content/images/icons/log_close.png" ng-click="modalHide()"></div><div class="c-modal-body chalk-view" style="text-align: left"><div class="chalk-view-1"><div class="chalk-view-1-3"><div ng-style="{\n                        position: \'relative\',\n                        width: vm.scale * page.mediabox.width,\n                        height: vm.scale * page.mediabox.height,\n                        background: \'#ddd\'}"><div style="width: 100%;height:100%;position: relative"><div ng-if="!page.outline" class="border-outline" ng-style="{\n                                \'width\':page.trimbox.width * vm.scale,\n                                \'height\':page.trimbox.height * vm.scale,\n                                \'left\':page.trimbox.x * vm.scale,\n                                \'top\':page.trimbox.y * vm.scale,\n                            }"></div><page-preview page="page" editor-type="\'PICTURE_PRO_P\'" is-outline="true" scale="vm.scale"></page-preview></div><!-- <div class="not-text" ng-if="!page.outline || !page.outline.cutline.resource || !page.outline.cutline.resource.identifier">{{"outline.noFile" | translate}}</div> --><!-- \u9AD8\u5EA6\u6807\u6CE8\u7EBF\uFF08\u5DE6\u4FA7\uFF09 --><div class="dimension-h"><span class="dimension-h-tick dimension-h-tick-top"></span> <span class="dimension-h-text">{{vm.height}}mm</span> <span class="dimension-h-tick dimension-h-tick-bottom"></span></div><!-- \u5BBD\u5EA6\u6807\u6CE8\u7EBF\uFF08\u5E95\u90E8\uFF09 --><div class="dimension-w"><span class="dimension-w-tick dimension-w-tick-left"></span> <span class="dimension-w-text">{{vm.width}}mm</span> <span class="dimension-w-tick dimension-w-tick-right"></span></div></div></div></div><div class="chalk-view-2"><div class="chalk-view-2-2"><i class="iconfont iconshangchuanzhaopian1"></i> <span>{{"outline.uploadCustom" | translate}}</span> <input onchange="updatePicOutline(event)" type="file" accept="image/png"></div><div class="chalk-view-2-2 chalk-view-2-2-reset" ng-click="resetOutline()"><i class="iconfont iconqingchu"></i> <span>{{"outline.reset" | translate}}</span></div><div class="outline-width-control" ng-if="page.outline && page.outline.type && page.outline.type === \'cutline\' && page.outline.cutline.resource && page.outline.cutline.resource.identifier"><div class="outline-width-title">{{"outline.strokeWidth" | translate}}</div><div class="outline-width-slider"><input class="outline-width-range" type="range" min="0" max="5" step="1" ng-model="vm.contourWidth" ng-change="vm.changeOutlineWidth()" ng-model-options="{ debounce: 250 }" aria-label=\'{{"outline.strokeWidth" | translate}}\'><div class="outline-width-ticks" aria-hidden="true"><span></span><span></span><span></span><span></span><span></span><span></span></div></div><div class="outline-width-labels"><span>{{"outline.fullCut" | translate}}</span> <span>1mm</span> <span>2mm</span> <span>3mm</span> <span>4mm</span> <span>5mm</span></div></div><div class="chalk-view-2-2 chalk-view-2-2-delete" style="margin-top: 60px" ng-click="removeOutline()" ng-if="page.outline && page.outline.type"><i class="iconfont iconqingchu"></i> <span>{{"outline.removeOutline" | translate}}</span></div></div></div><div class="c-modal-foot"><button class="confirm-dialog-footer-cancel" ng-click="modalHide()">{{"button.cancel" | translate}}</button> <button class="confirm-dialog-footer-delete" ng-click="save()">{{"outline.save" | translate}}</button></div></div><div class="c-mobile-modal" ng-if="vm.isMobile"><div class="mobile-head"><div class="mobile-btn" ng-click="modalHide()">{{"button.back" | translate}}</div><div class="mobile-btn-2" style="width: 110px" ng-click="resetOutline()">{{"outline.reset" | translate}}</div><div class="mobile-btn-2" ng-click="removeOutline()" ng-if="page.outline">{{"outline.removeOutline" | translate}}</div><div class="mobile-btn-3" ng-click="save()">{{"outline.save" | translate}}</div></div><div class="mobile-content" ng-style="{\n                position: \'relative\',\n                width: vm.scale * page.mediabox.width,\n                height: vm.scale * page.mediabox.height,\n                background: \'#ddd\'}"><div class="mobile-content-1" ng-if="page.outline && page.outline.cutline && page.outline.cutline.resource.identifier"><page-preview page="page" editor-type="\'PICTURE_PRO_P\'" is-outline="true" scale="vm.scale"></page-preview></div><div class="mobile-content-2" ng-if="!page.outline || !page.outline.cutline || !page.outline.cutline.resource.identifier"><div class="mobile-content-2-1"><i class="iconfont iconjia2"></i><div style="width: 100%; margin: 10px 0">{{"outline.uploadOutline" | translate}}</div><div style="width: 100%;font-weight: 400; font-size: 12px; color: #999999">{{"outline.uploadHint" | translate}}</div><input onchange="updatePicOutline(event)" type="file" accept="image/png"></div></div><!-- \u9AD8\u5EA6\u6807\u6CE8\u7EBF\uFF08\u5DE6\u4FA7\uFF09 --><div class="dimension-h"><span class="dimension-h-tick dimension-h-tick-top"></span> <span class="dimension-h-text">{{vm.height}}mm</span> <span class="dimension-h-tick dimension-h-tick-bottom"></span></div><!-- \u5BBD\u5EA6\u6807\u6CE8\u7EBF\uFF08\u5E95\u90E8\uFF09 --><div class="dimension-w"><span class="dimension-w-tick dimension-w-tick-left"></span> <span class="dimension-w-text">{{vm.width}}mm</span> <span class="dimension-w-tick dimension-w-tick-right"></span></div></div><div class="mobile-foot" ng-if="page.outline && page.outline.type && page.outline.type === \'cutline\' && page.outline.cutline.resource && page.outline.cutline.resource.identifier"><div class="outline-width-control"><div class="outline-width-title">{{"outline.strokeWidth" | translate}}</div><div class="outline-width-slider"><input class="outline-width-range" type="range" min="0" max="5" step="1" ng-model="vm.contourWidth" ng-change="vm.changeOutlineWidth()" ng-model-options="{ debounce: 250 }" aria-label=\'{{"outline.strokeWidth" | translate}}\'><div class="outline-width-ticks" aria-hidden="true"><span></span><span></span><span></span><span></span><span></span><span></span></div></div><div class="outline-width-labels"><span>{{"outline.fullCut" | translate}}</span> <span>1mm</span> <span>2mm</span> <span>3mm</span> <span>4mm</span> <span>5mm</span></div></div></div></div></div><div class="three-modal1" ng-if="vm.threeLoading"><img src="content/images/icon/loading.gif" alt=""><div>{{vm.threeLoadingText}}</div></div><!-- \u7F29\u7565\u56FE --><div id="thumbnail-outline" ng-if="page" style="position: absolute;left: 0;top: 0; z-index: -1; overflow: hidden"><page-preview page="page" scale="1" thumbnail="true"></page-preview></div><!-- \u5200\u7EBF\u5931\u8D25 --><div class="three-modal" style="z-index: 1001" ng-if="vm.errorImage" ng-class="{\'c-mode-modal\': vm.isMobile}"><div class="c-modal"><div class="c-modal-head" style="border: none"><span style="font-weight: bold">{{"outline.editTitle" | translate }}</span> <img style="float: right; width: 20px" src="content/images/icons/log_close.png" ng-click="vm.errorImage = null"></div><div class="c-modal-body" style="text-align: left; padding: 0 20px"><div style="color: #333; font-size: 16px; line-height: 30px">\u68C0\u6D4B\u5230\u6587\u4EF6\u5F02\u5E38\uFF0C\u8BF7\u4FEE\u6539\u540E\u91CD\u65B0\u4E0A\u4F20</div><div style="color: #333; font-size: 14px; line-height: 30px"><i class="iconfont iconjinggao1" style="color: #FF4D4F"></i>\u5355\u90E8\u4EF6\u4EC5\u652F\u6301\u8BBE\u8BA1\u4E00\u4E2A\u5916\u8F6E\u5ED3\uFF0C\u591A\u4E2A\u5206\u79BB\u5916\u8F6E\u5ED3\u8BF7\u521B\u5EFA\u591A\u4E2A\u90E8\u4EF6</div><div style="width: 100%; display: flex; justify-content: center; align-items: center; padding: 30px 0"><div ng-style="{\n                position: \'relative\',\n                width: vm.scale1 * page.mediabox.width,\n                height: vm.scale1 * page.mediabox.height}"><img ng-src="{{vm.errorImage.image}}" style="width: 100%; height: 100%"><div class="outline-error-mask" style="position: absolute; left: 0; top: 0; width: 100%; height: 100%; mask-size: cover" ng-style="{\'mask-image\': \'url(\' + vm.errorImage.multiple + \')\'}"></div></div></div></div><div class="c-modal-foot"><button class="confirm-dialog-footer-cancel" ng-click="vm.errorImage = null">\u53D6\u6D88</button> <button class="confirm-dialog-footer-delete" style="position: relative"><span>\u91CD\u65B0\u4E0A\u4F20</span> <input onchange="updatePicOutline(event)" type="file" accept="image/png"></button></div></div></div><style>.c-modal {\n        width: 1090px;\n        height: auto;\n        background: #fff;\n        border-radius: 8px;\n        margin: 50px auto;\n    }\n\n    /* \u5200\u7EBF\u5F02\u5E38\u9AD8\u4EAE\uFF1A\u7EA2\u8272\u80CC\u666F + \u95EA\u70C1\u52A8\u753B\uFF08\u901A\u8FC7 mask \u53EA\u663E\u793A\u5F02\u5E38\u8F6E\u5ED3\u533A\u57DF\uFF09 */\n    .outline-error-mask {\n        background: #FF4D4F;\n        animation: outline-error-blink 0.8s ease-in-out infinite;\n    }\n\n    @keyframes outline-error-blink {\n        0%, 100% { opacity: 1; }\n        50% { opacity: 0.25; }\n    }\n\n    .chalk-view {\n        padding: 24px;\n        height: 100%;\n        display: flex;\n        justify-content: space-between;\n    }\n\n    .chalk-view-1 {\n        width: 600px;\n        height: 600px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        position: relative;\n    }\n\n    .chalk-view-1-3 {\n        width: 100%;\n        height: 100%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n\n    .chalk-view-2 {\n        width: 400px;\n    }\n\n    .chalk-view-2-2 {\n        position: relative;\n        margin-top: 16px;\n        width: 100%;\n        height: 40px;\n        background: #FC5722;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        color: #fff;\n        font-size: 14px;\n        border-radius: 8px;\n        cursor: pointer;\n    }\n\n    input[type="file"] {\n        width: 100%;\n        height: 100%;\n        position: absolute;\n        top: 0;\n        left: 0;\n        opacity: 0;\n        cursor: pointer;\n        z-index: 1;\n    }\n    .chalk-view-2-2-reset{\n        background: #176be8;\n        color: #fff;\n    }\n    .chalk-view-2-2-delete {\n        background: #ffa503;\n        color: #fff;\n    }\n\n    .outline-width-control {\n        margin-top: 16px;\n        width: 100%;\n        color: #666666;\n    }\n\n    .outline-width-title {\n        font-size: 14px;\n        line-height: 20px;\n    }\n\n    .outline-width-range {\n        width: 100% !important;\n        height: 4px !important;\n        margin: 10px 0 8px !important;\n        appearance: none !important;\n        -webkit-appearance: none !important;\n        background:\n            radial-gradient(circle at 0% 50%, #FFFFFF 0, #FFFFFF 5px, #D1D5DB 5px, #D1D5DB 7px, transparent 7px),\n            radial-gradient(circle at 20% 50%, #FFFFFF 0, #FFFFFF 5px, #D1D5DB 5px, #D1D5DB 7px, transparent 7px),\n            radial-gradient(circle at 40% 50%, #FFFFFF 0, #FFFFFF 5px, #D1D5DB 5px, #D1D5DB 7px, transparent 7px),\n            radial-gradient(circle at 60% 50%, #FFFFFF 0, #FFFFFF 5px, #D1D5DB 5px, #D1D5DB 7px, transparent 7px),\n            radial-gradient(circle at 80% 50%, #FFFFFF 0, #FFFFFF 5px, #D1D5DB 5px, #D1D5DB 7px, transparent 7px),\n            radial-gradient(circle at 100% 50%, #FFFFFF 0, #FFFFFF 5px, #D1D5DB 5px, #D1D5DB 7px, transparent 7px),\n            #E5E7EB !important;\n        border-radius: 2px !important;\n        cursor: pointer !important;\n        vertical-align: middle !important;\n    }\n\n    .outline-width-slider {\n        position: relative;\n        height: 14px;\n        margin: 10px 0 8px;\n    }\n\n    .outline-width-slider::before {\n        content: \'\';\n        position: absolute;\n        top: 5px;\n        right: 7px;\n        left: 7px;\n        height: 4px;\n        background: #E5E7EB;\n        border-radius: 2px;\n    }\n\n    .outline-width-slider .outline-width-range {\n        position: absolute;\n        top: 5px;\n        left: 0;\n        z-index: 2;\n        margin: 0 !important;\n        background: transparent !important;\n    }\n\n    .outline-width-range::-webkit-slider-runnable-track {\n        background: transparent;\n    }\n\n    .outline-width-range::-moz-range-track {\n        background: transparent;\n    }\n\n    .outline-width-ticks {\n        position: absolute;\n        top: 0;\n        left: 0;\n        z-index: 1;\n        display: flex;\n        width: 100%;\n        justify-content: space-between;\n        pointer-events: none;\n    }\n\n    .outline-width-ticks span {\n        width: 14px;\n        height: 14px;\n        box-sizing: border-box;\n        background: #FFFFFF;\n        border: 2px solid #D1D5DB;\n        border-radius: 50%;\n    }\n\n    .outline-width-range::-webkit-slider-thumb {\n        width: 14px !important;\n        height: 14px !important;\n        appearance: none !important;\n        -webkit-appearance: none !important;\n        background: #FFFFFF !important;\n        border: 2px solid #0A8DFE !important;\n        border-radius: 50% !important;\n    }\n\n    .outline-width-range::-moz-range-thumb {\n        width: 10px !important;\n        height: 10px !important;\n        background: #FFFFFF !important;\n        border: 2px solid #0A8DFE !important;\n        border-radius: 50% !important;\n    }\n\n    .outline-width-labels {\n        display: flex;\n        justify-content: space-between;\n        font-size: 12px;\n        color: #A1A1AA;\n        line-height: 16px;\n    }\n\n    /* \u79FB\u52A8\u7AEF */\n    .c-mobile-modal {\n        position: relative;\n        width: 100%;\n        height: 100%;\n        background: #fff;\n        padding-top: 100px;\n    }\n\n    .mobile-btn {\n        width: 60px;\n        height: 35px;\n        background: #FFFFFF;\n        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);\n        border-radius: 16px;\n        font-weight: 500;\n        font-size: 14px;\n        color: #333333;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n\n    .mobile-content {\n        position: relative;\n        width: 343px;\n        height: 343px;\n        margin: 0 auto 20px;\n    }\n\n    .mobile-content-1 {\n        width: 100%;\n        height: 100%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n\n    .mobile-content-2 {\n        position: relative;\n        width: 100%;\n        height: 100%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n\n    .mobile-content-2-1 {\n        position: relative;\n        width: 100%;\n        height: 110px;\n        display: flex;\n        flex-wrap: wrap;\n        justify-content: center;\n        align-items: center;\n        color: #0A8DFE;\n        font-size: 16px;\n        font-weight: bold;\n        text-align: center;\n    }\n\n    .mobile-content-2-1 i {\n        font-size: 32px;\n    }\n\n    .mobile-foot {\n        position: fixed;\n        left: 0;\n        bottom: 0;\n        width: 100%;\n        height: 88px;\n        background: #FFFFFF;\n        box-shadow: 0px -12px 21px -10px rgba(6, 6, 6, 0.11);\n        display: flex;\n        justify-content: space-between;\n        padding: 16px;\n    }\n\n    .mobile-foot .outline-width-control {\n        margin: 0;\n    }\n\n    .mobile-btn-2 {\n        position: relative;\n        width: 80px;\n        height: 35px;\n        background: #fff;\n        color: #FB5721;\n        border: 1px solid #FB5721;\n        border-radius: 20px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        font-size: 14px;\n    }\n\n    .mobile-btn-3 {\n        width: 80px;\n        height: 35px;\n        background: #FB5721;\n        color: #fff;\n        border: 1px solid #FB5721;\n        border-radius: 20px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        font-size: 14px;\n        color: #FFFFFF;\n    }\n\n    /* \u5C3A\u5BF8\u6807\u6CE8\u7EBF */\n    .dimension-h {\n        position: absolute;\n        left: -18px;\n        top: 0;\n        height: 100%;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: space-between;\n        z-index: 2;\n    }\n    .dimension-h::before {\n        content: \'\';\n        position: absolute;\n        left: 50%;\n        top: 6px;\n        bottom: 6px;\n        width: 1px;\n        background: #0A8DFE;\n        transform: translateX(-50%);\n    }\n    .dimension-h-tick {\n        width: 8px;\n        height: 1px;\n        background: #0A8DFE;\n        flex-shrink: 0;\n    }\n    .dimension-h-text {\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%) rotate(-90deg);\n        background: #F4F5F6;\n        padding: 2px 4px;\n        font-size: 11px;\n        color: #0A8DFE;\n        font-weight: normal;\n        white-space: nowrap;\n    }\n\n    .dimension-w {\n        position: absolute;\n        bottom: -18px;\n        left: 0;\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        z-index: 2;\n    }\n    .dimension-w::before {\n        content: \'\';\n        position: absolute;\n        top: 50%;\n        left: 6px;\n        right: 6px;\n        height: 1px;\n        background: #0A8DFE;\n        transform: translateY(-50%);\n    }\n    .dimension-w-tick {\n        width: 1px;\n        height: 8px;\n        background: #0A8DFE;\n        flex-shrink: 0;\n    }\n    .dimension-w-text {\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        background: #F4F5F6;\n        padding: 2px 4px;\n        font-size: 11px;\n        color: #0A8DFE;\n        font-weight: normal;\n        white-space: nowrap;\n    }\n\n    .not-text{\n        width: 100%;\n        height: 100%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        font-size: 18px;\n    }\n    .mobile-head{\n        position: fixed;\n        left: 0;\n        top: 0;\n        width: 100%;\n        background: #FFFFFF;\n        box-shadow: 0px 12px 21px -10px rgba(6, 6, 6, 0.11);\n        display: flex;\n        justify-content: space-between;\n        padding: 16px;\n    }\n\n    \n    .c-mode-modal .c-modal{\n        position: absolute;\n        left: 0;\n        bottom: 0;\n        width: 100%;\n        border-radius: 8px 8px 0 0;\n        margin: 0;\n    }\n    .c-mode-modal .c-modal-body{\n        padding: 0 20px;\n    }\n    .c-mode-modal .c-modal-foot{\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        gap: 20px;\n    }\n    .c-mode-modal .c-modal-foot button{\n        width: 40%;\n        height: 40px;\n        border-radius: 20px;\n        font-size: 14px;\n        margin: 0;\n    }</style>');
$templateCache.put('app/entities/components/page-edit.html','<div class="page-edit-view" style="position: relative" ng-style="{\n        \'width\': vm.pageData[vm.pageIndex].custom.width * vm.pageData[vm.pageIndex].custom.ratio,\n        \'height\': vm.pageData[vm.pageIndex].custom.height * vm.pageData[vm.pageIndex].custom.ratio,\n    }"><div style="width: 100%; height: 100%; position: absolute" ng-if="vm.pageData[vm.pageIndex].scene" ng-style="{\n                    \'position\': \'absolute\',\n                    \'width\': vm.pageData[vm.pageIndex].custom.width * vm.pageData[vm.pageIndex].custom.ratio,\n                    \'height\': vm.pageData[vm.pageIndex].custom.height * vm.pageData[vm.pageIndex].custom.ratio,\n                    \'z-index\': vm.pageData[vm.pageIndex].scene.hierarchy == \'TOP\' ? \'1\' : \'0\',\n                    \'pointer-events\': \'none\'\n                }"><img ng-src="{{vm.pageData[vm.pageIndex].scene.resource.identifier | imageFilter}}" alt="" ng-style="{\n                                            \'width\': vm.pageData[vm.pageIndex].scene.resource.adaptation == \'Width\' ? \'auto\' : \'100%\',\n                                            \'height\': vm.pageData[vm.pageIndex].scene.resource.adaptation == \'Height\' ? \'auto\' : \'100%\'\n                                        }"><div ng-style="{\n                                            \'position\': \'absolute\',\n                                            \'width\': vm.pageData[vm.pageIndex].scene.imagebox.geometry.width * vm.pageData[vm.pageIndex].custom.ratio,\n                                            \'height\': vm.pageData[vm.pageIndex].scene.imagebox.geometry.height * vm.pageData[vm.pageIndex].custom.ratio,\n                                            \'left\': vm.pageData[vm.pageIndex].scene.imagebox.geometry.x * vm.pageData[vm.pageIndex].custom.ratio,\n                                            \'top\': vm.pageData[vm.pageIndex].scene.imagebox.geometry.y * vm.pageData[vm.pageIndex].custom.ratio,\n                                            \'transform\': \'rotate(\' + vm.pageData[vm.pageIndex].scene.imagebox.rotation.angle + \'deg)\',\n                                        }"></div></div><div style="width: 100%; height: 100%; position: relative" ng-style="{\n                \'z-index\': vm.pageData[vm.pageIndex].scene && vm.pageData[vm.pageIndex].scene.hierarchy == \'TOP\' ? 0 : 1\n            }"><div ng-style="pageStyle(vm.pageData[vm.pageIndex])" ng-class="{\'custom-grid2\':!vm.pageData[vm.pageIndex].background.color&&!vm.pageData[vm.pageIndex].scene}" style="transform: matrix(1, 0, 0, 1, 0, 0)"><div style="width: 100%; height: 100%; position: relative" ng-dblclick="editboxDblclick($event)"><div class="border-red" ng-if="vm.editorType != \'PICTURE_PRO_P\'" ng-repeat="editbox in vm.pageData[vm.pageIndex].editboxes.editbox" ng-style="{\n                                    \'width\':editbox.width * vm.pageData[vm.pageIndex].custom.ratio,\n                                    \'height\':editbox.height * vm.pageData[vm.pageIndex].custom.ratio,\n                                    \'left\':editbox.x * vm.pageData[vm.pageIndex].custom.ratio,\n                                    \'top\':editbox.y * vm.pageData[vm.pageIndex].custom.ratio,\n                                }"></div><div class="border-trimbox" ng-class="{\'border-outline\' : vm.editorType === \'PICTURE_PRO_P\'}" ng-style="{\n                                                width:vm.pageData[vm.pageIndex].trimbox.width*vm.pageData[vm.pageIndex].custom.ratio,\n                                                height:vm.pageData[vm.pageIndex].trimbox.height*vm.pageData[vm.pageIndex].custom.ratio,\n                                                top:vm.pageData[vm.pageIndex].trimbox.y*vm.pageData[vm.pageIndex].custom.ratio,\n                                                left:vm.pageData[vm.pageIndex].trimbox.x*vm.pageData[vm.pageIndex].custom.ratio}" ng-if="!vm.pageData[vm.pageIndex].outline"></div><div class="relative-view1" ng-if="vm.pageData[vm.pageIndex].background.type == \'Pic\'"><img ng-src="{{vm.pageData[vm.pageIndex].background.resource.identifier | imageFilter}}" alt="" ng-if="vm.pageData[vm.pageIndex].background.resource.identifier" ng-style="{\n                                            \'position\': \'absolute\',\n                                            \'width\': vm.pageData[vm.pageIndex].background.resource.adaptation == \'Width\' ? vm.pageData[vm.pageIndex].mediabox.width * vm.pageData[vm.pageIndex].custom.ratio : \'auto\',\n                                            \'height\': vm.pageData[vm.pageIndex].background.resource.adaptation == \'Height\' ? vm.pageData[vm.pageIndex].mediabox.height * vm.pageData[vm.pageIndex].custom.ratio : \'auto\',\n                                            \'left\': vm.pageData[vm.pageIndex].background.offsetx * vm.pageData[vm.pageIndex].custom.ratio,\n                                            \'top\': vm.pageData[vm.pageIndex].background.offsety * vm.pageData[vm.pageIndex].custom.ratio\n                                        }"></div><div style="position: absolute;width: 100%; height: 100%; left: 0; top: 0" ng-repeat="level in vm.pageData[vm.pageIndex].levels.level track by $index" ng-if="!level.isHidden"><div ng-if="level.code&&level.code.geometry" ng-class="{\'selected\':level.code.ctrlKey || (vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'code\'),\n                                    \'no-events\': vm.that.dragDom}" ng-mousedown="moveWebdown($event,level.code)" ng-dblclick="codeDblclick($event, level.code, $index)" ng-click="codeClick($event, level.code, $index)" ng-style="{\n                         \'position\':\'absolute\',\n                        \'width\': level.code.geometry.width*vm.pageData[vm.pageIndex].custom.ratio,\n                         \'height\': level.code.geometry.height*vm.pageData[vm.pageIndex].custom.ratio,\n                         \'left\': level.code.geometry.x*vm.pageData[vm.pageIndex].custom.ratio,\n                         \'top\': level.code.geometry.y*vm.pageData[vm.pageIndex].custom.ratio,\n                         \'z-index\':level.seq-0+200,\n                         \'transform\': \'rotate(-\' + level.code.rotation.angle + \'deg)\'\n                        }"><div id="code-qrcode-{{vm.pageIndex}}-{{$index}}" ng-init="initCodeQrcode($index, level.code)"></div></div><div ng-if="level.imagebox" class="imageboxView imageboxView{{vm.pageIndex}}{{$index}}" data-imgindex="{{$index}}" ng-class="{\'selected\':level.imagebox.ctrlKey || (vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'imagebox\')}" ng-dblclick="doubleClickImagebox($event,$index, level.imagebox)" ng-style="{\n                                                \'position\': opacityElement(vm.pageData[vm.pageIndex].mediabox, level.imagebox.geometry) == 1 ? \'absolute\' : \'fixed\',\n                                            width: imageboxW(level.imagebox)*vm.pageData[vm.pageIndex].custom.ratio,\n                                            height: imageboxH(level.imagebox)*vm.pageData[vm.pageIndex].custom.ratio,\n                                            left: imageboxL(level.imagebox)*vm.pageData[vm.pageIndex].custom.ratio,\n                                            top: imageboxT(level.imagebox)*vm.pageData[vm.pageIndex].custom.ratio,\n                                            \'z-index\':level.seq-0+200,\n                                            \'transform\': \'rotate(\' + level.imagebox.rotation.angle + \'deg)\',\n                                            \'opacity\': opacityElement(vm.pageData[vm.pageIndex].mediabox, level.imagebox.geometry)\n                                        }"><div ng-style="{\n                                        \'position\': \'absolute\',\n                                                    \'opacity\':level.imagebox.transparency,\n                                        \'z-index\':0,\n                                        \'left\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'left\')*vm.pageData[vm.pageIndex].custom.ratio : 0,\n                                        \'top\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'top\')*vm.pageData[vm.pageIndex].custom.ratio : 0,\n                                        \'right\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'right\')*vm.pageData[vm.pageIndex].custom.ratio : 0,\n                                        \'bottom\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'bottom\')*vm.pageData[vm.pageIndex].custom.ratio : 0,\n                                        \'background-image\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'url(\' + level.imagebox.border.resource.identifier + \')\' : \'\',\n                                        \'background-size\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'100% 100%\' : \'\'\n                                        }"></div><div class="relative-view2"><div class="relative-view1" ng-style="{\n                                                    \'overflow\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'unset\' : \'hidden\',\n                                                    \'opacity\':level.imagebox.transparency,\n                                                    \'border-top-left-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'lt\',vm.pageData[vm.pageIndex].custom.ratio),\n                                                    \'border-top-right-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'rt\',vm.pageData[vm.pageIndex].custom.ratio),\n                                                    \'border-bottom-right-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'rb\',vm.pageData[vm.pageIndex].custom.ratio),\n                                                    \'border-bottom-left-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'lb\',vm.pageData[vm.pageIndex].custom.ratio),\n                                                    \'border-width\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? ((level.imagebox.border.lineWidth*vm.pageData[vm.pageIndex].custom.ratio) | number:0) : \'\',\n                                                    \'border-style\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? (level.imagebox.border.lineType || \'solid\') : \'none\',\n                                                    \'border-color\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? level.imagebox.border.color : \'\',\n                                                    \'box-shadow\' : (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineWidth>0 && (!level.imagebox.border.lineType || level.imagebox.border.lineType == \'solid\')) ? \'0 0 0 1px \' + level.imagebox.border.color + \' inset\' : \'none\',\n                                                    \'filter\' : dropShadow(level.imagebox,vm.pageData[vm.pageIndex].custom.ratio),\n                                        }"><div class="relative-view1" data-imgindex="{{$index}}" ng-style="{\n                                            \'-webkit-mask-image\': level.imagebox.mask.resource.identifier ? \'url(\' + level.imagebox.mask.resource.identifier + \')\' : \'none\',\n                                            \'-webkit-mask-size\': \'100% 100%\',\n                                            \'border-top-left-radius\':imageboxWRadius1(level.imagebox, \'lt\',vm.pageData[vm.pageIndex].custom.ratio),\n                                            \'border-top-right-radius\':imageboxWRadius1(level.imagebox, \'rt\',vm.pageData[vm.pageIndex].custom.ratio),\n                                            \'border-bottom-right-radius\':imageboxWRadius1(level.imagebox, \'rb\',vm.pageData[vm.pageIndex].custom.ratio),\n                                            \'border-bottom-left-radius\':imageboxWRadius1(level.imagebox, \'lb\',vm.pageData[vm.pageIndex].custom.ratio),\n                                            }" ng-mousedown="moveWebdown($event,level.imagebox)" ng-click="imageboxClick($event, level.imagebox, $index)"><div ng-if="!level.imagebox.image || !level.imagebox.image.resource || !level.imagebox.image.resource.identifier" class="image-placeholder image-placeholder-class" data-imgindex="{{$index}}"><img src="content/images/icons/camera.svg" ondragstart="return false;" alt="" srcset="" data-imgindex="{{$index}}" class="image-placeholder-class" ng-style="{\'width\':imageboxW(level.imagebox)*vm.pageData[vm.pageIndex].custom.ratio <= 56 || imageboxH(level.imagebox)*vm.pageData[vm.pageIndex].custom.ratio <= 56 ? \'50%\' : \'\' ,\'height\':imageboxW(level.imagebox)*vm.pageData[vm.pageIndex].custom.ratio <= 58 || imageboxH(level.imagebox)*vm.pageData[vm.pageIndex].custom.ratio <= 58 ? \'50%\' : \'\'}"> <span data-imgindex="{{$index}}" class="image-placeholder-class" ng-show="imageboxW(level.imagebox)*vm.pageData[vm.pageIndex].custom.ratio > 60 && imageboxH(level.imagebox)*vm.pageData[vm.pageIndex].custom.ratio > 80">{{"editorCommon.dragInPhoto" | translate}}</span></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'None\' && level.imagebox.image.resource.identifier" data-imgindex="{{$index}}"><img ng-if="level.imagebox.whiteInk2" ng-src="{{level.imagebox.whiteInk2.resource.identifier | imageFilter:level.imagebox.image.angle:isLarge(level.imagebox.image.imageInfo)}}" ondragstart="return false;" ng-style="{\n                                                \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                \'position\': \'absolute\',\n                                                \'width\': level.imagebox.image.width*vm.pageData[vm.pageIndex].custom.ratio*level.imagebox.image.scale,\n                                                \'height\': level.imagebox.image.height*vm.pageData[vm.pageIndex].custom.ratio*level.imagebox.image.scale,\n                                                \'left\':level.imagebox.image.offsetx*vm.pageData[vm.pageIndex].custom.ratio*level.imagebox.image.scale,\n                                                \'top\':level.imagebox.image.offsety*vm.pageData[vm.pageIndex].custom.ratio*level.imagebox.image.scale\n                                            }"> <img alt="" data-imgindex="{{$index}}" ng-if="level.imagebox.image.resource.identifier" ng-src="{{level.imagebox.image.resource.identifier | imageFilter:level.imagebox.image.angle:isLarge(level.imagebox.image.imageInfo)}}" ondragstart="return false;" ng-style="{\n                                                \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                \'position\': \'absolute\',\n                                                \'width\': level.imagebox.image.width*vm.pageData[vm.pageIndex].custom.ratio*level.imagebox.image.scale,\n                                                \'height\': level.imagebox.image.height*vm.pageData[vm.pageIndex].custom.ratio*level.imagebox.image.scale,\n                                                \'left\':level.imagebox.image.offsetx*vm.pageData[vm.pageIndex].custom.ratio*level.imagebox.image.scale,\n                                                \'top\':level.imagebox.image.offsety*vm.pageData[vm.pageIndex].custom.ratio*level.imagebox.image.scale,\n                                                \'z-index\': 1\n                                            }"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'Blurred\' && level.imagebox.image.resource.identifier" data-imgindex="{{$index}}"><img class="c-blur" alt="" ng-if="level.imagebox.image.resource.identifier" ng-src="{{level.imagebox.image.resource.identifier | imageFilter:level.imagebox.image.angle:isLarge(level.imagebox.image.imageInfo)}}" data-index="{{$index}}" data-imgindex="{{$index}}" ondragstart="return false;" ng-style="{\n                                                        \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                    \'position\': \'absolute\',\n                                                }"> <img ng-src="{{level.imagebox.image.resource.identifier | imageFilter:level.imagebox.image.angle:isLarge(level.imagebox.image.imageInfo)}}" ng-if="level.imagebox.image.resource.identifier" data-imgindex="{{$index}}" ondragstart="return false;" ng-style="{\n                                                        \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                        \'position\': \'absolute\',\n                                                        \'width\': level.imagebox.blurredrectangle.width*vm.pageData[vm.pageIndex].custom.ratio*level.imagebox.image.scale,\n                                                        \'height\': level.imagebox.blurredrectangle.height*vm.pageData[vm.pageIndex].custom.ratio*level.imagebox.image.scale,\n                                                        \'left\':level.imagebox.blurredrectangle.x*vm.pageData[vm.pageIndex].custom.ratio*level.imagebox.image.scale,\n                                                        \'top\':level.imagebox.blurredrectangle.y*vm.pageData[vm.pageIndex].custom.ratio*level.imagebox.image.scale,\n                                                    \'z-index\': 1\n                                                }"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'Transparent\' && level.imagebox.image.resource.identifier" data-imgindex="{{$index}}"><img alt="" ng-src="{{level.imagebox.image.resource.identifier | imageFilter:level.imagebox.image.angle:isLarge(level.imagebox.image.imageInfo)}}" ondragstart="return false;" ng-if="level.imagebox.image.resource.identifier" data-index="{{$index}}" data-imgindex="{{$index}}" ng-style="{\n                                                        \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.imagebox.blurredrectangle.width*vm.pageData[vm.pageIndex].custom.ratio*level.imagebox.image.scale,\n                                                    \'height\': level.imagebox.blurredrectangle.height*vm.pageData[vm.pageIndex].custom.ratio*level.imagebox.image.scale,\n                                                    \'left\':level.imagebox.blurredrectangle.x*vm.pageData[vm.pageIndex].custom.ratio*level.imagebox.image.scale,\n                                                    \'top\':level.imagebox.blurredrectangle.y*vm.pageData[vm.pageIndex].custom.ratio*level.imagebox.image.scale\n                                                }"></div></div><div class="image-exchange" ng-click="changeMaskImage($event, $index)" ng-if="level.imagebox.image.resource.identifier && level.imagebox.exchange"><img src="content/images/icons/web_change01.svg" ondragstart="return false;"></div></div><div class="hint_pixel no-events flex-column-center hint-warning" ng-if="level.imagebox && level.imagebox.image && level.imagebox.image.resource && level.imagebox.image.resource.identifier && pxInsufficient(level.imagebox)" data-imgindex="{{$index}}"><!--                                <img src="content/images/icon/warning-icon.png" alt="" srcset="">--> <i class="icon iconfont iconwaring imageboxWarn" style="font-size: 16px !important"></i><div class="mar-top-10" ng-show="imageboxW(level.imagebox)*vm.pageData[vm.pageIndex].custom.ratio > 60 && imageboxH(level.imagebox)*vm.pageData[vm.pageIndex].custom.ratio > 80">{{\'editorCommon.lackPixels\' | translate}}</div></div><span class="sel-left" data-index="{{$index}}" ng-style="{\'cursor\': cursor(level.imagebox.rotation.angle, \'left\', true)}" ng-mousedown="resizeStartLeft($event,level.imagebox,vm.pageData[vm.pageIndex].custom.ratio, $index)" ng-if="(!level.imagebox.lock && !level.imagebox.ctrlKey && vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'imagebox\')"></span> <span class="sel-top" data-index="{{$index}}" ng-style="{\'cursor\': cursor(level.imagebox.rotation.angle, \'top\', true)}" ng-mousedown="resizeStartTop($event,level.imagebox,vm.pageData[vm.pageIndex].custom.ratio, $index)" ng-if="(!level.imagebox.lock && !level.imagebox.ctrlKey && vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'imagebox\')"></span> <span class="sel-right" data-index="{{$index}}" ng-style="{\'cursor\': cursor(level.imagebox.rotation.angle, \'right\', true)}" ng-mousedown="resizeStartRigth($event, level.imagebox,vm.pageData[vm.pageIndex].custom.ratio, $index)" ng-if="(!level.imagebox.lock && !level.imagebox.ctrlKey && vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'imagebox\')"></span> <span class="sel-bottom" data-index="{{$index}}" ng-style="{\'cursor\': cursor(level.imagebox.rotation.angle, \'bottom\', true)}" ng-mousedown="resizeStartBottom($event,level.imagebox,vm.pageData[vm.pageIndex].custom.ratio, $index)" ng-if="(!level.imagebox.lock && !level.imagebox.ctrlKey && vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'imagebox\')"></span> <span class="sel-left1" data-index="{{$index}}" ng-style="{\'cursor\': cursor(level.imagebox.rotation.angle, \'left1\', true),\'display\':imageboxH(level.imagebox)*vm.pageData[vm.pageIndex].custom.ratio > 30 ? \'block\':\'none\'}" ng-mousedown="resizeStartLeft1($event,level.imagebox,vm.pageData[vm.pageIndex].custom.ratio, $index)" ng-if="(!level.imagebox.lock && !level.imagebox.ctrlKey && vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'imagebox\')"></span> <span class="sel-top1" data-index="{{$index}}" ng-style="{\'cursor\': cursor(level.imagebox.rotation.angle, \'top1\', true),\'display\':imageboxW(level.imagebox)*vm.pageData[vm.pageIndex].custom.ratio > 30 ? \'block\':\'none\'}" ng-mousedown="resizeStartTop1($event,level.imagebox,vm.pageData[vm.pageIndex].custom.ratio, $index)" ng-if="(!level.imagebox.lock && !level.imagebox.ctrlKey && vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'imagebox\')"></span> <span class="sel-right1" data-index="{{$index}}" ng-style="{\'cursor\': cursor(level.imagebox.rotation.angle, \'right1\', true),\'display\':imageboxH(level.imagebox)*vm.pageData[vm.pageIndex].custom.ratio > 30 ? \'block\':\'none\'}" ng-mousedown="resizeStartRight1($event,level.imagebox,vm.pageData[vm.pageIndex].custom.ratio, $index)" ng-if="(!level.imagebox.lock && !level.imagebox.ctrlKey && vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'imagebox\')"></span> <span class="sel-bottom1" data-index="{{$index}}" ng-style="{\'cursor\': cursor(level.imagebox.rotation.angle, \'bottom1\', true),\'display\':imageboxW(level.imagebox)*vm.pageData[vm.pageIndex].custom.ratio > 30 ? \'block\':\'none\'}" ng-mousedown="resizeStartBottom1($event,level.imagebox,vm.pageData[vm.pageIndex].custom.ratio, $index)" ng-if="(!level.imagebox.lock && !level.imagebox.ctrlKey && vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'imagebox\')"></span><div class="rotate-box" ng-if="(!level.imagebox.lock && !level.imagebox.ctrlKey && vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'imagebox\')" style="width: 100%"><div style="position: relative; width: 100%"><!-- <span class="rotate-line"\n                                        style="position: absolute;left: 50%;margin-left: -0.5px;"></span><br> --> <span class="rotate-icon rotate-icon{{$index}}" data-index="{{$index}}" ng-mousedown="imageboxdownRotate($event,level.imagebox)" style="position: absolute; top: 17px; left: 50%; margin-left: -11px"></span></div></div><div class="c-circle-btn" ng-click="locking($event)" style="right: -10px;top: -10px" data-index="{{$index}}" ng-show="(level.imagebox.ctrlKey || (vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'imagebox\')) && level.imagebox.lock"><i class="iconfont iconduomeitiicon- selectedbar" style="font-size: 10px"></i></div><div class="editorbody-dpi-info" ng-if="vm.editorType != \'PICTURE_PRO\' && vm.editorType != \'PICTURE_PRO_P\' && level.imagebox && level.imagebox.image && level.imagebox.image.resource.identifier && (vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'imagebox\')">{{transitionMm(level.imagebox.geometry.width)}} x {{transitionMm(level.imagebox.geometry.height)}} mm, {{activeImageDpi(level.imagebox).toFixed(0)}}dpi</div><div class="editorbody-dpi-info1" ng-if="vm.editorType != \'PICTURE_PRO\' && vm.editorType != \'PICTURE_PRO_P\' && (vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'imagebox\')">{{transitionMm(level.imagebox.geometry.x)}} , {{transitionMm(level.imagebox.geometry.y)}} mm</div></div><div class="imagebox-shade"></div></div><div ng-if="level.imageart" class="c-xml-page-material" ng-class="{\'selected\':level.imageart.ctrlKey || (vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'imageart\'),\n                                    \'no-events\': vm.that.dragDom}" ng-click="imageartClick($event, level.imageart, $index)" ng-dblclick="imageartDblclick($event, level.imageart)" ng-style="{\n                                                \'position\': opacityElement(vm.pageData[vm.pageIndex].mediabox, level.imageart.geometry) == 1 ? \'absolute\' : \'fixed\',\n                                            \'width\': level.imageart.geometry.width * vm.pageData[vm.pageIndex].custom.ratio,\n                                            \'height\': level.imageart.geometry.height * vm.pageData[vm.pageIndex].custom.ratio,\n                                            \'left\': level.imageart.geometry.x * vm.pageData[vm.pageIndex].custom.ratio,\n                                            \'top\': level.imageart.geometry.y * vm.pageData[vm.pageIndex].custom.ratio,\n                                            \'transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                            \'z-index\':level.seq-0+200,\n                                            \'opacity\': opacityElement(vm.pageData[vm.pageIndex].mediabox, level.imageart.geometry)\n                                        }"><div style="overflow: hidden; position: relative; width: 100%; height: 100%" ng-mousedown="moveWebdown($event,level.imageart)"><img class="c-xml-page-material-img" style="position: absolute" ondragstart="return false;" ng-if="level.imageart.resource.identifier && !level.imageart.spotColor" ng-src="{{ level.imageart.resource.identifier | imageFilter}}" ng-style="{\n                                                        \'transform\': level.imageart.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                \'opacity\' : level.imageart.transparency,\n                                                \'left\': level.imageart.offsetx * vm.pageData[vm.pageIndex].custom.ratio + \'px\',\n                                                \'top\': level.imageart.offsety * vm.pageData[vm.pageIndex].custom.ratio + \'px\',\n                                                \'width\': level.imageart.geometry.width * vm.pageData[vm.pageIndex].custom.ratio * level.imageart.scale\n                                            }" alt="\u7D20\u6750\u56FE\u7247"><div class="gold-foil-text" ng-if="level.imageart.resource.identifier && level.imageart.spotColor" style="height: fit-content" ng-style="{\n                                    \'background\': goldFoil(level.imageart.spotColor.color),\n                                    \'position\': \'absolute\',\n                                    \'width\': level.imageart.geometry.width * vm.pageData[vm.pageIndex].custom.ratio * level.imageart.scale,\n                                    \'left\': level.imageart.offsetx * vm.pageData[vm.pageIndex].custom.ratio,\n                                    \'top\': level.imageart.offsety * vm.pageData[vm.pageIndex].custom.ratio,\n                                    \'opacity\': level.imageart.transparency,\n                                    \'transform\': level.imageart.flip ? \'rotateY(180deg)\' : \'unset\',\n                                    \'-webkit-mask-image\': \'url(\' + level.imageart.resource.identifier + \')\',\n                                    \'-webkit-mask-size\': \'100% 100%\'\n                                    }"><img class="c-xml-page-material-img" ng-src="{{ level.imageart.resource.identifier ? level.imageart.resource.identifier+\'?imageMogr2/thumbnail/800x800>\' : \'\'}}" ng-style="{\n                                        \'transform\': level.imageart.flip ? \'rotateY(180deg)\' : \'unset\',\n                                        \'opacity\' : 0,\n                                        \'width\': level.imageart.geometry.width * vm.pageData[vm.pageIndex].custom.ratio * level.imageart.scale,\n                                    }"></div></div><span class="c-xml-page-material-zoom c-xml-page-material-zoom-left1" ng-style="{\'cursor\': cursor(level.imageart.rotation.angle, \'left\', true)}" ng-if="(!level.imageart.lock && !level.imageart.ctrlKey && vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'imageart\')" ng-mousedown="imageartdownZoomLeft($event,level.imageart)"></span> <span class="c-xml-page-material-zoom c-xml-page-material-zoom-top" ng-style="{\'cursor\': cursor(level.imageart.rotation.angle, \'top\', true)}" ng-if="(!level.imageart.lock && !level.imageart.ctrlKey && vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'imageart\')" ng-mousedown="imageartdownZoomTop($event,level.imageart)"></span> <span class="c-xml-page-material-zoom c-xml-page-material-zoom-right1" ng-style="{\'cursor\': cursor(level.imageart.rotation.angle, \'right\', true)}" ng-if="(!level.imageart.lock && !level.imageart.ctrlKey && vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'imageart\')" ng-mousedown="imageartdownZoomRight($event,level.imageart)"></span> <span class="c-xml-page-material-zoom c-xml-page-material-zoom-bottom" ng-style="{\'cursor\': cursor(level.imageart.rotation.angle, \'bottom\', true)}" ng-if="(!level.imageart.lock && !level.imageart.ctrlKey && vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'imageart\')" ng-mousedown="imageartdownZoomBottom($event,level.imageart)"></span><div class="c-xml-page-material-rotate" ng-if="(!level.imageart.lock && !level.imageart.ctrlKey && vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'imageart\')"><span class="c-xml-page-material-rotate-icon" ng-mousedown="imageartdownRotate($event,level.imageart)"></span></div><div class="c-circle-btn" ng-click="locking($event)" style="right: -10px;top: -10px" data-index="{{$index}}" ng-show="(level.imageart.ctrlKey || (vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'imageart\')) && level.imageart.lock"><i class="iconfont iconduomeitiicon- selectedbar" style="font-size: 10px"></i></div></div><div ng-if="level.textbox" class="c-xml-page-textboxe" ng-class="{\'selected\':level.textbox.ctrlKey || (vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'textbox\')}" ng-click="textboxClick($event, level.textbox, $index)" ng-style="{\n                                                \'position\': opacityElement(vm.pageData[vm.pageIndex].mediabox, level.textbox.geometry) == 1 ? \'absolute\' : \'fixed\',\n                                            \'width\': level.textbox.geometry.width * vm.pageData[vm.pageIndex].custom.ratio,\n                                            \'height\': level.textbox.geometry.height * vm.pageData[vm.pageIndex].custom.ratio,\n                                            \'left\': level.textbox.geometry.x * vm.pageData[vm.pageIndex].custom.ratio,\n                                            \'top\': level.textbox.geometry.y * vm.pageData[vm.pageIndex].custom.ratio,\n                                            \'transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                            \'z-index\': level.seq-0+200,\n                                            \'opacity\': opacityElement(vm.pageData[vm.pageIndex].mediabox, level.textbox.geometry)\n                                        }"><pre class="c-xml-page-textboxe-text web-font c-xml-page-textboxe-text{{vm.pageIndex}}{{$index}}" data-index="{{$index}}" ng-mousedown="moveWebdown($event,level.textbox)" ng-dblclick="doubleClicktext($event, level.textbox, $index)" ng-style="{\n                                                \'font-family\': \'\\\'\' + level.textbox.fontuuid + \'\\\'\',\n                                                \'font-size\': (level.textbox.style.size*vm.pageData[vm.pageIndex].custom.ratio > 12 ? level.textbox.style.size* vm.pageData[vm.pageIndex].custom.ratio : 12) + \'pt\',\n                                                \'color\': level.textbox.style.color,\n                                                \'font-weight\': level.textbox.style.bold ? \'bold\': \'400\',\n                                                \'font-style\': level.textbox.style.italic ? \'italic\': \'initial\',\n                                                \'line-height\': (level.textbox.style.size * vm.pageData[vm.pageIndex].custom.ratio > 12 ? level.textbox.style.lineheight * vm.pageData[vm.pageIndex].custom.ratio : (level.textbox.style.lineheight * vm.pageData[vm.pageIndex].custom.ratio) / (1 / 12 * level.textbox.style.size * vm.pageData[vm.pageIndex].custom.ratio)) + \'pt\',\n                                                \'letter-spacing\': (level.textbox.style.size * vm.pageData[vm.pageIndex].custom.ratio > 12 ? level.textbox.style.letterspacing * vm.pageData[vm.pageIndex].custom.ratio : (level.textbox.style.letterspacing * vm.pageData[vm.pageIndex].custom.ratio) / (1 / 12 * level.textbox.style.size * vm.pageData[vm.pageIndex].custom.ratio)) + \'pt\',\n                                                \'opacity\': level.textbox.transparency,\n                                                \'text-decoration\': \'none\',\n                                                \'text-align\': level.textbox.style.align,\n                                                \'text-align-last\': \'unset\',\n                                                \'transform\':\'scale(\'+(1 / 12 * level.textbox.style.size* vm.pageData[vm.pageIndex].custom.ratio > 1 ? 1 : 1 / 12 * level.textbox.style.size* vm.pageData[vm.pageIndex].custom.ratio)+\')\',\n                                                \'transform-origin\': \'0 0\',\n                                                \'writing-mode\': level.textbox.style.writingmode,\n                                                 \'width\': level.textbox.style.size * vm.pageData[vm.pageIndex].custom.ratio > 12 ? level.textbox.geometry.width * vm.pageData[vm.pageIndex].custom.ratio : (level.textbox.geometry.width * vm.pageData[vm.pageIndex].custom.ratio) / (1 / 12 * level.textbox.style.size * vm.pageData[vm.pageIndex].custom.ratio) + \'px\',\n                                                 \'height\': level.textbox.style.size * vm.pageData[vm.pageIndex].custom.ratio > 12 ? level.textbox.geometry.height * vm.pageData[vm.pageIndex].custom.ratio : (level.textbox.geometry.height * vm.pageData[vm.pageIndex].custom.ratio) / (1 / 12 * level.textbox.style.size * vm.pageData[vm.pageIndex].custom.ratio) + \'px\',\n                                            }"><span class="c-xml-page-textboxe-span" onpaste="textPaste(event)" ng-blur="blur($event,level.textbox)" ng-keyup="changeHeight($event,level.textbox)">{{level.textbox.text}}</span></pre><div class="loading-font" ng-if="level.textbox.loading"></div><span class="c-xml-page-material-zoom c-xml-page-material-zoom-left" ng-style="{\'cursor\': cursor(level.textbox.rotation.angle, \'left1\', true)}" ng-if="(!level.textbox.lock && !level.textbox.ctrlKey && vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'textbox\' && !writingmodeInit(level.textbox.style.writingmode))" ng-mousedown="textboxZoomLeft($event,level.textbox)"></span> <span class="c-xml-page-material-zoom c-xml-page-material-zoom-right" ng-style="{\'cursor\': cursor(level.textbox.rotation.angle, \'right1\', true)}" ng-if="(!level.textbox.lock && !level.textbox.ctrlKey && vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'textbox\' && !writingmodeInit(level.textbox.style.writingmode))" ng-mousedown="textboxZoomRight($event,level.textbox)"></span> <span class="sel-top1" ng-style="{\'cursor\': cursor(level.textbox.rotation.angle, \'top1\', true)}" ng-if="(!level.textbox.lock && !level.textbox.ctrlKey && vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'textbox\' && writingmodeInit(level.textbox.style.writingmode))" ng-mousedown="textboxZoomTop($event,level.textbox)"></span> <span class="sel-bottom1" ng-style="{\'cursor\': cursor(level.textbox.rotation.angle, \'bottom1\', true)}" ng-if="(!level.textbox.lock && !level.textbox.ctrlKey && vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'textbox\' && writingmodeInit(level.textbox.style.writingmode))" ng-mousedown="textboxZoomBottom($event,level.textbox)"></span> <span class="c-xml-page-material-zoom c-xml-page-material-zoom-left1" ng-style="{\'cursor\': cursor(level.textbox.rotation.angle, \'left\', true)}" ng-if="(!level.textbox.lock && !level.textbox.ctrlKey && vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'textbox\')" ng-mousedown="textboxZoomLeft1($event,level.textbox)"></span> <span class="c-xml-page-material-zoom c-xml-page-material-zoom-top1" ng-style="{\'cursor\': cursor(level.textbox.rotation.angle, \'top\', true)}" ng-if="(!level.textbox.lock && !level.textbox.ctrlKey && vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'textbox\')" ng-mousedown="textboxZoomTop1($event,level.textbox)"></span> <span class="c-xml-page-material-zoom c-xml-page-material-zoom-right1" ng-style="{\'cursor\': cursor(level.textbox.rotation.angle, \'right\', true)}" ng-if="(!level.textbox.lock && !level.textbox.ctrlKey && vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'textbox\')" ng-mousedown="textboxZoomRight1($event,level.textbox)"></span> <span class="c-xml-page-material-zoom c-xml-page-material-zoom-bottom1" ng-style="{\'cursor\': cursor(level.textbox.rotation.angle, \'bottom\', true)}" ng-if="(!level.textbox.lock && !level.textbox.ctrlKey && vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'textbox\')" ng-mousedown="textboxZoomBottom1($event,level.textbox)"></span><div class="c-xml-page-material-rotate" ng-if="(!level.textbox.lock && !level.textbox.ctrlKey && vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'textbox\')"><span class="c-xml-page-material-rotate-icon" ng-mousedown="textboxRotate($event,level.textbox)"></span></div><div class="c-circle-btn" ng-click="locking($event)" style="right: -10px;top: -10px" data-index="{{$index}}" ng-show="(level.textbox.ctrlKey || (vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'textbox\')) && level.textbox.lock"><i class="iconfont iconduomeitiicon- selectedbar" style="font-size: 10px"></i></div></div><div data-index="{{$index}}" class="c-xml-page-textboxe" ng-class="{\'selected\':level.textdocument.ctrlKey || (vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'textdocument\')}" ng-if="level.textdocument" ng-mousedown="moveWebdown($event,level.textdocument)" ng-click="textdocumentClick($event, level.textdocument, $index)" ng-style="{\n                                                \'position\': opacityElement(vm.pageData[vm.pageIndex].mediabox, level.textdocument.geometry) == 1 ? \'absolute\' : \'fixed\',\n                                                width: level.textdocument.geometry.width * vm.pageData[vm.pageIndex].custom.ratio,\n                                                height: level.textdocument.geometry.height * vm.pageData[vm.pageIndex].custom.ratio,\n                                                left: level.textdocument.geometry.x * vm.pageData[vm.pageIndex].custom.ratio,\n                                                top: level.textdocument.geometry.y * vm.pageData[vm.pageIndex].custom.ratio,\n                                                \'z-index\':level.seq-0+200,\n                                                filter: \'alpha(opacity=\'+level.textdocument.transparency*100+\')\',\n                                                \'transform\': \'rotate(\' + level.textdocument.rotation.angle + \'deg)\',\n                                                \'opacity\': opacityElement(vm.pageData[vm.pageIndex].mediabox, level.textdocument.geometry)}"><div style="overflow: hidden;width: 100%;height: 100%;position: relative" class="no-events" ng-style="{\'opacity\':level.textdocument.transparency.toFixed(2)}"><img class="bg-image bg-image{{template.pageI}} pos" ng-cloak ng-if="level.textdocument.background.resource.identifier" ng-src="{{level.textdocument.background.resource.identifier | imageFilter}}" ng-style="{\n                                                        position: \'absolute\',\n                                                        left:level.textdocument.background.offsetx * vm.pageData[vm.pageIndex].custom.ratio,\n                                                        top:level.textdocument.background.offsety * vm.pageData[vm.pageIndex].custom.ratio,\n                                                        width: level.textdocument.background.adaptation==\'Width\'?level.textdocument.geometry.width * vm.pageData[vm.pageIndex].custom.ratio:\'\',\n                                                        height:level.textdocument.background.adaptation!=\'Width\'?level.textdocument.geometry.height * vm.pageData[vm.pageIndex].custom.ratio:\'\'}"><div ng-repeat="docLevel in level.textdocument.levels.level track by $index" ng-init="docIndex = $index" style="position: relative"><div data-index="{{docIndex}}" class="img-art" ng-if="docLevel.imageart" ng-style="{\n                                                                    width: docLevel.imageart.geometry.width * vm.pageData[vm.pageIndex].custom.ratio,\n                                                                    height: docLevel.imageart.geometry.height * vm.pageData[vm.pageIndex].custom.ratio,\n                                                                    left: docLevel.imageart.geometry.x * vm.pageData[vm.pageIndex].custom.ratio,\n                                                                    top: docLevel.imageart.geometry.y * vm.pageData[vm.pageIndex].custom.ratio,\n                                                                    \'z-index\':docLevel.seq-0+200,\n                                                                    \'opacity\':docLevel.imageart.transparency,\n                                                                    filter: \'alpha(opacity=\'+docLevel.imageart.transparency*100+\')\',\n                                                                    \'transform\': \'rotate(\' + docLevel.imageart.rotation.angle + \'deg)\'}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                                            \'left\': docLevel.imageart.offsetx * vm.pageData[vm.pageIndex].custom.ratio,\n                                                                            \'top\': docLevel.imageart.offsety * vm.pageData[vm.pageIndex].custom.ratio,\n                                                                            \'width\': docLevel.imageart.geometry.width * vm.pageData[vm.pageIndex].custom.ratio}" ng-src="{{docLevel.imageart.resource.identifier | imageFilter}}"></div></div><div class="c-xml-page-textboxe" ng-show="docLevel.textbox" style="white-space: normal" data-index="{{docIndex}}" ng-style="{\n                                                                    \'width\': docLevel.textbox.geometry.width * vm.pageData[vm.pageIndex].custom.ratio,\n                                                                    \'height\': docLevel.textbox.geometry.height * vm.pageData[vm.pageIndex].custom.ratio,\n                                                                    \'left\': docLevel.textbox.geometry.x * vm.pageData[vm.pageIndex].custom.ratio,\n                                                                    \'top\': docLevel.textbox.geometry.y * vm.pageData[vm.pageIndex].custom.ratio,\n                                                                    \'z-index\':docLevel.seq-0+200,\n                                                                    \'transform\': \'rotate(\' + docLevel.textbox.rotation.angle + \'deg)\'}"><pre class="c-xml-page-textboxe-text web-font" ng-style="{\n                                                                \'font-family\':  \'\\\'\' + docLevel.textbox.fontuuid + \'\\\'\',\n                                                                \'font-size\': (docLevel.textbox.style.size*vm.pageData[vm.pageIndex].custom.ratio > 12 ? docLevel.textbox.style.size* vm.pageData[vm.pageIndex].custom.ratio : 12) + \'pt\',\n                                                                \'color\': docLevel.textbox.style.color,\n                                                                \'font-weight\': docLevel.textbox.style.bold ? \'bold\': \'400\',\n                                                                \'font-style\': docLevel.textbox.style.italic ? \'italic\': \'initial\',\n                                                                \'line-height\': (docLevel.textbox.style.size * vm.pageData[vm.pageIndex].custom.ratio > 12 ? docLevel.textbox.style.lineheight * vm.pageData[vm.pageIndex].custom.ratio : (docLevel.textbox.style.lineheight * vm.pageData[vm.pageIndex].custom.ratio) / (1 / 12 * docLevel.textbox.style.size * vm.pageData[vm.pageIndex].custom.ratio)) + \'pt\',\n                                                                \'letter-spacing\': (docLevel.textbox.style.size * vm.pageData[vm.pageIndex].custom.ratio > 12 ? docLevel.textbox.style.letterspacing * vm.pageData[vm.pageIndex].custom.ratio : (docLevel.textbox.style.letterspacing * vm.pageData[vm.pageIndex].custom.ratio) / (1 / 12 * docLevel.textbox.style.size * vm.pageData[vm.pageIndex].custom.ratio)) + \'pt\',\n                                                                \'opacity\': docLevel.textbox.transparency,\n                                                                \'text-decoration\': \'none\',\n                                                                \'text-align\': docLevel.textbox.style.align,\n                                                                \'text-align-last\': \'unset\',\n                                                                \'transform\':\'scale(\'+(1 / 12 * docLevel.textbox.style.size* vm.pageData[vm.pageIndex].custom.ratio > 1 ? 1 : 1 / 12 * docLevel.textbox.style.size* vm.pageData[vm.pageIndex].custom.ratio)+\')\',\n                                                                \'width\': docLevel.textbox.style.size * vm.pageData[vm.pageIndex].custom.ratio > 12 ? docLevel.textbox.geometry.width * vm.pageData[vm.pageIndex].custom.ratio : (docLevel.textbox.geometry.width * vm.pageData[vm.pageIndex].custom.ratio) / (1 / 12 * docLevel.textbox.style.size * vm.pageData[vm.pageIndex].custom.ratio) + \'px\'\n                                                            }"><span class="c-xml-page-textboxe-span">{{docLevel.textbox.text}}</span></pre></div></div></div><span class="c-xml-page-material-zoom c-xml-page-material-zoom-right1" data-index="{{$index}}" ng-if="(!level.textdocument.lock && !level.textdocument.ctrlKey && vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'textdocument\')" onmousedown="resizeDocStart(event)"></span><div class="c-xml-page-material-rotate" ng-if="(!level.textdocument.lock && !level.textdocument.ctrlKey && vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'textdocument\')"><span class="c-xml-page-material-rotate-icon" ng-mousedown="textboxRotate($event,level.textdocument)"></span></div><div class="c-circle-btn" ng-click="locking($event)" style="right: -10px;top: -10px" data-index="{{$index}}" ng-show="vm.editorType != \'PICTURE_PRO\' && vm.editorType != \'PICTURE_PRO_P\' && (level.textdocument.ctrlKey || (vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'textdocument\')) && level.textdocument.lock"><i class="iconfont iconduomeitiicon- selectedbar" style="font-size: 10px"></i></div></div><div ng-if="level.calMonthBox" ng-class="{\'selected\':level.code.ctrlKey || (vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'calMonthBox\')}" ng-click="calMonthBoxClick($event, level.calMonthBox, $index)" ng-mousedown="moveWebdown($event,level.calMonthBox)" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.calMonthBox.geometry.width * vm.pageData[vm.pageIndex].custom.ratio,\n                                                    \'height\': level.calMonthBox.geometry.height * vm.pageData[vm.pageIndex].custom.ratio,\n                                                    \'left\': level.calMonthBox.geometry.x * vm.pageData[vm.pageIndex].custom.ratio,\n                                                    \'top\': level.calMonthBox.geometry.y * vm.pageData[vm.pageIndex].custom.ratio,\n                                                            \'transform\': \'rotate(\' + level.calMonthBox.rotation.angle + \'deg)\',\n                                                    \'z-index\':level.seq-0+200,\n                                                }"><month-table widget="level.calMonthBox" scale="vm.pageData[vm.pageIndex].custom.ratio" year="level.calMonthBox.sampleYear" month="level.calMonthBox.sampleMonth" week="level.calMonthBox.startOfWeek" width="level.calMonthBox.geometry.width" height="level.calMonthBox.geometry.height"></month-table><span class="c-xml-page-material-zoom c-xml-page-material-zoom-left1" ng-style="{\'cursor\': cursor(level.calMonthBox.rotation.angle, \'left\', true)}" ng-if="(!level.calMonthBox.lock && !level.calMonthBox.ctrlKey && vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'calMonthBox\')" ng-mousedown="imageartdownZoomLeft($event,level.calMonthBox)"></span> <span class="c-xml-page-material-zoom c-xml-page-material-zoom-top" ng-style="{\'cursor\': cursor(level.calMonthBox.rotation.angle, \'top\', true)}" ng-if="(!level.calMonthBox.lock && !level.calMonthBox.ctrlKey && vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'calMonthBox\')" ng-mousedown="imageartdownZoomTop($event,level.calMonthBox)"></span> <span class="c-xml-page-material-zoom c-xml-page-material-zoom-right1" ng-style="{\'cursor\': cursor(level.calMonthBox.rotation.angle, \'right\', true)}" ng-if="(!level.calMonthBox.lock && !level.calMonthBox.ctrlKey && vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'calMonthBox\')" ng-mousedown="imageartdownZoomRight($event,level.calMonthBox)"></span> <span class="c-xml-page-material-zoom c-xml-page-material-zoom-bottom" ng-style="{\'cursor\': cursor(level.calMonthBox.rotation.angle, \'bottom\', true)}" ng-if="(!level.calMonthBox.lock && !level.calMonthBox.ctrlKey && vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'calMonthBox\')" ng-mousedown="imageartdownZoomBottom($event,level.calMonthBox)"></span><!--                        <div class="c-xml-page-material-rotate"--><!--                             ng-if="(!level.calMonthBox.lock && !level.calMonthBox.ctrlKey && vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'calMonthBox\')">--><!--                                        <span class="c-xml-page-material-rotate-icon"--><!--                                              ng-mousedown="imageartdownRotate($event,level.calMonthBox)"></span>--><!--                        </div>--><div class="c-circle-btn" ng-click="locking($event)" style="right: -10px;top: -10px" data-index="{{$index}}" ng-show="vm.editorType != \'PICTURE_PRO\' && vm.editorType != \'PICTURE_PRO_P\' && (level.calMonthBox.ctrlKey || (vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'calMonthBox\')) && level.calMonthBox.lock"><i class="iconfont iconduomeitiicon- selectedbar" style="font-size: 10px"></i></div></div><div ng-if="level.calTitleBox" ng-class="{\'selected\':level.code.ctrlKey || (vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'calTitleBox\')}" ng-click="calTitleBoxClick($event, level.calTitleBox, $index)" ng-mousedown="moveWebdown($event,level.calTitleBox)" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.calTitleBox.geometry.width * vm.pageData[vm.pageIndex].custom.ratio,\n                                                    \'height\': level.calTitleBox.geometry.height * vm.pageData[vm.pageIndex].custom.ratio,\n                                                    \'left\': level.calTitleBox.geometry.x * vm.pageData[vm.pageIndex].custom.ratio,\n                                                    \'top\': level.calTitleBox.geometry.y * vm.pageData[vm.pageIndex].custom.ratio,\n                                                            \'transform\': \'rotate(\' + level.calTitleBox.rotation.angle + \'deg)\',\n                                                    \'z-index\':level.seq-0+200,\n                                                }"><div style="width: 100%; height: 100%; position: relative; overflow: hidden"><title-cell width="level.calTitleBox.geometry.width" height="level.calTitleBox.geometry.height" scale="vm.pageData[vm.pageIndex].custom.ratio" year="level.calTitleBox.sampleYear" month="level.calTitleBox.sampleMonth" widget="level.calTitleBox"></title-cell></div><span class="c-xml-page-material-zoom c-xml-page-material-zoom-left1" ng-style="{\'cursor\': cursor(level.calTitleBox.rotation.angle, \'left\', true)}" ng-if="(!level.calTitleBox.lock && !level.calTitleBox.ctrlKey && vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'calTitleBox\')" ng-mousedown="imageartdownZoomLeft($event,level.calTitleBox)"></span> <span class="c-xml-page-material-zoom c-xml-page-material-zoom-top" ng-style="{\'cursor\': cursor(level.calTitleBox.rotation.angle, \'top\', true)}" ng-if="(!level.calTitleBox.lock && !level.calTitleBox.ctrlKey && vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'calTitleBox\')" ng-mousedown="imageartdownZoomTop($event,level.calTitleBox)"></span> <span class="c-xml-page-material-zoom c-xml-page-material-zoom-right1" ng-style="{\'cursor\': cursor(level.calTitleBox.rotation.angle, \'right\', true)}" ng-if="(!level.calTitleBox.lock && !level.calTitleBox.ctrlKey && vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'calTitleBox\')" ng-mousedown="imageartdownZoomRight($event,level.calTitleBox)"></span> <span class="c-xml-page-material-zoom c-xml-page-material-zoom-bottom" ng-style="{\'cursor\': cursor(level.calTitleBox.rotation.angle, \'bottom\', true)}" ng-if="(!level.calTitleBox.lock && !level.calTitleBox.ctrlKey && vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'calTitleBox\')" ng-mousedown="imageartdownZoomBottom($event,level.calTitleBox)"></span><!--                        <div class="c-xml-page-material-rotate"--><!--                             ng-if="(!level.calTitleBox.lock && !level.calTitleBox.ctrlKey && vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'calTitleBox\')">--><!--                                        <span class="c-xml-page-material-rotate-icon"--><!--                                              ng-mousedown="imageartdownRotate($event,level.calTitleBox)"></span>--><!--                        </div>--><div class="c-circle-btn" ng-click="locking($event)" style="right: -10px;top: -10px" data-index="{{$index}}" ng-show="vm.editorType != \'PICTURE_PRO\' && vm.editorType != \'PICTURE_PRO_P\' && (level.calTitleBox.ctrlKey || (vm.elementOn.pageIndex == vm.pageIndex && vm.elementOn.index == $index &&  vm.elementOn.name == \'calTitleBox\')) && level.calTitleBox.lock"><i class="iconfont iconduomeitiicon- selectedbar" style="font-size: 10px"></i></div></div></div><div class="barcode" ng-show="vm.pageData[vm.pageIndex].barcode" ng-style="{\n                                            \'z-index\':999,\n                                            \'width\': vm.pageData[vm.pageIndex].barcode.geometry.width * vm.pageData[vm.pageIndex].custom.ratio,\n                                            \'height\': vm.pageData[vm.pageIndex].barcode.geometry.height * vm.pageData[vm.pageIndex].custom.ratio,\n                                            \'left\': vm.pageData[vm.pageIndex].barcode.geometry.x * vm.pageData[vm.pageIndex].custom.ratio,\n                                            \'top\': vm.pageData[vm.pageIndex].barcode.geometry.y * vm.pageData[vm.pageIndex].custom.ratio,\n                                            \'transform\': \'rotate(\' + vm.pageData[vm.pageIndex].barcode.rotation.angle + \'deg)\' }"><img src="content/images/txm.png" style="width: 100%;height: 100%"></div><div class="barcode" ng-show="vm.pageData[vm.pageIndex].qrcode" ng-style="{\n                                            \'z-index\':999,\n                                            \'width\': vm.pageData[vm.pageIndex].qrcode.geometry.width * vm.pageData[vm.pageIndex].custom.ratio,\n                                            \'height\': vm.pageData[vm.pageIndex].qrcode.geometry.height * vm.pageData[vm.pageIndex].custom.ratio,\n                                            \'left\': vm.pageData[vm.pageIndex].qrcode.geometry.x * vm.pageData[vm.pageIndex].custom.ratio,\n                                            \'top\': vm.pageData[vm.pageIndex].qrcode.geometry.y * vm.pageData[vm.pageIndex].custom.ratio,\n                                            \'transform\': \'rotate(\' + vm.pageData[vm.pageIndex].qrcode.rotation.angle + \'deg)\' }"><img src="content/images/QrCode.png" style="width: 100%;height: 100%"></div></div></div><object ng-attr-data="{{vm.pageData[vm.pageIndex].outline.cutline.resource.identifier}}" ng-if="vm.pageData[vm.pageIndex].outline && vm.pageData[vm.pageIndex].outline.cutline && vm.pageData[vm.pageIndex].outline.cutline.resource && vm.pageData[vm.pageIndex].outline.cutline.resource.identifier" type="image/svg+xml" style="width: 100%; height: 100%; pointer-events: none; position: absolute;left: 0; top: 0;z-index: 1" ng-style="{\n                width:transitionPx(vm.pageData[vm.pageIndex].outline.geometry.width) * vm.pageData[vm.pageIndex].custom.ratio,\n                height:transitionPx(vm.pageData[vm.pageIndex].outline.geometry.height) * vm.pageData[vm.pageIndex].custom.ratio,\n                \'left\': transitionPx(vm.pageData[vm.pageIndex].outline.geometry.x) * vm.pageData[vm.pageIndex].custom.ratio + \'px\',\n                \'top\': transitionPx(vm.pageData[vm.pageIndex].outline.geometry.y) * vm.pageData[vm.pageIndex].custom.ratio + \'px\',\n            }"></object></div></div><!--\u56FE\u7247\u6846\u88C1\u5207--><div class="editor-body1-modal" ng-if="vm.isImageboxTrim || vm.isImageartTrim || vm.isXmlDblclick || vm.editFailedFont"></div><div class="editor-body1" style="z-index: 99" ng-style="{\n        \'width\': vm.pageData[vm.pageIndex].custom.width * vm.pageData[vm.pageIndex].custom.ratio,\n        \'height\': vm.pageData[vm.pageIndex].custom.height * vm.pageData[vm.pageIndex].custom.ratio,\n    }" ng-if="vm.isImageboxTrim" data-html2canvas-ignore><div class="relative-view" ng-click="canvasCb($event)"></div><div style="position: absolute; left: 50%; top: 50%" ng-style="{\n            \'width\': vm.pageData[vm.pageIndex].custom.width * vm.pageData[vm.pageIndex].custom.ratio,\n            \'height\': vm.pageData[vm.pageIndex].custom.height * vm.pageData[vm.pageIndex].custom.ratio,\n            \'margin-top\': -(vm.pageData[vm.pageIndex].custom.height * vm.pageData[vm.pageIndex].custom.ratio)/2,\n            \'margin-left\': -(vm.pageData[vm.pageIndex].custom.width * vm.pageData[vm.pageIndex].custom.ratio)/2\n            }"><div ng-style="{\n        \'position\': \'absolute\',\n        \'width\': vm.pageData[vm.pageIndex].mediabox.width * vm.pageData[vm.pageIndex].custom.ratio,\n        \'height\': vm.pageData[vm.pageIndex].mediabox.height * vm.pageData[vm.pageIndex].custom.ratio,\n        \'left\': vm.pageData[vm.pageIndex].scene.imagebox.geometry.x * vm.pageData[vm.pageIndex].custom.ratio,\n        \'top\': vm.pageData[vm.pageIndex].scene.imagebox.geometry.y * vm.pageData[vm.pageIndex].custom.ratio\n        }"><div style="position: relative; width: 100%; height: 100%"><div style="width: 100%; height: 100%; position: absolute; left: 0; top: 0"><div style="background: #fff" ng-style="{\n                    \'position\': \'absolute\',\n                    \'width\': vm.imageboxDouble.geometry.width * vm.pageData[vm.pageIndex].custom.ratio,\n                    \'height\': vm.imageboxDouble.geometry.height * vm.pageData[vm.pageIndex].custom.ratio,\n                    \'left\': vm.imageboxDouble.geometry.x * vm.pageData[vm.pageIndex].custom.ratio,\n                    \'top\': vm.imageboxDouble.geometry.y * vm.pageData[vm.pageIndex].custom.ratio,\n                                        \'transform\': \'rotate(\' + vm.imageboxDouble.rotation.angle + \'deg)\',\n                    }"><div style="width: 100%; height: 100%;position: relative" ng-if="vm.imageboxDouble.bokehtype == \'None\'"><div style="position: absolute; background: rgba(0,0,0,0.5); z-index: 1" ng-style="{\n                                \'width\': vm.imageboxDouble.image.width*vm.pageData[vm.pageIndex].custom.ratio*vm.imageboxDouble.image.scale,\n                                \'height\': vm.imageboxDouble.image.height*vm.pageData[vm.pageIndex].custom.ratio*vm.imageboxDouble.image.scale,\n                                \'left\': vm.imageboxDouble.image.offsetx *vm.pageData[vm.pageIndex].custom.ratio*vm.imageboxDouble.image.scale,\n                                \'top\': vm.imageboxDouble.image.offsety *vm.pageData[vm.pageIndex].custom.ratio*vm.imageboxDouble.image.scale\n                            }"></div><img ng-src="{{vm.imageboxDouble.image.resource.identifier | imageFilter:vm.imageboxDouble.image.angle:isLarge(vm.imageboxDouble.image.imageInfo) }}" ng-style="{\n                                    \'transform\': vm.imageboxDouble.flip ? \'rotateY(180deg)\' : \'unset\',\n                                \'width\': vm.imageboxDouble.image.width*vm.pageData[vm.pageIndex].custom.ratio*vm.imageboxDouble.image.scale,\n                                \'height\': vm.imageboxDouble.image.height*vm.pageData[vm.pageIndex].custom.ratio*vm.imageboxDouble.image.scale,\n                                \'left\': vm.imageboxDouble.image.offsetx *vm.pageData[vm.pageIndex].custom.ratio*vm.imageboxDouble.image.scale,\n                                \'top\': vm.imageboxDouble.image.offsety *vm.pageData[vm.pageIndex].custom.ratio*vm.imageboxDouble.image.scale\n                                }" style="position: absolute" alt="\u80CC\u666F\u56FE\u7247"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="vm.imageboxDouble.bokehtype == \'Blurred\'"><img class="c-blur" ng-src="{{vm.imageboxDouble.image.resource.identifier | imageFilter:vm.imageboxDouble.image.angle:isLarge(vm.imageboxDouble.image.imageInfo)}}" ng-style="{\n                                            \'position\': \'absolute\',\n                                            \'z-index\':222,\n                                    \'transform\': vm.imageboxDouble.flip ? \'rotateY(180deg)\' : \'unset\',\n                                            \'width\': vm.imageboxDouble.image.width*vm.pageData[vm.pageIndex].custom.ratio,\n                                            \'height\': vm.imageboxDouble.image.height*vm.pageData[vm.pageIndex].custom.ratio,\n                                            \'left\': vm.imageboxDouble.image.offsetx *vm.pageData[vm.pageIndex].custom.ratio,\n                                            \'top\': vm.imageboxDouble.image.offsety *vm.pageData[vm.pageIndex].custom.ratio\n                                            }"> <img ng-src="{{vm.imageboxDouble.image.resource.identifier | imageFilter:vm.imageboxDouble.image.angle:isLarge(vm.imageboxDouble.image.imageInfo)}}" ng-style="{\n                                                \'position\': \'absolute\',\n                                    \'transform\': vm.imageboxDouble.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                \'width\': vm.imageboxDouble.blurredrectangle.width*vm.pageData[vm.pageIndex].custom.ratio,\n                                                \'height\': vm.imageboxDouble.blurredrectangle.height*vm.pageData[vm.pageIndex].custom.ratio,\n                                                \'left\':vm.imageboxDouble.blurredrectangle.x*vm.pageData[vm.pageIndex].custom.ratio,\n                                                \'top\':vm.imageboxDouble.blurredrectangle.y*vm.pageData[vm.pageIndex].custom.ratio,\n                                                \'z-index\': 222\n                                            }"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="vm.imageboxDouble.bokehtype == \'Transparent\'" ng-style="{\n                                            \'-webkit-mask-image\': vm.imageboxDouble.mask.resource.identifier ? \'url(\' + vm.imageboxDouble.mask.resource.identifier + \')\' : \'none\',\n                                            \'-webkit-mask-size\': \'100% 100%\'}"><img alt="" ng-src="{{vm.imageboxDouble.image.resource.identifier | imageFilter:vm.imageboxDouble.image.angle:isLarge(vm.imageboxDouble.image.imageInfo)}}" ng-if="vm.imageboxDouble.image.resource.identifier" ng-style="{\n                                                    \'transform\': vm.imageboxDouble.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                \'position\': \'absolute\',\n                                                \'width\': vm.imageboxDouble.blurredrectangle.width*vm.pageData[vm.pageIndex].custom.ratio*vm.imageboxDouble.image.scale,\n                                                \'height\': vm.imageboxDouble.blurredrectangle.height*vm.pageData[vm.pageIndex].custom.ratio*vm.imageboxDouble.image.scale,\n                                                \'left\':vm.imageboxDouble.blurredrectangle.x*vm.pageData[vm.pageIndex].custom.ratio*vm.imageboxDouble.image.scale,\n                                                \'top\':vm.imageboxDouble.blurredrectangle.y*vm.pageData[vm.pageIndex].custom.ratio*vm.imageboxDouble.image.scale\n                                            }"></div></div></div><div style="width: 100%; height: 100%; position: absolute; left: 0; top: 0; z-index: 10"><div class="relative-view" ng-click="canvasCb($event)"></div><div ng-style="{\n                                        \'position\': \'absolute\',\n                                        \'width\': vm.imageboxDouble.geometry.width*vm.pageData[vm.pageIndex].custom.ratio,\n                                        \'height\': vm.imageboxDouble.geometry.height*vm.pageData[vm.pageIndex].custom.ratio,\n                                        \'left\': vm.imageboxDouble.geometry.x *vm.pageData[vm.pageIndex].custom.ratio,\n                                        \'top\': vm.imageboxDouble.geometry.y*vm.pageData[vm.pageIndex].custom.ratio,\n                                        \'transform\': \'rotate(\' + vm.imageboxDouble.rotation.angle + \'deg)\',\n                                    }"><div style="width: 100%; height: 100%;position: relative;overflow: hidden" ng-mousedown="imageboxMouseDown($event)" onmousewheel="return bbimg()" ng-show="vm.imageboxDouble.bokehtype == \'None\'" ng-style="{\n                                            \'-webkit-mask-image\': vm.imageboxDouble.mask.resource.identifier ? \'url(\' + vm.imageboxDouble.mask.resource.identifier + \')\' : \'none\',\n                                            \'-webkit-mask-size\': \'100% 100%\'\n                                            }"><img ng-src="{{ vm.imageboxDouble.image.resource.identifier | imageFilter:vm.imageboxDouble.image.angle:isLarge(vm.imageboxDouble.image.imageInfo)}}" ng-style="{\n                                    \'transform\': vm.imageboxDouble.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                \'width\': vm.imageboxDouble.image.width*vm.pageData[vm.pageIndex].custom.ratio*vm.imageboxDouble.image.scale,\n                                                \'height\': vm.imageboxDouble.image.height*vm.pageData[vm.pageIndex].custom.ratio*vm.imageboxDouble.image.scale,\n                                                \'left\': vm.imageboxDouble.image.offsetx *vm.pageData[vm.pageIndex].custom.ratio*vm.imageboxDouble.image.scale,\n                                                \'top\': vm.imageboxDouble.image.offsety *vm.pageData[vm.pageIndex].custom.ratio*vm.imageboxDouble.image.scale\n                                                }" style="position: absolute" alt="\u80CC\u666F\u56FE\u7247"></div><div style="width: 100%; height: 100%;position: relative;overflow: hidden" ng-show="vm.imageboxDouble.bokehtype != \'None\'" ng-style="{\n                                            \'-webkit-mask-image\': vm.imageboxDouble.mask.resource.identifier ? \'url(\' + vm.imageboxDouble.mask.resource.identifier + \')\' : \'none\',\n                                            \'-webkit-mask-size\': \'100% 100%\'\n                                            }"><img alt="" ng-src="{{vm.imageboxDouble.image.resource.identifier | imageFilter:vm.imageboxDouble.image.angle:isLarge(vm.imageboxDouble.image.imageInfo)}}" ng-if="vm.imageboxDouble.image.resource.identifier" ng-style="{\n                                                    \'transform\': vm.imageboxDouble.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                \'position\': \'absolute\',\n                                                \'width\': vm.imageboxDouble.blurredrectangle.width*vm.pageData[vm.pageIndex].custom.ratio*vm.imageboxDouble.image.scale,\n                                                \'height\': vm.imageboxDouble.blurredrectangle.height*vm.pageData[vm.pageIndex].custom.ratio*vm.imageboxDouble.image.scale,\n                                                \'left\':vm.imageboxDouble.blurredrectangle.x*vm.pageData[vm.pageIndex].custom.ratio*vm.imageboxDouble.image.scale,\n                                                \'top\':vm.imageboxDouble.blurredrectangle.y*vm.pageData[vm.pageIndex].custom.ratio*vm.imageboxDouble.image.scale\n                                            }"></div><div style="right:-34px;width: 32px;z-index: 1" class="pos-abso" ng-style="{\n                                top:(vm.imageboxDouble.geometry.height*vm.pageData[vm.pageIndex].custom.ratio-134)/2}"><div class="cut-btn" ng-click="changeBlurred($event)" ng-show="vm.that.article.bokehtype != \'None\' || vm.editorType == \'PICTURE_PRO\' || vm.editorType == \'PICTURE_PRO_P\'"><i class="iconfont iconicon_list_zhankai" uib-tooltip="\u9002\u5E94\u56FE\u7247" tooltip-placement="right" ng-style="{\'transform\': \'rotate(\' + (360-vm.imageboxDouble.rotation.angle) + \'deg)\'}"></i></div><div class="cut-btn" ng-click="rotateImagebox($event)"><i class="iconfont iconrotation" uib-tooltip="\u65CB\u8F6C" tooltip-placement="right" ng-style="{\'transform\': \'rotate(\' + (360-vm.imageboxDouble.rotation.angle) + \'deg)\'}"></i></div><div class="cut-btn" ng-click="deleteImage($event)" ng-if="vm.editorType != \'PICTURE_PRO\' && vm.editorType != \'PICTURE_PRO_P\'"><i class="iconfont icondustbin_icon" uib-tooltip="\u5220\u9664\u56FE\u7247" tooltip-placement="right" ng-style="{\'transform\': \'rotate(\' + (360-vm.imageboxDouble.rotation.angle) + \'deg)\'}"></i></div><div class="cut-btn" ng-click="imageboxSite($event)" ng-if="vm.editorType == \'PICTURE_PRO\' || vm.editorType == \'PICTURE_PRO_P\'"><img src="content/images/icon/center-icon.png" alt="" uib-tooltip="\u5C45\u4E2D" tooltip-placement="right" ng-style="{\'transform\': \'rotate(\' + (360-vm.imageboxDouble.rotation.angle) + \'deg)\'}"></div><div class="cut-btn" ng-click="imageboxFlip($event)" ng-if="vm.editorType === \'PICTURE_PRO\' || vm.editorType === \'PICTURE_PRO_P\'"><i class="icon iconfont iconjingxiang2" uib-tooltip="\u955C\u50CF" tooltip-placement="right"></i></div><div class="cut-btn" ng-click="imageboxFalseClick($event)"><i class="iconfont iconcuo" uib-tooltip="\u9000\u51FA" tooltip-placement="right" ng-style="{\'transform\': \'rotate(\' + (360-vm.imageboxDouble.rotation.angle) + \'deg)\'}"></i></div><div class="cut-btn" ng-click="imageboxTrueClick($event)"><i class="iconfont iconduihao" uib-tooltip="\u5B8C\u6210" tooltip-placement="right" ng-style="{\'transform\': \'rotate(\' + (360-vm.imageboxDouble.rotation.angle) + \'deg)\'}"></i></div></div><div class="scale-view pos-abso" ng-show="vm.imageboxDouble.bokehtype == \'None\'"><span>{{\'editorCommon.zoom\' | translate}}</span> <input id="scaleViewRange{{vm.pageIndex}}" type="range" min="0" max="400" step="1" value="1" class="text-range-140 scale-view-range"> <span>{{vm.imageboxDouble.image.scale*100 | number:0}}%</span></div></div></div></div></div></div></div><!--\u7D20\u6750\u88C1\u5207--><div class="editor-body1" style="z-index: 99" ng-if="vm.isImageartTrim" data-html2canvas-ignore ng-style="{\n        \'width\': vm.pageData[vm.pageIndex].custom.width * vm.pageData[vm.pageIndex].custom.ratio,\n        \'height\': vm.pageData[vm.pageIndex].custom.height * vm.pageData[vm.pageIndex].custom.ratio,\n    }"><div class="relative-view" ng-click="canvasCb($event)"></div><div style="position: absolute; left: 50%; top: 50%" id="c-xml-imageart-div" ng-style="{\n        \'width\': vm.pageData[vm.pageIndex].custom.width * vm.pageData[vm.pageIndex].custom.ratio,\n        \'height\': vm.pageData[vm.pageIndex].custom.height * vm.pageData[vm.pageIndex].custom.ratio,\n        \'margin-top\': -(vm.pageData[vm.pageIndex].custom.height * vm.pageData[vm.pageIndex].custom.ratio)/2,\n        \'margin-left\': -(vm.pageData[vm.pageIndex].custom.width * vm.pageData[vm.pageIndex].custom.ratio)/2\n            }"><div style="position: relative; width: 100%; height: 100%"><div ng-style="{\n            \'position\': \'absolute\',\n            \'width\':vm.pageData[vm.pageIndex].mediabox.width * vm.pageData[vm.pageIndex].custom.ratio,\n            \'height\':vm.pageData[vm.pageIndex].mediabox.height * vm.pageData[vm.pageIndex].custom.ratio,\n            \'left\': vm.pageData[vm.pageIndex].scene.imagebox.geometry.x * vm.pageData[vm.pageIndex].custom.ratio,\n            \'top\': vm.pageData[vm.pageIndex].scene.imagebox.geometry.y * vm.pageData[vm.pageIndex].custom.ratio,\n        }"><div style="position: relative; width: 100%; height: 100%"><div class="relative-view" ng-click="canvasCb($event)"></div><div id="c-xml-imageart-trim-img" style="position: absolute" ng-style="{\n                \'width\': vm.imageartTrim.geometry.width1 * vm.pageData[vm.pageIndex].custom.ratio,\n                \'height\': vm.imageartTrim.geometry.height1 * vm.pageData[vm.pageIndex].custom.ratio,\n                \'left\': vm.imageartTrim.geometry.x1 * vm.pageData[vm.pageIndex].custom.ratio + \'px\',\n                \'top\': vm.imageartTrim.geometry.y1 * vm.pageData[vm.pageIndex].custom.ratio + \'px\'\n                }"><div style="position: relative; width: 100%; height: 100%"><div class="c-xml-imageart-trim-div" id="c-xml-imageart-trim-div" ng-style="{\n                            \'left\': vm.imageartTrim.offsetx * vm.pageData[vm.pageIndex].custom.ratio,\n                            \'top\': vm.imageartTrim.offsety * vm.pageData[vm.pageIndex].custom.ratio\n                            }"><img id="imageartTrimRight1" ng-if="!vm.imageartTrim.spotColor" ng-src="{{vm.imageartTrim.resource.identifier | imageFilter}}" ng-style="{\'width\': vm.imageartTrim.geometry.width1 * vm.pageData[vm.pageIndex].custom.ratio * vm.imageartTrim.scale + \'px\'}"><div class="gold-foil-text" id="imageartTrimRight1" ng-if="vm.imageartTrim.spotColor" style="height: fit-content" ng-style="{\n                                        \'background\': goldFoil(vm.imageartTrim.spotColor.color),\n                                        \'width\': vm.imageartTrim.geometry.width1 * vm.pageData[vm.pageIndex].custom.ratio * vm.imageartTrim.scale + \'px\',\n                                        \'-webkit-mask-image\': \'url(\' + vm.imageartTrim.resource.identifier + \')\',\n                                        \'-webkit-mask-size\': \'100% 100%\'\n                                        }"><img ng-src="{{vm.imageartTrim.resource.identifier}}?imageMogr2/thumbnail/800x800>" ng-style="{\'width\': vm.imageartTrim.geometry.width1 * vm.pageData[vm.pageIndex].custom.ratio * vm.imageartTrim.scale + \'px\', opacity:0}"></div><div style="width: 100%; height: 100%; position: absolute; background: rgba(0,0,0,0.5); top: 0; left: 0;z-index: 1"></div><!--                                <span class="c-xml-page-material-zoom c-xml-page-material-zoom-right1" style="display: block; z-index: 10;"--><!--                                      ng-mousedown="imageartTrimRight1($event,vm.imageartTrim)"></span>--></div></div></div><div id="c-xml-imageart-trim-frame" style="position: absolute; z-index: 2" ng-style="{\n                                \'width\': vm.imageartTrim.geometry.width * vm.pageData[vm.pageIndex].custom.ratio,\n                                \'height\': vm.imageartTrim.geometry.height * vm.pageData[vm.pageIndex].custom.ratio,\n                                \'left\': vm.imageartTrim.geometry.x * vm.pageData[vm.pageIndex].custom.ratio + \'px\',\n                                \'top\': vm.imageartTrim.geometry.y * vm.pageData[vm.pageIndex].custom.ratio + \'px\'\n                                }"><div style="width: 100%; height: 100%; overflow: hidden;position: absolute;border: 1px solid #e1a13c"><div style="position: absolute" id="c-xml-imageart-trim-frame-img" ng-mousedown="imageartTrimdown($event)" ng-style="{\n                        \'left\': vm.imageartTrim.geometry.x1 * vm.pageData[vm.pageIndex].custom.ratio - vm.imageartTrim.geometry.x * vm.pageData[vm.pageIndex].custom.ratio + vm.imageartTrim.offsetx * vm.pageData[vm.pageIndex].custom.ratio,\n                        \'top\': vm.imageartTrim.geometry.y1 * vm.pageData[vm.pageIndex].custom.ratio - vm.imageartTrim.geometry.y * vm.pageData[vm.pageIndex].custom.ratio + vm.imageartTrim.offsety * vm.pageData[vm.pageIndex].custom.ratio}"><img ng-src="{{vm.imageartTrim.resource.identifier | imageFilter}}" ng-if="!vm.imageartTrim.spotColor" ng-style="{\'width\': vm.imageartTrim.geometry.width1 * vm.pageData[vm.pageIndex].custom.ratio * vm.imageartTrim.scale + \'px\'}"><div class="gold-foil-text" ng-if="vm.imageartTrim.spotColor" style="height: fit-content" ng-style="{\n                                        \'background\': goldFoil(vm.imageartTrim.spotColor.color),\n                                        \'width\': vm.imageartTrim.geometry.width1 * vm.pageData[vm.pageIndex].custom.ratio * vm.imageartTrim.scale + \'px\',\n                                        \'-webkit-mask-image\': \'url(\' + vm.imageartTrim.resource.identifier + \')\',\n                                        \'-webkit-mask-size\': \'100% 100%\'\n                                        }"><img ng-src="{{vm.imageartTrim.resource.identifier}}?imageMogr2/thumbnail/800x800>" ng-style="{\'width\': vm.imageartTrim.geometry.width1 * vm.pageData[vm.pageIndex].custom.ratio * vm.imageartTrim.scale + \'px\', opacity:0}"></div></div></div><span class="c-xml-page-material-zoom c-xml-page-material-zoom-right1" style="display: block" ng-mousedown="imageartTrimRight($event,vm.imageartTrim)"></span><div class="c-xml-operation"><button type="button" ng-click="imageartTrimTrueClick()">\u221A</button> <button type="button" ng-click="imageartTrimFalseClick()">\xD7</button></div></div></div></div></div></div></div><!--\u80CC\u666F\u56FE\u88C1\u5207--><div class="editor-body1" style="z-index: 99" ng-if="vm.isXmlDblclick" data-html2canvas-ignore><div style="position: absolute; left: 50%; top: 50%" ng-style="{\n        \'width\': vm.pageData[vm.pageIndex].custom.width * vm.pageData[vm.pageIndex].custom.ratio,\n        \'height\': vm.pageData[vm.pageIndex].custom.height * vm.pageData[vm.pageIndex].custom.ratio,\n        \'margin-top\': -(vm.pageData[vm.pageIndex].custom.height * vm.pageData[vm.pageIndex].custom.ratio)/2,\n        \'margin-left\': -(vm.pageData[vm.pageIndex].custom.width * vm.pageData[vm.pageIndex].custom.ratio)/2\n    }"><div style="position: relative; width: 100%; height: 100%"><div ng-style="{\n            \'position\': \'absolute\',\n            \'width\':vm.pageData[vm.pageIndex].mediabox.width * vm.pageData[vm.pageIndex].custom.ratio,\n            \'height\':vm.pageData[vm.pageIndex].mediabox.height * vm.pageData[vm.pageIndex].custom.ratio,\n            \'left\': vm.pageData[vm.pageIndex].scene.imagebox.geometry.x * vm.pageData[vm.pageIndex].custom.ratio,\n            \'top\': vm.pageData[vm.pageIndex].scene.imagebox.geometry.y * vm.pageData[vm.pageIndex].custom.ratio,\n        }"><div style="position: relative; width: 100%; height: 100%"><div id="c-xml-bgImg-trim-img" style="width: 100%; height: 100%; position: absolute; left: 0; top: 0"><img ng-src="{{ vm.bgImg.resource.identifier | imageFilter}}" ng-style="{\n                            \'width\': vm.bgImg.resource.adaptation == \'Width\' ? vm.pageData[vm.pageIndex].mediabox.width * vm.pageData[vm.pageIndex].custom.ratio : \'auto\',\n                            \'height\': vm.bgImg.resource.adaptation == \'Height\' ? vm.pageData[vm.pageIndex].mediabox.height * vm.pageData[vm.pageIndex].custom.ratio : \'auto\',\n                            \'left\': vm.bgImg.offsetx * vm.pageData[vm.pageIndex].custom.ratio,\n                            \'top\': vm.bgImg.offsety * vm.pageData[vm.pageIndex].custom.ratio\n                            }" style="position: absolute" alt="\u80CC\u666F\u56FE\u7247"></div><div style="width: 100%; height: 100%; position: absolute; left: 0; top: 0; z-index: 10; overflow: hidden"><img ng-src="{{ vm.bgImg.resource.identifier | imageFilter}}" ng-mousedown="bgImgMouseDown($event)" ng-style="{\n                            \'width\': vm.bgImg.resource.adaptation == \'Width\' ? vm.pageData[vm.pageIndex].mediabox.width * vm.pageData[vm.pageIndex].custom.ratio : \'auto\',\n                            \'height\': vm.bgImg.resource.adaptation == \'Height\' ? vm.pageData[vm.pageIndex].mediabox.height * vm.pageData[vm.pageIndex].custom.ratio : \'auto\',\n                            \'left\': vm.bgImg.offsetx * vm.pageData[vm.pageIndex].custom.ratio,\n                            \'top\': vm.bgImg.offsety * vm.pageData[vm.pageIndex].custom.ratio\n                            }" style="position: absolute" alt="\u80CC\u666F\u56FE\u7247"></div><div class="c-xml-operation" style="z-index: 10"><button type="button" ng-click="bgImgTrueClick()">\u221A</button> <button type="button" ng-click="bgImgFalseClick()">\xD7</button></div></div></div></div></div><div style="position: fixed; left: 0; top: 0; width: 100vw; height: 100vh; background: rgba(0,0,0,0.5); z-index: 1" ng-click="canvasCb($event)"></div></div><div class="c-modal exit-box" ng-if="vm.editFailedFont" data-html2canvas-ignore><div class="exit-box-mask"></div><div class="exit-font-con"><div class="col-lg-12 col-sm-12 exit-font-con-head"><div class="exit-font-con-line1"><i></i>{{\'editorPop.editFailedFont.title\' | translate}}</div><div class="exit-font-con-line2">{{\'editorPop.editFailedFont.name1\' | translate}}<span>({{vm.failedFontArr.failed}})</span><div>{{\'editorPop.editFailedFont.name2\' | translate}}</div></div><div class="exit-font-con-button" ng-click="editFont($event)"><button>{{\'button.amend\' | translate}}</button></div></div></div></div>');
$templateCache.put('app/entities/components/page-mobile-edit.html','<div class="page-mobile-view" style="overflow: unset" ng-style="{\n        \'width\': vm.pageData[vm.pageIndex].custom.width * vm.pageData[vm.pageIndex].custom.ratio1,\n        \'height\': vm.pageData[vm.pageIndex].custom.height * vm.pageData[vm.pageIndex].custom.ratio1,\n     }"><div style="width: 100%; height: 100%; position: relative"><div style="width: 100%; height: 100%; left: 0; top: 0" ng-if="vm.pageData[vm.pageIndex].scene" ng-style="{\n                \'position\': \'absolute\',\n                \'z-index\': vm.pageData[vm.pageIndex].scene.hierarchy == \'TOP\' ? \'1\' : \'0\',\n                \'pointer-events\': \'none\'\n             }"><img ng-if="vm.pageData[vm.pageIndex].scene" ng-src="{{vm.pageData[vm.pageIndex].scene.resource.identifier | imageFilter}}" style="width: 100%"><div ng-style="{\n                            \'position\': \'absolute\',\n                            \'width\': vm.pageData[vm.pageIndex].scene.imagebox.geometry.width * vm.pageData[vm.pageIndex].custom.ratio1,\n                            \'height\': vm.pageData[vm.pageIndex].scene.imagebox.geometry.height * vm.pageData[vm.pageIndex].custom.ratio1,\n                            \'left\': vm.pageData[vm.pageIndex].scene.imagebox.geometry.x * vm.pageData[vm.pageIndex].custom.ratio1,\n                            \'top\': vm.pageData[vm.pageIndex].scene.imagebox.geometry.y * vm.pageData[vm.pageIndex].custom.ratio1,\n                            \'transform\': \'rotate(\' + vm.pageData[vm.pageIndex].scene.imagebox.rotation.angle + \'deg)\',\n                        }"></div></div><div style="transform: matrix(1, 0, 0, 1, 0, 0)" ng-style="pageStyle()"><div style="width: 100%; height: 100%; position: relative"><object ng-attr-data="{{vm.pageData[vm.pageIndex].outline.cutline.resource.identifier}}" ng-if="vm.pageData[vm.pageIndex].outline && vm.pageData[vm.pageIndex].outline.cutline && vm.pageData[vm.pageIndex].outline.cutline.resource && vm.pageData[vm.pageIndex].outline.cutline.resource.identifier" type="image/svg+xml" style="width: 100%; height: 100%; pointer-events: none; position: absolute;left: 0; top: 0;z-index: 1" ng-style="{\n                        width:transitionPx(vm.pageData[vm.pageIndex].outline.geometry.width) * vm.pageData[vm.pageIndex].custom.ratio1,\n                        height:transitionPx(vm.pageData[vm.pageIndex].outline.geometry.height) * vm.pageData[vm.pageIndex].custom.ratio1,\n                        \'left\': transitionPx(vm.pageData[vm.pageIndex].outline.geometry.x) * vm.pageData[vm.pageIndex].custom.ratio1 + \'px\',\n                        \'top\': transitionPx(vm.pageData[vm.pageIndex].outline.geometry.y) * vm.pageData[vm.pageIndex].custom.ratio1 + \'px\',\n                    }"></object><div class="border-trimbox" ng-class="{\'border-outline\' : vm.editorType === \'PICTURE_PRO_P\'}" ng-style="{\n                    \'width\':vm.pageData[vm.pageIndex].trimbox.width * vm.pageData[vm.pageIndex].custom.ratio1,\n                    \'height\':vm.pageData[vm.pageIndex].trimbox.height * vm.pageData[vm.pageIndex].custom.ratio1,\n                    \'left\':vm.pageData[vm.pageIndex].trimbox.x * vm.pageData[vm.pageIndex].custom.ratio1,\n                    \'top\':vm.pageData[vm.pageIndex].trimbox.y * vm.pageData[vm.pageIndex].custom.ratio1,\n                    }" ng-if="!vm.pageData[vm.pageIndex].outline"></div><div class="border-red" ng-if="vm.editorType != \'PICTURE_PRO_P\'" style="pointer-events: none" ng-repeat="editbox in vm.pageData[vm.pageIndex].editboxes.editbox" ng-style="{\n                                \'width\':editbox.width * vm.pageData[vm.pageIndex].custom.ratio1,\n                                \'height\':editbox.height * vm.pageData[vm.pageIndex].custom.ratio1,\n                                \'left\':editbox.x * vm.pageData[vm.pageIndex].custom.ratio1,\n                                \'top\':editbox.y * vm.pageData[vm.pageIndex].custom.ratio1,\n                            }"></div><div class="relative-view2" style="overflow: hidden" ng-if="vm.pageData[vm.pageIndex].background.type == \'Pic\'"><img ng-src="{{vm.pageData[vm.pageIndex].background.resource.identifier | imageFilter}}" alt="" ng-style="{\n                                        \'position\': \'absolute\',\n                                        \'width\': vm.pageData[vm.pageIndex].background.resource.adaptation == \'Width\' ? vm.pageData[vm.pageIndex].mediabox.width * vm.pageData[vm.pageIndex].custom.ratio1 : \'auto\',\n                                        \'height\': vm.pageData[vm.pageIndex].background.resource.adaptation == \'Height\' ? vm.pageData[vm.pageIndex].mediabox.height * vm.pageData[vm.pageIndex].custom.ratio1 : \'auto\',\n                                        \'left\': vm.pageData[vm.pageIndex].background.offsetx * vm.pageData[vm.pageIndex].custom.ratio1,\n                                        \'top\': vm.pageData[vm.pageIndex].background.offsety * vm.pageData[vm.pageIndex].custom.ratio1\n                                    }"></div><div style="position: absolute;width: 100%; height: 100%; left: 0; top: 0" ng-repeat="level in vm.pageData[vm.pageIndex].levels.level track by $index" ng-style="{\n                                        \'overflow\': $index == vm.levelIndex ? \'unset\' : \'hidden\',\n                                     }"><div ng-if="level.imagebox" data-index="{{$index}}" class="imagebox{{$index}}" ng-style="{\n                                         \'position\': opacityElement(vm.pageData[vm.pageIndex].mediabox, level.imagebox.geometry) == 1 ? \'absolute\' : \'fixed\',\n                                        width: imageboxW(level.imagebox) * vm.pageData[vm.pageIndex].custom.ratio1,\n                                        height: imageboxH(level.imagebox) * vm.pageData[vm.pageIndex].custom.ratio1,\n                                        left: imageboxL(level.imagebox) * vm.pageData[vm.pageIndex].custom.ratio1,\n                                        top: imageboxT(level.imagebox) * vm.pageData[vm.pageIndex].custom.ratio1,\n                                        \'z-index\':level.seq-0+200,\n                                        \'transform\': \'rotate(\' + level.imagebox.rotation.angle + \'deg)\',\n                                        \'opacity\': opacityElement(vm.pageData[vm.pageIndex].mediabox, level.imagebox.geometry),\n                                     }"><div ng-style="{\n                                             \'position\': \'absolute\',\n                                     \'opacity\':level.imagebox.transparency,\n                                             \'z-index\':0,\n                                            \'left\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'left\', vm.pageData[vm.pageIndex].custom.ratio1) : 0,\n                                            \'top\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'top\', vm.pageData[vm.pageIndex].custom.ratio1) : 0,\n                                            \'right\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'right\', vm.pageData[vm.pageIndex].custom.ratio1) : 0,\n                                            \'bottom\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'bottom\', vm.pageData[vm.pageIndex].custom.ratio1) : 0,\n                                            \'background-image\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'url(\' + level.imagebox.border.resource.identifier + \')\' : \'\',\n                                            \'background-size\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'100% 100%\' : \'\',\n                                            }"></div><div class="relative-view2" ng-class="{\n                                             \'pitch\' : $index == vm.levelIndex && !level.imagebox.lock && vm.levelType == \'imagebox\',\n                                             }"><div class="relative-view1 imageboxview" ng-style="{\n                                             \'overflow\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'unset\' : \'hidden\',\n                                     \'opacity\':level.imagebox.transparency,\n                                    \'border-top-left-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'lt\', vm.pageData[vm.pageIndex].custom.ratio1),\n                                    \'border-top-right-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'rt\', vm.pageData[vm.pageIndex].custom.ratio1),\n                                    \'border-bottom-right-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'rb\', vm.pageData[vm.pageIndex].custom.ratio1),\n                                    \'border-bottom-left-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'lb\', vm.pageData[vm.pageIndex].custom.ratio1),\n                                    \'border-width\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? ((level.imagebox.border.lineWidth * vm.pageData[vm.pageIndex].custom.ratio1) | number:0) : \'\',\n                                    \'border-style\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? (level.imagebox.border.lineType || \'solid\') : \'none\',\n                                    \'border-color\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? level.imagebox.border.color : \'\',\n                                                \'box-shadow\' : (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineWidth>0 && (!level.imagebox.border.lineType || level.imagebox.border.lineType == \'solid\')) ? \'0 0 0 1px \' + level.imagebox.border.color + \' inset\' : \'none\',\n                                                \'filter\' : dropShadow(level.imagebox,vm.pageData[vm.pageIndex].custom.ratio1) ,\n                                    }"><div class="relative-view1" data-index="{{$index}}" ng-style="{\n                                            \'border-top-left-radius\':imageboxWRadius1(level.imagebox, \'lt\', vm.pageData[vm.pageIndex].custom.ratio1),\n                                            \'border-top-right-radius\':imageboxWRadius1(level.imagebox, \'rt\', vm.pageData[vm.pageIndex].custom.ratio1),\n                                            \'border-bottom-right-radius\':imageboxWRadius1(level.imagebox, \'rb\', vm.pageData[vm.pageIndex].custom.ratio1),\n                                            \'border-bottom-left-radius\':imageboxWRadius1(level.imagebox, \'lb\', vm.pageData[vm.pageIndex].custom.ratio1),\n                                            \'-webkit-mask-image\': level.imagebox.mask.resource.identifier ? \'url(\' + level.imagebox.mask.resource.identifier + \')\' : \'none\',\n                                            \'-webkit-mask-size\': \'100% 100%\'\n                                            }"><!-- {{level.imagebox.bokehtype}}\n                                            {{level.imagebox.image.resource.identifier}} --><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'None\' && level.imagebox.image.resource.identifier"><!-- \u5927\u56FE\u5F02\u6B65\u5904\u7406\u4E2D - \u663E\u793A\u52A0\u8F7D\u5360\u4F4D\u56FE --> <img ng-if="level.imagebox.image.largeFlag && level.imagebox.image.largeStatus == \'running\'" src="content/images/largeLoading.jpg" alt="" data-index="{{$index}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': \'100%\',\n                                                    \'height\': \'100%\',\n                                                    \'left\': 0,\n                                                    \'top\': 0\n                                                 }"><!-- \u5927\u56FE\u5904\u7406\u5931\u8D25 - \u663E\u793A\u9519\u8BEF\u5360\u4F4D\u56FE --> <img ng-if="level.imagebox.image.largeFlag && level.imagebox.image.largeStatus == \'error\'" src="content/images/largeError.jpg" alt="" data-index="{{$index}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': \'100%\',\n                                                    \'height\': \'100%\',\n                                                    \'left\': 0,\n                                                    \'top\': 0\n                                                 }"><!-- \u5927\u56FE\u5904\u7406\u5B8C\u6210 \u6216 \u975E\u5927\u56FE - \u6B63\u5E38\u663E\u793A1 --> <img ng-if="(!level.imagebox.image.largeFlag || (level.imagebox.image.largeFlag && level.imagebox.image.largeStatus != \'running\' && level.imagebox.image.largeStatus != \'error\')) && level.imagebox.whiteInk2" ng-src="{{level.imagebox.whiteInk2.resource.identifier | imageFilter:level.imagebox.image.angle:isLarge(level.imagebox.image.imageInfo)}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.imagebox.image.width*level.imagebox.image.scale * vm.pageData[vm.pageIndex].custom.ratio1,\n                                                    \'height\': level.imagebox.image.height*level.imagebox.image.scale * vm.pageData[vm.pageIndex].custom.ratio1,\n                                                    \'left\':level.imagebox.image.offsetx*level.imagebox.image.scale * vm.pageData[vm.pageIndex].custom.ratio1,\n                                                    \'top\':level.imagebox.image.offsety*level.imagebox.image.scale * vm.pageData[vm.pageIndex].custom.ratio1,\n                                                    \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\'\n                                                }"> <img alt="" ng-if="!level.imagebox.image.largeFlag || (level.imagebox.image.largeFlag && level.imagebox.image.largeStatus != \'running\' && level.imagebox.image.largeStatus != \'error\')" ng-src="{{level.imagebox.image.resource.identifier | imageFilter:level.imagebox.image.angle:isLarge(level.imagebox.image.imageInfo)}}" data-index="{{$index}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.imagebox.image.width*level.imagebox.image.scale * vm.pageData[vm.pageIndex].custom.ratio1,\n                                                    \'height\': level.imagebox.image.height*level.imagebox.image.scale * vm.pageData[vm.pageIndex].custom.ratio1,\n                                                    \'left\':level.imagebox.image.offsetx*level.imagebox.image.scale * vm.pageData[vm.pageIndex].custom.ratio1,\n                                                    \'top\':level.imagebox.image.offsety*level.imagebox.image.scale * vm.pageData[vm.pageIndex].custom.ratio1,\n                                                    \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                    \'z-index\': 1\n                                                }"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-style="{\n                                            \'border-top-left-radius\':imageboxWRadius1(level.imagebox, \'lt\', vm.pageData[vm.pageIndex].custom.ratio1),\n                                            \'border-top-right-radius\':imageboxWRadius1(level.imagebox, \'rt\', vm.pageData[vm.pageIndex].custom.ratio1),\n                                            \'border-bottom-right-radius\':imageboxWRadius1(level.imagebox, \'rb\', vm.pageData[vm.pageIndex].custom.ratio1),\n                                            \'border-bottom-left-radius\':imageboxWRadius1(level.imagebox, \'lb\', vm.pageData[vm.pageIndex].custom.ratio1),}" ng-if="level.imagebox.bokehtype == \'Blurred\' && level.imagebox.image.resource.identifier"><img class="c-blur" alt="" ng-src="{{isLarge(level.imagebox.image.imageInfo) ? (level.imagebox.image.resource.identifier | imageFilter:level.imagebox.image.angle:true) : (level.imagebox.image.resource.identifier | imageFilter:level.imagebox.image.angle) }}" data-index="{{$index}}" ng-style="{\n                                                \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\'\n                                             }"> <img ng-src="{{isLarge(level.imagebox.image.imageInfo) ? (level.imagebox.image.resource.identifier | imageFilter:level.imagebox.image.angle:true) : (level.imagebox.image.resource.identifier | imageFilter:level.imagebox.image.angle) }}" data-index="{{$index}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.imagebox.blurredrectangle.width*level.imagebox.image.scale * vm.pageData[vm.pageIndex].custom.ratio1,\n                                                    \'height\': level.imagebox.blurredrectangle.height*level.imagebox.image.scale * vm.pageData[vm.pageIndex].custom.ratio1,\n                                                    \'left\':level.imagebox.blurredrectangle.x*level.imagebox.image.scale * vm.pageData[vm.pageIndex].custom.ratio1,\n                                                    \'top\':level.imagebox.blurredrectangle.y*level.imagebox.image.scale * vm.pageData[vm.pageIndex].custom.ratio1,\n                                                \'z-index\': 1,\n                                                    \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\'\n                                             }"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'Transparent\' && level.imagebox.image.resource.identifier"><img alt="" ng-src="{{isLarge(level.imagebox.image.imageInfo) ? (level.imagebox.image.resource.identifier | imageFilter:level.imagebox.image.angle:true) : (level.imagebox.image.resource.identifier | imageFilter:level.imagebox.image.angle) }}" data-index="{{$index}}" ng-style="{\n                                                \'position\': \'absolute\',\n                                                \'width\': level.imagebox.blurredrectangle.width*level.imagebox.image.scale * vm.pageData[vm.pageIndex].custom.ratio1,\n                                                \'height\': level.imagebox.blurredrectangle.height*level.imagebox.image.scale * vm.pageData[vm.pageIndex].custom.ratio1,\n                                                \'left\':level.imagebox.blurredrectangle.x*level.imagebox.image.scale * vm.pageData[vm.pageIndex].custom.ratio1,\n                                                \'top\':level.imagebox.blurredrectangle.y*level.imagebox.image.scale * vm.pageData[vm.pageIndex].custom.ratio1,\n                                                \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\'\n                                             }"></div><div class="no-events notImagebox" ng-if="!level.imagebox.image.resource.identifier" data-index="{{$index}}"><img src="content/images/icons/addcamera.svg" data-index="{{$index}}"></div><div class="no-events" ng-class="{\n                                         \'c-imagebox-warn1\' : (level.imagebox.geometry.width * vm.pageData[vm.pageIndex].custom.ratio1 < 120),\n                                         \'c-imagebox-warn\':(level.imagebox.geometry.width * vm.pageData[vm.pageIndex].custom.ratio1 >= 120)}" data-index="{{$index}}" ng-if="level.imagebox && level.imagebox.image && level.imagebox.image.resource && level.imagebox.image.resource.identifier && pxInsufficient(level.imagebox)"><i class="icon iconfont iconwaring imageboxWarn"></i> <span>{{\'editorCommon.lackPixels2\' | translate}}</span></div><div class="no-events imageboxHint" ng-if="vm.isSmallPic" translate="editorCommon.lackPixels3"></div></div></div><div class="c-circle-btn1" style="width: 20px; height: 20px; line-height: 20px; left: -10px;top: -10px" data-index="{{$index}}" ng-click="imageboxDelete($event, $index)" ng-show="$index == vm.levelIndex && !level.imagebox.lock && vm.levelType == \'imagebox\'"><i class="iconfont iconcuo" style="font-size: 10px"></i></div><!--                                        <span class="c-circle-btn1" style="right: -8px;top: -8px;" data-index="{{$index}}" data-site="rightTop"--><!--                                              ontouchstart="imageboxStartStart(event)"--><!--                                              ontouchmove="imageboxStartOn(event)"--><!--                                              ontouchend="imageboxStartEnd(event)"--><!--                                              ng-style="{\'transform\':\'scale(\'+(1/vm.pageData[vm.pageIndex].custom.ratio1)+\')\'}"--><!--                                              ng-show="$index == vm.levelIndex && level.imagebox.lock && vm.levelType == \'imagebox\'"></span>--><!--                                        <span class="c-circle-btn1" style="right: -8px;bottom: -8px;" data-index="{{$index}}" data-site="rightBottom"--><!--                                              ontouchstart="imageboxStartStart(event)"--><!--                                              ontouchmove="imageboxStartOn(event)"--><!--                                              ontouchend="imageboxStartEnd(event)"--><!--                                              ng-style="{\'transform\':\'scale(\'+(1/vm.pageData[vm.pageIndex].custom.ratio1)+\')\'}"--><!--                                              ng-show="$index == vm.levelIndex && level.imagebox.lock && vm.levelType == \'imagebox\'"></span>--> <span class="c-circle-btn1 c-circle-btn1-4" style="left: -8px;bottom: -8px" data-index="{{$index}}" data-site="leftBottom" ontouchstart="imageboxStartStart(event)" ontouchmove="imageboxStartOn(event)" ontouchend="imageboxStartEnd(event)" ng-show="$index == vm.levelIndex && !level.imagebox.lock && vm.levelType == \'imagebox\'"></span> <span class="c-circle-btn2 c-circle-btn2-left" style="left: -5px" data-index="{{$index}}" data-site="left" ontouchstart="imageboxStartStart(event)" ontouchmove="imageboxStartOn(event)" ontouchend="imageboxStartEnd(event)" ng-show="$index == vm.levelIndex && !level.imagebox.lock && vm.levelType == \'imagebox\' && (level.imagebox.geometry.height*vm.pageData[vm.pageIndex].custom.ratio1 > 60)"></span> <span class="c-circle-btn3 c-circle-btn3-top" style="top: -4px" data-index="{{$index}}" data-site="top" ontouchstart="imageboxStartStart(event)" ontouchmove="imageboxStartOn(event)" ontouchend="imageboxStartEnd(event)" ng-show="$index == vm.levelIndex && !level.imagebox.lock && vm.levelType == \'imagebox\' && (level.imagebox.geometry.width*vm.pageData[vm.pageIndex].custom.ratio1 > 60)"></span> <span class="c-circle-btn2 c-circle-btn2-right" style="right: -4px" data-index="{{$index}}" data-site="right" ontouchstart="imageboxStartStart(event)" ontouchmove="imageboxStartOn(event)" ontouchend="imageboxStartEnd(event)" ng-show="$index == vm.levelIndex && !level.imagebox.lock && vm.levelType == \'imagebox\' && (level.imagebox.geometry.height*vm.pageData[vm.pageIndex].custom.ratio1 > 60)"></span> <span class="c-circle-btn3 c-circle-btn3-bottom" style="bottom: -4px" data-index="{{$index}}" data-site="bottom" ontouchstart="imageboxStartStart(event)" ontouchmove="imageboxStartOn(event)" ontouchend="imageboxStartEnd(event)" ng-show="$index == vm.levelIndex && !level.imagebox.lock && vm.levelType == \'imagebox\' && (level.imagebox.geometry.width*vm.pageData[vm.pageIndex].custom.ratio1 > 60)"></span><div class="c-circle-btn1 c-circle-btn1-3" style="width: 20px; height: 20px; line-height: 20px; right: -10px;bottom: -10px" data-index="{{$index}}" ontouchstart="imageboxScaleStart(event)" ontouchmove="imageboxScaleOn(event)" ontouchend="imageboxScaleEnd(event)" ng-show="$index == vm.levelIndex && !level.imagebox.lock && vm.levelType == \'imagebox\'"><i class="iconfont iconxuanzhuan1" style="font-size: 10px"></i></div><div class="c-circle-btn1 c-circle-btn1-2" style="width: 20px; height: 20px; line-height: 20px; right: -10px;top: -10px" data-index="{{$index}}" ng-click="imageboxLock($event, true, level.imagebox)" ng-show="$index == vm.levelIndex && !level.imagebox.lock && vm.levelType == \'imagebox\' && vm.isImageboxLock"><i class="iconfont iconjiesuo" style="font-size: 10px"></i></div><div class="c-circle-btn1 c-circle-btn1-2" style="width: 20px; height: 20px; line-height: 20px; right: -10px;top: -10px" data-index="{{$index}}" ng-click="imageboxLock($event, false, level.imagebox)" ng-show="$index == vm.levelIndex && level.imagebox.lock && vm.levelType == \'imagebox\' && vm.isImageboxLock"><i class="iconfont iconsuoding" style="font-size: 10px"></i></div><!--                                        <div class="c-imagebox-btn-view" ng-show="$index == vm.levelIndex && level.imagebox.lock && vm.levelType == \'imagebox\'"--><!--                                             style="bottom: -35px"--><!--                                             ng-style="{\'transform\':\'scale(\'+(1/vm.pageData[vm.pageIndex].custom.ratio1)+\')\'}">--><!--                                            <div data-index="{{$index}}"--><!--                                                 ng-show="$index == vm.levelIndex && level.imagebox.lock && vm.levelType == \'imagebox\'"--><!--                                                 class="c-circle-btn4 imageboxview">--><!--                                                <i class="iconfont icontuozhuai" data-index="{{$index}}"></i>--><!--                                            </div>--><!--                                        </div>--></div></div><div class="imageartview" ng-if="level.imageart" ng-show="vm.editorType != \'PHOTO_EDITOR\'" data-index="{{$index}}" ng-click="imageartSelect($event, $index, level.imageart)" ng-class="{\n                                         \'pitch\' : $index == vm.levelIndex && level.imageart.useradded && vm.levelType == \'imageart\',\n                                         \'no-events\': !level.imageart.useradded\n                                         }" ng-style="{\n                                         \'position\': opacityElement(vm.pageData[vm.pageIndex].mediabox, level.imageart.geometry) == 1 ? \'absolute\' : \'fixed\',\n                                        \'opacity\': opacityElement(vm.pageData[vm.pageIndex].mediabox, level.imageart.geometry),\n                                        \'width\': level.imageart.geometry.width * vm.pageData[vm.pageIndex].custom.ratio1,\n                                        \'height\': level.imageart.geometry.height * vm.pageData[vm.pageIndex].custom.ratio1,\n                                        \'left\': level.imageart.geometry.x * vm.pageData[vm.pageIndex].custom.ratio1,\n                                        \'top\': level.imageart.geometry.y * vm.pageData[vm.pageIndex].custom.ratio1,\n                                                \'transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                        \'z-index\':level.seq-0+200,\n                                     }"><div style="overflow: hidden;position: relative;width: 100%;height: 100%"><div class="gold-foil-text" data-index="{{$index}}" ng-style="{\n                                    \'background\': goldFoil(level.imageart.spotColor.color),\n                                    \'position\': \'absolute\',\n                                    \'width\': level.imageart.geometry.width * level.imageart.scale * vm.pageData[vm.pageIndex].custom.ratio1,\n                                    \'height\': level.imageart.geometry.height * level.imageart.scale * vm.pageData[vm.pageIndex].custom.ratio1,\n                                    \'left\': level.imageart.offsetx * vm.pageData[vm.pageIndex].custom.ratio1,\n                                    \'top\': level.imageart.offsety * vm.pageData[vm.pageIndex].custom.ratio1,\n                                    \'opacity\': level.imageart.transparency,\n                                    \'transform\': level.imageart.flip ? \'rotateY(180deg)\' : \'unset\',\n                                    \'-webkit-mask-image\': \'url(\' + level.imageart.resource.identifier + \')\',\n                                    \'-webkit-mask-size\': \'100% 100%\'\n                                    }"><img class="imageart" ng-src="{{level.imageart.resource.identifier | imageFilter}}" alt="" ng-style="{\n                                    \'position\': \'absolute\',\n                                    \'width\': level.imageart.geometry.width * level.imageart.scale * vm.pageData[vm.pageIndex].custom.ratio1,\n                                    \'left\': level.imageart.offsetx * vm.pageData[vm.pageIndex].custom.ratio1,\n                                    \'top\': level.imageart.offsety * vm.pageData[vm.pageIndex].custom.ratio1,\n                                    \'opacity\': level.imageart.spotColor ? 0 : level.imageart.transparency,\n                                    \'transform\': level.imageart.flip ? \'rotateY(180deg)\' : \'unset\',\n                                    }" data-index="{{$index}}"></div></div><div ng-click="deleteImageart($event, $index)" class="c-circle-btn1" style="width: 20px; height: 20px; line-height: 20px; right: -10px; top: -10px" ng-show="$index == vm.levelIndex && level.imageart.useradded && vm.levelType == \'imageart\'"><i class="icon iconfont iconcuo" style="font-size: 10px"></i></div><div ng-click="overturnImageart($event,level.imageart)" class="c-circle-btn1" style="width: 20px; height: 20px; line-height: 20px; left: -10px;top: -10px" ng-show="$index == vm.levelIndex && level.imageart.useradded && vm.levelType == \'imageart\' && !level.imageart.serviceType"><i class="icon iconfont iconjingxiang2" style="font-size: 10px"></i></div><div ng-click="copyImageart($event,level)" class="c-circle-btn1" style="width: 20px; height: 20px; line-height: 20px; left: -8px; bottom: -8px" ng-show="$index == vm.levelIndex && level.imageart.useradded && vm.levelType == \'imageart\'"><i class="icon iconfont iconfuzhi11" style="font-size: 10px"></i></div><div class="c-circle-btn1 c-circle-btn1-3" style="width: 20px; height: 20px; line-height: 20px; right: -10px;bottom: -10px" data-index="{{$index}}" ontouchstart="resizeStickerStart(event)" ontouchmove="resizeStickerOn(event)" ontouchend="resizeStickerEnd(event)" ng-show="$index == vm.levelIndex && level.imageart.useradded && vm.levelType == \'imageart\'"><i class="iconfont iconxuanzhuan1" style="font-size: 10px"></i></div></div><div data-index="{{$index}}" ng-if="level.textbox" ng-class="{\'pitch1\': $index == vm.levelIndex && vm.levelType == \'textbox\',\n                                         \'no-border\':!level.textbox.editable&&!level.textbox.movable&&!level.textbox.useradded}" ng-style="{\n                                         \'position\': opacityElement(vm.pageData[vm.pageIndex].mediabox, level.textbox.geometry) == 1 ? \'absolute\' : \'fixed\',\n                                        \'opacity\': opacityElement(vm.pageData[vm.pageIndex].mediabox, level.textbox.geometry),\n                                        \'width\': level.textbox.geometry.width * vm.pageData[vm.pageIndex].custom.ratio1 + \'px\',\n                                        \'height\': level.textbox.geometry.height * vm.pageData[vm.pageIndex].custom.ratio1 + \'px\',\n                                        \'left\': level.textbox.geometry.x * vm.pageData[vm.pageIndex].custom.ratio1,\n                                        \'top\': level.textbox.geometry.y * vm.pageData[vm.pageIndex].custom.ratio1,\n                                        \'-webkit-transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                        \'z-index\': level.seq-0+200,\n                                     }"><pre class="c-xml-page-textboxe-text web-font" data-index="{{$index}}" ontouchstart="moveTextBoxStart(event)" ontouchmove="moveTextBoxOn(event)" ontouchend="moveTextBoxEnd(event)" ng-style="{\n                                            \'font-family\': \'\\\'\' + level.textbox.fontuuid + \'\\\'\',\n                                            \'font-size\': (level.textbox.style.size*vm.pageData[vm.pageIndex].custom.ratio1 > 12 ? level.textbox.style.size* vm.pageData[vm.pageIndex].custom.ratio1 : 12) + \'pt\',\n                                            \'color\': level.textbox.style.color,\n                                            \'font-weight\': level.textbox.style.bold ? \'bold\': \'400\',\n                                            \'font-style\': level.textbox.style.italic ? \'italic\': \'initial\',\n                                            \'line-height\': (level.textbox.style.size * vm.pageData[vm.pageIndex].custom.ratio1 > 12 ? level.textbox.style.lineheight * vm.pageData[vm.pageIndex].custom.ratio1 : (level.textbox.style.lineheight * vm.pageData[vm.pageIndex].custom.ratio1) / (1 / 12 * level.textbox.style.size * vm.pageData[vm.pageIndex].custom.ratio1)) + \'pt\',\n                                            \'letter-spacing\': (level.textbox.style.size * vm.pageData[vm.pageIndex].custom.ratio1 > 12 ? level.textbox.style.letterspacing * vm.pageData[vm.pageIndex].custom.ratio1 : (level.textbox.style.letterspacing * vm.pageData[vm.pageIndex].custom.ratio1) / (1 / 12 * level.textbox.style.size * vm.pageData[vm.pageIndex].custom.ratio1)) + \'pt\',\n                                            \'opacity\': level.textbox.transparency,\n                                            \'text-decoration\': \'none\',\n                                            \'text-align\': level.textbox.style.align,\n                                            \'text-align-last\': \'unset\',\n                                            \'transform\':\'scale(\'+(1 / 12 * level.textbox.style.size* vm.pageData[vm.pageIndex].custom.ratio1 > 1 ? 1 : 1 / 12 * level.textbox.style.size* vm.pageData[vm.pageIndex].custom.ratio1)+\')\',\n                                            \'transform-origin\': \'0 0\',\n                                            \'width\': level.textbox.style.size * vm.pageData[vm.pageIndex].custom.ratio1 > 12 ? level.textbox.geometry.width * vm.pageData[vm.pageIndex].custom.ratio1 : (level.textbox.geometry.width * vm.pageData[vm.pageIndex].custom.ratio1) / (1 / 12 * level.textbox.style.size * vm.pageData[vm.pageIndex].custom.ratio1) + \'px\',\n                                            \'height\': level.textbox.style.size * vm.pageData[vm.pageIndex].custom.ratio1 > 12 ? level.textbox.geometry.height * vm.pageData[vm.pageIndex].custom.ratio1 : (level.textbox.geometry.height * vm.pageData[vm.pageIndex].custom.ratio1) / (1 / 12 * level.textbox.style.size * vm.pageData[vm.pageIndex].custom.ratio1) + \'px\',\n                                            \'writing-mode\': level.textbox.style.writingmode\n                                            }"><span class="c-xml-page-textboxe-span">{{level.textbox.text}}</span></pre><div class="c-circle-btn2 c-circle-btn2-left" ng-if="$index == vm.levelIndex && level.textbox.editable && vm.levelType == \'textbox\' && level.textbox.style.size>30 && !writingmodeInit(level.textbox.style.writingmode)" data-index="{{$index}}" style="left: -5px" ontouchstart="textboxZoomLeftStatr(event)" ontouchmove="textboxZoomLeft(event)" ontouchend="textboxZoomEnd(event)"></div><span class="c-circle-btn2 c-circle-btn2-right" ng-if="$index == vm.levelIndex && level.textbox.editable && vm.levelType == \'textbox\' && level.textbox.style.size>30 && !writingmodeInit(level.textbox.style.writingmode)" style="right: -4px" data-index="{{$index}}" ontouchstart="textboxZoomRightStatr(event)" ontouchmove="textboxZoomRight(event)" ontouchend="textboxZoomEnd(event)"></span> <span class="c-circle-btn3 c-circle-btn3-top" ng-if="$index == vm.levelIndex && level.textbox.editable && vm.levelType == \'textbox\' && level.textbox.style.size>30 && writingmodeInit(level.textbox.style.writingmode)" style="top: -4px" data-index="{{$index}}" ontouchstart="textboxZoomRightStatr(event)" ontouchmove="textboxZoomTop(event)" ontouchend="textboxZoomEnd(event)"></span><div class="c-circle-btn1 c-circle-btn1-3" ng-if="$index == vm.levelIndex && level.textbox.editable && vm.levelType == \'textbox\'" data-index="{{$index}}" style="width: 20px; height: 20px; line-height: 20px; right: -10px; bottom: -10px" ontouchstart="textboxZoomOnStart(event)" ontouchmove="textboxZoomRight1(event)" ontouchend="textboxZoomEnd(event)"><i class="iconfont iconxuanzhuan1" style="font-size: 10px"></i></div><!--                                        <span data-index="{{$index}}"--><!--                                              ng-style="{--><!--                                              \'bottom\': (-25/vm.pageData[vm.pageIndex].custom.ratio1-1)--><!--                                              }"--><!--                                              ng-show="$index == vm.levelIndex && level.textbox.editable && vm.levelType == \'textbox\'"--><!--                                              style="width: 20px; height: 20px; line-height: 20px;left: 50%;bottom: -30px; margin-left: -8px;"--><!--                                              class="three-icon1 vertical_line"--><!--                                              ontouchstart="textboxStart(event)"--><!--                                              ontouchmove="textboxStickerOn(event)"--><!--                                              ontouchend="textboxStickerEnd(event)">--><!--                                            <i class="iconfont iconxuanzhuan1" style="font-size: 10px;"></i>--><!--                                        </span>--></div><div data-index="{{$index}}" ng-if="level.textdocument" ng-style="{\n                                         \'position\': opacityElement(vm.pageData[vm.pageIndex].mediabox, level.textdocument.geometry) == 1 ? \'absolute\' : \'fixed\',\n                                        \'opacity\': opacityElement(vm.pageData[vm.pageIndex].mediabox, level.textdocument.geometry),\n                                            width: level.textdocument.geometry.width * vm.pageData[vm.pageIndex].custom.ratio1,\n                                            height: level.textdocument.geometry.height * vm.pageData[vm.pageIndex].custom.ratio1,\n                                            left: level.textdocument.geometry.x * vm.pageData[vm.pageIndex].custom.ratio1,\n                                            top: level.textdocument.geometry.y * vm.pageData[vm.pageIndex].custom.ratio1,\n                                            \'z-index\':level.seq-0+200,\n                                            filter: \'alpha(opacity=\'+level.textdocument.transparency*100+\')\',\n                                            \'transform\': \'rotate(\' + level.textdocument.rotation.angle + \'deg)\'}"><div style="overflow: hidden;width: 100%;height: 100%;position: relative" class="no-events" ng-style="{\n                                            \'opacity\':level.textdocument.transparency.toFixed(2)\n                                            }"><img class="bg-image bg-image{{template.pageI}} pos" ng-cloak ng-if="level.textdocument.background.resource.identifier" ng-src="{{level.textdocument.background.resource.identifier | imageFilter}}" ng-style="{\n                                                     position: \'absolute\',\n                                                     left:level.textdocument.background.offsetx * vm.pageData[vm.pageIndex].custom.ratio1,\n                                                     top:level.textdocument.background.offsety * vm.pageData[vm.pageIndex].custom.ratio1,\n                                                     width: level.textdocument.background.adaptation==\'Width\'?level.textdocument.geometry.width * vm.pageData[vm.pageIndex].custom.ratio1:\'\',\n                                                     height:level.textdocument.background.adaptation!=\'Width\'?level.textdocument.geometry.height * vm.pageData[vm.pageIndex].custom.ratio1:\'\'}"><div ng-repeat="docLevel in level.textdocument.levels.level track by $index" ng-init="docIndex = $index" style="position: relative"><div data-index="{{docIndex}}" class="img-art" ng-if="docLevel.imageart" ng-style="{\n                                                        width: docLevel.imageart.geometry.width * vm.pageData[vm.pageIndex].custom.ratio1,\n                                                        height: docLevel.imageart.geometry.height * vm.pageData[vm.pageIndex].custom.ratio1,\n                                                        left: docLevel.imageart.geometry.x * vm.pageData[vm.pageIndex].custom.ratio1,\n                                                        top: docLevel.imageart.geometry.y * vm.pageData[vm.pageIndex].custom.ratio1,\n                                                        \'z-index\':docLevel.seq-0+200,\n                                                        \'opacity\':docLevel.imageart.transparency,\n                                                        filter: \'alpha(opacity=\'+docLevel.imageart.transparency*100+\')\',\n                                                        \'transform\': \'rotate(\' + docLevel.imageart.rotation.angle + \'deg)\'}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                                \'left\': docLevel.imageart.offsetx * vm.pageData[vm.pageIndex].custom.ratio1,\n                                                                \'top\': docLevel.imageart.offsety * vm.pageData[vm.pageIndex].custom.ratio1,\n                                                                \'width\': docLevel.imageart.geometry.width * vm.pageData[vm.pageIndex].custom.ratio1}" ng-src="{{docLevel.imageart.resource.identifier | imageFilter}}"></div></div><div class="c-xml-page-textboxe" ng-show="docLevel.textbox" style="white-space: normal" data-index="{{docIndex}}" ng-style="{\n                                                        \'width\': docLevel.textbox.geometry.width * vm.pageData[vm.pageIndex].custom.ratio1,\n                                                        \'height\': docLevel.textbox.geometry.height * vm.pageData[vm.pageIndex].custom.ratio1,\n                                                        \'line-height\': docLevel.textbox.geometry.height * vm.pageData[vm.pageIndex].custom.ratio1 + \'px\',\n                                                        \'left\': docLevel.textbox.geometry.x * vm.pageData[vm.pageIndex].custom.ratio1,\n                                                        \'top\': docLevel.textbox.geometry.y * vm.pageData[vm.pageIndex].custom.ratio1,\n                                                        \'z-index\':docLevel.seq-0+200,\n                                                        \'transform\': \'rotate(\' + docLevel.textbox.rotation.angle + \'deg)\'}"><pre class="c-xml-page-textboxe-text web-font" ng-style="{\n                                                                \'font-family\':  \'\\\'\' + docLevel.textbox.fontuuid + \'\\\'\',\n                                                                \'font-size\': (docLevel.textbox.style.size*vm.pageData[vm.pageIndex].custom.ratio1 > 12 ? docLevel.textbox.style.size* vm.pageData[vm.pageIndex].custom.ratio1 : 12) + \'pt\',\n                                                                \'color\': docLevel.textbox.style.color,\n                                                                \'font-weight\': docLevel.textbox.style.bold ? \'bold\': \'400\',\n                                                                \'font-style\': docLevel.textbox.style.italic ? \'italic\': \'initial\',\n                                                                \'line-height\': (docLevel.textbox.style.size * vm.pageData[vm.pageIndex].custom.ratio1 > 12 ? docLevel.textbox.style.lineheight * vm.pageData[vm.pageIndex].custom.ratio1 : (docLevel.textbox.style.lineheight * vm.pageData[vm.pageIndex].custom.ratio1) / (1 / 12 * docLevel.textbox.style.size * vm.pageData[vm.pageIndex].custom.ratio1)) + \'pt\',\n                                                                \'letter-spacing\': (docLevel.textbox.style.size * vm.pageData[vm.pageIndex].custom.ratio1 > 12 ? docLevel.textbox.style.letterspacing * vm.pageData[vm.pageIndex].custom.ratio1 : (docLevel.textbox.style.letterspacing * vm.pageData[vm.pageIndex].custom.ratio1) / (1 / 12 * docLevel.textbox.style.size * vm.pageData[vm.pageIndex].custom.ratio1)) + \'pt\',\n                                                                \'opacity\': docLevel.textbox.transparency,\n                                                                \'text-decoration\': \'none\',\n                                                                \'text-align\': docLevel.textbox.style.align,\n                                                                \'text-align-last\': \'unset\',\n                                                                \'transform\':\'scale(\'+(1 / 12 * docLevel.textbox.style.size* vm.pageData[vm.pageIndex].custom.ratio1 > 1 ? 1 : 1 / 12 * docLevel.textbox.style.size* vm.pageData[vm.pageIndex].custom.ratio1)+\')\',\n                                                                \'width\': docLevel.textbox.style.size * vm.pageData[vm.pageIndex].custom.ratio1 > 12 ? docLevel.textbox.geometry.width * vm.pageData[vm.pageIndex].custom.ratio1 : (docLevel.textbox.geometry.width * vm.pageData[vm.pageIndex].custom.ratio1) / (1 / 12 * docLevel.textbox.style.size * vm.pageData[vm.pageIndex].custom.ratio1) + \'px\',\n                                                                \'height\': docLevel.textbox.style.size * vm.pageData[vm.pageIndex].custom.ratio1 > 12 ? docLevel.textbox.geometry.height * vm.pageData[vm.pageIndex].custom.ratio1 : (docLevel.textbox.geometry.height * vm.pageData[vm.pageIndex].custom.ratio1) / (1 / 12 * docLevel.textbox.style.size * vm.pageData[vm.pageIndex].custom.ratio1) + \'px\',\n                                                            }"><span class="c-xml-page-textboxe-span">{{docLevel.textbox.text}}</span></pre></div></div></div></div><div ng-if="level.calMonthBox" class="no-events" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.calMonthBox.geometry.width * vm.pageData[vm.pageIndex].custom.ratio1,\n                                                    \'height\': level.calMonthBox.geometry.height * vm.pageData[vm.pageIndex].custom.ratio1,\n                                                    \'left\': level.calMonthBox.geometry.x * vm.pageData[vm.pageIndex].custom.ratio1,\n                                                    \'top\': level.calMonthBox.geometry.y * vm.pageData[vm.pageIndex].custom.ratio1,\n                                                            \'transform\': \'rotate(\' + level.calMonthBox.rotation.angle + \'deg)\',\n                                                    \'z-index\':level.seq-0+200,\n                                                }"><month-table widget="level.calMonthBox" scale="vm.pageData[vm.pageIndex].custom.ratio1" year="level.calMonthBox.sampleYear" month="level.calMonthBox.sampleMonth" week="level.calMonthBox.startOfWeek" width="level.calMonthBox.geometry.width" height="level.calMonthBox.geometry.height" update="level.calMonthBox.update"></month-table></div><div ng-if="level.calTitleBox" class="no-events" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.calTitleBox.geometry.width * vm.pageData[vm.pageIndex].custom.ratio1,\n                                                    \'height\': level.calTitleBox.geometry.height * vm.pageData[vm.pageIndex].custom.ratio1,\n                                                    \'left\': level.calTitleBox.geometry.x * vm.pageData[vm.pageIndex].custom.ratio1,\n                                                    \'top\': level.calTitleBox.geometry.y * vm.pageData[vm.pageIndex].custom.ratio1,\n                                                            \'transform\': \'rotate(\' + level.calTitleBox.rotation.angle + \'deg)\',\n                                                    \'z-index\':level.seq-0+200,\n                                                }"><div style="width: 100%; height: 100%; position: relative; overflow: hidden"><title-cell width="level.calTitleBox.geometry.width" height="level.calTitleBox.geometry.height" scale="vm.pageData[vm.pageIndex].custom.ratio1" year="level.calTitleBox.sampleYear" month="level.calTitleBox.sampleMonth" widget="level.calTitleBox"></title-cell></div></div></div><div class="barcode" ng-show="vm.pageData[vm.pageIndex].barcode" ng-style="{\n                                            \'z-index\':1200,\n                                         \'width\': vm.pageData[vm.pageIndex].barcode.geometry.width * vm.pageData[vm.pageIndex].custom.ratio1,\n                                         \'height\': vm.pageData[vm.pageIndex].barcode.geometry.height * vm.pageData[vm.pageIndex].custom.ratio1,\n                                         \'left\': vm.pageData[vm.pageIndex].barcode.geometry.x * vm.pageData[vm.pageIndex].custom.ratio1,\n                                         \'top\': vm.pageData[vm.pageIndex].barcode.geometry.y * vm.pageData[vm.pageIndex].custom.ratio1,\n                                         \'transform\': \'rotate(\' + vm.pageData[vm.pageIndex].barcode.rotation.angle + \'deg)\' }"><img src="content/images/txm.png" style="width: 100%;height: 100%"></div><div class="barcode" ng-show="vm.pageData[vm.pageIndex].qrcode" ng-style="{\n                                            \'z-index\':1200,\n                                         \'width\': vm.pageData[vm.pageIndex].qrcode.geometry.width * vm.pageData[vm.pageIndex].custom.ratio1,\n                                         \'height\': vm.pageData[vm.pageIndex].qrcode.geometry.height * vm.pageData[vm.pageIndex].custom.ratio1,\n                                         \'left\': vm.pageData[vm.pageIndex].qrcode.geometry.x * vm.pageData[vm.pageIndex].custom.ratio1,\n                                         \'top\': vm.pageData[vm.pageIndex].qrcode.geometry.y * vm.pageData[vm.pageIndex].custom.ratio1,\n                                         \'transform\': \'rotate(\' + vm.pageData[vm.pageIndex].qrcode.rotation.angle + \'deg)\' }"><img src="content/images/QrCode.png" style="width: 100%;height: 100%"></div></div></div><!--\u56FE\u7247\u6846\u88C1\u5207--><div class="imageboxview" style="position: absolute; left: 0; top: 0; z-index: 999" ng-show="vm.isImageboxTrim"><div ng-style="{\n            \'position\': \'absolute\',\n            \'width\': !vm.pageData[vm.pageIndex].scene ? \'100%\' : vm.pageData[vm.pageIndex].mediabox.width * vm.pageData[vm.pageIndex].custom.ratio1,\n            \'height\': !vm.pageData[vm.pageIndex].scene ? \'100%\' : vm.pageData[vm.pageIndex].mediabox.height * vm.pageData[vm.pageIndex].custom.ratio1,\n            \'left\': !vm.pageData[vm.pageIndex].scene ? \'0\' : vm.pageData[vm.pageIndex].scene.imagebox.geometry.x * vm.pageData[vm.pageIndex].custom.ratio1,\n            \'top\': !vm.pageData[vm.pageIndex].scene ? \'0\' : vm.pageData[vm.pageIndex].scene.imagebox.geometry.y * vm.pageData[vm.pageIndex].custom.ratio1,\n            }"><div style="width: 100%; height: 100%; position: absolute; left: 0; top: 0"><div ng-style="{\n                        \'position\': \'absolute\',\n                        \'width\': vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.geometry.width * vm.pageData[vm.pageIndex].custom.ratio1,\n                        \'height\': vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.geometry.height * vm.pageData[vm.pageIndex].custom.ratio1,\n                        \'left\': vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.geometry.x * vm.pageData[vm.pageIndex].custom.ratio1,\n                        \'top\': vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.geometry.y * vm.pageData[vm.pageIndex].custom.ratio1,\n                        \'transform\': \'rotate(\' + vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.rotation.angle + \'deg)\'\n                        }"><div style="width: 100%; height: 100%;position: relative" ng-if="vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.bokehtype == \'None\'"><div style="position: absolute; background: rgba(0,0,0,0.5); z-index: 1" ng-style="{\n                                    \'width\': vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.width*vm.pageData[vm.pageIndex].custom.ratio1*vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.scale,\n                                    \'height\': vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.height*vm.pageData[vm.pageIndex].custom.ratio1*vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.scale,\n                                    \'left\': vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.offsetx *vm.pageData[vm.pageIndex].custom.ratio1*vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.scale,\n                                    \'top\': vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.offsety *vm.pageData[vm.pageIndex].custom.ratio1*vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.scale\n                                }"></div><img ng-src="{{vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.resource.identifier | imageFilter:vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.angle:isLarge(vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.imageInfo)}}" ng-style="{\n                                         \'transform\': vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                        \'width\': vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.width*vm.pageData[vm.pageIndex].custom.ratio1*vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.scale,\n                                        \'height\': vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.height*vm.pageData[vm.pageIndex].custom.ratio1*vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.scale,\n                                        \'left\': vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.offsetx *vm.pageData[vm.pageIndex].custom.ratio1*vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.scale,\n                                        \'top\': vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.offsety *vm.pageData[vm.pageIndex].custom.ratio1*vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.scale\n                                     }" style="position: absolute" alt="\u80CC\u666F\u56FE\u7247"></div></div></div><div style="width: 100%; height: 100%; position: absolute; left: 0; top: 0; z-index: 10"><div ng-style="{\n                                \'position\': \'absolute\',\n                                \'width\': vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.geometry.width*vm.pageData[vm.pageIndex].custom.ratio1,\n                                \'height\': vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.geometry.height*vm.pageData[vm.pageIndex].custom.ratio1,\n                                \'left\': vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.geometry.x *vm.pageData[vm.pageIndex].custom.ratio1,\n                                \'top\': vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.geometry.y*vm.pageData[vm.pageIndex].custom.ratio1,\n                                \'transform\': \'rotate(\' + vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.rotation.angle + \'deg)\'\n                            }"><div style="width: 100%; height: 100%;position: relative;overflow: hidden" ng-style="{\n                                    \'-webkit-mask-image\': vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.mask.resource.identifier ? \'url(\' + vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.mask.resource.identifier + \')\' : \'none\',\n                                    \'-webkit-mask-size\': \'100% 100%\'\n                                    }"><img ng-if="vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.resource.identifier" ng-src="{{vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.resource.identifier | imageFilter:vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.angle:isLarge(vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.imageInfo)}}" ng-style="{\n                                        \'transform\': vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                        \'width\': vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.width*vm.pageData[vm.pageIndex].custom.ratio1*vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.scale,\n                                        \'height\': vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.height*vm.pageData[vm.pageIndex].custom.ratio1*vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.scale,\n                                        \'left\': vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.offsetx *vm.pageData[vm.pageIndex].custom.ratio1*vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.scale,\n                                        \'top\': vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.offsety *vm.pageData[vm.pageIndex].custom.ratio1*vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.scale\n                                     }" style="position: absolute" alt="\u80CC\u666F\u56FE\u7247"></div></div></div><div style="width: 100%; height: 100%; position: absolute; left: 0; top: 0; z-index: 10" ng-repeat="level in vm.pageData[vm.pageIndex].levels.level track by $index"><div class="imageartview" ng-if="level.imageart" ng-show="(level.imageart.onlyshow && vm.editorType == \'PHOTO_EDITOR\')" ng-class="{\n                                         \'pitch\' : $index == vm.levelIndex && level.imageart.useradded && vm.levelType == \'imageart\',\n                                         \'no-events\': !level.imageart.useradded\n                                         }" ng-style="{\n                                         \'position\': opacityElement(vm.pageData[vm.pageIndex].mediabox, level.imageart.geometry) == 1 ? \'absolute\' : \'fixed\',\n                                        \'opacity\': opacityElement(vm.pageData[vm.pageIndex].mediabox, level.imageart.geometry),\n                                        \'width\': level.imageart.geometry.width * vm.pageData[vm.pageIndex].custom.ratio1,\n                                        \'height\': level.imageart.geometry.height * vm.pageData[vm.pageIndex].custom.ratio1,\n                                        \'left\': level.imageart.geometry.x * vm.pageData[vm.pageIndex].custom.ratio1,\n                                        \'top\': level.imageart.geometry.y * vm.pageData[vm.pageIndex].custom.ratio1,\n                                                \'transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                        \'z-index\':level.seq-0+200,\n                                     }"><div style="overflow: hidden;position: relative;width: 100%;height: 100%"><img class="imageart" ng-src="{{level.imageart.resource.identifier | imageFilter}}" alt="" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.imageart.geometry.width * level.imageart.scale * vm.pageData[vm.pageIndex].custom.ratio1,\n                                                    \'left\': level.imageart.offsetx * vm.pageData[vm.pageIndex].custom.ratio1,\n                                                    \'top\': level.imageart.offsety * vm.pageData[vm.pageIndex].custom.ratio1,\n                                                    \'opacity\': level.imageart.transparency,\n                                                    \'transform\': level.imageart.flip ? \'rotateY(180deg)\' : \'unset\'\n                                                 }"></div></div></div></div></div></div></div><div class="move-tip1" ng-if="vm.hint" data-html2canvas-ignore><i class="iconfont iconjinggao"></i> <span>{{"hint.pageHint" | translate}}</span></div>');
$templateCache.put('app/entities/components/page-photo.html','<div class="three-modal" style="z-index: 999"><div class="editor-dialog" style="width: 100%; height: 100%; display: flex;padding: 0; box-shadow: 0 0 10px 6px rgba(255,255,255,0.2);z-index: 9"><div class="editor-dialog-title-right" style="top: 10px; right: 10px"><i class="iconfont iconcuo dialog-close" ng-click="editorDialogHide()"></i></div><div class="page-photo-view"><div class="page-photo-view1 hover-scrollbar"><div class="page-photo-view1-item" ng-class="{\'page-photo-view1-item-select\' : vm.menuIndex == \'picture\'}" ng-click="menuCb(\'picture\')"><i class="icon iconfont iconzhaopian"></i><div class="page-photo-view1-item-text">{{\'nav.photograph.title\' | translate}}</div><div class="page-photo-view1-item-hr"></div></div><div class="page-photo-view1-item" ng-class="{\'page-photo-view1-item-select\' : vm.menuIndex == \'material\'}" ng-click="menuCb(\'material\')"><i class="icon iconfont iconxiangkuang2"></i><div class="page-photo-view1-item-text">{{\'nav.mask.title\' | translate}}</div><div class="page-photo-view1-item-hr"></div></div><div class="page-photo-view1-item" ng-class="{\'page-photo-view1-item-select\' : vm.menuIndex == \'BORDER\'}" ng-click="menuCb(\'BORDER\')" ng-if="vm.borderLabels && vm.borderLabels.length>0"><i class="icon iconfont iconbiankuang1"></i><div class="page-photo-view1-item-text">{{\'nav.border.title\' | translate}}</div><div class="page-photo-view1-item-hr"></div></div><div class="page-photo-view1-item" ng-class="{\'page-photo-view1-item-select\' : vm.menuIndex == \'FONT\'}" ng-click="menuCb(\'FONT\')"><i class="icon iconfont iconwenben"></i><div class="page-photo-view1-item-text">{{\'nav.text.title\' | translate}}</div><div class="page-photo-view1-item-hr"></div></div><div class="page-photo-view1-item" ng-class="{\'page-photo-view1-item-select\' : vm.menuIndex == \'ClipArt\'}" ng-click="menuCb(\'ClipArt\')"><i class="icon iconfont iconsucai"></i><div class="page-photo-view1-item-text">{{\'nav.material.title\' | translate}}</div><div class="page-photo-view1-item-hr"></div></div><div class="page-photo-view1-item" ng-class="{\'page-photo-view1-item-select\' : vm.menuIndex == \'RECOMMENDPIC\'}" ng-click="menuCb(\'RECOMMENDPIC\')"><i class="icon iconfont iconzhaopian"></i><div class="page-photo-view1-item-text">{{\'nav.recommend1.title\' | translate}}</div><div class="page-photo-view1-item-hr"></div></div><div class="page-photo-view1-item" ng-class="{\'page-photo-view1-item-select\' : vm.menuIndex == \'backupPages\'}" ng-click="menuCb(\'backupPages\')" ng-if="vm.template.backupPages && vm.template.backupPages.list.length>0"><i class="icon iconfont iconbanshi"></i><div class="page-photo-view1-item-text">{{\'nav.reserve.title\' | translate}}</div><div class="page-photo-view1-item-hr"></div></div><div class="page-photo-view1-item" ng-class="{\'page-photo-view1-item-select\' : vm.menuIndex == \'Background\'}" ng-click="menuCb(\'Background\')"><i class="icon iconfont iconbanshi"></i><div class="page-photo-view1-item-text">{{\'nav.background.title\' | translate}}</div><div class="page-photo-view1-item-hr"></div></div><div class="page-photo-view1-item" ng-class="{\'page-photo-view1-item-select\' : vm.menuIndex == \'TECHNIQUE\'}" ng-click="menuCb(\'TECHNIQUE\')" ng-if="vm.propertyValue.hotStamp.length && (vm.product.pictureType == \'single\' || (vm.product.pictureType == \'spread\' && ((vm.product.reverseProcess && vm.pageIndex % 2 == 1) || vm.pageIndex % 2 == 0)))"><i class="icon iconfont iconzise"></i><div class="page-photo-view1-item-text">{{"pagePhoto.technique" | translate}}</div><div class="page-photo-view1-item-hr"></div></div><div class="page-photo-view1-item" ng-class="{\'page-photo-view1-item-select\' : vm.menuIndex == \'white\'}" ng-click="menuCb(\'white\')" ng-if="vm.propertyValue.white.length && (vm.product.pictureType == \'single\' || (vm.product.pictureType == \'spread\' && ((vm.product.reverseProcess && vm.pageIndex % 2 == 1) || vm.pageIndex % 2 == 0)))"><i class="icon iconfont iconbaipi"></i><div class="page-photo-view1-item-text">{{"pagePhoto.whiteInk" | translate}}</div><div class="page-photo-view1-item-hr"></div></div><div class="page-photo-view1-item" ng-click="setOutline()" ng-if="vm.isOutlineBtn"><i class="icon iconfont icondaoxian"></i><div class="page-photo-view1-item-text">{{"pagePhoto.outline" | translate}}</div><div class="page-photo-view1-item-hr"></div></div><div class="page-photo-view1-item" ng-class="{\'page-photo-view1-item-select\' : vm.menuIndex == \'uv\'}" ng-click="menuCb(\'uv\')" ng-if="vm.propertyValue.uv.length && (vm.product.pictureType == \'single\' || (vm.product.pictureType == \'spread\' && ((vm.product.reverseProcess && vm.pageIndex % 2 == 1) || vm.pageIndex % 2 == 0)))"><i class="icon iconfont iconuv"></i><div class="page-photo-view1-item-text">UV</div><div class="page-photo-view1-item-hr"></div></div><div class="page-photo-view1-item" ng-class="{\'page-photo-view1-item-select\' : vm.menuIndex == \'fluore\'}" ng-click="menuCb(\'fluore\')" ng-if="vm.propertyValue.fluore.length && (vm.product.pictureType == \'single\' || (vm.product.pictureType == \'spread\' && ((vm.product.reverseProcess && vm.pageIndex % 2 == 1) || vm.pageIndex % 2 == 0)))"><i class="icon iconfont iconyingguang"></i><div class="page-photo-view1-item-text">{{"pagePhoto.fluorescence" | translate}}</div><div class="page-photo-view1-item-hr"></div></div><div class="page-photo-view1-item" ng-class="{\'page-photo-view1-item-select\' : vm.menuIndex == 3}" ng-click="menuCb(3)"><i class="icon iconfont icontuceng"></i><div class="page-photo-view1-item-text">{{\'editorBtn.coverage\' | translate}}</div></div></div><div class="page-photo-view2 hover-scrollbar"><div class="page-photo-view2-item" ng-if="vm.menuIndex == \'picture\'"><picture pages="vm.pages" article="vm.article" product="vm.product" on-add="addPhoto(photos)"></picture></div><div class="page-photo-view2-item" ng-if="vm.menuIndex == \'material\'"><material-list></material-list></div><div class="page-photo-view2-item" ng-if="vm.menuIndex == \'BORDER\'"><div class="leftPanel-head" style="padding:0"><div class="leftPanel-privacy"><button ng-repeat="label in vm.borderLabels track by $index" ng-click="bordersCb(label,$index)" data-index="{{$index}}" class="leftPanel-privacy-btn" ng-class="{\'leftPanel-privacy-btn-active\':label.id==vm.borderId.id}" ng-show="$index<8||vm.borderUnfold">{{label.name}}</button></div><div class="leftPanel-privacy-btn-more" ng-if="vm.borderLabels.length >8"><div ng-if="!vm.borderUnfold" ng-click="vm.borderUnfold = true"><span>{{\'editorBtn.unfold\' | translate}}</span><i class="iconfont iconzhankaigengduo11 font-12"></i></div><div ng-if="vm.borderUnfold" ng-click="vm.borderUnfold = false"><span>{{\'editorBtn.foldUp\' | translate}}</span><i class="iconfont iconyouceshouqi11 font-12"></i></div></div></div><div class="nav-mask" style="margin: 20px 0"><img src="content/images/icons/loading01.gif" class="nav-mask-loading" ng-show="vm.borderLoading"><ul ng-hide="vm.borderLoading"><li ng-repeat="item in vm.borderList track by $index" data-index="{{$index}}"><div class="nav-mask-div" style="line-height: 100px; text-align: center"><img ng-src="{{item.img | imageFilter}}" draggable="true" ondragstart="dragStart(event)" ondragend="dragOn(event)" id="dragtargetFrameConfig{{$index}}" data-item="{{item.img}}" data-index="{{$index}}" style="max-width: 100%; max-height: 100%"></div></li></ul><button class="load-more" style="bottom:10px" ng-if="vm.borderFulfill" ng-click="loadMoreBorder()">{{\'editorBtn.loadMore\' | translate}}</button><div class="default-diagram" ng-show="vm.borderList.length == 0 && !vm.borderLoading"><img src="content/images/default-diagram.png"><div>{{\'hint.noData\' | translate}}</div></div><div class="text-center" ng-if="!vm.borderFulfill && vm.borderList.length>0&& !vm.borderLoading"><span class="tip-text">{{\'hint.noMore\' | translate}}</span></div></div></div><div class="page-photo-view2-item" ng-if="vm.menuIndex == 0"><div class="editor-dialog-footer-center" style="width: 100%; align-items: self-start; justify-content: space-between"><div class="editor-dialog-footer-center-btn" ng-class="{\'editor-dialog-btn-disabled\':!vm.pages[vm.pageIndex].levels.level[vm.levelIndex] || !vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox}" ng-click="rotateImagebox($event)"><img src="content/images/icon/rotate-icon.png" alt=""> <span>{{\'editorBtn.rotate\' | translate}}</span></div><div class="editor-dialog-footer-center-btn" ng-class="{\'editor-dialog-btn-disabled\':!vm.pages[vm.pageIndex].levels.level[vm.levelIndex] || !vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox || vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox.bokehtype != \'None\'}" ng-click="imageboxSite(\'center\')"><img src="content/images/icon/center-icon.png" alt=""> <span>{{\'editorBtn.center\' | translate}}</span></div><div class="editor-dialog-footer-center-btn" ng-class="{\'editor-dialog-btn-disabled\':!vm.pages[vm.pageIndex].levels.level[vm.levelIndex] || !vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox}" ng-click="cutImagebox($event)" ng-if="vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox.bokehtype != \'None\'"><img src="content/images/icon/unfold-icon.png" alt=""> <span>{{\'editorBtn.unfold\' | translate}}</span></div><div class="editor-dialog-footer-center-btn" ng-class="{\'editor-dialog-btn-disabled\':!vm.pages[vm.pageIndex].levels.level[vm.levelIndex] || !vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox}" ng-click="fillImagebox($event)" ng-if="vm.pages[vm.pageIndex].levels.level[vm.levelIndex].imagebox.bokehtype == \'None\'"><img src="content/images/icon/reduce-icon.png" alt=""> <span>{{\'editorBtn.lessen\' | translate}}</span></div></div></div><div class="page-photo-view2-item" ng-if="vm.menuIndex == \'FONT\'"><div class="leftPanel-head text-size-center" style="padding-bottom:20px"><div class="text-size-24" ng-click="addText(24)" role="button" tabindex="0">{{\'editorCommon.addTextbox\' | translate}}</div><div class="text-size-20" ng-click="addText(20)" role="button" tabindex="0">{{\'editorCommon.addTextbox1\' | translate}}</div><div class="text-size-16" ng-click="addText(16)" role="button" tabindex="0">{{\'editorCommon.addTextbox2\' | translate}}</div></div></div><div class="page-photo-view2-item" ng-if="vm.menuIndex == \'ClipArt\' || vm.menuIndex == \'TECHNIQUE\'"><div ng-if="vm.menuIndex == \'TECHNIQUE\'" ng-repeat="item in vm.propertyValue.hotStamp track by $index"><div class="update-gold-view"><i class="iconfont iconshangchuanzhaopian1"></i> <span>{{"pagePhoto.localUpload" | translate}}</span> <input onchange="updateGold(event, this.getAttribute(\'data-index\'))" data-index="{{$index}}" type="file" accept="image/png"></div><div style="color: #999; margin-bottom: 20px;display: flex;justify-content: space-between"><span><i class="iconfont iconxiangqing"></i>{{"pagePhoto.pngOnly" | translate}}</span> <span>{{item.operationValueAlias}}</span></div></div><!-- <div style="font-weight: 600;font-size: 16px;color: #333333; margin-bottom: 16px;" ng-if="vm.menuIndex == \'TECHNIQUE\'">{{"pagePhoto.techniqueMaterial" | translate}}</div> --><div class="leftPanel-head" style="padding:0" ng-if="vm.menuIndex == \'ClipArt\'"><div class="leftPanel-privacy"><button ng-repeat="label in vm.clipArts track by $index" ng-click="vm.clipArtCb(label,$index)" data-index="{{$index}}" class="leftPanel-privacy-btn" ng-class="{\'leftPanel-privacy-btn-active\':label.id==vm.clipArtChooseId.id}" ng-show="$index<8||isClip">{{label.name}}</button></div><div class="leftPanel-privacy-btn-more" ng-if="vm.clipArts.length >8"><div ng-if="!isClip" ng-click="clipMoreCb(true)"><span>{{\'button.spread\' | translate}}</span><i class="iconfont iconzhankaigengduo11 font-12"></i></div><div ng-if="isClip" ng-click="clipMoreCb(false)"><span>{{\'button.packUp\' | translate}}</span><i class="iconfont iconyouceshouqi11 font-12"></i></div></div></div><div class="nav-mask" ng-if="vm.menuIndex == \'ClipArt\'"><img src="content/images/icons/loading01.gif" class="nav-mask-loading" ng-show="vm.clipArtLoading"><ul id="main2" ng-hide="vm.clipArtLoading" style="padding: 0; margin-bottom: 8px"><li ng-repeat="item in vm.clipArtsList track by $index" data-index="{{$index}}" ng-click="materialCb(item)" style="padding: 3px"><div class="nav-mask-div" style="display: flex; align-items: center; justify-content: center"><img ng-src="{{item.identifier}}?imageMogr2/thumbnail/200x200>" data-art="{{item.identifier}}" draggable="true" ondragstart="dragStart(event)" ondragend="dragOn(event)" id="dragtargetClipArt{{$index}}" data-index="{{$index}}"></div></li></ul><button class="load-more" style="bottom:10px; width: 100%;position: unset" ng-if="vm.clipArtFulfill" ng-click="loadMoreClipArt()">{{\'button.loadMore\' | translate}}</button><div class="default-diagram" ng-show="vm.clipArtsList.length == 0 && !vm.clipArtLoading"><img src="content/images/default-diagram.png"><div>{{\'hint.noData\' | translate}}</div></div><div class="text-center" ng-if="!vm.clipArtFulfill && vm.clipArtsList.length > 0 && !vm.clipArtLoading" style="width: 100%; position: unset"><span class="tip-text">{{\'hint.noMore\' | translate}}</span></div></div></div><div class="page-photo-view2-item" ng-if="vm.menuIndex == \'RECOMMENDPIC\'"><div class="leftPanel-head" style="padding:0"><div class="leftPanel-privacy"><button ng-repeat="item in vm.recommendClassify track by $index" ng-click="vm.recommendClassifyItem = item" class="leftPanel-privacy-btn" ng-class="{\'leftPanel-privacy-btn-active\':item.id==vm.recommendClassifyItem.id}">{{item.name}}</button></div></div><div class="nav-mask" style="margin-top: 20px"><ul style="padding: 0; margin-bottom: 8px"><li ng-repeat="item in vm.recommendPics track by $index" data-index="{{$index}}" ng-click="recommendPicsCb(item)" style="padding: 3px; height: 90px" ng-show="!vm.recommendClassifyItem || vm.recommendClassifyItem.id == item.themeClassifyId"><div class="nav-mask-div" style="display: flex; align-items: center; justify-content: center"><img ng-src="{{item.identifier}}?imageMogr2/thumbnail/200x200>" draggable="true" ondragstart="dragStart(event)" ondragend="dragOn(event)" id="dragtargetRecommendPic{{$index}}" data-index="{{$index}}" data-item="{{item}}" style="max-width: 100%; max-height: 100%"></div></li></ul></div></div><div class="page-photo-view2-item" ng-show="vm.menuIndex == 3"><div class="c-editor-page"><div class="c-editor-page-view" ng-show="vm.pages[vm.pageIndex] && vm.pages[vm.pageIndex].levels && vm.pages[vm.pageIndex].levels.level && vm.isEditorPageElementBody" id="pageList1"><div class="c-editor-page-view-li" id="c-editor-page-view-li{{$index}}" ng-repeat="level in vm.pages[vm.pageIndex].levels.level | reverse"><div class="c-editor-page-view-li-view sortingPageView" style="position: relative" data-page="{{level}}" ng-click="dragCompleteClick($event,level,$index)"><div class="c-editor-page-view-li-view-img" ng-class="{\'nav-active\' : (vm.elementOn.index == vm.completeIndex($index))}"><img ng-if="level.imagebox && level.imagebox.image && level.imagebox.image.resource && level.imagebox.image.resource.identifier" ng-src="{{level.imagebox.image.resource.identifier + \'?imageMogr2/auto-orient/thumbnail/800x800>\'}}"> <img ng-if="level.imageart && level.imageart.resource && level.imageart.resource.identifier && !level.imageart.spotColor" ng-src="{{level.imageart.resource.identifier + \'?imageMogr2/auto-orient/thumbnail/800x800>\'}}"><div class="gold-foil-text" ng-if="level.imageart && level.imageart.resource && level.imageart.resource.identifier && level.imageart.spotColor" ng-style="{\n                                                \'height\': level.imageart.imageInfo.width/level.imageart.imageInfo.height < 280/96 ? \'-webkit-fill-available\' : \'auto\',\n                                                \'width\': level.imageart.imageInfo.width/level.imageart.imageInfo.height > 280/96 ? \'-webkit-fill-available\' : \'auto\',\n                                                \'background\': goldFoil(level.imageart.spotColor.color),\n                                                \'-webkit-mask-image\': \'url(\' + level.imageart.resource.identifier + \')\',\n                                                \'-webkit-mask-size\': \'100% 100%\'\n                                                }"><img ng-src="{{ level.imageart.resource.identifier ? level.imageart.resource.identifier+\'?imageMogr2/auto-orient/thumbnail/800x800>\' : \'\'}}" ng-style="{\'opacity\' : 0}"></div><i class="iconfont iconziti" ng-if="level.textbox || level.textdocument"></i> <i class="iconfont iconerweima" ng-if="level.code"></i> <i class="iconfont iconzhaopian_huabanfuben" ng-if="level.imagebox && (!level.imagebox.image || !level.imagebox.image.resource || !level.imagebox.image.resource.identifier)"></i> <i class="iconfont icontishi c-editor-page-view-li-view-iconWarn" ng-if="level.textbox && level.textbox.success === false" style="top: 17px;\n                                        right: 9px;\n                                        left: inherit;\n                                        font-size: 26px;\n                                        color: var(--webMainButtonBackColor)"></i></div><div class="c-editor-page-view-li-view-font" style="color: #fff"><div class="c-editor-page-view-li-view-font-sh" ng-click="levelHidden($event, level)"><i class="iconfont iconyanjing font-12" ng-if="!level.isHidden"></i> <i class="iconfont iconyanjing1 font-12" ng-if="level.isHidden"></i> <span class="c-editor-page-view-li-view-font-sh-span" uib-tooltip="{{levelInfo(level, $index)}}" tooltip-placement="bottom-left">{{levelInfo(level, $index)}}</span></div><i class="iconfont icondustbin_icon font-12" ng-click="levelDelete($index)" ng-if="!level.imagebox"></i></div></div></div></div></div></div><div class="page-photo-view2-item" ng-show="vm.menuIndex == \'backupPages\'"><div class="c-editor-page"><div class="c-editor-page-view" ng-if="vm.template.backupPages && vm.template.backupPages.list"><div class="c-editor-page-view-li" ng-repeat="backupPage in vm.template.backupPages.list"><div class="c-editor-page-view-li-view-img" style="cursor: pointer; position: relative" ng-if="backupPage.config.partid === vm.pages[vm.pageIndex].config.partid" ng-click="layoutCb(backupPage)"><img ng-src="{{backupPage.pagecover.identifier}}"></div></div></div></div></div><div class="page-photo-view2-item" ng-if="vm.menuIndex == \'Background\'"><background-list on-color="backgroundColor(text)" on-image="backgroundImage(text)"></background-list></div><div class="page-photo-view2-item" ng-show="vm.menuIndex == \'white\'"><div class="c-chalk-view" ng-if="vm.pages[vm.pageIndex] && vm.pages[vm.pageIndex].levels && vm.pages[vm.pageIndex].levels.level"><div class="c-chalk-view-li" ng-repeat="level in vm.pages[vm.pageIndex].levels.level" ng-if="level.imagebox"><div class="c-chalk-view-li-view"><div class="c-chalk-view-li-view-img custom-grid2"><!-- <img ng-if="level.imagebox.image && level.imagebox.image.resource && level.imagebox.image.resource.identifier" ng-src="{{level.imagebox.image.resource.identifier + \'?imageMogr2/thumbnail/800x800>\'}}"> --><div ng-style="{\n                                            position: \'relative\',\n                                            width: chalkSize(level.imagebox,\'width\'),\n                                            height: chalkSize(level.imagebox,\'height\')}"><img ng-src="{{level.imagebox.image.resource.identifier+\'?imageMogr2/thumbnail/800x800>\'}}" style="width: 100%; height: 100%"></div></div><i class="iconfont iconlianjie"></i><div class="c-chalk-view-li-view-img custom-grid2"><div ng-if="level.imagebox.whiteInk2" ng-style="{\n                                            position: \'relative\',\n                                            width: chalkSize(level.imagebox,\'width\'),\n                                            height: chalkSize(level.imagebox,\'height\')}"><img ng-src="{{level.imagebox.image.resource.identifier+\'?imageMogr2/thumbnail/800x800>\'}}" style="width: 100%; height: 100%;opacity: 0.2"><div class="chalk-view-1-3-1" ng-style="{\n                                            \'-webkit-mask-image\': level.imagebox.whiteInk2 ? \'url(\' + level.imagebox.whiteInk2.resource.identifier + \')\' : \'none\',\n                                            \'-webkit-mask-size\': \'100% 100%\'}"><img ng-src="{{level.imagebox.image.resource.identifier+\'?imageMogr2/thumbnail/800x800>\'}}" style="width: 100%; height: 100%;opacity: 0.2"></div></div></div></div><div class="c-chalk-view-li-bottom"><div class="c-chalk-view-li-btn c-chalk-view-li-btn-1" ng-click="editProcessImages(level.imagebox)"><i class="iconfont iconbianji2"></i><div>{{"pagePhoto.edit" | translate}}</div></div><div class="c-chalk-view-li-btn" ng-click="level.imagebox.whiteInk2 = null" ng-if="level.imagebox.whiteInk2"><i class="iconfont iconqingchu"></i><div>{{"pagePhoto.clear" | translate}}</div></div><div class="c-chalk-view-li-btn" ng-click="setProcessImages(level.imagebox)" ng-if="!level.imagebox.whiteInk2"><i class="iconfont iconnormal"></i><div>{{"pagePhoto.autoGenerate" | translate}}</div></div></div></div></div></div><div class="page-photo-view2-item" ng-show="vm.menuIndex == \'uv\' || vm.menuIndex == \'fluore\'"><div class="c-chalk-view"><div class="c-chalk-view-li" ng-repeat="item in vm.propertyValue[vm.menuIndex] track by $index"><div class="c-chalk-view-li-view custom-grid2" style="height: 300px; justify-content: center"><div class="gold-foil-text" ng-if="getImageart(vm.pages[vm.pageIndex], vm.menuIndex, item)" ng-style="{\n                                    \'width\': getImageartSize(\'width\',item),\n                                    \'height\': getImageartSize(\'height\',item),\n                                    \'background\': goldFoil(getImageart(vm.pages[vm.pageIndex], vm.menuIndex, item).spotColor.color),\n                                    \'-webkit-mask-image\': \'url(\' + getImageart(vm.pages[vm.pageIndex], vm.menuIndex, item).resource.identifier + \')\',\n                                    \'-webkit-mask-size\': \'100% 100%\'\n                                    }"><img ng-src="{{getImageart(vm.singleData[vm.singleIndex]).resource.identifier | imageFilter}}" style="width: 100%; height: 100%;opacity:0"></div><div class="c-chalk-view-li-view-not" ng-if="!getImageart(vm.pages[vm.pageIndex], vm.menuIndex, item)">{{"pagePhoto.noFile" | translate }}{{item.operationValueAlias}}</div></div><div class="c-chalk-view-li-bottom"><div class="c-chalk-view-li-btn c-chalk-view-li-btn-1" ng-click="editProcessImages(null,item)"><i class="iconfont iconbianji2"></i><div>{{"pagePhoto.edit" | translate}}</div></div><div class="c-chalk-view-li-btn" ng-click="deleteProcessImages(item)" ng-if="getImageart(vm.pages[vm.pageIndex], vm.menuIndex, item)"><i class="iconfont iconqingchu"></i><div>{{"pagePhoto.clear" | translate}}</div></div></div></div></div></div></div><div class="page-photo-view3"><div class="page-photo-view3-1" style="display: flex; justify-content: space-between; align-items: center"><div class="editor-nav2-ul2" style="display: flex;align-items: center"><ul class="clearfix c-xml-action-icon-font" ng-if="vm.hasImgBtn"><li class="pad-0"><button class="nav-operation tool-bar-btn tool-bar-btn-select" ng-click="doubleClickImagebox($event,$index, vm.elementOn.item)">{{"pagePhoto.crop" | translate}}</button></li><li class="pad-0"><button class="nav-operation tool-bar-btn tool-bar-btn-select" ng-click="exchange()">{{"pagePhoto.exchange" | translate}}</button></li><li class="pad-0" ng-if="!isLarge(vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.image.imageInfo)"><button class="nav-operation tool-bar-btn tool-bar-btn-select" ng-click="mattingOpen()" style="min-width: 37px;width: auto;padding: 0 5px">{{vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].imagebox.image.mattingMask ? ("pagePhoto.editMatting" | translate) : ("pagePhoto.aiMatting" | translate)}}</button></li></ul><div ng-show="vm.elementOn.name == \'textbox\' && !vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox.lock"><ul class="clearfix c-xml-action-icon-font"><li><div class="c-xml-action-div-icon c-xml-action-div-icon-color" ng-click="operationColorOpen($event)" ng-style="{background: vm.elementOn.item.style.color}" style="border: 1px solid #ddd"><div class="tip3" style="top:50px">{{\'editorBtn.color\' | translate}}</div></div><div class="c-xml-action-div-color-modal clearfix" style="z-index: 999;top:48px;left: -2px" ng-if="vm.isOperationColor"><input class="c-xml-action-div-color-modal-btn" type="color" ng-change="chooseTextColor()" ng-model="vm.textColor"> <span ng-repeat="item in vm.colorList track by $index" ng-style="{ \'background\' : item.id}" ng-class="{\'c-xml-action-div-color-on\' : item.id == vm.elementOn.item.style.color}" ng-click="operationColor(item)"></span></div></li><li><div class="c-font-view"><div class="c-font-view-head" ng-style="{\'font-family\': \'\\\'\' + vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox.fontuuid + \'\\\'\',}">{{vm.selectFontName(vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox.fontuuid)}}</div><div class="c-font-view-body"><div class="c-font-view-body-head"><input type="text" class="c-font-view-body-head-input" ng-model="vm.selectFont" ng-change="vm.selectFontBtn()"> <span class="c-font-view-body-head-btn" ng-click="vm.selectFontBtn()" style="top: 6px"></span></div><div class="chinese-support-view"><div class="chinese-support-item" ng-class="{\'chinese-support-select\' : vm.chineseSupport}" ng-click="vm.chineseSupport=true">{{\'editorBtn.\u4E2D\u6587\u5B57\u4F53\' | translate}}</div><div class="chinese-support-item" ng-class="{\'chinese-support-select\' : !vm.chineseSupport}" ng-click="vm.chineseSupport=false">{{\'editorBtn.\u5176\u4ED6\u5B57\u4F53\' | translate}}</div></div><div class="c-font-view-body-ul"><div class="c-font-view-body-li" ng-repeat="font in vm.fontuuid track by $index" ng-click="updateTextFont(font)" ng-if="vm.chineseSupport == font.chineseSupport" ng-class="{\'c-font-view-body-li-on\' : vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox.fontuuid == font.uuid}"><img ng-src="{{font.fontStyles[0].identifierimageFilter}}" alt="" ng-if="vm.domain && font.fontStyles[0].identifier"> <span ng-if="!font.fontStyles[0].identifier">{{font.family}}</span></div></div></div></div><!--                                        <select ng-options="item as item.family for item in vm.fontList" ng-model="item"--><!--                                                ng-model-options="{debounce:500}" class="select-text" ng-change="updateTextFont(item)">--><!--                                        </select>--></li><li><div class="c-font-view" style="width: 80px"><div class="c-font-view-head"><input type="number" class="c-input1" style="width: 100%; border: 0" ng-model="vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox.style.size" ng-change="updateTextSize(vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox.style.size)"></div><div class="c-font-view-body"><div class="c-font-view-body-ul"><div class="c-font-view-body-li" ng-repeat="size in fontSizes track by $index" ng-click="updateTextSize(size)" ng-class="{\'c-font-view-body-li-on\' : vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox.style.size == size}">{{size}}</div></div></div></div><!--                        <select ng-options="size for size in fontSizes" style="width: 70px;"--><!--                                ng-model-options="{debounce:500}" class="select-text"--><!--                                ng-change="updateTextSize()"--><!--                                ng-model="vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox.style.size">--><!--                        </select>--></li><li ng-if="vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox.style.italic1"><div class="c-xml-action-div-icon" style="background-size: auto" ng-class="{\'tools_bar_bold\':!vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox.style.italic,\'tools_bar_bold_Selected\':vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox.style.italic}" ng-click="operationItalic()"><i class="iconfont iconI"></i><div class="tip3">{{\'editorBtn.italic\' | translate}}</div></div></li><li ng-if="vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox.style.bold1"><div class="c-xml-action-div-icon" ng-class="{\'tools_bar_bold\':!vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox.style.bold,\'tools_bar_bold_Selected\':vm.pages[vm.pageIndex].levels.level[vm.elementOn.index].textbox.style.bold}" ng-click="operationBold()"><i class="iconfont iconb"></i><div class="tip3">{{\'editorBtn.bold\' | translate}}</div></div></li><li class="pad-0"><button class="nav-lock tool-bar-btn tool-bar-btn-select"><i class="icon iconfont iconhangjianju" ng-click="operationSpacing(!vm.isOperationSpacing)"></i><div class="tip">{{\'editorBtn.space\' | translate}}</div><div class="space-slider" ng-if="vm.isOperationSpacing"><div class="slider"><label class="slider-label">{{\'editorBtn.wordSpace\' | translate}}</label><div class="slider-area"><div class="slider-back" ng-click="spacingClick(event)"></div><div class="slider-block block-width" data-value="width" onmousedown="resizeSpacingStart(event)"></div></div><input type="number" class="slider-input" min="0" onmousewheel="return false;" ng-model="vm.template.letterspacing" ng-change="spacingChange(1)"></div><div class="slider"><label class="slider-label">{{\'editorBtn.verticalSpace\' | translate}}</label><div class="slider-area"><div class="slider-back" data-value="height" ng-click="spacingClick($event)"></div><div class="slider-block block-height" data-value="height" onmousedown="resizeSpacingStart(event)"></div></div><input type="number" class="slider-input" min="{{vm.template.lineheight}}" onmousewheel="return false;" ng-model="vm.template.lineheight" ng-change="spacingChange(0)"></div></div></button></li><li class="pad-0"><button class="nav-operation tool-bar-btn tool-bar-btn-select"><i class="icon iconfont iconduiqi" ng-click="operationDir(!vm.isOperationDir)"></i><div class="tip">{{\'editorBtn.align\' | translate}}</div><div class="coverage-slider" ng-show="vm.isOperationDir"><ul><li ng-click="operationBarDir(\'left\')"><i class="icon iconfont iconzuoduiqi"></i><div class="tip4">{{\'editorBtn.alignLeft\' | translate}}</div></li><li ng-click="operationBarDir(\'center\')"><i class="icon iconfont iconshuipingjuzhong"></i><div class="tip4">{{\'editorBtn.alignCenter\' | translate}}</div></li><li ng-click="operationBarDir(\'right\')"><i class="icon iconfont iconyouduiqi"></i><div class="tip4">{{\'editorBtn.alignRight\' | translate}}</div></li><!--                                        <li ng-click="operationBarDir(\'justified\')">--><!--                                            <i class="icon iconfont iconliangduanduiqi"></i>--><!--                                            <div class="tip4">\u4E24\u7AEF\u5BF9\u9F50</div>--><!--                                        </li>--></ul></div></button></li><li class="pad-0" ng-if="vm.elementOn.item.style.writingmode != \'horizontal-tb\'"><button class="nav-lock tool-bar-btn tool-bar-btn-select" ng-click="textHengban()"><i class="iconfont iconhengban"></i><div class="tip">{{\'editorBtn.horizontal\' | translate}}</div></button></li><!-- <li class="pad-0" ng-if="vm.elementOn.item.style.writingmode != \'vertical-lr\'">\n                                    <button class="nav-lock tool-bar-btn tool-bar-btn-select" ng-click="textShuban(\'vertical-lr\')">\n                                        <i class="iconfont iconshuban"></i>\n                                        <div class="tip">{{\'editorBtn.verticalLr\' | translate}}</div>\n                                    </button>\n                                </li>\n                                <li class="pad-0" ng-if="vm.elementOn.item.style.writingmode != \'vertical-rl\'">\n                                    <button class="nav-lock tool-bar-btn tool-bar-btn-select" ng-click="textShuban(\'vertical-rl\')">\n                                        <i class="iconfont iconwenzigongju-shupai"></i>\n                                        <div class="tip">{{\'editorBtn.verticalRl\' | translate}}</div>\n                                    </button>\n                                </li> --></ul></div></div><div class="editor-nav2-ul1" style="display: flex;align-items: center"><button class="nav-lock tool-bar-btn tool-bar-btn-select" style="cursor: pointer !important" ng-class="{\'selected-dashed\': vm.isRoundedSet}" ng-if=" vm.elementOn.item.border &&  vm.elementOn.item.border.type == \'Color\' &&  vm.elementOn.item.border.shape == \'Rectangle\'"><i class="icon iconfont iconyuanjiao font-20" ng-click="roundedSet(!vm.isTransp)" style="cursor: pointer !important"></i><div class="tip3">{{\'editorBtn.radius\' | translate}}</div><div class="roundedSet" ng-show="vm.isRoundedSet" style="z-index: 1000"><div class="roundedSet-title"><div style="display: flex;align-items: center"><h4 class="rightPanel-title" style="margin-right: 10px">{{\'editorBtn.radius\' | translate}}</h4><span class="filletType" ng-class="{\'filletTypeActive\': vm.elementOn.item.border.radius.filletType == \'Fixed\'}" ng-click="changeFilletType(\'Fixed\')">px</span> <span class="filletType" ng-class="{\'filletTypeActive\': vm.elementOn.item.border.radius.filletType == \'Proportion\'}" ng-click="changeFilletType(\'Proportion\')">%</span></div><div class="border-radio-btn"><span class="rightPanel-title-radio-btn" ng-click="borderRadiusAllbtn()" ng-style="{\'background\':vm.borderRadiusAllbtn?\'#e5e5e5\':\'\'}" style="padding:1px 3px"><img src="content/images/icons/acive-overall.svg" alt="" ng-show="vm.borderRadiusAllbtn"> <img src="content/images/icons/overall.svg" alt="" ng-show="!vm.borderRadiusAllbtn"> </span><span class="rightPanel-title-radio-btn" ng-click="vm.borderRadiusAllbtn = false" ng-style="{\'background\':!vm.borderRadiusAllbtn?\'#e5e5e5\':\'\'}" style="padding:1px 3px"><img src="content/images/icons/active-quadrangle.svg" alt="" ng-show="!vm.borderRadiusAllbtn"> <img src="content/images/icons/quadrangle.svg" alt="" ng-show="vm.borderRadiusAllbtn"></span></div></div><div ng-if="vm.elementOn.item.border.radius.filletType == \'Proportion\'"><div ng-if="!vm.borderRadiusAllbtn"><div class="c-schedule-view"><span class="c-schedule-title">{{\'editorBtn.radiusLT\' | translate}}\uFF1A</span> <input type="range" min="0" max="100" step="1" value="{{ vm.elementOn.item.border.radius.lt}}" ng-model=" vm.elementOn.item.border.radius.lt" class="text-range-140 rangeSize" style="flex:1"> <span style="width: 30px">{{ vm.elementOn.item.border.radius.lt}}%</span></div><div class="c-schedule-view"><span class="c-schedule-title">{{\'editorBtn.radiusTR\' | translate}}\uFF1A</span> <input type="range" min="0" max="100" step="1" value="{{ vm.elementOn.item.border.radius.rt}}" ng-model=" vm.elementOn.item.border.radius.rt" class="text-range-140 rangeSize" style="flex:1"> <span style="width: 30px">{{ vm.elementOn.item.border.radius.rt}}%</span></div><div class="c-schedule-view"><span class="c-schedule-title">{{\'editorBtn.radiusRB\' | translate}}\uFF1A</span> <input type="range" min="0" max="100" step="1" value="{{ vm.elementOn.item.border.radius.rb}}" ng-model=" vm.elementOn.item.border.radius.rb" class="text-range-140 rangeSize" style="flex:1"> <span style="width: 30px">{{ vm.elementOn.item.border.radius.rb}}%</span></div><div class="c-schedule-view"><span class="c-schedule-title">{{\'editorBtn.radiusLB\' | translate}}\uFF1A</span> <input type="range" min="0" max="100" step="1" value="{{ vm.elementOn.item.border.radius.lb}}" ng-model=" vm.elementOn.item.border.radius.lb" class="text-range-140 rangeSize" style="flex:1"> <span style="width: 30px">{{ vm.elementOn.item.border.radius.lb}}%</span></div></div><div ng-if="vm.borderRadiusAllbtn"><div class="c-schedule-view"><span class="c-schedule-title">{{\'editorBtn.radiusAll\' | translate}}\uFF1A</span> <input type="range" min="0" max="100" step="1" value="{{ vm.elementOn.item.border.radius.all}}" ng-model=" vm.elementOn.item.border.radius.all" ng-change="borderRadiusAll()" class="text-range-140 rangeSize" style="flex:1"> <span style="width: 30px">{{ vm.elementOn.item.border.radius.all}}%</span></div></div></div><div ng-if="vm.elementOn.item.border.radius.filletType == \'Fixed\'"><div ng-if="!vm.borderRadiusAllbtn" style="display: flex;flex-wrap: wrap;gap: 10px"><div class="c-schedule-view2"><span class="c-schedule-title">{{\'editorBtn.radiusLT\' | translate}}\uFF1A</span> <input type="number" min="0" step="1" ng-model=" vm.elementOn.item.border.radius.lt"> <span style="width: 30px">px</span></div><div class="c-schedule-view2"><span class="c-schedule-title">{{\'editorBtn.radiusTR\' | translate}}\uFF1A</span> <input type="number" min="0" step="1" ng-model=" vm.elementOn.item.border.radius.rt"> <span style="width: 30px">px</span></div><div class="c-schedule-view2"><span class="c-schedule-title">{{\'editorBtn.radiusLB\' | translate}}\uFF1A</span> <input type="number" min="0" step="1" ng-model=" vm.elementOn.item.border.radius.lb"> <span style="width: 30px">px</span></div><div class="c-schedule-view2"><span class="c-schedule-title">{{\'editorBtn.radiusRB\' | translate}}\uFF1A</span> <input type="number" min="0" step="1" ng-model=" vm.elementOn.item.border.radius.rb"> <span style="width: 30px">px</span></div></div><div ng-if="vm.borderRadiusAllbtn"><div class="c-schedule-view2"><span class="c-schedule-title">{{\'editorBtn.radiusAll\' | translate}}\uFF1A</span> <input type="number" min="0" step="1" ng-model=" vm.elementOn.item.border.radius.all" ng-change="borderRadiusAll()"> <span style="width: 30px">px</span></div></div></div></div></button> <button class="nav-lock tool-bar-btn tool-bar-btn-select" style="cursor: pointer !important" ng-class="{\'selected-dashed\': vm.isBorderSet}" ng-if=" vm.elementOn.item.border &&  vm.elementOn.item.border.type == \'Color\'"><i class="icon iconfont iconbiankuang font-20" ng-click="borderSet(!vm.isBorderSet)" style="cursor: pointer !important"></i><div class="tip3">{{\'editorBtn.border\' | translate}}</div><div class="roundedSet" ng-show="vm.isBorderSet" style="z-index: 1000"><div class="col-md-12 col-sm-12 col-lg-12 pad-0" ng-if=" vm.elementOn.item.border &&  vm.elementOn.item.border.type == \'Color\'"><h4 class="rightPanel-title">{{\'editorBtn.border\' | translate}}</h4></div><div class="borderSet-body"><div class="bezel-set-color" style="width: 30px;height: 30px" ng-style="vm.elementOn.item.border.color ? {background: vm.elementOn.item.border.color} : {}"><input type="color" ng-change="onArticleChange()" ng-value="vm.elementOn.item.border.color || \'#000000\'" ng-model="vm.elementOn.item.border.color"></div><div class="c-font-view" style="height: 30px;flex: 1;padding: 0 10px"><div class="c-font-view-head2"><div ng-show=" vm.elementOn.item.border.lineType == \'solid\'"><img src="content/images/icons/solid.png"></div><div ng-show=" vm.elementOn.item.border.lineType == \'dashed\'"><img src="content/images/icons/dashed.png"></div><div ng-show=" vm.elementOn.item.border.lineType == \'dotted\'"><img src="content/images/icons/dotted.png"></div><img src="content/images/icons/pulldownIcon.png" alt="" style="position: absolute;width: 20px;right: 5px;top: 50%;transform: translateY(-50%)"></div><div class="c-font-view-body"><div class="c-font-view-body-ul" style="margin-top: 0"><div class="c-font-view-body-li" ng-click="lineTypeChenge(\'solid\')"><img src="content/images/icons/solid.png"></div><div class="c-font-view-body-li" ng-click="lineTypeChenge(\'dashed\')"><img src="content/images/icons/dashed.png"></div><div class="c-font-view-body-li" ng-click="lineTypeChenge(\'dotted\')"><img src="content/images/icons/dotted.png"></div></div></div></div><div style="width: 80px;height: 30px;display: flex"><input type="number" style="border: 1px solid #dedede;color: #000" oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/\\D/g,\'\');if(value>999)value=999;if(value<0)value=null" ng-model=" vm.elementOn.item.border.lineWidth"> <span>px</span></div></div></div></button> <button class="nav-lock tool-bar-btn tool-bar-btn-select" style="cursor: pointer !important" ng-class="{\'selected-dashed\': vm.isShadowSet}" ng-if=" vm.elementOn.item.border &&  vm.elementOn.item.border.type == \'Color\'"><i class="icon iconfont iconbim_yinying font-20" ng-click="shadowSet(!vm.isShadowSet)" style="cursor: pointer !important"></i><div class="tip3">{{\'editorBtn.shadow\' | translate}}</div><div class="roundedSet" ng-show="vm.isShadowSet" style="z-index: 1000"><div class="roundedSet-title"><h4 class="rightPanel-title">{{\'editorBtn.shadow\' | translate}}</h4><div class="bezel-set-color" style="width: 30px;height: 30px" ng-style="vm.elementOn.item.shadow.color ? {background: vm.elementOn.item.shadow.color} : {}"><input type="color" ng-change="onArticleChange()" ng-value="vm.elementOn.item.shadow.color || \'#000000\'" ng-model="vm.elementOn.item.shadow.color"></div></div><div><div class="c-schedule-view"><span class="c-schedule-title">{{\'editorBtn.shadowX\' | translate}}\uFF1A</span> <input type="range" min="-100" max="100" step="1" ng-change="onArticleChange()" value="{{ vm.elementOn.item.shadow.x}}" ng-model=" vm.elementOn.item.shadow.x" class="text-range-140 rangeSize" style="flex:1"> <span style="width: 30px">{{ vm.elementOn.item.shadow.x}}%</span></div><div class="c-schedule-view"><span class="c-schedule-title">{{\'editorBtn.shadowY\' | translate}}\uFF1A</span> <input type="range" min="-100" max="100" step="1" ng-change="onArticleChange()" value="{{ vm.elementOn.item.shadow.y}}" ng-model=" vm.elementOn.item.shadow.y" class="text-range-140 rangeSize" style="flex:1"> <span style="width: 30px">{{ vm.elementOn.item.shadow.y}}%</span></div><div class="c-schedule-view"><span class="c-schedule-title">{{\'editorBtn.shadowDim\' | translate}}\uFF1A</span> <input type="range" min="0" max="20" step="1" ng-change="onArticleChange()" value="{{ vm.elementOn.item.shadow.blur}}" ng-model=" vm.elementOn.item.shadow.blur" class="text-range-140 rangeSize" style="flex:1"> <span style="width: 30px">{{ vm.elementOn.item.shadow.blur}}%</span></div></div></div></button> <button class="nav-lock tool-bar-btn tool-bar-btn-select" ng-if="vm.elementOn.item.image.resource && vm.elementOn.item.image.resource.identifier && vm.elementOn.item.image.imageInfo.size < 20971520"><i class="icon iconfont iconsetiao" ng-click="optimizationSelect()"></i><div class="tip3">{{\'editorBtn.imageOptimization\' | translate}}</div></button> <button class="nav-lock tool-bar-btn" ng-class="{\'selected-dashed\': vm.isTransp,\' tool-bar-btn-select\' : vm.transparencyBtn}"><i class="icon iconfont icontoumingdu" ng-click="transparencySelect(!vm.isTransp)"></i><div class="tip3">{{\'editorBtn.transparency\' | translate}}</div><div class="roundedSet" ng-show="vm.isTransp"><div class="roundedSet-title"><h4 class="rightPanel-title">{{\'editorBtn.transparencySet\' | translate}}</h4></div><div><div class="c-schedule-view"><input type="range" min="0" style="flex:1;margin-right: 10px" max="1" step="0.1" value="1" class="text-range-140 rangeSize transparency-range"> <input type="number" style="width: 45px" class="slider-input transparency-num" min="0" onmousewheel="return false;" ng-model="vm.transparency" ng-change="transparencyChange()"></div></div></div></button> <button class="nav-lock tool-bar-btn" ng-click="locking()" ng-class="{\'tool-bar-btn-select\' : vm.lockingBtn}"><i class="icon iconfont iconduomeitiicon-"></i><div class="roundedSet" style="width:112px" ng-show="vm.elementOn.item.lock && vm.lockingBtn">{{\'editorBtn.lock\' | translate}}</div></button> <button class="nav-lock tool-bar-btn" ng-class="{\'selected-dashed\': vm.isAlign,\'tool-bar-btn-select\' : vm.elementOn.item}"><i class="icon iconfont iconzuoduiqi2" ng-click="alignHover2()"></i><div class="tip3">{{\'editorBtn.align\' | translate}}</div><div class="roundedSet" ng-show="vm.isAlign" style="width: 240px"><h4 class="rightPanel-title" style="margin-top: 0" ng-if="vm.toobarAlignmentBtn">{{\'editorBtn.elementAlign\' | translate}}</h4><h4 class="rightPanel-title" style="margin-top: 0" ng-if="!vm.toobarAlignmentBtn">{{\'editorBtn.alignendsHorizontally\' | translate}}</h4><div style="display: flex;flex-wrap: wrap;flex-direction: unset"><div class="alignLi" ng-click="singleBoxAlignment(\'left\')"><i class="icon iconfont iconzuoduiqi"></i><div>{{\'editorBtn.alignLeft\' | translate}}</div></div><div class="alignLi" ng-click="singleBoxAlignment(\'right\')"><i class="icon iconfont iconyouduiqi"></i><div>{{\'editorBtn.alignRight\' | translate}}</div></div><div class="alignLi" ng-click="singleBoxAlignment(\'standard\')"><i class="icon iconfont iconchuizhijuzhong"></i><div>{{\'editorBtn.centerHorizontally\' | translate}}</div></div><div class="alignLi" ng-click="singleBoxAlignment(\'vertical\')"><i class="icon iconfont iconshuipingjuzhong"></i><div>{{\'editorBtn.centerVertical\' | translate}}</div></div><div class="alignLi" ng-click="singleBoxAlignment(\'top\')"><i class="icon iconfont iconshangduiqi"></i><div>{{\'editorBtn.alignTop\' | translate}}</div></div><div class="alignLi" ng-click="singleBoxAlignment(\'bottom\')"><i class="icon iconfont iconxiaduiqi"></i><div>{{\'editorBtn.alignBottom\' | translate}}</div></div></div><div ng-if="vm.distribute" style="margin-top: 10px"><h4 class="rightPanel-title" style="margin-top: 0">{{\'editorBtn.distributionElement\' | translate}}</h4><div style="display: flex;flex-wrap: wrap;flex-direction: unset"><div class="alignLi" ng-click="boxDistribute(\'horizontal\')"><i class="icon iconfont iconHorCenter"></i><div>{{\'editorBtn.distributionHorizontally\' | translate}}</div></div><div class="alignLi" ng-click="boxDistribute(\'vertical\')"><i class="icon iconfont iconVerCenter"></i><div>{{\'editorBtn.distributionVertical\' | translate}}</div></div></div></div></div></button> <button class="nav-coverage tool-bar-btn" ng-class="{\'selected-dashed\': vm.isCoverage, \'tool-bar-btn-select\' : vm.coverageBtn}" ng-if="!vm.elementOn.item.spotColor"><i class="icon iconfont icontuceng" ng-click="coverageSelect(!vm.isCoverage)"></i><div class="tip5" style="left:-3px">{{\'editorBtn.coverage\' | translate}}</div><div class="roundedSet" style="width:220px" ng-show="vm.isCoverage && vm.coverageBtn" style="z-index: 1000"><div class="roundedSet-title"><h4 class="rightPanel-title">{{\'editorBtn.coverageMove\' | translate}}</h4></div><div><div class="c-schedule-view hover-coverageMove" style="padding:5px 0" ng-click="coverageMove(\'top\')"><span class="c-schedule-title"><img style="width:20px" src="content/images/icon/coverage-top.png" alt=""></span><div class="font-size:14px;">{{\'editorBtn.coverageTop\' | translate}}</div></div><div class="c-schedule-view hover-coverageMove" style="padding:5px 0" ng-click="coverageMove(\'up\')"><span class="c-schedule-title"><img style="width:20px" src="content/images/icon/Bring-forward.png" alt=""></span><div class="font-size:14px;">{{\'editorBtn.coverageUp\' | translate}}</div></div><div class="c-schedule-view hover-coverageMove" style="padding:5px 0" ng-click="coverageMove(\'down\')"><span class="c-schedule-title"><img style="width:20px" src="content/images/icon/send-behind.png" alt=""></span><div class="font-size:14px;">{{\'editorBtn.coverageDown\' | translate}}</div></div><div class="c-schedule-view hover-coverageMove" style="padding:5px 0" ng-click="coverageMove(\'bottom\')"><span class="c-schedule-title"><img style="width:20px" src="content/images/icon/coverage-bottom.png" alt=""></span><div class="font-size:14px;">{{\'editorBtn.coverageBottom\' | translate}}</div></div></div></div></button> <button class="nav-copy tool-bar-btn" ng-click="copyimg($event)" ng-class="{\'tool-bar-btn-select\' : vm.copyBtn}" ng-hide="vm.elementOn.item.serviceType"><i class="icon iconfont iconfuzhi font-18"></i><div class="tip">{{\'editorBtn.copy\' | translate}}</div></button> <button class="nav-delete tool-bar-btn" ng-click="deleteBox($event)" ng-class="{\'tool-bar-btn-select\' : vm.deleteBtn}"><i class="icon iconfont iconshanchu font-18"></i><div class="tip">{{\'editorBtn.delete\' | translate}}</div></button></div></div><div class="page-photo-view3-2" ng-click="editorBodyView($event)"><page-edit that="vm" editor-type="vm.editorType" page-data="vm.pages" page-index="vm.pageIndex" page-number="vm.pageIndex" element-on="vm.elementOn" move-canvas-obj="vm.moveCanvasObj" img-size="vm.imgSize" img-dpi="vm.imgDpi"></page-edit></div><div class="page-photo-view3-3" style="position: relative" ng-if="vm.showEditorDialog"><div style="position: absolute;left: 20px; display: flex; align-items: center; color: #999"><i class="iconfont icontishi"></i>{{\'editorBtn.\u53CC\u51FB\u56FE\u7247\u8FDB\u884C\u7F16\u8F91\' | translate}}</div><button type="button" class="dialog-foot-close" ng-click="editorDialogHide()">{{\'button.retreat\' | translate}}</button> <button type="button" class="dialog-foot-confirm" ng-click="save()">{{\'button.confirm\' | translate}}</button></div><div class="page-photo-view3-3" style="position: relative; color: #d43838" ng-if="!vm.showEditorDialog">\u56FE\u50CF\u7F16\u8F91\u4E2D\uFF0C\u8BF7\u5B8C\u6210\u56FE\u50CF\u7F16\u8F91</div></div></div></div><div style="opacity: 0; position: absolute; left: 0; bottom: 0" ng-style="{\n            \'width\': writingmodeInit(vm.elementOn.item.style.writingmode) ? \'auto\' : (vm.elementOn.item.geometry.width),\n            \'height\': !writingmodeInit(vm.elementOn.item.style.writingmode) ? \'auto\' : (vm.elementOn.item.geometry.height)\n            }"><pre id="c-xml-page-material-fontId1" style="display: inline-block; opacity: 0" ng-style="{\n                    \'font-family\': \'\\\'\' + vm.elementOn.item.fontuuid + \'\\\'\',\n                    \'font-size\': (vm.elementOn.item.style.size) + \'pt\',\n                    \'color\': vm.elementOn.item.style.color,\n                    \'font-weight\': vm.elementOn.item.style.bold ? \'bold\': \'400\',\n                    \'font-style\': vm.elementOn.item.style.italic ? \'italic\': \'initial\',\n                    \'letter-spacing\': (vm.elementOn.item.style.letterspacing) + \'pt\',\n                    \'line-height\': (vm.elementOn.item.style.lineheight) + \'pt\',\n                    \'text-decoration\': \'none\',\n                    \'text-align-last\': \'unset\',\n                    \'max-width\' : \'100%\',\n                    \'writing-mode\': vm.elementOn.item.style.writingmode\n                    }"><span class="c-xml-page-textboxe-span">{{vm.elementOn.item.text}}</span></pre></div><div style="opacity: 0; position: absolute; left: 0; bottom: 0" ng-style="{\'width\': (vm.pages[vm.pageIndex].trimbox.width-10)}"><pre id="c-xml-page-material-fontId" style="display: inline-block; opacity: 0" ng-style="{\n                    \'font-family\': \'\\\'\' + vm.elementOn.item.fontuuid + \'\\\'\',\n                    \'font-size\': (vm.elementOn.item.style.size) + \'pt\',\n                    \'color\': vm.elementOn.item.style.color,\n                    \'font-weight\': vm.elementOn.item.style.bold ? \'bold\': \'400\',\n                    \'font-style\': vm.elementOn.item.style.italic ? \'italic\': \'initial\',\n                    \'line-height\': (vm.elementOn.item.style.size) + \'pt\',\n                    \'letter-spacing\': (vm.elementOn.item.style.letterspacing) + \'pt\',\n                    \'text-decoration\': \'none\',\n                    \'text-align-last\': \'unset\',\n                    \'max-width\' : \'100%\',\n                    }"><span class="c-xml-page-textboxe-span">{{vm.elementOn.item.text}}</span></pre></div><div style="opacity: 0; position: absolute; left: 0; bottom: 0" ng-style="{\n            \'width\': writingmodeInit(vm.elementOn.item.style.writingmode) ? \'auto\' : (vm.elementOn.item.geometry.width),\n            \'height\': !writingmodeInit(vm.elementOn.item.style.writingmode) ? \'auto\' : (vm.elementOn.item.geometry.height)\n            }"><pre id="c-xml-page-material-fontId2" style="display: inline-block; opacity: 0" ng-style="{\n                    \'font-family\': \'\\\'\' + vm.elementOn.item.fontuuid + \'\\\'\',\n                    \'font-size\': (vm.elementOn.item.style.size) + \'pt\',\n                    \'color\': vm.elementOn.item.style.color,\n                    \'font-weight\': vm.elementOn.item.style.bold ? \'bold\': \'400\',\n                    \'font-style\': vm.elementOn.item.style.italic ? \'italic\': \'initial\',\n                    \'line-height\': vm.elementOn.item.style.lineheight + \'pt\',\n                    \'letter-spacing\': (vm.elementOn.item.style.letterspacing) + \'pt\',\n                    \'text-decoration\': \'none\',\n                    \'text-align-last\': \'unset\',\n                    \'max-width\' : \'100%\',\n                    \'writing-mode\': vm.elementOn.item.style.writingmode\n                    }"><span class="c-xml-page-textboxe-span">{{vm.elementOn.item.text}}</span></pre></div></div><div class="three-modal1" ng-if="vm.threeLoading"><img src="content/images/icon/loading.gif" alt=""><div>{{vm.threeLoadingText}}</div></div><!-- \u56FE\u7247\u4F18\u5316 --><canvas-image-filter ng-if="vm.showCanvasImageFilter" element-on="vm.elementOn"></canvas-image-filter><!-- \u62A0\u56FE --><image-cutout ng-if="vm.isShowImageCutout" :imagebox="vm.imageboxCutout" on-save="imageCutoutSave(text)" on-change="imageCutoutChange(text)"></image-cutout><chalk-view width="vm.chalkWidth" height="vm.chalkHeight" imagebox="vm.chalkItem" type="vm.menuIndex" imageart="vm.chalkImageart" property-value="vm.chalkPropertyValue" on-change="vm.chalkChange(text)" ng-if="vm.chalkItem || vm.chalkImageart"></chalk-view><outline-view ng-if="vm.isOutline" page="vm.pages[vm.pageIndex]" property-value="vm.propertyValue.outline[0]" picture-type="vm.product.pictureType" contour-width="vm.product.contourWidth" on-change="outlineChange(text)"></outline-view><style>.page-photo-view{\n        width: 100%;\n        height: 100%;\n        display: flex;\n    }\n    .page-photo-view1{\n        position: relative;\n        width: 80px;\n        height: 100%;\n        background: #fff;\n        overflow: auto;\n    }\n    .page-photo-view1-item{\n        position: relative;\n        width: 100%;\n        height: 70px;\n        color: #1e1f22;\n        cursor: pointer;\n        transition: all .1s ease;\n        display: flex;\n        justify-content: center;\n        align-content: center;\n        align-items: center;\n        flex-wrap: wrap;\n    }\n    .page-photo-view1-item-text{\n        width: 100%;\n        text-align: center;\n        margin-top: 4px;\n    }\n    .page-photo-view1-item-hr{\n        position: absolute;\n        width: 50px;\n        height: 1px;\n        background: #e2e2e2;\n        bottom: 0;\n        left: 50%;\n        transform: translateX(-50%);\n    }\n    .coverage{\n        position: absolute;\n        bottom: 0;\n        left: 0;\n    }\n    .page-photo-view1-item-select{\n        color: #6296fe;\n    }\n    .page-photo-view2{\n        width: 320px;\n        height: 100%;\n        padding: 10px;\n        overflow: auto;\n        border-left: 1px solid #ddd;\n        border-right: 1px solid #ddd;\n        background: #fff;\n    }\n    .page-photo-view2-item{\n        width: 100%;\n    }\n    .page-photo-view3{\n        width: calc(100% - 400px);\n        background: #f5f7fa;\n    }\n    .page-photo-view3-1{\n        height: 40px;\n        width: 100%;\n        background: #fff;\n        display: flex;\n        align-items: center;\n    }\n    .page-photo-view3-2{\n        height:calc(100% - 100px);\n        width: 100%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        overflow: hidden;\n    }\n    .page-photo-view3-3{\n        height: 60px;\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n    .genericColor{\n        background: none !important;\n        color: #6296fe !important;\n    }\n    \n    .dialog-foot-close{\n        width: 96px;\n        height: 40px;\n        background: #fff;\n        border-radius: 4px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        color: #333333;\n        margin-right: 10px;\n    }\n    .dialog-foot-confirm{\n        width: 96px;\n        height: 40px;\n        background: #6296fe;\n        border-radius: 4px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        color: #FFFFFF;\n    }\n    .text-size-24, .text-size-20, .text-size-16, .radius-btn{\n        background: #747474;\n    }\n    .page-photo-view2::-webkit-scrollbar {\n        width: 0px;\n        height: 0px;\n    }\n    \n    .chalk-view-1-3-1 {\n        width: 100%;\n        height: 100%;\n        position: absolute;\n        top: 0;\n        left: 0;\n        z-index: 1;\n        background: rgba(32, 32, 249, 1);\n    }</style>');
$templateCache.put('app/entities/components/page-preview.html','<div ng-style="{\n        \'width\': vm.pageData.custom.width * vm.scale,\n        \'height\': vm.pageData.custom.height * vm.scale,\n        \'box-shadow\' : !vm.pageData.boxShadow ? \'0px 0px 13px 0 rgba(0, 0, 0, 0.3)\' : \'none\'\n    }" style="overflow: hidden;position: relative"><div style="position: relative" ng-style="{\n                                        \'width\': vm.pageData.custom.width * vm.scale,\n                                        \'height\': vm.pageData.custom.height * vm.scale\n                                    }"><div style="width: 100%; height: 100%; position: absolute" ng-if="vm.pageData.scene && !vm.cover" ng-style="{\n                    \'position\': \'absolute\',\n                    \'width\': vm.pageData.custom.width * vm.scale,\n                    \'height\': vm.pageData.custom.height * vm.scale,\n                    \'z-index\': vm.pageData.scene.hierarchy == \'TOP\' ? \'1\' : \'0\',\n                    \'pointer-events\': \'none\'\n                }"><img ng-src="{{vm.pageData.scene.resource.identifier | imageFilter}}" alt="" ng-style="{\n                    \'width\': vm.pageData.scene.resource.adaptation == \'Width\' ? \'auto\' : \'100%\',\n                    \'height\': vm.pageData.scene.resource.adaptation == \'Height\' ? \'auto\' : \'100%\'\n                }"><div ng-style="{\n                                            \'position\': \'absolute\',\n                                            \'width\': vm.pageData.scene.imagebox.geometry.width * vm.scale,\n                                            \'height\': vm.pageData.scene.imagebox.geometry.height * vm.scale,\n                                            \'left\': vm.pageData.scene.imagebox.geometry.x * vm.scale,\n                                            \'top\': vm.pageData.scene.imagebox.geometry.y * vm.scale,\n                                            \'transform\': \'rotate(\' + vm.pageData.scene.imagebox.rotation.angle + \'deg)\',\n                                        }"></div></div><div style="width: 100%; height: 100%; position: relative" ng-style="{\n                \'z-index\': vm.pageData.scene && !vm.cover && vm.pageData.scene.hierarchy == \'TOP\' ? 0 : 1\n            }"><div ng-style="pageStyle()"><div style="width: 100%; height: 100%; position: relative; overflow: hidden"><img ng-src="{{vm.pageData.background.resource.identifier | imageFilter}}" alt="" ng-if="vm.pageData.background.type == \'Pic\'" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': vm.pageData.background.resource.adaptation == \'Width\' ? (vm.pageData.mediabox1 ? vm.pageData.mediabox1.width : vm.pageData.mediabox.width) * vm.scale : \'auto\',\n                                                    \'height\': vm.pageData.background.resource.adaptation == \'Height\' ? (vm.pageData.mediabox1 ? vm.pageData.mediabox1.height : vm.pageData.mediabox.height) * vm.scale : \'auto\',\n                                                    \'left\': vm.pageData.background.offsetx * vm.scale,\n                                                    \'top\': vm.pageData.background.offsety * vm.scale\n                                                }"><div style="position: absolute;width: 100%; height: 100%; left: 0; top: 0" ng-repeat="level in vm.pageData.levels.level"><div ng-if="level.code&&level.code.geometry" ng-style="{\n                         \'position\':\'absolute\',\n                        \'width\': level.code.geometry.width*vm.scale,\n                         \'height\': level.code.geometry.height*vm.scale,\n                         \'left\': level.code.geometry.x*vm.scale,\n                         \'top\': level.code.geometry.y*vm.scale,\n                         \'z-index\':level.seq-0+200,\n                         \'transform\': \'rotate(-\' + level.code.rotation.angle + \'deg)\'\n                        }"><img ng-src="{{level.code.previewImage}}" alt="" style="width: 100%; height: 100%"></div><div ng-if="level.imagebox" class="imageboxView imageboxView{{vm.pageIndex}}{{$index}}" data-imgindex="{{$index}}" ng-style="{\n                             \'position\': \'absolute\',\n                                width: imageboxW(level.imagebox)*vm.scale,\n                                height: imageboxH(level.imagebox)*vm.scale,\n                                left: imageboxL(level.imagebox)*vm.scale,\n                                top: imageboxT(level.imagebox)*vm.scale,\n                                \'z-index\':level.seq-0+200,\n                                \'transform\': \'rotate(\' + level.imagebox.rotation.angle + \'deg)\',\n                                        }"><div ng-style="{\n                                        \'position\': \'absolute\',\n                                     \'opacity\':level.imagebox.transparency,\n                                        \'z-index\':0,\n                                        \'left\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'left\')*vm.scale : 0,\n                                        \'top\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'top\')*vm.scale : 0,\n                                        \'right\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'right\')*vm.scale : 0,\n                                        \'bottom\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'bottom\')*vm.scale : 0,\n                                        \'background-image\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'url(\' + level.imagebox.border.resource.identifier + \')\' : \'\',\n                                        \'background-size\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'100% 100%\' : \'\'\n                                        }"></div><div class="relative-view2"><div class="relative-view1" data-imgindex="{{$index}}" ng-style="{\n                                                    \'overflow\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'unset\' : \'hidden\',\n                                                    \'opacity\':level.imagebox.transparency,\n                                                    \'border-top-left-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'lt\',vm.scale),\n                                                    \'border-top-right-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'rt\',vm.scale),\n                                                    \'border-bottom-right-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'rb\',vm.scale),\n                                                    \'border-bottom-left-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'lb\',vm.scale),\n                                                    \'border-width\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? ((level.imagebox.border.lineWidth*vm.scale) | number:0) : \'\',\n                                                    \'border-style\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? (level.imagebox.border.lineType || \'solid\') : \'none\',\n                                                    \'border-color\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? level.imagebox.border.color : \'\',\n                                                    \'box-shadow\' : (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineWidth>0 && (!level.imagebox.border.lineType || level.imagebox.border.lineType == \'solid\')) ? \'0 0 0 1px \' + level.imagebox.border.color + \' inset\' : \'none\',\n                                                    \'filter\' : dropShadow(level.imagebox,vm.scale),\n                                        }"><div class="relative-view1" data-imgindex="{{$index}}" ng-style="{\n                                            \'-webkit-mask-image\': level.imagebox.mask.resource.identifier ? \'url(\' + level.imagebox.mask.resource.identifier + \')\' : \'none\',\n                                            \'-webkit-mask-size\': \'100% 100%\',\n                                            \'border-top-left-radius\':imageboxWRadius1(level.imagebox, \'lt\',vm.scale),\n                                            \'border-top-right-radius\':imageboxWRadius1(level.imagebox, \'rt\',vm.scale),\n                                            \'border-bottom-right-radius\':imageboxWRadius1(level.imagebox, \'rb\',vm.scale),\n                                            \'border-bottom-left-radius\':imageboxWRadius1(level.imagebox, \'lb\',vm.scale),\n                                            }"><div ng-if="vm.isImageboxNot && (!level.imagebox.image || !level.imagebox.image.resource || !level.imagebox.image.resource.identifier)" data-imgindex="{{$index}}" class="image-placeholder image-placeholder-class"><img data-imgindex="{{$index}}" src="content/images/icons/camera.svg" style="width: 100%; height: 100%;opacity: 0"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'None\' && level.imagebox.image.resource.identifier" data-imgindex="{{$index}}"><!-- \u5927\u56FE\u5F02\u6B65\u5904\u7406\u4E2D - \u663E\u793A\u52A0\u8F7D\u5360\u4F4D\u56FE --> <img ng-if="level.imagebox.image.largeFlag && level.imagebox.image.largeStatus == \'running\'" src="content/images/largeLoading.jpg" alt="" data-imgindex="{{$index}}" ng-style="{\n                                                        \'position\': \'absolute\',\n                                                        \'width\': \'100%\',\n                                                        \'height\': \'100%\',\n                                                        \'left\': 0,\n                                                        \'top\': 0\n                                                     }"><!-- \u5927\u56FE\u5904\u7406\u5931\u8D25 - \u663E\u793A\u9519\u8BEF\u5360\u4F4D\u56FE --> <img ng-if="level.imagebox.image.largeFlag && level.imagebox.image.largeStatus == \'error\'" src="content/images/largeError.jpg" alt="" data-imgindex="{{$index}}" ng-style="{\n                                                        \'position\': \'absolute\',\n                                                        \'width\': \'100%\',\n                                                        \'height\': \'100%\',\n                                                        \'left\': 0,\n                                                        \'top\': 0\n                                                     }"><!-- \u5927\u56FE\u5904\u7406\u5B8C\u6210 \u6216 \u975E\u5927\u56FE - \u6B63\u5E38\u663E\u793A2 --> <img ng-if="(!level.imagebox.image.largeFlag || (level.imagebox.image.largeFlag && level.imagebox.image.largeStatus != \'running\' && level.imagebox.image.largeStatus != \'error\')) && level.imagebox.whiteInk2" ng-src="{{level.imagebox.whiteInk2.resource.identifier | imageFilter:level.imagebox.image.angle:isLarge(level.imagebox.image.imageInfo)}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.imagebox.image.width*level.imagebox.image.scale * vm.scale,\n                                                    \'height\': level.imagebox.image.height*level.imagebox.image.scale * vm.scale,\n                                                    \'left\':level.imagebox.image.offsetx*level.imagebox.image.scale * vm.scale,\n                                                    \'top\':level.imagebox.image.offsety*level.imagebox.image.scale * vm.scale,\n                                                    \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\'\n                                                }"> <img alt="" ng-if="!level.imagebox.image.largeFlag || (level.imagebox.image.largeFlag && level.imagebox.image.largeStatus != \'running\' && level.imagebox.image.largeStatus != \'error\')" ng-src="{{level.imagebox.image.resource.identifier | imageFilter:level.imagebox.image.angle:isLarge(level.imagebox.image.imageInfo)}}" data-index="{{$index}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.imagebox.image.width*level.imagebox.image.scale * vm.scale,\n                                                    \'height\': level.imagebox.image.height*level.imagebox.image.scale * vm.scale,\n                                                    \'left\':level.imagebox.image.offsetx*level.imagebox.image.scale * vm.scale,\n                                                    \'top\':level.imagebox.image.offsety*level.imagebox.image.scale * vm.scale,\n                                                    \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                    \'z-index\': 1\n                                                }"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'Blurred\' && level.imagebox.image.resource.identifier" data-imgindex="{{$index}}"><img class="c-blur" alt="" ng-if="level.imagebox.image.resource.identifier" ng-src="{{ isLarge(level.imagebox.image.imageInfo) ? (level.imagebox.image.resource.identifier | imageFilter:level.imagebox.image.angle:true) : (level.imagebox.image.resource.identifier | imageFilter:level.imagebox.image.angle) }}" data-index="{{$index}}" data-imgindex="{{$index}}" ng-style="{\n                                                        \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                    \'position\': \'absolute\',\n                                                }"> <img ng-src="{{ isLarge(level.imagebox.image.imageInfo) ? (level.imagebox.image.resource.identifier | imageFilter:level.imagebox.image.angle:true) : (level.imagebox.image.resource.identifier | imageFilter:level.imagebox.image.angle) }}" data-imgindex="{{$index}}" ng-if="level.imagebox.image.resource.identifier" ng-style="{\n                                                        \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                        \'position\': \'absolute\',\n                                                        \'width\': level.imagebox.blurredrectangle.width*vm.scale*level.imagebox.image.scale,\n                                                        \'height\': level.imagebox.blurredrectangle.height*vm.scale*level.imagebox.image.scale,\n                                                        \'left\':level.imagebox.blurredrectangle.x*vm.scale*level.imagebox.image.scale,\n                                                        \'top\':level.imagebox.blurredrectangle.y*vm.scale*level.imagebox.image.scale,\n                                                    \'z-index\': 1\n                                                }"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" data-imgindex="{{$index}}" ng-if="level.imagebox.bokehtype == \'Transparent\' && level.imagebox.image.resource.identifier"><img alt="" ng-src="{{ isLarge(level.imagebox.image.imageInfo) ? (level.imagebox.image.resource.identifier | imageFilter:level.imagebox.image.angle:true) : (level.imagebox.image.resource.identifier | imageFilter:level.imagebox.image.angle) }}" ng-if="level.imagebox.image.resource.identifier" data-index="{{$index}}" data-imgindex="{{$index}}" ng-style="{\n                                                        \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.imagebox.blurredrectangle.width*vm.scale*level.imagebox.image.scale,\n                                                    \'height\': level.imagebox.blurredrectangle.height*vm.scale*level.imagebox.image.scale,\n                                                    \'left\':level.imagebox.blurredrectangle.x*vm.scale*level.imagebox.image.scale,\n                                                    \'top\':level.imagebox.blurredrectangle.y*vm.scale*level.imagebox.image.scale\n                                                }"></div></div></div></div><div class="imagebox-shade"></div><div ng-class="{\'c-imagebox-warn1\' : (level.imagebox.geometry.width * vm.scale < 120),\n                                            \'c-imagebox-warn\':(level.imagebox.geometry.width * vm.scale >= 120)}" data-index="{{$index}}" ng-if="vm.isImageboxNot && level.imagebox && level.imagebox.image && level.imagebox.image.resource && level.imagebox.image.resource.identifier && pxInsufficient(level.imagebox)"><i class="icon iconfont iconwaring imageboxWarn"></i> <span>{{\'editorCommon.lackPixels\' | translate}}</span></div></div><div ng-if="level.imageart" class="no-events" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.imageart.geometry.width * vm.scale,\n                                                    \'height\': level.imageart.geometry.height * vm.scale,\n                                                    \'left\': level.imageart.geometry.x * vm.scale,\n                                                    \'top\': level.imageart.geometry.y * vm.scale,\n                                                            \'transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                                    \'z-index\':level.seq-0+200,\n                                                }"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img ng-src="{{level.imageart.resource.identifier | imageFilter}}" ng-if="level.imageart.resource.identifier && !level.imageart.spotColor" ng-style="{\n                                        \'position\': \'absolute\',\n                                        \'width\': level.imageart.geometry.width * vm.scale * level.imageart.scale,\n                                        \'left\': level.imageart.offsetx * vm.scale,\n                                        \'top\': level.imageart.offsety * vm.scale,\n                                        \'opacity\': level.imageart.transparency,\n                                        \'transform\': level.imageart.flip ? \'rotateY(180deg)\' : \'unset\',\n                                    }"><div class="gold-foil-text" ng-if="level.imageart.resource.identifier && level.imageart.spotColor" style="height: fit-content" ng-style="{\n                                        \'background\': goldFoil(level.imageart.spotColor.color),\n                                        \'position\': \'absolute\',\n                                        \'width\': level.imageart.geometry.width * vm.scale * level.imageart.scale,\n                                        \'left\': level.imageart.offsetx * vm.scale,\n                                        \'top\': level.imageart.offsety * vm.scale,\n                                        \'opacity\': level.imageart.transparency,\n                                        \'transform\': level.imageart.flip ? \'rotateY(180deg)\' : \'unset\',\n                                        \'-webkit-mask-image\': \'url(\' + level.imageart.resource.identifier + \')\',\n                                        \'-webkit-mask-size\': \'100% 100%\'\n                                        }"><img class="c-xml-page-material-img" ng-src="{{level.imageart.resource.identifier | imageFilter}}" ng-style="{\n                                            \'transform\': level.imageart.flip ? \'rotateY(180deg)\' : \'unset\',\n                                            \'opacity\' : 0,\n                                            \'width\': level.imageart.geometry.width * vm.scale * level.imageart.scale,\n                                        }"></div></div></div><div ng-if="level.textbox" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.textbox.geometry.width * vm.scale,\n                                                    \'height\': level.textbox.geometry.height * vm.scale,\n                                                    \'left\': level.textbox.geometry.x * vm.scale,\n                                                    \'top\': level.textbox.geometry.y * vm.scale,\n                                                    \'transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                                    \'z-index\': level.seq-0+200\n                                                }"><pre class="c-xml-page-textboxe-text web-font" data-index="{{$index}}" ng-style="{\n                                                        \'font-family\': \'\\\'\' + level.textbox.fontuuid + \'\\\'\',\n                                                        \'font-size\': (level.textbox.style.size*vm.scale > 12 ? level.textbox.style.size* vm.scale : 12) + \'pt\',\n                                                        \'color\': level.textbox.style.color,\n                                                        \'font-weight\': level.textbox.style.bold ? \'bold\': \'400\',\n                                                        \'font-style\': level.textbox.style.italic ? \'italic\': \'initial\',\n                                                        \'line-height\': (level.textbox.style.size * vm.scale > 12 ? level.textbox.style.lineheight * vm.scale : (level.textbox.style.lineheight * vm.scale) / (1 / 12 * level.textbox.style.size * vm.scale)) + \'pt\',\n                                                        \'letter-spacing\': (level.textbox.style.size * vm.scale > 12 ? level.textbox.style.letterspacing * vm.scale : (level.textbox.style.letterspacing * vm.scale) / (1 / 12 * level.textbox.style.size * vm.scale)) + \'pt\',\n                                                        \'opacity\': level.textbox.transparency,\n                                                        \'text-decoration\': \'none\',\n                                                        \'text-align\': level.textbox.style.align,\n                                                        \'text-align-last\': \'unset\',\n                                                        \'transform\':\'scale(\'+(1 / 12 * level.textbox.style.size* vm.scale > 1 ? 1 : 1 / 12 * level.textbox.style.size* vm.scale)+\')\',\n                                                        \'transform-origin\': \'0 0\',\n                                                        \'writing-mode\': level.textbox.style.writingmode,\n                                                        \'width\': level.textbox.style.size * vm.scale > 12 ? level.textbox.geometry.width * vm.scale : (level.textbox.geometry.width * vm.scale) / (1 / 12 * level.textbox.style.size * vm.scale) + \'px\',\n                                                        \'height\': level.textbox.style.size * vm.scale > 12 ? level.textbox.geometry.height * vm.scale : (level.textbox.geometry.height * vm.scale) / (1 / 12 * level.textbox.style.size * vm.scale) + \'px\'\n                                                    }"><span class="c-xml-page-textboxe-span">{{level.textbox.text}}</span></pre></div><div data-index="{{$index}}" ng-if="level.textdocument" ng-style="{\n                                                        position: \'absolute\',\n                                                        width: level.textdocument.geometry.width * vm.scale,\n                                                        height: level.textdocument.geometry.height * vm.scale,\n                                                        left: level.textdocument.geometry.x * vm.scale,\n                                                        top: level.textdocument.geometry.y * vm.scale,\n                                                        \'z-index\':level.seq-0+200,\n                                                        \'opacity\':level.textdocument.transparency.toFixed(2),\n                                                        filter: \'alpha(opacity=\'+level.textdocument.transparency*100+\')\',\n                                                        \'transform\': \'rotate(\' + level.textdocument.rotation.angle + \'deg)\'}"><div style="overflow: hidden;width: 100%;height: 100%;position: relative" class="no-events"><img class="bg-image bg-image{{template.pageI}} pos" ng-cloak ng-if="level.textdocument.background.resource.identifier" ng-src="{{level.textdocument.background.resource.identifier | imageFilter}}" ng-style="{\n                                                                position: \'absolute\',\n                                                                left:level.textdocument.background.offsetx * vm.scale,\n                                                                top:level.textdocument.background.offsety * vm.scale,\n                                                                width: level.textdocument.background.adaptation==\'Width\'?level.textdocument.geometry.width * vm.scale:\'\',\n                                                                height:level.textdocument.background.adaptation!=\'Width\'?level.textdocument.geometry.height * vm.scale:\'\'}"><div ng-repeat="docLevel in level.textdocument.levels.level track by $index" ng-init="docIndex = $index" style="position: relative"><div data-index="{{docIndex}}" class="img-art" ng-if="docLevel.imageart" ng-style="{\n                                                                    width: docLevel.imageart.geometry.width * vm.scale,\n                                                                    height: docLevel.imageart.geometry.height * vm.scale,\n                                                                    left: docLevel.imageart.geometry.x * vm.scale,\n                                                                    top: docLevel.imageart.geometry.y * vm.scale,\n                                                                    \'z-index\':docLevel.seq-0+200,\n                                                                    \'opacity\':docLevel.imageart.transparency,\n                                                                    filter: \'alpha(opacity=\'+docLevel.imageart.transparency*100+\')\',\n                                                                    \'transform\': \'rotate(\' + docLevel.imageart.rotation.angle + \'deg)\'}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                                            \'left\': docLevel.imageart.offsetx * vm.scale,\n                                                                            \'top\': docLevel.imageart.offsety * vm.scale,\n                                                                            \'width\': docLevel.imageart.geometry.width * vm.scale}" ng-src="{{docLevel.imageart.resource.identifier | imageFilter}}"></div></div><div class="c-xml-page-textboxe" ng-show="docLevel.textbox" style="white-space: normal" data-index="{{docIndex}}" ng-style="{\n                                                                    \'width\': docLevel.textbox.geometry.width * vm.scale,\n                                                                    \'height\': docLevel.textbox.geometry.height * vm.scale,\n                                                                    \'left\': docLevel.textbox.geometry.x * vm.scale,\n                                                                    \'top\': docLevel.textbox.geometry.y * vm.scale,\n                                                                    \'z-index\':docLevel.seq-0+200,\n                                                                    \'transform\': \'rotate(\' + docLevel.textbox.rotation.angle + \'deg)\'}"><pre class="c-xml-page-textboxe-text web-font" ng-style="{\n                                                                \'font-family\':  \'\\\'\' + docLevel.textbox.fontuuid + \'\\\'\',\n                                                                \'font-size\': (docLevel.textbox.style.size*vm.scale > 12 ? docLevel.textbox.style.size* vm.scale : 12) + \'pt\',\n                                                                \'color\': docLevel.textbox.style.color,\n                                                                \'font-weight\': docLevel.textbox.style.bold ? \'bold\': \'400\',\n                                                                \'font-style\': docLevel.textbox.style.italic ? \'italic\': \'initial\',\n                                                                \'line-height\': (docLevel.textbox.style.size * vm.scale > 12 ? docLevel.textbox.style.lineheight * vm.scale : (docLevel.textbox.style.lineheight * vm.scale) / (1 / 12 * docLevel.textbox.style.size * vm.scale)) + \'pt\',\n                                                                \'letter-spacing\': (docLevel.textbox.style.size * vm.scale > 12 ? docLevel.textbox.style.letterspacing * vm.scale : (docLevel.textbox.style.letterspacing * vm.scale) / (1 / 12 * docLevel.textbox.style.size * vm.scale)) + \'pt\',\n                                                                \'opacity\': docLevel.textbox.transparency,\n                                                                \'text-decoration\': \'none\',\n                                                                \'text-align\': docLevel.textbox.style.align,\n                                                                \'text-align-last\': \'unset\',\n                                                                \'transform\':\'scale(\'+(1 / 12 * docLevel.textbox.style.size* vm.scale > 1 ? 1 : 1 / 12 * docLevel.textbox.style.size* vm.scale)+\')\',\n                                                                \'width\': docLevel.textbox.style.size * vm.scale > 12 ? docLevel.textbox.geometry.width * vm.scale : (docLevel.textbox.geometry.width * vm.scale) / (1 / 12 * docLevel.textbox.style.size * vm.scale) + \'px\'\n                                                            }"><span class="c-xml-page-textboxe-span">{{docLevel.textbox.text}}</span></pre></div></div></div></div><div ng-if="level.calMonthBox" class="no-events" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.calMonthBox.geometry.width * vm.scale,\n                                                    \'height\': level.calMonthBox.geometry.height * vm.scale,\n                                                    \'left\': level.calMonthBox.geometry.x * vm.scale,\n                                                    \'top\': level.calMonthBox.geometry.y * vm.scale,\n                                                            \'transform\': \'rotate(\' + level.calMonthBox.rotation.angle + \'deg)\',\n                                                    \'z-index\':level.seq-0+200,\n                                                }"><month-table widget="level.calMonthBox" scale="vm.scale" thumbnail="vm.thumbnail" year="level.calMonthBox.sampleYear" month="level.calMonthBox.sampleMonth" week="level.calMonthBox.startOfWeek" width="level.calMonthBox.geometry.width" height="level.calMonthBox.geometry.height" update="level.calMonthBox.update"></month-table></div><div ng-if="level.calTitleBox" class="no-events" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.calTitleBox.geometry.width * vm.scale,\n                                                    \'height\': level.calTitleBox.geometry.height * vm.scale,\n                                                    \'left\': level.calTitleBox.geometry.x * vm.scale,\n                                                    \'top\': level.calTitleBox.geometry.y * vm.scale,\n                                                            \'transform\': \'rotate(\' + level.calTitleBox.rotation.angle + \'deg)\',\n                                                    \'z-index\':level.seq-0+200,\n                                                }"><div style="width: 100%; height: 100%; position: relative; overflow: hidden"><title-cell width="level.calTitleBox.geometry.width" height="level.calTitleBox.geometry.height" scale="vm.scale" year="level.calTitleBox.sampleYear" month="level.calTitleBox.sampleMonth" widget="level.calTitleBox"></title-cell></div></div></div><div class="barcode" ng-show="vm.pageData.barcode" ng-style="{\n                                                    \'z-index\':999,\n                                                    \'width\': vm.pageData.barcode.geometry.width * vm.scale,\n                                                    \'height\': vm.pageData.barcode.geometry.height * vm.scale,\n                                                    \'left\': vm.pageData.barcode.geometry.x * vm.scale,\n                                                    \'top\': vm.pageData.barcode.geometry.y * vm.scale,\n                                                    \'transform\': \'rotate(\' + vm.pageData.barcode.rotation.angle + \'deg)\' }"><img src="content/images/txm.png" style="width: 100%;height: 100%"></div><div class="barcode" ng-show="vm.pageData.qrcode" ng-style="{\n                                                    \'z-index\':999,\n                                                    \'width\': vm.pageData.qrcode.geometry.width * vm.scale,\n                                                    \'height\': vm.pageData.qrcode.geometry.height * vm.scale,\n                                                    \'left\': vm.pageData.qrcode.geometry.x * vm.scale,\n                                                    \'top\': vm.pageData.qrcode.geometry.y * vm.scale,\n                                                    \'transform\': \'rotate(\' + vm.pageData.qrcode.rotation.angle + \'deg)\' }"><img src="content/images/QrCode.png" style="width: 100%;height: 100%"></div></div></div><div class="border-outline" ng-style="{\n                width:vm.pageData.trimbox.width*vm.scale,\n                height:vm.pageData.trimbox.height*vm.scale,\n                top:vm.pageData.trimbox.y*vm.scale,\n                left:vm.pageData.trimbox.x*vm.scale}" ng-if="vm.editorType === \'PICTURE_PRO_P\' && !vm.pageData.outline && vm.isOutline"></div><object ng-attr-data="{{vm.pageData.outline.cutline.resource.identifier}}" ng-if="vm.editorType === \'PICTURE_PRO_P\' && vm.pageData.outline && vm.pageData.outline.cutline && vm.pageData.outline.cutline.resource && vm.pageData.outline.cutline.resource.identifier && vm.isOutline" type="image/svg+xml" ng-style="{\n                    width:transitionPx(vm.pageData.outline.geometry.width) * vm.scale,\n                    height:transitionPx(vm.pageData.outline.geometry.height) * vm.scale,\n                    \'left\': transitionPx(vm.pageData.outline.geometry.x) * vm.scale + \'px\',\n                    \'top\': transitionPx(vm.pageData.outline.geometry.y) * vm.scale + \'px\',\n                }" style="width: 100%; height: 100%; pointer-events: none; position: absolute;left: 0; top: 0;z-index: 400"></object></div></div></div>');
$templateCache.put('app/entities/components/page-sort.html','<div class="editor-photoAlbum-page1" style="padding: 0"><input onchange="uploadImageMutiple(event)" type="file" multiple="multiple" accept="{{vm.supportedMimeTypes}}" name="file" ng-if="!vm.agentIos && !vm.isIPhone6" class="input-upload1" id="page-sort-upload-id"><div class="editor-photoAlbum-title"><span class="editor-photoAlbum-title-hint">\u957F\u6309\u62D6\u52A8\u6392\u5E8F</span> <span class="editor-photoAlbum-title-fr" ng-click="photoReverse()" ng-show="!vm.draggable"><i class="iconfont iconpaixu"></i> {{\'editorBtn.invertedOrder\' | translate}}</span> <span class="editor-photoAlbum-title-fr" ng-click="completeSort()" ng-show="vm.draggable">{{\'editorBtn.completeSort\' | translate}}</span></div><div class="c-productThree1-body" style="top: 40px; bottom: 80px" ng-style="{\'bottom\':vm.draggable?\'0px\':\'80px\'}"><div class="c-productThree1-body-no" ng-if="vm.photoAll.length == 0"><img src="content/images/worksNull.png" alt="" srcset="" style="width:50%;margin-top: 20vh"> <span class="c-productThree1-body-no-text">{{\'editorCommon.describe2\' | translate}}</span></div><div class="c-productThree1-body-y" ng-show="vm.photoAll.length > 0" style="margin-top: -10px"><ul class="clearfix" id="photoAllId"><li class="page1Img-li" ng-repeat="item in vm.photoAll track by $index" style="position: relative"><div class="c-productThree1-body-y-li sortingPageView" data-page="{{item}}"><div><img ng-if="item.identifier" ng-src="{{(item.largeFlag ? (item.largeStatus ==\'running\' ? \'content/images/largeLoading.jpg\' :item.largeStatus ==\'error\' ? \'content/images/largeError.jpg\': item.identifier + \'.thumbnail.jpg\' ): item.identifier )+\'?imageView2/1/w/102/h/115\'||\'//:0\'}}" alt="" class="c-productThree1-body-y-img" style="pointer-events:none"><div class="c-imagebox-warn" ng-if="item.imgSize && item.imgSize / 1024 < 150" style="width: 85px"><i class="icon iconfont iconwaring imageboxWarn"></i> <span>{{\'editorCommon.lackPixels\' | translate}}</span></div><span class="photoSelectAll-number">{{$index+1}}</span></div></div><div class="c-productThree1-body-y-x" ng-click="deletePhotoSelect($event,$index)" ng-show="!vm.draggable"><i class="icon iconfont iconguanbi1"></i></div></li><li class="page1Img-li" ng-repeat="data in vm.uploadPhotoItem" ng-if="data.percent != 100 && !data.state" style="position: relative"><div class="c-productThree1-body-y-li sortingPageView" data-page="{{item}}"><div><progres-view :src="data.blobCover" :progres="data.percent"></progres-view></div></div></li></ul></div></div><div class="editor-photoAlbum-page1-foot" style="height: 80px" ng-show="!vm.draggable"><div class="editor-photoAlbum-page1-foot-fl"><div class="editor-photoAlbum-page1-foot-btn" ng-click="uploadPhoto()"><i class="icon iconfont iconUpload"></i> <span>{{\'editorBtn.uploadGallery\' | translate}}</span> <input onchange="uploadImageMutiple(event)" type="file" multiple="multiple" accept="{{vm.supportedMimeTypes}}" name="file" ng-if="!vm.agentIos && vm.isIPhone6" class="input-upload2"></div></div><div class="editor-photoAlbum-page1-foot-fr" ng-if="vm.product.allowNegativeUnify"><button type="button" ng-click="book(true)">\u4EC5\u586B\u5145\u6B63\u9762</button> <button type="button" ng-click="book()">\u6309\u5E8F\u6B63\u53CD\u5BF9\u5E94</button></div><div class="editor-photoAlbum-page1-foot-fr" ng-if="!vm.product.allowNegativeUnify"><button type="button" ng-click="book()">{{\'editorBtn.confirm\' | translate}}\uFF08{{vm.photoAll.length}}\uFF09</button></div></div></div><upload-image store-id="vm.storeId" aid="vm.aid" upload-photo-item="vm.uploadPhotoItem" photo-all="vm.photoAll"></upload-image>');
$templateCache.put('app/entities/components/picture.html','<div class="editor-nav-view-li"><div class="editor-nav-view-li-title"><div class="editor-nav-view-li-title-left">{{\'nav.photograph.content.photo\' | translate}} <i class="iconfont icon31yiwen photo-query"><div class="photo-name-operate-div"><div class="photo-name-operate" style="font-size: 12px;width: 200px"><div>{{\'nav.photograph.content.photoHint\' | translate}}</div></div></div></i></div><div class="editor-nav-view-li-title-right" ng-class="{\'themecolor-black-color\':vm.Theme == \'Three\'}" ng-show="!vm.folderId" ng-click="addFolder()">{{\'nav.photograph.content.btn.addPhotoAlbum\' | translate}}</div></div><div class="editor-nav-view-li-web-local-photo"><button class="opacityMinus web-local-photo" ng-click="uploadImage($event)"><span class=""><i class="iconfont iconshangchuanzhaopian1"></i> {{\'nav.photograph.content.btn.upload\' | translate}}</span> <input onchange="updatePic(event)" id="uploadImg2" type="file" multiple="multiple" accept="image/png, image/jpeg, image/jpg, image/heic" name="file" value=""></button> <button class="opacityMinus web-local-photo" ng-click="uploadByPhone()"><span class=""><i class="iconfont iconshoujishangchuan1"></i> {{\'nav.photograph.content.btn.mobileUpload\' | translate}}</span></button></div><div class="folder-view" ng-show="!vm.folderId"><ul class="clearfix folderUl"><li ng-click="showFolderContent()"><div><img class="folderUl-img" src="content/images/icon/photo_has.png" alt=""> <span class="folderUl-text">{{\'nav.photograph.content.folders.name\' | translate}}</span></div></li><li ng-repeat="folder in Folders track by $index" ng-if="$index<5 || vm.folderShow" ng-click="showFolderContent(folder)"><div><img class="folderUl-img" src="content/images/icon/web_folder.png" alt=""> <span class="folderUl-text">{{folder.name}}</span> <img class="folderUl-sel" src="content/images/icons/folder_sel.svg" ng-if="vm.folderId == folder.id"><div class="folderUl-delete"><img src="content/images/icon/genduo.png" alt=""><div class="photo-name-operate-div2" style="width:96px !important"><div class="photo-name-operate"><div ng-click="deleteShow(folder.id,$event)">{{\'button.delete\' | translate}}</div><div ng-click="updateFloders(folder,$event)">{{\'button.ren\' | translate}}</div></div></div></div></div></li></ul><button type="button" class="folder-down" ng-click="folderOn()" ng-if="Folders.length>5 && !vm.folderShow">{{\'button.spread\' | translate}} <i class="iconfont iconxia"></i></button> <button type="button" class="folder-down1" ng-click="folderOn()" ng-if="Folders.length>5 && vm.folderShow">{{\'button.packUp\' | translate}} <i class="iconfont iconshang"></i></button></div><div class="folder-content-title" ng-show="vm.folderId"><div class="folder-content-title-title"><i class="iconfont iconchangyongicon-" style="font-size: 20px"></i> <span style="margin-left: 10px">{{vm.folderName}}</span></div><span class="iconfont iconguanbi1" ng-click="showFolderContent()"></span></div><div class="editor-nav-view-li-1"><div class="web-photo-nav"><div ng-class="{\'web-nav-active\':vm.photosTab==\'all\',\'web-nav-active-black\':vm.Theme == \'Three\'}" ng-click="switchBgTab(\'all\')">{{\'nav.photograph.content.btn.allPhotos\' | translate}}</div><div ng-class="{\'web-nav-active\':vm.photosTab!=\'all\',\'web-nav-active-black\':vm.Theme == \'Three\'}" ng-click="switchBgTab()">{{\'nav.photograph.content.btn.unused\' | translate}}<span style="font-size: 12px" ng-if="vm.unusedQuantity">\uFF08{{vm.unusedQuantity}}\uFF09</span></div></div><div class="editor-nav-view-li-seq2"><div class="editor-nav-view-li-seq2-left"><img src="content/images/icon/photoName.png" alt="" srcset="" ng-if="vm.isWatchName"> <img src="content/images/icon/photoName2.png" alt="" srcset="" ng-if="!vm.isWatchName"><div class="photo-name-operate-div2"><div class="photo-name-operate"><div ng-click="watchGalleryName(false)" ng-class="{\'photo-name-operate-active\':!vm.isWatchName}">{{\'nav.photograph.content.btn.photoName.hide\' | translate}}</div><div ng-click="watchGalleryName(true)" ng-class="{\'photo-name-operate-active\':vm.isWatchName}">{{\'nav.photograph.content.btn.photoName.show\' | translate}}</div></div></div></div><div class="editor-nav-view-li-seq2-right"><img src="content/images/icon/photoSeq.png" alt=""><div class="photo-name-operate-div2" style="right: 16px;bottom: 15px"><div class="photo-name-operate"><div ng-class="{\'photo-name-operate-active\':vm.photoSort == 1}" ng-click="photoSortChange(\'1\')">{{\'nav.photograph.content.btn.seq.time\' | translate}}</div><div ng-class="{\'photo-name-operate-active\':vm.photoSort == 2}" ng-click="photoSortChange(\'2\')">{{\'nav.photograph.content.btn.seq.nameUp\' | translate}}</div><div ng-class="{\'photo-name-operate-active\':vm.photoSort == 3}" ng-click="photoSortChange(\'3\')">{{\'nav.photograph.content.btn.seq.nameBelow\' | translate}}</div></div></div></div></div></div><div class="editor-nav-view-li-2" ng-style="{\'padding-bottom\':gallaryPic.length>0?\'120px\':\'70px\'}"><ul class="clearfix"><li ng-repeat="photo in photos track by $index" ng-if="vm.photosTab==\'all\' || (vm.photosTab!=\'all\'&&(photo.usenum==0||!photo.usenum))" ng-click="choosePhoto(photo)"><div class="editor-nav-view-li-2-view"><img class="editor-nav-view-li-2-view-img" ng-if="photo.identifier" ng-src="{{ photo.largeFlag ? (photo.identifier | imageFilter:false:true) : (photo.identifier | imageFilter)}}" draggable="true" ondragstart="dragStart(event)" ondragend="dragOn(event)" id="dragtargetRecommendPic{{$index}}" data-index="{{$index}}" data-item="{{photo}}" style="overflow: inherit;z-index: 9999"> <img class="editor-nav-view-li-2-view-img1" src="content/images/icon/editor_select.png" alt="" ng-show="photo.select"> <img class="editor-nav-view-li-2-view-img2" src="content/images/icon/editor_unchecked.png" alt="" ng-style="{\'display\':( !photo.select && gallaryPic.length>0 ) ? \'block\' : \'\'}"> <span class="editor-nav-view-li-2-view-value" ng-if="photo.usenum">{{photo.usenum}}</span><div class="imgSizeWarn" ng-if="photo.imgSize < vm.imgSize * 1024"><i class="iconfont iconjinggao" style="height: 25px;line-height: 25px"></i><div class="imgSizeWarn-text" style="height: 25px;line-height: 25px">{{\'nav.photograph.content.pictogram\' | translate}}</div></div></div><div class="text-ellipsis font-12 mar-top-10" style="color: #333;height: 18px" ng-if="vm.isWatchName" uib-tooltip="{{photo.name}}" tooltip-placement="top">{{photo.name}}</div></li></ul><div class="default-diagram" ng-show="(photos.length == 0 && !vm.picLoading && vm.photosTab == \'all\') || (vm.photosTab!=\'all\' && vm.unUsedImageboxsNum == photos.lenght)"><img src="content/images/default-diagram.png"><div>{{\'hint.noData\' | translate}}</div></div><div class="no-more" ng-if="vm.isPhotoFinish && photos.length>0 && !vm.picLoading">{{\'hint.noMore\' | translate}}</div><div class="web-photo-choose" ng-if="gallaryPic.length>0"><div class="web-photo-choose-top"><div class="web-photo-choose-top-left" translate="nav.photograph.content.selected" translate-values="{gallaryPic:gallaryPic.length,totalPhotoItems:vm.totalPhotoItems}"></div><div class="web-photo-choose-top-right"><span ng-click="whetherChoose(true)">{{\'nav.photograph.content.btn.selectAll\' | translate}}</span> <span ng-click="whetherChoose(false)">{{\'button.cancel\' | translate}}</span></div></div><div class="web-photo-choose-bottom"><div class="web-photo-choose-bottom-left"><i class="iconfont iconmove_folder" uib-tooltip="{{\'nav.photograph.content.btn.move\' | translate}}" tooltip-placement="top" ng-click="moveToFolder()"></i> <i class="iconfont icondustbin_icon" uib-tooltip="{{\'button.delete\' | translate}}" tooltip-placement="top" ng-click="deleteBatchPhotos()"></i></div><div><button class="web-choose-set" ng-class="{\'themecolor-black-bgc\':vm.Theme == \'Three\'}" ng-click="directFill()">{{\'nav.photograph.content.btn.fill\' | translate}}</button></div></div></div></div><div class="pic-loading1" ng-if="vm.picLoading"><div class="load-mask" style="display: flex; justify-content: center; align-items: center"><img src="content/images/icons/loading01.gif"></div></div><div class="errorAlertPopup" ng-if="vm.errorAlertPopup"><div class="errorAlertPopupLeft"><span class="iconfont iconjinggao1"></span> <span class="contentText">{{\'nav.photograph.content.uploadError\' | translate({lenght:vm.uploadFailedList.length})}}</span> <span class="view" ng-click="errorPhotoView()">{{\'button.view\' | translate}}</span></div><span class="iconfont iconguanbi1 errorAlertPopupClose" ng-click="errorAlertPopupClose()"></span></div></div><!--\u91CD\u590D\u56FE\u7247--><duplicate-list domain-url="domain" ng-if="vm.isDuplicateList" list="vm.duplicateList" on-change="duplicateChange()"></duplicate-list><!--\u624B\u673A\u4F20\u56FE--><div style="z-index: 999; position: fixed; top: 0px; left: 0px; right: 0px; bottom: 0px; background-color: rgba(0,0,0,.5)" ng-show="vm.qrcodeShow" data-html2canvas-ignore><div style="width: 528px;background-color: #FFF; position:absolute;left: 50%;top: 50%;transform: translate(-50%,-50%);border-radius: 8px;overflow: hidden"><div class="modal-header" style="border: none;font-size: 18px;color:#333;font-weight: bold"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="uploadByPhone1()">&times;</button> {{\'editorPop.photoUpload.title\' | translate}}</div><div class="modal-body col-lg-12 col-sm-12" style="text-align: center"><div class="form-group col-lg-12 col-sm-12"><div style="color: #333333; font-size: 20px; opacity: 0.85">{{\'editorPop.photoUpload.describe\' | translate}}</div></div><div class="form-group col-lg-12 col-sm-12"><div id="qrcode1"></div></div><div class="form-group col-lg-12 col-sm-12" style="margin-top: 10px"><div style="color: #666666; font-size: 14px; opacity: 0.85">{{\'editorPop.photoUpload.describe1\' | translate}}</div><br><div style="color: #999999; font-size: 12px; opacity: 0.85">{{\'editorPop.photoUpload.describe2\' | translate}}</div></div></div></div></div><style>.editor-nav-view-li-title{\n        padding: 16px 0;\n    }\n    .editor-nav-view-li-web-local-photo, .editor-nav-view-li-2 ul{\n        padding: 0;\n    }\n    .web-local-photo{\n        margin: 0;\n    }\n    .editor-nav-view-li-title-left{\n        color: #333;\n    }\n    .web-local-photo{\n        color: #333;\n        border: 1px solid #333;\n    }\n    .phone-updatePic{\n        color: #333;\n        border: 1px solid #333;\n    }\n    .folder-content-title, .web-photo-nav div, .default-diagram, .folderUl-text{\n        color: #333 !important;\n    }\n    .editor-nav-view-li-seq2-left, .editor-nav-view-li-seq2-right{\n        background: #333;\n    }\n    .editor-nav-view-li-2-view{\n        background: #E8EAED !important;\n    }\n    .web-photo-choose{\n        left: 80px;\n    }</style>');
$templateCache.put('app/entities/components/progres-view.html','<div class="circle_view"><div class="circle_view1"><img ng-src="{{vm.src}}" ng-if="vm.progres == 100"><div class="circle" ng-if="vm.progres < 100"><div class="circle_left ab" ng-style="{\n            \'transform\': vm.transform1,\n            \'border-color\': vm.borderColor,\n        }"></div><div class="circle_right ab" ng-style="{\n            \'transform\': vm.transform2,\n            \'border-color\': vm.borderColor1}"></div><div class="circle_text"><span class="value">{{vm.progres}}%</span></div></div></div></div><style>.circle_view{\n        position: absolute;\n        left: 0;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        background: #F7F8FA;\n    }\n    .circle_view1{\n        width: 100%;\n        height: 100%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n    .circle_view1 img{\n        max-width: 100%;\n        max-height: 100%;\n    }\n    .circle {\n        position: absolute;\n        left: 50%;\n        top: 50%;\n        width: 60px;\n        height: 60px;\n        margin: -30px 0 0 -30px;\n        border-radius: 50%;\n        z-index: 2;\n        box-shadow: inset 0 0 0 4px var(--genericColor);\n    }\n    .ab {\n        position: absolute;\n        left: 0;\n        right: 0;\n        top: 0;\n        bottom: 0;\n        margin: auto;\n    }\n\n    .circle_left {\n         border: 4px solid #CED4E0;\n         border-radius: 50%;\n         clip: rect(0, 30px, 60px, 0);\n     }\n\n    .circle_right {\n         border: 4px solid #CED4E0;\n         border-radius: 50%;\n         clip: rect(0, 60px, 60px, 30px);\n     }\n\n    .circle_text {\n         height: 100%;\n         display: flex;\n         flex-direction: column;\n         justify-content: center;\n         align-items: center;\n    }</style>');
$templateCache.put('app/entities/components/textbox-ec.html','<!--  \u6587\u5B57  --><div class="three-font" ng-show="vm.editbox"><div class="three-font-head"><button type="button" class="three-font-head-btn" ng-click="savePage5()">{{\'button.confirm\' | translate}}</button></div><div class="three-font-body"><textarea class="three-font-body-input" id="three-font-body-input" ng-keyup="changeText($event)" ng-style="{\'text-align\': vm.fontData.textbox.style.align }" ng-model="vm.fontData.textbox.text" placeholder="{{\'editorCommon.describe29\' | translate}}"></textarea></div></div><div class="c-editorPhoto3-foot" ng-if="vm.textboxSelect"><div class="icon-btn" ng-click="editTextbox()"><i class="icon iconfont iconbianjiwenzi" style="color: #000"></i> <span>{{\'editorBtn.editWordText\' | translate}}</span></div><div class="icon-btn" ng-click="textStyleTextbox()"><i class="icon iconfont iconwenziyangshi" style="color: #000"></i> <span>{{\'editorBtn.wordStyleText\' | translate}}</span></div><div class="icon-btn" ng-click="deleteTextbox()" ng-if="vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.useradded"><i class="icon iconfont icondustbin_icon" style="color: #000"></i> <span>{{\'editorBtn.delWordText\' | translate}}</span></div></div><div class="three-textStyle" ng-if="vm.textStyleShow"><div class="three-textStyle-head"><ul><li ng-repeat="item in vm.textStyleTab" ng-click="textStyleTabCb(item)" ng-class="{\'opt\' : item.id == vm.textStyleItem}"><span>{{item.name}}</span></li></ul><i class="icon iconfont iconlujing8" ng-click="textStyleHide()"></i></div><div class="three-textStyle-body"><div class="textStyleTabFont" ng-if="vm.textStyleItem==\'textStyleTabFont\'"><div class="textStyleTabFont-li" ng-repeat="font in vm.fontList track by $index" ng-class="{\'textStyleTabFont-li-on\' : vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.fontuuid == font.uuid}" ng-click="updateTextFont(font)"><i class="icon iconfont iconduihao"></i> <span>{{font.family}}</span></div></div><div class="textStyleTabSize" ng-if="vm.textStyleItem==\'textStyleTabSize\'"><div class="c-productThree5-li-content" style="text-align: center; padding-top: 40px"><p class="text-value">{{\'font.currentFontSize\' | translate:({size: vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.size})}}</p><div><i class="icon-font font-jia"></i> <input type="range" min="9" max="1000" step="1" value="16" class="text-range rangeSize" id="rangeChange" oninput="densityInput(event)" ng-model="vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.size"> <i class="icon-font font-jian"></i></div></div></div><div class="textStyleTabType" ng-if="vm.textStyleItem==\'textStyleTabType\'"><div class="textStyleTabType-view1"><span>{{\'font.transparency\' | translate}}\uFF1A</span> <input type="range" min="0" max="100" step="1" value="16" class="text-range rangeSize" id="textStyleTransparency" oninput="textStyleTransparency(event)" ng-model="vm.transparency"> <span>{{vm.transparency}}</span></div><div class="textStyleTabType-view2"><div class="textStyleTabType-view2-li-icon" ng-if="vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.bold1" ng-class="{\'textStyleTabType-view2-li-icon-no\':!vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.bold,\'textStyleTabType-view2-li-icon-yes\':vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.bold}" ng-click="operationBold()"><i class="icon iconfont iconb"></i> <span>{{\'font.bold\' | translate}}</span></div><div class="textStyleTabType-view2-li-icon" ng-if="vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.italic1" ng-class="{\'textStyleTabType-view2-li-icon-no\':!vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.italic,\'textStyleTabType-view2-li-icon-yes\':vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.italic}" ng-click="operationItalic()"><i class="icon iconfont iconI"></i> <span>{{\'font.italic\' | translate}}</span></div><!--                        <div class="textStyleTabType-view2-li-icon">--><!--                            <i class="icon iconfont iconU"></i>--><!--                            <span>\u4E0B\u5212\u7EBF</span>--><!--                        </div>--><div class="textStyleTabType-view2-li-icon" ng-click="operationBarDir(\'left\')"><i class="icon iconfont iconjuzuo"></i> <span>{{\'font.alignLeft\' | translate}}</span></div><div class="textStyleTabType-view2-li-icon" ng-click="operationBarDir(\'center\')"><i class="icon iconfont iconjuzhong-orange"></i> <span>{{\'font.alignCenter\' | translate}}</span></div><div class="textStyleTabType-view2-li-icon" ng-click="operationBarDir(\'right\')"><i class="icon iconfont iconjuyou"></i> <span>{{\'font.alignRight\' | translate}}</span></div><div class="textStyleTabType-view2-li-icon" ng-click="textLayout(\'horizontal-tb\')" ng-if="vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.writingmode != \'horizontal-tb\'"><i class="icon iconfont iconhengban"></i> <span>{{\'font.horizontal\' | translate}}</span></div><div class="textStyleTabType-view2-li-icon" ng-click="textLayout(\'vertical-lr\')" ng-if="vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.writingmode != \'vertical-lr\'"><i class="icon iconfont iconshuban"></i> <span>{{\'font.vertical\' | translate}}</span></div><!--                        <div class="textStyleTabType-view2-li-icon" ng-click="textLayout(\'vertical-rl\')" ng-if="vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.writingmode != \'vertical-rl\'">--><!--                            <i class="icon iconfont iconshuban1"></i>--><!--                            <span>\u7AD6\u7248\u53F3</span>--><!--                        </div>--></div></div><div class="clearfix" ng-if="vm.textStyleItem==\'textStyleTabColor\'"><span class="fontColor-item" style="float: left" ng-repeat="item in colorList" ng-click="fontColorCb(item)" ng-style="{\n                            \'border\': vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.color == item ?  \'1px solid \' + item : none,\n                          }"><i ng-style="{\'background\': item}"></i></span></div></div></div><div style="opacity: 0; position: fixed" ng-style="{\'width\': (vm.pageData[vm.pageIndex].trimbox.width-10)}"><pre id="c-xml-page-material-fontId" style="display: inline-block; opacity: 0" ng-style="{\n            \'font-family\': \'\\\'\' + vm.fontData.textbox.fontuuid + \'\\\'\',\n            \'font-size\': (vm.fontData.textbox.style.size) + \'pt\',\n            \'color\': vm.fontData.textbox.style.color,\n            \'font-weight\': vm.fontData.textbox.style.bold ? \'bold\': \'400\',\n            \'font-style\': vm.fontData.textbox.style.italic ? \'italic\': \'initial\',\n            \'line-height\': (vm.fontData.textbox.style.lineheight) + \'pt\',\n            \'letter-spacing\': (vm.fontData.textbox.style.letterspacing) + \'pt\',\n            \'text-decoration\': \'none\',\n            \'text-align-last\': \'unset\',\n            \'max-width\' : \'100%\',\n            \'writing-mode\': vm.fontData.textbox.style.writingmode,\n            }"><span class="c-xml-page-textboxe-span">{{vm.fontData.textbox.text}}</span></pre></div><div style="opacity: 0; position: fixed" ng-style="{\n        \'width\': !writingmodeInit(vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.writingmode) ? (vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.geometry.width) : \'auto\',\n        \'height\': writingmodeInit(vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.writingmode) ? (vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.geometry.height) : \'auto\'\n        }"><pre id="c-xml-page-material-fontId1" style="display: inline-block; opacity: 0" ng-style="{\n                \'font-family\': \'\\\'\' + vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.fontuuid + \'\\\'\',\n                \'font-size\': (vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.size > 12 ? vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.size : 12) + \'pt\',\n                \'color\': vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.color,\n                \'font-weight\': vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.bold ? \'bold\': \'400\',\n                \'font-style\': vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.italic ? \'italic\': \'initial\',\n                \'letter-spacing\': (vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.size > 12 ? vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.letterspacing : (vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.letterspacing) / (1 / 12 * vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.size)) + \'pt\',\n                \'line-height\': (vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.size > 12 ? vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.lineheight : (vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.lineheight) / (1 / 12 * vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.size)) + \'pt\',\n                \'transform\':\'scale(\'+(1 / 12 * vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.size > 1 ? 1 : 1 / 12 * vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.size)+\')\',\n                \'transform-origin\': \'0 0\',\n                \'text-decoration\': \'none\',\n                \'text-align-last\': \'unset\',\n                \'max-width\' : \'100%\',\n                \'writing-mode\': vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.writingmode\n                }"><span class="pre-span">{{vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.text}}</span></pre></div>');
$templateCache.put('app/entities/components/three-preview-2d.html','<div ng-style="{width: vm.width, height: vm.height}" style="margin: 0 auto; position: relative; overflow: hidden"><div class="loading-page3" ng-if="vm.loading"><img src="content/images/loading.gif" style="max-width: 40px; max-height: 40px"></div><img ng-src="{{vm.backgroundImg}}" alt="" ng-if="vm.backgroundImg+\'?imageMogr2/thumbnail/800x800>\'" style="position: absolute;left: 0;top: 0;width: 100%;height: 100%"><div id="threeView2d{{vm.index}}" ng-show="!vm.loading && !vm.error" style="position:absolute;left: 0;top: 0;z-index: 1;width: 100%; height: 100%"></div><div style="position: absolute;left: 0; top: 0; width: 100%; height: 100%; z-index: 2"></div></div><style>.loading-page3{\n        position: absolute;\n        left: 0;\n        top: 0;\n        z-index: 2;\n        width: 100%;\n        height: 100%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        margin: 0;\n    }</style>');
$templateCache.put('app/entities/components/three-preview.html','<div style="position: fixed; left: 50%; top: 50%; margin-top: 50%" ng-style="{width: vm.viewWidth, height: vm.viewHeight, \'margin-left\': -vm.viewWidth/2, \'margin-top\': -vm.viewHeight/2}"><div class="loading-page3" ng-if="vm.loading"><img src="content/images/loading.gif" style="max-width: 100%; max-height: 100%"></div><div id="threeView" ng-show="!vm.loading && !vm.error" style="width: 100%; height: 100%" ng-mouseover="onMouseOver()" ng-mouseout="onMouseOut()"></div></div><style>.modal-content {\n        width: 100%;\n    }</style>');
$templateCache.put('app/entities/components/three-preview1.html','<div ng-style="{width: vm.width, height: vm.height}" style="margin: auto; position: relative"><div class="loading-page3" ng-if="vm.loading"><img src="content/images/loading.gif" style="max-width: 100%; max-height: 100%"></div><div id="threeView1" ng-show="!vm.loading && !vm.error" style="width: 100%; height: 100%" ng-mouseover="onMouseOver()" ng-mouseout="onMouseOut()"></div></div>');
$templateCache.put('app/entities/components/three-preview2.html','<div ng-style="{width: vm.width, height: vm.height}" style="margin: 16px auto 20px; position: relative"><div class="editor-2d-3d-view" ng-if="vm.moulds && vm.moulds.length>0" style="position: absolute;\n    right: 10px;\n    top: 10px;\n    left: unset;\n    bottom: unset;\n    transform: none"><div class="editor-2d-3d-view-btn" ng-class="{\'editor-2d-3d-view-btn-select\':vm.viewTab == \'Two\'}" ng-click="viewTabCb(\'Two\')">2D</div><div>|</div><div class="editor-2d-3d-view-btn" ng-class="{\'editor-2d-3d-view-btn-select\':vm.viewTab == \'Three\'}" ng-click="vm.viewTab = \'Three\'">3D</div></div><div class="swiper-container swiper-container-webmin1" style="height: 100%;background-color: #ececec" ng-if="vm.viewTab == \'Two\'"><div class="swiper-wrapper"><div class="swiper-slide" ng-repeat="mould in vm.moulds track by $index" style="display: flex;align-items: center;justify-content: center"><three-preview-2d index="$index" width="vm.width" height="vm.height" pages="vm.pages" background-img="mould.background" model-data="mould.modelData" model-path="mould.modelPath" model-blendent="mould.modelBlendent" camera-position="mould.cameraPosition" target-position="mould.targetPosition" ng-if="$index == vm.mouldIndex"></three-preview-2d></div></div><div class="swiper-button-next swiper-button-next-webmin1 swiper-button-black"></div><div class="swiper-button-prev swiper-button-prev-webmin1 swiper-button-black"></div></div><div class="swiper-pagination" ng-if="vm.viewTab == \'Two\'"></div><three-preview1 width="vm.width" height="vm.height" model-path="vm.modelPath" model-blendents="vm.modelBlendents" model-blendent-uuid="vm.modelBlendentUuid" model-data="vm.modelData" pages="vm.pages" ng-if="vm.viewTab == \'Three\'"></three-preview1><div class="iconsousuofangda-view" ng-click="previewTab()"><i class="iconfont iconsousuofangda"></i></div></div><div style="height: 1px; width: 100%;box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.5);margin-bottom: 20px"></div><style>.swiper-button-prev{\n        left: 0;\n    }\n    .swiper-button-next{\n        right: 0;\n    }\n    .swiper-button-next.swiper-button-black{\n        background-size: 40%;\n        width: 20px;\n        height: 60px;\n        background-color: #fff;\n        border-radius: 10px 0 0 10px;\n    }\n    .swiper-button-prev.swiper-button-black{\n        background-size: 40%;\n        width: 20px;\n        height: 60px;\n        background-color: #fff;\n        border-radius: 0 10px 10px 0;\n    }\n    .swiper-pagination{\n        width: 100%;\n    }\n    .swiper-pagination span{\n        margin: 0 3px;\n    }\n    .swiper-pagination-bullet-active{\n        background: var(--genericColor);\n    }\n    .iconsousuofangda-view{\n        position: absolute;\n        right: 10px;\n        bottom: 10px;\n        width: 36px;\n        height: 36px;\n        background: rgba(0,0,0,0.5);\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        color: #fff;\n        cursor: pointer;\n        z-index: 10;\n        border-radius: 18px;\n    }</style>');
$templateCache.put('app/entities/components/three-preview3.html','<div class="editor-2d-3d-view" ng-if="vm.moulds && vm.moulds.length>0" style="position: absolute;\n     left: 50%;\n     top: 20px;\n     margin-left: -72px;\n    transform: none"><div class="editor-2d-3d-view-btn" ng-class="{\'editor-2d-3d-view-btn-select\':vm.viewTab == \'Two\'}" ng-click="viewTabCb(\'Two\')">2D</div><div class="editor-2d-3d-view-btn" ng-class="{\'editor-2d-3d-view-btn-select\':vm.viewTab == \'Three\'}" ng-click="vm.viewTab = \'Three\'">3D</div></div><div class="webMax-three-view" ng-if="vm.viewTab == \'Two\'"><div class="webMax-three-view1"><three-preview-2d index="vm.mouldIndex+\'max\'" width="600" height="600" pages="vm.pages" background-img="vm.moulds[vm.mouldIndex].background" model-data="vm.moulds[vm.mouldIndex].modelData" model-path="vm.moulds[vm.mouldIndex].modelPath" model-blendent="vm.moulds[vm.mouldIndex].modelBlendent" camera-position="vm.moulds[vm.mouldIndex].cameraPosition" target-position="vm.moulds[vm.mouldIndex].targetPosition" ng-if="vm.mouldIndex>=0&&vm.isWebMaxThree"></three-preview-2d><div class="webMax-three-view1-prev" ng-click="webMaxSwiper(\'prev\')"><i class="iconfont iconzuoceshouqi"></i></div><div class="webMax-three-view1-next" ng-click="webMaxSwiper(\'next\')"><i class="iconfont iconyouceshouqi"></i></div></div><div class="webMax-three-view2"><div class="swiper-container swiper-container-webmin" style="height: 100%"><div class="swiper-wrapper"><div class="swiper-slide" ng-repeat="mould in vm.moulds track by $index" style="display: flex;align-items: center;justify-content: center;overflow: hidden;border-radius: 12px" ng-click="webMaxSwiper($index)" ng-class="{\'swiper-container-webmin-item\' : vm.mouldIndex == $index}"><img ng-src="{{mould.background | imageFilter}}" alt="" class="c-image"><!--                    <three-preview-2d--><!--                        index="$index+\'min\'"--><!--                        width="107"--><!--                        height="107"--><!--                        pages="vm.pages"--><!--                        background-img="mould.background"--><!--                        model-data="mould.modelData"--><!--                        model-path="mould.modelPath"--><!--                        model-blendent="mould.modelBlendent"--><!--                        camera-position="mould.cameraPosition"--><!--                        target-position="mould.targetPosition"--><!--                        ng-if="$index>=0"--><!--                    ></three-preview-2d>--></div></div></div><div class="swiper-button-next swiper-button-next-webmin"><i class="iconfont iconyouceshouqi"></i></div><div class="swiper-button-prev swiper-button-prev-webmin"><i class="iconfont iconzuoceshouqi"></i></div></div></div><three-preview width="vm.width" height="vm.height" model-path="vm.modelPath" model-blendents="vm.modelBlendents" model-blendent-uuid="vm.modelBlendentUuid" model-data="vm.modelData" pages="vm.pages" ng-if="vm.viewTab == \'Three\'"></three-preview><style>.webMax-three-view{\n        width: 600px;\n        margin: 70px auto;\n    }\n    .webMax-three-view1{\n        position: relative;\n        width: 100%;\n        height: 600px;\n    }\n    .webMax-three-view1-prev{\n        display: none;\n        position: absolute;\n        left: 0;\n        top: 50%;\n        width: 32px;\n        height: 104px;\n        margin-top: -52px;\n        border-radius: 0 12px 12px 0;\n        background: rgba(0,0,0,0.4);\n        color: #fff;\n        justify-content: center;\n        align-items: center;\n        cursor: pointer;\n        z-index: 10;\n    }\n    .webMax-three-view1-next{\n        display: none;\n        position: absolute;\n        right: 0;\n        top: 50%;\n        width: 32px;\n        height: 104px;\n        margin-top: -52px;\n        border-radius: 12px 0 0 12px;\n        background: rgba(0,0,0,0.4);\n        color: #fff;\n        justify-content: center;\n        align-items: center;\n        cursor: pointer;\n        z-index: 10;\n    }\n    .webMax-three-view1:hover .webMax-three-view1-prev, .webMax-three-view1:hover .webMax-three-view1-next{\n        display: flex;\n    }\n    .webMax-three-view2{\n        position: relative;\n        margin-top: 16px;\n        width: 100%;\n        height: 107px;\n    }\n    .swiper-button-next-webmin{\n        position: absolute;\n        right: -60px;\n        top: 50%;\n        width: 48px;\n        height: 48px;\n        background: rgba(0,0,0,0.2);\n        color: #fff;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        cursor: pointer;\n        border-radius: 50%;\n        margin-top: -24px;\n    }\n    .swiper-button-prev-webmin{\n        position: absolute;\n        left: -60px;\n        top: 50%;\n        width: 48px;\n        height: 48px;\n        background: rgba(0,0,0,0.2);\n        color: #fff;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        cursor: pointer;\n        border-radius: 50%;\n        margin-top: -24px;\n    }\n    .swiper-container-webmin-item{\n        border: 1px solid var(--genericColor);\n    }</style>');
$templateCache.put('app/entities/components/three-preview4.html','<div><div class="editor-2d-3d-view" ng-class="{\'editor-2d-3d-view-editor\':vm.source}" ng-if="vm.moulds && vm.moulds.length>0" style="position: fixed;\n    top: 60px;\n    margin-left: -60px;\n    left: 50%;\n    bottom: unset;\n    transform: none"><div class="editor-2d-3d-view-btn" ng-class="{\'editor-2d-3d-view-btn-select\':vm.viewTab == \'Two\'}" ng-click="viewTabCb(\'Two\')">2D</div><div>|</div><div class="editor-2d-3d-view-btn" ng-class="{\'editor-2d-3d-view-btn-select\':vm.viewTab == \'Three\'}" ng-click="vm.viewTab = \'Three\'">3D</div></div><div class="editor-2d-3d-view-1" ng-if="vm.viewTab == \'Two\'"><three-preview-2d index="vm.mouldIndex" width="vm.width" height="vm.height" pages="vm.pages" background-img="vm.moulds[vm.mouldIndex].background" model-data="vm.moulds[vm.mouldIndex].modelData" model-path="vm.moulds[vm.mouldIndex].modelPath" model-blendent="vm.moulds[vm.mouldIndex].modelBlendent" camera-position="vm.moulds[vm.mouldIndex].cameraPosition" target-position="vm.moulds[vm.mouldIndex].targetPosition" ng-if="vm.isLoading&&vm.moulds[vm.mouldIndex]"></three-preview-2d><div class="editor-2d-3d-view-1-1 clearfix"><div class="editor-2d-3d-view-1-1-btn" style="float: left" ng-if="vm.mouldIndex>0" ng-click="flipOver(\'prev\')"><i class="iconfont iconzuoceshouqi"></i> <span>\u4E0A\u4E00\u9875</span></div><div class="editor-2d-3d-view-1-1-btn" style="float: right" ng-if="vm.mouldIndex<vm.moulds.length-1" ng-click="flipOver(\'next\')"><span>\u4E0B\u4E00\u9875</span> <i class="iconfont iconyouceshouqi"></i></div></div><div class="editor-2d-3d-view-1-1-1">{{vm.mouldIndex+1}}/{{vm.moulds.length}}</div></div><three-preview1 width="vm.width" height="vm.height" model-path="vm.modelPath" model-blendents="vm.modelBlendents" model-blendent-uuid="vm.modelBlendentUuid" model-data="vm.modelData" pages="vm.pages" ng-if="vm.viewTab == \'Three\'"></three-preview1></div><style>.editor-2d-3d-view-editor{\n        top: 16px !important;\n    }\n    .iconsousuofangda-view{\n        position: fixed;\n        right: 10px;\n        top: 60px;\n        z-index: 10;\n    }\n    .editor-2d-3d-view-1{\n        position: relative;\n    }\n    .editor-2d-3d-view-1-1{\n        margin-top: 20px;\n        width: 100%;\n        padding: 0 6px;\n        height: 30px;\n    }\n    .editor-2d-3d-view-1-1-btn{\n        height: 20px;\n        display: flex;\n        align-items: center;\n        color: #333333;\n        font-size: 14px;\n    }\n    .editor-2d-3d-view-1-1-btn .iconfont{\n        font-size: 14px;\n    }\n    .editor-2d-3d-view-1-1-1{\n        position: absolute;\n        right: 10px;\n        bottom: 60px;\n        width: 60px;\n        height: 24px;\n        font-size: 12px;\n        background: rgba(0,0,0,0.5);\n        border-radius: 12px;\n        color: #fff;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }</style>');
$templateCache.put('app/entities/components/trimbox-pop.html','<div class="trimbox-pop" ng-if="vm.isTrimbox"><div class="trimbox-pop-title">\u91CD\u8981\u63D0\u793A</div><div class="trimbox-pop-title1">\u56E0\u751F\u4EA7\u65F6\u9700\u8981\u5728<span class="color-108DFE">\u84DD\u8272\u865A\u7EBF</span>\u8FDB\u884C\u88C1\u5207\uFF0C\u5F3A\u70C8\u8981\u6C42\u4F60\u5728\u8BBE\u8BA1\u65F6\uFF1A</div><div class="trimbox-pop-view1"><div class="trimbox-pop-view1-text"><div class="trimbox-pop-view1-text-1">\u4F5C\u4E3A\u80CC\u666F\u7D20\u6750\u8BF7\u94FA\u6EE1\u6574\u4E2A\u8BBE\u8BA1\u533A\u57DF\uFF0C\u5426\u5219\u88C1\u5207\u65F6\u53EF\u80FD\u7559\u6709\u767D\u8FB9</div><div class="trimbox-pop-view1-text-2"><i class="iconfont iconzuoceshouqi11"></i> <span>\u6548\u679C\u89C1\u53F3\u56FE <span class="iconfont iconyouceshouqi1"></span></span></div></div><div class="trimbox-pop-view1-img"><img src="content/images/trimbox-img.png" alt=""></div></div><div class="trimbox-pop-border"></div><div class="trimbox-pop-view1"><div class="trimbox-pop-view1-text"><div class="trimbox-pop-view1-text-1">\u91CD\u8981\u56FE\u7247\u6216\u6587\u5B57\uFF0C\u8BF7\u4E0D\u8981\u4E0E<span class="color-108DFE">\u84DD\u8272\u865A\u7EBF</span>\u8D34\u592A\u8FD1\uFF0C\u5426\u5219\u53EF\u80FD\u4F1A\u88AB\u88C1\u5207\u6389</div><div class="trimbox-pop-view1-text-2"><i class="iconfont iconzuoceshouqi11"></i> <span>\u6548\u679C\u89C1\u53F3\u56FE <span class="iconfont iconyouceshouqi1"></span></span></div></div><div class="trimbox-pop-view1-img"><img src="content/images/trimbox-img-1.png" alt=""></div></div><div class="trimbox-pop-view2"><div class="trimbox-pop-view2-fl" ng-click="checkbox()"><span class="iconfont iconunpress" ng-if="!vm.checkbox"></span> <span class="iconfont iconcheckbox" ng-if="vm.checkbox"></span> <span>\u4E0D\u518D\u63D0\u793A</span></div><div class="trimbox-pop-view2-fr" ng-click="save()">\u77E5\u9053\u4E86</div></div></div><style>.trimbox-pop{\n        position: absolute;\n        top: 68px;\n        right: 30px;\n        width: 260px;\n        height: 413px;\n        background: #F9FDFF;\n        box-shadow: 0px 2px 6px 0px rgba(16,141,254,0.2);\n        border-radius: 4px;\n        border: 1px solid #9BCCF9;\n        z-index: 400;\n    }\n    .trimbox-pop-title{\n        padding: 16px;\n        height: 25px;\n        font-size: 18px;\n        font-family: PingFangSC-Medium, PingFang SC;\n        font-weight: 500;\n        color: #333333;\n        line-height: 25px;\n    }\n    .trimbox-pop-title1{\n        padding: 0 16px;\n        margin-top: 16px;\n        margin-bottom: 18px;\n        height: 40px;\n        font-size: 14px;\n        font-family: PingFangSC-Regular, PingFang SC;\n        font-weight: 400;\n        color: #666666;\n        line-height: 20px;\n    }\n    .trimbox-pop-view1{\n        margin-top: 18px;\n        padding: 0 12px;\n        display: flex;\n    }\n    .trimbox-pop-view1-img{\n        width: 80px;\n        height: 98px;\n    }\n    .trimbox-pop-view1-img img{\n        width: 100%;\n    }\n    .trimbox-pop-view1-text{\n        width: 142px;\n        margin-left: 10px;\n    }\n    .trimbox-pop-view1-text-1{\n        height: 51px;\n        font-size: 12px;\n        font-family: PingFangSC-Regular, PingFang SC;\n        font-weight: 400;\n        color: #666666;\n        line-height: 17px;\n    }\n    .trimbox-pop-view1-text-2{\n        margin-top: 20px;\n        height: 17px;\n        font-size: 12px;\n        font-family: PingFangSC-Regular, PingFang SC;\n        font-weight: 400;\n        color: #999999;\n        line-height: 17px;\n        display: flex;\n        align-items: center;\n    }\n    .trimbox-pop-view1-text-2 .iconfont{\n        font-size: 12px;\n        color: #999999;\n    }\n    .trimbox-pop-border{\n        width: calc(100% - 30px);\n        margin: 15px auto;\n        height: 1px;\n        border-bottom: 1px dotted #B8C7DB;\n    }\n    .trimbox-pop-view2{\n        margin-top: 18px;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding: 16px;\n    }\n    .trimbox-pop-view2-fl{\n        display: flex;\n        align-items: center;\n        color: #666666;\n        font-size: 12px;\n        cursor: pointer;\n    }\n    .trimbox-pop-view2-fl .iconfont{\n        height: 16px;\n        margin-right: 3px;\n    }\n    .trimbox-pop-view2-fl span{\n        line-height: 17px;\n    }\n    .trimbox-pop-view2-fr{\n        width: 96px;\n        height: 32px;\n        background: var(--genericColor);\n        border-radius: 16px;\n        color: #fff;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        cursor: pointer;\n    }\n    .iconcheckbox{\n        color: var(--genericColor);\n    }\n    .color-108DFE{\n        color: #108DFE;\n    }</style>');
$templateCache.put('app/entities/page/articles-failure.html','<div class="page-404"><img class="img-404" src="content/images/worksNull.png"><p class="tips">\u4F5C\u54C1\u5DF2\u5931\u6548</p></div><style>.page-404{\n    width: 100vw;\n    height: 100vh;\n    background: #FFFFFF;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    padding-bottom: 150px;\n}\n.page-404 .img-404{\n    width: 413px;\n    margin-bottom: 48px;\n}\n.page-404 .tips{\n    font-size: 18px;\n    color: #545454;\n}\n@media screen and (max-width: 750px) {\n    .page-404 .img-404{\n        width: 50%;\n        margin-bottom: 48px;\n    }\n}</style>');
$templateCache.put('app/entities/page/editor-photo-album.html','<div class="c-modal exit-box" ng-if="vm.saveSure" data-html2canvas-ignore><div class="exit-box-mask"></div><div class="exit-box-con" style="width: 528px; height: 240px"><div class="col-lg-12 col-sm-12 exit-box-con-head" style="border: none"><span class="col-md-6 col-sm-6 col-xs-6 text-left" style="font-weight: 500; font-size: 18px">{{\'button.save\' | translate}}</span> <span class="col-md-6 col-sm-6 col-xs-6 text-right"><img src="content/images/icons/close1.svg" style="width: 16px" ng-click="vm.saveSure = false"></span></div><div class="col-lg-12 col-sm-12" style="height: 70px;line-height: 50px;font-size: 16px; background: #fff;text-align: left">{{\'editorPop.saveSure\' | translate}}</div><div class="col-lg-12 col-sm-12" style="background: #fff; text-align: right; padding: 15px"><button ng-click="vm.saveSure = false" style="background-color: #F7F8FA;font-size: 15px; height: 40px;  padding: 5px 10px; border-radius: 6px; width: 96px; color: #333333; margin-right: 15px">{{\'button.cancel\' | translate}}</button> <button ng-click="saveClick()" class="main-button-color" style="font-size: 15px; height: 40px;  padding: 5px 10px; border-radius: 6px; width: 96px; color: #fff !important" ng-disabled="editForm.$invalid || vm.isSaving">{{\'button.confirm\' | translate}}</button></div></div></div><div class="c-view" ng-show="template" data-html2canvas-ignore style="min-width:1300px"><div class="editor-head" style="width: 100%"><div class="editor-head-1"><div class="editor-logo"><img ng-src="{{vm.logo}}"></div><div class="editor-title" uib-tooltip="{{vm.productXmlLine.name}}" tooltip-placement="bottom-left">{{vm.productTitle}}\uFF08 {{vm.productXmlLine.name}} \uFF09</div><div class="editor-heda-btn-view"><button class="web-rollback-undo tool-bar-btn" ng-click="rollback()" ng-class="{\'tool-bar-btn-select\' : vm.cookieIndex > 0}" ng-disabled="vm.cookieIndex == 0" style="background: none"><i class="icon iconfont iconchexiao" ng-style="{cursor:vm.cookieIndex == 0?\'not-allowed\':\'pointer\'}"></i><div class="tip">{{\'editorBtn.revocation\' | translate}}</div></button> <button class="web-rollback-redo tool-bar-btn" ng-click="xmlNextStep()" ng-class="{\'tool-bar-btn-select\' : vm.cookieIndex > 0}" ng-disabled="vm.cookieIndex == 0" style="background: none"><i class="icon iconfont iconhuifu" ng-style="{cursor:vm.cookieIndex == 0?\'not-allowed\':\'pointer\'}"></i><div class="tip">{{\'editorBtn.recover\' | translate}}</div></button> <span style="margin: 0 10px;line-height: 44px;opacity: 0.14">|</span> <button class="nav-lock tool-bar-btn tool-bar-btn-select" ng-click="toggleFullScreen()" style="background: none;cursor: pointer"><i class="icon iconfont" style="cursor: pointer" ng-class="{\'iconcaozuo-quanping-shousuo\':vm.fullFlag,\'iconquanping\':!vm.fullFlag}"></i><div class="tip">{{\'editorBtn.full\' | translate}}</div></button> <span style="margin: 0 10px;line-height: 44px;opacity: 0.14">|</span><div class="nav-lock c-btn-view" ng-click="$event.stopPropagation(); vm.showMoreOperationMenu = !vm.showMoreOperationMenu; vm.showRulerGuideMenu = false; vm.showlagnuages = false"><i class="icon iconfont iconquanbu"></i><div class="tip" ng-show="!vm.showMoreOperationMenu">{{\'editorBtn.moreOperations\' | translate}}</div><div class="more-operation-mask" ng-show="vm.showMoreOperationMenu" ng-click="$event.stopPropagation(); vm.showMoreOperationMenu = false"></div><div class="more-operation-menu" ng-show="vm.showMoreOperationMenu" ng-click="$event.stopPropagation()"><div class="more-operation-item more-operation-ruler" ng-mouseenter="vm.showRulerGuideMenu = true" ng-mouseleave="vm.showRulerGuideMenu = false"><span>{{\'editorBtn.rulerGuide\' | translate}}</span> <span class="more-operation-arrow">\u203A</span><div class="more-operation-submenu" ng-show="vm.showRulerGuideMenu"><div class="more-operation-item" ng-click="vm.staff = !vm.staff; vm.showMoreOperationMenu = false"><span>{{\'editorBtn.showRulerGuide\' | translate}}</span> <span class="more-operation-check" ng-show="vm.staff">\u2713</span></div><div class="more-operation-item" ng-click="addLineReference(); vm.showMoreOperationMenu = false">{{\'editorBtn.newGuide\' | translate}}</div></div></div><div class="more-operation-item" ng-show="vm.lagnuages.length>1" ng-mouseenter="vm.showlagnuages = true" ng-mouseleave="vm.showlagnuages = false"><span>{{\'editorBtn.language\' | translate}}</span> <span class="more-operation-arrow">\u203A</span><div class="more-operation-submenu" ng-show="vm.showlagnuages"><div class="more-operation-item" ng-repeat="lang in vm.lagnuages" ng-click="changeLagnuage(lang)"><span>{{lang.key}}</span> <span class="more-operation-check" ng-show="lang.selected">\u2713</span></div></div></div></div></div><div class="c-btn" style="margin-left:10px" ng-click="vm.isCalendar1 = true;" ng-if="template && template.config && template.config.productType == \'CALENDAR\' && template.config.dynamic"><i class="icon iconfont iconrili"></i>{{\'editorBtn.dateAdjustment\' | translate}}</div></div></div><div class="page-head-save" style="line-height: 36px"><span class="save-xml1 tool-bar-btn-select2" ng-click="previewTab($event)" role="button" tabindex="0"><i class="iconfont iconyulan1"></i> <i>{{\'button.preview\' | translate}}</i></span> <span class="save-xml1 tool-bar-btn-select2" ng-click="exitWork($event)" role="button" tabindex="0"><i class="iconfont icontuichu"></i> <i>{{\'button.retreat\' | translate}}</i></span> <span class="save-exit save-exit1" ng-click="immediateSave($event)" role="button" tabindex="0">{{\'button.forthwithSave\' | translate}}</span> <span class="save-release" ng-click="save($event)" role="button" tabindex="0">{{\'button.save3\' | translate}}</span></div></div><div style="width: 100%;position: relative;height: calc(100vh - 56px)"><div class="editor-nav scrollbar" style="position: absolute;top: 0"><ul><li ng-class="{\'leftPanel-photo-active\':vm.nav==\'picture\'}" ng-click="vm.navSelect(\'picture\')"><i class="icon iconfont iconzhaopian"></i> <span>{{\'nav.photograph.title\' | translate}}</span><!--                <div class="leftPanel-border"></div>--></li><li ng-class="{\'leftPanel-photo-active\':vm.nav==\'rahmen\'}" ng-click="vm.navSelect(\'rahmen\')"><i class="icon iconfont iconxiangkuang1"></i> <span>{{\'nav.mask.title\' | translate}}</span><!--                <div class="leftPanel-border"></div>--></li><li ng-class="{\'leftPanel-photo-active\':vm.nav==\'border\'}" ng-click="vm.navSelect(\'border\')" ng-if="vm.borderLabels && vm.borderLabels.length > 0"><i class="icon iconfont iconbiankuang1"></i> <span>{{\'nav.border.title\' | translate}}</span><!--                <div class="leftPanel-border"></div>--></li><li ng-class="{\'leftPanel-photo-active\':vm.nav==\'material\'}" ng-click="vm.navSelect(\'material\')"><i class="icon iconfont iconsucai"></i> <span>{{\'nav.material.title\' | translate}}</span><!--                <div class="leftPanel-border"></div>--></li><li ng-class="{\'leftPanel-photo-active\':vm.nav==\'text\'}" ng-click="vm.navSelect(\'text\')"><i class="icon iconfont iconwenben"></i> <span>{{\'nav.text.title\' | translate}}</span><!--                <div class="leftPanel-border"></div>--></li><!--            <li class="leftPanel-page" ng-class="{\'leftPanel-photo-active\':vm.nav==\'page\'}" ng-click="vm.navSelect(\'page\')">--><!--                <span>\u7248\u5F0F</span>--><!--                <div class="leftPanel-border"></div>--><!--            </li>--><li ng-class="{\'leftPanel-photo-active\':vm.nav==\'bgImg\'}" ng-click="vm.navSelect(\'bgImg\')"><i class="icon iconfont iconbeijing"></i> <span>{{\'nav.background.title\' | translate}}</span><!--                <div class="leftPanel-border"></div>--></li><li ng-class="{\'leftPanel-photo-active\':vm.nav==\'template\'}" ng-click="vm.navSelect(\'template\')"><i class="icon iconfont iconhuanshu"></i> <span>{{\'nav.template.title\' | translate}}</span><!--                <div class="leftPanel-border"></div>--></li><li ng-class="{\'leftPanel-photo-active\':vm.nav==\'reserve\'}" ng-click="vm.navSelect(\'reserve\')" ng-if="vm.article.editorType != \'POSTER\' && vm.article.editorType != \'DIY_EDITOR\' && template.replace && vm.isReservePage"><i class="icon iconfont iconbanshi"></i> <span>{{\'nav.reserve.title\' | translate}}</span><!--                <div class="leftPanel-border"></div>--></li><li ng-class="{\'leftPanel-photo-active\':vm.nav==\'qrcode\'}" ng-click="vm.navSelect(\'qrcode\')" ng-if="vm.article.editorType != \'POSTER\' && vm.article.editorType != \'DIY_EDITOR\' && vm.product.isCode"><i class="icon iconfont iconerweima1"></i> <span>{{\'nav.qrcode.title\' | translate}}</span><!--                <div class="leftPanel-border"></div>--></li><li ng-class="{\'leftPanel-photo-active\':vm.nav==\'layout\'}" ng-click="vm.navSelect(\'layout\')" ng-if="vm.article.editorType != \'POSTER\' && vm.article.editorType != \'DIY_EDITOR\' && vm.picLayoutXmlGroup && vm.picLayoutXmlGroup.data && vm.picLayoutXmlGroup.data.length>0"><i class="icon iconfont iconbujufangshi"></i> <span>{{\'nav.layout.title\' | translate}}</span><!--                <div class="leftPanel-border"></div>--></li><li ng-class="{\'leftPanel-photo-active\':vm.nav==\'variableData\'}" ng-click="vm.navSelect(\'variableData\')" ng-if="vm.article.editorType != \'POSTER\' && vm.article.editorType != \'DIY_EDITOR\' && vm.isVariable"><i class="icon iconfont iconkebianshuju"></i> <span>{{\'nav.variableData.title\' | translate}}</span><!--                <div class="leftPanel-border"></div>--></li></ul></div><div class="editor-nav-view" ng-style="{\'width\':vm.leftShow ? \'\' : \'0\'}" id="navId" style="position: absolute;top: 0"><div class="editor-nav-view-li" ng-show="vm.nav==\'picture\'"><div class="editor-nav-view-li-title"><div class="editor-nav-view-li-title-left">{{\'nav.photograph.content.photo\' | translate}} <i class="iconfont icon31yiwen photo-query"><div class="photo-name-operate-div"><div class="photo-name-operate" style="font-size: 12px;width: 200px"><div>{{\'nav.photograph.content.photoHint\' | translate}}</div></div></div></i></div><div class="editor-nav-view-li-title-right" ng-show="!vm.folderId" ng-click="addFolder()">{{\'nav.photograph.content.btn.addPhotoAlbum\' | translate}}</div></div><div class="folder-view" style="padding: 0" ng-show="vm.folderId == \'\'"><ul class="clearfix folderUl" style="padding: 0"><li ng-click="showFolderContent()"><div><img class="folderUl-img" src="content/images/icon/photo_has.png" alt=""> <span class="folderUl-text">{{\'nav.photograph.content.folders.name\' | translate}}</span></div></li><li ng-repeat="folder in Folders track by $index" ng-if="$index<5 || vm.folderShow" ng-click="showFolderContent(folder)"><div><img class="folderUl-img" src="content/images/icon/web_folder.png" alt=""> <span class="folderUl-text">{{folder.name}}</span> <img class="folderUl-sel" src="content/images/icons/folder_sel.svg" ng-if="vm.folderId == folder.id"><div class="folderUl-delete"><img src="content/images/icon/genduo.png" alt=""><div class="photo-name-operate-div2" style="width:96px !important"><div class="photo-name-operate"><div ng-click="deleteShow(folder.id,$event)">{{\'button.delete\' | translate}}</div><div ng-click="updateFloders(folder,$event)">{{\'button.ren\' | translate}}</div></div></div></div></div></li></ul><button type="button" class="folder-down" ng-click="folderOn()" ng-if="Folders.length>5 && !vm.folderShow">{{\'button.spread\' | translate}} <i class="iconfont iconxia"></i></button> <button type="button" class="folder-down1" ng-click="folderOn()" ng-if="Folders.length>5 && vm.folderShow">{{\'button.packUp\' | translate}} <i class="iconfont iconshang"></i></button></div><div class="folder-content-title" ng-show="vm.folderId != \'\'"><div class="folder-content-title-title"><i class="iconfont iconchangyongicon-" style="font-size: 20px"></i> <span style="margin-left: 10px">{{vm.folderName}}</span></div><span class="iconfont iconguanbi1" ng-click="showFolderContent()"></span></div><div class="editor-nav-view-li-web-local-photo"><button class="borderTheme opacityMinus web-local-photo" ng-click="uploadPic()"><span class="categoryPrice"><i class="iconfont iconyunshangchuan_o"></i> {{\'nav.photograph.content.btn.upload\' | translate}}</span> <input onchange="updatePic(event)" onclick="event.stopPropagation()" id="uploadImg2" type="file" multiple="multiple" accept="{{vm.supportedMimeTypes}}" name="file" value=""></button> <button class="web-local-photo" ng-click="uploadByPhone()"><span class="categoryPrice"><i class="iconfont iconshouji"></i> {{\'nav.photograph.content.btn.mobileUpload\' | translate}}</span></button></div><!-- <div class="">\n                    <span class="web-photo-btn" ng-click="showFolderContent()">\n                        <img src="content/images/icons/photo_has.svg">\u5DF2\u9009\u7167\u7247\n                    </span>\n                    <span class="web-photo-btn" ng-click="addFolder()">\n                        <img src="content/images/icons/folder_create.svg">\u65B0\u5EFA\u6587\u4EF6\u5939\n                    </span>\n                </div> --><div class="editor-nav-view-li-1"><div class="web-photo-nav"><div ng-class="{\'web-nav-active\':vm.photosTab==\'all\'}" ng-click="switchBgTab(\'all\')">{{\'nav.photograph.content.btn.allPhotos\' | translate}}</div><div ng-class="{\'web-nav-active\':vm.photosTab!=\'all\'}" ng-click="switchBgTab()">{{\'nav.photograph.content.btn.unused\' | translate}} <span style="font-size: 12px" ng-if="vm.unusedQuantity">\uFF08{{vm.unusedQuantity}}\uFF09</span></div></div><div class="editor-nav-view-li-seq2"><div class="editor-nav-view-li-seq2-left" style="margin-right: 8px"><img src="content/images/icon/refresh.png" style="width: 16px" ng-click="vm.refreshPhotos()" uib-tooltip="{{\'nav.photograph.content.btn.refresh\' | translate}}" alt=""></div><div class="editor-nav-view-li-seq2-left" style="margin-right: 8px"><img src="content/images/icon/photoName.png" style="width: 18px" alt="" srcset="" ng-if="vm.isWatchName"> <img src="content/images/icon/photoName2.png" style="width: 18px" alt="" srcset="" ng-if="!vm.isWatchName"><div class="photo-name-operate-div2"><div class="photo-name-operate"><div ng-click="watchGalleryName(false)" ng-class="{\'photo-name-operate-active\':!vm.isWatchName}">{{\'nav.photograph.content.btn.photoName.hide\' | translate}}</div><div ng-click="watchGalleryName(true)" ng-class="{\'photo-name-operate-active\':vm.isWatchName}">{{\'nav.photograph.content.btn.photoName.show\' | translate}}</div></div></div></div><div class="editor-nav-view-li-seq2-right"><img src="content/images/icon/photoSeq.png" style="width: 18px" alt=""><div class="photo-name-operate-div2" style="right: 16px;bottom: 15px"><div class="photo-name-operate"><div ng-class="{\'photo-name-operate-active\':vm.photoSort == 1}" ng-click="photoSortChange(\'1\')">{{\'nav.photograph.content.btn.seq.time\' | translate}}</div><div ng-class="{\'photo-name-operate-active\':vm.photoSort == 2}" ng-click="photoSortChange(\'2\')">{{\'nav.photograph.content.btn.seq.nameUp\' | translate}}</div><div ng-class="{\'photo-name-operate-active\':vm.photoSort == 3}" ng-click="photoSortChange(\'3\')">{{\'nav.photograph.content.btn.seq.nameBelow\' | translate}}</div></div></div></div></div></div><div class="editor-nav-view-li-2" style="padding-bottom:120px"><div class="editor-nav-view-li-2-loading-mask" ng-if="vm.refreshing"><img src="content/images/icons/loading-pic.gif"></div><!-- <p>\u53EF\u62D6\u5165\u6216\u70B9\u51FB\u56FE\u7247\u64CD\u4F5C</p> --><ul class="clearfix"><li ng-repeat="photo in photos track by $index" ng-if="vm.photosTab==\'all\' || vm.photosTab!=\'all\'&&photo.usenum==0" ng-click="choosePhoto(photo, $event)"><div class="editor-nav-view-li-2-view"><img class="editor-nav-view-li-2-view-img" ng-if="photo.identifier && photoStatus(photo) == \'\'" ng-src="{{ !isLarge(photo.imageInfo) ? photo.identifier + \'?imageMogr2/auto-orient/thumbnail/!20p\' : photo.identifier + \'.thumbnail.jpg\'}}" draggable="true" ondragstart="dragStart(event)" ondragend="dragOn(event)" id="dragtargetPhoto{{$index}}" data-index="{{$index}}" data-item="{{photo}}" style="overflow: inherit;z-index: 9999"><div class="editor-nav-view-li-2-view-status" ng-if="photo.identifier && photoStatus(photo) != \'\'" ng-class="{\'is-failed\': isPhotoFailed(photo)}" ng-click="isPhotoFailed(photo) ? showDeletePhotoPop(photo, $event) : null"><img class="editor-nav-view-li-2-view-placeholder" src="content/images/placeholderImage.png" alt=""><div class="editor-nav-view-li-2-view-status-mask"><img class="editor-nav-view-li-2-view-status-icon" ng-if="photoStatus(photo) == \'largeError\' || photoStatus(photo) == \'convertError\'" src="content/images/close1.png" alt=""> <img class="editor-nav-view-li-2-view-status-icon" ng-if="photoStatus(photo) == \'convertRunning\' || photoStatus(photo) == \'largeRunning\'" src="content/images/loading1.png" alt=""> <span class="editor-nav-view-li-2-view-status-text">{{(\'nav.photograph.content.status.\' + photoStatus(photo)) | translate}}</span></div></div><div class="editor-nav-view-li-2-view-refresh-mask" ng-if="(photo.largeFlag && photo.largeStatus == \'running\') || (photo.convertFlag && photo.convertStatus == \'running\')" ng-click="vm.refreshPhotos(); $event.stopPropagation();"><span style="display: inline-block; transform: translateY(16px)">{{\'nav.photograph.content.btn.refresh\' | translate}}</span></div><img class="editor-nav-view-li-2-view-img1" src="content/images/icons/editor_select.png" alt="" ng-show="photo.select"> <img class="editor-nav-view-li-2-view-img2" src="content/images/icons/editor_unchecked.png" alt="" ng-if="isPhotoSelectable(photo)" ng-style="{\'display\':( !photo.select && gallaryPic.length>0 ) ? \'block\' : \'\'}"> <span class="editor-nav-view-li-2-view-value" ng-if="photo.usenum">{{photo.usenum}}</span><!--                                <div class="imgSizeWarn" ng-if="photo.imgSize < vm.imgSize * 1024">--><!--                                    <i class="iconfont iconjinggao" style="height: 25px;line-height: 25px;"></i>--><!--                                    <div class="imgSizeWarn-text" style="height: 25px;line-height: 25px;">{{\'nav.photograph.content.pictogram\' | translate}}</div>--><!--                                </div>--><div class="c-imagebox-warn" ng-if="photo.imgSize < vm.imgSize * 1024" style="border-radius: 0px 0px 10px 0px"><i class="icon iconfont iconwaring imageboxWarn"></i> <span class="ng-binding">{{\'nav.photograph.content.pictogram\' | translate}}</span></div></div><div class="text-ellipsis font-12 mar-top-10" style="color: #FFFFFF" ng-if="vm.isWatchName" uib-tooltip="{{photo.name}}" tooltip-placement="top">{{photo.name}}</div></li></ul><!-- <button type="button"  class="load-more-btn" ng-if="!vm.isPhotoFinish" ng-click="photoCb()">{{\'button.loadMore\' | translate}}</button> --><div class="default-diagram" ng-show="(photos.length == 0 && !vm.picLoading && vm.photosTab == \'all\') || (vm.photosTab!=\'all\' && vm.unUsedImageboxsNum == 0 && !vm.picLoading)"><img src="content/images/default-diagram.png"><div>{{\'hint.noData\' | translate}}</div></div><div class="no-more" ng-if="vm.isPhotoFinish && !vm.picLoading && ((vm.photosTab == \'all\' && photos.length > 0) || (vm.photosTab != \'all\' && vm.unUsedImageboxsNum > 0))">{{\'hint.noMore\' | translate}}</div><div class="web-photo-choose"><div class="web-photo-choose-top"><div class="web-photo-choose-top-left" ng-if="vm.photosTab==\'all\'" translate="nav.photograph.content.selected" translate-values="{gallaryPic:(gallaryPic ? gallaryPic.length : 0),totalPhotoItems:vm.totalPhotoItems}"></div><div class="web-photo-choose-top-left" ng-if="vm.photosTab!==\'all\'" translate="nav.photograph.content.selected" translate-values="{gallaryPic:(gallaryPic ? gallaryPic.length : 0),totalPhotoItems:vm.unusedQuantity}"></div><div class="web-photo-choose-top-right"><span ng-click="whetherChoose(true)">{{\'nav.photograph.content.btn.selectAll\' | translate}}</span> <span ng-click="whetherChoose(false)" ng-if="gallaryPic.length">{{\'nav.photograph.content.btn.cancelSelect\' | translate}}</span></div></div><div class="web-photo-choose-bottom"><div class="web-photo-choose-bottom-left" ng-if="gallaryPic.length"><!-- <img src="content/images/icon/move_folder.png" width="15" height="15" style="cursor: pointer" ng-click="moveToFolder()">\n                                <img class="web-photo-del" src="content/images/icon/editor_delete.png" width="15" height="15" ng-click="deleteBatchPhotos()"> --> <i class="iconfont iconmove_folder" uib-tooltip="{{\'nav.photograph.content.btn.move\' | translate}}" tooltip-placement="top" ng-click="moveToFolder()"></i> <i class="iconfont icondustbin_icon" uib-tooltip="{{\'button.delete\' | translate}}" tooltip-placement="top" ng-click="deleteBatchPhotos()"></i></div><div class="web-photo-choose-bottom-left" ng-if="!gallaryPic.length">{{\'editorPop.selectPhoto.msg\' | translate}}</div><div class="web-choose-set1"><div class="web-choose-set1-btn" ng-click="directFill()">{{\'nav.photograph.content.btn.fill\' | translate}}</div><div class="web-choose-set1-hr"></div><div class="web-choose-set1-icon" ng-mouseenter="showChooseMenu($event)" ng-mouseleave="hideChooseMenu()"><i class="iconfont icongengduo" style="transform: rotate(90deg);font-size: 22px"></i></div></div></div></div></div><div class="pic-loading1" ng-if="vm.picLoading && !vm.refreshing"><div class="load-mask" style="display: flex; justify-content: center; align-items: center"><img src="content/images/icons/loading-pic.gif"></div></div><div class="errorAlertPopup" ng-if="vm.errorAlertPopup"><div class="errorAlertPopupLeft"><span class="iconfont iconjinggao1"></span> <span class="contentText">{{vm.uploadFailedList.length}}\u5F20\u56FE\u7247\u4E0A\u4F20\u5931\u8D25</span> <span class="view" ng-click="errorPhotoView()">\u67E5\u770B</span></div><span class="iconfont iconguanbi1 errorAlertPopupClose" ng-click="errorAlertPopupClose()"></span></div></div><div class="editor-nav-view-li" ng-show="vm.nav==\'rahmen\'"><div class="c-mask-tab"><span ng-class="{\'c-mask-tab-select\' : vm.maskType == \'recommend\'}" ng-click="vm.maskType = \'recommend\'">{{\'nav.mask.content.tab1\' | translate}}</span> <span ng-class="{\'c-mask-tab-select\' : vm.maskType == \'general\'}" ng-click="vm.maskType = \'general\'">{{\'nav.mask.content.tab2\' | translate}}</span></div><div ng-show="vm.maskType == \'recommend\'"><div class="leftPanel-head" style="padding: 10px 8px 0"><div class="leftPanel-privacy mar-bottom-10"><button ng-repeat="label in vm.masklabels track by $index" ng-click="vm.masklabelCb(label,$index)" data-index="{{$index}}" class="leftPanel-privacy-btn" ng-show="$index<8||showMaskLabels" ng-class="{\'genericColor\':label.id==vm.masklabelChooseId.id}">{{label.name}}</button><div class="col-md-12 col-sm-12 col-xs-12" ng-if="vm.masklabels.length >8"><div class="icon-drop-down outline" ng-if="!showMaskLabels" ng-click="showMoreMaskLabels()">{{\'button.spread\' | translate}}</div><div class="icon-retract outline" ng-if="showMaskLabels" ng-click="showMoreMaskLabels()">{{\'button.packUp\' | translate}}</div></div></div></div><div class="nav-mask"><img src="content/images/icons/loading01.gif" class="nav-mask-loading" ng-show="vm.maskLoading"><ul ng-hide="vm.maskLoading"><li ng-repeat="mask in vm.maskList track by $index" data-index="{{$index}}"><div class="nav-mask-div" style="width: 100%;height: 100%; display: flex; justify-content: center; align-items: center; background: #333437;padding: 5px"><img ng-src="{{mask.identifier}}?imageMogr2/thumbnail/200x200>" alt="" style="max-width: 100%; max-height: 100%" draggable="true" ondragstart="dragStart(event)" ondragend="dragOn(event)" id="dragtargetMask{{$index}}" data-index="{{$index}}" data-item="{{mask}}"></div></li></ul><button class="load-more" style="bottom:10px" ng-if="vm.masklabelsFulfill" ng-click="loadMoreMasks()">{{\'button.loadMore\' | translate}}</button><div class="default-diagram" ng-show="vm.maskList.length == 0 && !vm.maskLoading"><img src="content/images/default-diagram.png"><div>{{\'hint.noData\' | translate}}</div></div><div class="text-center" ng-if="!vm.masklabelsFulfill && vm.maskList.length>0&& !vm.maskLoading"><span class="tip-text">{{\'hint.noMore\' | translate}}</span></div></div></div><div ng-if="vm.maskType == \'general\'"><div class="c-mask-general"><div class="" style="padding:5px" ng-repeat="mask in vm.generalMask"><div class="c-mask-general-li"><img ng-src="{{mask.identifier}}?imageMogr2/thumbnail/200x200>" draggable="true" ondragstart="dragStart(event)" ondragend="dragOn(event)" id="{{mask.type1 == \'round\' ? \'dragtargetMaskRound\' : \'dragtargetMaskRectangle\'}}" data-index="{{$index}}" data-item="{{mask}}"></div></div></div></div></div><div class="editor-nav-view-li" ng-show="vm.nav==\'material\'"><div class="leftPanel-head" style="padding: 10px 8px 0"><div class="leftPanel-privacy mar-bottom-10"><button ng-repeat="label in vm.clipArts track by $index" ng-click="vm.clipArtCb(label,$index)" data-index="{{$index}}" class="leftPanel-privacy-btn" ng-show="$index<8||showMaskLabels" ng-class="{\'genericColor\':label.id==vm.clipArtChooseId.id}">{{label.name}}</button><div class="col-md-12 col-sm-12 col-xs-12" ng-if="vm.clipArts.length >8"><div class="icon-drop-down outline" ng-if="!showMaskLabels" ng-click="showMoreMaskLabels()">{{\'button.spread\' | translate}}</div><div class="icon-retract outline" ng-if="showMaskLabels" ng-click="showMoreMaskLabels()">{{\'button.packUp\' | translate}}</div></div></div></div><div class="nav-mask"><img src="content/images/icons/loading01.gif" class="nav-mask-loading" ng-show="vm.clipArtLoading"><ul id="main2" ng-hide="vm.clipArtLoading"><li ng-repeat="item in vm.clipArtsList track by $index" data-index="{{$index}}" ng-click="materialCb(item)"><div class="nav-mask-div" style="line-height: 100px; text-align: center"><img ng-src="{{item.identifier}}?imageMogr2/thumbnail/200x200>" data-art="{{clipArt.identifier}}" draggable="true" ondragstart="dragStart(event)" ondragend="dragOn(event)" id="dragtargetClipArt{{$index}}" data-index="{{$index}}" style="max-width: 100%; max-height: 100%"></div></li></ul><button class="load-more" style="bottom:10px" ng-if="vm.clipArtFulfill" ng-click="loadMoreClipArt()">{{\'button.loadMore\' | translate}}</button><div class="default-diagram" ng-show="vm.clipArtsList.length == 0 && !vm.clipArtLoading"><img src="content/images/default-diagram.png"><div>{{\'hint.noData\' | translate}}</div></div><div class="text-center" ng-if="!vm.clipArtFulfill && vm.clipArtsList.length > 0 && !vm.clipArtLoading"><span class="tip-text">{{\'hint.noMore\' | translate}}</span></div></div></div><div class="editor-nav-view-li" ng-show="vm.nav==\'text\'"><div class="leftPanel-head text-size-center" style="padding-bottom:20px"><div class="text-size-24" ng-click="addText(24)" role="button" tabindex="0">{{\'editorCommon.addTextbox\' | translate}}</div><div class="text-size-20" ng-click="addText(20)" role="button" tabindex="0">{{\'editorCommon.addTextbox1\' | translate}}</div><div class="text-size-16" ng-click="addText(16)" role="button" tabindex="0">{{\'editorCommon.addTextbox2\' | translate}}</div></div><div class="leftPanel-head" style="padding: 0 8px 0"><div class="leftPanel-privacy mar-bottom-10"><button ng-repeat="label in vm.fontlabels track by $index" ng-click="vm.fontlabelCb(label,$index)" data-index="{{$index}}" class="leftPanel-privacy-btn" ng-show="$index<8||showfontdocLabels" ng-class="{\'genericColor\':label.id==vm.fontChooseId.id}">{{label.name}}</button><div class="col-md-12 col-sm-12 col-xs-12 cursorPointer" ng-if="vm.fontlabels.length >8"><div class="icon-drop-down outline" ng-if="!showfontdocLabels" ng-click="showMorefontdocLabels()">{{\'button.spread\' | translate}}</div><div class="icon-retract outline" ng-if="showfontdocLabels" ng-click="showMorefontdocLabels()">{{\'button.packUp\' | translate}}</div></div></div></div><div class="leftPanel-con mar-bottom-10 fontdoc-con" style="border: none;height:auto; overflow: hidden"><img src="content/images/icons/loading01.gif" class="nav-mask-loading" ng-show="vm.fontLoading"><div ng-repeat="font in vm.fontXmlList track by $index" ng-hide="vm.fontLoading" data-index="{{$index}}" class="leftPanel-li lihover left-panel-hover outline-none" ng-click="addTextDoc(font,$event)" style="position: relative;height: 145px;line-height: 145px"><div style="width: 100%;height: 100%;display: flex;align-items: center;justify-content: center"><img ng-src="{{font.cover}}?imageMogr2/thumbnail/200x200>" data-art="{{font.cover}}" data-index="{{$index}}" style="left:0;top:0;max-width: 100%;position: absolute;max-height: 100%;z-index:100;opacity: 0;filter:alpha(opacity=0)"> <img style="max-width: 100%;max-height: 100%" ng-src="{{font.cover}}?imageMogr2/thumbnail/200x200>"></div></div></div><button class="load-more" style="bottom:10px" ng-if="vm.fontFulfill" ng-click="loadMoreTextDocs()">{{\'button.loadMore\' | translate}}</button><div class="default-diagram" ng-show="vm.fontXmlList.length == 0 && !vm.fontLoading"><img src="content/images/default-diagram.png"><div>{{\'hint.noData\' | translate}}</div></div><div class="text-center" ng-if="!vm.fontFulfill && vm.fontXmlList.length > 0 && !vm.fontLoading"><span class="tip-text">{{\'hint.noMore\' | translate}}</span></div></div><!--        <div class="editor-nav-view-li" ng-show="vm.nav==\'page\'">\u7248\u5F0F</div>--><div class="editor-nav-view-li" ng-show="vm.nav==\'bgImg\'"><div class="bgimg-color"><div class="leftPanel-bg-text">{{\'nav.background.content.title\' | translate}}</div><div class="leftPanel-bg-head"><div id="picker"></div><input class="leftPanel-bg-choose-color leftPanel-bg-color" type="color" ng-change="chooseColor()" ng-model="vm.bgColor"> <button class="leftPanel-bg-color leftPanel-bg-choose-mask"></button> <button class="leftPanel-bg-color" ng-repeat="color in vm.colorArr1" ng-click="chooseBgColor(color)" ng-style="{background:color,border:$first?\'1px solid #DADADA\':none,\'margin-left\': $index == 0 ? \'7px\' : \'0\'}"></button></div><div class="leftPanel-bg-text mar-top-20">{{\'nav.background.content.title1\' | translate}}</div><div class="leftPanel-bg-head" style="padding-left: 16px;margin-bottom: 20px"><button class="custom-grid2 leftPanel-bg-color" ng-click="chooseBgColor()"></button> <button class="leftPanel-bg-color" ng-repeat="color in vm.colorArr2" ng-click="chooseBgColor(color)" ng-style="{background:color,border:$index==4?\'1px solid #DADADA\':none}"></button></div></div><div class="leftPanel-head"><div class="leftPanel-privacy mar-bottom-10"><button ng-repeat="label in vm.bgImglabels track by $index" ng-click="vm.bgImglabelCb(label,$index)" data-index="{{$index}}" class="leftPanel-privacy-btn" ng-show="$index<8||showbgImgdocLabels" ng-class="{\'genericColor\':label.id==vm.bgImgChooseId.id}">{{label.name}}</button><div class="col-md-12 col-sm-12 col-xs-12" ng-if="vm.bgImglabels.length >8"><div class="icon-drop-down outline" ng-if="!showbgImgdocLabels" ng-click="showMorebgImgdocLabels()">{{\'button.spread\' | translate}}</div><div class="icon-retract outline" ng-if="showbgImgdocLabels" ng-click="showMorebgImgdocLabels()">{{\'button.packUp\' | translate}}</div></div></div></div><div class="leftPanel-con sticker-scroll bgimg-con" style="border: none"><ul class="clearfix" id="main4"><li ng-repeat="bgImg in vm.bgImgList track by $index" data-index="{{$index}}" ng-click="chooseBgimg(bgImg)" class="bgImg{{$index}} left-panel-hover outline-none" style="position: relative"><div class="nav-mask-div"><img ng-src="{{bgImg.identifier}}?imageMogr2/thumbnail/200x200>" data-mask="{{bgImg.identifier}}" draggable="true" ondragstart="dragStart(event)" ondragend="dragOn(event)" id="dragtargetBgImg{{$index}}" data-index="{{$index}}" style="max-width: 100%;max-height:100%;z-index:100"></div></li></ul><button class="load-more" style="bottom:10px" ng-if="vm.bgImgFulfill" ng-click="loadMoreBgImg()">{{\'button.loadMore\' | translate}}</button><div class="default-diagram" ng-show="vm.bgImgList.length == 0"><img src="content/images/default-diagram.png"><div>{{\'hint.noData\' | translate}}</div></div><div class="text-center" ng-if="!vm.bgImgFulfill && vm.bgImgList.length>0"><span class="tip-text">{{\'hint.noMore\' | translate}}</span></div></div></div><div class="editor-nav-view-li" ng-show="vm.nav==\'template\'" style="padding:16px"><div class=""><div class="leftPanel-privacy mar-bottom-10"><button ng-repeat="category in vm.tempCategories track by $index" ng-click="selectCategory(category)" data-index="{{$index}}" class="leftPanel-privacy-btn" ng-show="$index<8||showCategories" ng-class="{\'genericColor\':category==categoryNow.label}">{{category}}</button><div class="col-md-12 col-sm-12 col-xs-12" ng-if=" vm.tempCategories.length >8"><div class="icon-drop-down outline" ng-if="!showCategories" ng-click="showMoreCategories()">{{\'button.spread\' | translate}}</div><div class="icon-retract outline" ng-if="showCategories" ng-click="showMoreCategories()">{{\'button.packUp\' | translate}}</div></div></div></div><div class="leftPanel-con-temp clipart-con pad-top-10" style="border: none;height: auto" ng-style="{\'border-top\':\'none\'}"><ul><li ng-repeat="line in vm.tempList.productXmlLines track by $index" data-index="{{$index}}" class="outline-none" ng-show="!line.cancelled && (productXmlShow(line.themeClassifies)||categoryNow.label==\'\u5168\u90E8\')" style="position: relative;margin-bottom: 20px;display: flex;flex-direction: column;align-items: center"><div style="width: 100%;height: 288px;background: #333437;line-height: 278px;padding: 5px;overflow: hidden" ng-click="changeAllTemp($event,line)"><img ng-src="{{line.coverImg | imageFilter}}" style="width: 100%"></div><div class="web-temp-text"><span>{{line.name}}</span><div ng-click="tempPreview(line)">{{\'button.preview\' | translate}}</div></div><div style="position: absolute; left: 0; top: 0; width: 100%; height: 100%; display: flex; justify-content: center; align-items: center; background: rgba(0,0,0,0.5); color: #fff" ng-if="vm.article.productXmlId == line.productXmlId">{{\'nav.reserve.content.currentTemplate\' | translate}}</div></li></ul></div></div><div class="editor-nav-view-li" ng-show="vm.nav==\'border\'"><div class="leftPanel-head" style="padding: 10px 8px 0"><div class="leftPanel-privacy mar-bottom-10"><button ng-repeat="label in vm.borderLabels track by $index" ng-click="bordersCb(label,$index)" data-index="{{$index}}" class="leftPanel-privacy-btn" ng-show="$index<9||vm.borderUnfold" ng-class="{\'genericColor\':label.id==vm.borderId.id}">{{label.name}}</button><div class="col-md-12 col-sm-12 col-xs-12" ng-if="vm.borderLabels.length >8"><div class="icon-drop-down outline" ng-if="!vm.borderUnfold" ng-click="vm.borderUnfold = true">{{\'button.spread\' | translate}}</div><div class="icon-retract outline" ng-if="vm.borderUnfold" ng-click="vm.borderUnfold = false">{{\'button.packUp\' | translate}}</div></div></div></div><div class="nav-mask"><img src="content/images/icons/loading01.gif" class="nav-mask-loading" ng-show="vm.borderLoading"><ul ng-hide="vm.borderLoading"><li ng-repeat="item in vm.borderList track by $index" data-index="{{$index}}"><div class="nav-mask-div" style="line-height: 100px; text-align: center"><img ng-src="{{item.img}}?imageMogr2/thumbnail/200x200>" draggable="true" ondragstart="dragStart(event)" ondragend="dragOn(event)" id="dragtargetFrameConfig{{$index}}" data-item="{{item.img}}" data-index="{{$index}}" style="max-width: 100%; max-height: 100%"></div></li></ul><button class="load-more" style="bottom:10px" ng-if="vm.borderFulfill" ng-click="loadMoreBorder()">{{\'button.loadMore\' | translate}}</button><div class="default-diagram" ng-show="vm.borderList.length == 0 && !vm.borderLoading"><img src="content/images/default-diagram.png"><div>{{\'hint.noData\' | translate}}</div></div><div class="text-center" ng-if="!vm.borderFulfill && vm.borderList.length>0&& !vm.borderLoading"><span class="tip-text">{{\'hint.noMore\' | translate}}</span></div></div></div><div class="editor-nav-view-li" ng-show="vm.nav==\'reserve\'"><div class="leftPanel-head" style="padding: 10px 8px 0" ng-if="vm.reservePage.length>0 && !vm.pageData[vm.pageNumber].unreplace"><div class="leftPanel-privacy mar-bottom-10"><button ng-repeat="item in template.config.parts.list track by $index" ng-click="partCb(item,$index)" class="leftPanel-privacy-btn" ng-class="{\'genericColor\':item.id==vm.partid}" ng-if="item.backupPagesQuantity>0">{{item.name}}</button></div></div><div class="nav-mask" ng-if="vm.reservePage.length>0 && !vm.pageData[vm.pageNumber].unreplace"><ul><li ng-repeat="page in vm.reservePage track by $index" data-index="{{$index}}" ng-if="page.config.partid==vm.partid && page.genre == vm.pageData[vm.pageNumber].genre && page.spread == vm.pageData[vm.pageNumber].spread" ng-click="layoutCb(page)"><div class="nav-mask-div" style="line-height: 100px; text-align: center; position: relative"><img ng-src="{{page.pagecover.identifier}}?imageMogr2/thumbnail/200x200>" style="max-width: 100%; max-height: 100%"><div class="use-account" ng-if="page.count>0">{{page.count}}</div></div></li></ul></div><div class="default-diagram" ng-show="vm.reservePage.length == 0"><img src="content/images/default-diagram.png"><div>{{\'hint.noData\' | translate}}</div></div><div class="text-center" style="padding: 20px 0" ng-if="vm.pageData[vm.pageNumber].unreplace"><span class="tip-text">{{\'hint.noMore\' | translate}}</span></div></div><div class="editor-nav-view-li" ng-show="vm.nav==\'qrcode\'"><div class="qrcode-title">{{"nav.qrcode.content.title" | translate}}\uFF1A</div><div class="qrcode-input-div"><input type="text" class="qrcode-input" ng-model="vm.code.value" placeholder="{{\'nav.qrcode.content.placeholderV\' | translate}}"></div><div class="qrcode-title">{{"nav.qrcode.content.title1" | translate}}\uFF1A</div><div class="qrcode-input-div"><input type="text" class="qrcode-input" ng-model="vm.code.width" placeholder="{{\'nav.qrcode.content.placeholderW\' | translate}}"></div><div class="qrcode-input-div"><input type="text" class="qrcode-input" ng-model="vm.code.height" placeholder="{{\'nav.qrcode.content.placeholderH\' | translate}}"></div><div class="qrcode-input-div"><button class="qrcode-button" ng-click="addQrcode()" ng-disable="true">{{\'button.confirm\' | translate}}</button></div></div><div class="editor-nav-view-li" ng-show="vm.nav==\'layout\'"><div class="default-diagram" ng-show="vm.picLayoutXmlGroup.data.length == 0 || !vm.picLayoutXmlGroup"><img src="content/images/default-diagram.png"><div>{{\'hint.noData\' | translate}}</div></div><div class="leftPanel-head"><div class="leftPanel-privacy mar-bottom-10"><button ng-repeat="label in vm.picLayoutXmlsList track by $index" ng-click="selectLayoutLabel(label,$index)" data-index="{{$index}}" class="leftPanel-privacy-btn" ng-class="{\'genericColor\':label.name==vm.picLayoutXmlGroup.name}">{{label.name}}</button></div></div><div class="leftPanel-con sticker-scroll layout-con" style="border: none"><div><ul class="clearfix"><li ng-repeat="item in vm.picLayoutXmlGroup.data track by $index" data-index="{{$index}}" class="left-panel-hover outline-none" style="position: relative;height: 100px;line-height: 100px"><div style="width: 100%;height: 100%;overflow: hidden"><img ng-src="{{item.thumbnailresource.identifier}}?imageMogr2/thumbnail/200x200>" data-art="{{item.resource.identifier}}" ng-click="addLayout(item, true)" id="dragtargetLayout{{$index}}" data-index="{{$index}}" style="left:0;top:0;width: 100%;position: absolute;height: 100%;z-index:100;opacity: 0;filter:alpha(opacity=0)"> <img style="max-width: 100%;max-height: 100%" ng-src="{{item.thumbnailresource.identifier}}?imageMogr2/thumbnail/200x200>"></div></li></ul></div></div></div><div class="editor-nav-view-li" ng-show="vm.nav==\'variableData\'"><div class="variableData-title" style="padding:20px"><span style="color:#FFFFFF;font-size: 16px">{{\'nav.variableData.content.title\' | translate}}</span> <span style="color:#FFC6B3;font-size: 14px" ng-click="downloadFile()">{{\'nav.variableData.content.downloadTemplate\' | translate}}</span></div><div class="variableData-add" style="padding: 0 20px"><input type="file" ng-model="uploadFile" fileread="uploadFile" class="variableData-add-upload-file"> <span class="iconzengjia iconfont" ng-show="!vm.variableName"></span> <span class="mar-left-10" ng-show="!vm.variableName">{{\'nav.variableData.content.incTemplate\' | translate}}</span><div ng-show="vm.variableName" class="variableData-variableName"><span>{{vm.variableName}}</span> <span class="iconfont iconicon_system_reset_" style="font-size:14px;color:#999999">{{\'nav.variableData.content.uploadAgain\' | translate}}</span></div></div><div ng-if="vm.variableData&&vm.variableData.titles.title.length" style="padding: 0 20px"><div class="variableData-list"><div class="variableData-li" draggable="true" ondragstart="dragStart(event)" ondragend="dragOn(event)" id="dragtargetVariable{{$index}}" data-index="{{$index}}" data-value="{{title.value}}" ng-click="title.select=!title.select" ng-repeat="title in vm.variableData.titles.title track by $index" ng-style="{\'color\':title.select?\'#108dfe\':\'#FFFFFF\'}"><span data-index="{{$index}}" data-value="{{title.value}}" class="ellipsis" style="width:80%">{{title.value}}</span><div style="margin-top:16px"><span style="margin-top:6px;font-size: 14px" class="iconfont" ng-class="{\'iconxuanzhong1\' : title.select , \'iconxuanzhong\':!title.select}"></span> <span style="margin-left:6px">{{\'nav.variableData.content.setImagebox\' | translate}}</span></div></div></div></div><div class="mar-top-20" ng-if="vm.variableData&&vm.variableData.titles.title.length" style="padding:0 16px"><h4 class="left-panel-title">{{\'nav.variableData.content.title1\' | translate}}\uFF1A</h4><div class="mar-top-10" style="overflow: hidden"><div class="variable-data-list col-lg-12 col-sm-12 col-md-12 flex-btn-group-container" style="margin-top: 10px;padding: 10px"><div class="flex-1-normal text-ellipsis" style="margin-top: 5px;flex:0.8;font-size: 14px;color: #CCCCCC"><div ng-repeat="title in vm.variableData.titles.title track by $index" class="text-right">{{title.value}}\uFF1A</div></div><div class="flex-1-left text-ellipsis" style="margin-top: 5px;font-size: 14px;color: #FFFFFF;margin-left: 5px"><div ng-repeat="v in vm.variableData.values.value[0].values track by $index" class="text-left">{{v.value}}</div></div></div></div></div><div style="height:150px"></div><div class="web-photo-choose" style="background: #2B2C2F;height: 120px"><div class="col-lg-12 col-sm-12 col-xs-12 variable-data-btn" style="bottom:65px;padding: 0 15px"><button class="col-lg-12 col-sm-12 col-xs-12 pad-0" style="width:100%;background: rgba(255,255,255,0.09);color: #999999" ng-if="!vm.isTransformGroup">{{\'nav.variableData.content.combination\' | translate}}</button> <button class="col-lg-12 col-sm-12 col-xs-12 pad-0" style="width:100%;background: rgba(255,255,255,0.09)" ng-if="vm.isTransformGroup" ng-click="transformGroup($event)">{{\'nav.variableData.content.combination\' | translate}}</button></div><div class="col-lg-12 col-sm-12 col-xs-12 pad-0 variable-data-btn" style="padding-left: 7px !important"><button class="col-lg-6 col-sm-6 col-xs-6 mar-right-10 mar-left-10" ng-click="watchVariable()">{{\'nav.variableData.content.lockAll\' | translate}}</button> <button class="col-lg-6 col-sm-6 col-xs-6" ng-click="generVariable($event)">{{\'nav.variableData.content.generation\' | translate}}</button></div></div></div></div><div class="editor-nav2" ng-style="{\'left\':vm.leftShow ? \'\' : \'72px\',\'right\':vm.rightShow?\'\':\'42px\'}" style="position: absolute;top: 0"><div class="clearfix editor-nav2-ul2" style="display: flex"><!-- <ul class="clearfix c-xml-action-icon-font" ng-if="vm.toobarAlignmentBtn">\n                    <li class="pad-0">\n                        <button class="nav-operation tool-bar-btn tool-bar-btn-select">\n                            <i class="icon iconfont iconduiqi" ng-click="alignHover()"></i>\n                            <div class="tip" style="left: -1px;">{{\'editorBtn.align\' | translate}}</div>\n                            <div class="roundedSet" ng-show="vm.isAlignHover" style="width: 240px;">\n                                 <h4 class="rightPanel-title" style="margin-top: 0;">{{\'editorBtn.elementAlign\' | translate}}</h4>\n                                 <div style="display: flex;flex-wrap: wrap;flex-direction: unset;">\n                                    <div class="alignLi" ng-click="boxAlignment(\'left\')">\n                                        <i class="icon iconfont iconzuoduiqi"></i>\n                                        <div>{{\'editorBtn.alignLeft\' | translate}}</div>\n                                    </div>\n                                    <div class="alignLi" ng-click="boxAlignment(\'right\')">\n                                        <i class="icon iconfont iconyouduiqi"></i>\n                                        <div>{{\'editorBtn.alignRight\' | translate}}</div>\n                                    </div>\n                                    <div class="alignLi" ng-click="boxAlignment(\'standard\')">\n                                        <i class="icon iconfont iconchuizhijuzhong"></i>\n                                        <div>{{\'editorBtn.centerHorizontally\' | translate}}</div>\n                                    </div>\n                                    <div class="alignLi" ng-click="boxAlignment(\'vertical\')">\n                                        <i class="icon iconfont iconshuipingjuzhong"></i>\n                                        <div>{{\'editorBtn.centerVertical\' | translate}}</div>\n                                    </div>\n                                    <div class="alignLi" ng-click="boxAlignment(\'top\')">\n                                        <i class="icon iconfont iconshangduiqi"></i>\n                                        <div>{{\'editorBtn.alignTop\' | translate}}</div>\n                                    </div>\n                                    <div class="alignLi" ng-click="boxAlignment(\'bottom\')">\n                                        <i class="icon iconfont iconxiaduiqi"></i>\n                                        <div>{{\'editorBtn.alignBottom\' | translate}}</div>\n                                    </div>\n                                 </div>\n                            </div>\n                        </button>\n                    </li>\n                </ul> --><!-- <ul class="clearfix c-xml-action-icon-font" ng-if="vm.distribute">\n                    <li class="pad-0">\n                        <button class="nav-operation tool-bar-btn tool-bar-btn-select">\n                            <i class="icon iconfont iconchuizhifenbu2" ng-click="distribute()"></i>\n                            <div class="tip" style="left: -1px;">{{\'editorBtn.distribution\' | translate}}</div>\n                            <div class="roundedSet" ng-show="vm.isDistributeHover" style="width: 240px;">\n                                 <h4 class="rightPanel-title" style="margin-top: 0;">{{\'editorBtn.distributionElement\' | translate}}</h4>\n                                 <div style="display: flex;flex-wrap: wrap;flex-direction: unset;">\n                                    <div class="alignLi" ng-click="boxDistribute(\'horizontal\')">\n                                        <i class="icon iconfont iconHorCenter"></i>\n                                        <div>{{\'editorBtn.distributionHorizontally\' | translate}}</div>\n                                    </div>\n                                    <div class="alignLi" ng-click="boxDistribute(\'vertical\')">\n                                        <i class="icon iconfont iconVerCenter"></i>\n                                        <div>{{\'editorBtn.distributionVertical\' | translate}}</div>\n                                    </div>\n                                 </div>\n                            </div>\n                        </button>\n                    </li>\n                </ul> --><ul class="clearfix c-xml-action-icon-font" ng-if="vm.hasImgBtn"><li class="pad-0"><button class="nav-operation tool-bar-btn tool-bar-btn-select" ng-click="doubleClickImagebox($event,$index, vm.elementOn.item)">{{\'editorBtn.cut\' | translate}}</button></li><li class="pad-0"><button class="nav-operation tool-bar-btn tool-bar-btn-select" ng-click="exchange()">{{\'editorBtn.exchange\' | translate}}</button></li><!-- \u5927\u56FE\u4E0D\u663E\u793A\u62A0\u56FE\u6309\u94AE --><li class="pad-0" ng-if="vm.article.editorType == \'POSTER\' && !isLarge(vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].imagebox.image.imageInfo)"><button class="nav-operation tool-bar-btn tool-bar-btn-select" ng-click="mattingOpen()" style="min-width: 37px;width: auto;padding: 0 5px">{{vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].imagebox.image.mattingMask ? \'\u7F16\u8F91\u62A0\u56FE\' : \'AI\u62A0\u56FE\'}}</button></li></ul><div ng-show="vm.elementOn.name == \'textbox\' && vm.textboxBtn"><ul class="clearfix c-xml-action-icon-font"><li><div class="c-xml-action-div-icon c-xml-action-div-icon-color" ng-click="operationColorOpen($event)" ng-style="{background: vm.elementOn.item.style.color}" style="border: 1px solid #ddd"><div class="tip3" style="top:50px">{{\'editorBtn.color\' | translate}}</div></div><div class="c-xml-action-div-color-modal clearfix" style="z-index: 999;top:48px;left: -2px" ng-if="vm.isOperationColor"><input class="c-xml-action-div-color-modal-btn" type="color" ng-change="chooseTextColor()" ng-model="vm.textColor"> <span ng-repeat="item in vm.colorList track by $index" ng-style="{ \'background\' : item.id}" ng-class="{\'c-xml-action-div-color-on\' : item.id == vm.elementOn.item.style.color}" ng-click="operationColor(item)"></span></div></li><li><div class="c-font-view"><div class="c-font-view-head" ng-style="{\'font-family\': \'\\\'\' + vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].textbox.fontuuid + \'\\\'\',}">{{vm.selectFontName(vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].textbox.fontuuid)}}</div><div class="c-font-view-body"><div class="c-font-view-body-head"><input type="text" class="c-font-view-body-head-input" ng-model="vm.selectFont" ng-change="vm.selectFontBtn()"> <span class="c-font-view-body-head-btn" ng-click="vm.selectFontBtn()" style="top: 6px"></span></div><div class="chinese-support-view"><div class="chinese-support-item" ng-class="{\'chinese-support-select\' : vm.chineseSupport}" ng-click="vm.chineseSupport=true">{{\'editorBtn.\u4E2D\u6587\u5B57\u4F53\' | translate}}</div><div class="chinese-support-item" ng-class="{\'chinese-support-select\' : !vm.chineseSupport}" ng-click="vm.chineseSupport=false">{{\'editorBtn.\u5176\u4ED6\u5B57\u4F53\' | translate}}</div></div><div class="c-font-view-body-ul"><div class="c-font-view-body-li" ng-repeat="font in vm.fontuuid track by $index" ng-click="updateTextFont(font)" ng-if="vm.chineseSupport == font.chineseSupport" ng-class="{\'c-font-view-body-li-on\' : vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].textbox.fontuuid == font.uuid}"><img ng-src="{{font.fontStyles[0].identifier | imageFilter}}" alt="" ng-if="domain && font.fontStyles[0].identifier"> <span ng-if="!font.fontStyles[0].identifier">{{font.family}}</span></div></div></div></div><!--                                        <select ng-options="item as item.family for item in vm.fontList" ng-model="item"--><!--                                                ng-model-options="{debounce:500}" class="select-text" ng-change="updateTextFont(item)">--><!--                                        </select>--></li><li><div class="c-font-view" style="width: 80px"><div class="c-font-view-head"><input type="number" class="c-input1" style="width: 100%; border: 0" ng-model="vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].textbox.style.size" ng-change="updateTextSize(vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].textbox.style.size)"></div><div class="c-font-view-body"><div class="c-font-view-body-ul"><div class="c-font-view-body-li" ng-repeat="size in fontSizes track by $index" ng-click="updateTextSize(size)" ng-class="{\'c-font-view-body-li-on\' : vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].textbox.style.size == size}">{{size}}</div></div></div></div><!--                        <select ng-options="size for size in fontSizes" style="width: 70px;"--><!--                                ng-model-options="{debounce:500}" class="select-text"--><!--                                ng-change="updateTextSize()"--><!--                                ng-model="vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].textbox.style.size">--><!--                        </select>--></li><li ng-if="vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].textbox.style.italic1"><div class="c-xml-action-div-icon" style="background-size: auto" ng-class="{\'tools_bar_bold\':!vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].textbox.style.italic,\'tools_bar_bold_Selected\':vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].textbox.style.italic}" ng-click="operationItalic()"><i class="iconfont iconI"></i><div class="tip3">{{\'editorBtn.italic\' | translate}}</div></div></li><li ng-if="vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].textbox.style.bold1"><div class="c-xml-action-div-icon" ng-class="{\'tools_bar_bold\':!vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].textbox.style.bold,\'tools_bar_bold_Selected\':vm.pageData[vm.pageNumber].levels.level[vm.elementOn.index].textbox.style.bold}" ng-click="operationBold()"><i class="iconfont iconb"></i><div class="tip3">{{\'editorBtn.bold\' | translate}}</div></div></li><li class="pad-0"><button class="nav-lock tool-bar-btn tool-bar-btn-select"><i class="icon iconfont iconhangjianju" ng-click="operationSpacing(!vm.isOperationSpacing)"></i><div class="tip">{{\'editorBtn.space\' | translate}}</div><div class="space-slider" ng-if="vm.isOperationSpacing"><div class="slider"><label class="slider-label">{{\'editorBtn.wordSpace\' | translate}}</label><div class="slider-area"><div class="slider-back" ng-click="spacingClick(event)"></div><div class="slider-block block-width" data-value="width" onmousedown="resizeSpacingStart(event)"></div></div><input type="number" class="slider-input" min="0" onmousewheel="return false;" ng-model="template.letterspacing" ng-change="spacingChange(1)"></div><div class="slider"><label class="slider-label">{{\'editorBtn.verticalSpace\' | translate}}</label><div class="slider-area"><div class="slider-back" data-value="height" ng-click="spacingClick($event)"></div><div class="slider-block block-height" data-value="height" onmousedown="resizeSpacingStart(event)"></div></div><input type="number" class="slider-input" min="{{template.lineheight}}" onmousewheel="return false;" ng-model="template.lineheight" ng-change="spacingChange(0)"></div></div></button></li><li class="pad-0"><button class="nav-operation tool-bar-btn tool-bar-btn-select"><i class="icon iconfont iconduiqi" ng-click="operationDir(!vm.isOperationDir)"></i><div class="tip">{{\'editorBtn.align\' | translate}}</div><div class="coverage-slider" ng-show="vm.isOperationDir"><ul><li ng-click="operationBarDir(\'left\')"><i class="icon iconfont iconzuoduiqi"></i><div class="tip4">{{\'editorBtn.alignLeft\' | translate}}</div></li><li ng-click="operationBarDir(\'center\')"><i class="icon iconfont iconshuipingjuzhong"></i><div class="tip4">{{\'editorBtn.alignCenter\' | translate}}</div></li><li ng-click="operationBarDir(\'right\')"><i class="icon iconfont iconyouduiqi"></i><div class="tip4">{{\'editorBtn.alignRight\' | translate}}</div></li><!--                                        <li ng-click="operationBarDir(\'justified\')">--><!--                                            <i class="icon iconfont iconliangduanduiqi"></i>--><!--                                            <div class="tip4">\u4E24\u7AEF\u5BF9\u9F50</div>--><!--                                        </li>--></ul></div></button></li><li class="pad-0" ng-if="vm.elementOn.item.style.writingmode != \'horizontal-tb\'"><button class="nav-lock tool-bar-btn tool-bar-btn-select" ng-click="textHengban()"><i class="iconfont iconhengban"></i><div class="tip">{{\'editorBtn.horizontal\' | translate}}</div></button></li><!-- <li class="pad-0" ng-if="vm.elementOn.item.style.writingmode != \'vertical-lr\'">\n                            <button class="nav-lock tool-bar-btn tool-bar-btn-select" ng-click="textShuban(\'vertical-lr\')">\n                                <i class="iconfont iconshuban"></i>\n                                <div class="tip">{{\'editorBtn.verticalLr\' | translate}}</div>\n                            </button>\n                        </li>\n                        <li class="pad-0" ng-if="vm.elementOn.item.style.writingmode != \'vertical-rl\'">\n                            <button class="nav-lock tool-bar-btn tool-bar-btn-select" ng-click="textShuban(\'vertical-rl\')">\n                                <i class="iconfont iconwenzigongju-shupai"></i>\n                                <div class="tip">{{\'editorBtn.verticalRl\' | translate}}</div>\n                            </button>\n                        </li> --></ul></div><span ng-show="vm.elementOn.name==\'textdocument\'&&vm.elementOn.item.editable" style="color: #E1A03A;padding: 0 10px;line-height: 42px" ng-click="slipGroup()">{{\'editorBtn.split\' | translate}}</span></div><div class="clearfix editor-nav2-ul1"><button class="nav-lock tool-bar-btn tool-bar-btn-select" style="cursor: pointer !important" ng-class="{\'selected-dashed\': vm.isRoundedSet}" ng-if=" vm.elementOn.item.border &&  vm.elementOn.item.border.type == \'Color\' &&  vm.elementOn.item.border.shape == \'Rectangle\'"><i class="icon iconfont iconyuanjiao font-20" ng-click="roundedSet(!vm.isTransp)" style="cursor: pointer !important"></i><div class="tip3">{{\'editorBtn.radius\' | translate}}</div><div class="roundedSet" ng-show="vm.isRoundedSet" style="z-index: 1000"><div class="roundedSet-title"><div style="display: flex;align-items: center"><h4 class="rightPanel-title" style="margin-right: 10px">{{\'editorBtn.radius\' | translate}}</h4><span class="filletType" ng-class="{\'filletTypeActive\': vm.elementOn.item.border.radius.filletType == \'Fixed\'}" ng-click="changeFilletType(\'Fixed\')">px</span> <span class="filletType" ng-class="{\'filletTypeActive\': vm.elementOn.item.border.radius.filletType == \'Proportion\'}" ng-click="changeFilletType(\'Proportion\')">%</span></div><div class="border-radio-btn"><span class="rightPanel-title-radio-btn" ng-click="borderRadiusAllbtn()" ng-style="{\'background\':vm.borderRadiusAllbtn?\'#e5e5e5\':\'\'}" style="padding:1px 3px"><img src="content/images/icons/acive-overall.svg" alt="" ng-show="vm.borderRadiusAllbtn"> <img src="content/images/icons/overall.svg" alt="" ng-show="!vm.borderRadiusAllbtn"> </span><span class="rightPanel-title-radio-btn" ng-click="vm.borderRadiusAllbtn = false" ng-style="{\'background\':!vm.borderRadiusAllbtn?\'#e5e5e5\':\'\'}" style="padding:1px 3px"><img src="content/images/icons/active-quadrangle.svg" alt="" ng-show="!vm.borderRadiusAllbtn"> <img src="content/images/icons/quadrangle.svg" alt="" ng-show="vm.borderRadiusAllbtn"></span></div></div><div ng-if="vm.elementOn.item.border.radius.filletType == \'Proportion\'"><div ng-if="!vm.borderRadiusAllbtn"><div class="c-schedule-view"><span class="c-schedule-title">{{\'editorBtn.radiusLT\' | translate}}\uFF1A</span> <input type="range" min="0" max="100" step="1" value="{{ vm.elementOn.item.border.radius.lt}}" ng-model=" vm.elementOn.item.border.radius.lt" ng-change="borderRadiusCookie()" class="text-range-140 rangeSize" style="flex:1"> <span style="width: 30px">{{ vm.elementOn.item.border.radius.lt}}%</span></div><div class="c-schedule-view"><span class="c-schedule-title">{{\'editorBtn.radiusTR\' | translate}}\uFF1A</span> <input type="range" min="0" max="100" step="1" value="{{ vm.elementOn.item.border.radius.rt}}" ng-model=" vm.elementOn.item.border.radius.rt" ng-change="borderRadiusCookie()" class="text-range-140 rangeSize" style="flex:1"> <span style="width: 30px">{{ vm.elementOn.item.border.radius.rt}}%</span></div><div class="c-schedule-view"><span class="c-schedule-title">{{\'editorBtn.radiusRB\' | translate}}\uFF1A</span> <input type="range" min="0" max="100" step="1" value="{{ vm.elementOn.item.border.radius.rb}}" ng-model=" vm.elementOn.item.border.radius.rb" ng-change="borderRadiusCookie()" class="text-range-140 rangeSize" style="flex:1"> <span style="width: 30px">{{ vm.elementOn.item.border.radius.rb}}%</span></div><div class="c-schedule-view"><span class="c-schedule-title">{{\'editorBtn.radiusLB\' | translate}}\uFF1A</span> <input type="range" min="0" max="100" step="1" value="{{ vm.elementOn.item.border.radius.lb}}" ng-model=" vm.elementOn.item.border.radius.lb" ng-change="borderRadiusCookie()" class="text-range-140 rangeSize" style="flex:1"> <span style="width: 30px">{{ vm.elementOn.item.border.radius.lb}}%</span></div></div><div ng-if="vm.borderRadiusAllbtn"><div class="c-schedule-view"><span class="c-schedule-title">{{\'editorBtn.radiusAll\' | translate}}\uFF1A</span> <input type="range" min="0" max="100" step="1" value="{{ vm.elementOn.item.border.radius.all}}" ng-model=" vm.elementOn.item.border.radius.all" ng-change="borderRadiusAllChange()" class="text-range-140 rangeSize" style="flex:1"> <span style="width: 30px">{{ vm.elementOn.item.border.radius.all}}%</span></div></div></div><div ng-if="vm.elementOn.item.border.radius.filletType == \'Fixed\'"><div ng-if="!vm.borderRadiusAllbtn" style="display: flex;flex-wrap: wrap;gap: 10px"><div class="c-schedule-view2"><span class="c-schedule-title">{{\'editorBtn.radiusLT\' | translate}}\uFF1A</span> <input type="number" min="0" step="1" ng-change="vm.cookie()" ng-model=" vm.elementOn.item.border.radius.lt"> <span style="width: 30px">px</span></div><div class="c-schedule-view2"><span class="c-schedule-title">{{\'editorBtn.radiusTR\' | translate}}\uFF1A</span> <input type="number" min="0" step="1" ng-change="vm.cookie()" ng-model=" vm.elementOn.item.border.radius.rt"> <span style="width: 30px">px</span></div><div class="c-schedule-view2"><span class="c-schedule-title">{{\'editorBtn.radiusLB\' | translate}}\uFF1A</span> <input type="number" min="0" step="1" ng-change="vm.cookie()" ng-model=" vm.elementOn.item.border.radius.lb"> <span style="width: 30px">px</span></div><div class="c-schedule-view2"><span class="c-schedule-title">{{\'editorBtn.radiusRB\' | translate}}\uFF1A</span> <input type="number" min="0" step="1" ng-change="vm.cookie()" ng-model=" vm.elementOn.item.border.radius.rb"> <span style="width: 30px">px</span></div></div><div ng-if="vm.borderRadiusAllbtn"><div class="c-schedule-view2"><span class="c-schedule-title">{{\'editorBtn.radiusAll\' | translate}}\uFF1A</span> <input type="number" min="0" step="1" ng-model=" vm.elementOn.item.border.radius.all" ng-change="borderRadiusAll()"> <span style="width: 30px">px</span></div></div></div></div></button> <button class="nav-lock tool-bar-btn tool-bar-btn-select" style="cursor: pointer !important" ng-class="{\'selected-dashed\': vm.isBorderSet}" ng-if=" vm.elementOn.item.border &&  vm.elementOn.item.border.type == \'Color\'"><i class="icon iconfont iconbiankuang font-20" ng-click="borderSet(!vm.isBorderSet)" style="cursor: pointer !important"></i><div class="tip3">{{\'editorBtn.border\' | translate}}</div><div class="roundedSet" ng-show="vm.isBorderSet" style="z-index: 1000"><div class="col-md-12 col-sm-12 col-lg-12 pad-0" ng-if=" vm.elementOn.item.border &&  vm.elementOn.item.border.type == \'Color\'"><h4 class="rightPanel-title">{{\'editorBtn.border\' | translate}}</h4></div><div class="borderSet-body"><div class="bezel-set-color" style="width: 30px;height: 30px" ng-style="{background: vm.elementOn.item.border.color}"><input type="color" ng-change="vm.cookie()" ng-value=" vm.elementOn.item.border.color" ng-model=" vm.elementOn.item.border.color"></div><div class="c-font-view" style="height: 30px;flex: 1;padding: 0 10px"><div class="c-font-view-head2"><div ng-show=" vm.elementOn.item.border.lineType == \'solid\'"><img src="content/images/icons/solid.png"></div><div ng-show=" vm.elementOn.item.border.lineType == \'dashed\'"><img src="content/images/icons/dashed.png"></div><div ng-show=" vm.elementOn.item.border.lineType == \'dotted\'"><img src="content/images/icons/dotted.png"></div><img src="content/images/icons/pulldownIcon.png" alt="" style="position: absolute;width: 20px;right: 5px;top: 50%;transform: translateY(-50%)"></div><div class="c-font-view-body"><div class="c-font-view-body-ul" style="margin-top: 0"><div class="c-font-view-body-li" ng-click="lineTypeChenge(\'solid\')"><img src="content/images/icons/solid.png"></div><div class="c-font-view-body-li" ng-click="lineTypeChenge(\'dashed\')"><img src="content/images/icons/dashed.png"></div><div class="c-font-view-body-li" ng-click="lineTypeChenge(\'dotted\')"><img src="content/images/icons/dotted.png"></div></div></div></div><div style="width: 80px;height: 30px;display: flex"><input type="number" style="border: 1px solid #dedede;color: #000" oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/\\D/g,\'\');if(value>999)value=999;if(value<0)value=null" ng-change="vm.cookie()" ng-model=" vm.elementOn.item.border.lineWidth"> <span>px</span></div></div></div></button><!-- <button class="nav-lock tool-bar-btn tool-bar-btn-select" style="cursor: pointer !important;" ng-class="{\'selected-dashed\': vm.isShadowSet}" ng-if=" vm.elementOn.item.border &&  vm.elementOn.item.border.type == \'Color\'">\n                    <i class="icon iconfont iconbim_yinying font-20" ng-click="shadowSet(!vm.isShadowSet)" style="cursor: pointer !important;"></i>\n                    <div class="tip3">{{\'editorBtn.shadow\' | translate}}</div>\n                    <div class="roundedSet" ng-show="vm.isShadowSet" style="z-index: 1000;">\n                        <div class="roundedSet-title">\n                            <h4 class="rightPanel-title">{{\'editorBtn.shadow\' | translate}}</h4>\n                            <div class="bezel-set-color" style="width: 30px;height: 30px;" ng-style="{background: vm.elementOn.item.shadow.color}">\n                                <input type="color" ng-change="onArticleChange()" ng-value=" vm.elementOn.item.shadow.color" ng-model=" vm.elementOn.item.shadow.color"/>\n                            </div>\n                        </div>\n                        <div>\n                            <div class="c-schedule-view">\n                                <span class="c-schedule-title">{{\'editorBtn.shadowX\' | translate}}\uFF1A</span>\n                                <input type="range" min="-100" max="100" step="1" ng-change="onArticleChange()" value="{{ vm.elementOn.item.shadow.x}}" ng-model=" vm.elementOn.item.shadow.x"\n                                    class="text-range-140 rangeSize" style="flex:1;"/>\n                                <span style="width: 30px;">{{ vm.elementOn.item.shadow.x}}%</span>\n                            </div>\n                            <div class="c-schedule-view">\n                                <span class="c-schedule-title">{{\'editorBtn.shadowY\' | translate}}\uFF1A</span>\n                                <input type="range" min="-100" max="100" step="1" ng-change="onArticleChange()" value="{{ vm.elementOn.item.shadow.y}}" ng-model=" vm.elementOn.item.shadow.y"\n                                    class="text-range-140 rangeSize" style="flex:1;"/>\n                                <span style="width: 30px;">{{ vm.elementOn.item.shadow.y}}%</span>\n                            </div>\n                            <div class="c-schedule-view">\n                                <span class="c-schedule-title">{{\'editorBtn.shadowDim\' | translate}}\uFF1A</span>\n                                <input type="range" min="0" max="20" step="1" ng-change="onArticleChange()" value="{{ vm.elementOn.item.shadow.blur}}" ng-model=" vm.elementOn.item.shadow.blur"\n                                    class="text-range-140 rangeSize" style="flex:1;"/>\n                                <span style="width: 30px;">{{ vm.elementOn.item.shadow.blur}}%</span>\n                            </div>\n                        </div>\n                    </div>\n                </button> --> <button class="nav-lock tool-bar-btn" style="cursor: pointer !important" ng-class="{\'tool-bar-btn-select\' : vm.optimizationBtn}" ng-show="vm.elementOn.item.image.resource && vm.elementOn.item.image.resource.identifier&& vm.elementOn.item.image.imageInfo.size < 20971520"><i class="icon iconfont iconsetiao" style="cursor: pointer !important" ng-click="optimizationSelect(!vm.isOptimiza)" ng-class="{\'selectedbar\':vm.isOptimiza}"></i><div class="tip4">{{\'editorBtn.imageOptimization\' | translate}}</div><!-- <div class="roundedSet" ng-show="vm.isOptimiza" style="z-index: 1000;">\n                        <div class="roundedSet-title">\n                            <h4 class="rightPanel-title">{{\'editorBtn.imageOptimizationTitle\' | translate}}</h4>\n                        </div>\n                        <div>\n                            <div class="col-lg-12 col-sm-12 col-xs-12 pad-0 mar-bottom-10">\n                                <div class="col-lg-12 col-sm-12 col-xs-12 optimization-body-li">\n                                    <div class="col-lg-6 col-sm-6 col-xs-6 text-left optimization-body-li-text">{{\'editorBtn.luminance\' | translate}}</div>\n                                    <div class="col-lg-6 col-sm-6 col-xs-6 text-right optimization-body-li-num">{{vm.elementOn.item.image.brightness}}</div>\n                                </div>\n                                <div class="col-lg-12 col-sm-12 col-xs-12 optimization-body-li">\n                                     <input type="range" min="-100" max="100" step="1" value="0" class="text-range-100 rangeSize lighter-range"\n                                            ng-model="vm.elementOn.item.image.brightness" ng-change="changeBrightness()"/>\n                                </div>\n                            </div>\n                            <div class="col-lg-12 col-sm-12 col-xs-12 pad-0 mar-bottom-10">\n                                <div class="col-lg-12 col-sm-12 col-xs-12 optimization-body-li">\n                                    <div class="col-lg-6 col-sm-6 col-xs-6 text-left optimization-body-li-text">{{\'editorBtn.contrast\' | translate}}</div>\n                                    <div class="col-lg-6 col-sm-6 col-xs-6 text-right optimization-body-li-num">{{vm.elementOn.item.image.contrast}}</div>\n                                </div>\n                                <div class="col-lg-12 col-sm-12 col-xs-12 optimization-body-li">\n                                    <input type="range"  min="-100" max="100" step="1" value="0" class="text-range-100 rangeSize contrast-range"\n                                           ng-model="vm.elementOn.item.image.contrast" ng-change="changeContrast()"/>\n                                </div>\n                            </div>\n                            <div class="col-lg-12 col-sm-12 col-xs-12 pad-0 mar-bottom-10">\n                                <div class="col-lg-12 col-sm-12 col-xs-12 optimization-body-li">\n                                    <div class="col-lg-6 col-sm-6 col-xs-6 text-left optimization-body-li-text">{{\'editorBtn.colorSaturation\' | translate}}</div>\n                                    <div class="col-lg-6 col-sm-6 col-xs-6 text-right optimization-body-li-num">{{vm.elementOn.item.image.saturate}}</div>\n                                </div>\n                                <div class="col-lg-12 col-sm-12 col-xs-12 optimization-body-li">\n                                    <input type="range"  min="-100" max="100" step="1" value="0" class="text-range-100 rangeSize saturation-range"\n                                           ng-model="vm.elementOn.item.image.saturate" ng-change="changeSaturate()"/>\n                                </div>\n                            </div>\n                            <div class="col-lg-12 col-sm-12 col-xs-12 pad-0 mar-bottom-10">\n                                <div class="col-lg-12 col-sm-12 col-xs-12 optimization-body-li">\n                                    <div class="col-lg-6 col-sm-6 col-xs-6 text-left optimization-body-li-text">{{\'editorBtn.colorTemperature\' | translate}}</div>\n                                    <div class="col-lg-6 col-sm-6 col-xs-6 text-right optimization-body-li-num">{{vm.elementOn.item.image.temperature || 0}}</div>\n                                </div>\n                                <div class="col-lg-12 col-sm-12 col-xs-12 optimization-body-li">\n                                    <input type="range"  min="-100" max="100" step="1" value="0" class="text-range-100 rangeSize saturation-range"\n                                           ng-model="vm.elementOn.item.image.temperature" ng-change="changeTemperature()"/>\n                                </div>\n                            </div>\n                            <div class="col-lg-12 col-sm-12 col-xs-12 pad-0 mar-bottom-10">\n                                <div class="col-lg-12 col-sm-12 col-xs-12 optimization-body-li">\n                                    <div class="col-lg-6 col-sm-6 col-xs-6 text-left optimization-body-li-text">{{\'editorBtn.colorHue\' | translate}}</div>\n                                    <div class="col-lg-6 col-sm-6 col-xs-6 text-right optimization-body-li-num">{{vm.elementOn.item.image.hue}}</div>\n                                </div>\n                                <div class="col-lg-12 col-sm-12 col-xs-12 optimization-body-li">\n                                    <input type="range"  min="-100" max="100" step="1" value="0" class="text-range-100 rangeSize saturation-range"\n                                           ng-model="vm.elementOn.item.image.hue" ng-change="changeHue()"/>\n                                </div>\n                            </div>\n                        </div>\n                    </div> --></button> <button class="nav-lock tool-bar-btn" ng-class="{\'selected-dashed\': vm.isTransp,\' tool-bar-btn-select\' : vm.transparencyBtn}"><i class="icon iconfont icontoumingdu" ng-click="transparencySelect(!vm.isTransp)"></i><div class="tip3">{{\'editorBtn.transparency\' | translate}}</div><div class="roundedSet" ng-show="vm.isTransp"><div class="roundedSet-title"><h4 class="rightPanel-title">{{\'editorBtn.transparencySet\' | translate}}</h4></div><div><div class="c-schedule-view"><input type="range" min="0" style="flex:1;margin-right: 10px" max="1" step="0.1" value="1" class="text-range-140 rangeSize transparency-range"> <input type="number" style="width: 45px" class="slider-input transparency-num" min="0" onmousewheel="return false;" ng-model="vm.transparency" ng-change="transparencyChange()"></div></div></div></button> <button class="nav-lock tool-bar-btn" ng-click="locking()" ng-class="{\'tool-bar-btn-select\' : vm.lockingBtn}"><i class="icon iconfont iconduomeitiicon-"></i><!-- <div class="tip6" ng-show="vm.elementOn.item.lock && vm.lockingBtn"></div> --><div class="roundedSet" style="width:112px" ng-show="vm.elementOn.item.lock && vm.lockingBtn">{{\'editorBtn.lock\' | translate}}</div></button> <button class="nav-lock tool-bar-btn" ng-class="{\'selected-dashed\': vm.isAlign,\'tool-bar-btn-select\' : !vm.elementOn.item.lock&&vm.elementOn.item || vm.toobarAlignmentBtn}"><i class="icon iconfont iconzuoduiqi2" ng-click="alignHover2()"></i><div class="tip3">{{\'editorBtn.align\' | translate}}</div><div class="roundedSet" ng-show="vm.isAlign && !vm.elementOn.item.lock && vm.elementOn.item" style="width: 240px"><h4 class="rightPanel-title" style="margin-top: 0">{{\'editorBtn.alignendsHorizontally\' | translate}}</h4><div style="display: flex;flex-wrap: wrap;flex-direction: unset"><div class="alignLi" ng-click="singleBoxAlignment(\'left\')"><i class="icon iconfont iconzuoduiqi"></i><div>{{\'editorBtn.alignLeft\' | translate}}</div></div><div class="alignLi" ng-click="singleBoxAlignment(\'right\')"><i class="icon iconfont iconyouduiqi"></i><div>{{\'editorBtn.alignRight\' | translate}}</div></div><div class="alignLi" ng-click="singleBoxAlignment(\'standard\')"><i class="icon iconfont iconchuizhijuzhong"></i><div>{{\'editorBtn.centerHorizontally\' | translate}}</div></div><div class="alignLi" ng-click="singleBoxAlignment(\'vertical\')"><i class="icon iconfont iconshuipingjuzhong"></i><div>{{\'editorBtn.centerVertical\' | translate}}</div></div><div class="alignLi" ng-click="singleBoxAlignment(\'top\')"><i class="icon iconfont iconshangduiqi"></i><div>{{\'editorBtn.alignTop\' | translate}}</div></div><div class="alignLi" ng-click="singleBoxAlignment(\'bottom\')"><i class="icon iconfont iconxiaduiqi"></i><div>{{\'editorBtn.alignBottom\' | translate}}</div></div></div><div ng-if="vm.distribute" style="margin-top: 10px"><h4 class="rightPanel-title" style="margin-top: 0">{{\'editorBtn.distributionElement\' | translate}}</h4><div style="display: flex;flex-wrap: wrap;flex-direction: unset"><div class="alignLi" ng-click="boxDistribute(\'horizontal\')"><i class="icon iconfont iconHorCenter"></i><div>{{\'editorBtn.distributionHorizontally\' | translate}}</div></div><div class="alignLi" ng-click="boxDistribute(\'vertical\')"><i class="icon iconfont iconVerCenter"></i><div>{{\'editorBtn.distributionVertical\' | translate}}</div></div></div></div></div></button> <button class="nav-lock tool-bar-btn" ng-click="generBox()" ng-class="{\'tool-bar-btn-select\' : vm.generBoxBtn}"><i class="icon iconfont iconfuzhi_copy-one font-18"></i><div class="tip4">{{\'editorBtn.iterative\' | translate}}</div></button> <button class="nav-coverage tool-bar-btn" ng-class="{\'selected-dashed\': vm.isCoverage, \'tool-bar-btn-select\' : vm.coverageBtn}"><i class="icon iconfont icontuceng" ng-click="coverageSelect(!vm.isCoverage)"></i><div class="tip5" style="left:-3px">{{\'editorBtn.coverage\' | translate}}</div><div class="roundedSet" style="width:220px" ng-show="vm.isCoverage && vm.coverageBtn" style="z-index: 1000"><div class="roundedSet-title"><h4 class="rightPanel-title">{{\'editorBtn.coverageMove\' | translate}}</h4></div><div><div class="c-schedule-view hover-coverageMove" style="padding:5px 0" ng-click="coverageMove(\'top\')"><span class="c-schedule-title"><img style="width:20px" src="content/images/icon/coverage-top.png" alt=""></span><div class="font-size:14px;">{{\'editorBtn.coverageTop\' | translate}}</div></div><div class="c-schedule-view hover-coverageMove" style="padding:5px 0" ng-click="coverageMove(\'up\')"><span class="c-schedule-title"><img style="width:20px" src="content/images/icon/Bring-forward.png" alt=""></span><div class="font-size:14px;">{{\'editorBtn.coverageUp\' | translate}}</div></div><div class="c-schedule-view hover-coverageMove" style="padding:5px 0" ng-click="coverageMove(\'down\')"><span class="c-schedule-title"><img style="width:20px" src="content/images/icon/send-behind.png" alt=""></span><div class="font-size:14px;">{{\'editorBtn.coverageDown\' | translate}}</div></div><div class="c-schedule-view hover-coverageMove" style="padding:5px 0" ng-click="coverageMove(\'bottom\')"><span class="c-schedule-title"><img style="width:20px" src="content/images/icon/coverage-bottom.png" alt=""></span><div class="font-size:14px;">{{\'editorBtn.coverageBottom\' | translate}}</div></div></div></div></button> <button class="nav-copy tool-bar-btn" ng-click="copyimg($event)" ng-class="{\'tool-bar-btn-select\' : vm.copyBtn}"><i class="icon iconfont iconfuzhi font-18"></i><div class="tip">{{\'editorBtn.copy\' | translate}}</div></button> <button class="nav-delete tool-bar-btn" ng-click="deleteBox($event)" ng-class="{\'tool-bar-btn-select\' : vm.deleteBtn}"><i class="icon iconfont iconshanchu font-18"></i><div class="tip">{{\'editorBtn.delete\' | translate}}</div></button></div></div><div class="editor-body" ng-style="{\'left\':vm.leftShow ? \'\' : \'72px\',\'right\':vm.rightShow?\'\':\'42px\'}" style="background: #dfe0e3;position: absolute;top: 40px" id="canvasView"><trimbox-pop></trimbox-pop><div class="leftPanel-mainContent-toggle" ng-click="vm.leftShow = !vm.leftShow;updateMeasureRuler()"><i class="iconfont iconzuojian" ng-show="vm.leftShow"></i> <i class="iconfont iconyoujian" ng-show="!vm.leftShow"></i></div><div class="rightPanel-mainContent-toggle" style="right: 0" ng-click="vm.rightShow = !vm.rightShow;updateMeasureRuler()"><i class="iconfont iconzuojian" ng-show="!vm.rightShow"></i> <i class="iconfont iconyoujian" ng-show="vm.rightShow"></i></div><div ng-if="!vm.pageData[vm.pageIndex].isEditboxMagnify" class="col-lg-12 col-sm-12 col-xs-12 tip-pic-text" style="top:15px"><div class="col-lg-6 col-sm-6 col-xs-6" style="color:#999999"><div translate="editorCommon.templateHint" translate-values="{numAll:vm.counts,num:vm.current}"></div></div><div class="col-lg-6 col-sm-6 col-xs-6" style="text-align: right;color: #999999">{{\'editorCommon.canvasSize\' | translate}}\uFF1A{{transitionMm(vm.pageData[vm.pageNumber].custom.width) | number:0}}mm * {{transitionMm(vm.pageData[vm.pageNumber].custom.height) | number:0}}mm</div></div><div class="c-editboxMagnify-text" ng-if="vm.pageData[vm.pageIndex].isEditboxMagnify" ng-click="onRatioinfo1()"><i class="iconfont iconquanping"></i>\u9000\u51FA\u653E\u5927\u6A21\u5F0F</div><div style="position: relative; width: 100%; height: 100%; overflow: hidden"><div class="relative-view" ng-click="editorBodyView($event)"></div><div id="pageCanvas" style="position: absolute; left: 50%; top: 50%; z-index: 9; display: flex; justify-content: center; align-items: center" ng-style="{\n                        width: vm.pageMaxWidth,\n                        height: vm.pageMaxHeight,\n                        \'margin-left\': -vm.pageMaxWidth/2 + vm.moveCanvasObj.x,\n                        \'margin-top\': -vm.pageMaxHeight/2 + vm.moveCanvasObj.y,\n                     }"><div class="relative-view" ng-click="editorBodyView($event)"></div><div id="pageCanvasView" style="position: relative; width: fit-content; height: fit-content;display: flex; justify-content: center; align-items: center" ng-if="!vm.isCalendar"><div ng-if="vm.pageData && vm.pageNumber1 > -1 && vm.pageData[vm.pageNumber1]" class="pageCanvasItem pageCanvasItem1" data-pageindex="{{vm.pageNumber1}}" data-pageindex1="1" ng-click="pageInfo(vm.pageNumber1)" style="position: relative; z-index: 1" ng-style="{\'z-index\': vm.pageNumber == vm.pageNumber1 ? 2 : 1, \'overflow\': vm.elementOn.pageIndex == vm.pageNumber1 ? \'visible\' : \'hidden\'}"><page-edit ng-if="!vm.isCut" that="vm" page-data="vm.pageData" page-index="vm.pageNumber1" page-number="vm.pageNumber" element-on="vm.elementOn" move-canvas-obj="vm.moveCanvasObj" img-size="vm.imgSize" img-dpi="vm.imgDpi" on-ratioinfo="onRatioinfo(text)"></page-edit></div><div ng-if="vm.pageNumber2 > -1" class="pageCanvasItem pageCanvasItem2" data-pageindex="{{vm.pageNumber2}}" data-pageindex1="2" ng-click="pageInfo(vm.pageNumber2)" style="position: relative; z-index: 1" ng-style="{\'z-index\': vm.pageNumber == vm.pageNumber2 ? 2 : 1, \'overflow\': vm.elementOn.pageIndex == vm.pageNumber2 ? \'visible\' : \'hidden\'}"><page-edit ng-if="!vm.isCut" that="vm" page-data="vm.pageData" page-index="vm.pageNumber2" page-number="vm.pageNumber" element-on="vm.elementOn" move-canvas-obj="vm.moveCanvasObj" img-size="vm.imgSize" img-dpi="vm.imgDpi" on-ratioinfo="onRatioinfo(text)"></page-edit></div><div class="c-change-page" ng-if="vm.pageData && vm.pageNumber1 > -1 && vm.pageData[vm.pageNumber1]"><div class="c-change-view mar-bottom-10" uib-tooltip="\u968F\u673A\u6362\u4E00\u6362\u5907\u7528\u9875" tooltip-placement="bottom" ng-if="vm.pageNumber2 == -1 && vm.pageData[vm.pageNumber1] && template.replace && !vm.pageData[vm.pageNumber1].unreplace && vm.pageData[vm.pageNumber1].recommendLayout.length>1" ng-click="changePage(vm.pageNumber1)"><i class="iconfont iconhuanyihuan"></i></div><div class="c-change-view-body mar-bottom-10" style="position: relative" ng-if="\n                             vm.pageNumber2 > -1 &&\n                             template.replace &&\n                             ((vm.pageData[vm.pageNumber1] && !vm.pageData[vm.pageNumber1].unreplace && vm.pageData[vm.pageNumber1].recommendLayout.length>1) || (vm.pageData[vm.pageNumber2] && !vm.pageData[vm.pageNumber2].unreplace && vm.pageData[vm.pageNumber2].recommendLayout.length>1))"><div class="c-change-view mar-bottom-10" uib-tooltip="\u968F\u673A\u6362\u4E00\u6362\u5907\u7528\u9875" tooltip-placement="bottom" ng-click="changePage1($event)"><i class="iconfont iconhuanyihuan"></i></div><div class="c-change-view1" style="position: absolute; left: -71px; top: 50%; margin-top: -32px" ng-if="vm.isChangePage1"><i class="iconfont iconyoujiantou c-change-view-jt"></i><div class="c-change-view1-btn" uib-tooltip="\u968F\u673A\u6362\u4E00\u6362\u5907\u7528\u9875" tooltip-placement="bottom" ng-if="vm.pageData[vm.pageNumber1] && !vm.pageData[vm.pageNumber1].unreplace && vm.pageData[vm.pageNumber1].recommendLayout.length>1" ng-click="changePage(vm.pageNumber1)"><i class="iconfont iconzuo"></i> <span>\u5DE6\u8FB9</span></div><div class="c-change-view1-btn" uib-tooltip="\u968F\u673A\u6362\u4E00\u6362\u5907\u7528\u9875" tooltip-placement="bottom" ng-if="vm.pageData[vm.pageNumber2] && !vm.pageData[vm.pageNumber2].unreplace && vm.pageData[vm.pageNumber2].recommendLayout.length>1" ng-click="changePage(vm.pageNumber2)"><i class="iconfont iconyou"></i> <span>\u53F3\u8FB9</span></div></div></div><div class="c-change-view" ng-class="{\'c-change-view-select\':vm.isLayout}" uib-tooltip="\u5F00\u542F\u6216\u5173\u95ED\u4F7F\u7528\u81EA\u52A8\u5E03\u5C40\u529F\u80FD\uFF0C\u4F1A\u5728\u60A8\u62D6\u5165\u7167\u7247\u65F6\u81EA\u52A8\u9009\u62E9\u4E00\u4E2A\u5408\u9002\u7684\u5E03\u5C40" tooltip-placement="bottom" ng-if="vm.picLayoutXmlsList && vm.picLayoutXmlsList.length>0 && !vm.pageData[vm.pageNumber].unreplace" ng-click="vm.isLayout = !vm.isLayout"><i class="iconfont iconbuju1"></i></div></div></div></div></div><div style="opacity: 0; position: absolute; left: 0; bottom: 0" ng-style="{\'width\': (vm.pageData[vm.pageNumber].trimbox.width-10)}"><pre id="c-xml-page-material-fontId" style="display: inline-block; opacity: 0" ng-style="{\n                    \'font-family\': \'\\\'\' + vm.elementOn.item.fontuuid + \'\\\'\',\n                    \'font-size\': (vm.elementOn.item.style.size) + \'pt\',\n                    \'color\': vm.elementOn.item.style.color,\n                    \'font-weight\': vm.elementOn.item.style.bold ? \'bold\': \'400\',\n                    \'font-style\': vm.elementOn.item.style.italic ? \'italic\': \'initial\',\n                    \'line-height\': (vm.elementOn.item.style.size) + \'pt\',\n                    \'letter-spacing\': (vm.elementOn.item.style.letterspacing) + \'pt\',\n                    \'text-decoration\': \'none\',\n                    \'text-align-last\': \'unset\',\n                    \'max-width\' : \'100%\',\n                    }"><span class="c-xml-page-textboxe-span">{{vm.elementOn.item.text}}</span></pre></div><div style="opacity: 0; position: absolute; left: 0; bottom: 0" ng-style="{\n            \'width\': writingmodeInit(vm.elementOn.item.style.writingmode) ? \'auto\' : (vm.elementOn.item.geometry.width),\n            \'height\': !writingmodeInit(vm.elementOn.item.style.writingmode) ? \'auto\' : (vm.elementOn.item.geometry.height)\n            }"><pre id="c-xml-page-material-fontId1" style="display: inline-block; opacity: 0" ng-style="{\n                    \'font-family\': \'\\\'\' + vm.elementOn.item.fontuuid + \'\\\'\',\n                    \'font-size\': (vm.elementOn.item.style.size) + \'pt\',\n                    \'color\': vm.elementOn.item.style.color,\n                    \'font-weight\': vm.elementOn.item.style.bold ? \'bold\': \'400\',\n                    \'font-style\': vm.elementOn.item.style.italic ? \'italic\': \'initial\',\n                    \'letter-spacing\': (vm.elementOn.item.style.letterspacing) + \'pt\',\n                    \'text-decoration\': \'none\',\n                    \'text-align-last\': \'unset\',\n                    \'max-width\' : \'100%\',\n                    \'writing-mode\': vm.elementOn.item.style.writingmode\n                    }"><span class="c-xml-page-textboxe-span">{{vm.elementOn.item.text}}</span></pre></div><div style="opacity: 0; position: absolute; left: 0; bottom: 0" ng-style="{\n            \'width\': writingmodeInit(vm.elementOn.item.style.writingmode) ? \'auto\' : (vm.elementOn.item.geometry.width),\n            \'height\': !writingmodeInit(vm.elementOn.item.style.writingmode) ? \'auto\' : (vm.elementOn.item.geometry.height)\n            }"><pre id="c-xml-page-material-fontId2" style="display: inline-block; opacity: 0" ng-style="{\n                    \'font-family\': \'\\\'\' + vm.elementOn.item.fontuuid + \'\\\'\',\n                    \'font-size\': (vm.elementOn.item.style.size) + \'pt\',\n                    \'color\': vm.elementOn.item.style.color,\n                    \'font-weight\': vm.elementOn.item.style.bold ? \'bold\': \'400\',\n                    \'font-style\': vm.elementOn.item.style.italic ? \'italic\': \'initial\',\n                    \'line-height\': vm.elementOn.item.style.lineheight + \'pt\',\n                    \'letter-spacing\': (vm.elementOn.item.style.letterspacing) + \'pt\',\n                    \'text-decoration\': \'none\',\n                    \'text-align-last\': \'unset\',\n                    \'max-width\' : \'100%\',\n                    \'writing-mode\': vm.elementOn.item.style.writingmode\n                    }"><span class="c-xml-page-textboxe-span">{{vm.elementOn.item.text}}</span></pre></div><!--\u523B\u5EA6\u5C3A--><div class="graduatedScale-unit" ng-show="vm.staff">mm</div><div id="graduatedScale-cross" ng-show="vm.staff"></div><div id="graduatedScale-vertical" ng-show="vm.staff"></div><div id="graduatedScale-cross-hr" ng-show="vm.staff" ng-mousedown="moveLineReference1($event,\'x\')"></div><div id="graduatedScale-vertical-hr" ng-show="vm.staff" ng-mousedown="moveLineReference1($event,\'y\')"></div><!-- \u523B\u5EA6\u7EBF --><div ng-if="vm.staff"><div class="lineReference-x" ng-style="{left:canvasCoordX() + vm.lineReferenceX * vm.pageData[vm.pageNumber1].custom.ratio}" ng-if="vm.lineReferenceX != null"></div><div class="lineReference-y" ng-style="{top:canvasCoordY() + vm.lineReferenceY*vm.pageData[vm.pageNumber1].custom.ratio}" ng-if="vm.lineReferenceY != null"></div><div class="lineReference-x1" ng-repeat="item in template.xLines.line track by $index" ng-style="{left:canvasCoordX() + item * vm.pageData[vm.pageNumber1].custom.ratio}" ng-mousedown="moveLineReference($event,item, $index, \'x\')"><div class="lineReference-x1-hr"></div><span class="lineReference-item">{{PxTurnMm(item) | number:0}}</span></div><div class="lineReference-y1" ng-repeat="item in template.yLines.line track by $index" ng-style="{top:canvasCoordY() + item*vm.pageData[vm.pageNumber1].custom.ratio}" ng-mousedown="moveLineReference($event,item, $index, \'y\')"><div class="lineReference-y1-hr"></div><span class="lineReference-item">{{PxTurnMm(item) | number:0}}</span></div></div></div><div class="editor-nav3 hover-scrollbar" ng-style="{\'width\':vm.rightShow ? \'268px\' : \'42px\'}"><div class="load-mask1" ng-if="vm.pageListLoading"><img src="content/images/icons/loading-pic.gif" style="width: 50px"></div><div ng-show="vm.rightShow"><three-preview2 source="\'webMin\'" width="230" height="230" moulds="vm.product.moulds" model-path="vm.productXmlData.modelPath" model-blendents="vm.productXmlData.modelBlendent" model-data="vm.productXmlData.modelData" model-blendent-uuid="vm.article.modelBlendentUuid" pages="vm.pageData1" on-change="previewTab()" ng-if="vm.isHtml2canvas && vm.productXmlData && vm.productXmlData.modelType && vm.productXmlData.modelType === \'THREE\' && !vm.threeView"></three-preview2><div class="c-editor-mini-page-tab c-editor-mini-page-tab1"><div ng-class="{\'c-editor-min-page-tab-select\':vm.editorMiniPage == \'page\'}" ng-click="editorMiniPageCb(\'page\')">{{\'editorCommon.pageList.page\' | translate}}</div><div ng-class="{\'c-editor-min-page-tab-select\':vm.editorMiniPage == \'level\'}" ng-click="editorMiniPageCb(\'level\')">{{\'editorCommon.pageList.coverage\' | translate}}</div></div><div class="c-editor-page hover-scrollbar" ng-show="vm.editorMiniPage == \'page\'" style="position: relative"><div ng-repeat="part in template.config.parts.list" ng-if="part.counter>0"><div class="partTile" uib-tooltip="{{partNamt(part.id)}}" tooltip-placement="bottom">{{partNamt(part.id)}}</div><div ng-if="part.id != \'P\'"><div class="editor-body-view add-page-del-show" ng-repeat="item in vm.pageData track by $index" ng-click="turning($index)" ng-if="part.id == item.config.partid" style="margin: 0 auto 20px; width: fit-content; position: relative"><div class="editor-body-view-page" style="position: relative" ng-class="{\n                                \'nav-active\': $index == vm.pageNumber,}"><page-preview page="item" scale="item.custom.ratio1" is-imagebox-not="true" img-size="vm.imgSize" img-dpi="vm.imgDpi" ng-if="item && !vm.isCalendar && !vm.minLoading"></page-preview><!--                                    <div class="editor-nav3-pageNum">--><!--                                        {{getIndex(item)}}--><!--                                    </div>--></div></div></div><div id="pageList" ng-if="part.id == \'P\'&&vm.pageData.length>0"><div class="editor-body-view sortingPageView add-page-del-show" ng-repeat="item in vm.pageData track by $index" ng-click="turning($index)" data-id="{{$index+1}}" ng-class="{\n                                \'filtered\':!(!item.unreplace&&template.replace?true:false),\n                                \'notDrag\': !(!item.unreplace&&template.replace?true:false)}" data-page="{{item.pageUuid}}" ng-show="part.id == item.config.partid" style="margin: 0 auto 20px; width: fit-content; position: relative"><div class="editor-body-view-page" style="position: relative" ng-class="{\n                                    \'nav-active\': $index == vm.pageNumber,}"><page-preview page="item" scale="item.custom.ratio1" is-imagebox-not="true" img-size="vm.imgSize" img-dpi="vm.imgDpi" ng-if="item && !vm.isCalendar && !vm.minLoading"></page-preview><div class="editor-nav3-pageNum">{{getIndex1($index)}}</div></div><i class="icon iconfont icongongjulan71 add-page-del" uib-tooltip="{{\'button.delete\' | translate}}" tooltip-placement="left" ng-if="vm.product.addPage && vm.article.xml.addpage&&template.pages.page.length>vm.article.xml.minpage && template.config.productType == \'BOOK\'" ng-click="delAddPage($index)"></i></div></div></div></div><div class="rightPanel2-bottom-addPage" ng-click="addPages1()" ng-if="vm.product.addPage && vm.pageData[vm.pageNumber].config.partid == \'P\' && vm.editorMiniPage == \'page\' && vm.article.xml.addpage && template.config.productType == \'BOOK\' && template.pages.page.length < vm.article.xml.maxpage"><img src="content/images/icon/editor-addPage.png" uib-tooltip="{{\'editorCommon.addPage\' | translate}}" tooltip-placement="left" alt="" srcset=""></div><!--                <div class="rightPanel2-bottom-addPage2" ng-if="vm.editorMiniPage == \'page\' && (vm.picLayoutXmlsList.length>0) && (vm.counts-vm.current == 0) && template.config.productType == \'BOOK\'" ng-click="stochastic()">--><!--                    <img src="content/images/icon/editor-addPage2.png" alt="" srcset="" uib-tooltip="{{\'editorCommon.randomPlacement\' | translate}}" tooltip-placement="left">--><!--                </div>--><div class="c-editor-page hover-scrollbar" ng-show="vm.editorMiniPage == \'level\'"><div class="c-editor-page-view" ng-show="vm.pageData[vm.pageNumber] && vm.pageData[vm.pageNumber].levels && vm.pageData[vm.pageNumber].levels.level && vm.isEditorPageElementBody" id="pageList1"><div class="c-editor-page-view-li" id="c-editor-page-view-li{{$index}}" ng-repeat="level in vm.pageData[vm.pageNumber].levels.level | reverse"><div class="c-editor-page-view-li-view sortingPageView" style="position: relative" data-page="{{level}}" ng-click="dragCompleteClick($event,level,$index)"><div class="c-editor-page-view-li-view-img" ng-class="{\'nav-active\' : (vm.elementOn.index == vm.completeIndex($index))}"><img ng-if="level.imagebox && level.imagebox.image && level.imagebox.image.resource && level.imagebox.image.resource.identifier" ng-src="{{level.imagebox.image.resource.identifier + \'?imageMogr2/auto-orient/thumbnail/128x128>\'}}"> <img ng-if="level.imageart && level.imageart.resource && level.imageart.resource.identifier" ng-src="{{level.imageart.resource.identifier + \'?imageMogr2/auto-orient/thumbnail/128x128>\'}}"> <i class="iconfont iconziti" ng-if="level.textbox || level.textdocument"></i> <i class="iconfont iconerweima" ng-if="level.code"></i> <i class="iconfont iconzhaopian_huabanfuben" ng-if="level.imagebox && (!level.imagebox.image || !level.imagebox.image.resource || !level.imagebox.image.resource.identifier)"></i> <i class="iconfont icontishi c-editor-page-view-li-view-iconWarn" ng-if="level.textbox && level.textbox.success === false" style="top: 17px;\n                                        right: 9px;\n                                        left: inherit;\n                                        font-size: 26px;\n                                        color: var(--webMainButtonBackColor)"></i></div><div class="c-editor-page-view-li-view-font"><div class="c-editor-page-view-li-view-font-sh" ng-click="levelHidden($event, level)"><i class="iconfont iconyanjing font-12" ng-if="!level.isHidden"></i> <i class="iconfont iconyanjing1 font-12" ng-if="level.isHidden"></i> <span class="c-editor-page-view-li-view-font-sh-span" uib-tooltip="{{levelInfo(level, $index)}}" tooltip-placement="bottom">{{levelInfo(level, $index)}}</span></div><i class="iconfont icondustbin_icon font-12" ng-click="levelDelete($index)"></i></div></div></div></div></div></div><div class="page-top2" ng-show="!vm.rightShow"><div class="page-nav1"><div class="nav-ul1"><ul ng-model="template.pages.page"><div class="rightPanel-hide-div">{{\'editorCommon.pageList.page\' | translate}}</div><li ng-repeat="page in template.pages.page track by $index" style="" ng-class="{\'nav2-active\': $index == vm.pageNumber}" ng-click="turning($index)" data-index="{{$index}}" class="pad-lr-10 page-nav-box rightPanel-hide-li"><div>{{$index+1}}</div></li></ul></div></div></div></div></div><!--2D\u9884\u89C8--><div ng-if="vm.watchSure" class="preview-article hover-scrollbar" ng-style="{\n            \'background\': vm.toneSettings.previewBkWeb ? \'url(\' + vm.toneSettings.previewBkWeb + \')no-repeat top left scroll\' : \'#ECECEC\',\n            \'background-size\': \'cover\'\n        }"><img class="preview-article-close" src="content/images/icons/close4.svg" width="20px" ng-click="vm.watchSure = false"><div class="preview-article-con"><article-preview article="vm.article" document-page="vm.previewArticle" editor-type="vm.article.editorType" bindingtype="vm.bindingtype" is-landscape="false" is-nav="true" ng-if="vm.bindingtype != \'LeftNew\'"></article-preview><editor-preview-mini article="vm.article" document-page="vm.previewArticle" ng-if="vm.bindingtype === \'LeftNew\'" is-nav="true"></editor-preview-mini></div></div><!-- 3D\u9884\u89C8 --><div ng-if="vm.threeView" class="preview-article" style="z-index: 1100" ng-style="{\n            background: vm.toneSettings.previewBkWeb ? \'url(\' + vm.toneSettings.previewBkWeb + \') no-repeat left top 100%/100%\' : \'#ECECEC\'\n        }"><img class="preview-article-close" src="content/images/icon-close.svg" width="20px" ng-click="vm.threeView = false"><div class="preview-article-con1" style="overflow: auto;height: 100%"><three-preview3 source="\'webMax\'" moulds="vm.product.moulds" model-path="vm.productXmlData.modelPath" model-blendents="vm.productXmlData.modelBlendent" model-data="vm.productXmlData.modelData" model-blendent-uuid="vm.article.modelBlendentUuid" pages="vm.pageData1" ng-if="vm.isHtml2canvas && vm.productXmlData && vm.productXmlData.modelType && vm.productXmlData.modelType === \'THREE\'"></three-preview3><!--            <three-preview style=" background: #fff;"--><!--                           model-blendent-uuid="vm.article.modelBlendentUuid" product-xml="vm.productXmlData"--><!--                           pages="vm.pageData1"></three-preview>--></div></div></div><!--\u7F29\u7565\u56FEview--><div id="thumbnail-view" style="position: absolute; z-index: -1; overflow: hidden"><page-preview page="vm.thumbnailPageData" scale="vm.thumbnailPageData.custom.thumbnailScale" thumbnail="true" ng-if="vm.thumbnailPageData"></page-preview></div><!--\u7F29\u7565\u56FEview1--><div id="thumbnail-view1" style="position: absolute; z-index: -1; overflow: hidden"><page-preview page="vm.thumbnailPageData1" scale="vm.thumbnailPageData1.custom.thumbnailScale" thumbnail="true" cover="1" ng-if="vm.thumbnailPageData1"></page-preview></div><!--\u5220\u9664\u6587\u4EF6\u5939--><div class="three-modal" ng-if="vm.deleteSure" data-html2canvas-ignore><div class="dialog"><div class="dialog-titles"><div class="dialog-titles-title">{{\'nav.photograph.content.folders.btn.cancelPop.title\' | translate}}</div><i class="iconfont iconcuo dialog-close" ng-click="vm.deleteSure=false"></i></div><div class="dialog-content">{{\'nav.photograph.content.folders.btn.cancelPop.content\' | translate}}</div><div class="dialog-foot"><button type="button" class="dialog-foot-close" ng-click="vm.deleteSure = false">{{\'button.cancel\' | translate}}</button> <button type="button" class="dialog-foot-delete" ng-click="deleteFolders()">{{\'button.confirm\' | translate}}</button></div></div></div><!--\u5220\u9664\u5904\u7406\u5931\u8D25\u7684\u7167\u7247--><div class="three-modal" ng-if="vm.deletePhotoSure" data-html2canvas-ignore><div class="dialog"><div class="dialog-titles"><div class="dialog-titles-title">{{\'nav.photograph.content.deletePhoto.title\' | translate}}</div><i class="iconfont iconcuo dialog-close" ng-click="vm.deletePhotoSure=false"></i></div><div class="dialog-content">{{\'nav.photograph.content.deletePhoto.content\' | translate}}</div><div class="dialog-foot"><button type="button" class="dialog-foot-close" ng-click="vm.deletePhotoSure = false">{{\'button.cancel\' | translate}}</button> <button type="button" class="dialog-foot-delete" ng-click="deletePhotoConfirm()">{{\'button.confirm\' | translate}}</button></div></div></div><!--\u8F6C\u79FB\u7167\u7247--><div class="modal-property" ng-if="vm.isMoveToFolder" data-html2canvas-ignore><div class="modal-mask"></div><div class="content-scroll modal-con"><div class="col-lg-12 col-sm-12 modal-t"><span class="col-md-6 col-sm-6 col-xs-6 font-16 text-left">{{\'nav.photograph.content.btn.movePop.title\' | translate}}</span> <span class="col-md-6 col-sm-6 col-xs-6 text-right"><img src="content/images/icons/close1.svg" style="width: 16px" ng-click="vm.isMoveToFolder=false"></span></div><div class="col-lg-12 col-sm-12 pad-0 scrollbar" style="margin-top: 54px;height: 48vh"><ul class="col-lg-12 col-sm-12 pad-0 folder-ul"><li ng-class="{\'folder-active\':folder.selected}" ng-click="chooseFolder2()" ng-show="vm.folderId"><img src="content/images/icons/move_folder_big.svg"> <span class="text-ellipsis">\u56FE\u5E93</span> <button ng-if="vm.selectFolderId === -1"><img src="content/images/icons/folder_pre.svg" ng-click=""></button></li><li ng-repeat="folder in Folders track by $index" ng-show="vm.folderId != folder.id" ng-class="{\'folder-active\':folder.selected}" ng-click="chooseFolder(folder,$index)" data-index="{{$index}}" class="left-panel-hover folder{{$index}}"><img src="content/images/icons/move_folder_big.svg" data-index="{{$index}}" data-id="{{folder.id}}"> <span class="text-ellipsis">{{folder.name}}</span> <button ng-if="folder.selected"><img src="content/images/icons/folder_pre.svg" ng-click=""></button></li></ul></div><!--<div class="col-lg-12 col-sm-12" style="height: 80px;"></div>--><div class="col-lg-12 col-sm-12 pad-0"><button type="button" class="col-md-6 col-sm-6 col-xs-6" data-dismiss="modal" style="color: #232323;font-size: 15px;height: 60px;border-right:1px solid #E8E8E8" ng-click="vm.isMoveToFolder=false">{{\'button.cancel\' | translate}}</button> <button type="submit" style="background: var(--webMainButtonBackColor);color:var(--webMainButtonTextColor);font-size: 15px;height: 60px" class="col-md-6 col-sm-6 col-xs-6" ng-click="saveMoveToFolder()">{{\'button.save\' | translate}}</button></div></div></div><!--\u624B\u673A\u4F20\u56FE--><div style="z-index: 999; position: fixed; top: 0px; left: 0px; right: 0px; bottom: 0px; background-color: rgba(0,0,0,.5)" ng-show="vm.qrcodeShow" data-html2canvas-ignore><div style="width: 528px;background-color: #FFF; position:absolute;left: 50%;top: 50%;transform: translate(-50%,-50%);border-radius: 8px;overflow: hidden"><div class="modal-header" style="border: none;font-size: 18px;color:#333;font-weight: bold"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="uploadByPhone1()">&times;</button> {{\'editorPop.photoUpload.title\' | translate}}</div><div class="modal-body col-lg-12 col-sm-12" style="text-align: center"><div class="form-group col-lg-12 col-sm-12"><div style="color: #333333; font-size: 20px; opacity: 0.85">{{\'editorPop.photoUpload.describe\' | translate}}</div></div><div class="form-group col-lg-12 col-sm-12"><div id="qrcode1"></div></div><div class="form-group col-lg-12 col-sm-12" style="margin-top: 10px"><div style="color: #666666; font-size: 14px; opacity: 0.85">{{\'editorPop.photoUpload.describe1\' | translate}}</div><br><div style="color: #999999; font-size: 12px; opacity: 0.85">{{\'editorPop.photoUpload.describe2\' | translate}}</div></div></div></div></div><!-- \u9000\u51FA\u5F39\u7A97 --><div class="three-modal" ng-if="vm.exitSure" data-html2canvas-ignore><div class="dialog"><div class="dialog-titles"><div class="dialog-titles-title">{{\'editorPop.exitTitle\' | translate}}</div><i class="iconfont iconcuo dialog-close" ng-click="vm.exitSure = false"></i></div><div class="dialog-content">{{\'editorPop.exitWithoutSaveContent\' | translate}}</div><div class="dialog-foot" style="justify-content: space-between"><div><button type="button" class="dialog-foot-close" style="border: 1px solid #000" ng-click="exitPageCancel(true)">{{\'editorPop.iWantSave\' | translate}}</button></div><div style="display: flex;align-items: center"><button type="button" class="dialog-foot-close" style="border: 1px solid #000" ng-click="exitPageCancel()">{{\'editorPop.iThinkAboutIt\' | translate}}</button> <button type="button" class="dialog-foot-delete" style="background-color: rgb(220, 92, 67)" ng-click="exitPage()">{{\'editorPop.confirmExit\' | translate}}</button></div></div></div></div><div class="three-modal" ng-if="vm.isDirectFill" data-html2canvas-ignore><div class="dialog"><div class="dialog-titles"><div class="dialog-titles-title">{{\'editorCommon.hint\' | translate}}</div><i class="iconfont iconcuo dialog-close" ng-click="vm.isDirectFill=false"></i></div><div class="dialog-content">{{\'editorPop.directFill\' | translate}}</div><div class="dialog-foot"><button type="button" class="dialog-foot-close" ng-click="vm.isDirectFill = false">{{\'button.cancel\' | translate}}</button> <button type="button" class="dialog-foot-confirm" ng-click="fillPage()">{{\'button.confirm\' | translate}}</button></div></div></div><div class="c-modal exit-box" ng-if="vm.editFailedFont" data-html2canvas-ignore><div class="exit-box-mask"></div><div class="exit-font-con"><div class="col-lg-12 col-sm-12 exit-font-con-head"><div class="exit-font-con-line1"><i></i>{{\'editorPop.editFailedFont.title\' | translate}}</div><div class="exit-font-con-line2">{{\'editorPop.editFailedFont.name1\' | translate}}<span>({{vm.failedFontArr.failed}})</span><div>{{\'editorPop.editFailedFont.name2\' | translate}}</div></div><div class="exit-font-con-button" ng-click="editFont()"><button>{{\'button.amend\' | translate}}</button></div></div></div></div><!-- 2D\u548C3D\u5207\u6362 --><div class="editor-2d-3d-view" ng-if="!vm.moveCanvasView && vm.productXmlData.modelType && vm.productXmlData.modelType === \'THREE\'"><div class="editor-2d-3d-view-btn" ng-class="{\'editor-2d-3d-view-btn-select\':!vm.threeView}" ng-click="vm.threeView=false">2D</div><div>|</div><div class="editor-2d-3d-view-btn" ng-class="{\'editor-2d-3d-view-btn-select\':vm.threeView}" ng-click="previewTab($event)">3D</div></div><!-- \u753B\u5E03\u79FB\u52A8\u6A21\u5F0F\u4E2D --><div class="editor-2d-3d-view" ng-if="vm.moveCanvasView" style="z-index: 888; width: auto; gap: 14px; padding: 0 20px;left:520px"><div style="color: rgb(224, 30, 30)"><i class="iconfont iconshouxing" style="color: var(--webMainButtonBackColor);margin-right:5px"></i>\u753B\u5E03\u79FB\u52A8\u6A21\u5F0F\u4E2D</div><div class="editor-2d-3d-view-btn" style="color:#2834dd" ng-click="moveCanvasCb()">\u9000\u51FA</div></div><!--\u79FB\u52A8\u753B\u5E03--><div class="editor-body-view-ratio" ng-show="template" data-html2canvas-ignore><div class="editor-body-view-ratio-left"><div class="editor-body-view-ratio-icon"><i class="iconfont iconzuoceshouqi1" ng-show="vm.pageIndex > 0" ng-click="previousPage($event)" style="font-size: 14px"></i> <i class="iconfont iconzuoceshouqi1" ng-show="vm.pageIndex <= 0" style="opacity: 0.5;font-size: 14px"></i><div class="editor-body-view-ratio-title" ng-show="vm.pageIndex > 0">{{\'editorCommon.previousPage\' | translate}}</div></div><span class="editor-body-view-ratio-span"><span>{{vm.pageNumber1 + 1}}</span> <span ng-if="vm.pageNumber2<=vm.pageSum &&vm.pageNumber2>vm.pageNumber1">|</span> <span ng-if="vm.pageNumber2<=vm.pageSum &&vm.pageNumber2>vm.pageNumber1">{{vm.pageNumber2 + 1}}</span></span><div class="editor-body-view-ratio-icon"><i class="iconfont iconyouceshouqi1" ng-if="vm.pageIndex<vm.pageSum" ng-click="nextPage($event)" style="font-size: 14px"></i> <i class="iconfont iconyouceshouqi1" ng-show="vm.pageIndex == vm.pageSum" style="opacity: 0.5" style="font-size: 14px"></i><div class="editor-body-view-ratio-title" ng-if="vm.pageIndex<vm.pageSum">{{\'editorCommon.nextPage\' | translate}}</div></div></div><div class="editor-body-view-ratio-right"><div class="editor-body-view-ratio-icon" ng-click="ratioJian()"><i class="iconfont iconjian2"></i><div class="editor-body-view-ratio-title">{{\'editorCommon.canvasReduce\' | translate}}</div></div><span class="editor-body-view-ratio-span">{{vm.pageData[vm.pageNumber].custom.ratio * 100 | number:0}}%</span><div class="editor-body-view-ratio-icon" ng-click="ratioJia()"><i class="iconfont iconjia2"></i><div class="editor-body-view-ratio-title">{{\'editorCommon.canvasMagnify\' | translate}}</div></div><div class="editor-body-view-ratio-icon" ng-click="ratioInit(true)"><i class="iconfont iconfangda"></i><div class="editor-body-view-ratio-title">{{\'editorCommon.initialScale\' | translate}}</div></div><div class="editor-body-view-ratio-icon" ng-class="{\'editor-body-view-ratio-icon-select\' : vm.moveCanvasView}" ng-click="moveCanvasCb()"><i class="iconfont iconicon-zhuashou"></i><div class="editor-body-view-ratio-title">{{\'editorCommon.canvasMove\' | translate}}</div></div><div class="editor-body-view-ratio-icon" ng-click="ratioOriginal()"><i class="iconfont icona-1bi11"></i><div class="editor-body-view-ratio-title">{{\'editorCommon.canvasInitial\' | translate}}</div></div></div></div><div class="moveCanvas-view" ng-class="{\'moveCanvas-view2\': !vm.leftShow}" ng-mousedown="moveCanvas($event)" ng-if="vm.moveCanvasView" data-html2canvas-ignore></div><div class="move-tip flex-center" ng-if="vm.hint" data-html2canvas-ignore><img src="content/images/icon/warning-icon.png" style="width: 20px;height: 20px" alt="" srcset=""><div class="mar-left-10">{{\'editorCommon.moveTip\' | translate}}</div></div><div class="three-modal1" ng-if="vm.threeLoading"><img src="content/images/icon/loading.gif" alt=""><div>{{vm.threeLoadingText}}</div></div><!--\u6587\u6863\u68C0\u6D4B--><div class="three-modal" data-html2canvas-ignore ng-if="!vm.documentDetection.pass"><div class="dialog" style="width: 800px"><div class="dialog-titles"><div class="dialog-titles-title">{{\'editorCommon.documentDetection\' | translate}}</div><i class="iconfont iconcuo dialog-close" ng-click="vm.documentDetection.pass=true"></i></div><div class="c-documentDetection-tab"><div ng-class="{\'c-documentDetection-tab-select\' : vm.documentDetectionTab==\'text\'}" ng-click="vm.documentDetectionTab=\'text\'" ng-if="vm.documentDetection.isText">{{\'editorCommon.documentDetectionTabText\' | translate}}</div><div ng-class="{\'c-documentDetection-tab-select\' : vm.documentDetectionTab==\'repetition\'}" ng-click="vm.documentDetectionTab=\'repetition\'" ng-if="vm.documentDetection.isRepetition">{{\'editorCommon.documentDetectionTabRepetition\' | translate}}</div></div><div class="dialog-content hover-scrollbar" style="max-height: 500px; overflow: auto" ng-if="vm.documentDetectionTab==\'text\'"><div><i class="iconfont icontishi mar-right-10" style="color: var(--genericColor)"></i>{{\'editorCommon.documentDetectionTextTitle\' | translate}}</div><div class="c-documentDetection-view mar-top-10" ng-repeat="page in vm.documentDetection.pages" ng-if="vm.documentDetection.pages && vm.documentDetection.pages.length>0"><div class="c-documentDetection-view-title">{{\'editorCommon.pageIndex\' | translate:({pageIndex:page.pageIndex})}}</div><div class="c-documentDetection-view-1"><div class="c-documentDetection-view-1-li-text" ng-repeat="item in page.texts" ng-if="page.texts && page.texts.length>0">{{item.text}}</div></div></div></div><div class="dialog-content hover-scrollbar" style="max-height: 500px; overflow: auto" ng-if="vm.documentDetectionTab==\'repetition\'"><div><i class="iconfont icontishi mar-right-10" style="color: var(--genericColor)"></i>{{\'editorCommon.documentDetectionRepetitionTitle\' | translate}}</div><div class="c-documentDetection-view mar-top-10" ng-repeat="page in vm.documentDetection.pages" ng-if="vm.documentDetection.pages && vm.documentDetection.pages.length>0"><div class="c-documentDetection-view-title">{{\'editorCommon.pageIndex\' | translate:({pageIndex:page.pageIndex})}}</div><div class="c-documentDetection-view-1"><div class="c-documentDetection-view-1-li" ng-repeat="level in page.repetitions" ng-if="page.repetitions && page.repetitions.length>0"><div class="c-documentDetection-view-1-li-fl"><img ng-if="level.imagebox && level.imagebox.image && level.imagebox.image.resource && level.imagebox.image.resource.identifier" ng-src="{{level.imagebox.image.resource.identifier + \'?imageMogr2/thumbnail/128x128>\'}}"> <img ng-if="level.imageart && level.imageart.resource && level.imageart.resource.identifier" ng-src="{{level.imageart.resource.identifier + \'?imageMogr2/thumbnail/128x128>\'}}"> <i class="iconfont iconziti" ng-if="level.textbox || level.textdocument"></i> <i class="iconfont iconerweima" ng-if="level.code"></i> <i class="iconfont iconzhaopian_huabanfuben" ng-if="level.imagebox && (!level.imagebox.image || !level.imagebox.image.resource || !level.imagebox.image.resource.identifier)"></i></div><div class="c-documentDetection-view-1-li-fr">{{levelInfo(level)}}</div></div></div></div></div><div class="dialog-foot"><button type="button" class="dialog-foot-close" ng-click="vm.documentDetection.pass=true">{{\'button.cancel\' | translate}}</button> <button type="button" class="dialog-foot-confirm" ng-click="vm.documentDetection.pass=true">{{\'editorCommon.goAdjust\' | translate}}</button></div></div></div><!--\u53F0\u5386\u8BBE\u7F6E\u5F00\u59CB\u6708\u4EFD--><div class="set-month-view" ng-class="{\'set-month-view-class\': vm.isCalendar1}" ng-if="vm.isCalendar || vm.isCalendar1" ng-click="isYearHide($event)"><div class="set-month-view-item"><div class="set-month-view-1"><div class="set-month-view-1-1">\u8BBE\u7F6E\u53F0\u5386\u5F00\u59CB\u7684\u6708\u4EFD</div><div class="set-month-view-1-2">\u9009\u62E9\u53F0\u5386\u5F00\u59CB\u7684\u6708\u4EFD\uFF0C\u6211\u4EEC\u5C06\u4ECE\u8FD9\u4E2A\u6708\u5F00\u59CB\u4E3A\u60A8\u5B9A\u5236{{vm.monthIndex1}}\u4E2A\u6708\u7684\u7F8E\u597D</div><div class="set-month-view-1-3"><i class="iconfont iconzuoceshouqi1" ng-class="{\'set-month-view-1-3-not\':vm.yearIndex==2000}" ng-click="yearIndex(\'subtract\')"></i><div class="set-month-view-1-3-1" ng-click="isYearShow($event)"><div class="set-month-view-1-3-1-title">{{vm.yearIndex}}</div><div class="set-month-view-1-3-1-body" ng-if="vm.isYear"><div class="set-month-view-1-3-1-body-1"><div class="set-month-view-1-3-1-body-1-span">{{vm.years[0]}}\u5E74-{{vm.years[vm.years.length-1]}}\u5E74</div><div class="set-month-view-1-3-1-body-hr"></div></div><div class="set-month-view-1-3-1-body-2"><div class="set-month-view-1-3-1-body-2-ul"><div class="set-month-view-1-3-1-body-2-ul-li" ng-repeat="item in vm.years track by $index" ng-if="vm.yearPage == mathFloor($index)" ng-class="{\'set-month-view-1-3-1-body-2-ul-li-selected\' : vm.yearIndex == item}" ng-click="yearIndexSave($event,item)">{{item}}</div></div><div class="set-month-view-1-3-1-body-2-page-turning"><i class="iconfont iconzuoceshouqi1" ng-click="yearPageCb(\'subtract\')"></i><!-- <span class="set-month-view-1-3-1-body-2-page-turning-1">{{vm.yearPage}}</span> --> <input type="text" min="1" class="set-month-view-1-3-1-body-2-page-turning-1" ng-model="vm.yearPage" ng-change="yearPageChange()"> <span style="margin: 0 6px">/</span> <span>{{vm.yearSize}}</span> <i class="iconfont iconyouceshouqi1" ng-click="yearPageCb(\'add\')"></i></div></div></div></div><i class="iconfont iconyouceshouqi1" ng-class="{\'set-month-view-1-3-not\':vm.yearIndex==vm.years[vm.years.length-1]}" ng-click="yearIndex(\'add\')"></i></div><div class="set-month-view-1-4"><div class="set-month-view-1-4-view" ng-repeat="item in vm.months"><div class="set-month-view-1-4-li" ng-click="vm.monthIndex=item" ng-class="{\'set-month-view-1-4-li-selected\' : vm.monthIndex==item}">{{item}}</div></div></div></div><div class="set-month-view-2"><div class="set-month-view-1-1">\u7ED3\u675F\u65E5\u671F</div><div class="set-month-view-1-2">{{getEndYear()}}\u5E74{{getEndMonth()}}\u6708</div></div><div style="margin-top: 30px;display: flex;justify-content: center; gap: 16px"><div class="set-month-view-3" ng-click="vm.isCalendar1 = false" ng-if="vm.isCalendar1" style="background-color: #f7f8fa; color: #333;margin: 0">\u53D6\u6D88</div><div class="set-month-view-3" ng-click="calendarSave()" style="margin: 0">{{vm.isCalendar1 ? \'\u786E\u5B9A\' : \'\u5F00\u59CB\u5236\u4F5C\'}}</div></div></div></div><canvas-image-filter ng-if="vm.showCanvasImageFilter" element-on="vm.elementOn" logo="vm.logo" product-title="vm.productTitle" product-xml-line="vm.productXmlLine"></canvas-image-filter><!-- \u62A0\u56FE --><image-cutout ng-if="vm.isShowImageCutout" :imagebox="vm.imageboxCutout" on-save="imageCutoutSave(text)" on-change="imageCutoutChange(text)"></image-cutout><!--\u91CD\u590D\u56FE\u7247--><duplicate-list domain-url="domain" ng-if="vm.isDuplicateList" list="vm.duplicateList" on-change="duplicateChange()"></duplicate-list><!-- \u586B\u5145\u60AC\u6D6E\u6309\u94AE --><div class="web-choose-set1-icon-1" ng-show="gallaryPic.length>0 && vm.chooseMenuStyle" ng-mouseenter="showChooseMenu($event)" ng-mouseleave="hideChooseMenu()"><div class="web-choose-set1-icon-1-view"><div class="web-choose-set1-icon-1-item" ng-click="directFill()">\u6DFB\u52A0\u5230\u6240\u6709\u9875</div><div class="web-choose-set1-icon-1-item" ng-click="directFillPage()">\u6DFB\u52A0\u5230\u5F53\u524D\u9875</div><i class="iconfont iconyoujiantou"></i></div></div><style>.lang-option{\n        height: 20px;\n        font-size: 14px;\n        color: #108DFE;\n        line-height: 20px;\n        margin-top: 18px;\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n    }\n\n    .lang-option:hover{\n        color:#ffffff !important;\n    }\n\n    .lang-div{\n        position: relative;\n        width: 100%;\n        height: 36px;\n        background-color: #1E1F22;\n        border-radius: 22px;\n        font-size: 14px;\n        font-weight: bold;\n        padding: 0px 16px;\n        color: #ffffff;\n        border: 1px solid rgba(255,255,255,0.2);\n    }\n    .lang-icn{\n        transform: rotate(90deg);\n        position: absolute;\n        right: 10px;\n        top: 0px;\n    }\n    .lang-icn i{\n        margin: 0 !important;\n    }\n\n    .lang-option-div{\n        width: 172px;\n        height: 224px;\n        background: rgba(0,0,0,0.85);\n        border: 1px solid rgba(255,255,255,0.2);\n        position: absolute;\n        top: 46px;\n        cursor: pointer;\n        z-index: 1000;\n        border-radius: 10px;\n        text-align: left;\n        padding: 0px 16px;\n    }</style>');
$templateCache.put('app/entities/page/editor-photo-both-web.html','<div class="c-view" style="background: #F5F7FA"><div class="editor-head"><div><div class="editor-logo"><img ng-src="{{vm.logo}}"></div><div class="editor-title" uib-tooltip="{{vm.productTitle + \'(\' + vm.productXmlLine.name +  \')\'}}" tooltip-placement="bottom-left">{{vm.productTitle}}\uFF08 {{vm.productXmlLine.name}} \uFF09</div><div class="editor-number"><span>{{\'editorCommon.total\' | translate}}</span>{{ getTotalCountText() }}</div></div><div class="page-head-save" style="line-height: 36px"><span class="save-xml1 tool-bar-btn-select2" style="margin: 0 48px" role="button" tabindex="0" ng-show="vm.lagnuages.length>1"><div class="lang-div" ng-click="showLagnuages()"><span class="lang-icn"><i class="iconfont iconyoujian"></i> </span><span>{{vm.langKey}} &nbsp; &nbsp;</span></div><div class="lang-option-div" ng-show="vm.showLagnuages"><div class="lang-option" ng-repeat="lang in vm.lagnuages" ng-style="{\'color\':lang.selected ? \'#108DFE\' : \'#999999\'}" ng-click="changeLagnuage(lang)">{{lang.key}}</div></div></span><!-- <span class="save-exit" ng-click="exitWork($event)" role="button" tabindex="0">{{\'button.retreat\' | translate}}</span> --> <span class="save-xml1 tool-bar-btn-select2" ng-click="exitWork($event)" role="button" tabindex="0"><i class="iconfont icontuichu"></i> <i>{{\'button.retreat\' | translate}}</i></span> <span class="save-release" ng-click="save($event)" role="button" tabindex="0">{{\'button.save3\' | translate}}</span></div></div><div class="editor-nav scrollbar"><ul><li class="leftPanel-photo" ng-class="{\'leftPanel-photo-active\':vm.nav==\'picture\'}" ng-click="vm.navSelect(\'picture\')"><i class="icon iconfont iconzhaopian"></i> <span>{{\'nav.photograph.title\' | translate}}</span><!-- <div class="leftPanel-border"></div> --></li><li class="leftPanel-photo" ng-class="{\'leftPanel-photo-active\':vm.nav==\'template\'}" ng-click="vm.navSelect(\'template\')"><i class="icon iconfont iconhuanshu"></i> <span>{{\'nav.template1.title\' | translate}}</span><!-- <div class="leftPanel-border"></div> --></li><!--            <li ng-class="{\'leftPanel-photo-active\':vm.nav==\'reserve\'}" ng-click="vm.navSelect(\'reserve\')">--><!--                <i class="icon iconfont iconbanshi"></i>--><!--                <span>{{\'nav.reserve.title\' | translate}}</span>--><!--                &lt;!&ndash;                <div class="leftPanel-border"></div>&ndash;&gt;--><!--            </li>--></ul></div><div class="editor-nav-view" id="navId"><div class="editor-nav-view-li" ng-show="vm.nav==\'picture\'"><div class="editor-nav-view-li-title"><div class="editor-nav-view-li-title-left">{{\'nav.photograph.content.photo\' | translate}} <i class="iconfont icon31yiwen photo-query"><div class="photo-name-operate-div"><div class="photo-name-operate" style="font-size: 12px;width: 200px"><div>{{\'nav.photograph.content.photoHint\' | translate}}</div></div></div></i></div><div class="editor-nav-view-li-title-right" ng-show="!vm.folderId" ng-click="addFolder()">{{\'nav.photograph.content.btn.addPhotoAlbum\' | translate}}</div></div><div class="folder-view" style="padding: 0" ng-show="vm.folderId == \'\'"><ul class="clearfix folderUl" style="padding: 0"><li ng-click="showFolderContent()"><div><img class="folderUl-img" src="content/images/icon/photo_has.png" alt=""> <span class="folderUl-text">{{\'nav.photograph.content.folders.name\' | translate}}</span></div></li><li ng-repeat="folder in Folders track by $index" ng-if="$index<5 || vm.folderShow" ng-click="showFolderContent(folder)"><div><img class="folderUl-img" src="content/images/icon/web_folder.png" alt=""> <span class="folderUl-text">{{folder.name}}</span> <img class="folderUl-sel" src="content/images/icons/folder_sel.svg" ng-if="vm.folderId == folder.id"><div class="folderUl-delete"><img src="content/images/icon/genduo.png" alt=""><div class="photo-name-operate-div2" style="width:96px !important"><div class="photo-name-operate"><div ng-click="deleteShow(folder.id,$event)">{{\'button.delete\' | translate}}</div><div ng-click="updateFloders(folder,$event)">{{\'button.ren\' | translate}}</div></div></div></div></div></li></ul><button type="button" class="folder-down" ng-click="folderOn()" ng-if="Folders.length>5 && !vm.folderShow"><i class="iconfont iconxia"></i> {{\'button.spread\' | translate}}</button> <button type="button" class="folder-down1" ng-click="folderOn()" ng-if="Folders.length>5 && vm.folderShow"><i class="iconfont iconshang"></i> {{\'button.packUp\' | translate}}</button></div><div class="folder-content-title" ng-show="vm.folderId != \'\'"><span><i class="iconfont iconchangyongicon-" style="font-size: 20px"></i><span style="margin-left: 10px">{{vm.folderName}}</span></span> <span class="iconfont iconguanbi1" ng-click="showFolderContent()"></span></div><div class="editor-nav-view-li-web-local-photo"><button class="borderTheme opacityMinus web-local-photo" ng-click="uploadImage($event)"><span class="categoryPrice"><i class="iconfont iconyunshangchuan_o"></i> {{\'nav.photograph.content.btn.upload\' | translate}}</span> <input onchange="updatePic(event)" onclick="event.stopPropagation()" id="uploadImg2" type="file" multiple="multiple" accept="{{vm.supportedMimeTypes}}" name="file" value=""></button><!-- <div class="iconfont iconshouji phone-updatePic" ng-click="uploadByPhone()" style="font-size: 24px;"></div> --> <button class="web-local-photo" ng-click="uploadByPhone()"><span class="categoryPrice"><i class="iconfont iconshouji"></i> {{\'nav.photograph.content.btn.mobileUpload\' | translate}}</span></button></div><!-- <div class="editor-border-bottom">\n                <span class="web-photo-btn" ng-click="showFolderContent()">\n                    <img src="content/images/icons/photo_has.svg">\u5DF2\u9009\u7167\u7247\n                </span>\n                <span class="web-photo-btn" ng-click="addFolder()">\n                    <img src="content/images/icons/folder_create.svg">\u65B0\u5EFA\u6587\u4EF6\u5939\n                </span>\n            </div> --><div class="editor-nav-view-li-1"><div class="web-photo-nav"><div ng-class="{\'web-nav-active\':vm.photosTab==\'all\'}" ng-click="switchBgTab(\'all\')">{{\'nav.photograph.content.btn.allPhotos\' | translate}}</div><div ng-class="{\'web-nav-active\':vm.photosTab!=\'all\'}" ng-click="switchBgTab()">{{\'nav.photograph.content.btn.unused\' | translate}} <span style="font-size: 12px" ng-if="vm.unusedQuantity">\uFF08{{vm.unusedQuantity}}\uFF09</span></div></div><div class="editor-nav-view-li-seq2"><div class="editor-nav-view-li-seq2-left" style="margin-right: 8px"><img src="content/images/icon/refresh.png" style="width:16px" ng-click="vm.refreshPhotos()" uib-tooltip="{{\'nav.photograph.content.btn.refresh\' | translate}}" alt=""></div><div class="editor-nav-view-li-seq2-left" style="margin-right: 8px"><img src="content/images/icon/photoName.png" style="width: 18px" alt="" srcset="" ng-if="vm.isWatchName"> <img src="content/images/icon/photoName2.png" style="width: 18px" alt="" srcset="" ng-if="!vm.isWatchName"><div class="photo-name-operate-div2"><div class="photo-name-operate"><div ng-click="watchGalleryName(false)" ng-class="{\'photo-name-operate-active\':!vm.isWatchName}">{{\'nav.photograph.content.btn.photoName.hide\' | translate}}</div><div ng-click="watchGalleryName(true)" ng-class="{\'photo-name-operate-active\':vm.isWatchName}">{{\'nav.photograph.content.btn.photoName.show\' | translate}}</div></div></div></div><div class="editor-nav-view-li-seq2-right"><img src="content/images/icon/photoSeq.png" style="width: 18px" alt=""><div class="photo-name-operate-div2"><div class="photo-name-operate"><div ng-class="{\'photo-name-operate-active\':vm.photoSort == 1}" ng-click="photoSortChange(\'1\')">{{\'nav.photograph.content.btn.seq.time\' | translate}}</div><div ng-class="{\'photo-name-operate-active\':vm.photoSort == 2}" ng-click="photoSortChange(\'2\')">{{\'nav.photograph.content.btn.seq.nameUp\' | translate}}</div><div ng-class="{\'photo-name-operate-active\':vm.photoSort == 3}" ng-click="photoSortChange(\'3\')">{{\'nav.photograph.content.btn.seq.nameBelow\' | translate}}</div></div></div></div></div></div><div class="editor-nav-view-li-2"><div class="editor-nav-view-li-2-loading-mask" ng-if="vm.refreshing"><img src="content/images/icons/loading-pic.gif"></div><!-- <p>\u53EF\u62D6\u5165\u6216\u70B9\u51FB\u56FE\u7247\u64CD\u4F5C</p> --><ul class="clearfix"><li ng-repeat="photo in photos track by $index" ng-if="vm.photosTab==\'all\' || vm.photosTab!=\'all\'&&photo.usenum==0" ng-click="choosePhoto(photo, $event)"><div class="editor-nav-view-li-2-view"><!-- <img class="editor-nav-view-li-2-view-img" ng-if="photo.identifier" ng-src="{{photo.identifier+ \'?imageMogr2/auto-orient/thumbnail/!20p\'}}" --> <img class="editor-nav-view-li-2-view-img" ng-if="photo.identifier && photoStatus(photo) == \'\'" ng-src="{{ !isLarge(photo.imageInfo) ? photo.identifier + \'?imageMogr2/auto-orient/thumbnail/!20p\' : photo.identifier + \'.thumbnail.jpg\'}}" draggable="true" ondragstart="dragStart(event)" ondragend="dragOn(event)" id="dragtargetPhoto{{$index}}" data-index="{{$index}}" data-item="{{photo}}" style="overflow: inherit;z-index: 9999"><div class="editor-nav-view-li-2-view-status" ng-if="photo.identifier && photoStatus(photo) != \'\'" ng-class="{\'is-failed\': isPhotoFailed(photo)}" ng-click="isPhotoFailed(photo) ? showDeletePhotoPop(photo, $event) : null"><img class="editor-nav-view-li-2-view-placeholder" src="content/images/placeholderImage.png" alt=""><div class="editor-nav-view-li-2-view-status-mask"><img class="editor-nav-view-li-2-view-status-icon" ng-if="photoStatus(photo) == \'largeError\' || photoStatus(photo) == \'convertError\'" src="content/images/close1.png" alt=""> <img class="editor-nav-view-li-2-view-status-icon" ng-if="photoStatus(photo) == \'convertRunning\' || photoStatus(photo) == \'largeRunning\'" src="content/images/loading1.png" alt=""> <span class="editor-nav-view-li-2-view-status-text">{{(\'nav.photograph.content.status.\' + photoStatus(photo)) | translate}}</span></div></div><div class="editor-nav-view-li-2-view-refresh-mask" ng-if="(photo.largeFlag && photo.largeStatus == \'running\') || (photo.convertFlag && photo.convertStatus == \'running\')" ng-click="vm.refreshPhotos(); $event.stopPropagation();"><span style="display: inline-block; transform: translateY(16px)">{{\'nav.photograph.content.btn.refresh\' | translate}}</span></div><!-- <img class="editor-nav-view-li-2-view-img1" src="content/images/icons/editor_select.svg" alt="" ng-show="photo.select"> --> <img class="editor-nav-view-li-2-view-img1" src="content/images/icons/editor_select.png" alt="" ng-show="photo.select"> <img class="editor-nav-view-li-2-view-img2" src="content/images/icons/editor_unchecked.png" alt="" ng-if="isPhotoSelectable(photo)" ng-style="{\'display\':( !photo.select && gallaryPic.length>0 ) ? \'block\' : \'\'}"> <span class="editor-nav-view-li-2-view-value" ng-if="photo.usenum">{{photo.usenum}}</span><div class="c-imagebox-warn" ng-if="photo.imgSize < vm.imgSize * 1024" style="border-radius: 0px 0px 10px 0px"><i class="icon iconfont iconwaring imageboxWarn"></i> <span>{{\'nav.photograph.content.pictogram\' | translate}}</span></div></div><div class="text-ellipsis font-12 mar-top-10" style="color: #FFFFFF" ng-if="vm.isWatchName" uib-tooltip="{{photo.name}}" tooltip-placement="top">{{photo.name}}</div></li></ul><!-- <button type="button"  class="load-more-btn" ng-if="!vm.isPhotoFinish" ng-click="photoCb()">\u52A0\u8F7D\u66F4\u591A...</button> --><div class="default-diagram" ng-show="photos.length == 0&&!vm.picLoading"><img src="content/images/default-diagram.png"><div>{{\'hint.noData\' | translate}}</div></div><div class="no-more" ng-if="vm.isPhotoFinish && photos.length > 0">{{\'hint.noMore\' | translate}}</div><div class="web-photo-choose"><div class="web-photo-choose-top"><div class="web-photo-choose-top-left" ng-if="vm.photosTab==\'all\'" translate="nav.photograph.content.selected" translate-values="{gallaryPic:gallaryPic.length,totalPhotoItems:vm.totalPhotoItems}"></div><div class="web-photo-choose-top-left" ng-if="vm.photosTab!==\'all\'" translate="nav.photograph.content.selected" translate-values="{gallaryPic:gallaryPic.length,totalPhotoItems:vm.unusedQuantity}"></div><div class="web-photo-choose-top-right"><span ng-click="whetherChoose(true)">{{\'nav.photograph.content.btn.selectAll\' | translate}}</span> <span ng-click="whetherChoose(false)" ng-if="gallaryPic.length>0">{{\'nav.photograph.content.btn.cancelSelect\' | translate}}</span></div></div><div class="web-photo-choose-bottom"><div class="web-photo-choose-bottom-left" ng-if="gallaryPic.length"><!-- <img src="content/images/icon/move_folder.png" width="15" height="15" style="cursor: pointer" ng-click="moveToFolder()">\n                            <img class="web-photo-del" src="content/images/icon/editor_delete.png" width="15" height="15" ng-click="deleteBatchPhotos()"> --> <i class="iconfont iconmove_folder" uib-tooltip="{{\'nav.photograph.content.btn.move\' | translate}}" tooltip-placement="top" ng-click="moveToFolder()"></i> <i class="iconfont icondustbin_icon" uib-tooltip="{{\'button.delete\' | translate}}" tooltip-placement="top" ng-click="deleteBatchPhotos()"></i></div><div class="web-photo-choose-bottom-left" ng-if="!gallaryPic.length">{{\'editorPop.selectPhoto.msg\' | translate}}</div><div ng-if="vm.pictureType != \'spread\' || !vm.product.allowNegativeUnify"><button class="web-choose-set" ng-click="directFill()">{{\'nav.photograph.content.btn.fill\' | translate}}</button></div><div class="web-choose-set1" ng-if="vm.pictureType == \'spread\' && vm.product.allowNegativeUnify"><div class="web-choose-set1-btn" ng-click="directFill()">{{\'nav.photograph.content.btn.fill\' | translate}}</div><div class="web-choose-set1-hr"></div><div class="web-choose-set1-icon" ng-mouseenter="showChooseMenu($event)" ng-mouseleave="hideChooseMenu()"><i class="iconfont icongengduo" style="transform: rotate(90deg);font-size: 22px"></i></div></div></div></div></div><div class="pic-loading1" ng-if="vm.picLoading && !vm.refreshing"><div class="load-mask" style="display: flex; justify-content: center; align-items: center"><img src="content/images/icons/loading-pic.gif"></div></div><div class="errorAlertPopup" ng-if="vm.errorAlertPopup"><div class="errorAlertPopupLeft"><span class="iconfont iconjinggao1"></span> <span class="contentText">{{\'nav.photograph.content.uploadError\' | translate({lenght:vm.uploadFailedList.length})}}</span> <span class="view" ng-click="errorPhotoView()">{{\'button.view\' | translate}}</span></div><span class="iconfont iconguanbi1 errorAlertPopupClose" ng-click="errorAlertPopupClose()"></span></div></div><div class="editor-nav-view-li" ng-show="vm.nav==\'template\'" style="padding: 20px 16px"><div class="editor-nav-view-li-template" ng-repeat="item in vm.productXmlLines track by $index" ng-if="!item.cancelled" ng-click="productXmlLineClick(item)"><img ng-src="{{item.coverImg}}" alt=""><div class="editor-nav-view-li-template-hint" ng-if="item.productXmlId === vm.article.productXmlId"><span>{{\'nav.template1.content.currentUseTemplate\' | translate}}</span></div></div><div class="default-diagram" ng-show="vm.productXmlLines.length == 0 && !vm.picLoading"><img src="content/images/default-diagram.png"><div>{{\'hint.noData\' | translate}}</div></div></div><div class="editor-nav-view-li" ng-show="vm.nav==\'reserve\'"><div class="nav-mask" ng-if="vm.reservePage.length>0 && !vm.pageData[vm.pageNumber].unreplace"><ul class="clearfix"><li ng-repeat="page in vm.reservePage track by $index" data-index="{{$index}}" ng-click="layoutCb(page)"><div class="nav-mask-div" style="line-height: 100px; text-align: center; position: relative"><img ng-src="{{page.pagecover.identifier}}?imageMogr2/thumbnail/200x200>" style="max-width: 100%; max-height: 100%" ondragstart="dragStart(event)" ondragend="dragOn(event)" data-item="{{page}}" id="reservePage{{$index}}"><div class="use-account" ng-if="page.count>0">{{page.count}}</div></div></li></ul></div><div class="default-diagram" ng-show="vm.reservePage.length == 0"><img src="content/images/default-diagram.png"><div>{{\'hint.noData\' | translate}}</div></div><div class="text-center" ng-if="vm.pageData[vm.pageNumber].unreplace"><span class="tip-text">{{\'hint.noMore\' | translate}}</span></div></div></div><div class="editor-body" style="top: 72px;right:0;padding: 0 0 50px 0;overflow:auto;z-index: 1 !important"><trimbox-pop></trimbox-pop><div class="editor-photo-body" ng-show="vm.data.length > 0"><div class="editor-photo-body-li-two-sided" ng-repeat="page in vm.data track by $index" ng-if="vm.pictureType == \'spread\'" style="width: auto"><div class="two-sided-top"><!-- \u6B63\u9762 --><div class="c-page-view-li-img" data-pagearrindex="{{$index}}" data-pageindex="0" page-index2="{{$index*2}}" id="page{{$index*2}}"><page-preview page="page[0]" is-page-trimbox="true" scale="vm.ratio1" page-index="$index*2" is-imagebox-not="true" img-size="vm.imgSize" img-dpi="vm.imgDpi" editor-type="vm.article.editorType" is-outline="true" ng-if="page[0]"></page-preview><div class="two-sided-tag">{{\'editorCommon.front\' | translate}}</div><div class="two-sided-editor-btn" ng-click="editorPageDialog($index,0)" ng-if="!vm.isCopyBack"><i class="iconfont iconbianji2"></i> {{\'button.edit\' | translate}}</div><div class="imagebox-shade"></div></div><!-- \u53CD\u9762 --><div class="c-page-view-li-img" data-pagearrindex="{{$index}}" data-pageindex="1" page-index2="{{$index*2+1}}" id="page{{$index*2+1}}"><page-preview page="page[1]" is-page-trimbox="true" scale="vm.ratio1" page-index="$index*2+1" is-imagebox-not="true" img-size="vm.imgSize" img-dpi="vm.imgDpi" editor-type="vm.article.editorType" is-outline="true" ng-if="page[1]"></page-preview><div class="two-sided-tag">{{\'editorCommon.verso\' | translate}}</div><div class="two-sided-editor-btn" ng-click="editorPageDialog($index,1)" ng-if="!vm.isCopyBack"><i class="iconfont iconbianji2"></i> {{\'button.edit\' | translate}}</div><div class="imagebox-shade"></div><div class="c-page-view-li-img-copy" ng-if="vm.isCopyBack && vm.copyBackIndex != $index && !page[1].isCopyBack"><div class="c-page-view-li-img-copy-btn" ng-click="editorPageCopyHere($index)">{{\'editorCommon.copyHere\' | translate}}</div></div></div></div><div class="two-sided-bottom"><div style="display: flex; align-items: center"><i class="iconfont icondustbin_icon" style="font-size: 14px" ng-click="subtractDeleteTab($event,$index)" ng-if="!vm.isCopyBack"></i><div style="margin-left: 16px; cursor: pointer; color: #666; font-size: 12px" ng-if="ifCopyBack($index)" ng-click="copyBack($event,$index)"><i class="iconfont iconfuzhi" style="font-size: 14px"></i> <span style="margin-left: 1px">{{\'editorCommon.copyBack\' | translate}}</span></div><div ng-if="page[1].isCopyBack" style="color: var(--webMainButtonBackColor); font-size: 12px;line-height: 20px">{{\'editorCommon.Copied\' | translate}}</div></div><div><i class="iconfont iconjian" ng-click="subtractQuantityTab($event, page[0])" ng-style="{\'color\':page[0].quantity <= 1 ? \'#d5d5d5\':\'#000\'}"></i> <input type="text" style="border: 0; text-align: center; color: #333; width: 50px; background: #F7F8FA" ng-model="page[0].quantity" oninput="value=value.replace(/^0|[^0-9]/g, \'\')"> <i class="iconfont iconzengjia" style="color:#000000" ng-click="pushQuantityTab($event, page[0])"></i></div></div></div><div class="editor-photo-body-li-one-sided" ng-repeat="page in vm.data track by $index" ng-if="vm.pictureType == \'single\'" style="width: auto"><div class="two-sided-top"><div class="c-page-view-li-img" page-index2="{{$index}}" id="page{{$index}}" ng-click="single($index)"><page-preview page="page" is-page-trimbox="true" scale="vm.ratio1" page-index="$index" is-imagebox-not="true" img-size="vm.imgSize" img-dpi="vm.imgDpi" editor-type="vm.article.editorType" is-outline="true" ng-if="page"></page-preview><div class="two-sided-editor-btn" ng-click="editorPageDialog($index,0)"><i class="iconfont iconbianji2"></i> {{\'button.edit\' | translate}}</div></div></div><div class="two-sided-bottom"><div><i class="iconfont icondustbin_icon" ng-click="subtractDeleteTab($event,$index)"></i></div><div><i class="iconfont iconjian" ng-click="subtractQuantityTab($event, page)" ng-style="{\'color\':page.quantity <= 1 ? \'#d5d5d5\':\'#000\'}"></i> <input type="text" style="border: 0; text-align: center; color: #333; width: 50px; background: #F7F8FA" ng-model="page.quantity" oninput="value=value.replace(/^0|[^0-9]/g, \'\')"> <i class="iconfont iconzengjia" style="color:#000000" ng-click="pushQuantityTab($event, page)"></i></div></div></div></div><div ng-show="vm.data.length == 0" style="width:100%;height: 100%;display: flex;align-items: center;justify-content: center;flex-direction: column"><img src="content/images/worksNull.png" alt="" srcset=""><div style="text-align: center;font-size: 18px;color: #aeaeae"><div>{{\'editorCommon.noWorks\' | translate}}</div><div>{{\'editorCommon.addPhotosToStartProduction\' | translate}}</div></div><div ng-if="vm.signalPage1 && vm.signalPage2 && vm.article && vm.article.expectPageCount && !vm.article.multiple" class="expectPageCountBtn" translate="editorCommon.expectPageCount" translate-values="{expectPageCount:vm.pictureType == \'spread\' ? (vm.signalPage1.imageboxQuantity+vm.signalPage2.imageboxQuantity)*vm.article.expectPageCount : vm.signalPage1.imageboxQuantity*vm.article.expectPageCount}"></div></div><div class="editor-body-copy-view" ng-if="vm.isCopyBack"><div style="cursor: pointer; color: #666" ng-click="copyAll()"><i class="iconfont iconfuzhi"></i> <span style="margin-left: 1px">{{\'editorCommon.copyAll\' | translate}}</span></div><div style="margin-left: 26px; cursor: pointer; color: var(--webMainButtonBackColor)" ng-click="copyHide()"><i class="iconfont iconwancheng-"></i> <span style="margin-left: 1px">{{\'editorCommon.copyComplete\' | translate}}</span></div></div></div></div><page-photo ng-if="vm.editorDialog1" :editor-type="vm.article.editorType" :page-list="vm.editorPageList" :page-index="vm.pageIndex" :template="template" :img-size="vm.imgSize" :img-dpi="vm.imgDpi" :article="vm.article" :property-value="vm.propertyValue" :product="vm.product" :logo="vm.logo" on-change="pagePhotoCb(text)"></page-photo><div class="three-modal" ng-if="vm.editorDialog"><div class="editor-dialog" ng-click="editorBodyView($event)"><div class="editor-dialog-title"><div class="editor-dialog-title-left" ng-if="vm.pictureType == \'spread\'"><span ng-click="singleIndexClick(false)" ng-class="{\'editor-dialog-title-active\':!zfInit()}">{{\'editorCommon.front\' | translate}}</span> <span ng-click="singleIndexClick(true)" ng-class="{\'editor-dialog-title-active\':zfInit()}" style="margin-left:40px">{{\'editorCommon.verso\' | translate}}</span></div><div class="editor-dialog-title-right"><i class="iconfont iconcuo dialog-close" ng-click="editorDialogHide()"></i></div></div><div class="editor-dialog-body"><div ng-if="vm.data.length > 0 && !vm.pageLoading" style="position: relative; background: #fff; margin: 0 auto;box-shadow: 0 0 6px 4px rgba(0,0,0,0.3)" ng-style="{\n                    \'width\': vm.pageWidth * vm.ratio,\n                    \'height\': vm.pageHeight * vm.ratio,\n                 }"><div style="width: 100%; height: 100%; position: absolute" ng-if="vm.editorPageList[vm.pageIndex].scene" ng-style="{\n                    \'position\': \'absolute\',\n                    \'width\': vm.editorPageList[vm.pageIndex].custom.width * vm.ratio,\n                    \'height\': vm.editorPageList[vm.pageIndex].custom.height * vm.ratio,\n                    \'z-index\': vm.editorPageList[vm.pageIndex].scene.hierarchy == \'TOP\' ? \'1\' : \'0\',\n                    \'pointer-events\': \'none\'\n                }"><img ng-src="{{vm.editorPageList[vm.pageIndex].scene.resource.identifier | imageFilter}}" alt="" ng-style="{\n                                            \'width\': vm.editorPageList[vm.pageIndex].scene.resource.adaptation == \'Width\' ? \'auto\' : \'100%\',\n                                            \'height\': vm.editorPageList[vm.pageIndex].scene.resource.adaptation == \'Height\' ? \'auto\' : \'100%\'\n                                        }"><div ng-style="{\n                                            \'position\': \'absolute\',\n                                            \'width\': vm.editorPageList[vm.pageIndex].scene.imagebox.geometry.width * vm.ratio,\n                                            \'height\': vm.editorPageList[vm.pageIndex].scene.imagebox.geometry.height * vm.ratio,\n                                            \'left\': vm.editorPageList[vm.pageIndex].scene.imagebox.geometry.x * vm.ratio,\n                                            \'top\': vm.editorPageList[vm.pageIndex].scene.imagebox.geometry.y * vm.ratio,\n                                            \'transform\': \'rotate(\' + vm.editorPageList[vm.pageIndex].scene.imagebox.rotation.angle + \'deg)\',\n                                        }"></div></div><div style="width: 100%; height: 100%; position: relative" ng-style="{\n                \'z-index\': vm.editorPageList[vm.pageIndex].scene && vm.editorPageList[vm.pageIndex].scene.hierarchy == \'TOP\' ? 0 : 1\n            }"><div ng-style="{\n                                        \'position\': \'absolute\',\n                                        \'width\': vm.editorPageList[vm.pageIndex].mediabox.width * vm.ratio,\n                                        \'height\': vm.editorPageList[vm.pageIndex].mediabox.height * vm.ratio,\n                                        \'left\': vm.editorPageList[vm.pageIndex].scene ? vm.editorPageList[vm.pageIndex].scene.imagebox.geometry.x * vm.ratio : vm.editorPageList[vm.pageIndex].mediabox.x * vm.ratio,\n                                        \'top\': vm.editorPageList[vm.pageIndex].scene ? vm.editorPageList[vm.pageIndex].scene.imagebox.geometry.y * vm.ratio : vm.editorPageList[vm.pageIndex].mediabox.y * vm.ratio,\n                                        \'background\': vm.editorPageList[vm.pageIndex].background.color ? vm.editorPageList[vm.pageIndex].background.color : \'\',\n                                        }"><div style="width: 100%; height: 100%; position: relative; overflow: hidden"><div class="border-trimbox" ng-style="{\n                                                width:vm.editorPageList[vm.pageIndex].trimbox.width*vm.ratio,\n                                                height:vm.editorPageList[vm.pageIndex].trimbox.height*vm.ratio,\n                                                top:vm.editorPageList[vm.pageIndex].trimbox.y*vm.ratio,\n                                                left:vm.editorPageList[vm.pageIndex].trimbox.x*vm.ratio}"></div><div class="relative-view1"><img ng-src="{{vm.editorPageList[vm.pageIndex].background.resource.identifier | imageFilter}}" alt="" ng-if="!vm.editorPageList[vm.pageIndex].background.color" ng-style="{\n                                            \'position\': \'absolute\',\n                                            \'width\': vm.editorPageList[vm.pageIndex].background.resource.adaptation == \'Width\' ? vm.editorPageList[vm.pageIndex].mediabox.width * vm.ratio : \'auto\',\n                                            \'height\': vm.editorPageList[vm.pageIndex].background.resource.adaptation == \'Height\' ? vm.editorPageList[vm.pageIndex].mediabox.height * vm.ratio : \'auto\',\n                                            \'left\': vm.editorPageList[vm.pageIndex].background.offsetx * vm.ratio,\n                                            \'top\': vm.editorPageList[vm.pageIndex].background.offsety * vm.ratio\n                                        }"></div><div style="position: absolute;width: 100%; height: 100%; left: 0; top: 0"><div ng-repeat="level in vm.editorPageList[vm.pageIndex].levels.level track by $index" ng-if="level.imagebox" ng-mousedown="moveImageboxStart($index, $event)" ng-style="{\n                                    \'position\': \'absolute\',\n                                    width: imageboxW(level.imagebox) * vm.ratio,\n                                    height: imageboxH(level.imagebox) * vm.ratio,\n                                    left: imageboxL(level.imagebox) * vm.ratio,\n                                    top: imageboxT(level.imagebox) * vm.ratio,\n                                    \'z-index\':level.seq-0+200,\n                                    \'transform\': \'rotate(\' + level.imagebox.rotation.angle + \'deg)\',\n                                }" ng-class="{\'selected\':vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox && vm.levelIndex == $index}"><div class="relative-view1" ng-style="{\n                            \'overflow\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'unset\' : \'hidden\',\n                                \'opacity\':level.imagebox.transparency,\n                                \'border-top-left-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'lt\', vm.ratio),\n                                \'border-top-right-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'rt\', vm.ratio),\n                                \'border-bottom-right-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'rb\', vm.ratio),\n                                \'border-bottom-left-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'lb\', vm.ratio),\n                                \'border-width\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? (level.imagebox.border.lineWidth * vm.ratio) : \'\',\n                                                    \'border-style\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? (level.imagebox.border.lineType || \'solid\') : \'none\',\n                                \'border-color\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? level.imagebox.border.color : \'\',\n                                                    \'box-shadow\' : (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineWidth>0 && (!level.imagebox.border.lineType || level.imagebox.border.lineType == \'solid\')) ? \'0 0 0 1px \' + level.imagebox.border.color + \' inset\' : \'none\',\n                                                    \'filter\' : dropShadow(level.imagebox,vm.ratio,vm.ratio),\n                                }"><div ng-style="{\n                                \'position\': \'absolute\',\n                                \'z-index\':0,\n                                \'left\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'left\') * vm.ratio : 0,\n                                \'top\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'top\') * vm.ratio : 0,\n                                \'right\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'right\') * vm.ratio : 0,\n                                \'bottom\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'bottom\') * vm.ratio : 0,\n                                \'background-image\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'url(\' + level.imagebox.border.resource.identifier + \')\' : \'\',\n                                \'background-size\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'100% 100%\' : \'\',\n                                }"></div><div class="relative-view1" ng-style="{\n                                    \'-webkit-mask-image\': level.imagebox.mask.resource.identifier ? \'url(\' + level.imagebox.mask.resource.identifier + \')\' : \'none\',\n                                    \'-webkit-mask-size\': \'100% 100%\',\n                                    \'border-top-left-radius\':imageboxWRadius1(level.imagebox, \'lt\', vm.ratio),\n                                    \'border-top-right-radius\':imageboxWRadius1(level.imagebox, \'rt\', vm.ratio),\n                                    \'border-bottom-right-radius\':imageboxWRadius1(level.imagebox, \'rb\', vm.ratio),\n                                    \'border-bottom-left-radius\':imageboxWRadius1(level.imagebox, \'lb\', vm.ratio),\n                                    }"><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'None\'" onmousewheel="return bbimg()"><img alt="" ng-src="{{ isLarge(level.imagebox.image.imageInfo) ? (level.imagebox.image.resource.identifier | imageFilter:level.imagebox.image.angle:true) : (level.imagebox.image.resource.identifier | imageFilter:level.imagebox.image.angle) }}" data-index="{{$index}}" ng-style="{\n                                                \'position\': \'absolute\',\n                                                        \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                \'width\': level.imagebox.image.width*level.imagebox.image.scale*vm.ratio,\n                                                \'height\': level.imagebox.image.height*level.imagebox.image.scale*vm.ratio,\n                                                \'left\':level.imagebox.image.offsetx*level.imagebox.image.scale*vm.ratio,\n                                                \'top\':level.imagebox.image.offsety*level.imagebox.image.scale*vm.ratio,\n                                            }"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype != \'None\'"><img alt="" ng-src="{{isLarge(level.imagebox.image.imageInfo) ? (level.imagebox.image.resource.identifier | imageFilter:level.imagebox.image.angle:true) : (level.imagebox.image.resource.identifier | imageFilter:level.imagebox.image.angle)}}" data-index="{{$index}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                        \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                    \'width\': level.imagebox.blurredrectangle.width * vm.ratio,\n                                                    \'height\': level.imagebox.blurredrectangle.height * vm.ratio,\n                                                    \'left\':level.imagebox.blurredrectangle.x * vm.ratio,\n                                                    \'top\':level.imagebox.blurredrectangle.y * vm.ratio\n                                                }"></div><img class="c-page-view-li-warning" src="content/images/ic_pixel2.svg" alt="" ng-if="level.imagebox && level.imagebox.image && pxInsufficient(level.imagebox)"></div></div></div></div></div></div></div><!--\u56FE\u7247\u6846\u88C1\u5207--><div class="imageboxview" style="position: absolute; left: 0; top: 0; z-index: 999" ng-show="vm.isImageboxTrim"><div ng-style="{\n                    \'width\': vm.pageWidth * vm.ratio,\n                    \'height\': vm.pageHeight * vm.ratio,\n\n                    }"><div ng-style="{\n                                        \'position\': \'absolute\',\n                                        \'width\': vm.editorPageList[vm.pageIndex].mediabox.width * vm.ratio,\n                                        \'height\': vm.editorPageList[vm.pageIndex].mediabox.height * vm.ratio,\n                                        \'left\': vm.editorPageList[vm.pageIndex].scene ? vm.editorPageList[vm.pageIndex].scene.imagebox.geometry.x * vm.ratio : vm.editorPageList[vm.pageIndex].mediabox.x * vm.ratio,\n                                        \'top\': vm.editorPageList[vm.pageIndex].scene ? vm.editorPageList[vm.pageIndex].scene.imagebox.geometry.y * vm.ratio : vm.editorPageList[vm.pageIndex].mediabox.y * vm.ratio,\n                                        }"><div style="width: 100%; height: 100%; position: relative"><div style="width: 100%; height: 100%; position: absolute; left: 0; top: 0"><div ng-style="{\n                        \'position\': \'absolute\',\n                        \'width\': vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.geometry.width*vm.ratio,\n                        \'height\': vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.geometry.height*vm.ratio,\n                        \'left\': vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.geometry.x *vm.ratio,\n                        \'top\': vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.geometry.y*vm.ratio,\n                        \'transform\': \'rotate(\' + vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.rotation.angle + \'deg)\',\n                    }"><div style="width: 100%; height: 100%;position: relative" ng-if="vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.bokehtype == \'None\'"><div style="position: absolute; background: rgba(0,0,0,0.5); z-index: 1" ng-style="{\n                                    \'width\': vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.width*vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.scale*vm.ratio,\n                                    \'height\': vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.height*vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.scale*vm.ratio,\n                                    \'left\': vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.offsetx *vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.scale*vm.ratio,\n                                    \'top\': vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.offsety *vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.scale*vm.ratio\n                                }"></div><img ng-src="{{isLarge(vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.imageInfo) ? (vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.resource.identifier | imageFilter:vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.angle:true) : (vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.resource.identifier | imageFilter:vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.angle)}}" ng-style="{\n                                    \'transform\': vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                    \'width\':vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.width*vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.scale*vm.ratio,\n                                    \'height\':vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.heigh*vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.scale*vm.ratio,\n                                    \'left\': vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.offsetx *vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.scale*vm.ratio,\n                                    \'top\': vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.offsety *vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.scale*vm.ratio\n                                    }" style="position: absolute" alt="\u80CC\u666F\u56FE\u7247"></div></div></div><div style="width: 100%; height: 100%; position: absolute; left: 0; top: 0; z-index: 10"><div ng-style="{\n                                \'position\': \'absolute\',\n                                \'width\': vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.geometry.width*vm.ratio,\n                                \'height\': vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.geometry.height*vm.ratio,\n                                \'left\': vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.geometry.x *vm.ratio,\n                                \'top\': vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.geometry.y*vm.ratio,\n                                \'transform\': \'rotate(\' + vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.rotation.angle + \'deg)\'\n                            }"><div style="width: 100%; height: 100%;position: relative;overflow: hidden" ng-style="{\n                                    \'-webkit-mask-image\': vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.mask.resource.identifier ? \'url(\' + vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.mask.resource.identifier + \')\' : \'none\',\n                                    \'-webkit-mask-size\': \'100% 100%\'\n                                    }"><img ng-if="vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.resource.identifier" ng-src="{{isLarge(vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.imageInfo) ? (vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.resource.identifier | imageFilter:vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.angle:true) : (vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.resource.identifier | imageFilter:vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.angle)}}" ng-style="{\n                                        \'transform\': vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                        \'width\': vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.width*vm.ratio*vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.scale,\n                                        \'height\': vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.height*vm.ratio*vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.scale,\n                                        \'left\': vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.offsetx *vm.ratio*vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.scale,\n                                        \'top\': vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.offsety *vm.ratio*vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.scale\n                                    }" style="position: absolute" alt="\u80CC\u666F\u56FE\u7247"></div></div></div></div></div></div></div></div></div><div class="editor-dialog-footer"><div class="editor-dialog-footer-left"><span class="iconfont iconzuojian" ng-click="previousPage()" ng-if="vm.pageIndex > 0"></span> <span ng-click="previousPage()" ng-if="vm.pageIndex > 0">{{\'editorCommon.previousPage\' | translate}}</span></div><div class="editor-dialog-footer-center" ng-if="vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex] && vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox"><div class="editor-dialog-footer-center-btn" ng-class="{\'editor-dialog-btn-disabled\':!vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex] || !vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox}" ng-click="rotateImagebox($event)"><img src="content/images/icon/rotate-icon.png" alt=""> <span>{{\'editorBtn.rotate\' | translate}}</span></div><div class="editor-dialog-footer-center-btn" ng-class="{\'editor-dialog-btn-disabled\':!vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex] || !vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox || vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.bokehtype != \'None\'}" ng-click="imageboxSite(\'center\')"><img src="content/images/icon/center-icon.png" alt=""> <span>{{\'editorBtn.center\' | translate}}</span></div><div class="editor-dialog-footer-center-btn" ng-class="{\'editor-dialog-btn-disabled\':!vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex] || !vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox}" ng-click="cutImagebox($event)" ng-if="vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.bokehtype != \'None\'"><img src="content/images/icon/unfold-icon.png" alt=""> <span>{{\'editorBtn.unfold\' | translate}}</span></div><div class="editor-dialog-footer-center-btn" ng-class="{\'editor-dialog-btn-disabled\':!vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex] || !vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox}" ng-click="fillImagebox($event)" ng-if="vm.editorPageList[vm.pageIndex].levels.level[vm.levelIndex].imagebox.bokehtype == \'None\'"><img src="content/images/icon/reduce-icon.png" alt=""> <span>{{\'editorBtn.lessen\' | translate}}</span></div></div><div class="editor-dialog-footer-right"><span ng-click="nextPage()" ng-if="vm.pageIndex<vm.editorPageList.length-1">{{\'editorCommon.nextPage\' | translate}}</span> <span class="iconfont iconyoujian" ng-click="nextPage()" ng-if="vm.pageIndex<vm.editorPageList.length-1"></span></div></div></div></div><!--\u5220\u9664\u5904\u7406\u5931\u8D25\u7684\u7167\u7247--><div class="three-modal" ng-if="vm.deletePhotoSure" data-html2canvas-ignore><div class="dialog"><div class="dialog-titles"><div class="dialog-titles-title">{{\'nav.photograph.content.deletePhoto.title\' | translate}}</div><i class="iconfont iconcuo dialog-close" ng-click="vm.deletePhotoSure=false"></i></div><div class="dialog-content">{{\'nav.photograph.content.deletePhoto.content\' | translate}}</div><div class="dialog-foot"><button type="button" class="dialog-foot-close" ng-click="vm.deletePhotoSure = false">{{\'button.cancel\' | translate}}</button> <button type="button" class="dialog-foot-delete" ng-click="deletePhotoConfirm()">{{\'button.confirm\' | translate}}</button></div></div></div><!--\u5220\u9664\u6587\u4EF6\u5939--><div class="three-modal" ng-if="vm.deleteSure"><div class="dialog"><div class="dialog-titles"><div class="dialog-titles-title">{{\'nav.photograph.content.folders.btn.cancelPop.title\' | translate}}</div><i class="iconfont iconcuo dialog-close" ng-click="vm.deleteSure=false"></i></div><div class="dialog-content">{{\'nav.photograph.content.folders.btn.cancelPop.content\' | translate}}</div><div class="dialog-foot"><button type="button" class="dialog-foot-close" ng-click="vm.deleteSure = false">{{\'button.cancel\' | translate}}</button> <button type="button" class="dialog-foot-delete" ng-click="deleteFolders()">{{\'button.confirm\' | translate}}</button></div></div></div><!--\u8F6C\u79FB\u7167\u7247--><div class="modal-property" ng-if="vm.isMoveToFolder"><div class="modal-mask"></div><div class="content-scroll modal-con"><div class="col-lg-12 col-sm-12 modal-t"><span class="col-md-6 col-sm-6 col-xs-6 font-16 text-left">{{\'nav.photograph.content.btn.movePop.title\' | translate}}</span> <span class="col-md-6 col-sm-6 col-xs-6 text-right"><img src="content/images/icons/close1.svg" style="width: 16px" ng-click="vm.isMoveToFolder=false"></span></div><div class="col-lg-12 col-sm-12 pad-0 scrollbar" style="margin-top: 54px;height: 48vh"><ul class="col-lg-12 col-sm-12 pad-0 folder-ul"><li ng-class="{\'folder-active\':folder.selected}" ng-click="chooseFolder2()" ng-show="vm.folderId"><img src="content/images/icons/move_folder_big.svg"> <span class="text-ellipsis">{{\'nav.photograph.content.folders.name\' | translate}}</span> <button ng-if="vm.selectFolderId === -1"><img src="content/images/icons/folder_pre.svg" ng-click=""></button></li><li ng-repeat="folder in Folders track by $index" ng-show="vm.folderId != folder.id" ng-class="{\'folder-active\':folder.selected}" ng-click="chooseFolder(folder,$index)" data-index="{{$index}}" class="left-panel-hover folder{{$index}}"><img src="content/images/icons/move_folder_big.svg" data-index="{{$index}}" data-id="{{folder.id}}"> <span class="text-ellipsis">{{folder.name}}</span> <button ng-if="folder.selected"><img src="content/images/icons/folder_pre.svg" ng-click=""></button></li></ul></div><!--<div class="col-lg-12 col-sm-12" style="height: 80px;"></div>--><div class="col-lg-12 col-sm-12 pad-0" style="border-top: 1px solid #E8E8E8"><button type="button" class="col-md-6 col-sm-6 col-xs-6" data-dismiss="modal" style="color: #232323;font-size: 15px;height: 60px;border-right:1px solid #E8E8E8" ng-click="vm.isMoveToFolder=false">{{\'button.cancel\' | translate}}</button> <button type="submit" style="background: #ffc872;color:#232323;font-size: 15px;height: 60px" class="col-md-6 col-sm-6 col-xs-6" ng-click="saveMoveToFolder()">{{\'button.confirm\' | translate}}</button></div></div></div><!--\u624B\u673A\u4F20\u56FE--><div style="z-index: 999; position: fixed; top: 0px; left: 0px; right: 0px; bottom: 0px; background-color: rgba(0,0,0,.5)" ng-show="vm.qrcodeShow" data-html2canvas-ignore><div style="width: 528px;background-color: #FFF; position:absolute;left: 50%;top: 50%;transform: translate(-50%,-50%);border-radius: 8px;overflow: hidden"><div class="modal-header" style="border: none;font-size: 18px;color:#333;font-weight: bold"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="uploadByPhone1()">&times;</button> {{\'editorPop.photoUpload.title\' | translate}}</div><div class="modal-body col-lg-12 col-sm-12" style="text-align: center"><div class="form-group col-lg-12 col-sm-12"><div style="color: #333333; font-size: 20px; opacity: 0.85">{{\'editorPop.photoUpload.describe\' | translate}}</div></div><div class="form-group col-lg-12 col-sm-12"><div id="qrcode1"></div></div><div class="form-group col-lg-12 col-sm-12" style="margin-top: 10px"><div style="color: #666666; font-size: 14px; opacity: 0.85">{{\'editorPop.photoUpload.describe1\' | translate}}</div><br><div style="color: #999999; font-size: 12px; opacity: 0.85">{{\'editorPop.photoUpload.describe2\' | translate}}</div></div></div></div></div><!-- \u9000\u51FA\u5F39\u7A97 --><div class="three-modal" ng-if="vm.exitSure" data-html2canvas-ignore><div class="dialog"><div class="dialog-titles"><div class="dialog-titles-title">{{\'editorPop.exitTitle\' | translate}}</div><i class="iconfont iconcuo dialog-close" ng-click="vm.exitSure = false"></i></div><div class="dialog-content">{{\'editorPop.exitWithoutSaveContent\' | translate}}</div><div class="dialog-foot" style="justify-content: space-between"><div><button type="button" class="dialog-foot-close" style="border: 1px solid #000" ng-click="exitPageCancel(true)">{{\'editorPop.iWantSave\' | translate}}</button></div><div style="display: flex;align-items: center"><button type="button" class="dialog-foot-close" style="border: 1px solid #000" ng-click="exitPageCancel()">{{\'editorPop.iThinkAboutIt\' | translate}}</button> <button type="button" class="dialog-foot-delete" style="background-color: rgb(220, 92, 67)" ng-click="exitPage()">{{\'editorPop.confirmExit\' | translate}}</button></div></div></div></div><div class="three-modal" ng-if="vm.isTemplate"><div class="dialog"><div class="dialog-titles"><div class="dialog-titles-title">{{\'editorPop.replacementTemplate.title\' | translate}}</div><i class="iconfont iconcuo dialog-close" ng-click="vm.isTemplate=false"></i></div><div class="dialog-content"><div style="font-size:16px">{{\'editorPop.replacementTemplate.content\' | translate}}</div></div><div class="dialog-foot"><button type="button" class="dialog-foot-close" ng-click="vm.isTemplate=false">{{\'button.cancel\' | translate}}</button> <button type="button" class="dialog-foot-confirm" ng-style="{\'opacity\':vm.templateReplace == null?\'0.5\':\'1\'}" ng-disabled="vm.templateReplace == null" ng-click="templateReplace(vm.templateReplace)">{{\'button.confirm\' | translate}}</button></div></div></div><div class="three-modal1" ng-if="vm.imageboxLoad || vm.loading"><img src="content/images/icon/loading.gif" alt=""><div>{{\'editorCommon.loadingText\' | translate}}</div></div><!--\u7F29\u7565\u56FE\u5355\u9762--><div id="thumbnail-view1" ng-if="vm.pictureType == \'single\'" style="position: absolute; z-index: -1; overflow: hidden"><page-preview page="vm.data[0]" scale="vm.ratio" editor-type="vm.article.editorType" ng-if="vm.data[0]"></page-preview></div><!--\u91CD\u590D\u56FE\u7247--><duplicate-list domain-url="domain" ng-if="vm.isDuplicateList" list="vm.duplicateList" on-change="duplicateChange()"></duplicate-list><!--\u7F29\u7565\u56FE\u53CC\u9762--><div id="thumbnail-view1" ng-if="vm.pictureType == \'spread\'" style="position: absolute; z-index: -1; overflow: hidden"><page-preview page="vm.data[0][0]" scale="vm.ratio" editor-type="vm.article.editorType" ng-if="vm.data[0][0]"></page-preview></div><!-- \u586B\u5145\u60AC\u6D6E\u6309\u94AE --><div class="web-choose-set1-icon-1" ng-show="gallaryPic.length>0 && vm.chooseMenuStyle" ng-mouseenter="showChooseMenu($event)" ng-mouseleave="hideChooseMenu()"><div class="web-choose-set1-icon-1-view"><div class="web-choose-set1-icon-1-item" ng-click="directFill()">\u6309\u5E8F\u586B\u5145\u6B63\u53CD</div><div class="web-choose-set1-icon-1-item" ng-click="directFill(true)">\u4EC5\u586B\u5145\u5230\u6B63\u9762</div><i class="iconfont iconyoujiantou"></i></div></div><style>.lang-option{\n        height: 20px;\n        font-size: 14px;\n        color: #108DFE;\n        line-height: 20px;\n        margin-top: 18px;\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n    }\n\n    .lang-option:hover{\n        color:#ffffff !important;\n    }\n\n    .lang-div{\n        position: relative;\n        width: 100%;\n        height: 36px;\n        background-color: #1E1F22;\n        border-radius: 22px;\n        font-size: 14px;\n        font-weight: bold;\n        padding: 0px 16px;\n        color: #ffffff;\n        border: 1px solid rgba(255,255,255,0.2);\n    }\n    .lang-icn{\n        transform: rotate(90deg);\n        position: absolute;\n        right: 10px;\n        top: 0px;\n    }\n    .lang-icn i{\n        margin: 0 !important;\n    }\n\n    .lang-option-div{\n        width: 172px;\n        height: 224px;\n        background: rgba(0,0,0,0.85);\n        border: 1px solid rgba(255,255,255,0.2);\n        position: absolute;\n        top: 46px;\n        cursor: pointer;\n        z-index: 1000;\n        border-radius: 10px;\n        text-align: left;\n        padding: 0px 16px;\n    }</style>');
$templateCache.put('app/entities/page/editor-photo-preview.html','<div class="preview-div" style="width: 90%; max-width: 1335px; margin: 40px auto 100px;display: flex;flex-wrap: wrap" ng-if="!vm.product.pictureType || vm.product.pictureType == \'single\'"><div class="c-page-view-li" ng-repeat="page in vm.data track by $index" style="margin:10px; border: 0"><div class="c-page-view-li-img"><page-preview page="page" editor-type="vm.product.editorType" scale="vm.ratio1"></page-preview></div><div class="c-page-view-li-btn" style="height: 30px"><span style="padding: 0 5px; width: fit-content">{{page.quantity}}\u5F20</span></div></div></div><div class="preview-div" style="width: 90%; max-width: 1270px; margin: 40px auto 100px;display: flex;flex-wrap: wrap" ng-if="vm.product.pictureType == \'spread\'"><div class="c-page-view-li" ng-repeat="data in vm.data1 track by $index" style="float: none; background: #fff; border: 0"><div class="c-page-view-li-item"><div class="c-page-view-li-img" ng-repeat="page in data track by $index" ng-init="pageIndex = $index"><page-preview page="page" editor-type="vm.product.editorType" scale="vm.ratio1"></page-preview><img class="c-page-view-li-warning" src="content/images/ic_pixel2.svg" alt="" ng-if="page.levels.level[0].imagebox.image.size && page.levels.level[0].imagebox.image.size / 1024 < 150"><div class="c-page-view-li-direction">{{pageIndex == 0 ? \'editorCommon.front\' : \'editorCommon.verso\' | translate}}</div></div></div><div class="c-page-view-li-btn" style="height: 30px"><span style="padding: 0 5px; width: fit-content">{{data[0].quantity}}\u5F20</span></div></div></div><style>.modal-content {\n        width: 100%;\n    }\n    .c-page-view-li-img{\n        overflow: hidden;\n    }</style>');
$templateCache.put('app/entities/page/page-404.html','<div class="page-404"><img class="img-404" src="content/images/img-404.png" alt="404"><p class="tips">{{vm.tips}}</p></div><style>.page-404{\n    width: 100vw;\n    height: 100vh;\n    background: #FFFFFF;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    padding-bottom: 150px;\n}\n.page-404 .img-404{\n    width: 413px;\n    margin-bottom: 48px;\n}\n.page-404 .tips{\n    font-size: 18px;\n    color: #545454;\n}\n@media screen and (max-width: 750px) {\n    .page-404 .img-404{\n        width: 50%;\n        margin-bottom: 48px;\n    }\n}</style>');
$templateCache.put('app/entities/page/page-view-article.html','<div style="background: #f3f3f3;position: fixed;     left: 0;\n    right: 0;\n    margin: 0;\n    padding: 0 0 80px 0;\n    bottom: 0;\n    top: 0;\n    overflow: auto" ng-style="{\n            background: vm.toneSettings.previewBkWeb ? \'url(\' + vm.toneSettings.previewBkWeb + \') no-repeat center \' : \'#f3f3f3\',\n            \'background-size\': \'100% 100%\'\n        }"><div class="main-cover" ng-show="vm.qrcodeShow" ng-click="shareParents()"><div style="width: 280px;\n    height: 300px;\n    margin: 0 auto;\n    margin-top: 15%;\n    padding-top: 40px"><span>{{\'button.share\' | translate}}</span> <img style="float: right" src="content/images/close.png"></div><div style="width: 300px; height: 210px; background-color: #FFF; margin: 0 auto; margin-top:-270px; padding-left: 100px; padding-top: 50px; border-radius: 5px"><div id="qrcode1" style="margin-bottom: 20px"></div><span style="font-weight: bold;\n    position: relative;\n    padding-top: 5px;\n    left: -25px">{{\'editorCommon.tellFriend\' | translate}}</span></div></div><audio id="audio" autoplay loop>{{\'editorCommon.nonsupportMusic\' | translate}}</audio><span class="PanelRight hide1" style="z-index: 99"><span id="Play" class="Play"><img class="icon pause" id="music-icon" src="content/images/icons/ic_music2.svg"></span><div ng-show="vm.isPlay" class="gary-text">{{\'editorCommon.offMusic\' | translate}}</div><div ng-show="!vm.isPlay" class="gary-text">{{\'editorCommon.openMusic\' | translate}}</div></span><div ng-if="vm.previewArticle && (vm.watchSure || (!vm.threeView && !vm.picture))"><article-preview article="vm.article" document-page="vm.previewArticle" editor-type="vm.article.editorType" bindingtype="vm.itemValue.bindingType" is-landscape="false" is-nav="vm.isNav" ng-if="(!vm.itemValue.bindingType || vm.itemValue.bindingType != \'LeftNew\')&&vm.previewArticle&&vm.article"></article-preview><editor-preview-mini article="vm.article" document-page="vm.previewArticle" is-nav="vm.isNav" ng-if="vm.itemValue.bindingType === \'LeftNew\' && vm.previewArticle && vm.article"></editor-preview-mini></div><!-- 3D\u9884\u89C8 --><div ng-if="vm.previewArticle && vm.threeView"><div class="preview-article-con1"><three-preview3 moulds="vm.product.moulds" model-path="vm.threeProductXmlData.modelPath" model-blendents="vm.threeProductXmlData.modelBlendent" model-data="vm.threeProductXmlData.modelData" model-blendent-uuid="vm.article.modelBlendentUuid" pages="vm.previewArticle.pages.page"></three-preview3></div></div><!-- \u51B2\u5370\u9884\u89C8 --><div ng-if="vm.previewArticle && vm.picture"><editor-photo-preview preview-article="vm.previewArticle" article="vm.article"></editor-photo-preview></div><div class="text-align-center mar-top-40" id="back-btn" style="position: fixed;bottom: 0px;left: 0; z-index: 9999;width: 100%;background: #212225;padding: 20px" ng-if="!vm.orderArticleId"><button type="button" class="btn-cancel" data-dismiss="modal" ng-click="backToList()" style="padding: 6px 30px !important" ng-show="vm.returnurl1"><span>{{\'button.back\' | translate}}</span></button> <button type="button" class="btn-cancel" data-dismiss="modal" ng-click="openMusicList()" ng-show="!vm.isHideMusicBtn" style="padding: 6px 30px !important;margin-left: 30px"><span>{{\'button.music\' | translate}}</span></button> <button type="button" class="btn-cancel" data-dismiss="modal" ng-click="edit()" style="padding: 6px 30px !important;margin-left: 30px" ng-show="vm.returnurl"><span>{{\'button.edit\' | translate}}</span></button> <button type="button" class="btn-cancel" data-dismiss="modal" ng-click="shareParents()" style="padding: 6px 30px !important;margin-left: 30px" ng-show="vm.returnurl"><span>{{\'button.share\' | translate}}</span></button> <button type="button" class="btn-cancel bgcThemeColor" data-dismiss="modal" ng-click="reorder()" style="padding: 6px 30px !important;margin-left: 30px" ng-show="(vm.article.articleId || vm.article.articleStatus==\'COMPLETED\')&&vm.returnurl2"><span>{{vm.returnurl2Text}}</span></button></div><div class="main-cover" ng-show="vm.musicPage"><audio id="audition" autoplay></audio><div class="main-center"><div class="main-header"><span style="font-weight: bold">{{\'editorCommon.chooseMusic\' | translate}}</span> <span style="float: right;font-size: 20px" ng-click="cancel()">&times;</span></div><ul class="music_list"><li ng-repeat="music in Musics track by $index" ng-click="playList(music.identify,$index)" class="music-li{{$index}} music-li"><div class="music-name{{$index}} music-name">{{music.name}}</div><img src="content/images/icons/music-i2.svg" class="music-icon{{$index}} music-icon"> <span class="music-current{{$index}} music-current" style="float: right">{{\'editorCommon.currentMusic\' | translate}}</span></li></ul><div class="main-bottom"><span class="b-button b-cancel" ng-click="cancel()">{{\'button.cancel\' | translate}}</span> <span class="b-button b-confirm" ng-click="saveMusic()">{{\'button.confirm\' | translate}}</span></div></div></div></div>');
$templateCache.put('app/entities/page/pagesmySuffix-create.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" class="listBGC listCreate pad-0" style="border-radius: 8px;width: 528px"><div class="container-fluid" style="height: 50px"><div class="row moduleNameBGC"><button type="button" class="pad-5 close mar-top-10" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><div class="modal-detail-fff" style="border:none"><span style="color: #232323;font-size: 18px;font-weight: bold">{{vm.type=="NEW"?\'nav.photograph.content.btn.addPhotoAlbumPop.title\':\'nav.photograph.content.btn.addPhotoAlbumPop.title1\' | translate}}</span></div></div></div><div class="modal-body"><div class="panel-body form-horizontal"><input type="text" class="form-control" name="field_name" id="field_workName" ng-model="vm.name" style="border-radius: 4px" placeholder="{{\'nav.photograph.content.btn.addPhotoAlbumPop.inputPlaceholder\' | translate}}" maxlength="20"></div></div><div class="modal-footer pad-0 mar-0 dialog-foot" style="border:none;padding: 30px 24px 32px 0  !important"><button type="button" class="dialog-foot-close" ng-click="vm.clear()" data-dismiss="modal">{{\'button.cancel\' | translate}}</button> <button type="submit" ng-if="vm.type == \'NEW\'" class="dialog-foot-confirm" ng-disabled="editForm.$invalid || vm.isSaving">{{\'button.create\' | translate}}</button> <button type="submit" ng-if="vm.type == \'EDITOR\'" class="dialog-foot-confirm" ng-disabled="editForm.$invalid || vm.isSaving">{{\'button.ren\' | translate}}</button></div></form><style>.modal-content{\n        width: 528px !important;\n        background-clip: padding-box;\n        background-color: #FFFFFF;\n        border: none;\n        border-radius: 8px;\n        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);\n        outline: 0 none;\n        position: relative;\n        overflow: hidden;\n    }</style>');
$templateCache.put('app/entities/page-compontents/box-copy.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" class="listBGC listCreate pad-0" style="border-radius: 4px"><div class="container-fluid" style="height: 50px;font-weight: 600"><div class="row moduleNameBGC"><button type="button" class="pad-5 close mar-top-10" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><div style="line-height: 50px; padding-left: 30px"><span style="color: #232323;font-size: 16px">{{\'editorPop.boxCopy.title\' | translate}}</span></div></div></div><div class="panel-body form-horizontal" style="padding-top: 0px"><div class="col-lg-12 col-sm-12 form-group"><label class="col-md-3 control-label" style="text-align: left; font-weight: 400">{{\'editorPop.boxCopy.label\' | translate}}\uFF1A</label><div class="col-md-5"><select ng-model="vm.data.range" ng-options="type.page as type.name for type in vm.types" ng-change="unitConversion()" class="form-control left-panel-input noShadow" style="border-radius: 8px"></select></div></div><div class="col-lg-12 col-sm-12 form-group"><label class="col-md-12 mar-right-20"><input type="radio" ng-model="vm.data.generLoc" name="radio" value="all" style="width: 15px;height: 15px"> <span>{{\'editorPop.boxCopy.name1\' | translate}}</span></label></div><div class="col-lg-12 col-sm-12 form-group"><label class="col-md-12 mar-right-20"><input type="radio" ng-model="vm.data.generLoc" name="radio" value="next" style="width: 15px;height: 15px"> <span>{{\'editorPop.boxCopy.name2\' | translate}}</span></label></div><div class="col-lg-12 col-sm-12" style="text-align: right; padding:0px"><button type="submit" class="main-button-color" style="font-size: 15px; height: 40px;  padding: 5px 10px; border-radius: 6px; width: 96px; color: #fff !important" ng-disabled="editForm.$invalid || vm.isSaving">{{\'button.confirm\' | translate}}</button></div></div></form>');
$templateCache.put('app/entities/page-compontents/qrcode.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" class="listBGC listCreate pad-0" style="border-radius: 4px"><!-- <button type="button" class="pad-5 close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button> --><div class="container-fluid" style="height: 50px"><div class="row moduleNameBGC"><button type="button" class="pad-5 close mar-top-10" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><div class="modal-detail-fff"><span style="color: #232323;font-size: 16px">\u4E8C\u7EF4\u7801</span></div></div></div><div class="modal-body"><div class="panel-body form-horizontal"><div class="col-lg-10 col-sm-10 form-group"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label" for="field_workName">\u5185\u5BB9\uFF1A</label><div class="col-md-9 col-sm-9 col-xs-9"><input type="text" class="form-control" name="field_name" id="field_workName" ng-model="vm.code.value" placeholder="\u8BF7\u8F93\u5165"></div></div></div><div class="col-lg-2 col-sm-2 form-group"></div><div class="col-lg-12 col-sm-12 form-group mar-left-50">\u5C3A\u5BF8\uFF08\u5355\u4F4Dmm\uFF09\uFF1A</div><div class="col-lg-10 col-sm-10 form-group"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label" for="field_workName">\u5BBD\uFF1A</label><div class="col-md-6 col-sm-6 col-xs-6"><input type="number" class="form-control" placeholder="\u5BBD\u5EA6" max="" min="2" onkeyup="this.value= this.value.match(/\\d+(\\.\\d{0,2})?/) ? this.value.match(/\\d+(\\.\\d{0,2})?/)[0] : \'\'" ng-model-options="{debounce:500}" ng-model="vm.code.width"></div></div></div><div class="col-lg-2 col-sm-2 form-group"></div><div class="col-lg-10 col-sm-10 form-group"><div class="form-group"><label class="col-md-3 col-sm-3 col-xs-3 control-label" for="field_workName">\u9AD8\uFF1A</label><div class="col-md-6 col-sm-6 col-xs-6"><input type="number" class="form-control" placeholder="\u9AD8\u5EA6" max="" min="2" onkeyup="this.value= this.value.match(/\\d+(\\.\\d{0,2})?/) ? this.value.match(/\\d+(\\.\\d{0,2})?/)[0] : \'\'" ng-model-options="{debounce:500}" ng-model="vm.code.height"></div></div></div><div class="col-lg-2 col-sm-2 form-group"></div></div></div><!--<div class="modal-footer">--><!--<button type="button" class="btn btn-cancel" data-dismiss="modal" ng-click="vm.clear()">--><!--<span translate="entity.action.back">back</span>--><!--</button>--><!--<button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary btn-save btn-info">--><!--<span translate="entity.action.confirm">Confirm</span>--><!--</button>--><!--</div>--><div class="modal-footer pad-0 mar-0" style="border-top: 1px solid #E8E8E8"><button type="button" class="col-md-6 col-sm-6 col-xs-6 pad-0" data-dismiss="modal" style="background:#fff;color: #232323;font-size: 15px;height: 60px;border-right:1px solid #E8E8E8" ng-click="vm.clear()">\u53D6\u6D88</button> <button type="submit" style="font-size: 15px;height: 60px;padding: 0" class="col-md-6 col-sm-6 col-xs-6 main-button-color" ng-disabled="editForm.$invalid || vm.isSaving">\u786E\u5B9A</button></div></form>');
$templateCache.put('app/entities/page-compontents/thumbnailator.html','<form name="editForm" role="form" class="listBGC listCreate pad-0" style="border-radius: 15px;overflow: hidden;border: none"><div class="container-fluid" style="height: 50px"><div class="row moduleNameBGC"><i class="iconfont iconcuo dialog-close pad-5 close mar-top-10" style="font-size: 20px" ng-click="vm.clear()"></i><div class="modal-detail-fff"><span style="color: #232323;font-size: 16px">{{\'editorPop.thumbnailator1.title\' | translate}}</span></div></div></div><div class="pic-loading3" ng-if="vm.loading"><div class="load-mask"></div><img src="content/images/icons/loading01.gif"></div><div class="modal-body overflow-hidden"><div class="form-horizontal"><div translate-values="{bigSizeCount:vm.files.length}" translate="editorPop.thumbnailator1.content" class="font-14 mar-bottom-30"></div><div class="col-lg-3 col-sm-3 col-md-3 mar-bottom-10 text-center1" ng-repeat="file in vm.files track by $index"><div class="pos-rela thumbnailator-pic"><img ng-src="{{file.blobCover}}" class="thumbnailator-pic-cover" onerror="this.onerror=null;this.src=\'content/images/tooLarge.png\'"><div ng-click="deletePic($index)"><img src="content/images/x.png" width="12px" height="12px"></div><span class="thumbnailator-text-size"><span>{{\'editorPop.thumbnailator1.name1\' | translate}}\uFF1A{{file.imageSize}}</span>M</span></div><div class="thumbnailator-name" title="{{file.name}}">{{file.name}}</div><div class="thumbnailator-text" ng-if="vm.isEnd">{{\'editorPop.thumbnailator1.name2\' | translate}}\uFF1A{{file.lowerSize}}M</div></div></div></div><div class="dialog-foot" style="padding: 20px;margin: 0"><!-- <button type="button" class="dialog-foot-close" ng-click="vm.clear()">{{\'button.cancel\' | translate}}</button> --> <button type="button" class="dialog-foot-confirm" ng-if="!vm.isEnd" ng-click="vm.clear()">{{\'editorPop.thumbnailator1.compress\' | translate}}</button> <button type="button" class="dialog-foot-confirm" ng-if="vm.isEnd" ng-disabled="editForm.$invalid || vm.isSaving" ng-click="vm.save()">{{\'editorPop.thumbnailator1.upload\' | translate}}</button></div></form><style>.modal-content{\n        border-radius: 15px;\n        border:none;\n    }\n    .thumbnailator-pic-cover {\n        max-width: 100%;\n        max-height: 100%;\n        object-fit: contain;\n    }\n    .thumbnailator-name {\n        max-width: 100%;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        font-size: 12px;\n        color: #666;\n        margin-top: 4px;\n    }\n    .thumbnailator-text-size{\n        height: 30px;\n        position: absolute;\n        bottom: 0;\n        right: 0;\n        left: 0;\n        background: #000000b8;\n        color: #fff;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }</style>');
$templateCache.put('app/entities/page-compontents/uploadFailedImageListPopup.html','<div class="c-model"><div class="c-model-head"><div class="c-model-head-title">\u4E0A\u4F20\u5931\u8D25\u56FE\u7247\u5217\u8868</div><span class="iconfont iconcuo" ng-click="close()"></span></div><div class="c-model-body uploadFailedList scrollbar-main" style="height: 300px;overflow: auto"><div class="li" ng-repeat="file in vm.uploadFailedList track by $index"><img ng-src="{{file.blobCover}}"></div></div><div class="c-model-foot"><button type="button" class="close-btn" ng-click="close()">\u53D6\u6D88</button> <button type="button" class="save-btn" ng-click="upload()">\u91CD\u65B0\u4E0A\u4F20</button></div></div><style>.uploadFailedList{\n        display: flex;\n        flex-wrap: wrap;\n        gap: 16px;\n    }\n    .uploadFailedList .li{\n        width: 107px;\n        height: 107px;\n        background-color: #eee;\n    }\n    .uploadFailedList .li > img{\n        width: 100%;\n        height: 100%;\n        object-fit: contain;\n    }</style>');
$templateCache.put('app/entities/page-compontents/variable-data.html','<div><div class="container-fluid" style="height: 50px"><div class="row moduleNameBGC"><button type="button" class="pad-5 close mar-top-10" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><div class="modal-detail-fff"><span style="color: #232323;font-size: 16px">{{\'editorPop.variableDataTitle\' | translate}}</span></div></div></div><div class="modal-body scrollbar-main" style="height: 40vh; overflow: auto"><div class="scrollbar-main" style="overflow: auto"><table class="table table-striped"><thead><tr><th class="variable-data-table-th text-ellipsis" ng-repeat="title in vm.data.titles.title track by $index">{{title.value}}</th></tr></thead><tbody><tr ng-repeat="item in vm.data.values.value track by $index"><td class="variable-data-table-th text-ellipsis" ng-repeat="v in item.values track by $index">{{v.value}}</td></tr></tbody></table></div></div></div>');
$templateCache.put('app/entities/product-ec/editor-form.html','<div class="c-window" data-html2canvas-ignore><div class="c-editor-form" id="pageHeight"><div class="c-editor-form-canvas" ng-show="!vm.textFouched" ng-style="{\n                \'width\': vm.windowWidth,\n                \'height\': vm.windowHeight1\n             }"><page-mobile-edit ng-if="vm.productXmlData && vm.productXmlData.modelType != \'THREE\'" editor-type="vm.article.editorType" page-data="vm.pageData" page-index="vm.pageIndex" level-index="vm.levelIndex" level-type="vm.levelType" that="vm" img-size="vm.imgSize" img-dpi="vm.imgDpi" is-small-pic="vm.isSmallPic" transparency="vm.transparency" not-imagebox-tip="true" hint="vm.hint"></page-mobile-edit><three-preview1 ng-if="vm.article && vm.productXmlData && vm.productXmlData.modelType === \'THREE\' && vm.pageData1 && vm.productXmlData.modelData" width="vm.windowWidth" height="vm.windowHeight1" model-path="vm.productXmlData.modelPath" model-blendents="vm.productXmlData.modelBlendents" model-blendent-uuid="vm.article.modelBlendentUuid" model-data="vm.productXmlData.modelData" pages="vm.pageData1" style="background: #fff"></three-preview1></div><div class="c-editor-form-view" ng-style="{\'height\':vm.textFouched ? \'100vh\' : \'\'}"><div class="c-editor-form-view-textbox" ng-repeat="level in vm.pageData[vm.pageIndex].levels.level track by $index" ng-if="level.textbox"><div class="c-editor-form-view-title">{{level.name || \'editorCommon.textBoxTitle\' | translate}}</div><div class="c-editor-form-view-textbox-text"><input type="text" class="c-editor-form-view-textbox-text-input" ng-model="level.textbox.text" ng-change="textboxChange(level.textbox)" ng-focus="textboxFocus(level.textbox)" ng-blur="textboxBlur(level.textbox)"> <span class="c-editor-form-view-textbox-text-max">{{level.textbox.text.length}}/{{level.textbox.maxLength}}</span></div></div><div class="c-editor-form-view-imagebox" ng-repeat="level in vm.pageData[vm.pageIndex].levels.level track by $index" ng-if="level.imagebox"><div class="c-editor-form-view-title">{{level.name || \'editorCommon.imageBoxTitle\' | translate}}</div><div class="c-editor-form-view-imagebox-view" ng-click="imageboxCb(level.imagebox)"><i class="icon iconfont iconcamera" style="color: #fff; font-size: 18px" ng-if="!level.imagebox.image || !level.imagebox.image.resource || !level.imagebox.image.resource.identifier"></i> <img ng-src="{{( isLarge(level.imagebox.image.imageInfo) ? (level.imagebox.image.largeStatus == \'running\' ? \'content/images/largeLoading.jpg\' : level.imagebox.image.largeStatus == \'error\' ? \'content/images/largeError.jpg\' : level.imagebox.image.resource.identifier + \'.thumbnail.jpg\') : level.imagebox.image.resource.identifier)+ \'?imageMogr2/auto-orient/thumbnail/200x200\'}}" alt="" ng-if="level.imagebox.image && level.imagebox.image.resource && level.imagebox.image.resource.identifier"></div></div></div><div class="c-editor-form-font" ng-if="vm.pageData[vm.pageIndex].config.partid"><div class="c-editor-form-font-fl">{{partName(vm.pageData[vm.pageIndex].config.partid)}}</div><div class="c-editor-form-font-fr"><div class="c-editor-form-font-fr-btn1" ng-if="vm.pageIndex > 0" ng-click="previousPage()">{{\'editorBtn.previousPage\' | translate}}</div><div class="c-editor-form-font-fr-btn2" ng-if="vm.pageIndex<vm.pageSum" ng-click="nextPage()">{{\'editorBtn.nextPage\' | translate}}</div><div class="c-editor-form-font-fr-btn2" ng-if="vm.pageIndex == vm.pageSum" ng-click="save()">{{\'button.save\' | translate}}</div></div></div></div><!-- \u56FE\u7247\u5E93 --><div class="c-editor-form-photo-modal" ng-show="vm.isGallery || vm.isPlatformPhoto" ng-click="imageboxHide()"></div><div class="c-editor-form-photo-body" ng-show="vm.isGallery || vm.isPlatformPhoto"><div class="c-editor-form-photo-body-head"><div ng-class="{\'c-editor-form-photo-body-head-select\' : vm.isGallery}" ng-click="mapDepot(true)">{{\'editorBtn.showGallery\' | translate}} <span class="c-editor-form-photo-body-head-select-hr"></span></div><div ng-class="{\'c-editor-form-photo-body-head-select\' : vm.isPlatformPhoto}" ng-click="mapDepot(false)">{{\'editorBtn.platformPhoto\' | translate}} <span class="c-editor-form-photo-body-head-select-hr"></span></div></div><div class="c-editor-form-photo-body-view" ng-show="vm.isGallery" id="photoGalleryId"><ul><li><div class="c-editor-form-photo-body-view-li-view"><div ng-click="uploadPhoto()"><i class="icon iconfont iconcamera" style="color: #fff"></i> <input onchange="uploadImageMutiple(event)" type="file" multiple="multiple" accept="{{vm.supportedMimeTypes}}" name="file" ng-if="!agentIos && vm.isIPhone6" class="input-upload2"></div></div></li><li ng-repeat="data in vm.uploadPhotoItem" ng-if="data.percent != 100 && data.state !=\'error\'" style="position: relative"><progres-view :src="data.blobCover" :progres="data.percent"></progres-view></li><li ng-repeat="item in vm.photoAll track by $index" ng-click="addImageboxImg(item)"><div class="c-editor-form-photo-body-view-li-view"><img ng-if="(item.identifier || (item.largeFlag && item.identifier1)) && photoStatus(item) == \'\'" ng-src="{{(item.largeFlag ? item.identifier1 : item.identifier)+\'?imageView2/1/h/108\'}}" alt="" data-imgindex="{{$index}}"><!--\u5927\u56FE\u5904\u7406\u4E2D/\u5931\u8D25\u3001\u8272\u5F69\u8F6C\u6362\u4E2D/\u5931\u8D25\uFF1A\u5360\u4F4D\u56FE + \u5C45\u4E2D\u72B6\u6001\u56FE\u6807\u4E0E\u6587\u6848--><div class="c-editor-form-photo-status" ng-if="(item.identifier || (item.largeFlag && item.identifier1)) && photoStatus(item) != \'\'" ng-class="{\'is-failed\': isPhotoFailed(item)}" ontouchstart="event.stopPropagation()" ng-click="onPhotoStatusClick(item, $event)"><img class="c-editor-form-photo-status-placeholder" src="content/images/placeholderImage.png" alt=""><div class="c-editor-form-photo-status-mask"><img class="c-editor-form-photo-status-icon" ng-if="photoStatus(item) == \'largeError\' || photoStatus(item) == \'convertError\'" src="content/images/close1.png" alt=""> <img class="c-editor-form-photo-status-icon" ng-if="photoStatus(item) == \'convertRunning\' || photoStatus(item) == \'largeRunning\'" src="content/images/loading1.png" alt=""> <span class="c-editor-form-photo-status-text">{{(\'nav.photograph.content.status.\' + photoStatus(item)) | translate}}</span></div></div><div style="position: absolute; left: 0; top: 0; width: 100%; height: 100%; z-index: 1" data-imgindex="{{$index}}"></div></div></li></ul><div class="animation-xia" ng-if="vm.photoAll.length>8"><i class="icon iconfont iconxiangxia2"></i></div></div><div class="c-editor-form-photo-body-view" ng-show="vm.isPlatformPhoto" id="platformPhotoId"><ul ng-if="vm.recommendPics.length>0"><li ng-repeat="item in vm.recommendPics track by $index" ng-click="addImageboxImg(item)"><div class="c-editor-form-photo-body-view-li-view"><img ng-if="item.identifier" ng-src="{{item.identifier+\'?imageView2/1/h/108\'}}" alt=""></div></li></ul><div class="c-editor-form-photo-body-view-notData" ng-if="vm.recommendPics.length == 0">{{\'hint.noData\' | translate}}</div><div class="animation-xia" ng-if="vm.recommendPics.length>8"><i class="icon iconfont iconxiangxia2"></i></div></div></div><div style="opacity: 0; position: fixed" ng-if="vm.textbox" ng-style="{\n    \'width\': !writingmodeInit(vm.textbox.style.writingmode) ? (vm.textbox.geometry.width) : \'auto\',\n    \'height\': writingmodeInit(vm.textbox.style.writingmode) ? (vm.textbox.geometry.height) : \'auto\'\n    }"><pre id="c-xml-page-material-fontId1" style="display: inline-block; opacity: 0" ng-style="{\n                \'font-family\': \'\\\'\' + vm.textbox.fontuuid + \'\\\'\',\n                \'font-size\': (vm.textbox.style.size > 12 ? vm.textbox.style.size : 12) + \'pt\',\n                \'color\': vm.textbox.style.color,\n                \'font-weight\': vm.textbox.style.bold ? \'bold\': \'400\',\n                \'font-style\': vm.textbox.style.italic ? \'italic\': \'initial\',\n                \'letter-spacing\': (vm.textbox.style.size > 12 ? vm.textbox.style.letterspacing : (vm.textbox.style.letterspacing) / (1 / 12 * vm.textbox.style.size)) + \'pt\',\n                \'line-height\': (vm.textbox.style.size > 12 ? vm.textbox.style.lineheight : (vm.textbox.style.lineheight) / (1 / 12 * vm.textbox.style.size)) + \'pt\',\n                \'transform\':\'scale(\'+(1 / 12 * vm.textbox.style.size > 1 ? 1 : 1 / 12 * vm.textbox.style.size)+\')\',\n                \'transform-origin\': \'0 0\',\n                \'text-decoration\': \'none\',\n                \'text-align-last\': \'unset\',\n                \'max-width\' : \'100%\',\n                \'writing-mode\': vm.textbox.style.writingmode\n                }"><span class="pre-span">{{vm.textbox.text}}</span></pre></div><upload-image tag="\'normalEditor\'" store-id="vm.storeId" aid="vm.aid" upload-photo-item="vm.uploadPhotoItem" on-uploadphoto="uploadSuccess(text)"></upload-image><!--\u91CD\u590D\u56FE\u7247--><duplicate-list ng-if="vm.isDuplicateList" list="vm.duplicateList" on-change="duplicateChange(text)"></duplicate-list></div><div class="three-modal1" ng-if="vm.threeLoading"><img src="content/images/icon/loading.gif" alt=""><div>{{vm.threeLoadingText}}</div></div><!--\u5220\u9664\u5904\u7406\u5931\u8D25\u7684\u7167\u7247--><div class="three-modal" ng-if="vm.deletePhotoSure"><div class="three-modal-body"><div class="three-modal-body-content" style="flex-direction: column; height: auto; padding: 24px 20px"><div style="font-size: 15px; font-weight: bold; color: #333; margin-bottom: 10px">{{\'nav.photograph.content.deletePhoto.title\' | translate}}</div><div style="font-size: 14px; color: #666; text-align: center">{{\'nav.photograph.content.deletePhoto.content\' | translate}}</div></div><div class="three-modal-body-foot"><button type="button" class="color1" ng-click="vm.deletePhotoSure = false">{{\'button.cancel\' | translate}}</button> <button type="button" class="color2" ng-click="deletePhotoConfirm()">{{\'button.confirm\' | translate}}</button></div></div></div><div class="three-modal2" ng-if="vm.threeError"><div class="three-modal2-body"><i class="icon iconfont iconkulian"></i><div>{{vm.threeErrorText}}</div></div></div><div class="move-tip1" ng-if="vm.hint" data-html2canvas-ignore><img src="content/images/move_tip.png"></div><!--\u5C01\u9762\u7F29\u7565\u56FEview--><div id="thumbnail-view" style="position: fixed; z-index: -1; overflow: hidden"><page-preview page="template.pages.page[vm.pageIndex]" scale="template.pages.page[vm.pageIndex].custom.thumbnailScale" thumbnail="true"></page-preview></div><!-- \u5B58\u5728\u7167\u7247\u7269\u7406\u5220\u9664 \u63D0\u9192\u7528\u6237 --><!--<div class="c-modal exit-box" ng-if="vm.isDestroyed">--><!--    <div class="exit-box-mask"></div>--><!--    <div class="exit-box-con"  style=" background: #fff;width: 66%">--><!--        <div class="col-lg-12 col-sm-12 article-save-confirm-head">--><!--            <img src="content/images/icons/close1.svg" style="width: 16px;" ng-click="vm.isDestroyed=false">--><!--        </div>--><!--        <div class="col-lg-12 col-sm-12 article-save-confirm"  >--><!--            \u68C0\u6D4B\u51FA--><!--            <span class="themecolor" style="font-size: 26px;">--><!--                {{vm.deleteList.length}}--><!--            </span>--><!--            \u5F20\u56FE\u7247\u5DF2\u4ECE\u56FE\u5E93\u88AB\u5220\u9664\uFF0C\u4F5C\u54C1\u4E2D\u76F8\u5173\u56FE\u7247\u5C06\u88AB\u6E05\u7406\uFF0C\u662F\u5426\u7EE7\u7EED\u4FDD\u5B58\u4F5C\u54C1\uFF1F--><!--        </div>--><!--        <div class="col-lg-12 col-sm-12 pad-0" style="border-top: 1px solid #dfdfdf;">--><!--            <button class="col-lg-6 col-sm-6 pad-0 back-btn1" style=" width:49%;" ng-click="galleryDestroyConfirm(vm.saveflag)">\u786E\u8BA4</button>--><!--            <button class="col-lg-6 col-sm-6 pad-0 article-save-btn3" style="width:49%;"  ng-click="confirmRemove()">\u53BB\u4FEE\u6539</button>--><!--        </div>--><!--    </div>--><!--</div>--><!--\u6587\u5B57\u68C0\u6D4B\u7ED3\u679C--><div class="c-modal" ng-if="vm.isDocumentTextDetection"><div class="exit-box-mask"></div><div class="exit-box-con1"><div class="c-documentTextDetection-title">{{\'editorCommon.textDetection.title\' | translate}}</div><div class="c-documentTextDetection-list" ng-repeat="item in vm.documentTextDetection track by $index"><div class="c-documentTextDetection-list-title">{{\'editorCommon.textDetection.whichPage\' | translate:item.pageIndex}}</div><div class="c-documentTextDetection-list-body" ng-repeat="text in item.texts">{{text}}</div></div><div class="c-documentTextDetection-save" ng-click="vm.isDocumentTextDetection=false">{{\'editorBtn.toModify\' | translate}}</div><div class="c-documentTextDetection-save"><div class="c-documentTextDetection-save1" ng-click="vm.isDocumentTextDetection=false">{{\'button.cancel\' | translate}}</div><div class="c-documentTextDetection-save2" ng-click="goPageContent(vm.documentTextDetection[0].pageIndex-1)">{{\'editorBtn.toModify\' | translate}}</div></div></div></div><input onchange="uploadImageMutiple(event)" type="file" multiple="multiple" accept="{{vm.supportedMimeTypes}}" name="file" ng-if="!agentIos && !vm.isIPhone6" class="input-upload1" id="uploadImageMutipleId" data-html2canvas-ignore><div class="lang-ic" ng-show="vm.lagnuages.length>1&&!vm.hide" style="bottom: 120px"><img src="content/images/lagnuage.svg" ng-click="vm.language=true"><div class="lang-ic-content" ng-click="vm.hide=true"><i class="iconfont iconjian2"></i></div></div><language is-show="vm.language" ng-if="vm.language"></language><style>body{\n        overflow: unset !important;\n    }\n    .c-window *{\n        -webkit-touch-callout:none; /*\u7CFB\u7EDF\u9ED8\u8BA4\u83DC\u5355\u88AB\u7981\u7528*/\n        -webkit-user-select:none; /*webkit\u6D4F\u89C8\u5668*/\n        -khtml-user-select:none; /*\u65E9\u671F\u6D4F\u89C8\u5668*/\n        -moz-user-select:none;/*\u706B\u72D0*/\n        -ms-user-select:none; /*IE10*/\n        user-select:none;\n    }\n    .c-window input {\n        -webkit-user-select:auto !important;\n    }\n\n    .c-window textarea{\n        -webkit-user-select:auto !important;\n    }\n\n    /*\u8868\u5355\u7F16\u8F91\u5668*/\n    .c-editor-form{\n        width: 100vw;\n        height: 100vh;\n    }\n    .c-editor-form-canvas{\n        position: relative;\n        background: #fff;\n        overflow: hidden;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n    .c-editor-form-view{\n        position: relative;\n        width: 100%;\n        height: calc(100vh - 350px);\n        background: #fff;\n        padding: 15px 15px 100px;\n        overflow: auto;\n        border-radius: 18px 18px 0 0;\n        box-shadow: 0px 2px 10px 5px rgba(0, 0, 0, 0.15);\n    }\n    .c-editor-form-view-textbox{\n        margin-bottom: 20px;\n    }\n    .c-editor-form-view-title{\n        height: 30px;\n        line-height: 30px;\n        color: #141414;\n        font-size: 14px;\n    }\n    .c-editor-form-view-textbox-text{\n        width: 100%;\n        height: 45px;\n        position: relative;\n    }\n    .c-editor-form-view-textbox-text-input{\n        width: 100%;\n        background: #F9F9F9;\n        height: 100%;\n        padding: 0 60px 0 6px;\n        font-size: 14px;\n        color: #141414;\n        border: 0;\n        border-radius: 8px;\n    }\n    .c-editor-form-view-textbox-text-max{\n        position: absolute;\n        display: inline-block;\n        height: 45px;\n        line-height: 45px;\n        top: 0;\n        right: 6px;\n        color: #C7C7C7;\n        font-size: 16px;\n    }\n    .c-editor-form-view-imagebox{\n        margin-bottom: 20px;\n    }\n    .c-editor-form-view-imagebox-view{\n        width: 112px;\n        height: 112px;\n        border-radius: 8px;\n        background: #F9F9F9;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n    .c-editor-form-view-imagebox-view .iconfont{\n        font-size: 40px;\n    }\n    .c-editor-form-view-imagebox-view img{\n        max-width: 100%;\n        max-height: 100%;\n    }\n    .c-editor-form-photo-modal{\n        position: fixed;\n        left: 0;\n        top: 0;\n        width: 100vw;\n        height: 100vh;\n        background: rgba(0,0,0,0.6);\n        z-index: 99;\n    }\n    .c-editor-form-photo-body{\n        position: fixed;\n        left: 0;\n        bottom: 0;\n        width: 100vw;\n        height: 530px;\n        background: #fff;\n        border-radius: 16px 16px 0 0;\n        z-index: 100;\n    }\n    .c-editor-form-photo-body-head{\n        width: 100%;\n        height: 50px;\n        display: flex;\n        justify-content: space-around;\n        align-items: center;\n        font-size: 16px;\n        color: #909090;\n    }\n    .c-editor-form-photo-body-head .c-editor-form-photo-body-head-select-hr{\n        display: none;\n        position: absolute;\n        bottom: -8px;\n        left: 50%;\n        height: 2px;\n        width: 30px;\n        margin-left: -15px;\n        border-radius: 2px;\n        background: var(--genericColor);\n    }\n    .c-editor-form-photo-body-head-select{\n        position: relative;\n        color: var(--genericColor);\n    }\n    .c-editor-form-photo-body-head-select .c-editor-form-photo-body-head-select-hr{\n        display: block;\n    }\n    .c-editor-form-photo-body-view{\n        height: 480px;\n        width: 100%;\n        overflow: scroll;\n    }\n    .c-editor-form-photo-body-view-notData{\n        height: 100%;\n        width: 100%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        font-size: 16px;\n        color: #9999;\n    }\n    .c-editor-form-photo-body-view ul{\n        display: flex;\n        flex-flow: wrap;\n        padding: 15px;\n        width: 100%;\n    }\n    .c-editor-form-photo-body-view ul li{\n        width: 33%;\n        height: 108px;\n        display: flex;\n        justify-content: center;\n        margin-bottom: 15px;\n    }\n    .c-editor-form-photo-body-view-li-view{\n        position: relative;\n        width: 108px;\n        height: 108px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        background: #f3f3f3;\n        border-radius: 6px;\n    }\n    .c-editor-form-photo-body-view ul li img{\n        max-width: 100%;\n        max-height: 100%;\n    }\n    .c-editor-form-font{\n        position: fixed;\n        left: 0;\n        bottom: 0;\n        height: 80px;\n        width: 100vw;\n        background: #fff;\n        box-shadow: 0px 1px 10px 0px rgba(201,201,201,0.5);\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding: 0 15px;\n    }\n    .c-editor-form-font-fl{\n        color: #666666;\n        font-size: 14px;\n    }\n    .c-editor-form-font-fr{\n        display: flex;\n    }\n    .c-editor-form-font-fr-btn1{\n        width: 108px;\n        height: 40px;\n        border-radius: 20px;\n        border: 1px solid var(--genericColor);\n        color: var(--genericColor);\n        background: #fff;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        margin-right: 10px;\n    }\n    .c-editor-form-font-fr-btn2{\n        width: 108px;\n        height: 40px;\n        border-radius: 20px;\n        border: 1px solid var(--genericColor);\n        color: #fff;\n        background: var(--genericColor);\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n    /* \u5927\u56FE\u5904\u7406\u4E2D/\u5931\u8D25\u3001\u8272\u5F69\u8F6C\u6362\u4E2D/\u5931\u8D25\uFF1A\u5360\u4F4D\u56FE + \u5C45\u4E2D\u72B6\u6001\u56FE\u6807\u4E0E\u6587\u6848 */\n    .c-editor-form-photo-status{\n        position: absolute;\n        left: 0;\n        top: 0;\n        z-index: 2;\n        width: 100%;\n        height: 100%;\n        overflow: hidden;\n        border-radius: 6px;\n    }\n    .c-editor-form-photo-status-placeholder{\n        position: absolute;\n        left: 0;\n        top: 0;\n        z-index: 1;\n        display: block;\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n    }\n    .c-editor-form-photo-status-mask{\n        position: absolute;\n        left: 0;\n        top: 0;\n        z-index: 2;\n        display: flex;\n        box-sizing: border-box;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        width: 100%;\n        height: 100%;\n        padding: 4px;\n        background-color: rgba(0, 0, 0, 0.25);\n    }\n    .c-editor-form-photo-status-icon{\n        display: block;\n        flex: none;\n        width: 20px;\n        height: 20px;\n        margin-bottom: 4px;\n        object-fit: contain;\n    }\n    .c-editor-form-photo-status-text{\n        max-width: 100%;\n        color: #ffffff;\n        font-size: 11px;\n        line-height: 14px;\n        text-align: center;\n        word-break: break-all;\n        text-shadow: 0 1px 4px rgba(0,0,0,0.6);\n    }\n    .c-editor-form-photo-status.is-failed{\n        cursor: pointer;\n    }</style>');
$templateCache.put('app/entities/product-ec/editor-photo-both.html','<div style="min-height: 100vh;background: #f3f3f3" data-html2canvas-ignore><input onchange="uploadImageMutiple(event)" type="file" multiple="multiple" accept="{{vm.supportedMimeTypes}}" name="file" ng-if="!agentIos && !vm.isIPhone6" class="input-upload1" id="uploadImageMutiple-page0"><div class="c-productThree1" ng-if="vm.page1"><div class="c-editorPhoto1-head" style="padding: 0 0 60px"><div class="c-page-view clearfix" ng-if="vm.data.length>0"><div class="c-page-view-li" ng-repeat="data in vm.data track by $index" ng-init="index = $index" style="float: none; background: #fff" ng-if="vm.pictureType == \'spread\'"><div class="c-page-view-li-item"><div class="c-page-view-li-img" ng-repeat="page in data track by $index" ng-init="pageIndex = $index" id="page{{index*2+pageIndex}}" ng-click="single(index, pageIndex)" style="overflow: hidden;display: flex; justify-content: center; align-items: center" ng-style="{\n                            \'width\': page.custom.width * page.custom.ratio,\n                            \'height\': page.custom.height * page.custom.ratio,\n                         }"><page-preview page="page" is-page-trimbox="true" scale="page.custom.ratio" is-imagebox-not="true" img-size="vm.imgSize" img-dpi="vm.imgDpi" editor-type="vm.article.editorType" is-outline="true"></page-preview><div class="c-page-view-li-direction">{{(pageIndex == 0 ? \'editorCommon.front\' : \'editorCommon.verso\') | translate}}</div><div class="c-page-view-li-img-copy" ng-if="vm.isCopyBack && vm.copyBackIndex != index && pageIndex ==1 && !page.isCopyBack"><div class="c-page-view-li-img-copy-btn" style="color: var(--genericColor);height: 30px;line-height: 30px" ng-click="editorPageCopyHere($event, index)">{{\'editorCommon.copyHere\' | translate}}</div></div></div><img class="c-page-view-li-delete2" src="content/images/delete-photo-work.png" alt="" ng-click="subtractDeleteTab($event,$index)" ng-if="!vm.isCopyBack"></div><div class="c-page-view-li-btn" style="border: 0"><i class="iconfont iconjian" ng-click="subtractQuantityTab(data[0])" ng-style="{\'color\':data[0].quantity <= 1 ? \'#d5d5d5\':\'#000\'}"></i> <input type="number" class="c-input10" ng-model="data[0].quantity" style="text-align: center; padding: 0;margin: 0 8px" ng-change="quantityChange(data[0])"> <i class="iconfont iconzengjia" style="color:#000000" ng-click="pushQuantityTab(data[0])"></i><div class="c-page-view-li-btn-1" ng-if="ifCopyBack($index)" ng-click="copyBack($event,$index)">{{\'editorCommon.copyBack\' | translate}}</div><div class="c-page-view-li-btn-2" ng-if="data[1].isCopyBack" style="color: #fdb44f; font-size: 12px;line-height: 20px">{{\'editorCommon.Copied\' | translate}}</div></div></div><div class="c-page-view-li2" ng-repeat="page in vm.data track by $index" style="position: relative" ng-if="vm.pictureType == \'single\'" id="page{{$index}}"><div class="c-page-view-li-img" style="overflow: hidden;display: flex; justify-content: center; align-items: center" ng-click="single($index, 0)" ng-style="{\n                            \'width\': page.custom.width * page.custom.ratio,\n                            \'height\': page.custom.height * page.custom.ratio,\n                         }"><page-preview page="page" is-page-trimbox="true" scale="page.custom.ratio" is-imagebox-not="true" img-size="vm.imgSize" img-dpi="vm.imgDpi" editor-type="vm.article.editorType" is-outline="true"></page-preview></div><div class="c-page-view-li-btn" style="border: 0"><i class="iconfont iconjian" ng-click="subtractQuantityTab(page)" ng-style="{\'color\':page.quantity <= 1 ? \'#d5d5d5\':\'#000\'}"></i> <input type="number" class="c-input10" ng-model="page.quantity" style="text-align: center; padding: 0;margin: 0 8px" ng-change="quantityChange(page)"> <i class="iconfont iconzengjia" style="color:#000000" ng-click="pushQuantityTab(page)"></i></div><img class="c-page-view-li-delete2" src="content/images/delete-photo-work.png" alt="" ng-click="subtractDeleteTab($event,$index)"></div></div><div class="c-page-view-notData" ng-if="vm.data.length == 0"><img src="content/images/worksNull.png" alt="" srcset="" style="width:50%"><div style="display: flex;flex-direction: column;align-items: center;justify-content: center;margin-top: 12px"><div style="text-align: center;font-size: 14px;color: #aeaeae">{{\'editorCommon.noPhotos\' | translate}}</div><div style="color: var(--genericColor); font-size: 16px; margin-top: 16px" ng-if="vm.article.expectPageCount && !vm.article.multiple" translate="editorCommon.expectPageCount" translate-values="{expectPageCount:vm.pictureType == \'spread\' ? (vm.signalPage1.imageboxQuantity+vm.signalPage2.imageboxQuantity)*vm.article.expectPageCount : vm.signalPage1.imageboxQuantity*vm.article.expectPageCount}"></div></div></div></div><div class="c-editorPhoto1-foot" ng-show="!vm.templateView" ng-style="{\'padding-bottom\': vm.isIPhoneX ? \'30px\' : \'0\', \'height\' : vm.isIPhoneX ? \'auto\' : \'60px\'}"><div style="display:flex"><div class="btn1" ng-click="showGallery()" style="position: relative"><img src="content/images/add-photo.png" style="width: 24px" alt=""> <span>{{\'editorBtn.uploadGallery\' | translate}}</span> <input onchange="uploadImageMutiple(event)" type="file" multiple="multiple" accept="{{vm.supportedMimeTypes}}" name="file" ng-if="!agentIos && vm.isIPhone6" class="input-upload2"></div><div class="btn1" ng-click="vm.templateView = true"><img src="content/images/repeat-template.png" style="width: 24px" alt=""> <span>{{\'template.change\' | translate}}</span></div></div><div class="c-editorPhoto1-foot-right"><div style="color: var(--genericColor)" ng-if="!vm.article.multiple || (vm.article.multiple&&vm.article.expectPageCount>1)">{{\'editorCommon.totalCount\' | translate}}{{vm.totalCount/2 || 0}}/{{vm.article.expectPageCount}}</div><div class="btn-save" style="margin-left: 8px" ng-class="{\'btn-save-select\' : vm.data.length>0 && vm.placeOrder}" ng-click="saveTab()">{{\'editorBtn.save\' | translate}}</div></div><div class="c-editorPhoto1-foot-top" ng-if="vm.article.multiple && vm.article.expectPageCount > 1">{{\'editorCommon.minOrderInfo\' | translate: {expectPageCount: vm.article.expectPageCount} }}</div></div><!-- \u5F53\u524D\u4F7F\u7528 item.productXmlId === vm.article.productXmlId --><div class="c-editorPhoto3-foot" ng-if="vm.templateView" style="flex-direction: column;height: 148px"><div class="c-editorPhoto3-foot-template-view-head" ng-click="vm.templateView = false"><span>{{\'editorCommon.replaceTemplate\' | translate}}</span> <i class="iconfont iconcuo c-editorPhoto3-foot-template-view-close"></i></div><div class="c-editorPhoto3-foot-template-view-body"><div class="c-editorPhoto3-foot-template-view-body-view" ng-repeat="item in vm.productXmlLines track by $index" ng-click="productXmlLineClick(item)" ng-if="!item.cancelled"><img ng-src="{{item.coverImg}}" alt=""><div ng-show="item.productXmlId == vm.article.productXmlId" style="display: flex;align-items: center;justify-content: center;background-color: #0000007e;color: #FFFFFF;position: absolute;left: 0;top: 0;width: 100%;height: 100%">{{\'editorCommon.currentUse\' | translate}}</div></div></div></div></div><page-sort ng-if="vm.page2" :store-id="vm.storeId" :agent-ios="agentIos" :is-iphone6="vm.isIPhone6" :photo-all="vm.photoSelectAll" :product="vm.product" :aid="vm.aid" on-change="pageSortCb(text)"></page-sort><!--  \u5355\u9875\u7F16\u8F91  --><div class="c-productThree2" ng-if="vm.page3"><div class="c-productThree2-head1" style="position:relative"><span class="arrow-prev" ng-click="getBack(\'page3\')" style="width: 20px; height: 20px; position: absolute; left: 10px; top: 10px"></span><div class="c-editorPhoto3-body-tab1" style="font-size: 14px;color: #999999;position: unset"><span>{{\'editorCommon.pageNumber\' | translate: {pageIndex: singleInit(vm.singleIndex+1)} }}</span> <span>\uFF0C</span> <span>{{\'editorCommon.totalPages\' | translate: {pageSum: vm.pictureType == \'spread\' ? vm.singleData.length/2 : vm.singleData.length} }}</span></div><button class="c-productThree2-head1-button" ng-click="singleSave()">{{\'button.save2\' | translate}}</button></div><div class="spread-view" ng-if="vm.pictureType == \'spread\'"><span class="spread-view-btn" ng-class="{\'spread-view-select\' : !zfInit()}" ng-click="singleIndexClick(false)">{{\'editorCommon.front\' | translate}}</span> <span class="spread-view-btn" ng-class="{\'spread-view-select\' : zfInit()}" ng-click="singleIndexClick(true)">{{\'editorCommon.verso\' | translate}}</span></div><div class="c-editorPhoto3-body" ng-click="photoGalleryHide()"><div class="c-editorPhoto3-body-content1" style="position: relative"><page-mobile-edit editor-type="vm.article.editorType" page-data="vm.singleData" page-index="vm.singleIndex" level-index="vm.levelIndex" level-type="vm.levelType" that="vm" img-size="vm.imgSize" img-dpi="vm.imgDpi" is-small-pic="vm.isSmallPic" transparency="vm.transparency" not-imagebox-tip="true" hint="vm.hint"></page-mobile-edit><div style="margin-top: 10px; color: #666; display: flex; justify-content: space-between"><div style="display: flex; align-items: center" ng-click="previousPage()" ng-show="vm.singleIndex>0"><i class="iconfont iconzuoceshouqi1"></i> {{\'gallery.previousPage\' | translate}}</div><div style="display: flex; align-items: center; margin-left: auto" ng-click="nextPage()" ng-show="vm.singleIndex<vm.singleData.length-1">{{\'gallery.nextPage\' | translate}} <i class="iconfont iconyouceshouqi1"></i></div></div></div></div><div class="c-editorPhoto1-foot1" ng-if="vm.article.editorType == \'PICTURE_PRO\' || vm.article.editorType == \'PICTURE_PRO_P\'"><div class="c-editorPhoto1-foot1-1" ng-if="vm.propertyValue.outline.length || vm.propertyValue.hotStamp.length || vm.propertyValue.white.length || vm.propertyValue.uv.length || vm.propertyValue.fluore.length"><div ng-class="{\'c-editorPhoto1-foot1-1-active\' : vm.operationTab == \'picture\'}" ng-click="operationTabCb(\'picture\')">{{\'editorCommon.pictureLayer\' | translate}}</div><div ng-click="setOutline()" ng-if="vm.propertyValue.outline.length && (vm.pictureType == \'single\' || (vm.pictureType == \'spread\' && !zfInit()))">{{\'editorCommon.outlineLayer\' | translate}}</div><div ng-class="{\'c-editorPhoto1-foot1-1-active\' : vm.operationTab == \'TECHNIQUE\'}" ng-click="operationTabCb(\'TECHNIQUE\')" ng-if="vm.propertyValue.hotStamp.length && (vm.pictureType == \'single\' || (vm.pictureType == \'spread\' && ((vm.product.reverseProcess && zfInit()) || !zfInit())))">{{\'editorCommon.hotStampingLayer\' | translate}}</div><div ng-class="{\'c-editorPhoto1-foot1-1-active\' : vm.operationTab == \'white\'}" ng-click="operationTabCb(\'white\')" ng-if="vm.propertyValue.white.length && (vm.pictureType == \'single\' || (vm.pictureType == \'spread\' && ((vm.product.reverseProcess && zfInit()) || !zfInit())))">{{\'editorCommon.whiteInkLayer\' | translate}}</div><div ng-class="{\'c-editorPhoto1-foot1-1-active\' : vm.operationTab == \'uv\'}" ng-click="operationTabCb(\'uv\')" ng-if="vm.propertyValue.uv.length && (vm.pictureType == \'single\' || (vm.pictureType == \'spread\' && ((vm.product.reverseProcess && zfInit()) || !zfInit())))">{{\'editorCommon.uvLayer\' | translate}}</div><div ng-class="{\'c-editorPhoto1-foot1-1-active\' : vm.operationTab == \'fluore\'}" ng-click="operationTabCb(\'fluore\')" ng-if="vm.propertyValue.fluore.length && (vm.pictureType == \'single\' || (vm.pictureType == \'spread\' && ((vm.product.reverseProcess && zfInit()) || !zfInit())))">{{\'editorCommon.fluoreLayer\' | translate}}</div></div><div class="c-editorPhoto1-foot1-2" ng-if="vm.operationTab == \'picture\'"><div class="icon-btn c-color2" ng-click="materialShow()"><i class="icon iconfont iconsucaishape" style="color: #000"></i> <span>{{\'editorBtn.clipartText\' | translate}}</span></div><div class="icon-btn c-color2" ng-click="fontShow()"><i class="icon iconfont iconwenzishape" style="color: #000"></i> <span>{{\'editorBtn.wordText\' | translate}}</span></div><div class="icon-btn c-color2" ng-click="photoGalleryShow()"><i class="icon iconfont icontupianshape" style="color: #000"></i> <span>{{\'editorBtn.imgText\' | translate}}</span></div><div class="icon-btn c-color2" ng-click="reserveShow()" ng-if="template.backupPages && template.backupPages.list && template.backupPages.list.length>0"><i class="icon iconfont iconlayout" style="color: #000"></i> <span>{{\'editorBtn.reserve\' | translate}}</span></div></div><div class="c-editorPhoto1-foot1-2" ng-if="vm.operationTab == \'TECHNIQUE\'" style="justify-content: flex-start;gap: 40px;padding: 0 20px"><div class="icon-btn c-color2" style="position: relative" ng-repeat="item in vm.propertyValue.hotStamp track by $index"><i class="iconfont iconshangchuanzhaopian1" style="color: #000"></i> <span>{{\'editorCommon.uploadHotStamping\' | translate}}{{item.operationValueAlias}}</span> <input onchange="uploadColor(event, this.getAttribute(\'data-item\'))" data-item="{{item}}" type="file" accept="image/png" class="input-upload2"></div></div><div class="c-editorPhoto1-foot1-2" ng-if="vm.operationTab == \'white\'" style="height: auto; padding: 0; justify-content: flex-start"><div class="c-editorPhoto1-foot1-2-white" ng-if="vm.singleData && vm.singleData[vm.singleIndex] && vm.singleData[vm.singleIndex].levels.level && vm.singleData[vm.singleIndex].levels.level[vm.levelIndex] && vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox && vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.image"><div class="c-editorPhoto1-foot1-2-white-1 custom-grid2"><img ng-src="{{vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.image.resource.identifier | imageFilter}}" ng-if="vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.image"></div><div class="c-editorPhoto1-foot1-2-white-2"><div style="color: #FD5722" ng-click="editChalkImagebox()"><i class="iconfont iconbianji"></i>{{\'editorCommon.editCurrentWhiteInk\' | translate}}</div><div style="color: #999999">{{\'editorCommon.whiteInkMultiImageTip\' | translate}}</div></div></div><div class="c-editorPhoto1-foot1-2-white" ng-if="!vm.singleData || !vm.singleData[vm.singleIndex] || !vm.singleData[vm.singleIndex].levels.level || !vm.singleData[vm.singleIndex].levels.level[vm.levelIndex] || !vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox || !vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.image">{{\'editorCommon.selectImageToViewWhiteInk\' | translate}}</div></div><div class="c-editorPhoto1-foot1-2" ng-if="vm.operationTab == \'uv\' || vm.operationTab == \'fluore\'" style="padding: 0 16px; justify-content: flex-start; gap: 8px;overflow: auto"><div ng-repeat="item in vm.propertyValue[vm.operationTab] track by $index"><div class="c-editorPhoto1-foot1-2-white-1 custom-grid2" ng-if="getImageart(vm.singleData[vm.singleIndex],vm.operationTab, item)" style="overflow: hidden" ng-click="editChalkImagebox(vm.operationTab, item)"><div class="gold-foil-text" ng-style="{\n                            \'width\': getImageartSize(\'width\',item),\n                            \'height\': getImageartSize(\'height\',item),\n                            \'background\': goldFoil(getImageart(vm.singleData[vm.singleIndex],vm.operationTab,item).spotColor.color),\n                            \'-webkit-mask-image\': \'url(\' + getImageart(vm.singleData[vm.singleIndex],vm.operationTab, item).resource.identifier + \')\',\n                            \'-webkit-mask-size\': \'100% 100%\'\n                            }"><img ng-src="{{getImageart(vm.singleData[vm.singleIndex],vm.operationTab, item).resource.identifier | imageFilter}}" style="width: 100%; height: 100%;opacity:0"></div></div><div class="c-btn c-btn1" ng-if="!getImageart(vm.singleData[vm.singleIndex],vm.operationTab,item)" ng-click="editChalkImagebox(vm.operationTab, item)">{{\'editorBtn.edit\' | translate}}{{item.operationValueAlias}}</div></div></div></div><classify-ec ng-if="(vm.operationTab == \'picture\' || vm.operationTab == \'TECHNIQUE\') && vm.isClassify" property-value="vm.chalkPropertyValue" :cliparts="template.cliparts" :type="vm.operationTab" :domain="domain" :page="vm.singleData[vm.singleIndex]" on-save="addMaterial(text)" on-close="closeMaterial()"></classify-ec><textbox-ec ng-if="vm.operationTab == \'picture\'" :font-list="vm.fontList" :type="vm.textboxType" :page-data="vm.singleData" :page-index="vm.singleIndex" :level-index="vm.levelIndex" :textbox-select="vm.textboxSelect" on-add="textboxAdd(text)" on-edit="textboxEdit(text)" on-delete="textboxDelete()"></textbox-ec><div class="c-editorPhoto3-foot" style="height: 88px" ng-if="vm.operationTab == \'picture\' && vm.singleData[vm.singleIndex].levels.level[vm.levelIndex] && vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox"><div class="icon-btn" ng-class="{\'editor-dialog-btn-disabled\':!vm.singleData[vm.singleIndex].levels.level[vm.levelIndex]}" ng-click="rotateImagebox()"><img src="content/images/icon/rotate-icon.png" alt=""> <span>{{\'editorBtn.rotationText\' | translate}}</span></div><div class="icon-btn" ng-class="{\'editor-dialog-btn-disabled\':!vm.singleData[vm.singleIndex].levels.level[vm.levelIndex] || vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.bokehtype != \'None\'}" ng-click="imageboxSite(\'center\')"><img src="content/images/icon/center-icon.png" alt=""> <span>{{\'font.alignCenter\' | translate}}</span></div><div class="icon-btn" ng-class="{\'editor-dialog-btn-disabled\':!vm.singleData[vm.singleIndex].levels.level[vm.levelIndex]}" ng-if="vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.bokehtype == \'None\'" ng-click="fillImagebox()"><img src="content/images/icon/reduce-icon.png" alt=""> <span>{{\'editorBtn.retractText\' | translate}}</span></div><div class="icon-btn" ng-class="{\'editor-dialog-btn-disabled\':!vm.singleData[vm.singleIndex].levels.level[vm.levelIndex]}" ng-if="vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.bokehtype != \'None\'" ng-click="cutImagebox()"><img src="content/images/icon/unfold-icon.png" alt=""> <span>{{\'editorBtn.spreadText\' | translate}}</span></div><div class="icon-btn" ng-click="imageboxFlip()"><i class="icon iconfont iconjingxiang2" style="color: #333"></i> <span>\u955C\u50CF</span></div><div class="icon-btn" ng-click="photoGalleryShow()" ng-class="{\'editor-dialog-btn-disabled\':!vm.singleData[vm.singleIndex].levels.level[vm.levelIndex]}" ng-if="vm.article.editorType == \'PICTURE_PRO\' || vm.article.editorType == \'PICTURE_PRO_P\'"><i class="icon iconfont icontupianshape" style="color: #000"></i> <span>{{\'editorBtn.imgText\' | translate}}</span></div><div class="icon-btn" ng-click="photoGalleryShow(true)" ng-class="{\'editor-dialog-btn-disabled\':!vm.singleData[vm.singleIndex].levels.level[vm.levelIndex]}" ng-if="vm.article.editorType == \'PICTURE_PRO\' || vm.article.editorType == \'PICTURE_PRO_P\'"><i class="icon iconfont iconcamera" style="color: #000"></i> <span>{{\'editorCommon.recommend1\' | translate}}</span></div><div class="icon-btn" ng-click="mattingOpen()" ng-class="{\'editor-dialog-btn-disabled\':!vm.singleData[vm.singleIndex].levels.level[vm.levelIndex]}" ng-if="(vm.article.editorType == \'PICTURE_PRO\' || vm.article.editorType == \'PICTURE_PRO_P\') && !isLarge(vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.image.imageInfo)"><i class="icon iconfont iconkoutu" style="color: #000"></i> <span>{{vm.singleData[vm.singleIndex].levels.level[vm.levelIndex].imagebox.image.mattingMask ? \'editorCommon.mattingOpenEdit\' : \'editorCommon.mattingOpen\' | translate}}</span></div></div></div><div class="three-modal2" ng-if="vm.threeError"><div class="three-modal2-body"><!--            <i class="icon iconfont iconkulian"></i>--><div>{{vm.threeErrorText}}</div></div></div><div class="three-modal" ng-if="vm.isTemplate"><div class="three-modal-body"><div class="three-modal-body-content" style="flex-direction: column"><div style="">{{\'editorCommon.describe9\' | translate}}</div><div style="">{{\'editorCommon.describe10\' | translate}}</div><i class="iconfont iconcuo" style="position: absolute; right: 10px; top: 10px" ng-click="vm.isTemplate=false"></i></div><div class="three-modal-body-foot"><button type="button" style="border-right:1px solid #ddd" class="color1" ng-click="vm.isTemplate=false">{{\'button.cancel\' | translate}}</button> <button type="button" class="color2" ng-click="templateReplace()">{{\'button.confirm\' | translate}}</button></div></div></div><div class="three-modal" ng-if="vm.threeIsModal1"><div class="three-modal-body"><div class="three-modal-body-content">{{vm.threeModalText1}}</div><div class="three-modal-body-foot"><button type="button" class="color2" ng-click="threeModalHide()">{{vm.threeModalText1 == vm.backPhotoNotFilledMsg ? \'editorCommon.iSee\' : \'editorBtn.confirm\' | translate}}</button></div></div></div><div class="editor-body-copy-view1" ng-if="vm.isCopyBack"><div style="color: var(--genericColor); background: #fff" ng-click="copyAll()">{{\'editorCommon.copyAll\' | translate}}</div><div style="margin-left: 26px" ng-click="copyHide()">{{\'editorCommon.copyComplete\' | translate}}</div></div></div><!-- \u62A0\u56FE --><image-cutout ng-if="vm.isShowImageCutout" :imagebox="vm.imageboxCutout" on-save="imageCutoutSave(text)" on-change="imageCutoutChange(text)"></image-cutout><!--  \u5F00\u59CB\u5B9A\u5236\u52A0\u8F7D\u9875  --><div class="page-loading" ng-show="vm.loading"><img src="content/images/loading2.gif" onerror="this.src=\'content/images/loading2.gif\'"><p class="tip-style">{{\'editorCommon.loadingText\' | translate}}</p><span class="tip-style">{{\'editorCommon.loadingText1\' | translate}}</span></div><div class="page-loading" ng-show="vm.imageboxLoad"><img src="content/images/loading2.gif" onerror="this.src=\'content/images/loading2.gif\'"><p class="tip-style">{{\'editorCommon.loadingText\' | translate}}</p></div><div class="three-modal1" ng-if="vm.threeLoading"><img src="content/images/loading2.gif" alt=""><div>{{vm.threeLoadingText}}</div></div><!--\u5220\u9664\u5904\u7406\u5931\u8D25\u7684\u7167\u7247--><div class="three-modal" ng-if="vm.deletePhotoSure"><div class="three-modal-body"><div class="three-modal-body-content" style="flex-direction: column; height: auto; padding: 24px 20px"><div style="font-size: 15px; font-weight: bold; color: #333; margin-bottom: 10px">{{\'nav.photograph.content.deletePhoto.title\' | translate}}</div><div style="font-size: 14px; color: #666; text-align: center">{{\'nav.photograph.content.deletePhoto.content\' | translate}}</div></div><div class="three-modal-body-foot"><button type="button" class="color1" ng-click="vm.deletePhotoSure = false">{{\'button.cancel\' | translate}}</button> <button type="button" class="color2" ng-click="deletePhotoConfirm()">{{\'button.confirm\' | translate}}</button></div></div></div><!--\u7F29\u7565\u56FE\u5355\u9762--><div id="thumbnail-view1" ng-if="vm.pictureType == \'single\'" style="position: absolute;left: 0;top: 0; z-index: -1; overflow: hidden"><page-preview page="vm.data[0]" scale="vm.data[0].custom.thumbnailScale" editor-type="vm.article.editorType" ng-if="vm.data[0]" thumbnail="true"></page-preview></div><!--\u7F29\u7565\u56FE\u53CC\u9762--><div id="thumbnail-view1" ng-if="vm.pictureType == \'spread\'" style="position: absolute;left: 0;top: 0; z-index: -1; overflow: hidden"><page-preview page="vm.data[0][0]" scale="vm.data[0][0].custom.thumbnailScale" editor-type="vm.article.editorType" thumbnail="true" ng-if="vm.data[0][0]"></page-preview></div><!-- \u56FE\u7247\u5E93 --><div class="three-photoGallery" ng-show="vm.mapDepot" ng-style="{\'padding-bottom\': vm.isIPhoneX ? \'30px\' : \'0\'}"><!--    <div class="three-photoGallery-head1">--><!--        <span ng-class="{\'three-photoGallery-head1-span-on\' : vm.mapDepot1}" ng-click="vm.mapDepot1=true; vm.mapDepot2=false;">{{\'editorBtn.selectedImages\' | translate}}</span>--><!--        <span ng-class="{\'three-photoGallery-head1-span-on\' : vm.mapDepot2}" ng-click="vm.mapDepot2=true; vm.mapDepot1=false;">{{\'editorBtn.dcim\' | translate}}</span>--><!--        <i class="icon iconfont iconlujing8" ng-click="photoGalleryHide()"></i>--><!--        <div style=" position: absolute; bottom: 0; height: 20px; line-height: 20px; color: var(&#45;&#45;genericColor); padding-left: 15px; font-size: 12px;">{{\'picture.sentPictures1\' | translate}}</div>--><!--    </div>--><div class="three-photoGallery-head" ng-if="vm.mapDepot && !vm.isRecommend"><p style="margin: 0">{{vm.isRecommend ? \'editorCommon.recommend1\' : \'picture.sentPictures\' | translate}} <span style="color: var(--genericColor); font-size: 12px">{{\'picture.sentPictures1\' | translate}}</span></p><i class="icon iconfont iconlujing8" ng-click="photoGalleryHide()"></i></div><div class="three-materialGallery-head" ng-if="vm.mapDepot && vm.isRecommend"><ul class="three-materialGallery-head-ul"><li ng-repeat="item in vm.recommendClassify" ng-click="vm.recommendClassifyItem = item" ng-class="{\'opt\' : item.id == vm.recommendClassifyItem.id}"><span>{{item.name}}</span></li></ul><i class="icon iconfont iconlujing8" ng-click="photoGalleryHide()"></i></div><div class="three-photoGallery-body" id="photoGallery" ng-show="vm.mapDepot2" ng-style="{\n                    \'overflow\': vm.isSmallPic ? \'hidden\' : \'scroll\'\n                 }"><ul class="clearfix" ng-if="!vm.isRecommend"><li style="background: #ddd"><div ng-click="uploadPhoto()"><i class="icon iconfont iconcamera" style="color: #fff"></i></div></li><li ng-repeat="data in vm.uploadPhotoItem" ng-if="data.percent != 100 && data.state != \'error\'" style="position: relative"><progres-view :src="data.blobCover" :progres="data.percent"></progres-view></li><li ng-repeat="item in vm.photoAll track by $index" data-imgindex="{{$index}}" ontouchstart="startChange(event)" ontouchmove="dragChange(event)" ontouchend="stopChange(event)" ng-click="addImageboxImg(item)"><img ng-if="(item.identifier || (item.largeFlag && item.identifier1)) && photoStatus(item) == \'\'" ng-src="{{(item.largeFlag ? item.identifier1 : item.identifier)+\'?imageView2/1/w/100/h/75\'}}" alt="{{item.largeError}}" data-imgindex="{{$index}}" style="width: 100%; height: 100%"><div class="editor-photoBoth-status" ng-if="(item.identifier || (item.largeFlag && item.identifier1)) && photoStatus(item) != \'\'" ng-class="{\'is-failed\': isPhotoFailed(item)}" ontouchstart="event.stopPropagation()" ng-click="onPhotoStatusClick(item, $event)"><img class="editor-photoBoth-status-placeholder" src="content/images/placeholderImage.png" alt=""><div class="editor-photoBoth-status-mask"><img class="editor-photoBoth-status-icon" ng-if="photoStatus(item) == \'largeError\' || photoStatus(item) == \'convertError\'" src="content/images/close1.png" alt=""> <img class="editor-photoBoth-status-icon" ng-if="photoStatus(item) == \'convertRunning\' || photoStatus(item) == \'largeRunning\'" src="content/images/loading1.png" alt=""> <span class="editor-photoBoth-status-text">{{(\'nav.photograph.content.status.\' + photoStatus(item)) | translate}}</span></div></div><div style="position: absolute; left: 0; top: 0; width: 100%; height: 100%; z-index: 1" data-imgindex="{{$index}}"></div><div class="photoCount" ng-if="item.frequency>0">{{item.frequency}}</div></li></ul><ul class="clearfix" ng-if="vm.isRecommend"><li ng-repeat="item in vm.recommendPics track by $index" ng-show="!vm.recommendClassifyItem || vm.recommendClassifyItem.id == item.themeClassifyId" data-imgindex="{{$index}}" ontouchstart="startChange(event)" ontouchmove="dragChange(event)" ontouchend="stopChange(event)" ng-click="addImageboxImg(item)"><img ng-if="item.identifier" ng-src="{{item.identifier+\'?imageView2/1/w/100/h/75\'}}" alt="" data-imgindex="{{$index}}" style="width: 100%; height: 100%"></li></ul><div class="animation-xia" ng-if="vm.photoAll.length>8"><i class="icon iconfont iconxiangxia2"></i></div></div><div class="three-photoGallery-body" ng-show="vm.mapDepot1" ng-style="{\n                    \'overflow\': vm.isSmallPic ? \'hidden\' : \'scroll\'\n                 }"><ul class="clearfix"><li style="background: #ddd"><div ng-click="uploadPhoto()"><i class="icon iconfont iconcamera" style="color: #fff"></i> <input onchange="uploadImageMutiple(event)" type="file" multiple="multiple" accept="{{vm.supportedMimeTypes}}" name="file" ng-if="!agentIos" class="input-upload2"></div></li><li ng-repeat="data in vm.uploadPhotoItem" ng-if="data.percent != 100 && data.state != \'error\'" style="position: relative"><progres-view :src="data.blobCover" :progres="data.percent"></progres-view></li><li ng-repeat="item in vm.photoSelectAll1" data-imgindex="{{$index}}" ontouchstart="startChange(event)" ontouchmove="dragChange(event)" ontouchend="stopChange(event)" ng-click="addImageboxImg(item)"><img ng-if="item.identifier && photoStatus(item) == \'\'" ng-src="{{(item.largeFlag ? item.identifier1 : item.identifier)+\'?imageView2/1/w/100/h/75\'}}" alt="" data-imgindex="{{$index}}" style="width: 100%; height: 100%"><div class="editor-photoBoth-status" ng-if="item.identifier && photoStatus(item) != \'\'" ng-class="{\'is-failed\': isPhotoFailed(item)}" ontouchstart="event.stopPropagation()" ng-click="onPhotoStatusClick(item, $event)"><img class="editor-photoBoth-status-placeholder" src="content/images/placeholderImage.png" alt=""><div class="editor-photoBoth-status-mask"><img class="editor-photoBoth-status-icon" ng-if="photoStatus(item) == \'largeError\' || photoStatus(item) == \'convertError\'" src="content/images/close1.png" alt=""> <img class="editor-photoBoth-status-icon" ng-if="photoStatus(item) == \'convertRunning\' || photoStatus(item) == \'largeRunning\'" src="content/images/loading1.png" alt=""> <span class="editor-photoBoth-status-text">{{(\'nav.photograph.content.status.\' + photoStatus(item)) | translate}}</span></div></div><div style="position: absolute; left: 0; top: 0; width: 100%; height: 100%; z-index: 1" data-imgindex="{{$index}}"></div><div class="photoCount" ng-if="item.frequency>0">{{item.frequency}}</div></li></ul><div class="animation-xia" ng-if="vm.photoSelectAll.length>8"><i class="icon iconfont iconxiangxia2"></i></div></div></div><div id="small-pic" class="user-select-default pointer-un" ontouchstart="return false;" ng-style="{left:galleryX||0,top:galleryY||0}" ng-show="vm.isSmallPic"><img ng-if="galleryChoose" ng-src="{{galleryChoose+\'?imageView2/1/w/105/h/80\'}}"></div><!-- \u5E03\u5C40\u5E93 --><div class="three-photoGallery" ng-if="vm.isLayout" ng-style="{\'padding-bottom\': vm.isIPhoneX ? \'30px\' : \'0\'}"><div class="three-photoGallery-head"><p style="margin: 0">{{\'editorCommon.allLayout\' | translate}}</p><i class="icon iconfont iconlujing8" ng-click="photoGalleryHide()"></i></div><div class="three-photoGallery-body"><ul class="clearfix"><li ng-repeat="backupPage in template.backupPages.list" ng-click="layoutCb(backupPage)" ng-if="backupPage.config.partid === vm.singleData[vm.singleIndex].config.partid"><img ng-src="{{backupPage.pagecover.identifier+\'?imageView2/1/w/100\'}}" alt=""></li></ul></div></div><div class="lang-ic" ng-show="vm.lagnuages.length>1&&!vm.hide" style="bottom: 120px"><img src="content/images/lagnuage.svg" ng-click="vm.language=true"><div class="lang-ic-content" ng-click="vm.hide=true"><i class="iconfont iconjian2"></i></div></div><language is-show="vm.language" ng-if="vm.language"></language><upload-image ng-if="!vm.page2" store-id="vm.storeId" aid="vm.aid" upload-photo-item="vm.uploadPhotoItem" photos="vm.photoArray" photo-all="vm.photoSelectAll" folder-one="vm.folderOne" on-uploadphoto="uploadPhotoCb(text)" data-html2canvas-ignore></upload-image><!--\u91CD\u590D\u56FE\u7247--><duplicate-list ng-if="vm.isDuplicateList" list="vm.duplicateList" on-change="duplicateChange(text)"></duplicate-list><!--\u4E0A\u4F20\u5F39\u6846--><editor-photo-upload-popup :product="vm.product" ng-if="vm.isEditorPhotoUploadPopup" on-change="editorPhotoUploadPopupChange()"></editor-photo-upload-popup><!-- \u767D\u58A8\u3001uv\u3001\u8367\u5149\u5C42\u7F16\u8F91 --><chalk-view width="vm.chalkWidth" height="vm.chalkHeight" imagebox="vm.chalkImagebox" type="vm.operationTab" imageart="vm.chalkImageart" property-value="vm.chalkPropertyValue" on-change="chalkChange(text)" ng-if="vm.chalkImagebox || vm.chalkImageart"></chalk-view><outline-view ng-if="vm.isOutline" page="vm.singleData[vm.singleIndex]" property-value="vm.propertyValue.outline[0]" picture-type="vm.product.pictureType" contour-width="vm.product.contourWidth" on-change="outlineChange(text)"></outline-view><style>body{\n        overflow: unset !important;\n    }\n    /* \u5927\u56FE\u5904\u7406\u4E2D/\u5931\u8D25\u3001\u8272\u5F69\u8F6C\u6362\u4E2D/\u5931\u8D25\uFF1A\u5360\u4F4D\u56FE + \u5C45\u4E2D\u72B6\u6001\u56FE\u6807\u4E0E\u6587\u6848 */\n    .editor-photoBoth-status{\n        position: absolute;\n        left: 0;\n        top: 0;\n        z-index: 2;\n        width: 100%;\n        height: 100%;\n        overflow: hidden;\n    }\n    .editor-photoBoth-status-placeholder{\n        position: absolute;\n        left: 0;\n        top: 0;\n        z-index: 1;\n        display: block;\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n    }\n    .editor-photoBoth-status-mask{\n        position: absolute;\n        left: 0;\n        top: 0;\n        z-index: 2;\n        display: flex;\n        box-sizing: border-box;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        width: 100%;\n        height: 100%;\n        padding: 4px;\n        background-color: rgba(0, 0, 0, 0.25);\n    }\n    .editor-photoBoth-status-icon{\n        display: block;\n        flex: none;\n        width: 20px;\n        height: 20px;\n        margin-bottom: 4px;\n        object-fit: contain;\n    }\n    .editor-photoBoth-status-text{\n        max-width: 100%;\n        color: #ffffff;\n        font-size: 11px;\n        line-height: 14px;\n        text-align: center;\n        word-break: break-all;\n        text-shadow: 0 1px 4px rgba(0,0,0,0.6);\n    }\n    .editor-photoBoth-status.is-failed{\n        cursor: pointer;\n    }</style>');
$templateCache.put('app/entities/product-ec/editor-photo-preview.html','<div class="c-window" ng-show="!musicPage"><div class="c-productThree1"><div class="back-to-customer" ng-style="{width:dWidth}"><span class="arrowPrev arrow-prev opacityMinus" ng-click="goToCustomer()" ng-if="vm.returnurl1"></span><audio id="audio" controls="controls" autoplay preload hidden>{{\'editorCommon.nonsupportMusic\' | translate}}</audio><span class="PanelRight" ng-show="!vm.isHideMusicBtn &&  Musics && Musics.length > 0"><span id="Play" class="Play"><img class="icon pause" src="content/images/icons/ic_music2.svg" id="music-icon"></span></span></div><div class="infoWaring flex-btn-group-container tip-image" style="background: #f6f7f9;padding: 0 10px;font-size: 12px;z-index:400; width: 100%" ng-if="vm.message.length"><img src="content/images/icons/notice.svg" alt="" style="width:24px;height:24px;margin-right:5px;margin-top: 4px"><marquee scrollamount="2" height="30" behavior="scroll" direction="left" align="left" style="width: 100%;line-height: 30px">{{vm.messageText}}</marquee></div><div class="c-editorPhoto1-head" style="padding: 80px 0 0; position: relative;z-index: 1"><editor-photo-preview preview-article="vm.previewArticle" article="vm.article" ng-if="vm.previewArticle"></editor-photo-preview><button class="btn"></button></div><div class="c-editorPhoto1-foot" ng-style="{\'padding-bottom\': vm.isIPhoneX ? \'30px\' : \'0\', \'height\' : vm.isIPhoneX ? \'auto\' : \'60px\'}"><div class="c-editorPhoto1-foot-btn1"><div class="btn1" style="color: var(--mobileTextSelectedColor)" ng-click="editorPhoto()" ng-if="vm.returnurl"><i class="icon iconfont iconbianji"></i> <span style="font-size: 11px; color: #717171">{{\'button.edit\' | translate}}</span></div><div class="btn1" style="color: var(--mobileTextSelectedColor)" ng-click="openMusicList()" ng-if="Musics && Musics.length > 0"><i class="icon iconfont iconyinlemusic215"></i> <span style="font-size: 11px; color: #717171">{{\'editorCommon.chooseMusic\' | translate}}</span></div></div><div class="btn-order" ng-class="{\'btn-save-select\' : vm.photoSelectAll.length>0}" ng-click="save()" style="background-color: var(--mobileButtonBackColor)" ng-if="(vm.article.articleId || vm.article.articleStatus==\'COMPLETED\')&&vm.returnurl2">{{vm.returnurl2Text}}</div></div></div></div><div ng-show="musicPage && Musics && Musics.length > 0"><div class="top-menu" style="box-shadow: 0 2px 5px rgba(187, 187, 187, 0.6)"><div class="index-back"><span class="opacityMinus" ng-click="backTo()"><div class="tabIcons back-work"></div></span></div><div class="floatRight commit-div edit-save" ng-click="saveMusic()">{{\'button.confirm\' | translate}}</div></div><audio id="audition" autoplay></audio><ul class="music-list"><li ng-repeat="music in Musics track by $index" ng-click="playList(music.identify,$index)" class="music-li" ng-class="{\'music-li-select\' : vm.musicIdentify == music.identify}"><div class="music-name">{{music.name}}</div><img src="content/images/icons/music-i.svg" class="music-icon{{$index}} music-icon" style="top: 20px"> <span class="music-current">{{\'editorCommon.currentMusic\' | translate}}</span></li></ul></div><img ng-src="{{vm.toneSettings.previewBkMobile}}" class="bg-fixed" alt="" ng-if="vm.toneSettings.previewBkMobile"><style>body{\n        overflow: unset !important;\n    }\n    .c-page-view-li-item{\n        overflow: hidden;\n    }</style>');
$templateCache.put('app/entities/product-ec/editor-photo-share.html','<div class="c-window" ng-show="!musicPage"><div class="c-productThree1"><div class="back-to-customer" ng-style="{width:dWidth}" style="background: none"><!--            <span class="arrowPrev arrow-prev opacityMinus" ng-click="goToCustomer()" ng-if="vm.returnurl1"></span>--><audio id="audio" controls="controls" autoplay preload hidden>{{\'editorCommon.nonsupportMusic\' | translate}}</audio><span class="PanelRight" ng-show="!vm.isHideMusicBtn &&  Musics && Musics.length > 0"><span id="Play" class="Play"><img class="icon pause" src="content/images/icons/ic_music2.svg" id="music-icon"></span></span></div><!--        <div class="infoWaring flex-btn-group-container tip-image"--><!--             style="background: #f6f7f9;padding: 0 10px;font-size: 12px;z-index:400; width: 100%;"--><!--             ng-if="vm.message.length">--><!--            <img src="content/images/icons/notice.svg" alt=""--><!--                 style="width:24px;height:24px;margin-right:5px;margin-top: 4px;"/>--><!--            <marquee scrollAmount=2 height=30 behavior="scroll" direction="left" align="left"--><!--                     style="width: 100%;line-height: 30px;">--><!--                {{vm.messageText}}--><!--            </marquee>--><!--        </div>--><div class="c-editorPhoto1-head" style="padding: 80px 0 10px"><editor-photo-preview preview-article="vm.previewArticle" article="vm.article" ng-if="vm.previewArticle"></editor-photo-preview></div></div></div><img ng-src="{{vm.toneSettings.previewBkMobile}}" class="bg-fixed" alt="" ng-if="vm.toneSettings.previewBkMobile"><div class="c-aid-view">\u4F5C\u54C1ID\uFF1A{{vm.aid}}</div><style>body{\n        overflow: unset !important;\n    }\n    .c-page-view-li-item{\n        overflow: hidden;\n    }</style>');
$templateCache.put('app/entities/product-ec/editor-photo-upload-popup.html','<div class="pop-up-upload" ng-click="popupSave()"></div><div class="pop-up-upload-body"><div class="pop-up-upload-body-1"><img ng-src="{{product.editTipPic}}" style="width: 100%"></div><div class="pop-up-upload-body-btn" ng-click="popupSave()">\u6211\u5DF2\u4E86\u89E3</div></div><style>.pop-up-upload{\n        position: fixed;\n        left: 0;\n        top: 0;\n        width: 100vw;\n        height: 100vh;\n        background: rgba(0,0,0,0.3);\n        z-index: 3000;\n    }\n    .pop-up-upload-body{\n        position: fixed;\n        left: 0;\n        bottom: 0;\n        width: 100vw;\n        background: #fff;\n        padding: 12px;\n        border-radius: 12px 12px 0 0;\n        z-index: 3001;\n    }\n    .pop-up-upload-body-1{\n        width: 100%;\n        max-height: 500px;\n        overflow: auto;\n    }\n    .pop-up-upload-body-btn{\n        height: 35px;\n        line-height: 35px;\n        border-radius: 20px;\n        background: var(--genericColor);\n        color: #fff;\n        text-align: center;\n        margin-top: 12px;\n    }</style>');
$templateCache.put('app/entities/product-ec/editor-photoAlbum.html','<div class="editor-window" data-html2canvas-ignore><input onchange="uploadImageMutiple(event)" type="file" multiple="multiple" accept="{{vm.supportedMimeTypes}}" name="file" ng-if="!agentIos && !vm.isIPhone6" class="input-upload1" id="uploadImagePhotobook"><div class="editor-photoAlbum-page1" ng-show="vm.page0"><h1 class="editor-photoAlbum-page1-h1" ng-if="!vm.isEdit && vm.product.aiFill">{{\'editorCommon.imageNum\' | translate:({counts:(vm.productXmlLine.minPicQuantity + (vm.productXmlLine.maxPicQuantity > vm.productXmlLine.minPicQuantity ? \'~\' + vm.productXmlLine.maxPicQuantity : \'\'))})}}</h1><h1 class="editor-photoAlbum-page1-h1" ng-if="vm.isEdit || !vm.product.aiFill">{{\'editorCommon.imageNum\' | translate:({counts:vm.counts})}}</h1><p class="editor-photoAlbum-page1-p">{{\'editorCommon.describe\' | translate}}</p><div class="editor-photoAlbum-page1-btn-view"><!--            <button class="editor-photoAlbum-btn editor-photoAlbum-btn-hollow" ng-click="showGallery()"><i class="icon iconfont icontupianshape"></i> {{\'editorBtn.showGallery\' | translate}}</button>--> <button class="editor-photoAlbum-btn editor-photoAlbum-btn-solid" ng-click="page0Upload()"><i class="icon iconfont iconUpload"></i> {{\'editorBtn.uploadGallery\' | translate}} <input onchange="uploadImageMutiple(event)" type="file" multiple="multiple" accept="{{vm.supportedMimeTypes}}" name="file" ng-if="!agentIos && vm.isIPhone6" class="input-upload2"></button></div><span class="uploadNeedKnow" ng-click="uploadNeedKnowClick()"><i class="icon iconfont iconhelp"></i> {{\'editorBtn.uploadBefore\' | translate}}</span></div><!--  page2  --><div class="editor-photoAlbum-page1" ng-show="vm.page1" style="padding: 0"><div class="editor-photoAlbum-title"><span class="editor-photoAlbum-title-fl" ng-if="!vm.isEdit && vm.product.aiFill">{{\'editorCommon.describe30\' | translate:({counts:(vm.productXmlLine.minPicQuantity + (vm.productXmlLine.maxPicQuantity > vm.productXmlLine.minPicQuantity ? \'~\' + vm.productXmlLine.maxPicQuantity : \'\'))})}}</span> <span class="editor-photoAlbum-title-fl" ng-if="vm.isEdit || !vm.product.aiFill">{{\'editorCommon.describe30\' | translate:({counts:vm.counts})}}</span> <span class="editor-photoAlbum-title-hint" ng-if="vm.photoSelectAll.length > 0">{{\'editorCommon.describe31\' | translate}}</span> <span class="editor-photoAlbum-title-fr" ng-click="photoReverse()" ng-show="!vm.draggable"><i class="iconfont iconpaixu"></i> {{\'editorBtn.invertedOrder\' | translate}}</span> <span class="editor-photoAlbum-title-fr" ng-click="completeSort()" ng-show="vm.draggable">{{\'editorBtn.completeSort\' | translate}}</span></div><div class="c-productThree1-body" style="top: 40px; bottom: 80px" ng-style="{\'bottom\':vm.draggable?\'0px\':\'80px\'}"><div class="c-productThree1-body-no" ng-if="vm.photoSelectAll.length == 0"><!-- <span class="c-productThree1-body-no-img"></span> --> <img src="content/images/worksNull.png" alt="" srcset="" style="width:50%;margin-top: 20vh"> <span class="c-productThree1-body-no-text">{{\'editorCommon.describe2\' | translate}}</span></div><div class="c-productThree1-body-y" ng-show="vm.photoSelectAll.length > 0" style="margin-top: -10px"><ul class="clearfix" id="photoAllId"><li class="page1Img-li" ng-repeat="item in vm.photoSelectAll track by $index" style="position: relative"><div class="c-productThree1-body-y-li sortingPageView" data-page="{{item}}"><div><img ng-if="(item.identifier || (item.largeFlag && item.identifier1)) && photoStatus(item) == \'\'" ng-src="{{(item.largeFlag ? item.identifier1 : item.identifier)+\'?imageView2/1/w/102/h/115\'}}" alt="{{item.largeError}}" class="c-productThree1-body-y-img" style="pointer-events:none"><div class="editor-photoAlbum-status" ng-if="(item.identifier || (item.largeFlag && item.identifier1)) && photoStatus(item) != \'\'" ng-class="{\'is-failed\': isPhotoFailed(item)}" ng-click="onPhotoStatusClick(item, $event)"><img class="editor-photoAlbum-status-placeholder" src="content/images/placeholderImage.png" alt=""><div class="editor-photoAlbum-status-mask"><img class="editor-photoAlbum-status-icon" ng-if="photoStatus(item) == \'largeError\' || photoStatus(item) == \'convertError\'" src="content/images/close1.png" alt=""> <img class="editor-photoAlbum-status-icon" ng-if="photoStatus(item) == \'convertRunning\' || photoStatus(item) == \'largeRunning\'" src="content/images/loading1.png" alt=""> <span class="editor-photoAlbum-status-text">{{(\'nav.photograph.content.status.\' + photoStatus(item)) | translate}}</span></div></div><div class="c-imagebox-warn" ng-if="item.imgSize / 1024 < 150" style="width: 85px"><i class="icon iconfont iconwaring imageboxWarn"></i> <span>{{\'editorCommon.lackPixels\' | translate}}</span></div><span class="photoSelectAll-number">{{$index+1}}</span></div></div><div class="c-productThree1-body-y-x" ng-click="deletePhotoSelect($event,$index, item)" ng-show="!vm.draggable"><i class="icon iconfont iconguanbi1"></i></div></li><li class="page1Img-li" ng-repeat="data in vm.uploadPhotoItem" ng-if="data.percent != 100 && !data.state" style="position: relative"><div class="c-productThree1-body-y-li sortingPageView" data-page="{{item}}"><div><progres-view :src="data.blobCover" :progres="data.percent"></progres-view></div></div></li></ul></div></div><div class="editor-photoAlbum-page1-foot" style="height: 80px" ng-show="!vm.draggable"><div class="editor-photoAlbum-page1-foot-fl"><div class="editor-photoAlbum-page1-foot-btn" ng-click="uploadPhoto()"><i class="icon iconfont iconUpload"></i> <span>{{\'editorBtn.uploadGallery\' | translate}}</span> <input onchange="uploadImageMutiple(event)" type="file" multiple="multiple" accept="{{vm.supportedMimeTypes}}" name="file" ng-if="!agentIos && vm.isIPhone6" class="input-upload2"></div><div class="editor-photoAlbum-page1-foot-btn" ng-click="showGallery()"><i class="icon iconfont icontupianshape"></i> <span>{{\'editorBtn.dcim\' | translate}}</span></div><div class="editor-photoAlbum-page1-foot-btn" ng-click="book(true)"><i class="icon iconfont iconbianji2"></i> <span>{{\'editorCommon.onePageEditing\' | translate}}</span></div></div><div class="editor-photoAlbum-page1-foot-fr"><button type="button" ng-click="book()" ng-if="!vm.product.aiFill || vm.photoSelectAll.length>=vm.productXmlLine.minPicQuantity">{{\'editorBtn.aBook\' | translate}}\uFF08{{vm.photoSelectAll.length}}\uFF09</button> <button class="notEditable" ng-click="book()" type="button" ng-if="vm.product.aiFill && vm.photoSelectAll.length<vm.productXmlLine.minPicQuantity">{{\'editorBtn.aBook\' | translate}}\uFF08{{vm.photoSelectAll.length}}\uFF09</button></div></div></div><!-- \u5168\u5C4F\u9009\u56FE --><div class="three-photoGallery-head1" ng-if="vm.fullMap" style="position: fixed; left: 0; top: 0; z-index: 10; background: #fff"><span style="position: absolute; left: 8px; top: 0; font-size: 12px; color: #999" ng-click="fullMapHide()">{{\'button.back\' | translate}}</span> <span ng-class="{\'three-photoGallery-head1-span-on\' : vm.fullMap1}" ng-click="fullMapCb1()">{{\'editorBtn.selectedImages\' | translate}}</span> <span ng-class="{\'three-photoGallery-head1-span-on\' : vm.fullMap2}" ng-click="fullMapCb2()">{{\'editorBtn.dcim\' | translate}}</span></div><div class="three-photoGallery-body" style="height: 100vh" ng-show="vm.fullMap1"><ul class="clearfix" style="padding: 48px 0 90px"><li style="background: #ddd"><div ng-click="uploadPhoto()"><i class="icon iconfont iconcamera" style="color: #fff"></i> <input onchange="uploadImageMutiple(event)" type="file" multiple="multiple" accept="image/png, image/jpeg, image/jpg" name="file" ng-if="!agentIos && vm.isIPhone6" class="input-upload2"></div></li><li ng-repeat="item in vm.photoSelectAll2 track by item.id" ng-click="photoOneCb(item)"><img ng-if="item.blobCover" ng-src="{{item.blobCover}}" alt="" class="c-productThree2-head3-li-body-img"> <img ng-if="!item.blobCover && (item.identifier || (item.largeFlag && item.identifier1)) && photoStatus(item) == \'\'" ng-src="{{(item.largeFlag ? item.identifier1 : item.identifier)+\'?imageView2/1/w/100/h/75\'}}" alt="{{item.largeError}}" style="width: 100%; height: 100%"><div class="editor-photoAlbum-status" ng-if="!item.blobCover && (item.identifier || (item.largeFlag && item.identifier1)) && photoStatus(item) != \'\'" ng-class="{\'is-failed\': isPhotoFailed(item)}" ng-click="onPhotoStatusClick(item, $event)"><img class="editor-photoAlbum-status-placeholder" src="content/images/placeholderImage.png" alt=""><div class="editor-photoAlbum-status-mask"><img class="editor-photoAlbum-status-icon" ng-if="photoStatus(item) == \'largeError\' || photoStatus(item) == \'convertError\'" src="content/images/close1.png" alt=""> <img class="editor-photoAlbum-status-icon" ng-if="photoStatus(item) == \'convertRunning\' || photoStatus(item) == \'largeRunning\'" src="content/images/loading1.png" alt=""> <span class="editor-photoAlbum-status-text">{{(\'nav.photograph.content.status.\' + photoStatus(item)) | translate}}</span></div></div><i class="iconfont iconxuanzhong1" style="color: var(--genericColor);position: absolute;right: 2px;top: 0px; font-size: 14px" ng-if="item.selected"></i> <i class="iconfont iconxuanzhong" style="position: absolute;right: 2px;top: 0px; font-size: 14px" ng-if="!item.selected"></i><div class="photoCount" ng-if="item.frequency>0">{{item.frequency}}</div><div class="photoNot" ng-if="vm.photoSelectAll.length >= vm.fullMapNumber && !item.selected"></div></li><li ng-repeat="data in vm.uploadPhotoItem" ng-if="data.percent != 100 && data.state != \'error\'" style="position: relative"><progres-view :src="data.blobCover" :progres="data.percent"></progres-view></li></ul><div class="c-productThree2-head5"><button type="button" class="c-productThree2-head5-btn w100p" ng-click="folderSave()">{{\'button.confirm\' | translate}}\uFF08{{vm.photoSelectAll.length}}\uFF09</button></div></div><editor-gallery ng-if="vm.page2 || vm.page9 || vm.fullMap2" full-map="vm.fullMap" full-map-number="vm.fullMapNumber" photo-select-all="vm.photoSelectAll" article="vm.article" product-xml-line="vm.productXmlLine" counts="vm.counts" product="vm.product" agent-ios="agentIos"></editor-gallery><!--  \u6A21\u677F\u5C55\u793A\u9875  --><div class="c-productThree3" ng-if="vm.page3 && !vm.isCalendar"><div class="hint-text">{{\'editorCommon.describe3\' | translate}}</div><div class="c-productThree3-body scrollBarHide" lazy-img-container><div class="c-part-preview"><div class="c-part-preview-li" ng-repeat="part in template.config.parts.list" ng-if="part.counter && part.counter>0"><div class="c-part-preview-li-1">{{part.name}}</div><div class="c-part-preview-li-2"><div class="c-part-preview-li-2-li" ng-repeat="item in template.pages.page track by $index" ng-if="part.id == item.config.partid" ng-style="{\'margin-bottom\':part.id!=\'P\' ? \'10px\' : \'45px\'}"><div class="relative-view2 scrollBarHide" ng-click="editPageCb($index)" style="overflow-x: scroll;box-shadow: rgba(19, 20, 26, 0.15) 0px 0px 6px 0px"><page-preview page="item" scale="vm.ratio" is-lazy-img="true" is-imagebox-not="true" img-size="vm.imgSize" img-dpi="vm.imgDpi" ng-if="item"></page-preview></div><div class="pageTitle" ng-if="item.config.partid == \'P\'"><span>{{getIndex($index)}} / {{part.counter}}</span><div class="c-change-btn1" ng-if="template.config.productType == \'BOOK\'&&vm.replace && !item.unreplace && item.recommendLayout.length>1" ng-click="pageChange(item, $index)"><i class="iconfont icona-MagicWandmobang"></i> <span>\u6362\u4E00\u6362</span></div></div><div class="c-change-btn1 c-change-btn1-1" ng-if="template.config.productType == \'BOOK\'&&item.config.partid != \'P\' && vm.replace && !item.unreplace && item.recommendLayout.length>1" ng-click="pageChange(item, $index)"><i class="iconfont icona-MagicWandmobang"></i> <span>\u6362\u4E00\u6362</span></div></div><div class="c-productThree3-part-view-ul-slideable" ng-if="part.slideable">\u6ED1\u52A8\u67E5\u770B\u5168\u56FE <i class="iconfont icona-bianzubeifen5"></i></div></div></div></div></div><div class="c-productThree3-foot"><button class="editor-photoAlbum-btn editor-photoAlbum-btn-hollow mar-right-10" ng-click="sortingPage()" ng-if="vm.replace && template.config.productType == \'BOOK\'"><i class="icon iconfont iconpaixu"></i> {{\'editorBtn.sortingPage\' | translate}}</button> <button class="editor-photoAlbum-btn editor-photoAlbum-btn-solid" ng-click="save()"><i class="icon iconfont icon09"></i> {{\'editorBtn.allSave\' | translate}}</button></div></div><!--  \u6A21\u677F\u5236\u4F5C\u9875  --><div class="editor-photoAlbum-page4" ng-show="vm.page4"><div class="c-productThree4-head-view" style="position: fixed;top: 0; left: 0; width: 100%; z-index: 1"><div class="c-productThree4-head"><button type="button" class="c-productThree-btn2" ng-click="savePage4Return()" style="background: #a5a2a2">{{\'button.back\' | translate}}</button> <span>{{\'editorCommon.describe8\' | translate:({pageIndex:vm.pageIndex + 1, pageSum:vm.pageData.length})}}</span> <button type="button" class="c-productThree-btn2" ng-click="savePage4()">{{\'editorBtn.save\' | translate}}</button></div><div class="c-message-view2" ng-show="vm.messageList"><marquee scrollamount="2" height="30" behavior="scroll" direction="left" align="left" style="width: 100%;line-height: 30px; color: #fff">{{vm.messageList}}</marquee></div></div><!-- \u6587\u5B57\u63D0\u793A --><div class="c-productThree4" style="position:absolute; left: 0; top: 80px; right: 0; bottom: 0; overflow: hidden; z-index: 1" ng-click="makeBody($event)"><div class="c-productThree4-body" style="position: relative; margin: 2% auto 0;transition: all 0.1s" ng-style="{\n                    \'width\': vm.windowWidth,\n                    \'height\': vm.windowHeight,\n                    \'padding-top\': (vm.windowHeight - vm.pageData[vm.pageIndex].custom.height * vm.pageData[vm.pageIndex].custom.ratio1) / 2\n                 }"><page-mobile-edit page-data="vm.pageData" page-index="vm.pageIndex" level-index="vm.levelIndex" level-type="vm.levelType" that="vm" img-size="vm.imgSize" img-dpi="vm.imgDpi" is-small-pic="vm.isSmallPic" transparency="vm.transparency" hint="vm.hint"></page-mobile-edit><div class="previousPage" ng-if="vm.pageIndex > 0" ng-click="previousPage()"></div><div class="nextPage" ng-if="vm.pageIndex<vm.pageSum" ng-click="nextPage()"></div></div></div><div class="c-productThree4-foot" ng-show="!vm.isImageboxSelectItem && !vm.isMaterial && !vm.mapDepot && !vm.textboxSelect && !vm.textStyleShow"><div class="partName" style="top: -30px">{{\'editorCommon.textDetection.partName\' | translate:({partName: partName(vm.pageData[vm.pageIndex].config.partid)})}}</div><!--            <div class="warn-view2" ng-click="vm.isUploadNeedKnow=true">--><!--                <i class="icon iconfont iconhelp"></i>--><!--                <span>{{\'editorCommon.read\' | translate}}</span>--><!--            </div>--><div class="c-productThree4-foot-view" ng-click="templateShow()"><i class="icon iconfont iconmubanshape"></i> <span>{{\'editorBtn.templateText\' | translate}}</span></div><div class="c-productThree4-foot-view" ng-click="materialShow()"><i class="icon iconfont iconsucaishape"></i> <span>{{\'editorBtn.clipartText\' | translate}}</span></div><div class="c-productThree4-foot-view" ng-click="fontShow()"><i class="icon iconfont iconwenzishape"></i> <span>{{\'editorBtn.wordText\' | translate}}</span></div><div class="c-productThree4-foot-view" ng-click="photoGalleryShow()"><i class="icon iconfont icontupianshape"></i> <span>{{\'editorBtn.imgText\' | translate}}</span></div><div class="c-productThree4-foot-view" ng-click="layout()" ng-if="vm.replace && !vm.pageData[vm.pageIndex].unreplace && vm.reservePage.length>0"><i class="icon iconfont iconlayout"></i> <span>{{\'editorBtn.layout\' | translate}}</span></div></div><div class="picture-view" ng-style="{\'padding-bottom\': vm.isIPhoneX ? \'30px\' : \'0\'}" ng-if="vm.levelType == \'imagebox\' && vm.isImageboxSelectItem"><div class="picture-view-icon" ng-click="photoGalleryShow()"><i class="icon iconfont iconhuantu"></i> <span>{{\'editorBtn.changeImgText\' | translate}}</span></div><!--            <div class="picture-view-icon" ng-click="mattingImage()" ng-if="vm.filterInit(\'portrait\')">--><!--                <i class="icon iconfont iconbhjmianbushibie"></i>--><!--                <span>\u62A0\u4EBA\u50CF</span>--><!--            </div>--><div class="picture-view-icon" ng-click="cutImage()" ng-if="vm.filterInit(\'filter\')"><i class="icon iconfont iconlvjing"></i> <span>{{\'editorBtn.filterText\' | translate}}</span></div><div class="picture-view-icon" ng-click="modeIn()" ng-if="vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.bokehtype != \'None\'"><i class="icon iconfont iconicon_list_zhankai"></i> <span>{{\'editorBtn.retractText\' | translate}}</span></div><div class="picture-view-icon" ng-click="modeOut()" ng-if="vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.bokehtype == \'None\' && vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.bokehtypes != \'None\'"><i class="icon iconfont iconcaozuo-quanping-shousuo"></i> <span>{{\'editorBtn.spreadText\' | translate}}</span></div><div class="picture-view-icon" ng-click="cropImageboxRotate(vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.flip)" ng-if="vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.bokehtype == \'None\'"><i class="icon iconfont iconrotation"></i> <span>{{\'editorBtn.rotationText\' | translate}}</span></div><div class="picture-view-icon" ng-click="cropImageboxMassive()" ng-if="vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.bokehtype == \'None\'"><i class="icon iconfont iconxingzhuang2"></i> <span>{{\'editorBtn.upText\' | translate}}</span></div><div class="picture-view-icon" ng-click="cropImageboxMin()" ng-if="vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.bokehtype == \'None\'"><i class="icon iconfont iconxingzhuang3"></i> <span>{{\'editorBtn.downText\' | translate}}</span></div><div class="picture-view-icon" ng-click="overturnImagebox()"><i class="icon iconfont iconxingzhuang4"></i> <span>{{\'editorBtn.flipText\' | translate}}</span></div><div class="picture-view-icon" ng-click="cropImagRestore()"><i class="icon iconfont iconlujing6"></i> <span>{{\'editorBtn.restoreText\' | translate}}</span></div><!-- <div class="picture-view-icon" ng-click="mattingOpen()">\n                <i class="icon iconfont iconkoutu"></i>\n                <span>{{\'editorCommon.mattingOpen\' | translate}}</span>\n            </div> --></div><!-- \u4EBA\u50CF\u62A0\u56FE --><div class="three-filter" ng-if="vm.mattingShow" ng-style="{\'padding-bottom\': vm.isIPhoneX ? \'30px\' : \'0\'}"><div class="three-filter-body"><div class="three-filter-body-li" ng-repeat="item in vm.mattingList track by $index" ng-click="filterCb(item)"><img ng-src="{{item.img}}"><div class="three-filter-body-li-text">{{filterChoose(item.type)}}</div><!--                    <div class="three-filter-body-li-select" ng-if="item.type == vm.filterType">{{\'editorCommon.currentUse\' | translate}}</div>--></div></div></div><!-- \u6EE4\u955C --><div class="three-filter" ng-if="vm.filterShow" ng-style="{\'padding-bottom\': vm.isIPhoneX ? \'30px\' : \'0\'}"><div class="three-filter-body"><div class="three-filter-body-li" ng-repeat="item in vm.filterList track by $index" ng-click="filterCb(item)"><img ng-src="{{item.img}}"><div class="three-filter-body-li-text">{{filterChoose(item.type)}}</div><!--                    <div class="three-filter-body-li-select" ng-if="item.type == vm.filterType">{{\'editorCommon.currentUse\' | translate}}</div>--></div></div></div><!-- \u5E03\u5C40 --><div class="three-photoGallery" ng-style="{\'padding-bottom\': vm.isIPhoneX ? \'30px\' : \'0\'}" ng-show="vm.islayout && vm.replace && !vm.pageData[vm.pageIndex].unreplace && vm.reservePage.length>0"><div class="three-photoGallery-head1"><span ng-class="{\'three-photoGallery-head1-span-on\' : vm.islayout1}" ng-click="layoutFn(true)">{{\'editorCommon.recommendedLayout\' | translate}}</span> <span ng-class="{\'three-photoGallery-head1-span-on\' : vm.islayout2}" ng-click="layoutFn(false)">{{\'editorCommon.allLayout\' | translate}}</span> <i class="icon iconfont iconlujing8" ng-click="layoutHide()"></i><div style="position: absolute; bottom: 0; height: 20px; line-height: 20px; color: var(--genericColor); padding-left: 15px; font-size: 12px">{{\'editorCommon.changePage1\' | translate}}</div></div><div class="three-photoGallery-body"><ul class="clearfix" ng-if="vm.islayout1"><li ng-repeat="item in vm.recommendLayout track by $index" ng-click="layoutCb(item)" data-index="{{$index}}" style="background: #f3f3f3" ng-if="item.config.partid==vm.pageData[vm.pageIndex].config.partid && item.genre == vm.pageData[vm.pageIndex].genre && item.spread == vm.pageData[vm.pageIndex].spread"><img ng-src="{{item.pagecover.identifier}}"><div class="layout-quantity" ng-if="item.layoutQuantity && item.layoutQuantity>0">{{item.layoutQuantity}}</div></li></ul><ul class="clearfix" ng-if="vm.islayout2"><li ng-repeat="item in vm.reservePage track by $index" ng-click="layoutCb(item)" data-index="{{$index}}" style="background: #f3f3f3" ng-if="item.config.partid==vm.pageData[vm.pageIndex].config.partid && item.genre == vm.pageData[vm.pageIndex].genre && item.spread == vm.pageData[vm.pageIndex].spread"><img ng-src="{{item.pagecover.identifier}}"><div class="layout-quantity" ng-if="item.layoutQuantity && item.layoutQuantity>0">{{item.layoutQuantity}}\u6B21</div></li></ul></div></div><!-- \u6A21\u677F --><div class="three-photoGallery" ng-style="{\'padding-bottom\': vm.isIPhoneX ? \'30px\' : \'0\'}" ng-show="vm.istemplate"><div class="three-materialGallery-head"><ul class="three-materialGallery-head-ul"><li ng-repeat="item in vm.modelTab" ng-click="tempInfo(item)" ng-class="{\'opt\' : item.id == vm.productXmlThemeId}"><span>{{item.name}}</span></li></ul><i class="icon iconfont iconlujing8" ng-click="templateHide()"></i></div><div class="three-photoGallery-body"><ul class="clearfix"><li ng-repeat="line in vm.temps track by $index" ng-click="templateCb(line)" data-index="{{$index}}" ng-if="!line.cancelled"><img ng-src="{{line.coverImg}}" style="max-width: 100%;max-height: 100%"><div class="c-productThree4-img-list-select" ng-if="vm.article.productXmlId == line.productXmlId">{{\'editorCommon.currentUse\' | translate}}</div></li></ul></div><div class="animation-xia" ng-if="vm.tempList.productXmlLines.length>8"><i class="icon iconfont iconxiangxia2"></i></div></div><!-- \u56FE\u7247\u5E93 --><div class="three-photoGallery" ng-show="vm.mapDepot" ng-style="{\'padding-bottom\': vm.isIPhoneX ? \'30px\' : \'0\'}"><div class="three-photoGallery-head1"><span ng-class="{\'three-photoGallery-head1-span-on\' : vm.mapDepot1}" ng-click="vm.mapDepot1=true; vm.mapDepot2=false;">{{\'editorBtn.selectedImages\' | translate}}</span> <span ng-class="{\'three-photoGallery-head1-span-on\' : vm.mapDepot2}" ng-click="vm.mapDepot2=true; vm.mapDepot1=false;">{{\'editorBtn.dcim\' | translate}}</span> <i class="icon iconfont iconlujing8" ng-click="photoGalleryHide()"></i></div><div class="three-photoGallery-body" id="photoGallery" ng-show="vm.mapDepot2" ng-style="{\n                    \'overflow\': vm.isSmallPic ? \'hidden\' : \'scroll\'\n                 }"><ul class="clearfix"><li style="background: #ddd"><div ng-click="uploadPhoto()"><i class="icon iconfont iconcamera" style="color: #fff"></i> <input onchange="uploadImageMutiple(event)" type="file" multiple="multiple" accept="{{vm.supportedMimeTypes}}" name="file" ng-if="!agentIos && vm.isIPhone6" class="input-upload2"></div></li><li ng-repeat="data in vm.uploadPhotoItem" ng-if="data.state != \'error\'" style="position: relative"><progres-view :src="data.blobCover" :progres="data.percent"></progres-view></li><li ng-repeat="item in vm.photoAll track by $index" data-imgindex="{{$index}}" ontouchstart="startChange(event)" ontouchmove="dragChange(event)" ontouchend="stopChange(event)" ng-click="addImageboxImg(item)"><img ng-if="(item.identifier || (item.largeFlag && item.identifier1)) && photoStatus(item) == \'\'" ng-src="{{(item.largeFlag ? item.identifier1 : item.identifier)+\'?imageView2/1/w/100/h/75\'}}" alt="{{item.largeError}}" data-imgindex="{{$index}}" style="width: 100%; height: 100%"><div class="editor-photoAlbum-status" ng-if="(item.identifier || (item.largeFlag && item.identifier1)) && photoStatus(item) != \'\'" ng-class="{\'is-failed\': isPhotoFailed(item)}" ontouchstart="event.stopPropagation()" ng-click="onPhotoStatusClick(item, $event)"><img class="editor-photoAlbum-status-placeholder" src="content/images/placeholderImage.png" alt=""><div class="editor-photoAlbum-status-mask"><img class="editor-photoAlbum-status-icon" ng-if="photoStatus(item) == \'largeError\' || photoStatus(item) == \'convertError\'" src="content/images/close1.png" alt=""> <img class="editor-photoAlbum-status-icon" ng-if="photoStatus(item) == \'convertRunning\' || photoStatus(item) == \'largeRunning\'" src="content/images/loading1.png" alt=""> <span class="editor-photoAlbum-status-text">{{(\'nav.photograph.content.status.\' + photoStatus(item)) | translate}}</span></div></div><div style="position: absolute; left: 0; top: 0; width: 100%; height: 100%; z-index: 1" data-imgindex="{{$index}}"></div><div class="photoCount" ng-if="item.frequency>0">{{item.frequency}}</div></li></ul><div class="animation-xia" ng-if="vm.photoAll.length>8"><i class="icon iconfont iconxiangxia2"></i></div></div><div class="three-photoGallery-body" ng-show="vm.mapDepot1" ng-style="{\n                    \'overflow\': vm.isSmallPic ? \'hidden\' : \'scroll\'\n                 }"><ul class="clearfix"><li style="background: #ddd"><div ng-click="uploadPhoto()"><i class="icon iconfont iconcamera" style="color: #fff"></i> <input onchange="uploadImageMutiple(event)" type="file" multiple="multiple" accept="{{vm.supportedMimeTypes}}" name="file" ng-if="!agentIos && vm.isIPhone6" class="input-upload2"></div></li><li ng-repeat="data in vm.uploadPhotoItem" ng-if="data.percent != 100 && data.state != \'error\'" style="position: relative"><progres-view :src="data.blobCover" :progres="data.percent"></progres-view></li><li ng-repeat="item in vm.photoSelectAll1" data-imgindex="{{$index}}" ontouchstart="startChange(event)" ontouchmove="dragChange(event)" ontouchend="stopChange(event)" ng-click="addImageboxImg(item)"><img ng-if="(item.identifier || (item.largeFlag && item.identifier1)) && photoStatus(item) == \'\'" ng-src="{{(item.largeFlag ? item.identifier1 : item.identifier)+\'?imageView2/1/w/100/h/75\'}}" alt="{{item.largeError}}" data-imgindex="{{$index}}" style="width: 100%; height: 100%"><div class="editor-photoAlbum-status" ng-if="(item.identifier || (item.largeFlag && item.identifier1)) && photoStatus(item) != \'\'" ng-class="{\'is-failed\': isPhotoFailed(item)}" ontouchstart="event.stopPropagation()" ng-click="onPhotoStatusClick(item, $event)"><img class="editor-photoAlbum-status-placeholder" src="content/images/placeholderImage.png" alt=""><div class="editor-photoAlbum-status-mask"><img class="editor-photoAlbum-status-icon" ng-if="photoStatus(item) == \'largeError\' || photoStatus(item) == \'convertError\'" src="content/images/close1.png" alt=""> <img class="editor-photoAlbum-status-icon" ng-if="photoStatus(item) == \'convertRunning\' || photoStatus(item) == \'largeRunning\'" src="content/images/loading1.png" alt=""> <span class="editor-photoAlbum-status-text">{{(\'nav.photograph.content.status.\' + photoStatus(item)) | translate}}</span></div></div><div style="position: absolute; left: 0; top: 0; width: 100%; height: 100%; z-index: 1" data-imgindex="{{$index}}"></div><div class="photoCount" ng-if="item.frequency>0">{{item.frequency}}</div></li></ul><div class="animation-xia" ng-if="vm.photoSelectAll.length>8"><i class="icon iconfont iconxiangxia2"></i></div></div><div class="three-photoGallery-foot"><span class="c-color3">{{\'picture.sentPictures1\' | translate}}</span><div class="c-color1" ng-click="fullMapSelection()">{{\'button.full\' | translate}}<i class="iconfont iconyouceshouqi1"></i></div></div></div><div id="small-pic" class="user-select-default pointer-un" ontouchstart="return false;" ng-style="{left:galleryX||0,top:galleryY||0}" ng-show="vm.isSmallPic"><img ng-if="galleryChoose" ng-src="{{galleryChoose+\'?imageView2/1/w/105/h/80\'}}"></div><!--\u7D20\u6750--><div class="three-materialGallery" ng-show="vm.isMaterial" ng-style="{\'padding-bottom\': vm.isIPhoneX ? \'30px\' : \'0\'}"><div class="three-materialGallery-head"><ul class="three-materialGallery-head-ul"><li ng-repeat="item in vm.classify" ng-click="classifyCb(item)" ng-class="{\'opt\' : item.id == vm.classifyId}"><span>{{item.name}}</span></li></ul><i class="icon iconfont iconlujing8" ng-click="materialHide()"></i></div><div class="three-materialGallery-body" id="materialView"><ul class="clearfix"><li ng-repeat="item in vm.materialData" ng-click="addImageart(item)"><img ng-src="{{item.identifier+\'?imageView2/2/w/100\'}}" alt=""></li></ul></div><div class="animation-xia" ng-if="vm.materialData.length>8"><i class="icon iconfont iconxiangxia2"></i></div></div><!--  \u6587\u5B57  --><div class="three-font" ng-show="vm.page5"><div class="three-font-head"><button type="button" class="three-font-head-btn" ng-click="savePage5()">{{\'button.confirm\' | translate}}</button></div><div class="three-font-body"><!-- <input type="text" class="three-font-body-input" ng-model="vm.fontData.textbox.text" placeholder="\u8BF7\u8F93\u5165\u6587\u5B57"> --><textarea class="three-font-body-input" id="three-font-body-input" ng-keyup="changeText($event)" ng-style="{\'text-align\': vm.fontData.textbox.style.align }" ng-model="vm.fontData.textbox.text" placeholder="{{\'editorCommon.describe29\' | translate}}"></textarea><div style="opacity: 0" ng-style="{\'width\': (vm.pageData[vm.pageIndex].trimbox.width-10)}"><pre id="c-xml-page-material-fontId" style="display: inline-block; opacity: 0" ng-style="{\n                    \'font-family\': \'\\\'\' + vm.fontData.textbox.fontuuid + \'\\\'\',\n                    \'font-size\': (vm.fontData.textbox.style.size) + \'pt\',\n                    \'color\': vm.fontData.textbox.style.color,\n                    \'font-weight\': vm.fontData.textbox.style.bold ? \'bold\': \'400\',\n                    \'font-style\': vm.fontData.textbox.style.italic ? \'italic\': \'initial\',\n                    \'line-height\': (vm.fontData.textbox.style.lineheight) + \'pt\',\n                    \'letter-spacing\': (vm.fontData.textbox.style.letterspacing) + \'pt\',\n                    \'text-decoration\': \'none\',\n                    \'text-align-last\': \'unset\',\n                    \'max-width\' : \'100%\',\n                    \'writing-mode\': vm.fontData.textbox.style.writingmode,\n                    }"><span class="c-xml-page-textboxe-span">{{vm.fontData.textbox.text}}</span></pre></div></div></div><div style="opacity: 0; position: fixed" ng-style="{\n        \'width\': !writingmodeInit(vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.writingmode) ? (vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.geometry.width) : \'auto\',\n        \'height\': writingmodeInit(vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.writingmode) ? (vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.geometry.height) : \'auto\'\n        }"><pre id="c-xml-page-material-fontId1" style="display: inline-block; opacity: 0" ng-style="{\n                \'font-family\': \'\\\'\' + vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.fontuuid + \'\\\'\',\n                \'font-size\': (vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.size > 12 ? vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.size : 12) + \'pt\',\n                \'color\': vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.color,\n                \'font-weight\': vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.bold ? \'bold\': \'400\',\n                \'font-style\': vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.italic ? \'italic\': \'initial\',\n                \'letter-spacing\': (vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.size > 12 ? vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.letterspacing : (vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.letterspacing) / (1 / 12 * vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.size)) + \'pt\',\n                \'line-height\': (vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.size > 12 ? vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.lineheight : (vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.lineheight) / (1 / 12 * vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.size)) + \'pt\',\n                \'transform\':\'scale(\'+(1 / 12 * vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.size > 1 ? 1 : 1 / 12 * vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.size)+\')\',\n                \'transform-origin\': \'0 0\',\n                \'text-decoration\': \'none\',\n                \'text-align-last\': \'unset\',\n                \'max-width\' : \'100%\',\n                \'writing-mode\': vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.writingmode\n                }"><span class="pre-span">{{vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.text}}</span></pre></div><div class="three-font-operation" ng-if="vm.textboxSelect"><div class="three-font-operation-icon" ng-click="editTextbox()"><i class="icon iconfont iconbianjiwenzi"></i> <span>{{\'editorBtn.editWordText\' | translate}}</span></div><div class="three-font-operation-icon" ng-click="textStyleTextbox()"><i class="icon iconfont iconwenziyangshi"></i> <span>{{\'editorBtn.wordStyleText\' | translate}}</span></div><div class="three-font-operation-icon" ng-click="deleteTextbox()" ng-if="vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.useradded"><i class="icon iconfont icondustbin_icon"></i> <span>{{\'editorBtn.delWordText\' | translate}}</span></div></div><div class="three-textStyle" ng-if="vm.textStyleShow"><div class="three-textStyle-head"><ul><li ng-repeat="item in vm.textStyleTab" ng-click="textStyleTabCb(item)" ng-class="{\'opt\' : item.id == vm.textStyleItem}"><span>{{item.name}}</span></li></ul><i class="icon iconfont iconlujing8" ng-click="textStyleHide()"></i></div><div class="three-textStyle-body"><div class="textStyleTabFont" ng-if="vm.textStyleItem==\'textStyleTabFont\'"><div class="textStyleTabFont-li" ng-repeat="font in vm.fontList track by $index" ng-class="{\'textStyleTabFont-li-on\' : vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.fontuuid == font.uuid}" ng-click="updateTextFont(font)"><i class="icon iconfont iconduihao"></i> <span>{{font.family}}</span></div></div><div class="textStyleTabSize" ng-if="vm.textStyleItem==\'textStyleTabSize\'"><div class="c-productThree5-li-content" style="text-align: center; padding-top: 40px"><p class="text-value">{{\'font.currentFontSize\' | translate:({size: vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.size})}}</p><div><i class="icon-font font-jia"></i> <input type="range" min="9" max="1000" step="1" value="16" class="text-range rangeSize" id="rangeChange" oninput="densityInput(event)" ng-model="vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.size"> <i class="icon-font font-jian"></i></div></div></div><div class="textStyleTabType" ng-if="vm.textStyleItem==\'textStyleTabType\'"><div class="textStyleTabType-view1"><span>{{\'font.transparency\' | translate}}\uFF1A</span> <input type="range" min="0" max="100" step="1" value="16" class="text-range rangeSize" id="textStyleTransparency" oninput="textStyleTransparency(event)" ng-model="vm.transparency"> <span>{{vm.transparency}}</span></div><div class="textStyleTabType-view2"><div class="textStyleTabType-view2-li-icon" ng-if="vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.bold1" ng-class="{\'textStyleTabType-view2-li-icon-no\':!vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.bold,\'textStyleTabType-view2-li-icon-yes\':vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.bold}" ng-click="operationBold()"><i class="icon iconfont iconb"></i> <span>{{\'font.bold\' | translate}}</span></div><div class="textStyleTabType-view2-li-icon" ng-if="vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.italic1" ng-class="{\'textStyleTabType-view2-li-icon-no\':!vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.italic,\'textStyleTabType-view2-li-icon-yes\':vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.italic}" ng-click="operationItalic()"><i class="icon iconfont iconI"></i> <span>{{\'font.italic\' | translate}}</span></div><!--                        <div class="textStyleTabType-view2-li-icon">--><!--                            <i class="icon iconfont iconU"></i>--><!--                            <span>\u4E0B\u5212\u7EBF</span>--><!--                        </div>--><div class="textStyleTabType-view2-li-icon" ng-click="operationBarDir(\'left\')"><i class="icon iconfont iconjuzuo"></i> <span>{{\'font.alignLeft\' | translate}}</span></div><div class="textStyleTabType-view2-li-icon" ng-click="operationBarDir(\'center\')"><i class="icon iconfont iconjuzhong-orange"></i> <span>{{\'font.alignCenter\' | translate}}</span></div><div class="textStyleTabType-view2-li-icon" ng-click="operationBarDir(\'right\')"><i class="icon iconfont iconjuyou"></i> <span>{{\'font.alignRight\' | translate}}</span></div><div class="textStyleTabType-view2-li-icon" ng-click="textLayout(\'horizontal-tb\')" ng-if="vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.writingmode != \'horizontal-tb\'"><i class="icon iconfont iconhengban"></i> <span>{{\'font.horizontal\' | translate}}</span></div><!-- <div class="textStyleTabType-view2-li-icon" ng-click="textLayout(\'vertical-lr\')" ng-if="vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.writingmode != \'vertical-lr\'">\n                            <i class="icon iconfont iconshuban"></i>\n                            <span>{{\'font.vertical\' | translate}}</span>\n                        </div> --><!--                        <div class="textStyleTabType-view2-li-icon" ng-click="textLayout(\'vertical-rl\')" ng-if="vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.writingmode != \'vertical-rl\'">--><!--                            <i class="icon iconfont iconshuban1"></i>--><!--                            <span>\u7AD6\u7248\u53F3</span>--><!--                        </div>--></div></div><div class="clearfix" ng-if="vm.textStyleItem==\'textStyleTabColor\'"><span class="fontColor-item" style="float: left" ng-repeat="item in colorList" ng-click="fontColorCb(item)" ng-style="{\n                            \'border\': vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.color == item ?  \'1px solid \' + item : none,\n                          }"><i ng-style="{\'background\': item}"></i></span></div></div></div><!--  \u9009\u62E9\u6A21\u677F  --><div class="select-box" ng-show="vm.xmlShowPic"><div class="select-wrapper3"><div style="background: url(\'content/images/preview-close@2x.svg\') no-repeat; background-size: 100% 100%" id="previewClose" ng-click="previewClose()" ng-style="{\'right\':((dWidth-318)/2)+\'px\'}"></div><div class="containerTheme"><div class="swiper-template-view"><div class="swiper-container swiper-template-view-content" ng-show="vm.imgs.length>0"><div class="swiper-wrapper"><div class="swiper-slide" ng-repeat="item in vm.imgs"><img ng-src="{{item.identifier +\'?imageView2\'||\'//:0\'}}" ng-if="item.identifier"></div></div></div><div ng-if="vm.imgs.length == 0" class="swiper-template-view-content1"><img src="content/images/notImg.png" style="width: 160px"></div></div></div><div class="swiper-button-prev" style="background: url(\'content/images/prev_temp.svg\') no-repeat; background-size: 100% 100%" ng-click="prevImg()" ng-if="vm.imgs.length > 0"></div><div class="swiper-button-next" style="background: url(\'content/images/next_temp.svg\') no-repeat; background-size: 100% 100%" ng-click="nextImg()" ng-if="vm.imgs.length > 0"></div></div><div class="c-modal-foot" style="position: absolute; bottom: 10px;left: 0"><button class="startMake btn diy-btn-primarys opacityMinus no-padding" style="background: #858585" ng-click="previewClose()">{{\'template.cancelPreview\' | translate}}</button> <button class="startMake btn diy-btn-primarys opacityMinus no-padding" ng-click="changeAllTemp()" style="background: var(--genericColor); color: #fff!important">{{\'template.confirm\' | translate}}</button></div></div></div><!-- \u9875\u9762\u6392\u5E8F --><div class="c-productThree3" ng-if="vm.page7" style="padding: 50px 0 0 0;background: #f3f3f3; overflow: scroll"><div class="c-productThree4-head" style="position: fixed; top: 0; left: 0; width: 100%;justify-content: space-between; z-index: 9999; background: #fff"><div><button type="button" class="c-productThree-btn2" ng-click="getBack(\'page7\')" style="margin-right: 10px; width: 65px">{{\'button.back\' | translate}}</button> <button type="button" class="c-productThree-btn2" ng-click="restorePage7()" style="width: 65px">{{\'button.restore\' | translate}}</button></div><button type="button" class="c-productThree-btn2" ng-click="savePage7()" style="width: 65px">{{\'editorBtn.save\' | translate}}</button></div><div class="c-productThree3-body" style="overflow: unset; height: auto"><div class="c-productThree3-ul clearfix" id="my-ui-list1"><div class="c-productThree3-li sortingPageView" ng-repeat="item in vm.sortingPage track by $index" ng-class="{\'filtered\':item.unreplace, \'notDrag\': item.unreplace}" style="position: relative" ng-style="{\n                        \'width\': item.custom.width * item.custom.ratio,\n                        \'height\': item.custom.height * item.custom.ratio\n                     }" data-id="{{$index}}" data-spread="{{item.spread}}" ng-if="(item.config.partid == \'P\'&&!item.unreplace)"><page-preview page="item" scale="item.custom.ratio" is-imagebox-not="true" img-size="vm.imgSize" img-dpi="vm.imgDpi" ng-if="item"></page-preview><div class="pageTitle"><span ng-if="item.config.partid != \'P\'">{{partName($index)}}</span> <span ng-if="item.config.partid == \'P\'">\u7B2C{{getSortIndex($index)}}\u9875</span></div><div class="sort-item-cell"></div><div class="sort-item-mask">\u9875\u9762\u5C3A\u5BF8\u4E0D\u4E00\u81F4\uFF0C\u65E0\u6CD5\u66FF\u6362\u5230\u6B64\u5904</div></div></div></div></div><!--  \u5F00\u59CB\u5B9A\u5236\u52A0\u8F7D\u9875  --><div class="three-modal1" ng-if="vm.page8"><img src="content/images/loading2.gif" alt=""><div style="text-align: center; font-size: 14px; line-height: 20px">{{\'editorCommon.loadingText3\' | translate}}<br>{{\'editorCommon.loadingText4\' | translate}}</div></div><!-- \u4E0A\u4F20\u987B\u77E5  --><div class="three-modal" ng-if="vm.isUploadNeedKnow"><div class="three-modal-body1"><div class="uploadNeedKnow-head">{{\'editorBtn.uploadBefore\' | translate}}</div><div class="uploadNeedKnow-body"><span style="font-weight: bold; font-size: 16px; bottom: 10px">{{\'editorCommon.describe26\' | translate}}</span><ul style="padding: 0 0 15px 20px"><li>{{\'editorCommon.describe4\' | translate}}</li><li>{{\'editorCommon.describe5\' | translate}}</li><li><span class="icon iconfont iconwaring imageboxWarn"></span>{{\'editorCommon.describe22\' | translate}}</li><li>{{\'editorCommon.describe23\' | translate}}</li></ul><span style="font-weight: bold; font-size: 16px; margin-top: 20px">{{\'editorCommon.describe24\' | translate}}</span><ul style="padding-left: 20px"><li>{{\'editorCommon.describe25\' | translate}}</li></ul></div><div class="uploadNeedKnow-foot" ng-click="uploadNeedKnowHide()">{{\'editorCommon.iSee\' | translate}}</div></div></div><div class="three-modal" ng-if="vm.threeIsModal"><div class="three-modal-body"><div class="three-modal-body-content">{{vm.threeModalText}}</div><div class="three-modal-body-foot"><button type="button" class="color1" ng-click="threeModalHide()">{{\'button.cancel\' | translate}}</button> <button type="button" class="color2" ng-click="threeModalSave()">{{\'template.change\' | translate}}</button></div></div></div><div class="three-modal" ng-if="vm.threeIsModal1"><div class="three-modal-body"><div class="three-modal-body-content">{{vm.threeModalText1}}</div><div class="three-modal-body-foot"><button type="button" class="color2" ng-click="threeModalHide()">{{\'button.confirm\' | translate}}</button></div></div></div><div class="three-modal1" ng-if="vm.threeLoading"><img src="content/images/loading2.gif" alt=""><div>{{vm.threeLoadingText}}</div></div><div class="three-modal2" ng-if="vm.threeError"><div class="three-modal2-body"><!--            <i class="icon iconfont iconkulian"></i>--><div>{{vm.threeErrorText}}</div></div></div><div class="three-modal3" ng-if="vm.threeError1"><div class="three-modal3-body"><i class="icon iconfont iconxuanze"></i> <span>{{vm.threeErrorText1}}</span></div></div><div class="three-modal" ng-if="vm.isEditFolderName"><div class="three-modal-body"><div class="three-modal-body-content"><input type="text" class="c-input1" ng-model="vm.folderSelectData.name"></div><div class="three-modal-body-foot"><button type="button" class="color1" ng-click="editFolderNameHide()">{{\'button.cancel\' | translate}}</button> <button type="button" class="color2" ng-click="editFolderNameSave()">{{\'button.confirm\' | translate}}</button></div></div></div><!--\u5220\u9664\u5904\u7406\u5931\u8D25\u7684\u7167\u7247--><div class="three-modal" ng-if="vm.deletePhotoSure"><div class="three-modal-body"><div class="three-modal-body-content" style="flex-direction: column; height: auto; padding: 24px 20px"><div style="font-size: 15px; font-weight: bold; color: #333; margin-bottom: 10px">{{\'nav.photograph.content.deletePhoto.title\' | translate}}</div><div style="font-size: 14px; color: #666; text-align: center">{{\'nav.photograph.content.deletePhoto.content\' | translate}}</div></div><div class="three-modal-body-foot"><button type="button" class="color1" ng-click="vm.deletePhotoSure = false">{{\'button.cancel\' | translate}}</button> <button type="button" class="color2" ng-click="deletePhotoConfirm()">{{\'button.confirm\' | translate}}</button></div></div></div></div><div class="move-tip1" ng-if="vm.hint"><img src="content/images/move_tip.png"></div><div class="guidePage" ng-if="vm.isGuidePage && vm.isGuidePage1"><div class="guidePage-view guide-editor-photoAlbum-1" ng-if="vm.guidePage == 1"><div class="guidePage-button" ng-click="vm.guidePage = 2"></div><div class="guidePage-button" style="left: 219px;width: 143px;height: 200px;top: 200px" ng-click="vm.isGuidePage1 = false;"></div></div><div class="guidePage-view guide-editor-photoAlbum-2" ng-if="vm.guidePage == 2"><div class="guidePage-button" ng-click="vm.guidePage = 3"></div></div><div class="guidePage-view guide-editor-photoAlbum-3" ng-if="vm.guidePage == 3"><div class="guidePage-button" ng-click="vm.isGuidePage = false;"></div></div><div class="guidePage-view guide-editor-photoAlbum-4" ng-if="vm.guidePage == 4"><div class="guidePage-button" ng-click="vm.guidePage=5"></div><div class="guidePage-button" style="left: 191px;width: 143px" ng-click="vm.isGuidePage1 = false;"></div></div><div class="guidePage-view guide-editor-photoAlbum-5" ng-if="vm.guidePage == 5"><div class="guidePage-button" ng-click="vm.guidePage=6"></div></div><div class="guidePage-view guide-editor-photoAlbum-6" ng-if="vm.guidePage == 6"><div class="guidePage-button" ng-click="vm.guidePage=7"></div></div><div class="guidePage-view guide-editor-photoAlbum-7" ng-if="vm.guidePage == 7"><div class="guidePage-button" ng-click="vm.guidePage=8"></div></div><div class="guidePage-view guide-editor-photoAlbum-8" ng-if="vm.guidePage == 8"><div class="guidePage-button" ng-click="vm.guidePage=9"></div></div><div class="guidePage-view guide-editor-photoAlbum-9" ng-if="vm.guidePage == 9"><div class="guidePage-button" ng-click="vm.guidePage=10"></div></div><div class="guidePage-view guide-editor-photoAlbum-10" ng-if="vm.guidePage == 10"><div class="guidePage-button" ng-click="vm.guidePage=11"></div></div><div class="guidePage-view guide-editor-photoAlbum-11" ng-if="vm.guidePage == 11"><div class="guidePage-button" ng-click="vm.isGuidePage1 = false;"></div></div><div class="guidePage-view guide-editor-photoAlbum-12" ng-if="vm.guidePage == 12"><div class="guidePage-button" ng-click="vm.guidePage = 13"></div><div class="guidePage-button" style="right: 23px; width: 100px; height: 200px;top: 200px" ng-click="vm.isGuidePage1 = false;"></div></div><div class="guidePage-view guide-editor-photoAlbum-13" ng-if="vm.guidePage == 13"><div class="guidePage-button" ng-click="vm.guidePage = 14"></div></div><div class="guidePage-view guide-editor-photoAlbum-14" ng-if="vm.guidePage == 14"><div class="guidePage-button" ng-click="vm.guidePage = 15"></div></div><div class="guidePage-view guide-editor-photoAlbum-15" ng-if="vm.guidePage == 15"><div class="guidePage-button" ng-click="vm.guidePage = 16"></div></div><div class="guidePage-view guide-editor-photoAlbum-16" ng-if="vm.guidePage == 16"><div class="guidePage-button" ng-click="vm.guidePage = 17"></div></div><div class="guidePage-view guide-editor-photoAlbum-17" ng-if="vm.guidePage == 17"><div class="guidePage-button" ng-click="vm.guidePage = 18"></div></div><div class="guidePage-view guide-editor-photoAlbum-18" ng-if="vm.guidePage == 18"><div class="guidePage-button" ng-click="vm.guidePage = 19"></div></div><div class="guidePage-view guide-editor-photoAlbum-19" ng-if="vm.guidePage == 19"><div class="guidePage-button" ng-click="vm.isGuidePage = false;"></div></div></div><!--\u5C01\u9762\u7F29\u7565\u56FEview--><div id="thumbnail-view" style="position: fixed; z-index: -1; overflow: hidden"><page-preview page="template.pages.page[0]" thumbnail="true" scale="template.pages.page[0].custom.thumbnailScale"></page-preview></div><!--\u6587\u5B57\u68C0\u6D4B\u7ED3\u679C--><div class="c-modal" ng-if="vm.isDocumentTextDetection"><div class="exit-box-mask"></div><div class="exit-box-con1"><div class="c-documentTextDetection-title">{{\'editorCommon.textDetection.title\' | translate}}</div><div class="c-documentTextDetection-list" ng-repeat="item in vm.documentTextDetection track by $index"><div class="c-documentTextDetection-list-title">{{\'editorCommon.textDetection.whichPage\' | translate:({pageIndex:item.pageIndex})}}</div><div class="c-documentTextDetection-list-body" ng-repeat="text in item.texts">{{text}}</div></div><div class="c-documentTextDetection-save" ng-click="vm.isDocumentTextDetection=false">{{\'editorBtn.toModify\' | translate}}</div><div class="c-documentTextDetection-save"><div class="c-documentTextDetection-save1" ng-click="vm.isDocumentTextDetection=false">{{\'button.cancel\' | translate}}</div><div class="c-documentTextDetection-save2" ng-click="editPageCb(vm.documentTextDetection[0].pageIndex-1)">{{\'editorBtn.toModify\' | translate}}</div></div></div></div><!--\u53F0\u5386\u8BBE\u7F6E\u5F00\u59CB\u6708\u4EFD--><div class="set-month-view" ng-if="vm.isCalendar" ng-click="isYearHide($event)"><div class="set-month-view-item" style="display: block;width: 100%"><div class="set-month-view-1" style="padding: 15px"><div class="set-month-view-1-1">\u8BBE\u7F6E\u53F0\u5386\u5F00\u59CB\u7684\u6708\u4EFD</div><div class="set-month-view-1-2">\u9009\u62E9\u53F0\u5386\u5F00\u59CB\u7684\u6708\u4EFD\uFF0C\u6211\u4EEC\u5C06\u4ECE\u8FD9\u4E2A\u6708\u5F00\u59CB\u4E3A\u60A8\u5B9A\u5236{{vm.monthIndex1}}\u4E2A\u6708\u7684\u7F8E\u597D</div><!-- <div class="set-month-view-1-3">\n                <i class="iconfont iconzuoceshouqi1" ng-class="{\'set-month-view-1-3-not\':vm.yearIndex==2000}" ng-click="yearIndex(\'subtract\')"></i>\n                <span>{{vm.yearIndex}}</span>\n                <i class="iconfont iconyouceshouqi1" ng-class="{\'set-month-view-1-3-not\':vm.yearIndex==vm.years[vm.years.length-1]}" ng-click="yearIndex(\'add\')"></i>\n            </div> --><div class="set-month-view-1-3"><i class="iconfont iconzuoceshouqi1" ng-class="{\'set-month-view-1-3-not\':vm.yearIndex==2000}" ng-click="yearIndex(\'subtract\')"></i><div class="set-month-view-1-3-1" ng-click="isYearShow($event)"><div class="set-month-view-1-3-1-title">{{vm.yearIndex}}</div><div class="set-month-view-1-3-1-body" ng-if="vm.isYear"><div class="set-month-view-1-3-1-body-1"><div class="set-month-view-1-3-1-body-1-span">{{vm.years[0]}}\u5E74-{{vm.years[vm.years.length-1]}}\u5E74</div><div class="set-month-view-1-3-1-body-hr"></div></div><div class="set-month-view-1-3-1-body-2"><div class="set-month-view-1-3-1-body-2-ul"><div class="set-month-view-1-3-1-body-2-ul-li" ng-repeat="item in vm.years track by $index" ng-if="vm.yearPage == mathFloor($index)" ng-class="{\'set-month-view-1-3-1-body-2-ul-li-selected\' : vm.yearIndex == item}" ng-click="yearIndexSave($event,item)">{{item}}</div></div><div class="set-month-view-1-3-1-body-2-page-turning"><i class="iconfont iconzuoceshouqi1" ng-click="yearPageCb(\'subtract\')"></i><!-- <span class="set-month-view-1-3-1-body-2-page-turning-1">{{vm.yearPage}}</span> --> <input type="text" min="1" class="set-month-view-1-3-1-body-2-page-turning-1" ng-model="vm.yearPage" ng-change="yearPageChange()"> <span style="margin: 0 6px">/</span> <span>{{vm.yearSize}}</span> <i class="iconfont iconyouceshouqi1" ng-click="yearPageCb(\'add\')"></i></div></div></div></div><i class="iconfont iconyouceshouqi1" ng-class="{\'set-month-view-1-3-not\':vm.yearIndex==vm.years[vm.years.length-1]}" ng-click="yearIndex(\'add\')"></i></div><div class="set-month-view-1-4"><div class="set-month-view-1-4-view" ng-repeat="item in vm.months"><div class="set-month-view-1-4-li" ng-click="vm.monthIndex=item" ng-class="{\'set-month-view-1-4-li-selected\' : vm.monthIndex==item}">{{item}}</div></div></div></div><div class="set-month-view-2" style="padding: 15px"><div class="set-month-view-1-1">\u7ED3\u675F\u65E5\u671F</div><div class="set-month-view-1-2">{{getEndYear()}}\u5E74{{getEndMonth()}}\u6708</div></div><div class="set-month-view-3" ng-click="calendarSave()" style="width: 100%;border-radius: 20px">\u5F00\u59CB\u5236\u4F5C</div></div></div><upload-image ng-if="!(vm.page2 || vm.page9)" store-id="vm.storeId" aid="vm.aid" upload-photo-item="vm.uploadPhotoItem" photos="vm.photoArray" photo-all="vm.photoSelectAll" gallery-page="vm.photoAll" folder-one="vm.folderOne" data-html2canvas-ignore on-upload-start="onUploadStart()" on-uploadphoto="uploadSuccess(text)"></upload-image><div class="lang-ic" ng-show="vm.lagnuages.length>1&&!vm.hide" style="bottom: 120px"><img src="content/images/lagnuage.svg" ng-click="vm.language=true"><div class="lang-ic-content" ng-click="vm.hide=true"><i class="iconfont iconjian2"></i></div></div><language is-show="vm.language" ng-if="vm.language"></language><!-- \u62A0\u56FE --><image-cutout ng-if="vm.isShowImageCutout" :imagebox="vm.imageboxCutout" on-save="imageCutoutSave(text)" on-change="imageCutoutChange(text)"></image-cutout><!--\u91CD\u590D\u56FE\u7247--><duplicate-list ng-if="vm.isDuplicateList" list="vm.duplicateList" on-change="duplicateChange(text)"></duplicate-list><style>body{\n        overflow: unset !important;\n    }\n    .editor-window *{\n        -webkit-touch-callout:none; /*\u7CFB\u7EDF\u9ED8\u8BA4\u83DC\u5355\u88AB\u7981\u7528*/\n        -webkit-user-select:none; /*webkit\u6D4F\u89C8\u5668*/\n        -khtml-user-select:none; /*\u65E9\u671F\u6D4F\u89C8\u5668*/\n        -moz-user-select:none;/*\u706B\u72D0*/\n        -ms-user-select:none; /*IE10*/\n        user-select:none;\n    }\n    .editor-window input {\n        -webkit-user-select:auto !important;\n    }\n\n    .editor-window textarea{\n        -webkit-user-select:auto !important;\n    }\n    .c-part-preview{\n        width: 100vw;\n        padding: 15px;\n    }\n    .c-part-preview-li{\n        background: #fff;\n        border-radius: 8px;\n        padding: 15px;\n        margin-bottom: 15px;\n    }\n    .c-part-preview-li-1{\n        line-height: 22px;\n        font-size: 16px;\n        color: #333;\n        margin-bottom: 12px;\n    }\n    .c-part-preview-li-2{\n        display: flex;\n        flex-wrap: wrap;\n        justify-content: space-between;\n    }\n    .c-part-preview-li-2-li{\n        position: relative;\n        margin-bottom: 45px;\n        max-width: 100%;\n    }\n\n    .c-productThree3-part-view-ul-slideable{\n        width: 100%;\n        color: #666;\n        display: flex;\n        justify-content: end;\n        align-items: center;\n    }\n    @media (min-width: 768px) and (max-width: 999px){\n        .well {\n            width: 100%;\n            margin: 0 auto;\n            padding: 0 !important;\n            overflow: hidden;\n        }\n        .c-productThree1-body-y ul li{\n            width: 25%;\n        }\n        .c-productThree2-head3-li-body li{\n            width: calc(calc(100% / 4) - 10px);\n        }\n        .editor-photoAlbum-page1-foot-fr{\n            width: calc(100% - 200px);\n        }\n        .editor-photoAlbum-page1-foot-fr button{\n            width: 100%;\n        }\n        .three-materialGallery-body ul li, .three-photoGallery-body ul li{\n            width: 20%;\n        }\n        .three-font-body-input{\n            width: 70%;\n            height: 150px;\n            border-radius: 10px;\n            padding: 10px;\n        }\n        .three-modal-body{\n            position: fixed;\n            left: 20%;\n            top: 30%;\n            width: 60%;\n        }\n        .three-modal-body-content {\n            width: 100%;\n            height: 200px;\n        }\n        .select-wrapper3 {\n            position: absolute;\n            top: 30%;\n            left: 0;\n            width: 100vw;\n        }\n    }\n    @media (min-width: 999px){\n        .well {\n            width: 100%;\n            margin: 0 auto;\n            padding: 0 !important;\n            overflow: hidden;\n        }\n        .c-productThree1-body-y ul li{\n            width: 16.6%;\n        }\n        .c-productThree2-head3-li-body li{\n            width: calc(calc(100% / 6) - 10px);\n        }\n        .three-materialGallery-body ul li, .three-photoGallery-body ul li{\n            width: 16.6%;\n        }\n        .three-font-body-input{\n            width: 70%;\n            height: 150px;\n            border-radius: 10px;\n            padding: 10px;\n        }\n        .three-modal-body{\n            position: fixed;\n            left: 20%;\n            top: 30%;\n            width: 60%;\n        }\n        .three-modal-body-content {\n            width: 100%;\n            height: 200px;\n        }\n        .select-wrapper3 {\n            position: absolute;\n            top: 30%;\n            left: 0;\n            width: 100vw;\n        }\n    }\n    .modal-content {\n        width: 90%;\n    }\n    /*  \u52A8\u6001\u65E5\u5386  */\n    .set-month-view {\n        position: fixed;\n        left: 0;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        background: #fff;\n        z-index: 999;\n        padding: 50px 20px;\n    }\n    .set-month-view-1-4-li-selected{\n        background: var(--webMainButtonBackColor) !important;\n        color: #fff !important;\n    }\n    .sort-item-mask{\n        position: absolute;\n        display: none;\n        padding: 20px;\n        color: #ffffff;\n        justify-content: center;\n        align-items: center;\n        width: 100%;\n        height: 100%;\n        top: 0;\n        left: 0;\n        background: rgba(0,0,0,0.3);\n        z-index:1;\n    }\n    .sort-item-cell{\n        position: absolute;\n        top: 0;\n        width: 2px;\n        height: 100%;\n        background: #c7c7c7;\n        display: none;\n    }\n    .sort-item-cell:after{\n        content: "";\n        display: block;\n        width: 6px;\n        height: 6px;\n        position: absolute;\n        bottom: 0;\n        left: -2px;\n        border-radius: 50%;\n        background: #ffffff;\n        border: 1px solid #c7c7c7;\n    }\n    .sort-item-cell:before{\n        content: "";\n        display: block;\n        width: 6px;\n        height: 6px;\n        position: absolute;\n        top: 0;\n        left: -2px;\n        border-radius: 50%;\n        background: #ffffff;\n        border: 1px solid #c7c7c7;\n    }\n    /* \u5927\u56FE\u5904\u7406\u4E2D/\u5931\u8D25\u3001\u8272\u5F69\u8F6C\u6362\u4E2D/\u5931\u8D25\uFF1A\u5360\u4F4D\u56FE + \u5C45\u4E2D\u72B6\u6001\u56FE\u6807\u4E0E\u6587\u6848 */\n    .editor-photoAlbum-status{\n        position: absolute;\n        left: 0;\n        top: 0;\n        z-index: 2;\n        width: 100%;\n        height: 100%;\n        overflow: hidden;\n    }\n    .editor-photoAlbum-status-placeholder{\n        position: absolute;\n        left: 0;\n        top: 0;\n        z-index: 1;\n        display: block;\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n    }\n    .editor-photoAlbum-status-mask{\n        position: absolute;\n        left: 0;\n        top: 0;\n        z-index: 2;\n        display: flex;\n        box-sizing: border-box;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        width: 100%;\n        height: 100%;\n        padding: 4px;\n        background-color: rgba(0, 0, 0, 0.25);\n    }\n    .editor-photoAlbum-status-icon{\n        display: block;\n        flex: none;\n        width: 20px;\n        height: 20px;\n        margin-bottom: 4px;\n        object-fit: contain;\n    }\n    .editor-photoAlbum-status-text{\n        max-width: 100%;\n        color: #ffffff;\n        font-size: 11px;\n        line-height: 14px;\n        text-align: center;\n        word-break: break-all;\n        text-shadow: 0 1px 4px rgba(0,0,0,0.6);\n    }\n    .editor-photoAlbum-status.is-failed{\n        cursor: pointer;\n    }</style>');
$templateCache.put('app/entities/product-ec/id-photo.html','<div data-html2canvas-ignore style="background: #f3f3f3"><div class="c-message-view1" ng-show="vm.messageList && !vm.isImage"><marquee scrollamount="2" height="30" behavior="scroll" direction="left" align="left" style="width: 100%;line-height: 30px; height: 30px">{{vm.messageList}}</marquee></div><div class="id-phont-view1" ng-if="vm.isImage">\u70B9\u51FB\u56FE\u7247\u8FDB\u884C\u7F16\u8F91</div><div class="id-phont-view" ng-click="canvasOuter($event)"><div class="c-page-view-notData" ng-if="!vm.isImage"><img src="content/images/worksNull.png" alt="" srcset="" style="width:50%"><div style="display: flex;flex-direction: column;align-items: center;justify-content: center;margin-top: 12px"><div style="text-align: center;font-size: 16px;color: #aeaeae">{{\'editorCommon.noPhotos\' | translate}}</div><div class="botton-save" style="margin-top: 16px" ng-click="uploadPhoto()">{{\'editorBtn.uploadGallery\' | translate}}</div></div></div><page-mobile-edit ng-if="vm.isImage" editor-type="vm.article.editorType" page-data="template.pages.page" page-index="0" level-index="vm.levelIndex" level-type="vm.levelType" that="vm" img-size="vm.imgSize" transparency="vm.transparency" img-dpi="vm.imgDpi" not-imagebox-tip="true"></page-mobile-edit></div><div class="c-editorPhoto3-foot" ng-if="vm.isImage && template.pages.page[0].levels.level[vm.levelIndex]"><div class="icon-btn" ng-click="rotateImagebox()"><img src="content/images/icon/rotate-icon.png" alt=""> <span>{{\'editorBtn.rotationText\' | translate}}</span></div><div class="icon-btn" ng-class="{\'editor-dialog-btn-disabled\':!template.pages.page[0].levels.level[vm.levelIndex] || template.pages.page[0].levels.level[vm.levelIndex].imagebox.bokehtype != \'None\'}" ng-click="imageboxSite(\'center\')"><img src="content/images/icon/center-icon.png" alt=""> <span>{{\'font.alignCenter\' | translate}}</span></div><div class="icon-btn" ng-class="{\'editor-dialog-btn-disabled\':!template.pages.page[0].levels.level[vm.levelIndex]}" ng-if="template.pages.page[0].levels.level[vm.levelIndex].imagebox.bokehtype == \'None\'" ng-click="fillImagebox()"><img src="content/images/icon/reduce-icon.png" alt=""> <span>{{\'editorBtn.retractText\' | translate}}</span></div><div class="icon-btn" ng-class="{\'editor-dialog-btn-disabled\':!template.pages.page[0].levels.level[vm.levelIndex]}" ng-if="template.pages.page[0].levels.level[vm.levelIndex].imagebox.bokehtype != \'None\'" ng-click="cutImagebox()"><img src="content/images/icon/unfold-icon.png" alt=""> <span>{{\'editorBtn.spreadText\' | translate}}</span></div></div><div class="c-editorPhoto1-foot" ng-if="vm.isImage && !template.pages.page[0].levels.level[vm.levelIndex]" ng-style="{\'padding-bottom\': vm.isIPhoneX ? \'30px\' : \'0\', \'height\' : vm.isIPhoneX ? \'auto\' : \'60px\'}"><div class="c-editorPhoto1-foot-right" style="width: 100%"><div class="btn-save btn-save-select" ng-click="saveTab()" style="width: 100%; margin: 0">{{\'editorBtn.save\' | translate}}</div></div></div></div><input onchange="uploadImageMutiple(event)" id="uploadImageMutipleThree" type="file" multiple="multiple" accept="{{vm.supportedMimeTypes}}" name="file" class="input-upload1"><upload-image tag="\'normalEditor\'" store-id="vm.storeId" aid="vm.aid" upload-photo-item="vm.uploadPhotoItem"></upload-image><!--  \u5F00\u59CB\u5B9A\u5236\u52A0\u8F7D\u9875  --><div class="page-loading" ng-show="vm.loading"><img src="content/images/loading2.gif" onerror="this.src=\'content/images/loading2.gif\'"><p class="tip-style">{{\'editorCommon.loadingText\' | translate}}</p><span class="tip-style">{{\'editorCommon.loadingText1\' | translate}}</span></div><!--\u7F29\u7565\u56FE--><div id="thumbnail-view" style="position: absolute;left: 0;top: 0; z-index: -1; overflow: hidden"><page-preview page="template.pages.page[0]" scale="template.pages.page[0].custom.thumbnailScale" ng-if="template.pages.page[0]" thumbnail="true"></page-preview></div><div class="three-modal2" ng-if="vm.threeError"><div class="three-modal2-body"><!--            <i class="icon iconfont iconkulian"></i>--><div>{{vm.threeErrorText}}</div></div></div><style>body{\n        overflow: unset !important;\n    }\n    .c-message-view1{\n        background-color: #fff;\n    }\n    .id-phont-view1{\n        height: 30px;\n        background: #fff;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        color: #999;\n    }\n    .id-phont-view{\n        width: 100vw;\n        height: 100vh;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        padding-bottom: 100px;\n    }</style>');
$templateCache.put('app/entities/product-ec/product-dialog.html','<div class="edit-page page-view" style="background-image: url(\'content/images/22121x.png\')"><div class="come-in" ng-show="vm.aid?false:!isHide" ng-cloak><img src="content/images/index.jpg" style="width: 100%;height: 100%"> <img src="content/images/close-gray.svg" ng-click="hideComeIn()"></div><div class="edit-page-content" ng-style="{width:dWidth,height:vm.dHeight}" ng-click="hideMenu()"><div class="top-menu diy-row"><div class="index-info"><span class="currentIndex">{{currentCarouselIndex+1}}</span>/{{template.pages.page.length}}</div></div><button class="leftBtn ll{{$index}}" ng-click="pageLeft()" ng-show="visibleLeft"><img src="content/images/icons/left.svg"></button> <input id="uploadImg" type="file" multiple="multiple" accept="{{vm.supportedMimeTypes}}" name="file" value="" style="display: none"><div class="edit-menu hide1" style="position: absolute;z-index: 800"><span class="zoom-in" ng-click="zoomIn()"><img src="content/images/icons/zoom.svg" alt=""></span><span class="zoom-out" ng-click="zoomOut()"><img src="content/images/icons/shrink.svg" alt=""></span><span class="trash" ng-click="deleteImage()"><img src="content/images/icons/delete.svg" alt=""></span></div><div class="template-carousel" ng-style="{width:dWidth*0.8}"><ul class="carousel5" ng-style="{width:dWidth*0.8*template.pages.page.length}"><li ng-repeat="slide in template.pages.page track by $index" data-index="{{$index}}" class="slide-li" id="slide{{$index}}" ng-init="outerIndex = $index"><div class="slide-content" ng-style="{\n                            width:dWidth*0.8,\n                            height:dWidth*0.8*slide.height/slide.width-1\n                         }"><!--\u80CC\u666F\u5C42--> <img ng-src="{{slide.bgImg}}" class="background backgroundImg{{$index}} indexSet-700" id="backgroundImg{{$index}}" crossorigin="Anonymous" origin="*" data-index="{{$index}}" ng-style="{\n                                 width:dWidth*0.8,\n                                 position:\'absolute\'\n                             }"><!--\u8D34\u7EB8\u5C42--><div class="sticker-edit-box" ng-repeat="sticker in slide.imagearts.imageart track by $index" ng-click="editSticker($event, $index)" data-index="{{$index}}" ng-class="{\'selecteds\': sticker.zindex == slide.currentZindex}" ng-style="{\n                             \'transform\':\'rotate(\' + sticker.rotation.angle + \'deg)\',\n                             \'-ms-transform\': \'rotate(\' + sticker.rotation.angle + \'deg)\',\n                             \'-moz-transform\': \'rotate(\' + sticker.rotation.angle + \'deg)\',\n                             \'-webkit-transform\': \'rotate(\' + sticker.rotation.angle + \'deg)\',\n                             \'-o-transform\': \'rotate(\' + sticker.rotation.angle + \'deg)\',\n                             \'width\': sticker.geometry.width,\n                             \'left\': sticker.geometry.x,\n                             \'top\': sticker.geometry.y,\n                             \'z-index\': sticker.zindex + slide.imageboxes.imagebox.length+900}"><span ng-click="deleteSticker($event, $index)" class="delete-text" ng-show="sticker.zindex == slide.currentZindex"></span><!--<span data-index="{{$index}}" ontouchstart="resizeStickerStart(event)" ontouchmove="resizeStickerOn(event)" ontouchend="resizeStickerEnd()" class="resize-sticker">--><!--<img src="content/images/sticker-resize.png"/>--><!--</span>--> <img id="select-sticker-{{$index}}" ontouchstart="moveStickerStart(event)" ng-style="{width:sticker.geometry.width}" ontouchmove="moveStickerOn(event)" ontouchend="moveStickerEnd()" ng-src="{{sticker.imgUrl}}"></div><!--\u56FE\u7247\u6846\u5217\u8868\u5904\u7406--><div class="select-img-box diy-box place-holder indexSet-800" id="imgBox{{outerIndex}}{{$index}}" ng-repeat="imgInput in slide.imageboxes.imagebox track by $index" ng-style="{\n                                 \'width\': imgInput.geometry.width,\n                                 \'height\':imgInput.geometry.height,\n                                 \'left\': imgInput.geometry.x,\n                                 \'top\': imgInput.geometry.y,\n                                 \'transform-origin\': \'left bottom\',\n                                 \'transform\': \'rotate(-\' + imgInput.rotation.angle + \'deg)\'\n                             }"><div class="img-place-holder indexSet-800" ng-hide="imgInput.image.resource.identifier">+</div><div class="relative-box"><div class="upload choose-img-box indexSet-800" ng-click="chooseImage(imgInput, $event,$parent.$index, $index)" ng-hide="imgInput.image.resource.identifier"></div><img id="imgInput{{outerIndex}}{{$index}}" class="indexSet-800 imgMask{{outerIndex}}{{$index}} test" data-imgindex="{{$index}}" crossorigin="Anonymous" ontouchstart="startDrag(event)" ontouchmove="dragImage(event)" ontouchend="stopDrag(event)" ng-style="{\n                                        \'opacity\': 0,\n                                        \'width\': imgInput.geometry.width,\n                                        \'height\':imgInput.geometry.height,\n                                        \'left\': imgInput.geometry.x,\n                                        \'top\': imgInput.geometry.y,\n                                        \'transform-origin\': \'left bottom\'}"></div></div><img id="imgInputHolder{{outerIndex}}{{$index}}" class="indexSet-700 abso imgHold{{outerIndex}}{{$index}}" ng-repeat="imgInput in slide.imageboxes.imagebox track by $index" ng-show="imgInput.image.resource.identifier" ng-style="{\n                                        \'width\': imgInput.geometry.width,\n                                        \'height\':imgInput.geometry.height,\n                                        \'left\': imgInput.geometry.x,\n                                        \'top\': imgInput.geometry.y,\n                                        \'transform-origin\': \'left bottom\',\n                                        \'transform\': \'rotate(-\' + imgInput.rotation.angle + \'deg)\'}"><div class="select-img-box diy-box indexSet-700" ng-repeat="imgInput in slide.imageboxes.imagebox track by $index" ng-style="{\n                                 \'width\': imgInput.geometry.width+2,\n                                 \'height\':imgInput.geometry.height+2,\n                                 \'left\': imgInput.geometry.x,\n                                 \'top\': imgInput.geometry.y,\n                                 \'border\':imgInput.image.resource.identifier?\'none\':\'1px solid #CBCBCB\',\n                                 \'transform-origin\': \'left bottom\',\n                                 \'transform\': \'rotate(-\' + imgInput.rotation.angle + \'deg)\'\n                             }"><div class="relative-box"><img id="imgInputReal{{outerIndex}}{{$index}}" class="real-img imgBox{{outerIndex}}{{$index}}" crossorigin="Anonymous" data-imgindex="{{$index}}" ontouchstart="startDrag(event)" ontouchmove="dragImage(event)" ontouchend="stopDrag(event)" ng-style="{\n                                        \'width\': imgInput.geometry.width,\n                                        \'height\':imgInput.geometry.height,\n                                        \'left\': imgInput.geometry.x,\n                                        \'top\': imgInput.geometry.y,\n                                        \'transform-origin\': \'left bottom\'}"></div></div><!--\u56FE\u7247\u6846\u5217\u8868\u7ED3\u675F--><!--\u6587\u5B57\u6846\u5217\u8868--><div class="text-box" ng-repeat="text in slide.textboxes.textbox track by $index" ng-class="{\'selecteds\': text.zindex == slide.currentZindex,\'no-border\':text.status==\'static\'}" data-index="{{$index}}" ontouchstart="moveTextBoxStart(event)" ontouchmove="moveTextBoxOn(event)" ontouchend="moveTextBoxEnd()" style="transform-origin: left bottom" ng-style="{\n                            top: text.geometry.y,\n                            left: text.geometry.x-6,\n                            width: text.geometry.width+12,\n                            height: text.geometry.height==null?24: text.geometry.height<24?24:text.geometry.height,\n                            color: text.style.color,\n                            \'font-size\': text.style.size,\n                            \'font-family\': text.style.font,\n                            \'transform\': \'rotate(-\' + text.rotation.angle + \'deg)\',\n                            \'z-index\': text.zindex + slide.imageboxes.imagebox.length+900\n                        }"><img class="text-img{{$index}}" ng-src="{{text.picCode}}" style="position: absolute;top:0" ng-style="{width:text.geometry.width}" ng-if="text.picCode!=\'\'"><p class="text-content text-p{{$index}}" style="height: auto;text-indent: 6px" ng-if="text.picCode==\'\'">\u8BF7\u8F93\u5165\u6587\u5B57</p><span class="delete-text" ng-show="text.zindex == slide.currentZindex&&text.type==\'dynamic\'" data-index="{{$index}}" ng-click="deleteSelectedText($event, $index)"></span> <span class="edit-text" ng-show="text.zindex == slide.currentZindex&&(text.status==\'dynamic\'||text.type==\'dynamic\')" ng-click="editTextContent($event, $index,text)"></span> <span class="resize-text" ng-show="text.zindex == slide.currentZindex&&text.type==\'dynamic\'" data-index="{{$index}}" ontouchstart="resizeTextBoxStart(event)" ontouchmove="resizeTextBoxOn(event)" ontouchend="resizeTextBoxEnd()"></span></div><div ng-repeat="text in slide.textboxes.textbox track by $index" class="text-hidden{{$index}}" ng-style="{\n                            color: text.style.color,\n                            \'font-size\': text.style.size,\n                            \'font-family\': text.style.font,\n                            \'z-index\': text.zindex + slide.imageboxes.imagebox.length+900,\n                            \'position\':\'absolute\',\n                            \'white-space\':\'nowrap\',\n                            opacity:0}"></div><!--\u6587\u5B57\u6846\u5217\u8868\u7ED3\u675F--></div></li></ul><!--<div rn-carousel-nav="" ng-if="slides.length &gt; 1" slides="slides" rn-carousel-index="carouselIndex"--><!--class="ng-scope ng-isolate-scope">--><!--</div>--></div><button class="rightBtn rr{{$index}}" ng-click="pageRight()" ng-hide="visibleRight"><img src="content/images/icons/right.svg"></button></div><div class="text-modal" ng-show="showTextModal"><div class="input-wrapper"><input id="textInputArea" type="text" ng-model="textContent" placeholder="\u8BF7\u8F93\u5165\u6587\u5B57"></div><div class="btn-diy-primary btn-w-8" ng-click="closeTextModal()">\u5B8C\u6210\u8F93\u5165</div></div><div class="canvas-container"></div><!--\u5E95\u90E8\u83DC\u5355--><div class="fix-bottom-section"><!--\u7ED8\u56FE\u83DC\u5355--><div class="sketch-menu" ng-show="showSketchMenu && template.pages.page[currentCarouselIndex].sketchObject && template.pages.page[currentCarouselIndex].sketchObject.hasCanvasInit" ng-class="{\'hide\': !showSketchMenu}" ng-style="{\'height\': showSketchMenu? \'76\' : 0}"><!--\u989C\u8272\u9009\u62E9--><div class="color-picker-bar diy-row" ng-show="selectSketchMenu == \'sketch-color\'"><span class="color-item col-xs-1" ng-repeat="color in colorList" ng-click="selectColor(color)" ng-style="{\n                \'background-color\': color,\n                \'width\': 100/colorList.length + \'vw\',\n                \'padding\': \'0px\'}">{{selectedColor == color ? \'\u2713\' : \'\'}}</span></div><!--\u7C97\u7EC6\u9009\u62E9--> <span class="line-picker-bar diy-row" ng-show="selectSketchMenu != \'sketch-color\'"><span class="circle-item" ng-repeat="line in lineList track by $index" ng-class="{\'selected\': selectLine == line}" ng-click="selectLineSize(line)" ng-style="{\'width\': line - $index*2 - 2 , \'height\': line - $index*2 - 2}"></span> </span><!--\u989C\u8272\u7C97\u7EC6\u6A61\u76AE\u64E6\u5207\u6362\u83DC\u5355--><div class="sketch-nav diy-row"><div class="col-xs-4" ng-class="{\'selected\': selectSketchMenu == \'sketch-color\'}" ng-click="selectSketchMenu = \'sketch-color\'"><img ng-src="{{selectSketchMenu == \'sketch-color\'? \'content/images/icons/color-sel.svg\' : \'content/images/icons/color.svg\'}}"> <span ng-class="{\'menu-title\':selectSketchMenu == \'sketch-color\'}">\u989C\u8272</span></div><div class="col-xs-4 line" ng-class="{\'selected\': selectSketchMenu == \'sketch-line\'}" ng-click="selectSketchMenu = \'sketch-line\'"><img ng-src="{{selectSketchMenu == \'sketch-line\'? \'content/images/icons/line-selected.png\': \'content/images/icons/line.png\'}}"> <span ng-class="{\'menu-title\':selectSketchMenu == \'sketch-line\'}">\u7C97\u7EC6</span></div><div class="col-xs-4" ng-class="{\'selected\': selectSketchMenu == \'sketch-eraser\'}" ng-click="selectSketchMenu = \'sketch-eraser\'"><img ng-src="{{selectSketchMenu == \'sketch-eraser\'? \'content/images/icons/eraser-selected.png\': \'content/images/icons/eraser.png\'}}"> <span ng-class="{\'menu-title\':selectSketchMenu == \'sketch-eraser\'}">\u6A61\u76AE\u64E6</span></div></div></div><!--\u7ED8\u56FE\u83DC\u5355\u7ED3\u675F--><!--\u8D34\u7EB8\u83DC\u5355--><div class="sticker-menu" ng-show="showStickerMenu" ng-style="{\'height\': showStickerMenu? \'68\' : 0}"><div class="sticker-wrapper" ng-style="{\'height\': showStickerMenu? \'68\' : 0}"><span class="sticker-box" ng-repeat="sticker in stickerList | orderBy: \'sort\'"><img ng-src="{{sticker.imgUrl}}" ng-click="addSticker($event,sticker,$index)" ng-style="{\'width\': 60}"></span></div></div><!--\u6587\u5B57\u83DC\u5355--><div class="text-menu" ng-show="showTextMenu"><!--\u989C\u8272/\u5B57\u4F53\u5207\u6362\u83DC\u5355--><div class="sketch-nav diy-row"><div class="col-xs-6 mar-top-8" ng-class="{\'selected\': selectSketchMenu == \'sketch-color\'}" ng-click="selectSketchMenu = \'sketch-color\';"><img ng-src="{{selectSketchMenu == \'sketch-color\'? \'content/images/icons/color-sel.svg\' : \'content/images/icons/color.svg\'}}"> <span ng-class="{\'menu-title\':selectSketchMenu == \'sketch-color\'}">\u989C\u8272</span></div><div class="col-xs-6 line mar-top-8" ng-class="{\'selected\': selectSketchMenu == \'sketch-line\'}" ng-click="selectSketchMenu = \'sketch-line\';"><img ng-src="{{selectSketchMenu == \'sketch-line\'? \'content/images/icons/text-sel.svg\': \'content/images/icons/text.svg\'}}"> <span ng-class="{\'menu-title\':selectSketchMenu == \'sketch-line\'}">\u5B57\u4F53</span></div></div><!--\u989C\u8272\u9009\u62E9--> <span class="color-picker-bar diy-row" ng-show="selectSketchMenu == \'sketch-color\'"><span class="color-item" ng-repeat="color in colorList" ng-click="selectTextColor(color)" ng-style="{\n                      background:selectedColor == color?\'\':color,\n                \'border\':\'1px solid \'+color}"><!--{{selectedColor == color ? \'\u2713\' : \'\'}}--> <i ng-style="{background:color}" ng-show="selectedColor == color"></i> </span></span><!--\u5B57\u4F53\u9009\u62E9--> <span class="font-picker-bar diy-row pad-top-0" ng-show="selectSketchMenu != \'sketch-color\'"><input id="multiPickerInput" type="text" placeholder="+ \u8BF7\u9009\u62E9\u5B57\u4F53" value=""><div id="targetContainer"></div></span></div><!--\u5E95\u90E8\u529F\u80FD\u83DC\u5355--><div class="bottom-bar diy-row"><span class="col-xs-4" ng-class="{\'selected\': showStickerMenu}" ng-click="toggleStickerMenu($event)"><img ng-src="{{showStickerMenu? \'content/images/icons/sucai-selected.svg\' : \'content/images/icons/sucai-unselected.svg\'}}">\u7D20\u6750 </span><!--<span class="col-xs-3" ng-class="{\'selected\': showSketchMenu}" ng-click="toggleSketch($event)">--><!--<img ng-src="{{showSketchMenu? \'content/images/icons/sketch-selected.png\' : \'content/images/icons/sketch.png\'}}"/>\u6D82\u9E26</span>--> <span class="col-xs-4" ng-class="{\'selected\': showTextMenu}" ng-click="toggleTextMenu($event)" ng-show="fontList"><img class="text-icon" ng-src="{{showTextMenu? \'content/images/icons/text-selected.svg\' : \'content/images/icons/text-unselected.svg\'}}">\u6587\u5B57</span> <span class="col-xs-4" ng-click="saveWork()"><img ng-src="{{selectMenu == \'menu-save\'? \'content/images/icons/save-selected.svg\' : \'content/images/icons/save-unselected.svg\'}}">\u4FDD\u5B58</span></div></div></div>');
$templateCache.put('app/entities/product-ec/product-view.html','<div ng-hide="musicPage||viewPage" style="padding: 30px 0"><div class="back-to-customer" ng-style="{width:dWidth}"><!--<img src="content/images/icons/back_orange.svg" ng-click="goToCustomer()">--> <span class="arrowPrev arrow-prev opacityMinus" ng-click="goToCustomer()" ng-if="vm.returnurl1"></span><!--<span style="color: #3e3e3e;font-size: 16px;margin-left: 24vw" ng-click="viewPage=!viewPage">--><!--\u66F4\u6362\u9884\u89C8\u65B9\u5F0F--><!--</span>--><!--<i style="background:url(\'content/images/icons/arrow_down.svg\')no-repeat center;padding: 12px;"></i>--><audio id="audio" autoplay loop>{{\'editorCommon.nonsupportMusic\' | translate}}</audio><span class="PanelRight" ng-show="!vm.isHideMusicBtn"><span id="Play" class="Play"><img class="icon pause" id="music-icon" src="content/images/icons/ic_music2.svg"></span></span></div><div class="col-lg-12 col-sm-12 col-xs-12 infoWaring flex-btn-group-container tip-image" style="background: #f6f7f9;padding: 0 10px;font-size: 12px;z-index:400" ng-if="vm.message.length"><img src="content/images/icons/notice.svg" alt="" style="width:24px;height:24px;margin-right:5px;margin-top: 4px"><marquee scrollamount="2" height="30" behavior="scroll" direction="left" align="left" style="width: 100%;line-height: 30px">{{vm.messageText}}</marquee></div><img src="content/images/view_bg.png" class="bg-fixed" ng-if="!vm.toneSettings.previewBkMobile"> <img ng-src="{{vm.toneSettings.previewBkMobile}}" class="bg-fixed" alt="" ng-if="vm.toneSettings.previewBkMobile"><article-preview article="vm.article" document-page="vm.documentPage" editor-type="vm.article.editorType" bindingtype="vm.itemValue.bindingType" is-landscape="true" ng-if="vm.itemValue && vm.documentPage && (!vm.itemValue.bindingType || vm.itemValue.bindingType != \'LeftNew\')"></article-preview><editor-preview-mini article="vm.article" document-page="vm.documentPage" ng-if="vm.itemValue.bindingType === \'LeftNew\' && vm.documentPage && vm.article"></editor-preview-mini><div class="fix-bottom-section" style="z-index: 998;font-size: 15px" ng-hide="!hideEdit"><div class="edit-menu1" ng-show="showEditMenu &&(!disableTemplate) && vm.article && vm.article.productXmlId"><div class="diy-row opacityMinus" style="height: 50px!important;line-height: 50px"><span ng-click="editWork()">{{\'button.amend\' | translate}}</span></div></div><!-- <div class="bottom-bar diy-row" ng-hide="disableTemplate"> --><div class="col-md-12 col-sm-12 col-xs-12 no-padding flex-btn-group-container" ng-hide="disableTemplate" style="height: 48px; text-align: center"><div class="flex-1" style="height: 100%;color: var(--mobileTextSelectedColor)" ng-if="vm.returnurl" ng-click="toggleEditMenu($event)"><i class="icon iconfont iconbianji"></i> <span ng-class="{\'selected\': showEditMenu}" style="font-size: 11px;  padding-left: 0px; padding-right: 0px">{{\'button.edit\' | translate}}</span></div><div class="flex-1" style="height: 100%; padding-left: 0px" ng-if="!vm.isHideMusicBtn" ng-click="openMusicList()"><i class="icon iconfont iconyinlemusic215"></i> <span style="font-size: 11px; color: var(--mobileTextSelectedColor); padding-left: 0px; padding-right: 0px">{{\'button.music\' | translate}}</span></div><div class="product-order" ng-if="(vm.article.articleId || vm.article.articleStatus==\'COMPLETED\')&&vm.returnurl2" ng-click="gotoOrder()"><div style="width: 100%; height: 40px; border-radius: 20px; background-color: var(--mobileButtonBackColor); margin-top: 4px; line-height: 40px"><span class="opacityMinus" ng-click="orderNow()" style="color: #ffffff">{{orderFlag}}</span></div></div></div></div><!--\u5F15\u5BFC\u9875--><div class="save-pages" ng-click="nextStep()" ng-if="!vm.share"><div style="float: right;margin:10px 20px 0 0;width: 125px;display: flex;align-items: center;justify-content: center;flex-direction: column;text-align: center"><img src="content/images/share2.png" style="width: 100%"><div style="color: #ffffff"><div>{{\'hint.clickRT\' | translate}}</div><div>{{\'hint.shareYourWork\' | translate}}</div></div></div><div class="next-step" ng-click="nextStep()">{{\'hint.gotIt\' | translate}}</div></div></div><div ng-show="musicPage"><div class="top-menu" style="box-shadow: 0 2px 5px rgba(187, 187, 187, 0.6)"><div class="index-back"><span class="opacityMinus" ng-click="backTo()"><div class="tabIcons back-work"></div></span></div><div class="floatRight commit-div edit-save" ng-click="saveMusic()">{{\'button.confirm\' | translate}}</div></div><audio id="audition" autoplay></audio><ul class="music-list"><li ng-repeat="music in Musics track by $index" ng-click="playList(music.identify,$index)" class="music-li{{$index}} music-li"><div class="music-name{{$index}} music-name">{{music.name}}</div><img src="content/images/icons/music-i.svg" class="music-icon{{$index}} music-icon"> <span class="music-current{{$index}} music-current">{{\'editorCommon.currentMusic\' | translate}}</span></li></ul></div>');
$templateCache.put('app/entities/product-ec/product-view2.html','<div class="view-bookBg view-bg" style="position: absolute; top: 0; left: 0;z-index: 1"><audio id="audio" autoplay loop>{{\'editorCommon.nonsupportMusic\' | translate}}</audio><span class="PanelRight" ng-show="!vm.isHideMusicBtn"><span id="Play" class="Play"><img class="icon pause" id="music-icon" src="content/images/icons/ic_music2.svg"></span></span></div><img ng-src="{{vm.toneSettings.previewBkMobile}}" class="bg-fixed" alt="" ng-if="vm.toneSettings.previewBkMobile"><div style="width: 100vw; height: 100vh; background: #f3f3f3"><article-preview article="vm.article" document-page="vm.documentPage" editor-type="vm.article.editorType" bindingtype="vm.itemValue.bindingType" is-landscape="true" ng-if="vm.itemValue && vm.documentPage && (!vm.itemValue.bindingType || vm.itemValue.bindingType != \'LeftNew\')"></article-preview><editor-preview-mini article="vm.article" document-page="vm.documentPage" ng-if="vm.itemValue.bindingType === \'LeftNew\' && vm.documentPage && vm.article"></editor-preview-mini></div><div class="share-wrap" ng-show="!!vm.aid" style="width: 100vw;overflow: hidden"><div class="share-book col-lg-12 col-sm-12 col-xs-12 pad-0 text-default"><div class="share-left col-lg-3 col-sm-3 col-xs-3 pad-0"><img src="content/images/hua.png" style="width: 80px"></div><div class="share-right col-lg-9 col-sm-9 col-xs-9 pad-right-20 pad-left-0"><h2 class="share-title">{{\'editorCommon.describe16\' | translate}}</h2><p>{{\'editorCommon.describe17\' | translate}}</p><p>{{\'editorCommon.describe18\' | translate}}</p><p>{{\'editorCommon.describe19\' | translate}}</p></div></div><div class="col-lg-12 col-sm-12 col-xs-12 mar-top-20 pad-right-20" style="height:110px;overflow: hidden"><div class="col-lg-6 col-sm-6 col-xs-6 text-right no-padding text-default" style="position: absolute;bottom:6px"><div>{{\'editorCommon.describe20\' | translate}}</div><div>{{\'editorCommon.describe21\' | translate}}</div></div><div class="col-lg-5 col-sm-5 col-xs-5" style="position: absolute;bottom:0;right:0;height: 110px;padding-top: 5px"><img ng-show="miniType" src="{{image}}" style="position: absolute; height: 100px"><div ng-show="!miniType" id="qrcode" style="width: 100%; height:100px"><img src="content/images/trans_bg.jpg" style="opacity: 0;position: absolute;bottom:0"></div></div></div></div><div class="c-aid-view">\u4F5C\u54C1ID\uFF1A{{vm.aid}}</div>');
$templateCache.put('app/entities/product-ec/product-viewThree-preview.html','<div class="save-page hide1" ng-cloak><div><img src="content/images/loading.gif"> <span>{{\'hint.pleaseWait\' | translate}}</span></div></div><div class="loading-page"><div class="book"><div class="book__page"><div class="book__page__fill"></div><div class="book__page__fill"></div><div class="book__page__fill"></div><div class="book__page__fill"></div><div class="book__page__fill"></div></div></div><span>{{\'hint.loadingText\' | translate}}</span></div><div class="bg"><div class="view-bookBg view-bg"><img src="content/images/calendar@2x.png" style="width: 100vw"><audio id="audio" autoplay loop>{{\'editorCommon.nonsupportMusic\' | translate}}</audio><span class="PanelRight" ng-show="!vm.isHideMusicBtn"><span id="Play" class="Play"><img class="icon pause" id="music-icon" src="content/images/icons/ic_music2.svg"></span></span></div><div class="view2-article"><div class="main"><div class="bb-custom-wrapper bb-bg"><div class="templateView2-carousel" style="width:100vw"><div ng-if="vm.modelType == \'TWO\'" class="c-productThree3"><div class="c-productThree3-body"><div class="c-productThree3-ul clearfix"><div class="c-productThree3-li" ng-repeat="item in template.pages.page track by $index"><page-preview page="item" scale="item.custom.ratio"></page-preview></div></div></div></div><div ng-if="vm.modelType == \'THREE\'" style="width: 100%; height: 400px"><three-preview style="background: #fff" model-blendent-uuid="vm.article.modelBlendentUuid" product-xml="vm.threeProductXmlData" pages="vm.threeTemplate.pages.page" ng-if="vm.threeView"></three-preview><div style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center; font-size: 16px" ng-if="!vm.threeView"><span>{{\'editorCommon.not3D\' | translate}}</span></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/product-ec/product-viewThree-share.html','<div ng-hide="musicPage"><div class="back-to-customer" ng-style="{width:dWidth}" style="background: none"><!--<img src="content/images/icons/back_orange.svg" ng-click="goToCustomer()">--><!--        <span class="arrowPrev arrow-prev opacityMinus" ng-click="goToCustomer()" ng-if="vm.returnurl1"></span>--><audio id="audio" autoplay loop>{{\'editorCommon.nonsupportMusic\' | translate}}</audio><span class="PanelRight" ng-show="!vm.isHideMusicBtn"><span id="Play" class="Play"><img class="icon pause" id="music-icon" src="content/images/icons/ic_music2.svg"></span></span></div><div class="save-page hide1" ng-cloak><div><img src="content/images/loading.gif"> <span>{{\'hint.pleaseWait\' | translate}}</span></div></div><div class="loading-page"><div class="book"><div class="book__page"><div class="book__page__fill"></div><div class="book__page__fill"></div><div class="book__page__fill"></div><div class="book__page__fill"></div><div class="book__page__fill"></div></div></div><span>{{\'hint.loadingText\' | translate}}</span></div><div class="bg" style="padding-bottom: 50px"><img src="content/images/icon-bg.jpg" class="bg-fixed" ng-if="!vm.toneSettings.previewBkMobile"> <img ng-src="{{vm.toneSettings.previewBkMobile}}" class="bg-fixed" ng-if="vm.toneSettings.previewBkMobile"><!--  \u6A21\u677F\u5C55\u793A\u9875  --><div ng-if="vm.modelType == \'TWO\'" style="margin-top: 70px"><div style="margin: 20px 0;display: flex; flex-wrap: wrap; justify-content: center" ng-repeat="item in template.pages.page track by $index"><page-preview page="item" scale="item.custom.ratio"></page-preview></div></div><div ng-if="vm.modelType == \'THREE\'&&vm.threeView" style="margin-top: 120px"><three-preview4 moulds="vm.product.moulds" model-path="vm.threeProductXmlData.modelPath" model-blendents="vm.threeProductXmlData.modelBlendent" model-data="vm.threeProductXmlData.modelData" model-blendent-uuid="vm.article.modelBlendentUuid" pages="template.pages.page"></three-preview4></div></div><!--    <div class="select-box" ng-show="selectMenuShow && hideEdit">--><!--        <div class="select-wrapper">--><!--            <img class="close-icon" src="content/images/close-white.svg" style="top: -38px;position: absolute" ng-click="closeModal()"/>--><!--            &lt;!&ndash;<div class="first-row">&ndash;&gt;--><!--            <span class="col-md-12 col-sm-12 col-xs-12 no-padding" style="font-size: 16px">--><!--                <p class="col-md-8 col-sm-8 col-xs-8 no-padding" style="color: #232323;">--><!--                    {{\'editorBtn.article\' | translate}}\uFF1A{{vm.article.name}}--><!--                </p>--><!--                <p class="col-md-4 col-sm-4 col-xs-4 categoryPrice text-right no-padding">--><!--                    &yen;{{price.toFixed(2)}}--><!--                </p>--><!--            </span>--><!--            &lt;!&ndash;</div>&ndash;&gt;--><!--            <div class="select-quantity diy-row flexContainer1">--><!--                <span class="title flex1" style="font-size: 14px;color: #232323;">{{\'editorCommon.quantity\' | translate}}</span>--><!--                <div class="quantity-box diy-row" style="width: 200px;">--><!--                    <div style="font-size: 14px;text-align: right;">--><!--                        <span class="color-F6C176 width-50px">&nbsp;&nbsp;{{copy}}&nbsp;&nbsp;</span>--><!--                    </div>--><!--                </div>--><!--            </div>--><!--            <div class="diy-row flex-button">--><!--                <div class="flex1">{{\'editorCommon.sumTo\' | translate}}\uFF1A<span style="font-size: 15px;" class="categoryPrice">&yen;{{(copy * price).toFixed(2)}}</span></div>--><!--                <div class="opacityMinus confirm-flex" ng-show="action != action_orderNow" ng-click="addCart()">{{\'button.confirm\' | translate}}</div>--><!--            </div>--><!--        </div>--><!--    </div>--><!--    <div class="fix-bottom-section" style="z-index: 998;font-size: 15px;" ng-hide="!hideEdit">--><!--        <div class="edit-menu1" ng-show="showEditMenu &&(!disableTemplate)">--><!--            <div class="diy-row opacityMinus" style="height: 50px!important;line-height: 50px;">--><!--                <span ng-click="editWork()">{{\'button.amend\' | translate}} </span>--><!--            </div>--><!--        </div>--><!--        &lt;!&ndash; <div class="bottom-bar diy-row" ng-hide="disableTemplate"> &ndash;&gt;--><!--        <div class="col-md-12 col-sm-12 col-xs-12 no-padding flex-btn-group-container" ng-hide="disableTemplate" style="height: 48px; text-align: center;background: #fff;">--><!--            <div class="flex-1" style="height: 100%; color: var(&#45;&#45;mobileTextSelectedColor);" ng-if="vm.returnurl" ng-click="toggleEditMenu($event)">--><!--                <i class="icon iconfont iconbianji"></i>--><!--                <span ng-class="{\'selected\': showEditMenu}" style="font-size: 11px; padding-left: 0px; padding-right: 0px;">{{\'button.edit\' | translate}} </span>--><!--            </div>--><!--            <div class="flex-1" style="height: 100%; padding-left: 0px;" ng-if="!vm.isHideMusicBtn" ng-click="openMusicList()">--><!--                <i class="icon iconfont iconyinlemusic215"></i>--><!--                <span style="font-size: 11px; color: #717171; padding-left: 0px; padding-right: 0px;">{{\'editorCommon.chooseMusic\' | translate}}</span>--><!--            </div>--><!--            <div class="product-order" ng-if="vm.article.articleStatus==\'COMPLETED\'&&vm.returnurl2">--><!--                <div style="width: 100%; height: 40px; border-radius: 20px; background-color: var(&#45;&#45;mobileButtonBackColor); margin-top: 4px; line-height: 40px;" ng-click="gotoOrder()">--><!--                    <span class="opacityMinus" style="color: #ffffff;">{{orderFlag}}</span>--><!--                </div>--><!--            </div>--><!--        </div>--><!--    </div>--><!--\u5F15\u5BFC\u9875--><!--    <div class="save-pages" ng-click="nextStep()" ng-if="!vm.share">--><!--        <img src="content/images/share2.png" style="float: right;margin:10px 20px 0 0;width: 125px;height: 90px;">--><!--        <div class="next-step" ng-click="nextStep()">{{\'hint.gotIt\' | translate}}</div>--><!--    </div>--></div><!--<div ng-show="musicPage">--><!--    <div class="top-menu" style="--><!--    box-shadow: 0 2px 5px rgba(187, 187, 187, 0.6);">--><!--        <div class="index-back">--><!--        <span class="opacityMinus" ng-click="backTo()">--><!--            <div class="tabIcons back-work"></div>--><!--        </span>--><!--        </div>--><!--        <div class="floatRight commit-div edit-save" ng-click="saveMusic()">{{\'button.confirm\' | translate}}</div>--><!--    </div>--><!--    <audio id="audition" autoplay></audio>--><!--    <ul class="music-list" style="padding-top: 50px;">--><!--        <li ng-repeat="music in Musics track by $index" ng-click="playList(music.identify,$index)" class="music-li{{$index}} music-li">--><!--            <div class="music-name{{$index}} music-name">{{music.name}}</div>--><!--            <img src="content/images/icons/music-i.svg" class="music-icon{{$index}} music-icon">--><!--            <span class="music-current{{$index}} music-current">{{\'editorCommon.currentMusic\' | translate}}</span>--><!--        </li>--><!--    </ul>--><!--</div>--><div class="c-aid-view">\u4F5C\u54C1ID\uFF1A{{vm.aid}}</div>');
$templateCache.put('app/entities/product-ec/product-viewThree.html','<div ng-hide="musicPage"><div class="back-to-customer" ng-style="{width:dWidth}"><!--<img src="content/images/icons/back_orange.svg" ng-click="goToCustomer()">--> <span class="arrowPrev arrow-prev opacityMinus" ng-click="goToCustomer()" ng-if="vm.returnurl1"></span><audio id="audio" autoplay loop>{{\'editorCommon.nonsupportMusic\' | translate}}</audio><span class="PanelRight" ng-show="!vm.isHideMusicBtn"><span id="Play" class="Play"><img class="icon pause" id="music-icon" src="content/images/icons/ic_music2.svg"></span></span></div><div class="save-page hide1" ng-cloak><div><img src="content/images/loading.gif"> <span>{{\'hint.pleaseWait\' | translate}}</span></div></div><div class="loading-page"><div class="book"><div class="book__page"><div class="book__page__fill"></div><div class="book__page__fill"></div><div class="book__page__fill"></div><div class="book__page__fill"></div><div class="book__page__fill"></div></div></div><span>{{\'hint.loadingText\' | translate}}</span></div><div class="bg" style="padding-bottom: 50px"><img src="content/images/icon-bg.jpg" class="bg-fixed" ng-if="!vm.toneSettings.previewBkMobile"> <img ng-src="{{vm.toneSettings.previewBkMobile}}" class="bg-fixed" ng-if="vm.toneSettings.previewBkMobile"><!--  \u6A21\u677F\u5C55\u793A\u9875  --><div ng-if="vm.modelType == \'TWO\'" style="margin-top: 70px"><div style="margin: 20px 0;display: flex; flex-wrap: wrap; justify-content: center" ng-repeat="item in template.pages.page track by $index"><page-preview page="item" scale="item.custom.ratio"></page-preview></div></div><div ng-if="vm.modelType == \'THREE\'&&vm.threeView" style="margin-top: 120px"><three-preview4 moulds="vm.product.moulds" model-path="vm.threeProductXmlData.modelPath" model-blendents="vm.threeProductXmlData.modelBlendent" model-data="vm.threeProductXmlData.modelData" model-blendent-uuid="vm.article.modelBlendentUuid" pages="template.pages.page"></three-preview4></div></div><div class="select-box" ng-show="selectMenuShow && hideEdit"><div class="select-wrapper"><img class="close-icon" src="content/images/close-white.svg" style="top: -38px;position: absolute" ng-click="closeModal()"><!--<div class="first-row">--> <span class="col-md-12 col-sm-12 col-xs-12 no-padding" style="font-size: 16px"><p class="col-md-8 col-sm-8 col-xs-8 no-padding" style="color: #232323">{{\'editorBtn.article\' | translate}}\uFF1A{{vm.article.name}}</p><p class="col-md-4 col-sm-4 col-xs-4 categoryPrice text-right no-padding">&yen;{{price.toFixed(2)}}</p></span><!--</div>--><div class="select-quantity diy-row flexContainer1"><span class="title flex1" style="font-size: 14px;color: #232323">{{\'editorCommon.quantity\' | translate}}</span><div class="quantity-box diy-row" style="width: 200px"><div style="font-size: 14px;text-align: right"><span class="color-F6C176 width-50px">&nbsp;&nbsp;{{copy}}&nbsp;&nbsp;</span></div></div></div><div class="diy-row flex-button"><div class="flex1">{{\'editorCommon.sumTo\' | translate}}\uFF1A<span style="font-size: 15px" class="categoryPrice">&yen;{{(copy * price).toFixed(2)}}</span></div><div class="opacityMinus confirm-flex" ng-show="action != action_orderNow" ng-click="addCart()">{{\'button.confirm\' | translate}}</div></div></div></div><div class="fix-bottom-section" style="z-index: 998;font-size: 15px" ng-hide="!hideEdit"><div class="edit-menu1" ng-show="showEditMenu &&(!disableTemplate)"><div class="diy-row opacityMinus" style="height: 50px!important;line-height: 50px"><span ng-click="editWork()">{{\'button.amend\' | translate}}</span></div></div><!-- <div class="bottom-bar diy-row" ng-hide="disableTemplate"> --><div class="col-md-12 col-sm-12 col-xs-12 no-padding flex-btn-group-container" ng-hide="disableTemplate" style="height: 48px; text-align: center;background: #fff"><div class="flex-1" style="height: 100%; color: var(--mobileTextSelectedColor)" ng-if="vm.returnurl" ng-click="toggleEditMenu($event)"><i class="icon iconfont iconbianji"></i> <span ng-class="{\'selected\': showEditMenu}" style="font-size: 11px; padding-left: 0px; padding-right: 0px">{{\'button.edit\' | translate}}</span></div><div class="flex-1" style="height: 100%; padding-left: 0px" ng-if="!vm.isHideMusicBtn" ng-click="openMusicList()"><i class="icon iconfont iconyinlemusic215"></i> <span style="font-size: 11px; color: #717171; padding-left: 0px; padding-right: 0px">{{\'editorCommon.chooseMusic\' | translate}}</span></div><div class="product-order" ng-if="(vm.article.articleId || vm.article.articleStatus==\'COMPLETED\')&&vm.returnurl2"><div style="width: 100%; height: 40px; border-radius: 20px; background-color: var(--mobileButtonBackColor); margin-top: 4px; line-height: 40px" ng-click="gotoOrder()"><span class="opacityMinus" style="color: #ffffff">{{orderFlag}}</span></div></div></div></div><!--\u5F15\u5BFC\u9875--><div class="save-pages" ng-click="nextStep()" ng-if="!vm.share"><img src="content/images/share2.png" style="float: right;margin:10px 20px 0 0;width: 125px;height: 90px"><div class="next-step" ng-click="nextStep()">{{\'hint.gotIt\' | translate}}</div></div></div><div ng-show="musicPage"><div class="top-menu" style="box-shadow: 0 2px 5px rgba(187, 187, 187, 0.6)"><div class="index-back"><span class="opacityMinus" ng-click="backTo()"><div class="tabIcons back-work"></div></span></div><div class="floatRight commit-div edit-save" ng-click="saveMusic()">{{\'button.confirm\' | translate}}</div></div><audio id="audition" autoplay></audio><ul class="music-list" style="padding-top: 50px"><li ng-repeat="music in Musics track by $index" ng-click="playList(music.identify,$index)" class="music-li{{$index}} music-li"><div class="music-name{{$index}} music-name">{{music.name}}</div><img src="content/images/icons/music-i.svg" class="music-icon{{$index}} music-icon"> <span class="music-current{{$index}} music-current">{{\'editorCommon.currentMusic\' | translate}}</span></li></ul></div>');
$templateCache.put('app/entities/product-ec/products.html','<div class="z-modal" ng-if="bigSizeTip"><div class="z-modal-body3"><div class="z-modal-body3-title">{{"choose.editor.bigPictureTitle" | translate}}</div><div class="z-modal-body-icon"><img src="content/images/high_size.png" width="65%"></div><div class="z-modal-body3-tip" translate="choose.editor.editorMessage" translate-values="{higherSizeLen:higherSizeLen}"></div><div class="z-modal-body3-confirm" ng-click="filterBigSize()">{{"choose.editor.confirm" | translate}}</div></div></div><div ng-style="{width:dWidth}" ng-show="status==\'start\'" style="position: absolute;top: 0;left: 0; bottom: 0px; background: #FFF"><div class="choose_header col-md-12 col-sm-12 pad-0" ng-show="!choose"><div class="show_counts col-lg-12 col-sm-12 col-xs-12" ng-hide="qiniuId.length"><!-- \u663E\u793A\u9700\u8981\u5F20\u6570 --> <span translate="choose.editor.workNeedPicture" translate-values="{num:vm.counts}"></span></div><div class="save-pages hide1"><div class="save-page1"><div class="imgLoading"><div class="loadImg"></div><p class="imgText">{{"choose.editor.photoLoading" | translate}}<br>{{"choose.editor.await" | translate}}</p></div></div></div><div class="show_counts col-lg-12 col-sm-12 col-xs-12" ng-show="qiniuId.length"><!-- \u663E\u793A\u8FD8\u9700\u8981\u4E0A\u4F20n\u5F20--> <span ng-show="multipartUpload" class="prev-btn opacityMinus" ng-click="goBackToProduct()"><span class="arrowPrev arrow-prev"></span> </span><span translate="choose.editor.alreadyPicture" translate-values="{num:qiniuId.length,num2:vm.counts}"></span></div><!--new \u2014\u2014 upload--><div class="choose_btn col-lg-12 col-sm-12 col-xs-12 pad-0"><div class="choose_wx col-lg-6 col-sm-6 col-xs-6 pad-left-10 pad-right-5" ng-if="agentIos" ng-click="chooseWx()"><button class="borderTheme opacityMinus choose-btn-size"><span class="categoryPrice">{{\'choose.editor.wx\' | translate}}</span><!-- \u624B\u673A\u76F8\u518C --></button></div><div class="choose_wx col-lg-6 col-sm-6 col-xs-6 pad-left-10 pad-right-5" ng-if="!agentIos" style="position:relative;display:inline-block; margin-bottom: 10px"><button class="borderTheme opacityMinus choose-btn-size"><span class="categoryPrice">{{\'choose.editor.wx\' | translate}}</span><!-- \u624B\u673A\u76F8\u518C --> <input onchange="uploadPicMutiple(event)" id="uploadImg2" type="file" multiple="multiple" accept="{{vm.supportedMimeTypes}}" name="file" value="" style="opacity:0; position:absolute;top:0;left:0"></button></div><div class="choose_gallery col-lg-6 col-sm-6 col-xs-6 pad-left-5 pad-right-10" ng-click="showGallery()" style="margin-bottom: 10px"><button class="borderTheme opacityMinus choose-btn-size"><span class="categoryPrice">{{\'choose.editor.gallery\' | translate}}</span><!-- \u5DF2\u4F20\u56FE\u7247 --></button></div><div class="col-lg-12 col-sm-12 col-xs-12 infoWaring flex-btn-group-container" style="background: #f6f7f9;padding: 0 10px;font-size: 12px;z-index:1" ng-if="vm.messageGallery.length"><img src="content/images/icons/notice.svg" alt="" style="width:24px;height:24px;margin-right:5px;margin-top: 4px"><marquee scrollamount="2" height="30" behavior="scroll" direction="left" align="left" style="width: 100%;line-height: 30px">{{vm.messageGalleryText}}</marquee></div></div></div><!--\u9879\u76EE\u5E93\u4E3A\u7A7A--><div class="choose_none bg" ng-hide="qiniuId.length" ng-style="{\'padding-top\':choose?\'0\':\'172px\'}"><div ng-class="choose ?\'fixPhoto\' :\'\'"><span class="nonePic nonePhoto" ng-style="{\'margin\':choose?\'0 auto\':\'20vh auto 0\'}"></span><div>{{\'choose.editor.noPicTips\' | translate}}</div><!-- \u9879\u76EE\u5E93\u8FD8\u6CA1\u6709\u7167\u7247\uFF0C\u8BF7\u4E0A\u4F20\u7167\u7247 --></div></div><div class="choose_pic col-md-12 col-sm-12 col-xs-12 no-padding" ng-show="qiniuId.length" ng-style="{\'margin-top\':choose?\'70px\':vm.messageGallery.length?\'186px\':\'136px\'}"><!--edit--><div class="save-pages hide1"><div class="save-page1"><div class="imgLoading"><div class="loadImg"></div><p class="imgText">{{"choose.editor.photoLoading" | translate}}<br>{{"choose.editor.await" | translate}}</p></div></div></div><div class="col-md-12 col-sm-12 col-xs-12 no-padding border-bottom photoOperate" ng-show="choose"><div class="btn-pic"><span class="prev-btn opacityMinus" ng-click="goBackToProduct()"><span class="arrowPrev arrow-prev"></span></span></div></div><ul class="photos" ng-cloak ng-show="choose" ng-style="{\'margin-top\':choose?\'124px\':\'0\'}"><li ng-repeat="photo in qiniuId | orderBy: $index track by $index" class="photo-content opacityMinus" ng-click="singleTo(photo.identifier,photo,$index)"><img ng-src="{{photo.identifier+\'?imageView2/1/w/150/h/150\'||\'//:0\'}}" alt="" ng-style="{opacity:1-(photo.usenum>3?3:photo.usenum)*0.2, \'-ms-filter\': \'alpha(opacity=\'+100-(photo.usenum>3?3:photo.usenum)*20+\')\', \'filter\':\'alpha(opacity=\'+100-(photo.usenum>3?3:photo.usenum)*20+\')\' }" class="imgPhoto" style="pointer-events: none;-webkit-user-select: none;-webkit-touch-callout: none"><div ng-if="photo.imgSize/1024 < 150 " class="lowerSize"><div style="height: 15vw;line-height: 25vw"><img src="content/images/ic_pixel2.svg" alt="" ontouchstart="return false;" style="pointer-events: none;-webkit-user-select: none;-webkit-touch-callout: none"></div><div style="height: 15vw;line-height: 15vw">{{"choose.editor.lackofPixels" | translate}}</div></div><div class="use-account diy-btn-primarys"><!-- \u4F7F\u7528\u6B21\u6570 --> <span>{{photo.usenum}}{{"choose.editor.once" | translate}}</span></div></li></ul><!--new--><ul class="photos" ng-cloak ng-show="!choose"><li ng-repeat="photo in qiniuId | orderBy: $index track by $index" class="photo-content"><img ng-src="{{photo.identifier+\'?imageView2/1/w/150/h/150\'||\'//:0\'}}" alt="" class="imgPhoto" style="pointer-events: none;-webkit-user-select: none;-webkit-touch-callout: none"><div class="photo-del opacityMinus" ng-click="delPhoto(photo,$index)"><img src="content/images/icons/delete2.svg" ontouchstart="return false;" style="width: 100%;pointer-events: none;-webkit-user-select: none;-webkit-touch-callout: none"></div><div ng-if="photo.imgSize/1024 < 150 " class="lowerSize"><div style="height: 15vw;line-height: 25vw"><img src="content/images/ic_pixel2.svg" alt="" style="pointer-events: none;-webkit-user-select: none;-webkit-touch-callout: none"></div><div style="height: 15vw;line-height: 15vw">{{"choose.editor.lackofPixels" | translate}}</div></div></li></ul></div><div class="footer_bar col-md-12 col-sm-12 col-xs-12 no-padding" ng-show="!choose"><div class="col-md-12 col-sm-12 col-xs-12 no-padding flex-btn-group-container"><div class="opacityMinus flex-1" ng-click="photoSort()"><i class="icon iconfont iconpaixu default-btncolor-mobile"></i><!--                <img src="content/images/photo-sort.svg" alt="\u7167\u7247\u6392\u5E8F"/>--> <span class="size-foot categoryPrice">{{\'choose.editor.photoSort\' | translate}}</span><!-- \u7167\u7247\u6392\u5E8F --></div><div class="opacityMinus flex-1" ng-click="nextTo()"><i class="icon iconfont iconbianji default-btncolor-mobile"></i><!--                <img src="content/images/single-make.svg" alt="\u5355\u9875\u5236\u4F5C"/>--> <span class="size-foot categoryPrice">{{\'choose.editor.next\' | translate}}</span><!-- \u5355\u9875\u5236\u4F5C --></div><div class="opacityMinus product-go diy-btn-primarys" ng-click="goTo()"><span>{{\'choose.editor.go\' | translate}}</span><!-- \u4E00\u952E\u6210\u4E66 --></div></div><div class="iphoneX-content col-md-12 col-sm-12 col-xs-12 no-padding"></div></div><!--edit\u2014\u2014 upload --><div class="choose_header col-md-12 col-sm-12 pad-0" ng-show="choose"><div class="show_counts col-lg-12 col-sm-12 col-xs-12"><!-- \u663E\u793A\u9700\u8981\u5F20\u6570 --> <span style="font-size: 14px;position: absolute; left: 0; top: 4px;right: 0;z-index: -1" translate="choose.editor.workNeedPicture" translate-values="{num:vm.counts}"><!-- {{\'choose.editor.tips1\' | translate}} <span style="font-size: 16px; font-weight: 600; color: var(--mobileTextSelectedColor);">{{vm.counts}}</span> {{\'choose.editor.tips2\' | translate}} --> </span><span class="prev-btn opacityMinus" ng-click="showStartBtns()"><span class="arrowPrev arrow-prev"></span></span><div class="floatRight commit-div" ng-click="importAddGallery()">{{\'choose.editor.confirm\' | translate}}</div></div><div class="choose_btn col-lg-12 col-sm-12 col-xs-12 pad-0"><div class="choose_wx col-lg-6 col-sm-6 col-xs-6 pad-left-10 pad-right-5" ng-if="agentIos" ng-click="chooseWx()"><button class="borderTheme opacityMinus choose-btn-size"><span class="categoryPrice">{{\'choose.editor.wx\' | translate}}</span></button></div><div class="choose_wx col-lg-6 col-sm-6 col-xs-6 pad-left-10 pad-right-5" ng-if="!agentIos" style="position:relative;display:inline-block; margin-bottom: 10px"><button class="borderTheme opacityMinus choose-btn-size"><span class="categoryPrice">{{\'choose.editor.wx\' | translate}}</span> <input onchange="uploadPicMutiple(event)" id="uploadImg2" type="file" multiple="multiple" accept="{{vm.supportedMimeTypes}}" name="file" value="" style="opacity:0; position:absolute;top:0;left:0"></button></div><div class="choose_gallery col-lg-6 col-sm-6 col-xs-6 pad-left-5 pad-right-10" ng-click="showGallery()"><button class="borderTheme opacityMinus choose-btn-size"><span class="categoryPrice">{{\'choose.editor.gallery\' | translate}}</span></button></div><div class="col-lg-12 col-sm-12 col-xs-12 infoWaring flex-btn-group-container" style="background: #f6f7f9;padding: 0 10px;font-size: 12px;z-index:1" ng-if="vm.messageGallery.length"><img src="content/images/icons/notice.svg" alt="" style="width:24px;height:24px;margin-right:5px;margin-top: 4px"><marquee scrollamount="2" height="30" behavior="scroll" direction="left" align="left" style="width: 100%;line-height: 30px">{{vm.messageGalleryText}}</marquee></div></div></div><div class="iphoneX-content col-md-12 col-sm-12 col-xs-12 no-padding"></div><div class="save-pages" ng-click="nextStep()" ng-if="!vm.guideStep && (countN == 1 || countN == 2 || countN == 3 || countN == 4 || countN == 5)"><!--\u9879\u76EE\u5E93\u90E8\u5206\u5F15\u5BFC\u9875--><div class="choose_btn col-lg-12 col-sm-12 col-xs-12 pad-0" style="border: none;margin-top: 55px"><div class="col-lg-6 col-sm-6 col-xs-6 pad-left-10 pad-right-5" style="float: left" ng-class="1 == countN ? \'\' :\'hide\'"><button class="borderTheme opacityMinus choose_gallery2 choose-btn-size"><span class="categoryPrice">{{\'choose.editor.wx\' | translate}}</span></button><!-- <img src="content/images/mobile-album.svg" alt="\u624B\u673A\u76F8\u518C" style="margin-left: 20px;"/> --><div class="Lead-Bubble Lead-Bubble-LT"><span>{{\'choose.editor.clickAlbumUploadPicture\' | translate}}</span></div></div><div class="col-lg-6 col-sm-6 col-xs-6 pad-left-5 pad-right-10" style="float: right" ng-class="2 == countN ? \'\' :\'hide\'"><button class="borderTheme opacityMinus choose_gallery2 choose-btn-size"><span class="categoryPrice">{{\'choose.editor.gallery\' | translate}}</span></button><!-- <img src="content/images/history-photo.svg" alt="\u5DF2\u4F20\u56FE\u7247" style="margin-left: -30px;"/> --><div class="Lead-Bubble Lead-Bubble-RT" style="transform: translateX(-20%)"><span>{{\'choose.editor.historyPicture\' | translate}}</span></div></div></div><div class="footer_step col-md-12 col-sm-12 col-xs-12 no-padding" ng-show="!choose"><div class="col-md-12 col-sm-12 col-xs-12 no-padding"><div class="opacityMinus" ng-class="3 == countN ? \'\' :\'hide\'" style="float: left" ng-style="{\'width\':(vm.wid -200)/2+\'px\'}"><!-- <img src="content/images/sort-photo.svg" alt="\u7167\u7247\u6392\u5E8F"/> --><div class="Lead-Bubble Lead-Bubble-LB"><span>{{\'choose.editor.uploadPicturesSort\' | translate}}</span></div><div class="btn-step"><img src="content/images/photo-sort.svg" alt="\u7167\u7247\u6392\u5E8F"> <span class="size-foot categoryPrice">{{\'choose.editor.photoSort\' | translate}}</span></div></div><div class="opacityMinus" ng-class="4 == countN ? \'\' :\'hide\'" style="float: left" ng-style="{\'width\':(vm.wid -200)/2+\'px\',\'marginLeft\':(vm.wid -200)/2+\'px\'}"><div class="Lead-Bubble Lead-Bubble-CB" style="transform: translateX(-20%)"><span>{{\'choose.editor.goEditor\' | translate}}</span></div><!-- <img src="content/images/single-photo.svg" alt="\u5355\u9875\u5236\u4F5C" style="margin-left: -80px;"/> --><div class="btn-step"><img src="content/images/single-make.svg" alt="\u5355\u9875\u5236\u4F5C"> <span class="size-foot" style="color: #717171">{{\'choose.editor.next\' | translate}}</span></div></div><div class="opacityMinus" style="width: 200px;float: right" ng-class="5 == countN ? \'\' :\'hide\'"><!-- <img src="content/images/import-photo.svg" alt="\u4E00\u952E\u586B\u5145"/> --><div class="Lead-Bubble Lead-Bubble-BR" style="transform: translateX(-20%)"><span>{{\'choose.editor.photoAddedImport\' | translate}}</span></div><div class="product-go diy-btn-primarys" style="margin: 5px 0 3px -10px"><span>{{\'choose.editor.go\' | translate}}</span></div></div></div><div class="iphoneX-content col-md-12 col-sm-12 col-xs-12 no-padding"></div></div><div class="next-step2"><button class="c-btn-next">{{\'choose.editor.nextStep\' | translate}}</button></div><div class="never-hint" ng-click="neverHint()">{{\'choose.editor.notTips\' | translate}}</div></div></div><div ng-show="status==\'sort\'" style="position: absolute;top: 0;left: 0"><div class="choose_header col-md-12 col-sm-12 pad-0" style="line-height: 25px"><div class="show_count col-lg-4 col-sm-4 col-xs-4 text-left"><span class="arrowPrev arrow-prev" ng-click="showStartBtn()"></span></div><div class="show_count col-lg-4 col-sm-4 col-xs-4 text-center"><span>{{\'choose.editor.clickOnPhotosToSort\' | translate}}</span></div><div class="show_count col-lg-4 col-sm-4 col-xs-4" ng-click="sureSort()"><div class="floatRight commit-div" ng-click="sureSort()" style="text-align: center">{{\'choose.editor.confirm\' | translate}}</div></div><div class="save-pages hide1"><div class="save-page1"><div class="imgLoading"><div class="loadImg"></div><p class="imgText">{{\'choose.editor.photoLoading\' | translate}}<br>{{\'choose.editor.await\' | translate}}</p></div></div></div></div><div class="choose_pic col-md-12 col-sm-12 col-xs-12 no-padding" ng-show="qiniuId.length" style="margin-top: 48px"><ul class="photos" ng-cloak id="my-ui-list"><li ng-repeat="photo in qiniuId | orderBy: $index track by $index" class="photo-content"><img ng-src="{{photo.identifier+\'?imageView2/1/w/150/h/150\'||\'//:0\'}}" alt="" data-img-identifier="{{photo.identifier}}" class="imgPhoto" ng-click="selectPage(photo)"><div ng-if="photo.imgSize/1024 < 150 " class="lowerSize no-events"><div style="height: 15vw;line-height: 25vw"><img src="content/images/ic_pixel2.svg" alt="" style="pointer-events: none;-webkit-user-select: none;-webkit-touch-callout: none"></div><div style="height: 15vw;line-height: 15vw">{{\'choose.editor.lackofPixels\' | translate}}</div></div><div class="page-sort" ng-show="photo.seq.select"><div></div><p class="page-num" translate="choose.editor.pagination" translate-values="{pageI:photo.seq.pageI-0+1}"></p><p class="mask-num">{{photo.seq.maskI-0+1}}</p></div></li></ul></div><div class="iphoneX-content col-md-12 col-sm-12 col-xs-12 no-padding"></div></div><!--\u8DF3\u8F6C\u5230\u56FE\u7247\u5E93\u7684\u90E8\u5206 \u8FD8\u5728\u5F53\u524D\u9875\u9762--><div ng-style="{width:dWidth}" ng-if="status==\'gallery\'"><div class="prev-btn-gallery"><!-- <span style="font-size: 14px">{{"galleryContent.works" | translate}} <span style="font-size: 16px; font-weight: 600; color: var(--mobileTextSelectedColor);">{{getCount()}}</span> {{"galleryContent.pictureNum" | translate}}\n        <span style="font-size: 16px; font-weight: 600; color: var(--mobileTextSelectedColor);">{{gallaryPic.length}}</span> {{"galleryContent.paper" | translate}}</span> --> <span translate="galleryContent.workNeedPicture" translate-values="{num:getCount(),num2:gallaryPic.length}"></span> <span class="prev-btn opacityMinus" ng-click="backToView()"><span class="arrowPrev arrow-prev" style="width: 20px;height: 20px"></span></span></div><ul class="folder-nav col-md-12 col-sm-12 col-xs-12" ng-show="!moveGallery&&!folderInside" style="top:40px"><li class="col-md-6 col-sm-6 col-xs-6" ng-click="galleryNavSel()"><div ng-class="{\'folder-head-active\':currentNav==\'gallery\'}">{{"galleryContent.picture" | translate}}</div></li><li class="col-md-6 col-sm-6 col-xs-6" ng-click="folderNavSel()"><div ng-class="{\'folder-head-active\':currentNav==\'folder\'}">{{"galleryContent.folder" | translate}}</div></li></ul><header class="folder-inside" ng-show="folderInside"><div class="index-back"><span class="opacityMinus" ng-click="hideFolderContent()"><div class="tabIcons back-work"></div></span></div><span class="mar-left-54 text-ellip" style="width: 43vw">{{folderOne.name}}</span></header><div class="panel-body no-padding" ng-show="currentNav==\'gallery\'" style="background: #fff"><div class="col-md-12 col-sm-12 col-xs-12 no-padding border-bottom photoOperate" ng-show="noPic"><div class="btn-pic opacityMinus"><span class="prev-btn opacityMinus" ng-click="showStartBtn()"><span class="arrowPrev arrow-prev"></span></span></div></div><div class="choose_none bg" ng-show="noPic"><span class="nonePic nonePhoto"></span><div class="categoryPrice">{{"galleryContent.noPhotosAvailable" | translate}}</div></div><div style="width: 100vw;height: 50px" ng-hide="folderInside"></div><div class="col-md-12 col-sm-12 col-xs-12 no-padding mar-bottom-60 photo-show" ng-hide="noPic" ng-class="{\'mar-top-60\':vm.pid==\'\'&&!vm.aid}"><!-- \u56FE\u5E93\u663E\u793A --><div class="photo-item" ng-repeat="photo in photos" ng-class="{\'mar-top-60\':$first,\'mar-bottom-50\':$last}"><div class="photo_header mar-bo" style="height: 32px"><span ng-click="selectedPhoto($index,photo)"><!--                        <span class="select-icon select-all" ng-show="!!photo.select_photoAll"></span>--><!--                        <span class="select-icon selectCurrent" ng-show="!photo.select_photoAll"></span>--> <i class="icon iconfont icondui select-icon" ng-show="!!photo.select_photoAll"></i> <i class="icon iconfont iconbig-circle select-icon" ng-show="!photo.select_photoAll"></i></span></div><ul class="photos border-bottom" ng-cloak ng-show="vm.pid!=\'\'||vm.aid"><li ng-repeat="gallery in photo.galleries" class="photo-content" ng-click="selectThis2(gallery, photo,$index)" ng-class="justifySelect(gallery) ?\'transparentImg\':\'\'" ng-if="domain != null"><img ng-src="{{gallery.identifier +\'?imageView2/1/w/150/h/150\'||\'\'}}" alt="" class="imgPhoto" style="pointer-events: none;-webkit-user-select: none;-webkit-touch-callout: none"><!--                        <div class="select-icon select-all" ng-show="gallery.select_photo"></div>--><!--                        <div class="select-icon select-none" ng-show="delBar&&(!gallery.select_photo)"></div>--> <i class="icon iconfont icondui select-icon" ng-show="gallery.select_photo"></i> <i class="icon iconfont iconbig-circle select-icon" ng-show="delBar&&(!gallery.select_photo)"></i><div ng-if="gallery.imgSize/1024 < 150 " class="lowerSize"><div style="height: 15vw;line-height: 25vw"><img src="content/images/ic_pixel2.svg" alt="" style="pointer-events: none;-webkit-user-select: none;-webkit-touch-callout: none"></div><div style="height: 15vw;line-height: 15vw">{{"galleryContent.lackOfPixels" | translate}}</div></div></li></ul></div></div><div class="col-md-12 col-sm-12 col-xs-12 text-center" align="content"><img ng-if="vm.more" class="loadingPic" src="content/images/loading.gif"></div></div><div class="folder-file pad-bottom-70" ng-show="currentNav==\'folder\'"><header class="top-menu" ng-show="moveGallery" style="position: fixed;z-index:1000"><div class="index-back"><span class="opacityMinus" ng-click="backToGallery()"><div class="tabIcons back-work"></div></span></div><span class="top-title">{{"galleryContent.selectTheDestinationFolder" | translate}}</span><div class="floatRight commit-div edit-save" ng-click="saveMoveToFolder()">{{"galleryContent.confirm" | translate}}</div></header><ul class="folder-list" ng-style="{\'padding-top\':!moveGallery?\'90px\':\'40px\'}"><li ng-show="moveGallery"><div class="folder-namebar" ng-click="selectSingle(\'\',1)"><span class="namebar-left text-ellip"><img src="content/images/icons/folder.svg"> <span class="folder-name">{{"galleryContent.picture" | translate}}</span> </span><button class="choose-one" ng-show="selectOne.folderId==\'\'&&selectOne.selected"></button></div></li><li ng-repeat="folder in Folders track by $index" class="folder-li{{$index}} folder-li"><!--\u79FB\u52A8\u56FE\u7247--><div class="folder-namebar" ng-click="selectSingle(folder,1)" ng-show="moveGallery"><span class="namebar-left text-ellip"><img src="content/images/icons/folder.svg"> <span class="folder-name{{$index}} folder-name">{{folder.name}}</span> </span><button class="choose-one" ng-show="folder.selected"></button></div><!--\u6587\u4EF6\u5939\u5904\u7406--><div class="folder-namebar" ng-show="!moveGallery"><span class="namebar-left text-ellip" ng-click="showFolderContent(folder)"><img src="content/images/icons/folder.svg"> <span class="folder-name{{$index}} folder-name">{{folder.name}}</span> </span><span ng-click="selectFolders(folder)"><i class="sel-true sel" ng-if="folder.selected"></i> <i class="sel-false sel" ng-if="!folder.selected"></i></span></div><div class="folder-editbar editbar{{$index}} hide1"><div class="folder-edit" ng-click="editFolder(folder)"><!--                        <img src="content/images/icons/folder-edit.svg">--> <i class="icon iconfont iconbianji default-btncolor-mobile"></i><div class="text textActive">{{"galleryContent.rename" | translate}}</div></div></div></li></ul></div><div class="col-md-12 col-sm-12 col-xs-12 footer-del pad-0"><div class="folder-footer" ng-show="currentNav==\'gallery\'"><div class="folder-add folder-btn"><span class="add-img opacityMinus categoryPrice view-flex" style="position:relative"><!-- \u56FE\u7247\u5E93\u9009\u62E9\u4E0A\u4F20 --> <span class="icon iconfont icontianjiazhaopian default-btncolor-mobile"></span><!--                    <span class="select-icons add-photo"></span>--> <span ng-if="!agentIos"><span style="font-size: 12px">{{"galleryContent.localGallery" | translate}}</span> <input onchange="uploadPicMutiple(event)" id="uploadImg" type="file" multiple="multiple" accept="{{vm.supportedMimeTypes}}" name="file" value="" style="opacity:0; position:absolute;top:0;left:0"> </span><span ng-if="agentIos" ng-click="chooseWx()"><span style="font-size: 12px">{{"galleryContent.localGallery" | translate}}</span></span></span></div><!--<div class="folder-delete folder-btn" ng-click="moveToFolder()" ng-show="delBar">--><!--<img src="content/images/icons/folder-move.svg">--><!--<div class="text textActive">\u79FB\u52A8</div>--><!--</div>--><div class="folder-all folder-btn" ng-click="showDeleteBtn()" ng-show="delBar"><!--                <img src="content/images/icons/folder-choose-all.svg">--> <i class="icon iconfont iconquanxuan default-btncolor-mobile"></i><div class="textActive">{{"galleryContent.checkAll" | translate}}</div></div></div><div class="folder-footer" ng-show="currentNav==\'folder\'&&!moveGallery"><div class="folder-add folder-btn" ng-click="addFolder()"><!--                <img src="content/images/icons/folder-add-sel.svg">--> <i class="icon iconfont iconaddfile default-btncolor-mobile"></i><div class="textActive">{{"galleryContent.addFolder" | translate}}</div></div><div class="folder-editName folder-btn" ng-click="editFolder()" ng-show="folderIds.length>0"><i class="icon iconfont iconbianji default-btncolor-mobile" ng-show="folderIds.length==1"></i> <i class="icon iconfont iconbianji" ng-show="folderIds.length>1"></i><!--                <img src="content/images/icons/folder-edit.svg" ng-show="folderIds.length==1">--><!--                <img src="content/images/icons/folder-edit-gray.svg" ng-show="folderIds.length>1">--><div class="text textActive" ng-class="{\'folder-grayText\':folderIds.length>1}">{{"galleryContent.rename" | translate}}</div></div><div class="folder-all folder-btn" ng-click="chooseAll(1)" ng-show="folderIds.length>0"><!--                <img src="content/images/icons/folder-choose-all.svg">--> <i class="icon iconfont iconquanxuan default-btncolor-mobile"></i><div class="text textActive">{{"galleryContent.checkAll" | translate}}</div></div></div><div class="iphoneX-content col-md-12 col-sm-12 col-xs-12 no-padding"></div></div><!--\u56FE\u7247\u5E93\u4E2D\u9690\u85CF\u4E0A\u4F20\u6309\u94AE\uFF0C\u4E0A\u4F20\u56FE\u7247\u4E2D\u663E\u793A--><div class="footer-title opacityMinus" ng-click="confirmImport($event)" ng-show="(vm.pid!=\'\'||vm.aid)&&delBar"><!-- \u5DE5\u4F5C\u533A\u9009\u62E9\u4E0A\u4F20\u6309\u94AE --><div class="diy-btn-primarys" style="border-radius: 20px"><span>{{"galleryContent.confirm" | translate}}</span></div></div></div><div ng-style="{width:dWidth}" class="page-make user-select-default" ng-show="status==\'make\'||status==\'view\'"><!--1.\u663E\u793A\u52A0\u8F7D\u56FE\u6807\uFF0C\u9875\u9762\u52A0\u8F7D\u5B8C\u6210\u540E\u663E\u793A\u5F15\u5BFC\u9875--><div class="page-loading" ng-show="loading"><img src="content/images/loading2.gif" onerror="this.src=\'content/images/loading2.gif\'"><p class="tip-style">{{"choose.editor.addTextMessage" | translate}}</p><span class="tip-style">{{"choose.editor.clippingMessage" | translate}}</span></div><div class="page-orientation hide1"><span>{{"choose.editor.pleaseMakeItInPortrait" | translate}}</span></div><div class="page-turning hide1"><div class="k-square-holder2"><div class="k-square3 k-square3a"></div><div class="k-square3 k-square3b"></div><div class="k-square3 k-square3c"></div><div class="k-square3 k-square3d"></div></div></div><div class="edit-page page-view" ng-class="{\'edit-bg1\':status==\'view\',\'edit-bg2\':status==\'make\'}"><div class="save-page hide1"><div><img src="content/images/loading.gif"> <span>{{"choose.editor.worksInStorage" | translate}}</span></div></div><!--\u9876\u90E8\u72B6\u6001\u680F--><div class="diy-row edit-head"><div class="top-menu"><!--\u8FD4\u56DE\u6309\u94AE--><div class="index-back" ng-hide="status==\'view\' && (weixinFlag == \'weChatApplet\'|| weixinFlag == \'weChatAppletMake\')||vm.sortStatus"><span class="opacityMinus" ng-click="backTo()"><div class="tabIcons back-work"></div></span></div><button ng-show="status==\'view\'&&vm.sortStatus" class="commit-div floatLeft" ng-click="sortBack()" style="margin: 10px 10px 0 10px;text-align: center;padding: 0 6px">{{"choose.editor.sortBack" | translate}}</button> <button ng-show="status==\'view\'&&vm.sortStatus" class="commit-div floatLeft button-style1" ng-click="sortCancel()">{{"choose.editor.restore" | translate}}</button> <button ng-show="status==\'view\'&&!vm.sortStatus&&vm.replace" class="commit-div floatLeft button-style1" ng-click="sortPage()" ng-style="{\'margin-left\':(weixinFlag == \'weChatApplet\'|| weixinFlag == \'weChatAppletMake\')?\'15px\':\'50px\'}" style="width: 78px">{{"choose.editor.pageSorter" | translate}}</button><!--\u663E\u793A\u9875\u9762\u5F20\u6570--><div class="index-info" ng-show="status==\'make\'&&!showCut&&!showTextModal"><span class="categoryPrice" style="color: #B0B0B0;font-size: 16px">{{currentCarouselIndex+1}}</span>/{{PAGELEN}}</div><!--\u56FE\u7247\u7F16\u8F91\u65F6\u9876\u90E8\u72B6\u6001\u680F\uFF1A   \u653E\u5927  \u7F29\u5C0F  \u5DE6\u65CB\u8F6C  \u53F3\u65CB\u8F6C--><div class="index-cut" ng-show="showCut"><span class="zoom-in opacityMinus" ng-click="zoomIn()"><img src="content/images/icons/zoom-b.svg" alt=""></span><span class="zoom-out opacityMinus" ng-click="zoomOut()"><img src="content/images/icons/shrink-b.svg" alt=""></span><span class="zoom-out opacityMinus" ng-click="rotateImage(true)"><img src="content/images/icons/rotate-l.svg" alt=""></span><span class="zoom-out opacityMinus" ng-click="rotateImage(false)"><img src="content/images/icons/rotate-r.svg" alt=""></span></div><!--\u6587\u5B57\u7F16\u8F91\u65F6\u7684title--><div class="index-text" ng-show="showTextModal">{{"choose.editor.wordEdit" | translate}}</div><!--\u4FDD\u5B58\u7F16\u8F91\u540E\u7684\u56FE\u7247--><div class="floatRight commit-div edit-save" ng-show="showCut" ng-click="saveMove()">{{"choose.editor.confirm" | translate}}</div><div style="position: absolute; left: 44%; line-height: 50px;color: #B0B0B0;font-size: 16" ng-show="status==\'view\'">{{vm.productXmlNumber}}</div><!--\u4FDD\u5B58\u6587\u5B57--><div class="floatRight commit-div edit-save" ng-show="showTextModal" ng-click="saveText()">{{"choose.editor.confirm" | translate}}</div><!--\u4FDD\u5B58\u4F5C\u54C1--><div class="index-save" ng-hide="showCut||showTextModal"><span class="opacityMinus"><div ng-show="status==\'make\'" class="commit-div button-style1" ng-click="saveWork()">{{"choose.editor.save" | translate}}</div><div ng-show="status==\'view\'&&!vm.sortStatus" class="commit-div button-style1" style="width: 78px" ng-click="saveWork()">{{"choose.editor.saveAll" | translate}}</div><div ng-show="status==\'view\'&&vm.sortStatus" class="commit-div button-style1" ng-click="saveSort()">{{"choose.editor.finish" | translate}}</div></span></div></div></div><div class="col-lg-12 col-sm-12 col-xs-12 infoWaring flex-btn-group-container tip-image" style="padding: 0 10px;font-size: 12px;z-index:1" ng-if="vm.messageTile.length&&status==\'view\'&&!vm.sortStatus"><img src="content/images/icons/notice.svg" alt="" style="width:24px;height:24px;margin-right:5px;margin-top: 4px"><marquee scrollamount="2" height="30" behavior="scroll" direction="left" align="left" style="width: 100%;line-height: 30px">{{vm.messageTileText}}</marquee></div><div class="edit-page-content" style="background: #fff" ng-style="{width:dWidth,\'min-height\':dHeight}" ng-click="hideMenu()"><div ng-show="showCut" style="height: 50px"></div><div ng-show="showCut" class="cut-image-box" ng-style="{height:vm.editHeight-50}" ontouchstart="startEdit(event)" ontouchmove="dragEdit(event)" ontouchend="stopEdit()"><img ng-src="{{currentImage.image.resource.identifier+ \'?imageMogr2/strip/rotate/\' + currentImage.image.angle+\'/thumbnail/800x800>\'}}" id="cut-img" class="cut-img" ng-style="{\'transform\': currentImage.flip ? \'rotateY(180deg)\' : \'unset\', width:w?w*currentImage.image.scale:\'\', height:h?h*currentImage.image.scale:\'\'}"> <img class="cut-mask" id="cut-mask" style="position: absolute;top:0;left: 0"> <span class="cut-img opacity-zero cut-position"><img ng-src="{{currentImage.image.resource.identifier+ \'?imageMogr2/strip/rotate/0//thumbnail/800x800>\'}}" id="cut-opacity" class="cut-img" ng-style="{\'transform\': currentImage.flip ? \'rotateY(180deg)\' : \'unset\',width:wOpacity?wOpacity*currentImage.image.scale:\'\',height:hOpacity?hOpacity*currentImage.image.scale:\'\'}"></span></div><!--\u6587\u5B57\u72B6\u6001--><div ng-show="showTextModal" class="cut-Text-box" ng-style="{height:dHeight,background:\'#fff\'}"><div class="text-menu pad-top-60"><div class="text-op col-xs-12 col-md-12 col-sm-12 pad-0"><div class="text-head col-xs-12 col-md-12 col-sm-12"><div contenteditable="true" class="text-textarea col-xs-12 col-md-12 col-sm-12 pad-left-0 pad-right-40" id="text-div"></div><textarea id="text-area" rows="5" class="text-textarea col-xs-12 col-md-12 col-sm-12" ng-model="textContent" style="padding-top: 10px" placeholder="{{\'editorCommon.describe29\' | translate}}" ng-change="updateTextContents()">\n                            </textarea></div><div class="text-body pad-left-0 col-xs-12 col-md-12 col-sm-12"><!--\u989C\u8272/\u5B57\u4F53\u5207\u6362\u83DC\u5355--> <button class="text-content-tab" ng-class="{\'selected\': selectSketchMenu == \'sketch-color\'}" ng-click="selectSketchMenu = \'sketch-color\';"><span class="icon iconfont iconyansexuanzeqi iconColorText" ng-class="{\'default-btncolor-mobile\':selectSketchMenu == \'sketch-color\'}"></span></button> <button class="text-content-tab" ng-class="{\'selected\': selectSketchMenu == \'sketch-line\'}" ng-click="selectSketchMenu = \'sketch-line\';"><span class="icon iconfont iconzihao iconColorText" ng-class="{\'default-btncolor-mobile\':selectSketchMenu == \'sketch-line\'}"></span> <input id="multiPickerInput" type="button" placeholder="\u5B57\u4F53" value="" class="text-font" style="opacity: 0;margin-left: 300px"></button> <button class="text-content-tab" ng-class="{\'selected\': selectSketchMenu == \'sketch-size\'}" ng-click="selectSketchMenu = \'sketch-size\';"><span class="icon iconfont iconziti iconColorText" ng-class="{\'default-btncolor-mobile\':selectSketchMenu == \'sketch-size\'}"></span></button></div><div class="pad-0 col-xs-12 col-md-12 col-sm-12"><!--\u989C\u8272\u9009\u62E9--> <span class="color-picker-bar diy-row" ng-show="selectSketchMenu == \'sketch-color\'"><span class="color-item" ng-repeat="color in colorList track by $index" ng-click="selectTextColor(color)" data-index="{{$index}}" ng-style="{background:selectedColor == color?\'\':color, border: \'1px solid \'+color,\'margin-left\':(dWidth-210)/14,\'margin-right\':(dWidth-210)/14}" ng-class="{\'white-border\':$index==8}"><i ng-style="{background:color}" ng-show="selectedColor == color"></i> </span></span><!--\u5B57\u4F53\u9009\u62E9--><div id="targetContainer" class="diy-row pad-top-0" ng-show="selectSketchMenu == \'sketch-line\'"></div><!--\u5B57\u53F7\u9009\u62E9--><div ng-show="selectSketchMenu == \'sketch-size\'" style="height: 200px"><p class="text-value" translate="choose.editor.fontSize" translate-values="{size:16}"></p><div><i class="icon-font font-jia"></i> <input type="range" min="9" max="500" step="1" value="16" ng-model="vm.textSize" ng-change="fontRange()" class="text-range rangeSize"> <i class="icon-font font-jian"></i></div></div></div></div></div></div><!--            <div ng-show="status==\'view\'&&vm.sortStatus">--><!--                <div class="arrowCircle arrowCircle-up">--><!--                    <img src="content/images/arrowCircleUp@2x.svg" alt="" ontouchstart = "return false;" style="pointer-events: none;">--><!--                </div>--><!--                <div class="arrowCircle arrowCircle-down">--><!--                    <img src="content/images/arrowCircleDown@2x.svg" alt="" ontouchstart = "return false;" style="pointer-events: none;">--><!--                </div>--><!--            </div>--><!--\u5E73\u94FA\u5C55\u793A\u9875\u9762--><div class="template-view" ng-show="status==\'view\'" style="width: 100%;overflow: visible;margin-top: 84px" ng-style="{\'height\':(dHeight-50)+\'px\'}"><div style="color: #A1A1A1;text-align: center" ng-show="status==\'view\'&&vm.sortStatus" class="col-lg-12 col-sm-12 col-xs-12">{{"choose.editor.sortByLongDragOnThePage" | translate}}</div><ul class="carousel5 pad-bottom-10" style="width: 100vw" ng-if="vm.pattern == \'BOOK\'" id="my-ui-list1"><li ng-repeat="slide in template.pages.page" data-index="{{$index}}" class="slide-li photo-content1" ng-click="clickToEdit(slide,$index)" ng-hide="slide.unreplace&&vm.sortStatus" ng-style="{ \'margin-left\':$first||$last?(dWidth-dWidth*0.6)/2:$index%2==1?(dWidth*0.1-10)/2:10}" id="slide{{$index}}" ng-init="outerIndex = $index"><div class="slide-content" data-sort-tag="{{slide.seq}}" ng-style="{\n                             overflow:\'hidden\',\n                             position:\'relative\',\n                             background:slide.background.color,\n                             width:($first||$last?dWidth*0.6:dWidth*0.45).toFixed(2),\n                             height:$first||$last?dWidth*0.6*slide.mediabox.height/slide.mediabox.width:dWidth*0.45*slide.mediabox.height/slide.mediabox.width}"><div class="sort-disabled" ng-show="slide.unreplace&&vm.sortStatus"><div style="padding-top: 30%">{{"choose.editor.pageCannotBeMoved" | translate}}</div></div><img class="sort-disabled1" ng-show="slide.unreplace&&vm.sortStatus" ontouchstart="return false;" style="pointer-events: none;-webkit-user-select: none;-webkit-touch-callout: none"> <img ng-src="{{slide.background.resource.identifier+\'?imageMogr2/thumbnail/200x200>\'}}" ng-if="slide.background.resource.identifier" class="background backgroundImg{{$index}}" data-index="{{$index}}" ng-style="{\n                                             position: \'absolute\',\n                                             left:slide.background.offsetx*slide.styleScale,\n                                             top:slide.background.offsety*slide.styleScale,\n                                             width: slide.background.resource.adaptation==\'Width\'?\'100%\':\'auto\',\n                                             height:slide.background.resource.adaptation==\'Height\'?\'100%\':\'auto\'}"><div ng-repeat="level in slide.levels.level track by $index"><div ng-if="level.imagebox&&level.imagebox.geometry" ng-style="{\n                                            \'position\': \'absolute\',\n                                            width: imageboxW(level.imagebox) * slide.styleScale,\n                                            height: imageboxH(level.imagebox) * slide.styleScale,\n                                            left: imageboxL(level.imagebox) * slide.styleScale,\n                                            top: imageboxT(level.imagebox) * slide.styleScale,\n                                            \'z-index\':level.seq-0+200,\n                                            \'transform\': \'rotate(\' + level.imagebox.rotation.angle + \'deg)\',\n                                         }"><div class="relative-view1" ng-style="{\n                                         \'overflow\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'unset\' : \'hidden\',\n                                                \'opacity\':level.imagebox.transparency,\n                                                \'border-top-left-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'lt\', slide.styleScale),\n                                                \'border-top-right-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'rt\', slide.styleScale),\n                                                \'border-bottom-right-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'rb\', slide.styleScale),\n                                                \'border-bottom-left-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'lb\', slide.styleScale),\n                                                \'border-width\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? (level.imagebox.border.lineWidth * slide.styleScale) : \'\',\n                                                \'border-style\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? (level.imagebox.border.lineType || \'solid\') : \'none\',\n                                                \'border-color\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? level.imagebox.border.color : \'\',\n                                                \'box-shadow\' : (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineWidth>0 && (!level.imagebox.border.lineType || level.imagebox.border.lineType == \'solid\')) ? \'0 0 0 1px \' + level.imagebox.border.color + \' inset\' : \'none\',\n                                                \'filter\' : dropShadow(level.imagebox,slide.styleScale,slide.styleScale),\n                                                }"><div ng-style="{\n                                             \'position\': \'absolute\',\n                                             \'z-index\':0,\n                                            \'left\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'left\') * slide.styleScale : 0,\n                                            \'top\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'top\') * slide.styleScale : 0,\n                                            \'right\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'right\') * slide.styleScale : 0,\n                                            \'bottom\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'bottom\') * slide.styleScale : 0,\n                                            \'background-image\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'url(\' + level.imagebox.border.resource.identifier + \')\' : \'\',\n                                            \'background-size\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'100% 100%\' : \'\',\n                                            }"></div><div class="relative-view1" ng-style="{\n                                                    \'background\': level.imagebox.image.resource.identifier ? \'none\' : \'#ddd\',\n                                                    \'border-top-left-radius\':imageboxWRadius1(level.imagebox, \'lt\', slide.styleScale),\n                                                    \'border-top-right-radius\':imageboxWRadius1(level.imagebox, \'rt\', slide.styleScale),\n                                                    \'border-bottom-right-radius\':imageboxWRadius1(level.imagebox, \'rb\', slide.styleScale),\n                                                    \'border-bottom-left-radius\':imageboxWRadius1(level.imagebox, \'lb\', slide.styleScale),\n                                                    \'-webkit-mask-image\': level.imagebox.mask.resource.identifier ? \'url(\' + level.imagebox.mask.resource.identifier + \')\' : \'none\',\n                                                    \'-webkit-mask-size\': \'100% 100%\'}"><div style="position: relative"><div class="picLowerSize text-r" ng-cloak ng-show="level.imagebox && level.imagebox.image && level.imagebox.lowSize" ng-style="{ left:level.imagebox.geometry.width*slide.styleScale/2-8, top:level.imagebox.geometry.height*slide.styleScale/2-11}"><img src="content/images/ic_pixel.svg"></div></div><div class="img-place-holder indexSet-800" ng-hide="level.imagebox.image.resource.identifier"><img src="content/images/icons/addcamera.svg"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'None\' && level.imagebox.image.resource.identifier"><img ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/strip/rotate/\' + level.imagebox.image.angle+\'/thumbnail/800x800>\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                    \'width\': level.imagebox.image.width*level.imagebox.image.scale*slide.styleScale,\n                                                    \'height\': level.imagebox.image.height*level.imagebox.image.scale*slide.styleScale,\n                                                    \'left\':level.imagebox.image.offsetx*level.imagebox.image.scale*slide.styleScale,\n                                                    \'top\':level.imagebox.image.offsety*level.imagebox.image.scale*slide.styleScale\n                                                 }"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'Blurred\' && level.imagebox.image.resource.identifier"><img class="c-blur" ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/strip/rotate/\' + level.imagebox.image.angle+\'/thumbnail/800x800>\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                    \'width\': level.imagebox.image.width*slide.styleScale,\n                                                    \'height\': level.imagebox.image.height*slide.styleScale,\n                                                 }"> <img ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/strip/rotate/\' + level.imagebox.image.angle+\'/thumbnail/800x800>\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                    \'width\': level.imagebox.blurredrectangle.width*slide.styleScale,\n                                                    \'height\': level.imagebox.blurredrectangle.height*slide.styleScale,\n                                                    \'left\':level.imagebox.blurredrectangle.x*slide.styleScale,\n                                                    \'top\':level.imagebox.blurredrectangle.y*slide.styleScale,\n                                                    \'z-index\': 1\n                                                 }"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'Transparent\' && level.imagebox.image.resource.identifier"><img ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/strip/rotate/\' + level.imagebox.image.angle+\'/thumbnail/800x800>\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                    \'width\': level.imagebox.blurredrectangle.width*slide.styleScale,\n                                                    \'height\': level.imagebox.blurredrectangle.height*slide.styleScale,\n                                                    \'left\':level.imagebox.blurredrectangle.x*slide.styleScale,\n                                                    \'top\':level.imagebox.blurredrectangle.y*slide.styleScale,\n                                                    \'z-index\': 1\n                                                 }"></div></div></div></div><div class="sticker-edit-box" data-index="{{$index}}" ng-if="level.imageart&&level.imageart.geometry" ng-style="{\n                                     \'opacity\':level.imageart.transparency,\n                                     filter: \'alpha(opacity=\'+level.imageart.transparency*100+\')\',\n                                     \'transform\':\'rotate(-\' + level.imageart.rotation.angle + \'deg)\',\n                                     \'-ms-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                     \'-moz-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                     \'-webkit-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                     \'-o-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                     \'width\': level.imageart.geometry.width*slide.styleScale,\n                                     \'height\': level.imageart.geometry.height*slide.styleScale,\n                                     \'left\': level.imageart.geometry.x*slide.styleScale,\n                                     \'top\': level.imageart.geometry.y*slide.styleScale,\n                                     \'z-index\':level.seq-0+200}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                \'left\': level.imageart.offsetx*slide.styleScale,\n                                                \'top\': level.imageart.offsety*slide.styleScale,\n                                                \'width\': level.imageart.geometry.width * level.imageart.scale*slide.styleScale}" ng-src="{{level.imageart.resource.identifier+\'?imageMogr2/thumbnail/800x800>\'}}"></div></div><div class="text-box" ng-if="level.textbox&&level.textbox.geometry" data-index="{{$index}}" style="white-space: normal;line-height: 0;min-height: 10px;min-width: 24px" ng-style="{\n                                     top: level.textbox.geometry.y*slide.styleScale,\n                                     left: level.textbox.geometry.x*slide.styleScale,\n                                     \'width\': level.textbox.geometry.width*slide.styleScale,\n                                     \'height\': level.textbox.geometry.height*slide.styleScale,\n                                     \'transform\': \'rotate(\' +  level.textbox.rotation.angle + \'deg)\',\n                                     \'z-index\':level.seq-0+200}"><pre class="c-xml-page-textboxe-text web-font" data-index="{{$index}}" ng-style="{\n                                            \'font-family\':  \'\\\'\' + level.textbox.fontuuid + \'\\\'\',\n                                            \'font-size\': (level.textbox.style.size*slide.ratio > 12 ? level.textbox.style.size* slide.ratio : 12) + \'pt\',\n                                            \'color\': level.textbox.style.color,\n                                            \'font-weight\': level.textbox.style.bold ? \'bold\': \'400\',\n                                            \'font-style\': level.textbox.style.italic ? \'italic\': \'initial\',\n                                            \'line-height\': (level.textbox.style.size* slide.ratio > 12 ? level.textbox.style.lineheight* slide.ratio : level.textbox.style.lineheight*12/level.textbox.style.size) + \'pt\',\n                                            \'letter-spacing\': (level.textbox.style.size* slide.ratio > 12 ? level.textbox.style.letterspacing* slide.ratio : level.textbox.style.letterspacing*12/level.textbox.style.size) + \'pt\',\n                                            \'opacity\': level.textbox.transparency,\n                                            \'text-decoration\': \'none\',\n                                            \'text-align\': level.textbox.style.align,\n                                            \'writing-mode\': level.textbox.style.writingmode,\n                                            \'text-align-last\': level.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',\n                                            \'transform\':\'scale(\'+(1 / 12 * level.textbox.style.size* slide.ratio > 1 ? 1 : 1 / 12 * level.textbox.style.size* slide.ratio)+\')\',\n                                            \'width\':  (level.textbox.style.size* slide.ratio > 12 ? (level.textbox.geometry.width*slide.styleScale):(level.textbox.geometry.width*slide.styleScale)/( 1 / 12 * level.textbox.style.size*slide.ratio))+\'px\'\n                                          }"><span class="c-xml-page-textboxe-span">{{level.textbox.text}}</span></pre></div><div data-index="{{$index}}" ng-show="level.textdocument&&level.textdocument.geometry" ng-style="{\n                                        position: \'absolute\',\n                                        width: level.textdocument.geometry.width*slide.styleScale,\n                                        height: level.textdocument.geometry.height*slide.styleScale,\n                                        left: level.textdocument.geometry.x*slide.styleScale,\n                                        top: level.textdocument.geometry.y*slide.styleScale,\n                                        \'z-index\':level.seq-0+200,\n                                        \'opacity\':level.textdocument.transparency.toFixed(2),\n                                        filter: \'alpha(opacity=\'+level.textdocument.transparency*100+\')\',\n                                        \'transform\': \'rotate(-\' + level.textdocument.rotation.angle + \'deg)\'}"><div style="overflow: hidden;width: 100%;height: 100%;position: relative" class="no-events"><img class="bg-image bg-image{{template.pageI}} pos" ng-cloak ng-if="level.textdocument.background.resource.identifier" ng-src="{{level.textdocument.background.resource.identifier+\'?imageMogr2/thumbnail/800x800>\'||\'//:0\'}}" ng-style="{\n                                                 position: \'absolute\',\n                                                 left:level.textdocument.background.offsetx*slide.styleScale,\n                                                 top:level.textdocument.background.offsety*slide.styleScale,\n                                                 width: level.textdocument.background.adaptation==\'Width\'?level.textdocument.geometry.width*slide.styleScale:\'\',\n                                                 height:level.textdocument.background.adaptation!=\'Width\'?level.textdocument.geometry.height*slide.styleScale:\'\'}"><div ng-repeat="docLevel in level.textdocument.levels.level track by $index" ng-init="docIndex = $index" style="position: relative"><div data-index="{{docIndex}}" class="img-art" ng-show="docLevel.imageart" ng-style="{\n                                                    width: docLevel.imageart.geometry.width*slide.styleScale,\n                                                    height: docLevel.imageart.geometry.height*slide.styleScale,\n                                                    left: docLevel.imageart.geometry.x*slide.styleScale,\n                                                    top: docLevel.imageart.geometry.y*slide.styleScale,\n                                                    \'z-index\':docLevel.seq-0+200,\n                                                    \'opacity\':docLevel.imageart.transparency,\n                                                    filter: \'alpha(opacity=\'+docLevel.imageart.transparency*100+\')\',\n                                                    \'transform\': \'rotate(\' + docLevel.imageart.rotation.angle + \'deg)\'}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                            \'left\': docLevel.imageart.offsetx*slide.styleScale,\n                                                            \'top\': docLevel.imageart.offsety*slide.styleScale,\n                                                            \'width\': docLevel.imageart.geometry.width * docLevel.imageart.scale*slide.styleScale}" ng-src="{{docLevel.imageart.resource.identifier+\'?imageMogr2/thumbnail/800x800>\'}}"></div></div><div class="c-xml-page-textboxe" ng-show="docLevel.textbox" style="white-space: normal" data-index="{{docIndex}}" ng-style="{\n                                                    \'width\': docLevel.textbox.geometry.width*slide.styleScale,\n                                                    \'left\': docLevel.textbox.geometry.x*slide.styleScale,\n                                                    \'top\': docLevel.textbox.geometry.y*slide.styleScale,\n                                                    \'transform\': \'rotate(\' + docLevel.textbox.rotation.angle + \'deg)\'}"><pre class="c-xml-page-textboxe-text web-font" ng-style="{\n                                                    \'font-family\':  \'\\\'\' + docLevel.textbox.fontuuid + \'\\\'\',\n                                                    \'font-size\': (docLevel.textbox.style.size*slide.ratio > 12 ? docLevel.textbox.style.size* slide.ratio : 12) + \'pt\',\n                                                    \'color\': docLevel.textbox.style.color,\n                                                    \'font-weight\': docLevel.textbox.style.bold ? \'bold\': \'400\',\n                                                    \'font-style\': docLevel.textbox.style.italic ? \'italic\': \'initial\',\n                                                    \'line-height\': (docLevel.textbox.style.size* slide.ratio > 12 ? docLevel.textbox.style.lineheight* slide.ratio : docLevel.textbox.style.lineheight*12/docLevel.textbox.style.size) + \'pt\',\n                                                    \'letter-spacing\': (docLevel.textbox.style.size* slide.ratio > 12 ? docLevel.textbox.style.letterspacing* slide.ratio : docLevel.textbox.style.letterspacing*12/docLevel.textbox.style.size) + \'pt\',\n                                                    \'opacity\': docLevel.textbox.transparency,\n                                                    \'text-decoration\': \'none\',\n                                                    \'text-align\': docLevel.textbox.style.align,\n                                                    \'text-align-last\': docLevel.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',\n                                                    \'transform\':\'scale(\'+(1 / 12 * docLevel.textbox.style.size* slide.ratio > 1 ? 1 : 1 / 12 * docLevel.textbox.style.size* slide.ratio)+\')\',\n                                                    \'width\':  (docLevel.textbox.style.size* slide.ratio > 12 ? (docLevel.textbox.geometry.width*slide.styleScale):docLevel.textbox.geometry.width*slide.styleScale/( 1 / 12 * docLevel.textbox.style.size*slide.ratio))+\'px\'\n                                                  }"><span class="c-xml-page-textboxe-span">{{docLevel.textbox.text}}</span></pre></div></div></div></div></div><div class="barcode" ng-show="slide.barcode" ng-style="{\n                                 \'z-index\':496,\n                                 \'width\': slide.barcode.geometry.width*slide.styleScale,\n                                 \'height\': slide.barcode.geometry.height*slide.styleScale,\n                                 \'left\': slide.barcode.geometry.x*slide.styleScale,\n                                 \'top\': slide.barcode.geometry.y*slide.styleScale,\n                                 \'transform\': \'rotate(-\' + slide.barcode.rotation.angle + \'deg)\' }"><img src="content/images/txm.png" style="width: 100%;height: 100%"></div><div class="barcode" ng-show="slide.qrcode" ng-style="{\n                                 \'z-index\':496,\n                                 \'width\': slide.qrcode.geometry.width*slide.styleScale,\n                                 \'height\': slide.qrcode.geometry.height*slide.styleScale,\n                                 \'left\': slide.qrcode.geometry.x*slide.styleScale,\n                                 \'top\': slide.qrcode.geometry.y*slide.styleScale,\n                                 \'transform\': \'rotate(-\' + slide.qrcode.rotation.angle + \'deg)\' }"><img src="content/images/QrCode.png" style="width: 100%;height: 100%"></div></div><div class="li-page" style="width: 100%; text-align: center" ng-show="$first">{{"choose.pageType."+template.pages.page[0].type | translate}}</div><div class="li-page text-left" ng-hide="$first||$last" ng-class="{\'is-left\':$index%2==1,\'is-right\':$index%2==0}">{{\'unit.page\' | translate}}{{$index}}</div><div class="li-page text-left" ng-show="$last && template.pages.page[0].type==\'FrontBack\'" ng-class="{\'is-left\':$index%2==1,\'is-right\':$index%2==0}">{{\'unit.page\' | translate}}{{$index}}</div><div class="li-page left-45" ng-show="$last && template.pages.page[0].type!=\'FrontBack\'">{{"choose.pageType."+template.pages.page[0].type | translate}}</div></li></ul><ul class="carousel5 pad-bottom-10" style="width: 100vw" ng-if="vm.pattern != \'BOOK\'" id="my-ui-list1"><li ng-repeat="slide in template.pages.page" data-index="{{$index}}" class="slide-li photo-content1" ng-click="clickToEdit(slide,$index)" ng-hide="slide.unreplace&&vm.sortStatus" ng-style="{ \'margin-left\':$index%2==1?(dWidth*0.1-10)/2:10}" id="slide{{$index}}" ng-init="outerIndex = $index"><div class="slide-content" data-sort-tag="{{slide.seq}}" ng-style="{\n                             overflow:\'hidden\',\n                             position:\'relative\',\n                             background:slide.background.color?slide.background.color:\'#fff\',\n                             width:(dWidth*0.45).toFixed(2),\n                             height:dWidth*0.45*slide.mediabox.height/slide.mediabox.width}"><div class="sort-disabled" ng-show="slide.unreplace&&vm.sortStatus"><div style="padding-top: 30%">{{"choose.editor.pageCannotBeMoved" | translate}}</div></div><img class="sort-disabled1" ng-show="slide.unreplace&&vm.sortStatus" ontouchstart="return false;" style="pointer-events: none;-webkit-user-select: none;-webkit-touch-callout: none"> <img ng-src="{{slide.background.resource.identifier+\'?imageMogr2/thumbnail/200x200>\'}}" ng-if="slide.background.resource.identifier" class="background backgroundImg{{$index}}" data-index="{{$index}}" ng-style="{\n                                     position: \'absolute\',\n                                     left:slide.background.offsetx*slide.styleScale,\n                                     top:slide.background.offsety*slide.styleScale,\n                                     width: slide.background.resource.adaptation==\'Width\'?\'100%\':\'\',\n                                     height:slide.background.resource.adaptation==\'Height\'?\'100%\':\'\'}"><div ng-repeat="level in slide.levels.level track by $index"><div class="sticker-edit-box" ng-if="level.imageart&&level.imageart.geometry" data-index="{{$index}}" ng-style="{\n                                     \'opacity\':level.imageart.transparency,\n                                     filter: \'alpha(opacity=\'+level.imageart.transparency*100+\')\',\n                                     \'transform\':\'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                     \'-ms-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                     \'-moz-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                     \'-webkit-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                     \'-o-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                     \'width\': level.imageart.geometry.width*slide.styleScale+2,\n                                     \'height\': level.imageart.geometry.height*slide.styleScale+2,\n                                     \'left\': level.imageart.geometry.x*slide.styleScale,\n                                     \'top\': level.imageart.geometry.y*slide.styleScale,\n                                     \'z-index\':level.seq-0+200}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                \'left\': level.imageart.offsetx*slide.styleScale,\n                                                \'top\': level.imageart.offsety*slide.styleScale,\n                                                \'width\': level.imageart.geometry.width * level.imageart.scale*slide.styleScale}" ng-src="{{level.imageart.resource.identifier+\'?imageMogr2/thumbnail/800x800>\'}}"></div></div><div ng-if="level.imagebox&&level.imagebox.geometry" ng-style="{\n                                            \'position\': \'absolute\',\n                                            width: imageboxW(level.imagebox) * slide.styleScale,\n                                            height: imageboxH(level.imagebox) * slide.styleScale,\n                                            left: imageboxL(level.imagebox) * slide.styleScale,\n                                            top: imageboxT(level.imagebox) * slide.styleScale,\n                                            \'z-index\':level.seq-0+200,\n                                            \'transform\': \'rotate(\' + level.imagebox.rotation.angle + \'deg)\',\n                                         }"><div class="relative-view1" ng-style="{\n                                         \'overflow\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'unset\' : \'hidden\',\n                                                \'opacity\':level.imagebox.transparency,\n                                                \'border-top-left-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'lt\', slide.styleScale),\n                                                \'border-top-right-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'rt\', slide.styleScale),\n                                                \'border-bottom-right-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'rb\', slide.styleScale),\n                                                \'border-bottom-left-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'lb\', slide.styleScale),\n                                                \'border-width\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? (level.imagebox.border.lineWidth * slide.styleScale) : \'\',\n                                                \'border-style\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? (level.imagebox.border.lineType || \'solid\') : \'none\',\n                                                \'border-color\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? level.imagebox.border.color : \'\',\n                                                \'box-shadow\' : (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineWidth>0 && (!level.imagebox.border.lineType || level.imagebox.border.lineType == \'solid\')) ? \'0 0 0 1px \' + level.imagebox.border.color + \' inset\' : \'none\',\n                                                \'filter\' : dropShadow(level.imagebox,slide.styleScale,slide.styleScale),\n                                                }"><div ng-style="{\n                                             \'position\': \'absolute\',\n                                             \'z-index\':0,\n                                            \'left\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'left\') * slide.styleScale : 0,\n                                            \'top\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'top\') * slide.styleScale : 0,\n                                            \'right\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'right\') * slide.styleScale : 0,\n                                            \'bottom\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'bottom\') * slide.styleScale : 0,\n                                            \'background-image\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'url(\' + level.imagebox.border.resource.identifier + \')\' : \'\',\n                                            \'background-size\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'100% 100%\' : \'\',\n                                            }"></div><div class="relative-view1" ng-style="{\n                                                    \'background\': level.imagebox.image.resource.identifier ? \'none\' : \'#ddd\',\n                                                    \'border-top-left-radius\':imageboxWRadius1(level.imagebox, \'lt\', slide.styleScale),\n                                                    \'border-top-right-radius\':imageboxWRadius1(level.imagebox, \'rt\', slide.styleScale),\n                                                    \'border-bottom-right-radius\':imageboxWRadius1(level.imagebox, \'rb\', slide.styleScale),\n                                                    \'border-bottom-left-radius\':imageboxWRadius1(level.imagebox, \'lb\', slide.styleScale),\n                                                    \'-webkit-mask-image\': level.imagebox.mask.resource.identifier ? \'url(\' + level.imagebox.mask.resource.identifier + \')\' : \'none\',\n                                                    \'-webkit-mask-size\': \'100% 100%\'}"><div style="position: relative"><div class="picLowerSize text-r" ng-cloak ng-show="level.imagebox && level.imagebox.image && level.imagebox.lowSize" ng-style="{ left:level.imagebox.geometry.width*slide.styleScale/2-8, top:level.imagebox.geometry.height*slide.styleScale/2-11}"><img src="content/images/ic_pixel.svg"></div></div><div class="img-place-holder indexSet-800" ng-hide="level.imagebox.image.resource.identifier"><img src="content/images/icons/addcamera.svg"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'None\' && level.imagebox.image.resource.identifier"><img ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/strip/rotate/\' + level.imagebox.image.angle+\'/thumbnail/800x800>\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                    \'width\': level.imagebox.image.width*level.imagebox.image.scale*slide.styleScale,\n                                                    \'height\': level.imagebox.image.height*level.imagebox.image.scale*slide.styleScale,\n                                                    \'left\':level.imagebox.image.offsetx*level.imagebox.image.scale*slide.styleScale,\n                                                    \'top\':level.imagebox.image.offsety*level.imagebox.image.scale*slide.styleScale\n                                                 }"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'Blurred\' && level.imagebox.image.resource.identifier"><img class="c-blur" ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/strip/rotate/\' + level.imagebox.image.angle+\'/thumbnail/800x800>\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                    \'width\': level.imagebox.image.width*slide.styleScale,\n                                                    \'height\': level.imagebox.image.height*slide.styleScale,\n                                                 }"> <img ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/strip/rotate/\' + level.imagebox.image.angle+\'/thumbnail/800x800>\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                    \'width\': level.imagebox.blurredrectangle.width*slide.styleScale,\n                                                    \'height\': level.imagebox.blurredrectangle.height*slide.styleScale,\n                                                    \'left\':level.imagebox.blurredrectangle.x*slide.styleScale,\n                                                    \'top\':level.imagebox.blurredrectangle.y*slide.styleScale,\n                                                    \'z-index\': 1\n                                                 }"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'Transparent\' && level.imagebox.image.resource.identifier"><img ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/strip/rotate/\' + level.imagebox.image.angle+\'/thumbnail/800x800>\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                    \'width\': level.imagebox.blurredrectangle.width*slide.styleScale,\n                                                    \'height\': level.imagebox.blurredrectangle.height*slide.styleScale,\n                                                    \'left\':level.imagebox.blurredrectangle.x*slide.styleScale,\n                                                    \'top\':level.imagebox.blurredrectangle.y*slide.styleScale,\n                                                    \'z-index\': 1\n                                                 }"></div></div></div></div><div class="text-box" ng-if="level.textbox&&level.textbox.geometry" data-index="{{$index}}" style="line-height: 0;min-height: 10px;min-width: 24px" ng-style="{\n                                     top: level.textbox.geometry.y*slide.styleScale,\n                                     left: level.textbox.geometry.x*slide.styleScale,\n                                     \'width\': level.textbox.geometry.width*slide.styleScale,\n                                     \'height\': level.textbox.geometry.height*slide.styleScale,\n                                     \'transform\': \'rotate(\' +  level.textbox.rotation.angle + \'deg)\',\n                                     \'z-index\':level.seq-0+200}"><pre class="c-xml-page-textboxe-text web-font" data-index="{{$index}}" ng-style="{\n                                            \'font-family\':  \'\\\'\' + level.textbox.fontuuid + \'\\\'\',\n                                            \'font-size\': (level.textbox.style.size*slide.ratio > 12 ? level.textbox.style.size* slide.ratio : 12) + \'pt\',\n                                            \'color\': level.textbox.style.color,\n                                            \'font-weight\': level.textbox.style.bold ? \'bold\': \'400\',\n                                            \'font-style\': level.textbox.style.italic ? \'italic\': \'initial\',\n                                            \'line-height\': (level.textbox.style.size* slide.ratio > 12 ? level.textbox.style.lineheight* slide.ratio : level.textbox.style.lineheight*12/level.textbox.style.size) + \'pt\',\n                                            \'letter-spacing\': (level.textbox.style.size* slide.ratio > 12 ? level.textbox.style.letterspacing* slide.ratio : level.textbox.style.letterspacing*12/level.textbox.style.size) + \'pt\',\n                                            \'opacity\': level.textbox.transparency,\n                                            \'text-decoration\': \'none\',\n                                            \'text-align\': level.textbox.style.align,\n                                            \'writing-mode\': level.textbox.style.writingmode,\n                                            \'text-align-last\': level.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',\n                                            \'transform\':\'scale(\'+(1 / 12 * level.textbox.style.size* slide.ratio > 1 ? 1 : 1 / 12 * level.textbox.style.size* slide.ratio)+\')\',\n                                            \'width\':  (level.textbox.style.size* slide.ratio > 12 ? (level.textbox.geometry.width*slide.styleScale):(level.textbox.geometry.width*slide.styleScale)/( 1 / 12 * level.textbox.style.size*slide.ratio))+\'px\'\n                                          }"><span class="c-xml-page-textboxe-span">{{level.textbox.text}}</span></pre></div><div data-index="{{$index}}" ng-show="level.textdocument&&level.textdocument.geometry" ng-style="{\n                                        position: \'absolute\',\n                                        width: level.textdocument.geometry.width*slide.styleScale,\n                                        height: level.textdocument.geometry.height*slide.styleScale,\n                                        left: level.textdocument.geometry.x*slide.styleScale,\n                                        top: level.textdocument.geometry.y*slide.styleScale,\n                                        \'z-index\':level.seq-0+200,\n                                        \'opacity\':level.textdocument.transparency.toFixed(2),\n                                        filter: \'alpha(opacity=\'+level.textdocument.transparency*100+\')\',\n                                        \'transform\': \'rotate(-\' + level.textdocument.rotation.angle + \'deg)\'}"><div style="overflow: hidden;width: 100%;height: 100%;position: relative" class="no-events"><img class="bg-image bg-image{{template.pageI}} pos" ng-cloak ng-if="level.textdocument.background.resource.identifier" ng-src="{{level.textdocument.background.resource.identifier+\'?imageMogr2/thumbnail/800x800>\'||\'//:0\'}}" ng-style="{\n                                                 position: \'absolute\',\n                                                 left:level.textdocument.background.offsetx*slide.styleScale,\n                                                 top:level.textdocument.background.offsety*slide.styleScale,\n                                                 width: level.textdocument.background.adaptation==\'Width\'?level.textdocument.geometry.width*slide.styleScale:\'\',\n                                                 height:level.textdocument.background.adaptation!=\'Width\'?level.textdocument.geometry.height*slide.styleScale:\'\'}"><div ng-repeat="docLevel in level.textdocument.levels.level track by $index" ng-init="docIndex = $index" style="position: relative"><div data-index="{{docIndex}}" class="img-art" ng-show="docLevel.imageart" ng-style="{\n                                                    width: docLevel.imageart.geometry.width*slide.styleScale,\n                                                    height: docLevel.imageart.geometry.height*slide.styleScale,\n                                                    left: docLevel.imageart.geometry.x*slide.styleScale,\n                                                    top: docLevel.imageart.geometry.y*slide.styleScale,\n                                                    \'z-index\':docLevel.seq-0+200,\n                                                    \'opacity\':docLevel.imageart.transparency,\n                                                    filter: \'alpha(opacity=\'+docLevel.imageart.transparency*100+\')\',\n                                                    \'transform\': \'rotate(\' + docLevel.imageart.rotation.angle + \'deg)\'}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                            \'left\': docLevel.imageart.offsetx*slide.styleScale,\n                                                            \'top\': docLevel.imageart.offsety*slide.styleScale,\n                                                            \'width\': docLevel.imageart.geometry.width * docLevel.imageart.scale*slide.styleScale}" ng-src="{{docLevel.imageart.resource.identifier+\'?imageMogr2/thumbnail/800x800>\'}}"></div></div><div class="c-xml-page-textboxe" ng-show="docLevel.textbox" style="white-space: normal" data-index="{{docIndex}}" ng-style="{\n                                                    \'width\': docLevel.textbox.geometry.width*slide.styleScale,\n                                                    \'left\': docLevel.textbox.geometry.x*slide.styleScale,\n                                                    \'top\': docLevel.textbox.geometry.y*slide.styleScale,\n                                                    \'transform\': \'rotate(\' + docLevel.textbox.rotation.angle + \'deg)\'}"><pre class="c-xml-page-textboxe-text web-font" ng-style="{\n                                                    \'font-family\':  \'\\\'\' + docLevel.textbox.fontuuid + \'\\\'\',\n                                                    \'font-size\': (docLevel.textbox.style.size*slide.ratio > 12 ? docLevel.textbox.style.size* slide.ratio : 12) + \'pt\',\n                                                    \'color\': docLevel.textbox.style.color,\n                                                    \'font-weight\': docLevel.textbox.style.bold ? \'bold\': \'400\',\n                                                    \'font-style\': docLevel.textbox.style.italic ? \'italic\': \'initial\',\n                                                    \'line-height\': (docLevel.textbox.style.size* slide.ratio > 12 ? docLevel.textbox.style.lineheight* slide.ratio : docLevel.textbox.style.lineheight*12/docLevel.textbox.style.size) + \'pt\',\n                                                    \'letter-spacing\': (docLevel.textbox.style.size* slide.ratio > 12 ? docLevel.textbox.style.letterspacing* slide.ratio : docLevel.textbox.style.letterspacing*12/docLevel.textbox.style.size) + \'pt\',\n                                                    \'opacity\': docLevel.textbox.transparency,\n                                                    \'text-decoration\': \'none\',\n                                                    \'text-align\': docLevel.textbox.style.align,\n                                                    \'text-align-last\': docLevel.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',\n                                                    \'transform\':\'scale(\'+(1 / 12 * docLevel.textbox.style.size* slide.ratio > 1 ? 1 : 1 / 12 * docLevel.textbox.style.size* slide.ratio)+\')\',\n                                                    \'width\':  (docLevel.textbox.style.size* slide.ratio > 12 ? (docLevel.textbox.geometry.width*slide.styleScale):docLevel.textbox.geometry.width*slide.styleScale/( 1 / 12 * docLevel.textbox.style.size*slide.ratio))+\'px\'\n                                                  }"><span class="c-xml-page-textboxe-span">{{docLevel.textbox.text}}</span></pre></div></div></div></div></div><div class="barcode" ng-show="slide.barcode" ng-style="{\n                                 \'z-index\':496,\n                                 \'width\': slide.barcode.geometry.width*slide.styleScale,\n                                 \'height\': slide.barcode.geometry.height*slide.styleScale,\n                                 \'left\': slide.barcode.geometry.x*slide.styleScale,\n                                 \'top\': slide.barcode.geometry.y*slide.styleScale,\n                                 \'transform\': \'rotate(-\' + slide.barcode.rotation.angle + \'deg)\' }"><img src="content/images/txm.png" style="width: 100%;height: 100%"></div><div class="barcode" ng-show="slide.qrcode" ng-style="{\n                                 \'z-index\':496,\n                                 \'width\': slide.qrcode.geometry.width*slide.styleScale,\n                                 \'height\': slide.qrcode.geometry.height*slide.styleScale,\n                                 \'left\': slide.qrcode.geometry.x*slide.styleScale,\n                                 \'top\': slide.qrcode.geometry.y*slide.styleScale,\n                                 \'transform\': \'rotate(-\' + slide.qrcode.rotation.angle + \'deg)\' }"><img src="content/images/QrCode.png" style="width: 100%;height: 100%"></div></div><div class="li-page text-left" ng-class="{\'is-left\':$index%2==0,\'is-right\':$index%2==1}">{{"choose.editor.page" | translate}}{{$index+1}}</div></li></ul></div><div class="col-lg-12 col-sm-12 col-xs-12 infoWaring flex-btn-group-container tip-image" style="padding: 0 10px;font-size: 12px;z-index:1" ng-show="vm.messageEdit.length&&status==\'make\'"><img src="content/images/icons/notice.svg" alt="" style="width:24px;height:24px;margin-right:5px;margin-top: 4px"><marquee scrollamount="2" height="30" behavior="scroll" direction="left" align="left" style="width: 100%;line-height: 30px">{{vm.messageEditText}}</marquee></div><!--\u56FE\u7247\u7F16\u8F91\u6309\u94AE--><div class="edit-menu edit-menu-make opacity-zero pad-top-60" ng-show="status==\'make\'&&!showCut&&!showTextModal && template.currentMenu != \'textbox\'" style="font-size: 0"><div class="common cut-image" ng-click="cutImage()"><i class="iconfont iconcaiqie1"></i> <span>{{"choose.editor.cut" | translate}}</span></div><!--\u4EA4\u6362--><div class="common change" ng-click="replaceImage()"><i class="iconfont iconjiaohuan"></i> <span>{{"choose.editor.exchange" | translate}}</span></div><!--\u5C55\u5F00--><div class="common mode1" ng-click="modeIn()"><i class="iconfont iconxingzhuang2"></i> <span>{{"choose.editor.spread" | translate}}</span></div><!--\u7F29\u5C0F--><div class="common mode2" ng-click="modeOut()"><i class="iconfont iconxingzhuang3"></i> <span>{{"choose.editor.shrink" | translate}}</span></div><button class="opacity-zero" style="height: 50px">1</button><!--<span class="trash opacityMinus opacity-zero">--><!--<img src="content/images/icons/change00.svg" alt=""/>--><!--</span>--></div><div class="c-operation-view" style="margin: 60px 0 10px" ng-if="template.currentMenu == \'textbox\'"><div class="c-operation-ntm" ng-click="textLayout(\'horizontal-tb\')" ng-if="template.pages.page[template.pageI].levels.level[template.levelI].textbox.style.writingmode != \'horizontal-tb\'"><i class="iconfont iconhengban"></i><div>{{"choose.editor.horizontal" | translate}}</div></div><div class="c-operation-ntm" ng-click="textLayout(\'vertical-lr\')" ng-if="template.pages.page[template.pageI].levels.level[template.levelI].textbox.style.writingmode != \'vertical-lr\'"><i class="iconfont iconshuban"></i><div>{{"choose.editor.vertical" | translate}}</div></div></div><!--\u5355\u5F20\u7F16\u8F91\u9875\u9762--><div ng-show="status==\'make\'&&!showCut&&!showTextModal"><input id="uploadImg1" type="file" multiple="multiple" accept="{{vm.supportedMimeTypes}}" name="file" value="" style="display: none"><div class="template-carousel" ng-style="{ width:dWidth*0.94, \'margin-top\':0}"><ul class="carousel5 transition-move js-fade fade-in is-paused" ng-style="{width:dWidth*PAGELEN}"><li ng-repeat="slide in template.pages.page track by $index" data-index="{{$index}}" class="slide-li" ng-style="{ \'margin-left\':slide.isMaxWidth?0:(dWidth*0.94-(dHeight-tHeight)*slide.mediabox.width/slide.mediabox.height)/2,\n                            \'margin-right\':slide.isMaxWidth?0:(dWidth*0.94-(dHeight-tHeight)*slide.mediabox.width/slide.mediabox.height)/2,\n                            \'margin-top\':(dHeight-(slide.isMaxWidth?dWidth*0.94*slide.mediabox.height/slide.mediabox.width:(dHeight-tHeight))-220)/2}" id="slide-li{{$index}}" ng-init="outerIndex = $index"><div class="slide-content" ng-style="{ background:slide.background.color,\n                                 width:(slide.isMaxWidth?dWidth*0.94:(dHeight-tHeight)*slide.mediabox.width/slide.mediabox.height).toFixed(2),\n                                 height:slide.isMaxWidth?dWidth*0.94*slide.mediabox.height/slide.mediabox.width:(dHeight-tHeight)}"><div class="border-red no-events" ng-repeat="editbox in slide.editboxes.editbox" ng-style="{\n                                \'z-index\':999,\n                                overflow:\'hidden\',\n                                width:editbox.width*slide.styleScale2,\n                                height:editbox.height*slide.styleScale2,\n                                top:editbox.y*slide.styleScale2,\n                                left:editbox.x*slide.styleScale2}"></div><img ng-src="{{slide.background.resource.identifier+\'?imageMogr2/thumbnail/800x800>\'}}" ng-show="slide.background.resource.identifier" class="background backgroundImg{{$index}}" id="backgroundImg{{$index}}" data-index="{{$index}}" ng-style="{\n                                             position: \'absolute\',\n                                             left:slide.background.offsetx*slide.styleScale2,\n                                             top:slide.background.offsety*slide.styleScale2,\n                                             width: slide.background.resource.adaptation==\'Width\'?\'100%\':\'auto\',\n                                             height:slide.background.resource.adaptation==\'Height\'?\'100%\':\'auto\'}"><div ng-repeat="level in slide.levels.level track by $index"><div class="sticker-edit-box" ng-if="level.imageart&&level.imageart.geometry" ng-click="editSticker($event, $index)" data-index="{{$index}}" ng-class="{\n                                         \'outline1-solid\': $index == template.levelI&& level.imageart.useradded && template.currentMenu == \'imageart\',\n                                         \'no-border\':!level.imageart.useradded,\n                                         \'no-events\':!level.imageart.useradded}" ng-style="{\n                                         \'opacity\':level.imageart.transparency,\n                                         filter: \'alpha(opacity=\'+level.imageart.transparency*100+\')\',\n                                         \'transform\':\'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                         \'-ms-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                         \'-moz-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                         \'-webkit-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                         \'-o-transform\': \'rotate(\' +  level.imageart.rotation.angle + \'deg)\',\n                                         \'width\': level.imageart.geometry.width*slide.styleScale2,\n                                         \'height\': level.imageart.geometry.height*slide.styleScale2,\n                                         \'left\': level.imageart.geometry.x*slide.styleScale2,\n                                         \'top\': level.imageart.geometry.y*slide.styleScale2,\n                                         \'z-index\':level.seq-0+200}"><span ng-click="deleteAction($event, $index)" class="delete-text opacityMinus" style="top: -14px;left: -10px;z-index:300" ng-show="$index == template.levelI && level.imageart.movable&&level.imageart.editable&& level.imageart.useradded"></span> <span data-index="{{$index}}" ontouchstart="resizeStickerStart(event)" ng-show="$index == template.levelI && level.imageart.movable&&level.imageart.editable&& level.imageart.useradded" style="right: -10px" ontouchmove="resizeStickerOn(event)" ontouchend="resizeStickerEnd(event)" class="resize-text"></span><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                    \'left\': level.imageart.offsetx*slide.styleScale2,\n                                                    \'top\': level.imageart.offsety*slide.styleScale2,\n                                                    \'width\': level.imageart.geometry.width * level.imageart.scale*slide.styleScale2}" ng-src="{{level.imageart.resource.identifier+\'?imageMogr2/thumbnail/800x800>\'}}"></div></div><div ng-if="level.imagebox&&level.imagebox.geometry" data-index="{{$index}}" ng-click="imageboxSelect($event)" ng-style="{\n                                        \'position\': \'absolute\',\n                                            width: imageboxW(level.imagebox) * slide.styleScale2,\n                                            height: imageboxH(level.imagebox) * slide.styleScale2,\n                                            left: imageboxL(level.imagebox) * slide.styleScale2,\n                                            top: imageboxT(level.imagebox) * slide.styleScale2,\n                                        \'z-index\':level.seq-0+200,\n                                        \'transform\': \'rotate(\' + level.imagebox.rotation.angle + \'deg)\',\n                                     }"><div class="relative-view1" ng-style="{\n                                             \'overflow\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'unset\' : \'hidden\',\n                                                \'opacity\':level.imagebox.transparency,\n                                                \'border-top-left-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'lt\', slide.styleScale2),\n                                                \'border-top-right-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'rt\', slide.styleScale2),\n                                                \'border-bottom-right-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'rb\', slide.styleScale2),\n                                                \'border-bottom-left-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'lb\', slide.styleScale2),\n                                                \'border-width\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? (level.imagebox.border.lineWidth * slide.styleScale2) : \'\',\n                                                \'border-style\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? (level.imagebox.border.lineType || \'solid\') : \'none\',\n                                                \'border-color\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? level.imagebox.border.color : \'\',\n                                                \'box-shadow\' : (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineWidth>0 && (!level.imagebox.border.lineType || level.imagebox.border.lineType == \'solid\')) ? \'0 0 0 1px \' + level.imagebox.border.color + \' inset\' : \'none\',\n                                                \'filter\' : dropShadow(level.imagebox,slide.styleScale2,slide.styleScale2),\n                                                }"><div ng-style="{\n                                             \'position\': \'absolute\',\n                                             \'z-index\':0,\n                                            \'left\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'left\') * slide.styleScale2 : 0,\n                                            \'top\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'top\') * slide.styleScale2 : 0,\n                                            \'right\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'right\') * slide.styleScale2 : 0,\n                                            \'bottom\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'bottom\') * slide.styleScale2 : 0,\n                                            \'background-image\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'url(\' + level.imagebox.border.resource.identifier + \')\' : \'\',\n                                            \'background-size\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'100% 100%\' : \'\',\n                                            }"></div><div class="relative-view1" ng-style="{\n                                                    \'background\': level.imagebox.image.resource.identifier ? \'none\' : \'#ddd\',\n                                                    \'border-top-left-radius\':imageboxWRadius1(level.imagebox, \'lt\', slide.styleScale2),\n                                                    \'border-top-right-radius\':imageboxWRadius1(level.imagebox, \'rt\', slide.styleScale2),\n                                                    \'border-bottom-right-radius\':imageboxWRadius1(level.imagebox, \'rb\', slide.styleScale2),\n                                                    \'border-bottom-left-radius\':imageboxWRadius1(level.imagebox, \'lb\', slide.styleScale2),\n                                                    \'-webkit-mask-image\': level.imagebox.mask.resource.identifier ? \'url(\' + level.imagebox.mask.resource.identifier + \')\' : \'none\',\n                                                    \'-webkit-mask-size\': \'100% 100%\'}"><div style="position: relative"><div class="picLowerSize text-r" ng-cloak ng-show="level.imagebox && level.imagebox.image && level.imagebox.lowSize" ng-style="{ left:level.imagebox.geometry.width*slide.styleScale2/2-8, top:level.imagebox.geometry.height*slide.styleScale2/2-11}"><img src="content/images/ic_pixel.svg"></div></div><div class="change-btn" id="change-btn{{outerIndex}}{{$index}}" ng-click="changeMaskImage(outerIndex, $index,$event)" ng-show="level.imagebox.image.resource.identifier" ng-style="{ left:level.imagebox.geometry.width*slide.styleScale2/2-20, top:level.imagebox.geometry.height*slide.styleScale2/2-20}"><img src="content/images/icons/change01.svg"></div><div class="img-place-holder indexSet-800" ng-hide="level.imagebox.image.resource.identifier"><img src="content/images/icons/addcamera.svg"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden;transition: all .5s ease" ng-if="level.imagebox.bokehtype == \'None\' && level.imagebox.image.resource.identifier"><img alt="" ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/strip/rotate/\' + level.imagebox.image.angle+\'/thumbnail/800x800>\'}}" data-index="{{$index}}" ontouchstart="moveImageboxStart(event)" ontouchmove="moveImageboxOn(event)" ontouchend="moveImageboxEnd(event)" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'opacity\':level.imagebox.transparency,\n                                                    \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                    \'width\': level.imagebox.image.width*level.imagebox.image.scale*slide.styleScale2,\n                                                    \'height\': level.imagebox.image.height*level.imagebox.image.scale*slide.styleScale2,\n                                                    \'left\':level.imagebox.image.offsetx*level.imagebox.image.scale*slide.styleScale2,\n                                                    \'top\':level.imagebox.image.offsety*level.imagebox.image.scale*slide.styleScale2\n                                                 }"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'Blurred\' && level.imagebox.image.resource.identifier"><img class="c-blur" ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/strip/rotate/\' + level.imagebox.image.angle+\'/thumbnail/800x800>\'}}" data-index="{{$index}}" ng-style="{\n                                                \'position\': \'absolute\',\n                                                    \'opacity\':level.imagebox.transparency,\n                                                    \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                \'width\': level.imagebox.image.width*slide.styleScale2,\n                                                \'height\': level.imagebox.image.height*slide.styleScale2,\n                                             }"> <img ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/strip/rotate/\' + level.imagebox.image.angle+\'/thumbnail/800x800>\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'opacity\':level.imagebox.transparency,\n                                                    \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                    \'width\': level.imagebox.blurredrectangle.width*slide.styleScale2,\n                                                    \'height\': level.imagebox.blurredrectangle.height*slide.styleScale2,\n                                                    \'left\':level.imagebox.blurredrectangle.x*slide.styleScale2,\n                                                    \'top\':level.imagebox.blurredrectangle.y*slide.styleScale2,\n                                                    \'z-index\': 1\n                                             }"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'Transparent\' && level.imagebox.image.resource.identifier"><img alt="" ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/strip/rotate/\' + level.imagebox.image.angle+\'/thumbnail/800x800>\'}}" data-index="{{$index}}" ng-style="{\n                                                \'position\': \'absolute\',\n                                                    \'opacity\':level.imagebox.transparency,\n                                                    \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                \'width\': level.imagebox.blurredrectangle.width*slide.styleScale2,\n                                                \'height\': level.imagebox.blurredrectangle.height*slide.styleScale2,\n                                                \'left\':level.imagebox.blurredrectangle.x*slide.styleScale2,\n                                                \'top\':level.imagebox.blurredrectangle.y*slide.styleScale2,\n                                                \'z-index\': 1\n                                             }"></div></div></div></div><div class="text-box text-setX textbox{{outerIndex}}-{{$index}}" data-targ="text" ng-if="level.textbox&&level.textbox.geometry" ng-class="{\'outline1-dashed\': $index == template.levelI,\'no-border\':!level.textbox.editable&&!level.textbox.movable&&!level.textbox.useradded,\n                                          \'pitch11\' : $index == template.levelI && level.textbox.useradded && template.currentMenu == \'textbox\'}" data-index="{{$index}}" style="line-height: 0;min-height: 10px;min-width: 24px" ng-style="{\n                                         top: level.textbox.geometry.y*slide.styleScale2,\n                                         left: level.textbox.geometry.x*slide.styleScale2,\n                                         width: level.textbox.geometry.width*slide.styleScale2,\n                                         height: level.textbox.geometry.height*slide.styleScale2,\n                                         \'transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\', \'z-index\': level.seq-0+200}"><div style="width: 100%;height: 100%;position: absolute;top:0;left: 0"><pre class="c-xml-page-textboxe-text web-font" id="c-xml-page-textboxe-text{{$index}}" ontouchstart="moveTextBoxStart(event)" ontouchmove="moveTextBoxOn(event)" ontouchend="moveTextBoxEnd(event)" data-index="{{$index}}" style="min-height: 10px" ng-style="{\n                                            \'font-family\':  \'\\\'\' + level.textbox.fontuuid + \'\\\'\',\n                                            \'font-size\': (level.textbox.style.size*slide.ratio2 > 12 ? level.textbox.style.size* slide.ratio2 : 12) + \'pt\',\n                                            \'color\': level.textbox.style.color,\n                                            \'font-weight\': level.textbox.style.bold ? \'bold\': \'400\',\n                                            \'font-style\': level.textbox.style.italic ? \'italic\': \'initial\',\n                                            \'line-height\': (level.textbox.style.size* slide.ratio2 > 12 ? level.textbox.style.lineheight* slide.ratio2 : level.textbox.style.lineheight*12/level.textbox.style.size) + \'pt\',\n                                            \'letter-spacing\': (level.textbox.style.size* slide.ratio2 > 12 ? level.textbox.style.letterspacing* slide.ratio2 : level.textbox.style.letterspacing*12/level.textbox.style.size) + \'pt\',\n                                            \'opacity\': level.textbox.transparency,\n                                            \'text-decoration\': \'none\',\n                                            \'text-align\': level.textbox.style.align,\n                                            \'writing-mode\': level.textbox.style.writingmode,\n                                            \'text-align-last\': level.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',\n                                            \'transform\':\'scale(\'+(1 / 12 * level.textbox.style.size* slide.ratio2 > 1 ? 1 : 1 / 12 * level.textbox.style.size* slide.ratio2)+\')\',\n                                            \'width\':  (level.textbox.style.size* slide.ratio2 > 12 ? (level.textbox.geometry.width*slide.styleScale2):(level.textbox.geometry.width*slide.styleScale2)/( 1 / 12 * level.textbox.style.size*slide.ratio2))+\'px\',\n                                            \'height\':  (text.textbox.style.size* slide.ratio2 > 12 ? (text.textbox.geometry.height*slide.styleScale2):text.textbox.geometry.height*slide.styleScale2/( 1 / 12 * text.textbox.style.size*slide.ratio2))+\'px\'\n                                          }"><span class="c-xml-page-textboxe-span">{{level.textbox.text}}</span></pre><div class="loading-font" ng-if="level.textbox.loading"></div></div><span class="delete-text" ng-show="$index == template.levelI&&level.textbox.editable&&level.textbox.useradded" data-index="{{$index}}" ng-click="deleteSelectedText($event, $index,outerIndex)"></span> <span class="edit-text" ng-show="$index == template.levelI&&level.textbox.editable&&level.textbox.useradded" ng-click="editTextContent($event, $index,level.textbox,outerIndex)"></span> <span class="resize-text" ng-show="$index == template.levelI&&level.textbox.movable&&level.textbox.useradded" data-index="{{$index}}" ontouchstart="resizeTextBoxStart(event)" ontouchmove="resizeTextBoxOn(event)" ontouchend="resizeTextBoxEnd(event)"></span></div><div data-index="{{$index}}" ng-show="level.textdocument&&level.textdocument.geometry" ontouchstart="moveTextDocStart(event)" ontouchmove="moveTextDocOn(event)" ontouchend="moveTextDocEnd(event)" ng-style="{\n                                        position: \'absolute\',\n                                        width: level.textdocument.geometry.width*slide.styleScale2,\n                                        height: level.textdocument.geometry.height*slide.styleScale2,\n                                        left: level.textdocument.geometry.x*slide.styleScale2,\n                                        top: level.textdocument.geometry.y*slide.styleScale2,\n                                        \'z-index\':level.seq-0+200,\n                                        \'opacity\':level.textdocument.transparency.toFixed(2),\n                                        filter: \'alpha(opacity=\'+level.textdocument.transparency*100+\')\',\n                                        \'transform\': \'rotate(-\' + level.textdocument.rotation.angle + \'deg)\'}" ng-click="selectDoc($event, $index, level.textdocument)"><div style="overflow: hidden;width: 100%;height: 100%;position: relative" class="no-events"><img class="bg-image bg-image{{template.pageI}} pos" ng-cloak ng-if="level.textdocument.background.resource.identifier" ng-src="{{level.textdocument.background.resource.identifier+\'?imageMogr2/thumbnail/800x800>\'||\'//:0\'}}" ng-style="{\n                                                 position: \'absolute\',\n                                                 left:level.textdocument.background.offsetx*slide.styleScale2,\n                                                 top:level.textdocument.background.offsety*slide.styleScale2,\n                                                 width: level.textdocument.background.adaptation==\'Width\'?level.textdocument.geometry.width*slide.styleScale2:\'\',\n                                                 height:level.textdocument.background.adaptation!=\'Width\'?level.textdocument.geometry.height*slide.styleScale2:\'\'}"><div ng-repeat="docLevel in level.textdocument.levels.level track by $index" ng-init="docIndex = $index" style="position: relative"><div data-index="{{docIndex}}" class="img-art" ng-show="docLevel.imageart" ng-style="{\n                                                    width: docLevel.imageart.geometry.width*slide.styleScale2,\n                                                    height: docLevel.imageart.geometry.height*slide.styleScale2,\n                                                    left: docLevel.imageart.geometry.x*slide.styleScale2,\n                                                    top: docLevel.imageart.geometry.y*slide.styleScale2,\n                                                    \'z-index\':docLevel.seq-0+200,\n                                                    \'opacity\':docLevel.imageart.transparency,\n                                                    filter: \'alpha(opacity=\'+docLevel.imageart.transparency*100+\')\',\n                                                    \'transform\': \'rotate(\' + docLevel.imageart.rotation.angle + \'deg)\'}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                            \'left\': docLevel.imageart.offsetx*slide.styleScale2,\n                                                            \'top\': docLevel.imageart.offsety*slide.styleScale2,\n                                                            \'width\': docLevel.imageart.geometry.width * docLevel.imageart.scale*slide.styleScale2}" ng-src="{{docLevel.imageart.resource.identifier+\'?imageMogr2/thumbnail/800x800>\'}}"></div></div><div class="c-xml-page-textboxe" ng-show="docLevel.textbox" style="white-space: normal" data-index="{{docIndex}}" ng-style="{\n                                                    \'width\': docLevel.textbox.geometry.width*slide.styleScale2,\n                                                    \'left\': docLevel.textbox.geometry.x*slide.styleScale2,\n                                                    \'top\': docLevel.textbox.geometry.y*slide.styleScale2,\n                                                    \'transform\': \'rotate(\' + docLevel.textbox.rotation.angle + \'deg)\'}"><pre class="c-xml-page-textboxe-text web-font" ng-style="{\n                                                    \'font-family\':  \'\\\'\' + docLevel.textbox.fontuuid + \'\\\'\',\n                                                    \'font-size\': (docLevel.textbox.style.size*slide.ratio2 > 12 ? docLevel.textbox.style.size* slide.ratio2 : 12) + \'pt\',\n                                                    \'color\': docLevel.textbox.style.color,\n                                                    \'font-weight\': docLevel.textbox.style.bold ? \'bold\': \'400\',\n                                                    \'font-style\': docLevel.textbox.style.italic ? \'italic\': \'initial\',\n                                                    \'line-height\': (docLevel.textbox.style.size* slide.ratio2 > 12 ? docLevel.textbox.style.lineheight* slide.ratio2 : docLevel.textbox.style.lineheight*12/docLevel.textbox.style.size) + \'pt\',\n                                                    \'letter-spacing\': (docLevel.textbox.style.size* slide.ratio2 > 12 ? docLevel.textbox.style.letterspacing* slide.ratio2 : docLevel.textbox.style.letterspacing*12/docLevel.textbox.style.size) + \'pt\',\n                                                    \'opacity\': docLevel.textbox.transparency,\n                                                    \'text-decoration\': \'none\',\n                                                    \'text-align\': docLevel.textbox.style.align,\n                                                    \'text-align-last\': docLevel.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',\n                                                    \'transform\':\'scale(\'+(1 / 12 * docLevel.textbox.style.size* slide.ratio2 > 1 ? 1 : 1 / 12 * docLevel.textbox.style.size* slide.ratio2)+\')\',\n                                                    \'width\':  (docLevel.textbox.style.size* slide.ratio2 > 12 ? (docLevel.textbox.geometry.width*slide.styleScale2):docLevel.textbox.geometry.width*slide.styleScale2/( 1 / 12 * docLevel.textbox.style.size*slide.ratio2))+\'px\'\n                                                  }"><span class="c-xml-page-textboxe-span">{{docLevel.textbox.text}}</span></pre><div class="loading-font" ng-if="docLevel.textbox.loading"></div></div></div></div></div></div><div class="barcode" ng-show="slide.barcode" ng-style="{\n                                     \'z-index\':499,\n                                     \'width\': slide.barcode.geometry.width*slide.styleScale2,\n                                     \'height\': slide.barcode.geometry.height*slide.styleScale2,\n                                     \'left\': slide.barcode.geometry.x*slide.styleScale2,\n                                     \'top\': slide.barcode.geometry.y*slide.styleScale2,\n                                     \'transform\': \'rotate(-\' + slide.barcode.rotation.angle + \'deg)\' }"><img src="content/images/txm.png" style="width: 100%;height: 100%"></div><div class="barcode" ng-show="slide.qrcode" ng-style="{\n                                     \'z-index\':499,\n                                     \'width\': slide.qrcode.geometry.width*slide.styleScale2,\n                                     \'height\': slide.qrcode.geometry.height*slide.styleScale2,\n                                     \'left\': slide.qrcode.geometry.x*slide.styleScale2,\n                                     \'top\': slide.qrcode.geometry.y*slide.styleScale2,\n                                     \'transform\': \'rotate(-\' + slide.qrcode.rotation.angle + \'deg)\' }"><img src="content/images/QrCode.png" style="width: 100%;height: 100%"></div></div></li></ul></div><button class="leftBtn opacityMinus ll{{$index}}" ng-click="pageLeft()" ng-show="visibleLeft" style="position: fixed!important;left: 10px"><span class="arrowDirections arrowLeft-new"></span></button> <button class="rightBtn opacityMinus rr{{$index}}" ng-click="pageRight()" ng-hide="visibleRight" style="position: fixed!important;right: 10px"><span class="arrowDirections arrowRight-new"></span></button></div></div><p class="text-width"></p><div id="small-pic" class="hide1 user-select-default pointer-un" ontouchstart="return false;" ng-style="{left:galleryX||0,top:galleryY||0}"><img ng-src="{{galleryChoose+\'?imageView2/1/w/60/h/60\'||\'//:0\'}}"></div><div class="text-tip hide1"><span>{{"choose.editor.nonReplaceable" | translate}}</span></div><div class="select-box" ng-if="vm.xmlShowPic"><div class="select-wrapper2"><div style="background: url(\'content/images/preview-close@2x.svg\') no-repeat; background-size: 100% 100%" id="previewClose" ng-click="previewClose()" ng-style="{\'right\':((dWidth-318)/2)+\'px\'}"></div><div class="containerTheme"><div class="img-div"><img ng-click="imgClick($event)" id="top-img" ng-src="{{vm.imgs[0].identifier +\'?imageView2\'||\'//:0\'}}" ng-if="vm.imgs.length>0" style="max-height: 400px; max-width: 318px; width: 100%"><div ng-if="vm.imgs.length == 0"><img src="content/images/notImg.png" style="margin-top: 150px;width: 160px"> <span class="noData-text">{{"hint.noData" | translate}}</span></div></div></div><div class="button-prev" style="background: url(\'content/images/prev_temp.svg\') no-repeat; background-size: 100% 100%" ng-click="prevImg()" ng-disabled="$index==1"></div><div class="button-next" style="background: url(\'content/images/next_temp.svg\') no-repeat; background-size: 100% 100%" ng-click="nextImg()" ng-disabled="$index== vm.imgs.length-1"></div></div><div class="c-modal-foot" style="position: absolute; bottom: 40px;left: 0"><button class="startMake btn diy-btn-primarys opacityMinus no-padding" style="background: #858585" ng-click="previewClose()">{{"choose.editor.sortBack" | translate}}</button> <button class="startMake btn diy-btn-primarys opacityMinus no-padding" ng-click="changeAllTemp()">{{"choose.editor.useTemplate" | translate}}</button></div></div><!--\u5E95\u90E8\u83DC\u5355--><div class="fix-bottom-section fix-text" style="box-shadow: none!important"><!--\u8D34\u7EB8\u83DC\u5355--><div class="mar-bottom-10 clipart-head sticker-wrapper col-xs-12 pad-0" style="height: 30px" ng-show="showStickerMenu"><button ng-repeat="label in labels track by $index" ng-click="selectLabel(label,$index)" data-index="{{$index}}" class="radius-btn" ng-class="{\'button-sel\':label.id==artlabelChooseId}">{{label.name}}</button></div><div class="sticker-menu col-xs-12 pad-0" ng-show="showStickerMenu"><div class="bottom-close col-xs-1 pad-0" ng-click="closeToBarMenu()"><i class="icon iconfont iconcuo default-btncolor-mobile font-20"></i></div><div class="sticker-wrapper sticker-scroll col-xs-11 pad-0"><span class="sticker-box" ng-repeat="sticker in stickerList | orderBy: \'sort\'"><img ng-src="{{sticker.identifier}}?imageMogr2/thumbnail/200x200>" ng-click="addSticker($event,sticker)" ng-style="{\'width\': 80, \'max-height\':80}"></span></div></div><!--\u6362\u4E66\u83DC\u5355--><div class="temp-menu" ng-show="showTempMenu"><div class="bottom-close col-xs-1 pad-0" ng-click="closeToBarMenu()"><i class="icon iconfont iconcuo default-btncolor-mobile font-20"></i></div><div class="sticker-wrapper col-xs-11 pad-0"><ul style="height: 92px;margin-top: 8px" class="" ng-style="{width:96*tempList.productXmlLines.length}" ng-show="tempList.productXmlLines.length"><li class="temp-li" ng-init="outerIndex = $index" ng-repeat="line in tempList.productXmlLines track by $index" ng-if="line.paid"><div style="width: 84px;min-height: 50px;line-height: 84px;position: relative" ng-click="showTempImg(line)" data-index="{{$index}}"><div class="select-temp" ng-show="line.id == vm.xmlId">{{"choose.editor.currentUse" | translate}}</div><img ng-src="{{line.coverImg}}?imageMogr2/thumbnail/200x200>" style="width: 100%"></div></li></ul><div ng-show="!tempList.productXmlLines.length" class="mar-left-10">{{"choose.editor.noReplaceableTemplate" | translate}}</div></div></div><!--\u5DE5\u4F5C\u533A\u56FE\u7247--><div style="height: 100px;min-width: 100vw;background: #fff" ng-show="showImageMenu"><div class="bottom-add col-xs-2 pad-0" style="width: 13%; height: 100px;background: #FFA91B" ng-click="addGallery()"><button></button> <span>{{"choose.editor.addPhoto" | translate}}</span></div><div class="sticker-wrapper col-xs-10 pad-0" style="position: relative;width: 87%"><ul style="height: 100px" class="image-ul pad-left-10" ng-if="qiniuId.length>=1"><li ng-repeat="gallery in qiniuId | orderBy: $index track by $index" class="photo-menu" data-imgindex="{{$index}}" ontouchstart="startChange(event)" ontouchmove="dragChange(event)" ontouchend="stopChange(event)"><img ng-src="{{gallery.identifier+\'?imageView2/1/w/84/h/84\'||\'//:0\'}}" alt="" class="imgPhoto pointer-un" ontouchstart="return false;" data-imgindex="{{$index}}"><div class="use-account diy-btn-primarys pointer-un" ontouchstart="return false;"><!-- \u4F7F\u7528\u6B21\u6570 --> <span>{{gallery.usenum}}</span></div></li></ul><div ng-if="galleryList.length<1" style="line-height: 100px" class="pad-left-20">{{"choose.editor.imageNotSelectedYet" | translate}}</div><div style="height: 100px;position: absolute;top:0" class="image-ul pad-left-10 hide1 image-ul-mask"></div></div></div><div class="col-lg-12 col-sm-12 col-xs-12 bottom-btn mar-bottom-10 pad-0" ng-show="showBottomMenu&&status==\'make\'&&!showCut"><div class="col-xs-12 text-c" ng-if="!showBarMenu"><div class="col-xs-3 pad-0" ng-click="toggleTempMenu($event)"><div class="tabIcons4"><i class="icon iconfont iconmoban1"></i></div><span>{{"choose.editor.template" | translate}}</span></div><div class="col-xs-3 pad-0" ng-click="toggleStickerMenu($event)"><div class="tabIcons4"><i class="icon iconfont iconcailiao"></i></div><span>{{"choose.editor.material" | translate}}</span></div><div class="col-xs-3 pad-0"><div ng-click="toggleTextMenu($event)" ng-show="fontList.length"><div class="tabIcons4"><i class="icon iconfont iconwenzi"></i></div><span>{{"choose.editor.text" | translate}}</span></div></div><div class="col-xs-3 pad-0" ng-click="toggleBarMenu($event)"><div class="tabIcons2"><i class="icon iconfont iconcuo"></i></div><span>{{"choose.editor.close" | translate}}</span></div></div><div class="col-xs-12 text-c" ng-if="showBarMenu"><div class="col-xs-9 pad-0"></div><div class="col-xs-3 pad-0" ng-click="toggleBarMenu($event)"><!--                        <div class="tabIcons4 editSelected2"></div>--><div class="tabIcons4"><i class="icon iconfont iconjia1"></i></div><span>{{"choose.editor.edit" | translate}}</span></div></div></div></div></div><div class="save-pages opacity-zero guide-view" ng-click="nextStep2()" ng-show="!vm.guideStep && countN == 7 && !loadingAfter"><!--\u4F5C\u54C1\u5236\u4F5C\u9875\u9762\u9884\u89C8\u5F15\u5BFC\u56FE--><div class="edit-page-content1" ng-style="{width:dWidth,\'min-height\':dHeight,background:status==\'make\'?\'#eee\':\'\'}"><div class="template-view" ng-show="status==\'view\'" style="width: 100%;overflow: visible;margin-top: 84px" ng-style="{\'height\':(dHeight-84)+\'px\'}"><ul class="carousel5"><li class="slide-li" ng-style="{ \'margin-left\':vm.pattern!=\'BOOK\'?10:(dWidth-dWidth*0.6)/2}" ng-init="outerIndex = 0"><div class="slide-content" ng-style="{\n                             overflow:\'hidden\',\n                             position:\'relative\',\n                             background:template.pages.page[0].background.color?\'\':\'#fff\',\n                             width:vm.pattern!=\'BOOK\'?(dWidth*0.45).toFixed(2):(dWidth*0.6).toFixed(2),\n                             height:vm.pattern!=\'BOOK\'?dWidth*0.45*template.pages.page[0].height/template.pages.page[0].width: dWidth*0.6*template.pages.page[0].height/template.pages.page[0].width}"><img ng-src="{{template.pages.page[0].background.resource.identifier+\'?imageMogr2/thumbnail/!20p\'}}" ng-if="template.pages.page[0].background.resource.identifier" ng-style="{\n                                             position: \'absolute\',\n                                             left:template.pages.page[0].background.offsetx,\n                                             top:template.pages.page[0].background.offsety,\n                                             width: template.pages.page[0].background.resource.adaptation==\'Width\'?\'100%\':\'\',\n                                             height:template.pages.page[0].background.resource.adaptation==\'Height\'?\'100%\':\'\'}"><div ng-repeat="level in template.pages.page[0].levels.level track by $index"><div ng-if="level.imagebox&&level.imagebox.geometry" ng-style="{\n                                                \'position\': \'absolute\',\n                                                width: imageboxW(level.imagebox),\n                                                height: imageboxH(level.imagebox),\n                                                left: imageboxL(level.imagebox),\n                                                top: imageboxT(level.imagebox),\n                                                \'z-index\':level.seq-0+200,\n                                                \'-webkit-mask-image\': level.imagebox.mask.resource.identifier ? \'url(\' + level.imagebox.mask.resource.identifier + \')\' : \'none\',\n                                                \'transform\': \'rotate(\' + level.imagebox.rotation.angle + \'deg)\',\n                                                \'-webkit-mask-size\': \'100% 100%\'\n                                            }"><div class="relative-view1" ng-style="{\n                                         \'overflow\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'unset\' : \'hidden\',\n                                                \'opacity\':level.imagebox.transparency,\n                                                \'border-top-left-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'lt\'),\n                                                \'border-top-right-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'rt\'),\n                                                \'border-bottom-right-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'rb\'),\n                                                \'border-bottom-left-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'lb\'),\n                                                \'border-width\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? (level.imagebox.border.lineWidth) : \'\',\n                                                \'border-style\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? (level.imagebox.border.lineType || \'solid\') : \'none\',\n                                                \'border-color\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? level.imagebox.border.color : \'\',\n                                                \'box-shadow\' : (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineWidth>0 && (!level.imagebox.border.lineType || level.imagebox.border.lineType == \'solid\')) ? \'0 0 0 1px \' + level.imagebox.border.color + \' inset\' : \'none\',\n                                                \'filter\' : dropShadow(level.imagebox,1,1),\n                                                }"><div ng-style="{\n                                             \'position\': \'absolute\',\n                                             \'z-index\':0,\n                                            \'left\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'left\') : 0,\n                                            \'top\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'top\') : 0,\n                                            \'right\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'right\') : 0,\n                                            \'bottom\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'bottom\') : 0,\n                                            \'background-image\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'url(\' + level.imagebox.border.resource.identifier + \')\' : \'\',\n                                            \'background-size\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'100% 100%\' : \'\',\n                                            }"></div><div class="relative-view1" ng-style="{\n                                                    \'background\': level.imagebox.image.resource.identifier ? \'none\' : \'#ddd\',\n                                                    \'border-top-left-radius\':imageboxWRadius1(level.imagebox, \'lt\'),\n                                                    \'border-top-right-radius\':imageboxWRadius1(level.imagebox, \'rt\'),\n                                                    \'border-bottom-right-radius\':imageboxWRadius1(level.imagebox, \'rb\'),\n                                                    \'border-bottom-left-radius\':imageboxWRadius1(level.imagebox, \'lb\'),\n                                                    \'-webkit-mask-image\': level.imagebox.mask.resource.identifier ? \'url(\' + level.imagebox.mask.resource.identifier + \')\' : \'none\',\n                                                    \'-webkit-mask-size\': \'100% 100%\'}"><div style="position: relative"><div class="picLowerSize text-r" ng-cloak ng-show="level.imagebox && level.imagebox.image && level.imagebox.lowSize" ng-style="{ left:level.imagebox.geometry.width/2-8, top:level.imagebox.geometry.height/2-11}"><img src="content/images/ic_pixel.svg"></div></div><div class="img-place-holder indexSet-800" ng-hide="level.imagebox.image.resource.identifier"><img src="content/images/icons/addcamera.svg"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'None\' && level.imagebox.image.resource.identifier"><img ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/strip/rotate/\' + level.imagebox.image.angle+\'/thumbnail/!20p\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                    \'width\': level.imagebox.image.width*level.imagebox.image.scale,\n                                                    \'height\': level.imagebox.image.height*level.imagebox.image.scale,\n                                                    \'left\':level.imagebox.image.offsetx*level.imagebox.image.scale,\n                                                    \'top\':level.imagebox.image.offsety*level.imagebox.image.scale\n                                                 }"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'Blurred\' && level.imagebox.image.resource.identifier"><img class="c-blur" ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/strip/rotate/\' + level.imagebox.image.angle+\'/thumbnail/!20p\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                    \'width\': level.imagebox.image.width,\n                                                    \'height\': level.imagebox.image.height,\n                                                 }"> <img ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/strip/rotate/\' + level.imagebox.image.angle+\'/thumbnail/!20p\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                    \'width\': level.imagebox.blurredrectangle.width,\n                                                    \'height\': level.imagebox.blurredrectangle.height,\n                                                    \'left\':level.imagebox.blurredrectangle.x,\n                                                    \'top\':level.imagebox.blurredrectangle.y,\n                                                    \'z-index\': 1\n                                                 }"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'Transparent\' && level.imagebox.image.resource.identifier"><img ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/strip/rotate/\' + level.imagebox.image.angle+\'/thumbnail/!20p\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                    \'width\': level.imagebox.blurredrectangle.width,\n                                                    \'height\': level.imagebox.blurredrectangle.height,\n                                                    \'left\':level.imagebox.blurredrectangle.x,\n                                                    \'top\':level.imagebox.blurredrectangle.y\n                                                 }"></div></div></div></div><div class="sticker-edit-box" data-index="{{$index}}" ng-if="level.imageart&&level.imageart.geometry" ng-style="{\n                                     \'opacity\':level.imageart.transparency,\n                                     filter: \'alpha(opacity=\'+level.imageart.transparency*100+\')\',\n                                     \'transform\':\'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                     \'-ms-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                     \'-moz-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                     \'-webkit-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                     \'-o-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                     \'width\': level.imageart.geometry.width+2,\n                                     \'height\': level.imageart.geometry.height+2,\n                                     \'left\': level.imageart.geometry.x,\n                                     \'top\': level.imageart.geometry.y,\n                                     \'z-index\':level.seq-0+200}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                \'left\': level.imageart.offsetx,\n                                                \'top\': level.imageart.offsety,\n                                                \'width\': level.imageart.geometry.width * level.imageart.scale}" ng-src="{{level.imageart.resource.identifier+\'?imageView2\'}}"></div></div><div class="text-box" ng-if="level.textbox&&level.textbox.geometry" data-index="{{$index}}" style="line-height: 0;min-height: 10px;min-width: 24px" ng-style="{\n                                     top: level.textbox.geometry.y,\n                                     left: level.textbox.geometry.x,\n                                     width: level.textbox.geometry.width,\n                                     height: level.textbox.geometry.height,\n                                     \'transform\': \'rotate(\' +  level.textbox.rotation.angle + \'deg)\',\n                                     \'z-index\':level.seq-0+200}"><pre class="c-xml-page-textboxe-text web-font" data-index="{{$index}}" ng-style="{\n                                            \'font-family\':  \'\\\'\' + level.textbox.fontuuid + \'\\\'\',\n                                            \'font-size\': (level.textbox.style.size*template.pages.page[0].ratio > 12 ? level.textbox.style.size* template.pages.page[0].ratio : 12) + \'pt\',\n                                            \'color\': level.textbox.style.color,\n                                            \'font-weight\': level.textbox.style.bold ? \'bold\': \'400\',\n                                            \'font-style\': level.textbox.style.italic ? \'italic\': \'initial\',\n                                            \'line-height\': (level.textbox.style.size* template.pages.page[0].ratio > 12 ? level.textbox.style.lineheight* template.pages.page[0].ratio : level.textbox.style.lineheight*12/level.textbox.style.size) + \'pt\',\n                                            \'letter-spacing\': (level.textbox.style.size* template.pages.page[0].ratio > 12 ? level.textbox.style.letterspacing* template.pages.page[0].ratio : level.textbox.style.letterspacing*12/level.textbox.style.size) + \'pt\',\n                                            \'opacity\': level.textbox.transparency,\n                                            \'text-decoration\': \'none\',\n                                            \'text-align\': level.textbox.style.align,\n                                            \'writing-mode\': level.textbox.style.writingmode,\n                                            \'text-align-last\': level.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',\n                                            \'transform\':\'scale(\'+(1 / 12 * level.textbox.style.size* template.pages.page[0].ratio > 1 ? 1 : 1 / 12 * level.textbox.style.size* template.pages.page[0].ratio)+\')\',\n                                            \'width\':  (level.textbox.style.size* template.pages.page[0].ratio > 12 ? (level.textbox.geometry.width):(level.textbox.geometry.width)/( 1 / 12 * level.textbox.style.size*slide.ratio))+\'px\'\n                                          }"><span class="c-xml-page-textboxe-span">{{level.textbox.text}}</span></pre></div><div data-index="{{$index}}" ng-show="level.textdocument&&level.textdocument.geometry" ng-style="{\n                                        position: \'absolute\',\n                                        width: level.textdocument.geometry.width,\n                                        height: level.textdocument.geometry.height,\n                                        left: level.textdocument.geometry.x,\n                                        top: level.textdocument.geometry.y,\n                                        \'z-index\':level.seq-0+200,\n                                        \'opacity\':level.textdocument.transparency.toFixed(2),\n                                        filter: \'alpha(opacity=\'+level.textdocument.transparency*100+\')\',\n                                        \'transform\': \'rotate(-\' + level.textdocument.rotation.angle + \'deg)\'}"><div style="overflow: hidden;width: 100%;height: 100%;position: relative" class="no-events"><img class="bg-image bg-image{{template.pageI}} pos" ng-cloak ng-if="level.textdocument.background.resource.identifier" ng-src="{{level.textdocument.background.resource.identifier||\'//:0\'}}" ng-style="{\n                                                 position: \'absolute\',\n                                                 left:level.textdocument.background.offsetx,\n                                                 top:level.textdocument.background.offsety,\n                                                 width: level.textdocument.background.adaptation==\'Width\'?level.textdocument.geometry.width:\'\',\n                                                 height:level.textdocument.background.adaptation!=\'Width\'?level.textdocument.geometry.height:\'\'}"><div ng-repeat="docLevel in level.textdocument.levels.level track by $index" ng-init="docIndex = $index" style="position: relative"><div data-index="{{docIndex}}" class="img-art" ng-show="docLevel.imageart" ng-style="{\n                                                    width: docLevel.imageart.geometry.width,\n                                                    height: docLevel.imageart.geometry.height,\n                                                    left: docLevel.imageart.geometry.x,\n                                                    top: docLevel.imageart.geometry.y,\n                                                    \'z-index\':docLevel.seq-0+200,\n                                                    \'opacity\':docLevel.imageart.transparency,\n                                                    filter: \'alpha(opacity=\'+docLevel.imageart.transparency*100+\')\',\n                                                    \'transform\': \'rotate(\' + docLevel.imageart.rotation.angle + \'deg)\'}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                            \'left\': docLevel.imageart.offsetx,\n                                                            \'top\': docLevel.imageart.offsety,\n                                                            \'width\': docLevel.imageart.geometry.width * docLevel.imageart.scale}" ng-src="{{docLevel.imageart.resource.identifier+\'?imageView2\'}}"></div></div><div class="c-xml-page-textboxe" ng-show="docLevel.textbox" style="white-space: normal" data-index="{{docIndex}}" ng-style="{\n                                                    \'width\': docLevel.textbox.geometry.width,\n                                                    \'left\': docLevel.textbox.geometry.x,\n                                                    \'top\': docLevel.textbox.geometry.y,\n                                                    \'transform\': \'rotate(\' + docLevel.textbox.rotation.angle + \'deg)\'}"><pre class="c-xml-page-textboxe-text web-font" ng-style="{\n                                                    \'font-family\':  \'\\\'\' + docLevel.textbox.fontuuid + \'\\\'\',\n                                                    \'font-size\': (docLevel.textbox.style.size*slide.ratio > 12 ? docLevel.textbox.style.size* slide.ratio : 12) + \'pt\',\n                                                    \'color\': docLevel.textbox.style.color,\n                                                    \'font-weight\': docLevel.textbox.style.bold ? \'bold\': \'400\',\n                                                    \'font-style\': docLevel.textbox.style.italic ? \'italic\': \'initial\',\n                                                    \'line-height\': (docLevel.textbox.style.size* slide.ratio > 12 ? docLevel.textbox.style.lineheight* slide.ratio : docLevel.textbox.style.lineheight*12/docLevel.textbox.style.size) + \'pt\',\n                                                    \'letter-spacing\': (docLevel.textbox.style.size* slide.ratio > 12 ? docLevel.textbox.style.letterspacing* slide.ratio : docLevel.textbox.style.letterspacing*12/docLevel.textbox.style.size) + \'pt\',\n                                                    \'opacity\': docLevel.textbox.transparency,\n                                                    \'text-decoration\': \'none\',\n                                                    \'text-align\': docLevel.textbox.style.align,\n                                                    \'text-align-last\': docLevel.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',\n                                                    \'transform\':\'scale(\'+(1 / 12 * docLevel.textbox.style.size* slide.ratio > 1 ? 1 : 1 / 12 * docLevel.textbox.style.size* slide.ratio)+\')\',\n                                                    \'width\':  (docLevel.textbox.style.size* slide.ratio > 12 ? (docLevel.textbox.geometry.width):docLevel.textbox.geometry.width/( 1 / 12 * docLevel.textbox.style.size*slide.ratio))+\'px\'\n                                                  }"><span class="c-xml-page-textboxe-span">{{docLevel.textbox.text}}</span></pre></div></div></div></div></div><div class="barcode" ng-show="template.pages.page[0].barcode" ng-style="{\n                                 \'z-index\':999,\n                                 \'width\': template.pages.page[0].barcode.geometry.width,\n                                 \'height\': template.pages.page[0].barcode.geometry.height,\n                                 \'left\': template.pages.page[0].barcode.geometry.x,\n                                 \'top\': template.pages.page[0].barcode.geometry.y,\n                                 \'transform\': \'rotate(-\' + template.pages.page[0].barcode.rotation.angle + \'deg)\' }"><img src="content/images/txm.png" style="width: 100%;height: 100%"></div><div class="barcode" ng-show="template.pages.page[0].qrcode" ng-style="{\n                                 \'z-index\':999,\n                                 \'width\': template.pages.page[0].qrcode.geometry.width,\n                                 \'height\': template.pages.page[0].qrcode.geometry.height,\n                                 \'left\': template.pages.page[0].qrcode.geometry.x,\n                                 \'top\': template.pages.page[0].qrcode.geometry.y,\n                                 \'transform\': \'rotate(-\' + template.pages.page[0].qrcode.rotation.angle + \'deg)\' }"><img src="content/images/QrCode.png" style="width: 100%;height: 100%"></div></div><div class="li-page left-45">{{"choose.pageType.Cover" | translate}}</div></li></ul><div style="margin-top: 6px" ng-style="{\'text-align\':vm.pattern!=\'BOOK\'?\'left\':\'center\'}"><!-- <img src="content/images/single-edit.svg" alt="\u5355\u9875\u7F16\u8F91"/> --><div class="Lead-Bubble Lead-Bubble-CT"><span>{{\'choose.editor.clickOnePageGoEditor\' | translate}}</span></div></div></div></div><div class="next-step2" style="bottom: 60px"><button class="c-btn-next">{{"choose.editor.nextStep" | translate}}</button></div><div class="never-hint" ng-click="neverHint()">{{"choose.editor.notTips" | translate}}</div></div><div class="save-pages" ng-click="nextStep3()" ng-show="!vm.guideStep && (countN == 9 || countN == 10 || countN == 11 || countN == 12 || countN == 13)"><!--\u5355\u9875\u7F16\u8F91\u5F15\u5BFC\u56FE  \u6A21\u677F\u3001\u7D20\u83DC\u3001\u6587\u5B57\u7684\u66FF\u6362--><div class="col-lg-12 col-sm-12 col-xs-12 mar-bottom-10 pad-0" style="position: fixed;bottom: 0px"><div class="col-xs-12 text-c clearfix"><div class="col-xs-3 pad-0" style="float: left" ng-class="9 == countN ? \'\' :\'hide\'"><!-- <img src="content/images/change-template.svg" alt="\u66F4\u6362\u6A21\u677F" style="margin-left: 20px;"> --><div class="Lead-Bubble Lead-Bubble-LB"><span>{{\'choose.editor.replaceInnerTemplate\' | translate}}</span></div><div class="tabIcons2"><img src="content/images/icons/temp-show.svg"></div><span style="color: #fff;display: block">{{"choose.editor.template" | translate}}</span></div><div class="col-xs-3 pad-0" style="float: left;margin-left: 25%" ng-class="10 == countN ? \'\' :\'hide\'"><!-- <img src="content/images/add-material.svg" alt="\u6DFB\u52A0\u7D20\u6750" style="margin-left: -60px;"> --><div class="Lead-Bubble Lead-Bubble-CB" style="transform: translateX(-28%)"><span>{{\'choose.editor.dddFootageToComp\' | translate}}</span></div><div class="tabIcons2"><img src="content/images/icons/sucai-show.svg"></div><span style="color: #fff;display: block">{{"choose.editor.material" | translate}}</span></div><div class="col-xs-3 pad-0" style="float: left;margin-left: 50%" ng-class="11 == countN ? \'\' :\'hide\'"><!-- <img src="content/images/change-font.svg" alt="\u66F4\u6539\u6587\u5B57" style="margin-left: -60px;"> --><div class="Lead-Bubble Lead-Bubble-CB" style="transform: translateX(-28%)"><span>{{\'choose.editor.addTextEditor\' | translate}}</span></div><div><div class="tabIcons2"><img src="content/images/icons/text-show.svg"></div><span style="color: #fff;display: block">{{"choose.editor.text" | translate}}</span></div></div></div></div><!--\u88C1\u526A\u3001\u66FF\u6362\u56FE\u6807\u5F15\u5BFC--><div class="edit-menu pad-top-60" ng-show="status==\'make\'&&!showCut&&!showTextModal" style="font-size: 0"><span style="display: inline-block;position: relative" ng-class="12 == countN ? \'\' :\'hide\'"><img src="content/images/icons/crop2.svg" alt=""><!-- <img src="content/images/caijian.svg" alt="\u88C1\u526A\u56FE\u7247"\n                     style="position: absolute;bottom: -100px;left: -20px;"/> --><div class="Lead-Bubble Lead-Bubble-LT"><span>{{\'choose.editor.choosePhoto\' | translate}}</span></div></span><span style="display: inline-block;position: relative;margin-left: 42px" ng-class="13 == countN ? \'\' :\'hide\'"><img src="content/images/icons/exchange2.svg" alt=""><!-- <img src="content/images/exchange-photo.svg" alt="\u4EA4\u6362\u56FE\u7247\u4F4D\u7F6E"\n                     style="position: absolute;bottom: -100px;left: -15px;"/> --><div class="Lead-Bubble Lead-Bubble-LT"><span>{{\'choose.editor.changePictureInTemplate\' | translate}}</span></div></span></div><div class="next-step2" ng-if="13 != countN"><button class="c-btn-next">{{"choose.editor.nextStep" | translate}}</button></div><div class="next-step2" ng-if="13 == countN"><!-- <img src="content/images/experience.svg"/> --> <button class="c-btn-next">{{"choose.editor.experience" | translate}}</button></div><div class="never-hint" ng-click="neverHint()">{{"choose.editor.notTips" | translate}}</div></div></div><!--\u6587\u5B57\u68C0\u6D4B\u7ED3\u679C--><div class="c-modal" ng-if="vm.isDocumentTextDetection"><div class="exit-box-mask"></div><div class="exit-box-con1"><div class="c-documentTextDetection-title">{{"choose.editorMessage.documentTextDetectionTitle" | translate}}</div><div class="c-documentTextDetection-list" ng-repeat="item in vm.documentTextDetection track by $index"><div class="c-documentTextDetection-list-title" translate="choose.editorMessage.documentTextDetectionNum" translate-values="{pageIndex:item.pageIndex}"></div><div class="c-documentTextDetection-list-body" ng-repeat="text in item.texts">{{text}}</div></div><div class="c-documentTextDetection-save"><div class="c-documentTextDetection-save1" ng-click="vm.isDocumentTextDetection=false">{{"choose.editor.cancel" | translate}}</div><div class="c-documentTextDetection-save2" ng-click="clickToEdit(template.pages.page[vm.documentTextDetection[0].pageIndex-1],vm.documentTextDetection[0].pageIndex-1)">{{"choose.editor.goRevise" | translate}}</div></div></div></div><div class="move-tip1" ng-if="vm.hint"><i class="iconfont iconjinggao"></i> <span>{{"hint.pageHint" | translate}}</span></div><!--\u5C01\u9762\u7F29\u7565\u56FEview--><div class="thumbnail-view" style="transform: scale(0.01)"><div id="thumbnail-view" style="position: absolute; z-index: -1" ng-style="{\n            \'width\': template.pages.page[0].mediabox.width,\n            \'height\': template.pages.page[0].mediabox.height,\n             left: -(template.pages.page[0].mediabox.width - template.pages.page[0].mediabox.width*vm.thumbnailScale)/2,\n             top: -(template.pages.page[0].mediabox.height - template.pages.page[0].mediabox.height*vm.thumbnailScale)/2,\n            \'background\': template.pages.page[0].background.color ? template.pages.page[0].background.color : \'none\',\n            \'transform\':\'scale(\' + vm.thumbnailScale + \')\'\n            }"><div style="width: 100%; height: 100%; position: relative"><div ng-style="{\n                                \'position\': \'absolute\',\n                                \'width\': template.pages.page[0].mediabox.width,\n                                \'height\': template.pages.page[0].mediabox.height,\n                                \'left\': template.pages.page[0].mediabox.x,\n                                \'top\': template.pages.page[0].mediabox.y,\n                                \'background\': template.pages.page[0].background.color ? template.pages.page[0].background.color : \'none\'\n                                }"><div style="width: 100%; height: 100%; position: relative; overflow: hidden"><img ng-src="{{template.pages.page[0].background.resource.identifier}}" alt="" ng-if="template.pages.page[0].background.resource.identifier" ng-style="{\n                                            \'position\': \'absolute\',\n                                             width: template.pages.page[0].background.resource.adaptation==\'Width\'?\'100%\':\'auto\',\n                                             height:template.pages.page[0].background.resource.adaptation==\'Height\'?\'100%\':\'auto\',\n                                            \'left\': template.pages.page[0].background.offsetx,\n                                            \'top\': template.pages.page[0].background.offsety\n                                        }"></div><div style="position: absolute;width: 100%; height: 100%; left: 0; top: 0" ng-repeat="level in template.pages.page[0].levels.level track by $index"><div ng-if="level.imagebox" ng-style="{\n                                                \'position\': \'absolute\',\n                                        width: imageboxW(level.imagebox),\n                                        height: imageboxH(level.imagebox),\n                                        left: imageboxL(level.imagebox),\n                                        top: imageboxT(level.imagebox),\n                                            \'z-index\':level.seq-0+200,\n                                            \'transform\': \'rotate(\' + level.imagebox.rotation.angle + \'deg)\'\n                                         }"><div class="relative-view1" ng-style="{\n                             \'overflow\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'unset\' : \'hidden\',\n                            \'border-top-left-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius2(level.imagebox, \'lt\'),\n                            \'border-top-right-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius2(level.imagebox, \'rt\'),\n                            \'border-bottom-right-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius2(level.imagebox, \'rb\'),\n                            \'border-bottom-left-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius2(level.imagebox, \'lb\'),\n                            \'border-width\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? (level.imagebox.border.lineWidth) : \'\',\n                                                \'border-style\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? (level.imagebox.border.lineType || \'solid\') : \'none\',\n                            \'border-color\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? level.imagebox.border.color : \'\',\n                                                \'box-shadow\' : (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineWidth>0 && (!level.imagebox.border.lineType || level.imagebox.border.lineType == \'solid\')) ? \'0 0 0 1px \' + level.imagebox.border.color + \' inset\' : \'none\',\n                                                \'filter\' : dropShadow(level.imagebox,1,1),\n                            }"><div ng-style="{\n                                 \'position\': \'absolute\',\n                                 \'z-index\':0,\n                                \'left\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'left\') : 0,\n                                \'top\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'top\') : 0,\n                                \'right\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'right\') : 0,\n                                \'bottom\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'bottom\') : 0,\n                                \'background-image\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'url(\' + level.imagebox.border.resource.identifier + \')\' : \'\',\n                                \'background-size\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'100% 100%\' : \'\',\n                                }"></div><div class="relative-view1" style="position: absolute" ng-style="{\n                                 width: (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? level.imagebox.geometry.width : \'100%\',\n                                 height: (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? level.imagebox.geometry.height : \'100%\',\n                                 \'left\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : ((level.imagebox.border && level.imagebox.border.type == \'Color\') ? (level.imagebox.border.lineWidth) : 0),\n                                 \'top\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : ((level.imagebox.border && level.imagebox.border.type == \'Color\') ? (level.imagebox.border.lineWidth) : 0),\n                                \'border-top-left-radius\':imageboxWRadius3(level.imagebox, \'lt\'),\n                                \'border-top-right-radius\':imageboxWRadius3(level.imagebox, \'rt\'),\n                                \'border-bottom-right-radius\':imageboxWRadius3(level.imagebox, \'rb\'),\n                                \'border-bottom-left-radius\':imageboxWRadius3(level.imagebox, \'lb\'),\n                                }"><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'None\'"><img alt="" ng-if="level.imagebox.image.resource.identifier" ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/strip/rotate/\' + level.imagebox.image.angle+\'/thumbnail/800x800\'}}" ng-style="{\n                                            \'position\': \'absolute\',\n                                            \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                            \'width\': level.imagebox.image.width*level.imagebox.image.scale * vm.thumbnailScale1,\n                                            \'height\': level.imagebox.image.height*level.imagebox.image.scale * vm.thumbnailScale1,\n                                            \'left\':level.imagebox.image.offsetx*level.imagebox.image.scale * vm.thumbnailScale1,\n                                            \'top\':level.imagebox.image.offsety*level.imagebox.image.scale * vm.thumbnailScale1,\n                                            \'opacity\':level.imagebox.transparency\n                                         }"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'Blurred\'"><img alt="" ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/strip/rotate/\' + level.imagebox.image.angle+\'/thumbnail/800x800/blur/40x1000\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.imagebox.image.width*level.imagebox.image.scale * vm.thumbnailScale1,\n                                                    \'height\': level.imagebox.image.height*level.imagebox.image.scale * vm.thumbnailScale1,\n                                                    \'left\':level.imagebox.image.offsetx*level.imagebox.image.scale * vm.thumbnailScale1,\n                                                    \'top\':level.imagebox.image.offsety*level.imagebox.image.scale * vm.thumbnailScale1,\n                                                    \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\'\n                                                 }"> <img ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/strip/rotate/\' + level.imagebox.image.angle+\'/thumbnail/800x800\'}}" ng-style="{\n                                                        \'position\': \'absolute\',\n                                                        \'width\': level.imagebox.blurredrectangle.width*level.imagebox.image.scale * vm.thumbnailScale1,\n                                                        \'height\': level.imagebox.blurredrectangle.height*level.imagebox.image.scale * vm.thumbnailScale1,\n                                                        \'left\':level.imagebox.blurredrectangle.x*level.imagebox.image.scale * vm.thumbnailScale1,\n                                                        \'top\':level.imagebox.blurredrectangle.y*level.imagebox.image.scale * vm.thumbnailScale1,\n                                                    \'z-index\': 1,\n                                                        \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\'\n                                                 }"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'Transparent\'"><img alt="" ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/strip/rotate/\' + level.imagebox.image.angle+\'/thumbnail/800x800\'}}" data-index="{{$index}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'width\': level.imagebox.blurredrectangle.width*level.imagebox.image.scale * vm.thumbnailScale1,\n                                                    \'height\': level.imagebox.blurredrectangle.height*level.imagebox.image.scale * vm.thumbnailScale1,\n                                                    \'left\':level.imagebox.blurredrectangle.x*level.imagebox.image.scale * vm.thumbnailScale1,\n                                                    \'top\':level.imagebox.blurredrectangle.y*level.imagebox.image.scale * vm.thumbnailScale1,\n                                                    \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\'\n                                                 }"></div></div></div></div><div ng-if="level.imageart" class="c-xml-page-material" ng-style="{\n                             \'position\': \'absolute\',\n                                            \'width\': level.imageart.geometry.width,\n                                            \'height\': level.imageart.geometry.height,\n                                            \'left\': level.imageart.geometry.x,\n                                            \'top\': level.imageart.geometry.y,\n                                            \'transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                            \'z-index\':level.seq-0+200\n                                         }"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img class="c-xml-page-material-img" style="position: absolute" ng-if="level.imageart.resource.identifier" ng-src="{{ level.imageart.resource.identifier ? level.imageart.resource.identifier : \'\'}}" ng-style="{\n                                                        \'transform\': level.imageart.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                \'opacity\' : level.imageart.transparency,\n                                                \'left\': level.imageart.offsetx + \'px\',\n                                                \'top\': level.imageart.offsety + \'px\',\n                                                \'width\': level.imageart.geometry.width * level.imageart.scale\n                                             }" alt="\u7D20\u6750\u56FE\u7247"></div></div><div ng-if="level.textbox" class="c-xml-page-textboxe" ng-style="{\n                                                \'position\': \'absolute\',\n                                            \'width\': level.textbox.geometry.width,\n                                            \'height\': level.textbox.geometry.height,\n                                            \'line-height\': level.textbox.geometry.height + \'px\',\n                                            \'left\': level.textbox.geometry.x,\n                                            \'top\': level.textbox.geometry.y,\n                                            \'transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\',\n                                            \'z-index\': level.seq-0+200,\n                                         }"><pre class="c-xml-page-textboxe-text web-font" ng-style="{\n                                                \'font-family\': \'\\\'\' + level.textbox.fontuuid + \'\\\'\',\n                                                \'font-size\': level.textbox.style.size + \'pt\',\n                                                \'color\': level.textbox.style.color,\n                                                \'font-weight\': level.textbox.style.bold ? \'bold\': \'400\',\n                                                \'font-style\': level.textbox.style.italic ? \'italic\': \'initial\',\n                                                \'line-height\': level.textbox.style.lineheight + \'pt\',\n                                                \'letter-spacing\': level.textbox.style.letterspacing + \'pt\',\n\n                                                \'text-decoration\': \'none\',\n                                                \'text-align\': level.textbox.style.align,\n                                                \'text-align-last\': level.textbox.style.align == \'justified\' ? \'justify\' : \'unset\',\n                                                transform:\'scale(\'+(vm.thumbnailScale)+\')\',\n                                                \'transform-origin\': \'0 0\',\n                                                \'writing-mode\': level.textbox.style.writingmode,\n                                                width: level.textbox.geometry.width,\n                                                height: level.textbox.geometry.height\n                                              }"><span class="c-xml-page-textboxe-span" ng-style="{\'opacity\': level.textbox.transparency}">{{level.textbox.text}}</span></pre></div><div class="c-xml-page-textboxe" ng-if="level.textdocument" ng-style="{\n                                                \'position\': \'absolute\',\n                                                width: level.textdocument.geometry.width,\n                                                height: level.textdocument.geometry.height,\n                                                left: level.textdocument.geometry.x,\n                                                top: level.textdocument.geometry.y,\n                                                \'z-index\':level.seq-0+200,\n                                                filter: \'alpha(opacity=\'+level.textdocument.transparency*100+\')\',\n                                                \'transform\': \'rotate(\' + level.textdocument.rotation.angle + \'deg)\',}"><div style="overflow: hidden;width: 100%;height: 100%;position: relative" class="no-events" ng-style="{\'opacity\':level.textdocument.transparency.toFixed(2)}"><img class="bg-image bg-image{{template.pageI}} pos" ng-cloak ng-if="level.textdocument.background.resource.identifier" ng-src="{{level.textdocument.background.resource.identifier||\'//:0\'}}" ng-style="{\n                                                         position: \'absolute\',\n                                                         left:level.textdocument.background.offsetx,\n                                                         top:level.textdocument.background.offsety,\n                                                         width: level.textdocument.background.adaptation==\'Width\'?level.textdocument.geometry.width:\'\',\n                                                         height:level.textdocument.background.adaptation!=\'Width\'?level.textdocument.geometry.height:\'\'}"><div ng-repeat="docLevel in level.textdocument.levels.level track by $index" ng-init="docIndex = $index" style="position: relative"><div data-index="{{docIndex}}" class="img-art" ng-if="docLevel.imageart" ng-style="{\n                                                            width: docLevel.imageart.geometry.width,\n                                                            height: docLevel.imageart.geometry.height,\n                                                            left: docLevel.imageart.geometry.x,\n                                                            top: docLevel.imageart.geometry.y,\n                                                            \'z-index\':docLevel.seq-0+200,\n                                                            \'opacity\':docLevel.imageart.transparency,\n                                                            filter: \'alpha(opacity=\'+docLevel.imageart.transparency*100+\')\',\n                                                            \'transform\': \'rotate(\' + docLevel.imageart.rotation.angle + \'deg)\'}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                                    \'left\': docLevel.imageart.offsetx,\n                                                                    \'top\': docLevel.imageart.offsety,\n                                                                    \'width\': docLevel.imageart.geometry.width}" ng-src="{{docLevel.imageart.resource.identifier+\'?imageView2\'}}"></div></div><div class="c-xml-page-textboxe" ng-if="docLevel.textbox" style="white-space: normal" data-index="{{docIndex}}" ng-style="{\n                                                            \'width\': docLevel.textbox.geometry.width,\n                                                            \'height\': docLevel.textbox.geometry.height,\n                                                            \'left\': docLevel.textbox.geometry.x,\n                                                            \'top\': docLevel.textbox.geometry.y,\n                                                            \'z-index\':docLevel.seq-0+200,\n                                                            \'transform\': \'rotate(\' + docLevel.textbox.rotation.angle + \'deg)\'}"><pre class="c-xml-page-textboxe-text web-font" ng-style="{\n                                                        \'font-family\':  \'\\\'\' + docLevel.textbox.fontuuid + \'\\\'\',\n                                                        \'font-size\': docLevel.textbox.style.size + \'pt\',\n                                                        \'color\': docLevel.textbox.style.color,\n                                                        \'font-weight\': docLevel.textbox.style.bold ? \'bold\': \'400\',\n                                                        \'font-style\': docLevel.textbox.style.italic ? \'italic\': \'initial\',\n                                                        \'line-height\': docLevel.textbox.style.lineheight+ \'pt\',\n                                                        \'letter-spacing\': docLevel.textbox.style.letterspacing + \'pt\',\n                                                        \'opacity\': docLevel.textbox.transparency,\n                                                        \'text-decoration\': \'none\',\n                                                        \'text-align\': docLevel.textbox.style.align,\n                                                        \'text-align-last\': docLevel.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',\n                                                        transform:\'scale(\'+(vm.thumbnailScale)+\')\',\n                                                        \'transform-origin\': \'0 0\',\n                                                        width: docLevel.textbox.geometry.width,\n                                                        height: docLevel.textbox.geometry.height\n                                                      }"><span style="display: inline-block; width: 100%; white-space: pre-wrap;word-break: break-word; height: auto">{{docLevel.textbox.text}}</span></pre></div></div></div></div></div><div class="barcode" ng-show="template.pages.page[0].barcode" ng-style="{\n                                             \'z-index\':999,\n                                             \'width\': template.pages.page[0].barcode.geometry.width,\n                                             \'height\': template.pages.page[0].barcode.geometry.height,\n                                             \'left\': template.pages.page[0].barcode.geometry.x,\n                                             \'top\': template.pages.page[0].barcode.geometry.y,\n                                             \'transform\': \'rotate(\' + template.pages.page[0].barcode.rotation.angle + \'deg)\' }"><img src="content/images/txm.png" style="width: 100%;height: 100%"></div><div class="barcode" ng-show="template.pages.page[0].qrcode" ng-style="{\n                                             \'z-index\':999,\n                                             \'width\': template.pages.page[0].qrcode.geometry.width,\n                                             \'height\': template.pages.page[0].qrcode.geometry.height,\n                                             \'left\': template.pages.page[0].qrcode.geometry.x,\n                                             \'top\': template.pages.page[0].qrcode.geometry.y,\n                                             \'transform\': \'rotate(\' + template.pages.page[0].qrcode.rotation.angle + \'deg)\' }"><img src="content/images/QrCode.png" style="width: 100%;height: 100%"></div></div></div></div></div><div class="lang-ic" ng-show="vm.lagnuages.length>1&&!vm.hide" style="bottom: 120px"><img src="content/images/lagnuage.svg" ng-click="vm.language=true"><div class="lang-ic-content" ng-click="vm.hide=true"><i class="iconfont iconjian2"></i></div></div><language is-show="vm.language" ng-if="vm.language"></language>');
$templateCache.put('app/entities/product-ec/productsNew.html','<div class="z-modal" ng-if="bigSizeTip" data-html2canvas-ignore><div class="z-modal-body3"><div class="z-modal-body3-title">{{"choose.editorMessage.bigPictureTitle" | translate}}</div><div class="z-modal-body-icon"><img src="content/images/high_size.png" width="65%"></div><div class="z-modal-body3-tip" translate="choose.editor.editorMessage" translate-values="{higherSizeLen:higherSizeLen}"></div><div class="z-modal-body3-confirm" ng-click="filterBigSize()">{{"choose.editor.confirm" | translate}}</div></div></div><div ng-style="{width:dWidth}" ng-show="status==\'start\'" style="position: absolute; top: 0px; left: 0px; bottom: 0px; background: #FFF"><div class="choose_header col-md-12 col-sm-12 pad-0"><div class="show_counts col-lg-12 col-sm-12 col-xs-12" ng-hide="qiniuId.length"><!-- \u663E\u793A\u9700\u8981\u5F20\u6570 --> <span ng-show="multipartUpload" class="prev-btn opacityMinus" ng-click="goBackToProduct()"><span class="arrowPrev arrow-prev"></span> </span><span translate="choose.editor.workNeedPicture" translate-values="{num:vm.counts}"></span></div><div class="save-pages hide1"><div class="save-page1"><div class="imgLoading"><div class="loadImg"></div><p class="imgText">{{"choose.editor.photoLoading" | translate}}<br>{{"choose.editor.await" | translate}}</p></div></div></div><div class="show_counts col-lg-12 col-sm-12 col-xs-12" ng-show="qiniuId.length"><!-- \u663E\u793A\u8FD8\u9700\u8981\u4E0A\u4F20n\u5F20--> <span ng-show="multipartUpload" class="prev-btn opacityMinus" ng-click="goBackToProduct()"><span class="arrowPrev arrow-prev"></span> </span><span translate="choose.editor.alreadyPicture" translate-values="{num:qiniuId.length,num2:vm.counts}"></span></div><!--new \u2014\u2014 upload--><div class="choose_btn col-lg-12 col-sm-12 col-xs-12 pad-0"><div class="choose_wx col-lg-6 col-sm-6 col-xs-6 pad-left-10 pad-right-5" ng-if="agentIos" ng-click="chooseWx()"><button class="borderTheme opacityMinus choose-btn-size"><span class="categoryPrice">{{\'choose.editor.wx\' | translate}}</span></button></div><div class="choose_wx col-lg-6 col-sm-6 col-xs-6 pad-left-10 pad-right-5" ng-if="!agentIos" style="position:relative;display:inline-block; margin-bottom: 10px"><button class="borderTheme opacityMinus choose-btn-size"><span class="categoryPrice">{{\'choose.editor.wx\' | translate}}</span> <input onchange="uploadPicMutiple(event)" id="uploadImg2" type="file" multiple="multiple" accept="{{vm.supportedMimeTypes}}" name="file" value="" style="opacity:0; position:absolute;top:0;left:0"></button></div><div class="choose_gallery col-lg-6 col-sm-6 col-xs-6 pad-left-5 pad-right-10" ng-click="showGallery()" style="margin-bottom: 10px"><button class="borderTheme opacityMinus choose-btn-size"><span class="categoryPrice">{{\'choose.editor.gallery\' | translate}}</span></button></div><div class="col-lg-12 col-sm-12 col-xs-12 infoWaring flex-btn-group-container" style="background: #f6f7f9;padding: 0 10px;font-size: 12px;z-index:1" ng-if="vm.messageGallery.length"><img src="content/images/icons/notice.svg" alt="" style="width:24px;height:24px;margin-right:5px;margin-top: 4px"><marquee scrollamount="2" height="30" behavior="scroll" direction="left" align="left" style="width: 100%;line-height: 30px">{{vm.messageGalleryText}}</marquee></div></div></div><!--\u9879\u76EE\u5E93\u4E3A\u7A7A--><div class="choose_none bg" ng-hide="qiniuId.length" style="padding-top: 172px"><div><span class="nonePic nonePhoto" style="margin: 20vh auto 0"></span><div>{{\'choose.editor.noPicTips\' | translate}}</div></div></div><div class="choose_pic col-md-12 col-sm-12 col-xs-12 no-padding" ng-show="qiniuId.length" ng-style="{\'margin-top\':vm.messageGallery.length?\'186px\':\'136px\'}"><!--edit--><div class="save-pages hide1"><div class="save-page1"><div class="imgLoading"><div class="loadImg"></div><p class="imgText">{{"choose.editor.photoLoading" | translate}}<br>{{"choose.editor.await" | translate}}</p></div></div></div><!--new--><!--multipartUpload true\u5355\u9875\u5236\u4F5C\u591A\u9009\u7167\u7247\u9650\u5236\u5355\u9875\u53EF\u9009\u62E9\u7684\u6570\u91CF     false\u662F\u521A\u8FDB\u5165\u7684\u65F6\u5019\u7167\u7247\u5E93\u591A\u5F20\u9009\u62E9\u4E4B\u540E\u53EF\u4EE5\u8FDB\u884C\u5220\u9664--><ul class="photos" ng-cloak><li ng-repeat="photo in qiniuId | orderBy: $index track by $index" class="photo-content" ng-if="!multipartUpload"><img ng-src="{{photo.identifier+\'?imageView2/1/w/150/h/150\'||\'//:0\'}}" alt="" class="imgPhoto" style="pointer-events: none;-webkit-user-select: none;-webkit-touch-callout: none"><div class="photo-del opacityMinus" ng-click="delPhoto(photo,$index)"><img src="content/images/icons/delete2.svg" ontouchstart="return false;" style="width: 100%;pointer-events: none;-webkit-user-select: none;-webkit-touch-callout: none"></div><div ng-if="photo.imgSize/1024 < 150 " class="lowerSize"><div style="height: 15vw;line-height: 25vw"><img src="content/images/ic_pixel2.svg" alt="" style="pointer-events: none;-webkit-user-select: none;-webkit-touch-callout: none"></div><div style="height: 15vw;line-height: 15vw">{{"choose.editor.lackofPixels" | translate}}</div></div></li><li ng-repeat="photo in qiniuId | orderBy: $index track by $index" class="photo-content" ng-click="selectRestrict(photo.identifier,photo,$index)" ng-class="photo.flg ?\'transparentImg\':\'\'" ng-if="multipartUpload"><img ng-src="{{photo.identifier+\'?imageView2/1/w/150/h/150\'||\'//:0\'}}" alt="" class="imgPhoto" style="pointer-events: none;-webkit-user-select: none;-webkit-touch-callout: none"> <i class="icon iconfont icondui select-icon" ng-show="photo.photo_select"></i> <i class="icon iconfont iconbig-circle select-icon" ng-show="!photo.photo_select"></i><!--                <div class="select-icon select-all" ng-show="photo.photo_select"></div>--><!--                <div class="select-icon select-none" ng-show="!photo.photo_select"></div>--><div ng-if="photo.imgSize/1024 < 150 " class="lowerSize"><div style="height: 15vw;line-height: 25vw"><img src="content/images/ic_pixel2.svg" alt="" style="pointer-events: none;-webkit-user-select: none;-webkit-touch-callout: none"></div><div style="height: 15vw;line-height: 15vw">{{"choose.editor.lackofPixels" | translate}}</div></div><div class="use-account diy-btn-primarys"><!-- \u4F7F\u7528\u6B21\u6570 --> <span>{{photo.usenum}}</span></div></li></ul></div><div class="footer_bar col-md-12 col-sm-12 col-xs-12 no-padding" ng-show="!multipartUpload"><div class="col-md-12 col-sm-12 col-xs-12 no-padding flex-btn-group-container"><div class="opacityMinus flex-1" ng-click="photoSort()"><i class="icon iconfont iconpaixu default-btncolor-mobile"></i><!--                <img src="content/images/photo-sort.svg" alt="\u7167\u7247\u6392\u5E8F"/>--> <span class="size-foot categoryPrice">{{\'choose.editor.photoSort\' | translate}}</span></div><div class="opacityMinus flex-1" ng-click="nextTo()"><i class="icon iconfont iconbianji default-btncolor-mobile"></i><!--                <img src="content/images/single-make.svg" alt="\u5355\u9875\u5236\u4F5C"/>--> <span class="size-foot categoryPrice">{{\'choose.editor.next\' | translate}}</span></div><div class="opacityMinus product-go diy-btn-primarys" ng-click="goTo()"><span>{{\'choose.editor.go\' | translate}}</span></div></div><div class="iphoneX-content col-md-12 col-sm-12 col-xs-12 no-padding"></div></div><div class="footer-title opacityMinus" style="bottom: 20px" ng-click="confirmChoose()" ng-if="multipartUpload && photoPic.length>0"><!-- \u591A\u9009\u9009\u62E9\u4E0A\u4F20\u6309\u94AE --><div class="diy-btn-primarys" style="border-radius: 20px"><span>{{\'choose.editor.confirm\' | translate}}</span></div></div><div class="iphoneX-content col-md-12 col-sm-12 col-xs-12 no-padding"></div><div class="save-pages" ng-click="nextStep()" ng-if="!vm.guideStep && (countN == 1 || countN == 2 || countN == 3 || countN == 4 || countN == 5)"><!--\u9879\u76EE\u5E93\u90E8\u5206\u5F15\u5BFC\u9875--><div class="choose_btn col-lg-12 col-sm-12 col-xs-12 pad-0" style="border: none;margin-top: 55px"><div class="col-lg-6 col-sm-6 col-xs-6 pad-left-10 pad-right-5" style="float: left" ng-class="1 == countN ? \'\' :\'hide\'"><button class="borderTheme opacityMinus choose_gallery2 choose-btn-size"><span class="categoryPrice">{{\'choose.editor.wx\' | translate}}</span></button><!-- <img src="content/images/mobile-album.svg" alt="\u624B\u673A\u76F8\u518C" style="margin-left: 20px;"/> --><div class="Lead-Bubble Lead-Bubble-LT"><span>{{\'choose.editor.clickAlbumUploadPicture\' | translate}}</span></div></div><div class="col-lg-6 col-sm-6 col-xs-6 pad-left-5 pad-right-10" style="float: right" ng-class="2 == countN ? \'\' :\'hide\'"><button class="borderTheme opacityMinus choose_gallery2 choose-btn-size"><span class="categoryPrice">{{\'choose.editor.gallery\' | translate}}</span></button><!-- <img src="content/images/history-photo.svg" alt="\u5DF2\u4F20\u56FE\u7247" style="margin-left: -30px;"/> --><div class="Lead-Bubble Lead-Bubble-RT" style="transform: translateX(-20%)"><span>{{\'choose.editor.historyPicture\' | translate}}</span></div></div></div><div class="footer_step col-md-12 col-sm-12 col-xs-12 no-padding"><div class="col-md-12 col-sm-12 col-xs-12 no-padding"><div class="opacityMinus" ng-class="3 == countN ? \'\' :\'hide\'" style="float: left" ng-style="{\'width\':(vm.wid -200)/2+\'px\'}"><!-- <img src="content/images/sort-photo.svg" alt="\u7167\u7247\u6392\u5E8F"/> --><div class="Lead-Bubble Lead-Bubble-LB"><span>{{\'choose.editor.uploadPicturesSort\' | translate}}</span></div><div class="btn-step"><img src="content/images/photo-sort.svg" alt="\u7167\u7247\u6392\u5E8F"> <span class="size-foot categoryPrice">{{\'choose.editor.pageSorter\' | translate}}</span></div></div><div class="opacityMinus" ng-class="4 == countN ? \'\' :\'hide\'" style="float: left" ng-style="{\'width\':(vm.wid -200)/2+\'px\',\'marginLeft\':(vm.wid -200)/2+\'px\'}"><!-- <img src="content/images/single-photo.svg" alt="\u5355\u9875\u5236\u4F5C" style="margin-left: -80px;"/> --><div class="Lead-Bubble Lead-Bubble-CB" style="transform: translateX(-20%)"><span>{{\'choose.editor.goEditor\' | translate}}</span></div><div class="btn-step"><img src="content/images/single-make.svg" alt="\u5355\u9875\u5236\u4F5C"> <span class="size-foot" style="color: #717171">{{\'choose.editor.next\' | translate}}</span></div></div><div class="opacityMinus" style="width: 200px;float: right" ng-class="5 == countN ? \'\' :\'hide\'"><!-- <img src="content/images/import-photo.svg" alt="\u4E00\u952E\u586B\u5145"/> --><div class="Lead-Bubble Lead-Bubble-BR" style="transform: translateX(-20%)"><span>{{\'choose.editor.photoAddedImport\' | translate}}</span></div><div class="product-go diy-btn-primarys" style="margin: 5px 0 3px -10px"><span>{{\'choose.editor.go\' | translate}}</span></div></div></div><div class="iphoneX-content col-md-12 col-sm-12 col-xs-12 no-padding"></div></div><div class="next-step2"><button class="c-btn-next">{{"choose.editor.nextStep" | translate}}</button></div><div class="never-hint" ng-click="neverHint()">{{\'choose.editor.notTips\' | translate}}</div></div></div><div ng-show="status==\'sort\'" style="position: absolute;top: 0;left: 0"><div class="choose_header col-md-12 col-sm-12 pad-0" style="line-height: 25px"><div class="show_count col-lg-4 col-sm-4 col-xs-4 text-left"><span class="arrowPrev arrow-prev" ng-click="showStartBtn()"></span></div><div class="show_count col-lg-4 col-sm-4 col-xs-4 text-center"><span>{{\'choose.editor.clickOnPhotosToSort\' | translate}}</span></div><div class="show_count col-lg-4 col-sm-4 col-xs-4" ng-click="sureSort()"><div class="floatRight commit-div" ng-click="sureSort()" style="text-align: center">{{\'choose.editor.confirm\' | translate}}</div></div><div class="save-pages hide1"><div class="save-page1"><div class="imgLoading"><div class="loadImg"></div><p class="imgText">{{\'choose.editor.photoLoading\' | translate}}<br>{{\'choose.editor.await\' | translate}}</p></div></div></div></div><div class="choose_pic col-md-12 col-sm-12 col-xs-12 no-padding" ng-show="qiniuId.length" style="margin-top: 48px"><ul class="photos" ng-cloak id="my-ui-list"><li ng-repeat="photo in qiniuId | orderBy: $index track by $index" class="photo-content"><img ng-src="{{photo.identifier+\'?imageView2/1/w/150/h/150\'||\'//:0\'}}" alt="" data-img-identifier="{{photo.identifier}}" class="imgPhoto" ng-click="selectPage(photo)"><div ng-if="photo.imgSize/1024 < 150 " class="lowerSize no-events"><div style="height: 15vw;line-height: 25vw"><img src="content/images/ic_pixel2.svg" alt="" style="pointer-events: none;-webkit-user-select: none;-webkit-touch-callout: none"></div><div style="height: 15vw;line-height: 15vw">{{\'choose.editor.lackofPixels\' | translate}}</div></div><div class="page-sort" ng-show="photo.seq.select"><div></div><p class="page-num" translate="choose.editor.pagination" translate-values="{pageI:photo.seq.pageI-0+1}"></p><p class="mask-num">{{photo.seq.maskI-0+1}}</p></div></li></ul></div><div class="iphoneX-content col-md-12 col-sm-12 col-xs-12 no-padding"></div></div><!--\u8DF3\u8F6C\u5230\u56FE\u7247\u5E93\u7684\u90E8\u5206 \u8FD8\u5728\u5F53\u524D\u9875\u9762--><div ng-style="{width:dWidth}" ng-if="status==\'gallery\'"><div class="prev-btn-gallery"><span translate="galleryContent.workNeedPicture" translate-values="{num:getCount(),num2:gallaryPic.length}"></span> <span class="prev-btn opacityMinus" ng-click="backToView()"><span class="arrowPrev arrow-prev" style="width: 20px;height: 20px"></span></span></div><ul class="folder-nav col-md-12 col-sm-12 col-xs-12" ng-show="!moveGallery&&!folderInside" style="top:40px"><li class="col-md-6 col-sm-6 col-xs-6" ng-click="galleryNavSel()"><div ng-class="{\'folder-head-active\':currentNav==\'gallery\'}">{{"galleryContent.picture" | translate}}</div></li><li class="col-md-6 col-sm-6 col-xs-6" ng-click="folderNavSel()"><div ng-class="{\'folder-head-active\':currentNav==\'folder\'}">{{"galleryContent.folder" | translate}}</div></li></ul><header class="folder-inside" ng-show="folderInside"><div class="index-back"><span class="opacityMinus" ng-click="hideFolderContent()"><div class="tabIcons back-work"></div></span></div><span class="mar-left-54 text-ellip" style="width: 43vw">{{folderOne.name}}</span></header><div class="panel-body no-padding" ng-show="currentNav==\'gallery\'" style="background: #fff"><div class="choose_none bg" ng-show="noPic"><span class="nonePic nonePhoto"></span><div class="categoryPrice">{{"galleryContent.noPhotosAvailable" | translate}}</div></div><div style="width: 100vw;height: 50px" ng-hide="folderInside"></div><div class="col-md-12 col-sm-12 col-xs-12 no-padding mar-bottom-60 photo-show" ng-hide="noPic" ng-class="{\'mar-top-60\':vm.pid==\'\'&&!vm.aid}"><!-- \u56FE\u5E93\u663E\u793A --><div class="photo-item" ng-repeat="photo in photos" ng-class="{\'mar-top-60\':$first,\'mar-bottom-50\':$last}"><div class="photo_header mar-bo" style="height: 32px"><span ng-click="selectedPhoto($index,photo)"><!--                        <span class="select-icon select-all" ng-show="!!photo.select_photoAll"></span>--><!--                        <span class="select-icon selectCurrent" ng-show="!photo.select_photoAll"></span>--> <i class="icon iconfont icondui select-icon" ng-show="!!photo.select_photoAll"></i> <i class="icon iconfont iconbig-circle select-icon" ng-show="!photo.select_photoAll"></i></span></div><ul class="photos border-bottom" ng-cloak ng-show="vm.pid!=\'\'||vm.aid"><li ng-repeat="gallery in photo.galleries" class="photo-content" ng-click="selectThis2(gallery, photo,$index)" ng-class="justifySelect(gallery) ?\'transparentImg\':\'\'" ng-if="domain != null"><img ng-src="{{gallery.identifier +\'?imageView2/1/w/150/h/150\'||\'\'}}" alt="" class="imgPhoto" style="pointer-events: none;-webkit-user-select: none;-webkit-touch-callout: none"><!--                        <div class="select-icon select-all" ng-show="gallery.select_photo"></div>--><!--                        <div class="select-icon select-none" ng-show="delBar&&(!gallery.select_photo)"></div>--> <i class="icon iconfont icondui select-icon" ng-show="gallery.select_photo"></i> <i class="icon iconfont iconbig-circle select-icon" ng-show="delBar&&(!gallery.select_photo)"></i><div ng-if="gallery.imgSize/1024 < 150 " class="lowerSize"><div style="height: 15vw;line-height: 25vw"><img src="content/images/ic_pixel2.svg" alt="" style="pointer-events: none;-webkit-user-select: none;-webkit-touch-callout: none"></div><div style="height: 15vw;line-height: 15vw">{{\'choose.editor.lackofPixels\' | translate}}</div></div></li></ul></div></div><div class="col-md-12 col-sm-12 col-xs-12 text-center" align="content"><img ng-if="vm.more" class="loadingPic" src="content/images/loading.gif"></div></div><div class="folder-file pad-bottom-70" ng-show="currentNav==\'folder\'"><header class="top-menu" ng-show="moveGallery" style="position: fixed;z-index:1000"><div class="index-back"><span class="opacityMinus" ng-click="backToGallery()"><div class="tabIcons back-work"></div></span></div><span class="top-title">{{"galleryContent.selectTheDestinationFolder" | translate}}</span><div class="floatRight commit-div edit-save" ng-click="saveMoveToFolder()">{{"galleryContent.confirm" | translate}}</div></header><ul class="folder-list" ng-style="{\'padding-top\':!moveGallery?\'90px\':\'40px\'}"><li ng-show="moveGallery"><div class="folder-namebar" ng-click="selectSingle(\'\',1)"><span class="namebar-left text-ellip"><!--                    <i class="icon iconfont iconwenjianjia"></i>--> <img src="content/images/icons/folder.svg"> <span class="folder-name">{{"galleryContent.picture" | translate}}</span> </span><button class="choose-one" ng-show="selectOne.folderId==\'\'&&selectOne.selected"></button></div></li><li ng-repeat="folder in Folders track by $index" class="folder-li{{$index}} folder-li"><!--\u79FB\u52A8\u56FE\u7247--><div class="folder-namebar" ng-click="selectSingle(folder,1)" ng-show="moveGallery"><span class="namebar-left text-ellip"><!--                    <i class="icon iconfont iconwenjianjia"></i>--> <img src="content/images/icons/folder.svg"> <span class="folder-name{{$index}} folder-name">{{folder.name}}</span> </span><button class="choose-one" ng-show="folder.selected"></button></div><!--\u6587\u4EF6\u5939\u5904\u7406--><div class="folder-namebar" ng-show="!moveGallery"><span class="namebar-left text-ellip" ng-click="showFolderContent(folder)"><!--                    <i class="icon iconfont iconwenjianjia"></i>--> <img src="content/images/icons/folder.svg"> <span class="folder-name{{$index}} folder-name">{{folder.name}}</span> </span><span ng-click="selectFolders(folder)"><i class="sel-true sel" ng-if="folder.selected"></i> <i class="sel-false sel" ng-if="!folder.selected"></i></span></div><div class="folder-editbar editbar{{$index}} hide1"><div class="folder-edit" ng-click="editFolder(folder)"><!--                        <img src="content/images/icons/folder-edit.svg">--> <i class="icon iconfont iconbianji default-btncolor-mobile"></i><div class="text textActive">{{"galleryContent.rename" | translate}}</div></div></div></li></ul></div><div class="col-md-12 col-sm-12 col-xs-12 footer-del pad-0"><div class="folder-footer" ng-show="currentNav==\'gallery\'"><div class="folder-add folder-btn"><span class="add-img opacityMinus categoryPrice view-flex" style="position:relative"><!-- \u56FE\u7247\u5E93\u9009\u62E9\u4E0A\u4F20 --> <span class="icon iconfont icontianjiazhaopian default-btncolor-mobile"></span> <span ng-if="!agentIos"><span style="font-size: 12px">{{"galleryContent.localGallery" | translate}}</span> <input onchange="uploadPicMutiple(event)" id="uploadImg" type="file" multiple="multiple" accept="{{vm.supportedMimeTypes}}" name="file" value="" style="opacity:0; position:absolute;top:0;left:0"> </span><span ng-if="agentIos" ng-click="chooseWx()"><span style="font-size: 12px">{{"galleryContent.localGallery" | translate}}</span></span></span></div><!--<div class="folder-delete folder-btn" ng-click="moveToFolder()" ng-show="delBar">--><!--<img src="content/images/icons/folder-move.svg">--><!--<div class="text textActive">\u79FB\u52A8</div>--><!--</div>--><div class="folder-all folder-btn" ng-click="showDeleteBtn()" ng-show="delBar"><!--                <img src="content/images/icons/folder-choose-all.svg">--> <i class="icon iconfont iconquanxuan default-btncolor-mobile"></i><div class="textActive">{{"galleryContent.checkAll" | translate}}</div></div></div><div class="folder-footer" ng-show="currentNav==\'folder\'&&!moveGallery"><div class="folder-add folder-btn view-flex textActive" ng-click="addFolder()"><i class="icon iconfont iconaddfile default-btncolor-mobile"></i><div class="" style="font-size: 12px">{{"galleryContent.addFolder" | translate}}</div></div><div class="folder-editName folder-btn" ng-click="editFolder()" ng-show="folderIds.length>0"><i class="icon iconfont iconbianji default-btncolor-mobile" ng-show="folderIds.length==1"></i> <i class="icon iconfont iconbianji" ng-show="folderIds.length>1"></i><!--                <img src="content/images/icons/folder-edit.svg" ng-show="folderIds.length==1">--><!--                <img src="content/images/icons/folder-edit-gray.svg" ng-show="folderIds.length>1">--><div class="text textActive" ng-class="{\'folder-grayText\':folderIds.length>1}">{{"galleryContent.rename" | translate}}</div></div><div class="folder-all folder-btn" ng-click="chooseAll(1)" ng-show="folderIds.length>0"><!--                <img src="content/images/icons/folder-choose-all.svg">--> <i class="icon iconfont iconquanxuan default-btncolor-mobile"></i><div class="text textActive">{{"galleryContent.checkAll" | translate}}</div></div></div><div class="iphoneX-content col-md-12 col-sm-12 col-xs-12 no-padding"></div></div><!--\u56FE\u7247\u5E93\u4E2D\u9690\u85CF\u4E0A\u4F20\u6309\u94AE\uFF0C\u4E0A\u4F20\u56FE\u7247\u4E2D\u663E\u793A--><div class="footer-title opacityMinus" ng-click="confirmImport($event)" ng-show="(vm.pid!=\'\'||vm.aid)&&delBar"><!-- \u5DE5\u4F5C\u533A\u9009\u62E9\u4E0A\u4F20\u6309\u94AE --><div class="diy-btn-primarys" style="border-radius: 20px"><span>{{"galleryContent.confirm" | translate}}</span></div></div></div><div ng-style="{width:dWidth}" class="page-make user-select-default" ng-show="status==\'make\'||status==\'view\'"><!--1.\u663E\u793A\u52A0\u8F7D\u56FE\u6807\uFF0C\u9875\u9762\u52A0\u8F7D\u5B8C\u6210\u540E\u663E\u793A\u5F15\u5BFC\u9875--><div class="page-loading" ng-show="loading"><img src="content/images/loading2.gif" onerror="this.src=\'content/images/loading2.gif\'"><p class="tip-style">{{"choose.editor.addTextMessage" | translate}}</p><span class="tip-style">{{"choose.editor.clippingMessage" | translate}}</span></div><div class="page-orientation hide1"><span>{{"choose.editor.pleaseMakeItInPortrait" | translate}}</span></div><div class="page-turning hide1"><div class="k-square-holder2"><div class="k-square3 k-square3a"></div><div class="k-square3 k-square3b"></div><div class="k-square3 k-square3c"></div><div class="k-square3 k-square3d"></div></div></div><div class="edit-page page-view" ng-class="{\'edit-bg1\':status==\'view\',\'edit-bg2\':status==\'make\'}"><div class="save-page hide1"><div><img src="content/images/loading.gif"> <span>{{"choose.editor.worksInStorage" | translate}}</span></div></div><!--\u9876\u90E8\u72B6\u6001\u680F--><div class="diy-row edit-head"><div class="top-menu"><!--\u8FD4\u56DE\u6309\u94AE--><div class="index-back" ng-hide="status==\'view\' && (weixinFlag == \'weChatApplet\'|| weixinFlag == \'weChatAppletMake\')||vm.sortStatus"><span class="opacityMinus" ng-click="backTo()"><div class="tabIcons back-work"></div></span></div><button ng-show="status==\'view\'&&vm.sortStatus" class="commit-div floatLeft" ng-click="sortBack()" style="margin: 10px 10px 0 10px;text-align: center;padding: 0 6px">{{"choose.editor.sortBack" | translate}}</button> <button ng-show="status==\'view\'&&vm.sortStatus" class="commit-div floatLeft button-style1" ng-click="sortCancel()">{{"choose.editor.restore" | translate}}</button> <button ng-show="status==\'view\'&&!vm.sortStatus&&vm.replace" class="commit-div floatLeft button-style1" ng-click="sortPage()" ng-style="{\'margin-left\':(weixinFlag == \'weChatApplet\'|| weixinFlag == \'weChatAppletMake\')?\'15px\':\'50px\'}" style="width: 78px">{{"choose.editor.pageSorter" | translate}}</button><!--\u663E\u793A\u9875\u9762\u5F20\u6570--><div class="index-info" ng-show="status==\'make\'&&!showCut&&!showTextModal"><span class="categoryPrice" style="color: #B0B0B0;font-size: 16px">{{currentCarouselIndex+1}}</span>/{{PAGELEN}}</div><!--\u56FE\u7247\u7F16\u8F91\u65F6\u9876\u90E8\u72B6\u6001\u680F\uFF1A   \u653E\u5927  \u7F29\u5C0F  \u5DE6\u65CB\u8F6C  \u53F3\u65CB\u8F6C--><div class="index-cut" ng-show="showCut"><span class="zoom-in opacityMinus" ng-click="zoomIn()"><img src="content/images/icons/zoom-b.svg" alt=""></span><span class="zoom-out opacityMinus" ng-click="zoomOut()"><img src="content/images/icons/shrink-b.svg" alt=""></span><span class="zoom-out opacityMinus" ng-click="rotateImage(true)"><img src="content/images/icons/rotate-l.svg" alt=""></span><span class="zoom-out opacityMinus" ng-click="rotateImage(false)"><img src="content/images/icons/rotate-r.svg" alt=""></span></div><!--\u6587\u5B57\u7F16\u8F91\u65F6\u7684title--><div class="index-text" ng-show="showTextModal">{{"choose.editor.wordEdit" | translate}}</div><!--\u4FDD\u5B58\u7F16\u8F91\u540E\u7684\u56FE\u7247--><div class="floatRight commit-div edit-save" ng-show="showCut" ng-click="saveMove()">{{"choose.editor.confirm" | translate}}</div><div style="position: absolute; left: 44%; line-height: 50px;color: #B0B0B0;font-size: 16" ng-show="status==\'view\'">{{vm.productXmlNumber}}</div><!--\u4FDD\u5B58\u6587\u5B57--><div class="floatRight commit-div edit-save" ng-show="showTextModal" ng-click="saveText()">{{"choose.editor.confirm" | translate}}</div><!--\u4FDD\u5B58\u4F5C\u54C1--><div class="index-save" ng-hide="showCut||showTextModal"><span class="opacityMinus"><div ng-show="status==\'make\'" class="commit-div button-style1" ng-click="saveWork()">{{"choose.editor.save" | translate}}</div><div ng-show="status==\'view\'&&!vm.sortStatus" class="commit-div button-style1" style="width: 78px" ng-click="saveWork()">{{"choose.editor.saveAll" | translate}}</div><div ng-show="status==\'view\'&&vm.sortStatus" class="commit-div button-style1" ng-click="saveSort()">{{"choose.editor.finish" | translate}}</div></span></div></div></div><div class="col-lg-12 col-sm-12 col-xs-12 infoWaring flex-btn-group-container tip-image" style="padding: 0 10px;font-size: 12px;z-index:1" ng-if="vm.messageTile.length&&status==\'view\'&&!vm.sortStatus"><img src="content/images/icons/notice.svg" alt="" style="width:24px;height:24px;margin-right:5px;margin-top: 4px"><marquee scrollamount="2" height="30" behavior="scroll" direction="left" align="left" style="width: 100%;line-height: 30px">{{vm.messageTileText}}</marquee></div><div class="edit-page-content" style="background: #fff" ng-style="{width:dWidth,\'min-height\':dHeight}" ng-click="hideMenu()"><div ng-show="showCut" style="height: 50px"></div><div ng-show="showCut" class="cut-image-box" ng-style="{height:vm.editHeight-50}" ontouchstart="startEdit(event)" ontouchmove="dragEdit(event)" ontouchend="stopEdit()"><img ng-src="{{currentImage.image.resource.identifier+ \'?imageMogr2/strip/rotate/\' + currentImage.image.angle+\'/thumbnail/200x200>\'}}" id="cut-img" class="cut-img" ng-style="{\n                     \'transform\': currentImage.flip ? \'rotateY(180deg)\' : \'unset\',\n                    width:w?w*currentImage.image.scale:\'\', height:h?h*currentImage.image.scale:\'\'\n                    }"> <img class="cut-mask" id="cut-mask" style="position: absolute;top:0;left: 0"> <span class="cut-img opacity-zero cut-position"><img ng-src="{{currentImage.image.resource.identifier+ \'?imageMogr2/strip/rotate/0/thumbnail/200x200>\'}}" id="cut-opacity" class="cut-img" ng-style="{\'transform\': currentImage.flip ? \'rotateY(180deg)\' : \'unset\',width:wOpacity?wOpacity*currentImage.image.scale:\'\',height:hOpacity?hOpacity*currentImage.image.scale:\'\'}"></span></div><!--\u6587\u5B57\u72B6\u6001--><div ng-show="showTextModal" class="cut-Text-box" ng-style="{height:dHeight,background:\'#fff\'}"><div class="text-menu pad-top-60"><div class="text-op col-xs-12 col-md-12 col-sm-12 pad-0"><div class="text-head col-xs-12 col-md-12 col-sm-12"><div contenteditable="true" class="text-textarea col-xs-12 col-md-12 col-sm-12 pad-left-0 pad-right-40" id="text-div"></div><textarea id="text-area" rows="5" class="text-textarea col-xs-12 col-md-12 col-sm-12" ng-model="textContent" style="padding-top: 10px" placeholder="{{\'editorCommon.describe29\' | translate}}" ng-change="updateTextContents()">\n                            </textarea></div><div class="text-body pad-left-0 col-xs-12 col-md-12 col-sm-12"><!--\u989C\u8272/\u5B57\u4F53\u5207\u6362\u83DC\u5355--> <button class="text-content-tab" ng-class="{\'selected\': selectSketchMenu == \'sketch-color\'}" ng-click="selectSketchMenu = \'sketch-color\';"><span class="icon iconfont iconyansexuanzeqi iconColorText" ng-class="{\'default-btncolor-mobile\':selectSketchMenu == \'sketch-color\'}"></span></button> <button class="text-content-tab" ng-class="{\'selected\': selectSketchMenu == \'sketch-line\'}" ng-click="selectSketchMenu = \'sketch-line\';"><span class="icon iconfont iconzihao iconColorText" ng-class="{\'default-btncolor-mobile\':selectSketchMenu == \'sketch-line\'}"></span> <input id="multiPickerInput" type="button" placeholder="\u5B57\u4F53" value="" class="text-font" style="opacity: 0;margin-left: 300px"></button> <button class="text-content-tab" ng-class="{\'selected\': selectSketchMenu == \'sketch-size\'}" ng-click="selectSketchMenu = \'sketch-size\';"><span class="icon iconfont iconziti iconColorText" ng-class="{\'default-btncolor-mobile\':selectSketchMenu == \'sketch-size\'}"></span></button></div><div class="pad-0 col-xs-12 col-md-12 col-sm-12"><!--\u989C\u8272\u9009\u62E9--> <span class="color-picker-bar diy-row" ng-show="selectSketchMenu == \'sketch-color\'"><span class="color-item" ng-repeat="color in colorList track by $index" ng-click="selectTextColor(color)" data-index="{{$index}}" ng-style="{background:selectedColor == color?\'\':color, border: \'1px solid \'+color,\'margin-left\':(dWidth-210)/14,\'margin-right\':(dWidth-210)/14}" ng-class="{\'white-border\':$index==8}"><i ng-style="{background:color}" ng-show="selectedColor == color"></i> </span></span><!--\u5B57\u4F53\u9009\u62E9--><div id="targetContainer" class="diy-row pad-top-0" ng-show="selectSketchMenu == \'sketch-line\'"></div><!--\u5B57\u53F7\u9009\u62E9--><div ng-show="selectSketchMenu == \'sketch-size\'" style="height: 200px"><p class="text-value" translate="choose.editor.fontSize" translate-values="{size:16}"></p><div><i class="icon-font font-jia"></i> <input type="range" min="9" max="500" step="1" value="16" class="text-range rangeSize"> <i class="icon-font font-jian"></i></div></div></div></div></div></div><!--            <div ng-show="status==\'view\'&&vm.sortStatus">--><!--                <div class="arrowCircle arrowCircle-up">--><!--                    <img src="content/images/arrowCircleUp@2x.svg" alt="" ontouchstart = "return false;" style="pointer-events: none;">--><!--                </div>--><!--                <div class="arrowCircle arrowCircle-down">--><!--                    <img src="content/images/arrowCircleDown@2x.svg" alt="" ontouchstart = "return false;" style="pointer-events: none;">--><!--                </div>--><!--            </div>--><!--\u5E73\u94FA\u5C55\u793A\u9875\u9762--><div class="template-view" ng-show="status==\'view\'" style="width: 100%;overflow: visible;margin-top: 84px" ng-style="{\'height\':(dHeight-50)+\'px\'}"><div style="color: #A1A1A1;text-align: center" ng-show="status==\'view\'&&vm.sortStatus" class="col-lg-12 col-sm-12 col-xs-12">{{"choose.editor.sortByLongDragOnThePage" | translate}}</div><ul class="carousel5 pad-bottom-10" style="width: 100vw" ng-if="vm.pattern == \'BOOK\'" id="my-ui-list1"><li ng-repeat="slide in template.pages.page" data-index="{{$index}}" class="slide-li photo-content1" ng-click="clickToEdit(slide,$index)" ng-hide="slide.unreplace&&vm.sortStatus" ng-style="{ \'margin-left\':$first||$last?(dWidth-dWidth*0.6)/2:$index%2==1?(dWidth*0.1-10)/2:10}" id="slide{{$index}}" ng-init="outerIndex = $index"><div class="slide-content" data-sort-tag="{{slide.seq}}" ng-style="{\n                             overflow:\'hidden\',\n                             position:\'relative\',\n                             background:slide.background.color,\n                             width:($first||$last?dWidth*0.6:dWidth*0.45).toFixed(2),\n                             height:$first||$last?dWidth*0.6*slide.mediabox.height/slide.mediabox.width:dWidth*0.45*slide.mediabox.height/slide.mediabox.width}"><div class="sort-disabled" ng-show="slide.unreplace&&vm.sortStatus"><div style="padding-top: 30%">{{"choose.editor.pageCannotBeMoved" | translate}}</div></div><img class="sort-disabled1" ng-show="slide.unreplace&&vm.sortStatus" ontouchstart="return false;" style="pointer-events: none;-webkit-user-select: none;-webkit-touch-callout: none"> <img ng-src="{{slide.background.resource.identifier+\'?imageMogr2/thumbnail/200x200>\'}}" ng-if="slide.background.resource.identifier" class="background backgroundImg{{$index}}" data-index="{{$index}}" ng-style="{\n                                             position: \'absolute\',\n                                             left:slide.background.offsetx*slide.styleScale,\n                                             top:slide.background.offsety*slide.styleScale,\n                                             width: slide.background.resource.adaptation==\'Width\'?\'100%\':\'auto\',\n                                             height:slide.background.resource.adaptation==\'Height\'?\'100%\':\'auto\'}"><div ng-repeat="level in slide.levels.level track by $index"><div ng-if="level.imagebox&&level.imagebox.geometry" ng-style="{\n                                            \'position\': \'absolute\',\n                                            width: imageboxW(level.imagebox) * slide.styleScale,\n                                            height: imageboxH(level.imagebox) * slide.styleScale,\n                                            left: imageboxL(level.imagebox) * slide.styleScale,\n                                            top: imageboxT(level.imagebox) * slide.styleScale,\n                                            \'z-index\':level.seq-0+200,\n                                            \'transform\': \'rotate(\' + level.imagebox.rotation.angle + \'deg)\',\n                                         }"><div class="relative-view1" ng-style="{\n                                         \'overflow\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'unset\' : \'hidden\',\n                                                \'opacity\':level.imagebox.transparency,\n                                                \'border-top-left-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'lt\', slide.styleScale),\n                                                \'border-top-right-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'rt\', slide.styleScale),\n                                                \'border-bottom-right-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'rb\', slide.styleScale),\n                                                \'border-bottom-left-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'lb\', slide.styleScale),\n                                                \'border-width\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? (level.imagebox.border.lineWidth * slide.styleScale) : \'\',\n                                                \'border-style\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? (level.imagebox.border.lineType || \'solid\') : \'none\',\n                                                \'border-color\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? level.imagebox.border.color : \'\',\n                                                \'box-shadow\' : (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineWidth>0 && (!level.imagebox.border.lineType || level.imagebox.border.lineType == \'solid\')) ? \'0 0 0 1px \' + level.imagebox.border.color + \' inset\' : \'none\',\n                                                \'filter\' : dropShadow(level.imagebox,slide.styleScale,slide.styleScale),\n                                                }"><div ng-style="{\n                                             \'position\': \'absolute\',\n                                             \'z-index\':0,\n                                            \'left\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'left\') * slide.styleScale : 0,\n                                            \'top\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'top\') * slide.styleScale : 0,\n                                            \'right\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'right\') * slide.styleScale : 0,\n                                            \'bottom\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'bottom\') * slide.styleScale : 0,\n                                            \'background-image\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'url(\' + level.imagebox.border.resource.identifier + \')\' : \'\',\n                                            \'background-size\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'100% 100%\' : \'\',\n                                            }"></div><div class="relative-view1" ng-style="{\n                                                    \'background\': level.imagebox.image.resource.identifier ? \'none\' : \'#ddd\',\n                                                    \'border-top-left-radius\':imageboxWRadius1(level.imagebox, \'lt\', slide.styleScale),\n                                                    \'border-top-right-radius\':imageboxWRadius1(level.imagebox, \'rt\', slide.styleScale),\n                                                    \'border-bottom-right-radius\':imageboxWRadius1(level.imagebox, \'rb\', slide.styleScale),\n                                                    \'border-bottom-left-radius\':imageboxWRadius1(level.imagebox, \'lb\', slide.styleScale),\n                                                    \'-webkit-mask-image\': level.imagebox.mask.resource.identifier ? \'url(\' + level.imagebox.mask.resource.identifier + \')\' : \'none\',\n                                                    \'-webkit-mask-size\': \'100% 100%\'}"><div style="position: relative"><div class="picLowerSize text-r" ng-cloak ng-show="level.imagebox && level.imagebox.image && level.imagebox.lowSize" ng-style="{ left:level.imagebox.geometry.width*slide.styleScale/2-8, top:level.imagebox.geometry.height*slide.styleScale/2-11}"><img src="content/images/ic_pixel.svg"></div></div><div class="img-place-holder indexSet-800" ng-hide="level.imagebox.image.resource.identifier"><img src="content/images/icons/addcamera.svg"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'None\' && level.imagebox.image.resource.identifier"><img ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/strip/rotate/\' + level.imagebox.image.angle+\'/thumbnail/!20p\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                    \'width\': level.imagebox.image.width*level.imagebox.image.scale*slide.styleScale,\n                                                    \'height\': level.imagebox.image.height*level.imagebox.image.scale*slide.styleScale,\n                                                    \'left\':level.imagebox.image.offsetx*level.imagebox.image.scale*slide.styleScale,\n                                                    \'top\':level.imagebox.image.offsety*level.imagebox.image.scale*slide.styleScale\n                                                 }"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'Blurred\' && level.imagebox.image.resource.identifier"><img class="c-blur" ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/strip/rotate/\' + level.imagebox.image.angle+\'/thumbnail/200x200>\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                    \'width\': level.imagebox.image.width*slide.styleScale,\n                                                    \'height\': level.imagebox.image.height*slide.styleScale,\n                                                 }"> <img ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/strip/rotate/\' + level.imagebox.image.angle+\'/thumbnail/200x200>\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                    \'width\': level.imagebox.blurredrectangle.width*slide.styleScale,\n                                                    \'height\': level.imagebox.blurredrectangle.height*slide.styleScale,\n                                                    \'left\':level.imagebox.blurredrectangle.x*slide.styleScale,\n                                                    \'top\':level.imagebox.blurredrectangle.y*slide.styleScale,\n                                                    \'z-index\': 1\n                                                 }"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'Transparent\' && level.imagebox.image.resource.identifier"><img ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/strip/rotate/\' + level.imagebox.image.angle+\'/thumbnail/200x200>\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                    \'width\': level.imagebox.blurredrectangle.width*slide.styleScale,\n                                                    \'height\': level.imagebox.blurredrectangle.height*slide.styleScale,\n                                                    \'left\':level.imagebox.blurredrectangle.x*slide.styleScale,\n                                                    \'top\':level.imagebox.blurredrectangle.y*slide.styleScale,\n                                                    \'z-index\': 1\n                                                 }"></div></div></div></div><div class="sticker-edit-box" data-index="{{$index}}" ng-if="level.imageart&&level.imageart.geometry" ng-style="{\n                                     \'opacity\':level.imageart.transparency,\n                                     filter: \'alpha(opacity=\'+level.imageart.transparency*100+\')\',\n                                     \'transform\':\'rotate(-\' + level.imageart.rotation.angle + \'deg)\',\n                                     \'-ms-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                     \'-moz-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                     \'-webkit-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                     \'-o-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                     \'width\': level.imageart.geometry.width*slide.styleScale,\n                                     \'height\': level.imageart.geometry.height*slide.styleScale,\n                                     \'left\': level.imageart.geometry.x*slide.styleScale,\n                                     \'top\': level.imageart.geometry.y*slide.styleScale,\n                                     \'z-index\':level.seq-0+200}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                \'left\': level.imageart.offsetx*slide.styleScale,\n                                                \'top\': level.imageart.offsety*slide.styleScale,\n                                                \'width\': level.imageart.geometry.width * level.imageart.scale*slide.styleScale}" ng-src="{{level.imageart.resource.identifier+\'?imageMogr2/thumbnail/800x800>\'}}"></div></div><div class="text-box" ng-if="level.textbox&&level.textbox.geometry" data-index="{{$index}}" style="white-space: normal;line-height: 0;min-height: 10px;min-width: 24px" ng-style="{\n                                     top: level.textbox.geometry.y*slide.styleScale,\n                                     left: level.textbox.geometry.x*slide.styleScale,\n                                     \'width\': level.textbox.geometry.width*slide.styleScale,\n                                     \'height\': level.textbox.geometry.height*slide.styleScale,\n                                     \'transform\': \'rotate(\' +  level.textbox.rotation.angle + \'deg)\',\n                                     \'z-index\':level.seq-0+200}"><pre class="c-xml-page-textboxe-text web-font" data-index="{{$index}}" ng-style="{\n                                            \'font-family\':  \'\\\'\' + level.textbox.fontuuid + \'\\\'\',\n                                            \'font-size\': (level.textbox.style.size*slide.ratio > 12 ? level.textbox.style.size* slide.ratio : 12) + \'pt\',\n                                            \'color\': level.textbox.style.color,\n                                            \'font-weight\': level.textbox.style.bold ? \'bold\': \'400\',\n                                            \'font-style\': level.textbox.style.italic ? \'italic\': \'initial\',\n                                            \'line-height\': (level.textbox.style.size* slide.ratio > 12 ? level.textbox.style.lineheight* slide.ratio : level.textbox.style.lineheight*12/level.textbox.style.size) + \'pt\',\n                                            \'letter-spacing\': (level.textbox.style.size* slide.ratio > 12 ? level.textbox.style.letterspacing* slide.ratio : level.textbox.style.letterspacing*12/level.textbox.style.size) + \'pt\',\n                                            \'opacity\': level.textbox.transparency,\n                                            \'text-decoration\': \'none\',\n                                            \'text-align\': level.textbox.style.align,\n                                            \'writing-mode\': level.textbox.style.writingmode,\n                                            \'text-align-last\': level.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',\n                                            \'transform\':\'scale(\'+(1 / 12 * level.textbox.style.size* slide.ratio > 1 ? 1 : 1 / 12 * level.textbox.style.size* slide.ratio)+\')\',\n                                            \'width\':  (level.textbox.style.size* slide.ratio > 12 ? (level.textbox.geometry.width*slide.styleScale):(level.textbox.geometry.width*slide.styleScale)/( 1 / 12 * level.textbox.style.size*slide.ratio))+\'px\'\n                                          }"><span class="c-xml-page-textboxe-span">{{level.textbox.text}}</span></pre></div><div data-index="{{$index}}" ng-show="level.textdocument&&level.textdocument.geometry" ng-style="{\n                                        position: \'absolute\',\n                                        width: level.textdocument.geometry.width*slide.styleScale,\n                                        height: level.textdocument.geometry.height*slide.styleScale,\n                                        left: level.textdocument.geometry.x*slide.styleScale,\n                                        top: level.textdocument.geometry.y*slide.styleScale,\n                                        \'z-index\':level.seq-0+200,\n                                        \'opacity\':level.textdocument.transparency.toFixed(2),\n                                        filter: \'alpha(opacity=\'+level.textdocument.transparency*100+\')\',\n                                        \'transform\': \'rotate(-\' + level.textdocument.rotation.angle + \'deg)\'}"><div style="overflow: hidden;width: 100%;height: 100%;position: relative" class="no-events"><img class="bg-image bg-image{{template.pageI}} pos" ng-cloak ng-if="level.textdocument.background.resource.identifier" ng-src="{{level.textdocument.background.resource.identifier+\'?imageMogr2/thumbnail/800x800>\'||\'//:0\'}}" ng-style="{\n                                                 position: \'absolute\',\n                                                 left:level.textdocument.background.offsetx*slide.styleScale,\n                                                 top:level.textdocument.background.offsety*slide.styleScale,\n                                                 width: level.textdocument.background.adaptation==\'Width\'?level.textdocument.geometry.width*slide.styleScale:\'\',\n                                                 height:level.textdocument.background.adaptation!=\'Width\'?level.textdocument.geometry.height*slide.styleScale:\'\'}"><div ng-repeat="docLevel in level.textdocument.levels.level track by $index" ng-init="docIndex = $index" style="position: relative"><div data-index="{{docIndex}}" class="img-art" ng-show="docLevel.imageart" ng-style="{\n                                                    width: docLevel.imageart.geometry.width*slide.styleScale,\n                                                    height: docLevel.imageart.geometry.height*slide.styleScale,\n                                                    left: docLevel.imageart.geometry.x*slide.styleScale,\n                                                    top: docLevel.imageart.geometry.y*slide.styleScale,\n                                                    \'z-index\':docLevel.seq-0+200,\n                                                    \'opacity\':docLevel.imageart.transparency,\n                                                    filter: \'alpha(opacity=\'+docLevel.imageart.transparency*100+\')\',\n                                                    \'transform\': \'rotate(\' + docLevel.imageart.rotation.angle + \'deg)\'}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                            \'left\': docLevel.imageart.offsetx*slide.styleScale,\n                                                            \'top\': docLevel.imageart.offsety*slide.styleScale,\n                                                            \'width\': docLevel.imageart.geometry.width * docLevel.imageart.scale*slide.styleScale}" ng-src="{{docLevel.imageart.resource.identifier+\'?imageMogr2/thumbnail/800x800>\'}}"></div></div><div class="c-xml-page-textboxe" ng-show="docLevel.textbox" style="white-space: normal" data-index="{{docIndex}}" ng-style="{\n                                                    \'width\': docLevel.textbox.geometry.width*slide.styleScale,\n                                                    \'left\': docLevel.textbox.geometry.x*slide.styleScale,\n                                                    \'top\': docLevel.textbox.geometry.y*slide.styleScale,\n                                                    \'transform\': \'rotate(\' + docLevel.textbox.rotation.angle + \'deg)\'}"><pre class="c-xml-page-textboxe-text web-font" ng-style="{\n                                                    \'font-family\':  \'\\\'\' + docLevel.textbox.fontuuid + \'\\\'\',\n                                                    \'font-size\': (docLevel.textbox.style.size*slide.ratio > 12 ? docLevel.textbox.style.size* slide.ratio : 12) + \'pt\',\n                                                    \'color\': docLevel.textbox.style.color,\n                                                    \'font-weight\': docLevel.textbox.style.bold ? \'bold\': \'400\',\n                                                    \'font-style\': docLevel.textbox.style.italic ? \'italic\': \'initial\',\n                                                    \'line-height\': (docLevel.textbox.style.size* slide.ratio > 12 ? docLevel.textbox.style.lineheight* slide.ratio : docLevel.textbox.style.lineheight*12/docLevel.textbox.style.size) + \'pt\',\n                                                    \'letter-spacing\': (docLevel.textbox.style.size* slide.ratio > 12 ? docLevel.textbox.style.letterspacing* slide.ratio : docLevel.textbox.style.letterspacing*12/docLevel.textbox.style.size) + \'pt\',\n                                                    \'opacity\': docLevel.textbox.transparency,\n                                                    \'text-decoration\': \'none\',\n                                                    \'text-align\': docLevel.textbox.style.align,\n                                                    \'text-align-last\': docLevel.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',\n                                                    \'transform\':\'scale(\'+(1 / 12 * docLevel.textbox.style.size* slide.ratio > 1 ? 1 : 1 / 12 * docLevel.textbox.style.size* slide.ratio)+\')\',\n                                                    \'width\':  (docLevel.textbox.style.size* slide.ratio > 12 ? (docLevel.textbox.geometry.width*slide.styleScale):docLevel.textbox.geometry.width*slide.styleScale/( 1 / 12 * docLevel.textbox.style.size*slide.ratio))+\'px\'\n                                                  }"><span class="c-xml-page-textboxe-span">{{docLevel.textbox.text}}</span></pre></div></div></div></div></div><div class="barcode" ng-show="slide.barcode" ng-style="{\n                                 \'z-index\':496,\n                                 \'width\': slide.barcode.geometry.width*slide.styleScale,\n                                 \'height\': slide.barcode.geometry.height*slide.styleScale,\n                                 \'left\': slide.barcode.geometry.x*slide.styleScale,\n                                 \'top\': slide.barcode.geometry.y*slide.styleScale,\n                                 \'transform\': \'rotate(-\' + slide.barcode.rotation.angle + \'deg)\' }"><img src="content/images/txm.png" style="width: 100%;height: 100%"></div><div class="barcode" ng-show="slide.qrcode" ng-style="{\n                                 \'z-index\':496,\n                                 \'width\': slide.qrcode.geometry.width*slide.styleScale,\n                                 \'height\': slide.qrcode.geometry.height*slide.styleScale,\n                                 \'left\': slide.qrcode.geometry.x*slide.styleScale,\n                                 \'top\': slide.qrcode.geometry.y*slide.styleScale,\n                                 \'transform\': \'rotate(-\' + slide.qrcode.rotation.angle + \'deg)\' }"><img src="content/images/QrCode.png" style="width: 100%;height: 100%"></div></div><div class="li-page" style="width: 100%; text-align: center" ng-show="$first">{{"choose.pageType."+template.pages.page[0].type | translate}}</div><div class="li-page text-left" ng-hide="$first||$last" ng-class="{\'is-left\':$index%2==1,\'is-right\':$index%2==0}">{{\'unit.page\' | translate}}{{$index}}</div><div class="li-page text-left" ng-show="$last && template.pages.page[0].type==\'FrontBack\'" ng-class="{\'is-left\':$index%2==1,\'is-right\':$index%2==0}">{{\'unit.page\' | translate}}{{$index}}</div><div class="li-page left-45" ng-show="$last && template.pages.page[0].type!=\'FrontBack\'">{{"choose.pageType."+template.pages.page[0].type | translate}}</div></li></ul><ul class="carousel5 pad-bottom-10" style="width: 100vw" ng-if="vm.pattern != \'BOOK\'" id="my-ui-list1"><li ng-repeat="slide in template.pages.page" data-index="{{$index}}" class="slide-li photo-content1" ng-click="clickToEdit(slide,$index)" ng-hide="slide.unreplace&&vm.sortStatus" ng-style="{ \'margin-left\':$index%2==1?(dWidth*0.1-10)/2:10}" id="slide{{$index}}" ng-init="outerIndex = $index"><div class="slide-content" data-sort-tag="{{slide.seq}}" ng-style="{\n                             overflow:\'hidden\',\n                             position:\'relative\',\n                             background:slide.background.color?slide.background.color:\'#fff\',\n                             width:(dWidth*0.45).toFixed(2),\n                             height:dWidth*0.45*slide.mediabox.height/slide.mediabox.width}"><div class="sort-disabled" ng-show="slide.unreplace&&vm.sortStatus"><div style="padding-top: 30%">{{"choose.editor.pageCannotBeMoved" | translate}}</div></div><img class="sort-disabled1" ng-show="slide.unreplace&&vm.sortStatus" ontouchstart="return false;" style="pointer-events: none;-webkit-user-select: none;-webkit-touch-callout: none"> <img ng-src="{{slide.background.resource.identifier+\'?imageMogr2/thumbnail/200x200>\'}}" ng-if="slide.background.resource.identifier" class="background backgroundImg{{$index}}" data-index="{{$index}}" ng-style="{\n                                     position: \'absolute\',\n                                     left:slide.background.offsetx*slide.styleScale,\n                                     top:slide.background.offsety*slide.styleScale,\n                                     width: slide.background.resource.adaptation==\'Width\'?\'100%\':\'\',\n                                     height:slide.background.resource.adaptation==\'Height\'?\'100%\':\'\'}"><div ng-repeat="level in slide.levels.level track by $index"><div class="sticker-edit-box" ng-if="level.imageart&&level.imageart.geometry" data-index="{{$index}}" ng-style="{\n                                     \'opacity\':level.imageart.transparency,\n                                     filter: \'alpha(opacity=\'+level.imageart.transparency*100+\')\',\n                                     \'transform\':\'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                     \'-ms-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                     \'-moz-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                     \'-webkit-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                     \'-o-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                     \'width\': level.imageart.geometry.width*slide.styleScale+2,\n                                     \'height\': level.imageart.geometry.height*slide.styleScale+2,\n                                     \'left\': level.imageart.geometry.x*slide.styleScale,\n                                     \'top\': level.imageart.geometry.y*slide.styleScale,\n                                     \'z-index\':level.seq-0+200}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                \'left\': level.imageart.offsetx*slide.styleScale,\n                                                \'top\': level.imageart.offsety*slide.styleScale,\n                                                \'width\': level.imageart.geometry.width * level.imageart.scale*slide.styleScale}" ng-src="{{level.imageart.resource.identifier+\'?imageMogr2/thumbnail/800x800>\'}}"></div></div><div ng-if="level.imagebox&&level.imagebox.geometry" ng-style="{\n                                            \'position\': \'absolute\',\n                                            width: imageboxW(level.imagebox) * slide.styleScale,\n                                            height: imageboxH(level.imagebox) * slide.styleScale,\n                                            left: imageboxL(level.imagebox) * slide.styleScale,\n                                            top: imageboxT(level.imagebox) * slide.styleScale,\n                                            \'z-index\':level.seq-0+200,\n                                            \'transform\': \'rotate(\' + level.imagebox.rotation.angle + \'deg)\',\n                                         }"><div class="relative-view1" ng-style="{\n                                         \'overflow\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'unset\' : \'hidden\',\n                                                \'opacity\':level.imagebox.transparency,\n                                                \'border-top-left-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'lt\', slide.styleScale),\n                                                \'border-top-right-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'rt\', slide.styleScale),\n                                                \'border-bottom-right-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'rb\', slide.styleScale),\n                                                \'border-bottom-left-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'lb\', slide.styleScale),\n                                                \'border-width\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? (level.imagebox.border.lineWidth * slide.styleScale) : \'\',\n                                                \'border-style\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? (level.imagebox.border.lineType || \'solid\') : \'none\',\n                                                \'border-color\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? level.imagebox.border.color : \'\',\n                                                \'box-shadow\' : (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineWidth>0 && (!level.imagebox.border.lineType || level.imagebox.border.lineType == \'solid\')) ? \'0 0 0 1px \' + level.imagebox.border.color + \' inset\' : \'none\',\n                                                \'filter\' : dropShadow(level.imagebox,slide.styleScale,slide.styleScale),\n                                                }"><div ng-style="{\n                                             \'position\': \'absolute\',\n                                             \'z-index\':0,\n                                            \'left\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'left\') * slide.styleScale : 0,\n                                            \'top\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'top\') * slide.styleScale : 0,\n                                            \'right\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'right\') * slide.styleScale : 0,\n                                            \'bottom\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'bottom\') * slide.styleScale : 0,\n                                            \'background-image\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'url(\' + level.imagebox.border.resource.identifier + \')\' : \'\',\n                                            \'background-size\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'100% 100%\' : \'\',\n                                            }"></div><div class="relative-view1" ng-style="{\n                                                    \'background\': level.imagebox.image.resource.identifier ? \'none\' : \'#ddd\',\n                                                    \'border-top-left-radius\':imageboxWRadius1(level.imagebox, \'lt\', slide.styleScale),\n                                                    \'border-top-right-radius\':imageboxWRadius1(level.imagebox, \'rt\', slide.styleScale),\n                                                    \'border-bottom-right-radius\':imageboxWRadius1(level.imagebox, \'rb\', slide.styleScale),\n                                                    \'border-bottom-left-radius\':imageboxWRadius1(level.imagebox, \'lb\', slide.styleScale),\n                                                    \'-webkit-mask-image\': level.imagebox.mask.resource.identifier ? \'url(\' + level.imagebox.mask.resource.identifier + \')\' : \'none\',\n                                                    \'-webkit-mask-size\': \'100% 100%\'}"><div style="position: relative"><div class="picLowerSize text-r" ng-cloak ng-show="level.imagebox && level.imagebox.image && level.imagebox.lowSize" ng-style="{ left:level.imagebox.geometry.width*slide.styleScale/2-8, top:level.imagebox.geometry.height*slide.styleScale/2-11}"><img src="content/images/ic_pixel.svg"></div></div><div class="img-place-holder indexSet-800" ng-hide="level.imagebox.image.resource.identifier"><img src="content/images/icons/addcamera.svg"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'None\' && level.imagebox.image.resource.identifier"><img ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/strip/rotate/\' + level.imagebox.image.angle+\'/thumbnail/800x800>\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                    \'width\': level.imagebox.image.width*level.imagebox.image.scale*slide.styleScale,\n                                                    \'height\': level.imagebox.image.height*level.imagebox.image.scale*slide.styleScale,\n                                                    \'left\':level.imagebox.image.offsetx*level.imagebox.image.scale*slide.styleScale,\n                                                    \'top\':level.imagebox.image.offsety*level.imagebox.image.scale*slide.styleScale\n                                                 }"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'Blurred\' && level.imagebox.image.resource.identifier"><img class="c-blur" ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/strip/rotate/\' + level.imagebox.image.angle+\'/thumbnail/800x800>\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                    \'width\': level.imagebox.image.width*slide.styleScale,\n                                                    \'height\': level.imagebox.image.height*slide.styleScale,\n                                                 }"> <img ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/strip/rotate/\' + level.imagebox.image.angle+\'/thumbnail/800x800>\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                    \'width\': level.imagebox.blurredrectangle.width*slide.styleScale,\n                                                    \'height\': level.imagebox.blurredrectangle.height*slide.styleScale,\n                                                    \'left\':level.imagebox.blurredrectangle.x*slide.styleScale,\n                                                    \'top\':level.imagebox.blurredrectangle.y*slide.styleScale,\n                                                    \'z-index\': 1\n                                                 }"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'Transparent\' && level.imagebox.image.resource.identifier"><img ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/strip/rotate/\' + level.imagebox.image.angle+\'/thumbnail/800x800>\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                    \'width\': level.imagebox.blurredrectangle.width*slide.styleScale,\n                                                    \'height\': level.imagebox.blurredrectangle.height*slide.styleScale,\n                                                    \'left\':level.imagebox.blurredrectangle.x*slide.styleScale,\n                                                    \'top\':level.imagebox.blurredrectangle.y*slide.styleScale,\n                                                    \'z-index\': 1\n                                                 }"></div></div></div></div><div class="text-box" ng-if="level.textbox&&level.textbox.geometry" data-index="{{$index}}" style="line-height: 0;min-height: 10px;min-width: 24px" ng-style="{\n                                     top: level.textbox.geometry.y*slide.styleScale,\n                                     left: level.textbox.geometry.x*slide.styleScale,\n                                     \'width\': level.textbox.geometry.width*slide.styleScale,\n                                     \'height\': level.textbox.geometry.height*slide.styleScale,\n                                     \'transform\': \'rotate(\' +  level.textbox.rotation.angle + \'deg)\',\n                                     \'z-index\':level.seq-0+200}"><pre class="c-xml-page-textboxe-text web-font" data-index="{{$index}}" ng-style="{\n                                            \'font-family\':  \'\\\'\' + level.textbox.fontuuid + \'\\\'\',\n                                            \'font-size\': (level.textbox.style.size*slide.ratio > 12 ? level.textbox.style.size* slide.ratio : 12) + \'pt\',\n                                            \'color\': level.textbox.style.color,\n                                            \'font-weight\': level.textbox.style.bold ? \'bold\': \'400\',\n                                            \'font-style\': level.textbox.style.italic ? \'italic\': \'initial\',\n                                            \'line-height\': (level.textbox.style.size* slide.ratio > 12 ? level.textbox.style.lineheight* slide.ratio : level.textbox.style.lineheight*12/level.textbox.style.size) + \'pt\',\n                                            \'letter-spacing\': (level.textbox.style.size* slide.ratio > 12 ? level.textbox.style.letterspacing* slide.ratio : level.textbox.style.letterspacing*12/level.textbox.style.size) + \'pt\',\n                                            \'opacity\': level.textbox.transparency,\n                                            \'text-decoration\': \'none\',\n                                            \'text-align\': level.textbox.style.align,\n                                            \'writing-mode\': level.textbox.style.writingmode,\n                                            \'text-align-last\': level.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',\n                                            \'transform\':\'scale(\'+(1 / 12 * level.textbox.style.size* slide.ratio > 1 ? 1 : 1 / 12 * level.textbox.style.size* slide.ratio)+\')\',\n                                            \'width\':  (level.textbox.style.size* slide.ratio > 12 ? (level.textbox.geometry.width*slide.styleScale):(level.textbox.geometry.width*slide.styleScale)/( 1 / 12 * level.textbox.style.size*slide.ratio))+\'px\'\n                                          }"><span class="c-xml-page-textboxe-span">{{level.textbox.text}}</span></pre></div><div data-index="{{$index}}" ng-show="level.textdocument&&level.textdocument.geometry" ng-style="{\n                                        position: \'absolute\',\n                                        width: level.textdocument.geometry.width*slide.styleScale,\n                                        height: level.textdocument.geometry.height*slide.styleScale,\n                                        left: level.textdocument.geometry.x*slide.styleScale,\n                                        top: level.textdocument.geometry.y*slide.styleScale,\n                                        \'z-index\':level.seq-0+200,\n                                        \'opacity\':level.textdocument.transparency.toFixed(2),\n                                        filter: \'alpha(opacity=\'+level.textdocument.transparency*100+\')\',\n                                        \'transform\': \'rotate(-\' + level.textdocument.rotation.angle + \'deg)\'}"><div style="overflow: hidden;width: 100%;height: 100%;position: relative" class="no-events"><img class="bg-image bg-image{{template.pageI}} pos" ng-cloak ng-if="level.textdocument.background.resource.identifier" ng-src="{{level.textdocument.background.resource.identifier+\'?imageMogr2/thumbnail/800x800>\'||\'//:0\'}}" ng-style="{\n                                                 position: \'absolute\',\n                                                 left:level.textdocument.background.offsetx*slide.styleScale,\n                                                 top:level.textdocument.background.offsety*slide.styleScale,\n                                                 width: level.textdocument.background.adaptation==\'Width\'?level.textdocument.geometry.width*slide.styleScale:\'\',\n                                                 height:level.textdocument.background.adaptation!=\'Width\'?level.textdocument.geometry.height*slide.styleScale:\'\'}"><div ng-repeat="docLevel in level.textdocument.levels.level track by $index" ng-init="docIndex = $index" style="position: relative"><div data-index="{{docIndex}}" class="img-art" ng-show="docLevel.imageart" ng-style="{\n                                                    width: docLevel.imageart.geometry.width*slide.styleScale,\n                                                    height: docLevel.imageart.geometry.height*slide.styleScale,\n                                                    left: docLevel.imageart.geometry.x*slide.styleScale,\n                                                    top: docLevel.imageart.geometry.y*slide.styleScale,\n                                                    \'z-index\':docLevel.seq-0+200,\n                                                    \'opacity\':docLevel.imageart.transparency,\n                                                    filter: \'alpha(opacity=\'+docLevel.imageart.transparency*100+\')\',\n                                                    \'transform\': \'rotate(\' + docLevel.imageart.rotation.angle + \'deg)\'}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                            \'left\': docLevel.imageart.offsetx*slide.styleScale,\n                                                            \'top\': docLevel.imageart.offsety*slide.styleScale,\n                                                            \'width\': docLevel.imageart.geometry.width * docLevel.imageart.scale*slide.styleScale}" ng-src="{{docLevel.imageart.resource.identifier+\'?imageMogr2/thumbnail/800x800>\'}}"></div></div><div class="c-xml-page-textboxe" ng-show="docLevel.textbox" style="white-space: normal" data-index="{{docIndex}}" ng-style="{\n                                                    \'width\': docLevel.textbox.geometry.width*slide.styleScale,\n                                                    \'left\': docLevel.textbox.geometry.x*slide.styleScale,\n                                                    \'top\': docLevel.textbox.geometry.y*slide.styleScale,\n                                                    \'transform\': \'rotate(\' + docLevel.textbox.rotation.angle + \'deg)\'}"><pre class="c-xml-page-textboxe-text web-font" ng-style="{\n                                                    \'font-family\':  \'\\\'\' + docLevel.textbox.fontuuid + \'\\\'\',\n                                                    \'font-size\': (docLevel.textbox.style.size*slide.ratio > 12 ? docLevel.textbox.style.size* slide.ratio : 12) + \'pt\',\n                                                    \'color\': docLevel.textbox.style.color,\n                                                    \'font-weight\': docLevel.textbox.style.bold ? \'bold\': \'400\',\n                                                    \'font-style\': docLevel.textbox.style.italic ? \'italic\': \'initial\',\n                                                    \'line-height\': (docLevel.textbox.style.size* slide.ratio > 12 ? docLevel.textbox.style.lineheight* slide.ratio : docLevel.textbox.style.lineheight*12/docLevel.textbox.style.size) + \'pt\',\n                                                    \'letter-spacing\': (docLevel.textbox.style.size* slide.ratio > 12 ? docLevel.textbox.style.letterspacing* slide.ratio : docLevel.textbox.style.letterspacing*12/docLevel.textbox.style.size) + \'pt\',\n                                                    \'opacity\': docLevel.textbox.transparency,\n                                                    \'text-decoration\': \'none\',\n                                                    \'text-align\': docLevel.textbox.style.align,\n                                                    \'text-align-last\': docLevel.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',\n                                                    \'transform\':\'scale(\'+(1 / 12 * docLevel.textbox.style.size* slide.ratio > 1 ? 1 : 1 / 12 * docLevel.textbox.style.size* slide.ratio)+\')\',\n                                                    \'width\':  (docLevel.textbox.style.size* slide.ratio > 12 ? (docLevel.textbox.geometry.width*slide.styleScale):docLevel.textbox.geometry.width*slide.styleScale/( 1 / 12 * docLevel.textbox.style.size*slide.ratio))+\'px\'\n                                                  }"><span class="c-xml-page-textboxe-span">{{docLevel.textbox.text}}</span></pre></div></div></div></div></div><div class="barcode" ng-show="slide.barcode" ng-style="{\n                                 \'z-index\':496,\n                                 \'width\': slide.barcode.geometry.width*slide.styleScale,\n                                 \'height\': slide.barcode.geometry.height*slide.styleScale,\n                                 \'left\': slide.barcode.geometry.x*slide.styleScale,\n                                 \'top\': slide.barcode.geometry.y*slide.styleScale,\n                                 \'transform\': \'rotate(-\' + slide.barcode.rotation.angle + \'deg)\' }"><img src="content/images/txm.png" style="width: 100%;height: 100%"></div><div class="barcode" ng-show="slide.qrcode" ng-style="{\n                                 \'z-index\':496,\n                                 \'width\': slide.qrcode.geometry.width*slide.styleScale,\n                                 \'height\': slide.qrcode.geometry.height*slide.styleScale,\n                                 \'left\': slide.qrcode.geometry.x*slide.styleScale,\n                                 \'top\': slide.qrcode.geometry.y*slide.styleScale,\n                                 \'transform\': \'rotate(-\' + slide.qrcode.rotation.angle + \'deg)\' }"><img src="content/images/QrCode.png" style="width: 100%;height: 100%"></div></div><div class="li-page text-left" ng-class="{\'is-left\':$index%2==0,\'is-right\':$index%2==1}">{{"choose.editor.page" | translate}}{{$index+1}}</div></li></ul></div><div class="col-lg-12 col-sm-12 col-xs-12 infoWaring flex-btn-group-container tip-image" style="padding: 0 10px;font-size: 12px;z-index:1" ng-show="vm.messageEdit.length&&status==\'make\'"><img src="content/images/icons/notice.svg" alt="" style="width:24px;height:24px;margin-right:5px;margin-top: 4px"><marquee scrollamount="2" height="30" behavior="scroll" direction="left" align="left" style="width: 100%;line-height: 30px">{{vm.messageEditText}}</marquee></div><!--\u56FE\u7247\u7F16\u8F91\u6309\u94AE--><div class="edit-menu edit-menu-make opacity-zero1 operateButton clearfix" ng-if="template.pages.page[template.pageI].levels.level[template.levelI].imagebox" style="font-size: 0;padding-left: 0!important" ng-style="{\'width\':5*(24+30)+30+\'px\'}"><!--\u88C1\u5207--><div class="common cut-image" ng-click="cutImage()"><i class="iconfont iconcaiqie1"></i> <span>{{"choose.editor.cut" | translate}}</span></div><!--\u5C55\u5F00--> <span class="common mode1" ng-click="modeIn()" ng-if="vm.article.bokehtype != \'None\'"><img src="content/images/icons/unfold2.svg" alt=""> </span><!--\u7F29\u5C0F--> <span class="common mode2" ng-click="modeOut()" ng-if="vm.article.bokehtype != \'None\'"><img src="content/images/icons/shrink22.svg" alt=""> </span><!--\u6362\u56FE--><div class="common trash" ng-click="addGallery()"><i class="iconfont iconhuantu"></i> <span>{{"choose.editor.changeImgText" | translate}}</span></div><!--\u4EA4\u6362--><div class="common change" ng-click="replaceImage()"><i class="iconfont iconjiaohuan"></i> <span>{{"choose.editor.exchange" | translate}}</span></div></div><div class="c-operation-view" style="margin: 60px 0 10px" ng-if="template.pages.page[template.pageI].levels.level[template.levelI].textbox"><div class="c-operation-ntm" ng-click="textLayout(\'horizontal-tb\')" ng-if="template.pages.page[template.pageI].levels.level[template.levelI].textbox.style.writingmode != \'horizontal-tb\'"><i class="iconfont iconhengban"></i><div>{{"choose.editor.horizontal" | translate}}</div></div><div class="c-operation-ntm" ng-click="textLayout(\'vertical-lr\')" ng-if="template.pages.page[template.pageI].levels.level[template.levelI].textbox.style.writingmode != \'vertical-lr\'"><i class="iconfont iconshuban"></i><div>{{"choose.editor.vertical" | translate}}</div></div></div><!--\u5355\u5F20\u7F16\u8F91\u9875\u9762--><div ng-show="status==\'make\'&&!showCut&&!showTextModal"><input id="uploadImg1" type="file" multiple="multiple" accept="{{vm.supportedMimeTypes}}" name="file" value="" style="display: none"><div class="template-carousel" style="position: absolute; top: 50%;transform: translate(0, -50%)" ng-style="{ width:dWidth*0.94}"><ul class="carousel5 transition-move js-fade fade-in is-paused" ng-style="{width:dWidth*PAGELEN}"><li ng-repeat="slide in template.pages.page track by $index" data-index="{{$index}}" class="slide-li" ng-style="{ \'margin-left\':slide.isMaxWidth?0:(dWidth*0.94-(dHeight-tHeight)*slide.mediabox.width/slide.mediabox.height)/2,\n                            \'margin-right\':slide.isMaxWidth?0:(dWidth*0.94-(dHeight-tHeight)*slide.mediabox.width/slide.mediabox.height)/2,\n                            \'margin-top\':(tHeight-220)/2}" id="slide-li{{$index}}" ng-init="outerIndex = $index"><div class="slide-content" ng-style="{ background:slide.background.color,\n                                 width:(slide.isMaxWidth?dWidth*0.94:(dHeight-tHeight)*slide.mediabox.width/slide.mediabox.height).toFixed(2),\n                                 height:slide.isMaxWidth?dWidth*0.94*slide.mediabox.height/slide.mediabox.width:(dHeight-tHeight)}"><div class="border-red no-events" ng-repeat="editbox in slide.editboxes.editbox" ng-style="{\n                                \'z-index\':999,\n                                overflow:\'hidden\',\n                                width:editbox.width*slide.styleScale2,\n                                height:editbox.height*slide.styleScale2,\n                                top:editbox.y*slide.styleScale2,\n                                left:editbox.x*slide.styleScale2}"></div><img ng-src="{{slide.background.resource.identifier+\'?imageMogr2/thumbnail/800x800>\'}}" ng-if="slide.background.resource.identifier" class="background backgroundImg{{$index}}" id="backgroundImg{{$index}}" data-index="{{$index}}" ng-style="{\n                                             position: \'absolute\',\n                                             left:slide.background.offsetx*slide.styleScale2,\n                                             top:slide.background.offsety*slide.styleScale2,\n                                             width: slide.background.resource.adaptation==\'Width\'?\'100%\':\'auto\',\n                                             height:slide.background.resource.adaptation==\'Height\'?\'100%\':\'auto\'}"><div ng-repeat="level in slide.levels.level track by $index"><div class="sticker-edit-box" ng-if="level.imageart&&level.imageart.geometry" ng-click="editSticker($event, $index)" data-index="{{$index}}" ng-class="{\n                                         \'outline1-solid\': $index == template.levelI&& level.imageart.useradded && template.currentMenu == \'imageart\',\n                                         \'no-border\':!level.imageart.useradded,\n                                         \'no-events\':!level.imageart.useradded}" ng-style="{\n                                         \'opacity\':level.imageart.transparency,\n                                         filter: \'alpha(opacity=\'+level.imageart.transparency*100+\')\',\n                                         \'transform\':\'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                         \'-ms-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                         \'-moz-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                         \'-webkit-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                         \'-o-transform\': \'rotate(\' +  level.imageart.rotation.angle + \'deg)\',\n                                         \'width\': level.imageart.geometry.width*slide.styleScale2,\n                                         \'height\': level.imageart.geometry.height*slide.styleScale2,\n                                         \'left\': level.imageart.geometry.x*slide.styleScale2,\n                                         \'top\': level.imageart.geometry.y*slide.styleScale2,\n                                         \'z-index\':level.seq-0+200}"><span ng-click="deleteAction($event, $index)" class="delete-text opacityMinus" style="top: -14px;left: -10px;z-index:300" ng-show="$index == template.levelI && level.imageart.movable&&level.imageart.editable&& level.imageart.useradded"></span> <span data-index="{{$index}}" ontouchstart="resizeStickerStart(event)" ng-show="$index == template.levelI && level.imageart.movable&&level.imageart.editable&& level.imageart.useradded" style="right: -10px" ontouchmove="resizeStickerOn(event)" ontouchend="resizeStickerEnd(event)" class="resize-text"></span><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                    \'left\': level.imageart.offsetx*slide.styleScale2,\n                                                    \'top\': level.imageart.offsety*slide.styleScale2,\n                                                    \'width\': level.imageart.geometry.width * level.imageart.scale*slide.styleScale2}" ng-src="{{level.imageart.resource.identifier+\'?imageMogr2/thumbnail/800x800>\'}}"></div></div><div ng-if="level.imagebox&&level.imagebox.geometry" data-index="{{$index}}" ng-click="chooseImage(outerIndex, $index)" ng-style="{\n                                        \'position\': \'absolute\',\n                                            width: imageboxW(level.imagebox) * slide.styleScale2,\n                                            height: imageboxH(level.imagebox) * slide.styleScale2,\n                                            left: imageboxL(level.imagebox) * slide.styleScale2,\n                                            top: imageboxT(level.imagebox) * slide.styleScale2,\n                                        \'z-index\':level.seq-0+200,\n                                        \'transform\': \'rotate(\' + level.imagebox.rotation.angle + \'deg)\',\n                                     }"><div class="relative-view1" ng-style="{\n                                             \'overflow\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'unset\' : \'hidden\',\n                                                \'opacity\':level.imagebox.transparency,\n                                                \'border-top-left-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'lt\', slide.styleScale2),\n                                                \'border-top-right-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'rt\', slide.styleScale2),\n                                                \'border-bottom-right-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'rb\', slide.styleScale2),\n                                                \'border-bottom-left-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'lb\', slide.styleScale2),\n                                                \'border-width\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? (level.imagebox.border.lineWidth * slide.styleScale2) : \'\',\n                                                \'border-style\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? (level.imagebox.border.lineType || \'solid\') : \'none\',\n                                                \'border-color\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? level.imagebox.border.color : \'\',\n                                                \'box-shadow\' : (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineWidth>0 && (!level.imagebox.border.lineType || level.imagebox.border.lineType == \'solid\')) ? \'0 0 0 1px \' + level.imagebox.border.color + \' inset\' : \'none\',\n                                                \'filter\' : dropShadow(level.imagebox,slide.styleScale2,slide.styleScale2),\n                                                }"><div ng-style="{\n                                             \'position\': \'absolute\',\n                                             \'z-index\':0,\n                                            \'left\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'left\') * slide.styleScale2 : 0,\n                                            \'top\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'top\') * slide.styleScale2 : 0,\n                                            \'right\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'right\') * slide.styleScale2 : 0,\n                                            \'bottom\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'bottom\') * slide.styleScale2 : 0,\n                                            \'background-image\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'url(\' + level.imagebox.border.resource.identifier + \')\' : \'\',\n                                            \'background-size\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'100% 100%\' : \'\',\n                                            }"></div><div class="relative-view1" ng-style="{\n                                                    \'background\': level.imagebox.image.resource.identifier ? \'none\' : \'#ddd\',\n                                                    \'border-top-left-radius\':imageboxWRadius1(level.imagebox, \'lt\', slide.styleScale2),\n                                                    \'border-top-right-radius\':imageboxWRadius1(level.imagebox, \'rt\', slide.styleScale2),\n                                                    \'border-bottom-right-radius\':imageboxWRadius1(level.imagebox, \'rb\', slide.styleScale2),\n                                                    \'border-bottom-left-radius\':imageboxWRadius1(level.imagebox, \'lb\', slide.styleScale2),\n                                                    \'-webkit-mask-image\': level.imagebox.mask.resource.identifier ? \'url(\' + level.imagebox.mask.resource.identifier + \')\' : \'none\',\n                                                    \'-webkit-mask-size\': \'100% 100%\'}"><div style="position: relative"><div class="picLowerSize text-r no-events" ng-cloak ng-show="level.imagebox && level.imagebox.image && level.imagebox.lowSize" ng-style="{ left:level.imagebox.geometry.width*slide.styleScale2/2-8, top:level.imagebox.geometry.height*slide.styleScale2/2-11}"><img src="content/images/ic_pixel.svg"></div></div><div class="change-btn" id="change-btn{{outerIndex}}{{$index}}" ng-click="changeMaskImage(outerIndex, $index,$event)" ng-show="level.imagebox.image.resource.identifier" ng-style="{ left:level.imagebox.geometry.width*slide.styleScale2/2-20, top:level.imagebox.geometry.height*slide.styleScale2/2-20}"><img src="content/images/icons/change01.svg"></div><div class="img-place-holder indexSet-800" ng-hide="level.imagebox.image.resource.identifier"><img src="content/images/icons/addcamera.svg"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden;transition: all .5s ease" ng-if="level.imagebox.bokehtype == \'None\' && level.imagebox.image.resource.identifier"><img alt="" ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/strip/rotate/\' + level.imagebox.image.angle+\'/thumbnail/800x800>\'}}" data-index="{{$index}}" ontouchstart="moveImageboxStart(event)" ontouchmove="moveImageboxOn(event)" ontouchend="moveImageboxEnd(event)" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'opacity\':level.imagebox.transparency,\n                                                    \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                    \'width\': level.imagebox.image.width*level.imagebox.image.scale*slide.styleScale2,\n                                                    \'height\': level.imagebox.image.height*level.imagebox.image.scale*slide.styleScale2,\n                                                    \'left\':level.imagebox.image.offsetx*level.imagebox.image.scale*slide.styleScale2,\n                                                    \'top\':level.imagebox.image.offsety*level.imagebox.image.scale*slide.styleScale2\n                                                 }"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'Blurred\' && level.imagebox.image.resource.identifier"><img class="c-blur" ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/strip/rotate/\' + level.imagebox.image.angle+\'/thumbnail/800x800>\'}}" data-index="{{$index}}" ng-style="{\n                                                \'position\': \'absolute\',\n                                                    \'opacity\':level.imagebox.transparency,\n                                                    \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                \'width\': level.imagebox.image.width*slide.styleScale2,\n                                                \'height\': level.imagebox.image.height*slide.styleScale2,\n                                             }"> <img ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/strip/rotate/\' + level.imagebox.image.angle+\'/thumbnail/800x800>\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'opacity\':level.imagebox.transparency,\n                                                    \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                    \'width\': level.imagebox.blurredrectangle.width*slide.styleScale2,\n                                                    \'height\': level.imagebox.blurredrectangle.height*slide.styleScale2,\n                                                    \'left\':level.imagebox.blurredrectangle.x*slide.styleScale2,\n                                                    \'top\':level.imagebox.blurredrectangle.y*slide.styleScale2,\n                                                    \'z-index\': 1\n                                             }"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'Transparent\' && level.imagebox.image.resource.identifier"><img alt="" ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/strip/rotate/\' + level.imagebox.image.angle+\'/thumbnail/800x800>\'}}" data-index="{{$index}}" ng-style="{\n                                                \'position\': \'absolute\',\n                                                    \'opacity\':level.imagebox.transparency,\n                                                    \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                \'width\': level.imagebox.blurredrectangle.width*slide.styleScale2,\n                                                \'height\': level.imagebox.blurredrectangle.height*slide.styleScale2,\n                                                \'left\':level.imagebox.blurredrectangle.x*slide.styleScale2,\n                                                \'top\':level.imagebox.blurredrectangle.y*slide.styleScale2,\n                                                \'z-index\': 1\n                                             }"></div></div></div></div><div class="text-box text-setX textbox{{outerIndex}}-{{$index}}" data-targ="text" ng-if="level.textbox&&level.textbox.geometry" ng-class="{\'outline1-dashed\': $index == template.levelI && template.currentMenu == \'textbox\',\'no-border\':!level.textbox.editable&&!level.textbox.movable&&!level.textbox.useradded,\n                                        \'pitch11\' : $index == template.levelI && level.textbox.useradded && template.currentMenu == \'textbox\'}" data-index="{{$index}}" style="white-space: normal;line-height: 0;min-height: 10px;min-width: 24px" ng-style="{\n                                         top: level.textbox.geometry.y*slide.styleScale2,\n                                         left: level.textbox.geometry.x*slide.styleScale2,\n                                         width: level.textbox.geometry.width*slide.styleScale2,\n                                         height: level.textbox.geometry.height*slide.styleScale2,\n                                         \'transform\': \'rotate(\' + level.textbox.rotation.angle + \'deg)\', \'z-index\': level.seq-0+200}"><div style="width: 100%;height: 100%;position: absolute;top:0;left: 0"><pre class="c-xml-page-textboxe-text web-font" id="c-xml-page-textboxe-text{{$index}}" ontouchstart="moveTextBoxStart(event)" ontouchmove="moveTextBoxOn(event)" ontouchend="moveTextBoxEnd(event)" data-index="{{$index}}" style="min-height: 10px" ng-style="{\n                                            \'font-family\':  \'\\\'\' + level.textbox.fontuuid + \'\\\'\',\n                                            \'font-size\': (level.textbox.style.size*slide.ratio2 > 12 ? level.textbox.style.size* slide.ratio2 : 12) + \'pt\',\n                                            \'color\': level.textbox.style.color,\n                                            \'font-weight\': level.textbox.style.bold ? \'bold\': \'400\',\n                                            \'font-style\': level.textbox.style.italic ? \'italic\': \'initial\',\n                                            \'line-height\': (level.textbox.style.size* slide.ratio2 > 12 ? level.textbox.style.lineheight* slide.ratio2 : level.textbox.style.lineheight*12/level.textbox.style.size) + \'pt\',\n                                            \'letter-spacing\': (level.textbox.style.size* slide.ratio2 > 12 ? level.textbox.style.letterspacing* slide.ratio2 : level.textbox.style.letterspacing*12/level.textbox.style.size) + \'pt\',\n                                            \'opacity\': level.textbox.transparency,\n                                            \'text-decoration\': \'none\',\n                                            \'text-align\': level.textbox.style.align,\n                                            \'writing-mode\': level.textbox.style.writingmode,\n                                            \'text-align-last\': level.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',\n                                            \'transform\':\'scale(\'+(1 / 12 * level.textbox.style.size* slide.ratio2 > 1 ? 1 : 1 / 12 * level.textbox.style.size* slide.ratio2)+\')\',\n                                            \'width\':  (level.textbox.style.size* slide.ratio2 > 12 ? (level.textbox.geometry.width*slide.styleScale2):(level.textbox.geometry.width*slide.styleScale2)/( 1 / 12 * level.textbox.style.size*slide.ratio2))+\'px\',\n                                            \'height\':  (text.textbox.style.size* slide.ratio2 > 12 ? (text.textbox.geometry.height*slide.styleScale2):text.textbox.geometry.height*slide.styleScale2/( 1 / 12 * text.textbox.style.size*slide.ratio2))+\'px\'\n                                          }"><span class="c-xml-page-textboxe-span">{{level.textbox.text}}</span></pre><div class="loading-font" ng-if="level.textbox.loading"></div></div><span class="delete-text" ng-show="$index == template.levelI&&level.textbox.editable&&level.textbox.useradded" data-index="{{$index}}" ng-click="deleteSelectedText($event, $index,outerIndex)"></span> <span class="edit-text" ng-show="$index == template.levelI&&level.textbox.editable&&level.textbox.useradded" ng-click="editTextContent($event, $index,level.textbox,outerIndex)"></span> <span class="resize-text" ng-show="$index == template.levelI&&level.textbox.movable&&level.textbox.useradded" data-index="{{$index}}" ontouchstart="resizeTextBoxStart(event)" ontouchmove="resizeTextBoxOn(event)" ontouchend="resizeTextBoxEnd(event)"></span></div><div data-index="{{$index}}" ng-show="level.textdocument&&level.textdocument.geometry" ontouchstart="moveTextDocStart(event)" ontouchmove="moveTextDocOn(event)" ontouchend="moveTextDocEnd(event)" ng-style="{\n                                        position: \'absolute\',\n                                        width: level.textdocument.geometry.width*slide.styleScale2,\n                                        height: level.textdocument.geometry.height*slide.styleScale2,\n                                        left: level.textdocument.geometry.x*slide.styleScale2,\n                                        top: level.textdocument.geometry.y*slide.styleScale2,\n                                        \'z-index\':level.seq-0+200,\n                                        \'opacity\':level.textdocument.transparency.toFixed(2),\n                                        filter: \'alpha(opacity=\'+level.textdocument.transparency*100+\')\',\n                                        \'transform\': \'rotate(-\' + level.textdocument.rotation.angle + \'deg)\'}" ng-click="selectDoc($event, $index, level.textdocument)"><div style="overflow: hidden;width: 100%;height: 100%;position: relative" class="no-events"><img class="bg-image bg-image{{template.pageI}} pos" ng-cloak ng-if="level.textdocument.background.resource.identifier" ng-src="{{level.textdocument.background.resource.identifier+\'?imageMogr2/thumbnail/800x800>\'||\'//:0\'}}" ng-style="{\n                                                 position: \'absolute\',\n                                                 left:level.textdocument.background.offsetx*slide.styleScale2,\n                                                 top:level.textdocument.background.offsety*slide.styleScale2,\n                                                 width: level.textdocument.background.adaptation==\'Width\'?level.textdocument.geometry.width*slide.styleScale2:\'\',\n                                                 height:level.textdocument.background.adaptation!=\'Width\'?level.textdocument.geometry.height*slide.styleScale2:\'\'}"><div ng-repeat="docLevel in level.textdocument.levels.level track by $index" ng-init="docIndex = $index" style="position: relative"><div data-index="{{docIndex}}" class="img-art" ng-show="docLevel.imageart" ng-style="{\n                                                    width: docLevel.imageart.geometry.width*slide.styleScale2,\n                                                    height: docLevel.imageart.geometry.height*slide.styleScale2,\n                                                    left: docLevel.imageart.geometry.x*slide.styleScale2,\n                                                    top: docLevel.imageart.geometry.y*slide.styleScale2,\n                                                    \'z-index\':docLevel.seq-0+200,\n                                                    \'opacity\':docLevel.imageart.transparency,\n                                                    filter: \'alpha(opacity=\'+docLevel.imageart.transparency*100+\')\',\n                                                    \'transform\': \'rotate(\' + docLevel.imageart.rotation.angle + \'deg)\'}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                            \'left\': docLevel.imageart.offsetx*slide.styleScale2,\n                                                            \'top\': docLevel.imageart.offsety*slide.styleScale2,\n                                                            \'width\': docLevel.imageart.geometry.width * docLevel.imageart.scale*slide.styleScale2}" ng-src="{{docLevel.imageart.resource.identifier+\'?imageMogr2/thumbnail/800x800>\'}}"></div></div><div class="c-xml-page-textboxe" ng-show="docLevel.textbox" style="white-space: normal" data-index="{{docIndex}}" ng-style="{\n                                                    \'width\': docLevel.textbox.geometry.width*slide.styleScale2,\n                                                    \'left\': docLevel.textbox.geometry.x*slide.styleScale2,\n                                                    \'top\': docLevel.textbox.geometry.y*slide.styleScale2,\n                                                    \'transform\': \'rotate(\' + docLevel.textbox.rotation.angle + \'deg)\'}"><pre class="c-xml-page-textboxe-text web-font" ng-style="{\n                                                    \'font-family\':  \'\\\'\' + docLevel.textbox.fontuuid + \'\\\'\',\n                                                    \'font-size\': (docLevel.textbox.style.size*slide.ratio2 > 12 ? docLevel.textbox.style.size* slide.ratio2 : 12) + \'pt\',\n                                                    \'color\': docLevel.textbox.style.color,\n                                                    \'font-weight\': docLevel.textbox.style.bold ? \'bold\': \'400\',\n                                                    \'font-style\': docLevel.textbox.style.italic ? \'italic\': \'initial\',\n                                                    \'line-height\': (docLevel.textbox.style.size* slide.ratio2 > 12 ? docLevel.textbox.style.lineheight* slide.ratio2 : docLevel.textbox.style.lineheight*12/docLevel.textbox.style.size) + \'pt\',\n                                                    \'letter-spacing\': (docLevel.textbox.style.size* slide.ratio2 > 12 ? docLevel.textbox.style.letterspacing* slide.ratio2 : docLevel.textbox.style.letterspacing*12/docLevel.textbox.style.size) + \'pt\',\n                                                    \'opacity\': docLevel.textbox.transparency,\n                                                    \'text-decoration\': \'none\',\n                                                    \'text-align\': docLevel.textbox.style.align,\n                                                    \'text-align-last\': docLevel.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',\n                                                    \'transform\':\'scale(\'+(1 / 12 * docLevel.textbox.style.size* slide.ratio2 > 1 ? 1 : 1 / 12 * docLevel.textbox.style.size* slide.ratio2)+\')\',\n                                                    \'width\':  (docLevel.textbox.style.size* slide.ratio2 > 12 ? (docLevel.textbox.geometry.width*slide.styleScale2):docLevel.textbox.geometry.width*slide.styleScale2/( 1 / 12 * docLevel.textbox.style.size*slide.ratio2))+\'px\'\n                                                  }"><span class="c-xml-page-textboxe-span">{{docLevel.textbox.text}}</span></pre><div class="loading-font" ng-if="docLevel.textbox.loading"></div></div></div></div></div></div><div class="barcode" ng-show="slide.barcode" ng-style="{\n                                     \'z-index\':499,\n                                     \'width\': slide.barcode.geometry.width*slide.styleScale2,\n                                     \'height\': slide.barcode.geometry.height*slide.styleScale2,\n                                     \'left\': slide.barcode.geometry.x*slide.styleScale2,\n                                     \'top\': slide.barcode.geometry.y*slide.styleScale2,\n                                     \'transform\': \'rotate(-\' + slide.barcode.rotation.angle + \'deg)\' }"><img src="content/images/txm.png" style="width: 100%;height: 100%"></div><div class="barcode" ng-show="slide.qrcode" ng-style="{\n                                     \'z-index\':499,\n                                     \'width\': slide.qrcode.geometry.width*slide.styleScale2,\n                                     \'height\': slide.qrcode.geometry.height*slide.styleScale2,\n                                     \'left\': slide.qrcode.geometry.x*slide.styleScale2,\n                                     \'top\': slide.qrcode.geometry.y*slide.styleScale2,\n                                     \'transform\': \'rotate(-\' + slide.qrcode.rotation.angle + \'deg)\' }"><img src="content/images/QrCode.png" style="width: 100%;height: 100%"></div></div></li></ul></div><button class="leftBtn opacityMinus ll{{$index}}" ng-click="pageLeft()" ng-show="visibleLeft" style="position: fixed!important;left: 10px"><span class="arrowDirections arrowLeft-new"></span></button> <button class="rightBtn opacityMinus rr{{$index}}" ng-click="pageRight()" ng-hide="visibleRight" style="position: fixed!important;right: 10px"><span class="arrowDirections arrowRight-new"></span></button></div></div><p class="text-width"></p><div id="small-pic" class="hide1 user-select-default pointer-un" ontouchstart="return false;" ng-style="{left:galleryX||0,top:galleryY||0}"><img ng-src="{{galleryChoose+\'?imageView2/1/w/60/h/60\'||\'//:0\'}}"></div><div class="text-tip hide1"><span>{{"choose.editor.nonReplaceable" | translate}}</span></div><!--\u5E95\u90E8\u83DC\u5355--><div class="fix-bottom-section fix-text" style="box-shadow: none!important"><!--\u8D34\u7EB8\u83DC\u5355--><div class="mar-bottom-10 clipart-head sticker-wrapper col-xs-12 pad-0" style="height: 30px" ng-show="showStickerMenu"><button ng-repeat="label in labels track by $index" ng-click="selectLabel(label,$index)" data-index="{{$index}}" class="radius-btn" ng-class="{\'button-sel\':label.id==artlabelChooseId}">{{label.name}}</button></div><div class="sticker-menu col-xs-12 pad-0" ng-show="showStickerMenu"><div class="bottom-close col-xs-1 pad-0" ng-click="closeToBarMenu()"><i class="icon iconfont iconcuo default-btncolor-mobile font-20"></i></div><div class="sticker-wrapper sticker-scroll col-xs-11 pad-0"><span class="sticker-box" ng-repeat="sticker in stickerList | orderBy: \'sort\'"><img ng-src="{{sticker.identifier}}?imageMogr2/thumbnail/200x200>" ng-click="addSticker($event,sticker)" ng-style="{\'width\': 80, \'max-height\':80}"></span></div></div><!--\u6A21\u677F\u83DC\u5355--><div class="temp-menu" ng-show="showTempMenu"><div class="bottom-close col-xs-1 pad-0" ng-click="closeToBarMenu()"><i class="icon iconfont iconcuo default-btncolor-mobile font-20"></i></div><div class="sticker-wrapper col-xs-11 pad-0"><ul style="height: 92px;margin-top: 8px" class="temp-ul" ng-if="pageAllPx.page.length && vm.replace&&!template.pages.page[currentCarouselIndex].unreplace"><li class="temp-li" ng-class="{\'select-li\':selectedLi==page.uuid}" ng-click="changeTemp($index,page)" ng-repeat="page in pageAllPx.page track by $index" ng-init="outerIndex = $index" ng-if="!page.unreplace"><div data-index="{{$index}}" class="" ng-style="{ height:mHeight, width:page.width*mHeight/page.height, margin:\'0 auto\', background:\'#fff\', position:\'relative\'}"><img class="top-img no-events" style="width: 100%" ng-if="page.pagecover.identifier" ng-src="{{page.pagecover.identifier}}?imageMogr2/thumbnail/200x200>"> <img class="top-img no-events" style="width: 50%;margin-left: 25%;margin-top: 10px" ng-if="!page.pagecover.identifier" src="content/images/default.png"><div class="use-account diy-btn-primarys" style="z-index: 800"><!-- \u4F7F\u7528\u6B21\u6570 --> <span>{{page.count||0}}</span></div></div></li></ul><div ng-if="!pageAllPx.page.length || !vm.replace" class="pad-left-20"><img src="content/images/icons/empty.svg"> <span style="color: gray">{{"choose.editor.noReplaceableTemplate" | translate}}</span></div></div></div><div class="col-lg-12 col-sm-12 col-xs-12 bottom-btn" ng-show="showBottomMenu&&status==\'make\'&&!showCut"><div class="col-xs-12" style="padding: 10px 0"><div class="col-xs-4 pad-0 text-c" ng-click="toggleTempMenu($event)" ng-if="pageAllPx.page.length && vm.replace&&!template.pages.page[currentCarouselIndex].unreplace"><div class="tabIcons4"><i class="icon iconfont iconmoban1"></i></div><span class="col-3c3c">{{"choose.editor.template" | translate}}</span></div><div class="col-xs-4 pad-0 text-c" ng-if="!pageAllPx.page.length || !vm.replace||template.pages.page[currentCarouselIndex].unreplace"></div><div class="col-xs-4 pad-0 text-c" ng-click="toggleStickerMenu($event)"><div class="tabIcons4"><i class="icon iconfont iconcailiao"></i></div><span>{{"choose.editor.material" | translate}}</span></div><div class="col-xs-4 pad-0 text-c"><div ng-click="toggleTextMenu($event)" ng-show="fontList.length"><div class="tabIcons4"><i class="icon iconfont iconwenzi"></i></div><span>{{"choose.editor.text" | translate}}</span></div></div></div></div></div><div class="save-pages opacity-zero guide-view" ng-click="nextStep2()" ng-show="!vm.guideStep && countN == 7 && !loadingAfter"><!--\u4F5C\u54C1\u5236\u4F5C\u9875\u9762\u9884\u89C8\u5F15\u5BFC\u56FE--><div class="edit-page-content1" ng-style="{width:dWidth,\'min-height\':dHeight,background:status==\'make\'?\'#eee\':\'\'}"><div class="template-view" ng-show="status==\'view\'" style="width: 100%;overflow: visible;margin-top: 84px" ng-style="{\'height\':(dHeight-84)+\'px\'}"><ul class="carousel5"><li class="slide-li" ng-style="{ \'margin-left\':vm.pattern!=\'BOOK\'?10:(dWidth-dWidth*0.6)/2}" ng-init="outerIndex = 0"><div class="slide-content" ng-style="{\n                                 overflow:\'hidden\',\n                                 position:\'relative\',\n                                 background:template.pages.page[0].background.color,\n                                 width:vm.pattern!=\'BOOK\'?(dWidth*0.45).toFixed(2):(dWidth*0.6).toFixed(2),\n                                 height:vm.pattern!=\'BOOK\'?dWidth*0.45*template.pages.page[0].height/template.pages.page[0].width: dWidth*0.6*template.pages.page[0].height/template.pages.page[0].width}"><img ng-src="{{template.pages.page[0].background.resource.identifier+\'?imageMogr2/thumbnail/!20p\'}}" ng-if="template.pages.page[0].background.resource.identifier" ng-style="{\n                                             position: \'absolute\',\n                                             left:template.pages.page[0].background.offsetx,\n                                             top:template.pages.page[0].background.offsety,\n                                             width: template.pages.page[0].background.resource.adaptation==\'Width\'?\'100%\':\'\',\n                                             height:template.pages.page[0].background.resource.adaptation==\'Height\'?\'100%\':\'\'}"><div ng-repeat="level in template.pages.page[0].levels.level track by $index"><div ng-if="level.imagebox&&level.imagebox.geometry" ng-style="{\n                                                \'position\': \'absolute\',\n                                                width: imageboxW(level.imagebox),\n                                                height: imageboxH(level.imagebox),\n                                                left: imageboxL(level.imagebox),\n                                                top: imageboxT(level.imagebox),\n                                                \'z-index\':level.seq-0+200,\n                                                \'transform\': \'rotate(\' + level.imagebox.rotation.angle + \'deg)\',\n                                            }"><div class="relative-view1" ng-style="{\n                                             \'overflow\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'unset\' : \'hidden\',\n                                                \'opacity\':level.imagebox.transparency,\n                                                \'border-top-left-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'lt\'),\n                                                \'border-top-right-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'rt\'),\n                                                \'border-bottom-right-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'rb\'),\n                                                \'border-bottom-left-radius\':(level.imagebox.border && level.imagebox.border.type == \'Pic\') ? 0 : imageboxWRadius(level.imagebox, \'lb\'),\n                                                \'border-width\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? (level.imagebox.border.lineWidth) : \'\',\n                                                \'border-style\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? (level.imagebox.border.lineType || \'solid\') : \'none\',\n                                                \'border-color\': (level.imagebox.border && level.imagebox.border.type == \'Color\') ? level.imagebox.border.color : \'\',\n                                                \'box-shadow\' : (level.imagebox.border && level.imagebox.border.type == \'Color\' && level.imagebox.border.lineWidth>0 && (!level.imagebox.border.lineType || level.imagebox.border.lineType == \'solid\')) ? \'0 0 0 1px \' + level.imagebox.border.color + \' inset\' : \'none\',\n                                                \'filter\' : dropShadow(level.imagebox,1,1),\n                                                }"><div ng-style="{\n                                             \'position\': \'absolute\',\n                                             \'z-index\':0,\n                                            \'left\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'left\') : 0,\n                                            \'top\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'top\') : 0,\n                                            \'right\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'right\') : 0,\n                                            \'bottom\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? -imageboxWEdge(level.imagebox,\'bottom\') : 0,\n                                            \'background-image\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'url(\' + level.imagebox.border.resource.identifier + \')\' : \'\',\n                                            \'background-size\': (level.imagebox.border && level.imagebox.border.type == \'Pic\') ? \'100% 100%\' : \'\',\n                                            }"></div><div class="relative-view1" ng-style="{\n                                                    \'background\': level.imagebox.image.resource.identifier ? \'none\' : \'#ddd\',\n                                                    \'border-top-left-radius\':imageboxWRadius1(level.imagebox, \'lt\'),\n                                                    \'border-top-right-radius\':imageboxWRadius1(level.imagebox, \'rt\'),\n                                                    \'border-bottom-right-radius\':imageboxWRadius1(level.imagebox, \'rb\'),\n                                                    \'border-bottom-left-radius\':imageboxWRadius1(level.imagebox, \'lb\'),\n                                                    \'-webkit-mask-image\': level.imagebox.mask.resource.identifier ? \'url(\' + level.imagebox.mask.resource.identifier + \')\' : \'none\',\n                                                    \'-webkit-mask-size\': \'100% 100%\'}"><div style="position: relative"><div class="picLowerSize text-r" ng-cloak ng-show="level.imagebox && level.imagebox.image && level.imagebox.lowSize" ng-style="{ left:level.imagebox.geometry.width/2-8, top:level.imagebox.geometry.height/2-11}"><img src="content/images/ic_pixel.svg"></div></div><div class="img-place-holder indexSet-800" ng-hide="level.imagebox.image.resource.identifier"><img src="content/images/icons/addcamera.svg"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'None\' && level.imagebox.image.resource.identifier"><img ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/strip/rotate/\' + level.imagebox.image.angle+\'/thumbnail/!20p\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                    \'width\': level.imagebox.image.width*level.imagebox.image.scale,\n                                                    \'height\': level.imagebox.image.height*level.imagebox.image.scale,\n                                                    \'left\':level.imagebox.image.offsetx*level.imagebox.image.scale,\n                                                    \'top\':level.imagebox.image.offsety*level.imagebox.image.scale\n                                                 }"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'Blurred\' && level.imagebox.image.resource.identifier"><img class="c-blur" ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/strip/rotate/\' + level.imagebox.image.angle+\'/thumbnail/!20p\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                    \'width\': level.imagebox.image.width,\n                                                    \'height\': level.imagebox.image.height,\n                                                 }"> <img ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/strip/rotate/\' + level.imagebox.image.angle+\'/thumbnail/!20p\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                    \'width\': level.imagebox.blurredrectangle.width,\n                                                    \'height\': level.imagebox.blurredrectangle.height,\n                                                    \'left\':level.imagebox.blurredrectangle.x,\n                                                    \'top\':level.imagebox.blurredrectangle.y,\n                                                    \'z-index\': 1\n                                                 }"></div><div style="position: relative;width: 100%; height: 100%;overflow: hidden" ng-if="level.imagebox.bokehtype == \'Transparent\' && level.imagebox.image.resource.identifier"><img ng-src="{{level.imagebox.image.resource.identifier+ \'?imageMogr2/strip/rotate/\' + level.imagebox.image.angle+\'/thumbnail/!20p\'}}" ng-style="{\n                                                    \'position\': \'absolute\',\n                                                    \'transform\': level.imagebox.flip ? \'rotateY(180deg)\' : \'unset\',\n                                                    \'width\': level.imagebox.blurredrectangle.width,\n                                                    \'height\': level.imagebox.blurredrectangle.height,\n                                                    \'left\':level.imagebox.blurredrectangle.x,\n                                                    \'top\':level.imagebox.blurredrectangle.y\n                                                 }"></div></div></div></div><div class="sticker-edit-box" data-index="{{$index}}" ng-if="level.imageart&&level.imageart.geometry" ng-style="{\n                                     \'opacity\':level.imageart.transparency,\n                                     filter: \'alpha(opacity=\'+level.imageart.transparency*100+\')\',\n                                     \'transform\':\'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                     \'-ms-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                     \'-moz-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                     \'-webkit-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                     \'-o-transform\': \'rotate(\' + level.imageart.rotation.angle + \'deg)\',\n                                     \'width\': level.imageart.geometry.width+2,\n                                     \'height\': level.imageart.geometry.height+2,\n                                     \'left\': level.imageart.geometry.x,\n                                     \'top\': level.imageart.geometry.y,\n                                     \'z-index\':level.seq-0+200}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                \'left\': level.imageart.offsetx,\n                                                \'top\': level.imageart.offsety,\n                                                \'width\': level.imageart.geometry.width * level.imageart.scale}" ng-src="{{level.imageart.resource.identifier+\'?imageView2\'}}"></div></div><div class="text-box" ng-if="level.textbox&&level.textbox.geometry" data-index="{{$index}}" style="white-space: normal;line-height: 0;min-height: 10px;min-width: 24px" ng-style="{\n                                     width: level.textbox.geometry.width,\n                                     height:level.textbox.geometry.height,\n                                     top: level.textbox.geometry.y,\n                                     left: level.textbox.geometry.x,\n                                     \'transform\': \'rotate(\' +  level.textbox.rotation.angle + \'deg)\',\n                                     \'z-index\':level.seq-0+200}"><pre class="c-xml-page-textboxe-text web-font" data-index="{{$index}}" ng-style="{\n                                            \'font-family\':  \'\\\'\' + level.textbox.fontuuid + \'\\\'\',\n                                            \'font-size\': (level.textbox.style.size*template.pages.page[0].ratio > 12 ? level.textbox.style.size* template.pages.page[0].ratio : 12) + \'pt\',\n                                            \'color\': level.textbox.style.color,\n                                            \'font-weight\': level.textbox.style.bold ? \'bold\': \'400\',\n                                            \'font-style\': level.textbox.style.italic ? \'italic\': \'initial\',\n                                            \'line-height\': (level.textbox.style.size* template.pages.page[0].ratio > 12 ? level.textbox.style.lineheight* template.pages.page[0].ratio : level.textbox.style.lineheight*12/level.textbox.style.size) + \'pt\',\n                                            \'letter-spacing\': (level.textbox.style.size* template.pages.page[0].ratio > 12 ? level.textbox.style.letterspacing* template.pages.page[0].ratio : level.textbox.style.letterspacing*12/level.textbox.style.size) + \'pt\',\n                                            \'opacity\': level.textbox.transparency,\n                                            \'text-decoration\': \'none\',\n                                            \'text-align\': level.textbox.style.align,\n                                            \'writing-mode\': level.textbox.style.writingmode,\n                                            \'text-align-last\': level.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',\n                                            \'transform\':\'scale(\'+(1 / 12 * level.textbox.style.size* template.pages.page[0].ratio > 1 ? 1 : 1 / 12 * level.textbox.style.size* template.pages.page[0].ratio)+\')\',\n                                            \'width\':  (level.textbox.style.size* template.pages.page[0].ratio > 12 ? (level.textbox.geometry.width):(level.textbox.geometry.width)/( 1 / 12 * level.textbox.style.size*slide.ratio))+\'px\'\n                                          }"><span class="c-xml-page-textboxe-span">{{level.textbox.text}}</span></pre></div><div data-index="{{$index}}" ng-show="level.textdocument&&level.textdocument.geometry" ng-style="{\n                                        position: \'absolute\',\n                                        width: level.textdocument.geometry.width,\n                                        height: level.textdocument.geometry.height,\n                                        left: level.textdocument.geometry.x,\n                                        top: level.textdocument.geometry.y,\n                                        \'z-index\':level.seq-0+200,\n                                        \'opacity\':level.textdocument.transparency.toFixed(2),\n                                        filter: \'alpha(opacity=\'+level.textdocument.transparency*100+\')\',\n                                        \'transform\': \'rotate(-\' + level.textdocument.rotation.angle + \'deg)\'}"><div style="overflow: hidden;width: 100%;height: 100%;position: relative" class="no-events"><img class="bg-image bg-image{{template.pageI}} pos" ng-cloak ng-if="level.textdocument.background.resource.identifier" ng-src="{{level.textdocument.background.resource.identifier||\'//:0\'}}" ng-style="{\n                                                 position: \'absolute\',\n                                                 left:level.textdocument.background.offsetx,\n                                                 top:level.textdocument.background.offsety,\n                                                 width: level.textdocument.background.adaptation==\'Width\'?level.textdocument.geometry.width:\'\',\n                                                 height:level.textdocument.background.adaptation!=\'Width\'?level.textdocument.geometry.height:\'\'}"><div ng-repeat="docLevel in level.textdocument.levels.level track by $index" ng-init="docIndex = $index" style="position: relative"><div data-index="{{docIndex}}" class="img-art" ng-show="docLevel.imageart" ng-style="{\n                                                    width: docLevel.imageart.geometry.width,\n                                                    height: docLevel.imageart.geometry.height,\n                                                    left: docLevel.imageart.geometry.x,\n                                                    top: docLevel.imageart.geometry.y,\n                                                    \'z-index\':docLevel.seq-0+200,\n                                                    \'opacity\':docLevel.imageart.transparency,\n                                                    filter: \'alpha(opacity=\'+docLevel.imageart.transparency*100+\')\',\n                                                    \'transform\': \'rotate(\' + docLevel.imageart.rotation.angle + \'deg)\'}"><div style="overflow: hidden; position: relative; width: 100%; height: 100%"><img data-index="{{$index}}" style="transition: opacity 0.3s;position: absolute" ng-style="{\n                                                            \'left\': docLevel.imageart.offsetx,\n                                                            \'top\': docLevel.imageart.offsety,\n                                                            \'width\': docLevel.imageart.geometry.width * docLevel.imageart.scale}" ng-src="{{docLevel.imageart.resource.identifier+\'?imageView2\'}}"></div></div><div class="c-xml-page-textboxe" ng-show="docLevel.textbox" style="white-space: normal" data-index="{{docIndex}}" ng-style="{\n                                                    \'width\': docLevel.textbox.geometry.width,\n                                                    \'left\': docLevel.textbox.geometry.x,\n                                                    \'top\': docLevel.textbox.geometry.y,\n                                                    \'transform\': \'rotate(\' + docLevel.textbox.rotation.angle + \'deg)\'}"><pre class="c-xml-page-textboxe-text web-font" ng-style="{\n                                                    \'font-family\':  \'\\\'\' + docLevel.textbox.fontuuid + \'\\\'\',\n                                                    \'font-size\': (docLevel.textbox.style.size*slide.ratio > 12 ? docLevel.textbox.style.size* slide.ratio : 12) + \'pt\',\n                                                    \'color\': docLevel.textbox.style.color,\n                                                    \'font-weight\': docLevel.textbox.style.bold ? \'bold\': \'400\',\n                                                    \'font-style\': docLevel.textbox.style.italic ? \'italic\': \'initial\',\n                                                    \'line-height\': (docLevel.textbox.style.size* slide.ratio > 12 ? docLevel.textbox.style.lineheight* slide.ratio : docLevel.textbox.style.lineheight*12/docLevel.textbox.style.size) + \'pt\',\n                                                    \'letter-spacing\': (docLevel.textbox.style.size* slide.ratio > 12 ? docLevel.textbox.style.letterspacing* slide.ratio : docLevel.textbox.style.letterspacing*12/docLevel.textbox.style.size) + \'pt\',\n                                                    \'opacity\': docLevel.textbox.transparency,\n                                                    \'text-decoration\': \'none\',\n                                                    \'text-align\': docLevel.textbox.style.align,\n                                                    \'text-align-last\': docLevel.textbox.style.align == \'justify\' ? \'justify\' : \'unset\',\n                                                    \'transform\':\'scale(\'+(1 / 12 * docLevel.textbox.style.size* slide.ratio > 1 ? 1 : 1 / 12 * docLevel.textbox.style.size* slide.ratio)+\')\',\n                                                    \'width\':  (docLevel.textbox.style.size* slide.ratio > 12 ? (docLevel.textbox.geometry.width):docLevel.textbox.geometry.width/( 1 / 12 * docLevel.textbox.style.size*slide.ratio))+\'px\'\n                                                  }"><span class="c-xml-page-textboxe-span">{{docLevel.textbox.text}}</span></pre></div></div></div></div></div><div class="barcode" ng-show="template.pages.page[0].barcode" ng-style="{\n                                 \'z-index\':999,\n                                 \'width\': template.pages.page[0].barcode.geometry.width,\n                                 \'height\': template.pages.page[0].barcode.geometry.height,\n                                 \'left\': template.pages.page[0].barcode.geometry.x,\n                                 \'top\': template.pages.page[0].barcode.geometry.y,\n                                 \'transform\': \'rotate(-\' + template.pages.page[0].barcode.rotation.angle + \'deg)\' }"><img src="content/images/txm.png" style="width: 100%;height: 100%"></div><div class="barcode" ng-show="template.pages.page[0].qrcode" ng-style="{\n                                 \'z-index\':999,\n                                 \'width\': template.pages.page[0].qrcode.geometry.width,\n                                 \'height\': template.pages.page[0].qrcode.geometry.height,\n                                 \'left\': template.pages.page[0].qrcode.geometry.x,\n                                 \'top\': template.pages.page[0].qrcode.geometry.y,\n                                 \'transform\': \'rotate(-\' + template.pages.page[0].qrcode.rotation.angle + \'deg)\' }"><img src="content/images/QrCode.png" style="width: 100%;height: 100%"></div></div><div class="li-page left-45">{{"choose.pageType.Cover" | translate}}</div></li></ul><div style="margin-top: 6px" ng-style="{\'text-align\':vm.pattern!=\'BOOK\'?\'left\':\'center\'}"><!-- <img src="content/images/single-edit.svg" alt="\u5355\u9875\u7F16\u8F91"/> --><div class="Lead-Bubble Lead-Bubble-CT"><span>{{\'choose.editor.clickOnePageGoEditor\' | translate}}</span></div></div></div></div><div class="next-step2" style="bottom: 60px"><button class="c-btn-next">{{"choose.editor.nextStep" | translate}}</button></div><div class="never-hint" ng-click="neverHint()">{{"choose.editor.notTips" | translate}}</div></div><div class="save-pages" ng-click="nextStep3()" ng-show="!vm.guideStep && (countN == 9 || countN == 10 || countN == 11 || countN == 12)"><!--\u5355\u9875\u7F16\u8F91\u5F15\u5BFC\u56FE  \u6A21\u677F\u3001\u7D20\u83DC\u3001\u6587\u5B57\u7684\u66FF\u6362--><div class="col-lg-12 col-sm-12 col-xs-12 mar-bottom-10 pad-0" style="position: fixed;bottom: 0px"><div class="col-xs-12 clearfix"><div class="col-xs-4 pad-0 text-c" style="float: left" ng-class="9 == countN ? \'\' :\'hide\'"><!-- <img src="content/images/change-template.svg" alt="\u66F4\u6362\u6A21\u677F" style="margin-left: 20px;"> --><div class="Lead-Bubble Lead-Bubble-LB"><span>{{\'choose.editor.replaceInnerTemplate\' | translate}}</span></div><div class="tabIcons2"><img src="content/images/icons/temp-show.svg"></div><span style="color: #fff;display: block">{{"choose.editor.template" | translate}}</span></div><div class="col-xs-4 pad-0 text-c" style="float: left;margin-left: 33.33%" ng-class="10 == countN ? \'\' :\'hide\'"><!-- <img src="content/images/add-material.svg" alt="\u6DFB\u52A0\u7D20\u6750" style="margin-left: -60px;"> --><div class="Lead-Bubble Lead-Bubble-CB" style="transform: translateX(-28%)"><span>{{\'choose.editor.dddFootageToComp\' | translate}}</span></div><div class="tabIcons2"><img src="content/images/icons/sucai-show.svg"></div><span style="color: #fff;display: block">{{"choose.editor.material" | translate}}</span></div><div class="col-xs-4 pad-0 text-c" style="float: left;margin-left: 66.66%" ng-class="11 == countN ? \'\' :\'hide\'"><!-- <img src="content/images/change-font.svg" alt="\u66F4\u6539\u6587\u5B57" style="margin-left: -60px;"> --><div class="Lead-Bubble Lead-Bubble-CB" style="transform: translateX(-28%)"><span>{{\'choose.editor.addTextEditor\' | translate}}</span></div><div><div class="tabIcons2"><img src="content/images/icons/text-show.svg"></div><span style="color: #fff;display: block">{{"choose.editor.text" | translate}}</span></div></div></div></div><!--\u88C1\u526A\u3001\u66FF\u6362\u56FE\u6807\u5F15\u5BFC--><div class="edit-menu2" ng-show="status==\'make\'&&!showCut&&!showTextModal" style="font-size: 0"><span style="display: inline-block" ng-class="12 == countN ? \'\' :\'hide\'"><img src="content/images/icons/crop2.svg" class="mar-right-10 common" alt=""> <img src="content/images/icons/unfold2.svg" class="mar-right-10 common" alt=""> <img src="content/images/icons/shrink22.svg" class="mar-right-10 common" alt=""> <img src="content/images/icons/figure2.svg" class="mar-right-10 common" alt=""> <img src="content/images/icons/exchange2.svg" class="mar-right-10 common" alt=""><div><!-- <img src="content/images/icon/pic-text2.png" alt="\u64CD\u4F5C\u56FE\u7247"\n                         style="margin-top: 20px;width: 236px;height: 82px;"/> --><div class="Lead-Bubble Lead-Bubble-CT"><span>{{\'choose.editor.clickPictureRevise\' | translate}}</span></div></div></span></div><div class="next-step2" ng-if="12 != countN"><button class="c-btn-next">{{"choose.editor.nextStep" | translate}}</button></div><div class="next-step2" ng-if="12 == countN"><button class="c-btn-next">{{"choose.editor.experience" | translate}}</button></div><div class="never-hint" ng-click="neverHint()">{{"choose.editor.notTips" | translate}}</div></div></div></div><!--\u6587\u5B57\u68C0\u6D4B\u7ED3\u679C--><div class="c-modal" ng-if="vm.isDocumentTextDetection"><div class="exit-box-mask"></div><div class="exit-box-con1"><div class="c-documentTextDetection-title">{{"choose.editorMessage.documentTextDetectionTitle" | translate}}</div><div class="c-documentTextDetection-list" ng-repeat="item in vm.documentTextDetection track by $index"><div class="c-documentTextDetection-list-title" translate="choose.editorMessage.documentTextDetectionNum" translate-values="{pageIndex:item.pageIndex}"></div><div class="c-documentTextDetection-list-body" ng-repeat="text in item.texts">{{text}}</div></div><div class="c-documentTextDetection-save"><div class="c-documentTextDetection-save1" ng-click="vm.isDocumentTextDetection=false">{{"choose.editor.cancel" | translate}}</div><div class="c-documentTextDetection-save2" ng-click="clickToEdit(template.pages.page[vm.documentTextDetection[0].pageIndex-1],vm.documentTextDetection[0].pageIndex-1)">{{"choose.editor.goRevise" | translate}}</div></div></div></div><div class="move-tip1" ng-if="vm.hint"><i class="iconfont iconjinggao"></i> <span>{{"hint.pageHint" | translate}}</span></div><!--\u7F29\u7565\u56FEview--><div id="thumbnail-view" style="position: absolute; z-index: -1; overflow: hidden;left: -999999px"><page-preview page="template.pages.page[0]" scale="vm.thumbnailScale"></page-preview></div><div class="lang-ic" ng-show="vm.lagnuages.length>1&&!vm.hide" style="bottom: 120px"><img src="content/images/lagnuage.svg" ng-click="vm.language=true"><div class="lang-ic-content" ng-click="vm.hide=true"><i class="iconfont iconjian2"></i></div></div><language is-show="vm.language" ng-if="vm.language"></language>');
$templateCache.put('app/entities/product-ec/productsThree.html','<div class="c-window" style="background: #fff" data-html2canvas-ignore><input onchange="uploadImageMutiple(event)" id="uploadImageMutipleThree" type="file" multiple="multiple" accept="{{vm.supportedMimeTypes}}" name="file" class="input-upload1"><div style="position: relative; height: 100%" data-html2canvas-ignore><!--  \u6A21\u677F\u5236\u4F5C\u9875  --><div class="c-productThree4-head-view" style="position: fixed;top: 0; left: 0; width: 100%; z-index: 1" ng-if="vm.page4"><div class="c-productThree4-head clearfix"><div class="c-message-view1" ng-show="vm.messageList"><marquee scrollamount="2" height="30" behavior="scroll" direction="left" align="left" style="width: 100%;line-height: 30px; height: 30px">{{vm.messageList}}</marquee></div><div style="width: 60%; float: right; display: flex; justify-content: flex-end; align-items: center"><div class="c-btn-lock-true" ng-if="vm.levelType == \'imagebox\' && vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.lock" ng-click="vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.lock = !vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.lock"><i class="iconfont iconjiesuo mar-right-10"></i> {{\'editorBtn.lock\' | translate}}</div><div class="c-btn-lock-false" ng-if="vm.levelType == \'imagebox\' && !vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.lock" ng-click="vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.lock = !vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.lock"><i class="iconfont iconsuoding mar-right-10"></i> {{\'editorBtn.unlock\' | translate}}</div><button class="iconfangda-btn" style="" ng-click="editboxMagnify()"><img class="editor-icon-1" ng-src="{{vm.diyEditorSetting.downButtonIcon}}" ng-if="vm.isEditboxMagnify"> <img class="editor-icon-1" ng-src="{{vm.diyEditorSetting.upButtonIcon}}" ng-if="!vm.isEditboxMagnify"></button> <button type="button" class="c-productThree-btn2" ng-click="savePage4()" ng-style="{background: vm.diyEditorSetting.mainColor}">{{\'editorBtn.allSave\' | translate}}</button></div></div></div><div class="c-productThree4" ng-show="vm.page4" style="position:absolute; left: 0; top: 50px; right: 0; bottom: 0; overflow: auto; z-index: 1" ng-click="makeBody()"><div class="c-productThree4-body" style="position: relative; margin: 2% auto 0;transition: all 0.1s" ng-style="{\n                    \'width\': vm.windowWidth,\n                    \'margin-left\': vm.isEditboxMagnify ? -(vm.pageData[vm.pageIndex].scene.imagebox.geometry.x + vm.pageData[vm.pageIndex].mediabox.x) * vm.pageData[vm.pageIndex].custom.ratio1 + (vm.windowWidth - vm.pageData[vm.pageIndex].mediabox.width * vm.pageData[vm.pageIndex].custom.ratio1) / 2 : (vm.windowWidth - vm.pageData[vm.pageIndex].custom.width * vm.pageData[vm.pageIndex].custom.ratio1) / 2,\n                    \'margin-top\': vm.isEditboxMagnify ? -(vm.pageData[vm.pageIndex].scene.imagebox.geometry.y + vm.pageData[vm.pageIndex].mediabox.y) * vm.pageData[vm.pageIndex].custom.ratio1 : (vm.windowHeight - vm.pageData[vm.pageIndex].custom.height * vm.pageData[vm.pageIndex].custom.ratio1) / 2,\n                 }"><page-mobile-edit page-data="vm.pageData" page-index="vm.pageIndex" level-index="vm.levelIndex" level-type="vm.levelType" that="vm" img-size="vm.imgSize" img-dpi="vm.imgDpi" is-imagebox-lock="true" is-small-pic="vm.isSmallPic" transparency="vm.transparency"></page-mobile-edit><div class="previousPage" ng-if="vm.pageIndex > 0" ng-click="previousPage()"></div><div class="nextPage" ng-if="vm.pageIndex<vm.pageSum" ng-click="nextPage()"></div></div></div><div class="c-productThree4-foot" ng-show="!vm.isImageboxSelectItem && !vm.isMaterial && vm.page4 && !vm.mapDepot && !vm.textboxSelect && !vm.textStyleShow"><div class="c-productThree4-foot-1" ng-repeat="item in vm.diyEditorSetting.seqItem"><div class="c-productThree4-foot-view" ng-click="templateShow()" ng-if="item.type == \'template\'" ng-style="{color: vm.diyEditorSetting.templateColor}"><img class="editor-icon-1" ng-src="{{vm.diyEditorSetting.templateIcon}}"><div class="c-productThree4-foot-view-text">{{vm.diyEditorSetting.templateText}}</div></div><div class="c-productThree4-foot-view" ng-click="materialShow()" ng-if="item.type == \'clipart\'" ng-style="{color: vm.diyEditorSetting.clipartColor}"><img class="editor-icon-1" ng-src="{{vm.diyEditorSetting.clipartIcon}}"><div class="c-productThree4-foot-view-text">{{vm.diyEditorSetting.clipartText}}</div></div><div class="c-productThree4-foot-view" ng-click="fontShow()" ng-if="item.type == \'word\'" ng-style="{color: vm.diyEditorSetting.wordColor}"><img class="editor-icon-1" ng-src="{{vm.diyEditorSetting.wordIcon}}"><div class="c-productThree4-foot-view-text">{{vm.diyEditorSetting.wordText}}</div></div><div class="c-productThree4-foot-view" ng-click="photoGalleryShow()" ng-if="item.type == \'img\'" ng-style="{color: vm.diyEditorSetting.imgColor}"><img class="editor-icon-1" ng-src="{{vm.diyEditorSetting.imgIcon}}"><div class="c-productThree4-foot-view-text">{{vm.diyEditorSetting.imgText}}</div></div><div class="c-productThree4-foot-view" ng-click="addImageboxCb()" ng-if="item.type == \'photo\'" ng-style="{color: vm.diyEditorSetting.photoColor}"><img class="editor-icon-1" ng-src="{{vm.diyEditorSetting.photoIcon}}"><div class="c-productThree4-foot-view-text">{{vm.diyEditorSetting.photoText}}</div></div><div class="c-productThree4-foot-view" ng-click="graffitiCb()" ng-if="item.type == \'graffiti\'" ng-style="{color: vm.diyEditorSetting.graffitiColor}"><div class="editor-icon-1" style="display: flex; justify-content: center; align-items: center; margin: 0 auto"><i class="iconfont iconhuabi_huaban1" style="font-size: 20px"></i></div><div class="c-productThree4-foot-view-text">{{vm.diyEditorSetting.graffitiText}}</div></div></div><div class="partName" style="top: -30px; color: #999">{{\'editorCommon.textDetection.partName\' | translate:({partName: partName(vm.pageData[vm.pageIndex].config.partid)})}}</div></div><div class="picture-view" ng-if="vm.levelType == \'imagebox\' && vm.isImageboxSelectItem"><div class="picture-view-icon" ng-click="photoGalleryShow()" ng-style="{color: vm.diyEditorSetting.changeImgColor}"><img class="editor-icon-1" ng-src="{{vm.diyEditorSetting.changeImgIcon}}" alt=""><div class="span">{{vm.diyEditorSetting.changeImgText}}</div></div><!--            <div class="picture-view-icon" ng-click="mattingImage()">--><!--                <i class="icon iconfont iconbhjmianbushibie"></i>--><!--                <span>\u62A0\u4EBA\u50CF</span>--><!--            </div>--><!--            <div class="picture-view-icon" ng-click="cutImage()" ng-style="{color: vm.diyEditorSetting.filterColor}">--><!--                <img class="editor-icon-1" ng-src="{{vm.diyEditorSetting.filterIcon}}" alt="">--><!--                <div class="span">{{vm.diyEditorSetting.filterText}}</div>--><!--            </div>--><div class="picture-view-icon" ng-click="modeIn()" ng-if="vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.bokehtype != \'None\' && vm.article.bokehtype != \'None\'" ng-style="{color: vm.diyEditorSetting.spreadColor}"><img class="editor-icon-1" ng-src="{{vm.diyEditorSetting.spreadIcon}}" alt=""><div class="span">{{vm.diyEditorSetting.spreadText}}</div></div><div class="picture-view-icon" ng-click="modeOut()" ng-if="vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.bokehtype == \'None\' && vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.bokehtypes != \'None\'" ng-style="{color: vm.diyEditorSetting.retractColor}"><img class="editor-icon-1" ng-src="{{vm.diyEditorSetting.retractIcon}}" alt=""><div class="span">{{vm.diyEditorSetting.retractText}}</div></div><div class="picture-view-icon" ng-click="cropImageboxRotate(true)" ng-if="vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.bokehtype == \'None\'" ng-style="{color: vm.diyEditorSetting.rotationColor}"><img class="editor-icon-1" ng-src="{{vm.diyEditorSetting.rotationIcon}}" alt=""><div class="span">{{vm.diyEditorSetting.rotationText}}</div></div><div class="picture-view-icon" ng-click="cropImageboxMassive()" ng-if="vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.bokehtype == \'None\'" ng-style="{color: vm.diyEditorSetting.upColor}"><img class="editor-icon-1" ng-src="{{vm.diyEditorSetting.upIcon}}" alt=""><div class="span">{{vm.diyEditorSetting.upText}}</div></div><div class="picture-view-icon" ng-click="cropImageboxMin()" ng-if="vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.bokehtype == \'None\'" ng-style="{color: vm.diyEditorSetting.downColor}"><img class="editor-icon-1" ng-src="{{vm.diyEditorSetting.downIcon}}" alt=""><div class="span">{{vm.diyEditorSetting.downText}}</div></div><div class="picture-view-icon" ng-click="overturnImagebox()" ng-style="{color: vm.diyEditorSetting.flipColor}"><img class="editor-icon-1" ng-src="{{vm.diyEditorSetting.flipIcon}}" alt=""><div class="span">{{vm.diyEditorSetting.flipText}}</div></div><div class="picture-view-icon" ng-click="cropImagRestore()" ng-style="{color: vm.diyEditorSetting.restoreColor}"><img class="editor-icon-1" ng-src="{{vm.diyEditorSetting.restoreIcon}}" alt=""><div class="span">{{vm.diyEditorSetting.restoreText}}</div></div><div class="picture-view-icon" ng-click="mattingOpen()" ng-if="!isLarge(vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.imageInfo)"><i class="icon iconfont iconkoutu" style="height: 20px"></i> <span>{{vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].imagebox.image.mattingMask ? \'editorCommon.mattingOpenEdit\' : \'editorCommon.mattingOpen\' | translate}}</span></div></div><!--        <div class="c-productThree4-img" ng-style="{\'padding-bottom\': vm.isIPhoneX ? \'30px\' : \'0\'}" ng-show="vm.istemplate && vm.page4">--><!--            <div class="c-productThree4-foot2-centent-hide" ng-click="templateHide()">--><!--                <img src="content/images/icons/ic_close.svg" alt="">--><!--            </div>--><!--            <div class="c-productThree4-img-list" style="left: 26px">--><!--                <ul class="clearfix" ng-style="{\'width\':vm.tempList.productXmlLines.length * 100 }">--><!--                    <li ng-repeat="line in vm.tempList.productXmlLines track by $index" ng-click="templateCb(line)" data-index="{{$index}}">--><!--                        <img ng-src="{{domain+line.coverImg}}">--><!--                        <div class="c-productThree4-img-list-select" ng-if="line.id == vm.xmlId">\u5F53\u524D\u4F7F\u7528</div>--><!--                    </li>--><!--                </ul>--><!--            </div>--><!--        </div>--><!-- \u4EBA\u50CF\u62A0\u56FE --><!--        <div class="three-filter" ng-if="vm.mattingShow" ng-style="{\'padding-bottom\': vm.isIPhoneX ? \'30px\' : \'0\'}">--><!--            <div class="three-filter-body">--><!--                <div class="three-filter-body-li" ng-repeat="item in vm.mattingList track by $index" ng-click="filterCb(item)">--><!--                    <img ng-src="{{item.img}}">--><!--                    <div class="three-filter-body-li-text">{{filterChoose(item.type)}}</div>--><!--                    &lt;!&ndash;                    <div class="three-filter-body-li-select" ng-if="item.type == vm.filterType">\u5F53\u524D\u4F7F\u7528</div>&ndash;&gt;--><!--                </div>--><!--            </div>--><!--        </div>--><!-- \u6EE4\u955C --><!--        <div class="three-filter" ng-if="vm.filterShow" ng-style="{\'padding-bottom\': vm.isIPhoneX ? \'30px\' : \'0\'}">--><!--            <div class="three-filter-body">--><!--                <div class="three-filter-body-li" ng-repeat="item in vm.filterList track by $index" ng-click="filterCb(item)">--><!--                    <img ng-src="{{item.img}}">--><!--                    <div class="three-filter-body-li-text">{{filterChoose(item.type)}}</div>--><!--                    &lt;!&ndash;                    <div class="three-filter-body-li-select" ng-if="item.type == vm.filterType">\u5F53\u524D\u4F7F\u7528</div>&ndash;&gt;--><!--                </div>--><!--            </div>--><!--        </div>--><!-- \u6A21\u677F --><div class="three-materialGallery" ng-show="vm.istemplate && vm.page4" ng-style="{\'padding-bottom\': vm.isIPhoneX ? \'30px\' : \'0\'}"><div class="three-materialGallery-head"><ul class="three-materialGallery-head-ul"><li ng-repeat="item in vm.productXmls" ng-click="productXmlCb(item)" ng-class="{\'opt\' : item.id == vm.productXmlThemeId}"><span ng-style="{color: item.id == vm.productXmlThemeId ? vm.diyEditorSetting.mainColor : \'#999\',\'border-color\': item.id == vm.productXmlThemeId ? vm.diyEditorSetting.mainColor : \'#fff\'}">{{item.name}}</span></li></ul><i class="icon iconfont iconlujing8" ng-click="templateHide()"></i></div><div class="three-materialGallery-body" id="productXmlLineView"><ul class="clearfix"><li ng-repeat="line in vm.tempList.productXmlLines track by $index" ng-click="templateCb(line)" data-index="{{$index}}" ng-if="!line.cancelled &&(!vm.productXmlThemeId || productXmlShow(line.themeClassifies))"><img ng-src="{{line.coverImg}}" style="max-width: 100%;max-height: 100%"><div class="c-productThree4-img-list-select" ng-if="line.id == vm.xmlId || line.productXmlId == vm.article.productXmlId" ng-style="{color: vm.diyEditorSetting.mainColor}">{{\'editorCommon.currentUse\' | translate}}</div></li></ul></div><div class="animation-xia" ng-if="vm.tempList.productXmlLines.length>8"><i class="icon iconfont iconxiangxia2"></i></div></div><!-- \u56FE\u7247\u5E93 --><div class="three-photoGallery" ng-show="vm.mapDepot || vm.isAddImagebox" ng-style="{\'padding-bottom\': vm.isIPhoneX ? \'30px\' : \'0\'}"><div class="three-photoGallery-head"><p style="margin: 0" ng-if="vm.mapDepot">{{\'picture.sentPictures\' | translate}} <span style="color: var(--genericColor); font-size: 12px">{{\'picture.sentPictures1\' | translate}}</span></p><p style="margin: 0" ng-if="vm.isAddImagebox">{{\'picture.sentPictures\' | translate}} <span style="color: var(--genericColor); font-size: 12px">{{\'picture.sentPictures2\' | translate}}</span></p><i class="icon iconfont iconlujing8" ng-click="photoGalleryHide()"></i></div><div class="three-photoGallery-body" id="photoGallery" ng-style="{\n                    \'overflow\': vm.isSmallPic ? \'hidden\' : \'scroll\'\n                 }"><ul class="clearfix"><li ng-click="uploadPhoto()"><div><i class="icon iconfont iconcamera" style="color: #fff"></i></div><input onchange="uploadImageMutiple(event)" type="file" multiple="multiple" accept="{{vm.supportedMimeTypes}}" name="file" ng-if="!agentIos && vm.isIPhone6" class="input-upload2"><!--                        <div ng-if="!agentIos">--><!--                            <i class="icon iconfont iconcamera" style="color: #fff;"></i>--><!--                            <input onchange="uploadImageMutiple(event)" id="uploadImg" type="file" multiple="multiple" accept="{{vm.supportedMimeTypes}}" name="file" value="" style="opacity:0; position:absolute;top:0;left:0;right: 0; bottom: 0;">--><!--                        </div>--><!--                        <div ng-click="uploadPhoto()">--><!--                            <i class="icon iconfont iconUpload"></i>--><!--                            <span>{{\'editorBtn.uploadGallery\' | translate}}</span>--><!--                        </div>--></li><li ng-repeat="data in vm.uploadPhotoItem" ng-if="data.state !=\'error\' && data.percent != 100" style="position: relative"><progres-view :src="data.blobCover" :progres="data.percent"></progres-view></li><li ng-repeat="item in vm.photoAll track by $index" data-imgindex="{{$index}}" ontouchstart="startChange(event)" ontouchmove="dragChange(event)" ontouchend="stopChange(event)" ng-click="addImageboxImg(item)"><img ng-if="(item.identifier || (item.largeFlag && item.identifier1)) && photoStatus(item) == \'\'" ng-src="{{(item.largeFlag ? item.identifier1 : item.identifier)+\'?imageView2/1/w/120/h/75\'}}" alt="" data-imgindex="{{$index}}"><!--\u5927\u56FE\u5904\u7406\u4E2D/\u5931\u8D25\u3001\u8272\u5F69\u8F6C\u6362\u4E2D/\u5931\u8D25\uFF1A\u5360\u4F4D\u56FE + \u5C45\u4E2D\u72B6\u6001\u56FE\u6807\u4E0E\u6587\u6848--><div class="three-photo-status" ng-if="(item.identifier || (item.largeFlag && item.identifier1)) && photoStatus(item) != \'\'" ng-class="{\'is-failed\': isPhotoFailed(item)}" ontouchstart="event.stopPropagation()" ng-click="onPhotoStatusClick(item, $event)"><img class="three-photo-status-placeholder" src="content/images/placeholderImage.png" alt=""><div class="three-photo-status-mask"><img class="three-photo-status-icon" ng-if="photoStatus(item) == \'largeError\' || photoStatus(item) == \'convertError\'" src="content/images/close1.png" alt=""> <img class="three-photo-status-icon" ng-if="photoStatus(item) == \'convertRunning\' || photoStatus(item) == \'largeRunning\'" src="content/images/loading1.png" alt=""> <span class="three-photo-status-text">{{(\'nav.photograph.content.status.\' + photoStatus(item)) | translate}}</span></div></div><div style="position: absolute; left: 0; top: 0; width: 100%; height: 100%; z-index: 1" data-imgindex="{{$index}}"></div></li></ul></div><div class="animation-xia" ng-if="vm.photoAll.length>8"><i class="icon iconfont iconxiangxia2"></i></div></div><div id="small-pic" class="user-select-default pointer-un" ontouchstart="return false;" ng-style="{left:galleryX||0,top:galleryY||0}" ng-show="vm.isSmallPic"><img ng-if="galleryChoose" ng-src="{{galleryChoose+\'?imageMogr2/thumbnail/200x200>\'}}"></div><!--\u7D20\u6750--><div class="three-materialGallery" ng-show="vm.isMaterial" ng-style="{\'padding-bottom\': vm.isIPhoneX ? \'30px\' : \'0\'}"><div class="three-materialGallery-head"><ul class="three-materialGallery-head-ul"><li ng-repeat="item in vm.classify" ng-click="classifyCb(item)" ng-class="{\'opt\' : item.id == vm.classifyId}"><span ng-style="{color: item.id == vm.classifyId ? vm.diyEditorSetting.mainColor : \'#999\',\'border-color\': item.id == vm.classifyId ? vm.diyEditorSetting.mainColor : \'#fff\'}">{{item.name}}</span></li></ul><i class="icon iconfont iconlujing8" ng-click="materialHide()"></i></div><div class="three-materialGallery-body" id="materialView"><ul class="clearfix"><li ng-repeat="item in vm.materialData" ng-click="addImageart(item)"><img ng-src="{{item.identifier+\'?imageMogr2/thumbnail/200x200>\'}}" alt=""></li></ul></div><div class="animation-xia" ng-if="vm.materialData.length>8"><i class="icon iconfont iconxiangxia2"></i></div></div><!--  \u6587\u5B57  --><div class="three-font" ng-show="vm.page5"><div class="three-font-head"><button type="button" class="three-font-head-btn" ng-click="savePage5()" ng-style="{background: vm.diyEditorSetting.mainColor}">{{\'editorBtn.confirm\' | translate}}</button></div><div class="three-font-body"><!-- <input type="text" class="three-font-body-input" ng-model="vm.fontData.textbox.text" placeholder="\u8BF7\u8F93\u5165\u6587\u5B57"> --><textarea class="three-font-body-input" id="three-font-body-input" ng-keyup="changeText($event)" ng-style="{\'text-align\': vm.fontData.textbox.style.align }" ng-model="vm.fontData.textbox.text" placeholder="{{\'editorCommon.describe29\' | translate}}"></textarea><div style="opacity: 0" ng-style="{\'width\': (vm.pageData[vm.pageIndex].trimbox.width-10)}"><pre id="c-xml-page-material-fontId" style="display: inline-block; opacity: 0" ng-style="{\n                    \'font-family\': \'\\\'\' + vm.fontData.textbox.fontuuid + \'\\\'\',\n                    \'font-size\': (vm.fontData.textbox.style.size) + \'pt\',\n                    \'color\': vm.fontData.textbox.style.color,\n                    \'font-weight\': vm.fontData.textbox.style.bold ? \'bold\': \'400\',\n                    \'font-style\': vm.fontData.textbox.style.italic ? \'italic\': \'initial\',\n                    \'line-height\': (vm.fontData.textbox.style.lineheight) + \'pt\',\n                    \'letter-spacing\': (vm.fontData.textbox.style.letterspacing) + \'pt\',\n                    \'text-decoration\': \'none\',\n                    \'text-align-last\': \'unset\',\n                    \'max-width\' : \'100%\',\n                    \'writing-mode\': vm.fontData.textbox.style.writingmode\n                    }"><span class="c-xml-page-textboxe-span">{{vm.fontData.textbox.text}}</span></pre></div></div></div><div style="opacity: 0; position: fixed" ng-style="{\n        \'width\': !writingmodeInit(vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.writingmode) ? (vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.geometry.width) : \'auto\',\n        \'height\': writingmodeInit(vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.writingmode) ? (vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.geometry.height) : \'auto\'\n        }"><pre id="c-xml-page-material-fontId1" style="display: inline-block; opacity: 0" ng-style="{\n                \'font-family\': \'\\\'\' + vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.fontuuid + \'\\\'\',\n                \'font-size\': (vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.size > 12 ? vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.size : 12) + \'pt\',\n                \'color\': vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.color,\n                \'font-weight\': vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.bold ? \'bold\': \'400\',\n                \'font-style\': vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.italic ? \'italic\': \'initial\',\n                \'letter-spacing\': (vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.size > 12 ? vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.letterspacing : (vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.letterspacing) / (1 / 12 * vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.size)) + \'pt\',\n                \'line-height\': (vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.size > 12 ? vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.lineheight : (vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.lineheight) / (1 / 12 * vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.size)) + \'pt\',\n                \'transform\':\'scale(\'+(1 / 12 * vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.size > 1 ? 1 : 1 / 12 * vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.size)+\')\',\n                \'transform-origin\': \'0 0\',\n                \'text-decoration\': \'none\',\n                \'text-align-last\': \'unset\',\n                \'max-width\' : \'100%\',\n                \'writing-mode\': vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.writingmode\n                }"><span class="pre-span">{{vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.text}}</span></pre></div><div class="three-font-operation" ng-if="vm.textboxSelect"><div class="three-font-operation-icon" ng-click="editTextbox()" ng-style="{color: vm.diyEditorSetting.editWordColor}"><img class="editor-icon-1" ng-src="{{vm.diyEditorSetting.editWordIcon}}" alt=""><div class="span">{{vm.diyEditorSetting.editWordText}}</div></div><div class="three-font-operation-icon" ng-click="textStyleTextbox()" ng-style="{color: vm.diyEditorSetting.wordStyleColor}"><img class="editor-icon-1" ng-src="{{vm.diyEditorSetting.wordStyleIcon}}" alt=""><div class="span">{{vm.diyEditorSetting.wordStyleText}}</div></div><div class="three-font-operation-icon" ng-click="deleteTextbox()" ng-if="vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.useradded" ng-style="{color: vm.diyEditorSetting.delWordColor}"><img class="editor-icon-1" ng-src="{{vm.diyEditorSetting.delWordIcon}}" alt=""><div class="span">{{vm.diyEditorSetting.delWordText}}</div></div></div><div class="three-textStyle" ng-if="vm.textStyleShow"><div class="three-textStyle-head"><ul><li ng-repeat="item in vm.textStyleTab" ng-click="textStyleTabCb(item)" ng-class="{\'opt\' : item.id == vm.textStyleItem}"><span ng-style="{\n                            color: item.id == vm.textStyleItem ? vm.diyEditorSetting.mainColor : \'#999\',\n                            \'border-color\': item.id == vm.textStyleItem ? vm.diyEditorSetting.mainColor : \'#fff\'\n                         }">{{item.name}}</span></li></ul><i class="icon iconfont iconlujing8" ng-click="textStyleHide()"></i></div><div class="three-textStyle-body"><div class="textStyleTabFont" ng-if="vm.textStyleItem==\'textStyleTabFont\'"><div class="textStyleTabFont-li" ng-repeat="font in vm.fontList track by $index" ng-class="{\'textStyleTabFont-li-on\' : vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.fontuuid == font.uuid}" ng-style="{\n                            color: vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.fontuuid == font.uuid ? vm.diyEditorSetting.mainColor : \'#333\',\n                         }" ng-click="updateTextFont(font)"><i class="icon iconfont iconduihao"></i> <span>{{font.family}}</span></div></div><div class="textStyleTabSize" ng-if="vm.textStyleItem==\'textStyleTabSize\'"><div class="c-productThree5-li-content" style="text-align: center; padding-top: 40px"><p class="text-value">{{\'font.currentFontSize\' | translate:({size:vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.size})}}</p><div><i class="icon-font font-jia"></i> <input type="range" min="9" max="1000" step="1" value="16" class="text-range rangeSize" id="rangeChange" oninput="densityInput(event)" ng-model="vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.size"> <i class="icon-font font-jian"></i></div></div></div><div class="textStyleTabType" ng-if="vm.textStyleItem==\'textStyleTabType\'"><div class="textStyleTabType-view1"><span>{{\'font.transparency\' | translate}}\uFF1A</span> <input type="range" min="0" max="100" step="1" value="16" class="text-range rangeSize" id="textStyleTransparency" oninput="textStyleTransparency(event)" ng-model="vm.transparency"> <span>{{vm.transparency}}</span></div><div class="textStyleTabType-view2"><div class="textStyleTabType-view2-li-icon" ng-if="vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.bold1" ng-class="{\'textStyleTabType-view2-li-icon-no\':!vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.bold,\'textStyleTabType-view2-li-icon-yes\':vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.bold}" ng-click="operationBold()"><i class="icon iconfont iconb"></i> <span>{{\'font.bold\' | translate}}</span></div><div class="textStyleTabType-view2-li-icon" ng-if="vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.italic1" ng-class="{\'textStyleTabType-view2-li-icon-no\':!vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.italic,\'textStyleTabType-view2-li-icon-yes\':vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.italic}" ng-click="operationItalic()"><i class="icon iconfont iconI"></i> <span>{{\'font.italic\' | translate}}</span></div><!--                        <div class="textStyleTabType-view2-li-icon">--><!--                            <i class="icon iconfont iconU"></i>--><!--                            <span>\u4E0B\u5212\u7EBF</span>--><!--                        </div>--><div class="textStyleTabType-view2-li-icon" ng-click="operationBarDir(\'left\')"><i class="icon iconfont iconjuzuo"></i> <span>{{\'font.alignLeft\' | translate}}</span></div><div class="textStyleTabType-view2-li-icon" ng-click="operationBarDir(\'center\')"><i class="icon iconfont iconjuzhong-orange"></i> <span>{{\'font.alignCenter\' | translate}}</span></div><div class="textStyleTabType-view2-li-icon" ng-click="operationBarDir(\'right\')"><i class="icon iconfont iconjuyou"></i> <span>{{\'font.alignRight\' | translate}}</span></div><div class="textStyleTabType-view2-li-icon" ng-click="textLayout(\'horizontal-tb\')" ng-if="vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.writingmode != \'horizontal-tb\'"><i class="icon iconfont iconhengban"></i> <span>{{\'font.horizontal\' | translate}}</span></div><!-- <div class="textStyleTabType-view2-li-icon" ng-click="textLayout(\'vertical-lr\')" ng-if="vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.writingmode != \'vertical-lr\'">\n                            <i class="icon iconfont iconshuban"></i>\n                            <span>{{\'font.verticalLr\' | translate}}</span>\n                        </div>\n                        <div class="textStyleTabType-view2-li-icon" ng-click="textLayout(\'vertical-rl\')" ng-if="vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.writingmode != \'vertical-rl\'">\n                            <i class="icon iconfont iconwenzigongju-shupai"></i>\n                            <span>{{\'font.verticalRl\' | translate}}</span>\n                        </div> --></div></div><div class="textStyleTabColor" ng-if="vm.textStyleItem==\'textStyleTabColor\'"><span class="fontColor-item" ng-repeat="item in colorList" ng-click="fontColorCb(item)" ng-style="{\n                            \'border\': vm.pageData[vm.pageIndex].levels.level[vm.levelIndex].textbox.style.color == item ?  \'1px solid \' + item : none,\n                          }"><i ng-style="{\'background\': item}"></i></span></div></div></div><!--  \u5F00\u59CB\u5B9A\u5236\u52A0\u8F7D\u9875  --><div class="page-loading" ng-show="vm.page8"><img src="content/images/loading2.gif" onerror="this.src=\'content/images/loading2.gif\'"><p class="tip-style">{{\'editorCommon.loadingText\' | translate}}</p><span class="tip-style">{{\'editorCommon.loadingText1\' | translate}}</span></div><!--  \u9009\u62E9\u6A21\u677F  --><div class="select-box" ng-show="vm.xmlShowPic"><div class="select-wrapper2"><div style="background: url(\'content/images/preview-close@2x.svg\') no-repeat; background-size: 100% 100%" id="previewClose" ng-click="previewClose()" ng-style="{\'right\':((dWidth-318)/2)+\'px\'}"></div><div class="containerTheme"><div class="swiper-template-view"><div class="swiper-container swiper-template-view-content" ng-show="vm.imgs.length>0"><div class="swiper-wrapper"><div class="swiper-slide" ng-repeat="item in vm.imgs"><img ng-src="{{item.identifier +\'?imageView2\'||\'//:0\'}}"></div></div></div><div ng-if="vm.imgs.length == 0" class="swiper-template-view-content1"><img src="content/images/notImg.png" style="width: 160px"> <span class="noData-text">{{"hint.noData" | translate}}</span></div></div></div><div class="swiper-button-prev" style="background: url(\'content/images/prev_temp.svg\') no-repeat; background-size: 100% 100%" ng-click="prevImg()" ng-if="vm.imgs.length > 0"></div><div class="swiper-button-next" style="background: url(\'content/images/next_temp.svg\') no-repeat; background-size: 100% 100%" ng-click="nextImg()" ng-if="vm.imgs.length > 0"></div></div><div class="c-modal-foot" style="position: absolute; bottom: 100px;left: 0"><button class="startMake btn diy-btn-primarys opacityMinus no-padding" style="background: #858585" ng-click="previewClose()">{{\'template.cancelPreview\' | translate}}</button> <button class="startMake btn diy-btn-primarys opacityMinus no-padding" ng-click="changeAllTemp()" style="background: var(--genericColor); color: #fff!important">{{\'template.confirm\' | translate}}</button></div></div></div><div class="three-modal" ng-if="vm.threeIsModal"><div class="three-modal-body"><div class="three-modal-body-content">{{vm.threeModalText}}</div><div class="three-modal-body-foot"><button type="button" class="color1" ng-click="threeModalHide()">{{\'button.cancel\' | translate}}</button> <button type="button" class="color2" ng-click="threeModalSave()">{{\'template.change\' | translate}}</button></div></div></div><div class="three-modal" ng-if="vm.threeIsModal1"><div class="three-modal-body"><div class="three-modal-body-content">{{vm.threeModalText1}}</div><div class="three-modal-body-foot"><button type="button" class="color2" ng-click="threeModalHide()">{{\'editorBtn.confirm\' | translate}}</button></div></div></div><div class="three-modal1" ng-if="vm.threeLoading"><img src="content/images/icon/loading.gif" alt=""><div>{{vm.threeLoadingText}}</div></div><div class="three-modal2" ng-if="vm.threeError"><div class="three-modal2-body"><i class="icon iconfont iconkulian"></i><div>{{vm.threeErrorText}}</div></div></div><upload-image tag="\'normalEditor\'" store-id="vm.storeId" aid="vm.aid" upload-photo-item="vm.uploadPhotoItem" on-uploadphoto="uploadSuccess(text)"></upload-image><!--\u91CD\u590D\u56FE\u7247--><duplicate-list ng-if="vm.isDuplicateList" list="vm.duplicateList" on-change="duplicateChange(text)"></duplicate-list></div><!--\u5220\u9664\u5904\u7406\u5931\u8D25\u7684\u7167\u7247--><div class="three-modal" ng-if="vm.deletePhotoSure"><div class="three-modal-body"><div class="three-modal-body-content" style="flex-direction: column; height: auto; padding: 24px 20px"><div style="font-size: 15px; font-weight: bold; color: #333; margin-bottom: 10px">{{\'nav.photograph.content.deletePhoto.title\' | translate}}</div><div style="font-size: 14px; color: #666; text-align: center">{{\'nav.photograph.content.deletePhoto.content\' | translate}}</div></div><div class="three-modal-body-foot"><button type="button" class="color1" ng-click="vm.deletePhotoSure = false">{{\'button.cancel\' | translate}}</button> <button type="button" class="color2" ng-click="deletePhotoConfirm()">{{\'button.confirm\' | translate}}</button></div></div></div><!--\u7F29\u7565\u56FEview--><div id="thumbnail-view" style="position: fixed; z-index: -1; overflow: hidden"><page-preview page="vm.thumbnailPageData" scale="vm.thumbnailPageData.custom.thumbnailScale" thumbnail="true" ng-if="vm.thumbnailPageData"></page-preview></div><!--\u7F29\u7565\u56FEview1--><div id="thumbnail-view1" style="position: fixed; z-index: -1"><page-preview page="vm.thumbnailPageData1" scale="vm.thumbnailPageData1.custom.thumbnailScale" thumbnail="true" cover="1" ng-if="vm.thumbnailPageData1"></page-preview></div><div ng-class="{\'three-view-3d1\':vm.isThreeView3d1, \'three-view-3d\': !vm.isThreeView3d1}" ng-style="{\n        \'top\': vm.threeView3d.top,\n        \'right\': vm.threeView3d.right\n    }" ng-if="!vm.page5 && vm.isThreeView3d && vm.isHtml2canvas && vm.productXmlData && vm.productXmlData.modelType && vm.productXmlData.modelType === \'THREE\'&&!vm.isThreeView3d1" data-html2canvas-ignore><div ng-class="{\'three-view-3d1-view\':vm.isThreeView3d1}"><three-preview1 width="vm.threeView3dW" height="vm.threeView3dH" model-path="vm.productXmlData.modelPath" model-blendents="vm.productXmlData.modelBlendents" model-blendent-uuid="vm.article.modelBlendentUuid" model-data="vm.productXmlData.modelData" pages="vm.pageData1" style="background: #fff"></three-preview1></div><div class="three-view-3d-zoom" ng-if="!vm.isThreeView3d1" ontouchstart="threeView3dStart(event)" ontouchmove="threeView3dOn(event)"><i class="iconfont icontuozhuai"></i></div><i class="iconfont iconguanbi three-view-3d-hide" ng-click="vm.isThreeView3d=false"></i><div class="three-view-3d-btn" ng-click="threeView3d1Cb()" ng-if="!vm.isThreeView3d1">{{\'editorCommon.3DRendering\' | translate}} <i class="iconfont iconyoujiantou"></i></div></div><div class="three-view-3d2" ng-if="vm.isThreeView3d1"><i class="iconfont iconguanbi1 iconfontHide" ng-click="threeView3d1CbHide()" style="position: absolute; right: 16px; top: 16px;color: #333;font-size: 18px;left: auto"></i><three-preview4 source="\'editor\'" moulds="vm.product.moulds" model-path="vm.productXmlData.modelPath" model-blendents="vm.productXmlData.modelBlendent" model-data="vm.productXmlData.modelData" model-blendent-uuid="vm.article.modelBlendentUuid" pages="vm.pageData1"></three-preview4></div><!--\u6587\u5B57\u68C0\u6D4B\u7ED3\u679C--><div class="c-modal" ng-if="vm.isDocumentTextDetection"><div class="exit-box-mask"></div><div class="exit-box-con1"><div class="c-documentTextDetection-title">{{\'editorCommon.textDetection.title\' | translate}}</div><div class="c-documentTextDetection-list" ng-repeat="item in vm.documentTextDetection track by $index"><div class="c-documentTextDetection-list-title">{{\'editorCommon.textDetection.whichPage\' | translate:item.pageIndex}}</div><div class="c-documentTextDetection-list-body" ng-repeat="text in item.texts">{{text}}</div></div><div class="c-documentTextDetection-save" ng-click="vm.isDocumentTextDetection=false">{{\'editorBtn.toModify\' | translate}}</div><div class="c-documentTextDetection-save"><div class="c-documentTextDetection-save1" ng-click="vm.isDocumentTextDetection=false">{{\'button.cancel\' | translate}}</div><div class="c-documentTextDetection-save2" ng-click="goPageContent(vm.documentTextDetection[0].pageIndex-1)">{{\'editorBtn.toModify\' | translate}}</div></div></div></div><!--\u6D82\u9E26--><div class="c-graffiti-view" ng-if="vm.isGraffiti"><div class="c-graffiti-canvas" ng-style="{\n            left: (vm.windowWidth - vm.pageData[vm.pageIndex].custom.width * vm.pageData[vm.pageIndex].custom.ratio1) / 2,\n            top: vm.isEditboxMagnify ? -(vm.pageData[vm.pageIndex].scene.imagebox.geometry.y + vm.pageData[vm.pageIndex].mediabox.y) * vm.pageData[vm.pageIndex].custom.ratio1 + 50 : (vm.windowHeight - vm.pageData[vm.pageIndex].custom.height * vm.pageData[vm.pageIndex].custom.ratio1) / 2 + 50,\n            \'width\': vm.pageData[vm.pageIndex].custom.width * vm.pageData[vm.pageIndex].custom.ratio1,\n            \'height\': vm.pageData[vm.pageIndex].custom.height * vm.pageData[vm.pageIndex].custom.ratio1}"><canvas class="c-graffiti-canvas-item" id="graffitiCanvas"></canvas></div><div class="c-graffiti-operate"><div class="c-graffiti-operate-page1" ng-if="vm.graffitiPage == 1"><i class="iconfont iconguanbi1 iconfontHide" ng-click="graffitiHide()"></i><!--            <i class="iconfont iconchexiao iconfontRetreat" ng-click="graffitiRetreat()"></i>--> <i class="iconfont iconduihao iconfontSave" ng-click="graffitiSave()"></i><div class="c-graffiti-colors"><div class="c-graffiti-colors-li" ng-click="graffitiPageCb(2)"><div class="c-graffiti-colors-li-i" style="background: url(\'../../content/images/icons/colorChoose2.jpeg\') no-repeat center;background-size: 100% 100%"></div></div><div class="c-graffiti-colors-li" ng-repeat="item in vm.graffitiColors" ng-click="graffitiColorSet(item)" ng-style="{\n                        \'border-color\': item == vm.graffitiColor ? item : \'#fff\'\n                     }"><div class="c-graffiti-colors-li-i" ng-style="{background: item}"></div></div><div class="c-graffiti-colors-pen"><div class="c-graffiti-colors-pen-icon"><i class="iconfont iconhuabi_huaban1"></i></div><input type="range" min="1" max="10" step="1" value="3" class="text-range rangeSize" id="graffitiPen" oninput="graffitiPenChen(event)" ng-model="vm.graffitiPen" style="width: 90% !important"></div></div></div><div class="c-graffiti-operate-page2" ng-if="vm.graffitiPage == 2"><canvas id="ColorTip" style="width: 100%; height: 100%"></canvas><div class="ColorTipCur" id="cur"></div></div></div></div><div class="lang-ic" ng-show="vm.lagnuages.length>1&&!vm.hide" style="bottom: 120px; z-index: 100"><img src="content/images/lagnuage.svg" ng-click="vm.language=true"><div class="lang-ic-content" ng-click="vm.hide=true"><i class="iconfont iconjian2"></i></div></div><language is-show="vm.language" ng-if="vm.language"></language><!-- \u62A0\u56FE --><image-cutout ng-if="vm.isShowImageCutout" :imagebox="vm.imageboxCutout" on-save="imageCutoutSave(text)" on-change="imageCutoutChange(text)"></image-cutout><style>body{\n        overflow: unset !important;\n        background: #FFF;\n        position: fixed;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n    }\n    .c-window *{\n        -webkit-touch-callout:none; /*\u7CFB\u7EDF\u9ED8\u8BA4\u83DC\u5355\u88AB\u7981\u7528*/\n        -webkit-user-select:none; /*webkit\u6D4F\u89C8\u5668*/\n        -khtml-user-select:none; /*\u65E9\u671F\u6D4F\u89C8\u5668*/\n        -moz-user-select:none;/*\u706B\u72D0*/\n        -ms-user-select:none; /*IE10*/\n        user-select:none;\n    }\n    .c-window input {\n        -webkit-user-select:auto !important;\n    }\n\n    .c-window textarea{\n        -webkit-user-select:auto !important;\n    }\n    /*  \u6D82\u9E26  */\n\n    .c-graffiti-view{\n        position: fixed;\n        left: 0;\n        top: 0;\n        width: 100vw;\n        height: 100vh;\n        z-index: 2000;\n    }\n    .c-graffiti-canvas{\n        position: absolute;\n        border: 1px solid red;\n        z-index: 1;\n    }\n    .c-graffiti-canvas-item{\n        width: 100%;\n        height: 100%;\n    }\n    .c-graffiti-operate{\n        position: fixed;\n        bottom: 0;\n        left: 0;\n        width: 100vw;\n        z-index: 2;\n    }\n    .c-graffiti-operate-page1{\n        position: relative;\n        width: 100%;\n        height: 200px;\n        background: #fff;\n        box-shadow: 0 0 10px 3px rgba(0, 0, 0, 0.1);\n        border-radius: 8px 8px 0 0;\n        padding-bottom: 20px;\n    }\n    .iconfontHide{\n        position: absolute;\n        font-size: 20px;\n        font-weight: 600;\n        left: 10px;\n        top: 10px;\n    }\n    .iconfontRetreat{\n        position: absolute;\n        font-size: 20px;\n        font-weight: 600;\n        left: 50px;\n        top: 10px;\n    }\n    .iconfontSave{\n        position: absolute;\n        right: 10px;\n        top: 10px;\n        font-size: 20px;\n        font-weight: bold;\n    }\n    .c-graffiti-colors{\n        width: 100%;\n        padding: 40px 10px 10px;\n        display: flex;\n        flex-wrap: wrap;\n        justify-content: space-between;\n    }\n    .c-graffiti-colors-li{\n        width: 25px;\n        height: 25px;\n        border-radius: 50%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        border: 1px solid #fff;\n        margin: 5px;\n    }\n    .c-graffiti-colors-li-i{\n        width: 17px;\n        height: 17px;\n        border-radius: 50%;\n    }\n    .c-graffiti-colors-pen{\n        margin-top: 15px;\n        width: 100%;\n        display: flex;\n        height: 30px;\n        align-items: center;\n    }\n    .c-graffiti-colors-pen-icon{\n        width: 20px;\n        height: 20px;\n        background: #fff;\n        border-radius: 50%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        box-shadow: 0 0 10px 3px rgba(0, 0, 0, 0.1)\n    }\n    .c-graffiti-operate-page2{\n        position: relative;\n        width: 100%;\n        height: 200px;\n        background: #fff;\n        box-shadow: 0 0 10px 3px rgba(0, 0, 0, 0.1);\n        border-radius: 8px 8px 0 0;\n    }\n    .ColorTipCur{\n        width: 12px;\n        height: 12px;\n        outline: 4px solid #fff;\n        margin-left: -1px;\n        margin-top: -1px;\n        position: absolute;\n        border-radius: 50%;\n    }\n    /* \u5927\u56FE\u5904\u7406\u4E2D/\u5931\u8D25\u3001\u8272\u5F69\u8F6C\u6362\u4E2D/\u5931\u8D25\uFF1A\u5360\u4F4D\u56FE + \u5C45\u4E2D\u72B6\u6001\u56FE\u6807\u4E0E\u6587\u6848 */\n    .three-photo-status{\n        position: absolute;\n        left: 0;\n        top: 0;\n        z-index: 2;\n        width: 100%;\n        height: 100%;\n        overflow: hidden;\n        border-radius: 6px;\n    }\n    .three-photo-status-placeholder{\n        position: absolute;\n        left: 0;\n        top: 0;\n        z-index: 1;\n        display: block;\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n    }\n    .three-photo-status-mask{\n        position: absolute;\n        left: 0;\n        top: 0;\n        z-index: 2;\n        display: flex;\n        box-sizing: border-box;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        width: 100%;\n        height: 100%;\n        padding: 4px;\n        background-color: rgba(0, 0, 0, 0.25);\n    }\n    .three-photo-status-icon{\n        display: block;\n        flex: none;\n        width: 20px;\n        height: 20px;\n        margin-bottom: 4px;\n        object-fit: contain;\n    }\n    .three-photo-status-text{\n        max-width: 100%;\n        color: #ffffff;\n        font-size: 11px;\n        line-height: 14px;\n        text-align: center;\n        word-break: break-all;\n        text-shadow: 0 1px 4px rgba(0,0,0,0.6);\n    }\n    .three-photo-status.is-failed{\n        cursor: pointer;\n    }</style>');
$templateCache.put('app/entities/template/code-modal.html','<div class="c-modal"><div class="c-modal-head"><p>{{\'other.inputSecretPreview\' | translate}}</p><!-- <span class="c-modal-hide" ng-click="modalHide()">X</span> --></div><div class="c-modal-body" style="text-align: center"><input type="text" class="c-input1" placeholder="{{\'other.inputTaskQuery\' | translate}}" ng-model="vm.code"></div><div class="c-modal-foot"><button class="c-modal-btn c-modal-btn-hide" ng-click="modalSave()">{{\'button.confirm\' | translate}}</button></div></div>');
$templateCache.put('app/entities/template/template.html','<div class="table-responsive no-border bg-color mar-0" style="height: 100vh"><div class="c-search"><div class="search_length_none search-input2" style="display: flex;align-items: center;position: relative; background: #f8f8f8" ng-class="{\'search_length_have\':vm.searchText.length>0}"><span class="iconfont iconsousuo searchcion searchcion1" style="margin: 2px 0; top: 50%;transform: translateY(-50%)"></span> <input ng-model="vm.searchText" class="textInput1" placeholder="{{\'product.template.searchTerms\' | translate}}"></div><div ng-show="vm.searchText.length>0" class="delete-search" ng-click="clearSearchText()"><img src="content/images/delete.svg" width="23px" height="23px"></div><div ng-show="vm.searchText.length>0" class="search-btn-style btn1" ng-click="searchMethodClick()"><label style="font-size:12px;color:#FFFFFF;margin: 0">{{\'product.template.search\' | translate}}</label></div></div><div class="col-md-12 col-sm-12 col-xs-12 no-padding flexContainer" style="height: calc( 100vh - 50px);width: 100vw"><div id="themeLeft" class="theme_left"><div class="theme_left_top bc-ff9803" id="themeDiv_00" ng-click="vm.chooseTheme(theme.name, -1)"><div class="bc-ffffff" id="themeDiv0_00" style="width: 78px; height: 100%"><span>{{\'product.template.allTemplates\' | translate}}</span></div></div><div class="theme_left_div" ng-repeat="theme in vm.themeList track by $index" ng-click="vm.chooseTheme(theme.name, $index)" id="themeDiv_{{$index}}"><div class="bc-fafafa" id="themeDiv0_{{$index}}" style="width: 78px; height: 100%"><span class="text_color_030303 font-13">{{theme.name}}</span></div></div></div><div class="flex-1" ng-show="!vm.oldProduct"><!-- <div class="fixProduct"\n                 style="margin-top: 5px; margin-bottom: 20px;width: 100%;">\n                <div class="col-md-6 col-sm-6 col-xs-6 opacityMinus text-center1"\n                     ng-repeat="xml in vm.itemValueOne.productXmlLines track by $index" ng-if="!xml.cancelled&&xml.paid"\n                     ng-click="valueSeleted(xml)" style="padding-left: 10px; padding-right: 10px; margin-bottom: 20px;"\n                     id="div0_{{$index}}">\n                    <div>\n                        <div id="div_{{$index}}" class="col-md-8 col-sm-8 col-xs-8 theme_img_div"\n                             style="box-shadow: 0px 0px 5px 2px #DADADA; padding: 0 0px; max-height: 160px;">\n                            <img id="img_{{$index}}" alt="\u56FE\u7247\u7F3A\u5931"\n                                 style="width: 100%; max-width: 160px; max-height: 160px; display: inline-block; vertical-align: middle;"\n                                 ng-src="{{(xml.coverImg || vm.product.coverImg)}}?imageMogr2">\n                            <div class="count-tip" style="height: 20px;background: #5c5c5c;border-radius: 100px 0px 0px 100px; color: #ffffff !important;" ng-show="vm.product.editorType != \'PICTURE\' && vm.product.editorType != \'PICTURE_PRO\'">\n                                <span ng-if="vm.product.aiFill && xml.minPicQuantity!=xml.maxPicQuantity">{{xml.minPicQuantity}}~{{xml.maxPicQuantity}}{{\'product.template.paper\' | translate}}</span>\n                                <span ng-if="vm.product.aiFill && xml.minPicQuantity==xml.maxPicQuantity">{{xml.minPicQuantity}}{{\'product.template.paper\' | translate}}</span>\n                                <span ng-if="!vm.product.aiFill">{{xml.picQuantity || 0}}{{\'product.template.paper\' | translate}}</span>\n                            </div>\n                        </div>\n                        <div class="col-md-12 col-sm-12 col-xs-12 no-padding"\n                             ng-if="vm.itemValueOne.price == 0 || vm.itemValueOne.price == 0.00">\n                            <div class="col-md-12 col-sm-12 col-xs-12 pad-top-10"\n                                 style="display: flex;justify-content: center;">\n                                <span class="color_232323 font-14">{{xml.name.length > 5 ? xml.name.substr(0, 5) + \'..\' : xml.name}}</span>\n                            </div>\n                        </div>\n                        <div class="col-md-12 col-sm-12 col-xs-12 no-padding"\n                             ng-if="vm.itemValueOne.price != 0 && vm.itemValueOne.price != 0.00">\n                            <div class="col-md-12 col-sm-12 col-s-12 pad-top-10">\n                                <span class="color_232323 font-14">{{xml.name.length > 5 ? xml.name.substr(0, 5) + \'..\' : xml.name}}</span>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div> --><div class="fixProduct" style="margin: 5px 0 20px; width: 100%"><div class="product-grid"><div class="product-item" ng-repeat="xml in vm.itemValueOne.productXmlLines track by $index" ng-if="!xml.cancelled && xml.paid" ng-click="valueSeleted(xml)"><div><div id="div_{{$index}}" class="col-md-8 col-sm-8 col-xs-8 theme_img_div" style="box-shadow: 0px 0px 5px 2px #DADADA; padding: 0 0px; max-height: 160px"><img id="img_{{$index}}" alt="\u56FE\u7247\u7F3A\u5931" style="width: 100%; max-width: 160px; max-height: 160px; display: inline-block; vertical-align: middle" ng-src="{{(xml.coverImg || vm.product.coverImg)}}?imageMogr2/interlace/1/thumbnail/400x400>"><div class="count-tip" style="height: 20px;background: #5c5c5c;border-radius: 100px 0px 0px 100px; color: #ffffff !important" ng-show="vm.product.editorType != \'PICTURE\' && vm.product.editorType != \'PICTURE_PRO\' && vm.product.editorType != \'PICTURE_PRO_P\'"><span ng-if="vm.product.aiFill && xml.minPicQuantity!=xml.maxPicQuantity">{{xml.minPicQuantity}}~{{xml.maxPicQuantity}}{{\'product.template.paper\' | translate}}</span> <span ng-if="vm.product.aiFill && xml.minPicQuantity==xml.maxPicQuantity">{{xml.minPicQuantity}}{{\'product.template.paper\' | translate}}</span> <span ng-if="!vm.product.aiFill">{{xml.picQuantity || 0}}{{\'product.template.paper\' | translate}}</span></div></div><div class="col-md-12 col-sm-12 col-xs-12 no-padding" ng-if="vm.itemValueOne.price == 0 || vm.itemValueOne.price == 0.00"><div class="col-md-12 col-sm-12 col-xs-12 pad-top-10" style="display: flex;justify-content: center"><span class="color_232323 font-12">{{xml.name}}</span></div></div><div class="col-md-12 col-sm-12 col-xs-12 no-padding" ng-if="vm.itemValueOne.price != 0 && vm.itemValueOne.price != 0.00"><div class="col-md-12 col-sm-12 col-xs-12 pad-top-10"><span class="color_232323 font-12">{{xml.name.trim()}}</span></div></div></div></div></div></div></div><div class="flex-1" ng-show="vm.oldProduct"><div class="fixProduct" style="margin-top: 5px; margin-bottom: 20px"><div class="col-md-6 col-sm-6 col-xs-6 opacityMinus text-center1" ng-repeat="value in vm.itemValueList track by $index" ng-if="!value.cancelled&&value.paid" ng-click="valueSeleted(value)" style="padding-left: 10px; padding-right: 10px; margin-bottom: 20px" id="div0_{{$index}}"><div><div id="div_{{$index}}" class="col-md-8 col-sm-8 col-xs-8 theme_img_div" style="box-shadow: 0px 0px 5px 2px #DADADA; padding: 0 0px; max-height: 160px"><img id="img_{{$index}}" alt="\u56FE\u7247\u7F3A\u5931" style="width: 100%; max-width: 160px; max-height: 160px; display: inline-block; vertical-align: middle" ng-src="{{domain + (value.coverImg || vm.product.coverImg)}}?imageMogr2/interlace/1/thumbnail/400x400>"></div><div class="col-md-12 col-sm-12 col-xs-12 no-padding" ng-if="value.price == 0 || value.price == 0.00"><div class="col-md-12 col-sm-12 col-xs-12 pad-top-10" style="display: flex;justify-content: center"><span class="color_232323 font-14" ng-if="!value.sku">{{value.productName.length > 5 ? value.productName.substr(0, 5) + \'..\' : value.productName}}</span> <span class="color_232323 font-14" ng-if="value.sku">{{value.sku.length > 5 ? value.sku.substr(0, 5) + \'..\' : value.sku}}</span></div></div><div class="col-md-12 col-sm-12 col-xs-12 no-padding" ng-if="value.price != 0 && value.price != 0.00"><div class="col-md-12 col-sm-12 col-xs-12 pad-top-10"><span class="color_232323 font-14" ng-if="!value.sku">{{value.productName.trim().length > 5 ? value.productName.trim().substr(0, 5) + \'..\' : value.productName.trim()}}</span> <span class="color_232323 font-14" ng-if="value.sku">{{value.sku.trim().length > 5 ? value.sku.trim().substr(0, 5) + \'..\' : value.sku.trim()}}</span></div></div></div></div></div></div></div><div class="select-box" ng-if="vm.xmlShowPic"><div class="select-wrapper2"><div style="background: url(\'content/images/preview-close@2x.svg\') no-repeat; background-size: 100% 100%" id="previewClose" ng-click="previewClose()" ng-style="{\'right\':((vm.width-318)/2)+\'px\'}"></div><div class="containerTheme"><div class="img-div2" style="width: 100%"><img ng-click="imgClick($event)" id="top-img" src="" ng-src="{{vm.imgs[0].identifier +\'?imageView2\'||\'//:0\'}}" ng-if="vm.imgs.length>0" style="max-height: 400px; max-width: 318px; width: 100%"></div></div><div class="button-prev" style="background: url(\'content/images/prev.svg\') no-repeat; background-size: 100% 100%" ng-click="prevImg()" ng-disabled="$index==1"></div><div class="button-next" style="background: url(\'content/images/icons/next.svg\') no-repeat; background-size: 100% 100%" ng-click="nextImg()" ng-disabled="$index== vm.imgs.length-1"></div></div><div class="col-lg-12 col-sm-12 col-xs-12 text-center1 no-padding" style="position: absolute; bottom: 84px;left: 0"><button type="button" ng-click="productChoose();" class="startMake btn diy-btn-primarys opacityMinus no-padding">{{\'product.template.goEditing\' | translate}}</button></div></div></div><div class="lang-ic" ng-show="vm.lagnuages.length>1&&!vm.hide"><img src="content/images/lagnuage.svg" ng-click="vm.language=true"><div class="lang-ic-content" ng-click="vm.hide=true"><i class="iconfont iconjian2"></i></div></div><language is-show="vm.language" ng-if="vm.language"></language><style>.c-search {\n    width: 100%;\n    overflow: hidden;\n    height: 50px;\n    display: flex;\n    align-items: center;\n    border-top: 1px solid #F5F5F5;\n    padding: 0px 6px;\n}\n\n.search_length_have {\n    width: 305px !important;\n    background: #F6F7F9;\n    height: 32px;\n    border-radius: 18px;\n}\n\n.search_length_none {\n    width: calc(100vw - 20px);\n    background: #FFFFFF;\n    height: 32px;\n    border-radius: 18px;\n}\n\n.textInput::-webkit-input-placeholder {\n    color: #C1C1C1;\n    font-size: 12px;\n    text-align: center;\n}\n.searchcion {\n    margin: 7px 5px 5px 5px;\n    position: absolute;\n    left: calc(50vw - 40px);\n    z-index: 1;\n    width: 20px;\n    height: 20px;\n    text-align: center;\n}\n\n.searchcion1 {\n    margin: 7px 5px 5px 5px;\n    position: absolute;\n    left: 10px;\n    z-index: 100;\n    font-size: 20px !important;\n    margin: 0;\n    height: 32px;\n    color: #171717;\n    line-height: 32px;\n    text-align: center;\n}\n\n/*.search-input2{*/\n/**/\n/*}*/\n.textInput {\n    height: 32px;\n    color: #C1C1C1;\n    font-size: 14px;\n    width: 100%;\n    background: none;\n    border-radius: 18px;\n    margin-left: 10px;\n    border: none;\n    outline: none;\n}\n\n.textInput1 {\n    height: 32px;\n    color: #171717;\n    font-size: 14px;\n    width: 100%;\n    background: none;\n    border-radius: 18px;\n    margin-left: 20px;\n    padding-left: 10px;\n    border: none;\n    outline: none;\n}\n\n.delete-search {\n    width: 23px;\n    height: 48px;\n    margin-left: -28px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 999;\n}\n\n.search-btn-style {\n    width: 55px;\n    height: 32px;\n    margin-left: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: var(--mobileTextSelectedColor);\n    border-radius: 16px;\n    outline: none;\n}\n.product-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  /* gap: 10px; */\n  align-items: start;\n  grid-auto-flow: dense;\n}\n\n.product-item {\n  width: 100%;\n  padding: 0 10px;\n  margin-bottom: 10px;\n  max-width: 174px;\n}</style>');
$templateCache.put('app/entities/web-folder/entity-move-folder.html','<!-- <form name="editForm" role="form" novalidate class="listBGC listCreate pad-0"> --><!-- <div class="modal-detail">\n        <h4 class="modal-title">\u79FB\u52A8\u81F3\u6587\u4EF6\u5939</h4>\n    </div>\n    <div class="modal-body">\n        <div  class="panel-body form-horizontal">\n            <div class="col-lg-12 col-sm-12  form-group" style=" padding-top: 10px;" ng-style="{\'background-color\':folderId ==\'\'? \'#FFDDDD\':\'\'}">\n                <div class="form-group outline" ng-click="folderSelected()"  >\n                    &nbsp;&nbsp;&nbsp;<img src="content/images/floder.svg">  &nbsp;&nbsp;&nbsp; \n                    <span ng-if="vm.entity.type ==\'Article\'">\u4F5C\u54C1\u5217\u8868</span>\n                    <span ng-if="vm.entity.type ==\'Gallery\'">\u7167\u7247\u5217\u8868</span>\n                </div>\n            </div>\n            <div class="col-lg-12 col-sm-12 form-group" style=" padding-top: 10px;" ng-repeat="f in folders"  ng-style="{\'background-color\':folderId == f.id? \'#FFDDDD\':\'\'}" >\n                <div class="form-group outline" ng-click="folderSelected(f)">\n                    &nbsp;&nbsp;&nbsp;<img src="content/images/floder.svg">\n                    &nbsp;&nbsp;&nbsp;{{f.name}}\n                </div>\n            </div>\n        </div>\n    </div>\n\n    <div class="modal-footer">\n        <button type="button" class="btn btn-cancel" data-dismiss="modal" ng-click="vm.clear()">\n            <span translate="entity.action.back">back</span>\n        </button>\n        <button type="button" ng-click="vm.save()" ng-disabled=" vm.isSaving" class="btn btn-primary btn-save btn-info">\n            <span >\u4FDD\u5B58</span>\n        </button>\n    </div> --><!-- </form> --><div class="dialog"><div class="dialog-header"><div class="dialog-title">{{\'folder.moveToFolder\' | translate}}</div><div class="iconfont iconcloseicon1" ng-click="vm.clear()"></div></div><div class="dialog-content"><div class="col-lg-12 col-sm-12 hover-bgc" style="padding-top: 20px" ng-if="vm.folderId != null"><div class="outline border-bottom" ng-click="folderSelected()">&nbsp;&nbsp;&nbsp;<img src="content/images/icon/defaultFolder.png" style="width: 40px"> &nbsp;&nbsp;&nbsp; <span ng-if="vm.entity.type ==\'Article\'">{{\'folder.defaultFolder\' | translate}}</span> <span ng-if="vm.entity.type ==\'Gallery\'">{{\'folder.defaultFolder\' | translate}}</span> <img src="content/images/icon/selected-icon.png" ng-if="folderId ==\'\'" alt="" srcset="" style="float: right;width: 28px"></div></div><div class="col-lg-12 col-sm-12 hover-bgc" style="padding-top: 20px" ng-repeat="f in folders" ng-if="vm.folderId != f.id"><div class="outline border-bottom" ng-click="folderSelected(f)">&nbsp;&nbsp;&nbsp;<img src="content/images/icon/folder-icon.png" style="width: 40px"> &nbsp;&nbsp;&nbsp;{{f.name}} <img src="content/images/icon/selected-icon.png" ng-if="folderId ==f.id" alt="" srcset="" style="float: right;width: 28px"></div></div></div><div class="dialog-footer"><!-- <div class="dialog-footer-btn-close">\u5173\u95ED</div> --> <button class="dialog-footer-btn-confirm" ng-click="vm.save()" ng-disabled="vm.isSaving">{{\'folder.moveHere\' | translate}}</button></div></div><style>.hover-bgc:hover{\n        background: #f9f9f9;\n    }\n    .border-bottom{\n        padding-bottom: 20px;\n        border-bottom: 1px solid #F1F1F1;\n    }\n    \n.dialog{\n    position: fixed;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 704px;\n    background: #f7f8fa;\n    border-radius: 8px;\n    padding: 16px 24px;\n}\n.dialog-titles{\n    display: flex;\n    justify-content: space-between;\n    font-size: 18px;\n    color: #333;\n    font-weight: bold;\n    margin-bottom: 15px;\n}\n.dialog-titles-title{\n    font-weight: bold;\n}\n.dialog-close{\n    font-weight: bold;\n}\n.dialog-header{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n.dialog-title{\n    font-size: 18px;\n    font-weight: 500;\n    color: #333333;\n    line-height: 25px;\n}\n.dialog-content{\n    width: 100%;\n    height: 372px;\n    background: #FFFFFF;\n    border-radius: 8px;\n    margin-top: 15px;\n    overflow-y: auto;\n}\n.dialog-footer{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: 15px;\n}\n.dialog-footer-btn-confirm{\n    background: var(--genericColor);\n    border-radius: 20px;\n    padding: 10px 72px;\n    color: #fff;\n    margin: 0 10px;\n}\n.dialog-footer-btn-close{\n    background: #ffffff;\n    border-radius: 20px;\n    padding: 10px 72px;\n    color: #333333;\n    margin: 0 10px;\n}</style>');
$templateCache.put('app/entities/web-folder/folder-dialog.html','<form name="editForm" role="form" novalidate class="listBGC listCreate pad-0"><div class="modal-detail"><h4 class="modal-title"><span ng-show="vm.newFolder">{{\'folder.newFolder\' | translate}}</span> <span ng-show="!vm.newFolder">{{\'folder.renameFolder\' | translate}}</span></h4><span class="iconfont iconcloseicon1" ng-click="vm.clear()" style="color: #a0a0a0;font-size: 16px"></span></div><div class="modal-body"><input type="text" class="form-control" ng-model="vm.folder.name" placeholder="{{\'folder.enterName\' | translate}}" maxlength="20"></div><div class="modal-footer"><button type="button" class="btn-cancel" data-dismiss="modal" ng-click="vm.clear()"><span translate="entity.action.back">back</span></button> <button type="button" ng-click="vm.save()" ng-disabled=" vm.isSaving" class="btn-info" style="margin-left: 16px"><span>{{\'folder.save\' | translate}}</span></button></div></form><style>.modal-content{\n        width: 528px !important;\n        overflow:hidden;\n    }</style>');
$templateCache.put('app/components/login/login.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="login.title">Sign in</h4></div><div class="modal-body"><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="login.title">Sign in</h1></div><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-8 col-md-offset-2"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username" data-translate="global.form.username">Login</label><input type="text" class="form-control" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username"></div><div class="form-group"><label for="password" data-translate="login.form.password">Password</label><input type="password" class="form-control" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span data-translate="login.form.rememberme">Remember me</span></label></div><button type="submit" class="btn btn-primary" data-translate="login.form.button">Sign in</button></form><p></p><div class="alert alert-warning"><a class="alert-link" href="" ng-click="vm.requestResetPassword()" data-translate="login.password.forgot">Did you forget your password?</a></div><div class="alert alert-warning" data-translate="global.messages.info.register" translate-compile>You don\'t have an account yet? <a class="alert-link" href="" ng-click="vm.register()">Register a new account</a></div></div></div></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div class="alert alert-danger" data-translate="error.http.403">You are not authorized to access this page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar" role="navigation"><div class="navbar-wrap"><!-- <div class="navbar-top">\n            <div class="container clearfix">\n                <div class="c-head-logo">\n                    <img ng-src="{{vm.logoUrl}}" alt="">\n                </div>\n                <div class="c-head-operation">\n                    <div class="c-head-operation-logIn" ng-if="!vm.isLogin">\n                        <button type="button" ng-click="vm.login()">\u767B\u5F55</button>\n                        <span class="c-head-operation-logIn-hr"></span>\n                        <button type="button" ng-click="vm.register()" >\u6CE8\u518C</button>\n                    </div>\n                    <div class="c-head-operation-logIn" ng-if="vm.isLogin">\n                        <button type="button">{{getName()}}</button>\n                        <span class="c-head-operation-logIn-hr"></span>\n                        <button type="button" ng-click="vm.logout()">\u9000\u51FA</button>\n                    </div>\n                </div>\n            </div>\n        </div> --><div class="navbar-collapse side" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><!-- <div class="sidebar1"> --><!--<div href="#/" class="sidebar1-shrink" ng-click="vm.shrink()">--><!--<button class="sidebar1-btn btn1-shrik1"></button>--><!--</div>--><!--                <ul id="navbar">--><!--                    <li>--><!--                        <div class="c-navbar-head">--><!--                            <div class="c-navbar-head-icon c-navbar-head-icon-subtract"></div>--><!--                            <span class="c-navbar-head-title" ng-click="address()">\u5BA2\u6237\u4E2D\u5FC3</span>--><!--                        </div>--><!--                        <div class="c-navbar-body">--><!--                            &lt;!&ndash; <a ng-click="wechat()" ui-sref-active="hover" ng-class="{\'pageOn\': \'myWechat\' == vm.navSelection}">\u5FAE\u4FE1\u7ED1\u5B9A</a> &ndash;&gt;--><!--                            <a ng-click="address()" ui-sref-active="hover" ng-class="{\'pageOn\': \'myAddress\' == vm.navSelection}">\u5730\u5740\u7BA1\u7406</a>--><!--                        </div>--><!--                    </li>--><!--                </ul>--><!-- </div> --></div></div><!-- <div class="message-nav" id="message">\n        <div class="message-div">\n            <h1 class="message-title">\u6700\u65B0\u516C\u544A</h1>\n            <ul class="message-list" ng-if="vm.messageList.length > 0">\n                <li ng-repeat="item in vm.messageList track by $index">\n                    <p>{{item.content}}</p>\n                </li>\n            </ul>\n            <div ng-if="vm.messageList.length == 0" style="text-align: center; margin: 20px 0;">\n                <img src="content/images/icon/ic_wu.svg" alt="" style="max-width: 100%; max-height: 100%;">\n            </div>\n        </div>\n    </div> --></nav><script>$(document).ready(function () {\n        function nav(){\n            var windowW = document.body.offsetWidth;\n            var navLeft = (windowW - 1200) / 2;\n            if(windowW <= 1200){\n                navLeft = 0\n            }\n            $(".sidebar1").css(\'left\',navLeft);\n        };\n        nav();\n        window.onresize = function(){\n            nav();\n        };\n\n        $("#navbar").find("li").each(function () {\n            var that = this;\n            $(this).find(".c-navbar-head .c-navbar-head-icon").on(\'click\', function () {\n                var _this = this;\n                $(that).find(\'.c-navbar-body\').slideToggle(function () {\n                    if($(this).is(":hidden")){\n                        $(_this).attr("class","c-navbar-head-icon c-navbar-head-icon-plus");\n                    }else {\n                        $(_this).attr("class","c-navbar-head-icon c-navbar-head-icon-subtract");\n                    }\n                })\n            })\n        })\n        var _width = ($(window).width() - 1200) / 2 - 50;\n        $("#message").width(_width)\n    })</script>');
$templateCache.put('app/layouts/navbar/navbar_login.html','<nav class="navbar" role="navigation"><div class="navbar-wrap"><div class=""><div href="#/" class="navbar-logo"><div class="logo-text pad-log"></div></div><div class="navbar-collapse navbar-setting language-pad" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"></div></div></div></nav>');
$templateCache.put('app/layouts/navbar/userAgent.html','<div class="c-model"><div class="c-model-head clearfix"><div class="c-model-head-title">\u6E29\u99A8\u63D0\u793A</div><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="cancel()"><span aria-hidden="true">&times;</span></button></div><div class="c-model-body"><p style="text-indent:2em">\u90E8\u5206\u6D4F\u89C8\u5668\u5B58\u5728\u4E0D\u517C\u5BB9\u7684\u60C5\u51B5\uFF0C\u53EF\u80FD\u4F1A\u5BFC\u81F4\u60A8\u7684\u4E0B\u5355\u4F5C\u54C1\u5185\u5BB9\u4E0E\u9884\u89C8\u5185\u5BB9\u4E0D\u7B26\u3002\u975EChrome\u6D4F\u89C8\u5668\u4E0B\u5355\u5BFC\u81F4\u7684\u95EE\u9898\u4E00\u5F8B\u7531\u81EA\u5DF1\u627F \u62C5\uFF0C\u56E0\u6B64\u63A8\u8350\u60A8\u4F7F\u7528\u8C37\u6B4C\u6D4F\u89C8\u5668\u3002</p><p style="margin-top: 50px;text-align: center">Chrome\u4E0B\u8F7D\u94FE\u63A5\uFF1A<a href="https://www.google.cn/intl/zh-CN/chrome/" target="_blank">https://www.google.cn/intl/zh-CN/chrome/</a></p></div><div class="c-model-foot" style="text-align: center"><button type="button" class="btn btn-info" ng-click="cancel()">\u6211\u77E5\u9053\u4E86</button></div></div>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="reset.finish.title">Reset password</h1><div class="alert alert-danger" data-translate="reset.finish.messages.keymissing" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p data-translate="reset.finish.messages.info">Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p data-translate="reset.finish.messages.error">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p data-translate="reset.finish.messages.success" translate-compile><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.finish.form.button">Reset Password</button></form></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div class="register-wrap"><div class="col-lg-12 col-sm-12 col-xm-12" style="position: absolute;top:10%"><div class="register-content"><div class="col-md-12 col-lg-12 col-sm-12 register-condition"><div class="col-md-8 col-lg-8 col-sm-8 col-md-offset-2 form-group pos-rela"><h1 class="register-title" data-translate="reset.request.title">Reset your password</h1></div><div class="col-md-2 col-lg-2 col-sm-2"></div></div><!-- <h1 class="register-title" data-translate="reset.request.title">Reset your password</h1> --><div class="alert alert-success" ng-show="vm.success" data-translate="register.messages.success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="register.messages.error.fail"><strong>Registration failed!</strong> Please try again later.</div><div class="alert alert-danger" ng-show="vm.errorUserExists" data-translate="register.messages.error.userexists"><strong>Login name already registered!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation><div class="col-md-12 col-lg-12 col-sm-12 register-condition"><div class="col-md-8 col-lg-8 col-sm-8 col-md-offset-2 form-group pos-rela"><img src="content/images/icons/ic_phone.png"> <input style="width: 49%;color: gray" type="text" class="pad-left-8" id="mobile" name="mobile" placeholder="{{\'loginMessages.phoneNumber\' | translate}}" ng-model="vm.registerAccount.phone"> <a id="sendMobileCode" style="color: #FE5454; font-size: 10px; padding: 0px;min-width: 33%" ng-click="getVerifyCode()" class="btn btn-10 ml10 checkLogin" ng-disabled="vm.disabled" ng-bind="paracont"></a><div style="width: 100%; height: 1px;border-top: 1px solid rgb(229, 230, 231)"></div><div ng-show="form.mobile.$dirty && form.mobile.$invalid" class="pos-abso"><p class="help-block" ng-show="form.code.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your code is required.</p><p class="help-block" ng-show="form.mobile.$error.pattern" data-translate="global.messages.validate.mobile.pattern">Your code is required to be pattern.</p></div></div><div class="col-md-2 col-lg-2 col-sm-2"></div></div><div class="col-md-12 col-lg-12 col-sm-12"><div class="col-md-8 col-lg-8 col-sm-8 col-md-offset-2 form-group pos-rela"><img src="content/images/icons/ic_yanzheng.png"> <input style="width:85%;color: gray" type="text" class="pad-left-8" id="code" name="code" placeholder="{{\'loginMessages.verificationCode\' | translate}}" ng-model="vm.registerAccount.code" ng-blur="checkVerifyCode()"><div style="width: 100%; height: 1px;border-top: 1px solid rgb(229, 230, 231)"></div><div ng-show="form.code.$dirty && form.code.$invalid" class="pos-abso"><p class="help-block" ng-show="form.code.$error.required" data-translate="global.messages.validate.code.required">Your code is required.</p></div></div><div class="col-md-2 col-lg-2 col-sm-2"></div></div><div class="col-md-12 col-lg-12 col-sm-12 register-condition"><div class="col-md-8 col-lg-8 col-sm-8 col-md-offset-2 form-group pos-rela"><img src="content/images/icons/icon_password.png"> <input style="width:85%;color: gray" type="password" class="pad-left-8" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.registerAccount.password" ng-minlength="4" ng-maxlength="50" required><div style="width: 100%; height: 1px;border-top: 1px solid rgb(229, 230, 231)"></div><div ng-show="form.password.$dirty && form.password.$invalid" class="pos-abso"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div></div><div class="col-md-2 col-lg-2 col-sm-2"></div></div><div class="col-md-12 col-lg-12 col-sm-12 register-condition"><div class="col-md-8 col-lg-8 col-sm-8 col-md-offset-2 form-group pos-rela"><img src="content/images/icons/icon_password.png"> <input style="width:85%;color: gray" type="password" class="pad-left-8" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div style="width: 100%; height: 1px;border-top: 1px solid rgb(229, 230, 231)"></div><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid" class="pos-abso"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><div class="col-md-2 col-lg-2 col-sm-2"></div></div><button type="submit" ng-disabled="form.$invalid||!vm.checkCode" ng-click="vm.resetPassword()" class="btn btn-red register-btn" data-translate="reset.request.form.button">Reset</button><div class="col-lg-12 col-sm-12 form-group current-menu"><span style="cursor: pointer" ui-sref="home(storeId:vm.storeId)">{{\'hint.returnToLogin\' | translate}}</span></div></form></div></div><div class="col-lg-12 col-sm-12 col-xm-12 form-group company-info"><span>{{\'loginMessages.copyright\' | translate}}</span></div></div>');
$templateCache.put('app/entities/gallery/components/uplpadImage.html','<div class="z-modal" ng-if="loadingAllSuccess" ng-class="{\'error-modal\' : errorImageArrCb() > 0}" ng-click="closeErrorMoadl()"><div class="z-modal-body" ng-class="{\'error-modal-body\' : errorImageArrCb() > 0}"><div class="close-btn" ng-if="errorImageArrCb() > 0" ng-click="closeErrorMoadl()"><i style="font-size: 26px" class="close-icon1 iconfont iconguanbi1"></i></div><div class="z-modal-body-icon"><i class="icon iconfont iconjichu01"></i></div><span>{{\'uploadContent.uploadSuccess\' | translate}}{{schedule()}}</span><div class="z-modal-body-error-view" ng-if="errorImageArrCb()>0"><span class="tips"><b style="color: #ED2121">{{errorImageArrCb()}}</b>{{\'uploadContent.uploadError\' | translate}}</span> <span style="color: #0A8DFE; margin-left: 8px" ng-click="lookErrorImages()">{{\'button.view\' | translate}}</span></div></div></div><div class="save-pages2 hide1"><div class="save-page2"><div class="imgLoading"><div class="loadImg2"></div><p class="imgText2" ng-if="schedule()">{{\'uploadContent.pictureUploadWait\' | translate}} {{schedule()}}</p><p class="imgText2" ng-if="!schedule()">{{\'uploadContent.pictureUploadWait1\' | translate}}</p></div></div></div><!-- <div class="z-modal" ng-if="bigSizeTip">\n    <div class="z-modal-body3">\n        <div class="z-modal-body3-title">{{\'uploadContent.bigPictureTip\' | translate}}</div>\n        <div class="z-modal-body-icon">\n            <img src="content/images/high_size.png" width="65%">\n        </div>\n        <div class="z-modal-body3-tip" translate="uploadContent.pictureBigContent" translate-values="{higherSizeLen:higherSizeLen}"></div>\n        <div class="z-modal-body3-confirm" ng-click="filterBigSize()">{{\'uploadContent.confirm\' | translate}}</div>\n    </div>\n</div> --><div class="c-bigSizeImage-view" ng-if="bigSizeTip"><div class="c-bigSizeImage-view-content"><div class="c-bigSizeImage-view-head"><div></div><span>\u5927\u56FE\u63D0\u793A</span> <i class="iconfont iconguanbi1" ng-click="filterBigSize()"></i></div><div class="c-bigSizeImage-view-body" style="background: #FFFFFF"><div>\u7CFB\u7EDF\u68C0\u6D4B\u5230{{userCtrl.higherSize.length}}\u5F20\u5927\u4E8E50M\u6216\u603B\u50CF\u7D20\u8D85\u8FC74\u4EBF\u7684\u56FE\u7247\uFF0C\u5DF2\u81EA\u52A8\u8FC7\u6EE4\uFF0C\u8BF7\u538B\u7F29\u540E\u518D\u5C1D\u8BD5\u4E0A\u4F20!</div><div class="c-bigSizeImage-view-body-li" ng-repeat="item in userCtrl.higherSize track by $index"><img ng-src="{{item.blobCover}}" alt="" class="c-image" onerror="this.onerror=null;this.src=\'content/images/tooLarge.png\'"><div class="c-bigsize-name" title="{{item.name}}">{{item.name}}</div><div class="c-bigsize-text-size">{{item.size / 1048576 | number:2}}M</div></div></div><div class="c-bigSizeImage-view-foot"><!-- <div class="c-bigSizeImage-view-btn1" ng-click="filterBigSize()">{{\'uploadContent.goBack1\' | translate}}</div> --><div class="c-bigSizeImage-view-btn" ng-click="filterBigSize()">\u786E\u8BA4</div></div></div></div><div class="c-errorImage-view" ng-if="isLookErrorImages" style="overflow: scroll;padding-bottom: 180px"><div class="c-errorImage-view-head"><i class="iconfont iconzuoceshouqi1" ng-click="errorImageHide()"></i> <span>{{\'uploadContent.goBack\' | translate}}</span></div><div class="c-errorImage-view-body" style="background: #FFFFFF"><div class="c-errorImage-view-body-li" ng-repeat="item in errorImageArr_ track by $index"><img ng-src="{{item.blobCover}}" alt="" class="c-image"><progres-view :progres="item.percent" ng-if="item.state != \'error\'"></progres-view></div></div><div class="c-errorImage-view-btn" ng-click="reUpload()">{{\'uploadContent.reupload\' | translate}}</div></div><div class="three-modal2" ng-if="threeError"><div class="three-modal2-body"><div>{{threeErrorText}}</div></div></div><style>.error-modal{\n        background: rgba(0,0,0,0.5);\n    }\n    .error-modal-body{\n        background: #FFFFFF;\n        position: relative;\n    }\n    .error-modal-body .close-btn{\n        position: absolute;\n        right: 10px;\n        top: 10px;\n    }\n    .error-modal-body i,.error-modal-body span{\n        color: #999999;\n    }\n    .error-modal-body .tips{\n        color: #666666;\n    }\n\n    .c-bigSizeImage-view-body-li {\n        height: auto;\n        /* min-height: 160px; */\n        flex-direction: column;\n        justify-content: flex-start;\n        position: relative;\n        padding: 6px;\n    }\n    .c-bigSizeImage-view-body-li .c-image {\n        max-width: 100%;\n        max-height: 100px;\n        object-fit: contain;\n    }\n    .c-bigsize-name {\n        max-width: 100%;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        font-size: 12px;\n        color: #666;\n        margin-top: 6px;\n        width: 100%;\n        text-align: center;\n    }\n    .c-bigsize-text-size {\n        font-size: 11px;\n        color: #999;\n        margin-top: 2px;\n        width: 100%;\n        text-align: center;\n        position: absolute;\n        background: #000000b8;\n        bottom: 30px;\n        right: 0;\n        left: 0;\n    }</style>');
$templateCache.put('app/entities/components/controls/calendar-set.control.html','<div class="c-editor-attribute-view1"><div class="c-editor-attribute-head"><div ng-class="{\'c-editor-attribute-head-selected\' : vm.tag == 1}" ng-click="tagClick(1)">\u65E5\u5386</div><div ng-class="{\'c-editor-attribute-head-selected\' : vm.tag == 2}" ng-click="tagClick(2)">\u5468\u8BBE\u7F6E</div><div ng-class="{\'c-editor-attribute-head-selected\' : vm.tag == 3}" ng-click="tagClick(3)">\u65E5\u8BBE\u7F6E</div></div><div class="c-editor-attribute-body"><div ng-if="vm.tag == 1"><!--                    <div class="title">\u9884\u89C8\u5C3A\u5BF8</div>--><!--                    <div style="padding-left: 2em;">{{vm.data.width}} X {{vm.data.height}}</div>--><div class="title">\u5C3A\u5BF8</div><div class="c-editor-attribute-body-item" ng-if="vm.data.geometry">{{vm.data.geometry.width | number:0}} X {{vm.data.geometry.height | number:0}}</div><div class="c-editor-attribute-body-item" ng-if="!vm.data.geometry">{{vm.data.width | number:0}} X {{vm.data.height | number:0}}</div><div class="c-editor-attribute-body-hr"></div><div class="title">\u80CC\u666F\u989C\u8272</div><color-pick color="vm.data.backgroundColor" transparent="true" on-update="widgetUpdate()"></color-pick><div class="c-editor-attribute-body-hr"></div><div class="title">\u4E00\u5468\u5F00\u59CB</div><div class="c-editor-attribute-body-item">{{vm.data.startOfWeek==1 ? \'1 - \u5468\u4E00\' : \'0 - \u5468\u65E5\'}}</div><div class="c-editor-attribute-body-hr"></div><div class="title">\u663E\u793A\u5176\u4ED6\u6708\u65E5\u671F</div><div class="c-editor-attribute-body-item1"><div ng-class="{\'c-editor-attribute-body-item1-view\' : !vm.data.showOthers}" ng-click="showOthersCb(false)">\u4E0D\u663E\u793A</div><div ng-class="{\'c-editor-attribute-body-item1-view\' : vm.data.showOthers}" ng-click="showOthersCb(true)">\u663E\u793A</div></div><div ng-if="!vm.data.geometry"><div class="c-editor-attribute-body-hr"></div><div class="title">\u5B9E\u4F8B\u6570\u636E</div><div class="c-editor-attribute-body-item2"><modele-select prefix="\u5E74:" ng-model="vm.data.sampleYear" ng-change="onYearMonthChnage()" label-key="value" value-key="id" options="vm.sampleYears"></modele-select></div><div class="c-editor-attribute-body-item2" style="margin: 0"><modele-select prefix="\u6708:" ng-model="vm.data.sampleMonth" ng-change="onYearMonthChnage()" label-key="value" value-key="id" options="vm.sampleMonths"></modele-select></div></div></div><div ng-if="vm.tag == 2"><div class="title">\u7C7B\u578B</div><div ng-click="selectWeekLayout()" class="c-previewUrl-view"><div class="c-previewUrl-view-item"><img ng-if="vm.data.weekLayout.previewUrl" ng-src="{{vm.data.weekLayout.previewUrl}}"><div ng-if="!vm.data.weekLayout.previewUrl">\u65E0\u56FE</div></div><i class="iconfont icon-xia"></i></div><div class="c-editor-attribute-body-hr"></div><div ng-if="!vm.data.geometry"><div class="title">\u5355\u5143\u683C\u5C3A\u5BF8</div><div class="c-editor-attribute-body-item2"><span>\u5BBD</span> <input type="number" ng-model="vm.data.weekConfig.cellWidth" min="10" step="1" ng-change="widgetUpdate()"></div><div class="c-editor-attribute-body-item2"><span>\u9AD8</span> <input type="number" ng-model="vm.data.weekConfig.cellHeight" min="10" step="1" ng-change="widgetUpdate()"></div><div class="c-editor-attribute-body-item2" style="margin: 0"><span>\u95F4\u8DDD</span> <input type="number" ng-model="vm.data.weekConfig.margin" min="0" step="1" ng-change="widgetUpdate()" style="padding-left: 40px"></div><div class="c-editor-attribute-body-hr"></div></div><div style="display: flex; justify-content: space-between; align-items: center; margin-top: 10px"><div class="title" style="margin: 0">\u81EA\u5B9A\u4E49\u6837\u5F0F</div><i class="iconfont icon-icon_tianjia" ng-click="vm.addWeekStyle()" uib-tooltip="\u6DFB\u52A0" tooltip-placement="top"></i></div><div class="c-weekStyles-view"><div class="c-weekStyles-view-li" ng-repeat="s in vm.data.weekStyles track by $index"><span>{{s.name}}</span><div><i class="iconfont icon-xiugai" ng-click="vm.editWeekStyle(s,$index)" uib-tooltip="\u7F16\u8F91" tooltip-placement="top"></i> <i class="iconfont icon-guanbi" ng-click="vm.removeWeekStyle($index)" ng-if="$index>0" uib-tooltip="\u5220\u9664" tooltip-placement="top"></i></div></div></div><div class="c-editor-attribute-body-hr"></div><div class="title">\u65E5\u671F\u6837\u5F0F\u8BBE\u7F6E</div><div><modele-select ng-model="vm.weekStyleKey" ng-change="widgetUpdate()" label-key="value" value-key="id" options="vm.weekStyleKeys"></modele-select><div class="mt10"></div><modele-select ng-model="vm.data.weekConfig[vm.weekStyleKey]" ng-change="widgetUpdate()" label-key="name" value-key="uuid" options="vm.weekStyleOptions"></modele-select><!--                    <select class="c-select1" style="margin-bottom: 8px;" ng-model="vm.weekStyleKey" ng-options="s.id as s.value for s in vm.weekStyleKeys" ng-change="widgetUpdate()"></select>--><!--                    <select class="c-select1" ng-model="vm.data.weekConfig[vm.weekStyleKey]" ng-options="s.uuid as s.name for s in vm.weekStyleOptions" ng-change="widgetUpdate()"></select>--></div></div><div ng-if="vm.tag == 3"><div class="title">\u7C7B\u578B</div><div ng-click="selectDateLayout()" class="c-previewUrl-view"><div class="c-previewUrl-view-item"><img ng-if="vm.data.dateLayout.previewUrl" ng-src="{{vm.data.dateLayout.previewUrl}}"><div ng-if="!vm.data.dateLayout.previewUrl">\u65E0\u56FE</div></div><i class="iconfont icon-xia"></i></div><div class="c-editor-attribute-body-hr"></div><div ng-if="!vm.data.geometry"><div class="title">\u5355\u5143\u683C\u5C3A\u5BF8</div><div class="c-editor-attribute-body-item2"><span>\u5BBD</span> <input type="number" ng-model="vm.data.dateConfig.cellWidth" min="10" step="1" ng-change="widgetUpdate()"></div><div class="c-editor-attribute-body-item2"><span>\u9AD8</span> <input type="number" ng-model="vm.data.dateConfig.cellHeight" min="10" step="1" ng-change="widgetUpdate()"></div><div class="c-editor-attribute-body-item2" style="margin: 0"><span>\u95F4\u8DDD</span> <input type="number" ng-model="vm.data.dateConfig.margin" min="0" step="1" ng-change="widgetUpdate()" style="padding-left: 40px"></div><div class="c-editor-attribute-body-hr"></div></div><div style="display: flex; justify-content: space-between; align-items: center; margin-top: 10px"><div class="title" style="margin: 0">\u81EA\u5B9A\u4E49\u6837\u5F0F</div><i class="iconfont icon-icon_tianjia" ng-click="vm.addDateStyle()" uib-tooltip="\u6DFB\u52A0" tooltip-placement="top"></i></div><div class="c-weekStyles-view"><div class="c-weekStyles-view-li" ng-repeat="s in vm.data.dateStyles track by $index"><span>{{s.name}}</span><div><i class="iconfont icon-xiugai" ng-click="vm.editDateStyle(s,$index)" uib-tooltip="\u7F16\u8F91" tooltip-placement="top"></i> <i class="iconfont icon-guanbi" ng-click="vm.removeDateStyle($index)" ng-if="$index>0" uib-tooltip="\u5220\u9664" tooltip-placement="top"></i></div></div></div><div class="c-editor-attribute-body-hr"></div><div class="title">\u65E5\u671F\u6837\u5F0F\u8BBE\u7F6E</div><div><modele-select ng-model="vm.dateConfigKey" ng-change="widgetUpdate()" label-key="value" value-key="id" options="vm.dateConfigKeys"></modele-select><div class="mt10"></div><modele-select ng-model="vm.data.dateConfig[vm.dateConfigKey]" ng-change="widgetUpdate()" label-key="name" value-key="uuid" options="vm.dateStyleOptions"></modele-select><!--                    <select class="c-select1" style="margin-bottom: 8px;" ng-model="vm.dateConfigKey" ng-options="s.id as s.value for s in vm.dateConfigKeys" ng-change="widgetUpdate()"></select>--><!--                    <select class="c-select1" ng-model="vm.data.dateConfig[vm.dateConfigKey]" ng-options="s.uuid as s.name for s in vm.dateStyleOptions" ng-change="widgetUpdate()"></select>--></div></div></div></div><style>.c-editor-attribute-body-item{\n        width: 100%;\n        height: 36px;\n        line-height: 36px;\n        padding: 0 8px;\n        background: #F5F7FA;\n        border-radius: 2px;\n        color: #222529;\n        font-size: 12px;\n    }\n    .c-editor-attribute-body-item1{\n        width: 100%;\n        display: flex;\n        border-radius: 2px;\n        border: 1px solid #E1E5EB;\n    }\n    .c-editor-attribute-body-item1 div{\n        width: 50%;\n        height: 36px;\n        cursor: pointer;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        background: #fff;\n        color: #222529;\n        font-weight: bold;\n    }\n    .c-editor-attribute-body-item1-view{\n        background: #264DF0 !important;\n        color: #fff !important;\n    }\n    .c-editor-attribute-body-item2{\n        position: relative;\n        width: 100%;\n        height: 36px;\n        margin-bottom: 8px;\n    }\n    .c-editor-attribute-body-item2 span{\n        position: absolute;\n        left: 8px;\n        top: 0;\n        font-size: 12px;\n        color: #89919D;\n        display: inline-block;\n        height: 36px;\n        line-height: 36px;\n    }\n    .c-editor-attribute-body-item2 select, .c-editor-attribute-body-item2 input{\n        width: 100%;\n        height: 36px;\n        border-radius: 2px;\n        border: 1px solid #E1E5EB;\n        padding: 0 16px 0 28px;\n        font-size: 12px;\n        color: #222529;\n    }\n    .c-editor-attribute-body-hr{\n        width: 100%;\n        height: 1px;\n        background: #EEEEEE;\n        margin: 16px 0 24px;\n    }\n    .c-previewUrl-view{\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        width: 100%;\n    }\n    .c-previewUrl-view-item{\n        background: #F5F7FA;\n        border-radius: 2px;\n        width: calc(100% - 30px) !important;\n        height: 80px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n    .c-previewUrl-view-item img{\n        max-width: 90%;\n        max-height: 70px;\n    }\n\n    .c-weekStyles-view{\n        margin-top: 10px;\n    }\n    .c-weekStyles-view-li{\n        display: flex;\n        width: 100%;\n        justify-content: space-between;\n        align-items: center;\n        height: 36px;\n        background: #F5F7FA;\n        color: #333;\n        padding: 0 10px;\n        border-radius: 4px;\n        margin-bottom: 10px;\n    }</style>');
$templateCache.put('app/entities/components/controls/cell-settings-modal.html','<div class="c-model"><div class="c-model-head"><div class="c-model-head-title">\u5355\u5143\u683C\u8BBE\u7F6E</div><i class="iconfont icon-closeicon1" ng-click="vm.clear()"></i></div><div class="c-model-body scrollbar-main"><div class="c-model-body-view" style="display: flex; flex-wrap: wrap"><div class="c-form"><div class="c-form-label">\u6837\u5F0F\u540D\u79F0:</div><div class="c-form-div"><input type="text" class="c-select1" ng-model="vm.data.name"></div></div><div style="width: 59%; min-height: 300px; margin-left: -10px"><style-setting settings="vm.data.settings" on-change="onSettingsChange(text)" options="{backgroundEnabled: true, borderEnabled: true, debugEnabled: true}"></style-setting></div><div style="width: 40%; position: absolute; right: 10px"><div style="width: 200px; height: 100px; border: 1px solid #eee; position: relative" ng-if="vm.data.layout.type==\'WEEK\'"><div style="margin: 0 auto; width: 100px; padding-top: 25px"><week-cell layout="vm.data.layout" settings="vm.data.settings"></week-cell></div></div><div style="width: 200px; height: 200px; border: 1px solid #eee; position: relative" ng-if="vm.data.layout.type==\'DATE\'"><div style="margin: 0 auto; width: 100px; padding-top: 25px"><date-cell layout="vm.data.layout" settings="vm.data.settings"></date-cell></div></div></div></div></div><div class="c-model-foot"><button type="button" class="btn btn-cancel btn-max" ng-click="vm.clear()">\u53D6\u6D88</button> <button type="button" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-info btn-max" ng-click="vm.save()">\u786E\u5B9A</button></div></div><style type="text/css"></style>');
$templateCache.put('app/entities/components/controls/color-pick.control.html','<div class="leftPanel-bg-head"><input class="leftPanel-bg-choose-color" type="color" ng-value="vm.data.color" ng-change="onInputChange()" ng-model="vm.data.color"> <button class="leftPanel-bg-color leftPanel-bg-choose-mask"></button> <button class="leftPanel-bg-color custom-grid2" ng-click="onClean()"></button> <button class="leftPanel-bg-color" ng-repeat="c in vm.colorOptions" ng-click="onClick(c)" ng-style="{background:c.value,border:\'1px solid #DADADA\'}"></button></div><style>.leftPanel-bg-head{\n        padding: 0;\n    }</style>');
$templateCache.put('app/entities/components/controls/date-cell.control.html','<div ng-style="vm.data.styles" style="position: relative; overflow: hidden"><div ng-repeat="item in vm.data.items" ng-if="vm.data.showOthers"><div ng-if=" item.type==\'image\' " ng-style="item.styles"><img ng-if="item.url" ng-src="{{item.url}}" style="object-fit: contain; width:100%;height:100%;text-align: center"></div><div ng-if=" item.type==\'userimage\' " ng-style="item.styles"><img ng-if="item.url" ng-src="{{item.url}}" style="object-fit: contain; width:100%;height:100%;text-align: center"></div><div ng-if=" item.type==\'date\' || item.type==\'event\' " ng-style="item.styles">{{item.value}}</div></div></div>');
$templateCache.put('app/entities/components/controls/editorTipPicModal.html','<div style="background-color: #FFF;border-radius: 8px"><div class="modal-header"><span>{{\'hint.prompt\' | translate}}</span></div><div class="modal-body" style="max-height: 500px;overflow-y: auto"><img ng-src="{{vm.url}}" class="editorTipPic"></div><div class="modal-footer"><div class="floatLeft"><label class="checkboxItem"><input type="checkbox" ng-model="vm.dotRemindEditorTipPic" style="width: 20px;margin-top: 0"> {{\'hint.doNotRemindAgain\' | translate}}</label></div><button type="button" ng-click="vm.save()" class="dialog-foot-confirm">{{\'hint.iUnderstand\' | translate}}</button></div></div><style>.modal-dialog {\n        z-index: 2200;\n        position: fixed;\n        left: 50%;\n        top: 50%;\n        transform: translate(-50%, -50%) !important;\n    }\n    .modal-content{\n        width: 80%;\n    }\n    .modal-header{\n        border-bottom: none;\n        font-size: 18px;\n        font-weight: 500;\n        color:#333;\n    }\n    .modal-footer{\n        text-align: center;\n        position: relative;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n    .editorTipPic{\n        width: 100%;\n    }\n    .floatLeft{\n        position: absolute;\n        left: 0;\n        top: 50%;\n        transform: translateY(-50%);\n    }\n    .checkboxItem{\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        margin-bottom: 0;\n    }</style>');
$templateCache.put('app/entities/components/controls/font-family.html','<div class="c-font-view" style="width: 100%"><div class="c-font-view-head" ng-style="{\'font-family\': \'\\\'\' + vm.family + \'\\\'\',}">{{selectFontName(vm.family)}}</div><div class="c-font-view-body"><div class="c-font-view-body-head"><input type="text" class="c-font-view-body-head-input" id="selectFontInput" ng-model="vm.selectFont" ng-change="vm.selectFontBtn()"> <span class="c-font-view-body-head-btn" ng-click="vm.selectFontBtn()" style="top: 6px"></span></div><div class="c-font-view-body-ul"><div class="c-font-view-body-li" ng-repeat="font in vm.fontList track by $index" ng-click="updateTextFont(font)" ng-class="{\'c-font-view-body-li-on\' : vm.family == font.uuid}"><img ng-src="{{vm.url + font.fontStyles[0].identifier}}" alt="" ng-if="vm.url && font.fontStyles[0].identifier"> <span ng-if="!font.fontStyles[0].identifier">{{font.name}}</span></div></div></div></div>');
$templateCache.put('app/entities/components/controls/layout-select.html','<div class="c-model"><div class="c-model-head"><div class="c-model-head-title">\u9009\u62E9\u5355\u5143\u683C\u5E03\u5C40</div><i class="iconfont icon-closeicon1" ng-click="vm.clear()"></i></div><div class="c-model-body"><div class="c-model-body-view" style="display: flex; flex-wrap: wrap"><div ng-repeat="layout in vm.layouts" ng-click="vm.onLayoutSelect(layout)" style="margin: 10px; border: 1px solid #fff" ng-class="{\'layout-select\': layout.id==vm.selectedId}"><img ng-if="layout.previewUrl" ng-src="{{layout.previewUrl}}" width="100"> <span ng-if="!layout.previewUrl">\u65E0\u56FE</span></div></div></div><div class="c-model-foot" style="text-align: center"><button type="button" class="btn btn-cancel btn-max" ng-click="vm.clear()" translate="entity.action.cancel">Cancel</button> <button type="button" ng-disabled="vm.isSaving" class="btn btn-info btn-max" ng-click="vm.save()">\u786E\u5B9A</button></div></div><!--<div class="listBGC listCreate pad-0">--><!--    <button type="button" class="pad-5 close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;--><!--    </button>--><!--    <div class="modal-detail">--><!--        <h4 class="modal-title" >\u9009\u62E9\u5355\u5143\u683C\u5E03\u5C40</h4>--><!--    </div>--><!--    <div class="modal-body">--><!--        <div style="display: flex; flex-wrap: wrap;">--><!--        \t<div ng-repeat="layout in vm.layouts" ng-click="vm.onLayoutSelect(layout)" style="margin: 10px;" ng-class="{\'layout-select\': layout.id==vm.selectedId}">--><!--        \t\t<img ng-if="layout.previewUrl" ng-src="{{layout.previewUrl}}" width="100" />--><!--        \t\t<span ng-if="!layout.previewUrl">\u65E0\u56FE</span>--><!--        \t</div>--><!--        </div>--><!--    </div>--><!--    <div class="modal-footer" style="text-align: left;">--><!--        <button type="button" ng-disabled="vm.isSaving" style="width: 96px;" class="btn btn-primary btn-save btn-info" ng-click="vm.save()">--><!--            <span>\u786E\u5B9A</span>--><!--        </button>--><!--        <button type="button" class="btn btn-cancel mar-left-30" data-dismiss="modal" ng-click="vm.clear()">--><!--            <span translate="entity.action.cancel">Cancel</span>--><!--        </button>--><!--        --><!--    </div>--><!--</div>--><style type="text/css">.layout-select {\n\t\tborder: 1px solid #264DF0 !important;\n\t}</style>');
$templateCache.put('app/entities/components/controls/matting-modal.html','<div class="matting-container flex-col"><!-- \u6807\u9898\u680F --><div class="matting-topbar flex-row justify-between align-center"><span class="matting-title">\u62A0\u56FE</span><div class="matting-topbar-center flex-row"><i class="matting-canvas-icon iconfont iconshangyibu" ng-click="vm.undo()" ng-class="{disabled: !vm.undoEnabled}" title="\u4E0A\u4E00\u6B65"></i> <i class="matting-canvas-icon iconfont iconxiayibu" ng-click="vm.redo()" ng-class="{disabled: !vm.redoEnabled}" title="\u4E0B\u4E00\u6B65"></i> <i class="matting-canvas-icon iconfont iconchongzhi" ng-click="vm.resetMask()" title="\u8FD8\u539F"></i></div><i class="matting-close-btn iconfont iconguanbi1" ng-click="vm.close()"></i></div><!-- \u5DE5\u5177\u884C --><div class="matting-tools-row flex-row align-center"><div class="matting-tool-item flex-col justify-between" ng-click="vm.setToolMode(\'repair\')" ng-class="{active: vm.toolMode === \'repair\'}"><div class="matting-tool-icon flex-col" ng-class="{active: vm.toolMode === \'repair\'}"><i class="iconfont iconxiubu"></i></div><span>\u4FEE\u8865</span></div><div class="matting-tool-item flex-col justify-between" ng-click="vm.setToolMode(\'erase\')" ng-class="{active: vm.toolMode === \'erase\'}"><div class="matting-tool-icon flex-col" ng-class="{\'erase-active\': vm.toolMode === \'erase\'}"><i class="iconfont iconcachu"></i></div><span>\u64E6\u9664</span></div><div class="matting-divider"></div><div class="matting-slider-group flex-col"><input type="range" ng-model="vm.brushSize" ng-change="vm.onBrushSizeChange()" ng-style="{\'background\': vm.brushSizeBg}" min="1" max="100"><div class="matting-slider-label flex-row justify-between"><span>\u7C97\u7EC6</span><span class="matting-slider-value">{{ vm.brushSize }}</span></div></div><div class="matting-slider-group flex-col"><input type="range" ng-model="vm.hardness" ng-change="vm.onHardnessChange()" ng-style="{\'background\': vm.hardnessBg}" min="0" max="100"><div class="matting-slider-label flex-row justify-between"><span>\u786C\u5EA6</span><span class="matting-slider-value">{{ vm.hardness }}</span></div></div><div class="matting-slider-group flex-col"><input type="range" ng-model="vm.opacity" ng-change="vm.onOpacityChange()" ng-style="{\'background\': vm.opacityBg}" min="10" max="100"><div class="matting-slider-label flex-row justify-between"><span>\u900F\u660E\u5EA6</span><span class="matting-slider-value">{{ vm.opacity }}</span></div></div><div class="matting-tools-spacer"></div><button class="matting-apply-btn" ng-click="vm.confirm()">\u5E94\u7528</button></div><!-- \u53CC\u753B\u5E03\u533A\u57DF --><div class="matting-canvas-area" id="mattingCanvasContainer"><div id="mattingLoadingOverlay"><div class="matting-spinner"></div><span>\u52A0\u8F7D\u4E2D...</span></div><div class="matting-canvas-panels flex-row"><div class="matting-canvas-panel" id="mattingLeftPanel"><div class="matting-panel-canvas"><div id="mattingCanvasWrapperLeft"><canvas id="mattingImageCanvas"></canvas><canvas id="mattingOverlayCanvas"></canvas><div id="mattingBrushCursorLeft" ng-class="{\'erase-mode\': vm.toolMode === \'erase\'}"></div></div></div></div><div class="matting-canvas-panel" id="mattingRightPanel"><div class="matting-panel-canvas"><div id="mattingCanvasWrapperRight"><canvas id="mattingEffectCanvas"></canvas><canvas id="mattingEffectOverlay"></canvas><div id="mattingBrushCursorRight" ng-class="{\'erase-mode\': vm.toolMode === \'erase\'}"></div></div></div></div></div><div id="mattingBrushSizeHint" ng-style="{width: vm.brushSize + \'px\', height: vm.brushSize + \'px\'}" ng-class="{show: vm.brushHintVisible, \'erase-hint\': vm.toolMode === \'erase\'}"></div><!-- \u7F29\u653E\u63A7\u4EF6 --><div class="matting-zoom flex-row"><i class="matting-canvas-icon iconfont iconshouxing matting-pan-btn" ng-click="vm.togglePanMode()" ng-class="{active: vm.panMode}" title="\u79FB\u52A8\u753B\u5E03"></i> <i class="matting-canvas-icon iconfont iconjian2" ng-click="vm.zoomOut()" title="\u7F29\u5C0F"></i> <span class="matting-zoom-percent">{{ vm.zoomPercent }}</span> <i class="matting-canvas-icon iconfont iconjia2" ng-click="vm.zoomIn()" title="\u653E\u5927"></i> <i class="matting-canvas-icon iconfont iconyibiyi" ng-click="vm.zoomReset()" title="\u91CD\u7F6E"></i></div></div></div>');
$templateCache.put('app/entities/components/controls/month-table.html','<div ng-style="vm.data.styles" style="position: relative" ng-if="!vm.loading"><div ng-style="{width:vm.data.headWidth,\'margin-bottom\':vm.data.headSpacing}" style="width: 100%;height: fit-content;display: flex"><div ng-repeat="head in vm.data.heads" style="height: fit-content" ng-style="{\'margin-right\':$index<vm.data.heads.length-1 ? head.margin : 0,\'opacity\':vm.widget.weekConfig.hideWeek?0:1}"><week-cell index="$index" week-config="vm.widget.weekConfig" width="head.width" height="head.height" obj="head.obj" layout="head.layout" settings="head.settings" is-min="vm.isMin"></week-cell></div></div><div ng-style="{height:vm.data.bodyHeight,width:vm.data.bodyWidth}" style="display: flex; align-content: space-between;flex-wrap: wrap"><div ng-repeat="dateRow in vm.data.dates" ng-init="trIndex = $index" style="width: 100%;height: fit-content;display: flex"><div ng-repeat="date in dateRow" ng-init="tdIndex = $index" style="height: fit-content" ng-style="{\'margin-right\':tdIndex<dateRow.length-1 ? date.margin : 0,\'margin-bottom\':trIndex<vm.data.dates.length-1 ? date.marginH : 0}"><date-cell tr-index="trIndex" td-index="tdIndex" date-config="vm.widget.dateConfig" width="date.width" height="date.height" obj="date.obj" layout="date.layout" settings="date.settings" is-min="vm.isMin"></date-cell></div></div></div></div>');
$templateCache.put('app/entities/components/controls/style-setting.control.html','<div style="position: relative" ng-class="{\'c-style-two\' : vm.style}"><div ng-if="vm.options" class="c-view-set"><div class="c-form" ng-if="vm.options.debugEnabled"><div class="c-form-label">\u8C03\u8BD5\u5F00\u5173:</div><div class="c-form-div align-items-center"><input type="checkbox" class="checkOrIf" ng-model="vm.data.settings.debug" ng-change="onCheckboxChange()" aria-invalid="false" style="margin: 0"></div></div><div class="c-form" ng-if="vm.options.backgroundEnabled"><div class="c-form-label">\u80CC\u666F:</div><div class="c-form-div"><color-pick color="vm.data.settings.backgroundColor" transparent="true" on-update="onColorChange(text)"></color-pick></div></div><div ng-if="vm.options.borderEnabled"><div class="c-form"><div class="c-form-label">\u8FB9\u6846\u5BBD\u5EA6:</div><div class="c-form-div"><input type="number" class="c-select1" ng-model="vm.data.settings.border.lineWidth" step="0.1" min="0" ng-change="onBorderInputChange(vm.data.settings.border.lineWidth)"></div></div><div class="c-form"><div class="c-form-label">\u8FB9\u6846\u989C\u8272:</div><div class="c-form-div"><color-pick color="vm.data.settings.border.color" transparent="true" on-update="onColorChange(text)"></color-pick></div></div><div class="c-form"><div class="c-form-label">\u5706\u89D2:</div><div class="c-form-div align-items-center filleted-corner-view"><input type="text" ng-model="vm.data.settings.border.tlRadius" placeholder="TL" ng-change="onItemChange()"> <input type="text" ng-model="vm.data.settings.border.trRadius" placeholder="TR" ng-change="onItemChange()"> <input type="text" ng-model="vm.data.settings.border.blRadius" placeholder="BL" ng-change="onItemChange()"> <input type="text" ng-model="vm.data.settings.border.brRadius" placeholder="BR" ng-change="onItemChange()"></div></div></div></div><div class="c-view-set" ng-repeat="item in vm.data.settings.items track by $index" ng-if="item.type == \'date\' || item.type ==\'week\' || item.type == \'year\' || item.type == \'month\' || item.type == \'event\' "><div class="c-style-title">{{item.name || "\u672A\u77E5\u540D\u79F0"}}</div><div class="c-form"><div class="c-form-label">\u6587\u5B57\u80CC\u666F:</div><div class="c-form-div"><color-pick color="item.backgroundColor" transparent="true" on-update="onColorChange(text)"></color-pick></div></div><div class="c-form"><div class="c-form-label">\u6587\u5B57\u989C\u8272:</div><div class="c-form-div"><color-pick color="item.textColor" on-update="onColorChange(text)"></color-pick></div></div><div class="c-form"><div class="c-form-label">\u6587\u5B57\u5927\u5C0F:</div><div class="c-form-div"><input type="number" class="c-select1" ng-model="item.textSize" step="1" min="12" ng-change="onInputChange(item.textSize, $index)"></div></div><div class="c-form"><div class="c-form-label">\u6587\u5B57\u5B57\u4F53:</div><div class="c-form-div"><font-family :family="item.textFontUuid" on-change="onItemChange()"></font-family></div></div><div class="c-form"><div class="c-form-label">\u5BF9\u9F50\u65B9\u5F0F:</div><div class="c-form-div"><modele-select ng-model="item.textAlign" ng-change="onItemChange()" label-key="value" value-key="id" options="vm.textAligns"></modele-select><!--                <select class="c-select1" name="textAlign" ng-model="item.textAlign" ng-change="onItemChange()">--><!--                    <option value="left">\u5DE6\u5BF9\u9F50</option>--><!--                    <option value="center">\u5C45\u4E2D</option>--><!--                    <option value="right">\u53F3\u5BF9\u9F50</option>--><!--                </select>--></div></div><div class="c-form"><div class="c-form-label" style="width: 45px !important">\u7C97\u4F53:</div><div class="c-form-div align-items-center" style="margin-left: 45px !important; width: auto !important"><input type="checkbox" class="checkOrIf" ng-model="item.textBold" ng-change="onItemChange()" aria-invalid="false"></div></div><div class="c-form"><div class="c-form-label" style="width: 45px !important">\u659C\u4F53:</div><div class="c-form-div align-items-center" style="margin-left: 45px !important; width: auto !important"><input type="checkbox" class="checkOrIf" ng-model="item.textItalic" ng-change="onItemChange()" aria-invalid="false"></div></div></div></div><style>.modal-content{\n        width: 635px;\n    }\n    .c-view-set{\n        margin-bottom: 15px;\n        border-bottom: 1px solid #ddd;\n    }\n    .c-view-set:last-child{\n        border: 0;\n    }\n    .c-style-title{\n        line-height: 30px;\n        font-size: 14px;\n        font-weight: 600;\n        margin: 0 !important;\n    }\n    .title1{\n        height: 30px;\n        display: flex;\n        align-items: center;\n        font-weight: 400;\n        color: #555;\n        margin-top: 10px;\n    }\n    .title1:first-child{\n        margin-top: 0 !important;\n    }\n    .c-form-label{\n        width: 75px !important;\n    }\n    .c-form-div{\n        width: auto !important;\n        margin-left: 75px !important;\n    }\n    /*\u6837\u5F0F\u4E8C*/\n    .c-style-two .c-form-label{\n        width: 100% !important;\n        text-align: left;\n    }\n    .c-style-two .c-form-div{\n        margin: 0 !important;\n        width: 100% !important;\n    }</style>');
$templateCache.put('app/entities/components/controls/title-cell.control.html','<div ng-style="vm.data.styles" style="position: relative" ng-if="!vm.loading"><div ng-repeat="item in vm.data.items"><div ng-if=" item.type==\'image\' " ng-style="item.styles"><img ng-if="item.url" ng-src="{{item.url}}" style="object-fit: contain; width:100%;height:100%;text-align: center"></div><div ng-if=" item.type==\'userimage\' " ng-style="item.styles"><img ng-if="item.url" ng-src="{{item.url}}" style="object-fit: contain; width:100%;height:100%;text-align: center"></div><div ng-if=" item.type==\'year\' || item.type==\'month\' " ng-style="item.styles">{{item.value}}</div></div></div>');
$templateCache.put('app/entities/components/controls/week-cell.control.html','<div ng-style="vm.data.styles" style="position: relative"><div ng-repeat="item in vm.data.items"><div ng-if=" item.type==\'image\' " ng-style="item.styles"><img ng-if="item.url" ng-src="{{item.url}}" style="object-fit: contain; width:100%;height:100%;text-align: center"></div><div ng-if=" item.type==\'userimage\' " ng-style="item.styles"><img ng-if="item.url" ng-src="{{item.url}}" style="object-fit: contain; width:100%;height:100%;text-align: center"></div><div ng-if=" item.type==\'week\' " ng-style="item.styles">{{itemValue(item)}}</div></div></div>');
$templateCache.put('app/entities/page/model/reference.html','<div class="c-model"><div class="c-model-head"><div class="c-model-head-title">{{\'editorBtn.newGuide\' | translate}}</div><i class="iconfont icon-closeicon1" ng-click="vm.clear()"></i></div><div class="c-model-body"><div class="c-model-body-view"><div class="c-form"><label class="c-form-label">{{\'editorBtn.orientation\' | translate}}\uFF1A</label><div class="c-form-div" style="display: flex; align-items: center"><div ng-style="{\'color\':vm.direction == \'y\' ? \'var(--webMainButtonBackColor)\' : \'#505760\'}" style="color: var(--webMainButtonBackColor); margin-right: 20px" ng-click="vm.direction = \'y\'"><i class="iconfont iconbig-circle" ng-show="vm.direction != \'y\'"></i> <i class="iconfont iconxuanze" ng-show="vm.direction == \'y\'"></i> <span>{{\'editorBtn.horizontalDirection\' | translate}}</span></div><div ng-style="{\'color\':vm.direction == \'x\' ? \'var(--webMainButtonBackColor)\' : \'#505760\'}" style="color: var(--webMainButtonBackColor)" ng-click="vm.direction = \'x\'"><i class="iconfont iconbig-circle" ng-show="vm.direction != \'x\'"></i> <i class="iconfont iconxuanze" ng-show="vm.direction == \'x\'"></i> <span>{{\'editorBtn.verticalDirection\' | translate}}</span></div></div></div><div class="c-form"><label class="c-form-label">{{\'editorBtn.position\' | translate}}\uFF1A</label><div class="c-form-div group-form"><div class="group-form-input"><div class="group-form-item"><input type="text" ng-model="vm.place"></div></div><div class="c-editor-form-view1" style="width: 134px; min-width: 134px; margin: 0 10px"><div class="c-editor-form-view1-1"><span>{{\'editorBtn.unit\' | translate}}</span><select ng-options="dpi as dpi.data for dpi in vm.dpiChoose" ng-model-options="{debounce:500}" ng-change="updateDpi(vm.dpi1)" ng-model="vm.dpi1"></select></div></div></div></div></div></div><div class="c-model-foot"><button type="button" class="x-btn x-btn-cancel" ng-click="vm.clear()">{{\'button.cancel\' | translate}}</button> <button type="button" class="x-btn x-btn-info" ng-click="vm.save()">{{\'button.confirm\' | translate}}</button></div></div><style>.modal-content{\n        width: 720px !important;\n    }\n    \n    .c-model-body-view{\n        background: #fff;\n        padding: 20px;\n        max-height: 500px;\n        overflow: auto;\n    }\n    .c-form{width: 90%;}\n    .c-form .c-form-label{\n        width: 70px;\n        padding: 0;\n        height: 40px;\n        line-height: 40px;\n    }\n    .c-form .c-form-div{\n        position: relative;\n        margin-left: 70px;\n        width: auto;\n        min-height: 40px;\n    }</style>');}]);})();